
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4ccia", function(module, exports) {
$parcel$export(module.exports, "CustomerLandingPageRelayQuery", function () { return $3dc4ed61a4433ffb$export$a2e9c729852eb9a1; });
$parcel$export(module.exports, "getCustomerLandingPageRelayQueryVars", function () { return $3dc4ed61a4433ffb$export$d97c1c828e8e0162; });
$parcel$export(module.exports, "CustomerLandingPageContentfulResponse", function () { return $3dc4ed61a4433ffb$export$4b589896422ec0e0; });

var $hu7gH = parcelRequire("hu7gH");

var $kf4PU = parcelRequire("kf4PU");
var $3dc4ed61a4433ffb$var$_customerLandingPageRelayQuery;

const $3dc4ed61a4433ffb$export$a2e9c729852eb9a1 = $3dc4ed61a4433ffb$var$_customerLandingPageRelayQuery !== void 0 ? $3dc4ed61a4433ffb$var$_customerLandingPageRelayQuery : ($3dc4ed61a4433ffb$var$_customerLandingPageRelayQuery = (parcelRequire("i7ByD")), $3dc4ed61a4433ffb$var$_customerLandingPageRelayQuery.hash && $3dc4ed61a4433ffb$var$_customerLandingPageRelayQuery.hash !== "14e2d83e9b74bfe20f118ae09eb3c78c" && console.error("The definition of 'customerLandingPageRelayQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $3dc4ed61a4433ffb$var$_customerLandingPageRelayQuery);
const $3dc4ed61a4433ffb$export$d97c1c828e8e0162 = (location)=>{
    const { locale: locale } = (0, $hu7gH.parseRoute)(location);
    return {
        locale: (0, $kf4PU.WAC_TO_CPAPI_LOCALE_MAP)[locale] || 'en-US'
    };
};
const $3dc4ed61a4433ffb$export$4b589896422ec0e0 = (contentfulStories)=>{
    return {
        customerStories: {
            edges: contentfulStories.customerStoryCollection?.items?.map((item)=>{
                return {
                    node: {
                        title: item?.storyTitleExternal,
                        publishedAt: item?.sys?.publishedAt ?? null,
                        customerCompany: {
                            name: item?.customerCompany?.organizationNameExternal,
                            logo: item?.customerCompany?.logoCollection?.items?.map((item)=>{
                                return {
                                    description: item?.description,
                                    contentType: item?.contentType,
                                    url: item?.url
                                };
                            }),
                            industry: item?.customerCompany?.industryCollection?.items?.map((item)=>{
                                return {
                                    name: item?.industryName
                                };
                            }),
                            region: {
                                name: item?.customerCompany?.region?.regionNameExternal
                            },
                            organizationSize: {
                                name: item?.customerCompany?.organizationSize?.companySizeTitleExternal
                            }
                        },
                        advocateQuotes: item?.advocateQuotesCollection?.items?.map((item)=>{
                            if (item?.advocateName && item.advocateQuote && item.advocateJobTitle && item.advocateHeadshot) return {
                                advocateName: item?.advocateName,
                                advocateQuote: item?.advocateQuote,
                                advocateJobTitle: item?.advocateJobTitle,
                                advocateHeadshot: item?.advocateHeadshot
                            };
                            return null;
                        }).filter((item)=>item !== null),
                        storyIcon: item?.storyIcon,
                        callToAction: item?.callToActionCollection?.items?.map((item)=>{
                            return {
                                text: item?.ctaText,
                                url: item?.ctaUrl
                            };
                        }),
                        products: item?.productCollection?.items?.map((item)=>{
                            return {
                                name: item?.productNameReference?.productName
                            };
                        }),
                        marketplaceApps: item?.marketplaceAppsCollection?.items?.map((item)=>{
                            return {
                                name: item?.title
                            };
                        }),
                        solutions: item?.solutionCollection?.items?.map((item)=>{
                            return {
                                name: item?.solutionNameExternal
                            };
                        }),
                        solutionPartners: item?.solutionPartnersCollection?.items?.map((item)=>{
                            return {
                                name: item?.organizationNameExternal
                            };
                        }),
                        urlSlug: item?.urlSlug
                    }
                };
            }) ?? []
        },
        taxonomyCompanySizeCollection: contentfulStories.taxonomyCompanySizeCollection,
        filters: {
            edges: [
                ...contentfulStories?.taxonomyIndustryCollection?.items?.filter((item)=>item?.linkedFrom?.companyNameInternalCollection?.items?.some((link)=>link?.linkedFrom?.customerStoryCollection?.total)).map((element)=>{
                    return {
                        node: {
                            context: {
                                name: element?.industryName
                            },
                            field: 'industry'
                        }
                    };
                }) ?? [],
                ...contentfulStories?.taxonomyCompanySizeCollection?.items?.filter((item)=>item?.linkedFrom?.companyNameInternalCollection?.items?.some((link)=>link?.linkedFrom?.customerStoryCollection?.total)).map((element)=>{
                    return {
                        node: {
                            context: {
                                name: element?.companySizeTitleExternal
                            },
                            field: 'organizationSize'
                        }
                    };
                }) ?? [],
                ...contentfulStories?.productNameCollection?.items?.filter((item)=>item?.linkedFrom?.productListingCollection?.items?.some((link)=>link?.linkedFrom?.customerStoryCollection?.total)).map((element)=>{
                    return {
                        node: {
                            context: {
                                name: element?.productName
                            },
                            field: 'products'
                        }
                    };
                }) ?? [],
                ...contentfulStories?.taxonomyRegionCollection?.items?.filter((item)=>item?.linkedFrom?.companyNameInternalCollection?.items?.some((link)=>link?.linkedFrom?.customerStoryCollection?.total)).map((element)=>{
                    return {
                        node: {
                            context: {
                                name: element?.regionNameExternal
                            },
                            field: 'region'
                        }
                    };
                }) ?? [],
                ...contentfulStories?.taxonomySolutionCollection?.items?.filter((item)=>item?.linkedFrom?.customerStoryCollection?.total).map((element)=>{
                    return {
                        node: {
                            context: {
                                name: element?.solutionNameExternal
                            },
                            field: 'solution'
                        }
                    };
                }) ?? []
            ]
        }
    };
};

});
parcelRegister("i7ByD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return $f9d4831575b28347$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<f9492297d3ee68695018811c75e30dc9>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f9d4831575b28347$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locale"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "locale",
        "variableName": "locale"
    }, v2 = [
        {
            "kind": "Literal",
            "name": "limit",
            "value": 200
        },
        v1 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "order",
            "value": "sys_publishedAt_DESC"
        },
        {
            "kind": "Literal",
            "name": "where",
            "value": {
                "storyTitleExternal_exists": true,
                "sys": {
                    "publishedAt_exists": true
                }
            }
        }
    ], v3 = {
        "alias": null,
        "args": null,
        "concreteType": "Sys",
        "kind": "LinkedField",
        "name": "sys",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "publishedAt",
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "storyTitleExternal",
        "storageKey": null
    }, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "organizationNameExternal",
        "storageKey": null
    }, v6 = {
        "kind": "Literal",
        "name": "limit",
        "value": 5
    }, v7 = [
        v6 /*: any*/ 
    ], v8 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contentType",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
        }
    ], v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "industryName",
        "storageKey": null
    }, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "regionNameExternal",
        "storageKey": null
    }, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "companySizeTitleExternal",
        "storageKey": null
    }, v12 = {
        "alias": null,
        "args": null,
        "concreteType": "CompanyNameInternal",
        "kind": "LinkedField",
        "name": "customerCompany",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            {
                "alias": null,
                "args": v7 /*: any*/ ,
                "concreteType": "AssetCollection",
                "kind": "LinkedField",
                "name": "logoCollection",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Asset",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": v8 /*: any*/ ,
                        "storageKey": null
                    }
                ],
                "storageKey": "logoCollection(limit:5)"
            },
            {
                "alias": null,
                "args": v7 /*: any*/ ,
                "concreteType": "CompanyNameInternalIndustryCollection",
                "kind": "LinkedField",
                "name": "industryCollection",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "TaxonomyIndustry",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                            v9 /*: any*/ 
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": "industryCollection(limit:5)"
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "TaxonomyRegion",
                "kind": "LinkedField",
                "name": "region",
                "plural": false,
                "selections": [
                    v10 /*: any*/ 
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "TaxonomyCompanySize",
                "kind": "LinkedField",
                "name": "organizationSize",
                "plural": false,
                "selections": [
                    v11 /*: any*/ 
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v13 = {
        "alias": null,
        "args": v7 /*: any*/ ,
        "concreteType": "CustomerStoryAdvocateQuotesCollection",
        "kind": "LinkedField",
        "name": "advocateQuotesCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "AdvocateQuote",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "advocateName",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "advocateQuote",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "advocateJobTitle",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Asset",
                        "kind": "LinkedField",
                        "name": "advocateHeadshot",
                        "plural": false,
                        "selections": v8 /*: any*/ ,
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "advocateQuotesCollection(limit:5)"
    }, v14 = {
        "alias": null,
        "args": null,
        "concreteType": "Asset",
        "kind": "LinkedField",
        "name": "storyIcon",
        "plural": false,
        "selections": v8 /*: any*/ ,
        "storageKey": null
    }, v15 = {
        "alias": null,
        "args": v7 /*: any*/ ,
        "concreteType": "CustomerStoryCallToActionCollection",
        "kind": "LinkedField",
        "name": "callToActionCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "CallToAction",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ctaText",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ctaUrl",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "callToActionCollection(limit:5)"
    }, v16 = {
        "kind": "Literal",
        "name": "limit",
        "value": 20
    }, v17 = [
        v16 /*: any*/ 
    ], v18 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "productName",
        "storageKey": null
    }, v19 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ProductName",
                "kind": "LinkedField",
                "name": "productNameReference",
                "plural": false,
                "selections": [
                    v18 /*: any*/ 
                ],
                "storageKey": null
            }
        ],
        "type": "ProductListing",
        "abstractKey": null
    }, v20 = {
        "alias": null,
        "args": v7 /*: any*/ ,
        "concreteType": "CustomerStoryMarketplaceAppsCollection",
        "kind": "LinkedField",
        "name": "marketplaceAppsCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ContextApp",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "marketplaceAppsCollection(limit:5)"
    }, v21 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "solutionNameExternal",
        "storageKey": null
    }, v22 = {
        "alias": null,
        "args": v7 /*: any*/ ,
        "concreteType": "CustomerStorySolutionCollection",
        "kind": "LinkedField",
        "name": "solutionCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "TaxonomySolution",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    v21 /*: any*/ 
                ],
                "storageKey": null
            }
        ],
        "storageKey": "solutionCollection(limit:5)"
    }, v23 = {
        "alias": null,
        "args": v7 /*: any*/ ,
        "concreteType": "CustomerStorySolutionPartnersCollection",
        "kind": "LinkedField",
        "name": "solutionPartnersCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "CompanyNameInternal",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    v5 /*: any*/ 
                ],
                "storageKey": null
            }
        ],
        "storageKey": "solutionPartnersCollection(limit:5)"
    }, v24 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urlSlug",
        "storageKey": null
    }, v25 = [
        v16 /*: any*/ ,
        v1 /*: any*/ 
    ], v26 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "total",
        "storageKey": null
    }, v27 = [
        {
            "kind": "Literal",
            "name": "allowedLocales",
            "value": [
                "en-US",
                "es",
                "ja-JP",
                "pt-BR",
                "fr-FR",
                "de-DE",
                "nl-NL",
                "it-IT",
                "ko-KR",
                "pl-PL",
                "ru-RU",
                "zh-CN"
            ]
        }
    ], v28 = [
        v26 /*: any*/ 
    ], v29 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Literal",
                    "name": "limit",
                    "value": 1
                }
            ],
            "concreteType": "CustomerStoryCollection",
            "kind": "LinkedField",
            "name": "customerStoryCollection",
            "plural": false,
            "selections": v28 /*: any*/ ,
            "storageKey": "customerStoryCollection(limit:1)"
        }
    ], v30 = {
        "alias": null,
        "args": v27 /*: any*/ ,
        "concreteType": "CompanyNameInternalLinkingCollections",
        "kind": "LinkedField",
        "name": "linkedFrom",
        "plural": false,
        "selections": v29 /*: any*/ ,
        "storageKey": "linkedFrom(allowedLocales:[\"en-US\",\"es\",\"ja-JP\",\"pt-BR\",\"fr-FR\",\"de-DE\",\"nl-NL\",\"it-IT\",\"ko-KR\",\"pl-PL\",\"ru-RU\",\"zh-CN\"])"
    }, v31 = {
        "alias": null,
        "args": v25 /*: any*/ ,
        "concreteType": "TaxonomyIndustryCollection",
        "kind": "LinkedField",
        "name": "taxonomyIndustryCollection",
        "plural": false,
        "selections": [
            v26 /*: any*/ ,
            {
                "alias": null,
                "args": null,
                "concreteType": "TaxonomyIndustry",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    v9 /*: any*/ ,
                    {
                        "alias": null,
                        "args": v27 /*: any*/ ,
                        "concreteType": "TaxonomyIndustryLinkingCollections",
                        "kind": "LinkedField",
                        "name": "linkedFrom",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "CompanyNameInternalCollection",
                                "kind": "LinkedField",
                                "name": "companyNameInternalCollection",
                                "plural": false,
                                "selections": [
                                    v26 /*: any*/ ,
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "CompanyNameInternal",
                                        "kind": "LinkedField",
                                        "name": "items",
                                        "plural": true,
                                        "selections": [
                                            v5 /*: any*/ ,
                                            v30 /*: any*/ 
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": "linkedFrom(allowedLocales:[\"en-US\",\"es\",\"ja-JP\",\"pt-BR\",\"fr-FR\",\"de-DE\",\"nl-NL\",\"it-IT\",\"ko-KR\",\"pl-PL\",\"ru-RU\",\"zh-CN\"])"
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v32 = {
        "alias": null,
        "args": [
            {
                "kind": "Literal",
                "name": "limit",
                "value": 25
            },
            v1 /*: any*/ 
        ],
        "concreteType": "ProductNameCollection",
        "kind": "LinkedField",
        "name": "productNameCollection",
        "plural": false,
        "selections": [
            v26 /*: any*/ ,
            {
                "alias": null,
                "args": null,
                "concreteType": "ProductName",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    v18 /*: any*/ ,
                    {
                        "alias": null,
                        "args": v27 /*: any*/ ,
                        "concreteType": "ProductNameLinkingCollections",
                        "kind": "LinkedField",
                        "name": "linkedFrom",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProductListingCollection",
                                "kind": "LinkedField",
                                "name": "productListingCollection",
                                "plural": false,
                                "selections": [
                                    v26 /*: any*/ ,
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProductListing",
                                        "kind": "LinkedField",
                                        "name": "items",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": v27 /*: any*/ ,
                                                "concreteType": "ProductListingLinkingCollections",
                                                "kind": "LinkedField",
                                                "name": "linkedFrom",
                                                "plural": false,
                                                "selections": v29 /*: any*/ ,
                                                "storageKey": "linkedFrom(allowedLocales:[\"en-US\",\"es\",\"ja-JP\",\"pt-BR\",\"fr-FR\",\"de-DE\",\"nl-NL\",\"it-IT\",\"ko-KR\",\"pl-PL\",\"ru-RU\",\"zh-CN\"])"
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": "linkedFrom(allowedLocales:[\"en-US\",\"es\",\"ja-JP\",\"pt-BR\",\"fr-FR\",\"de-DE\",\"nl-NL\",\"it-IT\",\"ko-KR\",\"pl-PL\",\"ru-RU\",\"zh-CN\"])"
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v33 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "CompanyNameInternalCollection",
            "kind": "LinkedField",
            "name": "companyNameInternalCollection",
            "plural": false,
            "selections": [
                v26 /*: any*/ ,
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompanyNameInternal",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        v30 /*: any*/ 
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ], v34 = {
        "alias": null,
        "args": [
            {
                "kind": "Literal",
                "name": "limit",
                "value": 10
            },
            v1 /*: any*/ 
        ],
        "concreteType": "TaxonomyRegionCollection",
        "kind": "LinkedField",
        "name": "taxonomyRegionCollection",
        "plural": false,
        "selections": [
            v26 /*: any*/ ,
            {
                "alias": null,
                "args": null,
                "concreteType": "TaxonomyRegion",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    v10 /*: any*/ ,
                    {
                        "alias": null,
                        "args": v27 /*: any*/ ,
                        "concreteType": "TaxonomyRegionLinkingCollections",
                        "kind": "LinkedField",
                        "name": "linkedFrom",
                        "plural": false,
                        "selections": v33 /*: any*/ ,
                        "storageKey": "linkedFrom(allowedLocales:[\"en-US\",\"es\",\"ja-JP\",\"pt-BR\",\"fr-FR\",\"de-DE\",\"nl-NL\",\"it-IT\",\"ko-KR\",\"pl-PL\",\"ru-RU\",\"zh-CN\"])"
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v35 = {
        "alias": null,
        "args": v25 /*: any*/ ,
        "concreteType": "TaxonomySolutionCollection",
        "kind": "LinkedField",
        "name": "taxonomySolutionCollection",
        "plural": false,
        "selections": [
            v26 /*: any*/ ,
            {
                "alias": null,
                "args": null,
                "concreteType": "TaxonomySolution",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    v21 /*: any*/ ,
                    {
                        "alias": null,
                        "args": v27 /*: any*/ ,
                        "concreteType": "TaxonomySolutionLinkingCollections",
                        "kind": "LinkedField",
                        "name": "linkedFrom",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "CustomerStoryCollection",
                                "kind": "LinkedField",
                                "name": "customerStoryCollection",
                                "plural": false,
                                "selections": v28 /*: any*/ ,
                                "storageKey": null
                            }
                        ],
                        "storageKey": "linkedFrom(allowedLocales:[\"en-US\",\"es\",\"ja-JP\",\"pt-BR\",\"fr-FR\",\"de-DE\",\"nl-NL\",\"it-IT\",\"ko-KR\",\"pl-PL\",\"ru-RU\",\"zh-CN\"])"
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v36 = {
        "alias": null,
        "args": [
            v6 /*: any*/ ,
            v1 /*: any*/ 
        ],
        "concreteType": "TaxonomyCompanySizeCollection",
        "kind": "LinkedField",
        "name": "taxonomyCompanySizeCollection",
        "plural": false,
        "selections": [
            v26 /*: any*/ ,
            {
                "alias": null,
                "args": null,
                "concreteType": "TaxonomyCompanySize",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    v11 /*: any*/ ,
                    {
                        "alias": null,
                        "args": v27 /*: any*/ ,
                        "concreteType": "TaxonomyCompanySizeLinkingCollections",
                        "kind": "LinkedField",
                        "name": "linkedFrom",
                        "plural": false,
                        "selections": v33 /*: any*/ ,
                        "storageKey": "linkedFrom(allowedLocales:[\"en-US\",\"es\",\"ja-JP\",\"pt-BR\",\"fr-FR\",\"de-DE\",\"nl-NL\",\"it-IT\",\"ko-KR\",\"pl-PL\",\"ru-RU\",\"zh-CN\"])"
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "metadata": null,
            "name": "customerLandingPageRelayQuery",
            "selections": [
                {
                    "alias": null,
                    "args": v2 /*: any*/ ,
                    "concreteType": "CustomerStoryCollection",
                    "kind": "LinkedField",
                    "name": "customerStoryCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CustomerStory",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": v17 /*: any*/ ,
                                    "concreteType": "CustomerStoryProductCollection",
                                    "kind": "LinkedField",
                                    "name": "productCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                v19 /*: any*/ 
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "productCollection(limit:20)"
                                },
                                v20 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                v31 /*: any*/ ,
                v32 /*: any*/ ,
                v34 /*: any*/ ,
                v35 /*: any*/ ,
                v36 /*: any*/ 
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "customerLandingPageRelayQuery",
            "selections": [
                {
                    "alias": null,
                    "args": v2 /*: any*/ ,
                    "concreteType": "CustomerStoryCollection",
                    "kind": "LinkedField",
                    "name": "customerStoryCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CustomerStory",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": v17 /*: any*/ ,
                                    "concreteType": "CustomerStoryProductCollection",
                                    "kind": "LinkedField",
                                    "name": "productCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "__typename",
                                                    "storageKey": null
                                                },
                                                v19 /*: any*/ 
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "productCollection(limit:20)"
                                },
                                v20 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                v31 /*: any*/ ,
                v32 /*: any*/ ,
                v34 /*: any*/ ,
                v35 /*: any*/ ,
                v36 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "3d3404ffc84351b24b67ea30bba4dc60",
            "id": null,
            "metadata": {},
            "name": "customerLandingPageRelayQuery",
            "operationKind": "query",
            "text": "query customerLandingPageRelayQuery(\n  $locale: String!\n) {\n  customerStoryCollection(locale: $locale, limit: 200, order: sys_publishedAt_DESC, where: {sys: {publishedAt_exists: true}, storyTitleExternal_exists: true}) {\n    items {\n      sys {\n        publishedAt\n      }\n      storyTitleExternal\n      customerCompany {\n        organizationNameExternal\n        logoCollection(limit: 5) {\n          items {\n            description\n            contentType\n            url\n          }\n        }\n        industryCollection(limit: 5) {\n          items {\n            industryName\n          }\n        }\n        region {\n          regionNameExternal\n        }\n        organizationSize {\n          companySizeTitleExternal\n        }\n      }\n      advocateQuotesCollection(limit: 5) {\n        items {\n          advocateName\n          advocateQuote\n          advocateJobTitle\n          advocateHeadshot {\n            description\n            contentType\n            url\n          }\n        }\n      }\n      storyIcon {\n        description\n        contentType\n        url\n      }\n      callToActionCollection(limit: 5) {\n        items {\n          ctaText\n          ctaUrl\n        }\n      }\n      productCollection(limit: 20) {\n        items {\n          __typename\n          ... on ProductListing {\n            productNameReference {\n              productName\n            }\n          }\n        }\n      }\n      marketplaceAppsCollection(limit: 5) {\n        items {\n          title\n        }\n      }\n      solutionCollection(limit: 5) {\n        items {\n          solutionNameExternal\n        }\n      }\n      solutionPartnersCollection(limit: 5) {\n        items {\n          organizationNameExternal\n        }\n      }\n      urlSlug\n    }\n  }\n  taxonomyIndustryCollection(locale: $locale, limit: 20) {\n    total\n    items {\n      industryName\n      linkedFrom(allowedLocales: [\"en-US\", \"es\", \"ja-JP\", \"pt-BR\", \"fr-FR\", \"de-DE\", \"nl-NL\", \"it-IT\", \"ko-KR\", \"pl-PL\", \"ru-RU\", \"zh-CN\"]) {\n        companyNameInternalCollection {\n          total\n          items {\n            organizationNameExternal\n            linkedFrom(allowedLocales: [\"en-US\", \"es\", \"ja-JP\", \"pt-BR\", \"fr-FR\", \"de-DE\", \"nl-NL\", \"it-IT\", \"ko-KR\", \"pl-PL\", \"ru-RU\", \"zh-CN\"]) {\n              customerStoryCollection(limit: 1) {\n                total\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  productNameCollection(locale: $locale, limit: 25) {\n    total\n    items {\n      productName\n      linkedFrom(allowedLocales: [\"en-US\", \"es\", \"ja-JP\", \"pt-BR\", \"fr-FR\", \"de-DE\", \"nl-NL\", \"it-IT\", \"ko-KR\", \"pl-PL\", \"ru-RU\", \"zh-CN\"]) {\n        productListingCollection {\n          total\n          items {\n            linkedFrom(allowedLocales: [\"en-US\", \"es\", \"ja-JP\", \"pt-BR\", \"fr-FR\", \"de-DE\", \"nl-NL\", \"it-IT\", \"ko-KR\", \"pl-PL\", \"ru-RU\", \"zh-CN\"]) {\n              customerStoryCollection(limit: 1) {\n                total\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  taxonomyRegionCollection(locale: $locale, limit: 10) {\n    total\n    items {\n      regionNameExternal\n      linkedFrom(allowedLocales: [\"en-US\", \"es\", \"ja-JP\", \"pt-BR\", \"fr-FR\", \"de-DE\", \"nl-NL\", \"it-IT\", \"ko-KR\", \"pl-PL\", \"ru-RU\", \"zh-CN\"]) {\n        companyNameInternalCollection {\n          total\n          items {\n            linkedFrom(allowedLocales: [\"en-US\", \"es\", \"ja-JP\", \"pt-BR\", \"fr-FR\", \"de-DE\", \"nl-NL\", \"it-IT\", \"ko-KR\", \"pl-PL\", \"ru-RU\", \"zh-CN\"]) {\n              customerStoryCollection(limit: 1) {\n                total\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  taxonomySolutionCollection(locale: $locale, limit: 20) {\n    total\n    items {\n      solutionNameExternal\n      linkedFrom(allowedLocales: [\"en-US\", \"es\", \"ja-JP\", \"pt-BR\", \"fr-FR\", \"de-DE\", \"nl-NL\", \"it-IT\", \"ko-KR\", \"pl-PL\", \"ru-RU\", \"zh-CN\"]) {\n        customerStoryCollection {\n          total\n        }\n      }\n    }\n  }\n  taxonomyCompanySizeCollection(locale: $locale, limit: 5) {\n    total\n    items {\n      companySizeTitleExternal\n      linkedFrom(allowedLocales: [\"en-US\", \"es\", \"ja-JP\", \"pt-BR\", \"fr-FR\", \"de-DE\", \"nl-NL\", \"it-IT\", \"ko-KR\", \"pl-PL\", \"ru-RU\", \"zh-CN\"]) {\n        companyNameInternalCollection {\n          total\n          items {\n            linkedFrom(allowedLocales: [\"en-US\", \"es\", \"ja-JP\", \"pt-BR\", \"fr-FR\", \"de-DE\", \"nl-NL\", \"it-IT\", \"ko-KR\", \"pl-PL\", \"ru-RU\", \"zh-CN\"]) {\n              customerStoryCollection(limit: 1) {\n                total\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
        }
    };
}();
$f9d4831575b28347$var$node.hash = "14e2d83e9b74bfe20f118ae09eb3c78c";
var $f9d4831575b28347$export$2e2bcd8739ae039 = $f9d4831575b28347$var$node;

});


parcelRegister("6mvtm", function(module, exports) {
$parcel$export(module.exports, "RELAY_API_CONTENTFUL", function () { return $e62c9da570d0cc47$export$7b31a9938ec3ba75; });
const $e62c9da570d0cc47$export$7b31a9938ec3ba75 = 'contentful';

});

parcelRegister("k6PTJ", function(module, exports) {
$parcel$export(module.exports, "AnchorPageRelayQuery", function () { return $7906bd495d425fea$export$102ea97ffff273aa; });
$parcel$export(module.exports, "getAnchorPageRelayQueryVars", function () { return $7906bd495d425fea$export$9db61a55a3e7ac2d; });
$parcel$export(module.exports, "shapeAnchorContentfulResponse", function () { return $7906bd495d425fea$export$ee86e87edca54d71; });

var $hu7gH = parcelRequire("hu7gH");

var $kf4PU = parcelRequire("kf4PU");

var $gVC4y = parcelRequire("gVC4y");
var $7906bd495d425fea$var$_anchorPageRelayQuery;

const $7906bd495d425fea$export$102ea97ffff273aa = $7906bd495d425fea$var$_anchorPageRelayQuery !== void 0 ? $7906bd495d425fea$var$_anchorPageRelayQuery : ($7906bd495d425fea$var$_anchorPageRelayQuery = (parcelRequire("gpiLA")), $7906bd495d425fea$var$_anchorPageRelayQuery.hash && $7906bd495d425fea$var$_anchorPageRelayQuery.hash !== "b5acdf742944624a0b58eb80313c25b1" && console.error("The definition of 'anchorPageRelayQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $7906bd495d425fea$var$_anchorPageRelayQuery);
const $7906bd495d425fea$export$9db61a55a3e7ac2d = (cmsPageVariant, location)=>{
    const { locale: locale } = (0, $hu7gH.parseRoute)(location);
    return {
        paidVariant: cmsPageVariant,
        locale: (0, $kf4PU.WAC_TO_CPAPI_LOCALE_MAP)[locale] || 'en-US'
    };
};
function $7906bd495d425fea$export$ee86e87edca54d71(data) {
    // eslint-disable-next-line complexity
    return data.anchorCollection?.items.map((anchor)=>({
            node: {
                name: anchor?.anchorTitleExternal || '',
                pageVariant: anchor?.paidVariant || 'paid-lp-jsw-features',
                persona: anchor?.personaCollection?.items.map((persona)=>({
                        name: persona?.personaNameExternal || '',
                        id: persona?.personaNameExternal || ''
                    })) || [],
                product: anchor?.productCollection?.items.map((product)=>({
                        productNameId: product?.productNameReference?.productNameId || ''
                    })) || [],
                headline: anchor?.headlineCollection?.items.map((headline)=>({
                        name: headline?.headlineTitleExternal || null,
                        subheading: headline?.headlineSubheading || null,
                        planBenefits: headline?.planBenefitsCollection?.items.map((planBenefit)=>({
                                description: (0, $gVC4y.richTextToHTML)(planBenefit?.planBenefits?.json),
                                supportingAsset: {
                                    url: planBenefit?.supportingAsset?.url || '',
                                    description: planBenefit?.supportingAsset?.description || ''
                                },
                                planFeatures: planBenefit?.planFeaturesCollection?.items.map((planFeature)=>({
                                        description: (0, $gVC4y.richTextToHTML)(planFeature?.description?.json)
                                    })) || null
                            })) || []
                    })) || [],
                primaryMessage: anchor?.primaryMessageCollection?.items.map((primaryMessage)=>({
                        name: primaryMessage?.primaryMessageTitleExternal || '',
                        supportingExample: primaryMessage?.supportingExampleCollection?.items.map(// eslint-disable-next-line complexity
                        (supportingExample)=>({
                                proofpoint: (0, $gVC4y.richTextToHTML)(supportingExample?.proofpoint?.json),
                                supportingAsset: {
                                    url: supportingExample?.supportingAsset?.url || '',
                                    description: supportingExample?.supportingAsset?.description || ''
                                },
                                heading: supportingExample?.supportingExampleHeading || null,
                                name: supportingExample?.supportingExampleTitleExternal || '',
                                advocateQuote: !!supportingExample?.advocateQuote ? {
                                    advocateHeadshot: {
                                        url: supportingExample?.advocateQuote?.advocateHeadshot?.url || null,
                                        description: supportingExample?.advocateQuote?.advocateHeadshot?.description || null
                                    },
                                    advocateName: supportingExample?.advocateQuote?.advocateName || null,
                                    advocateQuote: supportingExample?.advocateQuote?.advocateQuote || null,
                                    advocateJobTitle: supportingExample?.advocateQuote?.advocateJobTitle || null
                                } : null
                            })) || []
                    })) || [],
                banner: // eslint-disable-next-line complexity
                anchor?.bannerCollection?.items.map((banner)=>({
                        bannerImage: {
                            description: banner?.bannerImage?.description || null,
                            url: banner?.bannerImage?.url || null
                        },
                        backgroundImage: {
                            url: banner?.bannerBackground?.url || null
                        },
                        text: (0, $gVC4y.richTextToHTML)(banner?.bannerText?.json) || '',
                        url: banner?.bannerUrl || '',
                        urlText: banner?.bannerUrlText || ''
                    })) || null,
                results: // eslint-disable-next-line complexity
                anchor?.resultsCollection?.items.map((result)=>({
                        id: result?.sys?.id || '',
                        name: result?.resultTitleExternal || '',
                        lozenge: result?.lozenge || null,
                        subheading: (0, $gVC4y.richTextToHTML)(result?.newResultSubheading?.json),
                        asset: {
                            url: result?.resultAsset?.url || '',
                            description: result?.resultAsset?.description || '',
                            fileName: result?.resultAsset?.fileName || '',
                            title: result?.resultAsset?.title || '',
                            details: null,
                            contentType: result?.resultAsset?.contentType || ''
                        }
                    })) || [],
                socialProof: anchor?.socialProofCollection?.items.map((proof)=>({
                        name: proof?.socialProofTitleExternal || '',
                        customers: proof?.customersCollection?.items.map((customer)=>({
                                logo: customer?.logoCollection?.items.map((logo)=>({
                                        url: logo?.url || '',
                                        description: logo?.description || ''
                                    })) || [],
                                altDarkLogo: customer?.altDarkLogoCollection?.items.map((darkLogo)=>({
                                        url: darkLogo?.url || '',
                                        description: darkLogo?.description || ''
                                    })) || []
                            })) || []
                    })) || [],
                callToAction: anchor?.callToActionCollection?.items.map((cta)=>({
                        valueProposition: cta?.valueProposition || '',
                        text: cta?.ctaText || '',
                        url: cta?.ctaUrl || ''
                    })) || []
            }
        }));
}

});
parcelRegister("gpiLA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return $95c4c2ff867336d4$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<3210dc1da59269531585a698c5b79a75>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $95c4c2ff867336d4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locale"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "paidVariant"
        }
    ], v1 = {
        "kind": "Literal",
        "name": "limit",
        "value": 1
    }, v2 = [
        v1 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "locale",
            "variableName": "locale"
        },
        {
            "kind": "Literal",
            "name": "skip",
            "value": 0
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "paidVariant",
                    "variableName": "paidVariant"
                }
            ],
            "kind": "ObjectValue",
            "name": "where"
        }
    ], v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "anchorTitleExternal",
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "paidVariant",
        "storageKey": null
    }, v5 = {
        "alias": null,
        "args": [
            v1 /*: any*/ ,
            {
                "kind": "Literal",
                "name": "where",
                "value": {
                    "personaNameExternal": "unknown"
                }
            }
        ],
        "concreteType": "AnchorPersonaCollection",
        "kind": "LinkedField",
        "name": "personaCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "TaxonomyPersona",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "personaNameExternal",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "personaCollection(limit:1,where:{\"personaNameExternal\":\"unknown\"})"
    }, v6 = [
        v1 /*: any*/ 
    ], v7 = {
        "alias": null,
        "args": v6 /*: any*/ ,
        "concreteType": "AnchorProductCollection",
        "kind": "LinkedField",
        "name": "productCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ProductListing",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductName",
                        "kind": "LinkedField",
                        "name": "productNameReference",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "productNameId",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "productCollection(limit:1)"
    }, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "headlineTitleExternal",
        "storageKey": null
    }, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "headlineSubheading",
        "storageKey": null
    }, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "json",
        "storageKey": null
    }, v11 = {
        "alias": null,
        "args": null,
        "concreteType": "Sys",
        "kind": "LinkedField",
        "name": "sys",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v12 = [
        {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "inline",
            "plural": true,
            "selections": [
                v11 /*: any*/ 
            ],
            "storageKey": null
        }
    ], v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
    }, v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
    }, v15 = [
        v13 /*: any*/ ,
        v14 /*: any*/ 
    ], v16 = {
        "alias": null,
        "args": null,
        "concreteType": "Asset",
        "kind": "LinkedField",
        "name": "supportingAsset",
        "plural": false,
        "selections": v15 /*: any*/ ,
        "storageKey": null
    }, v17 = [
        {
            "kind": "Literal",
            "name": "limit",
            "value": 6
        }
    ], v18 = [
        {
            "kind": "Literal",
            "name": "limit",
            "value": 10
        }
    ], v19 = [
        v10 /*: any*/ 
    ], v20 = {
        "alias": null,
        "args": v6 /*: any*/ ,
        "concreteType": "AnchorPrimaryMessageCollection",
        "kind": "LinkedField",
        "name": "primaryMessageCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "PrimaryMessage",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "primaryMessageTitleExternal",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": v18 /*: any*/ ,
                        "concreteType": "PrimaryMessageSupportingExampleCollection",
                        "kind": "LinkedField",
                        "name": "supportingExampleCollection",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "SupportingExample",
                                "kind": "LinkedField",
                                "name": "items",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SupportingExampleProofpoint",
                                        "kind": "LinkedField",
                                        "name": "proofpoint",
                                        "plural": false,
                                        "selections": v19 /*: any*/ ,
                                        "storageKey": null
                                    },
                                    v16 /*: any*/ ,
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "supportingExampleHeading",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "supportingExampleTitleExternal",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "AdvocateQuote",
                                        "kind": "LinkedField",
                                        "name": "advocateQuote",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Asset",
                                                "kind": "LinkedField",
                                                "name": "advocateHeadshot",
                                                "plural": false,
                                                "selections": v15 /*: any*/ ,
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "advocateName",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "advocateQuote",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "advocateJobTitle",
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": "supportingExampleCollection(limit:10)"
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "primaryMessageCollection(limit:1)"
    }, v21 = {
        "alias": null,
        "args": [
            {
                "kind": "Literal",
                "name": "limit",
                "value": 3
            }
        ],
        "concreteType": "AnchorBannerCollection",
        "kind": "LinkedField",
        "name": "bannerCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "Banner",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "bannerUrl",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Asset",
                        "kind": "LinkedField",
                        "name": "bannerImage",
                        "plural": false,
                        "selections": v15 /*: any*/ ,
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Asset",
                        "kind": "LinkedField",
                        "name": "bannerBackground",
                        "plural": false,
                        "selections": [
                            v13 /*: any*/ 
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "BannerBannerText",
                        "kind": "LinkedField",
                        "name": "bannerText",
                        "plural": false,
                        "selections": v19 /*: any*/ ,
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "bannerUrlText",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "bannerCollection(limit:3)"
    }, v22 = {
        "alias": null,
        "args": v18 /*: any*/ ,
        "concreteType": "AnchorResultsCollection",
        "kind": "LinkedField",
        "name": "resultsCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "Result",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    v11 /*: any*/ ,
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "resultTitleExternal",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lozenge",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "ResultNewResultSubheading",
                        "kind": "LinkedField",
                        "name": "newResultSubheading",
                        "plural": false,
                        "selections": v19 /*: any*/ ,
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Asset",
                        "kind": "LinkedField",
                        "name": "resultAsset",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "title",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "fileName",
                                "storageKey": null
                            },
                            v13 /*: any*/ ,
                            v14 /*: any*/ ,
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "contentType",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "resultsCollection(limit:10)"
    }, v23 = {
        "alias": null,
        "args": v6 /*: any*/ ,
        "concreteType": "AnchorCallToActionCollection",
        "kind": "LinkedField",
        "name": "callToActionCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "CallToAction",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "valueProposition",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ctaText",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ctaUrl",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "callToActionCollection(limit:1)"
    }, v24 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "Asset",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": v15 /*: any*/ ,
            "storageKey": null
        }
    ], v25 = {
        "alias": null,
        "args": v6 /*: any*/ ,
        "concreteType": "AnchorSocialProofCollection",
        "kind": "LinkedField",
        "name": "socialProofCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "SocialProof",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "socialProofTitleExternal",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "limit",
                                "value": 16
                            }
                        ],
                        "concreteType": "SocialProofCustomersCollection",
                        "kind": "LinkedField",
                        "name": "customersCollection",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "CompanyNameInternal",
                                "kind": "LinkedField",
                                "name": "items",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": v6 /*: any*/ ,
                                        "concreteType": "AssetCollection",
                                        "kind": "LinkedField",
                                        "name": "logoCollection",
                                        "plural": false,
                                        "selections": v24 /*: any*/ ,
                                        "storageKey": "logoCollection(limit:1)"
                                    },
                                    {
                                        "alias": null,
                                        "args": v6 /*: any*/ ,
                                        "concreteType": "AssetCollection",
                                        "kind": "LinkedField",
                                        "name": "altDarkLogoCollection",
                                        "plural": false,
                                        "selections": v24 /*: any*/ ,
                                        "storageKey": "altDarkLogoCollection(limit:1)"
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": "customersCollection(limit:16)"
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "socialProofCollection(limit:1)"
    }, v26 = [
        {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "inline",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                },
                v11 /*: any*/ 
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "metadata": null,
            "name": "anchorPageRelayQuery",
            "selections": [
                {
                    "alias": null,
                    "args": v2 /*: any*/ ,
                    "concreteType": "AnchorCollection",
                    "kind": "LinkedField",
                    "name": "anchorCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Anchor",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "AnchorHeadlineCollection",
                                    "kind": "LinkedField",
                                    "name": "headlineCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Headline",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                {
                                                    "alias": null,
                                                    "args": v6 /*: any*/ ,
                                                    "concreteType": "HeadlinePlanBenefitsCollection",
                                                    "kind": "LinkedField",
                                                    "name": "planBenefitsCollection",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "PlanBenefits",
                                                            "kind": "LinkedField",
                                                            "name": "items",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "PlanBenefitsPlanBenefits",
                                                                    "kind": "LinkedField",
                                                                    "name": "planBenefits",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "PlanBenefitsPlanBenefitsLinks",
                                                                            "kind": "LinkedField",
                                                                            "name": "links",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "PlanBenefitsPlanBenefitsEntries",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "entries",
                                                                                    "plural": false,
                                                                                    "selections": v12 /*: any*/ ,
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                v16 /*: any*/ ,
                                                                {
                                                                    "alias": null,
                                                                    "args": v17 /*: any*/ ,
                                                                    "concreteType": "PlanBenefitsPlanFeaturesCollection",
                                                                    "kind": "LinkedField",
                                                                    "name": "planFeaturesCollection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "TaxonomyFeature",
                                                                            "kind": "LinkedField",
                                                                            "name": "items",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "TaxonomyFeatureDescription",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "description",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v10 /*: any*/ ,
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "TaxonomyFeatureDescriptionLinks",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "links",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "TaxonomyFeatureDescriptionEntries",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "entries",
                                                                                                    "plural": false,
                                                                                                    "selections": v12 /*: any*/ ,
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": "planFeaturesCollection(limit:6)"
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": "planBenefitsCollection(limit:1)"
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "headlineCollection(limit:1)"
                                },
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v25 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "anchorPageRelayQuery",
            "selections": [
                {
                    "alias": null,
                    "args": v2 /*: any*/ ,
                    "concreteType": "AnchorCollection",
                    "kind": "LinkedField",
                    "name": "anchorCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Anchor",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "AnchorHeadlineCollection",
                                    "kind": "LinkedField",
                                    "name": "headlineCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Headline",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                {
                                                    "alias": null,
                                                    "args": v6 /*: any*/ ,
                                                    "concreteType": "HeadlinePlanBenefitsCollection",
                                                    "kind": "LinkedField",
                                                    "name": "planBenefitsCollection",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "PlanBenefits",
                                                            "kind": "LinkedField",
                                                            "name": "items",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "PlanBenefitsPlanBenefits",
                                                                    "kind": "LinkedField",
                                                                    "name": "planBenefits",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "PlanBenefitsPlanBenefitsLinks",
                                                                            "kind": "LinkedField",
                                                                            "name": "links",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "PlanBenefitsPlanBenefitsEntries",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "entries",
                                                                                    "plural": false,
                                                                                    "selections": v26 /*: any*/ ,
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                v16 /*: any*/ ,
                                                                {
                                                                    "alias": null,
                                                                    "args": v17 /*: any*/ ,
                                                                    "concreteType": "PlanBenefitsPlanFeaturesCollection",
                                                                    "kind": "LinkedField",
                                                                    "name": "planFeaturesCollection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "TaxonomyFeature",
                                                                            "kind": "LinkedField",
                                                                            "name": "items",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "TaxonomyFeatureDescription",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "description",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v10 /*: any*/ ,
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "TaxonomyFeatureDescriptionLinks",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "links",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "TaxonomyFeatureDescriptionEntries",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "entries",
                                                                                                    "plural": false,
                                                                                                    "selections": v26 /*: any*/ ,
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": "planFeaturesCollection(limit:6)"
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": "planBenefitsCollection(limit:1)"
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "headlineCollection(limit:1)"
                                },
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v25 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "c0e29d89a263bf14d5f310fa9fca5b2c",
            "id": null,
            "metadata": {},
            "name": "anchorPageRelayQuery",
            "operationKind": "query",
            "text": "query anchorPageRelayQuery(\n  $locale: String!\n  $paidVariant: String!\n) {\n  anchorCollection(locale: $locale, where: {paidVariant: $paidVariant}, limit: 1, skip: 0) {\n    items {\n      anchorTitleExternal\n      paidVariant\n      personaCollection(limit: 1, where: {personaNameExternal: \"unknown\"}) {\n        items {\n          personaNameExternal\n        }\n      }\n      productCollection(limit: 1) {\n        items {\n          productNameReference {\n            productNameId\n          }\n        }\n      }\n      headlineCollection(limit: 1) {\n        items {\n          headlineTitleExternal\n          headlineSubheading\n          planBenefitsCollection(limit: 1) {\n            items {\n              planBenefits {\n                json\n                links {\n                  entries {\n                    inline {\n                      __typename\n                      sys {\n                        id\n                      }\n                    }\n                  }\n                }\n              }\n              supportingAsset {\n                url\n                description\n              }\n              planFeaturesCollection(limit: 6) {\n                items {\n                  description {\n                    json\n                    links {\n                      entries {\n                        inline {\n                          __typename\n                          sys {\n                            id\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n      primaryMessageCollection(limit: 1) {\n        items {\n          primaryMessageTitleExternal\n          supportingExampleCollection(limit: 10) {\n            items {\n              proofpoint {\n                json\n              }\n              supportingAsset {\n                url\n                description\n              }\n              supportingExampleHeading\n              supportingExampleTitleExternal\n              advocateQuote {\n                advocateHeadshot {\n                  url\n                  description\n                }\n                advocateName\n                advocateQuote\n                advocateJobTitle\n              }\n            }\n          }\n        }\n      }\n      bannerCollection(limit: 3) {\n        items {\n          bannerUrl\n          bannerImage {\n            url\n            description\n          }\n          bannerBackground {\n            url\n          }\n          bannerText {\n            json\n          }\n          bannerUrlText\n        }\n      }\n      resultsCollection(limit: 10) {\n        items {\n          sys {\n            id\n          }\n          resultTitleExternal\n          lozenge\n          newResultSubheading {\n            json\n          }\n          resultAsset {\n            title\n            fileName\n            url\n            description\n            contentType\n          }\n        }\n      }\n      callToActionCollection(limit: 1) {\n        items {\n          valueProposition\n          ctaText\n          ctaUrl\n        }\n      }\n      socialProofCollection(limit: 1) {\n        items {\n          socialProofTitleExternal\n          customersCollection(limit: 16) {\n            items {\n              logoCollection(limit: 1) {\n                items {\n                  url\n                  description\n                }\n              }\n              altDarkLogoCollection(limit: 1) {\n                items {\n                  url\n                  description\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
        }
    };
}();
$95c4c2ff867336d4$var$node.hash = "b5acdf742944624a0b58eb80313c25b1";
var $95c4c2ff867336d4$export$2e2bcd8739ae039 = $95c4c2ff867336d4$var$node;

});


parcelRegister("5UKqd", function(module, exports) {
$parcel$export(module.exports, "PricingPageRelayQuery", function () { return $b9b8849a1260f275$export$1a50c94ee129d160; });
$parcel$export(module.exports, "getPricingPageRelayQueryVars", function () { return $b9b8849a1260f275$export$73d4337b94775e7c; });
$parcel$export(module.exports, "shapePricingContentfulResponse", function () { return $b9b8849a1260f275$export$7d2aff0545f03f9e; });

var $hu7gH = parcelRequire("hu7gH");

var $kf4PU = parcelRequire("kf4PU");

var $gVC4y = parcelRequire("gVC4y");
var $b9b8849a1260f275$var$_pricingPageRelayQuery;

const $b9b8849a1260f275$export$1a50c94ee129d160 = $b9b8849a1260f275$var$_pricingPageRelayQuery !== void 0 ? $b9b8849a1260f275$var$_pricingPageRelayQuery : ($b9b8849a1260f275$var$_pricingPageRelayQuery = (parcelRequire("i9aaD")), $b9b8849a1260f275$var$_pricingPageRelayQuery.hash && $b9b8849a1260f275$var$_pricingPageRelayQuery.hash !== "c972d0b0a98f9d312a6714300ced3fae" && console.error("The definition of 'pricingPageRelayQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $b9b8849a1260f275$var$_pricingPageRelayQuery);
const $b9b8849a1260f275$export$73d4337b94775e7c = (productNameId, location, pricingTitleInternal = null)=>{
    const { locale: locale } = (0, $hu7gH.parseRoute)(location);
    return {
        productNameId: productNameId,
        locale: (0, $kf4PU.WAC_TO_CPAPI_LOCALE_MAP)[locale] || 'en-US',
        pricingTitleInternal: pricingTitleInternal
    };
};
const $b9b8849a1260f275$export$7d2aff0545f03f9e = (data)=>{
    // Extract pricingCollection from data if it's nested
    const pricingCollection = data.pricingCollection;
    if (!pricingCollection || !pricingCollection.items) return {
        pricings: {
            edges: []
        }
    };
    return {
        pricings: {
            // @ts-ignore
            edges: pricingCollection.items.filter(Boolean).map((item)=>({
                    __typename: 'ContentPlatformPricingResultEdge',
                    node: {
                        __typename: 'ContentPlatformPricing',
                        pricingTitleInternal: item?.pricingTitleInternal ?? '',
                        pricingTitleExternal: item?.pricingTitleExternal ?? null,
                        // DO NOT DELETE — this field still exists in Contentful even though it is unused in UIP and hidden from the Contentful editor
                        pageDescription: item?.pageDescription ?? null,
                        // DO NOT DELETE — this field still exists in Contentful even though it is unused in UIP and hidden from the Contentful editor
                        headline: item?.headline?.json ? (0, $gVC4y.richTextToHTML)(item.headline.json) : null,
                        comparePlans: item?.comparePlansCollection?.items?.filter(Boolean).map((plan)=>({
                                __typename: 'ContentPlatformPlan',
                                planTitleExternal: plan?.planTitleExternal ?? null,
                                planOneLiner: plan?.planOneLiner ?? null,
                                highlightedFeaturesTitle: plan?.highlightedFeaturesTitle ?? null,
                                microCta: plan?.microCtaCollection?.items?.filter(Boolean).map((cta)=>({
                                        __typename: 'ContentPlatformCallToActionMicrocopy',
                                        ctaMicrocopyTitle: cta?.ctaMicrocopyTitleExternal ?? null,
                                        ctaButtonText: cta?.ctaButtonText ?? null,
                                        ctaUrl: cta?.ctaUrl ?? null
                                    })) || [],
                                highlightedFeaturesContainer: plan?.highlightedFeaturesContainerCollection?.items?.filter(Boolean).map((feature)=>({
                                        __typename: 'ContentPlatformHighlightedFeature',
                                        highlightedFeatureDetails: feature?.highlightedFeatureDetails?.json ? (0, $gVC4y.richTextToHTML)(feature.highlightedFeatureDetails.json) : null,
                                        highlightedFeatureTitleExternal: feature?.highlightedFeatureTitleExternal ?? null,
                                        callOut: feature?.callOut ?? null
                                    })) || []
                            })) || [],
                        compareFeaturesTitle: item?.compareFeaturesTitle ?? null,
                        compareFeatures: item?.compareFeaturesCollection?.items?.filter(Boolean).map((featureGroup)=>({
                                __typename: 'ContentPlatformFeatureGroup',
                                featureGroupTitleExternal: featureGroup?.featureGroupTitleExternal ?? null,
                                features: featureGroup?.featuresCollection?.items?.filter(Boolean).map((feature)=>({
                                        __typename: 'ContentPlatformFeature',
                                        callOut: feature?.callOut ?? null,
                                        featureNameExternal: feature?.featureNameExternal ?? null,
                                        description: feature?.description?.json ? (0, $gVC4y.richTextToHTML)(feature.description.json) : null,
                                        relevantPlan: feature?.relevantPlanCollection?.items?.filter(Boolean).map((plan)=>({
                                                __typename: 'ContentPlatformPlan',
                                                planTitleExternal: plan?.planTitleExternal ?? null
                                            })) || [],
                                        relevantUrl: feature?.relevantUrl ?? null,
                                        featureAdditionalInformation: feature?.featureAdditionalInformationCollection?.items?.filter(Boolean).map((info)=>({
                                                __typename: 'ContentPlatformFeatureAdditionalInformation',
                                                featureAdditionalInformation: info?.featureAdditionalInformation ?? null,
                                                relevantPlan: info?.relevantPlanCollection?.items?.filter(Boolean).map((plan)=>({
                                                        __typename: 'ContentPlatformPlan',
                                                        planTitleExternal: plan?.planTitleExternal ?? null
                                                    })) || []
                                            })) || []
                                    })) || []
                            })) || [],
                        getMoreDetailsTitle: item?.getMoreDetailsTitle ?? null,
                        additionalDetails: item?.additionalDetailsCollection?.items?.filter(Boolean).map((detail)=>({
                                __typename: 'ContentPlatformPlanDetails',
                                planAdditionalDetailsTitleExternal: detail?.planAdditionalDetailsTitleExternal ?? null,
                                planAdditionalDetails: detail?.planAdditionalDetails?.json ? (0, $gVC4y.richTextToHTML)(detail.planAdditionalDetails.json) : null
                            })) || [],
                        relatedProduct: item?.relatedProductCollection?.items?.filter(Boolean).map((product)=>({
                                __typename: 'ContentPlatformPricingProductName',
                                productName: product?.productName ?? '',
                                productNameId: product?.productNameId ?? ''
                            })) || [],
                        callToActionContainer: item?.callToActionContainerCollection?.items?.filter(Boolean).map((cta)=>{
                            if (cta && ('ctaTitleExternal' in cta || 'valueProposition' in cta || 'ctaText' in cta || 'ctaAsset' in cta)) // ContentPlatformCallToAction
                            return {
                                __typename: 'ContentPlatformCallToAction',
                                title: cta.ctaTitleExternal ?? null,
                                valueProposition: cta.valueProposition ?? null,
                                text: cta.ctaText ?? null,
                                url: cta.ctaUrl ?? null,
                                asset: cta.ctaAsset ? {
                                    __typename: 'ContentPlatformTemplateImageAsset',
                                    title: cta.ctaAsset.title ?? null,
                                    description: cta.ctaAsset.description ?? null,
                                    url: cta.ctaAsset.url ?? ''
                                } : null
                            };
                            else if (cta && ('ctaMicrocopyTitleExternal' in cta || 'ctaButtonText' in cta)) // ContentPlatformCallToActionMicrocopy
                            return {
                                __typename: 'ContentPlatformCallToActionMicrocopy',
                                ctaMicrocopyTitle: cta.ctaMicrocopyTitleExternal ?? null,
                                ctaButtonText: cta.ctaButtonText ?? null,
                                ctaUrl: cta.ctaUrl ?? null
                            };
                            // Filter null values at the map level
                            return null;
                        }).filter(Boolean) || [],
                        datacenterPlans: item?.datacenterPlansCollection?.items?.filter(Boolean).map((datacenterPlan)=>({
                                __typename: 'ContentPlatformPlan',
                                planTitleExternal: datacenterPlan?.planTitleExternal ?? null,
                                planOneLiner: datacenterPlan?.planOneLiner ?? null,
                                microCta: datacenterPlan?.microCtaCollection?.items?.filter(Boolean).map((cta)=>({
                                        __typename: 'ContentPlatformCallToActionMicrocopy',
                                        ctaMicrocopyTitle: cta?.ctaMicrocopyTitleExternal ?? null,
                                        ctaButtonText: cta?.ctaButtonText ?? null,
                                        ctaUrl: cta?.ctaUrl ?? null
                                    })) || [],
                                highlightedFeaturesTitle: datacenterPlan?.highlightedFeaturesTitle ?? null,
                                highlightedFeaturesContainer: datacenterPlan?.highlightedFeaturesContainerCollection?.items?.filter(Boolean).map((feature)=>({
                                        __typename: 'ContentPlatformHighlightedFeature',
                                        highlightedFeatureDetails: feature?.highlightedFeatureDetails?.json ? (0, $gVC4y.richTextToHTML)(feature.highlightedFeatureDetails.json) : null,
                                        highlightedFeatureTitleExternal: feature?.highlightedFeatureTitleExternal ?? null,
                                        callOut: feature?.callOut ?? null
                                    })) || []
                            })) || []
                    }
                }))
        }
    };
};

});
parcelRegister("i9aaD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return $7365710ab12be4cd$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<68677983e365c2fac9b611a2c95e4014>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7365710ab12be4cd$var$node = function() {
    var v0 = {
        "defaultValue": 1,
        "kind": "LocalArgument",
        "name": "limit"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locale"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pricingTitleInternal"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "productNameId"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        },
        {
            "kind": "Variable",
            "name": "locale",
            "variableName": "locale"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "pricingTitleInternal_contains",
                    "variableName": "pricingTitleInternal"
                },
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "productNameId_contains",
                            "variableName": "productNameId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "relatedProduct"
                }
            ],
            "kind": "ObjectValue",
            "name": "where"
        }
    ], v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pricingTitleInternal",
        "storageKey": null
    }, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pricingTitleExternal",
        "storageKey": null
    }, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pageDescription",
        "storageKey": null
    }, v8 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "json",
            "storageKey": null
        }
    ], v9 = {
        "alias": null,
        "args": null,
        "concreteType": "PricingHeadline",
        "kind": "LinkedField",
        "name": "headline",
        "plural": false,
        "selections": v8 /*: any*/ ,
        "storageKey": null
    }, v10 = [
        {
            "kind": "Literal",
            "name": "limit",
            "value": 10
        }
    ], v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "planTitleExternal",
        "storageKey": null
    }, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "planOneLiner",
        "storageKey": null
    }, v13 = [
        {
            "kind": "Literal",
            "name": "limit",
            "value": 15
        }
    ], v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ctaUrl",
        "storageKey": null
    }, v15 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ctaMicrocopyTitleExternal",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ctaButtonText",
                "storageKey": null
            },
            v14 /*: any*/ 
        ],
        "type": "CallToActionMicrocopy",
        "abstractKey": null
    }, v16 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "highlightedFeaturesTitle",
        "storageKey": null
    }, v17 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "callOut",
        "storageKey": null
    }, v18 = {
        "alias": null,
        "args": v13 /*: any*/ ,
        "concreteType": "PlanHighlightedFeaturesContainerCollection",
        "kind": "LinkedField",
        "name": "highlightedFeaturesContainerCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "HighlightedFeature",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "HighlightedFeatureHighlightedFeatureDetails",
                        "kind": "LinkedField",
                        "name": "highlightedFeatureDetails",
                        "plural": false,
                        "selections": v8 /*: any*/ ,
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "highlightedFeatureTitleExternal",
                        "storageKey": null
                    },
                    v17 /*: any*/ 
                ],
                "storageKey": null
            }
        ],
        "storageKey": "highlightedFeaturesContainerCollection(limit:15)"
    }, v19 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "Plan",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                {
                    "alias": null,
                    "args": v13 /*: any*/ ,
                    "concreteType": "PlanMicroCtaCollection",
                    "kind": "LinkedField",
                    "name": "microCtaCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v15 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": "microCtaCollection(limit:15)"
                },
                v16 /*: any*/ ,
                v18 /*: any*/ 
            ],
            "storageKey": null
        }
    ], v20 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "compareFeaturesTitle",
        "storageKey": null
    }, v21 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "Plan",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
                v11 /*: any*/ 
            ],
            "storageKey": null
        }
    ], v22 = {
        "alias": null,
        "args": v10 /*: any*/ ,
        "concreteType": "PricingCompareFeaturesCollection",
        "kind": "LinkedField",
        "name": "compareFeaturesCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "FeatureGroup",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "featureGroupTitleExternal",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "limit",
                                "value": 20
                            }
                        ],
                        "concreteType": "FeatureGroupFeaturesCollection",
                        "kind": "LinkedField",
                        "name": "featuresCollection",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Feature",
                                "kind": "LinkedField",
                                "name": "items",
                                "plural": true,
                                "selections": [
                                    v17 /*: any*/ ,
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "featureNameExternal",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "FeatureDescription",
                                        "kind": "LinkedField",
                                        "name": "description",
                                        "plural": false,
                                        "selections": v8 /*: any*/ ,
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "FeatureRelevantPlanCollection",
                                        "kind": "LinkedField",
                                        "name": "relevantPlanCollection",
                                        "plural": false,
                                        "selections": v21 /*: any*/ ,
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "relevantUrl",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": v13 /*: any*/ ,
                                        "concreteType": "FeatureFeatureAdditionalInformationCollection",
                                        "kind": "LinkedField",
                                        "name": "featureAdditionalInformationCollection",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "FeatureAdditionalInformation",
                                                "kind": "LinkedField",
                                                "name": "items",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "featureAdditionalInformation",
                                                        "storageKey": null
                                                    },
                                                    {
                                                        "alias": null,
                                                        "args": v13 /*: any*/ ,
                                                        "concreteType": "FeatureAdditionalInformationRelevantPlanCollection",
                                                        "kind": "LinkedField",
                                                        "name": "relevantPlanCollection",
                                                        "plural": false,
                                                        "selections": v21 /*: any*/ ,
                                                        "storageKey": "relevantPlanCollection(limit:15)"
                                                    }
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": "featureAdditionalInformationCollection(limit:15)"
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": "featuresCollection(limit:20)"
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "compareFeaturesCollection(limit:10)"
    }, v23 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "getMoreDetailsTitle",
        "storageKey": null
    }, v24 = {
        "alias": null,
        "args": v13 /*: any*/ ,
        "concreteType": "PricingAdditionalDetailsCollection",
        "kind": "LinkedField",
        "name": "additionalDetailsCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "PlanDetails",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "planAdditionalDetailsTitleExternal",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "PlanDetailsPlanAdditionalDetails",
                        "kind": "LinkedField",
                        "name": "planAdditionalDetails",
                        "plural": false,
                        "selections": v8 /*: any*/ ,
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "additionalDetailsCollection(limit:15)"
    }, v25 = {
        "alias": null,
        "args": [
            {
                "kind": "Literal",
                "name": "limit",
                "value": 1
            }
        ],
        "concreteType": "PricingRelatedProductCollection",
        "kind": "LinkedField",
        "name": "relatedProductCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ProductName",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "productName",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "productNameId",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "relatedProductCollection(limit:1)"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ctaTitleExternal",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "valueProposition",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ctaText",
                "storageKey": null
            },
            v14 /*: any*/ ,
            {
                "alias": null,
                "args": null,
                "concreteType": "Asset",
                "kind": "LinkedField",
                "name": "ctaAsset",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "description",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "CallToAction",
        "abstractKey": null
    }, v27 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    }, v28 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "Plan",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                {
                    "alias": null,
                    "args": v13 /*: any*/ ,
                    "concreteType": "PlanMicroCtaCollection",
                    "kind": "LinkedField",
                    "name": "microCtaCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v27 /*: any*/ ,
                                v15 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": "microCtaCollection(limit:15)"
                },
                v16 /*: any*/ ,
                v18 /*: any*/ 
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "pricingPageRelayQuery",
            "selections": [
                {
                    "alias": null,
                    "args": v4 /*: any*/ ,
                    "concreteType": "PricingCollection",
                    "kind": "LinkedField",
                    "name": "pricingCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Pricing",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v9 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "PricingComparePlansCollection",
                                    "kind": "LinkedField",
                                    "name": "comparePlansCollection",
                                    "plural": false,
                                    "selections": v19 /*: any*/ ,
                                    "storageKey": "comparePlansCollection(limit:10)"
                                },
                                v20 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "PricingCallToActionContainerCollection",
                                    "kind": "LinkedField",
                                    "name": "callToActionContainerCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                v26 /*: any*/ ,
                                                v15 /*: any*/ 
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "callToActionContainerCollection(limit:10)"
                                },
                                {
                                    "alias": null,
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "PricingDatacenterPlansCollection",
                                    "kind": "LinkedField",
                                    "name": "datacenterPlansCollection",
                                    "plural": false,
                                    "selections": v19 /*: any*/ ,
                                    "storageKey": "datacenterPlansCollection(limit:10)"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "pricingPageRelayQuery",
            "selections": [
                {
                    "alias": null,
                    "args": v4 /*: any*/ ,
                    "concreteType": "PricingCollection",
                    "kind": "LinkedField",
                    "name": "pricingCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Pricing",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v9 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "PricingComparePlansCollection",
                                    "kind": "LinkedField",
                                    "name": "comparePlansCollection",
                                    "plural": false,
                                    "selections": v28 /*: any*/ ,
                                    "storageKey": "comparePlansCollection(limit:10)"
                                },
                                v20 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "PricingCallToActionContainerCollection",
                                    "kind": "LinkedField",
                                    "name": "callToActionContainerCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                v27 /*: any*/ ,
                                                v26 /*: any*/ ,
                                                v15 /*: any*/ 
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "callToActionContainerCollection(limit:10)"
                                },
                                {
                                    "alias": null,
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "PricingDatacenterPlansCollection",
                                    "kind": "LinkedField",
                                    "name": "datacenterPlansCollection",
                                    "plural": false,
                                    "selections": v28 /*: any*/ ,
                                    "storageKey": "datacenterPlansCollection(limit:10)"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "8811cd880e6f31899681a2925b8a3e71",
            "id": null,
            "metadata": {},
            "name": "pricingPageRelayQuery",
            "operationKind": "query",
            "text": "query pricingPageRelayQuery(\n  $limit: Int = 1\n  $productNameId: String!\n  $locale: String!\n  $pricingTitleInternal: String = null\n) {\n  pricingCollection(limit: $limit, where: {relatedProduct: {productNameId_contains: $productNameId}, pricingTitleInternal_contains: $pricingTitleInternal}, locale: $locale) {\n    items {\n      pricingTitleInternal\n      pricingTitleExternal\n      pageDescription\n      headline {\n        json\n      }\n      comparePlansCollection(limit: 10) {\n        items {\n          planTitleExternal\n          planOneLiner\n          microCtaCollection(limit: 15) {\n            items {\n              __typename\n              ... on CallToActionMicrocopy {\n                ctaMicrocopyTitleExternal\n                ctaButtonText\n                ctaUrl\n              }\n            }\n          }\n          highlightedFeaturesTitle\n          highlightedFeaturesContainerCollection(limit: 15) {\n            items {\n              highlightedFeatureDetails {\n                json\n              }\n              highlightedFeatureTitleExternal\n              callOut\n            }\n          }\n        }\n      }\n      compareFeaturesTitle\n      compareFeaturesCollection(limit: 10) {\n        items {\n          featureGroupTitleExternal\n          featuresCollection(limit: 20) {\n            items {\n              callOut\n              featureNameExternal\n              description {\n                json\n              }\n              relevantPlanCollection {\n                items {\n                  planTitleExternal\n                }\n              }\n              relevantUrl\n              featureAdditionalInformationCollection(limit: 15) {\n                items {\n                  featureAdditionalInformation\n                  relevantPlanCollection(limit: 15) {\n                    items {\n                      planTitleExternal\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n      getMoreDetailsTitle\n      additionalDetailsCollection(limit: 15) {\n        items {\n          planAdditionalDetailsTitleExternal\n          planAdditionalDetails {\n            json\n          }\n        }\n      }\n      relatedProductCollection(limit: 1) {\n        items {\n          productName\n          productNameId\n        }\n      }\n      callToActionContainerCollection(limit: 10) {\n        items {\n          __typename\n          ... on CallToAction {\n            ctaTitleExternal\n            valueProposition\n            ctaText\n            ctaUrl\n            ctaAsset {\n              title\n              description\n              url\n            }\n          }\n          ... on CallToActionMicrocopy {\n            ctaMicrocopyTitleExternal\n            ctaButtonText\n            ctaUrl\n          }\n        }\n      }\n      datacenterPlansCollection(limit: 10) {\n        items {\n          planTitleExternal\n          planOneLiner\n          microCtaCollection(limit: 15) {\n            items {\n              __typename\n              ... on CallToActionMicrocopy {\n                ctaMicrocopyTitleExternal\n                ctaButtonText\n                ctaUrl\n              }\n            }\n          }\n          highlightedFeaturesTitle\n          highlightedFeaturesContainerCollection(limit: 15) {\n            items {\n              highlightedFeatureDetails {\n                json\n              }\n              highlightedFeatureTitleExternal\n              callOut\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
        }
    };
}();
$7365710ab12be4cd$var$node.hash = "c972d0b0a98f9d312a6714300ced3fae";
var $7365710ab12be4cd$export$2e2bcd8739ae039 = $7365710ab12be4cd$var$node;

});


parcelRegister("iwpqF", function(module, exports) {
$parcel$export(module.exports, "FourOhFourPage", function () { return $c6b186384bdc45c6$export$20dde44a04c91eb6; });
// @ts-ignore

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $7WM7y = parcelRequire("7WM7y");
const $c6b186384bdc45c6$export$20dde44a04c91eb6 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7WM7y.FourOhFourPageTemplate), {});

});
parcelRegister("7WM7y", function(module, exports) {
$parcel$export(module.exports, "FourOhFourPageTemplate", function () { return $b3e0454f7f1f85f3$export$580adf4c24c28053; });
// @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $9GLx2 = parcelRequire("9GLx2");

var $bv77X = parcelRequire("bv77X");

var $7GVWk = parcelRequire("7GVWk");

var $5Ntyw = parcelRequire("5Ntyw");

var $iLjCW = parcelRequire("iLjCW");

var $hcVGp = parcelRequire("hcVGp");

var $1ka2O = parcelRequire("1ka2O");

var $4d61Q = parcelRequire("4d61Q");
const $b3e0454f7f1f85f3$export$580adf4c24c28053 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9GLx2.default), {
        locale: "en",
        messages: {},
        defaultLocale: "en",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5Ntyw.BxpWebStargateClientProvider), {
            baseUrl: (0, $5Ntyw.getStargateBaseUrl)(),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bv77X.SitesContextProvider), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7GVWk.UserContextProvider), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "data-testid": "404-page",
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1ka2O.LocationProvider), {
                            location: typeof window !== 'undefined' ? window.location : {
                                pathname: '/',
                                href: '/'
                            },
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hcVGp.GlobalNav), {
                                        isShowTryNowLink: true,
                                        tryNowLinkCtaButtonColor: "light_grey",
                                        productKey: "404"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4d61Q.MainSection), {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iLjCW.GlobalFooter), {})
                            ]
                        })
                    })
                })
            })
        })
    });
};

});
parcelRegister("hcVGp", function(module, exports) {
$parcel$export(module.exports, "GlobalNav", function () { return $e87e996a56dac08a$export$963222cd47bfd015; });
/* nav-global.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $izdHQ = parcelRequire("izdHQ");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $5X1Oi = parcelRequire("5X1Oi");

var $bvLTq = parcelRequire("bvLTq");

var $aBl7x = parcelRequire("aBl7x");

var $3pg5Q = parcelRequire("3pg5Q");

var $Q3GOe = parcelRequire("Q3GOe");

var $8DdYy = parcelRequire("8DdYy");

var $gisLk = parcelRequire("gisLk");

var $hiOEV = parcelRequire("hiOEV");

var $jUCHH = parcelRequire("jUCHH");

var $jHmlF = parcelRequire("jHmlF");

var $3hAMp = parcelRequire("3hAMp");

var $ibZL7 = parcelRequire("ibZL7");

var $igXd8 = parcelRequire("igXd8");

var $4Rcm1 = parcelRequire("4Rcm1");

var $9KOR3 = parcelRequire("9KOR3");

var $aFrXh = parcelRequire("aFrXh");

var $96jet = parcelRequire("96jet");

var $5BEho = parcelRequire("5BEho");
const $e87e996a56dac08a$export$d6a07a1754b0e052 = (0, $4Rcm1.navLayout).height;
const $e87e996a56dac08a$var$navigationShellCss = null;
const $e87e996a56dac08a$var$expandedMobileShellCss = null;
// Compiled supports the calculated grid tracks needed to align with the page grid.
const $e87e996a56dac08a$var$navigationBarContentCss = null;
const $e87e996a56dac08a$var$desktopControlsCss = null;
const $e87e996a56dac08a$var$mobileControlsCss = null;
const $e87e996a56dac08a$var$mobileMenuCss = null;
const $e87e996a56dac08a$var$navigationBarSearchCss = null;
const $e87e996a56dac08a$var$navigationBarLogoCss = null;
const $e87e996a56dac08a$var$navigationBarLogoLink = null;
const $e87e996a56dac08a$var$navigationBarLogoImageCss = null;
const $e87e996a56dac08a$var$isStickyNavCss = null;
const $e87e996a56dac08a$export$b9a265e5df299ef2 = ({ productKey: productKey, isShowSearchBarAndProfileContainer: isShowSearchBarAndProfileContainer = true, isShowTryNowLink: isShowTryNowLink = false, isShowSearchButton: isShowSearchButton = true, tryNowLinkCtaButtonColor: tryNowLinkCtaButtonColor, globalLinksProps: globalLinksProps, tryNowLinkCtaUrl: tryNowLinkCtaUrl })=>{
    const intl = (0, $8e22h.default)();
    const atlasUrl = (0, $jQ0cd.useLocalizedHref)('/');
    const [isOpenSearch, setIsOpenSearch] = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useState(false);
    const mobileState = (0, $hiOEV.useMobileNavDisplay)(isOpenSearch);
    const globalLinksRef = (0, $1oC0p.useRef)(null);
    const searchAndProfileRef = (0, $1oC0p.useRef)(null);
    const hasMounted = (0, $1oC0p.useRef)(false);
    const navRef = (0, $1oC0p.useRef)(null);
    const { showMoreItems: setShowMore, shouldShowMoreItems: showMore, maxItems: maxLinks } = (0, $jUCHH.useMore)({
        leftElementRef: globalLinksRef,
        rightElementRef: searchAndProfileRef,
        initialMaxItems: globalLinksProps.length,
        buffer: 24
    });
    (0, $1oC0p.useEffect)(()=>{
        if (hasMounted.current) {
            const searchButton = Array.from(navRef.current?.querySelectorAll('#global-nav-search-bar-icon-desktop') ?? []).find((button)=>button.getClientRects().length > 0);
            if (searchButton) searchButton.focus();
        } else hasMounted.current = true;
    }, [
        isOpenSearch
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("nav", {
        ref: navRef,
        "aria-label": intl.formatMessage({
            id: 'wacGlobalNavigation.nav-label',
            defaultMessage: 'Main'
        }),
        className: (0, $2jatx.default)([
            "_p42h1b66 _bfhk1afi _18zr1n1m _1rjcidpf _vchhusvi _1s0lidpf _165t18pe",
            mobileState.showMenu && "_13zm1n9t _xaejidpf _1eg6idpf _1rfm1osq _tnru1kxc _1o831wug _98bk1wug _2rfoqfx8"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_1mhfb35": (0, $6ZVlx.default)((0, $4Rcm1.navLayout).outerInset),
            "--_eiqaqt": (0, $6ZVlx.default)((0, $4Rcm1.navLayout).height)
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _yv0ehpfy _4t3i18pe _4cvr1h6o _kqswh2mm _12qzi47z _165t1osq _1rqtvol0 _tyveoxdy"
                ]),
                style: {
                    "--_eiqaqt": (0, $6ZVlx.default)((0, $4Rcm1.navLayout).height),
                    "--_m1f5bg": (0, $6ZVlx.default)((0, $4Rcm1.navGrid).globalColumnsDesktop),
                    "--_1cmqt4n": (0, $6ZVlx.default)((0, $4Rcm1.navGrid).globalColumnsWide)
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _1q511b66"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5BEho.SkipToContent), {
                                alignToLogo: true
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                "data-testid": "navigation-bar-logo-link",
                                href: atlasUrl,
                                "aria-label": intl.formatMessage({
                                    id: 'wacGlobalNavigation.logo-label',
                                    defaultMessage: 'Atlassian logo'
                                }),
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-event-container": "globalNavWac",
                                "data-product-key": productKey,
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1bsbvb5u _4t3it8ph _1o9zidpf"
                                ]),
                                style: {
                                    "--_1ycknng": (0, $6ZVlx.default)((0, $4Rcm1.navLayout).atlassianLogoWidth),
                                    "--_1q2cqym": (0, $6ZVlx.default)((0, $4Rcm1.navLayout).logoHeight)
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _1bsb1osq _4t3i1osq"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
                                        brand: "atlassian",
                                        type: "logo",
                                        appearance: "brand",
                                        width: "100%",
                                        height: "100%"
                                    })
                                })
                            })
                        ]
                    }),
                    isOpenSearch ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _yyhy1jtt _1ul9idpf"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $96jet.default), {
                            isOpenSearch: isOpenSearch,
                            setIsOpenSearch: setIsOpenSearch,
                            parentType: "GlobalNav"
                        })
                    }) : /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0cglyw _dm251bgi"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.default), {
                                        alignDropdownsToGlobalMenu: true,
                                        globalLinksProps: globalLinksProps,
                                        globalLinksRef: globalLinksRef,
                                        maxLinks: maxLinks,
                                        showMore: showMore,
                                        setShowMore: setShowMore
                                    }),
                                    isShowSearchBarAndProfileContainer && !showMore && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
                                        experimentKey: "wac-globalui-team24-globalnav-cta",
                                        group: "test",
                                        conditions: [
                                            !isShowTryNowLink
                                        ],
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aFrXh.NavUtilities), {
                                            isShowTryNowLink: isShowTryNowLink,
                                            // @ts-expect-error -- Existing legacy CTA color prop.
                                            ctaButtonColor: tryNowLinkCtaButtonColor,
                                            productKey: productKey,
                                            isShowSearchButton: isShowSearchButton,
                                            setIsOpenSearch: setIsOpenSearch,
                                            searchAndProfileRef: searchAndProfileRef,
                                            navigationTrynowCtaUrl: tryNowLinkCtaUrl
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1bahesu3 _1ul9idpf _10y4glyw"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ibZL7.MobileNavTop), {
                                    showLogo: false,
                                    productKey: productKey,
                                    isLoggedIn: mobileState.userInfo.isUserLoggedIn,
                                    userName: mobileState.userInfo.name ?? '',
                                    picture: mobileState.userInfo.picture ?? '',
                                    handleClickAvatar: mobileState.handleClickAvatar,
                                    showMenu: mobileState.showMenu,
                                    handleToggleMenu: mobileState.handleToggleMenu,
                                    menuPage: mobileState.menuPage,
                                    handleMenuPage: mobileState.handleMenuPage,
                                    handleFirstOpen: mobileState.handleFirstOpen,
                                    isShowSearchButton: isShowSearchButton,
                                    isOpenSearch: isOpenSearch,
                                    setIsOpenSearch: setIsOpenSearch,
                                    tabletDropdownMenu: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3hAMp.GlobalNavMobileMenu), {
                                        productKey: productKey,
                                        state: mobileState
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            mobileState.showMenu && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                id: "nav-mobile-dropdown-menu",
                className: (0, $2jatx.default)([
                    "_1e0cglyw _suga1ule _476dutpp"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3hAMp.GlobalNavMobileMenu), {
                    productKey: productKey,
                    state: mobileState
                })
            })
        ]
    });
};
const $e87e996a56dac08a$export$963222cd47bfd015 = ({ productKey: productKey = 'home', isShowSearchBarAndProfileContainer: isShowSearchBarAndProfileContainer = true, isShowTryNowLink: isShowTryNowLink = false, isShowSearchButton: isShowSearchButton = true, tryNowLinkCtaButtonColor: tryNowLinkCtaButtonColor, isNavSticky: isNavSticky = true, tryNowLinkCtaUrl: tryNowLinkCtaUrl, compoundNav: compoundNav })=>{
    const intl = (0, $8e22h.default)();
    const hasScrolled = (0, $jHmlF.useNavScrollShadow)();
    const isAiTabEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).team26EuRefresh);
    const enterpriseHref = (0, $jQ0cd.useLocalizedHref)('/enterprise');
    const globalLinksProps = (0, $1oC0p.useMemo)(()=>[
            {
                globalLinksKey: 'products',
                linkText: intl.formatMessage({
                    id: 'globalNavigation.Navlink.products',
                    defaultMessage: 'Products'
                }),
                hasDropdown: true,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3pg5Q.GlobalNavProductsDropdown), {
                    productKey: productKey
                }),
                layout: (0, $9KOR3.GlobalNavDropdownLayout).Product
            },
            ...isAiTabEnabled ? [
                {
                    globalLinksKey: 'ai',
                    linkText: intl.formatMessage({
                        id: 'globalNavigation.Navlink.ai',
                        defaultMessage: 'AI'
                    }),
                    hasDropdown: true,
                    content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5X1Oi.AiContent), {
                        productKey: productKey
                    }),
                    layout: (0, $9KOR3.GlobalNavDropdownLayout).AI
                }
            ] : [],
            {
                globalLinksKey: 'solutions',
                linkText: intl.formatMessage({
                    id: 'globalNavigation.Navlink.solutions',
                    defaultMessage: 'Solutions'
                }),
                hasDropdown: true,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8DdYy.GlobalNavSolutionsDropdown), {
                    productKey: productKey
                }),
                layout: (0, $9KOR3.GlobalNavDropdownLayout).Solutions
            },
            {
                globalLinksKey: 'why-atlassian',
                linkText: intl.formatMessage({
                    id: 'globalNavigation.Navlink.whyAtlassian',
                    defaultMessage: 'Why Atlassian'
                }),
                hasDropdown: true,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gisLk.GlobalNavWhyAtlassianDropdown), {
                    productKey: productKey
                }),
                layout: (0, $9KOR3.GlobalNavDropdownLayout).WhyAtlassian
            },
            {
                globalLinksKey: 'resources',
                linkText: intl.formatMessage({
                    id: 'globalNavigation.Navlink.resources',
                    defaultMessage: 'Resources'
                }),
                hasDropdown: true,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $Q3GOe.GlobalNavResourcesDropdown), {
                    productKey: productKey
                }),
                layout: (0, $9KOR3.GlobalNavDropdownLayout).Resources
            },
            {
                globalLinksKey: 'enterprise',
                linkText: intl.formatMessage({
                    id: 'globalNavigation.Navlink.enterprise',
                    defaultMessage: 'Enterprise'
                }),
                hasDropdown: false,
                href: enterpriseHref
            }
        ], // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        enterpriseHref,
        intl,
        isAiTabEnabled,
        productKey
    ]);
    const globalNavItemKeys = (0, $1oC0p.useMemo)(()=>{
        return globalLinksProps.map((globalLink)=>globalLink.globalLinksKey);
    }, [
        globalLinksProps
    ]);
    const navProductRecosResponse = (0, $aBl7x.useGlobalNavProductRecommendations)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "global-nav-v2",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            "data-nav-dropdown-boundary": true,
            className: (0, $2jatx.default)([
                "_kqswh2mm _16qs1nxu _v5641tcc _sedtglyw _1pbyqfx8 _bfhk1afi",
                isNavSticky && "_kqsw1if8 _152tidpf"
            ]),
            style: {
                "--_127dc5p": (0, $6ZVlx.default)(hasScrolled ? (0, $jHmlF.NAV_SCROLL_SHADOW) : 'none'),
                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bvLTq.NavProductRecommendationsContext).Provider, {
                value: navProductRecosResponse,
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $9KOR3.GlobalNavProvider), {
                    globalNavItemKeys: globalNavItemKeys,
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)($e87e996a56dac08a$export$b9a265e5df299ef2, {
                            productKey: productKey,
                            isShowSearchBarAndProfileContainer: isShowSearchBarAndProfileContainer,
                            isShowTryNowLink: isShowTryNowLink,
                            tryNowLinkCtaUrl: tryNowLinkCtaUrl,
                            isShowSearchButton: isShowSearchButton,
                            tryNowLinkCtaButtonColor: tryNowLinkCtaButtonColor,
                            globalLinksProps: globalLinksProps
                        }),
                        compoundNav && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igXd8.CompoundSubNav), {
                            ...compoundNav
                        })
                    ]
                })
            })
        })
    });
};
$e87e996a56dac08a$export$963222cd47bfd015.displayName = 'GlobalNav';

});
parcelRegister("5X1Oi", function(module, exports) {
$parcel$export(module.exports, "AiContent", function () { return $f3b2a28b3e8594be$export$f2a5a033ab82a5e2; });
/* ai-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $5Zqcl = parcelRequire("5Zqcl");

var $jbgN3 = parcelRequire("jbgN3");

var $9KOR3 = parcelRequire("9KOR3");
const $f3b2a28b3e8594be$var$aiContentCss = null;
const $f3b2a28b3e8594be$var$primaryContentCss = null;
const $f3b2a28b3e8594be$var$secondaryContentCss = null;
const $f3b2a28b3e8594be$var$horizontalGridCss = null;
const $f3b2a28b3e8594be$var$productCss = null;
const $f3b2a28b3e8594be$var$productIconCss = null;
const $f3b2a28b3e8594be$var$productTitleCss = null;
const $f3b2a28b3e8594be$var$productDescriptionCss = null;
const $f3b2a28b3e8594be$var$linkListCss = null;
const $f3b2a28b3e8594be$var$externalListCss = null;
const $f3b2a28b3e8594be$var$worksWithCss = null;
const $f3b2a28b3e8594be$var$linkCss = null;
const $f3b2a28b3e8594be$var$externalAiProductCss = null;
const $f3b2a28b3e8594be$var$externalAiProductIconCss = null;
const $f3b2a28b3e8594be$var$useTrackAiLinkClick = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    return (0, $1oC0p.useCallback)((label)=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'linkButton',
            actionSubjectId: 'globalNavAiLink',
            source: 'globalNavAiDropdown',
            attributes: {
                label: label
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
};
const $f3b2a28b3e8594be$var$InternalAiProduct = ({ description: description, href: href, icon: icon, title: title, productKey: productKey })=>{
    const trackAiLinkClick = $f3b2a28b3e8594be$var$useTrackAiLinkClick();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
        href: href,
        "aria-label": description ? `${title}: ${description}` : title,
        onClick: ()=>trackAiLinkClick(title),
        "data-event": "clicked",
        "data-event-component": "linkButton",
        "data-event-container": "globalNavAiDropdown",
        "data-label": title,
        "data-product-key": productKey,
        className: (0, $2jatx.default)([
            "_4cvr1y6m _syaz1pfd _1e0c1txw _zulpu2gc _6rthxy5q _85i51b66 _4bfu1r31 _1hmsglyw _ajmmnqa1 _1ygb1qgu _1ah3yh40 _30l35hrz"
        ]),
        style: {
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
        },
        children: [
            icon && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "aria-hidden": "true",
                className: (0, $2jatx.default)([
                    "_4cvr1h6o _1e0c1txw _4t3iviql _1bah1h6o _1bsbviql"
                ]),
                children: icon
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_ect41vau _1wyboxwj _k48pni7l _vwz4kb7n"
                        ]),
                        style: {
                            "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                        },
                        children: title
                    }),
                    description && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_syaz1qc2 _1wyboqnp _vwz4kb7n _1pfh1b66"
                        ]),
                        style: {
                            "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800'))
                        },
                        children: description
                    })
                ]
            })
        ]
    });
};
const $f3b2a28b3e8594be$var$ExternalAiProduct = ({ href: href, icon: icon, productKey: productKey, title: title })=>{
    const trackAiLinkClick = $f3b2a28b3e8594be$var$useTrackAiLinkClick();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
            href: href,
            onClick: ()=>trackAiLinkClick(title),
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-event-container": "globalNavAiDropdown",
            "data-label": title,
            "data-product-key": productKey,
            className: (0, $2jatx.default)([
                "_4cvr1h6o _syaz1pfd _1e0c1txw _1wyboxwj _zulpu2gc _vwz41by7 _1rjc1b66 _4bfu1r31 _1hmsglyw _ajmmnqa1 _1ygb1qgu _1ah3yh40 _30l35hrz"
            ]),
            style: {
                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    "aria-hidden": "true",
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1o9zidpf _4t3i1j6v _1bsb1j6v _4cvr1h6o"
                    ]),
                    children: icon
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    children: title
                })
            ]
        })
    });
};
const $f3b2a28b3e8594be$var$AiLink = ({ href: href, text: text, productKey: productKey })=>{
    const trackAiLinkClick = $f3b2a28b3e8594be$var$useTrackAiLinkClick();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
            href: href,
            onClick: ()=>trackAiLinkClick(text),
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-event-container": "globalNavAiDropdown",
            "data-label": text,
            "data-product-key": productKey,
            className: (0, $2jatx.default)([
                "_1e0c1ule _syaz1pfd _1wyboxwj _vwz41by7 _1rjc1b66 _4bfu1r31 _1hmsglyw _ajmmnqa1 _1ygb1qgu _1ah3yh40 _30l35hrz"
            ]),
            style: {
                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
            },
            children: text
        })
    });
};
const $f3b2a28b3e8594be$export$f2a5a033ab82a5e2 = ({ productKey: productKey = 'home' })=>{
    const intl = (0, $8e22h.default)();
    const { direction: direction } = (0, $9KOR3.useGlobalNavContext)();
    // apps
    const rovoHref = (0, $jQ0cd.useLocalizedHref)('/software/rovo');
    const teamworkGraphHref = (0, $jQ0cd.useLocalizedHref)('/platform/teamwork-graph');
    // apps help
    const aiTrustHref = (0, $jQ0cd.useLocalizedHref)('/trust/ai');
    const rovoStartHref = (0, $jQ0cd.useLocalizedHref)('/software/rovo/start');
    // ecosystem
    const rovoConnectorsHref = (0, $jQ0cd.useLocalizedHref)('/software/rovo/connectors');
    const mcpHref = (0, $jQ0cd.useLocalizedHref)('/platform/rovo-mcp');
    // works with
    const anthropicHref = (0, $jQ0cd.useLocalizedHref)('/partnerships/anthropic/guide');
    const googleHref = (0, $jQ0cd.useLocalizedHref)('/partnerships/google/guide');
    const githubHref = (0, $jQ0cd.useLocalizedHref)('/partnerships/github/guide');
    const openAiHref = (0, $jQ0cd.useLocalizedHref)('/partnerships/openai/guide');
    // resource links
    const ampHref = (0, $jQ0cd.useLocalizedHref)('/platform/agentic-multiplayer-protocol');
    const fdeHref = (0, $jQ0cd.useLocalizedHref)('/enterprise/success/fde');
    const platformLinks = [
        {
            href: 'https://developer.atlassian.com/platform/forge/',
            text: intl.formatMessage({
                id: 'globalnav.v2.ai.platform.buildwithforge',
                defaultMessage: 'Build with Forge'
            })
        },
        {
            href: aiTrustHref,
            text: intl.formatMessage({
                id: 'globalnav.v2.ai.platform.aisecurity',
                defaultMessage: 'AI security and trust'
            })
        },
        {
            href: rovoStartHref,
            text: intl.formatMessage({
                id: 'globalnav.v2.ai.platform.rovogetstarted',
                defaultMessage: 'Get started'
            })
        }
    ];
    const resourceLinks = [
        {
            href: ampHref,
            text: intl.formatMessage({
                id: 'globalnav.v2.ai.resources.amp',
                defaultMessage: 'Introducing AMP: Agentic Multiplayer Protocol'
            })
        },
        {
            href: 'https://www.atlassian.com/blog/company-news/ai-sdlc',
            text: intl.formatMessage({
                id: 'globalnav.v2.ai.resources.evolvingjira',
                defaultMessage: 'Evolving Jira for AI-native software development'
            })
        },
        {
            href: fdeHref,
            text: intl.formatMessage({
                id: 'globalnav.v2.ai.resources.forwarddeployed',
                defaultMessage: 'Forward Deployed Engineering'
            })
        },
        {
            href: 'https://www.atlassian.com/blog/category/ai',
            text: intl.formatMessage({
                id: 'globalnav.v2.ai.resources.aiblogsnews',
                defaultMessage: 'AI blogs & news'
            })
        },
        {
            href: 'https://www.atlassian.com/blog/ai-research',
            text: intl.formatMessage({
                id: 'globalnav.v2.ai.resources.airesearch',
                defaultMessage: 'AI research'
            })
        }
    ];
    const AiContentExternalLinksInfo = {
        anthropic: {
            title: 'Anthropic',
            href: anthropicHref,
            icon: (0, $5Zqcl.AiContentExternalLogoSvgs).anthropic
        },
        google: {
            title: 'Google',
            href: googleHref,
            icon: (0, $5Zqcl.AiContentExternalLogoSvgs).google
        },
        github: {
            title: 'GitHub',
            href: githubHref,
            icon: (0, $5Zqcl.AiContentExternalLogoSvgs).github
        },
        openAi: {
            title: 'OpenAI',
            href: openAiHref,
            icon: (0, $5Zqcl.AiContentExternalLogoSvgs).openAi
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.DivOnHoverExit), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            "data-direction": direction,
            className: (0, $2jatx.default)([
                "_1e0c11p5 _yv0ehkll _1bsb1osq _1rqtpbuv"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_18zrxy5q _1q511jfw _xc2ize3t _1bhlze3t"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jbgN3.MobileNavTitle), {
                            title: intl.formatMessage({
                                id: 'globalnav.v2.ai.mobiletitle',
                                defaultMessage: 'AI'
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.GlobalNavEyebrow), {
                            children: intl.formatMessage({
                                id: 'globalnav.ai.platform',
                                defaultMessage: 'AI platform'
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c11p5 _4cvr1y6m _gy1pxy5q _yv0e9sye _1pfhidpf _6rthpxbi _1ph4hkll _1egl1jfw"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)($f3b2a28b3e8594be$var$InternalAiProduct, {
                                            title: intl.formatMessage({
                                                id: 'globalnav.ai.rovo.title',
                                                defaultMessage: 'Rovo'
                                            }),
                                            description: intl.formatMessage({
                                                id: 'globalnav.ai.rovo.description',
                                                defaultMessage: 'AI that knows your business'
                                            }),
                                            href: rovoHref,
                                            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
                                                brand: "rovo",
                                                type: "mark",
                                                appearance: "brand",
                                                width: "32px",
                                                height: "32px"
                                            }),
                                            productKey: productKey
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)($f3b2a28b3e8594be$var$InternalAiProduct, {
                                            title: intl.formatMessage({
                                                id: 'globalnav.ai.teamworkGraph.title',
                                                defaultMessage: 'Teamwork Graph'
                                            }),
                                            description: intl.formatMessage({
                                                id: 'globalnav.ai.teamworkGraph.description',
                                                defaultMessage: 'Context wherever you work'
                                            }),
                                            href: teamworkGraphHref,
                                            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
                                                brand: "teamworkgraph",
                                                type: "mark",
                                                appearance: "brand",
                                                width: "32px",
                                                height: "32px"
                                            }),
                                            productKey: productKey
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c11p5 _zulpu2gc _qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                                        ]),
                                        children: platformLinks.map((link)=>/*#__PURE__*/ (0, $7VQPk.jsx)($f3b2a28b3e8594be$var$AiLink, {
                                                ...link,
                                                productKey: productKey
                                            }, link.text))
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.GlobalNavEyebrow), {
                            children: intl.formatMessage({
                                id: 'globalnav.ai.ecosystem',
                                defaultMessage: 'AI ecosystem'
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c11p5 _4cvr1y6m _gy1pxy5q _yv0e9sye _1pfhidpf _6rthpxbi _1ph4hkll _1egl1jfw"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)($f3b2a28b3e8594be$var$InternalAiProduct, {
                                            title: intl.formatMessage({
                                                id: 'globalnav.ai.teamworkgraphconnectors.title',
                                                defaultMessage: 'Teamwork Graph Connectors'
                                            }),
                                            description: intl.formatMessage({
                                                id: 'globalnav.ai.teamworkgraphconnectors.description',
                                                defaultMessage: 'Centralize your knowledge sources'
                                            }),
                                            href: rovoConnectorsHref,
                                            productKey: productKey
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)($f3b2a28b3e8594be$var$InternalAiProduct, {
                                            title: intl.formatMessage({
                                                id: 'globalnav.ai.atlassianmcp.title',
                                                defaultMessage: 'Atlassian MCP'
                                            }),
                                            description: intl.formatMessage({
                                                id: 'globalnav.ai.atlassianmcp.description',
                                                defaultMessage: 'Bring Atlassian into your AI tools'
                                            }),
                                            href: mcpHref,
                                            productKey: productKey
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_1pfhidpf _6rthutpp _1wyboxwj"
                                            ]),
                                            children: intl.formatMessage({
                                                id: 'globalnav.ai.workswith',
                                                defaultMessage: 'Works with:'
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                                            className: (0, $2jatx.default)([
                                                "_1e0c11p5 _zulpu2gc _qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
                                                "_1e0c11p5 _yv0ewxkt _1ph4hkll _2osnpxbi"
                                            ]),
                                            children: Object.entries(AiContentExternalLinksInfo).map(([name, provider])=>/*#__PURE__*/ (0, $7VQPk.jsx)($f3b2a28b3e8594be$var$ExternalAiProduct, {
                                                    ...provider,
                                                    productKey: productKey
                                                }, name))
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_bfhkg7ng _18zrxy5q _1rjc1jfw _1fkkukr8"
                    ]),
                    style: {
                        "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.GlobalNavEyebrow), {
                            children: intl.formatMessage({
                                id: 'globalnav.ai.resources',
                                defaultMessage: 'Latest news and resources'
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                            className: (0, $2jatx.default)([
                                "_1e0c11p5 _zulpu2gc _qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                            ]),
                            children: resourceLinks.map((link)=>/*#__PURE__*/ (0, $7VQPk.jsx)($f3b2a28b3e8594be$var$AiLink, {
                                    ...link,
                                    productKey: productKey
                                }, link.text))
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("5Zqcl", function(module, exports) {
$parcel$export(module.exports, "AiContentExternalLogoSvgs", function () { return $7e3ba58dcc7282fd$export$5add86f1ff968f8e; });

var $7VQPk = parcelRequire("7VQPk");
const $7e3ba58dcc7282fd$export$5add86f1ff968f8e = {
    github: /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M8.00003 0C3.5823 0 0 3.49432 0 7.80491C0 11.2534 2.29225 14.179 5.47093 15.211C5.87073 15.2832 6.01754 15.0417 6.01754 14.8355C6.01754 14.6495 6.01008 14.0346 6.00669 13.3824C3.78101 13.8545 3.31138 12.4615 3.31138 12.4615C2.94747 11.5594 2.42313 11.3196 2.42313 11.3196C1.69732 10.8351 2.47784 10.845 2.47784 10.845C3.2812 10.9001 3.70421 11.6494 3.70421 11.6494C4.41773 12.8426 5.57571 12.4976 6.03223 12.2982C6.104 11.7937 6.31137 11.4494 6.54013 11.2545C4.76325 11.0571 2.89527 10.3879 2.89527 7.39729C2.89527 6.54522 3.20779 5.84892 3.71959 5.30236C3.63651 5.10574 3.3627 4.31194 3.79707 3.23686C3.79707 3.23686 4.46886 3.02708 5.99765 4.03691C6.63575 3.86392 7.32015 3.77724 8.00003 3.77431C8.67991 3.77724 9.36481 3.86392 10.0042 4.03691C11.5311 3.02708 12.202 3.23686 12.202 3.23686C12.6374 4.31194 12.3635 5.10574 12.2804 5.30236C12.7933 5.84892 13.1037 6.54515 13.1037 7.39729C13.1037 10.395 11.2322 11.0551 9.45084 11.2483C9.73776 11.4905 9.99343 11.9655 9.99343 12.6937C9.99343 13.7379 9.98415 14.5784 9.98415 14.8355C9.98415 15.0432 10.1281 15.2866 10.5337 15.21C13.7106 14.1768 16 11.2522 16 7.80491C16 3.49432 12.4182 0 8.00003 0Z",
            fill: "#505258"
        })
    }),
    anthropic: /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "11",
        viewBox: "0 0 16 11",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M11.2218 0H8.84045L13.1829 10.9714H15.5642L11.2218 0Z",
                fill: "#505258"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M4.34239 0L0 10.9714H2.428L3.31609 8.66743H7.85893L8.74702 10.9714H11.175L6.83264 0H4.34239ZM4.10145 6.6299L5.58752 2.7742L7.0736 6.6299H4.10145Z",
                fill: "#505258"
            })
        ]
    }),
    openAi: /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M6.13672 5.772V4.26555C6.13672 4.13868 6.18434 4.0435 6.29528 3.98015L9.3241 2.23585C9.73638 1.998 10.228 1.88706 10.7353 1.88706C12.6382 1.88706 13.8434 3.36181 13.8434 4.93161C13.8434 5.04258 13.8434 5.16946 13.8275 5.29633L10.6877 3.45686C10.4975 3.34592 10.3071 3.34592 10.1169 3.45686L6.13672 5.772ZM13.209 11.6392V8.03954C13.209 7.81749 13.1138 7.65892 12.9236 7.54795L8.94345 5.23281L10.2437 4.48747C10.3547 4.42412 10.4499 4.42412 10.5609 4.48747L13.5897 6.23176C14.4619 6.73925 15.0485 7.81749 15.0485 8.864C15.0485 10.0691 14.335 11.1792 13.209 11.6391V11.6392ZM5.20115 8.46778L3.90086 7.70668C3.78992 7.64333 3.7423 7.54811 3.7423 7.42124V3.93269C3.7423 2.23602 5.04258 0.951495 6.80277 0.951495C7.46886 0.951495 8.08716 1.17355 8.61059 1.56996L5.48672 3.37774C5.2965 3.48868 5.20132 3.64725 5.20132 3.86934V8.46792L5.20115 8.46778ZM7.99998 10.0852L6.13672 9.03863V6.8187L7.99998 5.77216L9.86312 6.8187V9.03863L7.99998 10.0852ZM9.19719 14.9058C8.53114 14.9058 7.91284 14.6838 7.38942 14.2874L10.5132 12.4796C10.7035 12.3686 10.7987 12.2101 10.7987 11.988V7.38942L12.1149 8.15052C12.2258 8.21387 12.2735 8.30905 12.2735 8.43596V11.9245C12.2735 13.6212 10.9572 14.9057 9.19719 14.9057V14.9058ZM5.439 11.3697L2.41018 9.62543C1.53797 9.11791 0.95133 8.03971 0.95133 6.99317C0.95133 5.77216 1.68077 4.67803 2.80657 4.21813V7.83355C2.80657 8.0556 2.90178 8.21417 3.092 8.32515L7.05639 10.6244L5.7561 11.3697C5.64516 11.433 5.54994 11.433 5.439 11.3697ZM5.26467 13.9703C3.47279 13.9703 2.1566 12.6224 2.1566 10.9574C2.1566 10.8305 2.1725 10.7036 2.18826 10.5768L5.31213 12.3845C5.50235 12.4955 5.69275 12.4955 5.88297 12.3845L9.86312 10.0853V11.5918C9.86312 11.7187 9.81553 11.8138 9.70455 11.8772L6.67577 13.6215C6.26346 13.8593 5.77186 13.9703 5.2645 13.9703H5.26467ZM9.19719 15.8572C11.1159 15.8572 12.7174 14.4935 13.0823 12.6857C14.8583 12.2258 16 10.5608 16 8.86417C16 7.7541 15.5243 6.6759 14.668 5.89887C14.7473 5.56584 14.7949 5.23281 14.7949 4.89995C14.7949 2.6324 12.9554 0.935566 10.8305 0.935566C10.4025 0.935566 9.99016 0.99892 9.57784 1.14172C8.86417 0.443972 7.88101 0 6.80277 0C4.88405 0 3.28256 1.36364 2.91771 3.17142C1.14172 3.63132 0 5.29633 0 6.993C0 8.10306 0.475665 9.18126 1.33198 9.9583C1.2527 10.2913 1.20511 10.6244 1.20511 10.9573C1.20511 13.2248 3.04458 14.9216 5.16946 14.9216C5.59753 14.9216 6.00984 14.8582 6.42216 14.7154C7.13567 15.4132 8.11882 15.8572 9.19719 15.8572Z",
            fill: "#505258"
        })
    }),
    google: /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M15.6521 8.19124C15.6521 7.65211 15.5999 7.09559 15.513 6.57385H7.98254V9.65211H12.2956C12.1217 10.6434 11.5478 11.513 10.6956 12.0695L13.2695 14.0695C14.7825 12.6608 15.6521 10.6086 15.6521 8.19124Z",
                fill: "#505258"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M7.98261 15.9826C10.1391 15.9826 11.9478 15.2696 13.2696 14.0522L10.6957 12.0696C9.98261 12.5565 9.06087 12.8348 7.98261 12.8348C5.89565 12.8348 4.13913 11.4261 3.49565 9.54785L0.852173 11.5826C2.20869 14.2783 4.95652 15.9826 7.98261 15.9826Z",
                fill: "#505258"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M3.49558 9.5304C3.16514 8.5391 3.16514 7.46084 3.49558 6.46953L0.852098 4.41736C-0.278336 6.67823 -0.278336 9.3391 0.852098 11.5826L3.49558 9.5304Z",
                fill: "#505258"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M7.98261 3.18261C9.11304 3.16522 10.2261 3.6 11.0435 4.38261L13.3217 2.08696C11.8783 0.730437 9.96522 2.07126e-06 7.98261 0.0173934C4.95652 0.0173934 2.20869 1.72174 0.852173 4.4174L3.49565 6.46957C4.13913 4.57392 5.89565 3.18261 7.98261 3.18261Z",
                fill: "#505258"
            })
        ]
    })
};

});


parcelRegister("aBl7x", function(module, exports) {
$parcel$export(module.exports, "useGlobalNavProductRecommendations", function () { return $1181c2878eb1a148$export$8b2dae449a6aff29; });

var $1oC0p = parcelRequire("1oC0p");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $3riD8 = parcelRequire("3riD8");

var $fJROq = parcelRequire("fJROq");

var $cT4PD = parcelRequire("cT4PD");

var $9uve9 = parcelRequire("9uve9");
function $1181c2878eb1a148$export$8b2dae449a6aff29() {
    const [isGlobalNavProductRecommendationsExperimentFailed, setIsGlobalNavProductRecommendationsExperimentFailed] = (0, $1oC0p.useState)(false);
    const { isUserLoggedIn: isUserLoggedIn } = (0, $3riD8.useLoggedInUser)();
    const intl = (0, $8e22h.default)();
    const hasEnterpriseEdition = (0, $9uve9.useHasEnterpriseEdition)();
    const { getProductRecommendations: getProductRecommendations, isRecommendationLoading: isRecommendationLoading, recommendations: recommendations } = (0, $cT4PD.useFetchRecommendations)();
    const { fireRenderGlobalNavProductRecommendationsFailed: fireRenderGlobalNavProductRecommendationsFailed, fireGlobalNavProductRecommendationsViewed: fireGlobalNavProductRecommendationsViewed } = (0, $fJROq.useAnalytics)();
    const onGlobalNavProductRecommendationsFailed = (0, $1oC0p.useCallback)((error, errorInfo)=>{
        fireRenderGlobalNavProductRecommendationsFailed(error, errorInfo);
        setIsGlobalNavProductRecommendationsExperimentFailed(true);
    }, [
        fireRenderGlobalNavProductRecommendationsFailed
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (isUserLoggedIn && !hasEnterpriseEdition) getProductRecommendations({
            setIsGlobalNavProductRecommendationsExperimentFailed: setIsGlobalNavProductRecommendationsExperimentFailed
        });
    }, [
        hasEnterpriseEdition,
        getProductRecommendations,
        isUserLoggedIn
    ]);
    const fireGlobalNavProductRecoEventsWhenInView = (0, $1oC0p.useCallback)(({ isMobile: isMobile })=>{
        try {
            if (isUserLoggedIn && !hasEnterpriseEdition && recommendations.length > 0) fireGlobalNavProductRecommendationsViewed({
                recommendations: recommendations,
                isMobile: isMobile
            });
        } catch (_) {
        // Do nothing
        }
    }, [
        recommendations,
        hasEnterpriseEdition,
        isUserLoggedIn,
        fireGlobalNavProductRecommendationsViewed
    ]);
    /**
   * Show the Global Nav Product Recommendations if the user is eligible, and the recommendations are loaded.
   */ const shouldShowGlobalNavProductRecommendations = (0, $1oC0p.useMemo)(()=>{
        const nonEmptyRecosLoaded = !isRecommendationLoading && recommendations.length > 0;
        const shouldShowByRecommendationState = isRecommendationLoading || nonEmptyRecosLoaded;
        return isUserLoggedIn && shouldShowByRecommendationState && !isGlobalNavProductRecommendationsExperimentFailed && !hasEnterpriseEdition;
    }, [
        hasEnterpriseEdition,
        isGlobalNavProductRecommendationsExperimentFailed,
        isRecommendationLoading,
        isUserLoggedIn,
        recommendations.length
    ]);
    const mobileNavPageLabelFeaturedProducts = (0, $1oC0p.useMemo)(()=>{
        return intl.formatMessage((0, $fnHPc.defineMessage)({
            id: 'globalnav.v2.productseveryone.title',
            defaultMessage: 'Featured Products'
        }));
    }, [
        intl
    ]);
    return {
        onGlobalNavProductRecommendationsFailed: onGlobalNavProductRecommendationsFailed,
        shouldShowGlobalNavProductRecommendations: shouldShowGlobalNavProductRecommendations,
        recommendations: recommendations,
        isRecommendationLoading: isRecommendationLoading,
        mobileNavPageLabelFeaturedProducts: mobileNavPageLabelFeaturedProducts,
        fireGlobalNavProductRecoEventsWhenInView: fireGlobalNavProductRecoEventsWhenInView
    };
}

});
parcelRegister("cT4PD", function(module, exports) {
$parcel$export(module.exports, "useFetchRecommendations", function () { return $9c9fb0cdbe76ac1b$export$6501da23a2770fc; });

var $1oC0p = parcelRequire("1oC0p");

var $jAb7e = parcelRequire("jAb7e");

var $cIsCk = parcelRequire("cIsCk");

var $fJROq = parcelRequire("fJROq");
const $9c9fb0cdbe76ac1b$var$WAC_GLOBAL_NAV_PRODUCT_RECOMMENDATION_USE_CASE = 'WACGlobalNavProductRecommendation';
function $9c9fb0cdbe76ac1b$export$6501da23a2770fc() {
    const [isRecommendationLoading, setIsRecommendationLoading] = (0, $1oC0p.useState)(false);
    const isRecommendationLoadedRef = (0, $1oC0p.useRef)(false);
    const [recommendations, setRecommendations] = (0, $1oC0p.useState)([]);
    const { fireFetchGrowthRecommendationSucceeded: fireFetchGrowthRecommendationSucceeded, fireFetchGrowthRecommendationFailed: fireFetchGrowthRecommendationFailed } = (0, $fJROq.useAnalytics)();
    const { getRecommendations: getRecommendations } = (0, $jAb7e.default)({
        endpoint: undefined,
        // use default endpoint
        contextResolver: {
            product: 'marketing',
            useCase: $9c9fb0cdbe76ac1b$var$WAC_GLOBAL_NAV_PRODUCT_RECOMMENDATION_USE_CASE
        }
    });
    const getProductRecommendations = (0, $1oC0p.useCallback)(async ({ setIsGlobalNavProductRecommendationsExperimentFailed: setIsGlobalNavProductRecommendationsExperimentFailed })=>{
        if (isRecommendationLoading || isRecommendationLoadedRef.current) return;
        const startTime = performance.now();
        try {
            setIsRecommendationLoading(true);
            const result = await getRecommendations({
                first: (0, $cIsCk.NUM_DISPLAY_RECOMMENDATIONS),
                rerank: $9c9fb0cdbe76ac1b$export$e15fc74c2b3bb267((0, $cIsCk.ccpKeyToProductId)),
                config: {
                    cacheConfig: {
                        ttl: 60
                    }
                }
            });
            const { response: { data: data } = {} } = result;
            if ($9c9fb0cdbe76ac1b$var$isValidResponse(data)) {
                const recommendedProductIds = data.map(({ entityId: entityId })=>entityId);
                setRecommendations(recommendedProductIds);
                const elapsedTime = performance.now() - startTime;
                fireFetchGrowthRecommendationSucceeded(recommendedProductIds, elapsedTime);
                setIsRecommendationLoading(false);
                isRecommendationLoadedRef.current = true;
            } else throw new Error('Invalid response from App Recommendations API');
        } catch (error) {
            const elapsedTime = performance.now() - startTime;
            const errorMessage = error instanceof Error ? error.message : String(error);
            fireFetchGrowthRecommendationFailed(errorMessage, elapsedTime);
            setIsGlobalNavProductRecommendationsExperimentFailed(true);
            setIsRecommendationLoading(false);
            isRecommendationLoadedRef.current = true;
        }
    }, [
        fireFetchGrowthRecommendationFailed,
        fireFetchGrowthRecommendationSucceeded,
        getRecommendations,
        isRecommendationLoading
    ]);
    return {
        getProductRecommendations: getProductRecommendations,
        isRecommendationLoading: isRecommendationLoading,
        recommendations: recommendations
    };
}
const $9c9fb0cdbe76ac1b$export$e15fc74c2b3bb267 = (entities)=>Object.keys(entities).map((key)=>({
            entityId: key
        }));
/**
 * Ensure the response is valid type
 */ const $9c9fb0cdbe76ac1b$var$isValidResponse = (data)=>{
    return Array.isArray(data);
};

});
parcelRegister("jAb7e", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e41a0078153c1871$export$2e2bcd8739ae039; });

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $d20AX = parcelRequire("d20AX");

var $gha1N = parcelRequire("gha1N");

var $k8ibi = parcelRequire("k8ibi");

var $5GTvM = parcelRequire("5GTvM");

var $2kG3g = parcelRequire("2kG3g");
function $e41a0078153c1871$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e41a0078153c1871$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e41a0078153c1871$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e41a0078153c1871$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e41a0078153c1871$var$useRecommendations = function useRecommendations(_ref) {
    var _ref$endpoint = _ref.endpoint, endpoint = _ref$endpoint === void 0 ? '/gateway/api/graphql' : _ref$endpoint, contextResolver = _ref.contextResolver;
    /**
   * Fetch recommendations for a given context
   */ var getRecommendations = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useCallback(function(args) {
        var deprecatedRerank = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        // Deconstruct the args object with deprecated arguments to make it backwards compatible
        var _ref2 = typeof args === 'number' ? {
            first: args,
            rerank: deprecatedRerank
        } : args, first = _ref2.first, rerank = _ref2.rerank, _ref2$config = _ref2.config, _ref2$config2 = _ref2$config === void 0 ? {
            cacheConfig: undefined
        } : _ref2$config, cacheConfig = _ref2$config2.cacheConfig;
        var recommendationRequestMaker = new (0, $k8ibi.default)(endpoint);
        var requester = new (0, $2kG3g.default)(new (0, $5GTvM.RecommendationsRequestBroker)());
        var context = (0, $gha1N.getContext)(contextResolver);
        return requester.fetch(recommendationRequestMaker.makeRequest({
            contextResolver: contextResolver,
            first: first,
            rerank: rerank
        }), {
            cacheConfig: cacheConfig ? $e41a0078153c1871$var$_objectSpread($e41a0078153c1871$var$_objectSpread({}, cacheConfig), {}, {
                cacheName: (0, $d20AX.CACHE_NAME),
                useCase: context.useCase
            }) : undefined
        });
    }, [
        contextResolver,
        endpoint
    ]);
    return {
        getRecommendations: getRecommendations
    };
};
var $e41a0078153c1871$export$2e2bcd8739ae039 = $e41a0078153c1871$var$useRecommendations;

});
parcelRegister("d20AX", function(module, exports) {
$parcel$export(module.exports, "CACHE_NAME", function () { return $97cbec763b5145a4$export$14b7e2c312f27acd; });
// Events
var $97cbec763b5145a4$export$38f20466f22f45f0 = 'CLICK_PRIVACY_POLICY_LINK';
var $97cbec763b5145a4$export$836f30b3a88d4259 = 'UNDO_DISMISSAL_STARTED';
var $97cbec763b5145a4$export$5ee3f53555c01a95 = 'UNDO_DISMISSAL_SUCCEEDED';
var $97cbec763b5145a4$export$eebf6a2671000e28 = 'UNDO_DISMISSAL_FAILED';
var $97cbec763b5145a4$export$14b7e2c312f27acd = 'atlassian-growth-recos';

});

parcelRegister("gha1N", function(module, exports) {
$parcel$export(module.exports, "getContext", function () { return $bd9603347281d53c$export$31553aaa555c1514; });

var $2zYm4 = parcelRequire("2zYm4");
function $bd9603347281d53c$export$a079a83b07f794bf(value) {
    if (value === null || value === undefined || value === '') return false;
    if (Array.isArray(value) && value.length === 0) return false;
    if ((0, $2zYm4.default)(value) === 'object' && Object.keys(value).length === 0) return false;
    return true;
}
function $bd9603347281d53c$export$31553aaa555c1514(contextResolver) {
    var checkUseCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var context = typeof contextResolver === 'function' ? contextResolver() : contextResolver;
    if (checkUseCase && (typeof (context === null || context === void 0 ? void 0 : context.useCase) !== 'string' || (context === null || context === void 0 ? void 0 : context.useCase.trim().length) === 0)) throw new Error('useCase is required');
    return context;
}

});

parcelRegister("k8ibi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ea82a8669afb93a6$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $i7dvh = parcelRequire("i7dvh");

var $imEER = parcelRequire("imEER");
function $ea82a8669afb93a6$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $ea82a8669afb93a6$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $ea82a8669afb93a6$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ea82a8669afb93a6$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $ea82a8669afb93a6$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_RequestMaker) {
    function RecommendationsRequestMaker() {
        (0, $cTewU.default)(this, RecommendationsRequestMaker);
        return $ea82a8669afb93a6$var$_callSuper(this, RecommendationsRequestMaker, arguments);
    }
    (0, $i7dvh.default)(RecommendationsRequestMaker, _RequestMaker);
    return (0, $avOEA.default)(RecommendationsRequestMaker, [
        {
            key: "makeRequest",
            value: function makeRequest(makeRequestParams) {
                var contextResolver = makeRequestParams.contextResolver, first = makeRequestParams.first, rerank = makeRequestParams.rerank;
                return new Request(this.endpoint, {
                    method: 'POST',
                    credentials: 'include',
                    mode: 'cors',
                    headers: this.getHeaders(),
                    body: JSON.stringify({
                        query: $ea82a8669afb93a6$var$recommendationsQuery,
                        variables: {
                            first: first,
                            context: this.getContext(contextResolver),
                            rerank: rerank
                        }
                    })
                });
            }
        }
    ]);
}((0, $imEER.default));
var $ea82a8669afb93a6$var$recommendationsQuery = "\nquery GrowthRecQuery($context: GrowthRecContext!, $first: Int!, $rerank: [GrowthRecRerankCandidate!]) {\n  growthRecommendations {\n    recommendations(context: $context, first: $first, rerank: $rerank) {\n      ... on GrowthRecRecommendations {\n        __typename\n        data {\n          __typename\n          entityId\n          reasons\n        }\n      }\n      ... on QueryError {\n        __typename\n        identifier\n        message\n        extensions {\n          __typename\n          statusCode\n          errorType\n        }\n      }\n    }\n  }\n}\n";

});
parcelRegister("imEER", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d5e9d1ed63117429$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $gha1N = parcelRequire("gha1N");
var $d5e9d1ed63117429$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function RequestMaker(endpoint) {
        (0, $cTewU.default)(this, RequestMaker);
        this.endpoint = endpoint;
    }
    return (0, $avOEA.default)(RequestMaker, [
        {
            key: "getHeaders",
            value: function getHeaders() {
                var headers = new Headers();
                headers.append('Content-Type', 'application/json');
                return headers;
            }
        },
        {
            key: "getContext",
            value: function getContext(contextResolver) {
                return (0, $gha1N.getContext)(contextResolver);
            }
        }
    ]);
}();

});


parcelRegister("5GTvM", function(module, exports) {
$parcel$export(module.exports, "RecommendationsRequestBroker", function () { return $424bef761d9eb5c1$export$7f19312509e0d2c0; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $252p6 = parcelRequire("252p6");
var $424bef761d9eb5c1$export$7f19312509e0d2c0 = /*#__PURE__*/ function() {
    function RecommendationsRequestBroker() {
        (0, $cTewU.default)(this, RecommendationsRequestBroker);
    }
    return (0, $avOEA.default)(RecommendationsRequestBroker, [
        {
            key: "extract",
            value: function extract(response) {
                var _response$recommendat, _response$recommendat2;
                return (_response$recommendat = response === null || response === void 0 || (_response$recommendat2 = response.recommendations) === null || _response$recommendat2 === void 0 ? void 0 : _response$recommendat2.data) !== null && _response$recommendat !== void 0 ? _response$recommendat : [];
            }
        },
        {
            key: "getSuccessResultCreator",
            value: function getSuccessResultCreator(response, result) {
                return new (0, $252p6.RecommendationSuccessResultCreator)(response, result);
            }
        }
    ]);
}();

});
parcelRegister("252p6", function(module, exports) {
$parcel$export(module.exports, "RecommendationSuccessResultCreator", function () { return $183de9c69a26f999$export$c02f0b31b3b527a3; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $i7dvh = parcelRequire("i7dvh");

var $cQKhY = parcelRequire("cQKhY");
function $183de9c69a26f999$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $183de9c69a26f999$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $183de9c69a26f999$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($183de9c69a26f999$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $183de9c69a26f999$export$c02f0b31b3b527a3 = /*#__PURE__*/ function(_QuerySuccessResultCr) {
    function RecommendationSuccessResultCreator(response, data) {
        var _this;
        (0, $cTewU.default)(this, RecommendationSuccessResultCreator);
        _this = $183de9c69a26f999$var$_callSuper(this, RecommendationSuccessResultCreator, [
            response,
            data
        ]);
        _this.response = response;
        return _this;
    }
    (0, $i7dvh.default)(RecommendationSuccessResultCreator, _QuerySuccessResultCr);
    return (0, $avOEA.default)(RecommendationSuccessResultCreator, [
        {
            key: "makeQueryResult",
            value: function makeQueryResult() {
                return new (0, $cQKhY.GraphQlQueryResult)(this.response.status, this.response.statusText, {
                    data: this.data
                });
            }
        }
    ]);
}((0, $cQKhY.QuerySuccessResultCreator));

});
parcelRegister("cQKhY", function(module, exports) {
$parcel$export(module.exports, "GraphQlQueryResult", function () { return $95ae3f64ec4e1ab2$export$d0a1abfd57dc5018; });
$parcel$export(module.exports, "NonOkQueryResultCreator", function () { return $95ae3f64ec4e1ab2$export$ad7cb7f4450dd7c4; });
$parcel$export(module.exports, "GeneralQueryErrorResultCreator", function () { return $95ae3f64ec4e1ab2$export$553722ecbbe27276; });
$parcel$export(module.exports, "MissingQueryDataResultCreator", function () { return $95ae3f64ec4e1ab2$export$ff264bfdc9a404eb; });
$parcel$export(module.exports, "QuerySuccessResultCreator", function () { return $95ae3f64ec4e1ab2$export$6b16771e962990ff; });

var $2qaZZ = parcelRequire("2qaZZ");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $i7dvh = parcelRequire("i7dvh");

var $avOEA = parcelRequire("avOEA");

var $cTewU = parcelRequire("cTewU");
function $95ae3f64ec4e1ab2$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $95ae3f64ec4e1ab2$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $95ae3f64ec4e1ab2$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($95ae3f64ec4e1ab2$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $95ae3f64ec4e1ab2$export$d0a1abfd57dc5018 = /*#__PURE__*/ (0, $avOEA.default)(function GraphQlQueryResult(code, reason, response) {
    (0, $cTewU.default)(this, GraphQlQueryResult);
    this.code = code;
    this.reason = reason;
    this.response = response;
});
var $95ae3f64ec4e1ab2$var$QueryResultCreator = /*#__PURE__*/ (0, $avOEA.default)(function QueryResultCreator() {
    (0, $cTewU.default)(this, QueryResultCreator);
});
var $95ae3f64ec4e1ab2$export$ad7cb7f4450dd7c4 = /*#__PURE__*/ function(_QueryResultCreator) {
    function NonOkQueryResultCreator(fetchResponse) {
        var _this;
        (0, $cTewU.default)(this, NonOkQueryResultCreator);
        _this = $95ae3f64ec4e1ab2$var$_callSuper(this, NonOkQueryResultCreator);
        _this.fetchResponse = fetchResponse;
        return _this;
    }
    (0, $i7dvh.default)(NonOkQueryResultCreator, _QueryResultCreator);
    return (0, $avOEA.default)(NonOkQueryResultCreator, [
        {
            key: "makeQueryResult",
            value: function makeQueryResult() {
                return new $95ae3f64ec4e1ab2$export$d0a1abfd57dc5018(this.fetchResponse.status, this.fetchResponse.statusText);
            }
        }
    ]);
}($95ae3f64ec4e1ab2$var$QueryResultCreator);
var $95ae3f64ec4e1ab2$export$553722ecbbe27276 = /*#__PURE__*/ function(_QueryResultCreator2) {
    function GeneralQueryErrorResultCreator(errors) {
        var _this2;
        (0, $cTewU.default)(this, GeneralQueryErrorResultCreator);
        _this2 = $95ae3f64ec4e1ab2$var$_callSuper(this, GeneralQueryErrorResultCreator);
        _this2.errors = errors;
        return _this2;
    }
    (0, $i7dvh.default)(GeneralQueryErrorResultCreator, _QueryResultCreator2);
    return (0, $avOEA.default)(GeneralQueryErrorResultCreator, [
        {
            key: "makeQueryResult",
            value: function makeQueryResult() {
                var _this$errors = (0, $2qaZZ.default)(this.errors, 1), extensions = _this$errors[0].extensions;
                var _ref = Array.isArray(extensions) ? extensions : [
                    extensions
                ], _ref2 = (0, $2qaZZ.default)(_ref, 1), _ref2$ = _ref2[0], statusCode = _ref2$.statusCode, errorType = _ref2$.errorType;
                return new $95ae3f64ec4e1ab2$export$d0a1abfd57dc5018(statusCode, errorType, {
                    errors: this.errors.map(function(error) {
                        return error.message;
                    })
                });
            }
        }
    ]);
}($95ae3f64ec4e1ab2$var$QueryResultCreator);
var $95ae3f64ec4e1ab2$export$ff264bfdc9a404eb = /*#__PURE__*/ function(_QueryResultCreator3) {
    function MissingQueryDataResultCreator(fetchResponse) {
        var _this3;
        (0, $cTewU.default)(this, MissingQueryDataResultCreator);
        _this3 = $95ae3f64ec4e1ab2$var$_callSuper(this, MissingQueryDataResultCreator);
        _this3.fetchResponse = fetchResponse;
        return _this3;
    }
    (0, $i7dvh.default)(MissingQueryDataResultCreator, _QueryResultCreator3);
    return (0, $avOEA.default)(MissingQueryDataResultCreator, [
        {
            key: "makeQueryResult",
            value: function makeQueryResult() {
                return new $95ae3f64ec4e1ab2$export$d0a1abfd57dc5018(this.fetchResponse.status, this.fetchResponse.statusText, {
                    errors: [
                        'Received data has missing attributes'
                    ]
                });
            }
        }
    ]);
}($95ae3f64ec4e1ab2$var$QueryResultCreator);
var $95ae3f64ec4e1ab2$export$6b16771e962990ff = /*#__PURE__*/ function(_QueryResultCreator4) {
    function QuerySuccessResultCreator(response, data) {
        var _this4;
        (0, $cTewU.default)(this, QuerySuccessResultCreator);
        _this4 = $95ae3f64ec4e1ab2$var$_callSuper(this, QuerySuccessResultCreator);
        _this4.response = response;
        _this4.data = data;
        return _this4;
    }
    (0, $i7dvh.default)(QuerySuccessResultCreator, _QueryResultCreator4);
    return (0, $avOEA.default)(QuerySuccessResultCreator);
}($95ae3f64ec4e1ab2$var$QueryResultCreator);

});



parcelRegister("2kG3g", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1b2e11991bebe1d3$export$2e2bcd8739ae039; });

var $cn8ql = parcelRequire("cn8ql");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $5Cxn4 = parcelRequire("5Cxn4");

var $cQKhY = parcelRequire("cQKhY");

var $jMzYo = parcelRequire("jMzYo");
/** The requester to make query operation to App Recommendations API via AGG
 *
 * Currently, App Recommendations Service has only a single query (and we only use a single query), which doesn't return any Query errors
 * @see {@link https://developer.atlassian.com/platform/graphql-gateway/standards/query-error/} for more about query errors
 * The query error checking is skipped for now, but it can be added in the future if needed
 */ var $1b2e11991bebe1d3$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Requester(broker) {
        (0, $cTewU.default)(this, Requester);
        this.broker = broker;
    }
    /**
   * Fetches the response by the given request from the cache or the API
   * the cache config is optional, if not provided, the response will not be cached
   *
   * @param request The request to fetch the response from
   * @param cacheConfig The cache configuration to use
   * @returns The query result
   */ return (0, $avOEA.default)(Requester, [
        {
            key: "fetch",
            value: function fetch1(request) {
                var _this = this;
                var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, cacheConfig = _ref.cacheConfig;
                return new Promise(/*#__PURE__*/ function() {
                    var _ref2 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(resolve, reject) {
                        var _json$data;
                        var response, json, schemaResponse, queryRes;
                        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                            while(true)switch(_context.prev = _context.next){
                                case 0:
                                    _context.next = 2;
                                    return _this.getResponse(request, cacheConfig);
                                case 2:
                                    response = _context.sent;
                                    if (response.ok) {
                                        _context.next = 5;
                                        break;
                                    }
                                    return _context.abrupt("return", reject(new (0, $cQKhY.NonOkQueryResultCreator)(response).makeQueryResult()));
                                case 5:
                                    _context.next = 7;
                                    return response.json();
                                case 7:
                                    json = _context.sent;
                                    if (!json.errors) {
                                        _context.next = 10;
                                        break;
                                    }
                                    return _context.abrupt("return", reject(new (0, $cQKhY.GeneralQueryErrorResultCreator)(json.errors).makeQueryResult()));
                                case 10:
                                    schemaResponse = json === null || json === void 0 || (_json$data = json.data) === null || _json$data === void 0 ? void 0 : _json$data.growthRecommendations;
                                    queryRes = _this.broker.extract(schemaResponse); // Undefined is not expected as a valid response from GraphQL
                                    if (!(queryRes === undefined)) {
                                        _context.next = 14;
                                        break;
                                    }
                                    return _context.abrupt("return", reject(new (0, $cQKhY.MissingQueryDataResultCreator)(response).makeQueryResult()));
                                case 14:
                                    return _context.abrupt("return", resolve(_this.broker.getSuccessResultCreator(response, queryRes).makeQueryResult()));
                                case 15:
                                case "end":
                                    return _context.stop();
                            }
                        }, _callee);
                    }));
                    return function(_x, _x2) {
                        return _ref2.apply(this, arguments);
                    };
                }());
            }
        },
        {
            key: "getResponse",
            value: function() {
                var _getResponse = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(request, cacheConfig) {
                    var cacheProvider, cachedResponse, clonedRequest;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                cacheProvider = (0, $jMzYo.default).resolve(cacheConfig);
                                _context2.next = 3;
                                return cacheProvider.get(request);
                            case 3:
                                cachedResponse = _context2.sent;
                                if (!cachedResponse) {
                                    _context2.next = 6;
                                    break;
                                }
                                return _context2.abrupt("return", cachedResponse);
                            case 6:
                                // Clone the request before it being used to be able to use it multiple times
                                clonedRequest = request.clone();
                                return _context2.abrupt("return", fetch(request).then(function(response) {
                                    // Cache response only if the response is ok
                                    if (response.ok) cacheProvider.set(clonedRequest, response.clone());
                                    return response;
                                }));
                            case 8:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }));
                function getResponse(_x3, _x4) {
                    return _getResponse.apply(this, arguments);
                }
                return getResponse;
            }()
        }
    ]);
}();

});
parcelRegister("jMzYo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e66e678845a31499$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $eRZlG = parcelRequire("eRZlG");

var $f6Frm = parcelRequire("f6Frm");
var $e66e678845a31499$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ResponseCacheProviderResolver() {
        (0, $cTewU.default)(this, ResponseCacheProviderResolver);
    }
    return (0, $avOEA.default)(ResponseCacheProviderResolver, null, [
        {
            key: "resolve",
            value: /**
     * Returns the cache provider based on the given cache configuration
     *
     * @param cacheConfig The cache configuration to use
     * @returns The cache provider
     */ function resolve(cacheConfig) {
                if (cacheConfig) return new (0, $f6Frm.default)(cacheConfig);
                return new (0, $eRZlG.default)();
            }
        }
    ]);
}();

});
parcelRegister("eRZlG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ad359a7f9fa92927$export$2e2bcd8739ae039; });

var $cn8ql = parcelRequire("cn8ql");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $5Cxn4 = parcelRequire("5Cxn4");
var $ad359a7f9fa92927$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function NoCache() {
        (0, $cTewU.default)(this, NoCache);
    }
    return (0, $avOEA.default)(NoCache, [
        {
            key: "get",
            value: function() {
                var _get = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(request) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                return _context.abrupt("return", undefined);
                            case 1:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function get(_x) {
                    return _get.apply(this, arguments);
                }
                return get;
            }()
        },
        {
            key: "set",
            value: function() {
                var _set = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(request, response) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return");
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }));
                function set(_x2, _x3) {
                    return _set.apply(this, arguments);
                }
                return set;
            }()
        },
        {
            key: "delete",
            value: function() {
                var _delete2 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(request) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", true);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _delete(_x4) {
                    return _delete2.apply(this, arguments);
                }
                return _delete;
            }()
        }
    ]);
}();

});

parcelRegister("f6Frm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $aff78fbdd9dd2c19$export$2e2bcd8739ae039; });

var $cn8ql = parcelRequire("cn8ql");

var $2zYm4 = parcelRequire("2zYm4");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $5Cxn4 = parcelRequire("5Cxn4");

var $5PZ9Y = parcelRequire("5PZ9Y");

var $kOoh1 = parcelRequire("kOoh1");
var $aff78fbdd9dd2c19$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Whether the Cache API is supported
   */ /**
   * Expiry storage
   */ /**
   * Initialise the WebCacheStorage
   * @param cacheName The name of the cache to use. See {@link https://developer.mozilla.org/en-US/docs/Web/API/CacheStorage/open}
   * @param onError a callback when any error occurs
   */ function WebCacheStorage(cacheProviderConfig) {
        (0, $cTewU.default)(this, WebCacheStorage);
        this.supported = (typeof caches === "undefined" ? "undefined" : (0, $2zYm4.default)(caches)) === 'object' && typeof caches.open === 'function';
        this.cacheConfig = new (0, $5PZ9Y.default)(cacheProviderConfig);
        this.expiryStorage = new (0, $kOoh1.default)(this.cacheConfig);
    }
    /**
   * Get cached response
   */ return (0, $avOEA.default)(WebCacheStorage, [
        {
            key: "get",
            value: function() {
                var _get = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(request) {
                    var cache, expired;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (this.supported) {
                                    _context.next = 2;
                                    break;
                                }
                                return _context.abrupt("return", undefined);
                            case 2:
                                _context.prev = 2;
                                _context.next = 5;
                                return caches.open(this.cacheConfig.cacheName);
                            case 5:
                                cache = _context.sent;
                                _context.next = 8;
                                return this.isExpired(request);
                            case 8:
                                expired = _context.sent;
                                if (!expired) {
                                    _context.next = 13;
                                    break;
                                }
                                _context.next = 12;
                                return this.delete(request);
                            case 12:
                                return _context.abrupt("return", undefined);
                            case 13:
                                return _context.abrupt("return", cache.match(this.getCacheKey(request)));
                            case 16:
                                _context.prev = 16;
                                _context.t0 = _context["catch"](2);
                                this.cacheConfig.onError(_context.t0);
                            case 19:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            16
                        ]
                    ]);
                }));
                function get(_x) {
                    return _get.apply(this, arguments);
                }
                return get;
            }()
        },
        {
            key: "set",
            value: function() {
                var _set = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(request, response) {
                    var cache, expiryDate;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                if (this.supported) {
                                    _context2.next = 2;
                                    break;
                                }
                                return _context2.abrupt("return");
                            case 2:
                                _context2.prev = 2;
                                _context2.next = 5;
                                return caches.open(this.cacheConfig.cacheName);
                            case 5:
                                cache = _context2.sent;
                                expiryDate = Date.now() + this.cacheConfig.ttl * 1000;
                                _context2.next = 9;
                                return this.expiryStorage.setExpiry(this.getStoreKey(request), expiryDate);
                            case 9:
                                _context2.next = 11;
                                return cache.put(this.getCacheKey(request), response);
                            case 11:
                                _context2.next = 16;
                                break;
                            case 13:
                                _context2.prev = 13;
                                _context2.t0 = _context2["catch"](2);
                                this.cacheConfig.onError(_context2.t0);
                            case 16:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            2,
                            13
                        ]
                    ]);
                }));
                function set(_x2, _x3) {
                    return _set.apply(this, arguments);
                }
                return set;
            }()
        },
        {
            key: "delete",
            value: function() {
                var _delete2 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee4(request) {
                    var _this = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                if (this.supported) {
                                    _context4.next = 2;
                                    break;
                                }
                                return _context4.abrupt("return", true);
                            case 2:
                                _context4.prev = 2;
                                return _context4.abrupt("return", caches.open(this.cacheConfig.cacheName).then(/*#__PURE__*/ function() {
                                    var _ref = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(cache) {
                                        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee3$(_context3) {
                                            while(true)switch(_context3.prev = _context3.next){
                                                case 0:
                                                    _context3.next = 2;
                                                    return cache.delete(_this.getCacheKey(request));
                                                case 2:
                                                    _context3.next = 4;
                                                    return _this.expiryStorage.deleteExpiry(_this.getStoreKey(request));
                                                case 4:
                                                    return _context3.abrupt("return", true);
                                                case 5:
                                                case "end":
                                                    return _context3.stop();
                                            }
                                        }, _callee3);
                                    }));
                                    return function(_x5) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()));
                            case 6:
                                _context4.prev = 6;
                                _context4.t0 = _context4["catch"](2);
                                this.cacheConfig.onError(_context4.t0);
                                return _context4.abrupt("return", false);
                            case 10:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this, [
                        [
                            2,
                            6
                        ]
                    ]);
                }));
                function _delete(_x4) {
                    return _delete2.apply(this, arguments);
                }
                return _delete;
            }()
        },
        {
            key: "isExpired",
            value: function() {
                var _isExpired = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee5(request) {
                    var key, expiry;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                _context5.prev = 0;
                                key = this.getStoreKey(request);
                                _context5.next = 4;
                                return this.expiryStorage.getExpiry(key);
                            case 4:
                                expiry = _context5.sent;
                                return _context5.abrupt("return", Date.now() > (expiry !== null && expiry !== void 0 ? expiry : 0));
                            case 8:
                                _context5.prev = 8;
                                _context5.t0 = _context5["catch"](0);
                                this.cacheConfig.onError(_context5.t0 instanceof Error ? _context5.t0 : new Error('Error checking expiry'));
                                return _context5.abrupt("return", true);
                            case 12:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this, [
                        [
                            0,
                            8
                        ]
                    ]);
                }));
                function isExpired(_x6) {
                    return _isExpired.apply(this, arguments);
                }
                return isExpired;
            }()
        },
        {
            key: "getCacheKey",
            value: function getCacheKey(request) {
                var url = new URL(request.url);
                url.searchParams.set('useCase', this.cacheConfig.useCase);
                return url;
            }
        },
        {
            key: "getStoreKey",
            value: function getStoreKey(request) {
                return this.getCacheKey(request).toString();
            }
        }
    ]);
}();

});
parcelRegister("5PZ9Y", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $44012843d4c19c08$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");
var $44012843d4c19c08$var$DEFAULT_TTL = 60;
var $44012843d4c19c08$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function CacheConfig(cacheProviderConfig) {
        (0, $cTewU.default)(this, CacheConfig);
        this.cacheProviderConfig = cacheProviderConfig;
    }
    return (0, $avOEA.default)(CacheConfig, [
        {
            key: "cacheName",
            get: function get() {
                return this.cacheProviderConfig.cacheName;
            }
        },
        {
            key: "useCase",
            get: function get() {
                return this.cacheProviderConfig.useCase;
            }
        },
        {
            key: "ttl",
            get: function get() {
                var _this$cacheProviderCo;
                return (_this$cacheProviderCo = this.cacheProviderConfig.ttl) !== null && _this$cacheProviderCo !== void 0 ? _this$cacheProviderCo : $44012843d4c19c08$var$DEFAULT_TTL;
            }
        },
        {
            key: "onError",
            get: function get() {
                var _this$cacheProviderCo2;
                return (_this$cacheProviderCo2 = this.cacheProviderConfig.onError) !== null && _this$cacheProviderCo2 !== void 0 ? _this$cacheProviderCo2 : function() {};
            }
        }
    ]);
}();

});

parcelRegister("kOoh1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f26b4e665d4a143b$export$2e2bcd8739ae039; });

var $cn8ql = parcelRequire("cn8ql");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $5Cxn4 = parcelRequire("5Cxn4");
/**
 * Expiry storage that stores the expiry date of the cached response
 */ var $f26b4e665d4a143b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Initialise the ExpiryStorage
   */ function ExpiryStorage(cacheConfig) {
        (0, $cTewU.default)(this, ExpiryStorage);
        (0, $f53LC.default)(this, "expiryStoreName", 'expiries');
        this.cacheConfig = cacheConfig;
    }
    /**
   * Set the expiry date of the cached response
   */ return (0, $avOEA.default)(ExpiryStorage, [
        {
            key: "setExpiry",
            value: function() {
                var _setExpiry = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(key, expireAt) {
                    var _this = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                return _context.abrupt("return", new Promise(function(resolve, reject) {
                                    var dbRequest = _this.initDb();
                                    dbRequest.onsuccess = function() {
                                        var store = _this.getObjectStore(dbRequest, 'readwrite');
                                        store.put(expireAt, key);
                                        resolve();
                                    };
                                    dbRequest.onerror = function() {
                                        if (dbRequest.error) reject(dbRequest.error);
                                    };
                                }));
                            case 1:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function setExpiry(_x, _x2) {
                    return _setExpiry.apply(this, arguments);
                }
                return setExpiry;
            }()
        },
        {
            key: "getExpiry",
            value: function() {
                var _getExpiry = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(key) {
                    var _this2 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", new Promise(function(resolve, reject) {
                                    var dbRequest = _this2.initDb();
                                    dbRequest.onsuccess = function() {
                                        var store = _this2.getObjectStore(dbRequest, 'readonly');
                                        var storeRequest = store.get(key);
                                        storeRequest.onsuccess = function() {
                                            var _storeRequest$result;
                                            resolve(Number((_storeRequest$result = storeRequest.result) !== null && _storeRequest$result !== void 0 ? _storeRequest$result : 0));
                                        };
                                    };
                                    dbRequest.onerror = function() {
                                        if (dbRequest.error) reject(dbRequest.error);
                                    };
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }));
                function getExpiry(_x3) {
                    return _getExpiry.apply(this, arguments);
                }
                return getExpiry;
            }()
        },
        {
            key: "deleteExpiry",
            value: function() {
                var _deleteExpiry = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(key) {
                    var _this3 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", new Promise(function(resolve, reject) {
                                    var dbRequest = _this3.initDb();
                                    dbRequest.onsuccess = function() {
                                        var store = _this3.getObjectStore(dbRequest, 'readwrite');
                                        store.delete(key);
                                        resolve();
                                    };
                                    dbRequest.onerror = function() {
                                        if (dbRequest.error) reject(dbRequest.error);
                                    };
                                }));
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function deleteExpiry(_x4) {
                    return _deleteExpiry.apply(this, arguments);
                }
                return deleteExpiry;
            }()
        },
        {
            key: "initDb",
            value: function initDb() {
                var _this4 = this;
                var dbRequest = indexedDB.open("".concat(this.cacheConfig.cacheName, "-expiry"));
                dbRequest.onupgradeneeded = function() {
                    var db = dbRequest.result;
                    db.createObjectStore(_this4.expiryStoreName);
                };
                return dbRequest;
            }
        },
        {
            key: "getObjectStore",
            value: function getObjectStore(dbRequest) {
                var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'readwrite';
                var db = dbRequest.result;
                return db.transaction(this.expiryStoreName, mode).objectStore(this.expiryStoreName);
            }
        }
    ]);
}();

});






parcelRegister("9uve9", function(module, exports) {
$parcel$export(module.exports, "useHasEnterpriseEdition", function () { return $5cd2010e18cc205f$export$d412e290bea9bfac; });

var $1oC0p = parcelRequire("1oC0p");

var $bv77X = parcelRequire("bv77X");
function $5cd2010e18cc205f$export$d412e290bea9bfac() {
    const { sites: sites = [] } = (0, $bv77X.useSitesContext)();
    const hasEnterpriseEdition = (0, $1oC0p.useMemo)(()=>sites.some((site)=>site.edition?.toLowerCase() === 'enterprise'), [
        sites
    ]);
    return hasEnterpriseEdition;
}

});


parcelRegister("Q3GOe", function(module, exports) {
$parcel$export(module.exports, "useResourcesData", function () { return $29bb8f9829fce176$export$33143093180b06fc; });
$parcel$export(module.exports, "useResourcesLinks", function () { return $29bb8f9829fce176$export$d033c7ddb6c3fb52; });
$parcel$export(module.exports, "GlobalNavResourcesDropdown", function () { return $29bb8f9829fce176$export$50e552a50c313b04; });
/* global-nav-resources-dropdown.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $fnHPc = parcelRequire("fnHPc");
var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $aIIww = parcelRequire("aIIww");

var $jsxHL = parcelRequire("jsxHL");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $MV9vM = parcelRequire("MV9vM");

var $8nFt2 = parcelRequire("8nFt2");

var $dzoWS = parcelRequire("dzoWS");

var $jgdMW = parcelRequire("jgdMW");

var $9KOR3 = parcelRequire("9KOR3");
function $29bb8f9829fce176$export$33143093180b06fc() {
    const templatesHref = (0, $jQ0cd.useLocalizedHref)('/templates');
    return [
        {
            id: 'resources.customer-support',
            title: (0, $fnHPc.defineMessage)({
                id: 'globalnavv2.subnav.resources.customer-support.title',
                defaultMessage: 'Customer Support'
            }),
            content: (0, $fnHPc.defineMessage)({
                id: 'globalnavv2.subnav.resources.customer-support.content',
                defaultMessage: 'Ask questions, report bugs & give us feedback'
            }),
            href: '//support.atlassian.com/'
        },
        {
            id: 'resources.template-gallery',
            title: (0, $fnHPc.defineMessage)({
                id: 'globalnavv2.subnav.resources.template-gallery.title',
                defaultMessage: 'Templates'
            }),
            content: (0, $fnHPc.defineMessage)({
                id: 'globalnavv2.subnav.resources.template-gallery.content',
                defaultMessage: 'Ready-made workflows for every team.'
            }),
            href: templatesHref,
            isNew: true
        },
        {
            id: 'resources.find-partners',
            title: (0, $fnHPc.defineMessage)({
                id: 'globalnavv2.subnav.resources.find-partners.title',
                defaultMessage: 'Find Partners'
            }),
            content: (0, $fnHPc.defineMessage)({
                id: 'globalnavv2.subnav.resources.find-partners.content',
                defaultMessage: 'Consulting, training & product customization support'
            }),
            href: (0, $aIIww.useLocalizedPartnerdirectory)()
        },
        {
            id: 'resources.migration-program',
            title: (0, $fnHPc.defineMessage)({
                id: 'globalnavv2.subnav.resources.migration-program.title',
                defaultMessage: 'Atlassian Ascend'
            }),
            content: (0, $fnHPc.defineMessage)({
                id: 'globalnavv2.subnav.resources.migration-program.content',
                defaultMessage: 'Resources and support for your transformation'
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/migration')
        },
        {
            id: 'resources.community',
            title: (0, $fnHPc.defineMessage)({
                id: 'globalnavv2.subnav.resources.community.title',
                defaultMessage: 'Community'
            }),
            content: (0, $fnHPc.defineMessage)({
                id: 'globalnavv2.subnav.resources.community.content',
                defaultMessage: 'Learn, connect and grow with the Atlassian Community'
            }),
            href: '//community.atlassian.com/'
        }
    ];
}
function $29bb8f9829fce176$export$d033c7ddb6c3fb52() {
    const usageHref = (0, $jQ0cd.useLocalizedHref)('/resources/usage');
    const usageCalculatorHref = (0, $jQ0cd.useLocalizedHref)('/resources/usage/calculator');
    const isUsageBasedPricingEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp11118UsageBasedPricingCalculator);
    return {
        support: {
            id: 'support',
            title: (0, $fnHPc.defineMessage)({
                id: 'globalnavv2.subnav.resources.links.support',
                defaultMessage: 'Support'
            }),
            items: [
                {
                    id: 'general-inquiries',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.resources.links.general-inquiries',
                        defaultMessage: 'General Inquiries'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/company/contact/general-inquiries')
                },
                {
                    id: 'technical-support',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.resources.links.technical-support',
                        defaultMessage: 'Technical Support'
                    }),
                    href: '//support.atlassian.com/contact/'
                },
                {
                    id: 'product-advice',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.resources.links.product-advice',
                        defaultMessage: 'Product Advice'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/company/contact/product-evaluator-advice')
                },
                {
                    id: 'pricing-billing',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.resources.links.pricing-billing',
                        defaultMessage: 'Pricing and Billing'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/company/contact/purchasing-licensing')
                },
                {
                    id: 'partner-support',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.resources.links.partner-support',
                        defaultMessage: 'Partner Support'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/partners')
                },
                {
                    id: 'developer-support',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.resources.links.developer-support',
                        defaultMessage: 'Developer Support'
                    }),
                    href: '//developer.atlassian.com/'
                },
                {
                    id: 'enterprise-support',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.resources.links.enterprise-support',
                        defaultMessage: 'Enterprise Support'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/enterprise/services')
                },
                {
                    id: 'purchasing-licensing',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.resources.links.purchasing-billing',
                        defaultMessage: 'Purchasing and Licensing'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/licensing/purchase-licensing')
                }
            ]
        },
        learn: {
            id: 'resources',
            title: (0, $fnHPc.defineMessage)({
                id: 'globalnavv2.subnav.resources.links.resources',
                defaultMessage: 'Resources'
            }),
            items: [
                {
                    id: 'project-management',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.resources.links.project-management',
                        defaultMessage: 'Project Management'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/project-management')
                },
                {
                    id: 'project-collaboration',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.resources.links.project-collaboration',
                        defaultMessage: 'Project Collaboration'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/work-management/project-collaboration')
                },
                {
                    id: 'agile',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.resources.links.agile',
                        defaultMessage: 'Agile'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/agile')
                },
                {
                    id: 'team-playbook',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.resources.links.team-playbook',
                        defaultMessage: 'Team Playbook'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/team-playbook')
                },
                {
                    id: 'learning',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.resources.links.learning',
                        defaultMessage: 'Atlassian Learning'
                    }),
                    href: '//community.atlassian.com/learning'
                },
                {
                    id: 'product-documentation',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.resources.links.product-documentation',
                        defaultMessage: 'Product Documentation'
                    }),
                    href: '//confluence.atlassian.com/display/ALLDOC/Atlassian+Documentation'
                },
                {
                    id: 'get-started',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.resources.links.get-started',
                        defaultMessage: 'Get Started'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/get-started')
                },
                ...isUsageBasedPricingEnabled ? [
                    {
                        id: 'usage',
                        text: (0, $fnHPc.defineMessage)({
                            id: 'globalnavv2.subnav.resources.links.usage',
                            defaultMessage: 'Usage-based Pricing'
                        }),
                        href: usageHref
                    },
                    {
                        id: 'usage-calculator',
                        text: (0, $fnHPc.defineMessage)({
                            id: 'globalnavv2.subnav.resources.links.usage-calculator',
                            defaultMessage: 'Usage Calculator'
                        }),
                        href: usageCalculatorHref
                    }
                ] : []
            ]
        }
    };
}
const $29bb8f9829fce176$var$ResourcesGrid = ({ children: children, numCols: numCols = 4 })=>{
    const gridTemplateColumns = Array(numCols).fill('1fr').join(' ');
    return /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _yv0e76xy _1p571jfw _gy1pxy5q _1rjc1jfw _18zr1jfw _2mzuglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ]),
        style: {
            "--_64rtn9": (0, $6ZVlx.default)(gridTemplateColumns)
        },
        children: children
    });
};
const $29bb8f9829fce176$export$50e552a50c313b04 = ({ productKey: productKey = 'home' })=>{
    const intl = (0, $8e22h.default)();
    const resourcesData = $29bb8f9829fce176$export$33143093180b06fc();
    const resourcesLinks = $29bb8f9829fce176$export$d033c7ddb6c3fb52();
    const linkColumns = Object.values(resourcesLinks);
    const { direction: direction } = (0, $9KOR3.useGlobalNavContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.DivOnHoverExit), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $8nFt2.MotionContainer), {
                direction: direction,
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)($29bb8f9829fce176$var$ResourcesGrid, {
                        numCols: 3,
                        children: resourcesData.map(({ id: id, title: title, content: content, ...rest })=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $MV9vM.TitleCard), {
                                    title: intl.formatMessage(title),
                                    content: intl.formatMessage(content),
                                    productKey: productKey,
                                    ...rest
                                })
                            }, id))
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_bfhkg7ng"
                        ]),
                        style: {
                            "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgdMW.RowGrid), {
                            numCols: 2,
                            columnGap: "var(--ds-space-400, 32px)",
                            paddingBlock: "var(--ds-space-500, 40px)",
                            paddingInline: "var(--ds-space-500, 40px)",
                            children: linkColumns.map((column)=>{
                                return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $dzoWS.GlobalNavDropdownLinkColumn), {
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.GlobalNavEyebrow), {
                                            removeMargin: true,
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                                ...column.title
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                                            className: (0, $2jatx.default)([
                                                "_2mzuglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0q14y2 _u5f3idpf _n3tdidpf _19bvidpf"
                                            ]),
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgdMW.RowGrid), {
                                                numCols: 2,
                                                columnGap: "var(--ds-space-400, 32px)",
                                                numRows: 3,
                                                rowHeight: "var(--ds-space-500, 40px)",
                                                children: column.items.map((link)=>{
                                                    return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                                        className: (0, $2jatx.default)([
                                                            "_2mzuglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qftgi _u5f3idpf _n3tdftgi _19bvidpf"
                                                        ]),
                                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                            className: (0, $2jatx.default)([
                                                                "_bpsp1nn1 _19tboxwj _1la11k8s _43ds1pfd _1e0c1txw _4cvrh9n0"
                                                            ]),
                                                            style: {
                                                                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                                                            },
                                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                                                type: "anchor",
                                                                href: link.href,
                                                                text: intl.formatMessage(link.text),
                                                                ariaLabel: intl.formatMessage(link.text),
                                                                dataEventProps: {
                                                                    'data-event': 'clicked',
                                                                    'data-event-component': 'linkButton',
                                                                    'data-event-container': 'globalNavSubnav',
                                                                    'data-product-key': productKey
                                                                },
                                                                "aria-label": intl.formatMessage(link.text)
                                                            })
                                                        }, link.id)
                                                    }, link.id);
                                                })
                                            })
                                        })
                                    ]
                                }, column.id);
                            })
                        })
                    })
                ]
            })
        })
    });
};

});
parcelRegister("aIIww", function(module, exports) {
$parcel$export(module.exports, "useLocalizedPartnerdirectory", function () { return $b23a5b1c5c6b9ebc$export$e8e649555cc9721a; });
$parcel$export(module.exports, "useLocalizedPartnerDirectoryHref", function () { return $b23a5b1c5c6b9ebc$export$ba1bcbad28261cae; });

var $3fFrT = parcelRequire("3fFrT");

var $17RBn = parcelRequire("17RBn");
const $b23a5b1c5c6b9ebc$var$localeMap = {
    [(0, $3fFrT.DEFAULT_LOCALE)]: '',
    de: 'de',
    es: 'es',
    fr: 'fr',
    it: 'it',
    ko: 'ko',
    nl: 'nl',
    ja: 'ja',
    pl: 'pl',
    br: 'br',
    ru: 'ru',
    zh: 'zh',
    ro: 'ro',
    cs: 'cs',
    hu: 'hu',
    fi: 'fi',
    xx: 'xx',
    zz: 'zz'
};
function $b23a5b1c5c6b9ebc$export$e8e649555cc9721a() {
    const locale = (0, $17RBn.useLocale)();
    return `//partnerdirectory.atlassian.com/${$b23a5b1c5c6b9ebc$var$localeMap[locale] || $b23a5b1c5c6b9ebc$var$localeMap[0, $3fFrT.DEFAULT_LOCALE]}`;
}
function $b23a5b1c5c6b9ebc$export$265340d886a0f5c7(url) {
    return url.includes('//partnerdirectory.atlassian.com/');
}
function $b23a5b1c5c6b9ebc$export$ba1bcbad28261cae(url) {
    const localizedPartnerDirectoryUrl = $b23a5b1c5c6b9ebc$export$e8e649555cc9721a();
    const locale = (0, $17RBn.useLocale)();
    if ($b23a5b1c5c6b9ebc$export$265340d886a0f5c7(url) && locale !== (0, $3fFrT.DEFAULT_LOCALE)) return url.replace('//partnerdirectory.atlassian.com/', `${localizedPartnerDirectoryUrl}/`);
    return url;
}

});

parcelRegister("MV9vM", function(module, exports) {
$parcel$export(module.exports, "TitleCard", function () { return $3e7e0535c18352cb$export$b39c77b32b32f068; });
/* card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $3pg5Q = parcelRequire("3pg5Q");
const $3e7e0535c18352cb$var$cardStyles = null;
const $3e7e0535c18352cb$var$hoverIconStyles = null;
const $3e7e0535c18352cb$var$CardTitleCardContentStyle = null;
const $3e7e0535c18352cb$var$CardTitleAnchorLinkStyle = null;
const $3e7e0535c18352cb$var$dropdownTitleStyles = null;
const $3e7e0535c18352cb$var$iconContainerStyles = null;
const $3e7e0535c18352cb$var$iconStyles = null;
const $3e7e0535c18352cb$export$b39c77b32b32f068 = ({ title: title, icon: icon, content: content, href: href, productKey: productKey = 'home', isNew: isNew })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1bsbvlwb _1s4p1osq _6ssjzu5n _kbawglyw _1x381ule"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
            className: (0, $2jatx.default)([
                "_4cvr1h6o _syaz1qc2 _1e0c1ule _10531kw7 _f8pj5hrz _30l35hrz _l8kux7w3",
                "title-card-link"
            ]),
            href: href,
            target: (0, $jQ0cd.isLocalizableHref)(href) ? '' : '_blank',
            rel: (0, $jQ0cd.isLocalizableHref)(href) ? '' : 'noreferrer',
            "aria-label": `${title}: ${content}`,
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-event-container": "globalNavSubnav",
            "data-product-key": productKey,
            style: {
                "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800')),
                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
            },
            children: [
                !!icon && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_6rth1mvu"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1ule _4cvrh9n0 _4t3i14no _1bsb14no",
                                "default-icon"
                            ]),
                            children: icon.normal
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1ule _4cvrh9n0 _4t3i14no _1bsb14no",
                                "_1e0cglyw",
                                "hover-icon"
                            ]),
                            children: icon.hover
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_vwz44jg8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _4cvr1h6o _1n261q9c _zulpi2wt _syaz1pfd _k48p1fw0 _10531kw7 _f8pj5hrz _30l35hrz _ect41vau _1wyboxwj _p7r1116y _t1edidpf _1v7x19bv _1aaynkob _cli0yu22 _9p8e1fw0 _1s16angw",
                        "titleCard-title"
                    ]),
                    style: {
                        "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                        "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                        "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                    },
                    children: [
                        title,
                        isNew && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3pg5Q.Pill), {
                            children: "New"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1wybjosm _vwz44jg8 _syaz1qc2 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48p1nn1 _1dyzidpf",
                        "titleCard-content"
                    ]),
                    style: {
                        "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800'))
                    },
                    children: content
                })
            ]
        })
    });
};
const $3e7e0535c18352cb$var$linkCardStyles = null;
const $3e7e0535c18352cb$export$2c381a86421d5abf = ({ href: href, text: text, productKey: productKey = 'home' })=>{
    const localizedHref = (0, $jQ0cd.useLocalizedHref)(href);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _19it1xhx _2rko1j6v _43ds1pfd _19tboxwj _1df31pfd"
        ]),
        style: {
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
            href: localizedHref,
            text: text,
            ariaLabel: text,
            type: "primary",
            dataEventProps: {
                'data-event': 'clicked',
                'data-event-component': 'linkButton',
                'data-event-container': 'globalNavSubnav',
                'data-product-key': productKey
            }
        })
    });
};

});

parcelRegister("jgdMW", function(module, exports) {
$parcel$export(module.exports, "RowGrid", function () { return $a79cb55f58fa05ed$export$29ae18f9ecc70243; });
/* row-grid.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $a79cb55f58fa05ed$export$29ae18f9ecc70243 = ({ children: children, numCols: numCols, colWidth: colWidth, numRows: numRows, rowHeight: rowHeight, rowGap: rowGap, columnGap: columnGap, paddingInline: paddingInline, paddingBlock: paddingBlock, marginInline: marginInline, marginBlock: marginBlock })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        style: {
            gridTemplateColumns: `${(colWidth ? `${colWidth} ` : '1fr ').repeat(numCols)}`,
            gridTemplateRows: `${numRows && (rowHeight ? `${rowHeight} ` : '1fr ').repeat(numRows)}`,
            rowGap: rowGap,
            columnGap: columnGap,
            paddingInline: paddingInline,
            paddingBlock: paddingBlock,
            marginInline: marginInline,
            marginBlock: marginBlock
        },
        className: (0, $2jatx.default)([
            "_1e0c11p5"
        ]),
        children: children
    });
};

});


parcelRegister("8DdYy", function(module, exports) {
$parcel$export(module.exports, "GlobalNavSolutionsDropdown", function () { return $a5ab63ea3778e91d$export$83f1e56729c29f53; });
/* global-nav-solutions-dropdown.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $jsxHL = parcelRequire("jsxHL");

var $8nFt2 = parcelRequire("8nFt2");

var $kxzNq = parcelRequire("kxzNq");

var $dzoWS = parcelRequire("dzoWS");

var $9KOR3 = parcelRequire("9KOR3");
function $a5ab63ea3778e91d$var$useNewSolutionLinks() {
    return {
        byUseCase: {
            id: 'byUseCase',
            title: (0, $fnHPc.defineMessage)({
                id: 'globalnavv2.subnav.teams.links.column.by-use-case',
                defaultMessage: 'By Use Case'
            }),
            items: [
                {
                    id: 'team-collaboration',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.teams.links.team-collaboration',
                        defaultMessage: 'Team collaboration'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/collections/teamwork')
                },
                {
                    id: 'strategy-and-planning',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.teams.links.strategy-and-planning',
                        defaultMessage: 'Strategy and planning'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/collections/strategy')
                },
                {
                    id: 'service-management',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.teams.links.service-management',
                        defaultMessage: 'Service management'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/collections/service')
                },
                {
                    id: 'software-development',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.teams.links.software-development',
                        defaultMessage: 'Software development'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/jira/dev')
                }
            ]
        },
        teamtype: {
            id: 'teamtype',
            title: (0, $fnHPc.defineMessage)({
                id: 'globalnavv2.subnav.teams.links.column.teamtype',
                defaultMessage: 'By Team'
            }),
            items: [
                {
                    id: 'software',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.teams.links.software',
                        defaultMessage: 'Software'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/jira/dev')
                },
                {
                    id: 'marketing',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.teams.links.marketing',
                        defaultMessage: 'Marketing'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/teams/marketing')
                },
                {
                    id: 'it',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.teams.links.it',
                        defaultMessage: 'IT'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/teams/it')
                },
                {
                    id: 'product-discovery-by-team',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.teams.links.product-discovery-by-team',
                        defaultMessage: 'Product'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/jira/product-discovery ')
                }
            ]
        },
        byTeamSize: {
            id: 'byTeamSize',
            title: (0, $fnHPc.defineMessage)({
                id: 'globalnavv2.subnav.teams.links.column.by-team-size',
                defaultMessage: 'By Size'
            }),
            items: [
                {
                    id: 'enterprise',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.teams.links.enterprise',
                        defaultMessage: 'Enterprise'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/enterprise')
                },
                {
                    id: 'small-business',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.teams.links.small-business',
                        defaultMessage: 'Small Business'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/small-business')
                },
                {
                    id: 'startup',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.teams.links.startup',
                        defaultMessage: 'Startup'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/startups')
                },
                {
                    id: 'non-profit',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.teams.links.non-profit',
                        defaultMessage: 'Non-profit'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/teams/nonprofits')
                }
            ]
        },
        byIndustry: {
            id: 'byIndustry',
            title: (0, $fnHPc.defineMessage)({
                id: 'globalnavv2.subnav.teams.links.column.by-industry',
                defaultMessage: 'By Industry'
            }),
            items: [
                {
                    id: 'retail',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.teams.links.retail',
                        defaultMessage: 'Retail'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/industries/retail')
                },
                {
                    id: 'telecommunications',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.teams.links.telecommunications',
                        defaultMessage: 'Telecommunications'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/industries/telecom')
                },
                {
                    id: 'professional-services',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.teams.links.professional-services',
                        defaultMessage: 'Professional Services'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/industries/professional-services')
                },
                {
                    id: 'government',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.teams.links.government',
                        defaultMessage: 'Government'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/government')
                }
            ]
        }
    };
}
const $a5ab63ea3778e91d$export$83f1e56729c29f53 = ({ productKey: productKey = 'home' })=>{
    const intl = (0, $8e22h.default)();
    const { direction: direction } = (0, $9KOR3.useGlobalNavContext)();
    const newSolutionsLinks = $a5ab63ea3778e91d$var$useNewSolutionLinks();
    const newGlobalNavDropdownLinkColumns = Object.values(newSolutionsLinks);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.DivOnHoverExit), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_tl28idpf _axwiidpf _1hwcidpf _sp8tidpf _12rrp2n4"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0cglyw _ect41vau _1wyboqnp _1p1dangw _18s8gx6n _1mjb1ule",
                            "mobile-label"
                        ]),
                        style: {
                            "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                        },
                        children: intl.formatMessage({
                            id: 'GlobalNav.collections.solutions.mobilelabel',
                            defaultMessage: 'Solutions'
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $8nFt2.MotionContainer), {
                        direction: direction,
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_bfhkg7ng _1e0c11p5 _yv0e1ajj _zulp1ejb _18zr1jfw _1rjc1jfw _xc2ize3t _1bhlze3t _1ph4hkll _xlt1xy5q _uk5u1afi",
                                    "new-solutions-bottom"
                                ]),
                                style: {
                                    "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100')),
                                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                                },
                                children: newGlobalNavDropdownLinkColumns.map((column)=>{
                                    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $dzoWS.GlobalNavDropdownLinkColumn), {
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.GlobalNavEyebrow), {
                                                removeMargin: true,
                                                children: intl.formatMessage(column.title)
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1e0c11p5 _2z051wug"
                                                ]),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                                                    className: (0, $2jatx.default)([
                                                        "_2mzuglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0q14y2 _u5f3idpf _n3tdidpf _19bvidpf _144to7ao"
                                                    ]),
                                                    children: column.items.map((link)=>{
                                                        return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                                            className: (0, $2jatx.default)([
                                                                "_2mzuglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qftgi _u5f3idpf _n3tdftgi _19bvidpf"
                                                            ]),
                                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                                className: (0, $2jatx.default)([
                                                                    "_bpsp1nn1 _19tboxwj _43ds1pfd _qfs11r31 _s41oglyw _1k6pnqa1 _1cay1pfd _oavv5hrz _oxk45hrz _1byu5hrz _1o7v5hrz _1e0c1txw _4cvrh9n0"
                                                                ]),
                                                                style: {
                                                                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                                                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                                                },
                                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                                                    type: "anchor",
                                                                    href: link.href,
                                                                    text: intl.formatMessage(link.text),
                                                                    "aria-label": intl.formatMessage(link.text),
                                                                    ariaLabel: intl.formatMessage(link.text),
                                                                    dataEventProps: {
                                                                        'data-event': 'clicked',
                                                                        'data-event-component': 'linkButton',
                                                                        'data-event-container': 'globalNavSubnav',
                                                                        'data-product-key': productKey
                                                                    }
                                                                })
                                                            }, link.id)
                                                        }, link.id);
                                                    })
                                                })
                                            })
                                        ]
                                    }, column.id);
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kxzNq.RovoSection), {})
                        ]
                    })
                ]
            })
        })
    });
};
const $a5ab63ea3778e91d$var$SolutionsContainerCSS = null;
const $a5ab63ea3778e91d$var$CollectionsMobileLabelCSS = null;
const $a5ab63ea3778e91d$var$CollectionsSolutionsBottomCSS = null;

});

parcelRegister("gisLk", function(module, exports) {
$parcel$export(module.exports, "useWhyAtlassianData", function () { return $605916ba887f51fd$export$e75d7d5034191e1; });
$parcel$export(module.exports, "GlobalNavWhyAtlassianDropdown", function () { return $605916ba887f51fd$export$f7682c439485f779; });
/* global-nav-why-atlassian-dropdown.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $jQ0cd = parcelRequire("jQ0cd");

var $jsxHL = parcelRequire("jsxHL");

var $MV9vM = parcelRequire("MV9vM");

var $8nFt2 = parcelRequire("8nFt2");

var $9KOR3 = parcelRequire("9KOR3");
function $605916ba887f51fd$export$e75d7d5034191e1() {
    const intl = (0, $8e22h.default)();
    return [
        {
            title: intl.formatMessage({
                id: 'globalnavv2.subnav.whyatlassian.systemofwork.title',
                defaultMessage: 'System of Work'
            }),
            content: intl.formatMessage({
                id: 'globalnavv2.subnav.whyatlassian.systemofwork.content',
                defaultMessage: "Atlassian's blueprint for how teams work together"
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/system-of-work')
        },
        {
            title: intl.formatMessage({
                id: 'globalnavv2.subnav.whyatlassian.ecosystem.title',
                defaultMessage: 'Ecosystem'
            }),
            content: intl.formatMessage({
                id: 'globalnavv2.subnav.whyatlassian.ecosystem.content',
                defaultMessage: 'Connect tools, teams, and agents into one intelligent system of work'
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/ecosystem'),
            isNew: true
        },
        {
            title: intl.formatMessage({
                id: 'globalnavv2.subnav.whyatlassian.integrations.title',
                defaultMessage: 'Marketplace'
            }),
            content: intl.formatMessage({
                id: 'globalnavv2.subnav.whyatlassian.integrations.content',
                defaultMessage: 'Connect thousands of apps to your Atlassian products'
            }),
            href: '//marketplace.atlassian.com/'
        },
        {
            title: intl.formatMessage({
                id: 'globalnavv2.subnav.whyatlassian.customers.title',
                defaultMessage: 'Customers'
            }),
            content: intl.formatMessage({
                id: 'globalnavv2.subnav.whyatlassian.customers.content',
                defaultMessage: 'Case studies & stories powered by teamwork'
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/customers')
        },
        {
            title: 'FedRAMP',
            content: intl.formatMessage({
                id: 'globalnavv2.subnav.whyatlassian.fedramp.content',
                defaultMessage: 'Compliant solutions for the public sector'
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/trust/compliance/resources/fedramp')
        },
        {
            title: intl.formatMessage({
                id: 'globalnavv2.subnav.whyatlassian.resilience.title',
                defaultMessage: 'Resilience'
            }),
            content: intl.formatMessage({
                id: 'globalnavv2.subnav.whyatlassian.resilience.content',
                defaultMessage: 'Enterprise-grade & highly performant infrastructure'
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/trust/resilience')
        },
        {
            title: intl.formatMessage({
                id: 'globalnavv2.subnav.whyatlassian.platform.title',
                defaultMessage: 'Platform'
            }),
            content: intl.formatMessage({
                id: 'globalnavv2.subnav.whyatlassian.platform.content',
                defaultMessage: 'Our deeply integrated, reliable & secure platform'
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/platform')
        },
        {
            title: intl.formatMessage({
                id: 'globalnavv2.subnav.whyatlassian.trustcenter.title',
                defaultMessage: 'Trust center'
            }),
            content: intl.formatMessage({
                id: 'globalnavv2.subnav.whyatlassian.trustcenter.content',
                defaultMessage: "Ensure your data's security, compliance & availability"
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/trust')
        }
    ];
}
const $605916ba887f51fd$var$WhyAtlassianGrid = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _yv0e1ajj _1p571jfw _gy1pxy5q _1rjc1jfw _18zr1jfw _2mzuglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ]),
        children: children
    });
};
const $605916ba887f51fd$export$f7682c439485f779 = ({ productKey: productKey = 'home' })=>{
    const teamsData = $605916ba887f51fd$export$e75d7d5034191e1();
    const { direction: direction } = (0, $9KOR3.useGlobalNavContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.DivOnHoverExit), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8nFt2.MotionContainer), {
                direction: direction,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($605916ba887f51fd$var$WhyAtlassianGrid, {
                    children: teamsData.map(({ title: title, ...rest })=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $MV9vM.TitleCard), {
                                title: title,
                                ...rest,
                                productKey: productKey
                            }, title)
                        }, title))
                })
            })
        })
    });
};

});

parcelRegister("3hAMp", function(module, exports) {
$parcel$export(module.exports, "GlobalNavMobileMenu", function () { return $1cab40d3a0528704$export$f9ef5f8ab01a323b; });
/* global-nav-mobile-menu.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $clnBI = parcelRequire("clnBI");

var $59F4T = parcelRequire("59F4T");

var $jQ0cd = parcelRequire("jQ0cd");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $5yuBp = parcelRequire("5yuBp");

var $5X1Oi = parcelRequire("5X1Oi");

var $kNyc7 = parcelRequire("kNyc7");

var $aTTHV = parcelRequire("aTTHV");

var $atJnX = parcelRequire("atJnX");

var $8DdYy = parcelRequire("8DdYy");

var $3R5TL = parcelRequire("3R5TL");

var $2a9sZ = parcelRequire("2a9sZ");

var $lB6jo = parcelRequire("lB6jo");

var $czCwT = parcelRequire("czCwT");

var $7LWkZ = parcelRequire("7LWkZ");

var $h3FQ3 = parcelRequire("h3FQ3");

var $4ytX0 = parcelRequire("4ytX0");

var $gdkcl = parcelRequire("gdkcl");

var $c0gDI = parcelRequire("c0gDI");
const $1cab40d3a0528704$var$shownInnerMobileDropdownMenuStyle = null;
const $1cab40d3a0528704$var$hiddenInnerMobileDropdownMenuStyle = null;
const $1cab40d3a0528704$var$slideInLeftKeyframes = null;
const $1cab40d3a0528704$var$slideInDown = null;
const $1cab40d3a0528704$var$slideInUp = null;
const $1cab40d3a0528704$var$slideInRight = null;
/**
 * Design asks for at least 32px between the search field and the CTA; the
 * menu's own top margin supplies the rest. The bottom padding gives the
 * PRODUCTS label below the same clearance. `ContactSalesCta` renders nothing
 * for most users, so the wrapper collapses when empty rather than leaving a
 * blank gap under the search field.
 */ const $1cab40d3a0528704$var$contactSalesCtaContainerCss = null;
const $1cab40d3a0528704$var$defaultInnerMenuCss = null;
const $1cab40d3a0528704$var$slideInLeftCss = null;
const $1cab40d3a0528704$var$slideInDownCss = null;
const $1cab40d3a0528704$var$slideInUpCss = null;
const $1cab40d3a0528704$var$slideInRightCss = null;
const $1cab40d3a0528704$var$backButtonCss = null;
const $1cab40d3a0528704$var$MobileGlobalNavDropdownMenu = ({ isUserLoggedIn: isUserLoggedIn, menuPage: menuPage = 'default', firstOpen: firstOpen, mobileLinksSections: mobileLinksSections, handleMenuPage: handleMenuPage, handleFirstOpen: handleFirstOpen, productKey: productKey = 'home' })=>{
    const intl = (0, $8e22h.default)();
    const isNavigatingBackRef = (0, $1oC0p.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const isMobile = (0, $5yuBp.useIsMobile)();
    const isAiTabEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).team26EuRefresh);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            menuPage === 'default' && isMobile ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1q511tcg",
                    isNavigatingBackRef.current && "",
                    isNavigatingBackRef.current && "_tzy4idpf _y44v1s1a"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kNyc7.default), {
                    isMobileView: true,
                    readOnly: true,
                    parentType: "GlobalNav",
                    menuPage: menuPage,
                    fullWidth: true,
                    onFocus: ()=>{
                        if (!isNavigatingBackRef.current) handleMenuPage('search');
                        createAnalyticsEvent({
                            eventName: 'searchOpen',
                            eventType: 'ui',
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'searchButtonMobileV2',
                            source: 'globalNav',
                            attributes: {
                                product: 'marketing',
                                pageUrl: window.location.href,
                                pagePath: window.location.pathname
                            }
                        }).fire();
                    }
                }, "default-search-bar")
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {}),
            (menuPage === 'resources' || menuPage === 'product-everyone' || menuPage === 'product-developer' || menuPage === 'product-product-managers' || menuPage === 'product-it-professionals' || menuPage === 'product-business-teams' || menuPage === 'product-leadership-teams' || menuPage === 'solutions' || menuPage === 'ai' || menuPage === 'why-atlassian') && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulpu2gc _ahbq1b66 _1pfhu2gc _6rthu2gc _1ywm1ejb"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                    style: {
                        all: 'unset',
                        width: 'fit-content'
                    },
                    onClick: (e)=>{
                        e.preventDefault();
                        e.stopPropagation();
                        isNavigatingBackRef.current = true;
                        handleFirstOpen(false);
                        handleMenuPage('default');
                        // reset the flag after navigation
                        setTimeout(()=>{
                            isNavigatingBackRef.current = false;
                        }, 100);
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_y44voibr",
                            "_syaz6x5g _1e0c1txw _4cvr1h6o"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($clnBI))), {
                                label: "",
                                spacing: "spacious"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                children: intl.formatMessage({
                                    id: 'globalnavv2.menu-back',
                                    defaultMessage: 'Back'
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_tzy4idpf _v564g4i2 _15qekb7n _1uewkb7n",
                    !firstOpen && "",
                    !firstOpen && "_y44vobx7",
                    !firstOpen && "",
                    !firstOpen && "_y44voibr",
                    menuPage === 'default' ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    `firstopen inner-mobile-dropdown-menu ${firstOpen ? 'fade-in' : 'slide-in-left'}`
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1q511ejb _85i5v47k _fiawglyw"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aTTHV.ContactSalesCta), {
                            isFullWidth: true
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3R5TL.MobileNavLinks), {
                        isLoggedIn: isUserLoggedIn,
                        handleMenuPage: handleMenuPage,
                        mobileLinksSections: mobileLinksSections,
                        productKey: productKey,
                        isShowContactSalesCta: false
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y44vobx7",
                    menuPage === 'product-everyone' ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    "product-everyone-inner inner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $atJnX.GlobalNavFeaturedCollectionDropdown), {
                    isMobile: true
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y44vobx7",
                    menuPage === 'product-developer' ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    "product-developer-inner inner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $czCwT.MobileNavProductDevelopers), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y44vobx7",
                    menuPage === 'product-product-managers' ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    "product-managers-inner inner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4ytX0.MobileNavProductProductManagers), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y44vobx7",
                    menuPage === 'product-it-professionals' ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    "inner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7LWkZ.MobileNavProductITProfessionals), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y44vobx7",
                    menuPage === 'product-business-teams' ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    "inner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lB6jo.MobileNavProductBusinessTeams), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y44vobx7",
                    menuPage === 'product-leadership-teams' ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    "inner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $h3FQ3.MobileNavProductLeadershipTeams), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y44vobx7",
                    menuPage === 'teams' || menuPage === 'solutions' ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    "inner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8DdYy.GlobalNavSolutionsDropdown), {})
            }),
            isAiTabEnabled && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y44vobx7",
                    menuPage === 'ai' ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    "inner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5X1Oi.AiContent), {
                    productKey: productKey
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y44vobx7",
                    menuPage === 'why-atlassian' ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    "inner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $c0gDI.MobileNavWhyAtlassian), {
                    productKey: productKey
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y44vobx7",
                    menuPage === 'resources' ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    "inner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gdkcl.MobileNavResources), {
                    productKey: productKey
                })
            }),
            menuPage === 'search' && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    menuPage === 'search' ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    "searchpageinnermenuinner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                            style: {
                                all: 'unset',
                                width: 'fit-content'
                            },
                            onClick: (e)=>{
                                e.preventDefault();
                                e.stopPropagation();
                                isNavigatingBackRef.current = true;
                                handleFirstOpen(false);
                                handleMenuPage('default');
                                // reset the flag after navigation
                                setTimeout(()=>{
                                    isNavigatingBackRef.current = false;
                                }, 100);
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_y44voibr",
                                    "_syaz6x5g _1e0c1txw _4cvr1h6o _1q517vkz"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($clnBI))), {
                                        label: "",
                                        spacing: "spacious"
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        children: intl.formatMessage({
                                            id: 'globalnavv2.menu-back',
                                            defaultMessage: 'Back'
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_tzy4idpf _y44v8blq"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kNyc7.default), {
                                isMobileView: true,
                                parentType: "GlobalNav",
                                menuPage: menuPage,
                                fullWidth: true
                            }, "search-page-search-bar")
                        })
                    ]
                })
            }, "search-page")
        ]
    });
};
const $1cab40d3a0528704$export$f9ef5f8ab01a323b = ({ productKey: productKey, state: state })=>{
    const intl = (0, $8e22h.default)();
    const { userInfo: userInfo, showMenu: showMenu, isDisplayLoggedInUseDropdown: isDisplayLoggedInUseDropdown, firstOpen: firstOpen, menuPage: menuPage, handleToggleMenu: handleToggleMenu, handleFirstOpen: handleFirstOpen, handleMenuPage: handleMenuPage } = state;
    const { onSwitchAccountClick: onSwitchAccountClick, onManageProfileClick: onManageProfileClick, onManageLicensesClick: onManageLicensesClick, onLogOutClick: onLogOutClick } = (0, $59F4T.useGlobalNavUserProfileClickActions)({
        email: userInfo.email
    });
    const teamsText = intl.formatMessage({
        id: 'globalNavigation.Navlink.solutions',
        defaultMessage: 'Solutions'
    });
    const teamsKeyAndDropdownType = 'solutions';
    const isAiTabEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).team26EuRefresh);
    const mobileLinksSections = [
        {
            mobileLinkKey: 'product-nav-links',
            isIncludeBottomDivider: true,
            mobileLinksProps: [
                {
                    globalLinksKey: 'products',
                    linkText: intl.formatMessage({
                        id: 'globalnavv2.navlink.products',
                        defaultMessage: 'Products'
                    }),
                    hasDropdown: false
                },
                {
                    globalLinksKey: 'everyone',
                    linkText: intl.formatMessage({
                        id: 'globalnavv2.navlink.featured',
                        defaultMessage: 'Featured'
                    }),
                    hasDropdown: true,
                    dropdownType: 'product-everyone'
                },
                {
                    globalLinksKey: 'developers',
                    linkText: intl.formatMessage({
                        id: 'globalnavv2.navlink.developers',
                        defaultMessage: 'Developers'
                    }),
                    hasDropdown: true,
                    dropdownType: 'product-developer'
                },
                {
                    globalLinksKey: 'productmanagers',
                    linkText: intl.formatMessage({
                        id: 'globalnavv2.navlink.productmanagers',
                        defaultMessage: 'Product Managers'
                    }),
                    hasDropdown: true,
                    dropdownType: 'product-product-managers'
                },
                {
                    globalLinksKey: 'itprofessionals',
                    linkText: intl.formatMessage({
                        id: 'globalnavv2.navlink.itprofessionals',
                        defaultMessage: 'IT professionals'
                    }),
                    hasDropdown: true,
                    dropdownType: 'product-it-professionals'
                },
                {
                    globalLinksKey: 'businessteams',
                    linkText: intl.formatMessage({
                        id: 'globalnavv2.navlink.businessteams',
                        defaultMessage: 'Business Teams'
                    }),
                    hasDropdown: true,
                    dropdownType: 'product-business-teams'
                },
                {
                    globalLinksKey: 'leadershipteams',
                    linkText: intl.formatMessage({
                        id: 'globalnavv2.navlink.leadershipteams',
                        defaultMessage: 'Leadership Teams'
                    }),
                    hasDropdown: true,
                    dropdownType: 'product-leadership-teams'
                }
            ]
        },
        {
            mobileLinkKey: 'other-nav-links',
            mobileLinksProps: [
                ...isAiTabEnabled ? [
                    {
                        globalLinksKey: 'ai',
                        linkText: intl.formatMessage({
                            id: 'globalnavv2.navlink.ai',
                            defaultMessage: 'AI'
                        }),
                        hasDropdown: true,
                        dropdownType: 'ai'
                    }
                ] : [],
                {
                    globalLinksKey: teamsKeyAndDropdownType,
                    linkText: teamsText,
                    hasDropdown: true,
                    dropdownType: teamsKeyAndDropdownType
                },
                {
                    globalLinksKey: 'why-atlassian',
                    linkText: intl.formatMessage({
                        id: 'globalnavv2.navlink.whyAtlassian',
                        defaultMessage: 'Why Atlassian'
                    }),
                    hasDropdown: true,
                    dropdownType: 'why-atlassian'
                },
                {
                    globalLinksKey: 'resources',
                    linkText: intl.formatMessage({
                        id: 'globalnavv2.navlink.resources',
                        defaultMessage: 'Resources'
                    }),
                    hasDropdown: true,
                    dropdownType: 'resources'
                },
                {
                    globalLinksKey: 'enterprise',
                    linkText: intl.formatMessage({
                        id: 'globalnavv2.navlink.enterprise',
                        defaultMessage: 'Enterprise'
                    }),
                    hasDropdown: false,
                    href: (0, $jQ0cd.useLocalizedHref)('/enterprise')
                }
            ]
        }
    ];
    return isDisplayLoggedInUseDropdown ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2a9sZ.default), {
        userInfo: {
            displayName: userInfo.name || '',
            email: userInfo.email || '',
            avatar: userInfo.picture || ''
        },
        onLogOutClick: onLogOutClick,
        onManageLicensesClick: onManageLicensesClick,
        onManageProfileClick: onManageProfileClick,
        onSwitchAccountClick: onSwitchAccountClick
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)($1cab40d3a0528704$var$MobileGlobalNavDropdownMenu, {
        showMenu: showMenu,
        isUserLoggedIn: userInfo.isUserLoggedIn,
        menuPage: menuPage,
        firstOpen: firstOpen,
        mobileLinksSections: mobileLinksSections,
        handleToggleMenu: handleToggleMenu,
        handleMenuPage: handleMenuPage,
        handleFirstOpen: handleFirstOpen,
        productKey: productKey
    });
};

});
parcelRegister("lB6jo", function(module, exports) {
$parcel$export(module.exports, "MobileNavProductBusinessTeams", function () { return $40485381a52c82a8$export$6a303a69999cf50c; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $3pg5Q = parcelRequire("3pg5Q");

var $jbgN3 = parcelRequire("jbgN3");
const $40485381a52c82a8$export$6a303a69999cf50c = ()=>{
    const intl = (0, $8e22h.default)();
    const { productsByTag: productsByTag } = (0, $3pg5Q.useProductData)();
    const businessTeamsProducts = productsByTag[(0, $3pg5Q.ProductCategory).BusinessTeams] || [];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jbgN3.MobileNavTitle), {
                title: intl.formatMessage((0, $3pg5Q.categories)[(0, $3pg5Q.ProductCategory).BusinessTeams].title)
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3pg5Q.ProductGrid), {
                children: businessTeamsProducts.map((product)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $3pg5Q.ProductItem), {
                        ...product,
                        currentCategory: (0, $3pg5Q.ProductCategory).BusinessTeams
                    }, product.id))
            })
        ]
    });
};

});

parcelRegister("czCwT", function(module, exports) {
$parcel$export(module.exports, "MobileNavProductDevelopers", function () { return $d9f0265905ee4b3a$export$d2e2cabc7ee48967; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $3pg5Q = parcelRequire("3pg5Q");

var $jbgN3 = parcelRequire("jbgN3");
const $d9f0265905ee4b3a$export$d2e2cabc7ee48967 = ()=>{
    const intl = (0, $8e22h.default)();
    const { productsByTag: productsByTag } = (0, $3pg5Q.useProductData)();
    const developersProducts = productsByTag[(0, $3pg5Q.ProductCategory).Developers] || [];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jbgN3.MobileNavTitle), {
                title: intl.formatMessage((0, $3pg5Q.categories)[(0, $3pg5Q.ProductCategory).Developers].title)
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3pg5Q.ProductGrid), {
                children: developersProducts.map((product)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $3pg5Q.ProductItem), {
                        ...product,
                        currentCategory: (0, $3pg5Q.ProductCategory).Developers
                    }, product.id))
            })
        ]
    });
};

});

parcelRegister("7LWkZ", function(module, exports) {
$parcel$export(module.exports, "MobileNavProductITProfessionals", function () { return $7da55e49b2d9a409$export$a00033f672d28a41; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $3pg5Q = parcelRequire("3pg5Q");

var $jbgN3 = parcelRequire("jbgN3");
const $7da55e49b2d9a409$export$a00033f672d28a41 = ()=>{
    const intl = (0, $8e22h.default)();
    const { productsByTag: productsByTag } = (0, $3pg5Q.useProductData)();
    const itProfessionalsProducts = productsByTag[(0, $3pg5Q.ProductCategory).ITProfessionals] || [];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jbgN3.MobileNavTitle), {
                title: intl.formatMessage((0, $3pg5Q.categories)[(0, $3pg5Q.ProductCategory).ITProfessionals].title)
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3pg5Q.ProductGrid), {
                children: itProfessionalsProducts.map((product)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $3pg5Q.ProductItem), {
                        ...product,
                        currentCategory: (0, $3pg5Q.ProductCategory).ITProfessionals
                    }, product.id))
            })
        ]
    });
};

});

parcelRegister("h3FQ3", function(module, exports) {
$parcel$export(module.exports, "MobileNavProductLeadershipTeams", function () { return $dc93b8153816ca1e$export$8f7556a31a879079; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $3pg5Q = parcelRequire("3pg5Q");

var $jbgN3 = parcelRequire("jbgN3");
const $dc93b8153816ca1e$export$8f7556a31a879079 = ()=>{
    const intl = (0, $8e22h.default)();
    const { productsByTag: productsByTag } = (0, $3pg5Q.useProductData)();
    const leadershipTeamsProducts = productsByTag[(0, $3pg5Q.ProductCategory).LeadershipTeams] || [];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jbgN3.MobileNavTitle), {
                title: intl.formatMessage((0, $3pg5Q.categories)[(0, $3pg5Q.ProductCategory).LeadershipTeams].title)
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3pg5Q.ProductGrid), {
                children: leadershipTeamsProducts.map((product)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $3pg5Q.ProductItem), {
                        ...product,
                        currentCategory: (0, $3pg5Q.ProductCategory).LeadershipTeams
                    }, product.id))
            })
        ]
    });
};

});

parcelRegister("4ytX0", function(module, exports) {
$parcel$export(module.exports, "MobileNavProductProductManagers", function () { return $87bdf77bd7bccf06$export$8bcbf0310429d54d; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $3pg5Q = parcelRequire("3pg5Q");

var $jbgN3 = parcelRequire("jbgN3");
const $87bdf77bd7bccf06$export$8bcbf0310429d54d = ()=>{
    const intl = (0, $8e22h.default)();
    const { productsByTag: productsByTag } = (0, $3pg5Q.useProductData)();
    const productManagersProducts = productsByTag[(0, $3pg5Q.ProductCategory).ProductManagers] || [];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jbgN3.MobileNavTitle), {
                title: intl.formatMessage((0, $3pg5Q.categories)[(0, $3pg5Q.ProductCategory).ProductManagers].title)
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3pg5Q.ProductGrid), {
                children: productManagersProducts.map((product)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $3pg5Q.ProductItem), {
                        ...product,
                        currentCategory: (0, $3pg5Q.ProductCategory).ProductManagers
                    }, product.id))
            })
        ]
    });
};

});

parcelRegister("gdkcl", function(module, exports) {
$parcel$export(module.exports, "MobileNavResources", function () { return $1ab13b0899c10eab$export$83bd5439901f0f7f; });
/* mobile-nav-resources.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $MV9vM = parcelRequire("MV9vM");

var $Q3GOe = parcelRequire("Q3GOe");

var $jbgN3 = parcelRequire("jbgN3");
const $1ab13b0899c10eab$var$mobileLinkListCss = null;
const $1ab13b0899c10eab$export$83bd5439901f0f7f = ({ productKey: productKey = 'home' })=>{
    const intl = (0, $8e22h.default)();
    const resourcesData = (0, $Q3GOe.useResourcesData)();
    const resourcesLinks = (0, $Q3GOe.useResourcesLinks)();
    const linkColumns = Object.values(resourcesLinks);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jbgN3.MobileNavTitle), {
                title: intl.formatMessage({
                    id: 'globalnav.v2.resources.title',
                    defaultMessage: 'Resources'
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                children: resourcesData.map(({ id: id, title: title, content: content, ...rest })=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $MV9vM.TitleCard), {
                            title: intl.formatMessage(title),
                            content: intl.formatMessage(content),
                            productKey: productKey,
                            ...rest
                        })
                    }, id))
            }),
            linkColumns.map((section)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_11q7g7ng _18s8urp9 _1yt4xy5q"
                    ]),
                    style: {
                        "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            style: {
                                margin: 0,
                                textTransform: 'uppercase',
                                fontSize: '0.75rem'
                            },
                            children: intl.formatMessage(section.title)
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                            className: (0, $2jatx.default)([
                                "_2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _e3ub1bpf"
                            ]),
                            children: section.items.map((link)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                        type: "anchor",
                                        href: link.href,
                                        text: intl.formatMessage(link.text),
                                        ariaLabel: intl.formatMessage(link.text),
                                        dataEventProps: {
                                            'data-event': 'clicked',
                                            'data-event-component': 'linkButton',
                                            'data-event-container': 'globalNavSubnav',
                                            'data-product-key': productKey
                                        }
                                    })
                                }, link.id))
                        })
                    ]
                }, section.id))
        ]
    });
};

});

parcelRegister("c0gDI", function(module, exports) {
$parcel$export(module.exports, "MobileNavWhyAtlassian", function () { return $50c76f65d5751cef$export$15a36ea830bd3411; });
/* mobile-nav-why-atlassian.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $MV9vM = parcelRequire("MV9vM");

var $gisLk = parcelRequire("gisLk");

var $jbgN3 = parcelRequire("jbgN3");
const $50c76f65d5751cef$var$mobileWhyAtlassianGridCss = null;
const $50c76f65d5751cef$export$15a36ea830bd3411 = ({ productKey: productKey = 'home' })=>{
    const intl = (0, $8e22h.default)();
    const whyAtlassianData = (0, $gisLk.useWhyAtlassianData)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jbgN3.MobileNavTitle), {
                title: intl.formatMessage({
                    id: 'globalnav.v2.whyatlassian.title',
                    defaultMessage: 'Why Atlassian'
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulpidpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                ]),
                children: whyAtlassianData.map(({ title: title, ...rest })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $MV9vM.TitleCard), {
                        title: title,
                        ...rest,
                        productKey: productKey
                    }, title))
            })
        ]
    });
};

});


parcelRegister("igXd8", function(module, exports) {
$parcel$export(module.exports, "CompoundSubNav", function () { return $6052244f048f0d1c$export$2e7b57b2b3287680; });
/* nav-global-compound-subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $clnBI = parcelRequire("clnBI");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $3PWZ2 = parcelRequire("3PWZ2");

var $4Rcm1 = parcelRequire("4Rcm1");

var $9KOR3 = parcelRequire("9KOR3");
const $6052244f048f0d1c$var$compoundSubNavPadding = "var(--ds-space-100, 8px)";
const $6052244f048f0d1c$var$linkableCompoundSubNavTitleStyle = null;
const $6052244f048f0d1c$export$2e7b57b2b3287680 = ({ compoundSubNavTitle: compoundSubNavTitle, compoundSubNavLinksProps: compoundSubNavLinksProps, productKey: productKey = 'home', optionalClassName: optionalClassName = '', compoundSubNavTitleHref: compoundSubNavTitleHref = '' })=>{
    const compoundSubNavStyle = null;
    const compoundSubNavBarStyle = null;
    const compoundSubNavTitleStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("nav", {
        "aria-label": compoundSubNavTitle,
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _bfhk1afi _4t3i18pe _18zru2gc _d2ik1n1m _exxmnatz _kjzlu23k _vqaqu23k _12z714n7 _qc27idpf _rbmh1g6m",
            `compoundSubNav ${optionalClassName}`
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_eiqaqt": (0, $6ZVlx.default)((0, $4Rcm1.navLayout).height),
            "--_1mhfb35": (0, $6ZVlx.default)((0, $4Rcm1.navLayout).outerInset),
            "--_17s1s73": (0, $6ZVlx.default)((0, $4Rcm1.navGrid).compoundEndInset),
            "--_84k7f0": (0, $6ZVlx.default)((0, $4Rcm1.navLayout).menuItemPadding),
            "--_x0psmk": (0, $6ZVlx.default)((0, $4Rcm1.navGrid).compoundStartInsetWide),
            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_4cvr1h6o _1bah1yb4 _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx2vrvc _kqswh2mm _1bsb1osq _p12ftfvk _18zru2gc _owpuidpf _10jxglyw",
                "compoundSubNavBar"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_4bfu1r31 _1hmsglyw _ajmmnqa1 _k48p1fw0 _1wybgktf _vwz4gktf _1o9zidpf _o5721q9c _bozgu2gc _d2ikidpf",
                        "compoundSubNavTitle"
                    ]),
                    children: [
                        compoundSubNavTitleHref && /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            href: compoundSubNavTitleHref,
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-event-container": "navbar",
                            "data-label": compoundSubNavTitle,
                            "data-product-key": productKey,
                            className: (0, $2jatx.default)([
                                "_f8pj5hrz _30l35hrz _1ien5hrz _n0fx5hrz"
                            ]),
                            style: {
                                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                            },
                            children: compoundSubNavTitle
                        }),
                        compoundSubNavTitleHref.length === 0 && compoundSubNavTitle
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)($6052244f048f0d1c$var$CompoundSubNavLinks, {
                    compoundSubNavLinksProps: compoundSubNavLinksProps,
                    productKey: productKey
                })
            ]
        })
    });
};
$6052244f048f0d1c$export$2e7b57b2b3287680.displayName = 'CompoundSubNav';
const $6052244f048f0d1c$var$CompoundSubNavLinks = ({ compoundSubNavLinksProps: compoundSubNavLinksProps, productKey: productKey = 'home' })=>{
    const linksContainerWrapperStyle = null;
    const linksContainerStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx2vrvc _1bsb1osq _4t3i1osq _kqswh2mm _4cvr1h6o _1bahesu3 _msup1yb4",
            "compoundSubNavLinksContainer"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_4t3i1osq _bozgu2gc _1e0cglyw _dm251ule _d2ikidpf",
                    "compoundSubNavLinks"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.default), {
                    globalLinksProps: compoundSubNavLinksProps,
                    isCompoundSubnav: true
                })
            }),
            compoundSubNavLinksProps.length > 0 && /*#__PURE__*/ (0, $7VQPk.jsx)($6052244f048f0d1c$var$CompoundSubNavDropdownLinks, {
                compoundSubNavLinksProps: compoundSubNavLinksProps,
                productKey: productKey
            })
        ]
    });
};
const $6052244f048f0d1c$var$CompoundSubNavDropdownLinks = ({ compoundSubNavLinksProps: compoundSubNavLinksProps, productKey: productKey = 'home' })=>{
    const dropdownContentStyle = null;
    const [isOpen, setIsOpen] = (0, $1oC0p.useState)(false);
    const [onCaretButton, setOnCaretButton] = (0, $1oC0p.useState)(false);
    const [activeDropdownKey, setActiveDropdownKey] = (0, $1oC0p.useState)(null);
    const intl = (0, $8e22h.default)();
    const menuId = (0, $1oC0p.useId)();
    const dropdownRef = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useLayoutEffect)(()=>{
        const panel = dropdownRef.current;
        if (!isOpen || !panel) return;
        const updateHeight = ()=>{
            const viewport = window.visualViewport;
            const bottom = viewport ? viewport.offsetTop + viewport.height : document.documentElement.clientHeight;
            panel.style.setProperty('--compound-nav-dropdown-height', `${Math.max(0, bottom - panel.getBoundingClientRect().top)}px`);
        };
        updateHeight();
        const observer = new ResizeObserver(updateHeight);
        const nav = panel.closest('nav');
        if (nav) observer.observe(nav);
        window.addEventListener('resize', updateHeight);
        window.addEventListener('scroll', updateHeight, {
            passive: true
        });
        window.visualViewport?.addEventListener('resize', updateHeight);
        window.visualViewport?.addEventListener('scroll', updateHeight);
        return ()=>{
            observer.disconnect();
            window.removeEventListener('resize', updateHeight);
            window.removeEventListener('scroll', updateHeight);
            window.visualViewport?.removeEventListener('resize', updateHeight);
            window.visualViewport?.removeEventListener('scroll', updateHeight);
        };
    }, [
        isOpen
    ]);
    const backButtonRef = (0, $1oC0p.useRef)(null);
    const activeDropdown = compoundSubNavLinksProps.find((link)=>link.globalLinksKey === activeDropdownKey);
    const handleEscKeyEvent = (0, $1oC0p.useCallback)((event)=>{
        if (event.key === 'Escape') {
            setIsOpen(false);
            setActiveDropdownKey(null);
        }
    }, []);
    const handleClickOutside = (0, $1oC0p.useCallback)((event)=>{
        if (isOpen && !dropdownRef.current?.contains(event.target) && !onCaretButton) {
            setIsOpen(false);
            setActiveDropdownKey(null);
        }
    }, [
        isOpen,
        onCaretButton
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (activeDropdownKey) backButtonRef.current?.focus();
    }, [
        activeDropdownKey
    ]);
    (0, $1oC0p.useEffect)(()=>{
        // Attach the listeners on component mount.
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleEscKeyEvent, false);
        // Detach the listeners on component unmount.
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscKeyEvent, false);
        };
    }, [
        handleEscKeyEvent,
        handleClickOutside
    ]);
    const linkClickAction = (e)=>{
        e.preventDefault();
        setIsOpen((prevIsOpen)=>{
            if (prevIsOpen) setActiveDropdownKey(null);
            return !prevIsOpen;
        });
    };
    const rotate180deg = null;
    const fadeOutKeyframes = null;
    const fadeOutAnimation = null;
    const tabletDropdownGap = "var(--ds-space-100, 8px)";
    const tabletDropdownTopGap = "var(--ds-space-050, 4px)";
    const tabletDropdownHeight = `var(--compound-nav-dropdown-height, calc(100dvh - 136px - ${tabletDropdownTopGap}))`;
    const dropdownContainerStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1ule _bozg1n1m _y4ti1b66 _15vtu23k _dm25glyw _oqicidpf _1rmjidpf _cjbtidpf _pnmbidpf",
            "compoundSubNavDropdownLinks"
        ]),
        style: {
            "--_1mhfb35": (0, $6ZVlx.default)((0, $4Rcm1.navLayout).outerInset),
            "--_84k7f0": (0, $6ZVlx.default)((0, $4Rcm1.navLayout).menuItemPadding)
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                onClick: linkClickAction,
                // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
                onMouseEnter: ()=>{
                    setOnCaretButton(true);
                },
                // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
                onMouseLeave: ()=>{
                    setOnCaretButton(false);
                },
                "aria-label": intl.formatMessage({
                    id: 'compoundSubNav.openDropdown',
                    defaultMessage: 'Open navigation menu'
                }),
                "aria-expanded": isOpen,
                "aria-controls": menuId,
                "data-event": "clicked",
                "data-event-component": "linkButton",
                "data-event-container": "headerDropdownLink",
                "data-label": intl.formatMessage({
                    id: 'compoundSubNav.openDropdown',
                    defaultMessage: 'Open navigation menu'
                }),
                "data-product-key": productKey,
                "data-testid": "compoundSubNavDropdownLinksCaretButton",
                className: (0, $2jatx.default)([
                    "_bfhk1j28 _19itglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1ule _vwz4idpf _v5641doz",
                        isOpen && "_t9ec1sub",
                        "chevron-icon"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "15",
                        height: "10",
                        viewBox: "0 0 15 10",
                        fill: "none",
                        "aria-hidden": "true",
                        focusable: "false",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M0.571934 1.12105C0.441394 1.25145 0.337835 1.40629 0.267179 1.57674C0.196524 1.74718 0.160156 1.92988 0.160156 2.11439C0.160156 2.2989 0.196524 2.48159 0.267179 2.65204C0.337835 2.82248 0.441394 2.97733 0.571934 3.10772L6.6346 9.18372C6.75846 9.30789 6.90559 9.4064 7.06758 9.47362C7.22956 9.54084 7.40322 9.57544 7.5786 9.57544C7.75398 9.57544 7.92764 9.54084 8.08962 9.47362C8.25161 9.4064 8.39874 9.30789 8.5226 9.18372L14.5893 3.10639C14.8524 2.84329 15.0002 2.48646 15.0002 2.11439C15.0002 1.74232 14.8524 1.38548 14.5893 1.12239C14.3262 0.859292 13.9693 0.711487 13.5973 0.711487C13.2252 0.711487 12.8684 0.859292 12.6053 1.12239L7.5786 6.15705L2.5546 1.12239C2.42446 0.992129 2.26992 0.888796 2.09982 0.818295C1.92972 0.747793 1.7474 0.711505 1.56327 0.711505C1.37914 0.711505 1.19681 0.747793 1.02671 0.818295C0.856613 0.888796 0.702076 0.992129 0.571934 1.12239V1.12105Z",
                            fill: (0, $kbpa7.wacToken)('color.primary.black')
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                id: menuId,
                ref: dropdownRef,
                "aria-hidden": !isOpen,
                className: (0, $2jatx.default)([
                    "_1e0cglyw _tzy4kb7n _1rjcpxbi _18zr1ejb _rjxp1qka _152t1osq _1bsb8hk1 _4t3i1w9h _kqswstnw _1f49b4wl _bfhk1afi _v564122b _1pbyzo7u _zulputpp _dwk3usvi _1bv01wug _1d2yncxg _14b51ris _kiya1b66 _1xlo1h9b _1kkmo7ao _z21jglyw _nxbc130s",
                    isOpen && "_1e0c1txw _2lx21bp4",
                    !isOpen && "",
                    !isOpen && "_y44v10i3"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0cglyw _kzvi1ule _em6n1n9t _1vxp5k2d _mmgkidpf _12rrauwl _1vkh1osq _18ooglyw _195y12a9 _1d0q6vh0 _4ik01mrw"
                        ])
                    }),
                    activeDropdown ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                                ref: backButtonRef,
                                type: "button",
                                onClick: ()=>setActiveDropdownKey(null),
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvr1h6o _zulpu2gc _19itglyw _bfhk1j28 _syaz5hrz _1yt4u2gc _1ygb1qgu _1ah3yh40"
                                ]),
                                style: {
                                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($clnBI))), {
                                        label: ""
                                    }),
                                    intl.formatMessage({
                                        id: 'globalnavv2.menu-back',
                                        defaultMessage: 'Back'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                children: activeDropdown.content
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        children: compoundSubNavLinksProps.map((link)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1rjcpxbi _1bsb1osq"
                                ]),
                                children: link.hasDropdown ? /*#__PURE__*/ (0, $7VQPk.jsx)($6052244f048f0d1c$var$CompoundNavDropdownLinkWithDropdown, {
                                    ...link,
                                    onOpen: ()=>setActiveDropdownKey(link.globalLinksKey)
                                }) : /*#__PURE__*/ (0, $7VQPk.jsx)($6052244f048f0d1c$var$CompoundNavDropdownLink, {
                                    ...link
                                })
                            }, link.globalLinksKey))
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1ule _181nglyw"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3PWZ2.Divider), {})
                    })
                ]
            })
        ]
    });
};
// Resolve tokens before sharing this style so Compiled and magnetic DI do not
// create a token-function binding in only one of the consuming components.
const $6052244f048f0d1c$var$dropdownLinkFont = (0, $kbpa7.wacToken)('font.charlie.text');
const $6052244f048f0d1c$var$dropdownLinkColor = (0, $kbpa7.wacToken)('color.primary.black');
const $6052244f048f0d1c$var$dropdownLinkHoverColor = (0, $kbpa7.wacToken)('color.primary.blue');
const $6052244f048f0d1c$var$dropdownLinkStyle = null;
const $6052244f048f0d1c$var$CompoundNavDropdownLink = (link)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        href: (0, $jQ0cd.useLocalizedHref)(link.href),
        "data-event": "clicked",
        "data-event-component": "linkButton",
        "data-event-container": "navbarDropdown",
        "data-label": link.linkText,
        "data-product-key": link.productKey,
        className: (0, $2jatx.default)([
            "_ect41h9v _1wybdlk8 _k48p1fw0 _syaz7sff _vwz4gktf _4t3igktf _30l31qkc",
            "_1e0c1o8l _1bsb1osq"
        ]),
        style: {
            "--_1ruzwcx": (0, $6ZVlx.default)($6052244f048f0d1c$var$dropdownLinkFont),
            "--_zyif3w": (0, $6ZVlx.default)($6052244f048f0d1c$var$dropdownLinkColor),
            "--_soiiez": (0, $6ZVlx.default)($6052244f048f0d1c$var$dropdownLinkHoverColor)
        },
        children: link.linkText
    });
};
const $6052244f048f0d1c$var$CompoundNavDropdownLinkWithDropdown = ({ linkText: linkText, productKey: productKey, onOpen: onOpen })=>{
    const dropdownLinkButtonStyle = null;
    const dropdownCaret = /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "6",
        height: "10",
        viewBox: "0 0 6 10",
        fill: "none",
        "aria-hidden": "true",
        focusable: "false",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M1.36328 1L4.99964 5L1.36328 9",
            stroke: (0, $kbpa7.wacToken)('color.primary.black'),
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
        type: "button",
        onClick: onOpen,
        "data-event": "clicked",
        "data-event-component": "linkButton",
        "data-event-container": "navbarDropdown",
        "data-label": linkText,
        "data-product-key": productKey,
        className: (0, $2jatx.default)([
            "_80omtlke _1e0c1txw _1bsb1osq _1bah1yb4 _4cvr1h6o _4t3igktf _vwz4gktf _19itglyw _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_ect41h9v _1wybdlk8 _k48p1fw0 _syaz7sff _vwz4gktf _4t3igktf _30l31qkc"
                ]),
                style: {
                    "--_1ruzwcx": (0, $6ZVlx.default)($6052244f048f0d1c$var$dropdownLinkFont),
                    "--_zyif3w": (0, $6ZVlx.default)($6052244f048f0d1c$var$dropdownLinkColor),
                    "--_soiiez": (0, $6ZVlx.default)($6052244f048f0d1c$var$dropdownLinkHoverColor)
                },
                children: linkText
            }),
            dropdownCaret
        ]
    });
};

});




parcelRegister("lsYgE", function(module, exports) {
$parcel$export(module.exports, "BuyCloudOrgSetupPage", function () { return $263c5b0e055ff0bd$export$4e76f99368941eb8; });

var $7VQPk = parcelRequire("7VQPk");

var $8DbQq = parcelRequire("8DbQq");
const $263c5b0e055ff0bd$export$4e76f99368941eb8 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $8DbQq.BuyCloudOrgSetupPageTemplate), {});

});
parcelRegister("8DbQq", function(module, exports) {
$parcel$export(module.exports, "BuyCloudOrgSetupPageTemplate", function () { return $1dcf28602161449e$export$61ed6150ce1cf26a; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $j2b52 = parcelRequire("j2b52");

const $1dcf28602161449e$var$DirectBuyOrgSetupContainer = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>// @ts-ignore
    Promise.resolve((parcelRequire("4wClq"))));
const $1dcf28602161449e$export$61ed6150ce1cf26a = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j2b52.ClientOnly), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($1dcf28602161449e$var$DirectBuyOrgSetupContainer, {})
    });
};

});
parcelRegister("j2b52", function(module, exports) {
$parcel$export(module.exports, "ClientOnly", function () { return $1445362815fc2039$export$70f10949f62d7670; });
// @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
let $1445362815fc2039$var$hydrating = true;
function $1445362815fc2039$export$1b590bd8f758497b() {
    const [hydrated, setHydrated] = (0, $1oC0p.useState)(()=>!$1445362815fc2039$var$hydrating);
    (0, $1oC0p.useEffect)(function hydrate() {
        $1445362815fc2039$var$hydrating = false;
        console.debug('hydrating:', $1445362815fc2039$var$hydrating);
        setHydrated(true);
    }, []);
    return hydrated;
}
const $1445362815fc2039$export$70f10949f62d7670 = ({ children: children })=>{
    return $1445362815fc2039$export$1b590bd8f758497b() ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: children
    }) : null;
};

});



parcelRegister("2ABij", function(module, exports) {
$parcel$export(module.exports, "BuyCloudPostOrderProvisioningPage", function () { return $4e5168b65a5948ac$export$a5f8b599017bd5cd; });

var $7VQPk = parcelRequire("7VQPk");

var $8pDM0 = parcelRequire("8pDM0");
const $4e5168b65a5948ac$export$a5f8b599017bd5cd = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $8pDM0.BuyCloudPostOrderProvisioningPageTemplate), {});

});

parcelRegister("2kCSN", function(module, exports) {
$parcel$export(module.exports, "BuyCloudSiteSetupPage", function () { return $0cf966eca9574fc8$export$4febe9f853354faf; });

var $7VQPk = parcelRequire("7VQPk");

var $7YWV2 = parcelRequire("7YWV2");
const $0cf966eca9574fc8$export$4febe9f853354faf = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7YWV2.BuyCloudSiteSetupPageTemplate), {});

});
parcelRegister("7YWV2", function(module, exports) {
$parcel$export(module.exports, "BuyCloudSiteSetupPageTemplate", function () { return $675a97dee15650d0$export$17d9bc116915a14; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $j2b52 = parcelRequire("j2b52");

const $675a97dee15650d0$var$DirectBuySiteSetupContainer = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>// @ts-ignore
    (parcelRequire("44QbK")));
const $675a97dee15650d0$export$17d9bc116915a14 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j2b52.ClientOnly), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($675a97dee15650d0$var$DirectBuySiteSetupContainer, {})
    });
};

});
parcelRegister("44QbK", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = Promise.all([
    $eao4m("hRefO"),
    $eao4m("9E5dL"),
    $eao4m("dRCk4"),
    $eao4m("93FiB"),
    $eao4m("bNb0m"),
    $eao4m("8Hh5M"),
    $eao4m("aWPy3"),
    $eao4m("b69he")
]).then(()=>parcelRequire('1Mst4'));

});



parcelRegister("83Z9w", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e00e0b56977ce279$export$2e2bcd8739ae039; });
/* cdn-library.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1rGpC = parcelRequire("1rGpC");

var $jsxHL = parcelRequire("jsxHL");

var $gaU6N = parcelRequire("gaU6N");
const $e00e0b56977ce279$var$CDNLibrary = ()=>{
    const [bgColor, setBgColor] = (0, $1oC0p.useState)('#f0f0f0');
    // Redirect to the homepage if the page is accessed from atlassian.com
    if (window?.location.hostname === 'atlassian.com') window.location.href = '/';
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_ca0q1wto _u5f3idpf _n3td1wto _19bvidpf _1tke1kxc _bfhkbs0x"
        ]),
        style: {
            "--_1w9snyi": (0, $6ZVlx.default)(bgColor)
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jsxHL.TypographyStyles), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_kqsw1n9t _152tidpf _1e0c1txw _1bah1yb4 _zulp1wto _ca0qviql _u5f3viql _n3tdviql _19bvviql _1bsb1osq _16qsd8sd _bfhkbs0x"
                    ]),
                    style: {
                        "--_1w9snyi": (0, $6ZVlx.default)(bgColor)
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                            type: "color",
                            value: bgColor,
                            onChange: (e)=>setBgColor(e.target.value),
                            title: "Change background color of the page"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("b", {
                                        children: "Last updated:"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    children: new Date((0, $gaU6N.lastUpdated)).toLocaleString()
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    children: $e00e0b56977ce279$var$calculateHowLongAgo(new Date((0, $gaU6N.lastUpdated)))
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1q51webb _rzby1wto _8k2z1wug _nd4uidpf _9u9n1wug _iowe1h6o"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                                children: "WAC-WEB CDN Library"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f1ogm _y3gn1h6o"
                                ]),
                                children: "These are the asset files uploaded to the WAC CDN. Search, filter, and copy the URL of the asset you are looking for quick and easy."
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _2lx21bp4 _zulpviql _19pk1wto _2hwxidpf _otyr1wto _18u0idpf"
                                ]),
                                children: (0, $gaU6N.cdnLibraryData).map((section)=>/*#__PURE__*/ (0, $7VQPk.jsx)($e00e0b56977ce279$var$DirectorySection, {
                                        directory: section.directory,
                                        files: section.files
                                    }, section.directory))
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $e00e0b56977ce279$var$DirectorySection = ({ directory: directory, files: files })=>{
    const [showFiles, setShowFiles] = (0, $1oC0p.useState)(false);
    const [filter, setFilter] = (0, $1oC0p.useState)('');
    const filteredFiles = files.filter((file)=>file.includes(filter));
    if (files.length === 0) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _4cvr1h6o _6a6z1e5h _yv0ek13l _zulpviql _1n461j6v _if5y1j6v _1gnp1j6v _7e5b1j6v _cq5utlke"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        children: directory
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
                        htmlFor: directory + 'show',
                        className: (0, $2jatx.default)([
                            "_80omtlke"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                id: directory + 'show',
                                type: "checkbox",
                                checked: showFiles,
                                onChange: ()=>setShowFiles((prev)=>!prev)
                            }),
                            "Show ",
                            files.length === 1 ? 'file' : 'files',
                            " (",
                            filteredFiles.length,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
                        htmlFor: directory + 'filter',
                        children: [
                            "Filter:",
                            ' ',
                            /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                id: directory + 'filter',
                                type: "text",
                                value: filter,
                                onChange: (e)=>setFilter(e.target.value)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1dyj _2lx21bp4 _zulpviql"
                ]),
                style: {
                    "--_i4wbgz": (0, $6ZVlx.default)(showFiles ? 'flex' : 'none')
                },
                children: filteredFiles.map((file)=>/*#__PURE__*/ (0, $7VQPk.jsx)($e00e0b56977ce279$var$FilePreview, {
                        file: file
                    }, file))
            })
        ]
    });
};
const $e00e0b56977ce279$var$FilePreview = ({ file: file })=>{
    const copyToClipboard = ()=>{
        navigator.clipboard.writeText(file);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvrv2br _6a6zv2br _zulp1j6v _19pkidpf _2hwxviql _otyridpf _18u0viql _bozg1j6v _191w1qv1 _43ds13q2"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _zulpviql"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                onClick: copyToClipboard,
                                title: "Save to clipboard",
                                children: "COPY URL"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                href: file,
                                target: "_blank",
                                rel: "noreferrer",
                                children: "OPEN IN NEW TAB"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        children: file
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_p12f1kdj _mezj1osq _1y2k1osq _rtys1osq _26rc1osq _19l31osq _1ghp1osq"
                ]),
                children: [
                    $e00e0b56977ce279$var$isVideo(file) && // Tech debt: Adding this disable to unblock commits for GWP-2646
                    // eslint-disable-next-line jsx-a11y/media-has-caption
                    /*#__PURE__*/ (0, $7VQPk.jsx)("video", {
                        src: file,
                        controls: true
                    }),
                    $e00e0b56977ce279$var$isImage(file) && /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                        src: file,
                        alt: file,
                        loading: "lazy"
                    })
                ]
            })
        ]
    });
};
const $e00e0b56977ce279$var$isVideo = (file)=>{
    return file.endsWith('.mp4') || file.endsWith('.webm');
};
const $e00e0b56977ce279$var$isImage = (file)=>{
    return file.endsWith('.svg') || file.endsWith('.webp') || file.endsWith('.png') || file.endsWith('.jpg') || file.endsWith('.jpeg') || file.endsWith('.gif');
};
const $e00e0b56977ce279$var$calculateHowLongAgo = (datePast)=>{
    // Calculate the difference between now and the datePast
    const difference = new Date().getTime() - datePast.getTime();
    // Convert difference into days, hours, and minutes
    const daysDifference = Math.floor(difference / 86400000);
    const hoursDifference = Math.floor(difference % 86400000 / 3600000);
    const minutesDifference = Math.floor(difference % 3600000 / 60000);
    // Construct the output string
    let result = '';
    if (daysDifference > 0) result += daysDifference + ' day' + (daysDifference > 1 ? 's' : '');
    if (daysDifference > 0 && hoursDifference > 0) result += ', ';
    if (hoursDifference > 0) result += hoursDifference + ' hour' + (hoursDifference > 1 ? 's' : '');
    if (hoursDifference > 0 && minutesDifference > 0) result += ', and ';
    if (minutesDifference > 0) result += minutesDifference + ' minute' + (minutesDifference > 1 ? 's' : '');
    return result + ' ago';
};
var $e00e0b56977ce279$export$2e2bcd8739ae039 = $e00e0b56977ce279$var$CDNLibrary;

});
parcelRegister("gaU6N", function(module, exports) {
$parcel$export(module.exports, "lastUpdated", function () { return $18aac2c07ff756bf$export$c60d1a715a48771d; });
$parcel$export(module.exports, "cdnLibraryData", function () { return $18aac2c07ff756bf$export$48209f5fd1d7ca21; });
// This file is auto-generated by the script generate-cdn-library-data.mjs
const $18aac2c07ff756bf$export$c60d1a715a48771d = '2024-04-20T06:39:46.627Z';
const $18aac2c07ff756bf$export$48209f5fd1d7ca21 = [
    {
        directory: 'download/',
        files: []
    },
    {
        directory: 'keynote/',
        files: []
    },
    {
        directory: 'keyword-cluster/',
        files: []
    },
    {
        directory: 'mp4-animations/',
        files: [
            'https://wac-cdn.atlassian.com/misc-assets/mp4-animations/jira-hero-wac-animation.mp4'
        ]
    },
    {
        directory: 'optimizely/',
        files: []
    },
    {
        directory: 'pdfs/',
        files: [
            'https://wac-cdn.atlassian.com/misc-assets/pdfs/CSD-10312_France_Gender_Equity_Disclosure-FY24_Q3.pdf'
        ]
    },
    {
        directory: 'svgs/',
        files: [
            'https://wac-cdn.atlassian.com/misc-assets/svgs/audi-n50.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/avocado.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/beacon-blue.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/beacon-hero.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/beacon-white.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/bitbucket-blue.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/blue-wave-background.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/canva-n50.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/code-aws-devops.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/code-aws-jsw.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/compass-hero.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/confluence-blue.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/confluence-hero.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/confluence-social-proof-reel.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/confluence-whiteboards-logo-lockup-blue.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/confluence-whiteboards-logo-lockup.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/crowd.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/devops-background.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/devops-v2-left-optimized.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/envelope-n2n.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/figma.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/google-drive-logo.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/google-drive.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/jira-core-hero.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/jira-hero.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/jira-logo.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/jira-ops-blue-rgb.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/jira-product-discovery-logo-blue.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/jira-service-management-logo-gradient-blue.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/jira-software-blue.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/jira-software-white.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/jira-work-management-logo-gradient-blue.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/jira.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/jpd-firstimpression-hero.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/jpd-white.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/jsd-hero.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/jsd-logo.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/jsm-social-proof-reel.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/jsw-social-proof-reel.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/jwm-social-proof-reel.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/logo-gradient-blue-compass.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/loom.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/loom_beam_color.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/menu.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/microsoft-teams.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/ms-teams.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/opsgenie-blue-rgb.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/slack-icon-logo.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/slack.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/ss-atlassian-logo.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/ss-jsw-logo.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/statuspage-blue.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/statuspage-white.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/success-n2e.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/team-central-beta-color.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/team-central-beta-white.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/team-central-hero.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/tempo-logo-white.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/tempo-logo.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/trello-icon-logo.svg',
            'https://wac-cdn.atlassian.com/misc-assets/svgs/trello-logo.svg'
        ]
    },
    {
        directory: 'test-svgs/',
        files: []
    },
    {
        directory: 'testreplica/',
        files: []
    },
    {
        directory: 'videos/',
        files: []
    },
    {
        directory: 'webp-images/',
        files: [
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/001 Plan-1878220112.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/002 Track-61709455.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/003 Collab-1370881390.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/004 Launch-3779179643.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/005 Report-161454665.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/10C-Logo-Nextiva1.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/10C-Logo-Nextiva@2x 1.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/5_New%20Mobile@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/9D-Logo-Lufthansa-Systems.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/9D-Logo-Lufthansa-Systems_l.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ADD_DARK_MODE@2x_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ADD_DARK_MODE@2x_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ADD_DARK_MODE@2x_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ADD_DARK_MODE@2x_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/AUTO_LOAD_BALANCE@2x_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/AUTO_LOAD_BALANCE@2x_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/AUTO_LOAD_BALANCE@2x_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/AUTO_LOAD_BALANCE@2x_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Air_Canada-logo-n0.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Announcement_Banner.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Archived_Page.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Arvato Systems-4222291387.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Atlassian-Intelligence-icon.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Atlassian-intelligence.webm',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Atlassian_DHCS_Ryan_Alpha-1206744447.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Atlassian_Presents_Unleash_logo_banner.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Automation.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Automation_Triggers.1353.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Automation_Triggers.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/BANC.LY-SUPPORT@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/BANC.LY_SUPPORT@2x_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/BANC.LY_SUPPORT@2x_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/BANC.LY_SUPPORT@2x_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/BANC.LY_SUPPORT@2x_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/BG-Hero-1440-left.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/BG-Hero-1440-right.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/BG-Hero-768-right.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/BG-dot_filled_circle.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Backlog.1353.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Blog_360x265@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Blue%20Best%20Practices@4x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Blue%20Demo%20Video@4x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Blue%20Use%20Cases@4x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Board-with-nav-collapsed.1353.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Board.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Bulk_archiving.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CE_-_Macros__@1x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CE_-_Page_versioning__@1x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CE_-_Unlimited_spaces__@1x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_ AI-3298633667.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_ AI_LowBR.mp4',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_ Confluence-2040505915.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_ Confluence_LowBR.mp4',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_ JPD-286968629.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_ JPD_LowBR.mp4',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_ JSM-3020245023.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_ JSM_LowBR.mp4',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_ Loom-791474346.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_ Loom_LowBR.mp4',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Hero_A_HD (0-00-00-00)-4060786602.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Hero_A_LowBR.mp4',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Hero_A_LowBR.webm',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Hero_B_HD (0-00-09-24)-1969559334.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Hero_B_LowBR.mp4',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Hero_B_LowBR.webm',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Hero_C_HD (0-00-16-35)-1443600009.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Hero_C_LowBR.mp4',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Hero_C_LowBR.webm',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Hero_FULL_LowBR.mp4',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Hero_FULL_LowBR.webm',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Jira-4003614779.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Jira_LowBR.mp4',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204 project north star plan@2x.webp-2125193628.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204-Templates-screen@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204-cta-left.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204-cta-right.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204-hero-left-side.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204-hero-right-side.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204_Break_down_information_silos@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204_Employee_Resource_hub@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204_Get_on_the_same_page@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204_Templates_screen@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204_Weekly_status@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204_Your_entire_team_on_one_platform@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204_project_north_star_plan@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204_project_overview@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-8431-FY24-Team-24-Animated-Website-Hero_v03.webm',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ClearwaterAnalytics-823945256.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Community@2x-3332122863.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Community@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/CommunityMobile_360x235@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Conf_ProductTour_BlueBestPractices.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Conf_ProductTour_BlueDemoVideo.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Conf_ProductTour_BlueUseCases.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Conf_ProductTour_Hero.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Conf_ProductTour_Mobile.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Conf_ProductTour_Thumbnail.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Confluence%20PT%20thumbnail@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Confluence@2x-blue.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Development-graphic@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Development-graphic@2x_(1.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Development-graphic@2x_deDE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Development-graphic@2x_frFR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Development-graphic@2x_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Development-graphic@2x_ptBR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Onboarding-graphic@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Onboarding-graphic@2x_deDE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Onboarding-graphic@2x_frFR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Onboarding-graphic@2x_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Onboarding-graphic@2x_ptBR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Recent-graphic@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Recent-graphic@2x_(1.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Recent-graphic@2x_deDE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Recent-graphic@2x_frFR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Recent-graphic@2x_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Recent-graphic@2x_ptBR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Collaboration.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Documentation.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Documentation_(1.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Documentation_deDE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Documentation_frFR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Documentation_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Documentation_ptBR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_SourceOfTruth.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Templates.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_BusinessPlan.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_BusinessPlan_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_BusinessPlan_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_BusinessPlan_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_BusinessPlan_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Marketing.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Marketing_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Marketing_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Marketing_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Marketing_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Product.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_ProductJA.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_ProductPT.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Product_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Product_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Productivity-revised.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Productivity-revisedJA.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Productivity-revisedPT.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Productivity-revised_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Productivity-revised_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Project.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_ProjectJA.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_ProjectPT.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Project_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Project_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Advanced%20search%201.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Advanced_search.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Advanced_search_1.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Integration.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_KnowledgeMangement.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Real%20time%20Editing%201.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Real_time_Editing.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Real_time_Editing_1.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Wiki.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Wiki-961320203.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Wiki_deDE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Wiki_frFR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Wiki_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Wiki_ptBR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Confluence_AI.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Copy_Space_Permissions-optimized.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/DESIGN_TEAMS@2x-de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/DESIGN_TEAMS@2x-ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/DESIGN_TEAMS@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/DESIGN_TEAMS@2x_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/DESIGN_TEAMS@2x_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/DHCS-1703508494.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Dektop_TL@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Dependency-management.1353.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Desktop_BL-2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Desktop_BR-2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Desktop_TR-2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Doodle-3562754075.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/DropBox-4186472046.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Endenred-734004069.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Engineering_team.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Ent%20sign-responsive.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/FLO_logo_horizontal_white%201.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/FUN@2x-de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/FUN@2x-ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/FUN@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/FUN@2x_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/FUN@2x_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Frame 1010105996-1698270861.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/GW-1212_ds_jsm_bancly_help_center2.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-dark-sectionbg.png',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-dark-sectionbg.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-dark-sectionbg2.png',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-dark-sectionbg2.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-dark-sectionbg3.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-footerbg.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-mobile-workflow-diagram.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-tab-bg2-1.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-tab-bg2.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-tab-bg3.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-tablet-footerbg.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1212-unlock-collaboration-2790x1554.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1212_Incident_issue_view_jsm.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1212_it_ops_tab.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1212_jsm_bancly_help_center2.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1212_service_management_screenshot.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Group 6273011-2525946013.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Group 6273205-1701574714.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Group 6273206-2473828409.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Group 6273207-554690744.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Guest_markers_in_product.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/HERO_ROADMAPS@2x-de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/HERO_ROADMAPS@2x-ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/HERO_ROADMAPS@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/HERO_ROADMAPS@2x_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/HERO_ROADMAPS@2x_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/HR_team.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/IP_allowlist.1353.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ITSM-1400.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Impossible-Alone-Video-Header-Image-@2X%202.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Impossible-Alone-Video-Header-Image-smile.webp-647850140.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Impossible-Alone-Video-Header-Image.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Insights.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Inspect_Perms-optimized.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JA sign-responsive.webp-1988963931.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JA%20sign-responsive.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JPD_screen_framed.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM + topics.png',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSMJiraprovisioning.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_AI.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_BG%20Graphics.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_CTA Background.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_CTA%20Background.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_DeliverFast.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_DeliverFast_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_DeliverFast_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_DeliverFast_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_DeliverFast_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_DevOps.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_DevOps_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_DevOps_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_DevOps_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_DevOps_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_Automation.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_Automation_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_Automation_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_Automation_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_Automation_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_ITIL.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_ITIL_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_ITIL_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_ITIL_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_ITIL_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_Knowledge.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_Knowledge_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_Knowledge_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_Knowledge_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_Knowledge_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_SLA.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_SLA_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_SLA_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_SLA_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_SLA_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Change.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Change_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Change_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Change_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Change_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Configuration.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Configuration_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Configuration_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Configuration_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Configuration_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_DynamicForms.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_DynamicForms_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_DynamicForms_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_DynamicForms_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_DynamicForms_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Incident.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Incident_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Incident_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Incident_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Incident_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Integrations.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Integrations_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Integrations_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Integrations_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Integrations_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Problem.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Problem_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Problem_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Problem_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Problem_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Request.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Request_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Request_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Request_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Request_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_SelfService.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_SelfService_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_SelfService_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_SelfService_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_SelfService_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_ServiceDesk.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_ServiceDesk_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_ServiceDesk_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_ServiceDesk_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_ServiceDesk_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_MakeVisible.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_MakeVisible_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_MakeVisible_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_MakeVisible_ja_JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_MakeVisible_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW%20free-responsive.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW%20sign-responsive.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_AI.1353.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Automation.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Automation_br.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Automation_de.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Automation_en.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Automation_fr.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Automation_ja.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Backlog_x2%202.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Backlog_x2_2.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Backlog_x2_2_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Backlog_x2_2_pt-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Backlog_x2_2_pt-de.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Backlog_x2_2pt-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Blue_Grid.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Boards.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Boards_br.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Boards_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Boards_de.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Boards_en.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Boards_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Boards_fr.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Boards_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Boards_ja.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Boards_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Bug_Tracking.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Bye_Bye_Spreadseets.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Bye_Bye_Spreadseets_br.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Bye_Bye_Spreadseets_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Bye_Bye_Spreadseets_de.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Bye_Bye_Spreadseets_en.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Bye_Bye_Spreadseets_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Bye_Bye_Spreadseets_fr.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Bye_Bye_Spreadseets_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Bye_Bye_Spreadseets_ja.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Bye_Bye_Spreadseets_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Capacity.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Capacity_deDE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Capacity_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Capacity_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Capacity_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Forecast.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Forecast_deDE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Forecast_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Forecast_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Forecast_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Goals_deDE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Goals_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Goals_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Goals_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Kanban.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ProductTour_DarkModeIllustration_BugTracking_Spot.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ProductTour_DarkModeIllustration_Hero.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ProductTour_DarkModeIllustration_Wave.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ProductTour_DarkModeIllustration_Workflow.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ProductTour_PromoBannerGeo.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Reports.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ReportsInsights_2.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ReportsInsights_2_deDE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ReportsInsights_2_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ReportsInsights_2_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ReportsInsights_2_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Reports_br.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Reports_de.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Reports_en.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Reports_fr.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Reports_ja.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Roadmaps_br.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Roadmaps_ja.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_SingleSource.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_SingleSource_deDE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_SingleSource_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_SingleSource_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_SingleSource_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Visualization.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Visualization_deDE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Visualization_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Visualization_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Visualization_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JWM.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Jira-Board-Software-3233077719.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Jira-Calendar-Marketing-4146978900.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Jira-List-Design-1069502226.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Jira-On-call-IT-3030871761.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Jira-Timeline-Product Management-3301759489.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Jira-Timeline-Project Management-2679766879.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JiraConfluenceprovisioning.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/JiraJSMProvisioning.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Joe Cotant Roblox-2296603445.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Kanban_DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Kanban_ES.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Kanban_FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Kanban_JA.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Kanban_RU.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Kanban_ptBR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Kiva-1702957319.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Lang_support@1x-from-@harry.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Logo-wall-left-2221824116.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Logo-wall-right-3214451279.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Lumen-381040365.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/MARKETING_CALENDAR@2x-de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/MARKETING_CALENDAR@2x-ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/MARKETING_CALENDAR@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/MARKETING_CALENDAR@2x_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/MARKETING_CALENDAR@2x_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Marketing_team.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/MehmetSari-4103257443.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/MercedesBenz-357676847.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Microsoft-teams-logo-1526817987.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Microsoft_Teams_Logo_2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Miro-logo-3117227469.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/MissionControl.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Mobile_B-2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Mobile_T@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Networking_people_spot@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/OPEN-INCIDENTS@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/OPEN_INCIDENTS@2x_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/OPEN_INCIDENTS@2x_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/OPEN_INCIDENTS@2x_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/OPEN_INCIDENTS@2x_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/OPERATIONS@2x-de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/OPERATIONS@2x-ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/OPERATIONS@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/OPERATIONS@2x_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/OPERATIONS@2x_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Octicons-cloud-download.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Overview_issue_hiearchy.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_de-DE-01.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_de-DE-02.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_de-DE-03.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_de-DE-04.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_de-DE-07.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_de-DE-11.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_de-DE-13.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_fr-FR-01.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_fr-FR-02.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_fr-FR-03.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_fr-FR-04.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_fr-FR-07.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_fr-FR-11.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_fr-FR-13.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_ja-JP-01.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_ja-JP-02.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_ja-JP-03.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_ja-JP-04.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_ja-JP-07.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_ja-JP-13.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_pt-BR-01.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_pt-BR-02.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_pt-BR-03.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_pt-BR-04.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_pt-BR-07.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_pt-BR-11.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_pt-BR-13.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/POS-system.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/PRODUCT_TEAMS@2x-de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/PRODUCT_TEAMS@2x-ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/PRODUCT_TEAMS@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/PRODUCT_TEAMS@2x_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/PRODUCT_TEAMS@2x_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Pasted Graphic-2395339363.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Prem%20sign-responsive.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Premium_feature_-_site_analytics-2X_2.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Product_Management.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Product_team.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/QMetry-logo-978966706.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/RTR_logo.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Releases.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Roblox Interview Joe Cotant + Alpha-1942757731.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Roblox-3121607094.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/RobloxJoeCotant-1985850389.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Round 5.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/RoyalCaribbean-2310931816.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Rule-builder-component_list-2x_.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/SERVICE_CENTER@2x_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/SERVICE_CENTER@2x_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/SERVICE_CENTER@2x_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/SERVICE_CENTER@2x_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/SOFTWARE_TEAMS@2x-ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/SOFTWARE_TEAMS@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/SOFTWARE_TEAMS@2x_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/SOFTWARE_TEAMS@2x_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/SUBTASKS@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/SUBTASKS@2x_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/SUBTASKS@2x_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/SUBTASKS@2x_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/SUBTASKS@2x_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen%20Shot%202023-01-05%20at%203.48%201.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights%20JA.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights_DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights_ES.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights_FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights_JA.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights_RU.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-kanban_board@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-scrum_board@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Scrum_board_DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Scrum_board_ES.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Scrum_board_FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Scrum_board_JA.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Scrum_board_RU.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Scrum_board_ptBR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Social%20Unleash%20193x122.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Software AG-2524322619.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/SonyMusic-3191867672.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Spotify_Logo-N0.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Stars.webp-347416437.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/StephanieLeue_CPO_Doodle-2892442182.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Structured_page_tree__@1x_(2.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/TEAM_ANALYTICS@2x_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/TEAM_ANALYTICS@2x_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/TEAM_ANALYTICS@2x_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/TEAM_ANALYTICS@2x_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/TEMPLATES_de-DE@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/TEMPLATES_fr-FR@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/TEMPLATES_ja-JP@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/TEMPLATES_pt-BR@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/TOOLS@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/TRACK_PROGRESS@2x-de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/TRACK_PROGRESS@2x-ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/TRACK_PROGRESS@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/TRACK_PROGRESS@2x_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/TRACK_PROGRESS@2x_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Team%20Playbook_360x265@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Team-24-Animated-Website-Hero_Mobile_329x253.webm',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Team-Calendars.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Team-Logo-1786577449.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Team_Logo only_1200_628.webp-2037705328.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Team_Logo-1729653467.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Team_Logo.webp-1729653467.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Team_Logo_-977956.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Team_Logo_only_1200_628.webp-3936184367.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/TheVeryGroup-1520026636.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Ticket_created@2x_1.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/Timeline.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/WaisRoyalCaribbean-4173208448.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/add-dark-mode.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/admin-insights.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/admin-key.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/advanced-roadmaps-timeline.1353.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/agile-reporting.1353.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ai-deeplink-atlassian-intelligence-logo.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ai-deeplink-banner-background-mobile.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ai-deeplink-banner-background-tablet.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ai-deeplink-banner-background.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ai-img.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/air-table-3638621307.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor-jsm-add-people-modal.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor-jsm-automation-screen.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor-jsm-customer-service-screen.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor-jsm-customer-support-screen.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor-jsm-iress-logo.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor-jsm-open-cases-screen.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor-jsm-silverline-screen.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor-jsm-support-screen.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor-jsm-trouble-ticket-screen.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_HR_support_screenshot.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_JSM_topics.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_automation_rule_jsm.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_automation_screen.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_business_team_support.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_change_details_jsm.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_facilities.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_facilities2.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_incident_issue_view_jsm.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_jsm_cs.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_jsm_cs2.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_jsm_features_dynamic_forms.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_project_templates.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_team_analytics_dashboard.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_topics_jsm.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/artboard-hand.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/artboard-stars.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/arvato-johannes-siebzehnrubl-2519619866.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/asana-363871342.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/aset-selection.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/assign-and-prioritize2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/assign-and-prioritize_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/assign-and-prioritize_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/assign-and-prioritize_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/assign-and-prioritize_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/astronaut.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/atlassian-unleash.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/audi-logo.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/audit-logs.cdnVersion1351.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-rules.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-rules2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-rules_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-rules_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-rules_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-screen.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-string-ES.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-string-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-string-JA.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-string-RU.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-string.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/automation2_1_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/automation2_1_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/automation2_1_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/automation2_1_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/automation2xpng.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/automationscreen.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/backing1.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/backing2.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/backing3.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/backing4.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/balsamiq-1570513082.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/bannerAlert_team24_bg_l.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/bannerAlert_team24_bg_l_.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/bannerAlert_team24_bg_l_with_lines.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/bannerAlert_team24_bg_r.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/bannerAlert_team24_bg_r_.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/bannerAlert_team24_logo.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/bannerAlert_team24_logo_.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/bg_atl_cloud_hero_small.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/bitbucketscreen.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/bitbucketscreen2.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/blue-angle.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/blue-closing-angle.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/bonobos-logo.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/breakdownInfoSilos.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/bring-visibility.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/bucket_test.png',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/bucket_test_2.png',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/canva-363018985.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/canva-logo.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/canvalogo.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/capacity-management.1354.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/cec1c0b14a8ceca297df71534fae13dd-481890245.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/check-green.1353.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/check-green.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/checkmark-paper-plane-illustration.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/choose_your_own_adventure_1.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/choose_your_own_adventure_DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/choose_your_own_adventure_FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/choose_your_own_adventure_JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/choose_your_own_adventure_br.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/clearwater-analytics-erica-larson-783154932.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/closing-banner-graphic.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/collaborate-1.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/collaborate-2.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/collaborate-3.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/collaborate-4.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/collaborate_1.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/collaborate_2.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/collaborate_3.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/collaborate_4.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/community-bubble-icon-3561157108.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/con-onboard-invite.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/con-onboard-product-question-collaboration.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/con-onboard-product-question-default.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/con-onboard-product-question-knowledge-base.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/con-onboard-product-question-trying-out.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/con-onboard-team.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/con-onboard-template-background-2765676952.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence-create-a-page.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence-organize-your-work.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence-share-it-with-your-team.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluencelp-feature-collaboration.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluencelp-feature-documentation.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluencelp-feature-templates.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluencelp-templates-businessplan.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluencelp-templates-marketing.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluencelp-templates-product.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/construction.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/content_gif_v1.0.2.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/create_issue_2_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/create_issue_2_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/create_issue_2_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/create_issue_2_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/create_issue_2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ctaLeft.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ctaRight.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/curved-arrow-icon-3497580723.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/customer service screen.webp-3113962215.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/customer-story-company-placeholder-mercedes-benz-3039099905.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/customer-story-company-placeholder-roblox-4173828533.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/customer-story-filter-icon-3367749555.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/customer-story-hero-asset-placeholder-mercedes-benz-1758178859.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/customer-story-person-placeholder-roblox-2783909767.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/customers-team24-hero-background.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/dark-shape.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/database-server-on-v3.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/demo-deeny-fullcard1.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/department-of-defense-n50.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/deploymentscreen.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/desc.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/design-card-1-3753095941.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/design-card-2-1415836422.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/design-card-3-3083932167.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/design-main-2975787526.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/devOps_template_1.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/devOps_template_DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/devOps_template_FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/devOps_template_JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/devOps_template_br.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/devops-diagram-compressed.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/devops-diagram-compressed.webp-1760218363.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/dhcs-ryan-mosley-4192898571.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/dhcs2-419927292.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/dhcsfigma-846763754.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/dhcsfigma2-303950232.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/dominos-n0.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/doodle-stephanie-leue-1192382875.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/doodle2-1344893385.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/doodlefigma-3413596895.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/double-feature-1.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/double-feature-2.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/dropbox-damien-davis-3638188557.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/earf-high-res.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/earf.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/earf2.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/earth-noise.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/edenred-razvan-nechifor-1301495753.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/emp-screen-campaign-management.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/emp-screen-content-management.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/emp-screen-customer-journey-mapping.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/emp-screen-go-to-market.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/emp-screen-kanban.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/emp-screen-roadmap.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/emp-screen-scrum.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/employeeResourcehub.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/empower-employees.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/empower1.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/empower2.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/empower3.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/empower4.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/empower5.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-bars.webp-2356904232.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-data-center-icon-3736035258.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-graph.webp-3089236614.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-grid.webp-3189788274.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-quarter-circle.webp-2345858369.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprisetabContentImage-978864670.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/esm_templates.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/explore-apps-screen.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/fabric-sign-up-hero-rev@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/feature-code-image-three.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/features-code-image-one.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/features-code-image-three.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/features-code-image-two.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/figma-363833302.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/figma-logo-4073520400.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/figma.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/file.webp-1703115956.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ford-n0.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/forresterfigma-3996254026.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/fullcard1.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/fullcard2.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/fullcard3.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/fullcard4.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/gartnerfigma-4234034927.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/gartnerpeerinsightsfigma-3794251448.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/gestural-line.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/getOnTheSamePage.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/git-lab-204839338.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/github-3505995671.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/github-logo-1518537873.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/google-analytics-3286988256.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/google-docs-2740153165.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/google-docs-logo-950929547.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/google-docs.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/google-drive-2276762714.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/google-drive-logo-2396662236.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/google-drive.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/google-play-280x86.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/google-sheets-1718541418.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/header-line.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/hero-illustration%20.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/hero-illustration.webp-1789985659.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/hero-screenshot-main.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/hero-screenshot.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/heroCardDesign.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/heroCardIt.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/heroCardMarketing.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/heroCardOps.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/heroCardSoftwareDev.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/heroLeftSide.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/heroRightSide.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/high-velocity.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/hot-jar-1014134517.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/how-to-screen.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/hubspot-3684386805.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/hubspotLogo.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/icongithub.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/iconsalesforce.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/image-368080789.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/image.webp-368080789.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/image0_1822_82735.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/image1-1147150532.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/image2-951482151.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/image3-917086086.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/img-arrow.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/incident-screen.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/infobip-logo.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/iss-logo-white.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/iss-logo-white_l.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/it-card-1-197982346.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/it-card-2-3557245065.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/it-card-3-1450489864.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/it-main-2485041033.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/itsm-market-event-wac-homepage-nov16-thumbnail.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/jenkins-214038284.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-board-sparkle.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-family-hero.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-feature-v2-cta.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-homepage-full.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-homepage-res.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-ticket-loop-de-loop.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/jpd-pt-impact_assessment.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/jpd-pt-improve_discoverability.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/jpd-pt-performance.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-anchor-competitors-service-desk.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-anchor-engie-logo.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-anchor-explore-apps-screen.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-anchor-incident-issue-view-shadow.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-anchor-incident-issue-view.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-anchor-logo-ginkgo-bioworks.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-anchor-nextiva-logo.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-anchor-request-screen.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-anchor-saint-gobain-logo.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-anchor-subtasks.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-deliverfast.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-devops.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-hero-portal.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-makevisible.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/jsw-admin insights screenshot with sidebar.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/jsw-admin%20insights%20screenshot%20with%20sidebar.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/jsw-admin_insights_screenshot_with_sidebar.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/jsw-project-archiving.1353.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/jwm-mobile.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/jwm.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/kanban-mobile.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/kanban.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/kiva-brit-heiring-2670154364.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/launch-darkly-198811051.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/load-balance-screen.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/logged-in-states.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/login-flyout.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/logo-angle.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/logo-canva-80x80.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/lucid_motors_logo.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/lucid_motors_logo_l.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/lumen-mai-lian-scarlett-2328968069.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/lumenfigma-2189149097.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/mailchimp-1767865028.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/marketing-card-1-2762112147.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/marketing-card-2-1921074928.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/marketing-card-3-2388914769.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/marketing-main-3970751984.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/maximize-efficiency_1.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/maximize-efficiency_DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/maximize-efficiency_FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/maximize-efficiency_JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/maximize-efficiency_br.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/mbenz-357294988.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/mercedes-benz-mehmet-sari-366365367.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/mercedesbenz2-2811812509.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/mercedesbenzfigma-1447440523.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/microsoft-365-3971673211.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/microsoft-office-1075029899.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/microsoft-teams-500184357.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/miro.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/mobile-dark-shape.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/modalCardDesign.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/modalCardIt.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/modalCardMarketing.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/modalCardOps.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/modalCardSoftwareDev.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/monday-3089500834.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/ms-teams.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/nasa-logo-1.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/nav-expanded-products.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/new-collaborate-1.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/new-collaborate-2.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/new-collaborate-3.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/new-collaborate-4.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/new-double-feature-1.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/new-double-feature-2.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/new-staggered-double-feature-1.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/new-staggered-double-feature-2.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/nextiva-logo.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/notifications2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/notifications_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/notifications_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/notifications_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/notifications_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/object lightning 1.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/page-insights.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/page-space-permissions.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/paid-hero.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/pendo-379684898.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/placeholder-video-1920x1080.webm',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/power-of-teamwork-stroke.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/pre-approved-change.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/prod-management-card-1-4088370720.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/prod-management-card-2-3111339843.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/prod-management-card-3-4125726562.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/prod-management-main-2176065091.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/prodbutton.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/proj-management-card-1-4087893998.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/proj-management-card-2-3111006349.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/proj-management-card-3-4125393068.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/proj-management-main-2175731597.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/projectNorthStarPlan.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/projectOverview@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/public_links_1.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/quote.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/redfinfigma-3508974692.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/reports_and_insights_1.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/reports_and_insights_DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/reports_and_insights_FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/reports_and_insights_JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/reports_and_insights_br.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/resource-agile.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/resource-community.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/resource-devops.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/resource-playbook.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/roadmaps_1462x860_en.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/roblox-joe-cotant-466070325.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/roblox2-2160814116.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/robloxfigma-3257924658.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/rocket-icon.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/royal-caribbean-wais-mojaddidi-3806226212.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/royalcaribbean2-1165951194.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/royalcaribbeanfigma-286749900.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/salesforce-2848088583.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/salesforce-logo-1329625985.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/scottf-usericon.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-advanced_20reporting_DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-advanced_20reporting_ES.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-advanced_20reporting_FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-advanced_20reporting_JA.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-advanced_20reporting_RU.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-advanced_20reporting_ptBR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-dev%20status%20in%20issue.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-dev_20status_20in_20issue_DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-dev_20status_20in_20issue_ES.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-dev_20status_20in_20issue_FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-dev_20status_20in_20issue_JA.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-dev_20status_20in_20issue_RU.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-dev_20status_20in_20issue_ptBR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-jira-see-code_DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-jira-see-code_ES.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-jira-see-code_FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-jira-see-code_JA.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-jira-see-code_RU.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-jira-see-code_ptBR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-roadmaps_(1848x1062.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-scrum-de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/script-runner-1229978336.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-accent-1.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-accent-2.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-accent-3.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-accent-4.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-accent-5.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-brand-1.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-brand-2.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-brand-3.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-brand-4.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-brand-5.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-portrait-1.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-portrait-2.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-portrait-3.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-portrait-4.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-portrait-5.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-screenshot-1.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-screenshot-2.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-screenshot-3.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-screenshot-4.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-screenshot-5.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/scrum_template_1.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/scrum_template_DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/scrum_template_FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/scrum_template_JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/scrum_template_br.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/seamless-integration2_1_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/seamless-integration2_1_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/seamless-integration2_1_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/seamless-integration2_1_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/seamless-integration2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/service-center.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/service-desk-screen.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/service-map.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/service-now-3403321428.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/sickkids_logo.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/signal.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/slack-375335524.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/slack-logo-4089617954.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/slack.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/smartsheet-2509293444.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/software-card-1-2014673720.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/software-card-2-1837920251.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/software-card-3-2211238458.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/software-main-4112590587.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/softwareag-tim-brutscher-149530773.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/sony-music-publishing-alison-wood-1422956484.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/sony_music_publishing_logo.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/sophosLogo.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/sprints-mobile.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/sprints.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/star.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/statsig-4214018365.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/stay-on-track-re-export_br.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/stay-on-track-re-export_de.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/stay-on-track-re-export_fr.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/stay-on-track-re-export_ja.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/sunlifefigma-451494296.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/sydney.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/sydney.webp-3093752750.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/tab2image-29451184.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/tab3image-29484945.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/tab4image-29379446.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/tab5image-29413207.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-ad-banner-confluence-logo-desktop.webp-1192641009.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-ad-banner-confluence-right-hand-image-desktop.webp-3380811166.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-ad-banner-confluence-right-hand-image-tablet.webp-2937812902.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-anu-desktop.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-anu-tablet.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-logo-confluence-ad-banner-desktop.webp-1441519569.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-promotion-header-poster.webp-1047714346.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-promotion-header-static-desktop.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-promotion-header-static-mobile.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-promotion-header-static-tablet.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-right-hand-image-confluence-desktop.webp-4272371151.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24_attribution-logo-above-center_full-color_RGB.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24_attribution-logo-above-left_full-color_RGB.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/team-tour_government_attribution-logo.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-card-test.webp-4063272267.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-color-lockup-desktop-3939666149.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-liftedbar-left-desktop-1497436778.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-liftedbar-left-tablet-3665178386.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-liftedbar-right-desktop-2027904593.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-liftedbar-right-tablet-1999618345.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-panel.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-testimonial-1.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-testimonial-2.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-testimonial-audi.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-testimonial-hubspot.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-testimonial-kiva.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/team24_card.webp-3094176962.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/team24promo.webp-432199718.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/team24promobanner.webp-3262748562.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/team24promobannerwithdates.webp-3177688311.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/team24promowithdates.webp-3515396547.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/team24widerpromobanner.webp-2328022111.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/team_24_logo.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/team_anywear_illo.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/template-blogpost.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/template-brainwriting-theme-white-v2.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/template-brainwriting-theme-white.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/template-choice-business-card-header.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/template-choice-kanban-card-header.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/template-choice-scrum-card-header-update.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/template-choice-scrum-card-header.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/template-confluence-chart.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/template_library-2X.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/templates-screenshot.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/templatesScreen@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/test_png.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial-roblox.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial1.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial2.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial3.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial4.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/timeline-view-de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/timeline-view-fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/timeline_view_(1.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/timeline_view_updated.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/toast_logo_n70_1.svg',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/track-bugs2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/track-bugs_de-DE.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/track-bugs_fr-FR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/track-bugs_ja-JP.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/track-bugs_pt-BR.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/trophy.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/trophy.webp-3079354842.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/trust-center-cloud-icon-3087608378.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/underline-header.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/unified-service-view.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/unitedfigma-3439270545.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/upgradescreen.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/user-icon-scottf.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/variant-1-customer-service.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/variant-1-hero-employee-support.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/variant-1-hero-engineering-support.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/variant-1-hero-it-management-tab.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/variant-1-hero-it-operations.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/variant-2-hero-customer-service.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/variant-2-hero-employee-support.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/variant-2-hero-engineering-support.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/variant-2-hero-it-operations.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/variant-2-hero-it-support.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/very-group-rob-crompton-1788084465.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/video-play-light.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/wac_banner_background_11_14_23.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/wac_lifted_bar_bg.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/wac_lifted_bar_bg_lu.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/wac_lifted_bar_tablet_bg.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/weeklyStatus@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/welcome-login-product.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/whiteboards.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/workflow-diagram.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/workflow.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/wrike-368502576.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/yale_school_mgmt_logo.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/yellow-gestural-lines-2995366884.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/yourEntireTeamOnOnePlatform@2x.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/zendesk-97087002.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/zoom-1703389861.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/zoom-logo-3117034915.webp',
            'https://wac-cdn.atlassian.com/misc-assets/webp-images/zoom.webp'
        ]
    }
];

});


parcelRegister("1mtK6", function(module, exports) {
$parcel$export(module.exports, "CustomersLandingPage", function () { return $b5b303b3fe3c05f9$export$ba23a27a05802abe; });
/* customers-landing-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");

var $4ccia = parcelRequire("4ccia");

var $4EfnG = parcelRequire("4EfnG");

var $2Aj98 = parcelRequire("2Aj98");
const $b5b303b3fe3c05f9$var$relayUnavailableCss = null;
const $b5b303b3fe3c05f9$var$CustomersLandingRelayUnavailable = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "data-testid": "customers-landing-relay-unavailable",
        role: "status",
        className: (0, $2jatx.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1fdn _1rjcoahv _18zrxy5q"
        ]),
        children: intl.formatMessage({
            id: 'CustomersLandingPage.relayUnavailable',
            defaultMessage: 'This page could not be loaded. Refresh the page or try again later.'
        })
    });
};
const $b5b303b3fe3c05f9$var$CustomersLandingPageWithQuery = ({ queryRef: queryRef })=>{
    const preloadedQueryResult = (0, $f3gS9.usePreloadedQuery)((0, $4ccia.CustomerLandingPageRelayQuery), queryRef);
    const contentfulResponse = (0, $4ccia.CustomerLandingPageContentfulResponse)(preloadedQueryResult);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4EfnG.default), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Aj98.CustomersLandingPageRelayTemplate), {
            // @ts-ignore
            customerLanding: contentfulResponse
        })
    });
};
const $b5b303b3fe3c05f9$export$ba23a27a05802abe = ({ queryRef: queryRef })=>{
    if (!queryRef) return /*#__PURE__*/ (0, $7VQPk.jsx)($b5b303b3fe3c05f9$var$CustomersLandingRelayUnavailable, {});
    return /*#__PURE__*/ (0, $7VQPk.jsx)($b5b303b3fe3c05f9$var$CustomersLandingPageWithQuery, {
        queryRef: queryRef
    });
};

});
parcelRegister("2Aj98", function(module, exports) {
$parcel$export(module.exports, "CustomersLandingPageRelayTemplate", function () { return $2ac8f5f1195b6d64$export$1d3625540e7063b8; });
/* eslint-disable complexity */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");

var $bQjAr = parcelRequire("bQjAr");

var $jsxHL = parcelRequire("jsxHL");

var $iLjCW = parcelRequire("iLjCW");

var $hcVGp = parcelRequire("hcVGp");

var $h8xfN = parcelRequire("h8xfN");

var $5bCKL = parcelRequire("5bCKL");

var $9K8X0 = parcelRequire("9K8X0");

var $gZvpb = parcelRequire("gZvpb");

var $lksJ1 = parcelRequire("lksJ1");

var $03nan = parcelRequire("03nan");
parcelRequire("gD5LF");
var $hBvFS = parcelRequire("hBvFS");
var $1ODGq = parcelRequire("1ODGq");
var $6eXit = parcelRequire("6eXit");

var $4U3Z4 = parcelRequire("4U3Z4");
const $2ac8f5f1195b6d64$var$STORIES_AT_A_TIME = 10;
const $2ac8f5f1195b6d64$var$productOrder = [
    'Jira',
    'Jira Service Management',
    'Jira Align',
    'Jira Product Discovery',
    'Confluence',
    'Trello',
    'Bitbucket',
    'Atlassian Access',
    'Guard',
    'Statuspage',
    'Compass',
    'Bamboo'
];
const $2ac8f5f1195b6d64$var$orgSizeOrder = [
    'Small/Medium',
    // Small/Medium
    'Enterprise',
    // Enterprise
    'Large Enterprise' // Large Enterprise
];
const $2ac8f5f1195b6d64$export$1b8a19b49348996e = (customers, filterByEnterprise)=>{
    const industry = (0, $hBvFS.getFilterOptions)(customers.filters?.industries);
    const region = (0, $hBvFS.getFilterOptions)(customers.filters?.regions, 'region');
    const product = (0, $hBvFS.getFilterOptions)(customers.filters?.products);
    const solution = (0, $hBvFS.getFilterOptions)(customers.filters?.solutions);
    let teamSize = (0, $hBvFS.getFilterOptions)(customers.filters?.teamSizes, 'team size');
    const defaulted = {
        ...(0, $1ODGq.defaultCustomerStoryFilterOptionsObject)
    };
    if (Object.keys(industry).length) defaulted.industry = industry;
    if (Object.keys(region).length) defaulted['more filters'] = {
        ...defaulted['more filters'],
        ...region
    };
    const teamEnterpriseOverride = {
        Enterprise: {
            committedActive: true,
            stagedActive: true,
            grouping: 'team size'
        }
    };
    if (filterByEnterprise) teamSize = {
        ...teamSize,
        ...teamEnterpriseOverride
    };
    if (Object.keys(teamSize).length) defaulted['more filters'] = {
        ...defaulted['more filters'],
        ...teamSize
    };
    if (Object.keys(solution).length) defaulted.solution = solution;
    if (Object.keys(product).length) defaulted.product = product;
    return defaulted;
};
const $2ac8f5f1195b6d64$export$970674147b1999f = (data)=>{
    const filters = data?.filters?.edges.sort((a, b)=>a.node.context.name < b.node.context.name ? -1 : 1);
    const result = {
        // Ordering (sys_publishedAt_DESC) and filtering (publishedAt_exists: true)
        // are handled directly in the Contentful GraphQL query.
        customerStories: data?.customerStories?.edges.map((story)=>(0, $4U3Z4.flattenTemplateImageAssets)(story.node)),
        // Get lists to populate filters, by category
        filters: {
            industries: filters?.filter((filter)=>filter?.node?.field === 'industry').map((filter)=>filter?.node?.context),
            regions: filters?.filter((filter)=>filter?.node?.field === 'region').map((filter)=>filter?.node?.context),
            solutions: filters?.filter((filter)=>filter?.node?.field === 'solution').map((filter)=>filter?.node?.context),
            teamSizes: filters?.filter((filter)=>filter?.node?.field === 'organizationSize').map((filter)=>filter?.node?.context).sort((a, b)=>{
                const aIndex = $2ac8f5f1195b6d64$var$orgSizeOrder.indexOf(a.name);
                const bIndex = $2ac8f5f1195b6d64$var$orgSizeOrder.indexOf(b.name);
                if (aIndex < 0) return 1;
                else if (bIndex < 0) return -1;
                return aIndex - bIndex;
            }),
            products: filters?.filter((filter)=>filter?.node?.field === 'products').map((filter)=>filter?.node?.context).sort((a, b)=>{
                const aIndex = $2ac8f5f1195b6d64$var$productOrder.indexOf(a.name);
                const bIndex = $2ac8f5f1195b6d64$var$productOrder.indexOf(b.name);
                if (aIndex < 0) return 1;
                else if (bIndex < 0) return -1;
                return aIndex - bIndex;
            })
        }
    };
    return result;
};
const $2ac8f5f1195b6d64$export$1d3625540e7063b8 = ({ customerLanding: customerLanding })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const filterByEnterpriseParam = $2ac8f5f1195b6d64$var$getFilterByEnterpriseParam();
    const [filterByEnterprise, setFilterByEnterprise] = (0, $1oC0p.useState)(filterByEnterpriseParam);
    const customers = $2ac8f5f1195b6d64$export$970674147b1999f(customerLanding);
    const [filterObjectValue, setFilterObjectValue] = (0, $1oC0p.useState)($2ac8f5f1195b6d64$export$1b8a19b49348996e(customers, filterByEnterprise));
    const [searchFilterString, setSearchString] = (0, $1oC0p.useState)('');
    const [searchInputFieldFocused, setSearchInputFieldFocused] = (0, $1oC0p.useState)(false);
    const [filterSearchhasRun, setFilterSearchHasRun] = (0, $1oC0p.useState)(false);
    const [customerStoryList, updateCustomerStoryList] = (0, $1oC0p.useState)(customers.customerStories);
    const [numberOfCustomerStories, setNumberOfCustomerStories] = (0, $1oC0p.useState)(customerStoryList?.length);
    const [numberOfVisibleStories, setNumberOfVisibleStories] = (0, $1oC0p.useState)($2ac8f5f1195b6d64$var$STORIES_AT_A_TIME);
    (0, $1oC0p.useEffect)(()=>{
        setNumberOfCustomerStories(customerStoryList?.length);
    }, [
        customerStoryList
    ]);
    (0, $1oC0p.useEffect)(()=>{
        // if the URL parameter `filterByEnterprise` is true, and we have received customer stories
        // proceed to run a search with the enterprise filter
        if (filterByEnterprise && customers.customerStories.length > 0) {
            runSearchWithFilters(filterObjectValue, '');
            //set to false so that getDefaultFilterObject() ignores overriding the teamSize filter
            setFilterByEnterprise(false);
        }
    // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        customers
    ]);
    const clearAllFilters = ()=>{
        setFilterObjectValue($2ac8f5f1195b6d64$export$1b8a19b49348996e(customers, filterByEnterprise));
        updateCustomerStoryList(customers.customerStories);
        setSearchString('');
        setSearchInputFieldFocused(false);
        setFilterSearchHasRun(false);
    };
    const clearSearchField = ()=>{
        setSearchString('');
        setSearchInputFieldFocused(false);
        runSearchWithFilters(filterObjectValue, '');
    };
    const setSearchStringWrapper = (searchString)=>{
        setSearchString(searchString);
    };
    const loadMoreStories = ()=>{
        setNumberOfVisibleStories(numberOfVisibleStories + $2ac8f5f1195b6d64$var$STORIES_AT_A_TIME);
    };
    const runSearchWithFilters = (filterObject, searchString)=>{
        const normalizedSearchString = searchString.toLowerCase() ?? '';
        const filtersAreActive = (0, $hBvFS.areFiltersAreActive)(filterObject);
        if (!filtersAreActive && normalizedSearchString.length === 0) {
            setFilterSearchHasRun(false);
            if (customers.customerStories.length !== numberOfCustomerStories) updateCustomerStoryList(customers.customerStories);
            return;
        }
        // Initial text based search
        const searchResults = customers.customerStories?.filter((story)=>{
            if (searchFilterString?.length) return story.title?.toLowerCase()?.includes(normalizedSearchString) || story.customerCompany?.name?.toLowerCase()?.includes(normalizedSearchString) || story.urlSlug?.toLowerCase()?.includes(normalizedSearchString) || story.customerCompany?.region?.name?.toLowerCase()?.includes(normalizedSearchString) || // @ts-expect-error -- industry/products types have optional fields not reflected in filter callback
            story.customerCompany?.industry?.filter((industry)=>industry.name?.toLowerCase()?.includes(normalizedSearchString))?.length || // @ts-expect-error -- industry/products types have optional fields not reflected in filter callback
            story.products?.filter((product)=>product.name?.toLowerCase()?.includes(normalizedSearchString))?.length || story.customerCompany?.organizationSize?.name?.toLowerCase()?.includes(normalizedSearchString);
            return true;
        });
        const filterResults = (0, $6eXit.filterCustomerStories)(searchResults, filterObject, 'committedActive');
        updateCustomerStoryList(filterResults);
        setFilterSearchHasRun(true);
        createAnalyticsEvent({
            eventComponent: 'customerFilter',
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'component',
            attributes: {
                filtersApplied: (0, $hBvFS.getFilterEventProps)(filterObject),
                page_path: '/customers'
            }
        }).fire();
    };
    // In order to get the number of Customer Stories matching the stagedActive filter
    // we need to we'll call the filterCustomerStories function with the stagedActive flag
    const numberOfCustomerStoriesFilteredByStagedActive = (0, $1oC0p.useMemo)(()=>{
        return (0, $6eXit.filterCustomerStories)(customers.customerStories, filterObjectValue, 'stagedActive')?.length;
    }, [
        filterObjectValue,
        customers.customerStories
    ]);
    let fallbackCustomerStoryList = (0, $1oC0p.useMemo)(()=>{
        return [];
    }, []);
    fallbackCustomerStoryList = (0, $1oC0p.useMemo)(()=>{
        return (0, $hBvFS.handleFallbackCustomerStories)(customers.customerStories);
    }, [
        customers.customerStories
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $bQjAr.default), {
        name: "customers-page",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hcVGp.GlobalNav), {
                isShowTryNowLink: true,
                productKey: "customers"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jsxHL.TypographyStyles), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $h8xfN.CarouselSection), {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gZvpb.CustomersPrimaryCtaBand), {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9K8X0.CustomerStoryFilters), {
                        filterObject: filterObjectValue,
                        clearAllFilterButtonClickHandler: clearAllFilters,
                        setFilterObjectValue: setFilterObjectValue,
                        runSearchWithFilters: runSearchWithFilters,
                        numberOfCustomerStoriesByCommittedValues: numberOfCustomerStories,
                        numberOfCustomerStoriesByStagedValues: numberOfCustomerStoriesFilteredByStagedActive,
                        searchStringValue: searchFilterString,
                        searchInputFieldFocused: searchInputFieldFocused,
                        setSearchInputFieldFocused: setSearchInputFieldFocused,
                        clearSearchField: clearSearchField,
                        setSearchString: setSearchStringWrapper,
                        hasFilterSearchRun: filterSearchhasRun
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5bCKL.CustomerStoriesSection), {
                        totalNumberOfCustomerStories: numberOfCustomerStories,
                        customerStoryList: customerStoryList?.slice(0, numberOfVisibleStories),
                        fallbackCustomerStoryList: fallbackCustomerStoryList,
                        filterSearchHasRun: filterSearchhasRun,
                        loadMoreStories: loadMoreStories
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $03nan.GlobalStatsSection), {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lksJ1.FutureOfTeamwork), {})
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iLjCW.GlobalFooter), {})
        ]
    });
};
const $2ac8f5f1195b6d64$var$getFilterByEnterpriseParam = ()=>{
    const { searchParams: searchParams } = new URL(window.location.href);
    const enterpriseParam = searchParams.get('filterByEnterprise');
    return enterpriseParam === 'true';
};

});
parcelRegister("h8xfN", function(module, exports) {
$parcel$export(module.exports, "CarouselSection", function () { return $7494b97c76b7cdcf$export$5edf3752a9da9c72; });
/* carousel-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kbpa7 = parcelRequire("kbpa7");

var $i1SI4 = parcelRequire("i1SI4");

var $jQ0cd = parcelRequire("jQ0cd");

var $4X0dO = parcelRequire("4X0dO");
const $7494b97c76b7cdcf$export$5edf3752a9da9c72 = ()=>{
    const intl = (0, $8e22h.default)();
    const tryItFreeHref = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=jira-software&edition=free');
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $bQjAr.default), {
        name: "customers-page-testimonial",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                layout: "8-4",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                    className: (0, $2jatx.default)([
                        "_1kd31nn1"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "CustomersLandingPage.CustomerStoriesCarouselSection.header",
                        values: {
                            span: (chunks)=>{
                                return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    children: chunks
                                });
                            }
                        },
                        defaultMessage: "Customer stories <span>driven by the power of teamwork</span>"
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $i1SI4.CustomerTestimonials), {
                testimonials: $7494b97c76b7cdcf$var$Testimonials(),
                productKey: "customers",
                secondaryCta: {
                    experiment: (0, $4X0dO.experiments).cfindWacCustomersTryItFreeV1,
                    text: intl.formatMessage({
                        id: 'CustomersLandingPage.tryItFree.cta.text',
                        defaultMessage: 'Try it free'
                    }),
                    href: tryItFreeHref
                }
            })
        ]
    });
};
const $7494b97c76b7cdcf$var$h1Styles = null;
const $7494b97c76b7cdcf$var$Testimonials = ()=>{
    const intl = (0, $8e22h.default)();
    const mercedesBenzTestimonial = {
        name: "Magnus \xd6stberg",
        logo: {
            contentType: 'image',
            src: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12T9B.svg',
            alt: 'Mercedes Benz'
        },
        title: intl.formatMessage({
            id: 'CustomersLandingPage.testimonial.mercedes-benz.title',
            defaultMessage: 'Chief Software Officer, Mercedes-Benz'
        }),
        image: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N9T8.png',
        quote: intl.formatMessage({
            id: 'CustomersLandingPage.testimonial.mercedes-benz.quote',
            defaultMessage: "We can only achieve our goals for speed and deliver on our promise for software-defined vehicles when we have a great platform. That\u2019s why we rely on Atlassian."
        }),
        link: {
            text: intl.formatMessage({
                id: 'CustomersLandingPage.testimonial.link.text',
                defaultMessage: 'Read customer story'
            }),
            url: (0, $jQ0cd.useLocalizedHref)('/customers/mercedes-benz')
        },
        label: 'Mercedes Benz'
    };
    const ciscoTestimonial = {
        name: 'Jason Andrews',
        logo: {
            contentType: 'image',
            src: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12EVAP.svg',
            alt: 'Cisco'
        },
        title: intl.formatMessage({
            id: 'CustomersLandingPage.testimonial.cisco.title',
            defaultMessage: "Vice President of Strategy & Planning \u2013 Engineering Operations, Cisco"
        }),
        image: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12EQOG.png',
        quote: intl.formatMessage({
            id: 'CustomersLandingPage.testimonial.cisco.quote',
            defaultMessage: "As we\u2019ve started to build a System of Work with Atlassian, tooling spend is down 54% annually, and we\u2019ve been able to reinvest 40% of our OpEx expenses back into the business within three years \u2013 without dropping work."
        }),
        link: {
            text: intl.formatMessage({
                id: 'CustomersLandingPage.testimonial.link.text',
                defaultMessage: 'Read customer story'
            }),
            url: (0, $jQ0cd.useLocalizedHref)('/customers/cisco')
        },
        label: 'Cisco'
    };
    const dominosTestimonial = {
        name: 'Matthias Hansen',
        logo: {
            contentType: 'image',
            src: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12LMY1.svg',
            alt: "Domino's"
        },
        title: intl.formatMessage({
            id: 'CustomersLandingPage.testimonial.dominos.title',
            defaultMessage: "Group CTO, Domino's"
        }),
        image: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12E20H.png',
        quote: intl.formatMessage({
            id: 'CustomersLandingPage.testimonial.dominos.quote',
            defaultMessage: "At Domino\u2019s, we have a motto: \u2018Every order counts.\u2019 Rolling out the Atlassian system of work allowed us to successfully deliver on that promise."
        }),
        link: {
            text: intl.formatMessage({
                id: 'CustomersLandingPage.testimonial.link.text',
                defaultMessage: 'Read customer story'
            }),
            url: (0, $jQ0cd.useLocalizedHref)('/customers/dominos')
        },
        label: "Domino's"
    };
    const deliveryHeroTestimonial = {
        name: 'Jousef Waggad',
        logo: {
            contentType: 'image',
            src: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12EEB7.png',
            alt: 'Delivery Hero'
        },
        title: intl.formatMessage({
            id: 'CustomersLandingPage.testimonial.delivery-hero.title',
            defaultMessage: 'Atlassian Administrator, Delivery Hero'
        }),
        image: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12EEB1.png',
        quote: intl.formatMessage({
            id: 'CustomersLandingPage.testimonial.delivery-hero.quote',
            defaultMessage: 'After comparing collaboration and productivity tools, I knew Atlassian should be our #1 platform. Everything else felt too simple or too complex. Atlassian was intuitive enough for our basic users and advanced enough for our power users.'
        }),
        link: {
            text: intl.formatMessage({
                id: 'CustomersLandingPage.testimonial.link.text',
                defaultMessage: 'Read customer story'
            }),
            url: (0, $jQ0cd.useLocalizedHref)('/customers/delivery-hero')
        },
        label: 'Delivery Hero'
    };
    const brevilleTestimonial = {
        name: 'Roni Nestorovski',
        logo: {
            contentType: 'image',
            src: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT14QNK.png',
            alt: 'Breville'
        },
        title: intl.formatMessage({
            id: 'CustomersLandingPage.testimonial.breville.title',
            defaultMessage: 'Global Service Delivery Manager, Breville'
        }),
        image: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT17M86.png',
        quote: intl.formatMessage({
            id: 'CustomersLandingPage.testimonial.breville.quote',
            defaultMessage: 'In no time, we had a single point of contact for all support across Breville.'
        }),
        link: {
            text: intl.formatMessage({
                id: 'CustomersLandingPage.testimonial.link.text',
                defaultMessage: 'Read customer story'
            }),
            url: (0, $jQ0cd.useLocalizedHref)('/customers/breville')
        },
        label: 'Breville'
    };
    return [
        mercedesBenzTestimonial,
        ciscoTestimonial,
        dominosTestimonial,
        deliveryHeroTestimonial,
        brevilleTestimonial
    ];
};

});
parcelRegister("i1SI4", function(module, exports) {
$parcel$export(module.exports, "CustomerTestimonials", function () { return $82b7f8eaea519598$export$ff99f9acc73d9931; });
/* customer-testimonials.tsx generated by @compiled/babel-plugin v0.28.8 */ // Initial changes from ADG4CustomerTestimonials
// Removed scroll Ref and inview tracker, since there is no longer an automatic transition to new tabs
// Removed className since it was not in use
// Removed testimonialCta since that is a non standard usage in the Confluence Product Tour and clouds the core Design Pattern
// Removed Blue as an option for backgrounds for now since that is not spec
// Removed h2 heading (that should be included as a Content Block separately going forward)
// Removed TypographyStyles wrapper for consistency with other components/patterns
// Cleaned up unused classnames within the component

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $9s3Hk = parcelRequire("9s3Hk");

var $90TSV = parcelRequire("90TSV");

var $ilkqI = parcelRequire("ilkqI");

var $iyOcM = parcelRequire("iyOcM");

var $ftgEA = parcelRequire("ftgEA");

var $bSVv5 = parcelRequire("bSVv5");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $hfzfc = parcelRequire("hfzfc");
// Not able to use wacToken function with cssMap. Need to refactor this in the future to use dynamic functions
const $82b7f8eaea519598$var$backgroundColorStyleMap = {
    black: "_bfhkr3uz",
    white: "_bfhku67f"
};
const $82b7f8eaea519598$var$backgroundShape = null;
const $82b7f8eaea519598$var$fontColorStyleMap = {
    'dark-bg': "_syaz12cp",
    'white-bg': "_syazn7od"
};
const $82b7f8eaea519598$var$topLineStyleMap = {
    black: "_bfhku67f",
    white: "_bfhkr3uz"
};
const $82b7f8eaea519598$var$logoOptionStyleMap = {
    'dark-bg': "_d4ksu67f _i862u67f _1uiy16sm",
    'white-bg': "_d4ksr3uz _i862r3uz"
};
const $82b7f8eaea519598$var$justifyContentStyleMap = {
    'dark-bg': "_1bahh9n0",
    'white-bg': "_1bah1h6o"
};
const $82b7f8eaea519598$export$ff99f9acc73d9931 = ({ bgColor: bgColor = 'black', testimonials: testimonials, productKey: productKey, secondaryCta: secondaryCta })=>{
    const bgTheme = bgColor === 'black' ? 'dark-bg' : 'white-bg';
    const renderTestimonials = (showSecondaryCta)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iyOcM.Adg4Tabs), {
            loop: true,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _1pbykb7n _6rth1jfw",
                        $82b7f8eaea519598$var$fontColorStyleMap[bgTheme]
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                        layout: "12",
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_kqswstnw _1r04idpf _1bsb1lk2 _p12fklux _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1rfm1osq",
                                        $82b7f8eaea519598$var$backgroundColorStyleMap[bgColor],
                                        bgColor === 'black' && "_mkrzq8qa _kxoh75ra"
                                    ])
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c11p5 _yv0ehkll _2z05hkll _1ir7idpf _bhknkb7n _1rrs1txw _s9hn1ekt _16l7kb7n _w53ccs5v"
                                    ]),
                                    children: testimonials.map((testimonial, index)=>{
                                        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ilkqI.Adg4TabPanel), {
                                            id: `${index}`,
                                            panelIndex: index,
                                            forceRender: true,
                                            hideTabPanelRole: testimonials.length === 1,
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)($82b7f8eaea519598$var$TopRowContent, {
                                                testimonial: testimonial,
                                                index: index,
                                                bgTheme: bgTheme,
                                                bgColor: bgColor,
                                                productKey: productKey,
                                                secondaryCta: secondaryCta,
                                                showSecondaryCta: showSecondaryCta
                                            })
                                        }, index);
                                    })
                                }),
                                testimonials.length > 1 && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_kqswh2mm _1e0c1txw _1p57pxbi _1n261g80 _4cvr1fhb _1gde1bp4 _xsmr1h6o"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1reo15vq _18m915vq _1bsb1osq _1bah1yb4 _1v611bp4 _476dgktf"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $90TSV.Adg4DraggableTabList), {
                                            rowGap: "32px",
                                            className: (0, $2jatx.default)([
                                                "_6rth1fu0 _1q511aa3 _qtt8agmp"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_kqswstnw _152tt94y _1e02idpf _rjxpidpf _4t3it94y _2rkoyh40 _tzy4105o _xaej183y",
                                                        $82b7f8eaea519598$var$topLineStyleMap[bgColor]
                                                    ])
                                                }),
                                                testimonials.map((testimonial, index)=>{
                                                    return testimonial.logo ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9s3Hk.Adg4DraggableTab), {
                                                        as: "li",
                                                        tabIndex: index,
                                                        dataEventProps: {
                                                            'data-product-key': productKey,
                                                            'data-event-component': 'tab',
                                                            'data-event-container': 'testimonialsSection',
                                                            'data-event': 'clicked',
                                                            'data-label-english': testimonial.label
                                                        },
                                                        label: testimonial.label,
                                                        className: (0, $2jatx.default)([
                                                            $82b7f8eaea519598$var$logoOptionStyleMap[bgTheme],
                                                            "_1e0c1txw _1bah1fhb _4cvr1fhb _kqswh2mm _1atpidpf"
                                                        ]),
                                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)($82b7f8eaea519598$var$LogoTabContent, {
                                                            testimonialLogo: testimonial.logo
                                                        })
                                                    }, index) : null;
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        });
    // Hoist the experiment check to the section level so exposure fires exactly
    // once per page view. Rendering ExperimentView inside the per-testimonial
    // loop would fire one exposure per card and corrupt the experiment metrics.
    if (secondaryCta) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hfzfc.ExperimentView), {
        experiment: secondaryCta.experiment,
        render: (isEnabled)=>renderTestimonials(isEnabled)
    });
    return renderTestimonials(false);
};
const $82b7f8eaea519598$var$TopRowContent = ({ testimonial: testimonial, index: index, bgTheme: bgTheme, bgColor: bgColor, isPanelActive: isPanelActive, productKey: productKey, secondaryCta: secondaryCta, showSecondaryCta: showSecondaryCta = false })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _1e0c1txw _1p57pxbi _1n261g80 _4cvr1fhb _1gde1bp4 _xsmr1h6o",
            "_6rth1ylp _1e0c11p5 _yv0ewxkt _gy1pzwfg _tzy4idpf _1pbykb7n _1ph4hkll",
            isPanelActive && "_tzy4kb7n _1pbycs5v"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _i0dlhwvj _1e0c1txw _1bah1h6o _4cvresu3 _16xt1ssb _1rfm1vuk _q5ugidpf _7tld1wug _14adidpf _4uro1wug _7bcc1n8h _18jmidpf _qji61wug _ms0lidpf _v5we1wug"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_bna7ng7t _1jtm1c95 _1fhe1c95 _1cwsdlvw _mezj1wug _rtys1osq _1jpx1f51 _v4pn1ule",
                        isPanelActive && "_m3691nt4"
                    ]),
                    children: typeof testimonial.image !== 'string' && 'contentType' in testimonial.image ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ftgEA.ContentPlatformImage), {
                        ...testimonial.image
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                        src: testimonial.image,
                        alt: ""
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_i0dl1nrf _1reo15vq _18m915vq _bozg1b66 _85i51b66 _1a8l1ssb"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _4t3i1osq _2rkogktf _kqswh2mm _19pkidpf _2hwx1wug _otyridpf _18u01wug _26vxys9h _12rr1e9y _1rfm1osq",
                        $82b7f8eaea519598$var$justifyContentStyleMap[bgTheme]
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_v5641pn7 _1e0c1txw _2lx21bp4 _zulp1tcg",
                            isPanelActive && "_y44v13sw _11vozap6"
                        ]),
                        children: [
                            testimonial.eyebrow && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    $82b7f8eaea519598$var$fontColorStyleMap[bgTheme],
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "eyebrow-md"
                                ]),
                                children: testimonial.eyebrow
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("blockquote", {
                                className: (0, $2jatx.default)([
                                    $82b7f8eaea519598$var$fontColorStyleMap[bgTheme],
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "callout"
                                ]),
                                children: [
                                    "\u201C",
                                    testimonial.quote,
                                    "\u201D"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            $82b7f8eaea519598$var$fontColorStyleMap[bgTheme],
                                            "eyebrow-lg"
                                        ]),
                                        children: testimonial.name
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            $82b7f8eaea519598$var$fontColorStyleMap[bgTheme],
                                            "body-md title"
                                        ]),
                                        children: testimonial.title
                                    })
                                ]
                            }),
                            testimonial.link || secondaryCta && showSecondaryCta ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1n261g80 _4cvr1h6o _gy1p1tcg _1p57ftgi"
                                ]),
                                children: [
                                    testimonial.link ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                        anchorProps: {
                                            tabIndex: isPanelActive ? 0 : -1
                                        },
                                        text: testimonial.link.text,
                                        href: testimonial.link.url,
                                        type: testimonial.link.type ?? 'primary',
                                        bgColor: bgColor === 'black' ? 'bgBlackBlue' : 'bgWhite',
                                        "aria-label": testimonial.link.text,
                                        dataEventProps: testimonial.link.dataEventProps ?? {
                                            'data-product-key': productKey,
                                            'data-event-component': 'linkButton',
                                            'data-event-container': 'testimonialsSection',
                                            'data-event': 'clicked'
                                        }
                                    }) : null,
                                    secondaryCta && showSecondaryCta ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                        anchorProps: {
                                            tabIndex: isPanelActive ? 0 : -1
                                        },
                                        text: secondaryCta.text,
                                        href: secondaryCta.href,
                                        type: "primary",
                                        bgColor: bgColor === 'black' ? 'bgBlackBlue' : 'bgWhite',
                                        "aria-label": secondaryCta.text,
                                        showArrow: true,
                                        dataEventProps: // The `customerStoryCard` container is only valid in the
                                        // DataEventProps union variant keyed to the 'customers'
                                        // product key, so this fallback is intentionally
                                        // surface-specific. Callers on other surfaces should pass
                                        // their own `secondaryCta.dataEventProps`.
                                        secondaryCta.dataEventProps ?? {
                                            'data-product-key': 'customers',
                                            'data-event-component': 'link',
                                            'data-event-container': 'customerStoryCard',
                                            'data-event': 'clicked'
                                        }
                                    }) : null
                                ]
                            }) : null
                        ]
                    }, index)
                })
            })
        ]
    });
};
const $82b7f8eaea519598$var$topRowActiveStyle = null;
const $82b7f8eaea519598$var$customerImagesImgActiveStyle = null;
const $82b7f8eaea519598$var$quoteContainerActiveStyle = null;
const $82b7f8eaea519598$var$LogoTabContent = ({ testimonialLogo: testimonialLogo, isSelected: isSelected = false })=>{
    const isContentfulImage = 'contentType' in testimonialLogo;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_tzy4kb7n _kqswstnw _152tj39m _1e02idpf _rjxpidpf _4t3i14y2 _2rkoyh40",
                    "top-marker"
                ])
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_11q7glyw _19itidpf _r06hglyw _1q51gktf _80omtlke _kqswh2mm"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_tzy4105o _v5641bs3 _16l4kb7n",
                        "_4t3i1u1b _1e0c1txw _4cvr1h6o",
                        isSelected && "_tzy4kb7n"
                    ]),
                    children: isContentfulImage ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ftgEA.ContentPlatformImage), {
                        ...testimonialLogo,
                        width: "140",
                        height: "34",
                        style: {
                            objectFit: 'contain',
                            objectPosition: 'center center'
                        },
                        className: "tab-logo",
                        draggable: "false"
                    }) : testimonialLogo
                })
            })
        ]
    });
};
// LogoTabContent styles
const $82b7f8eaea519598$var$logoImgStyle = null;
const $82b7f8eaea519598$var$logoImgSelectedStyle = null;
const $82b7f8eaea519598$var$logoButtonStyle = null;
const $82b7f8eaea519598$var$topMarkerStyle = null;
const $82b7f8eaea519598$var$logoImgContainerStyle = null;
// ADG4CustomerTestimonials styles
const $82b7f8eaea519598$var$topLineStyles = null;
const $82b7f8eaea519598$var$testimonialKeyframeStyles = null;
const $82b7f8eaea519598$var$rowWidthStyle = null;
const $82b7f8eaea519598$var$topRowStyle = null;
const $82b7f8eaea519598$var$bgShapeStyle = null;
const $82b7f8eaea519598$var$customerImagesSectionStyles = null;
const $82b7f8eaea519598$var$customerImagesSectionImageStyles = null;
const $82b7f8eaea519598$var$customerQuotesSectionStyle = null;
const $82b7f8eaea519598$var$testimonialQuotesSectionStyle = null;
const $82b7f8eaea519598$var$quoteContainerStyle = null;
// Lays the primary "Read customer story" link and the experiment-gated
// "Try it free" secondary CTA inline (side by side), matching the poster's
// "inline to the right of the existing CTA" treatment spec. Wraps on narrow
// viewports so the card layout stays intact.
const $82b7f8eaea519598$var$ctaRowStyle = null;
const $82b7f8eaea519598$var$quoteContainerPStyle = null;
const $82b7f8eaea519598$var$logosContainerBaseStyle = null;
const $82b7f8eaea519598$var$logosStyle = null;
const $82b7f8eaea519598$var$logoOptionStyle = null;
const $82b7f8eaea519598$var$testimonialStyles = null;
const $82b7f8eaea519598$var$tabPanelWrapperStyles = null;

});
parcelRegister("ilkqI", function(module, exports) {
$parcel$export(module.exports, "Adg4TabPanel", function () { return $640ef6c57a5f1486$export$34e8382484247e57; });
/* tab-panel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $lTkkF = parcelRequire("lTkkF");

var $6jJHH = parcelRequire("6jJHH");

var $iyOcM = parcelRequire("iyOcM");
const $640ef6c57a5f1486$var$hidePanelStyle = null;
/**
 * @deprecated - Please use @/libraries/design/patterns/tabs instead
 */ const $640ef6c57a5f1486$export$34e8382484247e57 = ({ forceRender: forceRender, keepInDom: keepInDom, children: children, panelIndex: panelIndex, id: id, hideTabPanelRole: hideTabPanelRole, ...props })=>{
    const { isCurrentTab: isCurrentTab } = (0, $iyOcM.useAdg4TabsContext)();
    const isTabSelected = isCurrentTab(panelIndex);
    const activeClass = isTabSelected ? 'active-panel' : '';
    const originalChildrenCount = (0, $1oC0p.Children).count(children);
    const shouldHideRole = hideTabPanelRole !== undefined ? hideTabPanelRole : originalChildrenCount === 0;
    children = forceRender || isTabSelected || keepInDom ? children : null;
    const { panelId: panelId, tabId: tabId } = (0, $lTkkF.generateSafeIds)(id, panelIndex);
    const { css: existingCss, ...propsWithoutCss } = props;
    const filteredProps = Object.fromEntries(Object.entries(propsWithoutCss).filter(([key])=>!key.startsWith('aria-') && key !== 'role'));
    if (!shouldHideRole) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ...filteredProps,
        id: panelId,
        "aria-labelledby": tabId,
        "aria-hidden": !isTabSelected,
        role: "tabpanel",
        className: (0, $2jatx.default)([
            !isTabSelected && !forceRender && "_1e0cglyw",
            [
                'tab-panel',
                activeClass
            ].join(' ')
        ]),
        children: (0, $1oC0p.Children).map(children, (child)=>{
            return (0, $6jJHH.mapChild)(child, {
                isPanelActive: isTabSelected
            });
        })
    });
    const cssProp = [
        !isTabSelected && !forceRender && $640ef6c57a5f1486$var$hidePanelStyle
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        id: panelId,
        className: (0, $2jatx.default)([
            !isTabSelected && !forceRender && "_1e0cglyw",
            [
                'tab-panel',
                activeClass
            ].join(' ')
        ]),
        "aria-labelledby": undefined,
        "aria-hidden": undefined,
        role: undefined,
        children: (0, $1oC0p.Children).map(children, (child)=>{
            return (0, $6jJHH.mapChild)(child, {
                isPanelActive: isTabSelected
            });
        })
    });
};
$640ef6c57a5f1486$export$34e8382484247e57.tabsRole = 'Adg4TabPanel';

});

parcelRegister("ftgEA", function(module, exports) {
$parcel$export(module.exports, "ContentPlatformImage", function () { return $93bafa18ccb06246$export$f8e4eb6f7b9af79c; });

var $7VQPk = parcelRequire("7VQPk");

var $hnmMQ = parcelRequire("hnmMQ");
const $93bafa18ccb06246$export$f8e4eb6f7b9af79c = ({ contentType: contentType, src: src, alt: alt, baseWidth: baseWidth, ...rest })=>{
    const queryPairs = [];
    let srcSet = [];
    if (contentType === 'image/png') {
        queryPairs.push('fm=webp');
        if (baseWidth) {
            srcSet = (0, $hnmMQ.getSrcSet)(src, baseWidth, queryPairs, 'w');
            queryPairs.push(`w=${baseWidth}`);
        }
    }
    const queryString = queryPairs.length > 0 ? `?${queryPairs.join('&')}` : '';
    return(// eslint-disable-next-line no-restricted-syntax
    /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
        loading: "lazy",
        ...rest,
        src: `${src}${queryString}`,
        srcSet: srcSet.length > 0 ? srcSet.join(',') : undefined,
        alt: alt
    }));
};

});



parcelRegister("5bCKL", function(module, exports) {
$parcel$export(module.exports, "CustomerStoriesSection", function () { return $e854fc08d1c2ace6$export$48ea351ea7a5a012; });
/* customer-stories.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $7qFQI = parcelRequire("7qFQI");

var $lmQGF = parcelRequire("lmQGF");

var $1rGpC = parcelRequire("1rGpC");

var $jsxHL = parcelRequire("jsxHL");

var $2Z9hF = parcelRequire("2Z9hF");

var $fnda5 = parcelRequire("fnda5");

var $hBvFS = parcelRequire("hBvFS");
const $e854fc08d1c2ace6$export$48ea351ea7a5a012 = ({ totalNumberOfCustomerStories: totalNumberOfCustomerStories, customerStoryList: customerStoryList, fallbackCustomerStoryList: fallbackCustomerStoryList, filterSearchHasRun: filterSearchHasRun, loadMoreStories: loadMoreStories })=>{
    const intl = (0, $8e22h.default)();
    const [numStories, setNumStories] = (0, $1oC0p.useState)(0);
    const { width: width } = (0, $hBvFS.useWindowDimensions)();
    const numColumns = (0, $hBvFS.getNumberOfCustomerStoryColumns)(width);
    let storyGrid = (0, $1oC0p.useMemo)(()=>{
        return {};
    }, []);
    storyGrid = (0, $1oC0p.useMemo)(()=>{
        if (numStories !== customerStoryList.length) setNumStories(customerStoryList.length);
        // if the number of columns has changed, re-sort the stories
        if (numColumns !== Object.keys(storyGrid).length) return (0, $hBvFS.sortStoriesByHeight)(storyGrid, customerStoryList.slice(0, numStories), numColumns);
        else return (0, $hBvFS.sortStoriesByHeight)(storyGrid, customerStoryList.slice(0, customerStoryList.length), numColumns);
        return storyGrid;
    }, [
        numStories,
        storyGrid,
        customerStoryList,
        numColumns
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "customers-page-stories-grid",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_6rth12bs"
                ]),
                children: [
                    customerStoryList.length === 0 && filterSearchHasRun ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fnda5.CustomerStoryNoResultsFallback), {
                        numColumns: numColumns,
                        fallbackCustomerStories: fallbackCustomerStoryList
                    }) : customerStoryList.length === 0 && !filterSearchHasRun ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                        layout: '12',
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _1bah1h6o _4cvr1y6m _1pfh1lit _4t3i1us8"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7qFQI.default), {
                                size: "xlarge"
                            })
                        })
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Z9hF.CustomerStoriesGrid), {
                        numColumns: numColumns,
                        storiesGrid: storyGrid
                    }),
                    numStories !== 0 && numStories < totalNumberOfCustomerStories && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                        layout: "12",
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_19pkzwfg _2hwx1wug _otyridpf _18u01wug _1e0c1txw _1n261g80 _2lx21bp4 _1bah1h6o _4cvr1h6o"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "CustomersLandingPage.showingListOfStories",
                                        defaultMessage: "Showing <numberOfCustomerStories></numberOfCustomerStories> of <totalNumberOfCustomerStories></totalNumberOfCustomerStories> stories",
                                        values: {
                                            numberOfCustomerStories: ()=>customerStoryList.length,
                                            totalNumberOfCustomerStories: ()=>totalNumberOfCustomerStories
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                                    variant: "secondary",
                                    color: "black",
                                    onClick: loadMoreStories,
                                    dataEventProps: {
                                        'data-event': 'clicked',
                                        'data-event-component': 'button',
                                        'data-event-container': 'customerStorySection',
                                        'data-product-key': 'customers',
                                        'data-label-english': 'Load more stories'
                                    },
                                    children: intl.formatMessage({
                                        id: 'CustomersLandingPage.loadMoreStories',
                                        defaultMessage: 'Load more stories'
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
const $e854fc08d1c2ace6$var$customerStoryContainerStyles = null;
const $e854fc08d1c2ace6$var$spinnerStyles = null;
const $e854fc08d1c2ace6$var$loadMoreStyles = null;

});
parcelRegister("2Z9hF", function(module, exports) {
$parcel$export(module.exports, "CustomerStoriesGrid", function () { return $e2a07677b6faccb5$export$630103427516de50; });
/* customer-stories-grid.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $1rGpC = parcelRequire("1rGpC");

var $d1ibd = parcelRequire("d1ibd");
const $e2a07677b6faccb5$export$630103427516de50 = ({ storiesGrid: storiesGrid, numColumns: numColumns })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: numColumns === 1 ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
            layout: '12',
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulpzwfg"
                ]),
                children: storiesGrid[0] && storiesGrid[0].stories.map((story, index)=>{
                    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $d1ibd.CustomerStoryCard), {
                        ...story
                    }, index);
                })
            })
        }) : numColumns === 2 ? /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1rGpC.Row), {
            layout: '6-6',
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _zulpzwfg"
                    ]),
                    children: storiesGrid[0] && storiesGrid[0].stories.map((story, index)=>{
                        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $d1ibd.CustomerStoryCard), {
                            ...story
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _zulpzwfg"
                    ]),
                    children: storiesGrid[1] && storiesGrid[1].stories.map((story, index)=>{
                        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $d1ibd.CustomerStoryCard), {
                            ...story
                        }, index);
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1rGpC.Row), {
            layout: '4-4-4',
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _zulpzwfg"
                    ]),
                    children: storiesGrid[0] && storiesGrid[0].stories.map((story, index)=>{
                        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $d1ibd.CustomerStoryCard), {
                            ...story
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _zulpzwfg"
                    ]),
                    children: storiesGrid[1] && storiesGrid[1].stories.map((story, index)=>{
                        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $d1ibd.CustomerStoryCard), {
                            ...story
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _zulpzwfg"
                    ]),
                    children: storiesGrid[2] && storiesGrid[2].stories.map((story, index)=>{
                        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $d1ibd.CustomerStoryCard), {
                            ...story
                        }, index);
                    })
                })
            ]
        })
    });
};
const $e2a07677b6faccb5$var$columnStyles = null;

});
parcelRegister("d1ibd", function(module, exports) {
$parcel$export(module.exports, "CustomerStoryCard", function () { return $98c69aee85a5c0ed$export$ec4bed50821b5168; });
/* customer-story-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $ftgEA = parcelRequire("ftgEA");

var $5HK05 = parcelRequire("5HK05");

var $iPPTB = parcelRequire("iPPTB");

var $jQ0cd = parcelRequire("jQ0cd");
const $98c69aee85a5c0ed$export$ec4bed50821b5168 = ({ title: title, urlSlug: urlSlug, customerCompany: customerCompany, advocateQuotes: advocateQuotes, storyIcon: storyIcon, callToAction: callToAction })=>{
    const href = (0, $jQ0cd.useLocalizedHref)(callToAction?.[0]?.url ?? `/customers/${urlSlug}`);
    const isExternalHref = href.startsWith('https://');
    const advocateQuote = advocateQuotes?.[0];
    const isQuote = !!advocateQuote?.advocateHeadshot?.url;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
        href: href,
        target: isExternalHref ? '_blank' : undefined,
        rel: isExternalHref ? 'noreferrer noopener' : undefined,
        className: (0, $2jatx.default)([
            "_311tkb7n _1dbzjojz _1vpokb7n _ca0q1tcg _u5f31tcg _n3tdzwfg _19bv1tcg _bfhku67f _2rkogktf _16qs1yxe _v56416gf _r57hidpf _zy2nm7ou"
        ]),
        children: [
            customerCompany && (customerCompany?.logo?.[0]?.url ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_6rth1tcg _rtysmlf1 _bna71ylp _1jpx1f51"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ftgEA.ContentPlatformImage), {
                    alt: customerCompany.name ?? customerCompany.logo[0].description ?? ' ',
                    src: customerCompany.logo[0].url,
                    contentType: customerCompany.logo[0].contentType,
                    baseWidth: 200,
                    height: "40px"
                })
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_6rth1tcg _rtysmlf1 _bna71ylp _1jpx1f51"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    children: (0, $5HK05.expectContent)(customerCompany.name)
                })
            })),
            storyIcon?.url && !isQuote && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_6rth1tcg _1e0c1txw _mezj1osq _rtys163v _salg1wug _18zxkb7n"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ftgEA.ContentPlatformImage), {
                    alt: ' ' /* we consider these illustrations decorative */ ,
                    src: storyIcon.url,
                    contentType: storyIcon.contentType,
                    baseWidth: 300
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _zulp1k8s _19pkidpf _2hwxidpf _otyr1tcg _18u0idpf _1b4didpf _vo4eidpf _wotzidpf _1ugbidpf _mezj1osq _rtys1ltq _clfdidpf _11pqidpf _q0a5idpf _c3k8idpf _czr612u0 _xx1w1lzr _btqhidpf _1tadidpf _1ejbidpf _1ahqidpf"
                ]),
                children: advocateQuote?.advocateHeadshot?.url ? /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ftgEA.ContentPlatformImage), {
                            alt: ' ' /* details here would duplicate information elsewhere on the card */ ,
                            src: advocateQuote.advocateHeadshot.url,
                            contentType: advocateQuote.advocateHeadshot.contentType,
                            baseWidth: 400
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                                    children: advocateQuote.advocateName
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    className: "eyebrow-md",
                                    children: advocateQuote.advocateJobTitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("blockquote", {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: "body-lg",
                                children: advocateQuote.advocateQuote
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: "body-lg",
                    children: title
                })
            }),
            callToAction && callToAction[0] && callToAction[0].text && // eslint-disable-next-line @atlassian/a11y/anchor-has-content, @atlassian/a11y/link-name
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                className: "customer-story-link-container",
                href: href,
                text: callToAction[0].text,
                type: "primary",
                isStyleOnly: true
            })
        ]
    });
};
const $98c69aee85a5c0ed$var$customerStoryCardsStyles = null;
const $98c69aee85a5c0ed$var$customerLogoStyles = null;
const $98c69aee85a5c0ed$var$spotIllustrationStyles = null;
const $98c69aee85a5c0ed$var$storyTitleStyles = null;

});


parcelRegister("fnda5", function(module, exports) {
$parcel$export(module.exports, "CustomerStoryNoResultsFallback", function () { return $4e8f8f3882fb2389$export$bdcbebb305fb33c3; });
/* customer-story-no-results-fallback-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $1rGpC = parcelRequire("1rGpC");

var $hBvFS = parcelRequire("hBvFS");

var $2Z9hF = parcelRequire("2Z9hF");
const $4e8f8f3882fb2389$export$bdcbebb305fb33c3 = ({ numColumns: numColumns, fallbackCustomerStories: fallbackCustomerStories })=>{
    const intl = (0, $8e22h.default)();
    const fallbackStoriesGrid = (0, $hBvFS.sortStoriesByHeight)({}, fallbackCustomerStories, numColumns);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
        layout: "12",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4 _y3gn1e5h _amuvangw _1li31tcg"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: "eyebrow-md",
                    children: intl.formatMessage({
                        id: 'CustomersLandingPage.recommendedStories',
                        defaultMessage: 'Recommended stories you may like'
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Z9hF.CustomerStoriesGrid), {
                    storiesGrid: fallbackStoriesGrid,
                    numColumns: numColumns
                })
            ]
        })
    });
};
const $4e8f8f3882fb2389$var$customerStoryRecommendedStoriesStyles = null;

});
parcelRegister("hBvFS", function(module, exports) {
$parcel$export(module.exports, "areFiltersAreActive", function () { return $3baf5d614699af5f$export$caf5989571fe03fd; });
$parcel$export(module.exports, "commitAllStagedActiveValues", function () { return $3baf5d614699af5f$export$995b34954b6e3c5d; });
$parcel$export(module.exports, "setAllStagedActiveToFalse", function () { return $3baf5d614699af5f$export$32ef36095a2643ff; });
$parcel$export(module.exports, "resetAllStagedActiveToCommittedActiveValue", function () { return $3baf5d614699af5f$export$6e8eccaa2da87c2a; });
$parcel$export(module.exports, "getActiveFiltersByFilterType", function () { return $3baf5d614699af5f$export$5c95673afb2371b8; });
$parcel$export(module.exports, "handleFallbackCustomerStories", function () { return $3baf5d614699af5f$export$bb39b836f537201; });
$parcel$export(module.exports, "sortStoriesByHeight", function () { return $3baf5d614699af5f$export$bf9342a233bd676b; });
$parcel$export(module.exports, "getNumberOfCustomerStoryColumns", function () { return $3baf5d614699af5f$export$65d9e924579f6503; });
$parcel$export(module.exports, "useWindowDimensions", function () { return $3baf5d614699af5f$export$f715c0e61b2c1a36; });
$parcel$export(module.exports, "isContentPlatformFacetAvailable", function () { return $3baf5d614699af5f$export$f2735cb33092c31f; });
$parcel$export(module.exports, "getFilterOptions", function () { return $3baf5d614699af5f$export$8ba04a2269d8d395; });
$parcel$export(module.exports, "getFilterEventProps", function () { return $3baf5d614699af5f$export$c09429083a9f1f77; });

var $1oC0p = parcelRequire("1oC0p");
const $3baf5d614699af5f$var$sizeMap = {
    lg: 4,
    md: 3,
    sm: 2
};
const $3baf5d614699af5f$export$caf5989571fe03fd = (filterObject)=>{
    let isActive = false;
    const filterCategories = Object.values(filterObject);
    let i = 0;
    while(!isActive && i < filterCategories.length){
        const filterCategoryValues = filterCategories[i];
        let j = 0;
        while(!isActive && j < Object.values(filterCategoryValues).length){
            const subFilterObject = Object.values(filterCategoryValues)[j];
            if (subFilterObject['committedActive']) isActive = true;
            j++;
        }
        i++;
    }
    return isActive;
};
const $3baf5d614699af5f$export$995b34954b6e3c5d = (prevState)=>{
    return Object.keys(prevState).reduce((acc, filterCategory)=>{
        acc[filterCategory] = {
            ...prevState[filterCategory],
            ...Object.entries(prevState[filterCategory]).reduce((acc, [filterOptionName, filterOptionValue])=>{
                acc[filterOptionName] = {
                    ...filterOptionValue,
                    committedActive: filterOptionValue.stagedActive
                };
                return acc;
            }, {})
        };
        return acc;
    }, {});
};
const $3baf5d614699af5f$export$32ef36095a2643ff = (prevState)=>{
    return Object.keys(prevState).reduce((acc, filterCategory)=>{
        acc[filterCategory] = {
            ...prevState[filterCategory],
            ...Object.entries(prevState[filterCategory]).reduce((acc, [filterOptionName, filterOptionValue])=>{
                acc[filterOptionName] = {
                    ...filterOptionValue,
                    stagedActive: false
                };
                return acc;
            }, {})
        };
        return acc;
    }, {});
};
const $3baf5d614699af5f$export$6e8eccaa2da87c2a = (prevState)=>{
    return Object.keys(prevState).reduce((acc, filterCategory)=>{
        acc[filterCategory] = {
            ...prevState[filterCategory],
            ...Object.entries(prevState[filterCategory]).reduce((acc, [filterOptionName, filterOptionValue])=>{
                acc[filterOptionName] = {
                    ...filterOptionValue,
                    stagedActive: filterOptionValue.committedActive
                };
                return acc;
            }, {})
        };
        return acc;
    }, {});
};
const $3baf5d614699af5f$export$b16988f469572eb0 = (event, filter, onClickHandler)=>{
    if (event.key === 'Enter') onClickHandler(filter);
};
const $3baf5d614699af5f$export$5c95673afb2371b8 = (filter, filterObject)=>{
    if (filter === 'all') return Object.values(filterObject).reduce((acc, filterCategory)=>acc + Object.values(filterCategory).reduce((subacc, filterOption)=>filterOption.committedActive ? subacc + 1 : subacc, 0), 0);
    else return Object.values(filterObject[filter]).reduce((acc, subFilter)=>subFilter.committedActive ? acc + 1 : acc, 0);
};
const $3baf5d614699af5f$var$NUMBER_OF_FALLBACK_STORIES = 3;
const $3baf5d614699af5f$export$bb39b836f537201 = (customerStories)=>{
    const fallbackCustomerStoryList = new Array($3baf5d614699af5f$var$NUMBER_OF_FALLBACK_STORIES);
    const extraFallbackCustomerStoryList = [];
    customerStories.forEach((story)=>{
        switch(story.urlSlug){
            case 'the-very-group':
                fallbackCustomerStoryList[0] = story;
                break;
            case 'sonymusic-publishing':
                fallbackCustomerStoryList[1] = story;
                break;
            case 'lumen':
                fallbackCustomerStoryList[2] = story;
                break;
            case 'edenred':
            case 'engie':
            case 'sunlife':
                extraFallbackCustomerStoryList.push(story);
                break;
            default:
                break;
        }
    });
    let extraFallbackStoriesUsed = 0;
    // If one of the original three are missing,
    // we'll use the extra fallback stories
    fallbackCustomerStoryList.forEach((story, index)=>{
        if (!story && extraFallbackCustomerStoryList[extraFallbackStoriesUsed]) {
            fallbackCustomerStoryList[index] = extraFallbackCustomerStoryList[extraFallbackStoriesUsed];
            extraFallbackStoriesUsed++;
        }
    });
    return fallbackCustomerStoryList;
};
const $3baf5d614699af5f$var$getShortestColumnIndex = (storyList)=>{
    let shortestColumnIndex = 0;
    let shortestHeight = storyList[0].height;
    Object.values(storyList).forEach((story, index)=>{
        if (shortestHeight > story.height) {
            shortestColumnIndex = index;
            shortestHeight = story.height;
        }
    });
    return shortestColumnIndex;
};
const $3baf5d614699af5f$export$bf9342a233bd676b = (storiesList, stories, rows)=>{
    if (Object.keys(storiesList).length === 0) // initialize object
    for(let i = 0; i < rows; i++)storiesList[i] = {
        stories: [],
        height: 0
    };
    else if (Object.keys(storiesList).length !== rows || stories.length !== 0) {
        // clear out existing object, and re-intialize it
        for(const key in storiesList)delete storiesList[key];
        for(let i = 0; i < rows; i++)storiesList[i] = {
            stories: [],
            height: 0
        };
    }
    let shortestColumnIndex = 0;
    stories.forEach((story)=>{
        shortestColumnIndex = $3baf5d614699af5f$var$getShortestColumnIndex(storiesList);
        const storyGridItem = storiesList[shortestColumnIndex];
        if (story.advocateQuotes?.length) storyGridItem.height += $3baf5d614699af5f$var$sizeMap['lg'];
        else if (story.storyIcon?.url) storyGridItem.height += $3baf5d614699af5f$var$sizeMap['md'];
        else storyGridItem.height += $3baf5d614699af5f$var$sizeMap['sm'];
        storyGridItem.stories.push(story);
    });
    return storiesList;
};
const $3baf5d614699af5f$export$65d9e924579f6503 = (width)=>{
    if (width > 1024) return 3;
    else if (width > 768) return 2;
    else if (width <= 768) return 1;
    else return 1;
};
const $3baf5d614699af5f$export$4d4f48a65e76da56 = 0;
const $3baf5d614699af5f$export$2d18ca8a66126a1d = ()=>{
    // `window` exists during SSR but has no `innerWidth`.
    if (typeof window === 'undefined' || typeof window.innerWidth !== 'number') return {
        width: $3baf5d614699af5f$export$4d4f48a65e76da56
    };
    return {
        width: window.innerWidth
    };
};
function $3baf5d614699af5f$export$f715c0e61b2c1a36() {
    // Deliberately does NOT seed from the real viewport. Measuring during render
    // makes the first client render disagree with the server markup, and because
    // the width drives how stories are distributed across masonry columns that
    // disagreement reorders the DOM. React cannot patch that, so it discards the
    // entire server tree and re-renders the whole page client-side.
    const [windowDimensions, setWindowDimensions] = (0, $1oC0p.useState)({
        width: $3baf5d614699af5f$export$4d4f48a65e76da56
    });
    (0, $1oC0p.useEffect)(()=>{
        function handleResize() {
            setWindowDimensions($3baf5d614699af5f$export$2d18ca8a66126a1d());
        }
        // Sync to the real viewport once hydration is done.
        handleResize();
        window.addEventListener('resize', handleResize);
        return ()=>window.removeEventListener('resize', handleResize);
    }, []);
    return windowDimensions;
}
function $3baf5d614699af5f$export$f2735cb33092c31f(category) {
    return category === 'industry' || category === 'product' || category === 'solution' || category === 'region' || category === 'team size';
}
const $3baf5d614699af5f$var$defaultCustomerStoryFilterOptionValue = {
    committedActive: false,
    stagedActive: false
};
function $3baf5d614699af5f$export$8ba04a2269d8d395(filters, subFilter) {
    const defaulted = {};
    filters.forEach((filter)=>{
        defaulted[filter.name] = {
            ...$3baf5d614699af5f$var$defaultCustomerStoryFilterOptionValue,
            grouping: subFilter === 'region' || subFilter === 'team size' ? subFilter : undefined
        };
    });
    return defaulted;
}
function $3baf5d614699af5f$export$c09429083a9f1f77(filterObject) {
    const committedActive = Object.keys(filterObject).map((key)=>{
        const map = Object.keys(filterObject[key]).map((key2)=>{
            const root = filterObject[key];
            const value = root[key2];
            const category = value?.grouping ?? key;
            return value?.committedActive ? `${category}=${key2}` : '';
        }).filter((item)=>item?.length);
        return map;
    });
    return committedActive.flat().join('|');
}

});



parcelRegister("9K8X0", function(module, exports) {
$parcel$export(module.exports, "CustomerStoryFilters", function () { return $22c8d2a2ca3fb814$export$801647fac331cbf3; });
/* customer-story-filters.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $bQjAr = parcelRequire("bQjAr");

var $lmQGF = parcelRequire("lmQGF");

var $1rGpC = parcelRequire("1rGpC");

var $jsxHL = parcelRequire("jsxHL");

var $WxMqy = parcelRequire("WxMqy");

var $bk5Uk = parcelRequire("bk5Uk");

var $3614I = parcelRequire("3614I");

var $hBvFS = parcelRequire("hBvFS");

var $7u2YB = parcelRequire("7u2YB");
const $22c8d2a2ca3fb814$export$801647fac331cbf3 = ({ filterObject: filterObject, numberOfCustomerStoriesByCommittedValues: numberOfCustomerStoriesByCommittedValues, numberOfCustomerStoriesByStagedValues: numberOfCustomerStoriesByStagedValues, searchStringValue: searchStringValue, searchInputFieldFocused: searchInputFieldFocused, hasFilterSearchRun: hasFilterSearchRun, setFilterObjectValue: setFilterObjectValue, setSearchInputFieldFocused: setSearchInputFieldFocused, setSearchString: setSearchString, clearAllFilterButtonClickHandler: clearAllFilterButtonClickHandler, clearSearchField: clearSearchField, runSearchWithFilters: runSearchWithFilters })=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const localizedMap = (0, $7u2YB.LocalizedFilterOptions)();
    const whichFilterModalIsOpenObjectDefaultState = {
        solution: false,
        product: false,
        industry: false,
        'more filters': false
    };
    const { width: width } = (0, $hBvFS.useWindowDimensions)();
    Object.freeze(whichFilterModalIsOpenObjectDefaultState);
    const [whichFilterModalIsOpenObject, updateWhichFilterModalIsOpenObject] = (0, $1oC0p.useState)(whichFilterModalIsOpenObjectDefaultState);
    // Updates the state of which filter modal is open
    // If a modal is closing, we commit all the stagedActive values
    const updateWhichFilterModalIsShown = (subFilter)=>{
        const isModalClosing = Object.keys(whichFilterModalIsOpenObject).filter((key)=>whichFilterModalIsOpenObject[key]);
        updateWhichFilterModalIsOpenObject(()=>({
                ...whichFilterModalIsOpenObjectDefaultState,
                [subFilter]: !whichFilterModalIsOpenObject[subFilter]
            }));
        if (isModalClosing.length > 0) setFilterObjectValue((prevState)=>{
            filterObject = {
                ...prevState,
                ...(0, $hBvFS.commitAllStagedActiveValues)(prevState)
            };
            runSearchWithFilters(filterObject, searchStringValue);
            return filterObject;
        });
    };
    // Updates the stagedActive value of the filter
    const updateSubFilterStagedValue = (subFilterName, filterOptionName)=>{
        setFilterObjectValue((prevState)=>{
            return {
                ...prevState,
                [subFilterName]: {
                    ...prevState[subFilterName],
                    [filterOptionName]: {
                        ...prevState[subFilterName][filterOptionName],
                        stagedActive: !prevState[subFilterName][filterOptionName].stagedActive
                    }
                }
            };
        });
    };
    const clearAllStagedValues = ()=>{
        setFilterObjectValue((prevState)=>{
            return {
                ...prevState,
                ...(0, $hBvFS.setAllStagedActiveToFalse)(prevState)
            };
        });
    };
    // Clears all stagedActive values in the more filters section
    const clearMoreFilterStagedValues = ()=>{
        setFilterObjectValue((prevState)=>{
            const updatedFilterState = Object.entries(prevState['more filters']).reduce((acc, [filterOptionName, filterOptionValue])=>{
                acc[filterOptionName] = {
                    ...filterOptionValue,
                    stagedActive: false
                };
                return acc;
            }, {});
            return {
                ...prevState,
                ['more filters']: {
                    ...prevState['more filters'],
                    ...updatedFilterState
                }
            };
        });
    };
    // resets all stagedActive values to their committedActive value
    const resetAllStagedValues = ()=>{
        setFilterObjectValue((prevState)=>{
            const updatedFilterState = (0, $hBvFS.resetAllStagedActiveToCommittedActiveValue)(prevState);
            return {
                ...prevState,
                ...updatedFilterState
            };
        });
    };
    // Closes complex modal and runs search
    const runSearchWithFiltersWrapper = ()=>{
        updateWhichFilterModalIsShown('more filters');
        runSearchWithFilters(filterObject, searchStringValue);
    };
    // Handles logic for determining which filter modal to show
    const getFilterModal = (showFilter, filterKey)=>{
        if (!showFilter || !whichFilterModalIsOpenObject[filterKey]) return null;
        const numCols = (0, $hBvFS.getNumberOfCustomerStoryColumns)(width);
        if (numCols === 3) {
            if (filterKey === 'more filters') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bk5Uk.CustomerStoryFilterModalComplex), {
                numberOfCustomerStories: numberOfCustomerStoriesByStagedValues,
                filterObject: filterObject,
                onlyShowMoreFiltersCategory: true,
                updateFilterObject: updateSubFilterStagedValue,
                closeModal: ()=>updateWhichFilterModalIsShown('more filters'),
                resetFilters: resetAllStagedValues,
                clearMoreFilters: clearMoreFilterStagedValues,
                clearFilters: clearAllStagedValues,
                runSearch: runSearchWithFiltersWrapper
            });
            else return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $WxMqy.CustomerStoryFilterModalBasic), {
                subFilter: filterKey,
                subFilterObject: filterObject[filterKey],
                updateFilterObject: (filterOptionName)=>updateSubFilterStagedValue(filterKey, filterOptionName)
            });
        } else return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bk5Uk.CustomerStoryFilterModalComplex), {
            numberOfCustomerStories: numberOfCustomerStoriesByStagedValues,
            filterObject: filterObject,
            onlyShowMoreFiltersCategory: false,
            updateFilterObject: updateSubFilterStagedValue,
            closeModal: ()=>updateWhichFilterModalIsShown('more filters'),
            resetFilters: resetAllStagedValues,
            clearFilters: clearAllStagedValues,
            runSearch: runSearchWithFiltersWrapper
        });
    };
    const filterButtonClickWrapper = (ev, filterCategory)=>{
        ev.preventDefault();
        createAnalyticsEvent({
            origin: 'web',
            platform: 'web',
            product: 'marketing',
            source: 'none',
            userIdType: 'atlassianAccount',
            eventComponent: 'customerFilterButton',
            event: 'clicked',
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'component',
            attributes: {
                labelEnglish: filterCategory,
                url: location.href,
                page_path: location.pathname,
                eventComponent: 'customerFilterButton'
            }
        }).fire();
        updateWhichFilterModalIsShown(filterCategory);
    };
    const buttonPropsList = [
        {
            variant: 'primary',
            color: 'light_grey',
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onClick: (ev)=>filterButtonClickWrapper(ev, 'solution')
        },
        {
            variant: 'primary',
            color: 'light_grey',
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onClick: (ev)=>filterButtonClickWrapper(ev, 'product')
        },
        {
            variant: 'primary',
            color: 'light_grey',
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onClick: (ev)=>filterButtonClickWrapper(ev, 'industry')
        },
        {
            variant: 'secondary',
            color: 'light_grey',
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onClick: (ev)=>filterButtonClickWrapper(ev, 'more filters')
        }
    ];
    const totalNumberOfActiveFilters = (0, $1oC0p.useMemo)(()=>{
        return (0, $hBvFS.getActiveFiltersByFilterType)('all', filterObject) || 0;
    }, [
        filterObject
    ]);
    // If any filter modal is open, show the modal
    const showModal = Object.values(whichFilterModalIsOpenObject).filter((isActiveValue)=>isActiveValue).length > 0;
    const handleDocumentClick = (0, $1oC0p.useCallback)((event)=>{
        if (showModal) {
            let parentNode = event.target;
            while(parentNode && parentNode.nodeName !== 'BODY'){
                if (parentNode.id === 'customer-story-modal-component-parent') return;
                parentNode = parentNode.parentNode;
            }
        }
        // If we are here, it means the click was outside the modal
        const isModalClosing = Object.keys(whichFilterModalIsOpenObject).filter((key)=>whichFilterModalIsOpenObject[key]);
        if (isModalClosing.length > 0) {
            updateWhichFilterModalIsOpenObject(()=>({
                    ...whichFilterModalIsOpenObjectDefaultState
                }));
            setFilterObjectValue((prevState)=>{
                // eslint-disable-next-line react-hooks/exhaustive-deps
                filterObject = {
                    ...prevState,
                    ...(0, $hBvFS.commitAllStagedActiveValues)(prevState)
                };
                runSearchWithFilters(filterObject, searchStringValue);
                return filterObject;
            });
        }
    }, [
        showModal
    ]);
    // Attach and detach the event listener for the document click
    // This is used to determine if there is a click outside of the filter modals
    (0, $1oC0p.useEffect)(()=>{
        // Attach the listeners on component mount.
        document.addEventListener('click', handleDocumentClick, false);
        // Detach the listeners on component unmount.
        return ()=>{
            document.removeEventListener('click', handleDocumentClick, false);
        };
    }, [
        handleDocumentClick
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "customers-page-filters",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
                className: (0, $2jatx.default)([
                    "_19pkys9h _2hwxidpf _otyrzwfg _18u0idpf _12eoidpf _1mg17vkz"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                        layout: "12",
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _1n261q9c _1bah1yb4"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_kqswh2mm _1e0c1txw _1n261q9c _i0dl1ns9 _v5646lqh _1a8lka7h _1vn5glyw",
                                        Object.keys(filterObject.industry).length === 0 && "_tzy4idpf"
                                    ]),
                                    children: [
                                        buttonPropsList.map((buttonProp, index)=>{
                                            const filterKey = Object.keys(filterObject)[index];
                                            // Inefficient, we should look into memoizing this
                                            const numFiltersActive = (0, $hBvFS.getActiveFiltersByFilterType)(filterKey, filterObject);
                                            const buttonClassNameBuilder = `customer-story-filter-button-adg4 ${numFiltersActive ? 'filter-active' : ''} ${whichFilterModalIsOpenObject[filterKey] ? 'selected' : ''} ${filterKey === 'more filters' ? 'more-filters' : ''}`;
                                            const filterModal = getFilterModal(showModal, filterKey);
                                            return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                className: "customer-story-filter-button",
                                                children: [
                                                    /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $lmQGF.Adg4Button), {
                                                        ...buttonProp,
                                                        className: (0, $2jatx.default)([
                                                            "_bja41dk0 _lf657vkz _1edd7vkz _1yprtlke _5pbz1j6v _1ffa1ipv _10tp1nn1 _1mjbglyw _qjacf1gs _12rgftgi _inqm18ms _3smh17fj _irr317fj _kasp1vpm _s9qi1vpm _1pmm1vpm _1il01o8l _pnatglyw _18csplmo",
                                                            buttonClassNameBuilder
                                                        ]),
                                                        id: "customer-story-modal-component-parent",
                                                        children: [
                                                            localizedMap[filterKey],
                                                            " ",
                                                            $22c8d2a2ca3fb814$var$filterDropDownArrowSVG,
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                                className: (0, $2jatx.default)([
                                                                    "_1e0cglyw _ae4v1h6o _bfhkshej _2rko1ssb _ahbqftgi _syazqlpt _1bsbgktf _4t3igktf _k48pni7l"
                                                                ]),
                                                                children: numFiltersActive
                                                            })
                                                        ]
                                                    }),
                                                    filterModal
                                                ]
                                            }, index);
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                            id: "customer-story-modal-component-parent",
                                            className: (0, $2jatx.default)([
                                                "_1e0cglyw _1mjb1ule"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                                                    id: 'more filters',
                                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                                    onClick: (ev)=>filterButtonClickWrapper(ev, 'more filters'),
                                                    className: (0, $2jatx.default)([
                                                        "_80omtlke _1e0c1txw _1bah1h6o _4cvr1h6o _11q7glyw _19itglyw _2rko53f4 _4t3i1ylp _1bsb1osq _syazqlpt _ca0qftgi _u5f37vkz _n3tdftgi _19bv7vkz _zulpftgi _irr317fj",
                                                        totalNumberOfActiveFilters && "_ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _bfhk1vpm _3smh1vpm _irr31vpm"
                                                    ]),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                                                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/customer-story-filter-icon-3367749555.webp",
                                                            alt: "Filter icon",
                                                            className: (0, $2jatx.default)([
                                                                "_1bsb1tcg _4t3i1tcg"
                                                            ])
                                                        }),
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                            className: (0, $2jatx.default)([
                                                                "_1e0c1o8l",
                                                                totalNumberOfActiveFilters && "_1e0cglyw"
                                                            ]),
                                                            children: intl.formatMessage({
                                                                id: 'CustomersLandingPage.button.filters',
                                                                defaultMessage: 'Filters'
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                            className: (0, $2jatx.default)([
                                                                "_1e0cglyw _1bah1h6o _4cvr1h6o _bfhkshej _2rko1ssb _19pkidpf _2hwxidpf _otyridpf _18u0idpf _syazqlpt _1bsb1tcg _4t3i1tcg _k48pni7l",
                                                                totalNumberOfActiveFilters && "_1e0c1txw"
                                                            ]),
                                                            children: totalNumberOfActiveFilters
                                                        })
                                                    ]
                                                }),
                                                getFilterModal(showModal, 'more filters')
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _1n261q9c _p12f1jax _i0dlmko7 _1bahesu3 _8fz61w8u _1a8l1w8u _o5kcesu3"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3614I.CustomerStorySearchBar), {
                                        searchStringValue: searchStringValue,
                                        setSearchString: setSearchString,
                                        runSearch: ()=>runSearchWithFilters(filterObject, searchStringValue),
                                        searchInputFieldFocused: searchInputFieldFocused,
                                        setSearchInputFieldFocused: setSearchInputFieldFocused,
                                        clearSearchField: clearSearchField
                                    })
                                })
                            ]
                        })
                    }),
                    hasFilterSearchRun && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                        layout: "12",
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _1n261q9c _1bsbzqdx _p12f1osq _19pkqslr _2hwx1wug _otyridpf _18u01wug _1bah1y6m _4cvr1h6o _4t3i1f4h _y3gn1e5h"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("h5", {
                                    className: (0, $2jatx.default)([
                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _12l27vkz _1wybgktf _k48p1fw0 _syazqlpt"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "CustomersLandingPage.numberOfResults",
                                        defaultMessage: "<numberOfCustomerStories></numberOfCustomerStories> results",
                                        values: {
                                            numberOfCustomerStories: ()=>numberOfCustomerStoriesByCommittedValues
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                    type: "button",
                                    onClick: clearAllFilterButtonClickHandler,
                                    className: (0, $2jatx.default)([
                                        "_4bfu1r31 _1hms8stv _ajmmnqa1 _ect48q0o _80omtlke _syazoelr _1wybdlk8 _11q7glyw _19itidpf"
                                    ]),
                                    children: intl.formatMessage({
                                        id: 'CustomersLandingPage.clear',
                                        defaultMessage: 'Clear'
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
const $22c8d2a2ca3fb814$var$filterDropDownArrowSVG = /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
    width: "10",
    height: "6",
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "customer-story-filter-dropdown-arrow",
    children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
        d: "M9 1.18164L5 4.818L1 1.18164",
        stroke: "#101214",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    })
});
const $22c8d2a2ca3fb814$var$customerStoriesSectionContainerStyle = null;
const $22c8d2a2ca3fb814$var$customerStoriesFilterContainerStyle = null;
const $22c8d2a2ca3fb814$var$filterButtonContainerStyle = null;
const $22c8d2a2ca3fb814$var$mobileFilterButtonContainerStyles = null;
const $22c8d2a2ca3fb814$var$mobileFilterButtonStyles = null;
const $22c8d2a2ca3fb814$var$mobileFilterButtonActiveStyles = null;
const $22c8d2a2ca3fb814$var$mobileFilterButtonImgStyles = null;
const $22c8d2a2ca3fb814$var$mobileFilterButtonTextStyles = null;
const $22c8d2a2ca3fb814$var$mobileFilterInnerStyles = null;
const $22c8d2a2ca3fb814$var$mobileFilterHiddenStyles = null;
const $22c8d2a2ca3fb814$var$mobileFilterButtonTextActiveStyles = null;
const $22c8d2a2ca3fb814$var$filterButtonStyles = null;
const $22c8d2a2ca3fb814$var$filterButtonCountStyles = null;
const $22c8d2a2ca3fb814$var$searchButtonContainerStyle = null;
const $22c8d2a2ca3fb814$var$filterResultStyle = null;
const $22c8d2a2ca3fb814$var$filterResultLabelStyle = null;
const $22c8d2a2ca3fb814$var$filterClearStyle = null;

});
parcelRegister("WxMqy", function(module, exports) {
$parcel$export(module.exports, "CustomerStoryFilterModalBasic", function () { return $aa5052a10495e1ad$export$bcad7e14b9c41118; });
/* customer-story-filter-modal-basic.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $OKl9V = parcelRequire("OKl9V");

var $hBvFS = parcelRequire("hBvFS");

var $7u2YB = parcelRequire("7u2YB");
const $aa5052a10495e1ad$export$bcad7e14b9c41118 = ({ subFilter: subFilter, subFilterObject: subFilterObject, updateFilterObject: updateFilterObject })=>{
    const localizedMap = (0, $7u2YB.LocalizedFilterOptions)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswstnw _bfhku67f _2rkogktf _1pbycs5v _152t4bvh _ca0q7vkz _u5f31tcg _n3td1tcg _19bv1tcg _2lx21bp4 _16qsjojz _11ko1txw _rs1e1bp4 _m0njftgi _13qeidpf _1esjidpf _lnxxidpf _1yn0tlke _1m5y1txw _6xef1q9c _5red1h6o _53691y6m _130f1oen _un46gktf _1ebcgktf _tmbl1l7b _ghxb16z6 _ym6vgktf _118yftgi _otnau67f _1jfy1txw _vjdb1h6o _16db1h6o _1mpgidpf _94z6doyu _1srq1oen _sj1jkb7n",
            subFilter
        ]),
        id: "customer-story-modal-component-parent",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: Object.keys(subFilterObject).map((filterOptionName, index)=>{
                const filterObject = subFilterObject[filterOptionName];
                const active = filterObject.stagedActive;
                const optionId = `option-${subFilter.replace(/\s/g, '')}-${index}`;
                return /*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
                    htmlFor: optionId,
                    className: "filter-radio-button-container",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                            id: optionId,
                            type: "checkbox",
                            onClick: ()=>updateFilterObject(filterOptionName),
                            className: (0, $2jatx.default)([
                                "_kqswstnw _1pby1mrw _tzy4idpf"
                            ])
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: active ? 'checked' : '',
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $OKl9V.Icon), {
                                name: "featurecheckmark",
                                size: "xs",
                                color: "#FFFFFF"
                            })
                        }),
                        (0, $hBvFS.isContentPlatformFacetAvailable)(subFilter) ? filterOptionName : localizedMap[filterOptionName]
                    ]
                }, filterOptionName);
            })
        })
    });
};
const $aa5052a10495e1ad$var$customerStoryFilterModalBasicStyle = null;
const $aa5052a10495e1ad$var$actualInputStyle = null;

});
parcelRegister("7u2YB", function(module, exports) {
$parcel$export(module.exports, "LocalizedFilterOptions", function () { return $1827895396126f0b$export$1021dd15869d400b; });

var $8e22h = parcelRequire("8e22h");
const $1827895396126f0b$export$1021dd15869d400b = ()=>{
    const intl = (0, $8e22h.default)();
    return {
        solution: intl.formatMessage({
            id: 'CustomersLandingPage.filterCategory.solution',
            defaultMessage: 'solution'
        }),
        product: intl.formatMessage({
            id: 'CustomersLandingPage.filterCategory.product-gwp-7518',
            defaultMessage: 'App'
        }),
        industry: intl.formatMessage({
            id: 'CustomersLandingPage.filterCategory.industry',
            defaultMessage: 'industry'
        }),
        'more filters': intl.formatMessage({
            id: 'CustomersLandingPage.filterCategory.morefilters',
            defaultMessage: 'more filters'
        }),
        'Work Management': intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.WorkManagement',
            defaultMessage: 'Work Management'
        }),
        'Agile / DevOps': intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.AgileDevOps',
            defaultMessage: 'Agile / DevOps'
        }),
        ITSM: intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.ITSM',
            defaultMessage: 'ITSMs'
        }),
        'Cloud Migration': intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.CloudMigration',
            defaultMessage: 'Cloud Migration'
        }),
        Jira: intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.Jira',
            defaultMessage: 'Jira'
        }),
        'Jira Service Management': intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.JiraServiceManagement',
            defaultMessage: 'Jira Service Management'
        }),
        'Jira Align': intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.JiraAlign',
            defaultMessage: 'Jira Align'
        }),
        'Jira Product Discovery': intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.JiraProductDiscovery',
            defaultMessage: 'Jira Product Discovery'
        }),
        Confluence: intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.Confluence',
            defaultMessage: 'Confluence'
        }),
        Trello: intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.Trello',
            defaultMessage: 'Trello'
        }),
        Bitbucket: intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.Bitbucket',
            defaultMessage: 'Bitbucket'
        }),
        Guard: intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.Guard',
            defaultMessage: 'Guard'
        }),
        Statuspage: intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.Statuspage',
            defaultMessage: 'Statuspage'
        }),
        Compass: intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.Compass',
            defaultMessage: 'Compass'
        }),
        Bamboo: intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.Bamboo',
            defaultMessage: 'Bamboo'
        }),
        Automotive: intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.Automotive',
            defaultMessage: 'Automotive'
        }),
        Aviation: intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.Aviation',
            defaultMessage: 'Aviation'
        }),
        'Consumer Goods & Retail': intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.ConsumerGoodsRetail',
            defaultMessage: 'Consumer Goods & Retail'
        }),
        Education: intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.Education',
            defaultMessage: 'Education'
        }),
        'Energy & Utilties': intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.EnergyUtilties',
            defaultMessage: 'Energy & Utilties'
        }),
        'Entertainment & Media': intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.EntertainmentMedia',
            defaultMessage: 'Entertainment & Media'
        }),
        'Financial Services': intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.FinancialServices',
            defaultMessage: 'Financial Services'
        }),
        Government: intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.Government',
            defaultMessage: 'Government'
        }),
        'Healthcare & Life Sciences': intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.HealthcareLifeSciences',
            defaultMessage: 'Healthcare & Life Sciences'
        }),
        'Internet & Telecommunications': intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.InternetTelecommunications',
            defaultMessage: 'Internet & Telecommunications'
        }),
        Manufacturing: intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.Manufacturing',
            defaultMessage: 'Manufacturing'
        }),
        'Non-Profit': intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.NonProfit',
            defaultMessage: 'Non-Profit'
        }),
        'Real Estate': intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.RealEstate',
            defaultMessage: 'Real Estate'
        }),
        Software: intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.Software',
            defaultMessage: 'Software'
        }),
        Technology: intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.Technology',
            defaultMessage: 'Technology'
        }),
        'Marketplace apps': intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.MarketplaceApps',
            defaultMessage: 'Marketplace apps'
        }),
        'Only show stories from customers that use marketplace apps': intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.MarketplaceApps.description',
            defaultMessage: 'Only show stories from customers that use Marketplace apps'
        }),
        'Solution partner': intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.SolutionPartner',
            defaultMessage: 'Solution partner'
        }),
        'Only show stories from customers that have a solution partner': intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.SolutionPartner.description',
            defaultMessage: 'Only show stories from customers that have a Solution Partner'
        }),
        Americas: intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.Americas',
            defaultMessage: 'Americas'
        }),
        'Europe, Middle East, Africa': intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.EuropeMiddleEastAfrica',
            defaultMessage: 'Europe, Middle East, Africa'
        }),
        'Asia Pacific': intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.AsiaPacific',
            defaultMessage: 'Asia Pacific'
        }),
        Global: intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.Global',
            defaultMessage: 'Global'
        }),
        'Small/Medium Business': intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.SmallMediumBusiness',
            defaultMessage: 'Small/Medium Business'
        }),
        Enterprise: intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.Enterprise',
            defaultMessage: 'Enterprise'
        }),
        'Large Enterprise': intl.formatMessage({
            id: 'CustomersLandingPage.subFilter.LargeEnterprise',
            defaultMessage: 'Large Enterprise'
        })
    };
};

});


parcelRegister("bk5Uk", function(module, exports) {
$parcel$export(module.exports, "CustomerStoryFilterModalComplex", function () { return $89e92ba9b8ccd01b$export$2f70c3bf84c20631; });
/* customer-story-filter-modal-complex.tsx generated by @compiled/babel-plugin v0.28.8 */ // This file has tons of nested selector errors that should be fixed.
// eslint-disable-next-line local/no-block-disable-of-nested-eslint
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $lmQGF = parcelRequire("lmQGF");

var $OKl9V = parcelRequire("OKl9V");

var $dOxmj = parcelRequire("dOxmj");

var $cL5ak = parcelRequire("cL5ak");
const $89e92ba9b8ccd01b$export$2f70c3bf84c20631 = ({ numberOfCustomerStories: numberOfCustomerStories, filterObject: filterObject, onlyShowMoreFiltersCategory: onlyShowMoreFiltersCategory, updateFilterObject: updateFilterObject, closeModal: closeModal, resetFilters: resetFilters, clearMoreFilters: clearMoreFilters, clearFilters: clearFilters, runSearch: runSearch })=>{
    const intl = (0, $8e22h.default)();
    // Handle clicking outside the modal
    const handleClickingOutsideModal = (event)=>{
        if (event.target === event.currentTarget) {
            resetFilters();
            closeModal();
        }
    };
    // Handle "esc" key being pressed to close the modal
    const handleKeyDownOutsideModal = (event)=>{
        if (event.key === 'Escape') {
            resetFilters();
            closeModal();
        }
    };
    // Handle click on the close button
    const handleClickingCloseModal = ()=>{
        resetFilters();
        closeModal();
    };
    const handleClearFilterClick = ()=>{
        if (onlyShowMoreFiltersCategory && clearMoreFilters) clearMoreFilters();
        else clearFilters();
    };
    let filterObjectKeys = Object.keys(filterObject);
    if (onlyShowMoreFiltersCategory) filterObjectKeys = [
        'more filters'
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        id: "customer-story-modal-component-parent",
        onKeyDown: handleKeyDownOutsideModal,
        onClick: handleClickingOutsideModal,
        className: (0, $2jatx.default)([
            "_kqsw1n9t _bfhk1ebw _1e02idpf _rjxpidpf _152tidpf _u7coidpf _1pbyouyt _1bsb1osq _4t3i1osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1rfm1osq _1rkb1osq _476didpf _123r1osq _a5ztidpf _gltephn8 _10jxphn8 _1mt1vbgk _kqswh2mm _1e0c1txw _2lx21bp4 _1reo15vq _18m915vq _bfhku67f _2rkogktf _16qsjojz _ca0qzwfg _u5f3zwfg _n3tdzwfg _19bvzwfg _19pkzwfg _2hwx1wug _otyrzwfg _18u01wug _1bsb1vuk _c71l1vuk _5mp0zwfg _uoe41txw _3p8m1yb4 _1f3a1h6o _xg3n1hjg _1eapidpf _feifidpf _1ul1idpf _c6iridpf _g0kv1fw0 _1d8aviql _1ys6tlke _1cpiqlpt _9xq715zi _xxjoglyw _pz8qglyw _1ydrglyw _br967vkz _ek7didpf _1xe37vkz _1gn8idpf _maetidpf _j5v9idpf _gnleidpf _l0efidpf _btwe1nn1 _1htt1k8s _1tnn1dk0 _ojp91tcg _1map1hjg _z5h1glyw _16ng1txw _1t661q9c _hy5i1yb4 _4pizidpf _13tl1osq _1wfif1ug _irdu1txw _1xae1bp4 _ikai1g80 _h2051y6m _1qitidpf _6dklidpf _yzz41ssb _7gqi1ssb _e3ic1tcg _1a66idpf _1eehidpf _mmhcidpf _119utlke _1yuw1txw _17zw1q9c _32f11h6o _1o5g1y6m _1shw1oen _9hinglyw _11w4gktf _1m9jgktf _ivy21l7b _1nsa16z6 _w3o2gktf _1p0lftgi _larvu67f _g1v11txw _1ggp1h6o _c2211h6o _1yr2doyu _1kdj1oen _1jezidpf _1sc3idpf _1xbzidpf _1fnuidpf _1y6a1txw _cj8a1g80 _7mj11yb4 _1a8f1osq _117t1tcg _yitridpf _1s8v1tcg _bwjgidpf _12u91tcg _1ur61txw _1drn1q9c _e9uk1yb4 _f1q21h6o _icc91hjg _kqdu12it _xtvnidpf _1a8gidpf _1579idpf _4cxwidpf _1jpwh2mm _t2ds1o8l _12kv1ylp _14rtgktf _1rhyidpf _hijaidpf _1srsidpf _1fj8doyu _1qzh1k0w _1ld0stnw _1f8ttlke _1jwpidpf _qqok1fkg _7l1y1cqc _7nn21u1b _cnocstnw _19tvb3bt _1mm47vkz _p98b7vkz _1qpgyh40 _13p3yh40 _w8ksu67f _hess1cqc _w28t1ssb _euwfdoyu _158b1k0w _1ab91tcg _1vva1ssb _1bqyzwfg _1hi7idpf _1bklidpf _3lyjidpf _18hj1txw _1x8i1yb4 _1b3v1h6o _i5ni1hjg _16xodoyu"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: "filter-modal-header",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                            children: "Filters"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                            type: "button",
                            onClick: handleClickingCloseModal,
                            className: (0, $2jatx.default)([
                                "_19itglyw _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1wyb1j6v _ect48q0o _80omtlke _syazalr3"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $OKl9V.Icon), {
                                name: 'cross',
                                size: 'small'
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: "filter-modal-body",
                    children: filterObjectKeys.map((filterCategory, index)=>{
                        const filterCategoryTyped = filterCategory;
                        if (filterCategoryTyped === 'more filters') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cL5ak.CustomerStoryFilterModalComplexGrouping), {
                            filterCategory: "more filters",
                            filterObject: filterObject,
                            updateFilterObject: (subFilterName)=>updateFilterObject(filterCategoryTyped, subFilterName)
                        }, index);
                        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dOxmj.ComplexModalFilterCategorySection), {
                            filterCategory: filterCategoryTyped,
                            filterObject: filterObject,
                            updateFilterObject: updateFilterObject
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: "filter-modal-footer",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                            type: "button",
                            className: (0, $2jatx.default)([
                                "_19itglyw _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1wyb1j6v _ect48q0o _80omtlke _syazalr3",
                                "filter-modal-clear-all"
                            ]),
                            onClick: handleClearFilterClick,
                            children: intl.formatMessage({
                                id: 'CustomersLandingPage.clearAll',
                                defaultMessage: 'Clear all'
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                            className: "filter-apply-button",
                            variant: 'primary',
                            size: 'small',
                            color: 'blue',
                            onClick: runSearch,
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "CustomersLandingPage.showResults",
                                defaultMessage: "Show <numberOfCustomerStories></numberOfCustomerStories> results",
                                values: {
                                    numberOfCustomerStories: ()=>numberOfCustomerStories
                                }
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $89e92ba9b8ccd01b$var$customerStoryFilterModalBackgroundStyle = null;
const $89e92ba9b8ccd01b$var$customerStoryFilterModalStyle = null;
const $89e92ba9b8ccd01b$var$buttonBaselineStyle = null;

});
parcelRegister("dOxmj", function(module, exports) {
$parcel$export(module.exports, "ComplexModalFilterCategorySection", function () { return $89699be1bf153c27$export$7e2a92574800a5cf; });
/* complex-modal-filter-category-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $hBvFS = parcelRequire("hBvFS");

var $8e22h = parcelRequire("8e22h");

var $cL5ak = parcelRequire("cL5ak");
const $89699be1bf153c27$var$MAX_SUBFILTERS_BEFORE_EXPAND = 8;
const $89699be1bf153c27$var$MAX_COLUMN_ENTRIES_BEFORE_EXPAND = 4;
const $89699be1bf153c27$var$MAX_SUBFILTERS_BEFORE_TWO_COLUMNS = 5;
const $89699be1bf153c27$var$NUMBER_OF_COLUMNS = 2;
const $89699be1bf153c27$export$7e2a92574800a5cf = ({ filterCategory: filterCategory, filterObject: filterObject, updateFilterObject: updateFilterObject })=>{
    const intl = (0, $8e22h.default)();
    const [showingMore, setShowingMore] = (0, $1oC0p.useState)(false);
    const { width: width } = (0, $hBvFS.useWindowDimensions)();
    const FilterColumnOne = [];
    const FilterColumnTwo = [];
    // List of keys to see how many subfilters are in the category
    const keys = Object.keys(filterObject[filterCategory]);
    const expandSubsection = ()=>{
        setShowingMore(!showingMore);
    };
    Object.entries(filterObject[filterCategory]).forEach(([subFilterName, subFilterObject], index)=>{
        // On tablet and desktop, split the subfilters into two columns
        if (width > 768) {
            // If there are less than 5 subfilters,
            // or if the current subfilter is in the first half of the list,
            // Then add it to the first column
            if (keys.length < $89699be1bf153c27$var$MAX_SUBFILTERS_BEFORE_TWO_COLUMNS || keys.length / $89699be1bf153c27$var$NUMBER_OF_COLUMNS > index) {
                const isSubFilterHidden = FilterColumnOne.length >= $89699be1bf153c27$var$MAX_COLUMN_ENTRIES_BEFORE_EXPAND && keys.length > $89699be1bf153c27$var$MAX_SUBFILTERS_BEFORE_EXPAND && !showingMore;
                FilterColumnOne.push(/*#__PURE__*/ (0, $7VQPk.jsx)((0, $cL5ak.CustomerStoryFilterModalRadioButton), {
                    index: index,
                    filterCategory: filterCategory,
                    subFilterName: subFilterName,
                    grouping: subFilterObject.grouping,
                    active: subFilterObject.stagedActive,
                    isSubFilterHidden: isSubFilterHidden,
                    updateFilterObject: updateFilterObject
                }, index));
            // if the current subfilter is in the first half of the list,
            // Then add it to the first column
            } else {
                const isSubFilterHidden = FilterColumnTwo.length >= $89699be1bf153c27$var$MAX_COLUMN_ENTRIES_BEFORE_EXPAND && keys.length > $89699be1bf153c27$var$MAX_SUBFILTERS_BEFORE_EXPAND && !showingMore;
                FilterColumnTwo.push(/*#__PURE__*/ (0, $7VQPk.jsx)((0, $cL5ak.CustomerStoryFilterModalRadioButton), {
                    index: index,
                    filterCategory: filterCategory,
                    subFilterName: subFilterName,
                    grouping: subFilterObject.grouping,
                    active: subFilterObject.stagedActive,
                    isSubFilterHidden: isSubFilterHidden,
                    updateFilterObject: updateFilterObject
                }, index));
            }
        } else {
            // On mobile, add all subfilters to the first column
            const isSubFilterHidden = FilterColumnOne.length >= $89699be1bf153c27$var$MAX_COLUMN_ENTRIES_BEFORE_EXPAND && !showingMore;
            FilterColumnOne.push(/*#__PURE__*/ (0, $7VQPk.jsx)((0, $cL5ak.CustomerStoryFilterModalRadioButton), {
                index: index,
                filterCategory: filterCategory,
                subFilterName: subFilterName,
                grouping: subFilterObject.grouping,
                active: subFilterObject.stagedActive,
                isSubFilterHidden: isSubFilterHidden,
                updateFilterObject: updateFilterObject
            }, index));
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                children: filterCategory
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: "filter-modal-grouping-container",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: "filter-modal-grouping-column filter-column-1",
                        children: FilterColumnOne
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: "filter-modal-grouping-column filter-column-2",
                        children: FilterColumnTwo
                    })
                ]
            }),
            keys.length > $89699be1bf153c27$var$MAX_SUBFILTERS_BEFORE_EXPAND && /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                type: "button",
                onClick: expandSubsection,
                className: (0, $2jatx.default)([
                    "_19itglyw _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1wyb1j6v _ect48q0o _80omtlke _syazalr3 _1pfh1k8s"
                ]),
                children: !showingMore ? intl.formatMessage({
                    id: 'CustomersLandingPage.showMore',
                    defaultMessage: 'Show more'
                }) : intl.formatMessage({
                    id: 'CustomersLandingPage.showLess',
                    defaultMessage: 'Show less'
                })
            })
        ]
    });
};
const $89699be1bf153c27$var$showButtonStyle = null;

});
parcelRegister("cL5ak", function(module, exports) {
$parcel$export(module.exports, "CustomerStoryFilterModalRadioButton", function () { return $b2b472dc266838e9$export$ab592b785f13f9e8; });
$parcel$export(module.exports, "CustomerStoryFilterModalComplexGrouping", function () { return $b2b472dc266838e9$export$6ceba011e8ba7c3e; });
/* customer-story-filter-modal-grouping.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $OKl9V = parcelRequire("OKl9V");

var $hBvFS = parcelRequire("hBvFS");

var $7u2YB = parcelRequire("7u2YB");

var $e6w9W = parcelRequire("e6w9W");
const $b2b472dc266838e9$var$actualInputStyle = null;
const $b2b472dc266838e9$export$ab592b785f13f9e8 = ({ index: index, filterCategory: filterCategory, subFilterName: subFilterName, grouping: grouping, active: active, isSubFilterHidden: isSubFilterHidden, updateFilterObject: updateFilterObject })=>{
    const localizedMap = (0, $7u2YB.LocalizedFilterOptions)();
    const optionId = `option-${(grouping ?? filterCategory).replace(/\s/g, '')}-${index}`;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
        htmlFor: optionId,
        className: `filter-radio-button-container ${isSubFilterHidden ? 'hide-subfilter' : ''}`,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                id: optionId,
                type: "checkbox",
                onClick: ()=>updateFilterObject(filterCategory, subFilterName),
                className: (0, $2jatx.default)([
                    "_kqswstnw _1pby1mrw _tzy4idpf"
                ])
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: active ? 'checked' : '',
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $OKl9V.Icon), {
                    name: "featurecheckmark",
                    size: "xs",
                    color: "#FFFFFF"
                })
            }),
            (0, $hBvFS.isContentPlatformFacetAvailable)(grouping ?? filterCategory) ? subFilterName : localizedMap[subFilterName]
        ]
    });
};
const $b2b472dc266838e9$export$6ceba011e8ba7c3e = ({ filterCategory: filterCategory, filterObject: filterObject, updateFilterObject: updateFilterObject })=>{
    const intl = (0, $8e22h.default)();
    const sliderFilterContainer = [];
    const regionFilterContainer = [];
    const teamSizeFilterContainer = [];
    Object.keys(filterObject[filterCategory]).map((subFilter, index)=>{
        const subFilterObject = filterObject[filterCategory][subFilter];
        if (subFilterObject.description) sliderFilterContainer.push(/*#__PURE__*/ (0, $7VQPk.jsx)((0, $e6w9W.CustomerStoryFilterSliderFilter), {
            subFilterName: subFilter,
            active: subFilterObject.stagedActive,
            updateFilterObject: ()=>updateFilterObject(subFilter),
            subFilterDescription: subFilterObject.description
        }, subFilter));
        else if (subFilterObject.grouping === 'region') regionFilterContainer.push(/*#__PURE__*/ (0, $7VQPk.jsx)($b2b472dc266838e9$export$ab592b785f13f9e8, {
            index: index,
            filterCategory: filterCategory,
            subFilterName: subFilter,
            grouping: subFilterObject.grouping,
            active: subFilterObject.stagedActive,
            isSubFilterHidden: false,
            updateFilterObject: ()=>updateFilterObject(subFilter)
        }, index));
        else teamSizeFilterContainer.push(/*#__PURE__*/ (0, $7VQPk.jsx)($b2b472dc266838e9$export$ab592b785f13f9e8, {
            index: index,
            filterCategory: filterCategory,
            subFilterName: subFilter,
            grouping: subFilterObject.grouping,
            active: subFilterObject.stagedActive,
            isSubFilterHidden: false,
            updateFilterObject: ()=>updateFilterObject(subFilter)
        }, index));
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: "filter-modal-body-more-filters",
        children: [
            sliderFilterContainer.map((sliderFilter)=>{
                return sliderFilter;
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb1osq _179r1hjg _85i51tcg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                        children: intl.formatMessage({
                            id: 'CustomersLandingPage.filterGrouping.region',
                            defaultMessage: 'Region'
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: "filter-modal-grouping-container",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: "filter-modal-grouping-column",
                            children: regionFilterContainer.map((regionFilter)=>{
                                return regionFilter;
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1pfh1tcg _1bsb1osq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                        children: intl.formatMessage({
                            id: 'CustomersLandingPage.filterGrouping.TeamSize',
                            defaultMessage: 'Team size'
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: "filter-modal-grouping-container",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: "filter-modal-grouping-column",
                            children: teamSizeFilterContainer.map((regionFilter)=>{
                                return regionFilter;
                            })
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("e6w9W", function(module, exports) {
$parcel$export(module.exports, "CustomerStoryFilterSliderFilter", function () { return $eb64fda03a5fb4a6$export$4555d391c790a08; });

var $7VQPk = parcelRequire("7VQPk");

var $7u2YB = parcelRequire("7u2YB");
const $eb64fda03a5fb4a6$export$4555d391c790a08 = ({ subFilterName: subFilterName, subFilterDescription: subFilterDescription, active: active, updateFilterObject: updateFilterObject })=>{
    const localizedMap = (0, $7u2YB.LocalizedFilterOptions)();
    const optionId = `filter-checkbox-${subFilterName.replace(/\s/g, '')}`;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: "filter-slider-button-container",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                children: localizedMap[subFilterName]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: "filter-slider-content",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        children: localizedMap[subFilterDescription]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
                        className: "switch",
                        htmlFor: optionId,
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                type: "checkbox",
                                id: optionId,
                                checked: active,
                                onClick: ()=>updateFilterObject(subFilterName)
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: "slider round"
                            })
                        ]
                    })
                ]
            })
        ]
    }, subFilterName);
};

});




parcelRegister("3614I", function(module, exports) {
$parcel$export(module.exports, "CustomerStorySearchBar", function () { return $4849c25cac7de132$export$b6376e21a285c40b; });
/* customer-story-search-bar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $4aLWG = parcelRequire("4aLWG");

var $1nITY = parcelRequire("1nITY");
const $4849c25cac7de132$export$b6376e21a285c40b = ({ searchStringValue: searchStringValue, searchInputFieldFocused: searchInputFieldFocused, setSearchString: setSearchString, setSearchInputFieldFocused: setSearchInputFieldFocused, clearSearchField: clearSearchField, runSearch: runSearch })=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const searchRef = (0, $1oC0p.useRef)(null);
    const onSearchInputChange = (event)=>{
        setSearchString(event.target.value);
    };
    const handleSearchBarFocus = ()=>{
        setSearchInputFieldFocused(true);
        createAnalyticsEvent({
            origin: 'web',
            platform: 'web',
            product: 'marketing',
            source: 'none',
            userIdType: 'atlassianAccount',
            eventComponent: 'searchInput',
            event: 'clicked',
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'component',
            attributes: {
                url: location.href,
                page_path: location.pathname,
                eventComponent: 'customerStorysearchInput'
            }
        }).fire();
    };
    const handleOnBlur = ()=>{
        if (searchStringValue === '') setSearchInputFieldFocused(false);
        else setSearchInputFieldFocused(true);
    };
    const handleSearchButtonClick = (0, $1oC0p.useCallback)(()=>{
        if (searchRef.current) searchRef.current.focus();
        runSearch();
    }, [
        runSearch
    ]);
    const handleClearSearchButtonClick = ()=>{
        clearSearchField();
        if (searchRef.current) searchRef.current.focus();
    };
    const searchClassName = searchInputFieldFocused ? 'search-active' : '';
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("form", {
        onSubmit: (evt)=>{
            evt.preventDefault();
            handleSearchButtonClick();
        },
        className: (0, $2jatx.default)([
            "_4t3ior1b _1bsb1osq _bfhk17fj _2rko1ylp _1e0c1txw _1n261q9c _1bah1yb4 _ca0qidpf _u5f37vkz _n3tdidpf _19bv7vkz _scffglyw _1rwq1j28 _xmji1r31 _gxxuglyw _34ir1o36 _5hv91osq _17ea1vuk _125xdlk8 _psgkqlpt _yizh1fw0 _ggg71nn1 _1owa1w8u _4u6k1j28 _10709by0 _1f021txw _1vh3esu3 _dier1q9c _1b10idpf _cpccftgi _1s5lidpf _18asftgi _1sku1h6o _12nmbz2e _1d2m1f4h _11vy1dfy _p2rgx19p"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                className: searchClassName,
                type: "text",
                placeholder: intl.formatMessage({
                    id: 'CustomersLandingPage.searchPlaceholder',
                    defaultMessage: 'Search customer stories'
                }),
                onFocus: handleSearchBarFocus,
                onBlur: handleOnBlur,
                onChange: onSearchInputChange,
                value: searchStringValue,
                ref: searchRef
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: `search-buttons-container ${searchClassName}`,
                children: [
                    searchInputFieldFocused && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1nITY.SearchCloseButton), {
                                onClick: handleClearSearchButtonClick
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: "search-buttons-divider"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4aLWG.SearchButton), {})
                ]
            })
        ]
    });
};
const $4849c25cac7de132$var$searchBarContainerStyle = null;

});
parcelRegister("4aLWG", function(module, exports) {
$parcel$export(module.exports, "SearchButton", function () { return $734196fc18409da9$export$690bcf3a1f1e9f2f; });
/* customer-story-search-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $5ZCzy = parcelRequire("5ZCzy");
const $734196fc18409da9$var$searchIconStyle = null;
const $734196fc18409da9$export$690bcf3a1f1e9f2f = ()=>{
    const intl = (0, $8e22h.default)();
    const translated = {
        searchLabel: intl.formatMessage({
            id: 'CustomerLandingPage.search.label',
            defaultMessage: 'Search'
        })
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        type: "submit",
        id: "customer-story-search-icon",
        "aria-label": translated.searchLabel,
        "data-event": "clicked",
        "data-event-component": "button",
        "data-event-container": "customerStorySearchButton",
        "data-product-key": "customer",
        className: (0, $2jatx.default)([
            "_ahbqftgi _bfhk1j28 _19itidpf _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _syaz14rb _ql0oj1oc _1nj1qlpt _11vn1ssb _17521wug _i2i314y2 _uhas14y2 _5jw914y2 _7wy914y2 _w8l5zwfg _xwbjzwfg"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5ZCzy))), {
            label: translated.searchLabel,
            color: "var(--ds-icon, #292A2E)"
        })
    });
};

});

parcelRegister("1nITY", function(module, exports) {
$parcel$export(module.exports, "SearchCloseButton", function () { return $56c61533edb3940c$export$c5139e00bcad35c8; });
/* customer-story-search-close-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $dE0sS = parcelRequire("dE0sS");
const $56c61533edb3940c$var$searchIconStyle = null;
const $56c61533edb3940c$export$c5139e00bcad35c8 = (props)=>{
    const intl = (0, $8e22h.default)();
    const translated = {
        searchCloseLabel: intl.formatMessage({
            id: 'CustomerLandingPage.search.close.label',
            defaultMessage: 'Search close'
        })
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        type: "button",
        onClick: props.onClick,
        id: "customer-story-search-icon",
        "aria-label": translated.searchCloseLabel,
        "data-event": "clicked",
        "data-event-component": "button",
        "data-event-container": "customerStorySearchCloseButton",
        "data-product-key": "customer",
        className: (0, $2jatx.default)([
            "_1pfh1y44 _12l2ftgi _bfhk1j28 _19itidpf _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _syaz14rb _ql0oj1oc _1nj1qlpt _11vn1ssb _17521wug _i2i314y2 _uhas14y2 _5jw914y2 _7wy914y2 _w8l51ul9"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dE0sS.Cross), {
            size: '24'
        })
    });
};

});



parcelRegister("gZvpb", function(module, exports) {
$parcel$export(module.exports, "CustomersPrimaryCtaBand", function () { return $b7e96c4caddddff5$export$44aae34d58fcd103; });
/* customers-primary-cta-band.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $jKShK = parcelRequire("jKShK");

var $iVyKn = parcelRequire("iVyKn");

var $eY3N6 = parcelRequire("eY3N6");

var $bQjAr = parcelRequire("bQjAr");

var $lmQGF = parcelRequire("lmQGF");

var $jQ0cd = parcelRequire("jQ0cd");

var $1rGpC = parcelRequire("1rGpC");

var $4X0dO = parcelRequire("4X0dO");

var $gIKKj = parcelRequire("gIKKj");
const $b7e96c4caddddff5$export$44aae34d58fcd103 = ()=>{
    const experiment = (0, $gIKKj.useExperiment)((0, $4X0dO.experiments).twcg2273CustomersPagePrimaryCta);
    const signupHref = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=jira-software&edition=free');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { ref: bandRef, inView: inView } = (0, $jKShK.useInView)({
        threshold: 0.5,
        triggerOnce: true
    });
    const hasFiredSectionReachRef = (0, $1oC0p.useRef)(false);
    const isEnrolledTreatment = experiment.type === 'enrolled' && experiment.value === true;
    // Track treatment section reach once using WAC's section scroll event shape;
    // experiment exposure is handled by `useExperiment`.
    (0, $1oC0p.useEffect)(()=>{
        if (isEnrolledTreatment && inView && !hasFiredSectionReachRef.current) {
            hasFiredSectionReachRef.current = true;
            createAnalyticsEvent({
                eventType: 'ui',
                action: 'scrolledTo',
                actionSubject: 'section',
                source: window.location.pathname,
                attributes: {
                    section: 'customersPrimaryCtaBand',
                    productKey: 'customers',
                    labelEnglish: 'Get started with Jira'
                }
            }).fire();
        }
    }, [
        isEnrolledTreatment,
        inView,
        createAnalyticsEvent
    ]);
    if (!isEnrolledTreatment) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "customers-page-primary-cta-band",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            ref: bandRef,
            className: (0, $2jatx.default)([
                "_p12f1git _19pkidpf _2hwx1wug _otyridpf _18u01wug _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _y3gn1h6o"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                layout: "8",
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f1oh5 _1e0c1txw _2lx21bp4 _4cvr1h6o _zulp1ejb"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                            className: (0, $2jatx.default)([
                                "_p12foza4 _1pfhze3t _6rthze3t"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "CustomersLandingPage.primaryCtaBand.heading",
                                defaultMessage: "Start your own success story"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                            variant: "primary",
                            color: "blue",
                            href: signupHref,
                            dataEventProps: {
                                'data-event': 'clicked',
                                'data-event-component': 'linkButton',
                                'data-event-container': 'ctaSection',
                                'data-product-key': 'customers',
                                'data-label-english': 'Get started with Jira'
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "CustomersLandingPage.primaryCtaBand.button",
                                defaultMessage: "Get started with Jira"
                            })
                        })
                    ]
                })
            })
        })
    });
};
const $b7e96c4caddddff5$var$sectionStyles = null;
const $b7e96c4caddddff5$var$contentWrapperStyles = null;
const $b7e96c4caddddff5$var$headingStyles = null;

});

parcelRegister("lksJ1", function(module, exports) {
$parcel$export(module.exports, "FutureOfTeamwork", function () { return $892822865e707dc4$export$a40f2b95cdffc95c; });
/* future-of-teamwork.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $jKShK = parcelRequire("jKShK");

var $iVyKn = parcelRequire("iVyKn");

var $bQjAr = parcelRequire("bQjAr");

var $lmQGF = parcelRequire("lmQGF");

var $jQ0cd = parcelRequire("jQ0cd");

var $1rGpC = parcelRequire("1rGpC");
const $892822865e707dc4$export$a40f2b95cdffc95c = ()=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "customers-page-futureOfTeamwork",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            ref: scrollRef,
            className: (0, $2jatx.default)([
                "_kqswh2mm _1reo15vq _18m915vq _y3gn1h6o _ca0q53f4 _u5f3idpf _n3td53f4 _19bvidpf _p12f1git _19pk1wqb _2hwx1wug _otyridpf _18u01wug _gtagoshw _1k3j12qd _mzmgihc0 _1kmx11ux _1ggmidpf _1ykz1wqb _1maeidpf _dqkyoza4 _1n46idpf _if5yidpf _1gnpidpf _7e5bidpf _w77hr5sb _clfdidpf _11pqidpf _q0a5idpf _c3k8idpf _2trp1nn1",
                sectionIsVisible ? 'is-visible' : ''
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                layout: "8",
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1e0c1txw _2lx21bp4 _4cvr1h6o _zulpzwfg _p12f1oh5 _kqswh2mm _11wmstnw _tf4iidpf _mp8c15ko _98ph1e0x _7xg24bvh _1oli1wte _19zd183y _1fqc5gyx _1r4k11ux _ynmi101a _r7byckbl _1i6qljo4 _3iilglyw",
                        "content-wrapper"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                            width: "93",
                            height: "91",
                            viewBox: "0 0 93 91",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "big-star",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                                id: "Gestural Line/star 1",
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                    id: "star 1",
                                    d: "M63.1582 46.7878C65.7082 46.5678 99.8282 38.3178 90.8782 36.5278C87.5582 37.4578 84.9782 36.5178 83.3182 39.0378C82.8382 36.0678 76.3282 40.8078 75.3282 40.9878C74.8782 38.7378 64.6782 44.5278 66.1682 42.4378C61.5382 42.4978 55.7882 44.1177 49.8082 46.0177C46.8782 44.0277 59.4382 29.8278 54.1582 32.8978C54.5282 32.0978 55.9482 28.6378 55.7582 30.9278C57.4282 28.9678 75.6082 -1.03222 68.0482 4.04778C62.9482 10.2378 59.1182 20.6078 54.7982 25.7278C50.5982 27.4578 47.6882 42.3178 43.0082 40.8378C40.2782 37.4978 33.2382 -3.40217 28.2382 0.227831C29.1082 3.40783 28.3182 6.25777 30.7482 7.78777C27.7782 8.26777 32.5182 14.7778 32.6982 15.7778C30.4982 16.1978 36.1982 26.4378 34.1482 24.9378C34.1882 27.8278 34.8382 31.1678 35.7782 34.7178C34.5282 33.7678 33.1582 31.5978 32.3682 31.2778C23.9482 27.8678 17.5682 20.0278 8.7982 15.7778C1.4282 25.1678 66.5982 48.8577 26.1882 52.3978C18.5882 57.3577 8.48819 58.1177 0.00819142 62.8877C-0.721809 73.2177 47.6182 44.7178 33.6682 61.0878C31.4982 68.0078 28.2782 75.7778 23.8282 82.5978C20.9882 108.608 45.1382 37.9478 44.1382 64.9078C47.4682 71.3478 50.6882 79.1078 52.3382 87.0978C64.1482 104.418 48.0282 58.5978 46.3382 52.1078C52.7382 49.3778 77.4782 80.3378 81.9582 75.4578C82.1682 74.7678 78.6082 70.9378 77.5282 70.5278C76.7982 70.8978 76.4282 71.1977 75.9982 70.5177C78.1682 68.4277 70.5582 65.7878 69.8382 65.0678C71.4382 63.4778 60.8482 58.3077 63.4182 58.3877C61.4382 55.6177 58.4082 52.8277 54.9582 50.0177C61.0782 48.8377 63.7382 44.5177 63.1782 46.7677L63.1582 46.7878Z",
                                    fill: "#FCA700"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                            width: "49",
                            height: "51",
                            viewBox: "0 0 49 51",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "sm-star",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                                id: "Gestural Line/star 3",
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                    id: "Vector",
                                    d: "M47.4104 41.8537C47.4404 41.8037 47.4404 41.7137 47.5004 41.6437C45.7504 40.7637 45.5504 38.6038 44.2005 37.3138L44.1504 37.2637C42.7804 36.8237 43.1505 35.4538 41.4505 35.4438C41.4505 35.4438 41.8904 35.2237 41.9004 35.2237C39.1404 32.4837 32.3204 25.7537 32.3204 25.7537C32.1704 26.3637 33.4104 25.3037 34.6604 25.4837C34.6604 25.4837 34.7503 25.2538 34.8403 25.4338C38.0303 22.3238 41.6205 21.1338 45.7005 19.6538C47.7405 19.1038 48.0504 13.3337 44.5604 15.7237C44.5204 15.6837 44.4304 15.6538 44.3904 15.5838C43.1704 17.0038 41.1404 16.4837 39.6004 17.2237L39.5404 17.2537L36.9804 18.5037C35.5904 19.0737 33.9403 19.5238 32.2103 19.9638C32.2603 19.9138 32.3104 19.8638 32.3604 19.8138C32.3604 19.8138 32.5404 17.0438 32.4904 15.6738C32.4904 15.6738 34.2404 13.4738 33.6604 11.9638C34.6504 10.1938 38.1703 6.3237 34.9703 5.2237C33.9203 5.2237 33.1004 4.31373 32.7404 6.00373C32.6804 5.99373 32.6004 6.01371 32.5204 5.98371C32.3304 7.73371 30.2604 8.97374 29.6904 10.6337L29.6704 10.7038C29.8104 12.1238 28.7105 13.5238 28.7005 13.5238C28.1805 14.8238 27.5004 16.2437 26.7804 17.7237C26.4804 16.9237 26.1504 16.2138 25.8204 15.7038C24.6204 14.4038 25.1304 -3.35621 20.6904 0.56379C20.9004 3.91379 21.9604 7.40374 21.1004 10.3837C20.6804 10.6137 21.3203 11.8038 21.8403 12.7738C21.8003 14.0037 21.5504 14.6638 21.4804 16.4238C19.2804 14.8338 9.6804 6.7838 10.2704 12.2038C11.3004 12.7538 12.0503 13.3838 12.5903 14.6638C13.0903 15.2138 17.5004 17.6938 17.6404 18.3138C17.3504 19.1738 22.5605 19.8637 20.4505 20.5037C20.7605 21.1837 21.1804 21.8338 21.6704 22.4638C19.3904 22.7038 16.6604 23.3737 15.2304 24.2437C14.9804 24.6737 5.88033 25.2537 2.58033 27.3837C0.610334 28.4937 -1.12958 29.0438 0.920422 30.7138C1.66042 30.1138 4.44038 30.9738 4.38038 30.1838C5.06038 30.4638 9.66042 28.7037 10.1704 29.0037C10.4204 29.4037 14.0404 27.2838 13.6104 28.2838C16.1204 28.9938 19.1804 28.4137 22.3604 27.6037C21.1004 29.6037 19.8605 32.4537 19.7005 34.2237C18.6205 36.4937 15.7704 41.5138 14.8604 44.5938C13.5604 46.8338 14.0104 47.0138 15.6504 48.1638L15.6804 48.1938C16.0204 48.4238 15.6404 48.1937 16.9304 48.2437C16.8004 48.1237 16.6104 47.6038 16.3604 47.6938C16.5304 47.3438 18.4904 46.8437 17.6704 46.3737C17.6404 46.3037 18.9204 45.3237 19.0504 44.2637C20.1904 40.4837 22.9204 38.5737 24.9404 34.2637C24.8904 34.7137 28.2904 43.1838 28.1304 47.4038C27.8804 49.4838 32.9204 52.5838 32.1904 47.9438C32.2504 47.9238 32.3004 47.8438 32.3904 47.8338C31.5804 45.9238 32.6504 43.9537 32.2304 42.0137L32.2103 41.9338C31.3003 40.7538 32.3504 39.7738 30.9104 38.8138C30.9104 38.8138 31.4004 38.8637 31.4104 38.8737C30.7704 36.1237 30.3704 32.7637 29.7704 29.7537C31.9204 31.7037 33.8103 33.8037 34.5903 36.1137L34.6904 35.9638C34.6904 36.0338 34.8403 36.0837 34.7103 36.2437C36.5203 36.6237 37.1404 37.3837 38.4505 37.8937C38.4505 37.8937 39.8504 40.4237 41.4804 40.5137L43.9603 44.0238C45.0303 45.8338 50.8004 44.7937 47.4505 41.8937L47.4104 41.8537Z",
                                    fill: "#101214"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                            width: "74",
                            height: "71",
                            viewBox: "0 0 74 71",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "checkmark",
                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                                id: "Gestural Line/symbol check 1",
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                        id: "Vector",
                                        d: "M44.0389 33.5379C45.8049 32.3341 51.7382 25.3965 46.0606 27.0247C44.5346 28.2363 37.5403 37.5739 33.6984 42.3892C32.8541 40.4137 30.4297 38.2529 28.6559 37.1571C27.5793 36.1616 27.1455 37.8054 27.1455 37.8054C27.4476 38.2453 27.7652 38.9397 28.501 39.4954C29.3221 40.1127 29.4305 41.3937 30.7783 42.3738C35.5186 45.8078 33.3808 50.8623 37.9663 42.1036C39.5464 38.2606 43.5122 37.0105 44.0312 33.5379H44.0389Z",
                                        fill: "#82B536"
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                        id: "Vector_2",
                                        d: "M73.9993 33.2525C74.0381 23.2745 72.4037 7.62464 61.5132 3.92824C69.0653 14.0065 73.643 30.2429 69.4371 42.7366C65.541 62.5305 35.4644 73.635 17.3394 62.1677C19.1984 63.9272 23.4508 65.9259 26.0611 66.6976C19.1364 68.1947 3.56753 50.7699 14.5897 60.2539C-16.6875 20.4424 32.8308 -17.6327 61.3351 16.7538C53.2486 1.15796 32.2499 -4.17445 19.3146 3.41126C-43.0075 52.5834 64.6115 110.815 73.9916 33.2525H73.9993Z",
                                        fill: "#82B536"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "CustomersLandingPage.futureOfTeamworkHeader",
                                defaultMessage: "<helpUsShape>Help us shape</helpUsShape> <theFutureOfTeamwork>the future of teamwork</theFutureOfTeamwork>",
                                values: {
                                    helpUsShape: (str)=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                            className: "h1 reduced-font-weight",
                                            children: str
                                        }),
                                    theFutureOfTeamwork: (str)=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                            className: "h1",
                                            children: str
                                        })
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            className: ".body-lg",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "CustomersLandingPage.futureOfTeamworkParagraph",
                                defaultMessage: "At Atlassian, we believe the impossible is possible - together. Join us today to help us inspire teamwork anywhere and everywhere, worldwide."
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                            variant: "secondary",
                            color: "black",
                            href: (0, $jQ0cd.useLocalizedHref)('/customers/advocacy'),
                            dataEventProps: {
                                'data-event': 'clicked',
                                'data-event-component': 'linkButton',
                                'data-event-container': 'ctaSection',
                                'data-product-key': 'customers',
                                'data-label-english': 'Share your story'
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "CustomersLandingPage.futureOfTeamworkButton",
                                defaultMessage: "Share your story"
                            })
                        })
                    ]
                })
            })
        })
    });
};
const $892822865e707dc4$var$sectionStyles = null;
const $892822865e707dc4$var$contentWrapperStyles = null;

});

parcelRegister("03nan", function(module, exports) {
$parcel$export(module.exports, "GlobalStatsSection", function () { return $3e272949ffdb8f8e$export$844b01b63b4da82f; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kbpa7 = parcelRequire("kbpa7");

var $4Fnxt = parcelRequire("4Fnxt");
const $3e272949ffdb8f8e$export$844b01b63b4da82f = ()=>{
    const intl = (0, $8e22h.default)();
    const statsProps = {
        headerText: intl.formatMessage({
            id: 'CustomersLandingPage.stats.header',
            defaultMessage: 'Teams across the globe run on Atlassian'
        }),
        bigStat: {
            stat: '300000',
            statText: intl.formatMessage({
                id: 'CustomersLandingPage.numberOfCustomersTxt',
                defaultMessage: 'companies power team collaboration with Atlassian'
            }),
            statColor: (0, $kbpa7.wacToken)('color.primary.blue'),
            statSymbol: {
                symbolCharacter: '+',
                symbolCharacterColor: (0, $kbpa7.wacToken)('color.primary.blue')
            }
        },
        littleStats: [
            {
                stat: '200',
                statText: intl.formatMessage({
                    id: 'CustomersLandingPage.numberOfCountriesTxt',
                    defaultMessage: 'countries and territories have companies that use Atlassian'
                }),
                statColor: (0, $kbpa7.wacToken)('color.primary.blue'),
                statSymbol: {
                    symbolCharacter: '+',
                    symbolCharacterColor: (0, $kbpa7.wacToken)('color.primary.blue')
                }
            },
            {
                stat: '80',
                statText: intl.formatMessage({
                    id: 'CustomersLandingPage.fortune500CompaniesTxt',
                    defaultMessage: 'of Fortune 500 companies use Atlassian products'
                }),
                statColor: (0, $kbpa7.wacToken)('color.primary.blue'),
                statSymbol: {
                    symbolCharacter: '%',
                    symbolCharacterColor: (0, $kbpa7.wacToken)('color.primary.blue')
                }
            }
        ]
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "customers-page-stats",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4Fnxt.Stats), {
                ...statsProps
            })
        })
    });
};

});
parcelRegister("4Fnxt", function(module, exports) {
$parcel$export(module.exports, "AnimateCount", function () { return $cac0a62c179e6d20$export$b0e73e8bb50a1e4a; });
$parcel$export(module.exports, "Stats", function () { return $cac0a62c179e6d20$export$3cdec2bba15e3523; });
/* stats.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $6iKF0 = parcelRequire("6iKF0");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");
const $cac0a62c179e6d20$var$earthStyles = null;
const $cac0a62c179e6d20$export$cc52242338d2406f = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswstnw _1e02idpf _152txard _bna71wug _rtys1osq _t9ec1u9r _1h1t1ekt _tnru1wug _1rfm12eq _xaejlc6t _1eg616tw _95u51a2f"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
            image: {
                src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/435e558616x6e3c2jvth65jiq2vusf20.webp',
                alt: '',
                width: 700,
                height: 700
            }
        })
    });
};
const $cac0a62c179e6d20$var$easeOutQuad = (t)=>t * (2 - t);
const $cac0a62c179e6d20$var$frameDuration = 1000 / 60;
const $cac0a62c179e6d20$export$b0e73e8bb50a1e4a = ({ children: children = '0', duration: duration = 2000 })=>{
    const countTo = parseInt(children, 10);
    const [count, setCount] = (0, $1oC0p.useState)(0);
    (0, $1oC0p.useEffect)(()=>{
        let frame = 0;
        const totalFrames = Math.round(duration / $cac0a62c179e6d20$var$frameDuration);
        const counter = setInterval(()=>{
            frame++;
            const progress = $cac0a62c179e6d20$var$easeOutQuad(frame / totalFrames);
            setCount(countTo * progress);
            if (frame === totalFrames) clearInterval(counter);
        }, $cac0a62c179e6d20$var$frameDuration);
        return ()=>clearInterval(counter);
    }, [
        countTo,
        duration
    ]);
    return Math.floor(count).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
const $cac0a62c179e6d20$export$3cdec2bba15e3523 = (statsProps)=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: scrollRef,
        className: (0, $2jatx.default)([
            "_p12f1git _19pkidpf _2hwx1wug _otyridpf _18u01wug _kqswh2mm _1pbykb7n _ca0qymf6 _u5f3idpf _n3td53f4 _19bvidpf _1reo15vq _18m915vq _11q7g7ng _mkrz13pj _1vth1g58 _1kmxidpf _1ggmidpf _1ykzidpf _1maeidpf _srwz1ylp"
        ]),
        style: {
            "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
            layout: "12",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1q51gktf _85i5gktf _1gde1bp4",
                    "wrapper"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1q511ul9 _p12f1osq _1e0c1txw _4cvr1y6m _zulp1ylp _kqswh2mm _1t19idpf _p7vbidpf _1rhg1w8u _19wggktf _1gde1bp4 _1u2q1wqb",
                            "text-wrapper"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_16jlkb7n _1o9zkb7n _i0dl1ssb _1fe7kb7n _12ihkb7n _1a1xf1ug _1rfm1osq",
                                    "fifty"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                        className: (0, $2jatx.default)([
                                            "_1wyb8pqr _vwz4cjiy _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                        ]),
                                        children: statsProps.headerText
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                        className: (0, $2jatx.default)([
                                            "_ect41sko _vwz4zg3v _k48p53lb _19pk19bv _2hwxidpf _otyrftgi _18u0idpf _kqswh2mm _syaz5hrz",
                                            "_1wyb1qf2 _g4miqd8k _1lzo1bc9",
                                            "big-stat"
                                        ]),
                                        style: {
                                            "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display')),
                                            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                                className: (0, $2jatx.default)([
                                                    "_syazaktq",
                                                    "big-stat"
                                                ]),
                                                style: {
                                                    "--_ne49vm": (0, $6ZVlx.default)(statsProps.bigStat.statColor ? statsProps.bigStat.statColor : (0, $kbpa7.wacToken)('color.primary.black'))
                                                },
                                                children: [
                                                    ' ',
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6iKF0.default), {
                                                        fallback: null,
                                                        children: sectionIsVisible ? /*#__PURE__*/ (0, $7VQPk.jsx)($cac0a62c179e6d20$export$b0e73e8bb50a1e4a, {
                                                            children: statsProps.bigStat.stat
                                                        }) : statsProps.bigStat.stat
                                                    })
                                                ]
                                            }),
                                            statsProps.bigStat.statSymbol && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                className: (0, $2jatx.default)([
                                                    "_syaz3hme"
                                                ]),
                                                style: {
                                                    "--_1fkywrn": (0, $6ZVlx.default)(statsProps.bigStat.statSymbol?.symbolCharacterColor ? statsProps.bigStat.statSymbol.symbolCharacterColor : (0, $kbpa7.wacToken)('color.primary.black'))
                                                },
                                                children: statsProps.bigStat.statSymbol?.symbolCharacter
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                        className: (0, $2jatx.default)([
                                            "_1wyb1j6v _k48pl8b6 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                        ]),
                                        children: statsProps.bigStat.statText
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_16jlkb7n _1o9zkb7n _i0dl1r5k _1e0c1txw _zulpgktf _2lx21bp4 _y4ti1ylp _1fe7kb7n _12ihkb7n _1a1xf1ug _chtuidpf",
                                    "thirty"
                                ]),
                                children: statsProps.littleStats.map((statObj, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_kqswh2mm _bozggktf",
                                            "stat-wrapper"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_kqswstnw _4t3i1osq _11q71pfd _1bsbyh40 _1e02idpf"
                                                ]),
                                                style: {
                                                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                className: (0, $2jatx.default)([
                                                    "_ect41sko _vwz4zg3v _k48p53lb _19pk19bv _2hwxidpf _otyrftgi _18u0idpf _kqswh2mm _syaz5hrz",
                                                    "_1wybxxch",
                                                    "little-stat"
                                                ]),
                                                style: {
                                                    "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display')),
                                                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                                },
                                                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                                    className: (0, $2jatx.default)([
                                                        "_syaz1ymr"
                                                    ]),
                                                    style: {
                                                        "--_1bdhz6v": (0, $6ZVlx.default)(statObj.statColor ? statObj.statColor : (0, $kbpa7.wacToken)('color.primary.black'))
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6iKF0.default), {
                                                            fallback: null,
                                                            children: sectionIsVisible ? /*#__PURE__*/ (0, $7VQPk.jsx)($cac0a62c179e6d20$export$b0e73e8bb50a1e4a, {
                                                                children: statObj.stat
                                                            }) : statObj.stat
                                                        }),
                                                        statObj.statSymbol && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                            className: (0, $2jatx.default)([
                                                                "_syazo46c"
                                                            ]),
                                                            style: {
                                                                "--_hlkh7k": (0, $6ZVlx.default)(statObj.statSymbol?.symbolCharacterColor ? statObj.statSymbol.symbolCharacterColor : (0, $kbpa7.wacToken)('color.primary.black'))
                                                            },
                                                            children: statObj.statSymbol?.symbolCharacter
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                className: (0, $2jatx.default)([
                                                    "_1wyb1j6v _k48pl8b6 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                                ]),
                                                children: statObj.statText
                                            })
                                        ]
                                    }, index))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1h1tgbua _kqswh2mm _rjxpidpf _u7coidpf _152tidpf _4t3i1osq _1e0c1txw _1bah1h6o _mmgkgktf _1rfm1osq _tnru68cl _srwzidpf _476d1ylp _1t06idpf _1jc21gwv _10jx1gwv",
                            "earth-contents"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)($cac0a62c179e6d20$export$cc52242338d2406f, {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                                className: (0, $2jatx.default)([
                                    "_kqswstnw _152tidpf _1o2w1n0t _rjxp3ll0 _p5ce1x96 _1l7d176h _xaej15qf _1rfm68cl _tnru1wug",
                                    "blob"
                                ]),
                                width: "102",
                                height: "95",
                                "aria-hidden": "true",
                                viewBox: "0 0 102 95",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                        d: "M97.6377 58.2134C98.2297 54.8868 98.5329 51.356 98.5329 47.6063C98.5329 43.8566 98.2152 40.2236 97.6233 36.8533C94.057 16.8063 80.2829 4.44834 60.9645 1.28226C57.6726 0.742421 54.2074 0.46521 50.6123 0.46521C47.0172 0.46521 43.2632 0.771614 39.8414 1.34063C20.5085 4.60885 6.74887 16.923 3.18262 36.8533C2.57621 40.2236 2.27301 43.7982 2.27301 47.6063C2.27301 51.4143 2.57621 54.8868 3.16818 58.2134C6.70555 78.1144 20.4797 90.4578 39.8414 93.726C43.2632 94.3096 46.8728 94.6014 50.6123 94.6014C54.3518 94.6014 57.6726 94.3242 60.9645 93.7844C80.3118 90.6037 94.1148 78.2312 97.6521 58.2134H97.6377Z",
                                        fill: "#FCA700"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
                                className: (0, $2jatx.default)([
                                    "_1bsbutna _4t3i1wug _kqswstnw _1e021nh5 _u7co1228 _sugaglyw",
                                    "lightning"
                                ]),
                                width: "131",
                                height: "139",
                                "aria-hidden": "true",
                                viewBox: "0 0 131 139",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                        d: "M20.4793 61.2896C11.5228 63.9778 10.6462 63.8696 8.14861 74.6224C5.48565 77.7767 3.98043 82.2375 2.50009 87.7471C1.52422 89.9276 8.05758 89.112 4.36913 89.8361C6.75918 90.66 13.6813 90.2023 14.4338 91.2343C10.9604 99.0243 8.42147 107.638 6.13066 115.911C6.18028 130.151 27.1036 98.5582 29.5102 96.5941C30.7176 93.1152 44.2806 78.484 38.1442 78.1761C29.196 76.6947 23.4234 81.4636 30.1387 69.8369C30.2793 69.3875 33.3061 62.3049 32.6197 60.1909C28.0133 62.1883 27.0788 70.1864 24.2752 74.5474C19.5778 80.881 28.6253 81.9463 32.6114 81.3554C32.5618 82.2875 36.1345 80.7562 35.2909 82.7037C30.1718 90.2606 12.9866 112.723 13.028 112.765C11.7296 115.611 9.81084 116.752 9.33117 115.861C9.04172 115.328 18.2546 92.6159 19.5117 89.6947C20.5289 86.1243 14.2436 86.9482 14.2436 86.9482C14.2436 86.9482 14.897 87.2727 16.7578 87.3226C14.8143 87.8969 9.87707 87.1396 6.51115 86.8733C7.08179 81.7382 13.7061 65.3676 13.7061 65.3676C13.7061 65.3676 27.7817 64.2191 31.3378 59.9662C28.7245 59.7415 24.3001 61.0649 20.471 61.2979L20.4793 61.2896Z",
                                        fill: "#101214"
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                        d: "M128.71 53.5661L129.636 51.8599C129.934 51.294 130.314 50.7031 130.413 50.1954C130.537 49.6877 130.521 49.2633 130.488 48.9138C130.48 48.8139 130.488 48.7556 130.438 48.6391C130.397 48.5225 130.306 48.3894 130.248 48.3395C130.116 48.2313 129.983 48.1147 129.818 47.9982C129.487 47.7735 129.065 47.5322 128.47 47.424C127.858 47.3408 127.205 47.2908 126.576 47.2159C123.392 46.8913 120.216 46.5667 117.082 46.2505C114.138 45.9425 111.227 45.6346 108.341 45.335C105.76 45.052 103.205 44.7774 100.691 44.5027C100.492 44.4528 100.178 44.5193 100.137 44.253C100.153 44.0283 100.31 43.8369 100.393 43.6455C100.972 42.3971 101.543 41.1571 102.113 39.9336C103.395 37.1955 104.644 34.5239 105.86 31.9189C108.316 26.7256 110.689 21.8236 112.972 17.2878L112.699 17.5541C112.889 17.2295 113.303 16.1393 113.576 15.9479C113.923 14.9075 114.436 13.4843 115.039 11.9113C115.345 11.129 115.66 10.3051 115.982 9.47285L116.47 8.22446C116.76 7.53368 117.041 6.85116 117.322 6.17702C117.653 5.36141 117.702 4.6707 117.653 4.06315C117.587 3.43063 117.347 2.78144 116.958 2.27376C116.189 1.21679 114.948 0.800607 114.088 0.867188C113.063 1.14183 112.219 1.35825 111.632 1.51638C111.326 1.63289 111.086 1.7245 110.913 1.78276C110.789 1.82437 110.731 1.8493 110.731 1.8493C106.794 3.33905 102.626 4.49591 98.4578 5.61114C98.4578 5.61114 97.0768 5.87744 94.8769 6.31021C93.7687 6.5266 92.462 6.78464 91.0065 7.07593C90.2787 7.22574 89.5096 7.39216 88.7157 7.55861C88.3187 7.64184 87.9052 7.74169 87.4834 7.84988C87.0865 7.94975 86.6896 8.05795 86.2843 8.16614C83.0673 8.99008 79.4202 9.78077 76.1535 11.1124C74.5243 11.7699 73.0026 12.5771 71.729 13.4843C70.4472 14.3915 69.4216 15.4152 68.6939 16.3473C66.6181 18.4696 65.0798 21.008 63.8228 23.613C62.5575 26.2263 61.5733 28.9228 60.5974 31.5943C59.6464 34.2826 58.6292 36.8626 57.5458 39.5008L54.3536 47.3907C54.3536 47.3907 49.4163 60.7236 48.4156 64.9348C48.0931 66.2831 47.8864 67.4066 47.7871 68.2472C48.1841 68.2139 48.7382 68.1889 49.4328 68.1806C50.6899 65.9085 52.6582 61.3311 55.4452 53.7408C55.5527 53.5993 55.8008 53.1084 55.8918 53.0668C57.0744 49.6378 58.3315 46.2838 59.6465 42.9547C60.3163 41.2985 60.9862 39.6424 61.656 37.9862C62.3507 36.2967 62.9958 34.5821 63.6243 32.9176C64.8896 29.5886 66.1467 26.3178 67.7842 23.4132C68.6029 21.9651 69.5126 20.6085 70.5546 19.4267C71.5967 18.2365 72.7297 17.2711 74.086 16.4389C73.8213 16.3224 74.086 15.9145 74.4995 15.8479L74.5243 16.1808C76.3189 14.999 78.2789 14.2666 80.181 13.6924C82.0914 13.1181 83.9853 12.7103 85.8874 12.2609L87.3181 11.9113L88.7157 11.5452C89.6254 11.3205 90.5352 11.0957 91.4697 10.871C93.3801 10.3966 95.3814 9.84733 97.5233 9.11493C97.5068 9.12326 96.6053 9.71416 96.5888 9.7308C100.037 8.97344 103.627 8.15785 107.398 7.15081C108.341 6.88448 109.292 6.62649 110.259 6.32688C110.739 6.18539 111.227 6.03554 111.715 5.86909L112.145 5.72767L112.236 5.69435C112.352 5.64441 112.509 5.57783 112.616 5.69435C112.732 5.80254 112.658 5.96065 112.6 6.08549C109.813 12.3025 106.877 18.869 103.883 25.5521C102.32 29.0476 100.74 32.5681 99.1691 36.0969C98.3834 37.8613 97.5978 39.6257 96.8121 41.3818L95.8527 43.5206C95.6625 43.9284 95.4971 44.3446 95.431 44.7275C95.3648 45.1103 95.3649 45.4515 95.3897 45.7595C95.4145 46.3587 95.828 47.1993 96.3408 47.6321C96.5806 47.8484 96.837 47.9983 97.1595 48.1647C97.4903 48.3145 97.879 48.4394 98.3173 48.4893C105.239 49.1801 111.988 49.8542 118.521 50.5117C120.068 50.6615 121.598 50.8113 123.119 50.9528L124.252 51.061L124.74 51.1026H124.839L125.269 51.1275C125.327 51.1442 125.451 51.0943 125.46 51.1858L125.377 51.3689L125.195 51.76C124.906 52.3177 124.608 52.867 124.318 53.4246C123.979 54.0654 123.648 54.7063 123.293 55.3305L123.417 55.2056V55.2888C123.649 54.9726 123.963 54.5066 124.327 53.9073C124.674 53.3497 125.087 52.6838 125.534 51.9515C125.724 51.6851 125.956 51.3606 126.212 50.9778C126.262 50.8779 126.378 50.7947 126.378 50.6782C126.328 50.5866 126.204 50.6199 126.121 50.5783C125.915 50.5367 125.716 50.4951 125.517 50.4618C125.294 50.4202 125.071 50.3785 124.864 50.3369C124.393 50.2703 123.938 50.2038 123.5 50.1455C122.59 50.0207 121.763 49.9041 121.052 49.8126C119.638 49.6212 118.72 49.4963 118.72 49.4963C120.109 49.4547 121.523 49.463 122.946 49.5046C123.64 49.5379 124.343 49.5629 125.046 49.5962C125.592 49.6212 126.163 49.6544 126.742 49.6961L127.618 49.7709C127.693 49.7792 127.767 49.771 127.833 49.7959C127.899 49.8209 127.949 49.8958 127.932 49.9707C127.874 50.1038 127.8 50.2287 127.734 50.3536C127.453 50.8613 127.172 51.3772 126.882 51.8932C126.551 52.4758 126.212 53.0667 125.873 53.6493C125.501 54.2985 125.129 54.9476 124.732 55.5884C123.136 58.1352 121.564 60.7152 119.886 63.212C119.067 64.477 118.248 65.7338 117.438 66.9822C116.611 68.2222 115.8 69.4623 115.023 70.7107L114.742 70.4277C117.512 66.1749 119.629 62.1717 120.44 60.5571C115.593 68.2639 108.068 79.6908 99.8224 90.4602C95.7453 95.8783 91.4531 101.105 87.5 105.816C85.5069 108.154 83.6213 110.393 81.8185 112.399C80.9253 113.414 80.0735 114.388 79.263 115.312C78.4443 116.227 77.6669 117.093 76.9391 117.9C77.2037 117.842 78.1548 116.718 79.2382 115.578C80.3133 114.429 81.4959 113.223 82.3229 113.056C81.5786 113.888 80.8261 114.721 80.0818 115.545C79.3292 116.36 78.5684 117.176 77.8241 117.983C77.0715 118.79 76.3271 119.589 75.5911 120.38C74.8468 121.162 74.086 121.92 73.3416 122.661C72.8951 122.211 74.7641 120.646 75.0205 120.222C74.3093 120.788 72.1094 122.952 68.7187 126.114C67.0151 127.687 65.055 129.552 62.789 131.541C62.5161 131.782 62.2432 132.024 61.9703 132.273L61.7718 132.44C61.6312 132.531 61.532 132.681 61.3666 132.714C61.2012 132.739 61.0275 132.631 60.9614 132.465C60.8869 132.29 60.9944 132.115 61.0358 131.948C61.6395 129.901 62.268 127.754 62.9131 125.54C63.6822 122.96 64.4927 120.305 65.3446 117.6C67.0482 112.191 68.9006 106.573 70.8606 100.963C72.8124 95.3539 74.8716 89.7445 76.9474 84.3348C77.9811 81.63 79.0232 78.975 80.0569 76.395L80.4374 75.4296L80.6276 74.9469C80.6607 74.8636 80.6938 74.8054 80.7186 74.6889L80.8013 74.3227C81.0246 73.3406 81.2479 72.3668 81.4712 71.4014C81.5787 70.9187 81.6944 70.436 81.8019 69.9616L81.9674 69.2459L82.0501 68.8881C82.0583 68.8298 82.0914 68.7632 82.0832 68.7216C82.0584 68.6633 82.0087 68.6633 81.9591 68.6384C81.2313 68.3471 80.5036 68.0557 79.7841 67.7644C77.7 67.8477 75.6656 67.9226 73.6807 67.9975C72.2418 68.0391 70.8359 68.0724 69.4796 68.1057C66.767 68.1639 64.2198 68.1889 61.8959 68.1889C57.2398 68.1723 53.4522 68.164 50.8719 68.1557C50.3426 68.1557 49.8794 68.1557 49.4494 68.1557C49.2757 68.4719 49.1186 68.7382 48.9698 68.9629C49.8216 69.1128 50.9545 69.2792 52.4266 69.4789L51.5086 69.7619C56.082 70.0698 60.2584 70.253 64.501 70.4194C66.6181 70.4943 68.7517 70.5692 70.9516 70.6525C72.0515 70.6858 73.168 70.7274 74.3093 70.769C74.8799 70.7856 75.4588 70.8106 76.0377 70.8272C76.4512 70.8522 76.8647 70.8771 77.2865 70.9021C77.394 70.8938 77.4932 70.8855 77.5759 70.8772C78.2706 70.8189 78.3451 70.8355 78.6759 70.5276C79.0067 70.461 79.6517 70.3445 79.7261 70.203C79.8502 70.1031 79.9991 70.0116 80.1645 69.9367C80.2141 69.9201 80.3299 69.8785 80.3299 69.9367C80.3299 69.97 80.3299 70.0199 80.3216 70.0781C80.2803 70.3029 80.1645 70.6857 80.0074 71.1268C79.6931 72.0173 79.2217 73.0743 78.9819 73.7235C78.1549 72.5416 75.2273 79.3828 72.5809 87.1395C69.8931 94.8712 67.5443 103.469 66.8331 105.433C65.452 105.832 64.2198 113.214 63.0289 115.461C63.0372 115.278 63.1116 114.13 63.1281 113.98C62.7891 114.463 61.9538 117.026 60.9945 120.48C60.5148 122.203 59.9937 124.15 59.4727 126.156C58.9352 128.295 58.3811 130.5 57.8518 132.606C57.703 133.255 57.6368 133.821 57.6202 134.346C57.612 134.878 57.8105 135.427 58.1744 135.844C58.8773 136.709 60.1427 136.925 60.9779 136.501C61.7553 136.06 62.4582 135.394 63.0867 134.795C63.6491 134.271 64.1453 133.813 64.5588 133.438C66.0971 132.048 66.4692 131.907 64.7408 133.987C71.4147 128.528 78.742 121.678 86.1437 113.705C93.5702 105.757 100.972 96.6024 108.035 86.79C115.081 76.961 121.688 66.3996 127.61 55.6551L128.743 53.5661H128.71Z",
                                        fill: "#101214"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
const $cac0a62c179e6d20$var$wrapperStyle = null;
const $cac0a62c179e6d20$var$earthContents = null;
const $cac0a62c179e6d20$var$blobStyles = null;
const $cac0a62c179e6d20$var$lightningStyles = null;
const $cac0a62c179e6d20$var$TextWrapperStyles = null;
const $cac0a62c179e6d20$var$fiftyStyles = null;
const $cac0a62c179e6d20$var$h2Styles = null;
const $cac0a62c179e6d20$var$statStyles = null;
const $cac0a62c179e6d20$var$bigStatStyles = null;
const $cac0a62c179e6d20$var$littleStatStyles = null;
const $cac0a62c179e6d20$var$statTextStyles = null;
const $cac0a62c179e6d20$var$thirtyStyles = null;
const $cac0a62c179e6d20$var$statWrapperStyles = null;
const $cac0a62c179e6d20$var$dividerStyles = null;
const $cac0a62c179e6d20$var$statsStyles = null;

});


parcelRegister("gD5LF", function(module, exports) {
$parcel$export(module.exports, "filterCustomerStories", function () { return (parcelRequire("6eXit")).filterCustomerStories; });
$parcel$export(module.exports, "defaultCustomerStoryFilterOptionsObject", function () { return (parcelRequire("1ODGq")).defaultCustomerStoryFilterOptionsObject; });
$parcel$export(module.exports, "areFiltersAreActive", function () { return (parcelRequire("hBvFS")).areFiltersAreActive; });
$parcel$export(module.exports, "getFilterEventProps", function () { return (parcelRequire("hBvFS")).getFilterEventProps; });
$parcel$export(module.exports, "getFilterOptions", function () { return (parcelRequire("hBvFS")).getFilterOptions; });
$parcel$export(module.exports, "handleFallbackCustomerStories", function () { return (parcelRequire("hBvFS")).handleFallbackCustomerStories; });
parcelRequire("6eXit");
parcelRequire("1ODGq");
parcelRequire("hBvFS");
parcelRequire("7u2YB");
parcelRequire("fcMpu");

});
parcelRegister("6eXit", function(module, exports) {
$parcel$export(module.exports, "filterCustomerStories", function () { return $76b954c90d421ba3$export$e00c2f7823dc318c; });
const $76b954c90d421ba3$export$e00c2f7823dc318c = (results, filters, committedState)=>{
    const filteredProducts = Object.entries(filters.product).reduce((acc, [subFilterName, subFilterObject])=>{
        if (subFilterObject[committedState]) acc.push(subFilterName);
        return acc;
    }, []);
    const filteredIndustries = Object.entries(filters.industry).reduce((acc, [subFilterName, subFilterObject])=>{
        if (subFilterObject[committedState]) acc.push(subFilterName);
        return acc;
    }, []);
    const filteredSolutions = Object.entries(filters.solution).reduce((acc, [subFilterName, subFilterObject])=>{
        if (subFilterObject[committedState]) acc.push(subFilterName);
        return acc;
    }, []);
    const filteredRegions = Object.entries(filters['more filters']).reduce((acc, [subFilterName, subFilterObject])=>{
        if (subFilterObject.grouping === 'region') {
            if (subFilterObject[committedState]) acc.push(subFilterName);
        }
        return acc;
    }, []);
    const filteredTeamSize = Object.entries(filters['more filters']).reduce((acc, [subFilterName, subFilterObject])=>{
        if (subFilterObject.grouping === 'team size') {
            if (subFilterObject[committedState]) acc.push(subFilterName);
        }
        return acc;
    }, []);
    const filteredMarketplaceApps = filters['more filters']['Marketplace apps']?.[committedState];
    const filteredSolutionPartner = filters['more filters']['Solution partner']?.[committedState];
    const filterByCategory = (selectedCategoryValues, customerValues = [])=>{
        if (selectedCategoryValues.length > 0) {
            if (customerValues?.length > 0) {
                // Include if filter is applied and this company has that industry
                if (selectedCategoryValues.filter((selected)=>{
                    return customerValues.includes(selected);
                }).length > 0) return true;
            }
            // Remove this item if there is a filter applied but this customer does not have the appropriate value
            return false;
        }
        // Include all items if no filter has been requested
        return true;
    };
    const includeIfExists = (isEnabled = false, customerValues = [])=>{
        if (isEnabled) return customerValues?.length > 0;
        return true;
    };
    const filteredResults = results?.filter((customerStory)=>filterByCategory(filteredIndustries, customerStory.customerCompany?.industry?.map((industry)=>industry.name ?? ''))).filter((customerStory)=>filterByCategory(filteredProducts, customerStory.products?.map((product)=>product.name ?? ''))).filter((customerStory)=>filterByCategory(filteredSolutions, customerStory.solutions?.map((solution)=>solution.name ?? ''))).filter((customerStory)=>filterByCategory(filteredRegions, [
            customerStory.customerCompany?.region?.name ?? ''
        ])).filter((customerStory)=>filterByCategory(filteredTeamSize, [
            customerStory.customerCompany?.organizationSize?.name ?? ''
        ])).filter((customerStory)=>includeIfExists(filteredMarketplaceApps, customerStory.marketplaceApps?.map((app)=>app.name ?? ''))).filter((customerStory)=>includeIfExists(filteredSolutionPartner, customerStory.solutionPartners?.map((partner)=>partner.name ?? '')));
    return filteredResults;
};

});

parcelRegister("1ODGq", function(module, exports) {
$parcel$export(module.exports, "defaultCustomerStoryFilterOptionsObject", function () { return $6096117624169b39$export$6f0fff8c0ca899ac; });
const $6096117624169b39$export$6f0fff8c0ca899ac = {
    solution: {
    },
    product: {
    },
    industry: {
    },
    'more filters': {
        'Marketplace apps': {
            committedActive: false,
            stagedActive: false,
            description: 'Only show stories from customers that use marketplace apps'
        },
        'Solution partner': {
            committedActive: false,
            stagedActive: false,
            description: 'Only show stories from customers that have a solution partner'
        }
    }
};

});

parcelRegister("fcMpu", function(module, exports) {

});




parcelRegister("806Eh", function(module, exports) {
$parcel$export(module.exports, "EnterpriseContactThanksPage", function () { return $6afe4a8234fd5e3b$export$66942264c1afdb2a; });

var $7VQPk = parcelRequire("7VQPk");

var $1vmBr = parcelRequire("1vmBr");
const $6afe4a8234fd5e3b$export$66942264c1afdb2a = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $1vmBr.EnterpriseContactThanksPageTemplate), {});

});
parcelRegister("1vmBr", function(module, exports) {
$parcel$export(module.exports, "EnterpriseContactThanksPageTemplate", function () { return $7232d4740c8ebf7f$export$cb652a9a98cba1b2; });
/* enterprise-contact-thanks.template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8f0Vj = parcelRequire("8f0Vj");

var $iLjCW = parcelRequire("iLjCW");

var $hcVGp = parcelRequire("hcVGp");

var $eBWBi = parcelRequire("eBWBi");

var $8xKNU = parcelRequire("8xKNU");
const $7232d4740c8ebf7f$var$wrapperStyle = null;
const $7232d4740c8ebf7f$export$cb652a9a98cba1b2 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_vchhusvi _11rm1hrf _1e0c1txw _2lx21bp4"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hcVGp.GlobalNav), {
                            isShowTryNowLink: false,
                            tryNowLinkCtaButtonColor: "light_grey",
                            productKey: "enterpriseContactThanks"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8f0Vj.ContactSalesNav), {
                        showContactSales: true
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eBWBi.default), {})
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8xKNU.default), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iLjCW.GlobalFooter), {})
        ]
    });
};

});
parcelRegister("8f0Vj", function(module, exports) {
$parcel$export(module.exports, "ContactSalesNav", function () { return $cbfc951804659d8d$export$98b85ca48705081; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $9D78w = parcelRequire("9D78w");

var $5xvRI = parcelRequire("5xvRI");

var $jQ0cd = parcelRequire("jQ0cd");
const $cbfc951804659d8d$export$98b85ca48705081 = ({ showContactSales: showContactSales })=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $9D78w.ProductNavBar), {
        productHref: (0, $jQ0cd.useLocalizedHref)('/enterprise'),
        productName: "enterprise",
        showFreeHrefButton: false,
        showTextWithoutLogo: true,
        showContactSalesHrefButton: showContactSales,
        freeHref: (0, $jQ0cd.useLocalizedHref)('/enterprise/contact?formType=product-features'),
        ariaLabel: intl.formatMessage({
            id: 'contact-sales-thanks.logo-label',
            defaultMessage: 'Enterprise'
        }),
        dataProductKey: "enterpriseContactSales",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5xvRI.ProductNavLink), {
                label: intl.formatMessage({
                    id: 'contact-sales.navbar.overview',
                    defaultMessage: 'Overview'
                }),
                href: (0, $jQ0cd.useLocalizedHref)('/enterprise')
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5xvRI.ProductNavLink), {
                label: intl.formatMessage({
                    id: 'contact-sales.navbar.cloud',
                    defaultMessage: 'Cloud'
                }),
                href: (0, $jQ0cd.useLocalizedHref)('/enterprise/cloud')
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5xvRI.ProductNavLink), {
                label: intl.formatMessage({
                    id: 'contact-sales.navbar.data-center',
                    defaultMessage: 'Data Center'
                }),
                href: (0, $jQ0cd.useLocalizedHref)('/enterprise/data-center')
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5xvRI.ProductNavLink), {
                label: intl.formatMessage({
                    id: 'contact-sales.navbar.services',
                    defaultMessage: 'Services'
                }),
                href: (0, $jQ0cd.useLocalizedHref)('/enterprise/services')
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5xvRI.ProductNavLink), {
                label: intl.formatMessage({
                    id: 'contact-sales.navbar.resources',
                    defaultMessage: 'Resources'
                }),
                href: (0, $jQ0cd.useLocalizedHref)('/enterprise/resources')
            })
        ]
    });
};
$cbfc951804659d8d$export$98b85ca48705081.displayName = 'ContactSalesNav';

});
parcelRegister("9D78w", function(module, exports) {
$parcel$export(module.exports, "ProductNavBar", function () { return $b545d9db2ee66805$export$6bfdc568e00f9e3d; });
/* product-navbar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $l5ucJ = parcelRequire("l5ucJ");

var $lqyi6 = parcelRequire("lqyi6");

var $kbpa7 = parcelRequire("kbpa7");

var $4Rcm1 = parcelRequire("4Rcm1");

var $aHkxS = parcelRequire("aHkxS");

var $2Df35 = parcelRequire("2Df35");

var $80kL5 = parcelRequire("80kL5");

var $1ka2O = parcelRequire("1ka2O");

var $ldrV1 = parcelRequire("ldrV1");
const $b545d9db2ee66805$var$navigationWrapperCss = null;
const $b545d9db2ee66805$var$navigationBarWrapperCss = null;
const $b545d9db2ee66805$var$navigationBarCss = null;
// Jira paid landing pages share product-nav geometry without the Atlassian square.
const $b545d9db2ee66805$var$jiraNavigationBarCss = null;
const $b545d9db2ee66805$var$logoAndLinksCss = null;
const $b545d9db2ee66805$var$keyframeChevron = null;
const $b545d9db2ee66805$var$removeKeyframeChevron = null;
const $b545d9db2ee66805$var$dropdownSlideInAnimation = null;
const $b545d9db2ee66805$var$dropdownSlideOutAnimation = null;
const $b545d9db2ee66805$var$listItemCss = null;
const $b545d9db2ee66805$var$buttonWrapper = null;
const $b545d9db2ee66805$var$linkAndButtonWrapper = null;
const $b545d9db2ee66805$var$buttonStyle = null;
const $b545d9db2ee66805$var$contactSalesButtonStyle = null;
const $b545d9db2ee66805$var$logoDimensions = {
    confluence: 157,
    jiraservicemanagement: 280,
    jira: 80,
    jirasoftware: 80
};
const $b545d9db2ee66805$export$6bfdc568e00f9e3d = (props)=>{
    const intl = (0, $8e22h.default)();
    const isJira = props.productName === 'jira' || props.productName === 'jirasoftware';
    const isShowFreeHrefButton = props.showFreeHrefButton ?? true;
    const isShowContactSalesHrefButton = props.showContactSalesHrefButton ?? false;
    const showTextWithoutLogo = props.showTextWithoutLogo ?? false;
    const [activeDropdown, setActive] = (0, $1oC0p.useState)(null);
    const [buttonType, setButtonType] = (0, $1oC0p.useState)('secondary');
    const location = (0, $1ka2O.useLocation)();
    (0, $1oC0p.useEffect)(()=>{
        window.addEventListener('scroll', handleScroll);
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        (0, $aHkxS.Initializer).autoTrack();
    }, [
        activeDropdown,
        props.showFreeHrefButton
    ]);
    const handleScroll = ()=>{
        setButtonType(window.scrollY > 56 ? 'primary' : 'secondary');
    };
    const getItFreeText = intl.formatMessage({
        id: 'productNavBar.get-it-free-button',
        defaultMessage: 'Get it free'
    });
    const getContactSalesText = intl.formatMessage({
        id: 'productNavBar.contact-sales-button',
        defaultMessage: 'Contact sales'
    });
    const dropdownCss = [
        null,
        !activeDropdown && null,
        activeDropdown && null
    ];
    const mobileCategoriesWrapperCss = [
        null,
        activeDropdown === null && null,
        activeDropdown && null,
        !activeDropdown && null
    ];
    const renderSelectionItems = (isMobile)=>{
        const categoriesWrapperCss = [
            !isMobile && null
        ];
        return /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
            className: (0, $2jatx.default)([
                !isMobile && "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx2vrvc _qtt8glyw _18s8119w _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1mjbglyw"
            ]),
            children: props.children && (0, $1oC0p.Children).map(props.children, (child, index)=>child ? /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm"
                    ]),
                    children: /*#__PURE__*/ (0, $1oC0p.cloneElement)(child, {
                        isSelected: child.props.isSelected || (0, $80kL5.isEqualUnlocalizedPathname)(child.props.href, location.pathname),
                        isMobile: isMobile
                    })
                }, index) : null)
        });
    };
    const renderDropdownButton = ()=>{
        if (props.children) return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
            onClick: ()=>setActive(!activeDropdown),
            className: (0, $2jatx.default)([
                "_1e0cglyw _80omtlke _bfhk1j28 _19itglyw _syazftjs _1q5112x7 _1752xy5q _w8l5xy5q _48hmq7pw _1mjb1ule",
                !activeDropdown && "",
                !activeDropdown && "_1px117db",
                activeDropdown && "",
                activeDropdown && "_1px11vwh"
            ]),
            style: {
                "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800'))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l5ucJ))), {
                label: ""
            })
        });
        return null;
    };
    const logoWrapperCss = [
        props.logoLinkWrapperWidth && props.logoLinkWrapperWidth === '' && null,
        null,
        isJira && null
    ];
    const textWrapperCss = null;
    const textCss = null;
    const boxShadowCss = props.productName !== 'confluence' && props.productName !== 'jira' && null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqsw1n9t _1bsb1osq _152tidpf _1pby11wp"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_4cvr1y6m _11q71afi _1e0c1txw _2lx2vrvc _1bah1h6o",
                    props.productName !== 'confluence' && props.productName !== 'jira' && "_16qsg1bn"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_4cvr1h6o _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _1bah1yb4 _165t1wqb _10jx1fra _1yag119w _1vkh8vuz _13zno7np _em6nh2mm _4ik0kb7n _1gdevrvc _navj1g80 _tnru1wug _15tx119w",
                        isJira && "_btpd18pe _9qarglyw _1bg4usvi _1guz1q9c _16up1n1m _x8u0y5g8 _1ea11yva",
                        "productNavBar"
                    ]),
                    style: {
                        "--_eiqaqt": (0, $6ZVlx.default)((0, $4Rcm1.navLayout).height),
                        "--_1mhfb35": (0, $6ZVlx.default)((0, $4Rcm1.navLayout).outerInset)
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw"
                            ]),
                            children: [
                                showTextWithoutLogo ? /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                    href: props.productHref,
                                    "aria-label": props.ariaLabel,
                                    className: (0, $2jatx.default)([
                                        "_4t3i12am _syazkhc1 _4cvr1h6o _1e0c1txw _2lx2vrvc"
                                    ]),
                                    style: {
                                        "--_n0ignx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue1000'))
                                    },
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_1wyb166g _k48pbfng"
                                        ]),
                                        children: props.ariaLabel
                                    })
                                }) : /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                    href: props.productHref,
                                    "aria-label": props.ariaLabel,
                                    className: (0, $2jatx.default)([
                                        props.logoLinkWrapperWidth && props.logoLinkWrapperWidth === '' && "_1bsb2lms",
                                        "_4cvr1h6o _1e0c1txw",
                                        isJira && "_kqswh2mm _152t1lya _1o9zidpf"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
                                        brand: props.productName,
                                        type: "logo",
                                        appearance: "brand",
                                        height: isJira ? '24' : '48',
                                        width: isJira ? 62 : $b545d9db2ee66805$var$logoDimensions[props.productName]
                                    })
                                }),
                                renderDropdownButton(),
                                renderSelectionItems(false)
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o"
                            ]),
                            children: [
                                isShowFreeHrefButton && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _ca0qo7ao _u5f3idpf _n3tdo7ao _19bvidpf",
                                        isJira && "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
                                        "showFreeHrefButton"
                                    ]),
                                    children: isJira ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                        size: "small",
                                        href: props.freeHref,
                                        variant: buttonType,
                                        "aria-label": getItFreeText,
                                        dataEventProps: {
                                            'data-event-container': 'navbar',
                                            'data-event': 'clicked',
                                            'data-event-component': 'linkButton',
                                            'data-label': getItFreeText,
                                            'data-label-english': 'Get it free',
                                            'data-product-key': props.dataProductKey,
                                            'data-track-event': `${props.dataProductKey}.get-it-free-button-clicked`
                                        },
                                        onClick: props.onClick,
                                        className: (0, $2jatx.default)([
                                            "_1tke1ylp"
                                        ]),
                                        children: getItFreeText
                                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ldrV1.Button), {
                                        text: getItFreeText,
                                        url: props.freeHref,
                                        type: buttonType,
                                        "aria-label": getItFreeText,
                                        dataEventProps: {
                                            'data-event-container': 'navbar',
                                            'data-event': 'clicked',
                                            'data-event-component': 'linkButton',
                                            'data-label': getItFreeText,
                                            'data-label-english': 'Get it free',
                                            'data-product-key': props.dataProductKey,
                                            'data-track-event': `${props.dataProductKey}.get-it-free-button-clicked`
                                        },
                                        onClick: props.onClick,
                                        className: (0, $2jatx.default)([
                                            "_1wyb1j6v _k48pbfng _4t3iviql _1bsb1wug _1aaxusic _v5647x7w _3fcw1q9c _13zmh2mm _1rfm1wug _1gdevrvc _navj1g80 _1l7dn7od"
                                        ])
                                    })
                                }),
                                isShowContactSalesHrefButton && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: "showContactSalesHrefButton",
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ldrV1.Button), {
                                        text: getContactSalesText,
                                        color: "yellow",
                                        url: props.freeHref,
                                        type: buttonType,
                                        "aria-label": getContactSalesText,
                                        dataEventProps: {
                                            'data-event-container': 'navbar',
                                            'data-event': 'clicked',
                                            'data-event-component': 'linkButton',
                                            'data-label': getContactSalesText,
                                            'data-product-key': props.dataProductKey
                                        },
                                        onClick: props.onClick,
                                        className: (0, $2jatx.default)([
                                            "_1wyb1j6v _k48pbfng _4t3iviql _11q71uly _1bsb1wug _1aaxusic _v5647x7w _3fcw1q9c _13zmh2mm _1rfm1wug _1gdevrvc _navj1g80 _1l7dn7od"
                                        ]),
                                        style: {
                                            "--_1p38jlt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.saffron400'))
                                        }
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_16jlkb7n _1o9zkb7n _i0dlf1ug _16qsg1bn _c71lidpf _1reo15vq _18m91wug _kqswstnw _1bsb1osq _bfhkg7ng _179rn5xp _102oidpf _1kvxidpf _1ysjidpf _17d4idpf _1hzio7ao _3n4midpf _ltofo7ao _k7zy1ul9 _1hmtglyw _163ro7ao _dm25glyw",
                    activeDropdown === null && "_1h6d6u2e _mqm2n5xp",
                    activeDropdown && "",
                    activeDropdown && "_c71l8stt _y44vuhag _1h6dkhc1 _mqm2kze7",
                    !activeDropdown && "",
                    !activeDropdown && "_y44v1ovr _1h6d6u2e _mqm2kze7",
                    "mobileCategoriesWrapper"
                ]),
                style: {
                    "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100')),
                    "--_qtmnbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light300')),
                    "--_n0ignx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue1000')),
                    "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
                },
                children: renderSelectionItems(true)
            })
        ]
    });
};
var $b545d9db2ee66805$export$2e2bcd8739ae039 = $b545d9db2ee66805$export$6bfdc568e00f9e3d;

});
parcelRegister("l5ucJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::55c6484ab5ceb86b7f950bb9205e88a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f5a17e8d4d565048$var$_react = $f5a17e8d4d565048$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f5a17e8d4d565048$var$_baseNew = $f5a17e8d4d565048$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $f5a17e8d4d565048$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f5a17e8d4d565048$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $f5a17e8d4d565048$var$_react.default.createElement($f5a17e8d4d565048$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$f5a17e8d4d565048$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $f5a17e8d4d565048$var$_default = module.exports.default = $f5a17e8d4d565048$var$ChevronDownIcon;

});


parcelRegister("5xvRI", function(module, exports) {
$parcel$export(module.exports, "ProductNavLink", function () { return $3331e0af5dabfddc$export$df4f9873dfab197b; });
/* product-navlink.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $3331e0af5dabfddc$var$linkStyle = null;
const $3331e0af5dabfddc$export$df4f9873dfab197b = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_18ywh2mm _9c4j1l7b _1hw71ule _19tb1j6v _1la1kb7n _8bvm119w _i7kgzu5n _5i9qrbzz _1x5rusvi _1qxa59zy _1unt1r31 _jsn2glyw _1b4hnqa1 _1mcc10vn _1ry4oelr _906b1osq _1nzh1xjh _1euc119w _3uyxrbzz _1u7j19bv _c12j1r31 _1udz8stv _4ba5nqa1 _1u6y1r31 _14ifglyw _f3mxnqa1 _1sinoelr _jhsausvi _c3hm4m1f _1ohxni7l _4mi7nclz _b4f8nclz"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
            className: props.isSelected ? 'selected' : '',
            href: props.href,
            ...props.dataEventProps,
            "data-label": props.label,
            children: props.label
        })
    });
};
var $3331e0af5dabfddc$export$2e2bcd8739ae039 = $3331e0af5dabfddc$export$df4f9873dfab197b;

});


parcelRegister("eBWBi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $edc225729fd9b967$export$2e2bcd8739ae039; });
/* hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");
const $edc225729fd9b967$var$outerWrapperStyle = null;
const $edc225729fd9b967$var$rowWrapperStyle = null;
const $edc225729fd9b967$var$columnStyle = null;
const $edc225729fd9b967$var$headerTextStyle = null;
const $edc225729fd9b967$var$descriptionTextSytle = null;
const $edc225729fd9b967$var$imageStyle = null;
const $edc225729fd9b967$export$6e76f8357f41ff9b = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Ticket_created@2x_1.webp",
        alt: "Ticket",
        className: (0, $2jatx.default)([
            "_vchhusvi _1e0c1nu9 _y3gn1h6o _4t3i1qnl _6rth7vkz _p12f1osq _1reozryt _18m9zryt _1bsb1178 _1b3h1ntv _wii51fhb _1rx61osq"
        ])
    });
};
const $edc225729fd9b967$var$Hero = ()=>{
    const intl = (0, $8e22h.default)();
    const headerText = intl.formatMessage({
        id: 'enterpriseContactThanksPage.message-recieved',
        defaultMessage: 'Message received'
    });
    const descriptionTicketText = intl.formatMessage({
        id: 'enterpriseContactThanksPage.creating-ticket',
        defaultMessage: 'Our sales team is creating a ticket and will email you within 2 business days.'
    });
    const descriptionResourcesText = intl.formatMessage({
        id: 'enterpriseContactThanksPage.resources-to-start',
        defaultMessage: 'In the meantime, here are some resources to get you started.'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _vchhusvi _11rm1hrf _1e0c1ule _12qx1osq _85i5zwfg _1q5116xz"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_vchhusvi _1e0c1txw _1n261g80 _12l21wug _ahbq1wug _p12f1git"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _vchhusvi _1e0c1ule _2lx21bp4 _1aax1e5h _1tket94y _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _y3gn1h6o _1bsbf2ck _1rfm1osq _1fqp1jgg _1ywm1jgg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)($edc225729fd9b967$export$6e76f8357f41ff9b, {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_vchhusvi _1e0c1ule _6rth1tcg _ect41jfk _1wyb1wto _k48pbfng _1dyz4jg8 _vwz41k7u _y3gn1h6o _s7n41q9y _syaz1bqd _flz0yn4p _280zzz36 _1po47vkz _1lzoyn4p _119zzz36 _qtem7vkz _1cqsviql _1bys10nf _srwzdlk8"
                        ]),
                        children: headerText
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_vchhusvi _1e0c1ule _ect41jfk _1wyb1k92 _k48p1nn1 _1dyznl7k _vwz419ii _y3gn1h6o _s7n41q9y _syazvwuj"
                        ]),
                        children: [
                            descriptionTicketText,
                            /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
                            descriptionResourcesText
                        ]
                    })
                ]
            })
        })
    });
};
var $edc225729fd9b967$export$2e2bcd8739ae039 = $edc225729fd9b967$var$Hero;

});

parcelRegister("8xKNU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bc961ec8943d3af9$export$2e2bcd8739ae039; });
/* resource-cards.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $jQ0cd = parcelRequire("jQ0cd");

var $7iXNu = parcelRequire("7iXNu");
const $bc961ec8943d3af9$var$wrapperCardStyle = null;
const $bc961ec8943d3af9$var$resourceCardsStyling = null;
const $bc961ec8943d3af9$var$ResourceCards = ()=>{
    const intl = (0, $8e22h.default)();
    const roadMapsText = intl.formatMessage({
        id: 'EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.ViewRoadmaps',
        defaultMessage: 'View roadmaps'
    });
    const advancedFeaturesText = intl.formatMessage({
        id: 'EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.AdvancedFeatures',
        defaultMessage: 'See advanced features'
    });
    const browseResourcesText = intl.formatMessage({
        id: 'EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.BrowseResources',
        defaultMessage: 'Browse resources'
    });
    const resourceCards = [
        {
            header: intl.formatMessage({
                id: 'EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.FeatureRoadmaps',
                defaultMessage: 'Feature Roadmaps'
            }),
            description: intl.formatMessage({
                id: 'EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.FeatureRoadmaps.dsc',
                defaultMessage: "See what's in our pipeline for Cloud and Data Center products."
            }),
            buttonText: roadMapsText,
            url: (0, $jQ0cd.useLocalizedHref)('/roadmap/cloud')
        },
        {
            header: intl.formatMessage({
                id: 'EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.CloudPremium',
                defaultMessage: 'Cloud Premium products'
            }),
            description: intl.formatMessage({
                id: 'EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.CloudPremium.dsc',
                defaultMessage: 'Learn about advanced product features for enterprises.'
            }),
            buttonText: advancedFeaturesText,
            url: (0, $jQ0cd.useLocalizedHref)('/software/premium')
        },
        {
            header: intl.formatMessage({
                id: 'EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.EnterpriseResources',
                defaultMessage: 'More enterprise resources'
            }),
            description: intl.formatMessage({
                id: 'EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.EnterpriseResources.dsc',
                defaultMessage: 'View resources, filtered by Cloud and Data Center product features.'
            }),
            buttonText: browseResourcesText,
            url: (0, $jQ0cd.useLocalizedHref)('/enterprise/resources?format=&topic=product-features&platform=')
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _vchhusvi _11rm1hrf _1e0c1ule _1ul91osq _85i57vkz _1q517vkz"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_vchhusvi _1e0c1txw _2lx2vrvc _ahbq1wug _12l21wug _p12f1fra _1gde1bp4"
            ]),
            children: resourceCards.map((cardProps)=>/*#__PURE__*/ (0, $1oC0p.createElement)((0, $7iXNu.default), {
                    ...cardProps,
                    key: cardProps.header,
                    type: "primary",
                    color: "grey"
                }))
        })
    });
};
var $bc961ec8943d3af9$export$2e2bcd8739ae039 = $bc961ec8943d3af9$var$ResourceCards;

});
parcelRegister("7iXNu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $633ccda817580805$export$2e2bcd8739ae039; });
/* resource-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $ldrV1 = parcelRequire("ldrV1");
const $633ccda817580805$var$resourceCardStyles = {
    primary: {
        white: {
            padding: '24px',
            borderStyle: 'solid',
            borderWidth: '1px',
            borderRadius: '10px',
            // eslint-disable-next-line local/ensure-wac-token-usage
            borderColor: '#c1c7d0',
            width: '310px'
        },
        grey: {
            height: '100%',
            padding: '40px',
            // eslint-disable-next-line local/ensure-wac-token-usage
            backgroundColor: '#fafbfc',
            borderRadius: '3px'
        }
    },
    secondary: {}
};
const $633ccda817580805$var$wrapperStyle = null;
const $633ccda817580805$var$headerStyle = null;
const $633ccda817580805$var$descriptionStyle = null;
const $633ccda817580805$var$buttonStyle = null;
const $633ccda817580805$var$ResourceCard = ({ header: header, description: description, buttonText: buttonText, url: url, type: type, color: color })=>{
    const formattedType = type?.toLowerCase();
    const resourceCardType = formattedType === 'secondary' ? 'secondary' : 'primary';
    const formattedColor = color?.toLowerCase();
    const resourceCardColor = formattedColor === 'grey' ? 'grey' : 'white';
    const styles = $633ccda817580805$var$resourceCardStyles[resourceCardType][resourceCardColor];
    /* eslint-disable @typescript-eslint/no-non-null-assertion */ const { padding: padding, width: width, height: height, borderStyle: borderStyle, borderRadius: borderRadius, borderWidth: borderWidth, borderColor: borderColor, backgroundColor: backgroundColor } = styles ? styles : $633ccda817580805$var$resourceCardStyles.primary.white;
    /* eslint-enable @typescript-eslint/no-non-null-assertion */ const backgroundStyle = null;
    const templatesTabCardDataEventProps = {
        'data-product-key': 'enterpriseContactSales',
        'data-event-component': 'linkButton',
        'data-event-container': 'cardSection',
        'data-event': 'clicked'
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _vchhusvi _1e0c1ule _1aax1e5h _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1tket94y _ect4czdy _1wyb7vkz _vwz47vkz _s7n41q9y _14b527ks"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_vchhusvi _1e0c1ule _2lx21bp4 _1yt418y6 _1bsb9tg7 _4t3imry4 _1dqo1yif _2rko1qt3 _189e1ywc _bfhkaxbu _1h6d1srq"
            ]),
            style: {
                "--_1xumd0e": (0, $6ZVlx.default)(padding),
                "--_1ea5ebz": (0, $6ZVlx.default)(width),
                "--_roksyz": (0, $6ZVlx.default)(height),
                "--_ahoyl5": (0, $6ZVlx.default)(borderStyle),
                "--_1lnby5": (0, $6ZVlx.default)(borderRadius),
                "--_g1hsiq": (0, $6ZVlx.default)(borderWidth),
                "--_1ly4823": (0, $6ZVlx.default)(backgroundColor),
                "--_37cwmb": (0, $6ZVlx.default)(borderColor)
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_vchhusvi _1e0c1ule _6rth1tcg _ect418zh _1wyb1k92 _k48pbfng _1dyz165v _vwz4cjiy _s7n41q9y _syaz1bqd _qtemdlk8 _1cqs1j6v _srwzdlk8 _1bys10nf"
                    ]),
                    children: header
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_vchhusvi _1e0c1ule _6rth1tcg _ect4czdy _1wyb7vkz _k48p1nn1 _vwz4bs82 _syazvwuj _s7n41q9y"
                    ]),
                    children: description
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ldrV1.Button), {
                        text: buttonText,
                        "aria-label": buttonText,
                        url: url,
                        type: "secondary",
                        color: "whiteblue",
                        dataEventProps: templatesTabCardDataEventProps,
                        className: (0, $2jatx.default)([
                            "_bfhku67f _syazrbzz _vchhusvi _1e0c1o8l _4t3in7od _1tkel07h _85i56mu8 _bozg19bv _y4ti19bv _1q516mu8 _ect418gv _1wyboxwj _k48pbfng _vwz4nqt0 _y3gn1h6o _1hmsglyw _ajmmnqa1 _1keg1wug _3fcw1g80 _s7n41q9y _d5ymcfaq _1dqonqa1 _189et94y _80omtlke _2rko1l7b _qmxj15zi _1y1musvi _qjkj1u8q _1lrw1wug"
                        ])
                    })
                })
            ]
        })
    });
};
var $633ccda817580805$export$2e2bcd8739ae039 = $633ccda817580805$var$ResourceCard;

});




parcelRegister("bWWTF", function(module, exports) {
$parcel$export(module.exports, "CheckemailPage", function () { return $83469c2406e9f5ec$export$137de9ee4cfd53f4; });
// @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $33d71 = parcelRequire("33d71");
const $83469c2406e9f5ec$export$137de9ee4cfd53f4 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $33d71.CheckemailPageTemplate), {});

});
parcelRegister("33d71", function(module, exports) {
$parcel$export(module.exports, "CheckemailPageTemplate", function () { return $933e21ecde646934$export$81cea22471256edf; });
/* checkemail-page.template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $5uYpV = parcelRequire("5uYpV");

var $78ld5 = parcelRequire("78ld5");

var $h7dMy = parcelRequire("h7dMy");

var $j6OMz = parcelRequire("j6OMz");
const $933e21ecde646934$var$ContainerStyle = null;
const $933e21ecde646934$var$InnerStyle = null;
const $933e21ecde646934$export$81cea22471256edf = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1n261q9c _4cvr1h6o _1wpz1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_4cvr1fhb _1e0c1txw _2lx21bp4 _1bah1h6o _y3gn1h6o _ca0q1wto _u5f31wto _n3td1wto _19bv1wto _k48p4jg8 _ect4z4z1 _xlob1h6o _szfsglyw _stfgidpf _d32voelr _dpd3116y _1o7p1osq _1r4aidpf _125m1tcg _1hbsidpf _1u71idpf _y2qtidpf _fl8bidpf _1gflidpf _yhjmidpf _1gqnidpf _11lvidpf _ficf1h6o _397o1r31 _108nglyw _uulsnqa1 _1eo0tlke _4pkprbzz _1pnjrbzz _1k4x1ltp _wlf1oelr _k58frbzz _8t1xrbzz _knlz1ltp"
            ]),
            style: {
                "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5uYpV.Logo), {
                        type: 'logo',
                        appearance: 'brand',
                        brand: 'atlassian'
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j6OMz.EmailedYou), {}),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $h7dMy.EmailButtons), {}),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $78ld5.ContactSupport), {})
            ]
        })
    });
};

});
parcelRegister("5uYpV", function(module, exports) {
$parcel$export(module.exports, "Logo", function () { return $2b139601b22d9c87$export$e6ff31bff12b7ff4; });

var $7VQPk = parcelRequire("7VQPk");

var $6A2DX = parcelRequire("6A2DX");

var $888KO = parcelRequire("888KO");

var $fg0qm = parcelRequire("fg0qm");

var $cusIg = parcelRequire("cusIg");

var $3Dz6G = parcelRequire("3Dz6G");

var $hktDW = parcelRequire("hktDW");

var $3RGc0 = parcelRequire("3RGc0");

var $d3z6K = parcelRequire("d3z6K");

var $a9CD6 = parcelRequire("a9CD6");

var $aBawz = parcelRequire("aBawz");

var $eCQc3 = parcelRequire("eCQc3");

var $4IHFR = parcelRequire("4IHFR");

var $1OyVz = parcelRequire("1OyVz");

var $a0AEy = parcelRequire("a0AEy");

var $cH95H = parcelRequire("cH95H");

var $5xYFE = parcelRequire("5xYFE");

var $bEzzt = parcelRequire("bEzzt");

var $9YpGW = parcelRequire("9YpGW");

var $ldaRP = parcelRequire("ldaRP");

var $dmDFX = parcelRequire("dmDFX");

var $bogCj = parcelRequire("bogCj");

var $98rQm = parcelRequire("98rQm");
const $2b139601b22d9c87$var$Logos = {
    atlas: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fg0qm.AtlasMarkBrand), {})
        }
    },
    atlassian: {
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cusIg.AtlassianLogoBrand), {}),
            neutral: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3Dz6G.AtlassianLogoNeutral), {})
        }
    },
    bitbucket: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hktDW.BitbucketMarkBrand), {})
        }
    },
    compass: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3RGc0.CompassMarkBrand), {})
        }
    },
    confluence: {
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $d3z6K.ConfluenceLogoBrand), {})
        },
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9CD6.ConfluenceMarkBrand), {})
        }
    },
    customerservicemanagement: {
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aBawz.CustomerServiceManagementLogoBrand), {})
        },
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eCQc3.CustomerServiceManagementMarkBrand), {})
        }
    },
    enterprise: {
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $888KO.EnterpriseLogo), {})
        }
    },
    halp: {
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4IHFR.HalpLogoBrand), {})
        }
    },
    jira: {
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.JiraLogo), {
                appearance: "brand"
            })
        },
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1OyVz.JiraMarkBrand), {})
        }
    },
    jiraalign: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a0AEy.JiraAlignMarkBrand), {})
        }
    },
    jiraservicemanagement: {
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bEzzt.JiraServiceManagementLogoBrand), {})
        },
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9YpGW.JiraServiceManagementMarkBrand), {})
        }
    },
    jiraproductdiscovery: {
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cH95H.JiraProductDiscoveryLogoBrand), {})
        },
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5xYFE.JiraProductDiscoveryMarkBrand), {})
        }
    },
    jirasoftware: {
        logo: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ldaRP.JiraSoftwareLogoBrand), {})
        },
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dmDFX.JiraSoftwareMarkBrand), {})
        }
    },
    jiraworkmanagement: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bogCj.JiraWorkManagementMarkBrand), {})
        }
    },
    softwaredevelopment: {},
    trello: {
        mark: {
            brand: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $98rQm.TrelloMarkBrand), {})
        }
    }
};
const $2b139601b22d9c87$export$e6ff31bff12b7ff4 = ({ brand: brand, type: type, appearance: appearance })=>{
    return $2b139601b22d9c87$var$Logos[brand]?.[type]?.[appearance];
};

});
parcelRegister("888KO", function(module, exports) {
$parcel$export(module.exports, "EnterpriseLogo", function () { return $70f66111dc830150$export$854b8d8f612d0fbb; });

var $7VQPk = parcelRequire("7VQPk");
const $70f66111dc830150$export$854b8d8f612d0fbb = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "98",
        height: "28",
        viewBox: "0 0 98 28",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                children: "Enterprise"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 4H0.375V28H0V4Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M92.4455 11.3375C91.0255 11.3375 90.3055 12.3175 90.1455 13.6175C91.1255 13.4175 92.4855 13.3375 93.4055 13.3375H94.4656C94.3256 12.0575 93.6855 11.3375 92.4455 11.3375ZM97.0055 18.7775C96.1255 19.1775 94.8856 19.3775 93.1656 19.3775C89.2255 19.3775 87.1855 17.2575 87.1855 14.2575C87.1855 11.2975 89.0856 9.15747 92.5256 9.15747C96.0456 9.15747 97.4655 11.2775 97.4655 14.2575V14.9175H94.9656C93.3256 14.9175 91.6455 14.8775 90.1455 14.7775C90.3655 15.9775 91.3655 16.7375 93.4655 16.7375C94.7855 16.7375 95.8655 16.5975 97.0055 16.2975V18.7775Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M85.6294 16.1975C85.6294 17.9375 84.4894 19.3975 81.3294 19.3975C79.5294 19.3975 78.0094 19.1575 77.1494 18.6975V16.2175C78.0694 16.6375 79.6894 17.0575 81.3294 17.0575C82.3094 17.0575 82.8694 16.8175 82.8694 16.3375C82.8694 15.8175 82.5094 15.5775 80.6494 15.3175C78.1494 14.9775 77.1094 14.0175 77.1094 12.2375C77.1094 10.3375 78.6894 9.15747 81.3494 9.15747C82.8894 9.15747 84.3094 9.41747 85.1694 9.81747V12.3375C83.8494 11.7175 82.4894 11.4575 81.1694 11.4575C80.2294 11.4575 79.8094 11.7375 79.8094 12.1975C79.8094 12.6975 80.2694 12.9175 82.0894 13.1575C84.4694 13.4975 85.6294 14.3975 85.6294 16.1975Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M71.4473 6.3175C71.4473 5.0575 72.2473 4.4375 73.4073 4.4375C74.5473 4.4375 75.3473 5.0575 75.3473 6.3175C75.3473 7.5775 74.5473 8.1975 73.4073 8.1975C72.2473 8.1975 71.4473 7.5775 71.4473 6.3175ZM71.8873 19.1775V9.3575H74.8473V19.1775H71.8873Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M67.4854 14.6774V19.1774H64.5254V9.35741H67.4854V11.8374C67.9254 10.2574 68.6054 9.13741 70.2054 9.21741V12.3974C68.4454 12.2574 67.4854 12.7974 67.4854 14.6774Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M59.2491 14.2775C59.2491 12.7375 58.4691 11.7975 57.0891 11.7975C55.8091 11.7975 54.8291 12.7775 54.8291 14.1975V14.3775C54.8291 15.9375 55.8091 16.7375 57.0891 16.7375C58.4091 16.7375 59.2491 15.8975 59.2491 14.2775ZM57.9291 19.3775C56.4891 19.3775 55.4091 18.6775 54.8291 17.2975V23.5775H51.8691V9.35747H54.8291V11.2775C55.4491 9.87747 56.6291 9.15747 58.1691 9.15747C60.7891 9.15747 62.2091 11.3775 62.2091 14.2775C62.2091 17.0375 60.7691 19.3775 57.9291 19.3775Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M47.4659 14.6774V19.1774H44.5059V9.35741H47.4659V11.8374C47.9059 10.2574 48.5859 9.13741 50.1859 9.21741V12.3974C48.4259 12.2574 47.4659 12.7974 47.4659 14.6774Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M37.2698 11.3375C35.8498 11.3375 35.1298 12.3175 34.9698 13.6175C35.9498 13.4175 37.3098 13.3375 38.2298 13.3375H39.2898C39.1498 12.0575 38.5098 11.3375 37.2698 11.3375ZM41.8298 18.7775C40.9498 19.1775 39.7098 19.3775 37.9898 19.3775C34.0498 19.3775 32.0098 17.2575 32.0098 14.2575C32.0098 11.2975 33.9098 9.15747 37.3498 9.15747C40.8698 9.15747 42.2898 11.2775 42.2898 14.2575V14.9175H39.7898C38.1498 14.9175 36.4698 14.8775 34.9698 14.7775C35.1898 15.9775 36.1898 16.7375 38.2898 16.7375C39.6098 16.7375 40.6898 16.5975 41.8298 16.2975V18.7775Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M27.7716 15.4574C27.7716 16.1574 28.2316 16.6174 29.1516 16.6174C29.6316 16.6174 30.1516 16.5374 30.5116 16.4774V19.1574C30.0316 19.2974 29.4516 19.3974 28.6316 19.3974C26.0716 19.3974 24.8116 17.8974 24.8116 15.6974V12.0174H23.3516V9.3574H24.8116V6.8374H27.7716V9.3574H30.4916V12.0174H27.7716V15.4574Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M21.6467 13.6775V19.1775H18.6667V13.8975C18.6667 12.4375 18.1467 11.7575 16.9467 11.7575C15.7067 11.7575 14.8667 12.4975 14.8667 13.8975V19.1775H11.8867V9.35747H14.8667V11.2575C15.4667 9.91747 16.6467 9.15747 18.1667 9.15747C20.5667 9.15747 21.6467 10.8775 21.6467 13.6775Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 19.1776V6.0376H9.44V8.7976H3.04V11.3976H8.76V13.8976H3.04V16.4176H9.56V19.1776H0Z",
                fill: "black"
            })
        ]
    });

});

parcelRegister("fg0qm", function(module, exports) {
$parcel$export(module.exports, "AtlasMarkBrand", function () { return $004c01aa738aa03a$export$41a3624cc2b0f936; });

var $7VQPk = parcelRequire("7VQPk");
const $004c01aa738aa03a$export$41a3624cc2b0f936 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M24 42.7982C14.016 42.7982 5.89795 34.6802 5.89795 24.6962C5.89795 14.7122 14.016 6.59424 24 6.59424V9.47624C15.604 9.47624 8.78095 16.2992 8.78095 24.6952C8.78095 33.0912 15.604 39.9142 24 39.9142V42.7962V42.7982Z",
                fill: "url(#paint0_linear_818_466)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M23.9999 42.7983V39.9163C32.3959 39.9163 39.2189 33.0933 39.2189 24.6973H42.1009C42.1009 34.6813 33.9829 42.7993 23.9989 42.7993L23.9999 42.7983Z",
                fill: "url(#paint1_linear_818_466)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M42.102 24.6962H39.22C39.22 16.3002 32.397 9.47722 24.001 9.47722V6.59521C33.985 6.59521 42.103 14.7132 42.103 24.6972L42.102 24.6962Z",
                fill: "url(#paint2_linear_818_466)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.711 30.238C29.7889 29.862 28.2719 29.18 25.7509 28.038C25.055 27.732 24.289 27.384 23.412 26.994C22.883 26.757 22.396 26.548 21.908 26.34C18.107 24.655 16.018 23.736 13.4559 23.736C11.6599 23.736 10.3089 24.223 9.55695 25.142C9.04195 25.755 8.83295 26.548 8.98595 27.314L6.15895 27.857C5.85295 26.242 6.26995 24.585 7.32895 23.304C8.24795 22.19 10.0579 20.853 13.4559 20.853C16.6309 20.853 19.1929 21.995 23.0779 23.708C23.5509 23.917 24.039 24.14 24.568 24.362C25.459 24.752 26.239 25.1 26.9349 25.42C29.344 26.506 30.667 27.105 32.268 27.411L31.711 30.238Z",
                fill: "url(#paint3_linear_818_466)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M34.5259 30.516C33.5649 30.516 32.6459 30.432 31.7129 30.238L32.2699 27.411C33.0219 27.564 33.7599 27.634 34.5259 27.634C36.3079 27.634 37.6589 27.188 38.4389 26.339C39.2189 25.49 39.2469 24.459 39.2049 23.916L42.0729 23.665C42.2259 25.419 41.6969 27.063 40.5689 28.288C39.6359 29.304 37.8399 30.516 34.5259 30.516Z",
                fill: "url(#paint4_linear_818_466)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M23.9999 42.798V39.916C28.1359 39.916 30.5999 35.697 30.5999 28.637C30.5999 21.577 28.0939 15.659 22.9559 10.187L25.0589 8.20996C30.7259 14.239 33.4829 20.923 33.4829 28.637C33.4829 37.368 29.8489 42.798 23.9999 42.798Z",
                fill: "url(#paint5_linear_818_466)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M23.998 42.7981C17.774 42.7981 14.209 37.7301 14.209 28.8881C14.209 18.5701 18.721 12.8051 22.94 8.22412L25.057 10.1731C20.142 15.5201 17.092 20.5051 17.092 28.8871C17.092 38.0071 20.852 39.9151 23.999 39.9151V42.7971L23.998 42.7981Z",
                fill: "url(#paint6_linear_818_466)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M16.2849 26.2C18.1459 26.2 19.6549 24.691 19.6549 22.83C19.6549 20.969 18.1459 19.46 16.2849 19.46C14.4239 19.46 12.9149 20.969 12.9149 22.83C12.9149 24.691 14.4239 26.2 16.2849 26.2Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.8629 32.0071C33.7239 32.0071 35.2329 30.4981 35.2329 28.6371C35.2329 26.7761 33.7239 25.2671 31.8629 25.2671C30.0019 25.2671 28.4929 26.7761 28.4929 28.6371C28.4929 30.4981 30.0019 32.0071 31.8629 32.0071Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M23.997 11.9412C25.858 11.9412 27.367 10.4322 27.367 8.57117C27.367 6.71017 25.858 5.20117 23.997 5.20117C22.136 5.20117 20.627 6.71017 20.627 8.57117C20.627 10.4322 22.136 11.9412 23.997 11.9412Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint0_linear_818_466",
                        x1: "15.989",
                        y1: "43.1032",
                        x2: "14.6109",
                        y2: "6.93924",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.5",
                                stopColor: "#1D7AFC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0055CC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint1_linear_818_466",
                        x1: "42.4099",
                        y1: "26.2853",
                        x2: "26.3829",
                        y2: "42.8553",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0055CC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint2_linear_818_466",
                        x1: "33.051",
                        y1: "6.59421",
                        x2: "33.051",
                        y2: "24.6962",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                stopColor: "#1D7AFC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.59",
                                stopColor: "#1D7AFC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0055CC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint3_linear_818_466",
                        x1: "6.06095",
                        y1: "25.546",
                        x2: "32.268",
                        y2: "25.546",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.26",
                                stopColor: "#1D7AFC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0055CC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint4_linear_818_466",
                        x1: "34.6069",
                        y1: "29.777",
                        x2: "40.3299",
                        y2: "23.692",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0055CC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint5_linear_818_466",
                        x1: "28.2189",
                        y1: "42.798",
                        x2: "28.2189",
                        y2: "8.20996",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.36",
                                stopColor: "#1D7AFC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0055CC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint6_linear_818_466",
                        x1: "19.633",
                        y1: "42.7981",
                        x2: "19.633",
                        y2: "8.22312",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.06",
                                stopColor: "#1D7AFC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.58",
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    })
                ]
            })
        ]
    });

});

parcelRegister("cusIg", function(module, exports) {
$parcel$export(module.exports, "AtlassianLogoBrand", function () { return $8d6f9462c955fddb$export$be4b880845d08afc; });

var $7VQPk = parcelRequire("7VQPk");
const $8d6f9462c955fddb$export$be4b880845d08afc = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "282",
        height: "48",
        viewBox: "0 0 282 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                children: "Atlassian logo"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                clipPath: "url(#clip0_994_4077)",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M10.3 19.9003C9.80005 19.3003 9.00005 19.4003 8.60005 20.1003L0.100048 37.1003C-0.199952 37.8003 0.300048 38.6003 1.00005 38.6003H12.8C13.2 38.6003 13.5 38.4003 13.7 38.0003C16.3 32.7003 14.7 24.7003 10.3 19.9003Z",
                        fill: "url(#paint0_linear_994_4077)"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M16.5001 4.5001C11.8001 12.0001 12.1001 20.3001 15.2001 26.6001C18.3001 32.9001 20.7001 37.6001 20.9001 38.0001C21.1001 38.4001 21.4001 38.6001 21.8001 38.6001H33.6001C34.4001 38.6001 34.8001 37.8001 34.5001 37.1001C34.5001 37.1001 18.6001 5.3001 18.2001 4.5001C17.9001 3.8001 16.9001 3.8001 16.5001 4.5001Z",
                        fill: "#0082FF"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M155 18.1004C155 22.3004 156.9 25.6004 164.6 27.1004C169.1 28.1004 170.1 28.8004 170.1 30.3004C170.1 31.8004 169.1 32.7004 165.9 32.7004C162.2 32.7004 157.8 31.4004 154.9 29.7004V36.5004C157.2 37.6004 160.2 38.9004 165.9 38.9004C173.9 38.9004 177 35.3004 177 30.1004M177 30.2004C177 25.2004 174.4 22.9004 166.9 21.3004C162.8 20.4004 161.8 19.5004 161.8 18.2004C161.8 16.6004 163.3 15.9004 166 15.9004C169.3 15.9004 172.5 16.9004 175.6 18.3004V11.8004C173.4 10.7004 170.1 9.90039 166.2 9.90039C158.8 9.90039 155 13.1004 155 18.3004",
                        fill: "#0050D3"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M257.4 10.1001V38.6001H263.5V16.9001L266 22.6001L274.6 38.6001H282.2V10.1001H276.2V28.5001L273.9 23.1001L267 10.1001H257.4Z",
                        fill: "#0050D3"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M218.8 10.1001H212.2V38.6001H218.8V10.1001Z",
                        fill: "#0050D3"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M204.6 30.1003C204.6 25.1003 202 22.8003 194.5 21.2003C190.4 20.3003 189.4 19.4003 189.4 18.1003C189.4 16.5003 190.9 15.8003 193.6 15.8003C196.9 15.8003 200.1 16.8003 203.2 18.2003V11.7003C201 10.6003 197.7 9.80029 193.8 9.80029C186.4 9.80029 182.6 13.0003 182.6 18.2003C182.6 22.4003 184.5 25.7003 192.2 27.2003C196.7 28.2003 197.7 28.9003 197.7 30.4003C197.7 31.9003 196.7 32.8003 193.5 32.8003C189.8 32.8003 185.4 31.5003 182.5 29.8003V36.6003C184.8 37.7003 187.8 39.0003 193.5 39.0003C201.4 39.0003 204.6 35.4003 204.6 30.1003Z",
                        fill: "#0050D3"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M103.6 10.1001V38.6001H117.2L119.3 32.4001H110.2V10.1001H103.6Z",
                        fill: "#0050D3"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M76.7001 10.1001V16.2001H84.0001V38.6001H90.7001V16.2001H98.6001V10.1001H76.7001Z",
                        fill: "#0050D3"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M67 10.1001H58.3L48.4 38.6001H56L57.4 33.8001C59.1 34.3001 60.9 34.6001 62.7 34.6001C64.5 34.6001 66.3 34.3001 68 33.8001L69.4 38.6001H77C76.9 38.6001 67 10.1001 67 10.1001ZM62.6 28.6001C61.3 28.6001 60.1 28.4001 59 28.1001L62.6 15.7001L66.2 28.1001C65.1 28.4001 63.9 28.6001 62.6 28.6001Z",
                        fill: "#0050D3"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M140.7 10.1001H132L122 38.6001H129.6L131 33.8001C132.7 34.3001 134.5 34.6001 136.3 34.6001C138.1 34.6001 139.9 34.3001 141.6 33.8001L143 38.6001H150.6L140.7 10.1001ZM136.3 28.6001C135 28.6001 133.8 28.4001 132.7 28.1001L136.3 15.7001L139.9 28.1001C138.8 28.4001 137.6 28.6001 136.3 28.6001Z",
                        fill: "#0050D3"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M242.7 10.1001H234L224.1 38.6001H231.7L233.1 33.8001C234.8 34.3001 236.6 34.6001 238.4 34.6001C240.2 34.6001 242 34.3001 243.7 33.8001L245.1 38.6001H252.7L242.7 10.1001ZM238.4 28.6001C237.1 28.6001 235.9 28.4001 234.8 28.1001L238.4 15.7001L242 28.1001C240.9 28.4001 239.6 28.6001 238.4 28.6001Z",
                        fill: "#0050D3"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint0_linear_994_4077",
                        x1: "14.9161",
                        y1: "22.5557",
                        x2: "5.96115",
                        y2: "38.0657",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                stopColor: "#0050D3"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.923",
                                stopColor: "#0082FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                        id: "clip0_994_4077",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                            width: "282",
                            height: "48",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });

});

parcelRegister("3Dz6G", function(module, exports) {
$parcel$export(module.exports, "AtlassianLogoNeutral", function () { return $f1f3119cac8bd602$export$2146dec71e451533; });

var $7VQPk = parcelRequire("7VQPk");
const $f1f3119cac8bd602$export$2146dec71e451533 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "282",
        height: "48",
        viewBox: "0 0 282 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                children: "Atlassian logo"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                clipPath: "url(#clip0_994_3735)",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M10.3 19.9003C9.79999 19.3003 8.99999 19.4003 8.59999 20.1003L0.0999871 37.1003C-0.200013 37.8003 0.299987 38.6003 0.999987 38.6003H12.8C13.2 38.6003 13.5 38.4003 13.7 38.0003C16.3 32.7003 14.7 24.7003 10.3 19.9003Z",
                        fill: "url(#paint0_linear_994_3735)"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M16.5 4.5001C11.8 12.0001 12.1 20.3001 15.2 26.6001C18.3 32.9001 20.7 37.6001 20.9 38.0001C21.1 38.4001 21.4 38.6001 21.8 38.6001H33.6C34.4 38.6001 34.8 37.8001 34.5 37.1001C34.5 37.1001 18.6 5.3001 18.2 4.5001C17.9 3.8001 16.9 3.8001 16.5 4.5001Z",
                        fill: "#77859B"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M155 18.1004C155 22.3004 156.9 25.6004 164.6 27.1004C169.1 28.1004 170.1 28.8004 170.1 30.3004C170.1 31.8004 169.1 32.7004 165.9 32.7004C162.2 32.7004 157.8 31.4004 154.9 29.7004V36.5004C157.2 37.6004 160.2 38.9004 165.9 38.9004C173.9 38.9004 177 35.3004 177 30.1004M177 30.2004C177 25.2004 174.4 22.9004 166.9 21.3004C162.8 20.4004 161.8 19.5004 161.8 18.2004C161.8 16.6004 163.3 15.9004 166 15.9004C169.3 15.9004 172.5 16.9004 175.6 18.3004V11.8004C173.4 10.7004 170.1 9.90039 166.2 9.90039C158.8 9.90039 155 13.1004 155 18.3004",
                        fill: "#44546F"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M257.4 10.1001V38.6001H263.5V16.9001L266 22.6001L274.6 38.6001H282.2V10.1001H276.2V28.5001L273.9 23.1001L267 10.1001H257.4Z",
                        fill: "#44546F"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M218.8 10.1001H212.2V38.6001H218.8V10.1001Z",
                        fill: "#44546F"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M204.6 30.1003C204.6 25.1003 202 22.8003 194.5 21.2003C190.4 20.3003 189.4 19.4003 189.4 18.1003C189.4 16.5003 190.9 15.8003 193.6 15.8003C196.9 15.8003 200.1 16.8003 203.2 18.2003V11.7003C201 10.6003 197.7 9.80029 193.8 9.80029C186.4 9.80029 182.6 13.0003 182.6 18.2003C182.6 22.4003 184.5 25.7003 192.2 27.2003C196.7 28.2003 197.7 28.9003 197.7 30.4003C197.7 31.9003 196.7 32.8003 193.5 32.8003C189.8 32.8003 185.4 31.5003 182.5 29.8003V36.6003C184.8 37.7003 187.8 39.0003 193.5 39.0003C201.4 39.0003 204.6 35.4003 204.6 30.1003Z",
                        fill: "#44546F"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M103.6 10.1001V38.6001H117.2L119.3 32.4001H110.2V10.1001H103.6Z",
                        fill: "#44546F"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M76.7 10.1001V16.2001H84V38.6001H90.7V16.2001H98.6V10.1001H76.7Z",
                        fill: "#44546F"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M67 10.1001H58.3L48.4 38.6001H56L57.4 33.8001C59.1 34.3001 60.9 34.6001 62.7 34.6001C64.5 34.6001 66.3 34.3001 68 33.8001L69.4 38.6001H77C76.9 38.6001 67 10.1001 67 10.1001ZM62.6 28.6001C61.3 28.6001 60.1 28.4001 59 28.1001L62.6 15.7001L66.2 28.1001C65.1 28.4001 63.9 28.6001 62.6 28.6001Z",
                        fill: "#44546F"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M140.7 10.1001H132L122 38.6001H129.6L131 33.8001C132.7 34.3001 134.5 34.6001 136.3 34.6001C138.1 34.6001 139.9 34.3001 141.6 33.8001L143 38.6001H150.6L140.7 10.1001ZM136.3 28.6001C135 28.6001 133.8 28.4001 132.7 28.1001L136.3 15.7001L139.9 28.1001C138.8 28.4001 137.6 28.6001 136.3 28.6001Z",
                        fill: "#44546F"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M242.7 10.1001H234L224.1 38.6001H231.7L233.1 33.8001C234.8 34.3001 236.6 34.6001 238.4 34.6001C240.2 34.6001 242 34.3001 243.7 33.8001L245.1 38.6001H252.7L242.7 10.1001ZM238.4 28.6001C237.1 28.6001 235.9 28.4001 234.8 28.1001L238.4 15.7001L242 28.1001C240.9 28.4001 239.6 28.6001 238.4 28.6001Z",
                        fill: "#44546F"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint0_linear_994_3735",
                        x1: "14.9161",
                        y1: "22.5567",
                        x2: "5.96109",
                        y2: "38.0667",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                stopColor: "#304566"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.923",
                                stopColor: "#77859B"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                        id: "clip0_994_3735",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                            width: "282",
                            height: "48",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });

});

parcelRegister("hktDW", function(module, exports) {
$parcel$export(module.exports, "BitbucketMarkBrand", function () { return $97e6614f325f2af3$export$51dbe3f91062dd43; });

var $7VQPk = parcelRequire("7VQPk");
const $97e6614f325f2af3$export$51dbe3f91062dd43 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M8.73796 10.3291C8.09296 10.3291 7.60196 10.9071 7.70596 11.5441L12.13 38.4841C12.242 39.1661 12.831 39.6661 13.521 39.6721L34.812 39.6681C35.325 39.6681 35.763 39.2961 35.845 38.7901L40.294 11.5491C40.398 10.9131 39.907 10.3351 39.262 10.3351L8.73696 10.3281L8.73796 10.3291ZM27.427 29.8001H20.606L18.79 20.1901H29.072L27.427 29.8001Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M38.883 20.1899H29.072L27.427 29.7999H20.606L12.605 39.3269C12.605 39.3269 12.964 39.6709 13.521 39.6709L34.813 39.6669C35.325 39.6669 35.762 39.2949 35.844 38.7899L38.882 20.1899H38.883Z",
                fill: "url(#paint0_linear_818_495)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                    id: "paint0_linear_818_495",
                    x1: "41.152",
                    y1: "22.8799",
                    x2: "24.937",
                    y2: "35.5379",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            offset: "0.176",
                            stopColor: "#0055CC"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            offset: "1",
                            stopColor: "#1D7AFC"
                        })
                    ]
                })
            })
        ]
    });

});

parcelRegister("3RGc0", function(module, exports) {
$parcel$export(module.exports, "CompassMarkBrand", function () { return $15fbc70d0710051b$export$95ba070e064f69d4; });

var $7VQPk = parcelRequire("7VQPk");
const $15fbc70d0710051b$export$95ba070e064f69d4 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M23.5 23.179V32.092H14.57V23.179H23.5V14.272H7.20997C6.33997 14.278 5.63997 14.976 5.64597 15.832C5.64597 15.839 5.64597 15.846 5.64597 15.853V39.465C5.62797 40.321 6.31897 41.028 7.18797 41.046C7.19497 41.046 7.20297 41.046 7.20997 41.046H30.844C31.714 41.04 32.414 40.342 32.408 39.486C32.408 39.479 32.408 39.472 32.408 39.465V23.179H23.5Z",
                fill: "url(#paint0_linear_2304_2419)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M23.5 5.35987V14.2719H32.451V23.1789H41.354V6.91987C41.372 6.06387 40.681 5.35687 39.812 5.33887C39.805 5.33887 39.797 5.33887 39.79 5.33887L23.5 5.35987Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                    id: "paint0_linear_2304_2419",
                    x1: "30.859",
                    y1: "15.827",
                    x2: "15.688",
                    y2: "30.998",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            offset: "0.2",
                            stopColor: "#0055CC"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            offset: "1",
                            stopColor: "#1D7AFC"
                        })
                    ]
                })
            })
        ]
    });

});

parcelRegister("d3z6K", function(module, exports) {
$parcel$export(module.exports, "ConfluenceLogoBrand", function () { return $6057a35e6ecd0681$export$688c79db1f7ed58e; });

var $7VQPk = parcelRequire("7VQPk");
const $6057a35e6ecd0681$export$688c79db1f7ed58e = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "267",
        height: "48",
        viewBox: "0 0 267 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M70.2961 37.4057C68.4101 38.6477 65.4201 39.1997 62.2911 39.1997C52.3541 39.1997 46.7411 33.2197 46.7411 23.6957C46.7411 14.4957 52.3541 8.05371 62.1991 8.05371C65.1431 8.05371 68.0881 8.60671 70.2501 10.1697V14.1727C68.0881 12.7927 65.6951 12.0567 62.1991 12.0567C55.1141 12.0567 50.8821 16.7487 50.8821 23.6957C50.8821 30.6427 55.2531 35.2437 62.4301 35.2437C65.6041 35.2437 68.0881 34.5077 70.2961 33.4037V37.4057Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M73.1921 27.1929C73.1921 20.2919 77.2401 15.2769 84.1411 15.2769C90.9951 15.2769 94.9981 20.2919 94.9981 27.1929C94.9981 34.0939 90.9951 39.1999 84.1411 39.1999C77.2401 39.1999 73.1921 34.0939 73.1921 27.1929ZM77.0561 27.1929C77.0561 31.5629 79.2181 35.5199 84.1411 35.5199C89.0171 35.5199 91.1331 31.5629 91.1331 27.1929C91.1331 22.8229 89.0171 18.9579 84.1411 18.9579C79.2181 18.9579 77.0561 22.8219 77.0561 27.1929Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M119.148 38.7399H115.191V24.8459C115.191 20.7049 113.535 18.8659 109.762 18.8659C106.082 18.8659 103.552 21.3039 103.552 25.9509V38.7399H99.5951V15.7379H103.552V19.5099C105.024 16.7949 107.738 15.2769 110.821 15.2769C116.111 15.2769 119.148 18.9119 119.148 25.2599V38.7389V38.7399Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M130.139 15.7378H136.073V19.4178H130.139V38.7398H126.275V19.4178H122.548V15.7378H126.275V13.2078C126.275 8.92879 128.668 6.02979 133.589 6.02979C134.785 6.02979 135.568 6.21478 136.258 6.39778V10.0328C135.568 9.89478 134.694 9.80279 133.774 9.80279C131.336 9.80279 130.14 11.2298 130.14 13.2998V15.7378H130.139Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M146.515 38.8786C142.743 38.8786 140.35 37.0836 140.35 32.8516V6.12256H144.307V32.3916C144.307 34.4616 145.687 35.1986 147.389 35.1986C147.803 35.1986 148.078 35.1986 148.539 35.1526V38.6946C148.217 38.7866 147.526 38.8796 146.515 38.8796V38.8786Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M151.896 15.7378H155.852V29.6318C155.852 33.7718 157.508 35.6118 161.281 35.6118C164.962 35.6118 167.492 33.1738 167.492 28.5268V15.7378H171.449V38.7398H167.492V34.9678C166.02 37.6828 163.305 39.1998 160.223 39.1998C154.932 39.1998 151.896 35.5658 151.896 29.2178V15.7378Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M188.42 39.1999C179.817 39.1999 176.045 34.2319 176.045 27.1929C176.045 20.2459 179.909 15.2769 186.902 15.2769C193.986 15.2769 196.839 20.1999 196.839 27.1929V28.9869H180.047C180.6 32.8969 183.13 35.4269 188.559 35.4269C191.227 35.4269 193.481 34.9209 195.551 34.1849V37.8199C193.665 38.8319 190.767 39.1999 188.42 39.1999ZM180.001 25.5829H192.837C192.607 21.3049 190.675 18.8659 186.718 18.8659C182.531 18.8659 180.415 21.5799 180.001 25.5829Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M221.081 38.7399H217.124V24.8459C217.124 20.7049 215.468 18.8659 211.695 18.8659C208.015 18.8659 205.485 21.3039 205.485 25.9509V38.7399H201.528V15.7379H205.485V19.5099C206.957 16.7949 209.671 15.2769 212.754 15.2769C218.044 15.2769 221.081 18.9119 221.081 25.2599V38.7389V38.7399Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M242.839 38.1419C241.458 38.8779 239.342 39.1999 237.226 39.1999C229.038 39.1999 225.219 34.2319 225.219 27.1929C225.219 20.2459 229.037 15.2769 237.226 15.2769C239.296 15.2769 240.907 15.5529 242.701 16.3809V20.0619C241.229 19.3719 239.665 18.9579 237.503 18.9579C231.523 18.9579 229.084 22.7299 229.084 27.1929C229.084 31.6559 231.568 35.4269 237.595 35.4269C239.942 35.4269 241.413 35.1059 242.84 34.5989V38.1419H242.839Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M258.339 39.1999C249.736 39.1999 245.964 34.2319 245.964 27.1929C245.964 20.2459 249.828 15.2769 256.821 15.2769C263.905 15.2769 266.758 20.1999 266.758 27.1929V28.9869H249.966C250.519 32.8969 253.049 35.4269 258.478 35.4269C261.146 35.4269 263.4 34.9209 265.47 34.1849V37.8199C263.584 38.8319 260.686 39.1999 258.339 39.1999ZM249.92 25.5829H262.756C262.526 21.3049 260.594 18.8659 256.637 18.8659C252.45 18.8659 250.334 21.5799 249.92 25.5829Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M1.16806 31.3314C0.829057 31.8834 0.444057 32.5304 0.145057 33.0394C-0.142943 33.5304 0.0120573 34.1614 0.497057 34.4604L7.29106 38.6534C7.78906 38.9604 8.44106 38.8024 8.73806 38.2984C9.00806 37.8414 9.35806 37.2534 9.74006 36.6214C12.4331 32.1774 15.1411 32.7194 20.0201 35.0384L26.7581 38.2414C27.2891 38.4944 27.9241 38.2584 28.1631 37.7204L31.3991 30.4144C31.6291 29.8944 31.4031 29.2874 30.8891 29.0454C29.4661 28.3764 26.6381 27.0414 24.1061 25.8154C14.9051 21.3604 7.12006 21.6554 1.16806 31.3314Z",
                fill: "url(#paint0_linear_818_483)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.6351 14.7276C31.9741 14.1756 32.3591 13.5286 32.6581 13.0196C32.9461 12.5286 32.7911 11.8976 32.3061 11.5986L25.5121 7.40562C25.0141 7.09862 24.3621 7.25662 24.0651 7.76062C23.7951 8.21762 23.4451 8.80561 23.0631 9.43761C20.3701 13.8816 17.6621 13.3396 12.7831 11.0206L6.04512 7.81762C5.51412 7.56462 4.87912 7.80061 4.64012 8.33861L1.40412 15.6446C1.17412 16.1646 1.40012 16.7716 1.91412 17.0136C3.33712 17.6826 6.16512 19.0176 8.69712 20.2436C17.8971 24.6986 25.6821 24.4046 31.6341 14.7276H31.6351Z",
                fill: "url(#paint1_linear_818_483)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint0_linear_818_483",
                        x1: "31.1981",
                        y1: "40.8054",
                        x2: "10.6381",
                        y2: "28.9914",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint1_linear_818_483",
                        x1: "1.60412",
                        y1: "5.25362",
                        x2: "22.1641",
                        y2: "17.0676",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    })
                ]
            })
        ]
    });

});

parcelRegister("a9CD6", function(module, exports) {
$parcel$export(module.exports, "ConfluenceMarkBrand", function () { return $2ce451c25fbd45ca$export$c3c079c94b97bdde; });

var $7VQPk = parcelRequire("7VQPk");
const $2ce451c25fbd45ca$export$c3c079c94b97bdde = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M8.76706 32.3019C8.42806 32.8539 8.04306 33.5009 7.74406 34.0099C7.45606 34.5009 7.61106 35.1319 8.09606 35.4309L14.8901 39.6239C15.3881 39.9309 16.0401 39.7729 16.3371 39.2689C16.6071 38.8119 16.9571 38.2239 17.3391 37.5919C20.0321 33.1479 22.7401 33.6899 27.6191 36.0089L34.3571 39.2119C34.8881 39.4649 35.5231 39.2289 35.7621 38.6909L38.9981 31.3849C39.2281 30.8649 39.0021 30.2579 38.4881 30.0159C37.0651 29.3469 34.2371 28.0119 31.7051 26.7859C22.5051 22.3309 14.7201 22.6249 8.76806 32.3019H8.76706Z",
                fill: "url(#paint0_linear_818_553)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M39.233 15.6978C39.572 15.1458 39.957 14.4988 40.256 13.9898C40.544 13.4988 40.389 12.8678 39.904 12.5688L33.11 8.37583C32.612 8.06883 31.96 8.22683 31.663 8.73083C31.393 9.18783 31.043 9.77583 30.661 10.4078C27.968 14.8518 25.26 14.3098 20.381 11.9908L13.643 8.78783C13.112 8.53483 12.477 8.77083 12.238 9.30883L9.00202 16.6148C8.77202 17.1348 8.99802 17.7418 9.51202 17.9838C10.935 18.6528 13.763 19.9878 16.295 21.2138C25.495 25.6688 33.28 25.3748 39.232 15.6978H39.233Z",
                fill: "url(#paint1_linear_818_553)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint0_linear_818_553",
                        x1: "38.7961",
                        y1: "41.7759",
                        x2: "18.2371",
                        y2: "29.9619",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.972",
                                stopColor: "#1C78FA"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint1_linear_818_553",
                        x1: "9.20302",
                        y1: "6.22383",
                        x2: "29.763",
                        y2: "18.0378",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.972",
                                stopColor: "#1C78FA"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("aBawz", function(module, exports) {
$parcel$export(module.exports, "CustomerServiceManagementLogoBrand", function () { return $0bdf50abe1266280$export$77109fd0b35bd237; });

var $7VQPk = parcelRequire("7VQPk");
const $0bdf50abe1266280$export$77109fd0b35bd237 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "684",
        height: "48",
        viewBox: "0 0 684 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M85.392 32.664V36.666C83.506 37.908 80.516 38.46 77.388 38.46C67.452 38.46 61.84 32.48 61.84 22.958C61.84 13.758 67.452 7.318 77.296 7.318C80.24 7.318 83.184 7.87 85.346 9.434V13.436C83.184 12.056 80.792 11.32 77.296 11.32C70.212 11.32 65.98 16.012 65.98 22.958C65.98 29.904 70.35 34.504 77.526 34.504C80.7 34.504 83.184 33.768 85.392 32.664ZM89.7077 28.478V15H93.6637V28.892C93.6637 33.032 95.3197 34.872 99.0917 34.872C102.772 34.872 105.302 32.434 105.302 27.788V15H109.258V38H105.302V34.228C103.83 36.942 101.116 38.46 98.0337 38.46C92.7437 38.46 89.7077 34.826 89.7077 28.478ZM131.104 31.744C131.104 35.562 128.62 38.46 122.456 38.46C119.006 38.46 116.2 37.678 114.452 36.758V32.572C116.43 33.722 119.742 34.826 122.64 34.826C125.676 34.826 127.24 33.584 127.24 31.79C127.24 30.042 125.906 29.03 121.536 27.972C116.43 26.73 114.268 24.752 114.268 20.98C114.268 16.978 117.35 14.54 122.594 14.54C125.584 14.54 128.298 15.276 130 16.196V20.29C127.24 18.91 124.986 18.174 122.548 18.174C119.65 18.174 118.086 19.186 118.086 20.98C118.086 22.59 119.19 23.602 123.422 24.614C128.528 25.856 131.104 27.742 131.104 31.744ZM141.148 30.87C141.148 32.894 142.344 34.274 144.782 34.274C145.702 34.274 146.576 34.09 147.266 33.952V37.77C146.576 37.954 145.794 38.138 144.598 38.138C139.676 38.138 137.284 35.24 137.284 30.962V18.68H133.558V15H137.284V10.124H141.148V15H147.266V18.68H141.148V30.87ZM161.009 38.46C154.109 38.46 150.061 33.354 150.061 26.454C150.061 19.554 154.109 14.54 161.009 14.54C167.863 14.54 171.865 19.554 171.865 26.454C171.865 33.354 167.863 38.46 161.009 38.46ZM161.009 18.22C156.087 18.22 153.925 22.084 153.925 26.454C153.925 30.824 156.087 34.78 161.009 34.78C165.885 34.78 168.001 30.824 168.001 26.454C168.001 22.084 165.885 18.22 161.009 18.22ZM196.013 25.212V38H192.057V24.108C192.057 19.968 190.401 18.128 186.629 18.128C182.949 18.128 180.419 20.566 180.419 25.212V38H176.463V15H180.419V18.772C181.891 16.058 184.605 14.54 187.687 14.54C191.597 14.54 194.265 16.518 195.415 20.152C196.703 16.61 199.785 14.54 203.603 14.54C208.755 14.54 211.607 18.036 211.607 24.522V38H207.651V25.212C207.651 20.474 205.995 18.128 202.223 18.128C198.543 18.128 196.013 20.566 196.013 25.212ZM226.409 18.128C222.223 18.128 220.107 20.842 219.693 24.844H232.527C232.297 20.566 230.365 18.128 226.409 18.128ZM235.241 37.08C233.355 38.092 230.457 38.46 228.111 38.46C219.509 38.46 215.737 33.492 215.737 26.454C215.737 19.508 219.601 14.54 226.593 14.54C233.677 14.54 236.529 19.462 236.529 26.454V28.248H219.739C220.291 32.158 222.821 34.688 228.249 34.688C230.917 34.688 233.171 34.182 235.241 33.446V37.08ZM245.104 24.43V38H241.24V15H245.104V19.048C246.438 16.334 248.738 14.402 253.246 14.678V18.542C248.186 18.036 245.104 19.554 245.104 24.43ZM284.71 29.674C284.71 34.918 281.582 38.46 274.084 38.46C268.242 38.46 265.528 37.31 263.182 36.114V31.882C265.988 33.354 270.312 34.412 274.314 34.412C278.868 34.412 280.57 32.618 280.57 29.95C280.57 27.282 278.914 25.856 273.164 24.476C266.356 22.82 263.32 20.474 263.32 15.506C263.32 10.814 266.908 7.318 273.946 7.318C278.316 7.318 281.122 8.376 283.192 9.526V13.666C280.156 11.918 276.89 11.366 273.762 11.366C269.806 11.366 267.46 12.746 267.46 15.506C267.46 17.99 269.392 19.232 274.728 20.566C281.122 22.176 284.71 24.246 284.71 29.674ZM298.868 18.128C294.682 18.128 292.566 20.842 292.152 24.844H304.986C304.756 20.566 302.824 18.128 298.868 18.128ZM307.7 37.08C305.814 38.092 302.916 38.46 300.57 38.46C291.968 38.46 288.196 33.492 288.196 26.454C288.196 19.508 292.06 14.54 299.052 14.54C306.136 14.54 308.988 19.462 308.988 26.454V28.248H292.198C292.75 32.158 295.28 34.688 300.708 34.688C303.376 34.688 305.63 34.182 307.7 33.446V37.08ZM317.563 24.43V38H313.699V15H317.563V19.048C318.897 16.334 321.197 14.402 325.705 14.678V18.542C320.645 18.036 317.563 19.554 317.563 24.43ZM340.745 38H335.455L326.531 15H330.671L338.123 34.642L345.529 15H349.669L340.745 38ZM352.359 8.928C352.359 7.18 353.509 6.168 355.119 6.168C356.729 6.168 357.879 7.18 357.879 8.928C357.879 10.676 356.729 11.688 355.119 11.688C353.509 11.688 352.359 10.676 352.359 8.928ZM353.095 38V15H357.051V38H353.095ZM379.261 33.86V37.402C377.881 38.138 375.765 38.46 373.649 38.46C365.461 38.46 361.643 33.492 361.643 26.454C361.643 19.508 365.461 14.54 373.649 14.54C375.719 14.54 377.329 14.816 379.123 15.644V19.324C377.651 18.634 376.087 18.22 373.925 18.22C367.945 18.22 365.507 21.992 365.507 26.454C365.507 30.916 367.991 34.688 374.017 34.688C376.363 34.688 377.835 34.366 379.261 33.86ZM393.069 18.128C388.883 18.128 386.767 20.842 386.353 24.844H399.187C398.957 20.566 397.025 18.128 393.069 18.128ZM401.901 37.08C400.015 38.092 397.117 38.46 394.771 38.46C386.169 38.46 382.397 33.492 382.397 26.454C382.397 19.508 386.261 14.54 393.253 14.54C400.337 14.54 403.189 19.462 403.189 26.454V28.248H386.399C386.951 32.158 389.481 34.688 394.909 34.688C397.577 34.688 399.831 34.182 401.901 33.446V37.08ZM425.336 21.486L421.196 10.262V38H417.056V7.778H424.232L431.086 25.12L433.892 33.446L436.698 25.12L443.598 7.778H450.268V38H446.128V10.584L442.586 21.486L435.916 38H431.914L425.336 21.486ZM459.486 26.5C459.486 32.02 461.694 34.78 465.788 34.78C469.33 34.78 472.504 32.526 472.504 27.42V25.58C472.504 20.474 469.606 18.22 466.248 18.22C461.786 18.22 459.486 21.164 459.486 26.5ZM472.504 38V33.86C471.032 36.896 468.272 38.46 464.73 38.46C458.612 38.46 455.53 33.262 455.53 26.5C455.53 20.014 458.75 14.54 465.19 14.54C468.548 14.54 471.124 16.058 472.504 19.048V15H476.46V38H472.504ZM501.976 24.522V38H498.02V24.108C498.02 19.968 496.364 18.128 492.592 18.128C488.912 18.128 486.382 20.566 486.382 25.212V38H482.426V15H486.382V18.772C487.854 16.058 490.568 14.54 493.65 14.54C498.94 14.54 501.976 18.174 501.976 24.522ZM510.068 26.5C510.068 32.02 512.276 34.78 516.37 34.78C519.912 34.78 523.086 32.526 523.086 27.42V25.58C523.086 20.474 520.188 18.22 516.83 18.22C512.368 18.22 510.068 21.164 510.068 26.5ZM523.086 38V33.86C521.614 36.896 518.854 38.46 515.312 38.46C509.194 38.46 506.112 33.262 506.112 26.5C506.112 20.014 509.332 14.54 515.772 14.54C519.13 14.54 521.706 16.058 523.086 19.048V15H527.042V38H523.086ZM548.51 36.16V33.86C547.038 36.896 544.278 38.46 540.736 38.46C534.664 38.46 531.628 33.262 531.628 26.5C531.628 20.014 534.802 14.54 541.196 14.54C544.554 14.54 547.13 16.058 548.51 19.048V15H552.374V35.93C552.374 42.692 549.2 47.246 540.966 47.246C537.102 47.246 534.986 46.74 532.778 46.004V42.14C535.308 42.968 537.93 43.52 540.782 43.52C546.532 43.52 548.51 40.438 548.51 36.16ZM535.492 26.5C535.492 32.02 537.7 34.78 541.794 34.78C545.336 34.78 548.51 32.526 548.51 27.42V25.58C548.51 20.474 545.612 18.22 542.254 18.22C537.792 18.22 535.492 21.164 535.492 26.5ZM567.636 18.128C563.45 18.128 561.334 20.842 560.92 24.844H573.754C573.524 20.566 571.592 18.128 567.636 18.128ZM576.468 37.08C574.582 38.092 571.684 38.46 569.338 38.46C560.736 38.46 556.964 33.492 556.964 26.454C556.964 19.508 560.828 14.54 567.82 14.54C574.904 14.54 577.756 19.462 577.756 26.454V28.248H560.966C561.518 32.158 564.048 34.688 569.476 34.688C572.144 34.688 574.398 34.182 576.468 33.446V37.08ZM602.017 25.212V38H598.061V24.108C598.061 19.968 596.405 18.128 592.633 18.128C588.953 18.128 586.423 20.566 586.423 25.212V38H582.467V15H586.423V18.772C587.895 16.058 590.609 14.54 593.691 14.54C597.601 14.54 600.269 16.518 601.419 20.152C602.707 16.61 605.789 14.54 609.607 14.54C614.759 14.54 617.611 18.036 617.611 24.522V38H613.655V25.212C613.655 20.474 611.999 18.128 608.227 18.128C604.547 18.128 602.017 20.566 602.017 25.212ZM632.413 18.128C628.227 18.128 626.111 20.842 625.697 24.844H638.531C638.301 20.566 636.369 18.128 632.413 18.128ZM641.245 37.08C639.359 38.092 636.461 38.46 634.115 38.46C625.513 38.46 621.741 33.492 621.741 26.454C621.741 19.508 625.605 14.54 632.597 14.54C639.681 14.54 642.533 19.462 642.533 26.454V28.248H625.743C626.295 32.158 628.825 34.688 634.253 34.688C636.921 34.688 639.175 34.182 641.245 33.446V37.08ZM666.794 24.522V38H662.838V24.108C662.838 19.968 661.182 18.128 657.41 18.128C653.73 18.128 651.2 20.566 651.2 25.212V38H647.244V15H651.2V18.772C652.672 16.058 655.386 14.54 658.468 14.54C663.758 14.54 666.794 18.174 666.794 24.522ZM677.784 30.87C677.784 32.894 678.98 34.274 681.418 34.274C682.338 34.274 683.212 34.09 683.902 33.952V37.77C683.212 37.954 682.43 38.138 681.234 38.138C676.312 38.138 673.92 35.24 673.92 30.962V18.68H670.194V15H673.92V10.124H677.784V15H683.902V18.68H677.784V30.87Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                clipPath: "url(#clip0_793_39516)",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
                        fill: "#FFC716"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                        clipPath: "url(#clip1_793_39516)",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                d: "M34.4932 35.6143C31.9074 37.7304 28.602 39 25 39C21.3982 39 18.0928 37.7305 15.507 35.6145L21.2254 29.8961C22.3145 30.5948 23.61 31 25 31C26.3902 31 27.6857 30.5948 28.7749 29.896L34.4932 35.6143Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                d: "M36.6145 33.493C38.7305 30.9072 40 27.6018 40 24C40 20.3982 38.7305 17.0928 36.6145 14.507L30.8961 20.2254C31.5948 21.3145 32 22.61 32 24C32 25.39 31.5948 26.6855 30.8961 27.7746L36.6145 33.493Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                d: "M34.4932 12.3857L28.7749 18.104C27.6857 17.4052 26.3902 17 25 17C23.61 17 22.3145 17.4052 21.2254 18.1039L15.507 12.3855C18.0928 10.2695 21.3982 9 25 9C28.602 9 31.9074 10.2696 34.4932 12.3857Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                d: "M13.3857 14.5068C11.2696 17.0926 10 20.398 10 24C10 27.602 11.2696 30.9074 13.3857 33.4932L19.104 27.7749C18.4052 26.6857 18 25.3902 18 24C18 22.6098 18.4052 21.3143 19.104 20.2251L13.3857 14.5068Z",
                                fill: "#101214"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M11.7588 38.957H24.2588L21.2588 29.957L11.7588 38.957Z",
                        fill: "#101214"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                        id: "clip0_793_39516",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                        id: "clip1_793_39516",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                            width: "48",
                            height: "48",
                            fill: "white",
                            transform: "translate(1)"
                        })
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("eCQc3", function(module, exports) {
$parcel$export(module.exports, "CustomerServiceManagementMarkBrand", function () { return $e32d5fec259868ca$export$e68ebff4d1a373dc; });

var $7VQPk = parcelRequire("7VQPk");
const $e32d5fec259868ca$export$e68ebff4d1a373dc = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                clipPath: "url(#clip0_793_43052)",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
                        fill: "#FFC716"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                        clipPath: "url(#clip1_793_43052)",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                d: "M34.4932 35.6143C31.9074 37.7304 28.602 39 25 39C21.3982 39 18.0928 37.7305 15.507 35.6145L21.2254 29.8961C22.3145 30.5948 23.61 31 25 31C26.3902 31 27.6857 30.5948 28.7749 29.896L34.4932 35.6143Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                d: "M36.6145 33.493C38.7305 30.9072 40 27.6018 40 24C40 20.3982 38.7305 17.0928 36.6145 14.507L30.8961 20.2254C31.5948 21.3145 32 22.61 32 24C32 25.39 31.5948 26.6855 30.8961 27.7746L36.6145 33.493Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                d: "M34.4932 12.3857L28.7749 18.104C27.6857 17.4052 26.3902 17 25 17C23.61 17 22.3145 17.4052 21.2254 18.1039L15.507 12.3855C18.0928 10.2695 21.3982 9 25 9C28.602 9 31.9074 10.2696 34.4932 12.3857Z",
                                fill: "#101214"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                d: "M13.3857 14.5068C11.2696 17.0926 10 20.398 10 24C10 27.602 11.2696 30.9074 13.3857 33.4932L19.104 27.7749C18.4052 26.6857 18 25.3902 18 24C18 22.6098 18.4052 21.3143 19.104 20.2251L13.3857 14.5068Z",
                                fill: "#101214"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M11.7588 38.957H24.2588L21.2588 29.957L11.7588 38.957Z",
                        fill: "#101214"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                        id: "clip0_793_43052",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                        id: "clip1_793_43052",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                            width: "48",
                            height: "48",
                            fill: "white",
                            transform: "translate(1)"
                        })
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("4IHFR", function(module, exports) {
$parcel$export(module.exports, "HalpLogoBrand", function () { return $5254d3c1fdd35f3d$export$528edb2ffd8d250d; });

var $7VQPk = parcelRequire("7VQPk");
const $5254d3c1fdd35f3d$export$528edb2ffd8d250d = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "95",
        height: "32",
        viewBox: "0 0 95 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M50.8924 1.68506V22.1372H48.0904V13.2927H37.3177V22.1372H34.5157V1.68506H37.3177V10.6181H48.0904V1.68506H50.8924Z",
                fill: "#253858"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M65.928 19.3352C64.9339 21.3907 63.0659 22.4485 60.6673 22.4485C56.528 22.4485 54.4407 18.9319 54.4407 14.3539C54.4407 9.96704 56.62 6.2594 60.9786 6.2594C63.2534 6.2594 64.994 7.28891 65.9315 9.31254V6.57073H68.6097V22.1372H65.9315L65.928 19.3352ZM61.3854 19.9579C63.7805 19.9579 65.928 18.4331 65.928 14.9766V13.7313C65.928 10.2784 63.968 8.75003 61.6826 8.75003C58.6613 8.75003 57.1047 10.7454 57.1047 14.3539C57.1047 18.0899 58.6118 19.9579 61.3854 19.9579Z",
                fill: "#253858"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M76.8245 22.2327C74.2738 22.2327 72.6534 21.0157 72.6534 18.1536V0.0646973H75.3316V17.8423C75.3316 19.2574 76.2656 19.7421 77.4189 19.7421C77.6787 19.7467 77.9386 19.736 78.1972 19.7103V22.1054C77.7467 22.2042 77.2856 22.247 76.8245 22.2327Z",
                fill: "#253858"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M83.458 19.3989V28.2081H80.7799V6.57073H83.458V9.37269C84.4522 7.32075 86.3201 6.2594 88.7188 6.2594C92.858 6.2594 94.9454 9.79723 94.9454 14.3539C94.9454 18.7444 92.7661 22.4485 88.4075 22.4485C86.1326 22.4485 84.392 21.4225 83.458 19.3989ZM88.0006 8.75003C85.6055 8.75003 83.458 10.2784 83.458 13.7313V14.9766C83.458 18.4331 85.418 19.9579 87.7034 19.9579C90.7247 19.9579 92.2814 17.9661 92.2814 14.3539C92.2672 10.618 90.7743 8.75003 88.0006 8.75003Z",
                fill: "#253858"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.2901 3.87848C21.8726 5.46206 22.9501 7.47929 23.3863 9.67515C23.8225 11.871 23.5979 14.1469 22.7408 16.2151C21.8837 18.2833 20.4327 20.051 18.5711 21.2946C16.7095 22.5382 14.521 23.202 12.2822 23.202C10.0435 23.202 7.85496 22.5382 5.99339 21.2946C4.13181 20.051 2.68076 18.2833 1.82368 16.2151C0.96659 14.1469 0.741953 11.871 1.17816 9.67515C1.61437 7.47929 2.69184 5.46206 4.27436 3.87848C5.32572 2.82642 6.57408 1.99184 7.9481 1.42243C9.32213 0.853016 10.7949 0.559937 12.2822 0.559937C13.7696 0.559937 15.2423 0.853016 16.6164 1.42243C17.9904 1.99184 19.2388 2.82642 20.2901 3.87848ZM6.19186 17.9909L6.16002 17.959L6.18125 17.9803L6.19186 17.9909ZM15.3124 7.10144L17.4351 4.97874C15.9436 3.86422 14.1317 3.262 12.2699 3.262C10.408 3.262 8.59606 3.86422 7.10462 4.97874L9.22732 7.10144L7.48671 8.84205L5.36401 6.71935C4.24949 8.21079 3.64727 10.0227 3.64727 11.8846C3.64727 13.7464 4.24949 15.5584 5.36401 17.0498L7.48671 14.9271L9.22732 16.6748L7.10462 18.7975C8.59606 19.912 10.408 20.5142 12.2699 20.5142C14.1317 20.5142 15.9436 19.912 17.4351 18.7975L15.3124 16.6748L17.053 14.9271L19.1757 17.0498C20.2902 15.5584 20.8924 13.7464 20.8924 11.8846C20.8924 10.0227 20.2902 8.21079 19.1757 6.71935L17.053 8.84205L15.3124 7.10144Z",
                fill: "url(#paint0_radial_1486_1400)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.2805 6.21692C11.161 6.21692 10.0666 6.5489 9.1357 7.17089C8.20483 7.79288 7.47931 8.67693 7.05088 9.71125C6.62245 10.7456 6.51035 11.8837 6.72876 12.9818C6.94718 14.0798 7.48629 15.0884 8.27793 15.88C9.06957 16.6717 10.0782 17.2108 11.1762 17.4292C12.2742 17.6476 13.4124 17.5355 14.4467 17.1071C15.481 16.6787 16.3651 15.9531 16.9871 15.0223C17.6091 14.0914 17.941 12.997 17.941 11.8774C17.941 10.3762 17.3447 8.9364 16.2831 7.87485C15.2216 6.81329 13.7818 6.21692 12.2805 6.21692ZM12.2805 15.0615C11.6508 15.0615 11.0352 14.8747 10.5116 14.5249C9.98795 14.175 9.57984 13.6777 9.33885 13.0959C9.09786 12.5141 9.0348 11.8739 9.15766 11.2563C9.28051 10.6386 9.58377 10.0713 10.0291 9.62598C10.4744 9.18069 11.0417 8.87744 11.6593 8.75458C12.277 8.63172 12.9172 8.69477 13.499 8.93577C14.0808 9.17676 14.5781 9.58487 14.928 10.1085C15.2778 10.6321 15.4646 11.2477 15.4646 11.8774C15.465 12.2959 15.383 12.7103 15.2232 13.097C15.0634 13.4837 14.8289 13.8351 14.5332 14.1312C14.2375 14.4272 13.8864 14.6621 13.4998 14.8223C13.1133 14.9825 12.699 15.065 12.2805 15.065V15.0615Z",
                fill: "#2684FF"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("radialGradient", {
                    id: "paint0_radial_1486_1400",
                    cx: "0",
                    cy: "0",
                    r: "1",
                    gradientUnits: "userSpaceOnUse",
                    gradientTransform: "translate(12.2805 11.8775) scale(11.321 11.321)",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            offset: "0.43",
                            stopColor: "#0052CC"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            offset: "0.84",
                            stopColor: "#1B75F0"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            offset: "1",
                            stopColor: "#2684FF"
                        })
                    ]
                })
            })
        ]
    });

});

parcelRegister("1OyVz", function(module, exports) {
$parcel$export(module.exports, "JiraMarkBrand", function () { return $ac492e84be2f5dcc$export$2c53bf5b8775580d; });

var $7VQPk = parcelRequire("7VQPk");
const $ac492e84be2f5dcc$export$2c53bf5b8775580d = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M40.202 7.22998H22.124C22.124 11.736 25.777 15.388 30.282 15.388H33.611V18.601C33.611 23.107 37.264 26.759 41.769 26.759V8.79798C41.769 7.93198 41.067 7.22998 40.201 7.22998H40.202Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.255 16.2358H13.177C13.177 20.7418 16.83 24.3938 21.335 24.3938H24.664V27.6068C24.664 32.1128 28.317 35.7648 32.822 35.7648V17.8038C32.822 16.9378 32.12 16.2358 31.254 16.2358H31.255Z",
                fill: "url(#paint0_linear_818_567)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M22.308 25.2412H4.22998C4.22998 29.7472 7.88298 33.3992 12.388 33.3992H15.717V36.6122C15.717 41.1182 19.37 44.7702 23.875 44.7702V26.8092C23.875 25.9432 23.173 25.2412 22.307 25.2412H22.308Z",
                fill: "url(#paint1_linear_818_567)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint0_linear_818_567",
                        x1: "32.439",
                        y1: "16.2658",
                        x2: "24.749",
                        y2: "24.1958",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.176",
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint1_linear_818_567",
                        x1: "24.003",
                        y1: "25.3252",
                        x2: "15.112",
                        y2: "33.9752",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.176",
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("a0AEy", function(module, exports) {
$parcel$export(module.exports, "JiraAlignMarkBrand", function () { return $cd996cc87b3f94c2$export$3a24b449db907a8d; });

var $7VQPk = parcelRequire("7VQPk");
const $cd996cc87b3f94c2$export$3a24b449db907a8d = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M9.71802 9.71777C9.71802 15.1008 14.101 19.4648 19.479 19.4648H28.52V28.5348H38.281V11.2608C38.281 10.4088 37.591 9.71777 36.74 9.71777H9.71802Z",
                fill: "url(#paint0_linear_818_552)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M38.282 38.2818C38.282 32.8988 33.899 28.5348 28.521 28.5348H19.48V19.4648H9.71802V36.7388C9.71802 37.5908 10.408 38.2818 11.259 38.2818H38.282Z",
                fill: "url(#paint1_linear_818_552)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint0_linear_818_552",
                        x1: "21.692",
                        y1: "31.0018",
                        x2: "23.912",
                        y2: "19.5788",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.15",
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.522",
                                stopColor: "#0B63DE"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint1_linear_818_552",
                        x1: "26.308",
                        y1: "16.9978",
                        x2: "24.088",
                        y2: "28.4208",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.15",
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.522",
                                stopColor: "#0B63DE"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    })
                ]
            })
        ]
    });

});

parcelRegister("cH95H", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryLogoBrand", function () { return $d7cd8014b1bfee73$export$dbd49e0788c3653b; });

var $7VQPk = parcelRequire("7VQPk");
const $d7cd8014b1bfee73$export$dbd49e0788c3653b = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "475",
        height: "48",
        viewBox: "0 0 475 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M54.471 8.479H58.612V29.503C58.612 35.069 56.174 38.888 50.469 38.888C48.307 38.888 46.651 38.521 45.5 38.107V34.104C46.742 34.61 48.261 34.886 49.778 34.886C53.275 34.886 54.47 32.77 54.47 29.78V8.479H54.471Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M66.155 6.86816C67.765 6.86816 68.915 7.88116 68.915 9.62916C68.915 11.3772 67.766 12.3892 66.155 12.3892C64.544 12.3892 63.394 11.3772 63.394 9.62916C63.394 7.88116 64.544 6.86816 66.155 6.86816ZM64.131 15.7012H68.088V38.7042H64.131V15.7012Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M77.93 38.7038H74.066V15.7008H77.93V19.7498C79.264 17.0348 81.565 15.1038 86.074 15.3798V19.2438C81.013 18.7378 77.93 20.2558 77.93 25.1328V38.7038Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M104.612 34.5627C103.14 37.5987 100.38 39.1637 96.838 39.1637C90.719 39.1637 87.637 33.9657 87.637 27.2027C87.637 20.7157 90.857 15.2407 97.298 15.2407C100.656 15.2407 103.233 16.7597 104.612 19.7497V15.7007H108.569V38.7037H104.612V34.5627ZM97.895 35.4827C101.438 35.4827 104.612 33.2287 104.612 28.1227V26.2817C104.612 21.1757 101.714 18.9217 98.355 18.9217C93.893 18.9217 91.592 21.8657 91.592 27.2027C91.592 32.7237 93.8 35.4827 97.895 35.4827Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M133.867 28.812H127.841V38.704H123.7V8.479H133.867C141.412 8.479 145.093 12.343 145.093 18.554C145.093 25.133 141.412 28.813 133.867 28.813V28.812ZM140.814 18.645C140.814 14.965 138.744 12.435 133.407 12.435H127.841V24.856H133.407C138.744 25.041 140.814 22.51 140.814 18.645Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M152.587 38.7038H148.723V15.7008H152.587V19.7498C153.921 17.0348 156.222 15.1038 160.731 15.3798V19.2438C155.67 18.7378 152.587 20.2558 152.587 25.1328V38.7038Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M162.293 27.1567C162.293 20.2557 166.341 15.2407 173.242 15.2407C180.096 15.2407 184.099 20.2557 184.099 27.1567C184.099 34.0577 180.096 39.1637 173.242 39.1637C166.341 39.1637 162.293 34.0577 162.293 27.1567ZM166.157 27.1567C166.157 31.5267 168.319 35.4827 173.242 35.4827C178.118 35.4827 180.234 31.5267 180.234 27.1567C180.234 22.7867 178.118 18.9217 173.242 18.9217C168.319 18.9217 166.157 22.7857 166.157 27.1567Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M204.292 34.5629C202.82 37.5989 200.06 39.1639 196.518 39.1639C190.399 39.1639 187.317 33.9659 187.317 27.2029C187.317 20.7159 190.537 15.2409 196.978 15.2409C200.336 15.2409 202.913 16.7599 204.292 19.7499V6.08594H208.249V38.7039H204.292V34.5629ZM197.575 35.4829C201.118 35.4829 204.292 33.2289 204.292 28.1229V26.2819C204.292 21.1759 201.394 18.9219 198.035 18.9219C193.573 18.9219 191.272 21.8659 191.272 27.2029C191.272 32.7239 193.48 35.4829 197.575 35.4829Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M213.766 15.7012H217.722V29.5952C217.722 33.7362 219.378 35.5762 223.151 35.5762C226.832 35.5762 229.362 33.1382 229.362 28.4912V15.7012H233.318V38.7042H229.362V34.9322C227.89 37.6462 225.175 39.1642 222.093 39.1642C216.802 39.1642 213.766 35.5292 213.766 29.1812V15.7012Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M255.537 38.1057C254.156 38.8407 252.04 39.1637 249.924 39.1637C241.736 39.1637 237.917 34.1947 237.917 27.1567C237.917 20.2097 241.735 15.2407 249.924 15.2407C251.994 15.2407 253.605 15.5167 255.399 16.3447V20.0257C253.927 19.3357 252.363 18.9217 250.201 18.9217C244.221 18.9217 241.782 22.6937 241.782 27.1567C241.782 31.6197 244.266 35.3907 250.293 35.3907C252.64 35.3907 254.111 35.0687 255.538 34.5627V38.1057H255.537Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M269.151 34.9777C270.071 34.9777 270.945 34.7937 271.635 34.6557V38.4737C270.945 38.6587 270.162 38.8417 268.966 38.8417C264.044 38.8417 261.652 35.9437 261.652 31.6647V19.3817H257.925V15.7007H261.652V10.8247H265.516V15.7007H271.635V19.3817H265.516V31.5727C265.516 33.5967 266.712 34.9767 269.151 34.9767V34.9777Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M285.618 8.479H296.752C306.551 8.479 311.289 14.598 311.289 23.661C311.289 32.816 306.505 38.705 296.752 38.705H285.618V8.479ZM289.759 12.436V34.748H296.798C303.698 34.748 307.149 31.113 307.149 23.799C307.149 16.438 303.883 12.436 296.568 12.436H289.759Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M317.679 6.86816C319.289 6.86816 320.439 7.88116 320.439 9.62916C320.439 11.3772 319.29 12.3892 317.679 12.3892C316.068 12.3892 314.918 11.3772 314.918 9.62916C314.918 7.88116 316.068 6.86816 317.679 6.86816ZM315.655 15.7012H319.612V38.7042H315.655V15.7012Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M332.813 39.1637C329.363 39.1637 326.556 38.3817 324.808 37.4617V33.2747C326.787 34.4247 330.099 35.5287 332.997 35.5287C336.033 35.5287 337.598 34.2877 337.598 32.4927C337.598 30.7447 336.263 29.7327 331.893 28.6747C326.787 27.4327 324.624 25.4537 324.624 21.6827C324.624 17.6797 327.706 15.2417 332.951 15.2417C335.941 15.2417 338.655 15.9777 340.357 16.8977V20.9927C337.597 19.6127 335.342 18.8767 332.905 18.8767C330.007 18.8767 328.442 19.8887 328.442 21.6837C328.442 23.2927 329.546 24.3057 333.779 25.3177C338.885 26.5597 341.462 28.4467 341.462 32.4487C341.462 36.2667 338.978 39.1657 332.813 39.1657V39.1637Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M362.254 38.1057C360.873 38.8407 358.757 39.1637 356.641 39.1637C348.453 39.1637 344.634 34.1947 344.634 27.1567C344.634 20.2097 348.452 15.2407 356.641 15.2407C358.711 15.2407 360.322 15.5167 362.116 16.3447V20.0257C360.644 19.3357 359.08 18.9217 356.918 18.9217C350.938 18.9217 348.499 22.6937 348.499 27.1567C348.499 31.6197 350.983 35.3907 357.01 35.3907C359.357 35.3907 360.828 35.0687 362.255 34.5627V38.1057H362.254Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M365.379 27.1567C365.379 20.2557 369.427 15.2407 376.328 15.2407C383.182 15.2407 387.185 20.2557 387.185 27.1567C387.185 34.0577 383.182 39.1637 376.328 39.1637C369.427 39.1637 365.379 34.0577 365.379 27.1567ZM369.243 27.1567C369.243 31.5267 371.405 35.4827 376.328 35.4827C381.204 35.4827 383.32 31.5267 383.32 27.1567C383.32 22.7867 381.204 18.9217 376.328 18.9217C371.405 18.9217 369.243 22.7857 369.243 27.1567Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M397.211 38.7042L388.286 15.7012H392.427L399.88 35.3462L407.286 15.7012H411.427L402.502 38.7042H397.211Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M424.905 39.1637C416.302 39.1637 412.53 34.1947 412.53 27.1567C412.53 20.2097 416.394 15.2407 423.387 15.2407C430.471 15.2407 433.324 20.1637 433.324 27.1567V28.9507H416.532C417.085 32.8607 419.615 35.3907 425.044 35.3907C427.712 35.3907 429.966 34.8847 432.036 34.1487V37.7837C430.15 38.7957 427.252 39.1637 424.905 39.1637ZM416.486 25.5467H429.322C429.092 21.2687 427.16 18.8297 423.203 18.8297C419.016 18.8297 416.9 21.5437 416.486 25.5467Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M441.877 38.7038H438.013V15.7008H441.877V19.7498C443.211 17.0348 445.512 15.1038 450.021 15.3798V19.2438C444.96 18.7378 441.877 20.2558 441.877 25.1328V38.7038Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M459.173 37.2312L450.846 15.7012H455.078L462.439 35.3912L469.799 15.7012H474.031L465.336 37.9682C462.76 44.5472 461.288 47.9512 455.445 47.9512C453.466 47.9512 452.363 47.7672 451.213 47.3062V43.9022C452.547 44.3162 454.066 44.4552 455.215 44.4552C458.436 44.4552 459.861 42.2462 461.748 37.2312H459.172H459.173Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M20.998 22.8301C20.998 22.8301 21.027 23.4001 21.027 24.1871C21.027 27.1191 18.65 29.4961 15.718 29.4961C12.786 29.4961 10.409 27.1191 10.409 24.1871C10.409 21.2551 12.786 18.8781 15.718 18.8781C16.505 18.8781 16.988 18.9071 16.988 18.9071V8.53107C16.569 8.49707 16.146 8.47607 15.718 8.47607C7.037 8.47507 0 15.5121 0 24.1931C0 32.8741 7.037 39.9101 15.717 39.9101C24.397 39.9101 31.434 32.8731 31.434 24.1931C31.434 23.6931 31.425 23.3461 31.384 22.8311H20.997L20.998 22.8301Z",
                fill: "url(#paint0_linear_818_529)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M19.385 6.92496C23.747 8.10396 28.109 8.10396 32.471 6.92496C32.786 6.83996 33.069 7.12296 32.984 7.43796C31.805 11.8 31.805 16.162 32.984 20.524C33.069 20.839 32.786 21.122 32.471 21.037C28.109 19.858 23.747 19.858 19.385 21.037C19.07 21.122 18.787 20.839 18.872 20.524C20.051 16.162 20.051 11.8 18.872 7.43796C18.787 7.12296 19.07 6.83996 19.385 6.92496Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                    id: "paint0_linear_818_529",
                    x1: "13.767",
                    y1: "26.1431",
                    x2: "24.658",
                    y2: "15.2531",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            stopColor: "#1D7AFC"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            offset: "1",
                            stopColor: "#0055CC"
                        })
                    ]
                })
            })
        ]
    });

});

parcelRegister("5xYFE", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryMarkBrand", function () { return $e3d82782a56c17ec$export$1b2ff0e46e1f1569; });

var $7VQPk = parcelRequire("7VQPk");
const $e3d82782a56c17ec$export$1b2ff0e46e1f1569 = (props)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M28.498 24.4199C28.498 24.4199 28.527 24.9899 28.527 25.7769C28.527 28.7089 26.15 31.0859 23.218 31.0859C20.286 31.0859 17.909 28.7089 17.909 25.7769C17.909 22.8449 20.286 20.4679 23.218 20.4679C24.005 20.4679 24.488 20.4969 24.488 20.4969V10.1209C24.069 10.0869 23.646 10.0659 23.218 10.0659C14.538 10.0659 7.50098 17.1029 7.50098 25.7829C7.50098 34.4629 14.538 41.4999 23.218 41.4999C31.898 41.4999 38.935 34.4629 38.935 25.7829C38.935 25.2829 38.926 24.9359 38.885 24.4209H28.498V24.4199Z",
                fill: "url(#paint0_linear_818_557)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M26.885 8.5148C31.247 9.6938 35.609 9.6938 39.971 8.5148C40.286 8.4298 40.569 8.7128 40.484 9.0278C39.305 13.3898 39.305 17.7518 40.484 22.1138C40.569 22.4288 40.286 22.7118 39.971 22.6268C35.609 21.4478 31.247 21.4478 26.885 22.6268C26.57 22.7118 26.287 22.4288 26.372 22.1138C27.551 17.7518 27.551 13.3898 26.372 9.0278C26.287 8.7128 26.57 8.4298 26.885 8.5148Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                    id: "paint0_linear_818_557",
                    x1: "21.267",
                    y1: "27.7329",
                    x2: "32.158",
                    y2: "16.8419",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            stopColor: "#1D7AFC"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            offset: "1",
                            stopColor: "#0055CC"
                        })
                    ]
                })
            })
        ]
    });

});

parcelRegister("bEzzt", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementLogoBrand", function () { return $0fa0cae32ebe1442$export$962842ccd0a7c0b9; });

var $7VQPk = parcelRequire("7VQPk");
const $0fa0cae32ebe1442$export$962842ccd0a7c0b9 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "542",
        height: "48",
        viewBox: "0 0 542 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M53.655 8.47705H57.796V29.5021C57.796 35.0681 55.358 38.8871 49.653 38.8871C47.491 38.8871 45.835 38.519 44.684 38.105V34.1031C45.926 34.6091 47.445 34.885 48.962 34.885C52.459 34.885 53.654 32.769 53.654 29.779V8.47705H53.655Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M65.3379 6.86719C66.9479 6.86719 68.0979 7.87919 68.0979 9.62819C68.0979 11.3772 66.9489 12.3882 65.3379 12.3882C63.7269 12.3882 62.5769 11.3762 62.5769 9.62819C62.5769 7.88019 63.7269 6.86719 65.3379 6.86719ZM63.3139 15.7002H67.2709V38.7032H63.3139V15.7002Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M77.114 38.7031H73.25V15.7001H77.114V19.7491C78.448 17.0341 80.749 15.1031 85.258 15.3781V19.2421C80.197 18.7361 77.114 20.2551 77.114 25.1311V38.7031Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M103.795 34.5622C102.323 37.5982 99.563 39.1632 96.021 39.1632C89.902 39.1632 86.8199 33.9642 86.8199 27.2012C86.8199 20.7152 90.0399 15.2402 96.4809 15.2402C99.8389 15.2402 102.416 16.7592 103.795 19.7492V15.7002H107.752V38.7032H103.795V34.5622ZM97.0779 35.4822C100.621 35.4822 103.795 33.2282 103.795 28.1222V26.2812C103.795 21.1752 100.897 18.9212 97.5379 18.9212C93.0759 18.9212 90.7749 21.8652 90.7749 27.2012C90.7749 32.7222 92.9829 35.4822 97.0779 35.4822Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M131.164 39.1631C125.322 39.1631 122.607 38.0131 120.261 36.8161V32.5841C123.067 34.0571 127.392 35.1141 131.394 35.1141C135.949 35.1141 137.65 33.3201 137.65 30.6521C137.65 27.9841 135.994 26.5571 130.243 25.1771C123.434 23.5211 120.398 21.1741 120.398 16.2051C120.398 11.5131 123.986 8.01709 131.024 8.01709C135.395 8.01709 138.202 9.07509 140.272 10.2251V14.3661C137.235 12.6181 133.969 12.0651 130.841 12.0651C126.884 12.0651 124.538 13.4461 124.538 16.2061C124.538 18.6901 126.47 19.9331 131.807 21.2671C138.202 22.8771 141.789 24.9481 141.789 30.3761C141.789 35.6201 138.66 39.1631 131.162 39.1631H131.164Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M157.66 39.1632C149.056 39.1632 145.285 34.1942 145.285 27.1552C145.285 20.2092 149.148 15.2402 156.142 15.2402C163.226 15.2402 166.078 20.1632 166.078 27.1552V28.9502H149.287C149.84 32.8602 152.369 35.3902 157.799 35.3902C160.467 35.3902 162.721 34.8842 164.791 34.1482V37.7832C162.904 38.7952 160.006 39.1632 157.66 39.1632ZM149.24 25.5452H162.076C161.846 21.2672 159.914 18.8292 155.957 18.8292C151.771 18.8292 149.654 21.5432 149.24 25.5452Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M174.633 38.7031H170.768V15.7001H174.633V19.7491C175.967 17.0341 178.268 15.1031 182.776 15.3781V19.2421C177.715 18.7361 174.633 20.2551 174.633 25.1311V38.7031Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M192.525 38.7032L183.601 15.7002H187.742L195.195 35.3452L202.601 15.7002H206.742L197.816 38.7032H192.525Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M212.168 6.86719C213.777 6.86719 214.928 7.87919 214.928 9.62819C214.928 11.3772 213.778 12.3882 212.168 12.3882C210.558 12.3882 209.406 11.3762 209.406 9.62819C209.406 7.88019 210.556 6.86719 212.168 6.86719ZM210.143 15.7002H214.1V38.7032H210.143V15.7002Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M236.318 38.1042C234.937 38.8402 232.822 39.1632 230.705 39.1632C222.517 39.1632 218.699 34.1942 218.699 27.1552C218.699 20.2092 222.517 15.2402 230.705 15.2402C232.775 15.2402 234.387 15.5162 236.18 16.3442V20.0242C234.709 19.3352 233.145 18.9202 230.983 18.9202C225.003 18.9202 222.563 22.6922 222.563 27.1542C222.563 31.6162 225.047 35.3892 231.075 35.3892C233.421 35.3892 234.893 35.0672 236.319 34.5612V38.1032L236.318 38.1042Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M251.818 39.1632C243.216 39.1632 239.443 34.1942 239.443 27.1552C239.443 20.2092 243.308 15.2402 250.3 15.2402C257.384 15.2402 260.238 20.1632 260.238 27.1552V28.9502H243.445C243.998 32.8602 246.529 35.3902 251.957 35.3902C254.625 35.3902 256.879 34.8842 258.949 34.1482V37.7832C257.064 38.7952 254.166 39.1632 251.818 39.1632ZM243.4 25.5452H256.236C256.006 21.2672 254.074 18.8292 250.117 18.8292C245.929 18.8292 243.814 21.5432 243.4 25.5452Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M278.223 10.9621V38.703H274.082V8.47705H281.258L288.113 25.821L290.92 34.148L293.727 25.821L300.627 8.47705H307.297V38.703H303.156V11.2841L299.615 22.1861L292.943 38.703H288.941L282.363 22.1861L278.222 10.9611L278.223 10.9621Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M329.514 34.5622C328.041 37.5982 325.282 39.1632 321.739 39.1632C315.62 39.1632 312.538 33.9642 312.538 27.2012C312.538 20.7152 315.759 15.2402 322.2 15.2402C325.557 15.2402 328.134 16.7592 329.514 19.7492V15.7002H333.471V38.7032H329.514V34.5622ZM322.797 35.4822C326.34 35.4822 329.514 33.2282 329.514 28.1222V26.2812C329.514 21.1752 326.616 18.9212 323.256 18.9212C318.795 18.9212 316.494 21.8652 316.494 27.2012C316.494 32.7222 318.701 35.4822 322.797 35.4822Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M359 38.7032H355.043V24.8092C355.043 20.6682 353.387 18.8292 349.615 18.8292C345.935 18.8292 343.404 21.2672 343.404 25.9132V38.7032H339.447V15.7002H343.404V19.4722C344.877 16.7582 347.59 15.2402 350.674 15.2402C355.963 15.2402 359 18.8752 359 25.2232V38.7022V38.7032Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M380.113 34.5622C378.64 37.5982 375.881 39.1632 372.338 39.1632C366.219 39.1632 363.137 33.9642 363.137 27.2012C363.137 20.7152 366.358 15.2402 372.799 15.2402C376.156 15.2402 378.733 16.7592 380.113 19.7492V15.7002H384.07V38.7032H380.113V34.5622ZM373.396 35.4822C376.939 35.4822 380.113 33.2282 380.113 28.1222V26.2812C380.113 21.1752 377.215 18.9212 373.855 18.9212C369.394 18.9212 367.093 21.8652 367.093 27.2012C367.093 32.7222 369.3 35.4822 373.396 35.4822Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M405.551 34.5622C404.078 37.5982 401.319 39.1632 397.776 39.1632C391.704 39.1632 388.667 33.9642 388.667 27.2012C388.667 20.7152 391.841 15.2402 398.237 15.2402C401.594 15.2402 404.171 16.7592 405.551 19.7492V15.7002H409.414V36.6332C409.414 43.3962 406.24 47.9502 398.006 47.9502C394.141 47.9502 392.026 47.4442 389.817 46.7082V42.8442C392.348 43.6722 394.969 44.2242 397.823 44.2242C403.573 44.2242 405.552 41.1422 405.552 36.8632V34.5632L405.551 34.5622ZM398.834 35.4822C402.375 35.4822 405.551 33.2282 405.551 28.1222V26.2812C405.551 21.1752 402.653 18.9212 399.293 18.9212C394.83 18.9212 392.531 21.8652 392.531 27.2012C392.531 32.7222 394.738 35.4822 398.834 35.4822Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M426.389 39.1632C417.785 39.1632 414.014 34.1942 414.014 27.1552C414.014 20.2092 417.877 15.2402 424.871 15.2402C431.955 15.2402 434.807 20.1632 434.807 27.1552V28.9502H418.016C418.569 32.8602 421.098 35.3902 426.528 35.3902C429.196 35.3902 431.45 34.8842 433.52 34.1482V37.7832C431.633 38.7952 428.735 39.1632 426.389 39.1632ZM417.969 25.5452H430.805C430.575 21.2672 428.643 18.8292 424.686 18.8292C420.5 18.8292 418.383 21.5432 417.969 25.5452Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M459.049 38.7032H455.092V24.8092C455.092 20.6682 453.436 18.8292 449.662 18.8292C445.982 18.8292 443.453 21.2672 443.453 25.9132V38.7032H439.496V15.7002H443.453V19.4722C444.924 16.7582 447.639 15.2402 450.721 15.2402C454.631 15.2402 457.299 17.2192 458.45 20.8522C459.739 17.3102 462.821 15.2402 466.639 15.2402C471.791 15.2402 474.645 18.7362 474.645 25.2232V38.7022H470.688V25.9122C470.688 21.1742 469.032 18.8282 465.258 18.8282C461.578 18.8282 459.049 21.2662 459.049 25.9122V38.7022V38.7032Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M491.154 39.1632C482.552 39.1632 478.779 34.1942 478.779 27.1552C478.779 20.2092 482.644 15.2402 489.636 15.2402C496.72 15.2402 499.574 20.1632 499.574 27.1552V28.9502H482.781C483.334 32.8602 485.865 35.3902 491.293 35.3902C493.961 35.3902 496.215 34.8842 498.285 34.1482V37.7832C496.4 38.7952 493.502 39.1632 491.154 39.1632ZM482.736 25.5452H495.572C495.342 21.2672 493.41 18.8292 489.453 18.8292C485.265 18.8292 483.15 21.5432 482.736 25.5452Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M523.816 38.7032H519.859V24.8092C519.859 20.6682 518.203 18.8292 514.429 18.8292C510.749 18.8292 508.22 21.2672 508.22 25.9132V38.7032H504.263V15.7002H508.22V19.4722C509.691 16.7582 512.406 15.2402 515.488 15.2402C520.779 15.2402 523.816 18.8752 523.816 25.2232V38.7022V38.7032Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M538.541 34.9763C539.461 34.9763 540.336 34.7913 541.025 34.6543V38.4723C540.336 38.6573 539.552 38.8403 538.357 38.8403C533.435 38.8403 531.043 35.9423 531.043 31.6633V19.3803H527.316V15.6993H531.043V10.8223H534.906V15.6993H541.025V19.3803H534.906V31.5713C534.906 33.5953 536.103 34.9753 538.541 34.9753V34.9763Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M18.7379 19.3652L29.6659 19.4322C31.0659 19.4412 31.8589 21.0402 31.0189 22.1602L14.8909 43.6712C9.82089 39.8822 8.78189 32.7002 12.5709 27.6302L18.7379 19.3652Z",
                fill: "url(#paint0_linear_818_526)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M12.5619 27.63L1.69695 27.563C0.29795 27.554 -0.49505 25.958 0.34195 24.838L16.316 3.5C21.386 7.289 22.4249 14.471 18.636 19.541L12.5619 27.63Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                    id: "paint0_linear_818_526",
                    x1: "18.3052",
                    y1: "20.9799",
                    x2: "22.8997",
                    y2: "34.8695",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            stopColor: "#0055CC"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            offset: "1",
                            stopColor: "#1D7AFC"
                        })
                    ]
                })
            })
        ]
    });

});

parcelRegister("9YpGW", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementMarkBrand", function () { return $d634a61ef71547af$export$366b2081a44f303c; });

var $7VQPk = parcelRequire("7VQPk");
const $d634a61ef71547af$export$366b2081a44f303c = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M27.057 19.7803L37.985 19.8473C39.385 19.8563 40.178 21.4553 39.338 22.5753L23.21 44.0863C18.14 40.2973 17.101 33.1153 20.89 28.0453L27.057 19.7803Z",
                fill: "url(#paint0_linear_818_533)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M20.8799 28.0451L10.0149 27.9781C8.61594 27.9691 7.82294 26.3731 8.65994 25.2531L24.6339 3.91406C29.7039 7.70306 30.7429 14.8851 26.9539 19.9551L20.8799 28.0441V28.0451Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                    id: "paint0_linear_818_533",
                    x1: "26.6233",
                    y1: "21.3952",
                    x2: "31.2178",
                    y2: "35.2838",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            stopColor: "#0055CC"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            offset: "1",
                            stopColor: "#1D7AFC"
                        })
                    ]
                })
            })
        ]
    });

});

parcelRegister("ldaRP", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwareLogoBrand", function () { return $96e5f66704f42f3c$export$eb01765c5894c7d3; });

var $7VQPk = parcelRequire("7VQPk");
const $96e5f66704f42f3c$export$eb01765c5894c7d3 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "306",
        height: "48",
        viewBox: "0 0 306 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M57.123 8.48291H61.264V29.5079C61.264 35.0749 58.826 38.8939 53.121 38.8939C50.959 38.8939 49.303 38.5259 48.152 38.1119V34.1089C49.394 34.6159 50.913 34.8909 52.43 34.8909C55.927 34.8909 57.122 32.7749 57.122 29.7849V8.48291H57.123Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M68.807 6.87402C70.417 6.87402 71.567 7.88602 71.567 9.63402C71.567 11.382 70.418 12.395 68.807 12.395C67.196 12.395 66.046 11.382 66.046 9.63402C66.046 7.88602 67.196 6.87402 68.807 6.87402ZM66.783 15.707H70.74V38.709H66.783V15.707Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M80.582 38.7091H76.718V15.7071H80.582V19.7551C81.916 17.0411 84.217 15.1091 88.726 15.3851V19.2491C83.665 18.7431 80.582 20.2611 80.582 25.1381V38.7091Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M107.264 34.5681C105.792 37.6051 103.032 39.1691 99.4899 39.1691C93.3709 39.1691 90.2889 33.9711 90.2889 27.2081C90.2889 20.7211 93.5089 15.2461 99.9499 15.2461C103.308 15.2461 105.885 16.7651 107.264 19.7551V15.7071H111.221V38.7091H107.264V34.5681ZM100.547 35.4891C104.09 35.4891 107.264 33.2341 107.264 28.1281V26.2881C107.264 21.1821 104.366 18.9271 101.007 18.9271C96.5449 18.9271 94.2439 21.8711 94.2439 27.2081C94.2439 32.7291 96.4519 35.4891 100.547 35.4891Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M134.633 39.1689C128.79 39.1689 126.075 38.02 123.73 36.823V32.591C126.536 34.063 130.861 35.1209 134.863 35.1209C139.418 35.1209 141.12 33.326 141.12 30.658C141.12 27.99 139.464 26.5629 133.713 25.1829C126.904 23.5269 123.868 21.1809 123.868 16.2119C123.868 11.5199 127.456 8.02295 134.495 8.02295C138.866 8.02295 141.672 9.08195 143.742 10.2319V14.3719C140.706 12.6239 137.439 12.0719 134.311 12.0719C130.354 12.0719 128.008 13.4519 128.008 16.2129C128.008 18.6969 129.94 19.9399 135.277 21.2739C141.672 22.8839 145.26 24.955 145.26 30.382C145.26 35.6269 142.131 39.1689 134.633 39.1689Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M148.753 27.1621C148.753 20.2611 152.801 15.2461 159.702 15.2461C166.556 15.2461 170.559 20.2611 170.559 27.1621C170.559 34.0631 166.556 39.1691 159.702 39.1691C152.801 39.1691 148.753 34.0631 148.753 27.1621ZM152.617 27.1621C152.617 31.5321 154.779 35.4891 159.702 35.4891C164.578 35.4891 166.694 31.5321 166.694 27.1621C166.694 22.7921 164.578 18.9271 159.702 18.9271C154.779 18.9271 152.617 22.7911 152.617 27.1621Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M180.631 15.707H186.566V19.387H180.631V38.709H176.767V19.387H173.04V15.707H176.767V13.177C176.767 8.89802 179.16 5.99902 184.081 5.99902C185.277 5.99902 186.06 6.18402 186.75 6.36702V10.002C186.06 9.86402 185.186 9.77202 184.266 9.77202C181.828 9.77202 180.631 11.199 180.631 13.269V15.707Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M199.951 34.9821C200.871 34.9821 201.745 34.7981 202.435 34.6611V38.4791C201.745 38.6631 200.962 38.8471 199.766 38.8471C194.844 38.8471 192.452 35.9491 192.452 31.6701V19.3861H188.725V15.7061H192.452V10.8291H196.316V15.7061H202.435V19.3861H196.316V31.5771C196.316 33.6011 197.512 34.9811 199.951 34.9811V34.9821Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M229.208 38.709L225.252 27.576L223.136 20.491L221.02 27.576L217.063 38.709H212.002L203.537 15.707H207.907L214.532 35.213L221.249 15.707H225.021L231.738 35.213L238.363 15.707H242.733L234.268 38.709H229.207H229.208Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M260.81 34.5681C259.338 37.6051 256.578 39.1691 253.036 39.1691C246.917 39.1691 243.835 33.9711 243.835 27.2081C243.835 20.7211 247.055 15.2461 253.496 15.2461C256.854 15.2461 259.431 16.7651 260.81 19.7551V15.7071H264.767V38.7091H260.81V34.5681ZM254.093 35.4891C257.636 35.4891 260.81 33.2341 260.81 28.1281V26.2881C260.81 21.1821 257.912 18.9271 254.553 18.9271C250.091 18.9271 247.79 21.8711 247.79 27.2081C247.79 32.7291 249.998 35.4891 254.093 35.4891Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M274.607 38.7091H270.743V15.7071H274.607V19.7551C275.941 17.0411 278.242 15.1091 282.751 15.3851V19.2491C277.69 18.7431 274.607 20.2611 274.607 25.1381V38.7091Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M296.688 39.1691C288.085 39.1691 284.313 34.2011 284.313 27.1621C284.313 20.2151 288.177 15.2461 295.17 15.2461C302.254 15.2461 305.107 20.1691 305.107 27.1621V28.9561H288.315C288.868 32.8661 291.398 35.3961 296.827 35.3961C299.495 35.3961 301.749 34.8901 303.819 34.1541V37.7891C301.933 38.8011 299.035 39.1691 296.688 39.1691ZM288.269 25.5521H301.105C300.875 21.2741 298.943 18.8351 294.986 18.8351C290.799 18.8351 288.683 21.5491 288.269 25.5521Z",
                fill: "#172B4D"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M37.843 22.2901L20.803 5.25014L19.151 3.59814L6.323 16.4271L0.459 22.2901C-0.153 22.9021 -0.153 23.8951 0.459 24.5081L12.178 36.2271L19.151 43.2001L31.979 30.3721L32.178 30.1731L37.842 24.5091C38.454 23.8971 38.454 22.9041 37.842 22.2911L37.843 22.2901ZM19.151 29.2541L13.296 23.3991L19.152 17.5431L25.007 23.3981L19.151 29.2541Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M19.151 17.5441C15.314 13.7071 15.303 7.49707 19.111 3.64307L6.30103 16.4531L13.274 23.4261L19.153 17.5471L19.151 17.5451V17.5441Z",
                fill: "url(#paint0_linear_818_478)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.023 23.3843L19.151 29.2563C23.001 33.1073 23.001 39.3503 19.151 43.2003L31.995 30.3573L25.022 23.3843H25.023Z",
                fill: "url(#paint1_linear_818_478)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint0_linear_818_478",
                        x1: "18.107",
                        y1: "11.6201",
                        x2: "9.93002",
                        y2: "19.7961",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.176",
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint1_linear_818_478",
                        x1: "20.271",
                        y1: "35.1083",
                        x2: "28.431",
                        y2: "26.9483",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.176",
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    })
                ]
            })
        ]
    });

});

parcelRegister("dmDFX", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwareMarkBrand", function () { return $ce05d781735f7987$export$9b971ecc437a809; });

var $7VQPk = parcelRequire("7VQPk");
const $ce05d781735f7987$export$9b971ecc437a809 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M42.692 22.8912L25.652 5.85122L24 4.19922L11.172 17.0272L5.308 22.8912C4.696 23.5032 4.696 24.4962 5.308 25.1092L17.027 36.8282L24 43.8012L36.828 30.9732L37.027 30.7742L42.691 25.1102C43.303 24.4982 43.303 23.5052 42.691 22.8922L42.692 22.8912ZM24 29.8552L18.145 24.0002L24.001 18.1442L29.856 23.9992L24 29.8552Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M24 18.1442C20.163 14.3072 20.152 8.09716 23.96 4.24316L11.15 17.0532L18.123 24.0262L24.002 18.1472L24 18.1452V18.1442Z",
                fill: "url(#paint0_linear_818_577)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M29.872 23.9844L24 29.8564C27.85 33.7074 27.85 39.9504 24 43.8004L36.844 30.9574L29.871 23.9844H29.872Z",
                fill: "url(#paint1_linear_818_577)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint0_linear_818_577",
                        x1: "22.956",
                        y1: "12.2212",
                        x2: "14.779",
                        y2: "20.3972",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.176",
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint1_linear_818_577",
                        x1: "25.12",
                        y1: "35.7094",
                        x2: "33.28",
                        y2: "27.5494",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.176",
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    })
                ]
            })
        ]
    });

});

parcelRegister("bogCj", function(module, exports) {
$parcel$export(module.exports, "JiraWorkManagementMarkBrand", function () { return $4ff31055649af0b4$export$5a8caf8da5dd1ba6; });

var $7VQPk = parcelRequire("7VQPk");
const $4ff31055649af0b4$export$5a8caf8da5dd1ba6 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M27.852 9.79885L22.156 32.2829C29.408 34.3319 35.191 31.6679 37.407 22.9199L40.731 9.79785H27.852V9.79885Z",
                fill: "url(#paint0_linear_818_510)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M20.148 40.2007L25.844 17.7167C18.592 15.6677 12.809 18.3317 10.593 27.0797L7.26904 40.2017H20.148V40.2007Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                    id: "paint0_linear_818_510",
                    x1: "20.469",
                    y1: "32.3659",
                    x2: "32.167",
                    y2: "18.3079",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            stopColor: "#0055CC"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            offset: "1",
                            stopColor: "#1D7AFC"
                        })
                    ]
                })
            })
        ]
    });

});

parcelRegister("98rQm", function(module, exports) {
$parcel$export(module.exports, "TrelloMarkBrand", function () { return $af693e7b669a0669$export$f4e51c099e77aab7; });

var $7VQPk = parcelRequire("7VQPk");
const $af693e7b669a0669$export$f4e51c099e77aab7 = (props)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M36.429 7.69385H11.571C9.42997 7.69385 7.69397 9.42985 7.69397 11.5708V36.4288C7.69397 38.5698 9.42997 40.3058 11.571 40.3058H36.429C38.57 40.3058 40.306 38.5698 40.306 36.4288V11.5708C40.306 9.42985 38.57 7.69385 36.429 7.69385ZM21.742 31.1828C21.742 31.8948 21.165 32.4708 20.454 32.4708H15.003C14.291 32.4708 13.715 31.8938 13.715 31.1828V15.0028C13.715 14.2908 14.292 13.7148 15.003 13.7148H20.454C21.166 13.7148 21.742 14.2918 21.742 15.0028V31.1828ZM34.285 23.7548C34.285 24.4668 33.708 25.0428 32.997 25.0428H27.546C26.834 25.0428 26.258 24.4658 26.258 23.7548V15.0028C26.258 14.2908 26.835 13.7148 27.546 13.7148H32.997C33.709 13.7148 34.285 14.2918 34.285 15.0028V23.7548Z",
                fill: "url(#paint0_linear_818_512)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                    id: "paint0_linear_818_512",
                    x1: "24",
                    y1: "40.3058",
                    x2: "24",
                    y2: "7.69385",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            stopColor: "#0055CC"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            offset: "1",
                            stopColor: "#1D7AFC"
                        })
                    ]
                })
            })
        ]
    });

});


parcelRegister("78ld5", function(module, exports) {
$parcel$export(module.exports, "ContactSupport", function () { return $dfa248c26cf11756$export$d65ea6ee8960e96a; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $iRMRa = parcelRequire("iRMRa");
const $dfa248c26cf11756$export$d65ea6ee8960e96a = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                style: {
                    display: 'inline-block',
                    width: '22rem'
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: 'checkemail.didNotReceive',
                    defaultMessage: '<strong>{question}</strong> Check your spam folder.',
                    values: {
                        ...(0, $iRMRa.DEFAULT_VALUES),
                        question: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: 'checkemail.question',
                            defaultMessage: "Didn't receive an email?"
                        })
                    }
                })
            })
        })
    });
};

});

parcelRegister("h7dMy", function(module, exports) {
$parcel$export(module.exports, "EmailButtons", function () { return $73f96e1cee655e97$export$78d42fa1f0d70d0; });
/* email-buttons.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $3RaC6 = parcelRequire("3RaC6");

var $aAezZ = parcelRequire("aAezZ");
const $73f96e1cee655e97$var$overallContainerStyle = null;
const $73f96e1cee655e97$var$socialButtonStyles = null;
const $73f96e1cee655e97$var$CHECK_EMAIL_PAGE_TRACKING_EVENT_NAMES = {
    OPEN_GMAIL_CLICKED: 'check_email_page_open_gmail_clicked',
    OPEN_OUTLOOK_CLICKED: 'check_email_page_open_outlook_clicked'
};
const $73f96e1cee655e97$export$78d42fa1f0d70d0 = ()=>{
    const intl = (0, $8e22h.default)();
    const openGmail = intl.formatMessage({
        id: 'checkemail.openGmail',
        defaultMessage: 'Open Gmail'
    });
    const openOutlook = intl.formatMessage({
        id: 'checkemail.openOutlook',
        defaultMessage: 'Open Outlook'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c116y _zulp1j6v"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4cvr1h6o _bfhku67f _19it1s07 _2rko1l7b _vchhusvi _1e0c116y _zulpoark _1bah1h6o _19pkidpf _2hwxidpf _otyr1j6v _18u0idpf _jomr1qgq _f8pj1nct _irr31qgq _30l31nct _1ah3t94y _1ii71ule _w8l51k8s _17521k8s _12s31kwk _37z21h6o _incy116y _1sjq4jg8"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3RaC6.default), {
                        appearance: 'link',
                        "data-event-component": 'linkButton',
                        "data-event-container": 'gmailButton',
                        "data-event": 'clicked',
                        "data-product-key": 'checkEmail',
                        "data-name": $73f96e1cee655e97$var$CHECK_EMAIL_PAGE_TRACKING_EVENT_NAMES.OPEN_GMAIL_CLICKED,
                        href: 'https://mail.google.com/mail/u/0/#search/atlassian+from%3A(%40atlassian.com)+in%3Aanywhere',
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: 'buttonText',
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aAezZ.GmailLogo), {}),
                                openGmail
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4cvr1h6o _bfhku67f _19it1s07 _2rko1l7b _vchhusvi _1e0c116y _zulpoark _1bah1h6o _19pkidpf _2hwxidpf _otyr1j6v _18u0idpf _jomr1qgq _f8pj1nct _irr31qgq _30l31nct _1ah3t94y _1ii71ule _w8l51k8s _17521k8s _12s31kwk _37z21h6o _incy116y _1sjq4jg8"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3RaC6.default), {
                        appearance: 'link',
                        href: 'https://outlook.live.com/mail/0/inbox',
                        "data-event-component": 'linkButton',
                        "data-event-container": 'outlookButton',
                        "data-event": 'clicked',
                        "data-product-key": 'checkEmail',
                        "data-name": $73f96e1cee655e97$var$CHECK_EMAIL_PAGE_TRACKING_EVENT_NAMES.OPEN_OUTLOOK_CLICKED,
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: 'buttonText',
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aAezZ.OutlookLogo), {}),
                                openOutlook
                            ]
                        })
                    })
                })
            ]
        })
    });
};

});
parcelRegister("aAezZ", function(module, exports) {
$parcel$export(module.exports, "GmailLogo", function () { return $6744d74c5b31606c$export$e0989a788da1a704; });
$parcel$export(module.exports, "OutlookLogo", function () { return $6744d74c5b31606c$export$2926c6045834af46; });
$parcel$export(module.exports, "EmailLetterIcon", function () { return $6744d74c5b31606c$export$8ead1903281b785a; });

var $7VQPk = parcelRequire("7VQPk");
const $6744d74c5b31606c$export$e0989a788da1a704 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        "aria-hidden": "true",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "52 42 88 66",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fill: "#4285f4",
                d: "M58 108h14V74L52 59v43c0 3.32 2.69 6 6 6"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fill: "#34a853",
                d: "M120 108h14c3.32 0 6-2.69 6-6V59l-20 15"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fill: "#fbbc04",
                d: "M120 48v26l20-15v-8c0-7.42-8.47-11.65-14.4-7.2"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fill: "#ea4335",
                d: "M72 74V48l24 18 24-18v26L96 92"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fill: "#c5221f",
                d: "M52 51v8l20 15V48l-5.6-4.2c-5.94-4.45-14.4-.22-14.4 7.2"
            })
        ]
    });
const $6744d74c5b31606c$export$2926c6045834af46 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        "aria-hidden": "true",
        viewBox: "-0.12979372698077785 0 33.25199671942124 32",
        xmlns: "http://www.w3.org/2000/svg",
        width: "2500",
        height: "2397",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M28.596 2H11.404A1.404 1.404 0 0 0 10 3.404V5l9.69 3L30 5V3.404A1.404 1.404 0 0 0 28.596 2z",
                fill: "#0364b8"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.65 17.405A11.341 11.341 0 0 0 32 16a.666.666 0 0 0-.333-.576l-.013-.008-.004-.002L20.812 9.24a1.499 1.499 0 0 0-.145-.083 1.5 1.5 0 0 0-1.334 0 1.49 1.49 0 0 0-.145.082L8.35 15.415l-.004.002-.012.007A.666.666 0 0 0 8 16a11.344 11.344 0 0 0 .35 1.405l11.492 8.405z",
                fill: "#0a2767"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M24 5h-7l-2.021 3L17 11l7 6h6v-6z",
                fill: "#28a8ea"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M10 5h7v6h-7z",
                fill: "#0078d4"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M24 5h6v6h-6z",
                fill: "#50d9ff"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M24 17l-7-6h-7v6l7 6 10.832 1.768z",
                fill: "#0364b8"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M10.031 5H30",
                fill: "none"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M17 11h7v6h-7z",
                fill: "#0078d4"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M10 17h7v6h-7z",
                fill: "#064a8c"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M24 17h6v6h-6z",
                fill: "#0078d4"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M20.19 25.218l-11.793-8.6.495-.87s10.745 6.12 10.909 6.212a.528.528 0 0 0 .42-.012l10.933-6.23.496.869z",
                fill: "#0a2767",
                opacity: ".5"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.667 16.577l-.014.008-.003.002-10.838 6.174a1.497 1.497 0 0 1-1.46.091l3.774 5.061 8.254 1.797v.004A1.498 1.498 0 0 0 32 28.5V16a.666.666 0 0 1-.333.577z",
                fill: "#1490df"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M32 28.5v-.738l-9.983-5.688-1.205.687a1.497 1.497 0 0 1-1.46.091l3.774 5.061 8.254 1.797v.004A1.498 1.498 0 0 0 32 28.5z",
                opacity: ".05"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.95 28.883L21.007 22.65l-.195.11a1.497 1.497 0 0 1-1.46.092l3.774 5.061 8.254 1.797v.004a1.501 1.501 0 0 0 .57-.83z",
                opacity: ".1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M8.35 16.59v-.01h-.01l-.03-.02A.65.65 0 0 1 8 16v12.5A1.498 1.498 0 0 0 9.5 30h21a1.503 1.503 0 0 0 .37-.05.637.637 0 0 0 .18-.06.142.142 0 0 0 .06-.02 1.048 1.048 0 0 0 .23-.13c.02-.01.03-.01.04-.03z",
                fill: "#28a8ea"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M18 24.667V8.333A1.337 1.337 0 0 0 16.667 7H10.03V14.456l-1.68.958-.005.002-.012.007A.666.666 0 0 0 8 16v.005V16 26h8.667A1.337 1.337 0 0 0 18 24.667z",
                opacity: ".1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M17 25.667V9.333A1.337 1.337 0 0 0 15.667 8H10.03V14.456l-1.68.958-.005.002-.012.007A.666.666 0 0 0 8 16v.005V16 27h7.667A1.337 1.337 0 0 0 17 25.667z",
                opacity: ".2"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M17 23.667V9.333A1.337 1.337 0 0 0 15.667 8H10.03V14.456l-1.68.958-.005.002-.012.007A.666.666 0 0 0 8 16v.005V16 25h7.667A1.337 1.337 0 0 0 17 23.667z",
                opacity: ".2"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M16 23.667V9.333A1.337 1.337 0 0 0 14.667 8H10.03V14.456l-1.68.958-.005.002-.012.007A.666.666 0 0 0 8 16v.005V16 25h6.667A1.337 1.337 0 0 0 16 23.667z",
                opacity: ".2"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M1.333 8h13.334A1.333 1.333 0 0 1 16 9.333v13.334A1.333 1.333 0 0 1 14.667 24H1.333A1.333 1.333 0 0 1 0 22.667V9.333A1.333 1.333 0 0 1 1.333 8z",
                fill: "#0078d4"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M3.867 13.468a4.181 4.181 0 0 1 1.642-1.814A4.965 4.965 0 0 1 8.119 11a4.617 4.617 0 0 1 2.413.62 4.14 4.14 0 0 1 1.598 1.733 5.597 5.597 0 0 1 .56 2.55 5.901 5.901 0 0 1-.577 2.666 4.239 4.239 0 0 1-1.645 1.794A4.8 4.8 0 0 1 7.963 21a4.729 4.729 0 0 1-2.468-.627 4.204 4.204 0 0 1-1.618-1.736 5.459 5.459 0 0 1-.567-2.519 6.055 6.055 0 0 1 .557-2.65zm1.75 4.258a2.716 2.716 0 0 0 .923 1.194 2.411 2.411 0 0 0 1.443.435 2.533 2.533 0 0 0 1.541-.449 2.603 2.603 0 0 0 .897-1.197 4.626 4.626 0 0 0 .286-1.665 5.063 5.063 0 0 0-.27-1.686 2.669 2.669 0 0 0-.866-1.24 2.387 2.387 0 0 0-1.527-.473 2.493 2.493 0 0 0-1.477.439 2.741 2.741 0 0 0-.944 1.203 4.776 4.776 0 0 0-.007 3.44z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 0h32v32H0z",
                fill: "none"
            })
        ]
    });
const $6744d74c5b31606c$export$8ead1903281b785a = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "150",
        height: "128",
        viewBox: "0 0 150 128",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                clipPath: "url(#clip0)",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        width: "150",
                        height: "127.685",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M149.861 52.5802L91.7015 5.85771C86.9468 2.06703 81.046 0.00274658 74.9651 0.00274658C68.8843 0.00274658 62.9835 2.06703 58.2287 5.85771L0.13947 52.5802H0V127.615H150V52.5802H149.861Z",
                        fill: "#0065FF"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M131.241 15.6206H17.7126V107.545H131.241V15.6206Z",
                        fill: "#FAFBFC"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M118.271 39.8884H30.6136V41.2831H118.271V39.8884Z",
                        fill: "#3384FF"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M131.241 13.5983H17.7126V22.0711H131.241V13.5983Z",
                        fill: "#1DB9D4"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M76.4295 46.5829H30.6136V47.9776H76.4295V46.5829Z",
                        fill: "#3384FF"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M118.271 33.1938H30.6136V34.5885H118.271V33.1938Z",
                        fill: "#3384FF"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M118.271 59.9023H30.6136V61.297H118.271V59.9023Z",
                        fill: "#3384FF"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M118.271 66.5969H30.6136V67.9916H118.271V66.5969Z",
                        fill: "#3384FF"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M81.0321 73.2914H30.6136V74.6861H81.0321V73.2914Z",
                        fill: "#3384FF"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M150 127.685C124.547 127.685 108.368 123.57 98.2566 117.782C74.8954 104.254 71.9665 84.7977 47.5593 68.5495C30.265 57.0432 12.2734 53.7656 0 52.7196V127.685H150Z",
                        fill: "url(#paint0_linear)"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M0 127.685C25.5927 127.685 41.6318 123.57 51.7434 117.782C75.1046 104.254 77.9637 84.7977 102.441 68.5495C119.665 57.0432 137.727 53.7656 150 52.7196V127.685H0Z",
                        fill: "#6BD5E5"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint0_linear",
                        x1: "74.993",
                        y1: "127.699",
                        x2: "74.993",
                        y2: "52.7057",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                stopColor: "#1DB9D4"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.12",
                                stopColor: "#38C3DA"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.26",
                                stopColor: "#4FCBDF"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.41",
                                stopColor: "#5FD1E2"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.59",
                                stopColor: "#68D4E4"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.82",
                                stopColor: "#6BD5E5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                        id: "clip0",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                            width: "150",
                            height: "127.685",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });

});


parcelRegister("j6OMz", function(module, exports) {
$parcel$export(module.exports, "EmailedYou", function () { return $2afbb9e36d5769b0$export$3f894db345e46fe7; });
/* emailed-you.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $aAezZ = parcelRequire("aAezZ");
const $2afbb9e36d5769b0$var$h1Style = null;
const $2afbb9e36d5769b0$var$pStyle = null;
const $2afbb9e36d5769b0$export$3f894db345e46fe7 = ()=>{
    const intl = (0, $8e22h.default)();
    const headerMessage = {
        identifier: 'checkemail.header',
        text: intl.formatMessage({
            id: 'checkemail.header.text',
            defaultMessage: 'Verify and activate your account'
        })
    };
    const weveEmailedYou = {
        identifier: 'checkemail.emailedYou',
        text: intl.formatMessage({
            id: 'checkemail.emailedYou.text',
            defaultMessage: "We've emailed your verification link. Verify your account to create your site"
        })
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                className: (0, $2jatx.default)([
                    "_1wybahaf _k48pbfng _syazl4fm _ect41485"
                ]),
                children: headerMessage.text
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aAezZ.EmailLetterIcon), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_syazl4fm _y3gn1h6o _1bsbiolt _1e0c116y _ect41485 _ca0qviql _u5f3idpf _n3tdidpf _19bvidpf _1wyb1j6v"
                ]),
                children: weveEmailedYou.text
            })
        ]
    });
};

});



parcelRegister("2fKIG", function(module, exports) {
$parcel$export(module.exports, "SoftwareBitbucketPricingPage", function () { return $4feeaa56577cf171$export$a036524a443241f4; });

var $7VQPk = parcelRequire("7VQPk");

var $dl2JF = parcelRequire("dl2JF");

var $ijSTy = parcelRequire("ijSTy");
const $4feeaa56577cf171$export$a036524a443241f4 = ({ pricing: pricing, countryCode: countryCode, pricingContent: pricingContent, queryRef: queryRef })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dl2JF.PricingContentContextProviderRelay), {
        productId: "bitbucket",
        pricingContent: pricingContent,
        queryRef: queryRef,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            "data-testid": "bitbucket-pricing-page",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ijSTy.SoftwareBitbucketPricingPageTemplate), {
                pricing: pricing,
                countryCode: countryCode
            })
        })
    });
};

});
parcelRegister("dl2JF", function(module, exports) {
$parcel$export(module.exports, "usePricingContentContext", function () { return $f009a0814995d12d$export$5c4a541176bccda; });
$parcel$export(module.exports, "PricingContentContextProvider", function () { return $f009a0814995d12d$export$72e02a396b6ef938; });
$parcel$export(module.exports, "PricingContentContextProviderRelay", function () { return $f009a0814995d12d$export$4e54691009c7ed4c; });
$parcel$export(module.exports, "usePricingPlanComparison", function () { return $f009a0814995d12d$export$6ef9aee1b558c2a5; });
$parcel$export(module.exports, "useGetComparePlanCta", function () { return $f009a0814995d12d$export$8c0343b0c8323d5e; });
$parcel$export(module.exports, "useDatacenterPlans", function () { return $f009a0814995d12d$export$317f41c6296bda84; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $f3gS9 = parcelRequire("f3gS9");

var $5UKqd = parcelRequire("5UKqd");

var $eY3N6 = parcelRequire("eY3N6");

var $4EfnG = parcelRequire("4EfnG");

var $17RBn = parcelRequire("17RBn");

var $eEYrI = parcelRequire("eEYrI");
const $f009a0814995d12d$var$PricingContentContext = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
const $f009a0814995d12d$export$5c4a541176bccda = ()=>{
    return (0, $1oC0p.useContext)($f009a0814995d12d$var$PricingContentContext);
};
const $f009a0814995d12d$var$stripPTags = (htmlString)=>{
    return htmlString.replace(/<\/?p>/g, '');
};
const $f009a0814995d12d$export$72e02a396b6ef938 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4EfnG.default), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($f009a0814995d12d$var$PricingContentContextProviderInternal, {
            ...props
        })
    });
};
const $f009a0814995d12d$var$PricingContentContextProviderInternal = (props)=>{
    const { productId: productId, pricingContent: initialPricingContent, pricingTitleInternal: pricingTitleInternal } = props;
    const locale = (0, $17RBn.useLocale)();
    const [pricingContent, setPricingContent] = (0, $1oC0p.useState)(initialPricingContent);
    const [loading, setLoading] = (0, $1oC0p.useState)(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    (0, $1oC0p.useEffect)(()=>{
        async function fetchPricingContent() {
            try {
                const fetchedContent = await (0, $eEYrI.getPricingContent)(productId, {
                    locale: locale,
                    pricingTitleInternal: pricingTitleInternal
                });
                setPricingContent(fetchedContent);
            } catch (error) {
                createAnalyticsEvent({
                    eventType: 'track',
                    action: 'failed',
                    actionSubject: 'getPricingContent',
                    attributes: {
                        productId: productId,
                        locale: locale,
                        pricingTitleInternal: pricingTitleInternal,
                        // @ts-ignore
                        error: error.message
                    },
                    source: window.location.pathname
                }).fire();
                setPricingContent({
                    hasError: true
                });
            } finally{
                setLoading(false);
            }
        }
        if (!initialPricingContent) fetchPricingContent();
        else setLoading(false);
    }, [
        initialPricingContent,
        productId,
        locale
    ]);
    const cleanedValue = pricingContent ? {
        ...pricingContent,
        headline: pricingContent?.headline ? $f009a0814995d12d$var$stripPTags(pricingContent.headline) : ''
    } : undefined;
    if (loading) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)($f009a0814995d12d$var$PricingContentContext.Provider, {
        value: cleanedValue,
        children: props.children
    });
};
const $f009a0814995d12d$export$4e54691009c7ed4c = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4EfnG.default), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($f009a0814995d12d$var$PricingContentContextProviderInternalRelay, {
            ...props
        })
    });
};
const $f009a0814995d12d$var$PricingContentContextProviderInternalRelay = (props)=>{
    let { pricingContent: pricingContent } = props;
    const [loading, setLoading] = (0, $1oC0p.useState)(true);
    const data = (0, $f3gS9.usePreloadedQuery)((0, $5UKqd.PricingPageRelayQuery), props.queryRef || null);
    if (!pricingContent) {
        const shapedResponse = (0, $5UKqd.shapePricingContentfulResponse)(data);
        pricingContent = shapedResponse?.pricings?.edges?.[0]?.node;
    }
    (0, $1oC0p.useEffect)(()=>{
        if (!!pricingContent) setLoading(false);
    }, [
        pricingContent
    ]);
    const cleanedValue = pricingContent ? {
        ...pricingContent,
        headline: pricingContent?.headline ? $f009a0814995d12d$var$stripPTags(pricingContent.headline) : ''
    } : undefined;
    if (loading) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)($f009a0814995d12d$var$PricingContentContext.Provider, {
        value: cleanedValue,
        children: props.children
    });
};
function $f009a0814995d12d$export$6ef9aee1b558c2a5(title) {
    const context = $f009a0814995d12d$export$5c4a541176bccda();
    return context?.comparePlans?.find((p)=>p.planTitleExternal === title);
}
function $f009a0814995d12d$export$8c0343b0c8323d5e() {
    const context = $f009a0814995d12d$export$5c4a541176bccda();
    return function getComparePlanCta(params) {
        return context?.comparePlans?.[params.comparePlanIdx]?.microCta?.[params.microCtaIdx ?? 0];
    };
}
function $f009a0814995d12d$export$e5b23f1c4d669bad() {
    const context = $f009a0814995d12d$export$5c4a541176bccda();
    return function getPricingPlanCta(params) {
        return context?.comparePlans?.find((p)=>p.planTitleExternal === params.planName)?.microCta?.[0];
    };
}
function $f009a0814995d12d$export$317f41c6296bda84(btnText, linkText) {
    const context = $f009a0814995d12d$export$5c4a541176bccda();
    const datacenterContent = context?.datacenterPlans?.[0];
    const btnCtaObject = datacenterContent?.microCta?.find((btnCta)=>'ctaButtonText' in btnCta && btnText === btnCta.ctaButtonText);
    const linkCtaObject = datacenterContent?.microCta?.find((linkCta)=>'ctaButtonText' in linkCta && linkText === linkCta.ctaButtonText);
    return {
        title: datacenterContent?.planTitleExternal ?? '',
        description: datacenterContent?.planOneLiner ?? '',
        buttonCta: btnCtaObject && 'ctaUrl' in btnCtaObject ? {
            label: btnCtaObject.ctaButtonText || undefined,
            href: btnCtaObject.ctaUrl || undefined
        } : undefined,
        linkCta: linkCtaObject && 'ctaUrl' in linkCtaObject ? {
            label: linkCtaObject.ctaButtonText || undefined,
            href: linkCtaObject.ctaUrl || undefined
        } : undefined
    };
}

});
parcelRegister("eEYrI", function(module, exports) {
$parcel$export(module.exports, "getPricingContent", function () { return $ddf64ed950a8ce67$export$331f740a8830d0ce; });

var $f3gS9 = parcelRequire("f3gS9");

var $gRpMo = parcelRequire("gRpMo");

var $5UKqd = parcelRequire("5UKqd");

var $aj5Hv = parcelRequire("aj5Hv");

var $jiOui = parcelRequire("jiOui");

var $4IlVP = parcelRequire("4IlVP");
const $ddf64ed950a8ce67$var$CONTENTFUL_SPACE_URL = 'https://graphql.contentful.com/content/v1/spaces/xjcz23wx147q';
const $ddf64ed950a8ce67$var$CONTENTFUL_MASTER = {
    url: `${$ddf64ed950a8ce67$var$CONTENTFUL_SPACE_URL}/environments/master`,
    accessToken: 'fTu2YoVb3vqTOyvfOZveEriN4V4vgNk9aVYcJuLRfc8'
};
const $ddf64ed950a8ce67$var$CONTENTFUL_STAGING = {
    url: `${$ddf64ed950a8ce67$var$CONTENTFUL_SPACE_URL}/environments/staging`,
    accessToken: 'JjhwVz5Qb05UNV-3sgJ-5h4JsWSLrkkMV5vdEgfy6_U'
};
const $ddf64ed950a8ce67$export$331f740a8830d0ce = async (productId, opts = {})=>{
    const { pricingTitleInternal: pricingTitleInternal } = opts;
    const { url: url, accessToken: accessToken } = $ddf64ed950a8ce67$var$getContentfulSource();
    const fetchGraphQL = async (request, variables)=>{
        const resp = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            },
            body: JSON.stringify({
                query: request.text,
                variables: variables
            })
        });
        if (!resp.ok) throw new Error('Response failed.');
        return await resp.json();
    };
    const environment = new (0, $gRpMo.Environment)({
        store: new (0, $gRpMo.Store)(new (0, $gRpMo.RecordSource)({})),
        network: (0, $gRpMo.Network).create(fetchGraphQL)
    });
    const pricingDataRaw = await (0, $f3gS9.fetchQuery)(environment, (0, $5UKqd.PricingPageRelayQuery), (0, $5UKqd.getPricingPageRelayQueryVars)(productId, window.location, pricingTitleInternal)).toPromise().then((data)=>data).catch((error)=>{
        console.log(error);
    });
    const pricingDataRelay = (0, $5UKqd.shapePricingContentfulResponse)(pricingDataRaw);
    return pricingDataRelay?.pricings?.edges?.[0]?.node;
};
/**
 * Returns the Contentful staging source when running outside production and the
 * dynamic config opts in; otherwise falls back to master.
 */ const $ddf64ed950a8ce67$var$getContentfulSource = ()=>{
    const isStagingContentEnabled = (0, $jiOui.getDynamicConfig)({
        config: (0, $aj5Hv.dynamicConfigManifest).isPricingPageContentFromStagingEnabled,
        defaultValue: false
    });
    return (0, $4IlVP.getEnvironment)() !== 'production' && isStagingContentEnabled ? $ddf64ed950a8ce67$var$CONTENTFUL_STAGING : $ddf64ed950a8ce67$var$CONTENTFUL_MASTER;
};

});


parcelRegister("ijSTy", function(module, exports) {
$parcel$export(module.exports, "SoftwareBitbucketPricingPageTemplate", function () { return $102ffae1b997ffb4$export$d089087e1703e7f4; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $baTp3 = parcelRequire("baTp3");

var $7aKDf = parcelRequire("7aKDf");

var $dl2JF = parcelRequire("dl2JF");

var $bE8d4 = parcelRequire("bE8d4");

var $2zOxm = parcelRequire("2zOxm");

var $6Px6U = parcelRequire("6Px6U");

var $grcEk = parcelRequire("grcEk");

var $frz5c = parcelRequire("frz5c");

var $atyps = parcelRequire("atyps");

var $5S2vX = parcelRequire("5S2vX");

var $7Rs16 = parcelRequire("7Rs16");
const $102ffae1b997ffb4$export$d089087e1703e7f4 = ({ pricing: pricing, countryCode: countryCode })=>{
    const content = (0, $dl2JF.usePricingContentContext)();
    const dataCenterContent = (0, $dl2JF.useDatacenterPlans)('Contact Us', 'Learn more');
    const questionsCtaContent = content?.callToActionContainer?.[0];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
        nav: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $atyps.BitbucketNav), {}),
        showFallback: content?.hasError,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
            pageId: "bitbucket-pricing-page",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6Px6U.PageHeading), {
                    children: content?.headline
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7Rs16.BitbucketPriceFinder), {
                    serverSideHAMSPricing: pricing?.hamsPricingData?.bitbucket,
                    countryCode: countryCode
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aKDf.PricingFeatureTable), {
                    title: content?.compareFeaturesTitle ?? undefined,
                    comparePlans: content?.comparePlans ?? undefined,
                    compareFeatures: content?.compareFeatures ?? undefined
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $baTp3.DataCenterSection), {
                    ...dataCenterContent
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2zOxm.QuotationsAdornment), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bE8d4.PricingFaq), {
                            header: content?.getMoreDetailsTitle ?? undefined,
                            planDetails: content?.additionalDetails ?? undefined
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $frz5c.QuestionsCta), {
                    product: 'Bitbucket',
                    ctaHref: questionsCtaContent?.url ?? undefined,
                    questionsHeader: questionsCtaContent?.title ?? undefined,
                    priceAndLicensingLinkText: questionsCtaContent?.text ?? undefined,
                    questionsBody: questionsCtaContent?.valueProposition ?? undefined,
                    imageHref: questionsCtaContent?.asset?.url
                })
            ]
        })
    });
};

});
parcelRegister("baTp3", function(module, exports) {
$parcel$export(module.exports, "DataCenterSection", function () { return $beae9ace14d19c79$export$3e74b76dd9e071d6; });
/* data-center-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $lmQGF = parcelRequire("lmQGF");

var $hnmMQ = parcelRequire("hnmMQ");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");
const $beae9ace14d19c79$var$ctaButtonStyles = null;
const $beae9ace14d19c79$var$dataCenterSectionContainer = null;
const $beae9ace14d19c79$var$headingStyle = null;
const $beae9ace14d19c79$var$descriptionStyle = null;
const $beae9ace14d19c79$var$rightSection = null;
const $beae9ace14d19c79$var$ctaWrapper = null;
const $beae9ace14d19c79$var$svgStyles = null;
const $beae9ace14d19c79$export$64adec1d96f4a7a4 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: `https://wac-cdn.atlassian.com/misc-assets/webp-images/Illo_DataCenter.svg`,
            alt: ''
        },
        className: (0, $2jatx.default)([
            "_1bsb112f _4t3i1jj5 _1s4pawd2 _1kne10uk"
        ])
    });
};
const $beae9ace14d19c79$export$3e74b76dd9e071d6 = (props)=>{
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: 'Pricing.DataCenterSection.title',
        defaultMessage: 'Data Center Products'
    });
    const description = intl.formatMessage({
        id: 'Pricing.DataCenterSection.description',
        defaultMessage: 'Data Center is our self-managed product offering for customers with strict regulatory or security requirements. To learn more about this offering, please contact us.'
    });
    const buttonCtaLabel = intl.formatMessage({
        id: 'Pricing.DataCenterSection.buttonCta',
        defaultMessage: 'Contact Us'
    });
    const linkCtaLabel = intl.formatMessage({
        id: 'Pricing.DataCenterSection.linkCta',
        defaultMessage: 'Learn more'
    });
    const buttonCtaHref = `https://www.atlassian.com${(0, $jQ0cd.useLocalizedHref)('/enterprise/contact?formType=product-features')}`;
    const linkCtaHref = `https://www.atlassian.com${(0, $jQ0cd.useLocalizedHref)('/enterprise/data-center')}`;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_bfhk5hrz _mkrz1ohv _1e0c1txw _4cvr1y6m _1bah1h6o _zulpvbgk _ca0q1et3 _u5f313rr _n3td88uy _19bv13rr _2osnqslr _8fz61fdn _tl281et3 _axwi1l27 _1hwcvbgk _sp8t1l27 _1s4p1osq _1gde1bp4"
        ]),
        style: {
            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($beae9ace14d19c79$export$64adec1d96f4a7a4, {}),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_syaz1afi _p12fukw8 _8fz61im0"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        id: "data-center-section-heading",
                        className: (0, $2jatx.default)([
                            "_1wybzwfg _vwz410mc _19pkidpf _2hwxidpf _otyr7vkz _18u0idpf _so7d1f4h _19q11u1b _1cqs1tcg _1bys1ul9"
                        ]),
                        children: props.title ?? title
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_1wyb7vkz _vwz41tcg _6rth1tcg"
                        ]),
                        children: props.description ?? description
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_4cvr1h6o _1e0c1txw _zulp7vkz _1gde1bp4 _1rfmwz92"
                        ]),
                        children: [
                            props.buttonCta !== null && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                                size: "small",
                                variant: "secondary",
                                color: "white",
                                colorAgainst: "other",
                                href: props.buttonCta?.href ?? buttonCtaHref,
                                className: (0, $2jatx.default)([
                                    "_4t3i1ylp _1bsbwz92 _o5721q9c"
                                ]),
                                children: props.buttonCta?.label ?? buttonCtaLabel
                            }),
                            props.linkCta !== null && // eslint-disable-next-line @atlassian/a11y/anchor-has-content, @atlassian/a11y/link-name
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                bgColor: "bgBlackBlue",
                                text: props.linkCta?.label ?? linkCtaLabel,
                                href: props.linkCta?.href ?? linkCtaHref,
                                id: "data-center-section-link",
                                ariaLabelledby: "data-center-section-link data-center-section-heading"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$beae9ace14d19c79$export$3e74b76dd9e071d6.displayName = 'DataCenterSection';

});

parcelRegister("7aKDf", function(module, exports) {
$parcel$export(module.exports, "PricingFeatureTable", function () { return $84231b70db855011$export$49da9cb6ddf668ee; });
/* features-table.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $20Gca = parcelRequire("20Gca");

var $lmQGF = parcelRequire("lmQGF");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $OKl9V = parcelRequire("OKl9V");

var $6tSTn = parcelRequire("6tSTn");

var $hrGO1 = parcelRequire("hrGO1");

var $l4Rl8 = parcelRequire("l4Rl8");

var $6o9v8 = parcelRequire("6o9v8");
const $84231b70db855011$var$tdStyles = null;
const $84231b70db855011$var$advanceHeadingStyles = null;
const $84231b70db855011$var$advanceTitleStyles = null;
const $84231b70db855011$var$advanceButtontyles = null;
const $84231b70db855011$var$advanceSoftStyles = null;
const $84231b70db855011$var$featureTableSubHeader = null;
const $84231b70db855011$var$featuresTableHeadIdPrefix = 'featTableHead_';
const $84231b70db855011$export$5a7d94d7c691844a = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        ...props,
        className: (0, $2jatx.default)([
            "_y3gn1h6o _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1bsb1osq _b8yq1git _n09v1ylp _1txjidpf _y4duvbgk _u19lidpf _jpg4bfng"
        ])
    });
};
const $84231b70db855011$export$de898cfe2ca10ff8 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp7vkz"
        ]),
        children: props.children
    });
};
const $84231b70db855011$export$f052fee91dc6777a = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
        ...props,
        className: (0, $2jatx.default)([
            "_syaz1pfd _k48p1fw0 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wyb14no _1cqszwfg _3p1c1ylp _py5ockbl"
        ]),
        style: {
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
        },
        children: children
    });
};
const $84231b70db855011$export$a433b7aa5ad7fd61 = ({ linkText: linkText, linkHref: linkHref })=>{
    const intl = (0, $8e22h.default)();
    const defaultLinkText = intl.formatMessage({
        id: 'PricingPages.featureTable.subHeader',
        defaultMessage: 'Learn about features'
    });
    const defaultLinkHref = `https://www.atlassian.com${(0, $jQ0cd.useLocalizedHref)('/software/jira/features')}`;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1wyb7vkz _vwz4gktf"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
            text: linkText ?? defaultLinkText,
            href: linkHref ?? defaultLinkHref,
            className: "link-class",
            type: 'primary',
            "aria-label": linkText ?? defaultLinkText
        })
    });
};
const $84231b70db855011$var$featuresTableGroupIdPrefix = 'featTableGroup_';
const $84231b70db855011$var$FeaturesTableContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createContext({
    planTiers: []
});
const $84231b70db855011$export$e2b8eb038115bae6 = (props)=>{
    const intl = (0, $8e22h.default)();
    const localizedSignupURL = (0, $jQ0cd.useLocalizedHref)((0, $hrGO1.SIGNUP_CTA_URL));
    const localizedContactURL = (0, $jQ0cd.useLocalizedHref)((0, $hrGO1.CONTACT_CTA_URL));
    return /*#__PURE__*/ (0, $7VQPk.jsx)($84231b70db855011$var$FeaturesTableContext.Provider, {
        value: {
            planTiers: props.planTiers
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("table", {
            className: (0, $2jatx.default)([
                "_2lx21bp4 _1kqm1n9t _1bsb1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _y3gn1h6o _yq5hcfaq _btyzidpf _suga1txw _476d1tcg _1e0c5mfb _1pfhzwfg _1mt1ckbl"
            ]),
            children: [
                props.captionText && /*#__PURE__*/ (0, $7VQPk.jsx)("caption", {
                    className: (0, $2jatx.default)([
                        "_y3gnv2br _ca0qzwfg _u5f3dlk8 _n3tddlk8 _19bvdlk8 _ect41vau _1wyb1k92 _1kmx1tcg _1ggmdlk8 _1ykzdlk8 _1maedlk8"
                    ]),
                    style: {
                        "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                    },
                    children: props.captionText
                }),
                props.subCaptionText && /*#__PURE__*/ (0, $7VQPk.jsx)("caption", {
                    className: (0, $2jatx.default)([
                        "_y3gnv2br _ca0qidpf _u5f3dlk8 _n3tddlk8 _19bvdlk8 _ect41vau _1wyb1j6v"
                    ]),
                    style: {
                        "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                    },
                    children: props.subCaptionText
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("thead", {
                    className: (0, $2jatx.default)([
                        "_179rh1cn _sugaglyw _1pbykb7n _154i88uy _kqsw1if8 _11q71afi"
                    ]),
                    style: {
                        "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400')),
                        "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("tr", {
                        className: (0, $2jatx.default)([
                            "_17gvangw _7dd6v2br"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)($84231b70db855011$var$FeaturesTableHeadCell, {
                                index: 0,
                                role: "presentation",
                                "aria-hidden": "true"
                            }),
                            props.planTiers.map((tierContent, index)=>{
                                let edition, ctaBtnText = '', ctaBtnUrl = '', dataEventPropsLabel = 'start-trial';
                                if (props.stickyCtasEnabled && props.dataProductKey) {
                                    const startFreeTrialText = intl.formatMessage({
                                        id: 'Pricing.CompareFeatures.StartFreeTrial',
                                        defaultMessage: (0, $hrGO1.CtaBtnText).START_FREE_TRIAL
                                    });
                                    const getItNowText = intl.formatMessage({
                                        id: 'Pricing.CompareFeatures.GetItNow',
                                        defaultMessage: (0, $hrGO1.CtaBtnText).GET_IT_NOW
                                    });
                                    const contactSalesText = intl.formatMessage({
                                        id: 'Pricing.CompareFeatures.ContactSales',
                                        defaultMessage: (0, $hrGO1.CtaBtnText).CONTACT_SALES
                                    });
                                    ctaBtnText = startFreeTrialText;
                                    dataEventPropsLabel = dataEventPropsLabel = `${tierContent}-start-trial-compare-features`;
                                    // tech-debt: get cta text and urls from contentful
                                    // ticket: https://hello.jira.atlassian.cloud/browse/PRICING-1542
                                    switch(tierContent){
                                        case (0, $hrGO1.SpecialPlanNames).FREE:
                                            edition = (0, $hrGO1.Edition).FREE;
                                            ctaBtnText = getItNowText;
                                            ctaBtnUrl = localizedSignupURL + '?bundle=jira-software&edition=free';
                                            dataEventPropsLabel = `${tierContent}-get-it-now-compare-features`;
                                            break;
                                        case (0, $hrGO1.SpecialPlanNames).STANDARD:
                                            edition = (0, $hrGO1.Edition).STANDARD;
                                            ctaBtnUrl = localizedSignupURL + '?bundle=jira-software&edition=standard';
                                            break;
                                        case (0, $hrGO1.SpecialPlanNames).PREMIUM:
                                            edition = (0, $hrGO1.Edition).PREMIUM;
                                            ctaBtnUrl = localizedSignupURL + '?bundle=jira-software&edition=premium';
                                            break;
                                        case (0, $hrGO1.SpecialPlanNames).ENTERPRISE:
                                            edition = (0, $hrGO1.Edition).ENTERPRISE;
                                            ctaBtnText = contactSalesText;
                                            ctaBtnUrl = localizedContactURL;
                                            dataEventPropsLabel = `${tierContent}-contact-sales-compare-features`;
                                            break;
                                    }
                                }
                                return /*#__PURE__*/ (0, $7VQPk.jsx)($84231b70db855011$var$FeaturesTableHeadCell, {
                                    index: index,
                                    id: `${$84231b70db855011$var$featuresTableHeadIdPrefix}${index}`,
                                    children: typeof tierContent === 'string' ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _2lx21bp4 _zulpftgi _4cvr1y6m"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                className: (0, $2jatx.default)([
                                                    "_syaz1pfd _k48p1fw0"
                                                ]),
                                                style: {
                                                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                                                },
                                                children: tierContent
                                            }),
                                            props.stickyCtasEnabled && props.dataProductKey && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6o9v8.StickyCTAContextProvider), {
                                                isSticky: undefined,
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l4Rl8.CtaButton), {
                                                    edition: edition,
                                                    dataProductKey: props.dataProductKey,
                                                    type: 'secondary',
                                                    text: ctaBtnText,
                                                    dataEventPropsLabel: dataEventPropsLabel,
                                                    url: ctaBtnUrl,
                                                    isDisabled: false,
                                                    containerId: (0, $hrGO1.COMPARE_FEATURES_CONTAINER)
                                                })
                                            })
                                        ]
                                    }) : tierContent ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_y3gn1e5h"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                className: (0, $2jatx.default)([
                                                    "_syaz1pfd _k48p1fw0"
                                                ]),
                                                style: {
                                                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                                                },
                                                children: tierContent.title
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                        className: (0, $2jatx.default)([
                                                            "_syaz1pfd _k48p1fw0"
                                                        ]),
                                                        style: {
                                                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                                                        },
                                                        children: tierContent.price
                                                    }),
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                        className: (0, $2jatx.default)([
                                                            "_syazinbi _ahbqi2wt"
                                                        ]),
                                                        style: {
                                                            "--_1tiihzy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light600'))
                                                        },
                                                        children: "per user"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                                                size: "small",
                                                variant: "secondary",
                                                color: "black",
                                                colorAgainst: "other",
                                                href: "https://www.atlassian.com/enterprise/contact?formType=product-features",
                                                className: (0, $2jatx.default)([
                                                    "_1pfhw1gv"
                                                ]),
                                                children: tierContent.button
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        children: "Invalid Data"
                                    })
                                }, index);
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("tbody", {
                    children: props.children
                })
            ]
        })
    });
};
const $84231b70db855011$var$FeaturesTableHeadCell = ({ ...props })=>{
    const isPresentation = props.role === 'presentation';
    return /*#__PURE__*/ (0, $7VQPk.jsx)("th", {
        ...props,
        scope: isPresentation ? undefined : 'col',
        className: (0, $2jatx.default)([
            "_1bah1yb4 _k48p1nn1 _y3gn1e5h _syaz1pfd _suga1txw _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _s7n41q9y _t51zkze7 _10msglyw"
        ]),
        style: {
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
        }
    });
};
const $84231b70db855011$var$lozengeContainerCss = null;
const $84231b70db855011$export$4a48add4d33bb5cb = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("tr", {
        className: (0, $2jatx.default)([
            "_syaz1pfd _2lx21bp4 _19pk7vkz _2hwxidpf _otyr7vkz _18u0idpf _bfhkg7ng _v56411zw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _s7n41q9y _y3gn1h6o _sugaglyw"
        ]),
        style: {
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
            "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("th", {
            id: props.groupId,
            scope: "rowgroup",
            colSpan: props.tierCellsContent.length + 1,
            className: (0, $2jatx.default)([
                "_1bah1yb4 _k48p1nn1 _y3gn1e5h _syaz1pfd _suga1txw _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _s7n41q9y _t51zkze7 _10msglyw",
                "_y3gnv2br"
            ]),
            style: {
                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_syaz1pfd _1bsb1osq _k48p8n31 _4t3i1wug _1e0c1ule _1i4q1hna"
                ]),
                style: {
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                },
                children: props.headerTitle
            })
        })
    });
};
const $84231b70db855011$export$8d6c1dc4bc4e86f2 = (props)=>{
    let lozenge = null;
    const { text: text, expanderContent: expanderContent, href: href } = props.featureCellContent;
    if (props.lozengeText) lozenge = /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            "_ahbq1y44"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $20Gca.default), {
            children: props.lozengeText
        })
    });
    const rowDescId = `rowDesc_${props.id}`;
    let featureCellContent;
    if (href) featureCellContent = /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                text: text,
                href: href,
                type: 'primary',
                "aria-label": text,
                className: (0, $2jatx.default)([
                    "_1wybdlk8 _ahbq1y44"
                ])
            }),
            lozenge
        ]
    });
    else {
        const children = expanderContent ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: expanderContent
            },
            className: (0, $2jatx.default)([
                "_1wybdlk8 _syaz1x3z _43dsrbzz _59381r31 _yha28stv _1nmznqa1 _oxk4oelr _rfqo1r31 _1bgkglyw _1t0pnqa1"
            ]),
            style: {
                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
            }
        }) : undefined;
        featureCellContent = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6tSTn.ExpandableContent), {
            eventDataName: text,
            label: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                children: [
                    text,
                    lozenge
                ]
            }),
            children: children
        });
    }
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("tr", {
        className: (0, $2jatx.default)([
            "_19pk7vkz _2hwxidpf _otyr7vkz _18u0idpf _bfhk1afi _v56411zw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _s7n41q9y _y3gn1h6o _1ckvidpf _irr3g7ng _1o4gh1cn _a5ztgktf _suga1txw _1gde1bp4"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100')),
            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("th", {
                id: rowDescId,
                scope: "row",
                className: (0, $2jatx.default)([
                    "_1bah1yb4 _k48p1nn1 _y3gn1e5h _syaz1pfd _suga1txw _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _s7n41q9y _t51zkze7 _10msglyw",
                    "_y3gnv2br _k48p4jg8 _16nmgktf _1w6hgktf _gtp7dkka _1kmxdlk8 _1ggmdlk8 _1ykzdlk8 _1maedlk8"
                ]),
                style: {
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                    "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400')),
                    "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_1bsb1osq _1reo15vq"
                    ]),
                    children: featureCellContent
                })
            }),
            props.tierCellsContent.map((content, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)($84231b70db855011$export$17906fe86bec07d9, {
                    index: index,
                    cellContent: content,
                    rowDescId: rowDescId
                }, index))
        ]
    });
};
const $84231b70db855011$export$17906fe86bec07d9 = ({ cellContent: cellContent, index: index, rowDescId: rowDescId })=>{
    const { planTiers: planTiers, groupHeaderId: groupHeaderId } = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useContext($84231b70db855011$var$FeaturesTableContext);
    const tierContent = planTiers[index];
    const colHeaderId = `${$84231b70db855011$var$featuresTableHeadIdPrefix}${index}`;
    const headersAttr = [
        groupHeaderId,
        colHeaderId,
        rowDescId
    ].filter(Boolean).join(' ');
    const cellContentStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("td", {
        headers: headersAttr,
        className: (0, $2jatx.default)([
            "_1bah1yb4 _k48p1nn1 _y3gn1e5h _syaz1pfd _suga1txw _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _s7n41q9y _t51zkze7 _10msglyw",
            "_s7n4jp4b"
        ]),
        style: {
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_suga1txw _1e0cglyw"
                ]),
                children: typeof tierContent === 'string' ? tierContent : tierContent && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                    children: tierContent.title
                })
            }),
            cellContent && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _zulpu2gc"
                ]),
                children: [
                    cellContent.checkmark && /*#__PURE__*/ (0, $7VQPk.jsx)($84231b70db855011$export$4f481e0a96cfbed6, {
                        containerProps: {
                            'aria-hidden': 'true',
                            style: {
                                marginBlockStart: '-6px'
                            }
                        }
                    }),
                    cellContent.textContent && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: cellContent.textContent
                        },
                        className: (0, $2jatx.default)([
                            "_y3gnv2br _1wybdlk8 _43dsrbzz _59381r31 _yha28stv _1nmznqa1 _oxk4oelr _rfqo1r31 _1bgkglyw _1t0pnqa1"
                        ])
                    })
                ]
            })
        ]
    });
};
const $84231b70db855011$export$4f481e0a96cfbed6 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ...props.containerProps,
        className: (0, $2jatx.default)([
            "_1a1x1ssb"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
            "data-testid": "checkmark",
            className: (0, $2jatx.default)([
                "_bfhk1oqd _2rko1ssb _syaz1afi _1e0c1o8l _1o9zidpf _k48p8n31 _vwz41tcg _19pk1y44 _2hwx1y44 _otyr1y44 _18u01y44 _y3gn1h6o _4t3i1tcg _1bsb1tcg"
            ]),
            style: {
                "--_1blpe4f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.lime700')),
                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $OKl9V.Icon), {
                name: "featurecheckmark",
                size: "xs",
                color: (0, $kbpa7.wacToken)('color.neutral.light0')
            })
        })
    });
};
const $84231b70db855011$export$49da9cb6ddf668ee = ({ title: title, comparePlans: comparePlans, compareFeatures: compareFeatures, linkValues: linkValues, dataProductKey: dataProductKey, stickyCtasEnabled: stickyCtasEnabled })=>{
    const intl = (0, $8e22h.default)();
    if (!comparePlans || !compareFeatures) return null;
    // maintain a list to keep track of the plans in the contentful order
    const orderedPlanTiers = comparePlans?.map((plan)=>plan.planTitleExternal ?? '') ?? [];
    const fallbackTitle = intl.formatMessage({
        id: 'PricingFeatureTable.fallbackTitle',
        defaultMessage: 'Compare Features'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)($84231b70db855011$export$5a7d94d7c691844a, {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)($84231b70db855011$export$de898cfe2ca10ff8, {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)($84231b70db855011$export$f052fee91dc6777a, {
                        children: title ?? fallbackTitle
                    }),
                    linkValues?.linkHref && linkValues?.linkText ? /*#__PURE__*/ (0, $7VQPk.jsx)($84231b70db855011$export$a433b7aa5ad7fd61, {
                        ...linkValues
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)($84231b70db855011$export$e2b8eb038115bae6, {
                captionText: "",
                planTiers: orderedPlanTiers,
                dataProductKey: dataProductKey,
                stickyCtasEnabled: stickyCtasEnabled,
                children: compareFeatures?.map((featureGroup, index)=>{
                    return /*#__PURE__*/ (0, $7VQPk.jsx)($84231b70db855011$export$4612d2a76503b8a4, {
                        featureGroup: featureGroup,
                        orderedPlanTiers: orderedPlanTiers,
                        groupIndex: index
                    }, featureGroup.featureGroupTitleExternal);
                })
            })
        ]
    });
};
const $84231b70db855011$export$4612d2a76503b8a4 = ({ featureGroup: featureGroup, orderedPlanTiers: orderedPlanTiers, groupIndex: groupIndex })=>{
    const { featureGroupTitleExternal: featureGroupTitleExternal, features: features } = featureGroup;
    const { planTiers: planTiers } = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useContext($84231b70db855011$var$FeaturesTableContext);
    const groupId = `${$84231b70db855011$var$featuresTableGroupIdPrefix}${groupIndex}`;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)($84231b70db855011$var$FeaturesTableContext.Provider, {
        value: {
            planTiers: planTiers,
            groupHeaderId: groupId
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($84231b70db855011$export$4a48add4d33bb5cb, {
                headerTitle: featureGroupTitleExternal ?? '',
                tierCellsContent: Array(Object.keys(orderedPlanTiers).length).fill(''),
                groupId: groupId
            }),
            features?.map((feature, index)=>{
                const { featureNameExternal: featureNameExternal, description: description, relevantUrl: relevantUrl, callOut: callOut, featureAdditionalInformation: featureAdditionalInformation, relevantPlan: relevantPlan } = feature;
                // Initialize an object to store feature cell information for each plan.
                // The keys will be the plan names, and the values will be initially set to exmpty objects.
                const featureCellInfo = orderedPlanTiers.reduce((obj, plan)=>{
                    obj[plan] = {};
                    return obj;
                }, {});
                if (featureAdditionalInformation) // Iterate over each addtional information and update the appropiriate featureCellInfo with corresponding messages
                featureAdditionalInformation?.forEach((info)=>{
                    const { featureAdditionalInformation: message, relevantPlan: featureRelevantPlans } = info;
                    featureRelevantPlans?.forEach((plan)=>{
                        const planTitleExternal = plan.planTitleExternal;
                        if (featureCellInfo[planTitleExternal]) featureCellInfo[planTitleExternal].textContent = message ?? '';
                    });
                });
                // hanlding boolean values
                if (relevantPlan) relevantPlan?.forEach((plan)=>{
                    // Mark this plan as true in featureCellInfo
                    const planTitleExternal = plan.planTitleExternal;
                    if (featureCellInfo[planTitleExternal]) featureCellInfo[planTitleExternal].checkmark = true;
                });
                // Generate the ordered values for tierCellsContent
                const orderedValues = orderedPlanTiers.map((key)=>featureCellInfo[key]).filter((value)=>value !== undefined);
                return /*#__PURE__*/ (0, $7VQPk.jsx)($84231b70db855011$export$8d6c1dc4bc4e86f2, {
                    featureCellContent: {
                        text: featureNameExternal ?? '',
                        expanderContent: description ?? null,
                        href: relevantUrl ?? null
                    },
                    lozengeText: callOut,
                    tierCellsContent: orderedValues,
                    id: `${groupIndex}_${index}`
                }, featureNameExternal);
            })
        ]
    });
};

});
parcelRegister("6tSTn", function(module, exports) {
$parcel$export(module.exports, "ExpandableContent", function () { return $71a3008b09c61d64$export$9ffd278d9b1d2f4b; });
/* expandable-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $eY3N6 = parcelRequire("eY3N6");

var $Lp2P8 = parcelRequire("Lp2P8");

var $kbpa7 = parcelRequire("kbpa7");
const $71a3008b09c61d64$var$buttonCss = null;
const $71a3008b09c61d64$var$labelContentsCss = null;
const $71a3008b09c61d64$var$buttonContentCss = null;
const $71a3008b09c61d64$export$9ffd278d9b1d2f4b = (props)=>{
    const [expanded, setExpanded] = (0, $1oC0p.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    // contentRef controls the content element height upon expansion change
    const contentRef = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useEffect)(()=>{
        if (!contentRef.current) return;
        if (expanded) contentRef.current.style.maxHeight = `${contentRef.current.scrollHeight}px`;
        else contentRef.current.style.maxHeight = '0';
    }, [
        expanded
    ]);
    const handleButtonClick = ()=>{
        if (props.eventDataName) {
            const data = {
                name: props.eventDataName,
                direction: expanded ? 'close' : 'open'
            };
            createAnalyticsEvent({
                eventName: 'expandableContentClicked',
                eventType: 'ui',
                eventComponent: 'button',
                event: 'clicked',
                actionSubject: 'expandableContent',
                action: 'clicked',
                attributes: data,
                data: data
            }).fire();
        }
        setExpanded((prev)=>!prev);
    };
    const labelContents = /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
        className: (0, $2jatx.default)([
            "_1wybdlk8 _1e0c1txw _zulp1y44"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_4t3i1tcg _1bsb1tcg _t9ec1g85 _v564f4ca"
                ]),
                style: {
                    "--_vcjhmp": (0, $6ZVlx.default)(expanded ? 'rotate(90deg)' : 'rotate(0deg)')
                },
                children: props.children && /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($Lp2P8))), {
                    label: "",
                    spacing: "spacious"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                style: props.labelCss,
                className: (0, $2jatx.default)([
                    "_85i5yh40 _1bsb1osq"
                ]),
                children: expanded && props.expandedLabelText ? props.expandedLabelText : props.label
            })
        ]
    });
    const expandedStyles = null;
    const collapsedStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            props.children ? /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                "aria-expanded": expanded,
                onClick: handleButtonClick,
                className: (0, $2jatx.default)([
                    "_kkk218uv _mizuoelr _ra3x1wug _128mt94y",
                    "_ect41bgz _1wyboxwj _vwz44jg8 _syaz1x3z _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3"
                ]),
                style: {
                    cursor: 'pointer',
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                },
                children: labelContents
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_ect41bgz _1wyboxwj _vwz44jg8 _syaz1x3z _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3"
                ]),
                style: {
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                },
                children: labelContents
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                ref: contentRef,
                "aria-hidden": !expanded,
                role: expanded ? 'region' : undefined,
                className: (0, $2jatx.default)([
                    "_1e0ctcjq _1reo15vq _18m915vq _v56413gs _bozg1f4h"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        expanded && "_1e0c1ule",
                        !expanded && "_1e0cglyw"
                    ]),
                    children: props.children
                })
            })
        ]
    });
};

});

parcelRegister("l4Rl8", function(module, exports) {
$parcel$export(module.exports, "CtaButton", function () { return $8627522070c75517$export$87cbfb14b50d331c; });
/* cta-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $lmQGF = parcelRequire("lmQGF");

var $gfjAv = parcelRequire("gfjAv");

var $lOlsU = parcelRequire("lOlsU");

var $4IlVP = parcelRequire("4IlVP");
const $8627522070c75517$var$ctaButtonStyles = null;
const $8627522070c75517$export$87cbfb14b50d331c = ({ edition: edition, dataProductKey: dataProductKey, text: text, type: type, url: url, dataEventPropsLabel: dataEventPropsLabel, containerId: containerId, isDisabled: isDisabled, ...props })=>{
    const fireCtaEvent = (0, $lOlsU.useFirePricingPlanCtaEvent)({
        edition: edition,
        containerId: containerId,
        productKey: dataProductKey
    });
    const envSpecificURL = (0, $4IlVP.getEnvironment)(true) === 'staging' ? url.replace(/https:\/\/(www.)?atlassian.com/, 'https://wac.stg.internal.atlassian.com') : url;
    const handleClick = ()=>{
        fireCtaEvent();
        // @ts-ignore
        props.onClick?.();
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gfjAv.default), {
        intentType: 'button',
        containerId: containerId,
        productKey: dataProductKey,
        edition: edition,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
            isDisabled: isDisabled,
            variant: type,
            color: "black",
            href: envSpecificURL,
            dataEventProps: {
                'data-product-key': dataProductKey,
                'data-event-component': 'linkButton',
                'data-event-container': 'priceBlock',
                'data-event': 'clicked',
                'data-label': `${dataEventPropsLabel}`,
                'data-label-english': `${dataEventPropsLabel}`
            },
            ...props,
            onClick: handleClick,
            className: (0, $2jatx.default)([
                "_11c88q0o _1wyb7vkz _k48p1nn1 _vwz4gktf _4t3i1wug _4bfu1r31 _1hmsglyw _ajmmnqa1 _1bsb1ns9 _o5724jg8 _1q51ftgi _85i5ftgi"
            ]),
            children: text
        })
    });
};

});
parcelRegister("lOlsU", function(module, exports) {
$parcel$export(module.exports, "useFirePricingPlanCtaEvent", function () { return $94595cb38e128ae6$export$7f90eaa475fc1c9f; });

var $fuLgT = parcelRequire("fuLgT");

var $eY3N6 = parcelRequire("eY3N6");
function $94595cb38e128ae6$export$7f90eaa475fc1c9f(props) {
    const { edition: edition, productKey: productKey, containerId: containerId } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const createPayload = ()=>({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'linkButton',
            containerId: containerId,
            actionSubjectId: 'pricingPlanCta',
            attributes: {
                migrationExperimentCta: true,
                pricingEventId: (0, $fuLgT.default)(),
                productKey: productKey,
                edition: edition
            }
        });
    return ()=>createAnalyticsEvent(createPayload()).fire();
}

});


parcelRegister("6o9v8", function(module, exports) {
$parcel$export(module.exports, "StickyCTAContextProvider", function () { return $52fdcbddbb22aba0$export$6177378b3c0dfa99; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
const $52fdcbddbb22aba0$var$StickyCtaContext = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
const $52fdcbddbb22aba0$export$d07c74b192781870 = ()=>{
    const context = (0, $1oC0p.useContext)($52fdcbddbb22aba0$var$StickyCtaContext);
    if (!context) return {
        isSticky: false
    };
    return context;
};
const $52fdcbddbb22aba0$export$6177378b3c0dfa99 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)($52fdcbddbb22aba0$var$StickyCtaContext.Provider, {
        value: props,
        children: props.children
    });
};

});


parcelRegister("bE8d4", function(module, exports) {
$parcel$export(module.exports, "PricingFaq", function () { return $858340cf4dc38f41$export$3c5f68183e9d00f8; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $iAA1N = parcelRequire("iAA1N");

var $e1ZWr = parcelRequire("e1ZWr");
const $858340cf4dc38f41$export$3c5f68183e9d00f8 = ({ header: header, planDetails: planDetails })=>{
    const intl = (0, $8e22h.default)();
    if (!planDetails) return null;
    const fallbackHeader = intl.formatMessage({
        id: 'pricing.faq.header',
        defaultMessage: 'Get more info'
    });
    const faqAccordionsFeatures = planDetails.map((item)=>({
            header: item.planAdditionalDetailsTitleExternal ?? '',
            content: (0, $e1ZWr.parseHtmlString)(item.planAdditionalDetails ?? undefined)
        }));
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iAA1N.default), {
        header: header ?? fallbackHeader,
        features: faqAccordionsFeatures
    });
};
$858340cf4dc38f41$export$3c5f68183e9d00f8.displayName = 'PricingFaq';

});
parcelRegister("iAA1N", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6090491cfa4b9136$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable @atlaskit/design-system/no-physical-properties */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $6090491cfa4b9136$var$rowCss = null;
const $6090491cfa4b9136$var$containerCss = null;
const $6090491cfa4b9136$var$headerCss = null;
const $6090491cfa4b9136$var$featureContainerCss = null;
const $6090491cfa4b9136$var$fadeInAnimation = null;
const $6090491cfa4b9136$var$featureContentCss = null;
const $6090491cfa4b9136$var$showContentCss = null;
const $6090491cfa4b9136$var$featureHeaderCss = null;
const $6090491cfa4b9136$var$toggleIconCss = null;
/**
 * @deprecated - Please use @/libraries/design/components/accordion instead
 */ const $6090491cfa4b9136$var$FaqAccordions = ({ header: header, features: features })=>{
    const [expanded, setExpanded] = (0, $1oC0p.useState)({});
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        id: "faq",
        className: (0, $2jatx.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f1fra _1bsb1osq _j4or1wqb"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _n3tdvbgk _1bsbf2ck _8fz61c5i _1hwcidpf _1s4p1osq _q5bceo28 _jjfo1osq"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    className: (0, $2jatx.default)([
                        "_n7zld48f _syazqlpt _1wyb1ylp _k48p1fw0 _vwz4ckbl _1dyzidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0q1tcg _u5f37vkz _n3td1tcg _19bv7vkz _y3gn1h6o _so7d14no _19q1or1b _1v4mzwfg _1bl410mc"
                    ]),
                    children: header
                }),
                features.map((feature)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_n7zld48f _ca0qidpf _u5f37vkz _n3tdidpf _19bv7vkz _xlob1h6o _cy6oglyw _szfsglyw _stfgidpf _d32vrbzz _4rtxtlke _dpd31txw _1jmq1tcg _1gflidpf _yhjmidpf _1gqnidpf _11lvidpf _14hp1osq _1d421ul9 _k6cg1ul9"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                                "aria-expanded": expanded[feature.header] ?? false,
                                onClick: ()=>setExpanded({
                                        ...expanded,
                                        [feature.header]: !expanded[feature.header]
                                    }),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                        className: (0, $2jatx.default)([
                                            "_syaz1bqd _16jlkb7n _1o9zkb7n _i0dlf1ug _1wyb1tcg _k48pbfng _1dyznl7k _vwz410nf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0q1tcg _u5f3idpf _n3td1tcg _19bvidpf _y3gn1e5h _1xrxrbzz _so7dqslr _gwdjgktf"
                                        ]),
                                        children: feature.header
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_bfhkrbzz _2rko1ssb _4t3i1tcg _v56488n5 _1bsb1tcg _wtqc14w8 _pmf41sub _ts4v19bv _49x519bv _1mf219bv _12h0b3bt _s971b3bt _229db3bt _1st5stnw _vuffstnw _kd02stnw _189bidpf _1owaidpf _1ypnidpf _umq4idpf _1d08idpf _3rqzidpf _3uxpidpf _pl8lidpf _2x6gidpf _1lzuidpf _e2u3idpf _1u95idpf _tmcvu67f _1696u67f _15g2u67f _aze81wug _8u7c1wug _19dq1wug _144j14y2 _iui614y2 _6v8s14y2 _1faz1wug _1ew01wug _3r7i1wug _1oz314y2 _18xc14y2 _u63c14y2 _1xlyyh40 _kotoyh40 _6zj4yh40 _6zj41wug _ornayh40 _19dq14y2 _6v8s1wug _3r7i14y2 _u63c1wug",
                                            expanded[feature.header] ? 'minus' : 'plus'
                                        ])
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_y44v1dy6 _1e0cglyw _2hwxvbgk _n3td1tcg _43dsrbzz _59381r31 _yha28stv _1nmznqa1 _oxk4oelr _rfqo1r31 _1bgkglyw _1t0pnqa1 _clfdidpf _11pqidpf _q0a51tcg _c3k8idpf",
                                    expanded[feature.header] && "_1e0c1ule"
                                ]),
                                children: feature.content
                            })
                        ]
                    }, feature.header))
            ]
        })
    });
};
var $6090491cfa4b9136$export$2e2bcd8739ae039 = $6090491cfa4b9136$var$FaqAccordions;

});

parcelRegister("e1ZWr", function(module, exports) {
$parcel$export(module.exports, "parseHtmlString", function () { return $3d89aad90cf98a04$export$85d98c827c7edf42; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
const $3d89aad90cf98a04$var$sharedRichtextValues = {
    p: (chunks, key)=>/*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: chunks
        }, key),
    strong: (chunks, key)=>/*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
            children: chunks
        }, key),
    ul: (chunks, key)=>/*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
            children: chunks
        }, key),
    li: (chunks, key)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
            children: chunks
        }, key),
    a: (chunks, key, href)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
            href: href,
            children: chunks
        }, key),
    br: (_chunks, key)=>/*#__PURE__*/ (0, $7VQPk.jsx)("br", {}, key)
};
const $3d89aad90cf98a04$var$convertToReact = (node, key)=>{
    if (node.nodeType === Node.TEXT_NODE) return node.textContent;
    if (node.nodeType === Node.ELEMENT_NODE) {
        const element = node;
        const tagName = element.tagName.toLowerCase();
        const children = Array.from(element.childNodes).map((child, index)=>$3d89aad90cf98a04$var$convertToReact(child, `${key}-${index}`));
        const renderFunction = $3d89aad90cf98a04$var$sharedRichtextValues[tagName];
        if (renderFunction) return renderFunction(children, key, element.getAttribute('href') || undefined);
        else return /*#__PURE__*/ (0, $1oC0p.createElement)(tagName, {
            key: key
        }, children);
    }
    return null;
};
const $3d89aad90cf98a04$export$85d98c827c7edf42 = (htmlString)=>{
    if (!htmlString) return null;
    if (typeof document === 'undefined') return null;
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    return $3d89aad90cf98a04$var$convertToReact(tempDiv, 'root');
};

});


parcelRegister("2zOxm", function(module, exports) {
$parcel$export(module.exports, "QuotationsAdornment", function () { return $a59da8f7af8cdcb0$export$41c85da8b12966cf; });
/* quotations.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $hnmMQ = parcelRequire("hnmMQ");
const $a59da8f7af8cdcb0$export$41c85da8b12966cf = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _152t3sup _1e021c6i _1mjbglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($a59da8f7af8cdcb0$var$LeftQuotation, {})
            }),
            props.children,
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _152tidpf _rjxpu4aj _1mjbglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($a59da8f7af8cdcb0$var$RightQuotation, {})
            })
        ]
    });
};
const $a59da8f7af8cdcb0$var$LeftQuotation = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/02m24o230o077mu3rxv7gm30nj77wqii.svg',
            alt: ''
        }
    });
const $a59da8f7af8cdcb0$var$RightQuotation = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/50x33lwtmm1hnd8x717wk316dthyw741.svg',
            alt: ''
        }
    });

});

parcelRegister("6Px6U", function(module, exports) {
$parcel$export(module.exports, "PageHeading", function () { return $9310efba541b4555$export$9716a88f5535df7c; });
/* page-heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $hnmMQ = parcelRequire("hnmMQ");
const $9310efba541b4555$export$9716a88f5535df7c = (props)=>{
    const { as: Component = 'h1', children: children, ...rest } = props;
    const headingStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _zulpftgi"
        ]),
        children: [
            typeof children === 'string' ? /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                ...rest,
                dangerouslySetInnerHTML: {
                    __html: children
                },
                className: (0, $2jatx.default)([
                    "_k48p1fw0 _vwz48vuz _y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1s18ckbl _1cqs1ady _1qjn1ylp _syazqlpt"
                ])
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                ...rest,
                className: (0, $2jatx.default)([
                    "_k48p1fw0 _vwz48vuz _y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1s18ckbl _1cqs1ady _1qjn1ylp _syazqlpt"
                ]),
                children: children
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                image: {
                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ox5132cg4k77h80v02063670d5th386i.svg',
                    alt: ''
                }
            })
        ]
    });
};

});

parcelRegister("grcEk", function(module, exports) {
$parcel$export(module.exports, "PricingPageLayout", function () { return $229e6cc32b6909b5$export$179602f42864b2b8; });
/* pricing-page-layout.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iLjCW = parcelRequire("iLjCW");

var $jvvcS = parcelRequire("jvvcS");
const $229e6cc32b6909b5$export$179602f42864b2b8 = ({ nav: nav, banner: banner, hero: hero, bgColor: bgColor, hasGlobalFooter: hasGlobalFooter = true, showFallback: showFallback = false, noInlinePadding: noInlinePadding = false, children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            nav && nav,
            !showFallback && banner,
            !showFallback && hero,
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                style: {
                    background: bgColor
                },
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _1q51vbgk _85i5vbgk _xc2ickbl _1u2qzwfg"
                ]),
                children: [
                    showFallback && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jvvcS.PricingPageFallback), {}),
                    !showFallback && children && /*#__PURE__*/ (0, $7VQPk.jsx)("main", {
                        id: "content",
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _zulpvbgk _p12ftfvk _1bsbaq80 _vqct1h22 _1wfq1ul9 _15vt1ul9 _v7361wqb _chtu1wqb _8164ckbl _63vr1vh9 _1tbz1ul9 _68811ul9",
                            noInlinePadding && "_bozgidpf _y4tiidpf _1wfqidpf _15vtidpf _v736idpf _chtuidpf _1tbzidpf _6881idpf"
                        ]),
                        children: children
                    })
                ]
            }),
            hasGlobalFooter && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1pfhvbgk _476dckbl"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iLjCW.GlobalFooter), {})
            })
        ]
    });
};
const $229e6cc32b6909b5$var$footerCss = null;
const $229e6cc32b6909b5$var$pricingPageLayoutOuterCss = null;
const $229e6cc32b6909b5$var$pricingPageLayoutInnerCss = null;
// Opt-in override for full-bleed pricing pages (e.g. usage-based pricing
// calculator). Strips the inline padding at every breakpoint so the child
// content can span the full inner-max-width.
const $229e6cc32b6909b5$var$pricingPageLayoutInnerNoPaddingCss = null;

});
parcelRegister("jvvcS", function(module, exports) {
$parcel$export(module.exports, "PricingPageFallback", function () { return $a5f2023cdede46a1$export$54fc8f6b9874893e; });
/* pricing-page-fallback.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
const $a5f2023cdede46a1$export$54fc8f6b9874893e = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4t3idtre _1e0c1txw _4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "PageFallback.message",
            defaultMessage: "An unexpected error occurred. Please try again later."
        })
    });
};

});


parcelRegister("frz5c", function(module, exports) {
$parcel$export(module.exports, "QuestionsCta", function () { return $a5fd4efc00df1131$export$7874bf850b18c607; });
/* questions-cta.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $iPPTB = parcelRequire("iPPTB");

var $hnmMQ = parcelRequire("hnmMQ");
const $a5fd4efc00df1131$var$containerCss = null;
const $a5fd4efc00df1131$var$sectionLeftCss = null;
const $a5fd4efc00df1131$var$sectionLeftTextCss = null;
const $a5fd4efc00df1131$var$headingCss = null;
const $a5fd4efc00df1131$var$svgStyles = null;
const $a5fd4efc00df1131$export$7874bf850b18c607 = ({ questionsHeader: questionsHeader, questionsBody: questionsBody, priceAndLicensingLinkText: priceAndLicensingLinkText, ctaHref: ctaHref, imageHref: imageHref = 'https://dam-cdn.atl.orangelogic.com/AssetLink/0s31nt386q2lt662011182pvct037sp1.svg', product: product })=>{
    const intl = (0, $8e22h.default)();
    if (!ctaHref || !product && !questionsBody) return null;
    const fallbackQuestionsHeader = intl.formatMessage({
        id: 'PricingPage.QuestionsCta.questionsHeader',
        defaultMessage: 'Questions?'
    });
    const fallbackQuestionsBody = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "PricingPage.QuestionsCta.questionsBody",
        defaultMessage: "We got answers. Read our full list of common questions and answers for general cloud pricing and licensing or specific {product} pricing and licensing.",
        values: {
            product: product
        }
    });
    const text = intl.formatMessage({
        id: 'PricingPage.QuestionsCta.priceAndLicensingLinkText',
        defaultMessage: 'See price and licensing page'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_4cvr1y6m _1bah1h6o _bfhkr3uz _1e0c1txw _syazu67f _1reoewfl _18m9ewfl _ca0qvbgk _u5f31uvc _n3tdvbgk _19bvd3xy _2osnqslr _8fz61fdn _tl28vbgk _axwi1l27 _1hwc1et3 _sp8t1l27 _1gde1sxn _1vth1hhm _mkrz22xr _zulpt9kd"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _4cvr1y6m _y3gn1e5h _zulp7vkz _85i519bv _xlt110yn"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                        "data-testid": "questions-cta-header",
                        className: (0, $2jatx.default)([
                            "_1wybzwfg _vwz410mc _so7d1f4h _19q11u1b _1cqs1tcg _1bys1ul9",
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syazu67f"
                        ]),
                        children: questionsHeader ?? fallbackQuestionsHeader
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        "data-testid": "questions-cta-body",
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syazu67f"
                        ]),
                        children: questionsBody ?? fallbackQuestionsBody
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                        text: priceAndLicensingLinkText ?? text,
                        "aria-label": priceAndLicensingLinkText ?? text,
                        href: ctaHref,
                        anchorProps: {
                            'data-testid': 'questions-cta-link'
                        },
                        bgColor: 'bgBlackBlue'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                image: {
                    src: imageHref,
                    alt: ''
                },
                className: (0, $2jatx.default)([
                    "_1bsb7l9q _4t3irb92 _1s4pnxnw _1kne1yvi"
                ])
            })
        ]
    });
};
$a5fd4efc00df1131$export$7874bf850b18c607.displayName = 'QuestionsCTASection';

});

parcelRegister("atyps", function(module, exports) {
$parcel$export(module.exports, "BitbucketNav", function () { return $46b40aa87e150696$export$374e7235418bdbdb; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $20OkY = parcelRequire("20OkY");

var $asbmK = parcelRequire("asbmK");

var $eOIix = parcelRequire("eOIix");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $gn6Qa = parcelRequire("gn6Qa");

var $gpfek = parcelRequire("gpfek");
const $46b40aa87e150696$var$BitbucketLogoComponent = ()=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "bitbucket",
        type: "logo",
        appearance: "brand",
        darkTheme: isDarkTheme
    });
};
const $46b40aa87e150696$export$374e7235418bdbdb = ()=>{
    const intl = (0, $8e22h.default)();
    const signupLink = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=bitbucket&edition=free');
    const { openCrossFlow: openCrossFlow } = (0, $asbmK.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).BITBUCKET,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const dataCenterHref = (0, $jQ0cd.useLocalizedHref)('/software/bitbucket/enterprise/data-center');
    const pricingHref = (0, $jQ0cd.useLocalizedHref)('/software/bitbucket/pricing');
    const links = [
        {
            globalLinksKey: 'whyBitbucket',
            linkText: intl.formatMessage({
                id: 'BitbucketPageTemplate.navbar.whyBitbucket',
                defaultMessage: 'Why Bitbucket'
            }),
            productKey: 'bitbucket',
            hasDropdown: true,
            dropdownType: 'why-bitbucket'
        },
        {
            globalLinksKey: 'self-hosted',
            linkText: intl.formatMessage({
                id: 'BitbucketPageTemplate.navbar.selfhosted',
                defaultMessage: 'Self-Hosted'
            }),
            hasDropdown: false,
            productKey: 'bitbucket',
            href: dataCenterHref
        },
        {
            globalLinksKey: 'pricing',
            linkText: intl.formatMessage({
                id: 'BitbucketPageTemplate.navbar.pricing',
                defaultMessage: 'Pricing'
            }),
            hasDropdown: false,
            productKey: 'bitbucket',
            href: pricingHref
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-BitbucketNav",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gn6Qa.ProductPageNav), {
            productKey: 'bitbucket',
            productLogoUrl: "/software/bitbucket",
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($46b40aa87e150696$var$BitbucketLogoComponent, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: 'BitbucketPageTemplate.navbar.bitbucket-logo',
                defaultMessage: 'Bitbucket logo'
            }),
            mobileCtaText: intl.formatMessage({
                id: 'BitbucketPageTemplate.navbar.getitfree',
                defaultMessage: 'Get it Free'
            }),
            navigationTrynowCtaText: intl.formatMessage({
                id: 'BitbucketPageTemplate.navbar.getitfree',
                defaultMessage: 'Get it Free'
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: openCrossFlow,
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($46b40aa87e150696$var$BitbucketLogoComponent, {}),
            productPageNavLinks: [
                {
                    globalLinksKey: 'whyBitbucket',
                    linkText: intl.formatMessage({
                        id: 'BitbucketPageTemplate.navbar.whyBitbucket',
                        defaultMessage: 'Why Bitbucket'
                    }),
                    containerStyles: {
                        width: 'fit-content',
                        margin: 0
                    },
                    hasDropdown: true,
                    content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gpfek.WhyBitbucketDropdown), {
                        productKey: 'bitbucket'
                    })
                },
                {
                    globalLinksKey: 'self-hosted',
                    linkText: intl.formatMessage({
                        id: 'BitbucketPageTemplate.navbar.selfhosted',
                        defaultMessage: 'Self-Hosted'
                    }),
                    hasDropdown: false,
                    productKey: 'bitbucket',
                    href: dataCenterHref
                },
                {
                    globalLinksKey: 'pricing',
                    linkText: intl.formatMessage({
                        id: 'BitbucketPageTemplate.navbar.pricing',
                        defaultMessage: 'Pricing'
                    }),
                    hasDropdown: false,
                    productKey: 'bitbucket',
                    href: pricingHref
                }
            ],
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: openCrossFlow,
            mobileLinksSections: [
                {
                    mobileLinkKey: 'mobile-bitbucket',
                    mobileLinksProps: links
                }
            ]
        })
    });
};

});
parcelRegister("gpfek", function(module, exports) {
$parcel$export(module.exports, "WhyBitbucketDropdown", function () { return $fb55312c1434003b$export$2c78ab5135d18215; });
/* why-bitbucket-dropdown.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $jsxHL = parcelRequire("jsxHL");

var $8nFt2 = parcelRequire("8nFt2");

var $dzoWS = parcelRequire("dzoWS");

var $jgdMW = parcelRequire("jgdMW");

var $9KOR3 = parcelRequire("9KOR3");
function $fb55312c1434003b$var$useWhyBitbucketLinks() {
    return {
        features: {
            id: 'solution',
            title: (0, $fnHPc.defineMessage)({
                id: 'bitbucketnav.subnav.whybitbucket.links.solution',
                defaultMessage: 'Solution'
            }),
            items: [
                {
                    id: 'ci-cd',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'bitbucketnav.subnav.whybitbucket.links.work-management',
                        defaultMessage: 'CI/CD'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/bitbucket/features/pipelines')
                },
                {
                    id: 'cloud-security',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'bitbucketnav.subnav.whybitbucket.links.cloud-security',
                        defaultMessage: 'Cloud Security'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/bitbucket/features/cloud-security')
                },
                {
                    id: 'dev-sec-ops',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'bitbucketnav.subnav.whybitbucket.links.dev-sec-ops',
                        defaultMessage: 'DevSecOps'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/bitbucket/features/devsecops')
                },
                {
                    id: 'code-review',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'bitbucketnav.subnav.whybitbucket.links.it-service-management',
                        defaultMessage: 'Code Review'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/bitbucket/features/code-review')
                },
                {
                    id: 'jira-integrations',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'bitbucketnav.subnav.whybitbucket.links.agile-devops',
                        defaultMessage: 'Jira Integrations'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/jira/bitbucket-integration')
                }
            ]
        },
        plans: {
            id: 'plans',
            title: (0, $fnHPc.defineMessage)({
                id: 'bitbucketnav.subnav.whybitbucket.links.plans',
                defaultMessage: 'Plans'
            }),
            items: [
                {
                    id: 'bitbucket-cloud-premium',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'bitbucketnav.subnav.whybitbucket.links.bitbucket-cloud-premium',
                        defaultMessage: 'Bitbucket Cloud Premium'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/bitbucket/premium')
                }
            ]
        }
    };
}
const $fb55312c1434003b$export$2c78ab5135d18215 = ({ productKey: productKey = 'bitbucket' })=>{
    const intl = (0, $8e22h.default)();
    const bitbucketLinks = $fb55312c1434003b$var$useWhyBitbucketLinks();
    const linkColumns = Object.values(bitbucketLinks);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.DivOnHoverExit), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8nFt2.MotionContainer), {
                direction: "up",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_bfhkg7ng"
                    ]),
                    style: {
                        "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgdMW.RowGrid), {
                        numCols: 2,
                        columnGap: "var(--ds-space-500, 40px)",
                        paddingBlock: "var(--ds-space-500, 40px)",
                        paddingInline: "var(--ds-space-500, 40px)",
                        children: linkColumns.map((column)=>{
                            return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $dzoWS.GlobalNavDropdownLinkColumn), {
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_1p1dangw _syaz1pfd _1wyboqnp _ect4z4z1 _k48p1fw0 _vwz41j6v"
                                        ]),
                                        style: {
                                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                                        },
                                        children: intl.formatMessage(column.title)
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c11p5 _2z0510ma"
                                        ]),
                                        children: column.items.map((link)=>{
                                            return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_bpsp1nn1 _19tboxwj _43ds1pfd _qfs11r31 _s41oglyw _1k6pnqa1 _1cay1pfd _oavvftjs _oxk4ftjs _1e0c1txw _4cvrh9n0"
                                                ]),
                                                style: {
                                                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                                    "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800'))
                                                },
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                                    type: "anchor",
                                                    href: link.href,
                                                    text: intl.formatMessage(link.text),
                                                    ariaLabel: intl.formatMessage(link.text),
                                                    dataEventProps: {
                                                        'data-event': 'clicked',
                                                        'data-event-component': 'linkButton',
                                                        'data-event-container': 'globalNavSubnav',
                                                        'data-product-key': productKey
                                                    }
                                                })
                                            }, link.id);
                                        })
                                    })
                                ]
                            }, column.id);
                        })
                    })
                })
            })
        })
    });
};

});


parcelRegister("5S2vX", function(module, exports) {
$parcel$export(module.exports, "useParentScrollTracking", function () { return $d703c208f3e9c795$export$164ddb76b909974a; });
$parcel$export(module.exports, "ParentScrollTracking", function () { return $d703c208f3e9c795$export$248f1dfc9396e7e4; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $je135 = parcelRequire("je135");
const $d703c208f3e9c795$var$ScrollTrackingContext = /*#__PURE__*/ (0, $1oC0p.createContext)({
    pageId: 'wac-web',
    scrollTrackingEnabled: true
});
const $d703c208f3e9c795$export$164ddb76b909974a = ()=>{
    return (0, $1oC0p.useContext)($d703c208f3e9c795$var$ScrollTrackingContext);
};
const $d703c208f3e9c795$export$248f1dfc9396e7e4 = (props)=>{
    const parentContext = $d703c208f3e9c795$export$164ddb76b909974a();
    const arrayChildren = (0, $1oC0p.Children).toArray(props.children);
    const definedName = (child)=>{
        if (/*#__PURE__*/ (0, $1oC0p.isValidElement)(child) && child.type) {
            // Use a type assertion to tell TypeScript that the type has a displayName
            const namedComponent = child.type;
            return namedComponent.displayName;
        } else return undefined;
    };
    // Determine tracking of parent undefined means true
    const parentTrackScrolling = parentContext.scrollTrackingEnabled === undefined ? true : parentContext.scrollTrackingEnabled;
    // Parent should take precedence if parent tracking is disabled
    const trackScrolling = parentTrackScrolling && (props.scrollTrackingEnabled === undefined ? true : props.scrollTrackingEnabled);
    const pageId = props.pageId ?? parentContext.pageId;
    return /*#__PURE__*/ (0, $7VQPk.jsx)($d703c208f3e9c795$var$ScrollTrackingContext.Provider, {
        value: {
            pageId: pageId,
            scrollTrackingEnabled: trackScrolling
        },
        children: (0, $1oC0p.Children).map(arrayChildren, (child, index)=>{
            const name = definedName(child);
            return name ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $je135.ScrollTracking), {
                index: `${index}/${arrayChildren.length}`,
                section: name,
                as: props.as,
                children: child
            }, index) : child;
        })
    });
};

});
parcelRegister("je135", function(module, exports) {
$parcel$export(module.exports, "useScrollTracking", function () { return $0fbf1a9bc3d0315b$export$17700584f55fbc70; });
$parcel$export(module.exports, "ScrollTracking", function () { return $0fbf1a9bc3d0315b$export$1725757b7947b890; });
$parcel$export(module.exports, "withScrollTracking", function () { return $0fbf1a9bc3d0315b$export$391633ede08dabb1; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $jKShK = parcelRequire("jKShK");

var $eY3N6 = parcelRequire("eY3N6");

var $5S2vX = parcelRequire("5S2vX");

var $iSeHD = parcelRequire("iSeHD");
const $0fbf1a9bc3d0315b$export$17700584f55fbc70 = (section, props = {})=>{
    const { index: index, observerOptions: observerOptions, dwellTimeEnabled: dwellTimeEnabled, additionalAttributes: additionalAttributes } = props;
    const hasFunctionBeenCalled = (0, $1oC0p.useRef)(false);
    const scrollPercentage = (0, $1oC0p.useRef)(0);
    const { pageId: pageId, scrollTrackingEnabled: scrollTrackingEnabled } = (0, $5S2vX.useParentScrollTracking)();
    const { ref: ref, inView: inView, entry: entry } = (0, $jKShK.useInView)({
        threshold: 0.5,
        triggerOnce: true,
        ...observerOptions,
        skip: observerOptions?.skip || !scrollTrackingEnabled
    });
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleScroll = ()=>{
        const windowHeight = window.innerHeight;
        const fullHeight = document.documentElement.scrollHeight;
        const currentPosition = window.scrollY;
        scrollPercentage.current = Math.round(currentPosition / (fullHeight - windowHeight) * 100);
    };
    (0, $1oC0p.useEffect)(()=>{
        if (inView && !hasFunctionBeenCalled.current && section) {
            handleScroll();
            const scrollTrackAnalyticsPayload = {
                eventType: 'ui',
                action: 'scrolledTo',
                actionSubject: 'section',
                source: window.location.pathname,
                attributes: {
                    section: section,
                    scrollPercentage: scrollPercentage.current,
                    pageChildIndex: index,
                    pageId: pageId,
                    ...additionalAttributes
                }
            };
            const dwellTimeTrackAnalyticsPayload = {
                eventType: 'ui',
                action: 'dwellTimeTracked',
                actionSubject: 'section',
                source: window.location.pathname,
                attributes: {
                    section: section,
                    scrollPercentage: scrollPercentage.current,
                    pageChildIndex: index,
                    pageId: pageId,
                    ...additionalAttributes
                }
            };
            if (analyticsClient) {
                createAnalyticsEvent({
                    ...scrollTrackAnalyticsPayload
                }).fire();
                hasFunctionBeenCalled.current = true;
            }
            if (dwellTimeEnabled) {
                const activityEvents = [
                    'mousemove',
                    'keydown',
                    'scroll',
                    'touchstart'
                ];
                let intervalId = undefined;
                let activityTimeout = undefined;
                let active = true;
                // stop tracking after 1 minute of inactivity
                const setActive = ()=>{
                    active = true;
                    clearTimeout(activityTimeout);
                    activityTimeout = setTimeout(()=>{
                        active = false;
                    }, 60000);
                };
                activityEvents.forEach((evt)=>{
                    window.addEventListener(evt, setActive);
                });
                // emmit every 5 seconds if the user is active
                intervalId = setInterval(()=>{
                    if (active) {
                        handleScroll();
                        createAnalyticsEvent({
                            ...dwellTimeTrackAnalyticsPayload
                        }).fire();
                    } else {
                        clearInterval(intervalId);
                        clearTimeout(activityTimeout);
                        activityEvents.forEach((evt)=>{
                            window.removeEventListener(evt, setActive);
                        });
                    }
                }, 5000);
            }
        }
    }, [
        additionalAttributes,
        analyticsClient,
        createAnalyticsEvent,
        dwellTimeEnabled,
        hasFunctionBeenCalled,
        inView,
        index,
        pageId,
        section
    ]);
    return {
        ref: ref,
        inView: inView,
        entry: entry
    };
};
const $0fbf1a9bc3d0315b$export$1725757b7947b890 = ({ section: section, index: index, observerOptions: observerOptions, children: children, as: RootElement = 'div' })=>{
    const { ref: ref } = $0fbf1a9bc3d0315b$export$17700584f55fbc70(section, {
        index: index,
        observerOptions: observerOptions
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)(RootElement, {
        ref: ref,
        children: children
    });
};
function $0fbf1a9bc3d0315b$export$391633ede08dabb1(section, InnerComponent, options) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (props)=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)($0fbf1a9bc3d0315b$export$1725757b7947b890, {
            section: section,
            ...options,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)(InnerComponent, {
                ...props
            })
        });
    };
}

});


parcelRegister("7Rs16", function(module, exports) {
$parcel$export(module.exports, "BitbucketPriceFinder", function () { return $cd0a3f920b6b151d$export$3f1971038752fd47; });

var $7VQPk = parcelRequire("7VQPk");

var $fnHPc = parcelRequire("fnHPc");

var $hCc2m = parcelRequire("hCc2m");

var $g9ZvA = parcelRequire("g9ZvA");

var $gIRO7 = parcelRequire("gIRO7");

var $eYlij = parcelRequire("eYlij");

var $dl2JF = parcelRequire("dl2JF");
const $cd0a3f920b6b151d$export$3f1971038752fd47 = (props)=>{
    const content = {
        free: (0, $dl2JF.usePricingPlanComparison)('Free'),
        standard: (0, $dl2JF.usePricingPlanComparison)('Standard'),
        premium: (0, $dl2JF.usePricingPlanComparison)('Premium')
    };
    const bitbucketProductPlans = [
        {
            planName: content.free?.planTitleExternal ?? 'Free',
            description: content.free?.planOneLiner ?? '',
            recommendationLimit: 0,
            signupLimit: 35000,
            signupURLSuffix: '?bundle=bitbucket&edition=free',
            planFeatureMessages: []
        },
        {
            planName: content.standard?.planTitleExternal ?? 'Standard',
            description: content.standard?.planOneLiner ?? '',
            recommendationLimit: 5,
            signupLimit: 35000,
            signupURLSuffix: '?bundle=bitbucket&edition=standard',
            planFeatureMessages: []
        },
        {
            planName: content.premium?.planTitleExternal ?? 'Premium',
            description: content.premium?.planOneLiner ?? '',
            recommendationLimit: 100,
            signupLimit: 35000,
            signupURLSuffix: '?bundle=bitbucket&edition=premium',
            planFeatureMessages: []
        }
    ];
    const messages = (0, $fnHPc.defineMessages)({
        unitCountInputText: {
            id: 'BitbucketSoftwarePricingPage.priceFinder.unitCountInputText',
            defaultMessage: 'How many users are on your team?'
        },
        unitCountInputTextRedesign: {
            id: 'BitbucketSoftwarePricingPage.priceFinder.unitCountInputTextRedesign',
            defaultMessage: 'Team size:'
        },
        unitCountInputTerm: {
            id: 'BitbucketSoftwarePricingPage.priceFinder.unitCountInputTerm',
            defaultMessage: 'users'
        },
        billingCycleText: {
            id: 'BitbucketSoftwarePricingPage.priceFinder.billingCycleText',
            defaultMessage: 'Billing cycle:'
        },
        unitCountInputTooltip: {
            id: 'BitbucketSoftwarePricingPage.priceFinder.unitCountInputTooltip',
            defaultMessage: 'A Bitbucket Software user is any user who can log in to Bitbucket Software, and who exists in User Management'
        },
        monthlyExampleHelpText: {
            id: 'BitbucketSoftwarePricingPage.priceFinder.monthlyExampleHelpText',
            defaultMessage: 'Monthly plans give you flexibility as your number of active users changes, so pay for seats as you use them. Remember that the number of seats may change the total price.'
        },
        annualExampleHelpText: {
            id: 'BitbucketSoftwarePricingPage.priceFinder.annualExampleHelpText',
            defaultMessage: 'Annual plans give you flexibility and help you prepare for growth. Buy a group of seats at a flat rate now, then fill your empty seats through the year at no extra cost.'
        },
        exampleStandardPlan: {
            id: 'BitbucketSoftwarePricingPage.priceFinder.exampleStandardPlan',
            defaultMessage: 'Pricing for {unitCount} users on Standard plan',
            description: 'Standard is a plan name and should not be translated'
        },
        cardOverSignupLimit: {
            id: 'BitbucketSoftwarePricingPage.priceFinder.cardOverSignupLimit',
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: 'BitbucketSoftwarePricingPage.priceFinder.cardEnterpriseMinimumCount',
            defaultMessage: 'Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above',
            description: 'Enterprise is a plan name and should not be translated'
        },
        cardUnitCountTierRange: {
            id: 'BitbucketSoftwarePricingPage.priceFinder.cardUnitCountTierRange',
            defaultMessage: 'User tier: {lowerLimit} - {upperLimit}'
        },
        cardMonthlyPerUnitCount: {
            id: 'BitbucketSoftwarePricingPageTeam24.priceFinder.cardMonthlyPerUnitCount',
            defaultMessage: 'per user / month'
        },
        cardFreeDescription: {
            id: 'BitbucketSoftwarePricingPage.priceFinder.cardFreeDescription',
            defaultMessage: 'Always free for 10 users'
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hCc2m.default), {
        interactionName: 'bitbucket-price-finder',
        fallback: (0, $g9ZvA.LoadingSpinner),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eYlij.PriceFinderContextProvider), {
            dataProductKey: "bitbucket",
            productPlans: bitbucketProductPlans,
            defaultUnitCount: 5,
            isMonthlyBillingOnly: true,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gIRO7.default), {
                messages: messages,
                hamsProductKey: "com.atlassian.bitbucket.manual",
                ...props
            })
        })
    });
};
$cd0a3f920b6b151d$export$3f1971038752fd47.displayName = 'BitbucketPriceFinderSection';

});
parcelRegister("gIRO7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8b32bb2e3a52fb0a$export$2e2bcd8739ae039; });
/* price-finder.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $dkcYJ = parcelRequire("dkcYJ");

var $g9ZvA = parcelRequire("g9ZvA");

var $eYlij = parcelRequire("eYlij");

var $hu3Tl = parcelRequire("hu3Tl");

var $hrGO1 = parcelRequire("hrGO1");

var $daYeb = parcelRequire("daYeb");

var $4XErw = parcelRequire("4XErw");

var $3F38X = parcelRequire("3F38X");

var $1RK9J = parcelRequire("1RK9J");

var $7t0tI = parcelRequire("7t0tI");
const $8b32bb2e3a52fb0a$export$2b19a4f5a8b03e05 = ({ hamsProductKey: hamsProductKey = '', signupURL: signupURL = (0, $hrGO1.SIGNUP_CTA_URL), ccpPricingData: ccpPricingData, hamsPricingData: hamsPricingData, countryCode: countryCode = (0, $hrGO1.DEFAULT_COUNTRY_ISO_CODE), localeISOCode: localeISOCode = 'en-US', messages: messages })=>{
    const { productPlans: productPlans, defaultUnitCount: defaultUnitCount, enterpriseMinimumCount: enterpriseMinimumCount = (0, $hrGO1.DefaultPlanLimits).UNIT_MIN_ENTERPRISE, contactURL: contactURL = (0, $hrGO1.CONTACT_CTA_URL) } = (0, $eYlij.usePriceFinderContext)();
    const currencyISOCode = (0, $hu3Tl.COUNTRY_CODE_TO_CURRENCY)[countryCode] || (0, $hrGO1.DEFAULT_CURRENCY_ISO_CODE);
    const initialFetchPriceCalcs = (0, $1RK9J.usePriceFinderRequests)(hamsProductKey, productPlans, enterpriseMinimumCount, defaultUnitCount, 'MONTHLY');
    const initialPriceCalcs = (0, $1RK9J.usePricing)(ccpPricingData, hamsPricingData, initialFetchPriceCalcs, currencyISOCode, localeISOCode);
    const initialState = {
        unitCount: defaultUnitCount,
        billingCycle: 'MONTHLY',
        priceCalcs: initialPriceCalcs,
        currencyISOCode: currencyISOCode,
        messages: messages
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3F38X.PriceFinderContainer), {
        ...initialState,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1bsb1osq"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4XErw.PriceFinderInputsRedesign), {}),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $daYeb.PriceCardsContainer), {
                    productKey: hamsProductKey,
                    signupURL: signupURL,
                    contactURL: contactURL,
                    hamsProductKey: hamsProductKey,
                    hamsPricingData: hamsPricingData,
                    ccpPricingData: ccpPricingData,
                    localeISOCode: localeISOCode
                })
            ]
        })
    });
};
const $8b32bb2e3a52fb0a$var$PriceFinderWithFetch = ({ envSource: envSource, hamsProductKey: hamsProductKey = '', messages: messages, contentfulEnvironment: contentfulEnvironment })=>{
    const { dataProductKey: dataProductKey, productPlans: productPlans } = (0, $eYlij.usePriceFinderContext)();
    const offeringSkus = productPlans.map((plan)=>{
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return plan.offeringSku;
    }).filter(Boolean);
    const { prices: prices, status: status, fetchData: fetchData } = (0, $dkcYJ.useCCPPriceFinderData)(offeringSkus, envSource['PRODUCT_CATALOG_DELIVERY_KEY'], envSource['PRODUCT_CATALOG_SPACE'], contentfulEnvironment);
    (0, $1oC0p.useEffect)(()=>{
        fetchData();
    }, []);
    const { prices: hamsPrices, status: hamsStatus } = (0, $dkcYJ.useHAMSPriceData)(hamsProductKey, envSource['PRODUCT_CATALOG_DELIVERY_KEY'], envSource['PRODUCT_CATALOG_SPACE'], contentfulEnvironment);
    const { countryCode: countryCode, status: locationStatus } = (0, $hu3Tl.useGeoLocation)(envSource['PRODUCT_CATALOG_LOCATION_BASE_URL']);
    let forceCountryCode = countryCode;
    if (dataProductKey === 'bitbucket') forceCountryCode = (0, $hrGO1.DEFAULT_COUNTRY_ISO_CODE);
    if (locationStatus == 'complete' && status == 'complete' && hamsStatus == 'complete' && prices && hamsPrices && forceCountryCode) return /*#__PURE__*/ (0, $7VQPk.jsx)($8b32bb2e3a52fb0a$export$2b19a4f5a8b03e05, {
        ccpPricingData: prices,
        hamsPricingData: hamsPrices,
        hamsProductKey: hamsProductKey,
        messages: messages,
        countryCode: forceCountryCode
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _4t3i5o3v _4cvr1h6o"
        ]),
        children: (0, $g9ZvA.LoadingSpinner)
    });
};
const $8b32bb2e3a52fb0a$var$PriceFinderSection = ({ hamsProductKey: hamsProductKey, serverSideCCPPricing: serverSideCCPPricing, serverSideHAMSPricing: serverSideHAMSPricing, countryCode: countryCode, messages: messages, contentfulEnvironment: contentfulEnvironment })=>{
    if (serverSideCCPPricing && serverSideHAMSPricing && countryCode) return /*#__PURE__*/ (0, $7VQPk.jsx)($8b32bb2e3a52fb0a$export$2b19a4f5a8b03e05, {
        ccpPricingData: serverSideCCPPricing,
        hamsPricingData: serverSideHAMSPricing,
        hamsProductKey: hamsProductKey,
        countryCode: countryCode,
        messages: messages
    });
    // server-side request failed
    if (typeof window !== 'undefined') // client side render
    return /*#__PURE__*/ (0, $7VQPk.jsx)($8b32bb2e3a52fb0a$var$PriceFinderWithFetch, {
        hamsProductKey: hamsProductKey,
        messages: messages,
        envSource: window,
        contentfulEnvironment: contentfulEnvironment
    });
    // server side render
    return /*#__PURE__*/ (0, $7VQPk.jsx)($8b32bb2e3a52fb0a$var$PriceFinderWithFetch, {
        hamsProductKey: hamsProductKey,
        envSource: $7t0tI.env,
        messages: messages,
        contentfulEnvironment: contentfulEnvironment
    });
};
var $8b32bb2e3a52fb0a$export$2e2bcd8739ae039 = $8b32bb2e3a52fb0a$var$PriceFinderSection;

});
parcelRegister("eYlij", function(module, exports) {
$parcel$export(module.exports, "usePriceFinderContext", function () { return $d1b3d524711863c2$export$179afbf02f71f9f; });
$parcel$export(module.exports, "PriceFinderContextProvider", function () { return $d1b3d524711863c2$export$520d8e05995e73b; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
const $d1b3d524711863c2$var$PriceFinderContext = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
const $d1b3d524711863c2$export$179afbf02f71f9f = ()=>{
    const context = (0, $1oC0p.useContext)($d1b3d524711863c2$var$PriceFinderContext);
    if (!context) throw new Error('usePriceFinderContext must be used within a PriceFinderContextProvider');
    return context;
};
const $d1b3d524711863c2$export$520d8e05995e73b = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)($d1b3d524711863c2$var$PriceFinderContext.Provider, {
        value: props,
        children: props.children
    });
};

});

parcelRegister("daYeb", function(module, exports) {
$parcel$export(module.exports, "PriceCardsContainer", function () { return $beb84d554eee0045$export$631362d6f0b0bcb9; });
/* card-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $luVdE = parcelRequire("luVdE");

var $dl2JF = parcelRequire("dl2JF");

var $jQ0cd = parcelRequire("jQ0cd");

var $hrGO1 = parcelRequire("hrGO1");

var $eYlij = parcelRequire("eYlij");

var $3F38X = parcelRequire("3F38X");

var $1RK9J = parcelRequire("1RK9J");

var $l4Rl8 = parcelRequire("l4Rl8");

var $f1eZF = parcelRequire("f1eZF");
const $beb84d554eee0045$export$6d3386d43155b5be = {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: '1',
    justifyContent: 'center',
    lineHeight: '24px'
};
const $beb84d554eee0045$export$631362d6f0b0bcb9 = ({ productKey: productKey, signupURL: signupURL, contactURL: contactURL, hamsProductKey: hamsProductKey, hamsPricingData: hamsPricingData, ccpPricingData: ccpPricingData, localeISOCode: localeISOCode })=>{
    const intl = (0, $8e22h.default)();
    let forcedUsdPricing = undefined;
    const { dataProductKey: dataProductKey, productPlans: productPlans, enterpriseMinimumCount: enterpriseMinimumCount = (0, $hrGO1.DefaultPlanLimits).UNIT_MIN_ENTERPRISE } = (0, $eYlij.usePriceFinderContext)();
    const [{ unitCount: unitCount, billingCycle: billingCycle, currencyISOCode: currencyISOCode }, actions] = (0, $3F38X.usePriceFinderStore)();
    const recommendedPlanName = $beb84d554eee0045$export$623a082ce2e33ce1(unitCount, productPlans);
    const fetchPriceCalcs = (0, $1RK9J.usePriceFinderRequests)(hamsProductKey, productPlans, enterpriseMinimumCount, unitCount, billingCycle);
    if (dataProductKey === 'trello') forcedUsdPricing = 'USD';
    const finalPriceCalcs = (0, $1RK9J.usePricing)(ccpPricingData, hamsPricingData, fetchPriceCalcs, forcedUsdPricing || currencyISOCode, localeISOCode);
    (0, $1oC0p.useEffect)(()=>{
        actions.updatePriceCalcs(finalPriceCalcs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        unitCount,
        billingCycle,
        currencyISOCode
    ]);
    const localizedSignupURL = (0, $jQ0cd.useLocalizedHref)(signupURL);
    const localizedContactURL = (0, $jQ0cd.useLocalizedHref)(contactURL);
    const ctaButtonText = intl.formatMessage({
        id: 'Pricing.PriceCard.StartFreeTrial',
        defaultMessage: (0, $hrGO1.CtaBtnText).START_FREE_TRIAL
    });
    const getProductPlanProps = (params)=>({
            idx: params.idx,
            productPlan: params.productPlan,
            dataProductKey: dataProductKey,
            recommendedPlanName: recommendedPlanName,
            unitCount: unitCount,
            ctaButtonText: ctaButtonText,
            localizedSignupURL: localizedSignupURL,
            localizedContactURL: localizedContactURL,
            billingCycle: billingCycle,
            currencyISOCode: currencyISOCode,
            productKey: productKey
        });
    const hasFeatures = productPlans[0]?.planFeatureMessages?.length;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $luVdE.PriceCardsStack), {
            sections: hasFeatures ? 2 : 1,
            children: productPlans.map((productPlan, idx)=>/*#__PURE__*/ (0, $7VQPk.jsx)($beb84d554eee0045$var$ProductPlanPriceCard, {
                    ...getProductPlanProps({
                        idx: idx,
                        productPlan: productPlan
                    })
                }, productPlan.planName))
        })
    });
};
// eslint-disable-next-line complexity
const $beb84d554eee0045$var$ProductPlanPriceCard = (props)=>{
    const intl = (0, $8e22h.default)();
    const contactSalesText = intl.formatMessage({
        id: 'Pricing.PriceCard.ContactSales',
        defaultMessage: (0, $hrGO1.CtaBtnText).CONTACT_SALES
    });
    const { productPlan: productPlan, idx: idx, dataProductKey: dataProductKey, recommendedPlanName: recommendedPlanName, unitCount: unitCount, ctaButtonText: ctaButtonText, localizedSignupURL: localizedSignupURL, localizedContactURL: localizedContactURL, billingCycle: billingCycle, currencyISOCode: currencyISOCode, productKey: productKey } = props;
    const { productPlans: productPlans, shouldAddDiscount: shouldAddDiscount, ctaUrlSource: ctaUrlSource } = (0, $eYlij.usePriceFinderContext)();
    const getComparePlanCta = (0, $dl2JF.useGetComparePlanCta)();
    const { signupURLSuffix: signupURLSuffix, planFeatureMessages: planFeatureMessages, description: description, signupLimit: signupLimit, offeringSku: offeringSku } = productPlan;
    const { planTitleComponent: planTitleComponent } = productPlan;
    let { planName: planName } = productPlan;
    let edition = offeringSku?.toLowerCase().match(/free|standard|premium|enterprise/)?.[0];
    const isHighlighted = planName === recommendedPlanName || productPlans.length === 1;
    let dataEventPropsLabel = `${planName}-start-trial`;
    let ctaBtnText = ctaButtonText;
    let ctaBtnUrl = '';
    let rovoStartTrialUrl = '';
    const localizedUrlPath = (0, $jQ0cd.useLocalizedHref)(productPlan.signupURLInfo?.urlPath ?? '');
    if (productPlan.signupURLInfo) {
        const { shouldLocalize: shouldLocalize, urlDomain: urlDomain, urlPath: urlPath } = productPlan.signupURLInfo;
        if (shouldLocalize) {
            ctaBtnUrl = `${urlDomain}${localizedUrlPath}`;
            rovoStartTrialUrl = `${urlDomain}${localizedUrlPath}`;
        } else {
            ctaBtnUrl = `${urlDomain}${urlPath}`;
            rovoStartTrialUrl = `${urlDomain}${urlPath}`;
        }
    } else ctaBtnUrl = localizedSignupURL + (signupURLSuffix || '');
    const overSignupLimit = unitCount > (signupLimit || (0, $hrGO1.DefaultPlanLimits).UNIT_LIMIT);
    if (offeringSku === (0, $hrGO1.CloudOfferingsWithSkus).rovo || dataProductKey === 'rovo') {
        planName = 'Rovo';
        if (unitCount > 1000) {
            ctaBtnUrl = localizedContactURL;
            ctaBtnText = contactSalesText;
        }
    }
    const pricingPlanId = '';
    if (dataProductKey === 'trello') ctaBtnUrl = (0, $hrGO1.TRELLO_CTA_URL);
    switch(planName){
        case (0, $hrGO1.SpecialPlanNames).STARTER:
        case (0, $hrGO1.SpecialPlanNames).FREE:
            edition = (0, $hrGO1.Edition).FREE;
            dataEventPropsLabel = `${planName}-get-it-now`;
            ctaBtnText = intl.formatMessage({
                id: 'Pricing.PriceCard.GetItNow',
                defaultMessage: (0, $hrGO1.CtaBtnText).GET_IT_NOW
            });
            break;
        case (0, $hrGO1.SpecialPlanNames).ENTERPRISE:
            edition = (0, $hrGO1.Edition).ENTERPRISE;
            dataEventPropsLabel = `${planName}-contact-sales`;
            ctaBtnText = contactSalesText;
            ctaBtnUrl = productPlan.signupURLInfo ? ctaBtnUrl : localizedContactURL;
            break;
    }
    const shouldDisableCta = overSignupLimit && planName !== (0, $hrGO1.SpecialPlanNames).FREE && planName !== (0, $hrGO1.SpecialPlanNames).ENTERPRISE;
    const planTitleId = `planTitle_${idx}`;
    const planDescriptionId = `planDesc_${idx}`;
    const ctaId = `planCta_${idx}`;
    const ctaAriaLabelledBy = `${planTitleId} ${planDescriptionId} ${ctaId}`;
    const contentfulCta = getComparePlanCta({
        comparePlanIdx: idx
    });
    const localizedContentfulCtaUrl = (0, $jQ0cd.useLocalizedHref)(contentfulCta?.ctaUrl ?? '');
    let ctaButtonUrl = ctaBtnUrl;
    if (contentfulCta?.ctaUrl && ctaUrlSource !== 'productPlans') ctaButtonUrl = localizedContentfulCtaUrl;
    const urlWithSignupSource = new URL(ctaButtonUrl, window.location.origin);
    urlWithSignupSource.searchParams.set('signupSource', 'pricing');
    ctaButtonUrl = urlWithSignupSource.toString();
    let ctaButton = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l4Rl8.CtaButton), {
        id: ctaId,
        edition: edition,
        dataProductKey: dataProductKey,
        type: isHighlighted ? 'primary' : 'secondary',
        text: contentfulCta?.ctaButtonText ?? ctaBtnText,
        dataEventPropsLabel: dataEventPropsLabel,
        url: ctaButtonUrl,
        isDisabled: shouldDisableCta,
        containerId: (0, $hrGO1.PRICE_FINDER_CONTAINER),
        "aria-labelledby": ctaAriaLabelledBy
    });
    if (offeringSku === (0, $hrGO1.CloudOfferingsWithSkus).rovo && unitCount > 1000) ctaButton = /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "rovo-double-cta",
        className: (0, $2jatx.default)([
            "_1e0c1txw _zulp14y2"
        ]),
        children: [
            ctaButton,
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l4Rl8.CtaButton), {
                id: ctaId,
                edition: edition,
                dataProductKey: dataProductKey,
                type: 'secondary',
                text: ctaButtonText,
                dataEventPropsLabel: dataEventPropsLabel,
                url: rovoStartTrialUrl,
                isDisabled: overSignupLimit,
                target: "_self",
                "aria-labelledby": ctaAriaLabelledBy,
                containerId: (0, $hrGO1.PRICE_FINDER_CONTAINER)
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f1eZF.PriceCard), {
        planName: planName,
        planTitleComponent: planTitleComponent,
        description: description,
        highlighted: isHighlighted,
        ctaButton: ctaButton,
        planFeatureMessages: planFeatureMessages,
        adjacentLowerTierPlanName: productPlans[idx - 1]?.planName,
        first: idx === 0,
        last: idx === productPlans.length - 1,
        billingCycle: billingCycle,
        overSignupLimit: overSignupLimit,
        currencyISOCode: currencyISOCode,
        unitCount: unitCount,
        productKey: productKey,
        priceCalcIdx: idx,
        contactURL: localizedContactURL,
        offeringSku: offeringSku,
        enableRecommendation: productPlans.length > 1,
        shouldAddDiscount: shouldAddDiscount,
        pricingPlanId: pricingPlanId,
        edition: edition,
        dataProductKey: dataProductKey
    }, idx);
};
const $beb84d554eee0045$var$getRecommendedPlanIdx = (unitCount, minUnitCounts)=>{
    const len = minUnitCounts.length - 1;
    return len - minUnitCounts.reverse().findIndex((minUnitCount)=>unitCount > minUnitCount);
};
const $beb84d554eee0045$export$623a082ce2e33ce1 = (unitCount, productPlans)=>{
    const recommendedPlanIdx = $beb84d554eee0045$var$getRecommendedPlanIdx(unitCount, productPlans.map((productPlan)=>productPlan.recommendationLimit));
    return productPlans[recommendedPlanIdx]?.planName ?? '';
};

});
parcelRegister("luVdE", function(module, exports) {
$parcel$export(module.exports, "PriceCardsStack", function () { return $60c6fc47d6443243$export$4379d187fb91b2c6; });
$parcel$export(module.exports, "useIsInsideCardStack", function () { return $60c6fc47d6443243$export$41df4605c6d99494; });
/* price-cards-stack.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $4HVo5 = parcelRequire("4HVo5");
const $60c6fc47d6443243$export$4379d187fb91b2c6 = (props)=>{
    const { sections: sectionsCount = (0, $4HVo5.DEFAULT_SECTIONS_COUNT) } = props;
    const cardsCount = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Children.count(props.children);
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Children.map(props.children, (child, index)=>{
        const childElement = child;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).cloneElement(childElement, {
            first: index === 0,
            last: index === cardsCount - 1
        });
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)($60c6fc47d6443243$var$PriceCardStackContext.Provider, {
        value: {
            isInsideCardStack: true
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1e0c11p5 _wij21bp4 _1bsb1ns9 _glte1ns9 _1mjb1txw _na0i1bp4 _1s4p1osq",
                "_2z051xin _yv0e1iwh"
            ]),
            style: {
                "--_1u0qyx2": (0, $6ZVlx.default)(sectionsCount),
                "--_uofz2v": (0, $6ZVlx.default)(cardsCount)
            },
            children: children
        })
    });
};
const $60c6fc47d6443243$var$priceCardsStackCss = null;
const $60c6fc47d6443243$var$PriceCardStackContext = /*#__PURE__*/ (0, $1oC0p.createContext)({
    isInsideCardStack: false
});
const $60c6fc47d6443243$export$41df4605c6d99494 = ()=>{
    return (0, $1oC0p.useContext)($60c6fc47d6443243$var$PriceCardStackContext);
};

});
parcelRegister("4HVo5", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_SECTIONS_COUNT", function () { return $0d9e6c5b89c5e20f$export$366b07c70d10dc4d; });
const $0d9e6c5b89c5e20f$export$366b07c70d10dc4d = 2;

});


parcelRegister("3F38X", function(module, exports) {
$parcel$export(module.exports, "PriceFinderContainer", function () { return $ca9b5fbc269af845$export$d217816b05791954; });
$parcel$export(module.exports, "usePriceFinderStore", function () { return $ca9b5fbc269af845$export$f4b6caeda40bfc57; });

var $6FQb9 = parcelRequire("6FQb9");
var $cVxfO = parcelRequire("cVxfO");
var $dv8pz = parcelRequire("dv8pz");

var $g2S82 = parcelRequire("g2S82");
const $ca9b5fbc269af845$export$d4c72bab9d6cc13a = {
    unitCount: 0,
    billingCycle: 'MONTHLY',
    priceCalcs: [],
    currencyISOCode: 'USD',
    messages: {
        // These messages always be overridden by the consumer on init
        unitCountInputText: {},
        unitCountInputTooltip: {},
        cardOverSignupLimit: {},
        cardEnterpriseMinimumCount: {},
        cardUnitCountTierRange: {},
        cardMonthlyPerUnitCount: {},
        cardFreeDescription: {}
    }
};
const $ca9b5fbc269af845$export$d217816b05791954 = (0, $6FQb9.createContainer)();
const $ca9b5fbc269af845$var$store = (0, $dv8pz.createStore)({
    containedBy: $ca9b5fbc269af845$export$d217816b05791954,
    name: 'price-finder',
    initialState: $ca9b5fbc269af845$export$d4c72bab9d6cc13a,
    actions: $g2S82,
    handlers: {
        onInit: ()=>({ setState: setState }, state)=>{
                setState({
                    ...state
                });
            }
    }
});
const $ca9b5fbc269af845$export$f4b6caeda40bfc57 = (0, $cVxfO.createHook)($ca9b5fbc269af845$var$store);

});
parcelRegister("6FQb9", function(module, exports) {
$parcel$export(module.exports, "createContainer", function () { return $4dbf0c115974ff4b$export$26ae5ca175b4ec5a; });

var $1oC0p = parcelRequire("1oC0p");

var $4OgEb = parcelRequire("4OgEb");

var $djHSy = parcelRequire("djHSy");

var $19KTt = parcelRequire("19KTt");
var $iLhGt = parcelRequire("iLhGt");

var $iEBLg = parcelRequire("iEBLg");
const $4dbf0c115974ff4b$var$_excluded = [
    "children"
], $4dbf0c115974ff4b$var$_excluded2 = [
    "scope",
    "isGlobal"
];
function $4dbf0c115974ff4b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $4dbf0c115974ff4b$var$noop = ()=>()=>{};
function $4dbf0c115974ff4b$export$26ae5ca175b4ec5a(StoreOrOptions, _temp) {
    if (StoreOrOptions === void 0) StoreOrOptions = {};
    let { onInit: _onInit = $4dbf0c115974ff4b$var$noop, onUpdate: onUpdate = $4dbf0c115974ff4b$var$noop, onCleanup: onCleanup = $4dbf0c115974ff4b$var$noop, displayName: displayName = '' } = _temp === void 0 ? {} : _temp;
    if ('key' in StoreOrOptions) {
        const Store = StoreOrOptions;
        const dn = displayName || `Container(${Store.key.split('__')[0]})`;
        return $4dbf0c115974ff4b$var$createFunctionContainer({
            displayName: dn,
            // compat fields
            override: {
                Store: Store,
                handlers: Object.assign({}, _onInit !== $4dbf0c115974ff4b$var$noop && {
                    onInit: ()=>_onInit()
                }, onCleanup !== $4dbf0c115974ff4b$var$noop && {
                    onDestroy: ()=>onCleanup()
                }, onUpdate !== $4dbf0c115974ff4b$var$noop && {
                    onContainerUpdate: ()=>onUpdate()
                })
            }
        });
    }
    return $4dbf0c115974ff4b$var$createFunctionContainer(StoreOrOptions);
}
function $4dbf0c115974ff4b$var$useRegistry(scope, isGlobal, _ref) {
    let { globalRegistry: globalRegistry } = _ref;
    return (0, $1oC0p.useMemo)(()=>{
        const isLocal = !scope && !isGlobal;
        return isLocal ? new (0, $iLhGt.StoreRegistry)('__local__') : globalRegistry;
    }, [
        scope,
        isGlobal,
        globalRegistry
    ]);
}
function $4dbf0c115974ff4b$var$useContainedStore(scope, registry, propsRef, check, override) {
    // Store contained scopes in a map, but throwing it away on scope change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const containedStores = (0, $1oC0p.useMemo)(()=>new Map(), [
        scope
    ]);
    const getContainedStore = (0, $1oC0p.useCallback)((Store)=>{
        let containedStore = containedStores.get(Store); // first time it gets called we add store to contained map bound
        // so we can provide props to actions (only triggered by children)
        if (!containedStore) {
            const isExisting = registry.hasStore(Store, scope);
            const config = {
                props: ()=>propsRef.current.sub,
                contained: check
            };
            const { storeState: storeState } = registry.getStore(Store, scope, config);
            const actions = (0, $19KTt.bindActions)(Store.actions, storeState, config);
            const handlers = (0, $19KTt.bindActions)(Object.assign({}, Store.handlers, override == null ? void 0 : override.handlers), storeState, config, actions);
            containedStore = {
                storeState: storeState,
                actions: actions,
                handlers: handlers,
                unsubscribe: undefined
            };
            containedStores.set(Store, containedStore); // Signal store is contained and ready now, so by the time
            // consumers subscribe we already have updated the store (if needed).
            // Also if override maintain legacy behaviour, triggered on every mount
            if (!isExisting || override) handlers.onInit == null || handlers.onInit();
        }
        return containedStore;
    }, [
        containedStores,
        scope,
        registry,
        propsRef,
        check,
        override
    ]);
    return [
        containedStores,
        getContainedStore
    ];
}
function $4dbf0c115974ff4b$var$useApi(check, getContainedStore, _ref2) {
    let { globalRegistry: globalRegistry, retrieveStore: retrieveStore } = _ref2;
    const retrieveRef = (0, $1oC0p.useRef)();
    retrieveRef.current = (Store)=>check(Store) ? getContainedStore(Store) : retrieveStore(Store); // This api is "frozen", as changing it will trigger re-render across all consumers
    // so we link retrieveStore dynamically and manually call notify() on scope change
    return (0, $1oC0p.useMemo)(()=>({
            globalRegistry: globalRegistry,
            retrieveStore: (s)=>retrieveRef.current(s)
        }), [
        globalRegistry
    ]);
}
function $4dbf0c115974ff4b$var$createFunctionContainer(_temp2) {
    let { displayName: displayName, override: override } = _temp2 === void 0 ? {} : _temp2;
    const check = (store)=>override ? store === override.Store : store.containedBy === FunctionContainer;
    function FunctionContainer(props) {
        const { children: children } = props, restProps = $4dbf0c115974ff4b$var$_objectWithoutPropertiesLoose(props, $4dbf0c115974ff4b$var$_excluded);
        const { scope: scope, isGlobal: isGlobal } = restProps, subProps = $4dbf0c115974ff4b$var$_objectWithoutPropertiesLoose(restProps, $4dbf0c115974ff4b$var$_excluded2);
        const ctx = (0, $1oC0p.useContext)((0, $djHSy.Context));
        const registry = $4dbf0c115974ff4b$var$useRegistry(scope, isGlobal, ctx); // Store props in a ref to avoid re-binding actions when they change and re-rendering all
        // consumers unnecessarily. The update is handled by an effect on the component instead
        const propsRef = (0, $1oC0p.useRef)({
            prev: null,
            next: restProps,
            sub: subProps
        });
        propsRef.current = {
            prev: propsRef.current.next,
            next: restProps,
            sub: subProps // TODO remove on next major
        };
        const [containedStores, getContainedStore] = $4dbf0c115974ff4b$var$useContainedStore(scope, registry, propsRef, check, override); // Use a stable object as is passed as value to context Provider
        const api = $4dbf0c115974ff4b$var$useApi(check, getContainedStore, ctx); // This listens for custom props change, and so we trigger container update actions
        // before the re-render gets to consumers (hence why side effect on render).
        // We do not use React hooks because num of restProps might change and react will throws
        if (!(0, $iEBLg.default)(propsRef.current.next, propsRef.current.prev)) containedStores.forEach((_ref3)=>{
            let { handlers: handlers } = _ref3;
            handlers.onContainerUpdate == null || handlers.onContainerUpdate(propsRef.current.next, propsRef.current.prev);
        });
         // Every time we add/remove a contained store, we ensure we are subscribed to the updates
        // as an effect to properly handle strict mode
        (0, $1oC0p.useEffect)(()=>{
            containedStores.forEach((containedStore)=>{
                if (!containedStore.unsubscribe) {
                    const unsub = containedStore.storeState.subscribe(()=>containedStore.handlers.onUpdate == null ? void 0 : containedStore.handlers.onUpdate());
                    containedStore.unsubscribe = ()=>{
                        unsub();
                        containedStore.unsubscribe = undefined;
                    };
                }
            });
        }, [
            containedStores,
            containedStores.size
        ]); // We support renderding "bootstrap" containers without children with override API
        // so in this case we call getCS to initialize the store globally asap
        if (override && !containedStores.size && (scope || isGlobal)) getContainedStore(override.Store);
         // This listens for scope change or component unmount, to notify all consumers
        // so all work is done on cleanup
        (0, $1oC0p.useEffect)(()=>{
            return ()=>{
                containedStores.forEach((_ref4, Store)=>{
                    let { storeState: storeState, handlers: handlers, unsubscribe: unsubscribe } = _ref4;
                    // Detatch container from subscription
                    unsubscribe == null || unsubscribe(); // Trigger a forced update on all subscribers as we opted out from context
                    // Some might have already re-rendered naturally, but we "force update" all anyway.
                    // This is sub-optimal as if there are other containers with the same
                    // old scope id we will re-render those too, but still better than context
                    storeState.notify(); // Given unsubscription is handled by useSyncExternalStore, we have no control on when
                    // React decides to do it. So we schedule on next tick to run last
                    Promise.resolve().then(()=>{
                        var _registry$getStore;
                        if (!storeState.listeners().size && // ensure registry has not already created a new store with same scope
                        storeState === ((_registry$getStore = registry.getStore(Store, scope, null)) == null ? void 0 : _registry$getStore.storeState)) {
                            handlers.onDestroy == null || handlers.onDestroy(); // We only delete scoped stores, as global shall persist and local are auto-deleted
                            if (!isGlobal) registry.deleteStore(Store, scope);
                        }
                    });
                }); // no need to reset containedStores as the map is already bound to scope
            };
        }, [
            registry,
            scope,
            isGlobal,
            containedStores
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $djHSy.Context).Provider, {
            value: api
        }, children);
    }
    FunctionContainer.displayName = displayName || `Container`;
    FunctionContainer.propTypes = {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).node,
        scope: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).string,
        isGlobal: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).bool
    };
    return FunctionContainer;
}

});
parcelRegister("djHSy", function(module, exports) {
$parcel$export(module.exports, "Context", function () { return $9b1f1627d56ad4e6$export$841858b892ce1f4c; });

var $1oC0p = parcelRequire("1oC0p");

var $iLhGt = parcelRequire("iLhGt");
const $9b1f1627d56ad4e6$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createContext({
    globalRegistry: (0, $iLhGt.defaultRegistry),
    retrieveStore: (Store)=>(0, $iLhGt.defaultRegistry).getStore(Store)
}, ()=>0);

});
parcelRegister("iLhGt", function(module, exports) {
$parcel$export(module.exports, "StoreRegistry", function () { return $da8a557b4bf7f386$export$acb47f32da33501e; });
$parcel$export(module.exports, "defaultRegistry", function () { return $da8a557b4bf7f386$export$9d726ae4880b1060; });

var $5SdS7 = parcelRequire("5SdS7");

var $19KTt = parcelRequire("19KTt");

var $4h8Lm = parcelRequire("4h8Lm");
const $da8a557b4bf7f386$export$e4d628ba0054221b = '__global__';
class $da8a557b4bf7f386$export$acb47f32da33501e {
    constructor(defaultScope){
        var _this = this;
        if (defaultScope === void 0) defaultScope = $da8a557b4bf7f386$export$e4d628ba0054221b;
        this.stores = new Map();
        this.initStore = (key, Store, config)=>{
            const { initialState: initialState, actions: actions } = Store;
            if (Store.containedBy && !config.contained(Store)) {
                const err = new Error(`Store ${Store.key} should be contained by a container but it is used globally. ` + `While it might still work, it will likely cause unexpected behaviours.`);
                if ((0, $5SdS7.default).scheduling()) Promise.reject(err);
                else throw err;
            }
            const storeState = (0, $4h8Lm.default)(key, initialState);
            let boundActions;
            const store = {
                storeState: storeState,
                // these are used only when container-less, so we generate them on-demand
                get actions () {
                    if (!boundActions) boundActions = (0, $19KTt.bindActions)(actions, storeState, config);
                    return boundActions;
                }
            };
            this.stores.set(key, store);
            return store;
        };
        this.hasStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.has(key);
        };
        this.getStore = function(Store, scopeId, config) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            if (config === void 0) config = {
                props: ()=>({}),
                contained: ()=>false
            };
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.get(key) || config && _this.initStore(key, Store, config);
        };
        this.deleteStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            _this.stores.delete(key);
        };
        this.generateKey = (Store, scopeId)=>`${Store.key}@${scopeId}`;
        this.defaultScope = defaultScope;
    }
}
const $da8a557b4bf7f386$export$9d726ae4880b1060 = new $da8a557b4bf7f386$export$acb47f32da33501e();

});
parcelRegister("5SdS7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $446cc194a1624a36$export$2e2bcd8739ae039; });
const $446cc194a1624a36$var$supports = {
    scheduling () {
        return typeof window !== 'undefined' && typeof MessageChannel === 'function';
    }
};
var $446cc194a1624a36$export$2e2bcd8739ae039 = $446cc194a1624a36$var$supports;

});

parcelRegister("19KTt", function(module, exports) {
$parcel$export(module.exports, "bindActions", function () { return $0d7b01ce9c6a9ee9$export$5ee1d46cd0883a22; });

var $7EDZa = parcelRequire("7EDZa");
const $0d7b01ce9c6a9ee9$var$namedMutator = (storeState, actionName)=>function() {
        storeState.mutator.actionName = actionName;
        return storeState.mutator(...arguments);
    };
const $0d7b01ce9c6a9ee9$var$warnings = new WeakMap();
const $0d7b01ce9c6a9ee9$export$5f944353e69b9bf3 = (storeState, actionFn, actionKey, config, actions)=>{
    const callThunk = (instance, thunkFn, actionName)=>thunkFn({
            setState: (0, $7EDZa.default).devtools ? $0d7b01ce9c6a9ee9$var$namedMutator(instance.storeState, actionName) : instance.storeState.mutator,
            getState: instance.storeState.getState,
            get actions () {
                if (!$0d7b01ce9c6a9ee9$var$warnings.has(actionFn)) $0d7b01ce9c6a9ee9$var$warnings.set(actionFn, console.warn(`react-sweet-state 'actions' property has been deprecated and will be removed in the next mayor. ` + `Please check action '${actionName}' of Store '${instance.storeState.key}' and use 'dispatch' instead`));
                return actions;
            },
            dispatch: (tFn)=>callThunk(instance, tFn, `${actionName}.dispatch`)
        }, config.props());
    return function() {
        return callThunk({
            storeState: storeState,
            actions: actions
        }, actionFn(...arguments), actionKey);
    };
};
const $0d7b01ce9c6a9ee9$export$5ee1d46cd0883a22 = function bindActions(actions, storeState, config, boundActions) {
    if (boundActions === void 0) boundActions = null;
    return Object.keys(actions).reduce((acc, k)=>{
        acc[k] = $0d7b01ce9c6a9ee9$export$5f944353e69b9bf3(storeState, actions[k], k, config, boundActions || acc);
        return acc;
    }, {});
};

});
parcelRegister("7EDZa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $592b492760646f40$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
const $592b492760646f40$var$defaultMutator = (prevState, partialState)=>{
    // Merge the partial state and the previous state.
    return Object.assign({}, prevState, partialState);
};
const $592b492760646f40$var$defaults = {
    batchUpdates: 'useSyncExternalStore' in (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))),
    devtools: false,
    middlewares: new Set(),
    mutator: $592b492760646f40$var$defaultMutator
};
var $592b492760646f40$export$2e2bcd8739ae039 = $592b492760646f40$var$defaults;

});


parcelRegister("4h8Lm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $31cf8c17d087a0dd$export$2e2bcd8739ae039; });

var $l7oft = parcelRequire("l7oft");

var $iltul = parcelRequire("iltul");

var $7EDZa = parcelRequire("7EDZa");

var $beVz1 = parcelRequire("beVz1");
function $31cf8c17d087a0dd$var$createStoreState(key, initialState) {
    let listeners = new Set();
    let currentState = initialState;
    const storeState = {
        key: key,
        getState () {
            return currentState;
        },
        setState (nextState) {
            currentState = nextState; // Instead of notifying all handlers immediately, we wait next tick
            // so multiple actions affecting the same store gets combined
            (0, $beVz1.default)(storeState.notify);
        },
        resetState () {
            storeState.setState(initialState);
        },
        notify () {
            for (const listener of listeners)listener(storeState.getState());
        },
        subscribe (listener) {
            listeners.add(listener);
            return function unsubscribe() {
                listeners.delete(listener);
            };
        },
        listeners () {
            return listeners;
        }
    };
    storeState.mutator = (0, $l7oft.default)(storeState, (0, $7EDZa.default).middlewares);
    return storeState;
}
var $31cf8c17d087a0dd$export$2e2bcd8739ae039 = (0, $iltul.default)($31cf8c17d087a0dd$var$createStoreState);

});
parcelRegister("l7oft", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f5fd0fb4f3f37e08$export$2e2bcd8739ae039; });

var $7EDZa = parcelRequire("7EDZa");

var $8p4Wo = parcelRequire("8p4Wo");
const $f5fd0fb4f3f37e08$var$applyMiddleware = (storeState, middlewares)=>Array.from(middlewares).concat((0, $8p4Wo.default)).reduceRight((next, mw)=>mw(storeState)(next), (0, $7EDZa.default).mutator);
var $f5fd0fb4f3f37e08$export$2e2bcd8739ae039 = $f5fd0fb4f3f37e08$var$applyMiddleware;

});
parcelRegister("8p4Wo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $61e47da7d6a27804$export$2e2bcd8739ae039; });

var $iEBLg = parcelRequire("iEBLg");
const $61e47da7d6a27804$var$updateMiddleware = (storeState)=>(next)=>(arg)=>{
            let output;
            const state = storeState.getState();
            const nextState = next(state, arg, (out)=>{
                output = out;
            });
            if (!(0, $iEBLg.default)(nextState, state)) storeState.setState(nextState);
            return output;
        };
var $61e47da7d6a27804$export$2e2bcd8739ae039 = $61e47da7d6a27804$var$updateMiddleware;

});
parcelRegister("iEBLg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d9494103866cad1b$export$2e2bcd8739ae039; });
// Mostly copied from fbjs/packages/fbjs/src/core/shallowEqual.js
// enhanced with keys cache as might get called multiple times with same args
const $d9494103866cad1b$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $d9494103866cad1b$var$CACHE = new WeakMap();
function $d9494103866cad1b$export$2e2bcd8739ae039(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    if (Array.isArray(objA) && Array.isArray(objB)) {
        // do array comparison
        if (objA.length !== objB.length) return false;
        for(let i = 0; i < objA.length; i++){
            if (objA[i] !== objB[i]) return false;
        }
        return true;
    } else {
        // Handle Date, RegExp, String, Number, ... and complex objects
        const strA = '' + objA;
        const strB = '' + objB;
        if (strA !== strB || strA[0] === '[' && strA !== '[object Object]') return false;
         // do object comparison
        let keysA;
        if ($d9494103866cad1b$var$CACHE.has(objA)) keysA = $d9494103866cad1b$var$CACHE.get(objA);
        else {
            keysA = Object.keys(objA);
            $d9494103866cad1b$var$CACHE.set(objA, keysA);
        }
        let keysB;
        if ($d9494103866cad1b$var$CACHE.has(objB)) keysB = $d9494103866cad1b$var$CACHE.get(objB);
        else {
            keysB = Object.keys(objB);
            $d9494103866cad1b$var$CACHE.set(objB, keysB);
        }
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(let i = 0; i < keysA.length; i++){
            if (!$d9494103866cad1b$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
        }
        return true;
    }
}

});



parcelRegister("iltul", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d5b10ff816f52ca9$export$2e2bcd8739ae039; });

var $7EDZa = parcelRequire("7EDZa");
const $d5b10ff816f52ca9$var$connectDevTools = (storeState, config)=>{
    const devTools = window.__REDUX_DEVTOOLS_EXTENSION__.connect(Object.assign({
        name: `Store ${storeState.key}`,
        serialize: true,
        trace: true
    }, config));
    devTools.init(storeState.getState());
    devTools.subscribe((message)=>{
        if (message.type === 'DISPATCH') switch(message.payload.type){
            case 'RESET':
                storeState.resetState();
                devTools.init(storeState.getState());
                return;
            case 'COMMIT':
                devTools.init(storeState.getState());
                return;
            case 'ROLLBACK':
                storeState.setState(JSON.parse(message.state));
                devTools.init(storeState.getState());
                return;
            case 'JUMP_TO_STATE':
            case 'JUMP_TO_ACTION':
                storeState.setState(JSON.parse(message.state));
                return;
        }
        else if (message.type === 'ACTION') {
            let action = JSON.parse(message.payload);
            storeState.setState(action.payload);
        }
    });
    return devTools;
};
const $d5b10ff816f52ca9$var$withDevtools = (createStoreState)=>function() {
        const storeState = createStoreState(...arguments);
        if ((0, $7EDZa.default).devtools && window && window.__REDUX_DEVTOOLS_EXTENSION__) {
            const origMutator = storeState.mutator;
            let devTools;
            const devtoolMutator = (arg)=>{
                const result = origMutator(arg);
                try {
                    if (!devTools) {
                        const config = typeof (0, $7EDZa.default).devtools === 'function' ? (0, $7EDZa.default).devtools(storeState) : {};
                        devTools = $d5b10ff816f52ca9$var$connectDevTools(storeState, config);
                    }
                    devTools.send({
                        type: storeState.mutator.actionName,
                        payload: arg
                    }, storeState.getState(), {}, storeState.key);
                } catch (err) {
                /* ignore devtools errors */ }
                return result;
            };
            storeState.mutator = devtoolMutator;
        }
        return storeState;
    };
var $d5b10ff816f52ca9$export$2e2bcd8739ae039 = $d5b10ff816f52ca9$var$withDevtools;

});

parcelRegister("beVz1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $82eda785b72bac58$export$2e2bcd8739ae039; });

var $7EDZa = parcelRequire("7EDZa");

var $9PrlP = parcelRequire("9PrlP");

var $5SdS7 = parcelRequire("5SdS7");
const $82eda785b72bac58$var$QUEUE = [];
let $82eda785b72bac58$var$scheduled;
function $82eda785b72bac58$export$2e2bcd8739ae039(fn) {
    // if we are in node/tests or feature disabled, make updates sync batched
    if (!(0, $7EDZa.default).batchUpdates || !(0, $5SdS7.default).scheduling()) return (0, $9PrlP.batch)(()=>fn()); // Add to queue if not already there
    // so we avoid multiple notifications to same store listeners
    if (!$82eda785b72bac58$var$QUEUE.includes(fn)) $82eda785b72bac58$var$QUEUE.push(fn); // if something already started schedule, skip
    if ($82eda785b72bac58$var$scheduled) return;
    $82eda785b72bac58$var$scheduled = (0, $9PrlP.batch)(()=>{
        let queueFn;
        while(queueFn = $82eda785b72bac58$var$QUEUE.shift())queueFn();
        $82eda785b72bac58$var$scheduled = null;
    });
}

});
parcelRegister("9PrlP", function(module, exports) {
$parcel$export(module.exports, "batch", function () { return $727e17d26f80e91e$export$712ea50be43a7858; });
/* eslint-disable import/no-unresolved */ 
var $gUjjH = parcelRequire("gUjjH");

var $jEVVm = parcelRequire("jEVVm");

var $7EDZa = parcelRequire("7EDZa");

var $5SdS7 = parcelRequire("5SdS7");
let $727e17d26f80e91e$var$isInsideBatchedSchedule = false;
function $727e17d26f80e91e$export$712ea50be43a7858(fn) {
    // if we are in node/tests or nested schedule
    if (!(0, $7EDZa.default).batchUpdates || !(0, $5SdS7.default).scheduling() || $727e17d26f80e91e$var$isInsideBatchedSchedule) return (0, $gUjjH.unstable_batchedUpdates)(fn);
    $727e17d26f80e91e$var$isInsideBatchedSchedule = true; // Use ImmediatePriority as it has -1ms timeout
    // https://github.com/facebook/react/blob/main/packages/scheduler/src/forks/Scheduler.js#L65
    return (0, $jEVVm.unstable_scheduleCallback)((0, $jEVVm.unstable_ImmediatePriority), function scheduleBatchedUpdates() {
        (0, $gUjjH.unstable_batchedUpdates)(fn);
        $727e17d26f80e91e$var$isInsideBatchedSchedule = false;
    });
}

});
parcelRegister("jEVVm", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9BZqy"));

});
parcelRegister("9BZqy", function(module, exports) {
$parcel$export(module.exports, "unstable_now", function () { return $6ff737efae05bc89$export$c4744153514ff05d; }, function (v) { return $6ff737efae05bc89$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6ff737efae05bc89$export$3e506c1ccc9cc1a7; }, function (v) { return $6ff737efae05bc89$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6ff737efae05bc89$export$e26fe2ed2fa76875; }, function (v) { return $6ff737efae05bc89$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6ff737efae05bc89$export$502329bbf4b505b1; }, function (v) { return $6ff737efae05bc89$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6ff737efae05bc89$export$6e3807111c4874c4; }, function (v) { return $6ff737efae05bc89$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6ff737efae05bc89$export$c27134553091fb3a; }, function (v) { return $6ff737efae05bc89$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6ff737efae05bc89$export$33ee1acdc04fd2a2; }, function (v) { return $6ff737efae05bc89$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6ff737efae05bc89$export$b00a404bbd5edef2; }, function (v) { return $6ff737efae05bc89$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6ff737efae05bc89$export$d66a1c1c77bd778b; }, function (v) { return $6ff737efae05bc89$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6ff737efae05bc89$export$d3dfb8e4810cb555; }, function (v) { return $6ff737efae05bc89$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6ff737efae05bc89$export$72fdf0e06517287b; }, function (v) { return $6ff737efae05bc89$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6ff737efae05bc89$export$816d2913ae6b83b1; }, function (v) { return $6ff737efae05bc89$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6ff737efae05bc89$export$61bcfe829111a1d0; }, function (v) { return $6ff737efae05bc89$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6ff737efae05bc89$export$7ee8c9beb337bc3f; }, function (v) { return $6ff737efae05bc89$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6ff737efae05bc89$export$b5836b71941fa3ed; }, function (v) { return $6ff737efae05bc89$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6ff737efae05bc89$export$cf845f2c119da08a; }, function (v) { return $6ff737efae05bc89$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6ff737efae05bc89$export$c4744153514ff05d;
var $6ff737efae05bc89$export$3e506c1ccc9cc1a7;
var $6ff737efae05bc89$export$e26fe2ed2fa76875;
var $6ff737efae05bc89$export$502329bbf4b505b1;
var $6ff737efae05bc89$export$6e3807111c4874c4;
var $6ff737efae05bc89$export$c27134553091fb3a;
var $6ff737efae05bc89$export$33ee1acdc04fd2a2;
var $6ff737efae05bc89$export$b00a404bbd5edef2;
var $6ff737efae05bc89$export$d66a1c1c77bd778b;
var $6ff737efae05bc89$export$d3dfb8e4810cb555;
var $6ff737efae05bc89$export$72fdf0e06517287b;
var $6ff737efae05bc89$export$816d2913ae6b83b1;
var $6ff737efae05bc89$export$61bcfe829111a1d0;
var $6ff737efae05bc89$export$7ee8c9beb337bc3f;
var $6ff737efae05bc89$export$b5836b71941fa3ed;
var $6ff737efae05bc89$export$cf845f2c119da08a;
"use strict";
function $6ff737efae05bc89$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $6ff737efae05bc89$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $6ff737efae05bc89$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $6ff737efae05bc89$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $6ff737efae05bc89$var$compare(left, last)) rightIndex < length && 0 > $6ff737efae05bc89$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $6ff737efae05bc89$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $6ff737efae05bc89$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$6ff737efae05bc89$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6ff737efae05bc89$var$localPerformance = performance;
    $6ff737efae05bc89$export$c4744153514ff05d = function() {
        return $6ff737efae05bc89$var$localPerformance.now();
    };
} else {
    var $6ff737efae05bc89$var$localDate = Date, $6ff737efae05bc89$var$initialTime = $6ff737efae05bc89$var$localDate.now();
    $6ff737efae05bc89$export$c4744153514ff05d = function() {
        return $6ff737efae05bc89$var$localDate.now() - $6ff737efae05bc89$var$initialTime;
    };
}
var $6ff737efae05bc89$var$taskQueue = [], $6ff737efae05bc89$var$timerQueue = [], $6ff737efae05bc89$var$taskIdCounter = 1, $6ff737efae05bc89$var$currentTask = null, $6ff737efae05bc89$var$currentPriorityLevel = 3, $6ff737efae05bc89$var$isPerformingWork = !1, $6ff737efae05bc89$var$isHostCallbackScheduled = !1, $6ff737efae05bc89$var$isHostTimeoutScheduled = !1, $6ff737efae05bc89$var$needsPaint = !1, $6ff737efae05bc89$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $6ff737efae05bc89$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $6ff737efae05bc89$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $6ff737efae05bc89$var$advanceTimers(currentTime) {
    for(var timer = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$timerQueue); null !== timer;){
        if (null === timer.callback) $6ff737efae05bc89$var$pop($6ff737efae05bc89$var$timerQueue);
        else if (timer.startTime <= currentTime) $6ff737efae05bc89$var$pop($6ff737efae05bc89$var$timerQueue), timer.sortIndex = timer.expirationTime, $6ff737efae05bc89$var$push($6ff737efae05bc89$var$taskQueue, timer);
        else break;
        timer = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$timerQueue);
    }
}
function $6ff737efae05bc89$var$handleTimeout(currentTime) {
    $6ff737efae05bc89$var$isHostTimeoutScheduled = !1;
    $6ff737efae05bc89$var$advanceTimers(currentTime);
    if (!$6ff737efae05bc89$var$isHostCallbackScheduled) {
        if (null !== $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$taskQueue)) $6ff737efae05bc89$var$isHostCallbackScheduled = !0, $6ff737efae05bc89$var$isMessageLoopRunning || ($6ff737efae05bc89$var$isMessageLoopRunning = !0, $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$timerQueue);
            null !== firstTimer && $6ff737efae05bc89$var$requestHostTimeout($6ff737efae05bc89$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $6ff737efae05bc89$var$isMessageLoopRunning = !1, $6ff737efae05bc89$var$taskTimeoutID = -1, $6ff737efae05bc89$var$frameInterval = 5, $6ff737efae05bc89$var$startTime = -1;
function $6ff737efae05bc89$var$shouldYieldToHost() {
    return $6ff737efae05bc89$var$needsPaint ? !0 : $6ff737efae05bc89$export$c4744153514ff05d() - $6ff737efae05bc89$var$startTime < $6ff737efae05bc89$var$frameInterval ? !1 : !0;
}
function $6ff737efae05bc89$var$performWorkUntilDeadline() {
    $6ff737efae05bc89$var$needsPaint = !1;
    if ($6ff737efae05bc89$var$isMessageLoopRunning) {
        var currentTime = $6ff737efae05bc89$export$c4744153514ff05d();
        $6ff737efae05bc89$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $6ff737efae05bc89$var$isHostCallbackScheduled = !1;
                $6ff737efae05bc89$var$isHostTimeoutScheduled && ($6ff737efae05bc89$var$isHostTimeoutScheduled = !1, $6ff737efae05bc89$var$localClearTimeout($6ff737efae05bc89$var$taskTimeoutID), $6ff737efae05bc89$var$taskTimeoutID = -1);
                $6ff737efae05bc89$var$isPerformingWork = !0;
                var previousPriorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
                try {
                    b: {
                        $6ff737efae05bc89$var$advanceTimers(currentTime);
                        for($6ff737efae05bc89$var$currentTask = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$taskQueue); null !== $6ff737efae05bc89$var$currentTask && !($6ff737efae05bc89$var$currentTask.expirationTime > currentTime && $6ff737efae05bc89$var$shouldYieldToHost());){
                            var callback = $6ff737efae05bc89$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $6ff737efae05bc89$var$currentTask.callback = null;
                                $6ff737efae05bc89$var$currentPriorityLevel = $6ff737efae05bc89$var$currentTask.priorityLevel;
                                var continuationCallback = callback($6ff737efae05bc89$var$currentTask.expirationTime <= currentTime);
                                currentTime = $6ff737efae05bc89$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $6ff737efae05bc89$var$currentTask.callback = continuationCallback;
                                    $6ff737efae05bc89$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $6ff737efae05bc89$var$currentTask === $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$taskQueue) && $6ff737efae05bc89$var$pop($6ff737efae05bc89$var$taskQueue);
                                $6ff737efae05bc89$var$advanceTimers(currentTime);
                            } else $6ff737efae05bc89$var$pop($6ff737efae05bc89$var$taskQueue);
                            $6ff737efae05bc89$var$currentTask = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$taskQueue);
                        }
                        if (null !== $6ff737efae05bc89$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$timerQueue);
                            null !== firstTimer && $6ff737efae05bc89$var$requestHostTimeout($6ff737efae05bc89$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $6ff737efae05bc89$var$currentTask = null, $6ff737efae05bc89$var$currentPriorityLevel = previousPriorityLevel, $6ff737efae05bc89$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline() : $6ff737efae05bc89$var$isMessageLoopRunning = !1;
        }
    }
}
var $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $6ff737efae05bc89$var$localSetImmediate) $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline = function() {
    $6ff737efae05bc89$var$localSetImmediate($6ff737efae05bc89$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6ff737efae05bc89$var$channel = new MessageChannel(), $6ff737efae05bc89$var$port = $6ff737efae05bc89$var$channel.port2;
    $6ff737efae05bc89$var$channel.port1.onmessage = $6ff737efae05bc89$var$performWorkUntilDeadline;
    $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline = function() {
        $6ff737efae05bc89$var$port.postMessage(null);
    };
} else $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline = function() {
    $6ff737efae05bc89$var$localSetTimeout($6ff737efae05bc89$var$performWorkUntilDeadline, 0);
};
function $6ff737efae05bc89$var$requestHostTimeout(callback, ms) {
    $6ff737efae05bc89$var$taskTimeoutID = $6ff737efae05bc89$var$localSetTimeout(function() {
        callback($6ff737efae05bc89$export$c4744153514ff05d());
    }, ms);
}
$6ff737efae05bc89$export$3e506c1ccc9cc1a7 = 5;
$6ff737efae05bc89$export$e26fe2ed2fa76875 = 1;
$6ff737efae05bc89$export$502329bbf4b505b1 = 4;
$6ff737efae05bc89$export$6e3807111c4874c4 = 3;
$6ff737efae05bc89$export$c27134553091fb3a = null;
$6ff737efae05bc89$export$33ee1acdc04fd2a2 = 2;
$6ff737efae05bc89$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$6ff737efae05bc89$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6ff737efae05bc89$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$6ff737efae05bc89$export$d3dfb8e4810cb555 = function() {
    return $6ff737efae05bc89$var$currentPriorityLevel;
};
$6ff737efae05bc89$export$72fdf0e06517287b = function(eventHandler) {
    switch($6ff737efae05bc89$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
    $6ff737efae05bc89$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $6ff737efae05bc89$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$6ff737efae05bc89$export$816d2913ae6b83b1 = function() {
    $6ff737efae05bc89$var$needsPaint = !0;
};
$6ff737efae05bc89$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
    $6ff737efae05bc89$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $6ff737efae05bc89$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$6ff737efae05bc89$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $6ff737efae05bc89$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $6ff737efae05bc89$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $6ff737efae05bc89$var$push($6ff737efae05bc89$var$timerQueue, priorityLevel), null === $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$taskQueue) && priorityLevel === $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$timerQueue) && ($6ff737efae05bc89$var$isHostTimeoutScheduled ? ($6ff737efae05bc89$var$localClearTimeout($6ff737efae05bc89$var$taskTimeoutID), $6ff737efae05bc89$var$taskTimeoutID = -1) : $6ff737efae05bc89$var$isHostTimeoutScheduled = !0, $6ff737efae05bc89$var$requestHostTimeout($6ff737efae05bc89$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $6ff737efae05bc89$var$push($6ff737efae05bc89$var$taskQueue, priorityLevel), $6ff737efae05bc89$var$isHostCallbackScheduled || $6ff737efae05bc89$var$isPerformingWork || ($6ff737efae05bc89$var$isHostCallbackScheduled = !0, $6ff737efae05bc89$var$isMessageLoopRunning || ($6ff737efae05bc89$var$isMessageLoopRunning = !0, $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$6ff737efae05bc89$export$b5836b71941fa3ed = $6ff737efae05bc89$var$shouldYieldToHost;
$6ff737efae05bc89$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
        $6ff737efae05bc89$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $6ff737efae05bc89$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});








parcelRegister("cVxfO", function(module, exports) {
$parcel$export(module.exports, "createHook", function () { return $96949a7b8ed8e0eb$export$e7f733c8fc2b8a24; });
$parcel$export(module.exports, "createActionsHook", function () { return $96949a7b8ed8e0eb$export$7c643e1d6648e418; });
$parcel$export(module.exports, "createStateHook", function () { return $96949a7b8ed8e0eb$export$6e4e5611de132e85; });

var $1oC0p = parcelRequire("1oC0p");

var $ixLXc = parcelRequire("ixLXc");

var $djHSy = parcelRequire("djHSy");

var $82g7P = parcelRequire("82g7P");
const $96949a7b8ed8e0eb$var$EMPTY_SELECTOR = ()=>undefined;
const $96949a7b8ed8e0eb$var$DEFAULT_SELECTOR = (state)=>state;
function $96949a7b8ed8e0eb$export$e7f733c8fc2b8a24(Store, _temp) {
    let { selector: selector } = _temp === void 0 ? {} : _temp;
    return function useSweetState(propsArg) {
        const { retrieveStore: retrieveStore } = (0, $1oC0p.useContext)((0, $djHSy.Context));
        const { storeState: storeState, actions: actions } = retrieveStore(Store);
        const hasPropsArg = propsArg !== undefined;
        const propsArgRef = (0, $1oC0p.useRef)(propsArg);
        propsArgRef.current = propsArg;
        const stateSelector = (0, $1oC0p.useMemo)(()=>selector ? (0, $82g7P.getSelectorInstance)(selector, storeState, hasPropsArg) : selector === null ? $96949a7b8ed8e0eb$var$EMPTY_SELECTOR : $96949a7b8ed8e0eb$var$DEFAULT_SELECTOR, [
            hasPropsArg,
            storeState
        ]);
        const forceUpdate = (0, $1oC0p.useState)({})[1];
        const getSnapshot = (0, $1oC0p.useCallback)(()=>{
            // parent scope has changed and notify was explicitly triggered by the container
            // we need to force the hook to re-render to listen new storeState
            if (retrieveStore(Store).storeState !== storeState) forceUpdate({});
            const state = storeState.getState();
            return stateSelector(state, propsArgRef.current);
        }, [
            retrieveStore,
            storeState,
            stateSelector,
            forceUpdate
        ]);
        const currentState = (0, $ixLXc.useSyncExternalStore)(storeState.subscribe, getSnapshot, getSnapshot);
        return [
            currentState,
            actions
        ];
    };
}
function $96949a7b8ed8e0eb$export$7c643e1d6648e418(Store) {
    const useHook = $96949a7b8ed8e0eb$export$e7f733c8fc2b8a24(Store, {
        selector: null
    });
    return function useSweetStateActions() {
        return useHook()[1];
    };
}
function $96949a7b8ed8e0eb$export$6e4e5611de132e85(Store, _temp2) {
    let { selector: selector } = _temp2 === void 0 ? {} : _temp2;
    const useHook = $96949a7b8ed8e0eb$export$e7f733c8fc2b8a24(Store, {
        selector: selector
    });
    return function useSweetStateState(propsArg) {
        return useHook(propsArg)[0];
    };
}

});
parcelRegister("ixLXc", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3H9Cb"));

});
parcelRegister("3H9Cb", function(module, exports) {
$parcel$export(module.exports, "useSyncExternalStore", function () { return $2b0cd8895c4bf8a0$export$306c0aa65ff9ec16; }, function (v) { return $2b0cd8895c4bf8a0$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2b0cd8895c4bf8a0$export$306c0aa65ff9ec16;
"use strict";

var $1oC0p = parcelRequire("1oC0p");
function $2b0cd8895c4bf8a0$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $2b0cd8895c4bf8a0$var$objectIs = "function" === typeof Object.is ? Object.is : $2b0cd8895c4bf8a0$var$is, $2b0cd8895c4bf8a0$var$useState = $1oC0p.useState, $2b0cd8895c4bf8a0$var$useEffect = $1oC0p.useEffect, $2b0cd8895c4bf8a0$var$useLayoutEffect = $1oC0p.useLayoutEffect, $2b0cd8895c4bf8a0$var$useDebugValue = $1oC0p.useDebugValue;
function $2b0cd8895c4bf8a0$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $2b0cd8895c4bf8a0$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $2b0cd8895c4bf8a0$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $2b0cd8895c4bf8a0$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $2b0cd8895c4bf8a0$var$useEffect(function() {
        $2b0cd8895c4bf8a0$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $2b0cd8895c4bf8a0$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $2b0cd8895c4bf8a0$var$useDebugValue(value);
    return value;
}
function $2b0cd8895c4bf8a0$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$2b0cd8895c4bf8a0$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $2b0cd8895c4bf8a0$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $2b0cd8895c4bf8a0$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $2b0cd8895c4bf8a0$var$useSyncExternalStore$1 : $2b0cd8895c4bf8a0$var$useSyncExternalStore$2;
$2b0cd8895c4bf8a0$export$306c0aa65ff9ec16 = void 0 !== $1oC0p.useSyncExternalStore ? $1oC0p.useSyncExternalStore : $2b0cd8895c4bf8a0$var$shim;

});


parcelRegister("82g7P", function(module, exports) {
$parcel$export(module.exports, "createSelector", function () { return $5d9b04c7903768eb$export$595d22ed68ca2841; });
$parcel$export(module.exports, "getSelectorInstance", function () { return $5d9b04c7903768eb$export$38d24f3c60944dd5; });

var $lrKV1 = parcelRequire("lrKV1");
function $5d9b04c7903768eb$export$595d22ed68ca2841() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    const resultFunc = funcs.pop();
    const dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    const memoizedResultFunc = (0, $lrKV1.default)(function() {
        return resultFunc.apply(null, arguments);
    }); // this memoisation is optimised for 2 arguments (state, props)
    const selector = (0, $lrKV1.default)(function() {
        // calculate all dependencies results
        const params = [];
        for(let i = 0; i < dependencies.length; i++)params.push(dependencies[i].apply(null, arguments));
         // then call the final func with all them as arguments
        return memoizedResultFunc.apply(null, params);
    }, true); // expose so we can create per scope selectors
    // API compatible with reselect@^4
    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    return selector;
}
function $5d9b04c7903768eb$export$d2c200d79fc82f8c(selector) {
    const isReselector = typeof selector.resultFunc === 'function' && Array.isArray(selector.dependencies);
    const dependencies = isReselector ? selector.dependencies : [
        (s)=>s,
        (_, p)=>p
    ];
    const resultFunc = isReselector ? selector.resultFunc : selector;
    return $5d9b04c7903768eb$export$595d22ed68ca2841(dependencies, resultFunc);
}
const $5d9b04c7903768eb$var$cache = new WeakMap();
function $5d9b04c7903768eb$export$38d24f3c60944dd5(selector, storeState, hasProps) {
    if (!hasProps) {
        if (!$5d9b04c7903768eb$var$cache.has(storeState)) $5d9b04c7903768eb$var$cache.set(storeState, new WeakMap());
        const scopeSelectors = $5d9b04c7903768eb$var$cache.get(storeState);
        if (!scopeSelectors.has(selector)) scopeSelectors.set(selector, $5d9b04c7903768eb$export$d2c200d79fc82f8c(selector));
        return scopeSelectors.get(selector);
    }
    return $5d9b04c7903768eb$export$d2c200d79fc82f8c(selector);
}

});
parcelRegister("lrKV1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f9d083a877bb8b60$export$2e2bcd8739ae039; });

var $iEBLg = parcelRequire("iEBLg");
function $f9d083a877bb8b60$var$exactEqual(objA, objB) {
    return objA === objB;
}
function $f9d083a877bb8b60$var$areArgumentsEqual(propsMode, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false; // If propsMode and 2 arguments, means it is an input selector
    // and we check for shallow equality on 2nd one to optimise props
    if (propsMode && prev.length === 2) return prev[0] === next[0] && (0, $iEBLg.default)(prev[1], next[1]);
    for(let i = 0; i < prev.length; i++){
        if (!$f9d083a877bb8b60$var$exactEqual(prev[i], next[i])) return false;
    }
    return true;
}
function $f9d083a877bb8b60$export$2e2bcd8739ae039(resultFn, propsMode) {
    if (propsMode === void 0) propsMode = false;
    let lastArgs = [];
    let lastResult;
    let calledOnce = false;
    const result = function result() {
        if (calledOnce && $f9d083a877bb8b60$var$areArgumentsEqual(propsMode, arguments, lastArgs)) return lastResult;
        const nextResult = resultFn.apply(this, arguments);
        if (!propsMode && (0, $iEBLg.default)(nextResult, lastResult)) return lastResult;
        lastResult = nextResult;
        calledOnce = true;
        lastArgs = arguments;
        return lastResult;
    };
    return result;
}

});



parcelRegister("dv8pz", function(module, exports) {
$parcel$export(module.exports, "createStore", function () { return $9d44b1f8bf314c4a$export$f51a9068ac82ea43; });

var $ekT4F = parcelRequire("ekT4F");
function $9d44b1f8bf314c4a$var$createKey(initialState, actions, name) {
    const src = !name ? Object.keys(actions).reduce((acc, k)=>acc + actions[k].toString(), '') : '';
    return [
        name,
        (0, $ekT4F.default)(src + JSON.stringify(initialState))
    ].filter(Boolean).join('__');
}
function $9d44b1f8bf314c4a$export$f51a9068ac82ea43(_ref) {
    let { name: name = '', initialState: initialState, actions: actions, containedBy: containedBy, handlers: handlers = {} } = _ref;
    let key;
    return {
        get key () {
            // lazy evaluate key on first access
            return key || (key = $9d44b1f8bf314c4a$var$createKey(initialState, actions, name));
        },
        initialState: initialState,
        actions: actions,
        containedBy: containedBy,
        handlers: handlers
    };
}

});
parcelRegister("ekT4F", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a6fda7907ddc7134$export$2e2bcd8739ae039; });
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $a6fda7907ddc7134$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});


parcelRegister("g2S82", function(module, exports) {
$parcel$export(module.exports, "updateUnitCount", function () { return $281be3e92bc01f76$export$753383981d56a121; });
$parcel$export(module.exports, "updateBillingCycle", function () { return $281be3e92bc01f76$export$ea0e718cff6511cb; });
$parcel$export(module.exports, "updatePriceCalcs", function () { return $281be3e92bc01f76$export$55173bfd96ab1f01; });
$parcel$export(module.exports, "updateCurrencyISOCode", function () { return $281be3e92bc01f76$export$c376e0e2eb868782; });
const $281be3e92bc01f76$export$753383981d56a121 = (unitCount)=>({ setState: setState })=>{
        setState({
            unitCount: unitCount
        });
    };
const $281be3e92bc01f76$export$ea0e718cff6511cb = (billingCycle)=>({ setState: setState })=>{
        setState({
            billingCycle: billingCycle
        });
    };
const $281be3e92bc01f76$export$55173bfd96ab1f01 = (priceCalcs)=>({ setState: setState })=>{
        setState({
            priceCalcs: priceCalcs
        });
    };
const $281be3e92bc01f76$export$c376e0e2eb868782 = (currencyISOCode)=>({ setState: setState })=>{
        setState({
            currencyISOCode: currencyISOCode
        });
    };

});


parcelRegister("1RK9J", function(module, exports) {
$parcel$export(module.exports, "getFreePriceCalc", function () { return $9f9b50f36097439e$export$cb6f0dbb8c9b28d2; });
$parcel$export(module.exports, "usePriceFinderRequests", function () { return $9f9b50f36097439e$export$e1ef037d62746bfa; });
$parcel$export(module.exports, "usePricing", function () { return $9f9b50f36097439e$export$2bd1dff4b72a4894; });

var $1oC0p = parcelRequire("1oC0p");

var $hrGO1 = parcelRequire("hrGO1");

var $ieLA0 = parcelRequire("ieLA0");

var $69Lp1 = parcelRequire("69Lp1");

var $8dsKS = parcelRequire("8dsKS");
const $9f9b50f36097439e$export$cb6f0dbb8c9b28d2 = (currencyISOCode)=>{
    const zeroPrice = (0, $ieLA0.getFormattedPrice)(currencyISOCode, 0);
    return {
        totalPrice: 0,
        avgPerUnitPrice: 0,
        avgPerUnitPriceWithDiscount: 0,
        formattedTotalPrice: zeroPrice,
        formattedAvgPerUnitPrice: zeroPrice,
        formattedAvgPerUnitPriceWithDiscount: zeroPrice,
        formattedTotalPriceWithDiscount: zeroPrice,
        hasFlatRateFirstTier: true,
        breakdown: [
            {
                unitsInTier: 0,
                unitsAvailableInTier: 0,
                unitLimitLower: 0,
                unitLimitUpper: 0,
                totalPriceForTier: 0,
                avgPerUnitPriceForTier: 0
            }
        ],
        formattedBreakdown: [
            {
                formattedUnitsInTier: '0',
                formattedUnitsAvailableInTier: '0',
                formattedUnitLimitLower: '0',
                formattedUnitLimitUpper: '0',
                formattedTotalPriceForTier: zeroPrice,
                formattedAvgPerUnitPriceForTier: zeroPrice
            }
        ]
    };
};
const $9f9b50f36097439e$export$e1ef037d62746bfa = (productKey, productPlans, unitMinEnterprise, unitCount, billingCycle)=>{
    return (0, $1oC0p.useMemo)(()=>{
        const getNumUnits = (planName, signupUnitLimit)=>{
            let adjNumUnits = 0;
            // following scenarios do not have pricing and should send a zero unit count,
            // the zero pricing will not be displayed and is needed only to retain the
            // correct array order of the pricing requests/responses
            // Free plan has no pricing
            const isFree = planName === (0, $hrGO1.SpecialPlanNames).FREE;
            // Enterprise plans do not have monthly pricing
            const isMonthlyEnterprise = planName === (0, $hrGO1.SpecialPlanNames).ENTERPRISE && billingCycle === 'MONTHLY';
            // Enterprise plans have a minimum unit count
            const isUnmetUnitCountEnterprise = planName === (0, $hrGO1.SpecialPlanNames).ENTERPRISE && unitCount < unitMinEnterprise;
            const isOverSignupUnitLimit = unitCount > signupUnitLimit;
            if (![
                isFree,
                isMonthlyEnterprise,
                isUnmetUnitCountEnterprise,
                isOverSignupUnitLimit
            ].includes(true)) adjNumUnits = unitCount;
            // keep unit count to general maximum limit
            return Math.min(adjNumUnits, signupUnitLimit);
        };
        const planPriceReqs = productPlans.map(({ offeringSku: offeringSku, planName: planName, signupLimit: signupLimit })=>({
                ccpOfferingSKU: offeringSku,
                hamsProductKey: productKey + (planName === (0, $hrGO1.SpecialPlanNames).STANDARD ? '' : `.${planName.toLowerCase()}`),
                numUnits: getNumUnits(planName, signupLimit || (0, $hrGO1.DefaultPlanLimits).UNIT_LIMIT),
                period: billingCycle
            }));
        return planPriceReqs;
    }, [
        productPlans,
        productKey,
        billingCycle,
        unitCount,
        unitMinEnterprise
    ]);
};
const $9f9b50f36097439e$export$2bd1dff4b72a4894 = (ccpPricingData, hamsPricingData, getPriceRequests, currencyISOCode, localeISOCode)=>{
    const priceCalculations = [];
    for (const { ccpOfferingSKU: ccpOfferingSKU, hamsProductKey: hamsProductKey, numUnits: numUnits, period: period } of getPriceRequests)if (numUnits === 0) priceCalculations.push($9f9b50f36097439e$export$cb6f0dbb8c9b28d2(currencyISOCode));
    else {
        const pricingTiers = (0, $69Lp1.extractPricingTiersFromEntry)(ccpPricingData, hamsPricingData, period, currencyISOCode, ccpOfferingSKU, hamsProductKey);
        if (!pricingTiers) {
            console.log(`Pricing tiers not found for ${period}.`);
            priceCalculations.push($9f9b50f36097439e$export$cb6f0dbb8c9b28d2(currencyISOCode));
        } else priceCalculations.push((0, $8dsKS.calculatePrice)(numUnits, pricingTiers, currencyISOCode, period, localeISOCode));
    }
    return priceCalculations;
};

});
parcelRegister("ieLA0", function(module, exports) {
$parcel$export(module.exports, "getFormattedPrice", function () { return $db8d9502e3c15040$export$1b80ff309ec5fcb1; });
$parcel$export(module.exports, "getTwoDigitFormattedPrice", function () { return $db8d9502e3c15040$export$716b461c5fe22c57; });
$parcel$export(module.exports, "getFormattedUnitAmount", function () { return $db8d9502e3c15040$export$4f6f7f43804883a5; });
const $db8d9502e3c15040$export$93b318a4d10f1db1 = (value)=>{
    if (value !== null && value !== undefined && !Number.isNaN(value)) return Number.isInteger(+value) ? 0 : 2;
    else return 0;
};
const $db8d9502e3c15040$var$fmtCurrencyValue = (currencyISOCode, value, useTwoDigits)=>{
    const isJPY = currencyISOCode === 'JPY';
    const adjVal = isJPY ? Math.ceil(value || 0) : value;
    return new Intl.NumberFormat(isJPY ? 'ja-JP' : 'en-US', {
        style: 'currency',
        currency: currencyISOCode,
        // Note: JPY does not use decimals
        minimumFractionDigits: useTwoDigits && !isJPY ? 2 : $db8d9502e3c15040$export$93b318a4d10f1db1(adjVal),
        maximumFractionDigits: useTwoDigits && !isJPY ? 2 : $db8d9502e3c15040$export$93b318a4d10f1db1(adjVal)
    }).format(adjVal || 0);
};
const $db8d9502e3c15040$export$1b80ff309ec5fcb1 = (currencyISOCode, value)=>$db8d9502e3c15040$var$fmtCurrencyValue(currencyISOCode, value, false);
const $db8d9502e3c15040$export$716b461c5fe22c57 = (currencyISOCode, value)=>$db8d9502e3c15040$var$fmtCurrencyValue(currencyISOCode, value, true);
const $db8d9502e3c15040$export$4f6f7f43804883a5 = (localeISOCode, value)=>new Intl.NumberFormat(localeISOCode).format(value || 0);

});

parcelRegister("69Lp1", function(module, exports) {
$parcel$export(module.exports, "extractPricingTiersFromEntry", function () { return $eeff08f2d55148ea$export$99b3bd15b49bca3d; });

var $6AKYt = parcelRequire("6AKYt");
const $eeff08f2d55148ea$export$99b3bd15b49bca3d = (ccpOfferingsBySKU, hamsPricingPlansByKey, period, currencyISOCode, ccpOfferingSKU, hamsProductKey, getCcpTiers)=>{
    let pricingPlans;
    let pricingTiers;
    if (ccpOfferingSKU) {
        const offering = ccpOfferingsBySKU[ccpOfferingSKU];
        pricingPlans = offering?.defaultPricingPlans;
        if (!pricingPlans) {
            console.log(`Offering empty of pricing plan data for: ${ccpOfferingSKU}`);
            return undefined;
        }
        const convertedTiers = (0, $6AKYt.convertCCPPricingPlansToHAMS)(pricingPlans, currencyISOCode, getCcpTiers);
        if (period === 'MONTHLY' && convertedTiers.monthly) pricingTiers = convertedTiers.monthly.slice();
        else if (period === 'ANNUAL' && convertedTiers.annual) pricingTiers = convertedTiers.annual.slice();
        else {
            console.log(`Found neither monthly or annual pricing tiers for CCP Offering SKU: ${ccpOfferingSKU}`);
            return undefined;
        }
    } else {
        if (hamsProductKey === undefined) {
            console.log(`HAMS product key was undefined for price request!`);
            return undefined;
        }
        pricingPlans = hamsPricingPlansByKey[hamsProductKey];
        if (pricingPlans === undefined) {
            console.log(`No ${period} pricing plans found for HAMS product key: ${hamsProductKey}`);
            return undefined;
        }
        if (period === 'MONTHLY' && pricingPlans.monthly) pricingTiers = pricingPlans.monthly.slice();
        else if (period === 'ANNUAL' && pricingPlans.annual) pricingTiers = pricingPlans.annual.slice();
        else {
            console.log(`Found neither monthly or annual (period is ${period}) pricing tiers for HAMS product key: ${hamsProductKey}`);
            return undefined;
        }
    }
    return pricingTiers;
};

});
parcelRegister("6AKYt", function(module, exports) {
$parcel$export(module.exports, "convertCCPPricingPlansToHAMS", function () { return $ba494f9c4080e515$export$1fb00d50ed2ce89c; });

var $hrGO1 = parcelRequire("hrGO1");
// CCP Amounts are stored in cents - Note: JPY needs no conversion
const $ba494f9c4080e515$var$formatCentsToDollars = (value, currency)=>{
    if (currency === 'USD' && value) return value / 100;
    return value;
};
const $ba494f9c4080e515$var$convertCCPTiersToHAMS = (ccpTiers, chargeElement, currency)=>ccpTiers.map((ccpTier)=>{
        let pricingStrategy = (0, $hrGO1.PricingStrategy).MARGINAL_PER_UNIT;
        let unitPrice = ccpTier.unitAmount;
        if (ccpTier.flatAmount) {
            pricingStrategy = (0, $hrGO1.PricingStrategy).FIXED_COST;
            unitPrice = ccpTier.flatAmount;
        }
        return {
            starter: false,
            pricingStrategy: pricingStrategy,
            unitDescription: chargeElement,
            unitLimitLower: ccpTier.floor,
            unitLimitUpper: ccpTier.ceiling,
            prices: [
                {
                    currency: currency,
                    unitPrice: $ba494f9c4080e515$var$formatCentsToDollars(unitPrice, currency)
                }
            ]
        };
    });
const $ba494f9c4080e515$export$1fb00d50ed2ce89c = (pricingPlans, currencyISOCode, getCcpTiers)=>{
    const [monthlyCCP, annualCCP] = [
        'MONTH',
        'YEAR'
    ].map((primaryCycle)=>// Per CCP Team: We need to filter by COMMERCIAL, DEFAULT_PRICING
        pricingPlans.find((pricingPlan)=>pricingPlan.primaryCycle_interval === primaryCycle && pricingPlan.type === 'COMMERCIAL' && pricingPlan.activatedWithReason === 'DEFAULT_PRICING' && // We filter by currencyISOCode as we need both USD & JPY Pricing for Pricing Pages
            // If needed, can filter by USD only which we will pass in directly in those components
            pricingPlan.currency === currencyISOCode));
    const [monthly, annual] = [
        monthlyCCP,
        annualCCP
    ].map((ccpContent)=>{
        if (!ccpContent) return undefined;
        const ccpTiers = getCcpTiers ? getCcpTiers(ccpContent) : ccpContent.items[0];
        const { tiers: tiers, chargeElement: chargeElement } = ccpTiers;
        return $ba494f9c4080e515$var$convertCCPTiersToHAMS(tiers, chargeElement, ccpContent.currency);
    });
    return {
        monthly: monthly,
        annual: annual
    };
};

});


parcelRegister("8dsKS", function(module, exports) {
$parcel$export(module.exports, "calculatePrice", function () { return $9c8fafac440a889f$export$8f857d3e1dbdf9cf; });

var $hrGO1 = parcelRequire("hrGO1");

var $ieLA0 = parcelRequire("ieLA0");

var $cuq2S = parcelRequire("cuq2S");

var $fmcUV = parcelRequire("fmcUV");
const $9c8fafac440a889f$var$getTierIdxForNumUnits = (numUnits, tiers)=>tiers.findIndex(({ unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper })=>numUnits >= (unitLimitLower || 0) && numUnits <= (unitLimitUpper || Math.pow(10, 1000)));
function $9c8fafac440a889f$export$8f857d3e1dbdf9cf(numUnits, tiers, currencyISOCode, period, localeISOCode = 'en-US') {
    if (!Number.isInteger(numUnits) || numUnits < 1) throw new Error(`Number of units must be a positive non-zero integer, got ${numUnits}.`);
    if (!tiers || tiers.length === 0) throw new Error(`Price tiers must not be null, undefined or an empty array, got ${tiers}.`);
    tiers.sort((a, b)=>{
        return (a.unitLimitLower ?? 0) - (b.unitLimitLower ?? 0);
    });
    let matchingTierIdx = $9c8fafac440a889f$var$getTierIdxForNumUnits(numUnits, tiers);
    const matchingTier = tiers[matchingTierIdx];
    const finalTier = tiers[tiers.length - 1];
    let adjustedNumberOfUnits = numUnits;
    let calcFunc;
    if (matchingTier !== undefined) {
        const tierPricingStrategy = matchingTier.pricingStrategy;
        calcFunc = period === 'MONTHLY' || tierPricingStrategy === (0, $hrGO1.PricingStrategy).MARGINAL_PER_UNIT ? (0, $fmcUV.default) : (0, $cuq2S.default);
    } else if (finalTier && finalTier.pricingStrategy === (0, $hrGO1.PricingStrategy).MARGINAL_PER_UNIT) calcFunc = (0, $fmcUV.default);
    else {
        /*
     * When a user input is greater than the max tier limit
     * we will reset the number of users to max tier limit
     * of that product and perform price calculations.
     * */ adjustedNumberOfUnits = finalTier?.unitLimitUpper || 0;
        matchingTierIdx = $9c8fafac440a889f$var$getTierIdxForNumUnits(adjustedNumberOfUnits, tiers);
        calcFunc = (0, $cuq2S.default);
    }
    const fmtUnit = (amount)=>(0, $ieLA0.getFormattedUnitAmount)(localeISOCode, amount);
    const fmtPrice = (price)=>(0, $ieLA0.getFormattedPrice)(currencyISOCode, price);
    const { totalPrice: totalPrice, avgPerUnitPrice: avgPerUnitPrice, hasFlatRateFirstTier: hasFlatRateFirstTier, breakdown: breakdown } = calcFunc(adjustedNumberOfUnits, matchingTierIdx, tiers, currencyISOCode);
    const avgPerUnitPriceWithDiscount = (0, $cuq2S.calculateDiscountedPrice)(0.75, avgPerUnitPrice);
    const totalPriceWithDiscount = (0, $cuq2S.calculateDiscountedPrice)(0.75, totalPrice);
    return {
        totalPrice: totalPrice,
        avgPerUnitPriceWithDiscount: avgPerUnitPriceWithDiscount,
        formattedTotalPrice: fmtPrice(totalPrice),
        formattedAvgPerUnitPriceWithDiscount: fmtPrice(avgPerUnitPriceWithDiscount),
        formattedTotalPriceWithDiscount: fmtPrice(totalPriceWithDiscount),
        avgPerUnitPrice: avgPerUnitPrice,
        formattedAvgPerUnitPrice: fmtPrice(avgPerUnitPrice),
        breakdown: breakdown,
        hasFlatRateFirstTier: hasFlatRateFirstTier,
        formattedBreakdown: breakdown.map(({ unitsInTier: unitsInTier, unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper, unitsAvailableInTier: unitsAvailableInTier, totalPriceForTier: totalPriceForTier, avgPerUnitPriceForTier: avgPerUnitPriceForTier })=>({
                formattedUnitsInTier: fmtUnit(unitsInTier),
                formattedUnitsAvailableInTier: fmtUnit(unitsAvailableInTier),
                formattedUnitLimitLower: fmtUnit(unitLimitLower),
                formattedUnitLimitUpper: fmtUnit(unitLimitUpper),
                formattedTotalPriceForTier: (0, $ieLA0.getTwoDigitFormattedPrice)(currencyISOCode, totalPriceForTier),
                formattedAvgPerUnitPriceForTier: (0, $ieLA0.getTwoDigitFormattedPrice)(currencyISOCode, avgPerUnitPriceForTier)
            }))
    };
}

});
parcelRegister("cuq2S", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $20e5665ddc9d914c$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "calculateDiscountedPrice", function () { return $20e5665ddc9d914c$export$3a875854e1248ca4; });

var $8q2jX = parcelRequire("8q2jX");
function $20e5665ddc9d914c$export$2e2bcd8739ae039(numUnits, matchingTierIdx, tiers, currencyISOCode) {
    const matchingTier = tiers[matchingTierIdx];
    if (!matchingTier) throw new Error(`Matching price tier not found for ${numUnits}.`);
    const { prices: prices, unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper } = matchingTier;
    const totalPrice = (0, $8q2jX.getLocalUnitPrice)(currencyISOCode, prices.slice());
    const avgPerUnitPrice = totalPrice / numUnits;
    return {
        totalPrice: totalPrice,
        avgPerUnitPrice: avgPerUnitPrice,
        hasFlatRateFirstTier: true,
        breakdown: [
            {
                unitsInTier: numUnits,
                unitsAvailableInTier: (unitLimitUpper || 0) - numUnits,
                unitLimitLower: unitLimitLower || 1,
                unitLimitUpper: unitLimitUpper || 0,
                totalPriceForTier: totalPrice,
                avgPerUnitPriceForTier: totalPrice / numUnits
            }
        ]
    };
}
const $20e5665ddc9d914c$export$3a875854e1248ca4 = (discountRate, price)=>price * (1 - discountRate);

});
parcelRegister("8q2jX", function(module, exports) {
$parcel$export(module.exports, "getLocalUnitPrice", function () { return $032de19fb775a510$export$e4a3f0ac75d6f09; });
const $032de19fb775a510$export$e4a3f0ac75d6f09 = (currencyISOCode, prices)=>prices.find(({ currency: currency })=>currency === currencyISOCode)?.unitPrice || 0;

});


parcelRegister("fmcUV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e064390e0d1f8ae6$export$2e2bcd8739ae039; });

var $hrGO1 = parcelRequire("hrGO1");

var $8q2jX = parcelRequire("8q2jX");
function $e064390e0d1f8ae6$export$2e2bcd8739ae039(numUnits, matchingTierIdx, tiers, currencyISOCode) {
    let totalPrice = 0;
    let price = 0;
    const breakdown = [];
    const getUnitPrice = (prices)=>(0, $8q2jX.getLocalUnitPrice)(currencyISOCode, prices);
    // if no matching tier then default to highest (last) tier
    if (matchingTierIdx === -1) matchingTierIdx = tiers.length - 1;
    let idx = 0;
    for (const tier of tiers){
        const { unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper } = tier;
        const adjUnitLimitLower = Math.max((unitLimitLower || 0) - 1, 0);
        // the upper unit limit can't be undefined so we can just set it to
        // one million units as an upper bound
        const adjUnitLimitUpper = unitLimitUpper || 1000000;
        const unitsInTier = idx === matchingTierIdx ? numUnits - adjUnitLimitLower : adjUnitLimitUpper - adjUnitLimitLower;
        if (tier.pricingStrategy === (0, $hrGO1.PricingStrategy).FIXED_COST) price = getUnitPrice(tier.prices.slice());
        else {
            const finalTier = tiers[Math.min(idx, tiers.length - 1)];
            price = getUnitPrice(finalTier.prices.slice());
        }
        const totalPriceForTier = tier.pricingStrategy === (0, $hrGO1.PricingStrategy).FIXED_COST ? price : unitsInTier * price;
        totalPrice += totalPriceForTier;
        breakdown.push({
            unitsInTier: unitsInTier,
            unitsAvailableInTier: adjUnitLimitUpper - unitsInTier,
            unitLimitLower: adjUnitLimitLower || 1,
            unitLimitUpper: adjUnitLimitUpper,
            totalPriceForTier: totalPriceForTier,
            avgPerUnitPriceForTier: price
        });
        if (++idx > matchingTierIdx) break;
    }
    const avgPerUnitPrice = totalPrice / numUnits;
    return {
        totalPrice: totalPrice,
        avgPerUnitPrice: avgPerUnitPrice,
        hasFlatRateFirstTier: tiers[0]?.pricingStrategy === (0, $hrGO1.PricingStrategy).FIXED_COST,
        breakdown: breakdown
    };
}

});



parcelRegister("f1eZF", function(module, exports) {
$parcel$export(module.exports, "PriceCard", function () { return $9cd0991b9ed771f1$export$24997073811e6afa; });
/* price-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $20Gca = parcelRequire("20Gca");

var $j75fB = parcelRequire("j75fB");

var $f7LGP = parcelRequire("f7LGP");

var $k6638 = parcelRequire("k6638");

var $jgk8M = parcelRequire("jgk8M");

var $6RfM0 = parcelRequire("6RfM0");

var $6oL3t = parcelRequire("6oL3t");

var $hrGO1 = parcelRequire("hrGO1");

var $jcRJT = parcelRequire("jcRJT");

var $eYlij = parcelRequire("eYlij");

var $kbpa7 = parcelRequire("kbpa7");

var $9Rl14 = parcelRequire("9Rl14");

var $6o9v8 = parcelRequire("6o9v8");
const $9cd0991b9ed771f1$var$planFeatureMessageContainerStyles = null;
const $9cd0991b9ed771f1$var$planFeatureMessagesStyles = null;
// @ts-ignore
const $9cd0991b9ed771f1$var$stickyCtaContainerStyles = null;
const $9cd0991b9ed771f1$export$24997073811e6afa = (props)=>{
    const { enableRecommendation: enableRecommendation = true } = props;
    const { recommendationElement: recommendationElement } = (0, $eYlij.usePriceFinderContext)();
    let highlightedFeaturesTitle = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "Pricing.PriceCard.featureMessageTitleFree",
        defaultMessage: "Includes:"
    });
    if (props.adjacentLowerTierPlanName) highlightedFeaturesTitle = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "Pricing.PriceCard.featureMessageTitle",
        defaultMessage: "Everything from {featureMessagePlanName}, plus:",
        values: {
            featureMessagePlanName: props.adjacentLowerTierPlanName
        }
    });
    const planTitleId = `planTitle_${props.priceCalcIdx}`;
    const defaultRecommendationElement = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "Pricing.PriceCard.recommended",
        defaultMessage: "Recommended"
    });
    /* eslint-disable jsx-a11y/no-redundant-roles */ /* added role="list" to ul for safari https://developer.mozilla.org/en-US/docs/Web/CSS/list-style#accessibility  */ return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $6RfM0.PriceCard), {
        ...(0, $6RfM0.getPriceCardProps)(props),
        outlined: props.highlighted,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $6oL3t.PriceCardSection), {
                children: [
                    enableRecommendation && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j75fB.Banner), {
                        shown: props.highlighted,
                        children: recommendationElement ? recommendationElement : defaultRecommendationElement
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $f7LGP.ContentStack), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k6638.ContentText), {
                                        id: planTitleId,
                                        variant: "lg",
                                        as: "h2",
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)($9cd0991b9ed771f1$var$PriceCardTitle, {
                                            planName: props.planName,
                                            planTitleComponent: props.planTitleComponent
                                        })
                                    }),
                                    props.description && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k6638.ContentText), {
                                        variant: "md",
                                        id: `pricing-plan-description-${props.planName}`,
                                        children: props.description
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1pfh1wug _1e0c1txw _2lx21bp4 _4cvr1h6o _zulp1tcg"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_4t3i88uy"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9Rl14.Price), {
                                            ...props
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            props.billingCycle === 'ANNUAL' && !(props.offeringSku === (0, $hrGO1.CloudOfferingsWithSkus).rovo && props.billingCycle === 'ANNUAL' && props.unitCount > 1000) && "_1pfh1tcg"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6o9v8.StickyCTAContextProvider), {
                                            isSticky: false,
                                            children: props.ctaButton
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            !!props.planFeatureMessages?.length && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6oL3t.PriceCardSection), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgk8M.ExpanderStack), {
                    heading: highlightedFeaturesTitle,
                    lozenge: props.dataProductKey === 'loom' && props.planName === 'Business + AI' && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_1pfhmyb0 _x10q1wr3"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $20Gca.default), {
                            style: {
                                color: (0, $kbpa7.wacToken)('color.neutral.light0')
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "Pricing.PriceCard.LoomAiLozenge",
                                defaultMessage: "Powered by Loom AI",
                                description: "Loom AI should not be translated"
                            })
                        })
                    }),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                        role: "list",
                        className: (0, $2jatx.default)([
                            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1pfhidpf _2mzuglyw"
                        ]),
                        children: props.planFeatureMessages.map((planFeatureMessage, idx)=>{
                            return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                className: (0, $2jatx.default)([
                                    "_1pfh7vkz _1d6jidpf"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jcRJT.PlanFeature), {
                                    ...planFeatureMessage,
                                    padded: false
                                })
                            }, idx);
                        })
                    })
                })
            })
        ]
    });
};
const $9cd0991b9ed771f1$var$PriceCardTitle = (props)=>{
    const { planName: planName, planTitleComponent: PlanTitle } = props;
    return PlanTitle ? /*#__PURE__*/ (0, $7VQPk.jsx)(PlanTitle, {
        planName: planName
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        id: `pricing-plan-title-${planName}`,
        children: planName
    });
};

});
parcelRegister("j75fB", function(module, exports) {
$parcel$export(module.exports, "Banner", function () { return $29230037a2fbb88e$export$3b4e64e77073e307; });
/* banner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $29230037a2fbb88e$export$3b4e64e77073e307 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4t3i1tcg _1e0c1txw _1bah1h6o _4cvr1h6o _1bsb1osq",
            props.shown && "_11q71pfd _2rko1kw7"
        ]),
        style: {
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
        },
        children: props.shown && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_syaz1afi _1wyb1crf _ect48q0o _k48pni7l _1p1dangw _vwz4f6fq _1dyzt94y _slp31hna _y3gn1h6o"
            ]),
            style: {
                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
            },
            children: props.children
        })
    });
};
const $29230037a2fbb88e$var$bannerCss = null;
const $29230037a2fbb88e$var$bannerContent = null;

});

parcelRegister("f7LGP", function(module, exports) {
$parcel$export(module.exports, "ContentStack", function () { return $3df91ce6dd04ff8b$export$346989ded957d179; });
/* content-stack.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $3df91ce6dd04ff8b$export$346989ded957d179 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _zulp1tcg _4t3i1osq _ca0q1tcg _u5f31tcg _n3td1tcg _19bv1tcg"
        ]),
        children: props.children
    });
};
const $3df91ce6dd04ff8b$var$contentStackCss = null;

});

parcelRegister("k6638", function(module, exports) {
$parcel$export(module.exports, "ContentText", function () { return $f542c6588c759f80$export$646b80a994b34028; });
/* content-text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $f542c6588c759f80$export$646b80a994b34028 = (props)=>{
    const { as: Component = 'span', variant: variant = 'md' } = props;
    return /*#__PURE__*/ (0, $7VQPk.jsx)(Component, {
        ...props,
        className: (0, $2jatx.default)([
            "_ect48q0o _syazqlpt _y3gn1h6o _1e0c1ule _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            variant === 'xl' && "_1wyb1ylp _vwz4ckbl _k48p1fw0",
            variant === 'lg' && "_1wyb1tcg _vwz41ul9 _k48p1fw0",
            variant === 'md' && "_1wybdlk8 _vwz4gktf"
        ]),
        children: props.children
    });
};
const $f542c6588c759f80$var$xlCss = null;
const $f542c6588c759f80$var$lgCss = null;
const $f542c6588c759f80$var$mdCss = null;
const $f542c6588c759f80$var$contentTextCss = null;

});

parcelRegister("jgk8M", function(module, exports) {
$parcel$export(module.exports, "ExpanderStack", function () { return $d03c0397d251a4ea$export$b2da8816cb6c8b9e; });
/* expander-stack.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $d03c0397d251a4ea$var$expanderStackCss = null;
const $d03c0397d251a4ea$var$expanderStackHeadingCss = null;
const $d03c0397d251a4ea$export$b2da8816cb6c8b9e = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp7vkz _ca0q1tcg _u5f31tcg _n3td1tcg _19bv1tcg _1bsb1osq"
        ]),
        children: [
            props.lozenge,
            props.heading && /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                className: (0, $2jatx.default)([
                    "_1wyb7vkz _vwz41tcg _k48pni7l _19pkidpf _2hwxidpf _otyridpf _18u0idpf _syazeipq"
                ]),
                children: props.heading
            }),
            props.children
        ]
    });
};

});

parcelRegister("6RfM0", function(module, exports) {
$parcel$export(module.exports, "PriceCard", function () { return $733cb585185a6f15$export$24997073811e6afa; });
$parcel$export(module.exports, "getPriceCardProps", function () { return $733cb585185a6f15$export$3a1eade60b680c85; });
/* price-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $luVdE = parcelRequire("luVdE");
const $733cb585185a6f15$export$24997073811e6afa = (props)=>{
    const { isInsideCardStack: isInsideCardStack } = (0, $luVdE.useIsInsideCardStack)();
    const validChildren = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Children.forEach(props.children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).isValidElement(child)) validChildren.push(child);
    });
    const children = validChildren.map((child, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).cloneElement(child, {
            key: index,
            first: index === 0,
            last: index === (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Children.count(validChildren) - 1,
            firstCard: props.first,
            lastCard: props.last,
            outlined: props.outlined
        });
    });
    if (isInsideCardStack) return children;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1s4p1osq"
        ]),
        children: children
    });
};
const $733cb585185a6f15$var$priceCardCss = null;
const $733cb585185a6f15$export$3a1eade60b680c85 = ({ first: first, last: last, outlined: outlined })=>({
        first: first,
        last: last,
        outlined: outlined
    });

});

parcelRegister("6oL3t", function(module, exports) {
$parcel$export(module.exports, "PriceCardSection", function () { return $d647f0efe2b4519d$export$bead6418a4510dba; });
/* price-card-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $luVdE = parcelRequire("luVdE");
const $d647f0efe2b4519d$export$bead6418a4510dba = (props)=>{
    const { first: first, last: last, firstCard: firstCard, lastCard: lastCard, outlined: outlined, children: children, ...divProps } = props;
    const { isInsideCardStack: isInsideCardStack } = (0, $luVdE.useIsInsideCardStack)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ...divProps,
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1bah1yb4 _4cvr1h6o _glte1osq _11q71afi",
            "_mqm2h1cn _191wh1cn _16qsglyw",
            !isInsideCardStack && first && "_1s1ggktf _5fbcgktf",
            !isInsideCardStack && "_t51zh1cn",
            !isInsideCardStack && last && "_179rh1cn _1yxngktf _1eingktf",
            !isInsideCardStack && outlined && "_191w1erl _t51z1erl",
            !isInsideCardStack && outlined && first && "_mqm21erl",
            !isInsideCardStack && outlined && last && "_179r1erl _1yxngktf _1eingktf",
            isInsideCardStack && "_1tk6h1cn",
            isInsideCardStack && first && "_1e0kgktf _tg79gktf",
            isInsideCardStack && last && "_179rh1cn _1egl1tcg _6q09idpf",
            isInsideCardStack && lastCard && "_p5clh1cn",
            isInsideCardStack && firstCard && first && "_1orwgktf",
            isInsideCardStack && lastCard && first && "_yo7bgktf",
            isInsideCardStack && lastCard && last && "_1f8wgktf",
            isInsideCardStack && firstCard && last && "_3ynegktf",
            isInsideCardStack && outlined && first && "_mqm21erl",
            isInsideCardStack && outlined && "_xvbn1erl _1tk61erl _1w6e1erl _p5cl1erl",
            isInsideCardStack && outlined && last && "_179r1erl"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400')),
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
        },
        children: children
    });
};
const $d647f0efe2b4519d$var$priceCardSectionCss = null;

});

parcelRegister("jcRJT", function(module, exports) {
$parcel$export(module.exports, "PlanFeature", function () { return $4dfd82fed4675488$export$eba92f5ed965ecf9; });
/* price-card-plan-feature.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $6tSTn = parcelRequire("6tSTn");

var $20Gca = parcelRequire("20Gca");
const $4dfd82fed4675488$var$planFeatureMessageContainerCss = null;
const $4dfd82fed4675488$var$contentContainerCss = null;
const $4dfd82fed4675488$var$lozengeContainerCss = null;
const $4dfd82fed4675488$var$featureContentContainerCss = null;
const $4dfd82fed4675488$export$eba92f5ed965ecf9 = ({ featureMessage: featureMessage, lozengeText: lozengeText, padded: padded = true })=>{
    const featureMessageHasContent = !(typeof featureMessage === 'string');
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _szfsglyw _stfgglyw _d32voelr _4rtxtlke _1sg88q0o _1o7poxwj _1q9t1nn1 _11lv1y44 _ficf1e5h _4pkpu7gi",
            padded && "_1q517vkz _bozg19bv"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_syaz1mpp _1bsb1osq"
            ]),
            children: featureMessageHasContent ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6tSTn.ExpandableContent), {
                eventDataName: featureMessage.text,
                label: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                    children: [
                        featureMessage.text,
                        lozengeText && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                "_ahbq1y44"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $20Gca.default), {
                                children: lozengeText
                            })
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1wyboxwj _syazqlpt _43dsrbzz _59381r31 _yha28stv _1nmznqa1 _oxk4oelr _rfqo1r31 _1bgkglyw _1t0pnqa1"
                    ]),
                    children: featureMessage.content('100%')
                })
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6tSTn.ExpandableContent), {
                eventDataName: featureMessage,
                label: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                    children: [
                        featureMessage,
                        lozengeText && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                "_ahbq1y44"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $20Gca.default), {
                                children: lozengeText
                            })
                        })
                    ]
                })
            })
        })
    });
};

});

parcelRegister("9Rl14", function(module, exports) {
$parcel$export(module.exports, "Price", function () { return $c39a07724f817c70$export$3f58fdce283c1f4c; });
/* price.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable complexity */ /* Will be refactored once we have redesign goes live */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $k6638 = parcelRequire("k6638");

var $hrGO1 = parcelRequire("hrGO1");

var $iRMRa = parcelRequire("iRMRa");

var $eYlij = parcelRequire("eYlij");

var $3F38X = parcelRequire("3F38X");

var $kOGAE = parcelRequire("kOGAE");

var $cdVVX = parcelRequire("cdVVX");
const $c39a07724f817c70$var$fontCharlieDisplay = '"Charlie Display", "Charlie Text", -apple-system, BlinkMacSystemFont, "Segoe UI",Roboto, "Noto Sans", Ubuntu, "Droid Sans", "Helvetica Neue", sans-serif !important';
const $c39a07724f817c70$var$priceSpanStyles = null;
const $c39a07724f817c70$export$3f58fdce283c1f4c = (props)=>{
    const { billingCycle: billingCycle, overSignupLimit: overSignupLimit, planName: planName, currencyISOCode: currencyISOCode, unitCount: unitCount, productKey: productKey, priceCalcIdx: priceCalcIdx, contactURL: contactURL, offeringSku: offeringSku, shouldAddDiscount: shouldAddDiscount } = props;
    const [{ priceCalcs: priceCalcs, messages: messages }, actions] = (0, $3F38X.usePriceFinderStore)();
    const { enterpriseMinimumCount: enterpriseMinimumCount = (0, $hrGO1.DefaultPlanLimits).UNIT_MIN_ENTERPRISE } = (0, $eYlij.usePriceFinderContext)();
    const priceCalc = priceCalcs[priceCalcIdx];
    if (!priceCalc) throw new Error(`Price calculation was not found for index ${priceCalcIdx}`);
    let planMessage = billingCycle === 'MONTHLY' ? /*#__PURE__*/ (0, $7VQPk.jsx)($c39a07724f817c70$var$MonthlyPrice, {
        formattedPrice: priceCalc.formattedAvgPerUnitPrice,
        formattedAvgPerUnitPriceWithDiscount: priceCalc.formattedAvgPerUnitPriceWithDiscount,
        planName: planName,
        shouldAddDiscount: shouldAddDiscount
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)($c39a07724f817c70$export$8e077f62bcf5008c, {
        formattedPrice: priceCalc.formattedTotalPrice,
        formattedTotalPriceWithDiscount: priceCalc.formattedTotalPriceWithDiscount,
        planName: planName,
        priceCalc: priceCalc,
        priceDisplaySize: currencyISOCode === 'JPY' ? 'small' : 'normal',
        shouldAddDiscount: shouldAddDiscount
    });
    if (overSignupLimit && productKey === (0, $hrGO1.SpecialProductKeys).BITBUCKET) planMessage = /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $k6638.ContentText), {
        variant: "md",
        "data-testid": "bitbucket-signup-limit",
        children: [
            "For teams of more than 35,000, ",
            /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                href: contactURL,
                children: "contact our sales team."
            })
        ]
    });
    else if (overSignupLimit) planMessage = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k6638.ContentText), {
        variant: "md",
        "data-testid": "signup-limit",
        children: messages?.cardOverSignupLimit?.defaultMessage ?? ''
    });
    if (offeringSku === (0, $hrGO1.CloudOfferingsWithSkus).rovo && unitCount > 1000) planMessage = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k6638.ContentText), {
        variant: "md",
        "data-testid": "rovo-annual-message",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "Pricing.card.body.rovo.annual.message",
            defaultMessage: "Start your free 30-day trial or contact your Atlassian sales representative for more information."
        })
    });
    switch(planName){
        case (0, $hrGO1.SpecialPlanNames).STARTER:
        case (0, $hrGO1.SpecialPlanNames).FREE:
            planMessage = /*#__PURE__*/ (0, $7VQPk.jsx)($c39a07724f817c70$var$FreePrice, {
                formattedPrice: priceCalc.formattedTotalPrice,
                planName: planName
            });
            break;
        case (0, $hrGO1.SpecialPlanNames).ENTERPRISE:
            if (messages.cardEnterpriseBodyOverride) planMessage = messages.cardEnterpriseBodyOverride;
            else if (billingCycle === 'MONTHLY') planMessage = /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $k6638.ContentText), {
                variant: "md",
                "data-testid": "enterprise-monthly",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kOGAE.BilledAnnuallyButton), {
                        onClick: ()=>actions.updateBillingCycle('ANNUAL')
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "PricingTeam24.card.body.enterprise.monthly",
                        defaultMessage: "Switch to Annual billing above to view Enterprise pricing."
                    })
                ]
            });
            else if (currencyISOCode === 'JPY') planMessage = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k6638.ContentText), {
                variant: "md",
                "data-testid": "enterprise-jpy",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "Pricing.card.body.enterprise.jpy",
                    defaultMessage: "For pricing details see FAQ below or talk to our sales team"
                })
            });
            else if (overSignupLimit) planMessage = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k6638.ContentText), {
                variant: "md",
                "data-testid": "enterprise-signup-limit",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "Pricing.card.body.enterprise.overSignupLimit",
                    defaultMessage: "Talk to our sales team about pricing for Cloud Enterprise"
                })
            });
            else if (unitCount < enterpriseMinimumCount) planMessage = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k6638.ContentText), {
                variant: "md",
                "data-testid": "enterprise-min-limit",
                children: messages.cardEnterpriseMinimumCount && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: messages.cardEnterpriseMinimumCount.id,
                    defaultMessage: messages.cardEnterpriseMinimumCount.defaultMessage,
                    values: {
                        ...(0, $iRMRa.DEFAULT_VALUES),
                        enterpriseMinimumCount: enterpriseMinimumCount
                    }
                })
            });
            break;
    }
    return planMessage;
};
const $c39a07724f817c70$var$FREE_PRICE_TEST_ID = 'free-price';
const $c39a07724f817c70$var$FreePrice = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k6638.ContentText), {
        variant: "xl",
        "data-cy": `plan-card-price-${props.planName.toLowerCase()}`,
        "data-testid": $c39a07724f817c70$var$FREE_PRICE_TEST_ID,
        children: props.formattedPrice
    });
};
const $c39a07724f817c70$var$MONTHLY_PRICE_TEST_ID = 'monthly-price';
const $c39a07724f817c70$var$MonthlyPrice = (props)=>{
    const [{ messages: messages }] = (0, $3F38X.usePriceFinderStore)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            props.shouldAddDiscount ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k6638.ContentText), {
                variant: "xl",
                "data-cy": `plan-card-price-${props.planName.toLowerCase()}`,
                "data-testid": $c39a07724f817c70$var$MONTHLY_PRICE_TEST_ID,
                children: props.formattedAvgPerUnitPriceWithDiscount
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k6638.ContentText), {
                variant: "xl",
                "data-cy": `plan-card-price-${props.planName.toLowerCase()}`,
                "data-testid": $c39a07724f817c70$var$MONTHLY_PRICE_TEST_ID,
                children: props.formattedPrice
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k6638.ContentText), {
                variant: "md",
                children: messages?.cardMonthlyPerUnitCount && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: messages.cardMonthlyPerUnitCount.id,
                    defaultMessage: messages.cardMonthlyPerUnitCount.defaultMessage
                })
            })
        ]
    });
};
const $c39a07724f817c70$var$ANNUAL_PRICE_TEST_ID = 'annual-price';
const $c39a07724f817c70$export$1db406331b1cb6e4 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            props.shouldAddDiscount ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k6638.ContentText), {
                variant: "xl",
                style: {
                    fontSize: props.priceDisplaySize === 'small' ? '35px' : undefined
                },
                "data-testid": $c39a07724f817c70$var$ANNUAL_PRICE_TEST_ID,
                "data-cy": `plan-card-price-${props.planName.toLowerCase()}`,
                children: props.formattedTotalPriceWithDiscount
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_1wybckbl _k48pbfng _ect41lim _kqswh2mm"
                ]),
                children: props.formattedPrice
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "data-testid": $c39a07724f817c70$var$ANNUAL_PRICE_TEST_ID,
                className: (0, $2jatx.default)([
                    "_1pfh1h22"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "Pricing.PriceCard.Annual.Description",
                    defaultMessage: "per year"
                })
            }),
            props.formattedUnitTierNode
        ]
    });
};
const $c39a07724f817c70$export$8e077f62bcf5008c = (props)=>{
    const [{ unitCount: unitCount }] = (0, $3F38X.usePriceFinderStore)();
    const { annualUserTierDisplayThreshold: annualUserTierDisplayThreshold } = (0, $eYlij.usePriceFinderContext)();
    const shouldDisplayPriceTier = annualUserTierDisplayThreshold === undefined || unitCount >= annualUserTierDisplayThreshold;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            props.shouldAddDiscount ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k6638.ContentText), {
                "data-testid": $c39a07724f817c70$var$ANNUAL_PRICE_TEST_ID,
                variant: "xl",
                style: {
                    fontSize: props.priceDisplaySize === 'small' ? '35px' : undefined
                },
                "data-cy": `plan-card-price-${props.planName.toLowerCase()}`,
                children: props.formattedTotalPriceWithDiscount
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k6638.ContentText), {
                "data-testid": $c39a07724f817c70$var$ANNUAL_PRICE_TEST_ID,
                variant: "xl",
                style: {
                    fontSize: props.priceDisplaySize === 'small' ? '35px' : undefined
                },
                "data-cy": `plan-card-price-${props.planName.toLowerCase()}`,
                children: props.formattedPrice
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $k6638.ContentText), {
                "data-testid": $c39a07724f817c70$var$ANNUAL_PRICE_TEST_ID,
                variant: "md",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "Pricing.PriceCard.Annual.Description",
                        defaultMessage: "per year"
                    }),
                    shouldDisplayPriceTier && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cdVVX.UserTier), {
                        priceCalc: props.priceCalc
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("kOGAE", function(module, exports) {
$parcel$export(module.exports, "BilledAnnuallyButton", function () { return $6a8c318d6d78f834$export$ae3c75f0e47b71cc; });
/* billed-annually-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
const $6a8c318d6d78f834$export$ae3c75f0e47b71cc = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        type: "button",
        onClick: props.onClick,
        tabIndex: 0,
        "data-event-component": "linkButton",
        "data-event": "clicked",
        className: (0, $2jatx.default)([
            "_bfhk1j28 _19itidpf _80omtlke _syazoelr _ect41kw7 _1wyb1kw7 _vwz4idpf _19pkidpf _2hwxyh40 _otyridpf _18u0yh40 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _4bfu1r31 _1hms8stv _ajmmnqa1 _o5721q9c _30l3u7gi"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "Pricing.card.body.enterprise.billedAnnually",
            defaultMessage: "Billed annually."
        })
    });
};

});

parcelRegister("cdVVX", function(module, exports) {
$parcel$export(module.exports, "UserTier", function () { return $0cbf75546d5654ce$export$cd4f9ca719669f8d; });
/* user-tier.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $2Yrzq = parcelRequire("2Yrzq");

var $iRMRa = parcelRequire("iRMRa");

var $3F38X = parcelRequire("3F38X");
const $0cbf75546d5654ce$var$userTierContainerStyles = null;
const $0cbf75546d5654ce$var$userTierMessageStyles = null;
const $0cbf75546d5654ce$var$toolTipContainerStyles = null;
const $0cbf75546d5654ce$export$cd4f9ca719669f8d = ({ priceCalc: priceCalc })=>{
    const { formattedBreakdown: formattedBreakdown } = priceCalc;
    const [{ messages: messages }] = (0, $3F38X.usePriceFinderStore)();
    const fmtBreakdownTier = formattedBreakdown[formattedBreakdown.length - 1];
    if (!fmtBreakdownTier) throw new Error('No breakdown provided for user tier.');
    const { formattedUnitLimitLower: formattedUnitLimitLower, formattedUnitLimitUpper: formattedUnitLimitUpper, formattedUnitsInTier: formattedUnitsInTier, formattedUnitsAvailableInTier: formattedUnitsAvailableInTier } = fmtBreakdownTier;
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const tooltipAriaLabel = formatMessage({
        id: 'Pricing.PriceCard.UserTier.MoreInformationAboutTier',
        defaultMessage: 'More information about tier'
    });
    const filledSeatsMessage = formatMessage({
        id: 'Pricing.PriceCard.UserTier.Details',
        defaultMessage: 'Filled seats'
    });
    const availableSeatsMessage = formatMessage({
        id: 'Pricing.PriceCard.UserTier.AvailableSeats',
        defaultMessage: 'Available seats'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _zulp1y44"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1wybdlk8"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        ...messages.cardUnitCountTierRange,
                        values: {
                            ...(0, $iRMRa.DEFAULT_VALUES),
                            lowerLimit: formattedUnitLimitLower,
                            upperLimit: formattedUnitLimitUpper
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Yrzq.Tooltip), {
                ariaLabel: tooltipAriaLabel,
                buttonSize: "small",
                content: `Tier:
                    ${formattedUnitLimitLower} -${' '}${formattedUnitLimitUpper}

                    ${filledSeatsMessage}:
                    ${formattedUnitsInTier}

                    ${availableSeatsMessage}:
                    ${formattedUnitsAvailableInTier}`
            })
        ]
    });
};

});
parcelRegister("2Yrzq", function(module, exports) {
$parcel$export(module.exports, "Tooltip", function () { return $d538995304586554$export$28c660c63b792dea; });
/* tooltip.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $eY3N6 = parcelRequire("eY3N6");

var $cwszX = parcelRequire("cwszX");

var $kbpa7 = parcelRequire("kbpa7");
const $d538995304586554$var$TOOLTIP_WIDTH = 250;
const $d538995304586554$export$28c660c63b792dea = ({ ariaLabel: ariaLabel, buttonSize: buttonSize, content: content })=>{
    const [isVisible, setIsVisible] = (0, $1oC0p.useState)(false);
    const [tooltipStyle, setTooltipStyle] = (0, $1oC0p.useState)({});
    const tooltipRef = (0, $1oC0p.useRef)(null);
    const buttonRef = (0, $1oC0p.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const toggleTooltip = ()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'tooltip',
            source: 'tooltip',
            attributes: {
                label: ariaLabel
            }
        }).fire();
        setIsVisible((prev)=>!prev);
    };
    const calculateTooltipPosition = ()=>{
        if (tooltipRef.current) {
            const tooltipRect = tooltipRef.current.getBoundingClientRect();
            const buttonRect = tooltipRef.current.parentElement?.getBoundingClientRect();
            const newStyle = {};
            if (buttonRect) {
                // Check if tooltip is going to be cut off on the right side
                const tooltipRight = buttonRect?.left + $d538995304586554$var$TOOLTIP_WIDTH;
                const tooltipRightOverflow = tooltipRight - window.innerWidth;
                if (tooltipRightOverflow > $d538995304586554$var$TOOLTIP_WIDTH / 2) newStyle.transform = 'translateX(-100%)';
                else if (tooltipRightOverflow > 0) newStyle.transform = 'translateX(-50%)';
                // Check if tooltip is going to be cut off on the bottom
                const tooltipBottom = buttonRect.bottom + tooltipRect.height;
                if (tooltipBottom > window.innerHeight) {
                    newStyle.bottom = buttonRect.height + 'px';
                    newStyle.top = 'auto';
                } else {
                    newStyle.bottom = 'auto';
                    newStyle.top = '100%';
                }
                setTooltipStyle(newStyle);
            }
        }
    };
    (0, $1oC0p.useEffect)(()=>{
        if (isVisible) calculateTooltipPosition();
    }, [
        isVisible
    ]);
    // Handle clicks and enter presses outside the tooltip
    (0, $1oC0p.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (tooltipRef.current && !tooltipRef.current.contains(event.target) && buttonRef.current && !buttonRef.current.contains(event.target)) setIsVisible(false);
        };
        const handleKeyPress = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                if (tooltipRef.current && !tooltipRef.current.contains(document.activeElement) && buttonRef.current && !buttonRef.current.contains(document.activeElement)) setIsVisible(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleKeyPress);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, [
        isVisible
    ]);
    const heightCss = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1o8l _kqswh2mm",
            "_4t3i14r9"
        ]),
        style: {
            "--_1t4tmi3": (0, $6ZVlx.default)(buttonSize === 'small' ? 14 : 22, "px")
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                type: "button",
                "aria-describedby": "tooltip",
                "aria-label": ariaLabel,
                onClick: toggleTooltip,
                ref: buttonRef,
                className: (0, $2jatx.default)([
                    "_11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _80omtlke _1xys5hrz _yk0p5hrz",
                    "_4t3i14r9"
                ]),
                style: {
                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                    "--_1t4tmi3": (0, $6ZVlx.default)(buttonSize === 'small' ? 14 : 22)
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cwszX.InfoIcon), {
                    size: buttonSize
                })
            }),
            isVisible && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                id: "tooltip",
                role: "tooltip",
                ref: tooltipRef,
                className: (0, $2jatx.default)([
                    "_kqswstnw _1bsbr0r7 _2rko1crf _19pk1y44 _2hwx1y44 _otyr1y44 _18u01y44 _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _bfhk1pfd _syaz1afi _1pbyb4wl",
                    "_o5726vc6 _y3gn1e5h",
                    'body-sm'
                ]),
                style: {
                    ...tooltipStyle,
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                },
                children: content
            })
        ]
    });
};
const $d538995304586554$var$containerCss = null;
const $d538995304586554$var$buttonCss = null;
const $d538995304586554$var$toolTipContainerCss = null;
const $d538995304586554$var$textCss = null;

});
parcelRegister("cwszX", function(module, exports) {
$parcel$export(module.exports, "InfoIcon", function () { return $a32037f0fe1c069c$export$2957fc44b3d2481; });

var $7VQPk = parcelRequire("7VQPk");

var $3c7rQ = parcelRequire("3c7rQ");

var $kbpa7 = parcelRequire("kbpa7");
const $a32037f0fe1c069c$export$2957fc44b3d2481 = ({ size: size = 'small' })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: size === 'small' ? '14' : '22',
        height: size === 'small' ? '14' : '22',
        viewBox: "0 0 24 24",
        role: "presentation",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("circle", {
                    fill: (0, $kbpa7.wacToken)('color.primary.black'),
                    cx: "12",
                    cy: "12",
                    r: "10"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("circle", {
                    fill: (0, $3c7rQ.N0),
                    cx: "12",
                    cy: "18",
                    r: "1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M15.89 9.05a3.975 3.975 0 00-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.992.992 0 00.982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 014.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 00-1 .987v2.014a1.001 1.001 0 002.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0015.89 9.05",
                    fill: (0, $3c7rQ.N0)
                })
            ]
        })
    });

});






parcelRegister("4XErw", function(module, exports) {
$parcel$export(module.exports, "PriceFinderInputsRedesign", function () { return $50a9f17dfaed6430$export$f72c1ba1733c641a; });
/* price-finder-inputs-redesign.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $eY3N6 = parcelRequire("eY3N6");

var $20Gca = parcelRequire("20Gca");

var $eYlij = parcelRequire("eYlij");

var $kbpa7 = parcelRequire("kbpa7");

var $hrGO1 = parcelRequire("hrGO1");

var $3F38X = parcelRequire("3F38X");
const $50a9f17dfaed6430$var$labelStyles = null;
const $50a9f17dfaed6430$var$legendStyles = null;
const $50a9f17dfaed6430$var$inputTermStyle = null;
const $50a9f17dfaed6430$var$radioLabelStyles = null;
const $50a9f17dfaed6430$var$radioStyles = null;
const $50a9f17dfaed6430$var$discountLozengeStyles = null;
const $50a9f17dfaed6430$var$billMeStyles = null;
const $50a9f17dfaed6430$export$f72c1ba1733c641a = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const [{ unitCount: unitCount, billingCycle: billingCycle, messages: messages }, actions] = (0, $3F38X.usePriceFinderStore)();
    const { isMonthlyBillingOnly: isMonthlyBillingOnly, isAnnualBillingOnly: isAnnualBillingOnly, dataProductKey: dataProductKey } = (0, $eYlij.usePriceFinderContext)();
    (0, $1oC0p.useEffect)(()=>{
        if (isAnnualBillingOnly) actions.updateBillingCycle('ANNUAL');
    }, []);
    const [visualUnitCount, setVisualUnitCount] = (0, $1oC0p.useState)(unitCount);
    (0, $1oC0p.useEffect)(()=>{
        if (visualUnitCount !== '' && visualUnitCount > 0 && !Number.isNaN(visualUnitCount)) actions.updateUnitCount(visualUnitCount);
    }, [
        visualUnitCount,
        actions
    ]);
    const handleUnitCountChange = (e)=>{
        const stringValue = e.target.value;
        if (stringValue === '') return setVisualUnitCount('');
        // validate max number of digits
        // default is 5
        // TODO: make this configurable
        if (stringValue.length > 6) return;
        const numberValue = parseInt(stringValue, 10);
        if (numberValue < 1) return;
        setVisualUnitCount(numberValue);
    };
    const handleUnitCountBlurChange = ()=>{
        if (visualUnitCount === '') setVisualUnitCount(unitCount);
        const data = {
            unitCount: unitCount,
            productKey: dataProductKey
        };
        createAnalyticsEvent({
            eventType: 'ui',
            eventName: `${(0, $hrGO1.TRACKING_EVENT_NAMES).unitTierBox}_blurred`,
            eventComponent: 'input',
            event: 'blurred',
            actionSubject: (0, $hrGO1.TRACKING_EVENT_NAMES).unitTierBox,
            action: 'blurred',
            attributes: data,
            data: data
        }).fire();
    };
    const handleRadioChange = (e)=>{
        const data = {
            billingCycle: e.target.id,
            productKey: dataProductKey
        };
        createAnalyticsEvent({
            eventType: 'ui',
            eventName: (0, $hrGO1.TRACKING_EVENT_NAMES).billingCycleChanged,
            eventComponent: 'radioButton',
            event: 'clicked',
            actionSubject: (0, $hrGO1.TRACKING_EVENT_NAMES).billingCycleChanged,
            action: 'clicked',
            attributes: data
        }).fire();
        actions.updateBillingCycle(e.target.id);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12fogza"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_p12f1kdj _19pk1wug _2hwx1wug _otyr1wug _18u01wug _b8yq1osq _3wvkidpf _1fbnidpf _1uby1wug _1t0ridpf"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_p12f1kdj _6rth1tcg _181n1txw _b8yq1osq _e8gh1h6o _19wgys9h"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _181n1ule"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                                htmlFor: "unit-count",
                                className: (0, $2jatx.default)([
                                    "_ect4z4z1 _1wyb1j6v _1dyznl7k _k48pni7l _o5721q9c",
                                    "_12l2ftgi _syaz1pfd"
                                ]),
                                style: {
                                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    ...messages.unitCountInputTextRedesign
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf _1bah1h6o _4cvr1h6o _1bsb1ns9 _15flidpf _1d2widpf _1svyidpf _seovidpf _1akoidpf _c7s7idpf _4puvidpf _1r3vidpf _181n116y _1t19kb7n _p7vbkb7n _1rhgf1ug"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                    id: "unit-count",
                                    type: "number",
                                    "aria-describedby": "unit-count-term",
                                    value: visualUnitCount,
                                    onChange: handleUnitCountChange,
                                    onBlur: handleUnitCountBlurChange,
                                    "data-event-component": "inputNumber",
                                    "data-event-container": "priceBlock",
                                    "data-event": "clicked",
                                    className: (0, $2jatx.default)([
                                        "_syazalr3 _k48p1nn1 _1wyb1j6v _vwz41tcg _12l214y2 _ca0qftgi _u5f3i2wt _n3tdftgi _19bvi2wt _1bsb8ved _2rko1y44 _bfhk1hxd _19itglyw _13di444r _jh1sglyw _ji0mglyw"
                                    ])
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                id: "unit-count-term",
                                className: (0, $2jatx.default)([
                                    "_syaz1mpp _ect4z4z1 _1wyb1j6v _1dyznl7k _k48p1nn1 _16jlkb7n _1o9zkb7n _i0dlf1ug"
                                ]),
                                style: {
                                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    ...messages.unitCountInputTerm
                                })
                            })
                        ]
                    }),
                    !isMonthlyBillingOnly && !isAnnualBillingOnly && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("fieldset", {
                            "data-testid": "billing-inputs",
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o _1n261g80 _zulp7vkz _19itglyw"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("legend", {
                                    className: (0, $2jatx.default)([
                                        "_ect4z4z1 _1wyb1j6v _1dyznl7k _k48pni7l _o5721q9c",
                                        "_1aax1e5h"
                                    ]),
                                    style: {
                                        "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                                    },
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "Pricing.priceFinderInputs.billMeText",
                                        defaultMessage: "Bill me:"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                    className: (0, $2jatx.default)([
                                        "_4t3i1osq _1e0c1txw _zulp7vkz _wnej1g80"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
                                            htmlFor: "MONTHLY",
                                            className: (0, $2jatx.default)([
                                                "_80omtlke _zulpftgi _1e0c1txw _4cvr1h6o"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                                    type: "radio",
                                                    id: "MONTHLY",
                                                    "data-testid": "billing-radio-monthly",
                                                    name: "billing",
                                                    checked: billingCycle === 'MONTHLY',
                                                    onChange: handleRadioChange,
                                                    className: (0, $2jatx.default)([
                                                        "_bfhki0pe _19it1pkj _2rko1ssb _80omtlke _1e0c1txw _1bsb1tcg _4t3i1tcg _19pkidpf _2hwxidpf _otyridpf _18u0idpf _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _12ji1r31 _1qu2glyw _12y31o36 _t9ec1s1q _v564lstf _s7n4jp4b _r06hglyw _858ub0wy _1di64m1f _irr34m1f _z0ai1cbz _1qdg1cbz _18postnw _1hfki0pe _14mj1ssb _aetrb3bt _1peqidpf _qc5o16qv _h0k6rbzz _9e6urbzz _1q44oelr _dhyqkb7n _1jb3u67f _xqvjrbzz _ga64yh40 _sfejglyw _128ydlk8 _1199dlk8 _12gnrbzz _kl6cu67f _1htqn7od _1e7g1m1a"
                                                    ])
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                                    id: "Pricing.priceFinderInputs.monthly",
                                                    defaultMessage: "Monthly"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                            className: (0, $2jatx.default)([
                                                "_1e0c1txw _1n261q9c"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
                                                    htmlFor: "ANNUAL",
                                                    className: (0, $2jatx.default)([
                                                        "_80omtlke _zulpftgi _1e0c1txw _4cvr1h6o"
                                                    ]),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                                            type: "radio",
                                                            id: "ANNUAL",
                                                            "aria-describedby": "annual-save-hint",
                                                            "data-testid": "billing-radio-annual",
                                                            name: "billing",
                                                            checked: billingCycle === 'ANNUAL',
                                                            onChange: handleRadioChange,
                                                            className: (0, $2jatx.default)([
                                                                "_bfhki0pe _19it1pkj _2rko1ssb _80omtlke _1e0c1txw _1bsb1tcg _4t3i1tcg _19pkidpf _2hwxidpf _otyridpf _18u0idpf _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _12ji1r31 _1qu2glyw _12y31o36 _t9ec1s1q _v564lstf _s7n4jp4b _r06hglyw _858ub0wy _1di64m1f _irr34m1f _z0ai1cbz _1qdg1cbz _18postnw _1hfki0pe _14mj1ssb _aetrb3bt _1peqidpf _qc5o16qv _h0k6rbzz _9e6urbzz _1q44oelr _dhyqkb7n _1jb3u67f _xqvjrbzz _ga64yh40 _sfejglyw _128ydlk8 _1199dlk8 _12gnrbzz _kl6cu67f _1htqn7od _1e7g1m1a"
                                                            ])
                                                        }),
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                                            id: "Pricing.priceFinderInputs.anually",
                                                            defaultMessage: "Annually"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                    id: "annual-save-hint",
                                                    className: (0, $2jatx.default)([
                                                        "_1bsb1ns9 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _bozg1y44 _1p1dangw _1rkb1wdt _1rfm1osq _q5ugidpf _7tldidpf _14adidpf _4uroidpf _11cg1y44 _xsmrusic"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $20Gca.default), {
                                                        appearance: "inprogress",
                                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                                            id: "Pricing.priceFinderInputs.saveUpTo",
                                                            defaultMessage: "SAVE UP TO 17%"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};

});





parcelRegister("8IsVQ", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorAutomation", function () { return $ca484168b962bf16$export$7f9d44dab84ab3fb; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");

var $k6PTJ = parcelRequire("k6PTJ");

var $cR8Gg = parcelRequire("cR8Gg");

var $bspxF = parcelRequire("bspxF");

var $hswtB = parcelRequire("hswtB");

var $3LcIp = parcelRequire("3LcIp");

var $l7lLR = parcelRequire("l7lLR");

var $4X0dO = parcelRequire("4X0dO");

var $hZuN8 = parcelRequire("hZuN8");

var $izdHQ = parcelRequire("izdHQ");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $ca484168b962bf16$export$7f9d44dab84ab3fb = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $hZuN8.useExperimentExposure)((0, $4X0dO.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cR8Gg.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Automation.start-with-page.title',
                defaultMessage: 'Start with a page'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Automation.start-with-page.body',
                defaultMessage: 'Plan projects, share knowledge, and automate workflows, all in one place.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp',
            imgAltText: 'A Confluence page being edited'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Automation.supercharge-productivity.title',
                defaultMessage: 'Supercharge productivity'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Automation.supercharge-productivity.body',
                defaultMessage: 'Save time by automating repetitive, manual tasks.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/qrpd4w43508d10hq328mq05417ilsc7y.webp',
            imgAltText: 'Confluence automating emails'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Automation.connect-work.title',
                defaultMessage: 'Connect all your work'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Automation.connect-work.body',
                defaultMessage: 'Stay organized in dedicated workspaces, equipped with AI-powered search.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp',
            imgAltText: 'Organized workspace in Confluence'
        }
    ];
    const carouselHeroProps = {
        'aria-label': 'A display of various confluence features',
        id: 'confluence-automation-carousel',
        slides: carouselSlides
    };
    const pageId = 'anchor-lp-conf-automation';
    const isLoggedIn = !!userProfileName;
    let customHeroSection;
    const getLiftShiftHeroSectionBrandUpdate = ()=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bspxF.PaidHeroCarousel), {
            pageId: pageId,
            embeddedSignup: {
                bundle: 'confluence'
            },
            carouselSlides: carouselSlides,
            shouldUseNewBrandBackground: true,
            shouldUseTransparentBackground: true
        });
    };
    if (isLoggedIn) {
        if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
            experimentKey: "cfind-2801-get-paid-users-back-to-product",
            group: "Test",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
                confluenceSites: recentSites,
                userProfileName: userProfileName,
                hideExploreMore: true,
                loggedInPaid: true
            })
        });
        else customHeroSection = getLiftShiftHeroSectionBrandUpdate();
    } else // Logged out user
    customHeroSection = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3LcIp.BanditsProvider), {
        product: (0, $l7lLR.BANDITS_PRODUCT).CONFLUENCE,
        keyword: pageProps.keyword,
        isExperimentEnabled: true,
        useCase: (0, $l7lLR.BANDITS_USE_CASE).ANCHOR_JOURNEY_SUB_ANCHOR,
        subAnchor: pageProps.subAnchor || '',
        channel: pageProps.utmMedium || 'paid-search',
        utmContent: pageProps.utmContent || '',
        utmCampaign: pageProps.utmCampaign || '',
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
            experimentKey: "cfind-3090-paid-confluence-product-tour",
            group: "Test",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), {
                ...pageProps,
                pageId: pageId,
                persona: "unknown",
                pageVariant: "brandUpdate",
                dataProductKey: "confluence-PaidLpConfAnchorAutomation",
                keyword: pageProps.keyword,
                carouselHeroProps: carouselHeroProps,
                customHeroSection: customHeroSection
            })
        })
    });
};

});
parcelRegister("cR8Gg", function(module, exports) {
$parcel$export(module.exports, "useLogMeInD0to6", function () { return $83b6c6a3b1991cc3$export$dc29ba926b713c7f; });

var $6gVNd = parcelRequire("6gVNd");

var $2WL8B = parcelRequire("2WL8B");
const $83b6c6a3b1991cc3$export$dc29ba926b713c7f = ({ availableProducts: availableProducts, userProfile: userProfile })=>{
    const confluenceD0to6 = (0, $2WL8B.useConfluenceD0to6)();
    const useLogMeInOriginalResponse = (0, $6gVNd.useLogMeIn)({
        availableProducts: availableProducts,
        userProfile: userProfile,
        siteType: (0, $6gVNd.AtlSiteType).CONFLUENCE
    });
    const shouldShowLogMeIn = !!confluenceD0to6 && useLogMeInOriginalResponse.shouldShowLogMeIn;
    return {
        userProfileName: useLogMeInOriginalResponse.userProfileName,
        recentSites: useLogMeInOriginalResponse.recentSites,
        shouldShowLogMeIn: shouldShowLogMeIn
    };
};

});
parcelRegister("6gVNd", function(module, exports) {
$parcel$export(module.exports, "AtlSiteType", function () { return $eb6f3bd622284567$export$25e165f6cdbb7fba; });
$parcel$export(module.exports, "useLogMeIn", function () { return $eb6f3bd622284567$export$3b3e141b692cc8f3; });

var $3riD8 = parcelRequire("3riD8");
var $eb6f3bd622284567$export$25e165f6cdbb7fba = /*#__PURE__*/ function(AtlSiteType) {
    AtlSiteType["CONFLUENCE"] = "confluence.ondemand";
    AtlSiteType["JIRA"] = "jira-software.ondemand";
    return AtlSiteType;
}({});
const $eb6f3bd622284567$var$filterAvailableSites = (availableProducts, siteType)=>{
    if (availableProducts) {
        const filteredSites = availableProducts.sites.filter((site)=>{
            return site.products.includes(siteType);
        }) || [];
        return filteredSites;
    } else return [];
};
const $eb6f3bd622284567$export$3b3e141b692cc8f3 = ({ availableProducts: availableProducts, userProfile: userProfile, siteType: siteType = "confluence.ondemand" })=>{
    const filteredSites = $eb6f3bd622284567$var$filterAvailableSites(availableProducts, siteType);
    const loggedInUserName = (0, $3riD8.useLoggedInUser)().name;
    const userProfileName = userProfile?.name || loggedInUserName;
    return {
        userProfileName: userProfileName,
        recentSites: filteredSites,
        shouldShowLogMeIn: !!userProfileName && filteredSites.length > 0
    };
};

});


parcelRegister("bspxF", function(module, exports) {
$parcel$export(module.exports, "PaidHeroCarousel", function () { return $3b471d0a49843259$export$f092ba03447984fe; });
/* paid-hero-carousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $iL9dx = parcelRequire("iL9dx");

var $3LcIp = parcelRequire("3LcIp");

var $izdHQ = parcelRequire("izdHQ");

var $cudmb = parcelRequire("cudmb");
const $3b471d0a49843259$var$paidHeroContainerStyles = null;
const $3b471d0a49843259$var$backgroundGradient = null;
const $3b471d0a49843259$var$paidHeroContentStyles = null;
const $3b471d0a49843259$var$blockStartPadding = null;
const $3b471d0a49843259$var$signUpFormContainerStyles = null;
const $3b471d0a49843259$var$carouselContainerStyles = null;
const $3b471d0a49843259$var$rebrandBackground = null;
const $3b471d0a49843259$export$f092ba03447984fe = ({ pageId: pageId, carouselSlides: carouselSlides, shouldUseTransparentBackground: shouldUseTransparentBackground, shouldUseBlockStartPadding: shouldUseBlockStartPadding = true, shouldUseNewBrandBackground: shouldUseNewBrandBackground, usePlainContainer: usePlainContainer })=>{
    const intl = (0, $8e22h.default)();
    const isLiftAndShiftExposure = pageId === 'paid-lp-conf-features' || pageId === 'confluence-default';
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
        experimentKey: isLiftAndShiftExposure ? 'cfind-1466-lift-and-shift' : 'wac-conf-anchors-lift-and-shift',
        group: isLiftAndShiftExposure ? 'treatmentA' : 'Test',
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            id: "start-trial",
            className: (0, $2jatx.default)([
                "_1e0c1txw _1bah1h6o",
                !shouldUseTransparentBackground && "_11q7i1wq",
                shouldUseNewBrandBackground && "_1pfh1wqb _kqswh2mm _1kt9b3bt _1cs8stnw _iajmgktf _z5wtidpf _1enw53f4 _1rusuzct _1fkrymf6 _7dwz16qr _8kay1h6o _1g0v1oqz _dsq4glyw _aetrb3bt _18postnw _1hfkuzct _19nq1h39 _g0nfuuw1 _1czdidpf _1gufidpf _clh31mo7 _1tlb1h6o _1bqq1oqz _11fnglyw"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1tke1fbq _p12fzqdx _gy1pckbl _1p571tcg _1bsb1osq _1bah1h6o",
                    shouldUseBlockStartPadding && "_1q511wqb"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _1bah1h6o _4cvr1h6o _16jlkb7n _1o9zkb7n _i0dl1osq _p12f1usy"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
                            name: isLiftAndShiftExposure ? 'conf-lift-and-shift-features-signup-module' : 'conf-lift-and-shift-signup-module',
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cudmb.EmbeddedSignupForm), {
                                pageId: pageId
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_4cvr1h6o _1e0c1txw _1bah1h6o _1ul91178 _16jlkb7n _1o9zkb7n _i0dl1osq _y4tizwfg _sugaglyw"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3LcIp.BanditsAssetWrapper), {
                            product: "confluence",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
                                name: isLiftAndShiftExposure ? 'cfind-1466-carousel' : 'conf-lift-and-shift-carousel',
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iL9dx.Carousel), {
                                    "aria-label": intl.formatMessage({
                                        id: 'ConfluenceSoftwarePage.v4.CarouselHero.AriaLabel',
                                        defaultMessage: 'A display of various confluence features',
                                        description: 'Aria label for the carousel section'
                                    }),
                                    slides: carouselSlides,
                                    id: "confluence-features-carousel",
                                    usePlainContainer: usePlainContainer
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};

});
parcelRegister("iL9dx", function(module, exports) {
$parcel$export(module.exports, "Carousel", function () { return $7acb0827f4cf9b6c$export$144901db2ea8e967; });
/* carousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $clnBI = parcelRequire("clnBI");

var $Lp2P8 = parcelRequire("Lp2P8");

var $ep4tq = parcelRequire("ep4tq");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");

var $hJfqz = parcelRequire("hJfqz");
const $7acb0827f4cf9b6c$var$carouselSlideStyle = null;
const $7acb0827f4cf9b6c$var$imageStyle = null;
const $7acb0827f4cf9b6c$var$infoContainerStyle = null;
const $7acb0827f4cf9b6c$var$textContainerStyle = null;
const $7acb0827f4cf9b6c$var$primaryTextStyle = null;
const $7acb0827f4cf9b6c$var$subTextStyle = null;
const $7acb0827f4cf9b6c$var$anchorPrimaryTextStyle = null;
const $7acb0827f4cf9b6c$var$anchorSubTextStyle = null;
const $7acb0827f4cf9b6c$var$plainImageContainer = null;
const $7acb0827f4cf9b6c$export$cabb5ccfbd60cbd4 = ({ primaryText: primaryText, description: description, imgSrc: imgSrc, imgAltText: imgAltText, id: id, stylingType: stylingType, usePlainContainer: usePlainContainer })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        role: "tabpanel",
        id: id,
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp7vkz"
        ]),
        children: [
            stylingType === 'anchor' ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                image: {
                    src: imgSrc,
                    alt: ''
                },
                className: (0, $2jatx.default)([
                    "_1bsb1osq"
                ])
            }) : usePlainContainer ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1reo15vq _18m915vq"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                    src: imgSrc,
                    alt: imgAltText,
                    className: (0, $2jatx.default)([
                        "_1bsb1osq"
                    ])
                })
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ep4tq.Adg4RaisedMedia), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                    src: imgSrc,
                    alt: imgAltText,
                    className: (0, $2jatx.default)([
                        "_1bsb1osq"
                    ])
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1yb4 _4cvr1h6o _195g1tcg _zulp7vkz _1tke53f4"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _1bsb1osq"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                "_k48pni7l",
                                stylingType === 'anchor' && "_y3gn1h6o _syaz1pfd _ect41vau _1wyb1k8s _k48p1fw0 _vwz4l07h _6rth14y2"
                            ]),
                            style: {
                                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                            },
                            children: primaryText
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                "_k48p1nn1",
                                stylingType === 'anchor' && "_y3gn1h6o _syaz1pfd _1wyb1j6v _vwz41k8s"
                            ]),
                            style: {
                                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                            },
                            children: description
                        })
                    ]
                })
            })
        ]
    });
};
const $7acb0827f4cf9b6c$var$carouselTabListStyle = null;
const $7acb0827f4cf9b6c$var$dotStyle = null;
const $7acb0827f4cf9b6c$var$currentDotStyle = null;
const $7acb0827f4cf9b6c$var$carouselStyles = null;
const $7acb0827f4cf9b6c$var$controlsContainerStyles = null;
const $7acb0827f4cf9b6c$var$centeredControlsContainerStyles = null;
const $7acb0827f4cf9b6c$var$rightAlignedControlsContainerStyles = null;
const $7acb0827f4cf9b6c$export$144901db2ea8e967 = ({ 'aria-label': ariaLabel, slides: slides, id: carouselId, showPlayButton: showPlayButton = true, stylingType: stylingType, usePlainContainer: usePlainContainer })=>{
    const intl = (0, $8e22h.default)();
    const cycleTime = 7000;
    const timeoutRef = (0, $1oC0p.useRef)(null);
    const tabsRef = (0, $1oC0p.useRef)({});
    const [visibleSlideIndex, _setVisibleSlideIndex] = (0, $1oC0p.useState)(0);
    const visibleSlide = slides[visibleSlideIndex];
    if (visibleSlide === undefined) throw new Error('Slide index out of bounds.');
    const setVisibleSlideIndex = (newState, moveFocus = false)=>{
        _setVisibleSlideIndex((prevState)=>{
            let calculatedState;
            if (typeof newState === 'function') calculatedState = newState(prevState);
            else calculatedState = newState;
            moveFocus && tabsRef?.current[calculatedState]?.focus();
            return calculatedState;
        });
    };
    const moveToPreviousSlide = (moveFocus = false)=>{
        setVisibleSlideIndex((prev)=>{
            return prev === 0 ? slides.length - 1 : prev - 1;
        }, moveFocus);
    };
    const moveToNextSlide = (0, $1oC0p.useCallback)((moveFocus = false)=>{
        setVisibleSlideIndex((prev)=>{
            return prev === slides.length - 1 ? 0 : prev + 1;
        }, moveFocus);
    }, [
        slides.length
    ]);
    const [isRotating, setIsRotating] = (0, $1oC0p.useState)(true);
    const stopRotating = ()=>{
        timeoutRef?.current !== null && window.clearInterval(timeoutRef.current);
        setIsRotating(false);
    };
    const startRotating = ()=>{
        timeoutRef.current = window.setInterval(()=>{
            moveToNextSlide();
        }, cycleTime);
        setIsRotating(true);
    };
    const toggleRotating = ()=>{
        isRotating ? stopRotating() : startRotating();
    };
    (0, $1oC0p.useEffect)(startRotating, [
        moveToNextSlide
    ]);
    const handleKeyDown = (e)=>{
        switch(e.key){
            case 'ArrowRight':
                moveToNextSlide(true);
                break;
            case 'ArrowLeft':
                moveToPreviousSlide(true);
                break;
            case 'Home':
                setVisibleSlideIndex(0, true);
                break;
            case 'End':
                setVisibleSlideIndex(slides.length - 1, true);
                break;
            default:
                return;
        }
        stopRotating();
        e.preventDefault();
    };
    const handleTabClick = (index)=>{
        stopRotating();
        setVisibleSlideIndex(index);
    };
    const handlePreviousClick = ()=>{
        stopRotating();
        moveToPreviousSlide();
    };
    const handleNextClick = ()=>{
        stopRotating();
        moveToNextSlide();
    };
    const getSlideId = (suffix)=>`${carouselId}-${suffix}`;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        "aria-label": ariaLabel,
        "aria-roledescription": "carousel",
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "aria-atomic": false,
                "aria-live": isRotating ? 'off' : 'polite',
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($7acb0827f4cf9b6c$export$cabb5ccfbd60cbd4, {
                    ...visibleSlide,
                    id: getSlideId(visibleSlideIndex),
                    stylingType: stylingType,
                    usePlainContainer: usePlainContainer
                }, visibleSlide.primaryText)
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _1lmceh92 _yv0e1n6q _zulpe2fx"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_nd5l1h6o _1e0c1txw _4cvr1h6o _zulp7vkz"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hJfqz.ArrowButton), {
                                onClick: handlePreviousClick,
                                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($clnBI))), {
                                    label: ""
                                }),
                                "aria-label": intl.formatMessage({
                                    id: 'confluence.paid.lp.carousel.previous.label',
                                    defaultMessage: 'Previous slide'
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                role: "tablist",
                                "aria-label": intl.formatMessage({
                                    id: 'confluence.paid.lp.carousel.tablist.label',
                                    defaultMessage: 'Choose a slide to display.'
                                }),
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _zulp1tcg"
                                ]),
                                children: slides.map((slide, index)=>{
                                    const isVisibleTab = visibleSlideIndex === index;
                                    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        "aria-controls": getSlideId(index),
                                        "aria-selected": isVisibleTab,
                                        role: "tab",
                                        "aria-label": intl.formatMessage({
                                            id: 'confluence.paid.lp.carousel.tab.label',
                                            defaultMessage: `Slide {slideNumber}`
                                        }, {
                                            slideNumber: `${index + 1}`
                                        }),
                                        tabIndex: isVisibleTab ? 0 : -1,
                                        onKeyDown: handleKeyDown,
                                        onClick: ()=>handleTabClick(index),
                                        ref: (node)=>{
                                            if (node) tabsRef.current[index] = node;
                                        },
                                        className: (0, $2jatx.default)([
                                            "_2rko1ssb _80omtlke _1bsb1crf _4t3i1crf _bfhk1afi",
                                            isVisibleTab && "_bfhkrbzz"
                                        ]),
                                        style: {
                                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                                        }
                                    }, `${slide.primaryText}-${index}`);
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hJfqz.ArrowButton), {
                                onClick: handleNextClick,
                                "aria-label": intl.formatMessage({
                                    id: 'confluence.paid.lp.carousel.next.label',
                                    defaultMessage: 'Next slide'
                                }),
                                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($Lp2P8))), {
                                    label: ""
                                })
                            })
                        ]
                    }),
                    showPlayButton && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_nd5lusic"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hJfqz.PlayPauseButton), {
                            onClick: toggleRotating,
                            isRotating: isRotating
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("hJfqz", function(module, exports) {
$parcel$export(module.exports, "ArrowButton", function () { return $5af61a161d3fd22c$export$15d663f77d176497; });
$parcel$export(module.exports, "PlayPauseButton", function () { return $5af61a161d3fd22c$export$e0201548afaa4886; });
/* carouselButtons.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $hoqkG = parcelRequire("hoqkG");

var $ic7ym = parcelRequire("ic7ym");
const $5af61a161d3fd22c$var$iconButtonStyles = null;
const $5af61a161d3fd22c$export$15d663f77d176497 = ({ onClick: onClick, icon: icon, 'aria-label': ariaLabel })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        onClick: onClick,
        "aria-label": ariaLabel,
        className: (0, $2jatx.default)([
            "_19it8cnq _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _4cvr1h6o _1bah1h6o _80omtlke _4t3izwfg _1bsbzwfg"
        ]),
        children: icon
    });
};
const $5af61a161d3fd22c$export$e0201548afaa4886 = ({ onClick: onClick, isRotating: isRotating })=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        onClick: onClick,
        className: (0, $2jatx.default)([
            "_19it8cnq _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _4cvr1h6o _1bah1h6o _80omtlke _4t3izwfg _1bsbzwfg"
        ]),
        children: isRotating ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hoqkG))), {
            label: intl.formatMessage({
                id: 'confluence.paid.lp.carousel.pause',
                defaultMessage: 'Pause carousel'
            })
        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ic7ym))), {
            label: intl.formatMessage({
                id: 'confluence.paid.lp.carousel.play',
                defaultMessage: 'Play carousel'
            })
        })
    });
};

});
parcelRegister("ic7ym", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::92409a0bcef1d03143cf6035c99e88da>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d3ef34e53550051b$var$_react = $d3ef34e53550051b$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $d3ef34e53550051b$var$_baseNew = $d3ef34e53550051b$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $d3ef34e53550051b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPlay".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for play video in Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d3ef34e53550051b$var$VideoPlayIcon = (props)=>/*#__PURE__*/ $d3ef34e53550051b$var$_react.default.createElement($d3ef34e53550051b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.112C2 1.592 3.63.627 4.963 1.36l8.902 4.888c1.383.76 1.383 2.747 0 3.506l-8.902 4.888C3.63 15.373 2 14.408 2 12.888zm2.24-.438a.5.5 0 0 0-.74.438v9.776a.5.5 0 0 0 .74.438l8.903-4.888a.5.5 0 0 0 0-.876z" clip-rule="evenodd"/>`
    }, props));
$d3ef34e53550051b$var$VideoPlayIcon.displayName = 'VideoPlayIcon';
var $d3ef34e53550051b$var$_default = module.exports.default = $d3ef34e53550051b$var$VideoPlayIcon;

});



parcelRegister("3LcIp", function(module, exports) {
$parcel$export(module.exports, "BanditsProvider", function () { return $6869915d6a46ae95$export$ed6616ed0f76d929; });
$parcel$export(module.exports, "BanditsHeaderWrapper", function () { return $6869915d6a46ae95$export$1cb749e21ac9e393; });
$parcel$export(module.exports, "BanditsAssetWrapper", function () { return $6869915d6a46ae95$export$f9fbacfdb5ded657; });
/* bandits-components.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable complexity */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iZHH7 = parcelRequire("iZHH7");

var $eUwCn = parcelRequire("eUwCn");

var $fcO7r = parcelRequire("fcO7r");

var $hnmMQ = parcelRequire("hnmMQ");

var $bSVv5 = parcelRequire("bSVv5");

var $l7lLR = parcelRequire("l7lLR");

var $kf4PU = parcelRequire("kf4PU");

var $gx3aw = parcelRequire("gx3aw");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
const $6869915d6a46ae95$export$3f24bc358fd1cb5b = 'en-US';
const $6869915d6a46ae95$export$6c5330c3ff3e7abf = (wacLocale)=>wacLocale && (0, $kf4PU.WAC_TO_CPAPI_LOCALE_MAP)[wacLocale] || $6869915d6a46ae95$export$3f24bc358fd1cb5b;
const $6869915d6a46ae95$var$BanditsContext = /*#__PURE__*/ (0, $1oC0p.createContext)({
    banditsContent: null,
    loading: false,
    error: null,
    isExperimentEnabled: false
});
const $6869915d6a46ae95$export$ed6616ed0f76d929 = ({ product: product, keyword: keyword, isExperimentEnabled: isExperimentEnabled = false, useCase: useCase = (0, $l7lLR.BANDITS_USE_CASE).ANCHOR_JOURNEY, subAnchor: subAnchor = '', channel: channel = '', utmContent: utmContent = '', utmCampaign: utmCampaign = '', children: children })=>{
    const anonymousId = decodeURIComponent((0, $gx3aw.Cookie).readCookie('ajs_anonymous_id') || '').replace(/['"]+/g, '');
    // D1D6-560: use the page locale instead of hardcoded en-US. Bandit content only
    // exists in en-US, so on non-EN pages skip the bandit override and keep the
    // localized SSR hero rather than swapping in an English headline.
    // Read intl via context (not useIntl) so the provider still renders without an IntlProvider.
    const pageLocale = (0, $1oC0p.useContext)((0, $iZHH7.Context))?.locale;
    // Memoised so the gate (and its Sentry exposure) is only checked when isExperimentEnabled changes.
    const isLocaleFixEnabled = (0, $1oC0p.useMemo)(()=>isExperimentEnabled && (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).d1d6BanditsLocaleFix), [
        isExperimentEnabled
    ]);
    const banditsLocale = isLocaleFixEnabled ? $6869915d6a46ae95$export$6c5330c3ff3e7abf(pageLocale) : $6869915d6a46ae95$export$3f24bc358fd1cb5b;
    const isBanditsEnabled = isExperimentEnabled && (!isLocaleFixEnabled || banditsLocale === $6869915d6a46ae95$export$3f24bc358fd1cb5b);
    const [banditsContent, setBanditsContent] = (0, $1oC0p.useState)(isBanditsEnabled ? null : (0, $l7lLR.nullBanditsContent));
    const [loading, setLoading] = (0, $1oC0p.useState)(isBanditsEnabled);
    const [error, setError] = (0, $1oC0p.useState)(null);
    // D1D6-561: only evaluated when bandits will actually fetch, to avoid exposures on non-bandit
    // pages (including non-EN pages skipped by the D1D6-560 locale fix).
    // Memoised so the gate (and its Sentry exposure) is only checked when isBanditsEnabled changes.
    const isAsyncErrorFixEnabled = (0, $1oC0p.useMemo)(()=>isBanditsEnabled && (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).d1d6BanditsAsyncErrorFix), [
        isBanditsEnabled
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (!isBanditsEnabled) return;
        const fetchBanditsContent = async ()=>{
            const content = await (0, $l7lLR.getGrsAndContentfulContent)({
                keyword: keyword || '',
                product: product,
                locale: banditsLocale,
                anonymousId: anonymousId,
                useCase: useCase,
                subAnchor: subAnchor,
                channel: channel,
                utmContent: utmContent,
                utmCampaign: utmCampaign
            });
            if (content?.recoSessionId) {
                // Map BanditsProduct to a productKey string for storage
                const productKey = product === 'jira' ? (0, $fcO7r.ProductKey).JIRA_SOFTWARE : (0, $fcO7r.ProductKey).CONFLUENCE;
                (0, $l7lLR.setGrsDataToLocalStorage)({
                    recoSessionId: content.recoSessionId,
                    recoEntityId: content.recoEntityId
                }, productKey);
            }
            return content;
        };
        if (isAsyncErrorFixEnabled) {
            // Await the fetch so errors are caught and loading reflects the request. On
            // failure fall back to nullBanditsContent so wrappers render the default hero
            // instead of a stuck skeleton. Ignore results after unmount or a deps change.
            let cancelled = false;
            const loadBanditsContent = async ()=>{
                try {
                    const content = await fetchBanditsContent();
                    if (!cancelled) setBanditsContent(content);
                } catch (e) {
                    if (!cancelled) {
                        setError(e instanceof Error ? e : new Error(String(e)));
                        setBanditsContent((0, $l7lLR.nullBanditsContent));
                    }
                } finally{
                    if (!cancelled) setLoading(false);
                }
            };
            loadBanditsContent();
            return ()=>{
                cancelled = true;
            };
        }
        // Legacy behaviour (gate off): unchanged.
        const getBanditsContent = async ()=>{
            setBanditsContent(await fetchBanditsContent());
        };
        try {
            getBanditsContent();
        } catch (e) {
            setError(e);
        } finally{
            setLoading(false);
        }
    }, [
        isBanditsEnabled,
        banditsLocale,
        isAsyncErrorFixEnabled,
        keyword,
        product,
        anonymousId,
        useCase,
        subAnchor,
        channel,
        utmContent,
        utmCampaign
    ]);
    const value = (0, $1oC0p.useMemo)(()=>({
            banditsContent: banditsContent,
            loading: loading,
            error: error,
            isExperimentEnabled: isBanditsEnabled
        }), [
        banditsContent,
        loading,
        error,
        isBanditsEnabled
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($6869915d6a46ae95$var$BanditsContext.Provider, {
        value: value,
        children: children
    });
};
const $6869915d6a46ae95$export$d85787cef2955e0c = ()=>{
    const context = (0, $1oC0p.useContext)($6869915d6a46ae95$var$BanditsContext);
    if (!context) console.info('useBanditsContext is not used within a BanditsProvider');
    return context;
};
// Wrapper Components
const $6869915d6a46ae95$var$imgContainer = null;
const $6869915d6a46ae95$var$confluenceImgContainer = null;
const $6869915d6a46ae95$export$1cb749e21ac9e393 = ({ product: product, type: type = 'header', children: children })=>{
    const { banditsContent: banditsContent, loading: loading, error: error, isExperimentEnabled: isExperimentEnabled } = $6869915d6a46ae95$export$d85787cef2955e0c();
    const SkeletonComponent = product === 'jira' ? $6869915d6a46ae95$export$15339ba7c5b3a2b8 : $6869915d6a46ae95$export$ce1a828edc281b5e;
    if (loading || !banditsContent && isExperimentEnabled) return /*#__PURE__*/ (0, $7VQPk.jsx)(SkeletonComponent, {
        type: type
    });
    if (error || !banditsContent?.headline) return children;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: type === 'header' ? banditsContent?.headline?.title : banditsContent?.headline?.subheading
    });
};
const $6869915d6a46ae95$export$f9fbacfdb5ded657 = ({ product: product, showChildren: showChildren = false, children: children })=>{
    const { banditsContent: banditsContent, loading: loading, error: error, isExperimentEnabled: isExperimentEnabled } = $6869915d6a46ae95$export$d85787cef2955e0c();
    if (loading || !banditsContent && isExperimentEnabled) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _p12fcv93 _1bah1h6o _1e0cglyw _181n1txw"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($6869915d6a46ae95$export$8a7df558a5bc35a7, {})
    });
    if (showChildren || error || !banditsContent?.asset || banditsContent?.asset?.id === (0, $l7lLR.JIRA_FEATURES_ASSET_CONTROL) || banditsContent?.asset?.id === (0, $l7lLR.CONFLUENCE_FEATURES_ASSET_CONTROL) || (0, $l7lLR.isConfluenceSubAnchorAssetControl)(banditsContent?.asset?.id)) return children;
    const image1OrangeLogic = banditsContent?.asset?.image1OrangeLogic;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1e0c1txw _1bah1h6o _c71lstmo _1bsb1osq _p12f1kpv",
            product === 'confluence' && "_1ul91178 _p12f1osq _16jlkb7n _1o9zkb7n _i0dl1osq _sugaglyw",
            image1OrangeLogic && "_1bsb1wug _16jlidpf _1o9zkb7n _i0dl1wug"
        ]),
        children: banditsContent?.asset?.video1Mp4?.url ? /*#__PURE__*/ (0, $7VQPk.jsxs)("video", {
            autoPlay: true,
            loop: true,
            muted: true,
            playsInline: true,
            preload: "auto",
            poster: banditsContent?.asset?.image1?.url,
            controls: true,
            className: (0, $2jatx.default)([
                "_c71lcv93 _p12f1osq"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                    src: banditsContent?.asset?.video1Mp4?.url,
                    type: "video/mp4"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                    src: banditsContent?.asset?.video1Webm?.url,
                    type: "video/webm"
                })
            ]
        }) : image1OrangeLogic ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_p12fcv93 _c71l1ogm"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                src: image1OrangeLogic.assetUrl || '',
                alt: image1OrangeLogic.alt ?? ''
            })
        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
            image: {
                src: banditsContent?.asset?.image1?.url || '',
                alt: banditsContent?.asset?.image1?.description || ''
            },
            className: (0, $2jatx.default)([
                "_c71lcv93"
            ])
        })
    });
};
// Skeleton Components
const $6869915d6a46ae95$var$sectionGap = null;
const $6869915d6a46ae95$var$desktopDisplay = null;
const $6869915d6a46ae95$var$tabletDisplay = null;
const $6869915d6a46ae95$var$mobileDisplay = null;
const $6869915d6a46ae95$var$containerStyles = null;
const $6869915d6a46ae95$export$15339ba7c5b3a2b8 = ({ type: type })=>{
    if (type === 'subheader') return;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "hero-header-skeleton",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _dm251ule"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _dh1a1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rthu2gc"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "420px",
                                height: "64px"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rthu2gc"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "360px",
                                height: "64px"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _kzvi1ule"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _dh1a1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rthu2gc"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "680px",
                                height: "64px"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rthu2gc"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "460px",
                                height: "64px"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _suga1ule"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _dh1a1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rthu2gc"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "320px",
                                height: "64px"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rthu2gc"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "280px",
                                height: "64px"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rthu2gc"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "240px",
                                height: "64px"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const $6869915d6a46ae95$export$ce1a828edc281b5e = ({ type: type })=>{
    if (type === 'subheader') return;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_6rthu2gc"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                    width: "280px",
                    height: "32px"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_6rthu2gc"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                    width: "300px",
                    height: "32px"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_6rthu2gc"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                    width: "320px",
                    height: "32px"
                })
            })
        ]
    });
};
const $6869915d6a46ae95$export$8a7df558a5bc35a7 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "hero-asset-skeleton",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _dm251ule"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                    width: "600px",
                    height: "480px"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _kzvi1ule"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                    width: "420px",
                    height: "280px"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _suga1ule"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                    width: "250px",
                    height: "200px"
                })
            })
        ]
    });
};

});
parcelRegister("eUwCn", function(module, exports) {
$parcel$export(module.exports, "Adg4Skeleton", function () { return $a7f43d28d2add36d$export$e754784845e8828d; });

var $7VQPk = parcelRequire("7VQPk");

var $4jcRW = parcelRequire("4jcRW");

var $lP7A9 = parcelRequire("lP7A9");

var $kbpa7 = parcelRequire("kbpa7");
const $a7f43d28d2add36d$export$e754784845e8828d = ({ width: width, height: height, groupName: groupName, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4jcRW.default), {
        width: width,
        height: height,
        groupName: groupName,
        testId: testId,
        isShimmering: true,
        borderRadius: (0, $lP7A9.default)('space.100'),
        color: (0, $kbpa7.wacToken)('color.neutral.light200'),
        ShimmeringEndColor: (0, $kbpa7.wacToken)('color.neutral.light300'),
        ...props
    });
};

});
parcelRegister("4jcRW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3232eb4c0efd91e0$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $c9bqK = parcelRequire("c9bqK");

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $7DAIH = parcelRequire("7DAIH");
var $dtlzK = parcelRequire("dtlzK");
function $3232eb4c0efd91e0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3232eb4c0efd91e0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3232eb4c0efd91e0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3232eb4c0efd91e0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3232eb4c0efd91e0$var$shimmerKeyframes = null;
var $3232eb4c0efd91e0$var$skeletonStyles = null;
var $3232eb4c0efd91e0$var$activeShimmerStyles = null;
/**
 * __Skeleton__
 *
 * A skeleton acts as a placeholder for content, usually while the content loads.
 *
 * - [Examples](https://atlassian.design/components/skeleton/examples)
 * - [Code](https://atlassian.design/components/skeleton/code)
 */ var $3232eb4c0efd91e0$var$Skeleton = function Skeleton(_ref) {
    var width = _ref.width, height = _ref.height, _ref$borderRadius = _ref.borderRadius, borderRadius = _ref$borderRadius === void 0 ? "var(--ds-radius-small, 4px)" : _ref$borderRadius, color = _ref.color, ShimmeringEndColor = _ref.ShimmeringEndColor, _ref$isShimmering = _ref.isShimmering, isShimmering = _ref$isShimmering === void 0 ? false : _ref$isShimmering, groupName = _ref.groupName, testId = _ref.testId;
    var groupDataAttribute = groupName && "data-".concat(groupName);
    return /*#__PURE__*/ $1oC0p.createElement("div", (0, $c9bqK.default)({
        "data-testid": testId
    }, groupDataAttribute && (0, $f53LC.default)({}, groupDataAttribute, 'true'), {
        className: (0, $7DAIH.default)([
            "_7hjf1yy8 _5sag12o8 _tip812c5 _1pglp3kn _bfhkn82g",
            isShimmering && "",
            isShimmering && "_j7hq586c"
        ]),
        style: $3232eb4c0efd91e0$var$_objectSpread($3232eb4c0efd91e0$var$_objectSpread({}, {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
            '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
            '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
        }), {}, {
            "--_wenvhl": (0, $dtlzK.default)("var(--ds-skeleton-from-color, ".concat("var(--ds-skeleton, #091E420F)", ")")),
            "--_1soe2er": (0, $dtlzK.default)("var(--ds-skeleton-to-color, ".concat("var(--ds-skeleton-subtle, #091E4208)", ")"))
        })
    }));
};
var $3232eb4c0efd91e0$export$2e2bcd8739ae039 = $3232eb4c0efd91e0$var$Skeleton;

});
parcelRegister("7DAIH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $58f8a8b7a32ab166$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $58f8a8b7a32ab166$var$ATOMIC_GROUP_LENGTH = 5;
function $58f8a8b7a32ab166$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $58f8a8b7a32ab166$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("dtlzK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9ceeb844cdd8c978$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $9ceeb844cdd8c978$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});




parcelRegister("cudmb", function(module, exports) {
$parcel$export(module.exports, "EmbeddedSignupForm", function () { return $4568c23a144289c5$export$7572837522fb3c8b; });

var $7VQPk = parcelRequire("7VQPk");

var $fcO7r = parcelRequire("fcO7r");

var $7GVWk = parcelRequire("7GVWk");

var $dx6hU = parcelRequire("dx6hU");

var $7Izt2 = parcelRequire("7Izt2");

var $b9dfy = parcelRequire("b9dfy");

var $2UACm = parcelRequire("2UACm");
const $4568c23a144289c5$export$2f0084313b87d4cc = {
    'paid-lp-conf-features': /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7Izt2.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "paid-lp-conf-features"
    }),
    'paid-lp-confl-documentation': /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7Izt2.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "paid-lp-confl-documentation"
    }),
    'paid-lp-confl-template': /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7Izt2.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "paid-lp-confl-template"
    }),
    'anchor-lp-conf-automation': /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7Izt2.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "anchor-lp-conf-automation"
    }),
    'anchor-lp-conf-collaboration': /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7Izt2.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "anchor-lp-conf-collaboration"
    }),
    'anchor-lp-conf-teamwork': /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7Izt2.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "anchor-lp-conf-teamwork"
    }),
    'anchor-lp-conf-work-management': /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7Izt2.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "anchor-lp-conf-work-management"
    }),
    'anchor-lp-conf-competitors': /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7Izt2.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "anchor-lp-conf-competitors"
    }),
    default: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $b9dfy.DefaultEmbeddedSignupForm), {}),
    'confluence-default': /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dx6hU.CFindEmbeddedSignupForm), {})
};
const $4568c23a144289c5$export$7572837522fb3c8b = ({ pageId: pageId })=>{
    const { product: product, user: user } = (0, $7GVWk.useUserContext)();
    if (user.isUserLoggedIn) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2UACm.LoggedInForm), {});
    let variantName = 'default';
    if (product?.key === (0, $fcO7r.ProductKey).CONFLUENCE) variantName = 'confluence-default';
    if (pageId in $4568c23a144289c5$export$2f0084313b87d4cc) variantName = pageId;
    return $4568c23a144289c5$export$2f0084313b87d4cc[variantName];
};

});
parcelRegister("dx6hU", function(module, exports) {
$parcel$export(module.exports, "CFindEmbeddedSignupForm", function () { return $0f104ab1090b0a33$export$30d022a977c0a6db; });
/* cfind-embedded-signup.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $fnHPc = parcelRequire("fnHPc");
var $iVyKn = parcelRequire("iVyKn");

var $6KUQg = parcelRequire("6KUQg");

var $3LcIp = parcelRequire("3LcIp");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $8GyVU = parcelRequire("8GyVU");

var $Mhvf3 = parcelRequire("Mhvf3");

var $4MWzW = parcelRequire("4MWzW");
const $0f104ab1090b0a33$var$confluenceEmbeddedExistingText = (0, $fnHPc.defineMessage)({
    id: 'BxpUiSignup.SignupForm.existingProduct.confluence.embedded',
    defaultMessage: 'Trying to access {product}? <logInLink>Log in</logInLink>'
});
const $0f104ab1090b0a33$export$30d022a977c0a6db = ()=>{
    const gwp9286ConfluenceAnchorUpdates = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp9286ConfluenceAnchorUpdates);
    const defaultHeader = gwp9286ConfluenceAnchorUpdates ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "GWP9286ConfluenceAnchorUpdates.header.confluence.features",
        defaultMessage: "Meet your new AI-powered workspace"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.features.gwp9286",
        defaultMessage: "Goodbye silos, hello teamwork with Confluence"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8GyVU.EmbeddedSignupFormWrapper), {
        hideFooter: true,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            "data-testid": "signup-form",
            className: (0, $2jatx.default)([
                "_4cvr1fhb _bfhku67f _16qsoopq _2rkogktf _syaz1bqd _1e0c1txw _2lx21bp4 _1bah1h6o _ca0qzwfg _u5f312am _n3tdzwfg _19bv12am _1bsb1erl"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                    className: (0, $2jatx.default)([
                        "_y4tivbgk _y3gn1qpp"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3LcIp.BanditsHeaderWrapper), {
                        product: "confluence",
                        type: "header",
                        children: defaultHeader
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    className: (0, $2jatx.default)([
                        "_1wyb1gpt _k48pocj5 _y3gn1qpp"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3LcIp.BanditsHeaderWrapper), {
                        product: "confluence",
                        type: "subheader",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "BxpUiSignup.SignupForm.subheader.1",
                            defaultMessage: "It's free for up to 10 users \u2014 no credit card needed."
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6KUQg.AccountCreation), {
                    Login: null
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4MWzW.SocialEndorsement), {}),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $Mhvf3.ExistingProductText), {
                    messageOverride: $0f104ab1090b0a33$var$confluenceEmbeddedExistingText
                })
            ]
        })
    });
};
const $0f104ab1090b0a33$var$containerStyle = null;
const $0f104ab1090b0a33$var$headerStyle = null;
const $0f104ab1090b0a33$var$subheaderStyle = null;

});
parcelRegister("6KUQg", function(module, exports) {
$parcel$export(module.exports, "AccountCreation", function () { return $42aa4ee4b4afed63$export$b841b541bc741e79; });

var $7VQPk = parcelRequire("7VQPk");

var $7u4F3 = parcelRequire("7u4F3");

var $cGEBM = parcelRequire("cGEBM");
const $42aa4ee4b4afed63$export$b841b541bc741e79 = ({ getContinueUrl: getContinueUrl, identityCobranding: identityCobranding, templateId: templateId, ...props })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $cGEBM.AccountCreationContextProvider), {
        getContinueUrl: getContinueUrl,
        identityCobranding: identityCobranding,
        templateId: templateId,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7u4F3.Content), {
            ...props
        })
    });

});
parcelRegister("7u4F3", function(module, exports) {
$parcel$export(module.exports, "Content", function () { return $6cc2293976038b02$export$7c6e2c02157bb7d2; });

var $7VQPk = parcelRequire("7VQPk");

var $lX14w = parcelRequire("lX14w");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $cGEBM = parcelRequire("cGEBM");

var $mG5bv = parcelRequire("mG5bv");

var $irRyj = parcelRequire("irRyj");

var $lJMiD = parcelRequire("lJMiD");

var $4qMMD = parcelRequire("4qMMD");

var $32ARy = parcelRequire("32ARy");

var $l7G9R = parcelRequire("l7G9R");

var $8K1Jw = parcelRequire("8K1Jw");
const $6cc2293976038b02$export$7c6e2c02157bb7d2 = ({ Submit: Submit = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l7G9R.Submit), {}), Input: Input = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $irRyj.Input), {}), Social: Social = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $32ARy.Social), {}), Separator: Separator = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4qMMD.Separator), {}), Error: Error = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $mG5bv.Error), {}), Login: Login = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lJMiD.Login), {}), TermsAndConditions: TermsAndConditions })=>{
    const { onSubmit: onSubmit } = (0, $cGEBM.useAccountCreationContext)();
    if (TermsAndConditions === undefined && (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).accountCreationTermsAndConditions)) TermsAndConditions = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8K1Jw.TermsAndConditions), {});
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lX14w.default), {
                onSubmit: onSubmit,
                isDisabled: false,
                children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("form", {
                        ...formProps,
                        autoComplete: "off",
                        "data-testid": "account-creation",
                        children: [
                            Input,
                            TermsAndConditions,
                            Submit
                        ]
                    })
            }),
            Error,
            Separator,
            Social,
            Login
        ]
    });
};

});
parcelRegister("cGEBM", function(module, exports) {
$parcel$export(module.exports, "useAccountCreationContext", function () { return $835e146085c3a79b$export$30b295205cfae694; });
$parcel$export(module.exports, "AccountCreationContextProvider", function () { return $835e146085c3a79b$export$b0a1b3550379fc78; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $buVH1 = parcelRequire("buVH1");

var $fFzjl = parcelRequire("fFzjl");

var $gPKCY = parcelRequire("gPKCY");

var $gZgIU = parcelRequire("gZgIU");

var $gfjAv = parcelRequire("gfjAv");

var $7GVWk = parcelRequire("7GVWk");

var $hZy36 = parcelRequire("hZy36");

var $8bsd2 = parcelRequire("8bsd2");

var $1ka2O = parcelRequire("1ka2O");

var $iSeHD = parcelRequire("iSeHD");
const $835e146085c3a79b$export$52bc2238e0ff8657 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
const $835e146085c3a79b$export$30b295205cfae694 = ()=>{
    const context = (0, $1oC0p.useContext)($835e146085c3a79b$export$52bc2238e0ff8657);
    if (!context) throw new Error('useAccountCreationContext must be used within a AccountCreationContextProvider');
    return context;
};
const $835e146085c3a79b$export$b0a1b3550379fc78 = ({ getContinueUrl: getContinueUrl, identityCobranding: identityCobranding = 'wac', templateId: templateId, children: children })=>{
    const location = (0, $1ka2O.useLocation)();
    const isEmbedded = !location.pathname.endsWith('/try/cloud/signup');
    const { product: product, edition: edition } = (0, $7GVWk.useUserContext)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const [isEmailValid, setIsEmailValid] = (0, $1oC0p.useState)(false);
    const [hasSubmitted, setHasSubmitted] = (0, $1oC0p.useState)(false);
    const [isReadyForInvalid, setIsReadyForInvalid] = (0, $1oC0p.useState)(false);
    const [isSubmitting, setIsSubmitting] = (0, $1oC0p.useState)(false);
    const [formError, setFormError] = (0, $1oC0p.useState)(false);
    const [typeAheadEmail, setTypeAheadEmail] = (0, $1oC0p.useState)('');
    const [tryIntentAnalyticsEventHasFired, setTryIntentAnalyticsEventHasFired] = (0, $1oC0p.useState)(false);
    const localePath = (0, $gZgIU.getLocalePath)(intl.locale);
    const continueParam = (0, $gZgIU.getContinueParam)(location);
    const dataFoundationsActionSubjectId = !!isEmbedded ? 'embedded' : 'standalone';
    // default experiment params
    if (product && identityCobranding === 'wac') {
        if (product.name === 'confluence') identityCobranding = 'wac--otp-confluence';
        else if (product.name === 'jira') identityCobranding = 'wac--otp-jira';
        else if (product.name === 'loom') identityCobranding = 'wac--loom';
        else if (product.name === 'jira-product-discovery') identityCobranding = 'wac--jpd';
        else if (product.name === 'jira-servicedesk') identityCobranding = 'wac--jsm';
        else if (product.name === 'service-collection') identityCobranding = 'wac--service-collection';
        else if (product.name === 'teamwork-collection') identityCobranding = 'wac--teamwork-collection';
    }
    const defaultContinueUrl = (0, $1oC0p.useCallback)(()=>continueParam ? continueParam : (0, $gZgIU.getNameYourSiteRedirectUrl)({
            bundle: product?.bundle,
            edition: edition,
            localePath: localePath,
            templateId: templateId,
            application: identityCobranding,
            isEmbedded: isEmbedded
        }), [
        continueParam,
        product,
        edition,
        localePath,
        templateId,
        identityCobranding
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (!analyticsClient) return;
        (0, $buVH1.trackDataFoundationsAccountCreationComponent)(createAnalyticsEvent, {
            actionSubjectId: dataFoundationsActionSubjectId,
            productKey: product?.key,
            edition: edition
        });
        (0, $gPKCY.ufoEventSignupFormLoad).success({
            customData: {
                webPlatform: 'bxp-ui',
                reactComponent: 'DefaultSignupForm',
                isLoggedIn: false
            }
        });
        (0, $buVH1.trackSignFormLoad)(createAnalyticsEvent);
        (0, $buVH1.trackTimeToFormReady)(createAnalyticsEvent, performance.now());
    }, [
        createAnalyticsEvent,
        edition,
        product?.key,
        dataFoundationsActionSubjectId,
        analyticsClient
    ]);
    const onSubmit = (0, $1oC0p.useCallback)(async ({ email: email })=>{
        setIsReadyForInvalid(true);
        if (!email || !isEmailValid) {
            (0, $buVH1.trackInvalidEmail)(createAnalyticsEvent);
            return;
        }
        (0, $buVH1.trackFormSubmit)(createAnalyticsEvent, product?.key, edition);
        setIsSubmitting(true);
        let continueUrl;
        if (getContinueUrl) continueUrl = getContinueUrl();
        if (!continueUrl) continueUrl = defaultContinueUrl();
        try {
            const castleToken = await (0, $hZy36.getCastleRequestToken)();
            // check identity interstitial redirect experiments for enrollment
            const url = (0, $gZgIU.getIdentityInterstitialUrl)(email, continueUrl, identityCobranding, castleToken);
            createAnalyticsEvent({
                eventType: 'ui',
                action: 'succeeded',
                actionSubject: 'accountCreationInterstitialRedirect',
                containerId: 'bxp-ui-signup',
                attributes: {
                    productKey: product?.key,
                    edition: edition
                }
            }).fire();
            (0, $8bsd2.trackCastleSignupAttempt)({
                href: url,
                email: email,
                productKey: product?.key
            });
            window.location.assign(url);
            return;
        } catch  {
            setHasSubmitted(true);
            setFormError(true);
            setIsSubmitting(false);
            createAnalyticsEvent({
                eventType: 'ui',
                action: 'errored',
                actionSubject: 'accountCreationInterstitialRedirect',
                containerId: 'bxp-ui-signup',
                attributes: {
                    productKey: product?.key,
                    edition: edition
                }
            }).fire();
        }
    }, [
        createAnalyticsEvent,
        defaultContinueUrl,
        edition,
        getContinueUrl,
        identityCobranding,
        isEmailValid,
        product
    ]);
    const onClickSocialButton = (provider)=>{
        (0, $buVH1.trackContinueWithSocialSignups)(createAnalyticsEvent, provider, product?.key, edition);
        let continueUrl;
        if (getContinueUrl) continueUrl = getContinueUrl();
        if (!continueUrl) continueUrl = defaultContinueUrl();
        const socialRedirectUrl = (0, $fFzjl.getSocialButtonUrl)({
            redirectTo: continueUrl,
            identityCobranding: identityCobranding,
            provider: provider
        });
        // Note: no Castle event here. Social signups don't go through the email
        // form, so we have no user-entered email to correlate against — and
        // Castle is only valuable with an email-to-fingerprint correlation.
        window.location.assign(socialRedirectUrl);
    };
    const onClickSubmitButton = ()=>(0, $buVH1.trackSubmitButtonClick)(createAnalyticsEvent);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($835e146085c3a79b$export$52bc2238e0ff8657.Provider, {
        value: {
            dataFoundationsActionSubjectId: dataFoundationsActionSubjectId,
            edition: edition,
            formError: formError,
            hasSubmitted: hasSubmitted,
            identityCobranding: identityCobranding,
            isReadyForInvalid: isReadyForInvalid,
            isSubmitting: isSubmitting,
            onClickSocialButton: onClickSocialButton,
            onClickSubmitButton: onClickSubmitButton,
            onSubmit: onSubmit,
            product: product,
            setIsEmailValid: setIsEmailValid,
            setIsReadyForInvalid: setIsReadyForInvalid,
            setTypeAheadEmail: setTypeAheadEmail,
            typeAheadEmail: typeAheadEmail,
            tryIntentAnalyticsEventHasFired: tryIntentAnalyticsEventHasFired
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gfjAv.default), {
            edition: edition,
            intentType: "form",
            productKey: product?.key,
            onAnalyticsEventFired: ()=>!tryIntentAnalyticsEventHasFired && setTryIntentAnalyticsEventHasFired(true),
            children: children
        })
    });
};

});
parcelRegister("8bsd2", function(module, exports) {
$parcel$export(module.exports, "trackCastleSignupAttempt", function () { return $cc4df0ecef4c9b53$export$5b4bab8f0582c91c; });

var $hZy36 = parcelRequire("hZy36");
const $cc4df0ecef4c9b53$export$3aef6f37ef107ada = 'WAC Signup Attempted';
const $cc4df0ecef4c9b53$var$MAX_PATH_SEGMENT_LENGTH = 48;
const $cc4df0ecef4c9b53$var$SAFE_QUERY_PARAM_NAMES = new Set([
    'bundle',
    'edition',
    'product',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term'
]);
const $cc4df0ecef4c9b53$var$getUrl = (href)=>{
    try {
        return new URL(href, window.location.origin);
    } catch  {
        return undefined;
    }
};
const $cc4df0ecef4c9b53$var$getSafeSearchParams = (url)=>{
    const safe = new URLSearchParams();
    url.searchParams.forEach((value, name)=>{
        if ($cc4df0ecef4c9b53$var$SAFE_QUERY_PARAM_NAMES.has(name)) safe.append(name, value);
    });
    return safe.toString();
};
const $cc4df0ecef4c9b53$var$sanitizePathSegment = (segment)=>{
    if (segment.length > $cc4df0ecef4c9b53$var$MAX_PATH_SEGMENT_LENGTH) return '[redacted]';
    return segment;
};
const $cc4df0ecef4c9b53$var$getSanitizedPath = (pathname)=>{
    return pathname.split('/').map((segment)=>$cc4df0ecef4c9b53$var$sanitizePathSegment(segment)).join('/');
};
const $cc4df0ecef4c9b53$var$getSanitizedHref = (url)=>{
    const safeParams = $cc4df0ecef4c9b53$var$getSafeSearchParams(url);
    const safePath = $cc4df0ecef4c9b53$var$getSanitizedPath(url.pathname);
    const base = `${url.origin}${safePath}`;
    return safeParams ? `${base}?${safeParams}` : base;
};
const $cc4df0ecef4c9b53$var$getSanitizedPagePath = ()=>$cc4df0ecef4c9b53$var$getSanitizedPath(window.location.pathname);
const $cc4df0ecef4c9b53$export$5b4bab8f0582c91c = ({ href: href, email: email, productKey: productKey })=>{
    const url = $cc4df0ecef4c9b53$var$getUrl(href);
    if (!url) return;
    (0, $hZy36.sendCastleCustomEvent)({
        name: $cc4df0ecef4c9b53$export$3aef6f37ef107ada,
        properties: {
            wac_href: $cc4df0ecef4c9b53$var$getSanitizedHref(url),
            wac_pagePath: $cc4df0ecef4c9b53$var$getSanitizedPagePath(),
            wac_eventType: 'signup',
            ...productKey ? {
                wac_productKey: productKey
            } : {}
        },
        email: email
    });
};

});


parcelRegister("mG5bv", function(module, exports) {
$parcel$export(module.exports, "Error", function () { return $d2f561c370fddce6$export$edf27be85e5f6da0; });
/* error.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $cGEBM = parcelRequire("cGEBM");

var $8e22h = parcelRequire("8e22h");

var $iPPTB = parcelRequire("iPPTB");
const $d2f561c370fddce6$export$edf27be85e5f6da0 = ({ errorText: errorText })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $8e22h.default)();
    const { formError: formError } = (0, $cGEBM.useAccountCreationContext)();
    if (!formError) return null;
    if (errorText === undefined) errorText = locale === 'en' // temporary fix until translation is available
     ? formatMessage({
        id: 'AccountCreation.userSignupError',
        defaultMessage: `It's taking longer than expected to get you started. Please refresh and try again or <contactUsLink>contact us</contactUsLink>.`
    }, {
        contactUsLink: $d2f561c370fddce6$var$contactUsLink
    }) : formatMessage({
        id: 'BxpUiSignup.SignupForm.formError',
        defaultMessage: "It's taking longer than expected to get you started. Please check your inbox to see if the order has completed successfully, or <contactUsLink>contact us</contactUsLink>."
    }, {
        contactUsLink: $d2f561c370fddce6$var$contactUsLink
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        role: "alert",
        className: (0, $2jatx.default)([
            "_syaz1cjc _19pk1j6v _2hwxidpf _otyr1j6v _18u0idpf _3fcw150s"
        ]),
        children: errorText
    });
};
const $d2f561c370fddce6$var$contactUsLink = (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
        text: text,
        "aria-label": text,
        type: "inline",
        href: "/company/contact",
        className: "linkText"
    });
const $d2f561c370fddce6$var$errorCss = null;

});

parcelRegister("irRyj", function(module, exports) {
$parcel$export(module.exports, "Input", function () { return $5190fd2e8a96a930$export$f5b8910cec6cf069; });
/* input.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $igGC3 = parcelRequire("igGC3");

var $8KJ2x = parcelRequire("8KJ2x");

var $gM7M2 = parcelRequire("gM7M2");

var $iTHVN = parcelRequire("iTHVN");

var $bNzAT = parcelRequire("bNzAT");

var $eOIix = parcelRequire("eOIix");

var $cGEBM = parcelRequire("cGEBM");

var $6nMZs = parcelRequire("6nMZs");
const $5190fd2e8a96a930$var$HELP_TEXT_ID = 'account_creation_email_help_text';
const $5190fd2e8a96a930$export$f5b8910cec6cf069 = ({ helpText: helpText, errorMessageText: errorMessageText, labelText: labelText, placeholderText: placeholderText })=>{
    const { isReadyForInvalid: isReadyForInvalid, setIsEmailValid: setIsEmailValid, setIsReadyForInvalid: setIsReadyForInvalid, setTypeAheadEmail: setTypeAheadEmail, typeAheadEmail: typeAheadEmail } = (0, $cGEBM.useAccountCreationContext)();
    const [email, setEmail] = (0, $1oC0p.useState)(typeAheadEmail);
    const [isValid, setValid] = (0, $1oC0p.useState)();
    const intl = (0, $8e22h.default)();
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    if (helpText === undefined) helpText = intl.formatMessage({
        id: 'signupForm.accountCreation.helperText',
        defaultMessage: 'Using a work email helps find teammates and boost collaboration.'
    });
    if (errorMessageText === undefined) errorMessageText = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.invalidEmail',
        defaultMessage: 'Please enter a valid email address.'
    });
    if (labelText === undefined) labelText = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.workEmail',
        defaultMessage: 'Work email'
    });
    if (placeholderText === undefined) placeholderText = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.emailPlaceholder',
        defaultMessage: 'you@company.com'
    });
    (0, $1oC0p.useEffect)(()=>{
        const isValid = (0, $gM7M2.emailIsValid)(email);
        // wait to show invalid state if the user is not finished typing
        if (!isValid && !isReadyForInvalid) {
            setValid(undefined);
            return;
        }
        setValid(isValid);
        setIsEmailValid(isValid);
    }, [
        email,
        setIsEmailValid,
        isReadyForInvalid
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_6rth7vkz _1rwquftu _1heu1kw7 _125x1syg _62vcmccc _1d6jidpf _1t2q1kw7 _17rn1kw7 _1q9pbfng _d78pglyw _1osle4h9 _tx14t94y _1bjadkaa _kj1xidpf",
            isDarkTheme && "_1mi9rttd _1rwqrttd _psgk1afi _1t2q1afi"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0')),
            "--_1jvo4a6": (0, $6ZVlx.default)((0, $iTHVN.fontSize).md),
            "--_1mehvmr": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.dark200'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
            "aria-required": true,
            isRequired: true,
            label: labelText,
            name: "email",
            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_7hwb183y",
                        isValid === true && "_olzhaf4m _1osldkaa _tx14idpf",
                        isValid === false && "_olzh1wfy _1osldkaa _tx14idpf"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                            ...fieldProps,
                            autoComplete: "email",
                            "aria-describedby": $5190fd2e8a96a930$var$HELP_TEXT_ID,
                            elemAfterInput: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6nMZs.InputIcon), {
                                valid: isValid
                            }),
                            onBlur: ()=>setIsReadyForInvalid(true),
                            onChange: (e)=>{
                                setEmail(e.target.value);
                                setTypeAheadEmail(e.target.value);
                                fieldProps.onChange(e);
                            },
                            placeholder: placeholderText,
                            testId: "email_field",
                            type: "email",
                            value: email
                        }),
                        isValid === false ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            id: $5190fd2e8a96a930$var$HELP_TEXT_ID,
                            role: "alert",
                            className: (0, $2jatx.default)([
                                "_syaz1tmw _1wybepq8 _vwz4bs82 _1pfhi2wt",
                                isDarkTheme && "_syaz1366"
                            ]),
                            style: {
                                "--_1h1y5xv": (0, $6ZVlx.default)((0, $iTHVN.fontSize).xs)
                            },
                            children: errorMessageText
                        }) : helpText ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            id: $5190fd2e8a96a930$var$HELP_TEXT_ID,
                            className: (0, $2jatx.default)([
                                "_1wybepq8 _vwz4bs82 _syazl3em _1pfhi2wt"
                            ]),
                            style: {
                                "--_1h1y5xv": (0, $6ZVlx.default)((0, $iTHVN.fontSize).xs)
                            },
                            children: helpText
                        }) : null
                    ]
                })
        })
    });
};
const $5190fd2e8a96a930$var$errorMessageCss = null;
const $5190fd2e8a96a930$var$darkThemeErrorMessageCss = null;
const $5190fd2e8a96a930$var$helpTextCss = null;
const $5190fd2e8a96a930$var$fieldCss = null;
const $5190fd2e8a96a930$var$darkThemeFieldCss = null;
const $5190fd2e8a96a930$var$inputCss = null;
const $5190fd2e8a96a930$var$inputInvalidCss = null;
const $5190fd2e8a96a930$var$inputValidCss = null;

});
parcelRegister("6nMZs", function(module, exports) {
$parcel$export(module.exports, "InputIcon", function () { return $f28bd5fc1ae39550$export$f8fea9f50a4bfae6; });
/* input-icon.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $hrBjL = parcelRequire("hrBjL");

var $5J9KJ = parcelRequire("5J9KJ");

var $iTHVN = parcelRequire("iTHVN");

var $kbpa7 = parcelRequire("kbpa7");
const $f28bd5fc1ae39550$export$f8fea9f50a4bfae6 = ({ valid: valid })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const validMessage = formatMessage({
        id: 'signupForm.accountCreation.validEmailIcon',
        defaultMessage: 'Success'
    });
    const invalidMessage = formatMessage({
        id: 'signupForm.accountCreation.invalidEmailIconError',
        defaultMessage: 'Error'
    });
    if (valid === undefined) return null;
    return valid ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1e0c1txw _lswu1afi _1wyb1syg _y4ti19bv _w8l5gktf _1752gktf",
            "_syaz81oq"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_1jvo4a6": (0, $6ZVlx.default)((0, $iTHVN.fontSize).md),
            "--_12jscdq": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.lime600'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hrBjL))), {
            label: validMessage
        })
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1e0c1txw _lswu1afi _1wyb1syg _y4ti19bv _w8l5gktf _1752gktf",
            "_syaz1bqt"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_1jvo4a6": (0, $6ZVlx.default)((0, $iTHVN.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5J9KJ))), {
            label: invalidMessage
        })
    });
};
const $f28bd5fc1ae39550$var$iconWrapperCss = null;
const $f28bd5fc1ae39550$var$iconValidCss = null;
const $f28bd5fc1ae39550$var$iconInvalidCss = null;

});
parcelRegister("hrBjL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2e29ae4526453fe67eff894ad5ac76ad>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cb31e7ce97688c96$var$_react = $cb31e7ce97688c96$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $cb31e7ce97688c96$var$_baseNew = $cb31e7ce97688c96$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $cb31e7ce97688c96$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: completed items, productivity emoji category. Completed task work type in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cb31e7ce97688c96$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $cb31e7ce97688c96$var$_react.default.createElement($cb31e7ce97688c96$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0m-2.174-2.52-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308zM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/>`
    }, props));
$cb31e7ce97688c96$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $cb31e7ce97688c96$var$_default = module.exports.default = $cb31e7ce97688c96$var$CheckCircleIcon;

});



parcelRegister("lJMiD", function(module, exports) {
$parcel$export(module.exports, "Login", function () { return $50db90a6da99c80d$export$21a94553ffa41578; });
/* login.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $iTHVN = parcelRequire("iTHVN");

var $gZgIU = parcelRequire("gZgIU");

var $iPPTB = parcelRequire("iPPTB");

var $1ka2O = parcelRequire("1ka2O");

var $cGEBM = parcelRequire("cGEBM");
const $50db90a6da99c80d$export$21a94553ffa41578 = ({ loginText: loginText })=>{
    const intl = (0, $8e22h.default)();
    const location = (0, $1ka2O.useLocation)();
    const { product: product } = (0, $cGEBM.useAccountCreationContext)();
    if (loginText === undefined) loginText = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.existingProduct',
        defaultMessage: 'Already have {product}? <logInLink>Log in</logInLink>'
    }, {
        product: product?.description,
        logInLink: (text)=>$50db90a6da99c80d$var$logInLink(text, location)
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        className: (0, $2jatx.default)([
            "_1wyb8oy7 _19pk14b4 _2hwxgrf3 _otyrgrf3 _18u0grf3 _y3gn1h6o"
        ]),
        style: {
            "--_djwknj": (0, $6ZVlx.default)((0, $iTHVN.fontSize).sm)
        },
        children: loginText
    });
};
const $50db90a6da99c80d$var$logInLink = (text, location)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
        text: text,
        "aria-label": text,
        type: "inline",
        href: (0, $gZgIU.getLoginUrl)(location)
    });
const $50db90a6da99c80d$var$existingProductCss = null;

});

parcelRegister("32ARy", function(module, exports) {
$parcel$export(module.exports, "Social", function () { return $4e2e5c1067955974$export$9a0fadb2797ac9a5; });
/* social.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $jUqeL = parcelRequire("jUqeL");

var $lHKk6 = parcelRequire("lHKk6");

var $cGEBM = parcelRequire("cGEBM");

var $8e22h = parcelRequire("8e22h");
const $4e2e5c1067955974$export$9a0fadb2797ac9a5 = ({ providers: providers })=>{
    const intl = (0, $8e22h.default)();
    const { onClickSocialButton: onClickSocialButton } = (0, $cGEBM.useAccountCreationContext)();
    if (providers === undefined) providers = {
        google: 'Google',
        microsoft: 'Microsoft',
        apple: 'Apple',
        slack: 'Slack'
    };
    const buttons = Object.entries(providers);
    // when there are 3 buttons, we display in a single row and visually hide the text labels
    const rowStyle = buttons.length === 3;
    /* added role="list" to ul for safari https://developer.mozilla.org/en-US/docs/Web/CSS/list-style#accessibility  */ return /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
        role: "list",
        className: (0, $2jatx.default)([
            "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            buttons.length > 1 && !rowStyle && "_1e0c11p5 _zulp7vkz _yv0efsjm",
            rowStyle && "_1e0c11p5 _zulp7vkz _wij21bp4"
        ]),
        children: buttons.map(([provider, label])=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $lHKk6.LogoButton), {
                    "aria-label": intl.formatMessage({
                        id: 'social.label.signup',
                        defaultMessage: 'sign up with {provider}'
                    }, {
                        provider: label
                    }),
                    onClick: ()=>onClickSocialButton(provider),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jUqeL.ProviderLogo), {
                            logo: provider
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                rowStyle && "_kqswstnw _1e021cib _152t1wug _1bsbt94y _4t3it94y _1reo15vq _18m915vq _ogtohxbz _o5721q9c"
                            ]),
                            children: label
                        })
                    ]
                })
            }, provider))
    });
};
const $4e2e5c1067955974$var$buttonGridCss = null;
const $4e2e5c1067955974$var$buttonListCss = null;
const $4e2e5c1067955974$var$buttonRowCss = null;
const $4e2e5c1067955974$var$srOnlyCss = null;

});

parcelRegister("l7G9R", function(module, exports) {
$parcel$export(module.exports, "Submit", function () { return $9e3c42c7c44204a7$export$2c4cf1f7b42ef78c; });
/* submit.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $lqyi6 = parcelRequire("lqyi6");

var $cGEBM = parcelRequire("cGEBM");
const $9e3c42c7c44204a7$export$2c4cf1f7b42ef78c = ({ buttonText: buttonText })=>{
    const intl = (0, $8e22h.default)();
    const { isSubmitting: isSubmitting, hasSubmitted: hasSubmitted, formError: formError, onClickSubmitButton: onClickSubmitButton } = (0, $cGEBM.useAccountCreationContext)();
    if (buttonText === undefined) buttonText = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.submit',
        defaultMessage: 'Sign up'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
        type: "submit",
        isDisabled: isSubmitting || hasSubmitted && !formError,
        isLoading: isSubmitting || hasSubmitted && !formError,
        onClick: onClickSubmitButton,
        className: (0, $2jatx.default)([
            "_ect41kw7 _1wyb7vkz _p12f1wug _1rjcftgi _1bsb1osq"
        ]),
        children: buttonText
    });
};
const $9e3c42c7c44204a7$var$buttonCss = null;

});

parcelRegister("8K1Jw", function(module, exports) {
$parcel$export(module.exports, "TermsAndConditions", function () { return $44792323d2da14c0$export$71c56c718a357b5; });
/* terms-and-conditions.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $iPPTB = parcelRequire("iPPTB");

var $jQ0cd = parcelRequire("jQ0cd");
const $44792323d2da14c0$export$71c56c718a357b5 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        "data-testid": "terms-and-conditions",
        className: (0, $2jatx.default)([
            "_1wyboqnp _vwz41k92 _1mou1j6v"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "BxpUiSignup.SignupForm.termsAndConditions",
            defaultMessage: "I agree to the <termsOfServiceLink>Atlassian Customer Agreement</termsOfServiceLink>, which incorporates by reference the <aiTermsLink>AI Product-Specific Terms</aiTermsLink>, and acknowledge the <privacyPolicyLink>Privacy Policy</privacyPolicyLink>.",
            values: {
                termsOfServiceLink: $44792323d2da14c0$var$TermsOfServiceLink,
                aiTermsLink: $44792323d2da14c0$var$AiTermsLink,
                privacyPolicyLink: $44792323d2da14c0$var$PrivacyPolicyLink
            }
        })
    });
const $44792323d2da14c0$var$AiTermsLink = (text)=>{
    const aiTermsLinkHref = (0, $jQ0cd.useLocalizedHref)('/legal/product-specific-terms#atlassian-intelligence-specific-terms');
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
        "aria-label": text,
        href: aiTermsLinkHref,
        text: text,
        type: "inline"
    });
};
const $44792323d2da14c0$var$PrivacyPolicyLink = (text)=>{
    const privacyPolicyLinkHref = (0, $jQ0cd.useLocalizedHref)('/legal/privacy-policy#what-this-policy-covers');
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
        "aria-label": text,
        href: privacyPolicyLinkHref,
        text: text,
        type: "inline"
    });
};
const $44792323d2da14c0$var$TermsOfServiceLink = (text)=>{
    const termsOfServiceLinkHref = (0, $jQ0cd.useLocalizedHref)('/legal/cloud-terms-of-service');
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
        "aria-label": text,
        href: termsOfServiceLinkHref,
        text: text,
        type: "inline"
    });
};
const $44792323d2da14c0$var$termsAndConditionsCss = null;

});



parcelRegister("8GyVU", function(module, exports) {
$parcel$export(module.exports, "EmbeddedSignupFormWrapper", function () { return $15727279b34dd3f9$export$feb4e6597ee7cf21; });
/* embedded-signup-form-wrapper.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $5YGzb = parcelRequire("5YGzb");

var $iTHVN = parcelRequire("iTHVN");
const $15727279b34dd3f9$var$signupModule = null;
const $15727279b34dd3f9$var$container = null;
const $15727279b34dd3f9$var$footer = null;
const $15727279b34dd3f9$export$feb4e6597ee7cf21 = ({ hideFooter: hideFooter, children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _vchhusvi _1e0c1txw _2lx21bp4 _ect41qje _1wyb8oy7 _ca0qviql _u5f3viql _n3tdviql _19bvviql _1kmxviql _1ggm1kwk _1ykzviql _1mae1kwk _ie1cviql _78i21j6v _1db0viql _dpmd1j6v _i6jxviql _1lh71j6v _z3ncviql _wpai1j6v"
        ]),
        style: {
            "--_djwknj": (0, $6ZVlx.default)((0, $iTHVN.fontSize).sm)
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_p12fnl1e _1bsb1osq _cadt1qje _8v2f1qje _iowe1h6o _1afj1h6o _1vfhqwb1 _1twlni7l _1xd21btq _rzbyidpf _8k2zidpf _nd4uidpf _9u9nidpf _11eb1kw7 _l5k14jg8 _1n461kwk _if5yidpf _1gnp1kwk _7e5bidpf _1g0f1k8s _cg41alr3 _1t2qalr3 _125xalr3 _doqyalr3 _zcqxbs82 _clfd1j6v _11pqidpf _q0a51j6v _c3k8idpf _1sgrepq8 _kminepq8 _59381r31 _yha2glyw _1nmznqa1 _43dsoelr _1cayoelr _9m7f1r31 _rfqo1r31 _w7sw8stv _1bgk8stv _15a9nqa1 _1t0pnqa1"
                ]),
                style: {
                    "--_1n7yiy6": (0, $6ZVlx.default)((0, $iTHVN.fontSize).xl),
                    "--_1h1y5xv": (0, $6ZVlx.default)((0, $iTHVN.fontSize).xs)
                },
                children: children
            }),
            !hideFooter && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_19pk1k8s _2hwx1wug _otyridpf _18u01wug"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5YGzb.AtlassianLogo), {
                    appearance: "brand",
                    size: "small",
                    testId: "atlassian-logo",
                    label: "Atlassian logo"
                })
            })
        ]
    });
};

});

parcelRegister("Mhvf3", function(module, exports) {
$parcel$export(module.exports, "ExistingProductText", function () { return $b146f38ea128bebe$export$2421ab9e56e71ee7; });
/* existing-product-text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $fnHPc = parcelRequire("fnHPc");
var $iVyKn = parcelRequire("iVyKn");

var $kNE9Z = parcelRequire("kNE9Z");

var $gZgIU = parcelRequire("gZgIU");

var $7GVWk = parcelRequire("7GVWk");

var $iPPTB = parcelRequire("iPPTB");

var $1ka2O = parcelRequire("1ka2O");
const $b146f38ea128bebe$var$existingText = (0, $fnHPc.defineMessage)({
    id: 'BxpUiSignup.SignupForm.existingProduct',
    defaultMessage: 'Already have {product}? <logInLink>Log in</logInLink>'
});
const $b146f38ea128bebe$export$2421ab9e56e71ee7 = ({ messageOverride: messageOverride, bgColor: bgColor = 'bgWhite' })=>{
    const { product: product } = (0, $7GVWk.useUserContext)();
    const location = (0, $1ka2O.useLocation)();
    const loginUrl = new URL('/login', (0, $kNE9Z.getIdentityBaseUrl)());
    const continueParam = (0, $gZgIU.getContinueParam)(location);
    if (continueParam) loginUrl.searchParams.append('continue', continueParam);
    else {
        const defaultContinueUrl = new URL('/gateway/api/start/authredirect', (0, $kNE9Z.getWacIntegrationUrl)()).toString();
        loginUrl.searchParams.append('continue', defaultContinueUrl);
    }
    return /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        className: (0, $2jatx.default)([
            "_19pk14b4 _2hwxgrf3 _otyrgrf3 _18u0grf3 _y3gn1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            ...messageOverride ?? $b146f38ea128bebe$var$existingText,
            values: {
                product: product?.name,
                logInLink: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                        text: text,
                        "aria-label": text,
                        type: "inline",
                        href: loginUrl.toString(),
                        bgColor: bgColor,
                        className: "linkText"
                    })
            }
        })
    });
};
const $b146f38ea128bebe$var$existingProductCss = null;

});

parcelRegister("4MWzW", function(module, exports) {
$parcel$export(module.exports, "SocialEndorsement", function () { return $c94a1620ecd53dba$export$782656e60c9cecfd; });
/* social-endorsement.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $izdHQ = parcelRequire("izdHQ");
const $c94a1620ecd53dba$var$carouselStyle = null;
const $c94a1620ecd53dba$var$trackStyle = null;
const $c94a1620ecd53dba$var$logoStyle = null;
const $c94a1620ecd53dba$var$SocialEndorsementComponent = ()=>{
    const logos = [
        {
            src: 'https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/canva.svg',
            alt: 'Canva',
            width: 95
        },
        {
            src: 'https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/nasa.svg',
            alt: 'Nasa',
            width: 60
        },
        {
            src: 'https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/illumina.svg',
            alt: 'Illumina',
            width: 103
        },
        {
            src: 'https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/docker.svg',
            alt: 'Docker',
            width: 108
        },
        {
            src: 'https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/new-york-times.svg',
            alt: 'The New York Times',
            width: 165
        },
        {
            src: 'https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/audi.svg',
            alt: 'Audi',
            width: 68
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "data-testid": "cfind-2675-social-proof",
        className: (0, $2jatx.default)([
            "_1reo15vq _18m915vq _4t3i14no _kqswh2mm _1q511tcg _1bsb1osq _vchh1ntv"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_y44v9j94 _1e0c1txw _zulpzwfg _kqswstnw"
            ]),
            children: [
                ...logos,
                ...logos
            ].map((logo, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Fragment), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                        src: logo.src,
                        alt: logo.alt,
                        loading: "lazy",
                        width: logo.width,
                        className: (0, $2jatx.default)([
                            "_lcxvglyw _kdamllbs _4t3i14no _16bullbs"
                        ])
                    })
                }, index))
        })
    });
};
const $c94a1620ecd53dba$export$782656e60c9cecfd = (0, $izdHQ.withFeatureExposed)('cfind-2675-social-proof-paid', 'true', $c94a1620ecd53dba$var$SocialEndorsementComponent);

});


parcelRegister("7Izt2", function(module, exports) {
$parcel$export(module.exports, "ConfluenceFeaturesPageEmbeddedSignupForm", function () { return $00a39583d443db7b$export$2394908a1a97673f; });
/* confluence-features-page-embedded.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $fnHPc = parcelRequire("fnHPc");
var $iVyKn = parcelRequire("iVyKn");

var $6KUQg = parcelRequire("6KUQg");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $8GyVU = parcelRequire("8GyVU");

var $Mhvf3 = parcelRequire("Mhvf3");
const $00a39583d443db7b$var$confluenceEmbeddedExistingText = (0, $fnHPc.defineMessage)({
    id: 'BxpUiSignup.SignupForm.existingProduct.confluence.embedded',
    defaultMessage: 'Trying to access {product}? <logInLink>Log in</logInLink>'
});
const $00a39583d443db7b$export$2394908a1a97673f = ({ variant: variant })=>{
    const gwp9286ConfluenceAnchorUpdates = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp9286ConfluenceAnchorUpdates);
    const headers = {
        'paid-lp-conf-features': /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.features",
            defaultMessage: "Goodbye silos, hello teamwork with Confluence"
        }),
        'anchor-lp-conf-competitors': /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.competitors",
            defaultMessage: "Confluence is the #1 collaboration tool for productive teams"
        }),
        'anchor-lp-conf-work-management': /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.work.management",
            defaultMessage: "Bring your team\u2019s work together with Confluence"
        }),
        'anchor-lp-conf-teamwork': /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.teamwork",
            defaultMessage: "Accelerate teamwork and productivity with Confluence"
        }),
        'anchor-lp-conf-collaboration': gwp9286ConfluenceAnchorUpdates ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "GWP9286ConfluenceAnchorUpdates.header.confluence.collaboration",
            defaultMessage: "AI-driven project collaboration for modern teams"
        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.collaboration",
            defaultMessage: "Turn ideas into action with Confluence"
        }),
        'anchor-lp-conf-automation': /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.automation",
            defaultMessage: "Collaborate better with Confluence"
        }),
        'paid-lp-confl-template': /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.template",
            defaultMessage: "There\u2019s a Confluence template for that"
        }),
        'paid-lp-confl-documentation': gwp9286ConfluenceAnchorUpdates ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "GWP9286ConfluenceAnchorUpdates.header.confluence.documentation",
            defaultMessage: "Turn team knowledge into lasting documentation everyone can use"
        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.documentation",
            defaultMessage: "Technically superior documentation starts with Confluence"
        })
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8GyVU.EmbeddedSignupFormWrapper), {
        hideFooter: true,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            "data-testid": "signup-form",
            className: (0, $2jatx.default)([
                "_4cvr1fhb _bfhku67f _16qs130s _2rkogktf _syaz1bqd _1e0c1txw _2lx21bp4 _1bah1h6o _ca0qzwfg _u5f312am _n3tdzwfg _19bv12am _1bsb1erl"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                    className: (0, $2jatx.default)([
                        "_y4tivbgk _y3gn1qpp"
                    ]),
                    children: headers[variant]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    className: (0, $2jatx.default)([
                        "_1wyb1gpt _k48pocj5 _y3gn1qpp"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "BxpUiSignup.SignupForm.subheader.1",
                        defaultMessage: "It's free for up to 10 users \u2014 no credit card needed."
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6KUQg.AccountCreation), {
                    Login: null
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $Mhvf3.ExistingProductText), {
                    messageOverride: $00a39583d443db7b$var$confluenceEmbeddedExistingText
                })
            ]
        })
    });
};
const $00a39583d443db7b$var$containerStyle = null;
const $00a39583d443db7b$var$headerStyle = null;
const $00a39583d443db7b$var$subheaderStyle = null;

});

parcelRegister("b9dfy", function(module, exports) {
$parcel$export(module.exports, "DefaultEmbeddedSignupForm", function () { return $c1b1a124c7e97ca9$export$ec3bbe4365c4cdfa; });
/* default-form.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $6KUQg = parcelRequire("6KUQg");

var $7GVWk = parcelRequire("7GVWk");

var $8GyVU = parcelRequire("8GyVU");

var $Mhvf3 = parcelRequire("Mhvf3");
const $c1b1a124c7e97ca9$export$ec3bbe4365c4cdfa = ()=>{
    const { product: product } = (0, $7GVWk.useUserContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8GyVU.EmbeddedSignupFormWrapper), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            "data-testid": "signup-form",
            className: (0, $2jatx.default)([
                "_4cvr1fhb _syaz1bqd _1e0c1txw _2lx21bp4 _1bah1h6o"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "BxpUiSignup.EmbeddedSignupForm.header",
                        defaultMessage: "Get started with {product}",
                        values: {
                            product: product?.name
                        }
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "BxpUiSignup.EmbeddedSignupForm.subheader.1",
                        defaultMessage: "It's free for up to 10 users \u2014 no credit card needed."
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6KUQg.AccountCreation), {
                    Login: null
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $Mhvf3.ExistingProductText), {})
            ]
        })
    });
};
const $c1b1a124c7e97ca9$var$containerStyle = null;

});

parcelRegister("2UACm", function(module, exports) {
$parcel$export(module.exports, "LoggedInForm", function () { return $0eca7a5f583e0e14$export$c5d014cdd7dc976f; });
/* logged-in-form.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $bGrkd = parcelRequire("bGrkd");

var $bs458 = parcelRequire("bs458");

var $ka4Xu = parcelRequire("ka4Xu");

var $2WL8B = parcelRequire("2WL8B");
const $0eca7a5f583e0e14$export$c5d014cdd7dc976f = ()=>{
    const intl = (0, $8e22h.default)();
    const firstName = (0, $2WL8B.useFirstName)();
    const useContactExpandCohortLogic = (0, $2WL8B.useIsConfluenceContactCompanyExpandEligible)();
    if (useContactExpandCohortLogic) return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_bfhku67f _2rkogktf _ca0q1ylp _u5f312am _n3td8vuz _19bv12am _1bsb1erl"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                className: (0, $2jatx.default)([
                    "_k48pbfng",
                    "_19pkidpf _2hwxidpf _otyr1j6v _18u0idpf _y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "BxpUiSignup.nameSite.header",
                    defaultMessage: "Welcome back, {name}",
                    values: {
                        name: firstName
                    }
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {
                useContactExpandCohortLogic: true,
                CurrentProductJoinableUser: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bGrkd.JoinableSites), {}),
                CurrentProductUser: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bs458.ReturnToProduct), {})
            })
        ]
    });
    const headerText = intl.formatMessage({
        id: 'BxpUiSignup.nameSite.header',
        defaultMessage: 'Welcome back, {name}'
    }, {
        name: firstName
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_bfhku67f _2rkogktf _ca0q1ylp _u5f312am _n3td8vuz _19bv12am _1bsb1erl"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                className: (0, $2jatx.default)([
                    "_k48pbfng"
                ]),
                children: headerText
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {
                WeekOneUser: null
            })
        ]
    });
};
const $0eca7a5f583e0e14$var$containerStyles = null;
const $0eca7a5f583e0e14$var$headerStyles = null;
const $0eca7a5f583e0e14$var$headerContactExpandCss = null;

});
parcelRegister("bGrkd", function(module, exports) {
$parcel$export(module.exports, "JoinableSites", function () { return $701300cad08ca63f$export$fa96b097075fdf52; });
/* joinable-sites.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $kNE9Z = parcelRequire("kNE9Z");

var $fcO7r = parcelRequire("fcO7r");

var $gZgIU = parcelRequire("gZgIU");

var $7GVWk = parcelRequire("7GVWk");

var $9tcM4 = parcelRequire("9tcM4");

var $lqyi6 = parcelRequire("lqyi6");

var $kbpa7 = parcelRequire("kbpa7");

var $ff4S3 = parcelRequire("ff4S3");

var $jgBbG = parcelRequire("jgBbG");
const $701300cad08ca63f$export$fa96b097075fdf52 = ({ ExistingUser: ExistingUser = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgBbG.ExistingUser), {}) })=>{
    const [showSiteNaming, setShowSiteNaming] = (0, $1oC0p.useState)(false);
    const { product: product, edition: edition, profile: profile } = (0, $7GVWk.useUserContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const { isWorkspaceProduct: isWorkspaceProduct } = (0, $ff4S3.useSiteActivationContext)();
    const { user: { email: email } } = (0, $7GVWk.useUserContext)();
    const { productName: productName } = (0, $fcO7r.getProductData)(product?.key);
    let sites = profile.attributes?.existingProductsFromOrg.filter(({ accessType: accessType })=>[
            (0, $9tcM4.AccessRequestCapability).DIRECT_ACCESS,
            (0, $9tcM4.AccessRequestCapability).REQUEST_ACCESS
        ].includes(accessType)).sort((a, b)=>a.accessType !== b.accessType && a.accessType === (0, $9tcM4.AccessRequestCapability).DIRECT_ACCESS ? -1 : 1) || [];
    // make sure sites are unique by cloudId (userProfile can return duplicates)
    sites = Array.from(sites.reduce((acc, currentItem)=>{
        if (!acc.has(currentItem.cloudId)) acc.set(currentItem.cloudId, currentItem);
        return acc;
    }, new Map()).values());
    const requestAccess = intl.formatMessage({
        id: 'signup.siteActivation.requestAccess',
        defaultMessage: 'Request access'
    });
    const join = intl.formatMessage({
        id: 'signup.siteActivation.join',
        defaultMessage: 'Join'
    });
    const createNewWorkspaceMessageValues = {
        link: (str)=>$701300cad08ca63f$var$createNewWorkspaceMessageLink(str, ()=>{
                setShowSiteNaming(true);
                createAnalyticsEvent({
                    eventType: 'ui',
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'joinableSitesGoToSiteNamingScreen',
                    attributes: {
                        productName: product?.name,
                        productKey: product?.key,
                        edition: edition
                    }
                }).fire();
            })
    };
    const createNewWorkspaceMessage = isWorkspaceProduct ? intl.formatMessage({
        id: 'BxpSignup.SiteExpansionForm.cobrandedConfluenceCreateNewWorkspaceLink',
        defaultMessage: 'or <link>create a new workspace</link>'
    }, createNewWorkspaceMessageValues) : intl.formatMessage({
        id: 'BxpSignup.SiteExpansionForm.cobrandedJiraCreateNewWorkspaceLink',
        defaultMessage: 'or <link>start a new site</link>'
    }, createNewWorkspaceMessageValues);
    const clickReturnToExistingWorkspace = ()=>{
        setShowSiteNaming(false);
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'joinableSitesGoToReturnToProductScreen',
            attributes: {
                productName: product?.name,
                productKey: product?.key,
                edition: edition
            }
        }).fire();
    };
    const goToExistingWorkspaceMessageValues = {
        link: (str)=>$701300cad08ca63f$var$link(str, clickReturnToExistingWorkspace)
    };
    const goToExistingWorkspaceMessage = isWorkspaceProduct ? intl.formatMessage({
        id: 'BxpSignup.SiteExpansionForm.cobrandedGoToExistingWorkspace',
        defaultMessage: 'or <link>visit an existing workspace</link>'
    }, goToExistingWorkspaceMessageValues) : intl.formatMessage({
        id: 'bxpSignup.companyExpand.cobrandedReturnToJoinSites',
        defaultMessage: 'or <link>join an existing site</link>'
    }, goToExistingWorkspaceMessageValues);
    return showSiteNaming ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ae4v1yb4 _1e0c11p5 _16jlkb7n _zulpzwfg"
        ]),
        children: [
            ExistingUser,
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1wybdlk8 _k48pbfng _y3gn1h6o"
                ]),
                children: goToExistingWorkspaceMessage
            })
        ]
    }) : /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ae4v1yb4 _1e0c11p5 _16jlkb7n _zulpzwfg"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_1wybdlk8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "BxpSignup.SiteExpansionForm.cobrandedSubheader.2",
                    defaultMessage: "You\u2019re logged in as {email}. <switchAccountLink>Switch account</switchAccountLink>",
                    values: {
                        email: /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                            className: (0, $2jatx.default)([
                                "_k48pni7l _ct361wug _1i4q1hna _1nmz1hna _slp31hna"
                            ]),
                            children: email
                        }),
                        switchAccountLink: $701300cad08ca63f$var$switchAccountLink
                    }
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "data-testid": "return-to-product",
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _zulp7vkz _1jop70sv _1bv01wug"
                ]),
                children: sites?.map((site, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                        href: $701300cad08ca63f$var$getProductUrl(site),
                        onClick: (e)=>{
                            e.preventDefault(); // wait for event to fire
                            createAnalyticsEvent({
                                eventType: 'ui',
                                action: 'clicked',
                                actionSubject: 'button',
                                actionSubjectId: site.accessType === (0, $9tcM4.AccessRequestCapability).REQUEST_ACCESS ? 'joinableSitesClickRequestAccessButton' : 'joinableSitesClickJoinSiteButton',
                                attributes: {
                                    productName: productName,
                                    productKey: site.productKey,
                                    edition: site.productEdition
                                }
                            }).fire();
                            window.location.assign($701300cad08ca63f$var$getProductUrl(site));
                        },
                        className: (0, $2jatx.default)([
                            "_4cvr1h6o _19itkze7 _2rkoftgi _1e0c11p5 _zulp19bv _yv0e1ghl _1bah1yb4 _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1bsb1osq _9oik1snc _1bnxagmp _jf4cvv82"
                        ]),
                        style: {
                            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
                        },
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1wyb7vkz _1reo15vq _18m915vq"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                        className: (0, $2jatx.default)([
                                            "_k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                        ]),
                                        children: productName
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_syazk0sw _1wybdlk8 _1reo15vq _18m915vq _1bto1l2s _o5721q9c"
                                        ]),
                                        style: {
                                            "--_1e97w25": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light700'))
                                        },
                                        children: site.displayName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1sg8jdj5 _1o7pdlk8 _187zmgvx _1wtnftgi"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                    variant: "primary",
                                    size: "small",
                                    color: "blue",
                                    children: site.accessType === (0, $9tcM4.AccessRequestCapability).REQUEST_ACCESS ? requestAccess : join
                                })
                            })
                        ]
                    }, index))
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1wybdlk8 _k48pbfng _y3gn1h6o"
                ]),
                children: createNewWorkspaceMessage
            })
        ]
    });
};
const $701300cad08ca63f$var$getProductUrl = ({ productKey: productKey, productUrl: productUrl, cloudId: cloudId })=>{
    // loom links go through Loom SSO directly into the workspace
    if (productKey === (0, $fcO7r.ProductKey).LOOM) return (0, $gZgIU.getLoomSsoUrl)(cloudId);
    // jira links should be myjira.atlassian.net/welcome/software
    if (productKey === (0, $fcO7r.ProductKey).JIRA_SOFTWARE) {
        const { origin: origin } = new URL(productUrl);
        productUrl = `${origin}/welcome/software`;
    }
    //send to identity login with continue param
    const joinUrl = new URL('/login', (0, $kNE9Z.getIdentityBaseUrl)());
    joinUrl.searchParams.append('continue', productUrl);
    return joinUrl.toString();
};
const $701300cad08ca63f$var$link = (str, clickReturnToExistingWorkspace)=>/*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        onClick: clickReturnToExistingWorkspace,
        className: (0, $2jatx.default)([
            "_bfhkmzrp _19itidpf _2rkoidpf _syaz5hrz _80omtlke _ect41kw7 _1wybjdj5 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l31fez"
        ]),
        style: {
            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
            "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800'))
        },
        children: str
    });
const $701300cad08ca63f$var$createNewWorkspaceMessageLink = (str, exitView)=>/*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        onClick: exitView,
        className: (0, $2jatx.default)([
            "_bfhkmzrp _19itidpf _2rkoidpf _syaz5hrz _80omtlke _ect41kw7 _1wybjdj5 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l3ftjs"
        ]),
        style: {
            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
            "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800'))
        },
        children: str
    });
const $701300cad08ca63f$var$switchAccountLink = (children)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        href: (0, $gZgIU.getSwitchAccountUrl)(),
        className: (0, $2jatx.default)([
            "_syaz5hrz _4bfu1r31 _1hms8stv _ajmmnqa1 _o5721q9c _30l3ftjs"
        ]),
        style: {
            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
            "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800'))
        },
        children: children
    });
const $701300cad08ca63f$var$containerCss = null;
const $701300cad08ca63f$var$goToExistingWorkspaceLinkCss = null;
const $701300cad08ca63f$var$goToExistingWorkspaceMessageCss = null;
const $701300cad08ca63f$var$switchAccountSubheader = null;
const $701300cad08ca63f$var$createNewWorkspaceMessageCss = null;
const $701300cad08ca63f$var$createNewWorkspaceLinkCss = null;
const $701300cad08ca63f$var$boxContainerCss = null;
const $701300cad08ca63f$var$siteBoxCss = null;
const $701300cad08ca63f$var$goToProductButtonCss = null;
const $701300cad08ca63f$var$bold = null;
const $701300cad08ca63f$var$siteCss = null;
const $701300cad08ca63f$var$siteNameCss = null;
const $701300cad08ca63f$var$emailCss = null;
const $701300cad08ca63f$var$switchAccountLinkCss = null;

});
parcelRegister("ff4S3", function(module, exports) {
$parcel$export(module.exports, "hasStoredProvisioningRequestId", function () { return $d9523cfc95d5074c$export$65f080cf3bdd9909; });
$parcel$export(module.exports, "useSiteActivationContext", function () { return $d9523cfc95d5074c$export$48473054405e7add; });
$parcel$export(module.exports, "SiteActivationContextProvider", function () { return $d9523cfc95d5074c$export$e1087d57f38afae1; });
//TO DO: in the next PR refactor and test this context

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $eLTTO = parcelRequire("eLTTO");

var $8e22h = parcelRequire("8e22h");

var $fuLgT = parcelRequire("fuLgT");

var $eY3N6 = parcelRequire("eY3N6");

var $iSeHD = parcelRequire("iSeHD");

var $buVH1 = parcelRequire("buVH1");

var $cG7vk = parcelRequire("cG7vk");

var $36RSw = parcelRequire("36RSw");

var $9EuLB = parcelRequire("9EuLB");

var $fcO7r = parcelRequire("fcO7r");

var $427NR = parcelRequire("427NR");

var $77cxG = parcelRequire("77cxG");

var $6isYE = parcelRequire("6isYE");

var $fgra6 = parcelRequire("fgra6");

var $gPKCY = parcelRequire("gPKCY");

var $lIWv2 = parcelRequire("lIWv2");

var $gZgIU = parcelRequire("gZgIU");

var $2WL8B = parcelRequire("2WL8B");

var $7GVWk = parcelRequire("7GVWk");

var $5Ntyw = parcelRequire("5Ntyw");

var $9tcM4 = parcelRequire("9tcM4");

var $jQ0cd = parcelRequire("jQ0cd");

var $gx3aw = parcelRequire("gx3aw");

var $1ka2O = parcelRequire("1ka2O");

var $cURcB = parcelRequire("cURcB");

var $amfpH = parcelRequire("amfpH");
const { ABORTED: $d9523cfc95d5074c$var$ABORTED, SUCCEEDED: $d9523cfc95d5074c$var$SUCCEEDED } = (0, $lIWv2.UfoExperienceStatus);
const { PRESS: $d9523cfc95d5074c$var$PRESS, TRANSITION: $d9523cfc95d5074c$var$TRANSITION } = (0, $lIWv2.UfoInteractionType);
// Persists the provisioningRequestId once the deferred-site-name (spark-defer-
// site-name-v2, TWCG-2407) flow starts provisioning, so that navigating back to
// signup does not re-mount the variant or re-trigger provisioning. Stored in
// sessionStorage when available, mirrored to a self-expiring cookie for users
// without sessionStorage (e.g. private mode). A TTL bounds how long a returning
// user is excluded, so a genuinely new signup later in the same session is not
// permanently suppressed.
const $d9523cfc95d5074c$var$PROVISIONING_REQUEST_ID_KEY = 'sparkDeferSiteNameV2ProvisioningRequestId';
const $d9523cfc95d5074c$var$PROVISIONING_REQUEST_ID_TTL_MS = 1200000;
const $d9523cfc95d5074c$var$PROVISIONING_REQUEST_ID_TTL_SECONDS = $d9523cfc95d5074c$var$PROVISIONING_REQUEST_ID_TTL_MS / 1000;
// Stored as `${id}::${savedAtMs}` so reads can enforce the TTL.
const $d9523cfc95d5074c$var$isStoredValueRecent = (value)=>{
    if (!value) return false;
    const [, savedAt] = value.split('::');
    const savedAtMs = Number(savedAt);
    if (!savedAtMs) return false;
    return Date.now() - savedAtMs <= $d9523cfc95d5074c$var$PROVISIONING_REQUEST_ID_TTL_MS;
};
// Unlike sessionStorage or cookies, window.name is scoped to this tab — it
// survives reloads/back-forward navigation within the tab, but a different
// tab (even to the same page) starts with its own, unset window.name. Used
// to tag the cookie fallback below so it can still be recognised as
// tab-isolated even when sessionStorage itself is unavailable.
const $d9523cfc95d5074c$var$TAB_ID_WINDOW_NAME_PREFIX = 'sparkDeferSiteNameV2TabId::';
const $d9523cfc95d5074c$var$getTabId = ()=>{
    if (window.name.startsWith($d9523cfc95d5074c$var$TAB_ID_WINDOW_NAME_PREFIX)) return window.name.slice($d9523cfc95d5074c$var$TAB_ID_WINDOW_NAME_PREFIX.length);
    const tabId = typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random()}`;
    window.name = `${$d9523cfc95d5074c$var$TAB_ID_WINDOW_NAME_PREFIX}${tabId}`;
    return tabId;
};
const $d9523cfc95d5074c$export$c68ef462fc27f6da = (provisioningRequestId)=>{
    if (typeof window === 'undefined' || !provisioningRequestId) return;
    const value = `${provisioningRequestId}::${Date.now()}`;
    // Prefer sessionStorage: it is tab-isolated, so activating in one tab does not
    // affect a separate signup in another tab. Only fall back to a cookie when
    // sessionStorage is unavailable (e.g. Safari private mode).
    let sessionStorageAvailable = false;
    try {
        window.sessionStorage.setItem($d9523cfc95d5074c$var$PROVISIONING_REQUEST_ID_KEY, value);
        sessionStorageAvailable = true;
    } catch  {
    // Ignore; the cookie fallback below covers storage-unavailable browsers.
    }
    if (!sessionStorageAvailable) // Cookies aren't tab-isolated on their own, so tag the value with this
    // tab's id — a different tab's read will see the cookie but recognise
    // it belongs to another tab and ignore it (see hasStoredProvisioningRequestId).
    (0, $gx3aw.Cookie).writeCookieInSeconds($d9523cfc95d5074c$var$PROVISIONING_REQUEST_ID_KEY, `${$d9523cfc95d5074c$var$getTabId()}::${value}`, $d9523cfc95d5074c$var$PROVISIONING_REQUEST_ID_TTL_SECONDS);
};
const $d9523cfc95d5074c$export$65f080cf3bdd9909 = ()=>{
    if (typeof window === 'undefined') return false;
    let stored = null;
    try {
        stored = window.sessionStorage.getItem($d9523cfc95d5074c$var$PROVISIONING_REQUEST_ID_KEY);
    } catch  {
        stored = null;
    }
    if ($d9523cfc95d5074c$var$isStoredValueRecent(stored)) return true;
    // Fall back to the cookie when sessionStorage is empty or unavailable, but
    // only if it was written by this same tab.
    const cookieValue = (0, $gx3aw.Cookie).readCookie($d9523cfc95d5074c$var$PROVISIONING_REQUEST_ID_KEY);
    if (!cookieValue) return false;
    const [tabId, ...rest] = cookieValue.split('::');
    if (tabId !== $d9523cfc95d5074c$var$getTabId()) return false;
    return $d9523cfc95d5074c$var$isStoredValueRecent(rest.join('::'));
};
// spark-defer-site-name-v2 (TWCG-2407): when the auto-activation attempt
// fails, the variant falls back to a screen that mounts a brand-new
// SiteActivation instance with its own fresh provider — that instance has no
// memory of the error the failing attempt already surfaced. Carrying just the
// error/trace id (a plain string) through sessionStorage lets the new
// instance rebuild the same message from its own copy of the message
// template, without needing to serialize the message object itself (its
// `values` include a render function, which sessionStorage can't hold).
// "Take" semantics (read-then-clear) mean a stale id can never leak into an
// unrelated later mount.
const $d9523cfc95d5074c$var$AUTO_ACTIVATION_FAILURE_ERROR_ID_KEY = 'sparkDeferSiteNameV2AutoActivationFailureErrorId';
const $d9523cfc95d5074c$export$da3a03d534251f74 = (errorId)=>{
    try {
        window.sessionStorage.setItem($d9523cfc95d5074c$var$AUTO_ACTIVATION_FAILURE_ERROR_ID_KEY, errorId);
    } catch  {
    // Best-effort only: if sessionStorage is unavailable, the fallback screen
    // simply won't have the specific error id to show.
    }
};
const $d9523cfc95d5074c$export$85b7b16eeb1e8a22 = ()=>{
    try {
        const errorId = window.sessionStorage.getItem($d9523cfc95d5074c$var$AUTO_ACTIVATION_FAILURE_ERROR_ID_KEY);
        if (errorId) window.sessionStorage.removeItem($d9523cfc95d5074c$var$AUTO_ACTIVATION_FAILURE_ERROR_ID_KEY);
        return errorId ?? undefined;
    } catch  {
        return undefined;
    }
};
const $d9523cfc95d5074c$var$ufoBaseLogs = [
    {
        name: 'pkg:site-activation'
    },
    {
        name: 'component:siteActivationContextProvider'
    }
];
const $d9523cfc95d5074c$export$fe5d808150ab3415 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
const $d9523cfc95d5074c$export$48473054405e7add = ()=>{
    const context = (0, $1oC0p.useContext)($d9523cfc95d5074c$export$fe5d808150ab3415);
    if (!context) throw new Error('useSiteActivationContext must be used within a SiteActivationContextProvider');
    return context;
};
async function $d9523cfc95d5074c$var$getHasPaidTargetEditionRequiringConfirmationScreen({ cloudId: cloudId, productKey: productKey, stargateClient: stargateClient, signupSource: signupSource, createAnalyticsEvent: createAnalyticsEvent }) {
    if (!cloudId || !productKey || signupSource === 'pricing' || ![
        (0, $fcO7r.ProductKey).CONFLUENCE,
        (0, $fcO7r.ProductKey).JIRA_SOFTWARE,
        (0, $fcO7r.ProductKey).JIRA_PRODUCT_DISCOVERY,
        (0, $fcO7r.ProductKey).JIRA_SERVICE_DESK,
        (0, $fcO7r.ProductKey).SERVICE_COLLECTION
    ].includes(productKey)) return false;
    try {
        (0, $buVH1.trackCrossFlowActivationPlanFetched)({
            createAnalyticsEvent: createAnalyticsEvent,
            cloudId: cloudId,
            productKey: productKey
        });
        const activateProductCrossflowPlanResult = await stargateClient.activateProductCrossflowPlan({
            cloudId: cloudId,
            productKey: productKey,
            jobName: (0, $9tcM4.JobName).WAC_SIGNUP,
            context: {
                sourceComponent: 'redirect',
                sourceContext: 'start',
                originProduct: 'wac'
            }
        });
        const activatePlanTaskContext = activateProductCrossflowPlanResult?.tasks?.find((task)=>task?.name === 'activate')?.context;
        const plannedEditionId = activatePlanTaskContext?.['edition']?.['id'];
        const plannedEditionStrategy = activatePlanTaskContext?.['editionStrategy'];
        return plannedEditionStrategy === 'highest' && plannedEditionId !== 'free' || plannedEditionStrategy === 'servco' && plannedEditionId === 'standard';
    } catch (error) {
        (0, $buVH1.trackCrossFlowActivationPlanFailed)({
            createAnalyticsEvent: createAnalyticsEvent,
            cloudId: cloudId,
            productKey: productKey,
            error: error
        });
        return false;
    }
}
const $d9523cfc95d5074c$export$e1087d57f38afae1 = ({ children: children, existingSites: existingSites, useContactExpandCohortLogic: useContactExpandCohortLogic, autoActivateWithRecommendedName: autoActivateWithRecommendedName = false })=>{
    //HOOKS
    const intl = (0, $8e22h.default)();
    const { executeRecaptcha: executeRecaptcha } = (0, $eLTTO.useGoogleReCaptcha)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const { profile: profile, user: user, product: product, edition: originalEdition = 'free', transactionAccounts: transactionAccounts } = (0, $7GVWk.useUserContext)();
    /**
   * Rovo Dev (aka DEVAI) is a special case, it only has a single
   * edition, standard. There is an outstanding DACI:
   * https://hello.atlassian.net/wiki/spaces/uts/pages/5807772710/Rovo+Dev+Everywhere+SKU+DACI
   * If/when this DACI is resolved and Rovo Dev supports the free
   * edition, this special case can then be removed.
   */ let edition = originalEdition;
    if (product?.key === (0, $fcO7r.ProductKey).DEVAI) edition = 'standard';
    const { companyType: companyType, domainType: domainType, userType: userType } = profile?.cohorts || {};
    const cohort = (0, $2WL8B.useCohort)(useContactExpandCohortLogic);
    const expandableSites = (0, $2WL8B.useCrossflowEligibleSites)();
    const upgradableSites = (0, $2WL8B.useUpgradableSites)();
    const stargateClient = (0, $5Ntyw.useBxpWebStargateClient)();
    const location = (0, $1ka2O.useLocation)();
    const localizedContactUrl = (0, $jQ0cd.useLocalizedHref)('/company/contact');
    const sites = (0, $1oC0p.useMemo)(()=>existingSites ?? (cohort === (0, $2WL8B.COHORTS).UPGRADE_ELIGIBLE_USER ? upgradableSites : expandableSites) ?? [], [
        cohort,
        expandableSites,
        upgradableSites,
        existingSites
    ]);
    const isWorkspaceProduct = (0, $1oC0p.useMemo)(()=>!!product?.key && [
            (0, $fcO7r.ProductKey).CONFLUENCE,
            (0, $fcO7r.ProductKey).TEAMWORK_COLLECTION,
            (0, $fcO7r.ProductKey).SERVICE_COLLECTION,
            (0, $fcO7r.ProductKey).PRODUCT_COLLECTION
        ].includes(product?.key), [
        product?.key
    ]);
    //STATE
    const [showSitePicker, setShowSitePicker] = (0, $1oC0p.useState)(sites.length > 0);
    const [siteNameValid, setSiteNameValid] = (0, $1oC0p.useState)(false);
    const [hasSubmitted, setHasSubmitted] = (0, $1oC0p.useState)(false);
    const [isSubmitting, setIsSubmitting] = (0, $1oC0p.useState)(false);
    const [sitePickerValue, setSitePickerValue] = (0, $1oC0p.useState)(sites[0]);
    const [siteName, setSiteNameValue] = (0, $1oC0p.useState)('');
    const [recommendedSiteName] = (0, $1oC0p.useState)('');
    // Guards single-fire auto activation across re-renders/remounts, used by the
    // autoActivateWithRecommendedName flow (spark-defer-site-name-v2, TWCG-2407).
    const hasAutoActivatedRef = (0, $1oC0p.useRef)(false);
    // If a previous (now-unmounted) auto-activation attempt in this tab left an
    // error id behind, this is the fresh SiteActivation instance the TWCG-2407
    // fallback screen mounts — seed the manual form with that same error rather
    // than showing it with no explanation. See saveAutoActivationFailureErrorId.
    const [initialAutoActivationFailureErrorId] = (0, $1oC0p.useState)(()=>$d9523cfc95d5074c$export$85b7b16eeb1e8a22());
    // Set when auto-activation aborts because the recommended name's last-moment
    // availability re-check failed; consumers fall back to manual naming. Seeded
    // true when an error id above was found — SiteNameInput's own guard against
    // clearing that seeded message keys off this same flag (site-name-input.tsx).
    const [autoActivationFailed, setAutoActivationFailed] = (0, $1oC0p.useState)(!!initialAutoActivationFailureErrorId);
    // Tracks whether the in-flight activateSiteHandler call was started by the
    // auto-activation path (skipManualFormValidationFlag), so the recaptcha-retry
    // effect below — which calls activateSiteHandler directly, bypassing
    // activateSite's own closure over that flag — can still flag
    // autoActivationFailed on failure (TWCG-2407).
    const isAutoActivationAttemptRef = (0, $1oC0p.useRef)(false);
    const [selectedTransactionAccountId, setSelectedTransactionAccountId] = (0, $1oC0p.useState)(transactionAccounts[0]?.id ?? '');
    const [recaptchaFailedToLoad, setRecaptchFailedToLoad] = (0, $1oC0p.useState)(false);
    const [recaptchaRetryTimeRemainingSecond, setRecaptchaRetryTimeRemainingSecond] = (0, $1oC0p.useState)(60);
    const [validatationMessage, setValidationMessage] = (0, $1oC0p.useState)(()=>initialAutoActivationFailureErrorId ? {
            ...(0, $amfpH.messages).timeout,
            values: {
                // eslint-disable-next-line react/no-unstable-nested-components
                'href-support': (node)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                        href: localizedContactUrl,
                        children: node
                    }),
                error_id: initialAutoActivationFailureErrorId
            }
        } : undefined);
    const [paymentDetailsView, setPaymentDetailsView] = (0, $1oC0p.useState)({
        view: 'site-setup'
    });
    //VARIABLES
    const searchParameters = new URLSearchParams(location.search);
    const platform = searchParameters.get('platform') ?? 'routing';
    const primaryCollectionProduct = searchParameters.get('primaryCollectionProduct');
    const isNewUser = profile.cohorts?.userType === 'new-user';
    const productKey = product?.key;
    const { isValid: isValid, isValidating: isValidating, error: error } = (0, $cURcB.useSiteNameValidation)(siteName, setSiteNameValid);
    const isEmbedded = !location.pathname?.endsWith('/try/cloud/signup');
    const dataFoundationsActionSubjectId = isEmbedded ? 'embedded' : 'standalone';
    const showRecaptchaFormError = (0, $1oC0p.useCallback)(()=>{
        const anonymousId = decodeURIComponent((0, $gx3aw.Cookie).readCookie('ajs_anonymous_id') || 'n/a');
        setValidationMessage({
            ...(0, $amfpH.messages).timeout,
            values: {
                // eslint-disable-next-line react/no-unstable-nested-components
                'href-support': (node)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                        href: localizedContactUrl,
                        children: node
                    }),
                error_id: `Anonymous ID: ${anonymousId}`
            }
        });
        // spark-defer-site-name-v2 (TWCG-2407): the auto path never reaches here.
        if (analyticsClient) (0, $buVH1.trackDeferSiteNameErrorScreen)(createAnalyticsEvent, {
            cohort: 'control',
            reason: 'recaptcha',
            productKey: productKey
        });
        // Reset form to allow re-submit
        setIsSubmitting(false);
        setHasSubmitted(false);
    }, [
        analyticsClient,
        createAnalyticsEvent,
        localizedContactUrl,
        productKey
    ]);
    const activateSiteHandler = (0, $1oC0p.useCallback)(async (signupId, privacyPolicy)=>{
        setIsSubmitting(true);
        if (!executeRecaptcha && recaptchaRetryTimeRemainingSecond > 0) {
            // set trigger that will wait for Recaptcha retry logic
            setRecaptchFailedToLoad(true);
            return;
        }
        setRecaptchFailedToLoad(false);
        const localeData = await stargateClient.getConsentConfig();
        const testingPurposes = (0, $9EuLB.isTestTenantByName)(siteName);
        const signupContext = (0, $36RSw.getSignupContext)({
            productKey: productKey,
            testingPurposes: testingPurposes,
            signupId: signupId,
            search: location.search,
            locale: intl.locale
        });
        const MAX_SIGNUP_CONTEXT_LENGTH = 8192;
        let signupContextString = JSON.stringify(signupContext);
        if (signupContextString.length > MAX_SIGNUP_CONTEXT_LENGTH) signupContextString = '{}';
        const ccpProducts = (0, $fcO7r.mapProductKeyAndEditionToCcpProduct)({
            productKey: productKey,
            edition: edition,
            primaryCollectionProduct: primaryCollectionProduct
        });
        const gRecaptchaResponse = await (0, $427NR.getRecaptcha)(user['email'] || '', executeRecaptcha);
        (0, $gPKCY.ufoEventNewSiteN2NSubmit).setCustomData({
            gRecaptchaResponse: gRecaptchaResponse ?? 'none',
            executeRecaptchaExists: Boolean(executeRecaptcha),
            reactComponent: 'SiteActivationProvider'
        });
        // Handle missing reCAPTCHA response
        if (!gRecaptchaResponse) {
            (0, $buVH1.trackRecaptchaFailure)(createAnalyticsEvent, 'site-activation');
            // spark-defer-site-name-v2 (TWCG-2407): the auto-activation path has no
            // visible form to surface showRecaptchaFormError's message on. Without
            // this, a recaptcha that never loads leaves the user on the spinner
            // forever — fall back to manual naming instead.
            if (isAutoActivationAttemptRef.current) {
                setAutoActivationFailed(true);
                setIsSubmitting(false);
                setHasSubmitted(false);
            } else showRecaptchaFormError();
            return;
        }
        // Set experiment metadata before starting UFO event for GraphQL webhook setup
        (0, $gPKCY.ufoEventGraphQLWebhookSetup).setCustomData({
            webPlatform: 'site-activation'
        });
        // get consents
        const consent = (0, $cG7vk.getConsents)(localeData.locale ?? 'US-VA', localeData.localeRequiresMarketingCommunicationOptIn, privacyPolicy);
        const response = await stargateClient.activateProduct({
            displayName: user['name'],
            email: user['email'] || '',
            ccpProducts: [
                ccpProducts
            ],
            siteName: siteName,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            useCcpPlatform: platform === 'ccp',
            consent: consent,
            platform: platform,
            signupContext: signupContextString,
            isNewUser: productKey === (0, $fcO7r.ProductKey).JIRA_SOFTWARE || isNewUser,
            gRecaptchaResponse: gRecaptchaResponse,
            testingPurposes: testingPurposes,
            signupId: signupId,
            transactionAccountId: selectedTransactionAccountId
        });
        // spark-defer-site-name-v2 (TWCG-2407): persist the provisioning request
        // id (the same value appended to the confirmation URL) before redirecting
        // so that if the user navigates back to signup we can recognise that
        // provisioning already started — the auto-activation effect and the
        // experiment's screen branch both check this to avoid re-provisioning.
        // Gated on autoActivateWithRecommendedName so this only runs for the
        // deferred-site-name variant; control and all other cohorts never store
        // an id, keeping their behaviour unchanged.
        if (autoActivateWithRecommendedName) {
            const provisioningRequestId = response.metadata?.provisionRequestId;
            if (provisioningRequestId) $d9523cfc95d5074c$export$c68ef462fc27f6da(provisioningRequestId);
        }
        const redirectUrl = (0, $gZgIU.getConfirmationPageUrl)({
            locale: intl.locale,
            productKey: productKey,
            response: response,
            siteName: siteName,
            signupId: signupId,
            edition: edition,
            primaryCollectionProduct: primaryCollectionProduct
        });
        window.location.assign(redirectUrl);
    }, [
        executeRecaptcha,
        recaptchaRetryTimeRemainingSecond,
        showRecaptchaFormError,
        stargateClient,
        siteName,
        primaryCollectionProduct,
        location.search,
        productKey,
        edition,
        user,
        platform,
        isNewUser,
        intl.locale,
        createAnalyticsEvent,
        selectedTransactionAccountId,
        autoActivateWithRecommendedName
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (profile.requestInProgress || !analyticsClient) return;
        (0, $buVH1.trackSiteActivationViewed)(createAnalyticsEvent, {
            actionSubjectId: dataFoundationsActionSubjectId,
            cohort: cohort,
            productKey: productKey,
            edition: edition,
            userType: userType,
            domainType: domainType,
            companyType: companyType,
            numTxas: transactionAccounts.length
        });
    }, [
        analyticsClient,
        cohort,
        createAnalyticsEvent,
        companyType,
        dataFoundationsActionSubjectId,
        domainType,
        edition,
        productKey,
        profile.requestInProgress,
        userType,
        transactionAccounts.length
    ]);
    (0, $1oC0p.useEffect)(()=>{
        const ufoSubmitEvent = showSitePicker ? (0, $gPKCY.ufoEventExistingSiteN2ESubmit) : (0, $gPKCY.ufoEventNewSiteN2NSubmit);
        if (recaptchaFailedToLoad && recaptchaRetryTimeRemainingSecond <= 0) ufoSubmitEvent.failure({
            customData: {
                reactComponent: 'SiteActivationContextProvider',
                analyticsEvent: 'errored',
                recaptchaRetryTimeRemainingSecond: 0,
                siteType: showSitePicker ? 'existing-site' : 'new-site'
            },
            error: new Error('Recaptcha retry failed')
        });
        if (recaptchaFailedToLoad) activateSiteHandler().then(()=>{
            ufoSubmitEvent.success({
                customData: {
                    reactComponent: 'SiteActivationContextProvider',
                    analyticsEvent: 'succeeded',
                    siteType: showSitePicker ? 'existing-site' : 'new-site',
                    recaptchaRetryTimeRemainingSecond: recaptchaRetryTimeRemainingSecond
                }
            });
        }).catch((error)=>{
            // spark-defer-site-name-v2 (TWCG-2407): if the retried call belongs
            // to the auto-activation path, fall back to manual naming instead of
            // (also) surfacing showRecaptchaFormError's message on a form that
            // path never renders.
            if (isAutoActivationAttemptRef.current) {
                setAutoActivationFailed(true);
                setIsSubmitting(false);
                setHasSubmitted(false);
            } else showRecaptchaFormError();
            ufoSubmitEvent.failure({
                customData: {
                    reactComponent: 'SiteActivationContextProvider',
                    analyticsEvent: 'errored',
                    siteType: showSitePicker ? 'existing-site' : 'new-site',
                    recaptchaRetryTimeRemainingSecond: recaptchaRetryTimeRemainingSecond
                },
                error: error
            });
            return;
        });
    }, [
        activateSiteHandler,
        executeRecaptcha,
        localizedContactUrl,
        recaptchaFailedToLoad,
        recaptchaRetryTimeRemainingSecond,
        showRecaptchaFormError,
        showSitePicker
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (!recaptchaFailedToLoad) return;
        if (recaptchaRetryTimeRemainingSecond <= 0) return;
        const intervalId = setInterval(()=>{
            setRecaptchaRetryTimeRemainingSecond(recaptchaRetryTimeRemainingSecond - 1);
        }, 1000);
        return ()=>clearInterval(intervalId);
    }, [
        recaptchaFailedToLoad,
        recaptchaRetryTimeRemainingSecond
    ]);
    const activateSite = async ({ privacyPolicy: privacyPolicy, skipManualFormValidationFlag: skipManualFormValidationFlag = false })=>{
        setHasSubmitted(true);
        sessionStorage.setItem('provisioningStartTime', `${Date.now()}`);
        // Start UFOs to begin duration metrics for signup submit
        (0, $gPKCY.ufoEventNewSiteN2NSubmit).start({
            productKey: productKey,
            webPlatform: 'site-activation'
        });
        (0, $gPKCY.ufoEventExistingSiteN2ESubmit).start({
            productKey: productKey,
            webPlatform: 'site-activation'
        });
        const ufoLogs = [
            ...$d9523cfc95d5074c$var$ufoBaseLogs,
            {
                name: 'method:activateSite'
            }
        ];
        // user must be logged in
        if (!user.isUserLoggedIn) return;
        // Generate a signup ID and add it to all the events in this flow.
        // This id is used to stitch together a view of the end-to-end
        // provisioning experience, all the way to landing in product.
        const signupId = (0, $fuLgT.default)();
        const isN2N = !showSitePicker && !sitePickerValue;
        const domainType = profile?.cohorts?.domainType;
        (0, $buVH1.trackSignupStarted)(createAnalyticsEvent, signupId, productKey, edition, isN2N, domainType);
        // handle site picker submit
        if (showSitePicker) {
            if (sitePickerValue) {
                const upgradableProduct = sitePickerValue.products.find((product)=>[
                        product.productKey,
                        product.partOfCollection
                    ].includes(productKey) && product.productEdition === 'free');
                // checking the standard-to-premium upgrade eligibility cohort
                const hasUpgradableStandardProduct = edition === 'premium' && [
                    (0, $fcO7r.ProductKey).JIRA_SOFTWARE,
                    (0, $fcO7r.ProductKey).CONFLUENCE,
                    (0, $fcO7r.ProductKey).JIRA_PRODUCT_DISCOVERY
                ].includes(productKey) && sitePickerValue.products.some((product)=>[
                        product.productKey
                    ].includes(productKey) && product.productEdition === 'standard');
                if (upgradableProduct || hasUpgradableStandardProduct) {
                    // send to adminhub
                    const redirectUrl = await (0, $gZgIU.getAdminHubUpgradeProductUrl)(sitePickerValue, productKey, edition);
                    createAnalyticsEvent({
                        eventName: 'signupUpgrade',
                        eventComponent: 'button',
                        billingSystem: sitePickerValue.products[0]?.billingSourceSystem,
                        cloudId: sitePickerValue.cloudId,
                        event: 'clicked',
                        eventType: 'ui',
                        action: 'upgrade'
                    }).fire('signup');
                    window.location.assign(redirectUrl);
                    return;
                }
                try {
                    // Check for Shadow IT authorization.
                    await stargateClient.getActivationAuthorization({
                        productKeys: [
                            productKey
                        ],
                        productEdition: edition,
                        cloudId: sitePickerValue.cloudId,
                        siteName: sitePickerValue?.displayName
                    });
                    const searchParameters = new URLSearchParams(window.location.search);
                    const signupSource = searchParameters.get('signupSource');
                    // Fetch the activation plan once the user has clicked so redirect
                    // handling can preserve paid-target confirmation flows.
                    const hasPaidTargetEditionRequiringConfirmationScreen = await $d9523cfc95d5074c$var$getHasPaidTargetEditionRequiringConfirmationScreen({
                        cloudId: sitePickerValue.cloudId,
                        productKey: productKey,
                        stargateClient: stargateClient,
                        signupSource: signupSource,
                        createAnalyticsEvent: createAnalyticsEvent
                    });
                    const crossFlowActivationUrl = (0, $gZgIU.getCrossFlowActivationUrl)({
                        cloudId: sitePickerValue.cloudId,
                        edition: edition,
                        productKey: primaryCollectionProduct ?? productKey,
                        siteName: sitePickerValue?.displayName,
                        hasPaidTargetEditionRequiringConfirmationScreen: hasPaidTargetEditionRequiringConfirmationScreen
                    });
                    (0, $gPKCY.ufoEventExistingSiteN2ESubmit).success({
                        customData: {
                            reactComponent: 'SiteActivationContextProvider',
                            analyticsEvent: 'succeeded',
                            siteType: 'existing-site'
                        }
                    });
                    (0, $buVH1.trackSitePickerSubmit)({
                        createAnalyticsEvent: createAnalyticsEvent,
                        targetCloudId: sitePickerValue.cloudId,
                        provisionedProducts: [
                            {
                                product: productKey,
                                edition: edition
                            }
                        ],
                        signupUrl: crossFlowActivationUrl,
                        aaid: user['accountId'],
                        signupSource: signupSource,
                        componentSource: 'SiteActivationContextProvider',
                        hasPaidTargetEditionRequiringConfirmationScreen: hasPaidTargetEditionRequiringConfirmationScreen
                    });
                    window.location.assign(crossFlowActivationUrl);
                } catch (error) {
                    (0, $gPKCY.ufoEventExistingSiteN2ESubmit).failure({
                        customData: {
                            reactComponent: 'SiteActivationContextProvider',
                            analyticsEvent: 'errored',
                            siteType: 'existing-site'
                        },
                        error: error
                    });
                    (0, $77cxG.redirectToAdminHubForShadowIt)(error);
                }
            }
            return;
        }
        if (isValidating) {
            const { availability: availability } = await stargateClient.checkCloudNameAvailability({
                cloudName: siteName
            });
            if (availability !== 'AVAILABLE') {
                setHasSubmitted(false); // reset to allow re-submit
                return;
            }
            setSiteNameValid(true);
        }
        // spark-defer-site-name-v2 (TWCG-2407): the auto-activation path bypasses
        // the manual-form siteNameValid gate, but the recommended name must still
        // be confirmed available immediately before activating — it may have been
        // taken by another signup since the validation hook last ran. Re-check
        // authoritatively and, if it is not available, abort and let the consumer
        // fall back to the manual naming screen rather than activating a bad name.
        if (skipManualFormValidationFlag) {
            const availabilityResult = await stargateClient.checkCloudNameAvailability({
                cloudName: siteName
            }).catch(()=>undefined);
            // Fail safe: treat a missing/errored/non-available result as not
            // available so we never activate a name we could not confirm.
            if (availabilityResult?.availability !== 'AVAILABLE') {
                setAutoActivationFailed(true);
                setHasSubmitted(false); // reset to allow re-submit
                return;
            }
        }
        if (!siteNameValid && !isValidating && !skipManualFormValidationFlag || !siteName) {
            setHasSubmitted(false); // reset to allow re-submit
            return;
        }
        (0, $buVH1.trackSubmitSuccess)(createAnalyticsEvent);
        if (siteName !== recommendedSiteName) (0, $buVH1.trackSiteNameChangedFromRecommendedSiteName)(createAnalyticsEvent, siteName, recommendedSiteName);
        // Record whether this attempt is the auto-activation one so a later
        // recaptcha-retry (which calls activateSiteHandler directly, outside this
        // closure) can still recognise it on failure (TWCG-2407).
        isAutoActivationAttemptRef.current = skipManualFormValidationFlag;
        let setTimeoutId;
        const interactionId = (0, $fuLgT.default)();
        (0, $fgra6.operateWithSignupUFOLogging)({
            interactionId: interactionId,
            interactionName: 'try-cloud-signup_form-submit',
            type: 'press',
            timeout: 120000,
            labelStack: [
                {
                    name: 'uip'
                }
            ],
            errorContext: 'error occured on signup form submit button'
        }, async ()=>Promise.race([
                new Promise((_resolve, reject)=>{
                    setTimeoutId = setTimeout(()=>{
                        reject((0, $fgra6.SignupUFOLoggingActionTimeoutError));
                    }, 60000);
                }),
                activateSiteHandler(signupId, privacyPolicy).finally(()=>{
                    if (setTimeoutId) clearTimeout(setTimeoutId);
                })
            ])).then(()=>{
            // SLO "good event" for N2N signup submit
            (0, $gPKCY.ufoEventNewSiteN2NSubmit).success({
                customData: {
                    reactComponent: 'SiteActivationContextProvider',
                    analyticsEvent: 'succeeded',
                    siteType: 'new-site'
                }
            });
            (0, $fgra6.trackAndCompleteUFOEvent)({
                experienceName: (0, $lIWv2.UfoEventName).ACTIVATE_PRODUCT_API_SUCCESS,
                experienceStatus: $d9523cfc95d5074c$var$SUCCEEDED,
                interactionType: $d9523cfc95d5074c$var$TRANSITION,
                ufoLogger: ufoLogs
            });
            // Reliabiltiy SLO "good event" for signup submit captured on bxp-ui only
            (0, $fgra6.trackAndCompleteUFOEvent)({
                experienceName: (0, $lIWv2.UfoEventName).BXPUI_SIGNUP_SUBMIT_SLO_SUCCEEDED,
                experienceStatus: $d9523cfc95d5074c$var$SUCCEEDED,
                interactionType: $d9523cfc95d5074c$var$PRESS,
                ufoLogger: ufoLogs
            });
            // Reliabiltiy SLO "good event" for signup submit captured across bxp-ui and bxpkit
            (0, $fgra6.trackAndCompleteUFOEvent)({
                experienceName: (0, $lIWv2.UfoEventName).DEFAULT_SIGNUP_SUBMIT_SLO_SUCCEEDED,
                experienceStatus: $d9523cfc95d5074c$var$SUCCEEDED,
                interactionType: $d9523cfc95d5074c$var$PRESS,
                ufoLogger: ufoLogs
            });
        }).catch((error)=>{
            // Show add-payment-method page if Rovo Dev 403 (user clicks "Open payment methods" to open in new tab)
            if (productKey === (0, $fcO7r.ProductKey).DEVAI && error?.response?.status === 403) {
                const adminPaymentLink = (0, $6isYE.getAdminPaymentLink)(error);
                if (adminPaymentLink) {
                    setIsSubmitting(false);
                    setHasSubmitted(false);
                    setPaymentDetailsView({
                        view: 'payment-required',
                        adminPaymentLink: adminPaymentLink
                    });
                    return;
                }
            }
            // SLO "bad event" for N2N signup submit
            (0, $gPKCY.ufoEventNewSiteN2NSubmit).failure({
                customData: {
                    reactComponent: 'SiteActivationContextProvider',
                    analyticsEvent: 'errored',
                    siteType: 'new-site'
                },
                error: error
            });
            (0, $77cxG.redirectToAdminHubForShadowIt)(error);
            const traceId = error?.response?.headers?.get('atl-traceid');
            const errorId = traceId ? `Trace ID: ${traceId}` : `Interaction ID: ${interactionId}`;
            setValidationMessage({
                ...(0, $amfpH.messages).timeout,
                values: {
                    // eslint-disable-next-line react/no-unstable-nested-components
                    'href-support': (node)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            href: localizedContactUrl,
                            children: node
                        }),
                    error_id: errorId
                }
            });
            // spark-defer-site-name-v2 (TWCG-2407): the auto-activation path has
            // no visible form to surface this error on. Fall back to the manual
            // naming screen so the user sees the create-a-site panel (pre-filled
            // with the generated name via siteName) and the validation message
            // above, and can retry. The message just set above lives on this
            // (about to be replaced) provider instance, so persist the error id
            // for the fresh instance the fallback mounts to pick back up.
            // The manual form records the same error screen here.
            if (skipManualFormValidationFlag) {
                $d9523cfc95d5074c$export$da3a03d534251f74(errorId);
                setAutoActivationFailed(true);
            } else if (analyticsClient) (0, $buVH1.trackDeferSiteNameErrorScreen)(createAnalyticsEvent, {
                cohort: 'control',
                reason: 'activateProduct',
                productKey: productKey
            });
            // don't re-enable the form when there is an HTTP exception. this helps with rate-limiting
            const errorType = (0, $fgra6.SignupGetUFOErrorType)(error);
            if (errorType !== 'http_exception') {
                // Reset form to allow re-submit
                setIsSubmitting(false);
                setHasSubmitted(false);
            }
            (0, $fgra6.trackAndCompleteUFOEvent)({
                experienceName: (0, $lIWv2.UfoEventName).ACTIVATE_PRODUCT_API_ERROR,
                experienceStatus: $d9523cfc95d5074c$var$ABORTED,
                interactionType: $d9523cfc95d5074c$var$TRANSITION,
                error: error,
                errorName: 'ActivateProductError',
                errorMessage: 'error occured on activateProduct',
                ufoLogger: ufoLogs
            });
            // Reliabiltiy SLO "bad event" for signup submit captured on bxp-ui only
            (0, $fgra6.trackAndCompleteUFOEvent)({
                experienceName: (0, $lIWv2.UfoEventName).BXPUI_SIGNUP_SUBMIT_SLO_FAILED,
                experienceStatus: $d9523cfc95d5074c$var$ABORTED,
                interactionType: $d9523cfc95d5074c$var$PRESS,
                error: error,
                errorName: 'ActivateProductError',
                errorMessage: 'error occured on activateProduct',
                ufoLogger: ufoLogs
            });
            // Reliabiltiy SLO "bad event" for signup submit captured across bxp-ui and bxpkit
            (0, $fgra6.trackAndCompleteUFOEvent)({
                experienceName: (0, $lIWv2.UfoEventName).DEFAULT_SIGNUP_SUBMIT_SLO_FAILED,
                experienceStatus: $d9523cfc95d5074c$var$ABORTED,
                interactionType: $d9523cfc95d5074c$var$PRESS,
                error: error,
                errorName: 'ActivateProductError',
                errorMessage: 'error occured on activateProduct',
                ufoLogger: ufoLogs
            });
        });
    };
    // activateSite is a plain async function that gets a new reference every
    // render. Hold the latest version in a ref so the auto-activation effect can
    // call it without listing it as a dependency (which would otherwise re-run the
    // effect every render).
    const activateSiteRef = (0, $1oC0p.useRef)(activateSite);
    activateSiteRef.current = activateSite;
    // spark-defer-site-name-v2 (TWCG-2407): when a consumer opts into
    // auto-activation, activate the site automatically once a (recommended) site
    // name has been populated and validated — skipping the manual naming step.
    // The recommended name itself is fetched by the consumer via
    // useRecommendedSiteName, which writes it into siteName. hasAutoActivatedRef
    // keeps this to a single invocation across re-renders/remounts.
    (0, $1oC0p.useEffect)(()=>{
        if (!autoActivateWithRecommendedName || hasAutoActivatedRef.current || showSitePicker || !siteName || isValidating || // Provisioning already started in this session (e.g. the user navigated
        // back to signup after activation). Do not re-activate; the experiment's
        // screen branch also checks this so the existing-sites screen renders.
        $d9523cfc95d5074c$export$65f080cf3bdd9909()) return;
        if (!isValid) {
            // The recommended name failed validation (e.g. checkCloudNameAvailability
            // errored, or the name itself is invalid). That failure resolves without
            // ever throwing, so nothing else would flag this — without this check the
            // auto-activation path is stuck on the spinner forever since isValid can
            // never become true. Fall back to manual naming instead.
            // error's own "no error yet" sentinel (ErrorType.NO_ERROR) is a non-empty
            // string and therefore truthy — must compare against it explicitly, or
            // this fires on every transient not-yet-validated render and permanently
            // blocks activation (hasAutoActivatedRef.current) before isValid ever
            // gets a chance to become true.
            if (error && error !== (0, $cURcB.ErrorType).NO_ERROR) {
                hasAutoActivatedRef.current = true;
                setAutoActivationFailed(true);
            }
            return;
        }
        hasAutoActivatedRef.current = true;
        // The recommended name has already passed the validation hook (isValid),
        // so skip activateSite's manual-form siteNameValid gate (that flag is only
        // set by the manual naming form, which we bypass here).
        activateSiteRef.current({
            skipManualFormValidationFlag: true
        });
    }, [
        autoActivateWithRecommendedName,
        showSitePicker,
        siteName,
        isValidating,
        isValid,
        error
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($d9523cfc95d5074c$export$fe5d808150ab3415.Provider, {
        value: {
            isSubmitting: isSubmitting,
            activateSite: activateSite,
            showSitePicker: showSitePicker,
            sites: sites,
            isRequestInProgress: profile.requestInProgress,
            email: user['email'],
            sitePickerValue: sitePickerValue,
            setSitePickerValue: setSitePickerValue,
            setSiteNameValid: setSiteNameValid,
            siteName: siteName,
            setSiteNameValue: setSiteNameValue,
            setShowSitePicker: setShowSitePicker,
            recommendedSiteName: recommendedSiteName,
            hasSubmitted: hasSubmitted,
            setHasSubmitted: setHasSubmitted,
            validationMessageState: [
                validatationMessage,
                setValidationMessage
            ],
            isValid: isValid,
            isValidating: isValidating,
            error: error,
            isWorkspaceProduct: isWorkspaceProduct,
            selectedTransactionAccountId: selectedTransactionAccountId,
            setSelectedTransactionAccountId: setSelectedTransactionAccountId,
            primaryCollectionProduct: primaryCollectionProduct,
            paymentDetailsView: paymentDetailsView,
            setPaymentDetailsView: setPaymentDetailsView,
            autoActivationFailed: autoActivationFailed
        },
        children: children
    });
};

});
parcelRegister("cG7vk", function(module, exports) {
$parcel$export(module.exports, "getConsents", function () { return $cfc06dcc6844c6fb$export$aa1c769485f00255; });
const $cfc06dcc6844c6fb$export$aa1c769485f00255 = (locale, localeRequiresMarketingCommunicationOptIn = false, privacyPolicy = '')=>{
    //TO DO: Get signup to remove this payload reqirement as this is NOT shown to the user
    return {
        site: 'atlassian',
        locale: locale,
        formUrl: window.location.href,
        consents: [
            {
                key: 'termsOfService',
                // showing "" as we do not show anything to the user
                displayedText: '',
                granted: true
            },
            {
                key: 'privacyPolicy',
                displayedText: privacyPolicy,
                granted: true
            },
            {
                key: 'generalMarketingOptIn',
                // showing "" as we do not show anything to the user
                displayedText: '',
                granted: !localeRequiresMarketingCommunicationOptIn
            }
        ]
    };
};

});

parcelRegister("36RSw", function(module, exports) {
$parcel$export(module.exports, "getSignupContext", function () { return $2dcb0771ea012f74$export$d0b488e11359b5d1; });

var $3L8ZR = parcelRequire("3L8ZR");

var $dpiFM = parcelRequire("dpiFM");

var $2gCne = parcelRequire("2gCne");

var $fcO7r = parcelRequire("fcO7r");

var $gPKCY = parcelRequire("gPKCY");
function $2dcb0771ea012f74$export$d0b488e11359b5d1({ productKey: productKey, testingPurposes: testingPurposes, signupId: signupId, search: search, locale: locale }) {
    const searchParameters = new URLSearchParams(search);
    const templateId = searchParameters.get('templateId');
    const publicLinkId = searchParameters.get('publicLinkId');
    const signupContext = {};
    if (templateId) Object.assign(signupContext, {
        templateId: templateId
    });
    if (testingPurposes) Object.assign(signupContext, {
        testingPurposes: true
    });
    if (signupId) Object.assign(signupContext, {
        signupId: signupId
    });
    const anchorLocalStorage = (0, $2gCne.getLocalStorage)('onboarding-journey');
    if (anchorLocalStorage) try {
        (0, $gPKCY.ufoEventBxpGatewayAnchorParse).start({
            productKey: productKey,
            webPlatform: 'bxp-ui'
        });
        const localStorageObj = JSON.parse(anchorLocalStorage);
        if (localStorageObj) {
            const bxpGatewayAnchor = {
                anchor: localStorageObj.anchor?.name,
                type: localStorageObj.anchor?.type,
                team: localStorageObj.team,
                persona: localStorageObj.persona,
                keyword: localStorageObj.keyword,
                timestamp: new Date()
            };
            Object.assign(signupContext, {
                bxpGatewayAnchor: bxpGatewayAnchor
            });
        }
        (0, $gPKCY.ufoEventBxpGatewayAnchorParse).success({
            customData: {
                reactComponent: 'getSignupContext',
                analyticsEvent: 'succeeded'
            }
        });
    } catch (error) {
        (0, $gPKCY.ufoEventBxpGatewayAnchorParse).failure({
            customData: {
                reactComponent: 'getSignupContext',
                analyticsEvent: 'error',
                anchorLocalStorage: anchorLocalStorage
            },
            error: error
        });
    }
    const confluencePublicLinkEnabled = (0, $3L8ZR.default).checkGate((0, $dpiFM.StatsigFeatureGateKey).BXPSU_2854_CONFLUENCE_PUBLIC_LINK);
    if (productKey === (0, $fcO7r.ProductKey).CONFLUENCE && publicLinkId && confluencePublicLinkEnabled) Object.assign(signupContext, {
        publicLinkId: decodeURIComponent(publicLinkId)
    });
    if (locale) Object.assign(signupContext, {
        locale: locale
    });
    return signupContext;
}

});
parcelRegister("dpiFM", function(module, exports) {
$parcel$export(module.exports, "StatsigFeatureGateKey", function () { return $21861e1c4b9bb1e3$export$8af921d6e42706ad; });
var $21861e1c4b9bb1e3$export$8af921d6e42706ad = /*#__PURE__*/ function(StatsigFeatureGateKey) {
    StatsigFeatureGateKey["BXPSU_2854_CONFLUENCE_PUBLIC_LINK"] = "bxpsu-2854_confluence_public_link"; // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/gates/bxpsu-2854_confluence_public_link
    return StatsigFeatureGateKey;
}({});
var $21861e1c4b9bb1e3$export$111c3eba7363bcc7 = /*#__PURE__*/ function(StatsigExperimentKey) {
    StatsigExperimentKey["WAC_SIGNUP_UPGRADE_PATH"] = "wac_signup_upgrade_path";
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/wac_signup_upgrade_path
    StatsigExperimentKey["JFIND_COMPANY_EXPAND_IMPACT"] = "jfind-company-expand-impact";
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/jfind-company-expand-impact
    StatsigExperimentKey["JFIND_PAID_GET_USERS_BACK_TO_PRODUCT"] = "jfind-get-users-back-to-product-for-paid";
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/jfind-get-users-back-to-product-for-paid/setup
    StatsigExperimentKey["JFIND_REDIRECT_TO_PRODUCT_V2"] = "jfind-redirect-logged-in-users-to-product-v2"; //https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/jfind-redirect-logged-in-users-to-product-v2/setup
    return StatsigExperimentKey;
}({});
var $21861e1c4b9bb1e3$export$49182666c899d264 = /*#__PURE__*/ function(StatsigExperimentCohort) {
    StatsigExperimentCohort["CONTROL"] = "control";
    StatsigExperimentCohort["UNEXPECTED_FAILURE"] = "unexpected_failure";
    StatsigExperimentCohort["NOT_ENROLLED"] = "not_enrolled";
    StatsigExperimentCohort["WAC_SIGNUP_UPGRADE_PATH_TEST"] = "test";
    StatsigExperimentCohort["JFIND_COMPANY_EXPAND_IMPACT_VARIANT"] = "jfind-company-expand-impact";
    StatsigExperimentCohort["JFIND_REDIRECT_TO_PRODUCT_V2_CONTROL"] = "control";
    StatsigExperimentCohort["JFIND_REDIRECT_TO_PRODUCT_V2_VARIANT"] = "variant";
    StatsigExperimentCohort["JFIND_PAID_GET_USERS_BACK_TO_PRODUCT_CONTROL"] = "control";
    StatsigExperimentCohort["JFIND_PAID_GET_USERS_BACK_TO_PRODUCT_VARIANT"] = "variation";
    return StatsigExperimentCohort;
}({});

});


parcelRegister("9EuLB", function(module, exports) {
$parcel$export(module.exports, "isTestTenantByName", function () { return $ff00a0ebc0b5c261$export$293bc70a1f725926; });

var $kNE9Z = parcelRequire("kNE9Z");
const $ff00a0ebc0b5c261$export$293bc70a1f725926 = (siteName)=>{
    if ((0, $kNE9Z.isProduction)()) return false;
    const TEST_TENANT_PATTERN = /^atl-vertigo--(((?:jira|j|rolex|stg)+-jira-branch-[^-]+--)|(conf-(conf|stg)-proxy-\w+--[\w-]+)).*$/;
    const SHORT_TEST_TENANT_PATTERN = /^atl-vertigo--jira-(jes|jed)-[^-]+--.*$/;
    return TEST_TENANT_PATTERN.test(siteName) || SHORT_TEST_TENANT_PATTERN.test(siteName) || siteName.includes('polli.signup');
};

});

parcelRegister("77cxG", function(module, exports) {
$parcel$export(module.exports, "redirectToAdminHubForShadowIt", function () { return $03ca8126a2fae79c$export$cf3cb68c5cf1d1dd; });

var $eMftW = parcelRequire("eMftW");
const $03ca8126a2fae79c$export$cf3cb68c5cf1d1dd = (error)=>{
    const errorCode = error?.response?.status;
    const redirectUrlShadowIt = errorCode === 403 && (0, $eMftW.getRedirectUrlFromShadowItError)(error);
    // Shadow IT unauthorized user redirects to adminhub's Shadow IT request flow.
    if (errorCode === 403 && Boolean(redirectUrlShadowIt)) window.location.assign(redirectUrlShadowIt);
};

});

parcelRegister("6isYE", function(module, exports) {
$parcel$export(module.exports, "getAdminPaymentLink", function () { return $2a79b28f6910d324$export$ee6f0e0498ee449; });

var $kNE9Z = parcelRequire("kNE9Z");
const $2a79b28f6910d324$export$ee6f0e0498ee449 = (error)=>{
    const errorResponse = error?.message?.trim();
    if (!errorResponse) return null;
    const errorBody = errorResponse.startsWith('Forbidden') ? errorResponse.substring(9).trim() : errorResponse;
    try {
        const paymentMethodsPath = JSON.parse(errorBody)?.paymentMethodsPath;
        if (!paymentMethodsPath) return null;
        const adminBaseUrl = (0, $kNE9Z.isProduction)() ? 'https://admin.atlassian.com' : 'https://admin.stg.atlassian.com';
        return adminBaseUrl + paymentMethodsPath;
    } catch  {
        return null;
    }
};
const $2a79b28f6910d324$export$fd042af660d8eb2d = (error)=>{
    const url = $2a79b28f6910d324$export$ee6f0e0498ee449(error);
    if (url) {
        window.open(url, '_blank');
        return {
            result: true,
            adminPaymentLink: url
        };
    }
    return {
        result: false
    };
};

});

parcelRegister("fgra6", function(module, exports) {
$parcel$export(module.exports, "SignupUFOLoggingActionTimeoutError", function () { return $56f15a525545281c$export$6a44d450a6df8fd1; });
$parcel$export(module.exports, "operateWithSignupUFOLogging", function () { return $56f15a525545281c$export$20e2df2ad005f6b6; });
$parcel$export(module.exports, "SignupGetUFOErrorType", function () { return $56f15a525545281c$export$aa2a0d3061506a46; });
$parcel$export(module.exports, "trackAndCompleteUFOEvent", function () { return $56f15a525545281c$export$480a57084d436f31; });
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $fuLgT = parcelRequire("fuLgT");

var $03EZb = parcelRequire("03EZb");

var $1BTY2 = parcelRequire("1BTY2");

var $a48Mt = parcelRequire("a48Mt");

var $gx3aw = parcelRequire("gx3aw");

var $lIWv2 = parcelRequire("lIWv2");
const { ABORTED: $56f15a525545281c$var$ABORTED } = (0, $lIWv2.UfoExperienceStatus);
const $56f15a525545281c$export$6a44d450a6df8fd1 = new Error(`Action times out`);
async function $56f15a525545281c$export$20e2df2ad005f6b6(options, callback, errorLogCallback, responseLogCallback) {
    const { interactionId: interactionId, interactionName: interactionName, type: type = 'transition', timeout: timeout, labelStack: labelStack = [], errorContext: errorContext } = options;
    const baseStack = $56f15a525545281c$var$_buildUFOLoggerBaseStack();
    (0, $1BTY2.DefaultInteractionID).current = interactionId;
    (0, $a48Mt.addNewInteraction)(interactionId, interactionName, type, Date.now(), (0, $03EZb.getInteractionRate)(interactionName, type === 'segment' ? 'legacy' : type), labelStack);
    (0, $a48Mt.addCustomData)(interactionId, labelStack, baseStack);
    if (timeout) {
        const interaction = (0, $a48Mt.getActiveInteraction)();
        interaction?.changeTimeout(timeout);
    }
    try {
        const res = await callback();
        if (responseLogCallback) responseLogCallback(res);
        (0, $a48Mt.tryComplete)(interactionId, Date.now());
        return res;
    } catch (error) {
        if (errorLogCallback) {
            errorLogCallback(error);
            throw error;
        }
        const errorStack = $56f15a525545281c$var$_buildUFOLoggerErrorStack(error);
        const errorStackArray = Object.keys(errorStack).map((key)=>!!errorStack[key] ? {
                name: `${key}:${errorStack[key]}`
            } : null).filter((value)=>!!value);
        (0, $a48Mt.addError)(interactionId, interactionName, errorStackArray, $56f15a525545281c$export$aa2a0d3061506a46(error), `Error occurred on call: ${errorContext}`);
        (0, $a48Mt.abort)(interactionId, 'unload');
        throw error;
    }
}
function $56f15a525545281c$export$88234b8f2fbbd263(options) {
    const { interactionName: interactionName, type: type, timeout: timeout, labelStack: labelStack } = options;
    const formSubmitInteractionId = (0, $fuLgT.default)();
    (0, $1BTY2.DefaultInteractionID).current = formSubmitInteractionId;
    (0, $a48Mt.addNewInteraction)(formSubmitInteractionId, interactionName, type, Date.now(), (0, $03EZb.getInteractionRate)(interactionName, type === 'segment' ? 'legacy' : type), labelStack ?? []);
    if (timeout) {
        const interaction = (0, $a48Mt.getActiveInteraction)();
        interaction?.changeTimeout(timeout);
    }
    return formSubmitInteractionId;
}
function $56f15a525545281c$export$fe5b9d161ae98d2f(options) {
    const { error: error, interactionId: interactionId, errorType: errorType, name: name, labelStack: labelStack, errorMessage: errorMessage, config: config } = options;
    const errorCode = error?.response?.status;
    if (errorCode) labelStack.push({
        name: `errorCode:${errorCode}`
    });
    const errorId = error?.response?.headers?.get('atl-traceid');
    if (errorId) labelStack.push({
        name: `atlTraceId:${errorId}`
    });
    const errorUrl = window?.location?.href;
    if (config.isQueryParamCheck && errorUrl) {
        const url = new URL(errorUrl);
        const requestUrl = error?.url;
        labelStack.push({
            name: `pathName:${url.pathname}`
        });
        if (requestUrl) labelStack.push({
            name: `requestPath:${new URL(requestUrl).pathname}`
        });
        const product = url.searchParams.get('product');
        if (product) labelStack.push({
            name: `product:${product}`
        });
        const edition = url.searchParams.get('edition');
        if (product) labelStack.push({
            name: `edition:${edition}`
        });
        const bundle = url.searchParams.get('bundle');
        if (product) labelStack.push({
            name: `bundle:${bundle}`
        });
    }
    (0, $a48Mt.addError)(interactionId, name, labelStack, errorType, errorMessage);
}
function $56f15a525545281c$export$b023879ae3e4fb7c(interactionId) {
    (0, $a48Mt.tryComplete)(interactionId, Date.now());
}
function $56f15a525545281c$export$a47c5df8850058(interactionId) {
    (0, $a48Mt.abort)(interactionId, 'unload');
}
function $56f15a525545281c$export$aa2a0d3061506a46(error) {
    let errorType;
    if (error == $56f15a525545281c$export$6a44d450a6df8fd1) errorType = 'timeout';
    else if (!!error?.response?.status) errorType = 'http_exception';
    else if (error?.name) errorType = error.name;
    else errorType = 'react_error';
    return errorType;
}
function $56f15a525545281c$export$480a57084d436f31(options) {
    const { experienceName: experienceName, experienceStatus: experienceStatus, interactionType: interactionType = 'transition', ufoLogger: ufoLogger = [], error: error, errorName: errorName = '', errorMessage: errorMessage = '' } = options;
    const interactionId = (0, $fuLgT.default)();
    // UFO exposes 'labelStack', which acts similar to deferred info logger.
    // These logs surface to Splunk, but not SignalFX
    const labelStack = $56f15a525545281c$var$_buildUFOLoggerLabelStack({
        labelStack: ufoLogger,
        error: error
    });
    // Initialize UFO event
    (0, $a48Mt.addNewInteraction)(interactionId, experienceName, interactionType, Date.now(), (0, $03EZb.getInteractionRate)(experienceName, interactionType === 'segment' ? 'legacy' : interactionType), labelStack);
    if (experienceStatus === $56f15a525545281c$var$ABORTED) {
        // Add error meta data to UFO event
        (0, $a48Mt.addError)(interactionId, errorName, labelStack, $56f15a525545281c$export$aa2a0d3061506a46(error), errorMessage);
        // Send ABORTED event to UFO event queue
        (0, $a48Mt.abort)(interactionId, 'unload');
    } else // Send SUCCEEDED event to UFO event queue
    (0, $a48Mt.tryComplete)(interactionId, Date.now());
}
function $56f15a525545281c$var$_buildUFOLoggerLabelStack(options) {
    const { labelStack: labelStack = [], error: error } = options;
    const baseStack = $56f15a525545281c$var$_buildUFOLoggerBaseStack();
    const errorStack = $56f15a525545281c$var$_buildUFOLoggerErrorStack(error);
    const baseStackArray = Object.keys(baseStack).map((key)=>!!baseStack[key] ? {
            name: `${key}:${baseStack[key]}`
        } : null).filter((value)=>!!value);
    const errorStackArray = Object.keys(errorStack).map((key)=>!!errorStack[key] ? {
            name: `${key}:${errorStack[key]}`
        } : null).filter((value)=>!!value);
    return [
        ...labelStack,
        ...baseStackArray ?? [],
        ...errorStackArray ?? []
    ];
}
function $56f15a525545281c$var$_buildUFOLoggerBaseStack() {
    // We want to use 'analyticsAnonymousId' to link the interaction to the user via Splunk logs
    const analyticsAnonymousId = (0, $gx3aw.Cookie).readCookie('ajs_anonymous_id');
    // Build base stack for UFO logger
    const browserUrl = new URL(window?.location?.href);
    const browserPath = browserUrl?.pathname;
    const product = browserUrl.searchParams.get('product');
    const bundle = browserUrl.searchParams.get('bundle');
    const edition = browserUrl.searchParams.get('edition');
    return {
        anonymousId: analyticsAnonymousId,
        browserPath: browserPath,
        product: product,
        bundle: bundle,
        edition: edition
    };
}
function $56f15a525545281c$var$_buildUFOLoggerErrorStack(error) {
    // Build error stack if error present
    let errorUrl = null;
    let errorReqPath = null;
    let errorStatusCode = null;
    if (error) {
        if (error.url && typeof error.url === 'string') try {
            errorUrl = new URL(error.url);
            errorReqPath = errorUrl ? new URL(errorUrl).pathname : undefined;
            errorStatusCode = error.response.status;
        } catch (e) {
            console.log('error building UFO error stack: ', e);
        }
    }
    return {
        errorReqPath: errorReqPath,
        errorCode: errorStatusCode
    };
}

});

parcelRegister("cURcB", function(module, exports) {
$parcel$export(module.exports, "ErrorType", function () { return $23d0e7cb9d3a9a7d$export$dba1278861bf0dc1; });
$parcel$export(module.exports, "useSiteNameValidation", function () { return $23d0e7cb9d3a9a7d$export$2bad1b70bce0c458; });

var $1oC0p = parcelRequire("1oC0p");

var $erWD3 = parcelRequire("erWD3");

var $eY3N6 = parcelRequire("eY3N6");

var $gPKCY = parcelRequire("gPKCY");

var $5Ntyw = parcelRequire("5Ntyw");
var $23d0e7cb9d3a9a7d$export$dba1278861bf0dc1 = /*#__PURE__*/ function(ErrorType) {
    ErrorType["MAXIMUM_LENGTH"] = "maximumLength";
    ErrorType["INVALID_NAME"] = "invalidName";
    ErrorType["UNAVAILABLE"] = "unavailable";
    ErrorType["NETWORK_ERROR"] = "networkError";
    ErrorType["NO_ERROR"] = "noError";
    return ErrorType;
}({});
const $23d0e7cb9d3a9a7d$var$SITE_NAME_REGEX = /^[a-z0-9]+[a-z0-9-]+[a-z0-9]+$/;
function $23d0e7cb9d3a9a7d$export$2bad1b70bce0c458(siteName, onValidationChange = ()=>null) {
    const [isDirty, setIsDirty] = (0, $1oC0p.useState)(false);
    const [validation, setValidation] = (0, $1oC0p.useState)({
        isValid: undefined,
        error: "noError"
    });
    const [availability, setAvailable] = (0, $1oC0p.useState)({
        isValidating: false,
        isAvailable: false,
        error: "noError",
        siteName: ''
    });
    const [invalidTimes, setInvalidTimes] = (0, $1oC0p.useState)(0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const stargateClient = (0, $5Ntyw.useBxpWebStargateClient)();
    (0, $1oC0p.useEffect)(()=>{
        if (siteName.length > 0 && !isDirty) setIsDirty(true);
        setAvailable({
            ...availability,
            isValidating: true
        });
        $23d0e7cb9d3a9a7d$var$validateSiteNameDebounced.cancel();
        if (!$23d0e7cb9d3a9a7d$var$validateSiteNameLength(siteName, setValidation, isDirty)) {
            setAvailable((availability)=>({
                    ...availability,
                    isValidating: false
                }));
            return;
        }
        (0, $gPKCY.ufoEventSiteNameAvailability).setCustomData({
            invalidTimes: invalidTimes
        });
        $23d0e7cb9d3a9a7d$var$validateSiteNameDebounced(siteName, stargateClient, setAvailable, availability, createAnalyticsEvent)?.catch(()=>{
            setAvailable({
                siteName: siteName,
                isAvailable: false,
                isValidating: false,
                error: "noError"
            });
        });
    }, [
        siteName
    ]);
    (0, $1oC0p.useEffect)(()=>{
        onValidationChange(!!validation.isValid && validation.error === "noError" && availability.isAvailable && siteName === availability.siteName && availability.error === "noError");
        if (validation.error === "invalidName") setInvalidTimes(invalidTimes + 1);
    }, [
        validation,
        availability
    ]);
    return {
        isValidating: availability.isValidating,
        isValid: validation.isValid && availability.isAvailable && siteName === availability.siteName,
        error: validation.error === "noError" ? availability.error : validation.error
    };
}
const $23d0e7cb9d3a9a7d$var$validateSiteNameLength = (siteName, setValidation, isDirty)=>{
    if (siteName.length === 0 && !isDirty) {
        setValidation({
            isValid: false,
            error: "noError"
        });
        return false;
    } else if (siteName.length < 3) {
        setValidation({
            isValid: false,
            error: "invalidName"
        });
        return false;
    } else if (siteName.length > 50) {
        setValidation({
            isValid: false,
            error: "maximumLength"
        });
        return false;
    } else if (!$23d0e7cb9d3a9a7d$var$SITE_NAME_REGEX.test(siteName)) {
        setValidation({
            isValid: false,
            error: "invalidName"
        });
        return false;
    }
    setValidation({
        isValid: true,
        error: "noError"
    });
    return true;
};
const $23d0e7cb9d3a9a7d$var$validateSiteNameDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($erWD3)))($23d0e7cb9d3a9a7d$var$validateSiteName, 300, {
    trailing: true
});
async function $23d0e7cb9d3a9a7d$var$validateSiteName(siteName, stargateClient, setAvailable, availability, createAnalyticsEvent) {
    setAvailable({
        ...availability,
        isValidating: true
    });
    try {
        (0, $gPKCY.ufoEventSiteNameAvailability).start({
            webPlatform: 'bxp-ui'
        });
        const { availability: availability } = await stargateClient.checkCloudNameAvailability({
            cloudName: siteName
        });
        (0, $gPKCY.ufoEventSiteNameAvailability).success({
            customData: {
                siteName: siteName,
                availability: availability
            }
        });
        createAnalyticsEvent({
            isNewRelic: true,
            isAjax: true,
            apiName: 'react-signup-site-validation',
            action: 'react-signup-site-validation',
            success: true,
            response: {
                status: '200',
                apiUrl: 'site-availability-url'
            }
        }).fire('signup');
        switch(availability){
            case 'AVAILABLE':
                return setAvailable({
                    siteName: siteName,
                    isValidating: false,
                    isAvailable: true,
                    error: "noError"
                });
            default:
                return setAvailable({
                    siteName: siteName,
                    isValidating: false,
                    isAvailable: false,
                    error: "unavailable"
                });
        }
    } catch (e) {
        createAnalyticsEvent({
            isNewRelic: true,
            isAjax: true,
            apiName: 'react-signup-site-validation',
            action: 'react-signup-site-validation',
            success: false,
            response: undefined,
            additionalInfo: e
        }).fire('signup');
        return setAvailable({
            siteName: siteName,
            isValidating: false,
            isAvailable: false,
            error: "networkError"
        });
    }
}

});
parcelRegister("erWD3", function(module, exports) {

var $ih96c = parcelRequire("ih96c");

var $ez49H = parcelRequire("ez49H");

var $i5LOB = parcelRequire("i5LOB");
/** Error message constants. */ var $a85110cf61019b06$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a85110cf61019b06$var$nativeMax = Math.max, $a85110cf61019b06$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $a85110cf61019b06$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($a85110cf61019b06$var$FUNC_ERROR_TEXT);
    wait = $i5LOB(wait) || 0;
    if ($ih96c(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $a85110cf61019b06$var$nativeMax($i5LOB(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $a85110cf61019b06$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $ez49H();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($ez49H());
    }
    function debounced() {
        var time = $ez49H(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports = $a85110cf61019b06$var$debounce;

});
parcelRegister("ez49H", function(module, exports) {

var $bBiRC = parcelRequire("bBiRC");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $a9a78ebf45cce892$var$now = function() {
    return $bBiRC.Date.now();
};
module.exports = $a9a78ebf45cce892$var$now;

});

parcelRegister("i5LOB", function(module, exports) {

var $cwhLk = parcelRequire("cwhLk");

var $ih96c = parcelRequire("ih96c");

var $7K8RW = parcelRequire("7K8RW");
/** Used as references for various `Number` constants. */ var $0366286619144970$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $0366286619144970$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $0366286619144970$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $0366286619144970$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $0366286619144970$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $0366286619144970$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($7K8RW(value)) return $0366286619144970$var$NAN;
    if ($ih96c(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $ih96c(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $cwhLk(value);
    var isBinary = $0366286619144970$var$reIsBinary.test(value);
    return isBinary || $0366286619144970$var$reIsOctal.test(value) ? $0366286619144970$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $0366286619144970$var$reIsBadHex.test(value) ? $0366286619144970$var$NAN : +value;
}
module.exports = $0366286619144970$var$toNumber;

});
parcelRegister("cwhLk", function(module, exports) {

var $km1La = parcelRequire("km1La");
/** Used to match leading whitespace. */ var $91d64068929a6877$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $91d64068929a6877$var$baseTrim(string) {
    return string ? string.slice(0, $km1La(string) + 1).replace($91d64068929a6877$var$reTrimStart, '') : string;
}
module.exports = $91d64068929a6877$var$baseTrim;

});
parcelRegister("km1La", function(module, exports) {
/** Used to match a single whitespace character. */ var $ed173a2bc5e60c5a$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $ed173a2bc5e60c5a$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $ed173a2bc5e60c5a$var$reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = $ed173a2bc5e60c5a$var$trimmedEndIndex;

});





parcelRegister("amfpH", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $e768825b373a6c77$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $e768825b373a6c77$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    timeout: {
        id: 'siteActivation.nameSite.error.timeout',
        defaultMessage: 'Something went wrong on our end. Please try again. If this keeps happening, <href-support>contact support</href-support>. (Issue ID for Atlassian use: {error_id})'
    },
    invalidName: {
        id: 'siteActivation.nameSite.error.invalidName',
        defaultMessage: 'Your site name must be at least 3 characters long. Use only lowercase letters and numbers.'
    },
    maxLength: {
        id: 'siteActivation.nameSite.error.maxLength',
        defaultMessage: "That's a bit too long \u2014 try something 50 characters or less."
    },
    unavailable: {
        id: 'siteActivation.nameSite.error.unavailable',
        defaultMessage: 'This site is already taken.'
    },
    networkError: {
        id: 'siteActivation.nameSite.error.networkError',
        defaultMessage: 'Something went wrong. Please try again later.'
    }
});

});


parcelRegister("jgBbG", function(module, exports) {
$parcel$export(module.exports, "ExistingUser", function () { return $94f60ca190cbbbec$export$706672462bf25099; });

var $7VQPk = parcelRequire("7VQPk");

var $95d7u = parcelRequire("95d7u");
const $94f60ca190cbbbec$export$706672462bf25099 = (props)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $95d7u.Content), {
        ...props
    });

});
parcelRegister("95d7u", function(module, exports) {
$parcel$export(module.exports, "Content", function () { return $636317ea5e3d75f8$export$7c6e2c02157bb7d2; });
/* content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $lX14w = parcelRequire("lX14w");

var $2WL8B = parcelRequire("2WL8B");

var $ff4S3 = parcelRequire("ff4S3");

var $eWKFr = parcelRequire("eWKFr");

var $33py5 = parcelRequire("33py5");

var $aw05g = parcelRequire("aw05g");

var $aMZEL = parcelRequire("aMZEL");

var $k3fT0 = parcelRequire("k3fT0");
const $636317ea5e3d75f8$export$7c6e2c02157bb7d2 = ({ SitePicker: SitePicker = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $33py5.SitePicker), {}), SiteNameInput: SiteNameInput = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eWKFr.SiteNameInput), {}), SiteToggleButton: SiteToggleButton = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aw05g.SiteToggleButton), {}), SubmitButton: SubmitButton, PrivacyPolicy: PrivacyPolicy })=>{
    const { showSitePicker: showSitePicker, setShowSitePicker: setShowSitePicker, activateSite: activateSite, sites: sites } = (0, $ff4S3.useSiteActivationContext)();
    const transactionSelectorEligible = (0, $2WL8B.useSignupTransactionSelectorCohort)();
    const sitePickerEnabled = sites.length > 0 && SitePicker && SiteToggleButton;
    // if the site picker is not enabled, let context know it is not showing
    (0, $1oC0p.useEffect)(()=>{
        if (!sitePickerEnabled && showSitePicker) setShowSitePicker(false);
    }, [
        sitePickerEnabled
    ]);
    const activateSiteWithPrivacyPolicy = ()=>{
        const privacyPolicy = document.getElementById('privacy-policy-text')?.innerHTML || '';
        activateSite({
            privacyPolicy: privacyPolicy
        });
    };
    if (SubmitButton === undefined) SubmitButton = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k3fT0.ExistingSitesSubmitButton), {
        hasPrivacyPolicy: !!PrivacyPolicy
    });
    // Only show if user is in signup transaction selector cohort and creating a new site
    const showTxaSelector = !showSitePicker && transactionSelectorEligible;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lX14w.default), {
        onSubmit: activateSiteWithPrivacyPolicy,
        isDisabled: false,
        children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("form", {
                ...formProps,
                autoComplete: "off",
                "data-testid": "existing-sites-site-activation",
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _zulp1tcg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        children: [
                            showSitePicker && sitePickerEnabled ? SitePicker : SiteNameInput,
                            sitePickerEnabled && SiteToggleButton
                        ]
                    }),
                    showTxaSelector && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aMZEL.TransactionAccountSelector), {}),
                    SubmitButton,
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        id: "privacy-policy-text",
                        children: PrivacyPolicy
                    })
                ]
            })
    });
};
const $636317ea5e3d75f8$var$containerCss = null;

});
parcelRegister("eWKFr", function(module, exports) {
$parcel$export(module.exports, "SiteNameInput", function () { return $69669b99c9d478dc$export$42a3d109cf521241; });
/* site-name-input.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $eY3N6 = parcelRequire("eY3N6");

var $igGC3 = parcelRequire("igGC3");

var $8KJ2x = parcelRequire("8KJ2x");

var $iSeHD = parcelRequire("iSeHD");

var $cURcB = parcelRequire("cURcB");

var $buVH1 = parcelRequire("buVH1");

var $kNE9Z = parcelRequire("kNE9Z");

var $iTHVN = parcelRequire("iTHVN");

var $7GVWk = parcelRequire("7GVWk");

var $kbpa7 = parcelRequire("kbpa7");

var $lbA31 = parcelRequire("lbA31");

var $ff4S3 = parcelRequire("ff4S3");

var $amfpH = parcelRequire("amfpH");

var $lJoGY = parcelRequire("lJoGY");

var $54KVk = parcelRequire("54KVk");
const $69669b99c9d478dc$export$42a3d109cf521241 = ({ inputLabel: inputLabel })=>{
    (0, $lbA31.useRecommendedSiteName)({
        onError: console.error
    }); // onError catches errors from endpoint
    const { siteName: siteName, setSiteNameValue: setSiteNameValue, isSubmitting: isSubmitting, validationMessageState: [validationMessage, setValidationMessage], isValid: isValid, isValidating: isValidating, error: error, isWorkspaceProduct: isWorkspaceProduct, autoActivationFailed: autoActivationFailed } = (0, $ff4S3.useSiteActivationContext)();
    const { product: product } = (0, $7GVWk.useUserContext)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const siteNameAddressSuffix = (0, $kNE9Z.isProduction)() ? '.atlassian.net' : '.jira-dev.com';
    (0, $1oC0p.useEffect)(()=>{
        // Only for the spark-defer-site-name-v2 variant (TWCG-2407): when
        // auto-activation fails, the variant falls back to this form with the
        // activation error already set. The recommended name still validates as
        // NO_ERROR, so without this guard the switch below would immediately clear
        // that error. autoActivationFailed is always false for control and every
        // other cohort, so their behaviour is unchanged.
        if (autoActivationFailed) return;
        switch(error){
            case (0, $cURcB.ErrorType).NO_ERROR:
                setValidationMessage(undefined);
                break;
            case (0, $cURcB.ErrorType).INVALID_NAME:
                setValidationMessage((0, $amfpH.messages).invalidName);
                break;
            case (0, $cURcB.ErrorType).MAXIMUM_LENGTH:
                setValidationMessage((0, $amfpH.messages).maxLength);
                break;
            case (0, $cURcB.ErrorType).UNAVAILABLE:
                setValidationMessage((0, $amfpH.messages).unavailable);
                break;
            case (0, $cURcB.ErrorType).NETWORK_ERROR:
                setValidationMessage((0, $amfpH.messages).networkError);
                break;
        }
        // spark-defer-site-name-v2 (TWCG-2407): the variant records the same
        // failures as autoActivationFailed and returns above.
        if (error !== (0, $cURcB.ErrorType).NO_ERROR && analyticsClient) (0, $buVH1.trackDeferSiteNameErrorScreen)(createAnalyticsEvent, {
            cohort: 'control',
            reason: error,
            productKey: product?.key
        });
    }, [
        analyticsClient,
        autoActivationFailed,
        createAnalyticsEvent,
        error,
        product?.key,
        setValidationMessage
    ]);
    const label = inputLabel ?? isWorkspaceProduct ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "siteActivation.yourWorkspace",
        defaultMessage: "Your workspace"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "accountActivation.nameSite.inputSiteNameLabel",
        defaultMessage: "Your site"
    });
    const ariaSuffixId = 'site-name-suffix';
    const ariaHelperId = 'site-name-helper';
    const ariaErrorId = 'site-name-error';
    const [helperPresent, setHelperPresent] = (0, $1oC0p.useState)(false);
    (0, $1oC0p.useEffect)(()=>{
        // Detect if helper text is rendered on the page to avoid invalid aria-describedby refs
        if (typeof document !== 'undefined') setHelperPresent(!!document.getElementById(ariaHelperId));
    }, []);
    const textFieldAriaDescribedBy = [
        ariaSuffixId,
        helperPresent ? ariaHelperId : undefined,
        validationMessage ? ariaErrorId : undefined
    ].filter(Boolean).join(' ') || undefined;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "data-testid": "adg4-site-name-input",
        className: (0, $2jatx.default)([
            "_17rn1kw7"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_11zt3784 _7hwbi2wt _1rwq3784 _r64ckb7n _1ljbkb7n _17eaf1ug _1heu1kw7 _125x1j6v _aljm1ch8 _5hv91osq _1mmsglyw"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                "aria-required": true,
                isDisabled: isSubmitting,
                name: "site-name",
                label: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $54KVk.Label), {
                    children: label
                }),
                children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            isValid && "_olzhaf4m",
                            validationMessage !== undefined && "_olzh1wfy"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                                type: "text",
                                autoComplete: "on",
                                testId: "site-name-input",
                                ...fieldProps,
                                value: siteName,
                                onChange: (e)=>{
                                    setSiteNameValue(e.currentTarget.value);
                                    fieldProps.onChange(e);
                                },
                                "aria-describedby": textFieldAriaDescribedBy,
                                elemAfterInput: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_4cvr1h6o _1e0c1txw _y4ti19bv _w8l5gktf _1752gktf"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                            id: ariaSuffixId,
                                            className: (0, $2jatx.default)([
                                                "_syaz1rpy _1wyb8oy7 _y4tiu2gc _o5721q9c"
                                            ]),
                                            style: {
                                                "--_djwknj": (0, $6ZVlx.default)((0, $iTHVN.fontSize).sm)
                                            },
                                            children: siteNameAddressSuffix
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lJoGY.IsValidOrLoading), {
                                            isValidating: isValidating,
                                            siteNameValue: siteName,
                                            validationMessage: validationMessage
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                id: ariaErrorId,
                                role: "alert",
                                className: (0, $2jatx.default)([
                                    "_syaz1tmw _1wyboqnp _43ds5hrz _59381r31 _yha28stv _1nmznqa1",
                                    validationMessage && "_1pfhi2wt"
                                ]),
                                style: {
                                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                },
                                children: validationMessage && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    ...validationMessage
                                })
                            })
                        ]
                    })
            })
        })
    });
};
const $69669b99c9d478dc$var$inputInvalidCss = null;
const $69669b99c9d478dc$var$inputValidCss = null;
const $69669b99c9d478dc$var$fieldWrapperCss = null;
const $69669b99c9d478dc$var$labelCss = null;
const $69669b99c9d478dc$var$siteNameAfterCss = null;
const $69669b99c9d478dc$var$siteNameAfterLabelV2Css = null;
const $69669b99c9d478dc$var$siteNameErrorCss = null;
const $69669b99c9d478dc$var$siteNameErrorVisibleCss = null;

});
parcelRegister("lbA31", function(module, exports) {
$parcel$export(module.exports, "useRecommendedSiteName", function () { return $8bbeebdbf54863c8$export$c2aa7c9492b42e56; });

var $1oC0p = parcelRequire("1oC0p");

var $5Ntyw = parcelRequire("5Ntyw");

var $3riD8 = parcelRequire("3riD8");

var $ff4S3 = parcelRequire("ff4S3");
function $8bbeebdbf54863c8$export$c2aa7c9492b42e56(props = {}) {
    const { siteName: siteName, setSiteNameValue: setSiteNameValue, recommendedSiteName: recommendedSiteName } = (0, $ff4S3.useSiteActivationContext)();
    const [siteNamePopulated, setSiteNamePopulated] = (0, $1oC0p.useState)();
    const client = (0, $5Ntyw.useBxpWebStargateClient)();
    const user = (0, $3riD8.useLoggedInUser)();
    const email = user?.email;
    (0, $1oC0p.useEffect)(()=>{
        if (email) client.getRecommendedSiteName({
            email: email
        }).then((result)=>setSiteNameValue(result.recommendedName)).catch(props.onError);
    }, [
        client,
        email,
        props.onError,
        setSiteNameValue
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (siteNamePopulated) // take no action because site name was already changed via either user interaction or site-name recommendation
        return;
        if (siteName) // user has already started typing, let's not overwrite their input with a recommended site name
        setSiteNamePopulated(true);
        else if (recommendedSiteName) {
            setSiteNameValue(recommendedSiteName);
            setSiteNamePopulated(true);
        }
    }, [
        siteNamePopulated,
        recommendedSiteName,
        siteName,
        setSiteNameValue
    ]);
}

});

parcelRegister("lJoGY", function(module, exports) {
$parcel$export(module.exports, "IsValidOrLoading", function () { return $b4fede7ff554c6cb$export$71ec10810b978f7e; });

var $7VQPk = parcelRequire("7VQPk");

var $hrBjL = parcelRequire("hrBjL");

var $cKTdj = parcelRequire("cKTdj");

var $7qFQI = parcelRequire("7qFQI");

var $lP7A9 = parcelRequire("lP7A9");
const $b4fede7ff554c6cb$export$71ec10810b978f7e = ({ isValidating: isValidating, siteNameValue: siteNameValue, validationMessage: validationMessage })=>{
    if (siteNameValue === '') return null;
    if (isValidating) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7qFQI.default), {
        size: "small",
        testId: "spinner"
    });
    if (validationMessage) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cKTdj))), {
        label: "warning",
        color: (0, $lP7A9.default)('color.icon.danger')
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hrBjL))), {
        label: "success",
        color: (0, $lP7A9.default)('color.icon.accent.lime')
    });
};

});

parcelRegister("54KVk", function(module, exports) {
$parcel$export(module.exports, "Label", function () { return $08e560f13c474cc2$export$b04be29aa201d4f5; });
/* label.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $08e560f13c474cc2$var$labelCss = null;
const $08e560f13c474cc2$export$b04be29aa201d4f5 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            "_1wybdlk8 _k48p4jg8 _vwz4gktf"
        ]),
        children: children
    });
};

});


parcelRegister("33py5", function(module, exports) {
$parcel$export(module.exports, "SitePicker", function () { return $b5507a35ec5b9046$export$7793ee10ee71ac54; });
/* site-picker.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $igGC3 = parcelRequire("igGC3");

var $8KJ2x = parcelRequire("8KJ2x");

var $kbpa7 = parcelRequire("kbpa7");

var $ff4S3 = parcelRequire("ff4S3");

var $fMbfG = parcelRequire("fMbfG");

var $54KVk = parcelRequire("54KVk");
const $b5507a35ec5b9046$export$7793ee10ee71ac54 = ()=>{
    const { sites: sites, isWorkspaceProduct: isWorkspaceProduct } = (0, $ff4S3.useSiteActivationContext)();
    const label = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $54KVk.Label), {
        children: isWorkspaceProduct ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "siteActivation.yourWorkspace",
            defaultMessage: "Your workspace"
        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "siteActivation.siteNameSitePickerLabel",
            defaultMessage: "Your site"
        })
    });
    if (sites.length === 1) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1mmsglyw _11uri2wt _1rysg7ng _a5o8s3kk _1tgt1kw7 _1cgv7vkz _1b7z1nn1 _jxt41kw7 _1f3hi2wt _nrq3ftgi _1npwi2wt _aszr7vkz"
        ]),
        style: {
            "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100')),
            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
            "aria-required": true,
            isRequired: true,
            isDisabled: true,
            name: "site-picker-field",
            id: "site-picker-field",
            testId: "site-picker-field",
            label: label,
            defaultValue: sites[0]?.url.replace('https://', ''),
            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                    ...fieldProps
                })
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fMbfG.Dropdown), {
        sites: sites
    });
};
const $b5507a35ec5b9046$var$inputCss = null;

});
parcelRegister("fMbfG", function(module, exports) {
$parcel$export(module.exports, "Dropdown", function () { return $c66d8b790d64bccd$export$931cbfb6bfb85fc; });
/* dropdown.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $igGC3 = parcelRequire("igGC3");

var $lAVaU = parcelRequire("lAVaU");

var $iTHVN = parcelRequire("iTHVN");

var $ff4S3 = parcelRequire("ff4S3");
const $c66d8b790d64bccd$export$931cbfb6bfb85fc = ({ sites: sites })=>{
    const { sitePickerValue: sitePickerValue, setSitePickerValue: setSitePickerValue, isSubmitting: isSubmitting, isRequestInProgress: isRequestInProgress, isWorkspaceProduct: isWorkspaceProduct } = (0, $ff4S3.useSiteActivationContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "data-testid": "adg4-site-picker",
        className: (0, $2jatx.default)([
            "_125x1syg _62vcmccc _17rn1kw7 _1mmsglyw _pqyqi2wt _84yzi2wt _tnizyh40 _101oyh40 _9fwgmccc _1700grf3 _156ugrf3 _16z5grf3 _iazigrf3 _1ybr1crf _uy3o19bv"
        ]),
        style: {
            "--_1jvo4a6": (0, $6ZVlx.default)((0, $iTHVN.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
            "aria-required": true,
            isRequired: true,
            defaultValue: sites[0],
            isDisabled: isSubmitting,
            id: "site-picker-field",
            name: "site-picker-field",
            testId: "site-picker-field",
            label: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_1wybdlk8 _k48p4jg8 _vwz4gktf"
                ]),
                children: isWorkspaceProduct ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "siteActivation.yourWorkspace",
                    defaultMessage: "Your workspace"
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "WacSignupForm.siteNameN2ELabel",
                    defaultMessage: "Your site"
                })
            }),
            children: ({ fieldProps: { id: id, ...rest } })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $lAVaU.default), {
                    ...rest,
                    inputId: id,
                    options: sites,
                    getOptionLabel: (option)=>option.url.replace('https://', ''),
                    getOptionValue: (option)=>option.cloudId,
                    value: sitePickerValue,
                    onChange: (newValue)=>setSitePickerValue(newValue ?? sites[0]),
                    isLoading: isRequestInProgress,
                    isSearchable: false,
                    styles: {
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        menu: (base)=>({
                                ...base,
                                fontSize: (0, $iTHVN.fontSize).md
                            }),
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        container: (base)=>({
                                ...base,
                                fontFamily: 'inherit'
                            }),
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        valueContainer: (base)=>({
                                ...base,
                                fontSize: (0, $iTHVN.fontSize).md,
                                minHeight: '40px',
                                paddingTop: '8px',
                                paddingRight: '6px',
                                paddingBottom: '8px',
                                paddingLeft: '6px'
                            }),
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        singleValue: (base)=>({
                                ...base,
                                margin: 0
                            })
                    }
                })
        })
    });
};
const $c66d8b790d64bccd$var$labelCss = null;
const $c66d8b790d64bccd$var$inputAndLabelStyles = null;

});


parcelRegister("aw05g", function(module, exports) {
$parcel$export(module.exports, "SiteToggleButton", function () { return $b5b9071c4b1e6573$export$3bfd0ee4a8c5295a; });
/* site-toggle-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $3RaC6 = parcelRequire("3RaC6");

var $iTHVN = parcelRequire("iTHVN");

var $ff4S3 = parcelRequire("ff4S3");
const $b5b9071c4b1e6573$export$3bfd0ee4a8c5295a = ()=>{
    const intl = (0, $8e22h.default)();
    const { isWorkspaceProduct: isWorkspaceProduct, showSitePicker: showSitePicker, setShowSitePicker: setShowSitePicker } = (0, $ff4S3.useSiteActivationContext)();
    const toggleYourSiteButtonText = showSitePicker ? isWorkspaceProduct ? intl.formatMessage({
        id: 'siteActivation.nameSite.startNewWorkspaceButton',
        defaultMessage: 'Start a new workspace'
    }) : intl.formatMessage({
        id: 'siteActivation.nameSite.startNewSiteButton',
        defaultMessage: 'Start a new site'
    }) : isWorkspaceProduct ? intl.formatMessage({
        id: 'siteActivation.nameSite.useExistingWorkspaceButton',
        defaultMessage: 'Use an existing workspace'
    }) : intl.formatMessage({
        id: 'siteActivation.nameSite.useExistingSiteButton',
        defaultMessage: 'Use an existing site'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3RaC6.default), {
        appearance: "link",
        onClick: ()=>setShowSitePicker(!showSitePicker),
        className: (0, $2jatx.default)([
            "_18zrgrf3"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
            className: (0, $2jatx.default)([
                "_4cvr1h6o _1e0c1txw _1wyb8oy7 _zulp1y44 _syazrbzz"
            ]),
            style: {
                "--_djwknj": (0, $6ZVlx.default)((0, $iTHVN.fontSize).sm)
            },
            children: [
                toggleYourSiteButtonText,
                /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                    "aria-hidden": true,
                    fill: "currentColor",
                    height: "8",
                    width: "12",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "m7.908 0-1.08 1.202 1.75 1.948H1.264C.842 3.15.5 3.53.5 4c0 .469.342.85.763.85H8.58l-1.75 1.948L7.907 8 11.5 4 7.908 0Z"
                    })
                })
            ]
        })
    });
};
const $b5b9071c4b1e6573$var$buttonCss = null;
const $b5b9071c4b1e6573$var$buttonInnerCss = null;

});

parcelRegister("aMZEL", function(module, exports) {
$parcel$export(module.exports, "TransactionAccountSelector", function () { return $cf45f2a2372e480a$export$24b383d12e62d81f; });
/* transaction-account-selector.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $aTd7T = parcelRequire("aTd7T");

var $lAVaU = parcelRequire("lAVaU");

var $7GVWk = parcelRequire("7GVWk");

var $kbpa7 = parcelRequire("kbpa7");

var $ff4S3 = parcelRequire("ff4S3");

var $54KVk = parcelRequire("54KVk");
const $cf45f2a2372e480a$var$container = null;
const $cf45f2a2372e480a$export$24b383d12e62d81f = ()=>{
    const { transactionAccounts: transactionAccounts } = (0, $7GVWk.useUserContext)();
    const { isSubmitting: isSubmitting, selectedTransactionAccountId: selectedTransactionAccountId, setSelectedTransactionAccountId: setSelectedTransactionAccountId } = (0, $ff4S3.useSiteActivationContext)();
    const handleSelectionChange = (value)=>{
        if (value) setSelectedTransactionAccountId(value.value);
    };
    const selectedValue = transactionAccounts.find((account)=>account.id === selectedTransactionAccountId);
    const transactionAccountLabel = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "siteActivation.transactionAccountSelectorLabel",
        defaultMessage: "Billing Account"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "transaction-account-select-container",
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulpyh40"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aTd7T.Label), {
                htmlFor: "transaction-account-select",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $54KVk.Label), {
                    children: transactionAccountLabel
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lAVaU.default), {
                inputId: "transaction-account-select",
                options: transactionAccounts.map((transactionAccount)=>({
                        label: transactionAccount.number,
                        value: transactionAccount.id
                    })),
                value: selectedValue ? {
                    label: selectedValue.number,
                    value: selectedValue.id
                } : null,
                onChange: handleSelectionChange,
                isDisabled: isSubmitting,
                isRequired: true,
                styles: {
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    control: (rest)=>({
                            ...rest,
                            borderRadius: '21px',
                            fontFamily: (0, $kbpa7.wacToken)('font.charlie.text'),
                            fontSize: '1rem',
                            padding: '0px 6px'
                        })
                }
            })
        ]
    });
};

});

parcelRegister("k3fT0", function(module, exports) {
$parcel$export(module.exports, "ExistingSitesSubmitButton", function () { return $01476f5b75cbd817$export$795867072991ebfa; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $8Mruz = parcelRequire("8Mruz");
const $01476f5b75cbd817$export$795867072991ebfa = ({ hasPrivacyPolicy: hasPrivacyPolicy = false })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const submitMessage = hasPrivacyPolicy ? formatMessage({
        id: 'siteActivation.nameSite.agreeButton',
        defaultMessage: 'Agree and start now'
    }) : formatMessage({
        id: 'siteActivation.nameSiteNewUser.continueButton',
        defaultMessage: 'Continue'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8Mruz.SubmitButton), {
        submitMessage: submitMessage
    });
};

});
parcelRegister("8Mruz", function(module, exports) {
$parcel$export(module.exports, "SubmitButton", function () { return $b3ffdc0cbf384296$export$8b7b7cdfb85d78c5; });
/* submit-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $lqyi6 = parcelRequire("lqyi6");

var $ff4S3 = parcelRequire("ff4S3");
const $b3ffdc0cbf384296$export$8b7b7cdfb85d78c5 = ({ submitMessage: submitMessage })=>{
    const { isSubmitting: isSubmitting, hasSubmitted: hasSubmitted } = (0, $ff4S3.useSiteActivationContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
        type: "submit",
        isDisabled: isSubmitting || hasSubmitted,
        isLoading: isSubmitting || hasSubmitted,
        className: (0, $2jatx.default)([
            "_2rkoi2wt _ect41kw7 _1wybdlk8 _p12f1wug _1rjcftgi _1bsb1osq"
        ]),
        children: submitMessage
    });
};
const $b3ffdc0cbf384296$var$buttonCss = null;

});





parcelRegister("bs458", function(module, exports) {
$parcel$export(module.exports, "ReturnToProduct", function () { return $7a9446a5ace995a8$export$1cac7f8e3baae627; });
/* return-to-product.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $fcO7r = parcelRequire("fcO7r");

var $gZgIU = parcelRequire("gZgIU");

var $2WL8B = parcelRequire("2WL8B");

var $7GVWk = parcelRequire("7GVWk");

var $lqyi6 = parcelRequire("lqyi6");

var $kbpa7 = parcelRequire("kbpa7");

var $1ka2O = parcelRequire("1ka2O");

var $ff4S3 = parcelRequire("ff4S3");

var $jgBbG = parcelRequire("jgBbG");
const $7a9446a5ace995a8$export$1cac7f8e3baae627 = ({ ExistingUser: ExistingUser = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgBbG.ExistingUser), {}), sites: sites })=>{
    const location = (0, $1ka2O.useLocation)();
    const createNewWorkspace = (0, $1oC0p.useMemo)(()=>{
        const queryParams = new URLSearchParams(location.search);
        return queryParams.get('createNew') === 'true';
    }, [
        location.search
    ]);
    const [showSiteNaming, setShowSiteNaming] = (0, $1oC0p.useState)(createNewWorkspace);
    const { product: product } = (0, $7GVWk.useUserContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const sitesWithCurrentProduct = (0, $2WL8B.useSitesWithCurrentProduct)();
    const { isWorkspaceProduct: isWorkspaceProduct } = (0, $ff4S3.useSiteActivationContext)();
    const { user: { email: email } } = (0, $7GVWk.useUserContext)();
    const { productName: productName } = (0, $fcO7r.getProductData)(product?.key);
    if (sites === undefined) sites = sitesWithCurrentProduct;
    const goToProductButtonText = isWorkspaceProduct ? intl.formatMessage({
        id: 'bxpSignup.siteExpansion.goToWorkspace',
        defaultMessage: 'Go to workspace'
    }) : intl.formatMessage({
        id: 'bxpSignup.siteExpansion.goToProduct',
        defaultMessage: 'Go to {productName}'
    }, {
        productName: productName
    });
    const createNewWorkspaceMessageValues = {
        link: (str)=>$7a9446a5ace995a8$var$createNewWorkspaceMessageLink(str, ()=>{
                setShowSiteNaming(true);
                createAnalyticsEvent({
                    eventType: 'ui',
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'contactExpandGoToSiteNamingScreen',
                    attributes: {
                        productName: product?.name
                    }
                }).fire();
            })
    };
    const createNewWorkspaceMessage = isWorkspaceProduct ? intl.formatMessage({
        id: 'BxpSignup.SiteExpansionForm.cobrandedConfluenceCreateNewWorkspaceLink',
        defaultMessage: 'or <link>create a new workspace</link>'
    }, createNewWorkspaceMessageValues) : intl.formatMessage({
        id: 'BxpSignup.SiteExpansionForm.cobrandedJiraCreateNewWorkspaceLink',
        defaultMessage: 'or <link>start a new site</link>'
    }, createNewWorkspaceMessageValues);
    const clickReturnToExistingWorkspace = ()=>{
        setShowSiteNaming(false);
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'contactExpandGoToReturnToProductScreen',
            attributes: {
                productName: product?.name
            }
        }).fire();
    };
    const goToExistingWorkspaceMessageValues = {
        link: (str)=>$7a9446a5ace995a8$var$link(str, clickReturnToExistingWorkspace)
    };
    const goToExistingWorkspaceMessage = isWorkspaceProduct ? intl.formatMessage({
        id: 'BxpSignup.SiteExpansionForm.cobrandedGoToExistingWorkspace',
        defaultMessage: 'or <link>visit an existing workspace</link>'
    }, goToExistingWorkspaceMessageValues) : intl.formatMessage({
        id: 'bxpSignup.companyExpand.cobrandedReturnToJoinSites',
        defaultMessage: 'or <link>join an existing site</link>'
    }, goToExistingWorkspaceMessageValues);
    return showSiteNaming ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ae4v1yb4 _1e0c11p5 _16jlkb7n _zulpzwfg"
        ]),
        children: [
            ExistingUser,
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1wybdlk8 _k48pbfng _y3gn1h6o"
                ]),
                children: goToExistingWorkspaceMessage
            })
        ]
    }) : /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ae4v1yb4 _1e0c11p5 _16jlkb7n _zulpzwfg"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _zulpzwfg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_1wybdlk8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "BxpSignup.SiteExpansionForm.cobrandedSubheader.2",
                            defaultMessage: "You\u2019re logged in as {email}. <switchAccountLink>Switch account</switchAccountLink>",
                            values: {
                                email: /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                                    className: (0, $2jatx.default)([
                                        "_k48pni7l _ct361wug _1i4q1hna _1nmz1hna _slp31hna"
                                    ]),
                                    children: email
                                }),
                                switchAccountLink: $7a9446a5ace995a8$var$switchAccountLink
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "data-testid": "return-to-product",
                        className: (0, $2jatx.default)([
                            "_1e0c11p5 _zulp7vkz _1jop70sv _1bv01wug"
                        ]),
                        children: sites?.map((site, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                                href: $7a9446a5ace995a8$var$getProductUrl({
                                    url: site.url,
                                    productKey: product?.key ?? '',
                                    cloudId: site.cloudId
                                }),
                                onClick: (e)=>{
                                    e.preventDefault(); // wait for event to fire
                                    createAnalyticsEvent({
                                        eventType: 'ui',
                                        action: 'clicked',
                                        actionSubject: 'button',
                                        actionSubjectId: 'contactExpandClickReturnToProductButton',
                                        attributes: {
                                            productName: productName
                                        }
                                    }).fire();
                                    window.location.assign($7a9446a5ace995a8$var$getProductUrl({
                                        url: site.url,
                                        productKey: product?.key ?? '',
                                        cloudId: site.cloudId
                                    }));
                                },
                                className: (0, $2jatx.default)([
                                    "_4cvr1h6o _19itkze7 _2rkoftgi _1e0c11p5 _zulp19bv _yv0e1ghl _1bah1yb4 _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1bsb1osq _9oik1snc _1bnxagmp _jf4cvv82"
                                ]),
                                style: {
                                    "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1wyb7vkz _1reo15vq _18m915vq"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                className: (0, $2jatx.default)([
                                                    "_k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                                ]),
                                                children: productName
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_syazk0sw _1wybdlk8 _1reo15vq _18m915vq _1bto1l2s _o5721q9c"
                                                ]),
                                                style: {
                                                    "--_1e97w25": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light700'))
                                                },
                                                children: site.displayName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_p12fmgvx _2rkoi2wt _ect41kw7 _1wybdlk8"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                            variant: "primary",
                                            size: "small",
                                            color: "blue",
                                            className: (0, $2jatx.default)([
                                                "_p12fmgvx _2rkoi2wt _ect41kw7 _1wybdlk8"
                                            ]),
                                            children: goToProductButtonText
                                        })
                                    })
                                ]
                            }, index))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1wybdlk8 _k48pbfng _y3gn1h6o"
                ]),
                children: createNewWorkspaceMessage
            })
        ]
    });
};
const $7a9446a5ace995a8$var$link = (str, clickReturnToExistingWorkspace)=>/*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        onClick: clickReturnToExistingWorkspace,
        className: (0, $2jatx.default)([
            "_bfhkmzrp _19itidpf _2rkoidpf _syaz5hrz _80omtlke _1wybjdj5 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l31fez"
        ]),
        style: {
            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
            "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800'))
        },
        children: str
    });
const $7a9446a5ace995a8$var$createNewWorkspaceMessageLink = (str, exitView)=>/*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        onClick: exitView,
        className: (0, $2jatx.default)([
            "_bfhkmzrp _19itidpf _2rkoidpf _syaz5hrz _80omtlke _ect41kw7 _1wybjdj5 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l3ftjs"
        ]),
        style: {
            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
            "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800'))
        },
        children: str
    });
const $7a9446a5ace995a8$var$switchAccountLink = (children)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        href: (0, $gZgIU.getSwitchAccountUrl)(),
        className: (0, $2jatx.default)([
            "_syaz5hrz _4bfu1r31 _1hms8stv _ajmmnqa1 _o5721q9c _30l3ftjs"
        ]),
        style: {
            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
            "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800'))
        },
        children: children
    });
const $7a9446a5ace995a8$var$getProductUrl = ({ url: url, productKey: productKey, cloudId: cloudId })=>{
    switch(productKey){
        case (0, $fcO7r.ProductKey).JIRA_SOFTWARE:
            return `${url}/jira`;
        case (0, $fcO7r.ProductKey).CONFLUENCE:
            return `${url}/wiki`;
        case (0, $fcO7r.ProductKey).LOOM:
            return (0, $gZgIU.getLoomSsoUrl)(cloudId);
        default:
            return url;
    }
};
const $7a9446a5ace995a8$var$containerCss = null;
const $7a9446a5ace995a8$var$goToExistingWorkspaceLinkCss = null;
const $7a9446a5ace995a8$var$goToExistingWorkspaceMessageCss = null;
const $7a9446a5ace995a8$var$switchAccountSubheader = null;
const $7a9446a5ace995a8$var$contentCss = null;
const $7a9446a5ace995a8$var$createNewWorkspaceMessageCss = null;
const $7a9446a5ace995a8$var$createNewWorkspaceLinkCss = null;
const $7a9446a5ace995a8$var$boxContainerCss = null;
const $7a9446a5ace995a8$var$siteBoxCss = null;
const $7a9446a5ace995a8$var$goToProductButtonCss = null;
const $7a9446a5ace995a8$var$bold = null;
const $7a9446a5ace995a8$var$siteCss = null;
const $7a9446a5ace995a8$var$siteNameCss = null;
const $7a9446a5ace995a8$var$emailCss = null;
const $7a9446a5ace995a8$var$switchAccountLinkCss = null;

});

parcelRegister("ka4Xu", function(module, exports) {
$parcel$export(module.exports, "SiteActivation", function () { return $9dd5cc04ed0b1948$export$5f19f51fdf3d70; });
/* site-activation.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $2WL8B = parcelRequire("2WL8B");

var $ff4S3 = parcelRequire("ff4S3");

var $3fEYe = parcelRequire("3fEYe");
const $9dd5cc04ed0b1948$export$5f19f51fdf3d70 = (props)=>{
    const cohort = (0, $2WL8B.useCohort)(props.useContactExpandCohortLogic);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "data-testid": "site-activation",
        "data-cohort": cohort,
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff4S3.SiteActivationContextProvider), {
            existingSites: props.existingSites,
            useContactExpandCohortLogic: props.useContactExpandCohortLogic,
            autoActivateWithRecommendedName: props.autoActivateWithRecommendedName,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3fEYe.SiteActivationSwitcher), {
                ...props
            })
        })
    });
};
// fill the available space in the parent container
const $9dd5cc04ed0b1948$var$siteActivationCss = null;

});
parcelRegister("3fEYe", function(module, exports) {
$parcel$export(module.exports, "SiteActivationSwitcher", function () { return $aeae241f769fd6ee$export$336514a242c2c5c0; });

var $7VQPk = parcelRequire("7VQPk");

var $2WL8B = parcelRequire("2WL8B");

var $jgBbG = parcelRequire("jgBbG");

var $jGkoX = parcelRequire("jGkoX");

var $lBvZp = parcelRequire("lBvZp");

var $2HR6E = parcelRequire("2HR6E");

var $3ptXA = parcelRequire("3ptXA");
const $aeae241f769fd6ee$export$336514a242c2c5c0 = ({ ExistingUser: ExistingUser = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgBbG.ExistingUser), {}), ManagedUser: ManagedUser = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jGkoX.ManagedUser), {}), NewUser: NewUser = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lBvZp.NewUser), {}), WeekOneUser: WeekOneUser = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3ptXA.WeekOneUser), {}), UpgradeEligibleUser: UpgradeEligibleUser = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2HR6E.UpgradeEligibleUser), {}), CurrentProductJoinableUser: CurrentProductJoinableUser, CurrentProductUser: CurrentProductUser, UpliftEligibleUser: UpliftEligibleUser, CrossflowEligibleUser: CrossflowEligibleUser, useContactExpandCohortLogic: useContactExpandCohortLogic })=>{
    const cohort = (0, $2WL8B.useCohort)(useContactExpandCohortLogic);
    if (cohort === (0, $2WL8B.COHORTS).MANAGED_USER && ManagedUser) return ManagedUser;
    if (cohort === (0, $2WL8B.COHORTS).WEEK_ONE_USER && WeekOneUser) return WeekOneUser;
    if (cohort === (0, $2WL8B.COHORTS).CURRENT_PRODUCT_JOINABLE_USER && CurrentProductJoinableUser) return CurrentProductJoinableUser;
    if (cohort === (0, $2WL8B.COHORTS).CURRENT_PRODUCT_USER && CurrentProductUser) return CurrentProductUser;
    if (cohort === (0, $2WL8B.COHORTS).NEW_USER && NewUser) return NewUser;
    if (cohort === (0, $2WL8B.COHORTS).UPGRADE_ELIGIBLE_USER && UpgradeEligibleUser) return UpgradeEligibleUser;
    if (cohort === (0, $2WL8B.COHORTS).UPLIFT_ELIGIBLE_USER && UpliftEligibleUser) return UpliftEligibleUser;
    if (cohort === (0, $2WL8B.COHORTS).CROSSFLOW_ELIGIBLE_USER && CrossflowEligibleUser) return CrossflowEligibleUser;
    return ExistingUser;
};

});
parcelRegister("jGkoX", function(module, exports) {
$parcel$export(module.exports, "ManagedUser", function () { return $0ef791acb9b8931b$export$fcb76302df2c072d; });
/* managed-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $2WL8B = parcelRequire("2WL8B");

var $7GVWk = parcelRequire("7GVWk");

var $lqyi6 = parcelRequire("lqyi6");

var $kbpa7 = parcelRequire("kbpa7");

var $izdHQ = parcelRequire("izdHQ");

var $jgBbG = parcelRequire("jgBbG");

var $3D1CY = parcelRequire("3D1CY");
const $0ef791acb9b8931b$export$fcb76302df2c072d = ()=>{
    const [showSiteNaming, setShowSiteNaming] = (0, $1oC0p.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const sites = (0, $2WL8B.useManagingOrgUserSites)();
    const { profile: profile, product: product } = (0, $7GVWk.useUserContext)();
    const orgId = profile?.attributes?.managingOrg?.orgId;
    const clickGoToExistingWorkspace = ()=>{
        setShowSiteNaming(false);
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'guardGoToReturnToProductScreen',
            attributes: {
                orgId: orgId,
                productName: product?.name
            }
        }).fire();
    };
    const goToExistingWorkspaceMessageValues = {
        link: (str)=>$0ef791acb9b8931b$var$goToExistingWorkspace(str, clickGoToExistingWorkspace)
    };
    const goToExistingWorkspaceMessage = formatMessage({
        id: 'bxpSignup.companyExpand.cobrandedReturnToJoinSites',
        defaultMessage: 'or <link>join an existing site</link>'
    }, goToExistingWorkspaceMessageValues);
    const clickGoToSiteNamingScreen = ()=>{
        setShowSiteNaming(true);
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'guardGoToSiteNamingScreen',
            attributes: {
                orgId: orgId,
                productName: product?.name
            }
        }).fire();
    };
    const goToSiteNamingMessageValues = {
        link: (str)=>$0ef791acb9b8931b$var$goToSiteNaming(str, clickGoToSiteNamingScreen)
    };
    const goToSiteNamingMessage = formatMessage({
        id: 'BxpSignup.SiteExpansionForm.cobrandedJiraCreateNewWorkspaceLink',
        defaultMessage: 'or <link>start a new site</link>'
    }, goToSiteNamingMessageValues);
    return sites?.length ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
        experimentKey: "signup-guard-return-to-product",
        group: "treatment",
        metadata: {
            orgId: orgId
        },
        children: showSiteNaming ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_ae4v1yb4 _1e0c1txw _2lx21bp4 _16jlkb7n _zulp7vkz _1bah1yb4"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgBbG.ExistingUser), {}),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1wybdlk8 _k48pbfng _y3gn1h6o"
                    ]),
                    children: goToExistingWorkspaceMessage
                })
            ]
        }) : /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_ae4v1yb4 _1e0c1txw _2lx21bp4 _16jlkb7n _zulp7vkz _1bah1yb4"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3D1CY.SitesList), {
                    sites: sites
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1wybdlk8 _k48pbfng _y3gn1h6o"
                    ]),
                    children: goToSiteNamingMessage
                })
            ]
        })
    }) : null;
};
const $0ef791acb9b8931b$var$goToSiteNaming = (str, clickGoToSiteNamingScreen)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
        onClick: clickGoToSiteNamingScreen,
        className: (0, $2jatx.default)([
            "_bfhkmzrp _19itgrf3 _2rkogrf3 _syaz5hrz _ect41kw7 _1wyb1kw7 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l3ftjs"
        ]),
        style: {
            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
            "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800'))
        },
        children: str
    });
const $0ef791acb9b8931b$var$goToExistingWorkspace = (str, clickGoToExistingWorkspace)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
        onClick: clickGoToExistingWorkspace,
        className: (0, $2jatx.default)([
            "_bfhkmzrp _19itgrf3 _2rkogrf3 _syaz5hrz _ect41kw7 _1wyb1kw7 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l3ftjs"
        ]),
        style: {
            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
            "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800'))
        },
        children: str
    });
const $0ef791acb9b8931b$var$containerCss = null;
const $0ef791acb9b8931b$var$goToLinkCss = null;
const $0ef791acb9b8931b$var$goToMessageCss = null;

});
parcelRegister("3D1CY", function(module, exports) {
$parcel$export(module.exports, "SitesList", function () { return $fa618feefe0aa5d1$export$e2789664959efdd3; });
/* sites-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $eY3N6 = parcelRequire("eY3N6");

var $kNE9Z = parcelRequire("kNE9Z");

var $iTHVN = parcelRequire("iTHVN");

var $fcO7r = parcelRequire("fcO7r");

var $gZgIU = parcelRequire("gZgIU");

var $7GVWk = parcelRequire("7GVWk");

var $lqyi6 = parcelRequire("lqyi6");

var $kbpa7 = parcelRequire("kbpa7");
const $fa618feefe0aa5d1$export$e2789664959efdd3 = ({ sites: sites })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { profile: profile, product: product, user: { email: email } } = (0, $7GVWk.useUserContext)();
    const orgId = profile.attributes?.managingOrg?.orgId;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _zulp7vkz"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wybdlk8 _y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "BxpSignup.SiteExpansionForm.cobrandedSubheader.2",
                    defaultMessage: "You\u2019re logged in as {email}. <switchAccountLink>Switch account</switchAccountLink>",
                    values: {
                        email: /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                            className: (0, $2jatx.default)([
                                "_k48pni7l _ct361wug _1i4q1hna _1nmz1hna _slp31hna"
                            ]),
                            children: email
                        }),
                        switchAccountLink: $fa618feefe0aa5d1$var$switchAccountLink
                    }
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_4cvr1h6o _1e0c11p5 _1bsb1osq _1jc21k1x _1mbp1wug"
                ]),
                children: sites.map(({ displayName: displayName, url: url, cloudId: cloudId })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                        href: $fa618feefe0aa5d1$var$getIdentityUrl({
                            url: url,
                            productKey: product?.key,
                            cloudId: cloudId
                        }),
                        onClick: (e)=>{
                            e.preventDefault(); // wait for event to fire
                            createAnalyticsEvent({
                                eventType: 'ui',
                                action: 'clicked',
                                actionSubject: 'button',
                                actionSubjectId: 'guardClickReturnToProductButton',
                                attributes: {
                                    orgId: orgId,
                                    productName: product?.name
                                }
                            }).fire();
                            window.location.href = $fa618feefe0aa5d1$var$getIdentityUrl({
                                url: url,
                                productKey: product?.key,
                                cloudId: cloudId
                            });
                        },
                        className: (0, $2jatx.default)([
                            "_4cvr1h6o _179rj0fz _1e0c11p5 _zulp1y44 _yv0e9sye _1bah1yb4 _ca0q7vkz _u5f3ftgi _n3td7vkz _19bvftgi _1bsb1osq _9oik1snc _1bnxagmp _jf4cvv82 _8gg5glyw"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1wyb1syg"
                                ]),
                                style: {
                                    "--_1jvo4a6": (0, $6ZVlx.default)((0, $iTHVN.fontSize).md)
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                        className: (0, $2jatx.default)([
                                            "_k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                        ]),
                                        children: product?.name
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_syaz1rpy _1reo15vq _18m915vq _1bto1l2s _o5721q9c _1wybdlk8"
                                        ]),
                                        children: displayName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_p12f13i4 _1e0c1txw _1bahesu3"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                    variant: "secondary",
                                    size: "small",
                                    color: "black",
                                    className: (0, $2jatx.default)([
                                        "_ect41kw7 _1wybdlk8 _1rjcftgi"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "bxpSignup.siteExpansion.goToProduct",
                                        defaultMessage: "Go to {productName}",
                                        values: {
                                            productName: product?.description
                                        }
                                    })
                                })
                            })
                        ]
                    }, url))
            })
        ]
    });
};
const $fa618feefe0aa5d1$var$switchAccountLink = (children)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        href: (0, $gZgIU.getSwitchAccountUrl)(),
        className: (0, $2jatx.default)([
            "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz5hrz _o5721q9c _30l3ftjs"
        ]),
        style: {
            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
            "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800'))
        },
        children: children
    });
const $fa618feefe0aa5d1$var$getIdentityUrl = ({ url: url, productKey: productKey, cloudId: cloudId })=>{
    switch(productKey){
        case (0, $fcO7r.ProductKey).JIRA_SOFTWARE:
            return `${(0, $kNE9Z.getIdentityBaseUrl)()}/login?${new URLSearchParams({
                continue: `${url}/jira`,
                application: 'jira'
            })}`;
        case (0, $fcO7r.ProductKey).CONFLUENCE:
            return `${(0, $kNE9Z.getIdentityBaseUrl)()}/login?${new URLSearchParams({
                continue: `${url}/wiki`,
                application: 'confluence'
            })}`;
        case (0, $fcO7r.ProductKey).DEVAI:
            return `${(0, $kNE9Z.getIdentityBaseUrl)()}/login?${new URLSearchParams({
                continue: `${url}/rovodev`,
                application: 'devai'
            })}`;
        case (0, $fcO7r.ProductKey).LOOM:
            return (0, $gZgIU.getLoomSsoUrl)(cloudId);
        default:
            return url;
    }
};
const $fa618feefe0aa5d1$var$containerCss = null;
const $fa618feefe0aa5d1$var$switchAccountSubheader = null;
const $fa618feefe0aa5d1$var$sitesListCss = null;
const $fa618feefe0aa5d1$var$siteBoxCss = null;
const $fa618feefe0aa5d1$var$productNameCss = null;
const $fa618feefe0aa5d1$var$siteCss = null;
const $fa618feefe0aa5d1$var$siteNameCss = null;
const $fa618feefe0aa5d1$var$goToSiteButtonContainerCss = null;
const $fa618feefe0aa5d1$var$goToSiteButtonCss = null;
const $fa618feefe0aa5d1$var$emailCss = null;
const $fa618feefe0aa5d1$var$switchAccountLinkCss = null;

});


parcelRegister("lBvZp", function(module, exports) {
$parcel$export(module.exports, "NewUser", function () { return $642e4e985a9cdc5c$export$17cbb676e2e98676; });

var $7VQPk = parcelRequire("7VQPk");

var $3kezV = parcelRequire("3kezV");
const $642e4e985a9cdc5c$export$17cbb676e2e98676 = (props)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $3kezV.Content), {
        ...props
    });

});
parcelRegister("3kezV", function(module, exports) {
$parcel$export(module.exports, "Content", function () { return $3dbd49b2429de188$export$7c6e2c02157bb7d2; });
/* content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $lX14w = parcelRequire("lX14w");

var $ff4S3 = parcelRequire("ff4S3");

var $eWKFr = parcelRequire("eWKFr");

var $3naW4 = parcelRequire("3naW4");

var $8SDzo = parcelRequire("8SDzo");
const $3dbd49b2429de188$export$7c6e2c02157bb7d2 = ({ SiteNameInput: SiteNameInput = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eWKFr.SiteNameInput), {}), HelperText: HelperText = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3naW4.HelperText), {}), SubmitButton: SubmitButton, PrivacyPolicy: PrivacyPolicy = null })=>{
    const { activateSite: activateSite } = (0, $ff4S3.useSiteActivationContext)();
    const activateSiteWithPrivacyPolicy = ()=>{
        const privacyPolicy = document.getElementById('privacy-policy-text')?.innerHTML || '';
        activateSite({
            privacyPolicy: privacyPolicy
        });
    };
    if (SubmitButton === undefined) SubmitButton = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8SDzo.NewUserSubmitButton), {
        hasPrivacyPolicy: !!PrivacyPolicy
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lX14w.default), {
        onSubmit: activateSiteWithPrivacyPolicy,
        isDisabled: false,
        children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("form", {
                ...formProps,
                autoComplete: "off",
                "data-testid": "new-user-site-activation",
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _zulp1tcg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        children: [
                            SiteNameInput,
                            HelperText
                        ]
                    }),
                    SubmitButton,
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        id: "privacy-policy-text",
                        children: PrivacyPolicy
                    })
                ]
            })
    });
};
const $3dbd49b2429de188$var$containerCss = null;

});
parcelRegister("3naW4", function(module, exports) {
$parcel$export(module.exports, "HelperText", function () { return $b38a10467ddc3e98$export$7bc3de131d90901c; });
/* helper-text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $ff4S3 = parcelRequire("ff4S3");
const $b38a10467ddc3e98$export$7bc3de131d90901c = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const { isWorkspaceProduct: isWorkspaceProduct, autoActivationFailed: autoActivationFailed } = (0, $ff4S3.useSiteActivationContext)();
    // spark-defer-site-name-v2 (TWCG-2407): once auto-activation has failed and
    // fallen back to this form, a real error is already shown for the site
    // name — the generic "this is just a suggestion" hint is redundant next to
    // it. Control and every other cohort never set this flag, so they're
    // unaffected.
    if (autoActivationFailed) return null;
    const text = isWorkspaceProduct ? formatMessage({
        id: 'siteActivation.nameSite.inputWorkspaceNameHelperText',
        defaultMessage: 'This workspace name is just a suggestion. Feel free to change to something your team will recognize.'
    }) : formatMessage({
        id: 'siteActivation.nameSite.inputSiteNameHelperText',
        defaultMessage: 'This site name is just a suggestion. Feel free to change to something your team will recognize.'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        id: "site-name-helper",
        className: (0, $2jatx.default)([
            "_syaz1kw7 _1wyboqnp _vwz4bs82 _19pk1kwk _2hwxidpf _otyridpf _18u0idpf"
        ]),
        children: text
    });
};
const $b38a10467ddc3e98$var$helperTextCss = null;

});

parcelRegister("8SDzo", function(module, exports) {
$parcel$export(module.exports, "NewUserSubmitButton", function () { return $95b46875f4877d38$export$f05369598c89e38f; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $8Mruz = parcelRequire("8Mruz");
const $95b46875f4877d38$export$f05369598c89e38f = ({ hasPrivacyPolicy: hasPrivacyPolicy = false })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const submitMessage = hasPrivacyPolicy ? formatMessage({
        id: 'siteActivation.nameSite.agreeButton',
        defaultMessage: 'Agree and start now'
    }) : formatMessage({
        id: 'siteActivation.nameSiteNewUser.continueButton',
        defaultMessage: 'Continue'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8Mruz.SubmitButton), {
        submitMessage: submitMessage
    });
};

});



parcelRegister("2HR6E", function(module, exports) {
$parcel$export(module.exports, "UpgradeEligibleUser", function () { return $ce270ebdae685cc4$export$31213096ab10a3ce; });

var $7VQPk = parcelRequire("7VQPk");

var $b72iB = parcelRequire("b72iB");
const $ce270ebdae685cc4$export$31213096ab10a3ce = (props)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $b72iB.Content), {
        ...props
    });

});
parcelRegister("b72iB", function(module, exports) {
$parcel$export(module.exports, "Content", function () { return $455b4be8f401193e$export$7c6e2c02157bb7d2; });
/* content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $aw05g = parcelRequire("aw05g");

var $33py5 = parcelRequire("33py5");

var $eWKFr = parcelRequire("eWKFr");

var $lX14w = parcelRequire("lX14w");

var $ff4S3 = parcelRequire("ff4S3");

var $ejUcs = parcelRequire("ejUcs");
const $455b4be8f401193e$export$7c6e2c02157bb7d2 = ({ SiteNameInput: SiteNameInput = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eWKFr.SiteNameInput), {}), SitePicker: SitePicker = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $33py5.SitePicker), {}), SiteToggleButton: SiteToggleButton = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aw05g.SiteToggleButton), {}), SubmitButton: SubmitButton = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ejUcs.UpgradeEligibleSubmitButton), {}) })=>{
    const { activateSite: activateSite, showSitePicker: showSitePicker } = (0, $ff4S3.useSiteActivationContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lX14w.default), {
        onSubmit: activateSite,
        isDisabled: false,
        children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("form", {
                ...formProps,
                autoComplete: "off",
                "data-testid": "upgrade-eligible-site-activation",
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _zulp1tcg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        children: [
                            showSitePicker ? SitePicker : SiteNameInput,
                            SiteToggleButton
                        ]
                    }),
                    SubmitButton
                ]
            })
    });
};
const $455b4be8f401193e$var$containerCss = null;

});
parcelRegister("ejUcs", function(module, exports) {
$parcel$export(module.exports, "UpgradeEligibleSubmitButton", function () { return $ec48f630e3d05de6$export$9143452c910a3be3; });

var $7VQPk = parcelRequire("7VQPk");

var $ff4S3 = parcelRequire("ff4S3");

var $8e22h = parcelRequire("8e22h");

var $8Mruz = parcelRequire("8Mruz");
const $ec48f630e3d05de6$export$9143452c910a3be3 = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const { showSitePicker: showSitePicker } = (0, $ff4S3.useSiteActivationContext)();
    const submitMessage = showSitePicker ? formatMessage({
        id: 'WacSignupForm.upgradeButtonText',
        defaultMessage: 'Upgrade now'
    }) : formatMessage({
        id: 'siteActivation.nameSiteNewUser.continueButton',
        defaultMessage: 'Continue'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8Mruz.SubmitButton), {
        submitMessage: submitMessage
    });
};

});



parcelRegister("3ptXA", function(module, exports) {
$parcel$export(module.exports, "WeekOneUser", function () { return $0d9840caf41bd814$export$16be3dbbc731576d; });
/* week-one-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $lmQGF = parcelRequire("lmQGF");

var $fcO7r = parcelRequire("fcO7r");

var $7GVWk = parcelRequire("7GVWk");

var $kbpa7 = parcelRequire("kbpa7");

var $jgBbG = parcelRequire("jgBbG");

var $g4osg = parcelRequire("g4osg");
const $0d9840caf41bd814$export$16be3dbbc731576d = ()=>{
    const createNewWorkspace = (0, $1oC0p.useMemo)(()=>{
        if (typeof window === 'undefined') return false;
        const queryParams = new URLSearchParams(window.location.search);
        return queryParams.get('createNew') === 'true';
    }, []);
    const [showSiteNaming, setShowSiteNaming] = (0, $1oC0p.useState)(createNewWorkspace);
    const { product: product } = (0, $7GVWk.useUserContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const clickReturnToExistingWorkspace = ()=>{
        setShowSiteNaming(false);
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'contactExpandGoToReturnToProductScreen',
            attributes: {
                productName: product?.name
            }
        }).fire();
    };
    const goToExistingWorkspaceMessageValues = {
        link: (str)=>$0d9840caf41bd814$var$link(str, clickReturnToExistingWorkspace)
    };
    const goToExistingWorkspaceMessage = product?.key === (0, $fcO7r.ProductKey).CONFLUENCE ? intl.formatMessage({
        id: 'BxpSignup.SiteExpansionForm.cobrandedGoToExistingWorkspace',
        defaultMessage: 'or <link>visit an existing workspace</link>'
    }, goToExistingWorkspaceMessageValues) : intl.formatMessage({
        id: 'bxpSignup.companyExpand.cobrandedReturnToJoinSites',
        defaultMessage: 'or <link>join an existing site</link>'
    }, goToExistingWorkspaceMessageValues);
    return showSiteNaming ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ae4v1yb4 _1e0c11p5 _16jlkb7n"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgBbG.ExistingUser), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1wybdlk8 _k48pbfng _y3gn1h6o"
                ]),
                children: goToExistingWorkspaceMessage
            })
        ]
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g4osg.ReturnToExistingProduct), {
        productKeyForExpand: product?.key || (0, $fcO7r.ProductKey).JIRA_SOFTWARE,
        exitView: ()=>{
            setShowSiteNaming(true);
            createAnalyticsEvent({
                eventType: 'ui',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'contactExpandGoToSiteNamingScreen',
                attributes: {
                    productName: product?.name
                }
            }).fire();
        }
    });
};
const $0d9840caf41bd814$var$containerCss = null;
const $0d9840caf41bd814$var$goToExistingWorkspaceLinkCss = null;
const $0d9840caf41bd814$var$goToExistingWorkspaceMessageCss = null;
const $0d9840caf41bd814$var$link = (str, clickReturnToExistingWorkspace)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
        onClick: clickReturnToExistingWorkspace,
        className: (0, $2jatx.default)([
            "_bfhkmzrp _19itidpf _2rkoidpf _syaz5hrz _80omtlke _1wyb1kw7 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l3l3k2"
        ]),
        style: {
            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
        },
        children: str
    });

});
parcelRegister("g4osg", function(module, exports) {
$parcel$export(module.exports, "ReturnToExistingProduct", function () { return $a961e78bb1453a70$export$ba7c22a9ce02f49f; });
/* return-to-existing-product.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $lmQGF = parcelRequire("lmQGF");

var $iTHVN = parcelRequire("iTHVN");

var $fcO7r = parcelRequire("fcO7r");

var $gZgIU = parcelRequire("gZgIU");

var $2WL8B = parcelRequire("2WL8B");

var $7GVWk = parcelRequire("7GVWk");

var $lqyi6 = parcelRequire("lqyi6");

var $kbpa7 = parcelRequire("kbpa7");
const $a961e78bb1453a70$export$ba7c22a9ce02f49f = ({ exitView: exitView, productKeyForExpand: productKeyForExpand })=>{
    const d0to6JiraSite = (0, $2WL8B.useProductD0to6Site)({
        productKey: productKeyForExpand
    });
    const { product: product } = (0, $7GVWk.useUserContext)();
    const { user: { email: email } } = (0, $7GVWk.useUserContext)();
    const { productName: productName } = (0, $fcO7r.getProductData)(product?.key);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const goToProductButtonText = productKeyForExpand === (0, $fcO7r.ProductKey).CONFLUENCE ? intl.formatMessage({
        id: 'bxpSignup.siteExpansion.goToWorkspace',
        defaultMessage: 'Go to workspace'
    }) : intl.formatMessage({
        id: 'bxpSignup.siteExpansion.goToProduct',
        defaultMessage: 'Go to {productName}'
    }, {
        productName: productName
    });
    const createNewWorkspaceMessageValues = {
        link: (str)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                onClick: exitView,
                className: (0, $2jatx.default)([
                    "_bfhkmzrp _19itidpf _2rkoidpf _syaz5hrz _80omtlke _ect41kw7 _1wyb1kw7 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l3ftjs"
                ]),
                style: {
                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                    "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800'))
                },
                children: str
            })
    };
    const createNewWorkspaceMessage = productKeyForExpand === (0, $fcO7r.ProductKey).CONFLUENCE ? intl.formatMessage({
        id: 'BxpSignup.SiteExpansionForm.cobrandedConfluenceCreateNewWorkspaceLink',
        defaultMessage: 'or <link>create a new workspace</link>'
    }, createNewWorkspaceMessageValues) : intl.formatMessage({
        id: 'BxpSignup.SiteExpansionForm.cobrandedJiraCreateNewWorkspaceLink',
        defaultMessage: 'or <link>start a new site</link>'
    }, createNewWorkspaceMessageValues);
    return !d0to6JiraSite ? null : /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ae4v1yb4 _1e0c11p5 _16jlkb7n _zulp7vkz"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _zulpzwfg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_ect41kw7 _1wybdlk8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "BxpSignup.SiteExpansionForm.cobrandedSubheader.2",
                            defaultMessage: "You\u2019re logged in as {email}. <switchAccountLink>Switch account</switchAccountLink>",
                            values: {
                                email: /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                                    className: (0, $2jatx.default)([
                                        "_k48pni7l _ct361wug _1i4q1hna _1nmz1hna _slp31hna"
                                    ]),
                                    children: email
                                }),
                                switchAccountLink: $a961e78bb1453a70$var$switchAccountLink
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "data-testid": "return-to-existing-product",
                        className: (0, $2jatx.default)([
                            "_4cvr1h6o _19itkze7 _2rkoftgi _1e0c11p5 _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1bsb1osq"
                        ]),
                        style: {
                            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                            href: $a961e78bb1453a70$var$getProductUrl({
                                url: d0to6JiraSite.url,
                                productKey: product?.key ?? ''
                            }),
                            onClick: (e)=>{
                                e.preventDefault(); // wait for event to fire
                                createAnalyticsEvent({
                                    eventType: 'ui',
                                    action: 'clicked',
                                    actionSubject: 'button',
                                    actionSubjectId: 'contactExpandClickReturnToProductButton',
                                    attributes: {
                                        productName: productName
                                    }
                                }).fire();
                                window.location.href = $a961e78bb1453a70$var$getProductUrl({
                                    url: d0to6JiraSite.url,
                                    productKey: product?.key ?? ''
                                });
                            },
                            className: (0, $2jatx.default)([
                                "_4cvr1h6o _1e0c1txw _1bah1yb4 _1bsb1osq _9oik1snc _1bnxagmp _jf4cvv82"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1wyb1syg _1reo15vq _18m915vq"
                                    ]),
                                    style: {
                                        "--_1jvo4a6": (0, $6ZVlx.default)((0, $iTHVN.fontSize).md)
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                            className: (0, $2jatx.default)([
                                                "_k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                            ]),
                                            children: productName
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_syazk0sw _1wybdlk8 _1reo15vq _18m915vq _1bto1l2s _o5721q9c"
                                            ]),
                                            style: {
                                                "--_1e97w25": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light700'))
                                            },
                                            children: d0to6JiraSite.displayName
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                    variant: "primary",
                                    size: "small",
                                    color: "blue",
                                    className: (0, $2jatx.default)([
                                        "_ect41kw7 _1wyb7vkz _1rjcftgi"
                                    ]),
                                    children: goToProductButtonText
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1wybdlk8 _k48pbfng _y3gn1h6o"
                ]),
                children: createNewWorkspaceMessage
            })
        ]
    });
};
const $a961e78bb1453a70$var$switchAccountLink = (children)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        href: (0, $gZgIU.getSwitchAccountUrl)(),
        className: (0, $2jatx.default)([
            "_syaz5hrz _4bfu1r31 _1hms8stv _ajmmnqa1 _o5721q9c _30l3ftjs"
        ]),
        style: {
            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
            "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800'))
        },
        children: children
    });
const $a961e78bb1453a70$var$getProductUrl = ({ url: url, productKey: productKey })=>{
    switch(productKey){
        case (0, $fcO7r.ProductKey).JIRA_SOFTWARE:
            return `${url}/jira`;
        case (0, $fcO7r.ProductKey).CONFLUENCE:
            return `${url}/wiki`;
        default:
            return url;
    }
};
const $a961e78bb1453a70$var$switchAccountSubheader = null;
const $a961e78bb1453a70$var$containerCss = null;
const $a961e78bb1453a70$var$contentCss = null;
const $a961e78bb1453a70$var$createNewWorkspaceMessageCss = null;
const $a961e78bb1453a70$var$createNewWorkspaceLinkCss = null;
const $a961e78bb1453a70$var$boxContainerCss = null;
const $a961e78bb1453a70$var$siteBoxCss = null;
const $a961e78bb1453a70$var$bold = null;
const $a961e78bb1453a70$var$siteCss = null;
const $a961e78bb1453a70$var$siteNameCss = null;
const $a961e78bb1453a70$var$emailCss = null;
const $a961e78bb1453a70$var$switchAccountLinkCss = null;
const $a961e78bb1453a70$var$goToProductButtonCss = null;

});







parcelRegister("hswtB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f8728e2e52e85e74$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $jsxHL = parcelRequire("jsxHL");

var $aRkc9 = parcelRequire("aRkc9");

var $7DnXU = parcelRequire("7DnXU");
const $f8728e2e52e85e74$export$4489c2ed11909944 = ({ ...props })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
        children: [
            props.loggedInPaid ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7DnXU.default), {
                    ...props
                })
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7DnXU.default), {
                ...props
            }),
            !props.hideExploreMore && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aRkc9.default), {})
        ]
    });
};
var $f8728e2e52e85e74$export$2e2bcd8739ae039 = $f8728e2e52e85e74$export$4489c2ed11909944;

});
parcelRegister("aRkc9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f2dcff6f910a7097$export$2e2bcd8739ae039; });
/* explore-more-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $7Sp5f = parcelRequire("7Sp5f");

var $bDAxQ = parcelRequire("bDAxQ");

var $02dyT = parcelRequire("02dyT");
const $f2dcff6f910a7097$var$exploreStyle = null;
const $f2dcff6f910a7097$var$largeSparklesIconContainerStyles = null;
const $f2dcff6f910a7097$var$mediumSparklesIconContainerStyles = null;
const $f2dcff6f910a7097$var$smallSparklesIconContainerStyles = null;
const $f2dcff6f910a7097$export$ce05c083d6af8c49 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $02dyT.default), {
        header: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1rkb1kdj"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "ConfluenceSoftwarePageTemplate.heroHeaderExploreMoreOfConfluence",
                    defaultMessage: "Explore more of Confluence"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_kqswstnw _11wmh2mm _fc2710yn _1kyz14y2 _1mjbglyw"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7Sp5f.SparklesIcon), {
                        width: '120',
                        height: '80'
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_kqswstnw _11wmh2mm _fc271crf _1kyz14y2 _dm25glyw _sugaglyw"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7Sp5f.SparklesIcon), {
                        width: '90',
                        height: '60'
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_kqswstnw _11wmh2mm _fc27ftgi _1kyz1l7b _181nglyw"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bDAxQ.ThickSparklesIcon), {
                        width: '60',
                        height: '40'
                    })
                })
            ]
        }),
        subHeader: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePage.heroHeaderExploreMoreOfConfluence.subHeading",
            defaultMessage: "Create, collaborate, and connect your team's knowledge, all in one place"
        })
    });
};
var $f2dcff6f910a7097$export$2e2bcd8739ae039 = $f2dcff6f910a7097$export$ce05c083d6af8c49;

});
parcelRegister("7Sp5f", function(module, exports) {
$parcel$export(module.exports, "SparklesIcon", function () { return $4e81f00723f31458$export$a05b22346a85e647; });

var $7VQPk = parcelRequire("7VQPk");
const $4e81f00723f31458$export$a05b22346a85e647 = ({ width: width, height: height })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 122 82",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
            id: "Gestural Line/star 7",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    id: "Vector",
                    d: "M27.8084 18.2872C24.4456 16.7937 16.6276 20.7744 17.5199 14.5683C16.7065 16.9365 20.2695 2.56069 17.3317 4.61946C17.101 4.3398 16.1662 6.63659 16.4758 6.708C16.8339 9.13569 14.497 14.1696 14.2663 18.0253C14.2481 17.8944 -6.35927 17.6029 2.88523 20.0484C4.59695 20.2507 17.6656 18.9298 13.0342 26.3259C14.2543 43.7363 17.1678 31.3836 17.01 20.8815C18.9463 21.2801 32.9193 21.0719 27.8023 18.2872H27.8084Z",
                    fill: "#101214"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    id: "Vector_2",
                    d: "M120.32 39.0772C115.701 38.2025 110.116 40.8504 108.89 36.4056C110.371 35.644 109.431 22.3749 107.543 29.4676C107.871 29.6164 108.308 29.4914 108.119 29.8009C106.22 29.8842 108.332 32.3237 107.488 32.77C106.311 32.1809 108.338 35.3941 107.154 34.5849C106.426 35.763 106.353 37.3279 106.426 38.9761C107.106 39.4878 88.4408 37.8098 96.447 41.2312C97.0115 39.4521 96.5381 42.3915 99.1906 40.6719C101.679 41.6954 103.33 42.1 106.584 42.0881C105.261 45.807 108.866 60.9205 109.631 49.7817C110.189 47.5206 107.561 39.4521 113.437 42.5224C114.748 40.9694 124.921 41.9452 120.308 39.0713L120.32 39.0772Z",
                    fill: "#101214"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    id: "Vector_3",
                    d: "M82.6317 11.6885C78.0125 10.8138 72.4282 13.4617 71.2021 9.01685C72.6832 8.25522 71.7423 -5.01372 69.8546 2.07894C70.1824 2.2277 70.6194 2.10271 70.4312 2.41212C68.5313 2.49542 70.6437 4.93501 69.8 5.38127C68.6224 4.7922 70.6497 8.00535 69.4661 7.19612C68.7377 8.37426 68.6649 9.93917 68.7377 11.5874C69.4176 12.0991 50.7464 10.4211 58.7587 13.8425C59.3233 12.0634 58.8498 15.0028 61.5024 13.2832C63.991 14.3066 65.642 14.7112 68.8955 14.6993C67.7908 18.2754 70.7226 33.2462 72.1733 22.4406C72.064 20.6555 70.1216 11.9444 75.7545 15.1337C77.0656 13.5807 87.2388 14.5566 82.6257 11.6826L82.6317 11.6885Z",
                    fill: "#101214"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    id: "Vector_4",
                    d: "M71.3178 67.2696C66.6986 66.3949 61.1143 69.0428 59.8881 64.598C61.3692 63.8363 60.4284 50.5673 58.5406 57.66C58.8684 57.8087 59.3054 57.6838 59.1172 57.9932C57.2174 58.0765 59.3297 60.5161 58.486 60.9624C57.3084 60.3733 59.3358 63.5865 58.1521 62.7772C57.4237 63.9554 57.3509 65.5203 57.4238 67.1685C58.1036 67.6802 39.4325 66.0022 47.4448 69.4236C48.0093 67.6445 47.5358 70.5839 50.1884 68.8643C52.6771 69.8877 54.3281 70.2924 57.5816 70.2805C56.2584 73.9993 59.8638 89.1129 60.6286 77.9741C61.1871 75.713 58.5588 67.6445 64.4345 70.7148C65.7456 69.1618 75.9188 70.1376 71.3057 67.2637L71.3178 67.2696Z",
                    fill: "#101214"
                })
            ]
        })
    });
};

});

parcelRegister("bDAxQ", function(module, exports) {
$parcel$export(module.exports, "ThickSparklesIcon", function () { return $3181594c1a3e5352$export$8016ce75dc94b90d; });

var $7VQPk = parcelRequire("7VQPk");
const $3181594c1a3e5352$export$8016ce75dc94b90d = ({ width: width, height: height })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 62 43",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M14.0609 10.1436C12.3934 9.39683 8.51669 11.3872 8.95914 8.28414C8.55582 9.46824 10.3226 2.28034 8.86582 3.30973C8.75144 3.1699 8.28791 4.3183 8.44142 4.354C8.619 5.56784 7.46019 8.08479 7.34581 10.0127C7.33678 9.94721 -2.88176 9.80144 1.70229 11.0242C2.55108 11.1254 9.03138 10.4649 6.73484 14.163C7.33982 22.8681 8.78454 16.6918 8.70629 11.4407C9.66644 11.6401 16.5952 11.5359 14.0579 10.1436H14.0609Z",
                fill: "#101214",
                stroke: "black"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M59.9349 20.5386C57.6444 20.1013 54.8753 21.4252 54.2673 19.2028C55.0017 18.822 54.5352 12.1875 53.5991 15.7338C53.7617 15.8082 53.9784 15.7457 53.8851 15.9004C52.943 15.9421 53.9904 17.1619 53.5721 17.385C52.9881 17.0905 53.9934 18.697 53.4065 18.2924C53.0453 18.8815 53.0092 19.664 53.0453 20.4881C53.3824 20.7439 44.127 19.9049 48.0971 21.6156C48.377 20.726 48.1422 22.1958 49.4575 21.336C50.6916 21.8477 51.5103 22.05 53.1236 22.044C52.4674 23.9035 54.2553 31.4602 54.6346 25.8908C54.9115 24.7603 53.6082 20.7261 56.5217 22.2612C57.1719 21.4847 62.2164 21.9726 59.9289 20.5356L59.9349 20.5386Z",
                fill: "#101214",
                stroke: "black"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M41.2465 6.84425C38.956 6.4069 36.1869 7.73083 35.579 5.50842C36.3134 5.12761 35.8468 -1.50686 34.9108 2.03947C35.0733 2.11385 35.29 2.05135 35.1967 2.20606C34.2546 2.24771 35.3021 3.4675 34.8837 3.69064C34.2998 3.3961 35.3051 5.00267 34.7181 4.59806C34.3569 5.18713 34.3208 5.96959 34.357 6.79369C34.6941 7.04955 25.4357 6.21055 29.4087 7.92123C29.6886 7.03168 29.4539 8.5014 30.7692 7.64159C32.0032 8.15331 32.8219 8.35562 34.4352 8.34967C33.8874 10.1377 35.3412 17.6231 36.0605 12.2203C36.0063 11.3278 35.0432 6.97219 37.8364 8.56685C38.4865 7.79034 43.531 8.27828 41.2435 6.8413L41.2465 6.84425Z",
                fill: "#101214",
                stroke: "black"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M35.6353 34.6348C33.3447 34.1975 30.5756 35.5214 29.9676 33.299C30.702 32.9182 30.2355 26.2837 29.2994 29.83C29.462 29.9044 29.6787 29.8419 29.5854 29.9966C28.6433 30.0383 29.6907 31.2581 29.2724 31.4812C28.6884 31.1867 29.6937 32.7932 29.1068 32.3886C28.7456 32.9777 28.7095 33.7601 28.7456 34.5843C29.0827 34.8401 19.8243 34.0011 23.7974 35.7118C24.0773 34.8222 23.8425 36.292 25.1578 35.4322C26.3919 35.9439 27.2106 36.1462 28.8239 36.1402C28.1677 37.9997 29.9556 45.5564 30.3348 39.987C30.6117 38.8565 29.3085 34.8222 32.222 36.3574C32.8722 35.5809 37.9167 36.0688 35.6292 34.6318L35.6353 34.6348Z",
                fill: "#101214",
                stroke: "black"
            })
        ]
    });
};

});

parcelRegister("02dyT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8a314bdb44da51be$export$2e2bcd8739ae039; });
/* header-text-block.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $8a314bdb44da51be$var$headerTextBlock = null;
const $8a314bdb44da51be$var$headerText = null;
const $8a314bdb44da51be$var$headerSubText = null;
const $8a314bdb44da51be$var$leftAlignedStyle = null;
const $8a314bdb44da51be$var$button = null;
const $8a314bdb44da51be$export$b0d75561f67a4b0d = ({ header: header, subHeader: subHeader, leftAligned: leftAligned, cta: cta })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _1e0c1txw _2lx21bp4 _1bah1h6o _1q51oahv _85i5xncg _ag851h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                className: (0, $2jatx.default)([
                    "_y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3td7vkz _19bvidpf",
                    leftAligned && "_y3gn1e5h",
                    "superhero-contrast"
                ]),
                children: header
            }),
            subHeader && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3td7vkz _19bvidpf",
                    leftAligned && "_y3gn1e5h",
                    "body-lg"
                ]),
                children: subHeader
            }),
            cta && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y3gn1h6o _bpsp1nn1 _43ds1afi"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                },
                children: cta
            })
        ]
    });
};
var $8a314bdb44da51be$export$2e2bcd8739ae039 = $8a314bdb44da51be$export$b0d75561f67a4b0d;

});


parcelRegister("7DnXU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0dd858399beccd45$export$2e2bcd8739ae039; });
/* log-me-in.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $lmQGF = parcelRequire("lmQGF");

var $iPPTB = parcelRequire("iPPTB");

var $jQ0cd = parcelRequire("jQ0cd");

var $iRMRa = parcelRequire("iRMRa");

var $5uYpV = parcelRequire("5uYpV");

var $dEFIL = parcelRequire("dEFIL");

var $4X0dO = parcelRequire("4X0dO");

var $gIKKj = parcelRequire("gIKKj");

var $iSeHD = parcelRequire("iSeHD");

var $eXdK6 = parcelRequire("eXdK6");
const $0dd858399beccd45$var$START_URL = 'https://start.atlassian.com';
const $0dd858399beccd45$var$SIGNUP_URL = 'https://atlassian.com/try/cloud/signup?bundle=confluence&edition=free';
const $0dd858399beccd45$var$sectionCSS = null;
const $0dd858399beccd45$var$wrapLogMeSecAndLines = null;
// Adjustments for fixed top nav.
// The logged in paid pages have a position:fixed top nav.
const $0dd858399beccd45$var$wrapLogMeSecAndLinesLoggedInPaid = null;
const $0dd858399beccd45$var$logMeBackInSectionStyle = null;
const $0dd858399beccd45$var$headingStyle = null;
const $0dd858399beccd45$var$subHeadingStyle = null;
const $0dd858399beccd45$var$confluenceSiteBoxContainerStyle = null;
const $0dd858399beccd45$var$flareContainerCss = null;
const $0dd858399beccd45$var$confluenceSiteBoxUnderlayStyle = null;
const $0dd858399beccd45$var$confluenceSiteBoxStyle = null;
const $0dd858399beccd45$var$logoAndSiteNameStyle = null;
const $0dd858399beccd45$var$logoStyle = null;
const $0dd858399beccd45$var$siteStyle = null;
const $0dd858399beccd45$var$productStyle = null;
const $0dd858399beccd45$var$siteNameStyle = null;
const $0dd858399beccd45$var$otherSiteLinkStyle = null;
const $0dd858399beccd45$var$buttonStyle = null;
const $0dd858399beccd45$var$imgWrapperStyle = null;
const $0dd858399beccd45$var$imgStyle = null;
var $0dd858399beccd45$var$TRACKING_EVENT_NAMES = /*#__PURE__*/ function(TRACKING_EVENT_NAMES) {
    TRACKING_EVENT_NAMES["loggedInHeroProductCtaClicked"] = "loggedInHeroProductCtaClicked";
    TRACKING_EVENT_NAMES["loggedInHeroAnotherSiteCtaClicked"] = "loggedInHeroAnotherSiteCtaClicked";
    TRACKING_EVENT_NAMES["loggedInHeroNewSiteCtaClicked"] = "loggedInHeroNewSiteCtaClicked";
    return TRACKING_EVENT_NAMES;
}($0dd858399beccd45$var$TRACKING_EVENT_NAMES || {});
const $0dd858399beccd45$export$48ece50d13cfbebc = ({ confluenceSites: confluenceSites, userProfileName: userProfileName, imgSrc: // eslint-disable-next-line local/no-non-orangelogic-images-eslint
imgSrc = 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Hero Image B-1884788674.webp', loggedInPaid: loggedInPaid })=>{
    const createConfluenceUrl = (url)=>{
        try {
            const tempUrl = new URL(url);
            tempUrl.pathname = '/wiki';
            tempUrl.search = '';
            return tempUrl.toString();
        } catch  {
            return url;
        }
    };
    const getSitenameFromUrl = (url)=>{
        try {
            const tempUrl = new URL(url);
            return tempUrl.hostname.split('.')[0] || '';
        } catch  {
            return '';
        }
    };
    const firstName = userProfileName?.split(' ')[0];
    const siteUrl = createConfluenceUrl(confluenceSites[0]?.url || '') || $0dd858399beccd45$var$START_URL;
    const siteName = getSitenameFromUrl(confluenceSites[0]?.url || '');
    const hasMultipleConfluences = confluenceSites.length > 1;
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    (0, $1oC0p.useEffect)(()=>{
        if (typeof window !== 'undefined') createAnalyticsEvent({
            eventType: 'ui',
            action: 'loaded',
            actionSubject: 'page',
            actionSubjectId: 'loggedInHero',
            source: '/software/confluence',
            attributes: {
                url: window.location.href
            }
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const clickHandler = (eventName)=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'loggedInHero',
            source: '/software/confluence',
            attributes: {
                eventName: eventName,
                url: window.location.href
            }
        }).fire();
    };
    const intl = (0, $8e22h.default)();
    const linkUrl = loggedInPaid ? $0dd858399beccd45$var$SIGNUP_URL : $0dd858399beccd45$var$START_URL;
    const signupHref = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=confluence&edition=free&createNew=true');
    const gwp5090BannerExperiment = (0, $gIKKj.useExperiment)((0, $4X0dO.experiments).gwp5090ExperimentBannerConfluence);
    const gwp5090IsLiftedBanner = gwp5090BannerExperiment !== undefined && gwp5090BannerExperiment.type === 'enrolled' && gwp5090BannerExperiment.value === 'lifted';
    const gwp5090Team25Config = {
        identifier: 'GWP5090.confluence-product-tour.lifted',
        customCSS: {
            position: 'absolute',
            margin: 'auto',
            inset: 'auto 0 90px'
        },
        bannerType: 'lifted',
        text: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "team25-banners-and-butterbars.confluence.text",
                defaultMessage: "<strong>April 8-10 \u2022 Anaheim, California</strong>Hear from the world\u2019s leading product experts on how to boost team performance at Team \u201925!",
                values: (0, $iRMRa.DEFAULT_VALUES)
            })
        }),
        mobileText: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "team25-banners-and-butterbars.confluence.mobile-text",
                defaultMessage: "<strong>April 8-10 \u2022 Anaheim, California</strong>Hear from leading product experts!",
                values: (0, $iRMRa.DEFAULT_VALUES)
            })
        }),
        productKey: 'home',
        backgroundPreset: 'gwp-5090-banners',
        imageProps: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/gf1wkse40oux4nf58b103kknvb18p4yc.webp',
            alt: 'Team25',
            //Event name is not localized
            width: 200
        },
        linkText: intl.formatMessage({
            id: 'team25-banners-and-butterbars.confluence.cta',
            defaultMessage: 'Get your pass'
        }),
        linkUrl: 'https://events.atlassian.com/team?utm_medium=event-web-referral&utm_source=confluence_product-tour&event_context=701QB00000Lg6oBYAR&utm_campaign=K:event|H:any|N:Team_25|P:agnostic|O:event-marketing|F:pre-event|C:event-home&utm_content=lifted-bar_WEBTEAM-17396&event_id=216653',
        dataEventProps: {
            'data-product-key': 'home',
            'data-event-component': 'linkButton',
            'data-event-container': 'announcementBanner',
            'data-event': 'clicked',
            'data-label': intl.formatMessage({
                id: 'team25-banners-and-butterbars.confluence.cta',
                defaultMessage: 'Get your pass'
            }),
            'data-label-english': 'Get your pass'
        }
    };
    const classWrapperName = gwp5090IsLiftedBanner ? 'lifted' : 'standard';
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Fragment), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
            className: (0, $2jatx.default)([
                "_1yeuh2mm",
                classWrapperName
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1itk1m1u _1lrw1dfr _1e0c1txw _4cvr1h6o _1bah1h6o _zulp1a0z _19pkidpf _2hwx1wug _otyridpf _18u01wug _ca0q1wto _u5f31lev _n3td1fqw _19bv1lev _165t1kc5 _na0i1bp4 _2osnckbl _13lo7rrr",
                        loggedInPaid && "_165t1wug _5br81et3 _rvh8ys9h _17y2ys9h _2936ys9h _jk7n16xz _la4x1tcg _d8uxys9h _1vw11tcg",
                        classWrapperName
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_ca0q1tcg _u5f3idpf _n3td1tcg _19bvidpf _1lp7vrvc _10jx1erl _1s4p1osq"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                                    className: (0, $2jatx.default)([
                                        "_1wybckbl _vwz48vuz _k48pbfng _1pfhidpf _6rthftgi"
                                    ]),
                                    children: firstName ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "ConfluenceSoftwarePageTemplate.loggedInHero.welcomeBackWithName",
                                        defaultMessage: `Welcome back, {name}.`,
                                        values: {
                                            name: firstName
                                        }
                                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "ConfluenceSoftwarePageTemplate.loggedInHero.welcomeBack",
                                        defaultMessage: "Welcome back"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    className: (0, $2jatx.default)([
                                        "_1wybgktf _6rth1tcg _1pfhidpf"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "ConfluenceSoftwarePageTemplate.loggedInHero.pickUpWhereYouLeftOff",
                                        defaultMessage: "Pick up where you left off in Confluence."
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_kqswh2mm"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_kqswstnw _1e02k4tm _1pbycs5v _14qqglyw"
                                            ]),
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eXdK6.FlareSvg), {})
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                            className: (0, $2jatx.default)([
                                                "_kqswh2mm _1pbykb7n _1bsb1wug _4t3it9kd _1e0c1txw _1bah1yb4 _2lx2vrvc _4cvr1h6o _19it1puz _2rko1y44 _ca0q7vkz _u5f31tcg _n3td7vkz _19bv7vkz _bfhku67f _yhmu1bp4 _9pnu1wug _te6cv2br _jk7n1v6z _la4x7vkz _d8ux7vkz _1vw17vkz"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_1e0c1txw _2lx2vrvc _4cvr1h6o _1ul9idpf"
                                                    ]),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                            className: (0, $2jatx.default)([
                                                                "_12l219bv _1pfhrdoj"
                                                            ]),
                                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5uYpV.Logo), {
                                                                brand: "confluence",
                                                                type: "mark",
                                                                appearance: "brand"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                            className: (0, $2jatx.default)([
                                                                "_vwz4qslr _1wyb7vkz _1reo15vq _18m915vq"
                                                            ]),
                                                            children: [
                                                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                                    className: (0, $2jatx.default)([
                                                                        "_k48pbfng _4t3iqslr _1wybl52n _y3gnv2br"
                                                                    ]),
                                                                    children: "Confluence"
                                                                }),
                                                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                                    className: (0, $2jatx.default)([
                                                                        "_k48powjs _1bto1l2s _1reo15vq _18m915vq _o5721q9c _4t3iqslr"
                                                                    ]),
                                                                    children: siteName
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                                                    id: "confluence-button",
                                                    variant: "primary",
                                                    size: "small",
                                                    color: "blue",
                                                    href: siteUrl,
                                                    onClick: ()=>clickHandler("loggedInHeroProductCtaClicked"),
                                                    className: (0, $2jatx.default)([
                                                        "_o5721q9c _ahbqo7ao _19tjidpf _1qza1osq _5m7p1osq"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                                        id: "ConfluenceSoftwarePageTemplate.loggedInHero.goToConfluence",
                                                        defaultMessage: "Go to Confluence"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_1bsb1w8u _kqswstnw _u7conicn _rjxpd439 _bfhkh727 _4t3i1wqb _9pnu1l8a"
                                            ])
                                        })
                                    ]
                                }),
                                hasMultipleConfluences && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                    href: linkUrl,
                                    text: intl.formatMessage({
                                        id: 'ConfluenceSoftwarePageTemplate.loggedInHero.lookingForDifferentSite',
                                        defaultMessage: 'Looking for a different site?'
                                    }),
                                    onClick: ()=>clickHandler("loggedInHeroAnotherSiteCtaClicked"),
                                    className: (0, $2jatx.default)([
                                        "_1pfhckbl"
                                    ])
                                }),
                                loggedInPaid && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                    href: signupHref,
                                    text: intl.formatMessage({
                                        id: 'ConfluenceSoftwarePageTemplate.loggedInHero.orCreateANewWorkspace',
                                        defaultMessage: 'Or create a new workspace'
                                    }),
                                    onClick: ()=>clickHandler("loggedInHeroNewSiteCtaClicked"),
                                    className: (0, $2jatx.default)([
                                        "_1pfhckbl"
                                    ])
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_10jxstmo _1s4p1osq"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                                alt: "",
                                src: imgSrc,
                                className: (0, $2jatx.default)([
                                    "_1bsb1osq"
                                ])
                            })
                        })
                    ]
                }),
                gwp5090IsLiftedBanner && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dEFIL.EnhancedBannerAlert), {
                    ...gwp5090Team25Config
                })
            ]
        })
    });
};
var $0dd858399beccd45$export$2e2bcd8739ae039 = $0dd858399beccd45$export$48ece50d13cfbebc;

});
parcelRegister("dEFIL", function(module, exports) {
$parcel$export(module.exports, "EnhancedBannerAlert", function () { return $41ab4e6d9e0b9eaf$export$e2bb4f4abc9a31da; });
/* enhanced-banner-alert.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $hnmMQ = parcelRequire("hnmMQ");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $1rGpC = parcelRequire("1rGpC");

var $dE0sS = parcelRequire("dE0sS");

var $jsxHL = parcelRequire("jsxHL");

var $2gCne = parcelRequire("2gCne");
const $41ab4e6d9e0b9eaf$export$e2bb4f4abc9a31da = (bannerInfo)=>{
    const bannerStorageItem = `BannerAlert_dismiss-${bannerInfo.identifier}`;
    const closeIconDataEventProps = {
        'data-product-key': bannerInfo.productKey,
        'data-event-component': 'button',
        'data-event-container': 'announcementBanner',
        'data-event': 'clicked',
        'data-label': 'Close',
        'data-label-english': 'Close'
    };
    const [isHidden, setIsHidden] = (0, $1oC0p.useState)(true);
    const mobileClass = bannerInfo.mobileTextThirdScreen ? 'three-screen' : 'two-screen';
    (0, $1oC0p.useEffect)(()=>{
        const dismissValue = (0, $2gCne.getLocalStorage)(bannerStorageItem);
        if (dismissValue !== '1') setIsHidden(false);
    }, [
        bannerStorageItem
    ]);
    let mobileProps = bannerInfo.imageProps;
    if (bannerInfo.imageMobileProps && bannerInfo.imageMobileProps.src) mobileProps = bannerInfo.imageMobileProps;
    const bannerBgPreset = bannerInfo.backgroundPreset ? `bg-${bannerInfo.backgroundPreset}` : `bg-none`;
    const bannerType = bannerInfo.bannerType ? `banner-type-${bannerInfo.bannerType}` : 'banner-type-default';
    const bgLinkColor = bannerInfo.backgroundPreset === 'gwp-5090-banners' ? 'bgBlackBlue' : 'bgWhite';
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_bfhk1bjw _kqswh2mm _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _1pbykb7n _85i5yh40 _189eh5ge _1dqonqa1 _5pioemm7 _nzmgglyw _1auo1lef _21w0idpf _15641crf _s4s5idpf _1qlo1crf _7j8l1lk2 _jw2n1wug _1yvc1wug _19z9gktf _nue91vuk _1lrfidpf _pytjidpf _smywidpf _4tf1idpf _1dkqidpf _1i8zidpf _1twsidpf _c7u0idpf _1u1bu5k9 _1876mq8p _gsz9mgnk _evayglyw _lhr7161t _1cmq12iu _88w11afi _5vmz1ejb _3kek1ejb _190eni2e _wb1217a9 _vb1gvgh6 _1at2oyge _49yzdf70 _cfy01ule _18901k92 _1aavidpf _72q2idpf _11sc1y44 _i4q0idpf _n8ff1cby _qho21j28 _1w7d1pfd _sqps1bjw _iawm1pfd _abydglyw _6c4a1afi _udn3glyw _2fl2idpf _1kn81afi _1vxm1afi _1maf1afi _waep1afi _1y8x1afi _1ur01afi _ojfc1afi _1yaa1afi _11zs1afi _1s051afi _6rr71bjw _fsy11bjw _sx881bjw _1s7h1bjw _1gud1afi _1m8a1afi _1lcv1afi _v05m1afi _lkhdni7l _pu49ni7l _162fni7l _19ycni7l _102q1hbo _2utfmgnk _1vm51dlf _1e74altx _1o3a1izt _1blmu4dp _1si213i1 _1k051ms4 _1yip1f51 _6zpp1f51 _eyt5xchc _nxj7u58z _7w4f1afi _xfs2idpf _17esg7ng _lfur1dgx _1t0kmgnk _ejrwidpf _1m4lanty _7ax8uuw1 _1ww71tcg _cfnoftgi _ogm61et3 _ve7k1ule _1mt7kfja _76j711ux _1dxgidpf _1i4jt1wm _ne8lqiko _1it7ys9h _umq2mgvx _16471dnu _1uhmmr2s _6cysidpf _yo8p1tcg _17pqqslr _ti1kp3fh _onmtn7od",
                `${bannerBgPreset} ${bannerType}`
            ]),
            "data-dismissed": isHidden ? 'true' : undefined,
            "data-testid": "banner-alert-container",
            style: {
                ...bannerInfo.customCSS,
                "--_lwvw50": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue100')),
                "--_1z9q1i": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.purple500')),
                "--_1hcckvk": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue900')),
                "--_5dnsy5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue700')),
                "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red')),
                "--_td2gmy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.saffron')),
                "--_ci5h4w": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.green')),
                "--_5p9fny": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.lime')),
                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1rjcpxbi _1e0c1txw _2lx2vrvc _zulpzwfg _kqswh2mm _6rth12gs _sugaglyw",
                                    "desktop-container"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _4cvr1h6o"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                            image: {
                                                width: 209,
                                                ...bannerInfo.imageProps
                                            },
                                            style: {
                                                maxWidth: '100%',
                                                height: 'auto'
                                            },
                                            forceEagerLoad: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_191wqgqc _4t3i1osq _sugaglyw",
                                            "line"
                                        ]),
                                        style: {
                                            "--_1e97w25": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light700'))
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1bsb1osq _1e0c1txw _2lx2vrvc _1bah1yb4 _4cvr1h6o _zulpzwfg _na0i1bp4 _dh1a1y6m _2osn14y2 _ag851h6o _10ca1q9c"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                className: (0, $2jatx.default)([
                                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pbykb7n",
                                                    "body-md"
                                                ]),
                                                children: bannerInfo.text
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                                bgColor: bgLinkColor,
                                                text: bannerInfo.linkText,
                                                "aria-label": bannerInfo.linkText,
                                                href: bannerInfo.linkUrl,
                                                type: "primary",
                                                dataEventProps: bannerInfo.dataEventProps
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1rjcpxbi _1e0cglyw _2lx21bp4 _4cvr1h6o _suga1txw",
                                    "mobile-container"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c11p5 _p12f1osq _18zr7vkz"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1ii7kb7n _yyhykb7n _1pglp3kn _tip812c5 _ow34q126 _ezr91onc _17k81cg0 _18shrjc5 _1h6z1ule",
                                                    "_19pkidpf _2hwx1wug _otyridpf _18u01wug",
                                                    mobileClass
                                                ]),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                                        image: {
                                                            width: 180,
                                                            ...mobileProps
                                                        },
                                                        style: {
                                                            maxWidth: '100%',
                                                            height: 'auto'
                                                        },
                                                        forceEagerLoad: true
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1ii7kb7n _yyhykb7n _1pglp3kn _tip812c5 _ow34q126 _ezr91onc _17k81cg0 _18shrjc5 _1h6z1ule",
                                                    "_y3gn1h6o _1mou1wug _tzy4idpf _ju25i11n",
                                                    mobileClass
                                                ]),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                    className: (0, $2jatx.default)([
                                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pbykb7n",
                                                        "body-md"
                                                    ]),
                                                    children: bannerInfo.mobileText
                                                })
                                            }),
                                            bannerInfo.mobileTextThirdScreen && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1ii7kb7n _yyhykb7n _1pglp3kn _tip812c5 _ow34q126 _ezr91onc _17k81cg0 _18shrjc5 _1h6z1ule",
                                                    "_y3gn1h6o _1mou1wug _tzy4idpf _ju251onc",
                                                    mobileClass
                                                ]),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                    className: (0, $2jatx.default)([
                                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pbykb7n",
                                                        "body-md"
                                                    ]),
                                                    children: bannerInfo.mobileTextThirdScreen
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                        bgColor: bgLinkColor,
                                        text: bannerInfo.linkText,
                                        "aria-label": bannerInfo.linkText,
                                        href: bannerInfo.linkUrl,
                                        type: "primary",
                                        dataEventProps: bannerInfo.dataEventProps
                                    })
                                ]
                            })
                        ]
                    })
                }),
                bannerInfo.bannerType !== 'lifted' && /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                    className: (0, $2jatx.default)([
                        "_19itidpf _r06hglyw _bfhk1j28 _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw _1pbykb7n _rjxpidpf _19pk7vkz _2hwx7vkz _otyr7vkz _18u07vkz",
                        `close-button-symbol`
                    ]),
                    "data-testid": "close-button",
                    "aria-label": "Close",
                    onClick: ()=>{
                        setIsHidden(true);
                        (0, $2gCne.setLocalStorage)(bannerStorageItem, '1');
                    },
                    ...closeIconDataEventProps,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dE0sS.Cross), {
                        size: "24"
                    })
                })
            ]
        })
    });
};
const $41ab4e6d9e0b9eaf$var$scrollUpTwoScreens = null;
const $41ab4e6d9e0b9eaf$var$scrollUpThreeScreens = null;
const $41ab4e6d9e0b9eaf$var$desktopContainerStyles = null;
const $41ab4e6d9e0b9eaf$var$mobileContainerStyles = null;
const $41ab4e6d9e0b9eaf$var$desktopLogoStyles = null;
const $41ab4e6d9e0b9eaf$var$marqueeContainerStyles = null;
const $41ab4e6d9e0b9eaf$var$marqueeItemStyle = null;
const $41ab4e6d9e0b9eaf$var$marqueeItem1Styles = null;
const $41ab4e6d9e0b9eaf$var$marqueeItem2Styles = null;
const $41ab4e6d9e0b9eaf$var$marqueeItem3Styles = null;
const $41ab4e6d9e0b9eaf$var$containerStyles = null;
const $41ab4e6d9e0b9eaf$var$contentStyles = null;
const $41ab4e6d9e0b9eaf$var$pStyle = null;
const $41ab4e6d9e0b9eaf$var$lineStyle = null;
const $41ab4e6d9e0b9eaf$var$closeStyles = null;

});

parcelRegister("eXdK6", function(module, exports) {
$parcel$export(module.exports, "FlareSvg", function () { return $7baa2276e93da712$export$7b83271ab79d7cd2; });

var $7VQPk = parcelRequire("7VQPk");

var $hnmMQ = parcelRequire("hnmMQ");
const $7baa2276e93da712$export$7b83271ab79d7cd2 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8ra1mh2pbsd5j7i3kc5rdw2h5815w1i1.svg',
            alt: '',
            width: 77,
            height: 81
        }
    });

});



parcelRegister("3sDDl", function(module, exports) {
$parcel$export(module.exports, "ConfluencePagePaidLpConflAnchor", function () { return $7e46c16dbeed31a5$export$66f40902ad8b3dc6; });
/* eslint-disable complexity */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $gHIMV = parcelRequire("gHIMV");

var $8e22h = parcelRequire("8e22h");

var $a8Jhy = parcelRequire("a8Jhy");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $leg8m = parcelRequire("leg8m");

var $kZQhV = parcelRequire("kZQhV");

var $28AH4 = parcelRequire("28AH4");

var $cqCPq = parcelRequire("cqCPq");

var $ik40B = parcelRequire("ik40B");
const $7e46c16dbeed31a5$var$LANDING_TYPE = 'confluence-rebranded-anchor';
const $7e46c16dbeed31a5$export$66f40902ad8b3dc6 = ({ anchorContents: anchorContents, persona: persona, teamType: teamType, pageId: pageId, pageVariant: pageVariant, animatedJiraTourProps: animatedJiraTourProps, dataProductKey: dataProductKey, carouselHeroProps: carouselHeroProps, keyword: keyword, subAnchor: subAnchor, customHeroSection: customHeroSection, customTabsProps: customTabsProps })=>{
    const intl = (0, $8e22h.default)();
    const productHref = (0, $jQ0cd.useLocalizedHref)('/software/confluence');
    const [content, setContent] = (0, $1oC0p.useState)(undefined);
    const { setAnchorLocalStorage: setAnchorLocalStorage } = (0, $28AH4.useAnchorLocalStorage)();
    (0, $1oC0p.useEffect)(()=>{
        const anchorLocalStorageData = {
            persona: persona,
            team: '',
            teamTypeInferredMl: teamType
        };
        if (!!keyword) anchorLocalStorageData.keyword = keyword;
        if (!!subAnchor) anchorLocalStorageData.subAnchor = subAnchor;
        setAnchorLocalStorage(anchorLocalStorageData);
        setContent(anchorContents);
    // We only want to run this useEffect once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!content) // TODO: loading UI for static renders
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {});
    const props = {
        hideNavigationBar: false,
        landingType: $7e46c16dbeed31a5$var$LANDING_TYPE,
        pageId: pageId,
        animatedJiraTourProps: animatedJiraTourProps,
        showHorizontalRule: false,
        productNavProps: {
            productHref: productHref,
            productName: 'confluence',
            ariaLabel: intl.formatMessage({
                id: 'wacConfluenceNavigation.logo-label',
                defaultMessage: 'Confluence logo'
            }),
            dataProductKey: 'confluence',
            showFreeHrefButton: false
        },
        heroProps: $7e46c16dbeed31a5$var$getHeroProps({
            resp: content,
            pageVariant: pageVariant,
            keyword: keyword,
            subAnchor: subAnchor
        }),
        carouselHeroProps: carouselHeroProps,
        tabsProps: customTabsProps || $7e46c16dbeed31a5$var$getTabProps(content, dataProductKey, pageVariant, keyword, subAnchor),
        ctaWithPolyGonProps: $7e46c16dbeed31a5$var$getCtaWithPolygonProps(content, pageId, dataProductKey),
        testimonialProps: $7e46c16dbeed31a5$var$getTestimonialProps(content),
        alternatingTextAndImageProps: $7e46c16dbeed31a5$var$getAlternatingTextAndImageProps(content),
        resultSectionDivider: {
            color: (0, $kbpa7.wacToken)('color.neutral.light100'),
            variation: (0, $a8Jhy.SECTION_DIVIDER_VARIATION).NORMAL
        },
        hasRebrandedSignupFormStyles: true,
        heroBgColor: 'bgWhite',
        customHeroSection: customHeroSection
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kZQhV.PaidLandingTemplate), {
        ...props
    });
};
const $7e46c16dbeed31a5$var$heroFeatureMatrix = {
    engineering: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: false,
        showStaticImage: true,
        showScribble: false,
        showEyeLash: false,
        showFourSocialButtons: false
    },
    featuresCerebro: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: false,
        showStaticImage: true,
        showScribble: false,
        showEyeLash: false,
        showFourSocialButtons: false
    },
    keywords: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: false,
        showStaticImage: true,
        showScribble: true,
        showEyeLash: true,
        showFourSocialButtons: false
    },
    subAnchor: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: false,
        showStaticImage: true,
        showScribble: true,
        showEyeLash: true,
        showFourSocialButtons: false
    },
    marketing: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: false,
        showStaticImage: true,
        showScribble: false,
        showEyeLash: false,
        showFourSocialButtons: false
    },
    brandUpdate: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: false,
        showStaticImage: false,
        showScribble: true,
        showEyeLash: true,
        showFourSocialButtons: true
    }
};
const $7e46c16dbeed31a5$var$getHeroFeatures = (pageVariant)=>{
    const defaultFeatures = {
        useNewHero: false,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: false,
        showStaticImage: false,
        showScribble: false,
        showEyeLash: false,
        showFourSocialButtons: false
    };
    return $7e46c16dbeed31a5$var$heroFeatureMatrix[pageVariant] || defaultFeatures;
};
const $7e46c16dbeed31a5$var$getAnimation = ({ pageVariant: pageVariant, keyword: keyword, subAnchor: subAnchor })=>{
    if (pageVariant === 'keywords') return (0, $cqCPq.getAnimationByKeyword)(keyword?.trim() || '');
    else if (pageVariant === 'subAnchor') return (0, $ik40B.getAnimationBySubAnchor)(subAnchor?.trim() || '');
    return undefined;
};
const $7e46c16dbeed31a5$var$getHeroProps = ({ resp: resp, pageVariant: pageVariant, keyword: keyword, subAnchor: subAnchor })=>{
    const defaultProps = {
        theme: 'dark-on-light',
        headerText: '',
        secondaryText: '',
        signup: {
            bundle: 'confluence',
            edition: 'free',
            featureFlags: {
                enableDefaultExpandedEmail: false,
                enableDeferredFullName: true
            }
        }
    };
    if (!resp || !resp[0]) return defaultProps;
    const { headline: headline } = resp[0].node;
    const data = headline && headline[0] ? headline[0] : null;
    const planBenefits = data?.planBenefits && data?.planBenefits[0] ? data?.planBenefits[0] : null;
    const supportingAsset = planBenefits?.supportingAsset;
    const features = $7e46c16dbeed31a5$var$getHeroFeatures(pageVariant);
    const getImage = (url, description)=>url && description ? {
            src: url ? url : '',
            alt: description || ''
        } : undefined;
    const getFeaturesRawHtml = ()=>planBenefits && planBenefits.planFeatures && planBenefits.planFeatures[0] ? planBenefits.planFeatures[0].description || '' : '';
    const animation = $7e46c16dbeed31a5$var$getAnimation({
        pageVariant: pageVariant,
        keyword: keyword,
        subAnchor: subAnchor
    });
    return {
        ...defaultProps,
        ...features,
        headerText: data?.name || '',
        secondaryText: data?.subheading || '',
        image: getImage(supportingAsset?.url, supportingAsset?.description),
        featuresRawHtml: getFeaturesRawHtml(),
        tertiaryText: planBenefits?.description || '',
        animation: animation
    };
};
const $7e46c16dbeed31a5$var$getTabProps = (resp, dataProductKey, pageVariant, keyword, subAnchor)=>{
    const defaultProps = {
        dataProductKey: dataProductKey,
        headerText: '',
        tabStyles: {
            defaultBG: (0, $kbpa7.wacToken)('color.neutral.light200'),
            // eslint-disable-next-line local/ensure-wac-token-usage
            defaultText: '#172B4D',
            hoverBG: (0, $kbpa7.wacToken)('color.neutral.light200'),
            // eslint-disable-next-line local/ensure-wac-token-usage
            hoverText: '#172B4D',
            activeBG: (0, $kbpa7.wacToken)('color.extended.blue100'),
            // eslint-disable-next-line local/ensure-wac-token-usage
            activeText: '#172B4D'
        },
        styles: {
            '--lp-tabs-hover': '#0C66E4',
            '--lp-tabs-unselected': '#172B4D'
        },
        tabs: undefined
    };
    if (!resp || !resp[0]) return defaultProps;
    const tabs = $7e46c16dbeed31a5$var$getTabs(resp, pageVariant, keyword, subAnchor);
    const primaryMessage = $7e46c16dbeed31a5$var$getPrimaryMessage(resp);
    return {
        ...defaultProps,
        landingType: $7e46c16dbeed31a5$var$LANDING_TYPE,
        headerText: primaryMessage?.name || '',
        tabs: tabs
    };
};
const $7e46c16dbeed31a5$var$getCtaWithPolygonProps = (resp, pageId, dataProductKey)=>{
    const cta = $7e46c16dbeed31a5$var$getCta(resp);
    return {
        header: cta?.valueProposition || '',
        ctaText: cta?.text || '',
        ctaUrl: cta?.url || '',
        ctaLabel: pageId,
        backgroundColor: (0, $kbpa7.wacToken)('color.extended.blue700'),
        productKey: dataProductKey,
        buttonVariant: 'primary',
        buttonColor: 'yellow'
    };
};
const $7e46c16dbeed31a5$var$getTestimonialProps = (resp)=>{
    if (!resp || !resp[0]) return undefined;
    const { socialProof: socialProof } = resp[0].node;
    const data = socialProof && socialProof[0] ? socialProof[0] : null;
    if (!data) return undefined;
    return {
        headerText: data?.name,
        logos: data?.customers?.map((customer)=>{
            return {
                src: customer && customer.altDarkLogo && customer?.altDarkLogo[0] && customer?.altDarkLogo[0].url ? customer?.altDarkLogo[0].url : '',
                alt: customer && customer.altDarkLogo && customer?.altDarkLogo[0] && customer?.altDarkLogo[0].description ? customer?.altDarkLogo[0].description : '',
                lazy: true
            };
        })
    };
};
const $7e46c16dbeed31a5$var$getAlternatingTextAndImageProps = (resp)=>{
    const results = $7e46c16dbeed31a5$var$getResults(resp);
    function generateProps(result, index) {
        // this shouldn't go past
        const countMap = [
            'one',
            'two',
            'three',
            'four'
        ];
        const count = (0, (/*@__PURE__*/$parcel$interopDefault($gHIMV)))(`${countMap[index]}`);
        const position = index % 2 === 1 ? 'left' : 'right';
        return {
            backgroundColor: (0, $kbpa7.wacToken)('color.neutral.light100'),
            [`row${count}Header`]: result?.name || '',
            [`row${count}Lozenge`]: result?.lozenge || '',
            [`row${count}Body`]: result?.subheading || '',
            [`row${count}ImageLink`]: result?.asset?.url,
            [`row${count}ImageAltText`]: result?.asset?.description || '',
            [`row${count}ImagePosition`]: position
        };
    }
    const contentBlocks = results?.map((result, index)=>generateProps(result, index)).slice(0, 4) // ensure max of 4 results so we don't break the pattern
    .filter((result)=>!!result).reduce((acc, curr)=>{
        return {
            ...acc,
            ...curr
        };
    });
    return {
        imageWidth: '100%',
        imageTextSideRowOnePaddingBelowLargeScreen: '32px 0 16px',
        imageTextSideRowTwoPadding: '16px 0',
        imageTextSideRowThreePaddingBelowLargeScreen: '16px 0 32px',
        ...contentBlocks
    };
};
const $7e46c16dbeed31a5$var$getPrimaryMessage = (resp)=>{
    if (!resp || !resp[0]) return null;
    const { primaryMessage: primaryMessage } = resp[0].node;
    const data = primaryMessage && primaryMessage[0] ? primaryMessage[0] : null;
    return data;
};
const $7e46c16dbeed31a5$var$getTabs = (resp, pageVariant, keyword, subAnchor)=>{
    const primaryMessage = $7e46c16dbeed31a5$var$getPrimaryMessage(resp);
    if (!primaryMessage || !primaryMessage?.supportingExample) return undefined;
    if (pageVariant === 'keywords') return primaryMessage.supportingExample.filter((tab)=>tab !== null).map((tab)=>({
            textLabel: '',
            id: '',
            component: (0, $cqCPq.generateTabComponent)(keyword, {
                title: primaryMessage?.name || '',
                description: tab?.name || '',
                content: tab?.proofpoint || ''
            })
        }));
    if (pageVariant === 'subAnchor') return primaryMessage.supportingExample.filter((tab)=>tab !== null).map((tab)=>({
            textLabel: '',
            id: '',
            component: (0, $ik40B.generateTabComponentSubAnchor)(subAnchor, {
                title: primaryMessage?.name || '',
                description: tab?.name || '',
                content: tab?.proofpoint || ''
            })
        }));
    return primaryMessage.supportingExample.filter((tab)=>tab !== null).map((tab)=>{
        const supportingAsset = tab?.supportingAsset;
        const advocateQuote = tab?.advocateQuote;
        return {
            textLabel: tab?.name || '',
            id: tab?.name || '',
            component: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $leg8m.default), {
                isShowTestimonyBorder: false,
                isIncludeTestimony: !!tab?.advocateQuote,
                testimonyIsUsingTextQuotationMarks: true,
                title: tab?.heading || '',
                rawHtmlContent: tab?.proofpoint || '',
                imageSrc: supportingAsset?.url || '',
                imageAlt: supportingAsset?.description || '',
                quoteBlurb: advocateQuote?.advocateQuote || '',
                quoteName: advocateQuote?.advocateName || '',
                quoteCompany: advocateQuote?.advocateJobTitle || '',
                testimonyImageSrc: advocateQuote?.advocateHeadshot?.url || '',
                testimonyImageAlt: advocateQuote?.advocateHeadshot?.description || ''
            }, tab?.name)
        };
    });
};
const $7e46c16dbeed31a5$var$getResults = (resp)=>{
    if (!resp || !resp[0]) return null;
    const { results: results } = resp[0].node;
    const data = results && results.length ? results : null;
    return data;
};
const $7e46c16dbeed31a5$var$getCta = (resp)=>{
    if (!resp || !resp[0]) return null;
    const { callToAction: callToAction } = resp[0].node;
    const data = callToAction && callToAction[0] ? callToAction[0] : null;
    return data;
};

});
parcelRegister("gHIMV", function(module, exports) {

var $24uwp = parcelRequire("24uwp");

var $7RbbL = parcelRequire("7RbbL");
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $c2936778f0bf11fd$var$capitalize(string) {
    return $7RbbL($24uwp(string).toLowerCase());
}
module.exports = $c2936778f0bf11fd$var$capitalize;

});
parcelRegister("7RbbL", function(module, exports) {

var $iBcGo = parcelRequire("iBcGo");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $5b86297e1fc1db25$var$upperFirst = $iBcGo('toUpperCase');
module.exports = $5b86297e1fc1db25$var$upperFirst;

});
parcelRegister("iBcGo", function(module, exports) {

var $ehULU = parcelRequire("ehULU");

var $ePM67 = parcelRequire("ePM67");

var $1GITV = parcelRequire("1GITV");

var $24uwp = parcelRequire("24uwp");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $d8a585375440fb5a$var$createCaseFirst(methodName) {
    return function(string) {
        string = $24uwp(string);
        var strSymbols = $ePM67(string) ? $1GITV(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $ehULU(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
module.exports = $d8a585375440fb5a$var$createCaseFirst;

});
parcelRegister("ehULU", function(module, exports) {

var $ezuzU = parcelRequire("ezuzU");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $a66eb0e6cce6b4e5$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $ezuzU(array, start, end);
}
module.exports = $a66eb0e6cce6b4e5$var$castSlice;

});
parcelRegister("ezuzU", function(module, exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $a9bc0dc53628b88a$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = $a9bc0dc53628b88a$var$baseSlice;

});


parcelRegister("ePM67", function(module, exports) {
/** Used to compose unicode character classes. */ var $accb234eacd9a37f$var$rsAstralRange = '\\ud800-\\udfff', $accb234eacd9a37f$var$rsComboMarksRange = '\\u0300-\\u036f', $accb234eacd9a37f$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $accb234eacd9a37f$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $accb234eacd9a37f$var$rsComboRange = $accb234eacd9a37f$var$rsComboMarksRange + $accb234eacd9a37f$var$reComboHalfMarksRange + $accb234eacd9a37f$var$rsComboSymbolsRange, $accb234eacd9a37f$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $accb234eacd9a37f$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $accb234eacd9a37f$var$reHasUnicode = RegExp('[' + $accb234eacd9a37f$var$rsZWJ + $accb234eacd9a37f$var$rsAstralRange + $accb234eacd9a37f$var$rsComboRange + $accb234eacd9a37f$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $accb234eacd9a37f$var$hasUnicode(string) {
    return $accb234eacd9a37f$var$reHasUnicode.test(string);
}
module.exports = $accb234eacd9a37f$var$hasUnicode;

});

parcelRegister("1GITV", function(module, exports) {

var $3VH6A = parcelRequire("3VH6A");

var $ePM67 = parcelRequire("ePM67");

var $aYfG6 = parcelRequire("aYfG6");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $13ac8b161df780fb$var$stringToArray(string) {
    return $ePM67(string) ? $aYfG6(string) : $3VH6A(string);
}
module.exports = $13ac8b161df780fb$var$stringToArray;

});
parcelRegister("3VH6A", function(module, exports) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $2dc821c7632c8518$var$asciiToArray(string) {
    return string.split('');
}
module.exports = $2dc821c7632c8518$var$asciiToArray;

});

parcelRegister("aYfG6", function(module, exports) {
/** Used to compose unicode character classes. */ var $7fcbab4f0bbb188c$var$rsAstralRange = '\\ud800-\\udfff', $7fcbab4f0bbb188c$var$rsComboMarksRange = '\\u0300-\\u036f', $7fcbab4f0bbb188c$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $7fcbab4f0bbb188c$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $7fcbab4f0bbb188c$var$rsComboRange = $7fcbab4f0bbb188c$var$rsComboMarksRange + $7fcbab4f0bbb188c$var$reComboHalfMarksRange + $7fcbab4f0bbb188c$var$rsComboSymbolsRange, $7fcbab4f0bbb188c$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $7fcbab4f0bbb188c$var$rsAstral = '[' + $7fcbab4f0bbb188c$var$rsAstralRange + ']', $7fcbab4f0bbb188c$var$rsCombo = '[' + $7fcbab4f0bbb188c$var$rsComboRange + ']', $7fcbab4f0bbb188c$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $7fcbab4f0bbb188c$var$rsModifier = '(?:' + $7fcbab4f0bbb188c$var$rsCombo + '|' + $7fcbab4f0bbb188c$var$rsFitz + ')', $7fcbab4f0bbb188c$var$rsNonAstral = '[^' + $7fcbab4f0bbb188c$var$rsAstralRange + ']', $7fcbab4f0bbb188c$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $7fcbab4f0bbb188c$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $7fcbab4f0bbb188c$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $7fcbab4f0bbb188c$var$reOptMod = $7fcbab4f0bbb188c$var$rsModifier + '?', $7fcbab4f0bbb188c$var$rsOptVar = '[' + $7fcbab4f0bbb188c$var$rsVarRange + ']?', $7fcbab4f0bbb188c$var$rsOptJoin = '(?:' + $7fcbab4f0bbb188c$var$rsZWJ + '(?:' + [
    $7fcbab4f0bbb188c$var$rsNonAstral,
    $7fcbab4f0bbb188c$var$rsRegional,
    $7fcbab4f0bbb188c$var$rsSurrPair
].join('|') + ')' + $7fcbab4f0bbb188c$var$rsOptVar + $7fcbab4f0bbb188c$var$reOptMod + ')*', $7fcbab4f0bbb188c$var$rsSeq = $7fcbab4f0bbb188c$var$rsOptVar + $7fcbab4f0bbb188c$var$reOptMod + $7fcbab4f0bbb188c$var$rsOptJoin, $7fcbab4f0bbb188c$var$rsSymbol = '(?:' + [
    $7fcbab4f0bbb188c$var$rsNonAstral + $7fcbab4f0bbb188c$var$rsCombo + '?',
    $7fcbab4f0bbb188c$var$rsCombo,
    $7fcbab4f0bbb188c$var$rsRegional,
    $7fcbab4f0bbb188c$var$rsSurrPair,
    $7fcbab4f0bbb188c$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $7fcbab4f0bbb188c$var$reUnicode = RegExp($7fcbab4f0bbb188c$var$rsFitz + '(?=' + $7fcbab4f0bbb188c$var$rsFitz + ')|' + $7fcbab4f0bbb188c$var$rsSymbol + $7fcbab4f0bbb188c$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $7fcbab4f0bbb188c$var$unicodeToArray(string) {
    return string.match($7fcbab4f0bbb188c$var$reUnicode) || [];
}
module.exports = $7fcbab4f0bbb188c$var$unicodeToArray;

});





parcelRegister("a8Jhy", function(module, exports) {
$parcel$export(module.exports, "SECTION_DIVIDER_VARIATION", function () { return $15488782d37e40da$export$89ad02e8b5e6fb05; });
$parcel$export(module.exports, "Adg4SectionDivider", function () { return $15488782d37e40da$export$2446497a3d298a13; });
/* section-divider.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
var $15488782d37e40da$export$89ad02e8b5e6fb05 = /*#__PURE__*/ function(SECTION_DIVIDER_VARIATION) {
    SECTION_DIVIDER_VARIATION["NORMAL"] = "normal";
    SECTION_DIVIDER_VARIATION["REVERSE"] = "reverse";
    SECTION_DIVIDER_VARIATION["FLIP"] = "flip";
    SECTION_DIVIDER_VARIATION["REVERSE_FLIP"] = "reverse-flip";
    return SECTION_DIVIDER_VARIATION;
}({});
const $15488782d37e40da$export$2446497a3d298a13 = ({ bgColor: bgColor = '#1868DB', colorAgainst: colorAgainst = '#FFF', desktopHeight: desktopHeight = 120, tabletHeight: tabletHeight = 80, mobileHeight: mobileHeight = 60, variation: variation })=>{
    const sectionDividerStyles = null;
    const colorBehindDividerStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_bfhk1tls"
        ]),
        style: {
            "--_1gwlqo7": (0, $6ZVlx.default)(colorAgainst)
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_mkrzsrs8 _11q7bs0x _4t3iepwt _1vkh1mjl _tnruenus",
                variation === "reverse" && "_mkrz1fra",
                variation === "flip" && "_mkrz1n6g",
                variation === "reverse-flip" && "_mkrz1vud"
            ]),
            style: {
                "--_1w9snyi": (0, $6ZVlx.default)(bgColor),
                "--_qqqbix": (0, $6ZVlx.default)(desktopHeight, "px"),
                "--_1ly4yra": (0, $6ZVlx.default)(tabletHeight, "px"),
                "--_klg1fm": (0, $6ZVlx.default)(mobileHeight, "px")
            }
        })
    });
};

});

parcelRegister("leg8m", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4722f7927f6b8e0d$export$2e2bcd8739ae039; });
/* image-checklist-side.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $a0utR = parcelRequire("a0utR");

var $i5Yp0 = parcelRequire("i5Yp0");

var $kQNvM = parcelRequire("kQNvM");

var $hnmMQ = parcelRequire("hnmMQ");

var $1rGpC = parcelRequire("1rGpC");
// ================================================
// CSS
// ================================================
const $4722f7927f6b8e0d$var$checklistWithNoPullQuoteStyle = null;
const $4722f7927f6b8e0d$var$titleStyles = null;
// ================================================
// Rendering Functions
// ================================================
const $4722f7927f6b8e0d$var$HorizontalRuleMobile = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
        layout: "12",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1e0cglyw _7n83ssan _suga1ule"
            ])
        })
    });
const $4722f7927f6b8e0d$var$ChecklistWithImage = ({ title: title, listItems: listItems, rawHtmlContent: rawHtmlContent, imageSrc: imageSrc, imageAlt: imageAlt, isIncludeTestimony: isIncludeTestimony = false, quoteBlurb: quoteBlurb, quoteName: quoteName, quoteCompany: quoteCompany, testimonyImageSrc: testimonyImageSrc, testimonyImageAlt: testimonyImageAlt, isShowTestimonyBorder: isShowTestimonyBorder = true, testimonyIsUsingTextQuotationMarks: testimonyIsUsingTextQuotationMarks = false, isSmallQuote: isSmallQuote = false, isIncludeHorizontalMobileRule: isIncludeHorizontalMobileRule = true })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        className: (0, $2jatx.default)([
            !isIncludeTestimony && "_xlt1zwfg"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1rGpC.Row), {
                layout: "4-8",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                className: (0, $2jatx.default)([
                                    "_1pfhidpf _k48pbfng _syaz1bqd _1dyzidpf _1gw8ahaf"
                                ]),
                                children: title
                            }),
                            listItems && listItems.length && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kQNvM.default), {
                                listItems: listItems
                            }),
                            rawHtmlContent && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: "tab-content",
                                dangerouslySetInnerHTML: {
                                    __html: (0, (/*@__PURE__*/$parcel$interopDefault($a0utR)))(rawHtmlContent)
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Image), {
                            src: imageSrc,
                            alt: imageAlt
                        })
                    })
                ]
            }),
            isIncludeTestimony && isIncludeHorizontalMobileRule && /*#__PURE__*/ (0, $7VQPk.jsx)($4722f7927f6b8e0d$var$HorizontalRuleMobile, {}),
            isIncludeTestimony && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    isSmallQuote ? "_1q511wqb" : "_1q517vkz"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $i5Yp0.PullQuote), {
                    logoSrc: testimonyImageSrc,
                    logoAltText: testimonyImageAlt,
                    quoteBlurb: quoteBlurb || '',
                    quoteCompany: quoteCompany || '',
                    quoteName: quoteName || '',
                    isShowBorder: isShowTestimonyBorder,
                    isUsingTextQuotationMarks: testimonyIsUsingTextQuotationMarks,
                    isSmall: isSmallQuote
                })
            })
        ]
    });
};
var $4722f7927f6b8e0d$export$2e2bcd8739ae039 = $4722f7927f6b8e0d$var$ChecklistWithImage;

});
parcelRegister("i5Yp0", function(module, exports) {
$parcel$export(module.exports, "PullQuote", function () { return $49cc36364de70f98$export$f32a6ca59ed1d5d5; });
/* pull-quote.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $hnmMQ = parcelRequire("hnmMQ");

var $1rGpC = parcelRequire("1rGpC");
const $49cc36364de70f98$var$pullQuoteCss = null;
const $49cc36364de70f98$var$borderCss = null;
const $49cc36364de70f98$var$smallBorderCss = null;
const $49cc36364de70f98$var$smallWidthCss = null;
const $49cc36364de70f98$var$quoteCss = null;
const $49cc36364de70f98$var$quotationMarkStyle = {
    height: '24px'
};
const $49cc36364de70f98$var$quoteBlurbCss = null;
const $49cc36364de70f98$var$nameAndCompanyContainerCss = null;
const $49cc36364de70f98$var$quoteNameCss = null;
const $49cc36364de70f98$var$smallQuoteNameCss = null;
const $49cc36364de70f98$var$quoteCompanyCss = null;
const $49cc36364de70f98$var$smallQuoteCompanyCss = null;
const $49cc36364de70f98$var$pullQuoteImgContainerCss = null;
const $49cc36364de70f98$var$pullQuoteImgCss = null;
const $49cc36364de70f98$export$f32a6ca59ed1d5d5 = ({ logoSrc: logoSrc, logoAltText: logoAltText, quoteBlurb: quoteBlurb, quoteName: quoteName, quoteCompany: quoteCompany, isShowBorder: isShowBorder = false, isUsingTextQuotationMarks: isUsingTextQuotationMarks = false, isSmall: isSmall = false })=>{
    const isShowQuoteLogo = !!logoSrc;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
        layout: "10",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1q51zwfg _85i5zwfg _1e0c1txw _2lx21bp4 _1bah1yb4 _16ng1h6o _ae4v1h6o _1lp7vrvc",
                isShowBorder && !isSmall && "_mqm2136u _179r136u",
                isShowBorder && isSmall && "_mqm21bu1 _179r1bu1",
                isSmall && "_1bsb12it _10fp1h6o"
            ]),
            children: [
                isShowQuoteLogo && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_y3gn1h6o _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1e0c1txw _4cvr1h6o _1bah1h6o _6rthzwfg _12l2idpf _1ob9idpf _1lvazwfg"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                        src: logoSrc || '',
                        alt: logoAltText || '',
                        className: (0, $2jatx.default)([
                            "_5ralzm06 _4t3iuuw1 _1bsb1osq _1xlo1osq _14b5mgvx _glte1wdt"
                        ])
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_y3gn1e5h"
                    ]),
                    children: [
                        !isUsingTextQuotationMarks && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                            style: $49cc36364de70f98$var$quotationMarkStyle,
                            image: {
                                src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/41knb7g4sf3cg6sj54o2uubv0r3r3n33.svg',
                                alt: 'Quotation mark'
                            }
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _2lx21bp4 _4t3i1w8u _1bah1yb4"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                    className: (0, $2jatx.default)([
                                        isSmall ? "_syazl4fm" : "_1wybgktf _vwz41f4h _k48pb4wl _1s181f4h _17gq1ylp",
                                        isSmall ? 'body-sm' : ''
                                    ]),
                                    children: [
                                        isUsingTextQuotationMarks ? "\u201C" : '',
                                        quoteBlurb,
                                        "\u201D"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                            className: (0, $2jatx.default)([
                                                isSmall ? "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48p9y44 _1wyb1crf _vwz4qslr _1p1dangw" : "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48p8n31 _1wyb7vkz _vwz41tcg"
                                            ]),
                                            children: quoteName
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                            className: (0, $2jatx.default)([
                                                isSmall ? "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48p1nn1 _1wyb1crf _vwz4qslr _1p1dangw" : "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wyb7vkz _vwz41tcg"
                                            ]),
                                            children: quoteCompany
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});

parcelRegister("kQNvM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b8763b42cfbf25b2$export$2e2bcd8739ae039; });
/* checklist.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $OKl9V = parcelRequire("OKl9V");
const $b8763b42cfbf25b2$var$listItemStyles = null;
const $b8763b42cfbf25b2$var$Checklist = ({ listItems: listItems })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
        className: (0, $2jatx.default)([
            "_qtt8glyw _lswu1mzw _19bvgktf _19pkidpf _1mswidpf _53os1tcg _f0hdh2mm _2ts0glyw _138k1fm0 _1u82o7ao _s22yzwfg _59281o8l _rus87vkz _1vhestnw _mz937vkz _f1xm7vkz _oonc1y44 _13421l7b _3p611o8l _4fnt7vkz _1exr7vkz _ivf7r3uz _1v9r1j6v _1mmx1k8s"
        ]),
        children: listItems.map((listItem, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $OKl9V.Icon), {
                        name: "checkmarkbasic",
                        color: "#6554c0",
                        size: "xs"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        children: listItem
                    })
                ]
            }, index))
    });
};
var $b8763b42cfbf25b2$export$2e2bcd8739ae039 = $b8763b42cfbf25b2$var$Checklist;

});


parcelRegister("kZQhV", function(module, exports) {
$parcel$export(module.exports, "PaidLandingTemplate", function () { return $e49e6c38dcb8d4a0$export$b9ca3a4496ce259; });
/* paid-landing.template.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable complexity */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("1oC0p");

var $a8Jhy = parcelRequire("a8Jhy");

var $jVACb = parcelRequire("jVACb");

var $9D78w = parcelRequire("9D78w");

var $kbpa7 = parcelRequire("kbpa7");

var $1rGpC = parcelRequire("1rGpC");

var $4Jdkw = parcelRequire("4Jdkw");

var $iLjCW = parcelRequire("iLjCW");

var $loOqH = parcelRequire("loOqH");

var $50aZ0 = parcelRequire("50aZ0");

var $3riD8 = parcelRequire("3riD8");

var $5S2vX = parcelRequire("5S2vX");

var $icTHu = parcelRequire("icTHu");

var $5IbWH = parcelRequire("5IbWH");

var $gQSoJ = parcelRequire("gQSoJ");

var $1SFKa = parcelRequire("1SFKa");

var $hbUAT = parcelRequire("hbUAT");

var $cqYjz = parcelRequire("cqYjz");

var $cf7Ff = parcelRequire("cf7Ff");
const $e49e6c38dcb8d4a0$export$841e9c95e6429474 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
        layout: "12",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_179r1pzq"
            ]),
            style: {
                "--_qtmnbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light300'))
            }
        })
    });
const $e49e6c38dcb8d4a0$export$b9ca3a4496ce259 = ({ landingType: landingType, pageId: pageId, showHorizontalRule: showHorizontalRule, productNavProps: productNavProps, bannerAlertProps: bannerAlertProps, heroProps: heroProps, bannerProps: bannerProps, tabsProps: tabsProps, customSection: customSection, customHeroSection: customHeroSection, carouselHeroProps: carouselHeroProps, alternatingTextAndImageProps: alternatingTextAndImageProps, ctaProps: ctaProps, ctaWithPolyGonProps: ctaWithPolyGonProps, testimonialProps: testimonialProps, animatedJiraTourProps: animatedJiraTourProps, hideNavigationBar: hideNavigationBar, heroImageSubheader: heroImageSubheader, resultSectionDivider: resultSectionDivider, hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles, heroBgColor: heroBgColor = 'bgWhite', auxiaResponse: auxiaResponse })=>{
    const { isUserLoggedIn: isUserLoggedIn } = (0, $3riD8.useLoggedInUser)();
    // Temporary solution to show animated hero only for logged out users on anchor pages
    // This can be removed once we implement a way to configure this via CMS
    const showAnimatedHero = !isUserLoggedIn && (pageId === 'paid-lp-jsw-features' || !!heroProps.useNewHero);
    const showStaticTestimonials = !heroProps.animatedSocialBanner;
    const hasBannerAlert = bannerAlertProps ? true : false;
    const defaultPaidArgs = {
        ...heroProps,
        animatedJiraTourProps: animatedJiraTourProps,
        subheader: heroProps.secondaryText,
        header: heroProps.headerText,
        hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles,
        heroImageSubheader: heroImageSubheader,
        carouselHeroProps: carouselHeroProps,
        hasBannerAlert: hasBannerAlert,
        heroBgColor: heroBgColor,
        auxiaResponse: auxiaResponse,
        pageId: pageId
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("main", {
        id: "content",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
            pageId: pageId,
            scrollTrackingEnabled: pageId ? true : false,
            children: [
                !hideNavigationBar && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9D78w.ProductNavBar), {
                    ...productNavProps
                }),
                bannerAlertProps && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jVACb.BannerAlert), {
                    ...bannerAlertProps,
                    hasProductNavBar: !hideNavigationBar
                }),
                customHeroSection ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gQSoJ.PaidCustomHeroSection), {
                    customHeroSection: customHeroSection
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cqYjz.PaidHeroSectionTypes), {
                    darkSolidTheme: heroProps.darkSolidTheme,
                    landingType: landingType,
                    heroComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hbUAT.PaidHeroSectionTemplate), {
                        ...defaultPaidArgs
                    }),
                    showAnimatedHero: showAnimatedHero,
                    showNewHero: defaultPaidArgs.useNewHero
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cf7Ff.PaidTabsSection), {
                    ...tabsProps
                }),
                customSection && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1SFKa.PaidCustomSection), {
                    customSection: customSection
                }),
                showHorizontalRule && /*#__PURE__*/ (0, $7VQPk.jsx)($e49e6c38dcb8d4a0$export$841e9c95e6429474, {}),
                bannerProps && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $50aZ0.SimpleImageTextSide), {
                    ...bannerProps
                }),
                resultSectionDivider && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_6rth1cg9"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a8Jhy.Adg4SectionDivider), {
                        bgColor: resultSectionDivider.color,
                        variation: resultSectionDivider.variation
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $icTHu.PaidAlternatingImageText), {
                    landingType: landingType,
                    alternatingImageTextProps: alternatingTextAndImageProps
                }),
                ctaProps && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5IbWH.PaidCtaSection), {
                    ctaProps: ctaProps,
                    landingType: landingType
                }),
                ctaWithPolyGonProps && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                resultSectionDivider && "_bfhkyt3g _1pfh1cg9 _4t3iuuw1"
                            ]),
                            style: {
                                "--_1he1i5": (0, $6ZVlx.default)(resultSectionDivider?.color)
                            }
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                resultSectionDivider && "_1pfh1snh"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4Jdkw.ADG4CtaWithPolygonBackground), {
                                ...ctaWithPolyGonProps
                            })
                        })
                    ]
                }),
                showStaticTestimonials && testimonialProps && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $loOqH.PaidSocialProof), {
                    ...testimonialProps
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iLjCW.GlobalFooter), {})
            ]
        })
    });
};

});
parcelRegister("jVACb", function(module, exports) {
$parcel$export(module.exports, "BannerAlert", function () { return $8326461e03189c88$export$4eb8f3e4e539379b; });
/* banner-alert.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $iPPTB = parcelRequire("iPPTB");

var $dE0sS = parcelRequire("dE0sS");

var $2gCne = parcelRequire("2gCne");
const $8326461e03189c88$var$containerStyles = null;
const $8326461e03189c88$var$contentStyles = null;
const $8326461e03189c88$var$closeIconStyles = null;
const $8326461e03189c88$export$4eb8f3e4e539379b = ({ identifier: identifier, text: text, linkText: linkText, linkUrl: linkUrl, dataEventProps: dataEventProps, hasProductNavBar: hasProductNavBar })=>{
    const intl = (0, $8e22h.default)();
    const bannerStorageItem = `BannerAlert_dismiss-${identifier}`;
    const translatedLabel = intl.formatMessage({
        id: 'banner-alert.close.aria-label',
        defaultMessage: 'Close'
    });
    const [isHidden, setIsHidden] = (0, $1oC0p.useState)(true);
    (0, $1oC0p.useEffect)(()=>{
        let dismissValue = null;
        dismissValue = (0, $2gCne.getLocalStorage)(bannerStorageItem);
        if (dismissValue !== '1') setIsHidden(false);
    }, [
        bannerStorageItem
    ]);
    const dynamicStyles = hasProductNavBar ? {
        marginBlockStart: '60px'
    } : {};
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "banner-alert",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            "data-dismissed": isHidden ? 'true' : undefined,
            className: (0, $2jatx.default)([
                "_bfhkuzct _kqswh2mm _y4ti1ejb _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1e0c1txw _1pbykb7n _nzmgglyw"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                    "aria-label": translatedLabel,
                    onClick: ()=>{
                        setIsHidden(true);
                        (0, $2gCne.setLocalStorage)(bannerStorageItem, '1');
                    },
                    className: (0, $2jatx.default)([
                        "_r06hglyw _bfhk1j28 _19itidpf _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw _rjxp1ul9 _152tpxbi _1nj119tk"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dE0sS.Cross), {
                        size: "20"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    style: dynamicStyles,
                    className: (0, $2jatx.default)([
                        "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _bozgxy5q _y4tixncg _1e0c11p5 _syaz1mpp _1a9ox7w3 _oxk4oelr _rfqo1r31 _1bgkglyw _1t0pnqa1 _1d61glyw _14l354rc"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                children: text
                            }),
                            "\xa0",
                            linkText && linkUrl && // eslint-disable-next-line @atlassian/a11y/anchor-has-content,@atlassian/a11y/link-name
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                text: linkText,
                                href: linkUrl,
                                type: "inline",
                                dataEventProps: dataEventProps
                            })
                        ]
                    })
                })
            ]
        })
    });
};

});

parcelRegister("4Jdkw", function(module, exports) {
$parcel$export(module.exports, "ADG4CtaWithPolygonBackground", function () { return $07707e85aaf85d14$export$eacf4ba154ffd9bb; });
/* cta-with-polygon-background.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $lmQGF = parcelRequire("lmQGF");

var $kbpa7 = parcelRequire("kbpa7");

var $1rGpC = parcelRequire("1rGpC");

var $jsxHL = parcelRequire("jsxHL");
const $07707e85aaf85d14$var$ctaStyles = null;
const $07707e85aaf85d14$var$h3Styles = null;
const $07707e85aaf85d14$var$typographyOverrides = null;
const $07707e85aaf85d14$var$polygonStyles = null;
const $07707e85aaf85d14$export$eacf4ba154ffd9bb = ({ header: header, paragraph: paragraph, ctaText: ctaText, ctaUrl: ctaUrl, ctaLabel: ctaLabel, productKey: productKey, backgroundColor: backgroundColor = '#101214', buttonVariant: buttonVariant = 'secondary', buttonColor: buttonColor = 'white' })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)();
    const noParagraphSpacing = !paragraph ? "var(--ds-space-400, 32px)" : 0;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            ref: scrollRef,
            className: (0, $2jatx.default)([
                "_p12f1git _18s84p42 _y3gn1h6o",
                "_syazuftu _6rth4cqu",
                sectionIsVisible ? 'is-visible' : ''
            ]),
            style: {
                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                style: {
                    '--background-color': backgroundColor
                },
                className: (0, $2jatx.default)([
                    "_11q76ulk _mkrz1q5k _1vthpg2b _1yt4koci",
                    "polygon"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                    layout: "8",
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                className: (0, $2jatx.default)([
                                    "_1wyb1fu0 _vwz41da2 _1cqs1h67 _1jw853lb _1bys1fu0",
                                    "_syazuftu _6rth4cqu",
                                    "header h3"
                                ]),
                                style: {
                                    marginBottom: noParagraphSpacing,
                                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                                },
                                children: header
                            }),
                            paragraph && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                                layout: "8",
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    className: (0, $2jatx.default)([
                                        "_syazuftu _6rth4cqu",
                                        ".body-lg"
                                    ]),
                                    style: {
                                        "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                                    },
                                    children: paragraph
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                                variant: buttonVariant,
                                color: buttonColor,
                                colorAgainst: backgroundColor === '#101214' ? 'black' : 'other',
                                href: ctaUrl,
                                dataEventProps: {
                                    'data-product-key': productKey,
                                    'data-event': 'clicked',
                                    'data-event-component': 'linkButton',
                                    'data-event-container': 'ctaSection',
                                    'data-label-english': ctaLabel
                                },
                                className: (0, $2jatx.default)([
                                    "_6rthzwfg"
                                ]),
                                children: ctaText
                            })
                        ]
                    })
                })
            })
        })
    });
};

});

parcelRegister("loOqH", function(module, exports) {
$parcel$export(module.exports, "PaidSocialProof", function () { return $f018c88e44a87b10$export$ebcf40293fae7986; });
/* paid-social-proof.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $hnmMQ = parcelRequire("hnmMQ");
const $f018c88e44a87b10$var$customerSectionStyles = null;
const $f018c88e44a87b10$var$h3Styles = null;
const $f018c88e44a87b10$var$containerStyles = null;
const $f018c88e44a87b10$var$imageStyles = null;
const $f018c88e44a87b10$var$largeLogoStyles = null;
const $f018c88e44a87b10$var$smallLogoStyle = null;
const $f018c88e44a87b10$export$ebcf40293fae7986 = ({ headerText: headerText, logos: logos, logoSize: logoSize = 'small' })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_1bah1h6o _4cvr1h6o _y3gn1h6o _ca0q1j6v _u5f3idpf _n3tdviql _19bvidpf _1k9l12bs _1qwm12bs"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                className: (0, $2jatx.default)([
                    "_1wyb1tcg _vwz411ph _k48pbfng _syaz1bqd _ca0q1j6v _u5f31j6v _n3tdviql _19bv1j6v _1moun7od _3fcw10xh"
                ]),
                children: headerText
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _1bah1h6o _zulpzb0d _4cvr1h6o _y3gn1h6o _1n261g80 _195g1wug _p12f1fra _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1xf6vrvc _fukk1fhb _e47i1j6v _ldth1j6v _bjh61j6v _1nny1j6v"
                ]),
                children: logos?.map((inlineLogo, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_4t3i66rk _bna71osq _mezj1wug",
                            logoSize === 'small' ? "_1u7oldb6" : "_19rt1w81 _1u7o16xz"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                            image: {
                                ...inlineLogo
                            }
                        })
                    }, index))
            })
        ]
    });
};
$f018c88e44a87b10$export$ebcf40293fae7986.displayName = 'PaidSocialProof';

});

parcelRegister("50aZ0", function(module, exports) {
$parcel$export(module.exports, "SimpleImageTextSide", function () { return $52a85b4e5fd4de41$export$c449191a6146bc15; });
/* simple-image-text-side.tsx generated by @compiled/babel-plugin v0.28.8 */ // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $2ivuE = parcelRequire("2ivuE");

var $hnmMQ = parcelRequire("hnmMQ");

var $iPPTB = parcelRequire("iPPTB");

var $1rGpC = parcelRequire("1rGpC");
const $52a85b4e5fd4de41$var$simpleImageTextSideStyle = null;
const $52a85b4e5fd4de41$var$RenderImage = ({ imageLink: imageLink, imageAltText: imageAltText, aspectRatio: aspectRatio })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: imageLink,
            alt: imageAltText,
            aspectRatio: aspectRatio
        },
        className: (0, $2jatx.default)([
            "_rtys1osq _1jpx1f51 _mezj1osq _1oo31q9y _bna71wug _688gkb7n"
        ])
    });
const $52a85b4e5fd4de41$var$RenderContent = ({ eyebrowText: eyebrowText, headerText: headerText, isBannerRichText: isBannerRichText, headerType: headerType, lozenge: lozenge, bodyText: bodyText, ctaProps: ctaProps, horizontalRule: horizontalRule, linkText: linkText, linkUrl: linkUrl })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ivuE.ContentBlock), {
                eyebrowText: eyebrowText,
                headerText: headerText,
                isBannerRichText: isBannerRichText,
                headerType: headerType,
                lozenge: lozenge,
                bodyText: bodyText,
                ctaProps: ctaProps,
                horizontalRule: horizontalRule
            }),
            linkText && linkUrl && // eslint-disable-next-line @atlassian/a11y/anchor-has-content, @atlassian/a11y/link-name
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                text: linkText,
                href: linkUrl,
                type: "primary"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1jab1ylp _3fdxglyw _5jnq1ylp _uknx7vkz _b9s91ylp"
                ])
            })
        ]
    });
const $52a85b4e5fd4de41$export$c449191a6146bc15 = ({ eyebrowText: eyebrowText, headerText: headerText, isBannerRichText: isBannerRichText = false, headerType: headerType = 'h2', lozenge: lozenge, bodyText: bodyText, linkText: linkText, linkUrl: linkUrl, imageLink: imageLink, imageAltText: imageAltText, imagePosition: imagePosition, className: className = '', ctaProps: ctaProps, aspectRatio: aspectRatio, horizontalRule: horizontalRule = false, alignItems: alignItems = 'center', rowProps: rowProps = '6-6', backgroundColor: backgroundColor = 'transparent', margin: margin = '80px 0' })=>{
    const renderImageProps = {
        imageLink: imageLink,
        imageAltText: imageAltText,
        aspectRatio: aspectRatio
    };
    const renderContentProps = {
        eyebrowText: eyebrowText,
        headerText: headerText,
        isBannerRichText: isBannerRichText,
        headerType: headerType,
        lozenge: lozenge,
        bodyText: bodyText,
        ctaProps: ctaProps,
        horizontalRule: horizontalRule,
        linkText: linkText,
        linkUrl: linkUrl
    };
    const first = imagePosition === 'left' ? /*#__PURE__*/ (0, $7VQPk.jsx)($52a85b4e5fd4de41$var$RenderImage, {
        ...renderImageProps
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)($52a85b4e5fd4de41$var$RenderContent, {
        ...renderContentProps
    });
    const second = imagePosition === 'left' ? /*#__PURE__*/ (0, $7VQPk.jsx)($52a85b4e5fd4de41$var$RenderContent, {
        ...renderContentProps
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)($52a85b4e5fd4de41$var$RenderImage, {
        ...renderImageProps
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_ca0qys9h _u5f3idpf _n3tdys9h _19bvidpf _1kmx7vkz _1ggmidpf _1ykz7vkz _1maeidpf _i6jx1wqb _1lh7idpf _z3nc1wqb _wpaiidpf",
            className
        ]),
        style: {
            '--bkgd-color': backgroundColor,
            '--margin': margin,
            backgroundColor: 'var(--bkgd-color, transparent)',
            margin: 'var(--margin, 0)'
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1rGpC.Row), {
            layout: rowProps,
            alignItems: alignItems,
            children: [
                first,
                second
            ]
        })
    });
};

});
parcelRegister("2ivuE", function(module, exports) {
$parcel$export(module.exports, "ContentBlock", function () { return $20f7f25677f4cd05$export$eb38b3b9c7f5f31b; });
/* content-block.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $20Gca = parcelRequire("20Gca");

var $lmQGF = parcelRequire("lmQGF");

var $6SdoX = parcelRequire("6SdoX");

var $1pppr = parcelRequire("1pppr");

var $gfjAv = parcelRequire("gfjAv");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $OKl9V = parcelRequire("OKl9V");

var $ldrV1 = parcelRequire("ldrV1");

var $hnmMQ = parcelRequire("hnmMQ");
function $20f7f25677f4cd05$var$getHeaderTag(text, header, lozenge, lozengeAppearance) {
    const headerTag = header ? header : 'h3';
    const headerText = /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            text,
            lozenge && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_ahbqftgi _1e0c1o8l"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c116y _s7n4nkob"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $20Gca.default), {
                        appearance: lozengeAppearance,
                        children: lozenge
                    })
                })
            })
        ]
    });
    const style = lozenge ? {
        style: {
            display: 'inline-block'
        }
    } : null;
    return /*#__PURE__*/ (0, $1oC0p.createElement)(headerTag, style, headerText);
}
/* Gives p tag  so that page structure follows HTML semantic ordering */ function $20f7f25677f4cd05$var$getEyebrowTag(// @ts-expect-error unused
headerType, eyebrowText) {
    return /*#__PURE__*/ (0, $1oC0p.createElement)(`p`, {
        className: 'contentBlock-eyebrow'
    }, eyebrowText);
}
function $20f7f25677f4cd05$var$renderLinks({ ctaProps: ctaProps, product: product, edition: edition }) {
    if (!ctaProps) return null;
    let firstLink;
    if ('buttonProps' in ctaProps && 'text' in ctaProps.buttonProps) firstLink = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ldrV1.Button), {
        ...ctaProps.buttonProps
    });
    else if ('buttonProps' in ctaProps && 'variant' in ctaProps.buttonProps) firstLink = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
        ...ctaProps.buttonProps
    });
    else if ('primaryLinkProps' in ctaProps && ctaProps.primaryLinkProps) // eslint-disable-next-line @atlassian/a11y/anchor-has-content
    firstLink = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
        ...ctaProps.primaryLinkProps
    });
    const secondaryLink = 'secondaryLinkProps' in ctaProps ? // eslint-disable-next-line @atlassian/a11y/anchor-has-content
    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
        ...ctaProps.secondaryLinkProps
    }) : null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gfjAv.default), {
        intentType: 'button',
        containerId: 'ctaSection',
        edition: edition,
        productKey: product?.key,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: "contentBlock-linkFlex",
            children: [
                firstLink,
                secondaryLink
            ]
        })
    });
}
/**
 * This method retrieves either the eyebrow or icon decoration. If both are present, the icon is returned.
 * @param headerType
 */ const $20f7f25677f4cd05$var$getDecoration = (headerType, eyebrowText, iconName, iconColor, iconSize)=>{
    if (iconName) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $OKl9V.Icon), {
        name: iconName,
        color: iconColor,
        size: iconSize
    });
    else if (eyebrowText) return $20f7f25677f4cd05$var$getEyebrowTag(headerType, eyebrowText);
    return null;
};
const $20f7f25677f4cd05$var$getImage = (pictureProps, imageLink, imageAltText, aspectRatio)=>{
    if (pictureProps) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: "img-section",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
            ...pictureProps
        })
    });
    else if (imageLink && imageAltText) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: "img-section",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Image), {
            src: imageLink,
            alt: imageAltText,
            aspectRatio: aspectRatio
        })
    });
    else return null;
};
const $20f7f25677f4cd05$var$isHtml = (text)=>{
    return text.startsWith('<') && text.endsWith('>') && text.includes('</');
};
const $20f7f25677f4cd05$export$eb38b3b9c7f5f31b = ({ headerText: headerText, isBannerRichText: isBannerRichText = false, lozenge: lozenge, lozengeAppearance: lozengeAppearance = 'inprogress', bodyText: bodyText, bodyComponent: bodyComponent, headerType: headerType = 'h3', eyebrowText: eyebrowText, className: className = '', imageLink: imageLink, imageAltText: imageAltText, pictureProps: pictureProps, iconName: iconName, iconColor: iconColor, iconSize: iconSize, ctaProps: ctaProps, aspectRatio: aspectRatio = '1/1', orientation: orientation, cardStyle: cardStyle, isCentered: isCentered = false, horizontalRule: horizontalRule })=>{
    const { product: product, edition: edition } = (0, $1pppr.useProductIntent)();
    if (imageLink && !imageAltText) throw new Error('If using an image, please provide an alt text for accessibility purposes!');
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            isBannerRichText && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _1ma11kwk _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1vau _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && isCentered && orientation === 'horizontal' && cardStyle && headerType === 'h1' && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _a5ip1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1vau _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1vau _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && isCentered && orientation === 'horizontal' && !cardStyle && headerType === 'h1' && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _a5ip1osq _1ma11kwk _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1vau _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1vau _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation === 'horizontal' && cardStyle && headerType === 'h1' && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1vau _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1vau _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation === 'horizontal' && !cardStyle && headerType === 'h1' && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _1ma11kwk _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1vau _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1vau _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && isCentered && orientation === 'horizontal' && cardStyle && headerType !== 'h1' && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1vau _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && isCentered && orientation === 'horizontal' && !cardStyle && headerType !== 'h1' && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _a5ip1osq _1ma11kwk _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1vau _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation === 'horizontal' && cardStyle && headerType !== 'h1' && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1vau _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation === 'horizontal' && !cardStyle && headerType !== 'h1' && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _1ma11kwk _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1vau _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && isCentered && orientation !== 'horizontal' && cardStyle && headerType === 'h1' && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1vau _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1vau _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && isCentered && orientation !== 'horizontal' && !cardStyle && headerType !== 'h1' && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1vau _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation !== 'horizontal' && cardStyle && headerType === 'h1' && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1vau _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1vau _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation !== 'horizontal' && !cardStyle && headerType === 'h1' && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _1ma11kwk _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1vau _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1vau _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && isCentered && orientation !== 'horizontal' && cardStyle && headerType !== 'h1' && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1vau _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation !== 'horizontal' && cardStyle && headerType !== 'h1' && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1vau _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation !== 'horizontal' && !cardStyle && headerType !== 'h1' && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _1ma11kwk _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1vau _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            `content-block ${className}`
        ]),
        style: {
            "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
        },
        children: [
            $20f7f25677f4cd05$var$getImage(pictureProps, imageLink, imageAltText, aspectRatio),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: "text-section",
                children: [
                    headerText && $20f7f25677f4cd05$var$getHeaderTag(headerText, headerType, lozenge, lozengeAppearance),
                    $20f7f25677f4cd05$var$getDecoration(headerType, eyebrowText, iconName, iconColor, iconSize),
                    horizontalRule && /*#__PURE__*/ (0, $7VQPk.jsx)("hr", {
                        role: "presentation",
                        className: (0, $2jatx.default)([
                            "_4t3iyh40 _p12f1fra"
                        ])
                    }),
                    bodyText ? typeof bodyText === 'string' && $20f7f25677f4cd05$var$isHtml(bodyText) ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6SdoX.SanitizedRichText), {
                        innerHTML: bodyText
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: "contentBlock-body",
                        children: bodyText
                    }) : null,
                    !bodyText && bodyComponent && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: "contentBlock-body",
                        children: bodyComponent
                    }),
                    $20f7f25677f4cd05$var$renderLinks({
                        ctaProps: ctaProps,
                        product: product,
                        edition: edition
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("icTHu", function(module, exports) {
$parcel$export(module.exports, "PaidAlternatingImageText", function () { return $f11b78698fc43615$export$45a2817884af97dc; });
/* paid-alternating-image-text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $bSwKq = parcelRequire("bSwKq");
const $f11b78698fc43615$var$anchorPageStyles = null;
const $f11b78698fc43615$var$confluenceAnchorStyles = null;
const $f11b78698fc43615$export$45a2817884af97dc = ({ alternatingImageTextProps: alternatingImageTextProps, landingType: landingType })=>{
    if (!alternatingImageTextProps) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            landingType === 'jira-software-anchor' && "_7e8vgktf",
            landingType === 'confluence-rebranded-anchor' && "_vussviql _1b6r1fw0 _p1061k92"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSwKq.ThreeAlternatingImageText), {
            ...alternatingImageTextProps
        })
    });
};
$f11b78698fc43615$export$45a2817884af97dc.displayName = 'PaidAlternatingImageText';

});
parcelRegister("bSwKq", function(module, exports) {
$parcel$export(module.exports, "ThreeAlternatingImageText", function () { return $1f7cfd3057b21b6f$export$51a3e3286a1cf2b5; });
/* three-alternating-image-text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $50aZ0 = parcelRequire("50aZ0");
const $1f7cfd3057b21b6f$export$51a3e3286a1cf2b5 = ({ backgroundColor: backgroundColor, backgroundImage: backgroundImage, horizontalRuleColor: horizontalRuleColor, imageWidth: imageWidth, rowHeaderType: rowHeaderType = 'h2', rowPropsOdd: rowPropsOdd = '6-6', rowPropsEven: rowPropsEven = '6-6', imageTextSideRowOnePadding: imageTextSideRowOnePadding, imageTextSideRowOnePaddingBelowLargeScreen: imageTextSideRowOnePaddingBelowLargeScreen, rowOneHeader: rowOneHeader, rowOneLozenge: rowOneLozenge, rowOneBody: rowOneBody, rowOneImageLink: rowOneImageLink, rowOneImageAltText: rowOneImageAltText, rowOneImagePosition: rowOneImagePosition = 'left', rowOneEyebrowText: rowOneEyebrowText, imageTextSideRowTwoPadding: imageTextSideRowTwoPadding, imageTextSideRowTwoPaddingBelowLargeScreen: imageTextSideRowTwoPaddingBelowLargeScreen, rowTwoHeader: rowTwoHeader, rowTwoLozenge: rowTwoLozenge, rowTwoBody: rowTwoBody, rowTwoImageLink: rowTwoImageLink, rowTwoImageAltText: rowTwoImageAltText, rowTwoImagePosition: rowTwoImagePosition = 'right', rowTwoEyebrowText: rowTwoEyebrowText, imageTextSideRowThreePadding: imageTextSideRowThreePadding, imageTextSideRowThreePaddingBelowLargeScreen: imageTextSideRowThreePaddingBelowLargeScreen, rowThreeHeader: rowThreeHeader, rowThreeLozenge: rowThreeLozenge, rowThreeBody: rowThreeBody, rowThreeImageLink: rowThreeImageLink, rowThreeImageAltText: rowThreeImageAltText, rowThreeImagePosition: rowThreeImagePosition = 'left', rowThreeEyebrowText: rowThreeEyebrowText, imageTextSideRowFourPadding: imageTextSideRowFourPadding, imageTextSideRowFourPaddingBelowLargeScreen: imageTextSideRowFourPaddingBelowLargeScreen, rowFourHeader: rowFourHeader, rowFourLozenge: rowFourLozenge, rowFourBody: rowFourBody, rowFourImageLink: rowFourImageLink, rowFourImageAltText: rowFourImageAltText = 'Alt Text', rowFourImagePosition: rowFourImagePosition, rowFourEyebrowText: rowFourEyebrowText })=>{
    const imageWidthValue = imageWidth ?? '550px';
    const imageTextSideRowOnePaddingValue = imageTextSideRowOnePadding ?? '64px 0 16px';
    const imageTextSideRowOnePaddingBelowLargeScreenValue = imageTextSideRowOnePaddingBelowLargeScreen ?? '64px 0 16px';
    const imageTextSideRowTwoPaddingValue = imageTextSideRowTwoPadding ?? '32px 0';
    const imageTextSideRowTwoPaddingBelowLargeScreenValue = imageTextSideRowTwoPaddingBelowLargeScreen ?? '16px 0';
    const imageTextSideRowThreePaddingValue = imageTextSideRowThreePadding ?? '16px 0 64px';
    const imageTextSideRowThreePaddingBelowLargeScreenValue = imageTextSideRowThreePaddingBelowLargeScreen ?? '16px 0 64px';
    const imageTextSideRowFourPaddingValue = imageTextSideRowFourPadding ?? '16px 0 64px';
    const imageTextSideRowFourPaddingBelowLargeScreenValue = imageTextSideRowFourPaddingBelowLargeScreen ?? '16px 0 64px';
    const ThreeAlternatingImageTextStyles = null;
    const isShowHorizontalRule = !!horizontalRuleColor;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_j2qggma6 _cotpidpf _u5lc1ule _hm0s1wug _ceny1wug _o4bz1oh5 _17xw1bqd _vussviql _i80qidpf _1y3uidpf _vq3z1tcg _1x7sidpf _18m21038 _27c31k8s _e87pidpf _6mt8idpf _vljsdlk8 _1j6nidpf _yza7idpf _1vbdidpf _13r21ylp _dcnaidpf _vbkqidpf _9by51q87 _1of01mpp _5wk3idpf _1fus1j99 _19y1l3tq _1ltr7ip2 _1g391fux _amtq1col _kju2v4do _1djgx7vm _1drv1abn"
        ]),
        style: {
            "--_bwa4xl": (0, $6ZVlx.default)(imageWidthValue),
            "--_1cdekw0": (0, $6ZVlx.default)(horizontalRuleColor),
            "--_1o5bebe": (0, $6ZVlx.default)(imageTextSideRowOnePaddingValue),
            "--_1dlh24j": (0, $6ZVlx.default)(imageTextSideRowOnePaddingBelowLargeScreenValue),
            "--_1nsshok": (0, $6ZVlx.default)(imageTextSideRowTwoPaddingValue),
            "--_1e6od0m": (0, $6ZVlx.default)(imageTextSideRowTwoPaddingBelowLargeScreenValue),
            "--_1u1sozo": (0, $6ZVlx.default)(imageTextSideRowThreePaddingValue),
            "--_1div133": (0, $6ZVlx.default)(imageTextSideRowThreePaddingBelowLargeScreenValue),
            "--_1rnt45i": (0, $6ZVlx.default)(imageTextSideRowFourPaddingValue),
            "--_15kis35": (0, $6ZVlx.default)(imageTextSideRowFourPaddingBelowLargeScreenValue)
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_bfhkaxbu _1itk1u11",
                "background-side-by-side"
            ]),
            style: {
                "--_1ly4823": (0, $6ZVlx.default)(backgroundColor),
                "--_1jwom28": (0, $6ZVlx.default)(backgroundImage)
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $50aZ0.SimpleImageTextSide), {
                    headerType: rowHeaderType,
                    headerText: rowOneHeader,
                    lozenge: rowOneLozenge,
                    bodyText: rowOneBody,
                    imageLink: rowOneImageLink,
                    imageAltText: rowOneImageAltText,
                    imagePosition: rowOneImagePosition,
                    horizontalRule: isShowHorizontalRule,
                    className: "image-text-side-row-1",
                    eyebrowText: rowOneEyebrowText,
                    rowProps: rowPropsOdd
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $50aZ0.SimpleImageTextSide), {
                    headerType: rowHeaderType,
                    headerText: rowTwoHeader,
                    lozenge: rowTwoLozenge,
                    bodyText: rowTwoBody,
                    imageLink: rowTwoImageLink,
                    imageAltText: rowTwoImageAltText,
                    horizontalRule: isShowHorizontalRule,
                    imagePosition: rowTwoImagePosition,
                    className: "image-text-side-row-2",
                    eyebrowText: rowTwoEyebrowText,
                    rowProps: rowPropsEven
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $50aZ0.SimpleImageTextSide), {
                    headerType: rowHeaderType,
                    headerText: rowThreeHeader,
                    lozenge: rowThreeLozenge,
                    bodyText: rowThreeBody,
                    imageLink: rowThreeImageLink,
                    imageAltText: rowThreeImageAltText,
                    imagePosition: rowThreeImagePosition,
                    horizontalRule: isShowHorizontalRule,
                    className: "image-text-side-row-3",
                    eyebrowText: rowThreeEyebrowText,
                    rowProps: rowPropsOdd
                }),
                rowFourImageLink ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $50aZ0.SimpleImageTextSide), {
                    headerType: rowHeaderType,
                    headerText: rowFourHeader,
                    lozenge: rowFourLozenge,
                    bodyText: rowFourBody,
                    imageLink: rowFourImageLink,
                    imageAltText: rowFourImageAltText,
                    imagePosition: rowFourImagePosition,
                    horizontalRule: isShowHorizontalRule,
                    className: "image-text-side-row-4",
                    eyebrowText: rowFourEyebrowText,
                    rowProps: rowPropsEven
                }) : null
            ]
        })
    });
};
$1f7cfd3057b21b6f$export$51a3e3286a1cf2b5.displayName = 'ThreeAlternatingImageText';

});


parcelRegister("5IbWH", function(module, exports) {
$parcel$export(module.exports, "PaidCtaSection", function () { return $233fe779bf480799$export$5e5db24264a78d; });
/* paid-cta-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $1rGpC = parcelRequire("1rGpC");

var $kS9hn = parcelRequire("kS9hn");
const $233fe779bf480799$var$ctaStyles = {
    'jira-software': "_syaz1m8h _12vemgnk _ouxl1ssb _1lrw1dfr _1itk14uh _1dhs103n",
    'jira-software-paid-ai': "_12vemgnk _ouxl1ssb _1lrw1dfr _bfhkcs0v _1itkg4np _1dhs2iov",
    'jira-software-anchor': "_syazr3uz _bfhkoelr _6vsiidpf _t0odidpf _mqkjidpf _xz03idpf",
    'jira-software-rebranded-anchor': "_syazr3uz _bfhkoelr _6vsiidpf _t0odidpf _mqkjidpf _xz03idpf",
    'jira-service-management': "_syazu67f _1itkj4zg _ouxl1ssb _1lrw1dfr _12vemgnk",
    'jira-service-management-anchor': "_syazu67f _1itk1k2f _ouxl1ssb _1lrw1dfr _12vemgnk",
    'confluence-paid': "_syazu67f _1itkuuyn _ouxl1ssb _1lrw1dfr _12vemgnk",
    'confluence-anchor': "_1itk1gd4 _ouxl1ssb _12vemgnk _1lrw1dfr _ol8u1keg _1rmvwbzg _1f9f995e _r2cimgnk _u6yg1f51",
    'confluence-rebranded-anchor': "_1itk1gd4 _ouxl1ssb _12vemgnk _1lrw1dfr _ol8u1keg _1rmvwbzg _1f9f995e _r2cimgnk _u6yg1f51"
};
const $233fe779bf480799$export$5e5db24264a78d = ({ ctaProps: ctaProps, landingType: landingType })=>{
    const { layout: ctaLayout = '10', ...otherCtaProps } = ctaProps;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            $233fe779bf480799$var$ctaStyles[landingType]
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
            layout: ctaLayout,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kS9hn.PaidCtaPrimary), {
                ...otherCtaProps
            })
        })
    });
};
$233fe779bf480799$export$5e5db24264a78d.displayName = 'PaidCta';

});
parcelRegister("kS9hn", function(module, exports) {
$parcel$export(module.exports, "PaidCtaPrimary", function () { return $d6db1ae86de58bc4$export$a88d1ab51f344f2e; });
/* paid-cta-primary.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
parcelRequire("9MMEE");
var $amfUr = parcelRequire("amfUr");
const $d6db1ae86de58bc4$var$ctaSectionBaseStyle = null;
const $d6db1ae86de58bc4$export$a88d1ab51f344f2e = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_xgyx1k8s _1xcsahaf"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $amfUr.CTAPrimary), {
            className: "cta-primary",
            backgroundProperties: {
                /* this is deprecated, but need it temporarily to override current behavior */ textColor: 'n0'
            },
            ...props
        })
    });
};

});
parcelRegister("9MMEE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("amfUr")).CTAPrimary; });

var $amfUr = parcelRequire("amfUr");

});
parcelRegister("amfUr", function(module, exports) {
$parcel$export(module.exports, "CTAPrimary", function () { return $ee0917f296746ee7$export$2803c38b17523474; });
/* cta-primary.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $2ivuE = parcelRequire("2ivuE");

var $b4FXR = parcelRequire("b4FXR");
const $ee0917f296746ee7$var$ctaPrimaryStyle = null;
const $ee0917f296746ee7$export$2803c38b17523474 = ({ headerText: headerText, bodyText: bodyText, className: className, eyebrowText: eyebrowText, footNoteText: footNoteText, ctaProps: ctaProps, backgroundProperties: backgroundProperties })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $b4FXR.StyledBackground), {
        ...backgroundProperties,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1akovbgk _c7s7idpf _4puvvbgk _1r3vidpf _y3gn1h6o _i6jxckbl _1lh7idpf _z3ncckbl _wpaiidpf _1kmxzwfg _1ggmidpf _1ykzzwfg _1maeidpf _1916oxwj _jti51ul9 _xjyr1wug _2thuidpf _hbr31wug",
                className
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: "primary-cta-content",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ivuE.ContentBlock), {
                        isCentered: true,
                        headerText: headerText,
                        headerType: "h2",
                        eyebrowText: eyebrowText,
                        bodyText: bodyText,
                        ctaProps: ctaProps
                    }),
                    footNoteText ? /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: "footnote-text",
                        children: footNoteText
                    }) : null
                ]
            })
        })
    });
};

});
parcelRegister("b4FXR", function(module, exports) {
$parcel$export(module.exports, "StyledBackground", function () { return $5e184c6b078bec45$export$d5a32b9384a657de; });
/* styled-backgrounds.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $c9xu6 = parcelRequire("c9xu6");
const $5e184c6b078bec45$var$positioner = {
    cornerTopLeft: 'top left',
    cornerTopRight: 'top right',
    cornerBottomLeft: 'bottom left',
    cornerBottomRight: 'bottom right',
    sideTop: 'center top',
    sideLeft: 'left center',
    sideRight: 'right center',
    sideBottom: 'center bottom',
    hidden: '-100% -100%'
};
const $5e184c6b078bec45$var$sizes = {
    desktop: {
        cornerTopLeft: '400px auto',
        cornerTopRight: '400px auto',
        cornerBottomLeft: '400px auto',
        cornerBottomRight: '400px auto',
        sideTop: 'auto 150px',
        sideLeft: '400px auto',
        sideRight: '400px auto',
        sideBottom: 'auto 150px',
        hidden: '0 0'
    },
    tablet: {
        cornerTopLeft: 'auto 50%',
        cornerTopRight: 'auto 50%',
        cornerBottomLeft: 'auto 50%',
        cornerBottomRight: 'auto 50%',
        sideTop: 'auto 150px',
        sideLeft: 'calc(50% - 350px) auto',
        sideRight: 'calc(50% - 350px) auto',
        sideBottom: 'auto 150px',
        hidden: '0 0'
    },
    mobile: {
        cornerTopLeft: 'auto 200px',
        cornerTopRight: 'auto 200px',
        cornerBottomLeft: 'auto 200px',
        cornerBottomRight: 'auto 200px',
        sideTop: 'auto 150px',
        sideLeft: '50%',
        sideRight: '50%',
        sideBottom: 'auto 200px',
        hidden: '0 0'
    }
};
const $5e184c6b078bec45$var$getBGObject = (bg)=>{
    return {
        src: `url(${bg.imageLink})`,
        posDesktop: $5e184c6b078bec45$var$positioner[bg.positionDesktop],
        posTablet: $5e184c6b078bec45$var$positioner[bg.positionTablet],
        posMobile: $5e184c6b078bec45$var$positioner[bg.positionMobile],
        sizeDesktop: $5e184c6b078bec45$var$sizes.desktop[bg.positionDesktop],
        sizeTablet: $5e184c6b078bec45$var$sizes.tablet[bg.positionTablet],
        sizeMobile: $5e184c6b078bec45$var$sizes.mobile[bg.positionMobile]
    };
};
const $5e184c6b078bec45$export$d5a32b9384a657de = (backgroundProperties)=>{
    const obj = backgroundProperties || {};
    const hasGradient = obj.gradientDirection && obj.bgColor && obj.bgColor2;
    const totalBGs = [];
    const collections = {
        desktop: {
            topCorners: false,
            bottomCorners: false
        },
        tablet: {
            topCorners: false,
            bottomCorners: false
        },
        mobile: {
            topCorners: false,
            bottomCorners: false
        }
    };
    if (hasGradient) totalBGs.unshift({
        src: (0, $c9xu6.getGradient)(obj.gradientDirection, obj.bgColor, obj.bgColor2),
        posDesktop: 'top left',
        posTablet: 'top left',
        posMobile: 'top left',
        sizeDesktop: '100% 100%',
        sizeTablet: '100% 100%',
        sizeMobile: '100% 100%'
    });
    if (obj.bgImage) totalBGs.unshift({
        src: `url(${obj.bgImage} )`,
        posDesktop: 'center center',
        posTablet: 'center center',
        posMobile: 'center center',
        sizeDesktop: 'cover',
        sizeTablet: 'cover',
        sizeMobile: 'cover'
    });
    if (obj.partialBackgrounds) obj.partialBackgrounds.forEach((bg)=>{
        totalBGs.unshift($5e184c6b078bec45$var$getBGObject(bg));
        if (bg.positionDesktop.startsWith('cornerTop') || bg.positionDesktop == 'sideTop') collections.desktop.topCorners = true;
        if (bg.positionDesktop.startsWith('cornerBottom') || bg.positionDesktop == 'sideBottom') collections.desktop.bottomCorners = true;
        if (bg.positionTablet.startsWith('cornerTop') || bg.positionTablet == 'sideTop') collections.tablet.topCorners = true;
        if (bg.positionTablet.startsWith('cornerBottom') || bg.positionTablet == 'sideBottom') collections.tablet.bottomCorners = true;
        if (bg.positionMobile.startsWith('cornerTop') || bg.positionMobile == 'sideTop') collections.mobile.topCorners = true;
        if (bg.positionMobile.startsWith('cornerBottom') || bg.positionMobile == 'sideBottom') collections.mobile.bottomCorners = true;
    });
    const backgroundImage = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            obj.bgColor && "_bfhk9eee",
            !obj.bgColor && "_bfhk1j28",
            obj.textColor && "_syazy0xq",
            !obj.textColor && "_dvo71mpp",
            (hasGradient || obj.bgImage || obj.partialBackgrounds) && "_1itklu3u _12veczn9 _1lrwwnqo _ouxlcawu _1l1498sy _2cw2sv7q _1o6085j3 _1odr14xn",
            collections.mobile.topCorners && "_1q51uuw1",
            collections.mobile.bottomCorners && "_85i5uuw1",
            collections.tablet.topCorners && "_1waf68cl",
            collections.tablet.bottomCorners && "_1yd368cl",
            collections.desktop.topCorners && "_h14068cl",
            collections.desktop.bottomCorners && "_1rgh68cl",
            "styled-background"
        ]),
        style: {
            "--_1j0zdu3": (0, $6ZVlx.default)(obj.bgColor),
            "--_xtedcl": (0, $6ZVlx.default)(obj.textColor),
            "--_15wd2r6": (0, $6ZVlx.default)(totalBGs.map((__cmplp)=>__cmplp.src).join(', ')),
            "--_1gyqo69": (0, $6ZVlx.default)(totalBGs.map(()=>'no-repeat').join(', ')),
            "--_jrtwkm": (0, $6ZVlx.default)(totalBGs.map((__cmplp)=>__cmplp.sizeMobile).join(', ')),
            "--_1avycw4": (0, $6ZVlx.default)(totalBGs.map((__cmplp)=>__cmplp.posMobile).join(', ')),
            "--_1msyi7f": (0, $6ZVlx.default)(totalBGs.map((__cmplp)=>__cmplp.sizeTablet).join(', ')),
            "--_1ia7tp5": (0, $6ZVlx.default)(totalBGs.map((__cmplp)=>__cmplp.posTablet).join(', ')),
            "--_1ah5two": (0, $6ZVlx.default)(totalBGs.map((__cmplp)=>__cmplp.sizeDesktop).join(', ')),
            "--_o9c9fo": (0, $6ZVlx.default)(totalBGs.map((__cmplp)=>__cmplp.posDesktop).join(', '))
        },
        children: obj.children
    });
};

});
parcelRegister("c9xu6", function(module, exports) {
$parcel$export(module.exports, "getGradient", function () { return $1a402daca80fbbf6$export$e14995d3ec1747ee; });
const $1a402daca80fbbf6$export$e14995d3ec1747ee = (angle, color1, color2)=>{
    if (angle && color1 && color2) return `linear-gradient(${angle}deg, ${color1}, ${color2})`;
    return '';
};

});






parcelRegister("gQSoJ", function(module, exports) {
$parcel$export(module.exports, "PaidCustomHeroSection", function () { return $b8a06be8a2fd88ae$export$a51999b742dcc5f1; });

var $7VQPk = parcelRequire("7VQPk");
const $b8a06be8a2fd88ae$export$a51999b742dcc5f1 = ({ customHeroSection: // eslint-disable-next-line react/prop-types
customHeroSection })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: customHeroSection
    });
};
$b8a06be8a2fd88ae$export$a51999b742dcc5f1.displayName = 'CustomHero';

});

parcelRegister("1SFKa", function(module, exports) {
$parcel$export(module.exports, "PaidCustomSection", function () { return $b72bd2469708963e$export$4781d68a90c3d141; });

var $7VQPk = parcelRequire("7VQPk");
const $b72bd2469708963e$export$4781d68a90c3d141 = ({ customSection: // eslint-disable-next-line react/prop-types
customSection })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: customSection
    });
};
$b72bd2469708963e$export$4781d68a90c3d141.displayName = 'Custom';

});

parcelRegister("hbUAT", function(module, exports) {
$parcel$export(module.exports, "PaidHeroSectionTemplate", function () { return $900a26def99a782c$export$b2d485e7a33c4d4a; });
/* paid-hero-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $2u2Jd = parcelRequire("2u2Jd");

var $a0utR = parcelRequire("a0utR");

var $iL9dx = parcelRequire("iL9dx");

var $g85aC = parcelRequire("g85aC");

var $7kIQK = parcelRequire("7kIQK");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");

var $1Q6XY = parcelRequire("1Q6XY");

var $3LcIp = parcelRequire("3LcIp");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $2gCne = parcelRequire("2gCne");

var $j2b52 = parcelRequire("j2b52");

var $2opLs = parcelRequire("2opLs");
const $900a26def99a782c$var$formColumn = null;
const $900a26def99a782c$var$formColumnWithEyelash = null;
const $900a26def99a782c$var$HeaderEyelashStyle = null;
const $900a26def99a782c$var$contentStyle = null;
const $900a26def99a782c$var$withAnimation = null;
const $900a26def99a782c$var$signupFormContainer = null;
const $900a26def99a782c$var$headingBasicStyles = null;
const $900a26def99a782c$var$heavyFontWeightStyles = null;
const $900a26def99a782c$var$subheaderStyles = null;
const $900a26def99a782c$var$whiteFontColor = null;
const $900a26def99a782c$var$subheaderStylesWithEyelash = null;
const $900a26def99a782c$var$imgContainer = null;
const $900a26def99a782c$var$staticImageContainer = null;
const $900a26def99a782c$var$animationHeroContainer = null;
const $900a26def99a782c$var$carouselContainerStyles = null;
const $900a26def99a782c$var$squaresContainer = null;
const $900a26def99a782c$var$squareOne = null;
const $900a26def99a782c$var$squareTwo = null;
const $900a26def99a782c$var$eyelashStyle = null;
const $900a26def99a782c$var$serviceCollectionStyle = null;
const $900a26def99a782c$var$underlineStyles = null;
const $900a26def99a782c$var$strokeRight = null;
const $900a26def99a782c$var$accentImgStyles = null;
const $900a26def99a782c$var$AnimatedJiraTourStyles = null;
const $900a26def99a782c$var$heroImageSubheaderStyles = null;
const $900a26def99a782c$var$Squares = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswstnw _1bsb1osq _4t3i1lk2 _1e0c1txw _2lx21bp4"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _152tidpf _rjxpidpf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
                    width: "311",
                    height: "220",
                    viewBox: "0 0 311 220",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                            children: "square one"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M7.34559 1.71298L310.956 0.712733L305.579 218.935L0.637246 219.618L7.34559 1.71298Z",
                            fill: "#FFA900"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _u7coidpf _1e02idpf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
                    width: "252",
                    height: "219",
                    viewBox: "0 0 252 219",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                            children: "square two"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M2.76007 0.226074H251.614V212.007L0.0842285 218.146L2.76007 0.226074Z",
                            fill: "#82B536"
                        })
                    ]
                })
            })
        ]
    });
};
const $900a26def99a782c$var$EyeLash = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        className: (0, $2jatx.default)([
            "_y44ve12c _kqswh2mm",
            "_kqswstnw _1e0c1o8l _152t1mi1 _1e02bx3o _1bsb1wpv _4t3ickbl _1s4pd6z3 _1kne1wpv _1rfm1f4h _tnru1u1b",
            "eyelash"
        ]),
        image: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/f0scafs8p034p4uxb1r3f84m05g8s742.svg',
            alt: 'eyelash',
            width: 99,
            height: 50
        }
    });
};
const $900a26def99a782c$var$Scribble = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        className: (0, $2jatx.default)([
            "_y44ve12c _kqswh2mm",
            "_4t3i7vkz _1bsbl1r9 _6rth7vkz _dh1a1e5h _ag851e5h",
            "scribble"
        ]),
        image: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4g12qeh147330006huh36yys682jpa05.svg',
            alt: 'scribble',
            width: 90,
            height: 16
        }
    });
};
const $900a26def99a782c$var$ServiceCollectionLogoBrand = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/171f20t4om07135ujka42le40wvkp613.svg',
            alt: 'service collection mark brand',
            width: 160
        }
    });
};
const $900a26def99a782c$var$AnimationWrapper = ({ lottieAnimationPromise: lottieAnimationPromise, riveAnimation: RiveAnimation })=>{
    const [lottieAnimationData, setLottieAnimationData] = (0, $1oC0p.useState)();
    (0, $1oC0p.useEffect)(()=>{
        (async ()=>{
            if (lottieAnimationPromise && !RiveAnimation) {
                const lottieAnimation = await lottieAnimationPromise;
                setLottieAnimationData(lottieAnimation);
            }
        })();
    }, [
        RiveAnimation,
        lottieAnimationPromise
    ]);
    if (RiveAnimation) return /*#__PURE__*/ (0, $7VQPk.jsx)(RiveAnimation, {});
    else if (lottieAnimationData) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2u2Jd))), {
        options: {
            loop: false,
            autoplay: true,
            animationData: lottieAnimationData,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
            }
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        "data-testid": "default-animation",
        viewBox: "0 0 600 350",
        width: "600",
        height: "350",
        style: {
            width: '100%'
        }
    });
};
const $900a26def99a782c$export$b2d485e7a33c4d4a = ({ header: header, subheader: subheader, image: image, darkSolidTheme: darkSolidTheme, showAnimatedHero: showAnimatedHero, carouselHeroProps: carouselHeroProps, animatedJiraTourProps: animatedJiraTourProps, heroImageSubheader: heroImageSubheader, hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles, showScribble: showScribble, showEyeLash: showEyeLash, animation: animation, hasBannerAlert: hasBannerAlert = false, heroBgColor: heroBgColor = 'bgWhite', showFourSocialButtons: showFourSocialButtons, auxiaResponse: auxiaResponse, pageId: pageId })=>{
    // the default behavior is to show the animated hero image based on darkSolidTheme
    // however we can override this behavior if showAnimatedHero is explicitly set
    const showAnimated = showAnimatedHero !== undefined ? showAnimatedHero : !darkSolidTheme;
    (0, $1oC0p.useEffect)(()=>{
        const getaaCompleteQueryObj = (0, $2gCne.getLocalStorage)((0, $1Q6XY.AA_AUTOCOMPLETE_POTENTIAL_CONVERSION_EVENT_LOCAL_STORAGE_KEY));
        if (getaaCompleteQueryObj) {
            const parsedStringifyAttributes = JSON.parse(getaaCompleteQueryObj);
            (0, $1Q6XY.sendConversionEventAlgolia)({
                objectID: parsedStringifyAttributes.objectID,
                queryID: parsedStringifyAttributes.queryID,
                position: parsedStringifyAttributes.position
            });
        }
    }, []);
    const anchorsWithServiceCollectionHeader = [
        'anchor-lp-jsm-esm',
        'anchor-lp-jsm-team-operations',
        'paid-lp-jsm-features',
        'paid-lp-jsm-itsm'
    ];
    const showServiceCollectionHeader = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp9287JSMAnchorUpdates) && Boolean(pageId && anchorsWithServiceCollectionHeader.includes(pageId));
    const enhableCustomerServiceManagementVariant = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).enableCsmAjLogo) && pageId === 'anchor-lp-jsm-csm';
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx2vrvc _zulpzwfg _85i5gad4 _1bah1h6o _4cvr1h6o _ogq01wqb _p56c1wqb _na0i1bp4 _v736zwfg _chtuzwfg",
            animation && "_na0i1sxn",
            !hasBannerAlert && "_1q51tpru"
        ]),
        style: {
            "--_1e5oe7u": (0, $6ZVlx.default)(darkSolidTheme ? '60px' : '40px')
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _16jlkb7n _10jxdgin _dh1a1h6o",
                    showEyeLash && "_10jx1kx4",
                    heroBgColor !== 'bgWhite' && "_syaz1afi"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            showEyeLash && "_kqswh2mm"
                        ]),
                        children: [
                            showEyeLash && /*#__PURE__*/ (0, $7VQPk.jsx)($900a26def99a782c$var$EyeLash, {}),
                            (enhableCustomerServiceManagementVariant || showServiceCollectionHeader) && /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                className: (0, $2jatx.default)([
                                    "_1e0c116y _4cvr1h6o _zulp1xs6 _k48p1kze"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                        children: "PART OF"
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($900a26def99a782c$var$ServiceCollectionLogoBrand, {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                                className: (0, $2jatx.default)([
                                    "_1dyzidpf _1pfhidpf _6rthidpf _k48pbfng _1wybviql _vwz410nf _y3gn1h6o _uj6k1e5h _1hwfyn4p _cr9zzz36 _1awl7vkz _h60i1wto _s3b91k7u _1qir1tcg",
                                    hasRebrandedSignupFormStyles && "_k48p9y44"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3LcIp.BanditsHeaderWrapper), {
                                    product: "confluence",
                                    type: "header",
                                    children: header
                                })
                            })
                        ]
                    }),
                    darkSolidTheme && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_6rth7vkz _y3gn1h6o _uj6k1e5h",
                            heroBgColor !== 'bgWhite' && "_syaz1afi"
                        ]),
                        style: {
                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                        },
                        children: subheader
                    }),
                    showScribble && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_syaz1pfd _ect4z4z1 _1wyb7vkz _zg8l4jg8 _k48p1nn1 _vwz41tcg _1mjb1txw _o5kc1e5h"
                                ]),
                                style: {
                                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                                },
                                children: subheader
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)($900a26def99a782c$var$Scribble, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_p12f1feq _1bsb1osq"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j2b52.ClientOnly), {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2opLs.PaidAccountCreation), {
                                darkSolidTheme: darkSolidTheme,
                                showFourSocialButtons: showFourSocialButtons,
                                auxiaResponse: auxiaResponse,
                                pageId: pageId
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb1osq _p12fcv93"
                ]),
                children: [
                    animation && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)($900a26def99a782c$var$AnimationWrapper, {
                            ...animation
                        })
                    }),
                    showAnimated && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _1h1th1c8 _4t3i1wug _1tket94y _1bsb1osq _1ul91c3h _p12f1c3h _1e0c1txw _4cvr1h6o _1bah1h6o _s6371ogm _1y8o1c3h _1mjbglyw _ca0q1ul9 _u5f31ul9 _n3td1ul9 _19bv1ul9"
                        ]),
                        children: [
                            (darkSolidTheme || hasRebrandedSignupFormStyles) && /*#__PURE__*/ (0, $7VQPk.jsx)($900a26def99a782c$var$Squares, {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7kIQK.AnimatedJiraTour), {
                                ...animatedJiraTourProps,
                                className: (0, $2jatx.default)([
                                    "_kqswstnw _152t16gx _rjxp9by0 _1e029by0 _u7co16gx _1pbyzo7u"
                                ])
                            })
                        ]
                    }),
                    carouselHeroProps ? carouselHeroProps.slides?.[0]?.['videoSrcMp4'] ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_4cvr1h6o _1e0c1txw _1bah1h6o _1bsbcv93 _4t3i1ogm _1rfm1osq _tnru1osq"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g85aC.VideoCarousel), {
                            ...carouselHeroProps
                        })
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3LcIp.BanditsAssetWrapper), {
                        product: "confluence",
                        showChildren: false,
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_4cvr1h6o _1e0c1txw _1bah1h6o _1bsbcv93 _4t3i1ogm _1rfm1osq _tnru1osq"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iL9dx.Carousel), {
                                ...carouselHeroProps
                            })
                        })
                    }) : (image || heroImageSubheader) && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            showAnimated ? "_1e0cglyw _1mjb1txw _o5kc1h6o _na0i1bp4" : "_1bsbstmo _1wpz1h6o _1mjb1txw _o5kc1h6o _na0i1bp4 _1rfm1wug"
                        ]),
                        children: [
                            image && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                image: image,
                                style: {
                                    maxWidth: '100%',
                                    height: 'auto'
                                }
                            }),
                            heroImageSubheader && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: (0, (/*@__PURE__*/$parcel$interopDefault($a0utR)))(heroImageSubheader)
                                },
                                className: (0, $2jatx.default)([
                                    "_ca0qidpf _u5f39by0 _n3tdidpf _19bv9by0",
                                    heroBgColor !== 'bgWhite' && "_syaz1afi"
                                ]),
                                style: {
                                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$900a26def99a782c$export$b2d485e7a33c4d4a.displayName = 'PaidHero';

});
parcelRegister("2u2Jd", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hxJDR = parcelRequire("hxJDR");
var $1cf07fdf0b6a767a$var$_extends3 = $1cf07fdf0b6a767a$var$_interopRequireDefault($hxJDR);

var $assfS = parcelRequire("assfS");
var $1cf07fdf0b6a767a$var$_getPrototypeOf2 = $1cf07fdf0b6a767a$var$_interopRequireDefault($assfS);

var $6hpgc = parcelRequire("6hpgc");
var $1cf07fdf0b6a767a$var$_classCallCheck3 = $1cf07fdf0b6a767a$var$_interopRequireDefault($6hpgc);

var $eoU9h = parcelRequire("eoU9h");
var $1cf07fdf0b6a767a$var$_createClass3 = $1cf07fdf0b6a767a$var$_interopRequireDefault($eoU9h);

var $arjX2 = parcelRequire("arjX2");
var $1cf07fdf0b6a767a$var$_possibleConstructorReturn3 = $1cf07fdf0b6a767a$var$_interopRequireDefault($arjX2);

var $fpmbk = parcelRequire("fpmbk");
var $1cf07fdf0b6a767a$var$_inherits3 = $1cf07fdf0b6a767a$var$_interopRequireDefault($fpmbk);

var $1oC0p = parcelRequire("1oC0p");
var $1cf07fdf0b6a767a$var$_react2 = $1cf07fdf0b6a767a$var$_interopRequireDefault($1oC0p);

var $4OgEb = parcelRequire("4OgEb");
var $1cf07fdf0b6a767a$var$_propTypes2 = $1cf07fdf0b6a767a$var$_interopRequireDefault($4OgEb);

var $lDo4H = parcelRequire("lDo4H");
var $1cf07fdf0b6a767a$var$_lottieWeb2 = $1cf07fdf0b6a767a$var$_interopRequireDefault($lDo4H);
function $1cf07fdf0b6a767a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1cf07fdf0b6a767a$var$Lottie = function(_React$Component) {
    (0, $1cf07fdf0b6a767a$var$_inherits3.default)(Lottie, _React$Component);
    function Lottie() {
        var _ref;
        var _temp, _this, _ret;
        (0, $1cf07fdf0b6a767a$var$_classCallCheck3.default)(this, Lottie);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = (0, $1cf07fdf0b6a767a$var$_possibleConstructorReturn3.default)(this, (_ref = Lottie.__proto__ || (0, $1cf07fdf0b6a767a$var$_getPrototypeOf2.default)(Lottie)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.handleClickToPause = function() {
            // The pause() method is for handling pausing by passing a prop isPaused
            // This method is for handling the ability to pause by clicking on the animation
            if (_this.anim.isPaused) _this.anim.play();
            else _this.anim.pause();
        }, _temp), (0, $1cf07fdf0b6a767a$var$_possibleConstructorReturn3.default)(_this, _ret);
    }
    (0, $1cf07fdf0b6a767a$var$_createClass3.default)(Lottie, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _props = this.props, options = _props.options, eventListeners = _props.eventListeners;
                var loop = options.loop, autoplay = options.autoplay, animationData = options.animationData, rendererSettings = options.rendererSettings, segments = options.segments;
                this.options = {
                    container: this.el,
                    renderer: 'svg',
                    loop: loop !== false,
                    autoplay: autoplay !== false,
                    segments: segments !== false,
                    animationData: animationData,
                    rendererSettings: rendererSettings
                };
                this.options = (0, $1cf07fdf0b6a767a$var$_extends3.default)({}, this.options, options);
                this.anim = $1cf07fdf0b6a767a$var$_lottieWeb2.default.loadAnimation(this.options);
                this.registerEvents(eventListeners);
            }
        },
        {
            key: 'componentWillUpdate',
            value: function componentWillUpdate(nextProps /* , nextState */ ) {
                /* Recreate the animation handle if the data is changed */ if (this.options.animationData !== nextProps.options.animationData) {
                    this.deRegisterEvents(this.props.eventListeners);
                    this.destroy();
                    this.options = (0, $1cf07fdf0b6a767a$var$_extends3.default)({}, this.options, nextProps.options);
                    this.anim = $1cf07fdf0b6a767a$var$_lottieWeb2.default.loadAnimation(this.options);
                    this.registerEvents(nextProps.eventListeners);
                }
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate() {
                if (this.props.isStopped) this.stop();
                else if (this.props.segments) this.playSegments();
                else this.play();
                this.pause();
                this.setSpeed();
                this.setDirection();
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.deRegisterEvents(this.props.eventListeners);
                this.destroy();
                this.options.animationData = null;
                this.anim = null;
            }
        },
        {
            key: 'setSpeed',
            value: function setSpeed() {
                this.anim.setSpeed(this.props.speed);
            }
        },
        {
            key: 'setDirection',
            value: function setDirection() {
                this.anim.setDirection(this.props.direction);
            }
        },
        {
            key: 'play',
            value: function play() {
                this.anim.play();
            }
        },
        {
            key: 'playSegments',
            value: function playSegments() {
                this.anim.playSegments(this.props.segments);
            }
        },
        {
            key: 'stop',
            value: function stop() {
                this.anim.stop();
            }
        },
        {
            key: 'pause',
            value: function pause() {
                if (this.props.isPaused && !this.anim.isPaused) this.anim.pause();
                else if (!this.props.isPaused && this.anim.isPaused) this.anim.pause();
            }
        },
        {
            key: 'destroy',
            value: function destroy() {
                this.anim.destroy();
            }
        },
        {
            key: 'registerEvents',
            value: function registerEvents(eventListeners) {
                var _this2 = this;
                eventListeners.forEach(function(eventListener) {
                    _this2.anim.addEventListener(eventListener.eventName, eventListener.callback);
                });
            }
        },
        {
            key: 'deRegisterEvents',
            value: function deRegisterEvents(eventListeners) {
                var _this3 = this;
                eventListeners.forEach(function(eventListener) {
                    _this3.anim.removeEventListener(eventListener.eventName, eventListener.callback);
                });
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this4 = this;
                var _props2 = this.props, width = _props2.width, height = _props2.height, ariaRole = _props2.ariaRole, ariaLabel = _props2.ariaLabel, isClickToPauseDisabled = _props2.isClickToPauseDisabled, title = _props2.title;
                var getSize = function getSize(initial) {
                    var size = void 0;
                    if (typeof initial === 'number') size = initial + 'px';
                    else size = initial || '100%';
                    return size;
                };
                var lottieStyles = (0, $1cf07fdf0b6a767a$var$_extends3.default)({
                    width: getSize(width),
                    height: getSize(height),
                    overflow: 'hidden',
                    margin: '0 auto',
                    outline: 'none'
                }, this.props.style);
                var onClickHandler = isClickToPauseDisabled ? function() {
                    return null;
                } : this.handleClickToPause;
                return(// Bug with eslint rules https://github.com/airbnb/javascript/issues/1374
                // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                $1cf07fdf0b6a767a$var$_react2.default.createElement('div', {
                    ref: function ref(c) {
                        _this4.el = c;
                    },
                    style: lottieStyles,
                    onClick: onClickHandler,
                    title: title,
                    role: ariaRole,
                    'aria-label': ariaLabel,
                    tabIndex: '0'
                }));
            }
        }
    ]);
    return Lottie;
}($1cf07fdf0b6a767a$var$_react2.default.Component);
module.exports.default = $1cf07fdf0b6a767a$var$Lottie;
$1cf07fdf0b6a767a$var$Lottie.propTypes = {
    eventListeners: $1cf07fdf0b6a767a$var$_propTypes2.default.arrayOf($1cf07fdf0b6a767a$var$_propTypes2.default.object),
    options: $1cf07fdf0b6a767a$var$_propTypes2.default.object.isRequired,
    height: $1cf07fdf0b6a767a$var$_propTypes2.default.oneOfType([
        $1cf07fdf0b6a767a$var$_propTypes2.default.string,
        $1cf07fdf0b6a767a$var$_propTypes2.default.number
    ]),
    width: $1cf07fdf0b6a767a$var$_propTypes2.default.oneOfType([
        $1cf07fdf0b6a767a$var$_propTypes2.default.string,
        $1cf07fdf0b6a767a$var$_propTypes2.default.number
    ]),
    isStopped: $1cf07fdf0b6a767a$var$_propTypes2.default.bool,
    isPaused: $1cf07fdf0b6a767a$var$_propTypes2.default.bool,
    speed: $1cf07fdf0b6a767a$var$_propTypes2.default.number,
    segments: $1cf07fdf0b6a767a$var$_propTypes2.default.arrayOf($1cf07fdf0b6a767a$var$_propTypes2.default.number),
    direction: $1cf07fdf0b6a767a$var$_propTypes2.default.number,
    ariaRole: $1cf07fdf0b6a767a$var$_propTypes2.default.string,
    ariaLabel: $1cf07fdf0b6a767a$var$_propTypes2.default.string,
    isClickToPauseDisabled: $1cf07fdf0b6a767a$var$_propTypes2.default.bool,
    title: $1cf07fdf0b6a767a$var$_propTypes2.default.string,
    style: $1cf07fdf0b6a767a$var$_propTypes2.default.string
};
$1cf07fdf0b6a767a$var$Lottie.defaultProps = {
    eventListeners: [],
    isStopped: false,
    isPaused: false,
    speed: 1,
    ariaRole: 'button',
    ariaLabel: 'animation',
    isClickToPauseDisabled: false,
    title: ''
};

});
parcelRegister("hxJDR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", function () { return $cc58ec3eb70ca8a9$export$1e511d4a378977f5; }, function (v) { return $cc58ec3eb70ca8a9$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $cc58ec3eb70ca8a9$export$2e2bcd8739ae039; }, function (v) { return $cc58ec3eb70ca8a9$export$2e2bcd8739ae039 = v; });
var $cc58ec3eb70ca8a9$export$1e511d4a378977f5;
var $cc58ec3eb70ca8a9$export$2e2bcd8739ae039;
"use strict";
$cc58ec3eb70ca8a9$export$1e511d4a378977f5 = true;

var $5Ibi5 = parcelRequire("5Ibi5");
var $cc58ec3eb70ca8a9$var$_assign2 = $cc58ec3eb70ca8a9$var$_interopRequireDefault($5Ibi5);
function $cc58ec3eb70ca8a9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$cc58ec3eb70ca8a9$export$2e2bcd8739ae039 = $cc58ec3eb70ca8a9$var$_assign2.default || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

});
parcelRegister("5Ibi5", function(module, exports) {

module.exports = {
    "default": (parcelRequire("3aJcb")),
    __esModule: true
};

});
parcelRegister("3aJcb", function(module, exports) {
parcelRequire("fsMh2");

module.exports = (parcelRequire("23f7N")).Object.assign;

});
parcelRegister("fsMh2", function(module, exports) {
// 19.1.3.1 Object.assign(target, source)

var $6TZmN = parcelRequire("6TZmN");

$6TZmN($6TZmN.S + $6TZmN.F, 'Object', {
    assign: (parcelRequire("cNTzW"))
});

});
parcelRegister("6TZmN", function(module, exports) {

var $4FFa4 = parcelRequire("4FFa4");

var $23f7N = parcelRequire("23f7N");

var $04VsN = parcelRequire("04VsN");

var $1XBAS = parcelRequire("1XBAS");

var $763mL = parcelRequire("763mL");
var $50677b4cdf98284c$var$PROTOTYPE = 'prototype';
var $50677b4cdf98284c$var$$export = function(type, name, source) {
    var IS_FORCED = type & $50677b4cdf98284c$var$$export.F;
    var IS_GLOBAL = type & $50677b4cdf98284c$var$$export.G;
    var IS_STATIC = type & $50677b4cdf98284c$var$$export.S;
    var IS_PROTO = type & $50677b4cdf98284c$var$$export.P;
    var IS_BIND = type & $50677b4cdf98284c$var$$export.B;
    var IS_WRAP = type & $50677b4cdf98284c$var$$export.W;
    var exports = IS_GLOBAL ? $23f7N : $23f7N[name] || ($23f7N[name] = {});
    var expProto = exports[$50677b4cdf98284c$var$PROTOTYPE];
    var target = IS_GLOBAL ? $4FFa4 : IS_STATIC ? $4FFa4[name] : ($4FFa4[name] || {})[$50677b4cdf98284c$var$PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && $763mL(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? $04VsN(out, $4FFa4) : IS_WRAP && target[key] == out ? function(C) {
            var F = function(a, b, c) {
                if (this instanceof C) {
                    switch(arguments.length){
                        case 0:
                            return new C();
                        case 1:
                            return new C(a);
                        case 2:
                            return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            F[$50677b4cdf98284c$var$PROTOTYPE] = C[$50677b4cdf98284c$var$PROTOTYPE];
            return F;
        // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == 'function' ? $04VsN(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $50677b4cdf98284c$var$$export.R && expProto && !expProto[key]) $1XBAS(expProto, key, out);
        }
    }
};
// type bitmap
$50677b4cdf98284c$var$$export.F = 1; // forced
$50677b4cdf98284c$var$$export.G = 2; // global
$50677b4cdf98284c$var$$export.S = 4; // static
$50677b4cdf98284c$var$$export.P = 8; // proto
$50677b4cdf98284c$var$$export.B = 16; // bind
$50677b4cdf98284c$var$$export.W = 32; // wrap
$50677b4cdf98284c$var$$export.U = 64; // safe
$50677b4cdf98284c$var$$export.R = 128; // real proto method for `library`
module.exports = $50677b4cdf98284c$var$$export;

});
parcelRegister("4FFa4", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $366aeb9262291f44$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $366aeb9262291f44$var$global; // eslint-disable-line no-undef

});

parcelRegister("23f7N", function(module, exports) {
var $17e7980f5bcf229c$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $17e7980f5bcf229c$var$core; // eslint-disable-line no-undef

});

parcelRegister("04VsN", function(module, exports) {
// optional / simple context binding

var $2045g = parcelRequire("2045g");
module.exports = function(fn, that, length) {
    $2045g(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("2045g", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});


parcelRegister("1XBAS", function(module, exports) {

var $19vSD = parcelRequire("19vSD");

var $kKJnZ = parcelRequire("kKJnZ");

module.exports = (parcelRequire("2PPTD")) ? function(object, key, value) {
    return $19vSD.f(object, key, $kKJnZ(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("19vSD", function(module, exports) {
$parcel$export(module.exports, "f", function () { return $0d6f5c78ac7c57a6$export$2d1720544b23b823; }, function (v) { return $0d6f5c78ac7c57a6$export$2d1720544b23b823 = v; });
var $0d6f5c78ac7c57a6$export$2d1720544b23b823;

var $5asEa = parcelRequire("5asEa");

var $1Vpr5 = parcelRequire("1Vpr5");

var $bIV2P = parcelRequire("bIV2P");
var $0d6f5c78ac7c57a6$var$dP = Object.defineProperty;

$0d6f5c78ac7c57a6$export$2d1720544b23b823 = (parcelRequire("2PPTD")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $5asEa(O);
    P = $bIV2P(P, true);
    $5asEa(Attributes);
    if ($1Vpr5) try {
        return $0d6f5c78ac7c57a6$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("5asEa", function(module, exports) {

var $7QZ8S = parcelRequire("7QZ8S");
module.exports = function(it) {
    if (!$7QZ8S(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("7QZ8S", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("1Vpr5", function(module, exports) {



module.exports = !(parcelRequire("2PPTD")) && !(parcelRequire("hs8hK"))(function() {
    return Object.defineProperty((parcelRequire("kjubI"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("2PPTD", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("hs8hK"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("hs8hK", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("kjubI", function(module, exports) {

var $7QZ8S = parcelRequire("7QZ8S");

var $4FFa4 = parcelRequire("4FFa4");
var $ec9cffabb69d468c$require$document = $4FFa4.document;
// typeof document.createElement is 'object' in old IE
var $ec9cffabb69d468c$var$is = $7QZ8S($ec9cffabb69d468c$require$document) && $7QZ8S($ec9cffabb69d468c$require$document.createElement);
module.exports = function(it) {
    return $ec9cffabb69d468c$var$is ? $ec9cffabb69d468c$require$document.createElement(it) : {};
};

});


parcelRegister("bIV2P", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $7QZ8S = parcelRequire("7QZ8S");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$7QZ8S(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$7QZ8S(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$7QZ8S(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$7QZ8S(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("kKJnZ", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});


parcelRegister("763mL", function(module, exports) {
var $52abb468452e06ed$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $52abb468452e06ed$var$hasOwnProperty.call(it, key);
};

});


parcelRegister("cNTzW", function(module, exports) {
'use strict';

var $2PPTD = parcelRequire("2PPTD");

var $E0yCE = parcelRequire("E0yCE");

var $jBejz = parcelRequire("jBejz");

var $gGh3r = parcelRequire("gGh3r");

var $7tWaA = parcelRequire("7tWaA");

var $kMWzF = parcelRequire("kMWzF");
var $95252c6fd67bc852$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$95252c6fd67bc852$var$$assign || (parcelRequire("hs8hK"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $95252c6fd67bc852$var$$assign({}, A)[S] != 7 || Object.keys($95252c6fd67bc852$var$$assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = $7tWaA(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $jBejz.f;
    var isEnum = $gGh3r.f;
    while(aLen > index){
        var S = $kMWzF(arguments[index++]);
        var keys = getSymbols ? $E0yCE(S).concat(getSymbols(S)) : $E0yCE(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$2PPTD || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $95252c6fd67bc852$var$$assign;

});
parcelRegister("E0yCE", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $64rCp = parcelRequire("64rCp");

var $f5whe = parcelRequire("f5whe");
module.exports = Object.keys || function keys(O) {
    return $64rCp(O, $f5whe);
};

});
parcelRegister("64rCp", function(module, exports) {

var $763mL = parcelRequire("763mL");

var $2hx6g = parcelRequire("2hx6g");

var $46b88a3ecfad9eac$var$arrayIndexOf = (parcelRequire("5sIDY"))(false);

var $46b88a3ecfad9eac$var$IE_PROTO = (parcelRequire("9gke3"))('IE_PROTO');
module.exports = function(object, names) {
    var O = $2hx6g(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $46b88a3ecfad9eac$var$IE_PROTO) $763mL(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($763mL(O, key = names[i++])) ~$46b88a3ecfad9eac$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});
parcelRegister("2hx6g", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $kMWzF = parcelRequire("kMWzF");

var $bwTK5 = parcelRequire("bwTK5");
module.exports = function(it) {
    return $kMWzF($bwTK5(it));
};

});
parcelRegister("kMWzF", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $gNg6c = parcelRequire("gNg6c");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return $gNg6c(it) == 'String' ? it.split('') : Object(it);
};

});
parcelRegister("gNg6c", function(module, exports) {
var $c39db5dd98abd16e$var$toString = {}.toString;
module.exports = function(it) {
    return $c39db5dd98abd16e$var$toString.call(it).slice(8, -1);
};

});


parcelRegister("bwTK5", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("5sIDY", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $2hx6g = parcelRequire("2hx6g");

var $f0lw7 = parcelRequire("f0lw7");

var $6AE42 = parcelRequire("6AE42");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $2hx6g($this);
        var length = $f0lw7(O.length);
        var index = $6AE42(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("f0lw7", function(module, exports) {
// 7.1.15 ToLength

var $3ylxK = parcelRequire("3ylxK");
var $aec78bf4e7ec90d9$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $aec78bf4e7ec90d9$var$min($3ylxK(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});
parcelRegister("3ylxK", function(module, exports) {
// 7.1.4 ToInteger
var $2965421f6a410d04$var$ceil = Math.ceil;
var $2965421f6a410d04$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $2965421f6a410d04$var$floor : $2965421f6a410d04$var$ceil)(it);
};

});


parcelRegister("6AE42", function(module, exports) {

var $3ylxK = parcelRequire("3ylxK");
var $4cc52ebfd89326d3$var$max = Math.max;
var $4cc52ebfd89326d3$var$min = Math.min;
module.exports = function(index, length) {
    index = $3ylxK(index);
    return index < 0 ? $4cc52ebfd89326d3$var$max(index + length, 0) : $4cc52ebfd89326d3$var$min(index, length);
};

});


parcelRegister("9gke3", function(module, exports) {

var $6be54c1617561861$var$shared = (parcelRequire("izZ3Q"))('keys');

var $hoAgo = parcelRequire("hoAgo");
module.exports = function(key) {
    return $6be54c1617561861$var$shared[key] || ($6be54c1617561861$var$shared[key] = $hoAgo(key));
};

});
parcelRegister("izZ3Q", function(module, exports) {

var $23f7N = parcelRequire("23f7N");

var $4FFa4 = parcelRequire("4FFa4");
var $d86adc506cb5ba45$var$SHARED = '__core-js_shared__';
var $d86adc506cb5ba45$var$store = $4FFa4[$d86adc506cb5ba45$var$SHARED] || ($4FFa4[$d86adc506cb5ba45$var$SHARED] = {});

(module.exports = function(key, value) {
    return $d86adc506cb5ba45$var$store[key] || ($d86adc506cb5ba45$var$store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: $23f7N.version,
    mode: (parcelRequire("jHsIx")) ? 'pure' : 'global',
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("jHsIx", function(module, exports) {
module.exports = true;

});


parcelRegister("hoAgo", function(module, exports) {
var $caa0ceb2324f08b0$var$id = 0;
var $caa0ceb2324f08b0$var$px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$caa0ceb2324f08b0$var$id + $caa0ceb2324f08b0$var$px).toString(36));
};

});



parcelRegister("f5whe", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

});


parcelRegister("jBejz", function(module, exports) {
$parcel$export(module.exports, "f", function () { return $e44c939e5b5d76a8$export$2d1720544b23b823; }, function (v) { return $e44c939e5b5d76a8$export$2d1720544b23b823 = v; });
var $e44c939e5b5d76a8$export$2d1720544b23b823;
$e44c939e5b5d76a8$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});

parcelRegister("gGh3r", function(module, exports) {
$parcel$export(module.exports, "f", function () { return $c24dcc42a8b9bb86$export$2d1720544b23b823; }, function (v) { return $c24dcc42a8b9bb86$export$2d1720544b23b823 = v; });
var $c24dcc42a8b9bb86$export$2d1720544b23b823;
$c24dcc42a8b9bb86$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});

parcelRegister("7tWaA", function(module, exports) {
// 7.1.13 ToObject(argument)

var $bwTK5 = parcelRequire("bwTK5");
module.exports = function(it) {
    return Object($bwTK5(it));
};

});






parcelRegister("assfS", function(module, exports) {

module.exports = {
    "default": (parcelRequire("5rUW5")),
    __esModule: true
};

});
parcelRegister("5rUW5", function(module, exports) {
parcelRequire("iULCI");

module.exports = (parcelRequire("23f7N")).Object.getPrototypeOf;

});
parcelRegister("iULCI", function(module, exports) {
// 19.1.2.9 Object.getPrototypeOf(O)

var $7tWaA = parcelRequire("7tWaA");

var $kxvda = parcelRequire("kxvda");

(parcelRequire("bcSMG"))('getPrototypeOf', function() {
    return function getPrototypeOf(it) {
        return $kxvda($7tWaA(it));
    };
});

});
parcelRegister("kxvda", function(module, exports) {
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)

var $763mL = parcelRequire("763mL");

var $7tWaA = parcelRequire("7tWaA");

var $ef3f19ab31140719$var$IE_PROTO = (parcelRequire("9gke3"))('IE_PROTO');
var $ef3f19ab31140719$var$ObjectProto = Object.prototype;
module.exports = Object.getPrototypeOf || function(O) {
    O = $7tWaA(O);
    if ($763mL(O, $ef3f19ab31140719$var$IE_PROTO)) return O[$ef3f19ab31140719$var$IE_PROTO];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) return O.constructor.prototype;
    return O instanceof Object ? $ef3f19ab31140719$var$ObjectProto : null;
};

});

parcelRegister("bcSMG", function(module, exports) {
// most Object methods by ES6 should accept primitives

var $6TZmN = parcelRequire("6TZmN");

var $23f7N = parcelRequire("23f7N");

var $hs8hK = parcelRequire("hs8hK");
module.exports = function(KEY, exec) {
    var fn = ($23f7N.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $6TZmN($6TZmN.S + $6TZmN.F * $hs8hK(function() {
        fn(1);
    }), 'Object', exp);
};

});




parcelRegister("6hpgc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", function () { return $4927ecc8d63b2fec$export$1e511d4a378977f5; }, function (v) { return $4927ecc8d63b2fec$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $4927ecc8d63b2fec$export$2e2bcd8739ae039; }, function (v) { return $4927ecc8d63b2fec$export$2e2bcd8739ae039 = v; });
var $4927ecc8d63b2fec$export$1e511d4a378977f5;
var $4927ecc8d63b2fec$export$2e2bcd8739ae039;
"use strict";
$4927ecc8d63b2fec$export$1e511d4a378977f5 = true;
$4927ecc8d63b2fec$export$2e2bcd8739ae039 = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};

});

parcelRegister("eoU9h", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", function () { return $a7bedc85ff7818cc$export$1e511d4a378977f5; }, function (v) { return $a7bedc85ff7818cc$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $a7bedc85ff7818cc$export$2e2bcd8739ae039; }, function (v) { return $a7bedc85ff7818cc$export$2e2bcd8739ae039 = v; });
var $a7bedc85ff7818cc$export$1e511d4a378977f5;
var $a7bedc85ff7818cc$export$2e2bcd8739ae039;
"use strict";
$a7bedc85ff7818cc$export$1e511d4a378977f5 = true;

var $eYaOS = parcelRequire("eYaOS");
var $a7bedc85ff7818cc$var$_defineProperty2 = $a7bedc85ff7818cc$var$_interopRequireDefault($eYaOS);
function $a7bedc85ff7818cc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$a7bedc85ff7818cc$export$2e2bcd8739ae039 = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            (0, $a7bedc85ff7818cc$var$_defineProperty2.default)(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

});
parcelRegister("eYaOS", function(module, exports) {

module.exports = {
    "default": (parcelRequire("kxJeH")),
    __esModule: true
};

});
parcelRegister("kxJeH", function(module, exports) {
parcelRequire("hlCNl");

var $23f7N = parcelRequire("23f7N");
var $ef49faa80d2c2f9b$require$$Object = $23f7N.Object;
module.exports = function defineProperty(it, key, desc) {
    return $ef49faa80d2c2f9b$require$$Object.defineProperty(it, key, desc);
};

});
parcelRegister("hlCNl", function(module, exports) {

var $6TZmN = parcelRequire("6TZmN");


// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$6TZmN($6TZmN.S + $6TZmN.F * !(parcelRequire("2PPTD")), 'Object', {
    defineProperty: (parcelRequire("19vSD")).f
});

});




parcelRegister("arjX2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", function () { return $799be6e526c9d7f5$export$1e511d4a378977f5; }, function (v) { return $799be6e526c9d7f5$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $799be6e526c9d7f5$export$2e2bcd8739ae039; }, function (v) { return $799be6e526c9d7f5$export$2e2bcd8739ae039 = v; });
var $799be6e526c9d7f5$export$1e511d4a378977f5;
var $799be6e526c9d7f5$export$2e2bcd8739ae039;
"use strict";
$799be6e526c9d7f5$export$1e511d4a378977f5 = true;

var $frdl0 = parcelRequire("frdl0");
var $799be6e526c9d7f5$var$_typeof3 = $799be6e526c9d7f5$var$_interopRequireDefault($frdl0);
function $799be6e526c9d7f5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$799be6e526c9d7f5$export$2e2bcd8739ae039 = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && ((typeof call === "undefined" ? "undefined" : (0, $799be6e526c9d7f5$var$_typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

});
parcelRegister("frdl0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", function () { return $b3d3b93c2659cce8$export$1e511d4a378977f5; }, function (v) { return $b3d3b93c2659cce8$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $b3d3b93c2659cce8$export$2e2bcd8739ae039; }, function (v) { return $b3d3b93c2659cce8$export$2e2bcd8739ae039 = v; });
var $b3d3b93c2659cce8$export$1e511d4a378977f5;
var $b3d3b93c2659cce8$export$2e2bcd8739ae039;
"use strict";
$b3d3b93c2659cce8$export$1e511d4a378977f5 = true;

var $73CEX = parcelRequire("73CEX");
var $b3d3b93c2659cce8$var$_iterator2 = $b3d3b93c2659cce8$var$_interopRequireDefault($73CEX);

var $7xVAR = parcelRequire("7xVAR");
var $b3d3b93c2659cce8$var$_symbol2 = $b3d3b93c2659cce8$var$_interopRequireDefault($7xVAR);
var $b3d3b93c2659cce8$var$_typeof = typeof $b3d3b93c2659cce8$var$_symbol2.default === "function" && typeof $b3d3b93c2659cce8$var$_iterator2.default === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof $b3d3b93c2659cce8$var$_symbol2.default === "function" && obj.constructor === $b3d3b93c2659cce8$var$_symbol2.default && obj !== $b3d3b93c2659cce8$var$_symbol2.default.prototype ? "symbol" : typeof obj;
};
function $b3d3b93c2659cce8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$b3d3b93c2659cce8$export$2e2bcd8739ae039 = typeof $b3d3b93c2659cce8$var$_symbol2.default === "function" && $b3d3b93c2659cce8$var$_typeof($b3d3b93c2659cce8$var$_iterator2.default) === "symbol" ? function(obj) {
    return typeof obj === "undefined" ? "undefined" : $b3d3b93c2659cce8$var$_typeof(obj);
} : function(obj) {
    return obj && typeof $b3d3b93c2659cce8$var$_symbol2.default === "function" && obj.constructor === $b3d3b93c2659cce8$var$_symbol2.default && obj !== $b3d3b93c2659cce8$var$_symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : $b3d3b93c2659cce8$var$_typeof(obj);
};

});
parcelRegister("73CEX", function(module, exports) {

module.exports = {
    "default": (parcelRequire("kX62j")),
    __esModule: true
};

});
parcelRegister("kX62j", function(module, exports) {
parcelRequire("kvp0v");
parcelRequire("a6Pd3");

module.exports = (parcelRequire("iY0Fa")).f('iterator');

});
parcelRegister("kvp0v", function(module, exports) {
'use strict';

var $eeda19c7512e8b4e$var$$at = (parcelRequire("evNBk"))(true);

// 21.1.3.27 String.prototype[@@iterator]()
(parcelRequire("1MYRJ"))(String, 'String', function(iterated) {
    this._t = String(iterated); // target
    this._i = 0; // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return {
        value: undefined,
        done: true
    };
    point = $eeda19c7512e8b4e$var$$at(O, index);
    this._i += point.length;
    return {
        value: point,
        done: false
    };
});

});
parcelRegister("evNBk", function(module, exports) {

var $3ylxK = parcelRequire("3ylxK");

var $bwTK5 = parcelRequire("bwTK5");
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING) {
    return function(that, pos) {
        var s = String($bwTK5(that));
        var i = $3ylxK(pos);
        var l = s.length;
        var a, b;
        if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
        a = s.charCodeAt(i);
        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
};

});

parcelRegister("1MYRJ", function(module, exports) {
'use strict';

var $jHsIx = parcelRequire("jHsIx");

var $6TZmN = parcelRequire("6TZmN");

var $aDsEo = parcelRequire("aDsEo");

var $1XBAS = parcelRequire("1XBAS");

var $aODcA = parcelRequire("aODcA");

var $gRPe6 = parcelRequire("gRPe6");

var $jr22O = parcelRequire("jr22O");

var $kxvda = parcelRequire("kxvda");

var $14d97ccfd41e5645$var$ITERATOR = (parcelRequire("9xDAg"))('iterator');
var $14d97ccfd41e5645$var$BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var $14d97ccfd41e5645$var$FF_ITERATOR = '@@iterator';
var $14d97ccfd41e5645$var$KEYS = 'keys';
var $14d97ccfd41e5645$var$VALUES = 'values';
var $14d97ccfd41e5645$var$returnThis = function() {
    return this;
};
module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $gRPe6(Constructor, NAME, next);
    var getMethod = function(kind) {
        if (!$14d97ccfd41e5645$var$BUGGY && kind in proto) return proto[kind];
        switch(kind){
            case $14d97ccfd41e5645$var$KEYS:
                return function keys() {
                    return new Constructor(this, kind);
                };
            case $14d97ccfd41e5645$var$VALUES:
                return function values() {
                    return new Constructor(this, kind);
                };
        }
        return function entries() {
            return new Constructor(this, kind);
        };
    };
    var TAG = NAME + ' Iterator';
    var DEF_VALUES = DEFAULT == $14d97ccfd41e5645$var$VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[$14d97ccfd41e5645$var$ITERATOR] || proto[$14d97ccfd41e5645$var$FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
    var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
        IteratorPrototype = $kxvda($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            $jr22O(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!$jHsIx && typeof IteratorPrototype[$14d97ccfd41e5645$var$ITERATOR] != 'function') $1XBAS(IteratorPrototype, $14d97ccfd41e5645$var$ITERATOR, $14d97ccfd41e5645$var$returnThis);
        }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== $14d97ccfd41e5645$var$VALUES) {
        VALUES_BUG = true;
        $default = function values() {
            return $native.call(this);
        };
    }
    // Define iterator
    if ((!$jHsIx || FORCED) && ($14d97ccfd41e5645$var$BUGGY || VALUES_BUG || !proto[$14d97ccfd41e5645$var$ITERATOR])) $1XBAS(proto, $14d97ccfd41e5645$var$ITERATOR, $default);
    // Plug for library
    $aODcA[NAME] = $default;
    $aODcA[TAG] = $14d97ccfd41e5645$var$returnThis;
    if (DEFAULT) {
        methods = {
            values: DEF_VALUES ? $default : getMethod($14d97ccfd41e5645$var$VALUES),
            keys: IS_SET ? $default : getMethod($14d97ccfd41e5645$var$KEYS),
            entries: $entries
        };
        if (FORCED) {
            for(key in methods)if (!(key in proto)) $aDsEo(proto, key, methods[key]);
        } else $6TZmN($6TZmN.P + $6TZmN.F * ($14d97ccfd41e5645$var$BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
};

});
parcelRegister("aDsEo", function(module, exports) {

module.exports = (parcelRequire("1XBAS"));

});

parcelRegister("aODcA", function(module, exports) {
module.exports = {};

});

parcelRegister("gRPe6", function(module, exports) {
'use strict';

var $lmUsf = parcelRequire("lmUsf");

var $kKJnZ = parcelRequire("kKJnZ");

var $jr22O = parcelRequire("jr22O");
var $c4795519cce9da72$var$IteratorPrototype = {};


// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
(parcelRequire("1XBAS"))($c4795519cce9da72$var$IteratorPrototype, (parcelRequire("9xDAg"))('iterator'), function() {
    return this;
});
module.exports = function(Constructor, NAME, next) {
    Constructor.prototype = $lmUsf($c4795519cce9da72$var$IteratorPrototype, {
        next: $kKJnZ(1, next)
    });
    $jr22O(Constructor, NAME + ' Iterator');
};

});
parcelRegister("lmUsf", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $5asEa = parcelRequire("5asEa");

var $6Gg6R = parcelRequire("6Gg6R");

var $f5whe = parcelRequire("f5whe");

var $f8e771c717e03d19$var$IE_PROTO = (parcelRequire("9gke3"))('IE_PROTO');
var $f8e771c717e03d19$var$Empty = function() {};
var $f8e771c717e03d19$var$PROTOTYPE = 'prototype';


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $f8e771c717e03d19$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("kjubI"))('iframe');
    var i = $f5whe.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    (parcelRequire("h3ZDN")).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    $f8e771c717e03d19$var$createDict = iframeDocument.F;
    while(i--)delete $f8e771c717e03d19$var$createDict[$f8e771c717e03d19$var$PROTOTYPE][$f5whe[i]];
    return $f8e771c717e03d19$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $f8e771c717e03d19$var$Empty[$f8e771c717e03d19$var$PROTOTYPE] = $5asEa(O);
        result = new $f8e771c717e03d19$var$Empty();
        $f8e771c717e03d19$var$Empty[$f8e771c717e03d19$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$f8e771c717e03d19$var$IE_PROTO] = O;
    } else result = $f8e771c717e03d19$var$createDict();
    return Properties === undefined ? result : $6Gg6R(result, Properties);
};

});
parcelRegister("6Gg6R", function(module, exports) {

var $19vSD = parcelRequire("19vSD");

var $5asEa = parcelRequire("5asEa");

var $E0yCE = parcelRequire("E0yCE");

module.exports = (parcelRequire("2PPTD")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $5asEa(O);
    var keys = $E0yCE(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$19vSD.f(O, P = keys[i++], Properties[P]);
    return O;
};

});

parcelRegister("h3ZDN", function(module, exports) {

var $4FFa4 = parcelRequire("4FFa4");
var $c6c2880f85f59af4$require$document = $4FFa4.document;
module.exports = $c6c2880f85f59af4$require$document && $c6c2880f85f59af4$require$document.documentElement;

});


parcelRegister("jr22O", function(module, exports) {

var $19vSD = parcelRequire("19vSD");
var $e2621feb5510ea07$require$def = $19vSD.f;

var $763mL = parcelRequire("763mL");

var $e2621feb5510ea07$var$TAG = (parcelRequire("9xDAg"))('toStringTag');
module.exports = function(it, tag, stat) {
    if (it && !$763mL(it = stat ? it : it.prototype, $e2621feb5510ea07$var$TAG)) $e2621feb5510ea07$require$def(it, $e2621feb5510ea07$var$TAG, {
        configurable: true,
        value: tag
    });
};

});
parcelRegister("9xDAg", function(module, exports) {

var $6f25e6afc0784b1a$var$store = (parcelRequire("izZ3Q"))('wks');

var $hoAgo = parcelRequire("hoAgo");

var $4FFa4 = parcelRequire("4FFa4");
var $6f25e6afc0784b1a$require$Symbol = $4FFa4.Symbol;
var $6f25e6afc0784b1a$var$USE_SYMBOL = typeof $6f25e6afc0784b1a$require$Symbol == 'function';
var $6f25e6afc0784b1a$var$$exports = module.exports = function(name) {
    return $6f25e6afc0784b1a$var$store[name] || ($6f25e6afc0784b1a$var$store[name] = $6f25e6afc0784b1a$var$USE_SYMBOL && $6f25e6afc0784b1a$require$Symbol[name] || ($6f25e6afc0784b1a$var$USE_SYMBOL ? $6f25e6afc0784b1a$require$Symbol : $hoAgo)('Symbol.' + name));
};
$6f25e6afc0784b1a$var$$exports.store = $6f25e6afc0784b1a$var$store;

});





parcelRegister("a6Pd3", function(module, exports) {
parcelRequire("lP6GC");

var $4FFa4 = parcelRequire("4FFa4");

var $1XBAS = parcelRequire("1XBAS");

var $aODcA = parcelRequire("aODcA");

var $75c23011e1e94f01$var$TO_STRING_TAG = (parcelRequire("9xDAg"))('toStringTag');
var $75c23011e1e94f01$var$DOMIterables = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(',');
for(var $75c23011e1e94f01$var$i = 0; $75c23011e1e94f01$var$i < $75c23011e1e94f01$var$DOMIterables.length; $75c23011e1e94f01$var$i++){
    var $75c23011e1e94f01$var$NAME = $75c23011e1e94f01$var$DOMIterables[$75c23011e1e94f01$var$i];
    var $75c23011e1e94f01$var$Collection = $4FFa4[$75c23011e1e94f01$var$NAME];
    var $75c23011e1e94f01$var$proto = $75c23011e1e94f01$var$Collection && $75c23011e1e94f01$var$Collection.prototype;
    if ($75c23011e1e94f01$var$proto && !$75c23011e1e94f01$var$proto[$75c23011e1e94f01$var$TO_STRING_TAG]) $1XBAS($75c23011e1e94f01$var$proto, $75c23011e1e94f01$var$TO_STRING_TAG, $75c23011e1e94f01$var$NAME);
    $aODcA[$75c23011e1e94f01$var$NAME] = $aODcA.Array;
}

});
parcelRegister("lP6GC", function(module, exports) {
'use strict';

var $aWD6E = parcelRequire("aWD6E");

var $1Kz5Q = parcelRequire("1Kz5Q");

var $aODcA = parcelRequire("aODcA");

var $2hx6g = parcelRequire("2hx6g");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = (parcelRequire("1MYRJ"))(Array, 'Array', function(iterated, kind) {
    this._t = $2hx6g(iterated); // target
    this._i = 0; // next index
    this._k = kind; // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
        this._t = undefined;
        return $1Kz5Q(1);
    }
    if (kind == 'keys') return $1Kz5Q(0, index);
    if (kind == 'values') return $1Kz5Q(0, O[index]);
    return $1Kz5Q(0, [
        index,
        O[index]
    ]);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
$aODcA.Arguments = $aODcA.Array;
$aWD6E('keys');
$aWD6E('values');
$aWD6E('entries');

});
parcelRegister("aWD6E", function(module, exports) {
module.exports = function() {};

});

parcelRegister("1Kz5Q", function(module, exports) {
module.exports = function(done, value) {
    return {
        value: value,
        done: !!done
    };
};

});



parcelRegister("iY0Fa", function(module, exports) {
$parcel$export(module.exports, "f", function () { return $dcee583f97a923c0$export$2d1720544b23b823; }, function (v) { return $dcee583f97a923c0$export$2d1720544b23b823 = v; });
var $dcee583f97a923c0$export$2d1720544b23b823;

$dcee583f97a923c0$export$2d1720544b23b823 = (parcelRequire("9xDAg"));

});



parcelRegister("7xVAR", function(module, exports) {

module.exports = {
    "default": (parcelRequire("iI7gd")),
    __esModule: true
};

});
parcelRegister("iI7gd", function(module, exports) {
parcelRequire("99gPT");
parcelRequire("cPEqH");
parcelRequire("9qJRy");
parcelRequire("lm1z6");

module.exports = (parcelRequire("23f7N")).Symbol;

});
parcelRegister("99gPT", function(module, exports) {
'use strict';

var $4FFa4 = parcelRequire("4FFa4");

var $763mL = parcelRequire("763mL");

var $2PPTD = parcelRequire("2PPTD");

var $6TZmN = parcelRequire("6TZmN");

var $aDsEo = parcelRequire("aDsEo");

var $cj3Wz = parcelRequire("cj3Wz");
var $6a920393d90de711$require$META = $cj3Wz.KEY;

var $hs8hK = parcelRequire("hs8hK");

var $izZ3Q = parcelRequire("izZ3Q");

var $jr22O = parcelRequire("jr22O");

var $hoAgo = parcelRequire("hoAgo");

var $9xDAg = parcelRequire("9xDAg");

var $iY0Fa = parcelRequire("iY0Fa");

var $9PxVb = parcelRequire("9PxVb");

var $8x7zY = parcelRequire("8x7zY");

var $lap9z = parcelRequire("lap9z");

var $5asEa = parcelRequire("5asEa");

var $7QZ8S = parcelRequire("7QZ8S");

var $7tWaA = parcelRequire("7tWaA");

var $2hx6g = parcelRequire("2hx6g");

var $bIV2P = parcelRequire("bIV2P");

var $kKJnZ = parcelRequire("kKJnZ");

var $lmUsf = parcelRequire("lmUsf");

var $76OH6 = parcelRequire("76OH6");

var $k9HHU = parcelRequire("k9HHU");

var $jBejz = parcelRequire("jBejz");

var $19vSD = parcelRequire("19vSD");

var $E0yCE = parcelRequire("E0yCE");
var $6a920393d90de711$var$gOPD = $k9HHU.f;
var $6a920393d90de711$var$dP = $19vSD.f;
var $6a920393d90de711$var$gOPN = $76OH6.f;
var $6a920393d90de711$var$$Symbol = $4FFa4.Symbol;
var $6a920393d90de711$var$$JSON = $4FFa4.JSON;
var $6a920393d90de711$var$_stringify = $6a920393d90de711$var$$JSON && $6a920393d90de711$var$$JSON.stringify;
var $6a920393d90de711$var$PROTOTYPE = 'prototype';
var $6a920393d90de711$var$HIDDEN = $9xDAg('_hidden');
var $6a920393d90de711$var$TO_PRIMITIVE = $9xDAg('toPrimitive');
var $6a920393d90de711$var$isEnum = {}.propertyIsEnumerable;
var $6a920393d90de711$var$SymbolRegistry = $izZ3Q('symbol-registry');
var $6a920393d90de711$var$AllSymbols = $izZ3Q('symbols');
var $6a920393d90de711$var$OPSymbols = $izZ3Q('op-symbols');
var $6a920393d90de711$var$ObjectProto = Object[$6a920393d90de711$var$PROTOTYPE];
var $6a920393d90de711$var$USE_NATIVE = typeof $6a920393d90de711$var$$Symbol == 'function' && !!$jBejz.f;
var $6a920393d90de711$var$QObject = $4FFa4.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $6a920393d90de711$var$setter = !$6a920393d90de711$var$QObject || !$6a920393d90de711$var$QObject[$6a920393d90de711$var$PROTOTYPE] || !$6a920393d90de711$var$QObject[$6a920393d90de711$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $6a920393d90de711$var$setSymbolDesc = $2PPTD && $hs8hK(function() {
    return $lmUsf($6a920393d90de711$var$dP({}, 'a', {
        get: function() {
            return $6a920393d90de711$var$dP(this, 'a', {
                value: 7
            }).a;
        }
    })).a != 7;
}) ? function(it, key, D) {
    var protoDesc = $6a920393d90de711$var$gOPD($6a920393d90de711$var$ObjectProto, key);
    if (protoDesc) delete $6a920393d90de711$var$ObjectProto[key];
    $6a920393d90de711$var$dP(it, key, D);
    if (protoDesc && it !== $6a920393d90de711$var$ObjectProto) $6a920393d90de711$var$dP($6a920393d90de711$var$ObjectProto, key, protoDesc);
} : $6a920393d90de711$var$dP;
var $6a920393d90de711$var$wrap = function(tag) {
    var sym = $6a920393d90de711$var$AllSymbols[tag] = $lmUsf($6a920393d90de711$var$$Symbol[$6a920393d90de711$var$PROTOTYPE]);
    sym._k = tag;
    return sym;
};
var $6a920393d90de711$var$isSymbol = $6a920393d90de711$var$USE_NATIVE && typeof $6a920393d90de711$var$$Symbol.iterator == 'symbol' ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    return it instanceof $6a920393d90de711$var$$Symbol;
};
var $6a920393d90de711$var$$defineProperty = function defineProperty(it, key, D) {
    if (it === $6a920393d90de711$var$ObjectProto) $6a920393d90de711$var$$defineProperty($6a920393d90de711$var$OPSymbols, key, D);
    $5asEa(it);
    key = $bIV2P(key, true);
    $5asEa(D);
    if ($763mL($6a920393d90de711$var$AllSymbols, key)) {
        if (!D.enumerable) {
            if (!$763mL(it, $6a920393d90de711$var$HIDDEN)) $6a920393d90de711$var$dP(it, $6a920393d90de711$var$HIDDEN, $kKJnZ(1, {}));
            it[$6a920393d90de711$var$HIDDEN][key] = true;
        } else {
            if ($763mL(it, $6a920393d90de711$var$HIDDEN) && it[$6a920393d90de711$var$HIDDEN][key]) it[$6a920393d90de711$var$HIDDEN][key] = false;
            D = $lmUsf(D, {
                enumerable: $kKJnZ(0, false)
            });
        }
        return $6a920393d90de711$var$setSymbolDesc(it, key, D);
    }
    return $6a920393d90de711$var$dP(it, key, D);
};
var $6a920393d90de711$var$$defineProperties = function defineProperties(it, P) {
    $5asEa(it);
    var keys = $8x7zY(P = $2hx6g(P));
    var i = 0;
    var l = keys.length;
    var key;
    while(l > i)$6a920393d90de711$var$$defineProperty(it, key = keys[i++], P[key]);
    return it;
};
var $6a920393d90de711$var$$create = function create(it, P) {
    return P === undefined ? $lmUsf(it) : $6a920393d90de711$var$$defineProperties($lmUsf(it), P);
};
var $6a920393d90de711$var$$propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = $6a920393d90de711$var$isEnum.call(this, key = $bIV2P(key, true));
    if (this === $6a920393d90de711$var$ObjectProto && $763mL($6a920393d90de711$var$AllSymbols, key) && !$763mL($6a920393d90de711$var$OPSymbols, key)) return false;
    return E || !$763mL(this, key) || !$763mL($6a920393d90de711$var$AllSymbols, key) || $763mL(this, $6a920393d90de711$var$HIDDEN) && this[$6a920393d90de711$var$HIDDEN][key] ? E : true;
};
var $6a920393d90de711$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = $2hx6g(it);
    key = $bIV2P(key, true);
    if (it === $6a920393d90de711$var$ObjectProto && $763mL($6a920393d90de711$var$AllSymbols, key) && !$763mL($6a920393d90de711$var$OPSymbols, key)) return;
    var D = $6a920393d90de711$var$gOPD(it, key);
    if (D && $763mL($6a920393d90de711$var$AllSymbols, key) && !($763mL(it, $6a920393d90de711$var$HIDDEN) && it[$6a920393d90de711$var$HIDDEN][key])) D.enumerable = true;
    return D;
};
var $6a920393d90de711$var$$getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = $6a920393d90de711$var$gOPN($2hx6g(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if (!$763mL($6a920393d90de711$var$AllSymbols, key = names[i++]) && key != $6a920393d90de711$var$HIDDEN && key != $6a920393d90de711$require$META) result.push(key);
    return result;
};
var $6a920393d90de711$var$$getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === $6a920393d90de711$var$ObjectProto;
    var names = $6a920393d90de711$var$gOPN(IS_OP ? $6a920393d90de711$var$OPSymbols : $2hx6g(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if ($763mL($6a920393d90de711$var$AllSymbols, key = names[i++]) && (IS_OP ? $763mL($6a920393d90de711$var$ObjectProto, key) : true)) result.push($6a920393d90de711$var$AllSymbols[key]);
    return result;
};



// 19.4.1.1 Symbol([description])
if (!$6a920393d90de711$var$USE_NATIVE) {
    $6a920393d90de711$var$$Symbol = function Symbol() {
        if (this instanceof $6a920393d90de711$var$$Symbol) throw TypeError('Symbol is not a constructor!');
        var tag = $hoAgo(arguments.length > 0 ? arguments[0] : undefined);
        var $set = function(value) {
            if (this === $6a920393d90de711$var$ObjectProto) $set.call($6a920393d90de711$var$OPSymbols, value);
            if ($763mL(this, $6a920393d90de711$var$HIDDEN) && $763mL(this[$6a920393d90de711$var$HIDDEN], tag)) this[$6a920393d90de711$var$HIDDEN][tag] = false;
            $6a920393d90de711$var$setSymbolDesc(this, tag, $kKJnZ(1, value));
        };
        if ($2PPTD && $6a920393d90de711$var$setter) $6a920393d90de711$var$setSymbolDesc($6a920393d90de711$var$ObjectProto, tag, {
            configurable: true,
            set: $set
        });
        return $6a920393d90de711$var$wrap(tag);
    };
    $aDsEo($6a920393d90de711$var$$Symbol[$6a920393d90de711$var$PROTOTYPE], 'toString', function toString() {
        return this._k;
    });
    $k9HHU.f = $6a920393d90de711$var$$getOwnPropertyDescriptor;
    $19vSD.f = $6a920393d90de711$var$$defineProperty;
    (parcelRequire("bZLYs")).f = $76OH6.f = $6a920393d90de711$var$$getOwnPropertyNames;
    (parcelRequire("gGh3r")).f = $6a920393d90de711$var$$propertyIsEnumerable;
    $jBejz.f = $6a920393d90de711$var$$getOwnPropertySymbols;
    if ($2PPTD && !(parcelRequire("jHsIx"))) $aDsEo($6a920393d90de711$var$ObjectProto, 'propertyIsEnumerable', $6a920393d90de711$var$$propertyIsEnumerable, true);
    $iY0Fa.f = function(name) {
        return $6a920393d90de711$var$wrap($9xDAg(name));
    };
}
$6TZmN($6TZmN.G + $6TZmN.W + $6TZmN.F * !$6a920393d90de711$var$USE_NATIVE, {
    Symbol: $6a920393d90de711$var$$Symbol
});
for(var $6a920393d90de711$var$es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), $6a920393d90de711$var$j = 0; $6a920393d90de711$var$es6Symbols.length > $6a920393d90de711$var$j;)$9xDAg($6a920393d90de711$var$es6Symbols[$6a920393d90de711$var$j++]);
for(var $6a920393d90de711$var$wellKnownSymbols = $E0yCE($9xDAg.store), $6a920393d90de711$var$k = 0; $6a920393d90de711$var$wellKnownSymbols.length > $6a920393d90de711$var$k;)$9PxVb($6a920393d90de711$var$wellKnownSymbols[$6a920393d90de711$var$k++]);
$6TZmN($6TZmN.S + $6TZmN.F * !$6a920393d90de711$var$USE_NATIVE, 'Symbol', {
    // 19.4.2.1 Symbol.for(key)
    'for': function(key) {
        return $763mL($6a920393d90de711$var$SymbolRegistry, key += '') ? $6a920393d90de711$var$SymbolRegistry[key] : $6a920393d90de711$var$SymbolRegistry[key] = $6a920393d90de711$var$$Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(sym) {
        if (!$6a920393d90de711$var$isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
        for(var key in $6a920393d90de711$var$SymbolRegistry)if ($6a920393d90de711$var$SymbolRegistry[key] === sym) return key;
    },
    useSetter: function() {
        $6a920393d90de711$var$setter = true;
    },
    useSimple: function() {
        $6a920393d90de711$var$setter = false;
    }
});
$6TZmN($6TZmN.S + $6TZmN.F * !$6a920393d90de711$var$USE_NATIVE, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $6a920393d90de711$var$$create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $6a920393d90de711$var$$defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $6a920393d90de711$var$$defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $6a920393d90de711$var$$getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $6a920393d90de711$var$$getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $6a920393d90de711$var$$getOwnPropertySymbols
});
// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $6a920393d90de711$var$FAILS_ON_PRIMITIVES = $hs8hK(function() {
    $jBejz.f(1);
});
$6TZmN($6TZmN.S + $6TZmN.F * $6a920393d90de711$var$FAILS_ON_PRIMITIVES, 'Object', {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        return $jBejz.f($7tWaA(it));
    }
});
// 24.3.2 JSON.stringify(value [, replacer [, space]])
$6a920393d90de711$var$$JSON && $6TZmN($6TZmN.S + $6TZmN.F * (!$6a920393d90de711$var$USE_NATIVE || $hs8hK(function() {
    var S = $6a920393d90de711$var$$Symbol();
    // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols
    return $6a920393d90de711$var$_stringify([
        S
    ]) != '[null]' || $6a920393d90de711$var$_stringify({
        a: S
    }) != '{}' || $6a920393d90de711$var$_stringify(Object(S)) != '{}';
})), 'JSON', {
    stringify: function stringify(it) {
        var args = [
            it
        ];
        var i = 1;
        var replacer, $replacer;
        while(arguments.length > i)args.push(arguments[i++]);
        $replacer = replacer = args[1];
        if (!$7QZ8S(replacer) && it === undefined || $6a920393d90de711$var$isSymbol(it)) return; // IE8 returns string on undefined
        if (!$lap9z(replacer)) replacer = function(key, value) {
            if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
            if (!$6a920393d90de711$var$isSymbol(value)) return value;
        };
        args[1] = replacer;
        return $6a920393d90de711$var$_stringify.apply($6a920393d90de711$var$$JSON, args);
    }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$6a920393d90de711$var$$Symbol[$6a920393d90de711$var$PROTOTYPE][$6a920393d90de711$var$TO_PRIMITIVE] || (parcelRequire("1XBAS"))($6a920393d90de711$var$$Symbol[$6a920393d90de711$var$PROTOTYPE], $6a920393d90de711$var$TO_PRIMITIVE, $6a920393d90de711$var$$Symbol[$6a920393d90de711$var$PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
$jr22O($6a920393d90de711$var$$Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
$jr22O(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
$jr22O($4FFa4.JSON, 'JSON', true);

});
parcelRegister("cj3Wz", function(module, exports) {

var $8f5a5183b2bf41cd$var$META = (parcelRequire("hoAgo"))('meta');

var $7QZ8S = parcelRequire("7QZ8S");

var $763mL = parcelRequire("763mL");

var $19vSD = parcelRequire("19vSD");
var $8f5a5183b2bf41cd$require$setDesc = $19vSD.f;
var $8f5a5183b2bf41cd$var$id = 0;
var $8f5a5183b2bf41cd$var$isExtensible = Object.isExtensible || function() {
    return true;
};

var $8f5a5183b2bf41cd$var$FREEZE = !(parcelRequire("hs8hK"))(function() {
    return $8f5a5183b2bf41cd$var$isExtensible(Object.preventExtensions({}));
});
var $8f5a5183b2bf41cd$var$setMeta = function(it) {
    $8f5a5183b2bf41cd$require$setDesc(it, $8f5a5183b2bf41cd$var$META, {
        value: {
            i: 'O' + ++$8f5a5183b2bf41cd$var$id,
            w: {} // weak collections IDs
        }
    });
};
var $8f5a5183b2bf41cd$var$fastKey = function(it, create) {
    // return primitive with prefix
    if (!$7QZ8S(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!$763mL(it, $8f5a5183b2bf41cd$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$8f5a5183b2bf41cd$var$isExtensible(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        $8f5a5183b2bf41cd$var$setMeta(it);
    // return object ID
    }
    return it[$8f5a5183b2bf41cd$var$META].i;
};
var $8f5a5183b2bf41cd$var$getWeak = function(it, create) {
    if (!$763mL(it, $8f5a5183b2bf41cd$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$8f5a5183b2bf41cd$var$isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $8f5a5183b2bf41cd$var$setMeta(it);
    // return hash weak collections IDs
    }
    return it[$8f5a5183b2bf41cd$var$META].w;
};
// add metadata on freeze-family methods calling
var $8f5a5183b2bf41cd$var$onFreeze = function(it) {
    if ($8f5a5183b2bf41cd$var$FREEZE && $8f5a5183b2bf41cd$var$meta.NEED && $8f5a5183b2bf41cd$var$isExtensible(it) && !$763mL(it, $8f5a5183b2bf41cd$var$META)) $8f5a5183b2bf41cd$var$setMeta(it);
    return it;
};
var $8f5a5183b2bf41cd$var$meta = module.exports = {
    KEY: $8f5a5183b2bf41cd$var$META,
    NEED: false,
    fastKey: $8f5a5183b2bf41cd$var$fastKey,
    getWeak: $8f5a5183b2bf41cd$var$getWeak,
    onFreeze: $8f5a5183b2bf41cd$var$onFreeze
};

});

parcelRegister("9PxVb", function(module, exports) {

var $4FFa4 = parcelRequire("4FFa4");

var $23f7N = parcelRequire("23f7N");

var $jHsIx = parcelRequire("jHsIx");

var $iY0Fa = parcelRequire("iY0Fa");

var $19vSD = parcelRequire("19vSD");
var $72833089d3e03b7a$require$defineProperty = $19vSD.f;
module.exports = function(name) {
    var $Symbol = $23f7N.Symbol || ($23f7N.Symbol = $jHsIx ? {} : $4FFa4.Symbol || {});
    if (name.charAt(0) != '_' && !(name in $Symbol)) $72833089d3e03b7a$require$defineProperty($Symbol, name, {
        value: $iY0Fa.f(name)
    });
};

});

parcelRegister("8x7zY", function(module, exports) {
// all enumerable object keys, includes symbols

var $E0yCE = parcelRequire("E0yCE");

var $jBejz = parcelRequire("jBejz");

var $gGh3r = parcelRequire("gGh3r");
module.exports = function(it) {
    var result = $E0yCE(it);
    var getSymbols = $jBejz.f;
    if (getSymbols) {
        var symbols = getSymbols(it);
        var isEnum = $gGh3r.f;
        var i = 0;
        var key;
        while(symbols.length > i)if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
    return result;
};

});

parcelRegister("lap9z", function(module, exports) {
// 7.2.2 IsArray(argument)

var $gNg6c = parcelRequire("gNg6c");
module.exports = Array.isArray || function isArray(arg) {
    return $gNg6c(arg) == 'Array';
};

});

parcelRegister("76OH6", function(module, exports) {
$parcel$export(module.exports, "f", function () { return $52d06ac0be21d279$export$2d1720544b23b823; }, function (v) { return $52d06ac0be21d279$export$2d1720544b23b823 = v; });
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $52d06ac0be21d279$export$2d1720544b23b823;

var $2hx6g = parcelRequire("2hx6g");

var $bZLYs = parcelRequire("bZLYs");
var $52d06ac0be21d279$require$gOPN = $bZLYs.f;
var $52d06ac0be21d279$var$toString = {}.toString;
var $52d06ac0be21d279$var$windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $52d06ac0be21d279$var$getWindowNames = function(it) {
    try {
        return $52d06ac0be21d279$require$gOPN(it);
    } catch (e) {
        return $52d06ac0be21d279$var$windowNames.slice();
    }
};
$52d06ac0be21d279$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $52d06ac0be21d279$var$windowNames && $52d06ac0be21d279$var$toString.call(it) == '[object Window]' ? $52d06ac0be21d279$var$getWindowNames(it) : $52d06ac0be21d279$require$gOPN($2hx6g(it));
};

});
parcelRegister("bZLYs", function(module, exports) {
$parcel$export(module.exports, "f", function () { return $8bba9ae47cc7daf1$export$2d1720544b23b823; }, function (v) { return $8bba9ae47cc7daf1$export$2d1720544b23b823 = v; });
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $8bba9ae47cc7daf1$export$2d1720544b23b823;

var $64rCp = parcelRequire("64rCp");

var $8bba9ae47cc7daf1$var$hiddenKeys = (parcelRequire("f5whe")).concat('length', 'prototype');
$8bba9ae47cc7daf1$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $64rCp(O, $8bba9ae47cc7daf1$var$hiddenKeys);
};

});


parcelRegister("k9HHU", function(module, exports) {
$parcel$export(module.exports, "f", function () { return $eac68d442f70e4ee$export$2d1720544b23b823; }, function (v) { return $eac68d442f70e4ee$export$2d1720544b23b823 = v; });
var $eac68d442f70e4ee$export$2d1720544b23b823;

var $gGh3r = parcelRequire("gGh3r");

var $kKJnZ = parcelRequire("kKJnZ");

var $2hx6g = parcelRequire("2hx6g");

var $bIV2P = parcelRequire("bIV2P");

var $763mL = parcelRequire("763mL");

var $1Vpr5 = parcelRequire("1Vpr5");
var $eac68d442f70e4ee$var$gOPD = Object.getOwnPropertyDescriptor;

$eac68d442f70e4ee$export$2d1720544b23b823 = (parcelRequire("2PPTD")) ? $eac68d442f70e4ee$var$gOPD : function getOwnPropertyDescriptor(O, P) {
    O = $2hx6g(O);
    P = $bIV2P(P, true);
    if ($1Vpr5) try {
        return $eac68d442f70e4ee$var$gOPD(O, P);
    } catch (e) {}
    if ($763mL(O, P)) return $kKJnZ(!$gGh3r.f.call(O, P), O[P]);
};

});


parcelRegister("cPEqH", function(module, exports) {

});

parcelRegister("9qJRy", function(module, exports) {

(parcelRequire("9PxVb"))('asyncIterator');

});

parcelRegister("lm1z6", function(module, exports) {

(parcelRequire("9PxVb"))('observable');

});





parcelRegister("fpmbk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", function () { return $b37a659efa5f0475$export$1e511d4a378977f5; }, function (v) { return $b37a659efa5f0475$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $b37a659efa5f0475$export$2e2bcd8739ae039; }, function (v) { return $b37a659efa5f0475$export$2e2bcd8739ae039 = v; });
var $b37a659efa5f0475$export$1e511d4a378977f5;
var $b37a659efa5f0475$export$2e2bcd8739ae039;
"use strict";
$b37a659efa5f0475$export$1e511d4a378977f5 = true;

var $iwWa6 = parcelRequire("iwWa6");
var $b37a659efa5f0475$var$_setPrototypeOf2 = $b37a659efa5f0475$var$_interopRequireDefault($iwWa6);

var $eTqtS = parcelRequire("eTqtS");
var $b37a659efa5f0475$var$_create2 = $b37a659efa5f0475$var$_interopRequireDefault($eTqtS);

var $frdl0 = parcelRequire("frdl0");
var $b37a659efa5f0475$var$_typeof3 = $b37a659efa5f0475$var$_interopRequireDefault($frdl0);
function $b37a659efa5f0475$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$b37a659efa5f0475$export$2e2bcd8739ae039 = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $b37a659efa5f0475$var$_typeof3.default)(superClass)));
    subClass.prototype = (0, $b37a659efa5f0475$var$_create2.default)(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $b37a659efa5f0475$var$_setPrototypeOf2.default ? (0, $b37a659efa5f0475$var$_setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

});
parcelRegister("iwWa6", function(module, exports) {

module.exports = {
    "default": (parcelRequire("13ZIY")),
    __esModule: true
};

});
parcelRegister("13ZIY", function(module, exports) {
parcelRequire("asvPg");

module.exports = (parcelRequire("23f7N")).Object.setPrototypeOf;

});
parcelRegister("asvPg", function(module, exports) {
// 19.1.3.19 Object.setPrototypeOf(O, proto)

var $6TZmN = parcelRequire("6TZmN");

$6TZmN($6TZmN.S, 'Object', {
    setPrototypeOf: (parcelRequire("5BFbR")).set
});

});
parcelRegister("5BFbR", function(module, exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ 
var $7QZ8S = parcelRequire("7QZ8S");

var $5asEa = parcelRequire("5asEa");
var $41505bfbff01f966$var$check = function(O, proto) {
    $5asEa(O);
    if (!$7QZ8S(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};


module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
        try {
            set = (parcelRequire("04VsN"))(Function.call, (parcelRequire("k9HHU")).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            $41505bfbff01f966$var$check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: $41505bfbff01f966$var$check
};

});




parcelRegister("eTqtS", function(module, exports) {

module.exports = {
    "default": (parcelRequire("cFZmJ")),
    __esModule: true
};

});
parcelRegister("cFZmJ", function(module, exports) {
parcelRequire("fj7wp");

var $23f7N = parcelRequire("23f7N");
var $93a8ea4cff4cea96$require$$Object = $23f7N.Object;
module.exports = function create(P, D) {
    return $93a8ea4cff4cea96$require$$Object.create(P, D);
};

});
parcelRegister("fj7wp", function(module, exports) {

var $6TZmN = parcelRequire("6TZmN");

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$6TZmN($6TZmN.S, 'Object', {
    create: (parcelRequire("lmUsf"))
});

});





parcelRegister("g85aC", function(module, exports) {
$parcel$export(module.exports, "VideoCarousel", function () { return $94d5d3babf1768b0$export$402838bbb52a01c9; });
/* videoCarousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $jKShK = parcelRequire("jKShK");

var $8e22h = parcelRequire("8e22h");

var $clnBI = parcelRequire("clnBI");

var $Lp2P8 = parcelRequire("Lp2P8");

var $ep4tq = parcelRequire("ep4tq");

var $kbpa7 = parcelRequire("kbpa7");

var $hJfqz = parcelRequire("hJfqz");
const $94d5d3babf1768b0$var$carouselSlideStyle = null;
const $94d5d3babf1768b0$var$infoContainerStyle = null;
const $94d5d3babf1768b0$var$textContainerStyle = null;
const $94d5d3babf1768b0$var$primaryTextStyle = null;
const $94d5d3babf1768b0$var$subTextStyle = null;
const $94d5d3babf1768b0$var$videoStyle = null;
const $94d5d3babf1768b0$var$rightAlignedControlsContainerStyles = null;
const $94d5d3babf1768b0$export$542984e3b3a8582e = ({ primaryText: primaryText, description: description, videoSrcMp4: videoSrcMp4, videoSrcWebm: videoSrcWebm, videoPreviewSrc: videoPreviewSrc, id: id, loop: loop, onEnded: onEnded })=>{
    const { ref: containerRef, inView: sectionIsVisible } = (0, $jKShK.useInView)({
        initialInView: true,
        threshold: 0.3
    });
    const videoRef = /*#__PURE__*/ (0, $1oC0p.createRef)();
    (0, $1oC0p.useEffect)(()=>{
        const videoElem = videoRef.current;
        if (!videoElem) return;
        // Pause the video when it's out of view
        if (!sectionIsVisible && !videoElem.paused) videoElem.pause();
        // Play the video when it's in view
        if (sectionIsVisible && videoElem.paused) {
            videoElem.currentTime = 0;
            videoElem.play().catch(()=>{
            // Ignore error likely due to autoplay restrictions
            });
        }
    }, [
        videoRef,
        sectionIsVisible
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        role: "tabpanel",
        id: id,
        ref: containerRef,
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp7vkz"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ep4tq.Adg4RaisedMedia), {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("video", {
                    width: 1920,
                    height: 1080,
                    playsInline: true,
                    muted: true,
                    preload: "auto",
                    poster: videoPreviewSrc,
                    autoPlay: true,
                    loop: loop,
                    ref: videoRef,
                    onEnded: onEnded,
                    // Use onLoadedMetadata to trigger a Safari autplay workaround
                    onLoadedMetadata: (videoEvent)=>{
                        try {
                            videoEvent.currentTarget.currentTime = 0; // Set currentTime to workaround Safari not autplaying
                            if (videoEvent.currentTarget.parentElement) videoEvent.currentTarget.play().catch(()=>false); // Call play() as backup to ensure the video is playing
                        } catch (error) {
                            console.log('Error calling play method on video after onCanPlay is invoked.');
                        }
                    },
                    className: (0, $2jatx.default)([
                        "_p12f1osq _4t3i1wug"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                            src: videoSrcMp4,
                            type: `video/mp4`
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                            src: videoSrcWebm,
                            type: `video/webm`
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1yb4 _4cvr1h6o _zulp7vkz _1tke53f4"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _1bsb1osq _y3gn1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                            className: (0, $2jatx.default)([
                                "_k48p53lb _1wyba982 _vwz41i72 _1dyzzyni _6rthi2wt _ect41sko _so7dlb34"
                            ]),
                            style: {
                                "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                            },
                            children: primaryText
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                "_k48p1nn1 _1wyb7vkz _vwz41tcg"
                            ]),
                            children: description
                        })
                    ]
                })
            })
        ]
    });
};
const $94d5d3babf1768b0$var$carouselTabListStyle = null;
const $94d5d3babf1768b0$var$dotStyle = null;
const $94d5d3babf1768b0$var$currentDotStyle = null;
const $94d5d3babf1768b0$var$carouselStyles = null;
const $94d5d3babf1768b0$var$controlsContainerStyles = null;
const $94d5d3babf1768b0$var$centeredControlsContainerStyles = null;
const $94d5d3babf1768b0$export$402838bbb52a01c9 = ({ 'aria-label': ariaLabel, slides: slides, id: carouselId })=>{
    const intl = (0, $8e22h.default)();
    const tabsRef = (0, $1oC0p.useRef)({});
    const [visibleSlideIndex, _setVisibleSlideIndex] = (0, $1oC0p.useState)(0);
    const visibleSlide = slides[visibleSlideIndex];
    if (visibleSlide === undefined) throw new Error('Slide index out of bounds.');
    const setVisibleSlideIndex = (newState, moveFocus = false)=>{
        _setVisibleSlideIndex((prevState)=>{
            let calculatedState;
            if (typeof newState === 'function') calculatedState = newState(prevState);
            else calculatedState = newState;
            moveFocus && tabsRef?.current[calculatedState]?.focus();
            return calculatedState;
        });
    };
    const moveToPreviousSlide = (moveFocus = false)=>{
        setVisibleSlideIndex((prev)=>{
            return prev === 0 ? slides.length - 1 : prev - 1;
        }, moveFocus);
    };
    const moveToNextSlide = (0, $1oC0p.useCallback)((moveFocus = false)=>{
        setVisibleSlideIndex((prev)=>{
            return prev === slides.length - 1 ? 0 : prev + 1;
        }, moveFocus);
    }, [
        slides.length
    ]);
    const [isRotating, setIsRotating] = (0, $1oC0p.useState)(true);
    (0, $1oC0p.useEffect)(()=>setIsRotating(true), [
        moveToNextSlide
    ]);
    const handleKeyDown = (e)=>{
        switch(e.key){
            case 'ArrowRight':
                moveToNextSlide(true);
                break;
            case 'ArrowLeft':
                moveToPreviousSlide(true);
                break;
            case 'Home':
                setVisibleSlideIndex(0, true);
                break;
            case 'End':
                setVisibleSlideIndex(slides.length - 1, true);
                break;
            default:
                return;
        }
        setIsRotating(false);
        e.preventDefault();
    };
    const handleTabClick = (index)=>{
        setIsRotating(false);
        setVisibleSlideIndex(index);
    };
    const handlePreviousClick = ()=>{
        setIsRotating(false);
        moveToPreviousSlide();
    };
    const handleNextClick = ()=>{
        setIsRotating(false);
        moveToNextSlide();
    };
    const getSlideId = (suffix)=>`${carouselId}-${suffix}`;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        "aria-label": ariaLabel,
        "aria-roledescription": "carousel",
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "aria-atomic": false,
                "aria-live": isRotating ? 'off' : 'polite',
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($94d5d3babf1768b0$export$542984e3b3a8582e, {
                    ...visibleSlide,
                    id: getSlideId(visibleSlideIndex),
                    loop: !isRotating,
                    onEnded: ()=>moveToNextSlide()
                }, visibleSlide.primaryText)
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _1lmceh92 _yv0e1n6q _zulpe2fx _1pfh1crf"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_nd5l1h6o _1e0c1txw _4cvr1h6o _zulp7vkz"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hJfqz.ArrowButton), {
                                onClick: handlePreviousClick,
                                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($clnBI))), {
                                    label: ""
                                }),
                                "aria-label": intl.formatMessage({
                                    id: 'confluence.paid.lp.carousel.previous.label',
                                    defaultMessage: 'Previous slide'
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                role: "tablist",
                                "aria-label": intl.formatMessage({
                                    id: 'confluence.paid.lp.carousel.tablist.label',
                                    defaultMessage: 'Choose a slide to display.'
                                }),
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _zulp1tcg"
                                ]),
                                children: slides.map((slide, index)=>{
                                    const isVisibleTab = visibleSlideIndex === index;
                                    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        "aria-controls": getSlideId(index),
                                        "aria-selected": isVisibleTab,
                                        role: "tab",
                                        "aria-label": intl.formatMessage({
                                            id: 'confluence.paid.lp.carousel.tab.label',
                                            defaultMessage: `Slide {slideNumber}`
                                        }, {
                                            slideNumber: `${index + 1}`
                                        }),
                                        tabIndex: isVisibleTab ? 0 : -1,
                                        onKeyDown: handleKeyDown,
                                        onClick: ()=>handleTabClick(index),
                                        ref: (node)=>{
                                            if (node) tabsRef.current[index] = node;
                                        },
                                        className: (0, $2jatx.default)([
                                            "_2rko1ssb _80omtlke _1bsb1crf _4t3i1crf _bfhk1afi",
                                            isVisibleTab && "_bfhkrbzz"
                                        ]),
                                        style: {
                                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                                        }
                                    }, `${slide.primaryText}-${index}`);
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hJfqz.ArrowButton), {
                                onClick: handleNextClick,
                                "aria-label": intl.formatMessage({
                                    id: 'confluence.paid.lp.carousel.next.label',
                                    defaultMessage: 'Next slide'
                                }),
                                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($Lp2P8))), {
                                    label: ""
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_nd5lusic"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hJfqz.PlayPauseButton), {
                            onClick: ()=>setIsRotating(!isRotating),
                            isRotating: isRotating
                        })
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("2opLs", function(module, exports) {
$parcel$export(module.exports, "PaidAccountCreation", function () { return $d7f434f81ff32590$export$8cfb1818275d36da; });
/* paid-account-creation.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $ig7Vf = parcelRequire("ig7Vf");

var $gSzjE = parcelRequire("gSzjE");

var $6KUQg = parcelRequire("6KUQg");

var $irRyj = parcelRequire("irRyj");

var $lJMiD = parcelRequire("lJMiD");

var $32ARy = parcelRequire("32ARy");

var $l7G9R = parcelRequire("l7G9R");

var $iTHVN = parcelRequire("iTHVN");

var $gZgIU = parcelRequire("gZgIU");

var $2WL8B = parcelRequire("2WL8B");

var $7GVWk = parcelRequire("7GVWk");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $gx3aw = parcelRequire("gx3aw");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $1ka2O = parcelRequire("1ka2O");

var $bCs1B = parcelRequire("bCs1B");

var $l7ZAy = parcelRequire("l7ZAy");

var $3Souq = parcelRequire("3Souq");
const $d7f434f81ff32590$export$8cfb1818275d36da = ({ darkSolidTheme: darkSolidTheme, showFourSocialButtons: showFourSocialButtons, auxiaResponse: auxiaResponse, pageId: pageId })=>{
    const { product: product } = (0, $7GVWk.useUserContext)();
    const i18n = (0, $8e22h.default)();
    const location = (0, $1ka2O.useLocation)();
    const isAuxiaPage = (0, $2WL8B.useJiraServiceManagementIntent)() && (0, $ig7Vf.isAuxiaServedPage)(auxiaResponse);
    const logInLink = (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
            text: text,
            "aria-label": text,
            type: "inline",
            href: (0, $gZgIU.getLoginUrl)(location),
            onClick: ()=>{
                if (isAuxiaPage) {
                    const anonymousId = decodeURIComponent((0, $gx3aw.Cookie).readCookie('ajs_anonymous_id') || '').replace(/['"]+/g, '');
                    (0, $gSzjE.sendAnalyticsToAuxia)({
                        anonymousId: anonymousId,
                        treatmentTrackingId: auxiaResponse.treatmentTrackingId,
                        treatmentId: auxiaResponse.treatmentId,
                        interactionType: 'CLICKED',
                        interactionTimeMicros: (0, $gSzjE.convertDateTimeToInteractionTimeMicros)(Date.now()),
                        actionName: 'login_button'
                    });
                }
            }
        });
    const enableCustomerServiceManagementVariant = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).enableCsmAjLogo) && pageId === 'anchor-lp-jsm-csm';
    const loginText = i18n.formatMessage({
        id: 'BxpUiSignup.SignupForm.existingProduct.confluence.embedded',
        defaultMessage: 'Trying to access {product}? <logInLink>Log in</logInLink>'
    }, {
        product: enableCustomerServiceManagementVariant ? 'Customer Service Management' : product?.description,
        logInLink: logInLink
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6KUQg.AccountCreation), {
        Input: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                darkSolidTheme && "_ie4muftu _frvhuftu _q7r41afi",
                !darkSolidTheme && "_frvh1p0d _ie4m1cjc"
            ]),
            style: {
                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $irRyj.Input), {})
        }),
        Login: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_26vxviql",
                darkSolidTheme && "_43dsuftu"
            ]),
            style: {
                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
            },
            children: [
                enableCustomerServiceManagementVariant ? /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: (0, $2jatx.default)([
                        "_1wyb12re _19pk14b4 _2hwxgrf3 _otyrgrf3 _18u0grf3 _y3gn1e5h"
                    ]),
                    style: {
                        "--_58aws": (0, $6ZVlx.default)((0, $iTHVN.fontSize).lg)
                    },
                    children: "Join the 300K+ customers that trust Atlassian to power team collaboration"
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bCs1B.AnimatedSocialProof), {}),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lJMiD.Login), {
                    loginText: loginText
                })
            ]
        }),
        Social: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                showFourSocialButtons && "_jk741ezz _zs121ylp _1b94glyw"
            ]),
            children: [
                !isAuxiaPage && !showFourSocialButtons && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $32ARy.Social), {
                    providers: {
                        google: 'Google',
                        microsoft: 'Microsoft'
                    }
                }),
                !isAuxiaPage && showFourSocialButtons && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $32ARy.Social), {}),
                isAuxiaPage && !showFourSocialButtons && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l7ZAy.AuxiaSocial), {
                    providers: {
                        google: 'Google',
                        microsoft: 'Microsoft'
                    },
                    auxiaResponse: auxiaResponse
                }),
                isAuxiaPage && showFourSocialButtons && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l7ZAy.AuxiaSocial), {})
            ]
        }),
        Submit: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                darkSolidTheme && "_7dirk6ds _d32v4viv _6pup1s4t _4pkp4viv"
            ]),
            style: {
                "--_1p38jlt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.saffron400'))
            },
            children: [
                !isAuxiaPage && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l7G9R.Submit), {}),
                isAuxiaPage && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3Souq.AuxiaSubmit), {
                    auxiaResponse: auxiaResponse
                })
            ]
        })
    });
};
const $d7f434f81ff32590$var$socialWrapperStyle = null;
const $d7f434f81ff32590$var$loginSocialProofCss = null;
const $d7f434f81ff32590$var$yellowButtonCss = null;
const $d7f434f81ff32590$var$whiteLinkCss = null;
const $d7f434f81ff32590$var$whiteTextCss = null;
const $d7f434f81ff32590$var$darkGrayTextCss = null;
const $d7f434f81ff32590$var$existingProductCss = null;

});
parcelRegister("ig7Vf", function(module, exports) {
$parcel$export(module.exports, "isAuxiaServedPage", function () { return $13d3bb964979ef44$export$d387d4c6b79063ea; });

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
function $13d3bb964979ef44$var$isValidAuxiaResponse(auxiaResponse) {
    return auxiaResponse !== null && auxiaResponse !== undefined && typeof auxiaResponse.treatmentId === 'string' && typeof auxiaResponse.treatmentTrackingId === 'string' && auxiaResponse.treatmentId.length > 0 && auxiaResponse.treatmentTrackingId.length > 0 && Array.isArray(auxiaResponse.auxiaTreatment) && auxiaResponse.auxiaTreatment.length > 0;
}
const $13d3bb964979ef44$export$d387d4c6b79063ea = (auxiaResponse)=>{
    const usingAuxiaTreatment = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).jsmPaidLpAuxiaIntegration);
    return usingAuxiaTreatment && $13d3bb964979ef44$var$isValidAuxiaResponse(auxiaResponse);
};
const $13d3bb964979ef44$export$b9e49162afc62078 = (auxiaResponse)=>{
    const usingAuxiaTreatment = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).jsmPaidLpAuxiaIntegration);
    return usingAuxiaTreatment && !$13d3bb964979ef44$var$isValidAuxiaResponse(auxiaResponse);
};

});

parcelRegister("gSzjE", function(module, exports) {
$parcel$export(module.exports, "convertDateTimeToInteractionTimeMicros", function () { return $cc4cbbe75ecd9df3$export$1219d02973c84a52; });
$parcel$export(module.exports, "sendAnalyticsToAuxia", function () { return $cc4cbbe75ecd9df3$export$3d1788c6d7ad0255; });
const $cc4cbbe75ecd9df3$var$setWindowAnalyticsObject = ({ interactionType: interactionType, wasSent: wasSent })=>{
    if (interactionType === 'VIEWED') // @ts-ignore
    window.sentViewedAuxiaAnalytics = wasSent.toString();
    else if (interactionType === 'CLICKED') // @ts-ignore
    window.sentClickedAuxiaAnalytics = wasSent.toString();
};
const $cc4cbbe75ecd9df3$export$1219d02973c84a52 = (dateTime)=>{
    const microSeconds = dateTime * 1000;
    return microSeconds.toString();
};
const $cc4cbbe75ecd9df3$export$3d1788c6d7ad0255 = async ({ anonymousId: anonymousId, treatmentTrackingId: treatmentTrackingId, treatmentId: treatmentId, interactionType: interactionType, interactionTimeMicros: interactionTimeMicros, actionName: actionName })=>{
    const url = 'https://apis.auxia.io/v1/LogTreatmentInteraction';
    const auxiaRequest = {
        projectId: "1921",
        userId: anonymousId,
        treatmentTrackingId: treatmentTrackingId,
        treatmentId: treatmentId,
        surface: 'LANDING_PAGE_JSM',
        interactionType: interactionType,
        interactionTimeMicros: interactionTimeMicros,
        languageCode: 'en',
        actionName: actionName || ''
    };
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': "AIzaSyCUlO-ukAKTA1Khu87fez3UspN5PEtFOsY"
            },
            body: JSON.stringify(auxiaRequest)
        });
        const data = await response.json();
        const stringData = JSON.stringify(data);
        const responseContainsError = stringData !== '{}';
        if (responseContainsError) throw Error(`Auxia did not properly receive analytics: ${stringData}`);
        $cc4cbbe75ecd9df3$var$setWindowAnalyticsObject({
            interactionType: interactionType,
            wasSent: true
        });
    } catch (e) {
        console.error(`sendAnalyticsToAuxia call error:
                        Request Body: ${JSON.stringify(auxiaRequest)}
                        Error: ${e}
                    `);
    }
};

});

parcelRegister("bCs1B", function(module, exports) {
$parcel$export(module.exports, "AnimatedSocialProof", function () { return $cda7c4fda7a7cb96$export$b9b8b5eca0edeb76; });
/* animated-social-proof.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $helsO = parcelRequire("helsO");

var $keghS = parcelRequire("keghS");

var $kEiKm = parcelRequire("kEiKm");

var $ecrbE = parcelRequire("ecrbE");

var $8Uvps = parcelRequire("8Uvps");

var $2KJKq = parcelRequire("2KJKq");

var $bmyHB = parcelRequire("bmyHB");
const $cda7c4fda7a7cb96$var$carouselCss = null;
const $cda7c4fda7a7cb96$var$trackCss = null;
const $cda7c4fda7a7cb96$var$imageCss = null;
const $cda7c4fda7a7cb96$var$logos = [
    (0, $2KJKq.DominosLogo),
    (0, $helsO.SquareLogo),
    (0, $8Uvps.EbayLogo),
    (0, $bmyHB.CiscoLogo),
    (0, $ecrbE.FordLogo),
    (0, $keghS.PaypalLogo),
    (0, $kEiKm.NasaLogo)
];
const $cda7c4fda7a7cb96$export$b9b8b5eca0edeb76 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "data-testid": "animated-social-proof",
        className: (0, $2jatx.default)([
            "_1reo15vq _18m915vq _4t3ildb6 _kqswh2mm _1bsb1osq _1mjbglyw"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_y44v9j94 _1e0c1txw _kqswstnw"
            ]),
            children: [
                ...$cda7c4fda7a7cb96$var$logos,
                ...$cda7c4fda7a7cb96$var$logos
            ].map((Logo, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _4t3ildb6 _1bsbymf6 _12l2zwfg"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)(Logo, {})
                }, index))
        })
    });

});
parcelRegister("helsO", function(module, exports) {
$parcel$export(module.exports, "SquareLogo", function () { return $15b0470e32db7f40$export$dcc1072f6b07484d; });

var $7VQPk = parcelRequire("7VQPk");
const $15b0470e32db7f40$export$dcc1072f6b07484d = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        "aria-hidden": true,
        fill: "currentColor",
        opacity: 0.8,
        viewBox: "0 0 2048.9 500",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M318.2,303c0,8.4-6.8,15.2-15.1,15.2H197c-8.3,0-15.1-6.8-15.1-15.2V197c0-8.3,6.8-15.1,15.1-15.1h106.1 c8.3,0,15.1,6.8,15.1,15.1V303z M409.1,382.6c0,14.6-11.9,26.5-26.5,26.5H117.4c-14.6,0-26.5-11.9-26.5-26.5V117.4 c0-14.6,11.9-26.5,26.5-26.5h265.2c14.6,0,26.5,11.9,26.5,26.5V382.6z M416.7,0H83.3C37.5,0,0,37.5,0,83.3v333.3 C0,462.5,37.5,500,83.3,500h333.3c45.8,0,83.3-37.5,83.3-83.3V83.3C500,37.5,462.5,0,416.7,0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M731.4,414.2c-29.6,0-58.1-11.4-78.2-31.5c-17.9-17.9-27.8-41.1-27.8-65.4h30c0,16.3,6.7,32,19,44.2 c14.5,14.4,35.3,22.7,57,22.7h0.3c41.9,0,75.9-29.3,75.9-65.3c0-27-15-48.5-87.7-65.3c-29.6-6.8-49.5-16-62.8-28.8 c-14.1-13.7-21-31.9-21-55.8c0-47,42.1-85.3,94-85.3c24.8,0,48.2,8.5,65.9,24.1c18.2,16,28.3,37.6,28.3,60.9h-30 c0-30.3-28.8-54.9-64.2-54.9c-34.7,0-64,25.3-64,55.3c0,27.4,9.4,43.5,60.7,55.3c54.7,12.6,110.8,33.8,110.9,94.5 c0,25.8-11.2,50-31.5,68c-19.9,17.6-46.4,27.3-74.4,27.3H731.4z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M995.8,201.4c-53.9,0-92.8,40.2-92.8,93.7c0,53.1,39.8,92.1,92.8,92.1c51.5,0,90.8-41.9,90.8-92.5 C1086.7,244.1,1047.3,201.4,995.8,201.4 M1085,499.6V368.1h-0.8c-19.5,29.8-53,45.2-88.3,45.2c-68,0-121.9-51-121.9-119.4 c0-68,55.2-118.6,121.9-118.6c35.3,0,68.8,15.3,88.3,45.6h0.8v-39.8h29v318.5H1085z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M1530.6,201.4c-53.9,0-92.8,40.2-92.8,93.7c0,53.1,39.8,92.1,92.8,92.1c51.4,0,90.8-41.9,90.8-92.5 C1621.3,244.1,1582,201.4,1530.6,201.4 M1619.7,407.9v-39.8h-0.8c-19.9,29.8-53.1,45.2-88.3,45.2c-68,0-121.9-51-121.9-119.4 c0-68,55.1-118.6,121.9-118.6c35.7,0,68.9,15,88.3,45.6h0.8v-39.8h29v226.8H1619.7z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M1735.7,275.2v132.7h-29.1V181.1h29.1v32.8h0.8c12.5-29,34.4-36.5,63.9-38.6V206 C1760.6,209.3,1735.7,234.6,1735.7,275.2"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M1930.3,201.4c-45.2,0-81.3,33.2-88.4,77.5H2019C2011.6,234.6,1975.9,201.4,1930.3,201.4 M2048.5,305.1H1842 c2.1,44.8,43.6,82.1,88,82.1c34.8,0,68.8-19.9,81.3-53.5h30.6c-16.5,47.3-61.3,79.6-111.5,79.6c-65.5,0-118.2-53.5-118.2-118.6 c0-64.7,52.7-119.4,117.8-119.4c66.4,0,119,56,119,121.5C2048.9,299.6,2048.5,302.1,2048.5,305.1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M1339.3,408.2v-35.4h-0.8c-13.3,28-42.9,40.9-72.9,40.9c-29.6,0-59.6-10.4-78.3-34.1 c-16.2-20.4-20-47.9-20-73.3V180.3h29.2v125.4c0,47.1,17.1,81.7,69.2,81.7c19.1,0,34.2-5,48.3-18.4c20-19.1,23.7-41.7,23.7-68.3 V180.3h29.2v227.9H1339.3z"
            })
        ]
    });

});

parcelRegister("keghS", function(module, exports) {
$parcel$export(module.exports, "PaypalLogo", function () { return $0fb5b24cc361caa4$export$de02d99730715183; });

var $7VQPk = parcelRequire("7VQPk");
const $0fb5b24cc361caa4$export$de02d99730715183 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        "aria-hidden": true,
        fill: "currentColor",
        viewBox: "0 0 500 121",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M44,28.51h34.1c18.31,0,25.2,9.26,24.14,22.9C100.52,73.89,86.93,86.33,68.9,86.33H59.8c-2.47,0-4.14,1.63-4.81,6.07l-3.9,25.77c-.26,1.68-1.14,2.66-2.46,2.78H27.25c-2,0-2.73-1.54-2.21-4.88L38.1,33.4C38.63,30.08,40.44,28.51,44,28.51Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M192.08,27c11.5,0,22.12,6.24,20.67,21.79-1.73,18.45-11.67,28.72-27.3,28.76H171.81c-2,0-2.91,1.6-3.43,4.89L165.75,99.2c-.39,2.54-1.69,3.79-3.62,3.79h-12.7c-2,0-2.73-1.29-2.28-4.19l10.5-67.28c.52-3.31,1.78-4.54,4-4.54ZM171.39,63h10.34c6.47-.25,10.77-4.73,11.2-12.81.27-5-3.1-8.56-8.47-8.54l-9.73.05L171.39,63Zm75.88,34.84c1.16-1,2.34-1.6,2.17-.3l-.41,3.12c-.22,1.62.43,2.49,1.95,2.49h11.28c1.9,0,2.83-.77,3.29-3.7l7-43.65c.35-2.19-.18-3.26-1.85-3.26h-12.4c-1.12,0-1.67.62-2,2.33l-.46,2.69c-.24,1.4-.88,1.64-1.48.23-2.1-5-7.47-7.22-15-7.06-17.4.36-29.14,13.57-30.39,30.5-1,13.1,8.42,23.39,20.79,23.39,9,0,13-2.68,17.51-6.78Zm-9.44-6.7c-7.49,0-12.72-6-11.63-13.3a16.2,16.2,0,0,1,15.58-13.3c7.5,0,12.72,6,11.63,13.3a16.21,16.21,0,0,1-15.58,13.3ZM294.6,52.39H283.2c-2.36,0-3.32,1.72-2.57,3.92l14.21,41.6-14,19.79c-1.17,1.65-.27,3.16,1.38,3.16h12.86a4,4,0,0,0,3.83-1.87l43.68-62.68c1.35-1.93.72-4-1.49-4H328.94c-2.09,0-2.93.82-4.12,2.56L306.59,81.35l-8.1-26.49C298,53.23,296.79,52.39,294.6,52.39Z",
                opacity: 0.6
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M388.06,27c11.51,0,22.13,6.24,20.67,21.79C407,67.22,397.07,77.49,381.44,77.53H367.8c-2,0-2.91,1.6-3.43,4.89L361.74,99.2c-.4,2.54-1.7,3.79-3.62,3.79h-12.7c-2,0-2.73-1.29-2.28-4.19l10.5-67.28c.51-3.31,1.78-4.54,4-4.54ZM367.38,63h10.34c6.47-.25,10.77-4.73,11.2-12.81.27-5-3.1-8.56-8.47-8.54l-9.74.05L367.38,63Zm75.88,34.84c1.16-1,2.34-1.6,2.17-.3l-.41,3.12c-.22,1.62.43,2.49,2,2.49h11.28c1.9,0,2.82-.77,3.29-3.7l6.95-43.65c.35-2.19-.18-3.26-1.84-3.26H454.24c-1.12,0-1.66.62-1.95,2.33l-.46,2.69c-.24,1.4-.88,1.64-1.48.23-2.11-5-7.47-7.22-15-7.06-17.41.36-29.14,13.57-30.4,30.5-1,13.1,8.42,23.39,20.79,23.39,9,0,13-2.68,17.52-6.78Zm-9.44-6.7c-7.5,0-12.72-6-11.63-13.3a16.2,16.2,0,0,1,15.58-13.3c7.49,0,12.72,6,11.63,13.3a16.21,16.21,0,0,1-15.58,13.3Zm52,12.09h-13a1.53,1.53,0,0,1-1.6-1.8l11.45-72.49a2.25,2.25,0,0,1,2.17-1.8h13a1.53,1.53,0,0,1,1.6,1.8L488,101.42A2.26,2.26,0,0,1,485.86,103.22Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M22.72.05H56.86c9.61,0,21,.31,28.64,7,5.1,4.5,7.77,11.66,7.15,19.34C90.56,52.5,75,67.1,54.06,67.1H37.22c-2.86,0-4.76,1.9-5.57,7L27,104c-.3,1.93-1.14,3.08-2.68,3.21h-21c-2.34,0-3.17-1.78-2.56-5.65L15.84,5.72C16.44,1.88,18.54.05,22.72.05Z",
                opacity: 0.6
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M32.14,71.13l6-37.73c.53-3.32,2.34-4.89,5.94-4.89h34.1A33.35,33.35,0,0,1,91.92,31C88.5,54.21,73.49,67.1,53.84,67.1H37C34.79,67.1,33.14,68.23,32.14,71.13Z"
            })
        ]
    });

});

parcelRegister("kEiKm", function(module, exports) {
$parcel$export(module.exports, "NasaLogo", function () { return $cf7af220a252a559$export$e44efe2f415651b3; });

var $7VQPk = parcelRequire("7VQPk");
const $cf7af220a252a559$export$e44efe2f415651b3 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        "aria-hidden": true,
        fill: "currentColor",
        viewBox: "2.834 70.312 187.088 52.134",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M102.379 121.166h25.672c3.836 0 6.984-1.574 9.541-4.723 2.459-3.049 3.738-6.688 3.738-10.818 0-8.361-10.721-14.263-14.854-14.263h-14.065c-1.082 0-1.969-.492-2.656-1.278-.689-.886-1.082-1.869-1.082-3.05 0-1.377.393-2.557 1.082-3.541.787-.983 1.77-1.573 2.951-1.573h26.361V71.394h-26.854c-4.82 0-8.559 1.476-11.215 4.328-2.359 2.656-3.541 6.197-3.541 10.427 0 4.131 1.182 7.771 3.541 10.72 2.656 3.246 5.805 4.92 9.641 4.92h16.231c.982 0 1.77.295 2.359 1.08.689.787.984 1.771.984 2.854 0 1.279-.492 2.459-1.279 3.443-.885.885-1.869 1.377-3.146 1.377H99.82l-.393-.689-9.738-31.279-.492-.984c-2.361-4.82-6.295-7.18-11.705-7.18-2.951 0-5.607.688-7.968 2.164-2.459 1.475-4.033 3.639-4.918 6.394l-13.083 42.098 11.902.1 12-37.476c.295-1.181.984-1.771 1.869-1.771.492 0 .885.196 1.18.492.295.393.492.787.59 1.279l12.098 37.476h11.217v-.001zM13.851 86.739v34.328H2.834V83.001c0-4.918 1.181-8.361 3.738-10.426 1.967-1.476 4.918-2.263 9.049-2.263 3.344 0 6.197.984 8.754 2.853 2.557 1.869 4.229 4.426 5.115 7.574l7.18 25.279 1.181 3.443c.098.688.492 1.18.885 1.572.492.395.983.592 1.574.395.984-.098 1.476-.689 1.476-1.574V71.493h11.312v37.869c0 4.23-.983 7.379-3.049 9.641-1.967 2.262-4.918 3.443-8.853 3.443-3.443 0-6.296-.689-8.558-1.869-2.754-1.377-4.525-3.541-5.312-6.395l-8.262-28.82-.59-1.869c-.197-.688-.59-1.18-1.082-1.672-.492-.394-1.082-.492-1.672-.394-.59.099-.983.394-1.377.984a3.398 3.398 0 0 0-.492 1.77v2.558zm176.071 34.427-12.787-42.591-.492-.984c-2.361-4.82-6.295-7.18-11.705-7.18-2.951 0-5.607.688-7.967 2.164-2.461 1.475-4.033 3.639-4.92 6.394l-13.082 42.098 11.902.1 12-37.476c.295-1.181.984-1.771 1.869-1.771.492 0 .885.196 1.18.492.297.393.492.787.592 1.279l12.098 37.476h11.312v-.001z"
        })
    });

});

parcelRegister("ecrbE", function(module, exports) {
$parcel$export(module.exports, "FordLogo", function () { return $81c63495eccae022$export$22ac95c9dec2accf; });

var $7VQPk = parcelRequire("7VQPk");
const $81c63495eccae022$export$22ac95c9dec2accf = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        "aria-hidden": true,
        fill: "currentColor",
        viewBox: "0 0 500 175",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M250,1C112.68,1,1.37,39.72,1.37,87.51S112.68,174,250,174,498.63,135.3,498.63,87.51,387.31,1,250,1Zm0,165.58c-132.49,0-239.89-35.38-239.89-79S117.51,8.46,250,8.46,489.88,43.85,489.88,87.51,382.49,166.55,250,166.55Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M195.67,76.48c6.47-.82,16-1.73,22.16-2.08,1.36-.08,1.64-.06,2.19.61a20.27,20.27,0,0,0,5.91,4.77,4.58,4.58,0,0,0,2.12.78,2.7,2.7,0,0,0,2.07-1,2,2,0,0,0,.47-2.24c-.37-.64-4.63-3-4.77-3.95-.09-.61.58-.74.58-.74a13.9,13.9,0,0,0,8.37-6.81c1.95-3.74,2.27-8.72-1.29-11.48-3.13-2.45-7.85-2.05-11.61,1.32a14.05,14.05,0,0,0-4.4,12.24c.09.72,0,1-.94,1-5.66.45-11.12.61-17.18.93-.41,0-.54-.24-.3-.53,7-12.12,17.41-20.76,29-29.28.76-.57.52-1.67.49-2.58,20.84,4.52,41,12.95,62.58,12.78,8.94-.08,17.49-1.44,25.67-5.93,7.19-3.91,10.11-7.55,10.33-11.31.17-2.62-1.64-4.26-4.22-3.7-21.85,5-42.67,5-64.4,2.33-24.66-3-48.32-9.14-72.85-9.14-3.69,0-7.39.14-11.13.45-23.71,2-46.27,15.35-46.32,35.62,0,10.27,7.28,18.61,18.61,18.24,13.29-.46,24.22-11.11,29.95-24.54,2.17-5.11-1.85-7.22-3.77-4.29a33.85,33.85,0,0,1-13.42,12c-6.27,3.06-12.95,2.23-15-2.85-2.85-7.18,3.08-17.9,16.61-23,19.55-7.24,40-2.45,59.67,1.25.27,0,1.32.58.4,1.05a57,57,0,0,0-12.39,8.14A101.62,101.62,0,0,0,196,57.14c-3.9,4.74-6.67,9-10.32,13.67a1.44,1.44,0,0,1-1.11.64C175.61,73,166.9,74,158.92,79.51c-1.64,1.14-2.35,3.15-1.36,4.71a3.09,3.09,0,0,0,4.38.46,26.85,26.85,0,0,1,15.92-5.61c.25,0,.37.07.45.22a.48.48,0,0,1-.09.41c-8.77,12.17-11,14.92-17.56,22.46a128,128,0,0,1-10.4,10.55c-15,13.91-31.08,13.67-36.87,5a14.83,14.83,0,0,1-.73-15.29c2.79-5.59,8.41-9.67,13.1-12.06,1.74-.89,2.24-3.12.5-5.15-1.1-1.31-3.79-1.55-5.79-1.18-6.13,1.13-13.39,5.77-17.66,11.35a31,31,0,0,0-6.43,22.39c1.46,15.41,14.12,24.29,28.51,24.18,11.46-.09,22.24-3.55,35.22-16.73,12.09-12.29,23.12-30.63,33.45-47.66C193.88,77,194.12,76.67,195.67,76.48Zm30.49-17.79a3,3,0,0,1,3.94-.46c1.15,1,.61,3.43-.56,5.14a9.46,9.46,0,0,1-5.39,3.88H224c-.33,0-.6-.23-.75-1A8.77,8.77,0,0,1,226.16,58.69Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M404,58.15H390.71c-1,0-1.49.13-1.95,1-1.54,2.93-20.15,30.82-23.61,36.23-.57.82-1.29.7-1.38-.23-.34-3.22-3.12-6.91-7.5-8.68a18.91,18.91,0,0,0-10-1.15c-6.12.82-11.57,4-16.37,7.69-7.21,5.5-13.45,12.62-21.49,17.88C304,113.8,298,116.28,294,112.56c-3.64-3.38-3.23-10.88,2.33-16.69.6-.6,1.3-.09,1.19.45a7.36,7.36,0,0,0,2.12,7.07,7.9,7.9,0,0,0,8.88,1,11.59,11.59,0,0,0,6.18-8.91,10.16,10.16,0,0,0-9.32-11.57c-4.64-.32-9.08,1.29-13.4,4.87a25.5,25.5,0,0,0-5.28,5.8c-.47.65-1.17.72-1.14-.26.21-7.57-2.93-11.84-9.19-12-4.87-.11-10.06,2.52-14.12,5.76-4.43,3.56-8.32,8.28-12.48,12.73-.52.55-1,.52-1.11-.54-.13-5-1.4-9.89-3.72-13.34a3.08,3.08,0,0,0-4-1,29.48,29.48,0,0,0-4.72,2.82,2.67,2.67,0,0,0-.8,3A35.14,35.14,0,0,1,234.11,115c-2.79,6.61-8.23,12.55-14.61,14.58-4.2,1.32-8.58.67-11.29-3.06-3.71-5.14-2.21-14.1,3.32-21.52,4.9-6.55,12-10.7,19-13.39a1.1,1.1,0,0,0,.77-1.55c-.39-1.17-1-2.74-1.24-3.46-.66-1.72-2.46-2-4.68-1.76a39.6,39.6,0,0,0-14.31,4.8c-12,6.4-18,18.79-20.58,25.43a25.72,25.72,0,0,1-3.76,6.93c-1.88,2.36-4.25,4.52-8.58,8.32a1.55,1.55,0,0,0-.34,1.76c.44.9,2.7,4.08,3.32,4.38A2,2,0,0,0,183,136a44.67,44.67,0,0,0,8.42-7.52c.63-.74,1.26-.42,1.59.72A18.59,18.59,0,0,0,205,142c11,3.71,22.33-1.64,30.92-11,5.45-5.92,7.43-9.73,9.52-12.32C249,114.29,256,104.47,264.3,98.17c3.05-2.34,6.67-4.12,8.48-2.94,1.46,1,1.93,3.15-.41,7.4-8.49,15.5-21,33.72-23.27,38.13-.43.78,0,1.37.75,1.37,4.45,0,8.85,0,12.88,0a1.51,1.51,0,0,0,1.3-.81c6.52-10.2,12.65-19.9,19.22-29.94.37-.59.71-.13.72.13.15,2.32.71,5.51,2.1,7.6a11.38,11.38,0,0,0,9.9,5.56c3.11,0,4.69-.44,8-1.7a27.46,27.46,0,0,0,6.59-3.53c1-.69,1.16.46,1.13.64-1.51,8.09.36,17.68,8.41,21.66,9.62,4.74,20.2-1.92,26.3-7.95.58-.58,1.22-.52,1.29.73a11.07,11.07,0,0,0,3.07,7c5.1,5.11,15.39,3.08,25.72-4.92,6.63-5.11,13.58-12.35,19.84-20a.89.89,0,0,0,0-1.26c-1-1-2.33-2.13-3.28-3a1.18,1.18,0,0,0-1.43,0c-6.42,6.12-12.21,13.09-20.56,18.85-2.83,2-7.32,3.57-9.34.83-.79-1.06-.7-2.53.08-4.45,2.43-6.08,41-64.82,43-68.3C405.15,58.59,404.79,58.15,404,58.15ZM353.8,108.46c.08.46.66.89,1.23,1.09.21.07.32.23.1.69a59.09,59.09,0,0,1-5.2,8.61,32.38,32.38,0,0,1-6.62,7.14c-3,2.48-6.9,5.13-10.58,5.13a6.64,6.64,0,0,1-3.17-.76c-2-1-2.85-3.81-2.82-6.06.11-6.32,2.92-12.81,8.11-19.19,6.33-7.8,13.33-11.84,17.92-9.63,4.76,2.27,3.25,7.76,1.12,12.09A1.18,1.18,0,0,0,353.8,108.46Z"
            })
        ]
    });

});

parcelRegister("8Uvps", function(module, exports) {
$parcel$export(module.exports, "EbayLogo", function () { return $31671601fcd49ae7$export$6e7d7fb1946ca256; });

var $7VQPk = parcelRequire("7VQPk");
const $31671601fcd49ae7$export$6e7d7fb1946ca256 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        "aria-hidden": true,
        fill: "currentColor",
        viewBox: "0 0 100 44",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M13.039,8.84c-12.47,0-13,9.69-12.9,12.23,0,0-.62,11.35,12.58,11.35,11.35,0,11.89-7.12,11.89-7.12h-5.22s-1,3.94-6.67,3.83C5.469,29,5.2,21.95,5.2,21.95h20.11S26.829,8.84,13.039,8.84ZM5.389,18.5s.34-6.34,7.52-6.34,7.15,6.34,7.15,6.34Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M39.249,8.84c-6.26,0-9,3.72-9,3.72V0h-5l.08,26.51s0,3.08-.22,5.14h4.88l.21-3s2.28,3.75,8.94,3.75,11.92-4.09,12.05-11.7S45.549,8.86,39.249,8.84ZM38.1,29c-7.92.11-7.79-8.4-7.79-8.4s-.29-8.2,7.77-8.38,7.79,8.56,7.79,8.56S46.029,28.92,38.1,29Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M74.429,26.4c0-3.43.11-6.48,0-8.65-.13-2.52.11-8.54-10.7-9,0,0-10.39-.94-11.46,6.77h5.3s.4-3.54,5.81-3.43c5.08.11,6,2.6,6,5.68h-5.83c-2.63,0-11.84.3-12.69,5.92-1,6.67,4.92,8.73,9.58,8.7s7.31-1.42,9.27-3.91l.21,3.11h4.63S74.429,29.83,74.429,26.4Zm-13.14,2.81s-5,0-5.33-4c-.32-4.28,7.77-4,7.77-4h5.7S70.339,29.32,61.289,29.21Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("polygon", {
                points: "71.679 9.67 77.509 9.67 86.049 26.69 94.599 9.67 99.869 9.67 84.449 40 78.799 40 83.269 31.57 71.679 9.67"
            })
        ]
    });

});

parcelRegister("2KJKq", function(module, exports) {
$parcel$export(module.exports, "DominosLogo", function () { return $23f7dfd84bf81e71$export$3a87515d6bae358a; });

var $7VQPk = parcelRequire("7VQPk");
const $23f7dfd84bf81e71$export$3a87515d6bae358a = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        "aria-hidden": true,
        fill: "currentColor",
        viewBox: "0 0 2318.3 500",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M1331.1,323.5c-25-58.4-111.2-40.3-134.8-2.8v-29.2h-75.1v207.1h77.8V394.4c0-38.9,8.3-41.7,29.2-43.1 c20.8-1.4,29.2,1.4,29.2,43.1l1.4,104.2h75.1v-107c0-19.5,4.2-37.5,25-37.5c25-1.4,30.6,1.4,30.6,32v114h79.2V345.7 C1470.1,272.1,1365.9,270.7,1331.1,323.5z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M986.4,276.2c-61.2,0-111.2,50-111.2,111.2s50,111.2,111.2,111.2s111.2-50,111.2-111.2 S1047.6,276.2,986.4,276.2z M986.4,426.3c-22.2,0-38.9-18.1-38.9-38.9c0-22.2,18.1-38.9,38.9-38.9c20.8,0,38.9,18.1,38.9,38.9 C1025.4,408.3,1007.3,426.3,986.4,426.3z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M775.2,224.8c-15.3-6.9-30.6-12.5-47.3-13.9c-23.6-2.8-47.3-4.2-70.9-4.2h-86.2v291.9h79.2 c26.4,0,52.8-1.4,77.8-4.2c16.7-2.8,33.4-6.9,48.6-13.9c23.6-12.5,44.5-30.6,59.8-52.8c27.8-45.9,27.8-104.2,0-150.1 C821.1,255.4,800.2,237.3,775.2,224.8z M765.5,387.4c-5.6,9.7-13.9,19.5-25,25c-5.6,2.8-12.5,5.6-19.5,6.9 c-11.1,1.4-20.8,2.8-32,1.4h-32V283.2h36.1c9.7,0,19.5,0,29.2,1.4c6.9,1.4,13.9,2.8,19.5,6.9c9.7,5.6,18.1,13.9,25,25 c5.6,11.1,8.3,23.6,8.3,34.7C773.8,363.8,771,376.3,765.5,387.4z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                x: 1502.1,
                y: 287.4,
                width: 77.8,
                height: 209.9
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M2140,245.7c2.8-12.5,2.8-26.4-2.8-37.5c-6.9-15.3-22.2-25-38.9-25c-19.5-1.4-37.5,12.5-41.7,30.6 c-5.6,22.2,6.9,44.5,29.2,51.4c5.6,1.4,11.1,0,6.9,6.9c-4.2,5.6-9.7,11.1-15.3,15.3l8.3,12.5 C2119.2,281.8,2135.9,263.7,2140,245.7z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M1964.9,276.2c-61.2,0-111.2,50-111.2,111.2s50,111.2,111.2,111.2s111.2-50,111.2-111.2 S2026.1,276.2,1964.9,276.2z M1964.9,426.3c-22.2,0-38.9-18.1-38.9-38.9c0-20.8,18.1-38.9,38.9-38.9s38.9,18.1,38.9,38.9 C2003.8,408.3,1987.1,426.3,1964.9,426.3z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M2227.6,358.2c-38.9,0-36.1-26.4-12.5-27.8c25-1.4,50,5.6,69.5,20.8l25-48.6 c-68.1-40.3-183.5-34.7-186.2,38.9l0,0c-1.4,41.7,30.6,62.5,95.9,69.5c47.3,5.6,33.4,26.4,6.9,29.2c-26.4,2.8-51.4-9.7-77.8-25 l-33.4,50c91.7,58.4,198.7,32,202.9-36.1C2322.1,388.8,2290.1,356.8,2227.6,358.2z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M1691.1,320.7v-29.2h-75.1v207.1h75.1V394.4c0-34.7,15.3-41.7,32-43.1c20.8-2.8,36.1,1.4,36.1,43.1l1.4,104.2 h75.1V347.1C1834.3,272.1,1720.3,272.1,1691.1,320.7z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M1541,183.1c-23.6,0-43.1,19.5-43.1,43.1c0,23.6,19.5,43.1,43.1,43.1s43.1-19.5,43.1-43.1 C1584.1,202.6,1564.6,183.1,1541,183.1z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M494.4,151.1L348.5,5.2l0,0c-6.9-6.9-16.7-6.9-23.6,0L170.6,158.1l169.6,169.6l154.3-152.9l0,0 C501.4,167.8,501.4,158.1,494.4,151.1z M368,190.1c-16.7,16.7-43.1,16.7-58.4,0c-16.7-16.7-16.7-43.1,0-58.4l0,0 c16.7-16.7,43.1-16.7,58.4,0C383.3,147,383.3,173.4,368,190.1z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M160.9,169.2L5.2,323.5l0,0l0,0c-6.9,6.9-6.9,16.7,0,23.6l145.9,145.9l0,0c6.9,6.9,16.7,6.9,23.6,0L329,340.2 L160.9,169.2z M130.3,366.6c-16.7,15.3-43.1,15.3-58.4,0c-16.7-16.7-16.7-43.1,0-58.4s43.1-15.3,58.4,0 C145.6,323.5,145.6,349.9,130.3,366.6z M192.8,366.6c-16.7-15.3-16.7-43.1,0-58.4l0,0c16.7-16.7,43.1-16.7,58.4,0 c16.7,16.7,16.7,43.1,0,58.4C234.5,383.3,209.5,383.3,192.8,366.6z"
            })
        ]
    });

});

parcelRegister("bmyHB", function(module, exports) {
$parcel$export(module.exports, "CiscoLogo", function () { return $85f2815b49fbc3e5$export$c0ee1f55c8145cdb; });

var $7VQPk = parcelRequire("7VQPk");
const $85f2815b49fbc3e5$export$c0ee1f55c8145cdb = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        "aria-hidden": true,
        fill: "currentColor",
        viewBox: "0 0 79 42",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M22.2429424,41.0366151 L25.691892,41.0366151 L25.691892,27.4402999 L22.2429424,27.4402999 L22.2429424,41.0366151 Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M53.4978468,31.3359257 C53.356853,31.2637727 52.2457684,30.6093615 50.5963441,30.6093615 C48.3677661,30.6093615 46.8208827,32.1541075 46.8208827,34.236813 C46.8208827,36.2574334 48.300305,37.8659425 50.5963441,37.8659425 C52.2181094,37.8659425 53.3463965,37.2252908 53.4978468,37.1447479 L53.4978468,40.7936775 C53.0644091,40.9148275 51.8878872,41.2782774 50.3561825,41.2782774 C46.4764936,41.2782774 43.0720684,38.6176764 43.0720684,34.236813 C43.0720684,30.1757722 46.1526803,27.1987047 50.3561825,27.1987047 C51.9728882,27.1987047 53.1716723,27.590009 53.4978468,27.6863249 L53.4978468,31.3359257 Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M17.5025508,31.3359257 C17.3639182,31.2637727 16.2551948,30.6093615 14.6057704,30.6093615 C12.3721328,30.6093615 10.8262613,32.1541075 10.8262613,34.236813 C10.8262613,36.2574334 12.3077075,37.8659425 14.6057704,37.8659425 C16.2271984,37.8659425 17.354811,37.2252908 17.5025508,37.1447479 L17.5025508,40.7936775 C17.07451,40.9148275 15.8983255,41.2782774 14.3581881,41.2782774 C10.481535,41.2782774 7.08115739,38.6176764 7.08115739,34.236813 C7.08115739,30.1757722 10.161432,27.1987047 14.3581881,27.1987047 C15.9802907,27.1987047 17.1787375,27.590009 17.5025508,27.6863249 L17.5025508,31.3359257 Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M64.3466401,30.6607076 C62.3008817,30.6607076 60.78132,32.2621693 60.78132,34.236813 C60.78132,36.215484 62.3008817,37.8156032 64.3466401,37.8156032 C66.3900373,37.8156032 67.9136467,36.215484 67.9136467,34.236813 C67.9136467,32.2621693 66.3900373,30.6607076 64.3466401,30.6607076 M71.5673408,34.236813 C71.5673408,38.1263646 68.5491304,41.2782774 64.3466401,41.2782774 C60.1438125,41.2782774 57.1293124,38.1263646 57.1293124,34.236813 C57.1293124,30.3529666 60.1438125,27.1987047 64.3466401,27.1987047 C68.5491304,27.1987047 71.5673408,30.3529666 71.5673408,34.236813"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M38.7701066,30.5307315 C38.7188362,30.5142873 37.2663983,30.1155999 36.0736858,30.1155999 C34.6917448,30.1155999 33.9412398,30.5760369 33.9412398,31.2301125 C33.9412398,32.0583621 34.9541685,32.3459674 35.5221911,32.5245042 L36.4730556,32.8262046 C38.7117528,33.5339754 39.7310902,35.0592569 39.7310902,36.7154206 C39.7310902,40.1307757 36.7125425,41.2781767 34.0734636,41.2781767 C32.2381839,41.2781767 30.5206239,40.9425812 30.3512965,40.9070081 L30.3512965,37.7779159 C30.6552088,37.8544316 32.1012378,38.2843294 33.6079819,38.2843294 C35.3231808,38.2843294 36.1124759,37.7839566 36.1124759,37.0144361 C36.1124759,36.325123 35.4297694,35.9271068 34.575037,35.6596372 C34.3655703,35.5905045 34.0518761,35.4928462 33.8383616,35.4237136 C31.917069,34.8189705 30.316554,33.6964036 30.316554,31.4459004 C30.316554,28.9027578 32.229414,27.1945769 35.4085191,27.1945769 C37.0876263,27.1945769 38.6672284,27.5999762 38.7701066,27.6278306 L38.7701066,30.5307315 Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M3.42405648,12.8286741 C3.42405648,11.8910203 2.65567435,11.1308966 1.71223062,11.1308966 C0.770136118,11.1308966 6.74611175e-05,11.8910203 6.74611175e-05,12.8286741 L6.74611175e-05,16.3970608 C6.74611175e-05,17.3397485 0.770136118,18.0998723 1.71223062,18.0998723 C2.65567435,18.0998723 3.42405648,17.3397485 3.42405648,16.3970608 L3.42405648,12.8286741 Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M12.8283386,8.14366055 C12.8283386,7.20667798 12.0596192,6.44521184 11.1165128,6.44521184 C10.1734064,6.44521184 9.40434963,7.20667798 9.40434963,8.14366055 L9.40434963,16.3969601 C9.40434963,17.3396478 10.1734064,18.0997716 11.1165128,18.0997716 C12.0596192,18.0997716 12.8283386,17.3396478 12.8283386,16.3969601 L12.8283386,8.14366055 Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M22.2328907,1.73395472 C22.2328907,0.796972141 21.4634966,0.0368483835 20.5203902,0.0368483835 C19.5776211,0.0368483835 18.808227,0.796972141 18.808227,1.73395472 L18.808227,19.789327 C18.808227,20.7310079 19.5776211,21.4918029 20.5203902,21.4918029 C21.4634966,21.4918029 22.2328907,20.7310079 22.2328907,19.789327 L22.2328907,1.73395472 Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.6367681,8.14366055 C31.6367681,7.20667798 30.8677113,6.44521184 29.9242676,6.44521184 C28.9814985,6.44521184 28.212779,7.20667798 28.212779,8.14366055 L28.212779,16.3969601 C28.212779,17.3396478 28.9814985,18.0997716 29.9242676,18.0997716 C30.8677113,18.0997716 31.6367681,17.3396478 31.6367681,16.3969601 L31.6367681,8.14366055 Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M41.0304588,12.8286741 C41.0304588,11.8910203 40.266799,11.1308966 39.3284148,11.1308966 C38.385983,11.1308966 37.6169263,11.8910203 37.6169263,12.8286741 L37.6169263,16.3970608 C37.6169263,17.3397485 38.385983,18.0998723 39.3284148,18.0998723 C40.266799,18.0998723 41.0304588,17.3397485 41.0304588,16.3970608 L41.0304588,12.8286741 Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M50.4383164,8.14366055 C50.4383164,7.20667798 49.6746566,6.44521184 48.7318875,6.44521184 C47.7911422,6.44521184 47.0254585,7.20667798 47.0254585,8.14366055 L47.0254585,16.3969601 C47.0254585,17.3396478 47.7911422,18.0997716 48.7318875,18.0997716 C49.6746566,18.0997716 50.4383164,17.3396478 50.4383164,16.3969601 L50.4383164,8.14366055 Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M59.8490074,1.73395472 C59.8490074,0.796972141 59.0846729,0.0368483835 58.1425784,0.0368483835 C57.1987974,0.0368483835 56.4354748,0.796972141 56.4354748,1.73395472 L56.4354748,19.789327 C56.4354748,20.7310079 57.1987974,21.4918029 58.1425784,21.4918029 C59.0846729,21.4918029 59.8490074,20.7310079 59.8490074,19.789327 L59.8490074,1.73395472 Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M69.2578432,8.14366055 C69.2578432,7.20667798 68.4941833,6.44521184 67.5298267,6.44521184 C66.5863829,6.44521184 65.8227231,7.20667798 65.8227231,8.14366055 L65.8227231,16.3969601 C65.8227231,17.3396478 66.5863829,18.0997716 67.5298267,18.0997716 C68.4941833,18.0997716 69.2578432,17.3396478 69.2578432,16.3969601 L69.2578432,8.14366055 Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M78.6469129,12.8286741 C78.6469129,11.8910203 77.8808919,11.1308966 76.9404839,11.1308966 C75.9973775,11.1308966 75.2316938,11.8910203 75.2316938,12.8286741 L75.2316938,16.3970608 C75.2316938,17.3397485 75.9973775,18.0998723 76.9404839,18.0998723 C77.8808919,18.0998723 78.6469129,17.3397485 78.6469129,16.3970608 L78.6469129,12.8286741 Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M76.6735065,39.2465823 L76.6735065,39.4596855 L76.0639953,39.4596855 L76.0639953,41.0366486 L75.8133773,41.0366486 L75.8133773,39.4596855 L75.2011676,39.4596855 L75.2011676,39.2465823 L76.6735065,39.2465823 Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M76.8013453,39.2465823 L77.1936317,39.2465823 L77.7312968,40.714477 L77.741416,40.714477 L78.2618785,39.2465823 L78.6467442,39.2465823 L78.6467442,41.0366486 L78.3893801,41.0366486 L78.3893801,39.5677472 L78.3809474,39.5677472 L77.835187,41.0366486 L77.5973865,41.0366486 L77.0644437,39.5677472 L77.052638,39.5677472 L77.052638,41.0366486 L76.8013453,41.0366486 L76.8013453,39.2465823 Z"
            })
        ]
    });

});


parcelRegister("l7ZAy", function(module, exports) {
$parcel$export(module.exports, "AuxiaSocial", function () { return $94b9107219516ada$export$fe45cc996003fded; });
/* paid-jsm-account-creation-social-auxia.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $ig7Vf = parcelRequire("ig7Vf");

var $gSzjE = parcelRequire("gSzjE");

var $lHKk6 = parcelRequire("lHKk6");

var $jUqeL = parcelRequire("jUqeL");

var $cGEBM = parcelRequire("cGEBM");

var $gx3aw = parcelRequire("gx3aw");
const $94b9107219516ada$export$fe45cc996003fded = ({ providers: providers, auxiaResponse: auxiaResponse })=>{
    const intl = (0, $8e22h.default)();
    const { onClickSocialButton: onClickSocialButton } = (0, $cGEBM.useAccountCreationContext)();
    if (providers === undefined) providers = {
        google: 'Google',
        microsoft: 'Microsoft',
        apple: 'Apple',
        slack: 'Slack'
    };
    const buttons = Object.entries(providers);
    const buttonGridCss = null;
    const buttonListCss = null;
    /* eslint-disable jsx-a11y/no-redundant-roles */ /* added role="list" to ul for safari https://developer.mozilla.org/en-US/docs/Web/CSS/list-style#accessibility  */ return /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
        role: "list",
        className: (0, $2jatx.default)([
            "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            buttons.length > 1 && "_1e0c11p5 _zulp7vkz _yv0efsjm"
        ]),
        children: buttons.map(([provider, label])=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $lHKk6.LogoButton), {
                    "aria-label": intl.formatMessage({
                        id: 'social.label.signup',
                        defaultMessage: 'sign up with {provider}'
                    }, {
                        provider: label
                    }),
                    onClick: ()=>{
                        if ((0, $ig7Vf.isAuxiaServedPage)(auxiaResponse)) {
                            const anonymousId = decodeURIComponent((0, $gx3aw.Cookie).readCookie('ajs_anonymous_id') || '').replace(/['"]+/g, '');
                            (0, $gSzjE.sendAnalyticsToAuxia)({
                                anonymousId: anonymousId,
                                treatmentTrackingId: auxiaResponse.treatmentTrackingId,
                                treatmentId: auxiaResponse.treatmentId,
                                interactionType: 'CLICKED',
                                interactionTimeMicros: (0, $gSzjE.convertDateTimeToInteractionTimeMicros)(Date.now()),
                                actionName: `${provider}_login`
                            });
                        }
                        return onClickSocialButton(provider);
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jUqeL.ProviderLogo), {
                            logo: provider
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            children: label
                        })
                    ]
                })
            }, provider))
    });
};

});

parcelRegister("3Souq", function(module, exports) {
$parcel$export(module.exports, "AuxiaSubmit", function () { return $c17f6bc250444eac$export$f9bc420969cdc1a3; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $ig7Vf = parcelRequire("ig7Vf");

var $gSzjE = parcelRequire("gSzjE");

var $lmQGF = parcelRequire("lmQGF");

var $cGEBM = parcelRequire("cGEBM");

var $gx3aw = parcelRequire("gx3aw");
const $c17f6bc250444eac$export$f9bc420969cdc1a3 = ({ buttonText: buttonText, auxiaResponse: auxiaResponse })=>{
    const intl = (0, $8e22h.default)();
    const { isSubmitting: isSubmitting, hasSubmitted: hasSubmitted, formError: formError, onClickSubmitButton: onClickSubmitButton } = (0, $cGEBM.useAccountCreationContext)();
    if (buttonText === undefined) buttonText = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.submit',
        defaultMessage: 'Sign up'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
        type: "submit",
        isDisabled: isSubmitting || hasSubmitted && !formError,
        isFullWidth: true,
        isLoading: isSubmitting || hasSubmitted && !formError,
        onClick: ()=>{
            if ((0, $ig7Vf.isAuxiaServedPage)(auxiaResponse)) {
                const anonymousId = decodeURIComponent((0, $gx3aw.Cookie).readCookie('ajs_anonymous_id') || '').replace(/['"]+/g, '');
                (0, $gSzjE.sendAnalyticsToAuxia)({
                    anonymousId: anonymousId,
                    treatmentTrackingId: auxiaResponse.treatmentTrackingId,
                    treatmentId: auxiaResponse.treatmentId,
                    interactionType: 'CLICKED',
                    interactionTimeMicros: (0, $gSzjE.convertDateTimeToInteractionTimeMicros)(Date.now()),
                    actionName: 'sign_up'
                });
            }
            return onClickSubmitButton();
        },
        children: buttonText
    });
};

});



parcelRegister("cqYjz", function(module, exports) {
$parcel$export(module.exports, "PaidHeroSectionTypes", function () { return $c0ef82fc39e5a653$export$f14a1c5ae1fdb785; });
/* paid-hero-section-types.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $c0ef82fc39e5a653$var$heroStyles = {
    'jira-software': "_bfhkuzct _1itk1mj5 _ouxlsfij _12vemgnk _1lrw16om _1rmv1nmc",
    'jira-software-paid-ai': "",
    'jira-software-anchor': "_syazr3uz _bfhkdoyu _1ndau67f _1twl8n31 _r8nt1nn1 _7gaj1h6o",
    'jira-software-rebranded-anchor': "_1pfh1wqb _kqswh2mm _1kt9b3bt _1cs8stnw _iajmgktf _z5wtidpf _1enw53f4 _1rusuzct _1fkrymf6 _7dwz16qr _8kay1h6o _1g0v1oqz _dsq4glyw _aetrb3bt _18postnw _1hfkuzct _19nq1h39 _g0nfuuw1 _1czdidpf _1gufidpf _clh31mo7 _1tlb1h6o _1bqq1oqz _11fnglyw",
    'jira-service-management': "_ct361wug _11q71yp8",
    'jira-service-management-anchor': "_syazr3uz _bfhkdoyu _1ndau67f _1twl8n31 _r8nt1nn1 _7gaj1h6o",
    'confluence-paid': "_16qs1qj0 _1itk1yrd _ouxlroey _12veeva1 _1lrw13e2",
    'confluence-anchor': "_16qs1qj0 _1itkr87c _ouxl1ssb _12vemgnk _1lrw1dfr _1rmvw151 _1f9f8d6s _r2cimgnk _u6yg1f51",
    'confluence-rebranded-anchor': "_1pfh1wqb _kqswh2mm _1kt9b3bt _1cs8stnw _iajmgktf _z5wtidpf _1enw53f4 _1rusuzct _1fkrymf6 _7dwz16qr _8kay1h6o _1g0v1oqz _dsq4glyw _aetrb3bt _18postnw _1hfkuzct _19nq1h39 _g0nfuuw1 _1czdidpf _1gufidpf _clh31mo7 _1tlb1h6o _1bqq1oqz _11fnglyw"
};
const $c0ef82fc39e5a653$var$JSMRebrandedAnchorBackground = null;
const $c0ef82fc39e5a653$var$darkThemeEmailForm = null;
const $c0ef82fc39e5a653$var$defaultHeroStyles = null;
const $c0ef82fc39e5a653$var$padding = null;
const $c0ef82fc39e5a653$export$f14a1c5ae1fdb785 = ({ darkSolidTheme: darkSolidTheme, landingType: landingType, heroComponent: heroComponent, showAnimatedHero: showAnimatedHero, showNewHero: showNewHero })=>{
    const customHero = !darkSolidTheme && showNewHero && $c0ef82fc39e5a653$var$heroStyles[landingType];
    const defaultHero = !darkSolidTheme && !showNewHero && $c0ef82fc39e5a653$var$defaultHeroStyles;
    const isRebrandedJSMHero = darkSolidTheme && showNewHero && landingType === 'jira-service-management-anchor';
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        id: "start-trial",
        className: (0, $2jatx.default)([
            showAnimatedHero && darkSolidTheme && "_bfhk5hrz _syaz1afi _n3c51afi _h4c6uol8 _4pvy1x3z _1ajj1s4t _235j1x3z _dadm1afi _128auftu _1ro31951",
            showAnimatedHero && !darkSolidTheme && showNewHero && $c0ef82fc39e5a653$var$heroStyles[landingType],
            showAnimatedHero && !darkSolidTheme && !showNewHero && "_bfhkuzct _1itk1mj5 _ouxlsfij _12vemgnk _1lrw16om _ij141nmc",
            !showAnimatedHero && $c0ef82fc39e5a653$var$heroStyles[landingType],
            isRebrandedJSMHero && "_bfhk1ism",
            "_1q511wqb"
        ]),
        style: {
            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_td2gmy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.saffron')),
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
            "--_1g0po9p": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.saffron300'))
        },
        children: heroComponent
    });
};
$c0ef82fc39e5a653$export$f14a1c5ae1fdb785.displayName = 'PaidHero';

});

parcelRegister("cf7Ff", function(module, exports) {
$parcel$export(module.exports, "PaidTabsSection", function () { return $b500bda1d0e4abed$export$4db38360327330ee; });
/* paid-tabs-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $n8zeI = parcelRequire("n8zeI");
const $b500bda1d0e4abed$var$anchorStyles = null;
const $b500bda1d0e4abed$var$jsmAndConfTabsStyles = null;
const $b500bda1d0e4abed$export$4db38360327330ee = (tabsProps)=>{
    const { styles: tabsStyles, landingType: landingType, ...otherTabsProps } = tabsProps;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_11q71afi",
            landingType === 'jira-software-anchor' && "_wndr138k _irhiangw _jwciangw _x5s11kwk _1hhbidpf _19e6idpf _1rvsidpf _13bjgktf _1m99glyw _ez63b3bt _kljastnw _11p1rdoj _o15y1skh _s0awdlk8 _1rflidpf _4yy7idpf _1mneidpf _1moqidpf _1b72idpf _1sjjidpf _1gum1fm0 _7iau7ogb _1hqaidpf _1bch1ylp _1yb1idpf _79pazwfg _1rhwidpf _iwhj1ylp _ddh0idpf _1fdoidpf _qaxvidpf",
            landingType === 'jira-service-management-anchor' && "_wndr138k _irhiangw _jwciangw _x5s11kwk _1hhbidpf _19e6idpf _1rvsidpf _13bjgktf _1m99glyw _ez63b3bt _kljastnw _11p1rdoj _o15y1skh _s0awdlk8 _1rflidpf _4yy7idpf _1mneidpf _1moqidpf _1b72idpf _1sjjidpf _1gum1fm0 _7iau7ogb _1hqaidpf _1bch1ylp _1yb1idpf _79pazwfg _1rhwidpf _iwhj1ylp _ddh0idpf _1fdoidpf _qaxvidpf",
            landingType === 'jira-service-management-anchor' && "_kbzo4b9m _1spxzkiq _balx1vrj _fptx4b9m",
            landingType === 'confluence-rebranded-anchor' && "_wndr138k _irhiangw _jwciangw _x5s11kwk _1hhbidpf _19e6idpf _1rvsidpf _13bjgktf _1m99glyw _ez63b3bt _kljastnw _11p1rdoj _o15y1skh _s0awdlk8 _1rflidpf _4yy7idpf _1mneidpf _1moqidpf _1b72idpf _1sjjidpf _1gum1fm0 _7iau7ogb _1hqaidpf _1bch1ylp _1yb1idpf _79pazwfg _1rhwidpf _iwhj1ylp _ddh0idpf _1fdoidpf _qaxvidpf",
            landingType === 'confluence-rebranded-anchor' && "_kbzo4b9m _1spxzkiq _balx1vrj _fptx4b9m",
            "tabs-section"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $n8zeI.PaidTabs), {
            ...otherTabsProps
        })
    });
};
$b500bda1d0e4abed$export$4db38360327330ee.displayName = 'PaidTabs';

});
parcelRegister("n8zeI", function(module, exports) {
$parcel$export(module.exports, "PaidTabs", function () { return $52515045d7ff7678$export$699a6a05a32d157; });
/* paid-tabs.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $i5Yp0 = parcelRequire("i5Yp0");

var $2CA9S = parcelRequire("2CA9S");

var $1rGpC = parcelRequire("1rGpC");

var $leg8m = parcelRequire("leg8m");

var $50aZ0 = parcelRequire("50aZ0");
const $52515045d7ff7678$var$tabCustomStyles = null;
const $52515045d7ff7678$var$tabSectionTitleStyles = null;
const $52515045d7ff7678$var$singleTabStyles = null;
const $52515045d7ff7678$var$pullQuotesContainerStyles = null;
const $52515045d7ff7678$var$renderChecklist = (tab)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $leg8m.default), {
        title: tab.title,
        listItems: tab.listItems ?? [],
        imageSrc: tab.picture.image.src,
        imageAlt: tab.picture.image.alt
    });
};
const $52515045d7ff7678$var$renderBodyText = (tab)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $50aZ0.SimpleImageTextSide), {
        headerText: tab.title,
        headerType: "h3",
        bodyText: tab.body,
        imageLink: tab.picture.image.src,
        imageAltText: tab.picture.image.alt,
        alignItems: 'top',
        rowProps: "4-8",
        className: "simple-image-text-side-tabs"
    });
};
const $52515045d7ff7678$var$generateTabs = (tabsViaProps)=>{
    const transformedTabs = tabsViaProps.map((tab)=>{
        return {
            textLabel: tab.textLabel,
            id: tab.id,
            component: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, {
                children: [
                    tab.listItems?.length ? $52515045d7ff7678$var$renderChecklist(tab) : $52515045d7ff7678$var$renderBodyText(tab),
                    tab.pullQuote && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1q517vkz"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $i5Yp0.PullQuote), {
                            logoSrc: tab.pullQuote.logoSrc,
                            logoAltText: tab.pullQuote.logoAltText,
                            quoteBlurb: tab.pullQuote.quoteBlurb || '',
                            quoteCompany: tab.pullQuote.quoteCompany || '',
                            quoteName: tab.pullQuote.quoteName || '',
                            isShowBorder: tab.pullQuote.isShowBorder ?? false,
                            isUsingTextQuotationMarks: tab.pullQuote.isUsingTextQuotationMarks
                        })
                    })
                ]
            })
        };
    });
    return transformedTabs;
};
const $52515045d7ff7678$export$699a6a05a32d157 = ({ headerText: headerText, tabStyles: tabStyles, tabs: tabs, tabsConfig: tabsConfig, dataProductKey: dataProductKey, layout: layout = '8' })=>{
    tabs = tabsConfig ? $52515045d7ff7678$var$generateTabs(tabsConfig) : tabs ?? [];
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_19pk1ylp _otyr1wqb _btm9gktf _hywlokh7 _rpgtoxwj _1dl31k92 _1o4gidpf _1g2bidpf _16rridpf _1x1cidpf _1j4q1oe7 _1w42mw4m _1i7w1bqd _1qf41k92 _11451k8s"
        ]),
        children: tabs.length === 1 ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _ca0qidpf _u5f31wqb _n3tdidpf _19bv1wqb _1kmxidpf _1ggmzwfg _1ykzidpf _1maezwfg _11ebviql _1kll1k8s"
            ]),
            children: tabs[0]?.component
        }) : /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                    layout: layout,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        className: (0, $2jatx.default)([
                            "_y3gn1h6o _1wyb1k8s _6rth1ylp _k48pbfng _syaz1bqd _1gw8ahaf"
                        ]),
                        children: headerText
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2CA9S.TabGroup), {
                    tabContentType: "custom",
                    tabs: tabs,
                    id: "tabs",
                    label: "tabs",
                    colors: tabStyles,
                    dataProductKey: dataProductKey
                })
            ]
        })
    });
};

});
parcelRegister("2CA9S", function(module, exports) {
$parcel$export(module.exports, "TabGroup", function () { return $0e9f48a434f4cddf$export$85fd4ed3b8ca1010; });
/* tab-group.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $1rGpC = parcelRequire("1rGpC");

var $1ka2O = parcelRequire("1ka2O");

var $92jF6 = parcelRequire("92jF6");

var $2ivuE = parcelRequire("2ivuE");

var $hnmMQ = parcelRequire("hnmMQ");

var $hBYvx = parcelRequire("hBYvx");
const $0e9f48a434f4cddf$var$bannerStyle = null;
const $0e9f48a434f4cddf$var$TabGroupStyle = null;
const $0e9f48a434f4cddf$var$quoteSidebar = null;
const $0e9f48a434f4cddf$var$tabPanel = null;
const $0e9f48a434f4cddf$var$contentBlockStyle = null;
const $0e9f48a434f4cddf$var$cardRules = {
    6: 1,
    5: 2,
    4: 2,
    3: 3,
    2: 4
};
const $0e9f48a434f4cddf$var$CardStyleDisplay = (tab)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
        children: tab.cards.map((card, index)=>{
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $92jF6.Card), {
                ...card,
                aspectRatio: tab.cards.length < 3 ? '16/9' : '3/2'
            }, index);
        })
    });
};
const $0e9f48a434f4cddf$export$625d95e4189a6523 = (props)=>{
    const tabDisplay = props.tab.display;
    let elementToDisplay = null;
    if ('videoProps' in tabDisplay && tabDisplay.videoProps.videoLink?.length) elementToDisplay = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hBYvx.Video), {
        ...tabDisplay.videoProps
    });
    else if ('imageProps' in tabDisplay && tabDisplay.imageProps.src?.length && tabDisplay.imageProps.alt?.length) elementToDisplay = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Image), {
        ...tabDisplay.imageProps,
        alt: tabDisplay.imageProps.alt
    });
    else if (/*#__PURE__*/ (0, $1oC0p.isValidElement)(tabDisplay)) elementToDisplay = tabDisplay;
    return elementToDisplay;
};
const $0e9f48a434f4cddf$export$82b8d343c504672 = (props)=>{
    const backgroundImageColor = props.colors?.quoteColor ? `linear-gradient(90deg, transparent, ${props.colors.quoteColor})` : 'transparent';
    const quoteWrapperClass = props.isDisplayInSmScreen ? 'quote-wrapper isDisplayInSmScreen' : 'quote-wrapper';
    const quoteStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_y3gn1e5h _19pkidpf _2hwxidpf _otyr1tcg _18u0idpf _ca0q1ul9 _u5f312am _n3td1ul9 _19bvidpf _2rko1ygb _1itk1mlj _urbdidpf _bh33qgp8 _z1c11vau _1r1x8n31 _sjb1gktf _1pntidpf _1pugidpf _s3jyidpf _177hangw _1i5midpf _utopidpf _rggridpf _1ie3idpf _14sxoxwj _1uc8angw _sugaglyw _1kmxidpf _1ggmidpf _1ykzidpf _1maeidpf _p0bo1ule",
            quoteWrapperClass
        ]),
        style: {
            "--_xnxqej": (0, $6ZVlx.default)(backgroundImageColor),
            "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
        },
        children: [
            props.image ? props.image : null,
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: "quote-blurb",
                children: props.quote
            }),
            props.name ? /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: "quote-name",
                children: props.name
            }) : null,
            props.company ? /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: "quote-company",
                children: props.company
            }) : null
        ]
    });
};
const $0e9f48a434f4cddf$var$QuoteTextImage = (tab, colors)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1rGpC.Row), {
        layout: "4-8",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_y3gn1e5h"
                ]),
                children: [
                    tab.headerText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ivuE.ContentBlock), {
                        headerText: tab.headerText,
                        bodyText: tab.bodyText,
                        headerType: tab.headerTextType ?? 'h3',
                        iconName: tab.iconName,
                        className: (0, $2jatx.default)([
                            "_p12f1osq _19pkidpf _2hwx1wug _otyr1tcg _18u01wug _gltebxu3"
                        ])
                    }) : null,
                    tab.quote ? /*#__PURE__*/ (0, $7VQPk.jsx)($0e9f48a434f4cddf$export$82b8d343c504672, {
                        image: tab.quoteImageProps && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Image), {
                            ...tab.quoteImageProps,
                            alt: tab.quoteImageProps.alt
                        }),
                        quote: tab.quote,
                        name: tab.name,
                        company: tab.company,
                        isDisplayInSmScreen: tab.isDisplayQuoteInSmScreen || false,
                        colors: colors
                    }) : null,
                    tab.ctaProps && tab.ctaProps.primaryLinkProps ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                        "aria-label": tab.ctaProps.primaryLinkProps.ariaLabel,
                        ...tab.ctaProps.primaryLinkProps
                    }) : null
                ]
            }),
            $0e9f48a434f4cddf$export$625d95e4189a6523({
                tab: tab
            })
        ]
    });
};
const $0e9f48a434f4cddf$var$TextImageFullWidth = (tab)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            children: [
                tab.headerText ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_p12f1osq _19pkidpf _2hwx1wug _otyr1tcg _18u01wug _gltebxu3",
                        "content-block"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ivuE.ContentBlock), {
                        headerText: tab.headerText,
                        bodyText: tab.bodyText,
                        headerType: "h2",
                        isCentered: true
                    })
                }) : null,
                $0e9f48a434f4cddf$export$625d95e4189a6523({
                    tab: tab
                })
            ]
        })
    });
};
const $0e9f48a434f4cddf$var$TabContent = (tabContentType, tab, tabsLength, colors)=>{
    const cardRule = $0e9f48a434f4cddf$var$cardRules[tabsLength];
    switch(tabContentType){
        case 'custom':
            if (!('component' in tab)) throw new Error('Must provide a `customComponent` JSX node');
            return tab.component;
        case 'cards':
            if (!('cards' in tab)) throw new Error('Must provide an array of card values in the `cards` tab prop');
            else if (tab.cards.length > cardRule) throw new Error(`For a group of ${tabsLength} tabs, no more than ${cardRule} cards per tab`);
            return $0e9f48a434f4cddf$var$CardStyleDisplay(tab);
        case 'quoteTextImage':
            if (!('display' in tab)) throw new Error('Please provide image or video props');
            return $0e9f48a434f4cddf$var$QuoteTextImage(tab, colors);
        case 'textImageFullWidth':
            if (!('display' in tab)) throw new Error('Please provide image or video props');
            return $0e9f48a434f4cddf$var$TextImageFullWidth(tab);
        default:
            return null;
    }
};
const $0e9f48a434f4cddf$var$updateURL = (tabId)=>{
    const newParams = new URLSearchParams(window.location.search);
    if (tabId) {
        newParams.set('tab', tabId);
        window.history.pushState({}, '', `?${newParams.toString()}`);
    }
};
const $0e9f48a434f4cddf$var$getTabStyle = (colors, isActive)=>{
    if (isActive) return {
        backgroundColor: colors?.activeBG || (0, $kbpa7.wacToken)('color.extended.blue200'),
        color: colors?.activeText || (0, $kbpa7.wacToken)('color.extended.blue1000'),
        borderColor: colors?.activeBG || (0, $kbpa7.wacToken)('color.extended.blue200'),
        hoverBG: colors?.activeBG || (0, $kbpa7.wacToken)('color.extended.blue200'),
        hoverText: colors?.activeText || (0, $kbpa7.wacToken)('color.extended.blue1000'),
        activeBGColor: colors?.activeBG || (0, $kbpa7.wacToken)('color.extended.blue200'),
        hoverBGColor: colors?.activeBG || (0, $kbpa7.wacToken)('color.extended.blue200')
    };
    return {
        backgroundColor: colors?.defaultBG || (0, $kbpa7.wacToken)('color.neutral.light100'),
        color: colors?.defaultText || (0, $kbpa7.wacToken)('color.extended.blue1000'),
        borderColor: 'transparent',
        hoverBG: colors?.hoverBG || (0, $kbpa7.wacToken)('color.neutral.light200'),
        hoverText: colors?.hoverText || (0, $kbpa7.wacToken)('color.extended.blue1000'),
        activeBGColor: colors?.activeBG || (0, $kbpa7.wacToken)('color.extended.blue200'),
        hoverBGColor: colors?.hoverBG || (0, $kbpa7.wacToken)('color.neutral.light200')
    };
};
const $0e9f48a434f4cddf$var$TabGroupInner = ({ index: index, currentTab: currentTab, tab: tab, colors: colors, dataProductKey: dataProductKey, onDesktopClickHandler: onDesktopClickHandler, setCurrentTab: setCurrentTab })=>{
    const isActive = index === currentTab;
    const { activeBGColor: activeBGColor, hoverBGColor: hoverBGColor, backgroundColor: backgroundColor, color: color, borderColor: borderColor, hoverBG: hoverBG, hoverText: hoverText } = $0e9f48a434f4cddf$var$getTabStyle(colors, isActive);
    const tabStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
        type: "button",
        role: "tab",
        value: tab.textLabel,
        "aria-selected": index === currentTab,
        "aria-controls": tab.id,
        id: tab.id,
        "data-event-component": "linkButton",
        "data-event-container": "tabContent",
        "data-event": "clicked",
        "data-label": tab.textLabel,
        "data-label-english": tab.dataLabelEnglish,
        "data-product-key": dataProductKey,
        onClick: (event)=>{
            setCurrentTab(index);
            $0e9f48a434f4cddf$var$updateURL(tab.id);
            if (onDesktopClickHandler) onDesktopClickHandler(event);
        },
        className: (0, $2jatx.default)([
            "_80omtlke _2rko12am _vchhusvi _1y1m1u8q _ca0q19bv _u5f31ul9 _n3td19bv _19bv1ul9 _r06hglyw _1dqonqa1 _189eyh40 _1h6d1j28 _ect41td8 _1dyz1d98 _1seqidpf _zecv1wug _1uldidpf _1pp41wug _3zq41ule _1blx1osq _3p1c1k92 _so7d1qy7 _bfhkaxbu _syaz1aj3 _jomr10a2 _irr310a2 _f8pj7ny5 _30l37ny5 _858u1srq _4cvx1srq _mizu1r31 _ra3xglyw _128midpf _pojj1w4s _q4ztj7jn"
        ]),
        style: {
            "--_1ly4823": (0, $6ZVlx.default)(backgroundColor),
            "--_1ylxx6h": (0, $6ZVlx.default)(color),
            "--_mf9og": (0, $6ZVlx.default)(hoverBG),
            "--_3siqzd": (0, $6ZVlx.default)(hoverText),
            "--_37cwmb": (0, $6ZVlx.default)(borderColor),
            "--_1kkre8f": (0, $6ZVlx.default)(activeBGColor),
            "--_h2utlw": (0, $6ZVlx.default)(hoverBGColor)
        },
        children: [
            tab.iconBefore ?? tab.iconBefore,
            tab.isForceDisplayTextLabelOnPill ? tab.textLabel : tab.elementLabel ? tab.elementLabel : 'headerText' in tab ? tab.headerText : tab.textLabel
        ]
    }, `tab-${index}-${tab.id}`);
};
const $0e9f48a434f4cddf$var$TabOption = ({ index: index, currentTab: currentTab, tab: tab, colors: colors, dataProductKey: dataProductKey })=>{
    const isActive = index === currentTab;
    const { activeBGColor: activeBGColor, hoverBGColor: hoverBGColor, backgroundColor: backgroundColor, color: color, borderColor: borderColor, hoverBG: hoverBG, hoverText: hoverText } = $0e9f48a434f4cddf$var$getTabStyle(colors, isActive);
    const tabStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
        "data-index": index,
        "data-id": tab.id,
        "data-event-component": "linkButton",
        "data-event-container": "tabContent",
        "data-event": "clicked",
        "data-label": tab.textLabel,
        "data-product-key": dataProductKey,
        value: tab.textLabel,
        "aria-selected": index === currentTab,
        "aria-describedby": `tab-${tab.id}`,
        className: (0, $2jatx.default)([
            "_80omtlke _2rko12am _vchhusvi _1y1m1u8q _ca0q19bv _u5f31ul9 _n3td19bv _19bv1ul9 _r06hglyw _1dqonqa1 _189eyh40 _1h6d1j28 _ect41td8 _1dyz1d98 _1seqidpf _zecv1wug _1uldidpf _1pp41wug _3zq41ule _1blx1osq _3p1c1k92 _so7d1qy7 _bfhkaxbu _syaz1aj3 _jomr10a2 _irr310a2 _f8pj7ny5 _30l37ny5 _858u1srq _4cvx1srq _mizu1r31 _ra3xglyw _128midpf _pojj1w4s _q4ztj7jn"
        ]),
        style: {
            "--_1ly4823": (0, $6ZVlx.default)(backgroundColor),
            "--_1ylxx6h": (0, $6ZVlx.default)(color),
            "--_mf9og": (0, $6ZVlx.default)(hoverBG),
            "--_3siqzd": (0, $6ZVlx.default)(hoverText),
            "--_37cwmb": (0, $6ZVlx.default)(borderColor),
            "--_1kkre8f": (0, $6ZVlx.default)(activeBGColor),
            "--_h2utlw": (0, $6ZVlx.default)(hoverBGColor)
        },
        children: tab.isForceDisplayTextLabelOnPill ? tab.textLabel : tab.elementLabel ? tab.elementLabel : 'headerText' in tab ? tab.headerText : tab.textLabel
    }, `option-${index}-${tab.id}`);
};
const $0e9f48a434f4cddf$var$TabSelect = ({ id: id, currentTab: currentTab, tabs: tabs, colors: colors, updateURL: updateURL, onMobileChangeHandler: onMobileChangeHandler, setCurrentTab: setCurrentTab, dataProductKey: dataProductKey })=>{
    const isActive = true; // Always active for TabSelect
    const { activeBGColor: activeBGColor, hoverBGColor: hoverBGColor, backgroundColor: backgroundColor, color: color, borderColor: borderColor, hoverBG: hoverBG, hoverText: hoverText } = $0e9f48a434f4cddf$var$getTabStyle(colors, isActive);
    const tabStyle = null;
    const handleChange = (event)=>{
        const selectedIndex = event?.target?.selectedOptions[0]?.dataset['index'];
        const selectedId = event?.target?.selectedOptions[0]?.dataset['id'];
        setCurrentTab(Number(selectedIndex));
        updateURL(selectedId);
        if (onMobileChangeHandler) onMobileChangeHandler(event);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("select", {
        id: id,
        className: (0, $2jatx.default)([
            "_80omtlke _2rko12am _vchhusvi _1y1m1u8q _ca0q19bv _u5f31ul9 _n3td19bv _19bv1ul9 _r06hglyw _1dqonqa1 _189eyh40 _1h6d1j28 _ect41td8 _1dyz1d98 _1seqidpf _zecv1wug _1uldidpf _1pp41wug _3zq41ule _1blx1osq _3p1c1k92 _so7d1qy7 _bfhkaxbu _syaz1aj3 _jomr10a2 _irr310a2 _f8pj7ny5 _30l37ny5 _858u1srq _4cvx1srq _mizu1r31 _ra3xglyw _128midpf _pojj1w4s _q4ztj7jn",
            "select"
        ]),
        value: tabs[currentTab]?.textLabel || tabs[0]?.textLabel,
        onChange: handleChange,
        style: {
            "--_1ly4823": (0, $6ZVlx.default)(backgroundColor),
            "--_1ylxx6h": (0, $6ZVlx.default)(color),
            "--_mf9og": (0, $6ZVlx.default)(hoverBG),
            "--_3siqzd": (0, $6ZVlx.default)(hoverText),
            "--_37cwmb": (0, $6ZVlx.default)(borderColor),
            "--_1kkre8f": (0, $6ZVlx.default)(activeBGColor),
            "--_h2utlw": (0, $6ZVlx.default)(hoverBGColor)
        },
        children: tabs.map((tab, index)=>{
            return /*#__PURE__*/ (0, $7VQPk.jsx)($0e9f48a434f4cddf$var$TabOption, {
                index: index,
                tab: tab,
                colors: colors,
                dataProductKey: dataProductKey,
                currentTab: currentTab
            }, `option-${index}-${tab.id}`);
        })
    });
};
const $0e9f48a434f4cddf$export$85fd4ed3b8ca1010 = (props)=>{
    const { tabContentType: tabContentType, tabs: tabs, colors: colors, id: id, label: label, dataProductKey: dataProductKey, onDesktopClickHandler: onDesktopClickHandler, onMobileChangeHandler: onMobileChangeHandler, banner: banner } = props;
    const location = (0, $1ka2O.useLocation)();
    const [currentTab, setCurrentTab] = (0, $1oC0p.useState)(()=>{
        const params = new URLSearchParams(location.search ?? window.location.search);
        const paramID = params.get('tab');
        const matchingTab = tabs.findIndex((tab)=>{
            return tab.id === paramID;
        });
        if (matchingTab >= 0) return matchingTab;
        return 0;
    });
    if (!id || !label) throw new Error('"id" and "label" props are required for accessibility!');
    if (tabs.length > 6 || tabs.length < 1) throw new Error('Must have a minimum of 1 and a maximum of 6 tabs per group!');
    const tabsMap = tabs.reduce(function(map, obj, index) {
        map[index] = obj;
        return map;
    }, {});
    // eslint-disable-next-line react/no-unstable-nested-components
    const MobileSelect = ()=>{
        const selectContainerColor = colors?.activeText ? colors.activeText : (0, $kbpa7.wacToken)('color.extended.blue1000');
        const selectContainerStyles = null;
        return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1bah1h6o _suga1txw _181nglyw _12xhh2mm _d7qx1osq _c2wd1pna _qj6jstnw _14z6gktf _7x8didpf _jm44idpf _wppf1wug _6mc91wug _1yyz1wug _c8mx1wug _1vd7171q",
                "select-container"
            ]),
            style: {
                "--_1uth3n3": (0, $6ZVlx.default)(selectContainerColor)
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: "select-container-inner",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                        htmlFor: id,
                        "aria-label": label,
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)($0e9f48a434f4cddf$var$TabSelect, {
                            id: id,
                            currentTab: currentTab,
                            tabs: tabs,
                            colors: colors,
                            updateURL: $0e9f48a434f4cddf$var$updateURL,
                            setCurrentTab: setCurrentTab,
                            dataProductKey: dataProductKey,
                            onMobileChangeHandler: onMobileChangeHandler
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                        width: "15",
                        height: "8",
                        viewBox: "0 0 15 8",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M1.5 1L7.5 7L13.5 1",
                            stroke: "currentColor",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_p12f1osq",
            "tab-group"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                role: "tablist",
                className: (0, $2jatx.default)([
                    "_sugaglyw _1cj31txw _196r1h6o _270t1g80 _wmdl7vkz"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: "tab-group-inner",
                        children: [
                            tabs.map((tab, index)=>{
                                return /*#__PURE__*/ (0, $7VQPk.jsx)($0e9f48a434f4cddf$var$TabGroupInner, {
                                    tab: tab,
                                    index: index,
                                    colors: colors,
                                    dataProductKey: dataProductKey,
                                    onDesktopClickHandler: onDesktopClickHandler,
                                    setCurrentTab: setCurrentTab,
                                    currentTab: currentTab
                                }, `tab-${index}-${tab.id}`);
                            }),
                            banner && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1wyb1crf _syaz1afi _11q75hrz _y3gn1h6o _1bsb1osq _1dyzt94y _k48pni7l _vwz4f6fq _ca0q1l7b _u5f31l7b _n3td1l7b _19bv1l7b _1p1dangw"
                                ]),
                                style: {
                                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                },
                                children: banner
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)(MobileSelect, {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: "tab-panels",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_19pkgktf _2hwx1wug _otyridpf _18u01wug _mderglyw",
                        "tab-panel"
                    ]),
                    "aria-hidden": false,
                    id: `tab-${tabsMap[currentTab]?.id}`,
                    children: $0e9f48a434f4cddf$var$TabContent(tabContentType, tabsMap[currentTab], tabs.length, colors)
                }, `tabpanel-${currentTab}-${tabsMap[currentTab]?.id}`)
            })
        ]
    });
};

});
parcelRegister("92jF6", function(module, exports) {
$parcel$export(module.exports, "Card", function () { return $b6adcd00aae9005f$export$60332b2344f7fe41; });
/* card.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $2ivuE = parcelRequire("2ivuE");
const $b6adcd00aae9005f$var$containerStyles = null;
const $b6adcd00aae9005f$var$contentBlockStyles = null;
const $b6adcd00aae9005f$var$barStyles = null;
const $b6adcd00aae9005f$export$60332b2344f7fe41 = (props)=>{
    const { textColor: textColor, headerType: headerType, headerText: headerText, bodyText: bodyText, eyebrowText: eyebrowText, footerHeader: footerHeader, footerText: footerText, imageLink: imageLink, imageAltText: imageAltText, backgroundColor: backgroundColor, colorBars: colorBars, iconName: iconName, iconColor: iconColor, iconSize: iconSize, barColor: barColor = '', className: className, ctaProps: ctaProps, aspectRatio: aspectRatio, orientation: orientation, pictureProps: pictureProps, clickableCardUrl: clickableCardUrl } = props;
    if (imageLink && !imageAltText) throw new Error('If using an image, please provide an alt text for accessibility purposes!');
    const cardBackBackgroundColor = backgroundColor ?? '#ffffff';
    const cardBackTextColor = textColor ?? '#091e42';
    const cardBackColor = null;
    const contentBlockIconColor = iconColor ?? '#091e42';
    const handleClick = ()=>{
        if (clickableCardUrl) window.location.href = clickableCardUrl;
    };
    const clickableCardStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_2rkoyh40 _16qs1nta _1e0c1txw _2lx21bp4 _p12fg505 _7cca15wb _4t3i1osq",
            "_bfhk16d1 _syazn54i",
            "_80om1h06",
            className
        ]),
        onClick: handleClick,
        style: {
            "--_1vkwvj7": (0, $6ZVlx.default)(cardBackBackgroundColor),
            "--_1dl5pj2": (0, $6ZVlx.default)(cardBackTextColor),
            "--_ahbcrn": (0, $6ZVlx.default)(clickableCardUrl ? 'pointer' : 'default')
        },
        children: [
            colorBars === 'top' || colorBars === 'both' ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                style: {
                    backgroundColor: barColor,
                    borderTopRightRadius: '4px',
                    borderTopLeftRadius: '4px'
                },
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _4t3iftgi"
                ])
            }) : '',
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ivuE.ContentBlock), {
                cardStyle: true,
                aspectRatio: aspectRatio,
                orientation: orientation,
                headerType: headerType,
                headerText: headerText,
                bodyText: bodyText,
                imageLink: imageLink,
                imageAltText: imageAltText,
                eyebrowText: eyebrowText,
                footerHeader: footerHeader,
                footerText: footerText,
                iconColor: contentBlockIconColor,
                iconName: iconName,
                iconSize: iconSize,
                ctaProps: ctaProps,
                pictureProps: pictureProps,
                className: (0, $2jatx.default)([
                    "_4t3i1osq"
                ])
            }),
            colorBars === 'bottom' || colorBars === 'both' ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                style: {
                    backgroundColor: barColor,
                    borderBottomRightRadius: '4px',
                    borderBottomLeftRadius: '4px'
                },
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _4t3iftgi"
                ])
            }) : ''
        ]
    });
};

});

parcelRegister("hBYvx", function(module, exports) {
$parcel$export(module.exports, "Video", function () { return $5a5d9245727e1968$export$ae01dedf5c052bb; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
const $5a5d9245727e1968$var$videoStyle = (ratio)=>{
    const aspectRatioCSS = ratio && ratio !== 'none' ? {
        aspectRatio: ratio,
        objectFit: 'cover'
    } : {};
    return {
        maxWidth: '100%',
        ...aspectRatioCSS
    };
};
const $5a5d9245727e1968$export$ae01dedf5c052bb = ({ videoLink: videoLink, videoType: videoType, videoPreviewImage: videoPreviewImage, loop: loop = true, muted: muted = true, aspectRatio: aspectRatio, alternativeSources: alternativeSources, className: className, fallbackText: fallbackText, onEnded: onEnded, children: children })=>{
    const videoRef = (0, $1oC0p.useRef)(null);
    // reload video player if video source prop changes dynamically
    (0, $1oC0p.useEffect)(()=>{
        videoRef.current?.load();
    }, [
        videoLink
    ]);
    return(// eslint-disable-next-line jsx-a11y/media-has-caption
    /*#__PURE__*/ (0, $7VQPk.jsxs)("video", {
        playsInline: true,
        muted: muted,
        preload: "auto",
        poster: videoPreviewImage,
        autoPlay: true,
        className: className,
        style: $5a5d9245727e1968$var$videoStyle(aspectRatio),
        loop: loop,
        ref: videoRef,
        onEnded: onEnded,
        children: [
            fallbackText,
            /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                src: videoLink,
                type: `video/${videoType ? videoType : 'mp4'}`
            }),
            alternativeSources ? alternativeSources.map((source, index)=>{
                return /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                    src: source.videoLink,
                    type: `video/${source.videoType ? source.videoType : 'mp4'}`
                }, index);
            }) : null,
            children
        ]
    }));
};

});





parcelRegister("cqCPq", function(module, exports) {
$parcel$export(module.exports, "isTargetedKeyword", function () { return $44122322e18142b4$export$cb97405e1165a712; });
$parcel$export(module.exports, "getPageId", function () { return $44122322e18142b4$export$2ce6e339a89daf7a; });
$parcel$export(module.exports, "generateTabComponent", function () { return $44122322e18142b4$export$58cc84c10393e7c7; });
$parcel$export(module.exports, "getAnimationByKeyword", function () { return $44122322e18142b4$export$91b39788ec2acd40; });

var $7VQPk = parcelRequire("7VQPk");

var $iyOcM = parcelRequire("iyOcM");

var $2Y4QO = parcelRequire("2Y4QO");

var $a2Szx = parcelRequire("a2Szx");

var $4HcEI = parcelRequire("4HcEI");

var $cLuPb = parcelRequire("cLuPb");
const $44122322e18142b4$export$cb97405e1165a712 = (keyword = '')=>[
        'document editor',
        'documento editor',
        'document sharing',
        'doc editing',
        'editar um documento',
        'editar documentos online',
        'doc editing online',
        'doc editor online',
        'text editor online',
        'word',
        'notion',
        'google docs',
        'microsoft word',
        "microsoft word en l\xednea",
        'word gratis',
        'word editor',
        'word online',
        'microsoft word gratis descargar',
        'microsoft office',
        'spreadsheets',
        'google sheets',
        'project plan',
        'project management tool',
        'project management platform',
        'software project management tools',
        'project management template',
        'plan del proyecto',
        'task list',
        'digital diagram',
        'diagrama digital',
        'diagrama de flujo',
        'online flow chart',
        'creador de diagramas de flujo',
        'diagramas de flujo online',
        'hacer un diagrama de flujo',
        'diagrama de flujo online',
        'programas para hacer diagramas de flujo',
        'fluxograma online',
        'diagrama de flujo online gratis',
        'flowchart',
        'criar mapas mentais'
    ].includes(keyword);
const $44122322e18142b4$export$2ce6e339a89daf7a = (keyword = '')=>{
    return ({
        'document editor': 'paid-lp-conf-keywords-documentation',
        'documento editor': 'paid-lp-conf-keywords-documentation',
        'document sharing': 'paid-lp-conf-keywords-documentation',
        'doc editing': 'paid-lp-conf-keywords-documentation',
        'editar um documento': 'paid-lp-conf-keywords-documentation',
        'editar documentos online': 'paid-lp-conf-keywords-documentation',
        'doc editing online': 'paid-lp-conf-keywords-documentation',
        'doc editor online': 'paid-lp-conf-keywords-documentation',
        'text editor online': 'paid-lp-conf-keywords-documentation',
        word: 'paid-lp-conf-keywords-competitors',
        notion: 'paid-lp-conf-keywords-competitors',
        'google docs': 'paid-lp-conf-keywords-competitors',
        'microsoft word': 'paid-lp-conf-keywords-competitors',
        "microsoft word en l\xednea": 'paid-lp-conf-keywords-competitors',
        'word gratis': 'paid-lp-conf-keywords-competitors',
        'word editor': 'paid-lp-conf-keywords-competitors',
        'word online': 'paid-lp-conf-keywords-competitors',
        'microsoft word gratis descargar': 'paid-lp-conf-keywords-competitors',
        'microsoft office': 'paid-lp-conf-keywords-competitors',
        spreadsheets: 'paid-lp-conf-keywords-spreadsheets',
        'google sheets': 'paid-lp-conf-keywords-spreadsheets',
        'project plan': 'paid-lp-conf-keywords-project-plan',
        'project management tool': 'paid-lp-conf-keywords-project-plan',
        'project management platform': 'paid-lp-conf-keywords-project-plan',
        'software project management tools': 'paid-lp-conf-keywords-project-plan',
        'project management template': 'paid-lp-conf-keywords-project-plan',
        'plan del proyecto': 'paid-lp-conf-keywords-project-plan',
        'task list': 'paid-lp-conf-keywords-task-list',
        'digital diagram': 'paid-lp-conf-keywords-digital-diagram',
        'diagrama digital': 'paid-lp-conf-keywords-digital-diagram',
        'diagrama de flujo': 'paid-lp-conf-keywords-digital-diagram',
        'online flow chart': 'paid-lp-conf-keywords-digital-diagram',
        'creador de diagramas de flujo': 'paid-lp-conf-keywords-digital-diagram',
        'diagramas de flujo online': 'paid-lp-conf-keywords-digital-diagram',
        'hacer un diagrama de flujo': 'paid-lp-conf-keywords-digital-diagram',
        'diagrama de flujo online': 'paid-lp-conf-keywords-digital-diagram',
        'programas para hacer diagramas de flujo': 'paid-lp-conf-keywords-digital-diagram',
        'fluxograma online': 'paid-lp-conf-keywords-digital-diagram',
        'diagrama de flujo online gratis': 'paid-lp-conf-keywords-digital-diagram',
        flowchart: 'paid-lp-conf-keywords-digital-diagram',
        'criar mapas mentais': 'paid-lp-conf-keywords-mental-map'
    })[keyword] || 'paid-lp-conf-keywords-documentation';
};
const $44122322e18142b4$export$58cc84c10393e7c7 = (keyword = '', tab)=>{
    let videoProps;
    if ([
        'spreadsheets',
        'google sheets'
    ].includes(keyword)) videoProps = {
        videoSrcMp4: 'https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Databases_LowBR_reencode.mp4',
        videoSrcWebm: 'https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Databases_LowBR.webm',
        videoPreviewSrc: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Databases_Preview.webp'
    };
    else if ([
        'digital diagram',
        'diagrama digital',
        'diagrama de flujo',
        'criar mapas mentais',
        'online flow chart',
        'creador de diagramas de flujo',
        'diagramas de flujo online',
        'hacer un diagrama de flujo',
        'diagrama de flujo online',
        'programas para hacer diagramas de flujo',
        'fluxograma online',
        'diagrama de flujo online gratis',
        'flowchart'
    ].includes(keyword)) videoProps = {
        videoSrcMp4: 'https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Whiteboards_LowBR_reencode.mp4',
        videoSrcWebm: 'https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Whiteboards_LowBR.webm',
        videoPreviewSrc: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Whiteboards_Preview.webp'
    };
    else videoProps = {
        videoSrcMp4: 'https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Pages_LowBR_reencode.mp4',
        videoSrcWebm: 'https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Pages_LowBR.webm',
        videoPreviewSrc: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Pages_Preview.webp'
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iyOcM.Adg4Tabs), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cLuPb.ContentTypeVideo), {
            ...videoProps,
            showBackground: true,
            active: true,
            showAsterisks: true,
            hideSeparator: true,
            title: tab.title,
            description: tab.description,
            iconCollection: Array.from(new DOMParser().parseFromString(tab.content, 'text/html').querySelectorAll('p')).slice(0, 3).map((p, i)=>({
                    description: p.textContent || '',
                    icon: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4HcEI.Rocket), {
                            size: "small"
                        }, "Rocket"),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Y4QO.Megaphone), {
                            size: "small"
                        }, "Megaphone"),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a2Szx.Notepad), {
                            size: "small"
                        }, "Notepad")
                    ][i]
                }))
        })
    });
};





const $44122322e18142b4$export$91b39788ec2acd40 = (keyword)=>{
    let animation;
    if ([
        'spreadsheets',
        'google sheets'
    ].includes(keyword)) animation = (parcelRequire("2NKaH"));
    else if ([
        'digital diagram',
        'diagrama digital',
        'diagrama de flujo',
        'criar mapas mentais',
        'online flow chart',
        'creador de diagramas de flujo',
        'diagramas de flujo online',
        'hacer un diagrama de flujo',
        'diagrama de flujo online',
        'programas para hacer diagramas de flujo',
        'fluxograma online',
        'diagrama de flujo online gratis',
        'flowchart'
    ].includes(keyword)) animation = (parcelRequire("bvV0b"));
    else if ([
        'project plan',
        'project management tool',
        'project management platform',
        'software project management tools',
        'project management template',
        'plan del proyecto'
    ].includes(keyword)) animation = (parcelRequire("jjT5L"));
    else if ([
        'task list'
    ].includes(keyword)) animation = (parcelRequire("3lSVB"));
    else animation = (parcelRequire("1bgc5"));
    return animation ? {
        lottieAnimationPromise: animation
    } : undefined;
};

});
parcelRegister("2NKaH", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("gjPKD").then(()=>parcelRequire('djZoW'));

});

parcelRegister("bvV0b", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("2Ev8p").then(()=>parcelRequire('jczec'));

});

parcelRegister("jjT5L", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("32L2j").then(()=>parcelRequire('68Qcz'));

});

parcelRegister("3lSVB", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("67ATO").then(()=>parcelRequire('77xjy'));

});

parcelRegister("1bgc5", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("h4RwC").then(()=>parcelRequire('aZedk'));

});




parcelRegister("9Ws6n", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageVariantAnchorLpConfCollaboration", function () { return $7df99e51aa0e7f7e$export$bef8c54fab70371e; });
// @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");

var $k6PTJ = parcelRequire("k6PTJ");

var $cR8Gg = parcelRequire("cR8Gg");

var $bspxF = parcelRequire("bspxF");

var $hswtB = parcelRequire("hswtB");

var $3LcIp = parcelRequire("3LcIp");

var $l7lLR = parcelRequire("l7lLR");

var $4X0dO = parcelRequire("4X0dO");

var $hZuN8 = parcelRequire("hZuN8");

var $izdHQ = parcelRequire("izdHQ");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $jxpLG = parcelRequire("jxpLG");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $7df99e51aa0e7f7e$export$bef8c54fab70371e = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $hZuN8.useExperimentExposure)((0, $4X0dO.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cR8Gg.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const gwp9286ConfluenceAnchorUpdates = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp9286ConfluenceAnchorUpdates);
    const carouselSlidesOriginal = [
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Collaboration.get-on-the-same-page.title',
                defaultMessage: 'Get on the same page'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Collaboration.get-on-the-same-page.body',
                defaultMessage: "Plan projects, take notes, and brainstorm \u2013 all in one place."
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp',
            imgAltText: 'A Confluence page being edited'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Collaboration.collaborate-live-across-time-zones.title',
                defaultMessage: 'Collaborate live across time zones'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Collaboration.collaborate-live-across-time-zones.body',
                defaultMessage: 'Move work forward with real-time editing and inline comments.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/i0011ky0775062fk18784clr4dcxd5wg.webp',
            imgAltText: 'A Confluence page with multiple teammates editing and leaving comments'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Collaboration.find-what-you-need.title',
                defaultMessage: 'Find what you need'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Collaboration.find-what-you-need.body',
                defaultMessage: 'Stay organized in dedicated workspaces, equipped with AI-powered search.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp',
            imgAltText: 'Organized workspace in Confluence'
        }
    ];
    const carouselSlidesGwp9286Updates = [
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.CollaborationGwp9286Updates.turn-ideas-into-action.title',
                defaultMessage: 'Turn ideas into action'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.CollaborationGwp9286Updates.turn-ideas-into-action.body',
                defaultMessage: 'Help your team think bigger, move faster, and capture ever spark.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2p1rm3keie5h48ed6w7kag6u7m418264.webp',
            imgAltText: 'Marketing brainstorming whiteboard'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.CollaborationGwp9286Updates.from-prompt-to-draft.title',
                defaultMessage: 'From prompt to draft, in seconds'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.CollaborationGwp9286Updates.from-prompt-to-draft.body',
                defaultMessage: 'Spend less time starting from scratch and more time refining ideas with AI.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/37xpd5m0sv6yf55n24701d48q5uf2ut7.webp',
            imgAltText: 'Screenshot of using AI to create a project plan document'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.CollaborationGwp9286Updates.stay-in-sync.title',
                defaultMessage: 'Stay in sync'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.CollaborationGwp9286Updates.stay-in-sync.body',
                defaultMessage: 'Keep your team aligned from project kickoff to project completion.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8v31m8aisl4ty5cg1xf0nuhjdfnqmk37.webp',
            imgAltText: 'Screenshot of Rovo providing a summary of what changed on the page'
        }
    ];
    const carouselSlides = gwp9286ConfluenceAnchorUpdates ? carouselSlidesGwp9286Updates : carouselSlidesOriginal;
    const carouselHeroProps = {
        'aria-label': intl.formatMessage((0, $jxpLG.carouselHeroMessages).ariaLabel),
        id: 'confluence-collaboration-carousel',
        slides: carouselSlides,
        usePlainContainer: gwp9286ConfluenceAnchorUpdates
    };
    const pageId = 'anchor-lp-conf-collaboration';
    const isLoggedIn = !!userProfileName;
    let customHeroSection;
    const getLiftShiftHeroSectionBrandUpdate = ()=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bspxF.PaidHeroCarousel), {
            pageId: pageId,
            embeddedSignup: {
                bundle: 'confluence'
            },
            carouselSlides: carouselSlides,
            shouldUseNewBrandBackground: true,
            shouldUseTransparentBackground: true,
            usePlainContainer: gwp9286ConfluenceAnchorUpdates
        });
    };
    if (isLoggedIn) {
        if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
            experimentKey: "cfind-2801-get-paid-users-back-to-product",
            group: "Test",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
                confluenceSites: recentSites,
                userProfileName: userProfileName,
                hideExploreMore: true,
                loggedInPaid: true
            })
        });
        else customHeroSection = getLiftShiftHeroSectionBrandUpdate();
    } else // Logged out user
    customHeroSection = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3LcIp.BanditsProvider), {
        product: (0, $l7lLR.BANDITS_PRODUCT).CONFLUENCE,
        keyword: pageProps.keyword,
        isExperimentEnabled: true,
        useCase: (0, $l7lLR.BANDITS_USE_CASE).ANCHOR_JOURNEY_SUB_ANCHOR,
        subAnchor: pageProps.subAnchor || '',
        channel: pageProps.utmMedium || 'paid-search',
        utmContent: pageProps.utmContent || '',
        utmCampaign: pageProps.utmCampaign || '',
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
            experimentKey: "cfind-3090-paid-confluence-product-tour",
            group: "Test",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), {
                ...pageProps,
                pageId: pageId,
                persona: 'unknown',
                pageVariant: "brandUpdate",
                dataProductKey: "confluence-AnchorLpConfCollaboration",
                keyword: pageProps.keyword,
                carouselHeroProps: carouselHeroProps,
                customHeroSection: customHeroSection
            })
        })
    });
};

});
parcelRegister("jxpLG", function(module, exports) {
$parcel$export(module.exports, "carouselHeroMessages", function () { return $5c8eb521db6c66c7$export$556302becf693fc2; });

var $fnHPc = parcelRequire("fnHPc");
const $5c8eb521db6c66c7$export$556302becf693fc2 = (0, $fnHPc.defineMessages)({
    ariaLabel: {
        id: 'ConfluenceSoftwarePage.v4.CarouselHero.AriaLabel',
        defaultMessage: 'A display of various confluence features',
        description: 'Aria label for the carousel section'
    }
});

});


parcelRegister("kufmD", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorCompetitors", function () { return $b9f721f682896de7$export$97018adfbdd04630; });
// @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");

var $k6PTJ = parcelRequire("k6PTJ");

var $cR8Gg = parcelRequire("cR8Gg");

var $bspxF = parcelRequire("bspxF");

var $hswtB = parcelRequire("hswtB");

var $3LcIp = parcelRequire("3LcIp");

var $l7lLR = parcelRequire("l7lLR");

var $4X0dO = parcelRequire("4X0dO");

var $hZuN8 = parcelRequire("hZuN8");

var $izdHQ = parcelRequire("izdHQ");

var $jxpLG = parcelRequire("jxpLG");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $b9f721f682896de7$export$97018adfbdd04630 = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $hZuN8.useExperimentExposure)((0, $4X0dO.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cR8Gg.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Competitors.achieve-team-goals-together.title',
                defaultMessage: 'Achieve team goals together'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Competitors.achieve-team-goals-together.body',
                defaultMessage: 'Plan projects, take notes, and brainstorm. Let AI write your first draft.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp',
            imgAltText: 'A Confluence page being edited'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Competitors.get-everyone-on-the-same-page.title',
                defaultMessage: 'Get everyone on the same page'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Competitors.get-everyone-on-the-same-page.body',
                defaultMessage: 'Collaborate with your teams using real-time editing and inline comments.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/i0011ky0775062fk18784clr4dcxd5wg.webp',
            imgAltText: 'A Confluence page with multiple teammates editing and leaving comments'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Competitors.connect-teams-content-context.title',
                defaultMessage: 'Connect teams, content, and context'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Competitors.connect-teams-content-context.body',
                defaultMessage: 'Stay organized in dedicated workspaces, equipped with AI-powered search.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp',
            imgAltText: 'Organized workspace in Confluence'
        }
    ];
    const carouselHeroProps = {
        'aria-label': intl.formatMessage((0, $jxpLG.carouselHeroMessages).ariaLabel),
        id: 'confluence-competitors-carousel',
        slides: carouselSlides
    };
    const pageId = 'anchor-lp-conf-competitors';
    const isLoggedIn = !!userProfileName;
    let customHeroSection;
    const getLiftShiftHeroSectionBrandUpdate = ()=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bspxF.PaidHeroCarousel), {
            pageId: pageId,
            embeddedSignup: {
                bundle: 'confluence'
            },
            carouselSlides: carouselSlides,
            shouldUseNewBrandBackground: true,
            shouldUseTransparentBackground: true
        });
    };
    if (isLoggedIn) {
        if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
            experimentKey: "cfind-2801-get-paid-users-back-to-product",
            group: "Test",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
                confluenceSites: recentSites,
                userProfileName: userProfileName,
                hideExploreMore: true,
                loggedInPaid: true
            })
        });
        else customHeroSection = getLiftShiftHeroSectionBrandUpdate();
    } else // Logged out user
    customHeroSection = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3LcIp.BanditsProvider), {
        product: (0, $l7lLR.BANDITS_PRODUCT).CONFLUENCE,
        keyword: pageProps.keyword,
        isExperimentEnabled: true,
        useCase: (0, $l7lLR.BANDITS_USE_CASE).ANCHOR_JOURNEY_SUB_ANCHOR,
        subAnchor: pageProps.subAnchor || '',
        channel: pageProps.utmMedium || 'paid-search',
        utmContent: pageProps.utmContent || '',
        utmCampaign: pageProps.utmCampaign || '',
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
            experimentKey: "cfind-3090-paid-confluence-product-tour",
            group: "Test",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), {
                ...pageProps,
                pageId: pageId,
                persona: 'unknown',
                pageVariant: "brandUpdate",
                dataProductKey: "confluence-PaidLpConflCompetitors",
                keyword: pageProps.keyword,
                carouselHeroProps: carouselHeroProps,
                customHeroSection: customHeroSection
            })
        })
    });
};

});

parcelRegister("gKC0O", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorCustomerService", function () { return $00e2e8c4b076dd53$export$dee2b0bf0794eecf; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");

var $k6PTJ = parcelRequire("k6PTJ");

var $cR8Gg = parcelRequire("cR8Gg");

var $hswtB = parcelRequire("hswtB");

var $4X0dO = parcelRequire("4X0dO");

var $hZuN8 = parcelRequire("hZuN8");

var $izdHQ = parcelRequire("izdHQ");

var $jxpLG = parcelRequire("jxpLG");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $00e2e8c4b076dd53$export$dee2b0bf0794eecf = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $hZuN8.useExperimentExposure)((0, $4X0dO.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cR8Gg.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    // TODO: add missing images
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.CustomerService.dynamic-documentation.title',
                defaultMessage: 'Dynamic documentation'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.CustomerService.dynamic-documentation.body',
                defaultMessage: "Brainstorm ideas and workflows, document best practices, and share knowledge\u2014all in one place."
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp',
            imgAltText: 'A Confluence page being edited'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.CustomerService.scale-practices.title',
                defaultMessage: 'Scale best practices across your org'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.CustomerService.scale-practices.body',
                defaultMessage: 'Boost productivity by using Automation to coordinate workflows, prompting next steps when a dependency is completed.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/k2it51f6l70x62mw505kfe305m744wnv.webp',
            imgAltText: 'A Confluence automation rule'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.CustomerService.connect-your-work.title',
                defaultMessage: 'Centralize and connect all your work'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.CustomerService.connect-your-work.body',
                defaultMessage: 'Keep FAQs and commonly referenced documentation organized and easily findable in dedicated workspaces.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/23124865qxudxy6cj8rl3g6my5h472d7.webp',
            imgAltText: 'Organized Customer Success Hub in Confluence'
        }
    ];
    const carouselHeroProps = {
        'aria-label': intl.formatMessage((0, $jxpLG.carouselHeroMessages).ariaLabel),
        id: 'confluence-customer-service-carousel',
        slides: carouselSlides
    };
    const pageId = 'anchor-lp-conf-team-customerservice';
    let customHeroSection = null;
    if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
        experimentKey: "cfind-2801-get-paid-users-back-to-product",
        group: "Test",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
            confluenceSites: recentSites,
            userProfileName: userProfileName,
            hideExploreMore: true,
            loggedInPaid: true
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), {
        ...pageProps,
        pageId: pageId,
        persona: 'unknown',
        pageVariant: "customerService",
        dataProductKey: "confluence-AnchorLpConfCustomerService",
        carouselHeroProps: carouselHeroProps,
        keyword: pageProps.keyword,
        customHeroSection: customHeroSection
    });
};

});

parcelRegister("fTqPM", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorDesign", function () { return $218b189f0b6f91ef$export$e823aa878f5ce57e; });

var $7VQPk = parcelRequire("7VQPk");

var $jxpLG = parcelRequire("jxpLG");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");

var $k6PTJ = parcelRequire("k6PTJ");

var $cR8Gg = parcelRequire("cR8Gg");

var $hswtB = parcelRequire("hswtB");

var $hZuN8 = parcelRequire("hZuN8");

var $4X0dO = parcelRequire("4X0dO");

var $izdHQ = parcelRequire("izdHQ");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $218b189f0b6f91ef$export$e823aa878f5ce57e = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $hZuN8.useExperimentExposure)((0, $4X0dO.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cR8Gg.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Design.dynamic-documentation.title',
                defaultMessage: 'Dynamic documentation'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Design.dynamic-documentation.body',
                defaultMessage: "Brainstorm ideas, document design guidelines, and take notes\u2014all in one place."
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp',
            imgAltText: 'A Confluence page being edited'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Design.same-page.title',
                defaultMessage: 'Get everyone on the same page'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Design.same-page.body',
                defaultMessage: 'Collaborate with cross-functional teams using real-time editing and inline comments.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/i0011ky0775062fk18784clr4dcxd5wg.webp',
            imgAltText: 'A Confluence page with multiple teammates editing and leaving comments'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Design.context-designers-need.title',
                defaultMessage: 'The context designers need'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Design.context-designers-need.body',
                defaultMessage: 'Stay organized with dedicated team workspaces, all equipped with AI-powered search.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp',
            imgAltText: 'Organized workspace in Confluence'
        }
    ];
    const carouselHeroProps = {
        'aria-label': intl.formatMessage((0, $jxpLG.carouselHeroMessages).ariaLabel),
        id: 'confluence-design-carousel',
        slides: carouselSlides
    };
    const pageId = 'anchor-lp-conf-team-design';
    let customHeroSection = null;
    if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
        experimentKey: "cfind-2801-get-paid-users-back-to-product",
        group: "Test",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
            confluenceSites: recentSites,
            userProfileName: userProfileName,
            hideExploreMore: true,
            loggedInPaid: true
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), {
        ...pageProps,
        pageId: pageId,
        persona: 'unknown',
        pageVariant: "design",
        dataProductKey: "confluence-AnchorLpConfDesign",
        carouselHeroProps: carouselHeroProps,
        keyword: pageProps.keyword,
        customHeroSection: customHeroSection
    });
};

});

parcelRegister("e18uw", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorEngineering", function () { return $f16f31b365271cf4$export$e45207782b7349c7; });

var $7VQPk = parcelRequire("7VQPk");

var $jxpLG = parcelRequire("jxpLG");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");

var $k6PTJ = parcelRequire("k6PTJ");

var $cR8Gg = parcelRequire("cR8Gg");

var $hswtB = parcelRequire("hswtB");

var $4X0dO = parcelRequire("4X0dO");

var $hZuN8 = parcelRequire("hZuN8");

var $izdHQ = parcelRequire("izdHQ");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $f16f31b365271cf4$export$e45207782b7349c7 = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $hZuN8.useExperimentExposure)((0, $4X0dO.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cR8Gg.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const pageId = 'anchor-lp-conf-team-engineering';
    let customHeroSection = null;
    if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
        experimentKey: "cfind-2801-get-paid-users-back-to-product",
        group: "Test",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
            confluenceSites: recentSites,
            userProfileName: userProfileName,
            hideExploreMore: true,
            loggedInPaid: true
        })
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Engineering.dynamic-documentation.title',
                defaultMessage: 'Dynamic documentation'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Engineering.dynamic-documentation.body',
                defaultMessage: "Brainstorm workflows, plan sprints, and take release notes\u2014all in one place."
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0du4h6u1u85gdfw51btwg1w486m05ehy.webp',
            imgAltText: 'A Confluence page with advanced roadmap integration'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Engineering.get-everyone-on-the-same-page.title',
                defaultMessage: 'Get everyone on the same page'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Engineering.get-everyone-on-the-same-page.body',
                defaultMessage: 'Collaborate with cross-functional teams using real-time editing and inline comments.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/b2d5d0n6c3585bx8t07l0kmlsd36648q.webp',
            imgAltText: 'A Confluence page with multiple teammates editing and leaving comments'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Engineering.the-context-software-developers-need.title',
                defaultMessage: 'The context software developers need'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Engineering.the-context-software-developers-need.body',
                defaultMessage: 'Stay organized with dedicated team workspaces, all equipped with AI-powered search.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/21k4hektb512gekkj3ibm325ahan4vrh.webp',
            imgAltText: 'A Confluence page titled Project Hub'
        }
    ];
    const carouselHeroProps = {
        'aria-label': intl.formatMessage((0, $jxpLG.carouselHeroMessages).ariaLabel),
        id: 'confluence-engineering-carousel',
        slides: carouselSlides
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), {
        ...pageProps,
        pageId: pageId,
        persona: 'unknown',
        pageVariant: "engineering",
        dataProductKey: "confluence-PaidLpConflEngineering",
        carouselHeroProps: carouselHeroProps,
        keyword: pageProps.keyword,
        customHeroSection: customHeroSection,
        teamType: ""
    });
};

});

parcelRegister("ccCRD", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorHr", function () { return $8f53ed6e7f86da34$export$d807d62fc3dbe5f7; });

var $7VQPk = parcelRequire("7VQPk");

var $jxpLG = parcelRequire("jxpLG");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");

var $k6PTJ = parcelRequire("k6PTJ");

var $cR8Gg = parcelRequire("cR8Gg");

var $hswtB = parcelRequire("hswtB");

var $4X0dO = parcelRequire("4X0dO");

var $hZuN8 = parcelRequire("hZuN8");

var $izdHQ = parcelRequire("izdHQ");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $8f53ed6e7f86da34$export$d807d62fc3dbe5f7 = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $hZuN8.useExperimentExposure)((0, $4X0dO.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cR8Gg.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Hr.source-of-truth.title',
                defaultMessage: 'A single source of truth'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Hr.source-of-truth.body',
                defaultMessage: "Confluence brings together recruiting, onboarding, and employee development\u2014all in one place."
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/6ow1y2k84sc71x364sfir34k2fu2k4o8.webp',
            imgAltText: 'Organized HR Hub in Confluence'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Hr.scale-practices.title',
                defaultMessage: 'Scale best practices across your org'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Hr.scale-practices.body',
                defaultMessage: 'Boost productivity by using Automation to coordinate workflows, prompting next steps when a dependency is completed.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1d4ro6h610bxw33m1v70c0ik55110tmg.webp',
            imgAltText: 'A Confluence automation rule'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Hr.simplify-workflows.title',
                defaultMessage: 'Simplify HR workflows'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Hr.simplify-workflows.body',
                defaultMessage: 'Brainstorm ideas for employee engagement, coordinate training, and share announcements with the entire org.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/g46gcy7jab7kyu00487ys6bkiv0e7a1f.webp',
            imgAltText: 'Ideas on Confluence Sticky Notes'
        }
    ];
    const carouselHeroProps = {
        'aria-label': intl.formatMessage((0, $jxpLG.carouselHeroMessages).ariaLabel),
        id: 'confluence-hr-carousel',
        slides: carouselSlides
    };
    const pageId = 'anchor-lp-conf-team-hr';
    let customHeroSection = null;
    if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
        experimentKey: "cfind-2801-get-paid-users-back-to-product",
        group: "Test",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
            confluenceSites: recentSites,
            userProfileName: userProfileName,
            hideExploreMore: true,
            loggedInPaid: true
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), {
        ...pageProps,
        pageId: pageId,
        persona: 'unknown',
        pageVariant: "hr",
        dataProductKey: "confluence-AnchorLpConfHr",
        carouselHeroProps: carouselHeroProps,
        keyword: pageProps.keyword,
        customHeroSection: customHeroSection
    });
};

});

parcelRegister("kqZTJ", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorLegal", function () { return $2afaed4f728ce6ce$export$b53560d6986ee58d; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");

var $k6PTJ = parcelRequire("k6PTJ");

var $cR8Gg = parcelRequire("cR8Gg");

var $hswtB = parcelRequire("hswtB");

var $4X0dO = parcelRequire("4X0dO");

var $hZuN8 = parcelRequire("hZuN8");

var $izdHQ = parcelRequire("izdHQ");

var $jxpLG = parcelRequire("jxpLG");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $2afaed4f728ce6ce$export$b53560d6986ee58d = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $hZuN8.useExperimentExposure)((0, $4X0dO.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cR8Gg.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    let customHeroSection = null;
    if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
        experimentKey: "cfind-2801-get-paid-users-back-to-product",
        group: "Test",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
            confluenceSites: recentSites,
            userProfileName: userProfileName,
            hideExploreMore: true,
            loggedInPaid: true
        })
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Legal.dynamic-documentation.title',
                defaultMessage: 'Dynamic Documentation'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Legal.dynamic-documentation.body',
                defaultMessage: "Brainstorm on whiteboards, draft pages, and record video messages. Customize documentation to suit your clients' and team's needs."
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp',
            imgAltText: 'A Confluence page being edited'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Legal.same-page.title',
                defaultMessage: 'Get on the same page'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Legal.same-page.body',
                defaultMessage: 'Collaborate with your team using real-time editing and inline comments. Easily manage permissions so only the right people have access to information.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/i0011ky0775062fk18784clr4dcxd5wg.webp',
            imgAltText: 'A Confluence page with multiple teammates editing and leaving comments'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Legal.centralize-work.title',
                defaultMessage: 'Centralize and connect all your work'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Legal.centralize-work.body',
                defaultMessage: 'Keep commonly used legal forms, decision registers, and meeting notes organized in dedicated workspaces.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/prhqp320pa2f46636madbq6hv2kuff62.webp',
            imgAltText: 'Organized Legal Hub in Confluence'
        }
    ];
    const carouselHeroProps = {
        'aria-label': intl.formatMessage((0, $jxpLG.carouselHeroMessages).ariaLabel),
        id: 'confluence-legal-carousel',
        slides: carouselSlides
    };
    const pageId = 'anchor-lp-conf-team-legal';
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), {
        ...pageProps,
        pageId: pageId,
        persona: 'unknown',
        pageVariant: "legal",
        dataProductKey: "confluence-AnchorLpConfLegal",
        carouselHeroProps: carouselHeroProps,
        keyword: pageProps.keyword,
        customHeroSection: customHeroSection
    });
};

});

parcelRegister("kShM7", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorMarketing", function () { return $7668325f98bd6281$export$11286c25bf03cb0c; });
// @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");

var $k6PTJ = parcelRequire("k6PTJ");

var $cR8Gg = parcelRequire("cR8Gg");

var $hswtB = parcelRequire("hswtB");

var $4X0dO = parcelRequire("4X0dO");

var $hZuN8 = parcelRequire("hZuN8");

var $izdHQ = parcelRequire("izdHQ");

var $jxpLG = parcelRequire("jxpLG");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $7668325f98bd6281$export$11286c25bf03cb0c = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $hZuN8.useExperimentExposure)((0, $4X0dO.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cR8Gg.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Documentation.marketing-goals.title',
                defaultMessage: 'Achieve marketing goals together'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Documentation.marketing-goals.body',
                defaultMessage: 'Plan campaigns, take notes, and brainstorm. Let AI write your first draft.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp',
            imgAltText: 'A Confluence page being edited'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Documentation.same-page.title',
                defaultMessage: 'Get everyone on the same page'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Documentation.same-page.body',
                defaultMessage: 'Collaborate with cross-functional teams using real-time editing and inline comments.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/i0011ky0775062fk18784clr4dcxd5wg.webp',
            imgAltText: 'A Confluence page with multiple teammates editing and leaving comments'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Documentation.marketing-deadlines.title',
                defaultMessage: 'Hit marketing launch deadlines'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Documentation.marketing-deadlines.body',
                defaultMessage: 'Stay organized with dedicated marketing workspaces equipped with AI-powered search.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp',
            imgAltText: 'Organized workspace in Confluence'
        }
    ];
    const carouselHeroProps = {
        'aria-label': intl.formatMessage((0, $jxpLG.carouselHeroMessages).ariaLabel),
        id: 'confluence-marketing-carousel',
        slides: carouselSlides
    };
    const pageId = 'anchor-lp-conf-team-marketing';
    let customHeroSection = null;
    if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
        experimentKey: "cfind-2801-get-paid-users-back-to-product",
        group: "Test",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
            confluenceSites: recentSites,
            userProfileName: userProfileName,
            hideExploreMore: true,
            loggedInPaid: true
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), {
        ...pageProps,
        pageId: pageId,
        // TODO: replace with pageProps.persona when all personas are added
        persona: 'unknown',
        pageVariant: "marketing",
        dataProductKey: "confluence-AnchorLpConfMarketing",
        carouselHeroProps: carouselHeroProps,
        keyword: pageProps.keyword,
        customHeroSection: customHeroSection
    });
};

});

parcelRegister("4f5AO", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorOperations", function () { return $dac1d4b98d26b348$export$75eaa13c52290701; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");

var $k6PTJ = parcelRequire("k6PTJ");

var $cR8Gg = parcelRequire("cR8Gg");

var $hswtB = parcelRequire("hswtB");

var $4X0dO = parcelRequire("4X0dO");

var $hZuN8 = parcelRequire("hZuN8");

var $izdHQ = parcelRequire("izdHQ");

var $jxpLG = parcelRequire("jxpLG");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $dac1d4b98d26b348$export$75eaa13c52290701 = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $hZuN8.useExperimentExposure)((0, $4X0dO.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cR8Gg.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Operations.dynamic-documentation.title',
                defaultMessage: 'Dynamic documentation'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Operations.dynamic-documentation.body',
                defaultMessage: "Brainstorm more efficient workflows, manage resources, and share knowledge\u2014all in one place."
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp',
            imgAltText: 'A Confluence page being edited'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Operations.streamline-processes.title',
                defaultMessage: 'Streamline processes and team efficiency'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Operations.streamline-processes.body',
                defaultMessage: 'Boost productivity by using Automation to coordinate workflows, prompting next steps when a dependency is completed.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/n5g67a5u6744u0183v1em5q6rjc4oer5.webp',
            imgAltText: 'A Confluence automation rule'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Operations.same-page.title',
                defaultMessage: 'Get everyone on the same page'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Operations.same-page.body',
                defaultMessage: 'Keep teams organized with dedicated workspaces, all equipped with AI-powered search.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp',
            imgAltText: 'Organized workspace in Confluence'
        }
    ];
    const carouselHeroProps = {
        'aria-label': intl.formatMessage((0, $jxpLG.carouselHeroMessages).ariaLabel),
        id: 'confluence-operations-carousel',
        slides: carouselSlides
    };
    const pageId = 'anchor-lp-conf-team-operations';
    let customHeroSection = null;
    if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
        experimentKey: "cfind-2801-get-paid-users-back-to-product",
        group: "Test",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
            confluenceSites: recentSites,
            userProfileName: userProfileName,
            hideExploreMore: true,
            loggedInPaid: true
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), {
        ...pageProps,
        pageId: pageId,
        persona: 'unknown',
        pageVariant: "operations",
        dataProductKey: "confluence-AnchorLpConfOperations",
        carouselHeroProps: carouselHeroProps,
        keyword: pageProps.keyword,
        customHeroSection: customHeroSection
    });
};

});

parcelRegister("SJn7F", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorProgramMgmt", function () { return $4c7606deb194f802$export$7f35a3c71359f12a; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");

var $k6PTJ = parcelRequire("k6PTJ");

var $cR8Gg = parcelRequire("cR8Gg");

var $hswtB = parcelRequire("hswtB");

var $4X0dO = parcelRequire("4X0dO");

var $hZuN8 = parcelRequire("hZuN8");

var $izdHQ = parcelRequire("izdHQ");

var $jxpLG = parcelRequire("jxpLG");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $4c7606deb194f802$export$7f35a3c71359f12a = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $hZuN8.useExperimentExposure)((0, $4X0dO.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cR8Gg.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    // TODO: add missing images
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.ProgramMgmt.project-goals.title',
                defaultMessage: 'Achieve project goals together'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.ProgramMgmt.project-goals.body',
                defaultMessage: "Brainstorm ideas, plan projects, take notes, and share knowledge\u2014all in one place."
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp',
            imgAltText: 'A Confluence page being edited'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.ProgramMgmt.team-efficiency.title',
                defaultMessage: 'Streamline processes and team efficiency'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.ProgramMgmt.team-efficiency.body',
                defaultMessage: 'Boost productivity by using Automation to coordinate workflows, prompting next steps when a dependency is completed.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3rpsu66gd78285buk60k1t08w568ds37.webp',
            imgAltText: 'A Confluence automation rule'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.ProgramMgmt.project-deadlines.title',
                defaultMessage: 'Hit project deadlines'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.ProgramMgmt.project-deadlines.body',
                defaultMessage: 'Keep teams organized with dedicated workspaces, equipped with AI-powered search.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp',
            imgAltText: 'Organized workspace in Confluence'
        }
    ];
    const carouselHeroProps = {
        'aria-label': intl.formatMessage((0, $jxpLG.carouselHeroMessages).ariaLabel),
        id: 'confluence-program-management-carousel',
        slides: carouselSlides
    };
    const pageId = 'anchor-lp-conf-team-programmgmt';
    let customHeroSection = null;
    if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
        experimentKey: "cfind-2801-get-paid-users-back-to-product",
        group: "Test",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
            confluenceSites: recentSites,
            userProfileName: userProfileName,
            hideExploreMore: true,
            loggedInPaid: true
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), {
        ...pageProps,
        pageId: pageId,
        persona: 'unknown',
        pageVariant: "programMgmt",
        dataProductKey: "confluence-AnchorLpConfProgramMgmt",
        carouselHeroProps: carouselHeroProps,
        keyword: pageProps.keyword,
        customHeroSection: customHeroSection
    });
};

});

parcelRegister("8vTdi", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorTeamwork", function () { return $4ea0580cfd773d5e$export$c24154344f2ebeeb; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");

var $k6PTJ = parcelRequire("k6PTJ");

var $cR8Gg = parcelRequire("cR8Gg");

var $bspxF = parcelRequire("bspxF");

var $hswtB = parcelRequire("hswtB");

var $3LcIp = parcelRequire("3LcIp");

var $l7lLR = parcelRequire("l7lLR");

var $4X0dO = parcelRequire("4X0dO");

var $hZuN8 = parcelRequire("hZuN8");

var $izdHQ = parcelRequire("izdHQ");

var $jxpLG = parcelRequire("jxpLG");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $4ea0580cfd773d5e$export$c24154344f2ebeeb = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $hZuN8.useExperimentExposure)((0, $4X0dO.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cR8Gg.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Teamwork.get-everyone-on-the-same-page.title',
                defaultMessage: 'Get everyone on the same page'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Teamwork.get-everyone-on-the-same-page.body',
                defaultMessage: 'Plan projects, take notes, and brainstorm. Let AI write your first draft.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp',
            imgAltText: 'A Confluence page being edited'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Teamwork.bring-teams-together.title',
                defaultMessage: 'Bring teams together'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Teamwork.bring-teams-together.body',
                defaultMessage: 'Invite your teams to collaborate using real-time editing and inline comments.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/i0011ky0775062fk18784clr4dcxd5wg.webp',
            imgAltText: 'A Confluence page with multiple teammates editing and leaving comments'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Teamwork.centralize-the-teams-work.title',
                defaultMessage: "Centralize the team\u2019s work"
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Teamwork.centralize-the-teams-work.body',
                defaultMessage: 'Stay organized and up-to-date with dedicated team workspaces.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp',
            imgAltText: 'Organized workspace in Confluence'
        }
    ];
    const carouselHeroProps = {
        'aria-label': intl.formatMessage((0, $jxpLG.carouselHeroMessages).ariaLabel),
        id: 'confluence-teamwork-carousel',
        slides: carouselSlides
    };
    const pageId = 'anchor-lp-conf-teamwork';
    const isLoggedIn = !!userProfileName;
    let customHeroSection;
    const getLiftShiftHeroSectionBrandUpdate = ()=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bspxF.PaidHeroCarousel), {
            pageId: pageId,
            embeddedSignup: {
                bundle: 'confluence'
            },
            carouselSlides: carouselSlides,
            shouldUseNewBrandBackground: true,
            shouldUseTransparentBackground: true
        });
    };
    if (isLoggedIn) {
        if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
            experimentKey: "cfind-2801-get-paid-users-back-to-product",
            group: "Test",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
                confluenceSites: recentSites,
                userProfileName: userProfileName,
                hideExploreMore: true,
                loggedInPaid: true
            })
        });
        else customHeroSection = getLiftShiftHeroSectionBrandUpdate();
    } else // Logged out user
    customHeroSection = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3LcIp.BanditsProvider), {
        product: (0, $l7lLR.BANDITS_PRODUCT).CONFLUENCE,
        keyword: pageProps.keyword,
        isExperimentEnabled: true,
        useCase: (0, $l7lLR.BANDITS_USE_CASE).ANCHOR_JOURNEY_SUB_ANCHOR,
        subAnchor: pageProps.subAnchor || '',
        channel: pageProps.utmMedium || 'paid-search',
        utmContent: pageProps.utmContent || '',
        utmCampaign: pageProps.utmCampaign || '',
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
            experimentKey: "cfind-3090-paid-confluence-product-tour",
            group: "Test",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), {
                ...pageProps,
                pageId: pageId,
                persona: 'unknown',
                pageVariant: "brandUpdate",
                dataProductKey: "confluence-AnchorLpConfTeamwork",
                keyword: pageProps.keyword,
                carouselHeroProps: carouselHeroProps,
                customHeroSection: customHeroSection
            })
        })
    });
};

});

parcelRegister("drgFv", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorWorkManagement", function () { return $e31d55af448a7f73$export$9fca2d06de428e79; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");

var $k6PTJ = parcelRequire("k6PTJ");

var $cR8Gg = parcelRequire("cR8Gg");

var $bspxF = parcelRequire("bspxF");

var $hswtB = parcelRequire("hswtB");

var $3LcIp = parcelRequire("3LcIp");

var $l7lLR = parcelRequire("l7lLR");

var $4X0dO = parcelRequire("4X0dO");

var $hZuN8 = parcelRequire("hZuN8");

var $izdHQ = parcelRequire("izdHQ");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $e31d55af448a7f73$export$9fca2d06de428e79 = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $hZuN8.useExperimentExposure)((0, $4X0dO.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cR8Gg.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.WorkManagement.move-work-forward.title',
                defaultMessage: 'Move work forward'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.WorkManagement.move-work-forward.body',
                defaultMessage: "Plan projects, take notes, and brainstorm \u2014 all in one place."
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp',
            imgAltText: 'A Confluence page being edited'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.WorkManagement.work-better-together.title',
                defaultMessage: 'Work better, together'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.WorkManagement.work-better-together.body',
                defaultMessage: 'Collaborate with your teams with real-time editing and inline comments.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/i0011ky0775062fk18784clr4dcxd5wg.webp',
            imgAltText: 'A Confluence page with multiple teammates editing and leaving comments'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.WorkManagement.connect-all-your-work.title',
                defaultMessage: 'Connect all your work'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.WorkManagement.connect-all-your-work.body',
                defaultMessage: 'Stay organized and up-to-date with dedicated team workspaces.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp',
            imgAltText: 'Organized workspace in Confluence'
        }
    ];
    const carouselHeroProps = {
        'aria-label': 'A display of various confluence features',
        id: 'confluence-work-management-carousel',
        slides: carouselSlides
    };
    const pageId = 'anchor-lp-conf-work-management';
    const isLoggedIn = !!userProfileName;
    let customHeroSection;
    const getLiftShiftHeroSectionBrandUpdate = ()=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bspxF.PaidHeroCarousel), {
            pageId: pageId,
            embeddedSignup: {
                bundle: 'confluence'
            },
            carouselSlides: carouselSlides,
            shouldUseNewBrandBackground: true,
            shouldUseTransparentBackground: true
        });
    };
    if (isLoggedIn) {
        if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
            experimentKey: "cfind-2801-get-paid-users-back-to-product",
            group: "Test",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
                confluenceSites: recentSites,
                userProfileName: userProfileName,
                hideExploreMore: true,
                loggedInPaid: true
            })
        });
        else customHeroSection = getLiftShiftHeroSectionBrandUpdate();
    } else // Logged out user
    customHeroSection = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3LcIp.BanditsProvider), {
        product: (0, $l7lLR.BANDITS_PRODUCT).CONFLUENCE,
        keyword: pageProps.keyword,
        isExperimentEnabled: true,
        useCase: (0, $l7lLR.BANDITS_USE_CASE).ANCHOR_JOURNEY_SUB_ANCHOR,
        subAnchor: pageProps.subAnchor || '',
        channel: pageProps.utmMedium || 'paid-search',
        utmContent: pageProps.utmContent || '',
        utmCampaign: pageProps.utmCampaign || '',
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
            experimentKey: "cfind-3090-paid-confluence-product-tour",
            group: "Test",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), {
                ...pageProps,
                pageId: pageId,
                persona: 'unknown',
                pageVariant: "brandUpdate",
                dataProductKey: "confluence-PaidLpConfWorkManagementAutomation",
                keyword: pageProps.keyword,
                carouselHeroProps: carouselHeroProps,
                customHeroSection: customHeroSection
            })
        })
    });
};

});

parcelRegister("2veNk", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePage", function () { return $7c6f63f776b237bf$export$a9a1f3ad281c228; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $3L8ZR = parcelRequire("3L8ZR");

var $20OkY = parcelRequire("20OkY");

var $1rObi = parcelRequire("1rObi");

var $bTseT = parcelRequire("bTseT");

var $2CYZS = parcelRequire("2CYZS");

var $4X0dO = parcelRequire("4X0dO");

var $hZuN8 = parcelRequire("hZuN8");

var $28AH4 = parcelRequire("28AH4");

var $ik40B = parcelRequire("ik40B");
const $7c6f63f776b237bf$export$a9a1f3ad281c228 = (props)=>{
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom = (0, $3L8ZR.default).checkGate('gwp-737-enable-intercom-chat-confluence');
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $hZuN8.useExperimentExposure)((0, $4X0dO.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(props.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const { setAnchorLocalStorage: setAnchorLocalStorage } = (0, $28AH4.useAnchorLocalStorage)();
    (0, $1oC0p.useEffect)(()=>{
        const { keyword: keyword, subAnchor: subAnchor } = props;
        const anchorLocalStorage = {};
        if (!!keyword) anchorLocalStorage.keyword = keyword;
        if (!!subAnchor) anchorLocalStorage.subAnchor = subAnchor;
        if (Object.keys(anchorLocalStorage).length > 0) setAnchorLocalStorage(anchorLocalStorage);
    }, [
        props.keyword
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bTseT.IntercomProvider), {
        appId: 'p0ww63i2',
        triggerBoot: isBootIntercom,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rObi.CrossFlowTouchpointProvider), {
            screenName: "wacConfluenceProductTourPage",
            productKeys: [
                (0, $20OkY.ProductKeys).CONFLUENCE
            ],
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2CYZS.ConfluenceSoftwarePageTemplate), {
                pricing: props.pricing,
                availableProducts: props.availableProducts,
                userProfile: props.userProfile,
                keyword: props.keyword,
                subAnchor: props.subAnchor,
                useCase: props.useCase,
                utmMedium: props.utmMedium,
                utmContent: props.utmContent,
                utmCampaign: props.utmCampaign
            })
        })
    });
};

});
parcelRegister("bTseT", function(module, exports) {
$parcel$export(module.exports, "IntercomProvider", function () { return $d787a990cb9c57de$export$5091c5023e5c7eba; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $6GqRO = parcelRequire("6GqRO");

var $5Ntyw = parcelRequire("5Ntyw");

var $cIXzQ = parcelRequire("cIXzQ");
const $d787a990cb9c57de$var$isWindowExist = typeof window !== 'undefined';
const $d787a990cb9c57de$export$e578ca56db818a8e = /*#__PURE__*/ $1oC0p.createContext(undefined);
const $d787a990cb9c57de$export$5091c5023e5c7eba = ({ appId: appId, triggerBoot: triggerBoot = false, children: children })=>{
    const isBooted = $1oC0p.useRef(false);
    const isInit = $1oC0p.useRef(false);
    const stargateClient = (0, $5Ntyw.useBxpWebStargateClient)();
    const initIntercomInstance = $1oC0p.useCallback(()=>{
        if (!isInit.current) {
            (0, $cIXzQ.default)(appId);
            isInit.current = true;
        }
    }, [
        appId
    ]);
    // Ensure DOM is fully ready and stable before Intercom initialization
    const ensureDOMReady = $1oC0p.useCallback(()=>{
        return new Promise((resolve)=>{
            if (document.readyState === 'complete') // DOM is ready, but add buffer time for iframe stability
            setTimeout(resolve, 500);
            else {
                // Wait for DOM completion, then add buffer time
                const cleanup = ()=>{
                    document.removeEventListener('DOMContentLoaded', handleLoad);
                    window.removeEventListener('load', handleLoad);
                };
                const handleLoad = ()=>{
                    cleanup();
                    clearTimeout(safetyTimeout);
                    setTimeout(resolve, 500);
                };
                // Add event listeners for DOM ready
                document.addEventListener('DOMContentLoaded', handleLoad);
                window.addEventListener('load', handleLoad);
                // Safety timeout: resolve after 10 seconds even if events don't fire
                const safetyTimeout = setTimeout(()=>{
                    cleanup();
                    console.error('Intercom: DOM ready timeout reached, proceeding anyway');
                    resolve();
                }, 10000);
            }
        });
    }, []);
    const boot = $1oC0p.useCallback(async ()=>{
        if ($d787a990cb9c57de$var$isWindowExist && isInit.current && !isBooted.current) {
            const intercomSettings = window.intercomSettings ?? {
                app_id: appId
            };
            try {
                // Wait for DOM to be fully ready and stable
                await ensureDOMReady();
                window.Intercom?.('boot', {
                    alignment: 'right',
                    horizontal_padding: 20,
                    vertical_padding: 20,
                    custom_launcher_selector: '#intercomLauncher',
                    ...intercomSettings
                });
                window.Intercom?.('trackEvent', 'widget-loaded');
            } catch (error) {
                console.warn('Intercom boot failed:', error);
            } finally{
                isBooted.current = true; // Set value as true to enable functionality of show/hide methods
            }
        }
    }, [
        appId,
        ensureDOMReady
    ]);
    const shutdown = $1oC0p.useCallback(()=>{
        if (!isBooted.current) return;
        if ($d787a990cb9c57de$var$isWindowExist) {
            window.Intercom?.('shutdown');
            delete window.intercomSettings;
            isBooted.current = false;
        }
    }, []);
    const show = $1oC0p.useCallback(()=>{
        if ($d787a990cb9c57de$var$isWindowExist && isBooted.current) window.Intercom?.('show');
    }, []);
    const hide = $1oC0p.useCallback(()=>{
        if ($d787a990cb9c57de$var$isWindowExist && isBooted.current) window.Intercom?.('hide');
    }, []);
    $1oC0p.useEffect(()=>{
        if ($d787a990cb9c57de$var$isWindowExist && triggerBoot) (async function() {
            const intercomSettingsObj = {
                app_id: appId
            };
            const anonId = (0, $6GqRO.default).get('ajs_anonymous_id') || '';
            if (anonId) intercomSettingsObj['anonymousId'] = anonId;
            const getwayApiMeGetResponse = await stargateClient.me({}).catch(()=>null);
            if (getwayApiMeGetResponse) {
                intercomSettingsObj['name'] = getwayApiMeGetResponse.name;
                intercomSettingsObj['email'] = getwayApiMeGetResponse.email;
            }
            if ($d787a990cb9c57de$var$isWindowExist) window.intercomSettings = intercomSettingsObj;
            if (!isInit.current) initIntercomInstance();
            if (isInit.current && !isBooted.current) boot();
        })();
        // clean up code
        return ()=>{
            if (isInit.current) shutdown();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerBoot,
        stargateClient
    ]);
    const providerValue = $1oC0p.useMemo(()=>{
        return {
            initIntercomInstance: initIntercomInstance,
            boot: boot,
            shutdown: shutdown,
            show: show,
            hide: hide
        };
    }, [
        initIntercomInstance,
        boot,
        shutdown,
        show,
        hide
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($d787a990cb9c57de$export$e578ca56db818a8e.Provider, {
        value: providerValue,
        children: children
    });
};
const $d787a990cb9c57de$export$28418e623d2470bc = ()=>{
    const context = $1oC0p.useContext($d787a990cb9c57de$export$e578ca56db818a8e);
    if (context === undefined) throw new Error('This hook must be used within IntercomProvider');
    return context;
};

});
parcelRegister("cIXzQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $578d2b441e63143c$export$2e2bcd8739ae039; });
function $578d2b441e63143c$var$isIELikeWindow(w) {
    return Object.prototype.hasOwnProperty.call(w, 'attachEvent');
}
// Function per instruction here: https://developers.intercom.com/installing-intercom/web/installation/
const $578d2b441e63143c$var$initializeIntercomInstance = (appId)=>{
    const w = window;
    const ic = w.Intercom;
    if (typeof ic === 'function') {
        ic('reattach_activator');
        ic('update', w.intercomSettings);
    } else {
        const d = document;
        const i = function() {
            i.c(arguments);
        };
        i.q = [];
        i.c = function(args) {
            i.q.push(args);
        };
        w.Intercom = i;
        const l = function() {
            const s = d.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.src = 'https://widget.intercom.io/widget/' + appId;
            const x = d.getElementsByTagName('script')[0];
            x?.parentNode?.insertBefore(s, x);
        };
        if (document.readyState === 'complete') l();
        else if ($578d2b441e63143c$var$isIELikeWindow(w)) w.attachEvent('onload', l);
        else w.addEventListener('load', l, false);
    }
};
var $578d2b441e63143c$export$2e2bcd8739ae039 = $578d2b441e63143c$var$initializeIntercomInstance;

});


parcelRegister("2CYZS", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageTemplate", function () { return $9372a819789dd781$export$6a834c6096a76a8; });

var $7VQPk = parcelRequire("7VQPk");

var $a7tOB = parcelRequire("a7tOB");
const $9372a819789dd781$export$6a834c6096a76a8 = (props)=>{
    const ConfluenceSoftwarePageComponent = (0, $a7tOB.ConfluenceSoftwarePage);
    return /*#__PURE__*/ (0, $7VQPk.jsx)(ConfluenceSoftwarePageComponent, {
        ...props
    });
};

});
parcelRegister("a7tOB", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePage", function () { return $e091e31db171d4e1$export$a9a1f3ad281c228; });
/* confluence-software-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $6gVNd = parcelRequire("6gVNd");

var $kbpa7 = parcelRequire("kbpa7");

var $jsxHL = parcelRequire("jsxHL");

var $iLjCW = parcelRequire("iLjCW");

var $l4vdU = parcelRequire("l4vdU");

var $9AKFZ = parcelRequire("9AKFZ");

var $3JYqW = parcelRequire("3JYqW");

var $izdHQ = parcelRequire("izdHQ");

var $5S2vX = parcelRequire("5S2vX");

var $FlsVD = parcelRequire("FlsVD");

var $hCHU3 = parcelRequire("hCHU3");

var $bCAvd = parcelRequire("bCAvd");

var $heBZG = parcelRequire("heBZG");

var $2Jr3C = parcelRequire("2Jr3C");

var $592OP = parcelRequire("592OP");

var $cWN5u = parcelRequire("cWN5u");

var $hswtB = parcelRequire("hswtB");

var $4sY9l = parcelRequire("4sY9l");

var $5v7eV = parcelRequire("5v7eV");

var $bFVFT = parcelRequire("bFVFT");

var $iuSIG = parcelRequire("iuSIG");

var $kkULZ = parcelRequire("kkULZ");
const $e091e31db171d4e1$var$relativeParent = null;
const $e091e31db171d4e1$var$relativeChildren = null;
const $e091e31db171d4e1$var$backgroundShape = null;
const $e091e31db171d4e1$var$ConfluenceSoftwarePageComponent = ({ availableProducts: availableProducts, userProfile: userProfile })=>{
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $6gVNd.useLogMeIn)({
        availableProducts: availableProducts,
        userProfile: userProfile,
        siteType: (0, $6gVNd.AtlSiteType).CONFLUENCE
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $l4vdU.default), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9AKFZ.ConfluenceAboveNavButterbar), {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hCHU3.default), {})
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("main", {
                    id: "content",
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
                        scrollTrackingEnabled: true,
                        pageId: "confluence-software-page-cfind-1234",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3JYqW.ConfluencePageBanner), {}),
                            shouldShowLogMeIn ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
                                confluenceSites: recentSites,
                                userProfileName: userProfileName
                            }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $592OP.default), {
                                userProfile: userProfile
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bCAvd.default), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5v7eV.default), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4sY9l.default), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bFVFT.default), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kkULZ.default), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iuSIG.default), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_kqswh2mm _1e0c1txw _1bah1h6o _1reo15vq _18m915vq"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_mkrz1cp6 _bfhkg7ng _kqswstnw _152tidpf _1reo15vq _18m915vq _1bsb1wqz _4t3i16il _197pglyw _1knecv93"
                                        ]),
                                        style: {
                                            "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _2lx21bp4 _kqswh2mm _1pfh1ymo _zulpmxpn _2osn1sxy _1iyeviql"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cWN5u.default), {}),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $FlsVD.default), {})
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Jr3C.default), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $heBZG.default), {})
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iLjCW.GlobalFooter), {})
        ]
    });
};
const $e091e31db171d4e1$export$a9a1f3ad281c228 = (0, $izdHQ.withFeatureExposed)('cfind-1234-product-tour-refresh-q3fy24', 'Test', $e091e31db171d4e1$var$ConfluenceSoftwarePageComponent);

});
parcelRegister("l4vdU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $73f92d32d2fa0cb0$export$2e2bcd8739ae039; });
/* sticky-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
const $73f92d32d2fa0cb0$var$StickyContainer = ({ children: children })=>{
    const isMultipleStickyStart = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).wacLiftedBannerSticky);
    if (!isMultipleStickyStart) return children;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "data-testid": "banner-nav-combo",
        className: (0, $2jatx.default)([
            "_kqsw1if8 _152tidpf _1pbyqfx8"
        ]),
        children: children
    });
};
const $73f92d32d2fa0cb0$var$sticky = null;
var $73f92d32d2fa0cb0$export$2e2bcd8739ae039 = $73f92d32d2fa0cb0$var$StickyContainer;

});

parcelRegister("9AKFZ", function(module, exports) {
$parcel$export(module.exports, "ConfluenceAboveNavButterbar", function () { return $6ed1c9c1b57dfc0f$export$86417e4293705c14; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $iRMRa = parcelRequire("iRMRa");

var $dEFIL = parcelRequire("dEFIL");

var $4X0dO = parcelRequire("4X0dO");

var $gIKKj = parcelRequire("gIKKj");
const $6ed1c9c1b57dfc0f$export$86417e4293705c14 = ()=>{
    const intl = (0, $8e22h.default)();
    const gwp5090BannerExperiment = (0, $gIKKj.useExperiment)((0, $4X0dO.experiments).gwp5090ExperimentBannerConfluence);
    const gwp5090IsButterBar = gwp5090BannerExperiment != undefined && gwp5090BannerExperiment.type === 'enrolled' && gwp5090BannerExperiment.value === 'butterbar';
    const gwp5090Team25Config = {
        identifier: 'GWP5090.confluence-product-tour.butterbar',
        text: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "team25-banners-and-butterbars.confluence.text",
                defaultMessage: "<strong>April 8-10 \u2022 Anaheim, California</strong>Hear from the world\u2019s leading product experts on how to boost team performance at Team \u201925!",
                values: (0, $iRMRa.DEFAULT_VALUES)
            })
        }),
        mobileText: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "team25-banners-and-butterbars.confluence.mobile-text",
                defaultMessage: "<strong>April 8-10 \u2022 Anaheim, California</strong>Hear from leading product experts!",
                values: (0, $iRMRa.DEFAULT_VALUES)
            })
        }),
        productKey: 'home',
        backgroundPreset: 'gwp-5090-banners',
        imageProps: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4360jv8l7u81b0w6nn37fu86a2131624.webp',
            alt: 'Team25',
            //Event name is not localized
            width: 200
        },
        linkText: intl.formatMessage({
            id: 'team25-banners-and-butterbars.confluence.cta',
            defaultMessage: 'Get your pass'
        }),
        linkUrl: 'https://events.atlassian.com/team?utm_medium=event-web-referral&utm_source=confluence_product-tour&event_context=701QB00000Lg6oBYAR&utm_campaign=K:event|H:any|N:Team_25|P:agnostic|O:event-marketing|F:pre-event|C:event-home&utm_content=butterbar-banner_WEBTEAM-17396&event_id=216653',
        dataEventProps: {
            'data-product-key': 'home',
            'data-event-component': 'linkButton',
            'data-event-container': 'announcementBanner',
            'data-event': 'clicked',
            'data-label': intl.formatMessage({
                id: 'team25-banners-and-butterbars.confluence.cta',
                defaultMessage: 'Get your pass'
            }),
            'data-label-english': 'Get your pass'
        }
    };
    return gwp5090IsButterBar ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dEFIL.EnhancedBannerAlert), {
        ...gwp5090Team25Config
    }) : null;
};

});

parcelRegister("3JYqW", function(module, exports) {
$parcel$export(module.exports, "ConfluencePageBanner", function () { return $eb1962f2e68aa697$export$88cfc9a6a95640d1; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $3L8ZR = parcelRequire("3L8ZR");

var $jVACb = parcelRequire("jVACb");

var $jQ0cd = parcelRequire("jQ0cd");

var $4X0dO = parcelRequire("4X0dO");

var $gIKKj = parcelRequire("gIKKj");
const $eb1962f2e68aa697$export$88cfc9a6a95640d1 = ()=>{
    const intl = (0, $8e22h.default)();
    const showAiBanner = (0, $3L8ZR.default).checkGate('wac-uip-butter-bar-confluence-gate');
    const gwp5090BannerExperiment = (0, $gIKKj.useExperiment)((0, $4X0dO.experiments).gwp5090ExperimentBannerConfluence);
    const gwp5090IsButterBar = gwp5090BannerExperiment !== undefined && gwp5090BannerExperiment.type === 'enrolled' && gwp5090BannerExperiment.value === 'butterbar';
    const aiBannerMessages = {
        identifier: 'ConfluenceSoftwarePageTemplate.atlassian-intelligence_exp',
        text: intl.formatMessage({
            id: 'ConfluenceSoftwarePageTemplate.banner-alert.atlassian-intelligence_exp',
            defaultMessage: 'Transform teamwork with Atlassian Intelligence - now available.'
        }),
        linkText: intl.formatMessage({
            id: 'ConfluenceSoftwarePageTemplate.link-text',
            defaultMessage: 'Learn more'
        }),
        linkUrl: (0, $jQ0cd.useLocalizedHref)('/software/artificial-intelligence'),
        dataEventProps: {
            'data-product-key': 'confluence',
            'data-event-component': 'linkButton',
            'data-event-container': 'announcementBanner',
            'data-event': 'clicked',
            'data-label': 'Learn more',
            'data-label-english': 'Learn more',
            'data-track-event': 'confluencePageBanner.announcementBanner.learnMore'
        }
    };
    return !gwp5090IsButterBar && showAiBanner ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jVACb.BannerAlert), {
        ...aiBannerMessages
    }) : null;
};

});

parcelRegister("FlsVD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $64d774ca96291cd1$export$2e2bcd8739ae039; });
/* ai-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $lmQGF = parcelRequire("lmQGF");

var $gfjAv = parcelRequire("gfjAv");

var $irfTW = parcelRequire("irfTW");

var $6YfJw = parcelRequire("6YfJw");

var $je135 = parcelRequire("je135");
const $64d774ca96291cd1$var$AISection = ()=>{
    const intl = (0, $8e22h.default)();
    const [isModalOpen, setIsModalOpen] = (0, $1oC0p.useState)(false);
    const { ref: ref } = (0, $je135.useScrollTracking)('AISection', {
        observerOptions: {
            threshold: 0.25
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-aiSection",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            ref: ref,
            className: (0, $2jatx.default)([
                "_12l0y52h _46zeidpf _168b1l27 _ztwyidpf _1y1e1l27 _1brwstnw _1bzd9by0 _15w9stnw _j19k12am _voa41wug _19xgidpf _thu2fatv _1kplidpf _1p4vfatv"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $irfTW.Ai), {
                    theme: "light",
                    title: intl.formatMessage({
                        id: 'ConfluenceSoftwarePage.v4.AISection.title',
                        defaultMessage: 'Leave the busywork to AI'
                    }),
                    videoLink: "https://dam-cdn.atl.orangelogic.com/AssetLink/50m38s3ne34430160w3lr4jcg67ykb0t.mp4",
                    includeFooter: false,
                    button: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gfjAv.default), {
                        intentType: 'button',
                        containerId: 'aiSection',
                        productKey: 'confluence',
                        edition: 'free',
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                            variant: "secondary",
                            color: "black",
                            size: "large",
                            dataEventProps: {
                                'data-product-key': 'confluence',
                                'data-event': 'clicked',
                                'data-event-component': 'linkButton',
                                'data-event-container': 'aiSection',
                                'data-label': 'explore-atlassian-intelligence',
                                'data-label-english': 'Explore Atlassian Intelligence',
                                'data-track-event': 'confluence-pt.ai.explore-atlassian-intelligence'
                            },
                            onClick: ()=>setIsModalOpen(true),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "ConfluenceSoftwarePage.v4.AISection.button",
                                defaultMessage: "Explore Atlassian Intelligence"
                            })
                        })
                    }),
                    buttonPosition: "bottom",
                    videoContainerClassName: 'video-container',
                    showBurst: true,
                    burstClassName1: 'burst-container1',
                    burstClassName2: 'burst-container2',
                    videoClassName: 'video'
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6YfJw.YoutubeModal), {
                    isOpen: isModalOpen,
                    closeModal: ()=>setIsModalOpen(false),
                    src: "https://www.youtube.com/embed/ivIV1a8W0e4?si=iNOFdEMuDzTKN4X_?autoplay=1&rel=0&origin=https%3A%2F%2Fwww.atlassian.com&widget_referrer=https%3A%2F%2Fwww.atlassian.com&enablejsapi=1&widgetid=1&autoplay=1",
                    title: intl.formatMessage({
                        id: 'ConfluenceSoftwarePage.v4.AISection.ModalYouTubeIframeTitle',
                        defaultMessage: 'Empower Teams with Atlassian Intelligence in Confluence | Atlassian'
                    }),
                    closeIconLabel: intl.formatMessage({
                        id: 'ConfluenceSoftwarePage.v4.AISection.CloseModalButtonMobileLabel',
                        defaultMessage: 'Close modal'
                    })
                })
            ]
        })
    });
};
$64d774ca96291cd1$var$AISection.displayName = 'AISection';
var $64d774ca96291cd1$export$2e2bcd8739ae039 = $64d774ca96291cd1$var$AISection;

});
parcelRegister("irfTW", function(module, exports) {
$parcel$export(module.exports, "Ai", function () { return $1f8cf09c15c408d6$export$7ae07b56aa46260e; });
/* ai.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $bNzAT = parcelRequire("bNzAT");

var $l2rHD = parcelRequire("l2rHD");

var $32y9L = parcelRequire("32y9L");
const $1f8cf09c15c408d6$var$aiParentStyles = null;
const $1f8cf09c15c408d6$var$videoStyles = null;
const $1f8cf09c15c408d6$var$imageStyles = null;
const $1f8cf09c15c408d6$var$footerStyles = null;
const $1f8cf09c15c408d6$export$7ae07b56aa46260e = ({ theme: theme, title: title, buttonPosition: buttonPosition, button: button, videoLink: videoLink, includeFooter: includeFooter, showBurst: showBurst, videoContainerClassName: videoContainerClassName, videoClassName: videoClassName, burstClassName1: burstClassName1, burstClassName2: burstClassName2 })=>{
    const intl = (0, $8e22h.default)();
    const aiSectionStyles = null;
    const buttonSectionStyles = null;
    const titleStyles = null;
    const burstStyles1 = null;
    const burstStyles2 = null;
    const videoContainerStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _4cvr1h6o _bfhk1blq _syazu67f _4t3i1wug _1reo15vq _18m915vq _ca0q1f4h _u5f39by0 _n3tdidpf _19bv9by0 _1o9zidpf _1bsb1osq _kqswh2mm _9o8yglyw _tl281ylp _axwiidpf _1hwcidpf _sp8tidpf"
                ]),
                style: {
                    "--_1yyr69s": (0, $6ZVlx.default)(theme === 'light' ? '#CFE1FD' : '#1868DB')
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswstnw _4t3i1uc6 _1bsb53f4 _1e029by0 _liwcglyw",
                            burstClassName1
                        ]),
                        children: showBurst && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2rHD.Burst), {})
                    }),
                    theme === 'light' ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $32y9L.IntelligenceLight), {}) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $32y9L.IntelligenceDark), {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        className: (0, $2jatx.default)([
                            "_syaz83dj _y3gn1h6o _1iqs1cme _ect41vau _1wybckbl _zg8l4jg8 _k48p1fw0 _vwz4ckbl _85i5zwfg _flz0zwfg _1lzozwfg _1cqs1tcg"
                        ]),
                        style: {
                            "--_e9aqa9": (0, $6ZVlx.default)(theme === 'light' ? '#101214' : '#FFF'),
                            "--_1vugql0": (0, $6ZVlx.default)((0, $bNzAT.default)('font.charlie.display'))
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _4cvr1h6o _19pk1crf _9o8yglyw",
                            buttonPosition !== 'bottom' ? '' : 'hide'
                        ]),
                        children: button
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswstnw _4t3i7ynd _1bsb8ved _u7cogktf _rjxp9by0 _liwcglyw",
                            burstClassName2
                        ]),
                        children: showBurst && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2rHD.Burst), {})
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_4t3i1wug _liwcglyw",
                            videoContainerClassName
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("video", {
                            playsInline: true,
                            muted: true,
                            preload: "auto",
                            autoPlay: true,
                            loop: true,
                            className: (0, $2jatx.default)([
                                "_p12f1uof _4t3i1wug _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _liwcglyw",
                                videoClassName
                            ]),
                            children: [
                                intl.formatMessage({
                                    id: 'ConfluenceSoftwarePage.v4.AISection.imgAlt',
                                    defaultMessage: 'demo of AI integration'
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                                    src: videoLink,
                                    type: `video/webm`
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ai-img.webp",
                        loading: "lazy",
                        alt: intl.formatMessage({
                            id: 'ConfluenceSoftwarePage.v4.AISection.imgAlt',
                            defaultMessage: 'demo of AI integration'
                        }),
                        className: (0, $2jatx.default)([
                            "_1bsb1osq _4t3i1wug _ca0q7vkz _u5f310yn _n3tdidpf _19bv10yn _je3oglyw"
                        ])
                    })
                ]
            }),
            includeFooter && /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/blue-angle.webp",
                alt: "",
                className: (0, $2jatx.default)([
                    "_1bsb1osq _1pby1mrw _1pfh1n1a"
                ])
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _4cvr1h6o _19pk1crf _9o8yglyw",
                    buttonPosition === 'bottom' ? '' : 'hide'
                ]),
                children: button
            })
        ]
    });
};

});
parcelRegister("l2rHD", function(module, exports) {
$parcel$export(module.exports, "Burst", function () { return $8247e2fa7497915d$export$a3f4e2574d5726c7; });

var $7VQPk = parcelRequire("7VQPk");
const $8247e2fa7497915d$export$a3f4e2574d5726c7 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        viewBox: "0 0 86 85",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M40.7007 14.1674C34.894 6.10495 35.5846 12.4188 38.9551 18.1907C39.4398 15.5504 40.3978 19.8405 39.0651 18.4315C39.0463 19.1506 39.7286 22.1508 40.4308 20.9456C39.8016 21.4048 42.4581 30.0808 43.3518 24.7504C43.2753 24.6369 42.3825 25.0337 42.572 24.7366C43.69 22.5286 40.8513 17.8368 40.6978 14.1628L40.7007 14.1674Z",
                fill: "#111213"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M24.1165 33.3455C24.3704 34.0377 29.1781 37.8998 29.1178 35.3451C28.2937 34.5933 28.8737 34.0231 27.8473 34.6824C26.7515 28.5866 2.84954 20.7621 21.0405 31.5593C20.3668 29.885 21.5849 30.7022 21.9766 31.5345C20.0488 31.4834 24.2398 34.3884 23.8836 32.8848C24.2851 32.952 24.5516 33.3213 24.1165 33.3455Z",
                fill: "#111213"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M15.7083 51.6375C16.3508 51.9805 19.0481 50.6754 19.9635 50.0653C18.1731 49.685 19.6559 49.1297 20.5037 49.3266C19.6722 50.7596 22.5761 49.4556 23.151 48.8563C22.762 48.955 22.6178 48.4717 23.2188 48.3C23.9493 50.3058 31.4246 44.9641 26.5584 46.0775C25.0032 45.9635 19.65 47.7249 15.9357 48.32C15.2425 49.7063 13.9577 50.3323 12.381 50.6625C10.0879 53.4867 15.1171 53.1473 15.7008 51.6357L15.7083 51.6375Z",
                fill: "#111213"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M35.4623 56.5432C35.0962 56.2418 34.8744 57.0798 34.2236 57.1085C34.1841 57.2423 35.0696 57.6668 34.7174 57.7106C32.2276 59.1126 28.1044 64.5844 27.5687 68.8705C25.031 75.2029 31.6172 68.442 32.037 64.697C30.4251 65.5635 31.2001 64.1846 31.9792 63.7808C32.2658 65.4111 33.6465 62.5457 33.6996 61.7154C33.4636 62.0412 33.0481 61.7639 33.397 61.2462C34.0038 62.5309 37.7314 55.8562 35.4623 56.5432Z",
                fill: "#111213"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M47.5445 61.1109C47.7465 60.4073 46.1495 54.4473 44.6895 56.5385C44.8557 57.5678 44.2278 57.7689 45.3235 57.8257C44.3119 61.518 47.5357 67.6249 49.5384 71.9517C54.4828 75.7229 48.9857 62.4978 48.7485 65.2683C46.8849 64.155 50.374 63.7888 47.5491 61.108L47.5445 61.1109Z",
                fill: "#111213"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M68.081 60.87C67.506 60.7298 61.702 54.6915 62.4175 57.1311C60.2478 57.0943 63.0913 55.0365 59.2985 54.1301C59.1214 53.4163 54.7623 49.0521 54.539 51.5953C55.1987 52.4036 54.7538 52.8906 55.7259 52.3933C54.6288 53.6044 56.6163 53.3357 56.7169 53.4987C56.1274 54.7824 58.4929 54.5953 57.5662 55.0517C58.5404 57.473 68.5615 65.6671 68.0735 60.8682L68.081 60.87Z",
                fill: "#111213"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M74.1525 41.2299C71.1084 40.0993 67.3911 41.0436 65.8157 41.0322C67.1942 40.1104 64.0113 40.0045 63.2287 40.2882C63.622 40.3735 63.5412 40.8672 62.9225 40.7604C63.8553 39.6892 56.2426 38.9673 57.7848 40.7679C57.6537 41.2218 58.5161 41.0882 58.807 41.6739C58.9428 41.6544 58.9752 40.6761 59.162 40.9788C58.9268 42.5968 60.4305 41.2633 60.6023 41.3438C60.8304 42.7336 62.6879 41.2653 62.174 42.1614C64.1349 43.7549 77.7773 44.5296 74.1583 41.2392L74.1525 41.2299Z",
                fill: "#111213"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M64.2396 18.8011C61.3001 20.1721 59.3546 23.4762 58.2337 24.5863C58.5467 22.9589 56.2378 25.1432 55.8882 25.8992C56.2222 25.6802 56.5164 26.0838 56.0088 26.4486C55.9014 25.0357 50.0371 29.936 52.4026 30.1027C52.6359 30.5118 53.14 29.8083 53.7629 30.0155C53.8458 29.9 53.1705 29.1913 53.5169 29.2734C54.5039 30.5806 54.6084 28.5738 54.7885 28.5012C55.9381 29.3221 56.1975 26.9624 56.474 27.9622C59.1498 27.455 68.9328 18.9586 64.2414 18.7935L64.2396 18.8011Z",
                fill: "#111213"
            })
        ]
    });
};

});

parcelRegister("32y9L", function(module, exports) {
$parcel$export(module.exports, "IntelligenceDark", function () { return $e2d342c47f46899a$export$6c136ee6aa49536d; });
$parcel$export(module.exports, "IntelligenceLight", function () { return $e2d342c47f46899a$export$28c56d9c47eae24c; });

var $7VQPk = parcelRequire("7VQPk");
const $e2d342c47f46899a$export$6c136ee6aa49536d = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
            width: "48",
            height: "48",
            viewBox: "0 0 48 48",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                    id: "Group 626186",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M37.3027 23.8756C37.3027 22.4546 38.4547 21.3027 39.8757 21.3027H44.5842C46.0052 21.3027 47.1572 22.4546 47.1572 23.8756C47.1572 25.2967 46.0052 26.4486 44.5842 26.4486H39.8757C38.4547 26.4486 37.3027 25.2967 37.3027 23.8756Z",
                            fill: "url(#paint0_linear_2487_5195)"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_2",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M24.0007 0.718933C25.4217 0.718933 26.5737 1.87089 26.5737 3.2919V8.00043C26.5737 9.42144 25.4217 10.5734 24.0007 10.5734C22.5797 10.5734 21.4277 9.42144 21.4277 8.00043V3.2919C21.4277 1.87089 22.5797 0.718933 24.0007 0.718933Z",
                            fill: "url(#paint1_linear_2487_5195)"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_3",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0.84375 23.8756C0.84375 22.4546 1.99571 21.3027 3.41672 21.3027H8.12525C9.54626 21.3027 10.6982 22.4546 10.6982 23.8756C10.6982 25.2967 9.54626 26.4486 8.12525 26.4486H3.41672C1.99571 26.4486 0.84375 25.2967 0.84375 23.8756Z",
                            fill: "url(#paint2_linear_2487_5195)"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_4",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M24.0007 37.1779C25.4217 37.1779 26.5737 38.3298 26.5737 39.7508V44.4594C26.5737 45.8804 25.4217 47.0323 24.0007 47.0323C22.5797 47.0323 21.4277 45.8804 21.4277 44.4594V39.7508C21.4277 38.3298 22.5797 37.1779 24.0007 37.1779Z",
                            fill: "url(#paint3_linear_2487_5195)"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_5",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M29.9001 29.7752C30.9049 28.7703 32.534 28.7703 33.5388 29.7752L43.8307 40.067C44.8355 41.0718 44.8355 42.7009 43.8307 43.7058C42.8259 44.7106 41.1968 44.7106 40.192 43.7058L29.9001 33.4139C28.8953 32.4091 28.8953 30.78 29.9001 29.7752Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_6",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M43.8307 4.04548C44.8355 5.05028 44.8355 6.6794 43.8307 7.6842L33.5388 17.9761C32.534 18.9809 30.9049 18.9809 29.9001 17.9761C28.8953 16.9713 28.8953 15.3422 29.9001 14.3373L40.192 4.04548C41.1968 3.04067 42.8259 3.04067 43.8307 4.04548Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_7",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M4.16962 4.04548C5.17443 3.04067 6.80354 3.04067 7.80835 4.04548L18.1002 14.3373C19.105 15.3422 19.105 16.9713 18.1002 17.9761C17.0954 18.9809 15.4663 18.9809 14.4615 17.9761L4.16962 7.6842C3.16481 6.6794 3.16481 5.05028 4.16962 4.04548Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_8",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M18.1002 29.7752C19.105 30.78 19.105 32.4091 18.1002 33.4139L7.80835 43.7058C6.80354 44.7106 5.17443 44.7106 4.16962 43.7058C3.16481 42.7009 3.16481 41.0718 4.16962 40.067L14.4615 29.7752C15.4663 28.7703 17.0954 28.7703 18.1002 29.7752Z",
                            fill: "white"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                            id: "paint0_linear_2487_5195",
                            x1: "47.1571",
                            y1: "23.8756",
                            x2: "38.1517",
                            y2: "23.8756",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "0.270833",
                                    stopColor: "#9BC6FF"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "1",
                                    stopColor: "white"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                            id: "paint1_linear_2487_5195",
                            x1: "25.2872",
                            y1: "0.718933",
                            x2: "25.2872",
                            y2: "9.72432",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "0.1875",
                                    stopColor: "#9BC6FF"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "1",
                                    stopColor: "white"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                            id: "paint2_linear_2487_5195",
                            x1: "10.6981",
                            y1: "23.8756",
                            x2: "1.69272",
                            y2: "23.8756",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    stopColor: "white"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "0.791667",
                                    stopColor: "#2684FF"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                            id: "paint3_linear_2487_5195",
                            x1: "25.2872",
                            y1: "36.7404",
                            x2: "25.2872",
                            y2: "47.0323",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    stopColor: "white"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "0.802083",
                                    stopColor: "#A6CCFE"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
const $e2d342c47f46899a$export$28c56d9c47eae24c = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
            width: "60",
            height: "60",
            viewBox: "0 0 60 60",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M50.5501 27.4199H41.6001V32.4199H50.5501V27.4199Z",
                    fill: "url(#paint0_linear_4426_97000)"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M32.4253 9.29492H27.4253V18.2449H32.4253V9.29492Z",
                    fill: "url(#paint1_linear_4426_97000)"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M18.2503 27.4199H9.30029V32.4199H18.2503V27.4199Z",
                    fill: "url(#paint2_linear_4426_97000)"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M32.4253 41.595H27.4253V50.545H32.4253V41.595Z",
                    fill: "url(#paint3_linear_4426_97000)"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M37.8796 34.2856L34.291 37.8741L47.5051 51.0882L51.0936 47.4996L37.8796 34.2856Z",
                    fill: "#2684FF"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M47.5052 8.74824L34.2935 21.9646L37.8827 25.5525L51.0944 12.3362L47.5052 8.74824Z",
                    fill: "#2684FF"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M12.3395 8.7481L8.75098 12.3367L21.965 25.5507L25.5536 21.9622L12.3395 8.7481Z",
                    fill: "#2684FF"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M21.9618 34.2762L8.75 47.4926L12.3392 51.0805L25.5509 37.8641L21.9618 34.2762Z",
                    fill: "#2684FF"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                            id: "paint0_linear_4426_97000",
                            x1: "41.6001",
                            y1: "29.9199",
                            x2: "50.5501",
                            y2: "29.9199",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    stopColor: "#0052CC"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "0.8",
                                    stopColor: "#2684FF"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                            id: "paint1_linear_4426_97000",
                            x1: "29.9253",
                            y1: "18.2449",
                            x2: "29.9253",
                            y2: "9.29492",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    stopColor: "#0052CC"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "0.8",
                                    stopColor: "#2684FF"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                            id: "paint2_linear_4426_97000",
                            x1: "18.2503",
                            y1: "-0.0800891",
                            x2: "9.30029",
                            y2: "-0.0800891",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    stopColor: "#0052CC"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "0.8",
                                    stopColor: "#2684FF"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                            id: "paint3_linear_4426_97000",
                            x1: "29.9253",
                            y1: "41.595",
                            x2: "29.9253",
                            y2: "50.545",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    stopColor: "#0052CC"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "0.8",
                                    stopColor: "#2684FF"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});


parcelRegister("6YfJw", function(module, exports) {
$parcel$export(module.exports, "YoutubeModal", function () { return $86692670f5e6bd21$export$7283d5171aeba9eb; });

var $7VQPk = parcelRequire("7VQPk");

var $jOK0R = parcelRequire("jOK0R");
const $86692670f5e6bd21$export$7283d5171aeba9eb = ({ isOpen: isOpen, closeModal: closeModal, src: src, title: title, closeIconLabel: closeIconLabel })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jOK0R.Modal), {
        isOpen: isOpen,
        closeModal: closeModal,
        closeIconLabel: closeIconLabel,
        content: (height)=>/*#__PURE__*/ (0, $7VQPk.jsx)("iframe", {
                style: {
                    verticalAlign: 'bottom'
                },
                width: '100%',
                height: height,
                src: src,
                title: title,
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                allowFullScreen: true,
                "data-gtm-yt-inspected-12": "true"
            })
    });
};

});
parcelRegister("jOK0R", function(module, exports) {
$parcel$export(module.exports, "Modal", function () { return $e3e7cd9c1ba914e9$export$2b77a92f1a5ad772; });
/* modal.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $3RaC6 = parcelRequire("3RaC6");

var $cNOwN = parcelRequire("cNOwN");

var $5kbMC = parcelRequire("5kbMC");
var $ixnNi = parcelRequire("ixnNi");
var $7M4vT = parcelRequire("7M4vT");
const $e3e7cd9c1ba914e9$var$modalContentStyles = null;
const $e3e7cd9c1ba914e9$var$closeModalStyles = null;
const $e3e7cd9c1ba914e9$var$DESKTOP_MODAL_SIZE = {
    width: 'large',
    // atlaskit modal starts ignoring the width at smaller sizes
    height: '540' // atlaskit modal starts setting height to 100% at smaller sizes
};
const $e3e7cd9c1ba914e9$var$MOBILE_MODAL_SIZE = {
    width: '1024px',
    height: '576'
};
const $e3e7cd9c1ba914e9$export$2b77a92f1a5ad772 = ({ isOpen: isOpen, closeModal: closeModal, content: content, closeIconLabel: closeIconLabel, isContentModal: isContentModal })=>{
    const intl = (0, $8e22h.default)();
    const getModalSize = ()=>{
        if (window.innerWidth >= 1024) return $e3e7cd9c1ba914e9$var$MOBILE_MODAL_SIZE;
        return $e3e7cd9c1ba914e9$var$DESKTOP_MODAL_SIZE;
    };
    const [modalSize, setModalSize] = (0, $1oC0p.useState)(getModalSize());
    (0, $1oC0p.useEffect)(()=>{
        const updateModalSize = ()=>{
            setModalSize(getModalSize());
        };
        window.addEventListener('resize', updateModalSize);
        return ()=>window.removeEventListener('resize', updateModalSize);
    }, []);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7M4vT.default), {
        children: isOpen && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5kbMC.default), {
            onClose: closeModal,
            width: modalSize.width,
            height: modalSize.height,
            children: [
                window.innerWidth < 480 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ixnNi.default), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _1bsb1osq _1bahesu3 _jq8g1tcg"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3RaC6.default), {
                            appearance: "subtle-link",
                            onClick: closeModal,
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cNOwN))), {
                                label: closeIconLabel ?? intl.formatMessage({
                                    id: 'Modal.closeIconLabel',
                                    defaultMessage: 'close modal'
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_4t3i1osq _1bsb1osq _kqswh2mm _8hk7glyw _19aezwfg _i09y7vkz _1m61zwfg _8sf87vkz _12hx1wug _jdwsyly2 _z8tz1h6o _1wrf1wug _1ov51wug _9ry81wug _puii1wug _1lzu1wug _9ep71osq _skrarbzz _1c221r31 _72u08stv _17ignqa1 _e133oelr _gqi51r31 _1jvzglyw _1y27nqa1 _3njzidpf _1qbr1wug _mw5fidpf _n9dy1wug _1qmd1e5h _iml01ns9 _1hbcidpf _12evidpf _1f2i1crf _n1p2idpf _1oq91bqd _mpw4bfng _1kb4viql _1nfb10nf _pvcxidpf _1a76dlk8 _1uxeyn4p _d09fzz36 _tyl97vkz _wjni1wto _nggt1k7u _onli1tcg _1el9stnw _u7yn1lpd _14g8kfja _4wwiu67f _1ogfglyw"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: isContentModal ? 'content-modal' : '',
                            children: content(getModalSize().height)
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            id: "close-modal-button",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3RaC6.default), {
                                appearance: "subtle-link",
                                onClick: closeModal,
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cNOwN))), {
                                    label: closeIconLabel ?? intl.formatMessage({
                                        id: 'Modal.closeIconLabel',
                                        defaultMessage: 'close modal'
                                    })
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("ixnNi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d7edc4155f416dec$export$2e2bcd8739ae039; });
/* modal-header.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $8P02U = parcelRequire("8P02U");

var $8WISV = parcelRequire("8WISV");

var $dYPjn = parcelRequire("dYPjn");
var $d7edc4155f416dec$var$styles = {
    header: "_18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bah1yb4 _6rth1i6y _85i5pxbi _1q511ejb",
    flex: "_2lx21sbv _1bsb1osq",
    titleContainer: "_1ul9idpf"
};
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $d7edc4155f416dec$var$ModalHeader = function ModalHeader(props) {
    var children = props.children, userDefinedTestId = props.testId, _props$hasCloseButton = props.hasCloseButton, hasCloseButton = _props$hasCloseButton === void 0 ? false : _props$hasCloseButton;
    var _useModal = (0, $dYPjn.useModal)(), hasProvidedOnClose = _useModal.hasProvidedOnClose, onClose = _useModal.onClose, modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--header");
    // Only show if an onClose was provided for the modal dialog
    var shouldShowCloseButton = hasCloseButton && hasProvidedOnClose && onClose;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        "data-testid": testId,
        className: (0, $2jatx.default)([
            $d7edc4155f416dec$var$styles.header
        ])
    }, shouldShowCloseButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8P02U.Flex), {
        gap: "space.200",
        justifyContent: "space-between",
        xcss: $d7edc4155f416dec$var$styles.flex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8P02U.Flex), {
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8WISV.CloseButton), {
        onClick: onClose,
        testId: modalTestId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8P02U.Flex), {
        justifyContent: "start",
        alignItems: "center",
        xcss: $d7edc4155f416dec$var$styles.titleContainer
    }, children)) : children);
};
var $d7edc4155f416dec$export$2e2bcd8739ae039 = $d7edc4155f416dec$var$ModalHeader;

});
parcelRegister("8P02U", function(module, exports) {
$parcel$export(module.exports, "Flex", function () { return $66c31f411e535770$export$f51f4c4ede09e011; });
/* flex.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $66c31f411e535770$var$_excluded = [
    "as",
    "role",
    "alignItems",
    "justifyContent",
    "gap",
    "columnGap",
    "rowGap",
    "children",
    "testId",
    "direction",
    "wrap",
    "xcss"
];
var $66c31f411e535770$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
var $66c31f411e535770$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
var $66c31f411e535770$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $66c31f411e535770$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $66c31f411e535770$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $66c31f411e535770$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $66c31f411e535770$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
var $66c31f411e535770$export$f51f4c4ede09e011 = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, ariaAttributes = (0, $gnQ3X.default)(_ref, $66c31f411e535770$var$_excluded);
    return /*#__PURE__*/ $1oC0p.createElement(Component, (0, $c9bqK.default)({}, ariaAttributes, {
        role: role,
        className: (0, $2jatx.default)([
            $66c31f411e535770$var$styles.root,
            gap && $66c31f411e535770$var$columnGapMap[gap],
            columnGap && $66c31f411e535770$var$columnGapMap[columnGap],
            gap && $66c31f411e535770$var$rowGapMap[gap],
            rowGap && $66c31f411e535770$var$rowGapMap[rowGap],
            alignItems && $66c31f411e535770$var$alignItemsMap[alignItems],
            direction && $66c31f411e535770$var$flexDirectionMap[direction],
            justifyContent && $66c31f411e535770$var$justifyContentMap[justifyContent],
            wrap && $66c31f411e535770$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }), children);
}));
$66c31f411e535770$export$f51f4c4ede09e011.displayName = 'Flex';

});

parcelRegister("8WISV", function(module, exports) {
$parcel$export(module.exports, "CloseButton", function () { return $68368eb07ba4b07f$export$de65de8213222d10; });

var $1oC0p = parcelRequire("1oC0p");

var $cKNbK = parcelRequire("cKNbK");

var $5gEzD = parcelRequire("5gEzD");
var $68368eb07ba4b07f$export$de65de8213222d10 = function CloseButton(_ref) {
    var label = _ref.label, onBlur = _ref.onBlur, onClick = _ref.onClick, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cKNbK.default), {
        testId: testId && "".concat(testId, "--close-button"),
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5gEzD))),
        label: label || 'Close Modal',
        onBlur: onBlur,
        onClick: onClick
    });
};

});
parcelRegister("cKNbK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $948fefbcdac869d9$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $kPutE = parcelRequire("kPutE");

var $huaF6 = parcelRequire("huaF6");

var $ckHGa = parcelRequire("ckHGa");

var $3aj1x = parcelRequire("3aj1x");

var $eEgkm = parcelRequire("eEgkm");

var $4mOtV = parcelRequire("4mOtV");
var $948fefbcdac869d9$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $948fefbcdac869d9$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $948fefbcdac869d9$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Button(_ref, ref) {
    var _tooltip$content;
    var preventedAriaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, _onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, $gnQ3X.default)(_ref, $948fefbcdac869d9$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $gnQ3X.default)(unsafeRest, $948fefbcdac869d9$var$_excluded2);
    if (isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3aj1x.default), (0, $c9bqK.default)({}, saferRest, {
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: _onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eEgkm.default), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4mOtV.default), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $ckHGa.default), null, label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $huaF6.default), {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents,
        shortcut: tooltip === null || tooltip === void 0 ? void 0 : tooltip.shortcut
    }, function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3aj1x.default), (0, $c9bqK.default)({}, saferRest, {
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === 'circle',
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: function onClick(e, analyticsEvent) {
                var _triggerProps$onClick;
                _onClick === null || _onClick === void 0 || _onClick(e, analyticsEvent);
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _saferRest$onMouseOve;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _saferRest$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _saferRest$onMouseMov;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _saferRest$onMouseDow;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _saferRest$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _saferRest$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
            },
            ref: (0, $kPutE.default)([
                ref,
                triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eEgkm.default), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4mOtV.default), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $ckHGa.default), null, label)));
    });
}));
$948fefbcdac869d9$var$IconButton.displayName = 'IconButton';
var $948fefbcdac869d9$export$2e2bcd8739ae039 = $948fefbcdac869d9$var$IconButton;

});
parcelRegister("huaF6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cbad8245ea9d1ed4$export$2e2bcd8739ae039; });
/* tooltip.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $c9bqK = parcelRequire("c9bqK");

var $2qaZZ = parcelRequire("2qaZZ");

var $f53LC = parcelRequire("f53LC");


var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $iIKkf = parcelRequire("iIKkf");

var $7uNuF = parcelRequire("7uNuF");

var $4P6qn = parcelRequire("4P6qn");

var $5l9My = parcelRequire("5l9My");

var $2VaUS = parcelRequire("2VaUS");

var $dUP6e = parcelRequire("dUP6e");

var $iAIri = parcelRequire("iAIri");

var $6ur0l = parcelRequire("6ur0l");

var $lFMh3 = parcelRequire("lFMh3");

var $iJAOx = parcelRequire("iJAOx");

var $agtVC = parcelRequire("agtVC");

var $jp38o = parcelRequire("jp38o");

var $2chlf = parcelRequire("2chlf");

var $iQsXC = parcelRequire("iQsXC");

var $ik7PK = parcelRequire("ik7PK");

var $8O6sf = parcelRequire("8O6sf");

var $hbilF = parcelRequire("hbilF");

var $3Cc2B = parcelRequire("3Cc2B");

var $9Ozog = parcelRequire("9Ozog");

var $bnftV = parcelRequire("bnftV");

var $kp4DZ = parcelRequire("kp4DZ");
function $cbad8245ea9d1ed4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cbad8245ea9d1ed4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cbad8245ea9d1ed4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cbad8245ea9d1ed4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cbad8245ea9d1ed4$var$tooltipZIndex = (0, $agtVC.layers).tooltip();
var $cbad8245ea9d1ed4$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "24.2.1"
};
// Inverts motion direction
var $cbad8245ea9d1ed4$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $cbad8245ea9d1ed4$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * For the `platform-dst-top-layer-tooltip` path only. Always `false` when that
 * gate is off, so this cannot affect the legacy path even if it gains a caller
 * there.
 *
 * `mouseover` also fires when the pointer crosses boundaries between elements
 * _inside_ the trigger. A `relatedTarget` the trigger does not contain is what
 * distinguishes a real re-entry from one of those.
 */ function $cbad8245ea9d1ed4$var$isTopLayerPointerReEntry(_ref) {
    var trigger = _ref.trigger, relatedTarget = _ref.relatedTarget;
    if (!(0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) return false;
    // Missing trigger, or pointer from outside the document. Treat both as an
    // entry so we cannot get stuck suppressed.
    if (!trigger || !(relatedTarget instanceof Node)) return true;
    return !trigger.contains(relatedTarget);
}
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $cbad8245ea9d1ed4$var$Tooltip(_ref2) {
    var children = _ref2.children, _ref2$position = _ref2.position, position = _ref2$position === void 0 ? 'bottom' : _ref2$position, _ref2$mousePosition = _ref2.mousePosition, mousePosition = _ref2$mousePosition === void 0 ? 'bottom' : _ref2$mousePosition, content = _ref2.content, _ref2$truncate = _ref2.truncate, truncate = _ref2$truncate === void 0 ? false : _ref2$truncate, _ref2$component = _ref2.component, Container = _ref2$component === void 0 ? (0, $kp4DZ.default) : _ref2$component, _ref2$tag = _ref2.tag, TargetContainer = _ref2$tag === void 0 ? 'div' : _ref2$tag, testId = _ref2.testId, _ref2$delay = _ref2.delay, delay = _ref2$delay === void 0 ? 300 : _ref2$delay, _ref2$onShow = _ref2.onShow, onShow = _ref2$onShow === void 0 ? (0, $7uNuF.default) : _ref2$onShow, _ref2$onHide = _ref2.onHide, onHide = _ref2$onHide === void 0 ? (0, $7uNuF.default) : _ref2$onHide, canAppear = _ref2.canAppear, _ref2$hideTooltipOnCl = _ref2.hideTooltipOnClick, hideTooltipOnClick = _ref2$hideTooltipOnCl === void 0 ? false : _ref2$hideTooltipOnCl, _ref2$hideTooltipOnMo = _ref2.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref2$hideTooltipOnMo === void 0 ? false : _ref2$hideTooltipOnMo, analyticsContext = _ref2.analyticsContext, _ref2$strategy = _ref2.strategy, strategy = _ref2$strategy === void 0 ? 'fixed' : _ref2$strategy, _ref2$ignoreTooltipPo = _ref2.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref2$ignoreTooltipPo === void 0 ? false : _ref2$ignoreTooltipPo, _ref2$isScreenReaderA = _ref2.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref2$isScreenReaderA === void 0 ? false : _ref2$isScreenReaderA, shortcut = _ref2.shortcut, _ref2$shouldAlwaysFad = _ref2.shouldAlwaysFadeIn, shouldAlwaysFadeIn = _ref2$shouldAlwaysFad === void 0 ? false : _ref2$shouldAlwaysFad, _ref2$shouldRenderToP = _ref2.shouldRenderToParent, shouldRenderToParent = _ref2$shouldRenderToP === void 0 ? false : _ref2$shouldRenderToP;
    // Not using a gate for this check. When the gate is disabled `mouse-y` and `mouse-x` are treated as `mouse`.
    var isMousePosition = position === 'mouse' || position === 'mouse-y' || position === 'mouse-x';
    var tooltipPosition = isMousePosition ? mousePosition : position;
    var onShowHandler = (0, $iIKkf.usePlatformLeafSyntheticEventHandler)($cbad8245ea9d1ed4$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $cbad8245ea9d1ed4$var$analyticsAttributes));
    var onHideHandler = (0, $iIKkf.usePlatformLeafSyntheticEventHandler)($cbad8245ea9d1ed4$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $cbad8245ea9d1ed4$var$analyticsAttributes));
    var apiRef = (0, $1oC0p.useRef)(null);
    var _useState = (0, $1oC0p.useState)('hide'), _useState2 = (0, $2qaZZ.default)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $1oC0p.useRef)(null);
    var containerRef = (0, $1oC0p.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $1oC0p.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $5l9My.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $5l9My.default)(onShowHandler);
    var onHideHandlerStable = (0, $5l9My.default)(onHideHandler);
    var delayStable = (0, $5l9My.default)(delay);
    var canAppearStable = (0, $5l9My.default)(canAppear);
    var hasCalledShowHandler = (0, $1oC0p.useRef)(false);
    var shouldAlwaysFadeInStable = (0, $5l9My.default)(shouldAlwaysFadeIn);
    var start = (0, $1oC0p.useCallback)(function(api) {
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $1oC0p.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $1oC0p.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $1oC0p.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $1oC0p.useRef)(false);
    (0, $1oC0p.useEffect)(function() {
        return (0, $8O6sf.register)({
            onRegister: function onRegister(_ref3) {
                var isDragging = _ref3.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    // Set while a pointer press has dismissed the tooltip. Every read and write is
    // behind `platform-dst-top-layer-tooltip`, where `popover="hint"` owns pointer
    // dismissal, so the legacy path never sees this.
    var isTopLayerPointerDismissedRef = (0, $1oC0p.useRef)(false);
    var tryShowTooltip = (0, $1oC0p.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Stay dismissed until the trigger is re-entered or blurred. Otherwise
     * light dismiss hides on pointerup and the next `mouseover` from a
     * boundary crossing inside the trigger re-shows it. Deliberately after
     * the "already active" branch, so a held press stays visible.
     */ if (isTopLayerPointerDismissedRef.current && (0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) return;
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref4) {
                var isImmediate = _ref4.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(!isImmediate ? 'fade-in' : 'show-immediate');
            },
            hide: function hide(_ref5) {
                var isImmediate = _ref5.isImmediate;
                if (isImmediate) setState('hide');
                else if ((0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) // Top-layer path: set state to 'top-layer-exit'. The component
                // stays mounted and Popover's isOpen prop transitions to
                // false, triggering the CSS exit animation internally.
                // finishHideAnimation is called after a brief delay matching
                // the CSS exit animation duration.
                setState('top-layer-exit');
                else setState('before-fade-out');
            },
            done: done,
            shouldAlwaysFadeIn: shouldAlwaysFadeInStable.current
        };
        var api = (0, $9Ozog.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable,
        shouldAlwaysFadeInStable
    ]);
    var hideTooltipOnEsc = (0, $1oC0p.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    // When using top-layer, popover="auto" handles Escape natively
    (0, $4P6qn.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out' || state === 'top-layer-exit' || (0, $6ur0l.fg)('platform-dst-top-layer-tooltip')
    });
    // ── Top-layer exit animation lifecycle ──
    // When state is 'top-layer-exit', Popover's isOpen transitions to false and
    // the CSS exit animation plays. The Popover's built-in `transitionend`
    // detection (with timeout fallback) calls `onExitFinish` when the exit
    // animation completes, which triggers the tooltip-manager lifecycle
    // (finishHideAnimation → done → onHide, setState('hide'), cleanup).
    var handleExitFinish = (0, $1oC0p.useCallback)(function() {
        var _apiRef$current3;
        (_apiRef$current3 = apiRef.current) === null || _apiRef$current3 === void 0 || _apiRef$current3.finishHideAnimation();
    }, []);
    // Browser dismiss (light dismiss on pointerup, or Escape). Recorded so we stay
    // hidden until the trigger is re-entered. Only wired up on the top-layer path,
    // but gated anyway to keep every use of the ref flag-checked.
    var handlePopoverClose = (0, $1oC0p.useCallback)(function() {
        var _apiRef$current4;
        if ((0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = true;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $1oC0p.useEffect)(function() {
        if (state === 'hide') return 0, $7uNuF.default;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $dH1HR.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $1oC0p.useCallback)(function() {
        // Native light dismiss hides on pointerup, not here. Recorded now so the
        // tooltip stays dismissed afterwards.
        if ((0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = true;
        // A press inside the show delay never reaches light dismiss, because no
        // popover is open on pointerup. Cancel the pending show so a quick click
        // does not surface a tooltip over content the press just changed.
        var shouldCancelPendingShow = stableState.current === 'hide' && (0, $6ur0l.fg)('platform-dst-top-layer-tooltip');
        if ((hideTooltipOnMouseDown || shouldCancelPendingShow) && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown,
        stableState
    ]);
    var onClick = (0, $1oC0p.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $1oC0p.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        // Re-arm on a real re-entry, not on a boundary crossing inside the trigger.
        if ($cbad8245ea9d1ed4$var$isTopLayerPointerReEntry({
            trigger: targetRef.current,
            relatedTarget: event.relatedTarget
        }) && (0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = false;
        var source = isMousePosition ? {
            type: 'mouse',
            clientX: event.clientX,
            clientY: event.clientY
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        isMousePosition,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $1oC0p.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = isMousePosition ? function(event) {
        var _apiRef$current5;
        if ((_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.isActive()) apiRef.current.mousePos = {
            clientX: event.clientX,
            clientY: event.clientY
        };
    } : undefined;
    var onMouseOverTooltip = (0, $1oC0p.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $1oC0p.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch (_unused) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $1oC0p.useCallback)(function() {
        // Focus leaving ends the dismissal, so focus coming back can show the tooltip.
        if ((0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = false;
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $1oC0p.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out' && state !== 'top-layer-exit';
    var handleOpenLayerObserverCloseSignal = (0, $1oC0p.useCallback)(function() {
        var _apiRef$current6;
        (_apiRef$current6 = apiRef.current) === null || _apiRef$current6 === void 0 || _apiRef$current6.requestHide({
            isImmediate: true
        });
    }, []);
    // Registered unconditionally so the hook order never depends on the feature
    // flag value. On the top-layer path the Popover primitive (used by
    // TopLayerTooltipPopup) registers with the observer directly, so we pass
    // isOpen: false to avoid double-counting (the hook is a no-op while the
    // layer is not open).
    (0, $2VaUS.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: (0, $6ur0l.fg)('platform-dst-top-layer-tooltip') ? false : shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current7;
        if (isMousePosition && (_apiRef$current7 = apiRef.current) !== null && _apiRef$current7 !== void 0 && _apiRef$current7.mousePos && targetRef.current) return (0, $3Cc2B.getVirtualElementFromMousePos)(apiRef.current.mousePos, {
            targetElement: targetRef.current,
            tooltipPosition: position
        });
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $bnftV.default)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $1oC0p.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    var PopperWrapper = shouldRenderToParent ? (0, $1oC0p.Fragment) : $cbad8245ea9d1ed4$var$TooltipPortal;
    var trigger = typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, children($cbad8245ea9d1ed4$var$_objectSpread($cbad8245ea9d1ed4$var$_objectSpread($cbad8245ea9d1ed4$var$_objectSpread({}, tooltipTriggerProps), testId ? {
        testId: "".concat(testId, "--container")
    } : {}), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(CastTargetContainer, (0, $c9bqK.default)({}, tooltipTriggerProps, testId ? {
        'data-testid': "".concat(testId, "--container")
    } : undefined, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent);
    if ((0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) {
        var _apiRef$current$mouse, _apiRef$current8;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, trigger, shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($cbad8245ea9d1ed4$var$TopLayerTooltipPopup, {
            targetRef: targetRef,
            tooltipPosition: tooltipPosition,
            mousePos: (_apiRef$current$mouse = (_apiRef$current8 = apiRef.current) === null || _apiRef$current8 === void 0 ? void 0 : _apiRef$current8.mousePos) !== null && _apiRef$current$mouse !== void 0 ? _apiRef$current$mouse : undefined,
            position: position,
            onMouseOut: onMouseOut,
            onMouseOverTooltip: onMouseOverTooltip,
            ignoreTooltipPointerEvents: ignoreTooltipPointerEvents,
            truncate: truncate,
            testId: testId,
            shortcut: shortcut,
            content: content,
            Container: Container,
            onClose: handlePopoverClose,
            onExitFinish: handleExitFinish,
            isOpen: state !== 'hide' && state !== 'top-layer-exit'
        }) : null);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, trigger, shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(PopperWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $lFMh3.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref6) {
        var ref = _ref6.ref, style = _ref6.style, update = _ref6.update, placement = _ref6.placement;
        var direction = isMousePosition ? undefined : $cbad8245ea9d1ed4$var$invertedDirection[$cbad8245ea9d1ed4$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $dUP6e.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $iAIri.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref7) {
            var className = _ref7.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $cbad8245ea9d1ed4$var$_objectSpread($cbad8245ea9d1ed4$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                shortcut: shortcut
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $cbad8245ea9d1ed4$export$2e2bcd8739ae039 = $cbad8245ea9d1ed4$var$Tooltip;
var $cbad8245ea9d1ed4$var$TooltipPortal = function TooltipPortal(_ref8) {
    var children = _ref8.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $iJAOx.default), {
        zIndex: $cbad8245ea9d1ed4$var$tooltipZIndex
    }, children);
};
var $cbad8245ea9d1ed4$var$tooltipMouseAnimationStyles = {
    enter: "_j7hq1bym",
    exit: "_j7hq1a5s"
};
/**
 * Top-layer tooltip popup component.
 *
 * Composes `Popover` (top-layer visibility + animation) with one of two
 * positioning hooks:
 *
 *   - `useAnchorPositionAtPoint` — for cursor-tracking positions
 *     (`mouse`, `mouse-x`, `mouse-y`) when a cursor position is
 *     available (i.e. the popup was activated by a pointer). Positions
 *     the popover relative to a hidden synthetic anchor that follows
 *     the cursor according to the `position` / `mousePosition`
 *     semantics. The synthetic anchor element is rendered as a sibling
 *     of the popover.
 *   - `useAnchorPosition` directly — for non-cursor positions, AND
 *     for cursor positions activated via keyboard focus (where there
 *     is no cursor to track). Anchoring directly to the trigger keeps
 *     keyboard-activated tooltips correctly placed next to the target
 *     instead of rendering in the top-left of the viewport.
 *
 * Exactly one positioning strategy is active at a time: `useAnchorPosition`
 * is wired to the trigger only when the mouse strategy is inactive, and
 * `useAnchorPositionAtPoint` is told `isActive: false` when the direct
 * anchor strategy is active. The other hook is still called (Rules of
 * Hooks) but does no work.
 *
 * Exit animation is handled by `Popover`'s `isOpen` prop. When `isOpen`
 * transitions to `false`, the primitive calls `hidePopover()` internally and
 * the CSS exit animation plays via `allow-discrete`. No glue code needed.
 */ function $cbad8245ea9d1ed4$var$TopLayerTooltipPopup(_ref9) {
    var targetRef = _ref9.targetRef, tooltipPosition = _ref9.tooltipPosition, mousePos = _ref9.mousePos, position = _ref9.position, onMouseOut = _ref9.onMouseOut, onMouseOverTooltip = _ref9.onMouseOverTooltip, ignoreTooltipPointerEvents = _ref9.ignoreTooltipPointerEvents, truncate = _ref9.truncate, testId = _ref9.testId, shortcut = _ref9.shortcut, content = _ref9.content, Container = _ref9.Container, onClose = _ref9.onClose, onExitFinish = _ref9.onExitFinish, isOpen = _ref9.isOpen;
    var popoverRef = (0, $1oC0p.useRef)(null);
    // Translate the legacy Popper-style placement string ("right",
    // "bottom-start", etc.) once and pass the same object to both hooks.
    var placement = (0, $jp38o.fromLegacyPlacement)({
        legacy: tooltipPosition
    });
    var isMousePosition = position === 'mouse' || position === 'mouse-x' || position === 'mouse-y';
    var isMouseStrategyActive = isMousePosition && Boolean(mousePos);
    // Direct anchor strategy: anchors to the trigger element.
    // Disabled when the mouse strategy is active — both hooks writing
    // to the same popover would fight for positioning ownership.
    (0, $iQsXC.useAnchorPosition)({
        anchorRef: targetRef,
        popoverRef: popoverRef,
        placement: placement,
        isEnabled: !isMouseStrategyActive,
        isOpen: isOpen
    });
    // Mouse anchor strategy: the hook calls `getPoint()` exactly once
    // per activation and latches the resulting coordinate. The latch is
    // per-show because `TopLayerTooltipPopup` mounts fresh on every
    // show.
    //
    // `getPoint()` returns `null` for keyboard-activated shows (where
    // `mousePos` is undefined) or before the trigger has mounted —
    // leaving the direct strategy above to own positioning.
    //
    // SSR note: `getBoundingClientRect()` is only called here because
    // `TopLayerTooltipPopup` is gated behind client-only state
    // transitions.
    (0, $ik7PK.useAnchorPositionAtPoint)({
        popoverRef: popoverRef,
        placement: placement,
        isEnabled: isMouseStrategyActive,
        isOpen: isOpen,
        getPoint: function getPoint() {
            if (!mousePos || !targetRef.current || !isMousePosition) return null;
            return (0, $hbilF.getAnchorPoint)({
                cursor: mousePos,
                triggerRect: targetRef.current.getBoundingClientRect(),
                tooltipPosition: position,
                placement: placement
            });
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $2chlf.Popover), {
        ref: popoverRef,
        role: "tooltip",
        mode: "hint",
        isOpen: isOpen,
        onClose: onClose,
        onExitFinish: onExitFinish,
        testId: testId ? "".concat(testId, "--popover") : undefined,
        shouldAnimate: true,
        enteringAnimationXcss: isMouseStrategyActive && $cbad8245ea9d1ed4$var$tooltipMouseAnimationStyles.enter,
        exitingAnimationXcss: isMouseStrategyActive && $cbad8245ea9d1ed4$var$tooltipMouseAnimationStyles.exit,
        placement: placement
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Container, {
        className: "Tooltip",
        style: ignoreTooltipPointerEvents ? {
            pointerEvents: 'none'
        } : undefined,
        truncate: truncate,
        placement: tooltipPosition,
        testId: testId,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOverTooltip,
        shortcut: shortcut,
        role: "presentation"
    }, typeof content === 'function' ? content({
        update: (0, $7uNuF.default)
    }) : content));
}

});
parcelRegister("iIKkf", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", function () { return $da10455b33f295cb$export$1a04351537078b55; });

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $7AHLK = parcelRequire("7AHLK");

var $faiHG = parcelRequire("faiHG");
function $da10455b33f295cb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $da10455b33f295cb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $da10455b33f295cb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $da10455b33f295cb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $da10455b33f295cb$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $7AHLK.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $faiHG.useTrackedRef)(analyticsData);
    var fnRef = (0, $faiHG.useTrackedRef)(fn);
    var handler = (0, $1oC0p.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $da10455b33f295cb$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("4P6qn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3830e897c93da10e$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $lv5Ml = parcelRequire("lv5Ml");
function $3830e897c93da10e$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $1oC0p.useRef)(false);
    var onKeyDown = (0, $1oC0p.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $lv5Ml.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $1oC0p.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $1oC0p.useEffect)(function() {
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled) return;
        return (0, $dH1HR.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

});
parcelRegister("lv5Ml", function(module, exports) {
$parcel$export(module.exports, "KEY_UP", function () { return $fa70f9c343cd9b8a$export$390330c10ff2b9a1; });
$parcel$export(module.exports, "KEY_DOWN", function () { return $fa70f9c343cd9b8a$export$a80636c6f41931fe; });
$parcel$export(module.exports, "KEY_LEFT", function () { return $fa70f9c343cd9b8a$export$fc4577f2a2af0ae3; });
$parcel$export(module.exports, "KEY_RIGHT", function () { return $fa70f9c343cd9b8a$export$c40f9845adc73fb5; });
$parcel$export(module.exports, "KEY_HOME", function () { return $fa70f9c343cd9b8a$export$4af703091671bc; });
$parcel$export(module.exports, "KEY_END", function () { return $fa70f9c343cd9b8a$export$e2bc30913faa5db7; });
$parcel$export(module.exports, "KEY_TAB", function () { return $fa70f9c343cd9b8a$export$10f6869ed0a7d75b; });
$parcel$export(module.exports, "KEY_ENTER", function () { return $fa70f9c343cd9b8a$export$8152f929a25a0ff4; });
$parcel$export(module.exports, "KEY_SPACE", function () { return $fa70f9c343cd9b8a$export$e51a3576c045c8d5; });
$parcel$export(module.exports, "ESCAPE", function () { return $fa70f9c343cd9b8a$export$2bb790b9008907b4; });
/**
 * Character key codes which can be used in keyboard events.
 */ var $fa70f9c343cd9b8a$export$390330c10ff2b9a1 = 'ArrowUp';
var $fa70f9c343cd9b8a$export$a80636c6f41931fe = 'ArrowDown';
var $fa70f9c343cd9b8a$export$fc4577f2a2af0ae3 = 'ArrowLeft';
var $fa70f9c343cd9b8a$export$c40f9845adc73fb5 = 'ArrowRight';
var $fa70f9c343cd9b8a$export$4af703091671bc = 'Home';
var $fa70f9c343cd9b8a$export$e2bc30913faa5db7 = 'End';
var $fa70f9c343cd9b8a$export$10f6869ed0a7d75b = 'Tab';
var $fa70f9c343cd9b8a$export$8152f929a25a0ff4 = 'Enter';
var $fa70f9c343cd9b8a$export$e51a3576c045c8d5 = 'Space';
var $fa70f9c343cd9b8a$export$2bb790b9008907b4 = 'Escape';

});


parcelRegister("5l9My", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3e36806bbfaf2046$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
function $3e36806bbfaf2046$export$2e2bcd8739ae039(value) {
    var ref = (0, $1oC0p.useRef)(value);
    (0, $1oC0p.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("lFMh3", function(module, exports) {
$parcel$export(module.exports, "Popper", function () { return $fc72df841a7fe791$export$badac9ada3a0bdf9; });

var $lFOXD = parcelRequire("lFOXD");

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $eVddu = parcelRequire("eVddu");

var $6ur0l = parcelRequire("6ur0l");

var $gaoOw = parcelRequire("gaoOw");

var $Iz0N2 = parcelRequire("Iz0N2");

// Export types from PopperJS / React Popper
var $fc72df841a7fe791$var$viewportPadding = 5;
var $fc72df841a7fe791$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $fc72df841a7fe791$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $fc72df841a7fe791$var$defaultChildrenFn() {
    return null;
}
var $fc72df841a7fe791$var$defaultOffset = [
    0,
    8
];
function $fc72df841a7fe791$export$badac9ada3a0bdf9(_ref) {
    var children = _ref.children, offset = _ref.offset, placement = _ref.placement, referenceElement = _ref.referenceElement, modifiers = _ref.modifiers, strategy = _ref.strategy, shouldFitViewport = _ref.shouldFitViewport;
    // The FF check sits at the very top of the public Popper so the
    // rest of the function (which has its own hooks) does not violate
    // the rules of hooks. Each branch is its own component with its
    // own complete hook order. Props are forwarded explicitly to
    // satisfy `no-unsafe-spread-props`.
    if ((0, $6ur0l.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $Iz0N2.PopperTopLayer), {
        children: children,
        offset: offset,
        placement: placement,
        referenceElement: referenceElement,
        modifiers: modifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($fc72df841a7fe791$var$LegacyPopper, {
        children: children,
        offset: offset,
        placement: placement,
        referenceElement: referenceElement,
        modifiers: modifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    });
}
function $fc72df841a7fe791$var$LegacyPopper(_ref2) {
    var _ref2$children = _ref2.children, children = _ref2$children === void 0 ? $fc72df841a7fe791$var$defaultChildrenFn : _ref2$children, _ref2$offset = _ref2.offset, offset = _ref2$offset === void 0 ? $fc72df841a7fe791$var$defaultOffset : _ref2$offset, _ref2$placement = _ref2.placement, placement = _ref2$placement === void 0 ? 'bottom-start' : _ref2$placement, _ref2$referenceElemen = _ref2.referenceElement, referenceElement = _ref2$referenceElemen === void 0 ? undefined : _ref2$referenceElemen, modifiers = _ref2.modifiers, _ref2$strategy = _ref2.strategy, strategy = _ref2$strategy === void 0 ? 'fixed' : _ref2$strategy, _ref2$shouldFitViewpo = _ref2.shouldFitViewport, shouldFitViewport = _ref2$shouldFitViewpo === void 0 ? false : _ref2$shouldFitViewpo;
    var _offset = (0, $2qaZZ.default)(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $1oC0p.useMemo)(function() {
        var preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $fc72df841a7fe791$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $gaoOw.getMaxSizeModifiers)({
            viewportPadding: $fc72df841a7fe791$var$viewportPadding
        }) : [];
        return [].concat($fc72df841a7fe791$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, $lFOXD.default)(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $1oC0p.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, $lFOXD.default)(internalModifiers), (0, $lFOXD.default)(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eVddu.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});
parcelRegister("gaoOw", function(module, exports) {
$parcel$export(module.exports, "getMaxSizeModifiers", function () { return $bc50d4073cb1a3f6$export$6d8c2b45c99d6e3f; });

var $2qaZZ = parcelRequire("2qaZZ");
function $bc50d4073cb1a3f6$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== 'number' || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split('-'), _state$placement$spli2 = (0, $2qaZZ.default)(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}

});

parcelRegister("Iz0N2", function(module, exports) {
$parcel$export(module.exports, "PopperTopLayer", function () { return $085f44c71f033a2e$export$9802f50720ab826e; });
/* popper-top-layer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $2qaZZ = parcelRequire("2qaZZ");


var $1oC0p = parcelRequire("1oC0p");

var $7uNuF = parcelRequire("7uNuF");

var $jp38o = parcelRequire("jp38o");

var $2chlf = parcelRequire("2chlf");

var $iQsXC = parcelRequire("iQsXC");

var $ik7PK = parcelRequire("ik7PK");

var $8mOPg = parcelRequire("8mOPg");

var $2oBVx = parcelRequire("2oBVx");

var $Din8a = parcelRequire("Din8a");

var $fa33e = parcelRequire("fa33e");

var $d4haZ = parcelRequire("d4haZ");

var $aunCi = parcelRequire("aunCi");

var $aKkpJ = parcelRequire("aKkpJ");

var $grvl6 = parcelRequire("grvl6");
/**
 * Inert render-prop values. The browser owns positioning under CSS Anchor
 * Positioning, so `style` / `ref` / `arrowProps` / `update` / `forceUpdate`
 * are no-ops that consumers can safely spread. Module scope keeps identities
 * stable for effect dep arrays.
 */ var $085f44c71f033a2e$var$noopStyle = {};
var $085f44c71f033a2e$var$noopSetRef = (0, $7uNuF.default);
var $085f44c71f033a2e$var$noopUpdate = function noopUpdate() {
    return Promise.resolve(null);
};
var $085f44c71f033a2e$var$noopForceUpdate = function noopForceUpdate() {
    return {};
};
/**
 * `react-popper` stamps `data-popper-arrow` on the arrow element at runtime
 * but does not declare it on `arrowProps`. Widen the type so consumers that
 * rely on the attribute (CSS selectors, snapshots, tests) keep working.
 */ var $085f44c71f033a2e$var$noopArrowProps = {
    ref: $085f44c71f033a2e$var$noopSetRef,
    style: $085f44c71f033a2e$var$noopStyle,
    'data-popper-arrow': true
};
/**
 * Returns the primary axis (`top` / `bottom` / `left` / `right`) of a popper
 * placement, used to pick which axis `useFitViewportMaxSize` caps to the
 * anchor edge.
 */ function $085f44c71f033a2e$var$getPlacementAxis(placement) {
    if (placement.startsWith('top')) return 'top';
    if (placement.startsWith('bottom')) return 'bottom';
    if (placement.startsWith('left')) return 'left';
    if (placement.startsWith('right')) return 'right';
    // `auto*` placements have no fixed axis. Default to `bottom` to match the
    // `auto -> block-end` mapping in `fromLegacyPlacement`.
    return 'bottom';
}
/**
 * Normalises popper's `[along, away]` offset (which may include `null` or
 * `undefined` entries) into the `[along, away]` number tuple
 * `fromLegacyPlacement` expects.
 */ function $085f44c71f033a2e$var$popperToTopLayerOffset(offset) {
    if (!offset) return undefined;
    var _offset = (0, $2qaZZ.default)(offset, 2), along = _offset[0], away = _offset[1];
    if (along == null && away == null) return undefined;
    return [
        along !== null && along !== void 0 ? along : 0,
        away !== null && away !== void 0 ? away : 0
    ];
}
function $085f44c71f033a2e$export$9802f50720ab826e(_ref) {
    var _ref2;
    var children = _ref.children, offset = _ref.offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, referenceElement = _ref.referenceElement, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    // `modifiers` and `strategy` are accepted for source compatibility but have
    // no runtime effect; CSS Anchor Positioning + top-layer rendering replaces
    // them. See `top-layer/notes/migrations/popper-migration.md`.
    // Anchor resolution: `referenceElement` prop, then `<Manager>` context.
    var managerAnchor = (0, $aKkpJ.useManagerAnchor)();
    var effectiveReference = (_ref2 = referenceElement !== null && referenceElement !== void 0 ? referenceElement : managerAnchor) !== null && _ref2 !== void 0 ? _ref2 : undefined;
    // Real DOM nodes go to `useAnchorPosition`; popper `VirtualElement`s are
    // bridged through `useAnchorPositionAtPoint`, which owns its own synthetic
    // anchor.
    var htmlAnchor = effectiveReference instanceof HTMLElement ? effectiveReference : null;
    var virtualReference = effectiveReference != null && !(effectiveReference instanceof HTMLElement) ? effectiveReference : null;
    var htmlAnchorRef = (0, $1oC0p.useRef)(htmlAnchor);
    htmlAnchorRef.current = htmlAnchor;
    var popoverRef = (0, $1oC0p.useRef)(null);
    var popoverId = (0, $8mOPg.usePopoverId)();
    // Track the resolved DOM anchor in state so visibility / max-size hooks
    // re-run when its identity changes. Virtual anchors do not feed these
    // hooks because their probe is outside the consumer's DOM.
    //
    // Adjust state during render by comparing against the state itself: the
    // conditional guard means `setResolvedAnchor` is skipped once they match,
    // so it converges in one extra render. This is the React-documented pattern
    // and is side-effect-free — no ref mutation during render.
    var _useState = (0, $1oC0p.useState)(htmlAnchor), _useState2 = (0, $2qaZZ.default)(_useState, 2), resolvedAnchor = _useState2[0], setResolvedAnchor = _useState2[1];
    if (resolvedAnchor !== htmlAnchor) setResolvedAnchor(htmlAnchor);
    var topLayerPlacement = (0, $1oC0p.useMemo)(function() {
        return (0, $jp38o.fromLegacyPlacement)({
            legacy: (0, $d4haZ.toLegacyPlacement)(placement),
            offset: $085f44c71f033a2e$var$popperToTopLayerOffset(offset)
        });
    }, [
        placement,
        offset
    ]);
    var isOpen = effectiveReference != null;
    // HTML-element path. No-op when the reference is virtual or absent.
    (0, $iQsXC.useAnchorPosition)({
        anchorRef: htmlAnchorRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isEnabled: htmlAnchor != null,
        isOpen: isOpen
    });
    // Virtual-element path. `useAnchorPositionAtPoint` owns a synthetic
    // anchor in `document.body` and latches `getPoint` once per
    // `isEnabled` activation. Reading the latest `virtualReference` and
    // `topLayerPlacement` via refs ensures the latched closure always
    // sees the current values rather than the ones captured at first
    // activation, which would otherwise go stale if either prop changes
    // while the popper stays open.
    var virtualReferenceRef = (0, $1oC0p.useRef)(virtualReference);
    virtualReferenceRef.current = virtualReference;
    var topLayerPlacementRef = (0, $1oC0p.useRef)(topLayerPlacement);
    topLayerPlacementRef.current = topLayerPlacement;
    var isVirtualEnabled = virtualReference != null;
    (0, $ik7PK.useAnchorPositionAtPoint)({
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isEnabled: isVirtualEnabled,
        isOpen: isOpen,
        getPoint: function getPoint() {
            var current = virtualReferenceRef.current;
            if (!current) return null;
            return (0, $fa33e.rectPointForPlacement)({
                rect: current.getBoundingClientRect(),
                placement: topLayerPlacementRef.current,
                isRtl: (0, $Din8a.isPageRtl)()
            });
        }
    });
    var _useReferenceVisibili = (0, $grvl6.useReferenceVisibility)({
        anchor: resolvedAnchor,
        popoverRef: popoverRef
    }), isReferenceHidden = _useReferenceVisibili.isReferenceHidden, hasPopperEscaped = _useReferenceVisibili.hasPopperEscaped;
    // Restore legacy `react-popper`'s natural-width behaviour. Under CSS
    // Anchor Positioning the `position-area` grid cell becomes the popover
    // host's containing block, so an auto-width host shrinks to that cell.
    // When the anchor sits near a viewport edge the cell is narrow, so the
    // content wraps far more than it did under `react-popper` (which kept the
    // content's natural width and shifted/flipped to stay on screen).
    // `min-inline-size: max-content` (mode `'none'`) floors the host at its
    // content's intrinsic width, so a too-narrow span overflows the viewport
    // (driving `position-try-fallbacks`) instead of wrapping. This is safe
    // alongside `shouldFitViewport`: the fit caps clamp the host on both axes,
    // so the host never exceeds the viewport / anchor-edge cap.
    (0, $2oBVx.useWidthFromAnchor)({
        mode: 'none',
        popoverRef: popoverRef,
        anchorRef: htmlAnchorRef,
        isOpen: isOpen
    });
    // `shouldFitViewport` caps are applied directly to the `position-area`
    // host, whose containing block is the cell between the anchor edge and the
    // viewport edge — so a pure-CSS `calc(100% - 5px - gap)` reproduces the
    // legacy per-placement anchor-edge cap with no measurement. The gap mirrors
    // `getPlacement`: an omitted offset resolves to `space.100`, otherwise the
    // consumer's `away` value.
    var resolvedOffset = $085f44c71f033a2e$var$popperToTopLayerOffset(offset);
    var fitGap = resolvedOffset ? "".concat(resolvedOffset[1], "px") : "var(--ds-space-100, 8px)";
    var placementAxis = $085f44c71f033a2e$var$getPlacementAxis(placement);
    (0, $aunCi.useFitViewportMaxSize)({
        target: popoverRef,
        placementAxis: placementAxis,
        gap: fitGap,
        isEnabled: shouldFitViewport,
        isOpen: isOpen
    });
    var renderChildren = children;
    if (typeof renderChildren !== 'function') return null;
    var renderPropArg = {
        ref: $085f44c71f033a2e$var$noopSetRef,
        style: $085f44c71f033a2e$var$noopStyle,
        placement: placement,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped,
        update: $085f44c71f033a2e$var$noopUpdate,
        forceUpdate: $085f44c71f033a2e$var$noopForceUpdate,
        arrowProps: $085f44c71f033a2e$var$noopArrowProps
    };
    var content = renderChildren(renderPropArg);
    // The `shouldFitViewport` size caps live on the `<Popover>` host itself
    // (applied by `useFitViewportMaxSize` above), so the consumer's content is
    // rendered directly with no intermediate wrapper.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $2chlf.Popover), {
        ref: popoverRef,
        id: popoverId,
        isOpen: isOpen,
        mode: "manual",
        shouldAnimate: false
    }, content);
}

});
parcelRegister("jp38o", function(module, exports) {
$parcel$export(module.exports, "fromLegacyPlacement", function () { return $e202c88e96585d8d$export$69e99ed50b2534c9; });

var $f53LC = parcelRequire("f53LC");

var $2qaZZ = parcelRequire("2qaZZ");

var $1k40X = parcelRequire("1k40X");
function $e202c88e96585d8d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e202c88e96585d8d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e202c88e96585d8d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e202c88e96585d8d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e202c88e96585d8d$export$69e99ed50b2534c9(_ref) {
    var legacy = _ref.legacy, offset = _ref.offset;
    var basePlacement = (0, $1k40X.placementMapping)[legacy];
    if (!offset) return basePlacement;
    var _offset = (0, $2qaZZ.default)(offset, 2), along = _offset[0], away = _offset[1];
    return $e202c88e96585d8d$var$_objectSpread($e202c88e96585d8d$var$_objectSpread({}, basePlacement), {}, {
        offset: {
            gap: away,
            crossAxisShift: {
                // Sign is captured in `direction`; `value` is the magnitude.
                value: Math.abs(along),
                direction: along >= 0 ? 'forwards' : 'backwards'
            }
        }
    });
}

});
parcelRegister("1k40X", function(module, exports) {
$parcel$export(module.exports, "placementMapping", function () { return $0f6ac5ddb11ff824$export$27df359c528b7120; });
/**
 * The full mapping record. Internal - use `fromLegacyPlacement` from the
 * public entry-point so the offset-tuple translation is applied consistently.
 *
 * Note: `auto`, `auto-start`, `auto-end` map to `block-end` placements. This
 * is a reduction in expressiveness vs Popper.js (which picked the best
 * placement at runtime). CSS `position-try-fallbacks` flips at the edge but
 * the initial placement is fixed. Migration consumers who relied on Popper's
 * dynamic auto-flip should pick an explicit placement instead.
 */ var $0f6ac5ddb11ff824$export$27df359c528b7120 = {
    top: {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-start': {
        axis: 'block',
        edge: 'start',
        align: 'start'
    },
    'top-center': {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-end': {
        axis: 'block',
        edge: 'start',
        align: 'end'
    },
    bottom: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'bottom-center': {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    },
    right: {
        axis: 'inline',
        edge: 'end',
        align: 'center'
    },
    'right-start': {
        axis: 'inline',
        edge: 'end',
        align: 'start'
    },
    'right-end': {
        axis: 'inline',
        edge: 'end',
        align: 'end'
    },
    left: {
        axis: 'inline',
        edge: 'start',
        align: 'center'
    },
    'left-start': {
        axis: 'inline',
        edge: 'start',
        align: 'start'
    },
    'left-end': {
        axis: 'inline',
        edge: 'start',
        align: 'end'
    },
    auto: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'auto-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'auto-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    }
};

});


parcelRegister("2chlf", function(module, exports) {
$parcel$export(module.exports, "Popover", function () { return $199a2770e7b2e554$export$5b6b19405a83ff9d; });
/* popover.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $3sHnI = parcelRequire("3sHnI");

var $dH1HR = parcelRequire("dH1HR");

var $kPutE = parcelRequire("kPutE");

var $8zODL = parcelRequire("8zODL");

var $hW0q0 = parcelRequire("hW0q0");

var $6Rans = parcelRequire("6Rans");

var $bitxd = parcelRequire("bitxd");

var $4Ulob = parcelRequire("4Ulob");

var $211Th = parcelRequire("211Th");

var $3DkPv = parcelRequire("3DkPv");
/**
 * Detects `popover="hint"` support via DOM reflection. SSR-safe, cached.
 */ var $199a2770e7b2e554$var$supportsPopoverHint = (0, $8zODL.default)(function() {
    if (typeof document === 'undefined') return false;
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- feature detection
    var element = document.createElement('div');
    element.setAttribute('popover', 'hint');
    return element.popover === 'hint';
});
// Surface reset — neutralises inherited interaction and text-layout properties
// (e.g. `pointer-events: none` from an overlaid controls container and
// `white-space: nowrap` from an `@atlaskit/select` option) that leak into a
// top-layer element because, for CSS inheritance, it is still a DOM child of its
// trigger (top-layer promotion is paint/stacking only; the legacy portal path
// avoided this by rendering at `<body>`). Excludes `color`/`font` (theming) and
// `direction`/`unicode-bidi` (RTL must inherit).
//
// KEEP IN SYNC with the identical `surfaceResetStyles` in `dialog/dialog-content.tsx`.
// ADS forbids sharing styles across files (`no-exported-styles` /
// `no-imported-style-values` — Compiled styles are null at runtime), so the reset is
// co-located and duplicated deliberately.
var $199a2770e7b2e554$var$surfaceResetStyles = {
    root: "_lcxv1wug _o5724jg8 _1nmz4jg8 _1i4q4jg8 _y3gnv2br _azhwidpf _1p1dglyw"
};
var $199a2770e7b2e554$var$styles = {
    root: "_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1r041wug _1reoewfl _18m9ewfl _bfhk1j28 _4t3i1wug",
    motion: "_k8m011k7 _1oecdn4k _1s9z1a5r _1o511hrf _bl8aglyw _156y147i",
    enter: "_y44v179n",
    exit: "_y44vof1f"
};
// Intentionally using `Record<string, string>` instead of `React.CSSProperties`
// to avoid type errors about the CSS variables not being valid property names
var $199a2770e7b2e554$var$popupMotionStyles = {
    block: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    },
    inline: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    }
};
/**
 * Roles registered with the open layer observer as `popup`, so `closeLayers()`
 * dismisses them. `modal` comes from Dialog only; other layer types are unused.
 */ var $199a2770e7b2e554$var$POPUP_ROLES = new Set([
    'menu',
    'listbox',
    'dialog',
    'alertdialog',
    'tree',
    'grid'
]);
var $199a2770e7b2e554$export$5b6b19405a83ff9d = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function Popover(_ref, ref) {
    var children = _ref.children, _ref$mode = _ref.mode, modeProp = _ref$mode === void 0 ? 'auto' : _ref$mode, onClose = _ref.onClose, onEnterFinish = _ref.onEnterFinish, onExitFinish = _ref.onExitFinish, _ref$shouldAnimate = _ref.shouldAnimate, shouldAnimate = _ref$shouldAnimate === void 0 ? false : _ref$shouldAnimate, placement = _ref.placement, testId = _ref.testId, isOpen = _ref.isOpen, enteringAnimationXcss = _ref.enteringAnimationXcss, exitingAnimationXcss = _ref.exitingAnimationXcss, role = _ref.role, label = _ref.label, labelledBy = _ref.labelledBy, idProp = _ref.id;
    var autoId = (0, $1oC0p.useId)();
    var ownRef = (0, $1oC0p.useRef)(null);
    var combinedRef = (0, $kPutE.default)([
        ownRef,
        ref
    ].filter(Boolean));
    // `useId()` colons are invalid in CSS selectors and popover target attributes.
    var popoverId = idProp !== null && idProp !== void 0 ? idProp : "popover-".concat(autoId.replace(/:/g, ''));
    var _useAnimatedVisibilit = (0, $4Ulob.useAnimatedVisibility)({
        isOpen: isOpen,
        shouldAnimate: shouldAnimate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    }), phase = _useAnimatedVisibilit.phase, onToggle = _useAnimatedVisibilit.onToggle;
    // True while the host element is mounted (any phase except `closed`).
    // Used as a dep so listener-rebind effects re-attach after a remount.
    var isVisible = phase !== 'closed';
    // Focus management: initial focus on entry (role-dependent), Tab cycling
    // for dialog roles. Restoration is native for outermost popovers; nested
    // focus-capturing roles are handled below via the `beforetoggle` snapshot.
    // Passing `phase` keeps `useFocusWrap` attached through the animated-exit
    // window (WCAG 2.4.3 guard). See notes/architecture/focus-restoration.md.
    (0, $211Th.useFocusWrap)({
        elementRef: ownRef,
        role: role,
        phase: phase
    });
    (0, $3DkPv.useInitialFocus)({
        elementRef: ownRef,
        phase: phase,
        role: role
    });
    // Register with open layer observer so `closeLayers()` and open-count
    // subscriptions work. Only popup-like roles register as `popup`; passive
    // roles (tooltip, status, etc.) leave `type` undefined.
    var handleObserverClose = (0, $1oC0p.useCallback)(function() {
        onClose === null || onClose === void 0 || onClose({
            reason: 'programmatic'
        });
    }, [
        onClose
    ]);
    (0, $hW0q0.useNotifyOpenLayerObserver)({
        type: role && $199a2770e7b2e554$var$POPUP_ROLES.has(role) ? 'popup' : undefined,
        isOpen: isOpen,
        onClose: handleObserverClose
    });
    // `hint` falls back to `auto` when unsupported: closest behavior (light
    // dismiss works), but `auto` participates in the auto-dismiss stack so it
    // will close other `auto` popovers when opened. Acceptable trade-off given
    // shrinking browser set without `hint` support.
    var mode = modeProp === 'hint' && !$199a2770e7b2e554$var$supportsPopoverHint() ? 'auto' : modeProp;
    var popupMotionStyle = (0, $1oC0p.useMemo)(function() {
        if (!placement || !shouldAnimate) return undefined;
        var _resolvePlacement = (0, $6Rans.resolvePlacement)({
            placement: placement
        }), axis = _resolvePlacement.axis, edge = _resolvePlacement.edge;
        return $199a2770e7b2e554$var$popupMotionStyles[axis][edge];
    }, [
        placement,
        shouldAnimate
    ]);
    // Prevents toggle handler from calling onClose for our own hidePopover() calls.
    var programmaticCloseRef = (0, $1oC0p.useRef)(false);
    // Set in capture-phase keydown so the toggle handler knows close reason.
    var closeReasonRef = (0, $1oC0p.useRef)('light-dismiss');
    // Snapshot of pre-open focus, used to restore focus for nested popovers
    // with focus-capturing roles (browser only restores the outermost).
    var previouslyFocusedElementRef = (0, $1oC0p.useRef)(null);
    var handleBeforeToggle = (0, $1oC0p.useCallback)(function(event) {
        if (event.newState !== 'open') return;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- need active element snapshot
        var active = document.activeElement;
        previouslyFocusedElementRef.current = active instanceof HTMLElement ? active : null;
    }, []);
    var handleToggle = (0, $1oC0p.useCallback)(function(event) {
        var element = ownRef.current;
        if (event.newState === 'open') {
            onToggle(event);
            return;
        }
        if (event.newState === 'closed') {
            if (element) {
                // Nested-popover focus restoration fallback (browser only
                // restores outermost; Firefox skips nested entirely).
                // Restore only when the role moved focus in on open AND the
                // close was Escape/programmatic. For light dismiss, the
                // click target keeps focus per HTML spec
                // (`focusPreviousElement=false`).
                var previouslyFocused = previouslyFocusedElementRef.current;
                var reason = closeReasonRef.current;
                var isProgrammatic = programmaticCloseRef.current;
                var shouldRestore = previouslyFocused !== null && previouslyFocused.isConnected && (0, $bitxd.shouldFocusIntoPopover)({
                    role: role
                }) && (reason === 'escape' || isProgrammatic);
                if (shouldRestore && previouslyFocused) previouslyFocused.focus({
                    preventScroll: true
                });
                previouslyFocusedElementRef.current = null;
            }
            // Programmatic close: consumer already knows.
            if (programmaticCloseRef.current) // Reset reason so a stale 'escape' from a race with Escape keydown
            // does not corrupt the next browser-dismiss cycle.
            closeReasonRef.current = 'light-dismiss';
            else {
                // Browser dismiss (Escape/click-outside).
                var _reason = closeReasonRef.current;
                closeReasonRef.current = 'light-dismiss';
                // Optional: `manual` mode has no `onClose` in the forwarded type.
                onClose === null || onClose === void 0 || onClose({
                    reason: _reason
                });
            }
        }
        onToggle(event);
    }, [
        onClose,
        onToggle,
        role
    ]);
    // Bind via `useLayoutEffect`, and BEFORE the show/hide layout effect
    // below, so listeners are attached when `showPopover()` synchronously
    // dispatches `beforetoggle`. A regular `useEffect` would miss that
    // first dispatch, dropping the `previouslyFocusedElementRef` snapshot
    // and breaking nested-popover focus restoration on close. React runs
    // layout effects in source order on the same commit.
    (0, $1oC0p.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        // Tag Escape before the browser processes light dismiss.
        var unbindEscape = (0, $dH1HR.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key === 'Escape') closeReasonRef.current = 'escape';
            },
            options: {
                capture: true
            }
        });
        var unbindToggle = (0, $dH1HR.bind)(element, {
            type: 'toggle',
            listener: handleToggle
        });
        // Snapshot `document.activeElement` before `useInitialFocus` moves it.
        var unbindBeforeToggle = (0, $dH1HR.bind)(element, {
            type: 'beforetoggle',
            listener: handleBeforeToggle
        });
        return function() {
            unbindEscape();
            unbindToggle();
            unbindBeforeToggle();
        };
    }, [
        handleToggle,
        handleBeforeToggle,
        isVisible
    ]);
    // Show/hide based on isOpen. `showPopover`/`hidePopover` are no-ops when
    // already in the target state. Try/catch guards `InvalidStateError` on
    // disconnected elements (StrictMode/concurrent/unmount edge cases).
    (0, $1oC0p.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        if (isOpen) {
            programmaticCloseRef.current = false;
            // Clear stale 'escape' from a prior cycle: the ref outlives
            // the host element, and the no-animation path unmounts before
            // `handleToggle` can reset it.
            closeReasonRef.current = 'light-dismiss';
            try {
                element.showPopover();
            } catch (_unused) {}
            return function() {
                programmaticCloseRef.current = true;
                try {
                    element.hidePopover();
                } catch (_unused2) {}
            };
        }
        programmaticCloseRef.current = true;
        try {
            element.hidePopover();
        } catch (_unused3) {}
    }, [
        isOpen
    ]);
    // Unmount the host once exit completes so it does not leave an empty
    // `role`/`popover` element in the accessibility tree. The element
    // remounts on the next open; the `popoverId` is stable across opens.
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        ref: combinedRef,
        id: popoverId,
        popover: mode,
        role: role,
        "aria-label": label,
        "aria-labelledby": labelledBy,
        "data-testid": testId,
        style: popupMotionStyle,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $2jatx.default)([
            $199a2770e7b2e554$var$styles.root,
            $199a2770e7b2e554$var$surfaceResetStyles.root,
            shouldAnimate && phase === 'entering' && $199a2770e7b2e554$var$styles.enter,
            shouldAnimate && phase === 'exiting' && $199a2770e7b2e554$var$styles.exit,
            shouldAnimate && $199a2770e7b2e554$var$styles.motion,
            (0, $3sHnI.cx)(shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)
        ])
    }, children);
});

});
parcelRegister("6Rans", function(module, exports) {
$parcel$export(module.exports, "resolvePlacement", function () { return $4fdfbe0e59c57ddf$export$63044d21bc3d3fa2; });

var $lyGFl = parcelRequire("lyGFl");
/**
 * Default gap between trigger and popover. Resolves to a design
 * token (`space.100`) so the value follows the design system's spacing
 * scale. Used when `placement.offset.gap` is not provided.
 */ var $4fdfbe0e59c57ddf$var$DEFAULT_GAP = "var(--ds-space-100, 8px)";
function $4fdfbe0e59c57ddf$export$63044d21bc3d3fa2(_ref) {
    var _placement$offset, _placement$axis, _placement$edge, _placement$align, _placement$offset$cro, _placement$offset2, _placement$offset$cro2, _placement$offset3;
    var placement = _ref.placement;
    var consumerGap = (_placement$offset = placement.offset) === null || _placement$offset === void 0 ? void 0 : _placement$offset.gap;
    return {
        axis: (_placement$axis = placement.axis) !== null && _placement$axis !== void 0 ? _placement$axis : 'block',
        edge: (_placement$edge = placement.edge) !== null && _placement$edge !== void 0 ? _placement$edge : 'end',
        align: (_placement$align = placement.align) !== null && _placement$align !== void 0 ? _placement$align : 'center',
        offset: {
            gap: consumerGap === undefined ? $4fdfbe0e59c57ddf$var$DEFAULT_GAP : (0, $lyGFl.toCssLengthString)({
                value: consumerGap
            }),
            crossAxisShift: {
                value: (0, $lyGFl.toCssLengthString)({
                    value: (_placement$offset$cro = (_placement$offset2 = placement.offset) === null || _placement$offset2 === void 0 || (_placement$offset2 = _placement$offset2.crossAxisShift) === null || _placement$offset2 === void 0 ? void 0 : _placement$offset2.value) !== null && _placement$offset$cro !== void 0 ? _placement$offset$cro : 0
                }),
                direction: (_placement$offset$cro2 = (_placement$offset3 = placement.offset) === null || _placement$offset3 === void 0 || (_placement$offset3 = _placement$offset3.crossAxisShift) === null || _placement$offset3 === void 0 ? void 0 : _placement$offset3.direction) !== null && _placement$offset$cro2 !== void 0 ? _placement$offset$cro2 : 'forwards'
            }
        }
    };
}

});
parcelRegister("lyGFl", function(module, exports) {
$parcel$export(module.exports, "toCssLengthString", function () { return $fb1dde7bbf59050f$export$63b6b0ff65d84d47; });
/**
 * Normalizes an offset to a CSS length string. Numbers become `${n}px`;
 * strings pass through. Apply at the API boundary so internal code only
 * deals with strings.
 */ function $fb1dde7bbf59050f$export$63b6b0ff65d84d47(_ref) {
    var value = _ref.value;
    if (typeof value === 'number') return "".concat(value, "px");
    return value;
}

});


parcelRegister("bitxd", function(module, exports) {
$parcel$export(module.exports, "shouldFocusIntoPopover", function () { return $8398492586bc7ced$export$b12adccf56228c71; });
var $8398492586bc7ced$var$rolesThatMoveFocus = new Set([
    'dialog',
    'alertdialog',
    'menu',
    'listbox',
    'tree',
    'grid'
]);
function $8398492586bc7ced$export$b12adccf56228c71(_ref) {
    var role = _ref.role;
    if (!role) return false;
    return $8398492586bc7ced$var$rolesThatMoveFocus.has(role);
}

});

parcelRegister("3DkPv", function(module, exports) {
$parcel$export(module.exports, "useInitialFocus", function () { return $2a552bfc24859fc8$export$e992c40175757a22; });

var $1oC0p = parcelRequire("1oC0p");

var $2AUaL = parcelRequire("2AUaL");
/**
 * Determines the correct element to receive initial focus within a popover,
 * based on its ARIA role.
 *
 * Focus rules by role (per WAI-ARIA APG):
 * - `dialog` / `alertdialog`: first element with `[autofocus]`, or first focusable element
 * - `menu`: first menu item (`[role="menuitem|menuitemcheckbox|menuitemradio"]`)
 * - `listbox`: first selected option (`[aria-selected="true"]`), or first option (`[role="option"]`)
 * - `tooltip`: no focus movement (tooltips are informational)
 * - no role / other roles: no focus movement
 *
 * Note: React 18's `autoFocus` JSX prop does NOT set the HTML `autofocus`
 * attribute - it only calls `.focus()` imperatively during commit, which
 * has no effect on hidden popover content. Consumers must set the native
 * attribute via a ref callback (e.g. `node.setAttribute('autofocus', '')`).
 * React 19+ reflects the JSX prop as the HTML attribute automatically.
 *
 * Combobox pattern exception: if the popup is controlled by a focused
 * combobox-like trigger (its `aria-controls` references this popup),
 * focus stays on the textbox regardless of role. See
 * `isComboboxControllingPopup`.
 */ /**
 * WAI-ARIA APG Combobox Pattern: when a combobox controls a popup (listbox,
 * grid, tree, or menu), DOM focus must remain on the textbox. Subsequent
 * navigation through popup items uses `aria-activedescendant` (or proxied
 * keyboard events), never DOM focus movement.
 *
 * Detects both variants in a single pass:
 * - In-popup combobox: the textbox lives inside the popup `container`
 *   (the popup is rendered as a child of the combobox wrapper).
 * - External combobox: the textbox is rendered OUTSIDE the popup
 *   (`react-select` pattern, where the listbox is portalled separately
 *   from the textbox).
 *
 * Acceptance criteria for the active element:
 * - Role / element-type filter: `role="combobox"`, `role="textbox"`,
 *   `TEXTAREA`, `contentEditable`, or `INPUT` of text-like type
 *   (`text`, `search`, `email`, `url`, `tel`, `password`, or
 *   unspecified). Non-text input types (`button`, `checkbox`, etc.)
 *   are rejected.
 * - Reference filter: `aria-controls` (or legacy `aria-owns`) IDREFS
 *   must resolve to an element that IS or CONTAINS the popup container.
 *
 * See: https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
 */ // `<input>` types treated as text-like for combobox detection.
// Non-text input types (`button`, `checkbox`, `submit`, etc.) are rejected.
// A missing `type` attribute defaults to `text` per the HTML spec, so we
// normalize that case before lookup rather than including an empty string here.
var $2a552bfc24859fc8$var$TEXT_LIKE_INPUT_TYPES = new Set([
    'text',
    'search',
    'email',
    'url',
    'tel',
    'password'
]);
function $2a552bfc24859fc8$var$isTextboxLikeElement(element) {
    var role = element.getAttribute('role');
    if (role === 'combobox' || role === 'textbox') return true;
    // `tagName` is uppercase for HTML elements but can be mixed-case for
    // XML/SVG. Normalize once so downstream comparisons stay lowercase.
    var tag = element.tagName.toLowerCase();
    if (tag === 'textarea') return true;
    if (element.isContentEditable) return true;
    if (tag === 'input') {
        var _element$getAttribute;
        var type = ((_element$getAttribute = element.getAttribute('type')) !== null && _element$getAttribute !== void 0 ? _element$getAttribute : 'text').toLowerCase();
        return $2a552bfc24859fc8$var$TEXT_LIKE_INPUT_TYPES.has(type);
    }
    return false;
}
function $2a552bfc24859fc8$var$isComboboxControllingPopup(_ref) {
    var _active$getAttribute;
    var container = _ref.container;
    var ownerDocument = container.ownerDocument;
    var active = ownerDocument.activeElement;
    if (!(active instanceof HTMLElement)) return false;
    if (!$2a552bfc24859fc8$var$isTextboxLikeElement(active)) return false;
    // Accept legacy `aria-owns` in addition to `aria-controls`.
    // `aria-controls` / `aria-owns` are IDREFS (space-separated list of IDs)
    // per the WAI-ARIA spec, so we must split and check membership rather
    // than comparing with strict equality. A combobox that controls both
    // this popup and another element (e.g. a results status region) must
    // still be recognised as controlling this popup.
    var idRefs = (_active$getAttribute = active.getAttribute('aria-controls')) !== null && _active$getAttribute !== void 0 ? _active$getAttribute : active.getAttribute('aria-owns');
    if (!idRefs) return false;
    // Match if any referenced element IS, CONTAINS, or IS CONTAINED BY the
    // popup container. The "contained by" case covers wrapper-style adopters
    // like react-select, where the combobox input's `aria-controls` points at
    // a listbox element that is a descendant of the Popover host (the
    // listbox role lives on a child the wrapped library owns, not on the
    // host we render).
    var referencedIds = idRefs.split(/\s+/).filter(function(id) {
        return id !== '';
    });
    return referencedIds.some(function(id) {
        var referenced = ownerDocument.getElementById(id);
        if (!referenced) return false;
        return referenced === container || referenced.contains(container) || container.contains(referenced);
    });
}
function $2a552bfc24859fc8$var$getInitialFocusTarget(_ref2) {
    var container = _ref2.container, role = _ref2.role;
    if (role === 'dialog' || role === 'alertdialog') {
        // Prefer element with the native HTML autofocus attribute.
        var autofocusEl = container.querySelector('[autofocus]');
        if (autofocusEl) return autofocusEl;
        // Fall back to first focusable element
        return (0, $2AUaL.getFirstFocusable)({
            container: container
        });
    }
    // The combobox carve-out is kept role-specific (menu / listbox) rather
    // than hoisted. Hoisting it over-matched on dialog popups that contain
    // a nested combobox (e.g. datetime-picker's dialog hosts a react-select),
    // where the active combobox's `aria-controls` falsely matched the
    // container and suppressed the dialog's own focus contract.
    if (role === 'menu') {
        if ($2a552bfc24859fc8$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Initial focus placement is the extent of what top-layer provides
        // for menus. All subsequent keyboard navigation (arrow keys, Home/End,
        // type-ahead, Enter/Space, submenu coordination) is the responsibility
        // of the consumer component (e.g. dropdown-menu), because menu keyboard
        // behavior varies by context (orientation, nesting, item type, control
        // pattern). See: notes/outputs/menu-keyboard-decision.md
        return (0, $2AUaL.getFirstFocusable)({
            container: container
        });
    }
    if (role === 'listbox') {
        // ARIA Combobox Pattern: if a combobox-like textbox owns the popup
        // (in-popup or external e.g. react-select), leave focus on the
        // textbox - navigation is proxied through it.
        if ($2a552bfc24859fc8$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Prefer the selected option, then fall back to the first option.
        // We intentionally match by `[role="option"]` rather than by
        // `getFirstFocusable`. The standard WAI-ARIA APG listbox pattern
        // renders options with `tabindex="-1"` (managed via roving
        // tabindex); `getFirstFocusable` excludes `tabindex="-1"` elements
        // and would silently lose initial focus for spec-conformant
        // listboxes. Options remain programmatically focusable.
        var selectedOption = container.querySelector('[role="option"][aria-selected="true"]');
        if (selectedOption) return selectedOption;
        var firstOption = container.querySelector('[role="option"]');
        if (firstOption) return firstOption;
        // Last resort for non-standard listboxes that render no options
        // but do contain a focusable element (e.g. an empty-state action).
        return (0, $2AUaL.getFirstFocusable)({
            container: container
        });
    }
    // tooltip, no role, or other roles: no focus movement
    return null;
}
function $2a552bfc24859fc8$export$e992c40175757a22(_ref3) {
    var elementRef = _ref3.elementRef, phase = _ref3.phase, role = _ref3.role;
    // Track the previous phase so we only focus on transitions into a
    // visible phase from either `'closed'` (fresh mount) or `'exiting'`
    // (mid-exit reopen where the browser has already restored focus to
    // the trigger). Pure `entering → exiting → entering` stutters where
    // the consumer toggles in the same frame are still collapsed.
    var prevPhaseRef = (0, $1oC0p.useRef)('closed');
    (0, $1oC0p.useEffect)(function() {
        var _getInitialFocusTarge;
        var prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        // Only focus on transitions into a visible phase from `'closed'`
        // (fresh open) or `'exiting'` (mid-exit reopen).
        if (phase === 'closed') return;
        if (prevPhase !== 'closed' && prevPhase !== 'exiting') return;
        var element = elementRef.current;
        if (!element) return;
        (_getInitialFocusTarge = $2a552bfc24859fc8$var$getInitialFocusTarget({
            container: element,
            role: role
        })) === null || _getInitialFocusTarge === void 0 || _getInitialFocusTarge.focus();
    }, [
        elementRef,
        phase,
        role
    ]);
}

});


parcelRegister("iQsXC", function(module, exports) {
$parcel$export(module.exports, "useAnchorPosition", function () { return $db838c460aadbf4d$export$56b02a1e583f953c; });

var $lFOXD = parcelRequire("lFOXD");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $FcGYz = parcelRequire("FcGYz");

var $8zODL = parcelRequire("8zODL");

var $egBPL = parcelRequire("egBPL");

var $ca1ZK = parcelRequire("ca1ZK");

var $lAuUv = parcelRequire("lAuUv");

var $049fF = parcelRequire("049fF");

var $dnyDH = parcelRequire("dnyDH");

var $6Rans = parcelRequire("6Rans");

var $jYEP5 = parcelRequire("jYEP5");
// `resolvePlacement` is intentionally NOT re-exported here - import it directly
// from `./resolve-placement` so search-and-jump lands at the source of truth.
/**
 * Module-scope no-op `ResizeObserver` used in non-DOM jest environments where
 * `ResizeObserver` is `undefined`. Hoisted out of the effect to avoid
 * allocating a new class declaration on every run.
 */ var $db838c460aadbf4d$var$NoopResizeObserver = /*#__PURE__*/ function() {
    function NoopResizeObserver() {
        (0, $cTewU.default)(this, NoopResizeObserver);
    }
    return (0, $avOEA.default)(NoopResizeObserver, [
        {
            key: "observe",
            value: function observe() {}
        },
        {
            key: "unobserve",
            value: function unobserve() {}
        },
        {
            key: "disconnect",
            value: function disconnect() {}
        }
    ]);
}();
/**
 * Returns true when the popover is currently open. Wrapped because the
 * `:popover-open` pseudo-class is not implemented in some test environments
 * (e.g. jsdom), where `matches` throws on unknown selectors.
 */ function $db838c460aadbf4d$var$isPopoverOpen(popover) {
    try {
        return popover.matches(':popover-open');
    } catch (_unused) {
        return false;
    }
}
/**
 * Detects whether the browser supports CSS Anchor Positioning.
 * Uses `once()` for lazy evaluation: safe for SSR and avoids hydration mismatches.
 */ var $db838c460aadbf4d$var$supportsAnchorPositioning = (0, $8zODL.default)(function() {
    if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
    return CSS.supports('anchor-name', '--a');
});
/**
 * Every logical margin property this module can write: one per axis, per side.
 *
 * Deriving the union from `TPlacementAxis` and `TPlacementEdge` rather than
 * writing the four names out keeps it in step with the placement model, and
 * makes `CROSS_AXIS_SHIFT_CUSTOM_PROPERTY` below exhaustive by construction.
 */ /**
 * The custom property mirroring each cross-axis shift margin.
 *
 * These are written for the planned named arrow `@position-try` rules. Nothing
 * reads them yet, and the shift no longer depends on them: the antisymmetric
 * margins written by `crossAxisShiftMargins` survive a cross-axis slide on
 * their own.
 *
 * Keyed on `TLogicalMarginProperty` and not on `string`, so a margin property
 * that has no custom property (or a custom property whose margin no longer
 * exists) is a compile error rather than an `undefined` lookup that reaches
 * `setStyle` as `{ property: undefined, value }`.
 */ var $db838c460aadbf4d$var$CROSS_AXIS_SHIFT_CUSTOM_PROPERTY = {
    'margin-inline-start': '--ds-cross-axis-shift-margin-start',
    'margin-inline-end': '--ds-cross-axis-shift-margin-end',
    'margin-block-start': '--ds-cross-axis-shift-margin-block-start',
    'margin-block-end': '--ds-cross-axis-shift-margin-block-end'
};
var $db838c460aadbf4d$var$ZEROED_CROSS_AXIS_SHIFT_CUSTOM_PROPERTIES = Object.values($db838c460aadbf4d$var$CROSS_AXIS_SHIFT_CUSTOM_PROPERTY).map(function(property) {
    return {
        property: property,
        value: '0px'
    };
});
/**
 * Returns the CSS margin declaration that creates a gap between the
 * popover and its trigger on the side facing the anchor.
 *
 * For example, a `block-end` placement (popover below) gets
 * `margin-block-start: 8px` to push it away from the trigger's bottom edge.
 */ function $db838c460aadbf4d$var$edgeMargin(_ref) {
    var placement = _ref.placement, offset = _ref.offset;
    var axis = placement.axis, edge = placement.edge;
    // The gap sits on the side FACING the anchor, which is always the side
    // opposite the placement edge.
    var anchorFacingEdge = edge === 'end' ? 'start' : 'end';
    return {
        property: "margin-".concat(axis, "-").concat(anchorFacingEdge),
        value: offset
    };
}
/**
 * **The cross-axis shift margins.**
 *
 * The shift is written antisymmetrically on BOTH cross-axis sides
 * (`start: +value`, `end: -value`) rather than as a single margin on the side
 * picked from `align`. Two separate behaviours require it:
 *
 * 1. **`align: 'center'` is centered with `anchor-center`, which centers the
 *    popover's MARGIN box on the anchor.** A single-sided margin widens the
 *    margin box, so it displaces the border box by only half its value. An
 *    antisymmetric pair leaves the margin box width unchanged (`+value` and
 *    `-value` sum to zero) while moving its center by the full value.
 * 2. **`position-try-fallbacks` can slide the popover onto the opposite
 *    cross-axis side.** A `<position-area>` fallback keeps the base style's
 *    margins, and margin on the un-anchored side has no effect, so a
 *    single-sided margin is silently dropped once the browser slides across the
 *    cross axis. With both sides written, whichever side ends up anchored moves
 *    the popover the same physical direction.
 *
 * Leaving the margin box width unchanged also means the shift does not move
 * the point at which `position-try-fallbacks` decides the popover overflows.
 *
 * A `<try-tactic>` fallback (`flip-block`, `flip-inline`) behaves differently to
 * a `<position-area>` one: it SWAPS the start and end margins rather than
 * keeping them, which is what preserves the gap through a flip. So a flip across
 * the cross axis mirrors the shift along with the rest of the placement, rather
 * than preserving its physical direction. Only the diagonal fallback does that,
 * and only for `align: 'start' | 'end'`. See `placementToTryFallbacks`.
 *
 * A positive value always moves the popover toward the cross-axis END, so
 * `direction: 'forwards'` means the same thing for every `align` value. See
 * `notes/decisions/placement-offset.md`.
 */ function $db838c460aadbf4d$var$crossAxisShiftMargins(_ref2) {
    var placement = _ref2.placement, crossAxisShiftCssValue = _ref2.crossAxisShiftCssValue, direction = _ref2.direction;
    var crossAxis = placement.axis === 'block' ? 'inline' : 'block';
    // Wrap any string in calc() with the sign factor. CSS handles the math,
    // so opaque values such as design tokens negate correctly.
    var negated = "calc(-1 * ".concat(crossAxisShiftCssValue, ")");
    var isForwards = direction === 'forwards';
    return [
        {
            property: "margin-".concat(crossAxis, "-start"),
            value: isForwards ? crossAxisShiftCssValue : negated
        },
        {
            property: "margin-".concat(crossAxis, "-end"),
            value: isForwards ? negated : crossAxisShiftCssValue
        }
    ];
}
/**
 * Returns a referentially-stable, fully-resolved `TPlacement`. The memo is
 * keyed on the resolved primitive fields so a fresh inline `placement` object
 * (or undefined fields vs explicit defaults) does not produce a fresh result.
 */ function $db838c460aadbf4d$var$useStablePlacement(placement) {
    var resolved = (0, $6Rans.resolvePlacement)({
        placement: placement
    });
    var axis = resolved.axis;
    var edge = resolved.edge;
    var align = resolved.align;
    var gap = resolved.offset.gap;
    var shiftValue = resolved.offset.crossAxisShift.value;
    var shiftDirection = resolved.offset.crossAxisShift.direction;
    // Rebuild inside the memo from primitive deps so the factory does not
    // close over the outer `resolved` reference and exhaustive-deps can verify.
    return (0, $1oC0p.useMemo)(function() {
        return {
            axis: axis,
            edge: edge,
            align: align,
            offset: {
                gap: gap,
                crossAxisShift: {
                    value: shiftValue,
                    direction: shiftDirection
                }
            }
        };
    }, [
        axis,
        edge,
        align,
        gap,
        shiftValue,
        shiftDirection
    ]);
}
function $db838c460aadbf4d$export$56b02a1e583f953c(_ref3) {
    var anchorRef = _ref3.anchorRef, popoverRef = _ref3.popoverRef, _ref3$placement = _ref3.placement, placement = _ref3$placement === void 0 ? {} : _ref3$placement, _ref3$forceFallbackPo = _ref3.forceFallbackPositioning, forceFallbackPositioning = _ref3$forceFallbackPo === void 0 ? false : _ref3$forceFallbackPo, _ref3$isEnabled = _ref3.isEnabled, isEnabled = _ref3$isEnabled === void 0 ? true : _ref3$isEnabled, isOpen = _ref3.isOpen;
    var id = (0, $1oC0p.useId)();
    var stablePlacement = $db838c460aadbf4d$var$useStablePlacement(placement);
    (0, $1oC0p.useLayoutEffect)(function() {
        if (!isEnabled) return;
        var trigger = anchorRef.current;
        var popover = popoverRef.current;
        if (!trigger || !popover) return;
        var gapCssValue = stablePlacement.offset.gap;
        var crossAxisShiftCssValue = stablePlacement.offset.crossAxisShift.value;
        var shouldForceFallback = Boolean(forceFallbackPositioning);
        if ($db838c460aadbf4d$var$supportsAnchorPositioning() && !shouldForceFallback) {
            // Reuse an existing `anchor-name` if the element already has one.
            // Another popover might already be anchored to the old name.
            var anchorName = trigger.style.getPropertyValue('anchor-name') || "--anchor-".concat(id.replace(/:/g, ''));
            var gap = $db838c460aadbf4d$var$edgeMargin({
                placement: stablePlacement,
                offset: gapCssValue
            });
            // Computed once; also mirrored into the
            // `--ds-cross-axis-shift-margin-*` custom properties below.
            var crossAxisShift = $db838c460aadbf4d$var$crossAxisShiftMargins({
                placement: stablePlacement,
                crossAxisShiftCssValue: crossAxisShiftCssValue,
                direction: stablePlacement.offset.crossAxisShift.direction
            });
            var popoverStyles = [
                {
                    property: 'position-anchor',
                    value: anchorName
                },
                {
                    property: 'position-area',
                    value: (0, $lAuUv.placementToPositionArea)({
                        placement: stablePlacement
                    })
                },
                {
                    property: 'position-try-fallbacks',
                    value: (0, $049fF.placementToTryFallbacks)({
                        placement: stablePlacement
                    })
                },
                // Reset browser default popover positioning that conflicts
                // with anchor positioning (UA: `inset: 0; margin: auto;`)
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                },
                gap
            ].concat((0, $lFOXD.default)(crossAxisShift), (0, $lFOXD.default)($db838c460aadbf4d$var$ZEROED_CROSS_AXIS_SHIFT_CUSTOM_PROPERTIES), (0, $lFOXD.default)(crossAxisShift.map(function(_ref4) {
                var property = _ref4.property, value = _ref4.value;
                return {
                    property: $db838c460aadbf4d$var$CROSS_AXIS_SHIFT_CUSTOM_PROPERTY[property],
                    value: value
                };
            })));
            /**
       * **We are never cleaning up anchor names**
       *
       * _Rationale_
       *
       * - Multiple popovers can share the same anchor element.
       * - Sometimes the `useAnchorPosition` hook and `Popover`
       *   are not in the same component.
       * - There can be times when, even with reference counting, we
       *   could remove the anchor-name while it is still being used
       *   by something else - especially with async react updates
       *   which can cause tearing
       *
       * _More_
       *
       * See `notes/decisions/anchor-name-lifetime.md`
       */ trigger.style.setProperty('anchor-name', anchorName);
            return (0, $jYEP5.setStyle)({
                element: popover,
                styles: popoverStyles
            });
        }
        // JS fallback. The popover is already in the top layer via
        // popover="auto", so we only reset UA defaults and set top/left
        // based on measurements.
        var cleanupBaseStyles = (0, $jYEP5.setStyle)({
            element: popover,
            styles: [
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                }
            ]
        });
        // The popover can be consumer-owned (`@atlaskit/popper`'s `createPopper`),
        // so restore prior inline values rather than removing ours.
        var undoPosition;
        var undoHide;
        // `opacity: 0` not `visibility: hidden`: Firefox skips visibility-hidden
        // elements during `<dialog>` initial-focus traversal.
        function hideUntilPositioned() {
            // Keep the first snapshot, else we capture our own `opacity: 0`.
            // (`!popover` is for TS: narrowing does not reach nested functions.)
            if (!popover || undoHide) return;
            undoHide = (0, $jYEP5.setStyle)({
                element: popover,
                styles: [
                    {
                        property: 'opacity',
                        value: '0'
                    }
                ]
            });
        }
        function reveal() {
            var _undoHide;
            (_undoHide = undoHide) === null || _undoHide === void 0 || _undoHide();
            undoHide = undefined;
        }
        function restorePosition() {
            var _undoPosition;
            (_undoPosition = undoPosition) === null || _undoPosition === void 0 || _undoPosition();
            undoPosition = undefined;
        }
        function update() {
            if (!trigger || !popover) return;
            var triggerRect = trigger.getBoundingClientRect();
            var viewport = {
                width: window.innerWidth,
                height: window.innerHeight
            };
            // Resolve consumer-supplied CSS length strings (tokens, calc, var,
            // px, rem, etc) to pixels. The probe is mounted INSIDE the popover
            // itself so the resolved length matches the scope a token would
            // resolve against from inside the popover content. (The popover
            // lives in the top layer, not the trigger's DOM tree, so probing
            // at `popover.parentElement` would resolve in a different scope
            // than the consumer's token authoring expects.)
            var gapPx = (0, $dnyDH.resolveCssLengthToPixels)({
                value: gapCssValue,
                container: popover
            });
            var crossAxisShiftPx = (0, $dnyDH.resolveCssLengthToPixels)({
                value: crossAxisShiftCssValue,
                container: popover
            });
            var _computeFallbackPosit = (0, $egBPL.computeFallbackPosition)({
                triggerRect: triggerRect,
                popoverEl: popover,
                placement: stablePlacement,
                viewport: viewport,
                gap: gapPx,
                crossAxisShift: {
                    value: crossAxisShiftPx,
                    direction: stablePlacement.offset.crossAxisShift.direction
                }
            }), top = _computeFallbackPosit.top, left = _computeFallbackPosit.left;
            // Restore first so the snapshot stays the consumer's value.
            restorePosition();
            undoPosition = (0, $jYEP5.setStyle)({
                element: popover,
                styles: [
                    {
                        property: 'top',
                        value: "".concat(top, "px")
                    },
                    {
                        property: 'left',
                        value: "".concat(left, "px")
                    }
                ]
            });
            reveal();
        }
        // Throttle scroll/resize updates to one per animation frame
        var scheduledUpdate = (0, $FcGYz.default)(update);
        // Wait for the FIRST valid layout before measuring: the popover
        // is `display: none` until `showPopover()`, and some browsers
        // fire `toggle` before layout, so RAF-after-toggle is unreliable.
        // ResizeObserver fires once the browser has real dimensions.
        // Self-disconnects after one valid measurement; ongoing
        // scroll/resize is handled by the window listeners below.
        // `ResizeObserver` is missing in some non-DOM jest environments
        // (e.g. post-office's `node` environment). Fall back to a no-op
        // observer there. The scroll/resize listeners below still keep
        // the popover positioned in the rare case the consumer also
        // polyfilled `showPopover` but not `ResizeObserver`. Real
        // browsers always have it. The `NoopResizeObserver` class is
        // hoisted to module scope (see top of file) so we do not allocate
        // a new constructor on every effect run.
        var ResizeObserverImpl = typeof ResizeObserver !== 'undefined' ? ResizeObserver : $db838c460aadbf4d$var$NoopResizeObserver;
        var resizeObserver = new ResizeObserverImpl(function() {
            if (popover.offsetWidth > 0 && popover.offsetHeight > 0) {
                update();
                resizeObserver.disconnect();
            }
        });
        // If the popover is already open by the time this effect runs (for
        // example, the parent `useAnchorPosition` effect runs after the child
        // `Popover` effect that called `showPopover()`), the initial `toggle`
        // event has already fired and our listener below would miss it. Start
        // observing immediately so the first measurement still happens.
        if ($db838c460aadbf4d$var$isPopoverOpen(popover)) {
            hideUntilPositioned();
            resizeObserver.observe(popover);
        }
        var undoPositioning = (0, $ca1ZK.combine)(cleanupBaseStyles, // Each open needs a fresh measurement, so hide and re-observe.
        (0, $dH1HR.bind)(popover, {
            type: 'toggle',
            listener: function listener(event) {
                var toggleEvent = event;
                if (toggleEvent.newState === 'open') {
                    hideUntilPositioned();
                    resizeObserver.observe(popover);
                }
            }
        }), function() {
            return resizeObserver.disconnect();
        }, (0, $dH1HR.bind)(window, {
            type: 'scroll',
            listener: scheduledUpdate,
            options: {
                capture: true,
                passive: true
            }
        }), (0, $dH1HR.bind)(window, {
            type: 'resize',
            listener: scheduledUpdate,
            options: {
                passive: true
            }
        }), function() {
            scheduledUpdate.cancel();
            restorePosition();
            reveal();
        });
        return undoPositioning;
    }, [
        anchorRef,
        popoverRef,
        stablePlacement,
        forceFallbackPositioning,
        isEnabled,
        id,
        isOpen
    ]);
}

});
parcelRegister("egBPL", function(module, exports) {
$parcel$export(module.exports, "computeFallbackPosition", function () { return $a62fe85898046bac$export$d5ef1dac02135664; });

var $f53LC = parcelRequire("f53LC");
function $a62fe85898046bac$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a62fe85898046bac$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a62fe85898046bac$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a62fe85898046bac$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * JS fallback positioning math. Used only when the browser does not
 * support CSS Anchor Positioning (less than 6% of users).
 *
 * Consumer-supplied `offset.gap` and `offset.crossAxisShift` are
 * honored: the caller (`useAnchorPosition`) resolves CSS length strings
 * (tokens, calc, var, etc) to pixels via a DOM probe before passing them
 * in. The caller also keeps the popover hidden (`opacity: 0`) until the
 * first measurement completes, so the popover never paints at the wrong
 * position.
 */ /**
 * A viewport-relative position, in pixels. Physical rather than logical
 * because it is written straight to `top` / `left`.
 */ /**
 * The cross-axis shift with its length already resolved to pixels.
 *
 * Mirrors `TCrossAxisShiftOffset`, whose `value` is an unresolved CSS length
 * string. Only this module needs the pixel form, because only this module does
 * the arithmetic itself.
 */ /**
 * Computes the base {top, left} position based on the primary edge,
 * flipping to the opposite side when there is not enough space.
 *
 * `gap` is applied along the main axis between trigger and popover.
 */ function $a62fe85898046bac$var$computeEdgePosition(_ref) {
    var axis = _ref.axis, edge = _ref.edge, triggerRect = _ref.triggerRect, popoverWidth = _ref.popoverWidth, popoverHeight = _ref.popoverHeight, viewport = _ref.viewport, gap = _ref.gap;
    if (axis === 'block' && edge === 'end') {
        // Below trigger
        var spaceBelow = viewport.height - triggerRect.bottom;
        var spaceAbove = triggerRect.top;
        var fitsBelow = spaceBelow >= popoverHeight + gap;
        var useBelow = fitsBelow || spaceBelow >= spaceAbove;
        return {
            top: useBelow ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'block' && edge === 'start') {
        // Above trigger
        var _spaceAbove = triggerRect.top;
        var _spaceBelow = viewport.height - triggerRect.bottom;
        var fitsAbove = _spaceAbove >= popoverHeight + gap;
        var useAbove = fitsAbove || _spaceAbove >= _spaceBelow;
        return {
            top: useAbove ? triggerRect.top - popoverHeight - gap : triggerRect.bottom + gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'inline' && edge === 'end') {
        // Right of trigger
        var spaceRight = viewport.width - triggerRect.right;
        var spaceLeft = triggerRect.left;
        var fitsRight = spaceRight >= popoverWidth + gap;
        var useRight = fitsRight || spaceRight >= spaceLeft;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useRight ? triggerRect.right + gap : triggerRect.left - popoverWidth - gap
        };
    }
    if (axis === 'inline' && edge === 'start') {
        // Left of trigger
        var _spaceLeft = triggerRect.left;
        var _spaceRight = viewport.width - triggerRect.right;
        var fitsLeft = _spaceLeft >= popoverWidth + gap;
        var useLeft = fitsLeft || _spaceLeft >= _spaceRight;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useLeft ? triggerRect.left - popoverWidth - gap : triggerRect.right + gap
        };
    }
    // Unreachable for valid placements; defaults to below trigger
    return {
        top: triggerRect.bottom + gap,
        left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
    };
}
/**
 * Adjusts the base (centered) position for non-center alignments.
 *
 * `align: 'start'` → popover start edge at trigger start edge
 * `align: 'end'`   → popover end edge at trigger end edge
 */ function $a62fe85898046bac$var$applyAlignment(_ref2) {
    var position = _ref2.position, axis = _ref2.axis, align = _ref2.align, triggerRect = _ref2.triggerRect, popoverWidth = _ref2.popoverWidth, popoverHeight = _ref2.popoverHeight;
    if (align === 'center') return position;
    if (axis === 'block') {
        // Block-axis placement → cross-axis is inline (left/right)
        if (align === 'start') return $a62fe85898046bac$var$_objectSpread($a62fe85898046bac$var$_objectSpread({}, position), {}, {
            left: triggerRect.left
        });
        // align === 'end'
        return $a62fe85898046bac$var$_objectSpread($a62fe85898046bac$var$_objectSpread({}, position), {}, {
            left: triggerRect.right - popoverWidth
        });
    }
    // Inline-axis placement → cross-axis is block (top/bottom)
    if (align === 'start') return $a62fe85898046bac$var$_objectSpread($a62fe85898046bac$var$_objectSpread({}, position), {}, {
        top: triggerRect.top
    });
    // align === 'end'
    return $a62fe85898046bac$var$_objectSpread($a62fe85898046bac$var$_objectSpread({}, position), {}, {
        top: triggerRect.bottom - popoverHeight
    });
}
/**
 * Applies the cross-axis shift offset.
 *
 * `forwards` always moves the popover toward the cross-axis END and
 * `backwards` toward the START, for every `align` value. See
 * `notes/decisions/placement-offset.md`.
 *
 * This is a coordinate, so the direction is the sign and nothing else. There
 * is deliberately no per-`align` sign inversion here: the CSS path inverts the
 * sign only because a margin on the END side pushes a box the opposite way to
 * a margin on the START side, which is a property of margins rather than of
 * the shift. Applying that inversion to a coordinate moved `align: 'end'`
 * popovers the wrong way.
 */ function $a62fe85898046bac$var$applyCrossAxisShift(_ref3) {
    var position = _ref3.position, axis = _ref3.axis, crossAxisShift = _ref3.crossAxisShift;
    if (crossAxisShift.value === 0) return position;
    var directionSign = crossAxisShift.direction === 'forwards' ? 1 : -1;
    var delta = crossAxisShift.value * directionSign;
    // Cross-axis is the OPPOSITE of the placement axis.
    if (axis === 'block') return $a62fe85898046bac$var$_objectSpread($a62fe85898046bac$var$_objectSpread({}, position), {}, {
        left: position.left + delta
    });
    return $a62fe85898046bac$var$_objectSpread($a62fe85898046bac$var$_objectSpread({}, position), {}, {
        top: position.top + delta
    });
}
function $a62fe85898046bac$export$d5ef1dac02135664(_ref4) {
    var triggerRect = _ref4.triggerRect, popoverEl = _ref4.popoverEl, placement = _ref4.placement, viewport = _ref4.viewport, gap = _ref4.gap, crossAxisShift = _ref4.crossAxisShift;
    var axis = placement.axis, edge = placement.edge, align = placement.align;
    // Measure popover dimensions. Callers must ensure the popover has
    // laid out before calling this (it should not be `display: none`).
    var popoverWidth = popoverEl.offsetWidth;
    var popoverHeight = popoverEl.offsetHeight;
    var basePosition = $a62fe85898046bac$var$computeEdgePosition({
        axis: axis,
        edge: edge,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight,
        viewport: viewport,
        gap: gap
    });
    var alignedPosition = $a62fe85898046bac$var$applyAlignment({
        position: basePosition,
        axis: axis,
        align: align,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight
    });
    var shiftedPosition = $a62fe85898046bac$var$applyCrossAxisShift({
        position: alignedPosition,
        axis: axis,
        crossAxisShift: crossAxisShift
    });
    // Clamp to viewport so the popover is never offscreen
    return {
        top: Math.max(0, Math.min(shiftedPosition.top, viewport.height - popoverHeight)),
        left: Math.max(0, Math.min(shiftedPosition.left, viewport.width - popoverWidth))
    };
}

});

parcelRegister("ca1ZK", function(module, exports) {
$parcel$export(module.exports, "combine", function () { return $8da7f75e4cf21674$export$1be1fc439b849fdf; });
/**
 * Combine multiple cleanup functions into a single cleanup function.
 *
 * @example
 * ```ts
 * useEffect(() => {
 *   return combine(
 *     bind(window, { type: 'resize', listener: onResize }),
 *     bind(window, { type: 'scroll', listener: onScroll, options: { capture: true } }),
 *   );
 * }, []);
 * ```
 */ function $8da7f75e4cf21674$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, cleanupFns = new Array(_len), _key = 0; _key < _len; _key++)cleanupFns[_key] = arguments[_key];
    return function cleanup() {
        cleanupFns.forEach(function(callback) {
            return callback === null || callback === void 0 ? void 0 : callback();
        });
    };
}

});

parcelRegister("lAuUv", function(module, exports) {
$parcel$export(module.exports, "placementToPositionArea", function () { return $fb74efed3576da06$export$de49b61f233ddeb9; });

var $6Rans = parcelRequire("6Rans");
function $fb74efed3576da06$export$de49b61f233ddeb9(_ref) {
    var placement = _ref.placement;
    var _resolvePlacement = (0, $6Rans.resolvePlacement)({
        placement: placement
    }), axis = _resolvePlacement.axis, edge = _resolvePlacement.edge, align = _resolvePlacement.align;
    var edgeValue = "".concat(axis, "-").concat(edge);
    if (align === 'center') return edgeValue;
    // Cross-axis name: block ↔ inline
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    // Invert align → CSS span direction: visual 'start' → span toward 'end'
    var spanDir = align === 'start' ? 'end' : 'start';
    return "".concat(edgeValue, " span-").concat(crossAxis, "-").concat(spanDir);
}

});

parcelRegister("049fF", function(module, exports) {
$parcel$export(module.exports, "placementToTryFallbacks", function () { return $00c78d0a8003b715$export$c4e16947a95d61f1; });

var $6Rans = parcelRequire("6Rans");
/**
 * A `position-area` primary edge — the placement axis joined to its edge, e.g.
 * `block-end` or `inline-start`. These are the four edges a popover can sit on.
 */ function $00c78d0a8003b715$var$slideOnEdge(_ref) {
    var align = _ref.align, edgeKey = _ref.edgeKey, crossAxis = _ref.crossAxis;
    if (align === 'center') return [
        "".concat(edgeKey, " span-").concat(crossAxis, "-end"),
        "".concat(edgeKey, " span-").concat(crossAxis, "-start")
    ];
    // For `align: 'start'` the popover expands toward `end`, so the "near"
    // span is `end` and the "far" span is `start`; `align: 'end'` mirrors
    // this. The bare `edgeKey` (re-centered) sits between them.
    var near = align === 'start' ? 'end' : 'start';
    var far = align === 'start' ? 'start' : 'end';
    return [
        "".concat(edgeKey, " span-").concat(crossAxis, "-").concat(near),
        edgeKey,
        "".concat(edgeKey, " span-").concat(crossAxis, "-").concat(far)
    ];
}
function $00c78d0a8003b715$var$flipDiagonally(_ref2) {
    var axis = _ref2.axis;
    var flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    var flipToCrossAxis = axis === 'block' ? 'flip-inline' : 'flip-block';
    return "".concat(flipOnMainAxis, " ").concat(flipToCrossAxis);
}
function $00c78d0a8003b715$export$c4e16947a95d61f1(_ref3) {
    var placement = _ref3.placement;
    /**
   * **Build the fallback list**
   *
   * Each entry is a complete alternative position.
   * The browser tries them _in order_ and uses the _first_ one that fits.
   */ var resolved = (0, $6Rans.resolvePlacement)({
        placement: placement
    });
    var axis = resolved.axis, edge = resolved.edge, align = resolved.align;
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    var flippedEdge = edge === 'start' ? 'end' : 'start';
    var sameEdgeArea = "".concat(axis, "-").concat(edge);
    var oppositeEdgeArea = "".concat(axis, "-").concat(flippedEdge);
    var flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    /**
   * **Fallback algorithm**
   *
   * We have two things we can do to keep something visible:
   *
   * 1. _Slide_ along edges
   * 2. _Flip_ to another edge
   *
   * _Centered popover_
   *
   * Desired: Sits in middle of main edge
   *
   * Fallbacks:
   *  1: _Slide_ along main edge on the cross axis
   *  2: _Flip_ on main axis to opposite edge (centered)
   *  3: _Slide_ along opposite edge on the cross axis
   *
   * _Start or end aligned popover_
   *
   * Desired: Sits at start / end of main edge
   *
   * Fallbacks:
   *  1: _Slide_ along main edge on the cross axis
   *  2: _Flip_ on main axis to opposite edge
   *  3: _Flip_ on the diagonal (flip main axis + flip cross axis) into the
   *     opposite corner. For start / end alignment, this is the clean escape
   *     when the popover would otherwise land offscreen on both axes (ie in a
   *     corner). Rule 4 gets the job done, but a slide drops the gap
   *     as named position-area values don't carry margins).
   *     The diagonal flip keeps the gap and the alignment.
   *  4: _Slide_ along opposite edge on the cross axis
   */ return [
        $00c78d0a8003b715$var$slideOnEdge({
            align: align,
            edgeKey: sameEdgeArea,
            crossAxis: crossAxis
        }),
        flipOnMainAxis,
        align !== 'center' ? $00c78d0a8003b715$var$flipDiagonally({
            axis: axis
        }) : null,
        $00c78d0a8003b715$var$slideOnEdge({
            align: align,
            edgeKey: oppositeEdgeArea,
            crossAxis: crossAxis
        })
    ].filter(Boolean).flat().join(', ');
}

});

parcelRegister("dnyDH", function(module, exports) {
$parcel$export(module.exports, "resolveCssLengthToPixels", function () { return $9bd84afb8757b028$export$98721546d2816d9e; });
var $9bd84afb8757b028$var$elementCaches = new WeakMap();
function $9bd84afb8757b028$var$canCacheResolvedLength(value) {
    // Custom-property values can be retargeted by inline overrides on the
    // consumer's wrapper, so we cannot prove a cached pixel value is still valid.
    return !value.includes('var(');
}
function $9bd84afb8757b028$var$getCachedResolvedLength(_ref) {
    var _cacheForElement$get;
    var element = _ref.element, value = _ref.value;
    if (!$9bd84afb8757b028$var$canCacheResolvedLength(value)) return null;
    var cacheForElement = $9bd84afb8757b028$var$elementCaches.get(element);
    return (_cacheForElement$get = cacheForElement === null || cacheForElement === void 0 ? void 0 : cacheForElement.get(value)) !== null && _cacheForElement$get !== void 0 ? _cacheForElement$get : null;
}
function $9bd84afb8757b028$var$cacheResolvedLength(_ref2) {
    var _elementCaches$get;
    var element = _ref2.element, value = _ref2.value, result = _ref2.result;
    if (!$9bd84afb8757b028$var$canCacheResolvedLength(value)) return;
    var cacheForElement = (_elementCaches$get = $9bd84afb8757b028$var$elementCaches.get(element)) !== null && _elementCaches$get !== void 0 ? _elementCaches$get : new Map();
    cacheForElement.set(value, result);
    $9bd84afb8757b028$var$elementCaches.set(element, cacheForElement);
}
function $9bd84afb8757b028$export$98721546d2816d9e(_ref3) {
    var value = _ref3.value, container = _ref3.container;
    if (typeof value === 'number') return value;
    // Fast path: unitless zero is universally zero pixels - accept `'0'` and
    // `'-0'` without a probe. (Consumers occasionally pass `'0'` instead of
    // the number `0`.)
    if (value === '0' || value === '-0') return 0;
    // Fast path: bare `${n}px` strings come from the consumer normalisation
    // in `resolvePlacement`. Avoid a reflow when we can.
    var pxMatch = value.match(/^(-?\d+(?:\.\d+)?)px$/);
    if (pxMatch) return Number(pxMatch[1]);
    var cached = $9bd84afb8757b028$var$getCachedResolvedLength({
        element: container,
        value: value
    });
    if (cached !== null) return cached;
    var probe = container.ownerDocument.createElement('div');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.pointerEvents = 'none';
    probe.style.height = '0';
    probe.style.padding = '0';
    probe.style.border = '0';
    // `width` clamps negatives to 0; use `margin-left` instead so signs are
    // preserved. `getComputedStyle` returns the resolved pixel value for
    // margin-* properties even when the source was a token / calc / var.
    probe.style.marginLeft = value;
    // Hide the probe from assistive tech and event targeting; defensive
    // against `getElementsByTagName('div')` walks in consumer code.
    probe.setAttribute('aria-hidden', 'true');
    probe.setAttribute('inert', '');
    container.appendChild(probe);
    var resolved = parseFloat(getComputedStyle(probe).marginLeft);
    container.removeChild(probe);
    var result = Number.isFinite(resolved) ? resolved : 0;
    $9bd84afb8757b028$var$cacheResolvedLength({
        element: container,
        value: value,
        result: result
    });
    return result;
}

});

parcelRegister("jYEP5", function(module, exports) {
$parcel$export(module.exports, "setStyle", function () { return $e8b3497fdcbd0269$export$37a5fde709c1db82; });
/**
 * A single inline style declaration.
 *
 * `TProperty` narrows the property name for callers that write a known, closed
 * set of properties. Narrowing it lets a record keyed on those same names be
 * checked for exhaustiveness at compile time, rather than silently resolving to
 * `undefined` for a name that was never mapped.
 */ /**
 * Sets inline styles on an element and returns a cleanup function that
 * restores the prior inline values (so we do not stomp consumer styles).
 */ function $e8b3497fdcbd0269$export$37a5fde709c1db82(_ref) {
    var element = _ref.element, styles = _ref.styles;
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    var priorValues = styles.map(function(_ref2) {
        var property = _ref2.property;
        return {
            property: property,
            value: element.style.getPropertyValue(property)
        };
    });
    styles.forEach(function(_ref3) {
        var property = _ref3.property, value = _ref3.value;
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(function(_ref4) {
            var property = _ref4.property, value = _ref4.value;
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}

});


parcelRegister("ik7PK", function(module, exports) {
$parcel$export(module.exports, "useAnchorPositionAtPoint", function () { return $d5702bddf90e3bcc$export$6f230729189a5b8a; });

var $1oC0p = parcelRequire("1oC0p");

var $iQsXC = parcelRequire("iQsXC");
/**
 * A point in viewport coordinates (CSS pixels) at which the synthetic
 * anchor should be placed.
 *
 * Axis-named (`x`/`y`) rather than edge-named (`left`/`top`) so the
 * shape is unambiguous in RTL writing modes - there is no ambiguity
 * about whether a coordinate is logical (`inline-start`/`block-start`)
 * or physical (`left`/`top`). Viewport coordinates are always
 * physical, so we name them with the physical axis labels.
 */ /**
 * Styles the synthetic anchor as an invisible, zero-size point.
 * Dynamic `inset-*` overrides are written by the positioning effect.
 *
 * Uses `Object.assign` rather than Compiled CSS (element is outside the React tree)
 * or the internal `setStyle` helper (we own this element entirely - it is created
 * and removed by this hook - so the snapshot/restore semantics `setStyle`
 * provides for caller-owned elements would be dead work here).
 */ function $d5702bddf90e3bcc$var$applyStaticAnchorStyles(element) {
    Object.assign(element.style, {
        position: 'fixed',
        // `top`/`left` rather than `inset-block-start`/`inset-inline-start`
        // for consistency with the dynamic positioning effect below, which
        // uses physical properties (see comment there for the rationale).
        top: '0',
        left: '0',
        // Zero size - placement decides which side the popover sits on.
        width: '0',
        height: '0',
        // Prevent the overlay from intercepting pointer events.
        pointerEvents: 'none'
    });
}
function $d5702bddf90e3bcc$export$6f230729189a5b8a(_ref) {
    var popoverRef = _ref.popoverRef, placement = _ref.placement, getPoint = _ref.getPoint, _ref$isEnabled = _ref.isEnabled, isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled, isOpen = _ref.isOpen;
    var syntheticAnchorRef = (0, $1oC0p.useRef)(null);
    // `getPoint` is kept in a ref so the layout effect can call the
    // latest version without listing it as a dep - that would re-fire
    // on every render and re-latch the point.
    var getPointRef = (0, $1oC0p.useRef)(getPoint);
    getPointRef.current = getPoint;
    // Lazy element creation: the `<div>` is only created when both
    // `isEnabled` is true AND `getPoint()` returns a non-null point.
    // `useLayoutEffect` ensures the element exists before the inner
    // `useAnchorPosition` (also a layout effect) reads the ref.
    (0, $1oC0p.useLayoutEffect)(function() {
        if (!isEnabled) return;
        var point = getPointRef.current();
        if (!point) return;
        var anchor = document.createElement('div');
        anchor.setAttribute('aria-hidden', 'true');
        $d5702bddf90e3bcc$var$applyStaticAnchorStyles(anchor);
        // `point.x`/`y` are physical viewport coordinates (from
        // `MouseEvent.clientX/Y`), so map directly onto physical
        // `left`/`top`. This is RTL-safe: `position: fixed` + physical
        // insets is direction-independent. Using logical
        // `inset-inline-start` would need `viewportWidth - point.x` in
        // RTL to land at the same physical pixel.
        anchor.style.top = "".concat(point.y, "px");
        anchor.style.left = "".concat(point.x, "px");
        document.body.appendChild(anchor);
        syntheticAnchorRef.current = anchor;
        return function cleanup() {
            anchor.remove();
            syntheticAnchorRef.current = null;
        };
    }, [
        isEnabled
    ]);
    // Mirror `isEnabled` so both hooks stay in sync - when disabled,
    // neither this hook nor the inner one touches the popover, leaving
    // any other positioning the consumer has set up free to take effect.
    (0, $iQsXC.useAnchorPosition)({
        anchorRef: syntheticAnchorRef,
        popoverRef: popoverRef,
        placement: placement,
        isEnabled: isEnabled,
        isOpen: isOpen
    });
}

});

parcelRegister("8mOPg", function(module, exports) {
$parcel$export(module.exports, "usePopoverId", function () { return $6177cdc0d3e316fd$export$9198c6c168be2eeb; });

var $4UF4U = parcelRequire("4UF4U");
function $6177cdc0d3e316fd$export$9198c6c168be2eeb() {
    // `@atlaskit/ds-lib/use-id` already strips characters that React's
    // `useId` produces (`:`, `«`, `»`) which are invalid in HTML ID
    // tokens. The `popover-` prefix is purely for DOM debug clarity.
    return "popover-".concat((0, $4UF4U.useId)());
}

});

parcelRegister("2oBVx", function(module, exports) {
$parcel$export(module.exports, "useWidthFromAnchor", function () { return $1beb3e2f67081e1c$export$7071d791a7b131ed; });

var $1oC0p = parcelRequire("1oC0p");

var $8zODL = parcelRequire("8zODL");

var $jYEP5 = parcelRequire("jYEP5");
/**
 * Probes anchor SIZING, separately from `anchor-name` (see
 * `supportsAnchorPositioning`): some browsers have positioning but not sizing.
 * `once()` for SSR safety.
 */ var $1beb3e2f67081e1c$var$supportsAnchorSize = (0, $8zODL.default)(function() {
    if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
    return CSS.supports('min-inline-size', 'anchor-size(self-inline)');
});
/**
 * The JS fallback's stand-in for `anchor-size(self-inline)`. `offsetWidth` / `offsetHeight` are
 * physical, so the axis is picked from the popover's `writing-mode`. Anything not horizontal is
 * treated as vertical, and an unknown or empty value falls back to `offsetWidth`.
 */ function $1beb3e2f67081e1c$var$getFallbackAnchorInlineSize(_ref) {
    var anchor = _ref.anchor, popover = _ref.popover;
    // `String()` because not every test environment implements `writing-mode`.
    var writingMode = String(getComputedStyle(popover).writingMode);
    var isVertical = writingMode.startsWith('vertical') || writingMode.startsWith('sideways');
    return isVertical ? anchor.offsetHeight : anchor.offsetWidth;
}
function $1beb3e2f67081e1c$export$7071d791a7b131ed(_ref2) {
    var mode = _ref2.mode, popoverRef = _ref2.popoverRef, anchorRef = _ref2.anchorRef, isOpen = _ref2.isOpen;
    (0, $1oC0p.useLayoutEffect)(function() {
        var node = popoverRef.current;
        if (!node) return;
        if (mode === 'match-anchor') {
            // No floor here: it would let the popover grow past the anchor.
            if ($1beb3e2f67081e1c$var$supportsAnchorSize()) return (0, $jYEP5.setStyle)({
                element: node,
                styles: [
                    {
                        property: 'inline-size',
                        value: 'anchor-size(self-inline)'
                    }
                ]
            });
            var anchor = anchorRef.current;
            if (anchor) return (0, $jYEP5.setStyle)({
                element: node,
                styles: [
                    {
                        property: 'inline-size',
                        value: "".concat($1beb3e2f67081e1c$var$getFallbackAnchorInlineSize({
                            anchor: anchor,
                            popover: node
                        }), "px")
                    }
                ]
            });
            return;
        }
        if (mode === 'min-anchor') {
            // One floor only. The content floor from mode 'none' deliberately does not also apply
            // here, and cannot: it would need this same property. See the decision note.
            if ($1beb3e2f67081e1c$var$supportsAnchorSize()) return (0, $jYEP5.setStyle)({
                element: node,
                styles: [
                    {
                        property: 'min-inline-size',
                        value: 'anchor-size(self-inline)'
                    }
                ]
            });
            var _anchor = anchorRef.current;
            if (_anchor) return (0, $jYEP5.setStyle)({
                element: node,
                styles: [
                    {
                        property: 'min-inline-size',
                        value: "".concat($1beb3e2f67081e1c$var$getFallbackAnchorInlineSize({
                            anchor: _anchor,
                            popover: node
                        }), "px")
                    }
                ]
            });
            // Nothing to measure, so no floor.
            return;
        }
        // Makes a too-narrow span overflow and drive `position-try-fallbacks` instead of wrapping.
        // `@atlaskit/popper` resets this exact property to `0` for its fit-to-viewport mode.
        return (0, $jYEP5.setStyle)({
            element: node,
            styles: [
                {
                    property: 'min-inline-size',
                    value: 'max-content'
                }
            ]
        });
    }, [
        mode,
        popoverRef,
        anchorRef,
        isOpen
    ]);
}

});

parcelRegister("Din8a", function(module, exports) {
$parcel$export(module.exports, "isPageRtl", function () { return $0761e4f1ce2c1d1d$export$175375e9a2b5515d; });

var $lRmMw = parcelRequire("lRmMw");
function $0761e4f1ce2c1d1d$export$175375e9a2b5515d() {
    var document = (0, $lRmMw.getDocument)();
    if (!document) return false;
    return document.dir === 'rtl' || document.body.dir === 'rtl' || document.documentElement.dir === 'rtl';
}

});

parcelRegister("fa33e", function(module, exports) {
$parcel$export(module.exports, "rectPointForPlacement", function () { return $b09a281848192ab4$export$b065aeb850c3e87f; });
/**
 * Reduces an anchor rect to the single viewport point that, wrapped in a
 * zero-size synthetic anchor, produces the same popover position
 * `useAnchorPosition` would for the given placement. This works because
 * `useAnchorPosition` only reads the edge / alignment corner of the rect,
 * so a coincident zero-size point is geometrically equivalent.
 *
 * RTL is resolved here so the downstream synthetic anchor only sees physical
 * coordinates. Defaults mirror `getPlacement` in
 * `@atlaskit/top-layer/placement-map` (`axis: 'block'`, `edge: 'end'`,
 * `align: 'center'`).
 */ function $b09a281848192ab4$export$b065aeb850c3e87f(_ref) {
    var _placement$axis, _placement$edge, _placement$align;
    var rect = _ref.rect, placement = _ref.placement, isRtl = _ref.isRtl;
    var axis = (_placement$axis = placement.axis) !== null && _placement$axis !== void 0 ? _placement$axis : 'block';
    var edge = (_placement$edge = placement.edge) !== null && _placement$edge !== void 0 ? _placement$edge : 'end';
    var align = (_placement$align = placement.align) !== null && _placement$align !== void 0 ? _placement$align : 'center';
    if (axis === 'block') {
        // Popover sits above (`edge: 'start'`) or below (`edge: 'end'`)
        // the anchor. Hug the matching horizontal edge; align along x.
        var _y = edge === 'start' ? rect.top : rect.bottom;
        var _x = $b09a281848192ab4$var$horizontalForAlign({
            rect: rect,
            align: align,
            isRtl: isRtl
        });
        return {
            x: _x,
            y: _y
        };
    }
    // `axis: 'inline'`: popover sits inline-start or inline-end of the
    // anchor. Hug the matching vertical edge; align along y.
    var x = $b09a281848192ab4$var$inlineEdgeX({
        rect: rect,
        edge: edge,
        isRtl: isRtl
    });
    var y = $b09a281848192ab4$var$verticalForAlign({
        rect: rect,
        align: align
    });
    return {
        x: x,
        y: y
    };
}
function $b09a281848192ab4$var$horizontalForAlign(_ref2) {
    var rect = _ref2.rect, align = _ref2.align, isRtl = _ref2.isRtl;
    if (align === 'center') return rect.left + rect.width / 2;
    // `start` / `end` are logical. In LTR, `start` is the left edge.
    // In RTL, `start` is the right edge.
    var isStartLeft = !isRtl;
    if (align === 'start') return isStartLeft ? rect.left : rect.right;
    return isStartLeft ? rect.right : rect.left;
}
function $b09a281848192ab4$var$verticalForAlign(_ref3) {
    var rect = _ref3.rect, align = _ref3.align;
    if (align === 'center') return rect.top + rect.height / 2;
    if (align === 'start') return rect.top;
    return rect.bottom;
}
function $b09a281848192ab4$var$inlineEdgeX(_ref4) {
    var rect = _ref4.rect, edge = _ref4.edge, isRtl = _ref4.isRtl;
    var isStartLeft = !isRtl;
    if (edge === 'start') return isStartLeft ? rect.left : rect.right;
    return isStartLeft ? rect.right : rect.left;
}

});

parcelRegister("d4haZ", function(module, exports) {
$parcel$export(module.exports, "toLegacyPlacement", function () { return $9838f8eed70ee314$export$e9a6fdb80170ffd; });
/**
 * `@popperjs/core`'s `Placement` union is a strict subset of `TLegacyPlacement`
 * (the placement-map adds `top-center` / `bottom-center` on top of popper's
 * enum), so every value popper hands us is a valid legacy placement.
 *
 * The cast keeps the runtime path free of an extra module-level lookup that
 * bundlers can occasionally fail to wire up (observed as `Cannot read
 * properties of undefined (reading 'includes')` in component-test bundles).
 *
 * Shared so the React and imperative popper adapters resolve this identically.
 */ function $9838f8eed70ee314$export$e9a6fdb80170ffd(placement) {
    return placement;
}

});

parcelRegister("aunCi", function(module, exports) {
$parcel$export(module.exports, "useFitViewportMaxSize", function () { return $7a2f067f02466300$export$f16d8ac7373995e1; });

var $lFOXD = parcelRequire("lFOXD");

var $1oC0p = parcelRequire("1oC0p");

var $bhLXQ = parcelRequire("bhLXQ");
/**
 * Applies the `shouldFitViewport` size caps directly to the
 * `position-area`-anchored popover host. Pure CSS — the browser owns every
 * value, so there is no measurement, no scroll/resize listeners, and no
 * `--ds-popper-anchor-*` custom properties.
 *
 * **Primary (placement) axis** is capped to `calc(100% - 5px - gap)`. Because
 * the host carries `position-area`, its containing block *is* the position-area
 * cell — the region between the anchor edge and the viewport edge — so `100%`
 * resolves to that distance. The popover is pushed `gap` into the cell by its
 * offset margin (`margin-*`, set by `useAnchorPosition`), so the gap is
 * subtracted as well to keep the legacy `viewportPadding = 5` on the far edge.
 * The cap is also more correct than measuring the requested placement: the cell
 * follows whichever side `position-try-fallbacks` actually flips to, so it
 * tracks the flip automatically.
 *
 * **Cross axis** is capped to `calc(100dvw|dvh - 10px)` (viewport, legacy
 * `2 * viewportPadding`). `display: flex` (plus a `min-*-size: 0` reset on the
 * child) lets an oversized child shrink and reflow to the cap. The host stays
 * `overflow: visible` so it never clips the consumer surface's `box-shadow`;
 * scrolling content that cannot reflow is the consumer surface's own
 * responsibility (it owns `overflow`), matching legacy `react-popper`, which
 * applied the cap to the consumer's own element.
 *
 * `min-inline-size` is reset to `0`. `useWidthFromAnchor({ mode: 'none' })`
 * floors the host at `max-content` so a too-narrow span overflows and drives
 * `position-try-fallbacks` rather than wrapping. That floor is the opposite of
 * fitting: when it exceeds a cap, CSS min/max resolution lets the min win and
 * the host overflows the viewport. In fit mode the caps must win, so the floor
 * is neutralised here; `setStyle` restores the prior inline value on cleanup.
 *
 * Verified in Chromium: `max-block-size: calc(100% - …)` on a `position: fixed`
 * + `position-area` element resolves `100%` to the cell, not the viewport.
 */ var $7a2f067f02466300$var$CROSS_INLINE_CAP = 'calc(100dvw - 10px)';
var $7a2f067f02466300$var$CROSS_BLOCK_CAP = 'calc(100dvh - 10px)';
/**
 * Legacy `viewportPadding` (`preventOverflow` padding) the popover kept from
 * every viewport edge under `react-popper`. The caps above already *reserve*
 * this space (`- 5px` on the primary far edge, `- 10px` = `2 * 5px` on the
 * cross axis), but nothing makes the reservation land on the viewport side:
 * the anchor-side gap is a real margin (`useAnchorPosition`'s `edgeMargin`),
 * the viewport side has none, so a capped popover packs flush against the
 * viewport edge it slid/flipped to. Re-applying the padding as a margin on the
 * three non-anchor sides puts the reserved space back on the viewport side.
 * `position-try` flips mirror margins and slides keep them per-side, so the
 * gap tracks whichever edge the browser settles on.
 */ var $7a2f067f02466300$var$VIEWPORT_PADDING = '5px';
/**
 * The popover's three non-anchor margin sides for a given placement axis — the
 * primary *far* side plus both cross sides. The remaining (anchor-facing) side
 * already carries the offset gap from `useAnchorPosition` and is left alone.
 */ var $7a2f067f02466300$var$NON_ANCHOR_MARGIN_SIDES = {
    top: [
        'margin-block-start',
        'margin-inline-start',
        'margin-inline-end'
    ],
    bottom: [
        'margin-block-end',
        'margin-inline-start',
        'margin-inline-end'
    ],
    left: [
        'margin-inline-start',
        'margin-block-start',
        'margin-block-end'
    ],
    right: [
        'margin-inline-end',
        'margin-block-start',
        'margin-block-end'
    ]
};
function $7a2f067f02466300$export$f16d8ac7373995e1(_ref) {
    var target = _ref.target, placementAxis = _ref.placementAxis, gap = _ref.gap, isEnabled = _ref.isEnabled, isOpen = _ref.isOpen;
    (0, $1oC0p.useLayoutEffect)(function() {
        var element = target.current;
        if (!element || !isEnabled) return;
        var isBlockAxis = placementAxis === 'top' || placementAxis === 'bottom';
        var primaryAxisCap = "calc(100% - 5px - ".concat(gap, ")");
        var cleanupHost = (0, $bhLXQ.setStyle)({
            element: element,
            styles: [
                {
                    property: 'display',
                    value: 'flex'
                },
                // Neutralise `useWidthFromAnchor`'s `min-inline-size: max-content`
                // floor so the caps below win and content reflows. `setStyle`
                // restores the floor on cleanup.
                //
                // This package only uses `mode: 'none'`. Note that `mode: 'min-anchor'`
                // puts its ANCHOR floor on the same property, so pairing this hook with
                // that mode would drop the anchor floor rather than a content floor. See
                // `@atlaskit/top-layer` `notes/decisions/width-from-anchor-floors.md`.
                {
                    property: 'min-inline-size',
                    value: '0'
                },
                isBlockAxis ? {
                    property: 'max-block-size',
                    value: primaryAxisCap
                } : {
                    property: 'max-inline-size',
                    value: primaryAxisCap
                },
                isBlockAxis ? {
                    property: 'max-inline-size',
                    value: $7a2f067f02466300$var$CROSS_INLINE_CAP
                } : {
                    property: 'max-block-size',
                    value: $7a2f067f02466300$var$CROSS_BLOCK_CAP
                }
            ].concat((0, $lFOXD.default)($7a2f067f02466300$var$NON_ANCHOR_MARGIN_SIDES[placementAxis].map(function(property) {
                return {
                    property: property,
                    value: $7a2f067f02466300$var$VIEWPORT_PADDING
                };
            })))
        });
        // The host deliberately stays `overflow: visible`. An ancestor with
        // `overflow: auto` clips a descendant's `box-shadow`, so capping and
        // scrolling on the host would strip the elevation shadow from the
        // consumer surface. Instead the host only constrains size; scrolling
        // oversized content is the consumer surface's own responsibility,
        // matching the contract `@atlaskit/top-layer`'s `PopoverSurface` follows
        // (shadow and `overflow` on one element). For that surface (the host's
        // flex child) to be clamped to the cap and scroll its own content, it
        // must be allowed to shrink below its intrinsic size, so reset its
        // min-size floor.
        var child = element.firstElementChild;
        var cleanupChild = child instanceof HTMLElement ? (0, $bhLXQ.setStyle)({
            element: child,
            styles: [
                {
                    property: 'min-block-size',
                    value: '0'
                },
                {
                    property: 'min-inline-size',
                    value: '0'
                }
            ]
        }) : undefined;
        return function() {
            cleanupHost();
            cleanupChild === null || cleanupChild === void 0 || cleanupChild();
        };
    }, [
        target,
        placementAxis,
        gap,
        isEnabled,
        isOpen
    ]);
}

});
parcelRegister("bhLXQ", function(module, exports) {
$parcel$export(module.exports, "setStyle", function () { return $83767cec90300e4b$export$37a5fde709c1db82; });
/**
 * Sets inline styles on an element and returns a cleanup function that
 * restores the prior inline values (so we do not stomp consumer styles).
 *
 * Copied from `@atlaskit/top-layer`'s internal `setStyle` (not exported there
 * yet); inline here until top-layer exposes it via a subpath export.
 */ function $83767cec90300e4b$export$37a5fde709c1db82(_ref) {
    var element = _ref.element, styles = _ref.styles;
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    var priorValues = styles.map(function(_ref2) {
        var property = _ref2.property;
        return {
            property: property,
            value: element.style.getPropertyValue(property)
        };
    });
    styles.forEach(function(_ref3) {
        var property = _ref3.property, value = _ref3.value;
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(function(_ref4) {
            var property = _ref4.property, value = _ref4.value;
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}

});


parcelRegister("aKkpJ", function(module, exports) {
$parcel$export(module.exports, "useManagerAnchor", function () { return $7d2e090e2707069b$export$941a7e8bf0b9eafd; });

var $1oC0p = parcelRequire("1oC0p");

var $fvM1S = parcelRequire("fvM1S");
function $7d2e090e2707069b$export$941a7e8bf0b9eafd() {
    return (0, $1oC0p.useContext)((0, $fvM1S.AnchorContext));
}

});
parcelRegister("fvM1S", function(module, exports) {
$parcel$export(module.exports, "AnchorContext", function () { return $b4af01e6ae9d997c$export$8f73317645bb7b8e; });

var $1oC0p = parcelRequire("1oC0p");
var $b4af01e6ae9d997c$export$8f73317645bb7b8e = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});


parcelRegister("grvl6", function(module, exports) {
$parcel$export(module.exports, "useReferenceVisibility", function () { return $bf877a49ad993be2$export$61d36e2b682e92f7; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $brG9L = parcelRequire("brG9L");
var $bf877a49ad993be2$var$INITIAL = {
    isReferenceHidden: false,
    hasPopperEscaped: false
};
function $bf877a49ad993be2$var$isFullyOutsideViewport(rect, viewport) {
    if (rect.width === 0 && rect.height === 0) return true;
    if (rect.bottom <= 0) return true;
    if (rect.right <= 0) return true;
    if (rect.top >= viewport.height) return true;
    if (rect.left >= viewport.width) return true;
    return false;
}
function $bf877a49ad993be2$var$isClippingOverflow(value) {
    return value === 'auto' || value === 'scroll' || value === 'hidden' || value === 'clip';
}
function $bf877a49ad993be2$var$isClippedByAncestors(element) {
    var rect = element.getBoundingClientRect();
    var parent = element.parentElement;
    while(parent){
        // Read the longhand axis properties directly. The `overflow` shorthand
        // is only populated when both axes share the same value, so reading it
        // alone misses ancestors that set only `overflow-x` or `overflow-y`.
        var style = window.getComputedStyle(parent);
        var clipsHorizontally = $bf877a49ad993be2$var$isClippingOverflow(style.overflowX);
        var clipsVertically = $bf877a49ad993be2$var$isClippingOverflow(style.overflowY);
        if (clipsHorizontally || clipsVertically) {
            var parentRect = parent.getBoundingClientRect();
            var horizontallyOutside = rect.right <= parentRect.left || rect.left >= parentRect.right;
            var verticallyOutside = rect.bottom <= parentRect.top || rect.top >= parentRect.bottom;
            if (clipsHorizontally && horizontallyOutside) return true;
            if (clipsVertically && verticallyOutside) return true;
        }
        parent = parent.parentElement;
    }
    return false;
}
function $bf877a49ad993be2$export$61d36e2b682e92f7(_ref) {
    var anchor = _ref.anchor, popoverRef = _ref.popoverRef;
    var _useState = (0, $1oC0p.useState)($bf877a49ad993be2$var$INITIAL), _useState2 = (0, $2qaZZ.default)(_useState, 2), visibility = _useState2[0], setVisibility = _useState2[1];
    var measure = (0, $1oC0p.useCallback)(function() {
        if (!anchor) {
            setVisibility(function(previous) {
                return previous.isReferenceHidden === false && previous.hasPopperEscaped === false ? previous : $bf877a49ad993be2$var$INITIAL;
            });
            return;
        }
        var viewport = (0, $brG9L.readViewport)();
        var anchorRect = anchor.getBoundingClientRect();
        var isReferenceHidden = $bf877a49ad993be2$var$isFullyOutsideViewport(anchorRect, viewport) || $bf877a49ad993be2$var$isClippedByAncestors(anchor);
        var popoverElement = popoverRef.current;
        var hasPopperEscaped = popoverElement ? $bf877a49ad993be2$var$isFullyOutsideViewport(popoverElement.getBoundingClientRect(), viewport) : false;
        setVisibility(function(previous) {
            if (previous.isReferenceHidden === isReferenceHidden && previous.hasPopperEscaped === hasPopperEscaped) return previous;
            return {
                isReferenceHidden: isReferenceHidden,
                hasPopperEscaped: hasPopperEscaped
            };
        });
    }, [
        anchor,
        popoverRef
    ]);
    (0, $1oC0p.useLayoutEffect)(function() {
        measure();
        if (typeof window === 'undefined') return undefined;
        var cleanups = [];
        // Resize observer on the anchor so layout changes update visibility.
        if (anchor && typeof ResizeObserver !== 'undefined') {
            var observer = new ResizeObserver(function() {
                return measure();
            });
            observer.observe(anchor);
            cleanups.push(function() {
                return observer.disconnect();
            });
        }
        // Scroll + resize: any scroll event in the document can move the
        // anchor in/out of any scrollable ancestor's viewport.
        cleanups.push((0, $dH1HR.bindAll)(window, [
            {
                type: 'scroll',
                listener: measure,
                options: {
                    capture: true,
                    passive: true
                }
            },
            {
                type: 'resize',
                listener: measure,
                options: {
                    passive: true
                }
            }
        ]));
        var visual = window.visualViewport;
        if (visual) cleanups.push((0, $dH1HR.bind)(visual, {
            type: 'resize',
            listener: measure,
            options: {
                passive: true
            }
        }));
        return function() {
            cleanups.forEach(function(cleanup) {
                return cleanup();
            });
        };
    }, [
        anchor,
        measure
    ]);
    return visibility;
}

});
parcelRegister("brG9L", function(module, exports) {
$parcel$export(module.exports, "readViewport", function () { return $8552eabaf70d5ef8$export$64beed533e21f72d; });
/**
 * Returns the current viewport size in CSS pixels, preferring the visual
 * viewport (which accounts for pinch-zoom on touch devices) over the
 * layout viewport. Returns `{ width: 0, height: 0 }` in non-DOM
 * environments so callers can use the result unconditionally.
 */ function $8552eabaf70d5ef8$export$64beed533e21f72d() {
    if (typeof window === 'undefined') return {
        width: 0,
        height: 0
    };
    var visual = window.visualViewport;
    if (visual) return {
        width: visual.width,
        height: visual.height
    };
    return {
        width: window.innerWidth,
        height: window.innerHeight
    };
}

});




parcelRegister("8O6sf", function(module, exports) {
$parcel$export(module.exports, "register", function () { return $6697ffff412e1a23$export$6503ec6e8aabbaf; });
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $dH1HR = parcelRequire("dH1HR");
var $6697ffff412e1a23$var$registrations = new Set();
var $6697ffff412e1a23$var$cleanupEndEventListeners = null;
function $6697ffff412e1a23$var$onDragStart() {
    if ($6697ffff412e1a23$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $6697ffff412e1a23$var$cleanupEndEventListeners = (0, $dH1HR.bindAll)(window, [
        {
            type: 'dragend',
            listener: $6697ffff412e1a23$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $6697ffff412e1a23$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $6697ffff412e1a23$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($6697ffff412e1a23$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $6697ffff412e1a23$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $6697ffff412e1a23$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $6697ffff412e1a23$var$cleanupEndEventListeners = null;
    var clone = Array.from($6697ffff412e1a23$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $6697ffff412e1a23$var$bindStartEvents() {
    return (0, $dH1HR.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $6697ffff412e1a23$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $6697ffff412e1a23$var$onDragStart
        }
    ]);
}
var $6697ffff412e1a23$var$cleanupStartEventListeners = null;
function $6697ffff412e1a23$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$6697ffff412e1a23$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $6697ffff412e1a23$var$cleanupStartEventListeners = $6697ffff412e1a23$var$bindStartEvents();
    $6697ffff412e1a23$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $6697ffff412e1a23$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $6697ffff412e1a23$var$registrations.delete(registration);
        if ($6697ffff412e1a23$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $6697ffff412e1a23$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $6697ffff412e1a23$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("hbilF", function(module, exports) {
$parcel$export(module.exports, "getAnchorPoint", function () { return $c821b25bd62de38c$export$d26fd3d066ede49; });
/**
 * Returns the trigger's X edge for inline-axis placements, or the
 * trigger's horizontal center for block-axis placements.
 *
 * Note: does not account for RTL writing modes.
 */ function $c821b25bd62de38c$var$getTriggerEdgeX(_ref) {
    var triggerRect = _ref.triggerRect, placement = _ref.placement;
    if (placement.axis === 'inline') return placement.edge === 'start' ? triggerRect.left : triggerRect.right;
    return triggerRect.left + triggerRect.width / 2;
}
/**
 * Returns the trigger's Y edge for block-axis placements, or the
 * trigger's vertical center for inline-axis placements.
 */ function $c821b25bd62de38c$var$getTriggerEdgeY(_ref2) {
    var triggerRect = _ref2.triggerRect, placement = _ref2.placement;
    if (placement.axis === 'block') return placement.edge === 'start' ? triggerRect.top : triggerRect.bottom;
    return triggerRect.top + triggerRect.height / 2;
}
function $c821b25bd62de38c$export$d26fd3d066ede49(_ref3) {
    var cursor = _ref3.cursor, triggerRect = _ref3.triggerRect, tooltipPosition = _ref3.tooltipPosition, placement = _ref3.placement;
    if (tooltipPosition === 'mouse-y') return {
        x: $c821b25bd62de38c$var$getTriggerEdgeX({
            triggerRect: triggerRect,
            placement: placement
        }),
        y: cursor.clientY
    };
    if (tooltipPosition === 'mouse-x') return {
        x: cursor.clientX,
        y: $c821b25bd62de38c$var$getTriggerEdgeY({
            triggerRect: triggerRect,
            placement: placement
        })
    };
    // tooltipPosition === 'mouse'
    return {
        x: cursor.clientX,
        y: cursor.clientY
    };
}

});

parcelRegister("3Cc2B", function(module, exports) {
$parcel$export(module.exports, "getVirtualElementFromMousePos", function () { return $2a1e42c81d4cec35$export$2e68479e0a5d8746; });
function $2a1e42c81d4cec35$export$2e68479e0a5d8746(mousePos, _ref) {
    var targetElement = _ref.targetElement, tooltipPosition = _ref.tooltipPosition;
    if (tooltipPosition === 'mouse') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: mousePos.clientY,
                width: 0,
                height: 0
            });
        }
    };
    var targetRect = targetElement.getBoundingClientRect();
    if (tooltipPosition === 'mouse-x') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: targetRect.top,
                width: 0,
                height: targetRect.height
            });
        }
    };
    if (tooltipPosition === 'mouse-y') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: targetRect.left,
                y: mousePos.clientY,
                width: targetRect.width,
                height: 0
            });
        }
    };
    throw new Error("Invalid tooltip position for virtual element: ".concat(tooltipPosition));
}

});

parcelRegister("9Ozog", function(module, exports) {
$parcel$export(module.exports, "show", function () { return $72543c5ab8410b67$export$57bf213be019eeb0; });

var $6ur0l = parcelRequire("6ur0l");
var $72543c5ab8410b67$var$delayId = null;
function $72543c5ab8410b67$var$clearScheduled() {
    if ($72543c5ab8410b67$var$delayId != null) {
        window.clearTimeout($72543c5ab8410b67$var$delayId);
        $72543c5ab8410b67$var$delayId = null;
    }
}
function $72543c5ab8410b67$var$scheduleTimeout(fn, delay) {
    $72543c5ab8410b67$var$clearScheduled();
    $72543c5ab8410b67$var$delayId = window.setTimeout(function() {
        $72543c5ab8410b67$var$delayId = null;
        fn();
    }, delay);
}
// This file is a singleton for managing tooltips.
//
// Once we roll out top-layer and remove the legacy path, this manager can be simplified:
// - Singleton: Can be removed; the platform (popover="auto" or popover="hint") already enforces
//   only one tooltip open at a time.
// - Phase machine: Can be simplified; drop hide-animating and finishHideAnimation (legacy fade-out).
//   Use e.g. pending-show | visible | pending-hide with immediate hide.
// - API: Can drop or simplify mousePosition/mousePos if no longer needed; keep delay scheduling,
//   keep(), requestHide, abort, and minimal lifecycle.
var $72543c5ab8410b67$var$active = null;
function $72543c5ab8410b67$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($72543c5ab8410b67$var$active && $72543c5ab8410b67$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            $72543c5ab8410b67$var$clearScheduled();
            $72543c5ab8410b67$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            $72543c5ab8410b67$var$clearScheduled();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            $72543c5ab8410b67$var$clearScheduled();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        // Bug in legacy path: isImmediate hide requests are ignored during waiting-to-hide,
        // meaning Escape/scroll won't instantly dismiss a tooltip that's already fading out.
        // Gated fix: only apply the immediate-hide behavior under the top-layer flag for now.
        if (phase === 'waiting-to-hide') {
            if (isImmediate && (0, $6ur0l.fg)('platform-dst-top-layer-tooltip')) immediatelyHideAndDone();
            return;
        }
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        $72543c5ab8410b67$var$scheduleTimeout(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function start() {
        var shouldAlwaysFadeIn = entry.shouldAlwaysFadeIn;
        var showImmediately = Boolean($72543c5ab8410b67$var$active && $72543c5ab8410b67$var$active.isVisible()) && !shouldAlwaysFadeIn;
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($72543c5ab8410b67$var$active) {
            $72543c5ab8410b67$var$clearScheduled();
            $72543c5ab8410b67$var$active.entry.hide({
                isImmediate: true
            });
            $72543c5ab8410b67$var$active.entry.done();
            $72543c5ab8410b67$var$active = null;
        }
        // this tooltip is now the active tooltip
        $72543c5ab8410b67$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        $72543c5ab8410b67$var$scheduleTimeout(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePos: entry.source.type === 'mouse' ? {
            clientX: entry.source.clientX,
            clientY: entry.source.clientY
        } : null
    };
    return result;
}

});

parcelRegister("bnftV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $847dda077daa4d06$export$2e2bcd8739ae039; });

var $2vZJL = parcelRequire("2vZJL");
function $847dda077daa4d06$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $2vZJL.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});
parcelRegister("2vZJL", function(module, exports) {
$parcel$export(module.exports, "useIdSeed", function () { return $1d4e5dc0ecb5b1be$export$6ee17796e3d70de2; });

var $4UF4U = parcelRequire("4UF4U");
function $1d4e5dc0ecb5b1be$export$6ee17796e3d70de2() {
    var uid = (0, $4UF4U.useId)();
    return function(id) {
        return "".concat(uid, "-").concat(id.toString());
    };
}

});


parcelRegister("kp4DZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $eda9beac08093f96$export$2e2bcd8739ae039; });
/* tooltip-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8Uo48 = parcelRequire("8Uo48");
var $eda9beac08093f96$var$styles = {
    base: "_2rkofajl _11c8wadc _vchhusvi _p12fp3fh _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $eda9beac08093f96$var$TooltipContainer = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut, role = _ref.role;
    return /*#__PURE__*/ $1oC0p.createElement((0, $8Uo48.default), {
        ref: ref,
        style: style,
        className: (0, $2jatx.default)([
            $eda9beac08093f96$var$styles.base,
            truncate && $eda9beac08093f96$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut,
        role: role
    }, children);
});
$eda9beac08093f96$var$TooltipContainer.displayName = 'TooltipContainer';
var $eda9beac08093f96$export$2e2bcd8739ae039 = $eda9beac08093f96$var$TooltipContainer;

});
parcelRegister("8Uo48", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $67c638a91a570cde$export$2e2bcd8739ae039; });
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $9e03Q = parcelRequire("9e03Q");
var $67c638a91a570cde$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $67c638a91a570cde$var$TooltipPrimitive = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut, _ref$role = _ref.role, role = _ref$role === void 0 ? 'tooltip' : _ref$role;
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $1oC0p.createElement("div", {
        role: role,
        className: (0, $2jatx.default)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children, shortcut && /*#__PURE__*/ $1oC0p.createElement((0, $9e03Q.TooltipShortcut), {
        shortcut: shortcut
    })));
});
$67c638a91a570cde$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $67c638a91a570cde$export$2e2bcd8739ae039 = $67c638a91a570cde$var$TooltipPrimitive;

});
parcelRegister("9e03Q", function(module, exports) {
$parcel$export(module.exports, "TooltipShortcut", function () { return $6b7577fe82b6dfb2$export$5bcbc43c84236222; });
/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6b7577fe82b6dfb2$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c8wadc _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
var $6b7577fe82b6dfb2$export$5bcbc43c84236222 = function TooltipShortcut(_ref) {
    var shortcut = _ref.shortcut;
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        className: (0, $2jatx.default)([
            $6b7577fe82b6dfb2$var$styles.shortcutSegmentsContainer
        ])
    }, shortcut.map(function(segment, index) {
        return /*#__PURE__*/ $1oC0p.createElement("kbd", {
            key: "".concat(segment, "-").concat(index),
            className: (0, $2jatx.default)([
                $6b7577fe82b6dfb2$var$styles.shortcutSegment
            ])
        }, segment);
    }));
};

});




parcelRegister("ckHGa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8fa93c0832c102e4$export$2e2bcd8739ae039; });
/* visually-hidden.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $8fa93c0832c102e4$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $8fa93c0832c102e4$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $2jatx.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ])
    }, children);
};
$8fa93c0832c102e4$var$VisuallyHidden.displayName = 'VisuallyHidden';
var $8fa93c0832c102e4$export$2e2bcd8739ae039 = $8fa93c0832c102e4$var$VisuallyHidden;

});

parcelRegister("3aj1x", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $24e10ffbf6b8e2c5$export$2e2bcd8739ae039; });
/* button-base.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $4ZpaI = parcelRequire("4ZpaI");

var $kPutE = parcelRequire("kPutE");

var $gyCsW = parcelRequire("gyCsW");

var $4UF4U = parcelRequire("4UF4U");

var $6ur0l = parcelRequire("6ur0l");

var $b8nZ2 = parcelRequire("b8nZ2");

var $ckHGa = parcelRequire("ckHGa");

var $cjAw4 = parcelRequire("cjAw4");

var $4P0FC = parcelRequire("4P0FC");

var $83yV9 = parcelRequire("83yV9");

var $haKw5 = parcelRequire("haKw5");
var $24e10ffbf6b8e2c5$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isIconButton",
    "isCircle",
    "hasIconBefore",
    "hasIconAfter",
    "shouldFitContainer",
    "spacing",
    "ariaLabel",
    "ariaLabelledBy",
    "children",
    "interactionName",
    "onClick",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onClickCapture",
    "testId",
    "analyticsContext",
    "componentName",
    "role",
    "onMouseOver",
    "onMouseOut",
    "onFocus",
    "onBlur",
    "onMouseMove",
    "type"
], $24e10ffbf6b8e2c5$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $24e10ffbf6b8e2c5$var$LOADING_LABEL = ', Loading';
var $24e10ffbf6b8e2c5$var$styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    interactiveMotion: "_v564k6bl _1ggl5xtf",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1gmx _30l31gmx _9h8h1gmx",
    sharedDisabled: "_bfhk187o _irr3187o _1di6187o",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    spacingCompactT26Shape: "_2rko12b0",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var $24e10ffbf6b8e2c5$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $24e10ffbf6b8e2c5$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
var $24e10ffbf6b8e2c5$var$rovoStyles = {
    root: "_bfhklqh9 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31afz _9h8h15cr _1di61kru"
};
var $24e10ffbf6b8e2c5$var$warningStyles = {
    root: "_bfhk1kmu _syaz1yd3 _10531yd3 _f8pj1yd3 _30l31yd3 _9h8h1yd3",
    interactive: "_30l31yd3 _irr31spp _9h8h1yd3 _1di64m4m"
};
var $24e10ffbf6b8e2c5$var$dangerStyles = {
    root: "_bfhkybec _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3s9hg _9h8h15cr _1di613a9"
};
var $24e10ffbf6b8e2c5$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
var $24e10ffbf6b8e2c5$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $24e10ffbf6b8e2c5$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    warning: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    danger: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $24e10ffbf6b8e2c5$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
function(_ref, ref) {
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    var propAppearance = _ref.appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, children = _ref.children, interactionName = _ref.interactionName, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUp = _ref.onMouseUp, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUp = _ref.onKeyUp, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStart = _ref.onTouchStart, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEnd = _ref.onTouchEnd, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDown = _ref.onPointerDown, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUp = _ref.onPointerUp, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, testId = _ref.testId, analyticsContext = _ref.analyticsContext, componentName = _ref.componentName, role = _ref.role, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onMouseMove = _ref.onMouseMove, type = _ref.type, unsafeRest = (0, $gnQ3X.default)(_ref, $24e10ffbf6b8e2c5$var$_excluded);
    var localRef = (0, $1oC0p.useRef)(null);
    var splitButtonContext = (0, $4P0FC.useSplitButtonContext)();
    var loadingLabelId = (0, $4UF4U.useId)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    var appearance = isDefaultAppearanceSplitButton ? 'subtle' : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || 'default';
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $gyCsW.default)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $gnQ3X.default)(unsafeRest, $24e10ffbf6b8e2c5$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $b8nZ2.Pressable), (0, $c9bqK.default)({}, saferRest, {
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $kPutE.default)([
            localRef,
            ref
        ]),
        xcss: (0, $4ZpaI.cx)($24e10ffbf6b8e2c5$var$styles.base, (0, $6ur0l.fg)('platform-dst-shape-theme-default') && $24e10ffbf6b8e2c5$var$styles.baseT26Shape, isInteractive && (0, $6ur0l.fg)('platform-dst-motion-uplift-button') && $24e10ffbf6b8e2c5$var$styles.interactiveMotion, appearance === 'default' && $24e10ffbf6b8e2c5$var$defaultStyles.root, appearance === 'default' && isInteractive && $24e10ffbf6b8e2c5$var$defaultStyles.interactive, appearance === 'primary' && $24e10ffbf6b8e2c5$var$primaryStyles.root, appearance === 'primary' && isInteractive && $24e10ffbf6b8e2c5$var$primaryStyles.interactive, appearance === 'rovo' && $24e10ffbf6b8e2c5$var$rovoStyles.root, appearance === 'rovo' && isInteractive && $24e10ffbf6b8e2c5$var$rovoStyles.interactive, appearance === 'warning' && $24e10ffbf6b8e2c5$var$warningStyles.root, appearance === 'warning' && isInteractive && $24e10ffbf6b8e2c5$var$warningStyles.interactive, appearance === 'danger' && $24e10ffbf6b8e2c5$var$dangerStyles.root, appearance === 'danger' && isInteractive && $24e10ffbf6b8e2c5$var$dangerStyles.interactive, appearance === 'discovery' && $24e10ffbf6b8e2c5$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $24e10ffbf6b8e2c5$var$discoveryStyles.interactive, appearance === 'subtle' && $24e10ffbf6b8e2c5$var$subtleStyles.root, appearance === 'subtle' && isInteractive && $24e10ffbf6b8e2c5$var$subtleStyles.interactive, $24e10ffbf6b8e2c5$var$styles.linkDecorationUnset, isSelected && $24e10ffbf6b8e2c5$var$selectedStyles.root, isSelected && isSplitButton && $24e10ffbf6b8e2c5$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $24e10ffbf6b8e2c5$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $24e10ffbf6b8e2c5$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $24e10ffbf6b8e2c5$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $24e10ffbf6b8e2c5$var$selectedStyles.discovery, isDisabled && $24e10ffbf6b8e2c5$var$styles.disabled, isDisabled && appearance !== 'default' && appearance !== 'subtle' && $24e10ffbf6b8e2c5$var$styles.sharedDisabled, isDisabled && appearance === 'default' && $24e10ffbf6b8e2c5$var$defaultStyles.disabled, spacing === 'compact' && $24e10ffbf6b8e2c5$var$styles.spacingCompact, spacing === 'compact' && (0, $6ur0l.fg)('platform-dst-shape-theme-default') && $24e10ffbf6b8e2c5$var$styles.spacingCompactT26Shape, // This must come after spacing compact styling as it overrides the border radius
        isCircle && !isSplitButton && $24e10ffbf6b8e2c5$var$styles.circle, shouldFitContainer && $24e10ffbf6b8e2c5$var$styles.fullWidth, hasIconBefore && $24e10ffbf6b8e2c5$var$styles.buttonIconBefore, hasIconAfter && $24e10ffbf6b8e2c5$var$styles.buttonIconAfter, isIconButton && $24e10ffbf6b8e2c5$var$styles.iconButton, isIconButton && spacing === 'compact' && $24e10ffbf6b8e2c5$var$styles.iconButtonCompact, isLoading && $24e10ffbf6b8e2c5$var$styles.loading, isSplitButton && $24e10ffbf6b8e2c5$var$styles.splitButton, isNavigationSplitButton && $24e10ffbf6b8e2c5$var$styles.navigationSplitButton),
        isDisabled: (0, $6ur0l.fg)('platform-dst_fix_not_focusable_loading_button') ? isDisabled : isEffectivelyDisabled
    }, (0, $6ur0l.fg)('platform-dst_fix_not_focusable_loading_button') && {
        'aria-live': 'polite'
    }, isLoading && (0, $6ur0l.fg)('platform-dst_fix_not_focusable_loading_button') && {
        'aria-disabled': true
    }, {
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat($24e10ffbf6b8e2c5$var$LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }, (0, $83yV9.default)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cjAw4.SplitButtonContext).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        className: (0, $2jatx.default)([
            $24e10ffbf6b8e2c5$var$styles.loadingOverlay
        ])
    }, (0, $haKw5.default)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $ckHGa.default), {
        id: loadingLabelId
    }, $24e10ffbf6b8e2c5$var$LOADING_LABEL)));
});
var $24e10ffbf6b8e2c5$export$2e2bcd8739ae039 = $24e10ffbf6b8e2c5$var$ButtonBase;

});
parcelRegister("b8nZ2", function(module, exports) {
$parcel$export(module.exports, "Pressable", function () { return $81b30bb1dd2a079f$export$27c701ed9e449e99; });
/* pressable.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");


var $3sHnI = parcelRequire("3sHnI");

var $cTnMe = parcelRequire("cTnMe");

var $8EKpD = parcelRequire("8EKpD");

var $7uNuF = parcelRequire("7uNuF");

var $hGQNn = parcelRequire("hGQNn");

var $bRZnf = parcelRequire("bRZnf");
var $81b30bb1dd2a079f$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $81b30bb1dd2a079f$var$_excluded2 = [
    "className"
];
var $81b30bb1dd2a079f$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
var $81b30bb1dd2a079f$export$27c701ed9e449e99 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $7uNuF.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, $gnQ3X.default)(_ref, $81b30bb1dd2a079f$var$_excluded);
    var interactionContext = (0, $1oC0p.useContext)((0, $hGQNn.default));
    var handleClick = (0, $1oC0p.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $cTnMe.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "22.4.1",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $gnQ3X.default)(htmlAttributes, $81b30bb1dd2a079f$var$_excluded2);
    return /*#__PURE__*/ $1oC0p.createElement((0, $bRZnf.Focusable), (0, $c9bqK.default)({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $8EKpD.isSafari)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $3sHnI.cx)($81b30bb1dd2a079f$var$styles.root, isDisabled && $81b30bb1dd2a079f$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});

});
parcelRegister("hGQNn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ce0f4ff86b3b368a$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
var $ce0f4ff86b3b368a$var$interactionContext = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
var $ce0f4ff86b3b368a$export$2e2bcd8739ae039 = $ce0f4ff86b3b368a$var$interactionContext;

});

parcelRegister("bRZnf", function(module, exports) {
$parcel$export(module.exports, "Focusable", function () { return $8a44408cdc47afed$export$35a3bebf7ef2d934; });
/* focusable.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $8a44408cdc47afed$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $8a44408cdc47afed$var$_excluded2 = [
    "className"
];
var $8a44408cdc47afed$var$focusRingStyles = null;
var $8a44408cdc47afed$var$insetFocusRingStyles = null;
var $8a44408cdc47afed$export$35a3bebf7ef2d934 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, $gnQ3X.default)(_ref, $8a44408cdc47afed$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $gnQ3X.default)(htmlAttributes, $8a44408cdc47afed$var$_excluded2);
    return /*#__PURE__*/ $1oC0p.createElement(Component, (0, $c9bqK.default)({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $2jatx.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});

});


parcelRegister("cjAw4", function(module, exports) {
$parcel$export(module.exports, "SplitButtonContext", function () { return $8f7395bfc41cdbd9$export$4b86304b2c0d7e71; });
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $1oC0p = parcelRequire("1oC0p");
var $8f7395bfc41cdbd9$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);

});

parcelRegister("4P0FC", function(module, exports) {
$parcel$export(module.exports, "useSplitButtonContext", function () { return $382c71ee55316e65$export$47e2c6fdb142d947; });

var $1oC0p = parcelRequire("1oC0p");

var $cjAw4 = parcelRequire("cjAw4");
var $382c71ee55316e65$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $1oC0p.useContext)((0, $cjAw4.SplitButtonContext));
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        var newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("83yV9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5dd9b11b5da463fa$export$2e2bcd8739ae039; });
function $5dd9b11b5da463fa$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $5dd9b11b5da463fa$var$tabKeyCode = 9;
function $5dd9b11b5da463fa$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $5dd9b11b5da463fa$var$tabKeyCode) return;
    $5dd9b11b5da463fa$var$abort(event);
}
function $5dd9b11b5da463fa$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $5dd9b11b5da463fa$var$abort,
        onMouseUpCapture: $5dd9b11b5da463fa$var$abort,
        onKeyDownCapture: $5dd9b11b5da463fa$var$onKey,
        onKeyUpCapture: $5dd9b11b5da463fa$var$onKey,
        onTouchStartCapture: $5dd9b11b5da463fa$var$abort,
        onTouchEndCapture: $5dd9b11b5da463fa$var$abort,
        onPointerDownCapture: $5dd9b11b5da463fa$var$abort,
        onPointerUpCapture: $5dd9b11b5da463fa$var$abort,
        onClickCapture: $5dd9b11b5da463fa$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $5dd9b11b5da463fa$var$abort
    } : events;
}

});

parcelRegister("haKw5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c80774114be1b658$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $hgEXN = parcelRequire("hgEXN");
function $c80774114be1b658$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $c80774114be1b658$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'rovo' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $c80774114be1b658$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $hgEXN.default), {
        size: $c80774114be1b658$var$getIconSpacing(spacing),
        appearance: $c80774114be1b658$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}

});
parcelRegister("hgEXN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c923b4cd89681cbd$export$2e2bcd8739ae039; });
/* spinner.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $hGQNn = parcelRequire("hGQNn");

var $houd6 = parcelRequire("houd6");
/**
 * Returns the appropriate circle stroke color.
 */ function $c923b4cd89681cbd$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-inverse, #FFFFFF)";
}
var $c923b4cd89681cbd$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $c923b4cd89681cbd$var$loadIn = null;
var $c923b4cd89681cbd$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o511hrf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $c923b4cd89681cbd$var$useLayoutEffect = typeof window === 'undefined' ? (0, $1oC0p.useEffect) : (0, $1oC0p.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $c923b4cd89681cbd$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $houd6.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $c923b4cd89681cbd$var$getStrokeColor(appearance);
    var context = (0, $1oC0p.useContext)((0, $hGQNn.default));
    $c923b4cd89681cbd$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $2jatx.default)([
            $c923b4cd89681cbd$var$styles.wrapperStyles,
            $c923b4cd89681cbd$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $2jatx.default)([
            $c923b4cd89681cbd$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $2jatx.default)([
            $c923b4cd89681cbd$var$styles.circleStyles
        ])
    })));
}));
var $c923b4cd89681cbd$export$2e2bcd8739ae039 = $c923b4cd89681cbd$var$Spinner;

});
parcelRegister("houd6", function(module, exports) {
$parcel$export(module.exports, "presetSizes", function () { return $ca9c1cb54a98aa67$export$4e9f1640bbe7a1a8; });
var $ca9c1cb54a98aa67$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});




parcelRegister("eEgkm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $aaa17769bc7d8888$export$2e2bcd8739ae039; });
/* content.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");
var $aaa17769bc7d8888$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $aaa17769bc7d8888$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, isLoading = _ref.isLoading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        className: (0, $2jatx.default)([
            $aaa17769bc7d8888$var$styles.common,
            type === 'text' && $aaa17769bc7d8888$var$styles.text,
            type === 'icon' && $aaa17769bc7d8888$var$styles.icon,
            isLoading && $aaa17769bc7d8888$var$styles.fade
        ])
    }, children);
};
var $aaa17769bc7d8888$export$2e2bcd8739ae039 = $aaa17769bc7d8888$var$Content;

});

parcelRegister("4mOtV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $32e06019ad32533f$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $6ur0l = parcelRequire("6ur0l");
function $32e06019ad32533f$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $32e06019ad32533f$var$IconRenderer = function IconRenderer(_ref) {
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    var Icon = _ref.icon;
    var isRenderProp = $32e06019ad32533f$var$isIconRenderProp(Icon);
    var iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $6ur0l.fg)('platform_dst_button_chevron_sizing') ? function(iconName) {
            return iconName.startsWith('Chevron') ? 'small' : 'medium';
        } : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Icon, iconProps));
};
var $32e06019ad32533f$export$2e2bcd8739ae039 = $32e06019ad32533f$var$IconRenderer;

});


parcelRegister("5gEzD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe87206c037b1ad46cb54a88ca95fa3b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3d5deb74fe887a10$var$_react = $3d5deb74fe887a10$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $3d5deb74fe887a10$var$_iconNew = $3d5deb74fe887a10$var$_interopRequireDefault((parcelRequire("4lan8")));
function $3d5deb74fe887a10$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/cross
 * Usage guidance:
 * Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3d5deb74fe887a10$var$CrossIcon = (props)=>/*#__PURE__*/ $3d5deb74fe887a10$var$_react.default.createElement($3d5deb74fe887a10$var$_iconNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.53 3.53 9.06 8l4.47 4.47-1.06 1.06L8 9.06l-4.47 4.47-1.06-1.06L6.94 8 2.47 3.53l1.06-1.06L8 6.94l4.47-4.47z"/>`
    }, props));
$3d5deb74fe887a10$var$CrossIcon.displayName = 'CrossIcon';
var $3d5deb74fe887a10$var$_default = module.exports.default = $3d5deb74fe887a10$var$CrossIcon;

});
parcelRegister("4lan8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "Icon", function () { return $32912b4e32c2c3a8$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $32912b4e32c2c3a8$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $32912b4e32c2c3a8$var$svgStyles = null;
var $32912b4e32c2c3a8$var$iconStyles = null;
var $32912b4e32c2c3a8$var$smallIconStyles = null;
var $32912b4e32c2c3a8$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $32912b4e32c2c3a8$var$baseHcmStyles = null;
var $32912b4e32c2c3a8$var$scaleSize = null;
var $32912b4e32c2c3a8$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $32912b4e32c2c3a8$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $32912b4e32c2c3a8$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $32912b4e32c2c3a8$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $32912b4e32c2c3a8$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $2jatx.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $1oC0p.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $2jatx.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $32912b4e32c2c3a8$var$coreSizeSmall[spacing] : $32912b4e32c2c3a8$var$coreSizeMedium[spacing]
        ])
    }));
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$32912b4e32c2c3a8$export$2e2bcd8739ae039 = $32912b4e32c2c3a8$export$f04a61298a47a40f;

});



parcelRegister("dYPjn", function(module, exports) {
$parcel$export(module.exports, "useModal", function () { return $a2d8ae5ca7d76b71$export$33ffd74ebf07f060; });

var $1oC0p = parcelRequire("1oC0p");

var $bgW5X = parcelRequire("bgW5X");
var $a2d8ae5ca7d76b71$export$33ffd74ebf07f060 = function useModal() {
    var modalContext = (0, $1oC0p.useContext)((0, $bgW5X.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};

});





parcelRegister("bCAvd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $61c5850de1119ed8$export$2e2bcd8739ae039; });
/* content-types-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $bQjAr = parcelRequire("bQjAr");

var $9s3Hk = parcelRequire("9s3Hk");

var $90TSV = parcelRequire("90TSV");

var $ilkqI = parcelRequire("ilkqI");

var $iyOcM = parcelRequire("iyOcM");

var $iXFL3 = parcelRequire("iXFL3");

var $7GVWk = parcelRequire("7GVWk");

var $7yyLA = parcelRequire("7yyLA");

var $9ckS1 = parcelRequire("9ckS1");

var $kY2rG = parcelRequire("kY2rG");

var $c8DdQ = parcelRequire("c8DdQ");

var $7zrqq = parcelRequire("7zrqq");

var $5EpoY = parcelRequire("5EpoY");

var $aHOGX = parcelRequire("aHOGX");

var $jg9LG = parcelRequire("jg9LG");

var $7VkQP = parcelRequire("7VkQP");
const $61c5850de1119ed8$var$tabStyles = null;
const $61c5850de1119ed8$var$iconTabListStyles = null;
const $61c5850de1119ed8$var$iconTabStyles = null;
const $61c5850de1119ed8$var$opacityIn = null;
const $61c5850de1119ed8$var$contentContainer = null;
const $61c5850de1119ed8$export$375e4d9f76d4c766 = ({ isConfluenceCrossflow: isConfluenceCrossflow = false })=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { user: user } = (0, $7GVWk.useUserContext)();
    const tabList = [
        {
            title: intl.formatMessage((0, $7VkQP.tabbedHeroSectionPagesMessages).tabName),
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9ckS1.PagesIcon), {
                width: "1.5em"
            }),
            content: (0, $5EpoY.PagesContentType),
            eventProps: {
                label: 'content-type-tab-pages',
                labelEnglish: 'Pages'
            }
        },
        {
            title: intl.formatMessage((0, $7VkQP.tabbedHeroSectionWhiteboardsMessages).tabName),
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $c8DdQ.WhiteboardsIcon), {
                width: "1.5em"
            }),
            content: (0, $jg9LG.WhiteboardsContentType),
            eventProps: {
                label: 'content-type-tab-whiteboard',
                labelEnglish: 'Whiteboards'
            }
        },
        {
            title: intl.formatMessage((0, $7VkQP.tabbedHeroSectionDatabasesMessages).tabName),
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7yyLA.DatabasesIcon), {
                width: "1.5em"
            }),
            content: (0, $7zrqq.DatabasesContentType),
            eventProps: {
                label: 'content-type-tab-databases',
                labelEnglish: 'Databases'
            }
        },
        {
            title: intl.formatMessage((0, $7VkQP.tabbedHeroSectionSpacesMessages).tabName),
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kY2rG.SpacesIcon), {
                width: "1.5em"
            }),
            content: (0, $aHOGX.SpacesContentType),
            eventProps: {
                label: 'content-type-tab-spaces',
                labelEnglish: 'Spaces'
            }
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-contentTypesSection",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_p12f144l _195g1wug"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $iyOcM.Adg4Tabs), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $90TSV.Adg4DraggableTabList), {
                        className: (0, $2jatx.default)([
                            "_1q51ftgi _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1bsb1osq _1bah1yb4 _owpu1tcg _1bhl7vkz _2osn7vkz"
                        ]),
                        children: tabList.map((tab, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $9s3Hk.Adg4DraggableTab), {
                                dataEventProps: !isConfluenceCrossflow ? {
                                    'data-product-key': 'confluence',
                                    'data-event': 'clicked',
                                    'data-event-component': 'tab',
                                    'data-event-container': 'contentTypesSection',
                                    'data-label': tab.eventProps?.label ?? 'content-type-tab',
                                    'data-label-english': tab.eventProps?.labelEnglish,
                                    'data-track-event': 'confluence-pt.content-types.tab'
                                } : undefined,
                                onClick: ()=>{
                                    if (!isConfluenceCrossflow) return;
                                    createAnalyticsEvent({
                                        eventName: 'confluence-crossflow-content-types-tab-clicked',
                                        eventType: 'ui',
                                        action: 'clicked',
                                        actionSubject: 'confluenceCrossflowTab',
                                        attributes: {
                                            reactComponent: 'ContentTypesSection',
                                            tab: tab.eventProps?.labelEnglish?.toLowerCase(),
                                            userTeamType: user.extended_profile?.team_type
                                        }
                                    }).fire();
                                },
                                className: (0, $2jatx.default)([
                                    "_2rkoyh40"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXFL3.IconTab), {
                                    icon: tab.icon,
                                    title: tab.title,
                                    lozenge: tab.lozenge
                                })
                            }, index))
                    }),
                    tabList.map((tab, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $ilkqI.Adg4TabPanel), {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _2lx21bp4 _195g1wug _1q51zwfg _1tker5sb _owpu1tcg _o5kch9n0 _1bhl7vkz _xc2izwfg _j6qu12it _y44vsw2d"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)(tab.content, {
                                    index: index,
                                    isConfluenceCrossflow: isConfluenceCrossflow
                                })
                            })
                        }, index))
                ]
            })
        })
    });
};
$61c5850de1119ed8$export$375e4d9f76d4c766.displayName = 'ContentTypesSection';
var $61c5850de1119ed8$export$2e2bcd8739ae039 = $61c5850de1119ed8$export$375e4d9f76d4c766;

});
parcelRegister("iXFL3", function(module, exports) {
$parcel$export(module.exports, "IconTab", function () { return $d8474a2425643ec8$export$5fd6e91639893354; });
/* icon-tab.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $d8474a2425643ec8$var$tabVerticalWrapper = null;
const $d8474a2425643ec8$var$tabTextWrapper = null;
const $d8474a2425643ec8$var$selectedTabStyle = null;
const $d8474a2425643ec8$var$titleStyle = null;
const $d8474a2425643ec8$var$lozengeStyle = null;
const $d8474a2425643ec8$var$underline = null;
const $d8474a2425643ec8$var$selectedUnderline = null;
const $d8474a2425643ec8$export$5fd6e91639893354 = ({ isSelected: isSelected, icon: icon, title: title, lozenge: lozenge })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _133i1crf _v736yh40 _chtu1y44 _16im7vkz _1wfq1y44 _15vtftgi _30l3u5k9 _1xjmu5k9",
                    isSelected && "_syazu5k9 _1yo9u5k9"
                ]),
                style: {
                    "--_5dnsy5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue700'))
                },
                children: [
                    icon,
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                        className: (0, $2jatx.default)([
                            "_1mouidpf _11cgftgi _1ywm7vkz",
                            "h4"
                        ]),
                        children: [
                            title,
                            lozenge && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_ahbqftgi _2rko1l7b _bfhk1bjw _syazftjs _18zr1y44 _1p1dangw _1wyb1675 _vwz41j6v _k48pbfng _s7n4nkob"
                                ]),
                                style: {
                                    "--_lwvw50": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue100')),
                                    "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800'))
                                },
                                children: lozenge
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4t3i1y44 _2rkoyh40",
                    isSelected && "_bfhku5k9"
                ]),
                style: {
                    "--_5dnsy5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue700'))
                }
            })
        ]
    });
};

});

parcelRegister("7yyLA", function(module, exports) {
$parcel$export(module.exports, "DatabasesIcon", function () { return $d8228f68cc84606d$export$4fe34b71b973310d; });

var $7VQPk = parcelRequire("7VQPk");
const $d8228f68cc84606d$export$4fe34b71b973310d = (props)=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: 28,
        viewBox: "1 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M28.9465 21.5V28H16.4465V21.5H28.9465ZM28.9465 18.5V12.5H16.4465V18.5H28.9465ZM28.9465 9.5V0H0.946533V9.5H28.9465ZM0.946533 12.5V18.5H13.4465V12.5H0.946533ZM0.946533 21.5H13.4465V28H0.946533V21.5Z",
            fill: "currentColor"
        })
    });

});

parcelRegister("9ckS1", function(module, exports) {
$parcel$export(module.exports, "PagesIcon", function () { return $e4eaaa1e56221255$export$34791a62a45c026; });

var $7VQPk = parcelRequire("7VQPk");
const $e4eaaa1e56221255$export$34791a62a45c026 = (props)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: 31,
        viewBox: "0 0 31 29",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M.947 0h22v22h-22zm17 6h-12v3h12zm0 7h-12v3h12z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M26.947 9v16h-16v4h20V9z",
                fill: "currentColor"
            })
        ]
    });

});

parcelRegister("kY2rG", function(module, exports) {
$parcel$export(module.exports, "SpacesIcon", function () { return $4dc6ebf3a8febd1d$export$90df9698aa84700a; });

var $7VQPk = parcelRequire("7VQPk");
const $4dc6ebf3a8febd1d$export$90df9698aa84700a = (props)=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: 28,
        viewBox: "1 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M15.695 0a4 4 0 0 0-4 4v20a4 4 0 0 0 4 4h9a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4zm-15 8h8V4h-8zm0 16h8v-4h-8zm0-12h8v4h-8z",
            fill: "currentColor"
        })
    });

});

parcelRegister("c8DdQ", function(module, exports) {
$parcel$export(module.exports, "WhiteboardsIcon", function () { return $cd9d1a63bf679a68$export$5dab50d99c45ffad; });

var $7VQPk = parcelRequire("7VQPk");
const $cd9d1a63bf679a68$export$5dab50d99c45ffad = (props)=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: 27,
        height: 27,
        viewBox: "0 0 27 27",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.24 5.793c.292-.874 1.284-1.802 2.57-2.296 1.347-.518 2.264-.305 2.602.033.19.191.194.293.194.327.002.078-.025.257-.205.56-.382.643-1.123 1.335-1.941 2.05l-.182.16c-.318.276-.648.564-.903.815a4 4 0 0 0-.47.538c-.11.154-.38.554-.375 1.095.003.32.101.65.318.937.203.268.451.42.644.508.354.16.724.188.976.195.545.014 1.292-.073 2.232-.23 2.577-.429 3.984.226 4.511.878.438.541.651 1.602-.523 3.168l2.25 1.688c1.638-2.184 1.992-4.73.46-6.624-1.252-1.549-3.43-2.211-5.978-2.026.515-.51 1.03-1.094 1.4-1.716.334-.565.62-1.272.598-2.07-.023-.842-.382-1.606-1.017-2.241C18.864.005 16.499.218 14.8.872c-1.761.677-3.581 2.093-4.228 4.032zm-6.302 14.27a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125m0-2.813a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5m10.781-2.812c.494 0 .951.259 1.206.682l5.625 9.375a1.406 1.406 0 0 1-1.206 2.13h-11.25a1.406 1.406 0 0 1-1.206-2.13l5.625-9.375a1.4 1.4 0 0 1 1.206-.682m3.141 9.375-3.141-5.236-3.142 5.235z",
            fill: "currentColor"
        })
    });

});

parcelRegister("7zrqq", function(module, exports) {
$parcel$export(module.exports, "DatabasesContentType", function () { return $1c16f268fc978ca6$export$abd9e762d8d9ba66; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $g6LIw = parcelRequire("g6LIw");

var $iyOcM = parcelRequire("iyOcM");

var $7GVWk = parcelRequire("7GVWk");

var $iPPTB = parcelRequire("iPPTB");

var $jQ0cd = parcelRequire("jQ0cd");

var $7VkQP = parcelRequire("7VkQP");

var $cLuPb = parcelRequire("cLuPb");
const $1c16f268fc978ca6$export$abd9e762d8d9ba66 = ({ index: index, isConfluenceCrossflow: isConfluenceCrossflow })=>{
    const { isCurrentTab: isCurrentTab } = (0, $iyOcM.useAdg4TabsContext)();
    const intl = (0, $8e22h.default)();
    const ctaLink = (0, $jQ0cd.useLocalizedHref)('/software/confluence/databases');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { user: user } = (0, $7GVWk.useUserContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cLuPb.ContentTypeVideo), {
        active: isCurrentTab(index),
        title: intl.formatMessage((0, $7VkQP.tabbedHeroSectionDatabasesMessages).contentTitle),
        description: intl.formatMessage((0, $7VkQP.tabbedHeroSectionDatabasesMessages).contentDescription),
        iconTitle: intl.formatMessage((0, $7VkQP.tabbedHeroSectionDatabasesMessages).contentIconTitle),
        iconCollection: [
            {
                description: intl.formatMessage((0, $7VkQP.tabbedHeroSectionDatabasesMessages).contentFeaturePoint1),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6LIw))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $7VkQP.tabbedHeroSectionDatabasesMessages).contentFeaturePoint2),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6LIw))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $7VkQP.tabbedHeroSectionDatabasesMessages).contentFeaturePoint3),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6LIw))), {
                    label: ""
                })
            }
        ],
        cta: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
            href: ctaLink,
            text: intl.formatMessage((0, $7VkQP.tabbedHeroSectionDatabasesMessages).contentCta),
            type: 'primary',
            dataEventProps: !isConfluenceCrossflow ? {
                'data-product-key': 'confluence',
                'data-event-component': 'linkButton',
                'data-event-container': 'contentTypesSection',
                'data-event': 'clicked',
                'data-label': 'explore-databases',
                'data-label-english': 'Explore Databases',
                'data-track-event': 'confluence-pt.content-types.databases.cta'
            } : undefined,
            onClick: ()=>{
                if (!isConfluenceCrossflow) return;
                createAnalyticsEvent({
                    eventName: 'confluence-crossflow-tab-cta-clicked',
                    eventType: 'ui',
                    action: 'clicked',
                    actionSubject: 'linkButton',
                    actionSubjectId: 'confluenceCrossFlowHeroSection',
                    attributes: {
                        reactComponent: 'DatabasesContentType',
                        tab: 'databases',
                        userTeamType: user.extended_profile?.team_type
                    }
                }).fire();
            }
        }),
        reverseLayout: true,
        videoSrcMp4: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Databases_LowBR_reencode.mp4",
        videoSrcWebm: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Databases_LowBR.webm",
        videoPreviewSrc: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Databases_Preview.webp"
    });
};

});
parcelRegister("g6LIw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::66a799ab1502bc13cc028e76ca03921b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bba2387ddd03cb94$var$_react = $bba2387ddd03cb94$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $bba2387ddd03cb94$var$_baseNew = $bba2387ddd03cb94$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $bba2387ddd03cb94$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StrokeWeightMedium".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing medium border stroke widths.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bba2387ddd03cb94$var$StrokeWeightMediumIcon = (props)=>/*#__PURE__*/ $bba2387ddd03cb94$var$_react.default.createElement($bba2387ddd03cb94$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.25 8a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0" clip-rule="evenodd"/>`
    }, props));
$bba2387ddd03cb94$var$StrokeWeightMediumIcon.displayName = 'StrokeWeightMediumIcon';
var $bba2387ddd03cb94$var$_default = module.exports.default = $bba2387ddd03cb94$var$StrokeWeightMediumIcon;

});

parcelRegister("7VkQP", function(module, exports) {
$parcel$export(module.exports, "tabbedHeroSectionPagesMessages", function () { return $5ec21e3943929bcb$export$4256e39427240bad; });
$parcel$export(module.exports, "tabbedHeroSectionWhiteboardsMessages", function () { return $5ec21e3943929bcb$export$86b5cdc1c559b81d; });
$parcel$export(module.exports, "tabbedHeroSectionDatabasesMessages", function () { return $5ec21e3943929bcb$export$505de7052a30846e; });
$parcel$export(module.exports, "tabbedHeroSectionSpacesMessages", function () { return $5ec21e3943929bcb$export$954db68b244e5987; });

var $fnHPc = parcelRequire("fnHPc");
const $5ec21e3943929bcb$export$4256e39427240bad = (0, $fnHPc.defineMessages)({
    tabName: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Pages.tabName',
        defaultMessage: 'Pages'
    },
    contentTitle: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Pages.title.v2',
        defaultMessage: 'Get everyone on the same page'
    },
    contentDescription: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Pages.description.v2',
        defaultMessage: 'Take notes, plan projects, and refine ideas with flexible Confluence live docs and pages. Or let AI do it for you.'
    },
    contentIconTitle: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Pages.iconsHeader',
        defaultMessage: 'Create content with ease:'
    },
    contentFeaturePoint1: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Pages.icon1',
        defaultMessage: 'Countless templates to get started fast'
    },
    contentFeaturePoint2: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Pages.icon2',
        defaultMessage: 'Realtime collaboration with live docs, or draft and publish with pages'
    },
    contentFeaturePoint3: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Pages.icon3',
        defaultMessage: 'AI editor to fill in the blanks'
    },
    contentCta: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Pages.cta',
        defaultMessage: 'Try it out'
    }
});
const $5ec21e3943929bcb$export$86b5cdc1c559b81d = (0, $fnHPc.defineMessages)({
    tabName: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.tabName',
        defaultMessage: 'Whiteboards'
    },
    contentTitle: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.title',
        defaultMessage: 'Next-gen brainstorming'
    },
    contentDescription: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.description',
        defaultMessage: 'Capture free-flowing thoughts and collaborate on ideas with Confluence Whiteboards.'
    },
    contentIconTitle: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.iconsHeader',
        defaultMessage: 'Ideate on an infinite canvas with:'
    },
    contentFeaturePoint1: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.icon1',
        defaultMessage: 'Brainstorming templates'
    },
    contentFeaturePoint2: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.icon2',
        defaultMessage: 'Diagrams and flow charts'
    },
    contentFeaturePoint3: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.icon3',
        defaultMessage: 'Team retrospectives'
    },
    contentCta: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.cta',
        defaultMessage: 'Explore Whiteboards'
    }
});
const $5ec21e3943929bcb$export$505de7052a30846e = (0, $fnHPc.defineMessages)({
    tabName: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Databases.tabName',
        defaultMessage: 'Databases'
    },
    tabLozenge: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Databases.tabLozenge',
        defaultMessage: 'beta'
    },
    contentTitle: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Databases.title',
        defaultMessage: 'A new way to stay in sync'
    },
    contentDescription: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Databases.description',
        defaultMessage: "Add structure, sync in real-time, and visualize your team\u2019s work with Confluence Databases."
    },
    contentIconTitle: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Databases.iconsHeader',
        defaultMessage: 'Connect and relate information with:'
    },
    contentFeaturePoint1: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Databases.icon1',
        defaultMessage: 'Dynamic fields'
    },
    contentFeaturePoint2: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Databases.icon2',
        defaultMessage: 'Configurable views'
    },
    contentFeaturePoint3: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Databases.icon3',
        defaultMessage: 'Aggregated data sources'
    },
    contentCta: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Databases.cta',
        defaultMessage: 'Explore Databases'
    }
});
const $5ec21e3943929bcb$export$954db68b244e5987 = (0, $fnHPc.defineMessages)({
    tabName: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Spaces.tabName',
        defaultMessage: 'Spaces'
    },
    contentTitle: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Spaces.title',
        defaultMessage: 'Find what you need'
    },
    contentDescription: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Spaces.description',
        defaultMessage: 'Organize knowledge across teams, projects, and goals with Spaces in Confluence.'
    },
    contentIconTitle: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Spaces.iconsHeader',
        defaultMessage: 'Discover relevant information with:'
    },
    contentFeaturePoint1: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Spaces.icon1',
        defaultMessage: 'Structured page tree'
    },
    contentFeaturePoint2: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Spaces.icon2',
        defaultMessage: 'Centralized access to knowledge'
    },
    contentFeaturePoint3: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Spaces.icon3',
        defaultMessage: 'Customizable permissions'
    },
    contentCta: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Spaces.cta',
        defaultMessage: 'Explore knowledge sharing'
    }
});

});


parcelRegister("5EpoY", function(module, exports) {
$parcel$export(module.exports, "PagesContentType", function () { return $975cd41fcec23a6d$export$3914470415d96f5f; });
/* pages-content-type.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $g6LIw = parcelRequire("g6LIw");

var $iyOcM = parcelRequire("iyOcM");

var $7GVWk = parcelRequire("7GVWk");

var $iPPTB = parcelRequire("iPPTB");

var $7VkQP = parcelRequire("7VkQP");

var $cLuPb = parcelRequire("cLuPb");
const $975cd41fcec23a6d$var$hideMobile = null;
const $975cd41fcec23a6d$export$3914470415d96f5f = ({ index: index, isConfluenceCrossflow: isConfluenceCrossflow })=>{
    const { isCurrentTab: isCurrentTab } = (0, $iyOcM.useAdg4TabsContext)();
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { user: user } = (0, $7GVWk.useUserContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cLuPb.ContentTypeVideo), {
        active: isCurrentTab(index),
        title: intl.formatMessage((0, $7VkQP.tabbedHeroSectionPagesMessages).contentTitle),
        description: intl.formatMessage((0, $7VkQP.tabbedHeroSectionPagesMessages).contentDescription),
        iconTitle: intl.formatMessage((0, $7VkQP.tabbedHeroSectionPagesMessages).contentIconTitle),
        iconCollection: [
            {
                description: intl.formatMessage((0, $7VkQP.tabbedHeroSectionPagesMessages).contentFeaturePoint1),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6LIw))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $7VkQP.tabbedHeroSectionPagesMessages).contentFeaturePoint2),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6LIw))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $7VkQP.tabbedHeroSectionPagesMessages).contentFeaturePoint3),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6LIw))), {
                    label: ""
                })
            }
        ],
        cta: intl.locale === 'en' ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1mjbglyw"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                href: 'https://www.atlassian.com/confluence-sandbox-editor',
                text: intl.formatMessage((0, $7VkQP.tabbedHeroSectionPagesMessages).contentCta),
                type: 'primary',
                dataEventProps: !isConfluenceCrossflow ? {
                    'data-product-key': 'confluence',
                    'data-event-component': 'linkButton',
                    'data-event-container': 'contentTypesSection',
                    'data-event': 'clicked',
                    'data-label': 'try-it-out',
                    'data-label-english': 'Try it out',
                    'data-track-event': 'confluence-pt.content-types.pages.cta'
                } : undefined,
                onClick: ()=>{
                    if (!isConfluenceCrossflow) return;
                    createAnalyticsEvent({
                        eventName: 'confluence-crossflow-tab-cta-clicked',
                        eventType: 'ui',
                        action: 'clicked',
                        actionSubject: 'linkButton',
                        actionSubjectId: 'confluenceCrossFlowHeroSection',
                        attributes: {
                            reactComponent: 'PagesContentType',
                            tab: 'pages',
                            userTeamType: user.extended_profile?.team_type
                        }
                    }).fire();
                }
            })
        }) : undefined,
        reverseLayout: true,
        videoSrcMp4: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Pages_LowBR_reencode.mp4",
        videoSrcWebm: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Pages_LowBR.webm",
        videoPreviewSrc: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Pages_Preview.webp"
    });
};

});

parcelRegister("aHOGX", function(module, exports) {
$parcel$export(module.exports, "SpacesContentType", function () { return $03dc098a3df1d535$export$31e6bce70211a7b2; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $g6LIw = parcelRequire("g6LIw");

var $iyOcM = parcelRequire("iyOcM");

var $7GVWk = parcelRequire("7GVWk");

var $iPPTB = parcelRequire("iPPTB");

var $jQ0cd = parcelRequire("jQ0cd");

var $7VkQP = parcelRequire("7VkQP");

var $cLuPb = parcelRequire("cLuPb");
const $03dc098a3df1d535$export$31e6bce70211a7b2 = ({ index: index, isConfluenceCrossflow: isConfluenceCrossflow })=>{
    const { isCurrentTab: isCurrentTab } = (0, $iyOcM.useAdg4TabsContext)();
    const intl = (0, $8e22h.default)();
    const ctaLink = (0, $jQ0cd.useLocalizedHref)('/software/confluence/use-cases/knowledge-management-software');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { user: user } = (0, $7GVWk.useUserContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cLuPb.ContentTypeVideo), {
        active: isCurrentTab(index),
        title: intl.formatMessage((0, $7VkQP.tabbedHeroSectionSpacesMessages).contentTitle),
        description: intl.formatMessage((0, $7VkQP.tabbedHeroSectionSpacesMessages).contentDescription),
        iconTitle: intl.formatMessage((0, $7VkQP.tabbedHeroSectionSpacesMessages).contentIconTitle),
        iconCollection: [
            {
                description: intl.formatMessage((0, $7VkQP.tabbedHeroSectionSpacesMessages).contentFeaturePoint1),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6LIw))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $7VkQP.tabbedHeroSectionSpacesMessages).contentFeaturePoint2),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6LIw))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $7VkQP.tabbedHeroSectionSpacesMessages).contentFeaturePoint3),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6LIw))), {
                    label: ""
                })
            }
        ],
        cta: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
            href: ctaLink,
            text: intl.formatMessage((0, $7VkQP.tabbedHeroSectionSpacesMessages).contentCta),
            type: 'primary',
            dataEventProps: !isConfluenceCrossflow ? {
                'data-product-key': 'confluence',
                'data-event-component': 'linkButton',
                'data-event-container': 'contentTypesSection',
                'data-event': 'clicked',
                'data-label': 'explore-knowledge-sharing',
                'data-label-english': 'Explore knowledge sharing',
                'data-track-event': 'confluence-pt.content-types.spaces.cta'
            } : undefined,
            onClick: ()=>{
                if (!isConfluenceCrossflow) return;
                createAnalyticsEvent({
                    eventName: 'confluence-crossflow-tab-cta-clicked',
                    eventType: 'ui',
                    action: 'clicked',
                    actionSubject: 'linkButton',
                    actionSubjectId: 'confluenceCrossFlowHeroSection',
                    attributes: {
                        reactComponent: 'SpacesContentType',
                        tab: 'spaces',
                        userTeamType: user.extended_profile?.team_type
                    }
                }).fire();
            }
        }),
        reverseLayout: true,
        videoSrcMp4: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Spaces_LowBR_reencode.mp4",
        videoSrcWebm: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Spaces_LowBR.webm",
        videoPreviewSrc: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Spaces_Preview.webp"
    });
};

});

parcelRegister("jg9LG", function(module, exports) {
$parcel$export(module.exports, "WhiteboardsContentType", function () { return $b9c539ed2bf6758b$export$163a1257b16e076f; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $g6LIw = parcelRequire("g6LIw");

var $iyOcM = parcelRequire("iyOcM");

var $7GVWk = parcelRequire("7GVWk");

var $iPPTB = parcelRequire("iPPTB");

var $jQ0cd = parcelRequire("jQ0cd");

var $7VkQP = parcelRequire("7VkQP");

var $cLuPb = parcelRequire("cLuPb");
const $b9c539ed2bf6758b$export$163a1257b16e076f = ({ index: index, isConfluenceCrossflow: isConfluenceCrossflow })=>{
    const { isCurrentTab: isCurrentTab } = (0, $iyOcM.useAdg4TabsContext)();
    const intl = (0, $8e22h.default)();
    const ctaLink = (0, $jQ0cd.useLocalizedHref)('/software/confluence/whiteboards');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { user: user } = (0, $7GVWk.useUserContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cLuPb.ContentTypeVideo), {
        active: isCurrentTab(index),
        title: intl.formatMessage((0, $7VkQP.tabbedHeroSectionWhiteboardsMessages).contentTitle),
        description: intl.formatMessage((0, $7VkQP.tabbedHeroSectionWhiteboardsMessages).contentDescription),
        iconTitle: intl.formatMessage((0, $7VkQP.tabbedHeroSectionWhiteboardsMessages).contentIconTitle),
        iconCollection: [
            {
                description: intl.formatMessage((0, $7VkQP.tabbedHeroSectionWhiteboardsMessages).contentFeaturePoint1),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6LIw))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $7VkQP.tabbedHeroSectionWhiteboardsMessages).contentFeaturePoint2),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6LIw))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $7VkQP.tabbedHeroSectionWhiteboardsMessages).contentFeaturePoint3),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6LIw))), {
                    label: ""
                })
            }
        ],
        cta: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
            href: ctaLink,
            text: intl.formatMessage((0, $7VkQP.tabbedHeroSectionWhiteboardsMessages).contentCta),
            type: 'primary',
            dataEventProps: !isConfluenceCrossflow ? {
                'data-product-key': 'confluence',
                'data-event-component': 'linkButton',
                'data-event-container': 'contentTypesSection',
                'data-event': 'clicked',
                'data-label': 'explore-whiteboards',
                'data-label-english': 'Explore Whiteboards',
                'data-track-event': 'confluence-pt.content-types.whiteboards.cta'
            } : undefined,
            onClick: ()=>{
                if (!isConfluenceCrossflow) return;
                createAnalyticsEvent({
                    eventName: 'confluence-crossflow-tab-cta-clicked',
                    eventType: 'ui',
                    action: 'clicked',
                    actionSubject: 'linkButton',
                    actionSubjectId: 'confluenceCrossFlowHeroSection',
                    attributes: {
                        reactComponent: 'WhiteboardsContentType',
                        tab: 'whiteboards',
                        userTeamType: user.extended_profile?.team_type
                    }
                }).fire();
            }
        }),
        reverseLayout: true,
        videoSrcMp4: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Whiteboards_LowBR_reencode.mp4",
        videoSrcWebm: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Whiteboards_LowBR.webm",
        videoPreviewSrc: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Whiteboards_Preview.webp"
    });
};

});


parcelRegister("heBZG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $af1005f560ec61fd$export$2e2bcd8739ae039; });
/* cta-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $bQjAr = parcelRequire("bQjAr");

var $20OkY = parcelRequire("20OkY");

var $aq7HV = parcelRequire("aq7HV");

var $lmQGF = parcelRequire("lmQGF");

var $asbmK = parcelRequire("asbmK");

var $gfjAv = parcelRequire("gfjAv");

var $jQ0cd = parcelRequire("jQ0cd");
const $af1005f560ec61fd$var$sectionContainer = null;
const $af1005f560ec61fd$var$contentContainer = null;
const $af1005f560ec61fd$var$backgroundBlue = null;
const $af1005f560ec61fd$var$backgroundYellow = null;
const $af1005f560ec61fd$var$textSection = null;
const $af1005f560ec61fd$var$headingText = null;
const $af1005f560ec61fd$var$subText = null;
const $af1005f560ec61fd$var$graphicSection = null;
const $af1005f560ec61fd$var$replacesStyle = null;
const $af1005f560ec61fd$var$CtaSection = ()=>{
    const signupLink = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=confluence');
    const { openCrossFlow: openCrossFlow } = (0, $asbmK.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).CONFLUENCE,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-ctaSection",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
            className: (0, $2jatx.default)([
                "_kqswh2mm _1e0c1txw _1bah1h6o _19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f1rd8 _1tke1784 _1reo15vq _18m915vq"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswstnw _mkrz1ak8 _bfhkkizl _1ul91rd8 _1bsb1osq _4t3i1osq _152tidpf _u7coidpf _blhd1osq _197p5cbm"
                    ])
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswstnw _mkrz116y _bfhkdoyu _1ul91rd8 _1bsb1osq _4t3i1osq _152tidpf _u7coidpf _blhd1osq _197p8ehm"
                    ])
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _1e0c1txw _2lx2vrvc _p12f1fra _19pk1wug _2hwx1wug _otyr1wug _18u01wug _bozgvbgk _y4tivbgk _1q5116xz _85i516xz _zulpzwfg _na0i1bp4 _2osn1wqb _144t1k7u _xc2i1fqw"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_gu181h6o _8fz61c5i"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                    className: (0, $2jatx.default)([
                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz12cp _uqyg1k8s"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "ConfluenceSoftwarePage.v4.ctaSection.header",
                                        defaultMessage: "Ditch your old docs, collaborate effortlessly with Confluence"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    className: (0, $2jatx.default)([
                                        "_1pfhoqnp _6rth1k8s _p12f1sxm _syaz12cp _1fkk1wug _8fz61sum"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "ConfluenceSoftwarePage.v4.ctaSection.subtext",
                                        defaultMessage: "Confluence is your connected workspace, designed for collaboration and built to last"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gfjAv.default), {
                                    intentType: 'button',
                                    containerId: 'ctaSection',
                                    productKey: 'confluence',
                                    edition: 'free',
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                                        href: signupLink,
                                        variant: "primary",
                                        color: "yellow",
                                        size: "large",
                                        onClick: openCrossFlow,
                                        dataEventProps: {
                                            'data-product-key': 'confluence',
                                            'data-event': 'clicked',
                                            'data-event-component': 'linkButton',
                                            'data-event-container': 'ctaSection',
                                            'data-label': 'cta-get-confluence-free',
                                            'data-label-english': 'Get Confluence free',
                                            'data-track-event': 'confluence-pt.cta.get-confluence-free'
                                        },
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                            id: "ConfluenceSoftwarePage.v4.heroCTA",
                                            defaultMessage: "Get Confluence free"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _16jlidpf _1o9zidpf _i0dlhwvj"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gfjAv.default), {
                                    intentType: 'button',
                                    containerId: 'ctaSection',
                                    productKey: 'confluence',
                                    edition: 'free',
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aq7HV.AnimatedButtonArrows), {
                                        product: "confluence",
                                        href: signupLink,
                                        onClick: openCrossFlow,
                                        color: "#fff"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                                    src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/confluencelp-replaces.webp",
                                    alt: "",
                                    role: "presentation",
                                    className: (0, $2jatx.default)([
                                        "_1pfh8pqr _tzy4q80t _1o2w1lyw _lcxvglyw"
                                    ])
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
$af1005f560ec61fd$var$CtaSection.displayName = 'CtaSection';
var $af1005f560ec61fd$export$2e2bcd8739ae039 = $af1005f560ec61fd$var$CtaSection;

});
parcelRegister("aq7HV", function(module, exports) {
$parcel$export(module.exports, "AnimatedButtonArrows", function () { return $0cb23f027c4819c3$export$554aaec702debd9a; });
/* animated-button-arrows.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $5uYpV = parcelRequire("5uYpV");
const $0cb23f027c4819c3$var$animatedContainer = null;
const $0cb23f027c4819c3$var$arrowStyle = null;
const $0cb23f027c4819c3$var$arrowsContainer = null;
const $0cb23f027c4819c3$export$8941bb92081bfaa5 = (props)=>{
    const arrowInlineStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: "52",
        height: "17",
        viewBox: "0 0 72 25",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $2jatx.default)([
            "_kqswstnw _5sag9cwz _tip8kb7n _1o51eoah",
            "_1e021mv2 _rjxp1afg _152tl7rb _t9ecwv2z",
            props.animate && "_j7hqgx4m"
        ]),
        style: {
            color: props.color ? props.color : 'currentColor',
            visibility: props.animate ? 'visible' : 'hidden',
            "--_11zanbc": (0, $6ZVlx.default)(props.left),
            "--_c7a5uq": (0, $6ZVlx.default)(props.right),
            "--_kmwll6": (0, $6ZVlx.default)(props.top),
            "--_l8fg41": (0, $6ZVlx.default)(props.rotate ?? 0, "deg"),
            "--_76lb24": (0, $6ZVlx.default)(props.translateX ?? '0%'),
            "--_s0bevx": (0, $6ZVlx.default)(props.translateY ?? '0%')
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M59.9377 15.3992C59.0173 14.9197 58.1224 14.8026 57.2375 14.6506C56.2764 14.4847 55.3298 14.5122 54.3661 14.6939C53.5179 14.8575 52.6572 14.756 51.8548 14.5047C50.3545 14.0308 48.8161 13.9548 47.2581 13.9487C46.2852 13.9435 45.2992 13.8949 44.3421 13.7474C43.6788 13.6425 43.0503 13.3313 42.3766 13.1053C41.985 13.7302 41.3847 13.7038 40.7654 13.4715C39.4868 12.9907 38.1709 12.9018 36.8181 12.9291C36.0821 12.9425 35.3546 12.7709 34.7504 12.2942C34.6729 12.2382 34.5745 12.21 34.4827 12.1765C33.8726 12.7787 33.1602 12.7406 32.4202 12.5737C31.2308 12.3121 30.0329 12.0735 28.8435 11.8119C28.0392 11.6324 27.2369 11.435 26.434 11.2435C25.6375 11.0468 24.8746 10.7635 24.004 10.9669C22.9249 11.2205 21.8431 10.958 20.7692 10.7864C19.5431 10.5869 18.3301 10.2689 17.1034 10.1833C15.0061 10.0312 12.9448 9.66091 10.8685 9.37304C9.87464 9.2337 8.87682 9.12994 7.89344 8.94972C6.89235 8.76766 5.89651 8.53817 4.91509 8.28619C3.86938 8.02152 2.82958 7.7035 1.79371 7.40388C1.12194 7.21408 0.740116 6.67063 0.443572 6.11206C0.359595 5.95341 0.591152 5.53371 0.780077 5.33746C1.3744 4.71561 2.13013 4.41639 2.99148 4.35003C4.92541 4.19732 6.85018 4.28953 8.7651 4.47067C10.4852 4.63154 12.1902 4.92878 13.8886 5.23134C15.8515 5.57338 17.8274 5.79684 19.8165 5.95571C21.368 6.07507 22.9135 6.30175 24.4618 6.45076C25.9089 6.59525 27.3614 6.69231 28.8151 6.83149C30.4224 6.98663 32.0303 7.13584 33.6388 7.3331C35.9198 7.60628 38.1897 7.92627 40.47 8.20538C42.0904 8.40386 43.7114 8.59642 45.3646 8.49847C46.3027 8.4401 47.2618 8.62379 48.1927 8.79256C49.5336 9.03394 50.885 9.07253 52.239 9.14136C53.8902 9.22311 55.5421 9.29894 57.1985 9.38723C57.6735 9.41263 58.1432 9.48547 58.6182 9.51087C58.7481 9.52438 58.8865 9.46081 59.0203 9.43874C58.9685 9.31341 58.9514 9.14372 58.8583 9.06807C58.3052 8.61476 57.7305 8.19518 57.1775 7.74187C55.7106 6.53386 54.2437 5.32585 52.784 4.1066C52.2211 3.63427 51.8989 2.98308 51.5571 2.34784C51.3492 1.9604 51.5341 1.63781 51.7218 1.34547C51.9021 1.06438 52.0235 0.669208 52.4453 0.635111C52.7346 0.611222 53.0239 0.587334 53.3159 0.593703C54.7643 0.618392 56.0541 1.16031 57.3235 1.77807C58.2302 2.22017 59.1204 2.70255 60.0415 3.12217C60.4279 3.30028 60.6627 3.55259 60.8241 3.92919C60.9383 4.19293 61.0275 4.52005 61.4388 4.203C61.6212 4.06605 61.8429 4.11309 62.0102 4.32839C62.2563 4.64183 62.5469 4.92992 62.7922 5.24929C62.9589 5.47051 63.1498 5.52635 63.422 5.54866C64.448 5.61337 65.2517 6.12273 65.8284 6.95631C66.199 7.4926 66.6963 7.85616 67.2599 8.10666C67.9146 8.39663 68.5004 8.76939 68.9623 9.29118C69.8119 10.2491 70.6155 11.2442 71.4126 12.2446C71.7531 12.6758 71.6567 13.4934 71.2651 13.9024C70.5625 14.639 69.8337 15.3428 69.1476 16.093C68.7802 16.4986 68.4883 16.978 68.1472 17.4163C68.0081 17.5937 67.8625 17.8305 67.6703 17.8944C66.9192 18.1522 66.4311 18.7311 65.8676 19.2362C65.6354 19.4459 65.3887 19.6782 65.1073 19.7928C64.1935 20.1716 63.2705 20.5253 62.3343 20.8358C62.0614 20.9274 61.7282 20.8087 61.4231 20.813C61.2854 20.8167 61.0794 20.8432 61.0217 20.9332C60.5146 21.738 59.7602 22.1333 58.8588 22.1835C57.4825 22.2623 56.1856 22.7031 54.8565 23.0027C53.3253 23.3472 51.7949 23.6858 50.267 24.0547C49.0888 24.34 47.9008 24.4443 46.6976 24.4151C46.1853 24.4038 45.8133 24.1493 45.6316 23.7406C45.2412 22.8424 45.1435 22.8622 45.7706 22.0519C45.8893 21.8963 46.0244 21.7544 46.1209 21.5846C46.4935 20.9157 47.1521 20.7922 47.8029 20.5781C48.9181 20.2143 50.011 19.7822 51.0986 19.3436C52.5241 18.7662 53.93 18.1508 55.345 17.5603C56.1092 17.2379 56.8866 16.959 57.6358 16.6111C58.3849 16.2632 59.1046 15.8583 59.9219 15.4335L59.9377 15.3992Z",
            fill: "currentColor"
        })
    });
};
const $0cb23f027c4819c3$var$buttonStyle = null;
const $0cb23f027c4819c3$var$arrowInAnimation = null;
const $0cb23f027c4819c3$export$554aaec702debd9a = ({ product: product, href: href, color: color, distanceMultiplier: distanceMultiplier = 2, useInViewOptions: useInViewOptions, onClick: onClick })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)({
        threshold: 0.5,
        ...useInViewOptions
    });
    const translateX = `-${distanceMultiplier * 100}%`;
    const translateY = `-${distanceMultiplier * 50}%`;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1reoewfl _18m9ewfl"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)($0cb23f027c4819c3$export$8941bb92081bfaa5, {
                        color: color,
                        rotate: 26.4,
                        top: "-15%",
                        left: "-77px",
                        translateX: translateX,
                        translateY: translateY,
                        animate: sectionIsVisible
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($0cb23f027c4819c3$export$8941bb92081bfaa5, {
                        color: color,
                        rotate: 2.4,
                        top: "40%",
                        left: "-79px",
                        translateX: translateX,
                        translateY: translateY,
                        animate: sectionIsVisible
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($0cb23f027c4819c3$export$8941bb92081bfaa5, {
                        color: color,
                        rotate: -31.8,
                        top: "92%",
                        left: "-78px",
                        translateX: translateX,
                        translateY: translateY,
                        animate: sectionIsVisible
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                ref: scrollRef,
                href: href,
                onClick: onClick,
                "aria-label": product,
                className: (0, $2jatx.default)([
                    "_1e0c116y _bfhku67f _2rkogktf _t9ec16ji _ca0qftgi _u5f3ftgi _n3tdftgi _19bvftgi _1l9u7vkz _w8l51gw8 _17521gw8 _rulp1yij _19ek1yij _1dbzuehs"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5uYpV.Logo), {
                    brand: product,
                    type: "mark",
                    appearance: "brand"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)($0cb23f027c4819c3$export$8941bb92081bfaa5, {
                        color: color,
                        rotate: 137.7,
                        top: "-11%",
                        right: "-70px",
                        translateX: translateX,
                        translateY: translateY,
                        animate: sectionIsVisible
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($0cb23f027c4819c3$export$8941bb92081bfaa5, {
                        color: color,
                        rotate: 169.6,
                        top: "37%",
                        right: "-84px",
                        translateX: translateX,
                        translateY: translateY,
                        animate: sectionIsVisible
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($0cb23f027c4819c3$export$8941bb92081bfaa5, {
                        color: color,
                        rotate: -171.6,
                        top: "87%",
                        right: "-75px",
                        translateX: translateX,
                        translateY: translateY,
                        animate: sectionIsVisible
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("2Jr3C", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b95c3b42d3906cd4$export$2e2bcd8739ae039; });
/* feel-supported-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $1nOTC = parcelRequire("1nOTC");

var $f2Lca = parcelRequire("f2Lca");

var $4eAXW = parcelRequire("4eAXW");

var $b5WBX = parcelRequire("b5WBX");

var $6fSQu = parcelRequire("6fSQu");

var $jQ0cd = parcelRequire("jQ0cd");

var $6W938 = parcelRequire("6W938");
const $b95c3b42d3906cd4$var$feelSupportedSectionStyles = null;
const $b95c3b42d3906cd4$var$feelSupportedSectionHeaderStyles = null;
const $b95c3b42d3906cd4$var$infoCardContainerStyles = null;
const $b95c3b42d3906cd4$var$cardGroup = null;
const $b95c3b42d3906cd4$var$FeelSupportedSection = ()=>{
    const intl = (0, $8e22h.default)();
    const infoCards1 = [
        {
            id: 'atlassianCommunity',
            Icon: (0, $f2Lca.GroupsIcon),
            title: intl.formatMessage((0, $6W938.feelSupportedSectioni18n).atlassianCommunityInfoCardTitle),
            paragraph: intl.formatMessage((0, $6W938.feelSupportedSectioni18n).atlassianCommunityInfoCardParagraph),
            // callToActionText: intl.formatMessage(
            //     feelSupportedSectioni18n.atlassianCommunityInfoCardCallToActionText
            // ),
            callToActionUrl: 'https://community.atlassian.com/t5/Confluence/ct-p/confluence',
            eventProps: {
                label: 'atlassian-community',
                labelEnglish: 'Atlassian Community'
            }
        },
        {
            id: 'useCases',
            Icon: (0, $4eAXW.OfficeBuildingIcon),
            title: intl.formatMessage((0, $6W938.feelSupportedSectioni18n).useCasesInfoCardTitle),
            paragraph: intl.formatMessage((0, $6W938.feelSupportedSectioni18n).useCasesInfoCardParagraph),
            // callToActionText: intl.formatMessage(
            //     feelSupportedSectioni18n.useCasesInfoCardCallToActionText
            // ),
            callToActionUrl: (0, $jQ0cd.useLocalizedHref)('/software/confluence/use-cases'),
            eventProps: {
                label: 'use-cases',
                labelEnglish: 'Use cases'
            }
        }
    ];
    const infoCards2 = [
        {
            id: 'videoWalkthroughs',
            Icon: (0, $b5WBX.PlayIcon),
            title: intl.formatMessage((0, $6W938.feelSupportedSectioni18n).videoWalkthroughsInfoCardTitle),
            paragraph: intl.formatMessage((0, $6W938.feelSupportedSectioni18n).videoWalkthroughsInfoCardParagraph),
            // callToActionText: intl.formatMessage(
            //     feelSupportedSectioni18n.videoWalkthroughsInfoCardCallToActionText
            // ),
            callToActionUrl: (0, $jQ0cd.useLocalizedHref)('/software/confluence/demo'),
            eventProps: {
                label: 'video-walkthroughs',
                labelEnglish: 'Video walkthroughs'
            }
        },
        {
            id: 'productGuides',
            Icon: (0, $1nOTC.DocumentsIcon),
            title: intl.formatMessage((0, $6W938.feelSupportedSectioni18n).productGuidesInfoCardTitle),
            paragraph: intl.formatMessage((0, $6W938.feelSupportedSectioni18n).productGuidesInfoCardParagraph),
            // callToActionText: intl.formatMessage(
            //     feelSupportedSectioni18n.productGuidesInfoCardCallToActionText
            // ),
            callToActionUrl: (0, $jQ0cd.useLocalizedHref)('/software/confluence/resources/guides'),
            eventProps: {
                label: 'product-guides',
                labelEnglish: 'Product guides'
            }
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-feelSupportedSection",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4 _4cvr1h6o _1pfh1ylp _6rthzwfg _bozg1tcg _y4ti1tcg"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    className: (0, $2jatx.default)([
                        "_6rth1ex1 _gu181h6o"
                    ]),
                    children: intl.formatMessage((0, $6W938.feelSupportedSectioni18n).feelSupportSectionHeader)
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _19pkidpf _2hwx1wug _otyridpf _18u01wug _1n261g80 _zulp1tcg _p12f11vz _1bsb1osq"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _zulp1tcg _1bah1h6o _1n261g80"
                            ]),
                            children: infoCards1.map(({ eventProps: eventProps, id: id, ...infoCardProps })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $6fSQu.InfoCard), {
                                    ...infoCardProps,
                                    dataEventProps: {
                                        'data-product-key': 'confluence',
                                        'data-event': 'clicked',
                                        'data-event-component': 'card',
                                        'data-event-container': 'additionalResourcesSection',
                                        'data-label': eventProps?.label,
                                        'data-label-english': eventProps?.labelEnglish
                                    }
                                }, id))
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _zulp1tcg _1bah1h6o _1n261g80"
                            ]),
                            children: infoCards2.map(({ eventProps: eventProps, id: id, ...infoCardProps })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $6fSQu.InfoCard), {
                                    ...infoCardProps,
                                    dataEventProps: {
                                        'data-product-key': 'confluence',
                                        'data-event': 'clicked',
                                        'data-event-component': 'card',
                                        'data-event-container': 'additionalResourcesSection',
                                        'data-label': eventProps?.label,
                                        'data-label-english': eventProps?.labelEnglish
                                    }
                                }, id))
                        })
                    ]
                })
            ]
        })
    });
};
$b95c3b42d3906cd4$var$FeelSupportedSection.displayName = 'FeelSupportedSection';
var $b95c3b42d3906cd4$export$2e2bcd8739ae039 = $b95c3b42d3906cd4$var$FeelSupportedSection;

});
parcelRegister("1nOTC", function(module, exports) {
$parcel$export(module.exports, "DocumentsIcon", function () { return $846a54b40753b380$export$f4d1f69b1f255ce3; });

var $7VQPk = parcelRequire("7VQPk");
const $846a54b40753b380$export$f4d1f69b1f255ce3 = ({ size: size })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 48 49",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                id: "Brand Icons/Documents",
                clipPath: "url(#clip0_5565_6299)",
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                    id: "Vector",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M10.9993 8.5H20.9993L29.9993 17.5V33.5H10.9993V8.5ZM18.9993 19.5V11.5L26.9993 19.5H18.9993Z",
                            fill: "#101214"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M32.9991 18.5V36.5H16.9991V40.5H36.9991V18.5H32.9991Z",
                            fill: "#101214"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                    id: "clip0_5565_6299",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        width: "48",
                        height: "48",
                        fill: "white",
                        transform: "translate(-0.000976562 0.5)"
                    })
                })
            })
        ]
    });
};

});

parcelRegister("f2Lca", function(module, exports) {
$parcel$export(module.exports, "GroupsIcon", function () { return $8ce456a773f2e7b4$export$6b0e36037a267557; });

var $7VQPk = parcelRequire("7VQPk");
const $8ce456a773f2e7b4$export$6b0e36037a267557 = ({ size: size })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 49 49",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            id: "Brand Icons/Groups",
            clipPath: "url(#clip0_6876_13409)",
            filter: "url(#filter0_d_6876_13409)",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                id: "Vector",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M17.4463 31.5C17.4463 27.634 20.5803 24.5 24.4463 24.5C28.3123 24.5 31.4463 27.634 31.4463 31.5V40.5H17.4463V31.5Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M30.4463 15.5C30.4463 18.8137 27.76 21.5 24.4463 21.5C21.1326 21.5 18.4463 18.8137 18.4463 15.5C18.4463 12.1863 21.1326 9.5 24.4463 9.5C27.76 9.5 30.4463 12.1863 30.4463 15.5Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M31.2581 21.3824C31.6422 21.4595 32.0395 21.5 32.4463 21.5C35.76 21.5 38.4463 18.8137 38.4463 15.5C38.4463 12.1863 35.76 9.5 32.4463 9.5C32.0395 9.5 31.6422 9.54048 31.2581 9.61764C32.6216 11.1952 33.4463 13.2513 33.4463 15.5C33.4463 17.7487 32.6216 19.8048 31.2581 21.3824Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M17.6345 9.61764C16.271 11.1952 15.4463 13.2513 15.4463 15.5C15.4463 17.7487 16.271 19.8048 17.6345 21.3824C17.2504 21.4595 16.8531 21.5 16.4463 21.5C13.1326 21.5 10.4463 18.8137 10.4463 15.5C10.4463 12.1863 13.1326 9.5 16.4463 9.5C16.8531 9.5 17.2504 9.54048 17.6345 9.61764Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M17.3049 24.5C15.5366 26.3037 14.4463 28.7745 14.4463 31.5V40.5H10.4463V29.5C10.4463 26.7386 12.6849 24.5 15.4463 24.5H17.3049Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M34.4463 40.5V31.5C34.4463 28.7745 33.356 26.3037 31.5877 24.5H33.4463C36.2077 24.5 38.4463 26.7386 38.4463 29.5V40.5H34.4463Z",
                        fill: "#101214"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("4eAXW", function(module, exports) {
$parcel$export(module.exports, "OfficeBuildingIcon", function () { return $a44e9e73e8ce2395$export$2a7e5122c4e1fda; });

var $7VQPk = parcelRequire("7VQPk");
const $a44e9e73e8ce2395$export$2a7e5122c4e1fda = ({ size: size })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 48 49",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                id: "Brand Icons/Office Building",
                clipPath: "url(#clip0_5565_6283)",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    id: "Vector",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11.999 40.5V8.5H35.999V40.5H26.9995V33.5H20.9995V40.5H11.999ZM17.999 15.5H21.999V12.5H17.999V15.5ZM25.999 15.5H29.999V12.5H25.999V15.5ZM21.999 22.5H17.999V19.5H21.999V22.5ZM17.999 29.5H21.999V26.5H17.999V29.5ZM29.999 22.5H25.999V19.5H29.999V22.5ZM25.999 29.5H29.999V26.5H25.999V29.5Z",
                    fill: "#101214"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                    id: "clip0_5565_6283",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        width: "48",
                        height: "48",
                        fill: "white",
                        transform: "translate(-0.000976562 0.5)"
                    })
                })
            })
        ]
    });
};

});

parcelRegister("b5WBX", function(module, exports) {
$parcel$export(module.exports, "PlayIcon", function () { return $c98fe34d56285e32$export$a6630b90defda83f; });

var $7VQPk = parcelRequire("7VQPk");
const $c98fe34d56285e32$export$a6630b90defda83f = ({ size: size })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 48 49",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                clipPath: "url(#clip0_5565_6290)",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M37.999 10.5H9.99902V38.5H37.999V10.5ZM17.0027 16C15.8981 16 15.0027 16.8954 15.0027 18C15.0027 19.1046 15.8981 20 17.0027 20C18.1073 20 19.0027 19.1046 19.0027 18C19.0027 16.8954 18.1073 16 17.0027 16ZM17.0027 29C15.8981 29 15.0027 29.8954 15.0027 31C15.0027 32.1046 15.8981 33 17.0027 33C18.1073 33 19.0027 32.1046 19.0027 31C19.0027 29.8954 18.1073 29 17.0027 29ZM15.0027 24.5C15.0027 23.3954 15.8981 22.5 17.0027 22.5C18.1073 22.5 19.0027 23.3954 19.0027 24.5C19.0027 25.6046 18.1073 26.5 17.0027 26.5C15.8981 26.5 15.0027 25.6046 15.0027 24.5ZM31.999 19.5139L21.999 19.5139V16.5139L31.999 16.5139V19.5139ZM31.999 26L21.999 26V23L31.999 23V26ZM21.999 32.5H31.999V29.5H21.999V32.5Z",
                    fill: "#101214"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                x: "11.999",
                y: "12.5",
                width: "24",
                height: "24",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M30.999 24L19.749 30.4952L19.749 17.5048L30.999 24Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                    id: "clip0_5565_6290",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        width: "48",
                        height: "48",
                        fill: "white",
                        transform: "translate(-0.000976562 0.5)"
                    })
                })
            })
        ]
    });
};

});

parcelRegister("6fSQu", function(module, exports) {
$parcel$export(module.exports, "InfoCard", function () { return $f03f81205745c26a$export$2a4a2d730793fc2a; });
/* info-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $f03f81205745c26a$var$infoCardContainerStyles = null;
const $f03f81205745c26a$var$titleStyles = null;
const $f03f81205745c26a$var$paragraphStyles = null;
const $f03f81205745c26a$var$iconContainerStyles = null;
const $f03f81205745c26a$export$2a4a2d730793fc2a = ({ Icon: Icon, title: title, paragraph: paragraph, callToActionUrl: callToActionUrl, iconSize: iconSize = '48', dataEventProps: dataEventProps })=>{
    const isExternalHref = callToActionUrl.startsWith('https://');
    return /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        href: callToActionUrl,
        target: isExternalHref ? '_blank' : undefined,
        rel: isExternalHref ? 'noreferrer noopener' : undefined,
        ...dataEventProps,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _1bsb1178 _1tke4cy5 _1yt45gjp _2lx21bp4 _1bah1h6o _4cvr1y6m _zulp19bv _1o9zidpf _2rkou2gc _bfhku67f _19it14it _v564jfwv _1dbzv75q"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1pfhgktf"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)(Icon, {
                        size: iconSize
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                    className: (0, $2jatx.default)([
                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _vwz41ul9",
                        "h4"
                    ]),
                    children: title
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: (0, $2jatx.default)([
                        "_1tket9kd _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1wug _vwz41tcg"
                    ]),
                    children: paragraph
                })
            ]
        })
    });
};

});

parcelRegister("6W938", function(module, exports) {
$parcel$export(module.exports, "feelSupportedSectioni18n", function () { return $cfc6388c299c5d03$export$2388077e1c060dc; });

var $fnHPc = parcelRequire("fnHPc");
const $cfc6388c299c5d03$export$2388077e1c060dc = (0, $fnHPc.defineMessages)({
    feelSupportSectionHeader: {
        id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.Header',
        defaultMessage: 'Feel supported every step of the way'
    },
    atlassianCommunityInfoCardTitle: {
        id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.AtlassianCommunity.Title',
        defaultMessage: 'Atlassian Community'
    },
    atlassianCommunityInfoCardParagraph: {
        id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.AtlassianCommunity.Paragraph',
        defaultMessage: 'Your questions, answered by our community of experts'
    },
    atlassianCommunityInfoCardCallToActionText: {
        id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.AtlassianCommunity.CallToAction.Text',
        defaultMessage: 'Join now'
    },
    useCasesInfoCardTitle: {
        id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.UseCases.Title',
        defaultMessage: 'Use cases'
    },
    useCasesInfoCardParagraph: {
        id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.UseCases.Paragraph',
        defaultMessage: 'How different industries & teams use Confluence'
    },
    useCasesInfoCardCallToActionText: {
        id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.UseCases.CallToAction.Text',
        defaultMessage: 'Learn more'
    },
    videoWalkthroughsInfoCardTitle: {
        id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.VideoWalkthroughs.Title',
        defaultMessage: 'Video walkthroughs'
    },
    videoWalkthroughsInfoCardParagraph: {
        id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.VideoWalkthroughs.Paragraph',
        defaultMessage: 'Visual explanations for features & setup steps'
    },
    videoWalkthroughsInfoCardCallToActionText: {
        id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.VideoWalkthroughs.CallToAction.Text',
        defaultMessage: 'Watch now'
    },
    productGuidesInfoCardTitle: {
        id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.ProductGuides.Title',
        defaultMessage: 'User guides'
    },
    productGuidesInfoCardParagraph: {
        id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.ProductGuides.Paragraph',
        defaultMessage: 'In-depth guides to help build your Confluence expertise'
    },
    productGuidesInfoCardCallToActionText: {
        id: 'ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.ProductGuides.CallToAction.Text',
        defaultMessage: 'Read more'
    }
});

});


parcelRegister("592OP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $db25af6051e1db81$export$2e2bcd8739ae039; });
/* hero-text-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $20OkY = parcelRequire("20OkY");

var $lmQGF = parcelRequire("lmQGF");

var $8IYGL = parcelRequire("8IYGL");

var $asbmK = parcelRequire("asbmK");

var $6KUQg = parcelRequire("6KUQg");

var $irRyj = parcelRequire("irRyj");

var $32ARy = parcelRequire("32ARy");

var $l7G9R = parcelRequire("l7G9R");

var $gfjAv = parcelRequire("gfjAv");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $jsxHL = parcelRequire("jsxHL");

var $izdHQ = parcelRequire("izdHQ");

var $02dyT = parcelRequire("02dyT");
const $db25af6051e1db81$var$sectionStyle = null;
const $db25af6051e1db81$var$relative = null;
const $db25af6051e1db81$var$wrapper = null;
const $db25af6051e1db81$var$embeddedSignupStyle = null;
const $db25af6051e1db81$var$submitWrapperStyle = null;
const $db25af6051e1db81$var$socialWrapperStyle = null;
const $db25af6051e1db81$export$86cbf5054d71d20c = ({ lineBreak: lineBreak = false })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "ConfluenceSoftwarePage.v4.heroHeader",
        defaultMessage: "Goodbye silos, <bold-text>hello</bold-text> <underline-comp>teamwork</underline-comp>",
        values: {
            'bold-text': (node)=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                    children: [
                        lineBreak && /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: "superhero",
                            children: node
                        })
                    ]
                }),
            'underline-comp': (node)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $8IYGL.Adg4TextUnderline), {
                    underlineInset: "-28%",
                    underline: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                        image: {
                            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/i01olj0l1c7t5w32dncm1wn5853ibm16.svg',
                            alt: 'hero underline'
                        }
                    }),
                    children: node
                })
        }
    });
};
const $db25af6051e1db81$var$HeroTextSection = ({ userProfile: userProfile })=>{
    const intl = (0, $8e22h.default)();
    const ctaText = intl.formatMessage({
        id: 'ConfluenceSoftwarePage.v4.heroCTA',
        defaultMessage: 'Get Confluence free'
    });
    const signupLink = (0, $jQ0cd.useLocalizedHref)('/software/confluence/free');
    const { openCrossFlow: openCrossFlow } = (0, $asbmK.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).CONFLUENCE,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const embeddedSignup = !userProfile;
    (0, $izdHQ.useFeatureExposed)('cfind-2432_embedded_sign-up_confluence_unpaid_pt', 'Test', {
        conditions: [
            embeddedSignup
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-heroTextSection",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
                className: (0, $2jatx.default)([
                    "_85i5pxbi _1reo15vq _18m915vq"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _ca0qidpf _u5f31tcg _n3tdidpf _19bv1tcg _1kt9b3bt _1cs8stnw _z5wtidpf _iajmidpf _1y8l1git _1mp4auwl _kfgt1osq _1s6k1bjw _tgsmz517 _1g0v1mrw"
                    ]),
                    style: {
                        "--_lwvw50": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue100'))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_p12f6nhw _1e0c1txw _1bah1h6o _4cvr1h6o _zulp1wto _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1gde1bp4 _8164idpf",
                            embeddedSignup && "_1bah1yb4"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $02dyT.default), {
                                header: /*#__PURE__*/ (0, $7VQPk.jsx)($db25af6051e1db81$export$86cbf5054d71d20c, {
                                    lineBreak: embeddedSignup
                                }),
                                subHeader: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "ConfluenceSoftwarePage.v4.heroSubHeading",
                                    defaultMessage: "Create, share, and harness knowledge across teams"
                                }),
                                leftAligned: embeddedSignup,
                                cta: !embeddedSignup && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gfjAv.default), {
                                    intentType: 'button',
                                    containerId: 'heroSection',
                                    productKey: 'confluence',
                                    edition: 'free',
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                                        variant: "primary",
                                        size: "large",
                                        color: "blue",
                                        onClick: openCrossFlow,
                                        href: signupLink,
                                        dataEventProps: {
                                            'data-product-key': 'confluence',
                                            'data-event': 'clicked',
                                            'data-event-component': 'linkButton',
                                            'data-event-container': 'heroSection',
                                            'data-label': 'hero-get-confluence-free',
                                            'data-label-english': 'Get Confluence free',
                                            'data-track-event': 'confluence-pt.get-confluence-free.cta'
                                        },
                                        children: ctaText
                                    }, 'confluence')
                                })
                            }),
                            embeddedSignup && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1bsb1qbf _ca0q1wto _u5f3idpf _n3td1wto _19bvidpf _1u2qidpf _1vdkidpf"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6KUQg.AccountCreation), {
                                    Input: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $irRyj.Input), {
                                        helpText: null
                                    }),
                                    Submit: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1o7p1j6v _1wtni2wt _d4lf1ylp"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l7G9R.Submit), {})
                                    }),
                                    Social: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_jk7416hb _1b94glyw"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $32ARy.Social), {
                                            providers: {
                                                google: 'Google',
                                                apple: 'Apple',
                                                slack: 'Slack'
                                            }
                                        })
                                    }),
                                    Login: null
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
$db25af6051e1db81$var$HeroTextSection.displayName = 'HeroTextSection';
var $db25af6051e1db81$export$2e2bcd8739ae039 = $db25af6051e1db81$var$HeroTextSection;

});
parcelRegister("8IYGL", function(module, exports) {
$parcel$export(module.exports, "Adg4TextUnderline", function () { return $37a3584e5be26d24$export$a8ef4069b9c5e8b7; });
/* text-underline.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");
const $37a3584e5be26d24$var$textStyle = null;
const $37a3584e5be26d24$var$inViewTextStyle = null;
const $37a3584e5be26d24$var$underlineStyle = null;
const $37a3584e5be26d24$var$inViewUnderlineStyle = null;
const $37a3584e5be26d24$var$hiddenText = null;
const $37a3584e5be26d24$var$visibleText = null;
const $37a3584e5be26d24$export$a8ef4069b9c5e8b7 = ({ text: text, children: children, underline: underline, underlineInset: underlineInset = "-37.5%", underlineLeft: underlineLeft = false, fontWeight: fontWeight = {
    from: 400,
    to: 800
}, useInViewOptions: useInViewOptions })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)(useInViewOptions);
    const fontWeightAnimation = null;
    const underlineInsetStyle = null;
    const toFontWeight = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
        ref: scrollRef,
        className: (0, $2jatx.default)([
            "_1e0c116y _19pkidpf _2hwxidpf _otyridpf _18u0idpf _kqswh2mm _ju251bs3 _5sagfnf5 _tip8kb7n _1o51q7pw _vwz4kb7n _1nmz1hna",
            sectionIsVisible && "_j7hq1dkr"
        ]),
        style: {
            "--_15xzfe0": (0, $6ZVlx.default)(fontWeight.from),
            "--_1bgzcf7": (0, $6ZVlx.default)(fontWeight.to)
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                "aria-hidden": true,
                className: (0, $2jatx.default)([
                    "_3um015vq _lcxvglyw",
                    "_k48p103h"
                ]),
                style: {
                    "--_1bgzcf7": (0, $6ZVlx.default)(fontWeight.to)
                },
                children: text ?? children
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _1e02idpf"
                ]),
                children: text ?? children
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bsb1osq _mkrz16t8 _ju251bs3 _5sagpwmj _tip8kb7n _1e02idpf _1o51q7pw _kqswstnw _1pby1mrw",
                    "_u7co11y5 _cjf710zq _1kni10zq",
                    sectionIsVisible && "_j7hqzu28"
                ]),
                style: {
                    "--_1jmpxqi": (0, $6ZVlx.default)(underlineInset),
                    "--_p0j3r4": (0, $6ZVlx.default)(underlineLeft ? "0" : "auto")
                },
                children: underline
            })
        ]
    });
};

});


parcelRegister("cWN5u", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4fd8df2d7726aaf5$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $jQ0cd = parcelRequire("jQ0cd");

var $cAI5M = parcelRequire("cAI5M");

var $je135 = parcelRequire("je135");
const $4fd8df2d7726aaf5$var$IntegrationsSection = ()=>{
    const intl = (0, $8e22h.default)();
    const iconData = [
        {
            url: 'https://wac-cdn.atlassian.com/misc-assets/svgs/jira.svg',
            altText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.integrations.jira-logo-alt',
                defaultMessage: 'The Jira logo which resembles three arrowheads pointing up and to the right.'
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/software/confluence/jira-integration')
        },
        {
            url: 'https://wac-cdn.atlassian.com/misc-assets/svgs/loom_beam_color.svg',
            altText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.integrations.loom-logo-alt',
                defaultMessage: 'Loom logo'
            }),
            href: 'https://marketplace.atlassian.com/apps/1225947/loom-for-confluence'
        },
        {
            url: 'https://wac-cdn.atlassian.com/misc-assets/svgs/trello-icon-logo.svg',
            altText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.integrations.trello-logo-alt',
                defaultMessage: 'Trello logo which resembles a trello board with two columns.'
            }),
            href: (0, $jQ0cd.useLocalizedHrefTrello)('/')
        },
        {
            url: 'https://wac-cdn.atlassian.com/misc-assets/svgs/microsoft-teams.svg',
            altText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.integrations.microsoft-teams-logo-alt',
                defaultMessage: 'Microsoft Teams logo'
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/software/confluence/microsoft-teams-integration')
        },
        {
            url: 'https://wac-cdn.atlassian.com/misc-assets/svgs/figma.svg',
            altText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.integrations.figma-logo-alt',
                defaultMessage: 'Figma logo'
            }),
            href: 'https://marketplace.atlassian.com/apps/1221692/figma-for-confluence'
        },
        {
            url: 'https://wac-cdn.atlassian.com/misc-assets/svgs/slack-icon-logo.svg',
            altText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.integrations.slack-logo-alt',
                defaultMessage: 'Slack logo'
            }),
            href: 'https://marketplace.atlassian.com/apps/1219518/confluence-cloud-for-slack-official'
        },
        {
            url: 'https://wac-cdn.atlassian.com/misc-assets/svgs/google-drive-logo.svg',
            altText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.integrations.google-drive-logo-alt',
                defaultMessage: 'Google Drive logo'
            }),
            href: 'https://marketplace.atlassian.com/apps/1216978/google-drive-and-docs-for-confluence'
        }
    ];
    const headingText = intl.formatMessage({
        id: 'ConfluenceSoftwarePage.v4.integrationsSection.header',
        defaultMessage: 'Integrate with your faves'
    });
    const bodyText = intl.formatMessage({
        id: 'ConfluenceSoftwarePage.v4.integrationsSection.body',
        defaultMessage: 'All the tools you know and love integrate smoothly with Confluence'
    });
    const ctaText = intl.formatMessage({
        id: 'ConfluenceSoftwarePage.v4.integrationsSection.cta',
        defaultMessage: 'Go to Marketplace'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-integrationsSection",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $je135.ScrollTracking), {
            section: "IntegrationsSection",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cAI5M.Adg4OffsetIconCollection), {
                iconData: iconData,
                headingText: headingText,
                bodyText: bodyText,
                ctaText: ctaText,
                productKey: "confluence",
                ctaLink: "https://marketplace.atlassian.com/addons/app/confluence"
            })
        })
    });
};
$4fd8df2d7726aaf5$var$IntegrationsSection.displayName = 'IntegrationsSection';
var $4fd8df2d7726aaf5$export$2e2bcd8739ae039 = $4fd8df2d7726aaf5$var$IntegrationsSection;

});
parcelRegister("cAI5M", function(module, exports) {
$parcel$export(module.exports, "Adg4OffsetIconCollection", function () { return $e95e9453f4d3c6cc$export$df552133577e6dc7; });
/* offset-icon-collection.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $lmQGF = parcelRequire("lmQGF");

var $kbpa7 = parcelRequire("kbpa7");
const $e95e9453f4d3c6cc$var$sectionContainer = null;
const $e95e9453f4d3c6cc$var$contentContainer = null;
const $e95e9453f4d3c6cc$var$textContainerStyles = null;
const $e95e9453f4d3c6cc$var$headingTextStyles = null;
const $e95e9453f4d3c6cc$var$bodyTextStyles = null;
const $e95e9453f4d3c6cc$var$iconContainerStyles = null;
const $e95e9453f4d3c6cc$var$iconStyles = null;
const $e95e9453f4d3c6cc$var$linkStyles = null;
const $e95e9453f4d3c6cc$var$animationStyle = null;
const $e95e9453f4d3c6cc$export$df552133577e6dc7 = ({ iconData: iconData, textPosition: textPosition = 'right', headingText: headingText, bodyText: bodyText, ctaText: ctaText, ctaLink: ctaLink, productKey: productKey, ctaOnClickFunc: ctaOnClickFunc })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)();
    const isExternalHref = ctaLink.startsWith('https://');
    const textSection = /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1y6m _1bah1h6o _1gde1bp4 _ag851h6o _xsmr1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                className: (0, $2jatx.default)([
                    "_1mouidpf"
                ]),
                children: headingText
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_1mouidpf _1pfh1kwk _6rth1k8s _p12f1yxl _8fz6jbd8"
                ]),
                children: bodyText
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                variant: "secondary",
                size: "large",
                color: "black",
                href: ctaLink,
                target: isExternalHref ? '_blank' : undefined,
                rel: isExternalHref ? 'noreferrer noopener' : undefined,
                onClick: ctaOnClickFunc,
                dataEventProps: productKey ? {
                    'data-product-key': productKey,
                    'data-event': 'clicked',
                    'data-event-component': 'linkButton',
                    'data-event-container': 'integrationsSection',
                    'data-label': 'integrations-cta',
                    'data-track-event': 'integrations.cta'
                } : undefined,
                children: ctaText
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _1e0c1txw _1bah1h6o _4cvr1h6o _2lx21bp4"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx2vrvc _p12f17gh _1mouviql _zulp1et3 _1p5sckbl _1gzv14no _suga1txw _1gde1bp4 _ag851h6o _81641tcg"
            ]),
            children: [
                textPosition !== 'right' && textSection,
                /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                    ref: scrollRef,
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1n261g80 _i0dl1osq _zulp6veu _1bah1h6o _ae4v1h6o _p12f1vci _1o9zidpf _qtt8glyw _18zridpf _1p5s1bkc _ceho1byl _2osn7vkz _8fz6jbd8"
                    ]),
                    children: iconData.map((icon, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                            children: icon.href ? /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                href: icon.href,
                                "data-product-key": productKey,
                                "data-event-container": "integrationsSection",
                                "data-event-component": "linkButton",
                                "data-label": icon.altText,
                                "data-event": "clicked",
                                "data-track-event": "integrations.icon",
                                className: (0, $2jatx.default)([
                                    "_2rkod4y9 _1e0c1txw _4cvr1h6o _1bah1h6o _tip8kb7n _5sagw1p3 _11q71afi _1bsb18ly _4t3i18ly _rtys1ssb _19l31ssb _mezj1wug _bna71wug _1leho7ao _1hr216xz _159516xz _1l9uo7ao _1s4pvbgk _1knevbgk",
                                    "_80omtlke _16qs1yxe _1dbzjojz",
                                    sectionIsVisible && "_j7hq1nm9"
                                ]),
                                style: {
                                    animationDelay: `${0.5 + 0.25 * index}s`,
                                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                                    src: icon.url,
                                    alt: icon.altText
                                })
                            }) : /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_2rkod4y9 _1e0c1txw _4cvr1h6o _1bah1h6o _tip8kb7n _5sagw1p3 _11q71afi _1bsb18ly _4t3i18ly _rtys1ssb _19l31ssb _mezj1wug _bna71wug _1leho7ao _1hr216xz _159516xz _1l9uo7ao _1s4pvbgk _1knevbgk",
                                    sectionIsVisible && "_j7hq1nm9"
                                ]),
                                style: {
                                    animationDelay: `${0.5 + 0.25 * index}s`,
                                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                                    src: icon.url,
                                    alt: icon.altText
                                })
                            })
                        }, index))
                }),
                textPosition === 'right' && textSection
            ]
        })
    });
};

});


parcelRegister("4sY9l", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e0736add56ee2978$export$2e2bcd8739ae039; });
/* scroller-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $20OkY = parcelRequire("20OkY");

var $lmQGF = parcelRequire("lmQGF");

var $jr060 = parcelRequire("jr060");

var $asbmK = parcelRequire("asbmK");

var $gfjAv = parcelRequire("gfjAv");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $4hIcA = parcelRequire("4hIcA");

var $je135 = parcelRequire("je135");
const $e0736add56ee2978$var$contentStyles = null;
const $e0736add56ee2978$var$headingStyles = null;
const $e0736add56ee2978$var$textStyles = null;
const $e0736add56ee2978$var$scrollerHeading = null;
const $e0736add56ee2978$var$buttonContainer = null;
const $e0736add56ee2978$var$arrowStyles = null;
const $e0736add56ee2978$var$sectionStyle = null;
const $e0736add56ee2978$var$arrowInAnimation = null;
const $e0736add56ee2978$export$272f9c9325d00e8b = (props)=>{
    const transformStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: "72",
        height: "25",
        viewBox: "0 0 72 25",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $2jatx.default)([
            "_kqswstnw _5sag9cwz _ju251yx9 _tip8kb7n _1o51eoah",
            props.animate && "_j7hqxb4k"
        ]),
        style: {
            insetInlineStart: props.left,
            insetInlineEnd: props.right,
            insetBlockStart: props.top,
            insetBlockEnd: props.bottom,
            transform: `rotate(${props.rotate ? props.rotate : '0'}deg)`,
            color: props.color ? props.color : 'currentColor',
            visibility: props.animate ? 'visible' : 'hidden',
            "--_l8fg41": (0, $6ZVlx.default)(props.rotate ?? 0, "deg")
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M59.9377 15.3992C59.0173 14.9197 58.1224 14.8026 57.2375 14.6506C56.2764 14.4847 55.3298 14.5122 54.3661 14.6939C53.5179 14.8575 52.6572 14.756 51.8548 14.5047C50.3545 14.0308 48.8161 13.9548 47.2581 13.9487C46.2852 13.9435 45.2992 13.8949 44.3421 13.7474C43.6788 13.6425 43.0503 13.3313 42.3766 13.1053C41.985 13.7302 41.3847 13.7038 40.7654 13.4715C39.4868 12.9907 38.1709 12.9018 36.8181 12.9291C36.0821 12.9425 35.3546 12.7709 34.7504 12.2942C34.6729 12.2382 34.5745 12.21 34.4827 12.1765C33.8726 12.7787 33.1602 12.7406 32.4202 12.5737C31.2308 12.3121 30.0329 12.0735 28.8435 11.8119C28.0392 11.6324 27.2369 11.435 26.434 11.2435C25.6375 11.0468 24.8746 10.7635 24.004 10.9669C22.9249 11.2205 21.8431 10.958 20.7692 10.7864C19.5431 10.5869 18.3301 10.2689 17.1034 10.1833C15.0061 10.0312 12.9448 9.66091 10.8685 9.37304C9.87464 9.2337 8.87682 9.12994 7.89344 8.94972C6.89235 8.76766 5.89651 8.53817 4.91509 8.28619C3.86938 8.02152 2.82958 7.7035 1.79371 7.40388C1.12194 7.21408 0.740116 6.67063 0.443572 6.11206C0.359595 5.95341 0.591152 5.53371 0.780077 5.33746C1.3744 4.71561 2.13013 4.41639 2.99148 4.35003C4.92541 4.19732 6.85018 4.28953 8.7651 4.47067C10.4852 4.63154 12.1902 4.92878 13.8886 5.23134C15.8515 5.57338 17.8274 5.79684 19.8165 5.95571C21.368 6.07507 22.9135 6.30175 24.4618 6.45076C25.9089 6.59525 27.3614 6.69231 28.8151 6.83149C30.4224 6.98663 32.0303 7.13584 33.6388 7.3331C35.9198 7.60628 38.1897 7.92627 40.47 8.20538C42.0904 8.40386 43.7114 8.59642 45.3646 8.49847C46.3027 8.4401 47.2618 8.62379 48.1927 8.79256C49.5336 9.03394 50.885 9.07253 52.239 9.14136C53.8902 9.22311 55.5421 9.29894 57.1985 9.38723C57.6735 9.41263 58.1432 9.48547 58.6182 9.51087C58.7481 9.52438 58.8865 9.46081 59.0203 9.43874C58.9685 9.31341 58.9514 9.14372 58.8583 9.06807C58.3052 8.61476 57.7305 8.19518 57.1775 7.74187C55.7106 6.53386 54.2437 5.32585 52.784 4.1066C52.2211 3.63427 51.8989 2.98308 51.5571 2.34784C51.3492 1.9604 51.5341 1.63781 51.7218 1.34547C51.9021 1.06438 52.0235 0.669208 52.4453 0.635111C52.7346 0.611222 53.0239 0.587334 53.3159 0.593703C54.7643 0.618392 56.0541 1.16031 57.3235 1.77807C58.2302 2.22017 59.1204 2.70255 60.0415 3.12217C60.4279 3.30028 60.6627 3.55259 60.8241 3.92919C60.9383 4.19293 61.0275 4.52005 61.4388 4.203C61.6212 4.06605 61.8429 4.11309 62.0102 4.32839C62.2563 4.64183 62.5469 4.92992 62.7922 5.24929C62.9589 5.47051 63.1498 5.52635 63.422 5.54866C64.448 5.61337 65.2517 6.12273 65.8284 6.95631C66.199 7.4926 66.6963 7.85616 67.2599 8.10666C67.9146 8.39663 68.5004 8.76939 68.9623 9.29118C69.8119 10.2491 70.6155 11.2442 71.4126 12.2446C71.7531 12.6758 71.6567 13.4934 71.2651 13.9024C70.5625 14.639 69.8337 15.3428 69.1476 16.093C68.7802 16.4986 68.4883 16.978 68.1472 17.4163C68.0081 17.5937 67.8625 17.8305 67.6703 17.8944C66.9192 18.1522 66.4311 18.7311 65.8676 19.2362C65.6354 19.4459 65.3887 19.6782 65.1073 19.7928C64.1935 20.1716 63.2705 20.5253 62.3343 20.8358C62.0614 20.9274 61.7282 20.8087 61.4231 20.813C61.2854 20.8167 61.0794 20.8432 61.0217 20.9332C60.5146 21.738 59.7602 22.1333 58.8588 22.1835C57.4825 22.2623 56.1856 22.7031 54.8565 23.0027C53.3253 23.3472 51.7949 23.6858 50.267 24.0547C49.0888 24.34 47.9008 24.4443 46.6976 24.4151C46.1853 24.4038 45.8133 24.1493 45.6316 23.7406C45.2412 22.8424 45.1435 22.8622 45.7706 22.0519C45.8893 21.8963 46.0244 21.7544 46.1209 21.5846C46.4935 20.9157 47.1521 20.7922 47.8029 20.5781C48.9181 20.2143 50.011 19.7822 51.0986 19.3436C52.5241 18.7662 53.93 18.1508 55.345 17.5603C56.1092 17.2379 56.8866 16.959 57.6358 16.6111C58.3849 16.2632 59.1046 15.8583 59.9219 15.4335L59.9377 15.3992Z",
            fill: "currentColor"
        })
    });
};
const $e0736add56ee2978$var$AnimatedArrowButton = ({ href: href, text: text, onClick: onClick, label: label, labelEnglish: labelEnglish })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)({
        threshold: 1
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ref: scrollRef,
        className: (0, $2jatx.default)([
            "_kqswh2mm _1e0c1o8l"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                href: href,
                color: "blue",
                size: "large",
                onClick: onClick,
                dataEventProps: {
                    'data-product-key': 'confluence',
                    'data-event': 'clicked',
                    'data-event-component': 'linkButton',
                    'data-event-container': 'scrollPinnedSection',
                    'data-label': label,
                    'data-label-english': labelEnglish
                },
                children: text
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)($e0736add56ee2978$export$272f9c9325d00e8b, {
                rotate: 180,
                right: -88,
                top: "25%",
                animate: sectionIsVisible
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)($e0736add56ee2978$export$272f9c9325d00e8b, {
                rotate: -140,
                right: -61,
                bottom: -49,
                animate: sectionIsVisible
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)($e0736add56ee2978$export$272f9c9325d00e8b, {
                rotate: -121,
                right: 0,
                bottom: -62,
                animate: sectionIsVisible
            })
        ]
    });
};
const $e0736add56ee2978$var$ScrollerContent = ({ item: item })=>{
    const { ref: ref } = (0, $je135.useScrollTracking)(`ScrollerSectionItem-${item.id}`);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ref: ref,
        className: (0, $2jatx.default)([
            "_xsmr1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                ]),
                children: item.title
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1q517vkz _85i51tcg"
                ]),
                children: item.description
            }),
            item.link && item.link.type === 'link' && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                text: item.link.text,
                "aria-label": item.link.ariaLabelText,
                href: item.link.href,
                onClick: item.link.onClick,
                dataEventProps: {
                    'data-product-key': 'confluence',
                    'data-event': 'clicked',
                    'data-event-component': 'linkButton',
                    'data-event-container': 'scrollPinnedSection',
                    'data-label': item.link.label,
                    'data-label-english': item.link.labelEnglish
                }
            }),
            item.link && item.link.type === 'button' && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gfjAv.default), {
                intentType: 'button',
                containerId: 'scrollPinnedSection',
                productKey: 'confluence',
                edition: 'free',
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($e0736add56ee2978$var$AnimatedArrowButton, {
                    href: item.link.href,
                    text: item.link.text,
                    onClick: item.link.onClick,
                    label: item.link.label,
                    labelEnglish: item.link.labelEnglish
                })
            })
        ]
    });
};
const $e0736add56ee2978$var$ScrollerSection = ()=>{
    const intl = (0, $8e22h.default)();
    const featuresLink = (0, $jQ0cd.useLocalizedHref)('/software/confluence/features');
    const signupLink = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=confluence');
    const { openCrossFlow: openCrossFlow } = (0, $asbmK.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).CONFLUENCE,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const { ref: ref } = (0, $je135.useScrollTracking)('ScrollerSection', {
        observerOptions: {
            threshold: 0.1
        }
    });
    const items = [
        {
            id: '1-files',
            title: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.v4.scroller.1.title',
                defaultMessage: 'From files to freedom'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.v4.scroller.1.description',
                defaultMessage: 'Create dynamic Pages with all kinds of content, like Whiteboards, Databases, and videos. Pull in all your work to reduce context-switching.'
            }),
            feature: {
                src: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/confluence-scroll-2.webp',
                alt: intl.formatMessage({
                    id: 'ConfluenceSoftwarePage.v4.scroller.1.imgAlt',
                    defaultMessage: 'image of a confluence page'
                })
            },
            bgColor: (0, $kbpa7.wacToken)('color.primary.lime'),
            lazyLoadImage: true,
            bgShape: '0% 29%, 42% 28%, 43% 5%, 100% 0%, 100% 95%, 60% 95%, 60% 100%, 2% 93%, 2% 93%, 2% 93%',
            link: {
                type: 'link',
                text: intl.formatMessage({
                    id: 'ConfluenceSoftwarePage.v4.scroller.1.linkText',
                    defaultMessage: 'See more features'
                }),
                label: 'see-more-features',
                labelEnglish: 'See more features',
                href: featuresLink,
                ariaLabelText: intl.formatMessage({
                    id: 'ConfluenceSoftwarePage.v4.scroller.1.linkAriaLabel',
                    defaultMessage: 'See more features of Confluence'
                })
            }
        },
        {
            id: '2-work',
            title: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.v4.scroller.2.title',
                defaultMessage: 'Your shortcut for accelerating work'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.v4.scroller.2.description',
                defaultMessage: "Eliminate writer\u2019s block, automate repetitive tasks, and summarize lengthy docs with AI."
            }),
            feature: {
                src: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/confluence-scroll-1-updated.webp',
                alt: intl.formatMessage({
                    id: 'ConfluenceSoftwarePage.v4.scroller.2.imgAlt',
                    defaultMessage: 'image of Atlassian Intelligence on a confluence page'
                })
            },
            bgColor: (0, $kbpa7.wacToken)('color.primary.purple'),
            lazyLoadImage: true,
            bgShape: '6% 28%, 52% 23%, 53% 5%, 100% 0%, 100% 99%, 6% 96%, 6% 89%, 0% 88%, 0% 51%, 7% 50%',
            link: intl.locale === 'en' ? {
                type: 'link',
                text: intl.formatMessage({
                    id: 'ConfluenceSoftwarePage.v4.scroller.2.linkText',
                    defaultMessage: 'Try it out'
                }),
                label: 'try-it-out',
                labelEnglish: 'Try it out',
                href: 'https://www.atlassian.com/confluence-sandbox-editor',
                ariaLabelText: intl.formatMessage({
                    id: 'ConfluenceSoftwarePage.v4.scroller.2.linkAriaLabel',
                    defaultMessage: 'Try out Confluence for free'
                })
            } : undefined
        },
        {
            id: '3-teams',
            title: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.v4.scroller.3.title',
                defaultMessage: 'Connect the dots across your teams'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.v4.scroller.3.description',
                defaultMessage: "Build a source of truth for all teams. Stay caught up across your company with organized content and knowledge that's easily findable and always up-to-date."
            }),
            feature: {
                src: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/confluence-scroll-3.webp',
                alt: intl.formatMessage({
                    id: 'ConfluenceSoftwarePage.v4.scroller.3.imgAlt',
                    defaultMessage: 'image of a deliverable & outcomes document in confluence'
                })
            },
            bgColor: (0, $kbpa7.wacToken)('color.primary.saffron'),
            lazyLoadImage: true,
            bgShape: '0% 25%, 42% 20%, 42% 5%, 100% 0%, 100% 95%, 51% 100%, 50% 94%, 3% 95%, 3% 95%, 3% 95%',
            link: {
                type: 'button',
                text: intl.formatMessage({
                    id: 'ConfluenceSoftwarePage.v4.scroller.3.linkText',
                    defaultMessage: 'Get started free'
                }),
                label: 'get-started-free',
                labelEnglish: 'Get started free',
                href: signupLink,
                onClick: openCrossFlow,
                ariaLabelText: intl.formatMessage({
                    id: 'ConfluenceSoftwarePage.v4.scroller.3.linkAriaLabel',
                    defaultMessage: 'Get started with Confluence for free'
                })
            }
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-scrollerSection",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            ref: ref,
            className: (0, $2jatx.default)([
                "_1reozryt _18m9zryt"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4hIcA.Scroller), {
                items: items,
                renderText: (item)=>/*#__PURE__*/ (0, $7VQPk.jsx)($e0736add56ee2978$var$ScrollerContent, {
                        item: item
                    }),
                renderGraphic: (item, activeIndex, mobileSpecific)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $jr060.Adg4FramedImage), {
                        feature: item.feature,
                        accent: item.accent,
                        bgShape: item.bgShape,
                        bgColor: item.bgColor,
                        lazyLoadImage: item.lazyLoadImage,
                        activeIndexIsEven: !mobileSpecific ? activeIndex % 2 === 0 : undefined
                    }),
                layout: "right",
                mobileGraphicLayout: "above",
                backgroundColor: "#fff",
                inScrollBackgroundColor: "#fff",
                heading: /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    className: (0, $2jatx.default)([
                        "_y3gn1h6o _1bsb1osq"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "ConfluenceSoftwarePage.v4.scroller.heading",
                        defaultMessage: "Your team\u2019s knowledge, all in one place"
                    })
                })
            })
        })
    });
};
var $e0736add56ee2978$export$2e2bcd8739ae039 = $e0736add56ee2978$var$ScrollerSection;

});
parcelRegister("jr060", function(module, exports) {
$parcel$export(module.exports, "Adg4FramedImage", function () { return $aff033e41e7c32d0$export$3c140a884be9e13d; });
/* framed-image.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $ep4tq = parcelRequire("ep4tq");
const $aff033e41e7c32d0$export$3c140a884be9e13d = ({ feature: feature, accent: accent, bgShape: bgShape, bgColor: bgColor, activeIndexIsEven: activeIndexIsEven, lazyLoadImage: lazyLoadImage = false })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm _1h1t15ju"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    style: {
                        clipPath: `polygon(${bgShape})`,
                        backgroundColor: bgColor
                    },
                    className: (0, $2jatx.default)([
                        "_1bsb1osq _4t3i1osq _v564t24z _kqswstnw _1e02idpf _152tidpf",
                        activeIndexIsEven === true && "_y44v1cly",
                        activeIndexIsEven === false && "_y44vh8q8"
                    ])
                }),
                accent ? /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                    src: accent.src,
                    className: (0, $2jatx.default)([
                        "_1bsbx19p _kqswstnw _1e02idpf _u7co15qf",
                        activeIndexIsEven === true && "_y44vxsqx",
                        activeIndexIsEven === false && "_y44vgh22",
                        accent.className
                    ]),
                    alt: accent.alt,
                    loading: lazyLoadImage ? 'lazy' : undefined
                }) : '',
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _1e0c1ule _4t3i1wug _1bsb1osq _ca0q19nj _u5f316gx _n3td19nj _19bv16gx _rtys1osq",
                        activeIndexIsEven === true && "_y44vxsqx",
                        activeIndexIsEven === false && "_y44vgh22"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ep4tq.Adg4RaisedMedia), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                            className: feature.className,
                            loading: lazyLoadImage ? 'lazy' : undefined,
                            src: feature.src,
                            alt: feature.alt
                        })
                    })
                })
            ]
        })
    });
};
const $aff033e41e7c32d0$var$framedImageStyles = null;
const $aff033e41e7c32d0$var$imgRegion = null;
const $aff033e41e7c32d0$var$featureImageStyle = null;
const $aff033e41e7c32d0$var$accentImageStyle = null;
const $aff033e41e7c32d0$var$bgShapeStyle = null;
const $aff033e41e7c32d0$var$activeEvenBgStyle = null;
const $aff033e41e7c32d0$var$activeOddBgStyle = null;
const $aff033e41e7c32d0$var$activeEvenImgStyle = null;
const $aff033e41e7c32d0$var$activeOddImgStyle = null;

});

parcelRegister("4hIcA", function(module, exports) {
$parcel$export(module.exports, "ScrollContext", function () { return $7dccf64997c912da$export$dece24112a937f92; });
$parcel$export(module.exports, "Scroller", function () { return $7dccf64997c912da$export$76d6749d1cf8513c; });
/* scroller.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $Yd0go = parcelRequire("Yd0go");
const $7dccf64997c912da$export$dece24112a937f92 = /*#__PURE__*/ (0, $1oC0p.createContext)({
    activeIndex: 0,
    setActiveIndex: ()=>{
        return;
    },
    graphicHeight: 100,
    graphicTopBottom: {
        top: 188,
        bottom: 288
    }
});
const $7dccf64997c912da$export$76d6749d1cf8513c = ({ items: items, renderText: renderText, renderGraphic: renderGraphic, heading: heading, layout: layout = 'left', mobileGraphicLayout: mobileGraphicLayout = 'above', backgroundColor: backgroundColor = '#fff', inScrollBackgroundColor: inScrollBackgroundColor, scrollerInViewOptions: scrollerInViewOptions, navHeight: navHeight = 68 })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)({
        threshold: 0.2,
        ...scrollerInViewOptions
    });
    const containerRef = /*#__PURE__*/ (0, $1oC0p.createRef)();
    const graphicRef = /*#__PURE__*/ (0, $1oC0p.createRef)();
    const headingRef = /*#__PURE__*/ (0, $1oC0p.createRef)();
    const [activeIndex, setActiveIndex] = (0, $1oC0p.useState)(0);
    /**
   * The calculated top position to use for the graphic
   */ const [graphicTop, setGraphicTop] = (0, $1oC0p.useState)(navHeight + 100);
    /**
   * The height of the graphic, used to set min height on the text column
   */ const [graphicHeight, setGraphicHeight] = (0, $1oC0p.useState)(null);
    /**
   * The calculated top and bottom positions
   * to use for determining if an item is aligned with the graphic
   */ const [graphicTopBottom, setGraphicTopBottom] = (0, $1oC0p.useState)(null);
    (0, $1oC0p.useEffect)(()=>{
        if (!containerRef.current || !graphicRef.current || !headingRef.current || !window) return;
        // Where the magic happens
        const calculateSizes = ()=>{
            // Vertically center the graphic +navHeight for the sticky nav
            const currentGraphicHeight = graphicRef.current?.clientHeight ?? 100;
            const currentHeaderHeight = headingRef.current?.clientHeight ?? 100;
            const viewHeight = window.innerHeight;
            const minGraphicY = navHeight + currentHeaderHeight;
            const top = (viewHeight - navHeight - currentGraphicHeight) / 2 + navHeight;
            const newTop = Math.max(minGraphicY, top);
            const newBottom = Math.min(viewHeight, newTop + currentGraphicHeight);
            setGraphicTop(Math.max(minGraphicY, top));
            setGraphicHeight(currentGraphicHeight);
            setGraphicTopBottom({
                top: newTop,
                bottom: newBottom
            });
        };
        const observer = new ResizeObserver(()=>{
            // Use requestAnimationFrame to defer DOM updates and prevent ResizeObserver loop limit errors
            // This helps prevent the "ResizeObserver loop limit exceeded" warning by deferring DOM updates
            requestAnimationFrame(()=>{
                calculateSizes();
            });
        });
        observer.observe(containerRef.current);
        return ()=>{
            // Cleanup the observer by unobserving all elements
            observer.disconnect();
        };
    }, [
        containerRef,
        graphicRef,
        headingRef,
        navHeight
    ]);
    const backgroundStyle = null;
    const inViewBackgroundStyle = null;
    const dynamicHeadingStyle = null;
    const inViewHeaderBackgroundStyle = null;
    const currentItem = items[activeIndex] ?? items[0];
    return /*#__PURE__*/ (0, $7VQPk.jsx)($7dccf64997c912da$export$dece24112a937f92.Provider, {
        value: {
            activeIndex: activeIndex,
            setActiveIndex: setActiveIndex,
            graphicHeight: graphicHeight,
            graphicTopBottom: graphicTopBottom
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            ref: scrollRef,
            className: (0, $2jatx.default)([
                "_bfhkaxbu",
                sectionIsVisible && "_bfhk1tlu"
            ]),
            style: {
                "--_1ly4823": (0, $6ZVlx.default)(backgroundColor),
                "--_1p67x28": (0, $6ZVlx.default)(inScrollBackgroundColor)
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                ref: containerRef,
                className: (0, $2jatx.default)([
                    "_kqswh2mm _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _1e0c1txw _2lx2vrvc _18zrzwfg _umua1wqb _owpu1wqb _gltezqdx",
                    "_85i568cl _1q51mgvx _4cvr1y6m _zulp1wqb _10l5idpf _1w2i1bp4",
                    layout === 'right' && "_2lx21sbv"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        style: {
                            insetBlockEnd: graphicHeight ? graphicHeight + $7dccf64997c912da$var$contentBlockEnd + 'px' : 'auto'
                        },
                        className: (0, $2jatx.default)([
                            "_kqswstnw _152tidpf _1e02idpf _rjxpidpf _1e0c1txw _1bah1h6o _rolbh2mm"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_16jlkb7n _1o9zkb7n _i0dl1osq"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                ref: headingRef,
                                className: (0, $2jatx.default)([
                                    "_kqswh2mm _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _1e0c1txw _2lx2vrvc _18zrzwfg _umua1wqb _owpu1wqb _gltezqdx",
                                    "_152t1hcp",
                                    "_1pbykb7n _kqsw1if8 _rolbh2mm _14ucidpf",
                                    sectionIsVisible && "_1itk1qvr"
                                ]),
                                style: {
                                    "--_fr37x2": (0, $6ZVlx.default)(navHeight ? navHeight + 'px' : 0),
                                    "--_1p67x28": (0, $6ZVlx.default)(inScrollBackgroundColor)
                                },
                                children: heading
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_i0dlhwvj _311g1kc5 _c7541h6o"
                        ]),
                        children: items.map((item, i)=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $Yd0go.ScrollerItem), {
                                index: i,
                                children: [
                                    mobileGraphicLayout === 'above' && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0cglyw _1yba1ule"
                                        ]),
                                        children: renderGraphic(item, activeIndex, true)
                                    }),
                                    renderText(item),
                                    mobileGraphicLayout === 'below' && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0cglyw _1yba1ule"
                                        ]),
                                        children: renderGraphic(item, activeIndex, true)
                                    })
                                ]
                            }, i))
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        ref: graphicRef,
                        style: {
                            insetBlockStart: graphicTop + 'px'
                        },
                        className: (0, $2jatx.default)([
                            "_4cvresu3 _1e0c1txw _2lx21bp4 _1bah1h6o _i0dl1nrf _kqsw1if8 _1ybaglyw"
                        ]),
                        children: renderGraphic(currentItem, activeIndex, false)
                    })
                ]
            })
        })
    });
};
const $7dccf64997c912da$var$mediaQuery = '@media (max-height: 49.99vw) and (max-width: 1271.99px), (max-height: 635.99px) and (min-width: 1272px), not all and (min-width: 48rem)';
const $7dccf64997c912da$var$contentBlockEnd = 120;
const $7dccf64997c912da$var$rowStyles = null;
const $7dccf64997c912da$var$contentStyle = null;
const $7dccf64997c912da$var$headingContainer = null;
const $7dccf64997c912da$var$headingColumnContainer = null;
const $7dccf64997c912da$var$headingStyle = null;
const $7dccf64997c912da$var$rtlRowStyles = null;
const $7dccf64997c912da$var$textColumn = null;
const $7dccf64997c912da$var$mobileItemStyle = null;
const $7dccf64997c912da$var$graphicColumn = null;

});
parcelRegister("Yd0go", function(module, exports) {
$parcel$export(module.exports, "ScrollerItem", function () { return $4fd71dbca21309e3$export$11692ab46144d76c; });
/* scroller-item.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $jKShK = parcelRequire("jKShK");

var $4hIcA = parcelRequire("4hIcA");
const $4fd71dbca21309e3$export$11692ab46144d76c = ({ children: children, index: index })=>{
    const { ref: scrollRef, inView: sectionInView } = (0, $jKShK.useInView)({
        threshold: 0.25
    });
    const itemRef = /*#__PURE__*/ (0, $1oC0p.createRef)();
    const { setActiveIndex: setActiveIndex, graphicHeight: graphicHeight, graphicTopBottom: graphicTopBottom } = (0, $1oC0p.useContext)((0, $4hIcA.ScrollContext));
    (0, $1oC0p.useEffect)(()=>{
        if (!document) return;
        const checkElementPosition = ()=>{
            if (!itemRef.current || !graphicTopBottom || !sectionInView) return;
            const rect = itemRef.current.getBoundingClientRect();
            const top = rect.top;
            const bottom = rect.bottom;
            // check if this element overlaps with the top or bottom of the graphic
            if (top >= graphicTopBottom.top && top <= graphicTopBottom.bottom || bottom >= graphicTopBottom.top && bottom <= graphicTopBottom.bottom) setActiveIndex(index);
        };
        document.addEventListener('scroll', checkElementPosition);
        return ()=>{
            document.removeEventListener('scroll', checkElementPosition);
        };
    }, [
        setActiveIndex,
        index,
        itemRef,
        graphicTopBottom,
        sectionInView
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: scrollRef,
        style: {
            minHeight: graphicHeight ? graphicHeight + 'px' : 'auto'
        },
        className: (0, $2jatx.default)([
            "_kqswh2mm _4t3i1osq _c71l1a8x _1e0c1txw _2lx21bp4 _1bah1h6o _37sk1kxc _19yo1h90 _14q01wqb"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            ref: itemRef,
            className: (0, $2jatx.default)([
                "_1e0c1txw _tzy4kb7n _zulp12am _2lx21bp4"
            ]),
            children: children
        })
    });
};
const $4fd71dbca21309e3$var$mediaQuery = '@media (max-height: 49.99vw) and (max-width: 1271.99px), (max-height: 635.99px) and (min-width: 1272px), not all and (min-width: 48rem)';
const $4fd71dbca21309e3$var$itemWrapperStyle = null;
const $4fd71dbca21309e3$var$itemStyle = null;

});



parcelRegister("5v7eV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6b5236b6b57b7b0a$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $bQjAr = parcelRequire("bQjAr");

var $esXU7 = parcelRequire("esXU7");
const $6b5236b6b57b7b0a$var$SocialEndorsementSection = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-socialEndorsementSection",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $esXU7.SocialEndorsement), {})
    });
$6b5236b6b57b7b0a$var$SocialEndorsementSection.displayName = 'SocialEndorsementSection';
var $6b5236b6b57b7b0a$export$2e2bcd8739ae039 = $6b5236b6b57b7b0a$var$SocialEndorsementSection;

});
parcelRegister("esXU7", function(module, exports) {
$parcel$export(module.exports, "SocialEndorsement", function () { return $8df6c0f40bfd1ce3$export$782656e60c9cecfd; });
/* social-endorsement.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $1rGpC = parcelRequire("1rGpC");
const $8df6c0f40bfd1ce3$var$logosContainerStyle = null;
const $8df6c0f40bfd1ce3$var$logoStyle = null;
const $8df6c0f40bfd1ce3$export$782656e60c9cecfd = ()=>{
    const logos = [
        {
            src: 'https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/canva.svg',
            alt: 'Canva',
            width: 95
        },
        {
            src: 'https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/nasa.svg',
            alt: 'NASA',
            width: 60
        },
        {
            src: 'https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/illumina.svg',
            alt: 'Illumina',
            width: 103
        },
        {
            src: 'https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/docker.svg',
            alt: 'Docker',
            width: 108
        },
        {
            src: 'https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/new-york-times.svg',
            alt: 'The New York Times',
            width: 165
        },
        {
            src: 'https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/audi.svg',
            alt: 'Audi',
            width: 68
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_6a6z1h6o _4cvr1h6o _1pfhckbl _6rthzwfg _195g1wug _1bsb1osq _10jx1fa8 _msupitcz _181n1txw _zkhy1g80 _e8gh1h6o _1to91tcg _99s6ckbl _14b51osq _j6qucv93 _suga11p5 _131y7vkz _1d4s1tcg _19d7910g _1rkbcv93 _1rfm1osq _1m0a11p5 _6j7rftgi _1dw37vkz _1s8mfsjm"
            ]),
            children: logos.map((logo, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Fragment), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                        src: logo.src,
                        alt: logo.alt,
                        loading: "lazy",
                        width: logo.width,
                        className: (0, $2jatx.default)([
                            "_lcxvglyw _kdamllbs _16bullbs _95u51cm0 _14dm2k2r"
                        ])
                    })
                }, index))
        })
    });
};

});


parcelRegister("bFVFT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b19cbfc74e1ab266$export$2e2bcd8739ae039; });
/* templates-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $9s3Hk = parcelRequire("9s3Hk");

var $90TSV = parcelRequire("90TSV");

var $ilkqI = parcelRequire("ilkqI");

var $iyOcM = parcelRequire("iyOcM");

var $keCPI = parcelRequire("keCPI");

var $iPPTB = parcelRequire("iPPTB");

var $jQ0cd = parcelRequire("jQ0cd");

var $1rGpC = parcelRequire("1rGpC");

var $hzLa4 = parcelRequire("hzLa4");

var $je135 = parcelRequire("je135");

var $59uc6 = parcelRequire("59uc6");
const $b19cbfc74e1ab266$var$tabsWrapper = null;
const $b19cbfc74e1ab266$var$headingStyle = null;
const $b19cbfc74e1ab266$var$linkStyle = null;
// Prevent height jump when image is loading
const $b19cbfc74e1ab266$var$contentHeight = null;
function $b19cbfc74e1ab266$var$item(intl, title, description, imgSrc, templateLinkPrefix, templateSlug, lazyLoad = true) {
    const titleText = intl.formatMessage(title);
    const headingId = `${templateSlug}-heading`;
    const linkId = `${templateSlug}-link`;
    return {
        title: titleText,
        description: intl.formatMessage(description),
        expandAriaLabel: intl.formatMessage((0, $59uc6.templatesSectionMessages).expandAriaLabel, {
            title: titleText
        }),
        content: // eslint-disable-next-line no-restricted-syntax
        /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
            alt: "",
            loading: lazyLoad ? 'lazy' : undefined,
            src: imgSrc,
            width: "100%"
        }),
        link: // eslint-disable-next-line @atlassian/a11y/anchor-has-content, @atlassian/a11y/link-name
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
            text: intl.formatMessage((0, $59uc6.templatesSectionMessages).tryItOut),
            href: templateLinkPrefix + '/' + templateSlug,
            dataEventProps: {
                'data-product-key': 'confluence',
                'data-event': 'clicked',
                'data-event-component': 'linkButton',
                'data-event-container': 'templatesSection',
                'data-label': templateSlug,
                'data-label-english': 'Try it out',
                'data-track-event': 'confluence-pt.templates.try-it-out'
            },
            id: linkId,
            ariaLabelledby: `${headingId} ${linkId}`
        }),
        dataEventProps: {
            'data-product-key': 'confluence',
            'data-event': 'clicked',
            'data-event-component': 'carouselItem',
            'data-event-container': 'templatesSection',
            'data-label': templateSlug,
            'data-label-english': typeof title.defaultMessage === 'string' ? title.defaultMessage : undefined,
            'data-track-event': 'confluence-pt.templates.list-item'
        },
        headingId: headingId
    };
}
const $b19cbfc74e1ab266$var$TabContent = ({ category: category })=>{
    const { goToNextTab: goToNextTab, userSelected: userSelected } = (0, $iyOcM.useAdg4TabsContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hzLa4.ListContentCycle), {
        items: category.items,
        listHeading: category.categoryTitle,
        onCycleEnd: ()=>{
            if (!userSelected) goToNextTab();
        }
    });
};
const $b19cbfc74e1ab266$var$TemplatesSection = ()=>{
    const intl = (0, $8e22h.default)();
    const templatesLink = (0, $jQ0cd.useLocalizedHref)('/software/confluence/templates');
    const templateCategories = [
        {
            tabName: intl.formatMessage((0, $59uc6.templatesSectionMarketingMessages).tabName),
            categoryTitle: intl.formatMessage((0, $59uc6.templatesSectionMarketingMessages).contentHeading),
            eventProps: {
                label: 'marketing-and-sales',
                labelEnglish: 'Marketing'
            },
            items: [
                $b19cbfc74e1ab266$var$item(intl, (0, $59uc6.templatesSectionMarketingMessages).template1Heading, (0, $59uc6.templatesSectionMarketingMessages).template1Description, 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/marketing-template-01-plan.webp', templatesLink, 'marketing-plan'),
                $b19cbfc74e1ab266$var$item(intl, (0, $59uc6.templatesSectionMarketingMessages).template2Heading, (0, $59uc6.templatesSectionMarketingMessages).template2Description, 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/marketing-template-02-competitive-analysis.webp', templatesLink, 'competitive-analysis'),
                $b19cbfc74e1ab266$var$item(intl, (0, $59uc6.templatesSectionMarketingMessages).template3Heading, (0, $59uc6.templatesSectionMarketingMessages).template3Description, 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/marketing-template-03-campaign.webp', templatesLink, 'marketing-campaign')
            ]
        },
        {
            tabName: intl.formatMessage((0, $59uc6.templatesSectionProjectPlanningMessages).tabName),
            categoryTitle: intl.formatMessage((0, $59uc6.templatesSectionProjectPlanningMessages).contentHeading),
            eventProps: {
                label: 'project-planning',
                labelEnglish: 'Project Planning'
            },
            items: [
                $b19cbfc74e1ab266$var$item(intl, (0, $59uc6.templatesSectionProjectPlanningMessages).template1Heading, (0, $59uc6.templatesSectionProjectPlanningMessages).template1Description, 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/project-planning-template-01-brainstorm.webp', templatesLink, 'brainstorming'),
                $b19cbfc74e1ab266$var$item(intl, (0, $59uc6.templatesSectionProjectPlanningMessages).template2Heading, (0, $59uc6.templatesSectionProjectPlanningMessages).template2Description, 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/project-planning-template-02-plan.webp', templatesLink, 'project-plan'),
                $b19cbfc74e1ab266$var$item(intl, (0, $59uc6.templatesSectionProjectPlanningMessages).template3Heading, (0, $59uc6.templatesSectionProjectPlanningMessages).template3Description, 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/project-planning-template-03-roles.webp', templatesLink, 'roles-and-responsibilities')
            ]
        },
        {
            tabName: intl.formatMessage((0, $59uc6.templatesSectionSoftwareMessages).tabName),
            categoryTitle: intl.formatMessage((0, $59uc6.templatesSectionSoftwareMessages).contentHeading),
            eventProps: {
                label: 'software-development',
                labelEnglish: 'Software'
            },
            items: [
                $b19cbfc74e1ab266$var$item(intl, (0, $59uc6.templatesSectionSoftwareMessages).template1Heading, (0, $59uc6.templatesSectionSoftwareMessages).template1Description, 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/software-template-01-sprint-planning.webp', templatesLink, 'sprint-planning-meeting'),
                $b19cbfc74e1ab266$var$item(intl, (0, $59uc6.templatesSectionSoftwareMessages).template2Heading, (0, $59uc6.templatesSectionSoftwareMessages).template2Description, 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/software-template-02-experiment-plan.webp', templatesLink, 'experiment-plan-and-results'),
                $b19cbfc74e1ab266$var$item(intl, (0, $59uc6.templatesSectionSoftwareMessages).template3Heading, (0, $59uc6.templatesSectionSoftwareMessages).template3Description, 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/software-template-03-devops-runbook.webp', templatesLink, 'devops-runbook')
            ]
        },
        {
            tabName: intl.formatMessage((0, $59uc6.templatesSectionProductManagementMessages).tabName),
            categoryTitle: intl.formatMessage((0, $59uc6.templatesSectionProductManagementMessages).contentHeading),
            eventProps: {
                label: 'product-management',
                labelEnglish: 'Product Management'
            },
            items: [
                $b19cbfc74e1ab266$var$item(intl, (0, $59uc6.templatesSectionProductManagementMessages).template1Heading, (0, $59uc6.templatesSectionProductManagementMessages).template1Description, 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/product-template-01-requirements.webp', templatesLink, 'product-requirements'),
                $b19cbfc74e1ab266$var$item(intl, (0, $59uc6.templatesSectionProductManagementMessages).template2Heading, (0, $59uc6.templatesSectionProductManagementMessages).template2Description, 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/product-template-02-roadmap.webp', templatesLink, 'product-roadmap'),
                $b19cbfc74e1ab266$var$item(intl, (0, $59uc6.templatesSectionProductManagementMessages).template3Heading, (0, $59uc6.templatesSectionProductManagementMessages).template3Description, 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/product-template-03-launch.webp', templatesLink, 'product-launch')
            ]
        },
        {
            tabName: intl.formatMessage((0, $59uc6.templatesSectionBusinessStrategyMessages).tabName),
            categoryTitle: intl.formatMessage((0, $59uc6.templatesSectionBusinessStrategyMessages).contentHeading),
            eventProps: {
                label: 'business-strategy',
                labelEnglish: 'Business Strategy'
            },
            items: [
                $b19cbfc74e1ab266$var$item(intl, (0, $59uc6.templatesSectionBusinessStrategyMessages).template1Heading, (0, $59uc6.templatesSectionBusinessStrategyMessages).template1Description, 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/bus-strategy-template-01-vision.webp', templatesLink, 'vision-to-values'),
                $b19cbfc74e1ab266$var$item(intl, (0, $59uc6.templatesSectionBusinessStrategyMessages).template2Heading, (0, $59uc6.templatesSectionBusinessStrategyMessages).template2Description, 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/bus-strategy-template-02-strategic-plan.webp', templatesLink, 'strategic-plan'),
                $b19cbfc74e1ab266$var$item(intl, (0, $59uc6.templatesSectionBusinessStrategyMessages).template3Heading, (0, $59uc6.templatesSectionBusinessStrategyMessages).template3Description, 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/bus-strategy-template-03-updates.webp', templatesLink, 'business-status-update')
            ]
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-templatesSection",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm _1pbykb7n _1xgm1crf _vnhn1ylp _x3vx7vkz _zfbj1f4h"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        className: (0, $2jatx.default)([
                            "_y3gn1h6o _6rthidpf"
                        ]),
                        children: intl.formatMessage((0, $59uc6.templatesSectionMessages).heading)
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $iyOcM.Adg4Tabs), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $90TSV.Adg4DraggableTabList), {
                            className: "tab-list",
                            children: templateCategories.map((category, index)=>{
                                return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9s3Hk.Adg4DraggableTab), {
                                    className: "round-tab",
                                    dataEventProps: {
                                        'data-product-key': 'confluence',
                                        'data-event': 'clicked',
                                        'data-event-component': 'tab',
                                        'data-event-container': 'templatesSection',
                                        'data-label': category.eventProps.label,
                                        'data-label-english': category.eventProps.labelEnglish,
                                        'data-track-event': 'confluence-pt.templates.tab'
                                    },
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $keCPI.RoundTab), {
                                        title: category.tabName
                                    })
                                }, index);
                            })
                        }),
                        templateCategories.map((category, index)=>{
                            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ilkqI.Adg4TabPanel), {
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_19451pl1"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($b19cbfc74e1ab266$var$TabContent, {
                                        category: category
                                    })
                                })
                            }, index);
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1k9pzwfg _1tntvbgk"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                            text: intl.formatMessage((0, $59uc6.templatesSectionMessages).seeAllTemplates),
                            href: templatesLink,
                            dataEventProps: {
                                'data-product-key': 'confluence',
                                'data-event': 'clicked',
                                'data-event-component': 'linkButton',
                                'data-event-container': 'templatesSection',
                                'data-label': 'see-all-templates',
                                'data-label-english': 'See all templates',
                                'data-track-event': 'confluence-pt.templates.see-all-templates'
                            }
                        })
                    })
                })
            ]
        })
    });
};
var $b19cbfc74e1ab266$export$2e2bcd8739ae039 = (0, $je135.withScrollTracking)('TemplatesSection', $b19cbfc74e1ab266$var$TemplatesSection, {
    observerOptions: {
        threshold: 0.1
    }
});

});
parcelRegister("keCPI", function(module, exports) {
$parcel$export(module.exports, "RoundTab", function () { return $2c8e0b9e6af3661f$export$e748343268edd19c; });
/* round-tab.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $2c8e0b9e6af3661f$var$tabStyle = null;
const $2c8e0b9e6af3661f$var$selectedTabStyle = null;
const $2c8e0b9e6af3661f$export$e748343268edd19c = ({ isSelected: isSelected, title: title })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_bfhkdkka _4cvr1h6o _1bah1h6o _vchhusvi _1e0c1txw _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _4t3i8vuz _2rko1f4h _y4tigktf _bozggktf _80omtlke _19itn6xs _k48pbfng _1wyb1k92 _ect41vau _bfw71tdf _irr31bjw",
            isSelected && "_19it1tdf _syazvb1l"
        ]),
        style: {
            "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200')),
            "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display')),
            "--_lwvw50": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue100'))
        },
        children: title
    });
};

});

parcelRegister("hzLa4", function(module, exports) {
$parcel$export(module.exports, "ListContentCycle", function () { return $57669ce4acf66392$export$d6db5cefb2f41a42; });
/* list-content-cycle.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $kbpa7 = parcelRequire("kbpa7");

var $1rGpC = parcelRequire("1rGpC");
const $57669ce4acf66392$var$wrapperStyle = null;
const $57669ce4acf66392$var$contentWrapper = null;
const $57669ce4acf66392$var$textItemStyles = null;
const $57669ce4acf66392$var$graphicStyles = null;
const $57669ce4acf66392$var$itemContainer = null;
const $57669ce4acf66392$var$itemStyles = null;
const $57669ce4acf66392$var$buttonStyle = null;
const $57669ce4acf66392$var$headingStyle = null;
const $57669ce4acf66392$var$noMarginStyle = null;
const $57669ce4acf66392$var$textLinkStyle = null;
const $57669ce4acf66392$var$visibleTextLink = null;
const $57669ce4acf66392$var$progressBar = null;
const $57669ce4acf66392$var$barFillStyle = null;
const $57669ce4acf66392$var$fullBarStyle = null;
const $57669ce4acf66392$var$mobileContentStyles = null;
const $57669ce4acf66392$var$contentStyles = null;
const $57669ce4acf66392$var$activeContentMedia = null;
const $57669ce4acf66392$var$activeContentStyle = null;
const $57669ce4acf66392$export$d6db5cefb2f41a42 = ({ items: items, heading: heading, listHeading: listHeading, duration: duration = 5000, onCycleEnd: onCycleEnd })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)();
    const [activeItem, setActiveItem] = (0, $1oC0p.useState)(0);
    const [userSelected, setUserSelected] = (0, $1oC0p.useState)(false);
    const animation = null;
    const changeActive = (index, setSelected = false)=>{
        if (onCycleEnd && index >= items.length) onCycleEnd();
        if (setSelected) setUserSelected(true);
        setActiveItem(index >= items.length ? 0 : index);
    };
    // resume loop after comes back into view
    (0, $1oC0p.useEffect)(()=>{
        if (sectionIsVisible) setUserSelected(false);
    }, [
        sectionIsVisible
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            ref: scrollRef,
            className: (0, $2jatx.default)([]),
            children: [
                heading && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_85i51tcg"
                    ]),
                    children: heading
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx2vrvc _zulpys9h"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _2lx21bp4 _zulpzwfg _16jlidpf _1o9zidpf _i0dl1osq _10m4idpf _1vdkidpf _1wzn19wn"
                            ]),
                            children: [
                                listHeading && /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                    className: (0, $2jatx.default)([
                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                    ]),
                                    children: listHeading
                                }),
                                items.map((item, index)=>{
                                    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_kqswh2mm"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_kqswh2mm _1e0c1txw _2lx21bp4 _y3gnv2br _bozg1tcg"
                                                ]),
                                                children: [
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                        className: (0, $2jatx.default)([
                                                            "_kqswstnw _152tidpf _u7coidpf _1e02idpf _1bsb1l7b _bfhk1kby"
                                                        ]),
                                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                            onAnimationEnd: ()=>{
                                                                if (userSelected) return;
                                                                changeActive(index + 1);
                                                            },
                                                            className: (0, $2jatx.default)([
                                                                "_11q75hrz _4t3iidpf",
                                                                sectionIsVisible && !userSelected && activeItem === index && "_y44v1she",
                                                                userSelected && activeItem === index && "_4t3i1osq"
                                                            ]),
                                                            style: {
                                                                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                                                                "--_1bg9z7q": (0, $6ZVlx.default)(duration, "ms")
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                                        "aria-label": item.expandAriaLabel,
                                                        "aria-expanded": activeItem === index,
                                                        onClick: ()=>{
                                                            changeActive(index, true);
                                                        },
                                                        ...item.dataEventProps,
                                                        className: (0, $2jatx.default)([
                                                            "_y3gn1e5h _11q7glyw _r06hglyw _1r04idpf _80omtlke _19itidpf _18zridpf _1rjcidpf"
                                                        ]),
                                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                                                            id: item.headingId,
                                                            className: (0, $2jatx.default)([
                                                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                                            ]),
                                                            children: item.title
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                        className: (0, $2jatx.default)([
                                                            "_1e0c1txw _2lx21bp4 _zulpftgi _v5641tqq _c71lidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1reo15vq _18m915vq",
                                                            activeItem === index && "_c71lmgvx _1rjc1y44"
                                                        ]),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                                className: (0, $2jatx.default)([
                                                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                                                ]),
                                                                children: item.description
                                                            }),
                                                            item.link
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_v564ayzn _1e0cglyw _1reo15vq _18m915vq _tzy4idpf _1rjc7vkz",
                                                    activeItem === index && "_tzy4kb7n _1mjb1ule"
                                                ]),
                                                children: item.content
                                            })
                                        ]
                                    }, index);
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_16jlkb7n _1o9zkb7n _i0dlf1ug"
                            ]),
                            children: items.map((item, index)=>{
                                return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_v564ayzn _1lww1yx9 _4t3iidpf _tzy4idpf _1reo15vq _18m915vq _1mjbglyw",
                                        activeItem === index && "_4t3i1wug _tzy4kb7n _dm251ule"
                                    ]),
                                    children: item.content
                                }, index);
                            })
                        })
                    ]
                })
            ]
        })
    });
};

});

parcelRegister("59uc6", function(module, exports) {
$parcel$export(module.exports, "templatesSectionMessages", function () { return $9d33a1f63a3db544$export$918efc24479364d; });
$parcel$export(module.exports, "templatesSectionMarketingMessages", function () { return $9d33a1f63a3db544$export$217732740ce81bfa; });
$parcel$export(module.exports, "templatesSectionProjectPlanningMessages", function () { return $9d33a1f63a3db544$export$6b54437a0a39225d; });
$parcel$export(module.exports, "templatesSectionSoftwareMessages", function () { return $9d33a1f63a3db544$export$4c78b2adf33c9c13; });
$parcel$export(module.exports, "templatesSectionProductManagementMessages", function () { return $9d33a1f63a3db544$export$b3ac84acded839df; });
$parcel$export(module.exports, "templatesSectionBusinessStrategyMessages", function () { return $9d33a1f63a3db544$export$d594459a0e83d76e; });

var $fnHPc = parcelRequire("fnHPc");
const $9d33a1f63a3db544$export$918efc24479364d = (0, $fnHPc.defineMessages)({
    heading: {
        id: 'ConfluenceSoftwarePage.v4.TemplatesSection.heading',
        defaultMessage: 'Confluence is for every team'
    },
    seeAllTemplates: {
        id: 'ConfluenceSoftwarePage.v4.TemplatesSection.seeAllTemplates',
        defaultMessage: 'See all templates'
    },
    tryItOut: {
        id: 'ConfluenceSoftwarePage.v4.TemplatesSection.tryItOut',
        defaultMessage: 'Try it out'
    },
    expandAriaLabel: {
        id: 'ConfluenceSoftwarePage.v4.TemplatesSection.expandAriaLabel',
        defaultMessage: 'Expand {title}'
    },
    imgAlt: {
        id: 'ConfluenceSoftwarePage.v4.TemplatesSection.imgAlt',
        defaultMessage: 'Image of {title} template'
    }
});
const $9d33a1f63a3db544$export$217732740ce81bfa = (0, $fnHPc.defineMessages)({
    tabName: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Marketing.tabName',
        defaultMessage: 'Marketing'
    },
    contentHeading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Marketing.heading',
        defaultMessage: 'Templates for marketing teams'
    },
    template1Heading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Marketing.template1.heading',
        defaultMessage: 'Marketing plan'
    },
    template1Description: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Marketing.template1.description',
        defaultMessage: 'Nail your GTM strategy and plan marketing programs with your team'
    },
    template2Heading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Marketing.template2.heading',
        defaultMessage: 'Competitive analysis'
    },
    template2Description: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Marketing.template2.description',
        defaultMessage: 'Collaboratively document competitor offerings & strategies'
    },
    template3Heading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Marketing.template3.heading',
        defaultMessage: 'Marketing campaign'
    },
    template3Description: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Marketing.template3.description',
        defaultMessage: 'Build a solid campaign blueprint to drive impact'
    }
});
const $9d33a1f63a3db544$export$6b54437a0a39225d = (0, $fnHPc.defineMessages)({
    tabName: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProjectPlanning.tabName',
        defaultMessage: 'Project Planning'
    },
    contentHeading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProjectPlanning.heading',
        defaultMessage: 'Templates for project planning'
    },
    template1Heading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProjectPlanning.template1.heading',
        defaultMessage: 'Brainstorm'
    },
    template1Description: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProjectPlanning.template1.description',
        defaultMessage: 'Lead a productive brainstorming session and ideate on the most impactful work'
    },
    template2Heading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProjectPlanning.template2.heading',
        defaultMessage: 'Project plan'
    },
    template2Description: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProjectPlanning.template2.description',
        defaultMessage: 'Map out your project logistics and move your team across the finish line, every time.'
    },
    template3Heading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProjectPlanning.template3.heading',
        defaultMessage: 'Roles & responsibilities'
    },
    template3Description: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProjectPlanning.template3.description',
        defaultMessage: 'Clarify individual roles and responsibilities to build a strong project team'
    }
});
const $9d33a1f63a3db544$export$4c78b2adf33c9c13 = (0, $fnHPc.defineMessages)({
    tabName: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Software.tabName',
        defaultMessage: 'Software'
    },
    contentHeading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Software.heading',
        defaultMessage: 'Templates for software teams'
    },
    template1Heading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Software.template1.heading',
        defaultMessage: 'Sprint planning'
    },
    template1Description: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Software.template1.description',
        defaultMessage: 'Set goals, plan team capacity, and effectively kick off every sprint'
    },
    template2Heading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Software.template2.heading',
        defaultMessage: 'Experiment plan'
    },
    template2Description: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Software.template2.description',
        defaultMessage: 'Streamline your experiment process to more effectively test and learn'
    },
    template3Heading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Software.template3.heading',
        defaultMessage: 'DevOps runbook'
    },
    template3Description: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.Software.template3.description',
        defaultMessage: 'Help your operations team respond to system alerts and outages'
    }
});
const $9d33a1f63a3db544$export$b3ac84acded839df = (0, $fnHPc.defineMessages)({
    tabName: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProductManagement.tabName',
        defaultMessage: 'Product Management'
    },
    contentHeading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProductManagement.heading',
        defaultMessage: 'Templates for product management'
    },
    template1Heading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProductManagement.template1.heading',
        defaultMessage: 'Product requirements'
    },
    template1Description: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProductManagement.template1.description',
        defaultMessage: 'Outline your pre-launch prep and track your post-launch progress'
    },
    template2Heading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProductManagement.template2.heading',
        defaultMessage: 'Product roadmap'
    },
    template2Description: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProductManagement.template2.description',
        defaultMessage: 'Transform your product features from ideas to reality'
    },
    template3Heading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProductManagement.template3.heading',
        defaultMessage: 'Product launch'
    },
    template3Description: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProductManagement.template3.description',
        defaultMessage: 'Your ultimate liftoff planning doc'
    }
});
const $9d33a1f63a3db544$export$d594459a0e83d76e = (0, $fnHPc.defineMessages)({
    tabName: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.BusinessStrategy.tabName',
        defaultMessage: 'Business Strategy'
    },
    contentHeading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.BusinessStrategy.heading',
        defaultMessage: 'Templates for business strategy'
    },
    template1Heading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.BusinessStrategy.template1.heading',
        defaultMessage: 'Vision to values'
    },
    template1Description: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.BusinessStrategy.template1.description',
        defaultMessage: 'Align business strategies with company mission'
    },
    template2Heading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.BusinessStrategy.template2.heading',
        defaultMessage: 'Strategic plan'
    },
    template2Description: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.BusinessStrategy.template2.description',
        defaultMessage: 'Turn your business vision into actionable next steps'
    },
    template3Heading: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.BusinessStrategy.template3.heading',
        defaultMessage: 'Business status updates'
    },
    template3Description: {
        id: 'ConfluenceSoftwarePage.v4.ContentTypes.BusinessStrategy.template3.description',
        defaultMessage: 'Share performance results and customer insights across the team'
    }
});

});


parcelRegister("iuSIG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cb9283c42d2a5c48$export$2e2bcd8739ae039; });
/* testimonial-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $lmQGF = parcelRequire("lmQGF");

var $jQ0cd = parcelRequire("jQ0cd");

var $h8tN9 = parcelRequire("h8tN9");

var $dweoU = parcelRequire("dweoU");
const $cb9283c42d2a5c48$var$logoSizeStyles = null;
const $cb9283c42d2a5c48$var$TestimonialsSection = ()=>{
    const intl = (0, $8e22h.default)();
    const testimonials = [
        {
            name: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.v4.testimonials.testimonialDropbox.name',
                defaultMessage: 'Damien Davis'
            }),
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dweoU.TestimonialDropbox), {}),
            title: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.v4.testimonials.testimonialDropbox.title',
                defaultMessage: 'Lead Atlassian Administrator, Dropbox'
            }),
            image: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/testimonial-dropbox.webp',
            quote: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.v4.testimonials.testimonialDropbox.quote',
                defaultMessage: 'Confluence out of the box is a fantastic product, and integrations take it to another level. We can embed videos, media, and all sorts of files and make them accessible across the enterprise.'
            }),
            label: 'Dropbox'
        },
        {
            name: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.v4.testimonials.testimonialRoblox.name',
                defaultMessage: 'Joe Cotant'
            }),
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dweoU.TestimonialRoblox), {}),
            title: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.v4.testimonials.testimonialRoblox.title',
                defaultMessage: 'Senior Technical Program Manager, Roblox'
            }),
            image: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/testimonial-roblox.webp',
            quote: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.v4.testimonials.testimonialRoblox.quote',
                defaultMessage: 'Using smart links within Confluence and Jira makes cross-team collaboration much easier. These integrations have been pivotal in collaboration, productivity, and discoverability.'
            }),
            label: 'Roblox'
        },
        {
            name: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.v4.testimonials.testimonialLumen.name',
                defaultMessage: 'Rob Mulvaney'
            }),
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dweoU.TestimonialLumen), {}),
            title: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.v4.testimonials.testimonialLumen.title',
                defaultMessage: 'Director, Agile Transformation Office, Lumen Technologies'
            }),
            image: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/testimonial-lumen.webp',
            quote: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.v4.testimonials.testimonialLumen.quote',
                defaultMessage: 'Employees across the company use Confluence to document important information like objectives and key results, which helps keep teams aligned across the big-picture goals.'
            }),
            label: 'Lumen'
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-testimonialsSection",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1q51ckbl _1av31jry _125xu67f _1com1osq _1bdu18r2 _1c8yor1b"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $h8tN9.ADG4CustomerTestimonials), {
                testimonials: testimonials,
                imagePosition: "right",
                testimonialCta: /*#__PURE__*/ (0, $7VQPk.jsx)($cb9283c42d2a5c48$var$TestimonialCta, {})
            })
        })
    });
};
$cb9283c42d2a5c48$var$TestimonialsSection.displayName = 'TestimonialsSection';
const $cb9283c42d2a5c48$var$ctaContainerStyles = null;
const $cb9283c42d2a5c48$var$TestimonialCta = ()=>{
    const intl = (0, $8e22h.default)();
    const customersLink = (0, $jQ0cd.useLocalizedHref)('/customers');
    const linkText = intl.formatMessage({
        id: 'ConfluenceSoftwarePage.v4.testimonials.ctaButton.text',
        defaultMessage: 'Explore customer stories'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _mqm25xei _16jlkb7n _4t3i1osq _y4tifatv _1e0c1txw _1bahesu3 _152tt94y _kqswh2mm _xlmcidpf _wnjd1h6o _wm3b189y _4bscidpf _1uwridpf _7sgdidpf _1b3nidpf"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
            href: customersLink,
            variant: "secondary",
            color: "white",
            dataEventProps: {
                'data-product-key': 'confluence',
                'data-event': 'clicked',
                'data-event-component': 'linkButton',
                'data-event-container': 'testimonialsSection',
                'data-label': 'testimonials-cta',
                'data-label-english': 'Explore customer stories',
                'data-track-event': 'confluence-pt.testimonials.cta'
            },
            children: linkText
        })
    });
};
var $cb9283c42d2a5c48$export$2e2bcd8739ae039 = $cb9283c42d2a5c48$var$TestimonialsSection;

});
parcelRegister("h8tN9", function(module, exports) {
$parcel$export(module.exports, "ADG4CustomerTestimonials", function () { return $46cab561f3e1a3ae$export$d0511cb0623812b3; });
/* customer-testimonials.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $9s3Hk = parcelRequire("9s3Hk");

var $90TSV = parcelRequire("90TSV");

var $ilkqI = parcelRequire("ilkqI");

var $iyOcM = parcelRequire("iyOcM");

var $hnmMQ = parcelRequire("hnmMQ");

var $iPPTB = parcelRequire("iPPTB");

var $1rGpC = parcelRequire("1rGpC");

var $jsxHL = parcelRequire("jsxHL");
// @ts-expect-error unused
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $46cab561f3e1a3ae$var$AUTO_TRANSITION_INTERVAL = 8000;
/* eslint-disable local/ensure-wac-token-usage */ // Not able to use wacToken function with cssMap. Need to refactor this in the future to use dynamic functions
const $46cab561f3e1a3ae$var$backgroundColorStyleMap = {
    blue: "_bfhkdoyu",
    black: "_bfhkr3uz",
    white: "_bfhku67f"
};
const $46cab561f3e1a3ae$var$backgroundShapeStyleMap = {
    'image-left': "_mkrz75ra _1vthq8qa",
    'image-right': "_mkrz1ofp _1vth1ofp"
};
const $46cab561f3e1a3ae$var$customerImagesSectionStyleMap = {
    'image-left': "_1461n7od",
    'image-right': "_uhi5cs5v"
};
const $46cab561f3e1a3ae$var$customerQuotesSectionStyleMap = {
    'image-left': "_1461n7od",
    'image-right': "_uhi5kb7n _1fltkb7n"
};
const $46cab561f3e1a3ae$var$fontColorStyleMap = {
    'dark-bg': "_syaz12cp",
    'white-bg': "_syazn7od"
};
const $46cab561f3e1a3ae$var$topLineStyleMap = {
    blue: "_bfhk1nof",
    black: "_bfhku67f",
    white: "_bfhkr3uz"
};
const $46cab561f3e1a3ae$var$logoOptionStyleMap = {
    'dark-bg': "_d4ksu67f _i862u67f",
    'white-bg': "_d4ksr3uz _i862r3uz"
};
const $46cab561f3e1a3ae$export$d0511cb0623812b3 = ({ bgColor: bgColor = 'blue', heading: heading, subheading: subheading, cta: cta, testimonials: testimonials, productKey: productKey, className: className, imagePosition: imagePosition = 'left', testimonialCta: testimonialCta })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)();
    const logosContainerStyles = null;
    const bgTheme = bgColor === 'blue' || bgColor === 'black' ? 'dark-bg' : 'white-bg';
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iyOcM.Adg4Tabs), {
        loop: true,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
                ref: scrollRef,
                className: sectionIsVisible ? 'is-visible' : '',
                children: [
                    !heading && !subheading && !cta ? null : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                        layout: "8",
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_y3gn1h6o _6rth1ylp"
                            ]),
                            children: [
                                heading && /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                    className: (0, $2jatx.default)([
                                        "_1mouqlbw",
                                        ""
                                    ]),
                                    children: heading
                                }),
                                subheading && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    className: (0, $2jatx.default)([
                                        "_1mou1kvp",
                                        "body-lg"
                                    ]),
                                    children: subheading
                                }),
                                cta && // eslint-disable-next-line @atlassian/a11y/anchor-has-content, @atlassian/a11y/link-name
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                    text: cta.text,
                                    href: cta.url,
                                    dataEventProps: cta.dataEventProps,
                                    type: 'primary'
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        ref: scrollRef,
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _1pbykb7n _6rth1jfw",
                            $46cab561f3e1a3ae$var$fontColorStyleMap[bgTheme],
                            `${className} ${sectionIsVisible ? 'is-visible' : ''} image-${imagePosition} ${bgColor}-background`
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_kqswstnw _1r04idpf _1bsb1lk2 _p12fklux _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1rfm1osq",
                                            $46cab561f3e1a3ae$var$backgroundColorStyleMap[bgColor],
                                            $46cab561f3e1a3ae$var$backgroundShapeStyleMap[`image-${imagePosition}`],
                                            "bgshape"
                                        ])
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c11p5 _yv0ehkll _2z05hkll _1ir7idpf _bhknkb7n _1rrs1txw _s9hn1ekt _16l7kb7n _w53ccs5v"
                                        ]),
                                        children: testimonials.map((testimonial, index)=>{
                                            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ilkqI.Adg4TabPanel), {
                                                id: `${index}`,
                                                panelIndex: index,
                                                forceRender: true,
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)($46cab561f3e1a3ae$var$TopRowContent, {
                                                    testimonial: testimonial,
                                                    imagePosition: imagePosition,
                                                    index: index,
                                                    bgTheme: bgTheme,
                                                    bgColor: bgColor
                                                })
                                            }, index);
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_kqswh2mm _1e0c1txw _1p57v47k _1n261g80 _4cvr1fhb _1gde1bp4 _xsmr1h6o",
                                            "row-width"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                            className: (0, $2jatx.default)([
                                                "_1reo15vq _18m915vq _1bsb1osq _1bah1yb4 _1v611bp4 _476dgktf",
                                                "_1e0c31e1 _1jz91vn9",
                                                "logos-container"
                                            ]),
                                            style: {
                                                "--_1kyqkej": (0, $6ZVlx.default)(testimonialCta ? 'flex' : 'block'),
                                                "--_1chs0f7": (0, $6ZVlx.default)(testimonialCta ? '0' : 'auto')
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $90TSV.Adg4DraggableTabList), {
                                                    className: (0, $2jatx.default)([
                                                        "_6rth1fu0 _1q511aa3 _qtt8agmp",
                                                        "logos"
                                                    ]),
                                                    rowGap: "32px",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                            className: (0, $2jatx.default)([
                                                                "_kqswstnw _152tt94y _1e02idpf _rjxpidpf _4t3it94y _2rkoyh40 _tzy4105o _xaej183y",
                                                                $46cab561f3e1a3ae$var$topLineStyleMap[bgColor],
                                                                "top-line"
                                                            ])
                                                        }),
                                                        testimonials.map((testimonial, index)=>{
                                                            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9s3Hk.Adg4DraggableTab), {
                                                                as: "button",
                                                                className: (0, $2jatx.default)([
                                                                    $46cab561f3e1a3ae$var$logoOptionStyleMap[bgTheme],
                                                                    "_1e0c1txw _1bah1fhb _4cvr1fhb _kqswh2mm _1atpidpf",
                                                                    "logo-option"
                                                                ]),
                                                                tabIndex: index,
                                                                dataEventProps: {
                                                                    'data-product-key': productKey,
                                                                    'data-event-component': 'tab',
                                                                    'data-event-container': 'testimonialsSection',
                                                                    'data-event': 'clicked',
                                                                    'data-label-english': testimonial.label
                                                                },
                                                                label: testimonial.label,
                                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)($46cab561f3e1a3ae$var$LogoTabContent, {
                                                                    testimonialLogo: testimonial.logo
                                                                })
                                                            }, index);
                                                        })
                                                    ]
                                                }),
                                                testimonialCta && testimonialCta
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
};
const $46cab561f3e1a3ae$var$TopRowContent = ({ testimonial: testimonial, imagePosition: imagePosition, index: index, bgTheme: bgTheme, bgColor: bgColor, isPanelActive: isPanelActive })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _1e0c1txw _1p57v47k _1n261g80 _4cvr1fhb _1gde1bp4 _xsmr1h6o",
            "_6rth1ylp _1e0c11p5 _yv0ewxkt _gy1pzwfg _tzy4idpf _1pbykb7n _1ph4hkll",
            isPanelActive && "_tzy4kb7n _1pbycs5v",
            "row-width top-row"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _i0dlhwvj _1e0c1txw _1bah1h6o _4cvresu3 _16xt1ssb _1rfm1vuk _q5ugidpf _7tld1wug _14adidpf _4uro1wug _7bcc1n8h _18jmidpf _qji61wug _ms0lidpf _v5we1wug",
                    $46cab561f3e1a3ae$var$customerImagesSectionStyleMap[`image-${imagePosition}`],
                    "customer-images-section"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_bna7ng7t _1jtm1c95 _1fhe1c95 _1cwsdlvw _mezj1wug _v4pn1ule",
                        isPanelActive && "_m3691nt4"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                        image: {
                            src: testimonial.image,
                            alt: testimonial.title
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_i0dl1nrf _1reo15vq _18m915vq _1a8l1ssb",
                    $46cab561f3e1a3ae$var$customerQuotesSectionStyleMap[`image-${imagePosition}`],
                    "customer-quotes-section"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _4t3i1osq _1bahh9n0 _2rkogktf _kqswh2mm _19pkidpf _2hwx1wug _otyridpf _18u01wug _26vxys9h _12rr1e9y _1rfm1osq",
                        "testimonial-quotes-section"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_v5641pn7 _1e0c1txw _2lx21bp4 _zulp1tcg",
                            isPanelActive && "_y44v13sw _11vozap6",
                            "quote-container"
                        ]),
                        children: [
                            testimonial.eyebrow && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    $46cab561f3e1a3ae$var$fontColorStyleMap[bgTheme],
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "eyebrow-md"
                                ]),
                                children: testimonial.eyebrow
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("blockquote", {
                                className: (0, $2jatx.default)([
                                    $46cab561f3e1a3ae$var$fontColorStyleMap[bgTheme],
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "callout"
                                ]),
                                children: [
                                    "\u201C",
                                    testimonial.quote,
                                    "\u201D"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            $46cab561f3e1a3ae$var$fontColorStyleMap[bgTheme],
                                            "eyebrow-lg"
                                        ]),
                                        children: testimonial.name
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            $46cab561f3e1a3ae$var$fontColorStyleMap[bgTheme],
                                            "body-md title"
                                        ]),
                                        children: testimonial.title
                                    })
                                ]
                            }),
                            testimonial.link && // eslint-disable-next-line @atlassian/a11y/anchor-has-content, @atlassian/a11y/link-name
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                anchorProps: {
                                    tabIndex: isPanelActive ? 0 : -1
                                },
                                text: testimonial.link.text,
                                href: testimonial.link.url,
                                type: testimonial.link.type ?? 'primary',
                                bgColor: bgColor === 'blue' || bgColor === 'black' ? 'bgBlackBlue' : 'bgWhite',
                                dataEventProps: testimonial.link.dataEventProps
                            })
                        ]
                    }, index)
                })
            })
        ]
    });
};
const $46cab561f3e1a3ae$var$topRowActiveStyle = null;
const $46cab561f3e1a3ae$var$customerImagesImgActiveStyle = null;
const $46cab561f3e1a3ae$var$quoteContainerActiveStyle = null;
const $46cab561f3e1a3ae$var$LogoTabContent = ({ testimonialLogo: testimonialLogo, isSelected: isSelected })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    isSelected && "_tzy4kb7n _kqswstnw _152tj39m _1e02idpf _rjxpidpf _4t3i14y2 _2rkoyh40",
                    "top-marker"
                ])
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_11q7glyw _19itidpf _r06hglyw _1q51gktf _80omtlke _kqswh2mm"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_tzy4105o _v5641bs3 _16l4kb7n",
                        "_4t3i1u1b _1e0c1txw _4cvr1h6o",
                        isSelected && "_tzy4kb7n",
                        "logo-img-container"
                    ]),
                    children: testimonialLogo
                })
            })
        ]
    });
};
// LogoTabContent styles
const $46cab561f3e1a3ae$var$logoImgStyle = null;
const $46cab561f3e1a3ae$var$logoImgSelectedStyle = null;
const $46cab561f3e1a3ae$var$logoButtonStyle = null;
const $46cab561f3e1a3ae$var$topMarkerStyle = null;
const $46cab561f3e1a3ae$var$logoImgContainerStyle = null;
// ADG4CustomerTestimonials styles
const $46cab561f3e1a3ae$var$headerStyles = null;
const $46cab561f3e1a3ae$var$h2Styles = null;
const $46cab561f3e1a3ae$var$pStyles = null;
const $46cab561f3e1a3ae$var$topLineStyles = null;
const $46cab561f3e1a3ae$var$testimonialKeyframeStyles = null;
const $46cab561f3e1a3ae$var$rowWidthStyle = null;
const $46cab561f3e1a3ae$var$topRowStyle = null;
const $46cab561f3e1a3ae$var$bgShapeStyle = null;
const $46cab561f3e1a3ae$var$customerImagesSectionStyles = null;
const $46cab561f3e1a3ae$var$customerImagesSectionImageStyles = null;
const $46cab561f3e1a3ae$var$customerQuotesSectionStyle = null;
const $46cab561f3e1a3ae$var$testimonialQuotesSectionStyle = null;
const $46cab561f3e1a3ae$var$quoteContainerStyle = null;
const $46cab561f3e1a3ae$var$quoteContainerPStyle = null;
const $46cab561f3e1a3ae$var$logosContainerBaseStyle = null;
const $46cab561f3e1a3ae$var$logosStyle = null;
const $46cab561f3e1a3ae$var$logoOptionStyle = null;
const $46cab561f3e1a3ae$var$testimonialStyles = null;
const $46cab561f3e1a3ae$var$tabPanelWrapperStyles = null;

});

parcelRegister("dweoU", function(module, exports) {
$parcel$export(module.exports, "TestimonialDropbox", function () { return $ba4696cf403c7502$export$3944c61ebd3bc79e; });
$parcel$export(module.exports, "TestimonialRoblox", function () { return $ba4696cf403c7502$export$d76e3d65f440a2bb; });
$parcel$export(module.exports, "TestimonialLumen", function () { return $ba4696cf403c7502$export$2d5c2c6aa86b2349; });
/* testimonial-logos.tsx generated by @compiled/babel-plugin v0.28.8 */ /* testimonial logos */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $hnmMQ = parcelRequire("hnmMQ");
const $ba4696cf403c7502$export$c237744daee40794 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "69",
        height: "25",
        viewBox: "0 0 69 25",
        fill: "none",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M56.6992 0.810686C54.0412 0.806395 51.4603 1.7031 49.3776 3.35447C47.295 1.70299 44.714 0.806273 42.056 0.810686C39.3982 0.806573 36.8175 1.70327 34.7348 3.35447C32.6524 1.70291 30.0715 0.806178 27.4136 0.810686C24.7558 0.806573 22.1751 1.70327 20.0924 3.35447C18.0098 1.70321 15.429 0.806512 12.7712 0.810686C6.24899 0.810686 0.963501 6.09579 0.963501 12.6184C0.963501 19.1402 6.2486 24.4261 12.7712 24.4261C15.429 24.4302 18.0097 23.5335 20.0924 21.8823C22.175 23.5336 24.7558 24.4303 27.4136 24.4261C30.0715 24.4305 32.6523 23.5338 34.7348 21.8823C36.8175 23.5335 39.3982 24.4302 42.056 24.4261C44.714 24.4305 47.2949 23.5338 49.3776 21.8823C51.4603 23.5338 54.0412 24.4305 56.6992 24.4261C63.2214 24.4261 68.5065 19.1406 68.5065 12.6184C68.5065 6.09617 63.2214 0.810686 56.6992 0.810686ZM18.1605 19.9534C16.6559 21.051 14.7762 21.7209 12.7712 21.7209C7.73975 21.7209 3.66831 17.6498 3.66831 12.6184C3.66831 7.58693 7.73975 3.5155 12.7712 3.5155C14.7762 3.5155 16.6547 4.18574 18.1605 5.28373C16.5015 7.36796 15.6007 9.95451 15.6063 12.6184C15.6075 15.2812 16.5075 17.8657 18.1605 19.9534ZM20.0928 18.0269C18.9324 16.4627 18.3077 14.5659 18.3115 12.6184C18.3066 10.6707 18.9314 8.77353 20.0928 7.20992C21.2539 8.77365 21.8787 10.6707 21.8741 12.6184C21.8777 14.5659 21.253 16.4627 20.0928 18.0269ZM32.8032 19.9534C31.24 21.1043 29.3486 21.7229 27.4075 21.7182C25.4703 21.7221 23.5832 21.1035 22.0244 19.9534C23.6775 17.866 24.5775 15.2815 24.5785 12.6188C24.5841 9.95489 23.6834 7.36835 22.0244 5.28412C23.583 4.13374 25.4702 3.51491 27.4075 3.51896C29.427 3.51896 31.2929 4.17229 32.8032 5.28412C31.1443 7.36835 30.2435 9.95489 30.2491 12.6188C30.2502 15.2815 31.1502 17.8659 32.8032 19.9534ZM34.7348 18.0269C33.5744 16.4627 32.9497 14.5659 32.9535 12.6184C32.9488 10.6707 33.5736 8.77362 34.7348 7.20992C35.8962 8.77352 36.5212 10.6706 36.5165 12.6184C36.5202 14.566 35.8953 16.4628 34.7348 18.0269ZM47.4457 19.9534C45.9353 21.0656 44.0694 21.7182 42.0503 21.7182C40.0311 21.7182 38.1771 21.0645 36.6668 19.9534C38.32 17.8661 39.22 15.2816 39.2209 12.6188C39.2265 9.95489 38.3258 7.36835 36.6668 5.28412C38.1771 4.17268 40.0311 3.51896 42.0503 3.51896C44.0694 3.51896 45.9353 4.17229 47.4457 5.28412C45.7869 7.36845 44.8862 9.95493 44.8915 12.6188C44.8928 15.2815 45.7928 17.8658 47.4457 19.9534ZM49.378 18.0269C48.2176 16.4627 47.5929 14.5659 47.5967 12.6184C47.5916 10.6706 48.2165 8.77346 49.378 7.20992C50.5391 8.77365 51.1639 10.6707 51.1593 12.6184C51.1628 14.5659 50.5381 16.4626 49.378 18.0269ZM56.6992 21.7209C54.6935 21.7209 52.8142 21.051 51.3099 19.9534C52.9629 17.8659 53.8629 15.2815 53.8641 12.6188C53.8694 9.95493 52.9687 7.36845 51.3099 5.28412C52.8157 4.18651 54.6938 3.51588 56.6992 3.51588C61.7299 3.51588 65.8021 7.58732 65.8021 12.6188C65.8021 17.6495 61.7299 21.7209 56.6992 21.7209Z",
            fill: "#101214"
        })
    });
};
const $ba4696cf403c7502$export$7952818aa3b430a7 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "85",
        height: "25",
        viewBox: "0 0 85 25",
        fill: "none",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M45.0486 23.7095H56.5358C58.2522 23.7095 59.6608 23.0052 60.805 21.5961C61.9053 20.2318 62.4776 18.6035 62.4776 16.7555C62.4776 13.0143 57.6804 10.3735 55.831 10.3735H49.5375C49.0534 10.3735 48.6565 10.1533 48.3491 9.8016C48.0408 9.40515 47.8649 8.9653 47.8649 8.43685C47.8649 7.8207 48.0408 7.2927 48.3491 6.85241C48.7012 6.41255 49.1411 6.14856 49.6695 6.14856H61.465V1.43862H49.4489C47.2922 1.43862 45.6191 2.09907 44.4307 3.37521C43.3751 4.56366 42.8462 6.14811 42.8462 8.04086C42.8462 9.8893 43.3751 11.518 44.4307 12.8376C45.6191 14.29 47.0282 15.0391 48.7446 15.0391H56.0073C56.4467 15.0391 56.7993 15.1711 57.0629 15.5223C57.3712 15.8745 57.5032 16.3148 57.5032 16.7994C57.5032 17.3717 57.283 17.8997 56.9309 18.34C56.5349 18.736 56.0946 18.9561 55.5232 18.9561H43.9036L43.7277 18.6478L39.3704 4.65181L39.1502 4.21151C38.0938 2.05477 36.3335 0.998769 33.9128 0.998769C32.5923 0.998769 31.4039 1.30662 30.3474 1.96706C29.2471 2.62706 28.5428 3.59536 28.1468 4.82811L22.2927 23.6652L27.6184 23.7099L32.9879 6.941C33.1199 6.41256 33.4282 6.14856 33.8242 6.14856C34.0443 6.14856 34.2202 6.23626 34.3522 6.36871C34.4842 6.54456 34.5723 6.72086 34.6162 6.941L40.0295 23.7099L45.0486 23.7095ZM5.43611 8.30485V23.6652H0.50647V6.63226C0.50647 4.43166 1.03492 2.89106 2.17907 1.96706C3.05922 1.30662 4.37966 0.954468 6.22811 0.954468C7.72441 0.954468 9.001 1.39477 10.1452 2.23107C11.2893 3.06736 12.0375 4.21151 12.4339 5.62011L15.6466 16.9314L16.1751 18.472C16.2189 18.7798 16.3952 19 16.5711 19.1754C16.7912 19.3521 17.0109 19.4403 17.2754 19.3521C17.7157 19.3083 17.9358 19.0438 17.9358 18.6478V1.48292H22.9975V18.4277C22.9975 20.3204 22.5576 21.7295 21.6332 22.7416C20.753 23.7538 19.4326 24.2822 17.6718 24.2822C16.1312 24.2822 14.8546 23.9739 13.8425 23.4459C12.6102 22.8298 11.8177 21.8615 11.4656 20.5844L7.76871 7.68871L7.50471 6.85241C7.41656 6.54455 7.24071 6.32441 7.02056 6.10426C6.80041 5.92796 6.53641 5.88411 6.27241 5.92796C6.00841 5.97226 5.83256 6.10426 5.65626 6.36826C5.51155 6.60704 5.43538 6.88105 5.43611 7.16026V8.30485ZM84.2204 23.7095L78.4988 4.65181L78.2786 4.21151C77.2222 2.05477 75.4619 0.998769 73.0411 0.998769C71.7207 0.998769 70.5322 1.30662 69.4762 1.96706C68.375 2.62706 67.6716 3.59536 67.2747 4.82811L61.4211 23.6652L66.7467 23.7099L72.1162 6.941C72.2482 6.41256 72.5565 6.14856 72.9525 6.14856C73.1727 6.14856 73.3485 6.23626 73.4805 6.36871C73.6134 6.54456 73.7007 6.72086 73.7454 6.941L79.1588 23.7099L84.2204 23.7095Z",
            fill: "#101214"
        })
    });
};
const $ba4696cf403c7502$export$53457fb076dd0473 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: "71",
        height: "30",
        viewBox: "0 0 71 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M6.19961 0H0.302734V29.4403H6.19961V0ZM21.6954 29.4381H27.5923V9.42706H21.6954V29.4381ZM36.7814 29.4381H43.5707L50.36 9.42706H44.4632C44.4632 9.42706 41.3098 20.2777 40.349 23.7307H40.2807C39.3199 20.2777 36.0982 9.42706 36.0982 9.42706H29.8576L36.7814 29.4381ZM70.9264 9.42706H65.2344V12.175C64.2736 10.0617 62.0127 8.86294 59.3375 8.86294C54.5381 8.86294 50.6972 12.8801 50.6972 19.4315C50.6972 25.9828 54.3993 30 59.0621 30C62.3543 30 64.2736 28.3803 65.3027 26.5469V29.4359H70.9925L70.9264 9.42706ZM65.1 19.9273C65.1 23.5919 62.9052 25.3526 60.7104 25.3526C58.3107 25.3526 56.7329 22.8162 56.7329 19.4337C56.7329 16.0511 58.379 13.5148 60.9153 13.5148C62.9713 13.5148 65.0978 15.2755 65.0978 18.9401V19.9273H65.1ZM7.70688 18.9401C17.1692 18.9401 19.364 10.8374 19.364 9.42706H18.542C9.07973 9.42706 6.88493 17.5297 6.88493 18.9401H7.70688ZM6.88493 19.6452C6.88493 21.1238 8.53103 29.3676 18.6787 29.3676H19.5006C19.5006 27.8889 17.8545 19.6452 7.70688 19.6452H6.88493ZM28.2093 3.93125C28.2093 2.02953 26.7703 0.407668 24.9171 0.407668C24.8488 0.407668 24.7805 0.407668 24.7122 0.407668C22.8611 0.337153 21.2833 1.81578 21.215 3.7197C21.215 3.79022 21.215 3.86073 21.215 3.93125C21.215 5.83297 22.654 7.45483 24.5072 7.45483C24.5755 7.45483 24.6439 7.45483 24.7122 7.45483C26.5632 7.52534 28.141 6.04672 28.2093 4.1428C28.2093 4.07228 28.2093 4.00176 28.2093 3.93125Z",
            fill: "white"
        })
    });
};
const $ba4696cf403c7502$export$17670a653fa957a4 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "102",
        height: "31",
        viewBox: "0 0 102 31",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 6.34607H3.55597V14.2464H11.0557V6.34607H14.6163V25.739H11.0557V17.6727H3.55597V25.739H0V6.34607ZM25.8816 19.4224C25.8816 21.0458 24.559 22.3669 22.936 22.3669C21.3123 22.3669 19.9905 21.0458 19.9905 19.4224V11.0731H16.6182V19.4224C16.6182 22.9057 19.4525 25.739 22.936 25.739C26.4186 25.739 29.2527 22.9057 29.2527 19.4224V11.0731H25.8816V19.4224ZM38.6669 11.1709C36.9941 11.1709 35.8265 11.6563 34.6988 12.7632V6.34607H31.3156V18.2388C31.3156 22.6904 34.5341 25.739 38.15 25.739C42.1699 25.739 45.692 22.636 45.692 18.4551C45.692 14.3273 42.4442 11.1709 38.6669 11.1709ZM38.751 22.6091C36.4585 22.6091 34.7054 20.6945 34.7054 18.4551C34.7054 16.2154 36.4585 14.3002 38.751 14.3002C40.6935 14.3002 42.4476 16.2154 42.4476 18.4551C42.4476 20.6945 40.6935 22.6091 38.751 22.6091ZM51.3744 12.0232C51.3744 10.3225 52.5076 9.78333 53.7482 9.78333C54.7469 9.78333 56.0685 10.5387 56.931 11.4561L59.1427 8.86645C58.0373 7.38286 55.7986 6.35742 53.9641 6.35742C50.2948 6.35742 47.6509 8.48878 47.6509 12.0232C47.6509 18.5786 55.7176 16.5007 55.7176 20.1706C55.7176 21.3024 54.6118 22.3015 53.3446 22.3015C51.3475 22.3015 50.6997 21.3303 49.7828 20.3048L47.3274 22.8404C48.8931 24.756 50.8348 25.7276 53.1552 25.7276C56.635 25.7276 59.4409 23.5694 59.4409 20.1967C59.4409 12.913 51.3744 15.1794 51.3744 12.0232ZM68.3475 10.9809C64.732 10.9809 61.5131 14.0277 61.5131 18.4802V30.4037H64.8961V23.956C66.0239 25.0621 67.191 25.5484 68.8644 25.5484C72.6415 25.5484 75.8897 22.3924 75.8897 18.2645C75.8897 14.0831 72.3666 10.9809 68.3475 10.9809ZM68.9487 22.4195C66.6564 22.4195 64.9031 20.5022 64.9031 18.2645C64.9031 16.0248 66.6564 14.1096 68.9487 14.1096C70.8908 14.1096 72.6451 16.0248 72.6451 18.2645C72.6451 20.5022 70.8908 22.4195 68.9487 22.4195ZM100.793 22.6091C98.7974 22.6091 98.2309 21.7462 98.2309 20.4238V14.5699H101.333V11.6027H98.2309V7.69061L94.8058 9.22798V21.1522C94.8058 24.201 96.9093 25.739 99.7946 25.739C100.226 25.739 100.82 25.7111 101.144 25.6312L101.981 22.5561C101.603 22.5822 101.172 22.6091 100.793 22.6091Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M91.8684 14.7425C91.2198 13.6266 90.3075 12.7321 89.1669 12.0586C88.3146 11.5624 87.4308 11.2475 86.4348 11.1122V7.56661C87.4308 7.14373 88.0489 6.20773 88.0489 5.11576C88.0489 3.62739 86.8553 2.42129 85.3681 2.42129C83.8798 2.42129 82.6653 3.62739 82.6653 5.11576C82.6653 6.20773 83.2477 7.14373 84.2437 7.56661V11.1138C83.4469 11.229 82.6207 11.4774 81.8662 11.859C80.325 10.6885 75.2715 6.84873 72.3153 4.60602C72.3854 4.35325 72.4394 4.09271 72.4394 3.81782C72.4394 2.16931 71.1044 0.83313 69.4553 0.83313C67.8062 0.83313 66.4718 2.16931 66.4718 3.81782C66.4718 5.46614 67.8076 6.80271 69.4567 6.80271C70.0192 6.80271 70.5395 6.63818 70.9885 6.36768L71.6123 6.84096L80.1848 13.0175C79.7316 13.4336 79.3095 13.9069 78.9719 14.4379C78.2877 15.5205 77.8696 16.7117 77.8696 18.011V18.2821C77.8696 19.1942 78.0429 20.0554 78.3381 20.8643C78.598 21.5706 78.9781 22.2128 79.4488 22.7934L76.6037 25.6455C76.1914 25.492 75.7436 25.4605 75.3139 25.5548C74.8841 25.649 74.4906 25.865 74.1803 26.1769C73.9655 26.3907 73.7953 26.6449 73.6794 26.925C73.5636 27.205 73.5044 27.5053 73.5055 27.8083C73.5057 28.4244 73.7457 29.0035 74.1815 29.4391C74.3951 29.6541 74.6493 29.8245 74.9293 29.9406C75.2092 30.0566 75.5094 30.1159 75.8125 30.1151C76.1157 30.1159 76.416 30.0566 76.696 29.9405C76.9761 29.8245 77.2303 29.654 77.4441 29.4391C77.6588 29.2253 77.829 28.9712 77.9449 28.6913C78.0608 28.4113 78.1201 28.1113 78.1194 27.8083C78.1194 27.5699 78.0825 27.3372 78.0132 27.1161L80.9539 24.175C81.357 24.4535 81.7925 24.688 82.2606 24.8901C83.1838 25.2893 84.2029 25.5325 85.3182 25.5325H85.5225C86.7555 25.5325 87.9186 25.2429 89.012 24.6505C90.1641 24.0245 91.0658 23.1683 91.7471 22.0754C92.4319 20.9794 92.809 19.7685 92.809 18.4363V18.3698C92.809 17.0593 92.5056 15.8502 91.8684 14.7425ZM88.2754 20.9121C87.4772 21.7991 86.5597 22.3455 85.5225 22.3455H85.3516C84.7592 22.3455 84.1798 22.1817 83.6125 21.8839C82.9731 21.5561 82.487 21.0884 82.0892 20.4962C81.6781 19.9149 81.455 19.2803 81.455 18.6074V18.4031C81.455 17.7415 81.5819 17.1143 81.9018 16.5219C82.2438 15.8743 82.7057 15.3708 83.3201 14.9704C83.9232 14.5728 84.5674 14.3778 85.2849 14.3778H85.3516C86.0022 14.3778 86.6181 14.5061 87.1993 14.8035C87.7915 15.1206 88.2754 15.5538 88.6504 16.1237C89.0148 16.6938 89.2315 17.3087 89.3012 17.9786C89.3122 18.1178 89.3177 18.2604 89.3177 18.3967C89.3177 19.3058 88.9703 20.1478 88.2754 20.9121Z",
                fill: "#101214"
            })
        ]
    });
};
const $ba4696cf403c7502$export$faa4c35a40f54c9f = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "74",
        height: "21",
        viewBox: "0 0 74 21",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M38.2467 4.39989C36.9006 3.47215 35.0814 3.13135 32.662 3.13135H28.0898V18.8903H32.759C34.4205 18.8903 35.8515 18.6694 37.0461 18.1708C38.2467 17.6596 39.1866 16.8518 39.8233 15.6842C40.46 14.5166 40.7935 13.002 40.7935 11.0708C40.7935 9.40462 40.5934 8.0351 40.175 6.93696C39.7506 5.83883 39.1139 5.00576 38.2467 4.39989ZM37.0218 13.7972C36.7975 14.5861 36.4337 15.1856 35.8758 15.6022C35.2573 16.0566 34.3295 16.3027 33.1835 16.3027H31.5462V5.72523H32.9227C34.2749 5.73154 35.2755 5.95243 35.9486 6.46994C36.4397 6.85492 36.7854 7.38506 37.0097 8.11084C37.2341 8.84293 37.3311 9.75804 37.3311 10.9004C37.3311 12.0427 37.2462 13.0146 37.0218 13.7972Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M42.9609 18.8903H46.4234V12.1752H50.4194V9.60658H46.4234V5.72523H52.5963V3.13135H42.9609V18.8903Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M54.7842 18.8912H58.2467V3.13232H54.7842C54.7842 3.13232 54.76 18.8912 54.7842 18.8912Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M73.4648 3.13135H69.9902V12.1752L63.5505 3.13135H60.7793V18.8903H64.2599V9.60658L70.6269 18.8903H73.4648V3.13135Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M15.0294 19.4902C14.7384 19.3703 14.4473 19.1368 13.6651 17.7673L12.1006 15.0787L10.2633 11.9042L10.1056 11.6329C10.1966 11.6076 10.2815 11.576 10.3724 11.5445C12.4826 10.7935 13.7136 8.78021 13.7136 5.91496C13.7136 4.49495 13.1618 3.18855 12.1127 2.21032C11.9611 2.07778 11.8035 1.94525 11.6337 1.82534C10.233 0.859735 8.34105 0.5 5.8185 0.5H1.05841H0.985639C0.676384 0.5 0.646065 0.683023 0.767342 0.853424C0.87649 0.99858 1.00383 1.20054 1.05234 1.70543V17.5275C0.997767 18.1712 0.870427 18.3795 0.767342 18.5246C0.646065 18.695 0.70064 18.8843 1.00989 18.878H4.53904V12.1756H6.13988L7.26775 14.1699L8.68669 16.6755L9.37796 17.8935C10.2512 19.4271 11.0152 20.2728 12.5433 20.4558C12.7494 20.4874 12.9738 20.5 13.2103 20.5C13.2285 20.5 13.4286 20.5 13.4468 20.5C13.9925 20.5 14.5322 20.2728 14.8597 20.1213C14.9021 20.1024 14.9506 20.0835 14.9931 20.0645C15.3872 19.8752 15.272 19.5912 15.0294 19.4902ZM6.77659 9.60697H4.65425H4.53297V3.13174H6.77659C7.88626 3.13174 8.72913 3.28321 9.36584 3.88277C9.60232 4.11628 9.77817 4.39397 9.91158 4.72846C10.0692 5.13869 10.1481 5.62465 10.1481 6.21789C10.142 7.07621 10.0632 9.60697 6.77659 9.60697Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M19.5662 12.1752H23.5683V9.60658H19.5662V5.71891H25.7391V3.13135H16.0977V18.8903H25.7391V16.2774H19.5662V12.1752Z",
                fill: "white"
            })
        ]
    });
};
const $ba4696cf403c7502$var$testimonialDHCSStyle = null;
const $ba4696cf403c7502$export$559c708bf478ce1 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial-dhcs-2416114995.webp',
            alt: ''
        },
        className: (0, $2jatx.default)([
            "_1bsb10e3 _4t3i1u1b"
        ])
    });
};
const $ba4696cf403c7502$export$2e83fbbf538f5ae7 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "57",
        height: "34",
        viewBox: "0 0 57 34",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                clipPath: "url(#clip0_7035_3621)",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M38.2791 29.91C38.2336 29.8512 38.1835 29.8059 38.1153 29.7698C38.047 29.7336 37.9742 29.7109 37.8878 29.7109C37.8104 29.7109 37.7376 29.72 37.6694 29.7562C37.6012 29.7833 37.5466 29.8331 37.4965 29.8874C37.4465 29.9417 37.4192 30.0095 37.3919 30.0865C37.3646 30.1634 37.3555 30.2358 37.3555 30.3217V30.3308H38.4019C38.4019 30.2539 38.3928 30.1815 38.3746 30.1046C38.3564 30.0276 38.3291 29.9643 38.2791 29.9055V29.91Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1.32617 26.4219V34.0001H55.8044V26.4219H1.32617ZM14.3065 31.7741L13.9744 30.9145H12.6959L12.382 31.7741H11.9361L13.2009 28.4578H13.4876L14.7751 31.7741H14.3065ZM16.4767 29.8241C16.3994 29.7879 16.3266 29.7653 16.2401 29.7653C16.1628 29.7653 16.0763 29.7834 16.0035 29.8332C15.9171 29.8694 15.8307 29.9372 15.7351 30.0323V31.7651H15.2983V29.3989H15.6623L15.7215 29.6658C15.7988 29.5979 15.8625 29.5436 15.9217 29.4939C15.9808 29.4577 16.0354 29.417 16.0945 29.3989C16.14 29.3808 16.1992 29.3627 16.2356 29.3536C16.2811 29.3446 16.322 29.3446 16.3675 29.3446C16.4267 29.3446 16.4813 29.3536 16.5313 29.3627C16.5768 29.3808 16.6178 29.3989 16.6542 29.4215L16.4813 29.8287L16.4767 29.8241ZM18.0509 31.7741H17.7188L16.7952 29.3989H17.2411L17.878 31.1995H17.8871L18.6014 29.3989H19.0291L18.0464 31.7741H18.0509ZM20.8217 31.756L20.7261 31.5298C20.6988 31.566 20.6488 31.5977 20.6033 31.6338C20.5578 31.661 20.4987 31.6927 20.4395 31.7198C20.3804 31.7379 20.3167 31.756 20.2484 31.7786C20.1802 31.7877 20.1074 31.7967 20.0209 31.7967C19.9163 31.7967 19.8208 31.7877 19.7343 31.7515C19.6388 31.7243 19.5614 31.6746 19.4977 31.6112C19.4295 31.5524 19.3749 31.48 19.3339 31.385C19.2975 31.2991 19.2748 31.195 19.2748 31.0819C19.2748 30.8466 19.3612 30.6566 19.5205 30.5209C19.6843 30.3897 19.9208 30.3128 20.2348 30.3037L20.6897 30.2856V30.1997C20.6897 30.1137 20.6806 30.0368 20.6534 29.9734C20.6261 29.9101 20.5942 29.8603 20.5487 29.8241C20.5123 29.7879 20.4532 29.7563 20.3986 29.7382C20.344 29.7201 20.2757 29.711 20.2075 29.711C20.1301 29.711 20.0664 29.7201 20.0073 29.7291C19.939 29.7382 19.8844 29.7563 19.8344 29.7744C19.7889 29.7925 19.7389 29.8106 19.7025 29.8422C19.6661 29.8739 19.6251 29.8875 19.5887 29.9191L19.4249 29.616C19.5023 29.5572 19.5751 29.521 19.6433 29.4848C19.7116 29.4486 19.7844 29.417 19.8526 29.3989C19.9208 29.3717 19.9845 29.3627 20.0619 29.3536C20.1301 29.3446 20.2029 29.3446 20.2803 29.3446C20.4031 29.3446 20.5169 29.3627 20.6215 29.3898C20.7261 29.417 20.8126 29.4667 20.8899 29.5301C20.9673 29.5979 21.0219 29.6794 21.0719 29.7879C21.1174 29.892 21.1402 30.0232 21.1402 30.177V31.3217C21.1402 31.4167 21.1493 31.5026 21.1493 31.5569C21.1584 31.6158 21.1675 31.6429 21.1675 31.6791C21.1675 31.7153 21.1766 31.747 21.1857 31.7651H20.8126L20.8217 31.756ZM22.9555 31.747C22.8327 31.7922 22.7189 31.8148 22.6143 31.8148C22.5187 31.8148 22.4414 31.8058 22.3777 31.7786C22.314 31.7515 22.2549 31.7198 22.2139 31.6746C22.1684 31.6293 22.1366 31.5705 22.1184 31.5117C22.1002 31.4438 22.0911 31.3805 22.0911 31.3036V29.7698H21.6998V29.3989H22.0911V28.8695L22.5369 28.7293V29.4034H23.2603L23.1193 29.7653H22.5369V31.1588C22.5369 31.2538 22.5551 31.3307 22.5961 31.376C22.637 31.4212 22.6916 31.4438 22.769 31.4438C22.8054 31.4438 22.8463 31.4348 22.8827 31.4257C22.9191 31.4167 22.9601 31.4076 22.9965 31.3895C23.0329 31.3714 23.0647 31.3624 23.092 31.3443C23.1102 31.3171 23.1375 31.3081 23.1602 31.2855L23.2922 31.5886C23.1875 31.6655 23.0829 31.7198 22.9601 31.7605L22.9555 31.747ZM25.8218 31.0909C25.7627 31.2538 25.6808 31.385 25.5761 31.4981C25.4806 31.5931 25.3669 31.67 25.2349 31.7243C25.103 31.7696 24.9574 31.8012 24.7981 31.8012C24.4842 31.8012 24.234 31.7062 24.0383 31.5162C23.9337 31.4031 23.8472 31.2719 23.7927 31.109C23.7335 30.9462 23.7062 30.7697 23.7062 30.5797C23.7062 30.3897 23.7335 30.2178 23.7927 30.0594C23.8518 29.8965 23.9337 29.7653 24.0383 29.6522C24.1339 29.5482 24.2476 29.4712 24.3796 29.4169C24.5024 29.3581 24.648 29.331 24.8072 29.331C24.9801 29.331 25.1212 29.3581 25.2531 29.4169C25.3851 29.4758 25.4988 29.5482 25.5943 29.6522C25.699 29.7653 25.7854 29.8965 25.8218 30.0503C25.881 30.1997 25.9083 30.3806 25.9083 30.5706C25.9083 30.7607 25.881 30.9326 25.8218 31.0909ZM29.7755 31.281C29.7164 31.3941 29.6436 31.48 29.548 31.5569C29.4525 31.6339 29.3388 31.6881 29.2068 31.7379C29.0749 31.7741 28.9293 31.8058 28.7791 31.8058C28.6654 31.8058 28.5699 31.7967 28.4743 31.7786C28.3788 31.7605 28.2923 31.7424 28.215 31.7108C28.1376 31.6836 28.0739 31.6519 28.0057 31.6248C27.9374 31.5977 27.8919 31.5569 27.8328 31.5298L28.033 31.1905C28.0694 31.2176 28.1103 31.2493 28.1558 31.2764C28.2013 31.3036 28.2605 31.3352 28.3287 31.3533C28.3879 31.3714 28.4607 31.3895 28.5289 31.4122C28.6062 31.4303 28.679 31.4303 28.7564 31.4303C28.8246 31.4303 28.8974 31.4212 28.9748 31.4031C29.0521 31.385 29.1158 31.3579 29.175 31.3172C29.2341 31.2764 29.2796 31.2312 29.316 31.1769C29.3524 31.1181 29.3751 31.0457 29.3751 30.9688C29.3751 30.8828 29.357 30.7969 29.316 30.7335C29.2751 30.6702 29.2205 30.6023 29.1522 30.5435C29.084 30.4847 29.0112 30.4394 28.9247 30.3806C28.8383 30.3354 28.7518 30.2856 28.6654 30.2313C28.579 30.1861 28.4925 30.1273 28.4061 30.0684C28.3196 30.0096 28.2423 29.9463 28.1786 29.8694C28.1103 29.7925 28.0557 29.7065 28.0057 29.6115C27.9693 29.5165 27.9374 29.4034 27.9374 29.2722C27.9374 29.1591 27.9556 29.046 28.0057 28.9419C28.0512 28.8378 28.1103 28.7519 28.1968 28.675C28.2832 28.5981 28.3879 28.5438 28.5107 28.494C28.6335 28.4488 28.7791 28.4261 28.9293 28.4261C29.1022 28.4261 29.2523 28.4442 29.3751 28.4849C29.498 28.5257 29.6026 28.5619 29.68 28.5981L29.6709 29.0324C29.5662 28.9645 29.4616 28.9193 29.3297 28.8831C29.2068 28.8469 29.0703 28.8152 28.9384 28.8152C28.861 28.8152 28.7882 28.8243 28.72 28.8424C28.6517 28.8605 28.5971 28.8786 28.538 28.9193C28.4925 28.9555 28.4425 28.9962 28.4152 29.0505C28.3879 29.0957 28.3697 29.1636 28.3697 29.2405C28.3697 29.3265 28.3879 29.4034 28.4379 29.4667C28.4743 29.5346 28.5335 29.5979 28.6017 29.6477C28.6699 29.7065 28.7427 29.7608 28.8292 29.8106C28.9156 29.8603 29.0021 29.9146 29.0976 29.9599C29.1932 30.0051 29.2796 30.0639 29.3661 30.1318C29.4525 30.1906 29.5298 30.2539 29.5935 30.3309C29.6982 30.4168 29.7573 30.5028 29.7937 30.5978C29.8301 30.6928 29.862 30.8059 29.862 30.9281C29.862 31.0593 29.8347 31.1859 29.7755 31.29V31.281ZM31.5818 31.946C31.5044 32.1632 31.4316 32.3351 31.3452 32.4663C31.2587 32.5975 31.1723 32.7016 31.0858 32.7694C30.9994 32.8464 30.9039 32.8916 30.8083 32.9097C30.7128 32.9278 30.6172 32.9459 30.5126 32.9459C30.4079 32.9459 30.3215 32.9368 30.2441 32.9187C30.1668 32.9007 30.1031 32.8826 30.0349 32.8509L30.1486 32.5116C30.1941 32.5387 30.2532 32.5568 30.3124 32.5704C30.3715 32.5794 30.4352 32.5885 30.5035 32.5885C30.5717 32.5885 30.6354 32.5704 30.7037 32.5432C30.7719 32.5161 30.8356 32.4663 30.8948 32.403C30.9539 32.3396 31.0085 32.2537 31.0676 32.1451C31.1268 32.041 31.1723 31.9189 31.2087 31.7651L30.1304 29.3989H30.599L31.4089 31.2448H31.4271L32.0458 29.3989H32.4826L31.5772 31.946H31.5818ZM34.3935 31.4257C34.348 31.5117 34.2797 31.5886 34.1933 31.6429C34.1068 31.7017 34.0113 31.7379 33.8976 31.7651C33.7838 31.7922 33.6701 31.8012 33.5336 31.8012C33.4471 31.8012 33.3607 31.7922 33.297 31.7832C33.2197 31.7741 33.156 31.756 33.0968 31.7379C33.0377 31.7198 32.9831 31.7017 32.9239 31.67C32.8784 31.6519 32.8284 31.6248 32.792 31.5931L32.9421 31.2538C32.9785 31.2719 33.0195 31.2991 33.0559 31.3217C33.1014 31.3398 33.1423 31.3579 33.1969 31.3805C33.2561 31.3986 33.3015 31.4076 33.3607 31.4257C33.4198 31.4348 33.4744 31.4438 33.5427 31.4438C33.6109 31.4438 33.6746 31.4348 33.7338 31.4257C33.7929 31.4076 33.8384 31.3895 33.8839 31.3579C33.9203 31.3307 33.9613 31.2991 33.9795 31.2538C33.9977 31.2176 34.0159 31.1678 34.0159 31.1226C34.0159 31.0547 33.9977 31.0005 33.9704 30.9507C33.9431 30.9009 33.9021 30.8647 33.8475 30.8285C33.802 30.7923 33.7429 30.7607 33.6746 30.7335C33.6064 30.7064 33.5427 30.6747 33.4744 30.6476C33.4062 30.6204 33.3425 30.5797 33.2743 30.5435C33.206 30.5073 33.1514 30.4575 33.1014 30.4123C33.0559 30.3535 33.0058 30.2992 32.9785 30.2223C32.9512 30.1454 32.933 30.0594 32.933 29.9553C32.933 29.8694 32.9512 29.7834 32.9785 29.6975C33.0149 29.6205 33.065 29.5482 33.1287 29.4893C33.1924 29.4305 33.2788 29.3853 33.388 29.3491C33.4926 29.3129 33.6064 29.3038 33.752 29.3038C33.8839 29.3038 33.9977 29.3129 34.1023 29.34C34.2069 29.3581 34.2934 29.3989 34.3798 29.426V29.806C34.3343 29.7879 34.2843 29.7698 34.2479 29.7472C34.2024 29.7291 34.1523 29.7201 34.1068 29.702C34.0614 29.6929 34.0022 29.6748 33.9567 29.6748C33.8976 29.6658 33.843 29.6658 33.7838 29.6658C33.7247 29.6658 33.6701 29.6748 33.62 29.6839C33.57 29.6929 33.5245 29.711 33.4881 29.7291C33.4517 29.7472 33.4198 29.7744 33.4016 29.8151C33.3834 29.8558 33.3743 29.892 33.3743 29.9372C33.3743 29.9961 33.3925 30.0504 33.4198 30.0865C33.4471 30.1227 33.4972 30.1635 33.5427 30.1997C33.5882 30.2358 33.6473 30.2675 33.7156 30.2947C33.7838 30.3218 33.8475 30.3535 33.9158 30.3897C33.984 30.4168 34.0477 30.4575 34.116 30.4937C34.1842 30.5299 34.2388 30.5797 34.2888 30.634C34.3571 30.7109 34.3935 30.7652 34.4208 30.8421C34.4481 30.919 34.4663 31.005 34.4663 31.1C34.4663 31.2221 34.439 31.3352 34.3889 31.4212L34.3935 31.4257ZM36.1542 31.747C36.0314 31.7922 35.9176 31.8148 35.813 31.8148C35.7174 31.8148 35.6401 31.8058 35.5764 31.7786C35.5127 31.7515 35.4536 31.7198 35.4126 31.6746C35.3671 31.6293 35.3353 31.5705 35.3171 31.5117C35.2989 31.4438 35.2898 31.3805 35.2898 31.3036V29.7698H34.8985V29.3989H35.2898V28.8695L35.7356 28.7293V29.4034H36.459L36.318 29.7653H35.7356V31.1588C35.7356 31.2538 35.7538 31.3307 35.7948 31.376C35.8357 31.4212 35.8903 31.4438 35.9677 31.4438C36.0041 31.4438 36.045 31.4348 36.0814 31.4257C36.1178 31.4167 36.1588 31.4076 36.1952 31.3895C36.2316 31.3714 36.2634 31.3624 36.2907 31.3443C36.3089 31.3171 36.3362 31.3081 36.359 31.2855L36.4909 31.5886C36.3863 31.6655 36.2816 31.7198 36.1588 31.7605L36.1542 31.747ZM38.9068 30.6566H37.3917C37.3917 30.7697 37.4008 30.8647 37.4372 30.9597C37.4645 31.0547 37.5146 31.1407 37.5783 31.204C37.6374 31.281 37.7102 31.3352 37.8058 31.376C37.9013 31.4167 38.006 31.4348 38.1197 31.4348C38.2243 31.4348 38.329 31.4167 38.4245 31.376C38.5292 31.3398 38.6156 31.2991 38.7021 31.2538L38.8249 31.5569C38.7112 31.6429 38.5974 31.6972 38.4518 31.7379C38.3199 31.7741 38.1743 31.7967 38.0424 31.7967C37.8422 31.7967 37.6784 31.7605 37.5373 31.6927C37.3963 31.6248 37.278 31.5298 37.187 31.4167C37.096 31.3036 37.0232 31.1724 36.9777 31.0185C36.9322 30.8692 36.9095 30.7154 36.9095 30.5435C36.9095 30.3716 36.9277 30.2223 36.9777 30.0684C37.0232 29.9282 37.0915 29.7925 37.1779 29.6884C37.2644 29.5844 37.369 29.4984 37.4918 29.4305C37.6147 29.3627 37.7512 29.3355 37.9013 29.3355C38.0515 29.3355 38.197 29.3627 38.3108 29.4215C38.4245 29.4803 38.5292 29.5617 38.6156 29.6658C38.693 29.7698 38.7567 29.901 38.834 30.0368C38.8795 30.1861 38.9022 30.358 38.9022 30.539V30.6521L38.9068 30.6566ZM42.9651 31.7651H42.5193V30.2404C42.5193 30.1635 42.5102 30.1001 42.5011 30.0323C42.492 29.9644 42.4738 29.9191 42.4419 29.8694C42.4146 29.8241 42.3737 29.7834 42.3282 29.7563C42.2827 29.7291 42.2235 29.7201 42.1371 29.7201C42.0597 29.7201 41.996 29.7291 41.9369 29.7472C41.8687 29.7653 41.8141 29.7925 41.7549 29.8241C41.6958 29.8513 41.6412 29.892 41.5911 29.9282L41.4501 30.0413C41.4501 30.0413 41.4592 30.0775 41.4592 30.1001V31.7651H41.0133V30.2494C41.0133 30.1725 41.0042 30.1092 40.9951 30.0413C40.986 29.9734 40.9678 29.9191 40.936 29.8694C40.9041 29.8196 40.8677 29.7834 40.8222 29.7563C40.7767 29.7291 40.7085 29.7201 40.6311 29.7201C40.5538 29.7201 40.4901 29.7291 40.431 29.7472C40.3627 29.7653 40.3081 29.7925 40.249 29.8241C40.1898 29.8558 40.1352 29.892 40.0852 29.9282L39.9441 30.0413V31.747H39.4983V29.3808H39.8713L39.9305 29.6567C40.0806 29.5436 40.2262 29.4577 40.3582 29.3989C40.4901 29.34 40.6357 29.3129 40.7585 29.3129C40.8996 29.3129 41.027 29.3491 41.1316 29.4169C41.2362 29.4848 41.3136 29.5798 41.35 29.6929C41.4182 29.6341 41.4819 29.5798 41.5593 29.5301C41.6366 29.4803 41.7003 29.4441 41.7777 29.4079C41.855 29.3808 41.9187 29.3491 41.9961 29.331C42.0734 29.3129 42.1371 29.3038 42.2053 29.3038C42.3009 29.3038 42.3964 29.3129 42.4829 29.34C42.5693 29.3672 42.6467 29.4079 42.7195 29.4622C42.815 29.5572 42.8696 29.6432 42.9105 29.7382C42.9469 29.8332 42.9697 29.9553 42.9697 30.1092V31.7651H42.9651ZM45.1081 31.4303C45.0626 31.5117 44.9943 31.5886 44.9079 31.6429C44.8214 31.6972 44.7259 31.7379 44.6121 31.7651C44.4984 31.7922 44.3847 31.8012 44.2482 31.8012C44.1617 31.8012 44.0753 31.7922 44.0116 31.7832C43.9342 31.7741 43.8705 31.756 43.8114 31.7379C43.7522 31.7198 43.6976 31.7017 43.6385 31.6746C43.593 31.6565 43.543 31.6293 43.5066 31.6022L43.6567 31.2674C43.6931 31.2855 43.734 31.3126 43.7704 31.3307C43.8159 31.3488 43.8569 31.3669 43.9115 31.385C43.9706 31.4031 44.0161 31.4122 44.0753 31.4303C44.1344 31.4393 44.189 31.4484 44.2573 31.4484C44.3255 31.4484 44.3892 31.4393 44.4483 31.4303C44.5075 31.4122 44.553 31.3941 44.5985 31.3669C44.6349 31.3398 44.6758 31.3126 44.694 31.2629C44.7122 31.2267 44.7304 31.1814 44.7304 31.1317C44.7304 31.0683 44.7122 31.0095 44.6849 30.9643C44.6576 30.919 44.6167 30.8828 44.5621 30.8421C44.5166 30.8059 44.4574 30.7788 44.3892 30.7471C44.321 30.7199 44.2573 30.6928 44.189 30.6657C44.1208 30.6385 44.0571 30.6023 43.9888 30.5616C43.9206 30.5254 43.866 30.4802 43.8159 30.4304C43.7704 30.3761 43.7204 30.3173 43.6931 30.2449C43.6658 30.1725 43.6476 30.0865 43.6476 29.9825C43.6476 29.901 43.6658 29.8151 43.6931 29.7337C43.7295 29.6613 43.7795 29.5843 43.8432 29.5301C43.9069 29.4758 43.9934 29.426 44.1026 29.3898C44.2072 29.3536 44.321 29.3446 44.4665 29.3446C44.5985 29.3446 44.7122 29.3536 44.8169 29.3808C44.9215 29.3989 45.008 29.435 45.0944 29.4622V29.8332C45.0489 29.8151 44.9989 29.797 44.9625 29.7789C44.917 29.7608 44.8669 29.7517 44.8214 29.7337C44.7759 29.7156 44.7168 29.7065 44.6713 29.7065C44.6121 29.6975 44.5575 29.6975 44.4984 29.6975C44.4392 29.6975 44.3847 29.7065 44.3346 29.7156C44.2891 29.7246 44.2391 29.7427 44.2027 29.7608C44.1663 29.7789 44.1344 29.806 44.1162 29.8422C44.098 29.8784 44.0889 29.9146 44.0889 29.9644C44.0889 30.0187 44.1071 30.0775 44.1344 30.1137C44.1617 30.1499 44.2118 30.1861 44.2573 30.2268C44.3028 30.2675 44.3619 30.2901 44.4301 30.3218C44.4984 30.349 44.5621 30.3761 44.6303 30.4168C44.6986 30.444 44.7623 30.4802 44.8305 30.5209C44.8988 30.5616 44.9534 30.6023 45.0034 30.6611C45.0489 30.7154 45.099 30.7742 45.1263 30.8466C45.1627 30.9281 45.1854 31.014 45.1854 31.1181C45.1854 31.2402 45.1581 31.3488 45.1081 31.4348V31.4303Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M20.6989 30.6386L20.2712 30.6567C20.0801 30.6657 19.9391 30.7019 19.8526 30.7698C19.7662 30.8376 19.7207 30.9191 19.7207 31.0457C19.7207 31.1046 19.7298 31.1589 19.748 31.2086C19.7662 31.2539 19.7935 31.2946 19.8344 31.3308C19.8754 31.367 19.9118 31.3986 19.9664 31.4167C20.0255 31.4348 20.0892 31.4439 20.1575 31.4439C20.2348 31.4439 20.2894 31.4439 20.3486 31.4258C20.4077 31.4077 20.4532 31.3896 20.4987 31.367C20.5442 31.3443 20.5851 31.3217 20.6215 31.2901C20.6488 31.2629 20.6807 31.2448 20.708 31.2131H20.6989V30.634V30.6386Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M13.4011 29.2857C13.3829 29.2178 13.3647 29.1636 13.3556 29.1047H13.3465C13.3283 29.1726 13.3101 29.2269 13.2874 29.2948C13.2646 29.3626 13.2419 29.435 13.21 29.5119L12.8506 30.5073H13.8197L13.4784 29.5119C13.4511 29.426 13.4193 29.349 13.4011 29.2857Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M25.2891 29.9373C25.23 29.8604 25.1663 29.7971 25.0798 29.7563C24.9934 29.7111 24.8979 29.6885 24.7932 29.6885C24.6886 29.6885 24.6021 29.7156 24.5157 29.7563C24.4383 29.8016 24.3746 29.8604 24.3155 29.9373C24.2563 30.0142 24.2199 30.1092 24.1926 30.2133C24.1653 30.3174 24.1562 30.4305 24.1562 30.5617C24.1562 30.6929 24.1744 30.8195 24.2017 30.9236C24.229 31.0277 24.2791 31.1227 24.3337 31.1996C24.3928 31.2765 24.4565 31.3398 24.543 31.3806C24.6203 31.4258 24.7159 31.4484 24.8205 31.4484C24.9252 31.4484 25.0207 31.4213 25.098 31.3806C25.1754 31.3353 25.2391 31.2765 25.2982 31.1996C25.3437 31.1227 25.3938 31.0277 25.4211 30.9236C25.4484 30.8195 25.4666 30.7064 25.4666 30.5752C25.4666 30.444 25.4484 30.3174 25.4211 30.2133C25.3847 30.1092 25.3437 30.0142 25.2891 29.9373Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M49.0617 17.776H49.8989V23.4585H49.2892L46.3183 19.3957V23.4585H45.4811V17.776H46.1863L49.0617 21.7076V17.776ZM42.401 17.7308L44.6394 23.4585H43.6794L43.1835 22.1058H40.9633L40.4673 23.4585H39.5438L41.8095 17.7308H42.401ZM42.906 21.3774L42.0688 19.0835L41.2317 21.3774H42.906ZM37.4008 17.776L35.7447 21.3457L34.0295 17.776H33.256L32.6555 23.4585H33.5609L33.9249 19.4636L35.5446 22.8342H35.8949L37.4964 19.3776L37.8786 23.4676H38.7657L38.1652 17.7851H37.4054V17.776H37.4008ZM29.0612 19.0926C29.0612 18.6175 29.4525 18.3551 30.0804 18.3551C30.6036 18.3551 31.1177 18.613 31.327 18.7442L31.6318 18.0611C31.4589 17.9479 30.822 17.6177 30.0622 17.6177C28.902 17.6177 28.1558 18.2239 28.1558 19.1605C28.1558 21.1602 30.9948 20.4001 30.9948 21.8524C30.9948 22.4406 30.4898 22.7256 29.7482 22.7256H28.6836L28.3424 23.4721H29.771C31.1313 23.4721 31.9048 22.7618 31.9048 21.7936C31.923 19.6536 29.0658 20.3142 29.0658 19.0926H29.0612ZM25.7354 17.776H24.8573V23.4585H27.6554L27.9966 22.712H25.7308V17.776H25.7354ZM21.3358 20.8435H23.3559V20.106H21.3358V18.5044H23.6789V17.767H20.4714V23.4495H23.7654V22.712H21.3358V20.848V20.8435ZM15.403 18.5135H17.0045V23.4585H17.8826V18.5135H19.4841V17.767H15.4075V18.5135H15.403ZM14.5931 19.4636C14.5931 18.5813 14.0699 17.776 12.7914 17.776H10.9989V23.4585H11.8542V18.4501H12.5776C13.2828 18.4501 13.6923 18.8845 13.6923 19.4455C13.6923 20.3051 13.0735 20.6082 12.2364 20.6082H12.1226L13.9698 23.4585H15.0345L13.4148 21.0426C14.0608 20.8254 14.584 20.3051 14.584 19.4591L14.5931 19.4636ZM7.28629 20.8435H9.31547V20.106H7.29539V18.5044H9.6385V17.767H6.43095V23.4495H9.72494V22.712H7.29539L7.28629 20.848V20.8435ZM5.30717 21.7845C5.30717 22.6758 4.68841 23.4902 3.15516 23.4902H1.32617V17.7489H3.17335C4.51552 17.7489 5.03874 18.4139 5.03874 19.1695C5.03874 19.7577 4.65656 20.1468 4.28803 20.3458C4.74301 20.5177 5.30717 20.8933 5.30717 21.7845ZM4.41998 21.8388C4.41998 21.0607 3.75117 20.7485 2.90492 20.7485H2.63649L2.94132 20.0744C3.38719 20.0744 4.16064 19.9974 4.16064 19.1921C4.16064 18.8121 3.91496 18.4366 3.08236 18.4366H2.16787V22.7935H3.12786C3.87856 22.7844 4.41543 22.4451 4.41543 21.8388H4.41998ZM54.9536 17.776V21.7076L52.0782 17.776H51.373V23.4585H52.2101V19.3957L55.1811 23.4585H55.7908V17.776H54.9536Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M43.0972 3.15343H45.5177V5.27532H43.0972V9.92628C43.0972 10.8945 43.4612 11.3288 44.3939 11.3288H45.2037V13.4416H43.3474C41.3274 13.4416 40.4811 12.288 40.4811 10.7135V5.27532H38.9479V3.15343H40.4811V0.787226L43.1018 0V3.15343H43.0972ZM37.3054 10.7226C37.3054 12.202 37.3509 12.9576 37.5056 13.4416H35.0761L34.8577 12.5323C34.1798 13.1385 33.238 13.6588 31.8685 13.6588C29.9622 13.6588 28.479 12.3151 28.479 10.2973C28.479 8.16633 30.1669 6.95383 32.8012 6.86786L34.6666 6.8V6.57379C34.6666 5.33413 33.7612 5.031 32.6647 5.031C31.732 5.031 29.7484 5.12601 29.7484 5.12601V3.167C29.7484 3.167 31.5955 3.07199 33.1879 3.07199C35.7403 3.07199 37.2918 4.04019 37.2918 6.73666V10.7226H37.3009H37.3054ZM34.6711 8.60067L33.1561 8.64591C31.7366 8.6821 31.0996 9.23407 31.0996 10.0937C31.0996 10.9533 31.6911 11.5912 32.7876 11.5912C33.7021 11.5912 34.3299 11.2428 34.6711 10.9397V8.60067ZM23.0011 9.83127L20.5898 3.15343H17.6871L21.8956 13.4281H23.8883L28.1833 3.15343H25.4898L23.0057 9.83127H23.0011ZM13.5332 3.15343H11.2947V13.4281H13.9518V6.26613C14.5614 5.69607 15.2939 5.59202 15.9127 5.59202C16.122 5.59202 16.3813 5.61916 16.6543 5.70512V3.13985C15.6715 3.13985 14.8526 3.28011 13.8244 4.23021L13.5286 3.1489L13.5332 3.15343ZM9.06082 10.7226C9.06082 12.202 9.10631 12.9576 9.261 13.4416H6.83146L6.61307 12.5323C5.93516 13.1385 4.99337 13.6588 3.62391 13.6588C1.71758 13.6588 0.234375 12.3151 0.234375 10.2973C0.234375 8.16633 1.92232 6.95383 4.5566 6.86786L6.42198 6.8V6.57379C6.42198 5.33413 5.51659 5.031 4.42011 5.031C3.48742 5.031 1.50374 5.12601 1.50374 5.12601V3.167C1.50374 3.167 3.35093 3.07199 4.94333 3.07199C7.49571 3.07199 9.04717 4.04019 9.04717 6.73666V10.7226H9.05627H9.06082ZM6.42198 8.60067L4.90693 8.64591C3.48742 8.6821 2.85046 9.23407 2.85046 10.0937C2.85046 10.9533 3.44192 11.5912 4.5384 11.5912C5.45289 11.5912 6.08075 11.2428 6.42198 10.9397V8.60067ZM56.8965 8.27944C56.8965 11.3876 54.8855 13.7629 51.6962 13.7629C48.5068 13.7629 46.5322 11.3967 46.5322 8.3654C46.5322 4.85003 48.9026 2.8322 51.7144 2.8322C54.5261 2.8322 56.8965 4.78217 56.8965 8.27944ZM54.2031 8.29754C54.2031 6.3159 53.2886 4.88623 51.6689 4.88623C50.0492 4.88623 49.2029 6.38377 49.2029 8.29754C49.2029 10.2113 50.1447 11.745 51.7371 11.745C53.3295 11.745 54.2031 10.2294 54.2031 8.29754Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                    id: "clip0_7035_3621",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        width: "56.6667",
                        height: "34",
                        fill: "white",
                        transform: "translate(0.229492)"
                    })
                })
            })
        ]
    });
};
const $ba4696cf403c7502$var$testimonialDropboxStyle = null;
const $ba4696cf403c7502$export$3944c61ebd3bc79e = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial-dropbox-2272682323.webp',
            alt: ''
        },
        className: (0, $2jatx.default)([
            "_1bsbs0l4 _4t3izwfg"
        ])
    });
};
const $ba4696cf403c7502$var$testimonialRobloxStyle = null;
const $ba4696cf403c7502$export$d76e3d65f440a2bb = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial-roblox-1428046955.webp',
            alt: ''
        },
        className: (0, $2jatx.default)([
            "_1bsb1j4a _4t3i1tcg"
        ])
    });
};
const $ba4696cf403c7502$var$testimonialLumenStyle = null;
const $ba4696cf403c7502$export$2d5c2c6aa86b2349 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial-lumen-3277500912.webp',
            alt: ''
        },
        className: (0, $2jatx.default)([
            "_1bsb1j4a _4t3if6fq"
        ])
    });
};
const $ba4696cf403c7502$export$5ea2342df8447e77 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "89",
        height: "23",
        viewBox: "0 0 89 23",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M31.9993 21.1745C29.5465 21.1745 28.2194 19.926 28.2194 17.5961V10.7638H27.3641C26.9562 10.7589 26.5629 10.5918 26.2779 10.3018C25.9928 10.0118 25.8355 9.62348 25.8453 9.22042C25.865 8.40939 26.5384 7.76057 27.3641 7.75566H28.2194V5.72071C28.2931 4.81629 29.0599 4.1134 29.984 4.1134C30.9081 4.1134 31.6798 4.81138 31.7486 5.72071V7.75566H33.1249C33.5179 7.76704 33.8913 7.92991 34.1671 8.21022C34.4428 8.49053 34.5995 8.86658 34.6044 9.25974C34.5995 9.65291 34.4428 10.029 34.1671 10.3093C33.8913 10.5896 33.5179 10.7524 33.1249 10.7638H31.7486V16.672C31.7486 17.7043 32.4122 18.1073 32.9627 18.1073H33.2674C34.2603 18.1073 34.8158 18.7561 34.8158 19.6016C34.8158 20.447 34.2898 21.1745 31.9993 21.1745Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M43.035 21.1744C38.6505 21.1744 36.0012 18.0286 36.0012 14.2881C36.0012 10.577 38.6555 7.43119 43.035 7.43119C47.449 7.43119 50.0983 10.577 50.0983 14.2881C50.1278 15.2155 49.9639 16.1389 49.617 16.9996C49.2701 17.8602 48.7478 18.6392 48.0834 19.287C47.419 19.9347 46.627 20.4371 45.7579 20.762C44.8887 21.087 43.9614 21.2274 43.035 21.1744ZM43.035 10.4934C40.8526 10.4934 39.6434 12.2531 39.6434 14.2881C39.6434 16.323 40.8575 18.1171 43.035 18.1171C45.2125 18.1171 46.4561 16.3574 46.4561 14.2881C46.4561 12.2531 45.2125 10.4934 43.035 10.4934ZM62.48 21.0122H62.2048C61.9295 21.0122 60.6859 20.7959 60.6859 19.4934C59.7766 20.5502 58.2086 21.1744 56.4686 21.1744C54.3452 21.1744 51.8334 19.7637 51.8334 16.8342C51.8334 13.7719 54.3452 12.607 56.4686 12.607C58.2381 12.607 59.8061 13.1772 60.6859 14.2045V12.4399C60.6859 11.1128 59.5259 10.2427 57.7613 10.2427C56.707 10.2208 55.67 10.5134 54.7826 11.0833C54.5909 11.1997 54.3727 11.2657 54.1486 11.275C53.4113 11.2651 52.8214 10.6704 52.8214 9.94783C52.8253 9.70892 52.8914 9.47515 53.0131 9.26951C53.8389 7.96695 56.8176 7.42627 58.361 7.42627C61.3937 7.42627 64.1807 8.62069 64.1807 12.3858V19.3017C64.1856 20.2356 63.4238 21.0024 62.4702 21.0073L62.48 21.0122ZM60.6859 16.0772C60.1059 15.3203 59.0049 14.9369 57.8744 14.9369C56.4932 14.9369 55.3626 15.6349 55.3626 16.9178C55.3626 18.1368 56.4932 18.8446 57.8744 18.8446C59.0049 18.8446 60.1059 18.4661 60.6859 17.7042V16.0772Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M72.4687 21.1745C70.7336 21.1745 67.9466 20.6043 67.1209 19.4345C66.9587 19.2231 66.8702 18.9675 66.8751 18.7021C66.8853 18.3204 67.0431 17.9575 67.3154 17.6898C67.5876 17.4221 67.9531 17.2705 68.335 17.2668C68.5905 17.2668 68.8363 17.3356 69.0526 17.4683C70.0996 18.0631 71.4808 18.5251 72.6359 18.5251C74.1547 18.5251 74.8723 17.9304 74.8723 17.1144C74.8723 14.9468 66.9537 16.7065 66.9537 11.5552C66.9537 9.35805 68.915 7.43616 72.4147 7.43616C74.1498 7.43616 76.5239 7.98176 77.271 9.03364C77.414 9.22724 77.4915 9.46143 77.4922 9.70213C77.4676 10.4296 76.8581 11.0096 76.1159 11.0047C75.8848 11.0052 75.6571 10.9495 75.4523 10.8425C74.5313 10.328 73.4942 10.0573 72.4392 10.056C71.1711 10.056 70.3453 10.6262 70.3453 11.3586C70.3453 13.31 78.2344 11.683 78.2344 16.967C78.2344 19.3558 76.1651 21.1745 72.4687 21.1745ZM85.2928 21.1745C82.8401 21.1745 81.5129 19.926 81.5129 17.5961V10.7638H80.6577C80.2497 10.7589 79.8565 10.5918 79.5714 10.3018C79.2863 10.0118 79.129 9.62348 79.1388 9.22042C79.1585 8.4094 79.8319 7.76057 80.6577 7.75566H81.5129V5.72071C81.5534 5.28091 81.7569 4.87215 82.0834 4.57474C82.4099 4.27733 82.8359 4.11277 83.2775 4.11341C84.2016 4.11341 84.9733 4.81138 85.0421 5.72071V7.75566H86.4233C86.8164 7.76704 87.1898 7.92992 87.4655 8.21023C87.7412 8.49054 87.8979 8.86658 87.9028 9.25975C87.8979 9.65291 87.7412 10.029 87.4655 10.3093C87.1898 10.5896 86.8164 10.7524 86.4233 10.7638H85.0421V16.672C85.0421 17.7043 85.7057 18.1073 86.2562 18.1073H86.561C87.5539 18.1073 88.1044 18.7561 88.1044 19.6016C88.1044 20.447 87.5883 21.1745 85.2928 21.1745Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M23.5989 15.7873C23.6186 14.3373 23.5547 12.8872 23.4072 11.4471C23.2991 10.4738 22.9698 9.22533 21.913 8.96974C22.0492 9.00427 22.1924 8.99915 22.3259 8.95499C23.5498 8.316 23.4564 6.73818 23.0238 5.59783C22.4537 4.10357 21.1019 3.04186 19.7601 2.33897C17.2714 1.09804 14.5118 0.499666 11.7327 0.598398C8.95364 0.69713 6.24345 1.48982 3.84917 2.90423C2.63509 3.65136 1.23914 5.11121 1.85355 6.73818C2.02012 7.14309 2.26576 7.51071 2.5761 7.81955L3.03814 8.30125C2.4139 9.14669 1.95677 9.91348 1.66185 10.9408C0.777095 14.0374 0.924555 16.0281 1.16541 18.5153C1.31778 20.0538 1.82406 22.3443 3.59849 22.5999C5.04359 22.8015 6.61158 22.3247 8.05668 22.1526C9.64925 21.9658 11.2566 21.6709 12.8688 21.7152C15.1397 21.7741 17.3909 22.3099 19.6667 22.3345C20.866 22.3443 22.8616 22.4623 23.2204 20.8796C23.5596 19.3755 23.5744 17.8124 23.5744 16.2788C23.594 16.1166 23.594 15.9495 23.594 15.7922L23.5989 15.7873ZM21.0036 18.3875C20.4384 19.6606 18.8409 19.518 17.7251 19.4246L12.7361 18.8299C11.2516 18.7856 9.78196 19.0658 8.33686 19.3853C7.25549 19.6212 5.74648 20.2455 4.76834 19.4148C3.68205 18.4956 3.49035 16.9276 3.47561 15.6054C3.49602 14.4115 3.61438 13.2213 3.82951 12.0467C3.96222 11.3193 4.1785 10.6115 4.46359 9.93314C4.8519 8.95008 5.42699 8.35532 5.45648 8.38481C5.16648 8.08498 4.81749 7.92277 4.62088 7.5148C3.87866 5.96648 5.73174 4.65409 6.74429 4.20679C10.2882 2.62406 15.2429 2.78135 18.5902 4.81138C19.6323 5.44545 21.6574 7.62294 19.765 8.70922C20.9299 9.25974 21.2297 10.9211 21.3575 12.1008C21.562 13.9955 21.5024 15.9095 21.1806 17.7878C21.1458 17.9947 21.0896 18.1962 21.0036 18.3875Z",
                fill: "#101214"
            })
        ]
    });
};
const $ba4696cf403c7502$export$13c02cb17fc407de = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "103",
        height: "29",
        viewBox: "0 0 103 29",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M29.4863 0.270996L29.6308 22.1619H32.9144V0.270996H29.4863ZM70.1289 0.270996V22.1706H74.0802C74.0802 22.1706 74.113 14.268 74.1568 14.2768C74.2006 14.2768 80.0476 22.4705 80.1002 22.4421C80.1593 22.4267 83.6049 21.1877 83.6049 21.1527C83.6049 21.1264 77.7316 13.62 77.7316 13.6113C77.7316 13.5938 82.657 8.11231 82.6132 8.06852C82.4775 7.94156 79.809 6.78791 79.7324 6.8295C79.6974 6.85577 74.0802 12.9524 74.0802 12.9524V0.270996H70.1289ZM4.6708 6.94771C3.25009 7.24761 1.91693 8.15609 1.36966 9.20685C1.1214 9.71444 0.993808 10.2725 0.996846 10.8376C0.999884 11.4026 1.13347 11.9593 1.38717 12.4642C1.73743 13.1406 2.75535 14.0819 4.33587 15.1918C6.04774 16.4068 6.69571 17.0131 6.85989 17.5867C7.10726 18.4338 6.73073 19.2285 5.90983 19.6225C5.50047 19.8195 5.31877 19.8436 4.592 19.8108C3.64412 19.767 2.99396 19.5262 2.02858 18.8344C1.71992 18.6221 1.43752 18.4667 1.4025 18.5017C1.36966 18.5367 1.061 18.9986 0.719503 19.5284L0.10437 20.4763L0.334224 20.6558C0.472137 20.7499 0.881496 20.9995 1.25802 21.2118C3.85865 22.6566 7.70488 22.4267 9.65535 20.7083C10.1652 20.2713 10.5541 19.7106 10.7849 19.08C11.0156 18.4494 11.0805 17.7701 10.9732 17.1073C10.7849 15.8332 10.0822 14.997 7.87563 13.3968C6.14187 12.1402 5.32096 11.4485 5.1327 11.0807C4.76494 10.3605 5.02106 9.66874 5.79818 9.26595C6.19222 9.06237 6.35421 9.04486 7.13353 9.07769C7.89314 9.10396 8.12518 9.16525 8.75783 9.46297L9.49336 9.82198L10.0647 8.92445C10.3821 8.42972 10.612 7.9919 10.5879 7.95031C10.485 7.79707 9.27883 7.2914 8.52579 7.09657C7.52537 6.8295 5.59241 6.75288 4.6708 6.9499V6.94771ZM22.0368 8.88286C23.7662 9.69283 24.6878 12.2322 24.3135 15.1239C24.1821 16.1506 23.8166 17.3897 23.4751 17.9632C23.1314 18.5542 22.4659 19.1956 21.9339 19.443C20.9598 19.9027 19.515 19.7254 18.6 19.0315C17.3347 18.0661 16.6407 15.6975 16.9056 13.2348C17.1552 10.9778 17.9673 9.54835 19.3858 8.88943C20.1214 8.54793 21.3122 8.54793 22.0368 8.88286ZM20.4629 6.3676C19.4296 6.59965 18.6087 7.06154 17.7199 7.90653L16.9144 8.67709V6.83826H13.2126V28.7291H16.9144V19.802L17.6258 20.4938C18.9239 21.7678 20.4475 22.2823 22.2251 22.0327C23.3875 21.8707 24.2084 21.573 25.0731 20.9907C27.503 19.3664 28.8449 16.1244 28.4771 12.7378C28.1269 9.52426 26.4763 7.30016 23.8144 6.45517C23.1314 6.23188 21.2663 6.1881 20.4629 6.3676ZM35.6683 6.83826C35.6683 6.83826 35.7887 18.4076 35.8653 18.7425C36.163 20.0166 37.0189 21.2293 37.9778 21.7525C38.8578 22.2297 39.567 22.3764 40.8936 22.3764C42.7828 22.3676 43.9277 21.9145 45.3309 20.6229L46.0489 19.9728V22.1619H49.8623L49.812 6.83826H46.0489C46.0489 6.83826 46.0993 16.3564 46.0489 16.6891C45.8256 18.0245 44.7924 19.119 43.7394 19.4693C43.1155 19.6816 42.021 19.8524 41.3621 19.7495C40.6878 19.64 39.5495 18.8957 39.4817 17.7837V6.88861L35.6683 6.83826ZM67.375 22.1619C67.375 22.1619 67.2546 10.5925 67.178 10.2576C66.8803 8.98356 66.0243 7.77081 65.0655 7.24762C64.1855 6.7704 63.4762 6.62373 62.1496 6.62373C60.2605 6.63248 59.1156 7.08562 57.7124 8.37718L56.9944 9.02734V6.83826H53.181L53.2313 22.1619H56.9944C56.9944 22.1619 56.944 12.6437 56.9944 12.311C57.2176 10.9756 58.2509 9.88109 59.3038 9.53083C59.9277 9.31849 60.7486 9.1565 61.6812 9.25063C62.6115 9.35133 63.6295 10.1985 63.5616 11.2164V22.1115L67.375 22.1619Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M87.6399 5.74365V9.02728L100.774 13.4055L87.6399 19.1015V22.1618L102.963 15.5945V11.2164L87.6399 5.74365Z",
                fill: "#101214"
            })
        ]
    });
};
const $ba4696cf403c7502$export$9deaa7e38ca0abdf = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "85",
        height: "25",
        viewBox: "0 0 85 25",
        fill: "none",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M45.0486 23.7095H56.5358C58.2522 23.7095 59.6608 23.0052 60.805 21.5961C61.9053 20.2318 62.4776 18.6035 62.4776 16.7555C62.4776 13.0143 57.6804 10.3735 55.831 10.3735H49.5375C49.0534 10.3735 48.6565 10.1533 48.3491 9.8016C48.0408 9.40515 47.8649 8.9653 47.8649 8.43685C47.8649 7.8207 48.0408 7.2927 48.3491 6.85241C48.7012 6.41255 49.1411 6.14856 49.6695 6.14856H61.465V1.43862H49.4489C47.2922 1.43862 45.6191 2.09907 44.4307 3.37521C43.3751 4.56366 42.8462 6.14811 42.8462 8.04086C42.8462 9.8893 43.3751 11.518 44.4307 12.8376C45.6191 14.29 47.0282 15.0391 48.7446 15.0391H56.0073C56.4467 15.0391 56.7993 15.1711 57.0629 15.5223C57.3712 15.8745 57.5032 16.3148 57.5032 16.7994C57.5032 17.3717 57.283 17.8997 56.9309 18.34C56.5349 18.736 56.0946 18.9561 55.5232 18.9561H43.9036L43.7277 18.6478L39.3704 4.65181L39.1502 4.21151C38.0938 2.05477 36.3335 0.998769 33.9128 0.998769C32.5923 0.998769 31.4039 1.30662 30.3474 1.96706C29.2471 2.62706 28.5428 3.59536 28.1468 4.82811L22.2927 23.6652L27.6184 23.7099L32.9879 6.941C33.1199 6.41256 33.4282 6.14856 33.8242 6.14856C34.0443 6.14856 34.2202 6.23626 34.3522 6.36871C34.4842 6.54456 34.5723 6.72086 34.6162 6.941L40.0295 23.7099L45.0486 23.7095ZM5.43611 8.30485V23.6652H0.50647V6.63226C0.50647 4.43166 1.03492 2.89106 2.17907 1.96706C3.05922 1.30662 4.37966 0.954468 6.22811 0.954468C7.72441 0.954468 9.001 1.39477 10.1452 2.23107C11.2893 3.06736 12.0375 4.21151 12.4339 5.62011L15.6466 16.9314L16.1751 18.472C16.2189 18.7798 16.3952 19 16.5711 19.1754C16.7912 19.3521 17.0109 19.4403 17.2754 19.3521C17.7157 19.3083 17.9358 19.0438 17.9358 18.6478V1.48292H22.9975V18.4277C22.9975 20.3204 22.5576 21.7295 21.6332 22.7416C20.753 23.7538 19.4326 24.2822 17.6718 24.2822C16.1312 24.2822 14.8546 23.9739 13.8425 23.4459C12.6102 22.8298 11.8177 21.8615 11.4656 20.5844L7.76871 7.68871L7.50471 6.85241C7.41656 6.54455 7.24071 6.32441 7.02056 6.10426C6.80041 5.92796 6.53641 5.88411 6.27241 5.92796C6.00841 5.97226 5.83256 6.10426 5.65626 6.36826C5.51155 6.60704 5.43538 6.88105 5.43611 7.16026V8.30485ZM84.2204 23.7095L78.4988 4.65181L78.2786 4.21151C77.2222 2.05477 75.4619 0.998769 73.0411 0.998769C71.7207 0.998769 70.5322 1.30662 69.4762 1.96706C68.375 2.62706 67.6716 3.59536 67.2747 4.82811L61.4211 23.6652L66.7467 23.7099L72.1162 6.941C72.2482 6.41256 72.5565 6.14856 72.9525 6.14856C73.1727 6.14856 73.3485 6.23626 73.4805 6.36871C73.6134 6.54456 73.7007 6.72086 73.7454 6.941L79.1588 23.7099L84.2204 23.7095Z",
            fill: "#101214"
        })
    });
};
const $ba4696cf403c7502$var$testimonialDoodleStyle = null;
const $ba4696cf403c7502$export$72c6ec790fc33a37 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial-doodle-1380981062.webp',
            alt: ''
        },
        className: (0, $2jatx.default)([
            "_1bsb1qr7 _4t3i1tcg"
        ])
    });
};
const $ba4696cf403c7502$var$testimonialRoyalCaribbeanStyle = null;
const $ba4696cf403c7502$export$ea2a07b098c3c428 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial-royal-caribbean-3438806072.webp',
            alt: ''
        },
        className: (0, $2jatx.default)([
            "_1bsbhcro _4t3i1u1b"
        ])
    });
};
const $ba4696cf403c7502$var$testimonialMercedesBenzStyle = null;
const $ba4696cf403c7502$export$3192ac60f265126c = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial-mercedes-benz-2937659039.webp',
            alt: ''
        },
        className: (0, $2jatx.default)([
            "_1bsbwz92 _4t3i1u1b"
        ])
    });
};
const $ba4696cf403c7502$var$testimonialSunLifeStyle = null;
const $ba4696cf403c7502$export$53d258996873a1e3 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonials-sun-life-resize-2840009056.webp',
            alt: ''
        },
        className: (0, $2jatx.default)([
            "_1bsb18cf _4t3i1u1b"
        ])
    });
const $ba4696cf403c7502$var$testimonialUnitedStyle = null;
const $ba4696cf403c7502$export$6a1b58616eb8f4e3 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonials-united-resize-2634290916.webp',
            alt: ''
        },
        className: (0, $2jatx.default)([
            "_1bsb1qr7 _4t3i1u1b"
        ])
    });

});


parcelRegister("kkULZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b44003f57f0b2933$export$2e2bcd8739ae039; });
/* why-confluence-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kNEse = parcelRequire("kNEse");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $6yWka = parcelRequire("6yWka");

var $kbpa7 = parcelRequire("kbpa7");
const $b44003f57f0b2933$var$whyConfluenceSectionStyles = null;
const $b44003f57f0b2933$var$whyBackgroundStyles = null;
const $b44003f57f0b2933$var$relative = null;
const $b44003f57f0b2933$var$whyConfluenceSectionHeaderStyles = null;
const $b44003f57f0b2933$var$infoCardContainerStyles = null;
const $b44003f57f0b2933$var$infoBoxGroup = null;
const $b44003f57f0b2933$var$WhyConfluenceSection = ()=>{
    const intl = (0, $8e22h.default)();
    const infoBoxes1 = [
        {
            infoBoxId: 'versatileContentCreation',
            title: intl.formatMessage((0, $kNEse.whyConfluenceSectioni18n).versatileContentCreationInfoBoxTitle),
            paragraph: intl.formatMessage((0, $kNEse.whyConfluenceSectioni18n).versatileContentCreationInfoBoxParagraph)
        },
        {
            infoBoxId: 'organizationThatScales',
            title: intl.formatMessage((0, $kNEse.whyConfluenceSectioni18n).organizationThatScalesInfoBoxTitle),
            paragraph: intl.formatMessage((0, $kNEse.whyConfluenceSectioni18n).organizationThatScalesInfoBoxParagraph)
        }
    ];
    const infoBoxes2 = [
        {
            infoBoxId: 'powerfulIntegrations',
            title: intl.formatMessage((0, $kNEse.whyConfluenceSectioni18n).powerfulIntegrationsInfoBoxTitle),
            paragraph: intl.formatMessage((0, $kNEse.whyConfluenceSectioni18n).powerfulIntegrationsInfoBoxParagraph)
        },
        {
            infoBoxId: 'dataProtection',
            title: intl.formatMessage((0, $kNEse.whyConfluenceSectioni18n).dataProtectionInfoBoxTitle),
            paragraph: intl.formatMessage((0, $kNEse.whyConfluenceSectioni18n).dataProtectionInfoBoxParagraph)
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-whyConfluenceSection",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
            className: (0, $2jatx.default)([
                "_kqswh2mm _1e0c1txw _2lx21bp4 _4cvr1h6o _1q51ys9h _85i5vbgk _bozg1tcg _y4ti1tcg"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswstnw _mkrz1sm8 _bfhkg7ng _p12f1git _1bsb1osq _1tkekbql _4t3i1osq _152tidpf _h15z5580 _1vth1k1d _tnru1osq"
                    ]),
                    style: {
                        "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
                    }
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _1e0c1txw _2lx21bp4 _4cvr1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                            className: (0, $2jatx.default)([
                                "_1pfhidpf _6rth8vuz _gu181h6o"
                            ]),
                            children: intl.formatMessage((0, $kNEse.whyConfluenceSectioni18n).whyConfluenceSectionHeader)
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _2lx2vrvc _1n261g80 _zulpzwfg _19pkidpf _2hwx1wug _otyridpf _18u01wug _1bsb1osq"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _zulpzwfg _1bah1h6o _1n261g80"
                                    ]),
                                    children: infoBoxes1.map((infoCardProps)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $6yWka.InfoBox), {
                                            ...infoCardProps
                                        }, infoCardProps.infoBoxId))
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _zulpzwfg _1bah1h6o _1n261g80"
                                    ]),
                                    children: infoBoxes2.map((infoCardProps)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $6yWka.InfoBox), {
                                            ...infoCardProps
                                        }, infoCardProps.infoBoxId))
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
$b44003f57f0b2933$var$WhyConfluenceSection.displayName = 'WhyConfluenceSection';
var $b44003f57f0b2933$export$2e2bcd8739ae039 = $b44003f57f0b2933$var$WhyConfluenceSection;

});
parcelRegister("kNEse", function(module, exports) {
$parcel$export(module.exports, "whyConfluenceSectioni18n", function () { return $395e8cc883a0ecbc$export$ab4765e2b00a177e; });

var $fnHPc = parcelRequire("fnHPc");
const $395e8cc883a0ecbc$export$ab4765e2b00a177e = (0, $fnHPc.defineMessages)({
    whyConfluenceSectionHeader: {
        id: 'ConfluenceSoftwarePage.v4.WhyConfluenceSection.Header',
        defaultMessage: 'Why Confluence?'
    },
    versatileContentCreationInfoBoxTitle: {
        id: 'ConfluenceSoftwarePage.v4.WhyConfluenceSection.InfoBox.VersatileContentCreation.Title',
        defaultMessage: 'Versatile content creation'
    },
    versatileContentCreationInfoBoxParagraph: {
        id: 'ConfluenceSoftwarePage.v4.WhyConfluenceSection.InfoBox.VersatileContentCreation.Paragraph',
        defaultMessage: 'Bring your ideas to life with a rich palette of content: Whiteboards, Databases, and videos within every Confluence Page.'
    },
    organizationThatScalesInfoBoxTitle: {
        id: 'ConfluenceSoftwarePage.v4.WhyConfluenceSection.InfoBox.OrganizationThatScales.Title',
        defaultMessage: 'Organization that scales'
    },
    organizationThatScalesInfoBoxParagraph: {
        id: 'ConfluenceSoftwarePage.v4.WhyConfluenceSection.InfoBox.OrganizationThatScales.Paragraph',
        defaultMessage: "You\u2019ll never outgrow Confluence. Project resources and company knowledge stay centralized and discoverable."
    },
    powerfulIntegrationsInfoBoxTitle: {
        id: 'ConfluenceSoftwarePage.v4.WhyConfluenceSection.InfoBox.PowerfulIntegrations.Title',
        defaultMessage: 'Powerful integrations'
    },
    powerfulIntegrationsInfoBoxParagraph: {
        id: 'ConfluenceSoftwarePage.v4.WhyConfluenceSection.InfoBox.PowerfulIntegrations.Paragraph',
        defaultMessage: 'Connect Confluence to thousands of your favorite tools to access data and manage workflows across apps.'
    },
    dataProtectionInfoBoxTitle: {
        id: 'ConfluenceSoftwarePage.v4.WhyConfluenceSection.InfoBox.DataProtection.Title',
        defaultMessage: 'Data protection'
    },
    dataProtectionInfoBoxParagraph: {
        id: 'ConfluenceSoftwarePage.v4.WhyConfluenceSection.InfoBox.DataProtection.Paragraph',
        defaultMessage: 'User-level permissions keep your information private. Company data stays secure and always remains in your control.'
    }
});

});

parcelRegister("6yWka", function(module, exports) {
$parcel$export(module.exports, "InfoBox", function () { return $b4c01eb6d52c7791$export$aff4fc93593c3bcf; });
/* info-box.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $b4c01eb6d52c7791$var$infoBoxContainerStyles = null;
const $b4c01eb6d52c7791$var$imageStyles = null;
const $b4c01eb6d52c7791$var$titleStyles = null;
const $b4c01eb6d52c7791$var$paragraphStyles = null;
const $b4c01eb6d52c7791$export$aff4fc93593c3bcf = ({ imageUrl: imageUrl, imageHeight: imageHeight, imageWidth: imageWidth, containerWidth: containerWidth, title: title, paragraph: paragraph })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        style: {
            width: containerWidth ?? 290
        },
        className: (0, $2jatx.default)([
            "_1e0c1txw _1tke1kr5 _2lx21bp4 _1bah1h6o _4cvr1y6m _1o9zidpf"
        ]),
        children: [
            imageUrl && /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                src: imageUrl,
                alt: title,
                height: imageHeight ? imageHeight : '100%',
                width: imageWidth ? imageWidth : '100%',
                className: (0, $2jatx.default)([
                    "_p12f1osq _6rth19bv"
                ])
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1yt4u2gc _1e0c1txw _2lx2vrvc _4cvrv2br",
                    "h4"
                ]),
                children: title
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_1tke1obz _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1wug _1yt4u2gc"
                ]),
                children: paragraph
            })
        ]
    });
};

});





parcelRegister("WuRB2", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageVariantPaidLpConfFeatures", function () { return $02f5ad054c73b27b$export$8f2e6fd6be55a708; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $cR8Gg = parcelRequire("cR8Gg");

var $2WL8B = parcelRequire("2WL8B");

var $kbpa7 = parcelRequire("kbpa7");

var $5fw4P = parcelRequire("5fw4P");

var $leg8m = parcelRequire("leg8m");

var $bspxF = parcelRequire("bspxF");

var $9H2hw = parcelRequire("9H2hw");

var $hswtB = parcelRequire("hswtB");

var $3LcIp = parcelRequire("3LcIp");

var $l7lLR = parcelRequire("l7lLR");

var $4X0dO = parcelRequire("4X0dO");

var $hZuN8 = parcelRequire("hZuN8");

var $izdHQ = parcelRequire("izdHQ");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $1ka2O = parcelRequire("1ka2O");

var $6gQvZ = parcelRequire("6gQvZ");

var $ik40B = parcelRequire("ik40B");
const $02f5ad054c73b27b$export$8f2e6fd6be55a708 = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $hZuN8.useExperimentExposure)((0, $4X0dO.experiments).cfind4782LandingPageSubAnchorV3);
    // Evaluate condition for Conf BPS with Bandits
    const isLoggedOut = (0, $2WL8B.useLoggedOut)();
    const isEnglishLocale = (0, $6gQvZ.useEnglishLocale)();
    const locationSearch = (0, $1ka2O.useLocation)().search;
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure,
        pageProps.subAnchor
    ]);
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cR8Gg.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const gwp9286ConfluenceAnchorUpdates = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp9286ConfluenceAnchorUpdates);
    const carouselLiftAndShift = [
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.FeaturesSection.start-with-page.title',
                defaultMessage: 'Start with a page'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.FeaturesSection.start-with-page.body',
                defaultMessage: 'Plan projects, take notes, and brainstorm. Let AI write your first draft.'
            }),
            // will fix in separate ticket GWP-4659
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/cs8c8dbwh841g64nad3y8o63fo6peqkv.webp',
            imgAltText: 'A Confluence page being edited'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.FeaturesSection.share-with-teams.title',
                defaultMessage: 'Share with your teams'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.FeaturesSection.share-with-teams.body',
                defaultMessage: 'Invite your teams to collaborate using real-time editing and inline comments.'
            }),
            // will fix in separate ticket GWP-4659
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/63i2v45spmjd7q66mqefep624mf6y20h.webp',
            imgAltText: 'A Confluence page with multiple teammates editing and leaving comments'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.FeaturesSection.connect-work.title',
                defaultMessage: 'Connect all your work'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.FeaturesSection.connect-work.body',
                defaultMessage: 'Stay organized in dedicated workspaces, equipped with AI-powered search.'
            }),
            // will fix in separate ticket GWP-4659
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/o47q33qpw6cp3211df81a3noi34e41ib.webp',
            imgAltText: 'A Confluence page with a summary being generated by Atlassian Intelligence'
        }
    ];
    const carouselSlidesGwp9286Updates = [
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.FeaturesSectionGwp9286Updates.create-more-together.title',
                defaultMessage: 'Create more together'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.FeaturesSectionGwp9286Updates.create-more-together.body',
                defaultMessage: 'Instantly draft and brainstorm with Rovo AI and plan for any project'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/l8pf65qmp34as5x0u4d57k7x7hq82k45/Anchor_Journey_Confluence_Brand_Carousel_1.webp',
            imgAltText: 'Create more together'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.FeaturesSectionGwp9286Updates.collaborate-across-teams.title',
                defaultMessage: 'Collaborate across teams'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.FeaturesSectionGwp9286Updates.collaborate-across-teams.body',
                defaultMessage: 'Move projects forward faster with human-AI collaboration'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/sfr1x0ctcr3k8w56256gb5787tta8s8t/Anchor_Journey_Confluence_Brand_Carousel_2.webp',
            imgAltText: 'Collaborate across teams'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.FeaturesSectionGwp9286Updates.connect-knowledge-from-anywhere.title',
                defaultMessage: 'Connect knowledge from anywhere'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.FeaturesSectionGwp9286Updates.connect-knowledge-from-anywhere.body',
                defaultMessage: 'Get relevant answers across all your tools with AI-powered search'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/krl10r0n7l1x62114173sia1ws136md4/Anchor_Journey_Confluence_Brand_Carousel_3.webp',
            imgAltText: 'Connect knowledge from anywhere'
        }
    ];
    const carouselSlides = gwp9286ConfluenceAnchorUpdates ? carouselSlidesGwp9286Updates : carouselLiftAndShift;
    const showDefault = !shouldShowLogMeIn;
    let customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bspxF.PaidHeroCarousel), {
        pageId: showDefault ? 'confluence-default' : 'paid-lp-conf-features',
        embeddedSignup: {
            bundle: 'confluence'
        },
        carouselSlides: carouselSlides,
        keyword: pageProps.keyword,
        usePlainContainer: gwp9286ConfluenceAnchorUpdates
    });
    if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
        experimentKey: "cfind-2801-get-paid-users-back-to-product",
        group: "Test",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
            confluenceSites: recentSites,
            userProfileName: userProfileName,
            hideExploreMore: true,
            loggedInPaid: true
        })
    });
    const props = {
        customHeroSection: customHeroSection,
        heroProps: {
            headerText: intl.formatMessage({
                id: 'ConfluenceSoftwarePagePaidLpConfFeatures.heroHeader',
                defaultMessage: 'Accomplish more together with Confluence'
            }),
            secondaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePagePaidLpConfFeatures.heroBody',
                defaultMessage: "So many features, so little time \u2014 all built to meet your team\u2019s needs"
            }),
            featuresLabel: intl.formatMessage({
                id: 'ConfluenceSoftwarePagePaidLpConfFeatures.heroListHeading',
                defaultMessage: 'What you get on the free plan:'
            }),
            featuresList: [
                intl.formatMessage({
                    id: 'ConfluenceSoftwarePagePaidLpConfFeatures.heroListItem1',
                    defaultMessage: 'Supports up to 10 users or 3 agents'
                }),
                intl.formatMessage({
                    id: 'ConfluenceSoftwarePagePaidLpConfFeatures.heroListItem2',
                    defaultMessage: 'Includes 2 GB of storage'
                }),
                intl.formatMessage({
                    id: 'ConfluenceSoftwarePagePaidLpConfFeatures.heroListItem3',
                    defaultMessage: 'Offers Community support'
                }),
                intl.formatMessage({
                    id: 'ConfluenceSoftwarePagePaidLpConfFeatures.heroListItem4',
                    defaultMessage: 'Is always free, no credit card needed'
                })
            ],
            signup: {
                bundle: 'confluence',
                edition: 'free'
            }
        },
        tabsProps: {
            dataProductKey: 'confluence-PaidLpConflFeatures',
            headerText: gwp9286ConfluenceAnchorUpdates ? intl.formatMessage({
                id: 'ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.tabsHeader',
                defaultMessage: 'Power every stage of work with Confluence'
            }) : intl.formatMessage({
                id: 'ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.tabsHeader',
                defaultMessage: 'Jump start company-wide collaboration with fewer tools by using Confluence.'
            }),
            tabStyles: {
                // eslint-disable-next-line local/ensure-wac-token-usage
                defaultBG: '#ebecf0',
                // eslint-disable-next-line local/ensure-wac-token-usage
                defaultText: '#42526e',
                // eslint-disable-next-line local/ensure-wac-token-usage
                activeBG: '#0747a6',
                activeText: (0, $kbpa7.wacToken)('color.neutral.light0'),
                // eslint-disable-next-line local/ensure-wac-token-usage
                hoverBG: '#ebecf0',
                // eslint-disable-next-line local/ensure-wac-token-usage
                hoverText: '#42526e'
            },
            styles: {
                '--lp-tabs-hover': '#c1c7d0',
                '--lp-tabs-unselected': '#6b778c'
            },
            tabs: gwp9286ConfluenceAnchorUpdates ? [
                {
                    textLabel: intl.formatMessage({
                        id: 'ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.pill.create',
                        defaultMessage: 'Create'
                    }),
                    id: 'tab-create',
                    component: $02f5ad054c73b27b$var$CreateGwp9286()
                },
                {
                    textLabel: intl.formatMessage({
                        id: 'ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.pill.transform-work',
                        defaultMessage: 'Transform work'
                    }),
                    id: 'tab-transform-work',
                    component: $02f5ad054c73b27b$var$TransformWorkGwp9286()
                },
                {
                    textLabel: intl.formatMessage({
                        id: 'ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.pill.stay-up-to-date',
                        defaultMessage: 'Stay up to date'
                    }),
                    id: 'tab-stay-up-to-date',
                    component: $02f5ad054c73b27b$var$StayUpToDateGwp9286()
                },
                {
                    textLabel: intl.formatMessage({
                        id: 'ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.pill.get-answers',
                        defaultMessage: 'Get answers'
                    }),
                    id: 'tab-get-answers',
                    component: $02f5ad054c73b27b$var$GetAnswersGwp9286()
                }
            ] : [
                {
                    textLabel: intl.formatMessage({
                        id: 'ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.pill.documentation',
                        defaultMessage: 'Documentation'
                    }),
                    id: 'tab-documentation',
                    component: $02f5ad054c73b27b$var$Documentation()
                },
                {
                    textLabel: intl.formatMessage({
                        id: 'ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.pill.collaboration',
                        defaultMessage: 'Collaboration'
                    }),
                    id: 'tab-collaboration',
                    component: $02f5ad054c73b27b$var$Collaboration()
                },
                {
                    textLabel: intl.formatMessage({
                        id: 'ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.pill.truth',
                        defaultMessage: 'Single source of truth'
                    }),
                    id: 'tab-truth',
                    component: $02f5ad054c73b27b$var$Truth()
                },
                {
                    textLabel: intl.formatMessage({
                        id: 'ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.pill.templates',
                        defaultMessage: 'Templates'
                    }),
                    id: 'tab-templates',
                    component: $02f5ad054c73b27b$var$Templates()
                }
            ]
        },
        keyword: pageProps.keyword,
        subAnchor: pageProps.subAnchor
    };
    if (showDefault) props.testimonialProps = undefined;
    const isBanditsEnabled = isLoggedOut && isEnglishLocale && locationSearch.includes('keyword');
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3LcIp.BanditsProvider), {
        product: (0, $l7lLR.BANDITS_PRODUCT).CONFLUENCE,
        isExperimentEnabled: isBanditsEnabled,
        keyword: pageProps.keyword,
        subAnchor: pageProps.subAnchor || '',
        channel: pageProps.utmMedium || 'paid-search',
        utmContent: pageProps.utmContent || '',
        utmCampaign: pageProps.utmCampaign || '',
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9H2hw.PaidLandingConfTemplate), {
            ...props
        })
    });
};
/* GWP-9286 Updated Tabs */ const $02f5ad054c73b27b$var$CreateGwp9286 = ()=>{
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: 'ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.create.heading',
        defaultMessage: 'Put pen to paper without the heavy lifting'
    });
    const listItems = [
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.create.listItem1",
            defaultMessage: "Beat the blank page with AI-powered creation that brings your ideas to life in seconds."
        }, "listItem1"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.create.listItem2",
            defaultMessage: "Start fast with pre-built templates for meeting notes, project plans, retros, and more."
        }, "listItem2"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.create.listItem3",
            defaultMessage: "Articulate your ideas in a variety of content types such as pages, whiteboards, and databases."
        }, "listItem3")
    ];
    const imageSrc = 'https://dam-cdn.atl.orangelogic.com/AssetLink/k71m1n07jgo4dqk526dw11nhw4ia441p/Anchor_Journey_Confluence_Brand_Tab_1.webp';
    const imageAlt = intl.formatMessage({
        id: 'ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.tabsImageAltText.create',
        defaultMessage: 'Create'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $leg8m.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};
const $02f5ad054c73b27b$var$TransformWorkGwp9286 = ()=>{
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: 'ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.transform-work.heading',
        defaultMessage: 'Transform ideas into action'
    });
    const listItems = [
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.transform-work.listItem1",
            defaultMessage: "Turn brainstorms into structured plans with AI that organizes thoughts for you."
        }, "listItem1"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.transform-work.listItem2",
            defaultMessage: "Push work forward with seamlessly integrations with tools like Jira and other 3rd party apps"
        }, "listItem2"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.transform-work.listItem3",
            defaultMessage: "Collaborate with teammates in real-time on flexible content types like whiteboards, pages, and databases."
        }, "listItem3")
    ];
    const imageSrc = 'https://dam-cdn.atl.orangelogic.com/AssetLink/12kbaa12oil2751c30185853j6413vb2/Anchor_Journey_Confluence_Brand_Tab_2.webp';
    const imageAlt = intl.formatMessage({
        id: 'ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.tabsImageAltText.transform-work',
        defaultMessage: 'Transform work'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $leg8m.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};
const $02f5ad054c73b27b$var$StayUpToDateGwp9286 = ()=>{
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: 'ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.stay-up-to-date.heading',
        defaultMessage: 'Stay in the know, your way'
    });
    const listItems = [
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.stay-up-to-date.listItem1",
            defaultMessage: "AI summaries and audio briefings make it quick and easy to stay caught up on all things work."
        }, "listItem1"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.stay-up-to-date.listItem2",
            defaultMessage: "Get notified when content gets updated or when teammates share new information."
        }, "listItem2"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.stay-up-to-date.listItem3",
            defaultMessage: "Stay up to date on work happening across your org with personalized feeds."
        }, "listItem3")
    ];
    const imageSrc = 'https://dam-cdn.atl.orangelogic.com/AssetLink/3u2u80i2k4wnm266fqmtgnemy6d1ljt3/Anchor_Journey_Confluence_Brand_Tab_3.webp';
    const imageAlt = intl.formatMessage({
        id: 'ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.tabsImageAltText.stay-up-to-date',
        defaultMessage: 'Stay up to date'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $leg8m.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};
const $02f5ad054c73b27b$var$GetAnswersGwp9286 = ()=>{
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: 'ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.get-answers.heading',
        defaultMessage: 'Get context and answers in seconds'
    });
    const listItems = [
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.get-answers.listItem1",
            defaultMessage: "Find exactly what you need with AI-powered search that understands context and company jargon."
        }, "listItem1"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.get-answers.listItem2",
            defaultMessage: "Organize work into workspaces that centralize key information and break down siloes."
        }, "listItem2"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.get-answers.listItem3",
            defaultMessage: "Spend less time digging and more time doing with connected knowledge across teams."
        }, "listItem3")
    ];
    const imageSrc = 'https://dam-cdn.atl.orangelogic.com/AssetLink/4648h612p8824q33utwoa73nr08717n5/Anchor_Journey_Confluence_Brand_Tab_4.webp';
    const imageAlt = intl.formatMessage({
        id: 'ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.tabsImageAltText.get-answers',
        defaultMessage: 'Get answers'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $leg8m.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};
/* Tabs */ const $02f5ad054c73b27b$var$Documentation = ()=>{
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: 'ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.tabsHeader.documentation',
        defaultMessage: 'Create better documentation for your teams'
    });
    const listItems = [
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.documentation.listItem1",
            defaultMessage: "Organize pages, attachments, and even spaces with keyword labels \u2014 such as meeting type or project name."
        }, "listItem1"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.documentation.listItem2",
            defaultMessage: "Use the advanced search & page tree to quickly find and label key docs in a well-organized page tree."
        }, "listItem2"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.documentation.listItem3",
            defaultMessage: "Use the Table of Contents macro to help colleagues quickly locate information."
        }, "listItem3")
    ];
    const imageSrc = (0, $5fw4P.getLocalizedImage)('documentation', intl.locale);
    const imageAlt = intl.formatMessage({
        id: 'ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.tabsImageAltText.documentation',
        defaultMessage: 'Documentation'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $leg8m.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};
const $02f5ad054c73b27b$var$Collaboration = ()=>{
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: 'ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.tabsHeader.collaboration',
        defaultMessage: 'Collaborate with teams in real-time'
    });
    const listItems = [
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.collaboration.listItem1",
            defaultMessage: "Co-edit together in real time and publish updates that highlight changes."
        }, "listItem1"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.collaboration.listItem2",
            defaultMessage: "Make it a \u201Cteam effort\u201D with in-line and page comments, likes, and visual elements, such as images, GIFs, and emojis."
        }, "listItem2"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.collaboration.listItem3",
            defaultMessage: "Alert your teammates when you tag them or assign a task so everyone stays on top of progress."
        }, "listItem3")
    ];
    const imageSrc = (0, $5fw4P.getLocalizedImage)('collaboration', intl.locale);
    const imageAlt = intl.formatMessage({
        id: 'ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.tabsImageAltText.collaboration',
        defaultMessage: 'Project collaboration'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $leg8m.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};
const $02f5ad054c73b27b$var$Truth = ()=>{
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: 'ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.tabsHeader.truth',
        defaultMessage: 'Share information between teams'
    });
    const listItems = [
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.truth.listItem1",
            defaultMessage: "Keep employees informed with open access to information they need, but share and protect sensitive content with permission settings."
        }, "listItem1"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.truth.listItem2",
            defaultMessage: "Easily get back to recent spaces, in-progress work, and drafts, and stay updated with activity and popular feeds on your personal \u201Chomepage.\u201D"
        }, "listItem2")
    ];
    const imageSrc = (0, $5fw4P.getLocalizedImage)('truth', intl.locale);
    const imageAlt = intl.formatMessage({
        id: 'ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.tabsImageAltText.truth',
        defaultMessage: 'Program manager hub'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $leg8m.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};
const $02f5ad054c73b27b$var$Templates = ()=>{
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: 'ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.tabsHeader.templates',
        defaultMessage: "There\u2019s a template for that"
    });
    const listItems = [
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.templates.listItem1",
            defaultMessage: "Use best-practices templates, from product roadmaps to marketing plans so you can quickly jump right in."
        }, "listItem1"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.templates.listItem2",
            defaultMessage: "Kickstart the creation stage by spending less time formatting pages and more time getting sh*t done."
        }, "listItem2"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.templates.listItem3",
            defaultMessage: "Start with a blank page or choose from over 75 customizable templates for every team\u2013from strategy and planning docs to reports."
        }, "listItem3")
    ];
    const imageSrc = (0, $5fw4P.getLocalizedImage)('templates', intl.locale);
    const imageAlt = intl.formatMessage({
        id: 'ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.tabsImageAltText.templates',
        defaultMessage: 'Confluence templates'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $leg8m.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};

});
parcelRegister("5fw4P", function(module, exports) {
$parcel$export(module.exports, "getLocalizedImage", function () { return $169ced6c547859d9$export$df12673c228208c7; });
// no localized image for es, ru
const $169ced6c547859d9$var$tabsSectionCollaborationImageMap = {
    de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_de-DE-02.webp',
    fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_fr-FR-02.webp',
    br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_pt-BR-02.webp',
    en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Collaboration.webp',
    ja: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_ja-JP-02.webp'
};
// no localized image for es, ru
const $169ced6c547859d9$var$tabsSectionDocumentationImageMap = {
    de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Documentation_deDE.webp',
    fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Documentation_frFR.webp',
    br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Documentation_ptBR.webp',
    en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Documentation.webp',
    ja: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Documentation_ja-JP.webp'
};
// no localized image for es, ru
const $169ced6c547859d9$var$tabsSectionTemplatesImageMap = {
    de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_de-DE-13.webp',
    fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_fr-FR-13.webp',
    br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_pt-BR-13.webp',
    en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Templates.webp',
    ja: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_ja-JP-13.webp'
};
// no localized image for es, ru
const $169ced6c547859d9$var$tabsSectionTruthImageMap = {
    de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_de-DE-11.webp',
    fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_fr-FR-11.webp',
    br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_pt-BR-11.webp',
    en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_SourceOfTruth.webp',
    ja: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_ja-JP-13.webp'
};
// no localized image for es, ru
const $169ced6c547859d9$var$rowOneImageMap = {
    de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Onboarding-graphic@2x_deDE.webp',
    fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Onboarding-graphic@2x_frFR.webp',
    br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Onboarding-graphic@2x_ptBR.webp',
    en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Onboarding-graphic@2x.webp',
    ja: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Onboarding-graphic@2x_ja-JP.webp'
};
// no localized image for es, ru
const $169ced6c547859d9$var$rowTwoImageMap = {
    de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Development-graphic@2x_deDE.webp',
    fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Development-graphic@2x_frFR.webp',
    br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Development-graphic@2x_ptBR.webp',
    en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Development-graphic@2x.webp',
    ja: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Development-graphic@2x_ja-JP.webp'
};
// no localized image for es, ru
const $169ced6c547859d9$var$rowThreeImageMap = {
    de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Recent-graphic@2x_deDE.webp',
    fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Recent-graphic@2x_frFR.webp',
    br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Recent-graphic@2x_ptBR.webp',
    en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Recent-graphic@2x.webp',
    ja: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Recent-graphic@2x_ja-JP.webp'
};
const $169ced6c547859d9$var$getCorrespondingImageMap = (descriptor)=>{
    switch(descriptor){
        case 'collaboration':
            return $169ced6c547859d9$var$tabsSectionCollaborationImageMap;
        case 'documentation':
            return $169ced6c547859d9$var$tabsSectionDocumentationImageMap;
        case 'row one':
            return $169ced6c547859d9$var$rowOneImageMap;
        case 'row two':
            return $169ced6c547859d9$var$rowTwoImageMap;
        case 'row three':
            return $169ced6c547859d9$var$rowThreeImageMap;
        case 'templates':
            return $169ced6c547859d9$var$tabsSectionTemplatesImageMap;
        case 'truth':
            return $169ced6c547859d9$var$tabsSectionTruthImageMap;
        default:
            throw new Error(`Unknown descriptor: ${descriptor}`);
    }
};
const $169ced6c547859d9$export$df12673c228208c7 = (descriptor, locale)=>{
    const map = $169ced6c547859d9$var$getCorrespondingImageMap(descriptor);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return map[locale] || map['en'];
};

});

parcelRegister("9H2hw", function(module, exports) {
$parcel$export(module.exports, "PaidLandingConfTemplate", function () { return $297747c88b640aa1$export$5c32e5cc9dc425db; });
/* eslint-disable local/ensure-wac-token-usage */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $jQ0cd = parcelRequire("jQ0cd");

var $izdHQ = parcelRequire("izdHQ");

var $28AH4 = parcelRequire("28AH4");

var $5fw4P = parcelRequire("5fw4P");

var $3riD8 = parcelRequire("3riD8");

var $kZQhV = parcelRequire("kZQhV");
const $297747c88b640aa1$export$5c32e5cc9dc425db = (props)=>{
    const intl = (0, $8e22h.default)();
    const userInfo = (0, $3riD8.useLoggedInUser)();
    const { setAnchorLocalStorage: setAnchorLocalStorage } = (0, $28AH4.useAnchorLocalStorage)();
    (0, $1oC0p.useEffect)(()=>{
        const { keyword: keyword, subAnchor: subAnchor } = props;
        const anchorLocalStorage = {};
        if (!!keyword) anchorLocalStorage.keyword = keyword;
        if (!!subAnchor) anchorLocalStorage.subAnchor = subAnchor;
        if (Object.keys(anchorLocalStorage).length > 0) setAnchorLocalStorage(anchorLocalStorage);
    }, [
        props.keyword
    ]);
    const embeddedSignup = !userInfo.isUserLoggedIn && !userInfo.requestInProgress ? {
        bundle: 'confluence',
        edition: 'free',
        useCurrentRedirect: true
    } : undefined;
    (0, $izdHQ.useFeatureExposed)('cfind-1254-paid-embedded-signup-form', 'Test', {
        conditions: [
            !!embeddedSignup
        ]
    });
    const finalProps = {
        landingType: 'confluence-paid',
        productNavProps: {
            productHref: (0, $jQ0cd.useLocalizedHref)('/software/confluence'),
            productName: 'confluence',
            ariaLabel: intl.formatMessage({
                id: 'wacConfluenceNavigation.logo-label',
                defaultMessage: 'Confluence logo'
            }),
            dataProductKey: 'confluence',
            showFreeHrefButton: false
        },
        alternatingTextAndImageProps: {
            backgroundColor: '#e6fcff',
            horizontalRuleColor: '#dfe1e5',
            //Row 1
            rowOneHeader: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.paidLpConfDefault.alternatingTextAndImage.rowOneHeader',
                defaultMessage: 'Move work forward'
            }),
            rowOneBody: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.paidLpConfDefault.alternatingTextAndImage.rowOneBody',
                defaultMessage: "Kickstart collaboration with a flexible workspace \u2014 from actionable meeting notes to inspiring project plans."
            }),
            rowOneImageLink: (0, $5fw4P.getLocalizedImage)('row one', intl.locale),
            rowOneImageAltText: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.paidLpConfDefault.alternatingTextAndImage.rowOneImageAltText',
                defaultMessage: 'Screenshot of IT template'
            }),
            //Row 2
            rowTwoHeader: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.paidLpConfDefault.alternatingTextAndImage.rowTwoHeader',
                defaultMessage: 'Capture all the knowledge'
            }),
            rowTwoBody: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.paidLpConfDefault.alternatingTextAndImage.rowTwoBody',
                defaultMessage: "Save everyone time by harnessing your teams' collective knowledge into easy-to-find information."
            }),
            rowTwoImageLink: (0, $5fw4P.getLocalizedImage)('row two', intl.locale),
            rowTwoImageAltText: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.paidLpConfDefault.alternatingTextAndImage.rowTwoImageAltText',
                defaultMessage: 'Screenshot of strategic template in use'
            }),
            //Row 3
            rowThreeHeader: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.paidLpConfDefault.alternatingTextAndImage.rowThreeHeader',
                defaultMessage: 'Inspire conversation & connection'
            }),
            rowThreeBody: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.paidLpConfDefault.alternatingTextAndImage.rowThreeBody',
                defaultMessage: 'Motivate teams company-wide to share announcements, comment, and provide feedback.'
            }),
            rowThreeImageLink: (0, $5fw4P.getLocalizedImage)('row three', intl.locale),
            rowThreeImageAltText: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.paidLpConfDefault.alternatingTextAndImage.rowThreeImageAltText',
                defaultMessage: 'Screenshot of IT template'
            })
        },
        ctaProps: {
            headerText: intl.formatMessage({
                id: 'ConfluenceSoftwarePage.paidLpConfDefault.ctaSection.title',
                defaultMessage: 'Make quick decisions, gain alignment, and transform how your team works together.'
            }),
            ctaProps: {
                buttonProps: {
                    color: 'yellow',
                    url: '#start-trial',
                    text: intl.formatMessage({
                        id: 'ConfluenceSoftwarePage.paidLpConfDefault.ctaSection.button',
                        defaultMessage: 'Get it free'
                    }),
                    dataEventProps: {
                        'data-event': 'clicked',
                        'data-event-container': 'ctaSection',
                        'data-event-component': 'linkButton',
                        'data-product-key': 'confluence'
                    }
                }
            }
        },
        testimonialProps: {
            headerText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.paidLpConfDefault.customerSection.customersUseConfluenceToMoveWorkForward',
                defaultMessage: '75,000+ customers use Confluence to move work forward.'
            }),
            logoSize: 'large',
            logos: [
                {
                    src: 'https://wac-cdn.atlassian.com/dam/jcr:b12e4075-84f4-467e-9acf-f062c8fdaece/twilio-n50.svg',
                    alt: intl.formatMessage({
                        id: 'ConfluenceSoftwarePage.paidLpConfDefault.customerSection.imgAltText.twilio',
                        defaultMessage: 'Twilio logo'
                    }),
                    width: '107px',
                    height: '32px',
                    loading: 'lazy'
                },
                {
                    src: 'https://wac-cdn.atlassian.com/dam/jcr:35c6a74c-a259-4dac-8df8-ea8c5b12f44d/nasa-n50.svg',
                    alt: intl.formatMessage({
                        id: 'ConfluenceSoftwarePage.paidLpConfDefault.customerSection.imgAltText.nasa',
                        defaultMessage: 'NASA logo'
                    }),
                    width: '71px',
                    height: '60px',
                    loading: 'lazy'
                },
                {
                    src: 'https://wac-cdn.atlassian.com/dam/jcr:5a1e47e3-be98-4279-a3a2-c626164dbd5d/illumina-n50.svg',
                    alt: intl.formatMessage({
                        id: 'ConfluenceSoftwarePage.paidLpConfDefault.customerSection.imgAltText.illumina',
                        defaultMessage: 'Illumina logo'
                    }),
                    width: '100px',
                    height: '24px',
                    loading: 'lazy'
                },
                {
                    src: 'https://wac-cdn.atlassian.com/dam/jcr:731482d9-54c4-48e7-a10b-ab601ca4fbd6/docker-n50.svg',
                    alt: intl.formatMessage({
                        id: 'ConfluenceSoftwarePage.paidLpConfDefault.customerSection.imgAltText.docker',
                        defaultMessage: 'Docker logo'
                    }),
                    width: '126px',
                    height: '33px',
                    loading: 'lazy'
                },
                {
                    src: 'https://wac-cdn.atlassian.com/dam/jcr:7343b372-8a2a-4156-8755-bcf38735ca6b/morningstar-n50.svg',
                    alt: intl.formatMessage({
                        id: 'ConfluenceSoftwarePage.paidLpConfDefault.customerSection.imgAltText.morningStart',
                        defaultMessage: 'MorningStart logo'
                    }),
                    width: '134px',
                    height: '30px',
                    loading: 'lazy'
                },
                {
                    src: 'https://wac-cdn.atlassian.com/dam/jcr:c67f93d6-d8be-4970-b4f5-addf24c13e4e/rtr-n50.svg',
                    alt: intl.formatMessage({
                        id: 'ConfluenceSoftwarePage.paidLpConfDefault.customerSection.imgAltText.rtr',
                        defaultMessage: 'RTR logo'
                    }),
                    width: '43.71px',
                    height: '60px',
                    loading: 'lazy'
                },
                {
                    src: 'https://wac-cdn.atlassian.com/dam/jcr:b62031f5-0770-46cb-a1c2-50cdacb8a0b0/anz-n50.svg',
                    alt: intl.formatMessage({
                        id: 'ConfluenceSoftwarePage.paidLpConfDefault.customerSection.imgAltText.anz',
                        defaultMessage: 'ANZ logo'
                    }),
                    width: '102px',
                    height: '32px',
                    loading: 'lazy'
                },
                {
                    src: 'https://wac-cdn.atlassian.com/dam/jcr:475f41d8-45f4-48c9-a9b2-d78215ae4b16/nyt-n50.svg',
                    alt: intl.formatMessage({
                        id: 'ConfluenceSoftwarePage.paidLpConfDefault.customerSection.imgAltText.theNewYorkTimes',
                        defaultMessage: 'The New York Times logo'
                    }),
                    width: '223px',
                    height: '32px',
                    loading: 'lazy'
                },
                {
                    src: 'https://wac-cdn.atlassian.com/dam/jcr:6841df63-0c84-4075-9ac5-1ed0f8ddea17/gopro-n50.svg',
                    alt: intl.formatMessage({
                        id: 'ConfluenceSoftwarePage.paidLpConfDefault.customerSection.imgAltText.goPro',
                        defaultMessage: 'GoPro logo'
                    }),
                    width: '110px',
                    height: '35px',
                    loading: 'lazy'
                }
            ]
        },
        ...props,
        heroProps: {
            ...props.heroProps,
            embeddedSignup: embeddedSignup
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kZQhV.PaidLandingTemplate), {
        ...finalProps
    });
};

});


parcelRegister("8KaV5", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageVariantPaidLpConfKeywords", function () { return $7f70b95c93835cc1$export$bdb004359ea2e77b; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $f3gS9 = parcelRequire("f3gS9");

var $k6PTJ = parcelRequire("k6PTJ");

var $4X0dO = parcelRequire("4X0dO");

var $hZuN8 = parcelRequire("hZuN8");

var $izdHQ = parcelRequire("izdHQ");

var $cqCPq = parcelRequire("cqCPq");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $7f70b95c93835cc1$export$bdb004359ea2e77b = (pageProps)=>{
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $hZuN8.useExperimentExposure)((0, $4X0dO.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
        experimentKey: "cfind-2260-nbps-paid-anchor-journey",
        group: "Test",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), {
            ...pageProps,
            pageId: (0, $cqCPq.getPageId)(pageProps.keyword),
            persona: 'unknown',
            pageVariant: "keywords",
            dataProductKey: "confluence-PaidLpConflKeywords"
        })
    });
};

});

parcelRegister("jToCF", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageVariantPaidLpConfSubAnchors", function () { return $17e66f2f4b4e1fa2$export$5bd0bf292ae6f984; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $f3gS9 = parcelRequire("f3gS9");

var $k6PTJ = parcelRequire("k6PTJ");

var $4X0dO = parcelRequire("4X0dO");

var $hZuN8 = parcelRequire("hZuN8");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $17e66f2f4b4e1fa2$export$5bd0bf292ae6f984 = (pageProps)=>{
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $hZuN8.useExperimentExposure)((0, $4X0dO.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if (!exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), {
        ...pageProps,
        pageId: (0, $ik40B.getPageId)(pageProps.subAnchor),
        persona: 'unknown',
        pageVariant: "subAnchor",
        dataProductKey: "confluence-PaidLpConflSubAnchor"
    });
};

});

parcelRegister("4FLZc", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageVariantPaidLpConflDocumentation", function () { return $679cd8dcae2a792a$export$2a2456203daa2a03; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");

var $k6PTJ = parcelRequire("k6PTJ");

var $cR8Gg = parcelRequire("cR8Gg");

var $bspxF = parcelRequire("bspxF");

var $hswtB = parcelRequire("hswtB");

var $3LcIp = parcelRequire("3LcIp");

var $l7lLR = parcelRequire("l7lLR");

var $4X0dO = parcelRequire("4X0dO");

var $hZuN8 = parcelRequire("hZuN8");

var $izdHQ = parcelRequire("izdHQ");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $679cd8dcae2a792a$export$2a2456203daa2a03 = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $hZuN8.useExperimentExposure)((0, $4X0dO.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure,
        pageProps.subAnchor
    ]);
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cR8Gg.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const gwp9286ConfluenceAnchorUpdates = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp9286ConfluenceAnchorUpdates);
    const carouselSlidesLiftAndShift = [
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Documentation.dynamic-documentation.title',
                defaultMessage: 'Dynamic documentation'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Documentation.dynamic-documentation.body',
                defaultMessage: "Plan projects, take notes, and keep track of changes \u2013 all in one place."
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp',
            imgAltText: 'A Confluence page being edited'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Documentation.save-time-repeat-less.title',
                defaultMessage: 'Save time, repeat less'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Documentation.save-time-repeat-less.body',
                defaultMessage: 'Scale the production of documentation for faster project delivery.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/033m853kq4f084xpcj7g6l0u2da8thu4.webp',
            imgAltText: 'Start a Page with a Confluence Template'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Documentation.centralize-knowledge.title',
                defaultMessage: 'Centralize knowledge'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Documentation.centralize-knowledge.body',
                defaultMessage: 'Stay organized and find what you need with dedicated team workspaces.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp',
            imgAltText: 'Organized workspace in Confluence'
        }
    ];
    const carouselSlidesGwp9286Updates = [
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.DocumentationGwp9286Updates.create-faster.title',
                defaultMessage: 'Create faster'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.DocumentationGwp9286Updates.create-faster.body',
                defaultMessage: 'Turns ideas, notes, or outlines into clear documentation in seconds with AI.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/px480pk16cki2886ch46saty0405glgc/Anchor_Journey_Confluence_Documentation_Carousel_1.webp',
            imgAltText: 'Screenshots of messy notes turned into a Formatted page'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.DocumentationGwp9286Updates.centralize-knowledge.title',
                defaultMessage: 'Centralize knowledge'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.DocumentationGwp9286Updates.centralize-knowledge.body',
                defaultMessage: 'Build a single source of truth with team workspaces that keep documentation organized and accessible.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/rrukx4q7x2olk6o6w5e577pxf2bha32q/Anchor_Journey_Confluence_Documentation_Carousel_2.webp',
            imgAltText: 'Team space overview page with content tree visible'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.DocumentationGwp9286Updates.stay-up-to-date.title',
                defaultMessage: 'Stay up to date'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.DocumentationGwp9286Updates.stay-up-to-date.body',
                defaultMessage: 'Get AI summaries of changes, comments, and updates to keep everyone aligned on the latest.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/31iyaw5g2v083bs67h44un3pswa35o3i/Anchor_Journey_Confluence_Documentation_Carousel_3.webp',
            imgAltText: 'Screenshot showing AI Summary of a page'
        }
    ];
    const carouselSlides = gwp9286ConfluenceAnchorUpdates ? carouselSlidesGwp9286Updates : carouselSlidesLiftAndShift;
    const carouselHeroProps = {
        'aria-label': 'A display of various confluence features',
        id: 'confluence-documentation-carousel',
        slides: carouselSlides,
        usePlainContainer: gwp9286ConfluenceAnchorUpdates
    };
    const pageId = 'paid-lp-confl-documentation';
    const isLoggedIn = !!userProfileName;
    let customHeroSection;
    const getLiftShiftHeroSectionBrandUpdate = ()=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bspxF.PaidHeroCarousel), {
            pageId: pageId,
            embeddedSignup: {
                bundle: 'confluence'
            },
            carouselSlides: carouselSlides,
            shouldUseNewBrandBackground: true,
            shouldUseTransparentBackground: true,
            usePlainContainer: gwp9286ConfluenceAnchorUpdates
        });
    };
    if (isLoggedIn) {
        if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
            experimentKey: "cfind-2801-get-paid-users-back-to-product",
            group: "Test",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
                confluenceSites: recentSites,
                userProfileName: userProfileName,
                hideExploreMore: true,
                loggedInPaid: true
            })
        });
        else customHeroSection = getLiftShiftHeroSectionBrandUpdate();
    } else // Logged out user
    customHeroSection = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3LcIp.BanditsProvider), {
        product: (0, $l7lLR.BANDITS_PRODUCT).CONFLUENCE,
        keyword: pageProps.keyword,
        isExperimentEnabled: true,
        useCase: (0, $l7lLR.BANDITS_USE_CASE).ANCHOR_JOURNEY_SUB_ANCHOR,
        subAnchor: pageProps.subAnchor || '',
        channel: pageProps.utmMedium || 'paid-search',
        utmContent: pageProps.utmContent || '',
        utmCampaign: pageProps.utmCampaign || '',
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
            experimentKey: "cfind-3090-paid-confluence-product-tour",
            group: "Test",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), {
                ...pageProps,
                pageId: pageId,
                persona: 'unknown',
                pageVariant: "brandUpdate",
                dataProductKey: "confluence-PaidLpConflDocumentation",
                keyword: pageProps.keyword,
                carouselHeroProps: carouselHeroProps,
                customHeroSection: customHeroSection
            })
        })
    });
};

});

parcelRegister("imhoT", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageVariantPaidLpConflTemplate", function () { return $ee2fe640b2b64bb2$export$e1067e28e1b2acea; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");

var $k6PTJ = parcelRequire("k6PTJ");

var $cR8Gg = parcelRequire("cR8Gg");

var $bspxF = parcelRequire("bspxF");

var $hswtB = parcelRequire("hswtB");

var $3LcIp = parcelRequire("3LcIp");

var $l7lLR = parcelRequire("l7lLR");

var $4X0dO = parcelRequire("4X0dO");

var $hZuN8 = parcelRequire("hZuN8");

var $izdHQ = parcelRequire("izdHQ");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $ee2fe640b2b64bb2$export$e1067e28e1b2acea = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $hZuN8.useExperimentExposure)((0, $4X0dO.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cR8Gg.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Template.start-with-a-page.title',
                defaultMessage: 'Start with a page'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Template.start-with-a-page.body',
                defaultMessage: 'Plan projects, take notes, and brainstorm. Get started with a template.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/033m853kq4f084xpcj7g6l0u2da8thu4.webp',
            imgAltText: 'Start a Page with a Confluence Template'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Template.share-with-your-teams.title',
                defaultMessage: 'Share with your teams'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Template.share-with-your-teams.body',
                defaultMessage: 'Invite your teams to collaborate using real-time editing and inline comments.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/i0011ky0775062fk18784clr4dcxd5wg.webp',
            imgAltText: 'A Confluence page with multiple teammates editing and leaving comments'
        },
        {
            primaryText: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Template.connect-all-your-work.title',
                defaultMessage: 'Connect all your work'
            }),
            description: intl.formatMessage({
                id: 'ConfluenceSoftwarePageTemplate.Template.connect-all-your-work.body',
                defaultMessage: 'Stay organized and find what you need with dedicated team workspaces.'
            }),
            imgSrc: 'https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp',
            imgAltText: 'Organized workspace in Confluence'
        }
    ];
    const carouselHeroProps = {
        'aria-label': 'A display of various confluence features',
        id: 'confluence-template-carousel',
        slides: carouselSlides
    };
    const pageId = 'paid-lp-confl-template';
    const isLoggedIn = !!userProfileName;
    let customHeroSection;
    const getLiftShiftHeroSectionBrandUpdate = ()=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bspxF.PaidHeroCarousel), {
            pageId: pageId,
            embeddedSignup: {
                bundle: 'confluence'
            },
            carouselSlides: carouselSlides,
            shouldUseNewBrandBackground: true,
            shouldUseTransparentBackground: true
        });
    };
    if (isLoggedIn) {
        if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
            experimentKey: "cfind-2801-get-paid-users-back-to-product",
            group: "Test",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
                confluenceSites: recentSites,
                userProfileName: userProfileName,
                hideExploreMore: true,
                loggedInPaid: true
            })
        });
        else customHeroSection = getLiftShiftHeroSectionBrandUpdate();
    } else // Logged out user
    customHeroSection = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3LcIp.BanditsProvider), {
        product: (0, $l7lLR.BANDITS_PRODUCT).CONFLUENCE,
        keyword: pageProps.keyword,
        isExperimentEnabled: true,
        useCase: (0, $l7lLR.BANDITS_USE_CASE).ANCHOR_JOURNEY_SUB_ANCHOR,
        subAnchor: pageProps.subAnchor || '',
        channel: pageProps.utmMedium || 'paid-search',
        utmContent: pageProps.utmContent || '',
        utmCampaign: pageProps.utmCampaign || '',
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
            experimentKey: "cfind-3090-paid-confluence-product-tour",
            group: "Test",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), {
                ...pageProps,
                pageId: pageId,
                persona: 'unknown',
                pageVariant: "brandUpdate",
                dataProductKey: "confluence-PaidLpConflTemplate",
                keyword: pageProps.keyword,
                carouselHeroProps: carouselHeroProps,
                customHeroSection: customHeroSection
            })
        })
    });
};

});

parcelRegister("jYywI", function(module, exports) {
$parcel$export(module.exports, "ConfluenceFreePage", function () { return $3e100e14641888aa$export$5c727b1e47c0f85c; });

var $jQ0cd = parcelRequire("jQ0cd");
const $3e100e14641888aa$export$5c727b1e47c0f85c = ()=>{
    const signupPath = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup');
    location.href = `${signupPath}?bundle=confluence&edition=free`;
    return null;
};

});

parcelRegister("30s1N", function(module, exports) {
$parcel$export(module.exports, "ConfluencePricingPage", function () { return $de7d821157dc63ae$export$6bdd18cae91b5a8; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $3L8ZR = parcelRequire("3L8ZR");

var $20OkY = parcelRequire("20OkY");

var $1rObi = parcelRequire("1rObi");

var $dl2JF = parcelRequire("dl2JF");

var $bTseT = parcelRequire("bTseT");

var $8geYQ = parcelRequire("8geYQ");

var $4X0dO = parcelRequire("4X0dO");

var $hZuN8 = parcelRequire("hZuN8");
const $de7d821157dc63ae$export$6bdd18cae91b5a8 = ({ pricing: pricing, countryCode: countryCode, pricingContent: pricingContent, queryRef: queryRef })=>{
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom = (0, $3L8ZR.default).checkGate('gwp-737-enable-intercom-chat-confluence');
    const [hasFired, fireExposure] = (0, $hZuN8.useExperimentExposure)((0, $4X0dO.experiments).confluencePricingPageWaeMigration);
    (0, $1oC0p.useEffect)(()=>{
        if (!hasFired) fireExposure();
    }, [
        hasFired,
        fireExposure
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bTseT.IntercomProvider), {
        appId: 'p0ww63i2',
        triggerBoot: isBootIntercom,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rObi.CrossFlowTouchpointProvider), {
            productKeys: [
                (0, $20OkY.ProductKeys).CONFLUENCE
            ],
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dl2JF.PricingContentContextProviderRelay), {
                productId: "confluence",
                pricingContent: pricingContent,
                queryRef: queryRef,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8geYQ.ConfluencePricingPageV2Template), {
                    pricing: pricing,
                    countryCode: countryCode
                })
            })
        })
    });
};

});
parcelRegister("8geYQ", function(module, exports) {
$parcel$export(module.exports, "ConfluencePricingPageV2Template", function () { return $1a10b84a25e4b863$export$d4dd4cff5718a25c; });

var $7VQPk = parcelRequire("7VQPk");

var $in5fb = parcelRequire("in5fb");

var $kIC93 = parcelRequire("kIC93");

var $7aKDf = parcelRequire("7aKDf");

var $dl2JF = parcelRequire("dl2JF");

var $bE8d4 = parcelRequire("bE8d4");

var $2zOxm = parcelRequire("2zOxm");

var $6Px6U = parcelRequire("6Px6U");

var $grcEk = parcelRequire("grcEk");

var $frz5c = parcelRequire("frz5c");

var $hCHU3 = parcelRequire("hCHU3");

var $5S2vX = parcelRequire("5S2vX");

var $cxuID = parcelRequire("cxuID");
const $1a10b84a25e4b863$export$d4dd4cff5718a25c = (props)=>{
    const content = (0, $dl2JF.usePricingContentContext)();
    const featuresCtaContent = content?.callToActionContainer?.[1];
    const dataCenterContent = (0, $dl2JF.useDatacenterPlans)('Contact Us', 'Learn more');
    const questionsCtaContent = content?.callToActionContainer?.[0];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
        nav: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hCHU3.default), {}),
        showFallback: content?.hasError,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
            scrollTrackingEnabled: true,
            pageId: "confluence-pricing-page",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6Px6U.PageHeading), {
                    children: content?.headline
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cxuID.default), {
                    pricing: props.pricing,
                    countryCode: props.countryCode
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aKDf.PricingFeatureTable), {
                    title: content?.compareFeaturesTitle ?? undefined,
                    comparePlans: content?.comparePlans ?? undefined,
                    compareFeatures: content?.compareFeatures ?? undefined,
                    linkValues: {
                        linkText: featuresCtaContent?.text ?? undefined,
                        linkHref: featuresCtaContent?.url ?? undefined
                    },
                    dataProductKey: 'confluence'
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $in5fb.DataCenterPromoCard), {
                    dataCenterContent: dataCenterContent
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kIC93.TwcPromo), {
                    product: "confluence"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2zOxm.QuotationsAdornment), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bE8d4.PricingFaq), {
                            header: content?.getMoreDetailsTitle ?? undefined,
                            planDetails: content?.additionalDetails ?? undefined
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $frz5c.QuestionsCta), {
                    product: 'Confluence',
                    ctaHref: questionsCtaContent?.url ?? undefined,
                    questionsHeader: questionsCtaContent?.title ?? undefined,
                    priceAndLicensingLinkText: questionsCtaContent?.text ?? undefined,
                    questionsBody: questionsCtaContent?.valueProposition ?? undefined,
                    imageHref: questionsCtaContent?.asset?.url
                })
            ]
        })
    });
};

});
parcelRegister("in5fb", function(module, exports) {
$parcel$export(module.exports, "DataCenterPromoCard", function () { return $a35fac25401ec131$export$3e66a33f1e68491c; });
/* data-center-promo-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $NtjLk = parcelRequire("NtjLk");
const $a35fac25401ec131$export$3e66a33f1e68491c = ({ dataCenterContent: dataCenterContent })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_1bsbauwl _1pfh1ejb"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $NtjLk.Card), {
            orientation: "horizontal",
            columns: 10,
            title: dataCenterContent.title,
            body: dataCenterContent.description,
            callToAction: {
                text: 'Learn more',
                href: '/enterprise/data-center'
            },
            // eslint-disable-next-line local/no-non-orangelogic-images-eslint
            spotIllustration: {
                src: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Illo_DataCenter.svg'
            }
        })
    });
};

});
parcelRegister("NtjLk", function(module, exports) {
$parcel$export(module.exports, "Card", function () { return $2da6ff99551ef1ce$export$60332b2344f7fe41; });
/* card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $cNOwN = parcelRequire("cNOwN");

var $5kbMC = parcelRequire("5kbMC");

var $FapDU = parcelRequire("FapDU");

var $hnmMQ = parcelRequire("hnmMQ");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");

var $8cYSw = parcelRequire("8cYSw");

var $21L8z = parcelRequire("21L8z");

var $eOIix = parcelRequire("eOIix");

var $6iX8D = parcelRequire("6iX8D");

var $iPPTB = parcelRequire("iPPTB");
const $2da6ff99551ef1ce$export$3c868f5963107f89 = {
    atlassian: 'https://dam-cdn.atl.orangelogic.com/AssetLink/25o68v5s8lr856c06p606q47s76rs10f.svg',
    guard: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8j5d41rmb7q4himg4r42k3e84hvoo07i.svg'
};
const $2da6ff99551ef1ce$export$60332b2344f7fe41 = ({ align: align = 'start', orientation: // we currently do not support a horizontal orientation card with an image
// the outstanding issue is that the the image has a requirement of an aspect ratio of 16:9
// and the card text is unbounded (so prioritizing the image would make the text potentially
// overflow), and prioritizing the text would make the image potentially have undesired
// white space at the end
orientation = 'vertical', columns: columns, background: background = 'light', eyebrow: eyebrow, logo: logo, title: title, body: body, image: image, imageAspectRatio: imageAspectRatio = '16 / 9', icon: icon, icons: icons, callToAction: callToAction, spotIllustration: spotIllustration, videoSrc: videoSrc, ...props })=>{
    // hedge against the value being passed in as a string (the options in uniform can only be string values)
    // which would subsequently fail a string vs number check ie 10 === "10" is false
    const numColumns = Number(columns);
    const { titleAs: TitleComponent = 'h3', containerType: Container = 'div' } = props;
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    const isDark = background === 'dark' || isDarkTheme;
    const isLinkableCard = !!callToAction;
    const cardIcons = icons?.length ? icons : icon ? [
        icon
    ] : [];
    // React's useId() returns strings like ":R0:" which contain colons — colons are valid
    // in HTML id attributes but invalid in CSS id selectors without escaping. Compiled CSS
    // generates :has() selectors that reference elements by their id, and jsdom's nwsapi
    // cannot parse unescaped colons in generated selectors. Sanitize by replacing colons
    // with hyphens to produce CSS-safe ids like "-R0-".
    const uniqueId = (0, $1oC0p.useId)().replace(/:/g, '-');
    const titleId = `card-title-${uniqueId}`;
    const callToActionId = `card-cta-${uniqueId}`;
    const [isVideoOverlayOpen, setIsVideoOverlayOpen] = (0, $1oC0p.useState)(false);
    const bodyElement = typeof body === 'string' ? /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        className: (0, $2jatx.default)([
            "_19pkgrf3 _2hwxgrf3 _otyrgrf3 _18u0grf3"
        ]),
        children: body
    }) : body;
    const openVideoOverlay = (event)=>{
        event.preventDefault();
        setIsVideoOverlayOpen(true);
    };
    const videoOverlay = videoSrc ? isVideoOverlayOpen && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5kbMC.default), {
        onClose: ()=>setIsVideoOverlayOpen(false),
        label: typeof title === 'string' ? title : callToAction?.text,
        width: "x-large",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6iX8D.EmbeddedVideo), {
                    embedUrl: videoSrc,
                    title: typeof title === 'string' ? title : callToAction?.text,
                    autoPlay: true
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                    type: "button",
                    onClick: ()=>setIsVideoOverlayOpen(false),
                    className: (0, $2jatx.default)([
                        "_4cvr1h6o _11q7vkha _19itidpf _2rko1ssb _syaz1afi _80omtlke _1e0c1txw _152tu2gc _rjxpu2gc _1yt412x7 _kqswstnw _1pbykb7n _1ygb14ak _1ah3yh40"
                    ]),
                    style: {
                        "--_1mehvmr": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark200')),
                        "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cNOwN))), {
                            label: "",
                            color: "currentColor"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $FapDU.default), {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "card.video.close",
                                defaultMessage: "Close video"
                            })
                        })
                    ]
                })
            ]
        })
    }) : null;
    const card = /*#__PURE__*/ (0, $7VQPk.jsxs)(Container, {
        className: (0, $2jatx.default)([
            "_2rko1ylz _1e0c1txw _yyhy10md",
            align === 'center' && "_4cvr1h6o _y3gn1h6o",
            isDark ? "_11q7vkha _19itxb7o _1qgo1afi _q3s11afi" : "_11q71afi _19itkze7 _1qgo1pfd _q3s11pfd",
            orientation === 'vertical' && "_2lx21bp4",
            orientation === 'horizontal' && "_2lx2vrvc _4t3i1osq _1bsb1osq _14q21bp4",
            isLinkableCard && "_kqswh2mm _13whb3bt _ykcxidpf _1heustnw _1w8ikb7n _1piy1vf8 _q7ne1vf8",
            isLinkableCard && !isDark && "_v564mnji _1ni61kw8 _a7on1kw8 _clok130s _1v69130s"
        ]),
        style: {
            "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
            "--_1mehvmr": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark200')),
            "--_19gw9o2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark100')),
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400')),
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
        },
        children: [
            spotIllustration ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1pfhxy5q _ahbqxy5q _12l2xy5q _6rthu2gc",
                    orientation === 'horizontal' && "_12l2u2gc _1ob9xy5q",
                    "spotIllustrationContainer"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: spotIllustration.src,
                    alt: spotIllustration.alt ?? '',
                    style: {
                        height: spotIllustration.height ?? (orientation === 'vertical' ? (0, $21L8z.SPOT_ILLUSTRATION_MAX_HEIGHT) : 'auto'),
                        maxHeight: orientation === 'vertical' ? (0, $21L8z.SPOT_ILLUSTRATION_MAX_HEIGHT) : 'auto',
                        width: orientation === 'horizontal' && !spotIllustration.height ? (0, $21L8z.SPOT_ILLUSTRATION_WIDTH_ON_HORIZONTAL_CARD) : 'auto',
                        maxWidth: orientation === 'horizontal' && spotIllustration.height ? 'auto' : '100%'
                    }
                })
            }) : image && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1reozryt _18m9zryt _1e0c1txw _1bah1h6o _4cvr1h6o",
                    orientation === 'vertical' && "_1s1g1ylz _5fbc1ylz _1o9zidpf _kqswh2mm _1bsb1osq",
                    orientation === 'vertical' && imageAspectRatio === '1 / 1' && "_1h1t1ekt",
                    orientation === 'vertical' && imageAspectRatio !== '1 / 1' && "_1h1tcq2i",
                    orientation === 'horizontal' && "_1s1g1ylz _1yxn1ylz _4t3i1osq _1bsb1osq _1e0c1txw",
                    videoSrc && "_kqswh2mm _1hfkvkha _aetrb3bt _9v7aidpf _1peqnh7s _11fnglyw _18postnw",
                    `cardImageContainer${videoSrc ? ' videoCardImageContainer' : ''}`
                ]),
                style: {
                    "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
                    "--_1mehvmr": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark200'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                        ...image,
                        src: image.src,
                        alt: image.alt,
                        className: (0, $2jatx.default)([
                            "_4t3i1osq _1bsb1osq _1e0c1txw",
                            orientation === 'vertical' && "_1r04idpf _5ral1dfr _kqswstnw",
                            orientation === 'horizontal' && "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _5ral1f51",
                            videoSrc && "_4t3i1osq _5ral1dfr _t9ec1h7a _8hrzaqso _v5648pnm"
                        ])
                    }),
                    videoSrc && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6iX8D.PlayIcon), {})
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1yt41ejb _1e0c1txw _2lx21bp4 _zulpu2gc",
                    orientation === 'vertical' && "_16jlkb7n _1o9zkb7n _i0dlf1ug",
                    orientation === 'horizontal' && "_1bsb1osq _4t3i1osq _1q51xy5q"
                ]),
                children: [
                    logo && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_19pkgrf3 _2hwxgrf3 _otyrgrf3 _18u0grf3"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                            image: {
                                src: $2da6ff99551ef1ce$export$3c868f5963107f89[logo],
                                alt: '',
                                height: 24
                            }
                        })
                    }),
                    cardIcons.length > 0 && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_4cvr1h6o _1e0c1txw _zulpu2gc _6rthpxbi",
                            align === 'center' && "_1bah1h6o",
                            "cardIconRow"
                        ]),
                        children: cardIcons.map((cardIcon, index)=>{
                            const { linkedIcon: linkedIcon, iconComponent: iconComponent } = cardIcon;
                            const iconUrl = linkedIcon?.url;
                            const iconSize = linkedIcon?.size ?? 'medium';
                            const paddingIncluded = linkedIcon?.paddingIncluded ?? false;
                            return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw"
                                ]),
                                children: [
                                    iconUrl && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                                        src: iconUrl,
                                        alt: '',
                                        style: {
                                            width: `${(0, $8cYSw.iconSizesPaddingIncluded)[iconSize]}px`,
                                            height: `${(0, $8cYSw.iconSizesPaddingIncluded)[iconSize]}px`,
                                            aspectRatio: '1',
                                            padding: `${paddingIncluded ? 0 : ((0, $8cYSw.iconSizesPaddingIncluded)[iconSize] - (0, $8cYSw.iconSizesPaddingExcluded)[iconSize]) / 2}px`,
                                            objectPosition: 'center'
                                        }
                                    }),
                                    iconComponent
                                ]
                            }, iconUrl ?? index);
                        })
                    }),
                    eyebrow && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_19pkgrf3 _2hwxgrf3 _otyrgrf3 _18u0grf3",
                            "eyebrow-md"
                        ]),
                        children: eyebrow
                    }),
                    title && /*#__PURE__*/ (0, $7VQPk.jsx)(TitleComponent, {
                        className: (0, $2jatx.default)([
                            "_19pkgrf3 _2hwxgrf3 _otyrgrf3 _18u0grf3",
                            "card-title"
                        ]),
                        id: titleId,
                        children: title
                    }),
                    body && bodyElement,
                    isLinkableCard && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            orientation === 'vertical' && "_1pfh1wug",
                            "_1q51pxbi"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                            id: callToActionId,
                            ariaLabelledby: `${callToActionId} ${titleId}`,
                            type: videoSrc ? 'video' : 'primary',
                            ...callToAction,
                            href: videoSrc ?? callToAction.href,
                            anchorProps: videoSrc ? {
                                onClick: openVideoOverlay
                            } : callToAction.anchorProps,
                            className: `full-card ${callToAction?.className ?? ''}`,
                            bgColor: isDark ? 'bgBlackBlue' : 'bgWhite',
                            "aria-label": callToAction.text
                        })
                    })
                ]
            })
        ]
    });
    const fullWidthGridStyles = null;
    if (numColumns && orientation === 'horizontal') return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            videoOverlay,
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb1osq _4t3i1osq _1e0c1txw _1bah1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_195g1wug _p12f1osq _1bsb1osq _13ltwklj _bozgzwfg _y4tizwfg _qwmh1wqb _yu8o1wqb _1j8bcx6w _1vsw1vi7 _d2ik1wqb _exxm1wqb _10jxzqdx _1e0c11p5 _vchhusvi _zulp14hz _1dsl1tcg _1qnyaw08 _n6am13k5"
                    ]),
                    style: {
                        "--_18qdfwk": (0, $6ZVlx.default)(numColumns === 10 ? 2 : 1),
                        "--_1xniuc0": (0, $6ZVlx.default)(numColumns === 10 ? 10 : 12)
                    },
                    children: card
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            videoOverlay,
            card
        ]
    });
};
const $2da6ff99551ef1ce$var$cardContainer = null;
const $2da6ff99551ef1ce$var$cardContainerLight = null;
const $2da6ff99551ef1ce$var$cardContainerDark = null;
const $2da6ff99551ef1ce$var$illustrationContainer = null;
const $2da6ff99551ef1ce$var$horizontalIllustrationContainer = null;
const $2da6ff99551ef1ce$var$verticalOrientation = null;
const $2da6ff99551ef1ce$var$horizontalOrientation = null;
const $2da6ff99551ef1ce$var$centeredCardContainer = null;
const $2da6ff99551ef1ce$var$linkableCardContainer = null;
const $2da6ff99551ef1ce$var$linkableCardHoverShadow = null;
const $2da6ff99551ef1ce$var$cardImageContainer = null;
const $2da6ff99551ef1ce$var$horizontalImageContainer = null;
const $2da6ff99551ef1ce$var$verticalImageContainer = null;
const $2da6ff99551ef1ce$var$widescreenImageAspectRatio = null;
const $2da6ff99551ef1ce$var$squareImageAspectRatio = null;
const $2da6ff99551ef1ce$var$imageStyle = null;
const $2da6ff99551ef1ce$var$verticalImageStyle = null;
const $2da6ff99551ef1ce$var$horizontalImageStyle = null;
const $2da6ff99551ef1ce$var$videoThumbnailContainer = null;
const $2da6ff99551ef1ce$var$videoThumbnailImageStyle = null;
const $2da6ff99551ef1ce$var$verticalBodyContainer = null;
const $2da6ff99551ef1ce$var$horizontalBodyContainer = null;
const $2da6ff99551ef1ce$var$cardBodyContainer = null;
const $2da6ff99551ef1ce$var$resetMargin = null;
const $2da6ff99551ef1ce$var$iconContainer = null;
const $2da6ff99551ef1ce$var$iconRow = null;
const $2da6ff99551ef1ce$var$centeredIconRow = null;
const $2da6ff99551ef1ce$var$linkContainer = null;
const $2da6ff99551ef1ce$var$verticalLinkContainer = null;
const $2da6ff99551ef1ce$var$videoOverlayContent = null;
const $2da6ff99551ef1ce$var$videoOverlayCloseButton = null;

});
parcelRegister("6iX8D", function(module, exports) {
$parcel$export(module.exports, "PlayIcon", function () { return $41efe20f21d8b288$export$a6630b90defda83f; });
$parcel$export(module.exports, "EmbeddedVideo", function () { return $41efe20f21d8b288$export$e71032fcfd2bdb71; });
/* embedded-video.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $kbpa7 = parcelRequire("kbpa7");
const $41efe20f21d8b288$export$a6630b90defda83f = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            "_lswu1afi _tzy4q80t _kqswstnw _1e02idpf _rjxpidpf _152tidpf _u7coidpf _19pk1wug _2hwx1wug _otyr1wug _18u01wug _lcxvglyw _2rko1osq _1pbykb7n",
            "play-icon"
        ]),
        width: "70px",
        height: "70px",
        viewBox: "0 0 32 32",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M16,0 C7.163444,-5.41083001e-16 1.082166e-15,7.163444 0,16 C-1.082166e-15,24.836556 7.163444,32 16,32 C24.836556,32 32,24.836556 32,16 C32,11.7565362 30.3142906,7.68687356 27.3137085,4.6862915 C24.3131264,1.68570945 20.2434638,2.5983722e-16 16,0 Z M11.1288889,22.2222222 L11.1288889,9.77777778 L23.6533333,16 L11.1288889,22.2222222 Z"
        })
    });
};
const $41efe20f21d8b288$export$c233dcaeaeace6e8 = (url)=>{
    const normalizedUrl = url.toLowerCase();
    if (normalizedUrl.includes('loom.com')) return 'loom';
    if (normalizedUrl.endsWith('.mp4') || normalizedUrl.includes('video/mp4')) return 'mp4';
    return 'youtube';
};
/**
 * Normalizes a Loom URL to its embed format.
 * Converts share URLs (loom.com/share/ID) to embed URLs (loom.com/embed/ID).
 */ const $41efe20f21d8b288$var$normalizeLoomUrl = (url)=>{
    return url.replace('/share/', '/embed/');
};
/**
 * Normalizes a YouTube URL to its embed format.
 */ const $41efe20f21d8b288$var$normalizeYoutubeUrl = (url)=>{
    return url.replace('youtu.be/', 'youtube.com/embed/').replace('watch?v=', 'embed/').replace('https://youtube.com', 'https://www.youtube.com');
};
const $41efe20f21d8b288$var$roundedCornersCss = null;
const $41efe20f21d8b288$export$e71032fcfd2bdb71 = ({ embedUrl: embedUrl, title: title, thumbnail: thumbnail, dataEventProps: dataEventProps, videoType: videoType, autoPlay: autoPlay = false, roundedCorners: roundedCorners = false, aspectRatio: aspectRatio })=>{
    const [isPlaying, setIsPlaying] = (0, $1oC0p.useState)(autoPlay);
    const videoRef = (0, $1oC0p.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const resolvedVideoType = videoType ?? $41efe20f21d8b288$export$c233dcaeaeace6e8(embedUrl);
    const videoOverlayCss = null;
    const iFrameCss = null;
    const mp4VideoCss = null;
    const handleClick = (e)=>{
        e.preventDefault();
        setIsPlaying(true);
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'embeddedVideoPlay',
            source: dataEventProps?.['data-event-container'] ?? 'embeddedVideo',
            attributes: {
                ...dataEventProps?.['data-product-key'] && {
                    productKey: dataEventProps['data-product-key']
                },
                ...dataEventProps?.['data-label'] && {
                    label: dataEventProps['data-label']
                },
                videoType: resolvedVideoType
            }
        }).fire();
    };
    // needs to be defined outside of css
    const bgImage = `url("${thumbnail?.src}")`;
    const intl = (0, $8e22h.default)();
    const renderPlayingContent = ()=>{
        switch(resolvedVideoType){
            case 'mp4':
                return /*#__PURE__*/ (0, $7VQPk.jsxs)("video", {
                    ref: videoRef,
                    src: embedUrl,
                    title: title,
                    controls: true,
                    autoPlay: true,
                    playsInline: true,
                    "aria-label": title ?? '',
                    className: (0, $2jatx.default)([
                        "_1e0c1ule _1h1tbb7n _1bsb1osq _4t3i1wug _bfhk1pfd"
                    ]),
                    style: {
                        aspectRatio: aspectRatio,
                        "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("track", {
                            kind: "captions"
                        }),
                        intl.formatMessage({
                            id: 'embeddedVideo.videoNotSupported',
                            defaultMessage: 'Video not supported.'
                        })
                    ]
                });
            case 'youtube':
            default:
                {
                    const youtubeUrl = $41efe20f21d8b288$var$normalizeYoutubeUrl(embedUrl);
                    if (youtubeUrl.includes('iframe')) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: youtubeUrl
                        },
                        className: (0, $2jatx.default)([
                            "_digdyfq0 _11av1ule _1stxbb7n _i01y1osq _91ut1wug _mi22p5ev"
                        ])
                    });
                    return /*#__PURE__*/ (0, $7VQPk.jsx)("iframe", {
                        width: "100%",
                        height: "auto",
                        src: `${youtubeUrl}${youtubeUrl.includes('?') ? '&' : '?'}autoplay=1`,
                        title: title,
                        style: {
                            aspectRatio: aspectRatio
                        },
                        allow: "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; autoplay;",
                        allowFullScreen: true,
                        "data-gtm-yt-inspected-12": "true",
                        className: (0, $2jatx.default)([
                            "_s7n4yfq0 _1e0c1ule _1h1tbb7n _1bsb1osq _4t3i1wug _3y3kp5ev _19itglyw"
                        ])
                    });
                }
        }
    };
    if (resolvedVideoType === 'loom') {
        const loomUrl = $41efe20f21d8b288$var$normalizeLoomUrl(embedUrl);
        return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                roundedCorners && "_2rko1ylz _1reo15vq _18m915vq"
            ]),
            style: {
                "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card'))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("iframe", {
                width: "100%",
                height: "auto",
                src: loomUrl,
                title: title,
                style: {
                    aspectRatio: aspectRatio
                },
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen",
                allowFullScreen: true,
                className: (0, $2jatx.default)([
                    "_s7n4yfq0 _1e0c1ule _1h1tbb7n _1bsb1osq _4t3i1wug _3y3kp5ev _19itglyw"
                ])
            })
        });
    }
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            roundedCorners && "_2rko1ylz _1reo15vq _18m915vq"
        ]),
        style: {
            "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card'))
        },
        children: [
            !isPlaying && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1tke1osq _1bsb1osq _kqswh2mm _19itidpf _80omtlke _1e0c1txw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                    type: "button",
                    className: (0, $2jatx.default)([
                        "_1e0c1ule _1bsb1osq _1tke1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _80omtlke _ul7n1qgu _e6731y44 _8zzh1afi _12lu1vf8 _15l81afi _18y71vf8",
                        "play-trigger"
                    ]),
                    "aria-label": intl.formatMessage({
                        id: 'embeddedVideo.playTriggerButton.ariaLabel',
                        defaultMessage: 'Play Video'
                    }),
                    onClick: handleClick,
                    style: {
                        "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                        "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                            className: (0, $2jatx.default)([
                                "_p12f1osq _1bsb1osq _4t3i1wug _8hrzaqso _t9ec1h7a _v5648pnm _1itk1n01 _1lrw1dfr _ouxl1ssb _bfhkygj1 _11q31n0t _s7n4yfq0 _lcxvglyw",
                                "video-thumbnail"
                            ]),
                            src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAYAAAA7KqwyAAAAAXNSR0IArs4c6QAAAAlwSFlzAAALEwAACxMBAJqcGAAAAVlpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDUuNC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KTMInWQAAABFJREFUKBVjYBgFoyFAhRAAAAJJAAFEkgypAAAAAElFTkSuQmCC',
                            alt: thumbnail?.alt ?? '',
                            style: {
                                "--_um3idz": (0, $6ZVlx.default)(bgImage)
                            }
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($41efe20f21d8b288$export$a6630b90defda83f, {})
                    ]
                })
            }),
            isPlaying && renderPlayingContent()
        ]
    });
};

});



parcelRegister("kIC93", function(module, exports) {
$parcel$export(module.exports, "TwcPromo", function () { return $3b570c8d1312e036$export$f72cba571c49850d; });
/* twc-promo.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $2axoc = parcelRequire("2axoc");

var $kbpa7 = parcelRequire("kbpa7");
const $3b570c8d1312e036$export$f72cba571c49850d = ({ product: product })=>{
    const intl = (0, $8e22h.default)();
    let text = intl.formatMessage({
        id: 'TeamworkCollection.promo.jira.body',
        defaultMessage: 'Get Jira, Confluence, Loom, and Rovo in one collection to bring together projects, knowledge, video communication, and AI-powered insights.'
    });
    if (product === 'confluence') text = intl.formatMessage({
        id: 'TeamworkCollection.promo.confluence.body',
        defaultMessage: 'Get Confluence, Jira, Loom, and Rovo in one collection to bring together knowledge, projects, video communication, and AI-powered insights.'
    });
    if (product === 'loom') text = intl.formatMessage({
        id: 'TeamworkCollection.promo.loom.body',
        defaultMessage: 'Get Loom, Jira, Confluence, and Rovo in one collection to bring together video communication, projects, knowledge, and AI-powered insights.'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_1bsbauwl _1mouxy5q"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2axoc.ContentBlock), {
            logo: "teamworkCollection",
            title: intl.formatMessage({
                id: 'TeamworkCollection.promo.title',
                defaultMessage: 'All your tools, one collection'
            }),
            text: text,
            callToActionProps: {
                link: {
                    text: intl.formatMessage({
                        id: 'TeamworkCollection.promo.body',
                        defaultMessage: 'Explore Teamwork Collection'
                    }),
                    href: '/collections/teamwork'
                }
            },
            imageProps: {
                src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1q83t675w16167510pu524e7ccp6n551.png',
                alt: ''
            },
            orientation: "horizontal-reverse",
            columns: 12,
            backgroundColor: `${(0, $kbpa7.wacToken)('color.extended.blue100')}`,
            hat: "high-right"
        })
    });
};

});

parcelRegister("cxuID", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3ef1f3c8e12499aa$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $hCc2m = parcelRequire("hCc2m");

var $g9ZvA = parcelRequire("g9ZvA");

var $gIRO7 = parcelRequire("gIRO7");

var $eYlij = parcelRequire("eYlij");

var $1qGP5 = parcelRequire("1qGP5");

var $dl2JF = parcelRequire("dl2JF");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
const $3ef1f3c8e12499aa$var$ConfluencePriceFinder = (props)=>{
    const content = {
        free: (0, $dl2JF.usePricingPlanComparison)('Free'),
        standard: (0, $dl2JF.usePricingPlanComparison)('Standard'),
        premium: (0, $dl2JF.usePricingPlanComparison)('Premium'),
        enterprise: (0, $dl2JF.usePricingPlanComparison)('Enterprise')
    };
    const freePlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, 'free');
    const standardPlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, 'standard');
    const premiumPlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, 'premium');
    const enterprisePlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, 'enterprise');
    const intl = (0, $8e22h.default)();
    const signupLimit = 250000;
    // planNames should not be translated
    const confluenceProductPlans = [
        {
            planName: 'Free',
            offeringSku: 'confluence-free',
            description: intl.formatMessage({
                id: 'ConfluencePricingPageTeam24.priceFinder.freeDescription',
                defaultMessage: 'Free forever for 10 users'
            }),
            recommendationLimit: 0,
            signupLimit: signupLimit,
            signupURLSuffix: '?bundle=confluence&edition=free&signupSource=pricing&editionIntent=free',
            planFeatureMessages: freePlanFeatureMessages
        },
        {
            planName: 'Standard',
            offeringSku: 'confluence-standard',
            description: intl.formatMessage({
                id: 'ConfluencePricingPageTeam24.priceFinder.standardDescription',
                defaultMessage: 'Everything you need to get started'
            }),
            recommendationLimit: 10,
            signupLimit: signupLimit,
            signupURLSuffix: '?bundle=confluence&edition=standard&signupSource=pricing',
            planFeatureMessages: standardPlanFeatureMessages
        },
        {
            planName: 'Premium',
            offeringSku: 'confluence-premium',
            description: intl.formatMessage({
                id: 'ConfluencePricingPageTeam24.priceFinder.premiumDescription',
                defaultMessage: 'Connect work across teams'
            }),
            recommendationLimit: 250,
            signupLimit: signupLimit,
            signupURLSuffix: '?bundle=confluence&edition=premium&signupSource=pricing',
            planFeatureMessages: premiumPlanFeatureMessages
        },
        {
            planName: 'Enterprise',
            offeringSku: 'confluence-enterprise-sku',
            description: intl.formatMessage({
                id: 'ConfluencePricingPageTeam24.priceFinder.enterpriseDescription',
                defaultMessage: 'Advanced analytics, scale and security for enterprises'
            }),
            recommendationLimit: 5000,
            signupLimit: signupLimit,
            planFeatureMessages: enterprisePlanFeatureMessages
        }
    ];
    const messages = (0, $fnHPc.defineMessages)({
        headerText: {
            id: 'ConfluencePricingPageTeam24.priceFinder.headerText',
            defaultMessage: 'Build Your <blue>Source of Truth</blue>'
        },
        unitCountInputTextRedesign: {
            id: 'ConfluencePricingPage.priceFinder.unitCountInputTextRedesign',
            defaultMessage: 'Team size:'
        },
        unitCountInputDirectBuy: {
            id: 'ConfluencePricingPage.priceFinder.unitCountInputDirectBuy',
            defaultMessage: "What's your team size?"
        },
        unitCountInputTerm: {
            id: 'ConfluencePricingPage.priceFinder.unitCountInputTerm',
            defaultMessage: 'users'
        },
        billingCycleText: {
            id: 'ConfluencePricingPage.priceFinder.billingCycleText',
            defaultMessage: 'Billing cycle:'
        },
        unitCountInputText: {
            id: 'ConfluencePricingPage.priceFinder.unitCountInputText',
            defaultMessage: 'How many users are on your team?'
        },
        unitCountInputTooltip: {
            id: 'ConfluencePricingPage.priceFinder.unitCountInputTooltip',
            defaultMessage: 'A Confluence user is any user who can log in to Confluence, and who exists in User Management'
        },
        monthlyExampleHelpText: {
            id: 'ConfluencePricingPage.priceFinder.monthlyExampleHelpText',
            defaultMessage: 'Monthly plans give you flexibility as your number of active users changes, so pay for seats as you use them. Remember that the number of seats may change the total price.'
        },
        annualExampleHelpText: {
            id: 'ConfluencePricingPage.priceFinder.annualExampleHelpText',
            defaultMessage: 'Annual plans give you flexibility and help you prepare for growth. Buy a group of seats at a flat rate now, then fill your empty seats through the year at no extra cost.'
        },
        exampleStandardPlan: {
            id: 'ConfluencePricingPage.priceFinder.exampleStandardPlan',
            defaultMessage: 'Pricing for {unitCount} users on Standard plan',
            description: 'Standard is a plan name and should not be translated'
        },
        cardOverSignupLimit: {
            id: 'ConfluencePricingPage.priceFinder.cardOverSignupLimit',
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: 'ConfluencePricingPage.priceFinder.cardEnterpriseMinimumCount',
            defaultMessage: 'Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above',
            description: 'Enterprise is a plan name and should not be translated'
        },
        cardUnitCountTierRange: {
            id: 'ConfluencePricingPage.priceFinder.cardUnitCountTierRange',
            defaultMessage: 'User tier: {lowerLimit} - {upperLimit}'
        },
        cardMonthlyPerUnitCount: {
            id: 'ConfluencePricingPageTeam24.priceFinder.cardMonthlyPerUnitCount',
            defaultMessage: 'per user / month'
        },
        cardFreeDescription: {
            id: 'ConfluencePricingPage.priceFinder.cardFreeDescription',
            defaultMessage: 'Always free for 10 users'
        }
    });
    const sourceFromProductPlans = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7546ConfluencePricingCtaCtaUrlSource);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hCc2m.default), {
        interactionName: 'conf-price-finder',
        fallback: (0, $g9ZvA.LoadingSpinner),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eYlij.PriceFinderContextProvider), {
            dataProductKey: "confluence",
            ctaUrlSource: sourceFromProductPlans ? 'productPlans' : undefined,
            productPlans: confluenceProductPlans,
            defaultUnitCount: 300,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gIRO7.default), {
                messages: messages,
                serverSideCCPPricing: props.pricing?.ccpPricingData?.confluence,
                countryCode: props.countryCode
            })
        })
    });
};
$3ef1f3c8e12499aa$var$ConfluencePriceFinder.displayName = 'ConfluencePriceFinderTeam24';
var $3ef1f3c8e12499aa$export$2e2bcd8739ae039 = $3ef1f3c8e12499aa$var$ConfluencePriceFinder;

});
parcelRegister("1qGP5", function(module, exports) {
$parcel$export(module.exports, "createPlanFeatureMessages", function () { return $9f8554c0837366fe$export$8fd76139fda318d8; });

var $7VQPk = parcelRequire("7VQPk");
const $9f8554c0837366fe$export$68568ac1e2cced1f = (highlightedFeatures)=>{
    return highlightedFeatures.map((highlight)=>({
            featureMessage: highlight.highlightedFeatureDetails ? {
                text: highlight.highlightedFeatureTitleExternal,
                content: ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: highlight.highlightedFeatureDetails
                        }
                    })
            } : highlight.highlightedFeatureTitleExternal,
            lozengeText: highlight.callOut
        }));
};
const $9f8554c0837366fe$export$8fd76139fda318d8 = (content, planKey)=>{
    const plan = content?.[planKey];
    return plan?.highlightedFeaturesContainer ? $9f8554c0837366fe$export$68568ac1e2cced1f(plan.highlightedFeaturesContainer) : [];
};

});




parcelRegister("fenhY", function(module, exports) {
$parcel$export(module.exports, "getPricingTitleInternal", function () { return $16a2671b05b4487c$export$933c1404a4ee79b; });
const $16a2671b05b4487c$export$933c1404a4ee79b = ()=>{
    return 'Confluence Pricing Page';
};

});

parcelRegister("kPZ6t", function(module, exports) {
$parcel$export(module.exports, "ConfluenceTemplateCategoryRelayPage", function () { return $7acae86b58c469af$export$edf498f6a1736180; });

var $7VQPk = parcelRequire("7VQPk");

var $1YXN8 = parcelRequire("1YXN8");
const $7acae86b58c469af$export$edf498f6a1736180 = ({ queryRef: queryRef })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1YXN8.ConfluenceTemplatesUnifiedRelayPageTemplate), {
        queryRef: queryRef
    });
};

});

parcelRegister("c33x4", function(module, exports) {
$parcel$export(module.exports, "ConfluenceTemplateCollectionDetailsRelayPage", function () { return $78d507c9edcebec4$export$bc0513752517fd32; });

var $7VQPk = parcelRequire("7VQPk");

var $gbUpX = parcelRequire("gbUpX");
const $78d507c9edcebec4$export$bc0513752517fd32 = ({ queryRef: queryRef })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gbUpX.ConfluenceTemplateCollectionDetailsRelayPageTemplate), {
        queryRef: queryRef
    });
};

});

parcelRegister("8ItDm", function(module, exports) {
$parcel$export(module.exports, "ConfluenceTemplatesRelayPage", function () { return $7bccba45c9347f8e$export$931ec4cf658dfdff; });

var $7VQPk = parcelRequire("7VQPk");

var $20OkY = parcelRequire("20OkY");

var $1rObi = parcelRequire("1rObi");

var $1YXN8 = parcelRequire("1YXN8");
const $7bccba45c9347f8e$export$931ec4cf658dfdff = ({ queryRef: queryRef, mlTemplateIds: // @ts-ignore
mlTemplateIds })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rObi.CrossFlowTouchpointProvider), {
        productKeys: [
            (0, $20OkY.ProductKeys).CONFLUENCE
        ],
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1YXN8.ConfluenceTemplatesUnifiedRelayPageTemplate), {
            queryRef: queryRef
        })
    });
};

});

parcelRegister("6mr2B", function(module, exports) {
$parcel$export(module.exports, "ConfluenceTemplateSearchRelayPage", function () { return $4ca03bd75694ef27$export$b1405e79a5b8deb2; });

var $7VQPk = parcelRequire("7VQPk");

var $1YXN8 = parcelRequire("1YXN8");
const $4ca03bd75694ef27$export$b1405e79a5b8deb2 = ({ queryRef: queryRef })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1YXN8.ConfluenceTemplatesUnifiedRelayPageTemplate), {
        queryRef: queryRef
    });
};

});

parcelRegister("5v5zT", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePageAnchorLpJswDesign", function () { return $ca2938185376ac8a$export$911cc88a5f759c10; });

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");

var $k6PTJ = parcelRequire("k6PTJ");

var $17vRh = parcelRequire("17vRh");
const $ca2938185376ac8a$export$911cc88a5f759c10 = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $17vRh.JiraSoftwarePagePaidLpJswAnchor), {
        ...pageProps,
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsw-team-design",
        persona: "unknown",
        pageVariant: "design"
    });
};

});
parcelRegister("17vRh", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePagePaidLpJswAnchor", function () { return $28e1a916c0aa04c8$export$5bd099500f106950; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $gHIMV = parcelRequire("gHIMV");

var $8e22h = parcelRequire("8e22h");

var $2WL8B = parcelRequire("2WL8B");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $leg8m = parcelRequire("leg8m");

var $kZQhV = parcelRequire("kZQhV");

var $3oD33 = parcelRequire("3oD33");

var $izdHQ = parcelRequire("izdHQ");

var $28AH4 = parcelRequire("28AH4");
const $28e1a916c0aa04c8$export$5bd099500f106950 = ({ anchorContents: anchorContents, persona: persona, teamType: teamType, pageId: pageId, pageVariant: pageVariant, animatedJiraTourProps: animatedJiraTourProps })=>{
    const intl = (0, $8e22h.default)();
    const productHref = (0, $jQ0cd.useLocalizedHref)('/software/jira');
    const [content, setContent] = (0, $1oC0p.useState)(undefined);
    const loggedInHasJira = (0, $2WL8B.useLoggedInHasJira)();
    const { setAnchorLocalStorage: setAnchorLocalStorage } = (0, $28AH4.useAnchorLocalStorage)();
    (0, $1oC0p.useEffect)(()=>{
        setAnchorLocalStorage({
            persona: persona,
            teamTypeInferredMl: teamType,
            team: ''
        });
        setContent(anchorContents);
    // We only want to run this useEffect once.
    }, []);
    if (!content) // TODO: loading UI for static renders
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {});
    const landingType = pageVariant === 'features' || $28e1a916c0aa04c8$var$isTeamAnchor(pageVariant) ? 'jira-software-rebranded-anchor' : 'jira-software-anchor';
    const theme = pageVariant === 'features' || $28e1a916c0aa04c8$var$isTeamAnchor(pageVariant) ? 'dark-on-light' : 'light-on-dark';
    const props = {
        hideNavigationBar: false,
        customHeroSection: undefined,
        landingType: landingType,
        pageId: pageId,
        animatedJiraTourProps: animatedJiraTourProps,
        showHorizontalRule: true,
        productNavProps: {
            productHref: productHref,
            productName: 'jira',
            ariaLabel: intl.formatMessage({
                id: 'wacJiraSoftwareNavigation.logo-label',
                defaultMessage: 'Jira Software logo'
            }),
            dataProductKey: 'jiraSoftware',
            showFreeHrefButton: false
        },
        heroProps: $28e1a916c0aa04c8$var$getHeroProps({
            resp: content,
            pageVariant: pageVariant,
            theme: theme
        }),
        tabsProps: $28e1a916c0aa04c8$var$getTabProps(content, landingType),
        ctaProps: $28e1a916c0aa04c8$var$getCtaProps(content),
        testimonialProps: $28e1a916c0aa04c8$var$getTestimonialProps(content),
        alternatingTextAndImageProps: $28e1a916c0aa04c8$var$getAlternatingTextAndImageProps(content),
        hasRebrandedSignupFormStyles: true,
        heroBgColor: theme === 'dark-on-light' ? 'bgWhite' : 'bgBlackBlue'
    };
    return loggedInHasJira ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
        experimentKey: "jfind-1504-after-d7-get-users-back-to-product",
        group: "Test",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
            experimentKey: "jfind-get-d1to6-users-back-to-product-for-paid",
            group: "variant",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
                experimentKey: 'jfind-981-paid-jpto-logged-in-redesign',
                group: 'Test',
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3oD33.PaidLoggedInJiraProductTourOverview), {})
            })
        })
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kZQhV.PaidLandingTemplate), {
        ...props
    });
};
const $28e1a916c0aa04c8$var$heroFeatureMatrix = {
    features: {
        useNewHero: true,
        showAnimatedHero: true,
        animatedSocialBanner: true,
        darkSolidTheme: false,
        showStaticImage: false
    },
    pm: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: true,
        showStaticImage: true
    },
    template: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: true,
        showStaticImage: true
    },
    project_collaboration: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: true,
        showStaticImage: false
    },
    automation: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: true,
        showStaticImage: false
    },
    teamwork: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: true,
        showStaticImage: false
    },
    agile: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: true,
        showStaticImage: false
    },
    competitors: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: true,
        showStaticImage: false
    },
    roadmaps: {
        useNewHero: true,
        showAnimatedHero: true,
        animatedSocialBanner: true,
        darkSolidTheme: true,
        showStaticImage: false
    },
    tracker: {
        useNewHero: true,
        showAnimatedHero: true,
        animatedSocialBanner: true,
        darkSolidTheme: true,
        showStaticImage: false
    },
    engineering: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: false,
        showStaticImage: false
    },
    marketing: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: false,
        showStaticImage: false
    },
    hr: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: false,
        showStaticImage: false
    },
    legal: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: false,
        showStaticImage: false
    },
    operations: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: false,
        showStaticImage: false
    },
    design: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: false,
        showStaticImage: false
    },
    programmgmt: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: false,
        showStaticImage: false
    },
    sales: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: false,
        showStaticImage: false
    }
};
const $28e1a916c0aa04c8$var$isTeamAnchor = (pageVariant)=>{
    const teamAnchors = [
        'engineering',
        'marketing',
        'hr',
        'legal',
        'operations',
        'design',
        'programmgmt',
        'sales'
    ];
    return teamAnchors.includes(pageVariant);
};
const $28e1a916c0aa04c8$var$getHeroFeatures = (pageVariant)=>{
    const defaultFeatures = {
        useNewHero: false,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: false,
        showStaticImage: false
    };
    return $28e1a916c0aa04c8$var$heroFeatureMatrix[pageVariant] || defaultFeatures;
};
const $28e1a916c0aa04c8$var$getHeroProps = ({ resp: resp, pageVariant: pageVariant, theme: theme })=>{
    const defaultProps = {
        theme: theme,
        headerText: '',
        secondaryText: '',
        signup: {
            bundle: 'jira-software',
            edition: 'free',
            featureFlags: {
                enableDefaultExpandedEmail: false,
                enableDeferredFullName: true
            }
        }
    };
    if (!resp || !resp[0] || !resp[0].node) return defaultProps;
    const { headline: headline } = resp[0].node;
    const data = headline && headline[0] ? headline[0] : null;
    const planBenefits = data?.planBenefits && data?.planBenefits[0] ? data?.planBenefits[0] : null;
    const supportingAsset = planBenefits?.supportingAsset;
    const features = $28e1a916c0aa04c8$var$getHeroFeatures(pageVariant);
    const getImage = (url, description)=>url && description ? {
            src: url ? url : '',
            alt: description || ''
        } : undefined;
    const getFeaturesRawHtml = ()=>planBenefits && planBenefits.planFeatures && planBenefits.planFeatures[0] ? planBenefits.planFeatures[0].description || '' : '';
    return {
        ...defaultProps,
        ...features,
        headerText: data?.name || '',
        secondaryText: data?.subheading || '',
        image: getImage(supportingAsset?.url, supportingAsset?.description),
        featuresRawHtml: getFeaturesRawHtml(),
        tertiaryText: planBenefits?.description || ''
    };
};
const $28e1a916c0aa04c8$var$getTabProps = (resp, landingType)=>{
    const defaultProps = {
        dataProductKey: 'jiraSoftware-PaidLpJiraPm',
        headerText: '',
        tabStyles: {
            defaultBG: (0, $kbpa7.wacToken)('color.neutral.light0'),
            // eslint-disable-next-line local/ensure-wac-token-usage
            defaultText: '#091e42',
            hoverBG: (0, $kbpa7.wacToken)('color.neutral.light0'),
            // eslint-disable-next-line local/ensure-wac-token-usage
            hoverText: '#091e42',
            // eslint-disable-next-line local/ensure-wac-token-usage
            activeBG: '#deebff',
            // eslint-disable-next-line local/ensure-wac-token-usage
            activeText: '#091e42'
        },
        styles: {
            '--lp-tabs-hover': '#deebff',
            '--lp-tabs-unselected': '#6b778c'
        },
        tabs: undefined
    };
    if (!resp || !resp[0] || !resp[0].node) return defaultProps;
    const tabs = $28e1a916c0aa04c8$var$getTabs(resp);
    const primaryMessage = $28e1a916c0aa04c8$var$getPrimaryMessage(resp);
    return {
        ...defaultProps,
        landingType: landingType,
        headerText: primaryMessage?.name || '',
        tabs: tabs
    };
};
const $28e1a916c0aa04c8$var$getCtaProps = (resp)=>{
    const cta = $28e1a916c0aa04c8$var$getCta(resp);
    return {
        headerText: cta?.valueProposition || '',
        ctaProps: {
            buttonProps: {
                color: 'yellow',
                url: cta?.url || '',
                text: cta?.text || '',
                dataEventProps: {
                    'data-event': 'clicked',
                    'data-event-container': 'ctaSection',
                    'data-event-component': 'linkButton',
                    'data-product-key': 'jiraSoftware'
                }
            }
        },
        backgroundProperties: {
            textColor: (0, $kbpa7.wacToken)('color.neutral.light0')
        }
    };
};
const $28e1a916c0aa04c8$var$getTestimonialProps = (resp)=>{
    if (!resp || !resp[0] || !resp[0].node) return undefined;
    const { socialProof: socialProof } = resp[0].node;
    const data = socialProof && socialProof[0] ? socialProof[0] : null;
    if (!data) return undefined;
    return {
        headerText: data?.name,
        logos: data?.customers?.map((customer)=>{
            return {
                src: customer && customer.logo && customer?.logo[0] && customer?.logo[0].url ? customer?.logo[0].url : '',
                alt: customer && customer.logo && customer?.logo[0] && customer?.logo[0].description ? customer?.logo[0].description : '',
                lazy: true
            };
        })
    };
};
const $28e1a916c0aa04c8$var$getAlternatingTextAndImageProps = (resp)=>{
    const results = $28e1a916c0aa04c8$var$getResults(resp);
    function generateProps(result, index) {
        // this shouldn't go past
        const countMap = [
            'one',
            'two',
            'three',
            'four'
        ];
        const count = (0, (/*@__PURE__*/$parcel$interopDefault($gHIMV)))(`${countMap[index]}`);
        const position = index % 2 === 0 ? 'left' : 'right';
        return {
            [`row${count}Header`]: result?.name || '',
            [`row${count}Body`]: result?.subheading || '',
            [`row${count}ImageLink`]: result?.asset?.url,
            [`row${count}ImageAltText`]: result?.asset?.description || '',
            [`row${count}ImagePosition`]: position
        };
    }
    const contentBlocks = results?.map((result, index)=>generateProps(result, index)).slice(0, 4) // ensure max of 4 results so we don't break the pattern
    .filter((result)=>!!result).reduce((acc, curr)=>{
        return {
            ...acc,
            ...curr
        };
    });
    return {
        imageWidth: '100%',
        imageTextSideRowOnePaddingBelowLargeScreen: '32px 0 16px',
        imageTextSideRowTwoPadding: '16px 0',
        imageTextSideRowThreePaddingBelowLargeScreen: '16px 0 32px',
        ...contentBlocks
    };
};
const $28e1a916c0aa04c8$var$getPrimaryMessage = (resp)=>{
    if (!resp || !resp[0] || !resp[0].node) return null;
    const { primaryMessage: primaryMessage } = resp[0].node;
    const data = primaryMessage && primaryMessage[0] ? primaryMessage[0] : null;
    return data;
};
const $28e1a916c0aa04c8$var$getTabs = (resp)=>{
    const primaryMessage = $28e1a916c0aa04c8$var$getPrimaryMessage(resp);
    if (!primaryMessage || !primaryMessage?.supportingExample) return undefined;
    return primaryMessage.supportingExample.filter((tab)=>tab !== null).map((tab)=>{
        const supportingAsset = tab?.supportingAsset;
        const advocateQuote = tab?.advocateQuote;
        return {
            textLabel: tab?.name || '',
            id: tab?.name || '',
            component: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $leg8m.default), {
                isShowTestimonyBorder: false,
                isIncludeTestimony: !!tab?.advocateQuote,
                testimonyIsUsingTextQuotationMarks: true,
                title: tab?.heading || '',
                rawHtmlContent: tab?.proofpoint || '',
                imageSrc: supportingAsset?.url || '',
                imageAlt: supportingAsset?.description || '',
                quoteBlurb: advocateQuote?.advocateQuote || '',
                quoteName: advocateQuote?.advocateName || '',
                quoteCompany: advocateQuote?.advocateJobTitle || '',
                testimonyImageSrc: advocateQuote?.advocateHeadshot?.url || '',
                testimonyImageAlt: advocateQuote?.advocateHeadshot?.description || ''
            }, tab?.name)
        };
    });
};
const $28e1a916c0aa04c8$var$getResults = (resp)=>{
    if (!resp || !resp[0] || !resp[0].node) return null;
    const { results: results } = resp[0].node;
    const data = results && results.length ? results : null;
    return data;
};
const $28e1a916c0aa04c8$var$getCta = (resp)=>{
    if (!resp || !resp[0] || !resp[0].node) return null;
    const { callToAction: callToAction } = resp[0].node;
    const data = callToAction && callToAction[0] ? callToAction[0] : null;
    return data;
};

});
parcelRegister("3oD33", function(module, exports) {
$parcel$export(module.exports, "PaidLoggedInJiraProductTourOverview", function () { return $0a7c04675d65ed18$export$589a1fda37df576f; });

var $7VQPk = parcelRequire("7VQPk");

var $iLjCW = parcelRequire("iLjCW");

var $l4vdU = parcelRequire("l4vdU");

var $7ybN7 = parcelRequire("7ybN7");

var $ls6x3 = parcelRequire("ls6x3");

var $5S2vX = parcelRequire("5S2vX");

var $bVNw1 = parcelRequire("bVNw1");
const $0a7c04675d65ed18$export$589a1fda37df576f = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7ybN7.JiraSitesProvider), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l4vdU.default), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ls6x3.default), {})
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
                    scrollTrackingEnabled: true,
                    pageId: "jsw",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bVNw1.LoggedInHeroSection), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iLjCW.GlobalFooter), {
                            fullWidth: true
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("7ybN7", function(module, exports) {
$parcel$export(module.exports, "useJiraSitesContext", function () { return $3d32aa5e5ff6028d$export$8095836340dcdac5; });
$parcel$export(module.exports, "JiraSitesProvider", function () { return $3d32aa5e5ff6028d$export$e5844423e4215335; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $7GVWk = parcelRequire("7GVWk");

var $lmmDf = parcelRequire("lmmDf");

var $kP8Dm = parcelRequire("kP8Dm");
const $3d32aa5e5ff6028d$var$JiraSitesContext = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
const $3d32aa5e5ff6028d$export$8095836340dcdac5 = ()=>{
    const context = (0, $1oC0p.useContext)($3d32aa5e5ff6028d$var$JiraSitesContext);
    if (!context) throw new Error('useJiraSitesContext must be used within a JiraSitesProvider');
    return context;
};
const $3d32aa5e5ff6028d$export$e5844423e4215335 = ({ children: children })=>{
    const [jiraSitesFromAgg, setJiraSitesFromAgg] = (0, $1oC0p.useState)(undefined);
    const { profile: profile } = (0, $7GVWk.useUserContext)();
    const { cloudSiteId: cloudSiteId } = (0, $kP8Dm.useRecentJiraSite)();
    const aggClient = (0, $1oC0p.useMemo)(()=>new (0, $lmmDf.LoggedInUserJiraSitesClient)(), []);
    (0, $1oC0p.useEffect)(()=>{
        if (!profile.attributes?.existingSites) return;
        aggClient.getJiraSites(cloudSiteId ?? '').then((data)=>{
            setJiraSitesFromAgg(data);
        });
    }, [
        aggClient,
        profile.attributes?.existingSites,
        cloudSiteId
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($3d32aa5e5ff6028d$var$JiraSitesContext.Provider, {
        value: {
            jiraSitesFromAgg: jiraSitesFromAgg
        },
        children: children
    });
};

});
parcelRegister("lmmDf", function(module, exports) {
$parcel$export(module.exports, "LoggedInUserJiraSitesClient", function () { return $674243239df732ba$export$4a5a6b3b7497e383; });

var $1dWiR = parcelRequire("1dWiR");

var $1dWiR = parcelRequire("1dWiR");

var $gPKCY = parcelRequire("gPKCY");

var $7bBPn = parcelRequire("7bBPn");

var $4pGs1 = parcelRequire("4pGs1");
class $674243239df732ba$export$4a5a6b3b7497e383 {
    constructor(options){
        this.getJiraSites = async (cloudId)=>{
            (0, $gPKCY.ufoEventGetJiraSitesFromAgg).start();
            if (!cloudId) {
                (0, $gPKCY.ufoEventGetJiraSitesFromAgg).failure({
                    error: 'No Cloud ID provided'
                });
                return undefined;
            }
            const GET_JIRA_SITES_QUERY = (0, $1dWiR.gql)(`
                query getAllJiraProjects {
                    jira {
                        allJiraProjects(
                            cloudId: "${cloudId}"
                            filter: {types: [SOFTWARE], sortBy: {order: DESC, sortBy: LAST_ISSUE_UPDATED_TIME}}
                            first: 10
                        ) {
                            pageInfo {
                                hasNextPage
                            }
                            edges {
                                node {
                                    key
                                    name
                                    projectUrl
                                    webUrl
                                    assignableUsers(first: 5) {
                                        totalCount
                                        edges {
                                            node {
                                                name
                                                picture
                                                accountStatus
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            `);
            try {
                const { data: data, error: error } = await this.client.query(GET_JIRA_SITES_QUERY, {
                    cloudId: cloudId
                });
                if (error?.message) {
                    (0, $gPKCY.ufoEventGetJiraSitesFromAgg).failure({
                        error: error
                    });
                    return undefined;
                }
                try {
                    const allJiraSites = (0, $4pGs1.jiraResponseSchema).parse(data);
                    (0, $gPKCY.ufoEventGetJiraSitesFromAgg).success();
                    return allJiraSites;
                } catch (e) {
                    (0, $gPKCY.ufoEventGetJiraSitesFromAgg).failure({
                        error: e
                    });
                    return undefined;
                }
            } catch (e) {
                (0, $gPKCY.ufoEventGetJiraSitesFromAgg).failure({
                    error: e
                });
                return undefined;
            }
        };
        const fetchOptions = options?.slauthToken ? {
            headers: {
                Authorization: `SLAUTH ${options.slauthToken || ''}`
            }
        } : {
            credentials: 'include'
        };
        this.client = new (0, $1dWiR.Client)({
            url: (0, $7bBPn.GATEWAY_URL),
            exchanges: [
                (0, $1dWiR.cacheExchange),
                (0, $1dWiR.fetchExchange)
            ],
            fetchOptions: fetchOptions
        });
    }
}

});
parcelRegister("4pGs1", function(module, exports) {
$parcel$export(module.exports, "jiraResponseSchema", function () { return $576666e3bd5ce27e$export$9006e8d0932b16e7; });

var $5pILu = parcelRequire("5pILu");
const $576666e3bd5ce27e$var$assignableUserNodeSchema = (0, $5pILu.z).object({
    name: (0, $5pILu.z).string(),
    picture: (0, $5pILu.z).string().nullable(),
    accountStatus: (0, $5pILu.z).string()
});
const $576666e3bd5ce27e$var$assignableUserEdgesSchema = (0, $5pILu.z).object({
    node: $576666e3bd5ce27e$var$assignableUserNodeSchema
});
const $576666e3bd5ce27e$var$assignableUsersSchema = (0, $5pILu.z).object({
    totalCount: (0, $5pILu.z).number(),
    edges: (0, $5pILu.z).array($576666e3bd5ce27e$var$assignableUserEdgesSchema)
});
const $576666e3bd5ce27e$var$projectNodeSchema = (0, $5pILu.z).object({
    key: (0, $5pILu.z).string(),
    name: (0, $5pILu.z).string(),
    projectUrl: (0, $5pILu.z).string().nullable(),
    webUrl: (0, $5pILu.z).string(),
    assignableUsers: $576666e3bd5ce27e$var$assignableUsersSchema
});
const $576666e3bd5ce27e$var$projectEdgesSchema = (0, $5pILu.z).object({
    node: $576666e3bd5ce27e$var$projectNodeSchema
});
const $576666e3bd5ce27e$var$pageInfoSchema = (0, $5pILu.z).object({
    hasNextPage: (0, $5pILu.z).boolean()
});
const $576666e3bd5ce27e$var$allJiraProjectsSchema = (0, $5pILu.z).object({
    pageInfo: $576666e3bd5ce27e$var$pageInfoSchema,
    edges: (0, $5pILu.z).array($576666e3bd5ce27e$var$projectEdgesSchema)
});
const $576666e3bd5ce27e$var$jiraSchema = (0, $5pILu.z).object({
    allJiraProjects: $576666e3bd5ce27e$var$allJiraProjectsSchema
});
const $576666e3bd5ce27e$export$9006e8d0932b16e7 = (0, $5pILu.z).object({
    jira: $576666e3bd5ce27e$var$jiraSchema
});

});


parcelRegister("kP8Dm", function(module, exports) {
$parcel$export(module.exports, "filterAvailableJiraSites", function () { return $7f42103420ec9afa$export$c88497b4217b9e30; });
$parcel$export(module.exports, "useRecentJiraSite", function () { return $7f42103420ec9afa$export$df4ec66f2732798b; });

var $1oC0p = parcelRequire("1oC0p");

var $gV7D4 = parcelRequire("gV7D4");

var $7GVWk = parcelRequire("7GVWk");

var $5Ntyw = parcelRequire("5Ntyw");
const $7f42103420ec9afa$var$GRAPHQL_GATEWAY_URL = 'https://www.atlassian.com/gateway/api/graphql';
const $7f42103420ec9afa$var$START_URL = 'https://start.atlassian.com';
const $7f42103420ec9afa$var$constructLoginUrl = (url)=>{
    const loginUrl = new URL(url);
    loginUrl.pathname = '/login.jsp';
    const searchParam = new URLSearchParams();
    const browseUrl = new URL(loginUrl);
    browseUrl.pathname = '/browse';
    searchParam.append('os_destination', browseUrl.href);
    loginUrl.search = searchParam.toString();
    return loginUrl;
};
const $7f42103420ec9afa$export$c88497b4217b9e30 = (sites)=>{
    if (sites) {
        const filteredSites = sites.filter((site)=>{
            return site.products.some((product)=>{
                return product.productKey.includes('jira-software.ondemand');
            });
        }) || [];
        return filteredSites;
    } else return [];
};
const $7f42103420ec9afa$export$df4ec66f2732798b = ()=>{
    const { profile: profile, user: user } = (0, $7GVWk.useUserContext)();
    const splitName = user.name?.split(' ');
    (0, $5Ntyw.useBxpWebStargateClient)();
    const activityClient = (0, $gV7D4.useActivityClient)('v3', 'www.atlassian.com', undefined, $7f42103420ec9afa$var$GRAPHQL_GATEWAY_URL);
    const availableJiraSites = $7f42103420ec9afa$export$c88497b4217b9e30(profile.attributes?.existingSites);
    const hasMultipleJiras = availableJiraSites.length > 1;
    const [siteName, setSiteName] = (0, $1oC0p.useState)('');
    const [siteUrl, setSiteUrl] = (0, $1oC0p.useState)('');
    const [siteInitials, setSiteInitials] = (0, $1oC0p.useState)('');
    const [cloudSiteId, setCloudSiteId] = (0, $1oC0p.useState)();
    const [recentWorkUrl, setRecentWorkUrl] = (0, $1oC0p.useState)();
    const [isResolvingSite, setIsResolvingSite] = (0, $1oC0p.useState)(true);
    (0, $1oC0p.useEffect)(()=>{
        const promises = [];
        let mostRecentActivity;
        const fetchActivitiesPromise = activityClient.fetchActivities([
            50,
            125,
            250
        ], {
            limit: 5,
            products: [
                'jira'
            ]
        }, [
            'workedOn',
            'viewed'
        ]).then((data)=>{
            const mostRecentlyViewed = data.viewed[0];
            const mostRecentlyWorkedOn = data.workedOn[0];
            if (mostRecentlyViewed && mostRecentlyWorkedOn) mostRecentActivity = new Date(mostRecentlyViewed.timestamp) > new Date(mostRecentlyWorkedOn.timestamp) ? mostRecentlyViewed : mostRecentlyWorkedOn;
            else if (mostRecentlyWorkedOn) mostRecentActivity = mostRecentlyWorkedOn;
            else if (mostRecentlyViewed) mostRecentActivity = mostRecentlyViewed;
        }).catch((error)=>console.log(error));
        promises.push(fetchActivitiesPromise);
        Promise.allSettled(promises).then(()=>{
            if (mostRecentActivity) {
                const loginUrl = $7f42103420ec9afa$var$constructLoginUrl(mostRecentActivity.object.url);
                setSiteUrl(loginUrl.href);
                setSiteName(loginUrl.hostname.split('.')[0] || '');
                setSiteInitials(loginUrl.hostname.slice(0, 1).toUpperCase() + loginUrl.hostname.slice(1, 2));
                setCloudSiteId(mostRecentActivity.object.rootContainerIdentifier.id);
                setRecentWorkUrl(mostRecentActivity.object.url);
            } else if (availableJiraSites[0]) {
                const loginUrl = $7f42103420ec9afa$var$constructLoginUrl(availableJiraSites[0].url);
                setSiteUrl(loginUrl.href);
                setSiteName(loginUrl.hostname.split('.')[0] || '');
                setSiteInitials(loginUrl.hostname.slice(0, 1).toUpperCase() + loginUrl.hostname.slice(1, 2));
                setCloudSiteId(availableJiraSites[0].cloudId);
                setRecentWorkUrl(undefined);
            } else {
                setSiteUrl($7f42103420ec9afa$var$START_URL);
                setSiteName('');
                setRecentWorkUrl(undefined);
            }
            setIsResolvingSite(false);
        });
    }, []);
    return {
        splitName: splitName,
        hasMultipleJiras: hasMultipleJiras,
        siteName: siteName,
        siteUrl: siteUrl,
        siteInitials: siteInitials,
        cloudSiteId: cloudSiteId,
        recentWorkUrl: recentWorkUrl,
        isResolvingSite: isResolvingSite
    };
};

});
parcelRegister("gV7D4", function(module, exports) {
$parcel$export(module.exports, "useActivityClient", function () { return $c517e33112aa8e9d$export$6620595b7f837f8f; });

var $1oC0p = parcelRequire("1oC0p");

var $cOMGU = parcelRequire("cOMGU");

var $kttmz = parcelRequire("kttmz");

var $1KUQX = parcelRequire("1KUQX");
var $c517e33112aa8e9d$export$6620595b7f837f8f = function useActivityClient(version, product, logger, baseUrl) {
    var _useFlightDeckContext = (0, $cOMGU.useFlightDeckContext)(), getArtifact = _useFlightDeckContext.getArtifact;
    return (0, $1oC0p.useMemo)(function() {
        return (0, $1KUQX.createActivityClient)(version, product, logger, baseUrl, // If the rw-client is wrapped in a FD provider, use the provided fetch function
        getArtifact ? function() {
            return getArtifact((0, $kttmz.FD_CLIENT_FETCH_PROPS).name, (0, $kttmz.FD_CLIENT_FETCH_PROPS).dimensions);
        } : undefined);
    }, [
        version,
        product,
        logger,
        baseUrl,
        getArtifact
    ]);
};

});
parcelRegister("cOMGU", function(module, exports) {
$parcel$export(module.exports, "useFlightDeckContext", function () { return $954fec91d2575ca9$export$73c96350a5e69ec; });

var $1oC0p = parcelRequire("1oC0p");

var $37Osf = parcelRequire("37Osf");
const $954fec91d2575ca9$export$ca1b33377afa620 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createContext({
    getArtifact: null
});
function $954fec91d2575ca9$export$56da85ac9d40dbcd({ children: children, product: product, config: config, fallbackArtifacts: fallbackArtifacts }) {
    const flightDeckClient = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useMemo(()=>{
        return new (0, $37Osf.default)(product, {
            handlers: {
                captureException: config === null || config === void 0 ? void 0 : config.captureException
            }
        }, fallbackArtifacts);
    }, [
        product,
        config === null || config === void 0 ? void 0 : config.captureException,
        fallbackArtifacts
    ]);
    const getArtifact = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useCallback(async (name, dimensions)=>{
        return flightDeckClient.fetchConfigFromFlightDeck({
            name: name,
            dimensions: dimensions
        });
    }, [
        flightDeckClient
    ]);
    const providerValue = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useMemo(()=>({
            getArtifact: getArtifact
        }), [
        getArtifact
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($954fec91d2575ca9$export$ca1b33377afa620.Provider, {
        value: providerValue
    }, children);
}
const $954fec91d2575ca9$export$73c96350a5e69ec = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useContext($954fec91d2575ca9$export$ca1b33377afa620);
function $954fec91d2575ca9$export$3b241cde208d2c5e(key, dimensions) {
    const [artifact, setArtifact] = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useState();
    const { getArtifact: getArtifact } = $954fec91d2575ca9$export$73c96350a5e69ec();
    (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useEffect(()=>{
        if (!getArtifact) throw new Error("Flight Deck Context not provided");
        getArtifact(key, dimensions).then((resp)=>setArtifact(resp))// we don't need to do anything with the error as it is already instrumented in the flightDeckClient
        .catch();
    }, [
        dimensions,
        key,
        getArtifact,
        setArtifact
    ]);
    return artifact;
}

});
parcelRegister("37Osf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $246929c39dc571fb$export$2e2bcd8739ae039; });

var $f53LC = parcelRequire("f53LC");

var $737SZ = parcelRequire("737SZ");

var $aZlFU = parcelRequire("aZlFU");

var $4NAcO = parcelRequire("4NAcO");

var $7EJP8 = parcelRequire("7EJP8");

var $h3tyo = parcelRequire("h3tyo");

var $iclgX = parcelRequire("iclgX");
function $246929c39dc571fb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $246929c39dc571fb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $246929c39dc571fb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $246929c39dc571fb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $246929c39dc571fb$var$STORAGE_KEY_BASE = "@atlassiansox/flight-deck-frontend-client";
const $246929c39dc571fb$var$RETRIABLE_FD_ERROR_MESSAGES = [
    "Failed to fetch",
    "NetworkError when attempting to fetch resource.",
    "Load failed"
];
class $246929c39dc571fb$export$2e2bcd8739ae039 {
    constructor(product, options = {
        handlers: {}
    }, fallbackArtifacts = []){
        (0, $f53LC.default)(this, "fallbackArtifactMap", new Map());
        (0, $f53LC.default)(this, "fetchFromFlightDeckPromises", new Map());
        this.expiryMS = options.expiryMS;
        this.handlers = options.handlers;
        this.product = product;
        this.storageClient = new (0, $aZlFU.default)($246929c39dc571fb$var$STORAGE_KEY_BASE, options);
        fallbackArtifacts.forEach((artifact)=>this.fallbackArtifactMap.set((0, $h3tyo.artifactKey)(artifact.name, artifact.dimensions), artifact.value));
        this.captureException = this.captureException.bind(this);
    }
    captureException(e, tags) {
        if (this.handlers.captureException) this.handlers.captureException(e, tags);
    }
    async fetchAndCacheArtifact(artifact, retryConfig) {
        const response = await (0, $737SZ.retryOnException)(async ()=>{
            try {
                // await the result here so that we capture any errors
                const result = await (0, $4NAcO.fetchFlightDeckConfiguration)(artifact.name, artifact.dimensions);
                return result;
            } catch (error) {
                throw new (0, $7EJP8.default)({
                    artifact: artifact.key,
                    dimensions: artifact.dimensions,
                    error: error
                });
            }
        }, {
            captureException: this.captureException,
            retryOn: (err)=>$246929c39dc571fb$var$RETRIABLE_FD_ERROR_MESSAGES.includes(err.message),
            intervalsMS: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.intervalsMS,
            onRetry: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.onRetry
        });
        if (!response) {
            const missingArtifactError = new Error(`Missing artifact: ${artifact.key}`);
            this.captureException(missingArtifactError);
            throw missingArtifactError;
        }
        this.storageClient.setItemWithExpiry(artifact.key, response, this.expiryMS);
        // Clear the in-flight check
        this.fetchFromFlightDeckPromises.delete(artifact.key);
        return response;
    }
    async fetchArtifactPromise(artifact, retryConfig) {
        // Check for in-flight requests for this artifact
        if (this.fetchFromFlightDeckPromises.has(artifact.key)) return this.fetchFromFlightDeckPromises.get(artifact.key);
        const fetchPromise = this.fetchAndCacheArtifact(artifact, retryConfig);
        this.fetchFromFlightDeckPromises.set(artifact.key, fetchPromise);
        return fetchPromise;
    }
    async fetchConfigFromFlightDeck(artifact, retryConfig) {
        const experience = (0, $iclgX.flightDeckClientExperience)();
        experience.start();
        try {
            const artifactWithKey = $246929c39dc571fb$var$_objectSpread($246929c39dc571fb$var$_objectSpread({}, artifact), {}, {
                key: (0, $h3tyo.artifactKey)(artifact.name, artifact.dimensions)
            });
            experience.addMetadata({
                key: artifactWithKey.key,
                product: this.product
            });
            // Create the promise to fetch the config, we only need to await this if we don't have local config
            const artifactPromise = this.fetchArtifactPromise(artifactWithKey, retryConfig);
            // Check local storage for the artifact
            const localConfig = this.storageClient.getItem(artifactWithKey.key);
            if (localConfig) {
                experience.addMetadata({
                    configSource: "localStorage"
                });
                return localConfig;
            }
            // Was a fallback config provided?
            if (this.fallbackArtifactMap.has(artifactWithKey.key)) {
                experience.addMetadata({
                    configSource: "fallback"
                });
                return this.fallbackArtifactMap.get(artifactWithKey.key);
            }
            experience.addMetadata({
                configSource: "fetch"
            });
            // No local copies of config, await FD fetch promise here so that we can capture any errors & fail the experience
            const result = await artifactPromise;
            return result;
        } catch (e) {
            experience.failure({
                metadata: {
                    error: (0, $iclgX.exceptionToMetadata)(e)
                }
            });
            throw e;
        } finally{
            // if the experience has been failed in the "catch" block, calling "success" will have no effect
            experience.success();
        }
    }
}

});
parcelRegister("737SZ", function(module, exports) {
$parcel$export(module.exports, "retryOnException", function () { return $521eee301a453b24$export$1d94629c94e7a17f; });

var $lFOXD = parcelRequire("lFOXD");

var $cn8ql = parcelRequire("cn8ql");

var $5Cxn4 = parcelRequire("5Cxn4");

var $coDBZ = parcelRequire("coDBZ");

var $bWqzq = parcelRequire("bWqzq");

var $5MrcS = parcelRequire("5MrcS");
var $521eee301a453b24$export$5c069c93d2b7493f = function wait(ms) {
    return new Promise(function(resolve) {
        setTimeout(resolve, ms);
    });
};
var $521eee301a453b24$var$NO_CALLS_ERROR = 'No calls made';
var $521eee301a453b24$export$1d94629c94e7a17f = /*#__PURE__*/ function() {
    var _ref2 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(invokeOperation, _ref) {
        var _ref$intervalsMS, intervalsMS, _ref$retryOn, retryOn, captureException, onRetry, intervals, nextMSInterval, error;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _ref$intervalsMS = _ref.intervalsMS, intervalsMS = _ref$intervalsMS === void 0 ? (0, $bWqzq.NO_RETRIES) : _ref$intervalsMS, _ref$retryOn = _ref.retryOn, retryOn = _ref$retryOn === void 0 ? [
                        (0, $5MrcS.default)
                    ] : _ref$retryOn, captureException = _ref.captureException, onRetry = _ref.onRetry;
                    intervals = (0, $lFOXD.default)(intervalsMS);
                    nextMSInterval = 0;
                    error = new Error($521eee301a453b24$var$NO_CALLS_ERROR);
                case 4:
                    if (!(nextMSInterval !== undefined)) {
                        _context.next = 22;
                        break;
                    }
                    _context.prev = 5;
                    if (!(nextMSInterval > 0)) {
                        _context.next = 9;
                        break;
                    }
                    _context.next = 9;
                    return $521eee301a453b24$export$5c069c93d2b7493f(nextMSInterval);
                case 9:
                    if (onRetry && error.message !== $521eee301a453b24$var$NO_CALLS_ERROR) onRetry(error);
                    _context.next = 12;
                    return invokeOperation();
                case 12:
                    return _context.abrupt("return", _context.sent);
                case 15:
                    _context.prev = 15;
                    _context.t0 = _context["catch"](5);
                    error = (0, $coDBZ.default)(_context.t0);
                    if (captureException) captureException(error);
                    // Retry ONLY when the error is an instance of one of the provided `retryOn` errors, or passes the `retryOn` test.
                    // You need to ensure you are throwing one of the `retryOn` errors if that is the method you are using.
                    if (typeof retryOn === 'function' ? retryOn(error) : retryOn.some(function(err) {
                        return error instanceof err;
                    })) nextMSInterval = intervals.shift();
                    else nextMSInterval = undefined;
                case 20:
                    _context.next = 4;
                    break;
                case 22:
                    throw error;
                case 23:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                5,
                15
            ]
        ]);
    }));
    return function retryOnException(_x, _x2) {
        return _ref2.apply(this, arguments);
    };
}();

});
parcelRegister("coDBZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $906673f9fdb738cb$export$2e2bcd8739ae039; });

var $2zYm4 = parcelRequire("2zYm4");
var $906673f9fdb738cb$var$convertToError = function convertToError(e) {
    var error;
    if (e instanceof Error) error = e;
    else if (typeof e === 'string') error = new Error(e);
    else if ((0, $2zYm4.default)(e) === 'object') try {
        error = new Error('Object error instance thrown for operation: ' + JSON.stringify(e));
    } catch (jsonError) {
        error = new Error('Object serialisation error thrown during operation: ' + String(e));
    }
    else error = new Error('No error instance thrown for operation: ' + String(e));
    return error;
};
var $906673f9fdb738cb$export$2e2bcd8739ae039 = $906673f9fdb738cb$var$convertToError;

});

parcelRegister("bWqzq", function(module, exports) {
$parcel$export(module.exports, "NO_RETRIES", function () { return $8b19b8ccb3a031dc$export$a0a1c8f90becc136; });
var $8b19b8ccb3a031dc$export$a0a1c8f90becc136 = [];
var $8b19b8ccb3a031dc$export$972171517b12aa4 = [
    0,
    0
];
var $8b19b8ccb3a031dc$export$746d2203ed8cdc40 = [
    0,
    50,
    100
];
var $8b19b8ccb3a031dc$export$f6858378b665f957 = [
    100,
    500,
    1000
];

});

parcelRegister("5MrcS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $43568a20975868f4$export$2e2bcd8739ae039; });

var $avOEA = parcelRequire("avOEA");

var $cTewU = parcelRequire("cTewU");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $i7dvh = parcelRequire("i7dvh");

var $4GELH = parcelRequire("4GELH");
function $43568a20975868f4$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $43568a20975868f4$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $43568a20975868f4$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($43568a20975868f4$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $43568a20975868f4$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    function FailedFetchError(_ref) {
        var _this;
        var error = _ref.error, path = _ref.path, method = _ref.method;
        (0, $cTewU.default)(this, FailedFetchError);
        _this = $43568a20975868f4$var$_callSuper(this, FailedFetchError);
        _this.name = 'FailedFetchError';
        _this.message = error.message || 'Unknown fetch error';
        _this.stack = error.stack;
        _this.originalName = error.name;
        _this.method = method;
        var p = path.split('?')[0];
        _this.path = /^[/-a-z]+$/i.test(p) ? p : '';
        return _this;
    }
    (0, $i7dvh.default)(FailedFetchError, _Error);
    return (0, $avOEA.default)(FailedFetchError);
}(/*#__PURE__*/ (0, $4GELH.default)(Error));

});


parcelRegister("aZlFU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $80006a14e7fe218c$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $g7DPP = parcelRequire("g7DPP");
var $80006a14e7fe218c$var$DEFAULT_STORAGE_ENGINE = 'localStorage';
var $80006a14e7fe218c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function StorageClient(clientKey, options) {
        var _this = this;
        (0, $cTewU.default)(this, StorageClient);
        (0, $f53LC.default)(this, "getItem", function(key) {
            var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                useExpiredItem: false
            }, useExpiredItem = _ref.useExpiredItem;
            var item = _this.client.getItem(_this.itemKey(key));
            if (item) try {
                var parsedItem = JSON.parse(item);
                // item is expired
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    /**
             * Commented out removing this item, as it is a slightly different state
             * to the item not existing that we may want to preserve.
             *  this.client.removeItem(this.itemKey(key));
             */ if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                _this.captureException(e);
            }
            return undefined;
        });
        (0, $f53LC.default)(this, "removeItem", function(key) {
            try {
                _this.client.removeItem(_this.itemKey(key));
            } catch (e) {
                _this.captureException(e);
            }
        });
        (0, $f53LC.default)(this, "setItemWithExpiry", function(key, value, expireInMS) {
            var itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                _this.client.setItem(_this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                _this.captureException(e);
            }
        });
        this.clientKey = clientKey;
        this.handlers = options === null || options === void 0 ? void 0 : options.handlers;
        var storageEngine = (options === null || options === void 0 ? void 0 : options.storageEngine) || $80006a14e7fe218c$var$DEFAULT_STORAGE_ENGINE;
        if (!Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $g7DPP.mockWindowStorage)([
            storageEngine
        ]);
        this.client = window[storageEngine];
    }
    return (0, $avOEA.default)(StorageClient, [
        {
            key: "captureException",
            value: function captureException(e, tags) {
                var _this$handlers;
                if ((_this$handlers = this.handlers) !== null && _this$handlers !== void 0 && _this$handlers.captureException) {
                    var _this$handlers2;
                    (_this$handlers2 = this.handlers) === null || _this$handlers2 === void 0 || _this$handlers2.captureException(e, tags);
                }
            }
        },
        {
            key: "itemKey",
            value: function itemKey(key) {
                return "".concat(this.clientKey, "_").concat(key);
            }
        }
    ]);
}();

});
parcelRegister("g7DPP", function(module, exports) {
$parcel$export(module.exports, "mockWindowStorage", function () { return $bbcc332eee3093b5$export$efebfe7859cae3c7; });

var $f53LC = parcelRequire("f53LC");
function $bbcc332eee3093b5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bbcc332eee3093b5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bbcc332eee3093b5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bbcc332eee3093b5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $bbcc332eee3093b5$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $bbcc332eee3093b5$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $bbcc332eee3093b5$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $bbcc332eee3093b5$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $bbcc332eee3093b5$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $bbcc332eee3093b5$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $bbcc332eee3093b5$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function setItem(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function getItem(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function removeItem(id) {
        return delete this._data[id];
    },
    clear: function clear() {
        return this._data = {};
    },
    key: function key(index) {
        return Object.keys(this._data)[index];
    }
};
var $bbcc332eee3093b5$export$efebfe7859cae3c7 = function mockWindowStorage() {
    var storageToMock = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
        'localStorage',
        'sessionStorage'
    ];
    var _iterator = $bbcc332eee3093b5$var$_createForOfIteratorHelper(storageToMock), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var storageToMockElement = _step.value;
            Object.defineProperty(window, storageToMockElement, {
                value: $bbcc332eee3093b5$var$_objectSpread({}, $bbcc332eee3093b5$export$c65e688d8b365035),
                configurable: true
            });
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
};

});


parcelRegister("4NAcO", function(module, exports) {
$parcel$export(module.exports, "fetchFlightDeckConfiguration", function () { return $37e7d2b813017b8f$export$6026918e023c9101; });

var $2hVi7 = parcelRequire("2hVi7");

var $9zB5r = parcelRequire("9zB5r");

var $ia7Qf = parcelRequire("ia7Qf");

var $hgXMP = parcelRequire("hgXMP");

var $1MOuf = parcelRequire("1MOuf");

var $eRMh2 = parcelRequire("eRMh2");

var $f40Bu = parcelRequire("f40Bu");
/**
 * Arguments for passing in dimensions that the artifact might vary on.
 * For more details see: https://developer.atlassian.com/platform/flight-deck/getting-your-capability-onto-flight-deck/dimensions/
 */ /**
 * default to using prod instance since artifacts that don't depend on environment should be using the prod instance.
 */ const $37e7d2b813017b8f$var$defaultEnvType = "prod";
/**
 * default to using commercial instance.
 */ const $37e7d2b813017b8f$var$defaultPerimeter = "commercial";
async function $37e7d2b813017b8f$export$6026918e023c9101(artifactName, dim = {}) {
    var _dim$environmentType, _dim$perimeter;
    const environmentType = (_dim$environmentType = dim.environmentType) !== null && _dim$environmentType !== void 0 ? _dim$environmentType : $37e7d2b813017b8f$var$defaultEnvType;
    const perimeter = (_dim$perimeter = dim.perimeter) !== null && _dim$perimeter !== void 0 ? _dim$perimeter : $37e7d2b813017b8f$var$defaultPerimeter;
    const environment = $37e7d2b813017b8f$var$getEnvFromEnvType(environmentType);
    const locale = dim.locale && (0, $2hVi7.default)(dim.locale);
    const artifactDimensions = {
        perimeter: perimeter,
        environment: environment,
        locale: locale
    };
    const client = await $37e7d2b813017b8f$var$getConfigClient(environmentType, perimeter);
    return client.getArtifact(artifactName, artifactDimensions);
}
async function $37e7d2b813017b8f$export$4abbe3ae0811355(dim = {}) {
    var _dim$environmentType2, _dim$perimeter2;
    const client = await $37e7d2b813017b8f$var$getConfigClient((_dim$environmentType2 = dim.environmentType) !== null && _dim$environmentType2 !== void 0 ? _dim$environmentType2 : $37e7d2b813017b8f$var$defaultEnvType, (_dim$perimeter2 = dim.perimeter) !== null && _dim$perimeter2 !== void 0 ? _dim$perimeter2 : $37e7d2b813017b8f$var$defaultPerimeter);
    return client.getLatestVersionMetadata();
}
async function $37e7d2b813017b8f$var$getConfigClient(env, perimeter) {
    const fetchArtifactExperience = await (0, $eRMh2.getFlightDeckFetchExperience)();
    const fetchVersionMetadataExperience = await (0, $eRMh2.getVersionMetadataFetchExperience)();
    return new (0, $1MOuf.ConfigClient)(new (0, $ia7Qf.BifrostDataSource)(new (0, $hgXMP.BifrostHttpClientImpl)(env, perimeter), (0, $9zB5r.Versions).ManifestVersion), "Bifrost", fetchArtifactExperience, fetchVersionMetadataExperience);
}
/**
 *
 * This function is necessary since all artifacts are tagged using an environment,
 * so to get an artifact we need to specify an environment. However, users only
 * specify an environmentType since that's all that matters to them. Flight Deck
 * ensures that frontend artifacts don't vary based on region so this is safe to do.
 *
 * @param environmentDependentDimensions
 * @returns a specific environment that has that envtype
 */ function $37e7d2b813017b8f$var$getEnvFromEnvType(environment) {
    if (environment === undefined || environment === "prod") return "prod-west";
    switch(environment){
        case "stg":
            return "stg-west";
        case "adev":
            return "adev";
        case "ddev":
            return "ddev";
        case "pdev":
            return "pdev-apse2";
        case "fedex":
            return "stg-apse";
    }
}

});
parcelRegister("2hVi7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1aa99c250c6901b2$export$2e2bcd8739ae039; });
/**
 * This function is being used to address locale discrepancies in Atlassian products;
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ var $1aa99c250c6901b2$export$852ff24d0930c62f = function mapLocaleToPrsLocale(locale) {
    var standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-US':
        case 'en-GB':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $1aa99c250c6901b2$export$2e2bcd8739ae039 = $1aa99c250c6901b2$export$852ff24d0930c62f;

});

parcelRegister("9zB5r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = module.exports.ConfigRegistryDataSource = module.exports.checkManifest = module.exports.parseVersionMetadata = module.exports.parseArtifactManifest = module.exports.tryGetArtifactData = module.exports.getArtifactFromSource = module.exports.Either = void 0;

var $5NcNp = parcelRequire("5NcNp");
Object.defineProperty(module.exports, "Either", {
    enumerable: true,
    get: function() {
        return $5NcNp.Either;
    }
});

var $gubMS = parcelRequire("gubMS");
Object.defineProperty(module.exports, "getArtifactFromSource", {
    enumerable: true,
    get: function() {
        return $gubMS.getArtifactFromSource;
    }
});
Object.defineProperty(module.exports, "tryGetArtifactData", {
    enumerable: true,
    get: function() {
        return $gubMS.tryGetArtifactData;
    }
});

var $4TYFU = parcelRequire("4TYFU");
Object.defineProperty(module.exports, "parseArtifactManifest", {
    enumerable: true,
    get: function() {
        return $4TYFU.parseArtifactManifest;
    }
});

var $40yiy = parcelRequire("40yiy");
Object.defineProperty(module.exports, "parseVersionMetadata", {
    enumerable: true,
    get: function() {
        return $40yiy.parseVersionMetadata;
    }
});

var $8PjUn = parcelRequire("8PjUn");
Object.defineProperty(module.exports, "checkManifest", {
    enumerable: true,
    get: function() {
        return $8PjUn.checkManifest;
    }
});

var $6lwzY = parcelRequire("6lwzY");
Object.defineProperty(module.exports, "ConfigRegistryDataSource", {
    enumerable: true,
    get: function() {
        return $6lwzY.ConfigRegistryDataSource;
    }
});

var $3L3ce = parcelRequire("3L3ce");
Object.defineProperty(module.exports, "BaseUrls", {
    enumerable: true,
    get: function() {
        return $3L3ce.BaseUrls;
    }
});
Object.defineProperty(module.exports, "Versions", {
    enumerable: true,
    get: function() {
        return $3L3ce.Versions;
    }
});

});
parcelRegister("5NcNp", function(module, exports) {
"use strict";
var $437b745a00a9d3f9$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Either = void 0;
var $437b745a00a9d3f9$var$Either = /** @class */ function() {
    function Either() {}
    Either.prototype.map = function(f) {
        return this.flatMap(function(a) {
            return Either.right(f(a));
        });
    };
    Either.right = function(value) {
        return new $437b745a00a9d3f9$var$Right(value);
    };
    Either.left = function(error) {
        return new $437b745a00a9d3f9$var$Left(error);
    };
    return Either;
}();
module.exports.Either = $437b745a00a9d3f9$var$Either;
var $437b745a00a9d3f9$var$Right = /** @class */ function(_super) {
    $437b745a00a9d3f9$var$__extends(Right, _super);
    function Right(r) {
        var _this = _super.call(this) || this;
        _this.right = r;
        return _this;
    }
    Right.prototype.bimap = function(_f, g) {
        return $437b745a00a9d3f9$var$Either.right(g(this.right));
    };
    Right.prototype.flatMap = function(f) {
        return f(this.right);
    };
    Right.prototype.fold = function(_onLeft, onRight) {
        return onRight(this.right);
    };
    Right.prototype.leftMap = function(_f) {
        return $437b745a00a9d3f9$var$Either.right(this.right);
    };
    return Right;
}($437b745a00a9d3f9$var$Either);
var $437b745a00a9d3f9$var$Left = /** @class */ function(_super) {
    $437b745a00a9d3f9$var$__extends(Left, _super);
    function Left(e) {
        var _this = _super.call(this) || this;
        _this.left = e;
        return _this;
    }
    Left.prototype.bimap = function(f, _g) {
        return $437b745a00a9d3f9$var$Either.left(f(this.left));
    };
    Left.prototype.flatMap = function(_f) {
        return $437b745a00a9d3f9$var$Either.left(this.left);
    };
    Left.prototype.fold = function(onLeft, _onRight) {
        return onLeft(this.left);
    };
    Left.prototype.leftMap = function(f) {
        return $437b745a00a9d3f9$var$Either.left(f(this.left));
    };
    return Left;
}($437b745a00a9d3f9$var$Either);

});

parcelRegister("gubMS", function(module, exports) {
"use strict";
var $c0089769980bdb91$var$__assign = module.exports && module.exports.__assign || function() {
    $c0089769980bdb91$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c0089769980bdb91$var$__assign.apply(this, arguments);
};
var $c0089769980bdb91$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c0089769980bdb91$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getArtifactFromSource = $c0089769980bdb91$var$getArtifactFromSource;
module.exports.tryGetArtifactData = $c0089769980bdb91$var$tryGetArtifactData;

var $hbtOD = parcelRequire("hbtOD");

var $9zB5r = parcelRequire("9zB5r");

var $304Us = parcelRequire("304Us");

var $btDQD = parcelRequire("btDQD");

var $2FfAj = parcelRequire("2FfAj");
function $c0089769980bdb91$var$getArtifactFromSource(dataSource, specifiedDimensions, deniedArtifactType) {
    return $c0089769980bdb91$var$__awaiter(this, void 0, void 0, function() {
        var manifestResult;
        var _this = this;
        return $c0089769980bdb91$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        dataSource.getManifest(specifiedDimensions.name, specifiedDimensions.version)
                    ];
                case 1:
                    manifestResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        manifestResult.fold(function(error) {
                            return Promise.resolve({
                                type: "manifest-fetch-error",
                                error: error
                            });
                        }, function(manifest) {
                            return $c0089769980bdb91$var$__awaiter(_this, void 0, void 0, function() {
                                var manifestCheckResult, publishMetadata, dimensionContextResult;
                                return $c0089769980bdb91$var$__generator(this, function(_a) {
                                    manifestCheckResult = (0, $9zB5r.checkManifest)(manifest, {
                                        name: specifiedDimensions.name,
                                        version: specifiedDimensions.version
                                    });
                                    if (manifestCheckResult.key !== "success") return [
                                        2 /*return*/ ,
                                        {
                                            type: manifestCheckResult.key
                                        }
                                    ];
                                    publishMetadata = manifest.publishMetadata;
                                    if (manifest.frontend && deniedArtifactType === "frontend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "frontend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    else if (!manifest.frontend && deniedArtifactType === "backend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "backend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    dimensionContextResult = (0, $304Us.getDimensionContext)(specifiedDimensions, manifest);
                                    switch(dimensionContextResult.type){
                                        case "missing-dimension-specification":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "missing-dimension-specification",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "unsupported-value-specified-for-supported-dimension":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "unsupported-value-specified-for-supported-dimension",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "success":
                                            return [
                                                2 /*return*/ ,
                                                $c0089769980bdb91$var$getArtifact(dataSource, manifest, dimensionContextResult.dimensionContext)
                                            ];
                                        default:
                                            (0, $btDQD.assertUnreachable)(dimensionContextResult);
                                    }
                                    return [
                                        2 /*return*/ 
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $c0089769980bdb91$var$getArtifact(dataSource, manifest, dimensionContext) {
    return $c0089769980bdb91$var$__awaiter(this, void 0, void 0, function() {
        var publishMetadata, tag, artifactResult;
        var _this = this;
        return $c0089769980bdb91$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    publishMetadata = manifest.publishMetadata;
                    try {
                        tag = (0, $hbtOD.interpolateTagScheme)(manifest.tagScheme, $c0089769980bdb91$var$__assign($c0089769980bdb91$var$__assign({}, dimensionContext), {
                            name: manifest.name
                        }));
                    } catch (e) {
                        return [
                            2 /*return*/ ,
                            {
                                type: "tag-scheme-interpolation-error",
                                publishMetadata: publishMetadata
                            }
                        ];
                    }
                    return [
                        4 /*yield*/ ,
                        dataSource.getArtifact(manifest.name, tag)
                    ];
                case 1:
                    artifactResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        artifactResult.fold(function(error) {
                            return Promise.resolve({
                                type: "artifact-fetch-error",
                                error: error,
                                publishMetadata: publishMetadata
                            });
                        }, function(data) {
                            return $c0089769980bdb91$var$__awaiter(_this, void 0, void 0, function() {
                                return $c0089769980bdb91$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        {
                                            type: "success",
                                            data: data,
                                            publishMetadata: publishMetadata,
                                            artifactVersion: dimensionContext["version"]
                                        }
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $c0089769980bdb91$var$tryGetArtifactData(artifact, dataSourceName) {
    switch(artifact.type){
        case "manifest-fetch-error":
            throw new Error("Unable to fetch manifest due to ".concat(dataSourceName, " response error: ").concat((0, $2FfAj.toPrettyJson)(artifact.error)));
        case "artifact-fetch-error":
            throw new Error("Unable to fetch artifact due to ".concat(dataSourceName, " response error: ").concat((0, $2FfAj.toPrettyJson)(artifact.error)));
        case "denied-artifact-type":
            throw new Error("No artifacts should be denied, but type ".concat(artifact.deniedType, " was denied."));
        case "unsupported-value-specified-for-supported-dimension":
            throw new Error("An unsupported value was specified for a supported dimension");
        case "missing-dimension-specification":
            throw new Error("A required dimension specification was missing");
        case "tag-scheme-interpolation-error":
            throw new Error("Ran into failure when trying to interpolate tag scheme");
        case "mismatched-manifest-name":
            throw new Error("Manifest has been corrupted. Manifest name is mismatched.");
        case "mismatched-manifest-version":
            throw new Error("Manifest has been corrupted. Manifest version is mismatched.");
        case "success":
            return artifact.data;
        default:
            (0, $btDQD.assertUnreachable)(artifact);
    }
}

});
parcelRegister("hbtOD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTagScheme = $c82a9786233d5a82$var$interpolateTagScheme;
module.exports.generateTagScheme = $c82a9786233d5a82$var$generateTagScheme;
module.exports.getDimensionsFromTagScheme = $c82a9786233d5a82$var$getDimensionsFromTagScheme;
module.exports.getDataTagForManifest = $c82a9786233d5a82$var$getDataTagForManifest;
module.exports.getVersionMetadataTag = $c82a9786233d5a82$var$getVersionMetadataTag;
const $c82a9786233d5a82$var$TAG_SCHEME_VERSION = 2;
function $c82a9786233d5a82$var$interpolateTagScheme(tagSchema, context) {
    const dimensions = Array.from($c82a9786233d5a82$var$getDimensionsFromTagScheme(tagSchema));
    return dimensions.reduce((interpolatedTagScheme, dimension)=>{
        if (context.hasOwnProperty(dimension)) return interpolatedTagScheme.replace(new RegExp(`\\$${dimension}\\$`, "g"), context[dimension]);
        else {
            const contextAsJson = $c82a9786233d5a82$var$toPrettyJson(context);
            throw new Error(`Bad variable "${dimension}" found enclosed in '$', so cannot infer
                     filename for artifact from tag schema: was expecting that
                     '${dimension}' would be a known dimension passed in context. This
                     is most likely a bug in Flight Deck. To help you debug, the Context
                     received was:\n"${contextAsJson}"\nOne of the keys in that object should
                     have been '${contextAsJson}'.`);
        }
    }, tagSchema);
}
/**
 *
 * @param dimensions - the dimensions that this tag scheme needs to use
 *
 * @param supportedDimensionPrefixes - a map of those dimensions to
 * shortened versions (ie name to n)
 *
 *  @param effectiveContextDimension - maps dimensions down into dimensions supported
 *  by original context. NOTE:
 *
 *  There is only 1 correct implementation of this function, but
 *  it is not defined in this module because the most typesafe
 *  (least error prone) definition of this function requires referencing
 *  the specific dimension types (specific available dimensions), and
 *  we are intentionally keeping this module unaware of the specific
 *  dimensions to enable adding/changing dimensions easily in consumers
 *  which use this tags library. So therefore we define effectiveContextDimension
 *  outside of this package, but accept it as an argument. Note that in this
 *  package we redefine the meaning of common Flight Deck types (e.g.
 *  Dimension == string, rather than the specific subset of supported
 *  dimension strings), so when generateTagScheme is called then effectiveContextDimension
 *  needs to be cast (using `as`) in order to have the types
 *
 * @returns a generated schema
 */ function $c82a9786233d5a82$var$generateTagScheme(dimensions, supportedDimensionPrefixes, effectiveContextDimension = (d)=>d) {
    const effectiveDimensions = new Set([
        ...dimensions
    ].map(effectiveContextDimension));
    for (const dimensionToInclude of effectiveDimensions){
        if (!supportedDimensionPrefixes.has(effectiveContextDimension(dimensionToInclude))) throw new Error([
            `Building a tag scheme failed! The dimension '${dimensionToInclude}' is not `,
            `recognized as a dimension (known dimensions are ${[
                ...supportedDimensionPrefixes.keys()
            ].join(", ")}!`
        ].join(" "));
    }
    // pad the version number to 3 digits (e.g. 001, 002, 003, etc) so that artifacts will sort by
    // version when sorted lexicographically (helpful for debugging)
    const padded_version = $c82a9786233d5a82$var$TAG_SCHEME_VERSION.toString().padStart(3, "0");
    // IMPORTANT! Update {@link TAG_SCHEME_VERSION} if you change the tagging scheme logic!
    let tagScheme = `v${padded_version}`;
    for (const entry of supportedDimensionPrefixes.entries()){
        const [dimension, prefix] = entry;
        if (effectiveDimensions.has(dimension)) // We avoid using `:` or `/` or `\` as separator characters because these characters have
        // meaning on certain filesystems that make them painful to work with; we also don't use
        // ` ` or similar because whitespace characters are the default values used by shells
        // to word-split, which makes scripting harder (see https://bash.cyberciti.biz/guide/$IFS ).
        tagScheme += `-${prefix}_$${dimension}$`;
    }
    return tagScheme;
}
// Important! Context: Front end client will be using old version of tags.When we make changes to this function
// we need to be extra cautious that it will be compatible with older versions
// Step -1
// we have test in frontend package :integration-test/frontend/frontend-fetch.spec.ts to test oldest front end client
// make sure we add sample artifact to the test which will test newest functionality against oldest client
// Step-2
// Update manifest version across flight-deck
// step-3
// update manifest version in poop-deck repo
// step-4
// communicate with external customers and #flight-deck channel announcements
// step-5
// Update oldest supported version in integration-test/frontend/frontend-fetch.spec.ts and the test will be passed
function $c82a9786233d5a82$var$getDimensionsFromTagScheme(tagSchema) {
    // regex to get all dimensions
    // for a dimension:
    // \$ means the expression starts with a `$` sign
    // [A-Za-z]+ means dollar sign is followed by one or more alphabetical chars
    // \$ means the dimension ends with a `$` sign
    const dimensionsFormat = /\$([A-Za-z]+)\$/g;
    // regex to ensure that we have the right format
    // for the dimension format:
    // ^v means it must start with a v
    // \d{3} means it is followed by three digits
    // ?: tries to match the expression without capturing the group
    // -[a-z]_ means expression starts with `-<single lowercase a-z char>_`
    // (\$[A-Za-z]+\$) defines that a dimension is in the format `<one or more alphabetical chars>` and this group is captured.
    // + means we could have one or more dimensions.
    // $ means we must end at the end of a dimension.
    const tagSchemeFormat = /^v\d{3}(?:-[a-z]_(\$[A-Za-z]+\$))+$/;
    const isValidTag = tagSchemeFormat.test(tagSchema);
    if (!isValidTag) throw new Error(`The provided tag scheme: "${tagSchema}" is invalid.
                Tag schemes must have the following format:
                v<3 digit number>-<letter>$<dimension_name>$
                where -<letter>$<dimension_name>$ can be repeated
                and all characters of <letter> and <dimension_name>
                must be alphabetical characters
                e.g "v001-n_$name$-d_$dimension$" is a valid tag scheme`);
    const allDim = Array.from(tagSchema.matchAll(dimensionsFormat));
    try {
        // Grab the second element of each element in matches
        const captures = allDim.map(([_, capture])=>capture);
        const dimensions = new Set(captures);
        return dimensions;
    } catch (e) {
        throw new Error(`Could not capture dimensions. Expected dimension format to look like 
             ${dimensionsFormat}`);
    }
}
function $c82a9786233d5a82$var$getDataTagForManifest(artifactName, manifestVersion, artifactVersion) {
    return artifactVersion === undefined ? `${artifactName}_manifest_${manifestVersion}` : `${artifactName}_${artifactVersion}_manifest_${manifestVersion}`;
}
function $c82a9786233d5a82$var$getVersionMetadataTag(version) {
    return version ? `version_metadata_${version}` : "version_metadata";
}
function $c82a9786233d5a82$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});

parcelRegister("304Us", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDimensionContext = $22f52e25a403a4d1$var$getDimensionContext;
/**
 * Resolves a record of Dimensions and their values based on the manifest
 * and the user specified dimensions values.
 *
 * If a dimension is not specified by the user, then the fallback value
 * will be used as the value for that dimension. If the fallback value
 * does not exist in this case, then a "missing-dimension-specification"
 * result will be reported.
 *
 * If a dimension value specified by the user is not part of the list
 * of supported values, then the dimension value will be the fallback
 * value defined. If a fallback value does not exist for that dimension,
 * then an "unsupported-value-specified-for-supported-dimension" result
 * will be reported.
 *
 * Otherwise, a "success" result will be reported on a valid context
 * resolution.
 *
 * @param specifiedDimensions the dimensions the user specified
 * @param manifest the manifest to validate and fallback user specifications
 * @returns a record of Dimensions and their valid values, or an error type
 *      if a record of valid values could not be derived from the user input
 */ function $22f52e25a403a4d1$var$getDimensionContext(specifiedDimensions, manifest) {
    var dimensionToValues = {};
    for(var dimension in manifest.dimensions){
        var manifestDimensionSpecs = manifest.dimensions[dimension];
        var dimensionValue = specifiedDimensions[dimension];
        var fallback = manifestDimensionSpecs.fallback;
        if (dimensionValue === undefined) {
            if (fallback === undefined) return {
                type: "missing-dimension-specification"
            };
            else dimensionValue = fallback;
        }
        if (!manifestDimensionSpecs.supported.includes(dimensionValue)) {
            if (fallback === undefined) return {
                type: "unsupported-value-specified-for-supported-dimension"
            };
            else dimensionValue = fallback;
        }
        dimensionToValues[dimension] = dimensionValue;
    }
    return {
        type: "success",
        dimensionContext: dimensionToValues
    };
}

});

parcelRegister("btDQD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertUnreachable = $85b1501b423ea552$var$assertUnreachable;
function $85b1501b423ea552$var$assertUnreachable(_x) {
    throw new Error("This function should never be called. This is for yielding compile errors on non-exhaustive case checking.");
}

});

parcelRegister("2FfAj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toJson = $1f0b7fe01c629eb8$var$toJson;
module.exports.toPrettyJson = $1f0b7fe01c629eb8$var$toPrettyJson;
function $1f0b7fe01c629eb8$var$toJson(buffer) {
    return JSON.parse(buffer.toString());
}
function $1f0b7fe01c629eb8$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});


parcelRegister("4TYFU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseArtifactManifest = $391b5d45c7d5c1c2$var$parseArtifactManifest;

var $4e7Ar = parcelRequire("4e7Ar");
function $391b5d45c7d5c1c2$var$parseMetricTags(metricTags) {
    var unparsedMetricTags = (0, $4e7Ar.parseUnknownObject)(metricTags);
    var parsedMetricTags = {};
    for(var _i = 0, _a = Object.keys(unparsedMetricTags); _i < _a.length; _i++){
        var key = _a[_i];
        var tag = (0, $4e7Ar.parseString)(unparsedMetricTags[key]);
        parsedMetricTags[key] = tag;
    }
    return parsedMetricTags;
}
function $391b5d45c7d5c1c2$var$parsePublishMetadata(publishMetadata) {
    var unparsedPublishMetadata = (0, $4e7Ar.parseUnknownObject)(publishMetadata);
    var metricTags = "metricTags" in unparsedPublishMetadata ? $391b5d45c7d5c1c2$var$parseMetricTags(unparsedPublishMetadata.metricTags) : undefined;
    return {
        metricTags: metricTags
    };
}
function $391b5d45c7d5c1c2$var$parseDimensions(dimensions) {
    var unparsedDimensions = (0, $4e7Ar.parseUnknownObject)(dimensions);
    var supported = (0, $4e7Ar.parseArray)(unparsedDimensions.supported).map($4e7Ar.parseString);
    var fallback = (0, $4e7Ar.parseUndefinedOr)($4e7Ar.parseString, unparsedDimensions.fallback);
    return {
        fallback: fallback,
        supported: supported
    };
}
function $391b5d45c7d5c1c2$var$parseDimensionsRecord(dimensionRecord) {
    var parsedDimensionRecord = {};
    var unparsedDimensionRecord = (0, $4e7Ar.parseUnknownObject)(dimensionRecord);
    for(var _i = 0, _a = Object.keys(unparsedDimensionRecord); _i < _a.length; _i++){
        var key = _a[_i];
        var dimensionsSpec = $391b5d45c7d5c1c2$var$parseDimensions(unparsedDimensionRecord[key]);
        parsedDimensionRecord[key] = dimensionsSpec;
    }
    return parsedDimensionRecord;
}
function $391b5d45c7d5c1c2$var$parseArtifactManifest(potentialArtifactManifest) {
    var unparsedArtifactManifest = (0, $4e7Ar.parseUnknownObject)(potentialArtifactManifest);
    var name = (0, $4e7Ar.parseString)(unparsedArtifactManifest.name);
    var tagScheme = (0, $4e7Ar.parseString)(unparsedArtifactManifest.tagScheme);
    var frontend = (0, $4e7Ar.parseUndefinedOr)($4e7Ar.parseBoolean, unparsedArtifactManifest.frontend);
    var dimensions = $391b5d45c7d5c1c2$var$parseDimensionsRecord(unparsedArtifactManifest.dimensions);
    var publishMetadata = $391b5d45c7d5c1c2$var$parsePublishMetadata(unparsedArtifactManifest.publishMetadata);
    return {
        name: name,
        frontend: frontend,
        tagScheme: tagScheme,
        dimensions: dimensions,
        publishMetadata: publishMetadata
    };
}

});
parcelRegister("4e7Ar", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseString = $313e5acf31b69ea6$var$parseString;
module.exports.parseArray = $313e5acf31b69ea6$var$parseArray;
module.exports.parseBoolean = $313e5acf31b69ea6$var$parseBoolean;
module.exports.parseUnknownObject = $313e5acf31b69ea6$var$parseUnknownObject;
module.exports.parseUndefinedOr = $313e5acf31b69ea6$var$parseUndefinedOr;
function $313e5acf31b69ea6$var$parseString(string) {
    if (typeof string === "string") return string;
    throw new Error("Couldn't parse String");
}
function $313e5acf31b69ea6$var$parseArray(array) {
    if (Array.isArray(array)) return array;
    throw new Error("Couldn't parse List or Undefined");
}
function $313e5acf31b69ea6$var$parseBoolean(boolean) {
    if (typeof boolean === "boolean") return boolean;
    throw new Error("Couldn't parse Boolean or undefined");
}
function $313e5acf31b69ea6$var$parseUnknownObject(object) {
    if (typeof object === "object") return object;
    throw new Error("Couldn't parse object");
}
function $313e5acf31b69ea6$var$parseUndefinedOr(parse, thing) {
    if (typeof thing === "undefined") return thing;
    else return parse(thing);
}

});


parcelRegister("40yiy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseVersionMetadata = $2eb1c469e5a32cf2$var$parseVersionMetadata;

var $4e7Ar = parcelRequire("4e7Ar");
function $2eb1c469e5a32cf2$var$parseVersionMetadata(possiblyVersionMetadata) {
    var unknownObject = (0, $4e7Ar.parseUnknownObject)(possiblyVersionMetadata);
    var version = (0, $4e7Ar.parseString)(unknownObject.version);
    var publishTime = new Date((0, $4e7Ar.parseString)(unknownObject.publishTime));
    var sidecarImageDigestVersion = (0, $4e7Ar.parseString)(unknownObject.sidecarImageDigestVersion);
    return {
        version: version,
        publishTime: publishTime,
        sidecarImageDigestVersion: sidecarImageDigestVersion
    };
}

});

parcelRegister("8PjUn", function(module, exports) {
"use strict";
var $66d2878a3a9bd1fb$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkManifest = $66d2878a3a9bd1fb$var$checkManifest;
/**
 * @param manifest manifest retrieved from data source
 * @param request request used to retrieve manifest (ie the artifact name and version specified)
 * @returns the manifest, but now it is guaranteed that the manifest name is the same as the requested name,
 * the version is the same as the requested version (if one is requested) and the version dimension (if it exists)
 * specifies exactly one version
 */ function $66d2878a3a9bd1fb$var$checkManifest(manifest, request) {
    if (manifest.name !== request.name) return {
        key: "mismatched-manifest-name"
    };
    var manifestVersionDimension = manifest.dimensions.version;
    if (request.version) {
        var manifestVersions = manifestVersionDimension ? $66d2878a3a9bd1fb$var$__spreadArray([
            manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.fallback
        ], manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.supported, true).filter(function(s) {
            return !!s;
        }) : [];
        var allVersionsMatch = manifestVersions.every(function(v) {
            return v === request.version;
        });
        if (!allVersionsMatch || manifestVersions.length === 0) return {
            key: "mismatched-manifest-version"
        };
    }
    return {
        key: "success"
    };
}

});

parcelRegister("6lwzY", function(module, exports) {
"use strict";
var $49edf9ca1d9517f7$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $49edf9ca1d9517f7$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigRegistryDataSource = void 0;

var $hbtOD = parcelRequire("hbtOD");

var $5NcNp = parcelRequire("5NcNp");

var $4TYFU = parcelRequire("4TYFU");

var $40yiy = parcelRequire("40yiy");
var $49edf9ca1d9517f7$var$ConfigRegistryDataSource = /** @class */ function() {
    function ConfigRegistryDataSource(manifestVersion, configRegistryHttpClient) {
        this.manifestVersion = manifestVersion;
        this.configRegistryHttpClient = configRegistryHttpClient;
    }
    ConfigRegistryDataSource.prototype.getManifest = function(artifactName, artifactVersion) {
        return $49edf9ca1d9517f7$var$__awaiter(this, void 0, void 0, function() {
            var tag, configRegistryResponse, e_1;
            return $49edf9ca1d9517f7$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        tag = (0, $hbtOD.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 2:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.leftMap(function(e) {
                                return e;
                            }).map($4TYFU.parseArtifactManifest)
                        ];
                    case 3:
                        e_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            $5NcNp.Either.left({
                                key: "config-registry-error",
                                error: e_1
                            })
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getArtifact = function(_artifactName, tag) {
        return $49edf9ca1d9517f7$var$__awaiter(this, void 0, void 0, function() {
            return $49edf9ca1d9517f7$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getLatestVersionMetadata = function() {
        return $49edf9ca1d9517f7$var$__awaiter(this, void 0, void 0, function() {
            var dataTag, configRegistryResponse;
            return $49edf9ca1d9517f7$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        dataTag = (0, $hbtOD.getVersionMetadataTag)();
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(dataTag)
                        ];
                    case 1:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.bimap(function(error) {
                                return error;
                            }, function(response) {
                                return (0, $40yiy.parseVersionMetadata)(response);
                            })
                        ];
                }
            });
        });
    };
    return ConfigRegistryDataSource;
}();
module.exports.ConfigRegistryDataSource = $49edf9ca1d9517f7$var$ConfigRegistryDataSource;

});

parcelRegister("3L3ce", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = void 0;
var $2bc83d9fdb657ba9$var$BaseUrls = /** @class */ function() {
    function BaseUrls() {}
    BaseUrls.ConfigRegistryProd = "https://config-registry.prod.atl-paas.net";
    return BaseUrls;
}();
module.exports.BaseUrls = $2bc83d9fdb657ba9$var$BaseUrls;
var $2bc83d9fdb657ba9$var$Versions = /** @class */ function() {
    function Versions() {}
    Versions.ManifestVersion = "v1";
    return Versions;
}();
module.exports.Versions = $2bc83d9fdb657ba9$var$Versions;

});


parcelRegister("ia7Qf", function(module, exports) {
$parcel$export(module.exports, "BifrostDataSource", function () { return $d38f3e57bde984ec$export$2cb8d79200775058; });

var $9zB5r = parcelRequire("9zB5r");

var $hbtOD = parcelRequire("hbtOD");
class $d38f3e57bde984ec$export$2cb8d79200775058 {
    constructor(bifrostClient, manifestVersion){
        this.bifrostClient = bifrostClient;
        this.manifestVersion = manifestVersion;
    }
    async getLatestVersionMetadata() {
        const tag = (0, $hbtOD.getVersionMetadataTag)();
        const bifrostResponse = await this.bifrostClient.getBlob(`${tag}.json`);
        return bifrostResponse.fold((error)=>{
            return (0, $9zB5r.Either).left(error);
        }, (response)=>{
            try {
                const parsedVersionMetadata = (0, $9zB5r.parseVersionMetadata)(response);
                return (0, $9zB5r.Either).right(parsedVersionMetadata);
            } catch (e) {
                const error = {
                    key: "invalid-version-metadata"
                };
                return (0, $9zB5r.Either).left(error);
            }
        });
    }
    async getManifest(artifactName, artifactVersion) {
        const manifestTag = (0, $hbtOD.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
        const bifrostResponse = await this.bifrostClient.getBlob(`${manifestTag}.json`, artifactName);
        return bifrostResponse.fold((error)=>{
            return (0, $9zB5r.Either).left(error);
        }, (response)=>{
            try {
                const parsedArtifact = (0, $9zB5r.parseArtifactManifest)(response);
                return (0, $9zB5r.Either).right(parsedArtifact);
            } catch (e) {
                const error = {
                    key: "invalid-manifest"
                };
                return (0, $9zB5r.Either).left(error);
            }
        });
    }
    async getArtifact(artifactName, tag) {
        return this.bifrostClient.getBlob(`${tag}.json`, artifactName);
    }
}

});

parcelRegister("hgXMP", function(module, exports) {
$parcel$export(module.exports, "BifrostHttpClientImpl", function () { return $c9324ea40e9aaf6a$export$45c6d12ca9c14f83; });

var $9zB5r = parcelRequire("9zB5r");
function $c9324ea40e9aaf6a$export$f654b28f82155665(env, perimeter) {
    if (perimeter === "commercial") switch(env){
        case "adev":
        case "ddev":
        case "pdev":
        case "stg":
            return "https://fd-config-bifrost.stg-east.frontend.public.atl-paas.net";
        case "prod":
            return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
    }
    else if (perimeter === "fedramp-moderate") switch(env){
        case "stg":
            return "https://fd-config-bifrost.stg.frontend.cdn.atlassian-us-gov-mod.com";
        case "prod":
            return "https://fd-config-bifrost.frontend.cdn.atlassian-us-gov-mod.com";
    }
    return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
}
class $c9324ea40e9aaf6a$export$45c6d12ca9c14f83 {
    constructor(env, perimeter){
        this.baseUrl = $c9324ea40e9aaf6a$export$f654b28f82155665(env, perimeter);
    }
    async getBlob(tag) {
        const endpoint = `${this.baseUrl}/assets/${tag}`;
        return new Promise((resolve)=>fetch(endpoint).then((response)=>{
                if (!response.ok) resolve((0, $9zB5r.Either).left({
                    key: "unexpected-response-code",
                    httpResponseCode: response.status,
                    httpResponseStatusText: response.statusText
                }));
                response.json().then((json)=>resolve((0, $9zB5r.Either).right(json)));
            }).catch((error)=>resolve((0, $9zB5r.Either).left({
                    key: "failed-fetch",
                    error: "message" in error ? error.message : "unknown error"
                }))));
    }
}

});

parcelRegister("1MOuf", function(module, exports) {
$parcel$export(module.exports, "ConfigClient", function () { return $14d16fcbc5539836$export$8489e2f039bfcc4c; });

var $f53LC = parcelRequire("f53LC");

var $9zB5r = parcelRequire("9zB5r");

var $4Uq7P = parcelRequire("4Uq7P");
function $14d16fcbc5539836$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $14d16fcbc5539836$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $14d16fcbc5539836$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $14d16fcbc5539836$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $14d16fcbc5539836$export$8489e2f039bfcc4c {
    constructor(dataSource, dataSourceName, fetchArtifactExperience, versionMetadataExperience){
        this.fetchArtifactExperience = fetchArtifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
        this.dataSource = new (0, $4Uq7P.ExperienceDataSourceWrapper)(dataSource, this.fetchArtifactExperience, this.versionMetadataExperience);
        this.dataSourceName = dataSourceName;
    }
    async getArtifact(artifactName, dimensions) {
        this.fetchArtifactExperience.addMetadata(dimensions);
        this.fetchArtifactExperience.start();
        const specifiedDimensions = $14d16fcbc5539836$var$_objectSpread($14d16fcbc5539836$var$_objectSpread({}, dimensions), {}, {
            name: artifactName
        });
        const artifact = await (0, $9zB5r.getArtifactFromSource)(this.dataSource, specifiedDimensions, "backend").catch((e)=>({
                type: "artifact-fetch-error",
                publishMetadata: {},
                error: {
                    key: "unexpected-error",
                    error: e
                }
            }));
        if (artifact.type === "success") this.fetchArtifactExperience.success();
        else {
            this.fetchArtifactExperience.addMetadata({
                errorType: artifact.type,
                error: "error" in artifact ? artifact.error.key : undefined
            });
            this.fetchArtifactExperience.failure();
        }
        return (0, $9zB5r.tryGetArtifactData)(artifact, this.dataSourceName);
    }
    async getLatestVersionMetadata() {
        this.versionMetadataExperience.start();
        const getVersionMetadataResult = await this.dataSource.getLatestVersionMetadata();
        return getVersionMetadataResult.fold((error)=>{
            this.versionMetadataExperience.addMetadata({
                error: error.key
            });
            this.versionMetadataExperience.failure();
            throw new Error(`Unable to get latest version metadata from ${this.dataSourceName} due to error: ${error.key}`);
        }, (data)=>{
            this.versionMetadataExperience.success();
            return data;
        });
    }
}

});
parcelRegister("4Uq7P", function(module, exports) {
$parcel$export(module.exports, "ExperienceDataSourceWrapper", function () { return $3930a850de1f3604$export$1cc944571619e6e8; });
/**
 * Wraps a standard Datasource as defined by @atlassiansox/flight-deck-core && uses
 * the experience to mark when events happen.
 */ class $3930a850de1f3604$export$1cc944571619e6e8 {
    constructor(dataSource, artifactExperience, versionMetadataExperience){
        this.dataSource = dataSource;
        this.artifactExperience = artifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
    }
    getLatestVersionMetadata() {
        this.versionMetadataExperience.mark("start-fetch-metadata");
        const result = this.dataSource.getLatestVersionMetadata();
        this.versionMetadataExperience.mark("end-fetch-metadata");
        return result;
    }
    async getManifest(artifactName, artifactVersion) {
        this.artifactExperience.mark("start-fetch-artifact");
        const result = await this.dataSource.getManifest(artifactName, artifactVersion);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getManifestError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-artifact");
        return result;
    }
    async getArtifact(artifactName, tag) {
        this.artifactExperience.mark("start-fetch-manifest");
        const result = await this.dataSource.getArtifact(artifactName, tag);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getArtifactError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-manifest");
        return result;
    }
}

});


parcelRegister("eRMh2", function(module, exports) {
$parcel$export(module.exports, "getFlightDeckFetchExperience", function () { return $ad2b76163ebd593f$export$a3006f8f221c0a3b; });
$parcel$export(module.exports, "getVersionMetadataFetchExperience", function () { return $ad2b76163ebd593f$export$c3ac7702bfd47c1b; });
const $ad2b76163ebd593f$var$SAMPLING_RATE = 10;
class $ad2b76163ebd593f$var$UFOExperienceWrapper {
    constructor(experience){
        this.experience = experience;
    }
    start(startTime) {
        return this.experience.start(startTime);
    }
    success() {
        return this.experience.success();
    }
    failure() {
        return this.experience.failure();
    }
    addMetadata(data) {
        return this.experience.addMetadata(data);
    }
    mark(mark) {
        return this.experience.mark(mark);
    }
}
class $ad2b76163ebd593f$export$5e7536cf7bc56fee {
    start() {
        return Promise.resolve();
    }
    success() {
        return Promise.resolve(null);
    }
    failure() {
        return Promise.resolve(null);
    }
    mark() {
        return;
    }
    addMetadata() {
        return;
    }
}

async function $ad2b76163ebd593f$var$flightDeckSDKOperationExperience(id, timings, metadata) {
    try {
        // only emit metrics 1 in every 10 times a Flight Deck Configuration is fetched
        // to not flood Perf Portal with logs.
        if (Math.random() * 100 > $ad2b76163ebd593f$var$SAMPLING_RATE) return new $ad2b76163ebd593f$export$5e7536cf7bc56fee();
        const { UFOExperience: UFOExperience, ExperienceTypes: ExperienceTypes, ExperiencePerformanceTypes: ExperiencePerformanceTypes } = await (parcelRequire("8TMPL"));
        const ufoExperience = new UFOExperience(id, {
            type: ExperienceTypes.Operation,
            performanceType: ExperiencePerformanceTypes.Custom,
            platform: {
                component: "flight-deck-client"
            },
            timings: timings
        });
        ufoExperience.addMetadata(metadata);
        return new $ad2b76163ebd593f$var$UFOExperienceWrapper(ufoExperience);
    } catch (_unused) {
        return new $ad2b76163ebd593f$export$5e7536cf7bc56fee();
    }
}
const $ad2b76163ebd593f$export$a3006f8f221c0a3b = ()=>$ad2b76163ebd593f$var$flightDeckSDKOperationExperience("fetch", [
        {
            key: "fetch-artifact",
            endMark: "end-fetch-artifact",
            startMark: "start-fetch-artifact"
        },
        {
            key: "fetch-manifest",
            endMark: "end-fetch-manifest",
            startMark: "start-fetch-manifest"
        }
    ], {});
const $ad2b76163ebd593f$export$c3ac7702bfd47c1b = ()=>$ad2b76163ebd593f$var$flightDeckSDKOperationExperience("fetch-version-metadata", [
        {
            key: "fetch-metadata",
            startMark: "start-fetch-metadata",
            endMark: "end-fetch-metadata"
        }
    ], {});

});
parcelRegister("8TMPL", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("aju28").then(()=>parcelRequire('eYtTg'));

});


parcelRegister("f40Bu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = module.exports.parseConfigWithTargeting = void 0;

var $i2FWz = parcelRequire("i2FWz");
Object.defineProperty(module.exports, "parseConfigWithTargeting", {
    enumerable: true,
    get: function() {
        return $i2FWz.parseConfigWithTargeting;
    }
});

var $2X6Au = parcelRequire("2X6Au");
Object.defineProperty(module.exports, "TargetedConfig", {
    enumerable: true,
    get: function() {
        return $2X6Au.TargetedConfig;
    }
});

});
parcelRegister("i2FWz", function(module, exports) {
"use strict";
var $d228f306dc77eddd$var$__assign = module.exports && module.exports.__assign || function() {
    $d228f306dc77eddd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d228f306dc77eddd$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseConfigWithTargeting = $d228f306dc77eddd$var$parseConfigWithTargeting;

var $2X6Au = parcelRequire("2X6Au");
/**
 * For a given configuration, return the same configuration back
 * with {@link TargetedConfig} substituted where applicable.
 *
 * So anywhere in the JSON that has the objects:
 * ```
 * {
 *   "defaultConfig": ...
 * }
 * ```
 *
 * OR
 *
 * ```
 * {
 *   "defaultConfig": ...
 *   "targeting": {
 *     "targets": [...]
 *     "targetedConfig": ...
 *   }
 * }
 * ```
 *
 * become an instance of {@link TargetedConfig}.
 *
 * @param config configuration that may contain unparsed {@link TargetedConfig}
 * @returns the same configuration with targeted config sub-objects transformed
 *     into {@link TargetedConfig}
 */ function $d228f306dc77eddd$var$parseConfigWithTargeting(data) {
    // All "object" types will also need to have a null check because null is an "object", but an
    // invalid one for this use case.
    if (typeof data === "object") {
        if (Array.isArray(data)) return data.map(function(element) {
            return $d228f306dc77eddd$var$parseConfigWithTargeting(element);
        });
        else if (data) {
            var parsedObject_1 = data;
            var keys = Object.keys(parsedObject_1);
            if (keys.length === 1 && parsedObject_1.defaultConfig) return new $2X6Au.TargetedConfig({
                defaultConfig: $d228f306dc77eddd$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
            });
            else if (keys.length === 2 && parsedObject_1.defaultConfig && parsedObject_1.targeting) {
                var parseResult = $d228f306dc77eddd$var$parseTargeting(parsedObject_1.targeting);
                if (parseResult.type === "match") return new $2X6Au.TargetedConfig({
                    targeting: parseResult.result,
                    defaultConfig: $d228f306dc77eddd$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
                });
            }
            return keys.reduce(function(accObject, key) {
                var _a;
                return $d228f306dc77eddd$var$__assign($d228f306dc77eddd$var$__assign({}, accObject), (_a = {}, _a[key] = $d228f306dc77eddd$var$parseConfigWithTargeting(parsedObject_1[key]), _a));
            }, {});
        } else return null;
    } else return data;
}
function $d228f306dc77eddd$var$parseTargeting(targeting) {
    if (typeof targeting === "object" && targeting && !Array.isArray(targeting)) {
        var targetingKeyValue = targeting;
        var targetingKeys = Object.keys(targetingKeyValue);
        if (targetingKeys.length == 2 && targetingKeyValue.targets && targetingKeyValue.targetedConfig) return {
            type: "match",
            result: {
                targets: $d228f306dc77eddd$var$parseTargets(targetingKeyValue.targets),
                targetedConfig: $d228f306dc77eddd$var$parseConfigWithTargeting(targetingKeyValue.targetedConfig)
            }
        };
    }
    return {
        type: "no-match"
    };
}
function $d228f306dc77eddd$var$parseTargets(targets) {
    if (Array.isArray(targets)) return targets.map(function(target) {
        return {
            orgIds: $d228f306dc77eddd$var$parseIdentifierList(target.orgIds),
            siteIds: $d228f306dc77eddd$var$parseIdentifierList(target.siteIds),
            userIds: $d228f306dc77eddd$var$parseIdentifierList(target.userIds)
        };
    });
    else throw new Error("The targets for Flight Deck targeted configuration must come in an array.");
}
function $d228f306dc77eddd$var$parseIdentifierList(identifierList) {
    if (identifierList === undefined) return undefined;
    if (Array.isArray(identifierList)) return identifierList.map(function(id) {
        if (typeof id === "string") return id;
        else throw new Error("Identifiers for targets must be strings!");
    });
    else throw new Error("Identifier list must be an array!");
}

});
parcelRegister("2X6Au", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = void 0;
/**
 * Defines a part of the overall configuration that has different
 * values based on the intended target. The target is a specification
 * of a combination of site id, user id and org id.
 */ var $2266339d0bbba62b$var$TargetedConfig = /** @class */ function() {
    function TargetedConfig(targetedConfigDefinition) {
        this.targetedConfigDefinition = targetedConfigDefinition;
    }
    /**
     * Determines whether to use the targeted configuration value or the default value
     * depending on whether the specified values match any of the target's rules.
     *
     * @param target the values to use to evaluate the config
     * @returns the {@link TargetingResult}, which would be the default value
     *     if the specified target did not match, or the targeted value if there
     *     was a match
     */ TargetedConfig.prototype.resolve = function(target) {
        var targeting = this.targetedConfigDefinition.targeting;
        if (targeting) {
            var targeted = targeting.targets.some(function(configuredTarget) {
                var criteria = [];
                if (configuredTarget.orgIds) criteria.push({
                    allowList: configuredTarget.orgIds,
                    identifier: target.orgId
                });
                if (configuredTarget.siteIds) criteria.push({
                    allowList: configuredTarget.siteIds,
                    identifier: target.siteId
                });
                if (configuredTarget.userIds) criteria.push({
                    allowList: configuredTarget.userIds,
                    identifier: target.userId
                });
                if (criteria.length === 0) return false;
                else return criteria.every(function(criteria) {
                    return $2266339d0bbba62b$var$resolveForTargetCriteria(criteria);
                });
            });
            if (targeted) return {
                type: "targeted",
                value: targeting.targetedConfig
            };
        }
        return {
            type: "default",
            value: this.targetedConfigDefinition.defaultConfig
        };
    };
    return TargetedConfig;
}();
module.exports.TargetedConfig = $2266339d0bbba62b$var$TargetedConfig;
function $2266339d0bbba62b$var$resolveForTargetCriteria(criteria) {
    return !!criteria.identifier && criteria.allowList.includes(criteria.identifier);
}

});




parcelRegister("7EJP8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $592fd07c55ce8430$export$2e2bcd8739ae039; });
class $592fd07c55ce8430$export$2e2bcd8739ae039 extends Error {
    constructor({ artifact: artifact, dimensions: dimensions, error: error }){
        super(error instanceof Error && error.message ? error.message : "Unknown Flight Deck SDK error");
        this.name = "FlightDeckSDKError";
        this.error = error;
        this.artifact = artifact;
        this.environmentType = dimensions === null || dimensions === void 0 ? void 0 : dimensions.environmentType;
        this.locale = dimensions === null || dimensions === void 0 ? void 0 : dimensions.locale;
    }
}
const $592fd07c55ce8430$export$1d76d155060824c9 = (e)=>e instanceof $592fd07c55ce8430$export$2e2bcd8739ae039;

});

parcelRegister("h3tyo", function(module, exports) {
$parcel$export(module.exports, "artifactKey", function () { return $c6a9a43cbf9d3417$export$e3553dc63541d477; });
const $c6a9a43cbf9d3417$export$e3553dc63541d477 = (artifactName, dimensions)=>{
    return `${artifactName}${dimensions ? "_" + Object.keys(dimensions).sort().map((key)=>dimensions[key]).filter(Boolean).join("_") : ""}`;
};

});

parcelRegister("iclgX", function(module, exports) {
$parcel$export(module.exports, "flightDeckClientExperience", function () { return $d3f9d947d341ee1e$export$1e3a41a51f6457c5; });
$parcel$export(module.exports, "exceptionToMetadata", function () { return $d3f9d947d341ee1e$export$f33622abb5224195; });

var $f53LC = parcelRequire("f53LC");

var $7QZnA = parcelRequire("7QZnA");
var $vYGsY = parcelRequire("vYGsY");
function $d3f9d947d341ee1e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d3f9d947d341ee1e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d3f9d947d341ee1e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d3f9d947d341ee1e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $d3f9d947d341ee1e$export$6061a1a9a61f2e21 = ()=>new (0, $vYGsY.UFOExperience)("fetch", {
        type: (0, $7QZnA.ExperienceTypes).Operation,
        performanceType: (0, $7QZnA.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "flight-deck-client"
        }
    });
const $d3f9d947d341ee1e$export$1e3a41a51f6457c5 = ()=>new (0, $vYGsY.UFOExperience)("retrieve-artifact", {
        type: (0, $7QZnA.ExperienceTypes).Operation,
        performanceType: (0, $7QZnA.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "flight-deck-client"
        }
    });
const $d3f9d947d341ee1e$export$f33622abb5224195 = (e)=>{
    return e instanceof Error ? $d3f9d947d341ee1e$var$_objectSpread($d3f9d947d341ee1e$var$_objectSpread({}, e), {}, {
        cause: undefined
    }) : "unknown";
};

});
parcelRegister("7QZnA", function(module, exports) {
$parcel$export(module.exports, "ExperienceTypes", function () { return $5b7d006f119b3bea$export$994164cf3ae1cc9a; });
$parcel$export(module.exports, "ExperiencePerformanceTypes", function () { return $5b7d006f119b3bea$export$cc26007c03242fff; });
var $5b7d006f119b3bea$export$994164cf3ae1cc9a;
(function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
})($5b7d006f119b3bea$export$994164cf3ae1cc9a || ($5b7d006f119b3bea$export$994164cf3ae1cc9a = {}));
var $5b7d006f119b3bea$export$cc26007c03242fff;
(function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
})($5b7d006f119b3bea$export$cc26007c03242fff || ($5b7d006f119b3bea$export$cc26007c03242fff = {}));

});

parcelRegister("vYGsY", function(module, exports) {
$parcel$export(module.exports, "UFOExperience", function () { return $0601f7ee719391cf$export$c00d22927c60484a; });

var $avOEA = parcelRequire("avOEA");

var $cTewU = parcelRequire("cTewU");

var $i7dvh = parcelRequire("i7dvh");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $c8NwH = parcelRequire("c8NwH");
function $0601f7ee719391cf$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $0601f7ee719391cf$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $jlBwm.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $jlBwm.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $i3Ugd.default)(this, result);
    };
}
function $0601f7ee719391cf$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $0601f7ee719391cf$export$c00d22927c60484a = /*#__PURE__*/ function(_UFOAbstractExperienc) {
    (0, $i7dvh.default)(UFOExperience, _UFOAbstractExperienc);
    var _super = $0601f7ee719391cf$var$_createSuper(UFOExperience);
    function UFOExperience() {
        (0, $cTewU.default)(this, UFOExperience);
        return _super.apply(this, arguments);
    }
    return (0, $avOEA.default)(UFOExperience);
}((0, $c8NwH.UFOAbstractExperience));

});
parcelRegister("c8NwH", function(module, exports) {
$parcel$export(module.exports, "UFOAbstractExperience", function () { return $8d6ca6521b52e16d$export$d31c89db257648c; });

var $lFOXD = parcelRequire("lFOXD");

var $cn8ql = parcelRequire("cn8ql");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $5Cxn4 = parcelRequire("5Cxn4");

var $10s8f = parcelRequire("10s8f");

var $4wI0P = parcelRequire("4wI0P");

var $94rfp = parcelRequire("94rfp");

var $j6425 = parcelRequire("j6425");

var $5Zgra = parcelRequire("5Zgra");

var $dszxe = parcelRequire("dszxe");

var $fXc0M = parcelRequire("fXc0M");

var $2WZKA = parcelRequire("2WZKA");

var $3ZHVV = parcelRequire("3ZHVV");

var $2Uy7K = parcelRequire("2Uy7K");

var $7QZnA = parcelRequire("7QZnA");
function $8d6ca6521b52e16d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8d6ca6521b52e16d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $8d6ca6521b52e16d$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $f53LC.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $8d6ca6521b52e16d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $8d6ca6521b52e16d$var$getPageVisibleState = function getPageVisibleState() {
    return !(0, $94rfp.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $fXc0M.PageVisibleState).VISIBLE : (0, $fXc0M.PageVisibleState).HIDDEN;
};
var $8d6ca6521b52e16d$export$c753e8669d30c8ad = function perfNowOrTimestamp(timestamp) {
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $2WZKA.roundPerfNow)();
};
var $8d6ca6521b52e16d$export$d31c89db257648c = /*#__PURE__*/ function() {
    // for concurrent
    // @todo move to page load experience when proper classes/inheritance prepared
    function UFOAbstractExperience(id, config) {
        var _this = this;
        var instanceId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        (0, $cTewU.default)(this, UFOAbstractExperience);
        (0, $f53LC.default)(this, "state", (0, $3ZHVV.UFOExperienceState).NOT_STARTED);
        (0, $f53LC.default)(this, "instanceId", null);
        (0, $f53LC.default)(this, "parent", null);
        (0, $f53LC.default)(this, "category", null);
        (0, $f53LC.default)(this, "metadata", {});
        (0, $f53LC.default)(this, "onDoneCallbacks", []);
        (0, $f53LC.default)(this, "childExperiences", []);
        (0, $f53LC.default)(this, "explicitTimings", {});
        (0, $f53LC.default)(this, "isSSROutputAsFMP", false);
        (0, $f53LC.default)(this, "uuid", null);
        (0, $f53LC.default)(this, "_until", null);
        (0, $f53LC.default)(this, "metrics", {
            startTime: null,
            endTime: null,
            marks: []
        });
        (0, $f53LC.default)(this, "performanceConfig", {});
        (0, $f53LC.default)(this, "setPageVisibleStateToMixed", function() {
            _this.pageVisibleState = (0, $fXc0M.PageVisibleState).MIXED;
            (0, $dszxe.visibilityChangeObserver).unsubscribe(_this.setPageVisibleStateToMixed);
        });
        this.id = id;
        this.category = (config === null || config === void 0 ? void 0 : config.category) || null;
        this.until = (config === null || config === void 0 ? void 0 : config.until) || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $8d6ca6521b52e16d$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $7QZnA.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $7QZnA.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    (0, $avOEA.default)(UFOAbstractExperience, [
        {
            key: "transition",
            value: function() {
                var _transition = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(newState, timestamp) {
                    var data;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                (0, $5Zgra.ufolog)('async transition', this.id, this.state.id, newState.id);
                                if (!(0, $2Uy7K.canTransition)(this.state, newState)) {
                                    _context.next = 15;
                                    break;
                                }
                                (0, $5Zgra.ufolog)("TRANSITION: ".concat(this.id, " from ").concat(this.state.id, " to ").concat(newState.id, " successful"), this.state.final, !newState.final);
                                if (newState === (0, $3ZHVV.UFOExperienceState).STARTED) this._reset();
                                if (this.state.final && !newState.final) {
                                    this.metrics.startTime = $8d6ca6521b52e16d$export$c753e8669d30c8ad(timestamp);
                                    this.uuid = (0, $10s8f.v4)();
                                }
                                this.state = newState;
                                if (!newState.final) {
                                    _context.next = 14;
                                    break;
                                }
                                this.metrics.endTime = $8d6ca6521b52e16d$export$c753e8669d30c8ad(timestamp);
                                if (!this._isManualStateEnabled()) (0, $j6425.getGlobalEventStream)().push((0, $j6425.unsubscribeEvent)((0, $fXc0M.SUBSCRIBE_ALL), this.handleDoneBind));
                                _context.next = 11;
                                return this.exportData();
                            case 11:
                                data = _context.sent;
                                (0, $5Zgra.ufolog)('this.parent', this.parent);
                                (0, $j6425.getGlobalEventStream)().push((0, $j6425.experiencePayloadEvent)(data));
                            case 14:
                                return _context.abrupt("return", true);
                            case 15:
                                (0, $5Zgra.ufolog)("TRANSITION: ".concat(this.id, " from ").concat(this.state.id, " to ").concat(newState.id, " unsuccessful"));
                                (0, $5Zgra.ufowarn)("transition of ".concat(this.id, " from ").concat(this.state, " to ").concat(newState, " is not possible"));
                                return _context.abrupt("return", false);
                            case 18:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function transition(_x, _x2) {
                    return _transition.apply(this, arguments);
                }
                return transition;
            }()
        },
        {
            key: "start",
            value: function() {
                var _start = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(startTime) {
                    var transitionSuccessful;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return this.transition((0, $3ZHVV.UFOExperienceState).STARTED, startTime);
                            case 2:
                                transitionSuccessful = _context2.sent;
                                if (transitionSuccessful) {
                                    this.pageVisibleState = $8d6ca6521b52e16d$var$getPageVisibleState();
                                    (0, $dszxe.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
                                    if (!this._isManualStateEnabled()) {
                                        (0, $5Zgra.ufolog)('subscribed', this.id);
                                        (0, $j6425.getGlobalEventStream)().push((0, $j6425.subscribeEvent)((0, $fXc0M.SUBSCRIBE_ALL), this.handleDoneBind));
                                    }
                                }
                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function start(_x3) {
                    return _start.apply(this, arguments);
                }
                return start;
            }()
        },
        {
            key: "mark",
            value: function mark(name, timestamp) {
                if (name !== (0, $fXc0M.FMP_MARK) && name !== (0, $fXc0M.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
                else (0, $5Zgra.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
            }
        },
        {
            key: "_mark",
            value: function _mark(name, timestamp) {
                this.metrics.marks.push({
                    name: name,
                    time: $8d6ca6521b52e16d$export$c753e8669d30c8ad(timestamp)
                });
                this.transition((0, $3ZHVV.UFOExperienceState).IN_PROGRESS);
            }
        },
        {
            key: "markFMP",
            value: function markFMP(timestamp) {
                this._mark((0, $fXc0M.FMP_MARK), timestamp);
            }
        },
        {
            key: "markInlineResponse",
            value: function markInlineResponse(timestamp) {
                this._mark((0, $fXc0M.INLINE_RESPONSE_MARK), timestamp);
            }
        },
        {
            key: "_isManualStateEnabled",
            value: function _isManualStateEnabled() {
                return this.until === null;
            }
        },
        {
            key: "_validateManualState",
            value: function _validateManualState() {
                if (!this._isManualStateEnabled()) {
                    (0, $5Zgra.ufowarn)('manual change of state not allowed as "until" is defined');
                    return false;
                }
                return true;
            }
        },
        {
            key: "switchToEndState",
            value: function switchToEndState(state, config) {
                if (!(config !== null && config !== void 0 && config.force) && !this._validateManualState()) return null;
                if (config !== null && config !== void 0 && config.metadata) this.addMetadata(config.metadata);
                (0, $dszxe.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
                return this.transition(state);
            }
        },
        {
            key: "success",
            value: function() {
                var _success = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", this.switchToEndState((0, $3ZHVV.UFOExperienceState).SUCCEEDED, config));
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function success(_x4) {
                    return _success.apply(this, arguments);
                }
                return success;
            }()
        },
        {
            key: "failure",
            value: function() {
                var _failure = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee4(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                return _context4.abrupt("return", this.switchToEndState((0, $3ZHVV.UFOExperienceState).FAILED, config));
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function failure(_x5) {
                    return _failure.apply(this, arguments);
                }
                return failure;
            }()
        },
        {
            key: "abort",
            value: function() {
                var _abort = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee5(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                return _context5.abrupt("return", this.switchToEndState((0, $3ZHVV.UFOExperienceState).ABORTED, config));
                            case 1:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function abort(_x6) {
                    return _abort.apply(this, arguments);
                }
                return abort;
            }()
        },
        {
            key: "addMetadata",
            value: function addMetadata(data) {
                Object.assign(this.metadata, data);
            }
        },
        {
            key: "_handleDoneExperience",
            value: function _handleDoneExperience(data) {
                (0, $5Zgra.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
                if (data.state.final) {
                    if (this._until !== null) {
                        var _this$_until = this._until(data), done = _this$_until.done, state = _this$_until.state;
                        if (done && !this.state.final) this.transition(state);
                    }
                }
            }
        },
        {
            key: "getId",
            value: function() {
                var _getId = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee6() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                return _context6.abrupt("return", this.id);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function getId() {
                    return _getId.apply(this, arguments);
                }
                return getId;
            }()
        },
        {
            key: "exportData",
            value: function() {
                var _exportData = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                _context7.next = 2;
                                return this.getId();
                            case 2:
                                _context7.t0 = _context7.sent;
                                _context7.t1 = this.uuid;
                                _context7.t2 = this.type;
                                _context7.t3 = (0, $4wI0P.UFO_EXPERIMENTAL_BUILD_VERSION) || 'unknown';
                                _context7.t4 = this.performanceType;
                                _context7.t5 = this.category;
                                _context7.t6 = this.state;
                                _context7.t7 = $8d6ca6521b52e16d$var$_objectSpread({}, this.metadata);
                                _context7.t8 = $8d6ca6521b52e16d$var$_objectSpread({}, this.metrics);
                                _context7.t9 = (0, $lFOXD.default)(this.childExperiences);
                                _context7.t10 = {
                                    success: !!this.state.success,
                                    startTime: this.metrics.startTime,
                                    duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
                                };
                                _context7.t11 = this.config.platform || null;
                                _context7.t12 = this.pageVisibleState;
                                _context7.t13 = this.featureFlags;
                                _context7.t14 = this.isSSROutputAsFMP;
                                _context7.t15 = this.timings;
                                _context7.t16 = this.explicitTimings;
                                _context7.t17 = this.performanceConfig;
                                return _context7.abrupt("return", {
                                    id: _context7.t0,
                                    uuid: _context7.t1,
                                    type: _context7.t2,
                                    schemaVersion: _context7.t3,
                                    performanceType: _context7.t4,
                                    category: _context7.t5,
                                    state: _context7.t6,
                                    metadata: _context7.t7,
                                    metrics: _context7.t8,
                                    children: _context7.t9,
                                    result: _context7.t10,
                                    platform: _context7.t11,
                                    pageVisibleState: _context7.t12,
                                    featureFlags: _context7.t13,
                                    isSSROutputAsFMP: _context7.t14,
                                    timings: _context7.t15,
                                    explicitTimings: _context7.t16,
                                    performanceConfig: _context7.t17
                                });
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function exportData() {
                    return _exportData.apply(this, arguments);
                }
                return exportData;
            }()
        },
        {
            key: "_reset",
            value: function _reset() {
                this.parent = null;
                this.metadata = {};
                this.onDoneCallbacks = [];
                this.childExperiences = [];
                this.metrics = {
                    startTime: null,
                    endTime: null,
                    marks: []
                };
                this._until = this.until ? this.until() : null;
            }
        }
    ]);
    return UFOAbstractExperience;
}();

});
parcelRegister("10s8f", function(module, exports) {

var $fMbjf = parcelRequire("fMbjf");

var $4SzGT = parcelRequire("4SzGT");
var $0bbb9cf4b3b3750b$var$uuid = $4SzGT;
$0bbb9cf4b3b3750b$var$uuid.v1 = $fMbjf;
$0bbb9cf4b3b3750b$var$uuid.v4 = $4SzGT;
module.exports = $0bbb9cf4b3b3750b$var$uuid;

});
parcelRegister("fMbjf", function(module, exports) {

var $lfmFS = parcelRequire("lfmFS");

var $5Fsgk = parcelRequire("5Fsgk");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $b7c41c86ac93428b$var$_nodeId;
var $b7c41c86ac93428b$var$_clockseq;
// Previous uuid creation time
var $b7c41c86ac93428b$var$_lastMSecs = 0;
var $b7c41c86ac93428b$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $b7c41c86ac93428b$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $b7c41c86ac93428b$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $b7c41c86ac93428b$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $lfmFS();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $b7c41c86ac93428b$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $b7c41c86ac93428b$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $b7c41c86ac93428b$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $b7c41c86ac93428b$var$_lastMSecs + (nsecs - $b7c41c86ac93428b$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $b7c41c86ac93428b$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $b7c41c86ac93428b$var$_lastMSecs = msecs;
    $b7c41c86ac93428b$var$_lastNSecs = nsecs;
    $b7c41c86ac93428b$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $5Fsgk(b);
}
module.exports = $b7c41c86ac93428b$var$v1;

});
parcelRegister("lfmFS", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $f77c965593c42b16$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($f77c965593c42b16$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $f77c965593c42b16$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $f77c965593c42b16$var$getRandomValues($f77c965593c42b16$var$rnds8);
        return $f77c965593c42b16$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $f77c965593c42b16$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $f77c965593c42b16$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $f77c965593c42b16$var$rnds;
    };
}

});

parcelRegister("5Fsgk", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $4206b467799d164d$var$byteToHex = [];
for(var $4206b467799d164d$var$i = 0; $4206b467799d164d$var$i < 256; ++$4206b467799d164d$var$i)$4206b467799d164d$var$byteToHex[$4206b467799d164d$var$i] = ($4206b467799d164d$var$i + 0x100).toString(16).substr(1);
function $4206b467799d164d$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $4206b467799d164d$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = $4206b467799d164d$var$bytesToUuid;

});


parcelRegister("4SzGT", function(module, exports) {

var $lfmFS = parcelRequire("lfmFS");

var $5Fsgk = parcelRequire("5Fsgk");
function $38d7e4042b2549fb$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $lfmFS)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $5Fsgk(rnds);
}
module.exports = $38d7e4042b2549fb$var$v4;

});


parcelRegister("4wI0P", function(module, exports) {
$parcel$export(module.exports, "UFO_EXPERIMENTAL_BUILD_VERSION", function () { return $34bc4a84d91b2ee6$export$2295b861f318254a; });
// temp solution until we can get it automated
var $34bc4a84d91b2ee6$export$2295b861f318254a = '0.1.5';

});

parcelRegister("94rfp", function(module, exports) {
$parcel$export(module.exports, "isWindowObjectAvailable", function () { return $69a99f9848c16385$export$15e172712955e18f; });
var $69a99f9848c16385$export$15e172712955e18f = function isWindowObjectAvailable() {
    return typeof window !== 'undefined';
};

});

parcelRegister("j6425", function(module, exports) {
$parcel$export(module.exports, "getGlobalEventStream", function () { return $de71b4a88fd636bc$export$6123a44dc2384540; });
$parcel$export(module.exports, "subscribeEvent", function () { return $de71b4a88fd636bc$export$37863216db4b714d; });
$parcel$export(module.exports, "unsubscribeEvent", function () { return $de71b4a88fd636bc$export$ee1a7bd1fc9ea85e; });
$parcel$export(module.exports, "experiencePayloadEvent", function () { return $de71b4a88fd636bc$export$7c957416596ca127; });

var $5Zgra = parcelRequire("5Zgra");

var $fXc0M = parcelRequire("fXc0M");
var $de71b4a88fd636bc$var$MAX_EARLY_QUEUE_LENGTH = 250;
var $de71b4a88fd636bc$export$6123a44dc2384540 = function getGlobalEventStream() {
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        var earlyStream = function() {
            var stream = [];
            return {
                __buffer_only__: true,
                push: function push(event) {
                    if (stream.length < $de71b4a88fd636bc$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: function getStream() {
                    return stream;
                }
            };
        }();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
var $de71b4a88fd636bc$export$c1522520b417b066 = function setGlobalEventStream(eventStream) {
    var _globalThis$__UFO_GLO, _globalThis$__UFO_GLO2;
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !((_globalThis$__UFO_GLO = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO !== void 0 && _globalThis$__UFO_GLO.__buffer_only__)) {
        (0, $5Zgra.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if ((_globalThis$__UFO_GLO2 = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO2 !== void 0 && _globalThis$__UFO_GLO2.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
var $de71b4a88fd636bc$export$37863216db4b714d = function subscribeEvent(experienceId, callback) {
    return {
        type: (0, $fXc0M.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
var $de71b4a88fd636bc$export$ee1a7bd1fc9ea85e = function unsubscribeEvent(experienceId, callback) {
    return {
        type: (0, $fXc0M.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
var $de71b4a88fd636bc$export$7c957416596ca127 = function experiencePayloadEvent(data) {
    return {
        type: (0, $fXc0M.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("5Zgra", function(module, exports) {
$parcel$export(module.exports, "ufolog", function () { return $45bf6657173d0367$export$b4958caff08a0960; });
$parcel$export(module.exports, "ufowarn", function () { return $45bf6657173d0367$export$d53d07b6034c4560; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");
var $45bf6657173d0367$var$UFOLogger = /*#__PURE__*/ function() {
    function UFOLogger() {
        (0, $cTewU.default)(this, UFOLogger);
        (0, $f53LC.default)(this, "enabled", false);
    }
    (0, $avOEA.default)(UFOLogger, [
        {
            key: "log",
            value: function log() {
                var _console;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                // eslint-disable-next-line no-console
                this.enabled && (_console = console).log.apply(_console, [
                    UFOLogger.UFOprefix
                ].concat(args));
            }
        },
        {
            key: "warn",
            value: function warn() {
                var _console2;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                // eslint-disable-next-line no-console
                this.enabled && (_console2 = console).warn.apply(_console2, [
                    UFOLogger.UFOprefix
                ].concat(args));
            }
        },
        {
            key: "enable",
            value: function enable() {
                this.enabled = true;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this.enabled = false;
            }
        }
    ]);
    return UFOLogger;
}();
(0, $f53LC.default)($45bf6657173d0367$var$UFOLogger, "UFOprefix", "[ufo\uD83D\uDEF8]");
var $45bf6657173d0367$export$4ab84f6f04f6566d = new $45bf6657173d0367$var$UFOLogger();
var $45bf6657173d0367$export$b4958caff08a0960 = function ufolog() {
    $45bf6657173d0367$export$4ab84f6f04f6566d.log.apply($45bf6657173d0367$export$4ab84f6f04f6566d, arguments);
};
var $45bf6657173d0367$export$d53d07b6034c4560 = function ufowarn() {
    $45bf6657173d0367$export$4ab84f6f04f6566d.warn.apply($45bf6657173d0367$export$4ab84f6f04f6566d, arguments);
};

});

parcelRegister("fXc0M", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStreamEventType", function () { return $b9d5aef0b4c8094e$export$96253c35c37cf96b; });
$parcel$export(module.exports, "PageVisibleState", function () { return $b9d5aef0b4c8094e$export$a12c67b37a306b13; });
$parcel$export(module.exports, "SUBSCRIBE_ALL", function () { return $b9d5aef0b4c8094e$export$79bf131685ad41d7; });
$parcel$export(module.exports, "FMP_MARK", function () { return $b9d5aef0b4c8094e$export$9f2bf58999404c75; });
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", function () { return $b9d5aef0b4c8094e$export$837e0f79a8056912; });

var $b9d5aef0b4c8094e$export$96253c35c37cf96b;
(function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
})($b9d5aef0b4c8094e$export$96253c35c37cf96b || ($b9d5aef0b4c8094e$export$96253c35c37cf96b = {}));
var $b9d5aef0b4c8094e$export$a12c67b37a306b13;
(function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
})($b9d5aef0b4c8094e$export$a12c67b37a306b13 || ($b9d5aef0b4c8094e$export$a12c67b37a306b13 = {}));
var $b9d5aef0b4c8094e$export$66b33c055cbb625e;
(function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
})($b9d5aef0b4c8094e$export$66b33c055cbb625e || ($b9d5aef0b4c8094e$export$66b33c055cbb625e = {}));
var $b9d5aef0b4c8094e$export$3ce489cbe02dc21b;
(function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
})($b9d5aef0b4c8094e$export$3ce489cbe02dc21b || ($b9d5aef0b4c8094e$export$3ce489cbe02dc21b = {}));
var $b9d5aef0b4c8094e$export$341b330828bd3906;
(function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
})($b9d5aef0b4c8094e$export$341b330828bd3906 || ($b9d5aef0b4c8094e$export$341b330828bd3906 = {}));
var $b9d5aef0b4c8094e$export$b9b20160f581e4f8;
(function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
})($b9d5aef0b4c8094e$export$b9b20160f581e4f8 || ($b9d5aef0b4c8094e$export$b9b20160f581e4f8 = {}));
var $b9d5aef0b4c8094e$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
var $b9d5aef0b4c8094e$export$9f2bf58999404c75 = 'fmp';
var $b9d5aef0b4c8094e$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("dszxe", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", function () { return $9cc97463492fc80a$export$13e680397ec8f3eb; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $94rfp = parcelRequire("94rfp");
var $9cc97463492fc80a$var$VisibilityChangeObserver = /*#__PURE__*/ function() {
    function VisibilityChangeObserver() {
        var _this = this;
        (0, $cTewU.default)(this, VisibilityChangeObserver);
        (0, $f53LC.default)(this, "started", false);
        (0, $f53LC.default)(this, "observers", []);
        (0, $f53LC.default)(this, "broadcast", function() {
            _this.observers.forEach(function(fn) {
                return fn();
            });
            _this.observers = [];
        });
    }
    (0, $avOEA.default)(VisibilityChangeObserver, [
        {
            key: "start",
            value: function start() {
                if (this.started) return;
                this.started = true;
                document.addEventListener('visibilitychange', this.broadcast);
                /**
       * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
       * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
       * so for that case, you need to also include code to listen for the pagehide event.
       */ if ((0, $94rfp.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                this.observers.push(callback);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(callback) {
                this.observers = this.observers.filter(function(fn) {
                    return fn !== callback;
                });
            }
        }
    ]);
    return VisibilityChangeObserver;
}();
var $9cc97463492fc80a$export$13e680397ec8f3eb = new $9cc97463492fc80a$var$VisibilityChangeObserver();

});

parcelRegister("2WZKA", function(module, exports) {
$parcel$export(module.exports, "roundPerfNow", function () { return $2260e5ea1458e9eb$export$5f490af6b2b115cf; });
var $2260e5ea1458e9eb$export$5f490af6b2b115cf = function roundPerfNow() {
    return ~~performance.now();
};

});

parcelRegister("3ZHVV", function(module, exports) {
$parcel$export(module.exports, "UFOExperienceState", function () { return $2e8925d4a6ba1dbb$export$81b70111112841a0; });
var $2e8925d4a6ba1dbb$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    // isn't recovered IN_PROGRESS?
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("2Uy7K", function(module, exports) {
$parcel$export(module.exports, "canTransition", function () { return $21eb480796cfeeeb$export$178881f329fdb81f; });

var $f53LC = parcelRequire("f53LC");

var $3ZHVV = parcelRequire("3ZHVV");
var $21eb480796cfeeeb$var$_UFOStateAvailableTra;
var $21eb480796cfeeeb$var$UFOStateAvailableTransitions = ($21eb480796cfeeeb$var$_UFOStateAvailableTra = {}, (0, $f53LC.default)($21eb480796cfeeeb$var$_UFOStateAvailableTra, (0, $3ZHVV.UFOExperienceState).NOT_STARTED.id, [
    (0, $3ZHVV.UFOExperienceState).STARTED.id
]), (0, $f53LC.default)($21eb480796cfeeeb$var$_UFOStateAvailableTra, (0, $3ZHVV.UFOExperienceState).STARTED.id, [
    (0, $3ZHVV.UFOExperienceState).IN_PROGRESS.id,
    (0, $3ZHVV.UFOExperienceState).BLOCKED.id,
    (0, $3ZHVV.UFOExperienceState).SUCCEEDED.id,
    (0, $3ZHVV.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $3ZHVV.UFOExperienceState).FAILED.id,
    (0, $3ZHVV.UFOExperienceState).ABORTED.id
]), (0, $f53LC.default)($21eb480796cfeeeb$var$_UFOStateAvailableTra, (0, $3ZHVV.UFOExperienceState).IN_PROGRESS.id, [
    (0, $3ZHVV.UFOExperienceState).BLOCKED.id,
    (0, $3ZHVV.UFOExperienceState).SUCCEEDED.id,
    (0, $3ZHVV.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $3ZHVV.UFOExperienceState).FAILED.id,
    (0, $3ZHVV.UFOExperienceState).ABORTED.id
]), (0, $f53LC.default)($21eb480796cfeeeb$var$_UFOStateAvailableTra, (0, $3ZHVV.UFOExperienceState).BLOCKED.id, [
    (0, $3ZHVV.UFOExperienceState).RECOVERED.id,
    (0, $3ZHVV.UFOExperienceState).ABORTED.id
]), (0, $f53LC.default)($21eb480796cfeeeb$var$_UFOStateAvailableTra, (0, $3ZHVV.UFOExperienceState).RECOVERED.id, [
    (0, $3ZHVV.UFOExperienceState).STARTED.id,
    (0, $3ZHVV.UFOExperienceState).SUCCEEDED.id,
    (0, $3ZHVV.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $3ZHVV.UFOExperienceState).FAILED.id,
    (0, $3ZHVV.UFOExperienceState).ABORTED.id
]), (0, $f53LC.default)($21eb480796cfeeeb$var$_UFOStateAvailableTra, (0, $3ZHVV.UFOExperienceState).SUCCEEDED.id, [
    (0, $3ZHVV.UFOExperienceState).STARTED.id
]), (0, $f53LC.default)($21eb480796cfeeeb$var$_UFOStateAvailableTra, (0, $3ZHVV.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id, [
    (0, $3ZHVV.UFOExperienceState).SUCCEEDED.id,
    (0, $3ZHVV.UFOExperienceState).FAILED.id,
    (0, $3ZHVV.UFOExperienceState).ABORTED.id
]), (0, $f53LC.default)($21eb480796cfeeeb$var$_UFOStateAvailableTra, (0, $3ZHVV.UFOExperienceState).FAILED.id, [
    (0, $3ZHVV.UFOExperienceState).STARTED.id
]), (0, $f53LC.default)($21eb480796cfeeeb$var$_UFOStateAvailableTra, (0, $3ZHVV.UFOExperienceState).ABORTED.id, [
    (0, $3ZHVV.UFOExperienceState).STARTED.id
]), $21eb480796cfeeeb$var$_UFOStateAvailableTra);
var $21eb480796cfeeeb$export$178881f329fdb81f = function canTransition(state1, state2) {
    return $21eb480796cfeeeb$var$UFOStateAvailableTransitions[state1.id] && $21eb480796cfeeeb$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});






parcelRegister("kttmz", function(module, exports) {
$parcel$export(module.exports, "FD_CLIENT_FETCH_PROPS", function () { return $ee7d4afd7031b6cc$export$c270c412a04ff3e6; });
$parcel$export(module.exports, "default", function () { return $ee7d4afd7031b6cc$export$2e2bcd8739ae039; });

var $cn8ql = parcelRequire("cn8ql");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $5Cxn4 = parcelRequire("5Cxn4");

var $37Osf = parcelRequire("37Osf");

var $cDUWS = parcelRequire("cDUWS");
var $ee7d4afd7031b6cc$var$RECENT_WORK_ARTIFACT = 'recent-work-service';
var $ee7d4afd7031b6cc$var$FD_ENVIRONMENT = 'prod';
var $ee7d4afd7031b6cc$export$c270c412a04ff3e6 = {
    name: $ee7d4afd7031b6cc$var$RECENT_WORK_ARTIFACT,
    dimensions: {
        environmentType: $ee7d4afd7031b6cc$var$FD_ENVIRONMENT
    }
};
var $ee7d4afd7031b6cc$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function HydratorConfigClient(handlers, product, artifactFetch) {
        var _this = this;
        (0, $cTewU.default)(this, HydratorConfigClient);
        (0, $f53LC.default)(this, "fetchConfig", /*#__PURE__*/ (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee() {
            var artifact, fragments, hydrators;
            return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _context.next = 2;
                        return _this.fetchArtifact();
                    case 2:
                        artifact = _context.sent;
                        fragments = artifact.queryFragments, hydrators = artifact.hydrators;
                        return _context.abrupt("return", {
                            fragments: fragments,
                            hydrators: hydrators
                        });
                    case 5:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        })));
        this.flightDeck = new (0, $37Osf.default)(product || 'recent-work-client', {
            handlers: handlers
        }, [
            {
                name: 'recent-work-service',
                dimensions: {
                    environmentType: $ee7d4afd7031b6cc$var$FD_ENVIRONMENT
                },
                value: (0, $cDUWS.default)
            }
        ]);
        this.artifactFetch = artifactFetch;
    }
    return (0, $avOEA.default)(HydratorConfigClient, [
        {
            key: "fetchArtifact",
            value: function() {
                var _fetchArtifact = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                if (!this.artifactFetch) {
                                    _context2.next = 2;
                                    break;
                                }
                                return _context2.abrupt("return", this.artifactFetch());
                            case 2:
                                return _context2.abrupt("return", this.flightDeck.fetchConfigFromFlightDeck($ee7d4afd7031b6cc$export$c270c412a04ff3e6, // Retries are for the background refresh, so not too aggressive
                                {
                                    intervalsMS: [
                                        100,
                                        500
                                    ]
                                }));
                            case 3:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function fetchArtifact() {
                    return _fetchArtifact.apply(this, arguments);
                }
                return fetchArtifact;
            }()
        }
    ]);
}();

});
parcelRegister("cDUWS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $93454d58dfad5016$export$2e2bcd8739ae039; });
var $93454d58dfad5016$export$2e2bcd8739ae039 = {
    localization: {
        eventTypes: {
            commented: {
                absolute: 'You commented on {absoluteTime}',
                relative: 'You commented {relativeTime}',
                standalone: 'You commented',
                multiAbsolute: 'Commented on {absoluteTime}',
                multiRelative: 'Commented {relativeTime}',
                multiStandalone: 'Commented'
            },
            created: {
                absolute: 'You created on {absoluteTime}',
                relative: 'You created {relativeTime}',
                standalone: 'You created',
                multiAbsolute: 'Created on {absoluteTime}',
                multiRelative: 'Created {relativeTime}',
                multiStandalone: 'Created'
            },
            edited: {
                absolute: 'You edited on {absoluteTime}',
                relative: 'You edited {relativeTime}',
                standalone: 'You edited',
                multiAbsolute: 'Edited on {absoluteTime}',
                multiRelative: 'Edited {relativeTime}',
                multiStandalone: 'Edited'
            },
            published: {
                absolute: 'You published on {absoluteTime}',
                relative: 'You published {relativeTime}',
                standalone: 'You published',
                multiAbsolute: 'Published on {absoluteTime}',
                multiRelative: 'Published {relativeTime}',
                multiStandalone: 'Published'
            },
            updated: {
                absolute: 'You updated on {absoluteTime}',
                relative: 'You updated {relativeTime}',
                standalone: 'You updated',
                multiAbsolute: 'Updated on {absoluteTime}',
                multiRelative: 'Updated {relativeTime}',
                multiStandalone: 'Updated'
            },
            viewed: {
                absolute: 'You viewed on {absoluteTime}',
                relative: 'You viewed {relativeTime}',
                standalone: 'You viewed',
                multiAbsolute: 'Viewed on {absoluteTime}',
                multiRelative: 'Viewed {relativeTime}',
                multiStandalone: 'Viewed'
            }
        }
    },
    hydrators: {
        TownsquareGoal: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'key'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                icon: [
                    'iconData'
                ]
            }
        },
        TownsquareProject: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'key'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                icon: [
                    'iconData'
                ]
            }
        },
        TownsquareComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'container.key'
                ],
                name: [
                    'container.name'
                ],
                url: [
                    'container.url'
                ],
                icon: [
                    'container.iconData'
                ],
                deduplicateId: [
                    'container.id'
                ]
            }
        },
        ConfluencePage: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'pageId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
            }
        },
        ConfluenceBlogPost: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'blogPostId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg'
            }
        },
        ConfluenceComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
            }
        },
        ConfluenceFooterComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
            }
        },
        ConfluenceInlineComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
            }
        },
        JiraIssue: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                icon: [
                    'fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.xsmall'
                ],
                key: [
                    'key'
                ]
            }
        },
        JiraPlatformComment: {
            hydratorPaths: {
                id: [
                    'commentId'
                ],
                name: [
                    'issue.fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'issue.fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                icon: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.xsmall'
                ],
                key: [
                    'issue.key'
                ],
                deduplicateId: [
                    'issue.id'
                ]
            }
        },
        JiraServiceManagementComment: {
            hydratorPaths: {
                id: [
                    'commentId'
                ],
                name: [
                    'issue.fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'issue.fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                icon: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.xsmall'
                ],
                key: [
                    'issue.key'
                ],
                deduplicateId: [
                    'issue.id'
                ]
            }
        }
    },
    queryFragments: '\n\n  fragment townsquareGoal on TownsquareGoal {\n    id\n    key\n    name\n    url\n    iconData\n  }\n\n\n  fragment townsquareProject on TownsquareProject {\n    id\n    key\n    name\n    url\n    iconData\n  }\n\n\n  fragment townsquareComment on TownsquareComment {\n    id\n    url\n    container {\n      __typename\n      ...townsquareGoal\n      ...townsquareProject\n    }\n  }\n\n\n  fragment confluencePage on ConfluencePage {\n    id\n    title\n    pageId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceBlogPost on ConfluenceBlogPost {\n    id\n    title\n    blogPostId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceComment on ConfluenceComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n    }\n  }\n\n\n  fragment confluenceFooterComment on ConfluenceFooterComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n    }\n  }\n\n\n  fragment confluenceInlineComment on ConfluenceInlineComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n    }\n  }\n\n\nfragment jiraIssue on JiraIssue {\n  id\n  key\n  webUrl\n  fieldsById(ids: ["summary", "issuetype", "project"]) {\n    edges {\n      node {\n        __typename\n        fieldId\n        ...jiraSingleLineTextField\n        ...jiraIssueTypeField\n        ...jiraProjectField\n      }\n    }\n  }\n}\nfragment jiraSingleLineTextField on JiraSingleLineTextField {\n  text\n}\nfragment jiraIssueTypeField on JiraIssueTypeField {\n  issueType {\n    avatar {\n      xsmall\n    }\n  }\n}\nfragment jiraProjectField on JiraProjectField {\n  project {\n    name\n  }\n}\n\n\nfragment jiraPlatformComment on JiraPlatformComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\n\nfragment jiraServiceManagementComment on JiraServiceManagementComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\nfragment activityItemEdge on ActivityItemEdge {\n  cursor\n  node {\n    id\n    object {\n      id\n      type\n      product\n      subProduct\n      rootContainerId\n      contributors {\n        profile {\n          name\n          picture\n          accountId\n        }\n      }\n      data {\n        __typename\n\t...townsquareGoal\n\t...townsquareProject\n\t...townsquareComment\n\t...confluencePage\n\t...confluenceBlogPost\n\t...confluenceComment\n\t...confluenceFooterComment\n\t...confluenceInlineComment\n\t...jiraIssue\n\t...jiraPlatformComment\n\t...jiraServiceManagementComment\n      }\n    }\n    event {\n      id\n      timestamp\n      eventType\n      actor {\n        name\n        picture\n        accountId\n      }\n    }\n  }\n}\nfragment activityItemConnection on ActivityConnection {\n  edges {\n    ...activityItemEdge\n  }\n}\n\n'
};

});


parcelRegister("1KUQX", function(module, exports) {
$parcel$export(module.exports, "createActivityClient", function () { return $1476302f3691ca20$export$224367b01f71f2aa; });

var $70b4e = parcelRequire("70b4e");

var $4zPwD = parcelRequire("4zPwD");
var $1476302f3691ca20$var$previousClientVersion;
var $1476302f3691ca20$export$224367b01f71f2aa = function createActivityClient(version, product, logger, baseUrl, configFetch) {
    if ($1476302f3691ca20$var$previousClientVersion && $1476302f3691ca20$var$previousClientVersion !== version && logger !== null && logger !== void 0 && logger.captureWarning) logger.captureWarning("ActivityClient version has changed, is this intentional?");
    $1476302f3691ca20$var$previousClientVersion = version || 'v3';
    if (version === 'v2') return new (0, $70b4e.ActivityClientV2)(product, baseUrl);
    return new (0, $4zPwD.ActivityClientV3)(product, baseUrl, logger, configFetch);
};

});
parcelRegister("70b4e", function(module, exports) {
$parcel$export(module.exports, "ActivityClientV2", function () { return $51911e35d6e40ecd$export$330ab0047f2fb745; });

var $cn8ql = parcelRequire("cn8ql");

var $avOEA = parcelRequire("avOEA");

var $cTewU = parcelRequire("cTewU");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $i7dvh = parcelRequire("i7dvh");

var $f53LC = parcelRequire("f53LC");

var $5Cxn4 = parcelRequire("5Cxn4");

var $f4XZt = parcelRequire("f4XZt");

var $hqgpR = parcelRequire("hqgpR");

var $6gfwl = parcelRequire("6gfwl");
function $51911e35d6e40ecd$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $51911e35d6e40ecd$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $51911e35d6e40ecd$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($51911e35d6e40ecd$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $51911e35d6e40ecd$export$330ab0047f2fb745 = /*#__PURE__*/ function(_ActivityClient) {
    function ActivityClientV2(_product, baseUrl) {
        var _this;
        (0, $cTewU.default)(this, ActivityClientV2);
        _this = $51911e35d6e40ecd$var$_callSuper(this, ActivityClientV2, [
            'v2',
            _product,
            undefined,
            baseUrl
        ]);
        (0, $f53LC.default)(_this, "fetchActivities", /*#__PURE__*/ function() {
            var _ref = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(retryMS, filters, activityQueries) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            return _context.abrupt("return", (0, $f4XZt.fetchActivitiesWithExperience)(function(experience) {
                                return (0, $6gfwl.fetchActivitiesV2)({
                                    experience: experience,
                                    product: _this.product,
                                    retryMS: retryMS,
                                    filters: filters,
                                    activityQueries: activityQueries,
                                    baseUrl: _this.baseUrl
                                });
                            }, 'v2'));
                        case 1:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function(_x, _x2, _x3) {
                return _ref.apply(this, arguments);
            };
        }());
        (0, $f53LC.default)(_this, "setProduct", function(product) {
            _this.product = product;
        });
        return _this;
    }
    (0, $i7dvh.default)(ActivityClientV2, _ActivityClient);
    return (0, $avOEA.default)(ActivityClientV2);
}((0, $hqgpR.ActivityClient));

});
parcelRegister("f4XZt", function(module, exports) {
$parcel$export(module.exports, "fetchActivitiesWithExperience", function () { return $afa5c39692fb149f$export$4a906f16800734f3; });

var $f53LC = parcelRequire("f53LC");

var $cn8ql = parcelRequire("cn8ql");

var $5Cxn4 = parcelRequire("5Cxn4");

var $6tfcl = parcelRequire("6tfcl");

var $bmweo = parcelRequire("bmweo");

var $4jJEe = parcelRequire("4jJEe");
function $afa5c39692fb149f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $afa5c39692fb149f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $afa5c39692fb149f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $afa5c39692fb149f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $afa5c39692fb149f$export$4a906f16800734f3(_x, _x2) {
    return $afa5c39692fb149f$var$_fetchActivitiesWithExperience.apply(this, arguments);
}
function $afa5c39692fb149f$var$_fetchActivitiesWithExperience() {
    $afa5c39692fb149f$var$_fetchActivitiesWithExperience = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(fetchActivities, clientVersion) {
        var experience, data;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    experience = clientVersion === 'v2' ? (0, $4jJEe.recentWorkClientExperienceV2)() : (0, $4jJEe.recentWorkClientExperienceV3)();
                    _context.prev = 1;
                    experience.start();
                    experience.addMetadata({
                        clientVersion: clientVersion,
                        packageName: (0, $bmweo.packageName),
                        packageVersion: (0, $bmweo.packageVersion)
                    });
                    _context.next = 6;
                    return fetchActivities(experience);
                case 6:
                    data = _context.sent;
                    experience.success();
                    return _context.abrupt("return", data);
                case 11:
                    _context.prev = 11;
                    _context.t0 = _context["catch"](1);
                    experience.failure({
                        metadata: {
                            error: $afa5c39692fb149f$export$f33622abb5224195(_context.t0)
                        }
                    });
                    throw _context.t0;
                case 15:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                1,
                11
            ]
        ]);
    }));
    return $afa5c39692fb149f$var$_fetchActivitiesWithExperience.apply(this, arguments);
}
var $afa5c39692fb149f$export$f33622abb5224195 = function exceptionToMetadata(e) {
    if (e instanceof (0, $6tfcl.default)) {
        var _e$xRequestId;
        return $afa5c39692fb149f$var$_objectSpread($afa5c39692fb149f$var$_objectSpread({}, e), {}, {
            xRequestId: (_e$xRequestId = e.xRequestId) !== null && _e$xRequestId !== void 0 ? _e$xRequestId : undefined,
            cause: undefined
        });
    }
    return e instanceof Error ? $afa5c39692fb149f$var$_objectSpread($afa5c39692fb149f$var$_objectSpread({}, e), {}, {
        cause: undefined
    }) : 'unknown';
};

});
parcelRegister("6tfcl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4b613d84cb775990$export$2e2bcd8739ae039; });

var $avOEA = parcelRequire("avOEA");

var $cTewU = parcelRequire("cTewU");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $i7dvh = parcelRequire("i7dvh");

var $4GELH = parcelRequire("4GELH");
function $4b613d84cb775990$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $4b613d84cb775990$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $4b613d84cb775990$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($4b613d84cb775990$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $4b613d84cb775990$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    function HttpError(_ref) {
        var _this;
        var message = _ref.message, statusCode = _ref.statusCode, path = _ref.path, method = _ref.method, xRequestId = _ref.xRequestId, headers = _ref.headers;
        (0, $cTewU.default)(this, HttpError);
        _this = $4b613d84cb775990$var$_callSuper(this, HttpError);
        _this.name = 'HttpError';
        _this.message = message;
        var p = path.split('?')[0];
        _this.path = /^[/-a-z]+$/i.test(p) ? p : '';
        _this.method = method;
        _this.statusCode = statusCode;
        _this.xRequestId = xRequestId;
        // @ts-ignore - Property 'entries' does not exist on type 'Headers'.
        // This was added when enrolling `@atlassian/recent-work-client` into JFE local consumption
        _this.headers = Array.from(headers.entries()).map(function(value, key) {
            return "".concat(key, ":").concat(value);
        }).sort().join(',');
        return _this;
    }
    (0, $i7dvh.default)(HttpError, _Error);
    return (0, $avOEA.default)(HttpError);
}(/*#__PURE__*/ (0, $4GELH.default)(Error));
var $4b613d84cb775990$export$97b788730ba59845 = function isHttpError(e) {
    return e instanceof $4b613d84cb775990$export$2e2bcd8739ae039;
};

});

parcelRegister("bmweo", function(module, exports) {
$parcel$export(module.exports, "packageName", function () { return $845ac03352a14b07$export$9345d7360ffe0722; });
$parcel$export(module.exports, "packageVersion", function () { return $845ac03352a14b07$export$91546b032799aa40; });
var $845ac03352a14b07$export$9345d7360ffe0722 = "@atlassian/recent-work-client";
var $845ac03352a14b07$export$91546b032799aa40 = "1.11.0";

});

parcelRegister("4jJEe", function(module, exports) {
$parcel$export(module.exports, "recentWorkClientExperienceV2", function () { return $324c5883fd879e03$export$d7769758f5eaa63b; });
$parcel$export(module.exports, "recentWorkClientExperienceV3", function () { return $324c5883fd879e03$export$9e32a4ed888f4717; });

var $exy8S = parcelRequire("exy8S");
var $edn2O = parcelRequire("edn2O");
var $324c5883fd879e03$var$keyToTiming = function keyToTiming(key) {
    return {
        key: key,
        startMark: "".concat(key, "_start"),
        endMark: "".concat(key, "_end")
    };
};
var $324c5883fd879e03$var$timings = [
    'FetchedActivities',
    'TransformedActivityItems',
    'GeneratedQueryWithFilters'
].map($324c5883fd879e03$var$keyToTiming);
var $324c5883fd879e03$export$d7769758f5eaa63b = function recentWorkClientExperienceV2() {
    return new (0, $edn2O.UFOExperience)('client', {
        type: (0, $exy8S.ExperienceTypes).Load,
        performanceType: (0, $exy8S.ExperiencePerformanceTypes).Custom,
        platform: {
            component: 'recent-work'
        },
        timings: $324c5883fd879e03$var$timings
    });
};
var $324c5883fd879e03$export$9e32a4ed888f4717 = function recentWorkClientExperienceV3() {
    return new (0, $edn2O.UFOExperience)('client-v3', {
        type: (0, $exy8S.ExperienceTypes).Load,
        performanceType: (0, $exy8S.ExperiencePerformanceTypes).Custom,
        platform: {
            component: 'recent-work'
        },
        timings: $324c5883fd879e03$var$timings
    });
};

});
parcelRegister("exy8S", function(module, exports) {
$parcel$export(module.exports, "ExperienceTypes", function () { return $a95ea1aed6d4dc44$export$994164cf3ae1cc9a; });
$parcel$export(module.exports, "ExperiencePerformanceTypes", function () { return $a95ea1aed6d4dc44$export$cc26007c03242fff; });
var $a95ea1aed6d4dc44$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $a95ea1aed6d4dc44$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});

parcelRegister("edn2O", function(module, exports) {
$parcel$export(module.exports, "UFOExperience", function () { return $a59427b64d07d14a$export$c00d22927c60484a; });

var $avOEA = parcelRequire("avOEA");

var $cTewU = parcelRequire("cTewU");

var $i7dvh = parcelRequire("i7dvh");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $1pVvW = parcelRequire("1pVvW");
function $a59427b64d07d14a$var$_createSuper(t) {
    var r = $a59427b64d07d14a$var$_isNativeReflectConstruct();
    return function() {
        var e, o = (0, $jlBwm.default)(t);
        if (r) {
            var s = (0, $jlBwm.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $i3Ugd.default)(this, e);
    };
}
function $a59427b64d07d14a$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a59427b64d07d14a$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $a59427b64d07d14a$export$c00d22927c60484a = /*#__PURE__*/ function(_UFOAbstractExperienc) {
    (0, $i7dvh.default)(UFOExperience, _UFOAbstractExperienc);
    var _super = $a59427b64d07d14a$var$_createSuper(UFOExperience);
    function UFOExperience() {
        (0, $cTewU.default)(this, UFOExperience);
        return _super.apply(this, arguments);
    }
    return (0, $avOEA.default)(UFOExperience);
}((0, $1pVvW.UFOAbstractExperience));

});
parcelRegister("1pVvW", function(module, exports) {
$parcel$export(module.exports, "UFOAbstractExperience", function () { return $1084bd607500efb9$export$d31c89db257648c; });

var $lFOXD = parcelRequire("lFOXD");

var $cn8ql = parcelRequire("cn8ql");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $5Cxn4 = parcelRequire("5Cxn4");

var $7ClvB = parcelRequire("7ClvB");

var $bUjPg = parcelRequire("bUjPg");

var $lSX13 = parcelRequire("lSX13");

var $bpZXt = parcelRequire("bpZXt");

var $631GR = parcelRequire("631GR");

var $1naES = parcelRequire("1naES");

var $8QX85 = parcelRequire("8QX85");

var $efeDA = parcelRequire("efeDA");

var $1sPvo = parcelRequire("1sPvo");

var $lw61j = parcelRequire("lw61j");

var $exy8S = parcelRequire("exy8S");
function $1084bd607500efb9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1084bd607500efb9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1084bd607500efb9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1084bd607500efb9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1084bd607500efb9$var$getPageVisibleState = function getPageVisibleState() {
    return !(0, $lSX13.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $8QX85.PageVisibleState).VISIBLE : (0, $8QX85.PageVisibleState).HIDDEN;
};
var $1084bd607500efb9$export$c753e8669d30c8ad = function perfNowOrTimestamp(timestamp) {
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $efeDA.roundPerfNow)();
};
var $1084bd607500efb9$export$d31c89db257648c = /*#__PURE__*/ function() {
    function UFOAbstractExperience(id, config) {
        var _this = this;
        var instanceId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        (0, $cTewU.default)(this, UFOAbstractExperience);
        (0, $f53LC.default)(this, "state", (0, $1sPvo.UFOExperienceState).NOT_STARTED);
        (0, $f53LC.default)(this, "instanceId", null);
        // for concurrent
        (0, $f53LC.default)(this, "parent", null);
        (0, $f53LC.default)(this, "category", null);
        (0, $f53LC.default)(this, "metadata", {});
        (0, $f53LC.default)(this, "onDoneCallbacks", []);
        (0, $f53LC.default)(this, "childExperiences", []);
        (0, $f53LC.default)(this, "explicitTimings", {});
        // @todo move to page load experience when proper classes/inheritance prepared
        (0, $f53LC.default)(this, "isSSROutputAsFMP", false);
        (0, $f53LC.default)(this, "uuid", null);
        (0, $f53LC.default)(this, "_until", null);
        (0, $f53LC.default)(this, "metrics", {
            startTime: null,
            endTime: null,
            marks: []
        });
        (0, $f53LC.default)(this, "performanceConfig", {});
        (0, $f53LC.default)(this, "setPageVisibleStateToMixed", function() {
            _this.pageVisibleState = (0, $8QX85.PageVisibleState).MIXED;
            (0, $1naES.visibilityChangeObserver).unsubscribe(_this.setPageVisibleStateToMixed);
        });
        this.id = id;
        this.category = (config === null || config === void 0 ? void 0 : config.category) || null;
        this.until = (config === null || config === void 0 ? void 0 : config.until) || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $1084bd607500efb9$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $exy8S.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $exy8S.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    (0, $avOEA.default)(UFOAbstractExperience, [
        {
            key: "transition",
            value: function() {
                var _transition = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(newState, timestamp) {
                    var data;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                (0, $631GR.ufolog)('async transition', this.id, this.state.id, newState.id);
                                if (!(0, $lw61j.canTransition)(this.state, newState)) {
                                    _context.next = 15;
                                    break;
                                }
                                (0, $631GR.ufolog)("TRANSITION: ".concat(this.id, " from ").concat(this.state.id, " to ").concat(newState.id, " successful"), this.state.final, !newState.final);
                                if (newState === (0, $1sPvo.UFOExperienceState).STARTED) this._reset();
                                if (this.state.final && !newState.final) {
                                    this.metrics.startTime = $1084bd607500efb9$export$c753e8669d30c8ad(timestamp);
                                    this.uuid = (0, $7ClvB.v4)();
                                }
                                this.state = newState;
                                if (!newState.final) {
                                    _context.next = 14;
                                    break;
                                }
                                this.metrics.endTime = $1084bd607500efb9$export$c753e8669d30c8ad(timestamp);
                                if (!this._isManualStateEnabled()) (0, $bpZXt.getGlobalEventStream)().push((0, $bpZXt.unsubscribeEvent)((0, $8QX85.SUBSCRIBE_ALL), this.handleDoneBind));
                                _context.next = 11;
                                return this.exportData();
                            case 11:
                                data = _context.sent;
                                (0, $631GR.ufolog)('this.parent', this.parent);
                                (0, $bpZXt.getGlobalEventStream)().push((0, $bpZXt.experiencePayloadEvent)(data));
                            case 14:
                                return _context.abrupt("return", true);
                            case 15:
                                (0, $631GR.ufolog)("TRANSITION: ".concat(this.id, " from ").concat(this.state.id, " to ").concat(newState.id, " unsuccessful"));
                                (0, $631GR.ufowarn)("transition of ".concat(this.id, " from ").concat(this.state, " to ").concat(newState, " is not possible"));
                                return _context.abrupt("return", false);
                            case 18:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function transition(_x, _x2) {
                    return _transition.apply(this, arguments);
                }
                return transition;
            }()
        },
        {
            key: "start",
            value: function() {
                var _start = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(startTime) {
                    var transitionSuccessful;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return this.transition((0, $1sPvo.UFOExperienceState).STARTED, startTime);
                            case 2:
                                transitionSuccessful = _context2.sent;
                                if (transitionSuccessful) {
                                    this.pageVisibleState = $1084bd607500efb9$var$getPageVisibleState();
                                    (0, $1naES.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
                                    if (!this._isManualStateEnabled()) {
                                        (0, $631GR.ufolog)('subscribed', this.id);
                                        (0, $bpZXt.getGlobalEventStream)().push((0, $bpZXt.subscribeEvent)((0, $8QX85.SUBSCRIBE_ALL), this.handleDoneBind));
                                    }
                                }
                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function start(_x3) {
                    return _start.apply(this, arguments);
                }
                return start;
            }()
        },
        {
            key: "mark",
            value: function mark(name, timestamp) {
                if (name !== (0, $8QX85.FMP_MARK) && name !== (0, $8QX85.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
                else (0, $631GR.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
            }
        },
        {
            key: "_mark",
            value: function _mark(name, timestamp) {
                this.metrics.marks.push({
                    name: name,
                    time: $1084bd607500efb9$export$c753e8669d30c8ad(timestamp)
                });
                this.transition((0, $1sPvo.UFOExperienceState).IN_PROGRESS);
            }
        },
        {
            key: "markFMP",
            value: function markFMP(timestamp) {
                this._mark((0, $8QX85.FMP_MARK), timestamp);
            }
        },
        {
            key: "markInlineResponse",
            value: function markInlineResponse(timestamp) {
                this._mark((0, $8QX85.INLINE_RESPONSE_MARK), timestamp);
            }
        },
        {
            key: "_isManualStateEnabled",
            value: function _isManualStateEnabled() {
                return this.until === null;
            }
        },
        {
            key: "_validateManualState",
            value: function _validateManualState() {
                if (!this._isManualStateEnabled()) {
                    (0, $631GR.ufowarn)('manual change of state not allowed as "until" is defined');
                    return false;
                }
                return true;
            }
        },
        {
            key: "switchToEndState",
            value: function switchToEndState(state, config) {
                if (!(config !== null && config !== void 0 && config.force) && !this._validateManualState()) return null;
                if (config !== null && config !== void 0 && config.metadata) this.addMetadata(config.metadata);
                (0, $1naES.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
                return this.transition(state);
            }
        },
        {
            key: "success",
            value: function() {
                var _success = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", this.switchToEndState((0, $1sPvo.UFOExperienceState).SUCCEEDED, config));
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function success(_x4) {
                    return _success.apply(this, arguments);
                }
                return success;
            }()
        },
        {
            key: "failure",
            value: function() {
                var _failure = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee4(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                return _context4.abrupt("return", this.switchToEndState((0, $1sPvo.UFOExperienceState).FAILED, config));
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function failure(_x5) {
                    return _failure.apply(this, arguments);
                }
                return failure;
            }()
        },
        {
            key: "abort",
            value: function() {
                var _abort = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee5(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                return _context5.abrupt("return", this.switchToEndState((0, $1sPvo.UFOExperienceState).ABORTED, config));
                            case 1:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function abort(_x6) {
                    return _abort.apply(this, arguments);
                }
                return abort;
            }()
        },
        {
            key: "addMetadata",
            value: function addMetadata(data) {
                Object.assign(this.metadata, data);
            }
        },
        {
            key: "_handleDoneExperience",
            value: function _handleDoneExperience(data) {
                (0, $631GR.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
                if (data.state.final) {
                    if (this._until !== null) {
                        var _this$_until = this._until(data), done = _this$_until.done, state = _this$_until.state;
                        if (done && !this.state.final) this.transition(state);
                    }
                }
            }
        },
        {
            key: "getId",
            value: function() {
                var _getId = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee6() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                return _context6.abrupt("return", this.id);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function getId() {
                    return _getId.apply(this, arguments);
                }
                return getId;
            }()
        },
        {
            key: "exportData",
            value: function() {
                var _exportData = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                _context7.next = 2;
                                return this.getId();
                            case 2:
                                _context7.t0 = _context7.sent;
                                _context7.t1 = this.uuid;
                                _context7.t2 = this.type;
                                _context7.t3 = (0, $bUjPg.UFO_EXPERIMENTAL_BUILD_VERSION) || 'unknown';
                                _context7.t4 = this.performanceType;
                                _context7.t5 = this.category;
                                _context7.t6 = this.state;
                                _context7.t7 = $1084bd607500efb9$var$_objectSpread({}, this.metadata);
                                _context7.t8 = $1084bd607500efb9$var$_objectSpread({}, this.metrics);
                                _context7.t9 = (0, $lFOXD.default)(this.childExperiences);
                                _context7.t10 = {
                                    success: !!this.state.success,
                                    startTime: this.metrics.startTime,
                                    duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
                                };
                                _context7.t11 = this.config.platform || null;
                                _context7.t12 = this.pageVisibleState;
                                _context7.t13 = this.featureFlags;
                                _context7.t14 = this.isSSROutputAsFMP;
                                _context7.t15 = this.timings;
                                _context7.t16 = this.explicitTimings;
                                _context7.t17 = this.performanceConfig;
                                return _context7.abrupt("return", {
                                    id: _context7.t0,
                                    uuid: _context7.t1,
                                    type: _context7.t2,
                                    schemaVersion: _context7.t3,
                                    performanceType: _context7.t4,
                                    category: _context7.t5,
                                    state: _context7.t6,
                                    metadata: _context7.t7,
                                    metrics: _context7.t8,
                                    children: _context7.t9,
                                    result: _context7.t10,
                                    platform: _context7.t11,
                                    pageVisibleState: _context7.t12,
                                    featureFlags: _context7.t13,
                                    isSSROutputAsFMP: _context7.t14,
                                    timings: _context7.t15,
                                    explicitTimings: _context7.t16,
                                    performanceConfig: _context7.t17
                                });
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function exportData() {
                    return _exportData.apply(this, arguments);
                }
                return exportData;
            }()
        },
        {
            key: "_reset",
            value: function _reset() {
                this.parent = null;
                this.metadata = {};
                this.onDoneCallbacks = [];
                this.childExperiences = [];
                this.metrics = {
                    startTime: null,
                    endTime: null,
                    marks: []
                };
                this._until = this.until ? this.until() : null;
            }
        }
    ]);
    return UFOAbstractExperience;
}();

});
parcelRegister("7ClvB", function(module, exports) {

var $kDxb0 = parcelRequire("kDxb0");

var $gqRFp = parcelRequire("gqRFp");
var $58bcc437ecb0573d$var$uuid = $gqRFp;
$58bcc437ecb0573d$var$uuid.v1 = $kDxb0;
$58bcc437ecb0573d$var$uuid.v4 = $gqRFp;
module.exports = $58bcc437ecb0573d$var$uuid;

});
parcelRegister("kDxb0", function(module, exports) {

var $3n19L = parcelRequire("3n19L");

var $7hqHV = parcelRequire("7hqHV");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $f0612f5722e69906$var$_nodeId;
var $f0612f5722e69906$var$_clockseq;
// Previous uuid creation time
var $f0612f5722e69906$var$_lastMSecs = 0;
var $f0612f5722e69906$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $f0612f5722e69906$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $f0612f5722e69906$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $f0612f5722e69906$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $3n19L();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $f0612f5722e69906$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $f0612f5722e69906$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $f0612f5722e69906$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $f0612f5722e69906$var$_lastMSecs + (nsecs - $f0612f5722e69906$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $f0612f5722e69906$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $f0612f5722e69906$var$_lastMSecs = msecs;
    $f0612f5722e69906$var$_lastNSecs = nsecs;
    $f0612f5722e69906$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $7hqHV(b);
}
module.exports = $f0612f5722e69906$var$v1;

});
parcelRegister("3n19L", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $27446ab697bddb5a$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($27446ab697bddb5a$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $27446ab697bddb5a$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $27446ab697bddb5a$var$getRandomValues($27446ab697bddb5a$var$rnds8);
        return $27446ab697bddb5a$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $27446ab697bddb5a$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $27446ab697bddb5a$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $27446ab697bddb5a$var$rnds;
    };
}

});

parcelRegister("7hqHV", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $54ced67b03ce93b5$var$byteToHex = [];
for(var $54ced67b03ce93b5$var$i = 0; $54ced67b03ce93b5$var$i < 256; ++$54ced67b03ce93b5$var$i)$54ced67b03ce93b5$var$byteToHex[$54ced67b03ce93b5$var$i] = ($54ced67b03ce93b5$var$i + 0x100).toString(16).substr(1);
function $54ced67b03ce93b5$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $54ced67b03ce93b5$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = $54ced67b03ce93b5$var$bytesToUuid;

});


parcelRegister("gqRFp", function(module, exports) {

var $3n19L = parcelRequire("3n19L");

var $7hqHV = parcelRequire("7hqHV");
function $bf68b4309ff61307$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $3n19L)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $7hqHV(rnds);
}
module.exports = $bf68b4309ff61307$var$v4;

});


parcelRegister("bUjPg", function(module, exports) {
$parcel$export(module.exports, "UFO_EXPERIMENTAL_BUILD_VERSION", function () { return $8ab44daee64ff22f$export$2295b861f318254a; });
// temp solution until we can get it automated
var $8ab44daee64ff22f$export$2295b861f318254a = '0.1.5';

});

parcelRegister("lSX13", function(module, exports) {
$parcel$export(module.exports, "isWindowObjectAvailable", function () { return $feec6b7a32ace375$export$15e172712955e18f; });
var $feec6b7a32ace375$export$15e172712955e18f = function isWindowObjectAvailable() {
    return typeof window !== 'undefined';
};

});

parcelRegister("bpZXt", function(module, exports) {
$parcel$export(module.exports, "getGlobalEventStream", function () { return $850217257f5f22bc$export$6123a44dc2384540; });
$parcel$export(module.exports, "subscribeEvent", function () { return $850217257f5f22bc$export$37863216db4b714d; });
$parcel$export(module.exports, "unsubscribeEvent", function () { return $850217257f5f22bc$export$ee1a7bd1fc9ea85e; });
$parcel$export(module.exports, "experiencePayloadEvent", function () { return $850217257f5f22bc$export$7c957416596ca127; });

var $631GR = parcelRequire("631GR");

var $8QX85 = parcelRequire("8QX85");
var $850217257f5f22bc$var$MAX_EARLY_QUEUE_LENGTH = 250;
var $850217257f5f22bc$export$6123a44dc2384540 = function getGlobalEventStream() {
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        var earlyStream = function() {
            var stream = [];
            return {
                __buffer_only__: true,
                push: function push(event) {
                    if (stream.length < $850217257f5f22bc$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: function getStream() {
                    return stream;
                }
            };
        }();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
var $850217257f5f22bc$export$c1522520b417b066 = function setGlobalEventStream(eventStream) {
    var _globalThis$__UFO_GLO, _globalThis$__UFO_GLO2;
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !((_globalThis$__UFO_GLO = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO !== void 0 && _globalThis$__UFO_GLO.__buffer_only__)) {
        (0, $631GR.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if ((_globalThis$__UFO_GLO2 = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO2 !== void 0 && _globalThis$__UFO_GLO2.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
var $850217257f5f22bc$export$37863216db4b714d = function subscribeEvent(experienceId, callback) {
    return {
        type: (0, $8QX85.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
var $850217257f5f22bc$export$ee1a7bd1fc9ea85e = function unsubscribeEvent(experienceId, callback) {
    return {
        type: (0, $8QX85.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
var $850217257f5f22bc$export$7c957416596ca127 = function experiencePayloadEvent(data) {
    return {
        type: (0, $8QX85.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("631GR", function(module, exports) {
$parcel$export(module.exports, "ufolog", function () { return $4674558859cea609$export$b4958caff08a0960; });
$parcel$export(module.exports, "ufowarn", function () { return $4674558859cea609$export$d53d07b6034c4560; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");
var $4674558859cea609$var$UFOLogger = /*#__PURE__*/ function() {
    function UFOLogger() {
        (0, $cTewU.default)(this, UFOLogger);
        (0, $f53LC.default)(this, "enabled", false);
    }
    (0, $avOEA.default)(UFOLogger, [
        {
            key: "log",
            value: function log() {
                var _console;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                // eslint-disable-next-line no-console
                this.enabled && (_console = console).log.apply(_console, [
                    UFOLogger.UFOprefix
                ].concat(args));
            }
        },
        {
            key: "warn",
            value: function warn() {
                var _console2;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                // eslint-disable-next-line no-console
                this.enabled && (_console2 = console).warn.apply(_console2, [
                    UFOLogger.UFOprefix
                ].concat(args));
            }
        },
        {
            key: "enable",
            value: function enable() {
                this.enabled = true;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this.enabled = false;
            }
        }
    ]);
    return UFOLogger;
}();
(0, $f53LC.default)($4674558859cea609$var$UFOLogger, "UFOprefix", "[ufo\uD83D\uDEF8]");
var $4674558859cea609$export$4ab84f6f04f6566d = new $4674558859cea609$var$UFOLogger();
var $4674558859cea609$export$b4958caff08a0960 = function ufolog() {
    $4674558859cea609$export$4ab84f6f04f6566d.log.apply($4674558859cea609$export$4ab84f6f04f6566d, arguments);
};
var $4674558859cea609$export$d53d07b6034c4560 = function ufowarn() {
    $4674558859cea609$export$4ab84f6f04f6566d.warn.apply($4674558859cea609$export$4ab84f6f04f6566d, arguments);
};

});

parcelRegister("8QX85", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStreamEventType", function () { return $67210bee74e8c90e$export$96253c35c37cf96b; });
$parcel$export(module.exports, "PageVisibleState", function () { return $67210bee74e8c90e$export$a12c67b37a306b13; });
$parcel$export(module.exports, "SUBSCRIBE_ALL", function () { return $67210bee74e8c90e$export$79bf131685ad41d7; });
$parcel$export(module.exports, "FMP_MARK", function () { return $67210bee74e8c90e$export$9f2bf58999404c75; });
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", function () { return $67210bee74e8c90e$export$837e0f79a8056912; });
var $67210bee74e8c90e$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $67210bee74e8c90e$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $67210bee74e8c90e$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $67210bee74e8c90e$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $67210bee74e8c90e$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $67210bee74e8c90e$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
var $67210bee74e8c90e$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
var $67210bee74e8c90e$export$9f2bf58999404c75 = 'fmp';
var $67210bee74e8c90e$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("1naES", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", function () { return $100034ebf032be4d$export$13e680397ec8f3eb; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $lSX13 = parcelRequire("lSX13");
var $100034ebf032be4d$var$VisibilityChangeObserver = /*#__PURE__*/ function() {
    function VisibilityChangeObserver() {
        var _this = this;
        (0, $cTewU.default)(this, VisibilityChangeObserver);
        (0, $f53LC.default)(this, "started", false);
        (0, $f53LC.default)(this, "observers", []);
        (0, $f53LC.default)(this, "broadcast", function() {
            _this.observers.forEach(function(fn) {
                return fn();
            });
            _this.observers = [];
        });
    }
    (0, $avOEA.default)(VisibilityChangeObserver, [
        {
            key: "start",
            value: function start() {
                if (this.started) return;
                this.started = true;
                document.addEventListener('visibilitychange', this.broadcast);
                /**
       * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
       * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
       * so for that case, you need to also include code to listen for the pagehide event.
       */ if ((0, $lSX13.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                this.observers.push(callback);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(callback) {
                this.observers = this.observers.filter(function(fn) {
                    return fn !== callback;
                });
            }
        }
    ]);
    return VisibilityChangeObserver;
}();
var $100034ebf032be4d$export$13e680397ec8f3eb = new $100034ebf032be4d$var$VisibilityChangeObserver();

});

parcelRegister("efeDA", function(module, exports) {
$parcel$export(module.exports, "roundPerfNow", function () { return $a5edd216c26ead39$export$5f490af6b2b115cf; });
var $a5edd216c26ead39$export$5f490af6b2b115cf = function roundPerfNow() {
    return ~~performance.now();
};

});

parcelRegister("1sPvo", function(module, exports) {
$parcel$export(module.exports, "UFOExperienceState", function () { return $11105bdd531249ff$export$81b70111112841a0; });
var $11105bdd531249ff$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    // isn't recovered IN_PROGRESS?
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("lw61j", function(module, exports) {
$parcel$export(module.exports, "canTransition", function () { return $faa141a145d9a8bc$export$178881f329fdb81f; });

var $f53LC = parcelRequire("f53LC");

var $1sPvo = parcelRequire("1sPvo");
var $faa141a145d9a8bc$var$_UFOStateAvailableTra;
var $faa141a145d9a8bc$var$UFOStateAvailableTransitions = ($faa141a145d9a8bc$var$_UFOStateAvailableTra = {}, (0, $f53LC.default)($faa141a145d9a8bc$var$_UFOStateAvailableTra, (0, $1sPvo.UFOExperienceState).NOT_STARTED.id, [
    (0, $1sPvo.UFOExperienceState).STARTED.id
]), (0, $f53LC.default)($faa141a145d9a8bc$var$_UFOStateAvailableTra, (0, $1sPvo.UFOExperienceState).STARTED.id, [
    (0, $1sPvo.UFOExperienceState).IN_PROGRESS.id,
    (0, $1sPvo.UFOExperienceState).BLOCKED.id,
    (0, $1sPvo.UFOExperienceState).SUCCEEDED.id,
    (0, $1sPvo.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $1sPvo.UFOExperienceState).FAILED.id,
    (0, $1sPvo.UFOExperienceState).ABORTED.id
]), (0, $f53LC.default)($faa141a145d9a8bc$var$_UFOStateAvailableTra, (0, $1sPvo.UFOExperienceState).IN_PROGRESS.id, [
    (0, $1sPvo.UFOExperienceState).BLOCKED.id,
    (0, $1sPvo.UFOExperienceState).SUCCEEDED.id,
    (0, $1sPvo.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $1sPvo.UFOExperienceState).FAILED.id,
    (0, $1sPvo.UFOExperienceState).ABORTED.id
]), (0, $f53LC.default)($faa141a145d9a8bc$var$_UFOStateAvailableTra, (0, $1sPvo.UFOExperienceState).BLOCKED.id, [
    (0, $1sPvo.UFOExperienceState).RECOVERED.id,
    (0, $1sPvo.UFOExperienceState).ABORTED.id
]), (0, $f53LC.default)($faa141a145d9a8bc$var$_UFOStateAvailableTra, (0, $1sPvo.UFOExperienceState).RECOVERED.id, [
    (0, $1sPvo.UFOExperienceState).STARTED.id,
    (0, $1sPvo.UFOExperienceState).SUCCEEDED.id,
    (0, $1sPvo.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $1sPvo.UFOExperienceState).FAILED.id,
    (0, $1sPvo.UFOExperienceState).ABORTED.id
]), (0, $f53LC.default)($faa141a145d9a8bc$var$_UFOStateAvailableTra, (0, $1sPvo.UFOExperienceState).SUCCEEDED.id, [
    (0, $1sPvo.UFOExperienceState).STARTED.id
]), (0, $f53LC.default)($faa141a145d9a8bc$var$_UFOStateAvailableTra, (0, $1sPvo.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id, [
    (0, $1sPvo.UFOExperienceState).SUCCEEDED.id,
    (0, $1sPvo.UFOExperienceState).FAILED.id,
    (0, $1sPvo.UFOExperienceState).ABORTED.id
]), (0, $f53LC.default)($faa141a145d9a8bc$var$_UFOStateAvailableTra, (0, $1sPvo.UFOExperienceState).FAILED.id, [
    (0, $1sPvo.UFOExperienceState).STARTED.id
]), (0, $f53LC.default)($faa141a145d9a8bc$var$_UFOStateAvailableTra, (0, $1sPvo.UFOExperienceState).ABORTED.id, [
    (0, $1sPvo.UFOExperienceState).STARTED.id
]), $faa141a145d9a8bc$var$_UFOStateAvailableTra);
var $faa141a145d9a8bc$export$178881f329fdb81f = function canTransition(state1, state2) {
    return $faa141a145d9a8bc$var$UFOStateAvailableTransitions[state1.id] && $faa141a145d9a8bc$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});





parcelRegister("hqgpR", function(module, exports) {
$parcel$export(module.exports, "ActivityClient", function () { return $caf199469e9dacc4$export$157740f5433f3dbe; });

var $avOEA = parcelRequire("avOEA");

var $cTewU = parcelRequire("cTewU");

var $f53LC = parcelRequire("f53LC");

var $fOIzk = parcelRequire("fOIzk");
var $caf199469e9dacc4$export$157740f5433f3dbe = /*#__PURE__*/ (0, $avOEA.default)(function ActivityClient(clientVersion, product, headers, baseUrl) {
    (0, $cTewU.default)(this, ActivityClient);
    (0, $f53LC.default)(this, "product", 'unknown');
    (0, $f53LC.default)(this, "baseUrl", (0, $fOIzk.GRAPHQL_GATEWAY_PATH));
    if (product) this.product = product;
    this.clientVersion = clientVersion;
    this.headers = headers !== null && headers !== void 0 ? headers : {};
    if (baseUrl) this.baseUrl = baseUrl;
});

});
parcelRegister("fOIzk", function(module, exports) {
$parcel$export(module.exports, "GRAPHQL_GATEWAY_PATH", function () { return $b83e18f08c5b81bf$export$851c5df667ca24c8; });
$parcel$export(module.exports, "WORKED_EVENT", function () { return $b83e18f08c5b81bf$export$eb4e9f525aef1cc3; });
var $b83e18f08c5b81bf$export$851c5df667ca24c8 = '/gateway/api/graphql';
var $b83e18f08c5b81bf$export$d245b105c09339d8 = /*#__PURE__*/ function(VIEWED_EVENT) {
    VIEWED_EVENT["VIEWED"] = "viewed";
    return VIEWED_EVENT;
}({});
var $b83e18f08c5b81bf$export$eb4e9f525aef1cc3 = /*#__PURE__*/ function(WORKED_EVENT) {
    WORKED_EVENT["COMMENTED"] = "commented";
    WORKED_EVENT["CREATED"] = "created";
    WORKED_EVENT["EDITED"] = "edited";
    WORKED_EVENT["PUBLISHED"] = "published";
    WORKED_EVENT["UPDATED"] = "updated";
    return WORKED_EVENT;
}({});
var $b83e18f08c5b81bf$export$d02a56686be43f69 = /*#__PURE__*/ function(ActivityObjectType) {
    ActivityObjectType["BLOGPOST"] = "BLOGPOST";
    ActivityObjectType["COMMENT"] = "COMMENT";
    ActivityObjectType["ISSUE"] = "ISSUE";
    ActivityObjectType["PAGE"] = "PAGE";
    ActivityObjectType["PROJECT"] = "PROJECT";
    ActivityObjectType["SITE"] = "SITE";
    ActivityObjectType["SPACE"] = "SPACE";
    ActivityObjectType["TASK"] = "TASK";
    return ActivityObjectType;
}({});

});


parcelRegister("6gfwl", function(module, exports) {
$parcel$export(module.exports, "fetchActivitiesV2", function () { return $48f046cf581a607c$export$750ec7816fdd2f9e; });

var $gnQ3X = parcelRequire("gnQ3X");

var $cn8ql = parcelRequire("cn8ql");

var $5Cxn4 = parcelRequire("5Cxn4");

var $8UfbL = parcelRequire("8UfbL");

var $5XQsc = parcelRequire("5XQsc");

var $2reKI = parcelRequire("2reKI");

var $el6fl = parcelRequire("el6fl");
var $48f046cf581a607c$var$_excluded = [
    "limit"
];
var $48f046cf581a607c$var$ACTIVITIES_LIMIT = 50;
// typescript guard for validating the activities connection type
var $48f046cf581a607c$var$isMyActivitiesConnection = function isMyActivitiesConnection(activities) {
    return activities.myActivities !== undefined;
};
var $48f046cf581a607c$var$V2_AVAILABLE_PRODUCTS = [
    'teamCentral',
    'editor',
    'people',
    'jira',
    'townsquare',
    'apOnboarding',
    'worklens',
    'confluence',
    'start'
];
var $48f046cf581a607c$export$750ec7816fdd2f9e = /*#__PURE__*/ function() {
    var _ref2 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(_ref) {
        var _response$data;
        var experience, product, retryMS, _ref$filters, filters, activityQueries, baseUrl, _filters$limit, limit, restFilters, _generateActivityQuer, query, queryFilters, operationProduct, response, workedOn, viewed, all;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    experience = _ref.experience, product = _ref.product, retryMS = _ref.retryMS, _ref$filters = _ref.filters, filters = _ref$filters === void 0 ? {} : _ref$filters, activityQueries = _ref.activityQueries, baseUrl = _ref.baseUrl;
                    _filters$limit = filters.limit, limit = _filters$limit === void 0 ? $48f046cf581a607c$var$ACTIVITIES_LIMIT : _filters$limit, restFilters = (0, $gnQ3X.default)(filters, $48f046cf581a607c$var$_excluded);
                    experience.mark('GeneratedQueryWithFilters_start');
                    _generateActivityQuer = (0, $2reKI.generateActivityQueryWithFilters)(product, restFilters, activityQueries), query = _generateActivityQuer.query, queryFilters = _generateActivityQuer.queryFilters;
                    experience.mark('GeneratedQueryWithFilters_end');
                    // This is to make v2 forwards compatible. Defaulting to start as the product
                    operationProduct = $48f046cf581a607c$var$V2_AVAILABLE_PRODUCTS.includes(product) ? product : 'start';
                    experience.mark('FetchedActivities_start');
                    _context.prev = 7;
                    _context.next = 10;
                    return (0, $5XQsc.postResource)(baseUrl, {
                        operationName: (0, $8UfbL.getOperationName)(operationProduct),
                        query: query,
                        variables: {
                            first: limit,
                            filters: queryFilters
                        }
                    }, retryMS);
                case 10:
                    response = _context.sent;
                    _context.next = 17;
                    break;
                case 13:
                    _context.prev = 13;
                    _context.t0 = _context["catch"](7);
                    if (!(!_context.t0 || _context.t0.statusCode !== 401 && _context.t0.message !== 'The operation was aborted.')) {
                        _context.next = 17;
                        break;
                    }
                    throw _context.t0;
                case 17:
                    experience.mark('FetchedActivities_end');
                    workedOn = [], viewed = [], all = [];
                    if (!(!response || !((_response$data = response.data) !== null && _response$data !== void 0 && _response$data.activities))) {
                        _context.next = 21;
                        break;
                    }
                    return _context.abrupt("return", {
                        all: all,
                        workedOn: workedOn,
                        viewed: viewed
                    });
                case 21:
                    experience.mark('TransformedActivityItems_start');
                    if ($48f046cf581a607c$var$isMyActivitiesConnection(response.data.activities)) {
                        if (response.data.activities.myActivities.workedOn && activityQueries.includes('workedOn')) workedOn = (0, $el6fl.transformActivitiesItems)('workedOn', response.data.activities.myActivities.workedOn);
                        if (response.data.activities.myActivities.viewed && activityQueries.includes('viewed')) viewed = (0, $el6fl.transformActivitiesItems)('viewed', response.data.activities.myActivities.viewed);
                        if (response.data.activities.myActivities.all && activityQueries.includes('all')) all = (0, $el6fl.transformActivitiesItems)('all', response.data.activities.myActivities.all);
                    } else {
                        if (response.data.activities.workedOn && activityQueries.includes('workedOn')) workedOn = (0, $el6fl.transformActivitiesItems)('workedOn', response.data.activities.workedOn);
                        if (response.data.activities.all && activityQueries.includes('all')) all = (0, $el6fl.transformActivitiesItems)('all', response.data.activities.all);
                    }
                    experience.mark('TransformedActivityItems_end');
                    return _context.abrupt("return", {
                        all: all,
                        viewed: viewed,
                        workedOn: workedOn
                    });
                case 25:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                7,
                13
            ]
        ]);
    }));
    return function fetchActivitiesV2(_x) {
        return _ref2.apply(this, arguments);
    };
}();

});
parcelRegister("8UfbL", function(module, exports) {
$parcel$export(module.exports, "getOperationName", function () { return $67bf55daaab91040$export$41bca9dc6871dd4e; });

var $lXgpb = parcelRequire("lXgpb");
var $67bf55daaab91040$export$ad1e21d37f385bcb = function formatProductForOperation(product) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($lXgpb)))(product);
};
var $67bf55daaab91040$export$41bca9dc6871dd4e = function getOperationName(product) {
    return "".concat($67bf55daaab91040$export$ad1e21d37f385bcb(product), "_activity_recentWorkClient");
};

});
parcelRegister("lXgpb", function(module, exports) {

var $gHIMV = parcelRequire("gHIMV");

var $dNNx2 = parcelRequire("dNNx2");
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $ffbbd5682208087f$var$camelCase = $dNNx2(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $gHIMV(word) : word);
});
module.exports = $ffbbd5682208087f$var$camelCase;

});
parcelRegister("dNNx2", function(module, exports) {

var $5r99q = parcelRequire("5r99q");

var $hGxEi = parcelRequire("hGxEi");

var $cGaAm = parcelRequire("cGaAm");
/** Used to compose unicode capture groups. */ var $a0c645f3644bc61c$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $a0c645f3644bc61c$var$reApos = RegExp($a0c645f3644bc61c$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $a0c645f3644bc61c$var$createCompounder(callback) {
    return function(string) {
        return $5r99q($cGaAm($hGxEi(string).replace($a0c645f3644bc61c$var$reApos, '')), callback, '');
    };
}
module.exports = $a0c645f3644bc61c$var$createCompounder;

});
parcelRegister("5r99q", function(module, exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $3f56928ff1fa1456$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = $3f56928ff1fa1456$var$arrayReduce;

});

parcelRegister("hGxEi", function(module, exports) {

var $iCQu6 = parcelRequire("iCQu6");

var $24uwp = parcelRequire("24uwp");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $ce0075e69d454d18$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $ce0075e69d454d18$var$rsComboMarksRange = '\\u0300-\\u036f', $ce0075e69d454d18$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $ce0075e69d454d18$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $ce0075e69d454d18$var$rsComboRange = $ce0075e69d454d18$var$rsComboMarksRange + $ce0075e69d454d18$var$reComboHalfMarksRange + $ce0075e69d454d18$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $ce0075e69d454d18$var$rsCombo = '[' + $ce0075e69d454d18$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $ce0075e69d454d18$var$reComboMark = RegExp($ce0075e69d454d18$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $ce0075e69d454d18$var$deburr(string) {
    string = $24uwp(string);
    return string && string.replace($ce0075e69d454d18$var$reLatin, $iCQu6).replace($ce0075e69d454d18$var$reComboMark, '');
}
module.exports = $ce0075e69d454d18$var$deburr;

});
parcelRegister("iCQu6", function(module, exports) {

var $6V9cT = parcelRequire("6V9cT");
/** Used to map Latin Unicode letters to basic Latin letters. */ var $037fd0776303ae37$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $037fd0776303ae37$var$deburrLetter = $6V9cT($037fd0776303ae37$var$deburredLetters);
module.exports = $037fd0776303ae37$var$deburrLetter;

});
parcelRegister("6V9cT", function(module, exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $509f35426b22b824$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $509f35426b22b824$var$basePropertyOf;

});



parcelRegister("cGaAm", function(module, exports) {

var $agIzJ = parcelRequire("agIzJ");

var $2fyoH = parcelRequire("2fyoH");

var $24uwp = parcelRequire("24uwp");

var $51QbK = parcelRequire("51QbK");
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $93b19e4fcd969484$var$words(string, pattern, guard) {
    string = $24uwp(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $2fyoH(string) ? $51QbK(string) : $agIzJ(string);
    return string.match(pattern) || [];
}
module.exports = $93b19e4fcd969484$var$words;

});
parcelRegister("agIzJ", function(module, exports) {
/** Used to match words composed of alphanumeric characters. */ var $779df9bff564b02d$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $779df9bff564b02d$var$asciiWords(string) {
    return string.match($779df9bff564b02d$var$reAsciiWord) || [];
}
module.exports = $779df9bff564b02d$var$asciiWords;

});

parcelRegister("2fyoH", function(module, exports) {
/** Used to detect strings that need a more robust regexp to match words. */ var $1a37aa184b5f841b$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $1a37aa184b5f841b$var$hasUnicodeWord(string) {
    return $1a37aa184b5f841b$var$reHasUnicodeWord.test(string);
}
module.exports = $1a37aa184b5f841b$var$hasUnicodeWord;

});

parcelRegister("51QbK", function(module, exports) {
/** Used to compose unicode character classes. */ var $3a9587500dbb7d28$var$rsAstralRange = '\\ud800-\\udfff', $3a9587500dbb7d28$var$rsComboMarksRange = '\\u0300-\\u036f', $3a9587500dbb7d28$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $3a9587500dbb7d28$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $3a9587500dbb7d28$var$rsComboRange = $3a9587500dbb7d28$var$rsComboMarksRange + $3a9587500dbb7d28$var$reComboHalfMarksRange + $3a9587500dbb7d28$var$rsComboSymbolsRange, $3a9587500dbb7d28$var$rsDingbatRange = '\\u2700-\\u27bf', $3a9587500dbb7d28$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $3a9587500dbb7d28$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $3a9587500dbb7d28$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $3a9587500dbb7d28$var$rsPunctuationRange = '\\u2000-\\u206f', $3a9587500dbb7d28$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $3a9587500dbb7d28$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $3a9587500dbb7d28$var$rsVarRange = '\\ufe0e\\ufe0f', $3a9587500dbb7d28$var$rsBreakRange = $3a9587500dbb7d28$var$rsMathOpRange + $3a9587500dbb7d28$var$rsNonCharRange + $3a9587500dbb7d28$var$rsPunctuationRange + $3a9587500dbb7d28$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $3a9587500dbb7d28$var$rsApos = "['\u2019]", $3a9587500dbb7d28$var$rsBreak = '[' + $3a9587500dbb7d28$var$rsBreakRange + ']', $3a9587500dbb7d28$var$rsCombo = '[' + $3a9587500dbb7d28$var$rsComboRange + ']', $3a9587500dbb7d28$var$rsDigits = '\\d+', $3a9587500dbb7d28$var$rsDingbat = '[' + $3a9587500dbb7d28$var$rsDingbatRange + ']', $3a9587500dbb7d28$var$rsLower = '[' + $3a9587500dbb7d28$var$rsLowerRange + ']', $3a9587500dbb7d28$var$rsMisc = '[^' + $3a9587500dbb7d28$var$rsAstralRange + $3a9587500dbb7d28$var$rsBreakRange + $3a9587500dbb7d28$var$rsDigits + $3a9587500dbb7d28$var$rsDingbatRange + $3a9587500dbb7d28$var$rsLowerRange + $3a9587500dbb7d28$var$rsUpperRange + ']', $3a9587500dbb7d28$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $3a9587500dbb7d28$var$rsModifier = '(?:' + $3a9587500dbb7d28$var$rsCombo + '|' + $3a9587500dbb7d28$var$rsFitz + ')', $3a9587500dbb7d28$var$rsNonAstral = '[^' + $3a9587500dbb7d28$var$rsAstralRange + ']', $3a9587500dbb7d28$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $3a9587500dbb7d28$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $3a9587500dbb7d28$var$rsUpper = '[' + $3a9587500dbb7d28$var$rsUpperRange + ']', $3a9587500dbb7d28$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $3a9587500dbb7d28$var$rsMiscLower = '(?:' + $3a9587500dbb7d28$var$rsLower + '|' + $3a9587500dbb7d28$var$rsMisc + ')', $3a9587500dbb7d28$var$rsMiscUpper = '(?:' + $3a9587500dbb7d28$var$rsUpper + '|' + $3a9587500dbb7d28$var$rsMisc + ')', $3a9587500dbb7d28$var$rsOptContrLower = '(?:' + $3a9587500dbb7d28$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $3a9587500dbb7d28$var$rsOptContrUpper = '(?:' + $3a9587500dbb7d28$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $3a9587500dbb7d28$var$reOptMod = $3a9587500dbb7d28$var$rsModifier + '?', $3a9587500dbb7d28$var$rsOptVar = '[' + $3a9587500dbb7d28$var$rsVarRange + ']?', $3a9587500dbb7d28$var$rsOptJoin = '(?:' + $3a9587500dbb7d28$var$rsZWJ + '(?:' + [
    $3a9587500dbb7d28$var$rsNonAstral,
    $3a9587500dbb7d28$var$rsRegional,
    $3a9587500dbb7d28$var$rsSurrPair
].join('|') + ')' + $3a9587500dbb7d28$var$rsOptVar + $3a9587500dbb7d28$var$reOptMod + ')*', $3a9587500dbb7d28$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $3a9587500dbb7d28$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $3a9587500dbb7d28$var$rsSeq = $3a9587500dbb7d28$var$rsOptVar + $3a9587500dbb7d28$var$reOptMod + $3a9587500dbb7d28$var$rsOptJoin, $3a9587500dbb7d28$var$rsEmoji = '(?:' + [
    $3a9587500dbb7d28$var$rsDingbat,
    $3a9587500dbb7d28$var$rsRegional,
    $3a9587500dbb7d28$var$rsSurrPair
].join('|') + ')' + $3a9587500dbb7d28$var$rsSeq;
/** Used to match complex or compound words. */ var $3a9587500dbb7d28$var$reUnicodeWord = RegExp([
    $3a9587500dbb7d28$var$rsUpper + '?' + $3a9587500dbb7d28$var$rsLower + '+' + $3a9587500dbb7d28$var$rsOptContrLower + '(?=' + [
        $3a9587500dbb7d28$var$rsBreak,
        $3a9587500dbb7d28$var$rsUpper,
        '$'
    ].join('|') + ')',
    $3a9587500dbb7d28$var$rsMiscUpper + '+' + $3a9587500dbb7d28$var$rsOptContrUpper + '(?=' + [
        $3a9587500dbb7d28$var$rsBreak,
        $3a9587500dbb7d28$var$rsUpper + $3a9587500dbb7d28$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $3a9587500dbb7d28$var$rsUpper + '?' + $3a9587500dbb7d28$var$rsMiscLower + '+' + $3a9587500dbb7d28$var$rsOptContrLower,
    $3a9587500dbb7d28$var$rsUpper + '+' + $3a9587500dbb7d28$var$rsOptContrUpper,
    $3a9587500dbb7d28$var$rsOrdUpper,
    $3a9587500dbb7d28$var$rsOrdLower,
    $3a9587500dbb7d28$var$rsDigits,
    $3a9587500dbb7d28$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $3a9587500dbb7d28$var$unicodeWords(string) {
    return string.match($3a9587500dbb7d28$var$reUnicodeWord) || [];
}
module.exports = $3a9587500dbb7d28$var$unicodeWords;

});





parcelRegister("5XQsc", function(module, exports) {
$parcel$export(module.exports, "postResource", function () { return $457b26b1e243507d$export$2ff3e1f219ccfad6; });

var $f53LC = parcelRequire("f53LC");

var $cn8ql = parcelRequire("cn8ql");

var $5Cxn4 = parcelRequire("5Cxn4");
parcelRequire("gUHXN");
var $9Zkb8 = parcelRequire("9Zkb8");
var $gUHXN = parcelRequire("gUHXN");

var $gcB9L = parcelRequire("gcB9L");

var $6tfcl = parcelRequire("6tfcl");
function $457b26b1e243507d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $457b26b1e243507d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $457b26b1e243507d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $457b26b1e243507d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $457b26b1e243507d$var$fetchResource = /*#__PURE__*/ function() {
    var _ref = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(path, method) {
        var options, url, response, statusCode, text, httpError, _args = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
                    url = (0, $gcB9L.getFullUrl)(path);
                    _context.next = 4;
                    return fetch(url, $457b26b1e243507d$var$_objectSpread({
                        credentials: 'include',
                        method: method
                    }, options)).catch(function(error) {
                        throw new (0, $9Zkb8.default)({
                            error: error,
                            path: path,
                            method: method
                        });
                    });
                case 4:
                    response = _context.sent;
                    statusCode = response.status;
                    if (response.ok) {
                        _context.next = 15;
                        break;
                    }
                    statusCode;
                    _context.t0 = $457b26b1e243507d$var$scrubTimestampFromErrorBody;
                    _context.next = 11;
                    return response.text();
                case 11:
                    _context.t1 = _context.sent;
                    text = (0, _context.t0)(_context.t1);
                    httpError = new (0, $6tfcl.default)({
                        message: text,
                        method: method,
                        path: path,
                        statusCode: statusCode,
                        xRequestId: response.headers.get('x-request-id'),
                        headers: response.headers
                    });
                    throw httpError;
                case 15:
                    return _context.abrupt("return", response);
                case 16:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function fetchResource(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();
var $457b26b1e243507d$var$makeJsonRquest = /*#__PURE__*/ function() {
    var _ref2 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(path, method) {
        var additionalFetchOptions, response, text, _args2 = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    additionalFetchOptions = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
                    _context2.next = 3;
                    return $457b26b1e243507d$var$fetchResource(path, method, additionalFetchOptions);
                case 3:
                    response = _context2.sent;
                    _context2.next = 6;
                    return response.text();
                case 6:
                    text = _context2.sent;
                    return _context2.abrupt("return", text ? JSON.parse(text) : {});
                case 8:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function makeJsonRquest(_x3, _x4) {
        return _ref2.apply(this, arguments);
    };
}();
var $457b26b1e243507d$export$2ff3e1f219ccfad6 = /*#__PURE__*/ function() {
    var _ref3 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(path, data, retryMS, extraHeaders) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    return _context3.abrupt("return", (0, $gUHXN.retryOnException)(function() {
                        return $457b26b1e243507d$var$makeJsonRquest(path, 'POST', {
                            body: JSON.stringify(data),
                            headers: $457b26b1e243507d$var$_objectSpread({
                                'content-type': 'application/json'
                            }, extraHeaders)
                        });
                    }, {
                        intervalsMS: retryMS !== null && retryMS !== void 0 ? retryMS : []
                    }));
                case 1:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function postResource(_x5, _x6, _x7, _x8) {
        return _ref3.apply(this, arguments);
    };
}();
// to dedup sentry, scrub non-unique 'timestamp' field from the error body
function $457b26b1e243507d$var$scrubTimestampFromErrorBody(text) {
    var json;
    try {
        json = JSON.parse(text);
    } catch (err) {
        return text;
    }
    delete json.timestamp;
    return JSON.stringify(json);
}

});
parcelRegister("gUHXN", function(module, exports) {
$parcel$export(module.exports, "retryOnException", function () { return $c503fa8818b1581d$export$1d94629c94e7a17f; });
$parcel$export(module.exports, "FailedFetchError", function () { return (parcelRequire("9Zkb8")).default; });

var $lFOXD = parcelRequire("lFOXD");

var $cn8ql = parcelRequire("cn8ql");

var $5Cxn4 = parcelRequire("5Cxn4");

var $9WfMr = parcelRequire("9WfMr");

var $03Geo = parcelRequire("03Geo");

var $9Zkb8 = parcelRequire("9Zkb8");
var $c503fa8818b1581d$export$5c069c93d2b7493f = function wait(ms) {
    return new Promise(function(resolve) {
        setTimeout(resolve, ms);
    });
};
var $c503fa8818b1581d$var$NO_CALLS_ERROR = 'No calls made';
var $c503fa8818b1581d$export$1d94629c94e7a17f = /*#__PURE__*/ function() {
    var _ref2 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(invokeOperation, _ref) {
        var _ref$intervalsMS, intervalsMS, _ref$retryOn, retryOn, captureException, onRetry, intervals, nextMSInterval, error;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _ref$intervalsMS = _ref.intervalsMS, intervalsMS = _ref$intervalsMS === void 0 ? (0, $03Geo.NO_RETRIES) : _ref$intervalsMS, _ref$retryOn = _ref.retryOn, retryOn = _ref$retryOn === void 0 ? [
                        (0, $9Zkb8.default)
                    ] : _ref$retryOn, captureException = _ref.captureException, onRetry = _ref.onRetry;
                    intervals = (0, $lFOXD.default)(intervalsMS);
                    nextMSInterval = 0;
                    error = new Error($c503fa8818b1581d$var$NO_CALLS_ERROR);
                case 4:
                    if (!(nextMSInterval !== undefined)) {
                        _context.next = 22;
                        break;
                    }
                    _context.prev = 5;
                    if (!(nextMSInterval > 0)) {
                        _context.next = 9;
                        break;
                    }
                    _context.next = 9;
                    return $c503fa8818b1581d$export$5c069c93d2b7493f(nextMSInterval);
                case 9:
                    if (onRetry && error.message !== $c503fa8818b1581d$var$NO_CALLS_ERROR) onRetry(error);
                    _context.next = 12;
                    return invokeOperation();
                case 12:
                    return _context.abrupt("return", _context.sent);
                case 15:
                    _context.prev = 15;
                    _context.t0 = _context["catch"](5);
                    error = (0, $9WfMr.default)(_context.t0);
                    if (captureException) captureException(error);
                    // Retry ONLY when the error is an instance of one of the provided `retryOn` errors, or passes the `retryOn` test.
                    // You need to ensure you are throwing one of the `retryOn` errors if that is the method you are using.
                    if (typeof retryOn === 'function' ? retryOn(error) : retryOn.some(function(err) {
                        return error instanceof err;
                    })) nextMSInterval = intervals.shift();
                    else nextMSInterval = undefined;
                case 20:
                    _context.next = 4;
                    break;
                case 22:
                    throw error;
                case 23:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                5,
                15
            ]
        ]);
    }));
    return function retryOnException(_x, _x2) {
        return _ref2.apply(this, arguments);
    };
}();

});
parcelRegister("9WfMr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $73c5c579c2f24549$export$2e2bcd8739ae039; });

var $2zYm4 = parcelRequire("2zYm4");
var $73c5c579c2f24549$var$convertToError = function convertToError(e) {
    var error;
    if (e instanceof Error) error = e;
    else if (typeof e === 'string') error = new Error(e);
    else if ((0, $2zYm4.default)(e) === 'object') try {
        error = new Error('Object error instance thrown for operation: ' + JSON.stringify(e));
    } catch (jsonError) {
        error = new Error('Object serialisation error thrown during operation: ' + String(e));
    }
    else error = new Error('No error instance thrown for operation: ' + String(e));
    return error;
};
var $73c5c579c2f24549$export$2e2bcd8739ae039 = $73c5c579c2f24549$var$convertToError;

});

parcelRegister("03Geo", function(module, exports) {
$parcel$export(module.exports, "NO_RETRIES", function () { return $00b10a2bec117208$export$a0a1c8f90becc136; });
var $00b10a2bec117208$export$a0a1c8f90becc136 = [];
var $00b10a2bec117208$export$972171517b12aa4 = [
    0,
    0
];
var $00b10a2bec117208$export$746d2203ed8cdc40 = [
    0,
    50,
    100
];
var $00b10a2bec117208$export$f6858378b665f957 = [
    100,
    500,
    1000
];

});

parcelRegister("9Zkb8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7459769eef8fe667$export$2e2bcd8739ae039; });

var $avOEA = parcelRequire("avOEA");

var $cTewU = parcelRequire("cTewU");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $i7dvh = parcelRequire("i7dvh");

var $4GELH = parcelRequire("4GELH");
function $7459769eef8fe667$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $7459769eef8fe667$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $7459769eef8fe667$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7459769eef8fe667$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $7459769eef8fe667$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    function FailedFetchError(_ref) {
        var _this;
        var error = _ref.error, path = _ref.path, method = _ref.method;
        (0, $cTewU.default)(this, FailedFetchError);
        _this = $7459769eef8fe667$var$_callSuper(this, FailedFetchError);
        _this.name = 'FailedFetchError';
        _this.message = error.message || 'Unknown fetch error';
        _this.stack = error.stack;
        _this.originalName = error.name;
        _this.method = method;
        var p = path.split('?')[0];
        _this.path = /^[/-a-z]+$/i.test(p) ? p : '';
        return _this;
    }
    (0, $i7dvh.default)(FailedFetchError, _Error);
    return (0, $avOEA.default)(FailedFetchError);
}(/*#__PURE__*/ (0, $4GELH.default)(Error));

});


parcelRegister("gcB9L", function(module, exports) {
$parcel$export(module.exports, "getFullUrl", function () { return $bcba96d659f25196$export$2414511207262909; });
var $bcba96d659f25196$var$urlRegex = new RegExp(/^https?:\/\//);
function $bcba96d659f25196$export$2414511207262909(path) {
    var hostConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        host: window.location.hostname,
        port: window.location.port
    };
    // always return a just the URL if one is provided
    if ($bcba96d659f25196$var$urlRegex.test(path)) return path;
    return hostConfig.host === 'localhost' ? "http://".concat(hostConfig.host, ":").concat(hostConfig.port).concat(path) : path;
}

});


parcelRegister("2reKI", function(module, exports) {
$parcel$export(module.exports, "generateActivityQueryWithFilters", function () { return $1c698be7a7023701$export$855cd08371c65b8c; });

var $8UfbL = parcelRequire("8UfbL");

var $3MW3V = parcelRequire("3MW3V");
var $1c698be7a7023701$var$ACTIVITIES = "\n  nodes {\n    id\n    timestamp\n    object {\n      id\n      name\n      cloudId\n      localResourceId\n      product\n      type\n      url\n      iconUrl\n      containers {\n        name\n      }\n      contributors {\n        profile {\n          accountId\n          name\n          picture\n        }\n      }\n      events {\n        eventType\n      }\n      extension {\n        ... on ActivitiesJiraIssue {\n          issueKey\n        }\n      }\n    }\n  }\n";
var $1c698be7a7023701$var$WORKED_ON_QUERY = "\n   workedOn(first: $first, filters: $filters) {\n     ".concat($1c698be7a7023701$var$ACTIVITIES, "\n   }\n");
var $1c698be7a7023701$var$VIEWED__QUERY = "\n   viewed(first: $first, filters: $filters) {\n     ".concat($1c698be7a7023701$var$ACTIVITIES, "\n   }\n");
var $1c698be7a7023701$var$ALL__QUERY = "\n    all(first: $first, filters: $filters) {\n      ".concat($1c698be7a7023701$var$ACTIVITIES, "\n    }\n");
var $1c698be7a7023701$var$activityQueryMap = new Map([
    [
        'workedOn',
        $1c698be7a7023701$var$WORKED_ON_QUERY
    ],
    [
        'viewed',
        $1c698be7a7023701$var$VIEWED__QUERY
    ],
    [
        'all',
        $1c698be7a7023701$var$ALL__QUERY
    ]
]);
var $1c698be7a7023701$var$getMyActivitiesQuery = function getMyActivitiesQuery(queries) {
    return "\n      myActivities {\n        ".concat(queries.join('\n'), "\n      }\n");
};
var $1c698be7a7023701$var$getActivitiesQuery = function getActivitiesQuery(product, content) {
    return "\n    query ".concat((0, $8UfbL.getOperationName)(product), "($first: Int, $filters: [ActivitiesFilter!]) {\n      activities {\n        ").concat(content, "\n      }\n    }\n");
};
var $1c698be7a7023701$export$855cd08371c65b8c = function generateActivityQueryWithFilters(product, filters, activityQueries) {
    /**
   * If we are filtering by `accountIds` then we can't use the `myActivity` query.
   */ if (Array.isArray(filters.actors)) {
        // you can't view `viewed` events for other accounts
        var filteredAccountQueries = activityQueries.filter(function(query) {
            return query !== 'viewed';
        });
        return {
            query: $1c698be7a7023701$var$getActivitiesQuery(product, filteredAccountQueries.map(function(query) {
                return $1c698be7a7023701$var$activityQueryMap.get(query);
            }).join('\n')),
            queryFilters: (0, $3MW3V.ACTIVITY_FILTER_COLLECTION).v2.get('activities')(filters)
        };
    } else return {
        query: $1c698be7a7023701$var$getActivitiesQuery(product, $1c698be7a7023701$var$getMyActivitiesQuery(activityQueries.map(function(query) {
            return $1c698be7a7023701$var$activityQueryMap.get(query);
        }))),
        queryFilters: (0, $3MW3V.ACTIVITY_FILTER_COLLECTION).v2.get('myActivity')(filters)
    };
};

});
parcelRegister("3MW3V", function(module, exports) {
$parcel$export(module.exports, "ACTIVITY_FILTER_COLLECTION", function () { return $2c22e4c5ab4a7bf3$export$5201d39848130041; });

var $goASW = parcelRequire("goASW");

var $bF3YF = parcelRequire("bF3YF");
var $2c22e4c5ab4a7bf3$export$5201d39848130041 = {
    v2: (0, $goASW.ACTIVITY_FILTER_V2_MAP),
    v3: (0, $bF3YF.ACTIVITY_FILTER_V3_MAP)
};

});
parcelRegister("goASW", function(module, exports) {
$parcel$export(module.exports, "ACTIVITY_FILTER_V2_MAP", function () { return $befb7fdc5ea8453d$export$1dca7bc1ec360897; });

var $5JJwZ = parcelRequire("5JJwZ");

var $9ZSCC = parcelRequire("9ZSCC");
var $befb7fdc5ea8453d$export$1dca7bc1ec360897 = new Map([
    [
        'myActivity',
        (0, $9ZSCC.default)
    ],
    [
        'activities',
        (0, $5JJwZ.default)
    ]
]);

});
parcelRegister("5JJwZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $42d47942883c0d30$export$2e2bcd8739ae039; });

var $gnQ3X = parcelRequire("gnQ3X");

var $eqADc = parcelRequire("eqADc");
var $42d47942883c0d30$var$_excluded = [
    "limit"
];
/**
 * This is the query builder for the v2 - activities API
 *
 * @param filters
 */ var $42d47942883c0d30$var$generateV2ActivitiesFilters = function generateV2ActivitiesFilters() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var limit = filters.limit, restFilters = (0, $gnQ3X.default)(filters, $42d47942883c0d30$var$_excluded);
    return (0, $eqADc.generateActivityFiltersV2)(restFilters);
};
var $42d47942883c0d30$export$2e2bcd8739ae039 = $42d47942883c0d30$var$generateV2ActivitiesFilters;

});
parcelRegister("eqADc", function(module, exports) {
$parcel$export(module.exports, "generateActivityFiltersV2", function () { return $a80fe8968b7802f9$export$ebef9c1f1e15c057; });

var $f53LC = parcelRequire("f53LC");

var $aYF7h = parcelRequire("aYF7h");
// in V2 API the values for certain filters should be in UPPERCASE as are ENUMs in the GraphQL
// likewise for the V3 handler we should ensure we do appropriate lowercase conversion
var $a80fe8968b7802f9$var$FILTERS_TO_TRANSFORM__UPPERCASE = [
    'products',
    'eventTypes',
    'objectTypes'
];
var $a80fe8968b7802f9$var$KEYS_TO_TRANSFROM = new Map([
    [
        'actors',
        'accountIds'
    ]
]);
var $a80fe8968b7802f9$export$ebef9c1f1e15c057 = function generateActivityFiltersV2() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (0, $aYF7h.generateActivityFilters)(filters, function(originalkey, originalFilter) {
        var filter = Array.isArray(originalFilter) && $a80fe8968b7802f9$var$FILTERS_TO_TRANSFORM__UPPERCASE.includes(originalkey) ? originalFilter.map(function(f) {
            return f.toUpperCase();
        }) : originalFilter;
        var key = $a80fe8968b7802f9$var$KEYS_TO_TRANSFROM.has(originalkey) ? $a80fe8968b7802f9$var$KEYS_TO_TRANSFROM.get(originalkey) : originalkey;
        return (0, $f53LC.default)({}, key, filter);
    });
};

});
parcelRegister("aYF7h", function(module, exports) {
$parcel$export(module.exports, "generateActivityFilters", function () { return $7fdf66dcd3826252$export$23c75313f46dd54e; });

var $f53LC = parcelRequire("f53LC");

var $2qaZZ = parcelRequire("2qaZZ");
function $7fdf66dcd3826252$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7fdf66dcd3826252$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7fdf66dcd3826252$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7fdf66dcd3826252$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7fdf66dcd3826252$export$23c75313f46dd54e = function generateActivityFilters() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var transform = arguments.length > 1 ? arguments[1] : undefined;
    var rootLevelFilters = arguments.length > 2 ? arguments[2] : undefined;
    return Object.entries(filters).reduce(function(acc, _ref) {
        var _ref2 = (0, $2qaZZ.default)(_ref, 2), key = _ref2[0], filter = _ref2[1];
        var entry = transform ? transform(key, filter) : (0, $f53LC.default)({}, key, filter);
        return rootLevelFilters !== null && rootLevelFilters !== void 0 && rootLevelFilters.includes(key) ? $7fdf66dcd3826252$var$_objectSpread($7fdf66dcd3826252$var$_objectSpread({}, acc), entry) : $7fdf66dcd3826252$var$_objectSpread($7fdf66dcd3826252$var$_objectSpread({}, acc), {}, {
            arguments: $7fdf66dcd3826252$var$_objectSpread($7fdf66dcd3826252$var$_objectSpread({}, acc.arguments), entry)
        });
    }, {
        type: 'AND',
        arguments: {}
    });
};

});



parcelRegister("9ZSCC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $74742e543df2a0f8$export$2e2bcd8739ae039; });

var $gnQ3X = parcelRequire("gnQ3X");

var $eqADc = parcelRequire("eqADc");
var $74742e543df2a0f8$var$_excluded = [
    "limit",
    "actors"
];
/**
 * This is the query builder for the v2 - myActivity API
 *
 * @param filters
 */ var $74742e543df2a0f8$var$generateV2MyActivityFilters = function generateV2MyActivityFilters() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var limit = filters.limit, actors = filters.actors, restFilters = (0, $gnQ3X.default)(filters, $74742e543df2a0f8$var$_excluded);
    return (0, $eqADc.generateActivityFiltersV2)(restFilters);
};
var $74742e543df2a0f8$export$2e2bcd8739ae039 = $74742e543df2a0f8$var$generateV2MyActivityFilters;

});


parcelRegister("bF3YF", function(module, exports) {
$parcel$export(module.exports, "ACTIVITY_FILTER_V3_MAP", function () { return $87d69be94977d3ad$export$9a1782843b6e99d2; });

var $9yTBl = parcelRequire("9yTBl");

var $jDqtZ = parcelRequire("jDqtZ");
var $87d69be94977d3ad$export$9a1782843b6e99d2 = new Map([
    [
        'myActivity',
        (0, $jDqtZ.default)
    ],
    [
        'activities',
        (0, $9yTBl.default)
    ]
]);

});
parcelRegister("9yTBl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6f626b4c3f5558ac$export$2e2bcd8739ae039; });

var $gnQ3X = parcelRequire("gnQ3X");

var $5RIfX = parcelRequire("5RIfX");
var $6f626b4c3f5558ac$var$_excluded = [
    "limit"
];
/**
 * This is the query builder for the v3 - activities API
 *
 * @param filters
 */ var $6f626b4c3f5558ac$var$generateV3ActivityFilters = function generateV3ActivityFilters() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var limit = filters.limit, restFilters = (0, $gnQ3X.default)(filters, $6f626b4c3f5558ac$var$_excluded);
    return (0, $5RIfX.generateActivityFiltersV3)(restFilters);
};
var $6f626b4c3f5558ac$export$2e2bcd8739ae039 = $6f626b4c3f5558ac$var$generateV3ActivityFilters;

});
parcelRegister("5RIfX", function(module, exports) {
$parcel$export(module.exports, "generateActivityFiltersV3", function () { return $44543b60d5046812$export$e73fe7ded3fe2664; });

var $f53LC = parcelRequire("f53LC");

var $aYF7h = parcelRequire("aYF7h");
// in V2 API the values for certain filters should be in UPPERCASE as are ENUMs in the GraphQL
// likewise for the V3 handler we should ensure we do appropriate lowercase conversion
var $44543b60d5046812$var$FILTERS_TO_TRANSFORM__LOWERCASE = [
    'products',
    'eventTypes',
    'objectTypes'
];
var $44543b60d5046812$var$ROOT_LEVEL_FILTERS = [
    'actors',
    'rootContainerIds'
];
var $44543b60d5046812$export$e73fe7ded3fe2664 = function generateActivityFiltersV3() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (0, $aYF7h.generateActivityFilters)(filters, function(key, filter) {
        return Array.isArray(filter) && $44543b60d5046812$var$FILTERS_TO_TRANSFORM__LOWERCASE.includes(key) ? (0, $f53LC.default)({}, key, filter.map(function(f) {
            return f.toLowerCase();
        })) : (0, $f53LC.default)({}, key, filter);
    }, $44543b60d5046812$var$ROOT_LEVEL_FILTERS);
};

});


parcelRegister("jDqtZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e4b633bb10ef7390$export$2e2bcd8739ae039; });

var $gnQ3X = parcelRequire("gnQ3X");

var $5RIfX = parcelRequire("5RIfX");
var $e4b633bb10ef7390$var$_excluded = [
    "limit",
    "actors"
];
/**
 * This is the query builder for the v3 - myActivity API
 *
 * @param filters
 */ var $e4b633bb10ef7390$var$generateV3MyActivityFilters = function generateV3MyActivityFilters() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var limit = filters.limit, actors = filters.actors, restFilters = (0, $gnQ3X.default)(filters, $e4b633bb10ef7390$var$_excluded);
    return (0, $5RIfX.generateActivityFiltersV3)(restFilters);
};
var $e4b633bb10ef7390$export$2e2bcd8739ae039 = $e4b633bb10ef7390$var$generateV3MyActivityFilters;

});




parcelRegister("el6fl", function(module, exports) {
$parcel$export(module.exports, "transformActivitiesItems", function () { return $a707df465a5701f5$export$306a8b649360ca6f; });
var $a707df465a5701f5$var$SITE_ARI_PREFIX = 'ari:cloud:platform::site/';
function $a707df465a5701f5$export$306a8b649360ca6f(query) {
    var activities = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!activities || !activities.nodes) return [];
    return activities.nodes.map(function(item) {
        var object = item.object, timestamp = item.timestamp;
        var cloudId = object.cloudId, events = object.events, extension = object.extension, iconUrl = object.iconUrl, id = object.id, localResourceId = object.localResourceId, name = object.name, product = object.product, url = object.url, type = object.type;
        // V2 returns eventType captilised, V3 returns lowercase
        var eventType = events[0].eventType.toLowerCase();
        var issueKey = extension && extension.issueKey;
        var containers = [];
        if (issueKey) containers.push({
            name: issueKey
        });
        if (Array.isArray(object.containers)) containers = containers.concat(object.containers);
        containers = containers.filter(function(container) {
            return !!container.name;
        });
        return {
            query: query,
            containers: containers,
            contributors: (object.contributors || []).reduce(function(contributors, contributor) {
                if (contributor.profile) {
                    var _contributor$profile = contributor.profile, accountId = _contributor$profile.accountId, picture = _contributor$profile.picture;
                    contributors.push({
                        accountId: accountId,
                        name: contributor.profile.name,
                        picture: picture
                    });
                }
                return contributors;
            }, []),
            eventType: eventType,
            object: {
                rootContainerIdentifier: {
                    id: cloudId,
                    type: 'SITE',
                    ari: "".concat($a707df465a5701f5$var$SITE_ARI_PREFIX).concat(cloudId)
                },
                deduplicateId: id,
                icon: {
                    type: 'URL',
                    value: iconUrl
                },
                id: id,
                localResourceId: localResourceId,
                name: name,
                product: product,
                subProduct: null,
                type: type,
                url: url
            },
            timestamp: timestamp
        };
    });
}

});



parcelRegister("4zPwD", function(module, exports) {
$parcel$export(module.exports, "ActivityClientV3", function () { return $35526630329575d9$export$3c3c237c92ca1fb9; });

var $cn8ql = parcelRequire("cn8ql");

var $avOEA = parcelRequire("avOEA");

var $cTewU = parcelRequire("cTewU");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $i7dvh = parcelRequire("i7dvh");

var $f53LC = parcelRequire("f53LC");

var $5Cxn4 = parcelRequire("5Cxn4");

var $gUHXN = parcelRequire("gUHXN");

var $fOIzk = parcelRequire("fOIzk");

var $bmweo = parcelRequire("bmweo");

var $f4XZt = parcelRequire("f4XZt");

var $5XQsc = parcelRequire("5XQsc");

var $9Cd3n = parcelRequire("9Cd3n");

var $8c5iM = parcelRequire("8c5iM");

var $3MjIr = parcelRequire("3MjIr");

var $cOEz4 = parcelRequire("cOEz4");

var $lrhDf = parcelRequire("lrhDf");

var $kttmz = parcelRequire("kttmz");

var $hqgpR = parcelRequire("hqgpR");

var $cCmIC = parcelRequire("cCmIC");

var $gz827 = parcelRequire("gz827");

var $c53UJ = parcelRequire("c53UJ");
function $35526630329575d9$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $35526630329575d9$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $35526630329575d9$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $35526630329575d9$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $35526630329575d9$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $35526630329575d9$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $35526630329575d9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $35526630329575d9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $35526630329575d9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $35526630329575d9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $35526630329575d9$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $35526630329575d9$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $35526630329575d9$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($35526630329575d9$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $35526630329575d9$var$CONFLUENCE_COMMENT_TYPENAMES = [
    'ConfluenceComment',
    'ConfluenceFooterComment',
    'ConfluenceInlineComment'
];
var $35526630329575d9$var$IGNORED_HTTP_ERRORS = new Map([
    // ignore all 401 errors
    [
        401,
        [
            /.*/
        ]
    ],
    [
        403,
        [
            /Invalid CORS request/
        ]
    ]
]);
var $35526630329575d9$var$IGNORED_ERROR_MESSAGES = [
    'The operation was aborted.'
];
var $35526630329575d9$var$DEFAULT_TAGS = {
    source: (0, $bmweo.packageName),
    sourcePackageVersion: (0, $bmweo.packageVersion)
};
var $35526630329575d9$export$3c3c237c92ca1fb9 = /*#__PURE__*/ function(_ActivityClient) {
    function ActivityClientV3(_product, baseUrl, logger, configFetch) {
        var _this;
        (0, $cTewU.default)(this, ActivityClientV3);
        _this = $35526630329575d9$var$_callSuper(this, ActivityClientV3, [
            'v3',
            _product,
            {
                'X-ExperimentalApi': 'ActivityV3Api'
            },
            baseUrl
        ]);
        (0, $f53LC.default)(_this, "setProduct", function(product) {
            _this.product = product;
        });
        (0, $f53LC.default)(_this, "captureException", function(error, tags) {
            if (_this.clientHandlers) _this.clientHandlers.captureException(error, $35526630329575d9$var$_objectSpread($35526630329575d9$var$_objectSpread({}, $35526630329575d9$var$DEFAULT_TAGS), tags));
        });
        (0, $f53LC.default)(_this, "captureWarning", function(message, tags) {
            if (_this.clientHandlers) _this.clientHandlers.captureWarning(message, $35526630329575d9$var$_objectSpread($35526630329575d9$var$_objectSpread({}, $35526630329575d9$var$DEFAULT_TAGS), tags));
        });
        (0, $f53LC.default)(_this, "fetchHydratorConfig", /*#__PURE__*/ (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _context.next = 2;
                        return _this.hydratorConfigClient.fetchConfig();
                    case 2:
                        return _context.abrupt("return", _context.sent);
                    case 3:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        })));
        (0, $f53LC.default)(_this, "handleGraphQLErrors", function(errors) {
            var invalidFragments = [];
            if (Array.isArray(errors)) {
                var _iterator = $35526630329575d9$var$_createForOfIteratorHelper(errors), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var err = _step.value;
                        _this.captureException(new (0, $8c5iM.GraphQLJSError)(err));
                        var invalidFragment = (0, $cCmIC.default)(err);
                        if (invalidFragment) invalidFragments.push(invalidFragment);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return invalidFragments;
            }
            return [];
        });
        (0, $f53LC.default)(_this, "fetchActivitiesV3", /*#__PURE__*/ function() {
            var _ref2 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(experience, retryMS, filters, activityQueries) {
                var _response$data, _activityRoot, _response$data$activi, _activityRoot2;
                var deduplicateActivities, _yield$_this$fetchHyd, fragments, hydrators, response, _IGNORED_HTTP_ERRORS$, workedOn, viewed, all, activities, _args3 = arguments;
                return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee3$(_context3) {
                    while(true)switch(_context3.prev = _context3.next){
                        case 0:
                            deduplicateActivities = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : true;
                            _context3.next = 3;
                            return _this.fetchHydratorConfig();
                        case 3:
                            _yield$_this$fetchHyd = _context3.sent;
                            fragments = _yield$_this$fetchHyd.fragments;
                            hydrators = _yield$_this$fetchHyd.hydrators;
                            experience.mark('GeneratedQueryWithFilters_start');
                            _context3.prev = 7;
                            _context3.next = 10;
                            return (0, $gUHXN.retryOnException)(/*#__PURE__*/ (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2() {
                                var request, res, invalidFragments;
                                return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
                                    while(true)switch(_context2.prev = _context2.next){
                                        case 0:
                                            request = (0, $gz827.generateGraphQLRequest)(_this.product, filters, activityQueries, fragments);
                                            experience.mark('GeneratedQueryWithFilters_end');
                                            experience.mark('FetchedActivities_start');
                                            experience.addMetadata({
                                                filters: (0, $c53UJ.filtersToMetadata)(filters)
                                            });
                                            _context2.next = 6;
                                            return (0, $5XQsc.postResource)(_this.baseUrl, request, retryMS, $35526630329575d9$var$_objectSpread({}, _this.headers));
                                        case 6:
                                            res = _context2.sent;
                                            experience.mark('FetchedActivities_end');
                                            invalidFragments = _this.handleGraphQLErrors(res === null || res === void 0 ? void 0 : res.errors);
                                            if (!(invalidFragments.length > 0)) {
                                                _context2.next = 12;
                                                break;
                                            }
                                            fragments = (0, $c53UJ.filterInvalidFragments)(invalidFragments, fragments);
                                            throw new (0, $9Cd3n.GraphQLFragmentError)("Missing fragments: [".concat(invalidFragments.toString(), "]"));
                                        case 12:
                                            return _context2.abrupt("return", res);
                                        case 13:
                                        case "end":
                                            return _context2.stop();
                                    }
                                }, _callee2);
                            })), {
                                intervalsMS: [
                                    0,
                                    0,
                                    0
                                ],
                                retryOn: function retryOn(err) {
                                    return [
                                        (0, $9Cd3n.GraphQLFragmentError)
                                    ].some(function(retriableErr) {
                                        return err instanceof retriableErr;
                                    });
                                },
                                captureException: _this.captureException
                            });
                        case 10:
                            response = _context3.sent;
                            _context3.next = 17;
                            break;
                        case 13:
                            _context3.prev = 13;
                            _context3.t0 = _context3["catch"](7);
                            if (!(!_context3.t0 || !((_IGNORED_HTTP_ERRORS$ = $35526630329575d9$var$IGNORED_HTTP_ERRORS.get(_context3.t0.statusCode)) !== null && _IGNORED_HTTP_ERRORS$ !== void 0 && _IGNORED_HTTP_ERRORS$.some(function(regExp) {
                                return regExp.test(_context3.t0.message);
                            })) && !$35526630329575d9$var$IGNORED_ERROR_MESSAGES.includes(_context3.t0.message))) {
                                _context3.next = 17;
                                break;
                            }
                            throw _context3.t0;
                        case 17:
                            if (!(0, $c53UJ.isEmptyActivitiesWithErrorsResponse)(response)) {
                                _context3.next = 19;
                                break;
                            }
                            throw new (0, $3MjIr.GraphQLNoResultsError)(response.errors);
                        case 19:
                            if (!(!response || !((_response$data = response.data) !== null && _response$data !== void 0 && _response$data.activity))) {
                                _context3.next = 21;
                                break;
                            }
                            return _context3.abrupt("return", {
                                workedOn: [],
                                viewed: [],
                                all: []
                            });
                        case 21:
                            experience.mark('TransformedActivityItems_start');
                            workedOn = $35526630329575d9$var$transformActivityItem('workedOn', ((_activityRoot = (0, $c53UJ.activityRoot)(response.data.activity)) === null || _activityRoot === void 0 || (_activityRoot = _activityRoot.workedOn) === null || _activityRoot === void 0 ? void 0 : _activityRoot.edges) || [], hydrators, _this.captureException); // We don't need the activity root function here as viewed only exists on myActivity
                            viewed = $35526630329575d9$var$transformActivityItem('viewed', ((_response$data$activi = response.data.activity) === null || _response$data$activi === void 0 || (_response$data$activi = _response$data$activi.myActivity) === null || _response$data$activi === void 0 || (_response$data$activi = _response$data$activi.viewed) === null || _response$data$activi === void 0 ? void 0 : _response$data$activi.edges) || [], hydrators, _this.captureException);
                            all = $35526630329575d9$var$transformActivityItem('all', ((_activityRoot2 = (0, $c53UJ.activityRoot)(response.data.activity)) === null || _activityRoot2 === void 0 || (_activityRoot2 = _activityRoot2.all) === null || _activityRoot2 === void 0 ? void 0 : _activityRoot2.edges) || [], hydrators, _this.captureException);
                            experience.mark('TransformedActivityItems_end');
                            activities = {
                                viewed: viewed,
                                workedOn: workedOn,
                                all: all
                            };
                            return _context3.abrupt("return", deduplicateActivities ? (0, $c53UJ.rollupActivitiesData)(activities) : activities);
                        case 28:
                        case "end":
                            return _context3.stop();
                    }
                }, _callee3, null, [
                    [
                        7,
                        13
                    ]
                ]);
            }));
            return function(_x, _x2, _x3, _x4) {
                return _ref2.apply(this, arguments);
            };
        }());
        (0, $f53LC.default)(_this, "fetchActivities", /*#__PURE__*/ function() {
            var _ref4 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee4(retryMS, filters, activityQueries) {
                var deduplicateActivities, _args4 = arguments;
                return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee4$(_context4) {
                    while(true)switch(_context4.prev = _context4.next){
                        case 0:
                            deduplicateActivities = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : true;
                            return _context4.abrupt("return", (0, $f4XZt.fetchActivitiesWithExperience)(function(experience) {
                                return _this.fetchActivitiesV3(experience, retryMS, filters, activityQueries, deduplicateActivities);
                            }, 'v3'));
                        case 2:
                        case "end":
                            return _context4.stop();
                    }
                }, _callee4);
            }));
            return function(_x5, _x6, _x7) {
                return _ref4.apply(this, arguments);
            };
        }());
        _this.clientHandlers = logger;
        _this.hydratorConfigClient = new (0, $kttmz.default)({
            captureException: _this.captureException,
            captureWarning: _this.captureWarning
        }, _product, configFetch);
        return _this;
    }
    (0, $i7dvh.default)(ActivityClientV3, _ActivityClient);
    return (0, $avOEA.default)(ActivityClientV3);
}((0, $hqgpR.ActivityClient));
function $35526630329575d9$var$transformActivityItem(query, activities, hydrators, captureException) {
    return activities.reduce(function(acc, item) {
        if (item && item.node && item.node.object && item.node.event) {
            var _item$node = item.node, object = _item$node.object, event = _item$node.event;
            if (!object.product || !object.type) return acc;
            var containers = [];
            var c = object.contributors || [];
            var contributors = c.reduce(function(contributors, contributor) {
                if (contributor.profile) {
                    var _contributor$profile = contributor.profile, accountId = _contributor$profile.accountId, picture = _contributor$profile.picture;
                    contributors.push({
                        accountId: accountId,
                        name: contributor.profile.name,
                        picture: picture
                    });
                }
                return contributors;
            }, []);
            var hydratedData = (0, $cOEz4.hydratePolymorphicData)(hydrators, object.data, captureException);
            if (hydratedData) {
                var _object$data;
                if (hydratedData.key) containers.push({
                    name: (0, $lrhDf.hydratedValueToString)(hydratedData.key, ' ')
                });
                if (hydratedData.containers) containers.push({
                    name: (0, $lrhDf.hydratedValueToString)(hydratedData.containers, ' ')
                });
                var actor = event.actor ? {
                    name: event.actor.name,
                    picture: event.actor.picture,
                    accountId: event.actor.accountId
                } : undefined;
                // The V3 API returns "Created" for a new comment, we want this to display as "Commented"
                var eventType = object.type === 'comment' && event.eventType === (0, $fOIzk.WORKED_EVENT).CREATED ? (0, $fOIzk.WORKED_EVENT).COMMENTED : event.eventType;
                acc.push({
                    actor: actor,
                    query: query,
                    containers: containers,
                    contributors: contributors,
                    eventType: eventType,
                    object: {
                        rootContainerIdentifier: (0, $c53UJ.parseRootContainerARI)(object.rootContainerId),
                        icon: $35526630329575d9$var$CONFLUENCE_COMMENT_TYPENAMES.includes(object.data.__typename) ? (0, $lrhDf.hydrateConfluenceIcon)((_object$data = object.data) === null || _object$data === void 0 || (_object$data = _object$data.container) === null || _object$data === void 0 ? void 0 : _object$data.__typename, hydratedData.icon, hydratedData.staticFallbacks) : (0, $lrhDf.hydrateIcon)(hydratedData.icon, hydratedData.staticFallbacks),
                        id: object.id,
                        deduplicateId: (0, $lrhDf.hydratedValueToString)(hydratedData.deduplicateId) || object.id,
                        localResourceId: (0, $lrhDf.hydratedValueToString)(hydratedData.localResourceId),
                        name: (0, $lrhDf.hydratedValueToString)(hydratedData.name, ' '),
                        product: object.product,
                        subProduct: object.subProduct,
                        type: object.type,
                        url: (0, $lrhDf.hydratedValueToString)(hydratedData.url),
                        objectTypeName: (0, $lrhDf.hydratedValueToString)(hydratedData.objectTypeName)
                    },
                    timestamp: event.timestamp
                });
            }
        }
        return acc;
    }, []);
}

});
parcelRegister("9Cd3n", function(module, exports) {
$parcel$export(module.exports, "GraphQLFragmentError", function () { return $7001c9cbc41d3f0e$export$2d1b192199788179; });

var $avOEA = parcelRequire("avOEA");

var $cTewU = parcelRequire("cTewU");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $i7dvh = parcelRequire("i7dvh");

var $4GELH = parcelRequire("4GELH");
function $7001c9cbc41d3f0e$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $7001c9cbc41d3f0e$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $7001c9cbc41d3f0e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7001c9cbc41d3f0e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $7001c9cbc41d3f0e$export$2d1b192199788179 = /*#__PURE__*/ function(_Error) {
    function GraphQLFragmentError(message) {
        var _this;
        (0, $cTewU.default)(this, GraphQLFragmentError);
        _this = $7001c9cbc41d3f0e$var$_callSuper(this, GraphQLFragmentError, [
            message
        ]);
        _this.name = 'GraphQLFragmentError';
        _this.message = message;
        return _this;
    }
    (0, $i7dvh.default)(GraphQLFragmentError, _Error);
    return (0, $avOEA.default)(GraphQLFragmentError);
}(/*#__PURE__*/ (0, $4GELH.default)(Error));

});

parcelRegister("8c5iM", function(module, exports) {
$parcel$export(module.exports, "GraphQLJSError", function () { return $5f738e96752f4ba1$export$8d4af49ee2a0fbe2; });

var $avOEA = parcelRequire("avOEA");

var $cTewU = parcelRequire("cTewU");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $i7dvh = parcelRequire("i7dvh");

var $4GELH = parcelRequire("4GELH");
function $5f738e96752f4ba1$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $5f738e96752f4ba1$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $5f738e96752f4ba1$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5f738e96752f4ba1$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $5f738e96752f4ba1$export$8d4af49ee2a0fbe2 = /*#__PURE__*/ function(_Error) {
    function GraphQLJSError(graphQLError) {
        var _this;
        (0, $cTewU.default)(this, GraphQLJSError);
        _this = $5f738e96752f4ba1$var$_callSuper(this, GraphQLJSError, [
            graphQLError.message
        ]);
        _this.name = 'GraphQLJSError';
        _this.error = graphQLError;
        _this.message = graphQLError.message;
        return _this;
    }
    (0, $i7dvh.default)(GraphQLJSError, _Error);
    return (0, $avOEA.default)(GraphQLJSError);
}(/*#__PURE__*/ (0, $4GELH.default)(Error));

});

parcelRegister("3MjIr", function(module, exports) {
$parcel$export(module.exports, "GraphQLNoResultsError", function () { return $2c0525eaf00c408b$export$3f19ff30d409b70; });

var $avOEA = parcelRequire("avOEA");

var $cTewU = parcelRequire("cTewU");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $i7dvh = parcelRequire("i7dvh");

var $4GELH = parcelRequire("4GELH");
function $2c0525eaf00c408b$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $2c0525eaf00c408b$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $2c0525eaf00c408b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($2c0525eaf00c408b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $2c0525eaf00c408b$export$3f19ff30d409b70 = /*#__PURE__*/ function(_Error) {
    function GraphQLNoResultsError(graphQLErrors) {
        var _this;
        (0, $cTewU.default)(this, GraphQLNoResultsError);
        _this = $2c0525eaf00c408b$var$_callSuper(this, GraphQLNoResultsError);
        _this.name = 'GraphQLNoResultsError';
        _this.errors = graphQLErrors;
        _this.message = 'GraphQL returned errors & no results';
        _this.errorMessages = graphQLErrors.map(function(error) {
            return error.message;
        });
        return _this;
    }
    (0, $i7dvh.default)(GraphQLNoResultsError, _Error);
    return (0, $avOEA.default)(GraphQLNoResultsError);
}(/*#__PURE__*/ (0, $4GELH.default)(Error));

});

parcelRegister("cOEz4", function(module, exports) {
$parcel$export(module.exports, "hydratePolymorphicData", function () { return $95499edad6196007$export$d658049bf1a63492; });

var $f53LC = parcelRequire("f53LC");

var $2qaZZ = parcelRequire("2qaZZ");

var $4EAwS = parcelRequire("4EAwS");

var $3904H = parcelRequire("3904H");
function $95499edad6196007$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $95499edad6196007$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $95499edad6196007$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $95499edad6196007$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $95499edad6196007$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $95499edad6196007$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $95499edad6196007$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $95499edad6196007$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $95499edad6196007$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $95499edad6196007$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $95499edad6196007$export$d658049bf1a63492 = function hydratePolymorphicData(hydrators, data, captureException) {
    if (data) {
        if ('__typename' in data) {
            var hydrator = hydrators[data.__typename];
            if (hydrator) try {
                return $95499edad6196007$var$hydrateData(data, hydrator);
            } catch (error) {
                captureException && captureException(new (0, $3904H.default)({
                    error: error,
                    message: "Hydrator failed for [".concat(data.__typename, "].")
                }));
            }
            else captureException && captureException(new (0, $3904H.default)({
                message: "Missing hydrator for [".concat(data.__typename, "].")
            }));
        } else captureException && captureException(new (0, $3904H.default)({
            message: "Missing [__typename] field from data."
        }));
    }
    return null;
};
function $95499edad6196007$var$getOrSearch(object, path) {
    if (!object) return object;
    if (path.includes(':')) {
        var _path$split = path.split(':'), _path$split2 = (0, $2qaZZ.default)(_path$split, 2), searchField = _path$split2[0], searchValue = _path$split2[1];
        return $95499edad6196007$var$findNodeByField(object, searchField.trim(), searchValue.trim().replace(/"/g, '') // Strip any preceding whitesepace and quotes
        );
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($4EAwS)))(object, path);
}
function $95499edad6196007$var$resolvePath(object, path) {
    // Split the path on each bracket
    var splitPath = path.split(/\(|\)./);
    // Traverse the split path as a tree, resolving as we go
    var current = object;
    var _iterator = $95499edad6196007$var$_createForOfIteratorHelper(splitPath), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var split = _step.value;
            current = $95499edad6196007$var$getOrSearch(current, split);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return current;
}
function $95499edad6196007$var$findNodeByField(edges, fieldId, searchValue) {
    return edges.find(function(edge) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($4EAwS)))(edge, fieldId) === searchValue;
    });
}
function $95499edad6196007$export$a5c4301012ad6f07(object, paths) {
    return paths.map(function(path) {
        return $95499edad6196007$var$resolvePath(object, path);
    });
}
var $95499edad6196007$var$hydrateData = function hydrateData(data, hydrator) {
    var hydratorPaths = hydrator.hydratorPaths, staticFallbacks = hydrator.staticFallbacks;
    return $95499edad6196007$var$_objectSpread({
        staticFallbacks: staticFallbacks
    }, Object.entries(hydratorPaths).reduce(function(acc, _ref) {
        var _ref2 = (0, $2qaZZ.default)(_ref, 2), key = _ref2[0], dataValue = _ref2[1];
        var item = $95499edad6196007$export$a5c4301012ad6f07(data, dataValue);
        if (item) acc[key] = item;
        else throw new Error("Bad hydrator path: ".concat(key));
        return acc;
    }, {}));
};

});
parcelRegister("4EAwS", function(module, exports) {

var $5oMeU = parcelRequire("5oMeU");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $36373bd43f9f4b21$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $5oMeU(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $36373bd43f9f4b21$var$get;

});
parcelRegister("5oMeU", function(module, exports) {

var $hLLeA = parcelRequire("hLLeA");

var $119FI = parcelRequire("119FI");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $3ee49cf968a053d8$var$baseGet(object, path) {
    path = $hLLeA(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$119FI(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $3ee49cf968a053d8$var$baseGet;

});


parcelRegister("3904H", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $24a2453857014c20$export$2e2bcd8739ae039; });

var $avOEA = parcelRequire("avOEA");

var $cTewU = parcelRequire("cTewU");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $i7dvh = parcelRequire("i7dvh");

var $4GELH = parcelRequire("4GELH");
function $24a2453857014c20$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $24a2453857014c20$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $24a2453857014c20$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($24a2453857014c20$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $24a2453857014c20$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    function HydratorError(_ref) {
        var _this;
        var error = _ref.error, message = _ref.message;
        (0, $cTewU.default)(this, HydratorError);
        _this = $24a2453857014c20$var$_callSuper(this, HydratorError);
        var err = error instanceof Error ? error : new Error();
        _this.name = 'HydratorError';
        _this.message = message;
        _this.originalMessage = err.message;
        _this.stack = err.stack;
        _this.originalName = err.name;
        return _this;
    }
    (0, $i7dvh.default)(HydratorError, _Error);
    return (0, $avOEA.default)(HydratorError);
}(/*#__PURE__*/ (0, $4GELH.default)(Error));

});


parcelRegister("lrhDf", function(module, exports) {
$parcel$export(module.exports, "hydratedValueToString", function () { return $f9b9cbf2c3d54fd8$export$c5cea44a1f75b431; });
$parcel$export(module.exports, "hydrateConfluenceIcon", function () { return $f9b9cbf2c3d54fd8$export$86b9f44277b105a6; });
$parcel$export(module.exports, "hydrateIcon", function () { return $f9b9cbf2c3d54fd8$export$a328b2bb0d21d984; });

var $2zYm4 = parcelRequire("2zYm4");
var $f9b9cbf2c3d54fd8$export$c5cea44a1f75b431 = function hydratedValueToString(value) {
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    if (!value) return null;
    return Array.isArray(value) ? value.join(separator) : value;
};
function $f9b9cbf2c3d54fd8$var$isURL(icon) {
    return typeof icon === 'string';
}
function $f9b9cbf2c3d54fd8$var$isValidEmoji(icon) {
    return (0, $2zYm4.default)(icon) === 'object' && icon.value !== undefined && !!icon.value;
}
var $f9b9cbf2c3d54fd8$export$86b9f44277b105a6 = function hydrateConfluenceIcon(confluenceContainerType, icons, fallbacks) {
    switch(confluenceContainerType){
        case 'ConfluenceBlogPost':
            return $f9b9cbf2c3d54fd8$export$a328b2bb0d21d984(icons, fallbacks, 'confluenceBlogIcon') || $f9b9cbf2c3d54fd8$export$a328b2bb0d21d984(icons, fallbacks);
        case 'ConfluencePage':
            return $f9b9cbf2c3d54fd8$export$a328b2bb0d21d984(icons, fallbacks, 'confluencePageIcon') || $f9b9cbf2c3d54fd8$export$a328b2bb0d21d984(icons, fallbacks);
        default:
            return $f9b9cbf2c3d54fd8$export$a328b2bb0d21d984(icons, fallbacks);
    }
};
var $f9b9cbf2c3d54fd8$export$a328b2bb0d21d984 = function hydrateIcon(icons, fallbacks) {
    var fallbackKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'icon';
    if (Array.isArray(icons) && icons.length > 0) {
        var emojiIcons = icons.filter($f9b9cbf2c3d54fd8$var$isValidEmoji);
        if (emojiIcons.length > 0) return {
            type: 'EMOJI',
            value: emojiIcons[0].value,
            // return the first emoji
            fallback: fallbacks === null || fallbacks === void 0 ? void 0 : fallbacks[fallbackKey]
        };
        var urlIcons = icons.filter($f9b9cbf2c3d54fd8$var$isURL);
        if (urlIcons.length > 0) {
            var hydratedIcons = $f9b9cbf2c3d54fd8$export$c5cea44a1f75b431(urlIcons);
            if (hydratedIcons !== null) return {
                type: 'URL',
                value: hydratedIcons
            };
        }
    }
    if (fallbacks && fallbackKey in fallbacks && fallbacks[fallbackKey]) return {
        type: 'URL',
        value: fallbacks[fallbackKey]
    };
    return null;
};

});

parcelRegister("cCmIC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $92faa813afa41d46$export$2e2bcd8739ae039; });

var $ettkr = parcelRequire("ettkr");
var $92faa813afa41d46$var$errorHandlerMap = new Map([
    [
        'ValidationError',
        (0, $ettkr.default)
    ]
]);
var $92faa813afa41d46$var$graphQLErrorHandler = function graphQLErrorHandler(err) {
    var errorHandler = $92faa813afa41d46$var$errorHandlerMap.get(err.extensions.classification);
    if (typeof errorHandler === 'function') return errorHandler(err);
    return null;
};
var $92faa813afa41d46$export$2e2bcd8739ae039 = $92faa813afa41d46$var$graphQLErrorHandler;

});
parcelRegister("ettkr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a89a862b9fff41c6$export$2e2bcd8739ae039; });
/**
 * ^Validation error - look for validation errors from the start
 * .*?@ ' - look through everything up to the first instance of "@ '"
 * (\w+) - capture the first word, that's our invalid fragment
 */ var $a89a862b9fff41c6$var$captureRegex = new RegExp(/^Validation error.*?@ '(\w+)/);
var $a89a862b9fff41c6$var$validationErrorHandler = function validationErrorHandler(graphQLError) {
    var invalidFragmentMatch = $a89a862b9fff41c6$var$captureRegex.exec(graphQLError.message);
    if (Array.isArray(invalidFragmentMatch)) {
        var invalidFragment = invalidFragmentMatch[1];
        if (invalidFragment) return invalidFragment;
    }
    return null;
};
var $a89a862b9fff41c6$export$2e2bcd8739ae039 = $a89a862b9fff41c6$var$validationErrorHandler;

});


parcelRegister("gz827", function(module, exports) {
$parcel$export(module.exports, "generateGraphQLRequest", function () { return $c0f625712eba3002$export$7489a6ef09862e48; });

var $gnQ3X = parcelRequire("gnQ3X");

var $8UfbL = parcelRequire("8UfbL");

var $3MW3V = parcelRequire("3MW3V");
var $c0f625712eba3002$var$_excluded = [
    "limit"
];
var $c0f625712eba3002$var$ACTIVITIES_LIMIT = 50;
var $c0f625712eba3002$var$WORKED_ON_QUERY = "\n   workedOn(first: $first, filter: $filter) {\n     ...activityItemConnection\n   }\n";
var $c0f625712eba3002$var$VIEWED__QUERY = "\n   viewed(first: $first, filter: $filter) {\n     ...activityItemConnection\n   }\n";
var $c0f625712eba3002$var$ALL__QUERY = "\n    all(first: $first, filter: $filter) {\n      ...activityItemConnection\n    }\n";
var $c0f625712eba3002$var$activityQueryMap = new Map([
    [
        'workedOn',
        $c0f625712eba3002$var$WORKED_ON_QUERY
    ],
    [
        'viewed',
        $c0f625712eba3002$var$VIEWED__QUERY
    ],
    [
        'all',
        $c0f625712eba3002$var$ALL__QUERY
    ]
]);
var $c0f625712eba3002$var$getMyActivitiesQuery = function getMyActivitiesQuery(queries) {
    return "\n      myActivity {\n        ".concat(queries.join('\n'), "\n      }\n");
};
var $c0f625712eba3002$var$getActivitiesQuery = function getActivitiesQuery(product, content, fragments) {
    var activityFilterType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'ActivityFilter';
    return "\n    query ".concat((0, $8UfbL.getOperationName)(product), "($first: Int, $filter: ").concat(activityFilterType, ") {\n      activity {\n        ").concat(content, "\n      }\n    }\n").concat(fragments, "\n");
};
var $c0f625712eba3002$export$855cd08371c65b8c = function generateActivityQueryWithFilters(product, filters, activityQueries, fragments) {
    /**
   * If we are filtering by `actors` then we can't use the `myActivity` query.
   */ if (Array.isArray(filters.actors)) {
        // you can't view `viewed` events for other accounts
        var filteredAccountQueries = activityQueries.filter(function(query) {
            return query !== 'viewed';
        });
        return {
            query: $c0f625712eba3002$var$getActivitiesQuery(product, filteredAccountQueries.map(function(query) {
                return $c0f625712eba3002$var$activityQueryMap.get(query);
            }).join('\n'), fragments, 'ActivityFilter'),
            queryFilters: (0, $3MW3V.ACTIVITY_FILTER_COLLECTION).v3.get('activities')(filters)
        };
    } else return {
        query: $c0f625712eba3002$var$getActivitiesQuery(product, $c0f625712eba3002$var$getMyActivitiesQuery(activityQueries.map(function(query) {
            return $c0f625712eba3002$var$activityQueryMap.get(query);
        })), fragments, 'MyActivityFilter'),
        queryFilters: (0, $3MW3V.ACTIVITY_FILTER_COLLECTION).v3.get('myActivity')(filters)
    };
};
var $c0f625712eba3002$export$7489a6ef09862e48 = function generateGraphQLRequest(product, filters, activityQueries, fragments) {
    var _filters$limit = filters.limit, limit = _filters$limit === void 0 ? $c0f625712eba3002$var$ACTIVITIES_LIMIT : _filters$limit, restFilters = (0, $gnQ3X.default)(filters, $c0f625712eba3002$var$_excluded);
    var _generateActivityQuer = $c0f625712eba3002$export$855cd08371c65b8c(product, restFilters, activityQueries, fragments), query = _generateActivityQuer.query, queryFilters = _generateActivityQuer.queryFilters;
    return {
        operationName: (0, $8UfbL.getOperationName)(product),
        query: query,
        variables: {
            first: limit,
            filter: queryFilters
        }
    };
};

});

parcelRegister("c53UJ", function(module, exports) {
$parcel$export(module.exports, "rollupActivitiesData", function () { return $8cb8fce410310d53$export$750d93207e30f59a; });
$parcel$export(module.exports, "activityRoot", function () { return $8cb8fce410310d53$export$ea55e8e0446efa94; });
$parcel$export(module.exports, "parseRootContainerARI", function () { return $8cb8fce410310d53$export$788e6013936a6bb4; });
$parcel$export(module.exports, "filtersToMetadata", function () { return $8cb8fce410310d53$export$e8f56bed6776c7ea; });
$parcel$export(module.exports, "filterInvalidFragments", function () { return $8cb8fce410310d53$export$e22863ec502608d2; });
$parcel$export(module.exports, "isEmptyActivitiesWithErrorsResponse", function () { return $8cb8fce410310d53$export$c939d6148e47244a; });

var $f53LC = parcelRequire("f53LC");

var $lFOXD = parcelRequire("lFOXD");
function $8cb8fce410310d53$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8cb8fce410310d53$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8cb8fce410310d53$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8cb8fce410310d53$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8cb8fce410310d53$export$750d93207e30f59a(activitiesData) {
    var all = activitiesData.all, viewed = activitiesData.viewed, workedOn = activitiesData.workedOn;
    return {
        all: $8cb8fce410310d53$var$rollUpActivityItems(all),
        viewed: $8cb8fce410310d53$var$rollUpActivityItems(viewed),
        workedOn: $8cb8fce410310d53$var$rollUpActivityItems(workedOn)
    };
}
function $8cb8fce410310d53$var$rollUpActivityItems(activityItems) {
    // https://stackoverflow.com/a/49460534
    // creates an ordered 'hashmap' containing unique ids in the same order that the activity items appear
    var latestActivityItemsObjectWithLatestTimestamp = activityItems.reduce(function(acc, activityItem) {
        var deduplicateId = activityItem.object.deduplicateId || activityItem.object.id;
        var existingItem = acc[deduplicateId];
        if (existingItem) {
            var aggregatedItems = existingItem.aggregatedActivityItems || [];
            if (Date.parse(existingItem.timestamp) < Date.parse(activityItem.timestamp)) {
                activityItem.aggregatedActivityItems = [].concat((0, $lFOXD.default)(aggregatedItems), [
                    existingItem
                ]);
                // remove the current activity for that id so when we add the more recent activity it is in the order that it appears
                delete acc[deduplicateId];
                acc[deduplicateId] = activityItem;
            } else acc[deduplicateId].aggregatedActivityItems = [].concat((0, $lFOXD.default)(aggregatedItems), [
                activityItem
            ]);
        } else acc[deduplicateId] = activityItem;
        return acc;
    }, {});
    return Object.values(latestActivityItemsObjectWithLatestTimestamp);
}
var $8cb8fce410310d53$export$213ba2e9f2d143b9 = function extractFragmentRegex(key) {
    return new RegExp("fragment ".concat($8cb8fce410310d53$var$fragmentName(key), " on ").concat($8cb8fce410310d53$var$fragmentType(key), " ({(.|\\n)+?(?=fragment))"), 'gm');
};
var $8cb8fce410310d53$var$fragmentName = function fragmentName(key) {
    return key.charAt(0).toLowerCase() + key.slice(1);
};
var $8cb8fce410310d53$var$fragmentType = function fragmentType(key) {
    return key.charAt(0).toUpperCase() + key.slice(1);
};
var $8cb8fce410310d53$export$ea55e8e0446efa94 = function activityRoot(activity) {
    if (activity.myActivity) return activity.myActivity;
    return activity;
};
var $8cb8fce410310d53$var$SITE_ARI_PREFIX = 'ari:cloud:platform::site/';
var $8cb8fce410310d53$var$containerMapTypes = new Map([
    [
        $8cb8fce410310d53$var$SITE_ARI_PREFIX,
        'SITE'
    ]
]);
function $8cb8fce410310d53$export$788e6013936a6bb4(rootContainerARI) {
    // the "ID" portion of the ARI begins after the first '/'
    var ariSplitIndex = rootContainerARI.indexOf('/');
    return {
        ari: rootContainerARI,
        id: rootContainerARI.slice(ariSplitIndex + 1),
        type: $8cb8fce410310d53$var$containerMapTypes.get(rootContainerARI.slice(0, ariSplitIndex + 1)) || 'OTHER'
    };
}
function $8cb8fce410310d53$export$e8f56bed6776c7ea(filters) {
    var _filters$actors, _filters$containerIds, _filters$products, _filters$eventTypes, _filters$objectTypes, _filters$rootContaine;
    return $8cb8fce410310d53$var$_objectSpread($8cb8fce410310d53$var$_objectSpread({}, filters), {}, {
        // These have V high cardinality, so using a length
        actors: (_filters$actors = filters.actors) === null || _filters$actors === void 0 ? void 0 : _filters$actors.length,
        containerIds: (_filters$containerIds = filters.containerIds) === null || _filters$containerIds === void 0 ? void 0 : _filters$containerIds.length,
        // comma separated lists
        products: (_filters$products = filters.products) === null || _filters$products === void 0 ? void 0 : _filters$products.join(','),
        eventTypes: (_filters$eventTypes = filters.eventTypes) === null || _filters$eventTypes === void 0 ? void 0 : _filters$eventTypes.join(','),
        objectTypes: (_filters$objectTypes = filters.objectTypes) === null || _filters$objectTypes === void 0 ? void 0 : _filters$objectTypes.join(','),
        rootContainerIds: (_filters$rootContaine = filters.rootContainerIds) === null || _filters$rootContaine === void 0 ? void 0 : _filters$rootContaine.join(',')
    });
}
/**
 * These fragments are the core of our query, without them it will always fail,
 * so we shouldn't remove them. It is possible that removing other offending fragments
 * will fix the error in these core fragments. (e.g. Field conflict)
 */ var $8cb8fce410310d53$var$RESTRICTED_FRAGMENTS = [
    'activity',
    'all',
    'myActivity',
    'workedOn',
    'viewed',
    'activityItemConnection',
    'activityItemEdge'
];
function $8cb8fce410310d53$export$e22863ec502608d2(invalidFragments, allFragments) {
    return invalidFragments.filter(function(fragment) {
        return !$8cb8fce410310d53$var$RESTRICTED_FRAGMENTS.includes(fragment);
    }).reduce(function(acc, invalidFragment) {
        return acc.replace(new RegExp("...".concat(invalidFragment, "\n"), 'g'), '').replace($8cb8fce410310d53$export$213ba2e9f2d143b9(invalidFragment), '');
    }, allFragments);
}
var $8cb8fce410310d53$var$IGNORED_ERROR_CLASSIFICATIONS = [
    'IncorrectAuthException'
];
function $8cb8fce410310d53$export$c939d6148e47244a(response) {
    if (!(response !== null && response !== void 0 && response.data) || !Array.isArray(response.errors)) return false;
    var filteredAggErrors = response.errors.filter(function(e) {
        return !e.extensions.classification || !$8cb8fce410310d53$var$IGNORED_ERROR_CLASSIFICATIONS.includes(e.extensions.classification);
    });
    return filteredAggErrors.length > 0 && $8cb8fce410310d53$export$884573c560ed3600(response.data);
}
function $8cb8fce410310d53$export$884573c560ed3600(queryData) {
    var _activityRoot$all, _activityRoot$workedO, _queryData$activity;
    return !queryData.activity || ((_activityRoot$all = $8cb8fce410310d53$export$ea55e8e0446efa94(queryData.activity).all) === null || _activityRoot$all === void 0 || (_activityRoot$all = _activityRoot$all.edges) === null || _activityRoot$all === void 0 ? void 0 : _activityRoot$all.length) === 0 && ((_activityRoot$workedO = $8cb8fce410310d53$export$ea55e8e0446efa94(queryData.activity).workedOn) === null || _activityRoot$workedO === void 0 || (_activityRoot$workedO = _activityRoot$workedO.edges) === null || _activityRoot$workedO === void 0 ? void 0 : _activityRoot$workedO.length) === 0 && ((_queryData$activity = queryData.activity) === null || _queryData$activity === void 0 || (_queryData$activity = _queryData$activity.myActivity) === null || _queryData$activity === void 0 || (_queryData$activity = _queryData$activity.viewed) === null || _queryData$activity === void 0 || (_queryData$activity = _queryData$activity.edges) === null || _queryData$activity === void 0 ? void 0 : _queryData$activity.length) === 0;
}

});






parcelRegister("ls6x3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $624240eb18e2cb66$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $7GVWk = parcelRequire("7GVWk");

var $eOIix = parcelRequire("eOIix");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $gn6Qa = parcelRequire("gn6Qa");

var $7ybN7 = parcelRequire("7ybN7");
const $624240eb18e2cb66$var$JiraLogo = ()=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "jira",
        type: "logo",
        appearance: "brand",
        darkTheme: isDarkTheme
    });
};
const $624240eb18e2cb66$var$SoftwareJiraLoggedInNavbar = ()=>{
    const intl = (0, $8e22h.default)();
    const logoUrl = (0, $jQ0cd.useLocalizedHref)('/software/jira');
    const { profile: profile } = (0, $7GVWk.useUserContext)();
    const { jiraSitesFromAgg: jiraSitesFromAgg } = (0, $7ybN7.useJiraSitesContext)();
    const [siteUrl, setSiteUrl] = (0, $1oC0p.useState)('');
    (0, $1oC0p.useEffect)(()=>{
        //TODO: Probably a good spot for another UFO
        // e.g. if there are no resources for us to use
        const site = profile.attributes?.existingSites[0];
        let tempSiteUrl = site?.url;
        if (jiraSitesFromAgg?.jira.allJiraProjects.edges.length === 1) tempSiteUrl = jiraSitesFromAgg?.jira.allJiraProjects?.edges[0]?.node?.webUrl;
        setSiteUrl(tempSiteUrl ?? '');
    }, [
        jiraSitesFromAgg?.jira.allJiraProjects.edges,
        jiraSitesFromAgg?.jira.allJiraProjects.edges.length,
        profile.attributes?.existingSites,
        profile.attributes?.existingSites.length
    ]);
    const goToLoggedInJira = ()=>{
        window.location.assign(siteUrl);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gn6Qa.ProductPageNav), {
        productLogoUrl: logoUrl,
        productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($624240eb18e2cb66$var$JiraLogo, {}),
        productLogoAriaLabel: intl.formatMessage({
            id: 'wacJiraSoftwareNavigation.logo-label',
            defaultMessage: 'Jira Software logo'
        }),
        mobileCtaText: intl.formatMessage({
            id: 'JiraSoftwarePageTemplate.navbar.goToJira',
            defaultMessage: 'Go to Jira'
        }),
        mobileCtaOnClick: goToLoggedInJira,
        mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($624240eb18e2cb66$var$JiraLogo, {}),
        navigationTrynowCtaText: intl.formatMessage({
            id: 'JiraFeatureSoftwarePageTemplate.navbar.goToJira',
            defaultMessage: 'Go to Jira'
        }),
        navigationTrynowCtaOnClick: goToLoggedInJira,
        productPageNavLinks: [],
        mobileLinksSections: [],
        isShowSearchButton: false,
        isShowAppSwitcher: false,
        isShowTabletDropdown: false
    });
};
var $624240eb18e2cb66$export$2e2bcd8739ae039 = $624240eb18e2cb66$var$SoftwareJiraLoggedInNavbar;

});

parcelRegister("bVNw1", function(module, exports) {
$parcel$export(module.exports, "LoggedInHeroSection", function () { return $eb0889425594f31e$export$49c6370202c57ed1; });
/* logged-in-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $lqyi6 = parcelRequire("lqyi6");

var $eY3N6 = parcelRequire("eY3N6");

var $gqkLW = parcelRequire("gqkLW");

var $iSeHD = parcelRequire("iSeHD");

var $7GVWk = parcelRequire("7GVWk");

var $hnmMQ = parcelRequire("hnmMQ");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $1OyVz = parcelRequire("1OyVz");

var $kP8Dm = parcelRequire("kP8Dm");

var $jUgJp = parcelRequire("jUgJp");

var $1YSly = parcelRequire("1YSly");

var $7ybN7 = parcelRequire("7ybN7");
const $eb0889425594f31e$var$TRACKING_EVENT_NAMES = {
    loggedInHeroProductCtaClicked: 'loggedInHeroProductCtaClicked',
    loggedInHeroAnotherSiteCtaClicked: 'loggedInHeroAnotherSiteCtaClicked',
    loggedInHeroExploreFeaturesClicked: 'loggedInHeroExploreFeaturesClicked',
    loggedInHeroCreateNewSiteClicked: 'loggedInHeroCreateNewSiteClicked'
};
const $eb0889425594f31e$var$START_URL = 'https://start.atlassian.com';
const $eb0889425594f31e$export$cbc42fadf8b93ea3 = {
    eventType: 'ui',
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'loggedInHero',
    source: '/software/jira'
};
const $eb0889425594f31e$var$jswLoggedInCss = null;
const $eb0889425594f31e$var$heroSectionCss = null;
const $eb0889425594f31e$var$anchorContainer = null;
const $eb0889425594f31e$var$jiraSiteBoxCss = null;
const $eb0889425594f31e$var$headingCss = null;
const $eb0889425594f31e$var$starCss = null;
const $eb0889425594f31e$var$differentSiteCss = null;
const $eb0889425594f31e$var$subHeadingContainerCss = null;
const $eb0889425594f31e$var$createNewSiteAnchorCss = null;
const $eb0889425594f31e$var$subHeadingCss = null;
const $eb0889425594f31e$var$exploreFeaturesContainerCss = null;
const $eb0889425594f31e$var$exploreFeaturesHeadingCss = null;
const $eb0889425594f31e$var$exploreFeaturesCtaCss = null;
const $eb0889425594f31e$var$nameUnderlineCss = null;
const $eb0889425594f31e$var$inlineJiraLogoCss = null;
const $eb0889425594f31e$var$siteInfoContainerCss = null;
const $eb0889425594f31e$var$sitenameIconCss = null;
const $eb0889425594f31e$var$sitenameIconTextCss = null;
const $eb0889425594f31e$var$sitenameAndAvatarContainerCss = null;
const $eb0889425594f31e$var$siteNameSpanCss = null;
const $eb0889425594f31e$var$tooltipWrapperCss = null;
const $eb0889425594f31e$var$avatarContainerCss = null;
const $eb0889425594f31e$var$linkPlaceholderCss = null;
const $eb0889425594f31e$export$49c6370202c57ed1 = ()=>{
    const { user: user } = (0, $7GVWk.useUserContext)();
    const { jiraSitesFromAgg: jiraSitesFromAgg } = (0, $7ybN7.useJiraSitesContext)();
    const intl = (0, $8e22h.default)();
    const [teammateAvatars, setTeammateAvatars] = (0, $1oC0p.useState)([]);
    const [totalUserCount, setTotalUserCount] = (0, $1oC0p.useState)();
    const userFirstName = user?.name?.split(' ')[0];
    const userPicture = user?.picture;
    const avatars = jiraSitesFromAgg?.jira?.allJiraProjects.edges[0]?.node.assignableUsers.edges;
    (0, $1oC0p.useEffect)(()=>{
        setTeammateAvatars(jiraSitesFromAgg?.jira?.allJiraProjects.edges[0]?.node.assignableUsers.edges.filter((assignableUser)=>assignableUser.node.picture !== userPicture && assignableUser.node.accountStatus === 'active' && !assignableUser.node.name.includes('-bot')).map((assignableUser)=>{
            return assignableUser.node.picture ?? '';
        }) ?? []);
    }, [
        avatars,
        jiraSitesFromAgg?.jira?.allJiraProjects.edges,
        userPicture
    ]);
    (0, $1oC0p.useEffect)(()=>setTotalUserCount(jiraSitesFromAgg?.jira?.allJiraProjects.edges[0]?.node.assignableUsers.totalCount), [
        jiraSitesFromAgg?.jira?.allJiraProjects.edges
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const localizedTryLink = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=jira-software&createNew=true');
    const localizedProductGuideLink = (0, $jQ0cd.useLocalizedHref)('/software/jira/guides/getting-started/introduction');
    const [hasMultipleJiras, setHasMultipleJiras] = (0, $1oC0p.useState)(false);
    const [siteName, setSiteName] = (0, $1oC0p.useState)('');
    const [siteInitials, setSiteInitials] = (0, $1oC0p.useState)('');
    const [siteUrl, setSiteUrl] = (0, $1oC0p.useState)('');
    const { hasMultipleJiras: mostRecentHasMultipleJiras, siteName: mostRecentSiteName, siteUrl: mostRecentSiteUrl, siteInitials: mostRecentSiteInitials } = (0, $kP8Dm.useRecentJiraSite)();
    (0, $1oC0p.useEffect)(()=>{
        setHasMultipleJiras(mostRecentHasMultipleJiras);
        setSiteName(mostRecentSiteName);
        setSiteUrl(mostRecentSiteUrl);
        setSiteInitials(mostRecentSiteInitials);
    }, [
        mostRecentHasMultipleJiras,
        mostRecentSiteInitials,
        mostRecentSiteName,
        mostRecentSiteUrl
    ]);
    const loggedInHeroLoadedAnalyticsPayload = {
        eventType: 'ui',
        action: 'loaded',
        actionSubject: 'component',
        actionSubjectId: 'loggedInHero',
        source: '/software/jira',
        attributes: {
            atlasId: 'ATLAS-77776, ATLAS-93657'
        }
    };
    (0, $1oC0p.useEffect)(()=>{
        //if client side, fire analytics event
        if (typeof window !== 'undefined') createAnalyticsEvent({
            ...loggedInHeroLoadedAnalyticsPayload
        }).fire();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const clickHandler = (eventName)=>{
        createAnalyticsEvent({
            ...$eb0889425594f31e$export$cbc42fadf8b93ea3,
            attributes: {
                eventName: eventName,
                url: window.location.href,
                atlasId: 'ATLAS-77776, ATLAS-93657'
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _11q71bjw _12vemgnk _1lrw1dfr _1e0c11p5 _yv0ehkll _4cvr1h6o _6a6z1h6o _18zr53f4 _1q5110yn _85i512am _1bsb1osq _1bhl10yn"
        ]),
        style: {
            "--_lwvw50": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue100'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm _syaz1pfd _1bsb1osq _p12fk3xj _ca0qgktf _u5f3gktf _n3tdgktf _19bvgktf _s51sidpf"
            ]),
            style: {
                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_t9ecuuzf _kqswstnw _1e0c1o8l _u7co1w81 _1e021vgi _1mjbglyw"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                        image: {
                            width: 88,
                            height: 70,
                            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/g06k378gucflnfse7s88i0365h14j40v.webp',
                            alt: 'hand-drawn stars'
                        }
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                    className: (0, $2jatx.default)([
                        "_1wybckbl _vwz48vuz _k48p9y44 _ect41vau _6rtho7ao _bozgidpf _so7dldb6 _19q11ylp"
                    ]),
                    style: {
                        "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                    },
                    children: userFirstName ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "JiraSoftwarePageTemplate.loggedInHero.welcomeBackWithName",
                        defaultMessage: `Welcome back, {name}.`,
                        values: {
                            name: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_zg8l4jg8 _kqswh2mm _3p6m1sr6 _1v5vmgnk _14rnuol8 _19h91f51 _aetrb3bt _1qdggktf _1gufd439 _1czd12gs _g0nfmyb0 _18postnw _14tt14id _1ruvyjp0"
                                ]),
                                style: {
                                    "--_td2gmy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.saffron'))
                                },
                                children: userFirstName
                            })
                        }
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "JiraSoftwarePageTemplate.loggedInHero.welcomeBack",
                        defaultMessage: "Welcome back"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1n261g80 _gy1p53f4 _1bah1yb4 _4cvr1q9y"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_ect4z4z1 _1wybgktf _vwz41f4h _k48p1nn1"
                            ]),
                            style: {
                                "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "JiraSoftwarePageTemplate.loggedInHero.pickUpWhereYouLeftOffInProduct",
                                defaultMessage: "Pick up where you left off in <span>{product}</span>",
                                values: {
                                    product: 'Jira',
                                    // eslint-disable-next-line react/no-unstable-nested-components
                                    span: (text)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_1e0c1o8l _t9ec1jia _kqswh2mm _152tdlk8 _195g14id"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1OyVz.JiraMarkBrand), {})
                                                }),
                                                text
                                            ]
                                        })
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-testid": "createNewSiteAnchor",
                            href: localizedTryLink,
                            onClick: ()=>clickHandler($eb0889425594f31e$var$TRACKING_EVENT_NAMES.loggedInHeroCreateNewSiteClicked),
                            className: (0, $2jatx.default)([
                                "_ect4z4z1 _1wyb7vkz _k48pni7l _vwz41f4h _syaz5hrz"
                            ]),
                            style: {
                                "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "WacSignupForm.createNewSite",
                                defaultMessage: "Create a new site"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _16jlkb7n _1wpz1fhb"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_bfhk1afi _2rko1y44 _1bsb1osq _1ul91mjv _1e0c1txw _1bah1yb4 _2lx2vrvc _4cvr1h6o _19itgo0a _1rjc7vkz _18zr7vkz _1mougktf _kqswh2mm"
                        ]),
                        style: {
                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jUgJp.JiraSiteContainer), {
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _2lx2vrvc _4cvr1h6o _4t3ivbgk _zulppxbi"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_11q716ye _2rko1b66 _1e0c1txw _1bah1h6o _4cvr1h6o _4t3ivbgk _1bsbvbgk _1ul9vbgk"
                                            ]),
                                            style: {
                                                "--_alcc52": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.lime300'))
                                            },
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                                                className: (0, $2jatx.default)([
                                                    "_syazsei6 _ect41vau _1wyb1ejb _k48pni7l _vwz41f4h _1dyznl7k _y3gn1h6o"
                                                ]),
                                                style: {
                                                    "--_rhsgef": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.lime800')),
                                                    "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                                                },
                                                children: siteInitials
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                            className: (0, $2jatx.default)([
                                                "_1e0c1txw _2lx21bp4 _1bah1h6o _zulp19bv _kqswh2mm _4t3ivbgk"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_4t3igktf"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gqkLW.default), {
                                                        content: siteName,
                                                        position: 'top-end',
                                                        mousePosition: "top",
                                                        tag: 'span',
                                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                            className: (0, $2jatx.default)([
                                                                "_ect4z4z1 _1wybgktf _k48p1fw0 _4t3igktf _vwz41j6v _y3gn1e5h _1bto1l2s _o5721q9c _1reo15vq _18m915vq _1e0c1o8l _s7n4jp4b _uhd0uuw1 _1tssl1r9"
                                                            ]),
                                                            style: {
                                                                "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                                                            },
                                                            children: siteName
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_4t3i1tcg _uhd0uuw1 _1tssl1r9"
                                                    ]),
                                                    children: userPicture && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1YSly.LoggedInProductTourAvatarFacepile), {
                                                        max: 4,
                                                        iconSize: 24,
                                                        icons: [
                                                            userPicture,
                                                            ...teammateAvatars
                                                        ],
                                                        totalUserCount: totalUserCount ?? 0
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                    "data-testid": "goToJiraButton",
                                    variant: "primary_alt",
                                    href: siteUrl,
                                    size: "small",
                                    onClick: ()=>clickHandler($eb0889425594f31e$var$TRACKING_EVENT_NAMES.loggedInHeroProductCtaClicked),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "JiraSoftwarePageTemplate.loggedInHero.goToJira",
                                        defaultMessage: "Go to Jira"
                                    })
                                })
                            ]
                        })
                    })
                }),
                hasMultipleJiras ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_ect4z4z1 _1pfho7ao _1wybdlk8 _k48p1nn1 _gu181h6o"
                    ]),
                    style: {
                        "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                        text: intl.formatMessage({
                            id: 'ConfluenceSoftwarePageTemplate.loggedInHero.lookingForDifferentSite',
                            defaultMessage: 'Looking for a different site?'
                        }),
                        href: $eb0889425594f31e$var$START_URL,
                        type: "primary",
                        onClick: ()=>clickHandler($eb0889425594f31e$var$TRACKING_EVENT_NAMES.loggedInHeroAnotherSiteCtaClicked)
                    })
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4t3iqslr"
                    ])
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1pfhvbgk _1e0c1txw _2lx21bp4 _4cvr1h6o _y3gn1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_ect4z4z1 _1wybgktf _vwz41f4h _k48p1nn1 _6rth7vkz"
                            ]),
                            style: {
                                "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "JiraSoftwarePageTemplate.loggedInHero.findOutMore",
                                defaultMessage: "Want to find out more about Jira?"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-testid": "exploreFeaturesAnchor",
                            href: localizedProductGuideLink,
                            onClick: ()=>clickHandler($eb0889425594f31e$var$TRACKING_EVENT_NAMES.loggedInHeroExploreFeaturesClicked),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                className: (0, $2jatx.default)([
                                    "_ect4z4z1 _1wyb7vkz _k48pni7l _11q7glyw _r06hglyw _2rko1ul9 _ca0q19bv _u5f31ul9 _n3td19bv _19bv1ul9 _19it1axk _80omtlke"
                                ]),
                                style: {
                                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "jira-product-tour.staggered-double-feature-section.first-feature-link-text",
                                    defaultMessage: "Explore features"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
$eb0889425594f31e$export$49c6370202c57ed1.displayName = 'LoggedInHeroSection';
var $eb0889425594f31e$export$2e2bcd8739ae039 = $eb0889425594f31e$export$49c6370202c57ed1;

});
parcelRegister("jUgJp", function(module, exports) {
$parcel$export(module.exports, "JiraSiteContainer", function () { return $0f278737b86939ae$export$156fedbbf16eee65; });

var $7VQPk = parcelRequire("7VQPk");

var $kP8Dm = parcelRequire("kP8Dm");

var $lJgOZ = parcelRequire("lJgOZ");
const $0f278737b86939ae$export$156fedbbf16eee65 = ({ children: children })=>{
    const { siteName: siteName, siteInitials: siteInitials, siteUrl: siteUrl } = (0, $kP8Dm.useRecentJiraSite)();
    if (siteName === '' || siteInitials === '' || siteUrl === '') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lJgOZ.JiraSiteSkeleton), {});
    return children;
};

});
parcelRegister("lJgOZ", function(module, exports) {
$parcel$export(module.exports, "JiraSiteSkeleton", function () { return $e3c088fe27eb70b0$export$129bc33e2568dfe3; });
/* jira-site-skeleton.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $eUwCn = parcelRequire("eUwCn");
const $e3c088fe27eb70b0$var$siteInfoContainerCss = null;
const $e3c088fe27eb70b0$var$sitenameIconCss = null;
const $e3c088fe27eb70b0$var$sitenameAndAvatarContainerCss = null;
const $e3c088fe27eb70b0$var$containerCss = null;
const $e3c088fe27eb70b0$export$129bc33e2568dfe3 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "jira-site-skeleton",
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1yb4 _2lx2vrvc _4cvr1h6o _kqswh2mm _16jlkb7n _1wpz1fhb"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx2vrvc _4cvr1h6o _4t3ivbgk _zulppxbi"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _1bah1h6o _4cvr1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                            width: "64px",
                            height: "64px"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _1bah1h6o _zulp19bv _kqswh2mm _4t3ivbgk"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "300px",
                                height: "22px"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "160px",
                                height: "22px"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                    width: "120px",
                    height: "40px"
                })
            })
        ]
    });
};

});


parcelRegister("1YSly", function(module, exports) {
$parcel$export(module.exports, "LoggedInProductTourAvatarFacepile", function () { return $73d38aac98679b2d$export$5b9f7c22786b87bc; });
/* logged-in-product-tour-avatar-facepile.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $bUqvj = parcelRequire("bUqvj");
const $73d38aac98679b2d$export$5b9f7c22786b87bc = ({ icons: icons, max: max, overlap: overlap = 4, iconSize: iconSize = 16, totalUserCount: totalUserCount })=>{
    const userCountPillStyles = null;
    const intl = (0, $8e22h.default)();
    const maxUsersStyles = null;
    const andMoreText = intl.formatMessage({
        id: 'avatarFacePile.andMoreText',
        defaultMessage: 'and more'
    });
    const facepileStyles = [
        null,
        overlap > 0 && null
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c116y _4t3ibv8l _1bsb1osq _9e7b1bmj",
            overlap > 0 && "_ahbqccqr"
        ]),
        style: {
            "--_1lwyf0k": (0, $6ZVlx.default)(iconSize, "px"),
            "--_19zwya0-": (0, $6ZVlx.default)(overlap, "px", "-"),
            "--_19zwya0": (0, $6ZVlx.default)(overlap, "px")
        },
        children: [
            icons.slice(0, max).map((icon, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $bUqvj.AvatarIcon), {
                    icon: icon,
                    iconSize: iconSize,
                    overlap: overlap
                }, index)),
            totalUserCount > 99 ? /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_syaz1qc2 _1wyb1crf _k48p1nn1 _ahbqi2wt _1e0c1txw _4cvr1h6o"
                ]),
                style: {
                    "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800'))
                },
                children: andMoreText
            }) : totalUserCount > max && /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                className: (0, $2jatx.default)([
                    "_4cvr1h6o _2rko1k4y _19it1dxc _syaz1qc2 _1e0c116y _1wybgbje _k48p1nn1 _zulpze3t _4t3ibv8l _1bah1h6o _vwz4bv8l _ahbq1564 _1yt418uk _y3gn1h6o _s7n4nkob _1bsb1wug"
                ]),
                style: {
                    "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800')),
                    "--_1lwyf0k": (0, $6ZVlx.default)(iconSize, "px"),
                    "--_1j20svt": (0, $6ZVlx.default)(overlap * -1, "px")
                },
                children: [
                    "+",
                    totalUserCount - max
                ]
            })
        ]
    });
};

});
parcelRegister("bUqvj", function(module, exports) {
$parcel$export(module.exports, "AvatarIcon", function () { return $e312a6f2d047eb18$export$b1f22795a41806ac; });
$parcel$export(module.exports, "AvatarFacepile", function () { return $e312a6f2d047eb18$export$ca915dc6aced2b3e; });
/* avatar-facepile.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");
const $e312a6f2d047eb18$export$b1f22795a41806ac = ({ icon: icon, iconSize: iconSize, overlap: overlap })=>{
    const iconStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: icon,
            alt: 'avatar',
            width: iconSize,
            height: iconSize
        },
        className: (0, $2jatx.default)([
            "_2rko1wqb _1e0c1o8l _4t3ibv8l _ahbq1bmj _1reo15vq _18m915vq _kqswh2mm _1bsbbv8l _rtqb8nf5"
        ]),
        style: {
            "--_1lwyf0k": (0, $6ZVlx.default)(iconSize, "px"),
            "--_19zwya0-": (0, $6ZVlx.default)(overlap, "px", "-")
        }
    });
};
const $e312a6f2d047eb18$export$ca915dc6aced2b3e = ({ icons: icons, max: max, overlap: overlap = 4, iconSize: iconSize = 16 })=>{
    const userCountPillStyles = null;
    const facepileStyles = [
        null,
        overlap > 0 && null
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c116y _4t3ibv8l _1bsb1osq _9e7b1bmj",
            overlap > 0 && "_ahbqccqr"
        ]),
        style: {
            "--_1lwyf0k": (0, $6ZVlx.default)(iconSize, "px"),
            "--_19zwya0-": (0, $6ZVlx.default)(overlap, "px", "-"),
            "--_19zwya0": (0, $6ZVlx.default)(overlap, "px")
        },
        children: [
            icons.slice(0, max).map((icon, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)($e312a6f2d047eb18$export$b1f22795a41806ac, {
                    icon: icon,
                    iconSize: iconSize,
                    overlap: overlap
                }, index)),
            icons.length > max && /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                className: (0, $2jatx.default)([
                    "_4cvr1h6o _2rko1k4y _19it1dxc _syaz1qc2 _1e0c116y _1wybgbje _k48p1nn1 _zulpze3t _4t3ibv8l _1bah1h6o _vwz4bv8l _ahbq1564 _1yt418uk _y3gn1h6o _s7n4nkob _1bsb1wug"
                ]),
                style: {
                    "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800')),
                    "--_1lwyf0k": (0, $6ZVlx.default)(iconSize, "px"),
                    "--_1j20svt": (0, $6ZVlx.default)(overlap * -1, "px")
                },
                children: [
                    "+",
                    icons.length - max
                ]
            })
        ]
    });
};

});






parcelRegister("9h3ui", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePageAnchorLpJswEngineering", function () { return $5f64ecbd83542af8$export$21c206b8ba9eb903; });

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");

var $k6PTJ = parcelRequire("k6PTJ");

var $17vRh = parcelRequire("17vRh");
const $5f64ecbd83542af8$export$21c206b8ba9eb903 = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $17vRh.JiraSoftwarePagePaidLpJswAnchor), {
        ...pageProps,
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsw-team-engineering",
        persona: "unknown",
        pageVariant: "engineering"
    });
};

});

parcelRegister("8v2ki", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePageAnchorLpJswHr", function () { return $d9e299dc383c47ee$export$ad7cb727602fa346; });

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");

var $k6PTJ = parcelRequire("k6PTJ");

var $17vRh = parcelRequire("17vRh");
const $d9e299dc383c47ee$export$ad7cb727602fa346 = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $17vRh.JiraSoftwarePagePaidLpJswAnchor), {
        ...pageProps,
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsw-team-hr",
        persona: "unknown",
        pageVariant: "hr"
    });
};

});

parcelRegister("2LTjU", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePageAnchorLpJswLegal", function () { return $51fd46f684ec8cbe$export$a54419ba9ddd4e32; });

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");

var $k6PTJ = parcelRequire("k6PTJ");

var $17vRh = parcelRequire("17vRh");
const $51fd46f684ec8cbe$export$a54419ba9ddd4e32 = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $17vRh.JiraSoftwarePagePaidLpJswAnchor), {
        ...pageProps,
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsw-team-legal",
        persona: "unknown",
        pageVariant: "legal"
    });
};

});

parcelRegister("idul7", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePageAnchorLpJswMarketing", function () { return $c9117ca4233aaf70$export$560daf6a01ddd7ea; });

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");

var $k6PTJ = parcelRequire("k6PTJ");

var $17vRh = parcelRequire("17vRh");
const $c9117ca4233aaf70$export$560daf6a01ddd7ea = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $17vRh.JiraSoftwarePagePaidLpJswAnchor), {
        ...pageProps,
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsw-team-marketing",
        persona: "unknown",
        pageVariant: "marketing"
    });
};

});

parcelRegister("iEYMn", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePageAnchorLpJswOperations", function () { return $96b8a703ecbb65ad$export$e2ac21102c7fc08d; });

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");

var $k6PTJ = parcelRequire("k6PTJ");

var $17vRh = parcelRequire("17vRh");
const $96b8a703ecbb65ad$export$e2ac21102c7fc08d = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $17vRh.JiraSoftwarePagePaidLpJswAnchor), {
        ...pageProps,
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsw-team-operations",
        persona: "unknown",
        pageVariant: "operations"
    });
};

});

parcelRegister("1MAo5", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePageAnchorLpJswProgramMgmt", function () { return $6104242eaac5f9c8$export$474595b11c2cc21b; });

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");

var $k6PTJ = parcelRequire("k6PTJ");

var $17vRh = parcelRequire("17vRh");
const $6104242eaac5f9c8$export$474595b11c2cc21b = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $17vRh.JiraSoftwarePagePaidLpJswAnchor), {
        ...pageProps,
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsw-team-programmgmt",
        persona: "unknown",
        pageVariant: "programmgmt"
    });
};

});

parcelRegister("dQR2M", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePageAnchorLpJswSales", function () { return $e85ae7222d917129$export$bd9265ca82ed6224; });

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");

var $k6PTJ = parcelRequire("k6PTJ");

var $17vRh = parcelRequire("17vRh");
const $e85ae7222d917129$export$bd9265ca82ed6224 = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $17vRh.JiraSoftwarePagePaidLpJswAnchor), {
        ...pageProps,
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsw-team-sales",
        persona: "unknown",
        pageVariant: "sales"
    });
};

});

parcelRegister("dXL3R", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePage", function () { return $9d047481379b0727$export$a6be62ed06c967ea; });

var $7VQPk = parcelRequire("7VQPk");

var $67UrT = parcelRequire("67UrT");

var $9rnwe = parcelRequire("9rnwe");

var $bQjAr = parcelRequire("bQjAr");

var $20OkY = parcelRequire("20OkY");

var $1rObi = parcelRequire("1rObi");

var $2WL8B = parcelRequire("2WL8B");

var $bTseT = parcelRequire("bTseT");

var $5JA6e = parcelRequire("5JA6e");

var $2V8Su = parcelRequire("2V8Su");

var $gHXqX = parcelRequire("gHXqX");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
const $9d047481379b0727$export$a6be62ed06c967ea = ()=>{
    const loggedInHasJira = (0, $2WL8B.useLoggedInHasJira)();
    const isWae = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).dxpMigrationJiraProductTourGate);
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp737EnableIntercomChatJsw);
    let template = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gHXqX.LoggedOutOrNoJiraProductTourOverview), {});
    // For logged in, we will show a "Has Jira" experience,
    // or otherwise the Uniform "logged out" page.
    if (loggedInHasJira) template = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5JA6e.LoggedInHeroContainer), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2V8Su.OrganicLoggedInJiraProductTourOverview), {})
    });
    else if (isWae) template = /*#__PURE__*/ (0, $7VQPk.jsx)($9d047481379b0727$var$WaeJiraPage, {});
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "jira-product-tour-overview",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bTseT.IntercomProvider), {
            appId: "p0ww63i2",
            triggerBoot: isBootIntercom,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rObi.CrossFlowTouchpointProvider), {
                productKeys: [
                    (0, $20OkY.ProductKeys).JIRA_SOFTWARE
                ],
                screenName: "wacJswProductTourPage",
                children: template
            })
        })
    });
};
const $9d047481379b0727$var$WaeJiraPage = ()=>{
    const { composition: composition } = (0, $9rnwe.useWAEContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $67UrT.UniformEntryPage), {
        composition: composition
    });
};

});
parcelRegister("67UrT", function(module, exports) {
$parcel$export(module.exports, "UniformEntryPage", function () { return $567142e6bd5e85f1$export$f0d4a992b207ed41; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $iSeHD = parcelRequire("iSeHD");

var $4EfnG = parcelRequire("4EfnG");

var $7WM7y = parcelRequire("7WM7y");

var $ipRTK = parcelRequire("ipRTK");
const $567142e6bd5e85f1$export$f0d4a992b207ed41 = ({ composition: composition, compositionMetrics: compositionMetrics, isUniformPlayground: isUniformPlayground, isAllowPostMessage: isAllowPostMessage })=>{
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const { compositionFetchStart: compositionFetchStart, compositionCacheStatus: compositionCacheStatus, ssrEndTime: ssrEndTime } = compositionMetrics || {};
    const sendPageRenderAnalyticsEvent = (0, $1oC0p.useCallback)((pageRenderTime, ssrEndTime, compositionFetchStart, fcp)=>{
        if (pageRenderTime && analyticsClient) analyticsClient.sendUIEvent({
            action: 'pageRender',
            actionSubject: 'uniformPage',
            source: window.location.pathname,
            attributes: {
                pageRenderTime: pageRenderTime,
                compositionFetchStart: compositionFetchStart,
                ssrEndTime: ssrEndTime,
                compositionCacheStatus: compositionCacheStatus,
                fcp: fcp,
                isUniformPlayground: isUniformPlayground || false
            }
        });
    }, [
        analyticsClient,
        compositionCacheStatus,
        isUniformPlayground
    ]);
    (0, $1oC0p.useEffect)(()=>{
        // @ts-ignore
        const measureFirstContentfulPaint = ()=>{
            try {
                // First, check if FCP is already available
                const paintEntries = performance.getEntriesByType('paint');
                const firstContentfulPaint = paintEntries.find((entry)=>entry.name === 'first-contentful-paint');
                if (firstContentfulPaint && ssrEndTime && compositionFetchStart) {
                    const fcp = firstContentfulPaint.startTime;
                    // Calculate page render time
                    const pageRenderTime = ssrEndTime - compositionFetchStart + fcp;
                    if (pageRenderTime) sendPageRenderAnalyticsEvent(pageRenderTime, ssrEndTime, compositionFetchStart, fcp);
                    return firstContentfulPaint.startTime;
                }
                // If FCP isn't available yet, observe for it
                const observer = new PerformanceObserver((list)=>{
                    const entries = list.getEntries();
                    const fcpEntry = entries.find((entry)=>entry.name === 'first-contentful-paint');
                    if (fcpEntry && compositionFetchStart && ssrEndTime) {
                        const fcp = fcpEntry.startTime;
                        // Calculate page render time
                        const pageRenderTime = ssrEndTime - compositionFetchStart + fcp;
                        if (pageRenderTime) sendPageRenderAnalyticsEvent(pageRenderTime, ssrEndTime, compositionFetchStart, fcp);
                        observer.disconnect();
                    }
                });
                observer.observe({
                    entryTypes: [
                        'paint'
                    ]
                });
                // Cleanup observer after 10 seconds to prevent memory leaks
                setTimeout(()=>{
                    observer.disconnect();
                }, 10000);
                return undefined;
            } catch (error) {
                console.warn('Error measuring Page Render Time:', error);
                return undefined;
            }
        };
        measureFirstContentfulPaint();
    }, [
        compositionFetchStart,
        compositionMetrics,
        sendPageRenderAnalyticsEvent,
        ssrEndTime
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4EfnG.default), {
        fallback: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7WM7y.FourOhFourPageTemplate), {}),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            "data-testid": "uniform-entry-page-root",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ipRTK.UniformEntryPageTemplate), {
                    composition: composition,
                    isUniformPlayground: isUniformPlayground,
                    isAllowPostMessage: isAllowPostMessage
                })
            })
        })
    });
};

});
parcelRegister("ipRTK", function(module, exports) {
$parcel$export(module.exports, "UniformEntryPageTemplate", function () { return $9b881e462c85fa95$export$8328465fb6b6a7d2; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $dNSrU = parcelRequire("dNSrU");

var $4EfnG = parcelRequire("4EfnG");

var $7WM7y = parcelRequire("7WM7y");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $g7CEg = parcelRequire("g7CEg");

var $9rnwe = parcelRequire("9rnwe");
const $9b881e462c85fa95$export$8328465fb6b6a7d2 = ({ composition: composition, isUniformPlayground: isUniformPlayground, isAllowPostMessage: isAllowPostMessage })=>{
    const { uniformContext: uniformContext } = (0, $9rnwe.useWAEContext)();
    // The default "server-only" transfer-state script exists only in the SSR tree, so
    // hydration finds an extra node and client-renders the whole page
    const includeTransferState = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).personalizationNoContentSwap) ? 'always' : 'server-only';
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4EfnG.default), {
        fallback: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7WM7y.FourOhFourPageTemplate), {}),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dNSrU.UniformContext), {
            context: uniformContext,
            includeTransferState: includeTransferState,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g7CEg.UniformWrapper), {
                composition: composition,
                isUniformPlayground: isUniformPlayground,
                isAllowPostMessage: isAllowPostMessage
            })
        })
    });
};

});


parcelRegister("5JA6e", function(module, exports) {
$parcel$export(module.exports, "LoggedInHeroContainer", function () { return $7dd9a4cf5c1be356$export$c91dc4c235bd2e79; });

var $7VQPk = parcelRequire("7VQPk");

var $3Ccrv = parcelRequire("3Ccrv");

var $7GVWk = parcelRequire("7GVWk");

var $ZCSXq = parcelRequire("ZCSXq");
const $7dd9a4cf5c1be356$export$c91dc4c235bd2e79 = ({ children: children })=>{
    const { profile: { requestInProgress: profileRequestInProgress }, user: { requestInProgress: userRequestInProgress } } = (0, $7GVWk.useUserContext)();
    // Checking for both user and profile request in progress,
    // since profileRequestInProgress is initially defined as 'false' and then gets updated to true when the request is made.
    if (userRequestInProgress || profileRequestInProgress) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3Ccrv.default), {
        name: 'logged-in-hero-loading',
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ZCSXq.LoggedInHeroSkeleton), {})
    });
    return children;
};

});
parcelRegister("ZCSXq", function(module, exports) {
$parcel$export(module.exports, "LoggedInHeroSkeleton", function () { return $136a2b90265c9861$export$84abebbf129cccbc; });
/* logged-in-hero-skeleton.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $eUwCn = parcelRequire("eUwCn");
const $136a2b90265c9861$var$headingSectionGap = null;
const $136a2b90265c9861$var$sectionGap = null;
const $136a2b90265c9861$var$contianerStyles = null;
const $136a2b90265c9861$var$mobileDisplay = null;
const $136a2b90265c9861$var$desktopDisplay = null;
const $136a2b90265c9861$export$84abebbf129cccbc = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "logged-in-jira-pt-skeleton",
        className: (0, $2jatx.default)([
            "_1pfh1ejb"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1ule _1mjbglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rth1epz"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "1152px",
                                height: "48px"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rthxncg _1eglxncg"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "1140px",
                                height: "1140px"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _1mjb1ule"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rth1epz"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "480px",
                                height: "48px"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rthxncg _1eglxncg"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "480px",
                                height: "480px"
                            })
                        })
                    ]
                })
            })
        ]
    });
};

});


parcelRegister("2V8Su", function(module, exports) {
$parcel$export(module.exports, "OrganicLoggedInJiraProductTourOverview", function () { return $416013fb4d6c28df$export$49bc6fac881dd811; });

var $7VQPk = parcelRequire("7VQPk");

var $iLjCW = parcelRequire("iLjCW");

var $l4vdU = parcelRequire("l4vdU");

var $izdHQ = parcelRequire("izdHQ");

var $5S2vX = parcelRequire("5S2vX");

var $4afjM = parcelRequire("4afjM");

var $ly0rU = parcelRequire("ly0rU");

var $lTaG1 = parcelRequire("lTaG1");

var $jmYmp = parcelRequire("jmYmp");
const $416013fb4d6c28df$export$49bc6fac881dd811 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
        experimentKey: "jfind-1506-after-d7-gubtp-organic",
        group: "jfind-1506-after-d7-gubtp-organic",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
            experimentKey: "jfind-organic-jpt-logged-in-redesign",
            group: "jfind-organic-jpt-logged-in-redesign",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $ly0rU.JiraSitesProvider), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l4vdU.default), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jmYmp.default), {})
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
                        scrollTrackingEnabled: true,
                        pageId: "jsw",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4afjM.ReturningUserBanner), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTaG1.LoggedInHeroSection), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iLjCW.GlobalFooter), {})
                        ]
                    })
                ]
            })
        })
    });
};

});
parcelRegister("4afjM", function(module, exports) {
$parcel$export(module.exports, "ReturningUserBanner", function () { return $51537c7de9d5df83$export$14e4a778e9c76f32; });
/* returning-user-banner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $kbpa7 = parcelRequire("kbpa7");
const $51537c7de9d5df83$export$14e4a778e9c76f32 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "returning-user-banner",
        className: (0, $2jatx.default)([
            "_4cvr1h6o _bfhkcafw _1e0c1txw _1n261g80 _zulp1kwk _1bah1h6o _vwz410nf _ca0q1j6v _u5f31j6v _n3td1j6v _19bv1j6v"
        ]),
        style: {
            "--_1bnl49": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue200'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                children: "\uD83D\uDCE3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraProductTourReturningUserBanner.message",
                defaultMessage: "Introducing agents in Jira <link>Learn more</link>",
                values: {
                    link: $51537c7de9d5df83$var$LearnMoreLink
                }
            })
        ]
    });
const $51537c7de9d5df83$var$LearnMoreLink = (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        href: "https://www.atlassian.com/blog/announcements/ai-agents-in-jira",
        className: (0, $2jatx.default)([
            "_syazu5k9 _4bfu1r31 _1hmsglyw _ajmmnqa1 _9oik1r31 _1bnx8stv _jf4cnqa1"
        ]),
        style: {
            "--_5dnsy5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue700'))
        },
        children: chunks
    });
const $51537c7de9d5df83$var$bannerCss = null;
const $51537c7de9d5df83$var$linkCss = null;

});

parcelRegister("ly0rU", function(module, exports) {
$parcel$export(module.exports, "useJiraSitesContext", function () { return $007cd6e9556fb39d$export$8095836340dcdac5; });
$parcel$export(module.exports, "JiraSitesProvider", function () { return $007cd6e9556fb39d$export$e5844423e4215335; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $7GVWk = parcelRequire("7GVWk");

var $lmmDf = parcelRequire("lmmDf");
const $007cd6e9556fb39d$var$JiraSitesContext = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
const $007cd6e9556fb39d$export$8095836340dcdac5 = ()=>{
    const context = (0, $1oC0p.useContext)($007cd6e9556fb39d$var$JiraSitesContext);
    if (!context) throw new Error('useJiraSitesContext must be used within a JiraSitesProvider');
    return context;
};
const $007cd6e9556fb39d$export$e5844423e4215335 = ({ children: children })=>{
    const [jiraSitesFromAgg, setJiraSitesFromAgg] = (0, $1oC0p.useState)(undefined);
    const { profile: profile } = (0, $7GVWk.useUserContext)();
    const aggClient = (0, $1oC0p.useMemo)(()=>new (0, $lmmDf.LoggedInUserJiraSitesClient)(), []);
    (0, $1oC0p.useEffect)(()=>{
        if (!profile.attributes?.existingSites) return;
        const site = profile.attributes.existingSites[0];
        aggClient.getJiraSites(site?.cloudId ?? '').then((data)=>{
            setJiraSitesFromAgg(data);
        });
    }, [
        aggClient,
        profile.attributes?.existingSites
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($007cd6e9556fb39d$var$JiraSitesContext.Provider, {
        value: {
            jiraSitesFromAgg: jiraSitesFromAgg
        },
        children: children
    });
};

});

parcelRegister("lTaG1", function(module, exports) {
$parcel$export(module.exports, "LoggedInHeroSection", function () { return $27cf35ec8a7f1f0a$export$49c6370202c57ed1; });
/* logged-in-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $iSeHD = parcelRequire("iSeHD");

var $lqyi6 = parcelRequire("lqyi6");

var $eY3N6 = parcelRequire("eY3N6");

var $gqkLW = parcelRequire("gqkLW");

var $7GVWk = parcelRequire("7GVWk");

var $hnmMQ = parcelRequire("hnmMQ");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $1OyVz = parcelRequire("1OyVz");

var $aTTHV = parcelRequire("aTTHV");

var $kP8Dm = parcelRequire("kP8Dm");

var $3riD8 = parcelRequire("3riD8");

var $jUgJp = parcelRequire("jUgJp");

var $1YSly = parcelRequire("1YSly");

var $SWJer = parcelRequire("SWJer");

var $ly0rU = parcelRequire("ly0rU");
const $27cf35ec8a7f1f0a$var$TRACKING_EVENT_NAMES = {
    loggedInHeroProductCtaClicked: 'loggedInHeroProductCtaClicked',
    loggedInHeroAnotherSiteCtaClicked: 'loggedInHeroAnotherSiteCtaClicked',
    loggedInHeroExploreFeaturesClicked: 'loggedInHeroExploreFeaturesClicked',
    loggedInHeroCreateNewSiteClicked: 'loggedInHeroCreateNewSiteClicked'
};
const $27cf35ec8a7f1f0a$var$START_URL = 'https://start.atlassian.com';
const $27cf35ec8a7f1f0a$export$cbc42fadf8b93ea3 = {
    eventType: 'ui',
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'loggedInHero',
    source: '/software/jira'
};
const $27cf35ec8a7f1f0a$var$jswLoggedInCss = null;
const $27cf35ec8a7f1f0a$var$heroSectionCss = null;
const $27cf35ec8a7f1f0a$var$anchorContainer = null;
const $27cf35ec8a7f1f0a$var$jiraSiteBoxCss = null;
const $27cf35ec8a7f1f0a$var$headingCss = null;
const $27cf35ec8a7f1f0a$var$starCss = null;
const $27cf35ec8a7f1f0a$var$differentSiteCss = null;
const $27cf35ec8a7f1f0a$var$subHeadingContainerCss = null;
const $27cf35ec8a7f1f0a$var$createNewSiteAnchorCss = null;
const $27cf35ec8a7f1f0a$var$subHeadingCss = null;
const $27cf35ec8a7f1f0a$var$exploreFeaturesContainerCss = null;
const $27cf35ec8a7f1f0a$var$exploreFeaturesHeadingCss = null;
const $27cf35ec8a7f1f0a$var$exploreFeaturesCtaCss = null;
const $27cf35ec8a7f1f0a$var$nameUnderlineCss = null;
const $27cf35ec8a7f1f0a$var$inlineJiraLogoCss = null;
const $27cf35ec8a7f1f0a$var$siteInfoContainerCss = null;
const $27cf35ec8a7f1f0a$var$sitenameIconCss = null;
const $27cf35ec8a7f1f0a$var$sitenameIconTextCss = null;
const $27cf35ec8a7f1f0a$var$sitenameAndAvatarContainerCss = null;
const $27cf35ec8a7f1f0a$var$siteNameSpanCss = null;
const $27cf35ec8a7f1f0a$var$tooltipWrapperCss = null;
const $27cf35ec8a7f1f0a$var$avatarContainerCss = null;
const $27cf35ec8a7f1f0a$var$linkPlaceholderCss = null;
const $27cf35ec8a7f1f0a$export$49c6370202c57ed1 = ()=>{
    const loggedInUserProfile = (0, $3riD8.useLoggedInUser)();
    const { profile: profile, user: user } = (0, $7GVWk.useUserContext)();
    const { jiraSitesFromAgg: jiraSitesFromAgg } = (0, $ly0rU.useJiraSitesContext)();
    const [teammateAvatars, setTeammateAvatars] = (0, $1oC0p.useState)([]);
    const [totalUserCount, setTotalUserCount] = (0, $1oC0p.useState)();
    const intl = (0, $8e22h.default)();
    // GWP-10447: Check if the user is an SMB sales lead to adjust the hero CTA button variant
    const { isEligible: isSMBSalesLead } = (0, $aTTHV.useContactSalesCtaEligibility)();
    // Try to get name from props, and fallback to hook if needed
    const userFirstName = user.name?.split(' ')[0] ?? loggedInUserProfile.name?.split(' ')[0];
    // Try to get picture from props, and fallback to hook if needed
    const userPicture = user?.picture ?? loggedInUserProfile.picture;
    const avatars = jiraSitesFromAgg?.jira?.allJiraProjects.edges[0]?.node.assignableUsers.edges;
    (0, $1oC0p.useEffect)(()=>{
        setTeammateAvatars(jiraSitesFromAgg?.jira?.allJiraProjects.edges[0]?.node.assignableUsers.edges.filter((assignableUser)=>assignableUser.node.picture !== userPicture && assignableUser.node.accountStatus === 'active').map((assignableUser)=>{
            return assignableUser.node.picture ?? '';
        }) ?? []);
    }, [
        avatars,
        jiraSitesFromAgg?.jira?.allJiraProjects.edges,
        userPicture
    ]);
    (0, $1oC0p.useEffect)(()=>setTotalUserCount(jiraSitesFromAgg?.jira?.allJiraProjects.edges[0]?.node.assignableUsers.totalCount), [
        jiraSitesFromAgg?.jira?.allJiraProjects.edges
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const localizedTryLink = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=jira-software&createNew=true');
    const localizedProductGuideLink = (0, $jQ0cd.useLocalizedHref)('/software/jira/guides/getting-started/introduction');
    const [hasMultipleJiras, setHasMultipleJiras] = (0, $1oC0p.useState)(false);
    const [siteName, setSiteName] = (0, $1oC0p.useState)('');
    const [siteInitials, setSiteInitials] = (0, $1oC0p.useState)('');
    const [siteUrl, setSiteUrl] = (0, $1oC0p.useState)('');
    const { hasMultipleJiras: mostRecentHasMultipleJiras, siteName: mostRecentSiteName, siteUrl: mostRecentSiteUrl, siteInitials: mostRecentSiteInitials, cloudSiteId: mostRecentCloudSiteId, recentWorkUrl: mostRecentWorkUrl } = (0, $kP8Dm.useRecentJiraSite)();
    (0, $1oC0p.useEffect)(()=>{
        setHasMultipleJiras(mostRecentHasMultipleJiras);
        setSiteName(mostRecentSiteName);
        setSiteUrl(mostRecentSiteUrl);
        setSiteInitials(mostRecentSiteInitials);
    }, [
        mostRecentHasMultipleJiras,
        mostRecentSiteInitials,
        mostRecentSiteName,
        mostRecentSiteUrl
    ]);
    const loggedInHeroLoadedAnalyticsPayload = {
        eventType: 'ui',
        action: 'loaded',
        actionSubject: 'component',
        actionSubjectId: 'loggedInHero',
        source: '/software/jira',
        attributes: {
            atlasId: 'ATLAS-76385, ATLAS-93656'
        }
    };
    (0, $1oC0p.useEffect)(()=>{
        //if client side, fire analytics event
        if (typeof window !== 'undefined') createAnalyticsEvent({
            ...loggedInHeroLoadedAnalyticsPayload
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const clickHandler = (eventName)=>{
        createAnalyticsEvent({
            ...$27cf35ec8a7f1f0a$export$cbc42fadf8b93ea3,
            attributes: {
                eventName: eventName,
                url: window.location.href,
                atlasId: 'ATLAS-76385, ATLAS-93656'
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _11q71bjw _12vemgnk _1lrw1dfr _1e0c11p5 _yv0ehkll _4cvr1h6o _6a6z1h6o _18zr53f4 _1q5110yn _85i512am _1bsb1osq _1bhl10yn"
        ]),
        style: {
            "--_lwvw50": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue100'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm _syaz1pfd _1bsb1osq _p12fk3xj _ca0qgktf _u5f3gktf _n3tdgktf _19bvgktf _s51sidpf"
            ]),
            style: {
                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_t9ecuuzf _kqswstnw _1e0c1o8l _u7co1w81 _1e021vgi _1mjbglyw"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                        image: {
                            width: 88,
                            height: 70,
                            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/g06k378gucflnfse7s88i0365h14j40v.webp',
                            alt: ''
                        }
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                    className: (0, $2jatx.default)([
                        "_1wybckbl _vwz48vuz _k48p9y44 _ect41vau _6rtho7ao _bozgidpf _so7dldb6 _19q11ylp"
                    ]),
                    style: {
                        "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                    },
                    children: userFirstName ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "JiraSoftwarePageTemplate.loggedInHero.welcomeBackWithName",
                        defaultMessage: `Welcome back, {name}.`,
                        values: {
                            name: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_zg8l4jg8 _kqswh2mm _3p6m1sr6 _1v5vmgnk _14rnk6ds _19h91f51 _aetrb3bt _1qdggktf _1gufd439 _1czd12gs _g0nfmyb0 _18postnw _14tt14id _1ruvyjp0"
                                ]),
                                style: {
                                    "--_1p38jlt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.saffron400'))
                                },
                                children: userFirstName
                            })
                        }
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "JiraSoftwarePageTemplate.loggedInHero.welcomeBack",
                        defaultMessage: "Welcome back"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1n261g80 _gy1p53f4 _1bah1yb4 _4cvr1q9y"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_ect4z4z1 _1wybgktf _vwz41f4h _k48p1nn1"
                            ]),
                            style: {
                                "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "JiraSoftwarePageTemplate.loggedInHero.pickUpWhereYouLeftOffInProduct",
                                defaultMessage: "Pick up where you left off in <span>{product}</span>",
                                values: {
                                    product: 'Jira',
                                    // eslint-disable-next-line react/no-unstable-nested-components
                                    span: (text)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_1e0c1o8l _t9ec1jia _kqswh2mm _152tdlk8 _195g14id"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1OyVz.JiraMarkBrand), {})
                                                }),
                                                text
                                            ]
                                        })
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-testid": "createNewSiteAnchor",
                            href: localizedTryLink,
                            onClick: ()=>clickHandler($27cf35ec8a7f1f0a$var$TRACKING_EVENT_NAMES.loggedInHeroCreateNewSiteClicked),
                            className: (0, $2jatx.default)([
                                "_ect4z4z1 _1wyb7vkz _k48pni7l _vwz41f4h _syazu5k9"
                            ]),
                            style: {
                                "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                                "--_5dnsy5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue700'))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "WacSignupForm.createNewSite",
                                defaultMessage: "Create a new site"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _16jlkb7n _1wpz1fhb _1mougktf _158d1pfd _p1f31y44 _7s65grho"
                    ]),
                    style: {
                        "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            "data-activation-checklist-site-card": true,
                            className: (0, $2jatx.default)([
                                "_bfhk1afi _2rko1y44 _mrkb1tcb _1o0z1tcb _1bsb1osq _1ul91mjv _1e0c1txw _1bah1yb4 _2lx2vrvc _4cvr1h6o _19itgo0a _1rjc7vkz _18zr7vkz _kqswh2mm"
                            ]),
                            style: {
                                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jUgJp.JiraSiteContainer), {
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _2lx2vrvc _4cvr1h6o _4t3ivbgk _zulppxbi"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_11q716ye _2rko1b66 _1e0c1txw _1bah1h6o _4cvr1h6o _4t3ivbgk _1bsbvbgk _1ul9vbgk"
                                                ]),
                                                style: {
                                                    "--_alcc52": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.lime300'))
                                                },
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                                                    className: (0, $2jatx.default)([
                                                        "_syazsei6 _ect41vau _1wyb1ejb _k48pni7l _vwz41f4h _1dyznl7k _y3gn1h6o"
                                                    ]),
                                                    style: {
                                                        "--_rhsgef": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.lime800')),
                                                        "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                                                    },
                                                    children: siteInitials
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1e0c1txw _2lx21bp4 _1bah1h6o _zulp19bv _kqswh2mm _4t3ivbgk"
                                                ]),
                                                children: [
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                        className: (0, $2jatx.default)([
                                                            "_4t3igktf"
                                                        ]),
                                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gqkLW.default), {
                                                            content: siteName,
                                                            position: 'top-end',
                                                            mousePosition: "top",
                                                            tag: 'span',
                                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                                className: (0, $2jatx.default)([
                                                                    "_ect4z4z1 _1wybgktf _k48p1fw0 _4t3igktf _vwz41j6v _y3gn1e5h _1bto1l2s _o5721q9c _1reo15vq _18m915vq _1e0c1o8l _s7n4jp4b _uhd0uuw1 _1tssl1r9"
                                                                ]),
                                                                style: {
                                                                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                                                                },
                                                                children: siteName
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                        className: (0, $2jatx.default)([
                                                            "_4t3i1tcg _uhd0uuw1 _1tssl1r9"
                                                        ]),
                                                        children: userPicture && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1YSly.LoggedInProductTourAvatarFacepile), {
                                                            max: 4,
                                                            iconSize: 24,
                                                            icons: [
                                                                userPicture,
                                                                ...teammateAvatars
                                                            ],
                                                            totalUserCount: totalUserCount ?? 0
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                        "data-testid": "goToJiraButton",
                                        variant: isSMBSalesLead ? 'primary' : 'primary_alt',
                                        href: siteUrl,
                                        size: "small",
                                        onClick: ()=>clickHandler($27cf35ec8a7f1f0a$var$TRACKING_EVENT_NAMES.loggedInHeroProductCtaClicked),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                            id: "JiraSoftwarePageTemplate.loggedInHero.goToJira",
                                            defaultMessage: "Go to Jira"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $SWJer.ActivationChecklistLoggedInHeroPlacement), {
                            siteUrl: mostRecentSiteUrl,
                            cloudSiteId: mostRecentCloudSiteId,
                            recentWorkUrl: mostRecentWorkUrl,
                            existingSites: profile.attributes?.existingSites
                        })
                    ]
                }),
                hasMultipleJiras ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_ect4z4z1 _1pfho7ao _1wybdlk8 _k48p1nn1 _gu181h6o"
                    ]),
                    style: {
                        "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                        text: intl.formatMessage({
                            id: 'ConfluenceSoftwarePageTemplate.loggedInHero.lookingForDifferentSite',
                            defaultMessage: 'Looking for a different site?'
                        }),
                        href: $27cf35ec8a7f1f0a$var$START_URL,
                        type: "primary",
                        onClick: ()=>clickHandler($27cf35ec8a7f1f0a$var$TRACKING_EVENT_NAMES.loggedInHeroAnotherSiteCtaClicked)
                    })
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4t3iqslr"
                    ])
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1pfhvbgk _1e0c1txw _2lx21bp4 _4cvr1h6o _y3gn1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_ect4z4z1 _1wybgktf _vwz41f4h _k48p1nn1 _6rth7vkz"
                            ]),
                            style: {
                                "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "JiraSoftwarePageTemplate.loggedInHero.findOutMore",
                                defaultMessage: "Want to find out more about Jira?"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-testid": "exploreFeaturesAnchor",
                            href: localizedProductGuideLink,
                            onClick: ()=>clickHandler($27cf35ec8a7f1f0a$var$TRACKING_EVENT_NAMES.loggedInHeroExploreFeaturesClicked),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                className: (0, $2jatx.default)([
                                    "_ect4z4z1 _1wyb7vkz _k48pni7l _11q7glyw _r06hglyw _2rko1ul9 _ca0q19bv _u5f31ul9 _n3td19bv _19bv1ul9 _19it1axk _80omtlke"
                                ]),
                                style: {
                                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "jira-product-tour.staggered-double-feature-section.first-feature-link-text",
                                    defaultMessage: "Explore features"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
$27cf35ec8a7f1f0a$export$49c6370202c57ed1.displayName = 'LoggedInHeroSection';
var $27cf35ec8a7f1f0a$export$2e2bcd8739ae039 = $27cf35ec8a7f1f0a$export$49c6370202c57ed1;

});
parcelRegister("SWJer", function(module, exports) {
$parcel$export(module.exports, "ActivationChecklistLoggedInHeroPlacement", function () { return $ea8c3aa0bb1e4710$export$f01273f8b6af127f; });

var $7VQPk = parcelRequire("7VQPk");

var $2WL8B = parcelRequire("2WL8B");

var $kP8Dm = parcelRequire("kP8Dm");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $5Weqz = parcelRequire("5Weqz");
const $ea8c3aa0bb1e4710$export$f01273f8b6af127f = ({ siteUrl: siteUrl, cloudSiteId: cloudSiteId, recentWorkUrl: recentWorkUrl, existingSites: existingSites })=>{
    const gateEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).jiraWacActivationChecklistGate);
    const loggedInHasJira = (0, $2WL8B.useLoggedInHasJira)();
    if (gateEnabled !== true || loggedInHasJira !== true) return null;
    if (!cloudSiteId) return null;
    const jiraSite = (0, $kP8Dm.filterAvailableJiraSites)(existingSites).find((site)=>site.cloudId === cloudSiteId);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "data-activation-checklist-placement-root": true,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5Weqz.ActivationChecklistMainPlacement), {
            siteUrl: siteUrl,
            cloudSiteId: cloudSiteId,
            recentWorkUrl: recentWorkUrl,
            canInviteTeam: jiraSite?.hasAdminAccess === true
        })
    });
};
$ea8c3aa0bb1e4710$export$f01273f8b6af127f.displayName = 'ActivationChecklistLoggedInHeroPlacement';

});
parcelRegister("5Weqz", function(module, exports) {
$parcel$export(module.exports, "ActivationChecklistMainPlacement", function () { return $20cc2100df4398cb$export$29eb3204b6e64a09; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $hCc2m = parcelRequire("hCc2m");

var $2WL8B = parcelRequire("2WL8B");

var $hgaI1 = parcelRequire("hgaI1");

var $j2b52 = parcelRequire("j2b52");

var $4X0dO = parcelRequire("4X0dO");

var $gIKKj = parcelRequire("gIKKj");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

const $20cc2100df4398cb$var$LazyActivationChecklistPostOfficeMount = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>(parcelRequire("7nyYg")).then(({ ActivationChecklistPostOfficeMount: ActivationChecklistPostOfficeMount })=>({
            default: ActivationChecklistPostOfficeMount
        })));
const $20cc2100df4398cb$var$useActivationChecklistEnrollment = ({ cloudSiteId: cloudSiteId, experimentConfig: experimentConfig })=>{
    const isInTargetSiteCohort = (0, $2WL8B.useLoggedInHasJiraSiteD1toD14)(cloudSiteId);
    const experimentForTargetSite = (0, $1oC0p.useMemo)(()=>({
            ...experimentConfig,
            options: {
                ...experimentConfig.options,
                fireExperimentExposure: false
            },
            targeting: {
                cohort: ()=>isInTargetSiteCohort
            }
        }), [
        experimentConfig,
        isInTargetSiteCohort
    ]);
    const exposureMetadata = (0, $1oC0p.useMemo)(()=>({
            tenantId: cloudSiteId,
            cloudSiteId: cloudSiteId
        }), [
        cloudSiteId
    ]);
    const experiment = (0, $gIKKj.useExperiment)(experimentForTargetSite, exposureMetadata);
    const updateTenantId = (0, $hgaI1.useUpdateFeatureGatesClientWithTenantId)();
    const exposureFired = (0, $1oC0p.useRef)(false);
    (0, $1oC0p.useEffect)(()=>{
        if (exposureFired.current || experiment.type !== (0, $gIKKj.EnrollmentType).ENROLLED) return;
        let isCancelled = false;
        const syncTenantContextAndFireExposure = async ()=>{
            const bootstrapValues = typeof window !== 'undefined' ? window.featureGateBootstrapValues : undefined;
            if (bootstrapValues && bootstrapValues.identifiers?.tenantId !== cloudSiteId) await updateTenantId({
                cloudId: cloudSiteId
            });
            if (!isCancelled && !exposureFired.current) {
                experiment.fireExposure();
                exposureFired.current = true;
            }
        };
        syncTenantContextAndFireExposure();
        return ()=>{
            isCancelled = true;
        };
    }, [
        cloudSiteId,
        experiment,
        updateTenantId
    ]);
    return experiment;
};
const $20cc2100df4398cb$var$useActivationChecklistLaunchEnrollment = (cloudSiteId)=>$20cc2100df4398cb$var$useActivationChecklistEnrollment({
        cloudSiteId: cloudSiteId,
        experimentConfig: (0, $4X0dO.experiments).jiraWacActivationChecklist
    });
const $20cc2100df4398cb$export$29eb3204b6e64a09 = (props)=>{
    const experiment = $20cc2100df4398cb$var$useActivationChecklistLaunchEnrollment(props.cloudSiteId);
    const isEligible = experiment.type === (0, $gIKKj.EnrollmentType).ENROLLED && experiment.value === true;
    if (!isEligible) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j2b52.ClientOnly), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hCc2m.default), {
            fallback: null,
            interactionName: "wac-activation-checklist-placement",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)($20cc2100df4398cb$var$LazyActivationChecklistPostOfficeMount, {
                ...props
            })
        })
    });
};
const $20cc2100df4398cb$export$4e2ffbab462c781a = (props)=>{
    const { cloudSiteId: cloudSiteId } = props;
    const gateEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).jiraWacActivationChecklistGate);
    const loggedInHasJira = (0, $2WL8B.useLoggedInHasJira)();
    if (gateEnabled !== true || loggedInHasJira !== true) return null;
    if (!cloudSiteId) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)($20cc2100df4398cb$export$29eb3204b6e64a09, {
        ...props,
        cloudSiteId: cloudSiteId
    });
};
$20cc2100df4398cb$export$4e2ffbab462c781a.displayName = 'ActivationChecklistPlacement';
var $20cc2100df4398cb$export$2e2bcd8739ae039 = $20cc2100df4398cb$export$4e2ffbab462c781a;

});
parcelRegister("7nyYg", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = Promise.all([
    $eao4m("69oGP"),
    $eao4m("lwKSX"),
    $eao4m("ch50F"),
    $eao4m("5lMXK")
]).then(()=>parcelRequire('6wGS9'));

});




parcelRegister("jmYmp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $32c81aeeb0653afd$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $gNdrj = parcelRequire("gNdrj");

var $7GVWk = parcelRequire("7GVWk");

var $eOIix = parcelRequire("eOIix");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $gn6Qa = parcelRequire("gn6Qa");

var $ly0rU = parcelRequire("ly0rU");
const $32c81aeeb0653afd$var$JiraLogo = ()=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "jira",
        type: "logo",
        appearance: "brand",
        darkTheme: isDarkTheme
    });
};
const $32c81aeeb0653afd$var$SoftwareJiraLoggedInNavbar = ()=>{
    const intl = (0, $8e22h.default)();
    const logoUrl = (0, $jQ0cd.useLocalizedHref)('/software/jira');
    const { profile: profile } = (0, $7GVWk.useUserContext)();
    const { jiraSitesFromAgg: jiraSitesFromAgg } = (0, $ly0rU.useJiraSitesContext)();
    const [siteUrl, setSiteUrl] = (0, $1oC0p.useState)('');
    (0, $1oC0p.useEffect)(()=>{
        const site = profile?.attributes?.existingSites[0];
        let tempSiteUrl = site?.url;
        if (jiraSitesFromAgg?.jira.allJiraProjects.edges.length === 1) tempSiteUrl = jiraSitesFromAgg?.jira.allJiraProjects?.edges[0]?.node?.webUrl;
        setSiteUrl(tempSiteUrl ?? '');
    }, [
        jiraSitesFromAgg?.jira.allJiraProjects.edges,
        jiraSitesFromAgg?.jira.allJiraProjects.edges.length,
        profile?.attributes?.existingSites,
        profile?.attributes?.existingSites.length
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gNdrj.JiraSmartBanner), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gn6Qa.ProductPageNav), {
                productLogoUrl: logoUrl,
                productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($32c81aeeb0653afd$var$JiraLogo, {}),
                productLogoAriaLabel: intl.formatMessage({
                    id: 'wacJiraSoftwareNavigation.logo-label',
                    defaultMessage: 'Jira Software logo'
                }),
                mobileCtaText: intl.formatMessage({
                    id: 'JiraSoftwarePageTemplate.navbar.goToJira',
                    defaultMessage: 'Go to Jira'
                }),
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                mobileCtaOnClick: ()=>{},
                mobileCtaUrl: siteUrl,
                mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($32c81aeeb0653afd$var$JiraLogo, {}),
                navigationTrynowCtaText: intl.formatMessage({
                    id: 'JiraFeatureSoftwarePageTemplate.navbar.goToJira',
                    defaultMessage: 'Go to Jira'
                }),
                navigationTrynowCtaUrl: siteUrl,
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                navigationTrynowCtaOnClick: ()=>{},
                productPageNavLinks: [],
                mobileLinksSections: [],
                isShowSearchButton: false,
                isShowAppSwitcher: false,
                isShowTabletDropdown: false
            })
        ]
    });
};
var $32c81aeeb0653afd$export$2e2bcd8739ae039 = $32c81aeeb0653afd$var$SoftwareJiraLoggedInNavbar;

});
parcelRegister("gNdrj", function(module, exports) {
$parcel$export(module.exports, "JiraSmartBanner", function () { return $a6aa00f5612804c5$export$2620a3c848917338; });
/* jira-smart-banner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $63bv7 = parcelRequire("63bv7");

var $2WL8B = parcelRequire("2WL8B");

var $2gCne = parcelRequire("2gCne");

var $ivETl = parcelRequire("ivETl");

var $lnHkK = parcelRequire("lnHkK");
const $a6aa00f5612804c5$var$STORAGE_KEY = 'SmartBanner_dismiss-jira';
const $a6aa00f5612804c5$var$DISMISS_EXPIRY = 86400;
const $a6aa00f5612804c5$var$IOS_APP_STORE_URL = 'https://apps.apple.com/app/jira-cloud/id1006972087';
const $a6aa00f5612804c5$var$APPLE_APP_ID = '1006972087';
// Android Intent URL with built-in Play Store fallback
const $a6aa00f5612804c5$var$ANDROID_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.atlassian.android.jira.core';
const $a6aa00f5612804c5$var$ANDROID_INTENT_URL = `intent://home#Intent;scheme=jira;package=com.atlassian.android.jira.core;S.browser_fallback_url=${encodeURIComponent($a6aa00f5612804c5$var$ANDROID_PLAY_STORE_URL)};end`;
const $a6aa00f5612804c5$export$2620a3c848917338 = ({ className: className })=>{
    const { isMobile: isMobile, isAndroid: isAndroid, isMobileSafari: isMobileSafari } = (0, $ivETl.useDeviceInfo)();
    const [isDismissed, setIsDismissed] = (0, $1oC0p.useState)(true);
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const isSoftwareJiraPath = (0, $2WL8B.useIsSoftwareJiraPath)();
    // iOS Safari does not render our custom banner; instead it uses Apple's
    // native Smart App Banner, which is driven by an `apple-itunes-app` meta tag.
    // Only inject it once useIsSoftwareJiraPath confirms the user is on a Jira
    // software path with a Jira instance — the same gate as the custom banner.
    (0, $1oC0p.useEffect)(()=>{
        if (isMobileSafari && isSoftwareJiraPath) {
            const meta = document.createElement('meta');
            meta.name = 'apple-itunes-app';
            meta.content = `app-id=${$a6aa00f5612804c5$var$APPLE_APP_ID}, ct=wac_smart_banner`;
            document.head.appendChild(meta);
            return ()=>{
                if (meta.parentNode) meta.parentNode.removeChild(meta);
            };
        }
    }, [
        isMobileSafari,
        isSoftwareJiraPath
    ]);
    (0, $1oC0p.useEffect)(()=>{
        const dismissValue = (0, $2gCne.getLocalStorage)($a6aa00f5612804c5$var$STORAGE_KEY, true);
        if (dismissValue !== '1') setIsDismissed(false);
    }, []);
    const handleClose = ()=>{
        setIsDismissed(true);
        (0, $2gCne.setLocalStorage)($a6aa00f5612804c5$var$STORAGE_KEY, '1', $a6aa00f5612804c5$var$DISMISS_EXPIRY);
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'smartBannerClose',
            eventType: 'ui',
            attributes: {
                productKey: 'jira',
                eventContainer: 'smartBanner'
            }
        }).fire();
    };
    const getDeepLinkUrl = (0, $1oC0p.useCallback)(()=>{
        if (isAndroid) return $a6aa00f5612804c5$var$ANDROID_INTENT_URL;
        return $a6aa00f5612804c5$var$IOS_APP_STORE_URL;
    }, [
        isAndroid
    ]);
    if (!isMobile || isDismissed || isMobileSafari || !isSoftwareJiraPath) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lnHkK.SmartBanner), {
        appIcon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.JiraIcon), {
            appearance: "brand",
            size: "medium"
        }),
        title: intl.formatMessage({
            id: 'JiraSmartBanner.title',
            defaultMessage: 'Get the Jira app'
        }),
        subtitle: intl.formatMessage({
            id: 'JiraSmartBanner.subtitle',
            defaultMessage: 'Track tasks, projects, and work'
        }),
        buttonText: intl.formatMessage({
            id: 'JiraSmartBanner.buttonText',
            defaultMessage: 'OPEN'
        }),
        buttonHref: getDeepLinkUrl(),
        buttonAriaLabel: intl.formatMessage({
            id: 'JiraSmartBanner.buttonAriaLabel',
            defaultMessage: 'Open Jira app'
        }),
        onClose: handleClose,
        className: className,
        dataEventProps: {
            'data-product-key': 'jira',
            'data-event-container': 'smartBanner',
            'data-label': 'OPEN',
            'data-label-english': 'OPEN'
        }
    });
};
var $a6aa00f5612804c5$export$2e2bcd8739ae039 = $a6aa00f5612804c5$export$2620a3c848917338;

});



parcelRegister("gHXqX", function(module, exports) {
$parcel$export(module.exports, "LoggedOutOrNoJiraProductTourOverview", function () { return $9c557963d1338261$export$94dc3fb7b045f547; });
/* jira-software-logged-out-page.template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $bQjAr = parcelRequire("bQjAr");

var $2WL8B = parcelRequire("2WL8B");

var $kbpa7 = parcelRequire("kbpa7");

var $l4vdU = parcelRequire("l4vdU");

var $5S2vX = parcelRequire("5S2vX");

var $8IN8s = parcelRequire("8IN8s");

var $iKNCS = parcelRequire("iKNCS");

var $Tm4Gw = parcelRequire("Tm4Gw");

var $73ThH = parcelRequire("73ThH");

var $4AJjX = parcelRequire("4AJjX");

var $ihq7I = parcelRequire("ihq7I");

var $iFk4q = parcelRequire("iFk4q");

var $fCRLS = parcelRequire("fCRLS");

var $bRgjW = parcelRequire("bRgjW");

var $dS67T = parcelRequire("dS67T");

var $1UnBI = parcelRequire("1UnBI");

var $1i0Tw = parcelRequire("1i0Tw");

var $6PlQY = parcelRequire("6PlQY");
const $9c557963d1338261$export$94dc3fb7b045f547 = ()=>{
    const isLoggedOut = (0, $2WL8B.useLoggedOut)();
    let heroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1i0Tw.NoJiraHeroSection), {});
    if (isLoggedOut) heroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1UnBI.LoggedOutHeroSection), {});
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $bQjAr.default), {
        name: "logged-out-no-jira-product-tour",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $Tm4Gw.JiraSoftwarePageBannerAlert), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l4vdU.default), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8IN8s.default), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("main", {
                "data-testid": "loggedOutNoJira",
                id: "content",
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _1reo15vq _18m915vq"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
                    scrollTrackingEnabled: true,
                    pageId: "Jira",
                    children: [
                        heroSection,
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $73ThH.GartnerSection), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bRgjW.JswCollaborateSection), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iKNCS.AiRefreshSection), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4AJjX.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dS67T.JswDoubleFeatureSection), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fCRLS.IntegrationsSection), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_bfhk5hrz"
                            ]),
                            style: {
                                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                            },
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6PlQY.TestimonialSection), {}),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ihq7I.ClosingBanner), {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iFk4q.Footer), {})
                    ]
                })
            })
        ]
    });
};
const $9c557963d1338261$var$sectionContainerStyles = null;
const $9c557963d1338261$var$backgroundStyles = null;

});
parcelRegister("8IN8s", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f81b8289a3c24944$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $20OkY = parcelRequire("20OkY");

var $asbmK = parcelRequire("asbmK");

var $gNdrj = parcelRequire("gNdrj");

var $eOIix = parcelRequire("eOIix");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $cR2Ov = parcelRequire("cR2Ov");

var $9KOR3 = parcelRequire("9KOR3");

var $gn6Qa = parcelRequire("gn6Qa");

var $cB958 = parcelRequire("cB958");

var $1jBLM = parcelRequire("1jBLM");
const $f81b8289a3c24944$var$JiraLogo = ()=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "jira",
        type: "logo",
        appearance: "brand",
        darkTheme: isDarkTheme
    });
};
const $f81b8289a3c24944$var$JiraSoftwareNav = ({ productNavCtaCTAClickFunction: productNavCtaCTAClickFunction, isUseOpenCrossFlow: isUseOpenCrossFlow = false })=>{
    const intl = (0, $8e22h.default)();
    const ctaText = intl.formatMessage({
        id: 'JiraFeatureSoftwarePageTemplate.navbar.getItFree',
        defaultMessage: 'Get it free'
    });
    const signupLink = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=jira-software&edition=free');
    const { openCrossFlow: openCrossFlow } = (0, $asbmK.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).JIRA_SOFTWARE,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const productNavOnClick = (0, $1oC0p.useMemo)(()=>productNavCtaCTAClickFunction && isUseOpenCrossFlow ? productNavCtaCTAClickFunction : openCrossFlow, [
        openCrossFlow,
        productNavCtaCTAClickFunction,
        isUseOpenCrossFlow
    ]);
    const solutionsDropdownStyles = (0, $1oC0p.useMemo)(()=>{
        return {
            width: 'fit-content !important',
            margin: 0
        };
    }, []);
    // Teams Hrefs
    const marketingHref = (0, $jQ0cd.useLocalizedHref)('/jira/solutions/marketing');
    const engineeringHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/dev');
    const designHref = (0, $jQ0cd.useLocalizedHref)('/jira/solutions/design');
    const operationsHref = (0, $jQ0cd.useLocalizedHref)('/jira/solutions/operations');
    const itHref = (0, $jQ0cd.useLocalizedHref)('/jira/solutions/it');
    // Use Cases Hrefs
    const gettingStartedHref = (0, $jQ0cd.useLocalizedHref)('https://community.atlassian.com/learning/hub/jira');
    const planningHref = (0, $jQ0cd.useLocalizedHref)('/jira/solutions/planning');
    const campaignManagementHref = (0, $jQ0cd.useLocalizedHref)('/jira/solutions/campaign-management');
    const agileProjectManagementHref = (0, $jQ0cd.useLocalizedHref)('/jira/solutions/agile-project-management');
    const programManagementHref = (0, $jQ0cd.useLocalizedHref)('/jira/solutions/program-management');
    //Company Size Hrefs
    const enterpriseHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/enterprise');
    const solutionsDropdown = (0, $1oC0p.useMemo)(()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
            contentSections: [
                {
                    header: intl.formatMessage({
                        id: 'software-jira.navbar.solutions.teams.header',
                        defaultMessage: 'Teams'
                    }),
                    links: [
                        {
                            text: intl.formatMessage({
                                id: 'software-jira.navbar.solutions.teams.marketing',
                                defaultMessage: 'Marketing'
                            }),
                            href: marketingHref
                        },
                        {
                            text: intl.formatMessage({
                                id: 'software-jira.navbar.solutions.teams.engineering',
                                defaultMessage: 'Engineering'
                            }),
                            href: engineeringHref
                        },
                        {
                            text: intl.formatMessage({
                                id: 'software-jira.navbar.solutions.teams.design',
                                defaultMessage: 'Design'
                            }),
                            href: designHref
                        },
                        {
                            text: intl.formatMessage({
                                id: 'software-jira.navbar.solutions.teams.operations',
                                defaultMessage: 'Operations'
                            }),
                            href: operationsHref
                        },
                        {
                            text: intl.formatMessage({
                                id: 'software-jira.navbar.solutions.teams.it',
                                defaultMessage: 'IT'
                            }),
                            href: itHref
                        }
                    ]
                },
                {
                    header: intl.formatMessage({
                        id: 'software-jira.navbar.solutions.useCases.header',
                        defaultMessage: 'Use Cases'
                    }),
                    links: [
                        {
                            text: intl.formatMessage({
                                id: 'software-jira.navbar.solutions.useCases.getting-started',
                                defaultMessage: 'Getting started'
                            }),
                            href: gettingStartedHref
                        },
                        {
                            text: intl.formatMessage({
                                id: 'software-jira.navbar.solutions.useCases.planning',
                                defaultMessage: 'Planning'
                            }),
                            href: planningHref
                        },
                        {
                            text: intl.formatMessage({
                                id: 'software-jira.navbar.solutions.useCases.campaign-management',
                                defaultMessage: 'Campaign Management'
                            }),
                            href: campaignManagementHref
                        },
                        {
                            text: intl.formatMessage({
                                id: 'software-jira.navbar.solutions.useCases.agile-project-management',
                                defaultMessage: 'Agile Project Management'
                            }),
                            href: agileProjectManagementHref
                        },
                        {
                            text: intl.formatMessage({
                                id: 'software-jira.navbar.solutions.useCases.program-management',
                                defaultMessage: 'Program Management'
                            }),
                            href: programManagementHref
                        }
                    ]
                },
                {
                    header: intl.formatMessage({
                        id: 'software-jira.navbar.solutions.companySize.header',
                        defaultMessage: 'Company Size'
                    }),
                    links: [
                        {
                            text: intl.formatMessage({
                                id: 'software-jira.navbar.solutions.companySize.enterprise',
                                defaultMessage: 'Enterprise'
                            }),
                            href: enterpriseHref
                        }
                    ]
                }
            ]
        }), [
        intl,
        gettingStartedHref,
        marketingHref,
        engineeringHref,
        designHref,
        operationsHref,
        itHref,
        planningHref,
        campaignManagementHref,
        agileProjectManagementHref,
        programManagementHref,
        enterpriseHref
    ]);
    const guidesHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/guides/getting-started/introduction');
    const pricingHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/pricing');
    const productLogoHref = (0, $jQ0cd.useLocalizedHref)('/software/jira');
    const templatesLinkContent = (0, $1oC0p.useMemo)(()=>{
        return {
            globalLinksKey: 'templates',
            linkText: intl.formatMessage({
                id: 'software-jira.navbar.templates',
                defaultMessage: 'Templates'
            }),
            productKey: 'jira',
            hasDropdown: true,
            content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1jBLM.TemplateCategoriesDropdown), {}),
            dropdownType: 'templates',
            containerPosition: 'relative'
        };
    }, [
        intl
    ]);
    const featuresLinkContent = (0, $1oC0p.useMemo)(()=>({
            globalLinksKey: 'features',
            linkText: intl.formatMessage({
                id: 'software-jira.navbar.features',
                defaultMessage: 'Features'
            }),
            productKey: 'jira',
            hasDropdown: true,
            content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cB958.FeaturesDropdown), {}),
            dropdownType: 'features',
            containerPosition: 'relative'
        }), [
        intl
    ]);
    const links = (0, $1oC0p.useMemo)(()=>[
            featuresLinkContent,
            {
                globalLinksKey: 'solutions',
                linkText: intl.formatMessage({
                    id: 'software-jira.navbar.solutions',
                    defaultMessage: 'Solutions'
                }),
                hasDropdown: true,
                productKey: 'jira',
                containerPosition: 'relative',
                containerStyles: solutionsDropdownStyles,
                dropdownType: 'solutions',
                content: solutionsDropdown
            },
            {
                globalLinksKey: 'guides',
                linkText: intl.formatMessage({
                    id: 'software-jira.navbar.guides',
                    defaultMessage: 'Guides'
                }),
                hasDropdown: false,
                productKey: 'jira',
                href: guidesHref
            },
            templatesLinkContent,
            {
                globalLinksKey: 'pricing',
                linkText: intl.formatMessage({
                    id: 'software-jira.navbar.pricing',
                    defaultMessage: 'Pricing'
                }),
                hasDropdown: false,
                productKey: 'jira',
                href: pricingHref
            }
        ], [
        intl,
        featuresLinkContent,
        templatesLinkContent,
        solutionsDropdown,
        solutionsDropdownStyles,
        guidesHref,
        pricingHref
    ]);
    const globalNavItemKeys = (0, $1oC0p.useMemo)(()=>{
        return links.map((link)=>link.globalLinksKey);
    }, [
        links
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gNdrj.JiraSmartBanner), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.GlobalNavProvider), {
                globalNavItemKeys: globalNavItemKeys,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gn6Qa.ProductPageNav), {
                    productLogoUrl: productLogoHref,
                    productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($f81b8289a3c24944$var$JiraLogo, {}),
                    productLogoAriaLabel: intl.formatMessage({
                        id: 'wacJiraSoftwareNavigation.logo-label',
                        defaultMessage: 'Jira Software logo'
                    }),
                    mobileCtaText: intl.formatMessage({
                        id: 'JiraeSoftwarePageTemplate.navbar.getitfree',
                        defaultMessage: 'Get it free'
                    }),
                    mobileCtaUrl: signupLink,
                    mobileCtaOnClick: (e)=>{
                        if (productNavOnClick) productNavOnClick(e);
                    },
                    mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($f81b8289a3c24944$var$JiraLogo, {}),
                    navigationTrynowCtaText: ctaText,
                    navigationTrynowCtaUrl: signupLink,
                    navigationTrynowCtaOnClick: (e)=>{
                        if (productNavOnClick) productNavOnClick(e);
                    },
                    productPageNavLinks: links,
                    mobileLinksSections: [
                        {
                            mobileLinkKey: 'mobile-jira',
                            mobileLinksProps: links
                        }
                    ],
                    additionalMenuPageObjectsArray: [
                        {
                            menuPageKey: 'features',
                            menuPageObjects: links.find((link)=>link.globalLinksKey === 'features')?.content
                        },
                        {
                            menuPageKey: 'solutions',
                            menuPageObjects: links.find((link)=>link.globalLinksKey === 'solutions')?.content
                        },
                        {
                            menuPageKey: 'templates',
                            menuPageObjects: links.find((link)=>link.globalLinksKey === 'templates')?.content
                        }
                    ]
                })
            })
        ]
    });
};
$f81b8289a3c24944$var$JiraSoftwareNav.displayName = 'JiraSoftwareNav';
var $f81b8289a3c24944$export$2e2bcd8739ae039 = $f81b8289a3c24944$var$JiraSoftwareNav;

});
parcelRegister("cB958", function(module, exports) {
$parcel$export(module.exports, "FeaturesDropdown", function () { return $ea82a2d484c53cd9$export$ad0d22100914784b; });
// @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $jQ0cd = parcelRequire("jQ0cd");

var $cR2Ov = parcelRequire("cR2Ov");
const $ea82a2d484c53cd9$export$ad0d22100914784b = ()=>{
    const intl = (0, $8e22h.default)();
    const allFeaturesLink = {
        text: intl.formatMessage({
            id: 'jira.FeaturesDropdown.allFeatures',
            defaultMessage: 'All Features'
        }),
        href: (0, $jQ0cd.useLocalizedHref)('/software/jira/features')
    };
    const featureLinks = [
        {
            text: intl.formatMessage({
                id: 'jira.FeaturesDropdown.rovo',
                defaultMessage: 'Rovo in Jira'
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/software/jira/ai')
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
        orientation: "column",
        contentSections: [
            {
                links: [
                    allFeaturesLink,
                    ...featureLinks
                ]
            }
        ]
    });
};

});

parcelRegister("1jBLM", function(module, exports) {
$parcel$export(module.exports, "TemplateCategoriesDropdown", function () { return $6235f0ca21d73c59$export$8bb7e16f8f8a7ba6; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $jQ0cd = parcelRequire("jQ0cd");

var $cR2Ov = parcelRequire("cR2Ov");

var $bhzuC = parcelRequire("bhzuC");
const $6235f0ca21d73c59$export$8bb7e16f8f8a7ba6 = ()=>{
    const intl = (0, $8e22h.default)();
    const { data: data } = (0, $bhzuC.useJiraTemplateCategories)();
    const getLocalizedHref = (0, $jQ0cd.useLocalizedHref);
    const allTemplateLink = {
        text: intl.formatMessage({
            id: 'ira.TemplateCategoriesDropdown.allTemplates',
            defaultMessage: 'All templates'
        }),
        href: (0, $jQ0cd.useLocalizedHref)('/software/jira/templates')
    };
    const templateLinks = data.map((category)=>({
            text: category.categoryNameExternal,
            href: getLocalizedHref(`/software/jira/templates/${category.urlSlug}`)
        }));
    const jsmTemplatesLink = {
        text: intl.formatMessage({
            id: 'Jira.TemplateCategoriesDropdown.JiraServiceManagementTemplates',
            defaultMessage: 'Jira Service Management templates'
        }),
        href: (0, $jQ0cd.useLocalizedHref)('/software/jira/templates/service-management'),
        anchorProps: {
            target: '_blank'
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
        orientation: "column",
        contentSections: [
            {
                links: [
                    allTemplateLink,
                    ...templateLinks
                ]
            },
            {
                links: [
                    jsmTemplatesLink
                ]
            }
        ]
    });
};

});
parcelRegister("bhzuC", function(module, exports) {
$parcel$export(module.exports, "useJiraTemplateCategories", function () { return $d5e332dcdb267cf7$export$ef1e726410cc2d37; });

var $1oC0p = parcelRequire("1oC0p");

var $17RBn = parcelRequire("17RBn");

var $kf4PU = parcelRequire("kf4PU");

var $614MQ = parcelRequire("614MQ");
// cache data per locale to optimize duplicate queries
const $d5e332dcdb267cf7$var$cache = new Map();
const $d5e332dcdb267cf7$export$d2adf65b87e47523 = ()=>{
    $d5e332dcdb267cf7$var$cache.clear();
};
const $d5e332dcdb267cf7$export$ef1e726410cc2d37 = ()=>{
    const locale = (0, $17RBn.useLocale)();
    const mappedLocale = (0, $kf4PU.WAC_TO_CPAPI_LOCALE_MAP)[locale];
    // initialize state from cache if available
    const cacheEntry = mappedLocale ? $d5e332dcdb267cf7$var$cache.get(mappedLocale) : undefined;
    const [data, setData] = (0, $1oC0p.useState)(cacheEntry?.data ?? []);
    const [loading, setLoading] = (0, $1oC0p.useState)(false);
    const [error, setError] = (0, $1oC0p.useState)(null);
    (0, $1oC0p.useEffect)(()=>{
        // if we don't have a mapped locale, do nothing
        if (!mappedLocale) return;
        const existingCache = $d5e332dcdb267cf7$var$cache.get(mappedLocale);
        // if we already have cached data, use it
        if (existingCache?.data && !existingCache.promise) {
            setData(existingCache.data);
            return;
        }
        // if a fetch is already in progress, wait for it
        if (existingCache?.promise) {
            setLoading(true);
            existingCache.promise.then((items)=>{
                setData(items);
                setLoading(false);
            }).catch((err)=>{
                setError(err);
                setLoading(false);
            });
            return;
        }
        // start a new fetch
        setLoading(true);
        setError(null);
        const fetchPromise = (0, $614MQ.getTemplateCategories)({
            // @ts-ignore
            locale: mappedLocale
        }).then((response)=>{
            const items = response.taxonomyTemplateCategoryCollection.items ?? [];
            // update cache with data and clear promise
            $d5e332dcdb267cf7$var$cache.set(mappedLocale, {
                data: items,
                promise: null
            });
            setData(items);
            setLoading(false);
            return items;
        }).catch((err)=>{
            // clear promise on error
            const entry = $d5e332dcdb267cf7$var$cache.get(mappedLocale);
            if (entry) entry.promise = null;
            setError(err);
            setLoading(false);
            throw err;
        });
        // store the in-flight promise
        $d5e332dcdb267cf7$var$cache.set(mappedLocale, {
            data: existingCache?.data ?? [],
            promise: fetchPromise
        });
    }, [
        locale,
        mappedLocale
    ]);
    return {
        data: data,
        loading: loading,
        error: error
    };
};

});
parcelRegister("614MQ", function(module, exports) {
$parcel$export(module.exports, "getTemplateCategories", function () { return $8003fdfd77cf038c$export$819167f3de5f32cb; });

var $kXfPT = parcelRequire("kXfPT");

var $eRzlV = parcelRequire("eRzlV");
const $8003fdfd77cf038c$var$JIRA_PRODUCT_INTERNAL_TITLE = 'Jira Cloud Product';
const $8003fdfd77cf038c$export$52bf0b65d881440d = (0, $kXfPT.gql)`
query ($locale: String) {
  taxonomyTemplateCategoryCollection(
    locale: $locale
    limit: 100,
    where: {
      product: {
        internalTitle: "${$8003fdfd77cf038c$var$JIRA_PRODUCT_INTERNAL_TITLE}"
      }
    }
    # for the short-term, sort-ordering is done via the internal-name
    # todo: GWP-6125 implement a long term sort-ordering solution
    order: categoryNameInternal_ASC
  ) {
    items {
      sys {
        id
      }
      categoryNameInternal
      categoryNameExternal
      urlSlug
    }
  }
}
`;
const $8003fdfd77cf038c$export$819167f3de5f32cb = (args)=>{
    const { locale: locale } = args;
    return (0, $kXfPT.request)({
        url: (0, $eRzlV.CONTENTFUL_GRAPHQL_API_URL),
        document: $8003fdfd77cf038c$export$52bf0b65d881440d,
        variables: {
            locale: locale
        },
        requestHeaders: {
            Authorization: `Bearer ${window.CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES}`
        }
    });
};

});
parcelRegister("kXfPT", function(module, exports) {
$parcel$export(module.exports, "request", function () { return $f4159a034cc4c190$export$b5fe3f66a567bec0; });
$parcel$export(module.exports, "gql", function () { return $f4159a034cc4c190$export$72e4926bf8358653; });

var $eLb04 = parcelRequire("eLb04");

var $haH5f = parcelRequire("haH5f");

var $fSIns = parcelRequire("fSIns");

var $Xz7Q6 = parcelRequire("Xz7Q6");

var $1iZL3 = parcelRequire("1iZL3");

var $6FOC8 = parcelRequire("6FOC8");

var $fuprL = parcelRequire("fuprL");
/**
 * Convert the given headers configuration into a plain object.
 */ const $f4159a034cc4c190$var$resolveHeaders = (headers)=>{
    let oHeaders = {};
    if (headers) {
        if (typeof Headers !== `undefined` && headers instanceof Headers || $6FOC8 && $6FOC8.Headers && headers instanceof $6FOC8.Headers) oHeaders = (0, $haH5f.HeadersInstanceToPlainObject)(headers);
        else if (Array.isArray(headers)) headers.forEach(([name, value])=>{
            if (name && value !== undefined) oHeaders[name] = value;
        });
        else oHeaders = headers;
    }
    return oHeaders;
};
/**
 * Clean a GraphQL document to send it via a GET query
 */ const $f4159a034cc4c190$var$cleanQuery = (str)=>str.replace(/([\s,]|#[^\n\r]+)+/g, ` `).trim();
/**
 * Create query string for GraphQL request
 */ const $f4159a034cc4c190$var$buildRequestConfig = (params)=>{
    if (!Array.isArray(params.query)) {
        const params_ = params;
        const search = [
            `query=${encodeURIComponent($f4159a034cc4c190$var$cleanQuery(params_.query))}`
        ];
        if (params.variables) search.push(`variables=${encodeURIComponent(params_.jsonSerializer.stringify(params_.variables))}`);
        if (params_.operationName) search.push(`operationName=${encodeURIComponent(params_.operationName)}`);
        return search.join(`&`);
    }
    if (typeof params.variables !== `undefined` && !Array.isArray(params.variables)) throw new Error(`Cannot create query with given variable type, array expected`);
    // Batch support
    const params_ = params;
    const payload = params.query.reduce((acc, currentQuery, index)=>{
        acc.push({
            query: $f4159a034cc4c190$var$cleanQuery(currentQuery),
            variables: params_.variables ? params_.jsonSerializer.stringify(params_.variables[index]) : undefined
        });
        return acc;
    }, []);
    return `query=${encodeURIComponent(params_.jsonSerializer.stringify(payload))}`;
};
const $f4159a034cc4c190$var$createHttpMethodFetcher = (method)=>async (params)=>{
        const { url: url, query: query, variables: variables, operationName: operationName, fetch: fetch, fetchOptions: fetchOptions, middleware: middleware } = params;
        const headers = {
            ...params.headers
        };
        let queryParams = ``;
        let body = undefined;
        if (method === `POST`) {
            body = $f4159a034cc4c190$var$createRequestBody(query, variables, operationName, fetchOptions.jsonSerializer);
            if (typeof body === `string`) // @ts-expect-error todo
            headers[`Content-Type`] = `application/json`;
        } else // @ts-expect-error todo needs ADT for TS to understand the different states
        queryParams = $f4159a034cc4c190$var$buildRequestConfig({
            query: query,
            variables: variables,
            operationName: operationName,
            jsonSerializer: fetchOptions.jsonSerializer ?? (0, $eLb04.defaultJsonSerializer)
        });
        const init = {
            method: method,
            headers: headers,
            body: body,
            ...fetchOptions
        };
        let urlResolved = url;
        let initResolved = init;
        if (middleware) {
            const result = await Promise.resolve(middleware({
                ...init,
                url: url,
                operationName: operationName,
                variables: variables
            }));
            const { url: urlNew, ...initNew } = result;
            urlResolved = urlNew;
            initResolved = initNew;
        }
        if (queryParams) urlResolved = `${urlResolved}?${queryParams}`;
        return await fetch(urlResolved, initResolved);
    };
/**
 * GraphQL Client.
 */ class $f4159a034cc4c190$export$b0f268a6eae2cdf1 {
    constructor(url, requestConfig = {}){
        this.url = url;
        this.requestConfig = requestConfig;
        /**
         * Send a GraphQL query to the server.
         */ this.rawRequest = async (...args)=>{
            const [queryOrOptions, variables, requestHeaders] = args;
            const rawRequestOptions = (0, $fSIns.parseRawRequestArgs)(queryOrOptions, variables, requestHeaders);
            const { headers: headers, fetch: fetch = (0, (/*@__PURE__*/$parcel$interopDefault($6FOC8))), method: method = `POST`, requestMiddleware: requestMiddleware, responseMiddleware: responseMiddleware, ...fetchOptions } = this.requestConfig;
            const { url: url } = this;
            if (rawRequestOptions.signal !== undefined) fetchOptions.signal = rawRequestOptions.signal;
            const { operationName: operationName } = (0, $Xz7Q6.resolveRequestDocument)(rawRequestOptions.query);
            return $f4159a034cc4c190$var$makeRequest({
                url: url,
                query: rawRequestOptions.query,
                variables: rawRequestOptions.variables,
                headers: {
                    ...$f4159a034cc4c190$var$resolveHeaders($f4159a034cc4c190$var$callOrIdentity(headers)),
                    ...$f4159a034cc4c190$var$resolveHeaders(rawRequestOptions.requestHeaders)
                },
                operationName: operationName,
                fetch: fetch,
                method: method,
                fetchOptions: fetchOptions,
                middleware: requestMiddleware
            }).then((response)=>{
                if (responseMiddleware) responseMiddleware(response);
                return response;
            }).catch((error)=>{
                if (responseMiddleware) responseMiddleware(error);
                throw error;
            });
        };
    }
    async request(documentOrOptions, ...variablesAndRequestHeaders) {
        const [variables, requestHeaders] = variablesAndRequestHeaders;
        const requestOptions = (0, $fSIns.parseRequestArgs)(documentOrOptions, variables, requestHeaders);
        const { headers: headers, fetch: fetch = (0, (/*@__PURE__*/$parcel$interopDefault($6FOC8))), method: method = `POST`, requestMiddleware: requestMiddleware, responseMiddleware: responseMiddleware, ...fetchOptions } = this.requestConfig;
        const { url: url } = this;
        if (requestOptions.signal !== undefined) fetchOptions.signal = requestOptions.signal;
        const { query: query, operationName: operationName } = (0, $Xz7Q6.resolveRequestDocument)(requestOptions.document);
        return $f4159a034cc4c190$var$makeRequest({
            url: url,
            query: query,
            variables: requestOptions.variables,
            headers: {
                ...$f4159a034cc4c190$var$resolveHeaders($f4159a034cc4c190$var$callOrIdentity(headers)),
                ...$f4159a034cc4c190$var$resolveHeaders(requestOptions.requestHeaders)
            },
            operationName: operationName,
            fetch: fetch,
            method: method,
            fetchOptions: fetchOptions,
            middleware: requestMiddleware
        }).then((response)=>{
            if (responseMiddleware) responseMiddleware(response);
            return response.data;
        }).catch((error)=>{
            if (responseMiddleware) responseMiddleware(error);
            throw error;
        });
    }
    // prettier-ignore
    batchRequests(documentsOrOptions, requestHeaders) {
        const batchRequestOptions = (0, $fSIns.parseBatchRequestArgs)(documentsOrOptions, requestHeaders);
        const { headers: headers, ...fetchOptions } = this.requestConfig;
        if (batchRequestOptions.signal !== undefined) fetchOptions.signal = batchRequestOptions.signal;
        const queries = batchRequestOptions.documents.map(({ document: document })=>(0, $Xz7Q6.resolveRequestDocument)(document).query);
        const variables = batchRequestOptions.documents.map(({ variables: variables })=>variables);
        return $f4159a034cc4c190$var$makeRequest({
            url: this.url,
            query: queries,
            variables: // @ts-expect-error TODO reconcile batch variables into system.
            variables,
            headers: {
                ...$f4159a034cc4c190$var$resolveHeaders($f4159a034cc4c190$var$callOrIdentity(headers)),
                ...$f4159a034cc4c190$var$resolveHeaders(batchRequestOptions.requestHeaders)
            },
            operationName: undefined,
            fetch: this.requestConfig.fetch ?? (0, (/*@__PURE__*/$parcel$interopDefault($6FOC8))),
            method: this.requestConfig.method || `POST`,
            fetchOptions: fetchOptions,
            middleware: this.requestConfig.requestMiddleware
        }).then((response)=>{
            if (this.requestConfig.responseMiddleware) this.requestConfig.responseMiddleware(response);
            return response.data;
        }).catch((error)=>{
            if (this.requestConfig.responseMiddleware) this.requestConfig.responseMiddleware(error);
            throw error;
        });
    }
    setHeaders(headers) {
        this.requestConfig.headers = headers;
        return this;
    }
    /**
     * Attach a header to the client. All subsequent requests will have this header.
     */ setHeader(key, value) {
        const { headers: headers } = this.requestConfig;
        if (headers) // todo what if headers is in nested array form... ?
        //@ts-expect-error todo
        headers[key] = value;
        else this.requestConfig.headers = {
            [key]: value
        };
        return this;
    }
    /**
     * Change the client endpoint. All subsequent requests will send to this endpoint.
     */ setEndpoint(value) {
        this.url = value;
        return this;
    }
}
const $f4159a034cc4c190$var$makeRequest = async (params)=>{
    const { query: query, variables: variables, fetchOptions: fetchOptions } = params;
    const fetcher = $f4159a034cc4c190$var$createHttpMethodFetcher((0, $haH5f.uppercase)(params.method ?? `post`));
    const isBatchingQuery = Array.isArray(params.query);
    const response = await fetcher(params);
    const result = await $f4159a034cc4c190$var$getResult(response, fetchOptions.jsonSerializer ?? (0, $eLb04.defaultJsonSerializer));
    const successfullyReceivedData = Array.isArray(result) ? !result.some(({ data: data })=>!data) : Boolean(result.data);
    const successfullyPassedErrorPolicy = Array.isArray(result) || !result.errors || Array.isArray(result.errors) && !result.errors.length || fetchOptions.errorPolicy === `all` || fetchOptions.errorPolicy === `ignore`;
    if (response.ok && successfullyPassedErrorPolicy && successfullyReceivedData) {
        // @ts-expect-error TODO fixme
        const { errors: _, ...rest } = Array.isArray(result) ? result : result;
        const data = fetchOptions.errorPolicy === `ignore` ? rest : result;
        const dataEnvelope = isBatchingQuery ? {
            data: data
        } : data;
        // @ts-expect-error TODO
        return {
            ...dataEnvelope,
            headers: response.headers,
            status: response.status
        };
    } else {
        const errorResult = typeof result === `string` ? {
            error: result
        } : result;
        throw new (0, $1iZL3.ClientError)(// @ts-expect-error TODO
        {
            ...errorResult,
            status: response.status,
            headers: response.headers
        }, {
            query: query,
            variables: variables
        });
    }
};
/**
 * Send a GraphQL Query to the GraphQL server for execution.
 */ const $f4159a034cc4c190$export$3052fa16c23a17ef = async (...args)=>{
    const [urlOrOptions, query, ...variablesAndRequestHeaders] = args;
    const requestOptions = (0, $fSIns.parseRawRequestExtendedArgs)(urlOrOptions, query, ...variablesAndRequestHeaders);
    const client = new $f4159a034cc4c190$export$b0f268a6eae2cdf1(requestOptions.url);
    return client.rawRequest({
        ...requestOptions
    });
};
// prettier-ignore
// eslint-disable-next-line
async function $f4159a034cc4c190$export$b5fe3f66a567bec0(urlOrOptions, document, ...variablesAndRequestHeaders) {
    const requestOptions = (0, $fSIns.parseRequestExtendedArgs)(urlOrOptions, document, ...variablesAndRequestHeaders);
    const client = new $f4159a034cc4c190$export$b0f268a6eae2cdf1(requestOptions.url);
    return client.request({
        ...requestOptions
    });
}
/**
 * Send a batch of GraphQL Document to the GraphQL server for execution.
 *
 * @example
 *
 * ```ts
 * // You can pass a raw string
 *
 * await batchRequests('https://foo.bar/graphql', [
 * {
 *  query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * },
 * {
 *   query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * }])
 *
 * // You can also pass a GraphQL DocumentNode as query. Convenient if you
 * // are using graphql-tag package.
 *
 * import gql from 'graphql-tag'
 *
 * await batchRequests('https://foo.bar/graphql', [{ query: gql`...` }])
 * ```
 */ const $f4159a034cc4c190$export$72420c3222c11ca1 = async (...args)=>{
    const params = $f4159a034cc4c190$var$parseBatchRequestsArgsExtended(args);
    const client = new $f4159a034cc4c190$export$b0f268a6eae2cdf1(params.url);
    return client.batchRequests(params);
};
const $f4159a034cc4c190$var$parseBatchRequestsArgsExtended = (args)=>{
    if (args.length === 1) return args[0];
    else return {
        url: args[0],
        documents: args[1],
        requestHeaders: args[2],
        signal: undefined
    };
};
const $f4159a034cc4c190$var$createRequestBody = (query, variables, operationName, jsonSerializer)=>{
    const jsonSerializer_ = jsonSerializer ?? (0, $eLb04.defaultJsonSerializer);
    if (!Array.isArray(query)) return jsonSerializer_.stringify({
        query: query,
        variables: variables,
        operationName: operationName
    });
    if (typeof variables !== `undefined` && !Array.isArray(variables)) throw new Error(`Cannot create request body with given variable type, array expected`);
    // Batch support
    const payload = query.reduce((acc, currentQuery, index)=>{
        acc.push({
            query: currentQuery,
            variables: variables ? variables[index] : undefined
        });
        return acc;
    }, []);
    return jsonSerializer_.stringify(payload);
};
const $f4159a034cc4c190$var$getResult = async (response, jsonSerializer)=>{
    let contentType;
    response.headers.forEach((value, key)=>{
        if (key.toLowerCase() === `content-type`) contentType = value;
    });
    if (contentType && (contentType.toLowerCase().startsWith(`application/json`) || contentType.toLowerCase().startsWith(`application/graphql+json`) || contentType.toLowerCase().startsWith(`application/graphql-response+json`))) return jsonSerializer.parse(await response.text());
    else return response.text();
};
const $f4159a034cc4c190$var$callOrIdentity = (value)=>{
    return typeof value === `function` ? value() : value;
};
const $f4159a034cc4c190$export$72e4926bf8358653 = (chunks, ...variables)=>{
    return chunks.reduce((acc, chunk, index)=>`${acc}${chunk}${index in variables ? String(variables[index]) : ``}`, ``);
};
var $f4159a034cc4c190$export$2e2bcd8739ae039 = $f4159a034cc4c190$export$b5fe3f66a567bec0;

});
parcelRegister("eLb04", function(module, exports) {
$parcel$export(module.exports, "defaultJsonSerializer", function () { return $abedfcdcad7ec23a$export$94978876ea00418f; });
const $abedfcdcad7ec23a$export$94978876ea00418f = JSON;

});

parcelRegister("haH5f", function(module, exports) {
$parcel$export(module.exports, "uppercase", function () { return $c804ca5df265e067$export$6cfe151e6b925e83; });
$parcel$export(module.exports, "HeadersInstanceToPlainObject", function () { return $c804ca5df265e067$export$8cbbf7c85c69d7bd; });
const $c804ca5df265e067$export$6cfe151e6b925e83 = (str)=>str.toUpperCase();
const $c804ca5df265e067$export$8cbbf7c85c69d7bd = (headers)=>{
    const o = {};
    headers.forEach((v, k)=>{
        o[k] = v;
    });
    return o;
};

});

parcelRegister("fSIns", function(module, exports) {
$parcel$export(module.exports, "parseRequestArgs", function () { return $02fbd80aa1deaafb$export$23fbebc38045fef1; });
$parcel$export(module.exports, "parseRawRequestArgs", function () { return $02fbd80aa1deaafb$export$915c311301d24138; });
$parcel$export(module.exports, "parseBatchRequestArgs", function () { return $02fbd80aa1deaafb$export$db48f1a2d994371; });
$parcel$export(module.exports, "parseRequestExtendedArgs", function () { return $02fbd80aa1deaafb$export$77a1c1c6dd0fc83d; });
$parcel$export(module.exports, "parseRawRequestExtendedArgs", function () { return $02fbd80aa1deaafb$export$7dbb6e4001743509; });
const $02fbd80aa1deaafb$export$23fbebc38045fef1 = (documentOrOptions, variables, requestHeaders)=>{
    return documentOrOptions.document ? documentOrOptions : {
        document: documentOrOptions,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
const $02fbd80aa1deaafb$export$915c311301d24138 = (queryOrOptions, variables, requestHeaders)=>{
    return queryOrOptions.query ? queryOrOptions : {
        query: queryOrOptions,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
const $02fbd80aa1deaafb$export$db48f1a2d994371 = (documentsOrOptions, requestHeaders)=>{
    return documentsOrOptions.documents ? documentsOrOptions : {
        documents: documentsOrOptions,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
const $02fbd80aa1deaafb$export$77a1c1c6dd0fc83d = (urlOrOptions, document, ...variablesAndRequestHeaders)=>{
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.document ? urlOrOptions : {
        url: urlOrOptions,
        document: document,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
const $02fbd80aa1deaafb$export$7dbb6e4001743509 = (urlOrOptions, query, ...variablesAndRequestHeaders)=>{
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.query ? urlOrOptions : {
        url: urlOrOptions,
        query: query,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};

});

parcelRegister("Xz7Q6", function(module, exports) {
$parcel$export(module.exports, "resolveRequestDocument", function () { return $0b30c1fbc38efde2$export$8a71244cbc138170; });

var $bUPIt = parcelRequire("bUPIt");
var $hj3p7 = parcelRequire("hj3p7");
/**
 * helpers
 */ const $0b30c1fbc38efde2$var$extractOperationName = (document)=>{
    let operationName = undefined;
    const operationDefinitions = document.definitions.filter((definition)=>definition.kind === `OperationDefinition`);
    if (operationDefinitions.length === 1) operationName = operationDefinitions[0]?.name?.value;
    return operationName;
};
const $0b30c1fbc38efde2$export$8a71244cbc138170 = (document)=>{
    if (typeof document === `string`) {
        let operationName = undefined;
        try {
            const parsedDocument = (0, $bUPIt.parse)(document);
            operationName = $0b30c1fbc38efde2$var$extractOperationName(parsedDocument);
        } catch (err) {
        // Failed parsing the document, the operationName will be undefined
        }
        return {
            query: document,
            operationName: operationName
        };
    }
    const operationName = $0b30c1fbc38efde2$var$extractOperationName(document);
    return {
        query: (0, $hj3p7.print)(document),
        operationName: operationName
    };
};

});
parcelRegister("bUPIt", function(module, exports) {
$parcel$export(module.exports, "parse", function () { return $8acd0a795078b9c5$export$98e6a39c04603d36; });

var $aB6yt = parcelRequire("aB6yt");

var $aGcUy = parcelRequire("aGcUy");

var $kQhGE = parcelRequire("kQhGE");

var $dgoM9 = parcelRequire("dgoM9");

var $5LAxS = parcelRequire("5LAxS");

var $jd7uX = parcelRequire("jd7uX");

var $g39GT = parcelRequire("g39GT");
function $8acd0a795078b9c5$export$98e6a39c04603d36(source, options) {
    const parser = new $8acd0a795078b9c5$export$7acfa6ed01010e37(source, options);
    const document = parser.parseDocument();
    Object.defineProperty(document, 'tokenCount', {
        enumerable: false,
        value: parser.tokenCount
    });
    return document;
}
function $8acd0a795078b9c5$export$5303528d1070ff6f(source, options) {
    const parser = new $8acd0a795078b9c5$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $g39GT.TokenKind).SOF);
    const value = parser.parseValueLiteral(false);
    parser.expectToken((0, $g39GT.TokenKind).EOF);
    return value;
}
function $8acd0a795078b9c5$export$e14c466bd0916f7a(source, options) {
    const parser = new $8acd0a795078b9c5$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $g39GT.TokenKind).SOF);
    const value = parser.parseConstValueLiteral();
    parser.expectToken((0, $g39GT.TokenKind).EOF);
    return value;
}
function $8acd0a795078b9c5$export$28b8f402ccc88182(source, options) {
    const parser = new $8acd0a795078b9c5$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $g39GT.TokenKind).SOF);
    const type = parser.parseTypeReference();
    parser.expectToken((0, $g39GT.TokenKind).EOF);
    return type;
}
class $8acd0a795078b9c5$export$7acfa6ed01010e37 {
    constructor(source, options = {}){
        const sourceObj = (0, $jd7uX.isSource)(source) ? source : new (0, $jd7uX.Source)(source);
        this._lexer = new (0, $5LAxS.Lexer)(sourceObj);
        this._options = options;
        this._tokenCounter = 0;
    }
    get tokenCount() {
        return this._tokenCounter;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ parseName() {
        const token = this.expectToken((0, $g39GT.TokenKind).NAME);
        return this.node(token, {
            kind: (0, $dgoM9.Kind).NAME,
            value: token.value
        });
    }
    /**
   * Document : Definition+
   */ parseDocument() {
        return this.node(this._lexer.token, {
            kind: (0, $dgoM9.Kind).DOCUMENT,
            definitions: this.many((0, $g39GT.TokenKind).SOF, this.parseDefinition, (0, $g39GT.TokenKind).EOF)
        });
    }
    /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ parseDefinition() {
        if (this.peek((0, $g39GT.TokenKind).BRACE_L)) return this.parseOperationDefinition();
         // Many definitions begin with a description and require a lookahead.
        const hasDescription = this.peekDescription();
        const keywordToken = hasDescription ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $g39GT.TokenKind).NAME) {
            switch(keywordToken.value){
                case 'schema':
                    return this.parseSchemaDefinition();
                case 'scalar':
                    return this.parseScalarTypeDefinition();
                case 'type':
                    return this.parseObjectTypeDefinition();
                case 'interface':
                    return this.parseInterfaceTypeDefinition();
                case 'union':
                    return this.parseUnionTypeDefinition();
                case 'enum':
                    return this.parseEnumTypeDefinition();
                case 'input':
                    return this.parseInputObjectTypeDefinition();
                case 'directive':
                    return this.parseDirectiveDefinition();
            }
            if (hasDescription) throw (0, $aB6yt.syntaxError)(this._lexer.source, this._lexer.token.start, 'Unexpected description, descriptions are supported only on type definitions.');
            switch(keywordToken.value){
                case 'query':
                case 'mutation':
                case 'subscription':
                    return this.parseOperationDefinition();
                case 'fragment':
                    return this.parseFragmentDefinition();
                case 'extend':
                    return this.parseTypeSystemExtension();
            }
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ parseOperationDefinition() {
        const start = this._lexer.token;
        if (this.peek((0, $g39GT.TokenKind).BRACE_L)) return this.node(start, {
            kind: (0, $dgoM9.Kind).OPERATION_DEFINITION,
            operation: (0, $aGcUy.OperationTypeNode).QUERY,
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet()
        });
        const operation = this.parseOperationType();
        let name;
        if (this.peek((0, $g39GT.TokenKind).NAME)) name = this.parseName();
        return this.node(start, {
            kind: (0, $dgoM9.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * OperationType : one of query mutation subscription
   */ parseOperationType() {
        const operationToken = this.expectToken((0, $g39GT.TokenKind).NAME);
        switch(operationToken.value){
            case 'query':
                return (0, $aGcUy.OperationTypeNode).QUERY;
            case 'mutation':
                return (0, $aGcUy.OperationTypeNode).MUTATION;
            case 'subscription':
                return (0, $aGcUy.OperationTypeNode).SUBSCRIPTION;
        }
        throw this.unexpected(operationToken);
    }
    /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ parseVariableDefinitions() {
        return this.optionalMany((0, $g39GT.TokenKind).PAREN_L, this.parseVariableDefinition, (0, $g39GT.TokenKind).PAREN_R);
    }
    /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ parseVariableDefinition() {
        return this.node(this._lexer.token, {
            kind: (0, $dgoM9.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $g39GT.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $g39GT.TokenKind).EQUALS) ? this.parseConstValueLiteral() : undefined,
            directives: this.parseConstDirectives()
        });
    }
    /**
   * Variable : $ Name
   */ parseVariable() {
        const start = this._lexer.token;
        this.expectToken((0, $g39GT.TokenKind).DOLLAR);
        return this.node(start, {
            kind: (0, $dgoM9.Kind).VARIABLE,
            name: this.parseName()
        });
    }
    /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */ parseSelectionSet() {
        return this.node(this._lexer.token, {
            kind: (0, $dgoM9.Kind).SELECTION_SET,
            selections: this.many((0, $g39GT.TokenKind).BRACE_L, this.parseSelection, (0, $g39GT.TokenKind).BRACE_R)
        });
    }
    /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ parseSelection() {
        return this.peek((0, $g39GT.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    }
    /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ parseField() {
        const start = this._lexer.token;
        const nameOrAlias = this.parseName();
        let alias;
        let name;
        if (this.expectOptionalToken((0, $g39GT.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return this.node(start, {
            kind: (0, $dgoM9.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $g39GT.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined
        });
    }
    /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ parseArguments(isConst) {
        const item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $g39GT.TokenKind).PAREN_L, item, (0, $g39GT.TokenKind).PAREN_R);
    }
    /**
   * Argument[Const] : Name : Value[?Const]
   */ parseArgument(isConst = false) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $g39GT.TokenKind).COLON);
        return this.node(start, {
            kind: (0, $dgoM9.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    parseConstArgument() {
        return this.parseArgument(true);
    }
    /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ parseFragment() {
        const start = this._lexer.token;
        this.expectToken((0, $g39GT.TokenKind).SPREAD);
        const hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $g39GT.TokenKind).NAME)) return this.node(start, {
            kind: (0, $dgoM9.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false)
        });
        return this.node(start, {
            kind: (0, $dgoM9.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ parseFragmentDefinition() {
        const start = this._lexer.token;
        this.expectKeyword('fragment'); // Legacy support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (this._options.allowLegacyFragmentVariables === true) return this.node(start, {
            kind: (0, $dgoM9.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
        return this.node(start, {
            kind: (0, $dgoM9.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentName : Name but not `on`
   */ parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    }
    /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseValueLiteral(isConst) {
        const token = this._lexer.token;
        switch(token.kind){
            case (0, $g39GT.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, $g39GT.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, $g39GT.TokenKind).INT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $dgoM9.Kind).INT,
                    value: token.value
                });
            case (0, $g39GT.TokenKind).FLOAT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $dgoM9.Kind).FLOAT,
                    value: token.value
                });
            case (0, $g39GT.TokenKind).STRING:
            case (0, $g39GT.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $g39GT.TokenKind).NAME:
                this.advanceLexer();
                switch(token.value){
                    case 'true':
                        return this.node(token, {
                            kind: (0, $dgoM9.Kind).BOOLEAN,
                            value: true
                        });
                    case 'false':
                        return this.node(token, {
                            kind: (0, $dgoM9.Kind).BOOLEAN,
                            value: false
                        });
                    case 'null':
                        return this.node(token, {
                            kind: (0, $dgoM9.Kind).NULL
                        });
                    default:
                        return this.node(token, {
                            kind: (0, $dgoM9.Kind).ENUM,
                            value: token.value
                        });
                }
            case (0, $g39GT.TokenKind).DOLLAR:
                if (isConst) {
                    this.expectToken((0, $g39GT.TokenKind).DOLLAR);
                    if (this._lexer.token.kind === (0, $g39GT.TokenKind).NAME) {
                        const varName = this._lexer.token.value;
                        throw (0, $aB6yt.syntaxError)(this._lexer.source, token.start, `Unexpected variable "$${varName}" in constant value.`);
                    } else throw this.unexpected(token);
                }
                return this.parseVariable();
            default:
                throw this.unexpected();
        }
    }
    parseConstValueLiteral() {
        return this.parseValueLiteral(true);
    }
    parseStringLiteral() {
        const token = this._lexer.token;
        this.advanceLexer();
        return this.node(token, {
            kind: (0, $dgoM9.Kind).STRING,
            value: token.value,
            block: token.kind === (0, $g39GT.TokenKind).BLOCK_STRING
        });
    }
    /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ parseList(isConst) {
        const item = ()=>this.parseValueLiteral(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $dgoM9.Kind).LIST,
            values: this.any((0, $g39GT.TokenKind).BRACKET_L, item, (0, $g39GT.TokenKind).BRACKET_R)
        });
    }
    /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */ parseObject(isConst) {
        const item = ()=>this.parseObjectField(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $dgoM9.Kind).OBJECT,
            fields: this.any((0, $g39GT.TokenKind).BRACE_L, item, (0, $g39GT.TokenKind).BRACE_R)
        });
    }
    /**
   * ObjectField[Const] : Name : Value[?Const]
   */ parseObjectField(isConst) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $g39GT.TokenKind).COLON);
        return this.node(start, {
            kind: (0, $dgoM9.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    /**
   * Directives[Const] : Directive[?Const]+
   */ parseDirectives(isConst) {
        const directives = [];
        while(this.peek((0, $g39GT.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    }
    parseConstDirectives() {
        return this.parseDirectives(true);
    }
    /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */ parseDirective(isConst) {
        const start = this._lexer.token;
        this.expectToken((0, $g39GT.TokenKind).AT);
        return this.node(start, {
            kind: (0, $dgoM9.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst)
        });
    }
    /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ parseTypeReference() {
        const start = this._lexer.token;
        let type;
        if (this.expectOptionalToken((0, $g39GT.TokenKind).BRACKET_L)) {
            const innerType = this.parseTypeReference();
            this.expectToken((0, $g39GT.TokenKind).BRACKET_R);
            type = this.node(start, {
                kind: (0, $dgoM9.Kind).LIST_TYPE,
                type: innerType
            });
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $g39GT.TokenKind).BANG)) return this.node(start, {
            kind: (0, $dgoM9.Kind).NON_NULL_TYPE,
            type: type
        });
        return type;
    }
    /**
   * NamedType : Name
   */ parseNamedType() {
        return this.node(this._lexer.token, {
            kind: (0, $dgoM9.Kind).NAMED_TYPE,
            name: this.parseName()
        });
    }
    peekDescription() {
        return this.peek((0, $g39GT.TokenKind).STRING) || this.peek((0, $g39GT.TokenKind).BLOCK_STRING);
    }
    /**
   * Description : StringValue
   */ parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    }
    /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */ parseSchemaDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('schema');
        const directives = this.parseConstDirectives();
        const operationTypes = this.many((0, $g39GT.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $g39GT.TokenKind).BRACE_R);
        return this.node(start, {
            kind: (0, $dgoM9.Kind).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * OperationTypeDefinition : OperationType : NamedType
   */ parseOperationTypeDefinition() {
        const start = this._lexer.token;
        const operation = this.parseOperationType();
        this.expectToken((0, $g39GT.TokenKind).COLON);
        const type = this.parseNamedType();
        return this.node(start, {
            kind: (0, $dgoM9.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type
        });
    }
    /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ parseScalarTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('scalar');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $dgoM9.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ parseObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('type');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $dgoM9.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ parseImplementsInterfaces() {
        return this.expectOptionalKeyword('implements') ? this.delimitedMany((0, $g39GT.TokenKind).AMP, this.parseNamedType) : [];
    }
    /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */ parseFieldsDefinition() {
        return this.optionalMany((0, $g39GT.TokenKind).BRACE_L, this.parseFieldDefinition, (0, $g39GT.TokenKind).BRACE_R);
    }
    /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ parseFieldDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        this.expectToken((0, $g39GT.TokenKind).COLON);
        const type = this.parseTypeReference();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $dgoM9.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives
        });
    }
    /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ parseArgumentDefs() {
        return this.optionalMany((0, $g39GT.TokenKind).PAREN_L, this.parseInputValueDef, (0, $g39GT.TokenKind).PAREN_R);
    }
    /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ parseInputValueDef() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        this.expectToken((0, $g39GT.TokenKind).COLON);
        const type = this.parseTypeReference();
        let defaultValue;
        if (this.expectOptionalToken((0, $g39GT.TokenKind).EQUALS)) defaultValue = this.parseConstValueLiteral();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $dgoM9.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives
        });
    }
    /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ parseInterfaceTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('interface');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $dgoM9.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ parseUnionTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('union');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        return this.node(start, {
            kind: (0, $dgoM9.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $g39GT.TokenKind).EQUALS) ? this.delimitedMany((0, $g39GT.TokenKind).PIPE, this.parseNamedType) : [];
    }
    /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ parseEnumTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('enum');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        return this.node(start, {
            kind: (0, $dgoM9.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */ parseEnumValuesDefinition() {
        return this.optionalMany((0, $g39GT.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, $g39GT.TokenKind).BRACE_R);
    }
    /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */ parseEnumValueDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseEnumValueName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $dgoM9.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseEnumValueName() {
        if (this._lexer.token.value === 'true' || this._lexer.token.value === 'false' || this._lexer.token.value === 'null') throw (0, $aB6yt.syntaxError)(this._lexer.source, this._lexer.token.start, `${$8acd0a795078b9c5$var$getTokenDesc(this._lexer.token)} is reserved and cannot be used for an enum value.`);
        return this.parseName();
    }
    /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ parseInputObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('input');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        return this.node(start, {
            kind: (0, $dgoM9.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */ parseInputFieldsDefinition() {
        return this.optionalMany((0, $g39GT.TokenKind).BRACE_L, this.parseInputValueDef, (0, $g39GT.TokenKind).BRACE_R);
    }
    /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ parseTypeSystemExtension() {
        const keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $g39GT.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */ parseSchemaExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        const directives = this.parseConstDirectives();
        const operationTypes = this.optionalMany((0, $g39GT.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $g39GT.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $dgoM9.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ parseScalarTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        if (directives.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $dgoM9.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ parseObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $dgoM9.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ parseInterfaceTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $dgoM9.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ parseUnionTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $dgoM9.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ parseEnumTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $dgoM9.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ parseInputObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $dgoM9.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */ parseDirectiveDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $g39GT.TokenKind).AT);
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        const repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        const locations = this.parseDirectiveLocations();
        return this.node(start, {
            kind: (0, $dgoM9.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations
        });
    }
    /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ parseDirectiveLocations() {
        return this.delimitedMany((0, $g39GT.TokenKind).PIPE, this.parseDirectiveLocation);
    }
    /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ parseDirectiveLocation() {
        const start = this._lexer.token;
        const name = this.parseName();
        if (Object.prototype.hasOwnProperty.call((0, $kQhGE.DirectiveLocation), name.value)) return name;
        throw this.unexpected(start);
    }
    /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */ node(startToken, node) {
        if (this._options.noLocation !== true) node.loc = new (0, $aGcUy.Location)(startToken, this._lexer.lastToken, this._lexer.source);
        return node;
    }
    /**
   * Determines if the next token is of a given kind
   */ peek(kind) {
        return this._lexer.token.kind === kind;
    }
    /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return token;
        }
        throw (0, $aB6yt.syntaxError)(this._lexer.source, token.start, `Expected ${$8acd0a795078b9c5$var$getTokenKindDesc(kind)}, found ${$8acd0a795078b9c5$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $g39GT.TokenKind).NAME && token.value === value) this.advanceLexer();
        else throw (0, $aB6yt.syntaxError)(this._lexer.source, token.start, `Expected "${value}", found ${$8acd0a795078b9c5$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $g39GT.TokenKind).NAME && token.value === value) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ unexpected(atToken) {
        const token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $aB6yt.syntaxError)(this._lexer.source, token.start, `Unexpected ${$8acd0a795078b9c5$var$getTokenDesc(token)}.`);
    }
    /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    }
    /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            const nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    }
    advanceLexer() {
        const { maxTokens: maxTokens } = this._options;
        const token = this._lexer.advance();
        if (token.kind !== (0, $g39GT.TokenKind).EOF) {
            ++this._tokenCounter;
            if (maxTokens !== undefined && this._tokenCounter > maxTokens) throw (0, $aB6yt.syntaxError)(this._lexer.source, token.start, `Document contains more that ${maxTokens} tokens. Parsing aborted.`);
        }
    }
}
/**
 * A helper function to describe a token as a string for debugging.
 */ function $8acd0a795078b9c5$var$getTokenDesc(token) {
    const value = token.value;
    return $8acd0a795078b9c5$var$getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $8acd0a795078b9c5$var$getTokenKindDesc(kind) {
    return (0, $5LAxS.isPunctuatorTokenKind)(kind) ? `"${kind}"` : kind;
}

});
parcelRegister("aB6yt", function(module, exports) {
$parcel$export(module.exports, "syntaxError", function () { return $7b7271c50458c8a4$export$bbee0c6176c019d4; });

var $e7vvl = parcelRequire("e7vvl");
function $7b7271c50458c8a4$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $e7vvl.GraphQLError)(`Syntax Error: ${description}`, {
        source: source,
        positions: [
            position
        ]
    });
}

});
parcelRegister("e7vvl", function(module, exports) {
$parcel$export(module.exports, "GraphQLError", function () { return $a47a2849a9e89d1f$export$92d6ed0888e7cb7f; });

var $aaD2b = parcelRequire("aaD2b");

var $4QTBd = parcelRequire("4QTBd");

var $dkXxV = parcelRequire("dkXxV");
function $a47a2849a9e89d1f$var$toNormalizedOptions(args) {
    const firstArg = args[0];
    if (firstArg == null || 'kind' in firstArg || 'length' in firstArg) return {
        nodes: firstArg,
        source: args[1],
        positions: args[2],
        path: args[3],
        originalError: args[4],
        extensions: args[5]
    };
    return firstArg;
}
class $a47a2849a9e89d1f$export$92d6ed0888e7cb7f extends Error {
    /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */ constructor(message, ...rawArgs){
        var _this$nodes, _nodeLocations$, _ref;
        const { nodes: nodes, source: source, positions: positions, path: path, originalError: originalError, extensions: extensions } = $a47a2849a9e89d1f$var$toNormalizedOptions(rawArgs);
        super(message);
        this.name = 'GraphQLError';
        this.path = path !== null && path !== void 0 ? path : undefined;
        this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        this.nodes = $a47a2849a9e89d1f$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        const nodeLocations = $a47a2849a9e89d1f$var$undefinedIfEmpty((_this$nodes = this.nodes) === null || _this$nodes === void 0 ? void 0 : _this$nodes.map((node)=>node.loc).filter((loc)=>loc != null)); // Compute locations in the source for the given nodes/positions.
        this.source = source !== null && source !== void 0 ? source : nodeLocations === null || nodeLocations === void 0 ? void 0 : (_nodeLocations$ = nodeLocations[0]) === null || _nodeLocations$ === void 0 ? void 0 : _nodeLocations$.source;
        this.positions = positions !== null && positions !== void 0 ? positions : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>loc.start);
        this.locations = positions && source ? positions.map((pos)=>(0, $4QTBd.getLocation)(source, pos)) : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>(0, $4QTBd.getLocation)(loc.source, loc.start));
        const originalExtensions = (0, $aaD2b.isObjectLike)(originalError === null || originalError === void 0 ? void 0 : originalError.extensions) ? originalError === null || originalError === void 0 ? void 0 : originalError.extensions : undefined;
        this.extensions = (_ref = extensions !== null && extensions !== void 0 ? extensions : originalExtensions) !== null && _ref !== void 0 ? _ref : Object.create(null); // Only properties prescribed by the spec should be enumerable.
        // Keep the rest as non-enumerable.
        Object.defineProperties(this, {
            message: {
                writable: true,
                enumerable: true
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        /* c8 ignore start */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
        if (originalError !== null && originalError !== void 0 && originalError.stack) Object.defineProperty(this, 'stack', {
            value: originalError.stack,
            writable: true,
            configurable: true
        });
        else if (Error.captureStackTrace) Error.captureStackTrace(this, $a47a2849a9e89d1f$export$92d6ed0888e7cb7f);
        else Object.defineProperty(this, 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
    /* c8 ignore stop */ }
    get [Symbol.toStringTag]() {
        return 'GraphQLError';
    }
    toString() {
        let output = this.message;
        if (this.nodes) {
            for (const node of this.nodes)if (node.loc) output += '\n\n' + (0, $dkXxV.printLocation)(node.loc);
        } else if (this.source && this.locations) for (const location of this.locations)output += '\n\n' + (0, $dkXxV.printSourceLocation)(this.source, location);
        return output;
    }
    toJSON() {
        const formattedError = {
            message: this.message
        };
        if (this.locations != null) formattedError.locations = this.locations;
        if (this.path != null) formattedError.path = this.path;
        if (this.extensions != null && Object.keys(this.extensions).length > 0) formattedError.extensions = this.extensions;
        return formattedError;
    }
}
function $a47a2849a9e89d1f$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $a47a2849a9e89d1f$export$55ee1551a3f962e6(error) {
    return error.toString();
}
function $a47a2849a9e89d1f$export$7b5b869ee98c16ab(error) {
    return error.toJSON();
}

});
parcelRegister("aaD2b", function(module, exports) {
$parcel$export(module.exports, "isObjectLike", function () { return $76791deaefcd3527$export$c10d0b04eaa80a43; });
/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */ function $76791deaefcd3527$export$c10d0b04eaa80a43(value) {
    return typeof value == 'object' && value !== null;
}

});

parcelRegister("4QTBd", function(module, exports) {
$parcel$export(module.exports, "getLocation", function () { return $38872596a5d68688$export$e7fd20fad3cf4b5f; });

var $djyK9 = parcelRequire("djyK9");
const $38872596a5d68688$var$LineRegExp = /\r\n|[\n\r]/g;
function $38872596a5d68688$export$e7fd20fad3cf4b5f(source, position) {
    let lastLineStart = 0;
    let line = 1;
    for (const match of source.body.matchAll($38872596a5d68688$var$LineRegExp)){
        typeof match.index === 'number' || (0, $djyK9.invariant)(false);
        if (match.index >= position) break;
        lastLineStart = match.index + match[0].length;
        line += 1;
    }
    return {
        line: line,
        column: position + 1 - lastLineStart
    };
}

});
parcelRegister("djyK9", function(module, exports) {
$parcel$export(module.exports, "invariant", function () { return $9b1800075ea7c50b$export$f5708dca728d7177; });
function $9b1800075ea7c50b$export$f5708dca728d7177(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}

});


parcelRegister("dkXxV", function(module, exports) {
$parcel$export(module.exports, "printLocation", function () { return $9b5b554696a47538$export$96a9681e539deed; });
$parcel$export(module.exports, "printSourceLocation", function () { return $9b5b554696a47538$export$867940333fd9f869; });

var $4QTBd = parcelRequire("4QTBd");
function $9b5b554696a47538$export$96a9681e539deed(location) {
    return $9b5b554696a47538$export$867940333fd9f869(location.source, (0, $4QTBd.getLocation)(location.source, location.start));
}
function $9b5b554696a47538$export$867940333fd9f869(source, sourceLocation) {
    const firstLineColumnOffset = source.locationOffset.column - 1;
    const body = ''.padStart(firstLineColumnOffset) + source.body;
    const lineIndex = sourceLocation.line - 1;
    const lineOffset = source.locationOffset.line - 1;
    const lineNum = sourceLocation.line + lineOffset;
    const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    const columnNum = sourceLocation.column + columnOffset;
    const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
    const lines = body.split(/\r\n|[\n\r]/g);
    const locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        const subLineIndex = Math.floor(columnNum / 80);
        const subLineColumnNum = columnNum % 80;
        const subLines = [];
        for(let i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $9b5b554696a47538$var$printPrefixedLines([
            [
                `${lineNum} |`,
                subLines[0]
            ],
            ...subLines.slice(1, subLineIndex + 1).map((subLine)=>[
                    '|',
                    subLine
                ]),
            [
                '|',
                '^'.padStart(subLineColumnNum)
            ],
            [
                '|',
                subLines[subLineIndex + 1]
            ]
        ]);
    }
    return locationStr + $9b5b554696a47538$var$printPrefixedLines([
        // Lines specified like this: ["prefix", "string"],
        [
            `${lineNum - 1} |`,
            lines[lineIndex - 1]
        ],
        [
            `${lineNum} |`,
            locationLine
        ],
        [
            '|',
            '^'.padStart(columnNum)
        ],
        [
            `${lineNum + 1} |`,
            lines[lineIndex + 1]
        ]
    ]);
}
function $9b5b554696a47538$var$printPrefixedLines(lines) {
    const existingLines = lines.filter(([_, line])=>line !== undefined);
    const padLen = Math.max(...existingLines.map(([prefix])=>prefix.length));
    return existingLines.map(([prefix, line])=>prefix.padStart(padLen) + (line ? ' ' + line : '')).join('\n');
}

});



parcelRegister("aGcUy", function(module, exports) {
$parcel$export(module.exports, "Location", function () { return $7c67d77df7d81c8b$export$18a2be9195644f38; });
$parcel$export(module.exports, "Token", function () { return $7c67d77df7d81c8b$export$50792b0e93539fde; });
$parcel$export(module.exports, "QueryDocumentKeys", function () { return $7c67d77df7d81c8b$export$4fcd777a40ccf407; });
$parcel$export(module.exports, "isNode", function () { return $7c67d77df7d81c8b$export$8ee0fc9ee280b4ee; });
$parcel$export(module.exports, "OperationTypeNode", function () { return $7c67d77df7d81c8b$export$f58c50edb4aef9d4; });
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ class $7c67d77df7d81c8b$export$18a2be9195644f38 {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    get [Symbol.toStringTag]() {
        return 'Location';
    }
    toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
}
class $7c67d77df7d81c8b$export$50792b0e93539fde {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
    get [Symbol.toStringTag]() {
        return 'Token';
    }
    toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
}
const $7c67d77df7d81c8b$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
const $7c67d77df7d81c8b$var$kindValues = new Set(Object.keys($7c67d77df7d81c8b$export$4fcd777a40ccf407));
function $7c67d77df7d81c8b$export$8ee0fc9ee280b4ee(maybeNode) {
    const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === 'string' && $7c67d77df7d81c8b$var$kindValues.has(maybeKind);
}
/** Name */ var $7c67d77df7d81c8b$export$f58c50edb4aef9d4;
(function(OperationTypeNode) {
    OperationTypeNode['QUERY'] = 'query';
    OperationTypeNode['MUTATION'] = 'mutation';
    OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})($7c67d77df7d81c8b$export$f58c50edb4aef9d4 || ($7c67d77df7d81c8b$export$f58c50edb4aef9d4 = {}));

});

parcelRegister("kQhGE", function(module, exports) {
$parcel$export(module.exports, "DirectiveLocation", function () { return $f2c662417b81c5a0$export$b45ffd2948484c41; });
/**
 * The set of allowed directive location values.
 */ var $f2c662417b81c5a0$export$b45ffd2948484c41;
(function(DirectiveLocation) {
    DirectiveLocation['QUERY'] = 'QUERY';
    DirectiveLocation['MUTATION'] = 'MUTATION';
    DirectiveLocation['SUBSCRIPTION'] = 'SUBSCRIPTION';
    DirectiveLocation['FIELD'] = 'FIELD';
    DirectiveLocation['FRAGMENT_DEFINITION'] = 'FRAGMENT_DEFINITION';
    DirectiveLocation['FRAGMENT_SPREAD'] = 'FRAGMENT_SPREAD';
    DirectiveLocation['INLINE_FRAGMENT'] = 'INLINE_FRAGMENT';
    DirectiveLocation['VARIABLE_DEFINITION'] = 'VARIABLE_DEFINITION';
    DirectiveLocation['SCHEMA'] = 'SCHEMA';
    DirectiveLocation['SCALAR'] = 'SCALAR';
    DirectiveLocation['OBJECT'] = 'OBJECT';
    DirectiveLocation['FIELD_DEFINITION'] = 'FIELD_DEFINITION';
    DirectiveLocation['ARGUMENT_DEFINITION'] = 'ARGUMENT_DEFINITION';
    DirectiveLocation['INTERFACE'] = 'INTERFACE';
    DirectiveLocation['UNION'] = 'UNION';
    DirectiveLocation['ENUM'] = 'ENUM';
    DirectiveLocation['ENUM_VALUE'] = 'ENUM_VALUE';
    DirectiveLocation['INPUT_OBJECT'] = 'INPUT_OBJECT';
    DirectiveLocation['INPUT_FIELD_DEFINITION'] = 'INPUT_FIELD_DEFINITION';
})($f2c662417b81c5a0$export$b45ffd2948484c41 || ($f2c662417b81c5a0$export$b45ffd2948484c41 = {}));
 /**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */ 
});

parcelRegister("dgoM9", function(module, exports) {
$parcel$export(module.exports, "Kind", function () { return $9a7ffceec341d92b$export$a84bdc57c5122798; });
/**
 * The set of allowed kind values for AST nodes.
 */ var $9a7ffceec341d92b$export$a84bdc57c5122798;
(function(Kind) {
    Kind['NAME'] = 'Name';
    Kind['DOCUMENT'] = 'Document';
    Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
    Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
    Kind['SELECTION_SET'] = 'SelectionSet';
    Kind['FIELD'] = 'Field';
    Kind['ARGUMENT'] = 'Argument';
    Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
    Kind['INLINE_FRAGMENT'] = 'InlineFragment';
    Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
    Kind['VARIABLE'] = 'Variable';
    Kind['INT'] = 'IntValue';
    Kind['FLOAT'] = 'FloatValue';
    Kind['STRING'] = 'StringValue';
    Kind['BOOLEAN'] = 'BooleanValue';
    Kind['NULL'] = 'NullValue';
    Kind['ENUM'] = 'EnumValue';
    Kind['LIST'] = 'ListValue';
    Kind['OBJECT'] = 'ObjectValue';
    Kind['OBJECT_FIELD'] = 'ObjectField';
    Kind['DIRECTIVE'] = 'Directive';
    Kind['NAMED_TYPE'] = 'NamedType';
    Kind['LIST_TYPE'] = 'ListType';
    Kind['NON_NULL_TYPE'] = 'NonNullType';
    Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
    Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
    Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
    Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
    Kind['FIELD_DEFINITION'] = 'FieldDefinition';
    Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
    Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
    Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
    Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
    Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
    Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
    Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
    Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
    Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
    Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
    Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
    Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
    Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
    Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
})($9a7ffceec341d92b$export$a84bdc57c5122798 || ($9a7ffceec341d92b$export$a84bdc57c5122798 = {}));
 /**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */ 
});

parcelRegister("5LAxS", function(module, exports) {
$parcel$export(module.exports, "Lexer", function () { return $432db0af72306814$export$6168dc8908a6c652; });
$parcel$export(module.exports, "isPunctuatorTokenKind", function () { return $432db0af72306814$export$59ac0f4da287406a; });

var $aB6yt = parcelRequire("aB6yt");

var $aGcUy = parcelRequire("aGcUy");

var $2jPxL = parcelRequire("2jPxL");

var $dyxzy = parcelRequire("dyxzy");

var $g39GT = parcelRequire("g39GT");
class $432db0af72306814$export$6168dc8908a6c652 {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ constructor(source){
        const startOfFileToken = new (0, $aGcUy.Token)((0, $g39GT.TokenKind).SOF, 0, 0, 0, 0);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    get [Symbol.toStringTag]() {
        return 'Lexer';
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ advance() {
        this.lastToken = this.token;
        const token = this.token = this.lookahead();
        return token;
    }
    /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ lookahead() {
        let token = this.token;
        if (token.kind !== (0, $g39GT.TokenKind).EOF) {
            do if (token.next) token = token.next;
            else {
                // Read the next token and form a link in the token linked-list.
                const nextToken = $432db0af72306814$var$readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.
                token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.
                nextToken.prev = token;
                token = nextToken;
            }
            while (token.kind === (0, $g39GT.TokenKind).COMMENT);
        }
        return token;
    }
}
function $432db0af72306814$export$59ac0f4da287406a(kind) {
    return kind === (0, $g39GT.TokenKind).BANG || kind === (0, $g39GT.TokenKind).DOLLAR || kind === (0, $g39GT.TokenKind).AMP || kind === (0, $g39GT.TokenKind).PAREN_L || kind === (0, $g39GT.TokenKind).PAREN_R || kind === (0, $g39GT.TokenKind).SPREAD || kind === (0, $g39GT.TokenKind).COLON || kind === (0, $g39GT.TokenKind).EQUALS || kind === (0, $g39GT.TokenKind).AT || kind === (0, $g39GT.TokenKind).BRACKET_L || kind === (0, $g39GT.TokenKind).BRACKET_R || kind === (0, $g39GT.TokenKind).BRACE_L || kind === (0, $g39GT.TokenKind).PIPE || kind === (0, $g39GT.TokenKind).BRACE_R;
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */ function $432db0af72306814$var$isUnicodeScalarValue(code) {
    return code >= 0x0000 && code <= 0xd7ff || code >= 0xe000 && code <= 0x10ffff;
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */ function $432db0af72306814$var$isSupplementaryCodePoint(body, location) {
    return $432db0af72306814$var$isLeadingSurrogate(body.charCodeAt(location)) && $432db0af72306814$var$isTrailingSurrogate(body.charCodeAt(location + 1));
}
function $432db0af72306814$var$isLeadingSurrogate(code) {
    return code >= 0xd800 && code <= 0xdbff;
}
function $432db0af72306814$var$isTrailingSurrogate(code) {
    return code >= 0xdc00 && code <= 0xdfff;
}
/**
 * Prints the code point (or end of file reference) at a given location in a
 * source for use in error messages.
 *
 * Printable ASCII is printed quoted, while other points are printed in Unicode
 * code point form (ie. U+1234).
 */ function $432db0af72306814$var$printCodePointAt(lexer, location) {
    const code = lexer.source.body.codePointAt(location);
    if (code === undefined) return (0, $g39GT.TokenKind).EOF;
    else if (code >= 0x0020 && code <= 0x007e) {
        // Printable ASCII
        const char = String.fromCodePoint(code);
        return char === '"' ? "'\"'" : `"${char}"`;
    } // Unicode code point
    return 'U+' + code.toString(16).toUpperCase().padStart(4, '0');
}
/**
 * Create a token with line and column location information.
 */ function $432db0af72306814$var$createToken(lexer, kind, start, end, value) {
    const line = lexer.line;
    const col = 1 + start - lexer.lineStart;
    return new (0, $aGcUy.Token)(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $432db0af72306814$var$readNextToken(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // SourceCharacter
        switch(code){
            // Ignored ::
            //   - UnicodeBOM
            //   - WhiteSpace
            //   - LineTerminator
            //   - Comment
            //   - Comma
            //
            // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
            //
            // WhiteSpace ::
            //   - "Horizontal Tab (U+0009)"
            //   - "Space (U+0020)"
            //
            // Comma :: ,
            case 0xfeff:
            case 0x0009:
            case 0x0020:
            case 0x002c:
                // ,
                ++position;
                continue;
            // LineTerminator ::
            //   - "New Line (U+000A)"
            //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
            //   - "Carriage Return (U+000D)" "New Line (U+000A)"
            case 0x000a:
                // \n
                ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            case 0x000d:
                // \r
                if (body.charCodeAt(position + 1) === 0x000a) position += 2;
                else ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            // Comment
            case 0x0023:
                // #
                return $432db0af72306814$var$readComment(lexer, position);
            // Token ::
            //   - Punctuator
            //   - Name
            //   - IntValue
            //   - FloatValue
            //   - StringValue
            //
            // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
            case 0x0021:
                // !
                return $432db0af72306814$var$createToken(lexer, (0, $g39GT.TokenKind).BANG, position, position + 1);
            case 0x0024:
                // $
                return $432db0af72306814$var$createToken(lexer, (0, $g39GT.TokenKind).DOLLAR, position, position + 1);
            case 0x0026:
                // &
                return $432db0af72306814$var$createToken(lexer, (0, $g39GT.TokenKind).AMP, position, position + 1);
            case 0x0028:
                // (
                return $432db0af72306814$var$createToken(lexer, (0, $g39GT.TokenKind).PAREN_L, position, position + 1);
            case 0x0029:
                // )
                return $432db0af72306814$var$createToken(lexer, (0, $g39GT.TokenKind).PAREN_R, position, position + 1);
            case 0x002e:
                // .
                if (body.charCodeAt(position + 1) === 0x002e && body.charCodeAt(position + 2) === 0x002e) return $432db0af72306814$var$createToken(lexer, (0, $g39GT.TokenKind).SPREAD, position, position + 3);
                break;
            case 0x003a:
                // :
                return $432db0af72306814$var$createToken(lexer, (0, $g39GT.TokenKind).COLON, position, position + 1);
            case 0x003d:
                // =
                return $432db0af72306814$var$createToken(lexer, (0, $g39GT.TokenKind).EQUALS, position, position + 1);
            case 0x0040:
                // @
                return $432db0af72306814$var$createToken(lexer, (0, $g39GT.TokenKind).AT, position, position + 1);
            case 0x005b:
                // [
                return $432db0af72306814$var$createToken(lexer, (0, $g39GT.TokenKind).BRACKET_L, position, position + 1);
            case 0x005d:
                // ]
                return $432db0af72306814$var$createToken(lexer, (0, $g39GT.TokenKind).BRACKET_R, position, position + 1);
            case 0x007b:
                // {
                return $432db0af72306814$var$createToken(lexer, (0, $g39GT.TokenKind).BRACE_L, position, position + 1);
            case 0x007c:
                // |
                return $432db0af72306814$var$createToken(lexer, (0, $g39GT.TokenKind).PIPE, position, position + 1);
            case 0x007d:
                // }
                return $432db0af72306814$var$createToken(lexer, (0, $g39GT.TokenKind).BRACE_R, position, position + 1);
            // StringValue
            case 0x0022:
                // "
                if (body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) return $432db0af72306814$var$readBlockString(lexer, position);
                return $432db0af72306814$var$readString(lexer, position);
        } // IntValue | FloatValue (Digit | -)
        if ((0, $dyxzy.isDigit)(code) || code === 0x002d) return $432db0af72306814$var$readNumber(lexer, position, code);
         // Name
        if ((0, $dyxzy.isNameStart)(code)) return $432db0af72306814$var$readName(lexer, position);
        throw (0, $aB6yt.syntaxError)(lexer.source, position, code === 0x0027 ? 'Unexpected single quote character (\'), did you mean to use a double quote (")?' : $432db0af72306814$var$isUnicodeScalarValue(code) || $432db0af72306814$var$isSupplementaryCodePoint(body, position) ? `Unexpected character: ${$432db0af72306814$var$printCodePointAt(lexer, position)}.` : `Invalid character: ${$432db0af72306814$var$printCodePointAt(lexer, position)}.`);
    }
    return $432db0af72306814$var$createToken(lexer, (0, $g39GT.TokenKind).EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */ function $432db0af72306814$var$readComment(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($432db0af72306814$var$isUnicodeScalarValue(code)) ++position;
        else if ($432db0af72306814$var$isSupplementaryCodePoint(body, position)) position += 2;
        else break;
    }
    return $432db0af72306814$var$createToken(lexer, (0, $g39GT.TokenKind).COMMENT, start, position, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */ function $432db0af72306814$var$readNumber(lexer, start, firstCode) {
    const body = lexer.source.body;
    let position = start;
    let code = firstCode;
    let isFloat = false; // NegativeSign (-)
    if (code === 0x002d) code = body.charCodeAt(++position);
     // Zero (0)
    if (code === 0x0030) {
        code = body.charCodeAt(++position);
        if ((0, $dyxzy.isDigit)(code)) throw (0, $aB6yt.syntaxError)(lexer.source, position, `Invalid number, unexpected digit after 0: ${$432db0af72306814$var$printCodePointAt(lexer, position)}.`);
    } else {
        position = $432db0af72306814$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Full stop (.)
    if (code === 0x002e) {
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $432db0af72306814$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // E e
    if (code === 0x0045 || code === 0x0065) {
        isFloat = true;
        code = body.charCodeAt(++position); // + -
        if (code === 0x002b || code === 0x002d) code = body.charCodeAt(++position);
        position = $432db0af72306814$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 0x002e || (0, $dyxzy.isNameStart)(code)) throw (0, $aB6yt.syntaxError)(lexer.source, position, `Invalid number, expected digit but got: ${$432db0af72306814$var$printCodePointAt(lexer, position)}.`);
    return $432db0af72306814$var$createToken(lexer, isFloat ? (0, $g39GT.TokenKind).FLOAT : (0, $g39GT.TokenKind).INT, start, position, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading one or more digits.
 */ function $432db0af72306814$var$readDigits(lexer, start, firstCode) {
    if (!(0, $dyxzy.isDigit)(firstCode)) throw (0, $aB6yt.syntaxError)(lexer.source, start, `Invalid number, expected digit but got: ${$432db0af72306814$var$printCodePointAt(lexer, start)}.`);
    const body = lexer.source.body;
    let position = start + 1; // +1 to skip first firstCode
    while((0, $dyxzy.isDigit)(body.charCodeAt(position)))++position;
    return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */ function $432db0af72306814$var$readString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    let chunkStart = position;
    let value = '';
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Quote (")
        if (code === 0x0022) {
            value += body.slice(chunkStart, position);
            return $432db0af72306814$var$createToken(lexer, (0, $g39GT.TokenKind).STRING, start, position + 1, value);
        } // Escape Sequence (\)
        if (code === 0x005c) {
            value += body.slice(chunkStart, position);
            const escape = body.charCodeAt(position + 1) === 0x0075 // u
             ? body.charCodeAt(position + 2) === 0x007b // {
             ? $432db0af72306814$var$readEscapedUnicodeVariableWidth(lexer, position) : $432db0af72306814$var$readEscapedUnicodeFixedWidth(lexer, position) : $432db0af72306814$var$readEscapedCharacter(lexer, position);
            value += escape.value;
            position += escape.size;
            chunkStart = position;
            continue;
        } // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($432db0af72306814$var$isUnicodeScalarValue(code)) ++position;
        else if ($432db0af72306814$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $aB6yt.syntaxError)(lexer.source, position, `Invalid character within String: ${$432db0af72306814$var$printCodePointAt(lexer, position)}.`);
    }
    throw (0, $aB6yt.syntaxError)(lexer.source, position, 'Unterminated string.');
} // The string value and lexed size of an escape sequence.
function $432db0af72306814$var$readEscapedUnicodeVariableWidth(lexer, position) {
    const body = lexer.source.body;
    let point = 0;
    let size = 3; // Cannot be larger than 12 chars (\u{00000000}).
    while(size < 12){
        const code = body.charCodeAt(position + size++); // Closing Brace (})
        if (code === 0x007d) {
            // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
            if (size < 5 || !$432db0af72306814$var$isUnicodeScalarValue(point)) break;
            return {
                value: String.fromCodePoint(point),
                size: size
            };
        } // Append this hex digit to the code point.
        point = point << 4 | $432db0af72306814$var$readHexDigit(code);
        if (point < 0) break;
    }
    throw (0, $aB6yt.syntaxError)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + size)}".`);
}
function $432db0af72306814$var$readEscapedUnicodeFixedWidth(lexer, position) {
    const body = lexer.source.body;
    const code = $432db0af72306814$var$read16BitHexCode(body, position + 2);
    if ($432db0af72306814$var$isUnicodeScalarValue(code)) return {
        value: String.fromCodePoint(code),
        size: 6
    };
     // GraphQL allows JSON-style surrogate pair escape sequences, but only when
    // a valid pair is formed.
    if ($432db0af72306814$var$isLeadingSurrogate(code)) // \u
    {
        if (body.charCodeAt(position + 6) === 0x005c && body.charCodeAt(position + 7) === 0x0075) {
            const trailingCode = $432db0af72306814$var$read16BitHexCode(body, position + 8);
            if ($432db0af72306814$var$isTrailingSurrogate(trailingCode)) // JavaScript defines strings as a sequence of UTF-16 code units and
            // encodes Unicode code points above U+FFFF using a surrogate pair of
            // code units. Since this is a surrogate pair escape sequence, just
            // include both codes into the JavaScript string value. Had JavaScript
            // not been internally based on UTF-16, then this surrogate pair would
            // be decoded to retrieve the supplementary code point.
            return {
                value: String.fromCodePoint(code, trailingCode),
                size: 12
            };
        }
    }
    throw (0, $aB6yt.syntaxError)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`);
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */ function $432db0af72306814$var$read16BitHexCode(body, position) {
    // readHexDigit() returns -1 on error. ORing a negative value with any other
    // value always produces a negative value.
    return $432db0af72306814$var$readHexDigit(body.charCodeAt(position)) << 12 | $432db0af72306814$var$readHexDigit(body.charCodeAt(position + 1)) << 8 | $432db0af72306814$var$readHexDigit(body.charCodeAt(position + 2)) << 4 | $432db0af72306814$var$readHexDigit(body.charCodeAt(position + 3));
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */ function $432db0af72306814$var$readHexDigit(code) {
    return code >= 0x0030 && code <= 0x0039 // 0-9
     ? code - 0x0030 : code >= 0x0041 && code <= 0x0046 // A-F
     ? code - 0x0037 : code >= 0x0061 && code <= 0x0066 // a-f
     ? code - 0x0057 : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */ function $432db0af72306814$var$readEscapedCharacter(lexer, position) {
    const body = lexer.source.body;
    const code = body.charCodeAt(position + 1);
    switch(code){
        case 0x0022:
            // "
            return {
                value: '\u0022',
                size: 2
            };
        case 0x005c:
            // \
            return {
                value: '\u005c',
                size: 2
            };
        case 0x002f:
            // /
            return {
                value: '\u002f',
                size: 2
            };
        case 0x0062:
            // b
            return {
                value: '\u0008',
                size: 2
            };
        case 0x0066:
            // f
            return {
                value: '\u000c',
                size: 2
            };
        case 0x006e:
            // n
            return {
                value: '\u000a',
                size: 2
            };
        case 0x0072:
            // r
            return {
                value: '\u000d',
                size: 2
            };
        case 0x0074:
            // t
            return {
                value: '\u0009',
                size: 2
            };
    }
    throw (0, $aB6yt.syntaxError)(lexer.source, position, `Invalid character escape sequence: "${body.slice(position, position + 2)}".`);
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */ function $432db0af72306814$var$readBlockString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let lineStart = lexer.lineStart;
    let position = start + 3;
    let chunkStart = position;
    let currentLine = '';
    const blockLines = [];
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Triple-Quote (""")
        if (code === 0x0022 && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            const token = $432db0af72306814$var$createToken(lexer, (0, $g39GT.TokenKind).BLOCK_STRING, start, position + 3, (0, $2jPxL.dedentBlockStringLines)(blockLines).join('\n'));
            lexer.line += blockLines.length - 1;
            lexer.lineStart = lineStart;
            return token;
        } // Escaped Triple-Quote (\""")
        if (code === 0x005c && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022 && body.charCodeAt(position + 3) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            chunkStart = position + 1; // skip only slash
            position += 4;
            continue;
        } // LineTerminator
        if (code === 0x000a || code === 0x000d) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) position += 2;
            else ++position;
            currentLine = '';
            chunkStart = position;
            lineStart = position;
            continue;
        } // SourceCharacter
        if ($432db0af72306814$var$isUnicodeScalarValue(code)) ++position;
        else if ($432db0af72306814$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $aB6yt.syntaxError)(lexer.source, position, `Invalid character within String: ${$432db0af72306814$var$printCodePointAt(lexer, position)}.`);
    }
    throw (0, $aB6yt.syntaxError)(lexer.source, position, 'Unterminated string.');
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * ```
 * Name ::
 *   - NameStart NameContinue* [lookahead != NameContinue]
 * ```
 */ function $432db0af72306814$var$readName(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position);
        if ((0, $dyxzy.isNameContinue)(code)) ++position;
        else break;
    }
    return $432db0af72306814$var$createToken(lexer, (0, $g39GT.TokenKind).NAME, start, position, body.slice(start, position));
}

});
parcelRegister("2jPxL", function(module, exports) {
$parcel$export(module.exports, "dedentBlockStringLines", function () { return $1b055694180a3ddd$export$d5ee19b441e8d2ae; });
$parcel$export(module.exports, "printBlockString", function () { return $1b055694180a3ddd$export$adb6ca997eeb1f45; });

var $dyxzy = parcelRequire("dyxzy");
function $1b055694180a3ddd$export$d5ee19b441e8d2ae(lines) {
    var _firstNonEmptyLine2;
    let commonIndent = Number.MAX_SAFE_INTEGER;
    let firstNonEmptyLine = null;
    let lastNonEmptyLine = -1;
    for(let i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        const line = lines[i];
        const indent = $1b055694180a3ddd$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map((line, i)=>i === 0 ? line : line.slice(commonIndent)) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function $1b055694180a3ddd$var$leadingWhitespace(str) {
    let i = 0;
    while(i < str.length && (0, $dyxzy.isWhiteSpace)(str.charCodeAt(i)))++i;
    return i;
}
function $1b055694180a3ddd$export$40862a63ef85e395(value) {
    if (value === '') return true; // empty string is printable
    let isEmptyLine = true;
    let hasIndent = false;
    let hasCommonIndent = true;
    let seenNonEmptyLine = false;
    for(let i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
function $1b055694180a3ddd$export$adb6ca997eeb1f45(value, options) {
    const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    const lines = escapedValue.split(/\r\n|[\n\r]/g);
    const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line)=>line.length === 0 || (0, $dyxzy.isWhiteSpace)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    const hasTrailingSlash = value.endsWith('\\');
    const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    const printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    let result = ''; // Format a multi-line block quote to account for leading space.
    const skipLeadingNewLine = isSingleLine && (0, $dyxzy.isWhiteSpace)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += '\n';
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += '\n';
    return '"""' + result + '"""';
}

});
parcelRegister("dyxzy", function(module, exports) {
$parcel$export(module.exports, "isWhiteSpace", function () { return $9de87e1a57cadc26$export$3c52dd84024ae72c; });
$parcel$export(module.exports, "isDigit", function () { return $9de87e1a57cadc26$export$727d9dbc4fbb948f; });
$parcel$export(module.exports, "isNameStart", function () { return $9de87e1a57cadc26$export$45a677ea7cb6d5c8; });
$parcel$export(module.exports, "isNameContinue", function () { return $9de87e1a57cadc26$export$d3f406ff46035894; });
/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $9de87e1a57cadc26$export$3c52dd84024ae72c(code) {
    return code === 0x0009 || code === 0x0020;
}
function $9de87e1a57cadc26$export$727d9dbc4fbb948f(code) {
    return code >= 0x0030 && code <= 0x0039;
}
function $9de87e1a57cadc26$export$79c5d5217943d6a7(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
function $9de87e1a57cadc26$export$45a677ea7cb6d5c8(code) {
    return $9de87e1a57cadc26$export$79c5d5217943d6a7(code) || code === 0x005f;
}
function $9de87e1a57cadc26$export$d3f406ff46035894(code) {
    return $9de87e1a57cadc26$export$79c5d5217943d6a7(code) || $9de87e1a57cadc26$export$727d9dbc4fbb948f(code) || code === 0x005f;
}

});


parcelRegister("g39GT", function(module, exports) {
$parcel$export(module.exports, "TokenKind", function () { return $baf4718b92cdfca0$export$8b9d26ab11394711; });
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $baf4718b92cdfca0$export$8b9d26ab11394711;
(function(TokenKind) {
    TokenKind['SOF'] = '<SOF>';
    TokenKind['EOF'] = '<EOF>';
    TokenKind['BANG'] = '!';
    TokenKind['DOLLAR'] = '$';
    TokenKind['AMP'] = '&';
    TokenKind['PAREN_L'] = '(';
    TokenKind['PAREN_R'] = ')';
    TokenKind['SPREAD'] = '...';
    TokenKind['COLON'] = ':';
    TokenKind['EQUALS'] = '=';
    TokenKind['AT'] = '@';
    TokenKind['BRACKET_L'] = '[';
    TokenKind['BRACKET_R'] = ']';
    TokenKind['BRACE_L'] = '{';
    TokenKind['PIPE'] = '|';
    TokenKind['BRACE_R'] = '}';
    TokenKind['NAME'] = 'Name';
    TokenKind['INT'] = 'Int';
    TokenKind['FLOAT'] = 'Float';
    TokenKind['STRING'] = 'String';
    TokenKind['BLOCK_STRING'] = 'BlockString';
    TokenKind['COMMENT'] = 'Comment';
})($baf4718b92cdfca0$export$8b9d26ab11394711 || ($baf4718b92cdfca0$export$8b9d26ab11394711 = {}));
 /**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */ 
});


parcelRegister("jd7uX", function(module, exports) {
$parcel$export(module.exports, "Source", function () { return $dfc50c34074f35b9$export$1d2df86270c81ecb; });
$parcel$export(module.exports, "isSource", function () { return $dfc50c34074f35b9$export$75135ee9ed6e435b; });

var $ivvU2 = parcelRequire("ivvU2");

var $2fIcn = parcelRequire("2fIcn");

var $bmVFy = parcelRequire("bmVFy");
class $dfc50c34074f35b9$export$1d2df86270c81ecb {
    constructor(body, name = 'GraphQL request', locationOffset = {
        line: 1,
        column: 1
    }){
        typeof body === 'string' || (0, $ivvU2.devAssert)(false, `Body must be a string. Received: ${(0, $2fIcn.inspect)(body)}.`);
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $ivvU2.devAssert)(false, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $ivvU2.devAssert)(false, 'column in locationOffset is 1-indexed and must be positive.');
    }
    get [Symbol.toStringTag]() {
        return 'Source';
    }
}
function $dfc50c34074f35b9$export$75135ee9ed6e435b(source) {
    return (0, $bmVFy.instanceOf)(source, $dfc50c34074f35b9$export$1d2df86270c81ecb);
}

});
parcelRegister("ivvU2", function(module, exports) {
$parcel$export(module.exports, "devAssert", function () { return $d793de775eca8660$export$b6cb5906f04696c8; });
function $d793de775eca8660$export$b6cb5906f04696c8(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("2fIcn", function(module, exports) {
$parcel$export(module.exports, "inspect", function () { return $1a3f44701f868d2e$export$9dec5d1b3b6a130d; });
const $1a3f44701f868d2e$var$MAX_ARRAY_LENGTH = 10;
const $1a3f44701f868d2e$var$MAX_RECURSIVE_DEPTH = 2;
function $1a3f44701f868d2e$export$9dec5d1b3b6a130d(value) {
    return $1a3f44701f868d2e$var$formatValue(value, []);
}
function $1a3f44701f868d2e$var$formatValue(value, seenValues) {
    switch(typeof value){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? `[function ${value.name}]` : '[function]';
        case 'object':
            return $1a3f44701f868d2e$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $1a3f44701f868d2e$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return 'null';
    if (previouslySeenValues.includes(value)) return '[Circular]';
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if ($1a3f44701f868d2e$var$isJSONable(value)) {
        const jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === 'string' ? jsonValue : $1a3f44701f868d2e$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $1a3f44701f868d2e$var$formatArray(value, seenValues);
    return $1a3f44701f868d2e$var$formatObject(value, seenValues);
}
function $1a3f44701f868d2e$var$isJSONable(value) {
    return typeof value.toJSON === 'function';
}
function $1a3f44701f868d2e$var$formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return '{}';
    if (seenValues.length > $1a3f44701f868d2e$var$MAX_RECURSIVE_DEPTH) return '[' + $1a3f44701f868d2e$var$getObjectTag(object) + ']';
    const properties = entries.map(([key, value])=>key + ': ' + $1a3f44701f868d2e$var$formatValue(value, seenValues));
    return '{ ' + properties.join(', ') + ' }';
}
function $1a3f44701f868d2e$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $1a3f44701f868d2e$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    const len = Math.min($1a3f44701f868d2e$var$MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push($1a3f44701f868d2e$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return '[' + items.join(', ') + ']';
}
function $1a3f44701f868d2e$var$getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        const name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});

parcelRegister("bmVFy", function(module, exports) {
$parcel$export(module.exports, "instanceOf", function () { return $846e7bb4d6e20042$export$ca03416d6c9e029e; });

var $2fIcn = parcelRequire("2fIcn");
/* c8 ignore next 3 */ const $846e7bb4d6e20042$var$isProduction = globalThis.process && // eslint-disable-next-line no-undef
true;
const $846e7bb4d6e20042$export$ca03416d6c9e029e = /* c8 ignore next 6 */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
$846e7bb4d6e20042$var$isProduction ? function instanceOf(value, constructor) {
    return value instanceof constructor;
} : function instanceOf(value, constructor) {
    if (value instanceof constructor) return true;
    if (typeof value === 'object' && value !== null) {
        var _value$constructor;
        // Prefer Symbol.toStringTag since it is immune to minification.
        const className = constructor.prototype[Symbol.toStringTag];
        const valueClassName = Symbol.toStringTag in value // @ts-expect-error TS bug see, https://github.com/microsoft/TypeScript/issues/38009
         ? value[Symbol.toStringTag] : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name;
        if (className === valueClassName) {
            const stringifiedValue = (0, $2fIcn.inspect)(value);
            throw new Error(`Cannot use ${className} "${stringifiedValue}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
        }
    }
    return false;
};

});



parcelRegister("hj3p7", function(module, exports) {
$parcel$export(module.exports, "print", function () { return $c996da02a35ccde3$export$c2d084dc44961371; });

var $2jPxL = parcelRequire("2jPxL");

var $jiDqZ = parcelRequire("jiDqZ");

var $hl5HE = parcelRequire("hl5HE");
function $c996da02a35ccde3$export$c2d084dc44961371(ast) {
    return (0, $hl5HE.visit)(ast, $c996da02a35ccde3$var$printDocASTReducer);
}
const $c996da02a35ccde3$var$MAX_LINE_LENGTH = 80;
const $c996da02a35ccde3$var$printDocASTReducer = {
    Name: {
        leave: (node)=>node.value
    },
    Variable: {
        leave: (node)=>'$' + node.name
    },
    // Document
    Document: {
        leave: (node)=>$c996da02a35ccde3$var$join(node.definitions, '\n\n')
    },
    OperationDefinition: {
        leave (node) {
            const varDefs = $c996da02a35ccde3$var$wrap('(', $c996da02a35ccde3$var$join(node.variableDefinitions, ', '), ')');
            const prefix = $c996da02a35ccde3$var$join([
                node.operation,
                $c996da02a35ccde3$var$join([
                    node.name,
                    varDefs
                ]),
                $c996da02a35ccde3$var$join(node.directives, ' ')
            ], ' '); // Anonymous queries with no directives or variable definitions can use
            // the query short form.
            return (prefix === 'query' ? '' : prefix + ' ') + node.selectionSet;
        }
    },
    VariableDefinition: {
        leave: ({ variable: variable, type: type, defaultValue: defaultValue, directives: directives })=>variable + ': ' + type + $c996da02a35ccde3$var$wrap(' = ', defaultValue) + $c996da02a35ccde3$var$wrap(' ', $c996da02a35ccde3$var$join(directives, ' '))
    },
    SelectionSet: {
        leave: ({ selections: selections })=>$c996da02a35ccde3$var$block(selections)
    },
    Field: {
        leave ({ alias: alias, name: name, arguments: args, directives: directives, selectionSet: selectionSet }) {
            const prefix = $c996da02a35ccde3$var$wrap('', alias, ': ') + name;
            let argsLine = prefix + $c996da02a35ccde3$var$wrap('(', $c996da02a35ccde3$var$join(args, ', '), ')');
            if (argsLine.length > $c996da02a35ccde3$var$MAX_LINE_LENGTH) argsLine = prefix + $c996da02a35ccde3$var$wrap('(\n', $c996da02a35ccde3$var$indent($c996da02a35ccde3$var$join(args, '\n')), '\n)');
            return $c996da02a35ccde3$var$join([
                argsLine,
                $c996da02a35ccde3$var$join(directives, ' '),
                selectionSet
            ], ' ');
        }
    },
    Argument: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Fragments
    FragmentSpread: {
        leave: ({ name: name, directives: directives })=>'...' + name + $c996da02a35ccde3$var$wrap(' ', $c996da02a35ccde3$var$join(directives, ' '))
    },
    InlineFragment: {
        leave: ({ typeCondition: typeCondition, directives: directives, selectionSet: selectionSet })=>$c996da02a35ccde3$var$join([
                '...',
                $c996da02a35ccde3$var$wrap('on ', typeCondition),
                $c996da02a35ccde3$var$join(directives, ' '),
                selectionSet
            ], ' ')
    },
    FragmentDefinition: {
        leave: ({ name: name, typeCondition: typeCondition, variableDefinitions: variableDefinitions, directives: directives, selectionSet: selectionSet })=>// or removed in the future.
            `fragment ${name}${$c996da02a35ccde3$var$wrap('(', $c996da02a35ccde3$var$join(variableDefinitions, ', '), ')')} ` + `on ${typeCondition} ${$c996da02a35ccde3$var$wrap('', $c996da02a35ccde3$var$join(directives, ' '), ' ')}` + selectionSet
    },
    // Value
    IntValue: {
        leave: ({ value: value })=>value
    },
    FloatValue: {
        leave: ({ value: value })=>value
    },
    StringValue: {
        leave: ({ value: value, block: isBlockString })=>isBlockString ? (0, $2jPxL.printBlockString)(value) : (0, $jiDqZ.printString)(value)
    },
    BooleanValue: {
        leave: ({ value: value })=>value ? 'true' : 'false'
    },
    NullValue: {
        leave: ()=>'null'
    },
    EnumValue: {
        leave: ({ value: value })=>value
    },
    ListValue: {
        leave: ({ values: values })=>'[' + $c996da02a35ccde3$var$join(values, ', ') + ']'
    },
    ObjectValue: {
        leave: ({ fields: fields })=>'{' + $c996da02a35ccde3$var$join(fields, ', ') + '}'
    },
    ObjectField: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Directive
    Directive: {
        leave: ({ name: name, arguments: args })=>'@' + name + $c996da02a35ccde3$var$wrap('(', $c996da02a35ccde3$var$join(args, ', '), ')')
    },
    // Type
    NamedType: {
        leave: ({ name: name })=>name
    },
    ListType: {
        leave: ({ type: type })=>'[' + type + ']'
    },
    NonNullType: {
        leave: ({ type: type })=>type + '!'
    },
    // Type System Definitions
    SchemaDefinition: {
        leave: ({ description: description, directives: directives, operationTypes: operationTypes })=>$c996da02a35ccde3$var$wrap('', description, '\n') + $c996da02a35ccde3$var$join([
                'schema',
                $c996da02a35ccde3$var$join(directives, ' '),
                $c996da02a35ccde3$var$block(operationTypes)
            ], ' ')
    },
    OperationTypeDefinition: {
        leave: ({ operation: operation, type: type })=>operation + ': ' + type
    },
    ScalarTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$c996da02a35ccde3$var$wrap('', description, '\n') + $c996da02a35ccde3$var$join([
                'scalar',
                name,
                $c996da02a35ccde3$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$c996da02a35ccde3$var$wrap('', description, '\n') + $c996da02a35ccde3$var$join([
                'type',
                name,
                $c996da02a35ccde3$var$wrap('implements ', $c996da02a35ccde3$var$join(interfaces, ' & ')),
                $c996da02a35ccde3$var$join(directives, ' '),
                $c996da02a35ccde3$var$block(fields)
            ], ' ')
    },
    FieldDefinition: {
        leave: ({ description: description, name: name, arguments: args, type: type, directives: directives })=>$c996da02a35ccde3$var$wrap('', description, '\n') + name + ($c996da02a35ccde3$var$hasMultilineItems(args) ? $c996da02a35ccde3$var$wrap('(\n', $c996da02a35ccde3$var$indent($c996da02a35ccde3$var$join(args, '\n')), '\n)') : $c996da02a35ccde3$var$wrap('(', $c996da02a35ccde3$var$join(args, ', '), ')')) + ': ' + type + $c996da02a35ccde3$var$wrap(' ', $c996da02a35ccde3$var$join(directives, ' '))
    },
    InputValueDefinition: {
        leave: ({ description: description, name: name, type: type, defaultValue: defaultValue, directives: directives })=>$c996da02a35ccde3$var$wrap('', description, '\n') + $c996da02a35ccde3$var$join([
                name + ': ' + type,
                $c996da02a35ccde3$var$wrap('= ', defaultValue),
                $c996da02a35ccde3$var$join(directives, ' ')
            ], ' ')
    },
    InterfaceTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$c996da02a35ccde3$var$wrap('', description, '\n') + $c996da02a35ccde3$var$join([
                'interface',
                name,
                $c996da02a35ccde3$var$wrap('implements ', $c996da02a35ccde3$var$join(interfaces, ' & ')),
                $c996da02a35ccde3$var$join(directives, ' '),
                $c996da02a35ccde3$var$block(fields)
            ], ' ')
    },
    UnionTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, types: types })=>$c996da02a35ccde3$var$wrap('', description, '\n') + $c996da02a35ccde3$var$join([
                'union',
                name,
                $c996da02a35ccde3$var$join(directives, ' '),
                $c996da02a35ccde3$var$wrap('= ', $c996da02a35ccde3$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, values: values })=>$c996da02a35ccde3$var$wrap('', description, '\n') + $c996da02a35ccde3$var$join([
                'enum',
                name,
                $c996da02a35ccde3$var$join(directives, ' '),
                $c996da02a35ccde3$var$block(values)
            ], ' ')
    },
    EnumValueDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$c996da02a35ccde3$var$wrap('', description, '\n') + $c996da02a35ccde3$var$join([
                name,
                $c996da02a35ccde3$var$join(directives, ' ')
            ], ' ')
    },
    InputObjectTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, fields: fields })=>$c996da02a35ccde3$var$wrap('', description, '\n') + $c996da02a35ccde3$var$join([
                'input',
                name,
                $c996da02a35ccde3$var$join(directives, ' '),
                $c996da02a35ccde3$var$block(fields)
            ], ' ')
    },
    DirectiveDefinition: {
        leave: ({ description: description, name: name, arguments: args, repeatable: repeatable, locations: locations })=>$c996da02a35ccde3$var$wrap('', description, '\n') + 'directive @' + name + ($c996da02a35ccde3$var$hasMultilineItems(args) ? $c996da02a35ccde3$var$wrap('(\n', $c996da02a35ccde3$var$indent($c996da02a35ccde3$var$join(args, '\n')), '\n)') : $c996da02a35ccde3$var$wrap('(', $c996da02a35ccde3$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $c996da02a35ccde3$var$join(locations, ' | ')
    },
    SchemaExtension: {
        leave: ({ directives: directives, operationTypes: operationTypes })=>$c996da02a35ccde3$var$join([
                'extend schema',
                $c996da02a35ccde3$var$join(directives, ' '),
                $c996da02a35ccde3$var$block(operationTypes)
            ], ' ')
    },
    ScalarTypeExtension: {
        leave: ({ name: name, directives: directives })=>$c996da02a35ccde3$var$join([
                'extend scalar',
                name,
                $c996da02a35ccde3$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$c996da02a35ccde3$var$join([
                'extend type',
                name,
                $c996da02a35ccde3$var$wrap('implements ', $c996da02a35ccde3$var$join(interfaces, ' & ')),
                $c996da02a35ccde3$var$join(directives, ' '),
                $c996da02a35ccde3$var$block(fields)
            ], ' ')
    },
    InterfaceTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$c996da02a35ccde3$var$join([
                'extend interface',
                name,
                $c996da02a35ccde3$var$wrap('implements ', $c996da02a35ccde3$var$join(interfaces, ' & ')),
                $c996da02a35ccde3$var$join(directives, ' '),
                $c996da02a35ccde3$var$block(fields)
            ], ' ')
    },
    UnionTypeExtension: {
        leave: ({ name: name, directives: directives, types: types })=>$c996da02a35ccde3$var$join([
                'extend union',
                name,
                $c996da02a35ccde3$var$join(directives, ' '),
                $c996da02a35ccde3$var$wrap('= ', $c996da02a35ccde3$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeExtension: {
        leave: ({ name: name, directives: directives, values: values })=>$c996da02a35ccde3$var$join([
                'extend enum',
                name,
                $c996da02a35ccde3$var$join(directives, ' '),
                $c996da02a35ccde3$var$block(values)
            ], ' ')
    },
    InputObjectTypeExtension: {
        leave: ({ name: name, directives: directives, fields: fields })=>$c996da02a35ccde3$var$join([
                'extend input',
                name,
                $c996da02a35ccde3$var$join(directives, ' '),
                $c996da02a35ccde3$var$block(fields)
            ], ' ')
    }
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $c996da02a35ccde3$var$join(maybeArray, separator = '') {
    var _maybeArray$filter$jo;
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter((x)=>x).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */ function $c996da02a35ccde3$var$block(array) {
    return $c996da02a35ccde3$var$wrap('{\n', $c996da02a35ccde3$var$indent($c996da02a35ccde3$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $c996da02a35ccde3$var$wrap(start, maybeString, end = '') {
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $c996da02a35ccde3$var$indent(str) {
    return $c996da02a35ccde3$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $c996da02a35ccde3$var$hasMultilineItems(maybeArray) {
    var _maybeArray$some;
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some((str)=>str.includes('\n'))) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}

});
parcelRegister("jiDqZ", function(module, exports) {
$parcel$export(module.exports, "printString", function () { return $e0ce49993bc5e5b4$export$3cdec7cf614a0ecc; });
/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */ function $e0ce49993bc5e5b4$export$3cdec7cf614a0ecc(str) {
    return `"${str.replace($e0ce49993bc5e5b4$var$escapedRegExp, $e0ce49993bc5e5b4$var$escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex
const $e0ce49993bc5e5b4$var$escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $e0ce49993bc5e5b4$var$escapedReplacer(str) {
    return $e0ce49993bc5e5b4$var$escapeSequences[str.charCodeAt(0)];
} // prettier-ignore
const $e0ce49993bc5e5b4$var$escapeSequences = [
    '\\u0000',
    '\\u0001',
    '\\u0002',
    '\\u0003',
    '\\u0004',
    '\\u0005',
    '\\u0006',
    '\\u0007',
    '\\b',
    '\\t',
    '\\n',
    '\\u000B',
    '\\f',
    '\\r',
    '\\u000E',
    '\\u000F',
    '\\u0010',
    '\\u0011',
    '\\u0012',
    '\\u0013',
    '\\u0014',
    '\\u0015',
    '\\u0016',
    '\\u0017',
    '\\u0018',
    '\\u0019',
    '\\u001A',
    '\\u001B',
    '\\u001C',
    '\\u001D',
    '\\u001E',
    '\\u001F',
    '',
    '',
    '\\"',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\\\',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\u007F',
    '\\u0080',
    '\\u0081',
    '\\u0082',
    '\\u0083',
    '\\u0084',
    '\\u0085',
    '\\u0086',
    '\\u0087',
    '\\u0088',
    '\\u0089',
    '\\u008A',
    '\\u008B',
    '\\u008C',
    '\\u008D',
    '\\u008E',
    '\\u008F',
    '\\u0090',
    '\\u0091',
    '\\u0092',
    '\\u0093',
    '\\u0094',
    '\\u0095',
    '\\u0096',
    '\\u0097',
    '\\u0098',
    '\\u0099',
    '\\u009A',
    '\\u009B',
    '\\u009C',
    '\\u009D',
    '\\u009E',
    '\\u009F'
];

});

parcelRegister("hl5HE", function(module, exports) {
$parcel$export(module.exports, "BREAK", function () { return $c9f8d253aaeabceb$export$a89c95c098ac2a58; });
$parcel$export(module.exports, "visit", function () { return $c9f8d253aaeabceb$export$bf638b60ea8b89b7; });

var $ivvU2 = parcelRequire("ivvU2");

var $2fIcn = parcelRequire("2fIcn");

var $aGcUy = parcelRequire("aGcUy");

var $dgoM9 = parcelRequire("dgoM9");
const $c9f8d253aaeabceb$export$a89c95c098ac2a58 = Object.freeze({});
function $c9f8d253aaeabceb$export$bf638b60ea8b89b7(root, visitor, visitorKeys = (0, $aGcUy.QueryDocumentKeys)) {
    const enterLeaveMap = new Map();
    for (const kind of Object.values((0, $dgoM9.Kind)))enterLeaveMap.set(kind, $c9f8d253aaeabceb$export$736de8489257458(visitor, kind));
    /* eslint-disable no-undef-init */ let stack = undefined;
    let inArray = Array.isArray(root);
    let keys = [
        root
    ];
    let index = -1;
    let edits = [];
    let node = root;
    let key = undefined;
    let parent = undefined;
    const path = [];
    const ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        const isLeaving = index === keys.length;
        const isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    let editOffset = 0;
                    for (const [editKey, editValue] of edits){
                        const arrayKey = editKey - editOffset;
                        if (editValue === null) {
                            node.splice(arrayKey, 1);
                            editOffset++;
                        } else node[arrayKey] = editValue;
                    }
                } else {
                    node = Object.defineProperties({}, Object.getOwnPropertyDescriptors(node));
                    for (const [editKey, editValue] of edits)node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        let result;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, $aGcUy.isNode)(node) || (0, $ivvU2.devAssert)(false, `Invalid AST Node: ${(0, $2fIcn.inspect)(node)}.`);
            const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === $c9f8d253aaeabceb$export$a89c95c098ac2a58) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, $aGcUy.isNode)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
function $c9f8d253aaeabceb$export$728beebeea393478(visitors) {
    const skipping = new Array(visitors.length).fill(null);
    const mergedVisitor = Object.create(null);
    for (const kind of Object.values((0, $dgoM9.Kind))){
        let hasVisitor = false;
        const enterList = new Array(visitors.length).fill(undefined);
        const leaveList = new Array(visitors.length).fill(undefined);
        for(let i = 0; i < visitors.length; ++i){
            const { enter: enter, leave: leave } = $c9f8d253aaeabceb$export$736de8489257458(visitors[i], kind);
            hasVisitor || (hasVisitor = enter != null || leave != null);
            enterList[i] = enter;
            leaveList[i] = leave;
        }
        if (!hasVisitor) continue;
        const mergedEnterLeave = {
            enter (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                    var _enterList$i;
                    const result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                    if (result === false) skipping[i] = node;
                    else if (result === $c9f8d253aaeabceb$export$a89c95c098ac2a58) skipping[i] = $c9f8d253aaeabceb$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            },
            leave (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++){
                    if (skipping[i] === null) {
                        var _leaveList$i;
                        const result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                        if (result === $c9f8d253aaeabceb$export$a89c95c098ac2a58) skipping[i] = $c9f8d253aaeabceb$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    } else if (skipping[i] === node) skipping[i] = null;
                }
            }
        };
        mergedVisitor[kind] = mergedEnterLeave;
    }
    return mergedVisitor;
}
function $c9f8d253aaeabceb$export$736de8489257458(visitor, kind) {
    const kindVisitor = visitor[kind];
    if (typeof kindVisitor === 'object') // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === 'function') // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
function $c9f8d253aaeabceb$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    const { enter: enter, leave: leave } = $c9f8d253aaeabceb$export$736de8489257458(visitor, kind);
    return isLeaving ? leave : enter;
}

});



parcelRegister("1iZL3", function(module, exports) {
$parcel$export(module.exports, "ClientError", function () { return $0f3760bf22470851$export$bb8c263ad32caa8; });
class $0f3760bf22470851$export$bb8c263ad32caa8 extends Error {
    constructor(response, request){
        const message = `${$0f3760bf22470851$export$bb8c263ad32caa8.extractMessage(response)}: ${JSON.stringify({
            response: response,
            request: request
        })}`;
        super(message);
        Object.setPrototypeOf(this, $0f3760bf22470851$export$bb8c263ad32caa8.prototype);
        this.response = response;
        this.request = request;
        // this is needed as Safari doesn't support .captureStackTrace
        if (typeof Error.captureStackTrace === `function`) Error.captureStackTrace(this, $0f3760bf22470851$export$bb8c263ad32caa8);
    }
    static extractMessage(response) {
        return response.errors?.[0]?.message ?? `GraphQL Error (Code: ${response.status})`;
    }
}

});

parcelRegister("6FOC8", function(module, exports) {
// Save global object in a variable
var __global__ = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || typeof $parcel$global !== 'undefined' && $parcel$global;
// Create an object that extends from __global__ without the fetch function
var __globalThis__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = __global__.DOMException;
    }
    F.prototype = __global__; // Needed for feature detection on whatwg-fetch's code
    return new F();
}();
// Wraps whatwg-fetch with a function scope to hijack the global object
// "globalThis" that's going to be patched
(function(globalThis1) {
    var irrelevant = function(exports1) {
        /* eslint-disable no-prototype-builtins */ var g = typeof globalThis1 !== 'undefined' && globalThis1 || typeof self !== 'undefined' && self || // eslint-disable-next-line no-undef
        typeof $parcel$global !== 'undefined' && $parcel$global || {};
        var support = {
            searchParams: 'URLSearchParams' in g,
            iterable: 'Symbol' in g && 'iterator' in Symbol,
            blob: 'FileReader' in g && 'Blob' in g && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: 'FormData' in g,
            arrayBuffer: 'ArrayBuffer' in g
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                '[object Int8Array]',
                '[object Uint8Array]',
                '[object Uint8ClampedArray]',
                '[object Int16Array]',
                '[object Uint16Array]',
                '[object Int32Array]',
                '[object Uint32Array]',
                '[object Float32Array]',
                '[object Float64Array]'
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== 'string') name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== 'string') value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ', ' + value : value;
        };
        Headers.prototype['delete'] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body._noBody) return;
            if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
            var encoding = match ? match[1] : 'utf-8';
            reader.readAsText(blob, encoding);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join('');
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */ // eslint-disable-next-line no-self-assign
                this.bodyUsed = this.bodyUsed;
                this._bodyInit = body;
                if (!body) {
                    this._noBody = true;
                    this._bodyText = '';
                } else if (typeof body === 'string') this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get('content-type')) {
                    if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                }
            };
            if (support.blob) this.blob = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                    this._bodyArrayBuffer
                ]));
                else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
                else return Promise.resolve(new Blob([
                    this._bodyText
                ]));
            };
            this.arrayBuffer = function() {
                if (this._bodyArrayBuffer) {
                    var isConsumed = consumed(this);
                    if (isConsumed) return isConsumed;
                    else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
                    else return Promise.resolve(this._bodyArrayBuffer);
                } else if (support.blob) return this.blob().then(readBlobAsArrayBuffer);
                else throw new Error('could not read as ArrayBuffer');
            };
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error('could not read FormData body as text');
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            'CONNECT',
            'DELETE',
            'GET',
            'HEAD',
            'OPTIONS',
            'PATCH',
            'POST',
            'PUT',
            'TRACE'
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            if (!(this instanceof Request)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError('Already read');
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || 'same-origin';
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || 'GET');
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal || function() {
                if ('AbortController' in g) {
                    var ctrl = new AbortController();
                    return ctrl.signal;
                }
            }();
            this.referrer = null;
            if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
            this._initBody(body);
            if (this.method === 'GET' || this.method === 'HEAD') {
                if (options.cache === 'no-store' || options.cache === 'no-cache') {
                    // Search for a '_' parameter in the query string
                    var reParamSearch = /([?&])_=[^&]*/;
                    if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
                    this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
                    else {
                        // Otherwise add a new '_' parameter to the end with the current time
                        var reQueryString = /\?/;
                        this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
                    }
                }
            }
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split('&').forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split('=');
                    var name = split.shift().replace(/\+/g, ' ');
                    var value = split.join('=').replace(/\+/g, ' ');
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
            // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
            // https://github.com/github/fetch/issues/748
            // https://github.com/zloirock/core-js/issues/751
            preProcessedHeaders.split('\r').map(function(header) {
                return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
            }).forEach(function(line) {
                var parts = line.split(':');
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(':').trim();
                    try {
                        headers.append(key, value);
                    } catch (error) {
                        console.warn('Response ' + error.message);
                    }
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!(this instanceof Response)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            if (!options) options = {};
            this.type = 'default';
            this.status = options.status === undefined ? 200 : options.status;
            if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
            this.headers = new Headers(options.headers);
            this.url = options.url || '';
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 200,
                statusText: ''
            });
            response.ok = false;
            response.status = 0;
            response.type = 'error';
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = g.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException('Aborted', 'AbortError'));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
                    };
                    // This check if specifically for when a user fetches a file locally from the file system
                    // Only if the status is out of a normal range
                    if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
                    else options.status = xhr.status;
                    options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
                    var body = 'response' in xhr ? xhr.response : xhr.responseText;
                    setTimeout(function() {
                        resolve(new Response(body, options));
                    }, 0);
                };
                xhr.onerror = function() {
                    setTimeout(function() {
                        reject(new TypeError('Network request failed'));
                    }, 0);
                };
                xhr.ontimeout = function() {
                    setTimeout(function() {
                        reject(new TypeError('Network request timed out'));
                    }, 0);
                };
                xhr.onabort = function() {
                    setTimeout(function() {
                        reject(new exports1.DOMException('Aborted', 'AbortError'));
                    }, 0);
                };
                function fixUrl(url) {
                    try {
                        return url === '' && g.location.href ? g.location.href : url;
                    } catch (e) {
                        return url;
                    }
                }
                xhr.open(request.method, fixUrl(request.url), true);
                if (request.credentials === 'include') xhr.withCredentials = true;
                else if (request.credentials === 'omit') xhr.withCredentials = false;
                if ('responseType' in xhr) {
                    if (support.blob) xhr.responseType = 'blob';
                    else if (support.arrayBuffer) xhr.responseType = 'arraybuffer';
                }
                if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers || g.Headers && init.headers instanceof g.Headers)) {
                    var names = [];
                    Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                        names.push(normalizeName(name));
                        xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
                    });
                    request.headers.forEach(function(value, name) {
                        if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
                    });
                } else request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener('abort', abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!g.fetch) {
            g.fetch = fetch;
            g.Headers = Headers;
            g.Request = Request;
            g.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
        return exports1;
    }({});
})(__globalThis__);
// This is a ponyfill, so...
__globalThis__.fetch.ponyfill = true;
delete __globalThis__.fetch.polyfill;
// Choose between native implementation (__global__) or custom implementation (__globalThis__)
var ctx = __global__.fetch ? __global__ : __globalThis__;
exports = ctx.fetch; // To enable: import fetch from 'cross-fetch'
exports.default = ctx.fetch; // For TypeScript consumers without esModuleInterop.
exports.fetch = ctx.fetch; // To enable: import {fetch} from 'cross-fetch'
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRegister("fuprL", function(module, exports) {
/* eslint-disable */ 
var $Xz7Q6 = parcelRequire("Xz7Q6");

var $1iZL3 = parcelRequire("1iZL3");
// import type WebSocket from 'ws'
const $b46d659564fbec9f$var$CONNECTION_INIT = `connection_init`;
const $b46d659564fbec9f$var$CONNECTION_ACK = `connection_ack`;
const $b46d659564fbec9f$var$PING = `ping`;
const $b46d659564fbec9f$var$PONG = `pong`;
const $b46d659564fbec9f$var$SUBSCRIBE = `subscribe`;
const $b46d659564fbec9f$var$NEXT = `next`;
const $b46d659564fbec9f$var$ERROR = `error`;
const $b46d659564fbec9f$var$COMPLETE = `complete`;
class $b46d659564fbec9f$var$GraphQLWebSocketMessage {
    get type() {
        return this._type;
    }
    get id() {
        return this._id;
    }
    get payload() {
        return this._payload;
    }
    constructor(type, payload, id){
        this._type = type;
        this._payload = payload;
        this._id = id;
    }
    get text() {
        const result = {
            type: this.type
        };
        if (this.id != null && this.id != undefined) result.id = this.id;
        if (this.payload != null && this.payload != undefined) result.payload = this.payload;
        return JSON.stringify(result);
    }
    static parse(data, f) {
        const { type: type, payload: payload, id: id } = JSON.parse(data);
        return new $b46d659564fbec9f$var$GraphQLWebSocketMessage(type, f(payload), id);
    }
}
class $b46d659564fbec9f$export$5eb90cb6288c26cf {
    constructor(socket, { onInit: onInit, onAcknowledged: onAcknowledged, onPing: onPing, onPong: onPong }){
        this.socketState = {
            acknowledged: false,
            lastRequestId: 0,
            subscriptions: {}
        };
        this.socket = socket;
        socket.addEventListener(`open`, async (e)=>{
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
            socket.send($b46d659564fbec9f$var$ConnectionInit(onInit ? await onInit() : null).text);
        });
        socket.addEventListener(`close`, (e)=>{
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
        });
        socket.addEventListener(`error`, (e)=>{
            console.error(e);
        });
        socket.addEventListener(`message`, (e)=>{
            try {
                const message = $b46d659564fbec9f$var$parseMessage(e.data);
                switch(message.type){
                    case $b46d659564fbec9f$var$CONNECTION_ACK:
                        if (this.socketState.acknowledged) console.warn(`Duplicate CONNECTION_ACK message ignored`);
                        else {
                            this.socketState.acknowledged = true;
                            if (onAcknowledged) onAcknowledged(message.payload);
                        }
                        return;
                    case $b46d659564fbec9f$var$PING:
                        if (onPing) onPing(message.payload).then((r)=>socket.send($b46d659564fbec9f$var$Pong(r).text));
                        else socket.send($b46d659564fbec9f$var$Pong(null).text);
                        return;
                    case $b46d659564fbec9f$var$PONG:
                        if (onPong) onPong(message.payload);
                        return;
                }
                if (!this.socketState.acknowledged) // Web-socket connection not acknowledged
                return;
                if (message.id === undefined || message.id === null || !this.socketState.subscriptions[message.id]) // No subscription identifer or subscription indentifier is not found
                return;
                const { query: query, variables: variables, subscriber: subscriber } = this.socketState.subscriptions[message.id];
                switch(message.type){
                    case $b46d659564fbec9f$var$NEXT:
                        if (!message.payload.errors && message.payload.data) subscriber.next && subscriber.next(message.payload.data);
                        if (message.payload.errors) subscriber.error && subscriber.error(new (0, $1iZL3.ClientError)({
                            ...message.payload,
                            status: 200
                        }, {
                            query: query,
                            variables: variables
                        }));
                        return;
                    case $b46d659564fbec9f$var$ERROR:
                        subscriber.error && subscriber.error(new (0, $1iZL3.ClientError)({
                            errors: message.payload,
                            status: 200
                        }, {
                            query: query,
                            variables: variables
                        }));
                        return;
                    case $b46d659564fbec9f$var$COMPLETE:
                        subscriber.complete && subscriber.complete();
                        delete this.socketState.subscriptions[message.id];
                        return;
                }
            } catch (e) {
                // Unexpected errors while handling graphql-ws message
                console.error(e);
                socket.close(1006);
            }
            socket.close(4400, `Unknown graphql-ws message.`);
        });
    }
    makeSubscribe(query, operationName, subscriber, variables) {
        const subscriptionId = (this.socketState.lastRequestId++).toString();
        this.socketState.subscriptions[subscriptionId] = {
            query: query,
            variables: variables,
            subscriber: subscriber
        };
        this.socket.send($b46d659564fbec9f$var$Subscribe(subscriptionId, {
            query: query,
            operationName: operationName,
            variables: variables
        }).text);
        return ()=>{
            this.socket.send($b46d659564fbec9f$var$Complete(subscriptionId).text);
            delete this.socketState.subscriptions[subscriptionId];
        };
    }
    rawRequest(query, variables) {
        return new Promise((resolve, reject)=>{
            let result;
            this.rawSubscribe(query, {
                next: (data, extensions)=>result = {
                        data: data,
                        extensions: extensions
                    },
                error: reject,
                complete: ()=>resolve(result)
            }, variables);
        });
    }
    request(document, variables) {
        return new Promise((resolve, reject)=>{
            let result;
            this.subscribe(document, {
                next: (data)=>result = data,
                error: reject,
                complete: ()=>resolve(result)
            }, variables);
        });
    }
    subscribe(document, subscriber, variables) {
        const { query: query, operationName: operationName } = (0, $Xz7Q6.resolveRequestDocument)(document);
        return this.makeSubscribe(query, operationName, subscriber, variables);
    }
    rawSubscribe(query, subscriber, variables) {
        return this.makeSubscribe(query, undefined, subscriber, variables);
    }
    ping(payload) {
        this.socket.send($b46d659564fbec9f$var$Ping(payload).text);
    }
    close() {
        this.socket.close(1000);
    }
}
$b46d659564fbec9f$export$5eb90cb6288c26cf.PROTOCOL = `graphql-transport-ws`;
// Helper functions
function $b46d659564fbec9f$var$parseMessage(data, f = (a)=>a) {
    const m = $b46d659564fbec9f$var$GraphQLWebSocketMessage.parse(data, f);
    return m;
}
function $b46d659564fbec9f$var$ConnectionInit(payload) {
    return new $b46d659564fbec9f$var$GraphQLWebSocketMessage($b46d659564fbec9f$var$CONNECTION_INIT, payload);
}
function $b46d659564fbec9f$var$Ping(payload) {
    return new $b46d659564fbec9f$var$GraphQLWebSocketMessage($b46d659564fbec9f$var$PING, payload, undefined);
}
function $b46d659564fbec9f$var$Pong(payload) {
    return new $b46d659564fbec9f$var$GraphQLWebSocketMessage($b46d659564fbec9f$var$PONG, payload, undefined);
}
function $b46d659564fbec9f$var$Subscribe(id, payload) {
    return new $b46d659564fbec9f$var$GraphQLWebSocketMessage($b46d659564fbec9f$var$SUBSCRIBE, payload, id);
}
function $b46d659564fbec9f$var$Complete(id) {
    return new $b46d659564fbec9f$var$GraphQLWebSocketMessage($b46d659564fbec9f$var$COMPLETE, undefined, id);
}

});






parcelRegister("iKNCS", function(module, exports) {
$parcel$export(module.exports, "AiRefreshSection", function () { return $b7205ca5f6b32aa0$export$53cedacbbc185d7; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $f11bi = parcelRequire("f11bi");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $kgXas = parcelRequire("kgXas");

var $b3ukl = parcelRequire("b3ukl");
var $kHvUj = parcelRequire("kHvUj");

var $hLTRc = parcelRequire("hLTRc");
const $b7205ca5f6b32aa0$export$53cedacbbc185d7 = ()=>{
    const intl = (0, $8e22h.default)();
    const useGWP7617Gate = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7617JiraShortTermAiInfusionGate);
    if (useGWP7617Gate) return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $b3ukl.FeaturedInfoSection), {
        variant: (0, $kHvUj.LAUNCH),
        eyebrow: intl.formatMessage({
            id: 'JiraSoftwarePageTemplate.AiRefreshSection.eyebrow',
            defaultMessage: 'Plan, Track, and Collaborate'
        }),
        header: intl.formatMessage({
            id: 'JiraSoftwarePageTemplate.AiRefreshSection.heading',
            defaultMessage: 'Where your team + AI come together'
        }),
        description: intl.formatMessage({
            id: 'JiraSoftwarePageTemplate.AiRefreshSection.description',
            defaultMessage: "Jira\u2019s AI helps teams drive better outcomes, faster."
        }),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f11bi.FeaturedInfoCard), {
                video: {
                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/374p64xck763gywok4l212n24sji512r.mp4',
                    controls: false,
                    autoplay: true,
                    muted: true,
                    loop: true,
                    width: 1300,
                    height: 694
                },
                Icon: (0, $hLTRc.TimelineIcon),
                title: intl.formatMessage({
                    id: 'JiraSoftwarePage.AiRefreshSection.Card1.Title',
                    defaultMessage: 'Jumpstart planning'
                }),
                body: intl.formatMessage({
                    id: 'JiraSoftwarePage.AiRefreshSection.Card1.Description',
                    defaultMessage: 'Create work items from your favorite tools, then use AI to break down big ideas, polish descriptions, and link relevant resources in a snap.'
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f11bi.FeaturedInfoCard), {
                image: {
                    image: {
                        // eslint-disable-next-line local/no-non-orangelogic-images-eslint
                        src: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-ai-refresh/workflow-builder.webp',
                        alt: intl.formatMessage({
                            id: 'JiraSoftwarePage.AiRefreshSection.Card2.ImageAlt',
                            defaultMessage: 'Shared release date module in Jira'
                        })
                    }
                },
                Icon: (0, $hLTRc.RedoIcon),
                title: intl.formatMessage({
                    id: 'JiraSoftwarePage.AiRefreshSection.Card2.Title',
                    defaultMessage: 'Focus on impact'
                }),
                body: intl.formatMessage({
                    id: 'JiraSoftwarePage.AiRefreshSection.Card2.Description',
                    defaultMessage: 'Cut down on admin with AI agents that make it easier to create project plans, identify trends, and flag potential risks.'
                }),
                ctaProps: {
                    link: {
                        text: intl.formatMessage({
                            id: 'JiraSoftwarePage.AiRefreshSection.Card2.LinkText',
                            defaultMessage: 'Meet Rovo agents'
                        }),
                        href: '/software/rovo/use-cases?feature=agent&'
                    }
                }
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f11bi.FeaturedInfoCard), {
                image: {
                    image: {
                        // eslint-disable-next-line local/no-non-orangelogic-images-eslint
                        src: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-ai-refresh/linked-work-items.webp',
                        alt: intl.formatMessage({
                            id: 'JiraSoftwarePage.AiRefreshSection.Card3.ImageAlt',
                            defaultMessage: 'Shared release date module in Jira'
                        })
                    }
                },
                Icon: (0, $hLTRc.FastIcon),
                title: intl.formatMessage({
                    id: 'JiraSoftwarePage.AiRefreshSection.Card3.Title',
                    defaultMessage: 'Stay in sync'
                }),
                body: intl.formatMessage({
                    id: 'JiraSoftwarePage.AiRefreshSection.Card3.Description',
                    defaultMessage: 'Surface related work, summarize lengthy comments, and connect work to company goals to give your team the details they need to work faster and make better decisions.'
                }),
                ctaProps: {
                    link: {
                        text: intl.formatMessage({
                            id: 'JiraSoftwarePage.AiRefreshSection.Card3.LinkText',
                            defaultMessage: 'Explore AI features'
                        }),
                        href: '/software/jira/ai'
                    }
                }
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kgXas.Ai), {});
};

});
parcelRegister("f11bi", function(module, exports) {
$parcel$export(module.exports, "FeaturedInfoCard", function () { return $868863b8ca40ac22$export$d26c611c5262ca6a; });
/* featured-info-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $hnmMQ = parcelRequire("hnmMQ");

var $lqyi6 = parcelRequire("lqyi6");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");
const $868863b8ca40ac22$var$containerStyles = null;
const $868863b8ca40ac22$var$cardStyles = null;
const $868863b8ca40ac22$var$cardBodyStyles = null;
const $868863b8ca40ac22$var$ctaStyles = null;
const $868863b8ca40ac22$var$renderCta = ({ ctaProps: ctaProps })=>{
    if ('button' in ctaProps && ctaProps.button !== undefined) // Button + optional Link case
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1n261g80 _zulpv47k _4cvr1h6o _1bah1y6m"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                ...ctaProps.button,
                children: ctaProps.buttonText
            }),
            'link' in ctaProps && ctaProps.link && // eslint-disable-next-line  @atlassian/a11y/anchor-has-content
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                ...ctaProps.link
            })
        ]
    });
    // Link only case
    if ('link' in ctaProps && ctaProps.link !== undefined) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1n261g80 _zulpv47k _4cvr1h6o _1bah1y6m"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
            ...ctaProps.link
        })
    });
    return null;
};
const $868863b8ca40ac22$export$d26c611c5262ca6a = ({ Icon: Icon, title: title, body: body, iconSize: iconSize = '24', image: image, video: video, ctaProps: ctaProps })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_7cca15wb _1bsb1osq _4t3i1osq _gm59vrvc _o4yy1fhb _1bjp1ohn _5olw1ohn _13ndkb7n _5gu2kb7n _1g3pf1ug _7u5mf1ug _q8sr1wug _kw8y1wug _1cb1qfx8 _1ndykb7n _1ofjf1ug _sv321h6o",
            "featured-info-card"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4 _4cvr1y6m _1o9zidpf _2rkou2gc _1bsb1osq _4t3i1osq _1reozryt _18m9zryt _11q71afi _1i4oidpf _eytuidpf _1q3x1osq _1fj51wug _ufqd1ule _1x1tidpf _clfdidpf _s9kqidpf _11pqidpf _4wztidpf _q0a5idpf _98csidpf _c3k8idpf _1axi10nf _zcqx10nf"
            ]),
            style: {
                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
            },
            children: [
                video ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: "video",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("video", {
                        src: video.src,
                        poster: video.poster,
                        autoPlay: video.autoplay,
                        muted: video.muted,
                        loop: video.loop,
                        controls: video.controls ?? true,
                        width: video.width,
                        height: video.height,
                        preload: video.preload ?? 'metadata',
                        "aria-label": video.alt || title,
                        style: video.width && video.height ? {
                            aspectRatio: `${video.width}/${video.height}`
                        } : undefined,
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("track", {
                            kind: "captions",
                            src: video.captions?.src || '',
                            srcLang: video.captions?.srclang || 'en',
                            label: video.captions?.label || 'Captions',
                            default: true
                        })
                    })
                }) : image ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: "image",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                        ...image
                    })
                }) : null,
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _1yt4xy5q _4cvr1y6m _zulp19bv _1o9zidpf _2rkou2gc _11q71afi _1x1tidpf _clfdidpf _s9kqidpf _11pqidpf _4wztidpf _q0a5idpf _98csidpf _c3k8idpf _1axi10nf _zcqx10nf _zcqx1k8s",
                        "body"
                    ]),
                    style: {
                        "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                    },
                    children: [
                        Icon && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)(Icon, {
                                size: iconSize
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                            className: "h4",
                            children: title
                        }),
                        body && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            children: body
                        }),
                        ctaProps && $868863b8ca40ac22$var$renderCta({
                            ctaProps: ctaProps
                        })
                    ]
                })
            ]
        })
    });
};

});

parcelRegister("kgXas", function(module, exports) {
$parcel$export(module.exports, "Ai", function () { return $f3edea71192b0806$export$7ae07b56aa46260e; });
/* ai.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $lmQGF = parcelRequire("lmQGF");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $iNnWi = parcelRequire("iNnWi");

var $1pbCD = parcelRequire("1pbCD");
const $f3edea71192b0806$export$7ae07b56aa46260e = ()=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $8e22h.default)();
    const title = formatMessage({
        id: 'jira-product-tour.ai-section.title-text',
        defaultMessage: 'Your next move, suggested by AI'
    });
    const subTitle = formatMessage({
        id: 'jira-product-tour.ai-section.subtitle-text',
        defaultMessage: 'Atlassian Intelligence takes your big ideas and automatically suggests the tasks to help get it done.'
    });
    const buttonText = formatMessage({
        id: 'jira-product-tour.ai-section.button-text',
        defaultMessage: 'Explore Atlassian Intelligence'
    });
    const videoLink = (0, $iNnWi.getAiVideo)(locale);
    const imageLink = (0, $iNnWi.getAiImage)(locale);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleClick = ()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            attributes: {
                name: 'atlas-55799-ai-button-clicked',
                section: 'ai-section'
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _6a6z1h6o _bfhk5hrz _syazu67f _ca0qvbgk _u5f39by0 _n3tdvbgk _19bv9by0 _zulpzwfg"
                ]),
                style: {
                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1pbCD.Intelligence), {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                        className: (0, $2jatx.default)([
                            "_1wybckbl _k48p1fw0 _vwz4bs82 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o _flz0zwfg _1lzozwfg _1cqs1tcg"
                        ]),
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_syaz1afi _y3gn1h6o _ect4z4z1 _1wyb7vkz _k48p1nn1"
                        ]),
                        style: {
                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                        },
                        children: subTitle
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1tz91y44 _1k797vkz"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                            variant: "secondary",
                            color: "white",
                            colorAgainst: "other",
                            size: "large",
                            href: (0, $jQ0cd.useLocalizedHref)('/software/jira/ai'),
                            onClick: handleClick,
                            dataEventProps: {
                                'data-product-key': 'jira',
                                'data-event': 'clicked',
                                'data-event-component': 'linkButton',
                                'data-event-container': 'ctaSection',
                                'data-label': 'explore-atlassian-intelligence',
                                'data-label-english': `${buttonText}`,
                                'data-track-event': 'jira-pt.ai-section.explore-atlassian-intelligence'
                            },
                            children: buttonText
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("video", {
                        playsInline: true,
                        muted: true,
                        preload: "auto",
                        autoPlay: true,
                        loop: true,
                        controls: true,
                        className: (0, $2jatx.default)([
                            "_p12f1uof _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _19451ogm _liwcglyw"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                            src: videoLink,
                            type: "video/mp4"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                        image: {
                            src: imageLink,
                            alt: '',
                            width: 2752,
                            height: 1838
                        },
                        className: (0, $2jatx.default)([
                            "_mezj1osq _bna71wug _14bq7vkz _3tce7vkz _1ym67vkz _1xr17vkz _1z4kglyw"
                        ])
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1tkemgvx _12vemgnk _ouxlbbky _1lrwykpt _1itkoro1 _1jgo1wqb _1w8u1dh4"
                ])
            })
        ]
    });
};
const $f3edea71192b0806$var$aiSectionStyles = null;
const $f3edea71192b0806$var$imageStyles = null;
const $f3edea71192b0806$var$videoStyles = null;
const $f3edea71192b0806$var$titleStyles = null;
const $f3edea71192b0806$var$subTitleStyles = null;
const $f3edea71192b0806$var$buttonStyles = null;
const $f3edea71192b0806$var$footerStyles = null;

});
parcelRegister("iNnWi", function(module, exports) {
$parcel$export(module.exports, "getProductSoftwareDevelopmentModalImage", function () { return $3283639d1ff6b124$export$6954fe49bbdabc54; });
$parcel$export(module.exports, "getProductMarketingModalImage", function () { return $3283639d1ff6b124$export$cc19a82b226e3f08; });
$parcel$export(module.exports, "getUpdatedProductItModalImage", function () { return $3283639d1ff6b124$export$f31d1f714b55f0fb; });
$parcel$export(module.exports, "getProductDesignModalImage", function () { return $3283639d1ff6b124$export$e0ab49165f0180f7; });
$parcel$export(module.exports, "getProductOperationsModalImage", function () { return $3283639d1ff6b124$export$51a8246da0eeafec; });
$parcel$export(module.exports, "getDoubleFeatureFirstImage", function () { return $3283639d1ff6b124$export$af7f348492750745; });
$parcel$export(module.exports, "getDoubleFeatureSecondImage", function () { return $3283639d1ff6b124$export$51c1e8c9994962ad; });
$parcel$export(module.exports, "getCollaborateFirstImage", function () { return $3283639d1ff6b124$export$7a98b35c48983fe6; });
$parcel$export(module.exports, "getCollaborateSecondImage", function () { return $3283639d1ff6b124$export$3ff8286854e1bb40; });
$parcel$export(module.exports, "getCollaborateThirdImage", function () { return $3283639d1ff6b124$export$54ce02c1025509fa; });
$parcel$export(module.exports, "getCollaborateFourthImage", function () { return $3283639d1ff6b124$export$ea3cb1bf26550cc6; });
$parcel$export(module.exports, "getHeroCardOperationsImage", function () { return $3283639d1ff6b124$export$a27f10b8f2dbe6ec; });
$parcel$export(module.exports, "getHeroCardDesignImage", function () { return $3283639d1ff6b124$export$d2a58a00fc2c43; });
$parcel$export(module.exports, "getHeroCardItImage", function () { return $3283639d1ff6b124$export$e7e5a083e5974d8d; });
$parcel$export(module.exports, "getHeroCardMarketingImage", function () { return $3283639d1ff6b124$export$bf236abab7f9a91d; });
$parcel$export(module.exports, "getHeroCardSoftwareDevelopmentImage", function () { return $3283639d1ff6b124$export$44d7a932d2767a7a; });
$parcel$export(module.exports, "getStaggeredDoubleFeautureSecondImage", function () { return $3283639d1ff6b124$export$2d0f6370ca103766; });
$parcel$export(module.exports, "getStaggeredDoubleFeautureFirstImage", function () { return $3283639d1ff6b124$export$78335ebe3bbd9065; });
$parcel$export(module.exports, "getAiVideo", function () { return $3283639d1ff6b124$export$944f00714b8c3d98; });
$parcel$export(module.exports, "getAiImage", function () { return $3283639d1ff6b124$export$2e497ec5a3f0e9f7; });
$parcel$export(module.exports, "getAiVideoJSM", function () { return $3283639d1ff6b124$export$e88a1961b910936; });
$parcel$export(module.exports, "getAiImageJSM", function () { return $3283639d1ff6b124$export$be405a6adaf81ee7; });
/* eslint-disable @typescript-eslint/no-non-null-assertion */ const $3283639d1ff6b124$var$aiVideoJSMProductTourMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ov2b53oh3ly6rgucw1do7w4xoni4d6qh.mp4'
};
const $3283639d1ff6b124$var$aiImageJSMProductTourMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3cd8m6q81i47wxm8nt733jv5h885h064.webp'
};
const $3283639d1ff6b124$var$aiVideoMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/c57sisavif7febh3gsegy4vp55lm66v1.mp4'
};
const $3283639d1ff6b124$var$aiImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3mo3s2f6q0xfbg75wj1fqyjayo6ta246.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/l3mu66v75b212vhbp3v18217neb26r30.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/25qwhvk4ue212kn22s30d38la4p58d81.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4hhj8m4kmqh5es882153t0um1s327867.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/d5t1854qx65olc52p81k78p5336547sl.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8mj2v25vh521026wl1f7wv3a7ts63cb0.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/avkee2xvjgp258dmf71tt5u060cr0bj4.webp'
};
const $3283639d1ff6b124$var$staggaredDoubleFeautureFirstImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ex8536t33720160jkps31diiavoq7wa6.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/t67x4j1qeis0c6330we56e5op7j58040.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4863jx76lcis60cobj438qq2f76r6110.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/q5q45b8nf7dwl071122e311n0x2c8i6o.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/qd37iok4pb43q380hyxv8ran8iegwopd.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/qyc8q4674b85g13bsliagfc2sv2nt1l7.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8c4y5koi0roj2a5gl14ya60101g867dp.webp'
};
const $3283639d1ff6b124$var$staggaredDoubleFeautureSecondImageMap = {
    en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/new-staggered-double-feature-2.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ye325r1c82vwe80p17v707876sor0v57.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/kc48608o743ijn83hfsc7248o0855n33.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/r0138653i47tn4bd3ms25o67277wb4en.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/25a73j3b325y5433sgkc4056k8u2bgs2.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/qyc8q4674b85g13bsliagfc2sv2nt1l7.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/rulhdo87w10h368w5k071a7544kfdi34.webp'
};
const $3283639d1ff6b124$var$heroCardSoftwareDevelopmentImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ue25kj6kn4wq0wn1qg02q56fyop66rj8.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/t1p200v6f4ug14ngayoyim42cy1618bc.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/684fjfuywyexc1a23u572wcj05fi84y0.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/m51m5bb51aj4548p81jssu7w660ro0f8.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/l01f0tas2w10qap5g6u81tcq516vg37x.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/smh5n4ctme1r523d1g3uf7lm60130o04.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0j22k38v760owv56755oje0p37yeo711.webp'
};
const $3283639d1ff6b124$var$heroCardMarketingImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/m5hssc3g11uo84qx614br11443b744l3.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/63wxf44y8ut01ncxb0vo3g1762p76oe7.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/5u4x162411psnh2s22l4le4184aj4al3.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/30rrl683rurgws20103f520tec8a0b4r.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/q5gymh0604qp2b2vy2fiwymo6bcj5x47.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/6hq32u063ywsjill83o7v2a283g6jtq3.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/p3hnqjlr54wg1w56adkc254mb756ye22.webp'
};
const $3283639d1ff6b124$var$heroCardItImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/b00tc08w5880bt2xx078p24e142u0561.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/01oj3p2mmd1srk878al477q26840m1yv.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/fj108jc842621v46n6djd408300vcfod.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/vvuv40v0ibe0c2jh7xqdy3le0ev673np.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/tg55er46478ged8wg75q0muh70l03xp4.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/w2vr012658o07r84oikfd3vmw1728e31.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/sqst050suh056l837i652ato1382b4p0.webp'
};
const $3283639d1ff6b124$var$heroCardDesignImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/n831bpy2hv077jl7q3uvymb57bx0js6d.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/t7m1271fl2r40704e4u5i1r07b28bv3a.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3v68u503i5xkawuuf45g6uq85syu7h05.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/686564sowva47fegxg4y73oi8o6d77s6.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/rvj516a70mqo3hu0lgv2si7h0w08015i.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/l0u14221yq50dk1khv04lunbo6k271fd.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/66sjkv3q65r33272rgr0y35m72726ekc.webp'
};
const $3283639d1ff6b124$var$heroCardOperationsImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/6w08m6f83182557c4n2gdqd5lc8bxgux.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7t8ueumf388d67yap32075jv4n0w83lq.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/360yo8kpm3rl16l3d714vx8puhjs3a8x.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/p6ioacvwp466w8lh28582w86io78kv75.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2hx5h0y3380nx822w58k37ou7lt382a0.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/b75eb832avo555l01i0tf77yfr23ai80.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2y560886wr2048l0r4hxs6w5ym64doj7.webp'
};
const $3283639d1ff6b124$var$collaborateFirstImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1u8phig8g50c70bnq25c6x5htq6b253w.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/25udrh4pt816l1xn2s76v5fbk866h103.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/71x7642o01xexq1j3j36318p8hp3l4a7.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/6g6278kp6hdn68of821401s82qbd3dc8.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/df3a577s74j71s4q86w3fw2xh7r0kpxv.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/khf18qf74wmj0l07o8wh834t2h473ofn.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/26i42bqsjw1p6528lnf58602d7sjyksj.webp'
};
const $3283639d1ff6b124$var$collaborateSecondImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/30ref08c2xjhdi3bypsd4l534o6343k6.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/u53361562rpcil174kh548pmj47wk23r.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3it6mj67uqnn1kqqec0fili26xy1ad5a.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/h78h53re850ksk5b2u6mi3840u213jr7.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/cuikrei76g1lf48du36620j33lfkbaav.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/orake1uc43tel34v10d2lgp47pnkv65h.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/yykayg74usu65600v256n3sqnv6x6yov.webp'
};
const $3283639d1ff6b124$var$collaborateThirdImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2tqg4ls4336u276d4f6y7rennjd1t742.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/866dvbo07ft271755xa204dm1p4ej1sa.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/vai65atabw3lwv7w0abi8w748gf3725m.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/c3b3d36p064m286t2w140a75imlk0b76.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/s8038n5n37vkf1w3c75iy7y1o7871a43.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/hi58ex76esr013c8kr8xys2p036873w2.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/5r0r46q12refy5k44k760k6g3tyiy7l0.webp'
};
const $3283639d1ff6b124$var$collaborateFourthImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/j7ib7le01l6x411v5h42l87m64l0f611.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/m88b68g3r0vsqpmoe60kf2sps5717w22.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/6wox43k7ynt50p8w10bx6yj464ohbi68.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/01076d8sr5n4102kr7mgk302120o1421.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/pxrvm8q420v080r6nk43l87l6j1jr5j7.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/34301480xcnvb0qv17v074o405q67r30.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/o80f05nbv41b7i2ug006675p00r6027r.webp'
};
const $3283639d1ff6b124$var$doubleFeatureFirstImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/754lk6c6s3xkb50hyimkf4aujig8h7e8.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/85025n6sg53gb1o54gw52sa0a8l5252y.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/kp1g7ob05s14rv38xrl478bak8j1enwc.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/6c3xt34m70oh8712kl7p3225la77fb25.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/e717x180w2841fge4313e207b27f0jlp.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/52w7e23sbeuy32p6y3n06w7e2082yhxu.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/v74q0j753uk82d464054gqr5u568dw5w.webp'
};
const $3283639d1ff6b124$var$doubleFeatureSecondImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/m8lju6a7edoja1ey3g865yj77rgt2n6j.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/iddw2873d71vdyu0wrmasn218jn87a7f.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3e6ib72c51x05342cv48k07a0wo1jx7v.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/x64it50wnwrpqm50wye4140q63lm47y7.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/63apc7jibfy0ms6ntjv1486rcen53oc4.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3761m3b1ktjte0puv5f23r67n0be6rg5.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/837mvx5jali362e7a7504m853u81l73w.webp'
};
const $3283639d1ff6b124$var$productSoftwareDevelopmentModalImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/41y0vfa38q60m5384dg7sa765mf4ro28.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/pr2e520p47gw100v5eep6831u755nm23.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/m5070g810735714b11i5081065621m4s.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/46du0bd600v7yneguim2p18s2bmx38vt.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/365d4k835x4xj45a5wf6r7u3i865283g.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/6smuygao6ka5l72ud1e80j6cw33a5107.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0k440p3esv0l6u5c6dvgv2660166u7m4.webp'
};
const $3283639d1ff6b124$var$productMarketingModalImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/i58e36nty6p6km3a64v20ow565ecq126.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/hxx6isxs3m277360y8iub0e65pn6so78.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/j21lvt288m01q3m7g6f0l3d1bhjmdb24.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7u5oc32sv0yh6q1vdh2u60jnq8dwy2vk.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/61nt5bt5l4sebtma1l3a7e6w400dae0g.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ibp320cjl61b0rd8873ra2o332j266j4.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/wkx7n8q12fn88166l3y207e5f53xd646.webp'
};
const $3283639d1ff6b124$var$productItModalImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/75ous6w840rg1doie0203543yt22qnpa.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/r52381x63k34ljy2v248746pixvx76e5.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/d7q26epsti24r540gfcd4c5c1173cmc8.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/330645peuxhlid3577lr71073dm5ieyl.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/xpyktqf5jil6xah1xd7u54g8f08vi74j.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7a7kgk12347go142kr1euulv6058uak6.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/p70x4xyevviso1is348gj5yuci5735pk.webp'
};
const $3283639d1ff6b124$var$updatedProductItModalImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/whjwswo26s750yn06387a0s80ehy3e52.webp'
};
const $3283639d1ff6b124$var$productDesignModalImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/b2x4amce3w8mn2b213mtx3r31n44403q.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/44u783fxt66o02mxf5lr7kbw1xty380i.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/08smrtsr040biq47toh66t6us66q1o00.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7y78rlqj681mf1jlh7o65l525s6m7eya.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1a3lwr5vav0fd2a3yp4ouw244u1d1u36.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/57dmhof07485d05q2cdubfx65vxs85ah.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/u11mi1pyr7ncq1ur1b2x20y0774185ru.webp'
};
const $3283639d1ff6b124$var$productOperationsModalImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/rf4b8d0jn3u85g7rn8uf8481a1n1t8l5.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/q4hr0hm0ooqt42r0156010yevq5v3646.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/m5p21md0n60ec14qju78yfq7517sase0.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/n1w6347fgj1icy62w6gmak63ty1i66rq.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7v5df3xyd24e02x68l71pi0vrpsi1h86.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/v1e777xn7wd21g22ytpg5t44d055li82.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0eo1cu114id26b7ed48g46igo4j11pma.webp'
};
const $3283639d1ff6b124$export$6954fe49bbdabc54 = (locale)=>{
    return $3283639d1ff6b124$var$productSoftwareDevelopmentModalImageMap[locale] || $3283639d1ff6b124$var$productSoftwareDevelopmentModalImageMap['en'];
};
const $3283639d1ff6b124$export$cc19a82b226e3f08 = (locale)=>{
    return $3283639d1ff6b124$var$productMarketingModalImageMap[locale] || $3283639d1ff6b124$var$productMarketingModalImageMap['en'];
};
const $3283639d1ff6b124$export$fa7e84d2d2c567a7 = (locale)=>{
    return $3283639d1ff6b124$var$productItModalImageMap[locale] || $3283639d1ff6b124$var$productItModalImageMap['en'];
};
const $3283639d1ff6b124$export$f31d1f714b55f0fb = (locale)=>{
    return $3283639d1ff6b124$var$updatedProductItModalImageMap[locale] || $3283639d1ff6b124$var$updatedProductItModalImageMap['en'];
};
const $3283639d1ff6b124$export$e0ab49165f0180f7 = (locale)=>{
    return $3283639d1ff6b124$var$productDesignModalImageMap[locale] || $3283639d1ff6b124$var$productDesignModalImageMap['en'];
};
const $3283639d1ff6b124$export$51a8246da0eeafec = (locale)=>{
    return $3283639d1ff6b124$var$productOperationsModalImageMap[locale] || $3283639d1ff6b124$var$productOperationsModalImageMap['en'];
};
const $3283639d1ff6b124$export$af7f348492750745 = (locale)=>{
    return $3283639d1ff6b124$var$doubleFeatureFirstImageMap[locale] || $3283639d1ff6b124$var$doubleFeatureFirstImageMap['en'];
};
const $3283639d1ff6b124$export$51c1e8c9994962ad = (locale)=>{
    return $3283639d1ff6b124$var$doubleFeatureSecondImageMap[locale] || $3283639d1ff6b124$var$doubleFeatureSecondImageMap['en'];
};
const $3283639d1ff6b124$export$7a98b35c48983fe6 = (locale)=>{
    return $3283639d1ff6b124$var$collaborateFirstImageMap[locale] || $3283639d1ff6b124$var$collaborateFirstImageMap['en'];
};
const $3283639d1ff6b124$export$3ff8286854e1bb40 = (locale)=>{
    return $3283639d1ff6b124$var$collaborateSecondImageMap[locale] || $3283639d1ff6b124$var$collaborateSecondImageMap['en'];
};
const $3283639d1ff6b124$export$54ce02c1025509fa = (locale)=>{
    return $3283639d1ff6b124$var$collaborateThirdImageMap[locale] || $3283639d1ff6b124$var$collaborateThirdImageMap['en'];
};
const $3283639d1ff6b124$export$ea3cb1bf26550cc6 = (locale)=>{
    return $3283639d1ff6b124$var$collaborateFourthImageMap[locale] || $3283639d1ff6b124$var$collaborateFourthImageMap['en'];
};
const $3283639d1ff6b124$export$a27f10b8f2dbe6ec = (locale)=>{
    return $3283639d1ff6b124$var$heroCardOperationsImageMap[locale] || $3283639d1ff6b124$var$heroCardOperationsImageMap['en'];
};
const $3283639d1ff6b124$export$d2a58a00fc2c43 = (locale)=>{
    return $3283639d1ff6b124$var$heroCardDesignImageMap[locale] || $3283639d1ff6b124$var$heroCardDesignImageMap['en'];
};
const $3283639d1ff6b124$export$e7e5a083e5974d8d = (locale)=>{
    return $3283639d1ff6b124$var$heroCardItImageMap[locale] || $3283639d1ff6b124$var$heroCardItImageMap['en'];
};
const $3283639d1ff6b124$export$bf236abab7f9a91d = (locale)=>{
    return $3283639d1ff6b124$var$heroCardMarketingImageMap[locale] || $3283639d1ff6b124$var$heroCardMarketingImageMap['en'];
};
const $3283639d1ff6b124$export$44d7a932d2767a7a = (locale)=>{
    return $3283639d1ff6b124$var$heroCardSoftwareDevelopmentImageMap[locale] || $3283639d1ff6b124$var$heroCardSoftwareDevelopmentImageMap['en'];
};
const $3283639d1ff6b124$export$2d0f6370ca103766 = (locale)=>{
    return $3283639d1ff6b124$var$staggaredDoubleFeautureSecondImageMap[locale] || $3283639d1ff6b124$var$staggaredDoubleFeautureSecondImageMap['en'];
};
const $3283639d1ff6b124$export$78335ebe3bbd9065 = (locale)=>{
    return $3283639d1ff6b124$var$staggaredDoubleFeautureFirstImageMap[locale] || $3283639d1ff6b124$var$staggaredDoubleFeautureFirstImageMap['en'];
};
const $3283639d1ff6b124$export$944f00714b8c3d98 = (locale)=>{
    return $3283639d1ff6b124$var$aiVideoMap[locale] || $3283639d1ff6b124$var$aiVideoMap['en'];
};
const $3283639d1ff6b124$export$2e497ec5a3f0e9f7 = (locale)=>{
    return $3283639d1ff6b124$var$aiImageMap[locale] || $3283639d1ff6b124$var$aiImageMap['en'];
};
const $3283639d1ff6b124$export$e88a1961b910936 = (locale)=>{
    return $3283639d1ff6b124$var$aiVideoJSMProductTourMap[locale] || $3283639d1ff6b124$var$aiVideoJSMProductTourMap['en'];
};
const $3283639d1ff6b124$export$be405a6adaf81ee7 = (locale)=>{
    return $3283639d1ff6b124$var$aiImageJSMProductTourMap[locale] || $3283639d1ff6b124$var$aiImageJSMProductTourMap['en'];
};

});

parcelRegister("1pbCD", function(module, exports) {
$parcel$export(module.exports, "Intelligence", function () { return $7ed9ae281286c3c7$export$f080dd2dfaa7a195; });

var $7VQPk = parcelRequire("7VQPk");
const $7ed9ae281286c3c7$export$f080dd2dfaa7a195 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
            width: "48",
            height: "48",
            viewBox: "0 0 48 48",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                    id: "Group 626186",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M37.3027 23.8756C37.3027 22.4546 38.4547 21.3027 39.8757 21.3027H44.5842C46.0052 21.3027 47.1572 22.4546 47.1572 23.8756C47.1572 25.2967 46.0052 26.4486 44.5842 26.4486H39.8757C38.4547 26.4486 37.3027 25.2967 37.3027 23.8756Z",
                            fill: "url(#paint0_linear_2487_5195)"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_2",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M24.0007 0.718933C25.4217 0.718933 26.5737 1.87089 26.5737 3.2919V8.00043C26.5737 9.42144 25.4217 10.5734 24.0007 10.5734C22.5797 10.5734 21.4277 9.42144 21.4277 8.00043V3.2919C21.4277 1.87089 22.5797 0.718933 24.0007 0.718933Z",
                            fill: "url(#paint1_linear_2487_5195)"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_3",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0.84375 23.8756C0.84375 22.4546 1.99571 21.3027 3.41672 21.3027H8.12525C9.54626 21.3027 10.6982 22.4546 10.6982 23.8756C10.6982 25.2967 9.54626 26.4486 8.12525 26.4486H3.41672C1.99571 26.4486 0.84375 25.2967 0.84375 23.8756Z",
                            fill: "url(#paint2_linear_2487_5195)"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_4",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M24.0007 37.1779C25.4217 37.1779 26.5737 38.3298 26.5737 39.7508V44.4594C26.5737 45.8804 25.4217 47.0323 24.0007 47.0323C22.5797 47.0323 21.4277 45.8804 21.4277 44.4594V39.7508C21.4277 38.3298 22.5797 37.1779 24.0007 37.1779Z",
                            fill: "url(#paint3_linear_2487_5195)"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_5",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M29.9001 29.7752C30.9049 28.7703 32.534 28.7703 33.5388 29.7752L43.8307 40.067C44.8355 41.0718 44.8355 42.7009 43.8307 43.7058C42.8259 44.7106 41.1968 44.7106 40.192 43.7058L29.9001 33.4139C28.8953 32.4091 28.8953 30.78 29.9001 29.7752Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_6",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M43.8307 4.04548C44.8355 5.05028 44.8355 6.6794 43.8307 7.6842L33.5388 17.9761C32.534 18.9809 30.9049 18.9809 29.9001 17.9761C28.8953 16.9713 28.8953 15.3422 29.9001 14.3373L40.192 4.04548C41.1968 3.04067 42.8259 3.04067 43.8307 4.04548Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_7",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M4.16962 4.04548C5.17443 3.04067 6.80354 3.04067 7.80835 4.04548L18.1002 14.3373C19.105 15.3422 19.105 16.9713 18.1002 17.9761C17.0954 18.9809 15.4663 18.9809 14.4615 17.9761L4.16962 7.6842C3.16481 6.6794 3.16481 5.05028 4.16962 4.04548Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_8",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M18.1002 29.7752C19.105 30.78 19.105 32.4091 18.1002 33.4139L7.80835 43.7058C6.80354 44.7106 5.17443 44.7106 4.16962 43.7058C3.16481 42.7009 3.16481 41.0718 4.16962 40.067L14.4615 29.7752C15.4663 28.7703 17.0954 28.7703 18.1002 29.7752Z",
                            fill: "white"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                            id: "paint0_linear_2487_5195",
                            x1: "47.1571",
                            y1: "23.8756",
                            x2: "38.1517",
                            y2: "23.8756",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "0.270833",
                                    stopColor: "#9BC6FF"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "1",
                                    stopColor: "white"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                            id: "paint1_linear_2487_5195",
                            x1: "25.2872",
                            y1: "0.718933",
                            x2: "25.2872",
                            y2: "9.72432",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "0.1875",
                                    stopColor: "#9BC6FF"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "1",
                                    stopColor: "white"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                            id: "paint2_linear_2487_5195",
                            x1: "10.6981",
                            y1: "23.8756",
                            x2: "1.69272",
                            y2: "23.8756",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    stopColor: "white"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "0.791667",
                                    stopColor: "#2684FF"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                            id: "paint3_linear_2487_5195",
                            x1: "25.2872",
                            y1: "36.7404",
                            x2: "25.2872",
                            y2: "47.0323",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    stopColor: "white"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "0.802083",
                                    stopColor: "#A6CCFE"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});


parcelRegister("b3ukl", function(module, exports) {
$parcel$export(module.exports, "FeaturedImages", function () { return $2ecc3b22ab257db2$export$946cd9d3a173e972; });
$parcel$export(module.exports, "FeaturedInfoSection", function () { return $2ecc3b22ab257db2$export$2e0f2d2dcf045a0b; });
$parcel$export(module.exports, "PLAN", function () { return (parcelRequire("kHvUj")).PLAN; });
$parcel$export(module.exports, "TRACK", function () { return (parcelRequire("kHvUj")).TRACK; });
$parcel$export(module.exports, "LAUNCH", function () { return (parcelRequire("kHvUj")).LAUNCH; });
$parcel$export(module.exports, "REPORT", function () { return (parcelRequire("kHvUj")).REPORT; });
/* featured-info.tsx generated by @compiled/babel-plugin v0.28.8 */ // eslint-disable no-non-orangelogic-images-eslint

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kHvUj = parcelRequire("kHvUj");

var $kbpa7 = parcelRequire("kbpa7");

var $jsxHL = parcelRequire("jsxHL");
const $2ecc3b22ab257db2$var$featuresSectionStyles = null;
const $2ecc3b22ab257db2$var$featuresGridStyles = null;
const $2ecc3b22ab257db2$export$946cd9d3a173e972 = {
    collaborateAutomateWorkflows: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/collaborate-automate-workflows.webp',
    collaborateShareKeyResources: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/collaborate-share-key-resources.webp',
    collaborateStreamlineRequests: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/jswf-collaborate-streamline-requests-2.webp',
    planAlignWorkToGoals: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/plan-align-work-to-goals.webp',
    planGetTheBigPicture: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/plan-get-the-big-picture.webp',
    planJumpstartWithExpertTemplates: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/plan-jumpstart-with-expert-templates.webp',
    planPlanAndAssignWork: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/plan-plan-and-assign-work.webp',
    reportLearnAsYouDeliver: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/report-learn-as-you-deliver-2.webp',
    reportShareRealTimeUpdates: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/report-share-real-time-updates.webp',
    reportTrackYourProgressToGoals: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/report-track-your-progress-to-goals-2.webp',
    reportUnderstandTeamPerformance: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/report-understand-team-performance-2.webp',
    trackManageDependencies: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/track-manage-dependencies.webp',
    trackMonitorProgress: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/track-monitor-progress.webp',
    trackRemoveManualWork: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/track-remove-manual-work.webp',
    trackTrackWorkWhereYouWork: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/track-track-work-where-you-work.webp',
    streamlineRequests: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/streamline-requests.webp',
    shareKeyResources: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/share-key-resources.webp'
};
const $2ecc3b22ab257db2$export$2e0f2d2dcf045a0b = ({ variant: variant, eyebrow: eyebrow, header: header, description: description, children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_11q7g7ng _ca0qckbl _u5f3idpf _n3tdckbl _19bvidpf"
        ]),
        style: {
            "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jsxHL.TypographyStyles), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kHvUj.FeaturedInfoHeader), {
                    variant: variant,
                    eyebrow: eyebrow,
                    header: header,
                    description: description
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c11p5 _kqswh2mm _yv0ehkll _zulpzwfg _19pkidpf _2hwxzwfg _otyridpf _18u0zwfg _b8yq1nx3 _15flidpf _1d2w1wug _1svyidpf _seov1wug _1j8bfsjm _f2s5g31l"
                    ]),
                    children: children
                })
            ]
        })
    });
};

});
parcelRegister("kHvUj", function(module, exports) {
$parcel$export(module.exports, "PLAN", function () { return $8866872d119dba20$export$c303e491e026ebc6; });
$parcel$export(module.exports, "TRACK", function () { return $8866872d119dba20$export$23a21f8efe49e17f; });
$parcel$export(module.exports, "LAUNCH", function () { return $8866872d119dba20$export$609f530f49033bf7; });
$parcel$export(module.exports, "REPORT", function () { return $8866872d119dba20$export$e3d31417f21c1ce7; });
$parcel$export(module.exports, "FeaturedInfoHeader", function () { return $8866872d119dba20$export$4bbaf432f1794430; });
/* featured-info-header.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $8866872d119dba20$export$c303e491e026ebc6 = 'plan';
const $8866872d119dba20$export$23a21f8efe49e17f = 'track';
const $8866872d119dba20$export$609f530f49033bf7 = 'launch';
const $8866872d119dba20$export$e3d31417f21c1ce7 = 'report';
const $8866872d119dba20$var$containerStyles = null;
const $8866872d119dba20$var$planVariantStyles = null;
const $8866872d119dba20$var$trackVariantStyles = null;
const $8866872d119dba20$var$launchVariantStyles = null;
const $8866872d119dba20$var$reportVariantStyles = null;
const $8866872d119dba20$var$headerStyles = null;
const $8866872d119dba20$var$eyebrowStyles = null;
const $8866872d119dba20$var$PlanEyelash = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "46",
        height: "26",
        viewBox: "0 0 46 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M27.8179 8.5621L28.9492 7.54226C28.9492 7.54226 29.1999 6.94045 28.9993 6.53364C28.8767 6.28288 28.6873 6.03769 28.4811 5.84822C28.0631 5.46928 27.5672 5.34664 27.3498 5.94291C27.322 5.92619 27.2774 5.92622 27.2384 5.89835C27.1604 6.65623 26.2241 6.69528 25.8842 7.25812C26.018 7.35285 25.8731 7.28036 25.8731 7.28036C25.9232 7.87663 25.3548 8.2166 25.3548 8.22217C24.6137 9.36457 23.2539 10.6407 22.5908 11.9949L22.6186 12.006L22.641 12.0283C22.8862 12.0506 22.5295 12.3849 22.4905 12.2512C21.7047 12.658 20.646 13.8896 20.4899 14.7589C20.6571 14.8703 20.5679 15.0208 20.5233 14.9539C19.9605 14.9149 15.4912 19.7742 17.8819 19.6739L18.0268 19.8411C18.3556 19.5848 20.6292 17.6177 20.6459 17.64C21.1029 17.8796 21.0193 15.7174 21.493 16.6982C23.9951 16.2301 27.0991 10.5125 27.0991 10.5125L27.1715 9.83268C27.1715 9.83268 28.0742 9.27539 27.8123 8.55652L27.8179 8.5621Z",
                fill: (0, $kbpa7.wacToken)('color.neutral.light0')
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M8.85401 4.95098L8.60878 4.31569C8.60878 4.31569 9.15488 3.40732 8.59204 2.88906L9.12706 1.4625C9.12706 1.4625 9.07134 0.810485 8.70912 0.542998C8.48064 0.375818 8.202 0.242056 7.93451 0.175184C7.39396 0.0302949 6.89243 0.14737 6.97045 0.782652C6.93701 0.782652 6.89795 0.799313 6.8478 0.79374C7.12643 1.50147 6.31288 1.96401 6.27387 2.62159C6.43548 2.64388 6.55806 2.69403 6.4689 2.69403L6.26829 2.64948C6.58593 3.15659 5.88373 3.29032 6.49672 3.81972L6.2404 3.71938C6.10666 5.07911 5.4825 6.82894 5.52151 8.33913H5.55498C5.55498 8.33913 5.64414 8.71807 5.55498 8.61776C5.04229 9.34221 4.67449 10.9193 4.92526 11.7607C5.12588 11.783 2.79095 18.5148 4.86397 17.3278L5.07016 17.4114C5.24291 17.0325 5.3822 16.7149 5.87816 16.3861C5.85587 16.3192 5.90047 16.3247 5.68314 16.2802C5.65527 16.2579 5.594 16.2189 5.50484 16.2077C4.98101 16.1074 6.70848 13.0257 6.70848 13.0257C8.71464 11.4598 8.84843 4.95656 8.84843 4.95656L8.85401 4.95098Z",
                fill: (0, $kbpa7.wacToken)('color.neutral.light0')
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M44.1735 17.8016C43.984 17.2722 43.6106 16.9267 43.1314 17.3503C43.1147 17.3224 43.0756 17.3001 43.0534 17.2555C42.6243 17.8852 41.7828 17.4728 41.2199 17.8128C41.2924 17.9577 41.1976 17.8295 41.1976 17.8295C40.958 18.3756 40.3004 18.409 40.3004 18.4146C39.1023 19.0722 37.3024 19.5459 36.082 20.4264L36.0987 20.4486L36.1098 20.4765C36.316 20.6103 35.8423 20.7384 35.8702 20.5991C34.9841 20.5824 33.4684 21.1675 32.9222 21.8529C33.017 22.0313 33.0672 21.5297 33.3792 22.1037C33.2009 22.1873 33.056 22.3545 32.8777 22.4214C32.7105 22.0313 32.8665 22.1204 32.8554 22.0424C32.3761 21.7415 26.1404 23.9037 28.2914 24.9458L28.3415 25.1631C28.7539 25.0907 29.6232 24.9235 29.5842 24.8399C29.3725 24.3551 31.6907 24.4331 31.6963 24.4665L32.8888 24.0374C35.3129 24.8065 40.7574 21.2511 40.7574 21.2511L41.1475 20.6883C41.1475 20.6883 42.2063 20.627 42.3177 19.8691L43.7945 19.5069C43.7945 19.5069 44.3016 19.0945 44.3128 18.6431C44.3239 18.3645 44.2737 18.0579 44.1846 17.796L44.1735 17.8016Z",
                fill: (0, $kbpa7.wacToken)('color.neutral.light0')
            })
        ]
    });
const $8866872d119dba20$var$TrackEyelash = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "43",
        height: "20",
        viewBox: "0 0 43 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M41.1672 6.20799C29.1522 -1.68807 19.1878 -0.0992864 12.5988 1.16576C9.10339 0.0506007 -6.62876 8.95992 3.16787 6.59171C7.3767 3.10833 21.6519 1.39363 29.518 4.72712C31.8203 2.91049 46.5871 12.3833 41.1612 6.20799H41.1672Z",
                fill: (0, $kbpa7.wacToken)('color.primary.black')
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M34.6504 11.8079C29.9799 7.55705 23.1151 8.00677 20.2852 8.34252C22.5635 6.96356 16.5019 7.59904 15.5187 8.30051C16.478 8.24055 15.9745 8.85811 15.1771 8.92406C14.9252 7.26931 4.39719 11.1483 7.26304 13.1508C8.54008 12.4853 9.17553 13.0789 9.28944 11.7599C9.93096 13.3247 11.244 11.0884 11.6816 10.9145C12.6169 11.2203 12.593 11.598 13.8101 10.6927C15.4408 10.6927 17.773 11.1424 20.513 10.6328C24.3321 10.5069 26.4066 11.688 29.5662 11.9937C30.8972 12.4854 37.5462 15.627 34.6624 11.8199L34.6504 11.8079Z",
                fill: (0, $kbpa7.wacToken)('color.primary.black')
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M28.9065 17.8751C27.0359 16.2983 24.6736 15.369 21.3641 15.5788C22.7551 16.736 21.4541 16.706 20.5668 16.1484C22.3295 14.8773 16.7837 15.1892 18.2106 16.2803C17.8389 16.5441 17.4252 16.3822 17.707 16.0824C15.6385 15.1412 9.31332 19.7457 14.4574 18.7505C14.2176 17.9351 15.1289 19.9256 15.8064 17.977C16.5978 18.5166 16.3459 18.8104 17.0414 18.061C17.7728 18.109 19.2118 19.0083 20.6807 18.4327C22.7731 17.9411 23.5346 19.7757 25.1054 18.7025C26.0407 19.5059 30.5013 20.3512 28.8945 17.8691L28.9065 17.8751Z",
                fill: (0, $kbpa7.wacToken)('color.primary.black')
            })
        ]
    });
const $8866872d119dba20$var$LaunchEyelash = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: "58",
        height: "20",
        viewBox: "0 0 58 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M50.3635 18.9904C50.6395 18.4167 52.3934 17.7903 52.2324 17.1698C52.4164 17.2517 53.1467 16.561 53.0374 15.9171C55.1363 14.4477 58 10.0161 58 10.0161C58 10.0161 56.3036 6.15833 54.13 5.07533C54.0725 5.15729 48.1151 -1.82082 47.7068 1.34037C48.2186 1.5277 48.3221 3.24884 48.8742 2.55806C49.2939 1.75606 50.2887 3.78741 50.6568 3.86937C50.3865 4.7182 51.2548 5.73687 51.8758 5.83053C52.7844 7.10671 54.13 8.3418 54.13 8.3418C54.13 8.3418 47.3963 7.55744 45.1594 8.86289C44.1933 8.29505 25.6081 7.85015 32.6236 9.02096C31.1572 9.98688 25.2516 8.65797 29.1676 8.4004C18.5984 8.14282 13.0263 7.32917 0.979278 10.8123C-2.42494 12.3402 4.08448 12.1236 4.77452 11.5967C4.87803 11.1342 4.90103 10.8474 5.37257 10.9177C5.52208 12.6446 9.75435 10.2855 10.2604 10.3674C17.0631 11.4797 31.4678 10.461 40.2601 11.9128C42.3532 11.7957 51.0305 10.9411 52.5141 10.9411C53.9977 10.9411 53.0202 11.6084 52.0139 12.3695C51.9794 12.3695 51.9736 12.4456 51.8758 12.3812C51.7723 14.3189 50.444 15.8408 48.9087 17.1287C48.0806 17.7844 49.2537 20.694 50.3635 18.9904Z",
            fill: (0, $kbpa7.wacToken)('color.primary.black')
        })
    });
const $8866872d119dba20$var$ReportEyelash = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "51",
        height: "50",
        viewBox: "0 0 51 50",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M30.3513 23.6639C31.5684 22.8331 35.6575 18.0452 31.7445 19.1689C30.6929 20.0051 25.8724 26.4493 23.2247 29.7726C22.6428 28.4092 20.9719 26.9179 19.7495 26.1617C19.0074 25.4747 18.7085 26.6091 18.7085 26.6091C18.9167 26.9127 19.1356 27.392 19.6427 27.7754C20.2085 28.2015 20.2833 29.0855 21.2121 29.7619C24.4792 32.1319 23.0058 35.6202 26.1661 29.5754C27.2551 26.9232 29.9882 26.0605 30.3459 23.6639H30.3513Z",
                fill: (0, $kbpa7.wacToken)('color.primary.black')
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M50.9995 23.467C51.0262 16.5808 49.8999 5.78014 42.3943 3.2291C47.5991 10.1845 50.754 21.3899 47.8553 30.0123C45.1702 43.6729 24.4417 51.3366 11.9501 43.4225C13.2313 44.6368 16.162 46.0163 17.961 46.5488C13.1886 47.582 2.45871 35.5564 10.0551 42.1018C-11.5009 14.6262 22.6267 -11.651 42.2715 12.0806C36.6983 1.31722 22.2263 -2.3629 13.3114 2.87232C-29.6403 36.808 44.5296 76.9961 50.9942 23.467H50.9995Z",
                fill: (0, $kbpa7.wacToken)('color.primary.black')
            })
        ]
    });
const $8866872d119dba20$export$4bbaf432f1794430 = ({ variant: variant, eyebrow: eyebrow, header: header, description: description })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _p12f17kt _19pkidpf _2hwx1wug _otyridpf _18u01wug _1reozryt _1b3husvi _1pbyidpf _1kt9b3bt _1cs8stnw _dsq4glyw _1mp417kt _kfgtocp2 _1g0v1mrw _1tes1qqs _7dwzzr6s",
            variant === $8866872d119dba20$export$c303e491e026ebc6 && "_1ikb1afi _1loe1afi _iwqy1afi _1rus5hrz _tgsmh130 _13zg1gqn _1tynglyw _1w7r13g9 _1m1v1827",
            variant === $8866872d119dba20$export$23a21f8efe49e17f && "_1rus1t4l _1mp41gvu _tgsm1iq9 _1ksz1b5c",
            variant === $8866872d119dba20$export$609f530f49033bf7 && "_1rus1dux _kfgt8re4 _tgsm14z4 _13zg1gqn _1tynglyw _6my9ocp2 _1cnl1uo2 _1w7r1827",
            variant === $8866872d119dba20$export$e3d31417f21c1ce7 && "_1ruszh9h _kfgtlwrb _tgsm19fw _13zg1gqn _1tynglyw _1cnl1hc7 _1w7r1uo2 _1m1v13g9"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
            "--_hnp340": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.lime400')),
            "--_t0cjdu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.saffron200')),
            "--_ah1mef": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.purple400'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4 _zulpu2gc _19pkidpf _2hwx1wug _otyrzwfg _18u01wug _p12f1nx3 _ca0q4bvh _u5f3idpf _n3tdidpf _19bvidpf _1c58idpf _1fexidpf _1mh0idpf _av1ridpf _c5hwbxu3 _w7wbidpf _1iipidpf _6bnpidpf _cxn3idpf _dn1fbxu3 _178vidpf _obsiidpf _1qcbidpf _fzpmidpf _1rkbkd3c _1kmx4bvh _1ggmidpf _1ykzidpf _1maeidpf"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    className: "h2",
                    children: header
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1f491mrw _1e0c1txw _2lx21bp4 _zulpdlk8"
                    ]),
                    children: [
                        variant === $8866872d119dba20$export$c303e491e026ebc6 && /*#__PURE__*/ (0, $7VQPk.jsx)($8866872d119dba20$var$PlanEyelash, {}),
                        variant === $8866872d119dba20$export$23a21f8efe49e17f && /*#__PURE__*/ (0, $7VQPk.jsx)($8866872d119dba20$var$TrackEyelash, {}),
                        variant === $8866872d119dba20$export$609f530f49033bf7 && /*#__PURE__*/ (0, $7VQPk.jsx)($8866872d119dba20$var$LaunchEyelash, {}),
                        variant === $8866872d119dba20$export$e3d31417f21c1ce7 && /*#__PURE__*/ (0, $7VQPk.jsx)($8866872d119dba20$var$ReportEyelash, {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                            className: "eyebrow-md",
                            children: eyebrow
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: "body-md",
                    children: description
                })
            ]
        })
    });
};

});


parcelRegister("hLTRc", function(module, exports) {
$parcel$export(module.exports, "TimelineIcon", function () { return $696d79ea84e61612$export$e5aa73ddcf9d62e8; });
$parcel$export(module.exports, "RedoIcon", function () { return $696d79ea84e61612$export$d275b7689549104e; });
$parcel$export(module.exports, "FastIcon", function () { return $696d79ea84e61612$export$74dd0403ff5f7484; });
$parcel$export(module.exports, "LaunchSection", function () { return $696d79ea84e61612$export$a181f92ca97e792; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $f11bi = parcelRequire("f11bi");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $82jSm = parcelRequire("82jSm");

var $b3ukl = parcelRequire("b3ukl");
var $kHvUj = parcelRequire("kHvUj");
const $696d79ea84e61612$export$e5aa73ddcf9d62e8 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 5.26807L16.5 5.26807V1.51807L0 1.51807V5.26807Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M1.5 17.2681L18 17.2681V13.5181L1.5 13.5181L1.5 17.2681Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M24 23.2681L7.5 23.2681V19.5181L24 19.5181V23.2681Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M6 11.2681L22.5 11.2681V7.51806L6 7.51807V11.2681Z",
                fill: "#1868DB"
            })
        ]
    });
const $696d79ea84e61612$export$d275b7689549104e = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M2.87302 12.5736C2.87302 8.60683 6.08876 5.39109 10.0556 5.39109C14.0224 5.39109 17.2381 8.60683 17.2381 12.5736V13.415L15.3809 11.5578L13.3494 13.5893L18.6747 18.9146L24 13.5893L21.9685 11.5578L20.1111 13.4151V12.5736C20.1111 7.0201 15.6091 2.51807 10.0556 2.51807C4.50203 2.51807 0 7.0201 0 12.5736C0 18.1272 4.50203 22.6292 10.0556 22.6292V19.7562C6.08876 19.7562 2.87302 16.5405 2.87302 12.5736Z",
            fill: "#1868DB"
        })
    });
const $696d79ea84e61612$export$74dd0403ff5f7484 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M0 15.1847L10.6667 0.518066V9.8514H17.3333L6.66667 24.5181V15.1847H0Z",
            fill: "#1868DB"
        })
    });
const $696d79ea84e61612$export$a181f92ca97e792 = ()=>{
    const intl = (0, $8e22h.default)();
    const showGwp7999JiraFeaturesUpdates = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7999JiraFeatures);
    const launchSharedReleaseDatesImage = (0, $82jSm.useLocalizedImage)('launchSharedReleaseDatesImage');
    const launchYourFavoriteAppImage = (0, $82jSm.useLocalizedImage)('launchYourFavoriteAppImage');
    const launchWorkflowsAutomationImage = (0, $82jSm.useLocalizedImage)('launchWorkflowsAutomationImage');
    if (showGwp7999JiraFeaturesUpdates) return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $b3ukl.FeaturedInfoSection), {
        variant: (0, $kHvUj.LAUNCH),
        eyebrow: intl.formatMessage({
            id: 'JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Eyebrow',
            defaultMessage: 'Collaborate'
        }),
        header: intl.formatMessage({
            id: 'JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Header',
            defaultMessage: 'Get every team on the same page'
        }),
        description: intl.formatMessage({
            id: 'JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Description',
            defaultMessage: 'Jira brings teams, tools, and AI together to keep the entire org in sync and deliver impact faster.'
        }),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f11bi.FeaturedInfoCard), {
                image: {
                    image: {
                        src: (0, $b3ukl.FeaturedImages).collaborateStreamlineRequests,
                        alt: intl.formatMessage({
                            id: 'JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Card.StreamlineRequests.Alt',
                            defaultMessage: 'Forms in Jira'
                        })
                    }
                },
                Icon: $696d79ea84e61612$export$e5aa73ddcf9d62e8,
                title: intl.formatMessage({
                    id: 'JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Card.StreamlineRequests.Header',
                    defaultMessage: 'Streamline Requests'
                }),
                body: intl.formatMessage({
                    id: 'JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Card.StreamlineRequests.Description',
                    defaultMessage: 'Make it easy for partner teams to submit requests and track progress with forms.'
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f11bi.FeaturedInfoCard), {
                image: {
                    image: {
                        src: (0, $b3ukl.FeaturedImages).collaborateShareKeyResources,
                        alt: intl.formatMessage({
                            id: 'JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Card.ShareResources.Alt',
                            defaultMessage: 'Release management in Jira'
                        })
                    }
                },
                Icon: $696d79ea84e61612$export$d275b7689549104e,
                title: intl.formatMessage({
                    id: 'JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Card.ShareResources.Header',
                    defaultMessage: 'Share key resources'
                }),
                body: intl.formatMessage({
                    id: 'JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Card.ShareResources.Description',
                    defaultMessage: 'Keep everyone aligned by sharing key resources like content calendars or release announcements.'
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f11bi.FeaturedInfoCard), {
                image: {
                    image: {
                        src: (0, $b3ukl.FeaturedImages).collaborateAutomateWorkflows,
                        alt: intl.formatMessage({
                            id: 'JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Card.AutomateWorkflows.Alt',
                            defaultMessage: 'Manage workflows in Jira'
                        })
                    }
                },
                Icon: $696d79ea84e61612$export$74dd0403ff5f7484,
                title: intl.formatMessage({
                    id: 'JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Card.AutomateWorkflows.Header',
                    defaultMessage: 'Automate workflows'
                }),
                body: intl.formatMessage({
                    id: 'JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Card.AutomateWorkflows.Description',
                    defaultMessage: 'Scale processes and save time with customizable workflows that integrate with your tech stack.'
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $b3ukl.FeaturedInfoSection), {
        variant: (0, $kHvUj.LAUNCH),
        eyebrow: intl.formatMessage({
            id: 'JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Eyebrow',
            defaultMessage: 'Collaborate and launch'
        }),
        header: intl.formatMessage({
            id: 'JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Header',
            defaultMessage: 'Connect, collaborate, celebrate'
        }),
        description: intl.formatMessage({
            id: 'JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Description',
            defaultMessage: 'Jira better connects teams and work for more seamless collaboration and faster alignment.'
        }),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f11bi.FeaturedInfoCard), {
                image: {
                    image: {
                        src: launchSharedReleaseDatesImage,
                        alt: intl.formatMessage({
                            id: 'JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Card.ReleaseDates.ImageAlt',
                            defaultMessage: 'Shared release date module in Jira'
                        })
                    }
                },
                Icon: $696d79ea84e61612$export$e5aa73ddcf9d62e8,
                title: intl.formatMessage({
                    id: 'JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Card.ReleaseDates.Header',
                    defaultMessage: 'Shared release dates'
                }),
                body: intl.formatMessage({
                    id: 'JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Card.ReleaseDates.Description',
                    defaultMessage: 'The only place where teams who make your product are connected to teams who launch it. When dates change, every team is in the know.'
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f11bi.FeaturedInfoCard), {
                image: {
                    image: {
                        src: launchYourFavoriteAppImage,
                        alt: intl.formatMessage({
                            id: 'JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Card.SlackFigma.ImageAlt',
                            defaultMessage: 'Slack and Jira integration'
                        })
                    }
                },
                Icon: $696d79ea84e61612$export$d275b7689549104e,
                title: intl.formatMessage({
                    id: 'JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Card.SlackFigma.Header',
                    defaultMessage: 'Slack, Figma, {openBracket}your favorite app{closeBracket} '
                }, {
                    openBracket: '<',
                    closeBracket: '>'
                }),
                body: intl.formatMessage({
                    id: 'JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Card.SlackFigma.Description',
                    defaultMessage: "Bring in real-time data and information from popular 3rd party apps like Slack, Figma, and GitHub, so Jira becomes your team\u2019s trusted source for information."
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f11bi.FeaturedInfoCard), {
                image: {
                    image: {
                        src: launchWorkflowsAutomationImage,
                        alt: intl.formatMessage({
                            id: 'JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Card.WorkflowAutomation.ImageAlt',
                            defaultMessage: 'Workflow trigger setup screen in Jira'
                        })
                    }
                },
                Icon: $696d79ea84e61612$export$74dd0403ff5f7484,
                title: intl.formatMessage({
                    id: 'JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Card.WorkflowsAutomation.Header',
                    defaultMessage: 'Workflows and automation'
                }),
                body: intl.formatMessage({
                    id: 'JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Card.WorkflowAutomation.Description',
                    defaultMessage: 'Save time and scale your work confidently with no-code automation and workflows, like approvals, that keeps work moving forward when no one is watching.'
                })
            })
        ]
    });
};

});
parcelRegister("82jSm", function(module, exports) {
$parcel$export(module.exports, "useLocalizedImage", function () { return $6c5cccb5cc778b4c$export$351d137f57ab4fe2; });

var $8e22h = parcelRequire("8e22h");
/**
 * Enforces that values in `imageMaps` satisfy the type `ImageMap`
 * while still allowing for the keys in `imageMaps`
 * to be extracted and used as a union type.
 */ const $6c5cccb5cc778b4c$var$createImageMaps = (imageMaps)=>imageMaps;
/**
 * A map of image ids to their localized URLs.
 *
 * The keys in the map are the ids that should be passed to `useLocalizedImage`.
 * The values are objects thap map locales to URLs for localized images.
 * Note that the `en` is required!
 */ const $6c5cccb5cc778b4c$var$imageMaps = $6c5cccb5cc778b4c$var$createImageMaps({
    // Add image ids and their localized URLs here
    heroImage: {
        en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/image-368080789.webp',
        es: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Hero_es-ES-280262892.webp',
        hu: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Hero_hu-HU-1564215628.webp',
        ko: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Hero_ko-KR-2299841745.webp',
        nl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Hero-nl-NL-29055006.webp',
        ru: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Hero_ru-RU-3031695244.webp',
        fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Herofr-FR-34984137.webp',
        it: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Heroit-IT-215402249.webp',
        br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Heroptbr-PTBR-2288648393.webp',
        de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Hero_de-DE-3182006582.webp',
        jp: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Hero-1517722948.webp',
        pl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Hero-1037378293.webp',
        zh: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Hero-2582835035.webp'
    },
    planLabelImage: {
        en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Plan-1878220112.webp',
        es: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Plan_es-ES-2320946370.webp',
        hu: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Plan_hu-HU-219670370.webp',
        ko: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Plan_ko-KR-830423807.webp',
        nl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Plan_nl-NL-2786930498.webp',
        ru: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Plan_ru-RU-3701573538.webp',
        fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Planfr-FR-3457271915.webp',
        it: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Planit-IT-3195604523.webp',
        br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Planptbr-PTBR-3247145579.webp',
        de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Plan_de-DE-2971266205.webp',
        jp: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Plan-1551581806.webp',
        pl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Plan-2929654303.webp',
        zh: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Plan_zh-CN-681007050.webp'
    },
    trackLabelImage: {
        en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Track-61709455.webp',
        es: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Track_es-ES-3383229661.webp',
        hu: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Track_hu-HU-28375869.webp',
        ko: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Track_ko-KR-1956228992.webp',
        nl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Track_nl-NL-1580836701.webp',
        ru: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Track_ru-RU-1652057597.webp',
        fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Trackfr-FR-545895028.webp',
        it: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Trackit-IT-3805011636.webp',
        br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Trackptbr-PTBR-1151313332.webp',
        de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Track_de-DE-1856152322.webp',
        jp: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Track-1287427121.webp',
        pl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Track-2267954944.webp',
        zh: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Track_zh-CN-2298675573.webp'
    },
    collaborateLabelImage: {
        en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collab-1370881390.webp',
        es: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collab_es-ES-3256840060.webp',
        hu: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collab_hu-HU-2907439260.webp',
        ko: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collab_ko-KR-1915737025.webp',
        nl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collab_nl-NL-3907414524.webp',
        ru: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collab_ru-RU-1681301724.webp',
        fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collabfr-FR-306933269.webp',
        it: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collabit-IT-2959014357.webp',
        br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collabptbr-PTBR-1526398485.webp',
        de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collab_de-DE-3903230755.webp',
        jp: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collab-559675728.webp',
        pl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collab-2507891681.webp',
        zh: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collab_zh-CN-3730365236.webp'
    },
    launchLabelImage: {
        en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launch-3779179643.webp',
        es: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launch_es-ES-1284707561.webp',
        hu: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launch_hu-HU-4125799561.webp',
        ko: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launch_ko-KR-804198996.webp',
        nl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launch_nl-NL-1935282025.webp',
        ru: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launch_ru-RU-3225671625.webp',
        fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launchfr-FR-492072672.webp',
        it: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launchit-IT-2893616864.webp',
        br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launchptbr-PTBR-177406496.webp',
        de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launch_de-DE-3859546614.webp',
        jp: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launch-236640965.webp',
        pl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launch-724975156.webp',
        zh: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launch_zh-CN-3721511201.webp'
    },
    reportLabelImage: {
        en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Report-161454665.webp',
        es: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Report_es-ES-585529307.webp',
        hu: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Report_hu-HU-388065915.webp',
        ko: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Report_ko-KR-403646438.webp',
        nl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Report_nl-NL-1236103771.webp',
        ru: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Report_ru-RU-3382627771.webp',
        fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Reportfr-FR-426962258.webp',
        it: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Reportit-IT-2146252498.webp',
        br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Reportptbr-PTBR-1506788626.webp',
        de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Report_de-DE-1473304260.webp',
        jp: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Report-1135116023.webp',
        pl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Report-3347665734.webp',
        zh: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Report_zh-CN-2860637139.webp'
    },
    planListViewImage: {
        en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/plan-list-view-194474286.webp',
        es: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001_es-ES-2187812077.webp',
        hu: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001_hu-HU-529772653.webp',
        ko: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001_ko-KR-912241933.webp',
        nl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001_nl-NL-3071040621.webp',
        ru: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001_ru-RU-1543276909.webp',
        fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001fr-FR-4036874011.webp',
        it: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001it-IT-1435305947.webp',
        br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001ptbr-PTBR-1646874907.webp',
        de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001_de-DE-3074059530.webp',
        jp: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001-948026910.webp',
        pl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001-4156364335.webp',
        zh: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001_zh-CN-248550045.webp'
    },
    planCalendarImage: {
        en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/plan-calendar-view-3686747294.webp',
        es: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002_es-ES-4180018574.webp',
        hu: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002_hu-HU-2766112334.webp',
        ko: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002_ko-KR-3040982382.webp',
        nl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002_nl-NL-751132046.webp',
        ru: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002_ru-RU-3037425358.webp',
        fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002fr-FR-264278680.webp',
        it: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002it-IT-774319384.webp',
        br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002ptbr-PTBR-2340951128.webp',
        de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002_de-DE-852905257.webp',
        jp: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002-528338429.webp',
        pl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002-1352144332.webp',
        zh: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002_zh-CN-92973118.webp'
    },
    planSprintsBacklogImage: {
        en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/plan-sprints-backlog-3533034495.webp',
        es: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003_es-ES-111313327.webp',
        hu: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003_hu-HU-2885932719.webp',
        ko: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003_ko-KR-2978588495.webp',
        nl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003_nl-NL-3774460207.webp',
        ru: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003_ru-RU-4230471727.webp',
        fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003fr-FR-726055961.webp',
        it: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003it-IT-2656446425.webp',
        br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003ptbr-PTBR-891882521.webp',
        de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003_de-DE-3628604488.webp',
        jp: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003-3756990428.webp',
        pl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003-846581101.webp',
        zh: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003_zh-CN-1061927263.webp'
    },
    planTimelineImage: {
        en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/plan-timeline-4119095287.webp',
        es: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004_es-ES-1062283080.webp',
        hu: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004_hu-HU-3613163400.webp',
        ko: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004_ko-KR-3905143976.webp',
        nl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004_nl-NL-629198920.webp',
        ru: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004_ru-RU-631159688.webp',
        fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004fr-FR-1420566174.webp',
        it: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004it-IT-3283003422.webp',
        br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004ptbr-PTBR-3398383966.webp',
        de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004_de-DE-3798227823.webp',
        jp: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004-2344293819.webp',
        pl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004-65640202.webp',
        zh: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004_zh-CN-43781880.webp'
    },
    trackProjectBoardsImage: {
        en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/track-project-boards-1345608737.webp',
        es: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001_es-ES-2893710705.webp',
        hu: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001_hu-HU-1128889137.webp',
        ko: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001_ko-KR-1991995121.webp',
        nl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001_nl-NL-3117326833.webp',
        ru: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001_ru-RU-2679980209.webp',
        fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001fr-FR-775791207.webp',
        it: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001it-IT-3559459943.webp',
        br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001ptbr-PTBR-1057291367.webp',
        de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001_de-DE-2702397782.webp',
        jp: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001-2821188546.webp',
        pl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001-3940287731.webp',
        zh: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001_zh-CN-2162175841.webp'
    },
    trackTaskManagementImage: {
        en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/track-task-management-158514083.webp',
        es: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002_es-ES-1304081970.webp',
        hu: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002_hu-HU-3046449970.webp',
        ko: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002_ko-KR-4045234866.webp',
        nl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002_nl-NL-1847663410.webp',
        ru: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002_ru-RU-143791666.webp',
        fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002fr-FR-3937704452.webp',
        it: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002it-IT-2056260804.webp',
        br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002ptbr-PTBR-1262140356.webp',
        de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002_de-DE-2273949461.webp',
        jp: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002-1980867905.webp',
        pl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002-3060959664.webp',
        zh: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002_zh-CN-1124331746.webp'
    },
    trackDependencyManagementImage: {
        en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/track-dependency-management-3383416513.webp',
        es: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003_es-ES-519446131.webp',
        hu: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003_hu-HU-2597762739.webp',
        ko: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003_ko-KR-2710641267.webp',
        nl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003_nl-NL-948636659.webp',
        ru: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003_ru-RU-805907123.webp',
        fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003fr-FR-3862859045.webp',
        it: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003it-IT-899278885.webp',
        br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003ptbr-PTBR-561550885.webp',
        de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003_de-DE-3571317332.webp',
        jp: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003-681376448.webp',
        pl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003-792789361.webp',
        zh: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003_zh-CN-3400868451.webp'
    },
    trackGoalTrackingImage: {
        en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/track-goal-tracking-2550106487.webp',
        es: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004_es-ES-3670223412.webp',
        hu: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004_hu-HU-3589060020.webp',
        ko: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004_ko-KR-1965549108.webp',
        nl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004_nl-NL-1673756468.webp',
        ru: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004_ru-RU-2335341108.webp',
        fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004fr-FR-34424514.webp',
        it: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004it-IT-3310367362.webp',
        br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004ptbr-PTBR-2386394754.webp',
        de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004_de-DE-2554936851.webp',
        jp: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004-3474928967.webp',
        pl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004-2541054262.webp',
        zh: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004_zh-CN-2539167460.webp'
    },
    launchSharedReleaseDatesImage: {
        en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/launch-shared-release-dates-1278148773.webp',
        es: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001_es-ES-2825366097.webp',
        hu: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001_hu-HU-17543633.webp',
        ko: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001_ko-KR-1641702961.webp',
        nl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001_nl-NL-3905234641.webp',
        ru: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001_ru-RU-1474490321.webp',
        fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001fr-FR-1231209191.webp',
        it: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001it-IT-2864685991.webp',
        br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001ptbr-PTBR-1060273383.webp',
        de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001_de-DE-336816374.webp',
        jp: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001-3868783586.webp',
        pl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001-1515546771.webp',
        zh: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001_zh-CN-1419555617.webp'
    },
    launchYourFavoriteAppImage: {
        en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/launch-your-favorite-app-2394898694.webp',
        es: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002_es-ES-3521797326.webp',
        hu: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002_hu-HU-436086830.webp',
        ko: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002_ko-KR-3646187539.webp',
        nl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002_nl-NL-2753210190.webp',
        ru: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002_ru-RU-772035182.webp',
        fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002fr-FR-2890898724.webp',
        it: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002it-IT-659776164.webp',
        br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002ptbr-PTBR-1851042404.webp',
        de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002_de-DE-1088218453.webp',
        jp: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002-3724103425.webp',
        pl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002-22237808.webp',
        zh: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002_zh-CN-1063538050.webp'
    },
    launchWorkflowsAutomationImage: {
        en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/launch-workflows-automation-2356540848.webp',
        es: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003_es-ES-1136820627.webp',
        hu: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003_hu-HU-1318620819.webp',
        ko: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003_ko-KR-4096002803.webp',
        nl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003_nl-NL-701640211.webp',
        ru: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003_ru-RU-1260566547.webp',
        fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003fr-FR-742697573.webp',
        it: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003it-IT-555982117.webp',
        br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003ptbr-PTBR-3107713637.webp',
        de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003_de-DE-816862644.webp',
        jp: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003-671006752.webp',
        pl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003-3547956049.webp',
        zh: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003_zh-CN-2248394595.webp'
    },
    reportPlanYourWorkImage: {
        en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/report-plan-your-work-3125149458.webp',
        es: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001_es-ES-632410416.webp',
        hu: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001_hu-HU-3065455472.webp',
        ko: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001_ko-KR-1532904656.webp',
        nl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001_nl-NL-1310062384.webp',
        ru: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001_ru-RU-2476318832.webp',
        fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001fr-FR-3982217318.webp',
        it: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001it-IT-2788550118.webp',
        br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001ptbr-PTBR-2400170662.webp',
        de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001_de-DE-1437448791.webp',
        jp: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001-428996611.webp',
        pl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001-573869554.webp',
        zh: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001_zh-CN-2842346112.webp'
    },
    reportDuringYourProjectImage: {
        en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/report-during-your-project-3187559990.webp',
        es: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002_es-ES-2948979027.webp',
        hu: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002_hu-HU-3833184595.webp',
        ko: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002_ko-KR-3046902707.webp',
        nl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002_nl-NL-373810899.webp',
        ru: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002_ru-RU-937298899.webp',
        fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002fr-FR-2722552485.webp',
        it: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002it-IT-1760744037.webp',
        br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002ptbr-PTBR-2857878437.webp',
        de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002_de-DE-384230900.webp',
        jp: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002-1804751584.webp',
        pl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002-873723665.webp',
        zh: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/002_zh-CN-2609941795.webp'
    },
    reportWhenYouLaunchImage: {
        en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/report-when-you-launch-1999669051.webp',
        es: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003_es-ES-184654834.webp',
        hu: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003_hu-HU-2168975026.webp',
        ko: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003_ko-KR-933027090.webp',
        nl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003_nl-NL-3642225138.webp',
        ru: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003_ru-RU-116775218.webp',
        fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003fr-FR-1939314020.webp',
        it: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003it-IT-1748958436.webp',
        br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003ptbr-PTBR-4034521252.webp',
        de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003_de-DE-3037516437.webp',
        jp: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003-4127636161.webp',
        pl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003-912760624.webp',
        zh: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/003_zh-CN-1622278210.webp'
    },
    reportBringItAllTogetherImage: {
        en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/report-bring-it-all-together-2435824002.webp',
        es: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004_es-ES-35668245.webp',
        hu: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004_hu-HU-1879148693.webp',
        ko: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004_ko-KR-681638133.webp',
        nl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004_nl-NL-1789762965.webp',
        ru: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004_ru-RU-2525782933.webp',
        fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004fr-FR-904249251.webp',
        it: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004it-IT-1751247971.webp',
        br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004ptbr-PTBR-966252707.webp',
        de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004_de-DE-1966850610.webp',
        jp: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004-92672934.webp',
        pl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004-1929635927.webp',
        zh: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/004_zh-CN-4274294245.webp'
    },
    artificialIntelligenceImage: {
        en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/artificial-intelligence-2046937004.webp',
        es: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Image%20AI001_es-ES%201_es-ES-989623482.webp',
        hu: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001_hu-HU-3851804662.webp',
        ko: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001_ko-KO-813949256.webp',
        nl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001_nl-NL-1612463222.webp',
        ru: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/AI_Smart%20summary_JSW%201_ru-RU-2161971397.webp',
        fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001fr-FR-1823876768.webp',
        it: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001_it-IT-2008232250.webp',
        br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001ptbr-PTBR-3467326432.webp',
        de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001_de-DE-1473393171.webp',
        jp: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001-440488517.webp',
        pl: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001-928822708.webp',
        zh: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/001-2477633690.webp'
    }
});
function $6c5cccb5cc778b4c$export$351d137f57ab4fe2(id) {
    const intl = (0, $8e22h.default)();
    const imageMap = $6c5cccb5cc778b4c$var$imageMaps[id];
    return imageMap[intl.locale] ?? imageMap.en;
}

});



parcelRegister("Tm4Gw", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePageBannerAlert", function () { return $581896a3442fe3b7$export$5f2661a957aa01ba; });

var $7VQPk = parcelRequire("7VQPk");

var $k3xrk = parcelRequire("k3xrk");
const $581896a3442fe3b7$export$5f2661a957aa01ba = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k3xrk.GWP8238AcquisitionBanner), {
        productKey: "jiraSoftware",
        identifier: "JiraSoftwarePageTemplate.banner.gwp-8238-announcement",
        ufoSegmentName: "jira-software-bannerAlert-gwp8238",
        testId: "gwp-8238-announcement-jira",
        linkTextId: "JiraSoftwarePage.banner-alert.gwp-8238-announcement.link-text",
        linkTextDefault: "Learn more"
    });
};

});
parcelRegister("k3xrk", function(module, exports) {
$parcel$export(module.exports, "GWP8238AcquisitionBanner", function () { return $8c4f05102dffb3c9$export$21516a4ccbdd4e52; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $iRMRa = parcelRequire("iRMRa");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $dEFIL = parcelRequire("dEFIL");
const $8c4f05102dffb3c9$var$AcquisitionAnnouncementDetail = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "BannerAlert.gwp-8238-announcement.event-details",
        defaultMessage: "<strong>Breaking news:</strong> DX to join Atlassian!",
        values: (0, $iRMRa.DEFAULT_VALUES)
    });
const $8c4f05102dffb3c9$export$21516a4ccbdd4e52 = ({ productKey: productKey, identifier: identifier, ufoSegmentName: ufoSegmentName, testId: testId, linkTextId: linkTextId = 'BannerAlert.gwp-8238-announcement.link-text', linkTextDefault: linkTextDefault = 'Learn more' })=>{
    const intl = (0, $8e22h.default)();
    if (!(0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp8238BannerAnnouncement)) return null;
    const linkText = intl.formatMessage({
        id: linkTextId,
        defaultMessage: linkTextDefault
    });
    const acquisitionAnnouncementConfig = {
        imageProps: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/v8lbu3715h6ef46x68cmh3tl207d4l74.svg',
            alt: 'DX',
            width: 50
        },
        imageMobileProps: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/v8lbu3715h6ef46x68cmh3tl207d4l74.svg',
            alt: 'DX',
            width: 50
        },
        identifier: identifier,
        text: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)($8c4f05102dffb3c9$var$AcquisitionAnnouncementDetail, {}),
                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    "data-testid": testId
                })
            ]
        }),
        mobileText: /*#__PURE__*/ (0, $7VQPk.jsx)($8c4f05102dffb3c9$var$AcquisitionAnnouncementDetail, {}),
        productKey: productKey,
        backgroundPreset: 'gwp-8238-announcement',
        linkText: linkText,
        linkUrl: 'https://www.atlassian.com/blog/announcements/atlassian-acquires-dx',
        dataEventProps: {
            'data-product-key': productKey,
            'data-event-component': 'linkButton',
            'data-event-container': 'announcementBanner',
            'data-event': 'clicked',
            'data-label': linkText,
            'data-label-english': 'Learn more'
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: ufoSegmentName,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dEFIL.EnhancedBannerAlert), {
            ...acquisitionAnnouncementConfig
        })
    });
};

});


parcelRegister("73ThH", function(module, exports) {
$parcel$export(module.exports, "GartnerSection", function () { return $b4828e26cb60559a$export$4c6bc3f3981e1f4c; });
/* gartner-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $1rGpC = parcelRequire("1rGpC");

var $4X0dO = parcelRequire("4X0dO");

var $gIKKj = parcelRequire("gIKKj");
const $b4828e26cb60559a$var$GartnerStyles = null;
const $b4828e26cb60559a$export$4c6bc3f3981e1f4c = ({ experimentEnabled: experimentEnabled })=>{
    const getGwp4948GartnerJiraProductTourExperiment = (0, $gIKKj.useExperiment)((0, $4X0dO.experiments).gwp4948GartnerJiraProductTourExperiment);
    const gwp4948GartnerJiraProductTourExperimentIsActive = experimentEnabled || getGwp4948GartnerJiraProductTourExperiment !== undefined && getGwp4948GartnerJiraProductTourExperiment.type === 'enrolled' && getGwp4948GartnerJiraProductTourExperiment.value === 'test';
    const intl = (0, $8e22h.default)();
    const gartnerImage = // eslint-disable-next-line local/no-non-orangelogic-images-eslint
    'https://wac-cdn.atlassian.com/misc-assets/webp-images/gartner-jsw-left-img.webp';
    const gartnerMarketingHref = (0, $jQ0cd.useLocalizedHref)('https://www.atlassian.com/gartner/magic-quadrant-marketing-work-management');
    const gartnerDevopsHref = (0, $jQ0cd.useLocalizedHref)('https://www.atlassian.com/gartner/magic-quadrant-devops');
    const gartnerMarketingLink = (children)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
            href: gartnerMarketingHref,
            children: children
        });
    const gartnerDevopsLink = (children)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
            href: gartnerDevopsHref,
            children: children
        });
    if (gwp4948GartnerJiraProductTourExperimentIsActive) return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1e0c1txw _vwz410nf _1bah1h6o _ca0q53f4 _u5f3idpf _n3td12am _19bvidpf _1pfhkgzx _1itk1sxn _43ds5hrz _11eb8pqr _d62sidpf _dubxo1fv"
        ]),
        style: {
            "--_lwvw50": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue100')),
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1rGpC.Row), {
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                    image: {
                        src: gartnerImage,
                        alt: ''
                    }
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                            children: intl.formatMessage({
                                id: 'JiraSoftwarePageTemplate.GartnerSection.header',
                                defaultMessage: "Atlassian named a Leader in the 2024 Gartner\xae Magic Quadrant"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "JiraSoftwarePageTemplate.GartnerSection.body",
                            defaultMessage: `The best work management solution for all teams \u{2014} Atlassian is the only platform to be recognized as a Leader for both <gartnerMarketingLink>Marketing</gartnerMarketingLink> and <gartnerDevopsLink>DevOps</gartnerDevopsLink>`,
                            values: {
                                gartnerMarketingLink: gartnerMarketingLink,
                                gartnerDevopsLink: gartnerDevopsLink
                            }
                        })
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {});
};

});

parcelRegister("4AJjX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5f8bab4e5d7d8552$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $jQ0cd = parcelRequire("jQ0cd");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $eO8Mp = parcelRequire("eO8Mp");

var $iNnWi = parcelRequire("iNnWi");
const $5f8bab4e5d7d8552$var$BuildAndSupportDoubleFeatureSection = ()=>{
    const intl = (0, $8e22h.default)();
    const useGWP7617Gate = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7617JiraShortTermAiInfusionGate);
    const tailoredHeadingText = useGWP7617Gate ? intl.formatMessage({
        id: 'jira-product-tour.staggered-double-feature-section.header-text-gwp-7617',
        defaultMessage: 'Tailor for your team'
    }) : intl.formatMessage({
        id: 'jira-product-tour.staggered-double-feature-section.second-feature-header-text',
        defaultMessage: 'Tailor it for your team'
    });
    const tailoredBodyText = useGWP7617Gate ? intl.formatMessage({
        id: 'jira-product-tour.staggered-double-feature-section.second-feature-body-text-gwp-7617',
        defaultMessage: "Customize Jira to match your team\u2019s processes, workflows, language, and more. Integrate with every tool you use to get work done. "
    }) : intl.formatMessage({
        id: 'jira-product-tour.staggered-double-feature-section.second-feature-body-text',
        defaultMessage: "Configure Jira to match your team\u2019s processes, workflows, language, and more. Integrate with every tool you use to get work done."
    });
    const tailoredLinkNew = (0, $jQ0cd.useLocalizedHref)('/software/jira/guides/getting-started/basics#step-3-set-up-your-columns');
    const tailoredLinkOld = (0, $jQ0cd.useLocalizedHref)('/software/jira/guides/issues/overview#what-is-an-issue');
    const tailoredLink = useGWP7617Gate ? tailoredLinkNew : tailoredLinkOld;
    const featureData = [
        {
            headingText: intl.formatMessage({
                id: 'jira-product-tour.staggered-double-feature-section.first-feature-header-text',
                defaultMessage: 'Everything in one place'
            }),
            bodyText: intl.formatMessage({
                id: 'jira-product-tour.staggered-double-feature-section.first-feature-body-text',
                defaultMessage: 'The context you need, when you need it. See software team release dates, real-time views of Figma designs, and more, all inside Jira.'
            }),
            linkText: intl.formatMessage({
                id: 'jira-product-tour.staggered-double-feature-section.first-feature-link-text',
                defaultMessage: 'Explore features'
            }),
            linkUrl: (0, $jQ0cd.useLocalizedHref)('/software/jira/features'),
            imageLink: (0, $iNnWi.getStaggeredDoubleFeautureFirstImage)(intl.locale),
            analyticsEventLabel: 'atlas-55799-jira-features-button-clicked',
            imageHeight: 440
        },
        {
            headingText: tailoredHeadingText,
            bodyText: tailoredBodyText,
            linkText: intl.formatMessage({
                id: 'jira-product-tour.staggered-double-feature-section.second-feature-link-text',
                defaultMessage: 'Learn more'
            }),
            linkUrl: tailoredLink,
            imageLink: (0, $iNnWi.getStaggeredDoubleFeautureSecondImage)(intl.locale),
            analyticsEventLabel: 'atlas-55799-jira-issues-button-clicked',
            imageHeight: 490
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eO8Mp.StaggeredFeatureList), {
        mainHeadingText: intl.formatMessage({
            id: 'jira-product-tour.staggered-double-feature-section.header-text',
            defaultMessage: 'Bring every team together under one roof'
        }),
        subHeadingText: intl.formatMessage({
            id: 'jira-product-tour.staggered-double-feature-section.subheader-text',
            defaultMessage: 'Spend less time trying to get aligned and more time driving projects forward with confidence.'
        }),
        featureData: featureData,
        startingImagePosition: "left"
    });
};
$5f8bab4e5d7d8552$var$BuildAndSupportDoubleFeatureSection.displayName = 'BuildAndSupportDoubleFeatureSection';
var $5f8bab4e5d7d8552$export$2e2bcd8739ae039 = $5f8bab4e5d7d8552$var$BuildAndSupportDoubleFeatureSection;

});
parcelRegister("eO8Mp", function(module, exports) {
$parcel$export(module.exports, "StaggeredFeatureList", function () { return $9992b1ac5c0075b5$export$5bd229e30bf4ab20; });
/* staggered-feature-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");

var $2lwXu = parcelRequire("2lwXu");
const $9992b1ac5c0075b5$var$containerStyle = null;
const $9992b1ac5c0075b5$var$mainHeadingTextStyle = null;
const $9992b1ac5c0075b5$var$subHeadingTextStyle = null;
const $9992b1ac5c0075b5$var$featureContainerStyle = null;
const $9992b1ac5c0075b5$var$featureImageContainerStyle = null;
const $9992b1ac5c0075b5$var$featureBodyContainerStyle = null;
const $9992b1ac5c0075b5$var$featureLinkStyles = null;
const $9992b1ac5c0075b5$var$featureHeadingTextStyle = null;
const $9992b1ac5c0075b5$var$featureBodyTextStyle = null;
const $9992b1ac5c0075b5$var$Feature = ({ featureData: featureData, imagePosition: imagePosition })=>{
    if (imagePosition === 'left') return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx2vrvc _1pfhvbgk _79ty1bp4 _1np61h6o _1rwy1tcg _zzrm1osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($9992b1ac5c0075b5$var$FeatureImage, {
                ...featureData
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)($9992b1ac5c0075b5$var$FeatureBody, {
                ...featureData
            })
        ]
    });
    else return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx2vrvc _1pfhvbgk _79ty1bp4 _1np61h6o _1rwy1tcg _zzrm1osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($9992b1ac5c0075b5$var$FeatureBody, {
                ...featureData
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)($9992b1ac5c0075b5$var$FeatureImage, {
                ...featureData
            })
        ]
    });
};
const $9992b1ac5c0075b5$var$FeatureImage = ({ imageLink: imageLink, imageHeight: imageHeight })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1tvckb7n _1rwy1tcg _1y8o1ogm _bna71ns9 _rtys1ogm _1lre1osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
            image: {
                src: imageLink,
                alt: '',
                width: 600,
                height: imageHeight
            }
        })
    });
};
const $9992b1ac5c0075b5$var$FeatureBody = ({ headingText: headingText, bodyText: bodyText, linkUrl: linkUrl, linkText: linkText, analyticsEventLabel: analyticsEventLabel })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const handleClick = ()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            attributes: {
                name: `${analyticsEventLabel}`,
                section: 'staggered-feature-section'
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1o9zgrho _4cvr1h6o _1pfhvrzy _1bsb1diq _zulpftgi _1tvccs5v _1rwy1tcg _zzrm1osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                className: (0, $2jatx.default)([
                    "_1wybzwfg _ect41vau _k48p1fw0 _vwz410mc _slp31hna _195gidpf _1mouidpf _y3gn1h6o"
                ]),
                style: {
                    "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                },
                children: headingText
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1wyb7vkz _ect4z4z1 _k48p1nn1 _vwz41gkc _slp31hna _y3gn1h6o _p12fng7t _ca0qidpf _u5f310yn _n3tdidpf _19bv10yn _1y8o1osq"
                ]),
                style: {
                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                },
                children: bodyText
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                href: linkUrl,
                onClick: handleClick,
                "aria-label": formatMessage({
                    id: 'learnMoreAbout',
                    defaultMessage: 'Learn more about {subject}'
                }, {
                    subject: headingText
                }),
                className: (0, $2jatx.default)([
                    "_syaz5hrz"
                ]),
                style: {
                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                },
                children: [
                    linkText,
                    " ",
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2lwXu.ArrowRightNoCircle), {})
                ]
            })
        ]
    });
};
const $9992b1ac5c0075b5$export$5bd229e30bf4ab20 = ({ mainHeadingText: mainHeadingText, subHeadingText: subHeadingText, featureData: featureData, startingImagePosition: startingImagePosition })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1mou16xz _195gidpf _1e0c1txw _1bah1h6o _4cvr1h6o _2lx21bp4 _91qc9by0 _1x7014no"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_y3gn1h6o _ect41vau _1wybckbl _zg8l4jg8 _k48p1fw0 _slp31hna _flz0zwfg _1lzozwfg _1cqs1ul9"
                ]),
                style: {
                    "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                },
                children: mainHeadingText
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y3gn1h6o _ect4z4z1 _1wybgktf _zg8l4jg8 _k48p1nn1 _vwz41f4h _1pfh7vkz _1bsbbxu3 _79ty1bp4 _1np61h6o _1rwy1tcg _7se29by0 _zzrm1osq _s637jwe6"
                ]),
                style: {
                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                },
                children: subHeadingText
            }),
            featureData.map((feature, index)=>index % 2 === 0 ? /*#__PURE__*/ (0, $7VQPk.jsx)($9992b1ac5c0075b5$var$Feature, {
                    imagePosition: startingImagePosition === 'left' ? 'left' : 'right',
                    featureData: feature
                }, index) : /*#__PURE__*/ (0, $7VQPk.jsx)($9992b1ac5c0075b5$var$Feature, {
                    imagePosition: startingImagePosition === 'left' ? 'right' : 'left',
                    featureData: feature
                }, index))
        ]
    });
};

});
parcelRegister("2lwXu", function(module, exports) {
$parcel$export(module.exports, "ArrowRightNoCircle", function () { return $bbe047a4ec4aed29$export$c6abe79c9e2193ff; });

var $7VQPk = parcelRequire("7VQPk");
const $bbe047a4ec4aed29$export$c6abe79c9e2193ff = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        "aria-hidden": "true",
        width: "11",
        height: "8",
        viewBox: "0 0 11 8",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M7.40796 0L6.32831 1.2021L8.07854 3.1497H0.763182C0.341906 3.1497 0 3.53038 0 3.99943C0 4.46849 0.341906 4.84917 0.763182 4.84917H8.07854L6.32831 6.7979L7.40796 8L11 3.99943L7.40796 0Z"
        })
    });

});



parcelRegister("ihq7I", function(module, exports) {
$parcel$export(module.exports, "ClosingBanner", function () { return $683d4f00c3f6f587$export$3c134be78c4f7e1c; });
/* closing-banner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $lmQGF = parcelRequire("lmQGF");

var $gfjAv = parcelRequire("gfjAv");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
const $683d4f00c3f6f587$export$3c134be78c4f7e1c = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const useGWP7617Gate = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7617JiraShortTermAiInfusionGate);
    const text = useGWP7617Gate ? formatMessage({
        id: 'jira-product-tour.closing-banner.header-text-gwp-7617',
        defaultMessage: 'No matter what you dream up, Jira helps you get it done.'
    }) : formatMessage({
        id: 'jira-product-tour.closing-banner.header-text',
        defaultMessage: "No matter what you're trying to dream up, Jira helps you get it done"
    });
    const buttonText = formatMessage({
        id: 'jira-product-tour.closing-banner.button-text',
        defaultMessage: 'Get Jira free'
    });
    const ctaButtonUrl = '/try/cloud/signup?bundle=jira-software';
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1b1v _4cvr1h6o _p12f1dho _19pkidpf _2hwx1wug _otyridpf _18u01wug _1eogidpf _qjx39by0 _1celidpf _5n7a9by0 _1gde1bp4 _nssp1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _ca0qidpf _u5f3gktf _n3tdidpf _19bvgktf _zulp1ylp _144t1wqb _zzsz1h6o _1tz91y44"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        className: (0, $2jatx.default)([
                            "_p12fntfb _ect41vau _k48p1fw0 _1wyb1ylp _vwz4ckbl _19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1afi _xsmr1h6o _1cqs1ul9 _1bys14no"
                        ]),
                        style: {
                            "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display')),
                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                        },
                        children: text
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gfjAv.default), {
                        intentType: 'button',
                        containerId: 'jira-product-tour-overview-closing-banner',
                        productKey: 'jira-software.ondemand',
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                            variant: "primary",
                            size: "small",
                            color: "yellow",
                            href: (0, $jQ0cd.useLocalizedHref)(ctaButtonUrl),
                            dataEventProps: {
                                'data-product-key': 'jira',
                                'data-event': 'clicked',
                                'data-event-component': 'linkButton',
                                'data-event-container': 'ctaSection',
                                'data-label': 'get-jira-free',
                                'data-label-english': `${buttonText}`,
                                'data-track-event': 'jira-pt.closing-banner.get-jira-free'
                            },
                            children: buttonText
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1bsbhvew _4t3ieq5r _1wpzh9n0 _1wn41h6o _1tvd1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_mezjhvew _bna7eq5r"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                            image: {
                                src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/865y3n8f2i1843j2vs45535l48vtx77r.webp',
                                alt: '',
                                width: 303,
                                height: 303
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswstnw _152t1skh _1e021wqb"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                            image: {
                                src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/xbvh6b7g0mjibasf143rj6711054m0cf.webp',
                                alt: '',
                                width: 95,
                                height: 97
                            }
                        })
                    })
                ]
            })
        ]
    });
};
$683d4f00c3f6f587$export$3c134be78c4f7e1c.displayName = 'ClosingBanner';
const $683d4f00c3f6f587$var$ctaBannerContainer = null;
const $683d4f00c3f6f587$var$contentContainer = null;
const $683d4f00c3f6f587$var$headerStyles = null;
const $683d4f00c3f6f587$var$imageContainer = null;
const $683d4f00c3f6f587$var$imageStyles = null;
const $683d4f00c3f6f587$var$overlayStarImage = null;

});

parcelRegister("iFk4q", function(module, exports) {
$parcel$export(module.exports, "Footer", function () { return $f4806120b6b5d670$export$a06f1c675e846f6f; });

var $7VQPk = parcelRequire("7VQPk");

var $iLjCW = parcelRequire("iLjCW");
const $f4806120b6b5d670$export$a06f1c675e846f6f = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iLjCW.GlobalFooter), {})
    });
};
$f4806120b6b5d670$export$a06f1c675e846f6f.displayName = 'Footer';

});

parcelRegister("fCRLS", function(module, exports) {
$parcel$export(module.exports, "IntegrationsSection", function () { return $adef94d25ceb314a$export$94c8b142f0acfaff; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $kVWxs = parcelRequire("kVWxs");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
const $adef94d25ceb314a$export$94c8b142f0acfaff = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const useGWP7617Gate = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7617JiraShortTermAiInfusionGate);
    // TODO: add width and height prop to iconData to use in Picture component
    const iconData = [
        {
            url: 'https://dam-cdn.atl.orangelogic.com/AssetLink/n773sikm845802hme5xs1ne04uy2g837.webp',
            altText: intl.formatMessage({
                id: 'jira-product-tour.integrations-section.microsoft-alt-text',
                defaultMessage: 'Microsoft Teams icon'
            }),
            width: 60,
            height: 50
        },
        {
            url: 'https://dam-cdn.atl.orangelogic.com/AssetLink/s2b5621s46n36ogarwic4734b30xge4b.webp',
            altText: intl.formatMessage({
                id: 'jira-product-tour.integrations-section.google-drive-alt-text',
                defaultMessage: 'Google Drive icon'
            }),
            width: 60,
            height: 50
        },
        {
            url: 'https://dam-cdn.atl.orangelogic.com/AssetLink/wrb81j78p4733kc10bdjw8v637h1w438.webp',
            altText: intl.formatMessage({
                id: 'jira-product-tour.integrations-section.google-doc-alt-text',
                defaultMessage: 'Google Docs icon'
            }),
            width: 60,
            height: 50
        },
        {
            url: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1m0x1742g31t1446203avy1kpi468me1.webp',
            altText: intl.formatMessage({
                id: 'jira-product-tour.integrations-section.figma-alt-text',
                defaultMessage: 'Figma icon'
            }),
            width: 48,
            height: 60
        },
        {
            url: 'https://dam-cdn.atl.orangelogic.com/AssetLink/s2035t28j8p045avd6kjvjpr68g0uyfb.webp',
            altText: intl.formatMessage({
                id: 'jira-product-tour.integrations-section.miro-alt-text',
                defaultMessage: 'Miro icon'
            }),
            width: 60,
            height: 50
        },
        {
            url: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ow67lf57t0be1t6ami55288g1dx2kp46.webp',
            altText: intl.formatMessage({
                id: 'jira-product-tour.integrations-section.slack-alt-text',
                defaultMessage: 'Slack icon'
            }),
            width: 60,
            height: 58
        },
        {
            url: 'https://dam-cdn.atl.orangelogic.com/AssetLink/uje2jom52scmv5bs8o1ej15sp162l6h0.webp',
            altText: intl.formatMessage({
                id: 'jira-product-tour.integrations-section.zoom-alt-text',
                defaultMessage: 'Zoom icon'
            }),
            width: 60,
            height: 13
        }
    ];
    const handleClick = ()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            attributes: {
                name: 'atlas-55799-integrations-button-clicked',
                section: 'integration-section'
            }
        }).fire();
    };
    const headingText = useGWP7617Gate ? intl.formatMessage({
        id: 'jira-product-tour.integrations-section.heading-text-gwp-7617',
        defaultMessage: 'Meet teams where they work'
    }) : intl.formatMessage({
        id: 'jira-product-tour.integrations-section.heading-text',
        defaultMessage: 'Meets teams where they work'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kVWxs.OffsetIconCollection), {
        headingText: headingText,
        bodyText: intl.formatMessage({
            id: 'jira-product-tour.integrations-section.body-text',
            defaultMessage: 'If your team uses it, we integrate with it. Easily add your favorite tools from the Atlassian Marketplace, keeping Jira as your central source of truth.'
        }),
        iconData: iconData,
        ctaText: intl.formatMessage({
            id: 'jira-product-tour.integrations-section.cta-text',
            defaultMessage: 'Go to Marketplace'
        }),
        ctaLink: "https://marketplace.atlassian.com",
        ctaOnClickFunc: handleClick
    });
};
$adef94d25ceb314a$export$94c8b142f0acfaff.displayName = 'IntegrationsSection';

});
parcelRegister("kVWxs", function(module, exports) {
$parcel$export(module.exports, "OffsetIconCollection", function () { return $bef0e19d7a97ecea$export$87daf6ae3676874; });
/* offset-icon-collection.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $jKShK = parcelRequire("jKShK");

var $hnmMQ = parcelRequire("hnmMQ");
const $bef0e19d7a97ecea$var$sectionContainer = null;
const $bef0e19d7a97ecea$var$contentContainer = null;
const $bef0e19d7a97ecea$var$textContainerStyles = null;
const $bef0e19d7a97ecea$var$headingTextStyles = null;
const $bef0e19d7a97ecea$var$ctaStyles = null;
const $bef0e19d7a97ecea$var$iconContainerStyles = null;
const $bef0e19d7a97ecea$var$iconPictureStyles = null;
const $bef0e19d7a97ecea$var$animationStyle = null;
const $bef0e19d7a97ecea$export$4b1f681ca613adbb = ({ src: src, alt: alt, width: width, height: height })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: src,
            alt: alt,
            width: width,
            height: height
        }
    });
};
const $bef0e19d7a97ecea$export$87daf6ae3676874 = ({ iconData: iconData, headingText: headingText, bodyText: bodyText, ctaText: ctaText, ctaLink: ctaLink, ctaOnClickFunc: ctaOnClickFunc })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _bfhk1hxd _1e0c1txw _1bah1h6o _4cvr1h6o _2lx21bp4 _1pbykb7n _kqswh2mm"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx2vrvc _p12f17gh _1mou1qr7 _liwc1txw _79ty1bp4 _1np61h6o _s637jwe6 _1eogidpf _qjx39by0 _1celidpf _5n7a9by0 _1x701ylp"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _zulp1ul9 _4cvr1y6m _syazqlpt _bozg1ul9 _m80d1h6o _79ty1bp4 _1np61h6o _s637jwe6 _1eogidpf _qjx310yn _1celidpf _5n7a10yn"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                            className: (0, $2jatx.default)([
                                "_k48p1fw0 _1wyb1wto _vwz4cjiy _1mouidpf _1r3wl07h"
                            ]),
                            children: headingText
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            children: bodyText
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            href: ctaLink,
                            onClick: ctaOnClickFunc,
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                className: (0, $2jatx.default)([
                                    "_11q7glyw _1wyb1k92 _r06hglyw _2rko1ul9 _ca0q19bv _u5f31ul9 _n3td19bv _19bv1ul9 _ect41kw7 _19it1axk _80omtlke"
                                ]),
                                children: ctaText
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    ref: scrollRef,
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1n261g80 _i0dl1osq _zulp1wyk _1bah1h6o _ae4v1h6o _p12f18a8 _1o9zidpf _zzrm1kdj _1rwy1ylp"
                    ]),
                    children: iconData.map((icon, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            style: {
                                animationDelay: `${0.5 + 0.25 * index}s`
                            },
                            className: (0, $2jatx.default)([
                                "_2rko1ul9 _1e0c1txw _4cvr1h6o _1bah1h6o _tip8kb7n _5sagw1p3 _bfhku67f _1bsb53f4 _4t3i53f4 _ca0qgktf _u5f3gktf _n3tdgktf _19bvgktf _vavro7ao _zzrmvbgk _1gdlvbgk _60iy1txw _2a1o1h6o _1biz1h6o _137x8tad _mgbt1343 _v1631fm0 _1vsm1fm0 _1v3g1fm0 _1vvw1fm0 _rtys1osq _19l31osq _mezj1wug _bna71wug",
                                sectionIsVisible && "_j7hq1nm9"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)($bef0e19d7a97ecea$export$4b1f681ca613adbb, {
                                src: icon.url,
                                alt: icon.altText,
                                width: icon.width,
                                height: icon.height
                            })
                        }, index))
                })
            ]
        })
    });
};

});


parcelRegister("bRgjW", function(module, exports) {
$parcel$export(module.exports, "JswCollaborateSection", function () { return $0461ddbaa879edb2$export$46dbd2229fc0687f; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $iNnWi = parcelRequire("iNnWi");

var $h5cWZ = parcelRequire("h5cWZ");
const $0461ddbaa879edb2$export$46dbd2229fc0687f = ()=>{
    const intl = (0, $8e22h.default)();
    const useGWP7617Gate = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7617JiraShortTermAiInfusionGate);
    // first item
    const firstFeatureDescriptionOld = intl.formatMessage({
        id: 'jira-product-tour.collaborate-section.first-feature-description-text',
        defaultMessage: 'From short projects, to large cross-functional programs, Jira helps break big ideas down into achievable steps. Organize work, create milestones, map dependencies and more.'
    });
    const firstFeatureDescriptionAI = intl.formatMessage({
        id: 'jira-product-tour.collaborate-section.first-feature-description-text-ai',
        defaultMessage: 'From short projects, to large cross-functional programs, Jira uses AI to help break big ideas down into achievable steps. Organize work, create milestones, map dependencies and more.'
    });
    // third item
    const thirdFeatureTitleOld = intl.formatMessage({
        id: 'jira-product-tour.collaborate-section.third-feature-title-text',
        defaultMessage: 'Track work your way'
    });
    const thirdFeatureTitleAI = intl.formatMessage({
        id: 'jira-product-tour.collaborate-section.third-feature-title-text-ai',
        defaultMessage: 'Work your way'
    });
    const thirdFeatureDescriptionOld = intl.formatMessage({
        id: 'jira-product-tour.collaborate-section.third-feature-description-text',
        defaultMessage: 'Visualize work with lists, boards, backlogs, and more. Make workflows for any process and integrate with tools you love.'
    });
    const thirdFeatureDescriptionAI = intl.formatMessage({
        id: 'jira-product-tour.collaborate-section.third-feature-description-text-ai',
        defaultMessage: "Keep Jira in sync with your favorite tools, customize your workflows with AI \u2013 and, stay on top of it all with lists, boards, and timeline views."
    });
    // fourth item
    const fourthFeatureTitleOld = intl.formatMessage({
        id: 'jira-product-tour.collaborate-section.fourth-feature-title-text',
        defaultMessage: 'Optimize with insights'
    });
    const fourthFeatureTitleAI = intl.formatMessage({
        id: 'jira-product-tour.collaborate-section.fourth-feature-title-text-ai',
        defaultMessage: 'Keep your projects on track'
    });
    const fourthFeatureDescriptionOld = intl.formatMessage({
        id: 'jira-product-tour.collaborate-section.fourth-feature-description-text',
        defaultMessage: 'Get visibility into project progress, understand risks, and surface insights from real-time data to help you improve team performance.'
    });
    const fourthFeatureDescriptionAI = intl.formatMessage({
        id: 'jira-product-tour.collaborate-section.fourth-feature-description-text-ai',
        defaultMessage: 'Get visibility into project progress, understand risks, and surface insights from real-time data to help you improve team performance.'
    });
    const options = [
        {
            title: intl.formatMessage({
                id: 'jira-product-tour.collaborate-section.first-feature-title-text',
                defaultMessage: "\u26A1 Plan and organize tasks"
            }),
            image: (0, $iNnWi.getCollaborateFirstImage)(intl.locale),
            description: useGWP7617Gate ? firstFeatureDescriptionAI : firstFeatureDescriptionOld
        },
        {
            title: intl.formatMessage({
                id: 'jira-product-tour.collaborate-section.second-feature-title-text',
                defaultMessage: 'Align work to goals'
            }),
            image: (0, $iNnWi.getCollaborateSecondImage)(intl.locale),
            description: intl.formatMessage({
                id: 'jira-product-tour.collaborate-section.second-feature-description-text',
                defaultMessage: "Link work to goals so everyone can see how their work contributes to company objectives and stay aligned to what\u2019s important."
            })
        },
        {
            title: useGWP7617Gate ? thirdFeatureTitleAI : thirdFeatureTitleOld,
            image: (0, $iNnWi.getCollaborateThirdImage)(intl.locale),
            description: useGWP7617Gate ? thirdFeatureDescriptionAI : thirdFeatureDescriptionOld
        },
        {
            title: useGWP7617Gate ? fourthFeatureTitleAI : fourthFeatureTitleOld,
            image: (0, $iNnWi.getCollaborateFourthImage)(intl.locale),
            description: useGWP7617Gate ? fourthFeatureDescriptionAI : fourthFeatureDescriptionOld
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $h5cWZ.JswCollaborate), {
        options: options,
        heading: intl.formatMessage({
            id: 'jira-product-tour.collaborate-section.title-text',
            defaultMessage: 'Made for complex projects or everyday tasks'
        })
    });
};
$0461ddbaa879edb2$export$46dbd2229fc0687f.displayName = 'JswCollaborateSection';

});
parcelRegister("h5cWZ", function(module, exports) {
$parcel$export(module.exports, "JswCollaborate", function () { return $b8e4fdbb89836c28$export$b0665de8e27040dd; });
/* jsw-collaborate.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $8e22h = parcelRequire("8e22h");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");
const $b8e4fdbb89836c28$export$b0665de8e27040dd = ({ heading: heading, options: options })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)();
    const [activeOption, setActiveOption] = (0, $1oC0p.useState)(0);
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const changeActive = (index)=>{
        // Cancel all animations before activeOption change
        const progressGrowAnimations = document.getAnimations().filter((animation)=>{
            return animation instanceof CSSAnimation && animation.animationName === 'progressgrow';
        });
        progressGrowAnimations.forEach((animation)=>{
            animation.cancel();
        });
        setActiveOption(index);
    };
    (0, $1oC0p.useEffect)(()=>{
        const progressGrowAnimations = document.getAnimations().filter((animation)=>{
            return animation instanceof CSSAnimation && animation.animationName === 'progressgrow';
        });
        // set finish event
        progressGrowAnimations.forEach((animation)=>{
            animation.onfinish = ()=>{
                setActiveOption(activeOption == options.length - 1 ? 0 : activeOption + 1);
                animation.cancel();
            };
        });
        // Only cycle when visible
        if (!sectionIsVisible) progressGrowAnimations.forEach((animation)=>{
            animation.pause();
        });
        else progressGrowAnimations.forEach((animation)=>{
            animation.play();
        });
    }, [
        activeOption,
        options.length,
        sectionIsVisible
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ref: scrollRef,
        className: (0, $2jatx.default)([
            "_kqswh2mm _1e0c11p5 _6a6z1h6o _4cvr1h6o _1rjc12am _195gzwfg _1ilvzwfg _91qcidpf",
            sectionIsVisible ? 'is-visible' : ''
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y3gn1h6o _91qc9by0 _8fz6e0nm _mezj1mcy _bna71k4y _5nenxk0h _twjk1qjk _14w91a70 _j0lcd4y9 _1jtm14no _rpid14y2 _1h8ed4y9 _1ga514no _1ftj14y2",
                    "top-section"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("h2", {
                    className: (0, $2jatx.default)([
                        "_k48p1fw0 _1wybckbl _vwz48vuz _19pkidpf _2hwxidpf _otyr1ul9 _18u0idpf _1r3w1ul9 _73n214no _z9soidpf _161zidpf _2a8ridpf _ikcgidpf"
                    ]),
                    children: [
                        heading,
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                            image: {
                                src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/s31k3rin80p38d25a3wn54b8354r27vm.webp',
                                alt: '',
                                width: 245,
                                height: 279
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_91qc9by0 _jzgezwfg _1q5112am _11q71afi",
                    "bottom-section"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    "aria-label": formatMessage({
                        id: 'jira-product-tour.collaborate-section.carousel',
                        defaultMessage: 'Carousel'
                    }),
                    className: (0, $2jatx.default)([
                        "_p12f1uof _1e0c1txw _1n261g80 _zulpzwfg _zzrm1osq _79ty1bp4 _1np61h6o _9et11h6o _1yytidpf",
                        "row-width"
                    ]),
                    role: "region",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_i0dlbihp _kqswh2mm _cot22huk",
                                "half texts"
                            ]),
                            children: options.map((option, index)=>{
                                const src = (0, $hnmMQ.extendBfldrCacheTime)(option.image);
                                const isActive = activeOption == index;
                                return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: "option-container",
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                                            className: (0, $2jatx.default)([
                                                "_11q7glyw _r06hglyw _1r04idpf _80omtlke _19itidpf _1wyb1j6v _y3gn1e5h _19pkidpf _2hwxidpf _otyrzwfg _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvgktf _kqswh2mm _4t3i1osq _1vdjzwfg _1bfn10mc _1mjg1tcg _kmcs1ul9 _zpjv1w81 _19141wug _h95w1gmh",
                                                `option ${activeOption == index ? 'active' : 'inactive'}`
                                            ]),
                                            onClick: ()=>changeActive(index),
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_kqswstnw _1e02idpf _152tidpf _u7coidpf _1bsb1l7b _4t3i1osq _bfhk1kby",
                                                        "progress"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                        className: (0, $2jatx.default)([
                                                            "_bfhkoelr _4t3iidpf"
                                                        ])
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                                    className: (0, $2jatx.default)([
                                                        "_1wyb1tcg _vwz41ul9 _k48p1fw0 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _v5641fa5 _1496ni7l"
                                                    ]),
                                                    children: option.title
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                    className: (0, $2jatx.default)([
                                                        "_v5641qn0 _c71lidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1reo15vq _18m915vq"
                                                    ]),
                                                    children: option.description
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_1e0cglyw _liwc11p5 _9et11h6o _1np61h6o",
                                                "mobile-images"
                                            ]),
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                                image: {
                                                    src: src,
                                                    alt: option.title
                                                },
                                                style: {
                                                    aspectRatio: '5/4',
                                                    display: isActive ? 'block' : 'none',
                                                    width: '100%',
                                                    height: 'auto'
                                                },
                                                className: (0, $2jatx.default)([
                                                    "_kqswh2mm _p12f1ogm"
                                                ])
                                            })
                                        })
                                    ]
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            "aria-live": "polite",
                            className: (0, $2jatx.default)([
                                "_i0dlbihp _kqswh2mm _cot22huk",
                                "half images"
                            ]),
                            role: "status",
                            children: options.map((option, index)=>{
                                const src = (0, $hnmMQ.extendBfldrCacheTime)(option.image);
                                const isActive = activeOption == index;
                                return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_liwcglyw",
                                        "desktop-images"
                                    ]),
                                    hidden: !isActive,
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                        image: {
                                            src: src,
                                            alt: option.title
                                        },
                                        style: {
                                            aspectRatio: '5/4',
                                            position: 'absolute',
                                            width: '100%',
                                            height: 'auto'
                                        }
                                    })
                                }, index);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const $b8e4fdbb89836c28$var$topSectionForPictureStyles = null;
const $b8e4fdbb89836c28$var$mobileImagesStyles = null;
const $b8e4fdbb89836c28$var$desktopImagesStyles = null;
const $b8e4fdbb89836c28$var$rowWidthStyles = null;
const $b8e4fdbb89836c28$var$halfStyles = null;
const $b8e4fdbb89836c28$var$progressStyles = null;
const $b8e4fdbb89836c28$var$buttonStyles = null;
const $b8e4fdbb89836c28$var$optionDescriptionStyles = null;
const $b8e4fdbb89836c28$var$innerDivProgressStyles = null;
const $b8e4fdbb89836c28$var$optionH3Styles = null;
const $b8e4fdbb89836c28$var$bottomSectionStyles = null;
const $b8e4fdbb89836c28$var$optionContainerImageStyles = null;
const $b8e4fdbb89836c28$var$h2Styles = null;
const $b8e4fdbb89836c28$var$empowerStyles = null;

});


parcelRegister("dS67T", function(module, exports) {
$parcel$export(module.exports, "JswDoubleFeatureSection", function () { return $8f8dac8bd8ab28d3$export$fa980c3455a6cd08; });
/* jsw-double-feature.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iNnWi = parcelRequire("iNnWi");

var $7asA7 = parcelRequire("7asA7");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");
const $8f8dac8bd8ab28d3$export$fa980c3455a6cd08 = ()=>{
    const intl = (0, $8e22h.default)();
    const doubleFeatureItems = [
        {
            title: intl.formatMessage({
                id: 'jira-product-tour.double-feature-section.first-card-title-text',
                defaultMessage: "Easily see every team\u2019s progress"
            }),
            description: intl.formatMessage({
                id: 'jira-product-tour.double-feature-section.first-card-description-text',
                defaultMessage: "Track every team\u2019s work in a single timeline. Understand progress, map dependencies, and stay ahead of risks."
            }),
            image: (0, $iNnWi.getDoubleFeatureFirstImage)(intl.locale)
        },
        {
            title: intl.formatMessage({
                id: 'jira-product-tour.double-feature-section.second-card-title-text',
                defaultMessage: 'Map work to company impact'
            }),
            description: intl.formatMessage({
                id: 'jira-product-tour.double-feature-section.second-card-description-text',
                defaultMessage: "With goals in Jira, it\u2019s easy to track all the tasks across projects that contribute to a goal, no matter what team is working on it."
            }),
            image: (0, $iNnWi.getDoubleFeatureSecondImage)(intl.locale)
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _1eog16gx _qjx3idpf _1celidpf _5n7aidpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_syaz1pfd _y3gn1h6o _ect41vau _1wyb1ylp _k48p1fw0 _vwz4ckbl _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1r3w1ul9 _1eogidpf _qjx310yn _1celidpf _5n7a10yn"
                ]),
                style: {
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                    "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                },
                children: intl.formatMessage({
                    id: 'jira-product-tour.double-feature-section.title-text',
                    defaultMessage: 'Never lose sight of the big picture'
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1h6o _zulp1ul9 _ca0q1u1b _u5f3idpf _n3td10yn _19bvidpf _79ty1bp4 _1np61h6o _1yytzwfg _1eog1u1b _qjx39by0 _1cel10yn _5n7a9by0"
                ]),
                children: doubleFeatureItems.map((item, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7asA7.JswDoubleFeatureCard), {
                        title: item.title,
                        description: item.description,
                        image: item.image
                    }, index))
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_mkrzzwj5 _bfhkr3uz _4t3ir0r7 _1pby1mrw _1pfh1o8r"
                ])
            })
        ]
    });
};
$8f8dac8bd8ab28d3$export$fa980c3455a6cd08.displayName = 'JswDoubleFeatureSection';
const $8f8dac8bd8ab28d3$var$containerStyles = null;
const $8f8dac8bd8ab28d3$var$titleStyles = null;
const $8f8dac8bd8ab28d3$var$cardContainerStyles = null;
const $8f8dac8bd8ab28d3$var$blackShapeStyles = null;

});
parcelRegister("7asA7", function(module, exports) {
$parcel$export(module.exports, "JswDoubleFeatureCard", function () { return $31657ce82e95d787$export$881c15c7192d6044; });
/* double-feature-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");
const $31657ce82e95d787$export$881c15c7192d6044 = ({ title: title, description: description, image: image })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _1bsb1diq _zulp1gkc _11q71afi _16qs188r _1y8o1diq _zzrm1osq"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_mezj1osq _bna71osq"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                    image: {
                        src: image,
                        alt: ''
                    }
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                        className: (0, $2jatx.default)([
                            "_syaz1pfd _y3gn1h6o _ect41vau _1wyb1tcg _k48p1fw0 _vwz41ul9 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                        ]),
                        style: {
                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                            "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_syaz1pfd _y3gn1h6o _ect4z4z1 _1wybo7ao _k48p1nn1 _vwz41gkc _ca0qftgi _u5f353f4 _n3td8ved _19bv53f4 _1eogftgi _qjx310yn _1cel10yn _5n7a10yn"
                        ]),
                        style: {
                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                        },
                        children: description
                    })
                ]
            })
        ]
    });
};
const $31657ce82e95d787$var$cardStyle = null;
const $31657ce82e95d787$var$titleStyles = null;
const $31657ce82e95d787$var$descriptionStyles = null;
const $31657ce82e95d787$var$imageContainerStyle = null;

});


parcelRegister("1UnBI", function(module, exports) {
$parcel$export(module.exports, "LoggedOutHeroSection", function () { return $98430ad0795e6e5c$export$a8760ddc663c337c; });
/* logged-out-hero-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $6V1n4 = parcelRequire("6V1n4");

var $7chqp = parcelRequire("7chqp");

var $8e22h = parcelRequire("8e22h");

var $izdHQ = parcelRequire("izdHQ");

var $iE2db = parcelRequire("iE2db");

var $dmP4q = parcelRequire("dmP4q");
const $98430ad0795e6e5c$export$a8760ddc663c337c = ()=>{
    const intl = (0, $8e22h.default)();
    const headerContent = {
        mainHeadingFirstPart: intl.formatMessage({
            id: 'jira-product-tour.hero-header.first-header-text',
            defaultMessage: 'Great outcomes'
        }),
        mainHeadingSecondPart: intl.formatMessage({
            id: 'jira-product-tour.hero-header.second-header-text',
            defaultMessage: 'start with Jira'
        }),
        subHeading: intl.formatMessage({
            id: 'jira-product-tour.hero-header.sub-header-text',
            defaultMessage: 'The only project management tool you need to plan and track work across every team.'
        }),
        buttonText: intl.formatMessage({
            id: 'jira-product-tour.hero-header.button-text',
            defaultMessage: 'Get Jira free'
        })
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $izdHQ.FeatureExposed), {
        experimentKey: "jfind-jpto-organic-optimize-embedded-signup",
        group: "Test",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_bfhk1hxd _1bsb1osq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _p12f1qe4 _4cvr1h6o _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _zulpckbl _tl28idpf _axwi1tcg _1hwcidpf _sp8t1tcg _1gde1bp4 _1wm01tcg"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iE2db.LoggedOutHeader), {
                                ...headerContent
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_p12fkbql _1bsb1osq _1wafckbl"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dmP4q.LoggedOutJiraProductTourAccountCreation), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7chqp.HeroCards), {})
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6V1n4.LogoBanner), {})
        ]
    });
};
$98430ad0795e6e5c$export$a8760ddc663c337c.displayName = 'LoggedOutHeroSection';
const $98430ad0795e6e5c$var$heroStyles = null;
const $98430ad0795e6e5c$var$containerStyles = null;
const $98430ad0795e6e5c$var$formStyles = null;

});
parcelRegister("6V1n4", function(module, exports) {
$parcel$export(module.exports, "LogoBanner", function () { return $ff933ff67f9e4e4b$export$f856413bacaabd31; });
/* logo-banner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $hI0HU = parcelRequire("hI0HU");

var $abXwn = parcelRequire("abXwn");

var $1yAvB = parcelRequire("1yAvB");

var $38U9C = parcelRequire("38U9C");

var $76f4d = parcelRequire("76f4d");

var $bynL4 = parcelRequire("bynL4");

var $kbpa7 = parcelRequire("kbpa7");
const $ff933ff67f9e4e4b$var$svgArray = [
    (0, $bynL4.NasaLogo),
    (0, $76f4d.AirCanadaLogo),
    (0, $38U9C.VisaLogo),
    (0, $1yAvB.CanvaLogo),
    (0, $abXwn.DominosLogo),
    (0, $hI0HU.FordLogo)
];
const $ff933ff67f9e4e4b$export$f856413bacaabd31 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_bfhk1hxd _mkrztcy0 _1qv2ewaa"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
            className: (0, $2jatx.default)([
                "_qtt8glyw _ca0qys9h _u5f3idpf _n3tdys9h _19bvidpf _tzy415iw _p12f2w76 _19pkidpf _2hwx1wug _otyridpf _18u01wug _1e0c1txw _2lx2vrvc _4cvr1h6o _1bahitcz _1eog1ul9 _qjx3idpf _1cel1ul9 _5n7aidpf _liwc11p5 _13gz16hb _9et11h6o _17sl19q2 _4pgi1hwe _1fu1116b _eulesxk5 _tme71sp7 _1odz101s _r5d653f4 _b3uv1f06 _1avyys9h"
            ]),
            children: $ff933ff67f9e4e4b$var$svgArray.map((Component, idx)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                    id: `item-${idx}`,
                    className: (0, $2jatx.default)([
                        "_syaz1qc2 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _cjbs1ylp _12ra68cl"
                    ]),
                    style: {
                        "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800'))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)(Component, {})
                }, idx))
        })
    });
};
$ff933ff67f9e4e4b$export$f856413bacaabd31.displayName = 'LogoBanner';
const $ff933ff67f9e4e4b$var$logoBannerStyles = null;
const $ff933ff67f9e4e4b$var$logoContainerStyles = null;
const $ff933ff67f9e4e4b$var$logoStyles = null;

});
parcelRegister("hI0HU", function(module, exports) {
$parcel$export(module.exports, "FordLogo", function () { return $2ec6afa33ab5e2c3$export$22ac95c9dec2accf; });

var $7VQPk = parcelRequire("7VQPk");
const $2ec6afa33ab5e2c3$export$22ac95c9dec2accf = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "115",
        height: "41",
        viewBox: "0 0 115 41",
        fill: "currentColor",
        role: "img",
        "aria-label": "Ford",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M57.3414 0.674927C25.954 0.674927 0.511719 9.52522 0.511719 20.4487C0.511719 31.3721 25.954 40.2178 57.3414 40.2178C88.7289 40.2178 114.171 31.3721 114.171 20.4487C114.171 9.52522 88.7266 0.674927 57.3414 0.674927ZM57.3414 38.5218C27.058 38.5218 2.50943 30.4349 2.50943 20.4647C2.50943 10.4944 27.058 2.38007 57.3414 2.38007C87.6249 2.38007 112.171 10.4692 112.171 20.4487C112.171 30.4281 87.6249 38.5149 57.3414 38.5149V38.5218Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M44.9218 17.9264C46.4007 17.739 48.5789 17.531 49.9869 17.451C50.2978 17.4327 50.3618 17.4373 50.4875 17.5904C50.8651 18.0357 51.3234 18.4057 51.8384 18.6807C51.9825 18.7797 52.1491 18.841 52.3229 18.859C52.4138 18.8581 52.5033 18.8371 52.5851 18.7976C52.6668 18.7581 52.7389 18.701 52.7961 18.6304C52.8642 18.5664 52.9111 18.4829 52.9303 18.3913C52.9495 18.2998 52.9401 18.2045 52.9035 18.1184C52.8189 17.9722 51.8452 17.4327 51.8132 17.2156C51.7927 17.0762 51.9458 17.0464 51.9458 17.0464C52.3523 16.9276 52.731 16.7287 53.0596 16.4614C53.3881 16.1941 53.6599 15.8638 53.8589 15.4899C54.3047 14.635 54.3778 13.4967 53.5641 12.8659C52.8487 12.3059 51.7698 12.3973 50.9104 13.1676C50.5297 13.5183 50.2394 13.9559 50.0643 14.4431C49.8892 14.9302 49.8344 15.4524 49.9047 15.9653C49.9252 16.1299 49.9047 16.1939 49.6898 16.1939C48.3961 16.2967 47.1481 16.3333 45.7629 16.4064C45.6692 16.4064 45.6395 16.3516 45.6944 16.2853C47.2944 13.515 49.6738 11.5402 52.3229 9.59273C52.4967 9.46244 52.4418 9.21101 52.4349 9.00301C57.1984 10.0362 61.8064 11.963 66.7389 11.9242C68.7824 11.9059 70.7367 11.595 72.6064 10.5687C74.2498 9.67502 74.9172 8.84301 74.9675 7.98359C75.0064 7.38473 74.5927 7.00987 74.0029 7.13787C69.0087 8.28073 64.2498 8.28073 59.2829 7.67044C53.6464 6.98473 48.2384 5.5813 42.6315 5.5813C41.7881 5.5813 40.9424 5.6133 40.0875 5.68416C34.6681 6.1413 29.5115 9.19273 29.5001 13.8259C29.5001 16.1733 31.1641 18.0796 33.7538 17.995C36.7915 17.8899 39.2898 15.4556 40.5995 12.3859C41.0955 11.2179 40.1767 10.7356 39.7378 11.4053C38.9816 12.5797 37.9217 13.5275 36.6704 14.1482C35.2372 14.8476 33.7104 14.6579 33.2418 13.4967C32.5904 11.8556 33.9458 9.4053 37.0384 8.23959C41.5069 6.58473 46.1812 7.67959 50.6772 8.5253C50.7389 8.5253 50.9789 8.65787 50.7687 8.7653C49.7477 9.25956 48.7956 9.88504 47.9367 10.6259C46.8736 11.497 45.8899 12.4608 44.9972 13.5059C44.1058 14.5893 43.4727 15.563 42.6384 16.6304C42.6102 16.6728 42.5727 16.708 42.5287 16.7334C42.4847 16.7587 42.4354 16.7736 42.3847 16.7767C40.3367 17.131 38.3458 17.3596 36.5218 18.619C36.1469 18.8796 35.9847 19.339 36.2109 19.6956C36.2693 19.7689 36.3417 19.8298 36.4239 19.8748C36.506 19.9198 36.5963 19.948 36.6895 19.9578C36.7827 19.9676 36.8769 19.9587 36.9666 19.9318C37.0563 19.9048 37.1397 19.8603 37.2121 19.8007C38.2556 18.9932 39.5317 18.5436 40.8509 18.5184C40.9081 18.5184 40.9355 18.5344 40.9538 18.5687C40.9577 18.5849 40.9579 18.6017 40.9543 18.618C40.9507 18.6342 40.9435 18.6494 40.9332 18.6624C38.9287 21.4442 38.4189 22.0727 36.9195 23.7962C36.1743 24.6452 35.3806 25.4503 34.5424 26.2076C31.1138 29.387 27.4384 29.3322 26.1149 27.3505C25.7719 26.8382 25.5751 26.242 25.5457 25.6262C25.5163 25.0104 25.6554 24.3982 25.9481 23.8556C26.5858 22.5779 27.8704 21.6453 28.9424 21.099C29.3401 20.8956 29.4544 20.3859 29.0567 19.9219C28.8052 19.6224 28.1904 19.5676 27.7332 19.6522C26.3321 19.9104 24.6727 20.971 23.6966 22.2464C22.56 23.6964 22.0329 25.5321 22.2269 27.3642C22.5606 30.8865 25.4544 32.9162 28.7435 32.891C31.3629 32.8705 33.8269 32.0796 36.7938 29.067C39.5572 26.2579 42.0784 22.0659 44.4395 18.1733C44.5127 18.0453 44.5675 17.9699 44.9218 17.9264ZM51.8909 13.8602C52.0025 13.736 52.1556 13.6569 52.3214 13.6375C52.4872 13.6181 52.6543 13.6599 52.7915 13.755C53.0544 13.9836 52.9309 14.539 52.6635 14.9299C52.3735 15.3647 51.9359 15.6797 51.4315 15.8167H51.3972C51.3218 15.8167 51.2601 15.7642 51.2258 15.5882C51.1896 15.2679 51.2311 14.9436 51.3469 14.6428C51.4627 14.3419 51.6493 14.0735 51.8909 13.8602Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M92.5408 13.7385H89.5031C89.2745 13.7385 89.1625 13.7682 89.0574 13.9671C88.7054 14.6368 84.4516 21.0117 83.6608 22.2482C83.5305 22.4357 83.3659 22.4082 83.3454 22.1957C83.2676 21.4597 82.6322 20.6162 81.6311 20.2117C80.9069 19.9192 80.117 19.8283 79.3454 19.9488C77.9465 20.1362 76.7008 20.8631 75.6036 21.7065C73.9556 22.9637 72.5294 24.5911 70.6916 25.7934C69.6836 26.4585 68.3122 27.0254 67.3979 26.1751C66.5659 25.4025 66.6596 23.6882 67.9305 22.3602C68.0676 22.2231 68.2276 22.3397 68.2025 22.4631C68.1338 22.7513 68.1425 23.0525 68.2276 23.3362C68.3127 23.62 68.4712 23.8763 68.6871 24.0791C68.9628 24.3176 69.3042 24.4672 69.6665 24.508C70.0288 24.5488 70.3949 24.4789 70.7168 24.3077C71.1004 24.1091 71.4297 23.8197 71.6759 23.4648C71.9221 23.1098 72.0778 22.7 72.1294 22.2711C72.1744 21.9558 72.1541 21.6346 72.0697 21.3275C71.9854 21.0204 71.8387 20.7339 71.6389 20.4859C71.4391 20.2378 71.1904 20.0336 70.9083 19.8857C70.6262 19.7379 70.3167 19.6497 69.9991 19.6265C68.9385 19.5534 67.9237 19.9214 66.9362 20.7397C66.468 21.1167 66.0609 21.5639 65.7294 22.0654C65.6219 22.214 65.4619 22.23 65.4688 22.006C65.5168 20.2757 64.7991 19.2997 63.3682 19.2631C62.2551 19.238 61.0688 19.8391 60.1408 20.5797C59.1282 21.3934 58.2391 22.4722 57.2882 23.4894C57.1694 23.6151 57.0596 23.6082 57.0345 23.366C57.0048 22.2231 56.7145 21.1054 56.1842 20.3168C56.087 20.1724 55.9398 20.0692 55.771 20.027C55.6021 19.9848 55.4236 20.0066 55.2699 20.0882C54.891 20.269 54.5298 20.4848 54.1911 20.7328C54.0929 20.8138 54.0225 20.9234 53.9897 21.0464C53.9569 21.1693 53.9634 21.2994 54.0082 21.4185C54.5153 23.1725 54.4097 25.0469 53.7088 26.7328C53.0711 28.2437 51.8276 29.6014 50.3694 30.0654C49.4094 30.3671 48.4082 30.2185 47.7888 29.366C46.9408 28.1911 47.2836 26.1431 48.5476 24.4471C49.6676 22.95 51.2905 22.0014 52.8905 21.3865C52.9278 21.3788 52.9629 21.3627 52.9931 21.3394C53.0232 21.3161 53.0477 21.2863 53.0647 21.2522C53.0816 21.2181 53.0906 21.1805 53.0909 21.1424C53.0912 21.1043 53.0829 21.0666 53.0665 21.0322C52.9774 20.7648 52.8379 20.406 52.7831 20.2414C52.6322 19.8482 52.2208 19.7842 51.7134 19.8391C50.5628 19.9917 49.4524 20.3642 48.4425 20.9362C45.6996 22.3991 44.3282 25.2311 43.7385 26.7488C43.5351 27.3179 43.2453 27.8521 42.8791 28.3328C42.4494 28.8723 41.9076 29.366 40.9179 30.2345C40.8649 30.2853 40.8289 30.3512 40.815 30.4233C40.8011 30.4954 40.8099 30.57 40.8402 30.6368C40.9408 30.8425 41.4574 31.5694 41.5991 31.638C41.6734 31.6578 41.7516 31.6586 41.8263 31.6402C41.901 31.6218 41.9699 31.5849 42.0265 31.5328C42.7381 31.0436 43.3848 30.466 43.9511 29.814C44.0951 29.6448 44.2391 29.718 44.3145 29.9785C44.4953 30.6541 44.84 31.2745 45.3181 31.7849C45.7961 32.2953 46.3928 32.6798 47.0551 32.9043C49.5694 33.7523 52.1591 32.5294 54.1225 30.39C55.3682 29.0368 55.8208 28.166 56.2985 27.574C57.1122 26.5705 58.7122 24.326 60.6094 22.886C61.3065 22.3511 62.1339 21.9442 62.5476 22.214C62.8814 22.4425 62.9888 22.934 62.4539 23.9054C60.5134 27.4482 57.6539 31.6128 57.1351 32.6208C57.0368 32.7991 57.1351 32.934 57.3065 32.934C58.3236 32.934 59.3294 32.934 60.2505 32.934C60.312 32.9324 60.372 32.9144 60.4243 32.8819C60.4765 32.8493 60.5191 32.8034 60.5476 32.7488C62.0379 30.4174 63.4391 28.2002 64.9408 25.9054C65.0254 25.7705 65.1031 25.8757 65.1054 25.9351C65.1396 26.4654 65.2676 27.1945 65.5854 27.6722C65.8183 28.0636 66.1499 28.387 66.547 28.6101C66.9441 28.8331 67.3928 28.9479 67.8482 28.9431C68.5591 28.9431 68.9202 28.8425 69.6768 28.5545C70.2133 28.3555 70.7201 28.084 71.1831 27.7477C71.4116 27.59 71.4482 27.8528 71.4414 27.894C71.0962 29.7431 71.5236 31.9351 73.3637 32.8448C75.5625 33.9283 77.9808 32.406 79.3751 31.0277C79.5076 30.8951 79.6539 30.9088 79.6699 31.1945C79.7065 31.7943 79.9552 32.3614 80.3717 32.7945C81.5374 33.9625 83.8894 33.4985 86.2505 31.67C87.7659 30.502 89.3545 28.8471 90.7854 27.0985C90.8043 27.0796 90.8193 27.0572 90.8296 27.0325C90.8398 27.0078 90.8451 26.9813 90.8451 26.9545C90.8451 26.9278 90.8398 26.9013 90.8296 26.8766C90.8193 26.8519 90.8043 26.8294 90.7854 26.8105C90.5568 26.582 90.2528 26.3237 90.0357 26.1248C89.9887 26.089 89.9313 26.0697 89.8722 26.0697C89.8132 26.0697 89.7558 26.089 89.7088 26.1248C88.2414 27.5237 86.9179 29.1168 85.0094 30.4334C84.3625 30.8905 83.3362 31.2494 82.8745 30.6231C82.6939 30.3808 82.7145 30.0448 82.8928 29.606C83.4482 28.2162 92.2642 14.79 92.7214 13.9945C92.8036 13.8391 92.7214 13.7385 92.5408 13.7385ZM81.0665 25.238C81.0848 25.3431 81.2174 25.4414 81.3476 25.4871C81.3956 25.5031 81.4208 25.5397 81.3705 25.6448C81.031 26.3334 80.6333 26.9918 80.1819 27.6128C79.7627 28.23 79.2525 28.7802 78.6688 29.2448C77.9831 29.8117 77.0917 30.4174 76.2505 30.4174C75.9983 30.4206 75.7493 30.3609 75.5259 30.2437C75.0688 30.0151 74.8745 29.3728 74.8814 28.8585C74.9065 27.414 75.5488 25.9305 76.7351 24.4722C78.1819 22.6894 79.7819 21.766 80.8311 22.2711C81.9191 22.79 81.5739 24.0448 81.0871 25.0345C81.0538 25.097 81.0464 25.1701 81.0665 25.238Z"
            })
        ]
    });

});

parcelRegister("abXwn", function(module, exports) {
$parcel$export(module.exports, "DominosLogo", function () { return $3dcbc0b04b75e475$export$3a87515d6bae358a; });

var $7VQPk = parcelRequire("7VQPk");
const $3dcbc0b04b75e475$export$3a87515d6bae358a = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "149",
        height: "33",
        viewBox: "0 0 149 33",
        fill: "currentColor",
        role: "img",
        "aria-label": "Domino\u2019s",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M85.1443 21.4717C83.5509 17.7341 78.0566 18.8925 76.5524 21.2925V19.4237H71.7656V32.6781H76.7245V26.0093C76.7245 23.5197 77.2535 23.3405 78.5856 23.2509C79.9114 23.1613 80.4468 23.3405 80.4468 26.0093L80.536 32.6781H85.3228V25.8301C85.3228 24.5821 85.5905 23.4301 86.9162 23.4301C88.5097 23.3405 88.8666 23.5197 88.8666 25.4781V32.7741H93.9147V22.8925C94.004 18.1821 87.3624 18.0925 85.1443 21.4717Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M63.1736 18.4457C59.2729 18.4457 56.0859 21.6457 56.0859 25.5625C56.0859 29.4793 59.2729 32.6793 63.1736 32.6793C67.0744 32.6793 70.2614 29.4793 70.2614 25.5625C70.2614 21.6457 67.0744 18.4457 63.1736 18.4457ZM63.1736 28.0521C61.7587 28.0521 60.6942 26.8937 60.6942 25.5625C60.6942 24.1417 61.8479 23.0729 63.1736 23.0729C64.4994 23.0729 65.6531 24.2313 65.6531 25.5625C65.6594 26.9001 64.5058 28.0521 63.1736 28.0521Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M49.7117 15.1528C48.7365 14.7112 47.7613 14.3528 46.6969 14.2632C45.1927 14.084 43.6821 13.9944 42.1778 13.9944H36.6836V32.676H41.7317C43.4144 32.676 45.0971 32.5864 46.6905 32.4072C47.755 32.228 48.8194 31.9656 49.7882 31.5176C51.2924 30.7176 52.6246 29.5592 53.5998 28.1384C55.3717 25.2008 55.3717 21.4696 53.5998 18.532C52.6373 17.1112 51.3052 15.9528 49.7117 15.1528ZM49.0935 25.5592C48.7365 26.18 48.2075 26.8072 47.5 27.1592C47.1431 27.3384 46.7033 27.5176 46.2571 27.6008C45.5496 27.6904 44.9313 27.78 44.2175 27.6904H42.1778V18.8904H44.4788C45.0971 18.8904 45.7217 18.8904 46.34 18.98C46.7798 19.0696 47.2259 19.1592 47.5829 19.4216C48.2011 19.78 48.7365 20.3112 49.1763 21.0216C49.5333 21.732 49.7053 22.532 49.7053 23.2424C49.6225 24.0488 49.444 24.8488 49.0935 25.5592Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M101.002 19.1608H96.043V32.5944H101.002V19.1608Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M136.701 16.4923C136.88 15.6923 136.88 14.8027 136.523 14.0923C136.083 13.1131 135.108 12.4923 134.044 12.4923C132.801 12.4027 131.653 13.2923 131.386 14.4507C131.029 15.8715 131.825 17.2987 133.247 17.7403C133.604 17.8299 133.954 17.7403 133.687 18.1819C133.419 18.5403 133.068 18.8923 132.711 19.1611L133.24 19.9611C135.376 18.8027 136.44 17.6443 136.701 16.4923Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M125.541 18.4457C121.64 18.4457 118.453 21.6457 118.453 25.5625C118.453 29.4793 121.64 32.6793 125.541 32.6793C129.442 32.6793 132.629 29.4793 132.629 25.5625C132.629 21.6457 129.442 18.4457 125.541 18.4457ZM125.541 28.0521C124.126 28.0521 123.061 26.8937 123.061 25.5625C123.061 24.2313 124.215 23.0729 125.541 23.0729C126.867 23.0729 128.02 24.2313 128.02 25.5625C128.02 26.9001 126.956 28.0521 125.541 28.0521Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M142.286 23.6923C139.807 23.6923 139.985 22.0027 141.49 21.9131C143.083 21.8235 144.677 22.2715 145.919 23.2443L147.513 20.1339C143.172 17.5547 135.817 17.9131 135.645 22.6235C135.556 25.2923 137.595 26.6235 141.757 27.0715C144.772 27.4299 143.886 28.7611 142.197 28.9403C140.514 29.1195 138.921 28.3195 137.238 27.3403L135.109 30.5403C140.954 34.2779 147.774 32.5883 148.042 28.2299C148.31 25.6507 146.27 23.6027 142.286 23.6923Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M108.089 21.2934V19.4246H103.303V32.679H108.089V26.0102C108.089 23.7894 109.065 23.3414 110.129 23.2518C111.455 23.0726 112.43 23.3414 112.43 26.0102L112.519 32.679H117.306V22.983C117.217 18.183 109.951 18.183 108.089 21.2934Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M98.5225 12.4861C97.0183 12.4861 95.7754 13.7341 95.7754 15.2445C95.7754 16.7549 97.0183 18.0029 98.5225 18.0029C100.027 18.0029 101.27 16.7549 101.27 15.2445C101.27 13.7341 100.027 12.4861 98.5225 12.4861Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.8143 10.4361L22.5148 1.09853C22.075 0.656934 21.4504 0.656934 21.0106 1.09853L11.1758 10.8841L21.9858 21.7385L31.8206 11.9529C32.2604 11.5049 32.2604 10.8841 31.8143 10.4361ZM23.7577 12.9321C22.6933 14.0009 21.0106 14.0009 20.0354 12.9321C18.971 11.8633 18.971 10.1737 20.0354 9.19453C21.0998 8.12573 22.7825 8.12573 23.7577 9.19453C24.7329 10.1737 24.7329 11.8633 23.7577 12.9321Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M10.5567 11.5936L0.632581 21.4688C0.192786 21.9104 0.192786 22.5376 0.632581 22.9792L9.93202 32.3168C10.3718 32.7584 10.9964 32.7584 11.4362 32.3168L21.2711 22.5376L10.5567 11.5936ZM8.60626 24.2272C7.54183 25.2064 5.85913 25.2064 4.88393 24.2272C3.8195 23.1584 3.8195 21.4688 4.88393 20.4896C5.94836 19.5104 7.63106 19.5104 8.60626 20.4896C9.58145 21.4688 9.58145 23.1584 8.60626 24.2272ZM12.5899 24.2272C11.5255 23.248 11.5255 21.4688 12.5899 20.4896C13.6543 19.4208 15.337 19.4208 16.3122 20.4896C17.3767 21.5584 17.3767 23.248 16.3122 24.2272C15.2478 25.296 13.6543 25.296 12.5899 24.2272Z"
            })
        ]
    });

});

parcelRegister("1yAvB", function(module, exports) {
$parcel$export(module.exports, "CanvaLogo", function () { return $627549377313d3c5$export$41d9e6d43cf45e91; });

var $7VQPk = parcelRequire("7VQPk");
const $627549377313d3c5$export$41d9e6d43cf45e91 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "73",
        height: "73",
        viewBox: "0 0 73 73",
        fill: "currentColor",
        role: "img",
        "aria-label": "Canva",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M51.3643 35.0746C50.9233 35.0746 50.7793 35.6686 50.7793 36.1096C50.8126 36.9942 51.1568 37.8387 51.7513 38.4946C51.9811 37.9215 52.106 37.3118 52.1203 36.6946C52.1023 35.5966 51.6613 35.0746 51.3643 35.0746Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M36.4512 0.69458C29.3311 0.69458 22.3708 2.80594 16.4507 6.76167C10.5305 10.7174 5.91628 16.3398 3.19152 22.918C0.46677 29.4961 -0.24615 36.7345 1.14292 43.7178C2.53199 50.7011 5.96065 57.1157 10.9953 62.1504C16.03 67.1851 22.4446 70.6138 29.4279 72.0029C36.4113 73.3919 43.6497 72.679 50.2278 69.9542C56.8059 67.2295 62.4284 62.6153 66.3841 56.6951C70.3398 50.7749 72.4512 43.8147 72.4512 36.6946C72.4512 27.1468 68.6583 17.99 61.907 11.2387C55.1557 4.48743 45.999 0.69458 36.4512 0.69458ZM62.3892 46.4686C62.2848 46.4807 62.1794 46.4552 62.0922 46.3966C61.4858 46.201 60.9422 45.848 60.5169 45.3737C60.0915 44.8993 59.7997 44.3206 59.6712 43.6966C59.4147 44.0614 59.0735 44.3584 58.6769 44.5622C58.2803 44.766 57.8401 44.8705 57.3942 44.8666C56.6375 44.8137 55.9229 44.4992 55.3728 43.977C54.8226 43.4548 54.4714 42.7575 54.3792 42.0046C54.3079 41.31 54.3815 40.6083 54.5952 39.9436C54.0646 40.309 53.4392 40.5123 52.7952 40.5286H52.2822C51.2379 42.1236 49.8891 43.4968 48.3132 44.5696C47.9532 44.7729 47.5547 44.8986 47.1432 44.9386C47.0175 44.945 46.8921 44.9223 46.7766 44.8724C46.6611 44.8224 46.5586 44.7465 46.4772 44.6506C46.2312 44.3978 46.0396 44.0972 45.9143 43.7675C45.7889 43.4378 45.7324 43.086 45.7482 42.7336C44.5868 44.0553 42.9904 44.9174 41.2482 45.1636C41.0186 45.172 40.7896 45.1348 40.5745 45.054C40.3593 44.9733 40.1624 44.8507 39.9949 44.6934C39.8275 44.536 39.693 44.347 39.5992 44.1373C39.5053 43.9275 39.454 43.7013 39.4482 43.4716C39.4004 43.0775 39.4248 42.6779 39.5202 42.2926C39.8189 40.8972 40.2098 39.5232 40.6902 38.1796C40.6902 38.0356 40.6182 37.9636 40.5462 37.9636C39.8172 37.9636 37.3152 40.5286 36.9462 42.2206L36.6492 43.6156C36.5554 44.0328 36.3297 44.4087 36.0055 44.6876C35.6812 44.9664 35.2758 45.1333 34.8492 45.1636C34.7031 45.1712 34.5598 45.1221 34.4491 45.0265C34.3384 44.9309 34.2689 44.7962 34.2552 44.6506V44.2096L34.4082 43.4716C33.4455 44.2995 32.2918 44.8748 31.0512 45.1456C30.6669 45.1923 30.2794 45.0879 29.9705 44.8546C29.6616 44.6212 29.4553 44.277 29.3952 43.8946C29.145 44.2716 28.8072 44.5824 28.4106 44.8003C28.0141 45.0181 27.5706 45.1366 27.1182 45.1456C26.5535 45.121 26.0067 44.9396 25.5394 44.6216C25.072 44.3037 24.7024 43.8618 24.4722 43.3456C23.6937 44.2137 22.8075 44.9789 21.8352 45.6226C20.3011 46.7055 18.4907 47.3298 16.6152 47.4226C15.018 47.3779 13.4957 46.7355 12.3492 45.6226C11.105 44.3767 10.3293 42.7394 10.1532 40.9876C9.45119 35.7946 12.6462 28.9816 17.5512 26.0386C18.6183 25.3792 19.843 25.0187 21.0972 24.9946C22.1451 24.9667 23.1666 25.3257 23.9667 26.003C24.7669 26.6803 25.2896 27.6284 25.4352 28.6666C25.5805 29.5671 25.4134 30.4903 24.9615 31.2827C24.5096 32.0751 23.8002 32.6891 22.9512 33.0226C21.9252 33.5356 21.4122 33.5356 21.2592 33.2386C21.2132 33.1384 21.2033 33.0254 21.2311 32.9187C21.259 32.8121 21.323 32.7184 21.4122 32.6536C23.3202 31.1146 23.3202 29.7916 23.0952 27.9556C23.094 27.4674 22.9074 26.998 22.5733 26.6421C22.2391 26.2862 21.7823 26.0705 21.2952 26.0386C17.4792 26.0386 12.1872 34.3456 12.9252 40.3666C13.2132 42.7156 14.7252 45.4336 17.6232 45.4336C18.6458 45.4096 19.6506 45.1607 20.5662 44.7046C21.9121 44.1221 23.0998 43.2274 24.0312 42.0946C23.8152 39.3046 26.2362 35.7946 29.7642 35.7946C31.3122 35.7946 32.5542 36.3796 32.7072 37.5946C32.7491 37.8246 32.7377 38.0613 32.674 38.2862C32.6102 38.5112 32.4957 38.7186 32.3392 38.8924C32.1828 39.0662 31.9886 39.2019 31.7715 39.2889C31.5545 39.376 31.3204 39.4121 31.0872 39.3946C30.6462 39.3946 29.9892 39.2506 29.9082 38.8816C29.8272 38.5126 30.8712 38.6656 30.7182 37.7026C30.6462 37.1176 29.9892 36.9016 29.3952 36.9016C27.1902 36.9016 25.9482 39.9886 26.1642 41.8966C26.2362 42.7966 26.7492 43.6966 27.4872 43.6966C28.2252 43.6966 29.1072 42.7426 29.3952 41.4196C29.4903 41.003 29.7164 40.6279 30.0403 40.3492C30.3643 40.0706 30.7691 39.9032 31.1952 39.8716C31.5642 39.8716 31.7892 40.0246 31.7892 40.3846V40.8256C31.7082 41.1946 31.4202 42.6256 31.4202 42.8146C31.4177 42.8921 31.4311 42.9693 31.4596 43.0414C31.4881 43.1135 31.5311 43.179 31.586 43.2338C31.6408 43.2886 31.7063 43.3316 31.7784 43.3601C31.8505 43.3887 31.9277 43.4021 32.0052 43.3996C33.0226 43.0491 33.9462 42.4703 34.7052 41.7076C35.0742 39.9076 35.5152 37.5946 35.5152 37.4506C35.5289 37.2199 35.5905 36.9945 35.696 36.7889C35.8016 36.5833 35.9488 36.402 36.1282 36.2563C36.3077 36.1107 36.5155 36.0041 36.7385 35.9432C36.9614 35.8823 37.1946 35.8684 37.4232 35.9026C37.5698 35.8952 37.7133 35.9458 37.8228 36.0435C37.9323 36.1412 37.9989 36.2781 38.0082 36.4246V36.8566L37.6482 38.8456C38.9712 37.0456 41.0232 35.7586 42.2742 35.7586C42.5153 35.7419 42.754 35.8156 42.9437 35.9654C43.1334 36.1151 43.2605 36.3302 43.3002 36.5686C43.3143 37.0429 43.2411 37.5158 43.0842 37.9636C42.5581 39.4664 42.1459 41.0068 41.8512 42.5716C41.819 42.6702 41.8121 42.7752 41.831 42.8772C41.8498 42.9792 41.894 43.0748 41.9593 43.1554C42.0246 43.2359 42.1091 43.2988 42.205 43.3383C42.3008 43.3778 42.4051 43.3927 42.5082 43.3816C43.183 43.2388 43.8229 42.9641 44.3913 42.5734C44.9596 42.1826 45.4452 41.6835 45.8202 41.1046V40.3666C45.764 39.3003 45.8888 38.2322 46.1892 37.2076C46.3356 36.8008 46.591 36.4421 46.9275 36.1707C47.264 35.8992 47.6686 35.7255 48.0972 35.6686C48.1761 35.66 48.2559 35.6693 48.3308 35.6957C48.4056 35.7221 48.4736 35.7649 48.5297 35.821C48.5859 35.8772 48.6287 35.9451 48.6551 36.02C48.6815 36.0949 48.6907 36.1747 48.6822 36.2536C48.6934 36.4042 48.6688 36.5554 48.6102 36.6946C48.1656 37.948 47.9166 39.2624 47.8722 40.5916C47.8865 41.3998 47.9799 42.2046 48.1512 42.9946C48.1469 43.0243 48.1495 43.0547 48.1587 43.0833C48.1679 43.1119 48.1835 43.138 48.2044 43.1597C48.2252 43.1814 48.2507 43.1981 48.2789 43.2084C48.3071 43.2188 48.3373 43.2226 48.3672 43.2196C49.4848 42.374 50.4059 41.2962 51.0672 40.0606C50.5825 39.7281 50.1924 39.2755 49.9352 38.747C49.6781 38.2184 49.5626 37.6322 49.6002 37.0456C49.6002 34.8406 50.9232 33.6616 52.2462 33.6616C52.522 33.6642 52.794 33.7254 53.0443 33.8413C53.2946 33.9571 53.5174 34.1249 53.6979 34.3335C53.8783 34.542 54.0123 34.7866 54.091 35.0509C54.1697 35.3152 54.1912 35.5933 54.1542 35.8666C54.09 36.9274 53.782 37.9591 53.2542 38.8816H53.5512C53.8931 38.8929 54.2332 38.8258 54.5452 38.6854C54.8572 38.545 55.1329 38.335 55.3512 38.0716C55.4796 37.928 55.6282 37.8037 55.7922 37.7026C56.3143 37.051 56.9738 36.5227 57.7237 36.1556C58.4736 35.7884 59.2953 35.5914 60.1302 35.5786C61.6692 35.5786 62.9202 36.1636 63.0642 37.3786C63.105 37.6131 63.0938 37.8537 63.0316 38.0835C62.9693 38.3133 62.8575 38.5266 62.7039 38.7085C62.5504 38.8904 62.3588 39.0364 62.1427 39.1363C61.9266 39.2362 61.6912 39.2875 61.4532 39.2866C61.0122 39.2866 60.2742 39.1426 60.2742 38.7736C60.2742 38.4046 61.2282 38.5486 61.1742 37.5946C61.1022 37.0096 60.4362 36.6946 59.8512 36.6946C57.7902 36.6946 56.3952 39.3946 56.6202 41.6896C56.6922 42.5896 57.1332 43.4896 57.9432 43.4896C58.6002 43.4896 59.5542 42.5356 59.9232 41.2126C60.0332 40.8046 60.2639 40.4393 60.5851 40.1647C60.9063 39.89 61.303 39.7189 61.7232 39.6736C61.7963 39.6632 61.8709 39.6688 61.9417 39.6899C62.0125 39.7109 62.0779 39.7471 62.1334 39.7958C62.189 39.8445 62.2334 39.9046 62.2635 39.9721C62.2937 40.0395 62.3089 40.1127 62.3082 40.1866C62.2297 40.8778 62.1064 41.5633 61.9392 42.2386C61.8296 42.747 61.7812 43.2667 61.7952 43.7866C61.8989 44.4661 62.2138 45.0959 62.6952 45.5866C62.8071 45.6829 62.8859 45.812 62.9202 45.9556C62.9365 46.0279 62.934 46.1033 62.9127 46.1744C62.8915 46.2455 62.8523 46.3099 62.799 46.3614C62.7456 46.413 62.6799 46.4499 62.6081 46.4687C62.5363 46.4874 62.4609 46.4874 62.3892 46.4686Z"
            })
        ]
    });

});

parcelRegister("38U9C", function(module, exports) {
$parcel$export(module.exports, "VisaLogo", function () { return $864117658491d5fa$export$c17820a482ea0e7b; });

var $7VQPk = parcelRequire("7VQPk");
const $864117658491d5fa$export$c17820a482ea0e7b = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: "61",
        height: "19",
        viewBox: "0 0 61 19",
        fill: "currentColor",
        role: "img",
        "aria-label": "Visa",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M44.4329 0.753178C43.0385 0.245085 41.5646 -0.00987869 40.0805 0.000292741C35.2812 0.000292741 31.8917 2.41793 31.8677 5.88841C31.8378 8.43803 34.2764 9.87481 36.1211 10.7267C38.0138 11.6026 38.6467 12.1545 38.6407 12.9374C38.6287 14.1282 37.129 14.6681 35.7342 14.6681C33.8175 14.6681 32.7706 14.4011 31.1599 13.7322L30.5629 13.4533L29.882 17.4487C31.0489 17.9346 33.1516 18.3515 35.3232 18.3875C40.4255 18.3875 43.761 15.9849 43.8 12.2924C43.8419 10.2558 42.5221 8.71698 39.7446 7.44517C38.0558 6.6203 37.009 6.06838 37.009 5.23151C37.009 4.49062 37.9058 3.69874 39.7806 3.69874C41.0282 3.66855 42.2682 3.90264 43.419 4.38563L43.8689 4.5866L44.5498 0.726183L44.4329 0.753178ZM56.887 0.324244H53.1376C51.9707 0.324244 51.0919 0.645195 50.5819 1.80302L43.371 18.1386H48.4733L49.4931 15.46L55.7202 15.466C55.8672 16.0929 56.3171 18.1386 56.3171 18.1386H60.8164L56.887 0.324244ZM24.9658 0.174265H29.8281L26.7865 17.9976H21.9302L24.9658 0.168267V0.174265ZM12.6226 9.99779L13.1266 12.4724L17.8778 0.324244H23.0281L15.3762 18.1146H10.238L6.03862 3.05083C5.97061 2.80245 5.81088 2.58912 5.59169 2.45392C4.07812 1.67205 2.47439 1.07871 0.816406 0.687187L0.882396 0.312243H8.70822C9.77006 0.354237 10.6249 0.687188 10.9099 1.82102L12.6196 10.0068L12.6226 9.99779ZM50.8879 11.8155L52.8256 6.83027C52.8016 6.88426 53.2245 5.80142 53.4705 5.13252L53.8035 6.67129L54.9283 11.8125H50.8849L50.8879 11.8155Z"
        })
    });

});

parcelRegister("76f4d", function(module, exports) {
$parcel$export(module.exports, "AirCanadaLogo", function () { return $c116e0278aa92ff1$export$ea8385ffd753ff4e; });

var $7VQPk = parcelRequire("7VQPk");
const $c116e0278aa92ff1$export$ea8385ffd753ff4e = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "185",
        height: "24",
        viewBox: "0 0 185 24",
        fill: "currentColor",
        role: "img",
        "aria-label": "Air Canada",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M12.8603 17.077C12.8603 16.2693 13.2065 16.1539 14.0142 16.6154C15.3988 17.4231 16.7834 18.1154 16.7834 18.1154C16.7834 17.6539 17.2449 17.3077 18.0526 17.5385C18.8603 17.7693 19.668 17.8847 19.668 17.8847C19.668 17.8847 19.2065 16.8462 18.9757 16.3847C18.6295 15.577 18.9757 15.1154 19.3218 15C19.3218 15 18.8603 14.6539 18.5141 14.4231C17.8218 13.9616 17.9372 13.3847 18.6295 13.1539C19.5526 12.6924 20.8218 12.2308 20.8218 12.2308C20.4757 12.0001 20.0142 11.4231 20.4757 10.6154C20.9372 9.92312 21.7449 8.88466 21.7449 8.88466H19.5526C18.7449 8.88466 18.5141 8.19234 18.5141 7.73081C18.5141 7.73081 17.2449 8.6539 16.3218 9.23083C15.5142 9.80775 14.8218 9.23083 14.9372 8.30774C15.168 6.92313 15.2834 5.30775 15.2834 5.30775C14.8219 5.76928 14.0141 5.65391 13.5526 4.96159C12.9757 3.80774 12.3988 2.42312 12.3988 2.42312C12.3988 2.42312 11.8218 3.80774 11.2449 4.96159C10.8987 5.65391 10.0911 5.76928 9.62953 5.42312C9.62953 5.42312 9.74493 7.03849 9.97569 8.42311C10.0911 9.2308 9.39877 9.80772 8.59108 9.2308C7.66799 8.65387 6.28338 7.73079 6.28338 7.73079C6.28338 8.19232 6.05261 8.76924 5.24492 8.88464H3.05262C3.05262 8.88464 3.86031 9.92309 4.32184 10.6154C4.78337 11.3077 4.32184 12 3.97568 12.2308C3.97568 12.2308 5.12953 12.8077 6.16798 13.1539C6.8603 13.5 7.09107 13.9616 6.28338 14.4231C6.05261 14.6539 5.47569 15 5.47569 15C5.93722 15.1154 6.28338 15.5769 5.93722 16.3846C5.70645 16.8462 5.2449 17.8846 5.2449 17.8846C5.2449 17.8846 6.05259 17.6539 6.86028 17.5385C7.66797 17.3077 8.01413 17.7692 8.1295 18.1154C8.1295 18.1154 9.51411 17.3077 10.8987 16.6154C11.591 16.1539 12.0526 16.3846 12.0526 17.0769V19.0385C12.0526 20.1923 11.8218 21.3462 11.4756 22.0385C6.28335 21.4615 1.89872 17.3077 1.89872 11.7692C1.89872 6.11538 6.62948 1.50001 12.5141 1.50001C18.3987 1.50001 23.1295 6.11541 23.1295 11.7692C23.1295 17.0769 18.9756 21.4615 13.668 22.0385V23.4231C19.8987 22.8461 24.7449 17.8846 24.7449 11.7692C24.7449 5.1923 19.2064 0 12.3987 0C5.70643 0 0.167969 5.1923 0.167969 11.6538C0.167969 17.3077 4.43721 22.0385 10.0911 23.0769C11.0141 23.3077 11.5911 23.4231 12.168 24C12.7449 22.8461 12.8603 20.5384 12.8603 19.2692V17.077Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M62.3613 17.8843V5.42273H68.4767C71.7075 5.42273 73.2075 6.80734 73.3229 8.53812C73.3229 9.34581 73.2075 10.1535 72.6306 10.7304C72.0537 11.3073 71.8229 11.5381 70.7844 12.115L75.3998 17.9997H72.0537L67.8998 12.692H65.1306V17.8843L62.3613 17.8843ZM65.1306 11.0766H66.3998C69.7459 11.0766 70.4383 10.4997 70.4383 8.88428C70.4383 7.2689 68.9382 7.03814 66.7459 7.03814H65.1306V11.0766Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M35.0156 17.8843L40.4387 5.42273H43.7849L49.208 17.8843H45.8618L44.3618 14.5381H38.5926L37.0926 17.8843H35.0156ZM39.2849 12.9228H43.5541L41.3618 7.96122L39.2849 12.9228Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M55.9002 5.42273H53.0156V17.8843H55.9002V5.42273Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M96.1674 17.4227C94.7827 17.9997 93.052 18.2304 90.9751 18.2304C88.552 18.2304 86.5904 17.6535 85.2058 16.4996C83.8213 15.3458 83.1289 13.7304 83.1289 11.6535C83.1289 9.57654 83.8212 7.84579 85.2058 6.80731C86.5905 5.65346 88.552 5.07654 91.2058 5.07654C92.8212 5.07654 94.4366 5.19193 96.1674 5.53807V7.615C94.3212 7.03808 92.5904 6.80731 91.3212 6.80731C89.7058 6.80731 88.552 7.26884 87.6289 8.07653C86.8212 8.88422 86.3597 10.1535 86.3597 11.6535C86.3597 13.1534 86.8212 14.3073 87.7443 15.2304C88.6674 16.0381 89.9366 16.4996 91.552 16.4996C93.052 16.4996 94.6674 16.1534 96.1674 15.5765L96.1674 17.4227Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M99.7461 17.8843L105.169 5.42273H108.515L113.938 17.8843H110.592L109.092 14.5381H103.323L101.823 17.8843H99.7461ZM104.131 12.9228H108.4L106.323 7.96122L104.131 12.9228Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M135.861 17.8843L141.284 5.42273H144.631L150.054 17.8843H146.708L145.207 14.5381H139.438L137.938 17.8843H135.861ZM140.131 12.9228H144.4L142.207 7.96122L140.131 12.9228Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M176.477 7.96119L178.669 12.9227H174.4L176.477 7.96119ZM175.554 5.42273L170.131 17.8843H172.208L173.708 14.5381H179.477L180.977 17.8843H184.323L178.9 5.42273H175.554Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M118.092 17.8843V5.42273H121.438L129.284 14.3074V5.42273H131.707V17.8843H128.592L120.515 8.53812V17.8843H118.092Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M154.092 17.8843V5.42273H160.092C162.284 5.42273 163.9 5.99965 165.053 6.92274C166.207 7.96119 166.784 9.46121 166.784 11.3074C166.784 13.3843 166.207 14.9997 164.938 16.0381C163.669 17.192 162.053 17.7689 159.861 17.7689H154.092L154.092 17.8843ZM156.976 16.1535H159.169C160.669 16.1535 161.823 15.8074 162.63 14.9997C163.438 14.192 163.784 13.1535 163.784 11.5381C163.784 10.3843 163.438 9.34581 162.861 8.53812C162.4 7.96119 161.938 7.61503 161.361 7.38427C160.784 7.1535 159.976 7.03811 158.823 7.03811H157.092V16.1535H156.976Z"
            })
        ]
    });

});

parcelRegister("bynL4", function(module, exports) {
$parcel$export(module.exports, "NasaLogo", function () { return $b07d7862f0c2a57d$export$e44efe2f415651b3; });

var $7VQPk = parcelRequire("7VQPk");
const $b07d7862f0c2a57d$export$e44efe2f415651b3 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "88",
        height: "72",
        viewBox: "0 0 88 72",
        fill: "currentColor",
        role: "img",
        "aria-label": "NASA",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M76.4359 36C76.4359 55.7457 60.1693 71.9967 40.4025 71.9967C20.6364 71.9967 4.36914 55.7447 4.36914 36C4.36914 16.2532 20.256 0.0032959 40.4025 0.0032959C59.787 0.0032959 76.4359 16.2541 76.4359 36Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M48.5289 54.9456C63.9235 61.2787 61.2524 45.2754 53.0462 33.0216C48.3951 26.0795 42.3294 20.2956 38.5036 17.5045C25.8183 8.24615 17.9873 13.8614 26.9449 32.1201C29.8412 38.0235 33.5609 42.0079 36.4663 45.7634C38.6851 48.6306 43.0069 50.0662 41.4845 51.426C39.7687 52.9603 35.6147 46.1937 35.6147 46.1937C32.5467 42.4938 29.6224 38.5457 26.6085 33.1273C19.723 20.7524 20.7158 8.12178 33.1799 13.6237C43.7574 18.2953 53.8606 31.3977 57.9232 40.7025C59.7991 44.9995 64.9144 61.9986 48.6221 55.1256",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0.658203 46.6707C7.43066 42.1604 13.8517 39.2483 24.7788 35.6388C40.1336 30.5663 51.6898 27.1567 65.87 20.0294C72.2171 16.8399 83.23 9.68665 87.168 3.46851C85.9891 5.87521 82.3362 10.5597 80.6837 12.6312C61.4447 36.7206 20.464 35.3546 0.928637 46.9194"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M10.4824 29.0644C16.6807 29.113 16.0726 29.0519 16.145 29.1246C16.2532 29.1246 21.0941 37.461 21.0941 37.5334C21.0941 37.5686 21.0581 34.5706 21.0581 30.8208C21.0581 30.3878 19.8666 29.1249 19.9021 29.1249C21.6714 29.1249 23.9836 29.161 23.9836 29.161C23.1173 30.1715 22.9441 30.0881 22.9367 30.713C22.9123 32.7206 22.8897 36.4321 22.9367 40.6002C22.9435 41.2251 23.4064 41.4665 24.1652 42.5491H18.4931C16.6508 39.4818 13.2748 33.7275 13.2916 33.7443C13.3176 33.7706 13.2189 37.3537 13.327 40.2399C13.3634 41.1936 13.797 41.5028 14.5921 42.3694C14.5921 42.3694 15.5067 42.345 10.1484 42.4052C11.7741 41.5389 11.5581 40.4565 11.5574 40.4205C11.4991 36.4321 11.5452 33.0222 11.5452 30.8208C11.5452 30.46 11.5208 30.4957 10.4015 29.1246M29.8626 35.2239C30.383 33.417 30.8276 31.8024 31.0388 30.749C31.0745 30.5684 30.6415 29.9191 29.9552 29.2694L29.9066 29.1686C33.2163 29.1793 36.6739 29.1979 36.6739 29.1979C37.5771 31.3987 39.6358 37.5695 41.1893 41.3592C41.6 42.36 42.3093 42.5497 42.3093 42.5497C39.4916 42.514 34.2626 42.5384 34.2904 42.514C35.6988 41.2501 35.5182 41.2501 34.904 39.4112H30.4973C29.594 41.5037 30.7787 42.4859 30.9303 42.4782C29.9274 42.5302 26.5236 42.4782 26.5236 42.4782C28.3659 41.1783 28.2571 40.7817 28.2571 40.7817C28.7631 38.9812 29.3495 37.0087 29.8629 35.2236L31.671 35.2239L30.8942 37.7137H34.3992L32.4481 32.7334L31.6713 35.2233L29.8632 35.223M60.1359 35.4042C60.6554 33.5979 61.1003 31.9826 61.3115 30.9293C61.3469 30.749 60.9133 30.0997 60.2273 29.4494L60.1787 29.3492C63.4893 29.3599 66.9475 29.3782 66.9475 29.3782C67.8492 31.5796 69.9085 37.7498 71.4614 41.5395C71.8718 42.5415 72.5804 42.73 72.5804 42.73C69.7646 42.6943 64.5353 42.7187 64.5625 42.6943C65.9712 41.4313 65.7912 41.4313 65.177 39.5915H60.7694C59.8661 41.6843 61.0502 42.6662 61.2017 42.6591C60.1998 42.7105 56.7951 42.6591 56.7951 42.6591C58.6374 41.3598 58.5295 40.9626 58.5295 40.9626C59.0355 39.1615 59.6216 37.1899 60.1359 35.4042H61.9437C61.5544 36.65 61.1675 37.8949 61.1675 37.8949H64.6706L62.7195 32.914C62.7195 32.914 62.3324 34.1586 61.9437 35.4035L60.1359 35.4042ZM54.4372 32.4462C54.3654 29.8824 54.4372 29.0531 54.4372 29.0531C53.317 29.9558 53.8826 29.8406 51.0784 29.3779C42.9977 28.0447 42.382 35.5884 46.7795 37.2804C50.4709 38.7013 51.7784 38.98 51.2223 40.3114C51.0417 40.7459 47.6825 42.3331 44.2148 39.1209L44.2854 43.596C44.7193 43.1496 45.912 42.3331 45.912 42.3331C45.9471 42.3331 49.6706 43.9731 53.0276 42.261C58.194 39.6272 55.6155 35.3635 50.102 33.6725C45.5138 32.265 49.849 28.9807 54.4 32.4816M40.9091 3.27236C40.9089 3.35014 40.8779 3.42468 40.823 3.47974C40.768 3.5348 40.6936 3.56592 40.6158 3.56632C40.538 3.56584 40.4636 3.53469 40.4087 3.47965C40.3537 3.42461 40.3227 3.35011 40.3224 3.27236C40.3224 3.11284 40.4554 2.97961 40.6158 2.97961C40.6934 2.97986 40.7678 3.01076 40.8227 3.06559C40.8777 3.12042 40.9087 3.19473 40.9091 3.27236ZM42.9443 7.71602C42.9443 7.91404 42.7799 8.07752 42.5831 8.07752C42.4873 8.07712 42.3955 8.03891 42.3278 7.97122C42.26 7.90352 42.2218 7.8118 42.2213 7.71602C42.2213 7.51862 42.3844 7.35575 42.5831 7.35575C42.7802 7.35575 42.9443 7.51832 42.9443 7.71602ZM48.224 14.9783C48.224 15.1757 48.062 15.3392 47.8625 15.3392C47.7669 15.3386 47.6755 15.3003 47.6079 15.2328C47.5403 15.1653 47.502 15.0739 47.5013 14.9783C47.5013 14.7803 47.6526 14.6165 47.8515 14.6165C48.0507 14.6171 48.224 14.7803 48.224 14.9783ZM39.7357 10.2196C39.7354 10.2973 39.7044 10.3717 39.6494 10.4266C39.5945 10.4815 39.52 10.5124 39.4424 10.5126C39.3646 10.5124 39.2901 10.4815 39.2351 10.4266C39.18 10.3717 39.1489 10.2973 39.1484 10.2196C39.1484 10.0592 39.2813 9.92625 39.4424 9.92625C39.5201 9.92649 39.5946 9.95747 39.6495 10.0124C39.7045 10.0674 39.7355 10.1419 39.7357 10.2196ZM42.8984 11.889C42.8979 11.9665 42.8668 12.0407 42.812 12.0954C42.7571 12.1502 42.6829 12.1812 42.6054 12.1817C42.5278 12.1813 42.4535 12.1504 42.3985 12.0956C42.3435 12.0408 42.3124 11.9666 42.3117 11.889C42.3117 11.7285 42.4446 11.5959 42.6054 11.5959C42.7658 11.5959 42.8984 11.7285 42.8984 11.889ZM38.7884 7.21947C38.7884 7.41748 38.6253 7.58096 38.4273 7.58096C38.2292 7.58096 38.0661 7.4184 38.0661 7.21947C38.0661 7.02206 38.2292 6.85828 38.4273 6.85828C38.6253 6.85828 38.7884 7.02145 38.7884 7.21947ZM34.0031 10.1295C34.0031 10.2905 33.8708 10.4228 33.7095 10.4228C33.6318 10.4224 33.5574 10.3914 33.5025 10.3364C33.4476 10.2815 33.4165 10.2071 33.4161 10.1295C33.4161 9.96903 33.5487 9.8361 33.7095 9.8361C33.7872 9.83634 33.8617 9.86732 33.9168 9.92227C33.9718 9.97723 34.0028 10.0517 34.0031 10.1295ZM34.8587 10.7152C34.8584 10.7931 34.8274 10.8677 34.7723 10.9228C34.7172 10.9778 34.6427 11.0089 34.5648 11.0092C34.4869 11.0088 34.4124 10.9777 34.3574 10.9227C34.3023 10.8676 34.2712 10.7931 34.2708 10.7152C34.2743 10.6396 34.3068 10.5682 34.3615 10.5159C34.4163 10.4636 34.4891 10.4344 34.5648 10.4344C34.6405 10.4344 34.7133 10.4636 34.7681 10.5159C34.8228 10.5682 34.8553 10.6396 34.8587 10.7152ZM35.7174 11.3019C35.7172 11.3797 35.6862 11.4543 35.6313 11.5093C35.5763 11.5644 35.5018 11.5955 35.4241 11.5959C35.3463 11.5955 35.2717 11.5644 35.2168 11.5093C35.1618 11.4543 35.1307 11.3798 35.1304 11.3019C35.1304 11.1421 35.2633 11.0095 35.4241 11.0095C35.5851 11.0095 35.7174 11.1418 35.7174 11.3019ZM34.4096 12.4301C34.4088 12.5078 34.3775 12.582 34.3225 12.6369C34.2676 12.6918 34.1933 12.7228 34.1156 12.7235C34.0379 12.7231 33.9634 12.6921 33.9084 12.6372C33.8534 12.5822 33.8222 12.5079 33.8216 12.4301C33.8216 12.2697 33.9542 12.1371 34.1156 12.1371C34.276 12.1371 34.4096 12.2697 34.4096 12.4301ZM27.5903 17.2115C27.5899 17.2892 27.5587 17.3635 27.5036 17.4184C27.4486 17.4732 27.3741 17.504 27.2964 17.5042C27.1353 17.5042 27.0027 17.3722 27.0027 17.2115C27.0027 17.0507 27.1357 16.9178 27.2964 16.9178C27.4571 16.9178 27.5903 17.0504 27.5903 17.2115ZM28.8542 18.7457C28.8536 18.8234 28.8224 18.8976 28.7674 18.9525C28.7125 19.0073 28.6382 19.0383 28.5605 19.0388C28.4829 19.0383 28.4085 19.0073 28.3535 18.9525C28.2985 18.8977 28.2673 18.8234 28.2666 18.7457C28.2666 18.5844 28.3995 18.4524 28.5605 18.4524C28.7216 18.4524 28.8542 18.5844 28.8542 18.7457ZM27.8495 43.5111C27.849 43.5887 27.8179 43.6631 27.7629 43.718C27.7079 43.7728 27.6335 43.8038 27.5558 43.8041C27.3948 43.8041 27.2625 43.6715 27.2625 43.5111C27.2625 43.3506 27.3948 43.2174 27.5558 43.2174C27.7172 43.2174 27.8495 43.3506 27.8495 43.5111ZM28.0301 50.3434C28.0301 50.5414 27.8669 50.7046 27.6689 50.7046C27.4709 50.7046 27.3077 50.5423 27.3077 50.3434C27.3077 50.146 27.4709 49.9828 27.6689 49.9828C27.7644 49.9833 27.8559 50.0214 27.9235 50.0889C27.9911 50.1564 28.0294 50.2479 28.0301 50.3434ZM24.1459 53.8429C24.1453 53.9204 24.1143 53.9946 24.0594 54.0493C24.0046 54.1041 23.9304 54.1351 23.8529 54.1356C23.7753 54.1352 23.7009 54.1043 23.646 54.0495C23.591 53.9947 23.5598 53.9205 23.5592 53.8429C23.5592 53.6812 23.6921 53.5492 23.8529 53.5492C24.0133 53.5492 24.1459 53.6809 24.1459 53.8429ZM19.4957 55.2601C19.495 55.3558 19.4567 55.4474 19.389 55.515C19.3212 55.5826 19.2296 55.6208 19.1339 55.6213C19.0382 55.621 18.9465 55.5828 18.8788 55.5152C18.8112 55.4475 18.773 55.3558 18.7727 55.2601C18.7727 55.0624 18.9359 54.8989 19.1339 54.8989C19.2295 54.8995 19.3212 54.9377 19.3889 55.0053C19.4566 55.0729 19.4949 55.1644 19.4957 55.2601ZM18.5472 52.1038C18.5472 52.3009 18.384 52.4641 18.1866 52.4641C18.0911 52.4636 17.9996 52.4255 17.932 52.3581C17.8644 52.2907 17.8261 52.1993 17.8254 52.1038C17.8258 52.0081 17.8639 51.9163 17.9316 51.8485C17.9992 51.7808 18.0908 51.7424 18.1866 51.7417C18.384 51.7426 18.5472 51.9055 18.5472 52.1038ZM18.006 54.1115C18.006 54.2725 17.8731 54.4045 17.7123 54.4045C17.5516 54.4045 17.4184 54.2725 17.4184 54.1115C17.4184 53.9516 17.5516 53.8181 17.7123 53.8181C17.8731 53.8181 18.006 53.9507 18.006 54.1115ZM14.5282 52.4433C14.5278 52.5208 14.4968 52.5951 14.442 52.6499C14.3872 52.7047 14.313 52.7358 14.2355 52.7364C14.1578 52.736 14.0833 52.7051 14.0283 52.6502C13.9733 52.5954 13.9421 52.521 13.9415 52.4433C13.9415 52.2835 14.0742 52.1503 14.2355 52.1503C14.3956 52.1503 14.5282 52.2826 14.5282 52.4433ZM26.6748 58.0809C26.6748 58.2419 26.5535 58.3745 26.3931 58.3745C26.2321 58.3745 26.0878 58.2419 26.0878 58.0809C26.0878 57.9204 26.2208 57.7875 26.3812 57.7875C26.5428 57.7875 26.6748 57.9201 26.6748 58.0809ZM30.3332 55.3979C30.3332 55.5959 30.1816 55.7597 29.983 55.7597C29.785 55.7597 29.6108 55.5969 29.6108 55.3979C29.6108 55.2005 29.774 55.0373 29.972 55.0373C30.0675 55.0378 30.159 55.076 30.2267 55.1435C30.2943 55.211 30.3325 55.3024 30.3332 55.3979ZM30.7518 58.8479C30.7518 59.0089 30.6073 59.1421 30.4472 59.1421C30.3693 59.1417 30.2948 59.1105 30.2397 59.0554C30.1847 59.0003 30.1536 58.9257 30.1532 58.8479C30.1532 58.6881 30.2858 58.5554 30.4472 58.5554C30.6073 58.5551 30.7518 58.6871 30.7518 58.8479ZM45.7861 55.5538C45.7856 55.6313 45.7546 55.7056 45.6998 55.7605C45.6451 55.8154 45.5709 55.8466 45.4934 55.8474C45.4155 55.847 45.341 55.8159 45.2859 55.7609C45.2308 55.706 45.1995 55.6316 45.1988 55.5538C45.1988 55.3927 45.3314 55.2607 45.4934 55.2607C45.6535 55.2607 45.7861 55.3927 45.7861 55.5538ZM38.7884 58.0347C38.7881 58.1124 38.7571 58.1868 38.7021 58.2417C38.6472 58.2966 38.5728 58.3275 38.4951 58.3278C38.4175 58.3274 38.3431 58.2964 38.2882 58.2415C38.2333 58.1867 38.2022 58.1124 38.2017 58.0347C38.2017 57.8749 38.3347 57.7417 38.4951 57.7417C38.6564 57.7417 38.7884 57.8743 38.7884 58.0347ZM57.6183 61.6008C57.6176 61.6784 57.5865 61.7527 57.5315 61.8075C57.4766 61.8624 57.4022 61.8934 57.3246 61.8938C57.2469 61.8935 57.1724 61.8626 57.1173 61.8077C57.0622 61.7529 57.031 61.6785 57.0303 61.6008C57.0303 61.4407 57.1636 61.3077 57.3246 61.3077C57.485 61.3077 57.6183 61.4401 57.6183 61.6008ZM59.1519 47.728C59.1514 47.8238 59.1131 47.9154 59.0453 47.9831C58.9776 48.0508 58.8859 48.089 58.7901 48.0895C58.6945 48.0889 58.6028 48.0507 58.5352 47.983C58.4675 47.9153 58.4292 47.8237 58.4286 47.728C58.4286 47.53 58.5915 47.3665 58.7901 47.3665C58.8859 47.3669 58.9777 47.4051 59.0454 47.4728C59.1132 47.5405 59.1515 47.6322 59.1519 47.728ZM56.2643 49.6898C56.2637 49.7676 56.2325 49.8421 56.1774 49.897C56.1223 49.952 56.0478 49.983 55.97 49.9834C55.8099 49.9834 55.677 49.8505 55.677 49.6898C55.677 49.5291 55.8099 49.397 55.97 49.397C56.1313 49.397 56.2643 49.5288 56.2643 49.6898ZM59.1098 50.2551C59.1098 50.4528 58.9469 50.6169 58.748 50.6169C58.549 50.6169 58.3862 50.4537 58.3862 50.2551C58.3862 50.0577 58.549 49.8939 58.748 49.8939C58.9469 49.8939 59.1098 50.0577 59.1098 50.2551ZM56.2643 53.7509C56.2637 53.8286 56.2325 53.903 56.1774 53.9579C56.1223 54.0128 56.0478 54.0437 55.97 54.0439C55.8925 54.0434 55.8182 54.0123 55.7634 53.9575C55.7086 53.9026 55.6775 53.8284 55.677 53.7509C55.677 53.5898 55.8099 53.4572 55.97 53.4572C56.1313 53.4572 56.2643 53.5895 56.2643 53.7509ZM63.6225 45.7662C63.6225 45.9263 63.489 46.0596 63.3289 46.0596C63.2513 46.0589 63.1771 46.0278 63.1222 45.9729C63.0674 45.918 63.0364 45.8438 63.0358 45.7662C63.0358 45.6055 63.1684 45.4735 63.3289 45.4735C63.4893 45.4735 63.6225 45.6055 63.6225 45.7662ZM64.3345 47.5477C64.3345 47.7454 64.1839 47.9092 63.9849 47.9092C63.7866 47.9092 63.6121 47.7463 63.6121 47.5477C63.6121 47.3497 63.775 47.1868 63.973 47.1868C64.1716 47.1874 64.3345 47.3497 64.3345 47.5477ZM69.404 49.6684C69.404 49.8661 69.2426 50.0296 69.0425 50.0296C68.9467 50.0293 68.855 49.9911 68.7872 49.9235C68.7195 49.8558 68.6812 49.7641 68.6807 49.6684C68.6813 49.5726 68.7196 49.481 68.7873 49.4133C68.855 49.3456 68.9467 49.3074 69.0425 49.3069C69.1383 49.3072 69.23 49.3454 69.2978 49.4131C69.3655 49.4809 69.4037 49.5726 69.404 49.6684ZM64.2547 53.4364C64.254 53.5142 64.2227 53.5885 64.1677 53.6433C64.1126 53.6981 64.0382 53.7291 63.9605 53.7295C63.8828 53.7291 63.8085 53.6981 63.7535 53.6433C63.6985 53.5884 63.6674 53.5141 63.6668 53.4364C63.6668 53.2754 63.8001 53.1428 63.9605 53.1428C64.1209 53.1428 64.2547 53.2745 64.2547 53.4364ZM67.5064 50.3682C67.506 50.4458 67.475 50.5201 67.4201 50.5749C67.3652 50.6298 67.2909 50.6608 67.2133 50.6612C67.1357 50.6607 67.0614 50.6297 67.0065 50.5749C66.9516 50.52 66.9205 50.4458 66.92 50.3682C66.92 50.208 67.0535 50.0748 67.2133 50.0748C67.3737 50.0748 67.5064 50.2071 67.5064 50.3682ZM66.9074 55.1046C66.907 55.1822 66.876 55.2565 66.8212 55.3113C66.7663 55.3662 66.692 55.3972 66.6144 55.3976C66.5366 55.3975 66.462 55.3666 66.4069 55.3117C66.3518 55.2568 66.3206 55.1824 66.3201 55.1046C66.3201 54.9448 66.4527 54.8112 66.6144 54.8112C66.7748 54.8112 66.9074 54.9438 66.9074 55.1046ZM68.2856 47.233C68.2856 47.4808 68.0815 47.684 67.8336 47.684C67.5861 47.684 67.3823 47.4808 67.3823 47.233C67.3823 46.9854 67.5861 46.7822 67.8336 46.7822C68.0815 46.7822 68.2856 46.9854 68.2856 47.233Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M67.8322 45.8578L67.698 47.0981L66.4675 47.2338L67.7087 47.3682L67.8444 48.6544L67.9801 47.3682L69.1987 47.21L67.9691 47.0972L67.8322 45.8578ZM65.1223 55.0797C65.1223 55.3279 64.9185 55.5317 64.6707 55.5317C64.551 55.5312 64.4363 55.4834 64.3517 55.3988C64.267 55.3141 64.2192 55.1994 64.2188 55.0797C64.2188 54.8322 64.4229 54.629 64.6707 54.629C64.7902 54.6295 64.9046 54.6771 64.9892 54.7615C65.0738 54.8459 65.1216 54.9603 65.1223 55.0797Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M64.6731 53.7047L64.5374 54.9457L63.3074 55.0804L64.5487 55.2161L64.6847 56.5011L64.8204 55.2161L66.0384 55.0578L64.8078 54.9448L64.6731 53.7047ZM31.4384 17.8199C31.4384 18.0674 31.2346 18.2709 30.9871 18.2709C30.8675 18.2706 30.7529 18.223 30.6682 18.1385C30.5835 18.054 30.5357 17.9395 30.5352 17.8199C30.5352 17.5717 30.7387 17.3685 30.9871 17.3685C31.2346 17.3691 31.4384 17.5723 31.4384 17.8199Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M30.9876 16.4441L30.8519 17.6845L29.6211 17.8201L30.863 17.9543L30.9986 19.2411L31.1337 17.9543L32.3529 17.7972L31.1221 17.6839L30.9876 16.4441ZM48.237 6.90409C48.237 7.15161 48.0329 7.35543 47.7851 7.35543C47.5373 7.35543 47.334 7.15161 47.334 6.90409C47.334 6.65597 47.5369 6.45215 47.7851 6.45215C48.0332 6.45215 48.237 6.65658 48.237 6.90409Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M47.7847 5.5271L47.6503 6.76834L46.42 6.90402L47.6616 7.03878L47.796 8.32464L47.9317 7.03878L49.1503 6.88049L47.9198 6.76773L47.7847 5.5271ZM27.8154 62.3008C27.8154 62.5489 27.6116 62.7521 27.3641 62.7521C27.2444 62.7517 27.1298 62.704 27.0451 62.6195C26.9605 62.535 26.9127 62.4204 26.9121 62.3008C26.9121 62.0536 27.1159 61.8491 27.3641 61.8491C27.6116 61.8494 27.8154 62.0539 27.8154 62.3008Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M27.3734 60.923L27.2384 62.1642L26.0078 62.2993L27.2494 62.434L27.3847 63.7199L27.5198 62.434L28.739 62.2764L27.5088 62.1633L27.3734 60.923Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M87.1638 3.46875C81.6723 19.7596 59.6743 32.3392 41.1564 44.3476C29.9849 51.595 18.8935 59.9362 11.2578 67.0335C9.24526 68.9052 11.6679 66.3335 10.8966 67.124C21.5526 54.8548 33.8104 47.5467 40.5841 42.9463C52.0398 35.1636 58.5556 33.2021 78.3195 14.9975"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M5.23755 43.8289C3.26537 44.7929 1.49884 45.746 0 46.6765L0.911835 47.0084C2.22275 46.2013 3.79646 45.3595 5.45421 44.6179M15.6491 62.0592C13.7728 63.6953 11.9275 65.3667 10.1142 67.0724L10.0317 68.3164C11.7429 66.5529 13.845 64.6501 16.2709 62.6303"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M48.5295 54.9457C63.9241 61.2787 61.253 45.2755 53.0468 33.0216C48.3954 26.0796 42.6597 20.5725 38.5039 17.5045C33.6514 13.9217 33.1777 13.6246 33.1777 13.6246C44.014 18.7678 53.8584 31.3984 57.9204 40.7038C59.797 45.0005 64.912 61.9996 48.6193 55.1266",
                fill: "white"
            })
        ]
    });

});


parcelRegister("7chqp", function(module, exports) {
$parcel$export(module.exports, "HeroCards", function () { return $d73711ffa20ae17c$export$fd47e26e7f1281cb; });
/* index.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $iNnWi = parcelRequire("iNnWi");

var $6FYDc = parcelRequire("6FYDc");

var $6tzCE = parcelRequire("6tzCE");

var $3FT2j = parcelRequire("3FT2j");

var $b2wEL = parcelRequire("b2wEL");
const $d73711ffa20ae17c$export$fd47e26e7f1281cb = ()=>{
    const intl = (0, $8e22h.default)();
    const softwareCard = {
        eyebrow: intl.formatMessage({
            id: 'jira-product-tour.hero-cards-software-development-card.eyebrow-text',
            defaultMessage: 'product & issue tracking'
        }),
        title: intl.formatMessage({
            id: 'jira-product-tour.hero-cards-software-development-card.title-text',
            defaultMessage: 'Software Development'
        }),
        image: (0, $iNnWi.getHeroCardSoftwareDevelopmentImage)(intl.locale),
        BackgroundImage: (0, $6tzCE.OrangeCard),
        label: 'software-development'
    };
    const marketingCard = {
        eyebrow: intl.formatMessage({
            id: 'jira-product-tour.hero-cards-marketing-card.eyebrow-text',
            defaultMessage: 'plan & launch campaigns'
        }),
        title: intl.formatMessage({
            id: 'jira-product-tour.hero-cards-marketing-card.title-text',
            defaultMessage: 'Marketing'
        }),
        image: (0, $iNnWi.getHeroCardMarketingImage)(intl.locale),
        BackgroundImage: (0, $6tzCE.PurpleCard),
        label: 'marketing'
    };
    const itCard = {
        eyebrow: intl.formatMessage({
            id: 'jira-product-tour.hero-cards-it-card.updated-eyebrow-text',
            defaultMessage: 'plan & track it projects'
        }),
        title: intl.formatMessage({
            id: 'jira-product-tour.hero-cards-it-card.title-text',
            defaultMessage: 'IT'
        }),
        image: (0, $iNnWi.getHeroCardItImage)(intl.locale),
        BackgroundImage: (0, $6tzCE.GreenCard),
        label: 'it'
    };
    const designCard = {
        eyebrow: intl.formatMessage({
            id: 'jira-product-tour.hero-cards-design-card.eyebrow-text',
            defaultMessage: 'build creative workflows'
        }),
        title: intl.formatMessage({
            id: 'jira-product-tour.hero-cards-design-card.title-text',
            defaultMessage: 'Design'
        }),
        image: (0, $iNnWi.getHeroCardDesignImage)(intl.locale),
        BackgroundImage: (0, $6tzCE.BlueCard),
        label: 'design'
    };
    const operationsCard = {
        eyebrow: intl.formatMessage({
            id: 'jira-product-tour.hero-cards-operations-card.eyebrow-text',
            defaultMessage: 'create custom processes'
        }),
        title: intl.formatMessage({
            id: 'jira-product-tour.hero-cards-operations-card.title-text',
            defaultMessage: 'Operations'
        }),
        image: (0, $iNnWi.getHeroCardOperationsImage)(intl.locale),
        BackgroundImage: (0, $6tzCE.BlackCard),
        label: 'operations'
    };
    const heroCardText = [
        softwareCard,
        marketingCard,
        itCard,
        designCard,
        operationsCard
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $b2wEL.HeroContextProvider), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx2vrvc _1bah1y6m _1bsb1osq _p12f1ns9 _zulp7vkz _1reo1wug _12l21wug _ahbq1wug _ca0qvbgk _u5f319bv _n3td19bv _19bv19bv _a5o9vsbx _jzge1l27 _105s1y6m _2g9e19bv _1rwy1l7b _1w1e15zi _z6961l7b"
            ]),
            style: {
                "--_3dffxf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark800'))
            },
            children: [
                heroCardText.map((card, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $6FYDc.HeroCard), {
                        eyebrow: card.eyebrow,
                        title: card.title,
                        image: card.image,
                        BackgroundImage: card.BackgroundImage,
                        idx: index,
                        label: card.label
                    }, index)),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3FT2j.JswProductModalCarousel), {})
            ]
        })
    });
};
const $d73711ffa20ae17c$var$heroCardsStyling = null;

});
parcelRegister("6FYDc", function(module, exports) {
$parcel$export(module.exports, "HeroCard", function () { return $cd3457d7154b039d$export$57301f0520e516bf; });
/* hero-card.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/no-block-disable-of-nested-eslint */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");

var $b2wEL = parcelRequire("b2wEL");
const $cd3457d7154b039d$export$57301f0520e516bf = ({ eyebrow: eyebrow, title: title, image: image, BackgroundImage: BackgroundImage, idx: idx, label: label })=>{
    const { openModal: openModal } = (0, $b2wEL.useHeroState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const handleClick = ()=>{
        openModal(idx);
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            attributes: {
                name: `atlas-55799-${label}-modal-opened`,
                section: 'hero-section'
            }
        }).fire();
    };
    const eyebrowText = intl.locale === 'en' ? eyebrow : '';
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
        onClick: handleClick,
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1bah1yb4 _y3gn1e5h _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _2rkoqslr _c71l1kdj _1ul9gx0z _11q71afi _16qst7xp _80omtlke _v564188d _1reozryt _18m9zryt _1i7qgx0z _5jif1dft _1ii3130s _hzy51qv5 _1lsjkb7n _c1lpkb7n _mlnj1xcn _1y8o122m _123rnklw"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_bozg1u1b"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_syaz1pfd _ect41qje _1wyb1crf _k48p1nn1 _vwz47vkz _1dyz1wr8 _1p1dangw _1q511pa9 _3fcw1q9c _1bysw1gv _1rfmn6wy"
                        ]),
                        style: {
                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                        },
                        children: eyebrowText
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _1bsbzdsj _syaz1pfd _ect41qje _1wyb1tcg _k48p1fw0 _vwz41ul9 _1q511v6z _slp31hna _ct361wug _1bah1yb4 _zzrmn6wy _1gdl1oqx _1p1d1tcg _1r3wgktf _ui901pfd _1jw8ni7l _1bys1f4h"
                        ]),
                        style: {
                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                        },
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _18m9zryt _c71l1kdj"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)(BackgroundImage, {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_2rkoqslr _15801u1b _f45rstnw _dgw6idpf _1hlvidpf"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                            image: {
                                src: image,
                                width: 227,
                                height: 364,
                                alt: '',
                                loading: 'eager'
                            }
                        })
                    })
                ]
            })
        ]
    });
};
const $cd3457d7154b039d$var$cardStyles = null;
const $cd3457d7154b039d$var$textStyles = null;
const $cd3457d7154b039d$var$eyebrowStyles = null;
const $cd3457d7154b039d$var$titleStyles = null;
const $cd3457d7154b039d$var$imageContainer = null;
const $cd3457d7154b039d$var$pictureStyles = null;

});
parcelRegister("b2wEL", function(module, exports) {
$parcel$export(module.exports, "useHeroState", function () { return $2f6af509606af537$export$e2b31be5fe4d64c8; });
$parcel$export(module.exports, "HeroContextProvider", function () { return $2f6af509606af537$export$b1ebf81440d0ff8d; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
const $2f6af509606af537$var$initVal = {
    modalIndex: -1,
    closeModal: ()=>-1,
    openModal: ()=>0
};
const $2f6af509606af537$export$63ebd153bf781d5f = /*#__PURE__*/ (0, $1oC0p.createContext)($2f6af509606af537$var$initVal);
const $2f6af509606af537$export$e2b31be5fe4d64c8 = ()=>{
    return (0, $1oC0p.useContext)($2f6af509606af537$export$63ebd153bf781d5f);
};
const $2f6af509606af537$export$b1ebf81440d0ff8d = ({ children: children })=>{
    const [modalIndex, setModalIndex] = (0, $1oC0p.useState)(-1);
    const openModal = (num)=>setModalIndex(num);
    const closeModal = ()=>setModalIndex(-1);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($2f6af509606af537$export$63ebd153bf781d5f.Provider, {
        value: {
            modalIndex: modalIndex,
            openModal: openModal,
            closeModal: closeModal
        },
        children: children
    });
};

});


parcelRegister("6tzCE", function(module, exports) {
$parcel$export(module.exports, "OrangeCard", function () { return $ff9b5386d1e37ddf$export$b9f0637fcee76583; });
$parcel$export(module.exports, "PurpleCard", function () { return $ff9b5386d1e37ddf$export$265c26304bb77354; });
$parcel$export(module.exports, "GreenCard", function () { return $ff9b5386d1e37ddf$export$961a018b253e0f90; });
$parcel$export(module.exports, "BlueCard", function () { return $ff9b5386d1e37ddf$export$294f4b24111c26a1; });
$parcel$export(module.exports, "BlackCard", function () { return $ff9b5386d1e37ddf$export$89725581676ad6dc; });

var $7VQPk = parcelRequire("7VQPk");
const $ff9b5386d1e37ddf$export$b9f0637fcee76583 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        style: {
            transition: '400ms'
        },
        opacity: "0",
        width: "260",
        height: "100%",
        viewBox: "0 0 260 392",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M190 10.1105L287 0.5V551.5H190V10.1105Z",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                y: "309.5",
                width: "72",
                height: "242",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M12 174L242 93.5V551.5H33.7079L12 174Z",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M91.3757 345.607C94.4326 316.532 72.821 353.827 66.5766 359.591C66.6744 349.361 70.2219 339.822 71.6661 329.54C71.4521 329.774 71.4286 329.07 71.6094 328.451C73.7067 306.146 55.5882 335.822 52.852 342.965C52.8571 342.947 53.3076 341.612 53.3161 341.582C31.2979 381.303 52.5372 327.158 50.7712 312.8C48.0114 301.66 39.0231 319.691 36.7403 323.74C31.7817 332.292 13.1954 371.804 21.3158 339.578L21.2302 339.793L21.2235 339.686C19.9412 343.752 15.1863 361.553 23.3964 349.43C10.382 367.677 25.8305 321.339 26.8121 316.021C26.1187 322.416 23.5003 329.295 23.3121 331.581C41.6247 260.152 8.32378 331.528 -3.15113 344.753C-3.42866 340.861 -2.2046 336.52 -1.45501 332.791C-1.98174 333.871 -3.12206 341.129 -3.73261 342.354C-3.72327 338.625 1.46654 318.867 -0.581947 328.733C-0.457885 325.429 13.7951 290.239 0.489425 297.317C-9.28835 307.87 -13.5004 323.636 -23.888 333.64C-27.6163 327.225 -8.20945 290.969 -22.1535 295.019C-27.7263 298.074 -47.3766 333.181 -43.7036 312.264C-42.1393 303.197 -44.4527 311.487 -45.0251 315.266C-45.0595 314.841 -45.0769 314.422 -45.0925 313.996C-47.299 337.542 -24.8339 295.427 -19.3444 295.729C-19.8045 309.234 -37.4438 360.038 -12.0674 320.742C-12.162 320.968 -12.767 322.392 -12.8497 322.576C-9.19942 319.69 -2.36649 297.801 4.10625 299.033C4.95454 300.683 2.22361 313.34 3.286 305.572C-18.0291 379.053 3.4966 342.697 25.4581 304.882C28.5782 319.533 11.6245 341.427 18.0739 356.474C32.5546 349.034 35.4669 325.194 47.1207 313.346C48.9171 319.068 44.6492 329.85 43.4684 336.596L43.6763 336.143C36.233 364.657 39.9023 372.572 56.209 341.886C58.3648 338.768 71.6989 313.331 68.9071 329.746C59.4974 378.571 64.4338 364.369 88.6115 336.779C92.4748 337.752 87.4444 359.722 91.3626 345.61L91.3757 345.607Z",
                fill: "#101214"
            })
        ]
    });
};
const $ff9b5386d1e37ddf$export$265c26304bb77354 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        style: {
            transition: '400ms'
        },
        opacity: "0",
        width: "260",
        height: "100%",
        viewBox: "0 0 260 391",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M190 88.1977L287 80V550H190V88.1977Z",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                y: "245",
                width: "72",
                height: "305",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M18.5 0L261 16V550H35.5011L18.5 0Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M32.3957 245.058C33.5425 244.959 48.888 241.246 44.8628 240.44C43.3696 240.859 42.2092 240.436 41.4627 241.57C41.2468 240.233 38.3189 242.367 37.8691 242.448C37.6668 241.435 33.0793 244.041 33.7494 243.1C31.6671 243.127 29.081 243.856 26.3915 244.712C25.0737 243.816 30.7226 237.425 28.3479 238.807C28.5143 238.446 29.153 236.889 29.0675 237.92C29.8186 237.038 37.9951 223.535 34.595 225.822C32.3012 228.608 30.5787 233.275 28.6358 235.58C26.7468 236.358 25.438 243.046 23.3332 242.38C22.1054 240.877 18.9391 222.469 16.6904 224.103C17.0817 225.534 16.7264 226.816 17.8193 227.505C16.4835 227.721 18.6153 230.651 18.6963 231.101C17.7068 231.29 20.2704 235.899 19.3484 235.224C19.3664 236.525 19.6587 238.028 20.0815 239.626C19.5193 239.198 18.9032 238.221 18.5479 238.077C14.761 236.543 11.8915 233.014 7.94723 231.101C4.63257 235.327 33.9428 245.99 15.7684 247.583C12.3503 249.815 7.8078 250.157 3.99392 252.304C3.6656 256.954 25.4066 244.126 19.1325 251.494C18.1566 254.609 16.7084 258.106 14.707 261.175C13.4297 272.882 24.2912 241.079 23.8414 253.213C25.3391 256.112 26.7873 259.605 27.5294 263.201C32.8409 270.996 25.591 250.374 24.8309 247.453C27.7093 246.224 38.8361 260.158 40.851 257.962C40.9454 257.651 39.3443 255.927 38.8586 255.743C38.5303 255.909 38.3639 256.044 38.1705 255.738C39.1464 254.798 35.7238 253.61 35.4 253.286C36.1196 252.57 31.3568 250.243 32.5126 250.279C31.6221 249.032 30.2594 247.777 28.7077 246.512C31.4602 245.981 32.6565 244.036 32.4047 245.049L32.3957 245.058Z",
                fill: "#101214"
            })
        ]
    });
};
const $ff9b5386d1e37ddf$export$961a018b253e0f90 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        style: {
            transition: '400ms'
        },
        opacity: "0",
        width: "260",
        height: "100%",
        viewBox: "0 0 260 409",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M75.9004 26.5L287.4 0.5V569H119.4L75.9004 26.5Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-5.59961 311L67.4004 286L72.4004 568.5H0.400391L-5.59961 311Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M9.40039 151L242.4 110.5V568.5H34.1083L21.4004 352L9.40039 151Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M38.8986 132.781C39.2166 132.221 36.9442 123.743 35.8543 126.325C35.3391 127.211 35.4683 127.971 36.3627 128.134C34.6953 128.569 37.0904 129.969 36.6079 130.815C35.405 130.663 38.0687 132.76 36.8029 132.437C36.3425 141.913 49.4139 159.478 40.5422 137.288C40.2112 139.625 39.5574 137.525 39.7288 136.473C41.3639 137.777 39.6836 133.639 39.0942 132.906C39.2394 134.228 37.9371 132.161 38.895 132.785L38.8986 132.781Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M26.0831 151.179C25.9033 149.969 17.1793 145.733 16.3356 145.174C14.3049 144.321 14.3929 147.139 16.0855 147.422C16.3879 147.621 18.8106 148.168 17.851 148.841C18.5768 151.171 22.8129 151.064 23.2479 153.049C23.7743 152.669 24.4966 153.313 24.8533 153.111C24.8407 153.717 25.6701 153.967 25.7296 153.816C28.0241 156.156 30.1997 152.73 27.1018 151.667C27.2204 151.551 26.6349 150.91 26.0911 151.178L26.0831 151.179Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M13.214 183.803C14.6822 184.753 13.2253 184.829 12.5136 184.357C13.6609 183.246 10.784 183.546 10.075 183.952C10.379 183.982 10.4712 184.496 9.84193 184.471C10.3094 183.168 2.35086 182.948 6.04574 185.633C6.18193 185.627 6.26697 184.6 6.41885 184.919C6.11372 186.476 7.39131 185.384 7.74683 185.263C7.71942 186.071 8.07319 185.319 8.154 185.653C7.69634 186.742 9.77517 184.913 9.26035 185.992C11.045 187.634 14.7083 185.435 16.0664 186.932C17.0725 185.111 22.8461 187.798 20.677 184.338C18.1787 183.565 16.1276 183.133 13.214 183.803Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-1.49997 165.314C-2.19099 167.811 3.30413 167.242 4.76979 168.257C6.53807 169.708 25.7928 174.672 20.8767 169.788C15.0359 168.335 10.5165 166.116 3.19864 165.256C2.02145 165.029 -1.61684 163.57 -1.49997 165.314Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M57.4411 142.901C59.4435 144.317 56.8745 146.385 58.5173 147.732C61.6811 149.754 63.1253 131.281 59.8252 131.898C57.053 132.811 58.6706 141.577 57.4411 142.901Z",
                fill: "#101214"
            })
        ]
    });
};
const $ff9b5386d1e37ddf$export$294f4b24111c26a1 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        style: {
            transition: '400ms'
        },
        opacity: "0",
        width: "260",
        height: "100%",
        viewBox: "0 0 260 399",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                x: "-0.199219",
                y: "280",
                width: "72",
                height: "278",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M11.8008 138.97L241.801 109V558H33.5086L11.8008 138.97Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M90.8008 21.5233L280.801 0.5L286.801 558H90.8008V21.5233Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M55.8008 315.386C53.0837 310.928 56.2763 303.048 51.8894 298.79C43.0193 295.942 41.3834 312.505 35.5983 314.656C32.9661 310.471 35.7511 304.135 32.4397 299.771C32.5982 299.877 33.1077 300.429 33.1643 300.501C24.464 290.96 21.5771 313.413 14.9939 314.74C12.2316 310.148 16.8959 297.698 8.42202 298.227C3.07847 298.305 -3.06324 320.558 -6.14824 312.979L-6.15955 313.085L-6.19918 313.046C-5.89917 318.446 -1.16129 312.449 -0.312218 310.755C-7.56903 324.119 -7.16713 307.244 -7.90866 301.114C-6.45956 302.736 -7.05958 307.188 -6.56711 309.106C-6.63504 285.705 -18.9581 306.263 -24.5846 314.506C-28.5753 314.305 -25.6828 304.787 -27.4545 301.66C-27.3526 302.329 -26.6847 306.113 -27.3413 306.849C-27.5168 304.079 -27.3583 298.222 -31.666 298.929C-31.2244 298.021 -29.0621 298.929 -28.813 299.347C-37.836 295.084 -39.0303 313.202 -46.089 314.79C-48.1438 310.075 -45.54 304.045 -48.4155 299.403C-56.7761 290.498 -65.867 327.608 -67.401 309.49C-67.8708 305.834 -66.5066 299.431 -71.1992 298.801C-70.4577 299.23 -68.7992 300.384 -68.8897 302.179C-69.0143 301.989 -69.1331 301.8 -69.2577 301.621C-67.984 306.397 -70.1294 311.513 -67.8595 316.01C-61.9669 321.533 -56.0403 297.86 -50.0684 300.228C-47.6117 303.293 -49.3722 308.353 -48.7495 312.02C-48.7948 311.903 -49.0212 311.145 -49.0608 311.045C-47.4249 328.622 -35.8887 303.388 -37.0152 307.149C-22.5185 284.546 -36.5567 329.725 -20.8487 314.974C-17.1467 311.914 -14.8711 300.172 -9.98608 301.738C-9.32946 307.79 -9.0068 325.211 0.0557327 313.943C3.46905 310.17 4.82756 302.151 9.87677 301.036C12.5542 305.767 8.05408 322.286 18.4412 316.936C18.3393 316.975 18.2431 317.019 18.1355 317.058C22.347 315.609 26.632 296.137 31.0472 302.006C32.751 305.818 29.5415 316.791 36.1077 317.119C41.8532 316.646 47.7289 292.587 51.7761 303.522C52.512 306.13 52.1837 317.654 55.7894 315.37L55.8008 315.386Z",
                fill: "#101214"
            })
        ]
    });
};
const $ff9b5386d1e37ddf$export$89725581676ad6dc = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        style: {
            transition: '400ms'
        },
        opacity: "0",
        width: "260",
        height: "100%",
        viewBox: "0 0 260 428",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M190.199 46.1105L287.199 36.5V587.5H190.199V46.1105Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                x: "0.199219",
                y: "345.5",
                width: "72",
                height: "242",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M12.1992 210L242.199 129.5V587.5H33.9071L12.1992 210Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M264.513 26.5943C264.532 26.5625 264.532 26.5053 264.57 26.4609C263.451 25.9017 263.323 24.5292 262.46 23.7096L262.428 23.6778C261.552 23.3982 261.789 22.5277 260.702 22.5213C260.702 22.5213 260.983 22.3815 260.99 22.3815C259.225 20.6405 254.864 16.3642 254.864 16.3642C254.768 16.7518 255.561 16.0782 256.36 16.1926C256.36 16.1926 256.418 16.0465 256.475 16.1609C258.515 14.1848 260.811 13.4286 263.419 12.4882C264.724 12.1387 264.922 8.47237 262.69 9.991C262.665 9.96558 262.607 9.94659 262.582 9.90211C261.802 10.8044 260.504 10.4739 259.519 10.9441L259.481 10.9632L257.844 11.7575C256.955 12.1196 255.9 12.4056 254.794 12.6852C254.826 12.6534 254.858 12.6217 254.89 12.5899C254.89 12.5899 255.005 10.8298 254.973 9.95927C254.973 9.95927 256.092 8.5614 255.721 7.60193C256.354 6.47725 258.605 4.01814 256.559 3.31919C255.887 3.31919 255.363 2.74099 255.133 3.81483C255.094 3.80848 255.043 3.82117 254.992 3.80211C254.871 4.91408 253.547 5.702 253.183 6.75678L253.17 6.8013C253.259 7.70359 252.556 8.59313 252.55 8.59313C252.217 9.41916 251.782 10.3214 251.322 11.2618C251.13 10.7535 250.919 10.3024 250.708 9.97836C249.941 9.15232 250.267 -2.13257 247.428 0.358238C247.563 2.48686 248.24 4.70441 247.69 6.59793C247.422 6.74407 247.831 7.50022 248.164 8.11657C248.138 8.89812 247.978 9.31751 247.933 10.4358C246.527 9.42553 240.389 4.3105 240.766 7.75442C241.424 8.1039 241.904 8.50418 242.249 9.3175C242.569 9.66698 245.389 11.2428 245.478 11.6368C245.293 12.1832 248.624 12.6216 247.275 13.0283C247.473 13.4604 247.742 13.8734 248.055 14.2737C246.597 14.4262 244.852 14.8519 243.937 15.4047C243.777 15.6779 237.959 16.0465 235.849 17.3999C234.589 18.1052 233.477 18.4547 234.788 19.5159C235.261 19.1346 237.038 19.6811 237 19.1791C237.435 19.357 240.376 18.2386 240.702 18.4293C240.862 18.6834 243.176 17.3364 242.901 17.9718C244.506 18.4229 246.463 18.0544 248.496 17.5397C247.69 18.8105 246.898 20.6214 246.795 21.7461C246.105 23.1885 244.282 26.3783 243.701 28.3354C242.869 29.7587 243.157 29.873 244.206 30.6037L244.225 30.6228C244.442 30.769 244.199 30.6228 245.024 30.6545C244.941 30.5783 244.82 30.2479 244.66 30.3051C244.768 30.0827 246.022 29.765 245.497 29.4663C245.478 29.4219 246.297 28.7992 246.38 28.1256C247.109 25.7238 248.854 24.5101 250.146 21.7715C250.114 22.0575 252.288 27.4394 252.185 30.1208C252.025 31.4425 255.248 33.4123 254.781 30.464C254.82 30.4513 254.851 30.4004 254.909 30.3941C254.391 29.1805 255.075 27.9286 254.807 26.696L254.794 26.6451C254.212 25.8954 254.883 25.2727 253.963 24.6627C253.963 24.6627 254.276 24.6944 254.282 24.7008C253.873 22.9534 253.617 20.8184 253.234 18.9058C254.609 20.1449 255.817 21.4792 256.316 22.947L256.38 22.8518C256.38 22.8962 256.475 22.928 256.392 23.0296C257.55 23.2711 257.946 23.754 258.784 24.0781C258.784 24.0781 259.679 25.6857 260.721 25.7428L262.307 27.9731C262.991 29.1232 266.68 28.4624 264.538 26.6197L264.513 26.5943Z",
                fill: "#101214"
            })
        ]
    });
};

});

parcelRegister("3FT2j", function(module, exports) {
$parcel$export(module.exports, "JswProductModalCarousel", function () { return $3148b6359fff8134$export$e7364013ca7b67b5; });
/* product-modal-carousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $56bcs = parcelRequire("56bcs");

var $loQfN = parcelRequire("loQfN");

var $6j91P = parcelRequire("6j91P");

var $2RA08 = parcelRequire("2RA08");

var $eAAXu = parcelRequire("eAAXu");

var $k0ZFU = parcelRequire("k0ZFU");

var $hiWeO = parcelRequire("hiWeO");

var $eZVel = parcelRequire("eZVel");

var $gHoFv = parcelRequire("gHoFv");

var $j9re6 = parcelRequire("j9re6");

var $2Qv7t = parcelRequire("2Qv7t");

var $37mR0 = parcelRequire("37mR0");

var $jQ0cd = parcelRequire("jQ0cd");

var $6Ro48 = parcelRequire("6Ro48");

var $iNnWi = parcelRequire("iNnWi");

var $6RoNo = parcelRequire("6RoNo");

var $b97hj = parcelRequire("b97hj");

var $ktT4l = parcelRequire("ktT4l");

var $b2wEL = parcelRequire("b2wEL");
const $3148b6359fff8134$export$e7364013ca7b67b5 = ()=>{
    const { modalIndex: modalIndex } = (0, $b2wEL.useHeroState)();
    const intl = (0, $8e22h.default)();
    // Disable scroll if modal is open
    (0, $1oC0p.useEffect)(()=>{
        if (modalIndex !== -1) document.body.style.overflow = 'hidden';
        else document.body.style.overflow = 'unset';
    }, [
        modalIndex
    ]);
    const softwareModal = {
        eyebrow: intl.formatMessage({
            id: 'jira-product-tour.hero-modal-software-development.eyebrow-text',
            defaultMessage: 'product and issue tracking'
        }),
        title: intl.formatMessage({
            id: 'jira-product-tour.hero-modal-software-development.title-text',
            defaultMessage: 'Software Development'
        }),
        description: intl.formatMessage({
            id: 'jira-product-tour.hero-modal-software-development.description-text',
            defaultMessage: 'Plan, track, release and support world-class software. Jira is the single source of truth for your entire development lifecycle.'
        }),
        image: (0, $iNnWi.getProductSoftwareDevelopmentModalImage)(intl.locale),
        iconCollection: [
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($loQfN))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: 'jira-product-tour.hero-modal-software-development-icon-analytics.icon-text',
                    defaultMessage: 'Analytics'
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gHoFv))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: 'jira-product-tour.hero-modal-software-development-icon-progress-tracking.icon-text',
                    defaultMessage: 'Progress tracking'
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($37mR0))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: 'jira-product-tour.hero-modal-software-development-icon-sprint-planning.icon-text',
                    defaultMessage: 'Sprint planning'
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k0ZFU))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: 'jira-product-tour.hero-modal-software-development-icon-forms.icon-text',
                    defaultMessage: 'Forms'
                })
            }
        ],
        BackgroundImage: (0, $6RoNo.OrangeModal),
        ctaLink: (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=jira-software&jiraProductTourSignupType=software-development'),
        label: 'software-development',
        personaData: {
            team: 'Software Development',
            persona: 'Software Development Generic'
        }
    };
    const marketingModal = {
        eyebrow: intl.formatMessage({
            id: 'jira-product-tour.hero-modal-marketing.eyebrow-text',
            defaultMessage: 'plan and launch campaigns'
        }),
        title: intl.formatMessage({
            id: 'jira-product-tour.hero-modal-marketing.title-text',
            defaultMessage: 'Marketing'
        }),
        description: intl.formatMessage({
            id: 'jira-product-tour.hero-modal-marketing.description-text',
            defaultMessage: 'Make launching viral marketing campaigns a breeze. Break down complex campaigns into actionable steps, easily collect requests, and stay aligned with cross-functional teams.'
        }),
        image: (0, $iNnWi.getProductMarketingModalImage)(intl.locale),
        iconCollection: [
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eAAXu))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: 'jira-product-tour.hero-modal-marketing-icon-progress-tracking.icon-text',
                    defaultMessage: 'Progress tracking'
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($56bcs))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: 'jira-product-tour.hero-modal-marketing-icon-calendar-view.icon-text',
                    defaultMessage: 'Calendar view'
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k0ZFU))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: 'jira-product-tour.hero-modal-marketing-icon-forms.icon-text',
                    defaultMessage: 'Forms'
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2RA08))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: 'jira-product-tour.hero-modal-marketing-icon-reporting.icon-text',
                    defaultMessage: 'Reporting'
                })
            }
        ],
        BackgroundImage: (0, $6RoNo.PurpleModal),
        ctaLink: (0, $jQ0cd.useLocalizedHref)(`/try/cloud/signup?bundle=jira-software&templateId=${(0, $6Ro48.TemplateKey).CampaignManagement}`),
        label: 'marketing',
        personaData: {
            team: 'Marketing',
            persona: 'Marketing Generic'
        }
    };
    const itModal = {
        eyebrow: intl.formatMessage({
            id: 'jira-product-tour.hero-modal-it.updated-eyebrow-text',
            defaultMessage: 'plan and track it projects'
        }),
        title: intl.formatMessage({
            id: 'jira-product-tour.hero-modal-it.title-text',
            defaultMessage: 'IT support services'
        }),
        description: intl.formatMessage({
            id: 'jira-product-tour.hero-modal-it.updated-description-text',
            defaultMessage: 'Streamline IT projects and deliver reliable services to internal teams, from migration management to software deployment. Gain visibility across IT workflows to align technology projects to business goals.'
        }),
        image: (0, $iNnWi.getUpdatedProductItModalImage)(intl.locale),
        iconCollection: [
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gHoFv))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: 'jira-product-tour.hero-modal-it-icon-resolve-incidents.updated-icon-text',
                    defaultMessage: 'Progress tracking'
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($j9re6))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: 'jira-product-tour.hero-modal-it-icon-help-desk.updated-icon-text',
                    defaultMessage: 'Intake requests'
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eZVel))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: 'jira-product-tour.hero-modal-it-icon-manage-requests.updated-icon-text',
                    defaultMessage: 'Release management'
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6j91P))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: 'jira-product-tour.hero-modal-it-icon-reporting.icon-text',
                    defaultMessage: 'Reporting'
                })
            }
        ],
        BackgroundImage: (0, $6RoNo.GreenModal),
        ctaLink: (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=jira-software&jiraProductTourSignupType=it'),
        label: 'it',
        personaData: {
            team: 'IT Support',
            persona: 'IT Support Generic'
        }
    };
    const designModal = {
        eyebrow: intl.formatMessage({
            id: 'jira-product-tour.hero-modal-design.eyebrow-text',
            defaultMessage: 'build creative workflows'
        }),
        title: intl.formatMessage({
            id: 'jira-product-tour.hero-modal-design.title-text',
            defaultMessage: 'Design'
        }),
        description: intl.formatMessage({
            id: 'jira-product-tour.hero-modal-design.description-text',
            defaultMessage: "Collaborate on, organize, and deliver creative requests with ease. Give real-time visibility into designs with Jira\u2019s Figma integration and accelerate approvals."
        }),
        image: (0, $iNnWi.getProductDesignModalImage)(intl.locale),
        iconCollection: [
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eAAXu))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: 'jira-product-tour.hero-modal-design-task-planning.icon-text',
                    defaultMessage: 'Task planning'
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hiWeO))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: 'jira-product-tour.hero-modal-design-progress-tracking.icon-text',
                    defaultMessage: 'Progress tracking'
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($j9re6))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: 'jira-product-tour.hero-modal-design-prioritization.icon-text',
                    defaultMessage: 'Prioritization'
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2RA08))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: 'jira-product-tour.hero-modal-design-forms.icon-text',
                    defaultMessage: 'Forms'
                })
            }
        ],
        BackgroundImage: (0, $6RoNo.BlueModal),
        ctaLink: (0, $jQ0cd.useLocalizedHref)(`/try/cloud/signup?bundle=jira-software&templateId=${(0, $6Ro48.TemplateKey).WebDesignProcess}`),
        label: 'design',
        personaData: {
            team: 'Design',
            persona: 'Design Generic'
        }
    };
    const operationsModal = {
        eyebrow: intl.formatMessage({
            id: 'jira-product-tour.hero-modal-operations.eyebrow-text',
            defaultMessage: 'create intake processes'
        }),
        title: intl.formatMessage({
            id: 'jira-product-tour.hero-modal-operations.title-text',
            defaultMessage: 'Operations'
        }),
        description: intl.formatMessage({
            id: 'jira-product-tour.hero-modal-operations.description-text',
            defaultMessage: 'Manage procurement, office, and new vendor requests, craft new operational processes, monitor operational risks and more. Keep your company running at maximum efficiency with Jira.'
        }),
        image: (0, $iNnWi.getProductOperationsModalImage)(intl.locale),
        iconCollection: [
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eAAXu))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: 'jira-product-tour.hero-modal-operations-task-planning.icon-text',
                    defaultMessage: 'Task planning'
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gHoFv))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: 'jira-product-tour.hero-modal-operations-progress-tracking.icon-text',
                    defaultMessage: 'Progress tracking'
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Qv7t))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: 'jira-product-tour.hero-modal-operations-prioritization.icon-text',
                    defaultMessage: 'Prioritization'
                })
            },
            {
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k0ZFU))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: 'jira-product-tour.hero-modal-operations-forms.icon-text',
                    defaultMessage: 'Forms'
                })
            }
        ],
        BackgroundImage: (0, $6RoNo.BlackModal),
        ctaLink: (0, $jQ0cd.useLocalizedHref)(`/try/cloud/signup?bundle=jira-software&templateId=${(0, $6Ro48.TemplateKey).SimplifiedProcessControl}`),
        label: 'operations',
        personaData: {
            team: 'Operations',
            persona: 'Operations Generic'
        }
    };
    const JswProductTourModalCards = [
        softwareModal,
        marketingModal,
        itModal,
        designModal,
        operationsModal
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: modalIndex !== -1 && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $b97hj.ProductModalCarousel), {
                    children: JswProductTourModalCards.map((props, idx)=>{
                        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ktT4l.ProductModalCard), {
                            ...props
                        }, idx);
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqsw1n9t _1e02idpf _152tidpf _rjxpidpf _u7coidpf _1e0c1txw _4cvr1h6o _1bah1h6o _11q71sgx _1pbyzo7u _je3oglyw"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ktT4l.ProductModalCard), {
                        ...JswProductTourModalCards[modalIndex]
                    })
                })
            ]
        })
    });
};
const $3148b6359fff8134$var$modalBackgroundStyles = null;

});
parcelRegister("56bcs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43a4f9fcd22489798c1322bda48936cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3b66335b7827c74c$var$_react = $3b66335b7827c74c$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $3b66335b7827c74c$var$_baseNew = $3b66335b7827c74c$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $3b66335b7827c74c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3b66335b7827c74c$var$CalendarIcon = (props)=>/*#__PURE__*/ $3b66335b7827c74c$var$_react.default.createElement($3b66335b7827c74c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$3b66335b7827c74c$var$CalendarIcon.displayName = 'CalendarIcon';
var $3b66335b7827c74c$var$_default = module.exports.default = $3b66335b7827c74c$var$CalendarIcon;

});

parcelRegister("loQfN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d4a862ad906af43648c20a01ac989d3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f9445f6570be1c0c$var$_react = $f9445f6570be1c0c$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f9445f6570be1c0c$var$_baseNew = $f9445f6570be1c0c$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $f9445f6570be1c0c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartTrend".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: charts, reports in Jira, and sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f9445f6570be1c0c$var$ChartTrendIcon = (props)=>/*#__PURE__*/ $f9445f6570be1c0c$var$_react.default.createElement($f9445f6570be1c0c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h1.5v7.94l3.22-3.22a.75.75 0 0 1 1.06 0L8.5 7.44l3.94-3.94H10V2h4.25a.75.75 0 0 1 .75.75V7h-1.5V4.56L9.03 9.03a.75.75 0 0 1-1.06 0L6.25 7.31 2.5 11.06V13a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$f9445f6570be1c0c$var$ChartTrendIcon.displayName = 'ChartTrendIcon';
var $f9445f6570be1c0c$var$_default = module.exports.default = $f9445f6570be1c0c$var$ChartTrendIcon;

});

parcelRegister("6j91P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f238518c984ab5d0530bd2cff7eccbeb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $497b855083b7f301$var$_react = $497b855083b7f301$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $497b855083b7f301$var$_baseNew = $497b855083b7f301$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $497b855083b7f301$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $497b855083b7f301$var$FeedbackIcon = (props)=>/*#__PURE__*/ $497b855083b7f301$var$_react.default.createElement($497b855083b7f301$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.221l-4.064 2.63A.75.75 0 0 1 1 15V9.5h1.5v4.121l3.093-2A.75.75 0 0 1 6 11.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 0 .5.5h5.44L7.22 5.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$497b855083b7f301$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $497b855083b7f301$var$_default = module.exports.default = $497b855083b7f301$var$FeedbackIcon;

});

parcelRegister("2RA08", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ac12335f661fcbcd071a3693f0f2aa2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $215c7517353ffee6$var$_react = $215c7517353ffee6$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $215c7517353ffee6$var$_baseNew = $215c7517353ffee6$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $215c7517353ffee6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $215c7517353ffee6$var$FileIcon = (props)=>/*#__PURE__*/ $215c7517353ffee6$var$_react.default.createElement($215c7517353ffee6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$215c7517353ffee6$var$FileIcon.displayName = 'FileIcon';
var $215c7517353ffee6$var$_default = module.exports.default = $215c7517353ffee6$var$FileIcon;

});

parcelRegister("eAAXu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c464a7d95484e897372db9f1fff872cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9f118b18787d1b2$var$_react = $a9f118b18787d1b2$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $a9f118b18787d1b2$var$_baseNew = $a9f118b18787d1b2$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $a9f118b18787d1b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a9f118b18787d1b2$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $a9f118b18787d1b2$var$_react.default.createElement($a9f118b18787d1b2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.5 4.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 5H6V3.5h10zm0 7.5H6V11h10z" clip-rule="evenodd"/>`
    }, props));
$a9f118b18787d1b2$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $a9f118b18787d1b2$var$_default = module.exports.default = $a9f118b18787d1b2$var$ListBulletedIcon;

});

parcelRegister("k0ZFU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ecb53df8812f428ed0814030a719aff1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e923a61533d1d699$var$_react = $e923a61533d1d699$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $e923a61533d1d699$var$_baseNew = $e923a61533d1d699$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $e923a61533d1d699$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Menu".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for accessing the menu in global product navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e923a61533d1d699$var$MenuIcon = (props)=>/*#__PURE__*/ $e923a61533d1d699$var$_react.default.createElement($e923a61533d1d699$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm0 5.25H1v-1.5h14zM15 14H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$e923a61533d1d699$var$MenuIcon.displayName = 'MenuIcon';
var $e923a61533d1d699$var$_default = module.exports.default = $e923a61533d1d699$var$MenuIcon;

});

parcelRegister("hiWeO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63dc429f33c9470dc156b62d0ec66db5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c9914af41d2254d3$var$_react = $c9914af41d2254d3$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $c9914af41d2254d3$var$_baseNew = $c9914af41d2254d3$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $c9914af41d2254d3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c9914af41d2254d3$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $c9914af41d2254d3$var$_react.default.createElement($c9914af41d2254d3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3c-.586 0-1 .414-1 1H5.5c0-1.414 1.086-2.5 2.5-2.5s2.5 1.086 2.5 2.5c0 1.133-.713 1.706-1.162 2.058-.511.402-.588.494-.588.692v.75h-1.5v-.75c0-.977.689-1.507 1.078-1.806l.084-.065C8.838 6.544 9 6.367 9 6c0-.586-.414-1-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$c9914af41d2254d3$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $c9914af41d2254d3$var$_default = module.exports.default = $c9914af41d2254d3$var$QuestionCircleIcon;

});

parcelRegister("eZVel", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d727d3cc18de179b7b728d0be1f533d4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aeb327f65461dbf8$var$_react = $aeb327f65461dbf8$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $aeb327f65461dbf8$var$_baseNew = $aeb327f65461dbf8$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $aeb327f65461dbf8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for reloading or replaying content
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aeb327f65461dbf8$var$RefreshIcon = (props)=>/*#__PURE__*/ $aeb327f65461dbf8$var$_react.default.createElement($aeb327f65461dbf8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 3.67V1H1v5c0 .414.336.75.75.75H6.5v-1.5H3.236a5.5 5.5 0 1 1-.666 3.63l-1.48.24A7.002 7.002 0 0 0 15 8 7 7 0 0 0 2.5 3.67" clip-rule="evenodd"/>`
    }, props));
$aeb327f65461dbf8$var$RefreshIcon.displayName = 'RefreshIcon';
var $aeb327f65461dbf8$var$_default = module.exports.default = $aeb327f65461dbf8$var$RefreshIcon;

});

parcelRegister("gHoFv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e0a5e9b0b4b1b954a0d2b89a777fbfe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c283cc1eb873ea6d$var$_react = $c283cc1eb873ea6d$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $c283cc1eb873ea6d$var$_baseNew = $c283cc1eb873ea6d$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $c283cc1eb873ea6d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Roadmap".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c283cc1eb873ea6d$var$RoadmapIcon = (props)=>/*#__PURE__*/ $c283cc1eb873ea6d$var$_react.default.createElement($c283cc1eb873ea6d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM3 11a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$c283cc1eb873ea6d$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $c283cc1eb873ea6d$var$_default = module.exports.default = $c283cc1eb873ea6d$var$RoadmapIcon;

});

parcelRegister("j9re6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17ddc348c6f916127485ad6ca25becea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $df13fa2fa8ef1b93$var$_react = $df13fa2fa8ef1b93$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $df13fa2fa8ef1b93$var$_baseNew = $df13fa2fa8ef1b93$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $df13fa2fa8ef1b93$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Send".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sending messages in Rovo Chat.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $df13fa2fa8ef1b93$var$SendIcon = (props)=>/*#__PURE__*/ $df13fa2fa8ef1b93$var$_react.default.createElement($df13fa2fa8ef1b93$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 1.22a.75.75 0 0 1 .173.79l-5 13.5a.75.75 0 0 1-1.361.1l-2.895-5.307L.391 7.408A.75.75 0 0 1 .49 6.047l13.5-5a.75.75 0 0 1 .79.173M7.177 9.884l1.942 3.56 3.237-8.74zm4.118-6.24L2.556 6.881l3.56 1.942z" clip-rule="evenodd"/>`
    }, props));
$df13fa2fa8ef1b93$var$SendIcon.displayName = 'SendIcon';
var $df13fa2fa8ef1b93$var$_default = module.exports.default = $df13fa2fa8ef1b93$var$SendIcon;

});

parcelRegister("2Qv7t", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84298877a5ffec5302189e1356603055>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $212893c4a5d4c950$var$_react = $212893c4a5d4c950$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $212893c4a5d4c950$var$_baseNew = $212893c4a5d4c950$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $212893c4a5d4c950$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $212893c4a5d4c950$var$StarStarredIcon = (props)=>/*#__PURE__*/ $212893c4a5d4c950$var$_react.default.createElement($212893c4a5d4c950$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.655 6.336 8 2.84l1.345 3.497 3.506.27-2.7 2.25.973 3.627L8 10.341l-3.124 2.142.973-3.627-2.7-2.25z"/>`
    }, props));
$212893c4a5d4c950$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $212893c4a5d4c950$var$_default = module.exports.default = $212893c4a5d4c950$var$StarStarredIcon;

});

parcelRegister("37mR0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9875595fe1109f3e22750943d295221a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2453c0e262447c5c$var$_react = $2453c0e262447c5c$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $2453c0e262447c5c$var$_baseNew = $2453c0e262447c5c$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $2453c0e262447c5c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Tasks".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for multiple tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2453c0e262447c5c$var$TasksIcon = (props)=>/*#__PURE__*/ $2453c0e262447c5c$var$_react.default.createElement($2453c0e262447c5c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm6.426 1.517 1.148.966-4 4.75a.75.75 0 0 1-1.148 0l-2-2.375 1.148-.966L6 8.086z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M16 6v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75V6z" clip-rule="evenodd"/>`
    }, props));
$2453c0e262447c5c$var$TasksIcon.displayName = 'TasksIcon';
var $2453c0e262447c5c$var$_default = module.exports.default = $2453c0e262447c5c$var$TasksIcon;

});

parcelRegister("6Ro48", function(module, exports) {
$parcel$export(module.exports, "TemplateKey", function () { return $3bde895dc42da213$export$21f5be7276c6a79d; });
var $3bde895dc42da213$export$21f5be7276c6a79d = /*#__PURE__*/ function(TemplateKey) {
    TemplateKey["SimplifiedBasic"] = "com.pyxis.greenhopper.jira:gh-simplified-basic";
    TemplateKey["Scrum"] = "com.pyxis.greenhopper.jira:gh-simplified-agility-scrum";
    TemplateKey["Kanban"] = "com.pyxis.greenhopper.jira:gh-simplified-agility-kanban";
    TemplateKey["WebDesignProcess"] = "com.atlassian.jira-core-project-templates:jira-work-management-web-design-process";
    TemplateKey["GoToMarket"] = "com.atlassian.jira-core-project-templates:jira-work-management-go-to-market";
    TemplateKey["SimplifiedProcessControl"] = "com.atlassian.jira-core-project-templates:jira-core-simplified-process-control";
    TemplateKey["ProcessControlTeamManaged"] = "com.atlassian.jira-core-project-templates:jira-work-management-process-control-team-managed";
    TemplateKey["SalesPipeline"] = "com.atlassian.jira-core-project-templates:jira-work-management-sales-pipeline";
    TemplateKey["SimplifiedProcurement"] = "com.atlassian.jira-core-project-templates:jira-core-simplified-procurement";
    TemplateKey["EmployeeOnboarding"] = "com.atlassian.jira-core-project-templates:jira-work-management-employee-onboarding";
    TemplateKey["PersonalTaskPlanner"] = "com.atlassian.jira-core-project-templates:jira-work-management-personal-task-planner";
    TemplateKey["CampaignManagement"] = "com.atlassian.jira-core-project-templates:jira-work-management-campaign-management";
    TemplateKey["CampaignManagementTeamManaged"] = "com.atlassian.jira-core-project-templates:jira-work-management-campaign-management-team-managed";
    TemplateKey["CampaignManagementV2TeamManaged"] = "com.atlassian.jira-core-project-templates:jira-work-management-campaign-management-team-managed-v2";
    TemplateKey["Recruitment"] = "com.atlassian.jira-core-project-templates:jira-core-simplified-recruitment";
    TemplateKey["RecruitmentTeamManaged"] = "com.atlassian.jira-core-project-templates:jira-work-management-recruitment-team-managed";
    TemplateKey["LeadTracking"] = "com.atlassian.jira-core-project-templates:jira-core-simplified-lead-tracking";
    TemplateKey["LeadTrackingTeamManaged"] = "com.atlassian.jira-core-project-templates:jira-work-management-lead-tracking-team-managed";
    TemplateKey["MonthEndClose"] = "com.atlassian.jira-core-project-templates:jira-work-management-month-end-close";
    TemplateKey["MonthEndCloseTeamManaged"] = "com.atlassian.jira-core-project-templates:jira-work-management-month-end-close-team-managed";
    return TemplateKey;
}({});

});

parcelRegister("6RoNo", function(module, exports) {
$parcel$export(module.exports, "OrangeModal", function () { return $6ebf3ce23ce1ed11$export$6c8874c44e988ef8; });
$parcel$export(module.exports, "PurpleModal", function () { return $6ebf3ce23ce1ed11$export$fd3dd56b06272778; });
$parcel$export(module.exports, "GreenModal", function () { return $6ebf3ce23ce1ed11$export$4e38f8e127b6b98b; });
$parcel$export(module.exports, "BlueModal", function () { return $6ebf3ce23ce1ed11$export$f4813b8b24b3c6ba; });
$parcel$export(module.exports, "BlackModal", function () { return $6ebf3ce23ce1ed11$export$523a506d2ef0ae23; });

var $7VQPk = parcelRequire("7VQPk");
const $6ebf3ce23ce1ed11$export$6c8874c44e988ef8 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        viewBox: "0 0 757 491",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M356 15.3286L756.5 0.5L743 448H356V15.3286Z",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M43 232.398L388 184V470L52.2992 459.355L43 232.398Z",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M130.234 460.03C140.887 430.441 107.574 463.703 99.1998 468.074C101.862 457.404 108.184 448.371 112.355 438.004C112.058 438.192 112.208 437.45 112.563 436.851C120.461 414.086 92.9297 440.308 88.1073 447.052C88.1175 447.034 88.951 445.758 88.968 445.729C54.5977 481.419 91.7038 430.441 93.3267 414.961C93.0425 402.582 78.5587 419.05 75.0123 422.678C67.3702 430.305 36.8636 466.687 53.9276 435.147L53.7787 435.35L53.798 435.236C51.3589 439.146 41.6341 456.497 53.7788 446C34.7693 461.626 63.4948 417.275 65.9126 411.975C63.5461 418.477 58.9206 424.975 58.1411 427.315C96.3111 357.491 41.5077 423.285 25.4617 434.069C26.1251 429.926 28.5681 425.713 30.3316 422.012C29.4769 423.002 26.3986 430.288 25.4147 431.407C26.3559 427.511 37.0523 408.23 32.3143 418.001C33.277 414.579 57.8915 381.568 41.3467 385.439C27.8528 393.88 19.2388 409.247 5.2045 416.952C2.66538 409.255 33.2703 376.495 16.7724 377.032C9.82032 378.748 -20.7683 410.243 -11.4671 389.347C-7.46621 380.282 -12.1051 388.336 -13.6843 392.136C-13.6164 391.682 -13.531 391.239 -13.4422 390.79C-21.7707 414.823 13.6935 376.748 19.715 378.519C15.8326 392.517 -16.441 440.957 21.5529 406.601C21.3914 406.812 20.3641 408.14 20.2264 408.31C25.0007 406.262 38.054 385.188 44.9353 388.193C45.4657 390.142 39.2729 402.652 42.3922 394.811C0.374836 465.986 33.3582 433.682 67.1895 399.97C66.9974 416.115 42.7024 434.51 46.1091 451.952C64.0492 448.014 73.2351 423.861 89.1359 414.564C89.7026 421.023 82.271 431.164 79.2755 437.904L79.6195 437.485C64.2344 465.324 66.334 474.572 92.1053 446.813C95.2779 444.125 116.437 421.066 109.239 437.488C86.5994 486.04 95.6274 472.501 129.368 450.066C133.416 452.108 122.344 473.745 130.219 460.029L130.234 460.03Z",
                fill: "#101214"
            })
        ]
    });
};
const $6ebf3ce23ce1ed11$export$fd3dd56b06272778 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        viewBox: "0 0 729 447",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M453 6.8593L729 0V325H453V6.8593Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M21 229.336L218 185V447L26.31 437.248L21 229.336Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M28.471 195.058C29.6205 194.959 45.0014 191.246 40.9669 190.44C39.4702 190.859 38.3072 190.436 37.5589 191.57C37.3425 190.233 34.4079 192.367 33.9571 192.448C33.7542 191.435 29.1562 194.041 29.8279 193.1C27.7407 193.127 25.1487 193.856 22.453 194.712C21.1322 193.816 26.7941 187.425 24.4139 188.807C24.5807 188.446 25.2208 186.889 25.1352 187.92C25.888 187.038 34.0833 173.535 30.6754 175.822C28.3763 178.608 26.6498 183.275 24.7024 185.58C22.8091 186.358 21.4973 193.046 19.3876 192.38C18.1569 190.877 14.9834 172.469 12.7295 174.103C13.1216 175.534 12.7655 176.816 13.8609 177.505C12.5221 177.721 14.6588 180.651 14.74 181.101C13.7482 181.29 16.3177 185.899 15.3936 185.224C15.4117 186.525 15.7047 188.028 16.1284 189.626C15.5649 189.198 14.9473 188.221 14.5912 188.077C10.7956 186.543 7.91954 183.014 3.96613 181.101C0.643816 185.327 30.0217 195.99 11.8053 197.583C8.37936 199.815 3.82638 200.157 0.0036926 202.304C-0.325383 206.954 21.4657 194.126 15.1772 201.494C14.199 204.609 12.7475 208.106 10.7415 211.175C9.46124 222.882 20.3478 191.079 19.897 203.213C21.3981 206.112 22.8497 209.605 23.5935 213.201C28.9173 220.996 21.6506 200.374 20.8887 197.453C23.7738 196.224 34.9263 210.158 36.9458 207.962C37.0405 207.651 35.4357 205.927 34.9488 205.743C34.6198 205.909 34.453 206.044 34.2591 205.738C35.2373 204.798 31.8068 203.61 31.4823 203.286C32.2035 202.57 27.4297 200.243 28.5882 200.279C27.6956 199.032 26.3298 197.777 24.7745 196.512C27.5334 195.981 28.7325 194.036 28.48 195.049L28.471 195.058Z",
                fill: "#101214"
            })
        ]
    });
};
const $6ebf3ce23ce1ed11$export$4e38f8e127b6b98b = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        viewBox: "0 0 740 478",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M739.945 477.053L728.47 42.8846L403.714 51.9593L402.956 475.471L739.945 477.053Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M66.2766 21.5979C66.7767 20.978 65.6542 10.1027 63.8098 13.042C63.0037 14.0204 63.013 14.9796 64.0782 15.3669C61.9471 15.5508 64.6106 17.7697 63.8524 18.7063C62.4064 18.268 65.2624 21.3987 63.7729 20.7378C61.3465 32.2642 73.9329 56.5486 67.4076 27.4713C66.5426 30.2678 66.1529 27.5553 66.5698 26.3008C68.3198 28.2426 67.071 22.8154 66.4921 21.7923C66.4105 23.4442 65.2187 20.6369 66.2713 21.6025L66.2766 21.5979Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M46.9395 41.4791C46.9566 39.9576 37.0855 32.9328 36.1601 32.0708C33.8362 30.599 33.3907 34.0732 35.4116 34.7754C35.7436 35.0826 38.6085 36.2619 37.299 36.8864C37.7317 39.8964 42.95 40.6524 43.0937 43.1784C43.8141 42.8232 44.5739 43.7637 45.051 43.5916C44.9167 44.3313 45.8852 44.8118 45.9878 44.6391C48.3432 47.9902 51.6853 44.2447 48.0933 42.2918C48.2618 42.1735 47.6694 41.2644 46.9494 41.4798L46.9395 41.4791Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M24.7401 78.7976C26.3547 80.2709 24.5525 80.0579 23.772 79.3305C25.3978 78.2085 21.8092 77.9733 20.8595 78.3227C21.2268 78.4227 21.2389 79.0726 20.4717 78.9103C21.3013 77.4094 11.5803 75.4721 15.5859 79.54C15.7542 79.5615 16.0603 78.3193 16.184 78.7421C15.5038 80.5878 17.2858 79.5164 17.7456 79.443C17.5533 80.4283 18.1351 79.5794 18.1687 80.006C17.3932 81.2461 20.303 79.438 19.4595 80.6534C21.3263 83.0425 26.2528 81.1126 27.625 83.2332C29.2172 81.2103 35.7726 85.7171 33.7911 81.0187C30.8779 79.5466 28.4464 78.5866 24.7401 78.7976Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M10.3204 53.0348C8.98192 55.9537 15.8356 56.4071 17.4345 57.9592C19.3188 60.1099 41.9669 70.2344 36.895 63.213C30.0144 60.2067 24.9055 56.5376 16.0964 53.9487C14.6967 53.4237 10.5196 50.8717 10.3204 53.0348Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M87.0372 37.8984C89.2159 40.0542 85.6577 42.0527 87.4086 44.0495C90.893 47.1931 96.2939 24.8368 92.1239 24.9014C88.5433 25.4405 88.8059 36.5316 87.0372 37.8984Z",
                fill: "#101214"
            })
        ]
    });
};
const $6ebf3ce23ce1ed11$export$f4813b8b24b3c6ba = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        viewBox: "0 0 748 441",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 203.398L355 155V441L9.56873 430.355L0 203.398Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M748 21.7328C744.748 16.1599 748.569 6.30979 743.319 0.987671C732.702 -2.57202 730.745 18.1313 723.821 20.8202C720.67 15.5886 724.004 7.66819 720.04 2.21372C720.23 2.34607 720.84 3.03576 720.907 3.12632C710.495 -8.79968 707.039 19.2669 699.16 20.9248C695.854 15.1847 701.437 -0.377695 691.295 0.284086C684.899 0.381612 677.549 28.1973 673.856 18.7234L673.843 18.8559L673.795 18.8071C674.154 25.5572 679.825 18.0616 680.841 15.9439C672.156 32.6487 672.637 11.5552 671.749 3.89249C673.484 5.91963 672.766 11.4856 673.355 13.882C673.274 -15.3688 658.525 10.3292 651.791 20.6321C647.014 20.3813 650.476 8.48332 648.356 4.57533C648.478 5.41126 649.277 10.1411 648.491 11.0607C648.281 7.59849 648.471 0.277127 643.315 1.16182C643.844 0.0263465 646.432 1.16182 646.73 1.68428C635.931 -3.6448 634.501 19.002 626.053 20.9874C623.594 15.094 626.71 7.55679 623.269 1.75401C613.262 -9.37785 602.382 37.0094 600.546 14.3626C599.984 9.79281 601.616 1.78879 596 1.00162C596.888 1.53801 598.873 2.98004 598.764 5.22313C598.615 4.98628 598.473 4.74943 598.324 4.52652C599.848 10.4965 597.28 16.8914 599.997 22.5131C607.05 29.4165 614.143 -0.175617 621.29 2.78498C624.231 6.61635 622.124 12.9415 622.869 17.5252C622.815 17.3789 622.544 16.4316 622.496 16.3062C624.454 38.2773 638.261 6.73472 636.913 11.4369C654.264 -16.8177 637.462 39.6566 656.262 21.2173C660.693 17.3929 663.416 2.7153 669.263 4.67278C670.049 12.238 670.435 34.014 681.282 19.9285C685.367 15.2124 686.993 5.18826 693.036 3.79504C696.24 9.70927 690.854 30.3569 703.286 23.6694C703.164 23.7182 703.049 23.7739 702.92 23.8226C707.961 22.0114 713.089 -2.32819 718.374 5.00714C720.413 9.77196 716.572 23.4883 724.43 23.8993C731.307 23.3072 738.339 -6.76563 743.183 6.9019C744.064 10.162 743.671 24.568 747.986 21.7119L748 21.7328Z",
                fill: "#101214"
            })
        ]
    });
};
const $6ebf3ce23ce1ed11$export$523a506d2ef0ae23 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        viewBox: "0 0 721 465",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M359.416 94.2542L274.408 67.7112L9.74577 90.2379L0.164061 457.629L312.003 464.667L359.416 94.2542Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M720.092 34.905C720.117 34.8633 720.117 34.7882 720.168 34.7299C718.688 33.996 718.519 32.1946 717.377 31.1188L717.335 31.0771C716.177 30.7101 716.489 29.5676 715.052 29.5593C715.052 29.5593 715.424 29.3757 715.432 29.3757C713.098 27.0906 707.331 21.478 707.331 21.478C707.204 21.9867 708.253 21.1027 709.31 21.2528C709.31 21.2528 709.386 21.061 709.462 21.2112C712.16 18.6175 715.196 17.625 718.646 16.3908C720.371 15.9321 720.633 11.12 717.682 13.1132C717.648 13.0798 717.572 13.0549 717.538 12.9965C716.506 14.1808 714.79 13.747 713.487 14.3641L713.437 14.3892L711.272 15.4317C710.096 15.907 708.701 16.2824 707.238 16.6493C707.28 16.6076 707.323 16.5659 707.365 16.5242C707.365 16.5242 707.517 14.2141 707.475 13.0715C707.475 13.0715 708.955 11.2368 708.464 9.97753C709.302 8.50139 712.278 5.27381 709.572 4.35644C708.684 4.35644 707.991 3.59755 707.686 5.00697C707.636 4.99863 707.568 5.01529 707.5 4.99027C707.34 6.44973 705.589 7.48388 705.107 8.86828L705.09 8.92671C705.209 10.111 704.279 11.2785 704.27 11.2785C703.83 12.3626 703.255 13.5469 702.646 14.7811C702.393 14.114 702.114 13.5219 701.835 13.0966C700.82 12.0124 701.251 -2.799 697.497 0.470187C697.674 3.26401 698.57 6.17454 697.843 8.65978C697.488 8.8516 698.029 9.84404 698.469 10.653C698.435 11.6788 698.224 12.2292 698.165 13.697C696.304 12.371 688.186 5.65753 688.685 10.1777C689.556 10.6364 690.19 11.1617 690.647 12.2292C691.07 12.6879 694.799 14.7562 694.917 15.2733C694.672 15.9905 699.078 16.5659 697.294 17.0996C697.556 17.6667 697.911 18.2089 698.325 18.7343C696.397 18.9344 694.089 19.4931 692.879 20.2187C692.668 20.5773 684.973 21.061 682.182 22.8374C680.516 23.7631 679.045 24.2218 680.778 25.6146C681.404 25.1142 683.755 25.8314 683.704 25.1725C684.279 25.4061 688.169 23.9382 688.6 24.1884C688.812 24.522 691.873 22.754 691.509 23.588C693.632 24.1801 696.22 23.6963 698.909 23.0208C697.843 24.6888 696.795 27.0656 696.659 28.5417C695.746 30.4349 693.336 34.6215 692.566 37.1902C691.467 39.0583 691.848 39.2083 693.235 40.1674L693.26 40.1925C693.547 40.3843 693.226 40.1924 694.317 40.2341C694.207 40.134 694.046 39.7004 693.835 39.7755C693.979 39.4836 695.636 39.0665 694.943 38.6746C694.917 38.6162 696 37.7989 696.11 36.9149C697.074 33.7625 699.382 32.1696 701.09 28.5751C701.048 28.9504 703.923 36.0142 703.788 39.5336C703.577 41.2682 707.839 43.8536 707.221 39.984C707.272 39.9673 707.314 39.9006 707.39 39.8922C706.705 38.2993 707.61 36.6564 707.255 35.0384L707.238 34.9718C706.469 33.9877 707.357 33.1704 706.139 32.3698C706.139 32.3698 706.553 32.4114 706.562 32.4197C706.02 30.1263 705.682 27.3242 705.175 24.8139C706.993 26.4401 708.591 28.1915 709.251 30.118L709.335 29.9929C709.335 30.0513 709.462 30.0929 709.352 30.2264C710.883 30.5433 711.407 31.1771 712.515 31.6025C712.515 31.6025 713.699 33.7124 715.077 33.7875L717.174 36.7147C718.079 38.2242 722.959 37.3569 720.126 34.9384L720.092 34.905Z",
                fill: "#101214"
            })
        ]
    });
};

});

parcelRegister("b97hj", function(module, exports) {
$parcel$export(module.exports, "ProductModalCarousel", function () { return $67177947439a6edd$export$4bbc33d47571e3e6; });
/* modal-carousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $ggSCt = parcelRequire("ggSCt");

var $eY3N6 = parcelRequire("eY3N6");

var $b2wEL = parcelRequire("b2wEL");
const $67177947439a6edd$var$LeftArrow = ({ onClick: onClick })=>/*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        onClick: onClick,
        className: (0, $2jatx.default)([
            "_kqswstnw _19itglyw _80omtlke _1pbykb7n _bfhk1j28 _152t1ssb _1e0216lh"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "65",
            height: "64",
            viewBox: "0 0 65 64",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M56.6172 32C56.6172 18.6667 45.9505 8 32.6172 8C19.2838 8 8.61718 18.6667 8.61719 32C8.61719 45.3333 19.2839 56 32.6172 56C45.9505 56 56.6172 45.3333 56.6172 32Z",
                    fill: "#101214"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M35.2842 20.2667L39.0176 24.0001L31.0176 32.0001L39.0176 40.0001L35.2842 43.7334L23.5509 32.0001L35.2842 20.2667Z",
                    fill: "white"
                })
            ]
        })
    });
const $67177947439a6edd$var$RightArrow = ({ onClick: onClick })=>/*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        onClick: onClick,
        className: (0, $2jatx.default)([
            "_kqswstnw _19itglyw _80omtlke _1pbykb7n _bfhk1j28 _152t1ssb _rjxp16lh"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "64",
            height: "64",
            viewBox: "0 0 64 64",
            fill: "#none",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M8 32C8 45.3333 18.6667 56 32 56C45.3333 56 56 45.3333 56 32C56 18.6667 45.3333 8 32 8C18.6667 8 8 18.6667 8 32Z",
                    fill: "#101214"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M29.3329 43.7333L25.5996 39.9999L33.5996 31.9999L25.5996 23.9999L29.3329 20.2666L41.0663 31.9999L29.3329 43.7333Z",
                    fill: "white"
                })
            ]
        })
    });
const $67177947439a6edd$var$settings = {
    prevArrow: /*#__PURE__*/ (0, $7VQPk.jsx)($67177947439a6edd$var$LeftArrow, {}),
    nextArrow: /*#__PURE__*/ (0, $7VQPk.jsx)($67177947439a6edd$var$RightArrow, {})
};
const $67177947439a6edd$export$4bbc33d47571e3e6 = ({ children: children })=>{
    const { modalIndex: modalIndex } = (0, $b2wEL.useHeroState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const beforeChange = (currentSlide, nextSlide)=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            attributes: {
                name: 'atlas-55799-carousel-slide-button-clicked',
                section: 'hero-section',
                slide: currentSlide,
                nextSlide: nextSlide
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqsw1n9t _1e02idpf _152tidpf _rjxpidpf _u7coidpf _1e0c1txw _4cvr1h6o _1bah1h6o _11q71sgx _1pbyzo7u _liwcglyw"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_j6fg1txw _19moidpf _1vqqkfja _m8oxidpf _bzd2kfja _3otn1r31 _1d59glyw _r3kx1o36 _1u351txw _6aywidpf _1imc1wqb _1plyidpf _1k001wqb _1xnx1ule _qzmo15vq",
                "_1bsb1w8u"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ggSCt))), {
                ...$67177947439a6edd$var$settings,
                initialSlide: modalIndex,
                beforeChange: beforeChange,
                children: children
            })
        })
    });
};
const $67177947439a6edd$var$modalBackgroundStyles = null;
const $67177947439a6edd$var$sliderParent = null;
// Source https://github.com/kenwheeler/slick/blob/master/slick/slick.css
const $67177947439a6edd$var$slickStyle = null;
const $67177947439a6edd$var$arrowButton = null;
const $67177947439a6edd$var$buttonLeft = null;
const $67177947439a6edd$var$buttonRight = null;

});

parcelRegister("ktT4l", function(module, exports) {
$parcel$export(module.exports, "ProductModalCard", function () { return $9d005f3db5353a9a$export$91f997500fc720d5; });
/* product-modal-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $cNOwN = parcelRequire("cNOwN");

var $lmQGF = parcelRequire("lmQGF");

var $gfjAv = parcelRequire("gfjAv");

var $28AH4 = parcelRequire("28AH4");

var $b2wEL = parcelRequire("b2wEL");
const $9d005f3db5353a9a$export$91f997500fc720d5 = ({ eyebrow: eyebrow, title: title, description: description, iconCollection: iconCollection, image: image, BackgroundImage: BackgroundImage, ctaLink: ctaLink, label: label, personaData: personaData })=>{
    const intl = (0, $8e22h.default)();
    const { closeModal: closeModal } = (0, $b2wEL.useHeroState)();
    const { setAnchorLocalStorage: setAnchorLocalStorage } = (0, $28AH4.useAnchorLocalStorage)();
    const handleClick = ()=>{
        // Set team/persona in local storage for various uses later in funnel
        setAnchorLocalStorage(personaData);
    };
    const buttonText = intl.formatMessage({
        id: 'jira-product-tour.hero-modal-cta-btn.btn-text',
        defaultMessage: 'Get started'
    });
    const iconTitle = intl.formatMessage({
        id: 'jira-product-tour.hero-modal-icon-title.title-text',
        defaultMessage: 'Collaborate with these features'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2rkoqslr _11q71q2x _16qsaa27 _1bahesu3 _1bsb1w8u _4t3i1w8u _1ikw1us8 _6ru51osq _79ty1sxn _1p9vu67f _tnru1vuk _1rfm1w8u"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_16jlkb7n _kqswh2mm _1e0c11p5 _6a6z1h6o _4cvr1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_4t3i1vuk _1bsb1vuk _kqswstnw _1e0c1txw _1bah1h6o _1rfm1vuk _tnru1vuk"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)(BackgroundImage, {})
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                        src: image,
                        alt: "",
                        className: (0, $2jatx.default)([
                            "_c71l1w8u _p12f12it _kqswstnw _1rkb1w8u _123r1w8u"
                        ])
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1bsbr60k _2rkoqslr _bfhku67f _zzrm1osq"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_ca0qidpf _u5f3d6z3 _n3tdidpf _19bvd6z3"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                            onClick: closeModal,
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _1bahesu3 _1bsb1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _bfhk1j28 _19itglyw _1pfh7vkz _80omtlke"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cNOwN))), {
                                size: "medium",
                                label: "Close"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_syaz1x0p _ect41qje _1wybdlk8 _k48p1nn1 _vwz4f6fq _1dyzt94y _1p1dangw _1q511skh _1cqs1crf _1bys7vkz"
                            ]),
                            children: eyebrow
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_syaz1x0p _ect41qje _1wybzwfg _k48p1fw0 _vwz410mc _1pfh14y2 _1cqs1tcg _1bysvpzd"
                            ]),
                            children: title
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1pfh1gkc _1cqs7vkz _1bys1tcg _srwz7vkz"
                            ]),
                            children: description
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_4t3it94y _bfhk1sas _1pfhzwfg",
                                "_liwcglyw"
                            ])
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1pfhzwfg _6rthrdoj _syazr3uz _1wyb7vkz _k48p1nn1 _vwz41tcg _1bsbn8ye",
                                "_liwcglyw"
                            ]),
                            children: iconTitle
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c116y _2lx21bp4 _4cvr1y6m _zulpftgi _81641y44"
                            ]),
                            children: iconCollection.map((icon, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_1bsb1tcg _4t3i1tcg _1e0c1txw _1bah1h6o _4cvr1h6o"
                                            ]),
                                            children: icon.icon
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_syazr3uz _1wybdlk8 _k48p1nn1 _vwz4gktf"
                                            ]),
                                            children: icon.description
                                        })
                                    ]
                                }, index))
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1q51zwfg _1u2q7vkz _xlt17vkz"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gfjAv.default), {
                                intentType: 'button',
                                containerId: 'jira-product-tour-overview-hero-modal-' + personaData.team,
                                productKey: 'jira-software.ondemand',
                                edition: 'free',
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                                    onClick: handleClick,
                                    href: ctaLink,
                                    variant: "primary",
                                    size: "small",
                                    color: "blue",
                                    dataEventProps: {
                                        'data-product-key': 'jira',
                                        'data-event': 'clicked',
                                        'data-event-component': 'button',
                                        'data-event-container': 'heroSection',
                                        'data-label': 'get-started',
                                        'data-label-english': 'Get Started',
                                        'data-track-event': `jira-pt.hero-modal-${label}.get-started`
                                    },
                                    children: buttonText
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const $9d005f3db5353a9a$var$modalStyles = null;
const $9d005f3db5353a9a$var$modalImageStyles = null;
const $9d005f3db5353a9a$var$imageStyles = null;
const $9d005f3db5353a9a$var$backgroundStyles = null;
const $9d005f3db5353a9a$var$modalContentStyles = null;
const $9d005f3db5353a9a$var$textSpaceStyles = null;
const $9d005f3db5353a9a$var$closeModalButtonStyles = null;
const $9d005f3db5353a9a$var$eyebrowStyles = null;
const $9d005f3db5353a9a$var$titleStyles = null;
const $9d005f3db5353a9a$var$descriptionStyles = null;
const $9d005f3db5353a9a$var$seporatorStyles = null;
const $9d005f3db5353a9a$var$iconTitleStyles = null;
const $9d005f3db5353a9a$var$iconDescriptionStyles = null;
const $9d005f3db5353a9a$var$iconContainerStyles = null;
const $9d005f3db5353a9a$var$iconAndTextStyles = null;
const $9d005f3db5353a9a$var$iconStyles = null;
const $9d005f3db5353a9a$var$buttonSpaceStyles = null;
const $9d005f3db5353a9a$var$displayNoneBelowLg = null;

});



parcelRegister("iE2db", function(module, exports) {
$parcel$export(module.exports, "LoggedOutHeader", function () { return $c37ad61dcaa246c6$export$e0bdd3a7befb091b; });
/* logged-out-header.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $4X0dO = parcelRequire("4X0dO");

var $gIKKj = parcelRequire("gIKKj");
const $c37ad61dcaa246c6$export$e0bdd3a7befb091b = ({ subHeading: subHeading, testGWP7617Experiment: testGWP7617Experiment })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const gwp7617Experiment = (0, $gIKKj.useExperiment)((0, $4X0dO.experiments).gwp7617JiraShortTermAiInfusionExperiment);
    const useGWP7617Experiment = testGWP7617Experiment || gwp7617Experiment !== undefined && gwp7617Experiment.type === 'enrolled' && gwp7617Experiment.value === 'test';
    const mainHeading = useGWP7617Experiment ? formatMessage({
        id: 'jira-product-tour.hero-header.header-text-gwp-7617',
        defaultMessage: '<strong>Focus <br></br>on <span>outcomes,</span></strong><br></br> not admin'
    }, {
        strong: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                children: text
            }),
        span: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                children: text
            }),
        br: ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("br", {})
    }) : formatMessage({
        id: 'jira-product-tour.hero-header.header-text',
        defaultMessage: '<strong>Great outcomes</strong> start with <em>Jira</em>'
    }, {
        strong: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                children: text
            }),
        em: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)("em", {
                children: text
            })
    });
    const displayedSubheading = useGWP7617Experiment ? formatMessage({
        id: 'jira-product-tour.hero-header.subheading-text-gwp-7617',
        defaultMessage: 'AI-powered project management that removes the work around work.'
    }) : subHeading;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "logged-out-header",
        className: (0, $2jatx.default)([
            "_1e0c11p5 _p12f1y37 _6a6zv2br _jzgezwfg _1rkbko4j _zzsz1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                className: (0, $2jatx.default)([
                    "_syaz1pfd _1wyb14no _k48p4jg8 _1bsb1osq _vwz41gnr _2h8iglyw _60qa8n31 _1fxr1ule _cq6t4jg8 _a7ooh2mm _143949fr _mnurmgnk _c9e31f51 _1vd9b3bt _h9bzgktf _1x9td439 _odmg12gs _1sphmyb0 _1sbfstnw _vr2wh2mm _15lnbx14 _vvh0mgnk _12ng1f51 _140bb3bt _18ywo7ao _1mt1yjp0 _tedggktf _h3qd1y44 _1yl3stnw _erwr1nu9 _15701ule _flz0ckbl _17q314id _fz891k4y _k5t0yjp0 _xsmr1h6o"
                ]),
                style: {
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                },
                children: mainHeading
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_ect4z4z1 _k48p1nn1 _1wybgktf _vwz41f4h _syaz1pfd _so7d7vkz _19q11ou6 _xsmr1h6o"
                ]),
                style: {
                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                },
                children: displayedSubheading
            })
        ]
    });
};
const $c37ad61dcaa246c6$var$sectionStyles = null;
const $c37ad61dcaa246c6$var$subheadingStyles = null;
const $c37ad61dcaa246c6$var$mainHeadingStyles = null;

});

parcelRegister("dmP4q", function(module, exports) {
$parcel$export(module.exports, "LoggedOutJiraProductTourAccountCreation", function () { return $1e25437fc90af75b$export$f1c46015a9dcb031; });

var $7VQPk = parcelRequire("7VQPk");

var $6KUQg = parcelRequire("6KUQg");

var $32ARy = parcelRequire("32ARy");
const $1e25437fc90af75b$export$f1c46015a9dcb031 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6KUQg.AccountCreation), {
        Login: null,
        Social: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $32ARy.Social), {
            providers: {
                google: 'Google'
            }
        })
    });
};

});


parcelRegister("1i0Tw", function(module, exports) {
$parcel$export(module.exports, "NoJiraHeroSection", function () { return $5f71690abca8e56f$export$68338f1ab5428abb; });
/* no-jira-hero-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $6V1n4 = parcelRequire("6V1n4");

var $7chqp = parcelRequire("7chqp");

var $6Sktx = parcelRequire("6Sktx");

var $bQjAr = parcelRequire("bQjAr");
const $5f71690abca8e56f$export$68338f1ab5428abb = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $bQjAr.default), {
        name: "logged-out-no-jira-product-tour-hero",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_bfhk1hxd _1bsb1osq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6Sktx.Header), {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7chqp.HeroCards), {})
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6V1n4.LogoBanner), {})
        ]
    });
};
$5f71690abca8e56f$export$68338f1ab5428abb.displayName = 'NoJiraHeroSection';
const $5f71690abca8e56f$var$heroStyles = null;

});
parcelRegister("6Sktx", function(module, exports) {
$parcel$export(module.exports, "Header", function () { return $32314b1200b84dcf$export$8b251419efc915eb; });
/* header.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $20OkY = parcelRequire("20OkY");

var $lmQGF = parcelRequire("lmQGF");

var $asbmK = parcelRequire("asbmK");

var $gfjAv = parcelRequire("gfjAv");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");
const $32314b1200b84dcf$export$8b251419efc915eb = ()=>{
    const { openCrossFlow: openCrossFlow } = (0, $asbmK.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).JIRA_SOFTWARE,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: '/try/cloud/signup?bundle=jira-software'
    });
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const subHeading = formatMessage({
        id: 'jira-product-tour.hero-header.sub-header-text',
        defaultMessage: 'The only project management tool you need to plan and track work across every team.'
    });
    const buttonText = formatMessage({
        id: 'jira-product-tour.hero-header.button-text',
        defaultMessage: 'Get Jira free'
    });
    const mainHeading = formatMessage({
        id: 'jira-product-tour.hero-header.header-text',
        defaultMessage: '<strong>Great outcomes</strong> start with <em>Jira</em>'
    }, {
        strong: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                className: (0, $2jatx.default)([
                    "_k48p8n31 _1e0c1ule _181n1nu9"
                ]),
                children: text
            }),
        em: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)("em", {
                className: (0, $2jatx.default)([
                    "_zg8l4jg8 _kqswh2mm _3p6m49fr _1v5vmgnk _19h91f51 _aetrb3bt _1qdggktf _1gufd439 _1czd12gs _g0nfmyb0 _18postnw _14tt14id _1ruvyjp0"
                ]),
                children: text
            })
    });
    const handleClick = (e)=>{
        if (openCrossFlow) openCrossFlow(e);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _6a6z1h6o _1q51vbgk _jzgezwfg"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                className: (0, $2jatx.default)([
                    "_syaz1pfd _1wyb14no _k48p4jg8 _vwz41gnr _19pkidpf _2hwx1crf _otyr1crf _18u01crf _y3gn1h6o _flz0ckbl _fz891k4y"
                ]),
                style: {
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                },
                children: mainHeading
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_ect4z4z1 _k48p1nn1 _1wybgktf _vwz41f4h _y3gn1h6o _syaz1pfd _ca0qidpf _u5f39by0 _n3td1ylp _19bv9by0 _so7d7vkz _19q11ou6 _tl28idpf _axwix19p _1hwc1ylp _sp8tx19p"
                ]),
                style: {
                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                },
                children: subHeading
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gfjAv.default), {
                intentType: "button",
                containerId: "heroSection",
                productKey: "jira-software.ondemand",
                edition: "free",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                    onClick: handleClick,
                    href: (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=jira-software'),
                    variant: "primary",
                    size: "large",
                    color: "blue",
                    dataEventProps: {
                        'data-product-key': 'jira',
                        'data-event': 'clicked',
                        'data-event-component': 'button',
                        'data-event-container': 'heroSection',
                        'data-label': 'get-jira-free',
                        'data-label-english': 'Get Jira Free',
                        'data-track-event': 'jira-pt.hero-cta.get-jira-free'
                    },
                    children: buttonText
                })
            })
        ]
    });
};
const $32314b1200b84dcf$var$sectionStyles = null;
const $32314b1200b84dcf$var$subheadingStyles = null;
const $32314b1200b84dcf$var$mainHeadingStyles = null;
const $32314b1200b84dcf$var$mainHeadingStrongStyles = null;
const $32314b1200b84dcf$var$mainHeadingEmStyles = null;

});


parcelRegister("6PlQY", function(module, exports) {
$parcel$export(module.exports, "TestimonialSection", function () { return $f83d961845a629ac$export$1b0efcc7c1027c88; });
/* testimonial.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $9MZ6h = parcelRequire("9MZ6h");

var $AR1pQ = parcelRequire("AR1pQ");
const $f83d961845a629ac$export$f756e64b0cdd0c57 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_mezj1u1b _bna710mc _1egfglyw"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
            image: {
                src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3t76qr31nd0pyj71cs0562wxs6agxl02.webp',
                alt: ''
            }
        })
    });
};
const $f83d961845a629ac$export$1b0efcc7c1027c88 = ()=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const useGWP7617Gate = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7617JiraShortTermAiInfusionGate);
    const handleClick = ()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            attributes: {
                name: 'atlas-55799-testimonial-button-clicked',
                section: 'testimonial-section'
            }
        }).fire();
    };
    const header = intl.formatMessage({
        id: 'jira-product-tour.testimonial-section.header-text',
        defaultMessage: 'For teams big & small'
    });
    const subtitle = intl.formatMessage({
        id: 'jira-product-tour.testimonial-section.subtitle-text',
        defaultMessage: 'Hear from start-ups & large enterprises that prefer Atlassian'
    });
    const ctaTextOld = intl.formatMessage({
        id: 'jira-product-tour.testimonial-section.cta-text',
        defaultMessage: 'See more customer stories'
    });
    const ctaTextAi = intl.formatMessage({
        id: 'jira-product-tour.testimonial-section.cta-text-ai',
        defaultMessage: 'See how Roblox boosts collaboration with AI'
    });
    const ctaText = useGWP7617Gate ? ctaTextAi : ctaTextOld;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_mkrz16pp _11q71pfd _1e0c1txw _4cvr1h6o _1bah1h6o _ca0q19bv _u5f3idpf _n3td53f4 _19bvidpf _2tde53f4 _1a87idpf _uwpc53f4 _3r7oidpf _1kmx19bv _1ggmidpf _1ykzuuw1 _1maeidpf"
        ]),
        style: {
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm _1e0c1txw _4cvr1y6m _a64k1w81 _79ty1bp4 _1np61h6o _1yytidpf"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _4cvr1y6m _zulp19bv"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)($f83d961845a629ac$export$f756e64b0cdd0c57, {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_liwc1txw _79ty1bp4 _105s1h6o _1rkb1i94 _1kmxidpf _1ggm10yn _1ykzidpf _1mae10yn"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1i7q1ogy _liwc1txw _79ty1bp4 _m80d1h6o _1yyt10yn _1p1d8vuz _1rkbjwe6"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                        className: (0, $2jatx.default)([
                                            "_syaz1afi _ect41vau _k48p1fw0 _vwz44jg8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _fz891ylp _1ol9ckbl _flz0ckbl _1lzo1ylp _1cqs1ul9"
                                        ]),
                                        style: {
                                            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                                            "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                                        },
                                        children: header
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1pfh1y44 _syaz1w7g _ect4z4z1 _1wyb7vkz _k48p1nn1 _vwz41tcg"
                                        ]),
                                        style: {
                                            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400')),
                                            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                                        },
                                        children: subtitle
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1pfhzwfg _1rwyidpf"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                                            href: (0, $jQ0cd.useLocalizedHref)('/customers/roblox'),
                                            onClick: handleClick,
                                            className: (0, $2jatx.default)([
                                                "_syaz17i2"
                                            ]),
                                            style: {
                                                "--_xvz68f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue400'))
                                            },
                                            children: [
                                                ctaText,
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9MZ6h.ArrowRight), {})
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $AR1pQ.TestimonialCard), {
                    image: "https://dam-cdn.atl.orangelogic.com/AssetLink/thb1c563p4m28u32ri7fe867jx24dxpl.webp",
                    quote: intl.formatMessage({
                        id: 'jira-product-tour.testimonial-section.quote-text',
                        defaultMessage: 'Before, our team saw Atlassian as individual tools...Now, [features & integrations] like Jira macros & Smart Links have really been pivotal in collaboration, productivity, & discoverability.'
                    }),
                    name: intl.formatMessage({
                        id: 'jira-product-tour.testimonial-section.name-text',
                        defaultMessage: 'Joe Cotant'
                    }),
                    title: intl.formatMessage({
                        id: 'jira-product-tour.testimonial-section.job-title-text',
                        defaultMessage: 'Senior Technical Program Manager, Roblox'
                    })
                })
            ]
        })
    });
};
$f83d961845a629ac$export$1b0efcc7c1027c88.displayName = 'TestimonialSection';
const $f83d961845a629ac$var$sectionContainer = null;
const $f83d961845a629ac$var$testimonialContainer = null;
const $f83d961845a629ac$var$testimonialContentContainer = null;
const $f83d961845a629ac$var$leftContainer = null;
const $f83d961845a629ac$var$contentStyles = null;
const $f83d961845a629ac$var$headingStyles = null;
const $f83d961845a629ac$var$subtitleStyles = null;
const $f83d961845a629ac$var$linkStyles = null;
const $f83d961845a629ac$var$anchorStyles = null;
const $f83d961845a629ac$var$starStyles = null;

});
parcelRegister("9MZ6h", function(module, exports) {
$parcel$export(module.exports, "ArrowRight", function () { return $3c710196451a00e5$export$acad20503ad73ac1; });

var $7VQPk = parcelRequire("7VQPk");
const $3c710196451a00e5$export$acad20503ad73ac1 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        "aria-hidden": "true",
        width: "11",
        height: "8",
        viewBox: "0 0 11 8",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.40796 0L6.32831 1.2021L8.07854 3.1497H0.763182C0.341906 3.1497 0 3.53038 0 3.99943C0 4.46849 0.341906 4.84917 0.763182 4.84917H8.07854L6.32831 6.7979L7.40796 8L11 3.99943L7.40796 0Z"
        })
    });

});

parcelRegister("AR1pQ", function(module, exports) {
$parcel$export(module.exports, "TestimonialCard", function () { return $755c5031f1e223bd$export$a34a40ba0fc7f13f; });
/* testimonial-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $hnmMQ = parcelRequire("hnmMQ");
const $755c5031f1e223bd$export$e4a9ef29ffd77837 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswstnw _1bsb9by0 _rjxp4l2f _152t1vmu _1mjbglyw"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
            image: {
                src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8egyb3e0hgar3nj26we824nso1lfh124.webp',
                alt: '',
                width: 78,
                height: 47
            }
        })
    });
};
const $755c5031f1e223bd$export$8c97d8ed71074b34 = ({ image: image })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_ahbq1hnc _1pfh1hnc _mezj1w6l _bna75k64"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
            image: {
                src: image,
                alt: '',
                width: 255,
                height: 238
            }
        })
    });
};
const $755c5031f1e223bd$export$a34a40ba0fc7f13f = ({ image: image, quote: quote, name: name, title: title })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($755c5031f1e223bd$export$e4a9ef29ffd77837, {}),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _syazr3uz _p12f1kqb _85i510yn _bfhku67f _2rko1uj0 _1gde1bp4 _1rkbjwe6"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)($755c5031f1e223bd$export$8c97d8ed71074b34, {
                        image: image
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1bsb17ek _ahbq16gx _1qoxo7ao _suga1txw _1gde1bp4 _nssp1h6o _chtu1ou6 _v7361ou6"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                className: (0, $2jatx.default)([
                                    "_1wyb1k92 _syaz1yn5 _ect41td8 _1rkbncxg _q5ug1pa9 _7tld182x _14adidpf _4uroidpf _1cqsgktf _1bys1f4h _18ghnl7k _chtu1ou6",
                                    "quote"
                                ]),
                                children: [
                                    "\u201C",
                                    quote,
                                    "\u201D"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("hr", {
                                className: (0, $2jatx.default)([
                                    "_1bsb19n7 _4t3it94y _syaz9sh9 _19pk7vkz _2hwxidpf _otyridpf _18u0idpf _1rfmajfg"
                                ])
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_1wybqgp8 _k48pni7l _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "name"
                                ]),
                                children: name
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wybgktf _ui901hgu _62c41qje _1jw81nn1 _1bys1tcg _1rkb1rr2",
                                    "title"
                                ]),
                                children: title
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $755c5031f1e223bd$var$cardContainerStyles = null;
const $755c5031f1e223bd$var$testimonialQuoteImageStyles = null;
const $755c5031f1e223bd$var$testimonialQuotesSectionStyles = null;
const $755c5031f1e223bd$var$customerImagePictureStyles = null;
const $755c5031f1e223bd$var$quoteContainerStyles = null;
const $755c5031f1e223bd$var$quoteStyles = null;
const $755c5031f1e223bd$var$hrContainerStyles = null;
const $755c5031f1e223bd$var$nameStyles = null;
const $755c5031f1e223bd$var$titleStyles = null;

});




parcelRegister("3jSW5", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePagePaidLpJswAgile", function () { return $1069cb10173098de$export$914726d7f0b742d9; });

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");

var $k6PTJ = parcelRequire("k6PTJ");

var $17vRh = parcelRequire("17vRh");
const $1069cb10173098de$export$914726d7f0b742d9 = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $17vRh.JiraSoftwarePagePaidLpJswAnchor), {
        ...pageProps,
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsw-agile",
        persona: "unknown",
        pageVariant: "agile"
    });
};

});

parcelRegister("2LlD0", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePagePaidLpJswAutomation", function () { return $3ca8e0bedf5416b4$export$ed27212f6342eeed; });

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");

var $k6PTJ = parcelRequire("k6PTJ");

var $17vRh = parcelRequire("17vRh");
const $3ca8e0bedf5416b4$export$ed27212f6342eeed = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $17vRh.JiraSoftwarePagePaidLpJswAnchor), {
        ...pageProps,
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsw-automation",
        persona: "unknown",
        pageVariant: "automation"
    });
};

});

parcelRegister("faUzl", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePagePaidLpJswCompetitors", function () { return $09acfa39dba39643$export$68f655f873e2ac04; });

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");

var $k6PTJ = parcelRequire("k6PTJ");

var $17vRh = parcelRequire("17vRh");
const $09acfa39dba39643$export$68f655f873e2ac04 = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $17vRh.JiraSoftwarePagePaidLpJswAnchor), {
        ...pageProps,
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsw-competitors",
        persona: "unknown",
        pageVariant: "competitors"
    });
};

});

parcelRegister("7btsq", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePagePaidLpJswFeatures", function () { return $d1221b05e912c95d$export$6ab6d2db3208c01b; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $2WL8B = parcelRequire("2WL8B");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $iRMRa = parcelRequire("iRMRa");

var $k16ze = parcelRequire("k16ze");

var $leg8m = parcelRequire("leg8m");

var $I9wqw = parcelRequire("I9wqw");

var $kZQhV = parcelRequire("kZQhV");

var $3oD33 = parcelRequire("3oD33");

var $3LcIp = parcelRequire("3LcIp");

var $l7lLR = parcelRequire("l7lLR");

var $izdHQ = parcelRequire("izdHQ");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
const $d1221b05e912c95d$export$6ab6d2db3208c01b = ({ keyword: keyword })=>{
    const intl = (0, $8e22h.default)();
    const productHref = (0, $jQ0cd.useLocalizedHref)('/software/jira');
    const loggedInHasJira = (0, $2WL8B.useLoggedInHasJira)();
    const ctaButtonPropsHref = (0, $jQ0cd.useLocalizedHref)('#start-trial');
    const pageId = 'paid-lp-jsw-features';
    const paidLoggedOutHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $I9wqw.PaidTeamSelectionHeroSection), {
        keyword: keyword
    });
    const gwp9473JSWAnchorUpdates = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp9473JSWAnchorUpdates);
    const props = {
        hideNavigationBar: false,
        customHeroSection: paidLoggedOutHeroSection,
        landingType: 'jira-software',
        pageId: pageId,
        productNavProps: {
            productHref: productHref,
            productName: 'jira',
            ariaLabel: intl.formatMessage({
                id: 'wacJiraSoftwareNavigation.logo-label',
                defaultMessage: 'Jira Software logo'
            }),
            dataProductKey: 'jiraSoftware',
            showFreeHrefButton: false,
            logoLinkWrapperWidth: 'auto'
        },
        heroProps: {
            headerText: intl.formatMessage({
                id: 'JiraSoftwarePagePaidLpJswFeatures.hero.header',
                defaultMessage: 'Connect every team, task, and project together with Jira'
            }),
            secondaryText: intl.formatMessage({
                id: 'JiraSoftwarePagePaidLpJswFeatures.hero.body',
                defaultMessage: 'Trusted by 100K+ teams that plan, track, release, and manage world-class software.'
            }),
            tertiaryText: intl.formatMessage({
                id: 'JiraSoftwarePagePaidLpJswFeatures.heroListHeading',
                defaultMessage: 'INCLUDED IN YOUR FREE PLAN: Forever free for up to 10 users'
            }),
            image: {
                src: (0, $k16ze.getLocalizedImage)('hero', intl.locale),
                alt: intl.formatMessage({
                    id: 'JiraSoftwarePagePaidLpJswFeatures.heroImageAlt',
                    defaultMessage: 'Screen capture of a Jira backlog'
                }),
                width: 1134,
                height: 620
            },
            signup: {
                bundle: 'jira-software',
                edition: 'free',
                featureFlags: {
                    enableDefaultExpandedEmail: false,
                    enableDeferredFullName: true
                }
            }
        },
        tabsProps: {
            dataProductKey: 'jiraSoftware-PaidLpJiraFeatures',
            headerText: gwp9473JSWAnchorUpdates ? intl.formatMessage({
                id: 'JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.heading',
                defaultMessage: 'Discover AI features that power your teams'
            }) : intl.formatMessage({
                id: 'JiraSoftwarePagePaidLpJswFeatures.tabs.heading',
                defaultMessage: 'Discover the features that make Jira so easy to use'
            }),
            tabStyles: {
                defaultBG: (0, $kbpa7.wacToken)('color.neutral.light0'),
                defaultText: (0, $kbpa7.wacToken)('color.extended.blue1000'),
                hoverBG: (0, $kbpa7.wacToken)('color.neutral.light0'),
                hoverText: (0, $kbpa7.wacToken)('color.extended.blue1000'),
                activeBG: (0, $kbpa7.wacToken)('color.extended.blue200'),
                activeText: (0, $kbpa7.wacToken)('color.extended.blue1000')
            },
            styles: {
                '--lp-tabs-hover': (0, $kbpa7.wacToken)('color.extended.blue200'),
                '--lp-tabs-unselected': (0, $kbpa7.wacToken)('color.neutral.light700')
            },
            tabs: gwp9473JSWAnchorUpdates ? [
                {
                    textLabel: intl.formatMessage({
                        id: 'JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab1.textLabel',
                        defaultMessage: 'Plan'
                    }),
                    id: 'plan',
                    component: $d1221b05e912c95d$export$814cc77def5a44df()
                },
                {
                    textLabel: intl.formatMessage({
                        id: 'JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab2.textLabel',
                        defaultMessage: 'Track'
                    }),
                    id: 'track',
                    component: $d1221b05e912c95d$export$13921ac0cc260818()
                },
                {
                    textLabel: intl.formatMessage({
                        id: 'JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab3.textLabel',
                        defaultMessage: 'Collaborate'
                    }),
                    id: 'collaborate',
                    component: $d1221b05e912c95d$export$3141e70acdd1cdb7()
                },
                {
                    textLabel: intl.formatMessage({
                        id: 'JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab4.textLabel',
                        defaultMessage: 'Report'
                    }),
                    id: 'report',
                    component: $d1221b05e912c95d$export$33aa3110c4070c17()
                }
            ] : [
                {
                    textLabel: intl.formatMessage({
                        id: 'JiraSoftwarePagePaidLpJswFeatures.tabs.tab1.textLabel',
                        defaultMessage: 'Boards'
                    }),
                    id: 'boards',
                    component: $d1221b05e912c95d$var$Boards()
                },
                {
                    textLabel: intl.formatMessage({
                        id: 'JiraSoftwarePagePaidLpJswFeatures.tabs.tab2.textLabel',
                        defaultMessage: 'Timeline'
                    }),
                    id: 'timeline',
                    component: $d1221b05e912c95d$var$Timeline()
                },
                {
                    textLabel: intl.formatMessage({
                        id: 'JiraSoftwarePagePaidLpJswFeatures.tabs.tab3.textLabel',
                        defaultMessage: 'Reports'
                    }),
                    id: 'reports',
                    component: $d1221b05e912c95d$var$Reports()
                },
                {
                    textLabel: intl.formatMessage({
                        id: 'JiraSoftwarePagePaidLpJswFeatures.tabs.tab4.textLabel',
                        defaultMessage: 'Automation'
                    }),
                    id: 'automation',
                    component: $d1221b05e912c95d$var$Automation()
                }
            ]
        },
        ctaProps: {
            headerText: intl.formatMessage({
                id: 'JiraSoftwarePagePaidLpJswFeatures.ctaSection.header',
                defaultMessage: 'Move fast, stay aligned, and build better - together'
            }),
            ctaProps: {
                buttonProps: {
                    color: 'yellow',
                    url: ctaButtonPropsHref,
                    text: intl.formatMessage({
                        id: 'JiraSoftwarePagePaidLpJswFeatures.ctaSection.button',
                        defaultMessage: 'Get it free'
                    }),
                    dataEventProps: {
                        'data-event': 'clicked',
                        'data-event-container': 'ctaSection',
                        'data-event-component': 'linkButton',
                        'data-product-key': 'jiraSoftware-PaidLpJiraFeatures'
                    }
                }
            },
            backgroundProperties: {
                textColor: (0, $kbpa7.wacToken)('color.neutral.light0')
            }
        },
        testimonialProps: {
            headerText: intl.formatMessage({
                id: 'JiraSoftwarePagePaidLpJswFeatures.socialProof.heading',
                defaultMessage: 'Trusted by over 100,000 customers world-wide'
            }),
            logos: [
                {
                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/5382nib232306760cxko3fu33yr03hc6.svg',
                    alt: intl.formatMessage({
                        id: 'JiraSoftwarePagePaidLpJswFeatures.socialProof.squareAlt',
                        defaultMessage: 'Square logo'
                    }),
                    loading: 'lazy',
                    width: 162,
                    height: 40
                },
                {
                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8sh6x4kh58c7576am3gc70215abr77gu.svg',
                    alt: intl.formatMessage({
                        id: 'JiraSoftwarePagePaidLpJswFeatures.socialProof.ebayAlt',
                        defaultMessage: 'eBay logo'
                    }),
                    loading: 'lazy',
                    width: 99,
                    height: 41
                },
                {
                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7l40fo7ky3ck1752eh0ti31556343388.svg',
                    alt: intl.formatMessage({
                        id: 'JiraSoftwarePagePaidLpJswFeatures.socialProof.spotifyAlt',
                        defaultMessage: 'Spotify logo'
                    }),
                    loading: 'lazy',
                    width: 163,
                    height: 49
                },
                {
                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0atd5rxku6yg42wfhx0b1jdrsusm532i.svg',
                    alt: intl.formatMessage({
                        id: 'JiraSoftwarePagePaidLpJswFeatures.socialProof.ciscoAlt',
                        defaultMessage: 'Cisco logo'
                    }),
                    loading: 'lazy',
                    width: 92,
                    height: 49
                }
            ]
        },
        alternatingTextAndImageProps: {
            backgroundImage: `linear-gradient(225deg, ${(0, $kbpa7.wacToken)('color.extended.blue200')} 0%, ${(0, $kbpa7.wacToken)('color.neutral.light0')} 100%)`,
            horizontalRuleColor: (0, $kbpa7.wacToken)('color.extended.blue200'),
            imageWidth: '100%',
            imageTextSideRowOnePaddingBelowLargeScreen: '32px 0 16px',
            imageTextSideRowTwoPadding: '16px 0',
            imageTextSideRowThreePaddingBelowLargeScreen: '16px 0 32px',
            //Row 1
            rowOneHeader: intl.formatMessage({
                id: 'JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowOneHeader',
                defaultMessage: "Customize how your team\u2019s work flows"
            }),
            rowOneBody: intl.formatMessage({
                id: 'JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowOneBody',
                defaultMessage: 'Set up, clean up, and automate even the most complicated project workflows.'
            }),
            rowOneImageLink: (0, $k16ze.getLocalizedImage)('row one', intl.locale),
            rowOneImageAltText: intl.formatMessage({
                id: 'JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowOneImageAltText',
                defaultMessage: 'Jira boards'
            }),
            //Row 2
            rowTwoHeader: intl.formatMessage({
                id: 'JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.secondTextHeader',
                defaultMessage: "Stay on track \u2013 even when the track changes"
            }),
            rowTwoBody: intl.formatMessage({
                id: 'JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.secondTextBody',
                defaultMessage: 'Use the timeline view to map out the big picture, communicate updates to stakeholders, and ensure your team stays on the same page.'
            }),
            rowTwoImageLink: (0, $k16ze.getLocalizedImage)('row two', intl.locale),
            rowTwoImageAltText: intl.formatMessage({
                id: 'JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowTwoImageAltText',
                defaultMessage: 'Jira timeline view.'
            }),
            //Row 3
            rowThreeHeader: intl.formatMessage({
                id: 'JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowThreeHeader',
                defaultMessage: 'Bye-bye, spreadsheets'
            }),
            rowThreeBody: intl.formatMessage({
                id: 'JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowThreeBody',
                defaultMessage: 'Keep every detail of a project centralized in real time so up-to-date info can flow freely across people, teams, and tools.'
            }),
            rowThreeImageLink: (0, $k16ze.getLocalizedImage)('row three', intl.locale),
            rowThreeImageAltText: intl.formatMessage({
                id: 'JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowThreeImageAltText',
                defaultMessage: 'Spreadsheets'
            })
        }
    };
    return loggedInHasJira ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
        experimentKey: "jfind-1504-after-d7-get-users-back-to-product",
        group: "Test",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
            experimentKey: "jfind-get-d1to6-users-back-to-product-for-paid",
            group: "variant",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
                experimentKey: "jfind-981-paid-jpto-logged-in-redesign",
                group: "Test",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3oD33.PaidLoggedInJiraProductTourOverview), {})
            })
        })
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3LcIp.BanditsProvider), {
        product: (0, $l7lLR.BANDITS_PRODUCT).JIRA,
        isExperimentEnabled: false,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kZQhV.PaidLandingTemplate), {
            ...props
        })
    });
};
/* Tabs */ const $d1221b05e912c95d$var$Boards = ()=>{
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: 'JiraSoftwarePagePaidLpJswFeatures.tabs.tab1.heading',
        defaultMessage: 'Powerful agile boards'
    });
    const listItems = [
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab1.item1",
            values: (0, $iRMRa.DEFAULT_VALUES),
            defaultMessage: "<strong>Scrum boards:</strong> Scrum boards help agile teams break large, complex projects into manageable pieces of work so focused teams ship faster."
        }, "tabs.tab1.item1"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab1.item2",
            values: (0, $iRMRa.DEFAULT_VALUES),
            defaultMessage: "<strong>Kanban boards:</strong> Agile and DevOps teams can use flexible kanban boards to visualize workflows, limit work-in-progress, and maximize efficiency as a team. Templates make it easy to get started quickly and customize as you go."
        }, "tabs.tab1.item2"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab1.item3",
            values: (0, $iRMRa.DEFAULT_VALUES),
            defaultMessage: "<strong>Choose your own adventure:</strong> Jira is flexible enough to mold to your team\u2019s own unique way of working, whether it is Scrum, Kanban, or something in between."
        }, "tabs.tab1.item3")
    ];
    const imageSrc = (0, $k16ze.getLocalizedImage)('boards', intl.locale);
    const imageAlt = intl.formatMessage({
        id: 'JiraSoftwarePagePaidLpJswFeatures.tabs.tab1.imageAlt',
        defaultMessage: 'Jira boards'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $leg8m.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};
const $d1221b05e912c95d$var$Timeline = ()=>{
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: 'JiraSoftwarePagePaidLpJswFeatures.tabs.tab2.heading',
        defaultMessage: 'Timeline'
    });
    const listItems = [
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab2.item1",
            values: (0, $iRMRa.DEFAULT_VALUES),
            defaultMessage: "<strong>Keep teams aligned:</strong> Give your team the visibility they need to make fast and informed decisions while staying aligned with the bigger goals."
        }, "tabs.tab2.item1"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab2.item2",
            values: (0, $iRMRa.DEFAULT_VALUES),
            defaultMessage: "<strong>Track the big picture:</strong> Plan and track how you\u2019re making progress on the big picture for a single team."
        }, "tabs.tab2.item2"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab2.item3",
            values: (0, $iRMRa.DEFAULT_VALUES),
            defaultMessage: "<strong>Get ahead of dependencies:</strong> Visualize dependencies within your team to account for them when making plans."
        }, "tabs.tab2.item3"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab2.item4",
            values: (0, $iRMRa.DEFAULT_VALUES),
            defaultMessage: "<strong>Plan with team capacity in mind (Premium only):</strong> Ensure your teams have bandwidth to complete the work they\u2019ve scoped. See multiple teams' capacity on a sprint-by-sprint basis."
        }, "tabs.tab2.item4")
    ];
    const imageSrc = (0, $k16ze.getLocalizedImage)('timeline', intl.locale);
    const imageAlt = intl.formatMessage({
        id: 'JiraSoftwarePagePaidLpJswFeatures.tabs.tab2.imageAlt',
        defaultMessage: 'Jira timeline'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $leg8m.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};
const $d1221b05e912c95d$var$Reports = ()=>{
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: 'JiraSoftwarePagePaidLpJswFeatures.tabs.tab3.heading',
        defaultMessage: 'Reports and insights'
    });
    const listItems = [
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab3.item1",
            values: (0, $iRMRa.DEFAULT_VALUES),
            defaultMessage: "<strong>Ready to go reporting:</strong> Out-of-the-box reports and dashboards in Jira offer critical insights within the context of your work to ensure your teams are always up to date and set up for success."
        }, "tabs.tab3.item1"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab3.item2",
            values: (0, $iRMRa.DEFAULT_VALUES),
            defaultMessage: "<strong>Sprint reporting:</strong> Determine where your team is overcommitted to reduce excessive scope creep and better understand completed work in each sprint."
        }, "tabs.tab3.item2"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab3.item3",
            values: (0, $iRMRa.DEFAULT_VALUES),
            defaultMessage: "<strong>Burndown chart:</strong> Track work towards sprint goals to manage progress and respond accordingly."
        }, "tabs.tab3.item3"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab3.item4",
            values: (0, $iRMRa.DEFAULT_VALUES),
            defaultMessage: "<strong>Release Burndown:</strong> Track and monitor the projected release date for versions and take action if work is falling behind schedule."
        }, "tabs.tab3.item4")
    ];
    const imageSrc = (0, $k16ze.getLocalizedImage)('reports', intl.locale);
    const imageAlt = intl.formatMessage({
        id: 'JiraSoftwarePagePaidLpJswFeatures.tabs.tab3.imageAlt',
        defaultMessage: 'Jira reports'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $leg8m.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};
const $d1221b05e912c95d$var$Automation = ()=>{
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: 'JiraSoftwarePagePaidLpJswFeatures.tabs.tab4.heading',
        defaultMessage: 'Automation'
    });
    const listItems = [
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab4.item1",
            values: (0, $iRMRa.DEFAULT_VALUES),
            defaultMessage: "<strong>Drag and drop automation:</strong> Focus on the important things. Let automation do the rest. Powerful, yet simple - Jira automation is actually fun to use."
        }, "tabs.tab4.item1"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab4.item2",
            values: (0, $iRMRa.DEFAULT_VALUES),
            defaultMessage: "<strong>Auto-assign issues:</strong> When an issue is raised without an assignee, auto-assign to whoever created it so nothing falls through the cracks."
        }, "tabs.tab4.item2"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab4.item3",
            values: (0, $iRMRa.DEFAULT_VALUES),
            defaultMessage: "<strong>Sync work:</strong> When an epic is marked as 'done' move all of its stories to 'done' also."
        }, "tabs.tab4.item3"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab4.item4",
            values: (0, $iRMRa.DEFAULT_VALUES),
            defaultMessage: "<strong>Daily Slack summary:</strong> Send a daily Slack message with a list of issues still open in the Sprint."
        }, "tabs.tab4.item4"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab4.item5",
            values: (0, $iRMRa.DEFAULT_VALUES),
            defaultMessage: "<strong>Auto-close old support issues:</strong> If a customer has not responded to an issue in 5 days, close the issue and leave a comment."
        }, "tabs.tab4.item5")
    ];
    const imageSrc = (0, $k16ze.getLocalizedImage)('automation', intl.locale);
    const imageAlt = intl.formatMessage({
        id: 'JiraSoftwarePagePaidLpJswFeatures.tabs.tab4.imageAlt',
        defaultMessage: 'Jira automation'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $leg8m.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};
const $d1221b05e912c95d$export$814cc77def5a44df = ()=>{
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: 'JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab1.heading',
        defaultMessage: 'Kick off with clarity'
    });
    const listItems = [
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab1.item1",
            values: (0, $iRMRa.DEFAULT_VALUES),
            defaultMessage: "<strong>Align work to goals:</strong> Connect work to company impact and collaborate with cross-functional partners."
        }, "tabs.gwp9473.tab1.item1"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab1.item2",
            values: (0, $iRMRa.DEFAULT_VALUES),
            defaultMessage: "<strong>Break down projects:</strong> Go from big picture to automatically assigned tasks with Rovo AI."
        }, "tabs.gwp9473.tab1.item2"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab1.item3",
            values: (0, $iRMRa.DEFAULT_VALUES),
            defaultMessage: "<strong>Get the context you need:</strong> Use Rovo to find relevant resources and rich data from across your apps."
        }, "tabs.gwp9473.tab1.item3")
    ];
    const imageSrc = 'https://dam-cdn.atl.orangelogic.com/AssetLink/y43424xo5d312uq63es504lre561n4hf.webp';
    const imageAlt = intl.formatMessage({
        id: 'JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab1.imageAlt',
        defaultMessage: 'Jira plan view'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $leg8m.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};
const $d1221b05e912c95d$export$13921ac0cc260818 = ()=>{
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: 'JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab2.heading',
        defaultMessage: 'Stay up to date'
    });
    const listItems = [
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab2.item1",
            values: (0, $iRMRa.DEFAULT_VALUES),
            defaultMessage: "<strong>Track your work, your way:</strong> See projects in a board, list, timeline, or calendar view."
        }, "tabs.gwp9473.tab2.item1"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab2.item2",
            values: (0, $iRMRa.DEFAULT_VALUES),
            defaultMessage: "<strong>Manage risks and dependencies:</strong> Get status updates and any blockers from AI agents."
        }, "tabs.gwp9473.tab2.item2"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab2.item3",
            values: (0, $iRMRa.DEFAULT_VALUES),
            defaultMessage: "<strong>Remove work around work:</strong> Use Rovo AI to automate tedious tasks."
        }, "tabs.gwp9473.tab2.item3")
    ];
    const imageSrc = 'https://dam-cdn.atl.orangelogic.com/AssetLink/33884gu02a10x77i0282w08okk31o4c3.webp';
    const imageAlt = intl.formatMessage({
        id: 'JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab2.imageAlt',
        defaultMessage: 'Jira track view'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $leg8m.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};
const $d1221b05e912c95d$export$3141e70acdd1cdb7 = ()=>{
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: 'JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab3.heading',
        defaultMessage: 'Bring teams together'
    });
    const listItems = [
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab3.item1",
            values: (0, $iRMRa.DEFAULT_VALUES),
            defaultMessage: "<strong>Automate workflows:</strong> Use Rovo AI and everyday language to build any workflow."
        }, "tabs.gwp9473.tab3.item1"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab3.item2",
            values: (0, $iRMRa.DEFAULT_VALUES),
            defaultMessage: "<strong>Streamline requests:</strong> Get all the details you need and share your progress with forms."
        }, "tabs.gwp9473.tab3.item2"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab3.item3",
            values: (0, $iRMRa.DEFAULT_VALUES),
            defaultMessage: "<strong>Keep everyone aligned:</strong> Provide real-time status updates and use Rovo to identify risks."
        }, "tabs.gwp9473.tab3.item3")
    ];
    const imageSrc = 'https://dam-cdn.atl.orangelogic.com/AssetLink/py7ek04olrn273137jbptehj24b21d5p.webp';
    const imageAlt = intl.formatMessage({
        id: 'JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab3.imageAlt',
        defaultMessage: 'Jira collaborate view'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $leg8m.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};
const $d1221b05e912c95d$export$33aa3110c4070c17 = ()=>{
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: 'JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab4.heading',
        defaultMessage: 'Inform your decisions'
    });
    const listItems = [
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab4.item1",
            values: (0, $iRMRa.DEFAULT_VALUES),
            defaultMessage: "<strong>Track progress against goals:</strong> Get visibility into how your team's work contributes to company goals and progress."
        }, "tabs.gwp9473.tab4.item1"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab4.item2",
            values: (0, $iRMRa.DEFAULT_VALUES),
            defaultMessage: "<strong>See performance insights:</strong> Understand your teams with cycle time reports, burn down charts, and capacity plans."
        }, "tabs.gwp9473.tab4.item2"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab4.item3",
            values: (0, $iRMRa.DEFAULT_VALUES),
            defaultMessage: "<strong>Iterate with AI:</strong> Use Rovo's insights to identify recurring themes and priorities."
        }, "tabs.gwp9473.tab4.item3")
    ];
    const imageSrc = 'https://dam-cdn.atl.orangelogic.com/AssetLink/0d4wi87lq61r3551o21ij30mm5l03buq.webp';
    const imageAlt = intl.formatMessage({
        id: 'JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab4.imageAlt',
        defaultMessage: 'Jira report view'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $leg8m.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};

});
parcelRegister("k16ze", function(module, exports) {
$parcel$export(module.exports, "getLocalizedImage", function () { return $d7f99bd9e65d2fb0$export$df12673c228208c7; });
// no localized image for es, ru
const $d7f99bd9e65d2fb0$var$heroSectionImageMap = {
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/t1hdrv58771uc7a1caq48j2vup58nuxq.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/i138n0173hw3vplo38724k74w12fhljw.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7x1v3q2bn02e0r18p1c3p220orkcaa53.webp',
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/a6exiwjuxdt5yt737r34jm8r0qwgx5a1.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4krne7la727rr2uo447m5y6dcutb5468.webp'
};
// no localized image for es, ru
const $d7f99bd9e65d2fb0$var$tabsSectionAutomationImageMap = {
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/nhaj8o1l28kge001xo7746ov4nc72005.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/aw3e6hgl68r6v7mk0u4yw40xrk18kln0.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/j4dl52d0b2e8yn2s8tl0b34f2d0vwi1l.webp',
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/wf5834oq338l44v8yfrhf0s1q27g7kho.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4ak0a2801n26ls3f2kr37x6s7di8g435.webp'
};
// no localized image for es, ru
const $d7f99bd9e65d2fb0$var$tabsSectionBoardsImageMap = {
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/vsxtbk6nixxgyw7s86d2422h33183666.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8qyaj2s5n36ouwe8sw77d040776w2un2.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ei3ltwf7858ltw6l48670u8j6ews56bw.webp',
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/737g80fw6ml20lr326ccpphj50d7xex2.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1y3cs512486c3a2t7u112yui0nl1l6a1.webp'
};
// no localized image for es, ru
const $d7f99bd9e65d2fb0$var$tabsSectionReportsImageMap = {
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/670r88uhf63s523y62bq4p6r27cwo21h.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8hf8r6r78ma46c3tkah540710e506k0g.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/c341bo7s5q43xhtyeosj20utoa62j4gf.webp',
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/t7du15rcv88p3epa4n0r63n1733rb7oe.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/07cpm5tqamy4s567700fk6qyu1w1f3q8.webp'
};
// no localized image for es, ru
const $d7f99bd9e65d2fb0$var$tabsSectionTimelineImageMap = {
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/6i83t23511sqleh83338b6c3qdw3u5hy.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/78h0t1uh08qm08j78kyq1832060nsi2q.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/6nr6005kc5m6a0b5cu54862y667s561b.webp',
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/081fa55814t01f42l608c6v4rd4706yb.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/42f2e8u6c3g3fyq20k1lg6n6i08y3cr6.webp'
};
// no localized image for es, ru
const $d7f99bd9e65d2fb0$var$rowOneImageMap = {
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/vsxtbk6nixxgyw7s86d2422h33183666.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8qyaj2s5n36ouwe8sw77d040776w2un2.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ei3ltwf7858ltw6l48670u8j6ews56bw.webp',
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/737g80fw6ml20lr326ccpphj50d7xex2.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1y3cs512486c3a2t7u112yui0nl1l6a1.webp'
};
// no localized image for es, ru
const $d7f99bd9e65d2fb0$var$rowTwoImageMap = {
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1y066woqlgoe2430346q7c2r3pry10tb.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/l3yqms82gf6nyi141b7868v547mtk755.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/74u3u60n631kp01p67wlg211ml0ue676.webp',
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/03ww8q35s1o815s41383u0eye53o18ib.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1wo8sdr62p0we8736414nximtscv142r.webp'
};
// no localized image for es, ru
const $d7f99bd9e65d2fb0$var$rowThreeImageMap = {
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7o3775x22n2c5yxfb7l5g0v3ye568v0s.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/5wp1j5x50y0ppby1t1r16qsy54231h15.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/46o4s1jbv7733e4qv2723p4n0m274g84.webp',
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2oh1ay3ar5u0q28ey78w3e7iqsj5i5r1.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0k071g3m4h17ng7s54bw0vm37qxf3g7f.webp'
};
const $d7f99bd9e65d2fb0$var$getCorrespondingImageMap = (descriptor)=>{
    switch(descriptor){
        case 'automation':
            return $d7f99bd9e65d2fb0$var$tabsSectionAutomationImageMap;
        case 'boards':
            return $d7f99bd9e65d2fb0$var$tabsSectionBoardsImageMap;
        case 'hero':
            return $d7f99bd9e65d2fb0$var$heroSectionImageMap;
        case 'reports':
            return $d7f99bd9e65d2fb0$var$tabsSectionReportsImageMap;
        case 'timeline':
            return $d7f99bd9e65d2fb0$var$tabsSectionTimelineImageMap;
        case 'row one':
            return $d7f99bd9e65d2fb0$var$rowOneImageMap;
        case 'row two':
            return $d7f99bd9e65d2fb0$var$rowTwoImageMap;
        case 'row three':
            return $d7f99bd9e65d2fb0$var$rowThreeImageMap;
        default:
            throw new Error(`Unknown descriptor: ${descriptor}`);
    }
};
const $d7f99bd9e65d2fb0$export$df12673c228208c7 = (descriptor, locale)=>{
    const map = $d7f99bd9e65d2fb0$var$getCorrespondingImageMap(descriptor);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return map[locale] || map['en'];
};

});

parcelRegister("I9wqw", function(module, exports) {
$parcel$export(module.exports, "PaidTeamSelectionHeroSection", function () { return $55c23fe1cad42cf8$export$dbb9d3849f125826; });
/* paid-hero-section-team-selection-variant.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $9s3Hk = parcelRequire("9s3Hk");

var $90TSV = parcelRequire("90TSV");

var $ilkqI = parcelRequire("ilkqI");

var $iyOcM = parcelRequire("iyOcM");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");

var $28AH4 = parcelRequire("28AH4");

var $gCwEn = parcelRequire("gCwEn");
const $55c23fe1cad42cf8$var$iconWrapperStyle = null;
const $55c23fe1cad42cf8$var$buttonDefaultStyles = null;
const $55c23fe1cad42cf8$var$iconHoverStyles = null;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $55c23fe1cad42cf8$var$buttonStyles = {
    sm: "_1bsb16xz",
    md: "_1bsb1et3",
    lg: "_1bsb68cl",
    xl: "_1bsb68cl"
};
const $55c23fe1cad42cf8$var$selectedStyles = null;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $55c23fe1cad42cf8$var$iconWrapperStyleMap = {
    sm: "_4t3i10mc _1bsb10mc _ca0q19bv _u5f319bv _n3td19bv _19bv19bv",
    md: "_4t3iajfg _1bsbajfg _ca0q1skh _u5f31skh _n3td1skh _19bv1skh",
    lg: "_4t3ickbl _1bsbckbl _ca0q1skh _u5f31skh _n3td1skh _19bv1skh",
    xl: "_4t3i1wqb _1bsb1wqb _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8"
};
const $55c23fe1cad42cf8$var$Tab = ({ teamTypeId: teamTypeId, index: index, title: title, iconSrc: iconSrc, iconSrcSelected: iconSrcSelected, setSelectedTeamType: setSelectedTeamType })=>{
    const { isCurrentTab: isCurrentTab } = (0, $iyOcM.useAdg4TabsContext)();
    const isSelected = isCurrentTab(index);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    // analytics for "team expansion box" experiment GWP-4223
    const handleTeamTabClick = (clickedTeamType)=>{
        setSelectedTeamType(clickedTeamType);
        if (clickedTeamType) createAnalyticsEvent({
            eventName: 'clickTeamSelectorTab',
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'linkButton',
            actionSubjectId: 'teamSelectorTab',
            source: 'teamExpansionSelector',
            attributes: {
                product: 'wac',
                pageUrl: window.location.href,
                pagePath: window.location.pathname,
                teamType: clickedTeamType
            }
        }).fire();
    };
    let buttonSize;
    switch(index){
        case 0:
        case 6:
            buttonSize = 'sm';
            break;
        case 1:
        case 5:
            buttonSize = 'md';
            break;
        case 2:
        case 4:
            buttonSize = 'lg';
            break;
        case 3:
            buttonSize = 'xl';
            break;
        default:
            buttonSize = 'sm';
    }
    const buttonSizingStyles = $55c23fe1cad42cf8$var$buttonStyles[buttonSize];
    const iconWrapperSizingStyles = $55c23fe1cad42cf8$var$iconWrapperStyleMap[buttonSize];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
        onClick: (e)=>{
            e.preventDefault();
            handleTeamTabClick(teamTypeId);
        },
        className: (0, $2jatx.default)([
            "_11q7glyw _19itglyw _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _80omtlke _ect4z4z1 _k48p1nn1 _1e0c1txw _2lx21bp4 _4cvr1h6o",
            $55c23fe1cad42cf8$var$buttonStyles[buttonSize],
            "_z5z6jojz"
        ]),
        style: {
            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb1wqb _4t3i1wqb _2rko14q1 _bfhk1kix _1e0c1txw _4cvr1h6o _1bah1h6o",
                    $55c23fe1cad42cf8$var$iconWrapperStyleMap[buttonSize],
                    isSelected && "_bfhkftjs",
                    "icon-wrapper"
                ]),
                style: {
                    "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                    image: {
                        src: isSelected && iconSrcSelected ? iconSrcSelected : iconSrc,
                        alt: '',
                        width: 100
                    }
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                children: title
            })
        ]
    });
};
const $55c23fe1cad42cf8$export$dbb9d3849f125826 = ({ keyword: keyword })=>{
    const intl = (0, $8e22h.default)();
    const whiteBackgroundStyle = null;
    const containerStyle = null;
    const teamData = (0, $gCwEn.JSW_FEATURES_TEAM_DATA);
    const { setAnchorLocalStorage: setAnchorLocalStorage } = (0, $28AH4.useAnchorLocalStorage)();
    const [selectedTeamType, setSelectedTeamType] = (0, $1oC0p.useState)();
    (0, $1oC0p.useEffect)(()=>{
        setAnchorLocalStorage({
            team: selectedTeamType
        });
    }, [
        setAnchorLocalStorage,
        selectedTeamType
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "data-testid": "hero-team-selection-variant",
        id: "start-trial",
        className: (0, $2jatx.default)([
            "_bfhkuzct"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1q5153f4 _85i5ymf6"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $iyOcM.Adg4Tabs), {
                initialTab: 3,
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $90TSV.Adg4DraggableTabList), {
                        children: teamData.map((team, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $9s3Hk.Adg4DraggableTab), {
                                tabIndex: index,
                                className: "round-tab",
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)($55c23fe1cad42cf8$var$Tab, {
                                    index: index,
                                    title: intl.formatMessage(team.title),
                                    iconSrc: team.icon,
                                    iconSrcSelected: team.iconSrcSelected,
                                    setSelectedTeamType: setSelectedTeamType,
                                    teamTypeId: team.teamTypeId
                                })
                            }, index))
                    }),
                    teamData.map((team, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $ilkqI.Adg4TabPanel), {
                            panelIndex: index,
                            id: team.teamTypeId,
                            children: /*#__PURE__*/ (0, $1oC0p.cloneElement)(team.tabComponent, {
                                keyword: keyword
                            })
                        }, index))
                ]
            })
        })
    });
};
$55c23fe1cad42cf8$export$dbb9d3849f125826.displayName = 'PaidTeamSelectionHeroSection';

});
parcelRegister("gCwEn", function(module, exports) {
$parcel$export(module.exports, "JSW_FEATURES_TEAM_DATA", function () { return $ec246ec752747b53$export$cab6cf085c064769; });

var $7VQPk = parcelRequire("7VQPk");

var $fnHPc = parcelRequire("fnHPc");

var $9JSU2 = parcelRequire("9JSU2");

var $7RVa7 = parcelRequire("7RVa7");

var $8hXXn = parcelRequire("8hXXn");

var $4pIA3 = parcelRequire("4pIA3");

var $gRuVN = parcelRequire("gRuVN");

var $gYFKy = parcelRequire("gYFKy");

var $hYavq = parcelRequire("hYavq");
const $ec246ec752747b53$export$cab6cf085c064769 = [
    {
        teamTypeId: 'Software Engineering',
        icon: 'https://dam-cdn.atl.orangelogic.com/AssetLink/575h0o4d5531rcso8b6or7m5ljj5yf77.svg',
        title: (0, $fnHPc.defineMessage)({
            id: 'PaidLandingPage.teamSelectionHero.label.tab1',
            defaultMessage: 'Software'
        }),
        englishLabel: 'Software',
        tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hYavq.default), {})
    },
    {
        teamTypeId: 'Operations',
        icon: 'https://dam-cdn.atl.orangelogic.com/AssetLink/yl01ea2raydqsbpq411uu2jb4x1o5k16.svg',
        title: (0, $fnHPc.defineMessage)({
            id: 'PaidLandingPage.teamSelectionHero.label.tab2',
            defaultMessage: 'Operations'
        }),
        englishLabel: 'Operations',
        tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gRuVN.default), {})
    },
    {
        teamTypeId: 'HR',
        icon: 'https://dam-cdn.atl.orangelogic.com/AssetLink/c85anlqa4vbx8kgn1y41t10q44q0325l.svg',
        title: (0, $fnHPc.defineMessage)({
            id: 'PaidLandingPage.teamSelectionHero.label.tab3',
            defaultMessage: 'HR'
        }),
        englishLabel: 'HR',
        tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8hXXn.default), {})
    },
    {
        teamTypeId: undefined,
        icon: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7300dt61p6o2c340nk53534647755fep.svg',
        iconSrcSelected: 'https://dam-cdn.atl.orangelogic.com/AssetLink/72lkaojcq61b111eyg28t62gv1002f22.svg',
        title: (0, $fnHPc.defineMessage)({
            id: 'PaidLandingPage.teamSelectionHero.label.tab4',
            defaultMessage: 'All Teams'
        }),
        englishLabel: 'All Teams',
        tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9JSU2.default), {})
    },
    {
        teamTypeId: 'Marketing',
        icon: 'https://dam-cdn.atl.orangelogic.com/AssetLink/6648s271ra1efk47v7r40xslp7630o4w.svg',
        title: (0, $fnHPc.defineMessage)({
            id: 'PaidLandingPage.teamSelectionHero.label.tab5',
            defaultMessage: 'Marketing'
        }),
        englishLabel: 'Marketing',
        tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4pIA3.default), {})
    },
    {
        teamTypeId: 'Design',
        icon: 'https://dam-cdn.atl.orangelogic.com/AssetLink/x82hxxkp01k3f20y83q86a0r0bvm55p4.svg',
        title: (0, $fnHPc.defineMessage)({
            id: 'PaidLandingPage.teamSelectionHero.label.tab6',
            defaultMessage: 'Design'
        }),
        englishLabel: 'Design',
        tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7RVa7.default), {})
    },
    {
        teamTypeId: 'Sales',
        icon: 'https://dam-cdn.atl.orangelogic.com/AssetLink/6101e5o3r21du53012037egepyolhibt.svg',
        title: (0, $fnHPc.defineMessage)({
            id: 'PaidLandingPage.teamSelectionHero.label.tab7',
            defaultMessage: 'Sales'
        }),
        englishLabel: 'Sales',
        tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gYFKy.default), {})
    }
];

});
parcelRegister("9JSU2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9f47a62d22e6c98d$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $iN2W6 = parcelRequire("iN2W6");
const $9f47a62d22e6c98d$var$AllTeamsTabContent = ()=>{
    const intl = (0, $8e22h.default)();
    const gwp9473JSWAnchorUpdates = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp9473JSWAnchorUpdates);
    const allTeamsHeroProps = {
        header: intl.formatMessage({
            id: 'JiraSoftwarePagePaidLpJswFeatures.hero.header',
            defaultMessage: 'Connect every team, task, and project together with Jira'
        }),
        image: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/t501oo65h16scx35qe60q32dj6a4782t.webp',
            alt: intl.formatMessage({
                id: 'JiraSoftwarePagePaidLpJswFeatures.default.heroImageAlt',
                defaultMessage: 'Screen capture of a Jira backlog'
            })
        },
        showAnimatedHero: true
    };
    const gwp9473JSWAnchorUpdatesHeroProps = {
        header: intl.formatMessage({
            id: 'JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.hero.header',
            defaultMessage: 'Where your teams and AI come together'
        }),
        image: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/wdmncs35471g5521yr5462w3ku0t834b.webp',
            alt: intl.formatMessage({
                id: 'JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.default.heroImageAlt',
                defaultMessage: 'Screen capture of a Jira list view'
            })
        },
        showAnimatedHero: false
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iN2W6.PaidHeroTabPanelTemplate), {
        ...gwp9473JSWAnchorUpdates ? gwp9473JSWAnchorUpdatesHeroProps : allTeamsHeroProps,
        isAllTeamsTab: true
    });
};
var $9f47a62d22e6c98d$export$2e2bcd8739ae039 = $9f47a62d22e6c98d$var$AllTeamsTabContent;

});
parcelRegister("iN2W6", function(module, exports) {
$parcel$export(module.exports, "PaidHeroTabPanelTemplate", function () { return $6500b1ce48d546a6$export$b11df6f0d1a6642c; });
/* hero-tab-panel-template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iL9dx = parcelRequire("iL9dx");

var $7kIQK = parcelRequire("7kIQK");

var $bGrkd = parcelRequire("bGrkd");

var $bs458 = parcelRequire("bs458");

var $ka4Xu = parcelRequire("ka4Xu");

var $2WL8B = parcelRequire("2WL8B");

var $7GVWk = parcelRequire("7GVWk");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");

var $1rGpC = parcelRequire("1rGpC");

var $1Q6XY = parcelRequire("1Q6XY");

var $2opLs = parcelRequire("2opLs");

var $3LcIp = parcelRequire("3LcIp");

var $2gCne = parcelRequire("2gCne");
const $6500b1ce48d546a6$var$contentStyle = null;
const $6500b1ce48d546a6$var$formColumn = null;
const $6500b1ce48d546a6$var$signupFormContainer = null;
const $6500b1ce48d546a6$var$headerStyle = null;
const $6500b1ce48d546a6$var$imgContainer = null;
const $6500b1ce48d546a6$var$carouselContainerStyles = null;
const $6500b1ce48d546a6$var$subHeaderStyles = null;
const $6500b1ce48d546a6$var$animationHeroContainer = null;
const $6500b1ce48d546a6$var$staticImageContainer = null;
const $6500b1ce48d546a6$export$b11df6f0d1a6642c = ({ header: header, subHeader: subHeader, image: image, showAnimatedHero: showAnimatedHero = false, carouselHeroProps: carouselHeroProps, isAllTeamsTab: isAllTeamsTab = false })=>{
    (0, $1oC0p.useEffect)(()=>{
        const getaaCompleteQueryObj = (0, $2gCne.getLocalStorage)((0, $1Q6XY.AA_AUTOCOMPLETE_POTENTIAL_CONVERSION_EVENT_LOCAL_STORAGE_KEY));
        if (getaaCompleteQueryObj) {
            const parsedStringifyAttributes = JSON.parse(getaaCompleteQueryObj);
            (0, $1Q6XY.sendConversionEventAlgolia)({
                objectID: parsedStringifyAttributes.objectID,
                queryID: parsedStringifyAttributes.queryID,
                position: parsedStringifyAttributes.position
            });
        }
    }, []);
    const { user: { isUserLoggedIn: isUserLoggedIn } } = (0, $7GVWk.useUserContext)();
    const useContactExpandCohortLogic = (0, $2WL8B.useIsJiraContactCompanyExpandEligible)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            "data-testid": "hero-tab-panel",
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx2vrvc _zulpzwfg _4cvr1h6o _1bah1h6o _19pkidpf _2hwx1wug _otyridpf _18u01wug _1bsb1osq _na0i1bp4"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _10jxdgin _gltexe31 _1945stmo _dh1a1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                                className: (0, $2jatx.default)([
                                    "_ect41vau _1wyb1wto _vwz41k7u _k48pbfng _1pfh12am _6rth1tcg _gu181h6o"
                                ]),
                                style: {
                                    "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3LcIp.BanditsHeaderWrapper), {
                                    product: "jira",
                                    type: "header",
                                    children: header
                                })
                            })
                        }),
                        subHeader && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                "_6rth7vkz _y3gn1h6o _uj6k1e5h"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3LcIp.BanditsHeaderWrapper), {
                                product: "jira",
                                type: "subheader",
                                children: subHeader
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            "data-testid": "signup-form",
                            className: (0, $2jatx.default)([
                                "_p12f1feq _1bsb1osq"
                            ]),
                            children: isUserLoggedIn ? useContactExpandCohortLogic ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {
                                CurrentProductUser: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bs458.ReturnToProduct), {}),
                                CurrentProductJoinableUser: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bGrkd.JoinableSites), {}),
                                useContactExpandCohortLogic: true
                            }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ka4Xu.SiteActivation), {}) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2opLs.PaidAccountCreation), {
                                pageId: "paid-lp-jsw-features"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $3LcIp.BanditsAssetWrapper), {
                    product: "jira",
                    showChildren: !isAllTeamsTab,
                    children: [
                        showAnimatedHero && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_p12fstmo _glte1kpv _1mjb1txw _o5kc1h6o _na0i1bp4"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_kqswh2mm _1h1th1c8 _4t3i1wug _1tket94y _1bsb1osq _1e0c1txw _4cvr1h6o _1bah1h6o _1y8o1osq _1mjbglyw"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7kIQK.AnimatedJiraTour), {})
                            })
                        }),
                        carouselHeroProps ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_4cvr1h6o _1e0c1txw _1bah1h6o _1bsbcv93 _4t3i1ogm _1rfm1osq _tnru1osq"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iL9dx.Carousel), {
                                ...carouselHeroProps
                            })
                        }) : null,
                        image && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                showAnimatedHero ? "_1e0cglyw _1mjb1txw _o5kc1h6o _na0i1bp4" : "_p12fstmo _glte1kpv _1mjb1txw _o5kc1h6o _na0i1bp4"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                image: image,
                                style: {
                                    maxWidth: '100%'
                                }
                            })
                        })
                    ]
                })
            ]
        })
    });
};
$6500b1ce48d546a6$export$b11df6f0d1a6642c.displayName = 'PaidHeroTemplate';

});


parcelRegister("7RVa7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bd21a0ad00f4afb2$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $iN2W6 = parcelRequire("iN2W6");
const $bd21a0ad00f4afb2$var$DesignTabContent = ()=>{
    const intl = (0, $8e22h.default)();
    const gwp9473JSWAnchorUpdates = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp9473JSWAnchorUpdates);
    const designHeroProps = {
        header: intl.formatMessage({
            id: 'JiraSoftwarePagePaidLpJswFeatures.hero.design.header',
            defaultMessage: 'Unleash innovative design work with Jira'
        }),
        image: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/stwkq56nns422b0684fodlf0074s3b6e.webp',
            alt: intl.formatMessage({
                id: 'JiraSoftwarePagePaidLpJswFeatures.design.heroImageAlt',
                defaultMessage: 'Screen capture of a Jira design ticket'
            })
        }
    };
    const gwp9473JSWAnchorUpdatesHeroProps = {
        header: intl.formatMessage({
            id: 'JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.hero.design.header',
            defaultMessage: 'Design with all the right context'
        }),
        image: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2s7dw8mxw65kwtjh2npm8x55200kcnu3.webp',
            alt: intl.formatMessage({
                id: 'JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.design.heroImageAlt',
                defaultMessage: 'Screen capture of a Jira board view'
            })
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iN2W6.PaidHeroTabPanelTemplate), {
        ...gwp9473JSWAnchorUpdates ? gwp9473JSWAnchorUpdatesHeroProps : designHeroProps
    });
};
var $bd21a0ad00f4afb2$export$2e2bcd8739ae039 = $bd21a0ad00f4afb2$var$DesignTabContent;

});

parcelRegister("8hXXn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f2fde524a0049ee3$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $iN2W6 = parcelRequire("iN2W6");
const $f2fde524a0049ee3$var$HRTabContent = ()=>{
    const intl = (0, $8e22h.default)();
    const hrHeroProps = {
        header: intl.formatMessage({
            id: 'JiraSoftwarePagePaidLpJswFeatures.hero.hr.header',
            defaultMessage: 'Build teamwork and productivity across your organization with Jira'
        }),
        image: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/o3vf21711xl7j3k661enul0050252c02.webp',
            alt: intl.formatMessage({
                id: 'JiraSoftwarePagePaidLpJswFeatures.hr.heroImageAlt',
                defaultMessage: 'Screen capture of a Jira backlog'
            })
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iN2W6.PaidHeroTabPanelTemplate), {
        ...hrHeroProps
    });
};
var $f2fde524a0049ee3$export$2e2bcd8739ae039 = $f2fde524a0049ee3$var$HRTabContent;

});

parcelRegister("4pIA3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $500f5c9b451db8a6$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $iN2W6 = parcelRequire("iN2W6");
const $500f5c9b451db8a6$var$MarketingTabContent = ()=>{
    const intl = (0, $8e22h.default)();
    const gwp9473JSWAnchorUpdates = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp9473JSWAnchorUpdates);
    const marketingHeroProps = {
        header: intl.formatMessage({
            id: 'JiraSoftwarePagePaidLpJswFeatures.hero.marketing.header',
            defaultMessage: 'Unleash the power of marketing teams with Jira'
        }),
        image: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/62xi2h6p73mrb7t2ib163ss3qeh22c5f.webp',
            alt: intl.formatMessage({
                id: 'JiraSoftwarePagePaidLpJswFeatures.marketing.heroImageAlt',
                defaultMessage: 'Screen capture of a Jira board tracking a marketing launch'
            })
        }
    };
    const gwp9473JSWAnchorUpdatesHeroProps = {
        header: intl.formatMessage({
            id: 'JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.hero.marketing.header',
            defaultMessage: 'Go from big idea to an even bigger launch'
        }),
        image: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ox58yay38c0ps0rm5xeg0e2765128to3.webp',
            alt: intl.formatMessage({
                id: 'JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.marketing.heroImageAlt',
                defaultMessage: 'Screen capture of a Jira list view'
            })
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iN2W6.PaidHeroTabPanelTemplate), {
        ...gwp9473JSWAnchorUpdates ? gwp9473JSWAnchorUpdatesHeroProps : marketingHeroProps
    });
};
var $500f5c9b451db8a6$export$2e2bcd8739ae039 = $500f5c9b451db8a6$var$MarketingTabContent;

});

parcelRegister("gRuVN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b5fbde38ddff7678$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $iN2W6 = parcelRequire("iN2W6");
const $b5fbde38ddff7678$var$OperationsTabContent = ()=>{
    const intl = (0, $8e22h.default)();
    const gwp9473JSWAnchorUpdates = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp9473JSWAnchorUpdates);
    const operationsHeroProps = {
        header: intl.formatMessage({
            id: 'JiraSoftwarePagePaidLpJswFeatures.hero.operations.header',
            defaultMessage: 'Operations processes made easy with Jira'
        }),
        image: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/w4g3m6wrfl232cm6kx12p83t1sg1odlm.webp',
            alt: intl.formatMessage({
                id: 'JiraSoftwarePagePaidLpJswFeatures.operations.heroImageAlt',
                defaultMessage: 'Screen capture of a Jira backlog'
            })
        }
    };
    const gwp9473JSWAnchorUpdatesHeroProps = {
        header: intl.formatMessage({
            id: 'JiraSoftwarePagePaidLpJswFeatures.hero.operations.header',
            defaultMessage: 'Conquer complex workflows'
        }),
        image: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8mbx11md7br33n86667to5e4q87x8dfl.webp',
            alt: intl.formatMessage({
                id: 'JiraSoftwarePagePaidLpJswFeatures.operations.heroImageAlt',
                defaultMessage: 'Screen capture of a Jira board view'
            })
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iN2W6.PaidHeroTabPanelTemplate), {
        ...gwp9473JSWAnchorUpdates ? gwp9473JSWAnchorUpdatesHeroProps : operationsHeroProps
    });
};
var $b5fbde38ddff7678$export$2e2bcd8739ae039 = $b5fbde38ddff7678$var$OperationsTabContent;

});

parcelRegister("gYFKy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c34b5c3337693845$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $iN2W6 = parcelRequire("iN2W6");
const $c34b5c3337693845$var$SalesTabContent = ()=>{
    const intl = (0, $8e22h.default)();
    const salesHeroProps = {
        header: intl.formatMessage({
            id: 'JiraSoftwarePagePaidLpJswFeatures.hero.sales.header',
            defaultMessage: 'Hit sales team targets with Jira'
        }),
        image: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/87h6hy3p184v1kyn202mov58b5y6q82d.webp',
            alt: intl.formatMessage({
                id: 'JiraSoftwarePagePaidLpJswFeatures.sales.heroImageAlt',
                defaultMessage: 'Screen capture of a Jira board for a product launch'
            })
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iN2W6.PaidHeroTabPanelTemplate), {
        ...salesHeroProps
    });
};
var $c34b5c3337693845$export$2e2bcd8739ae039 = $c34b5c3337693845$var$SalesTabContent;

});

parcelRegister("hYavq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4b0af393b30f2063$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $iN2W6 = parcelRequire("iN2W6");
const $4b0af393b30f2063$var$SoftwareTabContent = ()=>{
    const intl = (0, $8e22h.default)();
    const gwp9473JSWAnchorUpdates = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp9473JSWAnchorUpdates);
    const softwareHeroProps = {
        header: intl.formatMessage({
            id: 'JiraSoftwarePagePaidLpJswFeatures.hero.software.header',
            defaultMessage: 'Jira is the #1 software development tool used by agile teams'
        }),
        image: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/fya3j34w81idu648i580m4mutc60guo0.webp',
            alt: intl.formatMessage({
                id: 'JiraSoftwarePagePaidLpJswFeatures.software.heroImageAlt',
                defaultMessage: 'Screen capture of a Jira board'
            })
        }
    };
    const gwp9473JSWAnchorUpdatesHeroProps = {
        header: intl.formatMessage({
            id: 'JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.hero.software.header',
            defaultMessage: 'Focus on outcomes, not admin'
        }),
        image: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3m35263c8gy137p68p2v33ijxb0703p5.webp',
            alt: intl.formatMessage({
                id: 'JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.software.heroImageAlt',
                defaultMessage: 'Screenshot of Jira list view'
            })
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iN2W6.PaidHeroTabPanelTemplate), {
        ...gwp9473JSWAnchorUpdates ? gwp9473JSWAnchorUpdatesHeroProps : softwareHeroProps
    });
};
var $4b0af393b30f2063$export$2e2bcd8739ae039 = $4b0af393b30f2063$var$SoftwareTabContent;

});




parcelRegister("eNeuM", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePagePaidLpJswPm", function () { return $736d9d54c77de04a$export$3940e8f9b3d490c4; });

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");

var $k6PTJ = parcelRequire("k6PTJ");

var $17vRh = parcelRequire("17vRh");
const $736d9d54c77de04a$export$3940e8f9b3d490c4 = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $17vRh.JiraSoftwarePagePaidLpJswAnchor), {
        ...pageProps,
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsw-pm",
        persona: "unknown",
        pageVariant: "pm"
    });
};

});

parcelRegister("lTIGz", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePagePaidLpJswProjCollab", function () { return $2774693f9dbda9e5$export$f9651956eec158e0; });

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");

var $k6PTJ = parcelRequire("k6PTJ");

var $17vRh = parcelRequire("17vRh");
const $2774693f9dbda9e5$export$f9651956eec158e0 = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $17vRh.JiraSoftwarePagePaidLpJswAnchor), {
        ...pageProps,
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsw-project_collaboration",
        persona: "unknown",
        pageVariant: "project_collaboration"
    });
};

});

parcelRegister("eIZwM", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePagePaidLpJswRoadmaps", function () { return $0eb5ea83f1f296e3$export$3507bd3b8f9604d1; });

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");

var $k6PTJ = parcelRequire("k6PTJ");

var $17vRh = parcelRequire("17vRh");
const $0eb5ea83f1f296e3$export$3507bd3b8f9604d1 = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $17vRh.JiraSoftwarePagePaidLpJswAnchor), {
        ...pageProps,
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsw-roadmaps",
        persona: "unknown",
        pageVariant: "roadmaps"
    });
};

});

parcelRegister("bcBwv", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePagePaidLpJswTeamwork", function () { return $86c08eafed9bc805$export$3577f38e8e4e34f; });

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");

var $k6PTJ = parcelRequire("k6PTJ");

var $17vRh = parcelRequire("17vRh");
const $86c08eafed9bc805$export$3577f38e8e4e34f = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $17vRh.JiraSoftwarePagePaidLpJswAnchor), {
        ...pageProps,
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsw-teamwork",
        persona: "unknown",
        pageVariant: "teamwork"
    });
};

});

parcelRegister("gfnSo", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePagePaidLpJswTemplate", function () { return $a648ed5db03ba6a2$export$4206a0db856d7544; });

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");

var $k6PTJ = parcelRequire("k6PTJ");

var $17vRh = parcelRequire("17vRh");
const $a648ed5db03ba6a2$export$4206a0db856d7544 = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $17vRh.JiraSoftwarePagePaidLpJswAnchor), {
        ...pageProps,
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsw-template",
        persona: "unknown",
        pageVariant: "template"
    });
};

});

parcelRegister("lFb3d", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePagePaidLpJswTracker", function () { return $baf81d2127141d55$export$5d7d37f42bf228bb; });

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");

var $k6PTJ = parcelRequire("k6PTJ");

var $17vRh = parcelRequire("17vRh");
const $baf81d2127141d55$export$5d7d37f42bf228bb = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $17vRh.JiraSoftwarePagePaidLpJswAnchor), {
        ...pageProps,
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsw-tracker",
        persona: "unknown",
        pageVariant: "tracker"
    });
};

});

parcelRegister("02cSL", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwareFreePage", function () { return $a6d720ca803f2dba$export$a1727845ccb60c5c; });

var $jQ0cd = parcelRequire("jQ0cd");

var $1ka2O = parcelRequire("1ka2O");
const $a6d720ca803f2dba$export$a1727845ccb60c5c = ()=>{
    const signupPath = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup');
    const location = (0, $1ka2O.useLocation)();
    // ATLAS-55799 - JSW Find Team
    const queryParameters = new URLSearchParams(location.search);
    const templateId = queryParameters.get('templateId') ?? '';
    const jiraProductTourSignupType = queryParameters.get('jiraProductTourSignupType') ?? '';
    const signupParameters = new URLSearchParams({
        bundle: 'jira-software',
        edition: 'free',
        skipBundles: 'true'
    });
    if (templateId) signupParameters.append('templateId', templateId);
    if (jiraProductTourSignupType) signupParameters.append('jiraProductTourSignupType', jiraProductTourSignupType);
    if (typeof window !== 'undefined') window.location.assign(`${signupPath}?${signupParameters}`);
    return null;
};

});

parcelRegister("koI83", function(module, exports) {
$parcel$export(module.exports, "getPricingTitleInternal", function () { return $31a5684656309797$export$933c1404a4ee79b; });
const $31a5684656309797$export$933c1404a4ee79b = ()=>{
    return 'Jira Pricing Page';
};

});

parcelRegister("Q2S5p", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePricingPage", function () { return $3f3699cf5f70cbd9$export$743fd6231b24dcf9; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $dl2JF = parcelRequire("dl2JF");

var $bTseT = parcelRequire("bTseT");

var $5yFib = parcelRequire("5yFib");

var $4X0dO = parcelRequire("4X0dO");

var $hZuN8 = parcelRequire("hZuN8");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
const $3f3699cf5f70cbd9$export$743fd6231b24dcf9 = ({ pricing: pricing, countryCode: countryCode, pricingContent: pricingContent, queryRef: queryRef })=>{
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp737EnableIntercomChatJsw);
    const [hasFired, fireExposure] = (0, $hZuN8.useExperimentExposure)((0, $4X0dO.experiments).jiraPricingWaeMigrationExperimentRerunExp);
    (0, $1oC0p.useEffect)(()=>{
        if (!hasFired) fireExposure();
    }, [
        hasFired,
        fireExposure
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bTseT.IntercomProvider), {
        appId: 'p0ww63i2',
        triggerBoot: isBootIntercom,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dl2JF.PricingContentContextProvider), {
            productId: "jira-software",
            pricingContent: pricingContent,
            queryRef: queryRef,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5yFib.JiraSoftwarePricingPageV2Template), {
                    pricing: pricing,
                    countryCode: countryCode
                })
            })
        })
    });
};

});
parcelRegister("5yFib", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePricingPageV2Template", function () { return $cdf4d25a3c43b2b5$export$413c805c73a21678; });

var $7VQPk = parcelRequire("7VQPk");

var $in5fb = parcelRequire("in5fb");

var $kIC93 = parcelRequire("kIC93");

var $7aKDf = parcelRequire("7aKDf");

var $dl2JF = parcelRequire("dl2JF");

var $bE8d4 = parcelRequire("bE8d4");

var $2zOxm = parcelRequire("2zOxm");

var $6Px6U = parcelRequire("6Px6U");

var $grcEk = parcelRequire("grcEk");

var $frz5c = parcelRequire("frz5c");

var $5S2vX = parcelRequire("5S2vX");

var $8IN8s = parcelRequire("8IN8s");

var $b7CnU = parcelRequire("b7CnU");
const $cdf4d25a3c43b2b5$export$413c805c73a21678 = (props)=>{
    const content = (0, $dl2JF.usePricingContentContext)();
    const questionsCtaContent = content?.callToActionContainer?.[0];
    const dataCenterContent = (0, $dl2JF.useDatacenterPlans)('Contact Us', 'Learn more');
    const featuresCtaContent = content?.callToActionContainer?.[1];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
        nav: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8IN8s.default), {}),
        showFallback: content?.hasError,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
            scrollTrackingEnabled: true,
            pageId: "jira-software-pricing-page",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6Px6U.PageHeading), {
                    children: content?.headline
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $b7CnU.JiraPriceFinder), {
                    pricing: props.pricing,
                    countryCode: props.countryCode
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aKDf.PricingFeatureTable), {
                    title: content?.compareFeaturesTitle ?? undefined,
                    comparePlans: content?.comparePlans ?? undefined,
                    compareFeatures: content?.compareFeatures ?? undefined,
                    linkValues: {
                        linkText: featuresCtaContent?.text ?? undefined,
                        linkHref: featuresCtaContent?.url ?? undefined
                    },
                    dataProductKey: 'jiraSoftware',
                    stickyCtasEnabled: false
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $in5fb.DataCenterPromoCard), {
                    dataCenterContent: dataCenterContent
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kIC93.TwcPromo), {
                    product: "jira"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2zOxm.QuotationsAdornment), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bE8d4.PricingFaq), {
                            header: content?.getMoreDetailsTitle ?? undefined,
                            planDetails: content?.additionalDetails ?? undefined
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $frz5c.QuestionsCta), {
                    product: 'Jira',
                    ctaHref: questionsCtaContent?.url ?? undefined,
                    questionsHeader: questionsCtaContent?.title ?? undefined,
                    priceAndLicensingLinkText: questionsCtaContent?.text ?? undefined,
                    questionsBody: questionsCtaContent?.valueProposition ?? undefined,
                    imageHref: questionsCtaContent?.asset?.url
                })
            ]
        })
    });
};

});
parcelRegister("b7CnU", function(module, exports) {
$parcel$export(module.exports, "JiraPriceFinder", function () { return $be32cafd3b047742$export$1bf486cdabb14f4d; });

var $7VQPk = parcelRequire("7VQPk");

var $fnHPc = parcelRequire("fnHPc");

var $hCc2m = parcelRequire("hCc2m");

var $g9ZvA = parcelRequire("g9ZvA");

var $gIRO7 = parcelRequire("gIRO7");

var $eYlij = parcelRequire("eYlij");

var $1qGP5 = parcelRequire("1qGP5");

var $dl2JF = parcelRequire("dl2JF");
const $be32cafd3b047742$export$1bf486cdabb14f4d = (props)=>{
    const content = {
        free: (0, $dl2JF.usePricingPlanComparison)('Free'),
        standard: (0, $dl2JF.usePricingPlanComparison)('Standard'),
        premium: (0, $dl2JF.usePricingPlanComparison)('Premium'),
        enterprise: (0, $dl2JF.usePricingPlanComparison)('Enterprise')
    };
    const freePlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, 'free');
    const standardPlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, 'standard');
    const premiumPlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, 'premium');
    const enterprisePlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, 'enterprise');
    const signupLimit = 100000;
    // planNames should not be translated
    const jswProductPlans = [
        {
            planName: content.free?.planTitleExternal ?? 'Free',
            offeringSku: 'jira-software-free',
            description: content.free?.planOneLiner ?? '',
            recommendationLimit: 0,
            signupLimit: signupLimit,
            signupURLSuffix: '?bundle=jira-software&edition=free&editionIntent=free&signupSource=pricing',
            planFeatureMessages: freePlanFeatureMessages
        },
        {
            planName: content.standard?.planTitleExternal ?? 'Standard',
            offeringSku: 'jira-software-standard',
            description: content.standard?.planOneLiner ?? '',
            recommendationLimit: 10,
            signupLimit: signupLimit,
            signupURLSuffix: '?bundle=jira-software&edition=standard&signupSource=pricing',
            planFeatureMessages: standardPlanFeatureMessages
        },
        {
            planName: content.premium?.planTitleExternal ?? 'Premium',
            offeringSku: 'jira-software-premium',
            description: content.premium?.planOneLiner ?? '',
            recommendationLimit: 250,
            signupLimit: signupLimit,
            signupURLSuffix: '?bundle=jira-software&edition=premium&signupSource=pricing',
            planFeatureMessages: premiumPlanFeatureMessages
        },
        {
            planName: content.enterprise?.planTitleExternal ?? 'Enterprise',
            offeringSku: 'jira-software-enterprise-sku',
            recommendationLimit: 5000,
            description: content.enterprise?.planOneLiner ?? '',
            signupLimit: signupLimit,
            planFeatureMessages: enterprisePlanFeatureMessages
        }
    ];
    const messages = (0, $fnHPc.defineMessages)({
        headerText: {
            id: 'JiraSoftwarePricingPageV2.priceFinder.header',
            defaultMessage: '<blue>Simple, transparent pricing</blue> for every team.'
        },
        unitCountInputText: {
            id: 'JiraSoftwarePricingPage.priceFinder.unitCountInputText',
            defaultMessage: 'How many users are on your team?'
        },
        unitCountInputTextRedesign: {
            id: 'JiraSoftwarePricingPage.priceFinder.unitCountInputTextRedesign',
            defaultMessage: 'Team size:'
        },
        unitCountInputDirectBuy: {
            id: 'JiraSoftwarePricingPage.priceFinder.unitCountInputDirectBuy',
            defaultMessage: "What's your team size?"
        },
        unitCountInputTerm: {
            id: 'JiraSoftwarePricingPage.priceFinder.unitCountInputTerm',
            defaultMessage: 'users'
        },
        billingCycleText: {
            id: 'JiraSoftwarePricingPage.priceFinder.billingCycleText',
            defaultMessage: 'Billing cycle:'
        },
        unitCountInputTooltip: {
            id: 'JiraSoftwarePricingPage.priceFinder.unitCountInputTooltip',
            defaultMessage: 'A Jira Software user is any user who can log in to Jira Software, and who exists in User Management'
        },
        cardOverSignupLimit: {
            id: 'JiraSoftwarePricingPage.priceFinder.cardOverSignupLimit',
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: 'JiraSoftwarePricingPage.priceFinder.cardEnterpriseMinimumCount',
            defaultMessage: 'Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above',
            description: 'Enterprise is a plan name and should not be translated'
        },
        cardUnitCountTierRange: {
            id: 'JiraSoftwarePricingPage.priceFinder.cardUnitCountTierRange',
            defaultMessage: 'User tier: {lowerLimit} - {upperLimit}'
        },
        cardMonthlyPerUnitCount: {
            id: 'JiraSoftwarePricingPageV2.priceFinder.cardMonthlyPerUnitCount',
            defaultMessage: 'per user / month'
        },
        cardFreeDescription: {
            id: 'JiraSoftwarePricingPage.priceFinder.cardFreeDescription',
            defaultMessage: 'Always free for 10 users'
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hCc2m.default), {
        interactionName: 'jira-price-finder',
        fallback: (0, $g9ZvA.LoadingSpinner),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eYlij.PriceFinderContextProvider), {
            productPlans: jswProductPlans,
            dataProductKey: "jiraSoftware",
            defaultUnitCount: 300,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gIRO7.default), {
                messages: messages,
                serverSideCCPPricing: props.pricing?.ccpPricingData?.jiraSoftware,
                countryCode: props.countryCode
            })
        })
    });
};
$be32cafd3b047742$export$1bf486cdabb14f4d.displayName = 'JiraPriceFinder';

});



parcelRegister("2S6eY", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryPage", function () { return $bd56f592d97598be$export$d8efa57f95a0eae9; });
// @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $3L8ZR = parcelRequire("3L8ZR");

var $20OkY = parcelRequire("20OkY");

var $1rObi = parcelRequire("1rObi");

var $bTseT = parcelRequire("bTseT");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $9xKEy = parcelRequire("9xKEy");

var $gZJ17 = parcelRequire("gZJ17");
const $bd56f592d97598be$export$d8efa57f95a0eae9 = ()=>{
    const intl = (0, $8e22h.default)();
    const isBootIntercom = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp1304AddIntercomToJpdProductTour);
    (0, $1oC0p.useEffect)(()=>{
        (0, $3L8ZR.default).getLayer('wac-edge-track-routing-layer').get('track', 'main');
    }, []);
    const intercomAppId = intl.locale === 'ja' ? 'p0ww63i2' : '';
    const isSalesWidgetBxpWebPlatform = intercomAppId !== '' && (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).salesWidgetBxpWebPlatform);
    const isSalesWidgetBxpWebPlatformDeveloper = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).salesWidgetBxpWebPlatformDeveloper);
    if (isSalesWidgetBxpWebPlatformDeveloper) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9xKEy.ChatWidgetProvider), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rObi.CrossFlowTouchpointProvider), {
            screenName: "wacJpdProductTourPage",
            productKeys: [
                (0, $20OkY.ProductKeys).JIRA_PRODUCT_DISCOVERY
            ],
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gZJ17.JiraProductDiscoveryTemplate), {})
        })
    });
    else if (isSalesWidgetBxpWebPlatform) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9xKEy.ChatWidgetProvider), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rObi.CrossFlowTouchpointProvider), {
            screenName: "wacJpdProductTourPage",
            productKeys: [
                (0, $20OkY.ProductKeys).JIRA_PRODUCT_DISCOVERY
            ],
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gZJ17.JiraProductDiscoveryTemplate), {})
        })
    });
    else return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bTseT.IntercomProvider), {
        appId: intercomAppId,
        triggerBoot: isBootIntercom,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rObi.CrossFlowTouchpointProvider), {
            screenName: "wacJpdProductTourPage",
            productKeys: [
                (0, $20OkY.ProductKeys).JIRA_PRODUCT_DISCOVERY
            ],
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gZJ17.JiraProductDiscoveryTemplate), {})
        })
    });
};

});
parcelRegister("9xKEy", function(module, exports) {
$parcel$export(module.exports, "ChatWidgetProvider", function () { return $c6548387155117f6$export$a4cac963ae9f34ca; });
$parcel$export(module.exports, "default", function () { return $c6548387155117f6$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $jIe84 = parcelRequire("jIe84");
var $ac0eX = parcelRequire("ac0eX");
var $6NMje = parcelRequire("6NMje");
var $aCV3p = parcelRequire("aCV3p");

var $fuLgT = parcelRequire("fuLgT");

var $6e3tU = parcelRequire("6e3tU");

var $7qFQI = parcelRequire("7qFQI");

var $lP7A9 = parcelRequire("lP7A9");

var $kbpa7 = parcelRequire("kbpa7");

var $j2b52 = parcelRequire("j2b52");

var $gx3aw = parcelRequire("gx3aw");

var $3riD8 = parcelRequire("3riD8");

var $kEjoI = parcelRequire("kEjoI");

// Load omni-channel UI only on the client when widget is open to avoid SSR 503 (Tesseract)
const $c6548387155117f6$var$ChatWidgetOmniChannelUI = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>(parcelRequire("ilYix")));

// Lazy-load analytics when fetchChatConnectionConfig succeeds (keeps @atlassian/omni-channel out of main bundle)
const $c6548387155117f6$var$ChatWidgetCustomerJoinedAnalytics = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>(parcelRequire("jap9H")));

// Lazy-load analytics when fetchToken fails (same chunk as customer-joined analytics)
const $c6548387155117f6$var$ChatWidgetTokenErrorAnalytics = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>(parcelRequire("jap9H")).then((m)=>({
            default: m.ChatWidgetTokenErrorAnalytics
        })));

// Lazy-load analytics when fetchChatConnectionConfig succeeds
const $c6548387155117f6$var$ChatWidgetConnectionConfigSuccessAnalytics = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>(parcelRequire("jap9H")).then((m)=>({
            default: m.ChatWidgetConnectionConfigSuccessAnalytics
        })));

// Lazy-load analytics when fetchToken succeeds (channelPlatformTokenError empty or null)
const $c6548387155117f6$var$ChatWidgetTokenSuccessAnalytics = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>(parcelRequire("jap9H")).then((m)=>({
            default: m.ChatWidgetTokenSuccessAnalytics
        })));
const $c6548387155117f6$export$8a240b2f27c2948f = (url)=>{
    try {
        const urlObj = new URL(url);
        let pathname = urlObj.pathname.replace(/\/+$/, '');
        if (pathname.startsWith('/wac/')) pathname = pathname.slice(4);
        return pathname.replace(/^\/+/, '');
    } catch  {
        const match = /\/\/[^/]+(\/[^#?]*)/.exec(url);
        if (match?.[1]) {
            let pathname = match[1].replace(/\/+$/, '');
            if (pathname.startsWith('/wac/')) pathname = pathname.slice(4);
            return pathname.replace(/^\/+/, '');
        }
        return '';
    }
};
const $c6548387155117f6$var$CHAT_SUPPORT_CONFIG_BY_URL_PATH = {
    'software/jira/product-discovery': {
        contactFlowId: "39457874-4e30-4774-89a6-e086842bdcb6",
        formKey: [
            'ca-growth-pricing-billing-and-licensing'
        ]
    },
    'software/jira/service-management': {
        contactFlowId: "39457874-4e30-4774-89a6-e086842bdcb6",
        formKey: [
            'ca-growth-pricing-billing-and-licensing'
        ]
    },
    'software/jira': {
        contactFlowId: "1825e6f7-75fc-47e2-b634-98923fa4a3b1",
        formKey: [
            'ca-growth-pricing-billing-and-licensing'
        ]
    },
    'software/loom': {
        contactFlowId: "dc335c33-9da5-4291-842b-80956f53d2b7",
        formKey: [
            'ca-growth-pricing-billing-and-licensing'
        ]
    },
    'software/loom/loom-confluence': {
        contactFlowId: "7cf56869-3db7-431e-8311-b524e6065934",
        formKey: [
            'ca-growth-pricing-billing-and-licensing'
        ]
    },
    'software/loom/loom-jira': {
        contactFlowId: "199f4750-6436-4b88-a2db-c2b87c1bdaed",
        formKey: [
            'ca-growth-pricing-billing-and-licensing'
        ]
    },
    'software/loom/resources': {
        contactFlowId: "eadd2afc-29bb-4e9c-a0d6-370fd70186eb",
        formKey: [
            'ca-growth-pricing-billing-and-licensing'
        ]
    },
    'software/loom/ai-meeting': {
        contactFlowId: "364f6abb-5628-41c1-bf90-b3ca2486378d",
        formKey: [
            'ca-growth-pricing-billing-and-licensing'
        ]
    },
    'software/loom/editing': {
        contactFlowId: "a4addd51-eb96-46fc-b5a9-3f99c3d923de",
        formKey: [
            'ca-growth-pricing-billing-and-licensing'
        ]
    },
    'ja/company/contact/japan': {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            'jpns-growth-pricing-billing-and-licensing'
        ]
    },
    'ja/software/jira/service-management': {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            'jpns-growth-pricing-billing-and-licensing'
        ]
    },
    'ja/software/jira/pricing': {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            'jpns-growth-pricing-billing-and-licensing'
        ]
    },
    ja: {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            'jpns-growth-pricing-billing-and-licensing'
        ]
    },
    'ja/software/confluence': {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            'jpns-growth-pricing-billing-and-licensing'
        ]
    },
    'ja/software/confluence/pricing': {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            'jpns-growth-pricing-billing-and-licensing'
        ]
    },
    'ja/software/jira/service-management/pricing': {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            'jpns-growth-pricing-billing-and-licensing'
        ]
    }
};
const $c6548387155117f6$export$a8ad7472af635967 = (path)=>{
    const normalizedPath = path.replace(/^\/+|\/+$/g, '');
    return $c6548387155117f6$var$CHAT_SUPPORT_CONFIG_BY_URL_PATH[normalizedPath] ?? {
        contactFlowId: ''
    };
};
const $c6548387155117f6$export$b28607ea792e8283 = (path)=>{
    const normalizedPath = path.replace(/^\/+|\/+$/g, '');
    const entry = $c6548387155117f6$var$CHAT_SUPPORT_CONFIG_BY_URL_PATH[normalizedPath];
    if (entry && Array.isArray(entry.formKey)) return entry.formKey;
    return [
        ''
    ];
};
const $c6548387155117f6$export$39f87d2399b576ea = (path)=>{
    const normalizedPath = path.replace(/^\/+|\/+$/g, '');
    const entry = $c6548387155117f6$var$CHAT_SUPPORT_CONFIG_BY_URL_PATH[normalizedPath];
    if (entry && typeof entry.attributes === 'object' && entry.attributes !== null) return JSON.stringify(entry.attributes, null, 2);
    return '{}';
};
const $c6548387155117f6$export$c452173f1b4082d7 = (path)=>{
    const normalizedPath = path.replace(/^\/+|\/+$/g, '');
    return normalizedPath === 'ja' || normalizedPath.startsWith('ja/');
};
const $c6548387155117f6$export$8378cdc69cfc311a = (url)=>{
    try {
        const urlObj = new URL(url);
        const pathname = urlObj.pathname;
        // Remove leading and trailing slashes, then split by '/' and filter out empty strings
        const pathParts = pathname.replace(/^\/+|\/+$/g, '').split('/').filter((part)=>part.length > 0);
        // Join with underscores
        return pathParts.join('_');
    } catch  {
        // If URL parsing fails, try to extract path manually
        const match = /\/\/[^\/]+(\/[^?#]*)/.exec(url);
        if (match && match[1]) {
            const pathname = match[1];
            const pathParts = pathname.replace(/^\/+|\/+$/g, '').split('/').filter((part)=>part.length > 0);
            return pathParts.join('_');
        }
        return '';
    }
};
const $c6548387155117f6$export$2b66390f6eecea5c = (payload)=>{
    const transformed = {};
    if (!payload) return transformed;
    Object.entries(payload).forEach(([key, value])=>{
        // Skip attachments
        if (key === 'attachments') return;
        // Skip null or undefined values
        if (value === null || value === undefined) return;
        // Handle arrays - normalize to array of strings
        if (Array.isArray(value)) transformed[key] = value.map((v)=>{
            // If array element is an object (like {userEmail: "value"}), extract the first value
            if (typeof v === 'object' && v !== null && !Array.isArray(v)) {
                const firstValue = Object.values(v)[0];
                return firstValue !== undefined ? String(firstValue) : String(v);
            }
            // Already a string or primitive
            return String(v);
        });
        else transformed[key] = [
            String(value)
        ];
    });
    return transformed;
};
const $c6548387155117f6$export$a40d7197cc58cf92 = (payload)=>{
    return JSON.stringify(payload);
};
const $c6548387155117f6$export$b13b32483d23f773 = (formValues, flowId, analyticsSessionId)=>{
    const metadata = {};
    if (analyticsSessionId) metadata['analyticsSessionId'] = analyticsSessionId;
    // Only include flowId if it has a value
    if (flowId) metadata['flowId'] = flowId;
    if (formValues?.contactEmail) metadata['email'] = formValues.contactEmail;
    return JSON.stringify(metadata);
};
const $c6548387155117f6$export$6999922c2cdd8944 = (chatConnectionConfigResponse)=>{
    const submitRequest = chatConnectionConfigResponse?.channelPlatform_createContact;
    return {
        channelPlatform_submitRequest: submitRequest
    };
};
function $c6548387155117f6$export$c0c7c314cc68764f(config) {
    const contact = config?.channelPlatform_createContact;
    return contact?.value?.contactId;
}
function $c6548387155117f6$export$f0671fd2506d780c(config) {
    const contact = config?.channelPlatform_createContact;
    const value = contact?.value;
    return {
        contactId: value?.contactId,
        participantId: value?.participantId,
        region: value?.region
    };
}
function $c6548387155117f6$var$getChatConnectionFormValues(contextId, userEmail, isUserLoggedIn) {
    return {
        cst_support_forms_data_fieldDescMap: [
            '{"inquiry_category":"Inquiry Category","email":"Email","raised_obo_by":"Raised on behalf of by","language":"language","customer_working_hours":"Support Business Hours Select"}'
        ],
        customer_email: [
            isUserLoggedIn ? userEmail : ''
        ],
        authenticated: isUserLoggedIn ? null : [
            'No'
        ],
        email: [
            isUserLoggedIn ? userEmail : ''
        ],
        customer_status: [
            'Customer'
        ],
        cst_support_forms_data_formKey: $c6548387155117f6$export$b28607ea792e8283($c6548387155117f6$export$8a240b2f27c2948f(window.location.href)),
        cst_support_forms_data_formLabel: $c6548387155117f6$export$b28607ea792e8283($c6548387155117f6$export$8a240b2f27c2948f(window.location.href)),
        cst_support_forms_data_timezone: [
            'GMT+6'
        ],
        referral_url: [
            window.location.href
        ],
        language: [
            'en'
        ],
        is_partner_dc_exception: [
            'Customer not in SFDC'
        ],
        topic: [
            $c6548387155117f6$export$8378cdc69cfc311a(window.location.href)
        ],
        summary: [
            $c6548387155117f6$export$8378cdc69cfc311a(window.location.href).split('_').join(' ')
        ],
        support_channel: [
            'chat'
        ],
        inquiry_category: [
            'access_issues'
        ],
        cst_support_forms_data_contextId: [
            contextId
        ]
    };
}
function $c6548387155117f6$var$shouldFetchConversationsOnOpen(isWidgetOpen, wasOpenCurrent, clientToken, clientWithToken) {
    return isWidgetOpen && !wasOpenCurrent && !!clientToken && !!clientWithToken;
}
function $c6548387155117f6$var$getChatConnectionMetadataPayload(userEmail, isUserLoggedIn) {
    return {
        flowId: $c6548387155117f6$export$a8ad7472af635967($c6548387155117f6$export$8a240b2f27c2948f(window.location.href)).contactFlowId,
        formContext: {
            summary: [
                'Chat Transcript for <email removed for privacy>'
            ],
            details: '',
            contactEmail: isUserLoggedIn ? userEmail ?? '' : '',
            isAuthenticated: isUserLoggedIn
        }
    };
}
function $c6548387155117f6$var$hasCustomerConversations(response) {
    const count = response?.channelPlatform_getCustomerConversations?.conversations?.length ?? 0;
    return count > 0;
}
function $c6548387155117f6$var$getChatWidgetViewState(isWidgetOpen, clientToken, chatConnectionConfig, isCustomerComponentLoaded) {
    const isChatLoaded = isWidgetOpen && !!clientToken && !!chatConnectionConfig && isCustomerComponentLoaded;
    return {
        isChatLoaded: isChatLoaded,
        showFloatingButton: !isChatLoaded,
        isButtonLoading: isWidgetOpen && (!clientToken || !chatConnectionConfig || !isCustomerComponentLoaded)
    };
}
const $c6548387155117f6$var$ChatFloatingButton = ({ isLoading: isLoading, onClick: onClick, onKeyDown: onKeyDown })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        role: "button",
        tabIndex: 0,
        "aria-label": isLoading ? 'Loading chat' : 'Open chat widget',
        style: {
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            zIndex: 1000,
            cursor: isLoading ? 'wait' : 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '56px',
            height: '56px',
            borderRadius: '50%',
            backgroundColor: (0, $kbpa7.wacToken)('color.primary.blue'),
            color: 'white',
            boxShadow: (0, $lP7A9.default)('elevation.shadow.raised')
        },
        onClick: onClick,
        onKeyDown: onKeyDown,
        children: isLoading ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7qFQI.default), {
            size: "medium",
            label: "Loading chat",
            appearance: "invert"
        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6e3tU))), {
            label: "",
            size: "medium",
            color: "currentColor"
        })
    });
};

function $c6548387155117f6$var$useChatWidgetConnection({ isWidgetOpen: isWidgetOpen, contextId: contextId, userEmail: userEmail, isUserLoggedIn: isUserLoggedIn, setIsCustomerComponentLoaded: setIsCustomerComponentLoaded }) {
    const [clientToken, setClientToken] = (0, $1oC0p.useState)(null);
    const [chatConnectionConfig, setChatConnectionConfig] = (0, $1oC0p.useState)(null);
    const [loading, setLoading] = (0, $1oC0p.useState)(false);
    const [error, setError] = (0, $1oC0p.useState)(null);
    const [channelPlatformTokenError, setChannelPlatformTokenError] = (0, $1oC0p.useState)(null);
    const [customerConversationsResponse, setCustomerConversationsResponse] = (0, $1oC0p.useState)(null);
    const generateAuthHeader = (channelsIdentityHash)=>new (0, $ac0eX.ApolloLink)((operation, forward)=>{
            operation.setContext(({ headers: headers = {} })=>({
                    headers: {
                        ...headers,
                        'Content-Type': 'application/json',
                        'X-Client-Hash': channelsIdentityHash
                    }
                }));
            return forward(operation);
        });
    const client = (0, $1oC0p.useMemo)(()=>{
        const link = new (0, $6NMje.HttpLink)({
            uri: "https://www.atlassian.com/gateway/api/graphql",
            credentials: 'include'
        });
        return new (0, $jIe84.ApolloClient)({
            link: link,
            cache: new (0, $aCV3p.InMemoryCache)()
        });
    }, []);
    const wasWidgetOpenRef = (0, $1oC0p.useRef)(false);
    const clientWithToken = (0, $1oC0p.useMemo)(()=>{
        if (!clientToken) return null;
        const link = new (0, $6NMje.HttpLink)({
            uri: "https://www.atlassian.com/gateway/api/graphql",
            credentials: 'include'
        });
        return new (0, $jIe84.ApolloClient)({
            link: (0, $ac0eX.ApolloLink).from([
                generateAuthHeader(clientToken),
                link
            ]),
            cache: new (0, $aCV3p.InMemoryCache)()
        });
    }, [
        clientToken
    ]);
    const isRefreshed = (0, $1oC0p.useMemo)(()=>$c6548387155117f6$var$hasCustomerConversations(customerConversationsResponse), [
        customerConversationsResponse
    ]);
    const fetchCustomerConversations = (0, $1oC0p.useCallback)(()=>{
        if (!clientWithToken) return;
        const anonymousId = (0, $gx3aw.Cookie).readCookie('ajs_anonymous_id') || '';
        clientWithToken.query({
            query: (0, $kEjoI.getCustomerConversations),
            variables: {
                anonymousId: anonymousId
            }
        }).then((response)=>{
            setCustomerConversationsResponse(response?.data ?? null);
        }).catch((err)=>{
            console.warn('Error fetching customer conversations:', err);
            setCustomerConversationsResponse(null);
        });
    }, [
        clientWithToken
    ]);
    const fetchChatConnectionConfig = (0, $1oC0p.useCallback)(async ()=>{
        if (!clientWithToken) {
            console.warn('Client with token not available yet');
            return;
        }
        setLoading(true);
        const formValues = $c6548387155117f6$var$getChatConnectionFormValues(contextId, userEmail ?? '', isUserLoggedIn);
        // Dynamic import to avoid pulling @atlassiansox/analytics-web-client
        // (which calls setTimeout at module init) into the SSR bundle.
        const { getAnalyticsWebClient: getAnalyticsWebClient } = await (parcelRequire("ix6JR"));
        const metadataPayload = $c6548387155117f6$var$getChatConnectionMetadataPayload(userEmail, isUserLoggedIn);
        const metadata = $c6548387155117f6$export$b13b32483d23f773({
            contactEmail: metadataPayload.formContext['contactEmail']
        }, metadataPayload.flowId, getAnalyticsWebClient().getCurrentSessionId());
        clientWithToken.query({
            query: (0, $kEjoI.getChatConnectionConfigForSalesChannel),
            variables: {
                requestType: 'CHAT',
                payload: $c6548387155117f6$export$2b66390f6eecea5c(formValues),
                metadata: metadata,
                attributes: JSON.parse($c6548387155117f6$export$39f87d2399b576ea($c6548387155117f6$export$8a240b2f27c2948f(window.location.href))) ?? {},
                anonymousId: (0, $gx3aw.Cookie).readCookie('ajs_anonymous_id') || ''
            }
        }).then((response)=>{
            setChatConnectionConfig(response?.data);
            setLoading(false);
        }).catch((err)=>{
            console.error('Error fetching chat connection config:', err);
            setError(err);
            setLoading(false);
        });
    }, [
        clientWithToken,
        contextId,
        isUserLoggedIn,
        userEmail
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if ($c6548387155117f6$var$shouldFetchConversationsOnOpen(isWidgetOpen, wasWidgetOpenRef.current, clientToken, clientWithToken)) {
            wasWidgetOpenRef.current = true;
            fetchCustomerConversations();
            fetchChatConnectionConfig();
        }
        if (!isWidgetOpen) {
            wasWidgetOpenRef.current = false;
            setIsCustomerComponentLoaded(false);
        }
    }, [
        isWidgetOpen,
        clientToken,
        clientWithToken,
        fetchCustomerConversations,
        fetchChatConnectionConfig,
        setIsCustomerComponentLoaded
    ]);
    const fetchToken = (0, $1oC0p.useCallback)(()=>{
        setLoading(true);
        client.query({
            query: (0, $kEjoI.getChannelPlatformTokenByClientName),
            variables: {
                clientName: 'sales'
            }
        }).then((response)=>{
            const token = response.data?.supportInquiry_channelsIdentityHashByClientName;
            if (token) {
                setClientToken(token);
                setChannelPlatformTokenError(null);
            }
            setLoading(false);
        }).catch((err)=>{
            console.error('Error fetching channel platform token:', err);
            setError(err);
            setLoading(false);
            const errorMessage = err instanceof Error ? err.message : String(err);
            setChannelPlatformTokenError(errorMessage);
        });
    }, [
        client
    ]);
    return {
        clientToken: clientToken,
        chatConnectionConfig: chatConnectionConfig,
        loading: loading,
        error: error,
        channelPlatformTokenError: channelPlatformTokenError,
        client: client,
        clientWithToken: clientWithToken,
        isRefreshed: isRefreshed,
        customerConversationsResponse: customerConversationsResponse,
        setClientToken: setClientToken,
        fetchToken: fetchToken
    };
}
const $c6548387155117f6$export$a4cac963ae9f34ca = ({ children: children })=>{
    const [isWidgetOpen, setIsWidgetOpen] = (0, $1oC0p.useState)(false);
    const [isCustomerComponentLoaded, setIsCustomerComponentLoaded] = (0, $1oC0p.useState)(false);
    const { accountId: aaid, email: userEmail, isUserLoggedIn: isUserLoggedIn } = (0, $3riD8.useLoggedInUser)();
    const contextId = (0, $1oC0p.useMemo)(()=>(0, $fuLgT.default)(), []);
    const connection = $c6548387155117f6$var$useChatWidgetConnection({
        isWidgetOpen: isWidgetOpen,
        contextId: contextId,
        userEmail: userEmail,
        isUserLoggedIn: isUserLoggedIn,
        setIsCustomerComponentLoaded: setIsCustomerComponentLoaded
    });
    const { clientToken: clientToken, chatConnectionConfig: chatConnectionConfig, loading: loading, error: error, channelPlatformTokenError: channelPlatformTokenError, isRefreshed: isRefreshed, customerConversationsResponse: customerConversationsResponse } = connection;
    const surveyModalAttributes = {
        width: '80%',
        height: 500
    };
    const omniChannelEnv = 'production';
    const handleChatButtonClick = ()=>{
        const opening = !isWidgetOpen;
        setIsWidgetOpen(opening);
        if (opening) connection.fetchToken();
    };
    const handleChatButtonKeyDown = (event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleChatButtonClick();
        }
    };
    const viewState = $c6548387155117f6$var$getChatWidgetViewState(isWidgetOpen, clientToken, chatConnectionConfig, isCustomerComponentLoaded);
    const showChatPanel = isWidgetOpen && !!chatConnectionConfig && !!clientToken;
    const conversationId = $c6548387155117f6$export$c0c7c314cc68764f(chatConnectionConfig);
    const connectionConfigAttributes = $c6548387155117f6$export$f0671fd2506d780c(chatConnectionConfig);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            children,
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j2b52.ClientOnly), {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                    children: [
                        chatConnectionConfig && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Suspense), {
                            fallback: null,
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetCustomerJoinedAnalytics, {
                                    conversationId: conversationId
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetConnectionConfigSuccessAnalytics, {
                                    contactId: connectionConfigAttributes.contactId,
                                    participantId: connectionConfigAttributes.participantId,
                                    region: connectionConfigAttributes.region
                                })
                            ]
                        }),
                        channelPlatformTokenError && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                            fallback: null,
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetTokenErrorAnalytics, {
                                channelPlatformTokenError: channelPlatformTokenError
                            })
                        }),
                        clientToken && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                            fallback: null,
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetTokenSuccessAnalytics, {
                                clientToken: clientToken,
                                channelPlatformTokenError: channelPlatformTokenError
                            })
                        }),
                        viewState.showFloatingButton && /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatFloatingButton, {
                            isLoading: viewState.isButtonLoading,
                            onClick: handleChatButtonClick,
                            onKeyDown: handleChatButtonKeyDown
                        }),
                        showChatPanel && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                            fallback: null,
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetOmniChannelUI, {
                                env: omniChannelEnv,
                                clientIdentityHash: clientToken || '',
                                chatContactDetails: $c6548387155117f6$export$6999922c2cdd8944(chatConnectionConfig),
                                accountId: aaid || '',
                                isRefreshed: isRefreshed,
                                customerConversations: customerConversationsResponse,
                                loading: loading,
                                error: error,
                                isUserLoggedIn: isUserLoggedIn,
                                surveyModalAttributes: surveyModalAttributes,
                                onLoaded: ()=>setIsCustomerComponentLoaded(true)
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $c6548387155117f6$export$2e2bcd8739ae039 = $c6548387155117f6$export$a4cac963ae9f34ca;

});
parcelRegister("6e3tU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::451c857042316b193f6451d1ac5153c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4886c0393fe869b5$var$_react = $4886c0393fe869b5$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $4886c0393fe869b5$var$_baseNew = $4886c0393fe869b5$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $4886c0393fe869b5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4886c0393fe869b5$var$CommentIcon = (props)=>/*#__PURE__*/ $4886c0393fe869b5$var$_react.default.createElement($4886c0393fe869b5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$4886c0393fe869b5$var$CommentIcon.displayName = 'CommentIcon';
var $4886c0393fe869b5$var$_default = module.exports.default = $4886c0393fe869b5$var$CommentIcon;

});

parcelRegister("kEjoI", function(module, exports) {
$parcel$export(module.exports, "getChatConnectionConfigForSalesChannel", function () { return $59b9792633dffc77$export$2fedc4b0d22f20b3; });
$parcel$export(module.exports, "getCustomerConversations", function () { return $59b9792633dffc77$export$54e9b7f1aad2199a; });
$parcel$export(module.exports, "getChannelPlatformTokenByClientName", function () { return $59b9792633dffc77$export$c543cd67c9b21e36; });

var $4Wqet = parcelRequire("4Wqet");
const $59b9792633dffc77$export$51e62cbd534f416c = (0, $4Wqet.gql)`
	query channelPlatformTokenGeneration {
		supportInquiry_channelsIdentityHash
	}
`;
const $59b9792633dffc77$export$2fedc4b0d22f20b3 = (0, $4Wqet.gql)`
	query CreateContact(
		$requestType: ChannelPlatformChannelType!
		$payload: JSON
		$metadata: JSON
		$anonymousId: String
		$attributes: JSON
	) {
		channelPlatform_createContact(
			requestType: $requestType
			request: { payload: $payload, metadata: $metadata, attributes: $attributes }
			anonymousId: $anonymousId
		) {
			channel
			value {
				... on ChannelPlatformGetChannelTokenResponse {
					participantId
					participantToken
					region
					contactId
				}
			}
		}
	}
`;
const $59b9792633dffc77$export$54e9b7f1aad2199a = (0, $4Wqet.gql)`
	query CustomerConversations($anonymousId: String) {
		channelPlatform_getCustomerConversations(anonymousId: $anonymousId) {
			conversations
		}
	}
`;
const $59b9792633dffc77$export$f843774d31ce9c0c = (0, $4Wqet.gql)`
	query CreateContact($requestType: ChannelPlatformChannelType!, $payload: JSON, $metadata: JSON) {
		channelPlatform_createContact(
			requestType: $requestType
			request: { payload: $payload, metadata: $metadata }
		) {
			channel
			value {
				... on ChannelPlatformGetChannelTokenResponse {
					participantId
					participantToken
					region
					contactId
				}
			}
		}
	}
`;
const $59b9792633dffc77$export$c543cd67c9b21e36 = (0, $4Wqet.gql)`
	query channelPlatformTokenGenerationByClientName($clientName: String) {
		supportInquiry_channelsIdentityHashByClientName(request: { clientName: $clientName })
	}
`;

});

parcelRegister("ilYix", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = Promise.all([
    $eao4m("iwtJN"),
    $eao4m("69gSk"),
    $eao4m("2TJ5h"),
    $eao4m("cjcRX"),
    $eao4m("gmjn8"),
    $eao4m("9OXzg"),
    $eao4m("kY8TR"),
    $eao4m("lzpxo"),
    $eao4m("2RgTJ"),
    $eao4m("Oum3S"),
    $eao4m("38uoB"),
    $eao4m("iYBBz"),
    $eao4m("gmcn8"),
    $eao4m("erzni"),
    $eao4m("9E5dL"),
    $eao4m("8s7qj"),
    $eao4m("69oGP"),
    $eao4m("ch50F"),
    $eao4m("DSYwq"),
    $eao4m("8Hh5M"),
    $eao4m("aWPy3"),
    $eao4m("76kmj")
]).then(()=>parcelRequire('8Cs4z'));

});

parcelRegister("jap9H", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = Promise.all([
    $eao4m("iwtJN"),
    $eao4m("lzpxo"),
    $eao4m("69oGP"),
    $eao4m("hx68B")
]).then(()=>parcelRequire('cJIcN'));

});

parcelRegister("ix6JR", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("4lJtX").then(()=>parcelRequire('k1dhr'));

});


parcelRegister("gZJ17", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryTemplate", function () { return $6656f5e31aa2d995$export$55460b563be26bbf; });

var $7VQPk = parcelRequire("7VQPk");

var $jsxHL = parcelRequire("jsxHL");

var $iLjCW = parcelRequire("iLjCW");

var $fhttR = parcelRequire("fhttR");

var $aYwTu = parcelRequire("aYwTu");

var $cwVvH = parcelRequire("cwVvH");

var $ceI23 = parcelRequire("ceI23");

var $lY5mc = parcelRequire("lY5mc");

var $hBk6f = parcelRequire("hBk6f");

var $haaSq = parcelRequire("haaSq");

var $lLZy5 = parcelRequire("lLZy5");

var $tce8m = parcelRequire("tce8m");

var $dMCHr = parcelRequire("dMCHr");

var $5OLfs = parcelRequire("5OLfs");

var $8yYDi = parcelRequire("8yYDi");
const $6656f5e31aa2d995$export$55460b563be26bbf = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aYwTu.default), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("main", {
                    id: "content",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fhttR.JPDBanner), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lLZy5.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5OLfs.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hBk6f.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $haaSq.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dMCHr.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cwVvH.AtlassianIntelligence), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $tce8m.HowItWorks), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8yYDi.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ceI23.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lY5mc.default), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iLjCW.GlobalFooter), {})
        ]
    });
};

});
parcelRegister("fhttR", function(module, exports) {
$parcel$export(module.exports, "JPDBanner", function () { return $ffacf727c21fa555$export$637e7e5d1efd26e9; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $jVACb = parcelRequire("jVACb");

var $jQ0cd = parcelRequire("jQ0cd");

var $iRMRa = parcelRequire("iRMRa");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
const $ffacf727c21fa555$export$637e7e5d1efd26e9 = ()=>{
    const intl = (0, $8e22h.default)();
    const gwp6473JpdPremiumBanner = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp6473JpdPremiumBanner);
    const gwp7456JpdStateOfProductBanner = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7456JpdStateOfProductBanner);
    const gwp8038JpdBannerWebinar = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp8038JpdBannerWebinar);
    const gwp9038JdpAIWebinarBanner = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp9038JdpAIWebinarBanner);
    const jpdBannerMessagesWebinar = {
        identifier: 'JPDPageTemplate.webinar-announcement',
        text: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JPDPageTemplate.banner-alert.state-of-product-webinar-announcement",
            defaultMessage: "<strong>State of Product 2026:</strong> Register for the webinar to hear the surprising findings!",
            values: (0, $iRMRa.DEFAULT_VALUES)
        }),
        linkText: intl.formatMessage({
            id: 'JPDPageTemplate.banner-alert.state-of-product-webinar-announcement.link-text',
            defaultMessage: "Register now \u2192"
        }),
        linkUrl: (0, $jQ0cd.useLocalizedHref)('/webinars/software/state-of-product-2026'),
        dataEventProps: {
            'data-product-key': 'confluence',
            'data-event-component': 'linkButton',
            'data-event-container': 'announcementBanner',
            'data-event': 'clicked',
            'data-label': 'Register now',
            'data-label-english': 'Register now',
            'data-track-event': 'jpdPageTemplate.bannerAlert.stateOfProductWebinarAnnouncement.registerNow'
        }
    };
    const jpdBannerMessagesStateOfProduct = {
        identifier: 'JPDPageTemplate.premium-announcement',
        text: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JPDPageTemplate.banner-alert.state-of-product-announcement",
            defaultMessage: "<strong>State of Product 2026:</strong> Find out what 1000+ product teams think in our newest research report.",
            values: (0, $iRMRa.DEFAULT_VALUES)
        }),
        linkText: intl.formatMessage({
            id: 'JPDPageTemplate.banner-alert.state-of-product-announcement.link-text',
            defaultMessage: "Read now \u2192"
        }),
        linkUrl: (0, $jQ0cd.useLocalizedHref)('/software/jira/product-discovery/resources/state-of-product-2026'),
        dataEventProps: {
            'data-product-key': 'confluence',
            'data-event-component': 'linkButton',
            'data-event-container': 'announcementBanner',
            'data-event': 'clicked',
            'data-label': 'Read now',
            'data-label-english': 'Read now',
            'data-track-event': 'jpdPageTemplate.bannerAlert.stateOfProductAnnouncement.readNow'
        }
    };
    const jpdBannerMessagesAIWebinar = {
        identifier: 'JPDPageTemplate.ai-webinar-annnouncement',
        text: intl.formatMessage({
            id: 'JPDPageTemplate.banner-alert.ai-webinar-annnouncement',
            defaultMessage: 'AI product strategy: How to build & win today.'
        }),
        linkText: intl.formatMessage({
            id: 'JPDPageTemplate.link-text',
            defaultMessage: "Get the Details \u2192"
        }),
        linkUrl: (0, $jQ0cd.useLocalizedHref)('/webinars/software/jira-product-discovery-ai-webinar'),
        dataEventProps: {
            'data-product-key': 'confluence',
            'data-event-component': 'linkButton',
            'data-event-container': 'announcementBanner',
            'data-event': 'clicked',
            'data-label': 'Get the Details',
            'data-label-english': 'Get the Details',
            'data-track-event': 'jpdPageTemplate.announcementBanner.learnMore'
        }
    };
    const jpdBannerMessagesPremium = {
        identifier: 'JPDPageTemplate.premium-announcement',
        text: intl.formatMessage({
            id: 'JPDPageTemplate.banner-alert.premium-announcement',
            defaultMessage: 'Jira Product Discovery Premium is now available! Get more visibility, control, and support to build products at scale.'
        }),
        linkText: intl.formatMessage({
            id: 'JPDPageTemplate.link-text',
            defaultMessage: "Learn more \u2192"
        }),
        linkUrl: (0, $jQ0cd.useLocalizedHref)('/software/jira/product-discovery/premium'),
        dataEventProps: {
            'data-product-key': 'confluence',
            'data-event-component': 'linkButton',
            'data-event-container': 'announcementBanner',
            'data-event': 'clicked',
            'data-label': 'Learn more',
            'data-label-english': 'Learn more',
            'data-track-event': 'jpdPageTemplate.announcementBanner.learnMore'
        }
    };
    if (gwp9038JdpAIWebinarBanner) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jVACb.BannerAlert), {
        ...jpdBannerMessagesAIWebinar
    });
    if (gwp8038JpdBannerWebinar) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jVACb.BannerAlert), {
        ...jpdBannerMessagesWebinar
    });
    if (gwp7456JpdStateOfProductBanner) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jVACb.BannerAlert), {
        ...jpdBannerMessagesStateOfProduct
    });
    if (gwp6473JpdPremiumBanner) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jVACb.BannerAlert), {
        ...jpdBannerMessagesPremium
    });
    return null;
};

});

parcelRegister("aYwTu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a060b684c4f472c9$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $20OkY = parcelRequire("20OkY");

var $asbmK = parcelRequire("asbmK");

var $eOIix = parcelRequire("eOIix");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $gn6Qa = parcelRequire("gn6Qa");
const $a060b684c4f472c9$var$JpdLogo = ()=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "jiraproductdiscovery",
        type: "logo",
        appearance: "brand",
        darkTheme: isDarkTheme
    });
};
const $a060b684c4f472c9$var$JiraProductDiscoveryNavV2 = ()=>{
    const intl = (0, $8e22h.default)();
    const signupLink = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=jira-product-discovery');
    const { openCrossFlow: openCrossFlow } = (0, $asbmK.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).JIRA_PRODUCT_DISCOVERY,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const links = [
        {
            globalLinksKey: 'features',
            linkText: intl.formatMessage({
                // this id can be renamed once the above has been fixed as well
                id: 'jiraproductdiscovery.navbar.product-features',
                defaultMessage: 'Features'
            }),
            hasDropdown: false,
            productKey: 'jiraProductDiscovery',
            href: (0, $jQ0cd.useLocalizedHref)('/software/jira/product-discovery/features')
        },
        {
            globalLinksKey: 'resources',
            linkText: intl.formatMessage({
                id: 'jiraproductdiscovery.navbar.resources',
                defaultMessage: 'Resources'
            }),
            hasDropdown: false,
            productKey: 'jiraProductDiscovery',
            href: (0, $jQ0cd.useLocalizedHref)('/software/jira/product-discovery/resources')
        },
        {
            globalLinksKey: 'guides',
            linkText: intl.formatMessage({
                id: 'jiraproductdiscovery.navbar.guides',
                defaultMessage: 'Guides'
            }),
            hasDropdown: false,
            productKey: 'jiraProductDiscovery',
            href: (0, $jQ0cd.useLocalizedHref)('/software/jira/product-discovery/guides/getting-started/introduction')
        },
        {
            globalLinksKey: 'pricing',
            linkText: intl.formatMessage({
                // this id should be renamed, but for Team'24 hotfix we need to keep existing mapping
                id: 'jiraproductdiscovery.navbar.features',
                defaultMessage: 'Pricing'
            }),
            hasDropdown: false,
            productKey: 'jiraProductDiscovery',
            href: (0, $jQ0cd.useLocalizedHref)('/software/jira/product-discovery/pricing')
        }
    ];
    const ctaText = intl.formatMessage({
        id: 'productNavBar.get-it-free-button',
        defaultMessage: 'Get it free'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gn6Qa.ProductPageNav), {
        productLogoUrl: (0, $jQ0cd.useLocalizedHref)('/software/jira/product-discovery'),
        productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($a060b684c4f472c9$var$JpdLogo, {}),
        productLogoAriaLabel: intl.formatMessage({
            id: 'wacJiraProductDiscoveryNavigation.logo-label',
            defaultMessage: 'Jira Product Discovery logo'
        }),
        mobileCtaText: ctaText,
        mobileCtaUrl: signupLink,
        mobileCtaOnClick: openCrossFlow,
        mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($a060b684c4f472c9$var$JpdLogo, {}),
        navigationTrynowCtaText: ctaText,
        navigationTrynowCtaUrl: signupLink,
        navigationTrynowCtaOnClick: openCrossFlow,
        productPageNavLinks: links,
        mobileLinksSections: [
            {
                mobileLinkKey: 'mobile-jira-product-discovery',
                mobileLinksProps: links
            }
        ]
    });
};
$a060b684c4f472c9$var$JiraProductDiscoveryNavV2.displayName = 'JiraProductDiscoveryNavV2';
var $a060b684c4f472c9$export$2e2bcd8739ae039 = $a060b684c4f472c9$var$JiraProductDiscoveryNavV2;

});

parcelRegister("cwVvH", function(module, exports) {
$parcel$export(module.exports, "AtlassianIntelligence", function () { return $49ae067eb8751f37$export$eec9700d5a261698; });
/* ai.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $jKShK = parcelRequire("jKShK");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $hnmMQ = parcelRequire("hnmMQ");

var $iPPTB = parcelRequire("iPPTB");

var $jQ0cd = parcelRequire("jQ0cd");

var $1rGpC = parcelRequire("1rGpC");
const $49ae067eb8751f37$var$ArrowPencilPointRight = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        style: {
            color: props.color ? props.color : 'currentColor',
            transform: `rotate(${props.rotate ? props.rotate : '0'}deg)`
        },
        width: "50",
        height: "17",
        viewBox: "0 0 72 25",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $2jatx.default)([
            "_tnrurdoj _1rfm1tcg _1vkhl52n _12rr12am"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fill: "currentColor",
            d: "M59.938 15.4c-.92-.48-1.816-.597-2.7-.75a7.975 7.975 0 0 0-2.872.044c-.848.163-1.709.062-2.511-.19-1.5-.473-3.039-.55-4.597-.555-.973-.005-1.959-.054-2.916-.202-.663-.104-1.292-.416-1.965-.642-.392.625-.992.599-1.612.367-1.278-.481-2.594-.57-3.947-.543-.736.014-1.463-.158-2.068-.635-.077-.056-.175-.084-.267-.117-.61.602-1.323.564-2.063.397-1.19-.262-2.387-.5-3.577-.762-.804-.18-1.606-.377-2.409-.569-.797-.196-1.56-.48-2.43-.276-1.08.253-2.16-.009-3.235-.18-1.226-.2-2.439-.518-3.666-.604-2.097-.152-4.158-.522-6.235-.81-.993-.14-1.991-.243-2.975-.423a42.808 42.808 0 0 1-2.978-.664c-1.046-.264-2.085-.582-3.121-.882C1.122 7.214.74 6.67.444 6.112.36 5.953.59 5.534.78 5.337c.594-.621 1.35-.92 2.211-.987 1.934-.153 3.86-.06 5.774.12 1.72.162 3.425.459 5.124.761 1.963.342 3.938.566 5.928.725 1.551.12 3.096.346 4.645.495 1.447.144 2.9.241 4.353.38 1.607.156 3.215.305 4.824.502 2.28.273 4.55.593 6.831.872 1.62.199 3.241.391 4.895.293.938-.058 1.897.126 2.828.295 1.34.24 2.692.28 4.046.348 1.651.082 3.303.158 4.96.246.474.026.944.098 1.42.124.13.013.267-.05.401-.072-.052-.126-.069-.295-.162-.37-.553-.454-1.127-.874-1.68-1.327-1.467-1.208-2.934-2.416-4.394-3.635-.563-.473-.885-1.124-1.227-1.76-.208-.387-.023-.71.165-1.002.18-.28.301-.676.723-.71.29-.024.579-.048.87-.041 1.45.024 2.74.566 4.009 1.184.906.442 1.796.925 2.718 1.344.386.178.62.43.782.807.114.264.204.591.615.274.182-.137.404-.09.571.125.246.314.537.602.782.921.167.222.358.277.63.3 1.026.064 1.83.574 2.406 1.407.371.537.868.9 1.432 1.15.655.29 1.24.663 1.702 1.185.85.958 1.653 1.953 2.45 2.954.341.43.245 1.248-.147 1.657-.703.737-1.431 1.44-2.117 2.191-.368.406-.66.885-1 1.323-.14.178-.285.415-.478.478-.75.258-1.239.837-1.802 1.342-.233.21-.48.442-.76.557-.915.379-1.838.732-2.774 1.043-.273.091-.606-.027-.91-.023-.139.004-.345.03-.402.12-.507.805-1.262 1.2-2.163 1.25-1.377.08-2.673.52-4.003.82-1.53.344-3.061.683-4.589 1.052a13.66 13.66 0 0 1-3.57.36c-.512-.011-.884-.266-1.065-.674-.39-.899-.488-.879.139-1.69.118-.155.253-.297.35-.466.372-.67 1.031-.793 1.682-1.007 1.115-.364 2.208-.796 3.296-1.234 1.425-.578 2.831-1.193 4.246-1.784.764-.322 1.542-.601 2.29-.949.75-.348 1.47-.753 2.287-1.178l.016-.034z"
        })
    });
};
const $49ae067eb8751f37$var$ArrowPencilPointLeft = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        style: {
            color: props.color ? props.color : 'currentColor',
            transform: `rotate(${props.rotate ? props.rotate : '0'}deg)`
        },
        width: "50",
        height: "17",
        viewBox: "0 0 72 24",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $2jatx.default)([
            "_tnrurdoj _1rfm1tcg _1vkhl52n _12rr12am"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fill: "currentColor",
            d: "M11.923 9.891c.933.429 1.83.508 2.72.622a8.268 8.268 0 0 0 2.87-.149c.843-.189 1.706-.123 2.515.09 1.513.401 3.053.417 4.61.365.973-.031 1.96-.021 2.921.086.666.076 1.303.353 1.983.546.374-.617.975-.614 1.6-.413 1.292.416 2.61.453 3.962.376.735-.04 1.467.098 2.084.536.08.051.178.075.271.104.594-.604 1.307-.594 2.051-.46 1.197.208 2.4.393 3.597.601.809.144 1.616.304 2.424.46.802.16 1.572.404 2.437.176 1.072-.285 2.16-.072 3.24.053 1.23.147 2.452.409 3.68.446 2.102.069 4.172.35 6.256.55.997.097 1.998.16 2.986.297 1.006.139 2.007.323 2.995.53 1.053.216 2.101.484 3.145.735.677.158 1.073.668 1.385 1.196.088.15-.132.564-.316.76-.577.622-1.325.94-2.184 1.035-1.93.22-3.856.202-5.776.099-1.724-.091-3.436-.315-5.143-.543a66.397 66.397 0 0 0-5.946-.479c-1.554-.057-3.105-.218-4.657-.304-1.451-.086-2.906-.126-4.363-.206-1.611-.09-3.223-.174-4.836-.304-2.288-.179-4.566-.403-6.853-.588-1.626-.13-3.252-.256-4.902-.1-.936.091-1.9-.05-2.835-.179-1.348-.183-2.7-.17-4.055-.186-1.653-.017-3.307-.029-4.965-.052-.476-.007-.947-.06-1.423-.067-.13-.008-.267.059-.4.085.055.119.077.282.172.351.565.417 1.151.8 1.716 1.218 1.5 1.11 2.999 2.222 4.491 3.344.576.435.915 1.051 1.274 1.651.218.367.042.685-.137.974-.173.278-.284.664-.705.712-.288.034-.577.068-.869.072-1.449.03-2.753-.444-4.039-.993-.918-.393-1.821-.825-2.753-1.196a1.417 1.417 0 0 1-.805-.75c-.12-.25-.219-.562-.621-.24-.18.138-.402.1-.575-.1-.255-.294-.553-.561-.807-.86-.172-.207-.365-.254-.638-.266-1.027-.024-1.844-.485-2.444-1.268-.385-.504-.892-.836-1.462-1.057-.662-.256-1.258-.593-1.734-1.08a69.905 69.905 0 0 1-2.53-2.758c-.352-.404-.277-1.196.103-1.606.683-.737 1.392-1.443 2.058-2.192.356-.405.635-.879.964-1.314.135-.177.274-.41.464-.48.744-.276 1.217-.853 1.766-1.361.227-.211.467-.445.745-.566.904-.4 1.817-.775 2.745-1.11.27-.098.606.004.911-.011.138-.01.343-.042.398-.131.486-.796 1.23-1.205 2.129-1.287 1.374-.128 2.659-.601 3.98-.94 1.52-.39 3.042-.773 4.56-1.186C22.527.86 23.711.715 24.915.7c.513-.009.892.223 1.084.61.415.853.512.83-.093 1.635-.115.155-.246.297-.338.464-.354.66-1.01.803-1.654 1.034-1.105.393-2.186.85-3.262 1.314-1.41.61-2.798 1.257-4.197 1.879-.755.34-1.525.638-2.265 1.001-.74.364-1.448.781-2.254 1.222l-.014.033z"
        })
    });
};
const $49ae067eb8751f37$export$eec9700d5a261698 = ()=>{
    const intl = (0, $8e22h.default)();
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "jpd-atlassianIntelligence",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            id: "atlassian-intelligence",
            ref: scrollRef,
            className: (0, $2jatx.default)([
                "_85i51wqb _1reo15vq _18m915vq",
                sectionIsVisible ? 'is-visible' : ''
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                layout: "12",
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_kqswstnw _152tidpf _1e021ssb _t9eczr6s _1bsbtfvk _p12fauwl _bfhkqlpt _1pby1mrw _4t3i1w8u _mkrz1wiv _165t1mqo _1cfr1y69",
                                "background"
                            ])
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o _2lx21bp4 _kqswh2mm",
                                "content-wrapper"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvr1h6o _2lx21bp4 _zulp4bvh _p12f32xz _1q511k4y _kqswh2mm _y3gn1h6o _81641tcg"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _2lx21bp4 _4cvr1h6o _srwzi2wt"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1e0c1txw _4cvr1h6o _1bah1h6o _zulp1crf _6rthzwfg",
                                                    "branding"
                                                ]),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                                    image: {
                                                        src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/228i1sr1dfw1gwf6gej5q22wij418525.svg',
                                                        alt: 'Atlassian Intelligence',
                                                        width: 32,
                                                        height: 32
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                                className: (0, $2jatx.default)([
                                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz12cp _1pby11wp",
                                                    "_1rkb1w8u"
                                                ]),
                                                children: intl.formatMessage({
                                                    id: 'JiraProductDiscoveryPage.atlassianIntelligence.header',
                                                    defaultMessage: 'Transform teamwork with human-AI collaboration'
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                        text: intl.formatMessage({
                                            id: 'JiraProductDiscoveryPage.atlassianIntelligence.ctaText',
                                            defaultMessage: 'Explore Atlassian Intelligence'
                                        }),
                                        href: (0, $jQ0cd.useLocalizedHref)('/software/artificial-intelligence'),
                                        type: "primary",
                                        bgColor: "bgBlackBlue",
                                        dataEventProps: {
                                            'data-event': 'clicked',
                                            'data-event-component': 'linkButton',
                                            'data-event-container': 'ctaSection',
                                            'data-product-key': 'jiraProductDiscovery',
                                            'data-label-english': 'Explore Atlassian Intelligence'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_kqswh2mm _1h1tcq2i _1bsb1osq _lcxvglyw"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)($49ae067eb8751f37$var$LeftArrows, {
                                                sectionIsVisible: sectionIsVisible
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)($49ae067eb8751f37$var$RightArrows, {
                                                sectionIsVisible: sectionIsVisible
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                                image: {
                                                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/w5a2w16s762570j03psv36nc66c7bpuk.webp',
                                                    alt: '',
                                                    width: 1920,
                                                    height: 1080
                                                },
                                                style: {
                                                    maxWidth: '100%',
                                                    height: 'auto'
                                                }
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
const $49ae067eb8751f37$var$LeftArrows = ({ sectionIsVisible: sectionIsVisible })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswstnw _4t3i1osq _1bsb1osq _152tidpf _1pbycs5v",
            "_152tubeo _1e02tidb _1vxpvqxi _mmgkvkhr _jj7e1xgq _zsl9vkhr _17s11xgq _dqt7vkhr"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hq1fro"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($49ae067eb8751f37$var$ArrowPencilPointLeft, {
                    color: "#1868DB",
                    rotate: 200
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hq46li"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($49ae067eb8751f37$var$ArrowPencilPointLeft, {
                    color: "#BC5DF2",
                    rotate: 222
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hq1tbx"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($49ae067eb8751f37$var$ArrowPencilPointLeft, {
                    color: "#fff",
                    rotate: 219
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hq1pew"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($49ae067eb8751f37$var$ArrowPencilPointLeft, {
                    color: "#101214",
                    rotate: 196
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hqrfsk"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($49ae067eb8751f37$var$ArrowPencilPointLeft, {
                    color: "#B9D58D",
                    rotate: 199
                })
            })
        ]
    });
};
const $49ae067eb8751f37$var$RightArrows = ({ sectionIsVisible: sectionIsVisible })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswstnw _4t3i1osq _1bsb1osq _152tidpf _1pbycs5v",
            "_152t11oi _1e02sisq _1vxp1ebb _mmgk189v _jj7etpnp _zsl9189v _17s1tpnp _dqt7189v"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hq1g5v"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($49ae067eb8751f37$var$ArrowPencilPointRight, {
                    color: "#1868DB",
                    rotate: 139
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hqhu9p"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($49ae067eb8751f37$var$ArrowPencilPointRight, {
                    color: "#fff",
                    rotate: 127
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hqo84c"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($49ae067eb8751f37$var$ArrowPencilPointRight, {
                    color: "#82B536",
                    rotate: 114
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hqesey"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($49ae067eb8751f37$var$ArrowPencilPointRight, {
                    color: "#101214",
                    rotate: 138
                })
            })
        ]
    });
};
const $49ae067eb8751f37$var$sectionStyles = null;
const $49ae067eb8751f37$var$arrowStyles = null;
const $49ae067eb8751f37$var$wrapperStyles = null;
const $49ae067eb8751f37$var$leftAndRightArrowsStyles = null;
const $49ae067eb8751f37$var$svgStyles = null;
const $49ae067eb8751f37$var$leftArrowsStyles = null;
const $49ae067eb8751f37$var$rightArrowsStyles = null;
const $49ae067eb8751f37$var$headerStyles = null;
const $49ae067eb8751f37$var$containerStyles = null;
const $49ae067eb8751f37$var$backgroundStyles = null;
const $49ae067eb8751f37$var$textWrapperStyles = null;
const $49ae067eb8751f37$var$textStyles = null;
const $49ae067eb8751f37$var$brandingStyles = null;
const $49ae067eb8751f37$var$imageWrapperStyles = null;
const $49ae067eb8751f37$var$fadeIn = null;
const $49ae067eb8751f37$var$fadeInAnimation = null;
const $49ae067eb8751f37$var$arrowLeft1 = null;
const $49ae067eb8751f37$var$arrowLeft1Animation = null;
const $49ae067eb8751f37$var$arrowLeft2 = null;
const $49ae067eb8751f37$var$arrowLeft2Animation = null;
const $49ae067eb8751f37$var$arrowLeft3 = null;
const $49ae067eb8751f37$var$arrowLeft3Animation = null;
const $49ae067eb8751f37$var$arrowLeft4 = null;
const $49ae067eb8751f37$var$arrowLeft4Animation = null;
const $49ae067eb8751f37$var$arrowLeft5 = null;
const $49ae067eb8751f37$var$arrowLeft5Animation = null;
const $49ae067eb8751f37$var$arrowRight1 = null;
const $49ae067eb8751f37$var$arrowRight1Animation = null;
const $49ae067eb8751f37$var$arrowRight2 = null;
const $49ae067eb8751f37$var$arrowRight2Animation = null;
const $49ae067eb8751f37$var$arrowRight3 = null;
const $49ae067eb8751f37$var$arrowRight3Animation = null;
const $49ae067eb8751f37$var$arrowRight4 = null;
const $49ae067eb8751f37$var$arrowRight4Animation = null;

});

parcelRegister("ceI23", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b574d965bf0dad0e$export$2e2bcd8739ae039; });
/* community.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $hnmMQ = parcelRequire("hnmMQ");

var $iPPTB = parcelRequire("iPPTB");

var $1rGpC = parcelRequire("1rGpC");
const $b574d965bf0dad0e$var$Community = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_1mou1epz"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1rGpC.Row), {
            layout: "6-6",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                    image: {
                        src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/tj67uy2v6dlh816537m17ay3p0qwy6y2.webp',
                        alt: ''
                    },
                    className: (0, $2jatx.default)([
                        "_rtys1osq _bna71wug _1vr0xy5q"
                    ])
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                            className: "h4",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "JiraProductDiscoveryPage.community.heading",
                                defaultMessage: "Join us in the Atlassian Community"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "JiraProductDiscoveryPage.community.subheading",
                                defaultMessage: "Ask questions, give app feedback, and connect with our team and other users to learn best practices."
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                            text: intl.formatMessage({
                                id: 'JiraProductDiscoveryPage.community.ctaText',
                                defaultMessage: 'Join the discussion'
                            }),
                            href: "https://community.atlassian.com/t5/Jira-Product-Discovery/ct-p/jpd",
                            type: "primary",
                            dataEventProps: {
                                'data-event-component': 'linkButton',
                                'data-event-container': 'pronouncedCtaSection',
                                'data-event': 'clicked',
                                'data-product-key': 'jiraProductDiscovery'
                            }
                        })
                    ]
                })
            ]
        })
    });
};
var $b574d965bf0dad0e$export$2e2bcd8739ae039 = $b574d965bf0dad0e$var$Community;
const $b574d965bf0dad0e$var$section = null;
const $b574d965bf0dad0e$var$img = null;

});

parcelRegister("lY5mc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d8c7e3342f7badfc$export$2e2bcd8739ae039; });
/* cta.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $20OkY = parcelRequire("20OkY");

var $lmQGF = parcelRequire("lmQGF");

var $asbmK = parcelRequire("asbmK");

var $jQ0cd = parcelRequire("jQ0cd");

var $1rGpC = parcelRequire("1rGpC");
const $d8c7e3342f7badfc$var$CtaSection = ()=>{
    const signupLink = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=jira-product-discovery');
    const { openCrossFlow: openCrossFlow } = (0, $asbmK.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).JIRA_PRODUCT_DISCOVERY,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_1reo15vq _p12f1osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
            layout: "12",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _y3gn1h6o _6rthxncg _1q51xncg _85i5xy5q _1e0c1txw _2lx21bp4 _4cvr1h6o _zulppxbi _1cs8stnw _1g0v1mrw _1kt9b3bt _1812ukr8 _gs7s10v4 _1rusbq5w _7dwz6xro _1kwxdcea _jbut1ssa _5t3m1oci _m2uvwt5r _18postnw _1bqq1mrw _aetrb3bt _13w1ukr8 _16gxmgjw _1hfk1856 _3p6m1cq2 _1v5vmgnk _z0bc1h14 _19h9d943 _1oj4kh7c _otsx1cpx _wi3iz9ld _tzs91clp"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        className: (0, $2jatx.default)([
                            "_syaz1gfe _1mouidpf _14b51n8h _1m0r1wug",
                            "_1cs8stnw _1mp410mc _kfgt10mc _1kt9b3bt _1s6k11z8 _1ank5vt7 _cfu11o8l _7dwz4djf"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "JiraProductDiscoveryPage.cta.section.heading",
                            defaultMessage: "<span>Build</span> better features, not more features.",
                            values: {
                                span: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        children: chunks
                                    })
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_syaz1gfe _1mouidpf _14b51n8h _1m0r1wug",
                            "body-lg"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "JiraProductDiscoveryPage.cta.section.subheading",
                            defaultMessage: "Leave the guess work behind and build products your customers love."
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                        color: "yellow",
                        variant: "primary",
                        size: "small",
                        dataEventProps: {
                            'data-event-component': 'linkButton',
                            'data-event-container': 'ctaSection',
                            'data-event': 'clicked',
                            'data-product-key': 'jiraProductDiscovery',
                            'data-label-english': 'Get it free',
                            'data-track-event': 'jiraProductDiscovery.get-it-free-button-clicked'
                        },
                        href: signupLink,
                        onClick: openCrossFlow,
                        className: (0, $2jatx.default)([
                            "_1pfhpxbi"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "JiraProductDiscoveryPage.cta.section.cta.text",
                            defaultMessage: "Get it free"
                        })
                    })
                ]
            })
        })
    });
};
var $d8c7e3342f7badfc$export$2e2bcd8739ae039 = $d8c7e3342f7badfc$var$CtaSection;
const $d8c7e3342f7badfc$var$container = null;
const $d8c7e3342f7badfc$var$sectionStyle = null;
const $d8c7e3342f7badfc$var$textStyle = null;
const $d8c7e3342f7badfc$var$accent = null;
const $d8c7e3342f7badfc$var$button = null;

});

parcelRegister("hBk6f", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b532b44e72bdf1eb$export$2e2bcd8739ae039; });
/* customers.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");

var $1rGpC = parcelRequire("1rGpC");
const $b532b44e72bdf1eb$var$sectionStyle = null;
const $b532b44e72bdf1eb$var$logosGridStyle = null;
const $b532b44e72bdf1eb$var$liStyle = null;
const $b532b44e72bdf1eb$var$Customers = ()=>{
    const logos = [
        {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/260w4830ha12g7838ik7j5rq3ex31h8h.svg',
            alt: 'Canva',
            width: 136,
            height: 43
        },
        {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4ojx82fmj7q6l0354r1qfe572un65j0m.svg',
            alt: 'Coupa',
            width: 158
        },
        {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/g76770b7kmwx457yu43qbo42h874ann8.svg',
            alt: 'Docker',
            width: 158
        },
        {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7ivn8866tpd7e4155176u71d4syycwc8.webp',
            alt: 'The Economist',
            width: 112
        },
        {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4x7bp61gn38200m4omcfxsx0cm75w71i.svg',
            alt: 'Deliveroo',
            width: 148
        },
        {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/mmi427i07l27j8ul2aj32h25144vb65u.svg',
            alt: 'Decathlon',
            width: 156
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_6rth12bs _y3gn1h6o _syazkhc1"
        ]),
        style: {
            "--_n0ignx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue1000'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                layout: "12",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    className: "h5",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "JiraProductDiscoveryPage.customers.heading",
                        defaultMessage: "Join the 10,000+ customers who build products with Jira Product Discovery"
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                layout: "12",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                    className: (0, $2jatx.default)([
                        "_1e0c11p5 _zulpviql _yv0e14qi _4cvr1h6o _6a6z1h6o _19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _qtt8glyw _1bsb1osq _rtys1osq _1da7nl51 _1rqt1g7m"
                    ]),
                    children: logos.map((logo)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                            className: (0, $2jatx.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                image: {
                                    ...logo
                                }
                            })
                        }, logo.src))
                })
            })
        ]
    });
};
var $b532b44e72bdf1eb$export$2e2bcd8739ae039 = $b532b44e72bdf1eb$var$Customers;

});

parcelRegister("haaSq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3e07b8657bc59969$export$2e2bcd8739ae039; });
/* demo.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $lmQGF = parcelRequire("lmQGF");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $1rGpC = parcelRequire("1rGpC");
const $3e07b8657bc59969$var$bannerStyle = null;
const $3e07b8657bc59969$var$imgStyle = null;
const $3e07b8657bc59969$var$buttonStyle = null;
const $3e07b8657bc59969$var$DemoBanner = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
        layout: "12",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_11q7odbs _2rko1ylz _1e0c11p5 _yv0ehkll _4cvr1h6o _6a6z1h6o _zulp1ejb _1bsb1osq _1q51xy5q _18zrpxbi _6rthxy5q _y3gn1h6o _12e81fhb _uj6kv2br _1j8b7y8c _16imze3t _su07xy5q _jplc1xh7 _bj231xh7"
            ]),
            style: {
                "--_5p9fny": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.lime')),
                "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card'))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: "h3",
                    children: intl.formatMessage({
                        id: 'JiraProductDiscoveryPage.demo.body.text',
                        defaultMessage: 'Join our demo with live chat Q&A'
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                    variant: "secondary",
                    color: "black",
                    href: (0, $jQ0cd.useLocalizedHref)('/software/jira/product-discovery/demo'),
                    dataEventProps: {
                        'data-event': 'clicked',
                        'data-event-container': 'banner-link-button',
                        'data-event-component': 'linkButton',
                        'data-product-key': 'jiraProductDiscovery'
                    },
                    className: (0, $2jatx.default)([
                        "_10fp1h6o"
                    ]),
                    children: intl.formatMessage({
                        id: 'JiraProductDiscoveryPage.demo.cta.text',
                        defaultMessage: 'Register now'
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                    image: {
                        src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ua18axib18162bej4n515osj7675wepi.webp',
                        alt: intl.formatMessage({
                            id: 'JiraProductDiscoveryPage.demo.screenshot.alt',
                            defaultMessage: 'Screenshot of Jira Product Discovery'
                        }),
                        width: 368,
                        height: 154
                    },
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1wpzesu3 _p12f1osq _1kr6kb7n _dz5jcs5v _rtys1osq _bna71wug"
                    ])
                })
            ]
        })
    });
};
var $3e07b8657bc59969$export$2e2bcd8739ae039 = $3e07b8657bc59969$var$DemoBanner;

});

parcelRegister("lLZy5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a50f29d88e694ae6$export$2e2bcd8739ae039; });
/* hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $20OkY = parcelRequire("20OkY");

var $lmQGF = parcelRequire("lmQGF");

var $asbmK = parcelRequire("asbmK");

var $jQ0cd = parcelRequire("jQ0cd");

var $iRMRa = parcelRequire("iRMRa");

var $1rGpC = parcelRequire("1rGpC");
const $a50f29d88e694ae6$var$Hero = ()=>{
    const intl = (0, $8e22h.default)();
    const signupLink = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=jira-product-discovery');
    const { openCrossFlow: openCrossFlow } = (0, $asbmK.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).JIRA_PRODUCT_DISCOVERY,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1reo15vq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
            layout: "8",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_y3gn1h6o _1rjc1lhf _26vxxncg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _1g0v1mrw _1cs8stnw _1kt9b3bt _1tes18wq _18crxkqj _f6gemgnk _wkf1wsfl _1nrl42os _1gg83zxr",
                            "superhero"
                        ]),
                        children: intl.formatMessage({
                            id: 'JiraProductDiscoveryPage.hero.heading.super',
                            defaultMessage: 'From ideas to <em>impact</em>, build what matters'
                        }, {
                            ...(0, $iRMRa.DEFAULT_VALUES),
                            em: (text)=>{
                                return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    className: (0, $2jatx.default)([
                                        "_kqswh2mm _1cs8stnw _1kt9b3bt _1tesidpf _18crnqtd _f6gemgnk _wkf1174u _7dwz1vci _5z7wyan6 _1kwx1wlv _5t3mz98b"
                                    ]),
                                    children: text
                                });
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: "body-lg",
                        children: intl.formatMessage({
                            id: 'JiraProductDiscoveryPage.hero.subtitle',
                            defaultMessage: 'Capture insights, prioritize ideas, and build roadmaps - all in Jira'
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                        href: signupLink,
                        onClick: openCrossFlow,
                        variant: "primary",
                        dataEventProps: {
                            'data-event': 'clicked',
                            'data-event-container': 'heroSection',
                            'data-event-component': 'linkButton',
                            'data-product-key': 'jiraProductDiscovery',
                            'data-label-english': 'Get it free',
                            'data-track-event': 'jiraProductDiscovery.get-it-free-button-clicked'
                        },
                        className: (0, $2jatx.default)([
                            "_1pfhpxbi"
                        ]),
                        children: intl.formatMessage({
                            id: 'JiraProductDiscoveryPage.hero.cta.label',
                            defaultMessage: 'Get it free'
                        })
                    })
                ]
            })
        })
    });
};
var $a50f29d88e694ae6$export$2e2bcd8739ae039 = $a50f29d88e694ae6$var$Hero;
const $a50f29d88e694ae6$var$container = null;
const $a50f29d88e694ae6$var$heroContainer = null;
const $a50f29d88e694ae6$var$heading = null;
const $a50f29d88e694ae6$var$impact = null;
const $a50f29d88e694ae6$var$button = null;

});

parcelRegister("tce8m", function(module, exports) {
$parcel$export(module.exports, "HowItWorks", function () { return $4affc59986e2abbe$export$409faa00494a55a; });
/* how-it-works.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $9s3Hk = parcelRequire("9s3Hk");

var $90TSV = parcelRequire("90TSV");

var $iyOcM = parcelRequire("iyOcM");

var $8IYGL = parcelRequire("8IYGL");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");

var $1rGpC = parcelRequire("1rGpC");

var $l4UnR = parcelRequire("l4UnR");

var $iWL9l = parcelRequire("iWL9l");
const $4affc59986e2abbe$export$409faa00494a55a = ()=>{
    const intl = (0, $8e22h.default)();
    const cardRef = (0, $1oC0p.useRef)(null);
    const [activeTeamIndex, setActiveTeamIndex] = (0, $1oC0p.useState)(0);
    const [activeTeamData, setActiveTeamData] = (0, $1oC0p.useState)((0, $l4UnR.TEAM_DATA)[0]);
    (0, $1oC0p.useEffect)(()=>{
        setActiveTeamData((0, $l4UnR.TEAM_DATA)[activeTeamIndex]);
    }, [
        activeTeamIndex
    ]);
    const renderActiveMedia = ()=>{
        const { heroImage: heroImage, contentTitle: contentTitle, contentText: contentText, quoteColor: quoteColor, quoteText: quoteText, customerName: customerName, customerTitle: customerTitle } = activeTeamData;
        const quoteProps = {
            quoteColor: quoteColor,
            quoteText: intl.formatMessage(quoteText),
            customerName: intl.formatMessage(customerName),
            customerTitle: intl.formatMessage(customerTitle)
        };
        return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1rGpC.Row), {
                    layout: "4-8",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                    children: intl.formatMessage(contentTitle)
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    children: intl.formatMessage(contentText)
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_kzviglyw"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iWL9l.default), {
                                        ...quoteProps
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_mezj1osq _bna71wug"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                image: {
                                    src: heroImage,
                                    alt: ''
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_dm25glyw _sugaglyw"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                        layout: "8",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iWL9l.default), {
                            ...quoteProps
                        })
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "homepage-v2-hero",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            id: "hero-jira-cta",
            className: (0, $2jatx.default)([
                "_1reo15vq _18m915vq _6rth1ylp"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                            className: (0, $2jatx.default)([
                                "_ect41vau _1wyb1ylp _k48p1fw0 _vwz4ckbl _y3gn1h6o"
                            ]),
                            style: {
                                "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_kqswh2mm _18postnw _z0ai1qo0 _1qdg1qjk _1guf1lpd _1czd17hu _aetrb3bt _3p6m1s0j _1mhxca9o _1nww1ul9 _1y2q17rr _sjmw1lpd _1efb101a"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "JiraProductDiscoveryPage.howItWorks.header",
                                    defaultMessage: "How it works",
                                    values: {
                                        teams: (str)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $8IYGL.Adg4TextUnderline), {
                                                underline: /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                                                    width: "100%",
                                                    height: "30",
                                                    viewBox: "0 0 306 42",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                                        d: "M0.314542 22.3672C52.9464 14.9125 91.8245 33.6666 144.966 18.1254C147.46 24.7349 153.892 33.0058 163.497 33.1094C155.486 32.9725 142.641 15.7178 155.536 27.2686C163.119 36.0683 196.172 25.2364 170.842 32.944C188.334 31.2885 204.356 20.5339 216.163 10.9702C235.811 -2.65832 220.928 23.6737 235.178 36.8756C255.37 55.2242 316.463 7.29572 304.134 7.28816C296.296 13.2947 285.769 17.046 281.423 23.6985C204.757 63.1757 259.992 -9.72674 214.311 2.55426C139.744 53.2533 177.393 7.4163 133.572 10.6223C108.06 28.9946 -0.613806 0.46356 0.29434 22.3672L0.314542 22.3672Z",
                                                        fill: "#FFA900"
                                                    })
                                                }),
                                                children: str
                                            }),
                                        br: /*#__PURE__*/ (0, $7VQPk.jsx)("br", {})
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            ref: cardRef,
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iyOcM.Adg4Tabs), {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $90TSV.Adg4DraggableTabList), {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _1bah1yb4 _19pkidpf _2hwx1wug _otyridpf _18u01wug _6rth12am _zulpckbl"
                                        ]),
                                        children: (0, $l4UnR.TEAM_DATA).map(({ title: title, id: id, icon: icon, englishLabel: englishLabel }, index)=>{
                                            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9s3Hk.Adg4DraggableTab), {
                                                onClick: ()=>{
                                                    setActiveTeamIndex(index);
                                                },
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                                    "data-product-key": "home",
                                                    "data-event-component": "button",
                                                    "data-event-container": "heroSection",
                                                    "data-event": "clicked",
                                                    "data-label-english": englishLabel,
                                                    "aria-label": intl.formatMessage(title),
                                                    className: (0, $2jatx.default)([
                                                        "_19itglyw _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _d0altlke"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                        className: (0, $2jatx.default)([
                                                            "_vchhusvi _1e0c1txw _2lx21bp4 _1bsbh2q2 _4cvr1h6o _ca0qi2wt _u5f3i2wt _n3tdi2wt _19bvi2wt _zulpidpf _2rkoi2wt _19itt94y _11q7i8nm _1j55glyw _19lcplhp _kbawglyw _1x381ule",
                                                            activeTeamIndex === index && "_19it1dfy _2rkoi2wt _1kd31fw0"
                                                        ]),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                                className: (0, $2jatx.default)([
                                                                    "_4t3i3okq _1bsb3okq _mezj3okq _bna73okq",
                                                                    "default-icon"
                                                                ]),
                                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                                                    image: {
                                                                        src: `${icon}`,
                                                                        alt: '',
                                                                        draggable: 'false'
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                                className: (0, $2jatx.default)([
                                                                    "_4t3i3okq _1bsb3okq _mezj3okq _bna73okq",
                                                                    "hover-icon"
                                                                ]),
                                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                                                    image: {
                                                                        src: icon,
                                                                        alt: '',
                                                                        draggable: 'false'
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                                className: (0, $2jatx.default)([
                                                                    "_ect41vau _k48p1nn1 _1wyb1j6v _vwz41k8s _syazqlpt"
                                                                ]),
                                                                style: {
                                                                    "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                                                                },
                                                                children: intl.formatMessage(title)
                                                            })
                                                        ]
                                                    })
                                                })
                                            }, id);
                                        })
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                            children: renderActiveMedia()
                        })
                    ]
                })
            })
        })
    });
};
const $4affc59986e2abbe$var$jiraHeroStyles = null;
const $4affc59986e2abbe$var$heroTitleStyles = null;
const $4affc59986e2abbe$var$heroTitleSpanStyles = null;
const $4affc59986e2abbe$var$buttonResetStyle = null;
const $4affc59986e2abbe$var$tabsStyle = null;
const $4affc59986e2abbe$var$teamCardStyles = null;
const $4affc59986e2abbe$var$iconContainerStyles = null;
const $4affc59986e2abbe$var$teamCardTextStyles = null;
const $4affc59986e2abbe$var$teamCardActiveStyles = null;
const $4affc59986e2abbe$var$imageOverrideStyles = null;
const $4affc59986e2abbe$var$quoteStyles = null;
const $4affc59986e2abbe$var$tabletQuoteStyles = null;

});
parcelRegister("l4UnR", function(module, exports) {
$parcel$export(module.exports, "TEAM_DATA", function () { return $bc2f4f4043a65c9d$export$860b41270ca4de2e; });

var $fnHPc = parcelRequire("fnHPc");
const $bc2f4f4043a65c9d$export$860b41270ca4de2e = [
    {
        id: 'software',
        icon: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0tktsadc6a0h85663hv4lb34mml07y0g.svg',
        heroImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1l8b1267j66mc1b334eua3gyam2nggrx.webp',
        title: (0, $fnHPc.defineMessage)({
            id: 'JiraProductDiscoveryPage.howItWorks.tabs.label.tab1',
            defaultMessage: 'Capture'
        }),
        englishLabel: 'Capture',
        contentTitle: (0, $fnHPc.defineMessage)({
            id: 'JiraProductDiscoveryPage.howItWorks.tabs.title.tab1',
            defaultMessage: 'Capture ideas and insights'
        }),
        contentText: (0, $fnHPc.defineMessage)({
            id: 'JiraProductDiscoveryPage.howItWorks.tabs.text.tab1',
            defaultMessage: "There\u2019s now a home for all the unstructured work that happens before you start building software. Gather and organize your product opportunities, user feedback, and feature requests all in one place."
        }),
        quoteColor: 'blue',
        quoteText: (0, $fnHPc.defineMessage)({
            id: 'JiraProductDiscoveryPage.howItWorks.tabs.quote.text.tab1',
            defaultMessage: 'Jira Product Discovery is helping us do the right things, in the right order, and at the right time, focusing on work that will deliver on benefits.'
        }),
        customerName: (0, $fnHPc.defineMessage)({
            id: 'JiraProductDiscoveryPage.howItWorks.tabs.quote.name.tab1',
            defaultMessage: 'John Sayers'
        }),
        customerTitle: (0, $fnHPc.defineMessage)({
            id: 'JiraProductDiscoveryPage.howItWorks.tabs.quote.title.tab1',
            defaultMessage: 'PMO Lead, Renaissancere'
        })
    },
    {
        id: 'product-management',
        icon: 'https://dam-cdn.atl.orangelogic.com/AssetLink/kha7lb4n41e6nqbfm6uu8jwym0dumt36.svg',
        heroImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ohh610p3j7iv5hyda53yqh0006v40258.webp',
        title: (0, $fnHPc.defineMessage)({
            id: 'JiraProductDiscoveryPage.howItWorks.tabs.label.tab2',
            defaultMessage: 'Prioritize'
        }),
        englishLabel: 'Prioritize',
        contentTitle: (0, $fnHPc.defineMessage)({
            id: 'JiraProductDiscoveryPage.howItWorks.tabs.title.tab2',
            defaultMessage: "Prioritize \u2013 your way"
        }),
        contentText: (0, $fnHPc.defineMessage)({
            id: 'JiraProductDiscoveryPage.howItWorks.tabs.text.tab2',
            defaultMessage: 'Flexible views and granular fields let you compare ideas against one another using the prioritization method that works best for you.'
        }),
        quoteColor: 'lime',
        quoteText: (0, $fnHPc.defineMessage)({
            id: 'JiraProductDiscoveryPage.howItWorks.tabs.quote.text.tab2',
            defaultMessage: "Up until Jira Product Discovery, even with other roadmapping tools, we\u2019ve had to use shared spreadsheets and slide presentations to coordinate prioritization in an accessible way. However, within a week of \u201Ctrying\u201D out Jira Product Discovery, it became clear it was the tool to invest in going forward."
        }),
        customerName: (0, $fnHPc.defineMessage)({
            id: 'JiraProductDiscoveryPage.howItWorks.tabs.quote.name.tab2',
            defaultMessage: 'John Daily Jr.'
        }),
        customerTitle: (0, $fnHPc.defineMessage)({
            id: 'JiraProductDiscoveryPage.howItWorks.tabs.quote.title.tab2',
            defaultMessage: 'Head of Product, Karhoo'
        })
    },
    {
        id: 'marketing',
        icon: 'https://dam-cdn.atl.orangelogic.com/AssetLink/36m76eu4oo0e46hvd21s744fn11i35q5.svg',
        heroImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2fh1741j5vly80365ofehwwe0qes6b4a.webp',
        title: (0, $fnHPc.defineMessage)({
            id: 'JiraProductDiscoveryPage.howItWorks.tabs.label.tab3',
            defaultMessage: 'Engage'
        }),
        englishLabel: 'Engage',
        contentTitle: (0, $fnHPc.defineMessage)({
            id: 'JiraProductDiscoveryPage.howItWorks.tabs.title.tab3',
            defaultMessage: 'Engage and align your teams'
        }),
        contentText: (0, $fnHPc.defineMessage)({
            id: 'JiraProductDiscoveryPage.howItWorks.tabs.text.tab3',
            defaultMessage: "Create and share roadmaps tailored to individual stakeholders \u2013 even ones outside your organization \u2013 and let them provide feedback via comments, votes, or simple reactions."
        }),
        quoteColor: 'purple',
        quoteText: (0, $fnHPc.defineMessage)({
            id: 'JiraProductDiscoveryPage.howItWorks.tabs.quote.text.tab3',
            defaultMessage: 'Jira Product Discovery has revitalized how we think about roadmaps.'
        }),
        customerName: (0, $fnHPc.defineMessage)({
            id: 'JiraProductDiscoveryPage.howItWorks.tabs.quote.name.tab3',
            defaultMessage: 'Adam Chapman'
        }),
        customerTitle: (0, $fnHPc.defineMessage)({
            id: 'JiraProductDiscoveryPage.howItWorks.tabs.quote.title.tab3',
            defaultMessage: 'Full Stack Developer, Apex Networks'
        })
    },
    {
        id: 'project-management',
        icon: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3e2ln2b76w2544cn5633031qjtn2fobe.svg',
        heroImage: 'https://dam-cdn.atl.orangelogic.com/AssetLink/r1elfv055406ty7x72u4000npq20n46m.webp',
        title: (0, $fnHPc.defineMessage)({
            id: 'JiraProductDiscoveryPage.howItWorks.tabs.label.tab4',
            defaultMessage: 'Connect'
        }),
        englishLabel: 'Connect',
        contentTitle: (0, $fnHPc.defineMessage)({
            id: 'JiraProductDiscoveryPage.howItWorks.tabs.title.tab4',
            defaultMessage: 'Connect teams, all in Jira'
        }),
        contentText: (0, $fnHPc.defineMessage)({
            id: 'JiraProductDiscoveryPage.howItWorks.tabs.text.tab4',
            defaultMessage: 'Seamlessly connect your ideas to delivery work in Jira so your teams have full context and visibility from discovery to delivery.'
        }),
        quoteColor: 'yellow',
        quoteText: (0, $fnHPc.defineMessage)({
            id: 'JiraProductDiscoveryPage.howItWorks.tabs.quote.text.tab4',
            defaultMessage: 'Jira Product Discovery combines everything I was doing in spreadsheets and Powerpoints into one easy-to-navigate tool. Plus everything is added straight into Jira, instead of requiring some third-party tool to integrate.'
        }),
        customerName: (0, $fnHPc.defineMessage)({
            id: 'JiraProductDiscoveryPage.howItWorks.tabs.quote.name.tab4',
            defaultMessage: 'Abby Kiesling'
        }),
        customerTitle: (0, $fnHPc.defineMessage)({
            id: 'JiraProductDiscoveryPage.howItWorks.tabs.quote.title.tab4',
            defaultMessage: 'Product Manager, EZ Texting'
        })
    }
];

});

parcelRegister("iWL9l", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $edb29ea8e109e6d3$export$2e2bcd8739ae039; });
/* testimonial-quote.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $a8Jhy = parcelRequire("a8Jhy");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");
const $edb29ea8e109e6d3$var$quoteStyles = null;
const $edb29ea8e109e6d3$var$quotePStyles = null;
const $edb29ea8e109e6d3$var$portraitStyles = null;
const $edb29ea8e109e6d3$var$nameStyles = null;
const $edb29ea8e109e6d3$var$titleStyles = null;
const $edb29ea8e109e6d3$var$quoteSrcMap = {
    yellow: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3ixqjd5540sdn251h25h55i82occ48sa.svg',
    purple: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0ho3162460jba51mgj0a16k3cpvy074s.svg',
    lime: 'https://dam-cdn.atl.orangelogic.com/AssetLink/q6j1k002cmxpvr2145m8q3u70gfrm2qt.svg',
    blue: 'https://dam-cdn.atl.orangelogic.com/AssetLink/504175ycu5d01061dg4evte5l0m72pea.svg',
    none: ''
};
const $edb29ea8e109e6d3$var$TestimonialQuote = ({ quoteText: quoteText, customerName: customerName, customerTitle: customerTitle, quoteColor: quoteColor, colorAgainst: colorAgainst })=>{
    const quoteImage = {
        src: $edb29ea8e109e6d3$var$quoteSrcMap[quoteColor],
        alt: customerTitle
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_11q7hfxm _ca0q1ul9 _u5f3gktf _n3td1ul9 _19bv53f4 _kqswh2mm _1pfhzwfg _14dk1fw0"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _19pkidpf _2hwxidpf _otyr1j6v _18u0idpf _ect4z4z1 _1wybdlk8 _k48p1nn1 _vwz4gktf _y3gn1e5h",
                            "body-sm"
                        ]),
                        style: {
                            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                        },
                        children: quoteText
                    }),
                    quoteColor !== 'none' && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswstnw _1bsb88uy _1e02gktf _152tgktf"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                            image: quoteImage
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1mt11ul9",
                            "body-sm name"
                        ]),
                        children: customerName
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1p1dangw",
                            "fine-print"
                        ]),
                        children: customerTitle
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a8Jhy.Adg4SectionDivider), {
                variation: (0, $a8Jhy.SECTION_DIVIDER_VARIATION).FLIP,
                desktopHeight: 15,
                tabletHeight: 15,
                mobileHeight: 15,
                bgColor: "var(--ds-surface-sunken, #F8F8F8)",
                colorAgainst: colorAgainst
            })
        ]
    });
};
var $edb29ea8e109e6d3$export$2e2bcd8739ae039 = $edb29ea8e109e6d3$var$TestimonialQuote;

});


parcelRegister("dMCHr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d1835431f38c452b$export$2e2bcd8739ae039; });
/* side-by-side.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $hnmMQ = parcelRequire("hnmMQ");

var $4hIcA = parcelRequire("4hIcA");
const $d1835431f38c452b$var$SideBySide = ()=>{
    const intl = (0, $8e22h.default)();
    const items = [
        {
            title: intl.formatMessage({
                id: 'JiraProductDiscoveryPage.scroller.1.title',
                defaultMessage: 'Bring structure to chaos'
            }),
            description: intl.formatMessage({
                id: 'JiraProductDiscoveryPage.scroller.1.description',
                defaultMessage: 'Leverage data and customer insights to help your team prioritize ideas that will make the biggest impact.'
            }),
            img: {
                src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8i4ut65m3p28wvyedk7505mtqm5kiqr3.webp',
                alt: '',
                width: 768,
                height: 512
            }
        },
        {
            title: intl.formatMessage({
                id: 'JiraProductDiscoveryPage.scroller.2.title',
                defaultMessage: 'Get everyone on the same page'
            }),
            description: intl.formatMessage({
                id: 'JiraProductDiscoveryPage.scroller.2.description',
                defaultMessage: 'Spend less time updating and persuading with custom roadmaps that give your stakeholders the information they need.'
            }),
            img: {
                src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/g5xp0826vanhei54fi3437v7nr227cn7.webp',
                alt: '',
                width: 768,
                height: 512
            }
        },
        {
            title: intl.formatMessage({
                id: 'JiraProductDiscoveryPage.scroller.3.title',
                defaultMessage: 'Connect discovery and delivery in Jira'
            }),
            description: intl.formatMessage({
                id: 'JiraProductDiscoveryPage.scroller.3.description',
                defaultMessage: 'Reduce context switching, add visibility, and move faster by seamlessly connecting your ideas to the delivery work happening in Jira.'
            }),
            img: {
                src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/767r1t8n744265g8k4550obw1udklx2f.webp',
                alt: '',
                width: 768,
                height: 512
            }
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_1reozryt"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4hIcA.Scroller), {
                items: items,
                renderText: (item)=>/*#__PURE__*/ (0, $7VQPk.jsx)($d1835431f38c452b$var$ScrollerContent, {
                        item: item
                    }),
                renderGraphic: (item)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                        image: item.img,
                        className: (0, $2jatx.default)([
                            "_p12f1osq _rtys1osq _bna71wug"
                        ])
                    }),
                layout: "right",
                mobileGraphicLayout: "above",
                backgroundColor: "#fff",
                inScrollBackgroundColor: "#fff",
                heading: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_y3gn1h6o _1bsb1osq _1e0c11p5 _85i5xy5q"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                            className: (0, $2jatx.default)([
                                "_6rthidpf"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "JiraProductDiscoveryPage.scroller.heading.text",
                                defaultMessage: "Discover your next great product idea"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "JiraProductDiscoveryPage.scroller.subheading.text",
                                defaultMessage: "Better product decisions are made as a team"
                            })
                        })
                    ]
                })
            })
        })
    });
};
var $d1835431f38c452b$export$2e2bcd8739ae039 = $d1835431f38c452b$var$SideBySide;
const $d1835431f38c452b$var$ScrollerContent = ({ item: item })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                children: item.title
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                children: item.description
            })
        ]
    });
};
const $d1835431f38c452b$var$sectionStyle = null;
const $d1835431f38c452b$var$scrollerHeading = null;
const $d1835431f38c452b$var$heading = null;
const $d1835431f38c452b$var$imgStyle = null;

});

parcelRegister("5OLfs", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $545a9ce8cb3bf6be$export$2e2bcd8739ae039; });
/* video.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $hnmMQ = parcelRequire("hnmMQ");

var $hBYvx = parcelRequire("hBYvx");

var $1rGpC = parcelRequire("1rGpC");
const $545a9ce8cb3bf6be$var$HeroVideo = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
        layout: "12",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c11p5 _4cvr1h6o _6a6z1h6o _1pfhmgjw _6rthxy5q _1ob9xncg"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                    image: {
                        alt: '',
                        src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/eskxgojb0g32x168w8yg8g7g2586005n.svg'
                    },
                    className: (0, $2jatx.default)([
                        "_t9ec120f _yyhyrgcp _1ii7rgcp _1bsbj6kd"
                    ])
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hBYvx.Video), {
                    loop: true,
                    muted: true,
                    // existing video that is low priority to move over to brandfolder
                    // eslint-disable-next-line local/no-non-orangelogic-images-eslint
                    videoLink: "https://wac-cdn.atlassian.com/misc-assets/videos/jira-product-discovery/JPD_product-tour_hero.mp4",
                    className: (0, $2jatx.default)([
                        "_1reozryt _18m9zryt _1h1tcq2i _2rko1kwk _kdam1319 _yyhyrgcp _1ii7rgcp _t9eck9uq _14dmvqnv _sfej3ovx"
                    ])
                })
            ]
        })
    });
};
var $545a9ce8cb3bf6be$export$2e2bcd8739ae039 = $545a9ce8cb3bf6be$var$HeroVideo;
const $545a9ce8cb3bf6be$var$container = null;
const $545a9ce8cb3bf6be$var$video = null;
const $545a9ce8cb3bf6be$var$bgImage = null;

});

parcelRegister("8yYDi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $98f22cdf3b645268$export$2e2bcd8739ae039; });
/* workflow.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $hnmMQ = parcelRequire("hnmMQ");

var $1rGpC = parcelRequire("1rGpC");
const $98f22cdf3b645268$var$Workflow = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _11q7i8nm _195g1wug _1rjcoahv _2oz41k92 _1hr2kd3c _ecdxxy5q _6ru51ris"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1rGpC.Row), {
            layout: "6-6",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                            className: (0, $2jatx.default)([
                                "_1mouidpf"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "JiraProductDiscoveryPage.workflow.heading",
                                defaultMessage: "Connect your entire workflow with Jira"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "JiraProductDiscoveryPage.workflow.body.text",
                                defaultMessage: "From strategy and ideation through planning and delivery, bring your entire software lifecycle together in Jira"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                    image: {
                        src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1036e8r078n724ru6bb24rdl38bot0iu.webp',
                        alt: ''
                    },
                    className: (0, $2jatx.default)([
                        "_rtys1osq _bna71wug"
                    ])
                })
            ]
        })
    });
};
var $98f22cdf3b645268$export$2e2bcd8739ae039 = $98f22cdf3b645268$var$Workflow;
const $98f22cdf3b645268$var$section = null;
const $98f22cdf3b645268$var$img = null;
const $98f22cdf3b645268$var$bodyContent = null;

});



parcelRegister("04Umd", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryPricingPage", function () { return $de4035e7cb1b46bd$export$4771e0906f773aa4; });

var $7VQPk = parcelRequire("7VQPk");

var $dl2JF = parcelRequire("dl2JF");

var $kCFWz = parcelRequire("kCFWz");
const $de4035e7cb1b46bd$export$4771e0906f773aa4 = ({ pricing: pricing, countryCode: countryCode, pricingContent: pricingContent, queryRef: queryRef })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dl2JF.PricingContentContextProviderRelay), {
        productId: "jira-product-discovery",
        pricingContent: pricingContent,
        queryRef: queryRef,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            "data-testid": "jpd-pricing-page",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kCFWz.JiraProductDiscoveryPricingPageTemplate), {
                pricing: pricing,
                countryCode: countryCode
            })
        })
    });
};

});
parcelRegister("kCFWz", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryPricingPageTemplate", function () { return $c0b6d853aac0ee5e$export$6c2556bd70f89142; });

var $7VQPk = parcelRequire("7VQPk");

var $7aKDf = parcelRequire("7aKDf");

var $dl2JF = parcelRequire("dl2JF");

var $2zOxm = parcelRequire("2zOxm");

var $6Px6U = parcelRequire("6Px6U");

var $grcEk = parcelRequire("grcEk");

var $5S2vX = parcelRequire("5S2vX");

var $bE8d4 = parcelRequire("bE8d4");

var $fhttR = parcelRequire("fhttR");

var $aYwTu = parcelRequire("aYwTu");

var $aRBTI = parcelRequire("aRBTI");

var $dEsrl = parcelRequire("dEsrl");
const $c0b6d853aac0ee5e$export$6c2556bd70f89142 = (props)=>{
    const content = (0, $dl2JF.usePricingContentContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
            nav: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aYwTu.default), {}),
            banner: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fhttR.JPDBanner), {}),
            showFallback: content?.hasError,
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
                scrollTrackingEnabled: true,
                pageId: "jpd-pricing-page",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6Px6U.PageHeading), {
                        children: content?.headline
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aRBTI.JiraProductDiscoveryPriceFinder), {
                        pricing: props.pricing,
                        countryCode: props.countryCode
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aKDf.PricingFeatureTable), {
                        title: content?.compareFeaturesTitle ?? undefined,
                        comparePlans: content?.comparePlans ?? undefined,
                        compareFeatures: content?.compareFeatures ?? undefined
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2zOxm.QuotationsAdornment), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bE8d4.PricingFaq), {
                                header: content?.getMoreDetailsTitle ?? undefined,
                                planDetails: content?.additionalDetails ?? undefined
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dEsrl.JpdQuestionsCta), {})
                ]
            })
        })
    });
};

});
parcelRegister("aRBTI", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryPriceFinder", function () { return $3fd601000846fcbe$export$b36576908b6a3c15; });

var $7VQPk = parcelRequire("7VQPk");

var $fnHPc = parcelRequire("fnHPc");

var $gIRO7 = parcelRequire("gIRO7");

var $eYlij = parcelRequire("eYlij");

var $dl2JF = parcelRequire("dl2JF");
const $3fd601000846fcbe$export$b36576908b6a3c15 = (props)=>{
    const content = {
        free: (0, $dl2JF.usePricingPlanComparison)('Free'),
        standard: (0, $dl2JF.usePricingPlanComparison)('Standard'),
        premium: (0, $dl2JF.usePricingPlanComparison)('Premium')
    };
    const jiraProductDiscoveryProductPlans = [
        {
            planName: content.free?.planTitleExternal ?? 'Free',
            offeringSku: 'jira-servicedesk-free',
            description: content.free?.planOneLiner ?? '',
            recommendationLimit: 0,
            signupLimit: 20000,
            signupURLSuffix: '?bundle=jira-product-discovery&edition=free&signupSource=pricing'
        },
        {
            planName: content.standard?.planTitleExternal ?? 'Standard',
            offeringSku: 'jira-product-discovery-standard',
            description: content.standard?.planOneLiner ?? '',
            recommendationLimit: 3,
            signupLimit: 20000,
            signupURLSuffix: '?bundle=jira-product-discovery&edition=standard&signupSource=pricing'
        },
        {
            planName: content.premium?.planTitleExternal ?? 'Premium',
            offeringSku: 'jira-product-discovery-premium-sku',
            description: content.premium?.planOneLiner ?? '',
            recommendationLimit: 50,
            signupLimit: 20000,
            signupURLSuffix: '?bundle=jira-product-discovery&edition=premium&signupSource=pricing'
        }
    ];
    const messages = (0, $fnHPc.defineMessages)({
        unitCountInputTextRedesign: {
            id: 'JiraProductDiscoveryPricingPage.priceFinder.unitCountInputTextRedesign',
            defaultMessage: 'Team size:'
        },
        unitCountInputTerm: {
            id: 'JiraProductDiscoveryPricingPage.priceFinder.unitCountInputTerm',
            defaultMessage: 'creators'
        },
        unitCountInputText: {
            id: 'JiraProductDiscoveryPricingPage.priceFinder.unitCountInputText',
            defaultMessage: 'How many agents are on your team?'
        },
        cardOverSignupLimit: {
            id: 'JiraProductDiscoveryPricingPage.priceFinder.cardOverSignupLimit',
            defaultMessage: "Your agent count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: 'JiraProductDiscoveryPricingPage.priceFinder.cardEnterpriseMinimumCount',
            defaultMessage: 'Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more agents above',
            description: 'Enterprise is a plan name and should not be translated'
        },
        cardUnitCountTierRange: {
            id: 'JiraProductDiscoveryPricingPage.priceFinder.cardUnitCountTierRange',
            defaultMessage: 'Creator tier: {lowerLimit} - {upperLimit}'
        },
        cardMonthlyPerUnitCount: {
            id: 'JiraProductDiscoveryPricingPageTeam24.priceFinder.cardMonthlyPerUnitCount',
            defaultMessage: 'per creator / month'
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eYlij.PriceFinderContextProvider), {
        dataProductKey: "jiraProductDiscovery",
        productPlans: jiraProductDiscoveryProductPlans,
        defaultUnitCount: 10,
        enterpriseMinimumCount: 201,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gIRO7.default), {
            messages: messages,
            serverSideCCPPricing: props.pricing?.ccpPricingData?.jiraProductDiscovery,
            countryCode: props.countryCode
        })
    });
};
$3fd601000846fcbe$export$b36576908b6a3c15.displayName = 'JiraProductDiscoveryPriceFinder';

});

parcelRegister("dEsrl", function(module, exports) {
$parcel$export(module.exports, "JpdQuestionsCta", function () { return $062ddb31541d908d$export$5481e63b06ebf9c4; });

var $7VQPk = parcelRequire("7VQPk");

var $dl2JF = parcelRequire("dl2JF");

var $frz5c = parcelRequire("frz5c");

var $jQ0cd = parcelRequire("jQ0cd");
const $062ddb31541d908d$export$5481e63b06ebf9c4 = ()=>{
    const content = (0, $dl2JF.usePricingContentContext)();
    const questionsCtaContent = content?.callToActionContainer?.[0];
    const questionsCtaHref = `https://www.atlassian.com${(0, $jQ0cd.useLocalizedHref)('/licensing/jira-product-discovery#jira-product-discovery')}`;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $frz5c.QuestionsCta), {
        product: 'Jira Product Discovery',
        ctaHref: questionsCtaContent?.url ?? questionsCtaHref,
        questionsHeader: questionsCtaContent?.title ?? undefined,
        priceAndLicensingLinkText: questionsCtaContent?.text ?? undefined,
        questionsBody: questionsCtaContent?.valueProposition ?? undefined,
        imageHref: questionsCtaContent?.asset?.url
    });
};

});



parcelRegister("31J3d", function(module, exports) {
$parcel$export(module.exports, "getPricingTitleInternal", function () { return $4d8708b285ba0671$export$933c1404a4ee79b; });
const $4d8708b285ba0671$export$933c1404a4ee79b = ()=>{
    return 'Jira Service Management Pricing Page';
};

});

parcelRegister("6QgX2", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementPricingPage", function () { return $ef6f08b787170088$export$2a3104cce6671f76; });

var $7VQPk = parcelRequire("7VQPk");

var $3L8ZR = parcelRequire("3L8ZR");

var $9xKEy = parcelRequire("9xKEy");

var $dl2JF = parcelRequire("dl2JF");

var $bTseT = parcelRequire("bTseT");

var $94Mty = parcelRequire("94Mty");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
const $ef6f08b787170088$export$2a3104cce6671f76 = ({ pricing: pricing, countryCode: countryCode, pricingContent: pricingContent, queryRef: queryRef })=>{
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom = (0, $3L8ZR.default).checkGate('gwp-737-enable-intercom-chat-jsm');
    const isSalesWidgetBxpWebPlatform = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).salesWidgetBxpWebPlatform);
    const isSalesWidgetBxpWebPlatformDeveloper = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).salesWidgetBxpWebPlatformDeveloper);
    if (isSalesWidgetBxpWebPlatformDeveloper) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9xKEy.ChatWidgetProvider), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dl2JF.PricingContentContextProviderRelay), {
            productId: "jira-service-management",
            pricingContent: pricingContent,
            queryRef: queryRef,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "data-testid": "jsm-pricing-page",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $94Mty.JiraServiceManagementPricingPageV2Template), {
                    pricing: pricing,
                    countryCode: countryCode
                })
            })
        })
    });
    else if (isSalesWidgetBxpWebPlatform) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9xKEy.ChatWidgetProvider), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dl2JF.PricingContentContextProviderRelay), {
            productId: "jira-service-management",
            pricingContent: pricingContent,
            queryRef: queryRef,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "data-testid": "jsm-pricing-page",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $94Mty.JiraServiceManagementPricingPageV2Template), {
                    pricing: pricing,
                    countryCode: countryCode
                })
            })
        })
    });
    else return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bTseT.IntercomProvider), {
        appId: 'p0ww63i2',
        triggerBoot: isBootIntercom,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9xKEy.ChatWidgetProvider), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dl2JF.PricingContentContextProviderRelay), {
                productId: "jira-service-management",
                pricingContent: pricingContent,
                queryRef: queryRef,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    "data-testid": "jsm-pricing-page",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $94Mty.JiraServiceManagementPricingPageV2Template), {
                        pricing: pricing,
                        countryCode: countryCode
                    })
                })
            })
        })
    });
};

});
parcelRegister("94Mty", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementPricingPageV2Template", function () { return $2728f1090ab6b090$export$ac87b8d354f2d1fd; });

var $7VQPk = parcelRequire("7VQPk");

var $djE2J = parcelRequire("djE2J");

var $baTp3 = parcelRequire("baTp3");

var $7aKDf = parcelRequire("7aKDf");

var $dl2JF = parcelRequire("dl2JF");

var $bE8d4 = parcelRequire("bE8d4");

var $2zOxm = parcelRequire("2zOxm");

var $6Px6U = parcelRequire("6Px6U");

var $grcEk = parcelRequire("grcEk");

var $frz5c = parcelRequire("frz5c");

var $jQ0cd = parcelRequire("jQ0cd");

var $5S2vX = parcelRequire("5S2vX");

var $aYVVm = parcelRequire("aYVVm");

var $CxZAa = parcelRequire("CxZAa");
const $2728f1090ab6b090$export$ac87b8d354f2d1fd = (props)=>{
    const content = (0, $dl2JF.usePricingContentContext)();
    const questionsCtaContent = content?.callToActionContainer?.[0];
    const dataCenterContent = (0, $dl2JF.useDatacenterPlans)('Contact Us', 'Learn more');
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
        nav: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aYVVm.default), {}),
        showFallback: content?.hasError,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
            scrollTrackingEnabled: true,
            pageId: "jsm-pricing-page",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6Px6U.PageHeading), {
                    children: content?.headline
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $CxZAa.JsmPriceFinder), {
                    pricing: props.pricing,
                    countryCode: props.countryCode
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aKDf.PricingFeatureTable), {
                    title: content?.compareFeaturesTitle ?? undefined,
                    comparePlans: content?.comparePlans ?? undefined,
                    compareFeatures: content?.compareFeatures ?? undefined
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $djE2J.AtlassianGuardAddOnShared), {
                    ctaHref: (0, $jQ0cd.useLocalizedHref)('/software/guard')
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $baTp3.DataCenterSection), {
                    ...dataCenterContent
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2zOxm.QuotationsAdornment), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bE8d4.PricingFaq), {
                            header: content?.getMoreDetailsTitle ?? undefined,
                            planDetails: content?.additionalDetails ?? undefined
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $frz5c.QuestionsCta), {
                    product: 'JSM',
                    ctaHref: questionsCtaContent?.url ?? undefined,
                    questionsHeader: questionsCtaContent?.title ?? undefined,
                    priceAndLicensingLinkText: questionsCtaContent?.text ?? undefined,
                    questionsBody: questionsCtaContent?.valueProposition ?? undefined,
                    imageHref: questionsCtaContent?.asset?.url
                })
            ]
        })
    });
};

});
parcelRegister("djE2J", function(module, exports) {
$parcel$export(module.exports, "AtlassianGuardAddOnShared", function () { return $f4f37fc7b98c337e$export$fcf33b8d632fa1db; });
/* atlassian-guard-add-on-shared.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $6A2DX = parcelRequire("6A2DX");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $hnmMQ = parcelRequire("hnmMQ");
const $f4f37fc7b98c337e$var$containerCss = null;
const $f4f37fc7b98c337e$var$sectionRightCss = null;
const $f4f37fc7b98c337e$var$atlassianGuardLogoContainerCss = null;
const $f4f37fc7b98c337e$var$headingTextCss = null;
const $f4f37fc7b98c337e$var$bodyTextCss = null;
const $f4f37fc7b98c337e$var$svgStyles = null;
const $f4f37fc7b98c337e$export$5cd54d97896804b4 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/xxlo4l61p3fn223u1nahuu4r6r3ug1a2.svg',
            alt: ''
        },
        className: (0, $2jatx.default)([
            "_1bsbvrzy _4t3i11yp _glte1qi6 _165ti8ts"
        ])
    });
};
const $f4f37fc7b98c337e$export$fcf33b8d632fa1db = ({ headingText: headingText, bodyText: bodyText, linkText: linkText, ctaHref: ctaHref })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const defaultHeadingText = formatMessage({
        id: 'PricingPagesTeam.atlassianGuard.heading',
        defaultMessage: 'Safeguard your mission-critical data'
    });
    const defaultBodyText = formatMessage({
        id: 'PricingPagesTeam.atlassianGuard.body',
        defaultMessage: 'Add Atlassian Guard for enhanced security and visibility across your Atlassian cloud products. Set proactive security policies, quickly detect suspicious behavior, and take action with suggested remediation steps to protect your most valuable work. Additionally, with a Cloud Enterprise plan, you get support for multiple identity providers (IdPs) and Atlassian Guard Standard.'
    });
    const defaultLinkText = formatMessage({
        id: 'PricingPages.atlassianGuard.cta',
        defaultMessage: 'Learn more'
    });
    const handleClick = ()=>{
        if (ctaHref) window.location.href = ctaHref;
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "atlassianGuardAddOnShared",
        tabIndex: 0,
        onClick: handleClick,
        role: "link",
        onKeyDown: (e)=>{
            if (e.code === 'Enter' || e.code === 'Space') {
                e.preventDefault();
                handleClick();
            }
        },
        className: (0, $2jatx.default)([
            "_p12f1qhy _19pkidpf _2hwx1wug _otyridpf _18u01wug _1yt4oahv _1e0c1txw _2rko1ylz _4cvr1h6o _1gde1bp4 _8164183y _133ixy5q _s51s1ejb _16qst7xp _v56416gf _1dbz130s _zulpoahv _80omtlke"
        ]),
        style: {
            "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($f4f37fc7b98c337e$export$5cd54d97896804b4, {}),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulppxbi"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_4t3ixy5q _1752xy5q"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.GuardLogo), {
                            appearance: "brand"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                        id: "atlassian-guard-add-on-heading",
                        className: (0, $2jatx.default)([
                            "_1wyb1tcg _k48p1fw0 _vwz41ul9 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                        ]),
                        children: headingText ?? defaultHeadingText
                    }),
                    bodyText !== '' && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1ezn"
                        ]),
                        style: {
                            "--_xluqsf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark500'))
                        },
                        children: bodyText ?? defaultBodyText
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                        text: linkText ?? defaultLinkText,
                        type: "primary",
                        href: ctaHref,
                        id: "atlassian-guard-add-on-cta",
                        "aria-labelledby": "atlassian-guard-add-on-cta atlassian-guard-add-on-heading",
                        "aria-label": linkText ?? defaultLinkText
                    })
                ]
            })
        ]
    });
};
$f4f37fc7b98c337e$export$fcf33b8d632fa1db.displayName = 'AtlassianGuardAddOn';

});

parcelRegister("aYVVm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $133256a5190381b7$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $20OkY = parcelRequire("20OkY");

var $asbmK = parcelRequire("asbmK");

var $b31tm = parcelRequire("b31tm");

var $kCjSr = parcelRequire("kCjSr");

var $eOIix = parcelRequire("eOIix");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $cR2Ov = parcelRequire("cR2Ov");

var $gn6Qa = parcelRequire("gn6Qa");

var $iSeHD = parcelRequire("iSeHD");

var $9KOR3 = parcelRequire("9KOR3");
const $133256a5190381b7$var$JiraServiceManagementLogo = ()=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "jiraservicemanagement",
        type: "logo",
        appearance: "brand",
        darkTheme: isDarkTheme
    });
};
const $133256a5190381b7$var$JiraServiceManagementSoftwareNavV2 = ({ productNavCtaCTAClickFunction: productNavCtaCTAClickFunction, isUseOpenCrossFlow: isUseOpenCrossFlow = false })=>{
    const intl = (0, $8e22h.default)();
    const featuresHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/features');
    const pricingHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/pricing');
    const itSupportHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/itsm-software');
    const itOperationsHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/it-operations');
    const enterpriseServiceManagementHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/features/enterprise-service-management');
    const customerServiceHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/customer-service-software');
    const hrHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/hr');
    const smallTeamsHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/help-desk-software-small-business-software');
    const premiumHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/premium');
    const enterpriseHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/enterprise');
    const technologyTelecomHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/technology-telecommunications');
    const financialServicesHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/financial-services');
    const retailHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/retail-ecommerce');
    const manufacturingHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/manufacturing');
    const itsmHref = (0, $jQ0cd.useLocalizedHref)('/itsm');
    const guidesHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/product-guide');
    const resourcesHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/resources');
    const solutionsDropdownStyles = (0, $1oC0p.useMemo)(()=>{
        return {
            width: 'fit-content !important',
            margin: 0
        };
    }, []);
    const templatesUrl = (0, $jQ0cd.useLocalizedHref)('/software/jira/templates/service-management');
    const { fireUIEvent: fireUIEvent } = (0, $b31tm.useFireEvent)();
    const viewedUIEvent = (0, $1oC0p.useRef)(false);
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    (0, $1oC0p.useEffect)(()=>{
        if (!viewedUIEvent.current && analyticsClient) {
            viewedUIEvent.current = true;
            fireUIEvent({
                action: 'viewed',
                actionSubject: 'jiraServiceManagementSoftwareNavV2'
            });
        }
    }, [
        analyticsClient,
        fireUIEvent
    ]);
    const links = (0, $1oC0p.useMemo)(()=>[
            {
                globalLinksKey: 'features',
                linkText: intl.formatMessage({
                    id: 'software-jira-service-management.navbar.features',
                    defaultMessage: 'Features'
                }),
                hasDropdown: false,
                productKey: 'jira-servicedesk.ondemand',
                href: featuresHref
            },
            {
                globalLinksKey: 'solutions',
                linkText: intl.formatMessage({
                    id: 'software-jira-service-management.navbar.solutions',
                    defaultMessage: 'Solutions'
                }),
                hasDropdown: true,
                dropdownType: 'solutions',
                productKey: 'jira-servicedesk.ondemand',
                containerPosition: 'relative',
                containerStyles: solutionsDropdownStyles,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    contentSections: [
                        {
                            header: intl.formatMessage({
                                id: 'software-jira-service-management.navbar.solutions.useCases.header',
                                defaultMessage: 'By use case'
                            }),
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.useCases.itSupport',
                                        defaultMessage: 'IT Support'
                                    }),
                                    href: itSupportHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.useCases.itOperations',
                                        defaultMessage: 'IT Operations'
                                    }),
                                    href: itOperationsHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.useCases.businessTeams',
                                        defaultMessage: 'Business Teams'
                                    }),
                                    href: enterpriseServiceManagementHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.useCases.customerService',
                                        defaultMessage: 'Customer Service'
                                    }),
                                    href: customerServiceHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.useCases.humanResources',
                                        defaultMessage: 'Human Resources'
                                    }),
                                    href: hrHref
                                }
                            ]
                        },
                        {
                            header: intl.formatMessage({
                                id: 'software-jira-service-management.navbar.solutions.capability.header',
                                defaultMessage: 'By capability'
                            }),
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.capability.smallTeams',
                                        defaultMessage: 'Small Teams'
                                    }),
                                    href: smallTeamsHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.capability.premium',
                                        defaultMessage: 'Premium'
                                    }),
                                    href: premiumHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.capability.enterprise',
                                        defaultMessage: 'Enterprise'
                                    }),
                                    href: enterpriseHref
                                }
                            ]
                        },
                        {
                            header: intl.formatMessage({
                                id: 'software-jira-service-management.navbar.solutions.industry.customerService',
                                defaultMessage: 'By industry'
                            }),
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.industry.technologyTelecom',
                                        defaultMessage: 'Technology & Telecom'
                                    }),
                                    href: technologyTelecomHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.industry.financialServices',
                                        defaultMessage: 'Financial Services'
                                    }),
                                    href: financialServicesHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.industry.retail',
                                        defaultMessage: 'Retail'
                                    }),
                                    href: retailHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.useCases.manufacturing',
                                        defaultMessage: 'Manufacturing'
                                    }),
                                    href: manufacturingHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: 'resources',
                linkText: intl.formatMessage({
                    id: 'software-jira-service-management.navbar.resources',
                    defaultMessage: 'Resources'
                }),
                hasDropdown: true,
                dropdownType: 'resources',
                productKey: 'jira-servicedesk.ondemand',
                containerPosition: 'relative',
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    contentSections: [
                        {
                            header: intl.formatMessage({
                                id: 'software-jira-service-management.navbar.resources.type.header',
                                defaultMessage: 'By type'
                            }),
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.resources.type.itsm',
                                        defaultMessage: 'ITSM'
                                    }),
                                    href: itsmHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.resources.type.guides',
                                        defaultMessage: 'Guides'
                                    }),
                                    href: guidesHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.templates',
                                        defaultMessage: 'Templates'
                                    }),
                                    href: templatesUrl
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.resources.type.additionalResources',
                                        defaultMessage: 'Additional Resources'
                                    }),
                                    href: resourcesHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: 'pricing',
                linkText: intl.formatMessage({
                    id: 'software-jira-service-management.navbar.pricing',
                    defaultMessage: 'Pricing'
                }),
                hasDropdown: false,
                productKey: 'jira-servicedesk.ondemand',
                href: pricingHref
            }
        ], // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        customerServiceHref,
        solutionsDropdownStyles,
        enterpriseHref,
        enterpriseServiceManagementHref,
        featuresHref,
        financialServicesHref,
        hrHref,
        intl,
        itOperationsHref,
        itSupportHref,
        itsmHref,
        manufacturingHref,
        premiumHref,
        pricingHref,
        guidesHref,
        resourcesHref,
        retailHref,
        smallTeamsHref,
        technologyTelecomHref,
        templatesUrl
    ]);
    const localizedSignupLink = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/free');
    const signupLink = (0, $kCjSr.useJsmPlaygroundSignupHref)(localizedSignupLink);
    const { openCrossFlow: openCrossFlow } = (0, $asbmK.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).JIRA_SERVICE_DESK,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const isPlaygroundSignup = signupLink !== localizedSignupLink;
    const productNavOnClick = (0, $1oC0p.useMemo)(()=>{
        if (isPlaygroundSignup) return undefined;
        return productNavCtaCTAClickFunction && isUseOpenCrossFlow ? productNavCtaCTAClickFunction : openCrossFlow;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isPlaygroundSignup,
        openCrossFlow,
        productNavCtaCTAClickFunction
    ]);
    const globalNavItemKeys = (0, $1oC0p.useMemo)(()=>{
        return links.map((link)=>link.globalLinksKey);
    }, [
        links
    ]);
    const ctaText = intl.formatMessage({
        id: 'productNavBar.get-it-free-button',
        defaultMessage: 'Get it free'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.GlobalNavProvider), {
        globalNavItemKeys: globalNavItemKeys,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gn6Qa.ProductPageNav), {
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($133256a5190381b7$var$JiraServiceManagementLogo, {}),
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($133256a5190381b7$var$JiraServiceManagementLogo, {}),
            productLogoUrl: (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management'),
            productLogoAriaLabel: "Jira Service Management",
            productPageNavLinks: links,
            isShowTryNowLink: false,
            mobileLinksSections: [
                {
                    mobileLinkKey: 'mobile-jira-service-management',
                    mobileLinksProps: links
                }
            ],
            isIncludeMobileCTA: false,
            mobileCtaText: intl.formatMessage({
                id: 'productNavBar.get-it-free-button',
                defaultMessage: 'Get it free'
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: (e)=>{
                if (productNavOnClick) productNavOnClick(e);
            },
            navigationTrynowCtaText: ctaText,
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: (e)=>{
                if (productNavOnClick) productNavOnClick(e);
            },
            additionalMenuPageObjectsArray: [
                {
                    menuPageKey: 'solutions',
                    menuPageObjects: links.find((link)=>link.globalLinksKey === 'solutions')?.content
                },
                {
                    menuPageKey: 'resources',
                    menuPageObjects: links.find((link)=>link.globalLinksKey === 'resources')?.content
                }
            ]
        })
    });
};
var $133256a5190381b7$export$2e2bcd8739ae039 = $133256a5190381b7$var$JiraServiceManagementSoftwareNavV2;

});
parcelRegister("kCjSr", function(module, exports) {
$parcel$export(module.exports, "useJsmPlaygroundSignupHref", function () { return $eafc11ff1cda9b95$export$fa84af0726e923b1; });

var $1oC0p = parcelRequire("1oC0p");

var $gIKKj = parcelRequire("gIKKj");

var $7FWq8 = parcelRequire("7FWq8");

var $9IkPf = parcelRequire("9IkPf");
const $eafc11ff1cda9b95$export$fa84af0726e923b1 = (href)=>{
    const experiment = (0, $gIKKj.useExperiment)((0, $7FWq8.wacRefreshJsm));
    const isEnabled = experiment.type === 'enrolled' && experiment.value;
    const [resolvedHref, setResolvedHref] = (0, $1oC0p.useState)(()=>typeof window === 'undefined' ? href : (0, $9IkPf.addJsmPlaygroundSignupIntentToHref)(href, window.location.search, window.location.origin, isEnabled));
    (0, $1oC0p.useEffect)(()=>{
        const updateHref = ()=>{
            setResolvedHref((0, $9IkPf.addJsmPlaygroundSignupIntentToHref)(href, window.location.search, window.location.origin, isEnabled));
        };
        updateHref();
        window.addEventListener((0, $9IkPf.JSM_PLAYGROUND_SIGNUP_INTENT_CHANGE_EVENT), updateHref);
        window.addEventListener('popstate', updateHref);
        return ()=>{
            window.removeEventListener((0, $9IkPf.JSM_PLAYGROUND_SIGNUP_INTENT_CHANGE_EVENT), updateHref);
            window.removeEventListener('popstate', updateHref);
        };
    }, [
        href,
        isEnabled
    ]);
    return resolvedHref;
};

});


parcelRegister("CxZAa", function(module, exports) {
$parcel$export(module.exports, "JsmPriceFinder", function () { return $863743dd4076071d$export$27bafd5c0a9a3fce; });

var $7VQPk = parcelRequire("7VQPk");

var $fnHPc = parcelRequire("fnHPc");

var $gIRO7 = parcelRequire("gIRO7");

var $eYlij = parcelRequire("eYlij");

var $1qGP5 = parcelRequire("1qGP5");

var $dl2JF = parcelRequire("dl2JF");

var $aA1TB = parcelRequire("aA1TB");
const $863743dd4076071d$export$27bafd5c0a9a3fce = (props)=>{
    const messages = (0, $fnHPc.defineMessages)({
        headerText: {
            id: 'JsmPricingPageV2.priceFinder.headerText',
            defaultMessage: 'Service management <blue>that scales</blue>'
        },
        unitCountInputTextRedesign: {
            id: 'JsmPricingPageV2.priceFinder.unitCountInputTextRedesign',
            defaultMessage: 'Team size:'
        },
        unitCountInputDirectBuy: {
            id: 'JsmPricingPageV2.priceFinder.unitCountInputDirectBuy',
            defaultMessage: "What's your team size?"
        },
        unitCountInputTerm: {
            id: 'JsmPricingPageV2.priceFinder.unitCountInputTerm',
            defaultMessage: 'agents'
        },
        billingCycleText: {
            id: 'JsmPricingPageV2.priceFinder.billingCycleText',
            defaultMessage: 'Billing cycle:'
        },
        unitCountInputText: {
            id: 'JsmPricingPageV2.priceFinder.unitCountInputText',
            defaultMessage: 'How many agents are on your team?'
        },
        unitCountInputTooltip: {
            id: 'JsmPricingPageV2.priceFinder.unitCountInputTooltip',
            defaultMessage: 'Agents work on tickets and communicate directly with your customers.'
        },
        cardOverSignupLimit: {
            id: 'JsmPricingPageV2.priceFinder.cardOverSignupLimit',
            defaultMessage: "Your agent count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: 'JsmPricingPageV2.priceFinder.cardEnterpriseMinimumCount',
            defaultMessage: 'Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more agents above',
            description: 'Enterprise is a plan name and should not be translated'
        },
        cardUnitCountTierRange: {
            id: 'JsmPricingPageV2.priceFinder.cardUnitCountTierRange',
            defaultMessage: 'Agent tier: {lowerLimit} - {upperLimit}'
        },
        cardMonthlyPerUnitCount: {
            id: 'JsmPricingPageV2.priceFinder.cardMonthlyPerUnitCount',
            defaultMessage: 'per agent / month'
        },
        cardFreeDescription: {
            id: 'JsmPricingPageV2.priceFinder.cardFreeDescription',
            defaultMessage: 'always free for 3 agents,'
        }
    });
    const content = {
        free: (0, $dl2JF.usePricingPlanComparison)('Free'),
        standard: (0, $dl2JF.usePricingPlanComparison)('Standard'),
        premium: (0, $dl2JF.usePricingPlanComparison)('Premium'),
        enterprise: (0, $dl2JF.usePricingPlanComparison)('Enterprise')
    };
    const freePlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, 'free');
    const standardPlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, 'standard');
    const premiumPlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, 'premium');
    const enterprisePlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, 'enterprise');
    // Note: We need to use the jiraServiceDesk plan name instead of a new jiraServiceManagement key because of how the pricing data is stored in CCP/HAMS. jiraServiceManagement is used as the dataProductKey in all other components on the JSM pricing page.
    const jiraServiceManagementProductPlans = [
        {
            planName: content.free?.planTitleExternal || 'Free',
            offeringSku: 'jira-servicedesk-free',
            description: content.free?.planOneLiner || '',
            recommendationLimit: 0,
            signupLimit: 20000,
            signupURLSuffix: '?bundle=jira-service-management&edition=free&signupSource=pricing',
            planFeatureMessages: freePlanFeatureMessages
        },
        {
            planName: content.standard?.planTitleExternal || 'Standard',
            offeringSku: 'jira-servicedesk-standard-repack-sku',
            description: content.standard?.planOneLiner || '',
            recommendationLimit: 3,
            signupLimit: 20000,
            signupURLSuffix: '?bundle=jira-service-management&edition=standard&signupSource=pricing',
            planFeatureMessages: standardPlanFeatureMessages
        },
        {
            planName: content.premium?.planTitleExternal || 'Premium',
            offeringSku: 'jira-servicedesk-premium',
            description: content.premium?.planOneLiner || '',
            recommendationLimit: 50,
            signupLimit: 20000,
            signupURLSuffix: '?bundle=jira-service-management&edition=premium&signupSource=pricing',
            planFeatureMessages: premiumPlanFeatureMessages
        },
        {
            planName: content.enterprise?.planTitleExternal || 'Enterprise',
            offeringSku: 'jira-servicedesk-enterprise-sku',
            recommendationLimit: 250,
            description: content.enterprise?.planOneLiner || '',
            signupLimit: 20000,
            planFeatureMessages: enterprisePlanFeatureMessages
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $eYlij.PriceFinderContextProvider), {
        dataProductKey: "jiraServiceDesk",
        productPlans: jiraServiceManagementProductPlans,
        defaultUnitCount: 75,
        enterpriseMinimumCount: 201,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gIRO7.default), {
                messages: messages,
                serverSideCCPPricing: props.pricing?.ccpPricingData?.jiraServiceDesk,
                countryCode: props.countryCode
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aA1TB.default), {})
        ]
    });
};
$863743dd4076071d$export$27bafd5c0a9a3fce.displayName = 'JsmPriceFinderSection';

});
parcelRegister("aA1TB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $18b90e3e981074f6$export$2e2bcd8739ae039; });
/* disclaimer.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");
const $18b90e3e981074f6$var$disclaimerTextStyles = null;
const $18b90e3e981074f6$var$Disclaimer = ({ disclaimerText: disclaimerText })=>{
    const intl = (0, $8e22h.default)();
    const text = disclaimerText ?? intl.formatMessage({
        id: 'pricing.disclaimer.text',
        defaultMessage: "The prices shown are estimates and aren't binding for either you or Atlassian. The amount you are billed may be different if you change your scope of use, including by updating your agent count or exceeding your base plan usage of Assets or Virtual Service Agent."
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        className: (0, $2jatx.default)([
            "_k48p1kdj _vwz4gktf _1wybdlk8 _syazr3uz _1q511tcg"
        ]),
        children: text
    });
};
$18b90e3e981074f6$var$Disclaimer.displayName = 'disclaimer';
var $18b90e3e981074f6$export$2e2bcd8739ae039 = $18b90e3e981074f6$var$Disclaimer;

});




parcelRegister("keOu4", function(module, exports) {
$parcel$export(module.exports, "JiraTemplateCategoryPage", function () { return $35f22ae28293b9db$export$52bd3b9163994b81; });

var $7VQPk = parcelRequire("7VQPk");

var $5eEVK = parcelRequire("5eEVK");
const $35f22ae28293b9db$export$52bd3b9163994b81 = ({ templates: templates })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $5eEVK.JiraTemplateCategoryPageTemplate), {
        templates: templates
    });

});
parcelRegister("5eEVK", function(module, exports) {
$parcel$export(module.exports, "JiraTemplateCategoryPageTemplate", function () { return $53c56b844af24133$export$8ae757bfa7e42dde; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");

var $20OkY = parcelRequire("20OkY");

var $gMME0 = parcelRequire("gMME0");

var $1rObi = parcelRequire("1rObi");

var $6iKF0 = parcelRequire("6iKF0");

var $jBOxZ = parcelRequire("jBOxZ");

var $jsxHL = parcelRequire("jsxHL");

var $7ASVM = parcelRequire("7ASVM");

var $8Sr8q = parcelRequire("8Sr8q");

var $8AvPJ = parcelRequire("8AvPJ");

var $2fCHu = parcelRequire("2fCHu");
const $53c56b844af24133$var$PageContent = ({ templates: templates })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8AvPJ.SharedHeaderFooterContainer), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jsxHL.TypographyStyles), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fCHu.TemplatesGrid), {
                        templates: templates ?? (0, $7ASVM.JSM_TEMPLATES_CONTENT)
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jBOxZ.UnifiedTemplatesNavigationSection), {
                    product: "jiraServiceManagement"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8Sr8q.Resources), {})
            ]
        })
    });
};
const $53c56b844af24133$export$8ae757bfa7e42dde = ({ templates: templates })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const fireSLOErrorEvent = (0, $1oC0p.useCallback)((error)=>{
        createAnalyticsEvent({
            product: 'marketing',
            eventType: 'operational',
            actionSubject: 'wacJsmTemplateScreenFailed',
            action: 'failed',
            attributes: {
                errorMessage: error?.message || error
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6iKF0.default), {
        fallback: /*#__PURE__*/ (0, $7VQPk.jsx)($53c56b844af24133$var$PageContent, {
            templates: templates
        }),
        onError: (e)=>fireSLOErrorEvent(e),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gMME0.CrossFlowProvider), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rObi.CrossFlowTouchpointProvider), {
                productKeys: [
                    (0, $20OkY.ProductKeys).JIRA_SERVICE_DESK
                ],
                screenName: "wacJsmTemplateScreen",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($53c56b844af24133$var$PageContent, {
                    templates: templates
                })
            })
        })
    });
};

});
parcelRegister("7ASVM", function(module, exports) {
$parcel$export(module.exports, "JSM_TEMPLATES_CONTENT", function () { return $44530ce77f7794c2$export$a582b1f9bb954226; });
const $44530ce77f7794c2$export$a582b1f9bb954226 = [
    {
        templateId: 'it-service-management',
        name: 'IT service management',
        oneLinerHeadline: 'Intake requests, set up alerts, raise incidents, and fix issues quickly.',
        urlSlug: 'it-service-management',
        templateIcon: {
            name: 'Jira roadmap',
            size: 200,
            url: 'https://wac-cdn.atlassian.com/dam/jcr:f4f1a80b-82c9-4951-878a-ce360fb2da9d/Screen_Queues.png?cdnVersion=2319',
            refreshUrl: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ug362u6qv3ywnwcca17012vsdfpwcu1j.svg',
            description: 'Jira roadmap'
        },
        keyFeatures: [
            {
                name: 'Alerts and on-call schedules',
                iconRef: 'alert-icon'
            },
            {
                name: 'Multi-channel support',
                iconRef: 'headphone-icon'
            }
        ]
    },
    {
        templateId: 'advanced-it-service-management',
        name: 'Advanced IT service management',
        oneLinerHeadline: 'Incident, change, and problem management with ITSM best practices.',
        urlSlug: 'advanced-it-service-management',
        templateIcon: {
            name: 'Help Center screenshot',
            size: 200,
            url: 'https://wac-cdn.atlassian.com/dam/jcr:95aef340-57e7-4ec1-a92d-cbda63b1814e/var1%20for%20JSM%20templates.svg?cdnVersion=2319',
            refreshUrl: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3fte56b800hsu0n8r76727ht510v7808.svg',
            description: 'Help Center screenshot'
        },
        keyFeatures: [
            {
                name: 'Automated change requests',
                iconRef: 'check-task-icon'
            },
            {
                name: 'Alerts and on-call schedules',
                iconRef: 'alert-icon'
            }
        ]
    },
    {
        templateId: 'hr-service-management',
        name: 'HR service management',
        oneLinerHeadline: 'Manage onboarding and offboarding and respond to HR requests.',
        urlSlug: 'hr-service-management',
        templateIcon: {
            name: 'Jira roadmap',
            size: 200,
            url: 'https://wac-cdn.atlassian.com/dam/jcr:b7e76c98-78d2-4c35-9cf3-a30b6f888dc1/Screen_HelpCenter.png?cdnVersion=2319',
            refreshUrl: 'https://dam-cdn.atl.orangelogic.com/AssetLink/cre6xx6lyq1hcp327v813e1t38k241sx.svg',
            description: 'Jira roadmap'
        },
        keyFeatures: [
            {
                name: 'Self-service and FAQ help center',
                iconRef: 'help-icon'
            },
            {
                name: 'Customizable request forms',
                iconRef: 'mail-icon'
            }
        ]
    },
    {
        templateId: 'customer-service-management',
        name: 'Customer service management',
        oneLinerHeadline: 'Deliver great service experiences for your external customers.',
        urlSlug: 'customer-service-management',
        templateIcon: {
            name: 'Jira roadmap',
            size: 200,
            url: 'https://wac-cdn.atlassian.com/dam/jcr:0abefbb4-6cfd-4163-829a-fcf2db0b99e7/var2%20for%20JSM%20templates.svg?cdnVersion=2319',
            refreshUrl: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2b83vv62ssm4g2km1m7638d126w2e1u3.svg',
            description: 'Jira roadmap'
        },
        keyFeatures: [
            {
                name: 'Developer escalations',
                iconRef: 'flag-icon'
            },
            {
                name: 'Self-service and FAQ help center',
                iconRef: 'help-icon'
            }
        ]
    },
    {
        templateId: 'marketing-service-management',
        name: 'Marketing service management',
        oneLinerHeadline: 'Manage and track all your marketing requests.',
        urlSlug: 'marketing-service-management',
        templateIcon: {
            name: 'Jira roadmap',
            size: 200,
            url: 'https://wac-cdn.atlassian.com/dam/jcr:b7e76c98-78d2-4c35-9cf3-a30b6f888dc1/Screen_HelpCenter.png?cdnVersion=2319',
            refreshUrl: 'https://dam-cdn.atl.orangelogic.com/AssetLink/g13dr33528x350811shfr52mr5y5hr72.svg',
            description: 'Jira roadmap'
        },
        keyFeatures: [
            {
                name: 'Forms for Marketing requests',
                iconRef: 'mail-icon'
            },
            {
                name: 'Reports',
                iconRef: 'data-points-icon'
            }
        ]
    },
    {
        templateId: 'design-service-management',
        name: 'Design service management',
        oneLinerHeadline: 'Manage and track all your design requests.',
        urlSlug: 'design-service-management',
        templateIcon: {
            name: 'Help Center screenshot',
            size: 200,
            url: 'https://wac-cdn.atlassian.com/dam/jcr:95aef340-57e7-4ec1-a92d-cbda63b1814e/var1%20for%20JSM%20templates.svg?cdnVersion=2319',
            refreshUrl: 'https://dam-cdn.atl.orangelogic.com/AssetLink/e4tgp6i7841gcfb7wf43k0j6a2576264.svg',
            description: 'Help Center screenshot'
        },
        keyFeatures: [
            {
                name: 'Self-service and FAQ help center',
                iconRef: 'help-icon'
            },
            {
                name: 'Automated design workflows',
                iconRef: 'workflow-icon'
            }
        ]
    },
    {
        templateId: 'finance-service-management',
        name: 'Finance service management',
        oneLinerHeadline: 'Manage and track budget, spend, and other finance requests.',
        urlSlug: 'finance-service-management',
        templateIcon: {
            name: 'Form view',
            size: 200,
            url: 'https://wac-cdn.atlassian.com/dam/jcr:f4f1a80b-82c9-4951-878a-ce360fb2da9d/Screen_Queues.png?cdnVersion=2319',
            refreshUrl: 'https://dam-cdn.atl.orangelogic.com/AssetLink/401876mvht4ti1a070a3s3o3t3i6s51u.svg',
            description: 'Form view'
        },
        keyFeatures: [
            {
                name: 'Forms for Finance requests',
                iconRef: 'mail-icon'
            },
            {
                name: 'Reporting and tracking',
                iconRef: 'data-points-icon'
            }
        ]
    },
    {
        templateId: 'analytics-service-management',
        name: 'Analytics service management',
        oneLinerHeadline: 'Manage employee requests for the data and insights they need.',
        urlSlug: 'analytics-service-management',
        templateIcon: {
            name: 'Jira roadmap',
            size: 200,
            url: 'https://wac-cdn.atlassian.com/dam/jcr:95aef340-57e7-4ec1-a92d-cbda63b1814e/var1%20for%20JSM%20templates.svg?cdnVersion=2319',
            refreshUrl: 'https://dam-cdn.atl.orangelogic.com/AssetLink/hqvjo4k71u4x3y6e2nkden08471f4e47.svg',
            description: 'Jira roadmap'
        },
        keyFeatures: [
            {
                name: 'Self-service and FAQ help center',
                iconRef: 'help-icon'
            },
            {
                name: 'Automated Analytics workflows',
                iconRef: 'robot-icon'
            }
        ]
    },
    {
        templateId: 'facilities-service-management',
        name: 'Facilities service management',
        oneLinerHeadline: 'Manage requests for maintenance, moving, and event planning.',
        urlSlug: 'facilities-service-management',
        templateIcon: {
            name: 'Help center screenshot',
            size: 200,
            url: 'https://wac-cdn.atlassian.com/dam/jcr:b7e76c98-78d2-4c35-9cf3-a30b6f888dc1/Screen_HelpCenter.png?cdnVersion=2319',
            refreshUrl: 'https://dam-cdn.atl.orangelogic.com/AssetLink/18xqw35pw8do7ru0wp3d8oscs2fmw1mf.svg',
            description: 'Help center screenshot'
        },
        keyFeatures: [
            {
                name: 'Forms for Facilities requests',
                iconRef: 'mail-icon'
            },
            {
                name: 'Self-service and FAQ help center',
                iconRef: 'help-icon'
            }
        ]
    },
    {
        templateId: 'sales-service-management',
        name: 'Sales service management',
        oneLinerHeadline: 'Manage, track, and report on all your sales requests.',
        urlSlug: 'sales-service-management',
        templateIcon: {
            name: 'Kanban board',
            size: 200,
            url: 'https://wac-cdn.atlassian.com/dam/jcr:0abefbb4-6cfd-4163-829a-fcf2db0b99e7/var2%20for%20JSM%20templates.svg?cdnVersion=2319',
            refreshUrl: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1k3k7o8j66265rdk5e6vj0o23g611j04.svg',
            description: 'Kanban board'
        },
        keyFeatures: [
            {
                name: 'Forms designed for Sales requests',
                iconRef: 'mail-icon'
            },
            {
                name: 'Reporting and tracking',
                iconRef: 'data-points-icon'
            }
        ]
    },
    {
        templateId: 'legal-service-management',
        name: 'Legal service management',
        oneLinerHeadline: 'Manage and track all your contracts and legal requests.',
        urlSlug: 'legal-service-management',
        templateIcon: {
            name: 'Jira roadmap',
            size: 200,
            url: 'https://wac-cdn.atlassian.com/dam/jcr:b7e76c98-78d2-4c35-9cf3-a30b6f888dc1/Screen_HelpCenter.png?cdnVersion=2319',
            refreshUrl: 'https://dam-cdn.atl.orangelogic.com/AssetLink/47k1ynn8f0024m4tg2vd6omf3jr60h7u.svg',
            description: 'Jira roadmap'
        },
        keyFeatures: [
            {
                name: 'Self-service and FAQ help center',
                iconRef: 'help-icon'
            },
            {
                name: 'Customer portal to take requests',
                iconRef: 'mail-icon'
            }
        ]
    },
    {
        templateId: 'general-service-management',
        name: 'General service management',
        oneLinerHeadline: 'Collect, prioritize, and manage requests for any business teams.',
        urlSlug: 'general-service-management',
        templateIcon: {
            name: 'Queues view',
            size: 200,
            url: 'https://wac-cdn.atlassian.com/dam/jcr:f4f1a80b-82c9-4951-878a-ce360fb2da9d/Screen_Queues.png?cdnVersion=2319',
            refreshUrl: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2x43564ibsn386dk7g764353rk2341n2.svg',
            description: 'Queues view'
        },
        keyFeatures: [
            {
                name: 'Self-service and FAQ help center',
                iconRef: 'help-icon'
            },
            {
                name: 'Customer portal to take requests',
                iconRef: 'mail-icon'
            }
        ]
    }
];

});

parcelRegister("8Sr8q", function(module, exports) {
$parcel$export(module.exports, "Resources", function () { return $cfe011856ec0428b$export$e9a269813a6315a4; });
/* resources.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $iPPTB = parcelRequire("iPPTB");

var $jQ0cd = parcelRequire("jQ0cd");

var $1rGpC = parcelRequire("1rGpC");
const $cfe011856ec0428b$var$backgroundStyles = null;
const $cfe011856ec0428b$var$h2Styles = null;
const $cfe011856ec0428b$var$h4Styles = null;
const $cfe011856ec0428b$var$pStyles = null;
const $cfe011856ec0428b$var$linkStyles = null;
const $cfe011856ec0428b$export$e9a269813a6315a4 = ()=>{
    const intl = (0, $8e22h.default)();
    const resources = [
        {
            heading: intl.formatMessage({
                id: 'jsm.templates.resources.gettingStartedGuide',
                defaultMessage: 'Getting started guide'
            }),
            description: intl.formatMessage({
                id: 'jsm.templates.resources.gettingStartedGuideDescription',
                defaultMessage: 'Everything you need to know about getting started with Jira Service Management.'
            }),
            link: {
                text: intl.formatMessage({
                    id: 'jsm.templates.resources.gettingStartedGuideLink',
                    defaultMessage: 'Go to guide'
                }),
                href: (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/product-guide/getting-started/quick-start-guide'),
                type: 'primary'
            }
        },
        {
            heading: intl.formatMessage({
                id: 'jsm.templates.resources.productGuide',
                defaultMessage: 'Jira Service Management product guides'
            }),
            description: intl.formatMessage({
                id: 'jsm.templates.resources.productGuideDescription',
                defaultMessage: 'How to use Jira Service Management: guides, tutorials, and demos.'
            }),
            link: {
                text: intl.formatMessage({
                    id: 'jsm.templates.resources.productGuideLink',
                    defaultMessage: 'Review the guide'
                }),
                href: (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/product-guide'),
                type: 'primary'
            }
        },
        {
            heading: intl.formatMessage({
                id: 'jsm.templates.resources.demo',
                defaultMessage: 'Jira Service Management demo'
            }),
            description: intl.formatMessage({
                id: 'jsm.templates.resources.demoDescription',
                defaultMessage: "Choose specific features you\u2019re interested in and we\u2019ll personalize a demo for you."
            }),
            link: {
                text: intl.formatMessage({
                    id: 'jsm.templates.resources.demoLink',
                    defaultMessage: 'Watch the demo'
                }),
                href: (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/demo'),
                type: 'primary'
            }
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1itk1ejp _12vemgnk _1lrw1wug _1bsb1osq _ca0qgktf _u5f37vkz _n3tdckbl _19bv7vkz _1akockbl _c7s77vkz _4puvvbgk _1r3v7vkz _3int1h90 _4fuggrf3 _1ynq1h90 _1j3ngrf3 _ip651h90 _g8ou1h90 _1opi1h90 _1x951h90"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_syazmcao _1wybk299 _k48p124r _vwz42a8g _y3gn1qpp _19pkgrf3 _2hwx1h90 _otyrgrf3 _18u01h90 _ca0q7vkz _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _1ako1crf _c7s77vkz _4puv1crf _1r3v7vkz _1s18r6mz _uj6k1s23"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "resources.heading",
                    defaultMessage: 'Service management resources'
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                layout: "4-4-4",
                children: resources.map((resource, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                                className: (0, $2jatx.default)([
                                    "_syazmcao _k48p124r _vwz4cjiy _6rth1usy _1wyb19as _1dyzzyni _1s18n2z8"
                                ]),
                                children: resource.heading
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_syazt5hr _1wyb1j6v _k48pl8b6 _vwz41k8s _6rth1x4e"
                                ]),
                                children: resource.description
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                ...resource.link,
                                className: (0, $2jatx.default)([
                                    "_v56412xp"
                                ])
                            })
                        ]
                    }, index))
            })
        ]
    });
};

});

parcelRegister("8AvPJ", function(module, exports) {
$parcel$export(module.exports, "SharedHeaderFooterContainer", function () { return $37d8fa01f56156a9$export$93790172861f3d8b; });

var $7VQPk = parcelRequire("7VQPk");

var $20OkY = parcelRequire("20OkY");

var $iHYHa = parcelRequire("iHYHa");

var $iLjCW = parcelRequire("iLjCW");

var $aYVVm = parcelRequire("aYVVm");
const $37d8fa01f56156a9$export$93790172861f3d8b = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aYVVm.default), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iHYHa.SiteSelectorContextProvider), {
                productKey: (0, $20OkY.ProductKeys).JIRA_SERVICE_DESK,
                analyticsPrefix: "wac.showroom",
                internalLinkAfterIdentity: "/team-playbook/plays/choose-your-site",
                children: children
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iLjCW.GlobalFooter), {})
        ]
    });
};

});

parcelRegister("2fCHu", function(module, exports) {
$parcel$export(module.exports, "TemplatesGrid", function () { return $fc0f390a3f68e4b0$export$e845b3e887ad68a4; });
/* templates-grid.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $5LkDU = parcelRequire("5LkDU");

var $1rGpC = parcelRequire("1rGpC");
const $fc0f390a3f68e4b0$var$fontCharlieDisplay = `"Charlie Display", "Charlie Text", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Noto Sans", Ubuntu, "Droid Sans", "Helvetica Neue", sans-serif`;
const $fc0f390a3f68e4b0$var$fontCharlieText = `"Charlie Text", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Noto Sans", Ubuntu, "Droid Sans", "Helvetica Neue", sans-serif`;
const $fc0f390a3f68e4b0$var$backgroundStyles = null;
const $fc0f390a3f68e4b0$var$containerStyles = null;
const $fc0f390a3f68e4b0$var$titleStyles = null;
const $fc0f390a3f68e4b0$var$h1Styles = null;
const $fc0f390a3f68e4b0$var$pStyles = null;
const $fc0f390a3f68e4b0$var$gridContainerStyles = null;
const $fc0f390a3f68e4b0$export$e845b3e887ad68a4 = ({ templates: templates })=>{
    const templateGridRows = ()=>{
        const rows = [];
        for(let i = 0; i < templates.length; i += 3)rows.push(templates.slice(i, i + 3));
        return rows;
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1itk12hr _12vemgnk _1reoidpf _18m9idpf"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_ahbq1wug _12l21wug _85i57vkz _1q517vkz _p12f1fra _1yd316xz _1waf16xz"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_ahbq1wug _12l21wug _1bsb1osq _bozg7vkz _y4ti7vkz _85i5zwfg _14b5m8w4 _uj6k1h6o _1yd3vbgk _glte2c62 _40tuvbgk"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                            className: (0, $2jatx.default)([
                                "_syazmcao _vwz4zz36 _ect41bwv _k48p53lb _1pfhidpf _6rth7vkz _1wyb14b4 _1s181a5d _3p1cxxch"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "jsm.templates.page.title",
                                defaultMessage: 'Service management templates'
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            className: (0, $2jatx.default)([
                                "_syazi7uo _ect41fn2"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "jsm.templates.page.subtitle",
                                defaultMessage: 'Empower any team to get started with a service experience in Jira Service Management with pre-configured request types, workflows, and automations.'
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    "data-testid": "templates-grid",
                    className: (0, $2jatx.default)([
                        "_1bsb1osq _bozg1gpt _y4ti1gpt _9bbqgrf3 _1qqcgrf3"
                    ]),
                    children: templateGridRows().map((row, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                            layout: "4-4-4",
                            children: row.map((template)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $5LkDU.TemplateCard), {
                                    template: template
                                }, template.urlSlug))
                        }, `template-grid-row-${index}`))
                })
            ]
        })
    });
};

});
parcelRegister("5LkDU", function(module, exports) {
$parcel$export(module.exports, "TemplateCard", function () { return $5795f296170cd462$export$ba340e850b866867; });
/* template-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $92jF6 = parcelRequire("92jF6");

var $kbpa7 = parcelRequire("kbpa7");

var $jSj3N = parcelRequire("jSj3N");
const $5795f296170cd462$var$colorN700 = '#253858';
const $5795f296170cd462$var$containerStyles = null;
const $5795f296170cd462$export$ba340e850b866867 = ({ template: template })=>{
    const intl = (0, $8e22h.default)();
    const url = template.urlSlug ? `/software/jira/templates/${template.urlSlug}` : '';
    const messages = // @ts-ignore
    (0, $jSj3N.JiraServiceManagementTemplateMessageMap)[template.templateId];
    if (messages) return /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        href: url ?? '',
        className: (0, $2jatx.default)([
            "_z5uk1h67 _1boa1h67 _16it1h67 _ad5c1h67 _1rhqmcao _8kc9n2z8 _1euyw0jn _k6x01gpt _125xmcao _q7gq19as _zcqxk299 _1ayngrf3 _16qsvjkv _v564mihd _1dbz1x6p _858u1auy _2rko1wa3 _1reo15vq _18m915vq _1ilwgrf3"
        ]),
        style: {
            "--_1hwkv7u": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark1100')),
            "--_n0ignx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue1000'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $92jF6.Card), {
            className: "template-card",
            "data-testid": "template-card",
            headerText: intl.formatMessage(messages.name),
            headerType: "h4",
            bodyText: intl.formatMessage(messages.oneLinerHeadline),
            backgroundColor: (0, $kbpa7.wacToken)('color.neutral.light100'),
            textColor: $5795f296170cd462$var$colorN700,
            clickableCardUrl: url ?? '',
            pictureProps: {
                image: {
                    src: template.templateIcon?.url ?? '',
                    alt: intl.formatMessage(messages.iconDescription) ?? ''
                }
            }
        })
    });
    return null;
};

});
parcelRegister("jSj3N", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementTemplateMessageMap", function () { return $5cab63bd7c1076be$export$7eb612acc27aff49; });

var $fnHPc = parcelRequire("fnHPc");
const $5cab63bd7c1076be$export$7d34f3deca703e17 = (0, $fnHPc.defineMessages)({
    'it-service-managementName': {
        id: 'jsm.templates.it-service-management.name',
        defaultMessage: 'IT service management'
    },
    'it-service-managementOneLinerHeadline': {
        id: 'jsm.templates.it-service-management.oneLinerHeadline',
        defaultMessage: 'Intake requests, set up alerts, raise incidents, and fix issues quickly.'
    },
    'it-service-managementIconName': {
        id: 'jsm.templates.it-service-management.templateIcon.name',
        defaultMessage: 'Jira roadmap'
    },
    'it-service-managementIconDescription': {
        id: 'jsm.templates.it-service-management.templateIcon.description',
        defaultMessage: 'Jira roadmap'
    },
    'it-service-managementFeature-1': {
        id: 'jsm.templates.it-service-management.feature-1',
        defaultMessage: 'Alerts and on-call schedules'
    },
    'it-service-managementFeature-2': {
        id: 'jsm.templates.it-service-management.feature-2',
        defaultMessage: 'Multi-channel support'
    },
    'advanced-it-service-managementName': {
        id: 'jsm.templates.advanced-it-service-management.name',
        defaultMessage: 'Advanced IT service management'
    },
    'advanced-it-service-managementOneLinerHeadline': {
        id: 'jsm.templates.advanced-it-service-management.oneLinerHeadline',
        defaultMessage: 'Incident, change, and problem management with ITSM best practices.'
    },
    'advanced-it-service-managementIconName': {
        id: 'jsm.templates.advanced-it-service-management.templateIcon.name',
        defaultMessage: 'Help Center screenshot'
    },
    'advanced-it-service-managementIconDescription': {
        id: 'jsm.templates.advanced-it-service-management.templateIcon.description',
        defaultMessage: 'Help Center screenshot'
    },
    'advanced-it-service-managementFeature-1': {
        id: 'jsm.templates.advanced-it-service-management.feature-1',
        defaultMessage: 'Automated change requests'
    },
    'advanced-it-service-managementFeature-2': {
        id: 'jsm.templates.advanced-it-service-management.feature-2',
        defaultMessage: 'Alerts and on-call schedules'
    },
    'hr-service-managementName': {
        id: 'jsm.templates.hr-service-management.name',
        defaultMessage: 'HR service management'
    },
    'hr-service-managementOneLinerHeadline': {
        id: 'jsm.templates.hr-service-management.oneLinerHeadline',
        defaultMessage: 'Manage onboarding and offboarding and respond to HR requests.'
    },
    'hr-service-managementIconName': {
        id: 'jsm.templates.hr-service-management.templateIcon.name',
        defaultMessage: 'Jira roadmap'
    },
    'hr-service-managementIconDescription': {
        id: 'jsm.templates.hr-service-management.templateIcon.description',
        defaultMessage: 'Jira roadmap'
    },
    'hr-service-managementFeature-1': {
        id: 'jsm.templates.hr-service-management.feature-1',
        defaultMessage: 'Self-service and FAQ help center'
    },
    'hr-service-managementFeature-2': {
        id: 'jsm.templates.hr-service-management.feature-2',
        defaultMessage: 'Customizable request forms'
    },
    'customer-service-managementName': {
        id: 'jsm.templates.customer-service-management.name',
        defaultMessage: 'Customer service management'
    },
    'customer-service-managementOneLinerHeadline': {
        id: 'jsm.templates.customer-service-management.oneLinerHeadline',
        defaultMessage: 'Deliver great service experiences for your external customers.'
    },
    'customer-service-managementIconName': {
        id: 'jsm.templates.customer-service-management.templateIcon.name',
        defaultMessage: 'Jira roadmap'
    },
    'customer-service-managementIconDescription': {
        id: 'jsm.templates.customer-service-management.templateIcon.description',
        defaultMessage: 'Jira roadmap'
    },
    'customer-service-managementFeature-1': {
        id: 'jsm.templates.customer-service-management.feature-1',
        defaultMessage: 'Developer escalations'
    },
    'customer-service-managementFeature-2': {
        id: 'jsm.templates.customer-service-management.feature-2',
        defaultMessage: 'Self-service and FAQ help center'
    },
    'marketing-service-managementName': {
        id: 'jsm.templates.marketing-service-management.name',
        defaultMessage: 'Marketing service management'
    },
    'marketing-service-managementOneLinerHeadline': {
        id: 'jsm.templates.marketing-service-management.oneLinerHeadline',
        defaultMessage: 'Manage and track all your marketing requests.'
    },
    'marketing-service-managementIconName': {
        id: 'jsm.templates.marketing-service-management.templateIcon.name',
        defaultMessage: 'Jira roadmap'
    },
    'marketing-service-managementIconDescription': {
        id: 'jsm.templates.marketing-service-management.templateIcon.description',
        defaultMessage: 'Jira roadmap'
    },
    'marketing-service-managementFeature-1': {
        id: 'jsm.templates.marketing-service-management.feature-1',
        defaultMessage: 'Forms for Marketing requests'
    },
    'marketing-service-managementFeature-2': {
        id: 'jsm.templates.marketing-service-management.feature-2',
        defaultMessage: 'Reports'
    },
    'design-service-managementName': {
        id: 'jsm.templates.design-service-management.name',
        defaultMessage: 'Design service management'
    },
    'design-service-managementOneLinerHeadline': {
        id: 'jsm.templates.design-service-management.oneLinerHeadline',
        defaultMessage: 'Manage and track all your design requests.'
    },
    'design-service-managementIconName': {
        id: 'jsm.templates.design-service-management.templateIcon.name',
        defaultMessage: 'Help Center screenshot'
    },
    'design-service-managementIconDescription': {
        id: 'jsm.templates.design-service-management.templateIcon.description',
        defaultMessage: 'Help Center screenshot'
    },
    'design-service-managementFeature-1': {
        id: 'jsm.templates.design-service-management.feature-1',
        defaultMessage: 'Self-service and FAQ help center'
    },
    'design-service-managementFeature-2': {
        id: 'jsm.templates.design-service-management.feature-2',
        defaultMessage: 'Automated design workflows'
    },
    'finance-service-managementName': {
        id: 'jsm.templates.finance-service-management.name',
        defaultMessage: 'Finance service management'
    },
    'finance-service-managementOneLinerHeadline': {
        id: 'jsm.templates.finance-service-management.oneLinerHeadline',
        defaultMessage: 'Manage and track budget, spend, and other finance requests.'
    },
    'finance-service-managementIconName': {
        id: 'jsm.templates.finance-service-management.templateIcon.name',
        defaultMessage: 'Form view'
    },
    'finance-service-managementIconDescription': {
        id: 'jsm.templates.finance-service-management.templateIcon.description',
        defaultMessage: 'Form view'
    },
    'finance-service-managementFeature-1': {
        id: 'jsm.templates.finance-service-management.feature-1',
        defaultMessage: 'Forms for Finance requests'
    },
    'finance-service-managementFeature-2': {
        id: 'jsm.templates.finance-service-management.feature-2',
        defaultMessage: 'Reporting and tracking'
    },
    'analytics-service-managementName': {
        id: 'jsm.templates.analytics-service-management.name',
        defaultMessage: 'Analytics service management'
    },
    'analytics-service-managementOneLinerHeadline': {
        id: 'jsm.templates.analytics-service-management.oneLinerHeadline',
        defaultMessage: 'Manage employee requests for the data and insights they need.'
    },
    'analytics-service-managementIconName': {
        id: 'jsm.templates.analytics-service-management.templateIcon.name',
        defaultMessage: 'Jira roadmap'
    },
    'analytics-service-managementIconDescription': {
        id: 'jsm.templates.analytics-service-management.templateIcon.description',
        defaultMessage: 'Jira roadmap'
    },
    'analytics-service-managementFeature-1': {
        id: 'jsm.templates.analytics-service-management.feature-1',
        defaultMessage: 'Self-service and FAQ help center'
    },
    'analytics-service-managementFeature-2': {
        id: 'jsm.templates.analytics-service-management.feature-2',
        defaultMessage: 'Automated Analytics workflows'
    },
    'facilities-service-managementName': {
        id: 'jsm.templates.facilities-service-management.name',
        defaultMessage: 'Facilities service management'
    },
    'facilities-service-managementOneLinerHeadline': {
        id: 'jsm.templates.facilities-service-management.oneLinerHeadline',
        defaultMessage: 'Manage requests for maintenance, moving, and event planning.'
    },
    'facilities-service-managementIconName': {
        id: 'jsm.templates.facilities-service-management.templateIcon.name',
        defaultMessage: 'Help center screenshot'
    },
    'facilities-service-managementIconDescription': {
        id: 'jsm.templates.facilities-service-management.templateIcon.description',
        defaultMessage: 'Help center screenshot'
    },
    'facilities-service-managementFeature-1': {
        id: 'jsm.templates.facilities-service-management.feature-1',
        defaultMessage: 'Forms for Facilities requests'
    },
    'facilities-service-managementFeature-2': {
        id: 'jsm.templates.facilities-service-management.feature-2',
        defaultMessage: 'Self-service and FAQ help center'
    },
    'sales-service-managementName': {
        id: 'jsm.templates.sales-service-management.name',
        defaultMessage: 'Sales service management'
    },
    'sales-service-managementOneLinerHeadline': {
        id: 'jsm.templates.sales-service-management.oneLinerHeadline',
        defaultMessage: 'Manage, track, and report on all your sales requests.'
    },
    'sales-service-managementIconName': {
        id: 'jsm.templates.sales-service-management.templateIcon.name',
        defaultMessage: 'Kanban board'
    },
    'sales-service-managementIconDescription': {
        id: 'jsm.templates.sales-service-management.template    .Icon.description',
        defaultMessage: 'Kanban board'
    },
    'sales-service-managementFeature-1': {
        id: 'jsm.templates.sales-service-management.feature-1',
        defaultMessage: 'Forms designed for Sales requests'
    },
    'sales-service-managementFeature-2': {
        id: 'jsm.templates.sales-service-management.feature-2',
        defaultMessage: 'Reporting and tracking'
    },
    'legal-service-managementName': {
        id: 'jsm.templates.legal-service-management.name',
        defaultMessage: 'Legal service management'
    },
    'legal-service-managementOneLinerHeadline': {
        id: 'jsm.templates.legal-service-management.oneLinerHeadline',
        defaultMessage: 'Manage and track all your contracts and legal requests.'
    },
    'legal-service-managementIconName': {
        id: 'jsm.templates.legal-service-management.templateIcon.name',
        defaultMessage: 'Jira roadmap'
    },
    'legal-service-managementIconDescription': {
        id: 'jsm.templates.legal-service-management.templateIcon.description',
        defaultMessage: 'Jira roadmap'
    },
    'legal-service-managementFeature-1': {
        id: 'jsm.templates.legal-service-management.feature-1',
        defaultMessage: 'Self-service and FAQ help center'
    },
    'legal-service-managementFeature-2': {
        id: 'jsm.templates.legal-service-management.feature-2',
        defaultMessage: 'Customer portal to take requests'
    },
    'general-service-managementName': {
        id: 'jsm.templates.general-service-management.name',
        defaultMessage: 'General service management'
    },
    'general-service-managementOneLinerHeadline': {
        id: 'jsm.templates.general-service-management.oneLinerHeadline',
        defaultMessage: 'Collect, prioritize, and manage requests for any business teams.'
    },
    'general-service-managementIconName': {
        id: 'jsm.templates.general-service-management.templateIcon.name',
        defaultMessage: 'Queues view'
    },
    'general-service-managementIconDescription': {
        id: 'jsm.templates.general-service-management.templateIcon.description',
        defaultMessage: 'Queues view'
    },
    'general-service-managementFeature-1': {
        id: 'jsm.templates.general-service-management.feature-1',
        defaultMessage: 'Self-service and FAQ help center'
    },
    'general-service-managementFeature-2': {
        id: 'jsm.templates.general-service-management.feature-2',
        defaultMessage: 'Customer portal to take requests'
    }
});
const $5cab63bd7c1076be$export$7eb612acc27aff49 = {
    'it-service-management': {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17['it-service-managementName'],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17['it-service-managementOneLinerHeadline'],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17['it-service-managementIconName'],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17['it-service-managementIconDescription'],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17['it-service-managementFeature-1'],
            $5cab63bd7c1076be$export$7d34f3deca703e17['it-service-managementFeature-2']
        ]
    },
    'advanced-it-service-management': {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17['advanced-it-service-managementName'],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17['advanced-it-service-managementOneLinerHeadline'],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17['advanced-it-service-managementIconName'],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17['advanced-it-service-managementIconDescription'],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17['advanced-it-service-managementFeature-1'],
            $5cab63bd7c1076be$export$7d34f3deca703e17['advanced-it-service-managementFeature-2']
        ]
    },
    'hr-service-management': {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17['hr-service-managementName'],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17['hr-service-managementOneLinerHeadline'],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17['hr-service-managementIconName'],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17['hr-service-managementIconDescription'],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17['hr-service-managementFeature-1'],
            $5cab63bd7c1076be$export$7d34f3deca703e17['hr-service-managementFeature-2']
        ]
    },
    'customer-service-management': {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17['customer-service-managementName'],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17['customer-service-managementOneLinerHeadline'],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17['customer-service-managementIconName'],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17['customer-service-managementIconDescription'],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17['customer-service-managementFeature-1'],
            $5cab63bd7c1076be$export$7d34f3deca703e17['customer-service-managementFeature-2']
        ]
    },
    'marketing-service-management': {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17['marketing-service-managementName'],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17['marketing-service-managementOneLinerHeadline'],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17['marketing-service-managementIconName'],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17['marketing-service-managementIconDescription'],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17['marketing-service-managementFeature-1'],
            $5cab63bd7c1076be$export$7d34f3deca703e17['marketing-service-managementFeature-2']
        ]
    },
    'design-service-management': {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17['design-service-managementName'],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17['design-service-managementOneLinerHeadline'],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17['design-service-managementIconName'],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17['design-service-managementIconDescription'],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17['design-service-managementFeature-1'],
            $5cab63bd7c1076be$export$7d34f3deca703e17['design-service-managementFeature-2']
        ]
    },
    'finance-service-management': {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17['finance-service-managementName'],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17['finance-service-managementOneLinerHeadline'],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17['finance-service-managementIconName'],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17['finance-service-managementIconDescription'],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17['finance-service-managementFeature-1'],
            $5cab63bd7c1076be$export$7d34f3deca703e17['finance-service-managementFeature-2']
        ]
    },
    'analytics-service-management': {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17['analytics-service-managementName'],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17['analytics-service-managementOneLinerHeadline'],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17['analytics-service-managementIconName'],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17['analytics-service-managementIconDescription'],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17['analytics-service-managementFeature-1'],
            $5cab63bd7c1076be$export$7d34f3deca703e17['analytics-service-managementFeature-2']
        ]
    },
    'facilities-service-management': {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17['facilities-service-managementName'],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17['facilities-service-managementOneLinerHeadline'],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17['facilities-service-managementIconName'],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17['facilities-service-managementIconDescription'],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17['facilities-service-managementFeature-1'],
            $5cab63bd7c1076be$export$7d34f3deca703e17['facilities-service-managementFeature-2']
        ]
    },
    'sales-service-management': {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17['sales-service-managementName'],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17['sales-service-managementOneLinerHeadline'],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17['sales-service-managementIconName'],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17['sales-service-managementIconDescription'],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17['sales-service-managementFeature-1'],
            $5cab63bd7c1076be$export$7d34f3deca703e17['sales-service-managementFeature-2']
        ]
    },
    'legal-service-management': {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17['legal-service-managementName'],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17['legal-service-managementOneLinerHeadline'],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17['legal-service-managementIconName'],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17['legal-service-managementIconDescription'],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17['legal-service-managementFeature-1'],
            $5cab63bd7c1076be$export$7d34f3deca703e17['legal-service-managementFeature-2']
        ]
    },
    'general-service-management': {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17['general-service-managementName'],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17['general-service-managementOneLinerHeadline'],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17['general-service-managementIconName'],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17['general-service-managementIconDescription'],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17['general-service-managementFeature-1'],
            $5cab63bd7c1076be$export$7d34f3deca703e17['general-service-managementFeature-2']
        ]
    }
};

});





parcelRegister("cbLEA", function(module, exports) {
$parcel$export(module.exports, "LoomPricingPage", function () { return $129471080e200af5$export$1c056246c70ea895; });

var $7VQPk = parcelRequire("7VQPk");

var $dl2JF = parcelRequire("dl2JF");

var $2hXb7 = parcelRequire("2hXb7");
const $129471080e200af5$export$1c056246c70ea895 = (props)=>{
    const { pricingContent: pricingContent, queryRef: queryRef } = props;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dl2JF.PricingContentContextProviderRelay), {
        productId: "loom",
        pricingContent: pricingContent,
        queryRef: queryRef,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2hXb7.LoomPricingPage), {})
    });
};

});
parcelRegister("2hXb7", function(module, exports) {
$parcel$export(module.exports, "LoomPricingPage", function () { return $7badbe18ec94dee9$export$1c056246c70ea895; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $kIC93 = parcelRequire("kIC93");

var $7aKDf = parcelRequire("7aKDf");

var $dl2JF = parcelRequire("dl2JF");

var $bE8d4 = parcelRequire("bE8d4");

var $2zOxm = parcelRequire("2zOxm");

var $6Px6U = parcelRequire("6Px6U");

var $grcEk = parcelRequire("grcEk");

var $frz5c = parcelRequire("frz5c");

var $iPPTB = parcelRequire("iPPTB");

var $jQ0cd = parcelRequire("jQ0cd");

var $jsxHL = parcelRequire("jsxHL");

var $1K6kz = parcelRequire("1K6kz");

var $5S2vX = parcelRequire("5S2vX");

var $4ui88 = parcelRequire("4ui88");

var $9Url8 = parcelRequire("9Url8");

var $dQswK = parcelRequire("dQswK");
const $7badbe18ec94dee9$export$1c056246c70ea895 = (props)=>{
    const { pricing: pricing, countryCode: countryCode } = props;
    const content = (0, $dl2JF.usePricingContentContext)();
    const featuresCtaContent = content?.callToActionContainer?.[1];
    const questionsCtaContent = content?.callToActionContainer?.[0];
    const intl = (0, $8e22h.default)();
    const defaultQuestionsCtaHrefPath = (0, $dQswK.usePremiumSignupUrl)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
        nav: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1K6kz.default), {}),
        showFallback: content?.hasError,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
            scrollTrackingEnabled: true,
            pageId: "loom-pricing-page",
            as: "main",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6Px6U.PageHeading), {
                    children: content?.headline
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9Url8.LoomPriceFinder), {
                    pricing: pricing,
                    countryCode: countryCode
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4ui88.LoomAiSection), {}),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aKDf.PricingFeatureTable), {
                    title: content?.compareFeaturesTitle ?? undefined,
                    comparePlans: content?.comparePlans ?? undefined,
                    compareFeatures: content?.compareFeatures ?? undefined,
                    linkValues: {
                        linkText: featuresCtaContent?.text ?? undefined,
                        linkHref: featuresCtaContent?.url ?? undefined
                    },
                    dataProductKey: 'loom',
                    stickyCtasEnabled: false
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                    href: (0, $jQ0cd.useLocalizedHref)('/teams/nonprofits/discount-pricing?tab=loom'),
                    text: intl.formatMessage({
                        id: 'LoomPricingPage.educationDiscount',
                        defaultMessage: 'Are you a teacher or a student? Take advantage of our Education discount'
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kIC93.TwcPromo), {
                        product: "loom"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2zOxm.QuotationsAdornment), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bE8d4.PricingFaq), {
                            header: content?.getMoreDetailsTitle ?? undefined,
                            planDetails: content?.additionalDetails ?? undefined
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $frz5c.QuestionsCta), {
                    product: 'Loom',
                    ctaHref: questionsCtaContent?.url ?? defaultQuestionsCtaHrefPath,
                    questionsHeader: questionsCtaContent?.title ?? undefined,
                    priceAndLicensingLinkText: questionsCtaContent?.text ?? undefined,
                    questionsBody: questionsCtaContent?.valueProposition ?? undefined,
                    imageHref: questionsCtaContent?.asset?.url
                })
            ]
        })
    });
};

});
parcelRegister("1K6kz", function(module, exports) {
$parcel$export(module.exports, "LoomNav", function () { return $b0045c9e2971c8ff$export$e9541932877c1f74; });
$parcel$export(module.exports, "default", function () { return $b0045c9e2971c8ff$export$2e2bcd8739ae039; });
/* loom-navbar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $eOIix = parcelRequire("eOIix");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $jsxHL = parcelRequire("jsxHL");

var $8nFt2 = parcelRequire("8nFt2");

var $9KOR3 = parcelRequire("9KOR3");

var $gn6Qa = parcelRequire("gn6Qa");

var $56kyt = parcelRequire("56kyt");

var $2Kjb7 = parcelRequire("2Kjb7");
const $b0045c9e2971c8ff$var$wrapSubnav = (subnav)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.DivOnHoverExit), {
        className: (0, $2jatx.default)([
            "_kqswh2mm"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8nFt2.MotionContainer), {
                direction: "none",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1rjc1jfw _18zr1jfw"
                    ]),
                    children: subnav
                })
            })
        })
    });
};
const $b0045c9e2971c8ff$var$LoomLogoComponent = ()=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "loom",
        type: "logo",
        appearance: "brand",
        darkTheme: isDarkTheme
    });
};
const $b0045c9e2971c8ff$export$e9541932877c1f74 = ()=>{
    const intl = (0, $8e22h.default)();
    const dropdownStyles = (0, $1oC0p.useMemo)(()=>{
        return {
            width: 'fit-content !important',
            margin: 0,
            insetBlockStart: '4.25rem'
        };
    }, []);
    const signupLink = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=loom&edition=premium');
    const resourcesHref = (0, $jQ0cd.useLocalizedHref)('/software/loom/resources');
    const guidesHref = (0, $jQ0cd.useLocalizedHref)('/software/loom/resources/guides/getting-started');
    const pricingHref = (0, $jQ0cd.useLocalizedHref)('/software/loom/pricing');
    const links = [
        {
            globalLinksKey: 'features',
            productKey: 'loom',
            linkText: intl.formatMessage({
                id: 'LoomPageTemplate.navbar.features',
                defaultMessage: 'Features'
            }),
            hasDropdown: true,
            content: $b0045c9e2971c8ff$var$wrapSubnav(/*#__PURE__*/ (0, $7VQPk.jsx)((0, $56kyt.LoomFeaturesDropdown), {})),
            containerPosition: 'relative'
        },
        {
            globalLinksKey: 'solutions',
            productKey: 'loom',
            linkText: intl.formatMessage({
                id: 'LoomPageTemplate.navbar.resources',
                defaultMessage: 'Solutions'
            }),
            hasDropdown: true,
            containerStyles: dropdownStyles,
            content: $b0045c9e2971c8ff$var$wrapSubnav(/*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Kjb7.LoomSolutionsDropdown), {})),
            containerPosition: 'relative'
        },
        {
            globalLinksKey: 'resources',
            productKey: 'loom',
            linkText: intl.formatMessage({
                id: 'LoomPageTemplate.navbar.useCases',
                defaultMessage: 'Resources'
            }),
            hasDropdown: false,
            href: resourcesHref
        },
        {
            globalLinksKey: 'guides',
            productKey: 'loom',
            linkText: intl.formatMessage({
                id: 'LoomPageTemplate.navbar.guides',
                defaultMessage: 'Guides'
            }),
            hasDropdown: false,
            href: guidesHref
        },
        {
            globalLinksKey: 'pricing',
            productKey: 'loom',
            linkText: intl.formatMessage({
                id: 'LoomPageTemplate.navbar.pricing',
                defaultMessage: 'Pricing'
            }),
            hasDropdown: false,
            href: pricingHref
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gn6Qa.ProductPageNav), {
        productKey: 'loom',
        productLogoUrl: "/software/loom",
        productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($b0045c9e2971c8ff$var$LoomLogoComponent, {}),
        productLogoAriaLabel: intl.formatMessage({
            id: 'LoomPageTemplate.navbar.loom-logo',
            defaultMessage: 'Loom logo'
        }),
        mobileCtaText: intl.formatMessage({
            id: 'LoomPageTemplate.navbar.getitfree',
            defaultMessage: 'Get it Free'
        }),
        navigationTrynowCtaText: intl.formatMessage({
            id: 'LoomPageTemplate.navbar.getitfree',
            defaultMessage: 'Get it Free'
        }),
        mobileCtaUrl: signupLink,
        mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($b0045c9e2971c8ff$var$LoomLogoComponent, {}),
        productPageNavLinks: links,
        navigationTrynowCtaUrl: signupLink,
        mobileLinksSections: [
            {
                mobileLinkKey: 'mobile-loom',
                mobileLinksProps: links
            }
        ],
        additionalMenuPageObjectsArray: [
            {
                menuPageKey: 'features',
                menuPageObjects: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $56kyt.LoomFeaturesDropdown), {})
            },
            {
                menuPageKey: 'solutions',
                menuPageObjects: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Kjb7.LoomSolutionsDropdown), {})
            }
        ]
    });
};
var $b0045c9e2971c8ff$export$2e2bcd8739ae039 = $b0045c9e2971c8ff$export$e9541932877c1f74;

});
parcelRegister("56kyt", function(module, exports) {
$parcel$export(module.exports, "LoomFeaturesDropdown", function () { return $01961365e6587b1d$export$63797861b009ace8; });
/* loom-features-dropdown.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $dzoWS = parcelRequire("dzoWS");
const $01961365e6587b1d$export$63797861b009ace8 = ()=>{
    const intl = (0, $8e22h.default)();
    const productKey = 'loom';
    const loomLinks = {
        features: {
            id: 'features',
            title: (0, $fnHPc.defineMessage)({
                id: 'bitbucketnav.subnav.loomFeatures.links.features',
                defaultMessage: 'Explore Features'
            }),
            items: [
                {
                    id: 'meeting-notes',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.loomFeatures.links.meeting-notes',
                        defaultMessage: 'Meeting Notes'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/ai-meeting')
                },
                {
                    id: 'screen-recorder',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.loomFeatures.links.screen-recorder',
                        defaultMessage: 'Screen Recorder'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/screen-recorder')
                },
                {
                    id: 'screenshots',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.loomFeatures.links.screenshots',
                        defaultMessage: 'Screenshots'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/screenshot')
                },
                {
                    id: 'loom-ai',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.loomFeatures.links.loom-ai',
                        defaultMessage: 'Loom AI'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/ai')
                },
                {
                    id: 'editing',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.loomFeatures.links.editing',
                        defaultMessage: 'Editing'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/editing')
                }
            ]
        }
    };
    const linkColumns = Object.values(loomLinks);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: linkColumns.map((column)=>{
            return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $dzoWS.GlobalNavDropdownLinkColumn), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_1p1dangw _syazsjoz _1wyboqnp _ect4z4z1 _k48p1fw0 _vwz41j6v"
                        ]),
                        style: {
                            "--_8vca0i": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark0')),
                            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                        },
                        children: intl.formatMessage(column.title)
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c11p5 _umai1ylp"
                        ]),
                        children: column.items.map((link)=>{
                            return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_bpsp1nn1 _19tboxwj _43dssjoz _qfs11r31 _s41oglyw _1k6pnqa1 _1caysjoz _1e0c1txw _4cvrh9n0"
                                ]),
                                style: {
                                    "--_8vca0i": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark0'))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                    type: "anchor",
                                    href: link.href,
                                    text: intl.formatMessage(link.text),
                                    ariaLabel: intl.formatMessage(link.text),
                                    dataEventProps: {
                                        'data-event': 'clicked',
                                        'data-event-component': 'linkButton',
                                        'data-event-container': 'globalNavSubnav',
                                        'data-product-key': productKey
                                    }
                                })
                            }, link.id);
                        })
                    })
                ]
            }, column.id);
        })
    });
};

});

parcelRegister("2Kjb7", function(module, exports) {
$parcel$export(module.exports, "LoomSolutionsDropdown", function () { return $a78c336f6b748173$export$cc917f6d3393bbe0; });
/* loom-solutions-dropdown.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $jsxHL = parcelRequire("jsxHL");

var $8nFt2 = parcelRequire("8nFt2");

var $dzoWS = parcelRequire("dzoWS");

var $jgdMW = parcelRequire("jgdMW");

var $9KOR3 = parcelRequire("9KOR3");
function $a78c336f6b748173$var$useLoomSolutionsLinks() {
    return {
        features: {
            id: 'teams',
            title: (0, $fnHPc.defineMessage)({
                id: 'loom-product-nav.solutions.links.solution',
                defaultMessage: 'Teams'
            }),
            items: [
                {
                    id: 'sales',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.solutions.links.sales',
                        defaultMessage: 'Sales'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/use-case/sales')
                },
                {
                    id: 'marketing',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.solutions.links.marketing',
                        defaultMessage: 'Marketing'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/use-case/marketing')
                },
                {
                    id: 'design',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.solutions.links.design',
                        defaultMessage: 'Design'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/use-case/design')
                },
                {
                    id: 'support',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.solutions.links.support',
                        defaultMessage: 'Support'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/use-case/support')
                },
                {
                    id: 'productmanagement',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.solutions.links.product-management',
                        defaultMessage: 'Product Management'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/use-case/product-management')
                },
                {
                    id: 'engineering',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.solutions.links.engineering',
                        defaultMessage: 'Engineering'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/use-case/engineering')
                }
            ]
        },
        usecases: {
            id: 'usecases',
            title: (0, $fnHPc.defineMessage)({
                id: 'loom-product-nav.solutions.links.use-cases',
                defaultMessage: 'Use cases'
            }),
            items: [
                {
                    id: 'loom-jira',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.solutions.links.loom-jira',
                        defaultMessage: 'Loom + Jira'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/loom-jira')
                },
                {
                    id: 'loom-confluence',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.solutions.links.loom-confluence',
                        defaultMessage: 'Loom + Confluence'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/loom-confluence')
                }
            ]
        },
        companysize: {
            id: 'companysize',
            title: (0, $fnHPc.defineMessage)({
                id: 'loom-product-nav.solutions.links.company-size',
                defaultMessage: 'Company Size'
            }),
            items: [
                {
                    id: 'enterprise',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.solutions.links.enterprise',
                        defaultMessage: 'Enterprise'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/enterprise')
                }
            ]
        }
    };
}
const $a78c336f6b748173$export$cc917f6d3393bbe0 = ({ productKey: productKey = 'loom' })=>{
    const intl = (0, $8e22h.default)();
    const loomSolutionLinks = $a78c336f6b748173$var$useLoomSolutionsLinks();
    const linkColumns = Object.values(loomSolutionLinks);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.DivOnHoverExit), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8nFt2.MotionContainer), {
                direction: "up",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_bfhk1afi _fn1q1txw _12nx1bp4 _196i1ylp"
                    ]),
                    style: {
                        "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgdMW.RowGrid), {
                        numCols: 3,
                        columnGap: "var(--ds-space-500, 40px)",
                        children: linkColumns.map((column)=>{
                            return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $dzoWS.GlobalNavDropdownLinkColumn), {
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_1p1dangw _syaz1pfd _1wyboqnp _ect4z4z1 _k48p1fw0 _vwz41j6v"
                                        ]),
                                        style: {
                                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                                        },
                                        children: intl.formatMessage(column.title)
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c11p5 _umai1ylp"
                                        ]),
                                        children: column.items.map((link)=>{
                                            return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_bpsp1nn1 _19tboxwj _43ds1pfd _qfs11r31 _s41oglyw _1k6pnqa1 _1cay1pfd _oavvftjs _oxk4ftjs _1e0c1txw _4cvrh9n0"
                                                ]),
                                                style: {
                                                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                                    "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800'))
                                                },
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                                    type: "anchor",
                                                    href: link.href,
                                                    text: intl.formatMessage(link.text),
                                                    ariaLabel: intl.formatMessage(link.text),
                                                    dataEventProps: {
                                                        'data-event': 'clicked',
                                                        'data-event-component': 'linkButton',
                                                        'data-event-container': 'globalNavSubnav',
                                                        'data-product-key': productKey
                                                    }
                                                })
                                            }, link.id);
                                        })
                                    })
                                ]
                            }, column.id);
                        })
                    })
                })
            })
        })
    });
};

});


parcelRegister("4ui88", function(module, exports) {
$parcel$export(module.exports, "LoomAiSection", function () { return $71efe2429e06e754$export$7b95013d8cafda1; });
/* loom-ai-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $20Gca = parcelRequire("20Gca");

var $hnmMQ = parcelRequire("hnmMQ");

var $dl2JF = parcelRequire("dl2JF");

var $lqyi6 = parcelRequire("lqyi6");

var $1rGpC = parcelRequire("1rGpC");

var $jsxHL = parcelRequire("jsxHL");

var $dQswK = parcelRequire("dQswK");
const $71efe2429e06e754$export$7b95013d8cafda1 = ()=>{
    const context = (0, $dl2JF.usePricingContentContext)();
    const loomAiContent = context?.datacenterPlans?.[0];
    const ctaContent = loomAiContent?.microCta?.[0]?.__typename === 'ContentPlatformCallToActionMicrocopy' ? loomAiContent.microCta[0] : undefined;
    const textParagraph = loomAiContent?.planOneLiner ?? '';
    const textBullets = loomAiContent?.highlightedFeaturesContainer?.map((highlightedFeature)=>{
        return {
            text: highlightedFeature?.highlightedFeatureTitleExternal,
            callOut: highlightedFeature?.callOut
        };
    });
    const zeroMarginCss = null;
    const defaultPremiumSignupUrl = (0, $dQswK.usePremiumSignupUrl)();
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1rGpC.Row), {
            layout: "6-6",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                    image: {
                        src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/07v5f6mik43gk4jga0367a2x5qn64vbp.webp',
                        alt: intl.formatMessage({
                            id: 'LoomPricingPage.LoomAiSection.meetingGraphicAltText',
                            defaultMessage: 'Example graphic of using Loom AI for meetings'
                        })
                    },
                    style: {
                        width: '100%',
                        height: 'auto'
                    }
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _2lx2vrvc _4cvr1y6m _zulp1b66"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                    className: (0, $2jatx.default)([
                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                    ]),
                                    children: loomAiContent?.planTitleExternal
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                    image: {
                                        src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/y42547423ap63hd11cr1832n3n455pt5.webp',
                                        alt: ''
                                    },
                                    style: {
                                        width: '100%',
                                        height: '27px',
                                        position: 'relative',
                                        insetBlockStart: "var(--ds-space-050, 4px)"
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            className: (0, $2jatx.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                            ]),
                            children: textParagraph
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                            className: (0, $2jatx.default)([
                                "_6rthpxbi"
                            ]),
                            children: textBullets?.map((bullet)=>{
                                return /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    className: (0, $2jatx.default)([
                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                                        children: [
                                            bullet.text,
                                            bullet.callOut && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                className: (0, $2jatx.default)([
                                                    "_ahbq1b66"
                                                ]),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $20Gca.default), {
                                                    children: bullet.callOut
                                                })
                                            })
                                        ]
                                    })
                                }, bullet.text);
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                            href: ctaContent?.ctaUrl || defaultPremiumSignupUrl,
                            size: 'small',
                            children: ctaContent?.ctaButtonText || intl.formatMessage({
                                id: 'LoomAiSection.ctaButtonText',
                                defaultMessage: 'Try for free'
                            })
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("dQswK", function(module, exports) {
$parcel$export(module.exports, "SIGNUP_URL_QUERY_PREMIUM", function () { return $8f236d094af265c8$export$ff7054db20c33aeb; });
$parcel$export(module.exports, "usePremiumSignupUrl", function () { return $8f236d094af265c8$export$aa185ad968f4b15f; });

var $jQ0cd = parcelRequire("jQ0cd");
const $8f236d094af265c8$export$ff7054db20c33aeb = '?bundle=loom&edition=premium';
const $8f236d094af265c8$export$aa185ad968f4b15f = ()=>(0, $jQ0cd.useLocalizedHref)(`/try/cloud/signup${$8f236d094af265c8$export$ff7054db20c33aeb}`);

});


parcelRegister("9Url8", function(module, exports) {
$parcel$export(module.exports, "LoomPriceFinder", function () { return $44da10c9bd623a4e$export$4377a557bebc94dd; });
// @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $fnHPc = parcelRequire("fnHPc");
var $iVyKn = parcelRequire("iVyKn");

var $hCc2m = parcelRequire("hCc2m");

var $k6638 = parcelRequire("k6638");

var $g9ZvA = parcelRequire("g9ZvA");

var $gIRO7 = parcelRequire("gIRO7");

var $eYlij = parcelRequire("eYlij");

var $1qGP5 = parcelRequire("1qGP5");

var $dl2JF = parcelRequire("dl2JF");

var $17RBn = parcelRequire("17RBn");

var $crD7r = parcelRequire("crD7r");

var $dQswK = parcelRequire("dQswK");
const $44da10c9bd623a4e$export$4377a557bebc94dd = (props)=>{
    const content = {
        free: (0, $dl2JF.usePricingPlanComparison)('Starter'),
        standard: (0, $dl2JF.usePricingPlanComparison)('Business'),
        premium: (0, $dl2JF.usePricingPlanComparison)('Business + AI'),
        enterprise: (0, $dl2JF.usePricingPlanComparison)('Enterprise')
    };
    const freePlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, 'free');
    const standardPlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, 'standard');
    const premiumPlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, 'premium');
    const enterprisePlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, 'enterprise');
    const loomProductPlans = [
        {
            planName: 'Starter',
            offeringSku: 'loom-free-sku',
            recommendationLimit: Infinity,
            signupLimit: 50000,
            planFeatureMessages: freePlanFeatureMessages,
            description: content.free?.planOneLiner ?? '',
            signupURLSuffix: (0, $dQswK.SIGNUP_URL_QUERY_PREMIUM)
        },
        {
            planName: 'Business',
            offeringSku: 'loom-business-sku',
            recommendationLimit: Infinity,
            signupLimit: 50000,
            planFeatureMessages: standardPlanFeatureMessages,
            description: content.standard?.planOneLiner ?? '',
            signupURLSuffix: (0, $dQswK.SIGNUP_URL_QUERY_PREMIUM)
        },
        {
            planName: 'Business + AI',
            planTitleComponent: (0, $crD7r.LoomAiTitle),
            offeringSku: 'loom-business-ai-sku',
            recommendationLimit: 0,
            signupLimit: 50000,
            planFeatureMessages: premiumPlanFeatureMessages,
            description: content.premium?.planOneLiner ?? '',
            signupURLSuffix: (0, $dQswK.SIGNUP_URL_QUERY_PREMIUM)
        },
        {
            planName: 'Enterprise',
            offeringSku: 'loom-enterprise-sku',
            recommendationLimit: Infinity,
            signupLimit: 50000,
            planFeatureMessages: enterprisePlanFeatureMessages,
            description: content.enterprise?.planOneLiner ?? ''
        }
    ];
    let cardEnterpriseBodyOverride = /*#__PURE__*/ (0, $7VQPk.jsx)("div", {});
    const locale = (0, $17RBn.useLocale)();
    if (locale === 'en') cardEnterpriseBodyOverride = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k6638.ContentText), {
        variant: "xl",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "LoomPriceFinderTeam25.cardEnterpriseBodyOverride",
            defaultMessage: "Let's talk"
        })
    });
    const messages = (0, $fnHPc.defineMessages)({
        unitCountInputTextRedesign: {
            id: 'LoomPriceFinderTeam25.unitCountInputTextRedesign',
            defaultMessage: 'Team size:'
        },
        unitCountInputTerm: {
            id: 'LoomPriceFinderTeam25.unitCountInputTerm',
            defaultMessage: 'users'
        },
        billingCycleText: {
            id: 'LoomPriceFinderTeam25.billingCycleText',
            defaultMessage: 'Billing cycle:'
        },
        cardOverSignupLimit: {
            id: 'LoomPriceFinderTeam25.cardOverSignupLimit',
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: 'LoomPriceFinderTeam25.cardEnterpriseMinimumCount',
            defaultMessage: 'Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above',
            description: 'Enterprise is a plan name and should not be translated'
        },
        cardUnitCountTierRange: {
            id: 'LoomPriceFinderTeam25.cardUnitCountTierRange',
            defaultMessage: 'User tier: {lowerLimit} - {upperLimit}'
        },
        cardMonthlyPerUnitCount: {
            id: 'LoomPricingPage.priceFinder.cardMonthlyPerUnitCount',
            defaultMessage: 'per user / month'
        },
        cardEnterpriseBodyOverride: // @ts-ignore
        cardEnterpriseBodyOverride
    });
    const recommendationElement = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "LoomPriceFinderTeam25.recommendationElement",
        defaultMessage: "Most popular"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hCc2m.default), {
        interactionName: 'loom-price-finder',
        fallback: (0, $g9ZvA.LoadingSpinner),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eYlij.PriceFinderContextProvider), {
            dataProductKey: "loom",
            productPlans: loomProductPlans,
            defaultUnitCount: 100,
            shouldAddDiscount: props.shouldAddDiscount,
            annualUserTierDisplayThreshold: 26,
            recommendationElement: recommendationElement,
            ctaUrlSource: props.ctaUrlSource,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gIRO7.default), {
                messages: messages,
                serverSideCCPPricing: props.pricing?.ccpPricingData?.loom,
                countryCode: props.countryCode
            })
        })
    });
};
$44da10c9bd623a4e$export$4377a557bebc94dd.displayName = 'LoomPriceFinder';

});
parcelRegister("crD7r", function(module, exports) {
$parcel$export(module.exports, "LoomAiTitle", function () { return $981d3821a6ea456e$export$930d845fa234c9bc; });

var $7VQPk = parcelRequire("7VQPk");

var $lP7A9 = parcelRequire("lP7A9");

var $hnmMQ = parcelRequire("hnmMQ");
const $981d3821a6ea456e$export$930d845fa234c9bc = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
        id: `pricing-plan-title-${props.planName}`,
        children: [
            props.planName,
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                image: {
                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/y42547423ap63hd11cr1832n3n455pt5.webp',
                    alt: ''
                },
                style: {
                    height: '17px',
                    width: '17px',
                    position: 'relative',
                    insetInlineStart: (0, $lP7A9.default)('space.025'),
                    insetBlockEnd: (0, $lP7A9.default)('space.050')
                }
            })
        ]
    });
};

});




parcelRegister("ioPgw", function(module, exports) {
$parcel$export(module.exports, "SoftwareRovoPricingPage", function () { return $e13c4f74aaa45a69$export$28b640e1f1ca7dbf; });

var $7VQPk = parcelRequire("7VQPk");

var $dl2JF = parcelRequire("dl2JF");

var $hN6aG = parcelRequire("hN6aG");
const $e13c4f74aaa45a69$export$28b640e1f1ca7dbf = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "data-testid": "rovo-pricing-page",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dl2JF.PricingContentContextProviderRelay), {
            productId: "rovo",
            pricingContent: props.pricingContent,
            queryRef: props.queryRef,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hN6aG.SoftwareRovoPricingPageTemplate), {
                ...props
            })
        })
    });
};

});
parcelRegister("hN6aG", function(module, exports) {
$parcel$export(module.exports, "SoftwareRovoPricingPageTemplate", function () { return $5fb67fb458372cd2$export$b59f422a2cd6b675; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $7aKDf = parcelRequire("7aKDf");

var $dl2JF = parcelRequire("dl2JF");

var $bE8d4 = parcelRequire("bE8d4");

var $2zOxm = parcelRequire("2zOxm");

var $6Px6U = parcelRequire("6Px6U");

var $grcEk = parcelRequire("grcEk");

var $3wzIU = parcelRequire("3wzIU");

var $5S2vX = parcelRequire("5S2vX");

var $gTzEq = parcelRequire("gTzEq");

var $9uWXx = parcelRequire("9uWXx");
const $5fb67fb458372cd2$export$b59f422a2cd6b675 = (props)=>{
    const content = (0, $dl2JF.usePricingContentContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
        nav: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3wzIU.RovoNav), {}),
        showFallback: content?.hasError,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
            pageId: "rovo-pricing-page",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6Px6U.PageHeading), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        id: "rovo",
                        children: content?.headline
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gTzEq.RovoPriceFinder), {
                    ...props
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aKDf.PricingFeatureTable), {
                    title: content?.compareFeaturesTitle ?? undefined,
                    comparePlans: content?.comparePlans ?? undefined,
                    compareFeatures: content?.compareFeatures ?? undefined
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2zOxm.QuotationsAdornment), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bE8d4.PricingFaq), {
                            header: content?.getMoreDetailsTitle ?? undefined,
                            planDetails: content?.additionalDetails ?? undefined
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9uWXx.RovoQuestionsCta), {})
            ]
        })
    });
};

});
parcelRegister("3wzIU", function(module, exports) {
$parcel$export(module.exports, "RovoNav", function () { return $d94e8e579fb0c00d$export$f7b51e35c95f667c; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $3o1l4 = parcelRequire("3o1l4");

var $bQjAr = parcelRequire("bQjAr");

var $2WL8B = parcelRequire("2WL8B");

var $eOIix = parcelRequire("eOIix");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $gn6Qa = parcelRequire("gn6Qa");

var $3riD8 = parcelRequire("3riD8");
const $d94e8e579fb0c00d$export$f7b51e35c95f667c = ()=>{
    const intl = (0, $8e22h.default)();
    const navLinks = [
        {
            globalLinksKey: 'features',
            linkText: intl.formatMessage({
                id: 'RovoPageTemplate.navbar.features',
                defaultMessage: 'Features'
            }),
            hasDropdown: false,
            productKey: 'rovo',
            href: (0, $jQ0cd.useLocalizedHref)('/software/rovo/features')
        },
        {
            globalLinksKey: 'connectors',
            linkText: intl.formatMessage({
                id: 'RovoPageTemplate.navbar.connectors',
                defaultMessage: 'Connectors'
            }),
            hasDropdown: false,
            productKey: 'rovo',
            href: (0, $jQ0cd.useLocalizedHref)('/software/rovo/connectors')
        },
        {
            globalLinksKey: 'use-cases',
            linkText: intl.formatMessage({
                id: 'RovoPageTemplate.navbar.use-cases',
                defaultMessage: 'Use cases'
            }),
            hasDropdown: false,
            productKey: 'rovo',
            href: (0, $jQ0cd.useLocalizedHref)('/software/rovo/use-cases')
        },
        {
            globalLinksKey: 'guides',
            linkText: intl.formatMessage({
                id: 'RovoPageTemplate.navbar.guides',
                defaultMessage: 'Guides'
            }),
            hasDropdown: false,
            productKey: 'rovo',
            href: (0, $jQ0cd.useLocalizedHref)('/software/rovo/guides/end-user-guide/introduction')
        },
        {
            globalLinksKey: 'licensing',
            linkText: intl.formatMessage({
                id: 'RovoPageTemplate.navbar.licensing',
                defaultMessage: 'Licensing'
            }),
            hasDropdown: false,
            productKey: 'rovo',
            href: (0, $jQ0cd.useLocalizedHref)('/licensing/rovo')
        }
    ];
    const { requestInProgress: requestInProgress } = (0, $3riD8.useLoggedInUser)();
    const { data: userSegments } = (0, $3o1l4.useUserSegments)();
    const isRovoEnabledCohort = (0, $2WL8B.useRovoEnabledCohort)();
    const isRovoInPlanList = userSegments?.[(0, $3o1l4.UserSegmentTypes).OWNED_PRODUCTS]?.includes('rovo.ondemand');
    const defaultCTAUrl = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=teamwork-collection&primaryCollectionProduct=rovo.ondemand&edition=premium');
    const isUserLoggedInAndCtasEnabledAndInPlan = isRovoInPlanList;
    const ctaText = intl.formatMessage({
        id: 'RovoPageTemplate.navbar.cta.try-rovo',
        defaultMessage: 'Try Rovo'
    });
    const tryNowCTAUrl = isUserLoggedInAndCtasEnabledAndInPlan ? 'https://home.atlassian.com/chat' : defaultCTAUrl;
    const isShowTryNowLink = !requestInProgress && tryNowCTAUrl && ctaText ? true : false;
    const buttonVariant = isRovoEnabledCohort ? 'secondary' : 'primary';
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    const rovoLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "rovo",
        type: "logo",
        appearance: "brand",
        darkTheme: isDarkTheme
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "RovoNav",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gn6Qa.ProductPageNav), {
            productLogoHeight: 26,
            productLogoUrl: "/software/rovo",
            productLogo: rovoLogo,
            productLogoAriaLabel: intl.formatMessage({
                id: 'RovoPageTemplate.navbar.rovo-logo',
                defaultMessage: 'Rovo logo'
            }),
            mobileLogo: rovoLogo,
            isShowTryNowLink: isShowTryNowLink,
            isIncludeMobileCTA: isShowTryNowLink,
            navigationTrynowCtaText: isShowTryNowLink ? ctaText : undefined,
            navigationTrynowCtaUrl: isShowTryNowLink ? tryNowCTAUrl : undefined,
            navigationTrynowCtaButtonVariant: buttonVariant,
            mobileCtaText: isShowTryNowLink ? ctaText : undefined,
            mobileCtaUrl: isShowTryNowLink ? tryNowCTAUrl : undefined,
            mobileCtaButtonVariant: buttonVariant,
            productPageNavLinks: navLinks,
            mobileLinksSections: [
                {
                    mobileLinkKey: 'mobile-rovo',
                    mobileLinksProps: navLinks
                }
            ]
        })
    });
};

});

parcelRegister("gTzEq", function(module, exports) {
$parcel$export(module.exports, "RovoPriceFinder", function () { return $c856a897304fd7ef$export$dc441f522034d071; });

var $7VQPk = parcelRequire("7VQPk");

var $fnHPc = parcelRequire("fnHPc");

var $hCc2m = parcelRequire("hCc2m");

var $g9ZvA = parcelRequire("g9ZvA");

var $gIRO7 = parcelRequire("gIRO7");

var $eYlij = parcelRequire("eYlij");

var $1qGP5 = parcelRequire("1qGP5");

var $dl2JF = parcelRequire("dl2JF");
const $c856a897304fd7ef$export$dc441f522034d071 = (props)=>{
    const content = {
        standard: (0, $dl2JF.usePricingPlanComparison)('Rovo')
    };
    const planFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, 'standard');
    const rovoProductPlans = [
        {
            planName: 'Standard',
            offeringSku: 'rovo-org-purchase-sku',
            recommendationLimit: 100000,
            signupLimit: 35000,
            signupURLInfo: {
                urlDomain: window.location.origin,
                urlPath: '/software/rovo/start',
                shouldLocalize: true
            },
            planFeatureMessages: planFeatureMessages
        }
    ];
    const messages = (0, $fnHPc.defineMessages)({
        unitCountInputTextRedesign: {
            id: 'RovoSoftwarePricingPage.priceFinder.unitCountInputTextRedesign',
            defaultMessage: 'Team size:'
        },
        unitCountInputTerm: {
            id: 'RovoSoftwarePricingPage.priceFinder.unitCountInputTerm',
            defaultMessage: 'users'
        },
        cardOverSignupLimit: {
            id: 'RovoSoftwarePricingPage.priceFinder.cardOverSignupLimit',
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: 'RovoSoftwarePricingPage.priceFinder.cardEnterpriseMinimumCount',
            defaultMessage: 'Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above',
            description: 'Enterprise is a plan name and should not be translated'
        },
        cardUnitCountTierRange: {
            id: 'RovoSoftwarePricingPage.priceFinder.cardUnitCountTierRange',
            defaultMessage: 'User tier: {lowerLimit} - {upperLimit}'
        },
        cardMonthlyPerUnitCount: {
            id: 'RovoSoftwarePricingPageTeam24.priceFinder.cardMonthlyPerUnitCount',
            defaultMessage: 'per user / month'
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hCc2m.default), {
        interactionName: 'rovo-price-finder',
        fallback: (0, $g9ZvA.LoadingSpinner),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eYlij.PriceFinderContextProvider), {
            dataProductKey: "rovo",
            productPlans: rovoProductPlans,
            defaultUnitCount: 375,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gIRO7.default), {
                messages: messages,
                serverSideCCPPricing: props.pricing?.ccpPricingData?.rovo,
                countryCode: props.countryCode,
                ...props
            })
        })
    });
};
$c856a897304fd7ef$export$dc441f522034d071.displayName = 'RovoPriceFinderSection';

});

parcelRegister("9uWXx", function(module, exports) {
$parcel$export(module.exports, "RovoQuestionsCta", function () { return $d2a25cde4c4631f2$export$c1392586038e7a93; });

var $7VQPk = parcelRequire("7VQPk");

var $dl2JF = parcelRequire("dl2JF");

var $frz5c = parcelRequire("frz5c");

var $3fFrT = parcelRequire("3fFrT");

var $17RBn = parcelRequire("17RBn");

var $jQ0cd = parcelRequire("jQ0cd");
const $d2a25cde4c4631f2$export$c1392586038e7a93 = ()=>{
    const content = (0, $dl2JF.usePricingContentContext)();
    const questionsCtaContent = content?.callToActionContainer?.[0];
    const locale = (0, $17RBn.useLocale)();
    const questionsCtaHref = `https://support.atlassian.com${(0, $jQ0cd.getLocalizedHref)({
        locale: locale,
        href: '/subscriptions-and-billing/docs/managing-your-bill-for-rovo/',
        supportedLocales: (0, $3fFrT.ATLASSIAN_SUPPORT_CENTER_SUPPORTED_LOCALES)
    })}`;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $frz5c.QuestionsCta), {
        product: 'Rovo',
        ctaHref: questionsCtaContent?.url ?? questionsCtaHref,
        questionsHeader: questionsCtaContent?.title ?? undefined,
        priceAndLicensingLinkText: questionsCtaContent?.text ?? undefined,
        questionsBody: questionsCtaContent?.valueProposition ?? undefined,
        imageHref: questionsCtaContent?.asset?.url
    });
};
$d2a25cde4c4631f2$export$c1392586038e7a93.displayName = 'RovoQuestionsCtaSection';

});



parcelRegister("hI6CC", function(module, exports) {
$parcel$export(module.exports, "SoftwareRovoStartPage", function () { return $af65b479e9aa4397$export$7b3d03c2fa269586; });

var $7VQPk = parcelRequire("7VQPk");

var $72aQB = parcelRequire("72aQB");

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");

var $6iKF0 = parcelRequire("6iKF0");

var $gsqLc = parcelRequire("gsqLc");
const $af65b479e9aa4397$export$7b3d03c2fa269586 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleOnError = (0, $1oC0p.useCallback)((error)=>{
        createAnalyticsEvent({
            action: 'failed',
            eventType: 'track',
            actionSubject: 'SoftwareRovoStartPage',
            source: 'SoftwareRovoStartPage',
            attributes: {
                error: error.message
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6iKF0.default), {
        fallback: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gsqLc.ErrorScreen), {}),
        onError: handleOnError,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $72aQB.SoftwareRovoStartPageTemplate), {})
    });
};

});
parcelRegister("72aQB", function(module, exports) {
$parcel$export(module.exports, "SoftwareRovoStartPageTemplate", function () { return $154413073beb82d2$export$89c9d15d38180eeb; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");

var $5Ntyw = parcelRequire("5Ntyw");

var $lact3 = parcelRequire("lact3");

var $3riD8 = parcelRequire("3riD8");

var $iSeHD = parcelRequire("iSeHD");

var $jQ0cd = parcelRequire("jQ0cd");

var $4weTV = parcelRequire("4weTV");

var $6VYIX = parcelRequire("6VYIX");
const $154413073beb82d2$export$89c9d15d38180eeb = ()=>{
    const stargateClient = (0, $5Ntyw.useBxpWebStargateClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const { isUserLoggedIn: isUserLoggedIn, requestInProgress: requestInProgress } = (0, $3riD8.useLoggedInUser)();
    const [redirectUrl, setRedirectUrl] = (0, $1oC0p.useState)();
    const localizedContactHref = (0, $jQ0cd.useLocalizedHref)('/enterprise/contact');
    const adminBaseUrl = (0, $1oC0p.useMemo)(()=>{
        if (typeof window === 'undefined') return 'https://admin.atlassian.com';
        return (0, $lact3.isProduction)() ? 'https://admin.atlassian.com' : 'https://admin.stg.atlassian.com';
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        redirectUrl && setTimeout(()=>window.location.href = redirectUrl, 300);
    }, [
        redirectUrl
    ]);
    const fireViewAnalytics = (0, $1oC0p.useCallback)((attributes = {})=>{
        analyticsClient && createAnalyticsEvent({
            action: 'viewed',
            eventType: 'screen',
            name: 'softwareRovoStartPage',
            source: 'softwareRovoStartPage',
            attributes: attributes
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const getIsOrgAdmin = (0, $1oC0p.useCallback)(async ()=>{
        const { success: success, accountOrgs: accountOrgs } = await stargateClient.getAccountOrgs({});
        if (!success) throw new Error('Get account/orgs call failed');
        const isOrgAdmin = !!(accountOrgs && accountOrgs.length > 0);
        fireViewAnalytics({
            isOrgAdmin: isOrgAdmin
        });
        isOrgAdmin ? setRedirectUrl(`${adminBaseUrl}/rovo`) : setRedirectUrl(localizedContactHref);
    }, [
        fireViewAnalytics,
        stargateClient,
        setRedirectUrl,
        localizedContactHref,
        adminBaseUrl
    ]);
    const checkIfRovoProductExists = (0, $1oC0p.useCallback)(async ()=>{
        const productsUrl = (0, $lact3.isProduction)() ? 'https://rovo.atlassian.com' : 'https://home.stg.atlassian.com/rovo';
        const { accountProducts: accountProducts, success: success } = await stargateClient.getAccountProducts({});
        if (!success) throw new Error('Get account/products call failed');
        if (accountProducts && accountProducts.length > 0) {
            const siteWithRovo = accountProducts.find((site)=>site.products.includes('rovo.ondemand'));
            if (siteWithRovo) {
                fireViewAnalytics({
                    hasRovo: true
                });
                const cloudId = siteWithRovo.cloudId;
                setRedirectUrl(`${productsUrl}?cloudId=${cloudId}`);
                return;
            }
        }
        getIsOrgAdmin();
    }, [
        stargateClient,
        fireViewAnalytics,
        getIsOrgAdmin,
        setRedirectUrl
    ]);
    (0, $1oC0p.useEffect)(()=>{
        switch(requestInProgress){
            case false:
                switch(isUserLoggedIn){
                    case true:
                        checkIfRovoProductExists();
                        break;
                    case false:
                        fireViewAnalytics();
                        break;
                    default:
                        break;
                }
                break;
            default:
                break;
        }
    }, [
        fireViewAnalytics,
        checkIfRovoProductExists,
        isUserLoggedIn,
        requestInProgress
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: !requestInProgress && !isUserLoggedIn ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4weTV.LoginContactSales), {}) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6VYIX.LoadingSpinner), {})
    });
};

});
parcelRegister("4weTV", function(module, exports) {
$parcel$export(module.exports, "LoginContactSales", function () { return $00bb124a426bfcbf$export$6a33a815ad7360e9; });
/* login-contact-sales.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $dTJrO = parcelRequire("dTJrO");

var $6A2DX = parcelRequire("6A2DX");

var $bMxrA = parcelRequire("bMxrA");
var $9jghN = parcelRequire("9jghN");
var $7SWbn = parcelRequire("7SWbn");
var $6L4Qq = parcelRequire("6L4Qq");
var $1xo8q = parcelRequire("1xo8q");

var $lmQGF = parcelRequire("lmQGF");

var $8IYGL = parcelRequire("8IYGL");

var $8AXar = parcelRequire("8AXar");

var $iPPTB = parcelRequire("iPPTB");

var $lact3 = parcelRequire("lact3");

var $iSeHD = parcelRequire("iSeHD");

var $jQ0cd = parcelRequire("jQ0cd");

var $8AQXb = parcelRequire("8AQXb");

var $cxI2Y = parcelRequire("cxI2Y");
const $00bb124a426bfcbf$var$elevatedContainerInnerStyles = (0, $1xo8q.xcss)({
    textAlign: 'center',
    paddingBlockStart: 'space.500'
});
const $00bb124a426bfcbf$var$bodyTextStyles = (0, $1xo8q.xcss)({
    paddingBlockStart: 'space.100'
});
const $00bb124a426bfcbf$var$loginButtonStyles = (0, $1xo8q.xcss)({
    paddingBlockStart: 'space.400',
    paddingBlockEnd: 'space.400',
    paddingInlineStart: 'space.800',
    paddingInlineEnd: 'space.800'
});
const $00bb124a426bfcbf$var$contactAtlassianStyles = (0, $1xo8q.xcss)({
    justifyContent: 'center'
});
const $00bb124a426bfcbf$var$relative = null;
const $00bb124a426bfcbf$var$whiteBackground = null;
const $00bb124a426bfcbf$export$6a33a815ad7360e9 = ()=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const localizedContactHref = (0, $jQ0cd.useLocalizedHref)('/enterprise/contact');
    const fireButtonAnalytics = (0, $1oC0p.useCallback)((buttonName)=>{
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        analyticsClient && createAnalyticsEvent({
            action: 'clicked',
            actionSubject: buttonName,
            actionSubjectId: 'softwareRovoStartPageTemplate',
            attributes: {
                source: 'loginContactSalesScreen'
            }
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const loginButtonHandler = (0, $1oC0p.useCallback)(()=>fireButtonAnalytics('loginButton'), [
        fireButtonAnalytics
    ]);
    const contactSalesLinkHandler = (0, $1oC0p.useCallback)(()=>fireButtonAnalytics('contactSalesLink'), [
        fireButtonAnalytics
    ]);
    const loginUrl = (0, $1oC0p.useMemo)(()=>{
        if (typeof window === 'undefined') return 'id.atlassian.com/';
        return (0, $lact3.isProduction)() ? 'https://id.atlassian.com/' : 'https://id.stg.internal.atlassian.com/';
    }, []);
    const LinktoContactAtlassian = (props)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
            href: localizedContactHref,
            type: "primary",
            ariaLabel: "Contact Atlassian Page",
            "aria-label": 'Contact Atlassian Page',
            text: props.children,
            onClick: contactSalesLinkHandler
        });
    const allItemsContactAtlassian = intl.formatMessage((0, $8AQXb.messages).contactAtlassianText, {
        a: (contactAtlassian)=>/*#__PURE__*/ (0, $7VQPk.jsx)(LinktoContactAtlassian, {
                children: contactAtlassian
            })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8AXar.SignupBackgroundLayout), {
        ProductLogo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.RovoLogo), {
            size: "xlarge",
            appearance: "brand"
        }),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7SWbn.default), {
            xcss: $00bb124a426bfcbf$var$elevatedContainerInnerStyles,
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _1pbyidpf"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_kqswstnw _152tidpf _u7coidpf _1e02idpf _rjxpidpf _1bsb1osq _4t3i1osq _bfhku67f _1pby1mrw"
                            ])
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                            as: "h1",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                ...(0, $8AQXb.messages).rovoGetStarted,
                                values: {
                                    started: (str)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $8IYGL.Adg4TextUnderline), {
                                            underline: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cxI2Y.ScribbleImage), {}),
                                            fontWeight: {
                                                from: 600,
                                                to: 600
                                            },
                                            children: str
                                        })
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bMxrA.default), {
                    xcss: $00bb124a426bfcbf$var$bodyTextStyles,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6L4Qq.default), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            ...(0, $8AQXb.messages).rovoBodyText
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bMxrA.default), {
                    xcss: $00bb124a426bfcbf$var$loginButtonStyles,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                        size: "small",
                        isFullWidth: true,
                        "aria-label": "Login Button",
                        href: `${loginUrl}login?continue=${encodeURIComponent(window.location.href)}`,
                        onClick: loginButtonHandler,
                        target: "",
                        children: intl.formatMessage((0, $8AQXb.messages).loginButtonRovo)
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $9jghN.default), {
                    space: "space.100",
                    xcss: $00bb124a426bfcbf$var$contactAtlassianStyles,
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            ...(0, $8AQXb.messages).dontHaveAccountText
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bMxrA.default), {
                            children: allItemsContactAtlassian
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("9jghN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6c72857c82292085$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $1xo8q = parcelRequire("1xo8q");

var $1zgVm = parcelRequire("1zgVm");
var $6c72857c82292085$var$flexGrowMap = {
    hug: (0, $1xo8q.xcss)({
        flexGrow: 0
    }),
    fill: (0, $1xo8q.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
var $6c72857c82292085$var$separatorStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none',
    userSelect: 'none'
});
var $6c72857c82292085$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $3dJ4i.jsx)("span", {
        css: $6c72857c82292085$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $6c72857c82292085$var$Inline = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === 'string' ? (0, $3dJ4i.jsx)($6c72857c82292085$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $1oC0p.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $3dJ4i.jsx)((0, $1oC0p.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    return (0, $3dJ4i.jsx)((0, $1zgVm.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: grow ? [
            $6c72857c82292085$var$flexGrowMap[grow]
        ].concat((0, $lFOXD.default)(Array.isArray(xcss) ? xcss : [
            xcss
        ])) : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss,
        testId: testId,
        ref: ref
    }, children);
}));
$6c72857c82292085$var$Inline.displayName = 'Inline';
var $6c72857c82292085$export$2e2bcd8739ae039 = $6c72857c82292085$var$Inline;

});

parcelRegister("6L4Qq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4ebae3e62029ece2$export$2e2bcd8739ae039; });

var $gnQ3X = parcelRequire("gnQ3X");

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $lmxXn = parcelRequire("lmxXn");

var $jN4m6 = parcelRequire("jN4m6");

var $d3wYX = parcelRequire("d3wYX");
var $4ebae3e62029ece2$var$_excluded = [
    "children"
];
function $4ebae3e62029ece2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4ebae3e62029ece2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4ebae3e62029ece2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4ebae3e62029ece2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4ebae3e62029ece2$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $4ebae3e62029ece2$var$resetStyles = (0, $3dJ4i.css)({
    margin: 0
});
var $4ebae3e62029ece2$var$variantStyles = $4ebae3e62029ece2$var$_objectSpread($4ebae3e62029ece2$var$_objectSpread({}, (0, $jN4m6.bodyTextStylesMap)), (0, $jN4m6.uiTextStylesMap));
var $4ebae3e62029ece2$var$strongStyles = (0, $3dJ4i.css)({
    fontWeight: 'bold'
});
var $4ebae3e62029ece2$var$emStyles = (0, $3dJ4i.css)({
    fontStyle: 'italic'
});
var $4ebae3e62029ece2$var$textAlignMap = {
    center: (0, $3dJ4i.css)({
        textAlign: 'center'
    }),
    end: (0, $3dJ4i.css)({
        textAlign: 'end'
    }),
    start: (0, $3dJ4i.css)({
        textAlign: 'start'
    })
};
var $4ebae3e62029ece2$var$truncationStyles = (0, $3dJ4i.css)({
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
});
var $4ebae3e62029ece2$var$wordBreakMap = {
    breakAll: (0, $3dJ4i.css)({
        wordBreak: 'break-all'
    })
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $4ebae3e62029ece2$var$useColor = function useColor(colorProp) {
    var surface = (0, $d3wYX.useSurface)();
    var inverseTextColor = (0, $jN4m6.inverseColorMap)[surface];
    /**
   * Where the color of the surface is inverted we override the user choice
   * as there is no valid choice that is not covered by the override.
   */ var color = inverseTextColor !== null && inverseTextColor !== void 0 ? inverseTextColor : colorProp;
    return color;
};
var $4ebae3e62029ece2$var$HasTextAncestorContext = /*#__PURE__*/ (0, $1oC0p.createContext)(false);
var $4ebae3e62029ece2$var$useHasTextAncestor = function useHasTextAncestor() {
    return (0, $1oC0p.useContext)($4ebae3e62029ece2$var$HasTextAncestorContext);
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $4ebae3e62029ece2$var$Text = function Text(_ref) {
    var children = _ref.children, props = (0, $gnQ3X.default)(_ref, $4ebae3e62029ece2$var$_excluded);
    var asElement = props.as, _props$color = props.color, colorProp = _props$color === void 0 ? 'color.text' : _props$color, textAlign = props.textAlign, testId = props.testId, id = props.id, _props$variant = props.variant, variant = _props$variant === void 0 ? 'body' : _props$variant, weight = props.weight;
    // body variants -> p
    // ui variants -> span
    var Component = asElement || (variant.includes('body') ? 'p' : 'span');
    (0, $lmxXn.default)($4ebae3e62029ece2$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    // Remove the ability to bypass typescript errors for maxLines
    var maxLines;
    if ('maxLines' in props && variant.includes('body')) maxLines = props.maxLines;
    var color = $4ebae3e62029ece2$var$useColor(colorProp);
    var isWrapped = $4ebae3e62029ece2$var$useHasTextAncestor();
    /**
   * If the text is already wrapped and applies no props we can just
   * render the children directly as a fragment.
   */ if (isWrapped && Object.keys(props).length === 0) return (0, $3dJ4i.jsx)((0, $1oC0p.Fragment), null, children);
    var component = (0, $3dJ4i.jsx)(Component, {
        css: [
            $4ebae3e62029ece2$var$resetStyles,
            variant && $4ebae3e62029ece2$var$variantStyles[variant],
            color && (0, $jN4m6.textColorStylesMap)[color],
            maxLines && $4ebae3e62029ece2$var$truncationStyles,
            maxLines === 1 && $4ebae3e62029ece2$var$wordBreakMap.breakAll,
            textAlign && $4ebae3e62029ece2$var$textAlignMap[textAlign],
            weight && (0, $jN4m6.fontWeightStylesMap)[weight],
            asElement === 'em' && $4ebae3e62029ece2$var$emStyles,
            asElement === 'strong' && $4ebae3e62029ece2$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return isWrapped ? // no need to re-apply context if the text is already wrapped
    component : (0, $3dJ4i.jsx)($4ebae3e62029ece2$var$HasTextAncestorContext.Provider, {
        value: true
    }, component);
};
var $4ebae3e62029ece2$export$2e2bcd8739ae039 = $4ebae3e62029ece2$var$Text;

});

parcelRegister("8AXar", function(module, exports) {
$parcel$export(module.exports, "SignupBackgroundLayout", function () { return $3bb8ea39c6cdcf07$export$704c9f0bd9ea3790; });
/* signup-background-layout.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $5YGzb = parcelRequire("5YGzb");
const $3bb8ea39c6cdcf07$export$704c9f0bd9ea3790 = ({ ProductLogo: ProductLogo, children: children, theme: theme })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _zulp10yn _6a6z1h6o _2z051mfv _1itkuprl _bfhkvuon _1lrw10hx _ouxlbbky _12vemgnk _1tke1kxc _ca0q12am _u5f3idpf _n3td53f4 _19bvidpf _v5641i9m _9szs1kz8",
            theme === 'yellow' && "_1itkhe6p",
            theme === 'green' && "_1itkiyjd"
        ]),
        children: [
            ProductLogo,
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_bfhkvuon _2rko1crf _vchh1ntv _syazazsu _1e0c1txw _2lx21bp4 _ect4b1j9 _19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f13pj _ca0q1j6v _u5f31j6v _n3td1j6v _19bv1j6v _1bsb1kdj _scbp1jkq _oqic1ylp _1rmjys9h _cjbt1ylp _pnmbys9h _19451lk4"
                    ]),
                    children: children
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5YGzb.AtlassianLogo), {
                appearance: "neutral",
                size: "small",
                testId: "atlassian-logo",
                label: "Atlassian logo"
            })
        ]
    });
};
const $3bb8ea39c6cdcf07$var$containerStyles = null;
const $3bb8ea39c6cdcf07$var$yellowThemeCss = null;
const $3bb8ea39c6cdcf07$var$greenThemeCss = null;
const $3bb8ea39c6cdcf07$var$formWrapperCss = null;

});

parcelRegister("8AQXb", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $8fa89a103bc738eb$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $8fa89a103bc738eb$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    loading: {
        id: 'SoftwareRovoStart.Page.loading',
        defaultMessage: 'Loading'
    },
    login: {
        id: 'SoftwareRovoStart.Page.login',
        defaultMessage: 'Login'
    },
    contactSales: {
        id: 'SoftwareRovoStart.Page.contactSales',
        defaultMessage: 'Contact Sales'
    },
    rovoGetStarted: {
        defaultMessage: 'Get <started>started</started> with Rovo',
        description: 'Title text for WAC Rovo Start_logged out page',
        id: 'SoftwareRovoStart.Page.rovoGetStarted'
    },
    loginButtonRovo: {
        defaultMessage: 'Log in',
        id: 'SoftwareRovoStart.Page.loginButtonRovo'
    },
    rovoBodyText: {
        defaultMessage: 'Log in to add it to your organization',
        id: 'SoftwareRovoStart.Page.rovoBodyText'
    },
    dontHaveAccountText: {
        defaultMessage: "Don\u2019t have an account?",
        id: 'SoftwareRovoStart.Page.dontHaveAccountText'
    },
    contactAtlassianText: {
        defaultMessage: '<a>Contact Atlassian</a>',
        id: 'SoftwareRovoStart.Page.contactAtlassianText'
    },
    errorScreenTitle: {
        defaultMessage: 'Something went wrong',
        description: 'Error screen title',
        id: 'SoftwareRovoStart.Page.errorScreenTitle'
    },
    errorScreenMessageOne: {
        defaultMessage: '<a>Contact support</a> for further help or try again.',
        description: 'Error screen message part one',
        id: 'SoftwareRovoStart.Page.errorScreenMessageOne'
    },
    errorScreenMessageTwo: {
        defaultMessage: 'To receive a quote for Rovo, <a>contact sales.</a>',
        description: 'Error screen message part two',
        id: 'SoftwareRovoStart.Page.errorScreenMessageTwo'
    }
});

});

parcelRegister("cxI2Y", function(module, exports) {
$parcel$export(module.exports, "ScribbleImage", function () { return $84c16d41bc354312$export$31b1a25c5f295125; });

var $7VQPk = parcelRequire("7VQPk");
const $84c16d41bc354312$var$ScribbleImageComponent = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: "105",
        height: "17",
        viewBox: "0 0 105 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M104.435 9.68613C86.4938 6.51631 73.1262 13.83 55.0489 7.43996C54.1658 10.0608 51.9298 13.3276 48.6487 13.3318C51.3855 13.3082 55.8543 6.49074 51.3954 11.0379C48.7638 14.5108 37.5257 10.0724 46.1409 13.2376C40.1743 12.5113 34.7527 8.16936 30.7652 4.31768C24.1184 -1.18196 29.0775 9.35501 24.148 14.5541C17.1646 21.7785 -3.47552 2.46837 0.735557 2.51293C3.38441 4.93365 6.96197 6.46719 8.41505 9.13148C34.4142 25.1383 15.8926 -4.08831 31.4374 0.975475C56.6666 21.4402 44.0238 3.05288 58.9761 4.49783C67.6031 11.908 104.856 0.972575 104.442 9.68622L104.435 9.68613Z",
            fill: "#FCA700"
        })
    });
};
const $84c16d41bc354312$export$31b1a25c5f295125 = $84c16d41bc354312$var$ScribbleImageComponent;

});


parcelRegister("6VYIX", function(module, exports) {
$parcel$export(module.exports, "LoadingSpinner", function () { return $6c345910e2c56d86$export$b08b517936747730; });
/* spinner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $7qFQI = parcelRequire("7qFQI");

var $8AQXb = parcelRequire("8AQXb");
const $6c345910e2c56d86$var$loadingCss = null;
const $6c345910e2c56d86$export$b08b517936747730 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        role: "progressbar",
        "aria-label": intl.formatMessage((0, $8AQXb.messages).loading),
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1e0c1txw _1bah1h6o _1tke1kxc"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7qFQI.default), {
            size: "large"
        })
    });
};

});


parcelRegister("gsqLc", function(module, exports) {
$parcel$export(module.exports, "ErrorScreen", function () { return $88cb943b67e1fe7e$export$42f84e610f279c31; });
/* error-screen.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $eY3N6 = parcelRequire("eY3N6");

var $dTJrO = parcelRequire("dTJrO");

var $6A2DX = parcelRequire("6A2DX");

var $9jghN = parcelRequire("9jghN");
var $7SWbn = parcelRequire("7SWbn");
var $1xo8q = parcelRequire("1xo8q");

var $8AXar = parcelRequire("8AXar");

var $iSeHD = parcelRequire("iSeHD");

var $jQ0cd = parcelRequire("jQ0cd");

var $8AQXb = parcelRequire("8AQXb");

var $fJCnK = parcelRequire("fJCnK");
const $88cb943b67e1fe7e$var$elevatedContainerInnerStyles = (0, $1xo8q.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 'space.400',
    alignSelf: 'stretch',
    paddingBlockStart: 'space.150'
});
const $88cb943b67e1fe7e$var$contentStyles = (0, $1xo8q.xcss)({
    display: 'inline-flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 'space.200'
});
const $88cb943b67e1fe7e$var$bodyStyles = (0, $1xo8q.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    alignSelf: 'stretch',
    fontSize: "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: '400'
});
const $88cb943b67e1fe7e$var$linkStyles = null;
const $88cb943b67e1fe7e$export$42f84e610f279c31 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const localizedContactHref = (0, $jQ0cd.useLocalizedHref)('/enterprise/contact');
    (0, $1oC0p.useEffect)(()=>{
        analyticsClient && createAnalyticsEvent({
            action: 'viewed',
            eventType: 'screen',
            name: 'softwareRovoStartPageErrorScreen',
            source: 'softwareRovoStartPage'
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const fireButtonAnalytics = (0, $1oC0p.useCallback)((buttonName)=>{
        analyticsClient && createAnalyticsEvent({
            action: 'clicked',
            actionSubject: buttonName,
            actionSubjectId: 'softwareRovoStartPageTemplate',
            attributes: {
                source: 'errorScreen'
            }
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const contactSupportLinkHandler = (0, $1oC0p.useCallback)(()=>fireButtonAnalytics('contactSupportLink'), [
        fireButtonAnalytics
    ]);
    const contactSalesLinkHandler = (0, $1oC0p.useCallback)(()=>fireButtonAnalytics('contactSalesLink'), [
        fireButtonAnalytics
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8AXar.SignupBackgroundLayout), {
        ProductLogo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.RovoLogo), {
            size: "xlarge",
            appearance: "brand"
        }),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7SWbn.default), {
            xcss: $88cb943b67e1fe7e$var$elevatedContainerInnerStyles,
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fJCnK.ErrorIconImage), {}),
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7SWbn.default), {
                    xcss: $88cb943b67e1fe7e$var$contentStyles,
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                            as: "h1",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                ...(0, $8AQXb.messages).errorScreenTitle
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7SWbn.default), {
                            xcss: $88cb943b67e1fe7e$var$bodyStyles,
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9jghN.default), {
                                    space: "space.075",
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        ...(0, $8AQXb.messages).errorScreenMessageOne,
                                        values: {
                                            a: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                                    href: "https://support.atlassian.com/contact/",
                                                    onClick: contactSupportLinkHandler,
                                                    "aria-label": "Contact Atlassian Support Page",
                                                    className: (0, $2jatx.default)([
                                                        "_y3gn1h6o _syaz13af _k48p1fw0"
                                                    ]),
                                                    children: text
                                                })
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9jghN.default), {
                                    space: "space.075",
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        ...(0, $8AQXb.messages).errorScreenMessageTwo,
                                        values: {
                                            a: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                                    href: localizedContactHref,
                                                    onClick: contactSalesLinkHandler,
                                                    "aria-label": "Contact Atlassian Sales Page",
                                                    className: (0, $2jatx.default)([
                                                        "_y3gn1h6o _syaz13af _k48p1fw0"
                                                    ]),
                                                    children: text
                                                })
                                        }
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("fJCnK", function(module, exports) {
$parcel$export(module.exports, "ErrorIconImage", function () { return $ef9db3692a497100$export$a1922be2c234f039; });

var $7VQPk = parcelRequire("7VQPk");
const $ef9db3692a497100$var$ErrorIconComponent = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "105",
        height: "97",
        viewBox: "0 0 105 97",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                clipPath: "url(#clip0_2901_19175)",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M0.629883 96.2192L0.687156 96.3338H104.306L104.37 96.2192L52.4999 0.357422L0.629883 96.2192Z",
                        fill: "#DDDEE1"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M52.6782 34.6891V69.6954",
                        stroke: "white",
                        strokeWidth: "7.33",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M55.1283 80.6028C55.1601 80.4373 55.1728 80.2591 55.1728 80.0746C55.1728 79.8901 55.1601 79.7055 55.1283 79.5401C54.9501 78.541 54.2564 77.9301 53.2828 77.771C53.1174 77.7455 52.9455 77.7328 52.761 77.7328C52.5764 77.7328 52.3919 77.7455 52.2201 77.7773C51.2464 77.9364 50.5592 78.5537 50.3746 79.5464C50.3428 79.7119 50.3301 79.8901 50.3301 80.081C50.3301 80.2719 50.3428 80.4437 50.3746 80.6092C50.5528 81.6019 51.2464 82.2128 52.2201 82.3782C52.3919 82.4101 52.5764 82.4228 52.761 82.4228C52.9455 82.4228 53.1174 82.4101 53.2828 82.3846C54.2564 82.2255 54.9501 81.6082 55.1283 80.6155V80.6028Z",
                        stroke: "white",
                        strokeWidth: "7.33",
                        strokeMiterlimit: "10"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                    id: "clip0_2901_19175",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        width: "105",
                        height: "97",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
const $ef9db3692a497100$export$a1922be2c234f039 = $ef9db3692a497100$var$ErrorIconComponent;

});



parcelRegister("7Lagj", function(module, exports) {
$parcel$export(module.exports, "NonProfitPricingPage", function () { return $00749ab74f7d8f60$export$536ddfd40654e3e4; });

var $7VQPk = parcelRequire("7VQPk");

var $dl2JF = parcelRequire("dl2JF");

var $hkAZ4 = parcelRequire("hkAZ4");
const $00749ab74f7d8f60$export$536ddfd40654e3e4 = ({ pricing: pricing, countryCode: countryCode, pricingContent: pricingContent, queryRef: queryRef })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dl2JF.PricingContentContextProviderRelay), {
        productId: "nonprofit",
        pricingContent: pricingContent,
        queryRef: queryRef,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            "data-testid": "non-profit-pricing",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hkAZ4.NonProfitPricingPageTemplate), {
                pricing: pricing,
                countryCode: countryCode
            })
        })
    });
};

});
parcelRegister("hkAZ4", function(module, exports) {
$parcel$export(module.exports, "NonProfitPricingPageTemplate", function () { return $3183adb2da196ae8$export$55cf024acc460d8c; });

var $7VQPk = parcelRequire("7VQPk");

var $dl2JF = parcelRequire("dl2JF");

var $bE8d4 = parcelRequire("bE8d4");

var $grcEk = parcelRequire("grcEk");

var $9Url8 = parcelRequire("9Url8");

var $5S2vX = parcelRequire("5S2vX");

var $9RHgs = parcelRequire("9RHgs");

var $kvg9i = parcelRequire("kvg9i");

var $gaPqz = parcelRequire("gaPqz");

var $btggB = parcelRequire("btggB");

var $vCUGX = parcelRequire("vCUGX");

var $g7wmQ = parcelRequire("g7wmQ");

var $fZJZd = parcelRequire("fZJZd");

var $4bEWc = parcelRequire("4bEWc");

var $71t0B = parcelRequire("71t0B");

var $gtK7Z = parcelRequire("gtK7Z");

var $k53CY = parcelRequire("k53CY");

var $lSpoK = parcelRequire("lSpoK");

var $hJy82 = parcelRequire("hJy82");

var $3icmm = parcelRequire("3icmm");

var $in9in = parcelRequire("in9in");
const $3183adb2da196ae8$export$55cf024acc460d8c = ({ pricing: pricing, countryCode: countryCode })=>{
    const content = (0, $dl2JF.usePricingContentContext)();
    const isGwp10027NonprofitPricingPage = (0, $btggB.getIsGwp10027NonprofitPricingPage)();
    if (isGwp10027NonprofitPricingPage) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $vCUGX.NonProfitPricingPageTemplateWithTwc), {});
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
            pageId: "nonprofit-pricing-page",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    nav: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lSpoK.NonprofitNav), {}),
                    banner: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g7wmQ.Banner), {}),
                    hero: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gtK7Z.Hero), {}),
                    hasGlobalFooter: false
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    bgColor: "#F8F8F8",
                    hasGlobalFooter: false,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fZJZd.EligibleSection), {})
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    hasGlobalFooter: false,
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k53CY.NonprofitCalculatorHeading), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9RHgs.PricingTabs), {
                                jiraCalculatorComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gaPqz.JiraPriceFinder), {
                                    pricing: pricing,
                                    countryCode: countryCode,
                                    shouldAddDiscount: true
                                }),
                                confluenceCalculatorComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kvg9i.ConfluencePriceFinder), {
                                    pricing: pricing,
                                    countryCode: countryCode,
                                    shouldAddDiscount: true
                                }),
                                trelloCalculatorComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $in9in.TrelloPriceFinder), {
                                    pricing: pricing,
                                    countryCode: countryCode,
                                    shouldAddDiscount: true
                                }),
                                loomCalculatorComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9Url8.LoomPriceFinder), {
                                    pricing: pricing,
                                    countryCode: countryCode,
                                    shouldAddDiscount: true,
                                    ctaUrlSource: "productPlans"
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4bEWc.EnterpriseSection), {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    bgColor: "#E9F2FE",
                    hasGlobalFooter: false,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hJy82.OfficialSection), {})
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    hasGlobalFooter: false,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3icmm.ResourcesSection), {})
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    hasGlobalFooter: true,
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bE8d4.PricingFaq), {
                                header: content?.getMoreDetailsTitle,
                                planDetails: content?.additionalDetails
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $71t0B.Fineprint), {})
                        ]
                    })
                })
            ]
        })
    });
};

});
parcelRegister("9RHgs", function(module, exports) {
$parcel$export(module.exports, "PricingTabs", function () { return $85217f2010396a88$export$72a589327a08c3da; });
/* tabs.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $a9CD6 = parcelRequire("a9CD6");

var $1OyVz = parcelRequire("1OyVz");

var $hK1eD = parcelRequire("hK1eD");

var $98rQm = parcelRequire("98rQm");

var $dfmcY = parcelRequire("dfmcY");

var $gGOh9 = parcelRequire("gGOh9");
const $85217f2010396a88$var$tabStyles = null;
const $85217f2010396a88$export$72a589327a08c3da = ({ jiraCalculatorComponent: jiraCalculatorComponent, confluenceCalculatorComponent: confluenceCalculatorComponent, trelloCalculatorComponent: trelloCalculatorComponent, loomCalculatorComponent: loomCalculatorComponent, teamworkCollectionComponent: teamworkCollectionComponent, dataProductKey: dataProductKey, banner: banner })=>{
    const intl = (0, $8e22h.default)();
    const defaultProductKey = 'nonProfitCalculator';
    const defaultJiraCalculatorComponent = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: "Default Jira Component"
        });
    const defaultConfluenceCalculatorComponent = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: "Default Confluence Component"
        });
    const defaultTrelloCalculatorComponent = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: "Default Trello Component"
        });
    const defaultLoomCalculatorComponent = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: "Default Loom Component"
        });
    const defaultTeamworkCollectionCalculatorComponent = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: "Default Loom Component"
        });
    const JiraComponent = jiraCalculatorComponent ?? defaultJiraCalculatorComponent;
    const ConfluenceComponent = confluenceCalculatorComponent ?? defaultConfluenceCalculatorComponent;
    const TrelloComponent = trelloCalculatorComponent ?? defaultTrelloCalculatorComponent;
    const LoomComponent = loomCalculatorComponent ?? defaultLoomCalculatorComponent;
    const TeamworkCollectionComponent = teamworkCollectionComponent ?? defaultTeamworkCollectionCalculatorComponent;
    const possibleTabs = [
        {
            id: 'jira',
            textLabel: intl.formatMessage({
                id: 'PricingTabs.jira',
                defaultMessage: 'Jira'
            }),
            component: typeof JiraComponent === 'function' ? /*#__PURE__*/ (0, $7VQPk.jsx)(JiraComponent, {}) : JiraComponent,
            iconBefore: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1OyVz.JiraMarkBrand), {
                className: "logoSize"
            }),
            isAvailable: Boolean(jiraCalculatorComponent)
        },
        {
            id: 'confluence',
            textLabel: intl.formatMessage({
                id: 'PricingTabs.confluence',
                defaultMessage: 'Confluence'
            }),
            component: typeof ConfluenceComponent === 'function' ? /*#__PURE__*/ (0, $7VQPk.jsx)(ConfluenceComponent, {}) : ConfluenceComponent,
            iconBefore: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9CD6.ConfluenceMarkBrand), {
                className: "logoSize"
            }),
            isAvailable: Boolean(confluenceCalculatorComponent)
        },
        {
            id: 'loom',
            textLabel: intl.formatMessage({
                id: 'PricingTabs.loom',
                defaultMessage: 'Loom'
            }),
            component: typeof LoomComponent === 'function' ? /*#__PURE__*/ (0, $7VQPk.jsx)(LoomComponent, {}) : LoomComponent,
            iconBefore: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hK1eD.LoomMarkBrandV2), {
                className: "logoSize"
            }),
            isAvailable: Boolean(loomCalculatorComponent)
        },
        {
            id: 'trello',
            textLabel: intl.formatMessage({
                id: 'PricingTabs.trello',
                defaultMessage: 'Trello'
            }),
            component: typeof TrelloComponent === 'function' ? /*#__PURE__*/ (0, $7VQPk.jsx)(TrelloComponent, {}) : TrelloComponent,
            iconBefore: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $98rQm.TrelloMarkBrand), {
                className: "logoSize"
            }),
            isAvailable: Boolean(trelloCalculatorComponent)
        },
        {
            id: 'teamwork-collection',
            elementLabel: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_161tnagk _1lve1osq _1m8i1w81 _1pww1wug _eaz5idpf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dfmcY.CollectionTeamworkMarkBrandV3), {})
            }),
            textLabel: intl.formatMessage({
                id: 'PricingTabs.teamworkCollection',
                defaultMessage: 'Teamwork Collection'
            }),
            component: typeof TeamworkCollectionComponent === 'function' ? /*#__PURE__*/ (0, $7VQPk.jsx)(TeamworkCollectionComponent, {}) : TeamworkCollectionComponent,
            isAvailable: Boolean(teamworkCollectionComponent)
        }
    ];
    const tabs = possibleTabs.filter((tab)=>tab.isAvailable);
    const defaultBanner = intl.formatMessage({
        id: 'tabGroup.banner',
        defaultMessage: 'showing 75% off'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_p12f1osq _1kde1ule _5pbc1f4h _mp6aglyw _1v4zidpf _1n3n1osq _si4cgrf3 _1p4fgrf3 _r7togrf3 _17a1grf3 _1ypridpf _n8lpka7h _9ss6idpf _cy2pka7h _11cq1txw _1b5s1h6o _1rvg1h6o _jmjjr3uz _inr2g7ng _u4d1idpf _1v9nh2mm _7l98t94y _1bvkvle5 _1gvk1x1l _150515x9 _1afqkb7n _1b7v1crf _pu7u1crf _kqje1crf _16vm1crf _rclk1gky _12lk189y _f40h1afi _wx5o1afi _1lxt1hdd _xaq61hdd _qr3o1i53 _1xry1i53 _1lx01r31 _xx3h1r31 _1lleglyw _dqzjglyw _u4pp1o36 _12t91o36 _1s6ccs5v _1jp7cs5v _1lp7766g _2g4515iw _dt8dglyw _929l14y2 _15uvglyw _1schglyw _1qmzglyw _1fv4glyw _a47gglyw _fp1f7vkz _ipo11crf _mzrv1git _1plp1osq _1ckkidpf _o6gx1wug _1bmhidpf _196a1wug _mzhvidpf _113widpf _12kyidpf _1vg7idpf _w4c110yn _9kzd10yn _1qsfglyw _fe4v7vkz _1x987vkz _1pqlidpf _1lp010j7"
        ]),
        style: {
            "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100')),
            "--_1bik04v": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark900')),
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gGOh9.TabsCustom), {
            id: "pricingtabs",
            label: "pricing tabs",
            headerText: "",
            bodyText: "",
            className: "pricing-tabs",
            tabs: tabs,
            dataProductKey: dataProductKey ?? defaultProductKey,
            banner: banner ?? defaultBanner
        })
    });
};
$85217f2010396a88$export$72a589327a08c3da.displayName = 'TabbedCalculatorSection';

});
parcelRegister("hK1eD", function(module, exports) {
$parcel$export(module.exports, "LoomMarkBrandV2", function () { return $f58adaea274070d6$export$e783a4d8175ce805; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $4OgEb = parcelRequire("4OgEb");
const $f58adaea274070d6$export$e783a4d8175ce805 = ({ width: width = '100%', height: height = '100%', className: className, ...rest })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M41 22.1094H31.0579L39.6682 17.1383L37.7774 13.8622L29.167 18.8334L34.1371 10.2237L30.861 8.33173L25.891 16.9414V7H22.109V16.9423L17.137 8.33173L13.862 10.2228L18.833 18.8324L10.2227 13.8622L8.33169 17.1373L16.942 22.1085H7V25.8906H16.9411L8.33169 30.8617L10.2227 34.1378L18.8321 29.1676L13.8611 37.7772L17.137 39.6682L22.1081 31.0577V41H25.8901V31.0586L30.8601 39.6682L34.136 37.7772L29.1651 29.1667L37.7754 34.1378L39.6664 30.8617L31.057 25.8915H40.998V22.1094H41ZM24 29.1437C21.1483 29.1437 18.8368 26.8324 18.8368 23.9805C18.8368 21.1287 21.1483 18.8172 24 18.8172C26.8517 18.8172 29.1631 21.1287 29.1631 23.9805C29.1631 26.8324 26.8517 29.1437 24 29.1437Z",
            fill: "#625DF5"
        })
    });
$f58adaea274070d6$export$e783a4d8175ce805.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).number
    ]),
    height: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).number
    ]),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).string
};

});

parcelRegister("gGOh9", function(module, exports) {
$parcel$export(module.exports, "TabsCustom", function () { return $e3221c0f304a7ad7$export$da3a983bae6b9d3a; });
/* tabs-custom.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $2ivuE = parcelRequire("2ivuE");

var $2CA9S = parcelRequire("2CA9S");

var $iPPTB = parcelRequire("iPPTB");

var $1rGpC = parcelRequire("1rGpC");

var $b4FXR = parcelRequire("b4FXR");
const $e3221c0f304a7ad7$var$CustomTabsStyle = null;
const $e3221c0f304a7ad7$export$da3a983bae6b9d3a = ({ id: id, label: label, headerText: headerText, bodyText: bodyText, tabs: tabs, dataProductKey: dataProductKey, colors: colors, ctaProps: ctaProps, linkPosition: linkPosition = 'bottom', backgroundProperties: backgroundProperties, className: className, banner: banner })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $b4FXR.StyledBackground), {
        ...backgroundProperties,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1yt41d5t _13zni5hb _15tx1jx0",
                className
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ivuE.ContentBlock), {
                        headerText: headerText,
                        headerType: "h2",
                        bodyText: bodyText,
                        isCentered: true,
                        ctaProps: linkPosition === 'top' && ctaProps?.primaryLinkProps ? ctaProps : {}
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2CA9S.TabGroup), {
                        colors: colors,
                        tabContentType: "custom",
                        tabs: tabs,
                        id: id,
                        label: label,
                        dataProductKey: dataProductKey,
                        banner: banner
                    })
                }),
                linkPosition === 'bottom' && ctaProps?.primaryLinkProps ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_y3gn1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                            ...ctaProps.primaryLinkProps,
                            text: ctaProps.primaryLinkProps.text,
                            "aria-label": ctaProps.primaryLinkProps.text
                        })
                    })
                }) : null
            ]
        })
    });
};

});


parcelRegister("kvg9i", function(module, exports) {
$parcel$export(module.exports, "ConfluencePriceFinder", function () { return $82aa4d75759518c1$export$a33aedde1d62b896; });

var $7VQPk = parcelRequire("7VQPk");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $hCc2m = parcelRequire("hCc2m");

var $g9ZvA = parcelRequire("g9ZvA");

var $gIRO7 = parcelRequire("gIRO7");

var $eYlij = parcelRequire("eYlij");

var $koOAf = parcelRequire("koOAf");

var $fFFp6 = parcelRequire("fFFp6");

var $cLbmg = parcelRequire("cLbmg");

var $cOu5a = parcelRequire("cOu5a");

var $fesdZ = parcelRequire("fesdZ");

var $nFBGc = parcelRequire("nFBGc");

var $cgKz4 = parcelRequire("cgKz4");

var $eQdGa = parcelRequire("eQdGa");

var $hUuit = parcelRequire("hUuit");

var $hRBYs = parcelRequire("hRBYs");

var $6EgwO = parcelRequire("6EgwO");

var $gAdOA = parcelRequire("gAdOA");

var $ies49 = parcelRequire("ies49");

var $g1Nmd = parcelRequire("g1Nmd");

var $5CFs0 = parcelRequire("5CFs0");

var $2yu3p = parcelRequire("2yu3p");

var $9Voys = parcelRequire("9Voys");
const $82aa4d75759518c1$export$a33aedde1d62b896 = (props)=>{
    const intl = (0, $8e22h.default)();
    const newTagText = intl.formatMessage({
        id: 'ConfluencePricingPage.priceFinder.newTagText',
        defaultMessage: 'New'
    });
    const freePlanFeatureMessages = [
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: 'ConfluencePricingPageTeam24.features.unlimitedPages.title',
                    defaultMessage: 'Unlimited pages'
                }),
                content: (0, $5CFs0.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: 'ConfluencePricingPageTeam24.features.unlimitedSpaces.title',
                    defaultMessage: 'Unlimited spaces'
                }),
                content: (0, $2yu3p.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: 'ConfluencePricingPageTeam24.features.databases.title',
                    defaultMessage: 'Organize and connect work with databases'
                }),
                content: (0, $nFBGc.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: 'ConfluencePricingPageTeam24.features.templates.title',
                    defaultMessage: 'Templates for Marketing, Product, Program Management and more'
                }),
                content: (0, $g1Nmd.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: 'ConfluencePricingPageTeam24.features.activeWhiteboards.title',
                    defaultMessage: 'Up to 3 active whiteboards per user '
                }),
                content: (0, $koOAf.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: 'ConfluencePricingPageTeam24.features.freeAutomationRuleRuns.title',
                    defaultMessage: '10 automation rule runs per month '
                }),
                content: (0, $fesdZ.FreeAutomationRuleRuns)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: 'ConfluencePricingPageTeam24.features.supportAppsAndIntegrations',
                    defaultMessage: 'Support for apps and integrations'
                }),
                content: (0, $gAdOA.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: 'ConfluencePricingPageTeam24.features.supportFromAtlassianCommunity',
                    defaultMessage: 'Support from Atlassian Community'
                }),
                content: (0, $ies49.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: 'ConfluencePricingPageTeam24.features.freeFileStorage',
                defaultMessage: 'Up to 2 GB file storage'
            })
        }
    ];
    const standardPlanFeatureMessages = [
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: 'ConfluencePricingPageTeam24.features.externalCollaboration.title',
                    defaultMessage: 'External collaboration'
                }),
                content: (0, $eQdGa.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: 'ConfluencePricingPageTeam24.features.pagePermissions.title',
                    defaultMessage: 'Page permissions'
                }),
                content: (0, $hUuit.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: 'ConfluencePricingPageTeam24.features.standardAutomationRuleRuns.title',
                    defaultMessage: '100 automation rule runs per month'
                }),
                content: (0, $fesdZ.StandardAutomationRuleRuns)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: 'ConfluencePricingPageTeam24.features.standardStorage.title',
                defaultMessage: '250 GB of storage'
            })
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: 'ConfluencePricingPageTeam24.features.regionalSupport.title',
                    defaultMessage: '9/5 regional support'
                }),
                content: (0, $6EgwO.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: 'ConfluencePricingPageTeam24.features.standard150000singlesSite.title',
                defaultMessage: 'Up to 150,000 users on a single site'
            })
        }
    ];
    const premiumPlanFeatureMessages = [
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: 'ConfluencePricingPageTeam24.features.aiPowered.title',
                    defaultMessage: 'AI-powered creation and collaboration'
                }),
                content: (0, $cLbmg.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: 'ConfluencePricingPageTeam24.features.dynamicIntranet.title',
                    defaultMessage: 'Dynamic intranet'
                }),
                content: (0, $cgKz4.default)
            },
            lozengeText: newTagText
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: 'ConfluencePricingPageTeam24.features.perUserAutomation.title',
                    defaultMessage: 'Per user automation limits (1000 per month)'
                }),
                content: (0, $cOu5a.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: 'ConfluencePricingPageTeam24.features.unlimitedWhiteboards.title',
                    defaultMessage: 'Unlimited whiteboards'
                }),
                content: (0, $9Voys.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: 'ConfluencePricingPageTeam24.features.adminControlsInsights.title',
                    defaultMessage: 'Admin controls and insights'
                }),
                content: (0, $fFFp6.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: 'ConfluencePricingPageTeam24.features.unlimitedStorage.title',
                defaultMessage: 'Unlimited storage'
            })
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: 'ConfluencePricingPageTeam24.features.premiumSupport.title',
                    defaultMessage: '24/7 support for critical issues'
                }),
                content: (0, $hRBYs.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: 'ConfluencePricingPageTeam24.features.premiumSla.title',
                defaultMessage: '99.9% uptime SLA'
            })
        }
    ];
    const confluenceProductPlans = [
        {
            planName: 'Free',
            offeringSku: 'confluence-free',
            description: intl.formatMessage({
                id: 'ConfluencePricingPageTeam24.priceFinder.freeDescription',
                defaultMessage: 'Free forever for 10 users'
            }),
            recommendationLimit: 0,
            signupLimit: 150000,
            signupURLSuffix: '?bundle=confluence&edition=free&signupSource=pricing',
            planFeatureMessages: freePlanFeatureMessages
        },
        {
            planName: 'Standard',
            offeringSku: 'confluence-standard',
            description: intl.formatMessage({
                id: 'ConfluencePricingPageTeam24.priceFinder.standardDescription',
                defaultMessage: 'Everything you need to get started'
            }),
            recommendationLimit: 10,
            signupLimit: 150000,
            signupURLSuffix: '?bundle=confluence&edition=standard',
            planFeatureMessages: standardPlanFeatureMessages
        },
        {
            planName: 'Premium',
            offeringSku: 'confluence-premium',
            description: intl.formatMessage({
                id: 'ConfluencePricingPageTeam24.priceFinder.premiumDescription',
                defaultMessage: 'Connect work across teams'
            }),
            recommendationLimit: 250,
            signupLimit: 150000,
            signupURLSuffix: '?bundle=confluence&edition=premium',
            planFeatureMessages: premiumPlanFeatureMessages
        }
    ];
    const messages = (0, $fnHPc.defineMessages)({
        headerText: {
            id: 'ConfluencePricingPageTeam24.priceFinder.headerText',
            defaultMessage: 'Build Your <blue>Source of Truth</blue>'
        },
        unitCountInputTextRedesign: {
            id: 'ConfluencePricingPage.priceFinder.unitCountInputTextRedesign',
            defaultMessage: 'Team size:'
        },
        unitCountInputDirectBuy: {
            id: 'ConfluencePricingPage.priceFinder.unitCountInputDirectBuy',
            defaultMessage: "What's your team size?"
        },
        unitCountInputTerm: {
            id: 'ConfluencePricingPage.priceFinder.unitCountInputTerm',
            defaultMessage: 'users'
        },
        billingCycleText: {
            id: 'ConfluencePricingPage.priceFinder.billingCycleText',
            defaultMessage: 'Billing cycle:'
        },
        unitCountInputText: {
            id: 'ConfluencePricingPage.priceFinder.unitCountInputText',
            defaultMessage: 'How many users are on your team?'
        },
        unitCountInputTooltip: {
            id: 'ConfluencePricingPage.priceFinder.unitCountInputTooltip',
            defaultMessage: 'A Confluence user is any user who can log in to Confluence, and who exists in User Management'
        },
        monthlyExampleHelpText: {
            id: 'ConfluencePricingPage.priceFinder.monthlyExampleHelpText',
            defaultMessage: 'Monthly plans give you flexibility as your number of active users changes, so pay for seats as you use them. Remember that the number of seats may change the total price.'
        },
        annualExampleHelpText: {
            id: 'ConfluencePricingPage.priceFinder.annualExampleHelpText',
            defaultMessage: 'Annual plans give you flexibility and help you prepare for growth. Buy a group of seats at a flat rate now, then fill your empty seats through the year at no extra cost.'
        },
        exampleStandardPlan: {
            id: 'ConfluencePricingPage.priceFinder.exampleStandardPlan',
            defaultMessage: 'Pricing for {unitCount} users on Standard plan',
            description: 'Standard is a plan name and should not be translated'
        },
        cardOverSignupLimit: {
            id: 'ConfluencePricingPage.priceFinder.cardOverSignupLimit',
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: 'ConfluencePricingPage.priceFinder.cardEnterpriseMinimumCount',
            defaultMessage: 'Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above',
            description: 'Enterprise is a plan name and should not be translated'
        },
        cardUnitCountTierRange: {
            id: 'ConfluencePricingPage.priceFinder.cardUnitCountTierRange',
            defaultMessage: 'User tier: {lowerLimit} - {upperLimit}'
        },
        cardMonthlyPerUnitCount: {
            id: 'ConfluencePricingPageTeam24.priceFinder.cardMonthlyPerUnitCount',
            defaultMessage: 'per user / month'
        },
        cardFreeDescription: {
            id: 'ConfluencePricingPage.priceFinder.cardFreeDescription',
            defaultMessage: 'Always free for 10 users'
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hCc2m.default), {
        interactionName: 'conf-price-finder',
        fallback: (0, $g9ZvA.LoadingSpinner),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eYlij.PriceFinderContextProvider), {
            dataProductKey: "confluence",
            productPlans: confluenceProductPlans,
            defaultUnitCount: 150,
            shouldAddDiscount: props.shouldAddDiscount,
            ctaUrlSource: "productPlans",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gIRO7.default), {
                messages: messages,
                serverSideCCPPricing: props.pricing?.ccpPricingData?.confluence,
                countryCode: props.countryCode
            })
        })
    });
};
$82aa4d75759518c1$export$a33aedde1d62b896.displayName = 'ConfluencePriceFinder';
var $82aa4d75759518c1$export$2e2bcd8739ae039 = $82aa4d75759518c1$export$a33aedde1d62b896;

});
parcelRegister("koOAf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f16e3c3feb0f7500$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $jQ0cd = parcelRequire("jQ0cd");

var $iRMRa = parcelRequire("iRMRa");
const $f16e3c3feb0f7500$var$ActiveWhiteboards = ()=>{
    const localizedHref = (0, $jQ0cd.useLocalizedHref)('/software/confluence/whiteboards');
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.activeWhiteboards.content.body",
                defaultMessage: "Confluence whiteboards brings the flexibility of a digital whiteboard into your team workspace. Collaborate, brainstorm, draw and visualize ideas in a freeform way with up to 3 active whiteboards per user. <a>Learn more.</a>",
                values: {
                    ...(0, $iRMRa.DEFAULT_VALUES),
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-label-english": "learn more",
                            "data-track-event": "ConfluencePricingPageTeam24.activeWhiteboards.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            href: localizedHref,
                            children: chunks
                        })
                }
            })
        })
    });
};
var $f16e3c3feb0f7500$export$2e2bcd8739ae039 = $f16e3c3feb0f7500$var$ActiveWhiteboards;

});

parcelRegister("fFFp6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $469172ebba1ea1c7$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $469172ebba1ea1c7$var$AdminControlsInsights = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.adminControlsInsights.content.body",
                defaultMessage: "Inspect permissions to specify who can do and create what, and fix permission problems quickly with an admin key. Manage site health, get actionable alerts, and unlock site-level insights, all in one place."
            })
        })
    });
};
var $469172ebba1ea1c7$export$2e2bcd8739ae039 = $469172ebba1ea1c7$var$AdminControlsInsights;

});

parcelRegister("cLbmg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4433695e8f3d4b1b$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $3fFrT = parcelRequire("3fFrT");

var $jQ0cd = parcelRequire("jQ0cd");

var $iRMRa = parcelRequire("iRMRa");
const $4433695e8f3d4b1b$var$AtlassianIntelligence = ()=>{
    const localizedHref = `https://support.atlassian.com${(0, $jQ0cd.useLocalizedHref)('/organization-administration/docs/get-started-with-atlassian-intelligence/', {
        supportedLocales: (0, $3fFrT.ATLASSIAN_SUPPORT_CENTER_SUPPORTED_LOCALES)
    })}`;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.atlassianIntelligence.content.body",
                defaultMessage: "Communicate efficiently, glean relevant insights, and work on what matters with AI capabilities. These include AI-powered editing experiences, quick summaries of long pages, and more. <a>Learn more.</a>",
                values: {
                    ...(0, $iRMRa.DEFAULT_VALUES),
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-label-english": "learn more",
                            "data-track-event": "ConfluencePricingPageTeam24.atlassianInteligence.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            href: localizedHref,
                            children: chunks
                        })
                }
            })
        })
    });
};
var $4433695e8f3d4b1b$export$2e2bcd8739ae039 = $4433695e8f3d4b1b$var$AtlassianIntelligence;

});

parcelRegister("cOu5a", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ca383066b7aa1366$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $jQ0cd = parcelRequire("jQ0cd");

var $iRMRa = parcelRequire("iRMRa");
const $ca383066b7aa1366$var$PerUserAutomation = ()=>{
    const localizedHref = (0, $jQ0cd.useLocalizedHref)('/software/confluence/automation');
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.perUserAutomation.content.body",
                defaultMessage: "Save time by automating repetitive, manual tasks to organize and manage content at scale. Get started quickly with out-of-the box templates or build your own powerful, custom rules by using the low-code / no-code rule builder and with AI. With Premium, unlock up to 1,000 automations per user per month. <a>Learn more.</a>",
                values: {
                    ...(0, $iRMRa.DEFAULT_VALUES),
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-label-english": "learn more",
                            "data-track-event": "ConfluencePricingPageTeam24.perUserAutomation.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            href: localizedHref,
                            children: chunks
                        })
                }
            })
        })
    });
};
var $ca383066b7aa1366$export$2e2bcd8739ae039 = $ca383066b7aa1366$var$PerUserAutomation;

});

parcelRegister("fesdZ", function(module, exports) {
$parcel$export(module.exports, "FreeAutomationRuleRuns", function () { return $fba808d380f6bdb1$export$cb1c6db7544762b5; });
$parcel$export(module.exports, "StandardAutomationRuleRuns", function () { return $fba808d380f6bdb1$export$6716f876ee5d7d01; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $jQ0cd = parcelRequire("jQ0cd");

var $iRMRa = parcelRequire("iRMRa");
const $fba808d380f6bdb1$export$cb1c6db7544762b5 = ()=>{
    const localizedHref = (0, $jQ0cd.useLocalizedHref)('/software/confluence/automation');
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.freeAutomationRuleRuns.content.body",
                defaultMessage: "Increase efficiency by replacing manual, time-consuming work with automated processes and workflows. With Free, unlock 10 automation rule runs per instance per month. <a>Learn more.</a>",
                values: {
                    ...(0, $iRMRa.DEFAULT_VALUES),
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-label-english": "learn more",
                            "data-track-event": "ConfluencePricingPageTeam24.freeAutomationRuleRuns.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            href: localizedHref,
                            children: chunks
                        })
                }
            })
        })
    });
};
const $fba808d380f6bdb1$export$6716f876ee5d7d01 = ()=>{
    const localizedHref = (0, $jQ0cd.useLocalizedHref)('/software/confluence/automation');
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.standardAutomationRuleRuns.content.body",
                defaultMessage: "Increase efficiency by replacing manual, time-consuming work with automated processes and workflows. With Standard, unlock 100 automation rule runs per instance per month. <a>Learn more.</a>",
                values: {
                    ...(0, $iRMRa.DEFAULT_VALUES),
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-label-english": "learn more",
                            "data-track-event": "ConfluencePricingPageTeam24.standardAutomationRuleRuns.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            href: localizedHref,
                            children: chunks
                        })
                }
            })
        })
    });
};

});

parcelRegister("nFBGc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $508f39883b774a30$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $jQ0cd = parcelRequire("jQ0cd");

var $iRMRa = parcelRequire("iRMRa");

var $dtAYn = parcelRequire("dtAYn");
const $508f39883b774a30$var$Databases = ()=>{
    const localizedHref = (0, $jQ0cd.useLocalizedHref)('/software/confluence/databases');
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.databases.content.body",
                defaultMessage: "Confluence databases are a central source of info that dramatically changes the way that teams can organize, reference, and display data in Confluence. <a>Learn more</a>.",
                values: {
                    ...(0, $iRMRa.DEFAULT_VALUES),
                    a: (0, $dtAYn.getMessageHyperlinkValue)({
                        localizedHref: localizedHref,
                        'data-event-container': 'ConfluencePricingPage',
                        'data-label-english': 'Learn more',
                        'data-track-event': 'ConfluencePricingPageTeam24.databases'
                    })
                }
            })
        })
    });
};
var $508f39883b774a30$export$2e2bcd8739ae039 = $508f39883b774a30$var$Databases;

});
parcelRegister("dtAYn", function(module, exports) {
$parcel$export(module.exports, "getMessageHyperlinkValue", function () { return $fc23cd4c346f4bb0$export$c5b540569b1a51b0; });

var $7VQPk = parcelRequire("7VQPk");
function $fc23cd4c346f4bb0$export$c5b540569b1a51b0(params) {
    const { localizedHref: localizedHref, ...rest } = params;
    return (chunks)=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
            href: params.localizedHref,
            ...rest,
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-product-key": "confluence",
            children: chunks
        });
    };
}

});


parcelRegister("cgKz4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6464191f0fead551$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $jQ0cd = parcelRequire("jQ0cd");

var $iRMRa = parcelRequire("iRMRa");
const $6464191f0fead551$var$DynamicIntranet = ()=>{
    const localizedHref = (0, $jQ0cd.useLocalizedHref)('/software/confluence/use-cases/intranet-software');
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.dynamicIntranet.content.body",
                defaultMessage: "Customize a dynamic info hub for your entire company with company hub, a single go-to destination for company news, announcements, and resources. <a>Learn more.</a>",
                values: {
                    ...(0, $iRMRa.DEFAULT_VALUES),
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-label-english": "learn more",
                            "data-track-event": "ConfluencePricingPageTeam24.dynamicIntranet.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            href: localizedHref,
                            children: chunks
                        })
                }
            })
        })
    });
};
var $6464191f0fead551$export$2e2bcd8739ae039 = $6464191f0fead551$var$DynamicIntranet;

});

parcelRegister("eQdGa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f839d5e47581ebfa$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $f839d5e47581ebfa$var$ExternalCollaboration = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "ConfluencePricingPageTeam24.features.externalCollaboration.content.bodyOne",
                    defaultMessage: "Invite external partners to collaborate as guests in your Confluence site. Guests are free of charge, up to 5 guests per paid user."
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "ConfluencePricingPageTeam24.features.externalCollaboration.content.bodyTwo",
                    defaultMessage: "You can also share view-only Confluence pages via public links. This can be useful for sharing information to the public, like customer FAQs and release notes."
                })
            })
        ]
    });
};
var $f839d5e47581ebfa$export$2e2bcd8739ae039 = $f839d5e47581ebfa$var$ExternalCollaboration;

});

parcelRegister("hUuit", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ef5e90854da8ecb8$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $ef5e90854da8ecb8$var$PagePermissions = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.pagePermissions.content.body",
                defaultMessage: "Control who can view, edit and comment on your pages, so important information can stay restricted until you\u2019re ready to share."
            })
        })
    });
};
var $ef5e90854da8ecb8$export$2e2bcd8739ae039 = $ef5e90854da8ecb8$var$PagePermissions;

});

parcelRegister("hRBYs", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5e1e0d16eb6e1cd0$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $jQ0cd = parcelRequire("jQ0cd");

var $iRMRa = parcelRequire("iRMRa");
const $5e1e0d16eb6e1cd0$var$PremiumSupport = ()=>{
    const localizedHref = (0, $jQ0cd.useLocalizedHref)('/enterprise/support-services');
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.premiumSupport.content.body",
                defaultMessage: "Get Premium support around the clock from a dedicated team with 1-hour response times to critical issues. <a>Learn more.</a>",
                values: {
                    ...(0, $iRMRa.DEFAULT_VALUES),
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-label-english": "learn more",
                            "data-track-event": "ConfluencePricingPageTeam24.premiumSupport.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            href: localizedHref,
                            children: chunks
                        })
                }
            })
        })
    });
};
var $5e1e0d16eb6e1cd0$export$2e2bcd8739ae039 = $5e1e0d16eb6e1cd0$var$PremiumSupport;

});

parcelRegister("6EgwO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1a5d9a10c21c25a8$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $jQ0cd = parcelRequire("jQ0cd");

var $iRMRa = parcelRequire("iRMRa");
const $1a5d9a10c21c25a8$var$RegionalSupport = ()=>{
    const localizedHref = (0, $jQ0cd.useLocalizedHref)('/enterprise/support-services');
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.regionalSupport.content.body",
                defaultMessage: "Customer support during business hours is available with Confluence Standard plan. <a>Learn more.</a>",
                values: {
                    ...(0, $iRMRa.DEFAULT_VALUES),
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-track-event": "ConfluencePricingPageTeam24.regionalSupport.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            "data-label-english": "learn more",
                            href: localizedHref,
                            children: chunks
                        })
                }
            })
        })
    });
};
var $1a5d9a10c21c25a8$export$2e2bcd8739ae039 = $1a5d9a10c21c25a8$var$RegionalSupport;

});

parcelRegister("gAdOA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f3f831b9287d5da4$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $iRMRa = parcelRequire("iRMRa");
const $f3f831b9287d5da4$var$SupportAppsIntegrations = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.supportAppsIntegrations.content.body",
                defaultMessage: "Integrate Confluence with other apps you\u2019re already using. <a>Learn more.</a>",
                values: {
                    ...(0, $iRMRa.DEFAULT_VALUES),
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-label-english": "Learn More",
                            "data-track-event": "ConfluencePricingPageTeam24.supportAppsIntegrations.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            href: "https://marketplace.atlassian.com/search?product=confluence",
                            children: chunks
                        })
                }
            })
        })
    });
};
var $f3f831b9287d5da4$export$2e2bcd8739ae039 = $f3f831b9287d5da4$var$SupportAppsIntegrations;

});

parcelRegister("ies49", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b7b841abdaecb242$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $iRMRa = parcelRequire("iRMRa");
const $b7b841abdaecb242$var$SupportAtlassianCommunity = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.supportAtlassianCommunity.content.body",
                defaultMessage: "Get support from the <a>Atlassian Community</a>, a public forum of community experts where you can ask questions. You can also access free Confluence guides and knowledge base articles.",
                values: {
                    ...(0, $iRMRa.DEFAULT_VALUES),
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-track-event": "ConfluencePricingPageTeam24.supportAtlassianCommunity",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            "data-label-english": "Atlassian Community",
                            href: "https://community.atlassian.com/",
                            children: chunks
                        })
                }
            })
        })
    });
};
var $b7b841abdaecb242$export$2e2bcd8739ae039 = $b7b841abdaecb242$var$SupportAtlassianCommunity;

});

parcelRegister("g1Nmd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d99847d75ead21a0$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $jQ0cd = parcelRequire("jQ0cd");

var $iRMRa = parcelRequire("iRMRa");
const $d99847d75ead21a0$var$Templates = ()=>{
    const localizedHref = (0, $jQ0cd.useLocalizedHref)('/software/confluence/templates');
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.templates.content.body",
                defaultMessage: "Get started quickly by using the <a>template library</a>. From product requirement documents to marketing plans, there\u2019s a template that\u2019s perfect fit for your project.",
                values: {
                    ...(0, $iRMRa.DEFAULT_VALUES),
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-track-event": "ConfluencePricingPageTeam24.templates",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            "data-label-english": "template libary",
                            href: localizedHref,
                            children: chunks
                        })
                }
            })
        })
    });
};
var $d99847d75ead21a0$export$2e2bcd8739ae039 = $d99847d75ead21a0$var$Templates;

});

parcelRegister("5CFs0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b141362605c57423$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $b141362605c57423$var$UnlimitedPages = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.unlimitedPages.content.body",
                defaultMessage: "Pages are used to create, share, and edit knowledge. These are living documents you can create and update for almost anything \u2013 from project plans, meeting notes, policies and more. You can create as many pages as you need."
            })
        })
    });
};
var $b141362605c57423$export$2e2bcd8739ae039 = $b141362605c57423$var$UnlimitedPages;

});

parcelRegister("2yu3p", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d946899749b1f69d$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $d946899749b1f69d$var$UnlimitedSpaces = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.unlimitedSpaces.content.body",
                defaultMessage: "Spaces are how you organize pages into meaningful categories, like different folders where you can store your work. You can create as many spaces as you need."
            })
        })
    });
};
var $d946899749b1f69d$export$2e2bcd8739ae039 = $d946899749b1f69d$var$UnlimitedSpaces;

});

parcelRegister("9Voys", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a0a4624eaf1e1adf$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $jQ0cd = parcelRequire("jQ0cd");

var $iRMRa = parcelRequire("iRMRa");
const $a0a4624eaf1e1adf$var$UnlimitedWhiteboards = ()=>{
    const localizedHref = (0, $jQ0cd.useLocalizedHref)('/software/confluence/whiteboards');
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.unlimitedWhiteboards.content.body",
                defaultMessage: "Confluence whiteboards brings the flexibility of a digital whiteboard into your team workspace. With Premium, unlock unlimited whiteboards and advanced Jira integrations to brainstorm, plan and action work like never before. <a>Learn more.</a>",
                values: {
                    ...(0, $iRMRa.DEFAULT_VALUES),
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-track-event": "ConfluencePricingPageTeam24.unlimitedWhiteboards.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            "data-label-english": "learn more",
                            href: localizedHref,
                            children: chunks
                        })
                }
            })
        })
    });
};
var $a0a4624eaf1e1adf$export$2e2bcd8739ae039 = $a0a4624eaf1e1adf$var$UnlimitedWhiteboards;

});


parcelRegister("gaPqz", function(module, exports) {
$parcel$export(module.exports, "JiraPriceFinder", function () { return $47b0960c2ef159b2$export$1bf486cdabb14f4d; });

var $7VQPk = parcelRequire("7VQPk");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $hCc2m = parcelRequire("hCc2m");

var $g9ZvA = parcelRequire("g9ZvA");

var $gIRO7 = parcelRequire("gIRO7");

var $eYlij = parcelRequire("eYlij");

var $1hGR5 = parcelRequire("1hGR5");

var $c6rNV = parcelRequire("c6rNV");

var $8kuWI = parcelRequire("8kuWI");

var $WOC4s = parcelRequire("WOC4s");

var $5Ikga = parcelRequire("5Ikga");

var $83Gke = parcelRequire("83Gke");

var $guvAv = parcelRequire("guvAv");

var $dBwTO = parcelRequire("dBwTO");

var $h2AoW = parcelRequire("h2AoW");

var $17uTl = parcelRequire("17uTl");

var $6w3tN = parcelRequire("6w3tN");

var $8wGxe = parcelRequire("8wGxe");

var $gl8tX = parcelRequire("gl8tX");
const $47b0960c2ef159b2$export$1bf486cdabb14f4d = (props)=>{
    const intl = (0, $8e22h.default)();
    const newTagText = intl.formatMessage({
        id: 'JiraSoftwarePricingPage.priceFinder.newTagText',
        defaultMessage: 'New'
    });
    const freePlanFeatureMessages = [
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: 'JiraSoftwarePricingPageV2.features.unlimitedProjectBoards.title.v2',
                    defaultMessage: 'Unlimited goals, projects, tasks, and forms'
                }),
                content: (0, $8wGxe.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: 'JiraSoftwarePricingPageV2.features.backlogAndTimeline.title',
                    defaultMessage: 'Backlog, list, board, timeline, calendar, and summary views'
                }),
                content: (0, $8kuWI.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: 'JiraSoftwarePricingPageV2.features.reportsAndDashboards.title',
                    defaultMessage: 'Reports and dashboards'
                }),
                content: (0, $dBwTO.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: 'JiraSoftwarePricingPageV2.features.freeAutomations.title',
                    defaultMessage: '100 automation rule runs per month'
                }),
                content: (0, $c6rNV.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: 'JiraSoftwarePricingPage.priceFinder.freePlan2GBOfStorage',
                defaultMessage: '2 GB of storage'
            })
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: 'JiraSoftwarePricingPageV2.features.freeCommunitySupport.title',
                    defaultMessage: 'Support from Atlassian Community'
                }),
                content: (0, $h2AoW.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: 'JiraSoftwarePricingPageV2.features.upTo10Users.title',
                defaultMessage: 'Up to 10 users'
            })
        }
    ];
    const standardPlanFeatureMessages = [
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: 'JiraSoftwarePricingPageV2.features.userRolesPermissions.title',
                    defaultMessage: 'User roles and permissions'
                }),
                content: (0, $gl8tX.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: 'JiraSoftwarePricingPageV2.features.externalCollaboration.title',
                    defaultMessage: 'External collaboration'
                }),
                content: (0, $83Gke.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: 'JiraSoftwarePricingPageV2.features.multiRegionDataResidency.title',
                    defaultMessage: 'Multi-region data residency'
                }),
                content: (0, $guvAv.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: 'JiraSoftwarePricingPageV2.features.standardAutomations.title',
                    defaultMessage: '1,700 automation rule runs per month'
                }),
                content: (0, $c6rNV.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: 'JiraSoftwarePricingPageV2.features.standardStorage.title',
                defaultMessage: '250 GB of storage'
            })
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: 'JiraSoftwarePricingPageV2.features.standardSupport.title',
                    defaultMessage: '9/5 regional support'
                }),
                content: (0, $6w3tN.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: 'JiraSoftwarePricingPageV2.features.standard5000singlesSite.title',
                defaultMessage: 'Up to 100,000 users on a single site'
            })
        }
    ];
    const premiumPlanFeatureMessages = [
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: 'JiraSoftwarePricingPageV2.features.aiPowered.title.v2',
                    defaultMessage: 'Generate, summarize, and search content with Atlassian Intelligence (AI)'
                }),
                content: (0, $1hGR5.default)
            },
            lozengeText: newTagText
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: 'JiraSoftwarePricingPageV2.features.crossTeamPlanning.title',
                    defaultMessage: 'Cross-team planning and dependency management'
                }),
                content: (0, $WOC4s.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: 'JiraSoftwarePricingPageV2.features.customizableApprovalProcesses.title',
                    defaultMessage: 'Customizable approval processes'
                }),
                content: (0, $5Ikga.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: 'JiraSoftwarePricingPageV2.features.premiumAutomation.title',
                    defaultMessage: 'Per user automation limits (1,000 rule runs per month)'
                }),
                content: (0, $c6rNV.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: 'JiraSoftwarePricingPageV2.features.unlimitedStorage.title',
                defaultMessage: 'Unlimited storage'
            })
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: 'JiraSoftwarePricingPageV2.features.premiumSupport.title',
                    defaultMessage: '24/7 support for critical issues'
                }),
                content: (0, $17uTl.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: 'JiraSoftwarePricingPageV2.features.premiumSla.title',
                defaultMessage: '99.9% uptime SLA'
            })
        }
    ];
    const signupLimit = 100000;
    // planNames should not be translated
    const jswProductPlans = [
        {
            planName: 'Free',
            offeringSku: 'jira-software-free',
            description: intl.formatMessage({
                id: 'JiraSoftwarePricingPageV2.priceFinder.freeDescription',
                defaultMessage: 'Free forever for 10 users'
            }),
            recommendationLimit: 0,
            signupLimit: signupLimit,
            signupURLSuffix: '?bundle=jira-software&edition=free',
            planFeatureMessages: freePlanFeatureMessages
        },
        {
            planName: 'Standard',
            offeringSku: 'jira-software-standard',
            description: intl.formatMessage({
                id: 'JiraSoftwarePricingPageV2.priceFinder.standardDescription',
                defaultMessage: 'Everything you need to get started'
            }),
            recommendationLimit: 10,
            signupLimit: signupLimit,
            signupURLSuffix: '?bundle=jira-software&edition=standard',
            planFeatureMessages: standardPlanFeatureMessages
        },
        {
            planName: 'Premium',
            offeringSku: 'jira-software-premium',
            description: intl.formatMessage({
                id: 'JiraSoftwarePricingPageV2.priceFinder.premiumDescription',
                defaultMessage: 'Align multiple teams'
            }),
            recommendationLimit: 250,
            signupLimit: signupLimit,
            signupURLSuffix: '?bundle=jira-software&edition=premium',
            planFeatureMessages: premiumPlanFeatureMessages
        }
    ];
    const messages = (0, $fnHPc.defineMessages)({
        headerText: {
            id: 'JiraSoftwarePricingPageV2.priceFinder.header',
            defaultMessage: '<blue>Simple, transparent pricing</blue> for every team.'
        },
        unitCountInputText: {
            id: 'JiraSoftwarePricingPage.priceFinder.unitCountInputText',
            defaultMessage: 'How many users are on your team?'
        },
        unitCountInputTextRedesign: {
            id: 'JiraSoftwarePricingPage.priceFinder.unitCountInputTextRedesign',
            defaultMessage: 'Team size:'
        },
        unitCountInputDirectBuy: {
            id: 'JiraSoftwarePricingPage.priceFinder.unitCountInputDirectBuy',
            defaultMessage: "What's your team size?"
        },
        unitCountInputTerm: {
            id: 'JiraSoftwarePricingPage.priceFinder.unitCountInputTerm',
            defaultMessage: 'users'
        },
        billingCycleText: {
            id: 'JiraSoftwarePricingPage.priceFinder.billingCycleText',
            defaultMessage: 'Billing cycle:'
        },
        unitCountInputTooltip: {
            id: 'JiraSoftwarePricingPage.priceFinder.unitCountInputTooltip',
            defaultMessage: 'A Jira Software user is any user who can log in to Jira Software, and who exists in User Management'
        },
        cardOverSignupLimit: {
            id: 'JiraSoftwarePricingPage.priceFinder.cardOverSignupLimit',
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: 'JiraSoftwarePricingPage.priceFinder.cardEnterpriseMinimumCount',
            defaultMessage: 'Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above',
            description: 'Enterprise is a plan name and should not be translated'
        },
        cardUnitCountTierRange: {
            id: 'JiraSoftwarePricingPage.priceFinder.cardUnitCountTierRange',
            defaultMessage: 'User tier: {lowerLimit} - {upperLimit}'
        },
        cardMonthlyPerUnitCount: {
            id: 'JiraSoftwarePricingPageV2.priceFinder.cardMonthlyPerUnitCount',
            defaultMessage: 'per user / month'
        },
        cardFreeDescription: {
            id: 'JiraSoftwarePricingPage.priceFinder.cardFreeDescription',
            defaultMessage: 'Always free for 10 users'
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hCc2m.default), {
        interactionName: 'jira-price-finder',
        fallback: (0, $g9ZvA.LoadingSpinner),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eYlij.PriceFinderContextProvider), {
            productPlans: jswProductPlans,
            dataProductKey: "jiraSoftware",
            defaultUnitCount: 150,
            shouldAddDiscount: props.shouldAddDiscount,
            ctaUrlSource: "productPlans",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gIRO7.default), {
                messages: messages,
                serverSideCCPPricing: props.pricing?.ccpPricingData?.jiraSoftware,
                countryCode: props.countryCode
            })
        })
    });
};
$47b0960c2ef159b2$export$1bf486cdabb14f4d.displayName = 'JiraPriceFinder';

});
parcelRegister("1hGR5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $46f8509b6a94140e$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $46f8509b6a94140e$var$AtlassianIntelligence = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.aiPowered.content.body.v2",
                defaultMessage: "Get more done with AI-powered summaries, generative AI editing, and natural language to build automations or search issues."
            })
        })
    });
};
var $46f8509b6a94140e$export$2e2bcd8739ae039 = $46f8509b6a94140e$var$AtlassianIntelligence;

});

parcelRegister("c6rNV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $39cb99e1093c55f5$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $39cb99e1093c55f5$var$Automations = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.automations.content.body",
                defaultMessage: "Increase efficiency by replacing manual, time-consuming work with automated processes and workflows."
            })
        })
    });
};
var $39cb99e1093c55f5$export$2e2bcd8739ae039 = $39cb99e1093c55f5$var$Automations;

});

parcelRegister("8kuWI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3f8a3492cd08aa6a$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $3f8a3492cd08aa6a$var$Backlog = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.backlogAndTimeline.content.body",
                defaultMessage: "Choose from different views to support your way of working."
            })
        })
    });
};
var $3f8a3492cd08aa6a$export$2e2bcd8739ae039 = $3f8a3492cd08aa6a$var$Backlog;

});

parcelRegister("WOC4s", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $87bc63ad3e80b17b$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $87bc63ad3e80b17b$var$CrossTeamPlanning = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.crossTeamPlanning.content.body",
                defaultMessage: "Plan and track goals, projects, and dependencies in one place."
            })
        })
    });
};
var $87bc63ad3e80b17b$export$2e2bcd8739ae039 = $87bc63ad3e80b17b$var$CrossTeamPlanning;

});

parcelRegister("5Ikga", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $20b6930dc723bc10$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $20b6930dc723bc10$var$CustomizableApprovalProcesses = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.customizableApprovalProcesses.content.body",
                defaultMessage: "Add approval steps to your workflows to get required signoffs."
            })
        })
    });
};
var $20b6930dc723bc10$export$2e2bcd8739ae039 = $20b6930dc723bc10$var$CustomizableApprovalProcesses;

});

parcelRegister("83Gke", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $90529a5f0f2d90d2$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $90529a5f0f2d90d2$var$ExternalCollaboration = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.externalCollaboration.content.body",
                defaultMessage: "Give people outside your org anonymous access to Jira projects."
            })
        })
    });
};
var $90529a5f0f2d90d2$export$2e2bcd8739ae039 = $90529a5f0f2d90d2$var$ExternalCollaboration;

});

parcelRegister("guvAv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b27ff3bd95e80201$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $b27ff3bd95e80201$var$MultiRegionDataResidency = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.multiRegionDataResidency.content.body",
                defaultMessage: "Specify where your content and data are hosted."
            })
        })
    });
};
var $b27ff3bd95e80201$export$2e2bcd8739ae039 = $b27ff3bd95e80201$var$MultiRegionDataResidency;

});

parcelRegister("dBwTO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5e502c2ad812b693$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $5e502c2ad812b693$var$ReportsAndDashboards = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.reportsAndDashboards.content.body",
                defaultMessage: "Get insights on teamwork tracked in any Jira product or project."
            })
        })
    });
};
var $5e502c2ad812b693$export$2e2bcd8739ae039 = $5e502c2ad812b693$var$ReportsAndDashboards;

});

parcelRegister("h2AoW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $305cb22209277d1b$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $305cb22209277d1b$var$CommunitySupport = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.freeCommunitySupport.content.body",
                defaultMessage: "Find answers and support from other Atlassian users."
            })
        })
    });
};
var $305cb22209277d1b$export$2e2bcd8739ae039 = $305cb22209277d1b$var$CommunitySupport;

});

parcelRegister("17uTl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5b772800e5f3090e$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $5b772800e5f3090e$var$PremiumSupport = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.premiumSupport.content.body",
                defaultMessage: "1-hr response time for critical issues from Cloud support team."
            })
        })
    });
};
var $5b772800e5f3090e$export$2e2bcd8739ae039 = $5b772800e5f3090e$var$PremiumSupport;

});

parcelRegister("6w3tN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f3c08a3cece63621$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $f3c08a3cece63621$var$StandardSupport = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.standardSupport.content.body",
                defaultMessage: "2-hr response time for critical issues from Cloud support team."
            })
        })
    });
};
var $f3c08a3cece63621$export$2e2bcd8739ae039 = $f3c08a3cece63621$var$StandardSupport;

});

parcelRegister("8wGxe", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d1cd49baf85eeb35$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $d1cd49baf85eeb35$var$UnlimitedProjects = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.unlimitedProjectBoards.content.body.v2",
                defaultMessage: "Align projects and tasks to goals. Collect data with forms."
            })
        })
    });
};
var $d1cd49baf85eeb35$export$2e2bcd8739ae039 = $d1cd49baf85eeb35$var$UnlimitedProjects;

});

parcelRegister("gl8tX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3027e47bf2c5ff81$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $3027e47bf2c5ff81$var$UserRolesPermissions = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.userRolesPermissions.content.body",
                defaultMessage: "Control what users can create, view, and comment on in Jira."
            })
        })
    });
};
var $3027e47bf2c5ff81$export$2e2bcd8739ae039 = $3027e47bf2c5ff81$var$UserRolesPermissions;

});


parcelRegister("btggB", function(module, exports) {
$parcel$export(module.exports, "getIsGwp10027NonprofitPricingPage", function () { return $6f8d41d4f75a0ee9$export$5669cf21cf977647; });

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
function $6f8d41d4f75a0ee9$export$5669cf21cf977647() {
    return (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp10027NonprofitPricingPage);
}

});

parcelRegister("vCUGX", function(module, exports) {
$parcel$export(module.exports, "NonProfitPricingPageTemplateWithTwc", function () { return $e7c6a76c0fc10e33$export$1e29151fb1d7b783; });

var $7VQPk = parcelRequire("7VQPk");

var $dl2JF = parcelRequire("dl2JF");

var $bE8d4 = parcelRequire("bE8d4");

var $grcEk = parcelRequire("grcEk");

var $jfojT = parcelRequire("jfojT");

var $kbpa7 = parcelRequire("kbpa7");

var $5S2vX = parcelRequire("5S2vX");

var $iTSLe = parcelRequire("iTSLe");

var $g7wmQ = parcelRequire("g7wmQ");

var $fZJZd = parcelRequire("fZJZd");

var $4bEWc = parcelRequire("4bEWc");

var $71t0B = parcelRequire("71t0B");

var $gtK7Z = parcelRequire("gtK7Z");

var $k53CY = parcelRequire("k53CY");

var $lSpoK = parcelRequire("lSpoK");

var $hJy82 = parcelRequire("hJy82");

var $3icmm = parcelRequire("3icmm");
const $e7c6a76c0fc10e33$export$1e29151fb1d7b783 = ()=>{
    const content = (0, $dl2JF.usePricingContentContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
            pageId: "nonprofit-pricing-page",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    nav: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lSpoK.NonprofitNav), {}),
                    banner: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g7wmQ.Banner), {}),
                    hero: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gtK7Z.Hero), {}),
                    hasGlobalFooter: false
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    bgColor: (0, $kbpa7.wacToken)('color.neutral.light100'),
                    hasGlobalFooter: false,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fZJZd.EligibleSection), {})
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    hasGlobalFooter: false,
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k53CY.NonprofitCalculatorHeading), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jfojT.TeamworkCollectionPricingHero), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iTSLe.NonProfitPricingCalculator), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4bEWc.EnterpriseSection), {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    bgColor: (0, $kbpa7.wacToken)('color.extended.blue100'),
                    hasGlobalFooter: false,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hJy82.OfficialSection), {})
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    hasGlobalFooter: false,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3icmm.ResourcesSection), {})
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    hasGlobalFooter: true,
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bE8d4.PricingFaq), {
                                header: content?.getMoreDetailsTitle,
                                planDetails: content?.additionalDetails
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $71t0B.Fineprint), {})
                        ]
                    })
                })
            ]
        })
    });
};

});
parcelRegister("jfojT", function(module, exports) {
$parcel$export(module.exports, "TeamworkCollectionPricingHero", function () { return $e2d3685819b80935$export$11d510446f2a0235; });

var $7VQPk = parcelRequire("7VQPk");

var $e0LCf = parcelRequire("e0LCf");
const $e2d3685819b80935$export$11d510446f2a0235 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e0LCf.CollectionPricingHero), {
        collectionImage: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/wwq35151x13e6200i5xc4qs5r21er0q5.svg',
            alt: 'Teamwork Collection'
        },
        products: [
            {
                name: 'Jira',
                image: {
                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/36a5pi244g3e1j3540td888vgj855s0u/collections-teamwork-jira.svg',
                    alt: 'Jira'
                }
            },
            {
                name: 'Confluence',
                image: {
                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/nj0wofvhj3q26f3vy866q801p5bbw83w/collections-teamwork-confluence.svg',
                    alt: 'Confluence'
                }
            },
            {
                name: 'Loom',
                image: {
                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/138cux5d67t757a2ddy0l833ihe728l8/collections-teamwork-loom.svg',
                    alt: 'Loom'
                }
            },
            {
                name: 'Rovo',
                image: {
                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/bijp0lf52qxqdt3257q0kj73t8d5681g.svg',
                    alt: 'Rovo'
                }
            }
        ]
    });
};

});
parcelRegister("e0LCf", function(module, exports) {
$parcel$export(module.exports, "CollectionPricingHero", function () { return $2a773e3b9098f7a0$export$8065869e82d5a4c7; });
/* collection-pricing-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");

var $8A3gV = parcelRequire("8A3gV");
const $2a773e3b9098f7a0$var$horizontalOrientationCss = null;
const $2a773e3b9098f7a0$var$verticalOrientationCss = null;
const $2a773e3b9098f7a0$var$logoCss = null;
const $2a773e3b9098f7a0$var$verticalLogoCss = null;
const $2a773e3b9098f7a0$var$baseIconStyles = null;
const $2a773e3b9098f7a0$var$fullIconStyles = null;
const $2a773e3b9098f7a0$export$8065869e82d5a4c7 = (props)=>{
    const orientation = props.orientation || 'horizontal';
    const isTeam26EuKeynote = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).team26EuKeynote);
    const messages = (0, $8A3gV.useCollectionPricingHeroMessages)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _1f2ygktf"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1bsb1ns9 _p12fuoas"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _4cvr1h6o _zulppxbi _1yt417la _1lp7vrvc _19wgxy5q _6yttgfpe"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                image: {
                                    src: props.collectionImage.src,
                                    alt: props.collectionImage.alt,
                                    height: props.collectionImage.height,
                                    width: props.collectionImage.width
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _2lx21bp4 _zulp1crf"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    className: (0, $2jatx.default)([
                                        "_ect4z4z1 _1wyb19bv _k48p1nn1 _1p1dangw _syaz1qc2 _vwz47vkz _y3gn1h6o _uj6k18uv"
                                    ]),
                                    style: {
                                        "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                                        "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800'))
                                    },
                                    children: messages.includes
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        orientation === 'horizontal' ? "_1e0c11p5 _yv0efsjm _2z05im57 _zulpxy5q _gy1pxy5q _1p57pxbi _ect41vau _k48p1nn1 _1wyb1wbj" : "_1e0c1txw _2lx21bp4 _zulppxbi"
                                    ]),
                                    style: {
                                        "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                                    },
                                    children: props.products.map((product, key)=>{
                                        return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                            className: (0, $2jatx.default)([
                                                orientation === 'horizontal' ? "_1e0c1txw _4cvr1h6o _zulp12x7 _1bsb1n5l" : "_1e0c1txw _4cvr1h6o _4t3igktf"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                                    image: {
                                                        src: product.image.src,
                                                        alt: product.image.alt
                                                    },
                                                    className: (0, $2jatx.default)([
                                                        "_y4ti1xn6"
                                                    ]),
                                                    style: {
                                                        height: '20px',
                                                        "--_1tc2js6": (0, $6ZVlx.default)(orientation === 'vertical' ? "var(--ds-space-075, 6px)" : 0)
                                                    }
                                                }),
                                                product.name
                                            ]
                                        }, key);
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1bsb1osq _mqm21hma"
                    ]),
                    style: {
                        "--_1hwkv7u": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark1100'))
                    }
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                "_syaz1pfd _1e0c1ule _y3gn1h6o _ect4z4z1 _1wyb7vkz _zg8l4jg8 _k48p1fw0 _vwz41ou6 _1yt4zu5n"
                            ]),
                            style: {
                                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                            },
                            children: messages.heading
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _1bah1h6o"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1n261g80 _1bah1h6o _zulpu2gc _19wgpxbi"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/k383m26br4w8fu6i68s0qbnym881f0wb.svg",
                                        name: messages.home,
                                        alt: messages.home
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/r7k15161ensv07cht48h87c31ueh7sh3.svg",
                                        name: messages.goals,
                                        alt: messages.goals
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/51ht267g50ve2d3051aw8nrgs0k11ad6.svg",
                                        name: messages.teams,
                                        alt: messages.teams
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/2pqaabre17cu7mx66ydvhplnbt4hh3ub.svg",
                                        name: messages.studio,
                                        alt: messages.studio
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/to7s6r4xr4564x6jhc134qhgevi13wo3.svg",
                                        name: messages.search,
                                        alt: messages.search
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/pe661ex05dvkmxul5nf4fi1e20hq8063.svg",
                                        name: messages.chat,
                                        alt: messages.chat
                                    }),
                                    isTeam26EuKeynote ? /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OSGA.svg",
                                        name: 'Insights',
                                        alt: 'Insights',
                                        isFullIcon: true
                                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8f6ta76fw1d04u40k8fp622i67154764.svg",
                                        name: messages.analytics,
                                        alt: messages.analytics
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/dv817l8n01hct543cmd030ksu3hfj0k6.svg",
                                        name: messages.admin,
                                        alt: messages.admin
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $2a773e3b9098f7a0$var$Subproduct = ({ name: name, src: src, alt: alt, isFullIcon: isFullIcon = false })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1b66 _1ul91l27 _1yt41giy"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        !isFullIcon && "_19pkrdoj _2hwxrdoj _otyrrdoj _18u0rdoj _4t3igktf _1bsbgktf",
                        isFullIcon && "_1bsb10mc _4t3i10mc"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                        image: {
                            src: src,
                            alt: alt
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_y3gn1h6o _ect4z4z1 _1wybsm30 _zg8l4jg8 _k48p1nn1 _vwz41crf"
                ]),
                style: {
                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                },
                children: name
            })
        ]
    });
};

});
parcelRegister("8A3gV", function(module, exports) {
$parcel$export(module.exports, "useCollectionPricingHeroMessages", function () { return $6e2ac6bb4e232ff3$export$7c226aa081048b2; });

var $8e22h = parcelRequire("8e22h");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
function $6e2ac6bb4e232ff3$export$7c226aa081048b2() {
    const intl = (0, $8e22h.default)();
    const hardcoded = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp8279CollectionHeroIntl);
    if (hardcoded) return $6e2ac6bb4e232ff3$export$22298271baa6ded9(intl.locale);
    return {
        heading: intl.formatMessage({
            id: 'TeamworkCollectionPricingPageHero.platformAppsHeading',
            defaultMessage: 'Plus all Atlassian Platform Apps'
        }),
        includes: intl.formatMessage({
            id: 'TeamworkCollectionPricingPageHero.includes',
            defaultMessage: 'Includes'
        }),
        home: intl.formatMessage({
            id: 'TeamworkCollectionPricingPageHero.app.home.alt',
            defaultMessage: 'Home'
        }),
        goals: intl.formatMessage({
            id: 'TeamworkCollectionPricingPageHero.app.goals',
            defaultMessage: 'Goals'
        }),
        teams: intl.formatMessage({
            id: 'TeamworkCollectionPricingPageHero.app.teams',
            defaultMessage: 'Teams'
        }),
        studio: intl.formatMessage({
            id: 'TeamworkCollectionPricingPageHero.app.studio',
            defaultMessage: 'Studio'
        }),
        search: intl.formatMessage({
            id: 'TeamworkCollectionPricingPageHero.app.search',
            defaultMessage: 'Search'
        }),
        chat: intl.formatMessage({
            id: 'TeamworkCollectionPricingPageHero.app.chat',
            defaultMessage: 'Chat'
        }),
        analytics: intl.formatMessage({
            id: 'TeamworkCollectionPricingPageHero.app.analytics',
            defaultMessage: 'Analytics'
        }),
        admin: intl.formatMessage({
            id: 'TeamworkCollectionPricingPageHero.app.admin',
            defaultMessage: 'Admin'
        })
    };
}
function $6e2ac6bb4e232ff3$export$22298271baa6ded9(locale) {
    return $6e2ac6bb4e232ff3$var$MESSAGES[locale] ?? $6e2ac6bb4e232ff3$var$enMessages;
}
const $6e2ac6bb4e232ff3$var$enMessages = {
    home: 'Home',
    heading: 'Plus all Atlassian Platform Apps',
    includes: 'Includes',
    goals: 'Goals',
    teams: 'Teams',
    studio: 'Studio',
    search: 'Search',
    chat: 'Chat',
    analytics: 'Analytics',
    admin: 'Admin'
};
const $6e2ac6bb4e232ff3$var$MESSAGES = {
    en: $6e2ac6bb4e232ff3$var$enMessages,
    nl: {
        home: 'Home',
        heading: 'Plus alle Atlassian Platform-apps',
        includes: 'Omvat',
        goals: 'Doelstellingen',
        teams: 'Teams',
        studio: 'Studio',
        search: 'Zoeken',
        chat: 'Chat',
        analytics: 'Analyses',
        admin: 'Beheerder'
    },
    es: {
        home: 'Inicio',
        heading: "Adem\xe1s de todas las aplicaciones de la plataforma de Atlassian",
        includes: 'Incluye',
        goals: 'Objetivos',
        teams: 'Equipos',
        studio: 'Studio',
        search: 'Buscar',
        chat: 'Chat',
        analytics: "An\xe1lisis",
        admin: 'Administrativo'
    },
    ru: {
        home: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F",
        heading: "\u0410 \u0442\u0430\u043A\u0436\u0435 \u0432\u0441\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u044B Atlassian",
        includes: "\u0412\u043A\u043B\u044E\u0447\u0430\u0435\u0442",
        goals: "\u0426\u0435\u043B\u0438",
        teams: "\u041A\u043E\u043C\u0430\u043D\u0434\u044B",
        studio: "\u041C\u0430\u0441\u0442\u0435\u0440\u0441\u043A\u0430\u044F",
        search: "\u041F\u043E\u0438\u0441\u043A",
        chat: "\u0427\u0430\u0442",
        analytics: "\u0410\u043D\u0430\u043B\u0438\u0442\u0438\u043A\u0430",
        admin: "\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440"
    },
    fr: {
        home: 'Accueil',
        heading: 'Et toutes les apps de la plateforme Atlassian',
        includes: "Fonctionnalit\xe9s incluses",
        goals: 'Objectifs',
        teams: "\xc9quipes",
        studio: 'Studio',
        search: 'Recherche',
        chat: 'Chat',
        analytics: 'Analyses',
        admin: 'Administrateur'
    },
    ko: {
        home: "\uD648",
        heading: "\uBC0F \uBAA8\uB4E0 Atlassian \uD50C\uB7AB\uD3FC \uC571",
        includes: "\uD3EC\uD568 \uC0AC\uD56D",
        goals: "\uBAA9\uD45C",
        teams: "\uD300",
        studio: "\uC2A4\uD29C\uB514\uC624",
        search: "\uAC80\uC0C9",
        chat: "\uCC44\uD305",
        analytics: "\uBD84\uC11D",
        admin: "\uAD00\uB9AC\uC790"
    },
    br: {
        home: "In\xedcio",
        heading: "Al\xe9m de todos os apps da plataforma Atlassian",
        includes: 'Inclui',
        goals: 'Metas',
        teams: 'Equipes',
        studio: 'Studio',
        search: 'Pesquisar',
        chat: 'Bate-papo',
        analytics: "Dados de An\xe1lise",
        admin: 'Admin'
    },
    pl: {
        home: "Strona g\u0142\xf3wna",
        heading: 'Plus wszystkie aplikacje platformy Atlassian',
        includes: 'Obejmuje',
        goals: 'Cele',
        teams: "Zespo\u0142y",
        studio: 'Studio',
        search: 'Wyszukiwanie',
        chat: 'Czat',
        analytics: 'Analizy',
        admin: 'Administrator'
    },
    de: {
        home: 'Home',
        heading: 'Plus alle Apps der Atlassian-Plattform',
        includes: 'Beinhaltet',
        goals: 'Ziele',
        teams: 'Teams',
        studio: 'Studio',
        search: 'Suchen',
        chat: 'Chat',
        analytics: 'Analysen',
        admin: 'Administrator'
    },
    zh: {
        home: "\u9996\u9875",
        heading: "\u4EE5\u53CA\u6240\u6709 Atlassian \u5E73\u53F0\u5E94\u7528",
        includes: "\u5305\u62EC",
        goals: "\u76EE\u6807",
        teams: "\u56E2\u961F",
        studio: "\u5DE5\u4F5C\u5BA4",
        search: "\u641C\u7D22",
        chat: "\u804A\u5929",
        analytics: "\u5206\u6790",
        admin: "\u7BA1\u7406\u5458"
    },
    it: {
        home: 'Pagina iniziale',
        heading: 'E tutte le app della piattaforma di Atlassian',
        includes: 'Include',
        goals: 'Obiettivi',
        teams: 'Team',
        studio: 'Studio',
        search: 'Cerca',
        chat: 'Chat',
        analytics: 'Analisi',
        admin: 'Amministratore'
    },
    ja: {
        home: "\u30DB\u30FC\u30E0",
        heading: "\u3055\u3089\u306B\u3059\u3079\u3066\u306E\u30A2\u30C8\u30E9\u30B7\u30A2\u30F3 \u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0 \u30A2\u30D7\u30EA",
        includes: "\u30A4\u30F3\u30AF\u30EB\u30FC\u30C9",
        goals: "\u76EE\u6A19",
        teams: "\u30C1\u30FC\u30E0",
        studio: "\u30B9\u30BF\u30B8\u30AA",
        search: "\u691C\u7D22",
        chat: "\u30C1\u30E3\u30C3\u30C8",
        analytics: "\u5206\u6790\u6A5F\u80FD",
        admin: "\u7BA1\u7406\u8005"
    }
};

});



parcelRegister("iTSLe", function(module, exports) {
$parcel$export(module.exports, "NonProfitPricingCalculator", function () { return $21cae14a7b90ea83$export$5866e8a6e62a7e05; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $9RHgs = parcelRequire("9RHgs");

var $42V1t = parcelRequire("42V1t");

var $5TIjy = parcelRequire("5TIjy");

var $aT8t4 = parcelRequire("aT8t4");

var $fNAVV = parcelRequire("fNAVV");

var $437NE = parcelRequire("437NE");
const $21cae14a7b90ea83$var$DEFAULT_UNIT_COUNT = 25;
const $21cae14a7b90ea83$var$DEFAULT_BILLING_CYCLE = 'ANNUAL';
const $21cae14a7b90ea83$var$FULL_DISCOUNT_MAX_UNITS = 25;
const $21cae14a7b90ea83$export$5866e8a6e62a7e05 = ()=>{
    const { plansDataByProduct: plansDataByProduct, error: error } = (0, $437NE.useNonProfitPricingCalculatorData)();
    const [inputs, setInputs] = (0, $1oC0p.useState)({
        unitCount: $21cae14a7b90ea83$var$DEFAULT_UNIT_COUNT,
        billingCycle: $21cae14a7b90ea83$var$DEFAULT_BILLING_CYCLE
    });
    const getDiscountedPrice = (0, $1oC0p.useCallback)((args)=>{
        const { price: price, inputs: inputs } = args;
        if (inputs.billingCycle === 'ANNUAL' && inputs.unitCount <= $21cae14a7b90ea83$var$FULL_DISCOUNT_MAX_UNITS) return 0;
        return price * 0.25;
    }, []);
    const intl = (0, $8e22h.default)();
    if (error) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $42V1t.ErrorMessage), {});
    if (!plansDataByProduct) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5TIjy.LoadingSpinner), {});
    const fullDiscountBanner = intl.formatMessage({
        id: 'nonprofit.fullDiscountBanner',
        defaultMessage: 'Showing 100% off'
    });
    const partialDiscountBanner = intl.formatMessage({
        id: 'nonprofit.partialDiscountBanner',
        defaultMessage: 'Showing 75% off'
    });
    const partialDiscountWithPromptBanner = intl.formatMessage({
        id: 'nonprofit.partialDiscountWithPromptBanner',
        defaultMessage: 'Showing 75% off - choose Annual billing for 100% off'
    });
    let banner = partialDiscountBanner;
    if (inputs.billingCycle === 'ANNUAL' && inputs.unitCount <= $21cae14a7b90ea83$var$FULL_DISCOUNT_MAX_UNITS) banner = fullDiscountBanner;
    if (inputs.billingCycle === 'MONTHLY') banner = partialDiscountWithPromptBanner;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9RHgs.PricingTabs), {
        banner: banner,
        jiraCalculatorComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aT8t4.default), {
            comparePlansData: plansDataByProduct[(0, $fNAVV.pricingTitleInternal).JIRA] ?? [],
            urlSlug: "jira",
            inputs: inputs,
            onChangeInputs: setInputs,
            getDiscountedPrice: getDiscountedPrice,
            configOverrides: (0, $fNAVV.nonprofitPlanLimitOverrides)[(0, $fNAVV.pricingTitleInternal).JIRA] ? {
                planLimitConfigs: (0, $fNAVV.nonprofitPlanLimitOverrides)[(0, $fNAVV.pricingTitleInternal).JIRA]
            } : undefined
        }),
        confluenceCalculatorComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aT8t4.default), {
            comparePlansData: plansDataByProduct[(0, $fNAVV.pricingTitleInternal).CONFLUENCE] ?? [],
            urlSlug: "confluence",
            inputs: inputs,
            onChangeInputs: setInputs,
            getDiscountedPrice: getDiscountedPrice,
            configOverrides: (0, $fNAVV.nonprofitPlanLimitOverrides)[(0, $fNAVV.pricingTitleInternal).CONFLUENCE] ? {
                planLimitConfigs: (0, $fNAVV.nonprofitPlanLimitOverrides)[(0, $fNAVV.pricingTitleInternal).CONFLUENCE]
            } : undefined
        }),
        teamworkCollectionComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aT8t4.default), {
            comparePlansData: plansDataByProduct[(0, $fNAVV.pricingTitleInternal).TWC] ?? [],
            urlSlug: "teamwork",
            inputs: inputs,
            onChangeInputs: setInputs,
            getDiscountedPrice: getDiscountedPrice
        }),
        loomCalculatorComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aT8t4.default), {
            comparePlansData: plansDataByProduct[(0, $fNAVV.pricingTitleInternal).LOOM] ?? [],
            urlSlug: "loom",
            inputs: inputs,
            onChangeInputs: setInputs,
            getDiscountedPrice: getDiscountedPrice
        })
    });
};

});
parcelRegister("42V1t", function(module, exports) {
$parcel$export(module.exports, "ErrorMessage", function () { return $92139e655263218b$export$915e9e7bd4f0f96d; });
/* error-message.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");
const $92139e655263218b$export$915e9e7bd4f0f96d = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _4t3i1ogm _4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            role: "alert",
            "aria-label": intl.formatMessage({
                id: 'pricing-calculator.error',
                defaultMessage: 'Error'
            }),
            "data-testid": "global-nav-user-profile-container-spinner",
            children: "ERROR"
        })
    });
};

});

parcelRegister("5TIjy", function(module, exports) {
$parcel$export(module.exports, "LoadingSpinner", function () { return $5e560a7364105b43$export$b08b517936747730; });
/* spinner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $7qFQI = parcelRequire("7qFQI");
const $5e560a7364105b43$export$b08b517936747730 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _4t3i1ogm _4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            role: "alert",
            "aria-label": intl.formatMessage({
                id: 'pricing-calculator.loading',
                defaultMessage: 'Loading'
            }),
            "data-testid": "global-nav-user-profile-container-spinner",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7qFQI.default), {})
        })
    });
};

});

parcelRegister("aT8t4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $779847b443bf05b9$export$2e2bcd8739ae039; });
/* price-calculator.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $4G0xh = parcelRequire("4G0xh");

var $kbpa7 = parcelRequire("kbpa7");

var $8bW04 = parcelRequire("8bW04");

var $iHcWb = parcelRequire("iHcWb");

var $gJe05 = parcelRequire("gJe05");

var $44bDI = parcelRequire("44bDI");

var $MgH7i = parcelRequire("MgH7i");

var $5TIjy = parcelRequire("5TIjy");

var $lc7EO = parcelRequire("lc7EO");

var $fEBe5 = parcelRequire("fEBe5");

var $aLva8 = parcelRequire("aLva8");

var $fhn1A = parcelRequire("fhn1A");

var $9evy5 = parcelRequire("9evy5");

var $juRep = parcelRequire("juRep");
const $779847b443bf05b9$var$RecommendationTracker = ({ plan: plan, index: index, onRecommendedChange: onRecommendedChange })=>{
    const state = (0, $gJe05.useCalculationState)({
        offeringSku: plan.fields.sku
    });
    (0, $1oC0p.useEffect)(()=>{
        onRecommendedChange(index, state.recommended);
    }, [
        index,
        state.recommended,
        onRecommendedChange
    ]);
    return null;
};
const $779847b443bf05b9$var$PricingCalculatorContent = ({ comparePlansData: comparePlansData, urlSlug: urlSlug, selectedCardIndex: selectedCardIndex, setSelectedCardIndex: setSelectedCardIndex, disclaimer: disclaimer, omitInputs: omitInputs, numSections: numSections })=>{
    const intl = (0, $8e22h.default)();
    const handleRecommendedChange = (0, $1oC0p.useCallback)((index, isRecommended)=>{
        if (isRecommended) setSelectedCardIndex(index);
    }, [
        setSelectedCardIndex
    ]);
    const unitsLabel = $779847b443bf05b9$var$useUnitsLabel(comparePlansData);
    const dwellTimeAttributes = (0, $iHcWb.useDwellTimeElementAttributes)({
        id: 'pricing-calculator'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ...dwellTimeAttributes,
        className: (0, $2jatx.default)([
            "_1bsb1osq _1e0c1txw _2lx21bp4 _4cvr1h6o"
        ]),
        children: [
            comparePlansData.length > 1 && comparePlansData.map((planData, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)($779847b443bf05b9$var$RecommendationTracker, {
                    plan: planData,
                    index: index,
                    onRecommendedChange: handleRecommendedChange
                }, `tracker-${planData.fields.sku}`)),
            !omitInputs && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $MgH7i.PricingCalculatorInputs), {
                unitCountLabel: intl.formatMessage($9evy5.units.teamSizePrompt),
                unitsLabel: unitsLabel,
                dataProductKey: (0, $4G0xh.urlSlugToDataProductKey)[urlSlug]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8bW04.PricingCards), {
                // must set the number of sections here if removing the bottom section
                // could also infer this from planData's getFeaturesList(fields.highlightedFeaturesContainer)
                numSections: numSections,
                selectedCardIndex: selectedCardIndex ? selectedCardIndex + 1 : 1,
                children: comparePlansData.map((planData, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $juRep.PricingCalculatorCard), {
                        showBannerText: comparePlansData.length > 1,
                        planData: planData,
                        urlSlug: urlSlug,
                        index: index,
                        isSingleCard: comparePlansData.length === 1
                    }, planData.fields.sku))
            }),
            disclaimer && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: (0, $2jatx.default)([
                        "_p12frdnh _k48p1nn1 _vwz4gktf _1wybdlk8 _syaz1pfd _1yt4utpp _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                    ]),
                    style: {
                        "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                    },
                    children: disclaimer
                })
            })
        ]
    });
};
const $779847b443bf05b9$var$disclaimerContainerCss = null;
const $779847b443bf05b9$var$disclaimerCss = null;
const $779847b443bf05b9$var$DEFAULT_SELECTED_CARD_INDEX = 2;
const $779847b443bf05b9$var$UniformPricingCalculator = (props)=>{
    const { urlSlug: urlSlug, disclaimer: disclaimer, inputs: inputs, onChangeInputs: onChangeInputs, getDiscountedPrice: getDiscountedPrice, comparePlansData: comparePlansData, configOverrides: configOverrides } = props;
    // GWP-10907: JPD-specific decision (urlSlug + FF) about whether to strip
    // each plan's `highlightedFeaturesContainer` BEFORE we compute
    // `numSections` and render any cards. The hook itself owns the JPD-only
    // `urlSlug === "product-discovery"` check, so this shared calculator no
    // longer has to know about JPD product semantics. For every non-JPD
    // product the hook returns `false` and the sanitizer is a no-op.
    const shouldStripJpdHighlightedFeatures = (0, $lc7EO.useShouldStripJpdHighlightedFeatures)(urlSlug);
    const [selectedCardIndex, setSelectedCardIndex] = (0, $1oC0p.useState)($779847b443bf05b9$var$DEFAULT_SELECTED_CARD_INDEX);
    const providerResult = (0, $fhn1A.useProviderProps)({
        plans: comparePlansData,
        product: urlSlug,
        inputValues: inputs
    });
    if (providerResult.status === 'pending') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5TIjy.LoadingSpinner), {});
    if (providerResult.status === 'error') return null; // todo: fire an event @bsparks GWP-6943
    if (providerResult.status !== 'ready') return null; // this should never happen due to checks above, but fixes type error
    const { config: baseConfig, inputValues: inputValues } = providerResult.props;
    // Apply configOverrides if provided (e.g., for nonprofit custom recommendation limits)
    const config = configOverrides ? {
        ...baseConfig,
        ...configOverrides
    } : baseConfig;
    // Resilience guard: drop any plan whose SKU is not represented in the
    // code-side `planLimitConfigs`. Downstream selectors (e.g.
    // `getPlanLimitConfig` in selectors.ts) throw on unknown SKUs, which
    // would crash the entire pricing page via the error boundary. This
    // lets CMS authors stage a new plan/SKU in Contentful before the
    // corresponding code-side limit config exists, without breaking the
    // live page. Once a `planLimitConfigs` entry is added for the SKU the
    // plan will start rendering automatically.
    //
    // For JPD this is also the mechanism that gates the new Enterprise
    // SKU rollout (GWP-10907): when the feature flag is off,
    // `useJpdPlanLimitConfigs()` (in `mappings.ts`) excludes the
    // Enterprise entry, so this guard automatically filters the matching
    // CMS plan out.
    const knownSkus = new Set(config.planLimitConfigs.map((plan)=>plan.offeringSku));
    const skippedSkus = comparePlansData.filter((plan)=>!knownSkus.has(plan.fields.sku)).map((plan)=>plan.fields.sku);
    if (skippedSkus.length > 0) // eslint-disable-next-line no-console
    console.warn(`[UniformPricingCalculator] Skipping plan(s) with SKUs not present in planLimitConfigs for "${urlSlug}": ${skippedSkus.join(', ')}. Add them to the corresponding *.pricing-calculator-config.ts to render.`);
    // Drop unknown SKUs first (resilience guard above), then — for JPD with
    // the highlighted-features FF off — strip the per-card highlighted-
    // features content via the JPD-owned sanitizer. For every non-JPD
    // product `shouldStripJpdHighlightedFeatures` is `false`, so the
    // `stripJpdHighlightedFeatures` call is skipped entirely and the
    // filtered `comparePlansData` flows through unchanged.
    const filteredComparePlansData = comparePlansData.filter((plan)=>knownSkus.has(plan.fields.sku));
    const sanitizedComparePlansData = shouldStripJpdHighlightedFeatures ? (0, $lc7EO.stripJpdHighlightedFeatures)(filteredComparePlansData) : filteredComparePlansData;
    const numSections = (0, $44bDI.getFeaturesList)(sanitizedComparePlansData?.[0]?.fields?.highlightedFeaturesContainer) === undefined ? 1 : 2;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aLva8.PricingCalculatorContextProvider), {
        config: config,
        inputValues: inputValues,
        onChangeInputs: onChangeInputs,
        getDiscountedPrice: getDiscountedPrice,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($779847b443bf05b9$var$PricingCalculatorContent, {
            comparePlansData: sanitizedComparePlansData,
            urlSlug: urlSlug,
            selectedCardIndex: selectedCardIndex,
            setSelectedCardIndex: setSelectedCardIndex,
            disclaimer: disclaimer,
            numSections: numSections,
            omitInputs: !config.billingCycleConfig.monthly && !config.billingCycleConfig.annual
        })
    });
};
var $779847b443bf05b9$export$2e2bcd8739ae039 = $779847b443bf05b9$var$UniformPricingCalculator;
function $779847b443bf05b9$var$useUnitsLabel(comparePlansData) {
    const intl = (0, $8e22h.default)();
    const hasAgents = comparePlansData.some((plan)=>{
        return [
            (0, $fEBe5.serviceCollectionOfferingSkus).free,
            (0, $fEBe5.serviceCollectionOfferingSkus).standard,
            (0, $fEBe5.serviceCollectionOfferingSkus).premium,
            (0, $fEBe5.serviceCollectionOfferingSkus).enterprise
        ].includes(plan.fields.sku);
    });
    if (hasAgents) return intl.formatMessage($9evy5.units.agentsUnitsLabel);
    return intl.formatMessage($9evy5.units.usersUnitsLabel);
}

});
parcelRegister("4G0xh", function(module, exports) {
$parcel$export(module.exports, "urlSlugToDataProductKey", function () { return $ceccdba2041bfa64$export$9c59efe722f16a54; });
const $ceccdba2041bfa64$export$e36fc9e5c75fc113 = 'jiraSoftware';
const $ceccdba2041bfa64$export$b65b36d21c9a62a9 = 'confluence';
const $ceccdba2041bfa64$export$b24966420407028a = 'strategyCollection';
const $ceccdba2041bfa64$export$46061d552ba374f4 = 'teamworkCollection';
const $ceccdba2041bfa64$export$e7e2043098922532 = 'compass';
const $ceccdba2041bfa64$export$6648fdba742bde2c = 'serviceCollection';
const $ceccdba2041bfa64$export$b3fce742f95b2633 = 'atlassianGuard';
const $ceccdba2041bfa64$export$9c59efe722f16a54 = {
    jira: $ceccdba2041bfa64$export$e36fc9e5c75fc113,
    confluence: $ceccdba2041bfa64$export$b65b36d21c9a62a9,
    strategy: $ceccdba2041bfa64$export$b24966420407028a,
    teamwork: $ceccdba2041bfa64$export$46061d552ba374f4,
    compass: $ceccdba2041bfa64$export$e7e2043098922532,
    service: $ceccdba2041bfa64$export$6648fdba742bde2c,
    guard: $ceccdba2041bfa64$export$b3fce742f95b2633
};

});

parcelRegister("8bW04", function(module, exports) {
$parcel$export(module.exports, "PricingCards", function () { return $6b8bae1d092d0de9$export$eb5ade451900e238; });
/* pricing-cards.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $6b8bae1d092d0de9$export$eb5ade451900e238 = (props)=>{
    const { selectedCardIndex: selectedCardIndex, children: children, numSections: numSections = 2, hasCalloutSlot: hasCalloutSlot, hasRangeSlot: hasRangeSlot, hasLinkSlot: hasLinkSlot, hasBannerSlot: hasBannerSlot } = props;
    const numberOfChildren = (0, $1oC0p.Children).count(children);
    const getBorderProps = (childIndex, numSections)=>{
        if (numSections !== 1) return {};
        const isFirstChild = childIndex === 1;
        const isLastChild = childIndex === numberOfChildren;
        return {
            topSectionStyle: {
                borderStartEndRadius: isFirstChild ? '0' : undefined,
                borderEndEndRadius: isFirstChild ? '0px' : undefined,
                borderStartStartRadius: isLastChild ? '0' : undefined,
                borderEndStartRadius: isLastChild ? '0px' : undefined
            }
        };
    };
    const getSelectedBorderProps = (childIndex)=>{
        if (selectedCardIndex === undefined || selectedCardIndex !== childIndex) return {};
        const isFirstChild = childIndex === 1;
        const isLastChild = childIndex === numberOfChildren;
        const blackBorder = `1px solid ${(0, $kbpa7.wacToken)('color.primary.black')}`;
        return {
            topSectionStyle: {
                borderInlineEnd: blackBorder,
                borderInlineStart: blackBorder,
                borderBlockStart: blackBorder,
                borderLeftRadius: '10px',
                borderTopRightRadius: numSections === 1 && isLastChild ? '20px' : undefined,
                borderBottomLeftRadius: numSections === 1 && isLastChild ? '0px' : undefined,
                borderBottomRightRadius: numSections === 1 && isFirstChild ? '0px' : undefined,
                borderRadius: numSections === 1 && !isFirstChild && !isLastChild ? `0px` : undefined,
                borderBottom: numSections === 1 ? blackBorder : undefined
            },
            bottomSectionStyle: {
                borderInlineEnd: blackBorder,
                borderInlineStart: blackBorder,
                borderBlockEnd: blackBorder
            }
        };
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_2z054em0 _yv0e1579 _1e0c11p5 _wij21bp4 _1bsb1ns9 _ca0q1crf _u5f31crf _n3td1crf _19bv1crf _glte1ns9 _1ao8kze7 _37tx1hz7 _11nh1hz7 _157nkze7 _1r9zkze7 _qrtggktf _bzkj1o2v _bi301wxo _x3301o2v _1x3d1wxo _1q1tkze7 _qcje1wxo _14bpgktf _uedhpqof _sqhgkze7 _1bs9gktf _1o36gktf _r0rakze7 _23ugkze7 _4ezvkze7",
            numSections !== 1 && "_1aqcftgi",
            "_1mjb1txw _na0i1bp4 _1s4p1osq _1a7ngktf _1xwygktf _9h3lkze7 _9rrkkze7 _18xwkze7",
            numSections === 1 && "_pmhu1txs _ukazftgi _i370kze7 _1635kze7"
        ]),
        style: {
            "--_wcq253": (0, $6ZVlx.default)(numSections),
            "--_1j6te2o": (0, $6ZVlx.default)(numberOfChildren),
            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400')),
            "--_kx26wc": (0, $6ZVlx.default)(numSections === 1 ? `1px solid ${(0, $kbpa7.wacToken)('color.neutral.light400')}` : undefined),
            "--_pkeca6": (0, $6ZVlx.default)(numSections === 1 ? '0px' : '20px'),
            "--_1gzfxjx": (0, $6ZVlx.default)(numSections === 1 ? '0px' : undefined),
            "--_y7p57n": (0, $6ZVlx.default)(numSections === 1 ? '20px' : undefined)
        },
        children: (0, $1oC0p.Children).map(children, (child, index)=>{
            if (!child) return null;
            return /*#__PURE__*/ (0, $1oC0p.cloneElement)(child, {
                key: index,
                hasCalloutSlot: hasCalloutSlot,
                hasRangeSlot: hasRangeSlot,
                hasLinkSlot: hasLinkSlot,
                hasBannerSlot: hasBannerSlot,
                ...index + 1 === selectedCardIndex ? getSelectedBorderProps(index + 1) : getBorderProps(index + 1, numSections)
            });
        })
    });
};

});

parcelRegister("iHcWb", function(module, exports) {
$parcel$export(module.exports, "useDwellTimeElementAttributes", function () { return $7c1ee2bf8ba3e9b8$export$b0b11b3d5fa9707f; });

var $1oC0p = parcelRequire("1oC0p");

var $hfydu = parcelRequire("hfydu");
function $7c1ee2bf8ba3e9b8$export$b0b11b3d5fa9707f({ id: id }) {
    const context = (0, $1oC0p.useContext)((0, $hfydu.DwellTimeContext));
    return context?.enabled ? {
        'data-dwell-id': id
    } : {};
}

});
parcelRegister("hfydu", function(module, exports) {
$parcel$export(module.exports, "DwellTimeContext", function () { return $a244796123281e74$export$823a77756167cdd0; });
$parcel$export(module.exports, "DwellTimeContextProvider", function () { return $a244796123281e74$export$f8e52a5bfd9c0a72; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");

var $aj5Hv = parcelRequire("aj5Hv");

var $jiOui = parcelRequire("jiOui");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $g5vAg = parcelRequire("g5vAg");

var $42SNp = parcelRequire("42SNp");
const $a244796123281e74$export$823a77756167cdd0 = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
// Emit boundaries (seconds): 2, 3, 5, 5, 5, 10 → cumulative 2, 5, 10, 15, 20, 30s.
// Final value repeats indefinitely.
const $a244796123281e74$var$DEFAULT_DWELL_INTERVAL_SCHEDULE = {
    intervals: [
        2,
        3,
        5,
        5,
        5,
        10
    ]
};
const $a244796123281e74$export$f8e52a5bfd9c0a72 = (props)=>{
    const { enabled: enabledProp, schedule: schedule = $a244796123281e74$var$DEFAULT_DWELL_INTERVAL_SCHEDULE, idleTimeoutSeconds: idleTimeoutSeconds, trackability: trackability, onEmit: onEmitOverride, children: children } = props;
    const enabledGate = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).wacDwellTimeTracking);
    // Dwell tracking only runs on routes explicitly whitelisted in the
    // `dwell-time-enabled-routes` dynamic config. Empty/missing allowlist =>
    // no routes emit (opt-in). The current route is derived via `parseRoute`
    // (locale-stripped, leading-slash) — the same canonical page path used by
    // the other WAC route-list configs in `resolve-page-props.ts`, so the
    // whitelist keys off the same path GASv3/metrics report. Whitelist entries
    // support `/*` glob suffixes (e.g. `/software/jira/*`).
    // Config: https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/dwell-time-enabled-routes
    const enabledRoutes = (0, $jiOui.getDynamicConfig)({
        config: (0, $aj5Hv.dynamicConfigManifest).dwellTimeEnabledRoutes,
        defaultValue: []
    });
    const isRouteEnabled = (0, $g5vAg.isRouteInPatternList)(enabledRoutes);
    const enabled = enabledProp && enabledGate && isRouteEnabled;
    const value = (0, $1oC0p.useMemo)(()=>({
            enabled: enabled
        }), [
        enabled
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const defaultOnEmit = (0, $1oC0p.useCallback)((payload)=>{
        const path = typeof window !== 'undefined' ? window.location.pathname : 'unknown';
        createAnalyticsEvent({
            name: 'dwellTimeIntervalElapsed',
            actionSubject: 'dwellTimeInterval',
            action: 'elapsed',
            eventType: 'track',
            source: path,
            attributes: {
                sessionId: payload.sessionId,
                sessionStartedAt: payload.sessionStartedAt,
                intervalEndedAt: payload.intervalEndedAt,
                stepIndex: payload.stepIndex,
                durations: payload.durations,
                path: path
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onEmit = onEmitOverride ?? defaultOnEmit;
    const onEmitRef = (0, $1oC0p.useRef)(onEmit);
    onEmitRef.current = onEmit;
    (0, $1oC0p.useEffect)(()=>{
        if (!enabled) return undefined;
        const tracker = new (0, $42SNp.DwellTracker)({
            schedule: schedule,
            idleTimeoutSeconds: idleTimeoutSeconds,
            trackability: trackability,
            onEmit: (payload)=>onEmitRef.current(payload)
        });
        tracker.start();
        return ()=>tracker.stop();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- non-`enabled` options are intentionally captured once.
    }, [
        enabled
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($a244796123281e74$export$823a77756167cdd0.Provider, {
        value: value,
        children: children
    });
};

});
parcelRegister("g5vAg", function(module, exports) {
$parcel$export(module.exports, "isRouteInPatternList", function () { return $4fa59628fab8c2ff$export$e4d60b2209adab32; });

var $hu7gH = parcelRequire("hu7gH");
const $4fa59628fab8c2ff$export$7bbf819073319b08 = (route, pattern)=>{
    if (pattern.endsWith('/*')) {
        const prefix = pattern.slice(0, -2);
        return route === prefix || route.startsWith(`${prefix}/`);
    }
    return route === pattern;
};
const $4fa59628fab8c2ff$export$4df88a88032fa293 = (location)=>{
    const resolvedLocation = location ?? (typeof globalThis !== 'undefined' ? globalThis.location : undefined);
    if (!resolvedLocation) return '';
    return `/${(0, $hu7gH.parseRoute)(resolvedLocation).path}`;
};
const $4fa59628fab8c2ff$export$e4d60b2209adab32 = (patterns, location)=>{
    const route = $4fa59628fab8c2ff$export$4df88a88032fa293(location);
    if (!route) return false;
    return patterns.some((pattern)=>$4fa59628fab8c2ff$export$7bbf819073319b08(route, pattern));
};

});

parcelRegister("42SNp", function(module, exports) {
$parcel$export(module.exports, "DwellTracker", function () { return $e05ccb7bf12f0466$export$b52d12393c27b8c2; });

var $h8tqd = parcelRequire("h8tqd");

var $1awGg = parcelRequire("1awGg");

var $jJju2 = parcelRequire("jJju2");

var $g14wK = parcelRequire("g14wK");

var $76bMJ = parcelRequire("76bMJ");

var $3yqd8 = parcelRequire("3yqd8");

var $2AizJ = parcelRequire("2AizJ");

var $9XWaQ = parcelRequire("9XWaQ");

var $jewWt = parcelRequire("jewWt");

var $cyd5Y = parcelRequire("cyd5Y");

var $kxdeC = parcelRequire("kxdeC");

var $dfN1H = parcelRequire("dfN1H");
const $e05ccb7bf12f0466$var$DEFAULT_IDLE_TIMEOUT_SECONDS = 60;
const $e05ccb7bf12f0466$var$defaultClock = ()=>Date.now();
class $e05ccb7bf12f0466$export$b52d12393c27b8c2 {
    constructor(options){
        this.spansCache = (0, $2AizJ.createElementDwellSpansCache)();
        this.sessionState = (0, $kxdeC.createDwellSessionState)();
        this.cursor = (0, $cyd5Y.createIntervalScheduleCursor)();
        this.idleState = (0, $jewWt.createIdleState)();
        this.trackerRunning = false;
        this.start = ()=>{
            if (this.trackerRunning) return;
            this.trackerRunning = true;
            this.domObserver.start();
            this.activityListener.start();
            this.browserLifecycle.start();
            this.idlePoller.start();
            this.openSession();
        };
        this.stop = ()=>{
            if (!this.trackerRunning) return;
            this.trackerRunning = false;
            this.closeSession();
            this.domObserver.stop();
            this.activityListener.stop();
            this.browserLifecycle.stop();
            this.idlePoller.stop();
        };
        this.openSession = ()=>{
            if ((0, $kxdeC.isDwellSessionActive)(this.sessionState)) return;
            const now = this.clock();
            (0, $kxdeC.startDwellSession)(this.sessionState, this.generateId(), now);
            (0, $cyd5Y.resetIntervalScheduleCursor)(this.cursor);
            (0, $jewWt.recordActivity)(this.idleState, now);
            // Rebase any spans that are still active from a previous session so
            // their entrance timestamps start at this session's opening moment.
            // Without this, the first interval would emit the full time-since-
            // last-close, including any idle/away gap.
            (0, $2AizJ.rolloverActiveElementDwellSpans)(this.spansCache, now);
            this.intervalLoop = new (0, $76bMJ.IntervalLoop)(this.schedule, this.cursor, (stepIndex)=>{
                const intervalEndedAt = this.clock();
                this.flushEmit(intervalEndedAt, stepIndex);
                (0, $2AizJ.rolloverActiveElementDwellSpans)(this.spansCache, intervalEndedAt);
            });
            this.intervalLoop.start();
        };
        this.closeSession = ()=>{
            if (!(0, $kxdeC.isDwellSessionActive)(this.sessionState)) return;
            const intervalEndedAt = this.clock();
            this.flushEmit(intervalEndedAt, this.cursor.stepIndex);
            this.intervalLoop?.stop();
            this.intervalLoop = undefined;
            (0, $kxdeC.endDwellSession)(this.sessionState);
            // Leave active spans alone — they'll be rebased when (if) a new
            // session opens. Drop completed spans now since they've been emitted.
            this.spansCache.completed = [];
            (0, $cyd5Y.resetIntervalScheduleCursor)(this.cursor);
        };
        this.handleSessionEnd = ()=>this.closeSession();
        this.handleSessionRestart = ()=>this.openSession();
        this.flushEmit = (intervalEndedAt, stepIndex)=>{
            const payload = (0, $9XWaQ.getEmitPayload)(this.sessionState, this.spansCache, intervalEndedAt, stepIndex);
            if (payload === null) return;
            try {
                this.onEmit(payload);
            } catch (err) {
                console.error('[dwell-time] emit handler threw:', err);
            }
        };
        this.schedule = options.schedule;
        this.onEmit = options.onEmit;
        this.clock = options.clock ?? $e05ccb7bf12f0466$var$defaultClock;
        this.generateId = options.generateId ?? (0, $dfN1H.generateSessionId);
        this.idleTimeoutSeconds = options.idleTimeoutSeconds ?? $e05ccb7bf12f0466$var$DEFAULT_IDLE_TIMEOUT_SECONDS;
        this.trackability = $e05ccb7bf12f0466$var$normalizeTrackability(options.trackability);
        // Construct the persistent effects eagerly. Each one is inert until
        // its `start` is called from `tracker.start()`.
        this.domObserver = new (0, $jJju2.DomObserver)(this.spansCache, this.trackability, this.clock);
        this.activityListener = new (0, $h8tqd.ActivityListener)(this.idleState, this.clock);
        this.browserLifecycle = new (0, $1awGg.BrowserLifecycleListeners)({
            onSessionEnd: this.handleSessionEnd,
            onSessionRestart: this.handleSessionRestart
        });
        this.idlePoller = new (0, $g14wK.IdlePoller)(this.idleState, {
            idleTimeoutMs: this.idleTimeoutSeconds * 1000,
            pollIntervalMs: options.idlePollerIntervalMs,
            clock: this.clock,
            onIdle: ()=>this.closeSession(),
            onActive: ()=>this.openSession()
        });
    }
}
function $e05ccb7bf12f0466$var$normalizeTrackability(trackability) {
    if (trackability === undefined) return [
        (0, $3yqd8.defaultTrackability)
    ];
    return Array.isArray(trackability) ? trackability : [
        trackability
    ];
}

});
parcelRegister("h8tqd", function(module, exports) {
$parcel$export(module.exports, "ActivityListener", function () { return $2a16eb342dbac022$export$653a82d4e3c8af65; });

var $jewWt = parcelRequire("jewWt");
const $2a16eb342dbac022$var$ACTIVITY_EVENTS = [
    'pointermove',
    'mousemove',
    'keydown',
    'scroll',
    'click',
    'pointerdown'
];
class $2a16eb342dbac022$export$653a82d4e3c8af65 {
    constructor(state, clock){
        this.started = false;
        this.start = ()=>{
            if (this.started) return;
            if (typeof document === 'undefined') {
                this.started = true;
                return;
            }
            this.started = true;
            this.handleActivity = ()=>{
                (0, $jewWt.recordActivity)(this.state, this.clock());
            };
            const handler = this.handleActivity;
            $2a16eb342dbac022$var$ACTIVITY_EVENTS.forEach((evt)=>{
                document.addEventListener(evt, handler, {
                    passive: true
                });
            });
        };
        this.stop = ()=>{
            if (!this.started) return;
            this.started = false;
            const handler = this.handleActivity;
            if (handler !== undefined) {
                $2a16eb342dbac022$var$ACTIVITY_EVENTS.forEach((evt)=>{
                    document.removeEventListener(evt, handler);
                });
                this.handleActivity = undefined;
            }
        };
        this.state = state;
        this.clock = clock;
    }
}

});
parcelRegister("jewWt", function(module, exports) {
$parcel$export(module.exports, "createIdleState", function () { return $73fd652edb98a7a1$export$1272f3ff7e83e1a2; });
$parcel$export(module.exports, "recordActivity", function () { return $73fd652edb98a7a1$export$9addc862983bb20b; });
$parcel$export(module.exports, "updateIdleStateAt", function () { return $73fd652edb98a7a1$export$4e0d7bb1ad57dcdb; });
function $73fd652edb98a7a1$export$1272f3ff7e83e1a2() {
    return {
        lastActivityAt: null,
        isIdle: false
    };
}
function $73fd652edb98a7a1$export$9addc862983bb20b(state, timestamp) {
    state.lastActivityAt = timestamp;
    state.isIdle = false;
}
function $73fd652edb98a7a1$export$d9d1ca76cbd41137(state, now, idleTimeoutMs) {
    if (state.lastActivityAt === null) return false;
    return now - state.lastActivityAt >= idleTimeoutMs;
}
function $73fd652edb98a7a1$export$4e0d7bb1ad57dcdb(state, now, idleTimeoutMs) {
    state.isIdle = $73fd652edb98a7a1$export$d9d1ca76cbd41137(state, now, idleTimeoutMs);
    return state.isIdle;
}
function $73fd652edb98a7a1$export$39a275e858742288(state) {
    state.lastActivityAt = null;
    state.isIdle = false;
}

});


parcelRegister("1awGg", function(module, exports) {
$parcel$export(module.exports, "BrowserLifecycleListeners", function () { return $44f23eed445fb4b5$export$5a070be5ed0156f6; });
const $44f23eed445fb4b5$var$SESSION_END_WIN_EVENTS = [
    'pagehide',
    'beforeunload',
    'unload'
];
const $44f23eed445fb4b5$var$SESSION_RESTART_WIN_EVENTS = [
    'pageshow',
    'focus'
];
class $44f23eed445fb4b5$export$5a070be5ed0156f6 {
    constructor(handlers){
        this.started = false;
        this.teardown = [];
        this.start = ()=>{
            if (this.started) return;
            if (typeof document === 'undefined' || typeof window === 'undefined') {
                this.started = true;
                return;
            }
            this.started = true;
            // Single visibilitychange listener that dispatches to the appropriate
            // callback based on the current visibilityState.
            const handleVisibility = ()=>{
                if (document.visibilityState === 'hidden') this.handlers.onSessionEnd('visibilitychange');
                else if (document.visibilityState === 'visible') this.handlers.onSessionRestart('visibilitychange');
            };
            document.addEventListener('visibilitychange', handleVisibility);
            this.teardown.push(()=>document.removeEventListener('visibilitychange', handleVisibility));
            $44f23eed445fb4b5$var$SESSION_END_WIN_EVENTS.forEach((evt)=>{
                const handler = ()=>this.handlers.onSessionEnd(evt);
                window.addEventListener(evt, handler);
                this.teardown.push(()=>window.removeEventListener(evt, handler));
            });
            // `blur` fires for many non-session-ending reasons (iframe focus, native
            // dropdowns, alert/print dialogs). Defer one microtask and confirm the
            // window genuinely lost focus before treating it as a session end.
            const handleBlur = (event)=>{
                if (event.target !== window) return;
                queueMicrotask(()=>{
                    if (!document.hasFocus()) this.handlers.onSessionEnd('blur');
                });
            };
            window.addEventListener('blur', handleBlur);
            this.teardown.push(()=>window.removeEventListener('blur', handleBlur));
            $44f23eed445fb4b5$var$SESSION_RESTART_WIN_EVENTS.forEach((evt)=>{
                const handler = ()=>this.handlers.onSessionRestart(evt);
                window.addEventListener(evt, handler);
                this.teardown.push(()=>window.removeEventListener(evt, handler));
            });
        };
        this.stop = ()=>{
            if (!this.started) return;
            this.started = false;
            this.teardown.forEach((off)=>off());
            this.teardown = [];
        };
        this.handlers = handlers;
    }
}

});

parcelRegister("jJju2", function(module, exports) {
$parcel$export(module.exports, "DomObserver", function () { return $403152b531bdd98a$export$1799337af8e4206c; });

var $2AizJ = parcelRequire("2AizJ");
const $403152b531bdd98a$var$FALLBACK_INTERSECTION_THRESHOLD = 0.5;
class $403152b531bdd98a$export$1799337af8e4206c {
    constructor(cache, trackables, clock){
        this.started = false;
        this.start = ()=>{
            if (this.started) return;
            if (typeof document === 'undefined' || document.body === null || typeof IntersectionObserver === 'undefined' || this.trackables.length === 0) {
                this.started = true;
                return;
            }
            this.started = true;
            this.observedElements = new WeakSet();
            this.observersByThreshold = new Map();
            const getOrCreateObserver = (threshold)=>{
                const existing = this.observersByThreshold?.get(threshold);
                if (existing !== undefined) return existing;
                const observer = new IntersectionObserver((entries)=>{
                    entries.forEach((entry)=>{
                        const elementKey = this.resolveKey(entry.target);
                        if (!elementKey) return;
                        const inView = entry.isIntersecting && entry.intersectionRatio >= threshold && $403152b531bdd98a$var$isElementVisuallyPresent(entry.target);
                        if (inView) (0, $2AizJ.startElementDwellSpan)(this.cache, elementKey, this.clock());
                        else (0, $2AizJ.endElementDwellSpan)(this.cache, elementKey, this.clock());
                    });
                }, {
                    threshold: threshold
                });
                // Guard against a race where stop() ran between constructing the
                // observer and registering it. If the map is gone, disconnect
                // immediately so the observer doesn't leak.
                if (this.observersByThreshold === undefined) {
                    observer.disconnect();
                    return observer;
                }
                this.observersByThreshold.set(threshold, observer);
                return observer;
            };
            const observeElement = (el)=>{
                if (this.observedElements?.has(el)) return;
                this.observedElements?.add(el);
                getOrCreateObserver(this.resolveThresholdForElement(el)).observe(el);
            };
            const scanAndObserve = (root)=>{
                root.querySelectorAll(this.combinedSelector).forEach(observeElement);
            };
            scanAndObserve(document);
            this.mutationObserver = new MutationObserver((mutations)=>{
                for (const mutation of mutations){
                    mutation.addedNodes.forEach((node)=>{
                        if (node instanceof Element) {
                            if (node.matches(this.combinedSelector)) observeElement(node);
                            scanAndObserve(node);
                        }
                    });
                    mutation.removedNodes.forEach((node)=>{
                        if (node instanceof Element) {
                            this.closeSpansForSubtree(node);
                            // Remove from the observed set so the element can be
                            // re-observed if it is re-inserted into the DOM later.
                            this.observedElements?.delete(node);
                            node.querySelectorAll(this.combinedSelector).forEach((desc)=>{
                                this.observedElements?.delete(desc);
                            });
                        }
                    });
                    if (mutation.type === 'attributes' && mutation.target instanceof Element) {
                        const el = mutation.target;
                        if (!$403152b531bdd98a$var$isElementVisuallyPresent(el)) {
                            // Close the target element itself (if tracked).
                            const elementKey = this.resolveKey(el);
                            if (elementKey) (0, $2AizJ.endElementDwellSpan)(this.cache, elementKey, this.clock());
                            // Also close any tracked descendants that are now
                            // hidden by this ancestor's attribute change (e.g. a
                            // parent gains class="hidden" or style="display:none").
                            el.querySelectorAll(this.combinedSelector).forEach((desc)=>{
                                const key = this.resolveKey(desc);
                                if (key) (0, $2AizJ.endElementDwellSpan)(this.cache, key, this.clock());
                            });
                        }
                    }
                }
            });
            this.mutationObserver.observe(document.body, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: [
                    'style',
                    'class',
                    'hidden'
                ]
            });
        };
        this.stop = ()=>{
            if (!this.started) return;
            this.started = false;
            this.observersByThreshold?.forEach((observer)=>observer.disconnect());
            this.observersByThreshold?.clear();
            this.observersByThreshold = undefined;
            this.mutationObserver?.disconnect();
            this.mutationObserver = undefined;
            this.observedElements = undefined;
        };
        // Resolve `el`'s dwell key from the first trackability config whose
        // selector it matches and whose `getKey` returns a non-empty key.
        this.resolveKey = (el)=>{
            for (const trackable of this.trackables)if (el.matches(trackable.selector)) {
                const key = trackable.getKey(el);
                if (key) return key;
            }
            return null;
        };
        // Resolve `el`'s intersection threshold from the first trackability config
        // whose selector it matches.
        this.resolveThresholdForElement = (el)=>{
            for (const trackable of this.trackables){
                if (el.matches(trackable.selector)) return $403152b531bdd98a$var$resolveThreshold(trackable, el);
            }
            return $403152b531bdd98a$var$FALLBACK_INTERSECTION_THRESHOLD;
        };
        // For every trackable element in (and including) `root`, close its active
        // dwell span at the current time. Used when DOM nodes are removed so
        // their open spans don't bleed past their lifetime.
        this.closeSpansForSubtree = (root)=>{
            if (root.matches(this.combinedSelector)) {
                const key = this.resolveKey(root);
                if (key) (0, $2AizJ.endElementDwellSpan)(this.cache, key, this.clock());
            }
            root.querySelectorAll(this.combinedSelector).forEach((descendant)=>{
                const key = this.resolveKey(descendant);
                if (key) (0, $2AizJ.endElementDwellSpan)(this.cache, key, this.clock());
            });
        };
        this.cache = cache;
        this.trackables = trackables;
        this.combinedSelector = trackables.map((trackable)=>trackable.selector).join(', ');
        this.clock = clock;
    }
}
// Resolve `trackable.intersectionThreshold` (number or per-element function)
// for `el`, clamped to [0, 1]. Falls back to `FALLBACK_INTERSECTION_THRESHOLD`
// for non-finite values.
function $403152b531bdd98a$var$resolveThreshold(trackable, el) {
    const raw = typeof trackable.intersectionThreshold === 'function' ? trackable.intersectionThreshold(el) : trackable.intersectionThreshold;
    if (!Number.isFinite(raw)) return $403152b531bdd98a$var$FALLBACK_INTERSECTION_THRESHOLD;
    return Math.max(0, Math.min(1, raw));
}
// Return true only if the element is connected to the DOM and not hidden
// via `display: none` or `visibility: hidden` (we treat both as out-of-view).
function $403152b531bdd98a$var$isElementVisuallyPresent(el) {
    if (!el.isConnected) return false;
    if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') return true;
    const style = window.getComputedStyle(el);
    if (style.visibility === 'hidden' || style.display === 'none') return false;
    return true;
}

});
parcelRegister("2AizJ", function(module, exports) {
$parcel$export(module.exports, "createElementDwellSpansCache", function () { return $fc45eef392a153a9$export$fada37894f4edf3b; });
$parcel$export(module.exports, "startElementDwellSpan", function () { return $fc45eef392a153a9$export$17a3da773210417; });
$parcel$export(module.exports, "endElementDwellSpan", function () { return $fc45eef392a153a9$export$bb6f6e97e932a4ec; });
$parcel$export(module.exports, "getElementDwellTimes", function () { return $fc45eef392a153a9$export$d63a0bb326060cae; });
$parcel$export(module.exports, "rolloverActiveElementDwellSpans", function () { return $fc45eef392a153a9$export$8bda0eeedd759d0b; });
function $fc45eef392a153a9$export$fada37894f4edf3b() {
    return {
        active: {},
        completed: []
    };
}
function $fc45eef392a153a9$export$17a3da773210417(cache, elementKey, timestamp) {
    if (cache.active[elementKey] !== undefined) return;
    cache.active[elementKey] = timestamp;
}
function $fc45eef392a153a9$export$bb6f6e97e932a4ec(cache, elementKey, timestamp) {
    const entranceTimestamp = cache.active[elementKey];
    if (entranceTimestamp === undefined) return;
    cache.completed.push({
        elementKey: elementKey,
        entranceTimestamp: entranceTimestamp,
        exitTimestamp: timestamp
    });
    delete cache.active[elementKey];
}
function $fc45eef392a153a9$export$d63a0bb326060cae(cache, intervalEndTimestamp) {
    const durations = {};
    cache.completed.forEach((span)=>{
        const duration = Math.max(0, span.exitTimestamp - span.entranceTimestamp);
        durations[span.elementKey] = (durations[span.elementKey] || 0) + duration;
    });
    for(const elementKey in cache.active){
        const entranceTimestamp = cache.active[elementKey];
        if (entranceTimestamp === undefined) continue;
        const duration = Math.max(0, intervalEndTimestamp - entranceTimestamp);
        durations[elementKey] = (durations[elementKey] || 0) + duration;
    }
    return durations;
}
function $fc45eef392a153a9$export$8bda0eeedd759d0b(cache, nextIntervalStartTimestamp) {
    cache.completed = [];
    for(const elementKey in cache.active)cache.active[elementKey] = nextIntervalStartTimestamp;
}
function $fc45eef392a153a9$export$61aae54d8f61a65c(cache) {
    cache.active = {};
    cache.completed = [];
}

});


parcelRegister("g14wK", function(module, exports) {
$parcel$export(module.exports, "IdlePoller", function () { return $05d40f2ca48b1c04$export$d8019e1f9862be37; });

var $jewWt = parcelRequire("jewWt");
class $05d40f2ca48b1c04$export$d8019e1f9862be37 {
    constructor(state, opts){
        this.started = false;
        this.lastSeenIdle = false;
        this.start = ()=>{
            if (this.started) return;
            this.started = true;
            this.lastSeenIdle = this.state.isIdle;
            this.intervalId = setInterval(()=>{
                const nowIdle = (0, $jewWt.updateIdleStateAt)(this.state, this.opts.clock(), this.opts.idleTimeoutMs);
                if (nowIdle && !this.lastSeenIdle) {
                    this.lastSeenIdle = true;
                    this.opts.onIdle();
                } else if (!nowIdle && this.lastSeenIdle) {
                    this.lastSeenIdle = false;
                    this.opts.onActive?.();
                }
            }, this.pollIntervalMs);
        };
        this.stop = ()=>{
            if (!this.started) return;
            this.started = false;
            if (this.intervalId !== undefined) {
                clearInterval(this.intervalId);
                this.intervalId = undefined;
            }
        };
        this.state = state;
        this.opts = opts;
        this.pollIntervalMs = opts.pollIntervalMs ?? 5000;
    }
}

});

parcelRegister("76bMJ", function(module, exports) {
$parcel$export(module.exports, "IntervalLoop", function () { return $fc3080c7d828a680$export$4843df8b035b2e8f; });

var $cyd5Y = parcelRequire("cyd5Y");
class $fc3080c7d828a680$export$4843df8b035b2e8f {
    constructor(schedule, cursor, onTick){
        this.started = false;
        this.start = ()=>{
            if (this.started) return;
            this.started = true;
            this.scheduleNext();
        };
        this.stop = ()=>{
            if (!this.started) return;
            this.started = false;
            if (this.timeoutId !== undefined) {
                clearTimeout(this.timeoutId);
                this.timeoutId = undefined;
            }
        };
        this.scheduleNext = ()=>{
            if (!this.started) return;
            const ms = (0, $cyd5Y.peekNextIntervalDurationMs)(this.schedule, this.cursor);
            this.timeoutId = setTimeout(()=>{
                if (!this.started) return;
                const consumedStep = (0, $cyd5Y.advanceIntervalScheduleCursor)(this.cursor);
                try {
                    this.onTick(consumedStep);
                } finally{
                    this.scheduleNext();
                }
            }, ms);
        };
        this.schedule = schedule;
        this.cursor = cursor;
        this.onTick = onTick;
    }
}

});
parcelRegister("cyd5Y", function(module, exports) {
$parcel$export(module.exports, "createIntervalScheduleCursor", function () { return $89989f888969848a$export$23c88cfa91f0da2e; });
$parcel$export(module.exports, "resetIntervalScheduleCursor", function () { return $89989f888969848a$export$fbd240badd5ad566; });
$parcel$export(module.exports, "advanceIntervalScheduleCursor", function () { return $89989f888969848a$export$a419cb2db33bebb4; });
$parcel$export(module.exports, "peekNextIntervalDurationMs", function () { return $89989f888969848a$export$a2a4539200c45474; });
function $89989f888969848a$export$23c88cfa91f0da2e() {
    return {
        stepIndex: 0
    };
}
function $89989f888969848a$export$fbd240badd5ad566(cursor) {
    cursor.stepIndex = 0;
}
function $89989f888969848a$export$a419cb2db33bebb4(cursor) {
    const consumed = cursor.stepIndex;
    cursor.stepIndex = consumed + 1;
    return consumed;
}
function $89989f888969848a$export$c427f03ab1864dc8(schedule, stepIndex) {
    if ('interval' in schedule) return $89989f888969848a$var$secondsToMs(schedule.interval);
    const list = schedule.intervals;
    if (list.length === 0) throw new Error('`intervals` must contain at least one value.');
    const idx = Math.min(Math.max(stepIndex, 0), list.length - 1);
    const seconds = list[idx];
    if (seconds === undefined) throw new Error('`intervals` must contain at least one value.');
    return $89989f888969848a$var$secondsToMs(seconds);
}
function $89989f888969848a$export$a2a4539200c45474(schedule, cursor) {
    return $89989f888969848a$export$c427f03ab1864dc8(schedule, cursor.stepIndex);
}
function $89989f888969848a$var$secondsToMs(seconds) {
    if (!Number.isFinite(seconds) || seconds <= 0) throw new Error(`Dwell interval must be a positive finite number of seconds (got ${seconds}).`);
    return Math.floor(seconds * 1000);
}

});


parcelRegister("3yqd8", function(module, exports) {
$parcel$export(module.exports, "defaultTrackability", function () { return $d44fa04671d8a944$export$69b0bc67dc7bbfe9; });
// Describes which DOM elements are dwell-trackable, how to derive their
// identifier, and what intersection-observer threshold each one uses.
// `selector` drives bulk-discovery via querySelectorAll. `getKey` returns
// the per-element id (or null to skip). `intersectionThreshold` is the
// 0–1 ratio of element area that must be in view to count as visible;
// supply a function to vary per element.
const $d44fa04671d8a944$export$69b0bc67dc7bbfe9 = {
    selector: '[data-dwell-id]',
    getKey: (el)=>el.getAttribute('data-dwell-id'),
    // Consider an element "in view" as soon as any part of it enters the
    // viewport. IntersectionObserver fires when `intersectionRatio > 0`.
    // This is because we need to fix some issues with the in-view threshold logic
    intersectionThreshold: 0
};

});

parcelRegister("9XWaQ", function(module, exports) {
$parcel$export(module.exports, "getEmitPayload", function () { return $7174aa8f60898700$export$186716f2172e66f6; });

var $2AizJ = parcelRequire("2AizJ");

var $kxdeC = parcelRequire("kxdeC");
function $7174aa8f60898700$export$186716f2172e66f6(sessionState, spansCache, intervalEndedAt, stepIndex) {
    const sessionId = (0, $kxdeC.getDwellSessionId)(sessionState);
    if (sessionId === null || sessionState.startedAt === null) return null;
    const durationsMs = (0, $2AizJ.getElementDwellTimes)(spansCache, intervalEndedAt);
    // Convert internal ms durations to seconds for the public payload.
    const durations = {};
    for(const key in durationsMs){
        const ms = durationsMs[key];
        if (ms !== undefined) durations[key] = ms / 1000;
    }
    return {
        sessionId: sessionId,
        sessionStartedAt: sessionState.startedAt,
        intervalEndedAt: intervalEndedAt,
        stepIndex: stepIndex,
        durations: durations
    };
}

});
parcelRegister("kxdeC", function(module, exports) {
$parcel$export(module.exports, "createDwellSessionState", function () { return $bb3bf7761d71d0a0$export$7b94a9ed909b49bd; });
$parcel$export(module.exports, "startDwellSession", function () { return $bb3bf7761d71d0a0$export$2f053a6b59709595; });
$parcel$export(module.exports, "endDwellSession", function () { return $bb3bf7761d71d0a0$export$908db22b48fb6b0b; });
$parcel$export(module.exports, "isDwellSessionActive", function () { return $bb3bf7761d71d0a0$export$260cc7330d5a853a; });
$parcel$export(module.exports, "getDwellSessionId", function () { return $bb3bf7761d71d0a0$export$bab02fdc122d0d3; });
function $bb3bf7761d71d0a0$export$7b94a9ed909b49bd() {
    return {
        id: null,
        startedAt: null
    };
}
function $bb3bf7761d71d0a0$export$2f053a6b59709595(state, id, timestamp) {
    if (state.id !== null) return;
    state.id = id;
    state.startedAt = timestamp;
}
function $bb3bf7761d71d0a0$export$908db22b48fb6b0b(state) {
    state.id = null;
    state.startedAt = null;
}
function $bb3bf7761d71d0a0$export$260cc7330d5a853a(state) {
    return state.id !== null;
}
function $bb3bf7761d71d0a0$export$bab02fdc122d0d3(state) {
    return state.id;
}

});


parcelRegister("dfN1H", function(module, exports) {
$parcel$export(module.exports, "generateSessionId", function () { return $cb300a478b7bfd99$export$e0d7d8f108b2bd0b; });
function $cb300a478b7bfd99$export$e0d7d8f108b2bd0b() {
    if (typeof globalThis !== 'undefined' && globalThis.crypto && typeof globalThis.crypto.randomUUID === 'function') return globalThis.crypto.randomUUID();
    return `dwell-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

});




parcelRegister("gJe05", function(module, exports) {
$parcel$export(module.exports, "useCalculationState", function () { return $ffe53822942d34d9$export$5ac48a71a65a15bc; });

var $1CtPM = parcelRequire("1CtPM");

var $3V3tC = parcelRequire("3V3tC");
function $ffe53822942d34d9$export$5ac48a71a65a15bc(props) {
    const { offeringSku: offeringSku } = props;
    return {
        billingCycle: (0, $1CtPM.useSelector)($3V3tC.getBillingCycle),
        isUnitCountAboveMaxThreshold: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.isUnitCountAboveMaxThreshold(ctx, offeringSku)),
        unitCountMin: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.getUnitCountMinThreshold(ctx, offeringSku)),
        isUnitCountBelowMinThreshold: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.isUnitCountBelowMinThreshold(ctx, offeringSku)),
        price: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.getFormattedPlanPrice(ctx, offeringSku)),
        recommended: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.isOfferingRecommended(ctx, offeringSku)),
        unitCount: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.getUnitCount(ctx)),
        unitTierLowerBound: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.getUnitTierLowerBound(ctx, offeringSku)),
        unitTierUpperBound: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.getUnitTierUpperBound(ctx, offeringSku)),
        unitsAvailableInTier: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.getUnitsAvailableInTier(ctx, offeringSku)),
        numberFormatLocale: (0, $1CtPM.useSelector)($3V3tC.getNumberFormatLocale)
    };
}

});
parcelRegister("1CtPM", function(module, exports) {
$parcel$export(module.exports, "useUnitCount", function () { return $f242ee1b597a5061$export$856785685ba8098f; });
$parcel$export(module.exports, "useBillingCycle", function () { return $f242ee1b597a5061$export$ada282ac321ec3b9; });
$parcel$export(module.exports, "useSelector", function () { return $f242ee1b597a5061$export$2105062e25df4afe; });
$parcel$export(module.exports, "useCcpPricingData", function () { return $f242ee1b597a5061$export$97374d6e908d2c; });

var $1oC0p = parcelRequire("1oC0p");

var $dkcYJ = parcelRequire("dkcYJ");

var $aLva8 = parcelRequire("aLva8");
function $f242ee1b597a5061$export$856785685ba8098f() {
    const { inputValues: inputValues, changeInputValues: changeInputValues } = (0, $aLva8.usePricingCalculatorContext)();
    const { unitCount: unitCount } = inputValues;
    const changeUnitCount = (value)=>{
        return changeInputValues({
            unitCount: value
        });
    };
    return [
        unitCount,
        changeUnitCount
    ];
}
function $f242ee1b597a5061$export$ada282ac321ec3b9() {
    const { inputValues: inputValues, changeInputValues: changeInputValues } = (0, $aLva8.usePricingCalculatorContext)();
    const { billingCycle: billingCycle } = inputValues;
    const changeBillingCycle = (value)=>{
        return changeInputValues({
            billingCycle: value
        });
    };
    return [
        billingCycle,
        changeBillingCycle
    ];
}
function $f242ee1b597a5061$export$f3fe2cc7a9497569() {
    return (0, $aLva8.usePricingCalculatorContext)().calculationResult;
}
const $f242ee1b597a5061$export$2105062e25df4afe = (selector)=>{
    const context = (0, $aLva8.usePricingCalculatorContext)();
    return selector(context);
};
const $f242ee1b597a5061$var$PRODUCT_CATALOG_DELIVERY_KEY = "nDQjfHDrrDfmPuccfIHYNMU3pSNCi1WOTRsI-q0igVU";
const $f242ee1b597a5061$var$PRODUCT_CATALOG_SPACE = "3s3v3nq72la0";
const $f242ee1b597a5061$export$97374d6e908d2c = (props)=>{
    const { offeringSkus: offeringSkus, ssrData: ssrData } = props;
    const { fetchData: fetchData, status: fetchStatus, prices: clientSideData } = (0, $dkcYJ.useCCPPriceFinderData)(offeringSkus, $f242ee1b597a5061$var$PRODUCT_CATALOG_DELIVERY_KEY, $f242ee1b597a5061$var$PRODUCT_CATALOG_SPACE);
    const execFetch = (0, $1oC0p.useCallback)(async ()=>{
        await fetchData();
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        if (!ssrData) execFetch();
    }, []);
    const status = $f242ee1b597a5061$var$getCcpPricingDataStatus({
        hasSsrData: !!ssrData,
        fetchStatus: fetchStatus
    });
    return {
        data: ssrData ?? clientSideData,
        status: status
    };
};
function $f242ee1b597a5061$var$getCcpPricingDataStatus(args) {
    const { fetchStatus: fetchStatus, hasSsrData: hasSsrData } = args;
    if (hasSsrData || fetchStatus === 'complete') return 'ready';
    if (fetchStatus === 'idle' || fetchStatus === 'fetching') return 'pending';
    return 'error';
}

});
parcelRegister("aLva8", function(module, exports) {
$parcel$export(module.exports, "usePricingCalculatorContext", function () { return $368a3b873d7337e6$export$cf6d27bb6377cd5b; });
$parcel$export(module.exports, "PricingCalculatorContextProvider", function () { return $368a3b873d7337e6$export$5a79cf764fd87278; });

var $7VQPk = parcelRequire("7VQPk");

var $8cfMz = parcelRequire("8cfMz");

var $5CQu1 = parcelRequire("5CQu1");

var $1oC0p = parcelRequire("1oC0p");
const $368a3b873d7337e6$var$PricingCalculatorContext = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
const $368a3b873d7337e6$export$cf6d27bb6377cd5b = ()=>{
    const pricingCalculatorContext = (0, $1oC0p.useContext)($368a3b873d7337e6$var$PricingCalculatorContext);
    if (!pricingCalculatorContext) throw new Error('usePricingCalculatorContext must be used within a PricingCalculatorProvider');
    return pricingCalculatorContext;
};
const $368a3b873d7337e6$export$5a79cf764fd87278 = (props)=>{
    const [inputValues, setInputValues] = (0, $1oC0p.useState)(props.inputValues);
    const calculate = (0, $1oC0p.useCallback)((v)=>{
        const { config: config } = props;
        const productCalculationInputs = (0, $8cfMz.getProductCalculationInputs)(config.planLimitConfigs, config.unitMinEnterprise, v.unitCount, v.billingCycle);
        return (0, $5CQu1.calculateProductPricing)(config.ccpPricingData, productCalculationInputs, config.currencyISOCode, config.localeISOCode);
    }, [
        props
    ]);
    const [calculationResult, setCalculationResult] = (0, $1oC0p.useState)(()=>calculate(inputValues));
    // Recalculate when config (including currency) changes
    (0, $1oC0p.useEffect)(()=>{
        const result = calculate(inputValues);
        setCalculationResult(result);
    }, [
        props.config,
        inputValues,
        calculate
    ]);
    const changeInputValues = (changes)=>{
        const nextValues = {
            ...inputValues,
            ...changes
        };
        setInputValues(nextValues);
        props.onChangeInputs?.(nextValues);
        const result = calculate(nextValues);
        setCalculationResult(result);
        return result;
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)($368a3b873d7337e6$var$PricingCalculatorContext.Provider, {
        value: {
            inputValues: inputValues,
            changeInputValues: changeInputValues,
            calculationResult: calculationResult,
            config: props.config,
            getDiscountedPrice: props.getDiscountedPrice
        },
        children: props.children
    });
};

});
parcelRegister("8cfMz", function(module, exports) {
$parcel$export(module.exports, "getProductCalculationInputs", function () { return $2c139569c5386442$export$915d8a609f55f86e; });

var $hrGO1 = parcelRequire("hrGO1");
const $2c139569c5386442$export$915d8a609f55f86e = (productPlans, unitMinEnterprise, unitCount, billingCycle)=>{
    const getNumUnits = (planName, signupUnitLimit)=>{
        let adjNumUnits = 0;
        // following scenarios do not have pricing and should send a zero unit count,
        // the zero pricing will not be displayed and is needed only to retain the
        // correct array order of the pricing requests/responses
        // Free plan has no pricing
        const isFree = planName === (0, $hrGO1.SpecialPlanNames).FREE;
        // Enterprise plans do not have monthly pricing
        const isMonthlyEnterprise = planName === (0, $hrGO1.SpecialPlanNames).ENTERPRISE && billingCycle === 'MONTHLY';
        // Enterprise plans have a minimum unit count
        const isUnmetUnitCountEnterprise = planName === (0, $hrGO1.SpecialPlanNames).ENTERPRISE && unitCount < unitMinEnterprise;
        const isOverSignupUnitLimit = unitCount > signupUnitLimit;
        if (![
            isFree,
            isMonthlyEnterprise,
            isUnmetUnitCountEnterprise,
            isOverSignupUnitLimit
        ].includes(true)) adjNumUnits = unitCount;
        // keep unit count to general maximum limit
        return Math.min(adjNumUnits, signupUnitLimit);
    };
    const planPriceReqs = productPlans.map(({ offeringSku: offeringSku, planName: planName, signupLimit: signupLimit })=>({
            ccpOfferingSKU: offeringSku,
            hamsProductKey: undefined,
            numUnits: getNumUnits(planName, signupLimit || (0, $hrGO1.DefaultPlanLimits).UNIT_LIMIT),
            period: billingCycle
        }));
    return planPriceReqs;
};

});

parcelRegister("5CQu1", function(module, exports) {
$parcel$export(module.exports, "calculateProductPricing", function () { return $a686a54aa7deba91$export$6c0aa9d51dade71d; });

var $1mbEv = parcelRequire("1mbEv");
const $a686a54aa7deba91$export$6c0aa9d51dade71d = (ccpPricingData, productCalculationInputs, currencyISOCode, localeISOCode)=>{
    const productPricing = [];
    for (const planCalculationInputs of productCalculationInputs){
        const { ccpOfferingSKU: ccpOfferingSKU, numUnits: numUnits, period: period } = planCalculationInputs;
        const planPricing = (0, $1mbEv.calculatePlanPricing)({
            ccpPricingData: ccpPricingData,
            ccpOfferingSKU: ccpOfferingSKU,
            numUnits: numUnits,
            period: period,
            currencyISOCode: currencyISOCode,
            localeISOCode: localeISOCode
        });
        productPricing.push({
            // @ts-ignore
            offeringSku: ccpOfferingSKU,
            ...planPricing
        });
    }
    return productPricing;
};

});
parcelRegister("1mbEv", function(module, exports) {
$parcel$export(module.exports, "calculatePlanPricing", function () { return $0f584d23bad95648$export$f9574505c9651410; });

var $69Lp1 = parcelRequire("69Lp1");

var $8dsKS = parcelRequire("8dsKS");

var $1RK9J = parcelRequire("1RK9J");

var $aTHox = parcelRequire("aTHox");

var $9Nmuw = parcelRequire("9Nmuw");
const $0f584d23bad95648$var$hamsPricingDataStub = {};
const $0f584d23bad95648$var$hamsProductKeyStub = '';
function $0f584d23bad95648$export$f9574505c9651410(args) {
    const { ccpPricingData: ccpPricingData, ccpOfferingSKU: ccpOfferingSKU, period: period, numUnits: numUnits, currencyISOCode: currencyISOCode, localeISOCode: localeISOCode } = args;
    if (numUnits === 0) return {
        offeringSku: ccpOfferingSKU,
        ...(0, $1RK9J.getFreePriceCalc)(currencyISOCode)
    };
    else {
        let getCcpTiers = undefined;
        if (ccpOfferingSKU === (0, $9Nmuw.rovoDevOfferingSkus).standard || ccpOfferingSKU === (0, $aTHox.bitbucketOfferingSkus).standard || ccpOfferingSKU === (0, $aTHox.bitbucketOfferingSkus).premium) // rovodev-standard price-plans contain both user and rovodev-credits charge-items
        // bitbucket-standard and bitbucket-premium price-plans contain both user and bitbucket-credits charge-items as well
        // so, we need to get the plan with the user charge-item
        // todo: GWP-8253 move out of reusable calc logic
        getCcpTiers = (pricingPlans)=>pricingPlans.items.find((item)=>item.chargeElement === 'user');
        const pricingTiers = (0, $69Lp1.extractPricingTiersFromEntry)(ccpPricingData, $0f584d23bad95648$var$hamsPricingDataStub, period, currencyISOCode, ccpOfferingSKU, $0f584d23bad95648$var$hamsProductKeyStub, getCcpTiers);
        if (!pricingTiers) {
            console.log(`Pricing tiers not found for ${period}.`);
            return {
                offeringSku: ccpOfferingSKU,
                ...(0, $1RK9J.getFreePriceCalc)(currencyISOCode)
            };
        } else return {
            offeringSku: ccpOfferingSKU,
            ...(0, $8dsKS.calculatePrice)(numUnits, pricingTiers, currencyISOCode, period, localeISOCode)
        };
    }
}

});
parcelRegister("aTHox", function(module, exports) {
$parcel$export(module.exports, "BITBUCKET_DEFAULT_BILLING_CYCLE", function () { return $4c3894076c255a40$export$6e78cb64dcbedbb9; });
$parcel$export(module.exports, "BITBUCKET_DEFAULT_UNIT_COUNT", function () { return $4c3894076c255a40$export$36a5806a0e4fc360; });
$parcel$export(module.exports, "BITBUCKET_MIN_ENTERPRISE_USER_COUNT", function () { return $4c3894076c255a40$export$2b15976b7672c2da; });
$parcel$export(module.exports, "bitbucketOfferingSkus", function () { return $4c3894076c255a40$export$eeb88db779daf862; });
$parcel$export(module.exports, "BITBUCKET_SIGNUP_LIMIT", function () { return $4c3894076c255a40$export$4d264dc26702f23b; });
$parcel$export(module.exports, "bitbucketOfferingSkusArray", function () { return $4c3894076c255a40$export$9a2735659d85fd7c; });
$parcel$export(module.exports, "bitbucketPlanLimitConfigs", function () { return $4c3894076c255a40$export$66d05a9262b43b7f; });
$parcel$export(module.exports, "bitbucketBillingCycleConfig", function () { return $4c3894076c255a40$export$f9cab01559b23739; });
const $4c3894076c255a40$export$6e78cb64dcbedbb9 = 'MONTHLY';
const $4c3894076c255a40$export$36a5806a0e4fc360 = 5;
const $4c3894076c255a40$export$2b15976b7672c2da = 201;
const $4c3894076c255a40$export$eeb88db779daf862 = {
    free: 'bitbucket-test-free',
    standard: 'bitbucket-std',
    premium: 'bitbucket-premium'
};
const $4c3894076c255a40$export$4d264dc26702f23b = 35000;
const $4c3894076c255a40$export$9a2735659d85fd7c = Object.values($4c3894076c255a40$export$eeb88db779daf862);
const $4c3894076c255a40$export$66d05a9262b43b7f = [
    {
        planName: 'Free',
        offeringSku: $4c3894076c255a40$export$eeb88db779daf862.free,
        recommendationLimit: 0,
        signupLimit: $4c3894076c255a40$export$4d264dc26702f23b
    },
    {
        planName: 'Standard',
        offeringSku: $4c3894076c255a40$export$eeb88db779daf862.standard,
        recommendationLimit: 5,
        signupLimit: $4c3894076c255a40$export$4d264dc26702f23b
    },
    {
        planName: 'Premium',
        offeringSku: $4c3894076c255a40$export$eeb88db779daf862.premium,
        recommendationLimit: 100,
        signupLimit: $4c3894076c255a40$export$4d264dc26702f23b
    }
];
const $4c3894076c255a40$export$f9cab01559b23739 = {
    monthly: true,
    annual: false
};

});

parcelRegister("9Nmuw", function(module, exports) {
$parcel$export(module.exports, "ROVO_DEV_DEFAULT_BILLING_CYCLE", function () { return $5113a0e17f25a106$export$f7b45b42f23a06a6; });
$parcel$export(module.exports, "ROVO_DEV_DEFAULT_UNIT_COUNT", function () { return $5113a0e17f25a106$export$c80f45e98f559c29; });
$parcel$export(module.exports, "ROVO_DEV_MIN_ENTERPRISE_USER_COUNT", function () { return $5113a0e17f25a106$export$5cdb7bb84622bb8e; });
$parcel$export(module.exports, "rovoDevOfferingSkus", function () { return $5113a0e17f25a106$export$6a8477cfea6a8fb8; });
$parcel$export(module.exports, "rovoDevOfferingSkusArray", function () { return $5113a0e17f25a106$export$69f1beff4f684452; });
$parcel$export(module.exports, "rovoDevPlanLimitConfigs", function () { return $5113a0e17f25a106$export$93aaa2531823d54e; });
$parcel$export(module.exports, "rovoDevBillingCycleConfig", function () { return $5113a0e17f25a106$export$120b0272a23f9b21; });
const $5113a0e17f25a106$export$f7b45b42f23a06a6 = 'MONTHLY';
const $5113a0e17f25a106$export$c80f45e98f559c29 = 10;
const $5113a0e17f25a106$export$5cdb7bb84622bb8e = Infinity;
const $5113a0e17f25a106$export$6a8477cfea6a8fb8 = {
    standard: 'rovodev-standard'
};
const $5113a0e17f25a106$export$69f1beff4f684452 = Object.values($5113a0e17f25a106$export$6a8477cfea6a8fb8);
const $5113a0e17f25a106$export$93aaa2531823d54e = [
    {
        planName: 'Standard',
        offeringSku: $5113a0e17f25a106$export$6a8477cfea6a8fb8.standard,
        recommendationLimit: Infinity,
        signupLimit: Infinity,
        minUnitCount: $5113a0e17f25a106$export$5cdb7bb84622bb8e
    }
];
const $5113a0e17f25a106$export$120b0272a23f9b21 = {
    monthly: false,
    annual: false
};

});





parcelRegister("3V3tC", function(module, exports) {
$parcel$export(module.exports, "getUnitCount", function () { return $964f907284a6b353$export$f188fc3b389e4986; });
$parcel$export(module.exports, "getBillingCycle", function () { return $964f907284a6b353$export$36cee2c7009ae4b; });
$parcel$export(module.exports, "hasAnnualBilling", function () { return $964f907284a6b353$export$101e70cd0fc05902; });
$parcel$export(module.exports, "hasMonthlyBilling", function () { return $964f907284a6b353$export$9adfa96ec47fe801; });
$parcel$export(module.exports, "isUnitCountAboveMaxThreshold", function () { return $964f907284a6b353$export$bdaa994f7aee683f; });
$parcel$export(module.exports, "getUnitCountMinThreshold", function () { return $964f907284a6b353$export$80145dc7d2cff456; });
$parcel$export(module.exports, "isUnitCountBelowMinThreshold", function () { return $964f907284a6b353$export$5566acad9364293b; });
$parcel$export(module.exports, "getNumberFormatLocale", function () { return $964f907284a6b353$export$3d36f1c8af14c3fb; });
$parcel$export(module.exports, "getCurrencyIsoCode", function () { return $964f907284a6b353$export$5052d5e5b6a90fdc; });
$parcel$export(module.exports, "isOfferingRecommended", function () { return $964f907284a6b353$export$d9589e71fc109cc; });
$parcel$export(module.exports, "getUnitTierLowerBound", function () { return $964f907284a6b353$export$f88112553e09e018; });
$parcel$export(module.exports, "getUnitTierUpperBound", function () { return $964f907284a6b353$export$6f3b3ca7764acc97; });
$parcel$export(module.exports, "getUnitsAvailableInTier", function () { return $964f907284a6b353$export$daa8dd568be987ed; });
$parcel$export(module.exports, "getFormattedPlanPrice", function () { return $964f907284a6b353$export$8808c13548cf959c; });
const $964f907284a6b353$export$f188fc3b389e4986 = (ctx)=>ctx.inputValues.unitCount;
const $964f907284a6b353$export$36cee2c7009ae4b = (ctx)=>ctx.inputValues.billingCycle;
const $964f907284a6b353$export$101e70cd0fc05902 = (ctx)=>{
    return ctx.config.billingCycleConfig.annual;
};
const $964f907284a6b353$export$9adfa96ec47fe801 = (ctx)=>{
    return ctx.config.billingCycleConfig.monthly;
};
const $964f907284a6b353$export$bdaa994f7aee683f = (ctx, offeringSku)=>{
    const unitCount = $964f907284a6b353$export$f188fc3b389e4986(ctx);
    const planLimitConfig = $964f907284a6b353$var$getPlanLimitConfig(ctx, offeringSku);
    return unitCount > planLimitConfig.signupLimit;
};
const $964f907284a6b353$export$80145dc7d2cff456 = (ctx, offeringSku)=>{
    const { minUnitCount: minUnitCount } = $964f907284a6b353$var$getPlanLimitConfig(ctx, offeringSku);
    return minUnitCount ?? 0;
};
const $964f907284a6b353$export$5566acad9364293b = (ctx, offeringSku)=>{
    const minUnitCount = $964f907284a6b353$export$80145dc7d2cff456(ctx, offeringSku);
    const unitCount = $964f907284a6b353$export$f188fc3b389e4986(ctx);
    return unitCount < minUnitCount;
};
const $964f907284a6b353$export$3a3e581c62c2c0f = (ctx)=>{
    const unitCount = $964f907284a6b353$export$f188fc3b389e4986(ctx);
    const unitMinEnterprise = ctx.config.unitMinEnterprise;
    return unitCount >= unitMinEnterprise;
};
const $964f907284a6b353$var$getPlanLimitConfigs = (ctx)=>{
    return ctx.config.planLimitConfigs;
};
const $964f907284a6b353$var$getPlanLimitConfig = (ctx, offeringSku)=>{
    const planLimitConfigs = $964f907284a6b353$var$getPlanLimitConfigs(ctx);
    const planLimitConfig = planLimitConfigs.find((plan)=>plan.offeringSku === offeringSku);
    if (!planLimitConfig) throw new Error('unexpected empty value');
    return planLimitConfig;
};
const $964f907284a6b353$var$getPlanPriceResult = (ctx, offeringSku)=>{
    const planPriceResult = ctx.calculationResult.find((plan)=>plan.offeringSku === offeringSku);
    if (!planPriceResult) throw new Error('unexpected empty value');
    return planPriceResult;
};
const $964f907284a6b353$export$e3c7f1437cafb58a = (ctx, offeringSku)=>{
    const price = $964f907284a6b353$var$getPlanPriceResult(ctx, offeringSku);
    let { totalPrice: totalPrice } = price;
    const { getDiscountedPrice: getDiscountedPrice } = ctx;
    if (getDiscountedPrice) totalPrice = getDiscountedPrice({
        price: totalPrice,
        inputs: ctx.inputValues
    });
    return $964f907284a6b353$export$c86caf1be068fb8d(ctx, totalPrice);
};
const $964f907284a6b353$export$2aabcb5d2a5bee2b = (ctx, offeringSku)=>{
    const { avgPerUnitPrice: avgPerUnitPrice } = $964f907284a6b353$var$getPlanPriceResult(ctx, offeringSku);
    const { getDiscountedPrice: getDiscountedPrice } = ctx;
    if (getDiscountedPrice) return getDiscountedPrice({
        inputs: ctx.inputValues,
        price: avgPerUnitPrice
    });
    return avgPerUnitPrice;
};
const $964f907284a6b353$export$10818dfc4986524e = (price)=>{
    return Math.round(price);
};
const $964f907284a6b353$export$2dd65b072d3a3106 = (price)=>{
    return Math.ceil(price);
};
const $964f907284a6b353$export$3d36f1c8af14c3fb = (ctx)=>{
    const currencyISOCode = $964f907284a6b353$export$5052d5e5b6a90fdc(ctx);
    const isJPY = currencyISOCode === 'JPY';
    return isJPY ? 'ja-JP' : 'en-US';
};
const $964f907284a6b353$export$c86caf1be068fb8d = (ctx, price, options = {})=>{
    const numberFormatLocale = $964f907284a6b353$export$3d36f1c8af14c3fb(ctx);
    const currencyISOCode = $964f907284a6b353$export$5052d5e5b6a90fdc(ctx);
    return new Intl.NumberFormat(numberFormatLocale, {
        style: 'currency',
        currency: currencyISOCode,
        minimumFractionDigits: options.minimumFractionDigits ?? 0,
        maximumFractionDigits: options.minimumFractionDigits ?? 0
    }).format(price);
};
const $964f907284a6b353$export$b3a0d360c4444407 = (ctx, offeringSku)=>{
    const price = $964f907284a6b353$var$getPlanPriceResult(ctx, offeringSku);
    return price.formattedAvgPerUnitPrice;
};
const $964f907284a6b353$export$d9589e71fc109cc = (ctx, offeringSku)=>{
    const recommendedOfferingSku = $964f907284a6b353$var$getRecommendedOfferingSku(ctx);
    return recommendedOfferingSku === offeringSku;
};
const $964f907284a6b353$var$getRecommendedOfferingSku = (ctx)=>{
    const getRecommendedPlanIdx = (unitCount, minUnitCounts)=>{
        const len = minUnitCounts.length - 1;
        return len - minUnitCounts.reverse().findIndex((minUnitCount)=>unitCount > minUnitCount);
    };
    const unitCount = $964f907284a6b353$export$f188fc3b389e4986(ctx);
    const planLimitConfigs = $964f907284a6b353$var$getPlanLimitConfigs(ctx);
    const recommendedPlanIdx = getRecommendedPlanIdx(unitCount, planLimitConfigs.map((productPlan)=>productPlan.recommendationLimit));
    return planLimitConfigs[recommendedPlanIdx]?.offeringSku;
};
const $964f907284a6b353$var$getUnformattedBreakdown = (ctx, offeringSku)=>{
    const planPriceResult = $964f907284a6b353$var$getPlanPriceResult(ctx, offeringSku);
    return planPriceResult.breakdown.at(-1);
};
const $964f907284a6b353$export$f88112553e09e018 = (ctx, offeringSku)=>{
    const breakdown = $964f907284a6b353$var$getUnformattedBreakdown(ctx, offeringSku);
    return breakdown?.unitLimitLower;
};
const $964f907284a6b353$export$6f3b3ca7764acc97 = (ctx, offeringSku)=>{
    const breakdown = $964f907284a6b353$var$getUnformattedBreakdown(ctx, offeringSku);
    return breakdown?.unitLimitUpper;
};
const $964f907284a6b353$export$daa8dd568be987ed = (ctx, offeringSku)=>{
    const unitCount = $964f907284a6b353$export$f188fc3b389e4986(ctx);
    const unitTierUpperBound = $964f907284a6b353$export$6f3b3ca7764acc97(ctx, offeringSku);
    return (unitTierUpperBound ?? 0) - unitCount;
};
/**
 * @deprecated
 */ const $964f907284a6b353$var$getFormattedBreakdown = (ctx, offeringSku)=>{
    const planPriceResult = $964f907284a6b353$var$getPlanPriceResult(ctx, offeringSku);
    return planPriceResult.formattedBreakdown.at(-1);
};
const $964f907284a6b353$export$b1a3e695caa8081d = (ctx, offeringSku)=>{
    const breakdown = $964f907284a6b353$var$getFormattedBreakdown(ctx, offeringSku);
    return breakdown?.formattedUnitLimitLower;
};
const $964f907284a6b353$export$24bf67bcc0364ee6 = (ctx, offeringSku)=>{
    const breakdown = $964f907284a6b353$var$getFormattedBreakdown(ctx, offeringSku);
    return breakdown?.formattedUnitLimitUpper;
};
const $964f907284a6b353$export$5052d5e5b6a90fdc = (ctx)=>ctx.config.currencyISOCode;
const $964f907284a6b353$export$8808c13548cf959c = (ctx, offeringSku)=>{
    const billingCycle = $964f907284a6b353$export$36cee2c7009ae4b(ctx);
    const currencyISOCode = $964f907284a6b353$export$5052d5e5b6a90fdc(ctx);
    if (billingCycle === 'ANNUAL') return $964f907284a6b353$export$e3c7f1437cafb58a(ctx, offeringSku);
    let price = $964f907284a6b353$export$2aabcb5d2a5bee2b(ctx, offeringSku);
    if (currencyISOCode === 'JPY') {
        price = $964f907284a6b353$export$2dd65b072d3a3106(price);
        return $964f907284a6b353$export$c86caf1be068fb8d(ctx, price, {
            minimumFractionDigits: 0
        });
    }
    return $964f907284a6b353$export$c86caf1be068fb8d(ctx, price, {
        minimumFractionDigits: price === 0 || Number.isInteger(price) ? 0 : 2
    });
};
const $964f907284a6b353$export$235d4fbb478dfba0 = (ctx, args)=>{
    const { offeringSku: offeringSku, edition: edition } = args;
    const offering = Object.values(ctx.config.ccpPricingData).find((offering)=>offering.sku === offeringSku);
    const currencyISOCode = $964f907284a6b353$export$5052d5e5b6a90fdc(ctx);
    const billingCycle = $964f907284a6b353$export$36cee2c7009ae4b(ctx);
    const defaultPricingPlan = offering?.defaultPricingPlans?.filter((item)=>item.currency.toLowerCase() === currencyISOCode.toLowerCase() && item.offeringName.toLowerCase() === edition.toLowerCase() && item.primaryCycle_name.toLowerCase() === billingCycle.toLowerCase() && item.status.toLowerCase() === 'active');
    const lastPricingPlan = defaultPricingPlan?.[defaultPricingPlan.length - 1];
    return lastPricingPlan?.id || '';
};

});


parcelRegister("44bDI", function(module, exports) {
$parcel$export(module.exports, "getFeaturesList", function () { return $b83af44fbf5738a9$export$501f60b80ced167; });
/* features-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $cXZQx = parcelRequire("cXZQx");

var $gVC4y = parcelRequire("gVC4y");
const $b83af44fbf5738a9$export$501f60b80ced167 = (highlightedFeaturesContainer)=>{
    if (!highlightedFeaturesContainer?.length) return undefined;
    return highlightedFeaturesContainer?.map((feature)=>({
            label: feature.fields.highlightedFeatureTitleExternal,
            details: feature.fields.highlightedFeatureDetails && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_q7gqdlk8"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cXZQx.RichTextComponent), {
                    text: (0, $gVC4y.richTextToHTML)(feature.fields.highlightedFeatureDetails)
                })
            }),
            lozengeText: feature.fields.highlightedLabel
        }));
};
const $b83af44fbf5738a9$var$featureDetailsCss = null;

});

parcelRegister("MgH7i", function(module, exports) {
$parcel$export(module.exports, "PricingCalculatorInputs", function () { return $884c8db4d1ecaa10$export$8c44531ca473ca22; });
/* pricing-calculator-inputs.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $eY3N6 = parcelRequire("eY3N6");

var $hrGO1 = parcelRequire("hrGO1");

var $4pGAV = parcelRequire("4pGAV");

var $kbpa7 = parcelRequire("kbpa7");

var $1CtPM = parcelRequire("1CtPM");

var $3V3tC = parcelRequire("3V3tC");
const $884c8db4d1ecaa10$export$8c44531ca473ca22 = (props)=>{
    const { unitCountLabel: unitCountLabel, unitsLabel: unitsLabel, dataProductKey: dataProductKey } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const [billingCycle, setBillingCycle] = (0, $1CtPM.useBillingCycle)();
    const [unitCount, setUnitCount] = (0, $1CtPM.useUnitCount)();
    const hasMonthlyBilling = (0, $1CtPM.useSelector)($3V3tC.hasMonthlyBilling);
    const hasAnnualBilling = (0, $1CtPM.useSelector)($3V3tC.hasAnnualBilling);
    const [visualUnitCount, setVisualUnitCount] = (0, $1oC0p.useState)(// @ts-ignore
    unitCount);
    (0, $1oC0p.useEffect)(()=>{
        if (visualUnitCount !== '' && visualUnitCount > 0 && !Number.isNaN(visualUnitCount)) // @ts-ignore
        setUnitCount(visualUnitCount);
    }, [
        visualUnitCount
    ]);
    const handleUnitCountChange = (e)=>{
        const stringValue = e.target.value;
        if (stringValue === '') return setVisualUnitCount('');
        // validate max number of digits
        // default is 5
        // TODO: make this configurable
        if (stringValue.length > 6) return;
        const numberValue = parseInt(stringValue, 10);
        if (numberValue < 1) return;
        setVisualUnitCount(numberValue);
    };
    const handleUnitCountBlurChange = ()=>{
        // @ts-ignore
        if (visualUnitCount === '') setVisualUnitCount(unitCount);
        const data = {
            unitCount: unitCount,
            productKey: dataProductKey
        };
        createAnalyticsEvent({
            eventType: 'ui',
            eventName: `${(0, $hrGO1.TRACKING_EVENT_NAMES).unitTierBox}_blurred`,
            eventComponent: 'input',
            event: 'blurred',
            actionSubject: (0, $hrGO1.TRACKING_EVENT_NAMES).unitTierBox,
            action: 'blurred',
            attributes: data,
            data: data
        }).fire();
    };
    const handleRadioChange = (billingCycle)=>{
        const data = {
            billingCycle: billingCycle,
            productKey: dataProductKey
        };
        createAnalyticsEvent({
            eventType: 'ui',
            eventName: (0, $hrGO1.TRACKING_EVENT_NAMES).billingCycleChanged,
            eventComponent: 'radioButton',
            event: 'clicked',
            actionSubject: (0, $hrGO1.TRACKING_EVENT_NAMES).billingCycleChanged,
            action: 'clicked',
            attributes: data
        }).fire();
        setBillingCycle(billingCycle);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12fogza"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_p12f1kdj _19pk1wug _2hwx1wug _otyr1wug _18u01wug _b8yq1osq _3wvkidpf _1fbnidpf _1uby1wug _1t0ridpf"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_p12f1kdj _6rth1tcg _181n1txw _b8yq1osq _e8gh1h6o _19wgys9h"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _181n1ule"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                                htmlFor: "unit-count",
                                className: (0, $2jatx.default)([
                                    "_ect4z4z1 _1wyb1j6v _1dyznl7k _k48pni7l _o5721q9c",
                                    "_12l2ftgi _syaz1pfd"
                                ]),
                                style: {
                                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                                },
                                children: unitCountLabel
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf _1bah1h6o _4cvr1h6o _1bsb1ns9 _15flidpf _1d2widpf _1svyidpf _seovidpf _1akoidpf _c7s7idpf _4puvidpf _1r3vidpf _181n116y _1t19kb7n _p7vbkb7n _1rhgf1ug"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                    id: "unit-count",
                                    type: "number",
                                    value: visualUnitCount,
                                    onChange: handleUnitCountChange,
                                    onBlur: handleUnitCountBlurChange,
                                    "data-event-component": "inputNumber",
                                    "data-event-container": "priceBlock",
                                    "data-event": "changed",
                                    className: (0, $2jatx.default)([
                                        "_syazalr3 _k48p1nn1 _1wyb1j6v _vwz41tcg _12l214y2 _ca0qftgi _u5f3i2wt _n3tdftgi _19bvi2wt _1bsb8ved _2rko1y44 _bfhk1hxd _19itglyw _13di444r _jh1sglyw _ji0mglyw"
                                    ])
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                                htmlFor: "unit-term",
                                className: (0, $2jatx.default)([
                                    "_syaz1mpp _ect4z4z1 _1wyb1j6v _1dyznl7k _k48p1nn1 _16jlkb7n _1o9zkb7n _i0dlf1ug"
                                ]),
                                style: {
                                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                                },
                                children: unitsLabel
                            })
                        ]
                    }),
                    hasMonthlyBilling && hasAnnualBilling && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4pGAV.RadioButtons), {
                            wrap: false,
                            dataProductKey: dataProductKey,
                            selectedButtonId: billingCycle,
                            onChange: handleRadioChange,
                            groupLabel: /*#__PURE__*/ (0, $7VQPk.jsx)("legend", {
                                className: (0, $2jatx.default)([
                                    "_ect4z4z1 _1wyb1j6v _1dyznl7k _k48pni7l _o5721q9c",
                                    "_1aax1e5h"
                                ]),
                                style: {
                                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "Pricing.priceFinderInputs.billMeText",
                                    defaultMessage: "Bill me:"
                                })
                            }),
                            buttons: [
                                {
                                    id: 'MONTHLY',
                                    label: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "Pricing.priceFinderInputs.monthly",
                                        defaultMessage: "Monthly"
                                    })
                                },
                                {
                                    id: 'ANNUAL',
                                    label: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "Pricing.pricingCalculatorInputs.anually",
                                        defaultMessage: "Annually"
                                    }),
                                    lozenge: {
                                        appearance: 'blue',
                                        text: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                            id: "Pricing.pricingCalculatorInputs.saveUpTo",
                                            defaultMessage: "SAVE UP TO 17%"
                                        })
                                    }
                                }
                            ]
                        })
                    })
                ]
            })
        })
    });
};
const $884c8db4d1ecaa10$var$labelStyles = null;
const $884c8db4d1ecaa10$var$legendStyles = null;
const $884c8db4d1ecaa10$var$inputTermStyle = null;
const $884c8db4d1ecaa10$var$inputCss = null;

});
parcelRegister("4pGAV", function(module, exports) {
$parcel$export(module.exports, "RadioButtons", function () { return $fce343fe26855c12$export$3f5c08aebfbff744; });
/* radio-buttons.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $eY3N6 = parcelRequire("eY3N6");

var $kbpa7 = parcelRequire("kbpa7");

var $jE3Ci = parcelRequire("jE3Ci");
const $fce343fe26855c12$var$RadioButton = ({ id: id, label: label, lozenge: lozenge, disabled: disabled = false, checked: checked = false, size: size, handleRadioChange: handleRadioChange })=>{
    const [isChecked, setIsChecked] = (0, $1oC0p.useState)(checked);
    (0, $1oC0p.useEffect)(()=>{
        setIsChecked(checked);
    }, [
        checked
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c116y _1n261q9c _4cvr1h6o _zulpu2gc _1o9zidpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
                className: (0, $2jatx.default)([
                    "_80omtlke _zulpu2gc _1e0c1txw _4cvr1h6o _syazeipq",
                    disabled && "_80om13gf _syazinbi",
                    'body-md'
                ]),
                htmlFor: id,
                style: {
                    "--_1tiihzy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light600'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                        type: "radio",
                        id: id,
                        "aria-describedby": lozenge ? `${id}-hint` : undefined,
                        "data-testid": `radio-${id}`,
                        checked: isChecked,
                        disabled: disabled,
                        onChange: (e)=>{
                            if (disabled) return;
                            handleRadioChange(e);
                            setIsChecked(!isChecked);
                        },
                        className: (0, $2jatx.default)([
                            "_syaz1r31 _r06hglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19it11a3 _2rko1ssb _80omtlke _1e0c11p5 _ae4v1h6o _1bah1h6o _1ah3v77o _1ygbm8mt _q4zt5hrz _4cvx5hrz _h0k65hrz _1gemb3bt _6sdp1ssb _1ofr1ule _1uv45hrz",
                            size === 'medium' && "_1bsbgktf _4t3igktf _1m1d19bv _rdm219bv",
                            size === 'large' && "_1bsb1f4h _4t3i1f4h _1m1d7vkz _rdm27vkz",
                            disabled && "_80om13gf _syazinbi _1h6dinbi _q4ztinbi _4cvxinbi"
                        ]),
                        style: {
                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                            "--_1tiihzy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light600'))
                        }
                    }),
                    label
                ]
            }),
            lozenge && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                id: `${id}-hint`,
                style: {
                    display: 'contents'
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jE3Ci.Lozenge), {
                    appearance: lozenge.appearance,
                    text: lozenge.text
                })
            })
        ]
    });
};
const $fce343fe26855c12$export$3f5c08aebfbff744 = ({ groupLabel: groupLabel, buttons: buttons, selectedButtonId: selectedButtonId, dataProductKey: // @ts-expect-error existing
// eslint-disable-next-line @typescript-eslint/no-unused-vars
dataProductKey, size: size = 'medium', onChange: onChange, wrap: wrap = true })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const [currentSelectedButtonId, setSelectedButtonId] = (0, $1oC0p.useState)(selectedButtonId);
    // Keep internal selection in sync when the controlling prop changes
    // (e.g. another component in the same context updates the shared
    // billing cycle, where clicking the in-card "Billed annually" link must move the
    // top "Bill me:" radio from Monthly to Annually).
    (0, $1oC0p.useEffect)(()=>{
        setSelectedButtonId(selectedButtonId);
    }, [
        selectedButtonId
    ]);
    const handleRadioChange = (e)=>{
        createAnalyticsEvent({
            eventType: 'ui',
            // eventName: TODO: event name,
            eventComponent: 'radioButton',
            event: 'clicked',
            // actionSubject: TODO: action subject,
            action: 'clicked'
        }).fire();
        setSelectedButtonId(e.target.id);
        if (onChange) onChange(e.target.id);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("fieldset", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx2vrvc _19itglyw _1bsb1osq _zulpxy5q",
            wrap && "_1n261g80"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("legend", {
                className: (0, $2jatx.default)([
                    "_1aax1e5h _o5721q9c _k48pni7l _syazeipq",
                    'body-md'
                ]),
                children: groupLabel
            }),
            buttons.map((button)=>/*#__PURE__*/ (0, $7VQPk.jsx)($fce343fe26855c12$var$RadioButton, {
                    id: button.id,
                    label: button.label,
                    lozenge: button.lozenge,
                    disabled: button.disabled,
                    checked: currentSelectedButtonId === button.id,
                    size: size,
                    handleRadioChange: handleRadioChange
                }, button.id))
        ]
    });
};
const $fce343fe26855c12$var$containerStyles = null;
const $fce343fe26855c12$var$groupLabelStyles = null;
const $fce343fe26855c12$var$radioContainerStyles = null;
const $fce343fe26855c12$var$radioLabelStyles = null;
const $fce343fe26855c12$var$mediumSizeRadioInputStyles = null;
const $fce343fe26855c12$var$largeSizeRadioInputStyles = null;
const $fce343fe26855c12$var$radioInputStyles = null;
const $fce343fe26855c12$var$disabledRadioButtonStyles = null;
const $fce343fe26855c12$var$disabledRadioLabelStyles = null;

});
parcelRegister("jE3Ci", function(module, exports) {
$parcel$export(module.exports, "Lozenge", function () { return $f71e5bcdfd5682cc$export$a31cbe1bf5463979; });
/* lozenge.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $i4BST = parcelRequire("i4BST");

var $eOIix = parcelRequire("eOIix");
const $f71e5bcdfd5682cc$var$appearanceColors = {
    blue: {
        backgroundColor: (0, $kbpa7.wacToken)('color.extended.blue100'),
        color: (0, $kbpa7.wacToken)('color.extended.blue800')
    },
    neutral: {
        backgroundColor: "var(--ds-background-neutral, #0515240F)",
        color: "var(--ds-text-subtle, #505258)"
    },
    saffron: {
        backgroundColor: (0, $kbpa7.wacToken)('color.extended.saffron100'),
        color: (0, $kbpa7.wacToken)('color.extended.saffron800')
    },
    lime: {
        backgroundColor: (0, $kbpa7.wacToken)('color.extended.lime100'),
        color: (0, $kbpa7.wacToken)('color.extended.lime800')
    },
    purple: {
        backgroundColor: (0, $kbpa7.wacToken)('color.extended.purple100'),
        color: (0, $kbpa7.wacToken)('color.extended.purple800')
    },
    danger: {
        backgroundColor: "var(--ds-background-danger, #FFEBE6)",
        color: (0, $kbpa7.wacToken)('color.secondary.red')
    }
};
const $f71e5bcdfd5682cc$export$a31cbe1bf5463979 = ({ appearance: appearance = 'neutral', text: text })=>{
    const isWacRefresh = (0, $i4BST.useWacRefresh)();
    const { isAwf1Theme: isAwf1Theme } = (0, $eOIix.useTheme)();
    if (!text) return null;
    const colors = $f71e5bcdfd5682cc$var$appearanceColors[appearance] ?? $f71e5bcdfd5682cc$var$appearanceColors.neutral;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c116y _4cvr1h6o _zulp19bv _18zrftgi _y3gn1h6o _ect4z4z1 _k48pbfng _1dyznl7k _1p1dangw _p12fuuw1 _vchhusvi _1o9zidpf _1bsb1ns9 _bfhk1a2e _syaz10mv",
            isWacRefresh ? "_2rko1l7b _1wyb1crf _vwz47vkz _3p1cdlk8 _py5of6fq _fz897vkz _1ol9f6fq" : "_1wyb1skh _vwz47vkz _2rkogktf",
            isAwf1Theme && "_2rko1mv1 _1h6d1r31 _189et94y _1dqonqa1 _syazl3em _o5721q9c _p12fglyw _ect4zzfg _k48p1nn1"
        ]),
        style: {
            '--lozenge-bg': colors.backgroundColor,
            '--lozenge-color': colors.color,
            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
            "--_hjrx1n": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.pill'))
        },
        children: text
    });
};
const $f71e5bcdfd5682cc$var$lozengeStyles = null;
const $f71e5bcdfd5682cc$var$nonRefreshLozengeStyles = null;
const $f71e5bcdfd5682cc$var$refreshLozengeStyles = null;
const $f71e5bcdfd5682cc$var$awf1Styles = null;

});



parcelRegister("lc7EO", function(module, exports) {
$parcel$export(module.exports, "JPD_DEFAULT_BILLING_CYCLE", function () { return $a2567840a72a8d9f$export$513f99bdcd3bd2; });
$parcel$export(module.exports, "JPD_DEFAULT_UNIT_COUNT", function () { return $a2567840a72a8d9f$export$503245d941330408; });
$parcel$export(module.exports, "JPD_MIN_ENTERPRISE_USER_COUNT", function () { return $a2567840a72a8d9f$export$4ebabaf17c585254; });
$parcel$export(module.exports, "jpdOfferingSkus", function () { return $a2567840a72a8d9f$export$400db592c8d58797; });
$parcel$export(module.exports, "jpdBillingCycleConfig", function () { return $a2567840a72a8d9f$export$370b1f24abd91670; });
$parcel$export(module.exports, "jpdPlanLimitConfigs", function () { return $a2567840a72a8d9f$export$886e6b42d7675517; });
$parcel$export(module.exports, "jpdOfferingSkusArray", function () { return $a2567840a72a8d9f$export$cf1798af40f51188; });
$parcel$export(module.exports, "useJpdPlanLimitConfigs", function () { return $a2567840a72a8d9f$export$489f0bd45c02b5f3; });
$parcel$export(module.exports, "useJpdPlanTitlesAllowList", function () { return $a2567840a72a8d9f$export$74aab5e5781ecaa8; });
$parcel$export(module.exports, "stripJpdHighlightedFeatures", function () { return $a2567840a72a8d9f$export$7f3e0ab07e999189; });
$parcel$export(module.exports, "useShouldStripJpdHighlightedFeatures", function () { return $a2567840a72a8d9f$export$5b64204eb3ad795a; });

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
const $a2567840a72a8d9f$export$513f99bdcd3bd2 = 'MONTHLY';
const $a2567840a72a8d9f$export$503245d941330408 = 10;
const $a2567840a72a8d9f$export$4ebabaf17c585254 = 100;
const $a2567840a72a8d9f$export$400db592c8d58797 = {
    free: 'jira-servicedesk-free',
    // jpd-free shares the same sku as jsm-free
    standard: 'jira-product-discovery-standard',
    premium: 'jira-product-discovery-premium-sku',
    enterprise: 'jira-product-discovery-enterprise'
};
const $a2567840a72a8d9f$export$370b1f24abd91670 = {
    monthly: true,
    annual: true
};
const $a2567840a72a8d9f$var$JPD_FREE_PLAN_LIMIT_CONFIG = {
    planName: 'Free',
    offeringSku: $a2567840a72a8d9f$export$400db592c8d58797.free,
    recommendationLimit: 0,
    signupLimit: 20000
};
const $a2567840a72a8d9f$var$JPD_STANDARD_PLAN_LIMIT_CONFIG = {
    planName: 'Standard',
    offeringSku: $a2567840a72a8d9f$export$400db592c8d58797.standard,
    recommendationLimit: 3,
    signupLimit: 20000
};
const $a2567840a72a8d9f$var$JPD_PREMIUM_PLAN_LIMIT_CONFIG = {
    planName: 'Premium',
    offeringSku: $a2567840a72a8d9f$export$400db592c8d58797.premium,
    recommendationLimit: 50,
    signupLimit: 20000
};
const $a2567840a72a8d9f$var$JPD_ENTERPRISE_PLAN_LIMIT_CONFIG = {
    planName: 'Enterprise',
    offeringSku: $a2567840a72a8d9f$export$400db592c8d58797.enterprise,
    recommendationLimit: 250,
    signupLimit: 20000,
    minUnitCount: $a2567840a72a8d9f$export$4ebabaf17c585254
};
const $a2567840a72a8d9f$export$33b06374587a97d9 = ()=>{
    return (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp10907JpdEnterpriseSku);
};
const $a2567840a72a8d9f$export$886e6b42d7675517 = ()=>{
    const isEnterpriseSkuEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp10907JpdEnterpriseSku);
    const base = [
        $a2567840a72a8d9f$var$JPD_FREE_PLAN_LIMIT_CONFIG,
        $a2567840a72a8d9f$var$JPD_STANDARD_PLAN_LIMIT_CONFIG,
        $a2567840a72a8d9f$var$JPD_PREMIUM_PLAN_LIMIT_CONFIG
    ];
    return isEnterpriseSkuEnabled ? [
        ...base,
        $a2567840a72a8d9f$var$JPD_ENTERPRISE_PLAN_LIMIT_CONFIG
    ] : base;
};
const $a2567840a72a8d9f$export$cf1798af40f51188 = ()=>$a2567840a72a8d9f$export$886e6b42d7675517().map((config)=>config.offeringSku);
const $a2567840a72a8d9f$export$489f0bd45c02b5f3 = ()=>{
    return $a2567840a72a8d9f$export$886e6b42d7675517();
};
const $a2567840a72a8d9f$export$3dbf1d01fece31ca = ()=>{
    return $a2567840a72a8d9f$export$489f0bd45c02b5f3().map((config)=>config.offeringSku);
};
const $a2567840a72a8d9f$export$74aab5e5781ecaa8 = ()=>{
    return $a2567840a72a8d9f$export$489f0bd45c02b5f3().map((config)=>config.planName);
};
const $a2567840a72a8d9f$export$89d0322d6cc3b745 = ()=>{
    return $a2567840a72a8d9f$export$33b06374587a97d9();
};
const $a2567840a72a8d9f$export$7f3e0ab07e999189 = (plans)=>plans.map((plan)=>({
            ...plan,
            fields: {
                ...plan.fields,
                highlightedFeaturesContainer: undefined,
                highlightedFeaturesTitle: undefined
            }
        }));
const $a2567840a72a8d9f$export$5b64204eb3ad795a = (urlSlug)=>{
    const shouldShow = $a2567840a72a8d9f$export$89d0322d6cc3b745();
    return urlSlug === 'product-discovery' && !shouldShow;
};

});

parcelRegister("fEBe5", function(module, exports) {
$parcel$export(module.exports, "SERVICE_COLLECTION_DEFAULT_BILLING_CYCLE", function () { return $6246fc483000f258$export$9423de11a8a6dfa7; });
$parcel$export(module.exports, "SERVICE_COLLECTION_DEFAULT_UNIT_COUNT", function () { return $6246fc483000f258$export$515fa2affea780b3; });
$parcel$export(module.exports, "SERVICE_COLLECTION_MIN_ENTERPRISE_USER_COUNT", function () { return $6246fc483000f258$export$3df704b75c4818f2; });
$parcel$export(module.exports, "serviceCollectionOfferingSkus", function () { return $6246fc483000f258$export$84b191ede7d628ea; });
$parcel$export(module.exports, "serviceCollectionOfferingSkusArray", function () { return $6246fc483000f258$export$953539e2774d6323; });
$parcel$export(module.exports, "serviceCollectionPlanLimitConfigs", function () { return $6246fc483000f258$export$29e5f53cb4f38894; });
$parcel$export(module.exports, "serviceCollectionBillingCycleConfig", function () { return $6246fc483000f258$export$7c96cfb0c18bfb05; });
const $6246fc483000f258$export$9423de11a8a6dfa7 = 'MONTHLY';
const $6246fc483000f258$export$515fa2affea780b3 = 75;
const $6246fc483000f258$export$3df704b75c4818f2 = 201;
const $6246fc483000f258$export$84b191ede7d628ea = {
    free: 'service-collection-free',
    standard: 'service-collection-standard',
    premium: 'service-collection-premium',
    enterprise: 'service-collection-enterprise'
};
const $6246fc483000f258$export$953539e2774d6323 = Object.values($6246fc483000f258$export$84b191ede7d628ea);
const $6246fc483000f258$export$29e5f53cb4f38894 = [
    {
        planName: 'Free',
        offeringSku: $6246fc483000f258$export$84b191ede7d628ea.free,
        recommendationLimit: 0,
        signupLimit: 100000
    },
    {
        planName: 'Standard',
        offeringSku: $6246fc483000f258$export$84b191ede7d628ea.standard,
        recommendationLimit: 3,
        signupLimit: 100000
    },
    {
        planName: 'Premium',
        offeringSku: $6246fc483000f258$export$84b191ede7d628ea.premium,
        recommendationLimit: 50,
        signupLimit: 100000
    },
    {
        planName: 'Enterprise',
        offeringSku: $6246fc483000f258$export$84b191ede7d628ea.enterprise,
        recommendationLimit: 250,
        signupLimit: 100000,
        minUnitCount: $6246fc483000f258$export$3df704b75c4818f2
    }
];
const $6246fc483000f258$export$7c96cfb0c18bfb05 = {
    monthly: true,
    annual: true
};

});

parcelRegister("fhn1A", function(module, exports) {
$parcel$export(module.exports, "useProviderProps", function () { return $00fd412ee2189aba$export$521c373ccc32c300; });

var $17RBn = parcelRequire("17RBn");

var $hu3Tl = parcelRequire("hu3Tl");

var $aTHox = parcelRequire("aTHox");

var $7dhmX = parcelRequire("7dhmX");

var $29JVp = parcelRequire("29JVp");

var $44C4o = parcelRequire("44C4o");

var $j1ORI = parcelRequire("j1ORI");

var $lc7EO = parcelRequire("lc7EO");

var $4utnL = parcelRequire("4utnL");

var $9Nmuw = parcelRequire("9Nmuw");

var $fEBe5 = parcelRequire("fEBe5");

var $hGYMM = parcelRequire("hGYMM");

var $YmHME = parcelRequire("YmHME");

var $1CtPM = parcelRequire("1CtPM");
function $00fd412ee2189aba$export$521c373ccc32c300(props) {
    const { plans: plans, product: product, inputValues: inputValues } = props;
    const billingCycle = inputValues?.billingCycle;
    const unitCount = inputValues?.unitCount;
    const locale = (0, $17RBn.useLocale)();
    const currencyISOCode = (0, $hu3Tl.getCurrencyFromUserLocale)(locale);
    // GWP-10907: single source of truth for which JPD plan-limit configs
    // are active for the current request. Must be called unconditionally
    // at the top per the Rules of Hooks (the result is only USED in the
    // `product === "product-discovery"` branch below).
    const jpdPlanLimitConfigs = $lc7EO.useJpdPlanLimitConfigs();
    let ssrData = plans.reduce((acc, plan)=>{
        if (!plan.pricingPlan) return acc;
        return {
            ...acc,
            [plan.fields.sku]: plan.pricingPlan
        };
    }, {});
    ssrData = Object.keys(ssrData).length === 0 ? undefined : ssrData;
    const { data: ccpPricingData, status: status } = (0, $1CtPM.useCcpPricingData)({
        offeringSkus: plans.map((plan)=>plan.fields.sku),
        ssrData: ssrData
    });
    if (status === 'error') return {
        status: 'error'
    };
    if (status === 'pending') return {
        status: 'pending'
    };
    if (product === 'jira') return {
        status: 'ready',
        props: {
            inputValues: {
                billingCycle: billingCycle ?? $j1ORI.JIRA_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount ?? $j1ORI.JIRA_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $j1ORI.jiraPlanLimitConfigs,
                unitMinEnterprise: $j1ORI.JIRA_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: {
                    monthly: true,
                    annual: true
                }
            }
        }
    };
    if (product === 'confluence') return {
        status: 'ready',
        props: {
            inputValues: {
                billingCycle: billingCycle ?? $29JVp.CONFLUENCE_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount ?? $29JVp.CONFLUENCE_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $29JVp.confluencePlanLimitConfigs,
                unitMinEnterprise: $29JVp.CONFLUENCE_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: {
                    monthly: true,
                    annual: true
                }
            }
        }
    };
    if (product === 'teamwork') return {
        status: 'ready',
        props: {
            inputValues: {
                billingCycle: billingCycle ?? $YmHME.TEAMWORK_COLLECTION_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount ?? $YmHME.TEAMWORK_COLLECTION_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $YmHME.teamworkCollectionPlanLimitConfigs,
                unitMinEnterprise: $YmHME.TEAMWORK_COLLECTION_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $YmHME.teamworkCollectionBillingCycleConfig
            }
        }
    };
    if (product === 'guard') return {
        status: 'ready',
        props: {
            inputValues: {
                billingCycle: billingCycle ?? $44C4o.GUARD_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount ?? $44C4o.GUARD_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $44C4o.guardPlanLimitConfigs,
                unitMinEnterprise: $44C4o.GUARD_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $44C4o.guardBillingCycleConfig
            }
        }
    };
    if (product === 'bitbucket') return {
        status: 'ready',
        props: {
            inputValues: {
                billingCycle: billingCycle ?? $aTHox.BITBUCKET_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount ?? $aTHox.BITBUCKET_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $aTHox.bitbucketPlanLimitConfigs,
                unitMinEnterprise: $aTHox.BITBUCKET_MIN_ENTERPRISE_USER_COUNT,
                // bitbucket only supports USD
                currencyISOCode: 'USD',
                localeISOCode: locale,
                billingCycleConfig: $aTHox.bitbucketBillingCycleConfig
            }
        }
    };
    if (product === 'strategy') return {
        status: 'ready',
        props: {
            inputValues: {
                billingCycle: billingCycle ?? $hGYMM.STRATEGY_COLLECTION_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount ?? $hGYMM.STRATEGY_COLLECTION_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $hGYMM.strategyCollectionPlanLimitConfigs,
                unitMinEnterprise: $hGYMM.STRATEGY_COLLECTION_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $hGYMM.strategyCollectionBillingCycleConfig
            }
        }
    };
    if (product === 'compass') return {
        status: 'ready',
        props: {
            inputValues: {
                billingCycle: billingCycle ?? $7dhmX.COMPASS_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount ?? $7dhmX.COMPASS_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $7dhmX.compassPlanLimitConfigs,
                // not sure why this field is necessary
                unitMinEnterprise: $7dhmX.COMPASS_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $7dhmX.compassBillingCycleConfig
            }
        }
    };
    if (product === 'service') return {
        status: 'ready',
        props: {
            inputValues: {
                billingCycle: billingCycle ?? $fEBe5.SERVICE_COLLECTION_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount ?? $fEBe5.SERVICE_COLLECTION_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $fEBe5.serviceCollectionPlanLimitConfigs,
                unitMinEnterprise: $fEBe5.SERVICE_COLLECTION_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $fEBe5.serviceCollectionBillingCycleConfig
            }
        }
    };
    if (product === 'rovo-dev') return {
        status: 'ready',
        props: {
            inputValues: {
                billingCycle: billingCycle ?? $9Nmuw.ROVO_DEV_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount ?? $9Nmuw.ROVO_DEV_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $9Nmuw.rovoDevPlanLimitConfigs,
                unitMinEnterprise: $9Nmuw.ROVO_DEV_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $9Nmuw.rovoDevBillingCycleConfig
            }
        }
    };
    if (product === 'loom') return {
        status: 'ready',
        props: {
            inputValues: {
                billingCycle: billingCycle ?? $4utnL.LOOM_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount ?? $4utnL.LOOM_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $4utnL.loomPlanLimitConfigs,
                unitMinEnterprise: $4utnL.LOOM_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $4utnL.loomBillingCycleConfig
            }
        }
    };
    if (product === 'product-discovery') return {
        status: 'ready',
        props: {
            inputValues: {
                billingCycle: billingCycle ?? $lc7EO.JPD_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount ?? $lc7EO.JPD_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                // Single source of truth for which JPD SKUs are
                // "live" (gated behind the GWP-10907 feature flag).
                // The downstream resilience guard in
                // `UniformPricingCalculator` will filter out any plan
                // whose SKU is not present here, so the Enterprise card
                // is automatically hidden when the FF is off.
                planLimitConfigs: jpdPlanLimitConfigs,
                unitMinEnterprise: $lc7EO.JPD_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $lc7EO.jpdBillingCycleConfig
            }
        }
    };
    throw new Error('unknown product');
}

});
parcelRegister("7dhmX", function(module, exports) {
$parcel$export(module.exports, "COMPASS_DEFAULT_BILLING_CYCLE", function () { return $50757f59ceb0cbe4$export$2c789441f8bab310; });
$parcel$export(module.exports, "COMPASS_DEFAULT_UNIT_COUNT", function () { return $50757f59ceb0cbe4$export$887bc0e84eafd3c; });
$parcel$export(module.exports, "COMPASS_MIN_ENTERPRISE_USER_COUNT", function () { return $50757f59ceb0cbe4$export$862352663e0ac9d7; });
$parcel$export(module.exports, "compassOfferingSkus", function () { return $50757f59ceb0cbe4$export$f93fb5caff8c778a; });
$parcel$export(module.exports, "compassOfferingSkusArray", function () { return $50757f59ceb0cbe4$export$74a0fd94f40ef5c5; });
$parcel$export(module.exports, "compassPlanLimitConfigs", function () { return $50757f59ceb0cbe4$export$4df3b64d28e0d138; });
$parcel$export(module.exports, "compassBillingCycleConfig", function () { return $50757f59ceb0cbe4$export$e0b3f0eba764d747; });
const $50757f59ceb0cbe4$export$2c789441f8bab310 = 'MONTHLY';
const $50757f59ceb0cbe4$export$887bc0e84eafd3c = 300;
const $50757f59ceb0cbe4$export$862352663e0ac9d7 = Infinity;
const $50757f59ceb0cbe4$export$f93fb5caff8c778a = {
    free: 'compass-free',
    standard: 'compass-standard',
    premium: 'compass-premium-sku'
};
const $50757f59ceb0cbe4$export$74a0fd94f40ef5c5 = Object.values($50757f59ceb0cbe4$export$f93fb5caff8c778a);
const $50757f59ceb0cbe4$export$4df3b64d28e0d138 = [
    {
        planName: 'Free',
        offeringSku: $50757f59ceb0cbe4$export$f93fb5caff8c778a.free,
        recommendationLimit: 0,
        signupLimit: 3
    },
    {
        planName: 'Standard',
        offeringSku: $50757f59ceb0cbe4$export$f93fb5caff8c778a.standard,
        recommendationLimit: 3,
        signupLimit: 35000
    },
    {
        planName: 'Premium',
        offeringSku: $50757f59ceb0cbe4$export$f93fb5caff8c778a.premium,
        recommendationLimit: 250,
        signupLimit: 35000
    }
];
const $50757f59ceb0cbe4$export$e0b3f0eba764d747 = {
    monthly: true,
    annual: true
};

});

parcelRegister("29JVp", function(module, exports) {
$parcel$export(module.exports, "CONFLUENCE_DEFAULT_BILLING_CYCLE", function () { return $1e226e69d394223a$export$d60dc2d142b5e9dd; });
$parcel$export(module.exports, "CONFLUENCE_DEFAULT_UNIT_COUNT", function () { return $1e226e69d394223a$export$ab3750ec8101ffcc; });
$parcel$export(module.exports, "CONFLUENCE_MIN_ENTERPRISE_USER_COUNT", function () { return $1e226e69d394223a$export$f76a76b996ace375; });
$parcel$export(module.exports, "confluenceOfferingSkus", function () { return $1e226e69d394223a$export$ffe6d3f38b5f7c3a; });
$parcel$export(module.exports, "confluenceOfferingSkusArray", function () { return $1e226e69d394223a$export$39e8fbae2abd0443; });
$parcel$export(module.exports, "confluencePlanLimitConfigs", function () { return $1e226e69d394223a$export$53fbba6eb29a73ad; });
$parcel$export(module.exports, "confluenceBillingCycleConfig", function () { return $1e226e69d394223a$export$e8f1610e98745fd7; });
const $1e226e69d394223a$export$d60dc2d142b5e9dd = 'MONTHLY';
const $1e226e69d394223a$export$ab3750ec8101ffcc = 300;
const $1e226e69d394223a$export$f76a76b996ace375 = 801;
const $1e226e69d394223a$export$ffe6d3f38b5f7c3a = {
    free: 'confluence-free',
    standard: 'confluence-standard',
    premium: 'confluence-premium',
    enterprise: 'confluence-enterprise-sku'
};
const $1e226e69d394223a$export$39e8fbae2abd0443 = Object.values($1e226e69d394223a$export$ffe6d3f38b5f7c3a);
const $1e226e69d394223a$export$53fbba6eb29a73ad = [
    {
        planName: 'Free',
        offeringSku: $1e226e69d394223a$export$ffe6d3f38b5f7c3a.free,
        recommendationLimit: 0,
        signupLimit: 250000
    },
    {
        planName: 'Standard',
        offeringSku: $1e226e69d394223a$export$ffe6d3f38b5f7c3a.standard,
        recommendationLimit: 10,
        signupLimit: 250000
    },
    {
        planName: 'Premium',
        offeringSku: $1e226e69d394223a$export$ffe6d3f38b5f7c3a.premium,
        recommendationLimit: 250,
        signupLimit: 250000
    },
    {
        planName: 'Enterprise',
        offeringSku: $1e226e69d394223a$export$ffe6d3f38b5f7c3a.enterprise,
        recommendationLimit: 5000,
        signupLimit: 250000,
        minUnitCount: $1e226e69d394223a$export$f76a76b996ace375
    }
];
const $1e226e69d394223a$export$e8f1610e98745fd7 = {
    monthly: true,
    annual: true
};

});

parcelRegister("44C4o", function(module, exports) {
$parcel$export(module.exports, "GUARD_DEFAULT_BILLING_CYCLE", function () { return $757a4e832c1a582d$export$9be98af08cc25cad; });
$parcel$export(module.exports, "GUARD_DEFAULT_UNIT_COUNT", function () { return $757a4e832c1a582d$export$d28097ea69640bd5; });
$parcel$export(module.exports, "GUARD_MIN_ENTERPRISE_USER_COUNT", function () { return $757a4e832c1a582d$export$13b500e201e8b319; });
$parcel$export(module.exports, "guardOfferingSkus", function () { return $757a4e832c1a582d$export$91a420e9c7eb7c83; });
$parcel$export(module.exports, "guardOfferingSkusArray", function () { return $757a4e832c1a582d$export$159558c2b3d66b11; });
$parcel$export(module.exports, "guardPlanLimitConfigs", function () { return $757a4e832c1a582d$export$a2329ae21ff2ff84; });
$parcel$export(module.exports, "guardBillingCycleConfig", function () { return $757a4e832c1a582d$export$129a445945b6d9b3; });
const $757a4e832c1a582d$export$9be98af08cc25cad = 'MONTHLY';
const $757a4e832c1a582d$export$d28097ea69640bd5 = 100;
const $757a4e832c1a582d$export$13b500e201e8b319 = Infinity;
const $757a4e832c1a582d$export$91a420e9c7eb7c83 = {
    standard: 'atlassian-access-standard-sku',
    premium: 'atlassian-guard-premium-addon-sku'
};
const $757a4e832c1a582d$export$159558c2b3d66b11 = Object.values($757a4e832c1a582d$export$91a420e9c7eb7c83);
const $757a4e832c1a582d$export$a2329ae21ff2ff84 = [
    {
        planName: 'Standard',
        offeringSku: $757a4e832c1a582d$export$91a420e9c7eb7c83.standard,
        recommendationLimit: 0,
        signupLimit: 50000
    },
    {
        planName: 'Premium',
        offeringSku: $757a4e832c1a582d$export$91a420e9c7eb7c83.premium,
        recommendationLimit: 99,
        signupLimit: 50000
    }
];
const $757a4e832c1a582d$export$129a445945b6d9b3 = {
    monthly: true,
    annual: true
};

});

parcelRegister("j1ORI", function(module, exports) {
$parcel$export(module.exports, "JIRA_DEFAULT_BILLING_CYCLE", function () { return $2a2b2c5bc611aa86$export$c34e5566df36b6ba; });
$parcel$export(module.exports, "JIRA_DEFAULT_UNIT_COUNT", function () { return $2a2b2c5bc611aa86$export$6521a918e64524fb; });
$parcel$export(module.exports, "JIRA_MIN_ENTERPRISE_USER_COUNT", function () { return $2a2b2c5bc611aa86$export$9aef50cd5f48bb38; });
$parcel$export(module.exports, "jiraOfferingSkus", function () { return $2a2b2c5bc611aa86$export$7529f2cfeec98447; });
$parcel$export(module.exports, "jiraOfferingSkusArray", function () { return $2a2b2c5bc611aa86$export$b2b09200ca76754f; });
$parcel$export(module.exports, "jiraPlanLimitConfigs", function () { return $2a2b2c5bc611aa86$export$3070b86c7bc28aea; });
$parcel$export(module.exports, "jiraBillingCycleConfig", function () { return $2a2b2c5bc611aa86$export$7a133a10c706882b; });
const $2a2b2c5bc611aa86$export$c34e5566df36b6ba = 'MONTHLY';
const $2a2b2c5bc611aa86$export$6521a918e64524fb = 300;
const $2a2b2c5bc611aa86$export$9aef50cd5f48bb38 = 801;
const $2a2b2c5bc611aa86$export$7529f2cfeec98447 = {
    free: 'jira-software-free',
    standard: 'jira-software-standard',
    premium: 'jira-software-premium',
    enterprise: 'jira-software-enterprise-sku'
};
const $2a2b2c5bc611aa86$export$b2b09200ca76754f = Object.values($2a2b2c5bc611aa86$export$7529f2cfeec98447);
const $2a2b2c5bc611aa86$export$3070b86c7bc28aea = [
    {
        planName: 'Free',
        offeringSku: $2a2b2c5bc611aa86$export$7529f2cfeec98447.free,
        recommendationLimit: 0,
        signupLimit: 100000
    },
    {
        planName: 'Standard',
        offeringSku: $2a2b2c5bc611aa86$export$7529f2cfeec98447.standard,
        recommendationLimit: 10,
        signupLimit: 100000
    },
    {
        planName: 'Premium',
        offeringSku: $2a2b2c5bc611aa86$export$7529f2cfeec98447.premium,
        recommendationLimit: 250,
        signupLimit: 100000
    },
    {
        planName: 'Enterprise',
        offeringSku: $2a2b2c5bc611aa86$export$7529f2cfeec98447.enterprise,
        recommendationLimit: 5000,
        signupLimit: 100000,
        minUnitCount: $2a2b2c5bc611aa86$export$9aef50cd5f48bb38
    }
];
const $2a2b2c5bc611aa86$export$7a133a10c706882b = {
    monthly: true,
    annual: true
};

});

parcelRegister("4utnL", function(module, exports) {
$parcel$export(module.exports, "LOOM_DEFAULT_BILLING_CYCLE", function () { return $567bad4c99b6ec03$export$501dc9dfd5b2bde4; });
$parcel$export(module.exports, "LOOM_DEFAULT_UNIT_COUNT", function () { return $567bad4c99b6ec03$export$2aa1a93e0ac00fc; });
$parcel$export(module.exports, "LOOM_MIN_ENTERPRISE_USER_COUNT", function () { return $567bad4c99b6ec03$export$2a2f7d7a7ae18850; });
$parcel$export(module.exports, "loomOfferingSkus", function () { return $567bad4c99b6ec03$export$a64578a63428ae96; });
$parcel$export(module.exports, "loomOfferingSkusArray", function () { return $567bad4c99b6ec03$export$9f95f1c871571078; });
$parcel$export(module.exports, "loomPlanLimitConfigs", function () { return $567bad4c99b6ec03$export$ed1379ed8713d252; });
$parcel$export(module.exports, "loomBillingCycleConfig", function () { return $567bad4c99b6ec03$export$d2bfeac6f7899675; });
const $567bad4c99b6ec03$export$501dc9dfd5b2bde4 = 'MONTHLY';
const $567bad4c99b6ec03$export$2aa1a93e0ac00fc = 100;
const $567bad4c99b6ec03$export$2a2f7d7a7ae18850 = Infinity;
const $567bad4c99b6ec03$export$a64578a63428ae96 = {
    free: 'loom-free-sku',
    business: 'loom-business-sku',
    businessPlusAi: 'loom-business-ai-sku',
    enterprise: 'loom-enterprise-sku'
};
const $567bad4c99b6ec03$export$9f95f1c871571078 = Object.values($567bad4c99b6ec03$export$a64578a63428ae96);
const $567bad4c99b6ec03$export$ed1379ed8713d252 = [
    {
        planName: 'Free',
        offeringSku: $567bad4c99b6ec03$export$a64578a63428ae96.free,
        recommendationLimit: Infinity,
        signupLimit: 50000
    },
    {
        planName: 'Business',
        offeringSku: $567bad4c99b6ec03$export$a64578a63428ae96.business,
        recommendationLimit: Infinity,
        signupLimit: 50000
    },
    {
        planName: 'Business + AI',
        offeringSku: $567bad4c99b6ec03$export$a64578a63428ae96.businessPlusAi,
        recommendationLimit: 0,
        signupLimit: 50000
    },
    {
        planName: 'Enterprise',
        offeringSku: $567bad4c99b6ec03$export$a64578a63428ae96.enterprise,
        recommendationLimit: Infinity,
        signupLimit: 50000
    }
];
const $567bad4c99b6ec03$export$d2bfeac6f7899675 = {
    monthly: true,
    annual: true
};

});

parcelRegister("hGYMM", function(module, exports) {
$parcel$export(module.exports, "STRATEGY_COLLECTION_DEFAULT_BILLING_CYCLE", function () { return $45ceb3dd2bb22ad6$export$c00ddd271304729a; });
$parcel$export(module.exports, "STRATEGY_COLLECTION_DEFAULT_UNIT_COUNT", function () { return $45ceb3dd2bb22ad6$export$27579c7f06007c25; });
$parcel$export(module.exports, "STRATEGY_COLLECTION_MIN_ENTERPRISE_USER_COUNT", function () { return $45ceb3dd2bb22ad6$export$a99f1f06dfc3702a; });
$parcel$export(module.exports, "strategyCollectionOfferingSkus", function () { return $45ceb3dd2bb22ad6$export$8427e2db10f569be; });
$parcel$export(module.exports, "strategyCollectionOfferingSkusArray", function () { return $45ceb3dd2bb22ad6$export$3b4c7d53b38ef615; });
$parcel$export(module.exports, "strategyCollectionPlanLimitConfigs", function () { return $45ceb3dd2bb22ad6$export$bc4927fbd68771ac; });
$parcel$export(module.exports, "strategyCollectionBillingCycleConfig", function () { return $45ceb3dd2bb22ad6$export$2225b2a65811f064; });
const $45ceb3dd2bb22ad6$export$c00ddd271304729a = 'ANNUAL';
const $45ceb3dd2bb22ad6$export$27579c7f06007c25 = 50;
const $45ceb3dd2bb22ad6$export$a99f1f06dfc3702a = 50;
const $45ceb3dd2bb22ad6$export$8427e2db10f569be = {
    enterprise: 'strategy-collection-enterprise-sku'
};
const $45ceb3dd2bb22ad6$export$3b4c7d53b38ef615 = Object.values($45ceb3dd2bb22ad6$export$8427e2db10f569be);
const $45ceb3dd2bb22ad6$export$bc4927fbd68771ac = [
    {
        planName: 'Enterprise',
        offeringSku: $45ceb3dd2bb22ad6$export$8427e2db10f569be.enterprise,
        recommendationLimit: 2000,
        signupLimit: 2000,
        minUnitCount: $45ceb3dd2bb22ad6$export$a99f1f06dfc3702a
    }
];
const $45ceb3dd2bb22ad6$export$2225b2a65811f064 = {
    monthly: false,
    annual: true
};

});

parcelRegister("YmHME", function(module, exports) {
$parcel$export(module.exports, "TEAMWORK_COLLECTION_DEFAULT_BILLING_CYCLE", function () { return $bf49a3d87bcf04a1$export$5784a04bb778d3c1; });
$parcel$export(module.exports, "TEAMWORK_COLLECTION_DEFAULT_UNIT_COUNT", function () { return $bf49a3d87bcf04a1$export$482604a575f7b4a5; });
$parcel$export(module.exports, "TEAMWORK_COLLECTION_MIN_ENTERPRISE_USER_COUNT", function () { return $bf49a3d87bcf04a1$export$da0d6abd6eaa52b2; });
$parcel$export(module.exports, "teamworkCollectionOfferingSkus", function () { return $bf49a3d87bcf04a1$export$2e2107bfa20be1d8; });
$parcel$export(module.exports, "teamworkCollectionOfferingSkusArray", function () { return $bf49a3d87bcf04a1$export$b61ab2c6a18de6d4; });
$parcel$export(module.exports, "teamworkCollectionPlanLimitConfigs", function () { return $bf49a3d87bcf04a1$export$88bcddbae46dd5f1; });
$parcel$export(module.exports, "teamworkCollectionBillingCycleConfig", function () { return $bf49a3d87bcf04a1$export$5861c5ce06e1556; });
const $bf49a3d87bcf04a1$export$5784a04bb778d3c1 = 'MONTHLY';
const $bf49a3d87bcf04a1$export$482604a575f7b4a5 = 300;
const $bf49a3d87bcf04a1$export$da0d6abd6eaa52b2 = 801;
const $bf49a3d87bcf04a1$export$2e2107bfa20be1d8 = {
    free: 'teamwork-collection-free-sku',
    standard: 'teamwork-collection-standard-sku',
    premium: 'teamwork-collection-premium-sku',
    enterprise: 'teamwork-collection-enterprise-sku'
};
const $bf49a3d87bcf04a1$export$b61ab2c6a18de6d4 = Object.values($bf49a3d87bcf04a1$export$2e2107bfa20be1d8);
const $bf49a3d87bcf04a1$export$88bcddbae46dd5f1 = [
    {
        planName: 'Free',
        offeringSku: $bf49a3d87bcf04a1$export$2e2107bfa20be1d8.free,
        recommendationLimit: 0,
        signupLimit: 10
    },
    {
        planName: 'Standard',
        offeringSku: $bf49a3d87bcf04a1$export$2e2107bfa20be1d8.standard,
        recommendationLimit: 0,
        signupLimit: 100000
    },
    {
        planName: 'Premium',
        offeringSku: $bf49a3d87bcf04a1$export$2e2107bfa20be1d8.premium,
        recommendationLimit: 0,
        signupLimit: 100000
    },
    {
        planName: 'Enterprise',
        offeringSku: $bf49a3d87bcf04a1$export$2e2107bfa20be1d8.enterprise,
        recommendationLimit: 5000,
        signupLimit: 100000,
        minUnitCount: $bf49a3d87bcf04a1$export$da0d6abd6eaa52b2
    }
];
const $bf49a3d87bcf04a1$export$5861c5ce06e1556 = {
    monthly: true,
    annual: true
};

});


parcelRegister("9evy5", function(module, exports) {
$parcel$export(module.exports, "recommended", function () { return $b8ce4f4c86785928$export$bc5b8d0824876806; });
$parcel$export(module.exports, "units", function () { return $b8ce4f4c86785928$export$fe0319385f0cf5a7; });
$parcel$export(module.exports, "perUserPerMonth", function () { return $b8ce4f4c86785928$export$d8b49137e99effc2; });
$parcel$export(module.exports, "perYear", function () { return $b8ce4f4c86785928$export$5eae4ab34e5b16ae; });
$parcel$export(module.exports, "aboveUnitMaxThreshold", function () { return $b8ce4f4c86785928$export$bf2ba8467ff15aa5; });
$parcel$export(module.exports, "belowUnitMinThreshold", function () { return $b8ce4f4c86785928$export$2e64ce41e89d1e18; });
$parcel$export(module.exports, "billedAnnually", function () { return $b8ce4f4c86785928$export$9e1a6bb525180618; });
$parcel$export(module.exports, "switchToAnnualToViewEnterprise", function () { return $b8ce4f4c86785928$export$3277af2b318f7bfa; });
$parcel$export(module.exports, "enterpriseJpyMessage", function () { return $b8ce4f4c86785928$export$68a1387c7d0a683f; });

var $fnHPc = parcelRequire("fnHPc");
const $b8ce4f4c86785928$export$bc5b8d0824876806 = (0, $fnHPc.defineMessage)({
    id: 'priceFinder.recommended',
    defaultMessage: 'Recommended'
});
const $b8ce4f4c86785928$export$fe0319385f0cf5a7 = (0, $fnHPc.defineMessages)({
    teamSizePrompt: {
        id: 'priceFinder.teamSizePrompt',
        defaultMessage: 'Team Size:'
    },
    usersUnitsLabel: {
        id: 'priceFinder.usersUnitsLabel',
        defaultMessage: 'users'
    },
    agentsUnitsLabel: {
        id: 'priceFinder.agentsUnitsLabel',
        defaultMessage: 'agents'
    }
});
const $b8ce4f4c86785928$export$d8b49137e99effc2 = (0, $fnHPc.defineMessage)({
    id: 'priceFinder.perUnitPerMonth',
    defaultMessage: 'per user / month'
});
const $b8ce4f4c86785928$export$5eae4ab34e5b16ae = (0, $fnHPc.defineMessage)({
    id: 'priceFinder.perYear',
    defaultMessage: 'per year'
});
const $b8ce4f4c86785928$export$bf2ba8467ff15aa5 = (0, $fnHPc.defineMessages)({
    default: {
        id: 'priceFinder.aboveUserMaxThreshold.default',
        defaultMessage: "Your user count exceeds this plan's limit"
    },
    cloudEnterprise: {
        id: 'priceFinder.aboveUserMaxThreshold.cloudEnterprise',
        defaultMessage: 'Talk to our sales team about pricing for Cloud Enterprise'
    },
    agents: {
        id: 'priceFinder.aboveUserMaxThreshold.agents',
        defaultMessage: "Your agent count exceeds this plan's limit"
    },
    specificCount: {
        id: 'priceFinder.aboveUserMaxThreshold.specificCount',
        defaultMessage: 'For teams of more than {lowerLimit}, contact our sales team.'
    },
    creators: {
        id: 'priceFinder.aboveUserMaxThreshold.creators',
        defaultMessage: "Your creator count exceeds this plan's limit"
    }
});
const $b8ce4f4c86785928$export$2e64ce41e89d1e18 = (0, $fnHPc.defineMessages)({
    cloudEnterprise: {
        id: 'priceFinder.belowUnitMinThreshold.cloudEnterprise',
        defaultMessage: 'Enterprise plan pricing is available when you enter {minUnitCount} or more users above'
    }
});
const $b8ce4f4c86785928$export$9e1a6bb525180618 = (0, $fnHPc.defineMessage)({
    id: 'priceFinder.billedAnnually',
    defaultMessage: 'Billed annually.'
});
const $b8ce4f4c86785928$export$3277af2b318f7bfa = (0, $fnHPc.defineMessage)({
    id: 'priceFinder.switchToAnnualToViewEnterprise',
    defaultMessage: 'Switch to Annual billing above to view Enterprise pricing.'
});
const $b8ce4f4c86785928$export$68a1387c7d0a683f = (0, $fnHPc.defineMessage)({
    id: 'priceFinder.enterpriseJpyMessage',
    defaultMessage: 'For pricing details see FAQ below or talk to our sales team'
});

});

parcelRegister("juRep", function(module, exports) {
$parcel$export(module.exports, "PricingCalculatorCard", function () { return $1b9806dc7038eb23$export$14072311c149f96f; });

var $7VQPk = parcelRequire("7VQPk");

var $4G0xh = parcelRequire("4G0xh");

var $eCYOL = parcelRequire("eCYOL");

var $1NsjC = parcelRequire("1NsjC");

var $v7O5E = parcelRequire("v7O5E");

var $2Wido = parcelRequire("2Wido");

var $kBDDI = parcelRequire("kBDDI");

var $9hJtd = parcelRequire("9hJtd");

var $aTHox = parcelRequire("aTHox");

var $7dhmX = parcelRequire("7dhmX");

var $29JVp = parcelRequire("29JVp");

var $44C4o = parcelRequire("44C4o");

var $j1ORI = parcelRequire("j1ORI");

var $lc7EO = parcelRequire("lc7EO");

var $4utnL = parcelRequire("4utnL");

var $9Nmuw = parcelRequire("9Nmuw");

var $fEBe5 = parcelRequire("fEBe5");

var $hGYMM = parcelRequire("hGYMM");

var $YmHME = parcelRequire("YmHME");
const $1b9806dc7038eb23$export$14072311c149f96f = (props)=>{
    const sku = props.planData.fields.sku;
    const trackingProductKey = (0, $4G0xh.urlSlugToDataProductKey)[props.urlSlug];
    switch(sku){
        // Free
        case (0, $j1ORI.jiraOfferingSkus).free:
        case (0, $29JVp.confluenceOfferingSkus).free:
        case (0, $YmHME.teamworkCollectionOfferingSkus).free:
        case (0, $7dhmX.compassOfferingSkus).free:
        case (0, $aTHox.bitbucketOfferingSkus).free:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.FreePriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        // Standard
        case (0, $j1ORI.jiraOfferingSkus).standard:
        case (0, $29JVp.confluenceOfferingSkus).standard:
        case (0, $YmHME.teamworkCollectionOfferingSkus).standard:
        case (0, $44C4o.guardOfferingSkus).standard:
        case (0, $7dhmX.compassOfferingSkus).standard:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.StandardPriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        case (0, $aTHox.bitbucketOfferingSkus).standard:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eCYOL.BitbucketStandardPriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        // Premium
        case (0, $j1ORI.jiraOfferingSkus).premium:
        case (0, $29JVp.confluenceOfferingSkus).premium:
        case (0, $YmHME.teamworkCollectionOfferingSkus).premium:
        case (0, $44C4o.guardOfferingSkus).premium:
        case (0, $7dhmX.compassOfferingSkus).premium:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.PremiumPriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        case (0, $aTHox.bitbucketOfferingSkus).premium:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eCYOL.BitbucketPremiumPriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        // Enterprise
        case (0, $j1ORI.jiraOfferingSkus).enterprise:
        case (0, $29JVp.confluenceOfferingSkus).enterprise:
        case (0, $YmHME.teamworkCollectionOfferingSkus).enterprise:
            // @ts-ignore
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.EnterprisePriceCard), {
                ...props
            });
        case (0, $hGYMM.strategyCollectionOfferingSkus).enterprise:
            // @ts-ignore
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.EnterprisePriceCard), {
                ...props,
                isJpyPriceEnabled: true
            });
        // Custom, for any tier
        case (0, $9Nmuw.rovoDevOfferingSkus).standard:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kBDDI.RovoDevStandardPriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        case (0, $fEBe5.serviceCollectionOfferingSkus).free:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9hJtd.ServiceCollectionFreePriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        case (0, $fEBe5.serviceCollectionOfferingSkus).standard:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9hJtd.ServiceCollectionStandardPriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        case (0, $fEBe5.serviceCollectionOfferingSkus).premium:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9hJtd.ServiceCollectionPremiumPriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        case (0, $fEBe5.serviceCollectionOfferingSkus).enterprise:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9hJtd.ServiceCollectionEnterprisePriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        case (0, $4utnL.loomOfferingSkus).free:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $v7O5E.LoomFreePriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        case (0, $4utnL.loomOfferingSkus).business:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $v7O5E.LoomBusinessPriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        case (0, $4utnL.loomOfferingSkus).businessPlusAi:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $v7O5E.LoomBusinessPlusAiPriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        case (0, $4utnL.loomOfferingSkus).enterprise:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $v7O5E.LoomEnterprisePriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        case (0, $lc7EO.jpdOfferingSkus).free:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1NsjC.JiraProductDiscoveryFreePriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        case (0, $lc7EO.jpdOfferingSkus).standard:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1NsjC.JiraProductDiscoveryStandardPriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        case (0, $lc7EO.jpdOfferingSkus).premium:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1NsjC.JiraProductDiscoveryPremiumPriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        case (0, $lc7EO.jpdOfferingSkus).enterprise:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1NsjC.JiraProductDiscoveryEnterprisePriceCard), {
                ...props,
                trackingProductKey: trackingProductKey
            });
        default:
            // todo: @bsparks GWP-6943 fire an event for unexpected sku
            return null;
    }
};

});
parcelRegister("eCYOL", function(module, exports) {
$parcel$export(module.exports, "BitbucketStandardPriceCard", function () { return $cb5a2cb54b1cfed2$export$3f65201715c64fe0; });
$parcel$export(module.exports, "BitbucketPremiumPriceCard", function () { return $cb5a2cb54b1cfed2$export$3845e26e0454185b; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $aTHox = parcelRequire("aTHox");

var $9evy5 = parcelRequire("9evy5");

var $iXfHC = parcelRequire("iXfHC");

var $2Wido = parcelRequire("2Wido");
const $cb5a2cb54b1cfed2$export$3f65201715c64fe0 = (props)=>{
    const intl = (0, $8e22h.default)();
    const formattedLimit = intl.formatNumber((0, $aTHox.BITBUCKET_SIGNUP_LIMIT));
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.StandardPriceCard), {
        ...props,
        priceAltElementForAboveMaxThreshold: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            children: intl.formatMessage($9evy5.aboveUnitMaxThreshold.specificCount, {
                lowerLimit: formattedLimit
            })
        })
    });
};
const $cb5a2cb54b1cfed2$export$3845e26e0454185b = (props)=>{
    const intl = (0, $8e22h.default)();
    const formattedLimit = intl.formatNumber((0, $aTHox.BITBUCKET_SIGNUP_LIMIT));
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.PremiumPriceCard), {
        ...props,
        priceAltElementForAboveMaxThreshold: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            children: intl.formatMessage($9evy5.aboveUnitMaxThreshold.specificCount, {
                lowerLimit: formattedLimit
            })
        })
    });
};

});
parcelRegister("iXfHC", function(module, exports) {
$parcel$export(module.exports, "PriceAltContainer", function () { return $886eaf760740e014$export$4e62248194b0727b; });
/* price-alt-container.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
parcelRequire("1oC0p");
const $886eaf760740e014$export$4e62248194b0727b = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ...props,
        className: (0, $2jatx.default)([
            "_1wybdlk8 _y3gn1h6o"
        ]),
        children: props.children
    });
};
const $886eaf760740e014$var$priceAltTextCss = null;

});

parcelRegister("2Wido", function(module, exports) {
$parcel$export(module.exports, "FreePriceCard", function () { return $fd07704e9f8e1231$export$75a717cafbbb6b29; });
$parcel$export(module.exports, "StandardPriceCard", function () { return $fd07704e9f8e1231$export$b2f3ad255eaef337; });
$parcel$export(module.exports, "PremiumPriceCard", function () { return $fd07704e9f8e1231$export$51a8509266751bd0; });
$parcel$export(module.exports, "EnterprisePriceCard", function () { return $fd07704e9f8e1231$export$ba2214b2dcd26743; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $BSG7c = parcelRequire("BSG7c");

var $2wDsW = parcelRequire("2wDsW");

var $lOlsU = parcelRequire("lOlsU");

var $8HBY7 = parcelRequire("8HBY7");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $gJe05 = parcelRequire("gJe05");

var $7khdS = parcelRequire("7khdS");

var $9Osbp = parcelRequire("9Osbp");

var $iXfHC = parcelRequire("iXfHC");

var $44bDI = parcelRequire("44bDI");

var $lbUj4 = parcelRequire("lbUj4");

var $1CtPM = parcelRequire("1CtPM");

var $9evy5 = parcelRequire("9evy5");

var $3V3tC = parcelRequire("3V3tC");
function $fd07704e9f8e1231$var$usePriceCardEvents(props) {
    const { productKey: productKey, edition: edition } = props;
    const tryIntent = (0, $2wDsW.useTryIntent)({
        containerId: (0, $BSG7c.PRICE_FINDER_CONTAINER),
        intentType: 'button',
        productKey: productKey,
        edition: edition
    });
    const handleClickCta = (0, $lOlsU.useFirePricingPlanCtaEvent)({
        edition: edition,
        productKey: productKey,
        containerId: (0, $BSG7c.PRICE_FINDER_CONTAINER)
    });
    return {
        onClick: ()=>{
            tryIntent.onClick();
            handleClickCta();
        },
        onKeyDown: tryIntent.onKeyDown
    };
}
const $fd07704e9f8e1231$var$FREE_EDITION = 'free';
const $fd07704e9f8e1231$var$JSM_BUNDLE = 'jira-service-management';
const $fd07704e9f8e1231$var$getPricingCardButtonHref = ({ ctaUrl: ctaUrl, edition: edition, shouldPropagateJsmIntent: shouldPropagateJsmIntent = false })=>{
    const url = new URL(ctaUrl, window.location.origin);
    url.searchParams.set('signupSource', 'pricing');
    if (shouldPropagateJsmIntent && url.pathname.endsWith('/try/cloud/signup') && (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).jsmGrowth528ImproveProvisioningWac)) {
        url.searchParams.set('bundle', $fd07704e9f8e1231$var$JSM_BUNDLE);
        url.searchParams.set('edition', edition);
    }
    return url.toString();
};
const $fd07704e9f8e1231$export$75a717cafbbb6b29 = (props)=>{
    const { planData: planData, topSectionStyle: topSectionStyle, bottomSectionStyle: bottomSectionStyle, customBannerText: customBannerText } = props;
    const fields = planData.fields;
    const state = (0, $gJe05.useCalculationState)({
        offeringSku: fields.sku
    });
    const intl = (0, $8e22h.default)();
    const currencyIsoCode = (0, $1CtPM.useSelector)((0, $3V3tC.getCurrencyIsoCode));
    const cta = fields.microCta?.[0]?.fields;
    const ctaUrl = (0, $7khdS.useLocalizedCtaUrl)(cta);
    const eventHandlers = $fd07704e9f8e1231$var$usePriceCardEvents({
        productKey: props.trackingProductKey,
        edition: $fd07704e9f8e1231$var$FREE_EDITION
    });
    const dataEventPropsLabel = `${$fd07704e9f8e1231$var$FREE_EDITION}-get-it-now`;
    const buttonHref = $fd07704e9f8e1231$var$getPricingCardButtonHref({
        ctaUrl: ctaUrl,
        edition: $fd07704e9f8e1231$var$FREE_EDITION,
        shouldPropagateJsmIntent: props.shouldPropagateJsmIntent
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8HBY7.PricingCard), {
        hasBannerSlot: true,
        topSectionStyle: topSectionStyle,
        bottomSectionStyle: bottomSectionStyle,
        bannerText: customBannerText ?? (state.recommended && intl.formatMessage($9evy5.recommended)),
        title: fields.planTitleExternal,
        description: fields.planOneLiner,
        currencyIsoCode: currencyIsoCode,
        price: state.price,
        hasUnitSlot: true,
        hasRangeSlot: props.hasRangeSlot !== undefined ? props.hasRangeSlot : state.billingCycle === 'ANNUAL',
        buttonText: cta?.ctaButtonText,
        buttonVariant: state.recommended ? 'primary' : 'secondary',
        buttonHref: buttonHref,
        buttonProps: {
            onClick: eventHandlers.onClick,
            onKeyDown: eventHandlers.onKeyDown,
            dataEventProps: {
                'data-product-key': props.trackingProductKey,
                'data-event-component': 'linkButton',
                'data-event-container': (0, $BSG7c.PRICE_FINDER_CONTAINER),
                'data-event': 'clicked',
                'data-label': `${dataEventPropsLabel}`,
                'data-label-english': `${dataEventPropsLabel}`
            }
        },
        benefitsTitle: fields.highlightedFeaturesTitle,
        benefits: (0, $44bDI.getFeaturesList)(fields.highlightedFeaturesContainer)
    });
};
const $fd07704e9f8e1231$var$STANDARD_EDITION = 'standard';
const $fd07704e9f8e1231$var$PREMIUM_EDITION = 'premium';
const $fd07704e9f8e1231$export$b2f3ad255eaef337 = (props)=>/*#__PURE__*/ (0, $7VQPk.jsx)($fd07704e9f8e1231$var$CommonPriceCard, {
        ...props,
        edition: $fd07704e9f8e1231$var$STANDARD_EDITION
    });
const $fd07704e9f8e1231$export$51a8509266751bd0 = (props)=>/*#__PURE__*/ (0, $7VQPk.jsx)($fd07704e9f8e1231$var$CommonPriceCard, {
        ...props,
        edition: $fd07704e9f8e1231$var$PREMIUM_EDITION
    });
// eslint-disable-next-line complexity
const $fd07704e9f8e1231$var$CommonPriceCard = (props)=>{
    const { planData: planData, topSectionStyle: topSectionStyle, bottomSectionStyle: bottomSectionStyle, tierLabelType: tierLabelType, customBannerText: customBannerText } = props;
    const fields = planData.fields;
    const state = (0, $gJe05.useCalculationState)({
        offeringSku: fields.sku
    });
    const intl = (0, $8e22h.default)();
    const currencyIsoCode = (0, $1CtPM.useSelector)((0, $3V3tC.getCurrencyIsoCode));
    const dataEventPropsLabel = `${props.edition}-start-trial`;
    const cta = fields.microCta?.[0]?.fields;
    const ctaUrl = (0, $7khdS.useLocalizedCtaUrl)(cta);
    const eventHandlers = $fd07704e9f8e1231$var$usePriceCardEvents({
        productKey: props.trackingProductKey,
        edition: props.edition
    });
    const priceAltElement = (()=>{
        if (state.isUnitCountAboveMaxThreshold && props.priceAltElementForAboveMaxThreshold !== undefined) return props.priceAltElementForAboveMaxThreshold;
        return null;
    })();
    const buttonHref = $fd07704e9f8e1231$var$getPricingCardButtonHref({
        ctaUrl: ctaUrl,
        edition: props.edition,
        shouldPropagateJsmIntent: props.shouldPropagateJsmIntent
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8HBY7.PricingCard), {
        priceTestid: state.billingCycle === 'ANNUAL' ? 'annual-price' : 'monthly-price',
        hasRangeSlot: state.isUnitCountAboveMaxThreshold && currencyIsoCode === 'JPY' && state.billingCycle === 'ANNUAL',
        hasBannerSlot: true,
        topSectionStyle: topSectionStyle,
        bottomSectionStyle: bottomSectionStyle,
        bannerText: customBannerText ?? (state.recommended && intl.formatMessage($9evy5.recommended)),
        title: fields.planTitleExternal,
        description: fields.planOneLiner,
        currencyIsoCode: currencyIsoCode,
        price: !state.isUnitCountAboveMaxThreshold && state.price,
        priceAltElement: state.isUnitCountAboveMaxThreshold && props.priceAltElementForAboveMaxThreshold !== undefined ? priceAltElement : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            children: intl.formatMessage($9evy5.aboveUnitMaxThreshold.default)
        }),
        unit: state.isUnitCountAboveMaxThreshold ? undefined : state.billingCycle === 'MONTHLY' ? props.monthlyPerUserLabel ?? intl.formatMessage($9evy5.perUserPerMonth) : intl.formatMessage($9evy5.perYear),
        hasUnitSlot: true,
        range: state.billingCycle === 'ANNUAL' && !props.omitRange && !state.isUnitCountAboveMaxThreshold && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lbUj4.UserTier), {
            // @ts-ignore
            unitLimitLower: state.unitTierLowerBound,
            // @ts-ignore
            unitLimitUpper: state.unitTierUpperBound,
            unitType: tierLabelType
        }),
        tooltipContent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lbUj4.UserTierExpanded), {
            // @ts-ignore
            unitLimitLower: state.unitTierLowerBound,
            // @ts-ignore
            unitLimitUpper: state.unitTierUpperBound,
            unitsInTier: state.unitCount,
            unitsAvailableInTier: state.unitsAvailableInTier
        }),
        buttonText: cta?.ctaButtonText,
        buttonHref: buttonHref,
        buttonDisabled: state.isUnitCountAboveMaxThreshold,
        buttonVariant: state.recommended || props.isSingleCard ? 'primary' : 'secondary',
        buttonProps: {
            onClick: eventHandlers.onClick,
            onKeyDown: eventHandlers.onKeyDown,
            dataEventProps: {
                'data-product-key': props.trackingProductKey,
                'data-event-component': 'linkButton',
                'data-event-container': (0, $BSG7c.PRICE_FINDER_CONTAINER),
                'data-event': 'clicked',
                'data-label': `${dataEventPropsLabel}`,
                'data-label-english': `${dataEventPropsLabel}`
            }
        },
        benefitsTitle: fields.highlightedFeaturesTitle,
        benefits: (0, $44bDI.getFeaturesList)(fields.highlightedFeaturesContainer)
    });
};
const $fd07704e9f8e1231$export$ba2214b2dcd26743 = (props)=>{
    const { planData: planData, topSectionStyle: topSectionStyle, bottomSectionStyle: bottomSectionStyle, showBannerText: showBannerText = true, isSingleCard: isSingleCard, tierLabelType: tierLabelType, customBannerText: customBannerText, isJpyPriceEnabled: isJpyPriceEnabled } = props;
    const fields = planData.fields;
    const state = (0, $gJe05.useCalculationState)({
        offeringSku: fields.sku
    });
    const intl = (0, $8e22h.default)();
    const currencyIsoCode = (0, $1CtPM.useSelector)((0, $3V3tC.getCurrencyIsoCode));
    const [_, changeBillingCycle] = (0, $1CtPM.useBillingCycle)();
    const priceAltElement = (()=>{
        if (props.priceAltElement !== undefined) return props.priceAltElement;
        if (currencyIsoCode === 'JPY' && !isJpyPriceEnabled) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            children: intl.formatMessage($9evy5.enterpriseJpyMessage)
        });
        if (state.billingCycle === 'MONTHLY') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            style: {
                paddingBlockEnd: '24px'
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9Osbp.MonthlyEnterpriseMessage), {
                switchToAnnual: ()=>changeBillingCycle('ANNUAL')
            })
        });
        if (state.isUnitCountAboveMaxThreshold) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            style: {
                paddingBlockEnd: '48px'
            },
            children: intl.formatMessage($9evy5.aboveUnitMaxThreshold.cloudEnterprise)
        });
        if (state.isUnitCountBelowMinThreshold) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            style: {
                paddingBlockEnd: '48px'
            },
            children: intl.formatMessage($9evy5.belowUnitMinThreshold.cloudEnterprise, {
                minUnitCount: state.unitCountMin
            })
        });
        return null;
    })();
    const isPriceShown = !state.isUnitCountAboveMaxThreshold && !priceAltElement;
    let price = undefined;
    let range = undefined;
    let tooltipContent = undefined;
    if (isPriceShown) {
        price = state.price;
        range = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lbUj4.UserTier), {
            // @ts-ignore
            unitLimitLower: state.unitTierLowerBound,
            // @ts-ignore
            unitLimitUpper: state.unitTierUpperBound,
            unitType: tierLabelType
        });
        tooltipContent = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lbUj4.UserTierExpanded), {
            // @ts-ignore
            unitLimitLower: state.unitTierLowerBound,
            // @ts-ignore
            unitLimitUpper: state.unitTierUpperBound,
            unitsInTier: state.unitCount,
            unitsAvailableInTier: state.unitsAvailableInTier
        });
    }
    const cta = fields.microCta?.[0]?.fields;
    const ctaUrl = (0, $7khdS.useLocalizedCtaUrl)(cta);
    const edition = 'enterprise';
    const eventHandlers = $fd07704e9f8e1231$var$usePriceCardEvents({
        productKey: props.trackingProductKey,
        edition: edition
    });
    const dataEventPropsLabel = `${edition}-contact-sales`;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8HBY7.PricingCard), {
        priceTestid: state.billingCycle === 'ANNUAL' ? 'annual-price' : 'monthly-price',
        hasBannerSlot: true,
        hasRangeSlot: currencyIsoCode === 'JPY' && state.billingCycle === 'ANNUAL',
        topSectionStyle: topSectionStyle,
        bottomSectionStyle: bottomSectionStyle,
        bannerText: customBannerText ?? (showBannerText && state.recommended && intl.formatMessage($9evy5.recommended)),
        title: fields.planTitleExternal,
        description: fields.planOneLiner,
        currencyIsoCode: currencyIsoCode,
        price: price,
        priceAltElement: priceAltElement,
        unit: // if a price alt element exists, there should be no unit
        priceAltElement ? undefined : !state.isUnitCountAboveMaxThreshold && !state.isUnitCountBelowMinThreshold ? intl.formatMessage($9evy5.perYear) : undefined,
        range: range,
        hasUnitSlot: // the unbounded text for the price alt element makes the unbounded
        currencyIsoCode === 'JPY',
        tooltipContent: tooltipContent,
        buttonText: cta?.ctaButtonText,
        buttonHref: ctaUrl,
        buttonVariant: state.recommended || isSingleCard ? 'primary' : 'secondary',
        buttonProps: {
            onClick: eventHandlers.onClick,
            onKeyDown: eventHandlers.onKeyDown,
            dataEventProps: {
                'data-product-key': props.trackingProductKey,
                'data-event-component': 'linkButton',
                'data-event-container': (0, $BSG7c.PRICE_FINDER_CONTAINER),
                'data-event': 'clicked',
                'data-label': `${dataEventPropsLabel}`,
                'data-label-english': `${dataEventPropsLabel}`
            }
        },
        benefitsTitle: fields.highlightedFeaturesTitle,
        // in order for us to render just the top section fo a pricing card, the contentful data must be empty/undefined
        benefits: (0, $44bDI.getFeaturesList)(fields.highlightedFeaturesContainer)
    });
};

});
parcelRegister("BSG7c", function(module, exports) {
$parcel$export(module.exports, "PRICE_FINDER_CONTAINER", function () { return $d0bc5feae5415d38$export$c5526af38120e3f; });
const $d0bc5feae5415d38$export$c5526af38120e3f = 'priceBlock';

});

parcelRegister("8HBY7", function(module, exports) {
$parcel$export(module.exports, "PricingCard", function () { return $70cbe8f32a7644b5$export$668dae926a178a9f; });
/* pricing-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $gqkLW = parcelRequire("gqkLW");

var $cwszX = parcelRequire("cwszX");

var $lqyi6 = parcelRequire("lqyi6");

var $g3AHF = parcelRequire("g3AHF");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jsxHL = parcelRequire("jsxHL");
const $70cbe8f32a7644b5$export$668dae926a178a9f = (props)=>{
    const { bannerText: bannerText, title: title, unit: unit, range: range, buttonText: buttonText, buttonDisabled: buttonDisabled, benefitsTitle: benefitsTitle, benefits: benefits, buttonVariant: buttonVariant = 'primary', buttonHref: buttonHref, description: description, currencyIsoCode: currencyIsoCode, price: price, priceAltElement: priceAltElement, tooltipContent: tooltipContent, buttonProps: buttonProps, calloutText: calloutText, link: link, linkText: linkText, topSectionStyle: topSectionStyle, bottomSectionStyle: bottomSectionStyle, isSingleCard: isSingleCard, hasUnitSlot: hasUnitSlot, hasLinkSlot: hasLinkSlot, hasCalloutSlot: hasCalloutSlot, hasRangeSlot: hasRangeSlot, hasBannerSlot: hasBannerSlot, priceTestid: priceTestid, buttonDataEventProps: buttonDataEventProps, linkDataEventProps: linkDataEventProps } = props;
    const intl = (0, $8e22h.default)();
    const uniqueId = (0, $1oC0p.useId)();
    const titleId = `pricing-card-title-${uniqueId}`;
    const buttonId = `pricing-card-button-${uniqueId}`;
    const linkId = `pricing-card-link-${uniqueId}`;
    const topSectionRecommendedStyles = null;
    const bottomSectionRecommendedStyles = null;
    const topSectionNeutralStyles = null;
    const bottomSectionNeutralStyles = null;
    const containerStyles = null;
    const bottomContainerStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1s1g1qsq _5fbc1qsq _1yxn15e8 _1ein15e8 _1ul91wdt",
                    isSingleCard && bannerText && "_mqm2go0a _191wgo0a _t51zgo0a _179r1rns",
                    isSingleCard && !bannerText && "_mqm2kze7 _191wkze7 _t51zkze7 _179r32ve"
                ]),
                style: {
                    ...topSectionStyle,
                    "--_vnkma9": (0, $6ZVlx.default)(isSingleCard ? `${(0, $kbpa7.wacToken)('corner.radius.card')}` : undefined),
                    "--_rfnhaj": (0, $6ZVlx.default)(!benefits ? `${(0, $kbpa7.wacToken)('corner.radius.card')}` : undefined),
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                    "--_1d7trqj": (0, $6ZVlx.default)(!benefits ? `1px solid ${(0, $kbpa7.wacToken)('color.primary.black')}` : undefined),
                    "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400')),
                    "--_1jl4ikm": (0, $6ZVlx.default)(!benefits ? `1px solid ${(0, $kbpa7.wacToken)('color.neutral.light400')}` : undefined)
                },
                children: [
                    bannerText ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_bfhk1pfd _1s1g1kw7 _5fbc1kw7 _ahbq1n1a _12l21n1a"
                        ]),
                        style: {
                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o _1p1dangw",
                                    "body-sm"
                                ]),
                                style: {
                                    // override the color from the typography styles
                                    color: (0, $kbpa7.wacToken)('color.neutral.light0'),
                                    // doesn't map to a type matrix in the design, so override
                                    fontSize: '0.75rem'
                                },
                                children: bannerText
                            })
                        })
                    }) : hasBannerSlot ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1q51v47k"
                        ])
                    }) : null,
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_bozg1ejb _y4ti1ejb _1q511ejb _1e0c1txw _4t3i1osq _2lx21bp4 _4cvr1h6o _40tuoahv _144t1ejb"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _2lx21bp4 _4cvr1h6o _4t3i1osq _1kq31ady"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _2lx21bp4 _4cvr1h6o _4t3i1osq _1egl1ejb"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1e0c1txw _2lx21bp4 _1bah1yb4 _4t3i1osq"
                                                ]),
                                                children: [
                                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                                                    id: titleId,
                                                                    className: (0, $2jatx.default)([
                                                                        "_y3gn1h6o _6rthidpf _1pfhidpf",
                                                                        "h4"
                                                                    ]),
                                                                    children: title
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                                    className: (0, $2jatx.default)([
                                                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o",
                                                                        "body-sm"
                                                                    ]),
                                                                    children: description
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    price && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                        children: price && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                            className: (0, $2jatx.default)([
                                                                "_1wyb1ylp _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1q511ejb _y3gn1h6o _k48p1fw0",
                                                                currencyIsoCode === 'JPY' && "_mteo1u1b",
                                                                "pricing-card-price h2"
                                                            ]),
                                                            "data-testid": priceTestid,
                                                            children: price
                                                        })
                                                    }),
                                                    !price && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                                                        children: priceAltElement
                                                    })
                                                ]
                                            }),
                                            unit && price && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                    className: (0, $2jatx.default)([
                                                        "_y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf _85i5khs7",
                                                        "body-sm"
                                                    ]),
                                                    style: {
                                                        "--_eb6eb7": (0, $6ZVlx.default)(range ? undefined : "var(--ds-space-300, 24px)")
                                                    },
                                                    children: unit
                                                })
                                            }),
                                            !unit && hasUnitSlot && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1tke1ady",
                                                    "unit-slot"
                                                ])
                                            }),
                                            range ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                                                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_1e0c1txw _2lx2vrvc _19pkidpf _2hwxidpf _otyridpf _18u0idpf _85i51ejb"
                                                    ]),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                            className: (0, $2jatx.default)([
                                                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                                                "body-sm"
                                                            ]),
                                                            children: range
                                                        }),
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                            className: (0, $2jatx.default)([
                                                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _4cvr1h6o _1bah1h6o _ahbq1b66"
                                                            ]),
                                                            children: tooltipContent && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gqkLW.default), {
                                                                content: tooltipContent,
                                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                                    role: "img",
                                                                    "aria-label": intl.formatMessage({
                                                                        id: 'pricing-card.tooltip.aria-label',
                                                                        defaultMessage: 'More information'
                                                                    }),
                                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cwszX.InfoIcon), {
                                                                        size: "small"
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            }) : hasRangeSlot ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_4t3i1crd _85i51ejb",
                                                    "range-slot"
                                                ])
                                            }) : null,
                                            (calloutText || hasCalloutSlot) && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o"
                                                ]),
                                                children: calloutText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                        className: (0, $2jatx.default)([
                                                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o _85i51ejb",
                                                            "body-sm"
                                                        ]),
                                                        children: calloutText
                                                    })
                                                }) : hasCalloutSlot ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_85i538v4"
                                                    ])
                                                }) : null
                                            })
                                        ]
                                    }),
                                    buttonText && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                        id: buttonId,
                                        variant: buttonVariant,
                                        size: "small",
                                        isDisabled: buttonDisabled,
                                        href: buttonHref,
                                        target: "_blank",
                                        "data-testid": "cta-button",
                                        ...buttonProps,
                                        className: "pricing-card-button",
                                        ariaLabelledby: `${buttonId} ${titleId}`,
                                        dataEventProps: buttonDataEventProps,
                                        children: buttonText
                                    })
                                ]
                            }),
                            typeof link === 'string' && linkText || typeof link === 'object' ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1q51gktf"
                                ]),
                                children: [
                                    typeof link === 'string' && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                        id: linkId,
                                        href: link,
                                        type: "primary",
                                        text: String(linkText),
                                        "aria-label": String(linkText),
                                        ariaLabelledby: `${linkId} ${titleId}`,
                                        dataEventProps: linkDataEventProps
                                    }),
                                    typeof link === 'object' && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                                        children: link
                                    })
                                ]
                            }) : hasLinkSlot ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_26vx1ejb _1tntgktf _1mjbglyw"
                                ]),
                                children: linkText
                            }) : null
                        ]
                    })
                ]
            }),
            benefits && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_2rko15e8 _1yxn1qsq _1ein1qsq",
                    isSingleCard && bannerText && "_179rgo0a _191wgo0a _t51zgo0a",
                    isSingleCard && !bannerText && "_179rkze7 _191wkze7 _t51zkze7"
                ]),
                style: {
                    ...bottomSectionStyle,
                    "--_rfnhaj": (0, $6ZVlx.default)(!benefits ? `${(0, $kbpa7.wacToken)('corner.radius.card')}` : undefined),
                    "--_vnkma9": (0, $6ZVlx.default)(isSingleCard ? `${(0, $kbpa7.wacToken)('corner.radius.card')}` : undefined),
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                    "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_ahbq1ejb _12l21ejb _mqm2n5xp"
                        ]),
                        style: {
                            "--_qtmnbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light300'))
                        }
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1yt41ejb _1e0c1txw _zulppxbi _2lx21bp4"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                    className: (0, $2jatx.default)([
                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48pni7l _syazeipq",
                                        "body-md"
                                    ]),
                                    children: benefitsTitle
                                })
                            }),
                            benefits?.map(({ label: label, details: details, lozengeText: lozengeText })=>details ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3AHF.Expand), {
                                    label: label,
                                    eventDataName: label,
                                    lozengeText: lozengeText,
                                    children: details
                                }, label) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                        className: (0, $2jatx.default)([
                                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _bozg19zt",
                                            "body-sm"
                                        ]),
                                        children: label
                                    })
                                }, label))
                        ]
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("g3AHF", function(module, exports) {
$parcel$export(module.exports, "Expand", function () { return $01c56c8250903469$export$49bd1dfb0ad29c40; });
/* expand.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $eY3N6 = parcelRequire("eY3N6");

var $Lp2P8 = parcelRequire("Lp2P8");

var $kbpa7 = parcelRequire("kbpa7");

var $jsxHL = parcelRequire("jsxHL");

var $jE3Ci = parcelRequire("jE3Ci");
const $01c56c8250903469$var$containerStyles = null;
// CSS to hide the default summary marker
const $01c56c8250903469$var$buttonStyles = null;
const $01c56c8250903469$export$49bd1dfb0ad29c40 = ({ children: children, label: label, expandedLabelText: expandedLabelText, eventDataName: eventDataName = 'expand', actionSubject: actionSubject = 'expand', boldLabel: boldLabel, chevronColor: chevronColor, isExpanded: isExpanded = false, lozengeText: lozengeText, lozengeAppearance: lozengeAppearance = 'blue' })=>{
    const [disableTransition, setDisableTransition] = (0, $1oC0p.useState)(true);
    const [expanded, setExpanded] = (0, $1oC0p.useState)(isExpanded);
    const [height, setHeight] = (0, $1oC0p.useState)(()=>{
        // "auto" if expanded on mount to avoid transition
        return isExpanded ? 'auto' : '0px';
    });
    const contentRef = (0, $1oC0p.useRef)(null);
    const contentId = (0, $1oC0p.useId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    (0, $1oC0p.useEffect)(()=>{
        setExpanded(isExpanded);
        if (contentRef.current && isExpanded) setHeight(contentRef.current.scrollHeight + 'px');
        else if (!isExpanded && contentRef.current) setHeight('0px');
    }, [
        isExpanded
    ]);
    const handleToggle = ()=>{
        if (disableTransition) setDisableTransition(false);
        if (!expanded && contentRef.current) {
            setHeight(contentRef.current.scrollHeight + 'px');
            setExpanded(true);
        } else if (expanded && contentRef.current) {
            setHeight(contentRef.current.scrollHeight + 'px'); // set to current height
            setTimeout(()=>setHeight('0px'), 10); // next tick to trigger transition
            setExpanded(false);
        }
        if (eventDataName) {
            const expandedDirectionLabel = !expanded ? 'open' : 'close';
            createAnalyticsEvent({
                eventType: 'ui',
                eventComponent: 'button',
                action: 'clicked',
                actionSubject: actionSubject ?? 'expand',
                source: 'expand-button',
                attributes: {
                    name: eventDataName,
                    label: expandedDirectionLabel,
                    direction: expandedDirectionLabel
                }
            }).fire();
        }
    };
    const handleTransitionEnd = ()=>{
        if (expanded && contentRef.current) setHeight('auto');
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulpftgi"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                type: "button",
                "data-testid": "expand-button",
                onClick: handleToggle,
                "aria-expanded": expanded,
                "aria-controls": contentId,
                className: (0, $2jatx.default)([
                    "_19itglyw _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _80omtlke _1e0c1txw _zulp1b66 _1ygb1qgu _1ah3yh40"
                ]),
                style: {
                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_4t3i1tcg _1bsb1tcg _t9ec1g85 _v564aob1",
                            chevronColor && "_syazu2ay"
                        ]),
                        style: {
                            "--_vcjhmp": (0, $6ZVlx.default)(expanded ? 'rotate(90deg)' : 'rotate(0deg)'),
                            "--_r33mjn": (0, $6ZVlx.default)(disableTransition ? 'none' : 'transform 0.1s ease-in-out'),
                            "--_1em7f5x": (0, $6ZVlx.default)((0, $kbpa7.wacToken)(chevronColor))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($Lp2P8))), {
                            label: "",
                            spacing: "spacious"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                            className: (0, $2jatx.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pfht94y _y3gn1e5h",
                                "body-sm"
                            ]),
                            style: {
                                fontWeight: boldLabel ? 700 : 'inherit'
                            },
                            children: [
                                expanded && expandedLabelText ? expandedLabelText : label,
                                ' ',
                                lozengeText && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jE3Ci.Lozenge), {
                                    text: lozengeText,
                                    appearance: lozengeAppearance
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "data-testid": "expand-content",
                id: contentId,
                ref: contentRef,
                onTransitionEnd: handleTransitionEnd,
                "aria-hidden": !expanded,
                className: (0, $2jatx.default)([
                    "_1reo15vq _18m915vq _v5641vd9 _4t3imry4 _bozg19zt"
                ]),
                style: {
                    "--_1gp6mdv": (0, $6ZVlx.default)(disableTransition ? '0s' : '0.15s ease-in-out'),
                    "--_roksyz": (0, $6ZVlx.default)(height)
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: "body-sm",
                        children: children
                    })
                })
            })
        ]
    });
};

});


parcelRegister("7khdS", function(module, exports) {
$parcel$export(module.exports, "useLocalizedCtaUrl", function () { return $85c9ce8b07ea27f8$export$b5e9728b9b8ebe33; });

var $jQ0cd = parcelRequire("jQ0cd");
function $85c9ce8b07ea27f8$export$b5e9728b9b8ebe33(ctaFields) {
    return (0, $jQ0cd.useLocalizedHref)(ctaFields?.ctaUrl ?? '');
}

});

parcelRegister("9Osbp", function(module, exports) {
$parcel$export(module.exports, "MonthlyEnterpriseMessage", function () { return $2abbf2119b6f777e$export$16f86c6a635bb9af; });
/* monthly-enterprise-message.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $kbpa7 = parcelRequire("kbpa7");

var $9evy5 = parcelRequire("9evy5");

var $iXfHC = parcelRequire("iXfHC");
const $2abbf2119b6f777e$export$16f86c6a635bb9af = (props)=>{
    const { switchToAnnual: switchToAnnual } = props;
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleClick = ()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'switchToAnnual',
            source: 'pricingCalculator',
            attributes: {
                label: 'billed annually'
            }
        }).fire();
        switchToAnnual();
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $iXfHC.PriceAltContainer), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                type: "button",
                onClick: handleClick,
                tabIndex: 0,
                className: (0, $2jatx.default)([
                    "_bfhk1j28 _19itidpf _80omtlke _syaz5hrz _ect41kw7 _1wyb1kw7 _vwz4idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _4bfu1r31 _1hms8stv _ajmmnqa1 _o5721q9c _30l3ftjs"
                ]),
                style: {
                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                    "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800'))
                },
                children: intl.formatMessage($9evy5.billedAnnually)
            }),
            "\xa0",
            intl.formatMessage($9evy5.switchToAnnualToViewEnterprise)
        ]
    });
};
const $2abbf2119b6f777e$var$buttonCss = null;

});

parcelRegister("lbUj4", function(module, exports) {
$parcel$export(module.exports, "UserTier", function () { return $b9de452da2cf6ac9$export$cd4f9ca719669f8d; });
$parcel$export(module.exports, "UserTierExpanded", function () { return $b9de452da2cf6ac9$export$a4c8408bf932bb2; });
/* user-tier.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $fnHPc = parcelRequire("fnHPc");
var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $iRMRa = parcelRequire("iRMRa");
const $b9de452da2cf6ac9$export$cd4f9ca719669f8d = (props)=>{
    const { unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper, numberFormatLocale: numberFormatLocale = 'en-US', unitType: unitType } = props;
    const formatNumber = new Intl.NumberFormat(numberFormatLocale).format;
    if (unitType === 'agent') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "PricingCalculator.agentTier.range",
        defaultMessage: "Agent tier: {lowerLimit} - {upperLimit}",
        values: {
            ...(0, $iRMRa.DEFAULT_VALUES),
            lowerLimit: formatNumber(unitLimitLower),
            upperLimit: formatNumber(unitLimitUpper)
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "PriceFunder.userTier.range",
        defaultMessage: "User tier: {lowerLimit} - {upperLimit}",
        values: {
            ...(0, $iRMRa.DEFAULT_VALUES),
            lowerLimit: formatNumber(unitLimitLower),
            upperLimit: formatNumber(unitLimitUpper)
        }
    });
};
const $b9de452da2cf6ac9$export$a4c8408bf932bb2 = (props)=>{
    const { unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper, unitsInTier: unitsInTier, unitsAvailableInTier: unitsAvailableInTier, numberFormatLocale: numberFormatLocale = 'en-US' } = props;
    const intl = (0, $8e22h.default)();
    const formatNumber = new Intl.NumberFormat(numberFormatLocale).format;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1wybdlk8 _ca0qidpf _u5f37vkz _n3tdidpf _19bv7vkz"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                children: [
                    intl.formatMessage($b9de452da2cf6ac9$var$messages.tier),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
                    formatNumber(unitLimitLower),
                    " - ",
                    formatNumber(unitLimitUpper)
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                children: [
                    intl.formatMessage($b9de452da2cf6ac9$var$messages.filledSeats),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
                    formatNumber(unitsInTier)
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                children: [
                    intl.formatMessage($b9de452da2cf6ac9$var$messages.availableSeats),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
                    formatNumber(unitsAvailableInTier)
                ]
            })
        ]
    });
};
const $b9de452da2cf6ac9$var$messages = (0, $fnHPc.defineMessages)({
    tier: {
        id: 'PriceFinder.userTier.tier',
        defaultMessage: 'Tier:'
    },
    filledSeats: {
        id: 'PriceFinder.userTier.filledSeats',
        defaultMessage: 'Filled seats:'
    },
    availableSeats: {
        id: 'PriceFinder.userTier.availableSeats',
        defaultMessage: 'Available seats:'
    }
});

});



parcelRegister("1NsjC", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryFreePriceCard", function () { return $bb1064deffe4f718$export$9301352401a96395; });
$parcel$export(module.exports, "JiraProductDiscoveryStandardPriceCard", function () { return $bb1064deffe4f718$export$f632b4bee5bd80fe; });
$parcel$export(module.exports, "JiraProductDiscoveryPremiumPriceCard", function () { return $bb1064deffe4f718$export$1fb355a43910f211; });
$parcel$export(module.exports, "JiraProductDiscoveryEnterprisePriceCard", function () { return $bb1064deffe4f718$export$df05cdb1f88cc3f9; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $9evy5 = parcelRequire("9evy5");

var $iXfHC = parcelRequire("iXfHC");

var $2Wido = parcelRequire("2Wido");
const $bb1064deffe4f718$export$9301352401a96395 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.FreePriceCard), {
        ...props
    });
};
const $bb1064deffe4f718$export$f632b4bee5bd80fe = (props)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.StandardPriceCard), {
        ...props,
        tierLabelType: "user",
        monthlyPerUserLabel: intl.formatMessage({
            id: 'JiraProductDiscoveryPriceCard.perCreatorPerMonth',
            defaultMessage: 'per creator / month'
        }),
        priceAltElementForAboveMaxThreshold: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            children: intl.formatMessage($9evy5.aboveUnitMaxThreshold.creators)
        })
    });
};
const $bb1064deffe4f718$export$1fb355a43910f211 = (props)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.PremiumPriceCard), {
        ...props,
        tierLabelType: "user",
        monthlyPerUserLabel: intl.formatMessage({
            id: 'JiraProductDiscoveryPriceCard.perCreatorPerMonth',
            defaultMessage: 'per creator / month'
        }),
        priceAltElementForAboveMaxThreshold: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            children: intl.formatMessage($9evy5.aboveUnitMaxThreshold.creators)
        })
    });
};
const $bb1064deffe4f718$export$df05cdb1f88cc3f9 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.EnterprisePriceCard), {
        ...props
    });
};

});

parcelRegister("v7O5E", function(module, exports) {
$parcel$export(module.exports, "LoomFreePriceCard", function () { return $c7b8be01488760da$export$947796c8957ff6ff; });
$parcel$export(module.exports, "LoomBusinessPriceCard", function () { return $c7b8be01488760da$export$2a7af2744a13b8c2; });
$parcel$export(module.exports, "LoomBusinessPlusAiPriceCard", function () { return $c7b8be01488760da$export$efaf4c20492b36b7; });
$parcel$export(module.exports, "LoomEnterprisePriceCard", function () { return $c7b8be01488760da$export$d88b84b01ca5e441; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $1CtPM = parcelRequire("1CtPM");

var $2Wido = parcelRequire("2Wido");
const $c7b8be01488760da$var$OMIT_TIER_UNIT_THRESHOLD = 26;
const $c7b8be01488760da$export$947796c8957ff6ff = (props)=>{
    const omitRange = $c7b8be01488760da$var$useOmitRange();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.FreePriceCard), {
        ...props,
        omitRange: omitRange,
        hasRangeSlot: omitRange ? false : undefined
    });
};
const $c7b8be01488760da$export$2a7af2744a13b8c2 = (props)=>{
    const omitRange = $c7b8be01488760da$var$useOmitRange();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.StandardPriceCard), {
        ...props,
        omitRange: omitRange
    });
};
const $c7b8be01488760da$export$efaf4c20492b36b7 = (props)=>{
    const omitRange = $c7b8be01488760da$var$useOmitRange();
    const intl = (0, $8e22h.default)();
    const customBannerText = intl.formatMessage({
        id: 'LoomBusinessPlusAiPriceCard.mostPopular',
        defaultMessage: 'Most popular'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.PremiumPriceCard), {
        ...props,
        omitRange: omitRange,
        customBannerText: customBannerText
    });
};
const $c7b8be01488760da$export$d88b84b01ca5e441 = (props)=>{
    const omitRange = $c7b8be01488760da$var$useOmitRange();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.EnterprisePriceCard), {
        ...props,
        omitRange: omitRange,
        priceAltElement: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {})
    });
};
const $c7b8be01488760da$var$useOmitRange = ()=>{
    const [billingCycle] = (0, $1CtPM.useBillingCycle)();
    const [unitCount] = (0, $1CtPM.useUnitCount)();
    return billingCycle === 'ANNUAL' && unitCount < $c7b8be01488760da$var$OMIT_TIER_UNIT_THRESHOLD;
};

});

parcelRegister("kBDDI", function(module, exports) {
$parcel$export(module.exports, "RovoDevStandardPriceCard", function () { return $429cde05ec573ae0$export$f0e8bcb2fb60056a; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $2Wido = parcelRequire("2Wido");
const $429cde05ec573ae0$export$f0e8bcb2fb60056a = (props)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.StandardPriceCard), {
        ...props,
        isSingleCard: true,
        monthlyPerUserLabel: intl.formatMessage({
            id: 'RovoDevStandardPriceCard.monthlyPerUserLabel',
            defaultMessage: 'per developer / month'
        })
    });
};

});

parcelRegister("9hJtd", function(module, exports) {
$parcel$export(module.exports, "ServiceCollectionFreePriceCard", function () { return $e9537e62b8dac42c$export$ce09fc7b6ac40092; });
$parcel$export(module.exports, "ServiceCollectionStandardPriceCard", function () { return $e9537e62b8dac42c$export$84affe19123eb209; });
$parcel$export(module.exports, "ServiceCollectionPremiumPriceCard", function () { return $e9537e62b8dac42c$export$1383d1ba03ed3746; });
$parcel$export(module.exports, "ServiceCollectionEnterprisePriceCard", function () { return $e9537e62b8dac42c$export$c277b80f2da61f89; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $1ka2O = parcelRequire("1ka2O");

var $2Wido = parcelRequire("2Wido");
const $e9537e62b8dac42c$var$SERVICE_COLLECTION_PRICING_PATH = '/collections/service/pricing';
const $e9537e62b8dac42c$var$JSM_BUNDLE = 'jira-service-management';
const $e9537e62b8dac42c$var$useShouldPropagateJsmIntent = ()=>{
    const location = (0, $1ka2O.useLocation)();
    const isServiceCollectionPricingPage = location.pathname.replace(/\/$/, '').endsWith($e9537e62b8dac42c$var$SERVICE_COLLECTION_PRICING_PATH);
    const hasExplicitJsmIntent = isServiceCollectionPricingPage && new URLSearchParams(location.search).get('bundle') === $e9537e62b8dac42c$var$JSM_BUNDLE;
    return hasExplicitJsmIntent;
};
const $e9537e62b8dac42c$export$ce09fc7b6ac40092 = (props)=>{
    const intl = (0, $8e22h.default)();
    const shouldPropagateJsmIntent = $e9537e62b8dac42c$var$useShouldPropagateJsmIntent();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.FreePriceCard), {
        ...props,
        shouldPropagateJsmIntent: shouldPropagateJsmIntent,
        tierLabelType: "agent",
        monthlyPerUserLabel: intl.formatMessage({
            id: 'ServiceCollectionPriceCard.perAgentPerMonth',
            defaultMessage: 'per agent / month'
        })
    });
};
const $e9537e62b8dac42c$export$84affe19123eb209 = (props)=>{
    const intl = (0, $8e22h.default)();
    const shouldPropagateJsmIntent = $e9537e62b8dac42c$var$useShouldPropagateJsmIntent();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.StandardPriceCard), {
        ...props,
        shouldPropagateJsmIntent: shouldPropagateJsmIntent,
        tierLabelType: "agent",
        monthlyPerUserLabel: intl.formatMessage({
            id: 'ServiceCollectionPriceCard.perAgentPerMonth',
            defaultMessage: 'per agent / month'
        })
    });
};
const $e9537e62b8dac42c$export$1383d1ba03ed3746 = (props)=>{
    const intl = (0, $8e22h.default)();
    const shouldPropagateJsmIntent = $e9537e62b8dac42c$var$useShouldPropagateJsmIntent();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.PremiumPriceCard), {
        ...props,
        shouldPropagateJsmIntent: shouldPropagateJsmIntent,
        tierLabelType: "agent",
        monthlyPerUserLabel: intl.formatMessage({
            id: 'ServiceCollectionPriceCard.perAgentPerMonth',
            defaultMessage: 'per agent / month'
        })
    });
};
const $e9537e62b8dac42c$export$c277b80f2da61f89 = (props)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.EnterprisePriceCard), {
        ...props,
        tierLabelType: "agent",
        monthlyPerUserLabel: intl.formatMessage({
            id: 'ServiceCollectionPriceCard.perAgentPerMonth',
            defaultMessage: 'per agent / month'
        })
    });
};

});



parcelRegister("fNAVV", function(module, exports) {
$parcel$export(module.exports, "pricingTitleInternal", function () { return $7e2f802cabb58fc1$export$e1fb2a6f4d847984; });
$parcel$export(module.exports, "getNonprofitPricingCalculatorData", function () { return $7e2f802cabb58fc1$export$3d0bcdd9a87aae52; });
$parcel$export(module.exports, "nonprofitPlanLimitOverrides", function () { return $7e2f802cabb58fc1$export$9338d3a2ffccb62; });

var $g0Z8A = parcelRequire("g0Z8A");

var $29JVp = parcelRequire("29JVp");

var $j1ORI = parcelRequire("j1ORI");

var $4utnL = parcelRequire("4utnL");

var $YmHME = parcelRequire("YmHME");
const $7e2f802cabb58fc1$export$e1fb2a6f4d847984 = {
    JIRA: 'Jira Pricing Page',
    CONFLUENCE: 'Confluence Pricing Page',
    TWC: 'Teamwork Collection Pricing Page',
    LOOM: 'Loom Pricing Page'
};
const $7e2f802cabb58fc1$export$3d0bcdd9a87aae52 = async ()=>{
    const result = await (0, $g0Z8A.getPricingCalculatorData)([
        $7e2f802cabb58fc1$export$e1fb2a6f4d847984.JIRA,
        $7e2f802cabb58fc1$export$e1fb2a6f4d847984.CONFLUENCE,
        $7e2f802cabb58fc1$export$e1fb2a6f4d847984.TWC,
        $7e2f802cabb58fc1$export$e1fb2a6f4d847984.LOOM
    ]);
    return $7e2f802cabb58fc1$var$omitEnterprisePlans(result);
};
const $7e2f802cabb58fc1$var$omitEnterprisePlans = (plansDataByProduct)=>{
    const jiraPlans = plansDataByProduct[$7e2f802cabb58fc1$export$e1fb2a6f4d847984.JIRA]?.filter((plan)=>{
        const sku = plan.pricingPlan?.sku;
        return sku !== (0, $j1ORI.jiraOfferingSkus).enterprise;
    }) ?? [];
    const confluencePlans = plansDataByProduct[$7e2f802cabb58fc1$export$e1fb2a6f4d847984.CONFLUENCE]?.filter((plan)=>{
        const sku = plan.pricingPlan?.sku;
        return sku !== (0, $29JVp.confluenceOfferingSkus).enterprise;
    }) ?? [];
    const teamworkCollectionPlans = plansDataByProduct[$7e2f802cabb58fc1$export$e1fb2a6f4d847984.TWC]?.filter((plan)=>{
        const sku = plan.pricingPlan?.sku;
        return sku !== (0, $YmHME.teamworkCollectionOfferingSkus).enterprise;
    }) ?? [];
    const loomPlans = plansDataByProduct[$7e2f802cabb58fc1$export$e1fb2a6f4d847984.LOOM]?.filter((plan)=>{
        const sku = plan.pricingPlan?.sku;
        return sku !== (0, $4utnL.loomOfferingSkus).enterprise;
    }) ?? [];
    return {
        [$7e2f802cabb58fc1$export$e1fb2a6f4d847984.JIRA]: jiraPlans,
        [$7e2f802cabb58fc1$export$e1fb2a6f4d847984.CONFLUENCE]: confluencePlans,
        [$7e2f802cabb58fc1$export$e1fb2a6f4d847984.TWC]: teamworkCollectionPlans,
        [$7e2f802cabb58fc1$export$e1fb2a6f4d847984.LOOM]: loomPlans
    };
};
const $7e2f802cabb58fc1$export$9338d3a2ffccb62 = {
    [$7e2f802cabb58fc1$export$e1fb2a6f4d847984.JIRA]: [
        {
            planName: 'Free',
            offeringSku: (0, $j1ORI.jiraOfferingSkus).free,
            recommendationLimit: 0,
            signupLimit: 100000
        },
        {
            planName: 'Standard',
            offeringSku: (0, $j1ORI.jiraOfferingSkus).standard,
            recommendationLimit: 10,
            signupLimit: 100000
        },
        {
            planName: 'Premium',
            offeringSku: (0, $j1ORI.jiraOfferingSkus).premium,
            recommendationLimit: 24,
            // ← Only difference from standard config
            signupLimit: 100000
        }
    ],
    [$7e2f802cabb58fc1$export$e1fb2a6f4d847984.CONFLUENCE]: [
        {
            planName: 'Free',
            offeringSku: (0, $29JVp.confluenceOfferingSkus).free,
            recommendationLimit: 0,
            signupLimit: 100000
        },
        {
            planName: 'Standard',
            offeringSku: (0, $29JVp.confluenceOfferingSkus).standard,
            recommendationLimit: 10,
            signupLimit: 100000
        },
        {
            planName: 'Premium',
            offeringSku: (0, $29JVp.confluenceOfferingSkus).premium,
            recommendationLimit: 24,
            // ← Only difference from standard config
            signupLimit: 100000
        }
    ]
};

});
parcelRegister("g0Z8A", function(module, exports) {
$parcel$export(module.exports, "getPricingCalculatorData", function () { return $bfe47c5595fb2c89$export$ec56dd3792d0c55e; });

var $61WdP = parcelRequire("61WdP");
async function $bfe47c5595fb2c89$export$ec56dd3792d0c55e(pricingTitleInternals) {
    const contentClient = await (0, $61WdP.getContentfulContentClient)();
    const contentResult = await contentClient.getEntries({
        content_type: 'pricing',
        'fields.pricingTitleInternal[in]': pricingTitleInternals,
        select: [
            'sys',
            'fields.comparePlans',
            'fields.pricingTitleInternal',
            'fields.compareFeaturesTitle'
        ],
        include: 10
    });
    const productCatalogClient = (0, $61WdP.getContentfulProductCatalogClient)();
    const productCatalogResults = await Promise.all(contentResult.items.map((item)=>{
        const skus = item.fields.comparePlans.map((plan)=>plan.fields.sku);
        return productCatalogClient.getCCPPricingData(skus);
    }));
    const ccpPricingData = productCatalogResults.reduce((acc, result)=>{
        return {
            ...acc,
            ...result
        };
    }, {});
    return pricingTitleInternals.reduce((acc, pricingTitleInternal)=>{
        const product = contentResult.items.find((product)=>product.fields.pricingTitleInternal === pricingTitleInternal);
        const comparePlans = product?.fields.comparePlans;
        if (!comparePlans) return acc;
        acc[pricingTitleInternal] = comparePlans.map((plan)=>({
                ...plan,
                pricingPlan: ccpPricingData[plan.fields.sku]
            })) ?? [];
        return acc;
    }, {});
}

});


parcelRegister("437NE", function(module, exports) {
$parcel$export(module.exports, "useNonProfitPricingCalculatorData", function () { return $79b000344fbd80a7$export$5805edf503905c58; });

var $1oC0p = parcelRequire("1oC0p");

var $fNAVV = parcelRequire("fNAVV");
const $79b000344fbd80a7$export$5805edf503905c58 = ()=>{
    const [plansDataByProduct, setPlansDataByProduct] = (0, $1oC0p.useState)();
    const [error, setError] = (0, $1oC0p.useState)();
    const loadPricingCalculatorData = (0, $1oC0p.useCallback)(async ()=>{
        try {
            const result = await (0, $fNAVV.getNonprofitPricingCalculatorData)();
            setPlansDataByProduct(result);
        } catch (err) {
            setError(err);
        }
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        loadPricingCalculatorData();
    }, [
        loadPricingCalculatorData
    ]);
    return {
        plansDataByProduct: plansDataByProduct,
        error: error
    };
};

});


parcelRegister("g7wmQ", function(module, exports) {
$parcel$export(module.exports, "Banner", function () { return $fb264eb8fd8740ec$export$3b4e64e77073e307; });
/* banner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $kbpa7 = parcelRequire("kbpa7");

var $btggB = parcelRequire("btggB");
const $fb264eb8fd8740ec$var$bannerContainerCss = null;
const $fb264eb8fd8740ec$var$bodyCss = null;
const $fb264eb8fd8740ec$export$3b4e64e77073e307 = ()=>{
    const isGwp10027 = (0, $btggB.getIsGwp10027NonprofitPricingPage)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_bfhk5hrz _1e0c1txw _1bah1h6o _y3gn1e5h _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _uj6k1h6o"
        ]),
        style: {
            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_syazu67f _1wyb7vkz _19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fbxu3 _1bsb1osq _1kny1nu9 _13pm1r31 _1dzg8stv _t1u2nqa1"
            ]),
            children: [
                isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.banner.body.isGwp10027",
                    defaultMessage: "Small social impact teams can now access Teamwork Collection apps at 100% off."
                }),
                !isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.banner.body.gwp7869",
                    defaultMessage: "Social Enterprises are now eligible for Atlassian\u2019s discounted apps and support programs!"
                })
            ]
        })
    });
};

});

parcelRegister("fZJZd", function(module, exports) {
$parcel$export(module.exports, "EligibleSection", function () { return $12df217695235bc1$export$1830bba02ce6e4ac; });
/* eligible-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $hnmMQ = parcelRequire("hnmMQ");

var $iPPTB = parcelRequire("iPPTB");

var $btggB = parcelRequire("btggB");

var $61SXF = parcelRequire("61SXF");
const $12df217695235bc1$var$eligibleContainerCss = null;
const $12df217695235bc1$var$headerCss = null;
const $12df217695235bc1$var$subtitleCss = null;
const $12df217695235bc1$var$ctaBlockCss = null;
const $12df217695235bc1$var$ctaBlockContentCss = null;
const $12df217695235bc1$var$ctaBlockTitleCss = null;
const $12df217695235bc1$var$ctaBlockDetailCss = null;
const $12df217695235bc1$var$imageCss = null;
const $12df217695235bc1$export$1830bba02ce6e4ac = ()=>{
    const intl = (0, $8e22h.default)();
    const isGwp10027 = (0, $btggB.getIsGwp10027NonprofitPricingPage)();
    const learnMore = intl.formatMessage({
        id: 'NonprofitPage.eligible.cta.content.link',
        defaultMessage: 'Learn more'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o _y3gn1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_1wybzwfg _vwz410mc _k48p9y44 _19pkidpf _2hwxidpf _otyrdlk8 _18u0idpf _1s18ckbl _17gqckbl _15flidpf _1d2widpf _1svy7vkz _seovidpf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.eligible.header",
                    defaultMessage: "Who\u2019s eligible"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                className: (0, $2jatx.default)([
                    "_1wyb7vkz _vwz41tcg _k48p1nn1 _19pkidpf _2hwx1wug _otyr19bv _18u01wug _1s18gktf _17gq1f4h _b8yqbxu3 _15flidpf _1d2w1wug _1svygktf _seov1wug _3p1c1f4h _py5o1ylp _10jx1osq"
                ]),
                children: isGwp10027 ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.eligible.subtitle.gwp10027",
                    defaultMessage: "50% - 100% off discounts are available for nonprofits and social enterprises that are:"
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.eligible.subtitle.gwp7869",
                    defaultMessage: "Discounts on Atlassian Cloud apps are available to nonprofits and social enterprises that are:"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $61SXF.EligibilityListGwp7869), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1h6o _1bsb1osq _19pk12am _2hwxidpf _otyridpf _18u0idpf _1lrw1sh2 _12veeva1 _ca0q4bvh _u5f37vkz _n3td4bvh _19bv7vkz _kqswh2mm _1itk1sc7 _13hp18tu _b2g019fs _i6jx16xz _1lh77vkz _z3nc16xz _wpai7vkz _1vkhvle5 _7uci11oj _2cw21ssb _1l142xu9"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _1bah1h6o _1ako7vkz _c7s77vkz _4puvzwfg _1r3v7vkz"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                            className: (0, $2jatx.default)([
                                "_1wyb1tcg _vwz41ul9 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "NonprofitPage.eligible.cta.title",
                                defaultMessage: "Need more info?"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            className: (0, $2jatx.default)([
                                "_1wyb7vkz _vwz41tcg"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "NonprofitPage.eligible.cta.content",
                                defaultMessage: "Get the answers for your most frequently asked eligibility questions."
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                            text: learnMore,
                            "aria-label": learnMore,
                            href: "#faq",
                            type: "primary",
                            dataEventProps: {
                                'data-event-component': 'linkButton',
                                'data-event-container': 'Eligibility section',
                                'data-event': 'clicked',
                                'data-product-key': 'nonProfitCalculator'
                            }
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_p12f1obz _c71l7iqz _kqswstnw _rjxp1wqo _u7co15qf _mezj12it _bna712it _p5ceka7h _enhl9by0 _j0lc1osq _1jtm1osq _1t06x19p _wtm5ka7h"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                image: {
                                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8fhb444317uecxj0n4dy144u8atr503c.webp',
                                    alt: ''
                                }
                            })
                        })
                    ]
                })
            })
        ]
    });
};
$12df217695235bc1$export$1830bba02ce6e4ac.displayName = 'EligibleSection';

});
parcelRegister("61SXF", function(module, exports) {
$parcel$export(module.exports, "EligibilityListGwp7869", function () { return $2ffcccaddfe16e55$export$c64766b093b22842; });
/* eligibility-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");
const $2ffcccaddfe16e55$export$5a8c33720cbdacee = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("ul", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1n261g80 _1bah1yb4 _2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1cqi1ssb _498vusvi _1gee7vkz _18ts7vkz _75fp7vkz _r0eh7vkz _1yp81x1l"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($2ffcccaddfe16e55$var$NonGovernmental, {}),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                        image: {
                            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1665m6o0xxrphegnh7lnwf17585pj211.svg',
                            alt: ''
                        }
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                        className: (0, $2jatx.default)([
                            "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf _1s181tcg _17gq1ul9"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "NonprofitPage.card.title2",
                            defaultMessage: "Non-commercial"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fpcwi"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "NonprofitPage.card.content2",
                            defaultMessage: "operating on a not-for-profit basis and for the public benefit"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)($2ffcccaddfe16e55$var$NonPolitical, {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)($2ffcccaddfe16e55$var$Nonprofit, {})
        ]
    });
};
const $2ffcccaddfe16e55$export$c64766b093b22842 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("ul", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1n261g80 _1bah1yb4 _2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1cqi1ssb _498vusvi _1gee7vkz _18ts7vkz _75fp7vkz _r0eh7vkz _1yp81x1l"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($2ffcccaddfe16e55$var$NonGovernmental, {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)($2ffcccaddfe16e55$var$NonPolitical, {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)($2ffcccaddfe16e55$var$Nonprofit, {}),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                        image: {
                            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1665m6o0xxrphegnh7lnwf17585pj211.svg',
                            alt: ''
                        }
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                        className: (0, $2jatx.default)([
                            "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf _1s181tcg _17gq1ul9"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "NonprofitPage.card.socialMissionTitle",
                            defaultMessage: "For-profit with a social mission"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fpcwi"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "NonprofitPage.card.socialMissionContent",
                            defaultMessage: "<a>as defined by Atlassian</a> and verified by Goodstack",
                            values: {
                                a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                        href: "#faq",
                                        className: (0, $2jatx.default)([
                                            "_syaz5hrz _4bfu1r31 _1hms8stv _ajmmnqa1"
                                        ]),
                                        style: {
                                            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                        },
                                        children: chunks
                                    })
                            }
                        })
                    })
                ]
            })
        ]
    });
};
const $2ffcccaddfe16e55$var$NonGovernmental = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                image: {
                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4vunf5vd4cboe8glor3vep3mam3a3d0o.svg',
                    alt: ''
                }
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                className: (0, $2jatx.default)([
                    "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf _1s181tcg _17gq1ul9"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.card.title1",
                    defaultMessage: "Non-governmental"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fpcwi"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.card.content1",
                    defaultMessage: "independent from government control"
                })
            })
        ]
    });
};
const $2ffcccaddfe16e55$var$NonPolitical = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                image: {
                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/k1y270i4t5e33yp8hw62tn3l37850050.svg',
                    alt: ''
                }
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                className: (0, $2jatx.default)([
                    "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf _1s181tcg _17gq1ul9"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.card.title3",
                    defaultMessage: "Non-political"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fpcwi"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.card.content3",
                    defaultMessage: "or against any political party, candidate, or campaign"
                })
            })
        ]
    });
};
const $2ffcccaddfe16e55$var$Nonprofit = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                image: {
                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8q882ia8oh77fl481x8f01up4y2a2q18.svg',
                    alt: ''
                }
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                className: (0, $2jatx.default)([
                    "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf _1s181tcg _17gq1ul9"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.card.title4",
                    defaultMessage: "Recognized as a nonprofit"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fpcwi"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.card.content4",
                        defaultMessage: "in the country in which you are registered, in accordance with the "
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                        target: "_blank",
                        href: "https://goodstack.org/nonprofit-definitions",
                        rel: "noreferrer",
                        className: (0, $2jatx.default)([
                            "_syaz5hrz _4bfu1r31 _1hms8stv _ajmmnqa1"
                        ]),
                        style: {
                            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "NonprofitPage.card.content4.link",
                            defaultMessage: "eligibility criteria for that country"
                        })
                    })
                ]
            })
        ]
    });
};
const $2ffcccaddfe16e55$var$rowWrapperCss = null;
const $2ffcccaddfe16e55$var$cardTitleCss = null;
const $2ffcccaddfe16e55$var$cardContentCss = null;
const $2ffcccaddfe16e55$var$cardContentLinkCss = null;

});


parcelRegister("4bEWc", function(module, exports) {
$parcel$export(module.exports, "EnterpriseSection", function () { return $2c55cd82052437a3$export$f366cf0ae8139431; });
/* enterprise-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $2ivuE = parcelRequire("2ivuE");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");
const $2c55cd82052437a3$export$f366cf0ae8139431 = ()=>{
    const localizedCTAHRef = (0, $jQ0cd.useLocalizedHref)('/software/views/community-license-request#/');
    const containerStyles = null;
    const pictureStyles = null;
    const contentBlockStyles = null;
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1bsb1osq _p12f5o3v _zulpoahv _yv0ewxkt _4cvr1h6o _y3gn1e5h _1ph4hkll _gu181h6o _1qgn1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                        image: {
                            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/scjwn81w6s2ardgn7641002jp2ye5252.svg',
                            alt: ''
                        },
                        className: (0, $2jatx.default)([
                            "_6rthpxbi"
                        ])
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ivuE.ContentBlock), {
                        headerType: 'h3',
                        headerText: intl.formatMessage({
                            id: 'NonprofitPage.enterprise-section.heading.gwp7869',
                            defaultMessage: 'Enterprise plans are 50% off for eligible nonprofits and social enterprises.'
                        }),
                        ctaProps: {
                            buttonProps: {
                                text: intl.formatMessage({
                                    id: 'NonprofitPage.enterprise-section.cta',
                                    defaultMessage: 'Apply now'
                                }),
                                url: localizedCTAHRef
                            }
                        },
                        className: (0, $2jatx.default)([
                            "_1axibfyo _r8ntni7l _ggmhxy5q _qliy1pfd"
                        ]),
                        style: {
                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1rg21ssb _1h6o1ssb _rtys1osq _15pj1osq _bna71wug _1r2v1wug _1cr61wug _dusl1wug _1hlx1wug _atom1wug _18741wug _2t2f1wug _10ew1wug _1iya1wug"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                    image: {
                        src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/334g168on374sch67v7r1lrv174i8psc.webp',
                        alt: ''
                    }
                })
            })
        ]
    });
};
$2c55cd82052437a3$export$f366cf0ae8139431.displayName = 'EnterpriseSection';

});

parcelRegister("71t0B", function(module, exports) {
$parcel$export(module.exports, "Fineprint", function () { return $a19187bc89cb8b37$export$3fb2e06c2eeca703; });
/* fineprint.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $btggB = parcelRequire("btggB");
const $a19187bc89cb8b37$var$fineprintContainerCss = null;
const $a19187bc89cb8b37$var$headerCss = null;
const $a19187bc89cb8b37$var$bodyCss = null;
const $a19187bc89cb8b37$export$3fb2e06c2eeca703 = ()=>{
    const isGwp10027 = (0, $btggB.getIsGwp10027NonprofitPricingPage)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o _y3gn1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_1wybzwfg _k48p9y44 _19pkidpf _2hwxidpf _otyrdlk8 _18u0idpf _1s18ckbl _15flidpf _1d2widpf _1svy7vkz _seovidpf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.fineprint.header",
                    defaultMessage: "The fine print"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                className: (0, $2jatx.default)([
                    "_1wyb7vkz _19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fbxu3"
                ]),
                children: [
                    isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.fineprint.body.gwp10027",
                        defaultMessage: "Atlassian aims to unleash the potential of every team, including nonprofits and social enterprises, but not every organization may meet Atlassian\u2019s Social Impact License eligibility criteria."
                    }),
                    !isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.fineprint.body",
                        defaultMessage: "Atlassian aims to unleash the potential of every team, including nonprofits and social enterprises, but not every organization may meet Atlassian\u2019s Community License eligibility criteria."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                className: (0, $2jatx.default)([
                    "_1wyb7vkz _19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fbxu3"
                ]),
                children: [
                    isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.fineprint.body.additional",
                        defaultMessage: "Atlassian verifies Social Impact License eligibility in partnership with Goodstack, yet determines qualification for discounted licenses at its sole discretion. We reserve the right to grant or deny an individual or organization\u2019s application for a discounted license, or to discontinue an active discounted license, at any time, for any reason, and to supplement or amend our Social Impact License eligibility guidelines at any time."
                    }),
                    !isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.fineprint.body.additional",
                        defaultMessage: "Atlassian verifies Community License eligibility in partnership with Goodstack, yet determines qualification for discounted licenses at its sole discretion. We reserve the right to grant or deny an individual or organization\u2019s application for a discounted license, or to discontinue an active discounted license, at any time, for any reason, and to supplement or amend our Community License eligibility guidelines at any time."
                    })
                ]
            })
        ]
    });
};
$a19187bc89cb8b37$export$3fb2e06c2eeca703.displayName = 'FineprintSection';

});

parcelRegister("gtK7Z", function(module, exports) {
$parcel$export(module.exports, "Hero", function () { return $1f97debb6b62cf0e$export$887967f05dc521ae; });
/* hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $lmQGF = parcelRequire("lmQGF");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $btggB = parcelRequire("btggB");
const $1f97debb6b62cf0e$var$heroContainerCss = null;
const $1f97debb6b62cf0e$var$contentBoxCss = null;
const $1f97debb6b62cf0e$var$preheaderCss = null;
const $1f97debb6b62cf0e$var$titleCss = null;
const $1f97debb6b62cf0e$var$subtitleCss = null;
const $1f97debb6b62cf0e$var$mobileImageCss = null;
const $1f97debb6b62cf0e$export$887967f05dc521ae = ()=>{
    const ctaButtonUrl = '/software/views/community-license-request#/';
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _1reo15vq _18m915vq _1bsb1osq _1gnk1029 _p17a18tu _1u5reva1 _rb2g8y3i _ij141rp3 _1odr1on4 _18xueva1 _1o60asht"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_syaz1pfd _y3gn1h6o _kqswh2mm _1q51zwfg _p12f1fra _1waf16xz _44j9idpf _1tz91y44 _1enu1f4h"
            ]),
            style: {
                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("h5", {
                    className: (0, $2jatx.default)([
                        "_1wybf6fq _vwz41ou6 _1pfhidpf _6rth1skh _k48p1fw0 _1s18gktf _17gq1f4h _1ob91tcg"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.hero.preheader",
                        defaultMessage: "ATLASSIAN FOR NONPROFITS"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                    className: (0, $2jatx.default)([
                        "_1wyb1wqb _vwz4ymf6 _k48p1nn1 _1pfhidpf _6rthf6fq _1s18ymf6 _17gqys9h _b8yq1ogm _jhy41nn1"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.hero.title",
                        defaultMessage: "Pricing that fits your nonprofit\u2019s budget"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                    className: (0, $2jatx.default)([
                        "_1wybgktf _vwz41f4h _p12f1178 _k48powjs _19pkidpf _2hwx1wug _otyr1skh _18u01wug _1s181f4h _17gq1ylp _b8yq1kdj _15flidpf _1d2w1wug _1svyo7ao _seov1wug"
                    ]),
                    children: (0, $btggB.getIsGwp10027NonprofitPricingPage)() ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.hero.subtitle.gwp10027",
                        defaultMessage: "Get free and discounted Atlassian apps for nonprofit and social enterprise teams"
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.hero.subtitle.gwp7869",
                        defaultMessage: "Get discounted Atlassian apps for nonprofit and social enterprise teams"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                    variant: "primary",
                    size: "small",
                    color: "blue",
                    href: (0, $jQ0cd.useLocalizedHref)(ctaButtonUrl),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.hero.button",
                        defaultMessage: "Apply now"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _1bsbixjv _4t3iva7c _1sjrglyw _mezj1osq _bna71osq"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                        image: {
                            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8p5v165n7f507j620h6738eoudo17oae.svg',
                            alt: ''
                        }
                    })
                })
            ]
        })
    });
};

});

parcelRegister("k53CY", function(module, exports) {
$parcel$export(module.exports, "NonprofitCalculatorHeading", function () { return $5c9f5bc678cf4f45$export$ea62e9564a56df6c; });
/* nonprofit-calculator-heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");
const $5c9f5bc678cf4f45$export$ea62e9564a56df6c = ()=>{
    const headingStyles = null;
    const subtitleStyles = null;
    const imgStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _zulpftgi _p12fbxu3 _kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_k48p9y44 _1wyb1ylp _vwz48vuz _y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fz8o0 _1s18ckbl _b8yqstmo _syaz1pfd"
                ]),
                style: {
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.calculator.heading",
                    defaultMessage: "Choose the tools and pricing that fit your team"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_p12fkbql _y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.calculator.subheading.gwp7869",
                    defaultMessage: "Use our pricing calculator to get a <bold>discounted pricing estimate</bold> available to nonprofits and social enterprises.",
                    values: {
                        // eslint-disable-next-line react/no-unstable-nested-components
                        bold: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_k48p8n31"
                                ]),
                                children: chunks
                            })
                    }
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                image: {
                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/27360l8wso6a72x4e44yyg66uak8r51f.svg',
                    alt: ''
                },
                className: (0, $2jatx.default)([
                    "_1e0cglyw _kqswstnw _4t3ivrzy _1bsb1dqv _mmgk1wqo _kzvi1ule _11901pbv _dm251ule"
                ])
            })
        ]
    });
};
$5c9f5bc678cf4f45$export$ea62e9564a56df6c.displayName = 'TabbedCalculatorHeadingSection';

});

parcelRegister("lSpoK", function(module, exports) {
$parcel$export(module.exports, "NonprofitNav", function () { return $6309917ad16a803d$export$4dfedf5c077d010b; });
/* nonprofit-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $jQ0cd = parcelRequire("jQ0cd");

var $gn6Qa = parcelRequire("gn6Qa");
const $6309917ad16a803d$var$NonprofitLogo = ()=>{
    const logoCss = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            "_1e0c1mog _1wyb1k92 _ca0q1ou6 _u5f3idpf _n3tdgktf _19bvidpf _k48pni7l"
        ]),
        children: "Nonprofits"
    });
};
const $6309917ad16a803d$export$4dfedf5c077d010b = ()=>{
    const intl = (0, $8e22h.default)();
    const eligibilityHref = (0, $jQ0cd.useLocalizedHref)('/teams/nonprofits/discount-pricing');
    const supportPrograms = (0, $jQ0cd.useLocalizedHref)('/teams/nonprofits/support-programs');
    const resource = (0, $jQ0cd.useLocalizedHref)('/teams/nonprofits/resources');
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "nonprofit-nav",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gn6Qa.ProductPageNav), {
            isShowTryNowLink: false,
            productLogoUrl: "/teams/nonprofits",
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($6309917ad16a803d$var$NonprofitLogo, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: 'NonprofitPageTemplate.navbar.nonprofit-logo',
                defaultMessage: 'Nonprofit logo'
            }),
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($6309917ad16a803d$var$NonprofitLogo, {}),
            productPageNavLinks: [
                {
                    globalLinksKey: 'pricing',
                    linkText: intl.formatMessage({
                        id: 'NonprofitPageTemplate.navbar.pricing',
                        defaultMessage: 'Eligibility and pricing'
                    }),
                    hasDropdown: false,
                    productKey: 'nonprofit',
                    href: eligibilityHref
                },
                {
                    globalLinksKey: 'support',
                    linkText: intl.formatMessage({
                        id: 'NonprofitPageTemplate.navbar.support',
                        defaultMessage: 'Support programs'
                    }),
                    hasDropdown: false,
                    productKey: 'nonprofit',
                    href: supportPrograms
                },
                {
                    globalLinksKey: 'resources',
                    linkText: intl.formatMessage({
                        id: 'NonprofitPageTemplate.navbar.resources',
                        defaultMessage: 'Resources'
                    }),
                    hasDropdown: false,
                    productKey: 'nonprofit',
                    href: resource
                }
            ],
            mobileLinksSections: [
                {
                    mobileLinkKey: 'mobile-nonprofit',
                    mobileLinksProps: [
                        {
                            globalLinksKey: 'pricing',
                            linkText: intl.formatMessage({
                                id: 'NonprofitPageTemplate.navbar.pricing',
                                defaultMessage: 'Eligibility and pricing'
                            }),
                            hasDropdown: false,
                            productKey: 'nonprofit',
                            href: eligibilityHref
                        },
                        {
                            globalLinksKey: 'support',
                            linkText: intl.formatMessage({
                                id: 'NonprofitPageTemplate.navbar.support',
                                defaultMessage: 'Support programs'
                            }),
                            hasDropdown: false,
                            productKey: 'nonprofit',
                            href: supportPrograms
                        },
                        {
                            globalLinksKey: 'resources',
                            linkText: intl.formatMessage({
                                id: 'NonprofitPageTemplate.navbar.resources',
                                defaultMessage: 'Resources'
                            }),
                            hasDropdown: false,
                            productKey: 'nonprofit',
                            href: resource
                        }
                    ]
                }
            ]
        })
    });
};

});

parcelRegister("hJy82", function(module, exports) {
$parcel$export(module.exports, "OfficialSection", function () { return $a3701dad3ae12d03$export$dba159851b545af3; });
/* official-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $lmQGF = parcelRequire("lmQGF");

var $hnmMQ = parcelRequire("hnmMQ");

var $jQ0cd = parcelRequire("jQ0cd");

var $btggB = parcelRequire("btggB");
const $a3701dad3ae12d03$var$buttonStyle = null;
const $a3701dad3ae12d03$var$officialContainerCss = null;
const $a3701dad3ae12d03$var$headerCss = null;
const $a3701dad3ae12d03$var$subtitleCss = null;
const $a3701dad3ae12d03$var$rowWrapperCss = null;
const $a3701dad3ae12d03$var$cardTitleCss = null;
const $a3701dad3ae12d03$var$imageCss = null;
const $a3701dad3ae12d03$export$dba159851b545af3 = ()=>{
    const isGwp10027 = (0, $btggB.getIsGwp10027NonprofitPricingPage)();
    const ctaButtonUrl = '/software/views/community-license-request#/';
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o _y3gn1h6o _kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_1wybzwfg _vwz410mc _k48p9y44 _19pkidpf _2hwx1wug _otyrdlk8 _18u01wug _p12f1y37 _1s18ckbl _17gqckbl _b8yqbxu3 _15flidpf _1d2w1wug _1svy7vkz _seov1wug"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.official.header",
                    defaultMessage: "Let\u2019s make it official"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("h3", {
                className: (0, $2jatx.default)([
                    "_1wyb7vkz _vwz41tcg _k48p1nn1 _19pkidpf _2hwx1wug _otyr19bv _18u01wug _p12f1y37 _1lzogktf _119z1f4h _lg5ridpf _d97m1wug _1b7egktf _12521wug _3p1c1f4h _py5o1ylp _10jxbxu3 _dbjgidpf _1hvk1wug _isu4gktf _15qm1wug"
                ]),
                children: [
                    isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.official.subtitle.gwp10027",
                        defaultMessage: "Apply for your Social Impact License. Here\u2019s how it\u2019ll work."
                    }),
                    !isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.official.subtitle",
                        defaultMessage: "Apply to verify your eligibility and receive your discounted Community License. Here\u2019s how it\u2019ll work."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                variant: "primary",
                size: "small",
                color: "blue",
                href: (0, $jQ0cd.useLocalizedHref)(ctaButtonUrl),
                className: (0, $2jatx.default)([
                    "_2rko1y44 _19pkidpf _2hwx1wug _otyr1tcg _18u01wug"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.hero.button",
                    defaultMessage: "Apply now"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("ul", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1n261g80 _1bah1yb4 _2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1cqi1ssb _498vusvi _1gee7vkz _18ts7vkz _75fp7vkz _r0eh7vkz _1yp81x1l"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                image: {
                                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1665m6o0xxrphegnh7lnwf17585pj211.svg',
                                    alt: ''
                                }
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("h4", {
                                className: (0, $2jatx.default)([
                                    "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf"
                                ]),
                                children: [
                                    isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "NonprofitPage.official.card.title1.gwp10027",
                                        defaultMessage: "1. Choose your apps and get started with a free trial"
                                    }),
                                    !isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "NonprofitPage.official.card.title1.v2",
                                        defaultMessage: "1. Choose your apps, calculate pricing, and sign up for a free plan or trial"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                image: {
                                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ok813kjv073y16g445ogp8yerkv6qvc2.svg',
                                    alt: ''
                                }
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("h4", {
                                className: (0, $2jatx.default)([
                                    "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf"
                                ]),
                                children: [
                                    isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "NonprofitPage.official.card.title2.gwp10027",
                                        defaultMessage: "2. Apply for a Social Impact License"
                                    }),
                                    !isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "NonprofitPage.official.card.title2",
                                        defaultMessage: "2. Apply for your discounted license"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                image: {
                                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/h1503x520p8bg7w744h810188q4bypf3.svg',
                                    alt: ''
                                }
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                                className: (0, $2jatx.default)([
                                    "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "NonprofitPage.official.card.title3",
                                    defaultMessage: "3. In 2-3 days, verification approved and received!"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                image: {
                                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/pe077p727atw2c04p00h3ecl1on0p841.svg',
                                    alt: ''
                                }
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("h4", {
                                className: (0, $2jatx.default)([
                                    "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf"
                                ]),
                                children: [
                                    isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "NonprofitPage.official.card.title4.gwp10027",
                                        defaultMessage: "4. 50-100% discount automatically applied to your subscription"
                                    }),
                                    !isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "NonprofitPage.official.card.title4",
                                        defaultMessage: "4. Discount automatically applied to your subscription and any future upgrades"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_p12f1k4y _c71l4bvh _kqswstnw _rjxp4l2f _u7co1a11 _j6qu146b _1pn4ucft _p5ce16gx _enhl1vuk _j0lc12it _1jtm12it _10jxmgvx _1jc2mhvn _1t0616gx _wtm512it _18oi1osq _1ky91osq"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                    image: {
                        src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/g626i0m4331tsgn2313fln510p5578n1.svg',
                        alt: ''
                    }
                })
            })
        ]
    });
};
$a3701dad3ae12d03$export$dba159851b545af3.displayName = 'OfficialSection';

});

parcelRegister("3icmm", function(module, exports) {
$parcel$export(module.exports, "ResourcesSection", function () { return $e3ba3f7a269b5999$export$3f0336208d56829f; });
/* resources-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $jQ0cd = parcelRequire("jQ0cd");

var $1rGpC = parcelRequire("1rGpC");

var $NtjLk = parcelRequire("NtjLk");

var $btggB = parcelRequire("btggB");
const $e3ba3f7a269b5999$var$resourcesContainerCss = null;
const $e3ba3f7a269b5999$var$headerCss = null;
const $e3ba3f7a269b5999$var$subtitleCss = null;
const $e3ba3f7a269b5999$var$cardBlockCss = null;
const $e3ba3f7a269b5999$export$3f0336208d56829f = ()=>{
    const intl = (0, $8e22h.default)();
    const teamCardProps = {
        title: intl.formatMessage({
            id: 'NonprofitPage.resources.team.title',
            defaultMessage: 'Team up with us'
        }),
        titleAs: 'h3',
        body: intl.formatMessage({
            id: 'NonprofitPage.resources.team.body',
            defaultMessage: 'Get free, customized app and teamwork coaching sessions with Atlassian experts. No question is too big or too small.'
        }),
        image: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7g2k6ru6bw83f33121usy12j03td6p88.webp',
            alt: 'Partners for Nonprofits'
        },
        callToAction: {
            href: (0, $jQ0cd.useLocalizedHref)('/teams/nonprofits/support-programs'),
            text: intl.formatMessage({
                id: 'NonprofitPage.resources.team.link',
                defaultMessage: 'Learn more'
            })
        }
    };
    const isGwp10027 = (0, $btggB.getIsGwp10027NonprofitPricingPage)();
    const successCardProps = {
        title: intl.formatMessage({
            id: 'NonprofitPage.resources.success.title.gwp7869',
            defaultMessage: 'Social impact team success stories'
        }),
        titleAs: 'h3',
        body: intl.formatMessage({
            id: 'NonprofitPage.resources.success.body',
            defaultMessage: 'Get inspired by teams like yours driving impact with Atlassian apps.'
        }),
        image: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/6kp84so85h055h6o517q02jx1qp42p78.webp',
            alt: 'Partners for Nonprofits'
        },
        callToAction: {
            href: (0, $jQ0cd.useLocalizedHref)('/teams/nonprofits/resources'),
            text: intl.formatMessage({
                id: 'NonprofitPage.resources.success.link',
                defaultMessage: 'See all use cases'
            })
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_1wybzwfg _vwz410mc _k48p9y44 _19pkidpf _2hwxidpf _otyrdlk8 _18u0idpf _y3gn1h6o _1s18ckbl _17gq8vuz _15flidpf _1d2widpf _1svy7vkz _seovidpf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.resources.header.v1",
                    defaultMessage: "Explore resources"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("h3", {
                className: (0, $2jatx.default)([
                    "_1wyb7vkz _vwz41tcg _k48powjs _19pkidpf _2hwx1wug _otyrgktf _18u01wug _y3gn1h6o _1lzogktf _119z1f4h _j6qubxu3 _lg5ridpf _d97m1wug _1b7eldb6 _12521wug _3p1c1f4h _py5o1ylp _10jx1osq"
                ]),
                children: [
                    isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.resources.subtitle.gwp10027",
                        defaultMessage: "While you wait for your Social Impact License to be approved\u2026"
                    }),
                    !isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.resources.subtitle",
                        defaultMessage: "While you wait for your Community License to be approved\u2026"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_3intidpf _4fugidpf _1ynqidpf _1j3nidpf _quu71osq _18zx1h90"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1rGpC.Row), {
                    layout: "6-6",
                    className: (0, $2jatx.default)([
                        "_3intidpf _4fugidpf _1ynqidpf _1j3nidpf _quu71osq _18zx1h90"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $NtjLk.Card), {
                            ...teamCardProps
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $NtjLk.Card), {
                            ...successCardProps
                        })
                    ]
                })
            })
        ]
    });
};
$e3ba3f7a269b5999$export$3f0336208d56829f.displayName = 'ResourcesSection';

});


parcelRegister("in9in", function(module, exports) {
$parcel$export(module.exports, "TrelloPriceFinder", function () { return $0e2ca0aa8f567d21$export$954e0f4d6ca6524; });

var $7VQPk = parcelRequire("7VQPk");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $hCc2m = parcelRequire("hCc2m");

var $g9ZvA = parcelRequire("g9ZvA");

var $gIRO7 = parcelRequire("gIRO7");

var $eYlij = parcelRequire("eYlij");
const $0e2ca0aa8f567d21$export$954e0f4d6ca6524 = (props)=>{
    const intl = (0, $8e22h.default)();
    const freePlanFeatureMessages = [
        {
            featureMessage: intl.formatMessage({
                id: 'TrelloPricingPage.features.unlimitedCards.title',
                defaultMessage: 'Unlimited cards'
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: 'TrelloPricingPage.features.upTo10BoardsPerWorkspace.title',
                defaultMessage: 'Up to 10 boards per Workspace'
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: 'TrelloPricingPage.features.unlimitedPowerUpsPerBoard.title',
                defaultMessage: 'Unlimited Power-Ups per board'
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: 'TrelloPricingPage.features.unlimitedStorage.title.free',
                defaultMessage: 'Unlimited storage (10MB/file)'
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: 'TrelloPricingPage.features.workspaceCommandRuns.title',
                defaultMessage: '250 Workspace command runs per month'
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: 'TrelloPricingPage.features.customBackgroundsAndStickers.title',
                defaultMessage: 'Custom backgrounds & stickers'
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: 'TrelloPricingPage.features.unlimitedActivityLog.title',
                defaultMessage: 'Unlimited activity log'
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: 'TrelloPricingPage.features.assigneeAndDueDates.title',
                defaultMessage: 'Assignee and due dates'
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: 'TrelloPricingPage.features.mobileApps.title',
                defaultMessage: 'iOS and Android mobile apps'
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: 'TrelloPricingPage.features.twoFactorAuthentication.title',
                defaultMessage: '2-factor authentication'
            })
        }
    ];
    const standardPlanFeatureMessages = [
        {
            featureMessage: intl.formatMessage({
                id: 'TrelloPricingPage.features.unlimitedBoards.title',
                defaultMessage: 'Unlimited boards'
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: 'TrelloPricingPage.features.advancedChecklists.title',
                defaultMessage: 'Advanced checklists'
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: 'TrelloPricingPage.features.customFields.title',
                defaultMessage: 'Custom Fields'
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: 'TrelloPricingPage.features.unlimitedStorage.title',
                defaultMessage: 'Unlimited storage (250MB/file)'
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: 'TrelloPricingPage.features.workspaceCommandRuns.title',
                defaultMessage: '1,000 Workspace command runs per month'
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: 'TrelloPricingPage.features.singleBoardGuests.title',
                defaultMessage: 'Single board guests'
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: 'TrelloPricingPage.features.savedSearches.title',
                defaultMessage: 'Saved searches'
            })
        }
    ];
    const premiumPlanFeatureMessages = [
        {
            featureMessage: intl.formatMessage({
                id: 'TrelloPricingPage.features.views.title',
                defaultMessage: 'Views: Calendar, Timeline, Table, Dashboard, and Map'
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: 'TrelloPricingPage.features.workspaceViews.title',
                defaultMessage: 'Workspace views: Table and Calendar'
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: 'TrelloPricingPage.features.unlimitedWorkspaceCommandRuns.title',
                defaultMessage: 'Unlimited Workspace command runs'
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: 'TrelloPricingPage.features.atlassianIntelligence.title',
                defaultMessage: 'Atlassian Intelligence (AI)'
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: 'TrelloPricingPage.features.adminAndSecurityFeatures.title',
                defaultMessage: 'Admin and security features'
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: 'TrelloPricingPage.features.workspaceLevelTemplates.title',
                defaultMessage: 'Workspace-level templates'
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: 'TrelloPricingPage.features.collections.title',
                defaultMessage: 'Collections'
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: 'TrelloPricingPage.features.observers.title',
                defaultMessage: 'Observers'
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: 'TrelloPricingPage.features.simpleDataExport.title',
                defaultMessage: 'Simple data export'
            })
        }
    ];
    const trelloProductPlans = [
        {
            planName: 'Free',
            offeringSku: 'jira-servicedesk-free',
            recommendationLimit: 0,
            signupLimit: 150000,
            planFeatureMessages: freePlanFeatureMessages
        },
        {
            planName: 'Standard',
            offeringSku: 'trello-standard-non-profit',
            recommendationLimit: 10,
            signupLimit: 150000,
            planFeatureMessages: standardPlanFeatureMessages
        },
        {
            planName: 'Premium',
            offeringSku: 'trello-premium-non-profit',
            recommendationLimit: 250,
            signupLimit: 150000,
            planFeatureMessages: premiumPlanFeatureMessages
        }
    ];
    const messages = (0, $fnHPc.defineMessages)({
        headerText: {
            id: 'TrelloPricingPage.priceFinder.headerText',
            defaultMessage: 'Build Your <blue>Source of Truth</blue>'
        },
        unitCountInputTextRedesign: {
            id: 'ConfluencePricingPage.priceFinder.unitCountInputTextRedesign',
            defaultMessage: 'Team size:'
        },
        unitCountInputTerm: {
            id: 'ConfluencePricingPage.priceFinder.unitCountInputTerm',
            defaultMessage: 'users'
        },
        billingCycleText: {
            id: 'ConfluencePricingPage.priceFinder.billingCycleText',
            defaultMessage: 'Billing cycle:'
        },
        unitCountInputText: {
            id: 'ConfluencePricingPage.priceFinder.unitCountInputText',
            defaultMessage: 'How many users are on your team?'
        },
        unitCountInputTooltip: {
            id: 'ConfluencePricingPage.priceFinder.unitCountInputTooltip',
            defaultMessage: 'A Confluence user is any user who can log in to Confluence, and who exists in User Management'
        },
        monthlyExampleHelpText: {
            id: 'ConfluencePricingPage.priceFinder.monthlyExampleHelpText',
            defaultMessage: 'Monthly plans give you flexibility as your number of active users changes, so pay for seats as you use them. Remember that the number of seats may change the total price.'
        },
        annualExampleHelpText: {
            id: 'ConfluencePricingPage.priceFinder.annualExampleHelpText',
            defaultMessage: 'Annual plans give you flexibility and help you prepare for growth. Buy a group of seats at a flat rate now, then fill your empty seats through the year at no extra cost.'
        },
        exampleStandardPlan: {
            id: 'ConfluencePricingPage.priceFinder.exampleStandardPlan',
            defaultMessage: 'Pricing for {unitCount} users on Standard plan',
            description: 'Standard is a plan name and should not be translated'
        },
        cardOverSignupLimit: {
            id: 'ConfluencePricingPage.priceFinder.cardOverSignupLimit',
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: 'ConfluencePricingPage.priceFinder.cardEnterpriseMinimumCount',
            defaultMessage: 'Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above',
            description: 'Enterprise is a plan name and should not be translated'
        },
        cardUnitCountTierRange: {
            id: 'ConfluencePricingPage.priceFinder.cardUnitCountTierRange',
            defaultMessage: 'User tier: {lowerLimit} - {upperLimit}'
        },
        cardMonthlyPerUnitCount: {
            id: 'TrelloPricingPage.priceFinder.cardMonthlyPerUnitCount',
            defaultMessage: 'per user / month'
        },
        cardFreeDescription: {
            id: 'ConfluencePricingPage.priceFinder.cardFreeDescription',
            defaultMessage: 'Always free for 10 users'
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hCc2m.default), {
        interactionName: 'trello-price-finder',
        fallback: (0, $g9ZvA.LoadingSpinner),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eYlij.PriceFinderContextProvider), {
            dataProductKey: "trello",
            productPlans: trelloProductPlans,
            defaultUnitCount: 150,
            shouldAddDiscount: props.shouldAddDiscount,
            ctaUrlSource: "productPlans",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gIRO7.default), {
                messages: messages,
                serverSideCCPPricing: props.pricing?.ccpPricingData?.trello,
                countryCode: props.countryCode
            })
        })
    });
};
$0e2ca0aa8f567d21$export$954e0f4d6ca6524.displayName = 'TrelloPriceFinder';

});



parcelRegister("keaFO", function(module, exports) {
$parcel$export(module.exports, "LoomChoicePage", function () { return $8bfaa5ca129bc7fd$export$4dcfc99cd2c1f98a; });

var $7VQPk = parcelRequire("7VQPk");

var $5fHuN = parcelRequire("5fHuN");
const $8bfaa5ca129bc7fd$export$4dcfc99cd2c1f98a = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $5fHuN.LoomChoicePageTemplate), {});

});
parcelRegister("5fHuN", function(module, exports) {
$parcel$export(module.exports, "LoomChoicePageTemplate", function () { return $9ff4e7f482d51972$export$aeedbe1eb1faa3d4; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");

var $bMxrA = parcelRequire("bMxrA");
var $1zgVm = parcelRequire("1zgVm");
var $1xo8q = parcelRequire("1xo8q");

var $7qFQI = parcelRequire("7qFQI");

var $1jJRS = parcelRequire("1jJRS");

var $h6kyD = parcelRequire("h6kyD");

var $43Dso = parcelRequire("43Dso");

var $fLCEK = parcelRequire("fLCEK");

var $czr4e = parcelRequire("czr4e");

var $fcO7r = parcelRequire("fcO7r");

var $gPKCY = parcelRequire("gPKCY");

var $lIWv2 = parcelRequire("lIWv2");

var $jQ0cd = parcelRequire("jQ0cd");

var $1ka2O = parcelRequire("1ka2O");
/**
 * TWCG-2108 Loom Land opt-in choice page.
 *
 * Route: /try/cloud/loom/choose
 *
 * Branches on the `twcg2108LoomLandOptIn` multivariant experiment cohort:
 * - control:  fall through to the existing Loom-only signup flow.
 * - radio:    {@link LoomChoiceVariantA} (multi-option "TWC choice" card).
 * - longText: {@link LoomChoiceVariantB} (single-option TWC pitch).
 *
 * This screen is read-only w.r.t. the experiment: it only consumes the resolved
 * cohort to render the correct arm. Exposure is owned by `/try/cloud/signup`,
 * where the treatment (the continue-URL rewrite) applies to the whole Loom-intent
 * population, so this page does NOT fire exposure.
 */ const $9ff4e7f482d51972$var$pageStyles = (0, $1xo8q.xcss)({
    minHeight: '100vh',
    width: '100%',
    backgroundColor: 'elevation.surface'
});
const $9ff4e7f482d51972$var$centeredStyles = (0, $1xo8q.xcss)({
    minHeight: '100vh',
    padding: 'space.400'
});
const $9ff4e7f482d51972$var$PRICE_FETCH_TIMING = (0, $lIWv2.UfoCustomTimingKey).LOOM_LAND_OPT_IN_PRICE_FETCH;
const $9ff4e7f482d51972$var$redirectToLoomOnlySignup = (loomOnlySignupHref)=>{
    // Control cohort keeps today's behaviour: the standard Loom signup page.
    window.location.replace(loomOnlySignupHref);
};
const $9ff4e7f482d51972$export$aeedbe1eb1faa3d4 = ()=>{
    const { cohort: cohort, isResolved: isResolved, isEnrolled: isEnrolled, hasResolveTimedOut: hasResolveTimedOut } = (0, $fLCEK.useLoomLandOptIn)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const location = (0, $1ka2O.useLocation)();
    // Keep the visitor's locale (e.g. /es/try/cloud/loom/choose → /es/try/cloud/signup).
    const loomOnlySignupHref = (0, $jQ0cd.useLocalizedHref)(`/try/cloud/signup${location.search}`);
    // Live, localized choice-card price for the Loom edition (from the `edition`
    // query param); `mode` picks the copy. Fetched client-side (no SSR pricing), so
    // we hold the spinner while loading rather than flash the default price.
    const edition = (0, $czr4e.resolveLoomEdition)(new URLSearchParams(location.search).get('edition'));
    const { price: price, mode: priceMode, isLoading: isPriceLoading, hasError: hasPriceError } = (0, $czr4e.useTwcPrice)(edition);
    // UFO "choose page → modal visible" SLO (STARB-5214). UFO times the
    // experience from `start()` to whichever of success / failure / abort ends it;
    // the ref guarantees exactly one terminal call per page view.
    const hasFinishedUfoRef = (0, $1oC0p.useRef)(false);
    (0, $1oC0p.useEffect)(()=>{
        (0, $gPKCY.ufoEventLoomLandOptInModalVisible).start({
            productKey: (0, $fcO7r.ProductKey).LOOM
        });
        // The live price fetch starts on mount too (see `useTwcPrice`).
        (0, $gPKCY.ufoEventLoomLandOptInModalVisible).startSubstep($9ff4e7f482d51972$var$PRICE_FETCH_TIMING);
    }, []); // Once per page view.
    const isPriceSettled = !isPriceLoading || hasPriceError;
    (0, $1oC0p.useEffect)(()=>{
        if (isPriceSettled) (0, $gPKCY.ufoEventLoomLandOptInModalVisible).endSubstep($9ff4e7f482d51972$var$PRICE_FETCH_TIMING);
    }, [
        isPriceSettled
    ]);
    // Fall through to the Loom-only signup whenever we are not going to show a
    // treatment arm:
    //  - resolved control cohort, or
    //  - definitively not enrolled (indeterminate / not-enrolled — e.g. no Loom
    //    intent or signed out), or
    //  - the selected edition is Enterprise, which has no monthly per-user rate,
    //    so there's no meaningful "how much more" to pitch — skip the screen, or
    //  - the price fetch failed or timed out: without a price the cards have
    //    nothing to pitch, so bail to the standard signup instead of spinning, or
    //  - enrolled but the arm can't resolve: Statsig initialised without a value,
    //    or didn't initialise within COHORT_RESOLVE_TIMEOUT_MS (it reports
    //    enrolled-but-unresolved, not "not enrolled").
    // The brief "enrolled but arm not yet resolved" window shows a spinner and is
    // capped by that timeout, so users never get stuck on a blank page.
    const redirectReason = (0, $43Dso.getOptInRedirectReason)({
        isEnrolled: isEnrolled,
        isResolved: isResolved,
        cohort: cohort,
        edition: edition,
        hasPriceError: hasPriceError,
        hasCohortTimedOut: hasResolveTimedOut
    });
    const shouldRedirect = redirectReason !== undefined;
    // Report why the modal was skipped, once per page view. Declared before the
    // redirect effect so the event is fired before navigation starts.
    const hasReportedRedirectRef = (0, $1oC0p.useRef)(false);
    (0, $1oC0p.useEffect)(()=>{
        if (!redirectReason || hasReportedRedirectRef.current) return;
        hasReportedRedirectRef.current = true;
        // `cohort` defaults to "control" until resolved, so only report it then.
        const reportedCohort = isResolved ? cohort : undefined;
        (0, $43Dso.fireOptInPageRedirected)({
            createAnalyticsEvent: createAnalyticsEvent,
            reason: redirectReason,
            cohort: reportedCohort,
            edition: edition
        });
        if (!hasFinishedUfoRef.current) {
            hasFinishedUfoRef.current = true;
            const ufoOptions = {
                customData: {
                    loomLandOptInRedirectReason: redirectReason,
                    loomLandOptInCohort: reportedCohort
                }
            };
            // Eligible users who should have seen the modal count against the SLO;
            // intentional skips (control, not enrolled, Enterprise) are scrubbed.
            (0, $43Dso.isOptInSloFailure)(redirectReason) ? (0, $gPKCY.ufoEventLoomLandOptInModalVisible).failure(ufoOptions) : (0, $gPKCY.ufoEventLoomLandOptInModalVisible).abort(ufoOptions);
        }
    }, [
        redirectReason,
        createAnalyticsEvent,
        isResolved,
        cohort,
        edition
    ]);
    // The modal (either arm) is on screen: stop the SLO timer as a good event.
    // Parent effects run after the child's mount, so this fires once it's rendered.
    const isModalVisible = !shouldRedirect && isResolved && !isPriceLoading;
    (0, $1oC0p.useEffect)(()=>{
        if (!isModalVisible || hasFinishedUfoRef.current) return;
        hasFinishedUfoRef.current = true;
        (0, $gPKCY.ufoEventLoomLandOptInModalVisible).success({
            customData: {
                loomLandOptInCohort: cohort
            }
        });
    }, [
        isModalVisible,
        cohort
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (shouldRedirect) $9ff4e7f482d51972$var$redirectToLoomOnlySignup(loomOnlySignupHref);
    }, [
        shouldRedirect,
        loomOnlySignupHref
    ]);
    if (shouldRedirect || !isResolved) // Redirecting (handled in the effect above), or still waiting for Statsig
    // to resolve the arm for an enrolled user. Show a spinner rather than a
    // blank page — `location.replace` and the resolve wait both take a moment.
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bMxrA.default), {
        xcss: $9ff4e7f482d51972$var$pageStyles,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1zgVm.default), {
            xcss: $9ff4e7f482d51972$var$centeredStyles,
            alignItems: "center",
            justifyContent: "center",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7qFQI.default), {
                label: "Loading",
                testId: "loom-choice-page-spinner"
            })
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bMxrA.default), {
        xcss: $9ff4e7f482d51972$var$pageStyles,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1zgVm.default), {
            xcss: $9ff4e7f482d51972$var$centeredStyles,
            alignItems: "center",
            justifyContent: "center",
            children: isPriceLoading ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7qFQI.default), {
                label: "Loading",
                testId: "loom-choice-price-spinner"
            }) : /* `'longText'` is the LoomChoiceVariantB cell of the
        twcg-2108-loom-land-opt-in experiment; the three cell names
        (control/radio/longText) match the Statsig console exactly —
        see experiments.twcg2108LoomLandOptIn in the experiment manifest. */ cohort === 'longText' ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $h6kyD.LoomChoiceVariantB), {
                price: price,
                priceMode: priceMode,
                edition: edition,
                search: location.search,
                cohort: cohort
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1jJRS.LoomChoiceVariantA), {
                price: price,
                priceMode: priceMode,
                edition: edition,
                search: location.search,
                cohort: cohort
            })
        })
    });
};

});
parcelRegister("1jJRS", function(module, exports) {
$parcel$export(module.exports, "LoomChoiceVariantA", function () { return $8a9ae01e3cc248ce$export$b33c35e492142225; });
/* loom-choice-variant-a.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $6uJzV = parcelRequire("6uJzV");

var $7H48e = parcelRequire("7H48e");

var $dECfd = parcelRequire("dECfd");

var $279Jr = parcelRequire("279Jr");
/**
 * TWCG-2108 Loom Land opt-in — "Variant A" (TWC choice) design.
 *
 * Renders the "Loom works better in a collection" choice cards as an accordion:
 * the card whose radio is selected expands to show its feature list and its own
 * call-to-action, and the graphic panel cross-fades to that choice's
 * illustration. Matches the Figma "TWC _ Variant A" frames. The modal shell,
 * analytics, header, features and legal copy are shared with Variant B via
 * `opt-in-shared`.
 */ const $8a9ae01e3cc248ce$var$CONTENT_TEST_ID = 'loom-land-opt-in-variant-a';
// Both illustrations are preloaded so switching cards never flashes.
const $8a9ae01e3cc248ce$var$PANEL_ILLUSTRATIONS = [
    'teamwork-collection',
    'loom-only'
];
// Figma groups the heading and cards (20px apart) so only the legal text is
// pushed to the bottom of the column.
const $8a9ae01e3cc248ce$var$mainCss = null;
const $8a9ae01e3cc248ce$var$cardsCss = null;
// Figma card: 8px radius, 20/24/20/16 padding, 20px gap, subtle border.
const $8a9ae01e3cc248ce$var$cardCss = null;
const $8a9ae01e3cc248ce$var$selectedCardCss = null;
// Indents the expanded card body under the header text rather than the radio
// control (DS Radio width plus its label gap, ~24px), matching Figma.
const $8a9ae01e3cc248ce$var$cardBodyCss = null;
// Extra breathing room under the card subtitle so it reads as a header for the
// feature list: 12px body gap + 4px = 16px (space.200) before the bullets.
const $8a9ae01e3cc248ce$var$cardSubtitleCss = null;
// The DS Radio's root `<label>` top-aligns the control (`align-items:
// flex-start`) for multi-line text labels, which leaves the circle sitting high
// beside our taller logo rows. It exposes no xcss/className hook, so we
// re-centre it via its root element (same approach as the JSM portal
// playground's DS overrides).
const $8a9ae01e3cc248ce$var$cardRadioCss = null;
// The DS `Radio` is a forwardRef component whose JSX signature, under this
// repo's @types/react, demands DOM-only attributes like `crossOrigin` as
// required props (TS2739). Casting it to a ComponentType keyed on the DS's own
// `RadioProps` restores the intended (all-optional) prop contract, mirroring the
// pattern used elsewhere in signup/.
const $8a9ae01e3cc248ce$var$Radio = (0, $7H48e.default);
// The custom header (logos) is passed as the radio's `label`, keeping the whole
// row clickable and accessible without a hand-rolled input.
const $8a9ae01e3cc248ce$var$CardRadio = ({ value: value, isChecked: isChecked, onChange: onChange, ariaLabel: ariaLabel, children: children })=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1joe1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($8a9ae01e3cc248ce$var$Radio, {
            name: "loom-land-choice",
            value: value,
            isChecked: isChecked,
            ariaLabel: ariaLabel,
            onChange: ()=>onChange(value),
            label: children
        })
    });
const $8a9ae01e3cc248ce$export$b33c35e492142225 = ({ onSelect: onSelect, initialChoice: initialChoice = 'teamwork-collection', price: price = (0, $dECfd.DEFAULT_TWC_PRICE), priceMode: priceMode = 'more', edition: edition = 'premium', search: search = '', cohort: cohort, previewVideoSrc: previewVideoSrc })=>{
    const intl = (0, $8e22h.default)();
    const [choice, setChoice] = (0, $1oC0p.useState)(initialChoice);
    const analyticsContext = {
        variant: 'a',
        cohort: cohort,
        edition: edition,
        priceMode: priceMode
    };
    const handleSelect = (0, $279Jr.useOptInSelect)({
        onSelect: onSelect,
        context: analyticsContext,
        search: search
    });
    (0, $279Jr.useOptInModalViewed)(analyticsContext);
    const trackChoiceChanged = (0, $279Jr.useOptInChoiceChanged)(analyticsContext);
    const handleChoiceChange = (next)=>{
        setChoice(next);
        trackChoiceChanged(next);
    };
    const isTwc = choice === 'teamwork-collection';
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $279Jr.OptInModalLayout), {
        contentTestId: $8a9ae01e3cc248ce$var$CONTENT_TEST_ID,
        contentLayout: "choice",
        activeIllustration: choice,
        illustrations: $8a9ae01e3cc248ce$var$PANEL_ILLUSTRATIONS,
        previewVideoSrc: previewVideoSrc,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulpv47k"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $279Jr.OptInHeading), {}),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _zulputpp _1tke1dty"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _2lx21bp4 _zulpv47k _1rjcv47k _bozgpxbi _y4ti1ejb _2rko1mok _189ee4h9 _1dqonqa1 _1h6d1l7x",
                                    isTwc && "_1h6dq98m"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($8a9ae01e3cc248ce$var$CardRadio, {
                                        value: "teamwork-collection",
                                        isChecked: isTwc,
                                        onChange: handleChoiceChange,
                                        ariaLabel: intl.formatMessage((0, $dECfd.messages).twcRadioLabel),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $279Jr.TwcLogos), {})
                                    }),
                                    isTwc && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _2lx21bp4 _zulputpp _bozg1ejb"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_6rth1b66"
                                                ]),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $279Jr.OptInSubtitle), {
                                                    message: (0, $dECfd.messages).twcSubtitle
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $279Jr.FeatureList), {
                                                features: (0, $279Jr.buildTwcFeatures)(price, priceMode)
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6uJzV.default), {
                                                appearance: "primary",
                                                shouldFitContainer: true,
                                                onClick: ()=>handleSelect('teamwork-collection'),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                                    ...(0, $dECfd.messages).twcCta
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _2lx21bp4 _zulpv47k _1rjcv47k _bozgpxbi _y4ti1ejb _2rko1mok _189ee4h9 _1dqonqa1 _1h6d1l7x",
                                    !isTwc && "_1h6dq98m"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($8a9ae01e3cc248ce$var$CardRadio, {
                                        value: "loom-only",
                                        isChecked: !isTwc,
                                        onChange: handleChoiceChange,
                                        ariaLabel: intl.formatMessage((0, $dECfd.messages).loomOnlyRadioLabel),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $279Jr.LoomOnlyLogo), {})
                                    }),
                                    !isTwc && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _2lx21bp4 _zulputpp _bozg1ejb"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_6rth1b66"
                                                ]),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $279Jr.OptInSubtitle), {
                                                    message: (0, $dECfd.messages).loomOnlySubtitle
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $279Jr.FeatureList), {
                                                features: (0, $279Jr.LOOM_ONLY_FEATURES)
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6uJzV.default), {
                                                shouldFitContainer: true,
                                                onClick: ()=>handleSelect('loom-only'),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                                    ...(0, $dECfd.messages).loomOnlyCta
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $279Jr.LegalText), {
                message: isTwc ? (0, $dECfd.messages).legalTwc : (0, $dECfd.messages).legalLoomOnly
            })
        ]
    });
};

});
parcelRegister("6uJzV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4ba8e659245bb9cc$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $fxEVM = parcelRequire("fxEVM");

var $3Lodh = parcelRequire("3Lodh");
var $4ba8e659245bb9cc$var$_excluded = [
    "analyticsContext",
    "autoFocus",
    "appearance",
    "spacing",
    "isDisabled",
    "isSelected",
    "iconBefore",
    "UNSAFE_iconAfter_size",
    "iconAfter",
    "UNSAFE_iconBefore_size",
    "children",
    "shouldFitContainer",
    "interactionName",
    "overlay",
    "onClick",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onTouchStartCapture",
    "onTouchEndCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onClickCapture",
    "type",
    "testId"
];
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $4ba8e659245bb9cc$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, autoFocus = _ref.autoFocus, appearance = _ref.appearance, spacing = _ref.spacing, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, iconBefore = _ref.iconBefore, UNSAFE_iconAfter_size = _ref.UNSAFE_iconAfter_size, iconAfter = _ref.iconAfter, UNSAFE_iconBefore_size = _ref.UNSAFE_iconBefore_size, children = _ref.children, shouldFitContainer = _ref.shouldFitContainer, interactionName = _ref.interactionName, overlay = _ref.overlay, onClick = _ref.onClick, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, testId = _ref.testId, rest = (0, $gnQ3X.default)(_ref, $4ba8e659245bb9cc$var$_excluded);
    var baseProps = (0, $3Lodh.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: 'button',
        children: children,
        iconBefore: iconBefore,
        UNSAFE_iconBefore_size: UNSAFE_iconBefore_size,
        iconAfter: iconAfter,
        UNSAFE_iconAfter_size: UNSAFE_iconAfter_size,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        overlay: overlay,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fxEVM.default), (0, $c9bqK.default)({}, rest, {
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        isDisabled: baseProps.isDisabled,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        type: type,
        testId: testId
    }), baseProps.children);
}));
$4ba8e659245bb9cc$var$Button.displayName = 'Button';
var $4ba8e659245bb9cc$export$2e2bcd8739ae039 = $4ba8e659245bb9cc$var$Button;

});
parcelRegister("fxEVM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b509b01cc302c941$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $lFOXD = parcelRequire("lFOXD");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $1xo8q = parcelRequire("1xo8q");

var $bMxrA = parcelRequire("bMxrA");
var $b509b01cc302c941$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "testId",
    "xcss"
];
// TODO: Duplicated FocusRing styles due to lack of `xcss` support
// and to prevent additional dependency
var $b509b01cc302c941$var$baseFocusRingStyles = {
    outlineColor: 'color.border.focused',
    outlineWidth: 'border.width.outline',
    outlineStyle: 'solid',
    outlineOffset: 'space.025'
};
var $b509b01cc302c941$var$focusRingStyles = (0, $1xo8q.xcss)({
    ':focus-visible': $b509b01cc302c941$var$baseFocusRingStyles,
    '@supports not selector(*:focus-visible)': {
        ':focus': $b509b01cc302c941$var$baseFocusRingStyles
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        ':focus-visible': {
            outline: '1px solid'
        }
    }
});
/**
 * __UNSAFE_PRESSABLE__
 *
 * @internal Still under development. Do not use.
 *
 * A Pressable is a primitive component that renders a `<button>`.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $b509b01cc302c941$var$UNSAFE_PRESSABLE = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, testId = _ref.testId, xcssStyles = _ref.xcss, htmlAttributes = (0, $gnQ3X.default)(_ref, $b509b01cc302c941$var$_excluded);
    // Combine default styles with supplied styles. XCSS does not support deep nested arrays
    var styles = [
        (0, $1xo8q.xcss)({
            cursor: isDisabled ? 'not-allowed' : 'pointer'
        }),
        $b509b01cc302c941$var$focusRingStyles
    ];
    styles = Array.isArray(xcssStyles) ? [].concat((0, $lFOXD.default)(styles), (0, $lFOXD.default)(xcssStyles)) : [].concat((0, $lFOXD.default)(styles), [
        xcssStyles
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $bMxrA.default), (0, $c9bqK.default)({}, htmlAttributes, {
        as: "button",
        ref: ref,
        testId: testId,
        type: type,
        backgroundColor: backgroundColor,
        padding: padding,
        paddingBlock: paddingBlock,
        paddingBlockStart: paddingBlockStart,
        paddingBlockEnd: paddingBlockEnd,
        paddingInline: paddingInline,
        paddingInlineStart: paddingInlineStart,
        paddingInlineEnd: paddingInlineEnd,
        xcss: styles,
        disabled: isDisabled
    }), children);
});
var $b509b01cc302c941$export$2e2bcd8739ae039 = $b509b01cc302c941$var$UNSAFE_PRESSABLE;

});

parcelRegister("3Lodh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2bd88b1b370b1314$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $co7jq = parcelRequire("co7jq");

var $f25dO = parcelRequire("f25dO");
/**
 * __Use default button base__
 *
 * A React hook that accepts a set of default Button props,
 * and processes them to return consistent base props for usage
 * across Button and LinkButton variants.
 *
 * @private
 */ var $2bd88b1b370b1314$var$useDefaultButton = function useDefaultButton(_ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, buttonType = _ref.buttonType, IconBefore = _ref.iconBefore, UNSAFE_iconBefore_size = _ref.UNSAFE_iconBefore_size, IconAfter = _ref.iconAfter, UNSAFE_iconAfter_size = _ref.UNSAFE_iconAfter_size, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, children = _ref.children, onClick = _ref.onClick, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, overlay = _ref.overlay, ref = _ref.ref, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing;
    var hasOverlay = Boolean(overlay);
    var baseProps = (0, $f25dO.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: buttonType,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, IconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $co7jq.default), {
            type: "icon",
            hasOverlay: hasOverlay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(IconBefore, {
            label: "",
            size: UNSAFE_iconBefore_size
        })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $co7jq.default), {
            hasOverlay: hasOverlay
        }, children), IconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $co7jq.default), {
            type: "icon",
            hasOverlay: hasOverlay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(IconAfter, {
            label: "",
            size: UNSAFE_iconAfter_size
        }))),
        interactionName: interactionName,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        overlay: overlay,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        hasIconBefore: Boolean(IconBefore),
        hasIconAfter: Boolean(IconAfter)
    });
    return baseProps;
};
var $2bd88b1b370b1314$export$2e2bcd8739ae039 = $2bd88b1b370b1314$var$useDefaultButton;

});
parcelRegister("co7jq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $904d6601455d39cd$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $1oC0p = parcelRequire("1oC0p");

var $bMxrA = parcelRequire("bMxrA");
var $1xo8q = parcelRequire("1xo8q");
var $904d6601455d39cd$var$textStyles = (0, $1xo8q.xcss)({
    // content can grow and shrink
    flexGrow: 1,
    flexShrink: 1,
    // ellipsis for overflow text
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
var $904d6601455d39cd$var$iconStyles = (0, $1xo8q.xcss)({
    display: 'flex',
    // icon size cannot grow and shrink
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: 'center',
    fontSize: 0,
    lineHeight: 0,
    userSelect: 'none'
});
var $904d6601455d39cd$var$commonStyles = (0, $1xo8q.xcss)({
    transition: 'opacity 0.3s'
});
var $904d6601455d39cd$var$fadeStyles = (0, $1xo8q.xcss)({
    opacity: 0
});
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $904d6601455d39cd$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, hasOverlay = _ref.hasOverlay;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $bMxrA.default), {
        as: "span",
        xcss: [
            $904d6601455d39cd$var$commonStyles
        ].concat((0, $lFOXD.default)(type === 'text' ? [
            $904d6601455d39cd$var$textStyles
        ] : [
            $904d6601455d39cd$var$iconStyles
        ]), (0, $lFOXD.default)(hasOverlay ? [
            $904d6601455d39cd$var$fadeStyles
        ] : []))
    }, children);
};
var $904d6601455d39cd$export$2e2bcd8739ae039 = $904d6601455d39cd$var$Content;

});

parcelRegister("f25dO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $af1b17daafe4876b$export$2e2bcd8739ae039; });

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $gJJny = parcelRequire("gJJny");

var $jRrAo = parcelRequire("jRrAo");

var $8XMc5 = parcelRequire("8XMc5");

var $3YHI1 = parcelRequire("3YHI1");

var $bMxrA = parcelRequire("bMxrA");
var $1xo8q = parcelRequire("1xo8q");

var $fWDl3 = parcelRequire("fWDl3");

var $c7Wwp = parcelRequire("c7Wwp");

var $b6oKR = parcelRequire("b6oKR");
function $af1b17daafe4876b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $af1b17daafe4876b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $af1b17daafe4876b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $af1b17daafe4876b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Include modified onClick with analytics
var $af1b17daafe4876b$var$overlayStyles = (0, $1xo8q.xcss)({
    position: 'absolute',
    insetInlineStart: 'space.0',
    insetBlockStart: 'space.0',
    insetInlineEnd: 'space.0',
    insetBlockEnd: 'space.0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
/**
 * __Use button base__
 *
 * A React hook that accepts a set of common Button props,
 * and processes them to return consistent base props for usage
 * across various Button components.
 *
 * It also:
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $af1b17daafe4876b$var$useButtonBase = function useButtonBase(_ref) {
    var analyticsContext = _ref.analyticsContext, _ref$appearance = _ref.appearance, propAppearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, buttonType = _ref.buttonType, interactionName = _ref.interactionName, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, children = _ref.children, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $jRrAo.default) : _ref$onClick, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, overlay = _ref.overlay, ref = _ref.ref, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? 'default' : _ref$spacing;
    var ourRef = (0, $1oC0p.useRef)();
    var splitButtonContext = (0, $fWDl3.useSplitButtonContext)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var appearance = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || propAppearance;
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isHighlighted = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isHighlighted) || false;
    var isActiveOverSelected = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isActiveOverSelected) || false;
    var setRef = (0, $1oC0p.useCallback)(function(node) {
        ourRef.current = node;
        if (ref === null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    (0, $8XMc5.default)(ourRef, autoFocus);
    var interactionContext = (0, $1oC0p.useContext)((0, $3YHI1.default));
    var handleClick = (0, $1oC0p.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $gJJny.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "@atlaskit/button",
        packageVersion: "16.18.1",
        analyticsData: analyticsContext,
        actionSubject: buttonType
    });
    var buttonXCSS = (0, $1oC0p.useMemo)(function() {
        return (0, $b6oKR.getXCSS)({
            appearance: appearance,
            spacing: spacing,
            isDisabled: isDisabled,
            isSelected: isSelected,
            isHighlighted: isHighlighted,
            isActiveOverSelected: isActiveOverSelected,
            shouldFitContainer: shouldFitContainer,
            isIconButton: isIconButton,
            isCircle: isCircle,
            hasOverlay: Boolean(overlay),
            isLink: buttonType === 'link',
            hasIconBefore: hasIconBefore,
            hasIconAfter: hasIconAfter,
            isSplit: isSplitButton,
            isNavigationSplit: isNavigationSplitButton
        });
    }, [
        appearance,
        buttonType,
        spacing,
        isDisabled,
        isSelected,
        isHighlighted,
        isActiveOverSelected,
        isIconButton,
        isCircle,
        shouldFitContainer,
        overlay,
        hasIconBefore,
        hasIconAfter,
        isSplitButton,
        isNavigationSplitButton
    ]);
    var isEffectivelyDisabled = isDisabled || Boolean(overlay);
    return $af1b17daafe4876b$var$_objectSpread({
        ref: setRef,
        xcss: buttonXCSS,
        // Consider overlay buttons to be effectively disabled
        isDisabled: isEffectivelyDisabled,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, children, overlay ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $bMxrA.default), {
            as: "span",
            xcss: $af1b17daafe4876b$var$overlayStyles
        }, overlay) : null)
    }, (0, $c7Wwp.default)(isEffectivelyDisabled, {
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }));
};
var $af1b17daafe4876b$export$2e2bcd8739ae039 = $af1b17daafe4876b$var$useButtonBase;

});
parcelRegister("fWDl3", function(module, exports) {
$parcel$export(module.exports, "useSplitButtonContext", function () { return $b9bac9a3261a876e$export$47e2c6fdb142d947; });

var $1oC0p = parcelRequire("1oC0p");
var $b9bac9a3261a876e$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
var $b9bac9a3261a876e$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $1oC0p.useContext)($b9bac9a3261a876e$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        var newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("c7Wwp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8d4388aec99d27a5$export$2e2bcd8739ae039; });
function $8d4388aec99d27a5$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $8d4388aec99d27a5$var$tabKeyCode = 9;
function $8d4388aec99d27a5$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $8d4388aec99d27a5$var$tabKeyCode) return;
    $8d4388aec99d27a5$var$abort(event);
}
function $8d4388aec99d27a5$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $8d4388aec99d27a5$var$abort,
        onMouseUpCapture: $8d4388aec99d27a5$var$abort,
        onKeyDownCapture: $8d4388aec99d27a5$var$onKey,
        onKeyUpCapture: $8d4388aec99d27a5$var$onKey,
        onTouchStartCapture: $8d4388aec99d27a5$var$abort,
        onTouchEndCapture: $8d4388aec99d27a5$var$abort,
        onPointerDownCapture: $8d4388aec99d27a5$var$abort,
        onPointerUpCapture: $8d4388aec99d27a5$var$abort,
        onClickCapture: $8d4388aec99d27a5$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $8d4388aec99d27a5$var$abort
    } : events;
}

});

parcelRegister("b6oKR", function(module, exports) {
$parcel$export(module.exports, "getXCSS", function () { return $8153750da454f117$export$f9dc8dc4cff30fc6; });

var $f53LC = parcelRequire("f53LC");

var $1xo8q = parcelRequire("1xo8q");

var $hnR5n = parcelRequire("hnR5n");

var $azS6p = parcelRequire("azS6p");
function $8153750da454f117$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8153750da454f117$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8153750da454f117$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8153750da454f117$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8153750da454f117$var$fontSize = (0, $hnR5n.fontSize)();
var $8153750da454f117$export$6c2552e9776539bb = {
    default: "".concat(32 / $8153750da454f117$var$fontSize, "em"),
    compact: "".concat(24 / $8153750da454f117$var$fontSize, "em"),
    none: 'auto'
};
var $8153750da454f117$var$lineHeights = {
    default: $8153750da454f117$export$6c2552e9776539bb.default,
    compact: $8153750da454f117$export$6c2552e9776539bb.compact,
    none: 'inherit'
};
var $8153750da454f117$var$paddingInline = {
    default: {
        default: 'space.150',
        withIcon: 'space.100'
    },
    compact: {
        default: 'space.150',
        withIcon: 'space.100'
    },
    none: {
        default: 'space.0',
        withIcon: 'space.0'
    }
};
var $8153750da454f117$var$gap = {
    compact: 'space.050',
    default: 'space.050',
    none: 'space.0'
};
var $8153750da454f117$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
var $8153750da454f117$var$splitBorderStyles = {
    ':focus-visible': {
        zIndex: 1
    }
};
function $8153750da454f117$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key;
    return group[key] || group.default;
}
function $8153750da454f117$var$getColors(_ref2) {
    var appearance = _ref2.appearance, _ref2$interactionStat = _ref2.interactionState, interactionState = _ref2$interactionStat === void 0 ? 'default' : _ref2$interactionStat, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, isHighlighted = _ref2.isHighlighted, isActiveOverSelected = _ref2.isActiveOverSelected, hasOverlay = _ref2.hasOverlay;
    var key = interactionState;
    // Overlay does not change color on interaction, revert to 'default' or resting state
    key = hasOverlay ? 'default' : key;
    key = isSelected || isHighlighted ? isActiveOverSelected ? 'active' : 'selected' : key;
    // Disabled colors overrule everything else
    key = isDisabled ? 'disabled' : key;
    return {
        backgroundColor: $8153750da454f117$var$getColor({
            group: (0, $azS6p.default).background[appearance],
            key: key
        }),
        color: "".concat($8153750da454f117$var$getColor({
            group: (0, $azS6p.default).color[appearance],
            key: key
        }))
    };
}
function $8153750da454f117$export$f9dc8dc4cff30fc6(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, isDisabled = _ref3.isDisabled, isSelected = _ref3.isSelected, isHighlighted = _ref3.isHighlighted, isActiveOverSelected = _ref3.isActiveOverSelected, isIconButton = _ref3.isIconButton, isCircle = _ref3.isCircle, shouldFitContainer = _ref3.shouldFitContainer, isLink = _ref3.isLink, isSplit = _ref3.isSplit, isNavigationSplit = _ref3.isNavigationSplit, hasOverlay = _ref3.hasOverlay, hasIconBefore = _ref3.hasIconBefore, hasIconAfter = _ref3.hasIconAfter;
    var baseColors = $8153750da454f117$var$getColors({
        appearance: appearance,
        isSelected: isSelected,
        isHighlighted: isHighlighted,
        isActiveOverSelected: isActiveOverSelected,
        isDisabled: isDisabled
    });
    var combinedBaseColorStyles = isLink ? $8153750da454f117$var$_objectSpread($8153750da454f117$var$_objectSpread({}, baseColors), {}, {
        textDecoration: 'none',
        // Disabling visited styles (by re-declaring the base colors)
        ':visited': baseColors
    }) : isNavigationSplit && !isSelected ? $8153750da454f117$var$_objectSpread($8153750da454f117$var$_objectSpread({}, baseColors), {}, {
        backgroundColor: 'color.background.neutral.subtle'
    }) : baseColors;
    var height = $8153750da454f117$export$6c2552e9776539bb[spacing];
    var width = shouldFitContainer ? '100%' : 'auto';
    width = isIconButton ? isNavigationSplit ? '24px' : height : width;
    var defaultPaddingInlineStart = $8153750da454f117$var$paddingInline[spacing][hasIconBefore ? 'withIcon' : 'default'];
    var defaultPaddingInlineEnd = $8153750da454f117$var$paddingInline[spacing][hasIconAfter ? 'withIcon' : 'default'];
    var splitButtonStyles = isSplit ? $8153750da454f117$var$splitBorderStyles : {};
    var getNavigationSplitButtonPaddings = function getNavigationSplitButtonPaddings() {
        if (isNavigationSplit) return {
            paddingInlineStart: 'space.075',
            paddingInlineEnd: 'space.075'
        };
        return {
            paddingInlineStart: isIconButton ? 'space.0' : defaultPaddingInlineStart,
            paddingInlineEnd: isIconButton ? 'space.0' : defaultPaddingInlineEnd
        };
    };
    var _getNavigationSplitBu = getNavigationSplitButtonPaddings(), paddingInlineStart = _getNavigationSplitBu.paddingInlineStart, paddingInlineEnd = _getNavigationSplitBu.paddingInlineEnd;
    return (0, $1xo8q.xcss)($8153750da454f117$var$_objectSpread($8153750da454f117$var$_objectSpread($8153750da454f117$var$_objectSpread({
        alignItems: 'baseline',
        borderWidth: 'border.width.0',
        borderRadius: isCircle && !isSplit ? 'border.radius.circle' : 'border.radius.100',
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        fontFamily: 'inherit',
        fontWeight: 500,
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap',
        height: height,
        lineHeight: $8153750da454f117$var$lineHeights[spacing],
        paddingBlock: 'space.0',
        paddingInlineStart: paddingInlineStart,
        paddingInlineEnd: paddingInlineEnd,
        columnGap: $8153750da454f117$var$gap[spacing],
        verticalAlign: $8153750da454f117$var$verticalAlign[spacing],
        width: width,
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center'
    }, combinedBaseColorStyles), isDisabled || hasOverlay ? {
        cursor: 'not-allowed'
    } : {}), {}, {
        ':hover': $8153750da454f117$var$_objectSpread($8153750da454f117$var$_objectSpread({}, $8153750da454f117$var$getColors({
            appearance: appearance,
            isSelected: isNavigationSplit && !isSelected ? false : isSelected,
            isActiveOverSelected: isActiveOverSelected,
            isDisabled: isDisabled,
            interactionState: 'hover',
            hasOverlay: hasOverlay
        })), {}, {
            textDecoration: !isSelected && (appearance === 'link' || appearance === 'subtle-link') ? 'underline' : 'none',
            // background, box-shadow
            transitionDuration: '0s, 0.15s'
        }),
        ':active': $8153750da454f117$var$_objectSpread($8153750da454f117$var$_objectSpread({}, $8153750da454f117$var$getColors({
            appearance: appearance,
            isSelected: isNavigationSplit && !isSelected ? false : isSelected,
            isActiveOverSelected: isActiveOverSelected,
            isDisabled: isDisabled,
            interactionState: 'active',
            hasOverlay: hasOverlay
        })), {}, {
            // background, box-shadow
            transitionDuration: '0s, 0s'
        })
    }, splitButtonStyles));
}

});
parcelRegister("azS6p", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7b3723e15fb12318$export$2e2bcd8739ae039; });

var $3c7rQ = parcelRequire("3c7rQ");
var $7b3723e15fb12318$var$values = {
    // Default appearance
    background: {
        default: {
            /**
       * Some colors need specific fallback colors specified
       * to match the original Button when no theme is active.
       *
       * This is because the `xcss` automatic token fallbacks use
       * the legacy themes, which do not match original colors.
       */ // @ts-expect-error
            default: "var(--ds-background-neutral, ".concat($3c7rQ.N20A, ")"),
            hover: 'color.background.neutral.hovered',
            active: 'color.background.neutral.pressed',
            // @ts-expect-error
            disabled: "var(--ds-background-disabled, ".concat($3c7rQ.N20A, ")"),
            // @ts-expect-error
            selected: "var(--ds-background-selected, ".concat($3c7rQ.N700, ")")
        },
        primary: {
            default: 'color.background.brand.bold',
            hover: 'color.background.brand.bold.hovered',
            active: 'color.background.brand.bold.pressed',
            // @ts-expect-error
            disabled: "var(--ds-background-disabled, ".concat($3c7rQ.N20A, ")"),
            // @ts-expect-error
            selected: "var(--ds-background-selected, ".concat($3c7rQ.N700, ")")
        },
        warning: {
            default: 'color.background.warning.bold',
            hover: 'color.background.warning.bold.hovered',
            active: 'color.background.warning.bold.pressed',
            // @ts-expect-error
            disabled: "var(--ds-background-disabled, ".concat($3c7rQ.N20A, ")"),
            // @ts-expect-error
            selected: "var(--ds-background-selected, ".concat($3c7rQ.Y400, ")")
        },
        danger: {
            default: 'color.background.danger.bold',
            hover: 'color.background.danger.bold.hovered',
            active: 'color.background.danger.bold.pressed',
            // @ts-expect-error
            disabled: "var(--ds-background-disabled, ".concat($3c7rQ.N20A, ")"),
            // @ts-expect-error
            selected: "var(--ds-background-selected, ".concat($3c7rQ.R500, ")")
        },
        link: {
            default: 'color.background.neutral.subtle',
            // @ts-expect-error
            selected: "var(--ds-background-selected, ".concat($3c7rQ.N700, ")")
        },
        subtle: {
            default: 'color.background.neutral.subtle',
            hover: 'color.background.neutral.subtle.hovered',
            active: 'color.background.neutral.subtle.pressed',
            // @ts-expect-error
            disabled: "var(--ds-background-neutral-subtle, none)",
            // @ts-expect-error
            selected: "var(--ds-background-selected, ".concat($3c7rQ.N700, ")")
        },
        'subtle-link': {
            default: 'color.background.neutral.subtle',
            // @ts-expect-error
            selected: "var(--ds-background-selected, ".concat($3c7rQ.N700, ")")
        }
    },
    color: {
        default: {
            default: 'color.text',
            active: 'color.text',
            disabled: 'color.text.disabled',
            // @ts-expect-error
            selected: "var(--ds-text-selected, ".concat($3c7rQ.N20, ")")
        },
        primary: {
            default: 'color.text.inverse',
            disabled: 'color.text.disabled',
            // @ts-expect-error
            selected: "var(--ds-text-selected, ".concat($3c7rQ.N20, ")")
        },
        warning: {
            default: 'color.text.warning.inverse',
            disabled: 'color.text.disabled',
            // @ts-expect-error
            selected: "var(--ds-text-selected, ".concat($3c7rQ.N800, ")")
        },
        danger: {
            default: 'color.text.inverse',
            disabled: 'color.text.disabled',
            // @ts-expect-error
            selected: "var(--ds-text-selected, ".concat($3c7rQ.N0, ")")
        },
        link: {
            default: 'color.link',
            hover: 'color.link',
            active: 'color.link.pressed',
            disabled: 'color.text.disabled',
            // @ts-expect-error
            selected: "var(--ds-text-selected, ".concat($3c7rQ.N20, ")")
        },
        subtle: {
            default: 'color.text',
            active: 'color.text',
            disabled: 'color.text.disabled',
            // @ts-expect-error
            selected: "var(--ds-text-selected, ".concat($3c7rQ.N20, ")")
        },
        'subtle-link': {
            default: 'color.text.subtle',
            hover: 'color.text.subtle',
            active: 'color.text',
            disabled: 'color.text.disabled',
            // @ts-expect-error
            selected: "var(--ds-text-selected, ".concat($3c7rQ.N20, ")")
        }
    }
};
var $7b3723e15fb12318$export$2e2bcd8739ae039 = $7b3723e15fb12318$var$values;

});





parcelRegister("dECfd", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $d3aa0934fe6d22db$export$defe85febe8b728c; });
$parcel$export(module.exports, "DEFAULT_TWC_PRICE", function () { return $d3aa0934fe6d22db$export$8c925f0e56c3face; });

var $fnHPc = parcelRequire("fnHPc");
const $d3aa0934fe6d22db$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    heading: {
        id: 'loomLandOptIn.heading',
        defaultMessage: 'Loom works better in a collection'
    },
    // Teamwork Collection (TWC) card
    twcSubtitle: {
        id: 'loomLandOptIn.twc.subtitle',
        defaultMessage: 'Get Loom plus Jira, Confluence, Rovo'
    },
    // Accessible name for the TWC card radio; its visible label is logos only.
    twcRadioLabel: {
        id: 'loomLandOptIn.twc.radioLabel',
        defaultMessage: 'Loom plus Jira, Confluence, Trello, Rovo'
    },
    twcOtherAppsAlt: {
        id: 'loomLandOptIn.twc.otherAppsAlt',
        defaultMessage: 'Jira, Confluence, Trello, Rovo'
    },
    twcCta: {
        id: 'loomLandOptIn.twc.cta',
        defaultMessage: 'Try it free'
    },
    twcFeatureEmbed: {
        id: 'loomLandOptIn.twc.feature.embed',
        defaultMessage: 'Embed Loom videos in Jira project tasks'
    },
    twcFeatureNotes: {
        id: 'loomLandOptIn.twc.feature.notes',
        defaultMessage: 'Instantly capture meeting notes in Confluence'
    },
    twcFeaturePrice: {
        id: 'loomLandOptIn.twc.feature.price',
        defaultMessage: 'Access all apps for only {price} more per user / month'
    },
    // TWC edition is cheaper than the Loom edition.
    twcFeaturePriceLess: {
        id: 'loomLandOptIn.twc.feature.priceLess',
        defaultMessage: 'Access all apps for {price} less per user / month'
    },
    // Raw TWC price (Starter / free case).
    twcFeaturePriceAbsolute: {
        id: 'loomLandOptIn.twc.feature.priceAbsolute',
        defaultMessage: 'Access all apps for {price} per user / month'
    },
    twcFeatureTrial: {
        id: 'loomLandOptIn.twc.feature.trial',
        defaultMessage: 'Get Teamwork Collection free for 30 days'
    },
    // Loom-only card
    loomOnlyLabel: {
        id: 'loomLandOptIn.loomOnly.onlyLabel',
        defaultMessage: 'only'
    },
    // Accessible name for the Loom-only card radio; its visible label is a logo.
    loomOnlyRadioLabel: {
        id: 'loomLandOptIn.loomOnly.radioLabel',
        defaultMessage: 'Loom only'
    },
    loomOnlySubtitle: {
        id: 'loomLandOptIn.loomOnly.subtitle',
        defaultMessage: 'Try Loom as a standalone app'
    },
    loomOnlyCta: {
        id: 'loomLandOptIn.loomOnly.cta',
        defaultMessage: 'Continue with Loom only'
    },
    loomOnlyFeatureRecord: {
        id: 'loomLandOptIn.loomOnly.feature.record',
        defaultMessage: 'Record videos to share context or demos instantly'
    },
    loomOnlyFeatureRecaps: {
        id: 'loomLandOptIn.loomOnly.feature.recaps',
        defaultMessage: 'Get instant recaps from meetings'
    },
    loomOnlyFeatureShare: {
        id: 'loomLandOptIn.loomOnly.feature.share',
        defaultMessage: 'Share instantly with links that you can embed'
    },
    // Variant B "Continue with Loom" secondary CTA
    variantBLoomOnlyCta: {
        id: 'loomLandOptIn.variantB.loomOnlyCta',
        defaultMessage: 'Continue with Loom'
    },
    // Legal disclaimer (one per CTA wording). The <customerAgreement>,
    // <privacyPolicy> and <cancelAnytime> tags are rendered as inline links.
    legalTwc: {
        id: 'loomLandOptIn.legal.twc',
        defaultMessage: "By selecting \u201CTry it free\u201D, you agree to the <customerAgreement>Atlassian Customer Agreement</customerAgreement> and <privacyPolicy>Privacy Policy</privacyPolicy>. <cancelAnytime>Cancel anytime</cancelAnytime>."
    },
    legalLoomOnly: {
        id: 'loomLandOptIn.legal.loomOnly',
        defaultMessage: "By selecting \u201CContinue with Loom only\u201D, you agree to the <customerAgreement>Atlassian Customer Agreement</customerAgreement> and <privacyPolicy>Privacy Policy</privacyPolicy>. <cancelAnytime>Cancel anytime</cancelAnytime>."
    }
});
const $d3aa0934fe6d22db$export$8c925f0e56c3face = '$5';

});

parcelRegister("279Jr", function(module, exports) {
$parcel$export(module.exports, "OptInModalLayout", function () { return $bac0c4d8d0aaf94c$export$2372b1f775b23301; });
$parcel$export(module.exports, "useOptInModalViewed", function () { return $bac0c4d8d0aaf94c$export$301f6748dd3537fd; });
$parcel$export(module.exports, "useOptInChoiceChanged", function () { return $bac0c4d8d0aaf94c$export$4ac3b1f83273982c; });
$parcel$export(module.exports, "useOptInSelect", function () { return $bac0c4d8d0aaf94c$export$5a20abc75f089bc1; });
$parcel$export(module.exports, "OptInHeading", function () { return $bac0c4d8d0aaf94c$export$10628c681a9e4413; });
$parcel$export(module.exports, "OptInSubtitle", function () { return $bac0c4d8d0aaf94c$export$19f3a7744b74ec16; });
$parcel$export(module.exports, "TwcLogos", function () { return $bac0c4d8d0aaf94c$export$ef9995cced5e428a; });
$parcel$export(module.exports, "LoomOnlyLogo", function () { return $bac0c4d8d0aaf94c$export$fcd5dec128f69f11; });
$parcel$export(module.exports, "buildTwcFeatures", function () { return $bac0c4d8d0aaf94c$export$ebb83fab4cb3fa57; });
$parcel$export(module.exports, "LOOM_ONLY_FEATURES", function () { return $bac0c4d8d0aaf94c$export$9b817898deb055a6; });
$parcel$export(module.exports, "FeatureList", function () { return $bac0c4d8d0aaf94c$export$aa18130def4b6cb4; });
$parcel$export(module.exports, "LegalText", function () { return $bac0c4d8d0aaf94c$export$fc21a04a622ec81e; });
/* opt-in-shared.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $dTJrO = parcelRequire("dTJrO");

var $56bcs = parcelRequire("56bcs");

var $8DbjG = parcelRequire("8DbjG");

var $bECX9 = parcelRequire("bECX9");

var $48PMv = parcelRequire("48PMv");

var $1DU5m = parcelRequire("1DU5m");

var $6A2DX = parcelRequire("6A2DX");

var $kvjl7 = parcelRequire("kvjl7");

var $iSeHD = parcelRequire("iSeHD");

var $6hsym = parcelRequire("6hsym");

var $bSVv5 = parcelRequire("bSVv5");

var $iPPTB = parcelRequire("iPPTB");

var $jQ0cd = parcelRequire("jQ0cd");

var $um6FI = parcelRequire("um6FI");

var $7ukD3 = parcelRequire("7ukD3");

var $dECfd = parcelRequire("dECfd");

var $43Dso = parcelRequire("43Dso");

var $iTeuE = parcelRequire("iTeuE");
/**
 * Building blocks shared by every TWCG-2108 Loom Land opt-in variant: the modal
 * shell (50/50 content + graphic panel), analytics/selection hooks, and the
 * common header, feature list and legal copy. Variants only own what differs.
 */ // ---------------------------------------------------------------------------
// Modal shell
// ---------------------------------------------------------------------------
// Figma "TWC _ Variant A/B" frame height (px). Both columns share it so the
// 50/50 split reads as a full-height panel.
const $bac0c4d8d0aaf94c$var$MODAL_HEIGHT = 600;
// Content (left) + graphic panel (right), filling the full modal width so the
// panel bleeds to the modal's right edge. The "md" modal (972px) is ~the Figma
// 968px frame.
const $bac0c4d8d0aaf94c$var$layoutCss = null;
// Figma "Content" / "Main Card" frames: 64px top, 48px sides. An explicit 50%
// basis (plus minWidth:0) keeps the cards' intrinsic width from widening it.
const $bac0c4d8d0aaf94c$var$contentCss = null;
// Variant A: heading + cards at the top, legal text pinned to the bottom.
const $bac0c4d8d0aaf94c$var$choiceContentCss = null;
// Variant B: stacked sections, with the actions pushed to the bottom.
const $bac0c4d8d0aaf94c$var$singleContentCss = null;
const $bac0c4d8d0aaf94c$export$2372b1f775b23301 = ({ contentTestId: contentTestId, contentLayout: contentLayout, activeIllustration: activeIllustration, illustrations: illustrations, previewVideoSrc: previewVideoSrc, children: children })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $kvjl7.JiraBackground), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6hsym.Modal), {
            size: "md",
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.LoomLogo), {
                appearance: "brand",
                size: "medium",
                shouldUseNewLogoDesign: true
            }),
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx2vrvc _4cvr1fhb _1tke1ogm _1bsb1osq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "data-testid": contentTestId,
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _1q51xncg _18zroahv _16jlkb7n _1o9zkb7n _i0dl1ssb _1bsb1ssb _1ul9idpf _vchhusvi",
                            contentLayout === 'choice' ? "_1bah1yb4 _zulpv47k _85i5oahv" : "_zulp1jfw _85i5xncg"
                        ]),
                        children: children
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iTeuE.OptInGraphicPanel), {
                        active: activeIllustration,
                        illustrations: illustrations,
                        videoSrc: previewVideoSrc
                    })
                ]
            })
        })
    });
const $bac0c4d8d0aaf94c$export$301f6748dd3537fd = ({ variant: variant, cohort: cohort, edition: edition, priceMode: priceMode })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    (0, $1oC0p.useEffect)(()=>{
        if (!analyticsClient) return;
        (0, $43Dso.fireOptInModalViewed)({
            createAnalyticsEvent: createAnalyticsEvent,
            context: {
                variant: variant,
                cohort: cohort,
                edition: edition,
                priceMode: priceMode
            }
        });
    }, [
        analyticsClient,
        createAnalyticsEvent,
        variant,
        cohort,
        edition,
        priceMode
    ]);
};
const $bac0c4d8d0aaf94c$export$4ac3b1f83273982c = ({ variant: variant, cohort: cohort, edition: edition, priceMode: priceMode })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    return (0, $1oC0p.useCallback)((choice)=>(0, $43Dso.fireOptInChoiceChanged)({
            createAnalyticsEvent: createAnalyticsEvent,
            context: {
                variant: variant,
                cohort: cohort,
                edition: edition,
                priceMode: priceMode
            },
            choice: choice
        }), [
        createAnalyticsEvent,
        variant,
        cohort,
        edition,
        priceMode
    ]);
};
const $bac0c4d8d0aaf94c$export$5a20abc75f089bc1 = ({ onSelect: onSelect, context: context, search: search })=>{
    const { variant: variant, cohort: cohort, edition: edition, priceMode: priceMode } = context;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const redirectToChoice = (0, $7ukD3.useChoiceRedirect)(edition, search);
    return (0, $1oC0p.useCallback)((choice)=>{
        (0, $43Dso.fireOptInChoiceSelected)({
            createAnalyticsEvent: createAnalyticsEvent,
            context: {
                variant: variant,
                cohort: cohort,
                edition: edition,
                priceMode: priceMode
            },
            choice: choice
        });
        onSelect?.(choice);
        redirectToChoice(choice);
    }, [
        createAnalyticsEvent,
        redirectToChoice,
        onSelect,
        variant,
        cohort,
        edition,
        priceMode
    ]);
};
// ---------------------------------------------------------------------------
// Header
// ---------------------------------------------------------------------------
// `text-wrap: balance` keeps the title tidy if it ever wraps on narrow content.
const $bac0c4d8d0aaf94c$var$headingCss = null;
const $bac0c4d8d0aaf94c$export$10628c681a9e4413 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_3fcw10xh"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
            size: "large",
            as: "h1",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                ...(0, $dECfd.messages).heading
            })
        })
    });
const $bac0c4d8d0aaf94c$var$subtitleCss = null;
const $bac0c4d8d0aaf94c$export$19f3a7744b74ec16 = ({ message: message })=>/*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        className: (0, $2jatx.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c8fhey _syazi7uo"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            ...message
        })
    });
const $bac0c4d8d0aaf94c$var$logosCss = null;
const $bac0c4d8d0aaf94c$var$plusCss = null;
// Combined product-logos graphic (Jira, Confluence, Trello, Rovo), sized to
// match the Loom wordmark height beside it.
const $bac0c4d8d0aaf94c$var$appTilesCss = null;
const $bac0c4d8d0aaf94c$export$ef9995cced5e428a = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _4cvr1h6o _zulpu2gc _11c8fhey _k48pi7a9"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.LoomLogo), {
                appearance: "brand",
                size: "small",
                shouldUseNewLogoDesign: true
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                "aria-hidden": "true",
                className: (0, $2jatx.default)([
                    "_syazazsu _k48pi7a9"
                ]),
                children: "+"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($um6FI))),
                alt: intl.formatMessage((0, $dECfd.messages).twcOtherAppsAlt),
                className: (0, $2jatx.default)([
                    "_1e0c1ule _4t3i1ul9 _1bsb1wug"
                ])
            })
        ]
    });
};
// Loom-only header: bottom-aligned so the "only" qualifier sits on the Loom
// wordmark's baseline rather than its vertical centre.
const $bac0c4d8d0aaf94c$var$loomOnlyLogosCss = null;
// The Loom "small" logo's glyphs sit around the centre of its ~24px box, so the
// text is anchored to the bottom and nudged to land on the visual baseline.
const $bac0c4d8d0aaf94c$var$onlyLabelCss = null;
const $bac0c4d8d0aaf94c$export$fcd5dec128f69f11 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _4cvr1h6o _zulpu2gc _11c8fhey _k48pi7a9",
            "_4cvresu3"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.LoomLogo), {
                appearance: "brand",
                size: "small",
                shouldUseNewLogoDesign: true
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_1wpzesu3 _vwz4kb7n _t9ec17vv _syazazsu _k48pi7a9"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    ...(0, $dECfd.messages).loomOnlyLabel
                })
            })
        ]
    });
// Feature icons use the Atlassian brand blue to match Figma.
const $bac0c4d8d0aaf94c$var$featureIconColor = "var(--ds-icon-brand, #1868DB)";
const $bac0c4d8d0aaf94c$var$priceMessageForMode = (mode)=>{
    switch(mode){
        case 'less':
            return (0, $dECfd.messages).twcFeaturePriceLess;
        case 'absolute':
            return (0, $dECfd.messages).twcFeaturePriceAbsolute;
        case 'more':
        default:
            return (0, $dECfd.messages).twcFeaturePrice;
    }
};
const $bac0c4d8d0aaf94c$export$ebb83fab4cb3fa57 = (price, mode = 'more')=>[
        {
            message: (0, $dECfd.messages).twcFeatureEmbed,
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1DU5m))), {
                label: "",
                color: $bac0c4d8d0aaf94c$var$featureIconColor
            })
        },
        {
            message: (0, $dECfd.messages).twcFeatureNotes,
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bECX9))), {
                label: "",
                color: $bac0c4d8d0aaf94c$var$featureIconColor
            })
        },
        {
            message: $bac0c4d8d0aaf94c$var$priceMessageForMode(mode),
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($48PMv))), {
                label: "",
                color: $bac0c4d8d0aaf94c$var$featureIconColor
            }),
            values: {
                price: price
            }
        },
        {
            message: (0, $dECfd.messages).twcFeatureTrial,
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($56bcs))), {
                label: "",
                color: $bac0c4d8d0aaf94c$var$featureIconColor
            })
        }
    ];
const $bac0c4d8d0aaf94c$export$9b817898deb055a6 = [
    {
        message: (0, $dECfd.messages).loomOnlyFeatureRecord,
        icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1DU5m))), {
            label: "",
            color: $bac0c4d8d0aaf94c$var$featureIconColor
        })
    },
    {
        message: (0, $dECfd.messages).loomOnlyFeatureRecaps,
        icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bECX9))), {
            label: "",
            color: $bac0c4d8d0aaf94c$var$featureIconColor
        })
    },
    {
        message: (0, $dECfd.messages).loomOnlyFeatureShare,
        icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8DbjG))), {
            label: "",
            color: $bac0c4d8d0aaf94c$var$featureIconColor
        })
    }
];
const $bac0c4d8d0aaf94c$var$listCss = null;
const $bac0c4d8d0aaf94c$var$listItemCss = null;
// Compact rows inside Variant A's cards (Figma "Body/S", 12/16), keeping long
// copy such as the pricing line on a single line.
const $bac0c4d8d0aaf94c$var$smallListCss = null;
// Roomier rows for Variant B (Figma "Body/M", 14/20, 36px cells, 4px gap).
const $bac0c4d8d0aaf94c$var$mediumListCss = null;
const $bac0c4d8d0aaf94c$var$mediumListItemCss = null;
// Keeps the icon from shrinking (which would otherwise force text to wrap).
const $bac0c4d8d0aaf94c$var$listIconCss = null;
const $bac0c4d8d0aaf94c$var$listTextCss = null;
const $bac0c4d8d0aaf94c$export$aa18130def4b6cb4 = ({ features: features, size: size = 'small' })=>/*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _qtt8glyw",
            size === 'small' ? "_zulputpp _11c8wadc _syazazsu" : "_zulp1b66 _85i512x7 _11c8fhey _syazazsu"
        ]),
        children: features.map((feature)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _zulpu2gc",
                    size === 'medium' && "_1tke14no"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_1o9zidpf _1e0c1txw"
                        ]),
                        children: feature.icon
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_1ul9idpf"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            ...feature.message,
                            values: feature.values
                        })
                    })
                ]
            }, feature.message.id))
    });
// ---------------------------------------------------------------------------
// Legal
// ---------------------------------------------------------------------------
// Coerces `FormattedMessage` chunk children to a plain string. ICU passes the
// chunk content as an array; the messages here are always plain text, so a
// non-primitive `ReactNode` can never render as "[object Object]".
const $bac0c4d8d0aaf94c$var$chunksToString = (chunks)=>(Array.isArray(chunks) ? chunks : [
        chunks
    ]).map((c)=>typeof c === 'string' ? c : '').join('');
const $bac0c4d8d0aaf94c$export$e13ed879a76f4ae6 = (chunks)=>{
    const href = (0, $jQ0cd.useLocalizedHref)('/legal/atlassian-customer-agreement');
    const label = $bac0c4d8d0aaf94c$var$chunksToString(chunks);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
        "aria-label": label,
        href: href,
        text: label,
        type: "inline"
    });
};
const $bac0c4d8d0aaf94c$export$fdd773f48aebb8ab = (chunks)=>{
    const href = (0, $jQ0cd.useLocalizedHref)('/legal/privacy-policy');
    const label = $bac0c4d8d0aaf94c$var$chunksToString(chunks);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
        "aria-label": label,
        href: href,
        text: label,
        type: "inline"
    });
};
const $bac0c4d8d0aaf94c$export$e1cd16a1bf67ca6b = (chunks)=>{
    const label = $bac0c4d8d0aaf94c$var$chunksToString(chunks);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
        "aria-label": label,
        href: "https://support.atlassian.com/subscriptions-and-billing/docs/cancel-a-subscription/",
        text: label,
        type: "inline"
    });
};
const $bac0c4d8d0aaf94c$var$legalCss = null;
const $bac0c4d8d0aaf94c$export$fc21a04a622ec81e = ({ message: message })=>/*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        className: (0, $2jatx.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c8wadc _syaz1rpy"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            ...message,
            values: {
                customerAgreement: $bac0c4d8d0aaf94c$export$e13ed879a76f4ae6,
                privacyPolicy: $bac0c4d8d0aaf94c$export$fdd773f48aebb8ab,
                cancelAnytime: $bac0c4d8d0aaf94c$export$e1cd16a1bf67ca6b
            }
        })
    });

});
parcelRegister("bECX9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f64abe706416b0877b5dd221be64e7d7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87c1a5674979a6af$var$_react = $87c1a5674979a6af$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $87c1a5674979a6af$var$_baseNew = $87c1a5674979a6af$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $87c1a5674979a6af$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $87c1a5674979a6af$var$PageIcon = (props)=>/*#__PURE__*/ $87c1a5674979a6af$var$_react.default.createElement($87c1a5674979a6af$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM12 6H4V4.5h8zm-2 3.5H4V8h6z" clip-rule="evenodd"/>`
    }, props));
$87c1a5674979a6af$var$PageIcon.displayName = 'PageIcon';
var $87c1a5674979a6af$var$_default = module.exports.default = $87c1a5674979a6af$var$PageIcon;

});

parcelRegister("48PMv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::338651941b03ec38a528c6808ae2ffcd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3040137f93e7a89a$var$_react = $3040137f93e7a89a$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $3040137f93e7a89a$var$_baseNew = $3040137f93e7a89a$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $3040137f93e7a89a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Tag".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tags in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3040137f93e7a89a$var$TagIcon = (props)=>/*#__PURE__*/ $3040137f93e7a89a$var$_react.default.createElement($3040137f93e7a89a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2"/><path fill="currentcolor" fill-rule="evenodd" d="M9.286 1a3.25 3.25 0 0 0-2.299.952L1.604 7.336a2 2 0 0 0 0 2.828l4.232 4.232a2 2 0 0 0 2.828 0l5.384-5.383A3.25 3.25 0 0 0 15 6.714V3a2 2 0 0 0-2-2zM8.048 3.013A1.75 1.75 0 0 1 9.286 2.5H13a.5.5 0 0 1 .5.5v3.714c0 .465-.184.91-.513 1.238l-5.383 5.384a.5.5 0 0 1-.708 0L2.664 9.104a.5.5 0 0 1 0-.708z" clip-rule="evenodd"/>`
    }, props));
$3040137f93e7a89a$var$TagIcon.displayName = 'TagIcon';
var $3040137f93e7a89a$var$_default = module.exports.default = $3040137f93e7a89a$var$TagIcon;

});

parcelRegister("1DU5m", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d7f4cbe44d53d27d30976de2191c923>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1324f0579617a371$var$_react = $1324f0579617a371$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $1324f0579617a371$var$_baseNew = $1324f0579617a371$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $1324f0579617a371$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Video".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for representing video content across Atlassian and Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1324f0579617a371$var$VideoIcon = (props)=>/*#__PURE__*/ $1324f0579617a371$var$_react.default.createElement($1324f0579617a371$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 4a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-7A.5.5 0 0 0 10 4zm-2 .5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v.218l2.137-1.203A1.25 1.25 0 0 1 16 4.605v6.79a1.25 1.25 0 0 1-1.863 1.09L12 11.282v.218a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm12 5.061 2.5 1.407V5.032L12 6.44z" clip-rule="evenodd"/>`
    }, props));
$1324f0579617a371$var$VideoIcon.displayName = 'VideoIcon';
var $1324f0579617a371$var$_default = module.exports.default = $1324f0579617a371$var$VideoIcon;

});

parcelRegister("um6FI", function(module, exports) {
module.exports = new URL("twc-others.62c88fcd.svg", import.meta.url).toString();

});

parcelRegister("7ukD3", function(module, exports) {
$parcel$export(module.exports, "useChoiceRedirect", function () { return $7c682f8b2e0f8e98$export$ee80d4a08e7cd33; });

var $1oC0p = parcelRequire("1oC0p");

var $jQ0cd = parcelRequire("jQ0cd");

var $eRzlV = parcelRequire("eRzlV");
// Continue URLs for the opt-in CTAs. The TWC edition mirrors the price
// comparison (Business + AI → Premium, otherwise Standard). `loomIntent=true`
// lets the confirmation page route back into Loom onboarding (STARB-4196).
const $7c682f8b2e0f8e98$var$twcSignupPath = (twcEdition)=>`/try/cloud/signup?bundle=teamwork-collection&edition=${twcEdition}&loomIntent=true`;
// The Loom-only CTA mirrors the control cohort: fall through to the standard
// signup page with the original query string (edition, application, campaign
// params) preserved, rather than a hard-coded path.
const $7c682f8b2e0f8e98$var$loomSignupPath = (search)=>`/try/cloud/signup${search}`;
// Loom edition → provisioned TWC edition (mirrors use-twc-price.ts).
const $7c682f8b2e0f8e98$var$LOOM_EDITION_TO_TWC_SIGNUP_EDITION = {
    free: 'standard',
    starter: 'standard',
    business: 'standard',
    standard: 'standard',
    premium: 'premium',
    enterprise: 'premium'
};
const $7c682f8b2e0f8e98$export$ee80d4a08e7cd33 = (edition = 'premium', search = '')=>{
    const twcEdition = $7c682f8b2e0f8e98$var$LOOM_EDITION_TO_TWC_SIGNUP_EDITION[edition];
    // useLocalizedHref is a hook, so resolve both editions and pick at nav time.
    const twcPremiumHref = (0, $jQ0cd.useLocalizedHref)($7c682f8b2e0f8e98$var$twcSignupPath('premium'));
    const twcStandardHref = (0, $jQ0cd.useLocalizedHref)($7c682f8b2e0f8e98$var$twcSignupPath('standard'));
    const loomHref = (0, $jQ0cd.useLocalizedHref)($7c682f8b2e0f8e98$var$loomSignupPath(search));
    // Memoized on the resolved hrefs (strings) so callers get a stable reference.
    return (0, $1oC0p.useCallback)((choice)=>{
        if (choice !== 'teamwork-collection') {
            window.location.assign(`${(0, $eRzlV.getWacIntegrationUrl)()}${loomHref}`);
            return;
        }
        const twcHref = twcEdition === 'standard' ? twcStandardHref : twcPremiumHref;
        window.location.assign(`${(0, $eRzlV.getWacIntegrationUrl)()}${twcHref}`);
    }, [
        twcEdition,
        twcPremiumHref,
        twcStandardHref,
        loomHref
    ]);
};

});

parcelRegister("43Dso", function(module, exports) {
$parcel$export(module.exports, "fireOptInModalViewed", function () { return $ca4bad267cc432f4$export$22ff2a41ba1dd030; });
$parcel$export(module.exports, "fireOptInChoiceChanged", function () { return $ca4bad267cc432f4$export$b880a4202e4a5efe; });
$parcel$export(module.exports, "fireOptInChoiceSelected", function () { return $ca4bad267cc432f4$export$467cee22ba1bb3d3; });
$parcel$export(module.exports, "isOptInSloFailure", function () { return $ca4bad267cc432f4$export$295a390abcf84270; });
$parcel$export(module.exports, "getOptInRedirectReason", function () { return $ca4bad267cc432f4$export$baf4fe93415bcee7; });
$parcel$export(module.exports, "fireOptInPageRedirected", function () { return $ca4bad267cc432f4$export$f29bb2ee6c96db26; });
const $ca4bad267cc432f4$export$e2168d09e3af83d0 = 'loomLandOptInModal';
const $ca4bad267cc432f4$export$ac43e9942952445f = 'loomLandOptInChoice';
const $ca4bad267cc432f4$export$b7ec0fbee77b7258 = 'loomChoicePage';
const $ca4bad267cc432f4$var$toAttributes = ({ variant: variant, cohort: cohort, edition: edition, priceMode: priceMode })=>({
        variant: variant,
        cohort: cohort,
        edition: edition,
        priceMode: priceMode
    });
const $ca4bad267cc432f4$export$22ff2a41ba1dd030 = ({ createAnalyticsEvent: createAnalyticsEvent, context: context })=>{
    createAnalyticsEvent({
        eventType: 'screen',
        action: 'viewed',
        actionSubject: 'modal',
        name: $ca4bad267cc432f4$export$e2168d09e3af83d0,
        attributes: $ca4bad267cc432f4$var$toAttributes(context)
    }).fire();
};
const $ca4bad267cc432f4$export$b880a4202e4a5efe = ({ createAnalyticsEvent: createAnalyticsEvent, context: context, choice: choice })=>{
    createAnalyticsEvent({
        eventType: 'ui',
        action: 'changed',
        actionSubject: 'radio',
        actionSubjectId: $ca4bad267cc432f4$export$ac43e9942952445f,
        attributes: {
            ...$ca4bad267cc432f4$var$toAttributes(context),
            choice: choice
        }
    }).fire();
};
const $ca4bad267cc432f4$export$467cee22ba1bb3d3 = ({ createAnalyticsEvent: createAnalyticsEvent, context: context, choice: choice })=>{
    createAnalyticsEvent({
        eventType: 'ui',
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: $ca4bad267cc432f4$export$ac43e9942952445f,
        attributes: {
            ...$ca4bad267cc432f4$var$toAttributes(context),
            choice: choice
        }
    }).fire();
};
const $ca4bad267cc432f4$export$295a390abcf84270 = (reason)=>reason === 'statsigError' || reason === 'priceError';
const $ca4bad267cc432f4$export$baf4fe93415bcee7 = ({ isEnrolled: isEnrolled, isResolved: isResolved, cohort: cohort, edition: edition, hasPriceError: hasPriceError, hasCohortTimedOut: hasCohortTimedOut = false })=>{
    if (!isEnrolled) return 'notEnrolled';
    if (isResolved && cohort === 'control') return 'control';
    if (edition === 'enterprise') return 'enterprise';
    // An unresolved cohort means we can't trust the arm at all, so report it
    // ahead of a (possibly concurrent) price failure.
    if (!isResolved && hasCohortTimedOut) return 'statsigError';
    if (hasPriceError) return 'priceError';
    return undefined;
};
const $ca4bad267cc432f4$export$f29bb2ee6c96db26 = ({ createAnalyticsEvent: createAnalyticsEvent, reason: reason, cohort: cohort, edition: edition })=>{
    createAnalyticsEvent({
        eventType: 'track',
        action: 'redirected',
        actionSubject: $ca4bad267cc432f4$export$b7ec0fbee77b7258,
        attributes: {
            reason: reason,
            cohort: cohort,
            edition: edition
        }
    }).fire();
};

});

parcelRegister("iTeuE", function(module, exports) {
$parcel$export(module.exports, "OptInGraphicPanel", function () { return $4aad0a9db646ad9e$export$3071dcb0e4176382; });
/* opt-in-graphic-panel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");

var $iYmqG = parcelRequire("iYmqG");

var $hNqz9 = parcelRequire("hNqz9");

var $3QhgF = parcelRequire("3QhgF");
/**
 * Right-hand marketing panel for the TWCG-2108 Loom Land opt-in modal.
 *
 * Built in two layers so the design stays editable in one place:
 *  1. {@link PanelBackground} — the Blue200 field, white swirl and cross-hatch
 *     grid, drawn as an inline SVG shared by every variant/selection.
 *  2. A transparent, full-panel @2x PNG per selection containing only the
 *     foreground illustration (product cards, arrows, cursor pill). The cards
 *     contain photographic content, so a raster is far lighter than an SVG
 *     export (~70KB vs ~1.6MB with embedded images).
 *
 * Both layers share the Figma "Graphic (Right side)" 484x601 coordinate space,
 * so they always stay aligned as the panel scales. On load, a short Loom clip
 * plays over the active illustration's screen ({@link OptInPreviewVideo}).
 */ // Figma "Graphic (Right side)" frame size; the background viewBox and the
// foreground PNGs (exported at 2x: 968x1202) share this coordinate space.
const $4aad0a9db646ad9e$var$PANEL_WIDTH = 484;
const $4aad0a9db646ad9e$var$PANEL_HEIGHT = 601;
const $4aad0a9db646ad9e$var$ILLUSTRATIONS = {
    'teamwork-collection': (0, (/*@__PURE__*/$parcel$interopDefault($hNqz9))),
    'loom-only': (0, (/*@__PURE__*/$parcel$interopDefault($iYmqG)))
};
// Cross-hatch grid geometry from the Figma "grid" frame: evenly spaced lines,
// masked to a rotated rectangle and clipped to the grid frame.
const $4aad0a9db646ad9e$var$GRID_SPACING = 37.2851;
const $4aad0a9db646ad9e$var$GRID_FIRST_ROW_Y = 60.7576;
const $4aad0a9db646ad9e$var$GRID_FIRST_COLUMN_X = 28.375;
const $4aad0a9db646ad9e$var$GRID_ROW_COUNT = 14;
const $4aad0a9db646ad9e$var$GRID_COLUMN_COUNT = 13;
const $4aad0a9db646ad9e$var$GRID_ROWS = Array.from({
    length: $4aad0a9db646ad9e$var$GRID_ROW_COUNT
}, (_, i)=>$4aad0a9db646ad9e$var$GRID_FIRST_ROW_Y + i * $4aad0a9db646ad9e$var$GRID_SPACING);
const $4aad0a9db646ad9e$var$GRID_COLUMNS = Array.from({
    length: $4aad0a9db646ad9e$var$GRID_COLUMN_COUNT
}, (_, i)=>$4aad0a9db646ad9e$var$GRID_FIRST_COLUMN_X + i * $4aad0a9db646ad9e$var$GRID_SPACING);
const $4aad0a9db646ad9e$var$panelCss = null;
// Locks both layers to the artwork's aspect ratio, anchored to the top and
// spanning the full panel width (nothing is cropped horizontally).
const $4aad0a9db646ad9e$var$artboardCss = null;
const $4aad0a9db646ad9e$var$layerCss = null;
const $4aad0a9db646ad9e$var$illustrationCss = null;
const $4aad0a9db646ad9e$var$activeIllustrationCss = null;
const $4aad0a9db646ad9e$export$dc101e1690ff9c5e = ()=>{
    const id = (0, $1oC0p.useId)();
    const maskId = `${id}-grid-mask`;
    const clipId = `${id}-grid-clip`;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        viewBox: `0 0 ${$4aad0a9db646ad9e$var$PANEL_WIDTH} ${$4aad0a9db646ad9e$var$PANEL_HEIGHT}`,
        fill: "none",
        "aria-hidden": "true",
        focusable: "false",
        "data-testid": "loom-land-opt-in-panel-background",
        className: (0, $2jatx.default)([
            "_kqswstnw _152tidpf _1e02idpf _1bsb1osq _4t3i1osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                width: $4aad0a9db646ad9e$var$PANEL_WIDTH,
                height: $4aad0a9db646ad9e$var$PANEL_HEIGHT,
                fill: (0, $kbpa7.wacToken)('color.extended.blue200')
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M185 0.0348145C16.5 183.961 0 620 0 620V0H135L185 0.0348145Z",
                fill: "var(--ds-surface, #FFFFFF)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                        id: clipId,
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                            width: "879.37",
                            height: "512.862",
                            transform: "translate(-131 55)"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("mask", {
                        id: maskId,
                        maskUnits: "userSpaceOnUse",
                        x: "8",
                        y: "41",
                        width: "476",
                        height: "528",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M272.848 41.1989L483.84 422.516L219.485 568.791L8.49235 187.473Z",
                            fill: "white"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                clipPath: `url(#${clipId})`,
                mask: `url(#${maskId})`,
                stroke: (0, $kbpa7.wacToken)('color.extended.blue300'),
                children: [
                    $4aad0a9db646ad9e$var$GRID_ROWS.map((y)=>/*#__PURE__*/ (0, $7VQPk.jsx)("line", {
                            x1: "-176",
                            y1: y,
                            x2: "795",
                            y2: y
                        }, `row-${y}`)),
                    $4aad0a9db646ad9e$var$GRID_COLUMNS.map((x)=>/*#__PURE__*/ (0, $7VQPk.jsx)("line", {
                            x1: x,
                            y1: "-219",
                            x2: x,
                            y2: "942"
                        }, `column-${x}`))
                ]
            })
        ]
    });
};
const $4aad0a9db646ad9e$export$3071dcb0e4176382 = ({ active: active, illustrations: illustrations = [
    active
], videoSrc: videoSrc })=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        role: "presentation",
        "data-testid": "loom-land-opt-in-graphic-panel",
        className: (0, $2jatx.default)([
            "_1e0cglyw _kqswh2mm _16jlkb7n _1o9zkb7n _i0dl1ssb _1bsb1ssb _1ul9idpf _1wpz1fhb _1reo15vq _18m915vq _bfhkcafw _1o2q1ule"
        ]),
        style: {
            "--_1bnl49": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue200'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm _1bsb1osq _1h1tde7b"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)($4aad0a9db646ad9e$export$dc101e1690ff9c5e, {}),
                illustrations.map((illustration)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                        src: $4aad0a9db646ad9e$var$ILLUSTRATIONS[illustration],
                        alt: "",
                        "aria-hidden": "true",
                        loading: "eager",
                        "data-testid": `loom-land-opt-in-illustration-${illustration}`,
                        "data-active": illustration === active,
                        className: (0, $2jatx.default)([
                            "_kqswstnw _152tidpf _1e02idpf _1bsb1osq _4t3i1osq",
                            "_1e0c1ule _tzy4idpf _v56416ea _sedtglyw",
                            illustration === active && "_tzy4kb7n"
                        ])
                    }, illustration)),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3QhgF.OptInPreviewVideo), {
                    illustration: active,
                    src: videoSrc
                })
            ]
        })
    });

});
parcelRegister("iYmqG", function(module, exports) {
module.exports = new URL("panel-illustration-loom-only.76b354e2.png", import.meta.url).toString();

});

parcelRegister("hNqz9", function(module, exports) {
module.exports = new URL("panel-illustration-teamwork-collection.474e07bc.png", import.meta.url).toString();

});

parcelRegister("3QhgF", function(module, exports) {
$parcel$export(module.exports, "OptInPreviewVideo", function () { return $ecc44696e5dc62fe$export$44274ba9d50514fe; });
/* opt-in-preview-video.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $bSVv5 = parcelRequire("bSVv5");

var $cuK0v = parcelRequire("cuK0v");
const $ecc44696e5dc62fe$export$78cf4a960b1d0133 = 'https://dam-cdn.atl.orangelogic.com/AssetLink/ipar5pr23bo2u04lfugytxn27snq82gn.mp4';
const $ecc44696e5dc62fe$export$2f9f0f66ae58f92b = 5000;
const $ecc44696e5dc62fe$var$REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
// The graphic panel is hidden below 768px, so skip the download there.
const $ecc44696e5dc62fe$var$NARROW_VIEWPORT_QUERY = '(max-width: 767px)';
const $ecc44696e5dc62fe$var$videoCss = null;
/**
 * Screen rect of each illustration, as percentages of the 484x601 panel
 * artboard (see `opt-in-graphic-panel`). Teamwork Collection is the Figma
 * screen rect (x 147.246, y 149.221, 198.694 x 144.362, r 2.018); Loom-only is
 * the same screen scaled 1.137x (x 135.11, y 173.98, 225.94 x 164.13).
 */ const $ecc44696e5dc62fe$var$videoScreenCss = {
    'teamwork-collection': "_152t1jbf _1e021a21 _1bsb1fz5 _4t3i1vmb _2rkolkp4",
    'loom-only': "_152t9ma0 _1e021thb _1bsbl3ws _4t3igkzy _2rkov7bf"
};
const $ecc44696e5dc62fe$var$foregroundCss = null;
const $ecc44696e5dc62fe$var$visibleCss = null;
/**
 * Artwork that overlaps an illustration's screen and must stay above the
 * video (Teamwork Collection's "Summarize meeting" pill and cursor). Loom-only
 * has nothing overlapping its screen.
 */ const $ecc44696e5dc62fe$var$VIDEO_FOREGROUNDS = {
    'teamwork-collection': (0, (/*@__PURE__*/$parcel$interopDefault($cuK0v)))
};
const $ecc44696e5dc62fe$export$44274ba9d50514fe = ({ illustration: illustration, src: src = $ecc44696e5dc62fe$export$78cf4a960b1d0133 })=>{
    const [playedIllustrations, setPlayedIllustrations] = (0, $1oC0p.useState)([
        illustration
    ]);
    const [playbackIllustration, setPlaybackIllustration] = (0, $1oC0p.useState)(illustration);
    (0, $1oC0p.useEffect)(()=>{
        if (playedIllustrations.includes(illustration)) {
            // Already had its turn (or is the one playing now): stay or go static.
            if (playbackIllustration !== illustration) setPlaybackIllustration(null);
            return;
        }
        setPlayedIllustrations([
            ...playedIllustrations,
            illustration
        ]);
        setPlaybackIllustration(illustration);
    }, [
        illustration,
        playedIllustrations,
        playbackIllustration
    ]);
    // Rendering only while the selection matches unmounts a clip as soon as the
    // user switches away; keying by illustration gives each card a fresh player.
    if (playbackIllustration !== illustration) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)($ecc44696e5dc62fe$var$PreviewVideoPlayback, {
        illustration: illustration,
        src: src
    }, illustration);
};
/** One playback of the clip on one illustration's screen. */ const $ecc44696e5dc62fe$var$PreviewVideoPlayback = ({ illustration: illustration, src: src })=>{
    const [status, setStatus] = (0, $1oC0p.useState)('off');
    const videoRef = (0, $1oC0p.useRef)(null);
    const stopTimeoutRef = (0, $1oC0p.useRef)(null);
    const clearStopTimeout = (0, $1oC0p.useCallback)(()=>{
        if (stopTimeoutRef.current !== null) {
            window.clearTimeout(stopTimeoutRef.current);
            stopTimeoutRef.current = null;
        }
    }, []);
    const stop = (0, $1oC0p.useCallback)(()=>{
        clearStopTimeout();
        setStatus('off');
    }, [
        clearStopTimeout
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (!src || typeof window.matchMedia !== 'function') return undefined;
        const reducedMotion = window.matchMedia($ecc44696e5dc62fe$var$REDUCED_MOTION_QUERY);
        if (reducedMotion.matches || window.matchMedia($ecc44696e5dc62fe$var$NARROW_VIEWPORT_QUERY).matches) return undefined;
        setStatus('loading');
        const stopForReducedMotion = (event)=>{
            if (event.matches) stop();
        };
        reducedMotion.addEventListener?.('change', stopForReducedMotion);
        return ()=>{
            clearStopTimeout();
            reducedMotion.removeEventListener?.('change', stopForReducedMotion);
        };
    }, [
        src,
        stop,
        clearStopTimeout
    ]);
    // Start playback explicitly so a blocked autoplay (rejected promise) falls
    // back to the static illustration instead of leaving a frozen first frame.
    (0, $1oC0p.useEffect)(()=>{
        if (status !== 'loading') return;
        const playPromise = videoRef.current?.play();
        playPromise?.catch(stop);
    }, [
        status,
        stop
    ]);
    const handlePlaying = ()=>{
        setStatus('playing');
        // `playing` also fires after buffering stalls; only start the clock once.
        if (stopTimeoutRef.current === null) stopTimeoutRef.current = window.setTimeout(stop, $ecc44696e5dc62fe$export$2f9f0f66ae58f92b);
    };
    if (status === 'off') return null;
    const isPlaying = status === 'playing';
    const foreground = $ecc44696e5dc62fe$var$VIDEO_FOREGROUNDS[illustration];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("video", {
                ref: videoRef,
                src: src,
                muted: true,
                playsInline: true,
                preload: "auto",
                "aria-hidden": "true",
                tabIndex: -1,
                onPlaying: handlePlaying,
                onEnded: stop,
                onError: stop,
                "data-testid": "loom-land-opt-in-preview-video",
                "data-playing": isPlaying,
                className: (0, $2jatx.default)([
                    "_kqswstnw _5ral1dfr _t9ec1x4n _8hrz5d63 _lcxvglyw _tzy4idpf _v56416ea",
                    $ecc44696e5dc62fe$var$videoScreenCss[illustration],
                    isPlaying && "_tzy4kb7n"
                ])
            }),
            foreground && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                src: foreground,
                alt: "",
                "aria-hidden": "true",
                loading: "eager",
                "data-testid": "loom-land-opt-in-preview-video-foreground",
                className: (0, $2jatx.default)([
                    "_kqswstnw _152tidpf _1e02idpf _1bsb1osq _4t3i1osq _lcxvglyw _tzy4idpf _v56416ea",
                    isPlaying && "_tzy4kb7n"
                ])
            })
        ]
    });
};

});
parcelRegister("cuK0v", function(module, exports) {
module.exports = new URL("video-foreground-teamwork-collection.3e8c8375.svg", import.meta.url).toString();

});





parcelRegister("h6kyD", function(module, exports) {
$parcel$export(module.exports, "LoomChoiceVariantB", function () { return $815a54cad0271235$export$37e60ed80f15e833; });
/* loom-choice-variant-b.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $6uJzV = parcelRequire("6uJzV");

var $dECfd = parcelRequire("dECfd");

var $279Jr = parcelRequire("279Jr");
/**
 * TWCG-2108 Loom Land opt-in — "Variant B" design.
 *
 * A single-option variant (no radio choice): it presents only the Teamwork
 * Collection pitch with a primary CTA and a secondary Loom-only CTA, on the same
 * 50/50 modal as Variant A. The modal shell, analytics, header, features, legal
 * copy and graphic panel are shared via `opt-in-shared`.
 */ const $815a54cad0271235$var$CONTENT_TEST_ID = 'loom-land-opt-in-variant-b';
// Figma "Information Container": headline, features and legal, 20px apart.
const $815a54cad0271235$var$informationCss = null;
// Figma "Headline": heading and subtitle, 12px apart.
const $815a54cad0271235$var$headlineCss = null;
// Actions aligned bottom-right and pinned to the bottom of the column.
const $815a54cad0271235$var$actionsCss = null;
const $815a54cad0271235$export$37e60ed80f15e833 = ({ onSelect: onSelect, price: price = (0, $dECfd.DEFAULT_TWC_PRICE), priceMode: priceMode = 'more', edition: edition = 'premium', search: search = '', cohort: cohort, previewVideoSrc: previewVideoSrc })=>{
    const analyticsContext = {
        variant: 'b',
        cohort: cohort,
        edition: edition,
        priceMode: priceMode
    };
    const handleSelect = (0, $279Jr.useOptInSelect)({
        onSelect: onSelect,
        context: analyticsContext,
        search: search
    });
    (0, $279Jr.useOptInModalViewed)(analyticsContext);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $279Jr.OptInModalLayout), {
        contentTestId: $815a54cad0271235$var$CONTENT_TEST_ID,
        contentLayout: "single",
        activeIllustration: "teamwork-collection",
        previewVideoSrc: previewVideoSrc,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $279Jr.TwcLogos), {}),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulpv47k"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _zulputpp"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $279Jr.OptInHeading), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $279Jr.OptInSubtitle), {
                                message: (0, $dECfd.messages).twcSubtitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $279Jr.FeatureList), {
                        features: (0, $279Jr.buildTwcFeatures)(price, priceMode),
                        size: "medium"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $279Jr.LegalText), {
                        message: (0, $dECfd.messages).legalTwc
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bahesu3 _4cvr1h6o _zulp1b66 _1pfh1wug"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6uJzV.default), {
                        appearance: "subtle",
                        onClick: ()=>handleSelect('loom-only'),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            ...(0, $dECfd.messages).variantBLoomOnlyCta
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6uJzV.default), {
                        appearance: "primary",
                        onClick: ()=>handleSelect('teamwork-collection'),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            ...(0, $dECfd.messages).twcCta
                        })
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("fLCEK", function(module, exports) {
$parcel$export(module.exports, "useLoomLandOptIn", function () { return $bf4959bf4d458994$export$6074d851f3145851; });

var $1oC0p = parcelRequire("1oC0p");

var $3L8ZR = parcelRequire("3L8ZR");

var $4X0dO = parcelRequire("4X0dO");

var $gIKKj = parcelRequire("gIKKj");
const $bf4959bf4d458994$export$610866ff4eaaacd4 = 5000;
const $bf4959bf4d458994$export$6074d851f3145851 = ()=>{
    const experiment = (0, $gIKKj.useExperiment)((0, $4X0dO.experiments).twcg2108LoomLandOptIn);
    const isEnrolled = experiment.type === (0, $gIKKj.EnrollmentType).ENROLLED;
    // Narrow to a single resolved-enrolled reference so reads of `value` are
    // type-safe (the not-enrolled / indeterminate arms of the union lack it).
    const resolvedExperiment = isEnrolled && experiment.usingDefault === false ? experiment : undefined;
    const isResolved = resolvedExperiment !== undefined;
    const cohort = resolvedExperiment?.value ?? 'control';
    // Client-only timer (effects don't run during SSR), cleared if the arm resolves.
    const isWaitingForCohort = isEnrolled && !isResolved;
    const [hasResolveTimedOut, setHasResolveTimedOut] = (0, $1oC0p.useState)(false);
    (0, $1oC0p.useEffect)(()=>{
        if (!isWaitingForCohort) return;
        // Statsig already initialised and still has no value for us: `useExperiment`
        // won't re-read it, so waiting can't help — give up now rather than after
        // the timeout. The timer only covers Statsig still (or never) initialising.
        if ((0, $3L8ZR.default).initializeCompleted()) {
            setHasResolveTimedOut(true);
            return;
        }
        const timer = setTimeout(()=>setHasResolveTimedOut(true), $bf4959bf4d458994$export$610866ff4eaaacd4);
        return ()=>clearTimeout(timer);
    }, [
        isWaitingForCohort
    ]);
    return {
        cohort: cohort,
        isResolved: isResolved,
        isEnrolled: isEnrolled,
        hasResolveTimedOut: hasResolveTimedOut
    };
};

});

parcelRegister("czr4e", function(module, exports) {
$parcel$export(module.exports, "resolveLoomEdition", function () { return $d6fb30f597c31a61$export$b8b9980876c83c3d; });
$parcel$export(module.exports, "useTwcPrice", function () { return $d6fb30f597c31a61$export$593726f57412763c; });

var $1oC0p = parcelRequire("1oC0p");

var $ieLA0 = parcelRequire("ieLA0");

var $dkcYJ = parcelRequire("dkcYJ");

var $7aFr7 = parcelRequire("7aFr7");

var $hu3Tl = parcelRequire("hu3Tl");

var $4utnL = parcelRequire("4utnL");

var $dECfd = parcelRequire("dECfd");
// Loom edition → CCP SKU. `standard` reuses `business` and `starter` reuses
// `free` (Loom has no separate standard/starter SKU).
const $d6fb30f597c31a61$var$LOOM_EDITION_TO_SKU = {
    free: (0, $4utnL.loomOfferingSkus).free,
    starter: (0, $4utnL.loomOfferingSkus).free,
    business: (0, $4utnL.loomOfferingSkus).business,
    standard: (0, $4utnL.loomOfferingSkus).business,
    premium: (0, $4utnL.loomOfferingSkus).businessPlusAi,
    enterprise: (0, $4utnL.loomOfferingSkus).enterprise
};
// Loom edition → the TWC edition we compare against (Business + AI vs Premium,
// everything else vs Standard).
const $d6fb30f597c31a61$var$LOOM_EDITION_TO_TWC_SKU = {
    free: (0, $7aFr7.offeringSkus).standard,
    starter: (0, $7aFr7.offeringSkus).standard,
    business: (0, $7aFr7.offeringSkus).standard,
    standard: (0, $7aFr7.offeringSkus).standard,
    premium: (0, $7aFr7.offeringSkus).premium,
    enterprise: (0, $7aFr7.offeringSkus).premium
};
// Editions where we show the raw TWC price instead of a delta.
const $d6fb30f597c31a61$var$ABSOLUTE_PRICE_EDITIONS = new Set([
    'free',
    'starter'
]);
const $d6fb30f597c31a61$var$DEFAULT_LOOM_EDITION = 'premium';
const $d6fb30f597c31a61$export$b8b9980876c83c3d = (edition)=>{
    const normalized = edition?.toLowerCase();
    if (normalized && normalized in $d6fb30f597c31a61$var$LOOM_EDITION_TO_SKU) return normalized;
    return $d6fb30f597c31a61$var$DEFAULT_LOOM_EDITION;
};
// CCP amounts come back in minor units. We only support USD and JPY: USD is in
// cents (divide by 100), JPY has no minor units and is already whole (use as-is).
// Mirrors the 'USD' | 'JPY' handling in ccp-to-hams-pricing-plan-converter and
// the JPY special-case in amounts-format.
const $d6fb30f597c31a61$var$toMajorUnits = (minorAmount, currency)=>currency === 'JPY' ? minorAmount : minorAmount / 100;
/**
 * Reads the per-user, monthly, first-tier amount (in major units) for the given
 * currency from a CCP offering. Returns `undefined` when the offering has no
 * matching monthly per-user plan (e.g. a free offering with no plan, or an
 * enterprise offering that is annual/quote-based only).
 */ const $d6fb30f597c31a61$var$readMonthlyPerUserAmount = (offering, currency)=>{
    const plan = offering?.defaultPricingPlans?.find((p)=>p.currency === currency && p.primaryCycle_name === 'MONTHLY');
    const userItem = plan?.items.find((item)=>item.chargeElement === 'user');
    const firstTier = userItem?.tiers[0];
    if (!firstTier || typeof firstTier.unitAmount !== 'number') return undefined;
    return $d6fb30f597c31a61$var$toMajorUnits(firstTier.unitAmount, currency);
};
/**
 * Loom baseline (major units) to subtract from the TWC price: the monthly
 * per-user amount, `0` for FREE offerings, or `undefined` when there's no
 * monthly rate (enterprise / annual-only) so the caller falls back.
 */ const $d6fb30f597c31a61$var$resolveLoomBaseline = (offering, currency)=>{
    const amount = $d6fb30f597c31a61$var$readMonthlyPerUserAmount(offering, currency);
    if (typeof amount === 'number') return amount;
    if (offering?.pricingType === 'FREE') return 0;
    return undefined;
};
/** How long to wait for geo + CCP before treating the price fetch as failed. */ const $d6fb30f597c31a61$var$PRICE_FETCH_TIMEOUT_MS = 10000;
// Fallback reads as a "more" delta.
const $d6fb30f597c31a61$var$DEFAULT_RESULT_MODE = 'more';
const $d6fb30f597c31a61$var$DEFAULT_RESULT = {
    price: (0, $dECfd.DEFAULT_TWC_PRICE),
    mode: $d6fb30f597c31a61$var$DEFAULT_RESULT_MODE,
    isLoading: false,
    hasError: false
};
/** Terminal result when the price fetch fails or times out. */ const $d6fb30f597c31a61$var$ERROR_RESULT = {
    price: (0, $dECfd.DEFAULT_TWC_PRICE),
    mode: $d6fb30f597c31a61$var$DEFAULT_RESULT_MODE,
    isLoading: false,
    hasError: true
};
/** Formats an amount, falling back to the default result on any format error. */ const $d6fb30f597c31a61$var$formatResult = (currency, amount, mode)=>{
    try {
        return {
            price: (0, $ieLA0.getFormattedPrice)(currency, amount),
            mode: mode,
            isLoading: false,
            hasError: false
        };
    } catch  {
        return $d6fb30f597c31a61$var$DEFAULT_RESULT;
    }
};
/** Derives the display result from already-fetched CCP amounts. */ const $d6fb30f597c31a61$var$resolvePriceResult = (twcAmount, loomBaseline, currency, isAbsolute)=>{
    // Missing TWC amount → fall back.
    if (typeof twcAmount !== 'number' || !Number.isFinite(twcAmount)) return $d6fb30f597c31a61$var$DEFAULT_RESULT;
    // Absolute (Starter): raw TWC price, no delta.
    if (isAbsolute) return $d6fb30f597c31a61$var$formatResult(currency, twcAmount, 'absolute');
    // Delta case needs a Loom baseline; without one, fall back.
    if (typeof loomBaseline !== 'number') return $d6fb30f597c31a61$var$DEFAULT_RESULT;
    const delta = twcAmount - loomBaseline;
    if (!Number.isFinite(delta) || delta === 0) return $d6fb30f597c31a61$var$DEFAULT_RESULT;
    // Positive → TWC costs more; negative → cheaper.
    return $d6fb30f597c31a61$var$formatResult(currency, Math.abs(delta), delta > 0 ? 'more' : 'less');
};
const $d6fb30f597c31a61$export$593726f57412763c = (edition = $d6fb30f597c31a61$var$DEFAULT_LOOM_EDITION)=>{
    const deliveryKey = "nDQjfHDrrDfmPuccfIHYNMU3pSNCi1WOTRsI-q0igVU";
    const space = "3s3v3nq72la0";
    const locationBaseUrl = "https://www.atlassian.com/endpoint";
    const twcSku = $d6fb30f597c31a61$var$LOOM_EDITION_TO_TWC_SKU[edition];
    const loomSku = $d6fb30f597c31a61$var$LOOM_EDITION_TO_SKU[edition];
    const isAbsolute = $d6fb30f597c31a61$var$ABSOLUTE_PRICE_EDITIONS.has(edition);
    const { prices: ccpPricingData, status: ccpStatus, fetchData: fetchCcpData } = (0, $dkcYJ.useCCPPriceFinderData)([
        twcSku,
        loomSku
    ], deliveryKey, space);
    // The CCP hook has no error state and never resolves its status if the fetch
    // rejects, so track failures ourselves. `hasError` also covers the timeout.
    const [hasError, setHasError] = (0, $1oC0p.useState)(false);
    (0, $1oC0p.useEffect)(()=>{
        // Wrap in Promise.resolve so a non-promise return can't throw here, and
        // surface any rejection as an error (the CCP hook has no error state).
        Promise.resolve(fetchCcpData()).catch(()=>setHasError(true));
    }, [
        fetchCcpData
    ]);
    const { countryCode: countryCode, status: locationStatus } = (0, $hu3Tl.useGeoLocation)(locationBaseUrl);
    const currency = (0, $hu3Tl.getCurrencyFromUserLocale)(countryCode ?? '');
    const isLoading = locationStatus !== 'complete' || ccpStatus !== 'complete';
    // Guard against a hung request (fetch that neither resolves nor rejects):
    // give up after the timeout so callers can fall back instead of spinning.
    (0, $1oC0p.useEffect)(()=>{
        if (!isLoading) return;
        const timer = setTimeout(()=>setHasError(true), $d6fb30f597c31a61$var$PRICE_FETCH_TIMEOUT_MS);
        return ()=>clearTimeout(timer);
    }, [
        isLoading
    ]);
    if (hasError) return $d6fb30f597c31a61$var$ERROR_RESULT;
    const hasData = Boolean(ccpPricingData && countryCode);
    if (isLoading || !hasData) return {
        price: (0, $dECfd.DEFAULT_TWC_PRICE),
        mode: $d6fb30f597c31a61$var$DEFAULT_RESULT_MODE,
        isLoading: isLoading,
        hasError: false
    };
    const twcAmount = $d6fb30f597c31a61$var$readMonthlyPerUserAmount(ccpPricingData?.[twcSku], currency);
    // For the delta case we also need the Loom baseline (free → 0). The absolute
    // case ignores it. `resolvePriceResult` handles all the miss/fallback branches.
    const loomBaseline = $d6fb30f597c31a61$var$resolveLoomBaseline(ccpPricingData?.[loomSku], currency);
    return $d6fb30f597c31a61$var$resolvePriceResult(twcAmount, loomBaseline, currency, isAbsolute);
};

});
parcelRegister("7aFr7", function(module, exports) {
$parcel$export(module.exports, "offeringSkus", function () { return $b5b897d4f7b95ee2$export$b2421372229fc1c9; });
const $b5b897d4f7b95ee2$export$b2421372229fc1c9 = {
    free: 'teamwork-collection-free-sku',
    standard: 'teamwork-collection-standard-sku',
    premium: 'teamwork-collection-premium-sku',
    enterprise: 'teamwork-collection-enterprise-sku'
};

});




parcelRegister("lfqXN", function(module, exports) {
$parcel$export(module.exports, "TryPage", function () { return $75831ec207552eea$export$609689a2a01efdbc; });

var $7VQPk = parcelRequire("7VQPk");

var $blNyO = parcelRequire("blNyO");
const $75831ec207552eea$export$609689a2a01efdbc = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $blNyO.TryPageTemplate), {});

});
parcelRegister("blNyO", function(module, exports) {
$parcel$export(module.exports, "TryPageTemplate", function () { return $6b6ef2c343dd8dd5$export$86c5cc40b74df40f; });

var $7VQPk = parcelRequire("7VQPk");

var $iLjCW = parcelRequire("iLjCW");

var $hcVGp = parcelRequire("hcVGp");

var $axrSA = parcelRequire("axrSA");

var $km4VI = parcelRequire("km4VI");

var $fPSzg = parcelRequire("fPSzg");

var $gTqUW = parcelRequire("gTqUW");

var $aUlfh = parcelRequire("aUlfh");

var $eLUM2 = parcelRequire("eLUM2");

var $liucL = parcelRequire("liucL");

var $cBRR6 = parcelRequire("cBRR6");
const $6b6ef2c343dd8dd5$export$86c5cc40b74df40f = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hcVGp.GlobalNav), {
                    isShowTryNowLink: false,
                    tryNowLinkCtaButtonColor: "light_grey",
                    productKey: "try"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aUlfh.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $liucL.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cBRR6.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $km4VI.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $axrSA.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eLUM2.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gTqUW.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fPSzg.default), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iLjCW.GlobalFooter), {})
        ]
    });
};

});
parcelRegister("axrSA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e9dc8f62f5e147b0$export$2e2bcd8739ae039; });
/* code-build-ship-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $jQ0cd = parcelRequire("jQ0cd");

var $1rGpC = parcelRequire("1rGpC");

var $2Df35 = parcelRequire("2Df35");

var $lVutU = parcelRequire("lVutU");

var $5Dppx = parcelRequire("5Dppx");

var $8p9Sp = parcelRequire("8p9Sp");
const $e9dc8f62f5e147b0$var$sectionCss = null;
const $e9dc8f62f5e147b0$var$CodeBuildShipSection = ()=>{
    const intl = (0, $8e22h.default)();
    const codeBuildShipHeaderText = intl.formatMessage({
        id: 'TryPageTemplate.codeBuildShip.headerText',
        defaultMessage: 'Code, Build, & Ship'
    });
    const bitbucketBody = intl.formatMessage({
        id: 'TryPageTemplate.codeBuildShip.bitbucket.bodyText',
        defaultMessage: 'Collaborate on code with inline comments and pull requests. Manage and share your Git repositories to build and ship software, as a team.'
    });
    const sourcetreeBody = intl.formatMessage({
        id: 'TryPageTemplate.codeBuildShip.sourcetree.bodyText',
        defaultMessage: 'Harness the full power of Git and Mercurial in a beautifully simple application. Get the free desktop client for Mac and Windows.'
    });
    const compassBody = intl.formatMessage({
        id: 'TryPageTemplate.codeBuildShip.compass.bodyText',
        defaultMessage: 'Bring your distributed software architecture and the teams that collaborate on it together in a single, unified place.'
    });
    const rovoDevBody = intl.formatMessage({
        id: 'TryPageTemplate.codeBuildShip.rovoDev.bodyText',
        defaultMessage: 'Stay in the flow longer with AI-enabled productivity and quality for the full software delivery lifecycle.'
    });
    const tryCloud = intl.formatMessage((0, $8p9Sp.messages).tryCloud);
    const downloadNow = intl.formatMessage((0, $8p9Sp.messages).downloadNow);
    const bitbucketLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: 'bitbucket',
        type: "logo",
        appearance: "brand"
    });
    const rovoLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: 'rovodev',
        type: "logo",
        appearance: "brand"
    });
    const sourcetreeLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: 'sourcetree',
        type: "logo",
        appearance: "brand"
    });
    const compassLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: 'compass',
        type: "logo",
        appearance: "brand"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $bQjAr.default), {
        name: 'code-build-ship',
        className: (0, $2jatx.default)([
            "_ca0qzwfg _u5f3idpf _n3tdzwfg _19bvidpf _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5Dppx.TryPageHeader), {
                    dividerColor: '#ff8b00',
                    headerText: codeBuildShipHeaderText
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1rGpC.Row), {
                layout: "6-6",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
                        logo: bitbucketLogo,
                        link: (0, $jQ0cd.useLocalizedHref)('/software/bitbucket/bundle'),
                        bodyText: bitbucketBody,
                        ctaText: tryCloud
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
                        logo: rovoLogo,
                        link: (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=devai'),
                        bodyText: rovoDevBody,
                        ctaText: tryCloud
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {}),
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1rGpC.Row), {
                layout: "6-6",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
                        logo: sourcetreeLogo,
                        link: 'https://www.sourcetreeapp.com/',
                        bodyText: sourcetreeBody,
                        ctaText: downloadNow
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
                        logo: compassLogo,
                        link: (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=compass'),
                        bodyText: compassBody,
                        ctaText: tryCloud
                    })
                ]
            })
        ]
    });
};
var $e9dc8f62f5e147b0$export$2e2bcd8739ae039 = $e9dc8f62f5e147b0$var$CodeBuildShipSection;

});
parcelRegister("lVutU", function(module, exports) {
$parcel$export(module.exports, "TryPageCard", function () { return $94c5ed983b086607$export$78a2651bc04a8175; });
/* try-page-card.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $ldrV1 = parcelRequire("ldrV1");
const $94c5ed983b086607$var$pStyle = null;
const $94c5ed983b086607$var$tryPageCardStyles = null;
const $94c5ed983b086607$var$logoBlockStyles = null;
const $94c5ed983b086607$var$StyledLogo = (logo)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_6rth19bv _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1752zwfg _w8l51wug _4x201osq"
        ]),
        children: logo
    });
};
const $94c5ed983b086607$export$78a2651bc04a8175 = (props)=>{
    const { title: title, logo: logo, link: link, bodyText: bodyText, ctaText: ctaText, buttonColor: buttonColor, buttonType: buttonType } = props;
    const styledLogo = logo && $94c5ed983b086607$var$StyledLogo(logo);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf"
        ]),
        children: [
            title && /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                children: title
            }),
            styledLogo && /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                href: link,
                children: styledLogo
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_1wyb1j6v _1pfhgrf3 _6rth1tcg",
                    "tryCardText"
                ]),
                children: bodyText
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ldrV1.Button), {
                className: 'ctaButton',
                text: ctaText,
                type: buttonType ?? 'secondary',
                url: link,
                size: 'small',
                color: buttonColor ?? 'darkblue',
                dataEventProps: {
                    'data-product-key': 'try',
                    'data-event-component': 'linkButton',
                    'data-event-container': 'cardSection',
                    'data-event': 'clicked',
                    'data-label': ctaText
                }
            })
        ]
    });
};

});

parcelRegister("5Dppx", function(module, exports) {
$parcel$export(module.exports, "TryPageHeader", function () { return $1e078ab4da7fc99d$export$d30aca31b48239d; });
/* try-page-header.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $2ivuE = parcelRequire("2ivuE");
const $1e078ab4da7fc99d$export$d30aca31b48239d = (props)=>{
    const { dividerColor: dividerColor, headerText: headerText } = props;
    const headerStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4f1d1bqd _z5uk7vkz _1boa7vkz _16itidpf _ad5cidpf _4rmj11ph _16niidpf _1132idpf _19abftgi _edooidpf _rzyb1k8s _1apkdlk8 _1x4qahaf _hkvxdlk8 _sizi1tcg _11o6bmm0 _u25g1y44 _19ed7vkz _pgbz11ux _2z90idpf _1mvaidpf"
        ]),
        style: {
            "--_ei0dq9": (0, $6ZVlx.default)(dividerColor)
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ivuE.ContentBlock), {
            headerText: headerText,
            headerType: 'h2',
            horizontalRule: true
        })
    });
};

});

parcelRegister("8p9Sp", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $2356406d4679fc86$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $2356406d4679fc86$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    tryCloud: {
        id: 'TryPageTemplate.tryCloud',
        defaultMessage: 'Try cloud'
    },
    downloadNow: {
        id: 'TryPageTemplate.downloadNow',
        defaultMessage: 'Download now'
    }
});

});


parcelRegister("km4VI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $820dda0b0a60c7c4$export$2e2bcd8739ae039; });
/* collaborate-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $1rGpC = parcelRequire("1rGpC");

var $2Df35 = parcelRequire("2Df35");

var $lVutU = parcelRequire("lVutU");

var $5Dppx = parcelRequire("5Dppx");

var $8p9Sp = parcelRequire("8p9Sp");
const $820dda0b0a60c7c4$var$sectionCss = null;
const $820dda0b0a60c7c4$var$CollaborateSection = ()=>{
    const intl = (0, $8e22h.default)();
    const tryCloud = intl.formatMessage((0, $8p9Sp.messages).tryCloud);
    const collaborateTitle = intl.formatMessage({
        id: 'TryPageTemplate.collaborate.title',
        defaultMessage: 'Collaborate'
    });
    const confluenceBody = intl.formatMessage({
        id: 'TryPageTemplate.collaborate.confluenceBody',
        defaultMessage: 'Get things done instead of hunting things down. Organize your work, create documents, and discuss everything in one place.'
    });
    const trelloBody = intl.formatMessage({
        id: 'TryPageTemplate.collaborate.trelloBody',
        defaultMessage: 'Collaborate and get more done. Trello boards enable your team to organize projects in a fun, flexible, and visual way.'
    });
    const loomBody = intl.formatMessage({
        id: 'TryPageTemplate.collaborate.loomBody',
        defaultMessage: 'Record your screen, camera, and voice with Loom. Send async video messages on an AI-powered platform.'
    });
    const confluenceLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: 'confluence',
        type: "logo",
        appearance: "brand"
    });
    const trelloLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: 'trello',
        type: "logo",
        appearance: "brand"
    });
    const loomLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: 'loom',
        type: "logo",
        appearance: "brand"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $bQjAr.default), {
        name: 'collaborateCards',
        className: (0, $2jatx.default)([
            "_ca0qzwfg _u5f3idpf _n3tdzwfg _19bvidpf _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5Dppx.TryPageHeader), {
                    headerText: collaborateTitle,
                    dividerColor: (0, $kbpa7.wacToken)('color.primary.blue')
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1rGpC.Row), {
                layout: "6-6",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
                        logo: confluenceLogo,
                        link: (0, $jQ0cd.useLocalizedHref)('/software/confluence/free'),
                        bodyText: confluenceBody,
                        ctaText: tryCloud
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
                        logo: trelloLogo,
                        link: 'https://www.trello.com/signup',
                        bodyText: trelloBody,
                        ctaText: tryCloud
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {}),
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1rGpC.Row), {
                layout: "6-6",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
                        logo: loomLogo,
                        link: (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=loom&edition=premium'),
                        bodyText: loomBody,
                        ctaText: tryCloud
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {})
                ]
            })
        ]
    });
};
var $820dda0b0a60c7c4$export$2e2bcd8739ae039 = $820dda0b0a60c7c4$var$CollaborateSection;

});

parcelRegister("fPSzg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $da7b5b800f10f760$export$2e2bcd8739ae039; });
/* enterprise-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $2ivuE = parcelRequire("2ivuE");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $1rGpC = parcelRequire("1rGpC");

var $lVutU = parcelRequire("lVutU");
const $da7b5b800f10f760$var$sectionCss = null;
const $da7b5b800f10f760$var$headerStyle = null;
const $da7b5b800f10f760$var$lowerCss = null;
const $da7b5b800f10f760$var$imageCss = null;
const $da7b5b800f10f760$var$EnterpriseSection = ()=>{
    const intl = (0, $8e22h.default)();
    const goBigHeader = intl.formatMessage({
        id: 'try.enterprise.goBig',
        defaultMessage: 'Go big with Atlassian Enterprise'
    });
    const goBigBody = intl.formatMessage({
        id: 'try.enterprise.goBigBody',
        defaultMessage: 'Connect, accelerate, and scale your entire enterprise with Atlassian enterprise solutions.'
    });
    const learnMore = intl.formatMessage({
        id: 'try.enterprise.learnMore',
        defaultMessage: 'Learn more'
    });
    const cloud = intl.formatMessage({
        id: 'try.enterprise.cloud',
        defaultMessage: 'Cloud'
    });
    const cloudBody = intl.formatMessage({
        id: 'try.enterprise.cloudBody',
        defaultMessage: 'Atlassian cloud solutions are equipped with everything large and growing teams need to scale collaboration and workflows seamlessly.'
    });
    const dataCenter = intl.formatMessage({
        id: 'try.enterprise.dataCenter',
        defaultMessage: 'Data Center'
    });
    const dataCenterBody = intl.formatMessage({
        id: 'try.enterprise.dataCenterBody',
        defaultMessage: 'Host our applications with IaaS vendors like AWS or Azure. Data Center is our self-managed solution for advanced administration at scale.'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_syaz1afi _bfhkftjs _ca0q12bs _u5f3idpf _n3td12bs _19bvidpf _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_l5k1bfng _11ebahaf _2fhk4jg8 _bpspbfng _1r2tidpf _1h3oud5o _hrxpidpf _oqlkud5o _3fwinqt0"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ivuE.ContentBlock), {
                        headerText: goBigHeader,
                        headerType: 'h2',
                        isCentered: true,
                        bodyText: goBigBody,
                        ctaProps: {
                            buttonProps: {
                                className: 'ctaButton',
                                text: learnMore,
                                url: 'https://www.atlassian.com/enterprise',
                                type: 'primary',
                                color: 'lightblue',
                                size: 'small'
                            }
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1r2tidpf _1h3oud5o _hrxpidpf _oqlkud5o _3fwinqt0 _x3mzbfng _k48p4jg8 _1o6v1j6v _ggmh1k8s _r8nt4jg8 _1adi12sy _19tboxwj _43dsftjs _bna711ux"
                ]),
                style: {
                    "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1rGpC.Row), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
                            title: cloud,
                            link: (0, $jQ0cd.useLocalizedHref)('/enterprise/cloud'),
                            bodyText: cloudBody,
                            ctaText: learnMore,
                            buttonColor: 'lightblue',
                            buttonType: 'primary'
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
                            title: dataCenter,
                            link: (0, $jQ0cd.useLocalizedHref)('/enterprise/data-center'),
                            bodyText: dataCenterBody,
                            ctaText: learnMore,
                            buttonColor: 'lightblue',
                            buttonType: 'primary'
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf _1bah1h6o _4cvr1h6o _1e0c1txw"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                image: {
                                    src: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/database-server-on-v3.webp',
                                    alt: intl.formatMessage({
                                        id: 'try.enterprise.databaseServer',
                                        defaultMessage: 'Data center + server'
                                    })
                                }
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $da7b5b800f10f760$export$2e2bcd8739ae039 = $da7b5b800f10f760$var$EnterpriseSection;

});

parcelRegister("gTqUW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6eb266b4632978e1$export$2e2bcd8739ae039; });
/* get-the-most-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $NtjLk = parcelRequire("NtjLk");

var $kbpa7 = parcelRequire("kbpa7");

var $1rGpC = parcelRequire("1rGpC");
const $6eb266b4632978e1$var$pageSection = null;
const $6eb266b4632978e1$var$sectionCss = null;
const $6eb266b4632978e1$var$headerStyle = null;
const $6eb266b4632978e1$var$cardContainer = null;
const $6eb266b4632978e1$var$GetTheMostSection = ()=>{
    const intl = (0, $8e22h.default)();
    const cardData = [
        {
            title: intl.formatMessage({
                id: 'TryPageTemplate.getTheMost.marketplaceHeaderText',
                defaultMessage: "Tailor to your team\u2019s needs"
            }),
            titleAs: 'h3',
            body: intl.formatMessage({
                id: 'TryPageTemplate.getTheMost.marketplaceBodyText',
                defaultMessage: 'Extend your Atlassian products with thousands of apps from Marketplace.'
            }),
            callToAction: {
                href: 'https://marketplace.atlassian.com/',
                text: intl.formatMessage({
                    id: 'TryPageTemplate.getTheMost.marketplacePrimaryLink',
                    defaultMessage: 'Go to Marketplace'
                })
            },
            orientation: 'horizontal',
            spotIllustration: {
                src: 'https://wac-cdn.atlassian.com/dam/jcr:76e94ebd-d71e-4991-9008-7b2e838090c8/illustrations-spot-Integrations.svg?cdnVersion=2999'
            }
        },
        {
            title: intl.formatMessage({
                id: 'TryPageTemplate.getTheMost.universityHeaderText',
                defaultMessage: 'Train with Atlassian University'
            }),
            titleAs: 'h3',
            body: intl.formatMessage({
                id: 'TryPageTemplate.getTheMost.universityBodyText',
                defaultMessage: "Develop new skills, improve your team\u2019s work, and advance your professional career."
            }),
            callToAction: {
                href: 'https://www.atlassian.com/university',
                text: intl.formatMessage({
                    id: 'TryPageTemplate.getTheMost.universityPrimaryLink',
                    defaultMessage: 'Go to Atlassian University'
                })
            },
            orientation: 'horizontal',
            spotIllustration: {
                src: 'https://wac-cdn.atlassian.com/dam/jcr:a88ae3d8-e6fd-4428-8a14-c9ce6b460b0e/illustrations-spot-Atlassian%20Book_1.svg?cdnVersion=2999'
            }
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_1q51xy5q _85i5xncg _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_12l21wug _ahbq1wug _1ul91osq _11rm1hrf _bfhk1afi _kqswh2mm"
            ]),
            style: {
                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_y3gn1h6o _cg41culw _l5k1bfng _1pxq7vkz _ygm1idpf _u6q57vkz _sydsidpf _17z411ph _xztqidpf _ubikidpf _j8iydlk8 _h9g4idpf _1kll1ejb _1g9widpf _1kovidpf _bsriidpf _1qsfidpf _1x1pahaf _12adidpf _1xe1idpf _hcanidpf _nji3idpf _j269ahaf"
                        ]),
                        style: {
                            "--_1hcckvk": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue900'))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "TryPageTemplate.getTheMost.header",
                                defaultMessage: "Get the most out of your products"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                    layout: "6-6",
                    children: cardData.map((card, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1ui68ved"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $NtjLk.Card), {
                                ...card
                            })
                        }, index))
                })
            ]
        })
    });
};
var $6eb266b4632978e1$export$2e2bcd8739ae039 = $6eb266b4632978e1$var$GetTheMostSection;

});

parcelRegister("aUlfh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ca30ac8f347471af$export$2e2bcd8739ae039; });
/* hero-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $3DHNM = parcelRequire("3DHNM");
const $ca30ac8f347471af$var$HeroTryGraphCard = ()=>{
    const intl = (0, $8e22h.default)();
    const headerText = intl.formatMessage({
        id: 'TryPageTemplate.hero.graphCard.bodyText',
        defaultMessage: 'Collaborate seamlessly across cross-functional teams, at scale'
    });
    const imgLink = 'https://wac-cdn.atlassian.com/dam/jcr:6f126124-1d52-4017-9078-40df4c78897e/illustrations-spot-Connections.svg?cdnVersion=1408';
    const imgAltText = intl.formatMessage({
        id: 'TryPageTemplate.hero.graphCard.imgAltText',
        defaultMessage: 'Connections illustration'
    });
    return {
        headerText: '',
        bodyText: headerText,
        imageAltText: imgAltText,
        imageLink: imgLink
    };
};
const $ca30ac8f347471af$var$HeroTryLockCard = ()=>{
    const intl = (0, $8e22h.default)();
    const headerText = intl.formatMessage({
        id: 'TryPageTemplate.hero.lockCard.bodyText',
        defaultMessage: 'Built with industry-leading privacy, security, and data control'
    });
    const imgLink = 'https://wac-cdn.atlassian.com/dam/jcr:c0c94526-036b-44df-9f0d-cd1e9455d1e2/illustrations-spot-Trust%20and%20Security.svg?cdnVersion=1408';
    const imgAltText = intl.formatMessage({
        id: 'TryPageTemplate.hero.lockCard.imgAltText',
        defaultMessage: 'Trust and security illustration'
    });
    return {
        headerText: '',
        bodyText: headerText,
        imageAltText: imgAltText,
        imageLink: imgLink
    };
};
const $ca30ac8f347471af$var$HeroTryPuzzleCard = ()=>{
    const intl = (0, $8e22h.default)();
    const headerText = intl.formatMessage({
        id: 'TryPageTemplate.hero.puzzleCard.bodyText',
        defaultMessage: 'Customize your products with 1,000+ apps and integrations'
    });
    const imgLink = 'https://wac-cdn.atlassian.com/dam/jcr:3dfc6901-1535-48aa-a25a-870ee1d5ff8e/illustrations-spot-Integration%20Puzzle.svg?cdnVersion=1408';
    const imgAltText = intl.formatMessage({
        id: 'TryPageTemplate.hero.puzzleCard.imgAltText',
        defaultMessage: 'Integration puzzle illustration'
    });
    return {
        headerText: '',
        bodyText: headerText,
        imageAltText: imgAltText,
        imageLink: imgLink
    };
};
const $ca30ac8f347471af$var$sectionCssOverride = null;
const $ca30ac8f347471af$var$outerContainerCssOverride = null;
const $ca30ac8f347471af$var$HeroSection = ()=>{
    const intl = (0, $8e22h.default)();
    const headerText = intl.formatMessage({
        id: 'TryPageTemplate.hero.header',
        defaultMessage: 'Try Atlassian apps for free'
    });
    const bodyText = intl.formatMessage({
        id: 'TryPageTemplate.hero.bodyText',
        defaultMessage: 'Our cloud products empower teams of all types, from startup to enterprise.'
    });
    const backgroundProps = {
        bgColor: (0, $kbpa7.wacToken)('color.neutral.light100')
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_cg41culw _18oz1wto _1ap71k7u _u8fj1tcg _163midpf _yzu7idpf _1kll14b4 _1qdgidpf _7toc10nf _cjxodlk8 _a5ip1n2x _1f35m24h _ps1ee8xo _z0gn1h6o _p1061k92 _zqtwnl7k _130319ii _10vfidpf _1of01qc2 _1xw61h67 _sz6216xe _3int1gpt _dmb7grf3"
        ]),
        style: {
            "--_1hcckvk": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue900')),
            "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_16qs130s _kqswh2mm"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3DHNM.ContentBlocksInline), {
                headerText: headerText,
                bodyText: bodyText,
                backgroundProperties: backgroundProps,
                inlineContentBlocks: [
                    $ca30ac8f347471af$var$HeroTryGraphCard(),
                    $ca30ac8f347471af$var$HeroTryLockCard(),
                    $ca30ac8f347471af$var$HeroTryPuzzleCard()
                ]
            })
        })
    });
};
var $ca30ac8f347471af$export$2e2bcd8739ae039 = $ca30ac8f347471af$var$HeroSection;

});
parcelRegister("3DHNM", function(module, exports) {
$parcel$export(module.exports, "ContentBlocksInline", function () { return $4d30ed72f33d6229$export$4fd59a663df2d810; });
/* content-blocks-inline.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $2ivuE = parcelRequire("2ivuE");

var $iPPTB = parcelRequire("iPPTB");

var $1rGpC = parcelRequire("1rGpC");

var $b4FXR = parcelRequire("b4FXR");
const $4d30ed72f33d6229$var$getCardAspectRatio = (length)=>{
    switch(length){
        case 4:
            return '4/3';
        case 3:
            return '4/3';
        case 2:
            return '2/1';
        default:
            return '1/1';
    }
};
const $4d30ed72f33d6229$var$ctaStyle = null;
const $4d30ed72f33d6229$export$4fd59a663df2d810 = ({ headerText: headerText, bodyText: bodyText, backgroundProperties: backgroundProperties, className: className, eyebrowText: eyebrowText, iconName: iconName, linkPosition: linkPosition = 'bottom', ctaProps: ctaProps, inlineContentBlocks: inlineContentBlocks })=>{
    if (inlineContentBlocks.length < 2 || inlineContentBlocks.length > 4) throw new Error('Pattern is meant to display between 2 and 4 cards');
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $b4FXR.StyledBackground), {
        ...backgroundProperties,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1akovbgk _c7s7idpf _4puvvbgk _1r3vidpf _i6jxckbl _1lh7idpf _z3ncckbl _wpaiidpf _1kmxzwfg _1ggmidpf _1ykzzwfg _1maeidpf",
                className
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ivuE.ContentBlock), {
                        headerText: headerText,
                        headerType: "h2",
                        eyebrowText: eyebrowText,
                        iconName: iconName,
                        bodyText: bodyText,
                        isCentered: true,
                        ctaProps: linkPosition === 'top' && ctaProps?.primaryLinkProps ? ctaProps : {}
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                    children: inlineContentBlocks.map((block, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ivuE.ContentBlock), {
                            aspectRatio: $4d30ed72f33d6229$var$getCardAspectRatio(inlineContentBlocks.length),
                            ...block
                        }, index))
                }),
                linkPosition === 'bottom' && ctaProps?.primaryLinkProps ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        style: {
                            textAlign: 'center'
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                            ...ctaProps.primaryLinkProps
                        })
                    })
                }) : null
            ]
        })
    });
};

});


parcelRegister("eLUM2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $eaa008ad72030cec$export$2e2bcd8739ae039; });
/* identity-and-security-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kbpa7 = parcelRequire("kbpa7");

var $1rGpC = parcelRequire("1rGpC");

var $2Df35 = parcelRequire("2Df35");

var $5Dppx = parcelRequire("5Dppx");

var $lVutU = parcelRequire("lVutU");

var $8p9Sp = parcelRequire("8p9Sp");
const $eaa008ad72030cec$var$sectionStyles = null;
const $eaa008ad72030cec$var$IdentityAndSecuritySection = ()=>{
    const intl = (0, $8e22h.default)();
    const atlassianAccessHeaderText = intl.formatMessage({
        id: 'TryPageTemplate.IdentityAndSecurity.title',
        defaultMessage: 'Identity & Security'
    });
    const headerProps = {
        headerText: atlassianAccessHeaderText,
        dividerColor: (0, $kbpa7.wacToken)('color.primary.blue')
    };
    const atlassianAccessLink = 'https://admin.atlassian.com/';
    const atlassianAccessBodyText = intl.formatMessage({
        id: 'TryPageTemplate.identityAndSecurity.atlassianAccessBody',
        defaultMessage: 'Gain company-wide visibility, security policies, and control across your Atlassian cloud infrastructure.'
    });
    const tryCloud = intl.formatMessage((0, $8p9Sp.messages).tryCloud);
    const guardLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: 'guard',
        type: "logo",
        appearance: "brand"
    });
    const cardProps = {
        logo: guardLogo,
        link: atlassianAccessLink,
        bodyText: atlassianAccessBodyText,
        ctaText: tryCloud
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_ca0qzwfg _u5f3idpf _n3tdzwfg _19bvidpf _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $bQjAr.default), {
            name: 'identityAndSecurity',
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5Dppx.TryPageHeader), {
                        ...headerProps
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1rGpC.Row), {
                    layout: "6-6",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
                            ...cardProps
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {})
                    ]
                })
            ]
        })
    });
};
var $eaa008ad72030cec$export$2e2bcd8739ae039 = $eaa008ad72030cec$var$IdentityAndSecuritySection;

});

parcelRegister("liucL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $79af9bea120adf60$export$2e2bcd8739ae039; });
/* plan-and-track.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $1rGpC = parcelRequire("1rGpC");

var $2Df35 = parcelRequire("2Df35");

var $lVutU = parcelRequire("lVutU");

var $5Dppx = parcelRequire("5Dppx");

var $8p9Sp = parcelRequire("8p9Sp");
const $79af9bea120adf60$var$sectionStyles = null;
const $79af9bea120adf60$var$PlanAndTrackSection = ()=>{
    const intl = (0, $8e22h.default)();
    const jiraSofttwareHeaderText = intl.formatMessage({
        id: 'TryPageTemplate.PlanAndTrack.title',
        defaultMessage: 'Plan & Track'
    });
    const headerProps = {
        headerText: jiraSofttwareHeaderText,
        dividerColor: (0, $kbpa7.wacToken)('color.primary.blue')
    };
    const jiraSofttwareBodyText = intl.formatMessage({
        id: 'TryPageTemplate.PlanAndTrack.jiraBody',
        defaultMessage: 'Friendly and intuitive collaboration for business teams and their projects, built for cross-team coordination and breaking down silos.'
    });
    const jiraSofttwareLink = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=jira-software&edition=free');
    const jirProductDiscoveryBodyText = intl.formatMessage({
        id: 'TryPageTemplate.PlanAndTrack.jirProductDiscoveryBody',
        defaultMessage: 'Organize and prioritize ideas, share product roadmaps, and connect business and tech teams, all in Jira.'
    });
    const jirProductDiscoveryLink = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=jira-product-discovery');
    const tryCloud = intl.formatMessage((0, $8p9Sp.messages).tryCloud);
    const jiraLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: 'jira',
        type: "logo",
        appearance: "brand"
    });
    const jpdLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: 'jiraproductdiscovery',
        type: "logo",
        appearance: "brand"
    });
    const jiracardProps = {
        logo: jiraLogo,
        link: jiraSofttwareLink,
        bodyText: jiraSofttwareBodyText,
        ctaText: tryCloud
    };
    const jpdcardProps = {
        logo: jpdLogo,
        link: jirProductDiscoveryLink,
        bodyText: jirProductDiscoveryBodyText,
        ctaText: tryCloud
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ca0qvbgk _u5f3idpf _n3tdzwfg _19bvidpf _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5Dppx.TryPageHeader), {
                    ...headerProps
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1rGpC.Row), {
                layout: "6-6",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
                        ...jiracardProps
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
                        ...jpdcardProps
                    })
                ]
            })
        ]
    });
};
var $79af9bea120adf60$export$2e2bcd8739ae039 = $79af9bea120adf60$var$PlanAndTrackSection;

});

parcelRegister("cBRR6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8d8fc6b8f8fde7c6$export$2e2bcd8739ae039; });
/* support-and-fix-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $jQ0cd = parcelRequire("jQ0cd");

var $1rGpC = parcelRequire("1rGpC");

var $2Df35 = parcelRequire("2Df35");

var $lVutU = parcelRequire("lVutU");

var $5Dppx = parcelRequire("5Dppx");

var $8p9Sp = parcelRequire("8p9Sp");
/* Cards */ const $8d8fc6b8f8fde7c6$var$JsmCard = ()=>{
    const intl = (0, $8e22h.default)();
    const localizedLink = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=jira-service-management');
    const localizedBodyText = intl.formatMessage({
        id: 'TryPageTemplate.supportAndFix.jsmCard.bodyText',
        defaultMessage: 'Collaborate at high-velocity, respond to business changes and deliver great customer and employee service experiences fast.'
    });
    const localizedCtaText = intl.formatMessage((0, $8p9Sp.messages).tryCloud);
    const jsmLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: 'jiraservicemanagement',
        type: "logo",
        appearance: "brand"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
        logo: jsmLogo,
        link: localizedLink,
        bodyText: localizedBodyText,
        ctaText: localizedCtaText
    });
};
const $8d8fc6b8f8fde7c6$var$StatusCard = ()=>{
    const intl = (0, $8e22h.default)();
    const localizedLink = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=statuspage');
    const localizedBodyText = intl.formatMessage({
        id: 'TryPageTemplate.supportAndFix.statusCard.bodyText',
        defaultMessage: 'Incidents happen. Keep your users informed with fewer support emails during downtime.'
    });
    const localizedCtaText = intl.formatMessage({
        id: 'TryPageTemplate.tryCloud',
        defaultMessage: 'Try cloud'
    });
    const statusPageLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: 'statuspage',
        type: "logo",
        appearance: "brand"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
        logo: statusPageLogo,
        link: localizedLink,
        bodyText: localizedBodyText,
        ctaText: localizedCtaText
    });
};
const $8d8fc6b8f8fde7c6$var$sectionStyles = null;
const $8d8fc6b8f8fde7c6$var$SupportAndFixSection = ()=>{
    const intl = (0, $8e22h.default)();
    const headerText = intl.formatMessage({
        id: 'TryPageTemplate.supportAndFix.headerText',
        defaultMessage: 'Support & fix'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: 'support-and-fix',
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_ca0qzwfg _u5f3idpf _n3tdzwfg _19bvidpf _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5Dppx.TryPageHeader), {
                        dividerColor: "#ff8b00",
                        headerText: headerText
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1rGpC.Row), {
                    layout: "6-6",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)($8d8fc6b8f8fde7c6$var$JsmCard, {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($8d8fc6b8f8fde7c6$var$StatusCard, {})
                    ]
                })
            ]
        })
    });
};
var $8d8fc6b8f8fde7c6$export$2e2bcd8739ae039 = $8d8fc6b8f8fde7c6$var$SupportAndFixSection;

});



parcelRegister("czsFN", function(module, exports) {
$parcel$export(module.exports, "UniformConfluencePricingEntryPage", function () { return $2b8dedcd909fa0cd$export$46490ce46aa9f785; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $4X0dO = parcelRequire("4X0dO");

var $hZuN8 = parcelRequire("hZuN8");

var $67UrT = parcelRequire("67UrT");
const $2b8dedcd909fa0cd$export$46490ce46aa9f785 = (props)=>{
    const [hasFired, fireExposure] = (0, $hZuN8.useExperimentExposure)((0, $4X0dO.experiments).confluencePricingPageWaeMigration);
    (0, $1oC0p.useEffect)(()=>{
        if (!hasFired) fireExposure();
    }, [
        hasFired,
        fireExposure
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $67UrT.UniformEntryPage), {
        ...props
    });
};

});

parcelRegister("iWEGU", function(module, exports) {
$parcel$export(module.exports, "UniformJiraPricingEntryPage", function () { return $f9cdabca1169389b$export$bf65523dba15d046; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $4X0dO = parcelRequire("4X0dO");

var $hZuN8 = parcelRequire("hZuN8");

var $67UrT = parcelRequire("67UrT");
const $f9cdabca1169389b$export$bf65523dba15d046 = (props)=>{
    const [hasFired, fireExposure] = (0, $hZuN8.useExperimentExposure)((0, $4X0dO.experiments).jiraPricingWaeMigrationExperimentRerunExp);
    (0, $1oC0p.useEffect)(()=>{
        if (!hasFired) fireExposure();
    }, [
        hasFired,
        fireExposure
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $67UrT.UniformEntryPage), {
        ...props
    });
};

});

parcelRegister("2aZDx", function(module, exports) {
$parcel$export(module.exports, "UniformPreviewPage", function () { return $81d123cf08d1936b$export$485017e8654f464d; });

var $7VQPk = parcelRequire("7VQPk");

var $1kAyD = parcelRequire("1kAyD");
const $81d123cf08d1936b$export$485017e8654f464d = ({ composition: composition, isUniformPlayground: isUniformPlayground, isAllowPostMessage: isAllowPostMessage })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $1kAyD.UniformPreviewPageTemplate), {
        composition: composition,
        isUniformPlayground: isUniformPlayground,
        isAllowPostMessage: isAllowPostMessage
    });

});
parcelRegister("1kAyD", function(module, exports) {
$parcel$export(module.exports, "UniformPreviewPageTemplate", function () { return $82214492219a5f40$export$4236df4850175643; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $dNSrU = parcelRequire("dNSrU");

var $4EfnG = parcelRequire("4EfnG");

var $7WM7y = parcelRequire("7WM7y");

var $g7CEg = parcelRequire("g7CEg");

var $9rnwe = parcelRequire("9rnwe");
const $82214492219a5f40$export$4236df4850175643 = ({ composition: composition, isUniformPlayground: isUniformPlayground, isAllowPostMessage: isAllowPostMessage })=>{
    const { uniformContext: uniformContext } = (0, $9rnwe.useWAEContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4EfnG.default), {
        fallback: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7WM7y.FourOhFourPageTemplate), {}),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dNSrU.UniformContext), {
            context: uniformContext,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g7CEg.UniformWrapper), {
                composition: composition,
                isUniformPlayground: isUniformPlayground,
                isAllowPostMessage: isAllowPostMessage
            })
        })
    });
};

});


parcelRegister("3t7DW", function(module, exports) {
$parcel$export(module.exports, "init", function () { return $be9c067c7be4fda0$export$2cd8252107eb640b; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $yhhhl = parcelRequire("yhhhl");

var $konOj = parcelRequire("konOj");

var $f3gS9 = parcelRequire("f3gS9");

var $fuLgT = parcelRequire("fuLgT");

var $eQyIx = parcelRequire("eQyIx");

var $g0QpW = parcelRequire("g0QpW");

var $6mvtm = parcelRequire("6mvtm");

var $eRzlV = parcelRequire("eRzlV");

var $6r14Z = parcelRequire("6r14Z");

var $hgaI1 = parcelRequire("hgaI1");

var $7mHQv = parcelRequire("7mHQv");

var $i2Oi2 = parcelRequire("i2Oi2");

var $hZy36 = parcelRequire("hZy36");

var $3H7QB = parcelRequire("3H7QB");

var $hp3ar = parcelRequire("hp3ar");

var $gLm0b = parcelRequire("gLm0b");

var $6gQvZ = parcelRequire("6gQvZ");

var $idVA4 = parcelRequire("idVA4");

var $hu7gH = parcelRequire("hu7gH");
window.BUILD_KEY = "p-a3cec09a4f";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $fuLgT.default)()
    }
};
(0, $hZy36.configureCastle)();
const $be9c067c7be4fda0$var$SUPPORTED_LOCALES = [
    {
        hrefLang: 'ja',
        langRoute: 'ja'
    },
    {
        hrefLang: 'fr',
        langRoute: 'fr'
    },
    {
        hrefLang: 'de',
        langRoute: 'de'
    },
    {
        hrefLang: 'es',
        langRoute: 'es'
    },
    {
        hrefLang: 'pt-BR',
        langRoute: 'br'
    },
    {
        hrefLang: 'zh-Hans',
        langRoute: 'zh'
    },
    {
        hrefLang: 'ko',
        langRoute: 'ko'
    },
    {
        hrefLang: 'ru',
        langRoute: 'ru'
    },
    {
        hrefLang: 'pl',
        langRoute: 'pl'
    },
    {
        hrefLang: 'it',
        langRoute: 'it'
    },
    {
        hrefLang: 'nl',
        langRoute: 'nl'
    }
];
const $be9c067c7be4fda0$export$2cd8252107eb640b = (Component, query, queryVars, relayApi)=>{
    const analyticsWebClient = (0, $g0QpW.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $hu7gH.parseRoute)(window.location);
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== 'undefined') locationData = {
        countryIsoCode: window.countryCode || '',
        regionIsoCode: window.regionIsoCode || ''
    };
    const isPerfOnetrustEnabled = (0, $gLm0b.isPerformanceOnetrustEnabled)(typeof window !== 'undefined' ? window.optanonConsentCookie : (0, $gLm0b.extractOptanonConsentCookie)(document.cookie), locationData);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    isPerfOnetrustEnabled && (0, $eQyIx.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $yhhhl.parse)(document.cookie) : {};
    const userAgent = typeof window !== 'undefined' ? window.navigator.userAgent : '';
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $idVA4.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    if ((0, $hp3ar.isEdgeCachingPath)(window.location)) {
        // Override for Edge Caching
        (0, $hp3ar.overrideAjsAnonIdFromCookie)();
        (0, $hp3ar.overrideCustomAttributes)();
    }
    (0, $hgaI1.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(async ()=>{
        try {
            await (0, $3H7QB.DynamicConfigClient).getInstance().initialize({
                bootstrapValues: window.featureGateBootstrapValues
            });
        } catch (error) {
            console.error('Failed to initialize DynamicConfigClient', error);
        }
        const isStatic = typeof window !== 'undefined' && window.IS_STATIC;
        const snapshot = window.relayStoreSnapshot;
        let relayBaseUrl = undefined;
        let relayAuthKey = undefined;
        if (relayApi === (0, $6mvtm.RELAY_API_CONTENTFUL)) {
            relayBaseUrl = (0, $eRzlV.CONTENTFUL_GRAPHQL_API_URL);
            relayAuthKey = window.CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES;
        }
        const relayEnvironment = (0, $i2Oi2.initRelayEnvironment)(snapshot, relayBaseUrl, relayAuthKey);
        const queryRef = (0, $f3gS9.loadQuery)(relayEnvironment, query, queryVars);
        const canonicalBaseUrl = (0, $6r14Z.getCanonicalBaseUrl)(window.location.hostname, path);
        const pathForCanonical = path ? (0, $6r14Z.canonicalPathForHref)(canonicalBaseUrl, path) : undefined;
        const route = pathForCanonical === undefined ? '' : pathForCanonical === '' ? '' : `/${pathForCanonical}`;
        const page = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6gQvZ.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $f3gS9.RelayEnvironmentProvider), {
                environment: relayEnvironment,
                children: [
                    isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                        rel: "canonical",
                        href: `${canonicalBaseUrl}${route}`
                    }),
                    isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                        rel: "alternate",
                        href: `${canonicalBaseUrl}${route}`,
                        hrefLang: "x-default"
                    }),
                    isStatic && $be9c067c7be4fda0$var$SUPPORTED_LOCALES.map(({ hrefLang: hrefLang, langRoute: langRoute })=>/*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                            rel: "alternate",
                            href: `${canonicalBaseUrl}/${langRoute}${route}`,
                            hrefLang: hrefLang
                        }, hrefLang)),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7mHQv.PageWrapper), {
                        analyticsWebClient: analyticsWebClient,
                        location: window.location,
                        pricing: window.prices,
                        availableProducts: window.availableProducts,
                        userProfile: window.userProfile,
                        userProfileStatus: window.userProfileStatus,
                        userContext: window.userContext,
                        userContextStatus: window.userContextStatus,
                        hasCloudSessionTokenCookie: window.hasCloudSessionTokenCookie,
                        loggedOutContext: window.loggedOutContext,
                        loggedOutContextStatus: window.loggedOutContextStatus,
                        loggedInContext: window.loggedInContext,
                        loggedInContextStatus: window.loggedInContextStatus,
                        countryCode: window.countryCode,
                        mlTemplateIds: window.mlTemplateIds,
                        keyword: window.keyword,
                        anchor: window.anchor,
                        subAnchor: window.subAnchor,
                        queryRef: queryRef,
                        PageComponent: Component,
                        transactionAccounts: window.transactionAccounts,
                        userAgent: userAgent
                    })
                ]
            })
        });
        if (isStatic) {
            // @ts-expect-error type
            const root = (0, $konOj.createRoot)(document.getElementById('wac'));
            root.render(page);
        } else (0, $konOj.hydrateRoot)(// @ts-expect-error type
        document.getElementById('wac-root'), page, {
            onRecoverableError: (error, errorInfo)=>{
                document.getElementById('wac-root')?.setAttribute('hydration-error', 'true');
            }
        });
    });
};

});
parcelRegister("i2Oi2", function(module, exports) {
$parcel$export(module.exports, "initRelayEnvironment", function () { return $36b5b9e576032b2f$export$1456be3de97c862f; });

var $gRpMo = parcelRequire("gRpMo");
(0, $gRpMo.RelayFeatureFlags).ENABLE_LOAD_QUERY_REQUEST_DEDUPING = true;
// TODO: Lift this into environment
const $36b5b9e576032b2f$var$GATEWAY_URL = 'https://www.atlassian.com/gateway/api/graphql';
function $36b5b9e576032b2f$var$createRelayEnvironment(initialRecords, baseUrlOverride, authToken) {
    const baseUrl = baseUrlOverride ?? $36b5b9e576032b2f$var$GATEWAY_URL;
    let headers = {
        'Content-Type': 'application/json'
    };
    if (authToken) headers = Object.assign({}, headers, {
        Authorization: `Bearer ${authToken}`
    });
    const fetchResponse = (params, variables)=>{
        const startTime = Date.now();
        const response = fetch(baseUrl, {
            method: 'POST',
            headers: headers,
            // Contentful uses an authToken, and Access-Control-Allow-Origin = "*",
            // therefore we cannot include credentials for Contentful queries
            credentials: authToken ? 'same-origin' : 'include',
            body: JSON.stringify({
                query: params.text,
                variables: variables
            })
        });
        return (0, $gRpMo.Observable).from(response.then(async (res)=>{
            const duration = Date.now() - startTime;
            // @ts-ignore
            if (!globalThis.IS_STATIC) try {
                // @ts-ignore
                globalThis.metrics.histogram(`contentful.duration`, '10_100_500_1000_2000_3000_5000_10000_30000', duration, {
                    gqlOperationName: params.name,
                    cacheStatus: res.headers.get('x-cache'),
                    status: res.status
                });
            } catch (e) {
                console.error(`Failed to track ${params.name} call`, e);
            }
            return res.json();
        }));
    };
    const network = (0, $gRpMo.Network).create(fetchResponse);
    const store = new (0, $gRpMo.Store)(new (0, $gRpMo.RecordSource)(initialRecords));
    return new (0, $gRpMo.Environment)({
        network: network,
        store: store
    });
}
let $36b5b9e576032b2f$var$clientSideRelayEnvironment;
function $36b5b9e576032b2f$export$1456be3de97c862f(initialRecords, baseUrlOverride, authToken) {
    const environment = $36b5b9e576032b2f$var$clientSideRelayEnvironment ?? $36b5b9e576032b2f$var$createRelayEnvironment(initialRecords, baseUrlOverride, authToken);
    if (typeof window === 'undefined') return environment;
    if (!$36b5b9e576032b2f$var$clientSideRelayEnvironment) $36b5b9e576032b2f$var$clientSideRelayEnvironment = environment;
    else if (initialRecords) environment.getStore().publish(new (0, $gRpMo.RecordSource)(initialRecords));
    return $36b5b9e576032b2f$var$clientSideRelayEnvironment;
}

});


parcelRegister("3NQOU", function(module, exports) {
$parcel$export(module.exports, "init", function () { return $b6785f1d81c92020$export$2cd8252107eb640b; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $yhhhl = parcelRequire("yhhhl");

var $konOj = parcelRequire("konOj");

var $fuLgT = parcelRequire("fuLgT");

var $eQyIx = parcelRequire("eQyIx");

var $g0QpW = parcelRequire("g0QpW");

var $gLm0b = parcelRequire("gLm0b");

var $6r14Z = parcelRequire("6r14Z");

var $hgaI1 = parcelRequire("hgaI1");

var $7mHQv = parcelRequire("7mHQv");

var $hZy36 = parcelRequire("hZy36");

var $3H7QB = parcelRequire("3H7QB");

var $hp3ar = parcelRequire("hp3ar");

var $6gQvZ = parcelRequire("6gQvZ");

var $idVA4 = parcelRequire("idVA4");

var $hu7gH = parcelRequire("hu7gH");
window.BUILD_KEY = "p-a3cec09a4f";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $fuLgT.default)()
    }
};
(0, $hZy36.configureCastle)();
const $b6785f1d81c92020$var$SUPPORTED_LOCALES = [
    {
        hrefLang: 'ja',
        langRoute: 'ja'
    },
    {
        hrefLang: 'fr',
        langRoute: 'fr'
    },
    {
        hrefLang: 'de',
        langRoute: 'de'
    },
    {
        hrefLang: 'es',
        langRoute: 'es'
    },
    {
        hrefLang: 'pt-BR',
        langRoute: 'br'
    },
    {
        hrefLang: 'zh-Hans',
        langRoute: 'zh'
    },
    {
        hrefLang: 'ko',
        langRoute: 'ko'
    },
    {
        hrefLang: 'ru',
        langRoute: 'ru'
    },
    {
        hrefLang: 'pl',
        langRoute: 'pl'
    },
    {
        hrefLang: 'it',
        langRoute: 'it'
    },
    {
        hrefLang: 'nl',
        langRoute: 'nl'
    }
];
const $b6785f1d81c92020$export$2cd8252107eb640b = (Component)=>{
    const isStatic = typeof window !== 'undefined' && window.IS_STATIC;
    const analyticsWebClient = (0, $g0QpW.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $hu7gH.parseRoute)(window.location);
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== 'undefined') locationData = {
        countryIsoCode: window.countryCode || '',
        regionIsoCode: window.regionIsoCode || ''
    };
    // In Uniform Playground (preview authoring environment), skip OneTrust check
    // and assume performance tracking is enabled — mirrors OneTrustProvider behavior.
    // Cookies are unavailable in the cross-origin iframe context, so the normal
    // cookie-based check always returns false for CPRA users (e.g. California).
    const isPerfOnetrustEnabled = window.isUniformPlayground || (0, $gLm0b.isPerformanceOnetrustEnabled)(typeof window !== 'undefined' ? window.optanonConsentCookie : (0, $gLm0b.extractOptanonConsentCookie)(document.cookie), locationData);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    isPerfOnetrustEnabled && (0, $eQyIx.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $yhhhl.parse)(document.cookie) : {};
    const userAgent = typeof window !== 'undefined' ? window.navigator.userAgent : '';
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $idVA4.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    // Below is for debugging edge - will be removed
    window.ssrAnonId = window.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
    // We can't feature gate below code as this is done before initialization so just overriding for the path we are testing
    if ((0, $hp3ar.isEdgeCachingPath)(window.location)) {
        // Override for Edge Caching
        (0, $hp3ar.overrideAjsAnonIdFromCookie)();
        (0, $hp3ar.overrideCustomAttributes)();
    }
    (0, $hgaI1.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(async ()=>{
        try {
            await (0, $3H7QB.DynamicConfigClient).getInstance().initialize({
                bootstrapValues: window.featureGateBootstrapValues
            });
        } catch (error) {
            console.error('Failed to initialize DynamicConfigClient', error);
        }
        const canonicalBaseUrl = (0, $6r14Z.getCanonicalBaseUrl)(window.location.hostname, path);
        const pathForCanonical = path ? (0, $6r14Z.canonicalPathForHref)(canonicalBaseUrl, path) : undefined;
        const route = pathForCanonical === undefined ? '' : pathForCanonical === '' ? '' : `/${pathForCanonical}`;
        const page = /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $6gQvZ.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: [
                isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                    rel: "canonical",
                    href: `${canonicalBaseUrl}${route}`
                }),
                isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                    rel: "alternate",
                    href: `${canonicalBaseUrl}${route}`,
                    hrefLang: "x-default"
                }),
                isStatic && $b6785f1d81c92020$var$SUPPORTED_LOCALES.map(({ hrefLang: hrefLang, langRoute: langRoute })=>/*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                        rel: "alternate",
                        href: `${canonicalBaseUrl}/${langRoute}${route}`,
                        hrefLang: hrefLang
                    }, hrefLang)),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7mHQv.PageWrapper), {
                    analyticsWebClient: analyticsWebClient,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    hasCloudSessionTokenCookie: window.hasCloudSessionTokenCookie,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    loggedInContext: window.loggedInContext,
                    loggedInContextStatus: window.loggedInContextStatus,
                    countryCode: window.countryCode,
                    templates: window.templates,
                    partnerTemplates: window.partnerTemplates,
                    collections: window.collections,
                    categories: window.categories,
                    composition: window._uniformPreloadedComposition,
                    compositionRegenerationMetadata: window._uniformRegenerationMetadata,
                    isUniformPlayground: window.isUniformPlayground,
                    isAllowPostMessage: window.isAllowPostMessage,
                    teamType: window.teamType,
                    keyword: window.keyword,
                    referrer: window.referrer,
                    mlTemplateIds: window.mlTemplateIds,
                    channel: window.channel,
                    track: window.track,
                    anchor: window.anchor,
                    subAnchor: window.subAnchor,
                    auxiaResponse: window.auxiaResponse,
                    PageComponent: Component,
                    transactionAccounts: window.transactionAccounts,
                    userAgent: userAgent,
                    clusterTag: window.clusterTag
                })
            ]
        });
        if (isStatic) {
            // @ts-expect-error type
            const root = (0, $konOj.createRoot)(document.getElementById('wac'));
            root.render(page);
        } else // @ts-expect-error type
        (0, $konOj.hydrateRoot)(document.getElementById('wac-root'), page, {
            onRecoverableError: (error, errorInfo)=>{
                document.getElementById('wac-root')?.setAttribute('hydration-error', 'true');
            }
        });
    });
};

});

parcelRegister("b3BH6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $80cd36d40705ea74$export$2e2bcd8739ae039; });
/* blanket.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $fweqv = parcelRequire("fweqv");
var $jn1J7 = parcelRequire("jn1J7");

var $h6fC1 = parcelRequire("h6fC1");

var $b3oLb = parcelRequire("b3oLb");

var $2EpPx = parcelRequire("2EpPx");

function $80cd36d40705ea74$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $80cd36d40705ea74$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $80cd36d40705ea74$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $80cd36d40705ea74$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $80cd36d40705ea74$var$packageName = "@atlaskit/blanket";
var $80cd36d40705ea74$var$packageVersion = "15.0.0";
var $80cd36d40705ea74$var$analyticsAttributes = {
    componentName: 'blanket',
    packageName: $80cd36d40705ea74$var$packageName,
    packageVersion: $80cd36d40705ea74$var$packageVersion
};
var $80cd36d40705ea74$var$baseStyles = null;
var $80cd36d40705ea74$var$shouldAllowClickThroughStyles = null;
var $80cd36d40705ea74$var$invisibleStyles = null;
/**
 * __Blanket__
 *
 * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
 *
 * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
 */ var $80cd36d40705ea74$var$Blanket = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function Blanket(_ref, ref) {
    var _ref$shouldAllowClick = _ref.shouldAllowClickThrough, shouldAllowClickThrough = _ref$shouldAllowClick === void 0 ? false : _ref$shouldAllowClick, _ref$isTinted = _ref.isTinted, isTinted = _ref$isTinted === void 0 ? false : _ref$isTinted, _ref$onBlanketClicked = _ref.onBlanketClicked, onBlanketClicked = _ref$onBlanketClicked === void 0 ? (0, $b3oLb.default) : _ref$onBlanketClicked, testId = _ref.testId, children = _ref.children, analyticsContext = _ref.analyticsContext;
    var mouseDownTarget = (0, $1oC0p.useRef)(null);
    var onBlanketClickedWithAnalytics = (0, $h6fC1.usePlatformLeafEventHandler)($80cd36d40705ea74$var$_objectSpread({
        fn: onBlanketClicked,
        action: 'clicked',
        analyticsData: analyticsContext
    }, $80cd36d40705ea74$var$analyticsAttributes));
    var blanketClickOutsideChildren = (0, $1oC0p.useCallback)(function(e) {
        return e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined;
    }, [
        onBlanketClickedWithAnalytics
    ]);
    var onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    var onMouseDown = (0, $1oC0p.useCallback)(function(e) {
        mouseDownTarget.current = e.target;
    }, []);
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        role: "presentation",
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref,
        className: (0, $fweqv.default)([
            "_1r04idpf _kqsw1n9t _1pbybfng _bfhk705f _18m91wug _lcxv1wug",
            shouldAllowClickThrough && "_lcxvglyw",
            !isTinted && "_bfhk1j28"
        ]),
        style: {
            "--_10avjlk": (0, $jn1J7.default)("var(--ds-blanket, ".concat((0, $2EpPx.N100A), ")"))
        }
    }, children);
}));
$80cd36d40705ea74$var$Blanket.displayName = 'Blanket';
var $80cd36d40705ea74$export$2e2bcd8739ae039 = $80cd36d40705ea74$var$Blanket;

});
parcelRegister("fweqv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b4c508fd21b98f78$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $b4c508fd21b98f78$var$ATOMIC_GROUP_LENGTH = 5;
function $b4c508fd21b98f78$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $b4c508fd21b98f78$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("jn1J7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e1a18130895f531e$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $e1a18130895f531e$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});

parcelRegister("h6fC1", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $c72f1b7e8146d730$export$a4687b0234b40e28; });

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $lgfxE = parcelRequire("lgfxE");

var $7X3P7 = parcelRequire("7X3P7");
function $c72f1b7e8146d730$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c72f1b7e8146d730$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c72f1b7e8146d730$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c72f1b7e8146d730$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c72f1b7e8146d730$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $lgfxE.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $7X3P7.useTrackedRef)(analyticsData);
    var fnRef = (0, $7X3P7.useTrackedRef)(fn);
    var handler = (0, $1oC0p.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $c72f1b7e8146d730$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("lgfxE", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", function () { return $f7a725d76e55863f$export$5bf35293e545f20c; });

var $hcVab = parcelRequire("hcVab");

var $acSNb = parcelRequire("acSNb");

var $99avv = parcelRequire("99avv");
function $f7a725d76e55863f$export$5bf35293e545f20c() {
    var analyticsContext = (0, $99avv.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $hcVab.useCallbackOne)(function(payload) {
        return new (0, $acSNb.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("acSNb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $76e586fe135a990c$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $7SQOE = parcelRequire("7SQOE");

var $i7dvh = parcelRequire("i7dvh");

var $f53LC = parcelRequire("f53LC");

var $cEU2a = parcelRequire("cEU2a");
function $76e586fe135a990c$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $76e586fe135a990c$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $76e586fe135a990c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($76e586fe135a990c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $76e586fe135a990c$var$_superPropGet(t, o, e, r) {
    var p = (0, $7SQOE.default)((0, $jlBwm.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $76e586fe135a990c$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $76e586fe135a990c$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $76e586fe135a990c$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $cTewU.default)(this, UIAnalyticsEvent);
        _this = $76e586fe135a990c$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $f53LC.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $f53LC.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $lFOXD.default)(_this.context);
            var handlers = (0, $lFOXD.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $f53LC.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $i7dvh.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $avOEA.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $76e586fe135a990c$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $cEU2a.default));

});
parcelRegister("cEU2a", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9374af9df9b7fe4f$export$2e2bcd8739ae039; });

var $2zYm4 = parcelRequire("2zYm4");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");
function $9374af9df9b7fe4f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9374af9df9b7fe4f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9374af9df9b7fe4f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9374af9df9b7fe4f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9374af9df9b7fe4f$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $9374af9df9b7fe4f$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $9374af9df9b7fe4f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $cTewU.default)(this, AnalyticsEvent);
        (0, $f53LC.default)(this, "_isAnalyticsEvent", true);
        (0, $f53LC.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $9374af9df9b7fe4f$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $avOEA.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $2zYm4.default)(updater) === 'object') this.payload = $9374af9df9b7fe4f$var$_objectSpread($9374af9df9b7fe4f$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("99avv", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", function () { return $6a8d1ad839b65654$export$d1f587f82ad51c4; });

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");
var $6a8d1ad839b65654$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $1oC0p.useContext)((0, $bEiDG.default));
};

});


parcelRegister("7X3P7", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", function () { return $5ca1025a2c9557d8$export$1d27a74659855e44; });

var $1oC0p = parcelRequire("1oC0p");
var $5ca1025a2c9557d8$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $1oC0p.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("b3oLb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $80c32e5df1b77ed5$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $80c32e5df1b77ed5$export$2e2bcd8739ae039() {}

});

parcelRegister("2EpPx", function(module, exports) {
$parcel$export(module.exports, "N100A", function () { return $1ee35a8d7554d885$export$486ab785e4bac3c6; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $1ee35a8d7554d885$export$4b84fd0e2c617bd = '#FFEBE6';
var $1ee35a8d7554d885$export$b34b069eff244586 = '#FFBDAD';
var $1ee35a8d7554d885$export$be802dd0d8b57f35 = '#FF8F73';
var $1ee35a8d7554d885$export$60847d42f9da92a6 = '#FF7452';
var $1ee35a8d7554d885$export$4a7404f376229999 = '#FF5630';
var $1ee35a8d7554d885$export$2010d0fb4295b346 = '#DE350B';
var $1ee35a8d7554d885$export$2837b5a1a71d5c02 = '#BF2600';
var $1ee35a8d7554d885$export$8d9596b529bbb9cf = '#FFFAE6';
var $1ee35a8d7554d885$export$41060a744ab0b7ae = '#FFF0B3';
var $1ee35a8d7554d885$export$1cc05bbbf340e559 = '#FFE380';
var $1ee35a8d7554d885$export$5aae31392d72caaa = '#FFC400';
var $1ee35a8d7554d885$export$c6930421db9fa514 = '#FFAB00';
var $1ee35a8d7554d885$export$59619663aa6500fb = '#FF991F';
var $1ee35a8d7554d885$export$874739ea9e379ab6 = '#FF8B00';
var $1ee35a8d7554d885$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $1ee35a8d7554d885$export$69a3bf21b9686c2b = '#ABF5D1';
var $1ee35a8d7554d885$export$afbce1382ec95f73 = '#79F2C0';
var $1ee35a8d7554d885$export$747d86715d4175de = '#57D9A3';
var $1ee35a8d7554d885$export$940e1f69e873f202 = '#36B37E';
var $1ee35a8d7554d885$export$a49394138f7b8e85 = '#00875A';
var $1ee35a8d7554d885$export$6fa04827ac68a4fb = '#006644';
var $1ee35a8d7554d885$export$226de0355ed012f8 = '#DEEBFF';
var $1ee35a8d7554d885$export$8c13c2ee36917869 = '#B3D4FF';
var $1ee35a8d7554d885$export$ecfc1dff386a3e7a = '#4C9AFF';
var $1ee35a8d7554d885$export$215b7063051591f1 = '#2684FF';
var $1ee35a8d7554d885$export$e62e8919cca44969 = '#0065FF';
var $1ee35a8d7554d885$export$b3de0ae08da2ce64 = '#0052CC';
var $1ee35a8d7554d885$export$a6ee3d71bc067634 = '#0747A6';
var $1ee35a8d7554d885$export$67f15409e87642a1 = '#669DF1';
var $1ee35a8d7554d885$export$f0539dbc42dbb067 = '#8FB8F6';
var $1ee35a8d7554d885$export$363e4475840015bb = '#EAE6FF';
var $1ee35a8d7554d885$export$4b0a4417ed59760f = '#C0B6F2';
var $1ee35a8d7554d885$export$6011520a64d9a187 = '#998DD9';
var $1ee35a8d7554d885$export$a7175d4e9206bc80 = '#8777D9';
var $1ee35a8d7554d885$export$b48405b95304b5a1 = '#6554C0';
var $1ee35a8d7554d885$export$c71e4279dd54a18d = '#5243AA';
var $1ee35a8d7554d885$export$147899de772240ec = '#403294';
var $1ee35a8d7554d885$export$2cf711fe14c66f06 = '#E6FCFF';
var $1ee35a8d7554d885$export$7a8f4d33f6f9772c = '#B3F5FF';
var $1ee35a8d7554d885$export$776c9c497ef08533 = '#79E2F2';
var $1ee35a8d7554d885$export$69cb3ca10c1e330e = '#00C7E6';
var $1ee35a8d7554d885$export$9dc1ef0f3f48059b = '#00B8D9';
var $1ee35a8d7554d885$export$7c835c78b6fcdef8 = '#00A3BF';
var $1ee35a8d7554d885$export$6036577f95c3877e = '#008DA6';
var $1ee35a8d7554d885$export$29a4f05edc054374 = '#FFFFFF';
var $1ee35a8d7554d885$export$e655ef011c4aa1a2 = '#FAFBFC';
var $1ee35a8d7554d885$export$9fdfb749e33cdf97 = '#F4F5F7';
var $1ee35a8d7554d885$export$3e51e8f1440314ba = '#EBECF0';
var $1ee35a8d7554d885$export$1ce2d1575d444ceb = '#DFE1E6';
var $1ee35a8d7554d885$export$8754fc7e6d8b3000 = '#C1C7D0';
var $1ee35a8d7554d885$export$c2e91cbeada39b8b = '#B3BAC5';
var $1ee35a8d7554d885$export$5f71e19f3a7ad9de = '#A5ADBA';
var $1ee35a8d7554d885$export$eaa8c8a70ac22806 = '#97A0AF';
var $1ee35a8d7554d885$export$7c87d337fb91a97d = '#8993A4';
var $1ee35a8d7554d885$export$d6447c357493214f = '#7A869A';
var $1ee35a8d7554d885$export$f563ee71e9ee74cd = '#6B778C';
var $1ee35a8d7554d885$export$e2ef2124cf4024b1 = '#5E6C84';
var $1ee35a8d7554d885$export$eece5f492e429f08 = '#505F79';
var $1ee35a8d7554d885$export$c39c0fe0f26207ae = '#42526E';
var $1ee35a8d7554d885$export$7090862dc3038a9f = '#344563';
var $1ee35a8d7554d885$export$ad0bacf983b7ddaa = '#253858';
var $1ee35a8d7554d885$export$7d61b15e0da132af = '#172B4D';
var $1ee35a8d7554d885$export$fbda843f0a27fe96 = '#091E42';
var $1ee35a8d7554d885$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $1ee35a8d7554d885$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $1ee35a8d7554d885$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $1ee35a8d7554d885$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $1ee35a8d7554d885$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $1ee35a8d7554d885$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $1ee35a8d7554d885$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $1ee35a8d7554d885$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $1ee35a8d7554d885$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $1ee35a8d7554d885$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $1ee35a8d7554d885$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $1ee35a8d7554d885$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $1ee35a8d7554d885$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $1ee35a8d7554d885$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $1ee35a8d7554d885$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $1ee35a8d7554d885$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $1ee35a8d7554d885$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $1ee35a8d7554d885$export$2f6319cf7d736c2a = '#E6EDFA';
var $1ee35a8d7554d885$export$95126bc8884d6634 = '#DCE5F5';
var $1ee35a8d7554d885$export$8338d8c35d44ff1 = '#CED9EB';
var $1ee35a8d7554d885$export$5368d76ae4fbbda7 = '#B8C7E0';
var $1ee35a8d7554d885$export$9f0a771d16ec8d36 = '#ABBBD6';
var $1ee35a8d7554d885$export$abcf8c38338b4aa5 = '#9FB0CC';
var $1ee35a8d7554d885$export$97e81faa16a182c7 = '#8C9CB8';
var $1ee35a8d7554d885$export$bfe21c59123ecf33 = '#7988A3';
var $1ee35a8d7554d885$export$ee82aa2ea6a1558 = '#67758F';
var $1ee35a8d7554d885$export$682927c6ed76be02 = '#56637A';
var $1ee35a8d7554d885$export$91fd9994c5be9757 = '#455166';
var $1ee35a8d7554d885$export$d281fbfe3cff2df6 = '#3B475C';
var $1ee35a8d7554d885$export$3902c91d8b98a753 = '#313D52';
var $1ee35a8d7554d885$export$8e8133c1ba5845b5 = '#283447';
var $1ee35a8d7554d885$export$33ff357f6620b39 = '#202B3D';
var $1ee35a8d7554d885$export$633847cf062b69e0 = '#1B2638';
var $1ee35a8d7554d885$export$9776a6e503bdbf76 = '#121A29';
var $1ee35a8d7554d885$export$6c813d5160dff5db = '#0E1624';
var $1ee35a8d7554d885$export$3d4f271a500072a = '#0D1424';
var $1ee35a8d7554d885$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $1ee35a8d7554d885$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $1ee35a8d7554d885$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $1ee35a8d7554d885$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $1ee35a8d7554d885$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $1ee35a8d7554d885$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $1ee35a8d7554d885$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $1ee35a8d7554d885$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $1ee35a8d7554d885$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $1ee35a8d7554d885$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $1ee35a8d7554d885$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $1ee35a8d7554d885$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $1ee35a8d7554d885$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $1ee35a8d7554d885$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $1ee35a8d7554d885$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $1ee35a8d7554d885$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $1ee35a8d7554d885$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $1ee35a8d7554d885$export$d2adc5dedf09fced = '#292A2E';
var $1ee35a8d7554d885$export$f51762073d2bb381 = '#94C748';
var $1ee35a8d7554d885$export$95e26d54def96891 = '#B3DF72';

});


parcelRegister("gwrd5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c074bdd976ff9b64$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $1YOZ4 = parcelRequire("1YOZ4");
/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions).
 */ var $c074bdd976ff9b64$var$SlideIn = function SlideIn(_ref) {
    var children = _ref.children, enterFrom = _ref.enterFrom, exitTo = _ref.exitTo, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'medium' : _ref$duration, isPaused = _ref.isPaused, onFinish = _ref.onFinish, _ref$animationTimingF = _ref.animationTimingFunction, animationTimingFunction = _ref$animationTimingF === void 0 ? 'ease-out' : _ref$animationTimingF, _ref$animationTimingF2 = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF2 === void 0 ? 'ease-in' : _ref$animationTimingF2;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1YOZ4.default), {
        duration: duration,
        enteringAnimation: "slide-in-from-".concat(enterFrom),
        exitingAnimation: "slide-out-from-".concat(exitTo || enterFrom),
        animationTimingFunction: animationTimingFunction,
        animationTimingFunctionExiting: animationTimingFunctionExiting,
        isPaused: isPaused,
        onFinish: onFinish
    }, children);
};
var $c074bdd976ff9b64$export$2e2bcd8739ae039 = $c074bdd976ff9b64$var$SlideIn;

});

parcelRegister("beJjp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $82e4268c2676c74f$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $h1JRM = parcelRequire("h1JRM");

var $10uW5 = parcelRequire("10uW5");
function $82e4268c2676c74f$export$2e2bcd8739ae039() {
    var intl = $1oC0p.useContext((0, $h1JRM.Context));
    (0, $10uW5.invariantIntlContext)(intl);
    return intl;
}

});
parcelRegister("h1JRM", function(module, exports) {
$parcel$export(module.exports, "Provider", function () { return $c6561bcaf5521620$export$2881499e37b75b9a; });
$parcel$export(module.exports, "Context", function () { return $c6561bcaf5521620$export$841858b892ce1f4c; });
$parcel$export(module.exports, "default", function () { return $c6561bcaf5521620$export$2e2bcd8739ae039; });

var $d3IQL = parcelRequire("d3IQL");

var $1oC0p = parcelRequire("1oC0p");

var $6PuZm = parcelRequire("6PuZm");

var $10uW5 = parcelRequire("10uW5");
function $c6561bcaf5521620$var$getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $c6561bcaf5521620$var$IntlContext = typeof window !== 'undefined' && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $1oC0p.createContext(null)) : $1oC0p.createContext(null);
var $c6561bcaf5521620$var$IntlConsumer = $c6561bcaf5521620$var$IntlContext.Consumer, $c6561bcaf5521620$var$IntlProvider = $c6561bcaf5521620$var$IntlContext.Provider;
var $c6561bcaf5521620$export$2881499e37b75b9a = $c6561bcaf5521620$var$IntlProvider;
var $c6561bcaf5521620$export$841858b892ce1f4c = $c6561bcaf5521620$var$IntlContext;
function $c6561bcaf5521620$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $1oC0p.createElement($c6561bcaf5521620$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $10uW5.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $1oC0p.createElement(WrappedComponent, (0, $d3IQL.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($c6561bcaf5521620$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($6PuZm)))($1oC0p.forwardRef(function(props, ref) {
        return $1oC0p.createElement(WithIntl, (0, $d3IQL.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6PuZm)))(WithIntl, WrappedComponent);
}

});
parcelRegister("10uW5", function(module, exports) {
$parcel$export(module.exports, "invariantIntlContext", function () { return $0bbdc9c184ffc2f9$export$45c4bbf6e55bba1f; });
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $0bbdc9c184ffc2f9$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "assignUniqueKeysToParts", function () { return $0bbdc9c184ffc2f9$export$cfec03d26465fa63; });
$parcel$export(module.exports, "shallowEqual", function () { return $0bbdc9c184ffc2f9$export$d36bdfa510afb180; });

var $d3IQL = parcelRequire("d3IQL");

var $1oC0p = parcelRequire("1oC0p");

var $jcL53 = parcelRequire("jcL53");

var $bceAk = parcelRequire("bceAk");
function $0bbdc9c184ffc2f9$export$45c4bbf6e55bba1f(intl) {
    (0, $jcL53.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $0bbdc9c184ffc2f9$export$b52f8d6fc0d47415 = (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, (0, $bceAk.DEFAULT_INTL_CONFIG)), {
    textComponent: $1oC0p.Fragment
});
function $0bbdc9c184ffc2f9$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($1oC0p.Children.toArray(parts));
    };
}
function $0bbdc9c184ffc2f9$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

});



parcelRegister("k0oFl", function(module, exports) {
$parcel$export(module.exports, "defineMessages", function () { return $e906f0e087fc2d17$export$1adfeb024f5185b; });
$parcel$export(module.exports, "defineMessage", function () { return $e906f0e087fc2d17$export$747d244ee58120dd; });
$parcel$export(module.exports, "FormattedDate", function () { return $e906f0e087fc2d17$export$40ae3194919d16b; });
$parcel$export(module.exports, "FormattedTime", function () { return $e906f0e087fc2d17$export$5b390a54f8a846f7; });
$parcel$export(module.exports, "FormattedNumber", function () { return $e906f0e087fc2d17$export$db80edc1e6b2f63d; });
$parcel$export(module.exports, "FormattedList", function () { return $e906f0e087fc2d17$export$f52b44e459e6e71d; });
$parcel$export(module.exports, "FormattedDisplayName", function () { return $e906f0e087fc2d17$export$c2336ea5aaab92fa; });
$parcel$export(module.exports, "FormattedDateParts", function () { return $e906f0e087fc2d17$export$7fdc7d2c91ce149b; });
$parcel$export(module.exports, "FormattedTimeParts", function () { return $e906f0e087fc2d17$export$ec35873761676c2a; });
$parcel$export(module.exports, "FormattedDateTimeRange", function () { return (parcelRequire("7Wtkv")).default; });
$parcel$export(module.exports, "FormattedMessage", function () { return (parcelRequire("fzVi0")).default; });
$parcel$export(module.exports, "FormattedPlural", function () { return (parcelRequire("gjSoO")).default; });
$parcel$export(module.exports, "FormattedRelativeTime", function () { return (parcelRequire("KIxfk")).default; });
$parcel$export(module.exports, "IntlContext", function () { return (parcelRequire("h1JRM")).Context; });
$parcel$export(module.exports, "IntlProvider", function () { return (parcelRequire("12z4Z")).default; });
$parcel$export(module.exports, "RawIntlProvider", function () { return (parcelRequire("h1JRM")).Provider; });
$parcel$export(module.exports, "createIntl", function () { return (parcelRequire("12z4Z")).createIntl; });
$parcel$export(module.exports, "injectIntl", function () { return (parcelRequire("h1JRM")).default; });
$parcel$export(module.exports, "useIntl", function () { return (parcelRequire("beJjp")).default; });
$parcel$export(module.exports, "createIntlCache", function () { return (parcelRequire("bceAk")).createIntlCache; });
$parcel$export(module.exports, "UnsupportedFormatterError", function () { return (parcelRequire("iOyCd")).UnsupportedFormatterError; });
$parcel$export(module.exports, "InvalidConfigError", function () { return (parcelRequire("iOyCd")).InvalidConfigError; });
$parcel$export(module.exports, "MissingDataError", function () { return (parcelRequire("iOyCd")).MissingDataError; });
$parcel$export(module.exports, "MessageFormatError", function () { return (parcelRequire("iOyCd")).MessageFormatError; });
$parcel$export(module.exports, "MissingTranslationError", function () { return (parcelRequire("iOyCd")).MissingTranslationError; });
$parcel$export(module.exports, "ReactIntlErrorCode", function () { return (parcelRequire("iOyCd")).IntlErrorCode; });
$parcel$export(module.exports, "ReactIntlError", function () { return (parcelRequire("iOyCd")).IntlError; });
$parcel$export(module.exports, "FormattedNumberParts", function () { return (parcelRequire("7AgIc")).FormattedNumberParts; });
$parcel$export(module.exports, "FormattedListParts", function () { return (parcelRequire("7AgIc")).FormattedListParts; });

var $7AgIc = parcelRequire("7AgIc");

var $h1JRM = parcelRequire("h1JRM");

var $beJjp = parcelRequire("beJjp");

var $12z4Z = parcelRequire("12z4Z");

var $KIxfk = parcelRequire("KIxfk");

var $gjSoO = parcelRequire("gjSoO");

var $fzVi0 = parcelRequire("fzVi0");

var $7Wtkv = parcelRequire("7Wtkv");

var $bceAk = parcelRequire("bceAk");
var $iOyCd = parcelRequire("iOyCd");
function $e906f0e087fc2d17$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $e906f0e087fc2d17$export$747d244ee58120dd(msg) {
    return msg;
}
var $e906f0e087fc2d17$export$40ae3194919d16b = (0, $7AgIc.createFormattedComponent)('formatDate');
var $e906f0e087fc2d17$export$5b390a54f8a846f7 = (0, $7AgIc.createFormattedComponent)('formatTime');
var $e906f0e087fc2d17$export$db80edc1e6b2f63d = (0, $7AgIc.createFormattedComponent)('formatNumber');
var $e906f0e087fc2d17$export$f52b44e459e6e71d = (0, $7AgIc.createFormattedComponent)('formatList');
var $e906f0e087fc2d17$export$c2336ea5aaab92fa = (0, $7AgIc.createFormattedComponent)('formatDisplayName');
var $e906f0e087fc2d17$export$7fdc7d2c91ce149b = (0, $7AgIc.createFormattedDateTimePartsComponent)('formatDate');
var $e906f0e087fc2d17$export$ec35873761676c2a = (0, $7AgIc.createFormattedDateTimePartsComponent)('formatTime');

});
parcelRegister("7AgIc", function(module, exports) {
$parcel$export(module.exports, "FormattedNumberParts", function () { return $5858dbd7db7f5104$export$54d4989ed3eea1ea; });
$parcel$export(module.exports, "FormattedListParts", function () { return $5858dbd7db7f5104$export$5ac259c7da6d2188; });
$parcel$export(module.exports, "createFormattedDateTimePartsComponent", function () { return $5858dbd7db7f5104$export$7448277f6036d2ab; });
$parcel$export(module.exports, "createFormattedComponent", function () { return $5858dbd7db7f5104$export$b37e14176d001dec; });

var $d3IQL = parcelRequire("d3IQL");

var $1oC0p = parcelRequire("1oC0p");

var $beJjp = parcelRequire("beJjp");
var $5858dbd7db7f5104$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($5858dbd7db7f5104$var$DisplayName || ($5858dbd7db7f5104$var$DisplayName = {}));
var $5858dbd7db7f5104$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($5858dbd7db7f5104$var$DisplayNameParts || ($5858dbd7db7f5104$var$DisplayNameParts = {}));
var $5858dbd7db7f5104$export$54d4989ed3eea1ea = function(props) {
    var intl = (0, $beJjp.default)();
    var value = props.value, children = props.children, formatProps = (0, $d3IQL.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$5858dbd7db7f5104$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
var $5858dbd7db7f5104$export$5ac259c7da6d2188 = function(props) {
    var intl = (0, $beJjp.default)();
    var value = props.value, children = props.children, formatProps = (0, $d3IQL.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$5858dbd7db7f5104$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
function $5858dbd7db7f5104$export$7448277f6036d2ab(name) {
    var ComponentParts = function(props) {
        var intl = (0, $beJjp.default)();
        var value = props.value, children = props.children, formatProps = (0, $d3IQL.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate' ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $5858dbd7db7f5104$var$DisplayNameParts[name];
    return ComponentParts;
}
function $5858dbd7db7f5104$export$b37e14176d001dec(name) {
    var Component = function(props) {
        var intl = (0, $beJjp.default)();
        var value = props.value, children = props.children, formatProps = (0, $d3IQL.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') return children(formattedValue);
        var Text = intl.textComponent || $1oC0p.Fragment;
        return $1oC0p.createElement(Text, null, formattedValue);
    };
    Component.displayName = $5858dbd7db7f5104$var$DisplayName[name];
    return Component;
}

});

parcelRegister("12z4Z", function(module, exports) {
$parcel$export(module.exports, "createIntl", function () { return $0c2130649a45a50f$export$7e4cbedfdd7b4c0d; });
$parcel$export(module.exports, "default", function () { return $0c2130649a45a50f$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $d3IQL = parcelRequire("d3IQL");

var $1oC0p = parcelRequire("1oC0p");

var $h1JRM = parcelRequire("h1JRM");

var $10uW5 = parcelRequire("10uW5");

var $ejHIf = parcelRequire("ejHIf");
var $bceAk = parcelRequire("bceAk");
var $8xwAh = parcelRequire("8xwAh");

var $hjTVN = parcelRequire("hjTVN");
function $0c2130649a45a50f$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
function $0c2130649a45a50f$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $hjTVN.isFormatXMLElementFn)(v) ? (0, $10uW5.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $0c2130649a45a50f$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $0c2130649a45a50f$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $8xwAh.formatMessage).apply(void 0, (0, $d3IQL.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $1oC0p.Children.toArray(chunks);
    return chunks;
};
var $0c2130649a45a50f$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $d3IQL.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $0c2130649a45a50f$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $ejHIf.createIntl)((0, $d3IQL.__assign)((0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, (0, $10uW5.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, coreIntl), {
        // @ts-expect-error fix this
        formatMessage: $0c2130649a45a50f$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters),
        // @ts-expect-error fix this
        $t: $0c2130649a45a50f$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};
var $0c2130649a45a50f$var$IntlProvider = /** @class */ function(_super) {
    (0, $d3IQL.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $bceAk.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: $0c2130649a45a50f$export$7e4cbedfdd7b4c0d($0c2130649a45a50f$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $0c2130649a45a50f$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $0c2130649a45a50f$var$processIntlConfig(props);
        if (!(0, $10uW5.shallowEqual)(prevConfig, config)) return {
            intl: $0c2130649a45a50f$export$7e4cbedfdd7b4c0d(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $10uW5.invariantIntlContext)(this.state.intl);
        return $1oC0p.createElement((0, $h1JRM.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, $10uW5.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($1oC0p.PureComponent);
var $0c2130649a45a50f$export$2e2bcd8739ae039 = $0c2130649a45a50f$var$IntlProvider;

});

parcelRegister("KIxfk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $08c6d7c2ef6b7128$export$2e2bcd8739ae039; });

var $d3IQL = parcelRequire("d3IQL");

var $1oC0p = parcelRequire("1oC0p");

var $jcL53 = parcelRequire("jcL53");

var $beJjp = parcelRequire("beJjp");
var $08c6d7c2ef6b7128$var$MINUTE = 60;
var $08c6d7c2ef6b7128$var$HOUR = 3600;
var $08c6d7c2ef6b7128$var$DAY = 86400;
function $08c6d7c2ef6b7128$var$selectUnit(seconds) {
    var absValue = Math.abs(seconds);
    if (absValue < $08c6d7c2ef6b7128$var$MINUTE) return 'second';
    if (absValue < $08c6d7c2ef6b7128$var$HOUR) return 'minute';
    if (absValue < $08c6d7c2ef6b7128$var$DAY) return 'hour';
    return 'day';
}
function $08c6d7c2ef6b7128$var$getDurationInSeconds(unit) {
    switch(unit){
        case 'second':
            return 1;
        case 'minute':
            return $08c6d7c2ef6b7128$var$MINUTE;
        case 'hour':
            return $08c6d7c2ef6b7128$var$HOUR;
        default:
            return $08c6d7c2ef6b7128$var$DAY;
    }
}
function $08c6d7c2ef6b7128$var$valueToSeconds(value, unit) {
    if (!value) return 0;
    switch(unit){
        case 'second':
            return value;
        case 'minute':
            return value * $08c6d7c2ef6b7128$var$MINUTE;
        default:
            return value * $08c6d7c2ef6b7128$var$HOUR;
    }
}
var $08c6d7c2ef6b7128$var$INCREMENTABLE_UNITS = [
    'second',
    'minute',
    'hour'
];
function $08c6d7c2ef6b7128$var$canIncrement(unit) {
    if (unit === void 0) unit = 'second';
    return $08c6d7c2ef6b7128$var$INCREMENTABLE_UNITS.indexOf(unit) > -1;
}
var $08c6d7c2ef6b7128$var$SimpleFormattedRelativeTime = function(props) {
    var _a = (0, $beJjp.default)(), formatRelativeTime = _a.formatRelativeTime, Text = _a.textComponent;
    var children = props.children, value = props.value, unit = props.unit, otherProps = (0, $d3IQL.__rest)(props, [
        "children",
        "value",
        "unit"
    ]);
    var formattedRelativeTime = formatRelativeTime(value || 0, unit, otherProps);
    if (typeof children === 'function') return children(formattedRelativeTime);
    if (Text) return $1oC0p.createElement(Text, null, formattedRelativeTime);
    return $1oC0p.createElement($1oC0p.Fragment, null, formattedRelativeTime);
};
var $08c6d7c2ef6b7128$var$FormattedRelativeTime = function(_a) {
    var value = _a.value, unit = _a.unit, updateIntervalInSeconds = _a.updateIntervalInSeconds, otherProps = (0, $d3IQL.__rest)(_a, [
        "value",
        "unit",
        "updateIntervalInSeconds"
    ]);
    (0, $jcL53.invariant)(!updateIntervalInSeconds || !!(updateIntervalInSeconds && $08c6d7c2ef6b7128$var$canIncrement(unit)), 'Cannot schedule update with unit longer than hour');
    var _b = $1oC0p.useState(), prevUnit = _b[0], setPrevUnit = _b[1];
    var _c = $1oC0p.useState(0), prevValue = _c[0], setPrevValue = _c[1];
    var _d = $1oC0p.useState(0), currentValueInSeconds = _d[0], setCurrentValueInSeconds = _d[1];
    var updateTimer;
    if (unit !== prevUnit || value !== prevValue) {
        setPrevValue(value || 0);
        setPrevUnit(unit);
        setCurrentValueInSeconds($08c6d7c2ef6b7128$var$canIncrement(unit) ? $08c6d7c2ef6b7128$var$valueToSeconds(value, unit) : 0);
    }
    $1oC0p.useEffect(function() {
        function clearUpdateTimer() {
            clearTimeout(updateTimer);
        }
        clearUpdateTimer();
        // If there's no interval and we cannot increment this unit, do nothing
        if (!updateIntervalInSeconds || !$08c6d7c2ef6b7128$var$canIncrement(unit)) return clearUpdateTimer;
        // Figure out the next interesting time
        var nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
        var nextUnit = $08c6d7c2ef6b7128$var$selectUnit(nextValueInSeconds);
        // We've reached the max auto incrementable unit, don't schedule another update
        if (nextUnit === 'day') return clearUpdateTimer;
        var unitDuration = $08c6d7c2ef6b7128$var$getDurationInSeconds(nextUnit);
        var remainder = nextValueInSeconds % unitDuration;
        var prevInterestingValueInSeconds = nextValueInSeconds - remainder;
        var nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds ? prevInterestingValueInSeconds - unitDuration : prevInterestingValueInSeconds;
        var delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
        if (currentValueInSeconds !== nextInterestingValueInSeconds) updateTimer = setTimeout(function() {
            return setCurrentValueInSeconds(nextInterestingValueInSeconds);
        }, delayInSeconds * 1e3);
        return clearUpdateTimer;
    }, [
        currentValueInSeconds,
        updateIntervalInSeconds,
        unit
    ]);
    var currentValue = value || 0;
    var currentUnit = unit;
    if ($08c6d7c2ef6b7128$var$canIncrement(unit) && typeof currentValueInSeconds === 'number' && updateIntervalInSeconds) {
        currentUnit = $08c6d7c2ef6b7128$var$selectUnit(currentValueInSeconds);
        var unitDuration = $08c6d7c2ef6b7128$var$getDurationInSeconds(currentUnit);
        currentValue = Math.round(currentValueInSeconds / unitDuration);
    }
    return $1oC0p.createElement($08c6d7c2ef6b7128$var$SimpleFormattedRelativeTime, (0, $d3IQL.__assign)({
        value: currentValue,
        unit: currentUnit
    }, otherProps));
};
$08c6d7c2ef6b7128$var$FormattedRelativeTime.displayName = 'FormattedRelativeTime';
$08c6d7c2ef6b7128$var$FormattedRelativeTime.defaultProps = {
    value: 0,
    unit: 'second'
};
var $08c6d7c2ef6b7128$export$2e2bcd8739ae039 = $08c6d7c2ef6b7128$var$FormattedRelativeTime;

});

parcelRegister("gjSoO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $be189e42a8b00fba$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $beJjp = parcelRequire("beJjp");
var $be189e42a8b00fba$var$FormattedPlural = function(props) {
    var _a = (0, $beJjp.default)(), formatPlural = _a.formatPlural, Text = _a.textComponent;
    var value = props.value, other = props.other, children = props.children;
    var pluralCategory = formatPlural(value, props);
    var formattedPlural = props[pluralCategory] || other;
    if (typeof children === 'function') return children(formattedPlural);
    if (Text) return $1oC0p.createElement(Text, null, formattedPlural);
    // Work around @types/react where React.FC cannot return string
    return formattedPlural;
};
$be189e42a8b00fba$var$FormattedPlural.defaultProps = {
    type: 'cardinal'
};
$be189e42a8b00fba$var$FormattedPlural.displayName = 'FormattedPlural';
var $be189e42a8b00fba$export$2e2bcd8739ae039 = $be189e42a8b00fba$var$FormattedPlural;

});

parcelRegister("fzVi0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b576905bdf724f70$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $d3IQL = parcelRequire("d3IQL");

var $1oC0p = parcelRequire("1oC0p");

var $beJjp = parcelRequire("beJjp");

var $10uW5 = parcelRequire("10uW5");
function $b576905bdf724f70$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $d3IQL.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $d3IQL.__rest)(nextProps, [
        "values"
    ]);
    return (0, $10uW5.shallowEqual)(nextValues, values) && (0, $10uW5.shallowEqual)(otherProps, nextOtherProps);
}
function $b576905bdf724f70$var$FormattedMessage(props) {
    var intl = (0, $beJjp.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $1oC0p.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === 'function') return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $1oC0p.createElement(Component, null, $1oC0p.Children.toArray(nodes));
    return $1oC0p.createElement($1oC0p.Fragment, null, nodes);
}
$b576905bdf724f70$var$FormattedMessage.displayName = 'FormattedMessage';
var $b576905bdf724f70$var$MemoizedFormattedMessage = $1oC0p.memo($b576905bdf724f70$var$FormattedMessage, $b576905bdf724f70$var$areEqual);
$b576905bdf724f70$var$MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
var $b576905bdf724f70$export$2e2bcd8739ae039 = $b576905bdf724f70$var$MemoizedFormattedMessage;

});

parcelRegister("7Wtkv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5c84b37497f6eba3$export$2e2bcd8739ae039; });

var $d3IQL = parcelRequire("d3IQL");

var $1oC0p = parcelRequire("1oC0p");

var $beJjp = parcelRequire("beJjp");
var $5c84b37497f6eba3$var$FormattedDateTimeRange = function(props) {
    var intl = (0, $beJjp.default)();
    var from = props.from, to = props.to, children = props.children, formatProps = (0, $d3IQL.__rest)(props, [
        "from",
        "to",
        "children"
    ]);
    var formattedValue = intl.formatDateTimeRange(from, to, formatProps);
    if (typeof children === 'function') return children(formattedValue);
    var Text = intl.textComponent || $1oC0p.Fragment;
    return $1oC0p.createElement(Text, null, formattedValue);
};
$5c84b37497f6eba3$var$FormattedDateTimeRange.displayName = 'FormattedDateTimeRange';
var $5c84b37497f6eba3$export$2e2bcd8739ae039 = $5c84b37497f6eba3$var$FormattedDateTimeRange;

});


parcelRegister("5r4Ts", function(module, exports) {
$parcel$export(module.exports, "J", function () { return $3f53451f2f444406$export$b4171a6734a65d42; });
$parcel$export(module.exports, "E", function () { return $3f53451f2f444406$export$a9c23c6ac3fc3eca; });
$parcel$export(module.exports, "H", function () { return $3f53451f2f444406$export$7f8ddf7c7c20b3cd; });
$parcel$export(module.exports, "G", function () { return $3f53451f2f444406$export$2329c99376c9d0a4; });
$parcel$export(module.exports, "I", function () { return $3f53451f2f444406$export$9bb611d729802a56; });
$parcel$export(module.exports, "z", function () { return $3f53451f2f444406$export$df995fae86a55f06; });
$parcel$export(module.exports, "A", function () { return $3f53451f2f444406$export$ebd11618f299a286; });
$parcel$export(module.exports, "s", function () { return $3f53451f2f444406$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "K", function () { return $3f53451f2f444406$export$3466f893ebf79586; });
$parcel$export(module.exports, "D", function () { return $3f53451f2f444406$export$96f57966bedc81b4; });
$parcel$export(module.exports, "C", function () { return $3f53451f2f444406$export$e7094788287c5e9b; });
$parcel$export(module.exports, "B", function () { return $3f53451f2f444406$export$ef35774e6d314e91; });
$parcel$export(module.exports, "r", function () { return $3f53451f2f444406$export$43caf9889c228507; });
$parcel$export(module.exports, "m", function () { return $3f53451f2f444406$export$953cecd6e717a553; });
$parcel$export(module.exports, "M", function () { return $3f53451f2f444406$export$3a1a48c8f6ef640e; });
$parcel$export(module.exports, "n", function () { return $3f53451f2f444406$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "u", function () { return $3f53451f2f444406$export$3b14a55fb2447963; });
$parcel$export(module.exports, "k", function () { return $3f53451f2f444406$export$342063e11d6c3cad; });
$parcel$export(module.exports, "o", function () { return $3f53451f2f444406$export$ae1af26003f05816; });
$parcel$export(module.exports, "b", function () { return $3f53451f2f444406$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "y", function () { return $3f53451f2f444406$export$4a5767248b18ef41; });
$parcel$export(module.exports, "i", function () { return $3f53451f2f444406$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "e", function () { return $3f53451f2f444406$export$f1e1789686576879; });
$parcel$export(module.exports, "a", function () { return $3f53451f2f444406$export$407448d2b89b1813; });
$parcel$export(module.exports, "h", function () { return $3f53451f2f444406$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "l", function () { return $3f53451f2f444406$export$882b5998b3b9117c; });
$parcel$export(module.exports, "d", function () { return $3f53451f2f444406$export$4368d992c4eafac0; });
$parcel$export(module.exports, "g", function () { return $3f53451f2f444406$export$39b482c5e57630a8; });
$parcel$export(module.exports, "f", function () { return $3f53451f2f444406$export$2d1720544b23b823; });
$parcel$export(module.exports, "j", function () { return $3f53451f2f444406$export$35e795649ee09318; });
$parcel$export(module.exports, "p", function () { return $3f53451f2f444406$export$ffb5f4729a158638; });
$parcel$export(module.exports, "q", function () { return $3f53451f2f444406$export$9e5f44173e64f162; });
$parcel$export(module.exports, "t", function () { return $3f53451f2f444406$export$625550452a3fa3ec; });
$parcel$export(module.exports, "v", function () { return $3f53451f2f444406$export$90a7f3efeed30595; });
$parcel$export(module.exports, "w", function () { return $3f53451f2f444406$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "x", function () { return $3f53451f2f444406$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "c", function () { return $3f53451f2f444406$export$db3b6bfb95261072; });
$parcel$export(module.exports, "F", function () { return $3f53451f2f444406$export$d66501df72047452; });

var $8jRs5 = parcelRequire("8jRs5");

var $c9bqK = parcelRequire("c9bqK");

var $3dJ4i = parcelRequire("3dJ4i");

var $2qaZZ = parcelRequire("2qaZZ");

var $gnQ3X = parcelRequire("gnQ3X");

var $2zYm4 = parcelRequire("2zYm4");

var $hOLdn = parcelRequire("hOLdn");

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $gUjjH = parcelRequire("gUjjH");

var $aWDwM = parcelRequire("aWDwM");

var $iComV = parcelRequire("iComV");
var $3f53451f2f444406$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $3f53451f2f444406$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $3f53451f2f444406$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $3f53451f2f444406$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($3f53451f2f444406$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $3f53451f2f444406$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($3f53451f2f444406$var$isArray(value)) return value.filter(Boolean);
    if ((0, $2zYm4.default)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $3f53451f2f444406$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $gnQ3X.default)(props, $3f53451f2f444406$var$_excluded$4);
    return (0, $8jRs5.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $3f53451f2f444406$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $3f53451f2f444406$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $3f53451f2f444406$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $3f53451f2f444406$var$normalizedHeight(el) {
    if ($3f53451f2f444406$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $3f53451f2f444406$var$getScrollTop(el) {
    if ($3f53451f2f444406$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $3f53451f2f444406$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($3f53451f2f444406$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $3f53451f2f444406$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $3f53451f2f444406$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $3f53451f2f444406$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $3f53451f2f444406$export$b4171a6734a65d42;
    var start = $3f53451f2f444406$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $3f53451f2f444406$var$easeOutCubic(currentTime, start, change, duration);
        $3f53451f2f444406$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $3f53451f2f444406$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $3f53451f2f444406$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $3f53451f2f444406$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $3f53451f2f444406$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $3f53451f2f444406$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $3f53451f2f444406$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $3f53451f2f444406$var$passiveOptionAccessed = false;
var $3f53451f2f444406$var$options = {
    get passive () {
        return $3f53451f2f444406$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $3f53451f2f444406$var$w = typeof window !== 'undefined' ? window : {};
if ($3f53451f2f444406$var$w.addEventListener && $3f53451f2f444406$var$w.removeEventListener) {
    $3f53451f2f444406$var$w.addEventListener('p', $3f53451f2f444406$export$b4171a6734a65d42, $3f53451f2f444406$var$options);
    $3f53451f2f444406$var$w.removeEventListener('p', $3f53451f2f444406$export$b4171a6734a65d42, false);
}
var $3f53451f2f444406$export$2408f22a0fab9ae5 = $3f53451f2f444406$var$passiveOptionAccessed;
function $3f53451f2f444406$export$3466f893ebf79586(item) {
    return item != null;
}
function $3f53451f2f444406$var$isArray(arg) {
    return Array.isArray(arg);
}
function $3f53451f2f444406$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $3f53451f2f444406$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $3f53451f2f444406$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $3f53451f2f444406$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $2qaZZ.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $2qaZZ.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $3f53451f2f444406$var$_excluded$3 = [
    "children",
    "innerProps"
], $3f53451f2f444406$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $3f53451f2f444406$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $3f53451f2f444406$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $3f53451f2f444406$var$normalizedHeight(scrollParent);
    var scrollTop = $3f53451f2f444406$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $3f53451f2f444406$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $3f53451f2f444406$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $3f53451f2f444406$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $3f53451f2f444406$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $3f53451f2f444406$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $3f53451f2f444406$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $3f53451f2f444406$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $3f53451f2f444406$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $8jRs5.default)((_objectSpread2 = {
        label: 'menu'
    }, (0, $f53LC.default)(_objectSpread2, $3f53451f2f444406$var$alignToControl(placement), '100%'), (0, $f53LC.default)(_objectSpread2, "position", 'absolute'), (0, $f53LC.default)(_objectSpread2, "width", '100%'), (0, $f53LC.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $3f53451f2f444406$var$PortalPlacementContext = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
// NOTE: internal only
var $3f53451f2f444406$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $1oC0p.useContext)($3f53451f2f444406$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $1oC0p.useRef)(null);
    var _useState = (0, $1oC0p.useState)(maxMenuHeight), _useState2 = (0, $2qaZZ.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)(null), _useState4 = (0, $2qaZZ.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $iComV.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $3f53451f2f444406$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $8jRs5.default)((0, $8jRs5.default)({}, props), {}, {
            placement: placement || $3f53451f2f444406$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $3f53451f2f444406$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $3dJ4i.jsx)("div", (0, $c9bqK.default)({}, $3f53451f2f444406$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $3f53451f2f444406$var$Menu$1 = $3f53451f2f444406$var$Menu;
// ==============================
// Menu List
// ==============================
var $3f53451f2f444406$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $8jRs5.default)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $3f53451f2f444406$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $3dJ4i.jsx)("div", (0, $c9bqK.default)({}, $3f53451f2f444406$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $3f53451f2f444406$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $8jRs5.default)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $3f53451f2f444406$export$3b14a55fb2447963 = $3f53451f2f444406$var$noticeCSS;
var $3f53451f2f444406$export$342063e11d6c3cad = $3f53451f2f444406$var$noticeCSS;
var $3f53451f2f444406$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? 'No options' : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $gnQ3X.default)(_ref6, $3f53451f2f444406$var$_excluded$3);
    return (0, $3dJ4i.jsx)("div", (0, $c9bqK.default)({}, $3f53451f2f444406$var$getStyleProps((0, $8jRs5.default)((0, $8jRs5.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
var $3f53451f2f444406$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? 'Loading...' : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $gnQ3X.default)(_ref7, $3f53451f2f444406$var$_excluded2$1);
    return (0, $3dJ4i.jsx)("div", (0, $c9bqK.default)({}, $3f53451f2f444406$var$getStyleProps((0, $8jRs5.default)((0, $8jRs5.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $3f53451f2f444406$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $3f53451f2f444406$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $1oC0p.useRef)(null);
    var cleanupRef = (0, $1oC0p.useRef)(null);
    var _useState5 = (0, $1oC0p.useState)($3f53451f2f444406$var$coercePlacement(menuPlacement)), _useState6 = (0, $2qaZZ.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $1oC0p.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $1oC0p.useState)(null), _useState8 = (0, $2qaZZ.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $1oC0p.useCallback)(function() {
        if (!controlElement) return;
        var rect = $3f53451f2f444406$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $iComV.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $1oC0p.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $aWDwM.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $iComV.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $1oC0p.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $3dJ4i.jsx)("div", (0, $c9bqK.default)({
        ref: setMenuPortalElement
    }, $3f53451f2f444406$var$getStyleProps((0, $8jRs5.default)((0, $8jRs5.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $3dJ4i.jsx)($3f53451f2f444406$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $gUjjH.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $3f53451f2f444406$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $3f53451f2f444406$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $3dJ4i.jsx)("div", (0, $c9bqK.default)({}, $3f53451f2f444406$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $3f53451f2f444406$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $8jRs5.default)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $3f53451f2f444406$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $3dJ4i.jsx)("div", (0, $c9bqK.default)({}, $3f53451f2f444406$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $3f53451f2f444406$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $3f53451f2f444406$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $3dJ4i.jsx)("div", (0, $c9bqK.default)({}, $3f53451f2f444406$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $3f53451f2f444406$var$_templateObject;
var $3f53451f2f444406$var$_excluded$2 = [
    "size"
], $3f53451f2f444406$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $3f53451f2f444406$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $3f53451f2f444406$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $3f53451f2f444406$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $gnQ3X.default)(_ref, $3f53451f2f444406$var$_excluded$2);
    return (0, $3dJ4i.jsx)("svg", (0, $c9bqK.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $3f53451f2f444406$var$_ref2
    }, props));
};
var $3f53451f2f444406$var$CrossIcon = function CrossIcon(props) {
    return (0, $3dJ4i.jsx)($3f53451f2f444406$var$Svg, (0, $c9bqK.default)({
        size: 20
    }, props), (0, $3dJ4i.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $3f53451f2f444406$var$DownChevron = function DownChevron(props) {
    return (0, $3dJ4i.jsx)($3f53451f2f444406$var$Svg, (0, $c9bqK.default)({
        size: 20
    }, props), (0, $3dJ4i.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $3f53451f2f444406$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $8jRs5.default)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $3f53451f2f444406$export$f1e1789686576879 = $3f53451f2f444406$var$baseCSS;
var $3f53451f2f444406$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $3dJ4i.jsx)("div", (0, $c9bqK.default)({}, $3f53451f2f444406$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $3dJ4i.jsx)($3f53451f2f444406$var$DownChevron, null));
};
var $3f53451f2f444406$export$407448d2b89b1813 = $3f53451f2f444406$var$baseCSS;
var $3f53451f2f444406$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $3dJ4i.jsx)("div", (0, $c9bqK.default)({}, $3f53451f2f444406$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $3dJ4i.jsx)($3f53451f2f444406$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $3f53451f2f444406$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $8jRs5.default)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $3f53451f2f444406$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $3dJ4i.jsx)("span", (0, $c9bqK.default)({}, innerProps, $3f53451f2f444406$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $3f53451f2f444406$var$loadingDotAnimations = (0, $3dJ4i.keyframes)($3f53451f2f444406$var$_templateObject || ($3f53451f2f444406$var$_templateObject = (0, $hOLdn.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $3f53451f2f444406$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $8jRs5.default)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $3f53451f2f444406$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $3dJ4i.jsx)("span", {
        css: /*#__PURE__*/ (0, $3dJ4i.css)({
            animation: "".concat($3f53451f2f444406$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $3f53451f2f444406$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $gnQ3X.default)(_ref7, $3f53451f2f444406$var$_excluded2);
    return (0, $3dJ4i.jsx)("div", (0, $c9bqK.default)({}, $3f53451f2f444406$var$getStyleProps((0, $8jRs5.default)((0, $8jRs5.default)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $3dJ4i.jsx)($3f53451f2f444406$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $3dJ4i.jsx)($3f53451f2f444406$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $3dJ4i.jsx)($3f53451f2f444406$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $3f53451f2f444406$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $8jRs5.default)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $3f53451f2f444406$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $3dJ4i.jsx)("div", (0, $c9bqK.default)({
        ref: innerRef
    }, $3f53451f2f444406$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $3f53451f2f444406$var$Control$1 = $3f53451f2f444406$var$Control;
var $3f53451f2f444406$var$_excluded$1 = [
    "data"
];
var $3f53451f2f444406$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $3f53451f2f444406$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $3dJ4i.jsx)("div", (0, $c9bqK.default)({}, $3f53451f2f444406$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $3dJ4i.jsx)(Heading, (0, $c9bqK.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $3dJ4i.jsx)("div", null, children));
};
var $3f53451f2f444406$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $8jRs5.default)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $3f53451f2f444406$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $3f53451f2f444406$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $gnQ3X.default)(_cleanCommonProps, $3f53451f2f444406$var$_excluded$1);
    return (0, $3dJ4i.jsx)("div", (0, $c9bqK.default)({}, $3f53451f2f444406$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $3f53451f2f444406$var$Group$1 = $3f53451f2f444406$var$Group;
var $3f53451f2f444406$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $3f53451f2f444406$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $8jRs5.default)((0, $8jRs5.default)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $3f53451f2f444406$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $3f53451f2f444406$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $3f53451f2f444406$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $8jRs5.default)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $3f53451f2f444406$var$spacingStyle)
};
var $3f53451f2f444406$var$inputStyle = function inputStyle(isHidden) {
    return (0, $8jRs5.default)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $3f53451f2f444406$var$spacingStyle);
};
var $3f53451f2f444406$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $3f53451f2f444406$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $gnQ3X.default)(_cleanCommonProps, $3f53451f2f444406$var$_excluded);
    return (0, $3dJ4i.jsx)("div", (0, $c9bqK.default)({}, $3f53451f2f444406$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $3dJ4i.jsx)("input", (0, $c9bqK.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $3f53451f2f444406$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $3f53451f2f444406$var$Input$1 = $3f53451f2f444406$var$Input;
var $3f53451f2f444406$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $8jRs5.default)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $3f53451f2f444406$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $8jRs5.default)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $3f53451f2f444406$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $8jRs5.default)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $3f53451f2f444406$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $3dJ4i.jsx)("div", innerProps, children);
};
var $3f53451f2f444406$var$MultiValueContainer = $3f53451f2f444406$var$MultiValueGeneric;
var $3f53451f2f444406$var$MultiValueLabel = $3f53451f2f444406$var$MultiValueGeneric;
function $3f53451f2f444406$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $3dJ4i.jsx)("div", (0, $c9bqK.default)({
        role: "button"
    }, innerProps), children || (0, $3dJ4i.jsx)($3f53451f2f444406$var$CrossIcon, {
        size: 14
    }));
}
var $3f53451f2f444406$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $3dJ4i.jsx)(Container, {
        data: data,
        innerProps: (0, $8jRs5.default)((0, $8jRs5.default)({}, $3f53451f2f444406$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $3dJ4i.jsx)(Label, {
        data: data,
        innerProps: (0, $8jRs5.default)({}, $3f53451f2f444406$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $3dJ4i.jsx)(Remove, {
        data: data,
        innerProps: (0, $8jRs5.default)((0, $8jRs5.default)({}, $3f53451f2f444406$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $3f53451f2f444406$var$MultiValue$1 = $3f53451f2f444406$var$MultiValue;
var $3f53451f2f444406$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $8jRs5.default)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $3f53451f2f444406$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $3dJ4i.jsx)("div", (0, $c9bqK.default)({}, $3f53451f2f444406$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $3f53451f2f444406$var$Option$1 = $3f53451f2f444406$var$Option;
var $3f53451f2f444406$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $8jRs5.default)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $3f53451f2f444406$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $3dJ4i.jsx)("div", (0, $c9bqK.default)({}, $3f53451f2f444406$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $3f53451f2f444406$var$Placeholder$1 = $3f53451f2f444406$var$Placeholder;
var $3f53451f2f444406$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $8jRs5.default)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $3f53451f2f444406$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $3dJ4i.jsx)("div", (0, $c9bqK.default)({}, $3f53451f2f444406$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $3f53451f2f444406$var$SingleValue$1 = $3f53451f2f444406$var$SingleValue;
var $3f53451f2f444406$export$db3b6bfb95261072 = {
    ClearIndicator: $3f53451f2f444406$var$ClearIndicator,
    Control: $3f53451f2f444406$var$Control$1,
    DropdownIndicator: $3f53451f2f444406$var$DropdownIndicator,
    DownChevron: $3f53451f2f444406$var$DownChevron,
    CrossIcon: $3f53451f2f444406$var$CrossIcon,
    Group: $3f53451f2f444406$var$Group$1,
    GroupHeading: $3f53451f2f444406$var$GroupHeading,
    IndicatorsContainer: $3f53451f2f444406$var$IndicatorsContainer,
    IndicatorSeparator: $3f53451f2f444406$var$IndicatorSeparator,
    Input: $3f53451f2f444406$var$Input$1,
    LoadingIndicator: $3f53451f2f444406$var$LoadingIndicator,
    Menu: $3f53451f2f444406$var$Menu$1,
    MenuList: $3f53451f2f444406$var$MenuList,
    MenuPortal: $3f53451f2f444406$var$MenuPortal,
    LoadingMessage: $3f53451f2f444406$var$LoadingMessage,
    NoOptionsMessage: $3f53451f2f444406$var$NoOptionsMessage,
    MultiValue: $3f53451f2f444406$var$MultiValue$1,
    MultiValueContainer: $3f53451f2f444406$var$MultiValueContainer,
    MultiValueLabel: $3f53451f2f444406$var$MultiValueLabel,
    MultiValueRemove: $3f53451f2f444406$var$MultiValueRemove,
    Option: $3f53451f2f444406$var$Option$1,
    Placeholder: $3f53451f2f444406$var$Placeholder$1,
    SelectContainer: $3f53451f2f444406$var$SelectContainer,
    SingleValue: $3f53451f2f444406$var$SingleValue$1,
    ValueContainer: $3f53451f2f444406$var$ValueContainer
};
var $3f53451f2f444406$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $8jRs5.default)((0, $8jRs5.default)({}, $3f53451f2f444406$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("8jRs5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $60e98f83d791250d$export$2e2bcd8739ae039; });

var $f53LC = parcelRequire("f53LC");
function $60e98f83d791250d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $60e98f83d791250d$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $60e98f83d791250d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $60e98f83d791250d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});

parcelRegister("aWDwM", function(module, exports) {
$parcel$export(module.exports, "autoUpdate", function () { return $7f7dfb8c3ddfdfd9$export$deee3a793edee05f; });

var $8GUHO = parcelRequire("8GUHO");
var $gvLCP = parcelRequire("gvLCP");

var $gvLCP = parcelRequire("gvLCP");

var $3S7gV = parcelRequire("3S7gV");
function $7f7dfb8c3ddfdfd9$var$getCssDimensions(element) {
    const css = (0, $3S7gV.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $3S7gV.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $gvLCP.round)(width) !== offsetWidth || (0, $gvLCP.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $7f7dfb8c3ddfdfd9$var$unwrapElement(element) {
    return !(0, $3S7gV.isElement)(element) ? element.contextElement : element;
}
function $7f7dfb8c3ddfdfd9$var$getScale(element) {
    const domElement = $7f7dfb8c3ddfdfd9$var$unwrapElement(element);
    if (!(0, $3S7gV.isHTMLElement)(domElement)) return (0, $gvLCP.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $7f7dfb8c3ddfdfd9$var$getCssDimensions(domElement);
    let x = ($ ? (0, $gvLCP.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $gvLCP.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $7f7dfb8c3ddfdfd9$var$noOffsets = /*#__PURE__*/ (0, $gvLCP.createCoords)(0);
function $7f7dfb8c3ddfdfd9$var$getVisualOffsets(element) {
    const win = (0, $3S7gV.getWindow)(element);
    if (!(0, $3S7gV.isWebKit)() || !win.visualViewport) return $7f7dfb8c3ddfdfd9$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $7f7dfb8c3ddfdfd9$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $3S7gV.getWindow)(element)) return false;
    return isFixed;
}
function $7f7dfb8c3ddfdfd9$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $7f7dfb8c3ddfdfd9$var$unwrapElement(element);
    let scale = (0, $gvLCP.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $3S7gV.isElement)(offsetParent)) scale = $7f7dfb8c3ddfdfd9$var$getScale(offsetParent);
        } else scale = $7f7dfb8c3ddfdfd9$var$getScale(element);
    }
    const visualOffsets = $7f7dfb8c3ddfdfd9$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $7f7dfb8c3ddfdfd9$var$getVisualOffsets(domElement) : (0, $gvLCP.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $3S7gV.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $3S7gV.isElement)(offsetParent) ? (0, $3S7gV.getWindow)(offsetParent) : offsetParent;
        let currentIFrame = win.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== win){
            const iframeScale = $7f7dfb8c3ddfdfd9$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $3S7gV.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentIFrame = (0, $3S7gV.getWindow)(currentIFrame).frameElement;
        }
    }
    return (0, $gvLCP.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $7f7dfb8c3ddfdfd9$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isOffsetParentAnElement = (0, $3S7gV.isHTMLElement)(offsetParent);
    const documentElement = (0, $3S7gV.getDocumentElement)(offsetParent);
    if (offsetParent === documentElement) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $gvLCP.createCoords)(1);
    const offsets = (0, $gvLCP.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== 'fixed') {
        if ((0, $3S7gV.getNodeName)(offsetParent) !== 'body' || (0, $3S7gV.isOverflowElement)(documentElement)) scroll = (0, $3S7gV.getNodeScroll)(offsetParent);
        if ((0, $3S7gV.isHTMLElement)(offsetParent)) {
            const offsetRect = $7f7dfb8c3ddfdfd9$var$getBoundingClientRect(offsetParent);
            scale = $7f7dfb8c3ddfdfd9$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $7f7dfb8c3ddfdfd9$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $7f7dfb8c3ddfdfd9$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $7f7dfb8c3ddfdfd9$var$getBoundingClientRect((0, $3S7gV.getDocumentElement)(element)).left + (0, $3S7gV.getNodeScroll)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $7f7dfb8c3ddfdfd9$var$getDocumentRect(element) {
    const html = (0, $3S7gV.getDocumentElement)(element);
    const scroll = (0, $3S7gV.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $gvLCP.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $gvLCP.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $7f7dfb8c3ddfdfd9$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $3S7gV.getComputedStyle)(body).direction === 'rtl') x += (0, $gvLCP.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $7f7dfb8c3ddfdfd9$var$getViewportRect(element, strategy) {
    const win = (0, $3S7gV.getWindow)(element);
    const html = (0, $3S7gV.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $3S7gV.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $7f7dfb8c3ddfdfd9$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $7f7dfb8c3ddfdfd9$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $3S7gV.isHTMLElement)(element) ? $7f7dfb8c3ddfdfd9$var$getScale(element) : (0, $gvLCP.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $7f7dfb8c3ddfdfd9$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $7f7dfb8c3ddfdfd9$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $7f7dfb8c3ddfdfd9$var$getDocumentRect((0, $3S7gV.getDocumentElement)(element));
    else if ((0, $3S7gV.isElement)(clippingAncestor)) rect = $7f7dfb8c3ddfdfd9$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $7f7dfb8c3ddfdfd9$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $gvLCP.rectToClientRect)(rect);
}
function $7f7dfb8c3ddfdfd9$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $3S7gV.getParentNode)(element);
    if (parentNode === stopNode || !(0, $3S7gV.isElement)(parentNode) || (0, $3S7gV.isLastTraversableNode)(parentNode)) return false;
    return (0, $3S7gV.getComputedStyle)(parentNode).position === 'fixed' || $7f7dfb8c3ddfdfd9$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $7f7dfb8c3ddfdfd9$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $3S7gV.getOverflowAncestors)(element, [], false).filter((el)=>(0, $3S7gV.isElement)(el) && (0, $3S7gV.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $3S7gV.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $3S7gV.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $3S7gV.isElement)(currentNode) && !(0, $3S7gV.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $3S7gV.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $3S7gV.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $3S7gV.isOverflowElement)(currentNode) && !currentNodeIsContaining && $7f7dfb8c3ddfdfd9$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $3S7gV.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $7f7dfb8c3ddfdfd9$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? $7f7dfb8c3ddfdfd9$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $7f7dfb8c3ddfdfd9$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $gvLCP.max)(rect.top, accRect.top);
        accRect.right = (0, $gvLCP.min)(rect.right, accRect.right);
        accRect.bottom = (0, $gvLCP.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $gvLCP.max)(rect.left, accRect.left);
        return accRect;
    }, $7f7dfb8c3ddfdfd9$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $7f7dfb8c3ddfdfd9$var$getDimensions(element) {
    return $7f7dfb8c3ddfdfd9$var$getCssDimensions(element);
}
function $7f7dfb8c3ddfdfd9$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $3S7gV.isHTMLElement)(offsetParent);
    const documentElement = (0, $3S7gV.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $7f7dfb8c3ddfdfd9$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $gvLCP.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $3S7gV.getNodeName)(offsetParent) !== 'body' || (0, $3S7gV.isOverflowElement)(documentElement)) scroll = (0, $3S7gV.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $7f7dfb8c3ddfdfd9$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $7f7dfb8c3ddfdfd9$var$getWindowScrollBarX(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
function $7f7dfb8c3ddfdfd9$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $3S7gV.isHTMLElement)(element) || (0, $3S7gV.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $7f7dfb8c3ddfdfd9$var$getOffsetParent(element, polyfill) {
    const window = (0, $3S7gV.getWindow)(element);
    if (!(0, $3S7gV.isHTMLElement)(element)) return window;
    let offsetParent = $7f7dfb8c3ddfdfd9$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $3S7gV.isTableElement)(offsetParent) && (0, $3S7gV.getComputedStyle)(offsetParent).position === 'static')offsetParent = $7f7dfb8c3ddfdfd9$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ((0, $3S7gV.getNodeName)(offsetParent) === 'html' || (0, $3S7gV.getNodeName)(offsetParent) === 'body' && (0, $3S7gV.getComputedStyle)(offsetParent).position === 'static' && !(0, $3S7gV.isContainingBlock)(offsetParent))) return window;
    return offsetParent || (0, $3S7gV.getContainingBlock)(element) || window;
}
const $7f7dfb8c3ddfdfd9$var$getElementRects = async function(_ref) {
    let { reference: reference, floating: floating, strategy: strategy } = _ref;
    const getOffsetParentFn = this.getOffsetParent || $7f7dfb8c3ddfdfd9$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    return {
        reference: $7f7dfb8c3ddfdfd9$var$getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
        floating: {
            x: 0,
            y: 0,
            ...await getDimensionsFn(floating)
        }
    };
};
function $7f7dfb8c3ddfdfd9$var$isRTL(element) {
    return (0, $3S7gV.getComputedStyle)(element).direction === 'rtl';
}
const $7f7dfb8c3ddfdfd9$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $7f7dfb8c3ddfdfd9$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $3S7gV.getDocumentElement,
    getClippingRect: $7f7dfb8c3ddfdfd9$var$getClippingRect,
    getOffsetParent: $7f7dfb8c3ddfdfd9$var$getOffsetParent,
    getElementRects: $7f7dfb8c3ddfdfd9$var$getElementRects,
    getClientRects: $7f7dfb8c3ddfdfd9$var$getClientRects,
    getDimensions: $7f7dfb8c3ddfdfd9$var$getDimensions,
    getScale: $7f7dfb8c3ddfdfd9$var$getScale,
    isElement: $3S7gV.isElement,
    isRTL: $7f7dfb8c3ddfdfd9$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $7f7dfb8c3ddfdfd9$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $3S7gV.getDocumentElement)(element);
    function cleanup() {
        clearTimeout(timeoutId);
        io && io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $gvLCP.floor)(top);
        const insetRight = (0, $gvLCP.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $gvLCP.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $gvLCP.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $gvLCP.max)(0, (0, $gvLCP.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $7f7dfb8c3ddfdfd9$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $7f7dfb8c3ddfdfd9$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $3S7gV.getOverflowAncestors)(referenceEl) : [],
        ...(0, $3S7gV.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $7f7dfb8c3ddfdfd9$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    resizeObserver && resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $7f7dfb8c3ddfdfd9$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $7f7dfb8c3ddfdfd9$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo && cleanupIo();
        resizeObserver && resizeObserver.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */ const $7f7dfb8c3ddfdfd9$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $7f7dfb8c3ddfdfd9$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $8GUHO.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("8GUHO", function(module, exports) {
$parcel$export(module.exports, "computePosition", function () { return $653e3b8bd8ae2adc$export$48a53dcb22e581d0; });
$parcel$export(module.exports, "rectToClientRect", function () { return (parcelRequire("gvLCP")).rectToClientRect; });

var $gvLCP = parcelRequire("gvLCP");
function $653e3b8bd8ae2adc$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $gvLCP.getSideAxis)(placement);
    const alignmentAxis = (0, $gvLCP.getAlignmentAxis)(placement);
    const alignLength = (0, $gvLCP.getAxisLength)(alignmentAxis);
    const side = (0, $gvLCP.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $gvLCP.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $653e3b8bd8ae2adc$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $653e3b8bd8ae2adc$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $653e3b8bd8ae2adc$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
            continue;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $653e3b8bd8ae2adc$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $gvLCP.evaluate)(options, state);
    const paddingObject = (0, $gvLCP.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $gvLCP.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        ...rects.floating,
        x: x,
        y: y
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $gvLCP.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $653e3b8bd8ae2adc$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $gvLCP.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $gvLCP.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $gvLCP.getAlignmentAxis)(placement);
            const length = (0, $gvLCP.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $gvLCP.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $gvLCP.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $gvLCP.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $gvLCP.getAlignment)(placement) != null && center != offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $653e3b8bd8ae2adc$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $gvLCP.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $gvLCP.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $gvLCP.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $gvLCP.getAlignment)(placement) === alignment || (autoAlignment ? (0, $gvLCP.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $653e3b8bd8ae2adc$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $gvLCP.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $gvLCP.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $gvLCP.placements) ? $653e3b8bd8ae2adc$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $653e3b8bd8ae2adc$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $gvLCP.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $gvLCP.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $gvLCP.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $gvLCP.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $653e3b8bd8ae2adc$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $gvLCP.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $gvLCP.getSide)(placement);
            const isBasePlacement = (0, $gvLCP.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $gvLCP.getOppositePlacement)(initialPlacement)
            ] : (0, $gvLCP.getExpandedPlacements)(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== 'none') fallbackPlacements.push(...(0, $gvLCP.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $653e3b8bd8ae2adc$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $gvLCP.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $653e3b8bd8ae2adc$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $653e3b8bd8ae2adc$var$isAnySideFullyClipped(overflow) {
    return (0, $gvLCP.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $653e3b8bd8ae2adc$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $gvLCP.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $653e3b8bd8ae2adc$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $653e3b8bd8ae2adc$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $653e3b8bd8ae2adc$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $653e3b8bd8ae2adc$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $653e3b8bd8ae2adc$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $653e3b8bd8ae2adc$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $653e3b8bd8ae2adc$var$getBoundingRect(rects) {
    const minX = (0, $gvLCP.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $gvLCP.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $gvLCP.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $gvLCP.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $653e3b8bd8ae2adc$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $gvLCP.rectToClientRect)($653e3b8bd8ae2adc$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $653e3b8bd8ae2adc$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $gvLCP.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $653e3b8bd8ae2adc$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $gvLCP.rectToClientRect)($653e3b8bd8ae2adc$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $gvLCP.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $gvLCP.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $gvLCP.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $gvLCP.getSide)(placement) === 'left';
                    const maxRight = (0, $gvLCP.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $gvLCP.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $653e3b8bd8ae2adc$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $gvLCP.getSide)(placement);
    const alignment = (0, $gvLCP.getAlignment)(placement);
    const isVertical = (0, $gvLCP.getSideAxis)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $gvLCP.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $653e3b8bd8ae2adc$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            const { x: x, y: y } = state;
            const diffCoords = await $653e3b8bd8ae2adc$var$convertValueToCoords(state, options);
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: diffCoords
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $653e3b8bd8ae2adc$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $gvLCP.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $653e3b8bd8ae2adc$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $gvLCP.getSideAxis)((0, $gvLCP.getSide)(placement));
            const mainAxis = (0, $gvLCP.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $gvLCP.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $gvLCP.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $653e3b8bd8ae2adc$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $gvLCP.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $gvLCP.getSideAxis)(placement);
            const mainAxis = (0, $gvLCP.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $gvLCP.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $gvLCP.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $653e3b8bd8ae2adc$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $gvLCP.evaluate)(options, state);
            const overflow = await $653e3b8bd8ae2adc$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $gvLCP.getSide)(placement);
            const alignment = (0, $gvLCP.getAlignment)(placement);
            const isYAxis = (0, $gvLCP.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const overflowAvailableHeight = height - overflow[heightSide];
            const overflowAvailableWidth = width - overflow[widthSide];
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) {
                const maximumClippingWidth = width - overflow.left - overflow.right;
                availableWidth = alignment || noShift ? (0, $gvLCP.min)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            } else {
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                availableHeight = alignment || noShift ? (0, $gvLCP.min)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            }
            if (noShift && !alignment) {
                const xMin = (0, $gvLCP.max)(overflow.left, 0);
                const xMax = (0, $gvLCP.max)(overflow.right, 0);
                const yMin = (0, $gvLCP.max)(overflow.top, 0);
                const yMax = (0, $gvLCP.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $gvLCP.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $gvLCP.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("gvLCP", function(module, exports) {
$parcel$export(module.exports, "sides", function () { return $c0547bf5653dfd39$export$832b6fa47fa053d2; });
$parcel$export(module.exports, "placements", function () { return $c0547bf5653dfd39$export$803cd8101b6c182b; });
$parcel$export(module.exports, "min", function () { return $c0547bf5653dfd39$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $c0547bf5653dfd39$export$8960430cfd85939f; });
$parcel$export(module.exports, "round", function () { return $c0547bf5653dfd39$export$2077e0241d6afd3c; });
$parcel$export(module.exports, "floor", function () { return $c0547bf5653dfd39$export$a3fe094919f356fd; });
$parcel$export(module.exports, "createCoords", function () { return $c0547bf5653dfd39$export$a397704b5e280835; });
$parcel$export(module.exports, "clamp", function () { return $c0547bf5653dfd39$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "evaluate", function () { return $c0547bf5653dfd39$export$fef61f332f2c0afc; });
$parcel$export(module.exports, "getSide", function () { return $c0547bf5653dfd39$export$3c915306cb7fc97a; });
$parcel$export(module.exports, "getAlignment", function () { return $c0547bf5653dfd39$export$f0989780f32bfcda; });
$parcel$export(module.exports, "getOppositeAxis", function () { return $c0547bf5653dfd39$export$8a000a963141ac32; });
$parcel$export(module.exports, "getAxisLength", function () { return $c0547bf5653dfd39$export$320bd9d53520c68a; });
$parcel$export(module.exports, "getSideAxis", function () { return $c0547bf5653dfd39$export$f28e8f882010718a; });
$parcel$export(module.exports, "getAlignmentAxis", function () { return $c0547bf5653dfd39$export$2b57e0052a6d6d4c; });
$parcel$export(module.exports, "getAlignmentSides", function () { return $c0547bf5653dfd39$export$be42861551f17911; });
$parcel$export(module.exports, "getOppositePlacement", function () { return $c0547bf5653dfd39$export$9c5e28bad23365fa; });
$parcel$export(module.exports, "getExpandedPlacements", function () { return $c0547bf5653dfd39$export$496432a3699e50b1; });
$parcel$export(module.exports, "getOppositeAlignmentPlacement", function () { return $c0547bf5653dfd39$export$2b182c584985588b; });
$parcel$export(module.exports, "getOppositeAxisPlacements", function () { return $c0547bf5653dfd39$export$a9b6fb18fd92c3ec; });
$parcel$export(module.exports, "getPaddingObject", function () { return $c0547bf5653dfd39$export$598c291c29bc2e71; });
$parcel$export(module.exports, "rectToClientRect", function () { return $c0547bf5653dfd39$export$ee05aea0aeecbad4; });
const $c0547bf5653dfd39$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $c0547bf5653dfd39$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $c0547bf5653dfd39$export$803cd8101b6c182b = /*#__PURE__*/ $c0547bf5653dfd39$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $c0547bf5653dfd39$export$27b07d8a310ed8b5[0], side + "-" + $c0547bf5653dfd39$export$27b07d8a310ed8b5[1]), []);
const $c0547bf5653dfd39$export$96ec731ed4dcb222 = Math.min;
const $c0547bf5653dfd39$export$8960430cfd85939f = Math.max;
const $c0547bf5653dfd39$export$2077e0241d6afd3c = Math.round;
const $c0547bf5653dfd39$export$a3fe094919f356fd = Math.floor;
const $c0547bf5653dfd39$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $c0547bf5653dfd39$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $c0547bf5653dfd39$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $c0547bf5653dfd39$export$7d15b64cf5a3a4c4(start, value, end) {
    return $c0547bf5653dfd39$export$8960430cfd85939f(start, $c0547bf5653dfd39$export$96ec731ed4dcb222(value, end));
}
function $c0547bf5653dfd39$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $c0547bf5653dfd39$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $c0547bf5653dfd39$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $c0547bf5653dfd39$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $c0547bf5653dfd39$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $c0547bf5653dfd39$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($c0547bf5653dfd39$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $c0547bf5653dfd39$export$2b57e0052a6d6d4c(placement) {
    return $c0547bf5653dfd39$export$8a000a963141ac32($c0547bf5653dfd39$export$f28e8f882010718a(placement));
}
function $c0547bf5653dfd39$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $c0547bf5653dfd39$export$f0989780f32bfcda(placement);
    const alignmentAxis = $c0547bf5653dfd39$export$2b57e0052a6d6d4c(placement);
    const length = $c0547bf5653dfd39$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $c0547bf5653dfd39$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $c0547bf5653dfd39$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $c0547bf5653dfd39$export$496432a3699e50b1(placement) {
    const oppositePlacement = $c0547bf5653dfd39$export$9c5e28bad23365fa(placement);
    return [
        $c0547bf5653dfd39$export$2b182c584985588b(placement),
        oppositePlacement,
        $c0547bf5653dfd39$export$2b182c584985588b(oppositePlacement)
    ];
}
function $c0547bf5653dfd39$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$c0547bf5653dfd39$var$oppositeAlignmentMap[alignment]);
}
function $c0547bf5653dfd39$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $c0547bf5653dfd39$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $c0547bf5653dfd39$export$f0989780f32bfcda(placement);
    let list = $c0547bf5653dfd39$var$getSideList($c0547bf5653dfd39$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($c0547bf5653dfd39$export$2b182c584985588b));
    }
    return list;
}
function $c0547bf5653dfd39$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$c0547bf5653dfd39$var$oppositeSideMap[side]);
}
function $c0547bf5653dfd39$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $c0547bf5653dfd39$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $c0547bf5653dfd39$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $c0547bf5653dfd39$export$ee05aea0aeecbad4(rect) {
    return {
        ...rect,
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    };
}

});


parcelRegister("3S7gV", function(module, exports) {
$parcel$export(module.exports, "getNodeName", function () { return $2d1c0e53d344b041$export$651544f548703224; });
$parcel$export(module.exports, "getWindow", function () { return $2d1c0e53d344b041$export$38b2d434cce3ea22; });
$parcel$export(module.exports, "getDocumentElement", function () { return $2d1c0e53d344b041$export$e495491855dc5418; });
$parcel$export(module.exports, "isElement", function () { return $2d1c0e53d344b041$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $2d1c0e53d344b041$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isOverflowElement", function () { return $2d1c0e53d344b041$export$989e911fa9af580a; });
$parcel$export(module.exports, "getComputedStyle", function () { return $2d1c0e53d344b041$export$3735103072e4a80; });
$parcel$export(module.exports, "isTableElement", function () { return $2d1c0e53d344b041$export$71535ffaa902797f; });
$parcel$export(module.exports, "isContainingBlock", function () { return $2d1c0e53d344b041$export$d6c4e8150c35fed1; });
$parcel$export(module.exports, "isWebKit", function () { return $2d1c0e53d344b041$export$78551043582a6a98; });
$parcel$export(module.exports, "getContainingBlock", function () { return $2d1c0e53d344b041$export$940d8225183e1404; });
$parcel$export(module.exports, "getParentNode", function () { return $2d1c0e53d344b041$export$4e12058fc4d51d56; });
$parcel$export(module.exports, "isLastTraversableNode", function () { return $2d1c0e53d344b041$export$d1162fb0b6d4cd51; });
$parcel$export(module.exports, "getNodeScroll", function () { return $2d1c0e53d344b041$export$dc8fc79fa2800137; });
$parcel$export(module.exports, "getOverflowAncestors", function () { return $2d1c0e53d344b041$export$3b57c1601291186b; });
function $2d1c0e53d344b041$export$651544f548703224(node) {
    if ($2d1c0e53d344b041$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $2d1c0e53d344b041$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null ? void 0 : (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $2d1c0e53d344b041$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($2d1c0e53d344b041$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $2d1c0e53d344b041$export$8ee0fc9ee280b4ee(value) {
    return value instanceof Node || value instanceof $2d1c0e53d344b041$export$38b2d434cce3ea22(value).Node;
}
function $2d1c0e53d344b041$export$45a5e7f76e0caa8d(value) {
    return value instanceof Element || value instanceof $2d1c0e53d344b041$export$38b2d434cce3ea22(value).Element;
}
function $2d1c0e53d344b041$export$1b3bfaa9684536aa(value) {
    return value instanceof HTMLElement || value instanceof $2d1c0e53d344b041$export$38b2d434cce3ea22(value).HTMLElement;
}
function $2d1c0e53d344b041$export$af51f0f06c0f328a(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $2d1c0e53d344b041$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $2d1c0e53d344b041$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $2d1c0e53d344b041$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $2d1c0e53d344b041$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($2d1c0e53d344b041$export$651544f548703224(element));
}
function $2d1c0e53d344b041$export$d6c4e8150c35fed1(element) {
    const webkit = $2d1c0e53d344b041$export$78551043582a6a98();
    const css = $2d1c0e53d344b041$export$3735103072e4a80(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $2d1c0e53d344b041$export$940d8225183e1404(element) {
    let currentNode = $2d1c0e53d344b041$export$4e12058fc4d51d56(element);
    while($2d1c0e53d344b041$export$1b3bfaa9684536aa(currentNode) && !$2d1c0e53d344b041$export$d1162fb0b6d4cd51(currentNode)){
        if ($2d1c0e53d344b041$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else currentNode = $2d1c0e53d344b041$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $2d1c0e53d344b041$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $2d1c0e53d344b041$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($2d1c0e53d344b041$export$651544f548703224(node));
}
function $2d1c0e53d344b041$export$3735103072e4a80(element) {
    return $2d1c0e53d344b041$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $2d1c0e53d344b041$export$dc8fc79fa2800137(element) {
    if ($2d1c0e53d344b041$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $2d1c0e53d344b041$export$4e12058fc4d51d56(node) {
    if ($2d1c0e53d344b041$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $2d1c0e53d344b041$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $2d1c0e53d344b041$export$e495491855dc5418(node);
    return $2d1c0e53d344b041$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $2d1c0e53d344b041$export$7cd01a57c8ca906c(node) {
    const parentNode = $2d1c0e53d344b041$export$4e12058fc4d51d56(node);
    if ($2d1c0e53d344b041$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($2d1c0e53d344b041$export$1b3bfaa9684536aa(parentNode) && $2d1c0e53d344b041$export$989e911fa9af580a(parentNode)) return parentNode;
    return $2d1c0e53d344b041$export$7cd01a57c8ca906c(parentNode);
}
function $2d1c0e53d344b041$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $2d1c0e53d344b041$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $2d1c0e53d344b041$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $2d1c0e53d344b041$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? $2d1c0e53d344b041$export$3b57c1601291186b(win.frameElement) : []);
    return list.concat(scrollableAncestor, $2d1c0e53d344b041$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}

});


parcelRegister("iComV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d8deadbbe1de4de7$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
var $d8deadbbe1de4de7$export$2e2bcd8739ae039 = (0, $1oC0p.useLayoutEffect);

});


parcelRegister("kKAAc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f1b47b25330ad7ad$export$2e2bcd8739ae039; });

var $er6m6 = parcelRequire("er6m6");

var $c9bqK = parcelRequire("c9bqK");

var $1oC0p = parcelRequire("1oC0p");

var $gtBsz = parcelRequire("gtBsz");

var $9dorK = parcelRequire("9dorK");

var $6g5L6 = parcelRequire("6g5L6");

var $5r4Ts = parcelRequire("5r4Ts");
parcelRequire("8jRs5");
parcelRequire("2qaZZ");
parcelRequire("gnQ3X");
parcelRequire("cTewU");
parcelRequire("avOEA");
parcelRequire("i7dvh");
parcelRequire("bRDUJ");
parcelRequire("lFOXD");

parcelRequire("2zYm4");
parcelRequire("hOLdn");
parcelRequire("f53LC");
parcelRequire("gUjjH");

parcelRequire("iComV");
var $f1b47b25330ad7ad$var$StateManagedSelect = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $er6m6.u)(props);
    return /*#__PURE__*/ $1oC0p.createElement((0, $gtBsz.S), (0, $c9bqK.default)({
        ref: ref
    }, baseSelectProps));
});
var $f1b47b25330ad7ad$export$2e2bcd8739ae039 = $f1b47b25330ad7ad$var$StateManagedSelect;
var $f1b47b25330ad7ad$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $1oC0p.useMemo)(function() {
        return (0, $6g5L6.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $1oC0p.createElement((0, $9dorK.C), {
        value: emotionCache
    }, children);
};

});
parcelRegister("er6m6", function(module, exports) {
$parcel$export(module.exports, "u", function () { return $a82884632b499a4d$export$3b14a55fb2447963; });

var $8jRs5 = parcelRequire("8jRs5");

var $2qaZZ = parcelRequire("2qaZZ");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");
var $a82884632b499a4d$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $a82884632b499a4d$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $gnQ3X.default)(_ref, $a82884632b499a4d$var$_excluded);
    var _useState = (0, $1oC0p.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $2qaZZ.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $2qaZZ.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $1oC0p.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $2qaZZ.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $1oC0p.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $1oC0p.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $1oC0p.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $1oC0p.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $8jRs5.default)((0, $8jRs5.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});

parcelRegister("gtBsz", function(module, exports) {
$parcel$export(module.exports, "b", function () { return $bfec698145095c09$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "g", function () { return $bfec698145095c09$export$39b482c5e57630a8; });
$parcel$export(module.exports, "m", function () { return $bfec698145095c09$export$953cecd6e717a553; });
$parcel$export(module.exports, "S", function () { return $bfec698145095c09$export$25ce5a424b770e84; });

var $c9bqK = parcelRequire("c9bqK");

var $8jRs5 = parcelRequire("8jRs5");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $i7dvh = parcelRequire("i7dvh");

var $bRDUJ = parcelRequire("bRDUJ");

var $lFOXD = parcelRequire("lFOXD");

var $1oC0p = parcelRequire("1oC0p");

var $5r4Ts = parcelRequire("5r4Ts");

var $3dJ4i = parcelRequire("3dJ4i");

var $dWJ7u = parcelRequire("dWJ7u");

var $gnQ3X = parcelRequire("gnQ3X");
function $bfec698145095c09$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $bfec698145095c09$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $bfec698145095c09$var$A11yText = function A11yText(props) {
    return (0, $3dJ4i.jsx)("span", (0, $c9bqK.default)({
        css: $bfec698145095c09$var$_ref
    }, props));
};
var $bfec698145095c09$var$A11yText$1 = $bfec698145095c09$var$A11yText;
var $bfec698145095c09$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu') {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? 'selected' : 'focused').concat(disabled);
            return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $bfec698145095c09$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $1oC0p.useMemo)(function() {
        return (0, $8jRs5.default)((0, $8jRs5.default)({}, $bfec698145095c09$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $1oC0p.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $8jRs5.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $1oC0p.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue
    ]);
    var ariaResults = (0, $1oC0p.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus
    ]);
    var ariaGuidance = (0, $1oC0p.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue
    ]);
    var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
    var ScreenReaderText = (0, $3dJ4i.jsx)((0, $1oC0p.Fragment), null, (0, $3dJ4i.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $3dJ4i.jsx)("span", {
        id: "aria-context"
    }, ariaContext));
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    return (0, $3dJ4i.jsx)((0, $1oC0p.Fragment), null, (0, $3dJ4i.jsx)($bfec698145095c09$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $3dJ4i.jsx)($bfec698145095c09$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $bfec698145095c09$var$LiveRegion$1 = $bfec698145095c09$var$LiveRegion;
var $bfec698145095c09$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $bfec698145095c09$var$anyDiacritic = new RegExp('[' + $bfec698145095c09$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $bfec698145095c09$var$diacriticToBase = {};
for(var $bfec698145095c09$var$i = 0; $bfec698145095c09$var$i < $bfec698145095c09$var$diacritics.length; $bfec698145095c09$var$i++){
    var $bfec698145095c09$var$diacritic = $bfec698145095c09$var$diacritics[$bfec698145095c09$var$i];
    for(var $bfec698145095c09$var$j = 0; $bfec698145095c09$var$j < $bfec698145095c09$var$diacritic.letters.length; $bfec698145095c09$var$j++)$bfec698145095c09$var$diacriticToBase[$bfec698145095c09$var$diacritic.letters[$bfec698145095c09$var$j]] = $bfec698145095c09$var$diacritic.base;
}
var $bfec698145095c09$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($bfec698145095c09$var$anyDiacritic, function(match) {
        return $bfec698145095c09$var$diacriticToBase[match];
    });
};
var $bfec698145095c09$var$memoizedStripDiacriticsForInput = (0, $dWJ7u.default)($bfec698145095c09$var$stripDiacritics);
var $bfec698145095c09$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $bfec698145095c09$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $bfec698145095c09$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $8jRs5.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $bfec698145095c09$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $bfec698145095c09$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $bfec698145095c09$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $bfec698145095c09$var$memoizedStripDiacriticsForInput(input);
            candidate = $bfec698145095c09$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $bfec698145095c09$var$_excluded = [
    "innerRef"
];
function $bfec698145095c09$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $gnQ3X.default)(_ref, $bfec698145095c09$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $5r4Ts.r)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $3dJ4i.jsx)("input", (0, $c9bqK.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $3dJ4i.css)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $bfec698145095c09$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $bfec698145095c09$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $1oC0p.useRef)(false);
    var isTop = (0, $1oC0p.useRef)(false);
    var touchStart = (0, $1oC0p.useRef)(0);
    var scrollTarget = (0, $1oC0p.useRef)(null);
    var handleEventDelta = (0, $1oC0p.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $bfec698145095c09$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $1oC0p.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $1oC0p.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $1oC0p.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $1oC0p.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $5r4Ts.s) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $1oC0p.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $1oC0p.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $bfec698145095c09$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $bfec698145095c09$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $bfec698145095c09$var$preventTouchMove(e) {
    e.preventDefault();
}
function $bfec698145095c09$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $bfec698145095c09$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $bfec698145095c09$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $bfec698145095c09$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $bfec698145095c09$var$activeScrollLocks = 0;
var $bfec698145095c09$var$listenerOptions = {
    capture: false,
    passive: false
};
function $bfec698145095c09$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $1oC0p.useRef)({});
    var scrollTarget = (0, $1oC0p.useRef)(null);
    var addScrollLock = (0, $1oC0p.useCallback)(function(touchScrollTarget) {
        if (!$bfec698145095c09$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $bfec698145095c09$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $bfec698145095c09$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($bfec698145095c09$var$LOCK_STYLES).forEach(function(key) {
                var val = $bfec698145095c09$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $bfec698145095c09$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $bfec698145095c09$var$preventTouchMove, $bfec698145095c09$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $bfec698145095c09$var$preventInertiaScroll, $bfec698145095c09$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $bfec698145095c09$var$allowTouchMove, $bfec698145095c09$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $bfec698145095c09$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $1oC0p.useCallback)(function(touchScrollTarget) {
        if (!$bfec698145095c09$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $bfec698145095c09$var$activeScrollLocks = Math.max($bfec698145095c09$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $bfec698145095c09$var$activeScrollLocks < 1) $bfec698145095c09$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $bfec698145095c09$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $bfec698145095c09$var$preventTouchMove, $bfec698145095c09$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $bfec698145095c09$var$preventInertiaScroll, $bfec698145095c09$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $bfec698145095c09$var$allowTouchMove, $bfec698145095c09$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $1oC0p.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $bfec698145095c09$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $bfec698145095c09$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $bfec698145095c09$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $bfec698145095c09$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $bfec698145095c09$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $bfec698145095c09$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $3dJ4i.jsx)((0, $1oC0p.Fragment), null, lockEnabled && (0, $3dJ4i.jsx)("div", {
        onClick: $bfec698145095c09$var$blurSelectInput,
        css: $bfec698145095c09$var$_ref2$1
    }), children(targetRef));
}
function $bfec698145095c09$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $bfec698145095c09$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $bfec698145095c09$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $3dJ4i.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $bfec698145095c09$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $bfec698145095c09$var$RequiredInput$1 = $bfec698145095c09$var$RequiredInput;
var $bfec698145095c09$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $bfec698145095c09$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $bfec698145095c09$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $bfec698145095c09$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $bfec698145095c09$var$defaultStyles = {
    clearIndicator: (0, $5r4Ts.a),
    container: (0, $5r4Ts.b),
    control: (0, $5r4Ts.d),
    dropdownIndicator: (0, $5r4Ts.e),
    group: (0, $5r4Ts.g),
    groupHeading: (0, $5r4Ts.f),
    indicatorsContainer: (0, $5r4Ts.i),
    indicatorSeparator: (0, $5r4Ts.h),
    input: (0, $5r4Ts.j),
    loadingIndicator: (0, $5r4Ts.l),
    loadingMessage: (0, $5r4Ts.k),
    menu: (0, $5r4Ts.m),
    menuList: (0, $5r4Ts.n),
    menuPortal: (0, $5r4Ts.o),
    multiValue: (0, $5r4Ts.p),
    multiValueLabel: (0, $5r4Ts.q),
    multiValueRemove: (0, $5r4Ts.t),
    noOptionsMessage: (0, $5r4Ts.u),
    option: (0, $5r4Ts.v),
    placeholder: (0, $5r4Ts.w),
    singleValue: (0, $5r4Ts.x),
    valueContainer: (0, $5r4Ts.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $bfec698145095c09$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $8jRs5.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $bfec698145095c09$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $bfec698145095c09$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $bfec698145095c09$var$baseUnit = 4;
// The minimum height of the control
var $bfec698145095c09$var$controlHeight = 38;
// The amount of space between the control and menu */
var $bfec698145095c09$var$menuGutter = $bfec698145095c09$var$baseUnit * 2;
var $bfec698145095c09$var$spacing = {
    baseUnit: $bfec698145095c09$var$baseUnit,
    controlHeight: $bfec698145095c09$var$controlHeight,
    menuGutter: $bfec698145095c09$var$menuGutter
};
var $bfec698145095c09$export$4368d992c4eafac0 = {
    borderRadius: $bfec698145095c09$var$borderRadius,
    colors: $bfec698145095c09$var$colors,
    spacing: $bfec698145095c09$var$spacing
};
var $bfec698145095c09$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $5r4Ts.z)(),
    captureMenuScroll: !(0, $5r4Ts.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $bfec698145095c09$export$db3b6bfb95261072(),
    formatGroupLabel: $bfec698145095c09$var$formatGroupLabel,
    getOptionLabel: $bfec698145095c09$export$8b22cf2602fb60ce,
    getOptionValue: $bfec698145095c09$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $bfec698145095c09$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $5r4Ts.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $bfec698145095c09$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $bfec698145095c09$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $bfec698145095c09$var$_isOptionSelected(props, option, selectValue);
    var label = $bfec698145095c09$var$getOptionLabel(props, option);
    var value = $bfec698145095c09$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $bfec698145095c09$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $bfec698145095c09$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $bfec698145095c09$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $bfec698145095c09$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $bfec698145095c09$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $5r4Ts.K));
}
function $bfec698145095c09$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $lFOXD.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $bfec698145095c09$var$buildFocusableOptions(props, selectValue) {
    return $bfec698145095c09$var$buildFocusableOptionsFromCategorizedOptions($bfec698145095c09$var$buildCategorizedOptions(props, selectValue));
}
function $bfec698145095c09$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$bfec698145095c09$var$shouldHideSelectedOptions(props) || !isSelected) && $bfec698145095c09$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $bfec698145095c09$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $bfec698145095c09$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $bfec698145095c09$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $bfec698145095c09$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $bfec698145095c09$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $bfec698145095c09$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $bfec698145095c09$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $bfec698145095c09$var$getOptionValue(props, i) === candidate;
    });
}
function $bfec698145095c09$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $bfec698145095c09$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $bfec698145095c09$var$instanceId = 1;
var $bfec698145095c09$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $i7dvh.default)(Select, _Component);
    var _super = (0, $bRDUJ.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $cTewU.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.instancePrefix = '';
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $5r4Ts.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $5r4Ts.B)([].concat((0, $lFOXD.default)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $5r4Ts.C)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $5r4Ts.C)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $5r4Ts.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $5r4Ts.D)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $5r4Ts.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $5r4Ts.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $bfec698145095c09$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $bfec698145095c09$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $bfec698145095c09$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $5r4Ts.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $bfec698145095c09$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $bfec698145095c09$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $8jRs5.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $5r4Ts.G)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $bfec698145095c09$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$bfec698145095c09$var$instanceId);
        _this.state.selectValue = (0, $5r4Ts.H)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusedOption = focusableOptions[optionIndex];
        }
        return _this;
    }
    (0, $avOEA.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $5r4Ts.I)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $5r4Ts.I)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex]
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $bfec698145095c09$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($bfec698145095c09$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $8jRs5.default)((0, $8jRs5.default)({}, $bfec698145095c09$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $bfec698145095c09$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $bfec698145095c09$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $bfec698145095c09$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $8jRs5.default)((0, $8jRs5.default)((0, $8jRs5.default)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox'
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox'),
                    'aria-owns': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $1oC0p.createElement($bfec698145095c09$var$DummyInput, (0, $c9bqK.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $5r4Ts.J),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $1oC0p.createElement(Input, (0, $c9bqK.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $1oC0p.createElement(Placeholder, (0, $c9bqK.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $1oC0p.createElement(MultiValue, (0, $c9bqK.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $1oC0p.createElement(SingleValue, (0, $c9bqK.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $1oC0p.createElement(ClearIndicator, (0, $c9bqK.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $1oC0p.createElement(LoadingIndicator, (0, $c9bqK.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $1oC0p.createElement(IndicatorSeparator, (0, $c9bqK.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $1oC0p.createElement(DropdownIndicator, (0, $c9bqK.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    };
                    return /*#__PURE__*/ $1oC0p.createElement(Option, (0, $c9bqK.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $1oC0p.createElement(Group, (0, $c9bqK.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $1oC0p.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $1oC0p.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $1oC0p.createElement((0, $5r4Ts.M), (0, $c9bqK.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $1oC0p.createElement(Menu, (0, $c9bqK.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove,
                            id: _this4.getElementId('listbox')
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $1oC0p.createElement($bfec698145095c09$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $1oC0p.createElement(MenuList, (0, $c9bqK.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $1oC0p.createElement(MenuPortal, (0, $c9bqK.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $1oC0p.createElement($bfec698145095c09$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $1oC0p.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $1oC0p.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $1oC0p.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $1oC0p.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $1oC0p.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $1oC0p.createElement($bfec698145095c09$var$LiveRegion$1, (0, $c9bqK.default)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $1oC0p.createElement(SelectContainer, (0, $c9bqK.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $1oC0p.createElement(Control, (0, $c9bqK.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $1oC0p.createElement(ValueContainer, (0, $c9bqK.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $1oC0p.createElement(IndicatorsContainer, (0, $c9bqK.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $5r4Ts.H)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $bfec698145095c09$var$buildFocusableOptions(props, selectValue) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $bfec698145095c09$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $bfec698145095c09$var$getNextFocusedOption(state, focusableOptions);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $5r4Ts.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $8jRs5.default)((0, $8jRs5.default)((0, $8jRs5.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $1oC0p.Component));
$bfec698145095c09$export$25ce5a424b770e84.defaultProps = $bfec698145095c09$export$407448d2b89b1813;

});
parcelRegister("bRDUJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8a339b0ed215adc4$export$2e2bcd8739ae039; });

var $jlBwm = parcelRequire("jlBwm");

var $8lpIP = parcelRequire("8lpIP");

var $i3Ugd = parcelRequire("i3Ugd");
function $8a339b0ed215adc4$export$2e2bcd8739ae039(t) {
    var r = (0, $8lpIP.default)();
    return function() {
        var e, o = (0, $jlBwm.default)(t);
        if (r) {
            var s = (0, $jlBwm.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $i3Ugd.default)(this, e);
    };
}

});



parcelRegister("kMnBu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f20a9984ad8b511a$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $f53LC = parcelRequire("f53LC");

var $gnQ3X = parcelRequire("gnQ3X");

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $gAD0i = parcelRequire("gAD0i");

var $4G4vL = parcelRequire("4G4vL");

var $9eBsh = parcelRequire("9eBsh");

var $gfKh0 = parcelRequire("gfKh0");

var $4O9wP = parcelRequire("4O9wP");

var $jfMva = parcelRequire("jfMva");

var $g9ZlO = parcelRequire("g9ZlO");

var $3AD7Y = parcelRequire("3AD7Y");

var $hnR5n = parcelRequire("hnR5n");

var $aS3sB = parcelRequire("aS3sB");

var $aey2F = parcelRequire("aey2F");

var $eY2pT = parcelRequire("eY2pT");

var $9go2L = parcelRequire("9go2L");

var $ce0eK = parcelRequire("ce0eK");
var $f20a9984ad8b511a$var$_excluded = [
    "ref",
    "aria-controls",
    "aria-expanded",
    "aria-haspopup"
];
function $f20a9984ad8b511a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f20a9984ad8b511a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f20a9984ad8b511a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f20a9984ad8b511a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f20a9984ad8b511a$var$gridSize = (0, $hnR5n.gridSize)();
var $f20a9984ad8b511a$var$MAX_HEIGHT = "calc(100vh - ".concat($f20a9984ad8b511a$var$gridSize * 2, "px)");
var $f20a9984ad8b511a$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
var $f20a9984ad8b511a$var$getFallbackPlacements = function getFallbackPlacements(placement) {
    var placementPieces = placement.split('-');
    var mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        var crossAxis = placementPieces[1];
        return [
            "".concat(mainAxis),
            "".concat(mainAxis, "-").concat($f20a9984ad8b511a$var$opposites[crossAxis]),
            "".concat($f20a9984ad8b511a$var$opposites[mainAxis], "-").concat(crossAxis),
            "".concat($f20a9984ad8b511a$var$opposites[mainAxis]),
            "".concat($f20a9984ad8b511a$var$opposites[mainAxis], "-").concat($f20a9984ad8b511a$var$opposites[crossAxis]),
            'auto'
        ];
    } else return [
        "".concat(mainAxis, "-start"),
        "".concat(mainAxis, "-end"),
        "".concat($f20a9984ad8b511a$var$opposites[mainAxis]),
        "".concat($f20a9984ad8b511a$var$opposites[mainAxis], "-start"),
        "".concat($f20a9984ad8b511a$var$opposites[mainAxis], "-end"),
        "auto"
    ];
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ var $f20a9984ad8b511a$var$DropdownMenu = function DropdownMenu(_ref) {
    var _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, children = _ref.children, _ref$defaultOpen = _ref.defaultOpen, defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isOpen = _ref.isOpen, _ref$onOpenChange = _ref.onOpenChange, onOpenChange = _ref$onOpenChange === void 0 ? (0, $gfKh0.default) : _ref$onOpenChange, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$shouldRenderToPa = _ref.shouldRenderToParent, shouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, spacing = _ref.spacing, statusLabel = _ref.statusLabel, testId = _ref.testId, _trigger = _ref.trigger, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? (0, $hnR5n.layers).modal() : _ref$zIndex, label = _ref.label;
    var _useControlledState = (0, $4O9wP.default)(isOpen, function() {
        return defaultOpen;
    }), _useControlledState2 = (0, $2qaZZ.default)(_useControlledState, 2), isLocalOpen = _useControlledState2[0], setLocalIsOpen = _useControlledState2[1];
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $2qaZZ.default)(_useState, 2), isTriggeredUsingKeyboard = _useState2[0], setTriggeredUsingKeyboard = _useState2[1];
    var id = (0, $ce0eK.default)();
    var itemRef = (0, $9go2L.default)();
    var fallbackPlacements = (0, $1oC0p.useMemo)(function() {
        return $f20a9984ad8b511a$var$getFallbackPlacements(placement);
    }, [
        placement
    ]);
    var handleTriggerClicked = (0, $1oC0p.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    function(event) {
        var newValue = !isLocalOpen;
        var clientX = event.clientX, clientY = event.clientY, type = event.type, detail = event.detail;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            var _itemRef$current;
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef === null || itemRef === void 0 || (_itemRef$current = itemRef.current) === null || _itemRef$current === void 0 || _itemRef$current.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        isLocalOpen,
        setLocalIsOpen
    ]);
    var handleOnClose = (0, $1oC0p.useCallback)(function(event) {
        var _event$target, _event$target$closest;
        if (event.key !== 'Escape' && event.key !== 'Tab' && (_event$target = event.target) !== null && _event$target !== void 0 && (_event$target$closest = _event$target.closest) !== null && _event$target$closest !== void 0 && _event$target$closest.call(_event$target, "[id^=".concat((0, $ce0eK.PREFIX), "] [aria-haspopup]"))) // Check if it is within dropdown and it is a trigger button
        // if it is a nested dropdown, clicking trigger won't close the dropdown
        // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
        return;
        if (event.key === 'Tab' && event.shiftKey || event.key === 'Escape') requestAnimationFrame(function() {
            var _itemRef$current2;
            (_itemRef$current2 = itemRef.current) === null || _itemRef$current2 === void 0 || _itemRef$current2.focus();
        });
        var newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        onOpenChange,
        setLocalIsOpen,
        itemRef
    ]);
    var _useFocus = (0, $jfMva.default)(), isFocused = _useFocus.isFocused, bindFocus = _useFocus.bindFocus;
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $1oC0p.useEffect)(function() {
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $gfKh0.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $gfKh0.default;
        return (0, $dH1HR.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                var isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest("[id^=".concat((0, $ce0eK.PREFIX), "] [aria-haspopup]"));
                if (e.key === (0, $4G4vL.KEY_DOWN) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $4G4vL.KEY_SPACE) || e.key === (0, $4G4vL.KEY_ENTER)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $4G4vL.KEY_TAB) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eY2pT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3AD7Y.default), {
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        testId: testId && "".concat(testId, "--content"),
        shouldUseCaptureOnOutsideClick: true,
        shouldRenderToParent: shouldRenderToParent,
        shouldDisableFocusLock: true,
        trigger: function trigger(_ref2) {
            var ref = _ref2.ref, ariaControls = _ref2['aria-controls'], ariaExpanded = _ref2['aria-expanded'], ariaHasPopup = _ref2['aria-haspopup'], rest = (0, $gnQ3X.default)(_ref2, $f20a9984ad8b511a$var$_excluded);
            if (typeof _trigger === 'function') return _trigger($f20a9984ad8b511a$var$_objectSpread($f20a9984ad8b511a$var$_objectSpread($f20a9984ad8b511a$var$_objectSpread({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup
            }, rest), bindFocus), {}, {
                triggerRef: (0, $9eBsh.default)([
                    ref,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger")
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $gAD0i.default), (0, $c9bqK.default)({}, bindFocus, {
                ref: (0, $9eBsh.default)([
                    ref,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($g9ZlO))),
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger"),
                "aria-label": label
            }), _trigger);
        },
        content: function content(_ref3) {
            var setInitialFocusRef = _ref3.setInitialFocusRef, update = _ref3.update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $aS3sB.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $aey2F.default), {
                spacing: spacing,
                maxHeight: $f20a9984ad8b511a$var$MAX_HEIGHT,
                maxWidth: 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && "".concat(testId, "--menu-wrapper")
            }, children));
        }
    }));
};
var $f20a9984ad8b511a$export$2e2bcd8739ae039 = $f20a9984ad8b511a$var$DropdownMenu;

});
parcelRegister("gAD0i", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c13e437c18ea2923$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $hsWf8 = parcelRequire("hsWf8");

var $f1cZ8 = parcelRequire("f1cZ8");
var $c13e437c18ea2923$var$_excluded = [
    "analyticsContext",
    "interactionName",
    "autoFocus",
    "appearance",
    "spacing",
    "isDisabled",
    "isSelected",
    "iconBefore",
    "isLoading",
    "UNSAFE_iconAfter_size",
    "iconAfter",
    "UNSAFE_iconBefore_size",
    "children",
    "shouldFitContainer",
    "overlay",
    "onClick",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onTouchStartCapture",
    "onTouchEndCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onClickCapture",
    "type",
    "testId"
];
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $c13e437c18ea2923$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, interactionName = _ref.interactionName, autoFocus = _ref.autoFocus, appearance = _ref.appearance, spacing = _ref.spacing, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, iconBefore = _ref.iconBefore, isLoading = _ref.isLoading, UNSAFE_iconAfter_size = _ref.UNSAFE_iconAfter_size, iconAfter = _ref.iconAfter, UNSAFE_iconBefore_size = _ref.UNSAFE_iconBefore_size, children = _ref.children, shouldFitContainer = _ref.shouldFitContainer, overlay = _ref.overlay, onClick = _ref.onClick, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, testId = _ref.testId, rest = (0, $gnQ3X.default)(_ref, $c13e437c18ea2923$var$_excluded);
    var baseProps = (0, $f1cZ8.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: 'button',
        children: children,
        iconBefore: iconBefore,
        UNSAFE_iconBefore_size: UNSAFE_iconBefore_size,
        iconAfter: iconAfter,
        UNSAFE_iconAfter_size: UNSAFE_iconAfter_size,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isSelected: isSelected,
        isLoading: isLoading,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        overlay: overlay,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $hsWf8.default), (0, $c9bqK.default)({}, rest, {
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        isDisabled: baseProps.isDisabled,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        type: type,
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "Button"
    }), baseProps.children);
}));
$c13e437c18ea2923$var$Button.displayName = 'Button';
var $c13e437c18ea2923$export$2e2bcd8739ae039 = $c13e437c18ea2923$var$Button;

});
parcelRegister("hsWf8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cb723b10f7ff5ada$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $lFOXD = parcelRequire("lFOXD");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $gJJny = parcelRequire("gJJny");

var $gfKh0 = parcelRequire("gfKh0");

var $jFYu8 = parcelRequire("jFYu8");

var $9ZNh9 = parcelRequire("9ZNh9");

var $4GEEE = parcelRequire("4GEEE");
var $cb723b10f7ff5ada$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "testId",
    "xcss",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext"
];
// TODO: Duplicated FocusRing styles due to lack of `xcss` support
// and to prevent additional dependency
var $cb723b10f7ff5ada$var$baseFocusRingStyles = {
    outlineColor: 'color.border.focused',
    outlineWidth: 'border.width.outline',
    outlineStyle: 'solid',
    outlineOffset: 'space.025'
};
var $cb723b10f7ff5ada$var$focusRingStyles = (0, $9ZNh9.xcss)({
    ':focus-visible': $cb723b10f7ff5ada$var$baseFocusRingStyles,
    '@supports not selector(*:focus-visible)': {
        ':focus': $cb723b10f7ff5ada$var$baseFocusRingStyles
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        ':focus-visible': {
            outline: '1px solid'
        }
    }
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $cb723b10f7ff5ada$var$Pressable = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, testId = _ref.testId, xcssStyles = _ref.xcss, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $gfKh0.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, htmlAttributes = (0, $gnQ3X.default)(_ref, $cb723b10f7ff5ada$var$_excluded);
    var interactionContext = (0, $1oC0p.useContext)((0, $jFYu8.default));
    var handleClick = (0, $1oC0p.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $gJJny.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "6.5.0",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // Combine default styles with supplied styles. XCSS does not support deep nested arrays
    var styles = [
        (0, $9ZNh9.xcss)({
            cursor: isDisabled ? 'not-allowed' : 'pointer'
        }),
        $cb723b10f7ff5ada$var$focusRingStyles
    ];
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    styles = Array.isArray(xcssStyles) ? [].concat((0, $lFOXD.default)(styles), (0, $lFOXD.default)(xcssStyles)) : [].concat((0, $lFOXD.default)(styles), [
        xcssStyles
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4GEEE.default), (0, $c9bqK.default)({}, htmlAttributes, {
        as: "button",
        ref: ref,
        testId: testId,
        type: type,
        onClick: onClick,
        backgroundColor: backgroundColor,
        padding: padding,
        paddingBlock: paddingBlock,
        paddingBlockStart: paddingBlockStart,
        paddingBlockEnd: paddingBlockEnd,
        paddingInline: paddingInline,
        paddingInlineStart: paddingInlineStart,
        paddingInlineEnd: paddingInlineEnd,
        xcss: styles,
        disabled: isDisabled
    }), children);
});
var $cb723b10f7ff5ada$export$2e2bcd8739ae039 = $cb723b10f7ff5ada$var$Pressable;

});
parcelRegister("jFYu8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e530c3bce111ed47$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
var $e530c3bce111ed47$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});

parcelRegister("9ZNh9", function(module, exports) {
$parcel$export(module.exports, "parseXcss", function () { return $747008afad88328a$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $747008afad88328a$export$f6c783d06584602c; });

var $lFOXD = parcelRequire("lFOXD");

var $f53LC = parcelRequire("f53LC");

var $2qaZZ = parcelRequire("2qaZZ");

var $2zYm4 = parcelRequire("2zYm4");

var $3dJ4i = parcelRequire("3dJ4i");

var $hAt2G = parcelRequire("hAt2G");

var $7t0tI = parcelRequire("7t0tI");
function $747008afad88328a$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $747008afad88328a$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $747008afad88328a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $747008afad88328a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $747008afad88328a$var$_arrayLikeToArray(o, minLen);
}
function $747008afad88328a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $747008afad88328a$export$9a199fbafee0014e = {
    backgroundColor: (0, $hAt2G.backgroundColorMap),
    blockSize: (0, $hAt2G.dimensionMap),
    borderBlockColor: (0, $hAt2G.borderColorMap),
    borderBlockEndColor: (0, $hAt2G.borderColorMap),
    borderBlockEndWidth: (0, $hAt2G.borderWidthMap),
    borderBlockStartColor: (0, $hAt2G.borderColorMap),
    borderBlockStartWidth: (0, $hAt2G.borderWidthMap),
    borderBlockWidth: (0, $hAt2G.borderWidthMap),
    borderBottomColor: (0, $hAt2G.borderColorMap),
    borderBottomLeftRadius: (0, $hAt2G.borderRadiusMap),
    borderBottomRightRadius: (0, $hAt2G.borderRadiusMap),
    borderBottomWidth: (0, $hAt2G.borderWidthMap),
    borderColor: (0, $hAt2G.borderColorMap),
    borderEndEndRadius: (0, $hAt2G.borderRadiusMap),
    borderEndStartRadius: (0, $hAt2G.borderRadiusMap),
    borderInlineColor: (0, $hAt2G.borderColorMap),
    borderInlineEndColor: (0, $hAt2G.borderColorMap),
    borderInlineEndWidth: (0, $hAt2G.borderWidthMap),
    borderInlineStartColor: (0, $hAt2G.borderColorMap),
    borderInlineStartWidth: (0, $hAt2G.borderWidthMap),
    borderInlineWidth: (0, $hAt2G.borderWidthMap),
    borderLeftColor: (0, $hAt2G.borderColorMap),
    borderLeftWidth: (0, $hAt2G.borderWidthMap),
    borderRadius: (0, $hAt2G.borderRadiusMap),
    borderRightColor: (0, $hAt2G.borderColorMap),
    borderRightWidth: (0, $hAt2G.borderWidthMap),
    borderStartEndRadius: (0, $hAt2G.borderRadiusMap),
    borderStartStartRadius: (0, $hAt2G.borderRadiusMap),
    borderTopColor: (0, $hAt2G.borderColorMap),
    borderTopLeftRadius: (0, $hAt2G.borderRadiusMap),
    borderTopRightRadius: (0, $hAt2G.borderRadiusMap),
    borderTopWidth: (0, $hAt2G.borderWidthMap),
    borderWidth: (0, $hAt2G.borderWidthMap),
    bottom: (0, $hAt2G.allSpaceMap),
    boxShadow: (0, $hAt2G.shadowMap),
    color: (0, $hAt2G.textColorMap),
    columnGap: (0, $hAt2G.positiveSpaceMap),
    gap: (0, $hAt2G.positiveSpaceMap),
    height: (0, $hAt2G.dimensionMap),
    inlineSize: (0, $hAt2G.dimensionMap),
    inset: (0, $hAt2G.allSpaceMap),
    insetBlock: (0, $hAt2G.allSpaceMap),
    insetBlockEnd: (0, $hAt2G.allSpaceMap),
    insetBlockStart: (0, $hAt2G.allSpaceMap),
    insetInline: (0, $hAt2G.allSpaceMap),
    insetInlineEnd: (0, $hAt2G.allSpaceMap),
    insetInlineStart: (0, $hAt2G.allSpaceMap),
    left: (0, $hAt2G.allSpaceMap),
    margin: (0, $hAt2G.allSpaceMap),
    marginBlock: (0, $hAt2G.allSpaceMap),
    marginBlockEnd: (0, $hAt2G.allSpaceMap),
    marginBlockStart: (0, $hAt2G.allSpaceMap),
    marginBottom: (0, $hAt2G.allSpaceMap),
    marginInline: (0, $hAt2G.allSpaceMap),
    marginInlineEnd: (0, $hAt2G.allSpaceMap),
    marginInlineStart: (0, $hAt2G.allSpaceMap),
    marginLeft: (0, $hAt2G.allSpaceMap),
    marginRight: (0, $hAt2G.allSpaceMap),
    marginTop: (0, $hAt2G.allSpaceMap),
    maxBlockSize: (0, $hAt2G.dimensionMap),
    maxHeight: (0, $hAt2G.dimensionMap),
    maxInlineSize: (0, $hAt2G.dimensionMap),
    maxWidth: (0, $hAt2G.dimensionMap),
    minBlockSize: (0, $hAt2G.dimensionMap),
    minHeight: (0, $hAt2G.dimensionMap),
    minInlineSize: (0, $hAt2G.dimensionMap),
    minWidth: (0, $hAt2G.dimensionMap),
    opacity: (0, $hAt2G.opacityMap),
    outlineColor: (0, $hAt2G.borderColorMap),
    outlineOffset: (0, $hAt2G.positiveSpaceMap),
    outlineWidth: (0, $hAt2G.borderWidthMap),
    padding: (0, $hAt2G.positiveSpaceMap),
    paddingBlock: (0, $hAt2G.positiveSpaceMap),
    paddingBlockEnd: (0, $hAt2G.positiveSpaceMap),
    paddingBlockStart: (0, $hAt2G.positiveSpaceMap),
    paddingBottom: (0, $hAt2G.positiveSpaceMap),
    paddingInline: (0, $hAt2G.positiveSpaceMap),
    paddingInlineEnd: (0, $hAt2G.positiveSpaceMap),
    paddingInlineStart: (0, $hAt2G.positiveSpaceMap),
    paddingLeft: (0, $hAt2G.positiveSpaceMap),
    paddingRight: (0, $hAt2G.positiveSpaceMap),
    paddingTop: (0, $hAt2G.positiveSpaceMap),
    right: (0, $hAt2G.allSpaceMap),
    rowGap: (0, $hAt2G.positiveSpaceMap),
    top: (0, $hAt2G.allSpaceMap),
    width: (0, $hAt2G.dimensionMap),
    zIndex: (0, $hAt2G.layerMap)
};
var $747008afad88328a$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $747008afad88328a$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $7t0tI === "undefined" ? "undefined" : (0, $2zYm4.default)($7t0tI)) === 'object' && (0, $2zYm4.default)($7t0tI.env) === 'object' && false;
};
var $747008afad88328a$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $747008afad88328a$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $747008afad88328a$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, $2zYm4.default)(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, $2qaZZ.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, $2zYm4.default)(value) === 'object' && $747008afad88328a$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($747008afad88328a$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($747008afad88328a$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $747008afad88328a$export$9a199fbafee0014e)) return;
        var tokenValue = $747008afad88328a$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $747008afad88328a$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $747008afad88328a$var$transformStyles(style);
    return (0, $f53LC.default)({}, $747008afad88328a$var$uniqueSymbol, (0, $3dJ4i.css)(transformedStyles));
};
var $747008afad88328a$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $747008afad88328a$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, $lFOXD.default)(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$747008afad88328a$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $747008afad88328a$export$f6c783d06584602c(style) {
    return $747008afad88328a$var$baseXcss(style);
}

});
parcelRegister("hAt2G", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", function () { return $ccdc53a4b75c0ae0$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $ccdc53a4b75c0ae0$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $ccdc53a4b75c0ae0$export$632685d741f3dbbf; });
$parcel$export(module.exports, "opacityMap", function () { return $ccdc53a4b75c0ae0$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $ccdc53a4b75c0ae0$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $ccdc53a4b75c0ae0$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $ccdc53a4b75c0ae0$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $ccdc53a4b75c0ae0$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $ccdc53a4b75c0ae0$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $ccdc53a4b75c0ae0$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $ccdc53a4b75c0ae0$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $ccdc53a4b75c0ae0$export$e615f061ca585a6c; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $ccdc53a4b75c0ae0$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $ccdc53a4b75c0ae0$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $ccdc53a4b75c0ae0$export$5e65a44e5b6ecadb; });

var $f53LC = parcelRequire("f53LC");

var $3dJ4i = parcelRequire("3dJ4i");

var $e354Q = parcelRequire("e354Q");
function $ccdc53a4b75c0ae0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ccdc53a4b75c0ae0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ccdc53a4b75c0ae0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ccdc53a4b75c0ae0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ccdc53a4b75c0ae0$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $ccdc53a4b75c0ae0$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $ccdc53a4b75c0ae0$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $ccdc53a4b75c0ae0$export$632685d741f3dbbf = $ccdc53a4b75c0ae0$var$_objectSpread($ccdc53a4b75c0ae0$var$_objectSpread({}, $ccdc53a4b75c0ae0$export$958d0ae7f2977ae4), $ccdc53a4b75c0ae0$export$d2dc61f58390201c);
var $ccdc53a4b75c0ae0$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $ccdc53a4b75c0ae0$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $ccdc53a4b75c0ae0$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $ccdc53a4b75c0ae0$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $ccdc53a4b75c0ae0$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $ccdc53a4b75c0ae0$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $ccdc53a4b75c0ae0$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $ccdc53a4b75c0ae0$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $ccdc53a4b75c0ae0$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $ccdc53a4b75c0ae0$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
var $ccdc53a4b75c0ae0$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
var $ccdc53a4b75c0ae0$export$6cc560b4dedf3816 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $ccdc53a4b75c0ae0$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $ccdc53a4b75c0ae0$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $ccdc53a4b75c0ae0$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $ccdc53a4b75c0ae0$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $3dJ4i.css)((0, $f53LC.default)({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $ccdc53a4b75c0ae0$export$e615f061ca585a6c = $ccdc53a4b75c0ae0$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $ccdc53a4b75c0ae0$var$getSerializedStylesMap(spacingProperty, $ccdc53a4b75c0ae0$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $ccdc53a4b75c0ae0$export$bf46c3f9eeafc71f = $ccdc53a4b75c0ae0$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $ccdc53a4b75c0ae0$var$getSerializedStylesMap(spacingProperty, $ccdc53a4b75c0ae0$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $ccdc53a4b75c0ae0$export$e7af83bafe7f9e63 = $ccdc53a4b75c0ae0$var$getSerializedStylesMap('backgroundColor', $ccdc53a4b75c0ae0$export$d1d79bf68ac056bd);
var $ccdc53a4b75c0ae0$export$3a1bcba60b23d7f0 = $ccdc53a4b75c0ae0$var$getSerializedStylesMap('color', $ccdc53a4b75c0ae0$export$8473307aa00d6ea1);
var $ccdc53a4b75c0ae0$export$45f3f4fe16f9f7d5 = $ccdc53a4b75c0ae0$var$getSerializedStylesMap('fontWeight', $ccdc53a4b75c0ae0$export$303e322c6b1ed114);
var $ccdc53a4b75c0ae0$export$68cc305da27dbaa4 = $ccdc53a4b75c0ae0$var$getSerializedStylesMap('fontFamily', $ccdc53a4b75c0ae0$export$3c7e9587132614b4);
var $ccdc53a4b75c0ae0$export$128f10c238242f83 = $ccdc53a4b75c0ae0$var$getSerializedStylesMap('font', $ccdc53a4b75c0ae0$export$6cc560b4dedf3816);
var $ccdc53a4b75c0ae0$export$ff257d957d48c421 = $ccdc53a4b75c0ae0$var$getSerializedStylesMap((0, $e354Q.CURRENT_SURFACE_CSS_VAR), $ccdc53a4b75c0ae0$export$41a358c9c2356760);
var $ccdc53a4b75c0ae0$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $ccdc53a4b75c0ae0$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("e354Q", function(module, exports) {
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $a3a548b70fa3cb49$export$9d7b58831ae93caa; });
var $a3a548b70fa3cb49$export$4ef52930e33717cd = 'data-theme';
var $a3a548b70fa3cb49$export$a00eac3f8684bcd0 = 'data-color-mode';
var $a3a548b70fa3cb49$export$2112803007239c61 = 'data-contrast-mode';
var $a3a548b70fa3cb49$export$352e418ed5b6193a = 'data-custom-theme';
var $a3a548b70fa3cb49$export$2faeed762aac6741 = 'light';
var $a3a548b70fa3cb49$export$6f0c6fb8c80fcc92 = 'ds';
var $a3a548b70fa3cb49$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $a3a548b70fa3cb49$export$dddac1532e822863 = "--".concat($a3a548b70fa3cb49$export$6f0c6fb8c80fcc92, "-token-not-found");
var $a3a548b70fa3cb49$export$9d7b58831ae93caa = "--".concat($a3a548b70fa3cb49$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});



parcelRegister("4GEEE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $369a9edb3a53c5c4$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $hAt2G = parcelRequire("hAt2G");

var $9ZNh9 = parcelRequire("9ZNh9");

var $jZnad = parcelRequire("jZnad");
var $369a9edb3a53c5c4$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $369a9edb3a53c5c4$var$_excluded2 = [
    "className"
];
var $369a9edb3a53c5c4$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $gnQ3X.default)(_ref, $369a9edb3a53c5c4$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $gnQ3X.default)(htmlAttributes, $369a9edb3a53c5c4$var$_excluded2);
    var resolvedStyles = (0, $9ZNh9.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $3dJ4i.jsx)(Component, (0, $c9bqK.default)({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $369a9edb3a53c5c4$var$baseStyles,
            backgroundColor && (0, $hAt2G.backgroundColorStylesMap)[backgroundColor],
            (0, $hAt2G.isSurfaceColorToken)(backgroundColor) && (0, $hAt2G.surfaceColorStylesMap)[backgroundColor],
            padding && (0, $hAt2G.paddingStylesMap).padding[padding],
            paddingBlock && (0, $hAt2G.paddingStylesMap).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $hAt2G.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $hAt2G.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $hAt2G.paddingStylesMap).paddingInline[paddingInline],
            paddingInlineStart && (0, $hAt2G.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $hAt2G.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $3dJ4i.jsx)((0, $jZnad.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $369a9edb3a53c5c4$export$2e2bcd8739ae039 = $369a9edb3a53c5c4$export$e71c4d32a2263218;
var $369a9edb3a53c5c4$var$baseStyles = (0, $3dJ4i.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});

});
parcelRegister("jZnad", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", function () { return $e8d5aea58f3af02a$export$1ca2a26fecb070ae; });

var $1oC0p = parcelRequire("1oC0p");
var $e8d5aea58f3af02a$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1oC0p.createContext)('elevation.surface');
var $e8d5aea58f3af02a$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $1oC0p.useContext)($e8d5aea58f3af02a$export$1ca2a26fecb070ae);
};
$e8d5aea58f3af02a$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});



parcelRegister("f1cZ8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $aef105901b18f3f1$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $8VQwQ = parcelRequire("8VQwQ");

var $4gPIz = parcelRequire("4gPIz");

var $7pzsb = parcelRequire("7pzsb");
/**
 * __Use default button base__
 *
 * A React hook that accepts a set of default Button props,
 * and processes them to return consistent base props for usage
 * across Button and LinkButton variants.
 *
 * @private
 */ var $aef105901b18f3f1$var$useDefaultButton = function useDefaultButton(_ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, buttonType = _ref.buttonType, IconBefore = _ref.iconBefore, UNSAFE_iconBefore_size = _ref.UNSAFE_iconBefore_size, IconAfter = _ref.iconAfter, UNSAFE_iconAfter_size = _ref.UNSAFE_iconAfter_size, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, children = _ref.children, onClick = _ref.onClick, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, overlay = _ref.overlay, ref = _ref.ref, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing;
    var hasOverlay = Boolean(overlay || isLoading);
    var baseProps = (0, $7pzsb.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: buttonType,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, IconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8VQwQ.default), {
            type: "icon",
            hasOverlay: hasOverlay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(IconBefore, {
            label: "",
            size: UNSAFE_iconBefore_size
        })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8VQwQ.default), {
            hasOverlay: hasOverlay
        }, children), IconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8VQwQ.default), {
            type: "icon",
            hasOverlay: hasOverlay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(IconAfter, {
            label: "",
            size: UNSAFE_iconAfter_size
        }))),
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        overlay: isLoading ? (0, $4gPIz.default)({
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : overlay,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        hasIconBefore: Boolean(IconBefore),
        hasIconAfter: Boolean(IconAfter)
    });
    return baseProps;
};
var $aef105901b18f3f1$export$2e2bcd8739ae039 = $aef105901b18f3f1$var$useDefaultButton;

});
parcelRegister("8VQwQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $680c64bbb2163013$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $1oC0p = parcelRequire("1oC0p");

var $4GEEE = parcelRequire("4GEEE");
var $9ZNh9 = parcelRequire("9ZNh9");
var $680c64bbb2163013$var$textStyles = (0, $9ZNh9.xcss)({
    // content can grow and shrink
    flexGrow: 1,
    flexShrink: 1,
    // ellipsis for overflow text
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
var $680c64bbb2163013$var$iconStyles = (0, $9ZNh9.xcss)({
    display: 'flex',
    // icon size cannot grow and shrink
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: 'center',
    fontSize: 0,
    lineHeight: 0,
    userSelect: 'none'
});
var $680c64bbb2163013$var$commonStyles = (0, $9ZNh9.xcss)({
    transition: 'opacity 0.3s'
});
var $680c64bbb2163013$var$fadeStyles = (0, $9ZNh9.xcss)({
    opacity: 0
});
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $680c64bbb2163013$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, hasOverlay = _ref.hasOverlay;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4GEEE.default), {
        as: "span",
        xcss: [
            $680c64bbb2163013$var$commonStyles
        ].concat((0, $lFOXD.default)(type === 'text' ? [
            $680c64bbb2163013$var$textStyles
        ] : [
            $680c64bbb2163013$var$iconStyles
        ]), (0, $lFOXD.default)(hasOverlay ? [
            $680c64bbb2163013$var$fadeStyles
        ] : []))
    }, children);
};
var $680c64bbb2163013$export$2e2bcd8739ae039 = $680c64bbb2163013$var$Content;

});

parcelRegister("4gPIz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $31c0c6284557992f$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $e9GJT = parcelRequire("e9GJT");
function $31c0c6284557992f$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        case 'none':
            return 'xsmall';
        default:
            return 'medium';
    }
}
function $31c0c6284557992f$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $31c0c6284557992f$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $e9GJT.default), {
        label: ", Loading",
        size: $31c0c6284557992f$var$getIconSpacing(spacing),
        appearance: $31c0c6284557992f$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});
parcelRegister("e9GJT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a4e30f0d1f888d9c$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $jFYu8 = parcelRequire("jFYu8");

var $kBdcY = parcelRequire("kBdcY");

var $k7Hn1 = parcelRequire("k7Hn1");
/**
 * Returns the appropriate circle stroke color.
 */ function $a4e30f0d1f888d9c$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $kBdcY.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $kBdcY.N0), ")");
}
var $a4e30f0d1f888d9c$var$rotate = (0, $3dJ4i.keyframes)({
    to: {
        transform: 'rotate(360deg)'
    }
});
var $a4e30f0d1f888d9c$var$rotateStyles = (0, $3dJ4i.css)({
    animation: "".concat($a4e30f0d1f888d9c$var$rotate, " 0.86s infinite"),
    animationTimingFunction: 'cubic-bezier(0.4, 0.15, 0.6, 0.85)',
    transformOrigin: 'center'
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $a4e30f0d1f888d9c$var$loadIn = (0, $3dJ4i.keyframes)({
    from: {
        transform: 'rotate(50deg)',
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: 'rotate(230deg)',
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $a4e30f0d1f888d9c$var$loadInStyles = (0, $3dJ4i.css)({
    animation: "".concat($a4e30f0d1f888d9c$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: 'forwards',
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $a4e30f0d1f888d9c$var$wrapperStyles = (0, $3dJ4i.css)({
    display: 'inline-flex',
    /**
   * Align better inline with text.
   */ verticalAlign: 'middle'
});
var $a4e30f0d1f888d9c$var$circleStyles = (0, $3dJ4i.css)({
    fill: 'none',
    strokeDasharray: 60,
    strokeDashoffset: 'inherit',
    strokeLinecap: 'round',
    strokeWidth: 1.5,
    '@media screen and (forced-colors: active)': {
        filter: 'grayscale(100%)',
        stroke: 'CanvasText'
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $a4e30f0d1f888d9c$var$useLayoutEffect = typeof window === 'undefined' ? (0, $1oC0p.useEffect) : (0, $1oC0p.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $a4e30f0d1f888d9c$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $k7Hn1.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $a4e30f0d1f888d9c$var$getStrokeColor(appearance);
    var context = (0, $1oC0p.useContext)((0, $jFYu8.default));
    $a4e30f0d1f888d9c$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $3dJ4i.jsx)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $a4e30f0d1f888d9c$var$wrapperStyles,
            $a4e30f0d1f888d9c$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $3dJ4i.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        css: $a4e30f0d1f888d9c$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none'
    }, (0, $3dJ4i.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $a4e30f0d1f888d9c$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));
var $a4e30f0d1f888d9c$export$2e2bcd8739ae039 = $a4e30f0d1f888d9c$var$Spinner;

});
parcelRegister("kBdcY", function(module, exports) {
$parcel$export(module.exports, "N0", function () { return $03debbe81a4480d4$export$29a4f05edc054374; });
$parcel$export(module.exports, "N500", function () { return $03debbe81a4480d4$export$c39c0fe0f26207ae; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $03debbe81a4480d4$export$4b84fd0e2c617bd = '#FFEBE6';
var $03debbe81a4480d4$export$b34b069eff244586 = '#FFBDAD';
var $03debbe81a4480d4$export$be802dd0d8b57f35 = '#FF8F73';
var $03debbe81a4480d4$export$60847d42f9da92a6 = '#FF7452';
var $03debbe81a4480d4$export$4a7404f376229999 = '#FF5630';
var $03debbe81a4480d4$export$2010d0fb4295b346 = '#DE350B';
var $03debbe81a4480d4$export$2837b5a1a71d5c02 = '#BF2600';
var $03debbe81a4480d4$export$8d9596b529bbb9cf = '#FFFAE6';
var $03debbe81a4480d4$export$41060a744ab0b7ae = '#FFF0B3';
var $03debbe81a4480d4$export$1cc05bbbf340e559 = '#FFE380';
var $03debbe81a4480d4$export$5aae31392d72caaa = '#FFC400';
var $03debbe81a4480d4$export$c6930421db9fa514 = '#FFAB00';
var $03debbe81a4480d4$export$59619663aa6500fb = '#FF991F';
var $03debbe81a4480d4$export$874739ea9e379ab6 = '#FF8B00';
var $03debbe81a4480d4$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $03debbe81a4480d4$export$69a3bf21b9686c2b = '#ABF5D1';
var $03debbe81a4480d4$export$afbce1382ec95f73 = '#79F2C0';
var $03debbe81a4480d4$export$747d86715d4175de = '#57D9A3';
var $03debbe81a4480d4$export$940e1f69e873f202 = '#36B37E';
var $03debbe81a4480d4$export$a49394138f7b8e85 = '#00875A';
var $03debbe81a4480d4$export$6fa04827ac68a4fb = '#006644';
var $03debbe81a4480d4$export$226de0355ed012f8 = '#DEEBFF';
var $03debbe81a4480d4$export$8c13c2ee36917869 = '#B3D4FF';
var $03debbe81a4480d4$export$ecfc1dff386a3e7a = '#4C9AFF';
var $03debbe81a4480d4$export$215b7063051591f1 = '#2684FF';
var $03debbe81a4480d4$export$e62e8919cca44969 = '#0065FF';
var $03debbe81a4480d4$export$b3de0ae08da2ce64 = '#0052CC';
var $03debbe81a4480d4$export$a6ee3d71bc067634 = '#0747A6';
var $03debbe81a4480d4$export$363e4475840015bb = '#EAE6FF';
var $03debbe81a4480d4$export$4b0a4417ed59760f = '#C0B6F2';
var $03debbe81a4480d4$export$6011520a64d9a187 = '#998DD9';
var $03debbe81a4480d4$export$a7175d4e9206bc80 = '#8777D9';
var $03debbe81a4480d4$export$b48405b95304b5a1 = '#6554C0';
var $03debbe81a4480d4$export$c71e4279dd54a18d = '#5243AA';
var $03debbe81a4480d4$export$147899de772240ec = '#403294';
var $03debbe81a4480d4$export$2cf711fe14c66f06 = '#E6FCFF';
var $03debbe81a4480d4$export$7a8f4d33f6f9772c = '#B3F5FF';
var $03debbe81a4480d4$export$776c9c497ef08533 = '#79E2F2';
var $03debbe81a4480d4$export$69cb3ca10c1e330e = '#00C7E6';
var $03debbe81a4480d4$export$9dc1ef0f3f48059b = '#00B8D9';
var $03debbe81a4480d4$export$7c835c78b6fcdef8 = '#00A3BF';
var $03debbe81a4480d4$export$6036577f95c3877e = '#008DA6';
var $03debbe81a4480d4$export$29a4f05edc054374 = '#FFFFFF';
var $03debbe81a4480d4$export$e655ef011c4aa1a2 = '#FAFBFC';
var $03debbe81a4480d4$export$9fdfb749e33cdf97 = '#F4F5F7';
var $03debbe81a4480d4$export$3e51e8f1440314ba = '#EBECF0';
var $03debbe81a4480d4$export$1ce2d1575d444ceb = '#DFE1E6';
var $03debbe81a4480d4$export$8754fc7e6d8b3000 = '#C1C7D0';
var $03debbe81a4480d4$export$c2e91cbeada39b8b = '#B3BAC5';
var $03debbe81a4480d4$export$5f71e19f3a7ad9de = '#A5ADBA';
var $03debbe81a4480d4$export$eaa8c8a70ac22806 = '#97A0AF';
var $03debbe81a4480d4$export$7c87d337fb91a97d = '#8993A4';
var $03debbe81a4480d4$export$d6447c357493214f = '#7A869A';
var $03debbe81a4480d4$export$f563ee71e9ee74cd = '#6B778C';
var $03debbe81a4480d4$export$e2ef2124cf4024b1 = '#5E6C84';
var $03debbe81a4480d4$export$eece5f492e429f08 = '#505F79';
var $03debbe81a4480d4$export$c39c0fe0f26207ae = '#42526E';
var $03debbe81a4480d4$export$7090862dc3038a9f = '#344563';
var $03debbe81a4480d4$export$ad0bacf983b7ddaa = '#253858';
var $03debbe81a4480d4$export$7d61b15e0da132af = '#172B4D';
var $03debbe81a4480d4$export$fbda843f0a27fe96 = '#091E42';
var $03debbe81a4480d4$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $03debbe81a4480d4$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $03debbe81a4480d4$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $03debbe81a4480d4$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $03debbe81a4480d4$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $03debbe81a4480d4$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $03debbe81a4480d4$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $03debbe81a4480d4$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $03debbe81a4480d4$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $03debbe81a4480d4$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $03debbe81a4480d4$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $03debbe81a4480d4$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $03debbe81a4480d4$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $03debbe81a4480d4$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $03debbe81a4480d4$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $03debbe81a4480d4$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $03debbe81a4480d4$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $03debbe81a4480d4$export$2f6319cf7d736c2a = '#E6EDFA';
var $03debbe81a4480d4$export$95126bc8884d6634 = '#DCE5F5';
var $03debbe81a4480d4$export$8338d8c35d44ff1 = '#CED9EB';
var $03debbe81a4480d4$export$5368d76ae4fbbda7 = '#B8C7E0';
var $03debbe81a4480d4$export$9f0a771d16ec8d36 = '#ABBBD6';
var $03debbe81a4480d4$export$abcf8c38338b4aa5 = '#9FB0CC';
var $03debbe81a4480d4$export$97e81faa16a182c7 = '#8C9CB8';
var $03debbe81a4480d4$export$bfe21c59123ecf33 = '#7988A3';
var $03debbe81a4480d4$export$ee82aa2ea6a1558 = '#67758F';
var $03debbe81a4480d4$export$682927c6ed76be02 = '#56637A';
var $03debbe81a4480d4$export$91fd9994c5be9757 = '#455166';
var $03debbe81a4480d4$export$d281fbfe3cff2df6 = '#3B475C';
var $03debbe81a4480d4$export$3902c91d8b98a753 = '#313D52';
var $03debbe81a4480d4$export$8e8133c1ba5845b5 = '#283447';
var $03debbe81a4480d4$export$33ff357f6620b39 = '#202B3D';
var $03debbe81a4480d4$export$633847cf062b69e0 = '#1B2638';
var $03debbe81a4480d4$export$9776a6e503bdbf76 = '#121A29';
var $03debbe81a4480d4$export$6c813d5160dff5db = '#0E1624';
var $03debbe81a4480d4$export$3d4f271a500072a = '#0D1424';
var $03debbe81a4480d4$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $03debbe81a4480d4$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $03debbe81a4480d4$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $03debbe81a4480d4$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $03debbe81a4480d4$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $03debbe81a4480d4$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $03debbe81a4480d4$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $03debbe81a4480d4$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $03debbe81a4480d4$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $03debbe81a4480d4$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $03debbe81a4480d4$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $03debbe81a4480d4$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $03debbe81a4480d4$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $03debbe81a4480d4$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $03debbe81a4480d4$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $03debbe81a4480d4$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $03debbe81a4480d4$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';

});

parcelRegister("k7Hn1", function(module, exports) {
$parcel$export(module.exports, "presetSizes", function () { return $ea661a83e92e5117$export$4e9f1640bbe7a1a8; });
var $ea661a83e92e5117$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});



parcelRegister("7pzsb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $56565e890ae91785$export$2e2bcd8739ae039; });

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $9eBsh = parcelRequire("9eBsh");

var $fACJY = parcelRequire("fACJY");

var $4GEEE = parcelRequire("4GEEE");
var $9ZNh9 = parcelRequire("9ZNh9");

var $3c7rQ = parcelRequire("3c7rQ");

var $hnR5n = parcelRequire("hnR5n");

var $jGExY = parcelRequire("jGExY");

var $1llVT = parcelRequire("1llVT");
function $56565e890ae91785$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $56565e890ae91785$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $56565e890ae91785$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $56565e890ae91785$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $56565e890ae91785$var$fontSize = (0, $hnR5n.fontSize)();
var $56565e890ae91785$var$buttonStyles = (0, $9ZNh9.xcss)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    width: 'auto',
    maxWidth: '100%',
    position: 'relative',
    alignItems: 'baseline',
    justifyContent: 'center',
    columnGap: 'space.050',
    background: "var(--ds-background-neutral, ".concat($3c7rQ.N20A, ")"),
    borderRadius: 'border.radius.100',
    borderWidth: 'border.width.0',
    // @ts-expect-error
    color: "var(--ds-text, ".concat($3c7rQ.N500, ")"),
    flexShrink: 0,
    fontFamily: 'inherit',
    fontSize: 'inherit',
    fontStyle: 'normal',
    fontWeight: 500,
    height: "".concat(32 / $56565e890ae91785$var$fontSize, "em"),
    lineHeight: "".concat(32 / $56565e890ae91785$var$fontSize, "em"),
    paddingBlock: 'space.0',
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    textAlign: 'center',
    transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
    verticalAlign: 'middle',
    ':visited': {
        // @ts-expect-error
        color: "var(--ds-text, ".concat($3c7rQ.N500, ")")
    }
});
var $56565e890ae91785$var$defaultInteractiveStyles = (0, $9ZNh9.xcss)({
    ':hover': {
        background: "var(--ds-background-neutral-hovered, #091e4214)",
        // @ts-expect-error
        color: "var(--ds-text, ".concat($3c7rQ.N500, ")"),
        transitionDuration: '0s, 0.15s'
    },
    ':active': {
        background: "var(--ds-background-neutral-pressed, ".concat($3c7rQ.B75, ")"),
        // @ts-expect-error
        color: "var(--ds-text, ".concat($3c7rQ.B400, ")"),
        transitionDuration: '0s, 0s'
    }
});
var $56565e890ae91785$var$primaryStyles = (0, $9ZNh9.xcss)({
    background: "var(--ds-background-brand-bold, #0052CC)",
    // @ts-expect-error
    color: "var(--ds-text-inverse, #FFFFFF)",
    ':visited': {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)"
    }
});
var $56565e890ae91785$var$primaryInteractiveStyles = (0, $9ZNh9.xcss)({
    ':hover': {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-hovered, #0065FF)"
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-pressed, #0747A6)"
    }
});
var $56565e890ae91785$var$warningStyles = (0, $9ZNh9.xcss)({
    background: "var(--ds-background-warning-bold, #FFAB00)",
    // @ts-expect-error
    color: "var(--ds-text-warning-inverse, #172B4D)",
    ':visited': {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)"
    }
});
var $56565e890ae91785$var$warningInteractiveStyles = (0, $9ZNh9.xcss)({
    ':hover': {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-hovered, #FFC400)"
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-pressed, #FF991F)"
    }
});
var $56565e890ae91785$var$dangerStyles = (0, $9ZNh9.xcss)({
    background: "var(--ds-background-danger-bold, #DE350B)",
    color: 'color.text.inverse',
    ':visited': {
        color: 'color.text.inverse'
    }
});
var $56565e890ae91785$var$dangerInteractiveStyles = (0, $9ZNh9.xcss)({
    ':hover': {
        color: 'color.text.inverse',
        background: "var(--ds-background-danger-bold-hovered, #FF5630)"
    },
    ':active': {
        color: 'color.text.inverse',
        background: "var(--ds-background-danger-bold-pressed, #BF2600)"
    }
});
var $56565e890ae91785$var$discoveryStyles = (0, $9ZNh9.xcss)({
    background: "var(--ds-background-discovery-bold, #5243AA)",
    color: 'color.text.inverse',
    ':visited': {
        color: 'color.text.inverse'
    }
});
var $56565e890ae91785$var$discoveryInteractiveStyles = (0, $9ZNh9.xcss)({
    ':hover': {
        color: 'color.text.inverse',
        background: "var(--ds-background-discovery-bold-hovered, #8777D9)"
    },
    ':active': {
        color: 'color.text.inverse',
        background: "var(--ds-background-discovery-bold-pressed, #5243AA)"
    }
});
var $56565e890ae91785$var$subtleStyles = (0, $9ZNh9.xcss)({
    background: "var(--ds-background-neutral-subtle, transparent)",
    // @ts-expect-error
    color: "var(--ds-text, #42526E)",
    ':visited': {
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
var $56565e890ae91785$var$subtleInteractiveStyles = (0, $9ZNh9.xcss)({
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
var $56565e890ae91785$var$linkStyles = (0, $9ZNh9.xcss)({
    // @ts-expect-error
    color: "var(--ds-link, ".concat($3c7rQ.B400, ")"),
    background: "var(--ds-background-neutral-subtle, transparent)",
    textDecoration: 'none',
    ':hover': {
        // @ts-expect-error
        color: "var(--ds-link, ".concat($3c7rQ.B300, ")"),
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-link-pressed, #0055CC)",
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ':visited': {
        // @ts-expect-error
        color: "var(--ds-link, ".concat($3c7rQ.B400, ")")
    }
});
var $56565e890ae91785$var$subtleLinkStyles = (0, $9ZNh9.xcss)({
    // @ts-expect-error
    color: "var(--ds-text-subtle, ".concat($3c7rQ.N200, ")"),
    background: "var(--ds-background-neutral-subtle, transparent)",
    textDecoration: 'none',
    ':hover': {
        // @ts-expect-error
        color: "var(--ds-text-subtle, ".concat($3c7rQ.N90, ")"),
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-text, ".concat($3c7rQ.N400, ")"),
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ':visited': {
        // @ts-expect-error
        color: "var(--ds-text-subtle, ".concat($3c7rQ.N200, ")")
    }
});
// Required due to Jira's AUI CSS reset: https://product-fabric.atlassian.net/browse/DSP-15687
var $56565e890ae91785$var$linkDecorationUnsetStyles = (0, $9ZNh9.xcss)({
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'none'
    },
    ':active': {
        textDecoration: 'none'
    },
    ':focus': {
        textDecoration: 'none'
    }
});
var $56565e890ae91785$var$linkDecorationStyles = (0, $9ZNh9.xcss)({
    ':hover': {
        textDecoration: 'underline'
    },
    ':focus': {
        textDecoration: 'underline'
    }
});
var $56565e890ae91785$var$disabledStyles = (0, $9ZNh9.xcss)({
    background: "var(--ds-background-disabled, ".concat($3c7rQ.N20A, ")"),
    // @ts-expect-error
    color: "var(--ds-text-disabled, #091E424F)",
    ':hover': {
        background: "var(--ds-background-disabled, ".concat($3c7rQ.N20A, ")"),
        // @ts-expect-error
        color: "var(--ds-text-disabled, #091E424F)"
    },
    ':active': {
        background: "var(--ds-background-disabled, ".concat($3c7rQ.N20A, ")"),
        // @ts-expect-error
        color: "var(--ds-text-disabled, #091E424F)"
    }
});
var $56565e890ae91785$var$selectedStyles = (0, $9ZNh9.xcss)({
    background: "var(--ds-background-selected, ".concat($3c7rQ.N700, ")"),
    // @ts-expect-error
    color: "var(--ds-text-selected, ".concat($3c7rQ.N20, ")"),
    ':visited': {
        // @ts-expect-error
        color: "var(--ds-text-selected, ".concat($3c7rQ.N20, ")")
    }
});
var $56565e890ae91785$var$selectedInteractiveStyles = (0, $9ZNh9.xcss)({
    ':hover': {
        // @ts-expect-error
        color: "var(--ds-text-selected, ".concat($3c7rQ.N20, ")"),
        background: "var(--ds-background-selected-hovered, ".concat($3c7rQ.N700, ")")
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-text-selected, ".concat($3c7rQ.N20, ")"),
        background: "var(--ds-background-selected-pressed, ".concat($3c7rQ.N700, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $56565e890ae91785$var$selectedWarningStyles = (0, $9ZNh9.xcss)({
    background: "var(--ds-background-selected, ".concat($3c7rQ.Y400, ")"),
    // @ts-expect-error
    color: "var(--ds-text-selected, ".concat($3c7rQ.N800, ")"),
    ':hover': {
        // @ts-expect-error
        color: "var(--ds-text-selected, ".concat($3c7rQ.N20, ")"),
        background: "var(--ds-background-selected, ".concat($3c7rQ.Y400, ")")
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-text-selected, ".concat($3c7rQ.N20, ")"),
        background: "var(--ds-background-selected, ".concat($3c7rQ.Y400, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $56565e890ae91785$var$selectedDangerStyles = (0, $9ZNh9.xcss)({
    background: "var(--ds-background-selected, ".concat($3c7rQ.R500, ")"),
    // @ts-expect-error
    color: "var(--ds-text-selected, ".concat($3c7rQ.N20, ")"),
    ':hover': {
        // @ts-expect-error
        color: "var(--ds-text-selected, ".concat($3c7rQ.N20, ")"),
        background: "var(--ds-background-selected, ".concat($3c7rQ.R500, ")")
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-text-selected, ".concat($3c7rQ.N20, ")"),
        background: "var(--ds-background-selected, ".concat($3c7rQ.R500, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $56565e890ae91785$var$selectedDiscoveryStyles = (0, $9ZNh9.xcss)({
    background: "var(--ds-background-selected, #403294)",
    // @ts-expect-error
    color: "var(--ds-text-selected, ".concat($3c7rQ.N20, ")"),
    ':hover': {
        // @ts-expect-error
        color: "var(--ds-text-selected, ".concat($3c7rQ.N20, ")"),
        background: "var(--ds-background-selected, #403294)"
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-text-selected, ".concat($3c7rQ.N20, ")"),
        background: "var(--ds-background-selected, #403294)"
    }
});
var $56565e890ae91785$var$spacingCompactStyles = (0, $9ZNh9.xcss)({
    columnGap: 'space.050',
    height: "".concat(24 / $56565e890ae91785$var$fontSize, "em"),
    lineHeight: "".concat(24 / $56565e890ae91785$var$fontSize, "em"),
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    verticalAlign: 'middle'
});
var $56565e890ae91785$var$spacingNoneStyles = (0, $9ZNh9.xcss)({
    columnGap: 'space.0',
    height: 'auto',
    lineHeight: 'inherit',
    paddingInlineEnd: 'space.0',
    paddingInlineStart: 'space.0',
    verticalAlign: 'baseline'
});
var $56565e890ae91785$var$circleStyles = (0, $9ZNh9.xcss)({
    borderRadius: 'border.radius.circle'
});
var $56565e890ae91785$var$fullWidthStyles = (0, $9ZNh9.xcss)({
    width: '100%'
});
var $56565e890ae91785$var$loadingOverlayStyles = (0, $9ZNh9.xcss)({
    cursor: 'progress'
});
var $56565e890ae91785$var$nonInteractiveStyles = (0, $9ZNh9.xcss)({
    cursor: 'not-allowed'
});
var $56565e890ae91785$var$iconButtonStyles = (0, $9ZNh9.xcss)({
    height: "".concat(32 / $56565e890ae91785$var$fontSize, "em"),
    width: "".concat(32 / $56565e890ae91785$var$fontSize, "em"),
    paddingInlineEnd: 'space.0',
    paddingInlineStart: 'space.0'
});
var $56565e890ae91785$var$iconButtonCompactStyles = (0, $9ZNh9.xcss)({
    width: "".concat(24 / $56565e890ae91785$var$fontSize, "em"),
    height: "".concat(24 / $56565e890ae91785$var$fontSize, "em")
});
var $56565e890ae91785$var$buttonIconBeforeStyles = (0, $9ZNh9.xcss)({
    paddingInlineStart: 'space.100'
});
var $56565e890ae91785$var$buttonIconAfterStyles = (0, $9ZNh9.xcss)({
    paddingInlineEnd: 'space.100'
});
var $56565e890ae91785$var$splitButtonStyles = (0, $9ZNh9.xcss)({
    ':focus-visible': {
        zIndex: 'card'
    }
});
var $56565e890ae91785$var$navigationSplitButtonStyles = (0, $9ZNh9.xcss)({
    width: '24px',
    backgroundColor: 'color.background.neutral.subtle',
    paddingInlineEnd: 'space.075',
    paddingInlineStart: 'space.075'
});
var $56565e890ae91785$var$overlayStyles = (0, $9ZNh9.xcss)({
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    insetBlockEnd: 'space.0',
    insetBlockStart: 'space.0',
    insetInlineEnd: 'space.0',
    insetInlineStart: 'space.0'
});
/**
 * __Use button base__
 *
 * A React hook that accepts a set of common Button props,
 * and processes them to return consistent base props for usage
 * across various Button components.
 *
 * It also:
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $56565e890ae91785$var$useButtonBase = function useButtonBase(_ref) {
    var _ref$appearance = _ref.appearance, propAppearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, children = _ref.children, onClick = _ref.onClick, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, overlay = _ref.overlay, ref = _ref.ref, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? 'default' : _ref$spacing;
    var localRef = (0, $1oC0p.useRef)(null);
    var splitButtonContext = (0, $jGExY.useSplitButtonContext)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var appearance = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || propAppearance;
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var hasOverlay = Boolean(overlay);
    var isInteractive = !isDisabled && !isLoading && !hasOverlay;
    var isEffectivelyDisabled = isDisabled || Boolean(overlay);
    (0, $fACJY.default)(localRef, autoFocus);
    return $56565e890ae91785$var$_objectSpread({
        ref: (0, $9eBsh.default)([
            localRef,
            ref
        ]),
        xcss: [
            $56565e890ae91785$var$buttonStyles,
            appearance === 'default' && isInteractive && $56565e890ae91785$var$defaultInteractiveStyles,
            appearance === 'primary' && $56565e890ae91785$var$primaryStyles,
            appearance === 'primary' && isInteractive && $56565e890ae91785$var$primaryInteractiveStyles,
            appearance === 'warning' && $56565e890ae91785$var$warningStyles,
            appearance === 'warning' && isInteractive && $56565e890ae91785$var$warningInteractiveStyles,
            appearance === 'danger' && $56565e890ae91785$var$dangerStyles,
            appearance === 'danger' && isInteractive && $56565e890ae91785$var$dangerInteractiveStyles,
            appearance === 'discovery' && $56565e890ae91785$var$discoveryStyles,
            appearance === 'discovery' && isInteractive && $56565e890ae91785$var$discoveryInteractiveStyles,
            appearance === 'subtle' && $56565e890ae91785$var$subtleStyles,
            appearance === 'subtle' && isInteractive && $56565e890ae91785$var$subtleInteractiveStyles,
            appearance === 'link' && $56565e890ae91785$var$linkStyles,
            appearance === 'subtle-link' && $56565e890ae91785$var$subtleLinkStyles,
            !isSelected && (appearance === 'link' || appearance === 'subtle-link') ? $56565e890ae91785$var$linkDecorationStyles : $56565e890ae91785$var$linkDecorationUnsetStyles,
            isSelected && $56565e890ae91785$var$selectedStyles,
            isSelected && isInteractive && $56565e890ae91785$var$selectedInteractiveStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === 'danger' && $56565e890ae91785$var$selectedDangerStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === 'warning' && $56565e890ae91785$var$selectedWarningStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === 'discovery' && $56565e890ae91785$var$selectedDiscoveryStyles,
            isDisabled && $56565e890ae91785$var$disabledStyles,
            isCircle && !isSplitButton && $56565e890ae91785$var$circleStyles,
            spacing === 'compact' && $56565e890ae91785$var$spacingCompactStyles,
            spacing === 'none' && $56565e890ae91785$var$spacingNoneStyles,
            spacing !== 'none' && hasIconBefore && $56565e890ae91785$var$buttonIconBeforeStyles,
            spacing !== 'none' && hasIconAfter && $56565e890ae91785$var$buttonIconAfterStyles,
            isIconButton && $56565e890ae91785$var$iconButtonStyles,
            isIconButton && spacing === 'compact' && $56565e890ae91785$var$iconButtonCompactStyles,
            shouldFitContainer && $56565e890ae91785$var$fullWidthStyles,
            isLoading && $56565e890ae91785$var$loadingOverlayStyles,
            (isDisabled || hasOverlay && !isLoading) && $56565e890ae91785$var$nonInteractiveStyles,
            isSplitButton && $56565e890ae91785$var$splitButtonStyles,
            isNavigationSplitButton && $56565e890ae91785$var$navigationSplitButtonStyles
        ],
        // Consider overlay buttons to be effectively disabled
        isDisabled: isEffectivelyDisabled,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, children, overlay ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4GEEE.default), {
            as: "span",
            xcss: $56565e890ae91785$var$overlayStyles
        }, overlay) : null)
    }, (0, $1llVT.default)(isEffectivelyDisabled, {
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }));
};
var $56565e890ae91785$export$2e2bcd8739ae039 = $56565e890ae91785$var$useButtonBase;

});
parcelRegister("fACJY", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b59844e45df060e2$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
function $b59844e45df060e2$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $1oC0p.useRef)(true);
    (0, $1oC0p.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("jGExY", function(module, exports) {
$parcel$export(module.exports, "useSplitButtonContext", function () { return $03b2dc751debd6aa$export$47e2c6fdb142d947; });

var $1oC0p = parcelRequire("1oC0p");
var $03b2dc751debd6aa$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
var $03b2dc751debd6aa$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $1oC0p.useContext)($03b2dc751debd6aa$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        var newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("1llVT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0fa8c3fb94067e32$export$2e2bcd8739ae039; });
function $0fa8c3fb94067e32$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $0fa8c3fb94067e32$var$tabKeyCode = 9;
function $0fa8c3fb94067e32$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $0fa8c3fb94067e32$var$tabKeyCode) return;
    $0fa8c3fb94067e32$var$abort(event);
}
function $0fa8c3fb94067e32$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $0fa8c3fb94067e32$var$abort,
        onMouseUpCapture: $0fa8c3fb94067e32$var$abort,
        onKeyDownCapture: $0fa8c3fb94067e32$var$onKey,
        onKeyUpCapture: $0fa8c3fb94067e32$var$onKey,
        onTouchStartCapture: $0fa8c3fb94067e32$var$abort,
        onTouchEndCapture: $0fa8c3fb94067e32$var$abort,
        onPointerDownCapture: $0fa8c3fb94067e32$var$abort,
        onPointerUpCapture: $0fa8c3fb94067e32$var$abort,
        onClickCapture: $0fa8c3fb94067e32$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $0fa8c3fb94067e32$var$abort
    } : events;
}

});




parcelRegister("4O9wP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $38033912fa48c93c$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");
function $38033912fa48c93c$export$2e2bcd8739ae039(propValue) {
    var getDefaultPropValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function() {
        return propValue;
    };
    var isControlled = propValue !== undefined;
    var _useState = (0, $1oC0p.useState)(getDefaultPropValue), _useState2 = (0, $2qaZZ.default)(_useState, 2), valueState = _useState2[0], setValue = _useState2[1];
    var isControlledRef = (0, $1oC0p.useRef)(isControlled);
    (0, $1oC0p.useEffect)(function() {
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    var value = isControlled ? propValue : valueState;
    var setValueIfUncontrolled = (0, $1oC0p.useCallback)(function(newValue) {
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("jfMva", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e0450a723ea9ce94$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");
function $e0450a723ea9ce94$export$2e2bcd8739ae039() {
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $2qaZZ.default)(_useState, 2), isFocused = _useState2[0], setIsFocused = _useState2[1];
    // ensure bindFocus has a stable ref
    var bindFocus = (0, $1oC0p.useRef)({
        onFocus: function onFocus() {
            return setIsFocused(true);
        },
        onBlur: function onBlur() {
            return setIsFocused(false);
        }
    });
    (0, $1oC0p.useEffect)(function() {
        // handle the case where a component might
        // unmount while being focused.
        return function() {
            return setIsFocused(false);
        };
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("g9ZlO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bc3d13962955facb$var$_react = $bc3d13962955facb$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $doa7i = parcelRequire("doa7i");

var $bc3d13962955facb$var$_chevronDown = $bc3d13962955facb$var$_interopRequireDefault((parcelRequire("dMIFv")));
function $bc3d13962955facb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bc3d13962955facb$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $bc3d13962955facb$var$_react.default.createElement($doa7i.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props, {
        newIcon: $bc3d13962955facb$var$_chevronDown.default,
        iconType: "utility"
    }));
$bc3d13962955facb$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $bc3d13962955facb$var$_default = module.exports.default = $bc3d13962955facb$var$ChevronDownIcon;

});
parcelRegister("doa7i", function(module, exports) {
$parcel$export(module.exports, "IconFacade", function () { return $9bf55d3ac95025e4$export$3cfb73f70dfca966; });

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $75Hol = parcelRequire("75Hol");

var $9uO6V = parcelRequire("9uO6V");
var $9bf55d3ac95025e4$var$_excluded = [
    "dangerouslySetGlyph"
];
var $9bf55d3ac95025e4$var$sizeSpacingMap = {
    utility: {
        small: 'compact',
        medium: 'spacious'
    },
    core: {
        small: 'none',
        medium: 'spacious'
    }
};
var $9bf55d3ac95025e4$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $1oC0p.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, $gnQ3X.default)(_ref, $9bf55d3ac95025e4$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : 'medium';
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $75Hol.fg)('platform-visual-refresh-icons-legacy-facade');
    if (useNewIcon && NewIcon && (size === 'small' || size === 'medium')) {
        if (props.iconType === 'utility') {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Icon, (0, $c9bqK.default)({}, props, {
                spacing: (0, $75Hol.fg)('platform-visual-refresh-icons-facade-button-fix') ? $9bf55d3ac95025e4$var$sizeSpacingMap['utility'][size] : 'none',
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(_Icon, (0, $c9bqK.default)({}, props, {
                spacing: $9bf55d3ac95025e4$var$sizeSpacingMap['core'][size],
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9uO6V.default), (0, $c9bqK.default)({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});
var $9bf55d3ac95025e4$export$2e2bcd8739ae039 = $9bf55d3ac95025e4$export$3cfb73f70dfca966;

});
parcelRegister("75Hol", function(module, exports) {
$parcel$export(module.exports, "fg", function () { return $529aa8bb22df20e0$export$b40ec24ac8275656; });

var $9Uwf5 = parcelRequire("9Uwf5");
function $529aa8bb22df20e0$export$ba05d765b8392e5e(flagResolver) {
    (0, $9Uwf5.setBooleanResolver)(flagResolver);
}
function $529aa8bb22df20e0$export$470e5c2be1411c89(name) {
    return (0, $9Uwf5.resolveBooleanFlag)(name);
}
function $529aa8bb22df20e0$export$b40ec24ac8275656(name) {
    return (0, $9Uwf5.resolveBooleanFlag)(name);
}

});
parcelRegister("9Uwf5", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", function () { return $73725aa6a93d1e63$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $73725aa6a93d1e63$export$6333b6aff9fc6275; });

var $aLZEy = parcelRequire("aLZEy");

var $7t0tI = parcelRequire("7t0tI");
var $73725aa6a93d1e63$var$pkgName = '@atlaskit/platform-feature-flags';
var $73725aa6a93d1e63$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $73725aa6a93d1e63$var$hasProcessEnv = typeof $7t0tI !== 'undefined' && typeof $7t0tI.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $73725aa6a93d1e63$var$ENV_ENABLE_PLATFORM_FF = $73725aa6a93d1e63$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $73725aa6a93d1e63$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $73725aa6a93d1e63$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $73725aa6a93d1e63$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $73725aa6a93d1e63$var$ENV_ENABLE_PLATFORM_FF || $73725aa6a93d1e63$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $73725aa6a93d1e63$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $73725aa6a93d1e63$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$73725aa6a93d1e63$var$globalVar[$73725aa6a93d1e63$export$7e41b1b2bdee3f98] = $73725aa6a93d1e63$var$globalVar[$73725aa6a93d1e63$export$7e41b1b2bdee3f98] || $73725aa6a93d1e63$var$DEFAULT_PFF_GLOBAL;
function $73725aa6a93d1e63$export$f2b591175b3e424c(resolver) {
    $73725aa6a93d1e63$var$globalVar[$73725aa6a93d1e63$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $73725aa6a93d1e63$export$6333b6aff9fc6275(flagKey) {
    if ($73725aa6a93d1e63$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $aLZEy.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $73725aa6a93d1e63$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $73725aa6a93d1e63$var$globalVar[$73725aa6a93d1e63$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("aLZEy", function(module, exports) {
$parcel$export(module.exports, "debug", function () { return $7d7e1e31dfe75780$export$1c9f709888824e05; });
var $7d7e1e31dfe75780$var$_ref, $7d7e1e31dfe75780$var$_process, $7d7e1e31dfe75780$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $7d7e1e31dfe75780$var$TESTS_MODE = ($7d7e1e31dfe75780$var$_ref = (globalThis === null || globalThis === void 0 || ($7d7e1e31dfe75780$var$_process = globalThis.process) === null || $7d7e1e31dfe75780$var$_process === void 0 || ($7d7e1e31dfe75780$var$_process = $7d7e1e31dfe75780$var$_process.env) === null || $7d7e1e31dfe75780$var$_process === void 0 ? void 0 : $7d7e1e31dfe75780$var$_process.JEST_WORKER_ID) !== undefined, $7d7e1e31dfe75780$var$_ref !== void 0) ? $7d7e1e31dfe75780$var$_ref : false;
var $7d7e1e31dfe75780$var$DEBUG_MODE = !$7d7e1e31dfe75780$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($7d7e1e31dfe75780$var$_process2 = globalThis.process) === null || $7d7e1e31dfe75780$var$_process2 === void 0 || ($7d7e1e31dfe75780$var$_process2 = $7d7e1e31dfe75780$var$_process2.env) === null || $7d7e1e31dfe75780$var$_process2 === void 0 ? void 0 : $7d7e1e31dfe75780$var$_process2.NODE_ENV) !== 'production';
var $7d7e1e31dfe75780$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$7d7e1e31dfe75780$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("9uO6V", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6e9dc953b4d1a5cc$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $99nKa = parcelRequire("99nKa");

var $7VK5h = parcelRequire("7VK5h");
function $6e9dc953b4d1a5cc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6e9dc953b4d1a5cc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6e9dc953b4d1a5cc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6e9dc953b4d1a5cc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $6e9dc953b4d1a5cc$var$iconStyles = (0, $3dJ4i.css)({
    display: 'inline-block',
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> svg': $6e9dc953b4d1a5cc$var$_objectSpread($6e9dc953b4d1a5cc$var$_objectSpread({}, (0, $99nKa.commonSVGStyles)), {}, {
        maxWidth: '100%',
        maxHeight: '100%',
        color: 'var(--icon-primary-color)',
        fill: 'var(--icon-secondary-color)',
        verticalAlign: 'bottom'
    })
});
/**
 * For windows high contrast mode
 */ var $6e9dc953b4d1a5cc$var$baseHcmStyles = (0, $3dJ4i.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            filter: 'grayscale(1)',
            '--icon-primary-color': 'CanvasText',
            // foreground
            '--icon-secondary-color': 'Canvas' // background
        }
    }
});
var $6e9dc953b4d1a5cc$var$primaryEqualsSecondaryHcmStyles = (0, $3dJ4i.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            '--icon-primary-color': 'Canvas' // foreground
        }
    }
});
var $6e9dc953b4d1a5cc$var$secondaryTransparentHcmStyles = (0, $3dJ4i.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            '--icon-secondary-color': 'transparent' // background
        }
    }
});
var $6e9dc953b4d1a5cc$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $3dJ4i.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $99nKa.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return (0, $3dJ4i.jsx)("span", (0, $c9bqK.default)({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $6e9dc953b4d1a5cc$var$_objectSpread({
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor || (0, $7VK5h.getBackground)()
        }, UNSAFE_margin ? {
            margin: UNSAFE_margin
        } : {})
    }, glyphProps, {
        css: [
            $6e9dc953b4d1a5cc$var$iconStyles,
            $6e9dc953b4d1a5cc$var$baseHcmStyles,
            primaryColor === secondaryColor && $6e9dc953b4d1a5cc$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === 'transparent' && $6e9dc953b4d1a5cc$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $3dJ4i.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                '> svg': dimensions
            })
        ]
    }));
});
var $6e9dc953b4d1a5cc$export$2e2bcd8739ae039 = $6e9dc953b4d1a5cc$export$f04a61298a47a40f;

});
parcelRegister("99nKa", function(module, exports) {
$parcel$export(module.exports, "commonSVGStyles", function () { return $6a975f54dd1d92db$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "getIconSize", function () { return $6a975f54dd1d92db$export$3eb7d6130acfda37; });

var $c8h0J = parcelRequire("c8h0J");

var $3dJ4i = parcelRequire("3dJ4i");
var $6a975f54dd1d92db$export$16374db1c3e6dfba = {
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: 'currentColor'
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $6a975f54dd1d92db$var$smallStyles = (0, $3dJ4i.css)((0, $c8h0J.dimensions).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $6a975f54dd1d92db$var$mediumStyles = (0, $3dJ4i.css)((0, $c8h0J.dimensions).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $6a975f54dd1d92db$var$largeStyles = (0, $3dJ4i.css)((0, $c8h0J.dimensions).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $6a975f54dd1d92db$var$xlargeStyles = (0, $3dJ4i.css)((0, $c8h0J.dimensions).xlarge);
var $6a975f54dd1d92db$export$ef0ad74202575b64 = {
    small: $6a975f54dd1d92db$var$smallStyles,
    medium: $6a975f54dd1d92db$var$mediumStyles,
    large: $6a975f54dd1d92db$var$largeStyles,
    xlarge: $6a975f54dd1d92db$var$xlargeStyles
};
var $6a975f54dd1d92db$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $c8h0J.dimensions)[size];
    return undefined;
};

});
parcelRegister("c8h0J", function(module, exports) {
$parcel$export(module.exports, "dimensions", function () { return $8d536d66a3eddfa9$export$62ad7b0c781000e9; });
var $8d536d66a3eddfa9$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
var $8d536d66a3eddfa9$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
var $8d536d66a3eddfa9$export$62ad7b0c781000e9 = {
    small: {
        width: $8d536d66a3eddfa9$export$c647cb0ee6e282fe.small,
        height: $8d536d66a3eddfa9$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $8d536d66a3eddfa9$export$c647cb0ee6e282fe.medium,
        height: $8d536d66a3eddfa9$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $8d536d66a3eddfa9$export$c647cb0ee6e282fe.large,
        height: $8d536d66a3eddfa9$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $8d536d66a3eddfa9$export$c647cb0ee6e282fe.xlarge,
        height: $8d536d66a3eddfa9$export$c647cb0ee6e282fe.xlarge
    }
};

});


parcelRegister("7VK5h", function(module, exports) {
$parcel$export(module.exports, "getBackground", function () { return $5c619aa47a404f96$export$18cb9425622d4e06; });
var $5c619aa47a404f96$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};

});



parcelRegister("dMIFv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3c58509c5f883b07cf4640f47a045782>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a092684d424a0310$var$_react = $a092684d424a0310$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $a092684d424a0310$var$_UNSAFE_baseNew = $a092684d424a0310$var$_interopRequireDefault((parcelRequire("g4tDL")));
function $a092684d424a0310$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronDown".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a092684d424a0310$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $a092684d424a0310$var$_react.default.createElement($a092684d424a0310$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.5 4.5 8.25 6.75 6 9 3.75 6.75 1.5 4.5"/>`,
        type: 'utility'
    }, props));
$a092684d424a0310$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $a092684d424a0310$var$_default = module.exports.default = $a092684d424a0310$var$ChevronDownIcon;

});
parcelRegister("g4tDL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return (parcelRequire("84SDF")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("84SDF")).Icon; });

var $84SDF = parcelRequire("84SDF");

});
parcelRegister("84SDF", function(module, exports) {
$parcel$export(module.exports, "Icon", function () { return $5e1914948672238d$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $5e1914948672238d$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $75Hol = parcelRequire("75Hol");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $5e1914948672238d$var$commonSVGStyles = (0, $3dJ4i.css)({
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: 'currentColor'
    }
});
var $5e1914948672238d$var$svgStyles = (0, $3dJ4i.css)({
    color: 'currentColor',
    verticalAlign: 'bottom'
});
var $5e1914948672238d$var$iconStyles = (0, $3dJ4i.css)({
    display: 'inline-block',
    boxSizing: 'border-box',
    flexShrink: 0,
    lineHeight: 1,
    paddingInlineEnd: 'var(--ds--button--new-icon-padding-end, 0)',
    paddingInlineStart: 'var(--ds--button--new-icon-padding-start, 0)'
});
var $5e1914948672238d$var$utilityIconStyles = (0, $3dJ4i.css)({
    lineHeight: "var(--ds-space-150, 12px)"
});
var $5e1914948672238d$var$scaleStyles = (0, $3dJ4i.css)({
    width: 'inherit',
    height: 'inherit'
});
/**
 * For windows high contrast mode
 */ var $5e1914948672238d$var$baseHcmStyles = (0, $3dJ4i.css)({
    '@media screen and (forced-colors: active)': {
        color: 'CanvasText',
        filter: 'grayscale(1)'
    }
});
var $5e1914948672238d$var$scaleSize = (0, $3dJ4i.css)({
    width: 'inherit',
    height: 'inherit'
});
var $5e1914948672238d$var$sizeMap = {
    core: {
        none: (0, $3dJ4i.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $3dJ4i.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    },
    utility: {
        none: (0, $3dJ4i.css)({
            width: "var(--ds-space-150, 12px)",
            height: "var(--ds-space-150, 12px)"
        }),
        compact: (0, $3dJ4i.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $3dJ4i.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    }
};
var $5e1914948672238d$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $5e1914948672238d$var$paddingMap = {
    core: {
        none: 0,
        spacious: 4
    },
    utility: {
        none: 0,
        compact: 2,
        spacious: 6
    }
};
var $5e1914948672238d$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _props$type, _props$spacing3, _props$spacing4;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $75Hol.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return (0, $3dJ4i.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var baseSize = $5e1914948672238d$var$baseSizeMap[(_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core'];
    var viewBoxPadding;
    if (props.type === 'utility') {
        var _props$spacing;
        viewBoxPadding = $5e1914948672238d$var$paddingMap[props.type][(_props$spacing = props.spacing) !== null && _props$spacing !== void 0 ? _props$spacing : 'none'];
    } else {
        var _props$spacing2;
        viewBoxPadding = $5e1914948672238d$var$paddingMap['core'][(_props$spacing2 = props.spacing) !== null && _props$spacing2 !== void 0 ? _props$spacing2 : 'none'];
    }
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    var iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = "\n<filter id=\"ds-newIconOpacityFilter\">\n  <feFlood flood-color=\"var(--ds-icon-disabled)\" />\n  <feComposite in2=\"SourceGraphic\" operator=\"in\" />\n</filter>\n<g filter=\"url(#ds-newIconOpacityFilter)\">\n  ".concat(dangerouslySetInnerHTML.__html, "\n</g>");
        iconColor = "var(--ds-icon, #44546F)";
    }
    return (0, $3dJ4i.jsx)("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $5e1914948672238d$var$iconStyles,
            $5e1914948672238d$var$baseHcmStyles,
            shouldScale && $5e1914948672238d$var$scaleStyles,
            props.type === 'utility' && $5e1914948672238d$var$utilityIconStyles
        ]
    }, (0, $3dJ4i.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $5e1914948672238d$var$commonSVGStyles,
            $5e1914948672238d$var$svgStyles,
            shouldScale ? $5e1914948672238d$var$scaleSize : props.type === 'utility' ? $5e1914948672238d$var$sizeMap[props.type][(_props$spacing3 = props.spacing) !== null && _props$spacing3 !== void 0 ? _props$spacing3 : 'none'] : $5e1914948672238d$var$sizeMap['core'][(_props$spacing4 = props.spacing) !== null && _props$spacing4 !== void 0 ? _props$spacing4 : 'none']
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $5e1914948672238d$export$2e2bcd8739ae039 = $5e1914948672238d$export$f04a61298a47a40f;

});




parcelRegister("3AD7Y", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $29d315d73757c614$export$2e2bcd8739ae039; });

var $fl9pk = parcelRequire("fl9pk");
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$29d315d73757c614$export$2e2bcd8739ae039 = (0, $fl9pk.Popup);

});
parcelRegister("fl9pk", function(module, exports) {
$parcel$export(module.exports, "Popup", function () { return $b2b01d4d00e2f2db$export$129a32eedafa97c5; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $30zJV = parcelRequire("30zJV");

var $gObAA = parcelRequire("gObAA");

var $ktjEI = parcelRequire("ktjEI");

var $75Hol = parcelRequire("75Hol");

var $8q4Jo = parcelRequire("8q4Jo");
var $kUCSO = parcelRequire("kUCSO");

var $bOHor = parcelRequire("bOHor");

var $8TumH = parcelRequire("8TumH");
var $aD1YA = parcelRequire("aD1YA");

var $S1Mxw = parcelRequire("S1Mxw");

var $hLnms = parcelRequire("hLnms");

var $iSC5R = parcelRequire("iSC5R");

var $iQ2sK = parcelRequire("iQ2sK");

var $73CYs = parcelRequire("73CYs");
var $b2b01d4d00e2f2db$var$defaultLayer = (0, $S1Mxw.layers).layer();
var $b2b01d4d00e2f2db$var$wrapperStyles = (0, $aD1YA.xcss)({
    position: 'relative'
});
var $b2b01d4d00e2f2db$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref) {
    var xcss = _ref.xcss, _ref$appearance = _ref.appearance, inAppearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, isOpen = _ref.isOpen, providedId = _ref.id, offset = _ref.offset, testId = _ref.testId, trigger = _ref.trigger, content = _ref.content, onClose = _ref.onClose, boundary = _ref.boundary, _ref$rootBoundary = _ref.rootBoundary, rootBoundary = _ref$rootBoundary === void 0 ? 'viewport' : _ref$rootBoundary, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, fallbackPlacements = _ref.fallbackPlacements, PopupContainer = _ref.popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? $b2b01d4d00e2f2db$var$defaultLayer : _ref$zIndex, _ref$shouldUseCapture = _ref.shouldUseCaptureOnOutsideClick, shouldUseCaptureOnOutsideClick = _ref$shouldUseCapture === void 0 ? false : _ref$shouldUseCapture, _ref$shouldRenderToPa = _ref.shouldRenderToParent, inShouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldDisableFoc = _ref.shouldDisableFocusLock, shouldDisableFocusLock = _ref$shouldDisableFoc === void 0 ? false : _ref$shouldDisableFoc, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport;
    var _useState = (0, $1oC0p.useState)(null), _useState2 = (0, $2qaZZ.default)(_useState, 2), triggerRef = _useState2[0], setTriggerRef = _useState2[1];
    var getMergedTriggerRef = (0, $iQ2sK.useGetMemoizedMergedTriggerRef)();
    var getMergedTriggerRefNew = (0, $73CYs.useGetMemoizedMergedTriggerRefNew)();
    var generatedId = (0, $30zJV.useId)();
    var _usePopupAppearance = (0, $iSC5R.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    }), appearance = _usePopupAppearance.appearance, shouldRenderToParent = _usePopupAppearance.shouldRenderToParent;
    var id = providedId || generatedId;
    (0, $ktjEI.useNotifyOpenLayerObserver)({
        isOpen: isOpen
    });
    var renderPopperWrapper = (0, $3dJ4i.jsx)((0, $gObAA.Layering), {
        isDisabled: false
    }, (0, $3dJ4i.jsx)((0, $hLnms.default), {
        xcss: xcss,
        appearance: appearance,
        content: content,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: PopupContainer,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
        shouldFitContainer: shouldFitContainer,
        shouldDisableFocusLock: shouldDisableFocusLock,
        shouldReturnFocus: shouldReturnFocus,
        triggerRef: triggerRef,
        strategy: shouldFitContainer ? 'absolute' : strategy,
        role: role,
        label: label,
        titleId: titleId,
        modifiers: modifiers,
        shouldFitViewport: shouldFitViewport
    }));
    var popupContent = (0, $3dJ4i.jsx)((0, $8q4Jo.Manager), null, (0, $3dJ4i.jsx)((0, $kUCSO.Reference), null, function(_ref2) {
        var ref = _ref2.ref;
        return trigger({
            ref: !(0, $75Hol.fg)('platform-design-system-popup-ref') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
            'aria-controls': isOpen ? id : undefined,
            'aria-expanded': isOpen,
            'aria-haspopup': role === 'dialog' && (0, $75Hol.fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
        });
    }), isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : (0, $3dJ4i.jsx)((0, $bOHor.default), {
        zIndex: zIndex
    }, renderPopperWrapper)));
    if (shouldFitContainer) return (0, $3dJ4i.jsx)((0, $8TumH.default), {
        xcss: $b2b01d4d00e2f2db$var$wrapperStyles
    }, popupContent);
    return popupContent;
});
var $b2b01d4d00e2f2db$export$2e2bcd8739ae039 = $b2b01d4d00e2f2db$export$129a32eedafa97c5;

});
parcelRegister("30zJV", function(module, exports) {
$parcel$export(module.exports, "useId", function () { return $230d185df06c280f$export$f680877a34711e37; });

var $2zYm4 = parcelRequire("2zYm4");

var $1oC0p = parcelRequire("1oC0p");

var $6JmtO = parcelRequire("6JmtO");

var $75Hol = parcelRequire("75Hol");
var $230d185df06c280f$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $230d185df06c280f$var$react18UseId = ($230d185df06c280f$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useId) !== null && $230d185df06c280f$var$_React$useId !== void 0 ? $230d185df06c280f$var$_React$useId : undefined;
function $230d185df06c280f$export$f680877a34711e37() {
    if ($230d185df06c280f$var$react18UseId && (0, $75Hol.fg)('platform.design-system-team.react-18-use-id_mn8q4')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $230d185df06c280f$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $6JmtO.useUID)());
}
var $230d185df06c280f$export$6be90bcb437e928f = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($230d185df06c280f$export$f680877a34711e37()).concat(postfix);
    (0, $1oC0p.useEffect)(function() {
        if (!ref) return;
        switch((0, $2zYm4.default)(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, $2zYm4.default)(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $230d185df06c280f$export$6ee17796e3d70de2() {
    if ($230d185df06c280f$var$react18UseId && (0, $75Hol.fg)('platform.design-system-team.react-18-use-id_mn8q4')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $230d185df06c280f$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $6JmtO.useUIDSeed)();
}

});

parcelRegister("gObAA", function(module, exports) {
$parcel$export(module.exports, "LevelContext", function () { return $c3ca4e37a7551b2f$export$650d12d3c2ddb8fc; });
$parcel$export(module.exports, "TopLevelContext", function () { return $c3ca4e37a7551b2f$export$48b383b280e20440; });
$parcel$export(module.exports, "Layering", function () { return $c3ca4e37a7551b2f$export$7c885f891c940977; });

var $1oC0p = parcelRequire("1oC0p");

var $3eigd = parcelRequire("3eigd");
var $c3ca4e37a7551b2f$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $1oC0p.createContext)(0);
var $c3ca4e37a7551b2f$export$48b383b280e20440 = /*#__PURE__*/ (0, $1oC0p.createContext)({
    topLevelRef: {
        current: null
    },
    setTopLevel: (0, $3eigd.default)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $c3ca4e37a7551b2f$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $1oC0p.useContext)($c3ca4e37a7551b2f$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel, topLevelRef = _useContext.topLevelRef;
    if (topLevelRef.current === null || currentLevel > topLevelRef.current) setTopLevel(currentLevel);
    (0, $1oC0p.useEffect)(function() {
        return function() {
            setTopLevel(currentLevel - 1);
        };
    }, [
        setTopLevel,
        currentLevel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($c3ca4e37a7551b2f$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $c3ca4e37a7551b2f$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $1oC0p.useRef)(0);
    var value = (0, $1oC0p.useMemo)(function() {
        return {
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        };
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($c3ca4e37a7551b2f$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $c3ca4e37a7551b2f$export$7c885f891c940977 = function Layering(_ref3) {
    var children = _ref3.children, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? true : _ref3$isDisabled;
    var currentLevel = (0, $1oC0p.useContext)($c3ca4e37a7551b2f$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($c3ca4e37a7551b2f$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($c3ca4e37a7551b2f$var$LayeringProvider, null, content);
};

});
parcelRegister("3eigd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $25a0d81529711562$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $25a0d81529711562$export$2e2bcd8739ae039() {}

});


parcelRegister("ktjEI", function(module, exports) {
$parcel$export(module.exports, "useNotifyOpenLayerObserver", function () { return $ee75c34cb64e791d$export$469bb693f11edc7f; });

var $1oC0p = parcelRequire("1oC0p");

var $b1DC5 = parcelRequire("b1DC5");
function $ee75c34cb64e791d$export$469bb693f11edc7f() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$isOpen = _ref.isOpen, isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen;
    var context = (0, $1oC0p.useContext)((0, $b1DC5.OpenLayerObserverContext));
    (0, $1oC0p.useEffect)(function() {
        if (context === null) return;
        if (!isOpen) return;
        context.increment();
        return function() {
            context.decrement();
        };
    }, [
        context,
        isOpen
    ]);
}

});
parcelRegister("b1DC5", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverContext", function () { return $806e8417c5dbd607$export$5fbf4d7fae6cdc00; });

var $1oC0p = parcelRequire("1oC0p");
var $806e8417c5dbd607$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});


parcelRegister("kUCSO", function(module, exports) {
$parcel$export(module.exports, "Reference", function () { return $f39732ff1e24afd6$export$e0be378c32fb70a7; });

var $1oC0p = parcelRequire("1oC0p");

var $at85i = parcelRequire("at85i");

var $8q4Jo = parcelRequire("8q4Jo");

var $elwQc = parcelRequire("elwQc");
function $f39732ff1e24afd6$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $1oC0p.useContext((0, $8q4Jo.ManagerReferenceNodeSetterContext));
    var refHandler = $1oC0p.useCallback(function(node) {
        (0, $elwQc.setRef)(innerRef, node);
        (0, $elwQc.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $1oC0p.useEffect(function() {
        return function() {
            return (0, $elwQc.setRef)(innerRef, null);
        };
    }, []);
    $1oC0p.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($at85i)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $elwQc.unwrapArray)(children)({
        ref: refHandler
    });
}

});
parcelRegister("at85i", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $79f2e2331b9e0776$var$__DEV__ = false;
var $79f2e2331b9e0776$var$warning = function() {};
if ($79f2e2331b9e0776$var$__DEV__) {
    var $79f2e2331b9e0776$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $79f2e2331b9e0776$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $79f2e2331b9e0776$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $79f2e2331b9e0776$var$warning;

});


parcelRegister("bOHor", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $89a6063548764e50$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $75Hol = parcelRequire("75Hol");

var $ecdux = parcelRequire("ecdux");

var $c8ZEW = parcelRequire("c8ZEW");

var $2fHYl = parcelRequire("2fHYl");

var $1vaqr = parcelRequire("1vaqr");
function $89a6063548764e50$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy;
    var isSubsequentRender = (0, $2fHYl.default)(mountStrategy);
    (0, $1vaqr.default)(zIndex);
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    return !(0, $75Hol.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $ecdux.default), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $c8ZEW.default), {
        zIndex: zIndex
    }, children);
}

});
parcelRegister("ecdux", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a55ca6cc5935a3ed$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $gUjjH = parcelRequire("gUjjH");

var $3wCFO = parcelRequire("3wCFO");
function $a55ca6cc5935a3ed$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $1oC0p.useMemo)(function() {
        return (0, $3wCFO.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $3wCFO.appendPortalContainerIfNotAppended)(container);
    (0, $1oC0p.useEffect)(function() {
        return function() {
            (0, $3wCFO.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $gUjjH.createPortal)(children, container);
}

});
parcelRegister("3wCFO", function(module, exports) {
$parcel$export(module.exports, "createContainer", function () { return $29125bfd127c941e$export$26ae5ca175b4ec5a; });
$parcel$export(module.exports, "removePortalContainer", function () { return $29125bfd127c941e$export$da99f98bf3fe55b3; });
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", function () { return $29125bfd127c941e$export$c582005add11e141; });
$parcel$export(module.exports, "createAtlaskitPortal", function () { return $29125bfd127c941e$export$fef014d7cef9e543; });
$parcel$export(module.exports, "createPortalParent", function () { return $29125bfd127c941e$export$95029ca7aca2989e; });

var $3EiyE = parcelRequire("3EiyE");
var $29125bfd127c941e$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $3EiyE.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $29125bfd127c941e$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $29125bfd127c941e$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $3EiyE.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $3EiyE.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = $29125bfd127c941e$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $29125bfd127c941e$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $29125bfd127c941e$var$getPortalParent().removeChild(container);
};
var $29125bfd127c941e$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $29125bfd127c941e$var$getPortalParent().appendChild(container);
};
var $29125bfd127c941e$export$842dfe7a9f24298 = function isDocumentDefined() {
    return document !== undefined;
};
var $29125bfd127c941e$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($29125bfd127c941e$export$842dfe7a9f24298()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $3EiyE.portalClassName);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
};
var $29125bfd127c941e$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($29125bfd127c941e$export$842dfe7a9f24298()) {
        var parentElement = document.querySelector((0, $3EiyE.portalParentSelector));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement('div');
            parent.className = (0, $3EiyE.portalParentClassName);
            parent.style.display = 'flex';
            (_getBody2 = $29125bfd127c941e$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
};

});
parcelRegister("3EiyE", function(module, exports) {
$parcel$export(module.exports, "portalParentClassName", function () { return $2a8380b5e4929c6f$export$e4c79eb95c23a0da; });
$parcel$export(module.exports, "portalParentSelector", function () { return $2a8380b5e4929c6f$export$72f415121273627e; });
$parcel$export(module.exports, "portalClassName", function () { return $2a8380b5e4929c6f$export$13f57c02915787b3; });
var $2a8380b5e4929c6f$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $2a8380b5e4929c6f$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $2a8380b5e4929c6f$export$13f57c02915787b3 = 'atlaskit-portal';

});



parcelRegister("c8ZEW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8d760fab057ae04d$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $gUjjH = parcelRequire("gUjjH");

var $75Hol = parcelRequire("75Hol");

var $84Iq5 = parcelRequire("84Iq5");

var $3wCFO = parcelRequire("3wCFO");
function $8d760fab057ae04d$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $1oC0p.useState)(null), _useState2 = (0, $2qaZZ.default)(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $84Iq5.useIsomorphicLayoutEffect)(function() {
        var tempPortalContainer = (0, $3wCFO.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $3wCFO.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * Conditionally wrap ALL portal children with Suspense behind a feature gate for safe rollout.
   *
   * This is here because in React 18 concurrent, if you suspend from _within_ a portal to a
   * suspense boundary _outside_ a portal, our portal gets in an infinite loop of re-rendering.
   */ var conditionallySuspendedChildren = (0, $75Hol.fg)('platform_design_system_suspend_portal_children') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Suspense), {
        fallback: null
    }, children) : children;
    return atlaskitPortal ? /*#__PURE__*/ (0, $gUjjH.createPortal)(conditionallySuspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("84Iq5", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $5e1127466d847f77$export$700979bc83e7db82; });

var $1oC0p = parcelRequire("1oC0p");
var $5e1127466d847f77$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $1oC0p.useLayoutEffect) : (0, $1oC0p.useEffect);

});


parcelRegister("2fHYl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1a3f177e7f2c0110$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $84Iq5 = parcelRequire("84Iq5");
var $1a3f177e7f2c0110$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $2qaZZ.default)(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $84Iq5.useIsomorphicLayoutEffect) : (0, $1oC0p.useEffect);
    }), _useState4 = (0, $2qaZZ.default)(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $1a3f177e7f2c0110$export$2e2bcd8739ae039 = $1a3f177e7f2c0110$var$useIsSubsequentRender;

});

parcelRegister("1vaqr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1180c600177ad706$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $36uqy = parcelRequire("36uqy");

var $a1842 = parcelRequire("a1842");
var $1180c600177ad706$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $1oC0p.useEffect)(function() {
        (0, $a1842.default)((0, $36uqy.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $a1842.default)((0, $36uqy.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $1180c600177ad706$export$2e2bcd8739ae039 = $1180c600177ad706$var$useFirePortalEvent;

});
parcelRegister("36uqy", function(module, exports) {
$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", function () { return $242988e1f18f4a4d$export$ed5835cc67e87f72; });
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", function () { return $242988e1f18f4a4d$export$80816bd900e5bd00; });
var $242988e1f18f4a4d$export$ed5835cc67e87f72 = 'akPortalMount';
var $242988e1f18f4a4d$export$80816bd900e5bd00 = 'akPortalUnmount';

});

parcelRegister("a1842", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $74b040bbda3fecb9$export$2e2bcd8739ae039; });
var $74b040bbda3fecb9$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $74b040bbda3fecb9$var$getLayerName = function getLayerName(zIndex) {
    return $74b040bbda3fecb9$var$zIndexToName.hasOwnProperty(zIndex) ? $74b040bbda3fecb9$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $74b040bbda3fecb9$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $74b040bbda3fecb9$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $74b040bbda3fecb9$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $74b040bbda3fecb9$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("8TumH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $679b03ace15634fc$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $43hV2 = parcelRequire("43hV2");

var $4KSla = parcelRequire("4KSla");

var $aD1YA = parcelRequire("aD1YA");
var $679b03ace15634fc$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $679b03ace15634fc$var$_excluded2 = [
    "className"
];
var $679b03ace15634fc$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $gnQ3X.default)(_ref, $679b03ace15634fc$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $gnQ3X.default)(htmlAttributes, $679b03ace15634fc$var$_excluded2);
    var resolvedStyles = (0, $aD1YA.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $3dJ4i.jsx)(Component, (0, $c9bqK.default)({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $679b03ace15634fc$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $4KSla.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $4KSla.isSurfaceColorToken)(backgroundColor) && (0, $4KSla.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $4KSla.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $4KSla.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $4KSla.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $4KSla.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $4KSla.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $4KSla.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $4KSla.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $3dJ4i.jsx)((0, $43hV2.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $679b03ace15634fc$export$2e2bcd8739ae039 = $679b03ace15634fc$export$e71c4d32a2263218;
var $679b03ace15634fc$var$baseStyles = (0, $3dJ4i.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});

});
parcelRegister("43hV2", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", function () { return $2f35578d7236eab7$export$1ca2a26fecb070ae; });

var $1oC0p = parcelRequire("1oC0p");
var $2f35578d7236eab7$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1oC0p.createContext)('elevation.surface');
var $2f35578d7236eab7$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $1oC0p.useContext)($2f35578d7236eab7$export$1ca2a26fecb070ae);
};
$2f35578d7236eab7$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});

parcelRegister("4KSla", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", function () { return $37659c3016757dc6$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $37659c3016757dc6$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $37659c3016757dc6$export$632685d741f3dbbf; });
$parcel$export(module.exports, "opacityMap", function () { return $37659c3016757dc6$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $37659c3016757dc6$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $37659c3016757dc6$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $37659c3016757dc6$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $37659c3016757dc6$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $37659c3016757dc6$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $37659c3016757dc6$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $37659c3016757dc6$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "fontMap", function () { return $37659c3016757dc6$export$6ffa317d5e70375; });
$parcel$export(module.exports, "fontWeightMap", function () { return $37659c3016757dc6$export$303e322c6b1ed114; });
$parcel$export(module.exports, "fontFamilyMap", function () { return $37659c3016757dc6$export$3c7e9587132614b4; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $37659c3016757dc6$export$e615f061ca585a6c; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $37659c3016757dc6$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $37659c3016757dc6$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $37659c3016757dc6$export$5e65a44e5b6ecadb; });

var $f53LC = parcelRequire("f53LC");

var $3dJ4i = parcelRequire("3dJ4i");

var $BzqLb = parcelRequire("BzqLb");
function $37659c3016757dc6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $37659c3016757dc6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $37659c3016757dc6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $37659c3016757dc6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $37659c3016757dc6$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $37659c3016757dc6$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $37659c3016757dc6$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $37659c3016757dc6$export$632685d741f3dbbf = $37659c3016757dc6$var$_objectSpread($37659c3016757dc6$var$_objectSpread({}, $37659c3016757dc6$export$958d0ae7f2977ae4), $37659c3016757dc6$export$d2dc61f58390201c);
var $37659c3016757dc6$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $37659c3016757dc6$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $37659c3016757dc6$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $37659c3016757dc6$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $37659c3016757dc6$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $37659c3016757dc6$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $37659c3016757dc6$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $37659c3016757dc6$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $37659c3016757dc6$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $37659c3016757dc6$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
var $37659c3016757dc6$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
var $37659c3016757dc6$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $37659c3016757dc6$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $37659c3016757dc6$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $37659c3016757dc6$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $37659c3016757dc6$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $37659c3016757dc6$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $37659c3016757dc6$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $3dJ4i.css)((0, $f53LC.default)({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $37659c3016757dc6$export$e615f061ca585a6c = $37659c3016757dc6$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $37659c3016757dc6$export$ca0f9c2de39ffed7(spacingProperty, $37659c3016757dc6$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $37659c3016757dc6$export$bf46c3f9eeafc71f = $37659c3016757dc6$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $37659c3016757dc6$export$ca0f9c2de39ffed7(spacingProperty, $37659c3016757dc6$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $37659c3016757dc6$export$e7af83bafe7f9e63 = $37659c3016757dc6$export$ca0f9c2de39ffed7('backgroundColor', $37659c3016757dc6$export$d1d79bf68ac056bd);
var $37659c3016757dc6$export$3a1bcba60b23d7f0 = $37659c3016757dc6$export$ca0f9c2de39ffed7('color', $37659c3016757dc6$export$8473307aa00d6ea1);
var $37659c3016757dc6$export$45f3f4fe16f9f7d5 = $37659c3016757dc6$export$ca0f9c2de39ffed7('fontWeight', $37659c3016757dc6$export$303e322c6b1ed114);
var $37659c3016757dc6$export$68cc305da27dbaa4 = $37659c3016757dc6$export$ca0f9c2de39ffed7('fontFamily', $37659c3016757dc6$export$3c7e9587132614b4);
var $37659c3016757dc6$export$128f10c238242f83 = $37659c3016757dc6$export$ca0f9c2de39ffed7('font', $37659c3016757dc6$export$6ffa317d5e70375);
var $37659c3016757dc6$export$219d364c0da35ae4 = $37659c3016757dc6$export$ca0f9c2de39ffed7('font', $37659c3016757dc6$export$236bfe3a33ef1292);
var $37659c3016757dc6$export$38845ca010b93505 = $37659c3016757dc6$export$ca0f9c2de39ffed7('fontWeight', $37659c3016757dc6$export$855cfd311192d666);
var $37659c3016757dc6$export$ff257d957d48c421 = $37659c3016757dc6$export$ca0f9c2de39ffed7((0, $BzqLb.CURRENT_SURFACE_CSS_VAR), $37659c3016757dc6$export$41a358c9c2356760);
var $37659c3016757dc6$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $37659c3016757dc6$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("BzqLb", function(module, exports) {
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $070ef098f159d7d9$export$9d7b58831ae93caa; });
var $070ef098f159d7d9$export$4ef52930e33717cd = 'data-theme';
var $070ef098f159d7d9$export$a00eac3f8684bcd0 = 'data-color-mode';
var $070ef098f159d7d9$export$2112803007239c61 = 'data-contrast-mode';
var $070ef098f159d7d9$export$352e418ed5b6193a = 'data-custom-theme';
var $070ef098f159d7d9$export$2faeed762aac6741 = 'light';
var $070ef098f159d7d9$export$6f0c6fb8c80fcc92 = 'ds';
var $070ef098f159d7d9$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $070ef098f159d7d9$export$dddac1532e822863 = "--".concat($070ef098f159d7d9$export$6f0c6fb8c80fcc92, "-token-not-found");
var $070ef098f159d7d9$export$9d7b58831ae93caa = "--".concat($070ef098f159d7d9$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("aD1YA", function(module, exports) {
$parcel$export(module.exports, "parseXcss", function () { return $7bcf145201a917c7$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $7bcf145201a917c7$export$f6c783d06584602c; });

var $lFOXD = parcelRequire("lFOXD");

var $f53LC = parcelRequire("f53LC");

var $2qaZZ = parcelRequire("2qaZZ");

var $2zYm4 = parcelRequire("2zYm4");

var $3dJ4i = parcelRequire("3dJ4i");

var $4KSla = parcelRequire("4KSla");

var $7t0tI = parcelRequire("7t0tI");
function $7bcf145201a917c7$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $7bcf145201a917c7$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $7bcf145201a917c7$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $7bcf145201a917c7$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $7bcf145201a917c7$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $7bcf145201a917c7$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $7bcf145201a917c7$export$9a199fbafee0014e = {
    backgroundColor: (0, $4KSla.backgroundColorMap),
    blockSize: (0, $4KSla.dimensionMap),
    borderBlockColor: (0, $4KSla.borderColorMap),
    borderBlockEndColor: (0, $4KSla.borderColorMap),
    borderBlockEndWidth: (0, $4KSla.borderWidthMap),
    borderBlockStartColor: (0, $4KSla.borderColorMap),
    borderBlockStartWidth: (0, $4KSla.borderWidthMap),
    borderBlockWidth: (0, $4KSla.borderWidthMap),
    borderBottomColor: (0, $4KSla.borderColorMap),
    borderBottomLeftRadius: (0, $4KSla.borderRadiusMap),
    borderBottomRightRadius: (0, $4KSla.borderRadiusMap),
    borderBottomWidth: (0, $4KSla.borderWidthMap),
    borderColor: (0, $4KSla.borderColorMap),
    borderEndEndRadius: (0, $4KSla.borderRadiusMap),
    borderEndStartRadius: (0, $4KSla.borderRadiusMap),
    borderInlineColor: (0, $4KSla.borderColorMap),
    borderInlineEndColor: (0, $4KSla.borderColorMap),
    borderInlineEndWidth: (0, $4KSla.borderWidthMap),
    borderInlineStartColor: (0, $4KSla.borderColorMap),
    borderInlineStartWidth: (0, $4KSla.borderWidthMap),
    borderInlineWidth: (0, $4KSla.borderWidthMap),
    borderLeftColor: (0, $4KSla.borderColorMap),
    borderLeftWidth: (0, $4KSla.borderWidthMap),
    borderRadius: (0, $4KSla.borderRadiusMap),
    borderRightColor: (0, $4KSla.borderColorMap),
    borderRightWidth: (0, $4KSla.borderWidthMap),
    borderStartEndRadius: (0, $4KSla.borderRadiusMap),
    borderStartStartRadius: (0, $4KSla.borderRadiusMap),
    borderTopColor: (0, $4KSla.borderColorMap),
    borderTopLeftRadius: (0, $4KSla.borderRadiusMap),
    borderTopRightRadius: (0, $4KSla.borderRadiusMap),
    borderTopWidth: (0, $4KSla.borderWidthMap),
    borderWidth: (0, $4KSla.borderWidthMap),
    bottom: (0, $4KSla.allSpaceMap),
    boxShadow: (0, $4KSla.shadowMap),
    color: (0, $4KSla.textColorMap),
    columnGap: (0, $4KSla.positiveSpaceMap),
    font: (0, $4KSla.fontMap),
    fontFamily: (0, $4KSla.fontFamilyMap),
    fontWeight: (0, $4KSla.fontWeightMap),
    gap: (0, $4KSla.positiveSpaceMap),
    height: (0, $4KSla.dimensionMap),
    inlineSize: (0, $4KSla.dimensionMap),
    inset: (0, $4KSla.allSpaceMap),
    insetBlock: (0, $4KSla.allSpaceMap),
    insetBlockEnd: (0, $4KSla.allSpaceMap),
    insetBlockStart: (0, $4KSla.allSpaceMap),
    insetInline: (0, $4KSla.allSpaceMap),
    insetInlineEnd: (0, $4KSla.allSpaceMap),
    insetInlineStart: (0, $4KSla.allSpaceMap),
    left: (0, $4KSla.allSpaceMap),
    margin: (0, $4KSla.allSpaceMap),
    marginBlock: (0, $4KSla.allSpaceMap),
    marginBlockEnd: (0, $4KSla.allSpaceMap),
    marginBlockStart: (0, $4KSla.allSpaceMap),
    marginBottom: (0, $4KSla.allSpaceMap),
    marginInline: (0, $4KSla.allSpaceMap),
    marginInlineEnd: (0, $4KSla.allSpaceMap),
    marginInlineStart: (0, $4KSla.allSpaceMap),
    marginLeft: (0, $4KSla.allSpaceMap),
    marginRight: (0, $4KSla.allSpaceMap),
    marginTop: (0, $4KSla.allSpaceMap),
    maxBlockSize: (0, $4KSla.dimensionMap),
    maxHeight: (0, $4KSla.dimensionMap),
    maxInlineSize: (0, $4KSla.dimensionMap),
    maxWidth: (0, $4KSla.dimensionMap),
    minBlockSize: (0, $4KSla.dimensionMap),
    minHeight: (0, $4KSla.dimensionMap),
    minInlineSize: (0, $4KSla.dimensionMap),
    minWidth: (0, $4KSla.dimensionMap),
    opacity: (0, $4KSla.opacityMap),
    outlineColor: (0, $4KSla.borderColorMap),
    outlineOffset: (0, $4KSla.positiveSpaceMap),
    outlineWidth: (0, $4KSla.borderWidthMap),
    padding: (0, $4KSla.positiveSpaceMap),
    paddingBlock: (0, $4KSla.positiveSpaceMap),
    paddingBlockEnd: (0, $4KSla.positiveSpaceMap),
    paddingBlockStart: (0, $4KSla.positiveSpaceMap),
    paddingBottom: (0, $4KSla.positiveSpaceMap),
    paddingInline: (0, $4KSla.positiveSpaceMap),
    paddingInlineEnd: (0, $4KSla.positiveSpaceMap),
    paddingInlineStart: (0, $4KSla.positiveSpaceMap),
    paddingLeft: (0, $4KSla.positiveSpaceMap),
    paddingRight: (0, $4KSla.positiveSpaceMap),
    paddingTop: (0, $4KSla.positiveSpaceMap),
    right: (0, $4KSla.allSpaceMap),
    rowGap: (0, $4KSla.positiveSpaceMap),
    top: (0, $4KSla.allSpaceMap),
    width: (0, $4KSla.dimensionMap),
    zIndex: (0, $4KSla.layerMap)
};
var $7bcf145201a917c7$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $7bcf145201a917c7$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $7t0tI === "undefined" ? "undefined" : (0, $2zYm4.default)($7t0tI)) === 'object' && (0, $2zYm4.default)($7t0tI.env) === 'object' && false;
};
var $7bcf145201a917c7$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $7bcf145201a917c7$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $7bcf145201a917c7$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, $2zYm4.default)(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($7bcf145201a917c7$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, $2qaZZ.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, $2zYm4.default)(value) === 'object' && $7bcf145201a917c7$var$safeSelectors.test(key)) {
            styleObj[key] = $7bcf145201a917c7$var$_transformStyles(value);
            return;
        }
        if ($7bcf145201a917c7$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($7bcf145201a917c7$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $7bcf145201a917c7$export$9a199fbafee0014e)) return;
        var tokenValue = $7bcf145201a917c7$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $7bcf145201a917c7$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $7bcf145201a917c7$var$_transformStyles(style);
    return (0, $f53LC.default)({}, $7bcf145201a917c7$var$uniqueSymbol, (0, $3dJ4i.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $7bcf145201a917c7$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $7bcf145201a917c7$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $7bcf145201a917c7$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, $lFOXD.default)(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$7bcf145201a917c7$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $7bcf145201a917c7$export$f6c783d06584602c(style) {
    return $7bcf145201a917c7$var$baseXcss(style);
}

});


parcelRegister("S1Mxw", function(module, exports) {
$parcel$export(module.exports, "layers", function () { return $0a266d1bc9f44712$export$7be255094ccdc533; });

var $eD703 = parcelRequire("eD703");

var $gQlbM = parcelRequire("gQlbM");
var $0a266d1bc9f44712$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $0a266d1bc9f44712$export$c93026a968943f95 = 'light';
var $0a266d1bc9f44712$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $0a266d1bc9f44712$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $0a266d1bc9f44712$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $0a266d1bc9f44712$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $0a266d1bc9f44712$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $0a266d1bc9f44712$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $0a266d1bc9f44712$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $0a266d1bc9f44712$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $gQlbM.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $0a266d1bc9f44712$export$6d8204c2cb2e06b8() / 4;
    (0, $eD703.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $0a266d1bc9f44712$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $0a266d1bc9f44712$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $0a266d1bc9f44712$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $eD703.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $0a266d1bc9f44712$export$ba1d834b86d72a09 = $0a266d1bc9f44712$export$a1b3edb637fb4f35;
var $0a266d1bc9f44712$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $gQlbM.N20A), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $gQlbM.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $gQlbM.N30A), ")")
            }
        }
    };
};

});
parcelRegister("eD703", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $aa6a233985cbf060$export$2e2bcd8739ae039; });

var $gZxnj = parcelRequire("gZxnj");

var $7t0tI = parcelRequire("7t0tI");
function $aa6a233985cbf060$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $gZxnj.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $aa6a233985cbf060$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $7t0tI;
}

});
parcelRegister("gZxnj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c5ec3b6ce3a5858a$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $c5ec3b6ce3a5858a$var$printed = {};
function $c5ec3b6ce3a5858a$export$2e2bcd8739ae039(message) {
    if ($c5ec3b6ce3a5858a$var$printed[message]) return;
    $c5ec3b6ce3a5858a$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});


parcelRegister("gQlbM", function(module, exports) {
$parcel$export(module.exports, "B200", function () { return $c431f05b7e793820$export$215b7063051591f1; });
$parcel$export(module.exports, "N0", function () { return $c431f05b7e793820$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20A", function () { return $c431f05b7e793820$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $c431f05b7e793820$export$920c0d5c49070351; });
$parcel$export(module.exports, "N50A", function () { return $c431f05b7e793820$export$7d3359664e8bb0e5; });
$parcel$export(module.exports, "N60A", function () { return $c431f05b7e793820$export$d2d3bedfb276cac0; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $c431f05b7e793820$export$4b84fd0e2c617bd = '#FFEBE6';
var $c431f05b7e793820$export$b34b069eff244586 = '#FFBDAD';
var $c431f05b7e793820$export$be802dd0d8b57f35 = '#FF8F73';
var $c431f05b7e793820$export$60847d42f9da92a6 = '#FF7452';
var $c431f05b7e793820$export$4a7404f376229999 = '#FF5630';
var $c431f05b7e793820$export$2010d0fb4295b346 = '#DE350B';
var $c431f05b7e793820$export$2837b5a1a71d5c02 = '#BF2600';
var $c431f05b7e793820$export$8d9596b529bbb9cf = '#FFFAE6';
var $c431f05b7e793820$export$41060a744ab0b7ae = '#FFF0B3';
var $c431f05b7e793820$export$1cc05bbbf340e559 = '#FFE380';
var $c431f05b7e793820$export$5aae31392d72caaa = '#FFC400';
var $c431f05b7e793820$export$c6930421db9fa514 = '#FFAB00';
var $c431f05b7e793820$export$59619663aa6500fb = '#FF991F';
var $c431f05b7e793820$export$874739ea9e379ab6 = '#FF8B00';
var $c431f05b7e793820$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $c431f05b7e793820$export$69a3bf21b9686c2b = '#ABF5D1';
var $c431f05b7e793820$export$afbce1382ec95f73 = '#79F2C0';
var $c431f05b7e793820$export$747d86715d4175de = '#57D9A3';
var $c431f05b7e793820$export$940e1f69e873f202 = '#36B37E';
var $c431f05b7e793820$export$a49394138f7b8e85 = '#00875A';
var $c431f05b7e793820$export$6fa04827ac68a4fb = '#006644';
var $c431f05b7e793820$export$226de0355ed012f8 = '#DEEBFF';
var $c431f05b7e793820$export$8c13c2ee36917869 = '#B3D4FF';
var $c431f05b7e793820$export$ecfc1dff386a3e7a = '#4C9AFF';
var $c431f05b7e793820$export$215b7063051591f1 = '#2684FF';
var $c431f05b7e793820$export$e62e8919cca44969 = '#0065FF';
var $c431f05b7e793820$export$b3de0ae08da2ce64 = '#0052CC';
var $c431f05b7e793820$export$a6ee3d71bc067634 = '#0747A6';
var $c431f05b7e793820$export$67f15409e87642a1 = '#669DF1';
var $c431f05b7e793820$export$f0539dbc42dbb067 = '#8FB8F6';
var $c431f05b7e793820$export$363e4475840015bb = '#EAE6FF';
var $c431f05b7e793820$export$4b0a4417ed59760f = '#C0B6F2';
var $c431f05b7e793820$export$6011520a64d9a187 = '#998DD9';
var $c431f05b7e793820$export$a7175d4e9206bc80 = '#8777D9';
var $c431f05b7e793820$export$b48405b95304b5a1 = '#6554C0';
var $c431f05b7e793820$export$c71e4279dd54a18d = '#5243AA';
var $c431f05b7e793820$export$147899de772240ec = '#403294';
var $c431f05b7e793820$export$2cf711fe14c66f06 = '#E6FCFF';
var $c431f05b7e793820$export$7a8f4d33f6f9772c = '#B3F5FF';
var $c431f05b7e793820$export$776c9c497ef08533 = '#79E2F2';
var $c431f05b7e793820$export$69cb3ca10c1e330e = '#00C7E6';
var $c431f05b7e793820$export$9dc1ef0f3f48059b = '#00B8D9';
var $c431f05b7e793820$export$7c835c78b6fcdef8 = '#00A3BF';
var $c431f05b7e793820$export$6036577f95c3877e = '#008DA6';
var $c431f05b7e793820$export$29a4f05edc054374 = '#FFFFFF';
var $c431f05b7e793820$export$e655ef011c4aa1a2 = '#FAFBFC';
var $c431f05b7e793820$export$9fdfb749e33cdf97 = '#F4F5F7';
var $c431f05b7e793820$export$3e51e8f1440314ba = '#EBECF0';
var $c431f05b7e793820$export$1ce2d1575d444ceb = '#DFE1E6';
var $c431f05b7e793820$export$8754fc7e6d8b3000 = '#C1C7D0';
var $c431f05b7e793820$export$c2e91cbeada39b8b = '#B3BAC5';
var $c431f05b7e793820$export$5f71e19f3a7ad9de = '#A5ADBA';
var $c431f05b7e793820$export$eaa8c8a70ac22806 = '#97A0AF';
var $c431f05b7e793820$export$7c87d337fb91a97d = '#8993A4';
var $c431f05b7e793820$export$d6447c357493214f = '#7A869A';
var $c431f05b7e793820$export$f563ee71e9ee74cd = '#6B778C';
var $c431f05b7e793820$export$e2ef2124cf4024b1 = '#5E6C84';
var $c431f05b7e793820$export$eece5f492e429f08 = '#505F79';
var $c431f05b7e793820$export$c39c0fe0f26207ae = '#42526E';
var $c431f05b7e793820$export$7090862dc3038a9f = '#344563';
var $c431f05b7e793820$export$ad0bacf983b7ddaa = '#253858';
var $c431f05b7e793820$export$7d61b15e0da132af = '#172B4D';
var $c431f05b7e793820$export$fbda843f0a27fe96 = '#091E42';
var $c431f05b7e793820$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $c431f05b7e793820$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $c431f05b7e793820$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $c431f05b7e793820$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $c431f05b7e793820$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $c431f05b7e793820$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $c431f05b7e793820$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $c431f05b7e793820$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $c431f05b7e793820$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $c431f05b7e793820$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $c431f05b7e793820$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $c431f05b7e793820$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $c431f05b7e793820$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $c431f05b7e793820$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $c431f05b7e793820$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $c431f05b7e793820$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $c431f05b7e793820$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $c431f05b7e793820$export$2f6319cf7d736c2a = '#E6EDFA';
var $c431f05b7e793820$export$95126bc8884d6634 = '#DCE5F5';
var $c431f05b7e793820$export$8338d8c35d44ff1 = '#CED9EB';
var $c431f05b7e793820$export$5368d76ae4fbbda7 = '#B8C7E0';
var $c431f05b7e793820$export$9f0a771d16ec8d36 = '#ABBBD6';
var $c431f05b7e793820$export$abcf8c38338b4aa5 = '#9FB0CC';
var $c431f05b7e793820$export$97e81faa16a182c7 = '#8C9CB8';
var $c431f05b7e793820$export$bfe21c59123ecf33 = '#7988A3';
var $c431f05b7e793820$export$ee82aa2ea6a1558 = '#67758F';
var $c431f05b7e793820$export$682927c6ed76be02 = '#56637A';
var $c431f05b7e793820$export$91fd9994c5be9757 = '#455166';
var $c431f05b7e793820$export$d281fbfe3cff2df6 = '#3B475C';
var $c431f05b7e793820$export$3902c91d8b98a753 = '#313D52';
var $c431f05b7e793820$export$8e8133c1ba5845b5 = '#283447';
var $c431f05b7e793820$export$33ff357f6620b39 = '#202B3D';
var $c431f05b7e793820$export$633847cf062b69e0 = '#1B2638';
var $c431f05b7e793820$export$9776a6e503bdbf76 = '#121A29';
var $c431f05b7e793820$export$6c813d5160dff5db = '#0E1624';
var $c431f05b7e793820$export$3d4f271a500072a = '#0D1424';
var $c431f05b7e793820$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $c431f05b7e793820$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $c431f05b7e793820$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $c431f05b7e793820$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $c431f05b7e793820$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $c431f05b7e793820$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $c431f05b7e793820$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $c431f05b7e793820$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $c431f05b7e793820$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $c431f05b7e793820$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $c431f05b7e793820$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $c431f05b7e793820$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $c431f05b7e793820$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $c431f05b7e793820$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $c431f05b7e793820$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $c431f05b7e793820$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $c431f05b7e793820$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $c431f05b7e793820$export$d2adc5dedf09fced = '#292A2E';
var $c431f05b7e793820$export$f51762073d2bb381 = '#94C748';
var $c431f05b7e793820$export$95e26d54def96891 = '#B3DF72';

});


parcelRegister("hLnms", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cee8f28716f800bb$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $2qaZZ = parcelRequire("2qaZZ");

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $dOUTz = parcelRequire("dOUTz");

var $d2z7w = parcelRequire("d2z7w");

var $75Hol = parcelRequire("75Hol");

var $4VcAN = parcelRequire("4VcAN");

var $gQlbM = parcelRequire("gQlbM");

var $S1Mxw = parcelRequire("S1Mxw");

var $BzqLb = parcelRequire("BzqLb");

var $3ozbV = parcelRequire("3ozbV");

var $dDaCM = parcelRequire("dDaCM");

var $aLQgK = parcelRequire("aLQgK");
var $cee8f28716f800bb$var$_excluded = [
    "shouldRenderToParent",
    "shouldFitContainer",
    "children",
    "appearance",
    "xcss"
];
var $cee8f28716f800bb$var$fullWidthStyles = (0, $3dJ4i.css)({
    width: '100%'
});
var $cee8f28716f800bb$var$rootStyles = (0, $3dJ4i.css)((0, $f53LC.default)((0, $f53LC.default)({
    display: 'block',
    boxSizing: 'border-box',
    zIndex: (0, $S1Mxw.layers).layer(),
    backgroundColor: "var(--ds-surface-overlay, ".concat((0, $gQlbM.N0), ")"),
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 4px 8px -2px ".concat((0, $gQlbM.N50A), ", 0 0 1px ").concat((0, $gQlbM.N60A)), ")"),
    // Resetting text color for portal content.
    // Otherwise, when rendering into the parent (not using a portal),
    // the text color can be inherited from the parent.
    color: "var(--ds-text, #172B4D)"
}, (0, $BzqLb.CURRENT_SURFACE_CSS_VAR), "var(--ds-surface-overlay, ".concat((0, $gQlbM.N0), ")")), '&:focus', {
    outline: 'none'
}));
var $cee8f28716f800bb$var$scrollableStyles = (0, $3dJ4i.css)({
    overflow: 'auto'
});
var $cee8f28716f800bb$var$blanketStyles = (0, $3dJ4i.css)({
    position: 'fixed',
    inset: 0,
    backgroundColor: "var(--ds-blanket, #091E427D)"
});
var $cee8f28716f800bb$var$modalStyles = (0, $3dJ4i.css)({
    maxHeight: '50vh',
    position: 'fixed',
    insetBlockStart: "var(--ds-space-050, 4px)",
    insetInline: "var(--ds-space-050, 4px)"
});
var $cee8f28716f800bb$var$DefaultPopupComponent = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
    var shouldRenderToParent = props.shouldRenderToParent, shouldFitContainer = props.shouldFitContainer, children = props.children, appearance = props.appearance, xcss = props.xcss, htmlAttributes = (0, $gnQ3X.default)(props, $cee8f28716f800bb$var$_excluded);
    return (0, $3dJ4i.jsx)("div", (0, $c9bqK.default)({
        // We suppress this for now as we can't use the Compiled pragma until this module has migrated to Compiled.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @compiled/jsx-pragma
        className: xcss,
        css: [
            $cee8f28716f800bb$var$rootStyles,
            appearance === 'UNSAFE_modal-below-sm' && $cee8f28716f800bb$var$modalStyles,
            !shouldRenderToParent && $cee8f28716f800bb$var$scrollableStyles,
            shouldFitContainer && $cee8f28716f800bb$var$fullWidthStyles
        ]
    }, htmlAttributes, {
        ref: ref
    }), children);
});
function $cee8f28716f800bb$var$PopperWrapper(_ref) {
    var xcss = _ref.xcss, isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, content = _ref.content, fallbackPlacements = _ref.fallbackPlacements, onClose = _ref.onClose, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, shouldFlip = _ref.shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, _ref$popupComponent = _ref.popupComponent, PopupContainer = _ref$popupComponent === void 0 ? $cee8f28716f800bb$var$DefaultPopupComponent : _ref$popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, triggerRef = _ref.triggerRef, shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, shouldRenderToParent = _ref.shouldRenderToParent, shouldFitContainer = _ref.shouldFitContainer, shouldDisableFocusLock = _ref.shouldDisableFocusLock, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance;
    var _useState = (0, $1oC0p.useState)(null), _useState2 = (0, $2qaZZ.default)(_useState, 2), popupRef = _useState2[0], setPopupRef = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)(null), _useState4 = (0, $2qaZZ.default)(_useState3, 2), initialFocusRef = _useState4[0], setInitialFocusRef = _useState4[1];
    // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    var shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    var shouldDisableFocusTrap = role !== 'dialog';
    (0, $aLQgK.useFocusManager)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $dDaCM.useCloseManager)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    var _useLayering = (0, $d2z7w.useLayering)(), currentLevel = _useLayering.currentLevel;
    var mergedModifiers = (0, $1oC0p.useMemo)(function() {
        return [
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            }
        ].concat((0, $lFOXD.default)(modifiers || []));
    }, [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return (0, $3dJ4i.jsx)((0, $4VcAN.Popper), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    }, function(_ref2) {
        var _ref3 = _ref2.ref, style = _ref2.style, placement = _ref2.placement, update = _ref2.update;
        var popupContainer = (0, $3dJ4i.jsx)(PopupContainer, {
            xcss: xcss,
            appearance: appearance,
            id: id,
            "data-ds--level": currentLevel,
            "data-placement": placement,
            "data-testid": testId,
            role: role,
            "aria-label": label,
            "aria-labelledby": titleId,
            ref: function ref(node) {
                if (node) {
                    if (typeof _ref3 === 'function') _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            },
            style: appearance === 'UNSAFE_modal-below-sm' ? {} : style,
            tabIndex: autoFocus ? 0 : undefined,
            shouldRenderToParent: shouldRenderToParent,
            shouldFitContainer: shouldFitContainer
        }, (0, $3dJ4i.jsx)((0, $3ozbV.RepositionOnUpdate), {
            update: update
        }, content({
            update: update,
            isOpen: isOpen,
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        })));
        return !initialFocusRef && (0, $75Hol.fg)('platform-design-system-apply-popup-wrapper-focus') ? (0, $3dJ4i.jsx)((0, $1oC0p.Fragment), null, (0, $3dJ4i.jsx)((0, $dOUTz.default), null, popupContainer), appearance === 'UNSAFE_modal-below-sm' && (0, $3dJ4i.jsx)("div", {
            css: $cee8f28716f800bb$var$blanketStyles
        })) : (0, $3dJ4i.jsx)((0, $1oC0p.Fragment), null, popupContainer, appearance === 'UNSAFE_modal-below-sm' && (0, $3dJ4i.jsx)("div", {
            css: $cee8f28716f800bb$var$blanketStyles
        }));
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cee8f28716f800bb$export$2e2bcd8739ae039 = $cee8f28716f800bb$var$PopperWrapper;

});
parcelRegister("dOUTz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a0fc1417a6d9dd69$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");
var $a0fc1417a6d9dd69$var$BORDER_WIDTH = 2;
var $a0fc1417a6d9dd69$var$baseFocusOutsideStyles = (0, $3dJ4i.css)({
    outline: "".concat($a0fc1417a6d9dd69$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $a0fc1417a6d9dd69$var$BORDER_WIDTH
});
var $a0fc1417a6d9dd69$var$baseInsetStyles = (0, $3dJ4i.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$a0fc1417a6d9dd69$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $a0fc1417a6d9dd69$var$focusRingStyles = (0, $3dJ4i.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $a0fc1417a6d9dd69$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $a0fc1417a6d9dd69$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
var $a0fc1417a6d9dd69$var$insetFocusRingStyles = (0, $3dJ4i.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $a0fc1417a6d9dd69$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $a0fc1417a6d9dd69$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $a0fc1417a6d9dd69$var$FocusRing = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $a0fc1417a6d9dd69$var$baseInsetStyles : $a0fc1417a6d9dd69$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $a0fc1417a6d9dd69$var$insetFocusRingStyles : $a0fc1417a6d9dd69$var$focusRingStyles;
    var focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return (0, $3dJ4i.jsx)((0, $3dJ4i.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $1oC0p.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $1oC0p.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$a0fc1417a6d9dd69$var$FocusRing.displayName = 'FocusRing';
var $a0fc1417a6d9dd69$export$2e2bcd8739ae039 = $a0fc1417a6d9dd69$var$FocusRing;

});

parcelRegister("d2z7w", function(module, exports) {
$parcel$export(module.exports, "useLayering", function () { return $97e6b46b3cd87d00$export$c8b4d54e03dee6ed; });

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $gObAA = parcelRequire("gObAA");
var $97e6b46b3cd87d00$var$ESCAPE = 'Escape';
function $97e6b46b3cd87d00$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $1oC0p.useRef)(false);
    var _useLayering = $97e6b46b3cd87d00$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $1oC0p.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $97e6b46b3cd87d00$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $1oC0p.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $1oC0p.useEffect)(function() {
        return (0, $dH1HR.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $97e6b46b3cd87d00$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $1oC0p.useContext)((0, $gObAA.LevelContext));
    var _useContext = (0, $1oC0p.useContext)((0, $gObAA.TopLevelContext)), topLevelRef = _useContext.topLevelRef;
    var isLayerDisabled = (0, $1oC0p.useCallback)(function() {
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef
    ]);
    return {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    };
}

});

parcelRegister("4VcAN", function(module, exports) {
$parcel$export(module.exports, "Popper", function () { return $395640e49ee22726$export$badac9ada3a0bdf9; });

var $lFOXD = parcelRequire("lFOXD");

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $eVddu = parcelRequire("eVddu");

var $7CuQq = parcelRequire("7CuQq");

// Export types from PopperJS / React Popper
var $395640e49ee22726$var$viewportPadding = 5;
var $395640e49ee22726$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $395640e49ee22726$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $395640e49ee22726$var$defaultChildrenFn() {
    return null;
}
var $395640e49ee22726$var$defaultOffset = [
    0,
    8
];
function $395640e49ee22726$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $395640e49ee22726$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $395640e49ee22726$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, $2qaZZ.default)(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $1oC0p.useMemo)(function() {
        var preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $395640e49ee22726$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $7CuQq.getMaxSizeModifiers)({
            viewportPadding: $395640e49ee22726$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [].concat($395640e49ee22726$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, $lFOXD.default)(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $1oC0p.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, $lFOXD.default)(internalModifiers), (0, $lFOXD.default)(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eVddu.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});
parcelRegister("7CuQq", function(module, exports) {
$parcel$export(module.exports, "getMaxSizeModifiers", function () { return $58c402138e74a29a$export$6d8c2b45c99d6e3f; });

var $2qaZZ = parcelRequire("2qaZZ");
function $58c402138e74a29a$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== 'number' || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split('-'), _state$placement$spli2 = (0, $2qaZZ.default)(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}

});


parcelRegister("3ozbV", function(module, exports) {
$parcel$export(module.exports, "RepositionOnUpdate", function () { return $278ee9472108076e$export$51eddd7655ca235a; });

var $1oC0p = parcelRequire("1oC0p");
var $278ee9472108076e$export$51eddd7655ca235a = function RepositionOnUpdate(_ref) {
    var children = _ref.children, update = _ref.update;
    // Ref used here to skip update on first render (when refs haven't been set)
    var isFirstRenderRef = (0, $1oC0p.useRef)(true);
    (0, $1oC0p.useLayoutEffect)(function() {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, children);
};

});

parcelRegister("dDaCM", function(module, exports) {
$parcel$export(module.exports, "useCloseManager", function () { return $9ec728aaaa9729e0$export$92dae2778ae88f9d; });
// eslint-disable-next-line @typescript-eslint/consistent-type-imports

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $3eigd = parcelRequire("3eigd");

var $d2z7w = parcelRequire("d2z7w");

var $75Hol = parcelRequire("75Hol");

var $adEpy = parcelRequire("adEpy");

var $5shJX = parcelRequire("5shJX");
var $9ec728aaaa9729e0$export$92dae2778ae88f9d = function useCloseManager(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, capture = _ref.shouldUseCaptureOnOutsideClick, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useLayering = (0, $d2z7w.useLayering)(), isLayerDisabled = _useLayering.isLayerDisabled, currentLevel = _useLayering.currentLevel;
    var _useAnimationFrame = (0, $5shJX.useAnimationFrame)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    (0, $1oC0p.useEffect)(function() {
        if (!isOpen || !popupRef) return 0, $3eigd.default;
        var inIframe = window && window.self !== window.top && (0, $75Hol.fg)('fix-dropdown-close-outside-iframe');
        var closePopup = function closePopup(event) {
            if (onClose) {
                if ((0, $75Hol.fg)('sibling-dropdown-close-issue')) {
                    var _currentLevel = null;
                    if (event.target instanceof HTMLElement) {
                        var _event$target$closest;
                        _currentLevel = (_event$target$closest = event.target.closest("[data-ds--level]")) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.getAttribute('data-ds--level');
                    }
                    _currentLevel ? onClose(event, Number(_currentLevel)) : onClose(event);
                } else onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $75Hol.fg)('platform_dst_popup-disable-focuslock')) // Restoring the normal focus order for trigger.
            requestFrame(function() {
                triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '0');
                if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        var onClick = function onClick(event) {
            var target = event.target;
            var doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist && !inIframe) return;
            if (isLayerDisabled()) {
                if ((0, $75Hol.fg)('design-system-closed-all-when-click-outside')) {
                    if (target instanceof HTMLElement) {
                        var _target$closest;
                        var layeredElement = (_target$closest = target.closest) === null || _target$closest === void 0 ? void 0 : _target$closest.call(target, "[data-ds--level]");
                        if (layeredElement) {
                            var closeType = layeredElement.getAttribute('[data-ds--close--type]');
                            if (closeType === 'single') // if the close type is single, we won't close other disabled layers when clicking outside
                            return;
                            var levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                            if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // won't trigger onClick event when we click in a higher layer.
                            return;
                        }
                    }
                } else return;
            }
            var isClickOnPopup = popupRef && popupRef.contains(target);
            var isClickOnTrigger = triggerRef && triggerRef.contains(target);
            if (!isClickOnPopup && !isClickOnTrigger) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $adEpy.isInteractiveElement)(document.activeElement) && (0, $75Hol.fg)('platform_dst_popup-disable-focuslock')) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
            }
        };
        var onKeyDown = function onKeyDown(event) {
            if ((0, $75Hol.fg)('platform_dst_popup-disable-focuslock')) {
                var key = event.key, shiftKey = event.shiftKey;
                if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(function() {
                        var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
                        }
                    });
                    return;
                }
                if (key === 'Tab') {
                    var _document$activeEleme;
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && (_document$activeEleme = document.activeElement) !== null && _document$activeEleme !== void 0 && _document$activeEleme.closest('[aria-modal]')) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(function() {
                            var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(function() {
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc') {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                var _key = event.key;
                if (_key === 'Escape' || _key === 'Esc' || shouldCloseOnTab && _key === 'Tab') closePopup(event);
            }
        };
        var parentUnbind;
        // if the popup is inside iframe, we want to listen to click events outside iframe,
        // to close the popup correctly in the iframe.
        if (inIframe && isOpen) parentUnbind = (0, $dH1HR.bind)(window.parent.window, {
            type: 'click',
            listener: onClick,
            options: {
                capture: capture
            }
        });
        var unbind = (0, $dH1HR.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        var unbindBlur = (0, $3eigd.default);
        unbindBlur = (0, $dH1HR.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return function() {
            var _parentUnbind;
            cancelAllFrames();
            unbind();
            (_parentUnbind = parentUnbind) === null || _parentUnbind === void 0 || _parentUnbind();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};

});
parcelRegister("adEpy", function(module, exports) {
$parcel$export(module.exports, "isInteractiveElement", function () { return $770a7712642acd68$export$3dee5e4542c672d9; });
var $770a7712642acd68$var$interactiveTags = [
    'button',
    'a',
    'input',
    'select',
    'textarea'
];
var $770a7712642acd68$export$3dee5e4542c672d9 = function isInteractiveElement(element) {
    if ($770a7712642acd68$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
    return false;
};

});

parcelRegister("5shJX", function(module, exports) {
$parcel$export(module.exports, "useAnimationFrame", function () { return $3f8d541a8ee188e8$export$641fa9c94086b46e; });

var $1oC0p = parcelRequire("1oC0p");
var $3f8d541a8ee188e8$export$641fa9c94086b46e = function useAnimationFrame() {
    var animationsRef = (0, $1oC0p.useRef)([]);
    var requestFrame = (0, $1oC0p.useCallback)(function(callback) {
        var id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    var cancelFrame = (0, $1oC0p.useCallback)(function(id) {
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter(function(frameId) {
            return frameId !== id;
        });
    }, []);
    var cancelAllFrames = (0, $1oC0p.useCallback)(function() {
        animationsRef.current.forEach(function(id) {
            return cancelAnimationFrame(id);
        });
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};

});


parcelRegister("aLQgK", function(module, exports) {
$parcel$export(module.exports, "useFocusManager", function () { return $7d76d6b54eac463d$export$10c5169755ce7bd7; });

var $1oC0p = parcelRequire("1oC0p");

var $4b05t = parcelRequire("4b05t");

var $3eigd = parcelRequire("3eigd");

var $d2z7w = parcelRequire("d2z7w");

var $75Hol = parcelRequire("75Hol");

var $5shJX = parcelRequire("5shJX");
var $7d76d6b54eac463d$export$10c5169755ce7bd7 = function useFocusManager(_ref) {
    var initialFocusRef = _ref.initialFocusRef, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, shouldReturnFocus = _ref.shouldReturnFocus, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useAnimationFrame = (0, $5shJX.useAnimationFrame)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    var _useLayering = (0, $d2z7w.useLayering)(), currentLevel = _useLayering.currentLevel;
    (0, $1oC0p.useEffect)(function() {
        if (!popupRef || shouldCloseOnTab) return 0, $3eigd.default;
        if (shouldDisableFocusTrap && (0, $75Hol.fg)('platform_dst_popup-disable-focuslock')) {
            var isDropdown = popupRef.matches('[id^=ds--dropdown--]');
            var popups = document.querySelectorAll("[data-ds--level=\"".concat(currentLevel - 1, "\"]"));
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(function() {
                    triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '-1');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $3eigd.default;
            }
        }
        var trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        var focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($4b05t)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(function() {
            focusTrap.activate();
        });
        return function() {
            cancelAllFrames();
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};

});
parcelRegister("4b05t", function(module, exports) {

var $jSt0M = parcelRequire("jSt0M");
var $30a841da5660bc0e$var$listeningFocusTrap = null;
function $30a841da5660bc0e$var$focusTrap(element, userOptions) {
    var tabbableNodes = [];
    var firstTabbableNode = null;
    var lastTabbableNode = null;
    var nodeFocusedBeforeActivation = null;
    var active = false;
    var paused = false;
    var tabEvent = null;
    var container = typeof element === 'string' ? document.querySelector(element) : element;
    var config = userOptions || {};
    config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
    config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (active) return;
        var defaultedActivateOptions = {
            onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
        };
        active = true;
        paused = false;
        nodeFocusedBeforeActivation = document.activeElement;
        if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!active) return;
        var defaultedDeactivateOptions = {
            returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
            onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
        };
        removeListeners();
        if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
        if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
            $30a841da5660bc0e$var$tryFocus(nodeFocusedBeforeActivation);
        }, 0);
        active = false;
        paused = false;
        return this;
    }
    function pause() {
        if (paused || !active) return;
        paused = true;
        removeListeners();
    }
    function unpause() {
        if (!paused || !active) return;
        paused = false;
        addListeners();
    }
    function addListeners() {
        if (!active) return;
        // There can be only one listening focus trap at a time
        if ($30a841da5660bc0e$var$listeningFocusTrap) $30a841da5660bc0e$var$listeningFocusTrap.pause();
        $30a841da5660bc0e$var$listeningFocusTrap = trap;
        updateTabbableNodes();
        // Ensure that the focused element doesn't capture the event that caused the focus trap activation
        setTimeout(function() {
            $30a841da5660bc0e$var$tryFocus(firstFocusNode());
        }, 0);
        document.addEventListener('focus', checkFocus, true);
        document.addEventListener('click', checkClick, true);
        document.addEventListener('mousedown', checkPointerDown, true);
        document.addEventListener('touchstart', checkPointerDown, true);
        document.addEventListener('keydown', checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!active || $30a841da5660bc0e$var$listeningFocusTrap !== trap) return;
        document.removeEventListener('focus', checkFocus, true);
        document.removeEventListener('click', checkClick, true);
        document.removeEventListener('mousedown', checkPointerDown, true);
        document.removeEventListener('touchstart', checkPointerDown, true);
        document.removeEventListener('keydown', checkKey, true);
        $30a841da5660bc0e$var$listeningFocusTrap = null;
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === 'string') {
            node = document.querySelector(optionValue);
            if (!node) throw new Error('`' + optionName + '` refers to no known node');
        }
        if (typeof optionValue === 'function') {
            node = optionValue();
            if (!node) throw new Error('`' + optionName + '` did not return a node');
        }
        return node;
    }
    function firstFocusNode() {
        var node;
        if (getNodeForOption('initialFocus') !== null) node = getNodeForOption('initialFocus');
        else if (container.contains(document.activeElement)) node = document.activeElement;
        else node = tabbableNodes[0] || getNodeForOption('fallbackFocus');
        if (!node) throw new Error('You can\'t have a focus-trap without at least one focusable element');
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event
    function checkPointerDown(e) {
        if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
            returnFocus: false
        });
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function checkFocus(e) {
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Checking for a blur method here resolves a Firefox issue (#15)
        if (typeof e.target.blur === 'function') e.target.blur();
        if (tabEvent) readjustFocus(tabEvent);
    }
    function checkKey(e) {
        if (e.key === 'Tab' || e.keyCode === 9) handleTab(e);
        if (config.escapeDeactivates !== false && $30a841da5660bc0e$var$isEscapeEvent(e)) deactivate();
    }
    function handleTab(e) {
        updateTabbableNodes();
        if (e.target.hasAttribute('tabindex') && Number(e.target.getAttribute('tabindex')) < 0) return tabEvent = e;
        e.preventDefault();
        var currentFocusIndex = tabbableNodes.indexOf(e.target);
        if (e.shiftKey) {
            if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return $30a841da5660bc0e$var$tryFocus(lastTabbableNode);
            return $30a841da5660bc0e$var$tryFocus(tabbableNodes[currentFocusIndex - 1]);
        }
        if (e.target === lastTabbableNode) return $30a841da5660bc0e$var$tryFocus(firstTabbableNode);
        $30a841da5660bc0e$var$tryFocus(tabbableNodes[currentFocusIndex + 1]);
    }
    function updateTabbableNodes() {
        tabbableNodes = $jSt0M(container);
        firstTabbableNode = tabbableNodes[0];
        lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
    }
    function readjustFocus(e) {
        if (e.shiftKey) return $30a841da5660bc0e$var$tryFocus(lastTabbableNode);
        $30a841da5660bc0e$var$tryFocus(firstTabbableNode);
    }
}
function $30a841da5660bc0e$var$isEscapeEvent(e) {
    return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}
function $30a841da5660bc0e$var$tryFocus(node) {
    if (!node || !node.focus) return;
    if (node === document.activeElement) return;
    node.focus();
    if (node.tagName.toLowerCase() === 'input') node.select();
}
module.exports = $30a841da5660bc0e$var$focusTrap;

});
parcelRegister("jSt0M", function(module, exports) {
module.exports = function(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var basicTabbables = [];
    var orderedTabbables = [];
    // A node is "available" if
    // - it's computed style
    var isUnavailable = $e78990932ff29185$var$createIsUnavailable(elementDocument);
    var candidateSelectors = [
        'input',
        'select',
        'a[href]',
        'textarea',
        'button',
        '[tabindex]'
    ];
    var candidates = el.querySelectorAll(candidateSelectors.join(','));
    if (options.includeContainer) {
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (candidateSelectors.some(function(candidateSelector) {
            return matches.call(el, candidateSelector);
        })) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var candidate, candidateIndexAttr, candidateIndex;
    for(var i = 0, l = candidates.length; i < l; i++){
        candidate = candidates[i];
        candidateIndexAttr = parseInt(candidate.getAttribute('tabindex'), 10);
        candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
        if (candidateIndex < 0 || candidate.tagName === 'INPUT' && candidate.type === 'hidden' || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
        if (candidateIndex === 0) basicTabbables.push(candidate);
        else orderedTabbables.push({
            index: i,
            tabIndex: candidateIndex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    });
    Array.prototype.push.apply(tabbableNodes, basicTabbables);
    return tabbableNodes;
};
function $e78990932ff29185$var$createIsUnavailable(elementDocument) {
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed
    var isOffCache = [];
    // "off" means `display: none;`, as opposed to "hidden",
    // which means `visibility: hidden;`. getComputedStyle
    // accurately reflects visiblity in context but not
    // "off" state, so we need to recursively check parents.
    function isOff(node, nodeComputedStyle) {
        if (node === elementDocument.documentElement) return false;
        // Find the cached node (Array.prototype.find not available in IE9)
        for(var i = 0, length = isOffCache.length; i < length; i++){
            if (isOffCache[i][0] === node) return isOffCache[i][1];
        }
        nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
        var result = false;
        if (nodeComputedStyle.display === 'none') result = true;
        else if (node.parentNode) result = isOff(node.parentNode);
        isOffCache.push([
            node,
            result
        ]);
        return result;
    }
    return function isUnavailable(node) {
        if (node === elementDocument.documentElement) return false;
        var computedStyle = elementDocument.defaultView.getComputedStyle(node);
        if (isOff(node, computedStyle)) return true;
        return computedStyle.visibility === 'hidden';
    };
}

});




parcelRegister("iSC5R", function(module, exports) {
$parcel$export(module.exports, "usePopupAppearance", function () { return $dbead1b4943b8ffe$export$4065aef1d79a5730; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $hNZaY = parcelRequire("hNZaY");
function $dbead1b4943b8ffe$export$4065aef1d79a5730(_ref) {
    var _appearance = _ref.appearance, _shouldRenderToParent = _ref.shouldRenderToParent;
    var mq = (0, $hNZaY.UNSAFE_useMediaQuery)('below.sm', function(e) {
        setIsSmallViewport(!!e.matches);
    });
    var _useState = (0, $1oC0p.useState)(!!(mq !== null && mq !== void 0 && mq.matches)), _useState2 = (0, $2qaZZ.default)(_useState, 2), isSmallViewport = _useState2[0], setIsSmallViewport = _useState2[1];
    var appearance = _appearance === 'UNSAFE_modal-below-sm' && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
    var shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}

});
parcelRegister("hNZaY", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useMediaQuery", function () { return $cf66778881cf97b9$export$49e55ae2c03d6045; });

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $6EMLh = parcelRequire("6EMLh");

var $61qAH = parcelRequire("61qAH");
var $cf66778881cf97b9$var$_window, $cf66778881cf97b9$var$_window$matchMedia, $cf66778881cf97b9$var$_window2, $cf66778881cf97b9$var$_window2$matchMedia, $cf66778881cf97b9$var$_window3, $cf66778881cf97b9$var$_window3$matchMedia, $cf66778881cf97b9$var$_window4, $cf66778881cf97b9$var$_window4$matchMedia, $cf66778881cf97b9$var$_window5, $cf66778881cf97b9$var$_window5$matchMedia, $cf66778881cf97b9$var$_window6, $cf66778881cf97b9$var$_window6$matchMedia, $cf66778881cf97b9$var$_window7, $cf66778881cf97b9$var$_window7$matchMedia, $cf66778881cf97b9$var$_window8, $cf66778881cf97b9$var$_window8$matchMedia, $cf66778881cf97b9$var$_window9, $cf66778881cf97b9$var$_window9$matchMedia, $cf66778881cf97b9$var$_window10, $cf66778881cf97b9$var$_window10$matchMedia, $cf66778881cf97b9$var$_window11, $cf66778881cf97b9$var$_window11$matchMedia;
var $cf66778881cf97b9$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : ($cf66778881cf97b9$var$_window = window) === null || $cf66778881cf97b9$var$_window === void 0 || ($cf66778881cf97b9$var$_window$matchMedia = $cf66778881cf97b9$var$_window.matchMedia) === null || $cf66778881cf97b9$var$_window$matchMedia === void 0 ? void 0 : $cf66778881cf97b9$var$_window$matchMedia.call($cf66778881cf97b9$var$_window, (0, $61qAH.UNSAFE_media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : ($cf66778881cf97b9$var$_window2 = window) === null || $cf66778881cf97b9$var$_window2 === void 0 || ($cf66778881cf97b9$var$_window2$matchMedia = $cf66778881cf97b9$var$_window2.matchMedia) === null || $cf66778881cf97b9$var$_window2$matchMedia === void 0 ? void 0 : $cf66778881cf97b9$var$_window2$matchMedia.call($cf66778881cf97b9$var$_window2, (0, $61qAH.UNSAFE_media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : ($cf66778881cf97b9$var$_window3 = window) === null || $cf66778881cf97b9$var$_window3 === void 0 || ($cf66778881cf97b9$var$_window3$matchMedia = $cf66778881cf97b9$var$_window3.matchMedia) === null || $cf66778881cf97b9$var$_window3$matchMedia === void 0 ? void 0 : $cf66778881cf97b9$var$_window3$matchMedia.call($cf66778881cf97b9$var$_window3, (0, $61qAH.UNSAFE_media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : ($cf66778881cf97b9$var$_window4 = window) === null || $cf66778881cf97b9$var$_window4 === void 0 || ($cf66778881cf97b9$var$_window4$matchMedia = $cf66778881cf97b9$var$_window4.matchMedia) === null || $cf66778881cf97b9$var$_window4$matchMedia === void 0 ? void 0 : $cf66778881cf97b9$var$_window4$matchMedia.call($cf66778881cf97b9$var$_window4, (0, $61qAH.UNSAFE_media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : ($cf66778881cf97b9$var$_window5 = window) === null || $cf66778881cf97b9$var$_window5 === void 0 || ($cf66778881cf97b9$var$_window5$matchMedia = $cf66778881cf97b9$var$_window5.matchMedia) === null || $cf66778881cf97b9$var$_window5$matchMedia === void 0 ? void 0 : $cf66778881cf97b9$var$_window5$matchMedia.call($cf66778881cf97b9$var$_window5, (0, $61qAH.UNSAFE_media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : ($cf66778881cf97b9$var$_window6 = window) === null || $cf66778881cf97b9$var$_window6 === void 0 || ($cf66778881cf97b9$var$_window6$matchMedia = $cf66778881cf97b9$var$_window6.matchMedia) === null || $cf66778881cf97b9$var$_window6$matchMedia === void 0 ? void 0 : $cf66778881cf97b9$var$_window6$matchMedia.call($cf66778881cf97b9$var$_window6, (0, $61qAH.UNSAFE_media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : ($cf66778881cf97b9$var$_window7 = window) === null || $cf66778881cf97b9$var$_window7 === void 0 || ($cf66778881cf97b9$var$_window7$matchMedia = $cf66778881cf97b9$var$_window7.matchMedia) === null || $cf66778881cf97b9$var$_window7$matchMedia === void 0 ? void 0 : $cf66778881cf97b9$var$_window7$matchMedia.call($cf66778881cf97b9$var$_window7, (0, $61qAH.UNSAFE_media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : ($cf66778881cf97b9$var$_window8 = window) === null || $cf66778881cf97b9$var$_window8 === void 0 || ($cf66778881cf97b9$var$_window8$matchMedia = $cf66778881cf97b9$var$_window8.matchMedia) === null || $cf66778881cf97b9$var$_window8$matchMedia === void 0 ? void 0 : $cf66778881cf97b9$var$_window8$matchMedia.call($cf66778881cf97b9$var$_window8, (0, $61qAH.UNSAFE_media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : ($cf66778881cf97b9$var$_window9 = window) === null || $cf66778881cf97b9$var$_window9 === void 0 || ($cf66778881cf97b9$var$_window9$matchMedia = $cf66778881cf97b9$var$_window9.matchMedia) === null || $cf66778881cf97b9$var$_window9$matchMedia === void 0 ? void 0 : $cf66778881cf97b9$var$_window9$matchMedia.call($cf66778881cf97b9$var$_window9, (0, $61qAH.UNSAFE_media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : ($cf66778881cf97b9$var$_window10 = window) === null || $cf66778881cf97b9$var$_window10 === void 0 || ($cf66778881cf97b9$var$_window10$matchMedia = $cf66778881cf97b9$var$_window10.matchMedia) === null || $cf66778881cf97b9$var$_window10$matchMedia === void 0 ? void 0 : $cf66778881cf97b9$var$_window10$matchMedia.call($cf66778881cf97b9$var$_window10, (0, $61qAH.UNSAFE_media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : ($cf66778881cf97b9$var$_window11 = window) === null || $cf66778881cf97b9$var$_window11 === void 0 || ($cf66778881cf97b9$var$_window11$matchMedia = $cf66778881cf97b9$var$_window11.matchMedia) === null || $cf66778881cf97b9$var$_window11$matchMedia === void 0 ? void 0 : $cf66778881cf97b9$var$_window11$matchMedia.call($cf66778881cf97b9$var$_window11, (0, $61qAH.UNSAFE_media).below.xl.replace('@media ', '').trim())
};
var $cf66778881cf97b9$export$49e55ae2c03d6045 = function UNSAFE_useMediaQuery(queryString, listener) {
    var listenerRef = (0, $1oC0p.useRef)(listener);
    (0, $1oC0p.useEffect)(function() {
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ var hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ var mq = $cf66778881cf97b9$var$queries[queryString];
    (0, $6EMLh.useLayoutEffect)(function() {
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $dH1HR.bind)(mq, {
            type: 'change',
            listener: function listener(event) {
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});
parcelRegister("6EMLh", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", function () { return $4d8c4d8dcec153d4$export$e5c5a5f917a5871c; });

var $1oC0p = parcelRequire("1oC0p");
var $4d8c4d8dcec153d4$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $1oC0p.useEffect) : (0, $1oC0p.useLayoutEffect);

});

parcelRegister("61qAH", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_media", function () { return $4627767a11a9284a$export$c881183ca713c214; });
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $4627767a11a9284a$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};
var $4627767a11a9284a$export$c881183ca713c214 = $4627767a11a9284a$export$987d49ffe1b0900f;

});



parcelRegister("iQ2sK", function(module, exports) {
$parcel$export(module.exports, "useGetMemoizedMergedTriggerRef", function () { return $db6efe5bed1e6982$export$7cc5c058dd769dff; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $dWJ7u = parcelRequire("dWJ7u");
var $db6efe5bed1e6982$export$7cc5c058dd769dff = function useGetMemoizedMergedTriggerRef() {
    var _useState = (0, $1oC0p.useState)(function() {
        return (0, $dWJ7u.default)(function(ref, setTriggerRef, isOpen) {
            return function(node) {
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, $2qaZZ.default)(_useState, 1), getMemoizedMergedTriggerRef = _useState2[0];
    return getMemoizedMergedTriggerRef;
};

});

parcelRegister("73CYs", function(module, exports) {
$parcel$export(module.exports, "useGetMemoizedMergedTriggerRefNew", function () { return $52370bacd9043c24$export$5d3a2de79e07b376; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $dWJ7u = parcelRequire("dWJ7u");
var $52370bacd9043c24$export$5d3a2de79e07b376 = function useGetMemoizedMergedTriggerRefNew() {
    var _useState = (0, $1oC0p.useState)(function() {
        return (0, $dWJ7u.default)(function(ref, setTriggerRef) {
            return function(node) {
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, $2qaZZ.default)(_useState, 1), getMemoizedMergedTriggerRefNew = _useState2[0];
    return getMemoizedMergedTriggerRefNew;
};

});



parcelRegister("aey2F", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $77359e3da7ef9360$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $adr5D = parcelRequire("adr5D");

var $4GEEE = parcelRequire("4GEEE");
var $9ZNh9 = parcelRequire("9ZNh9");

var $e9GJT = parcelRequire("e9GJT");

var $aS3sB = parcelRequire("aS3sB");

var $OUUyq = parcelRequire("OUUyq");

var $azgim = parcelRequire("azgim");
var $77359e3da7ef9360$var$spinnerContainerStyles = (0, $9ZNh9.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
var $77359e3da7ef9360$var$LoadingIndicator = function LoadingIndicator(_ref) {
    var _ref$statusLabel = _ref.statusLabel, statusLabel = _ref$statusLabel === void 0 ? 'Loading' : _ref$statusLabel, testId = _ref.testId;
    return (0, $3dJ4i.jsx)((0, $4GEEE.default), {
        xcss: $77359e3da7ef9360$var$spinnerContainerStyles
    }, (0, $3dJ4i.jsx)((0, $e9GJT.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
};
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ var $77359e3da7ef9360$var$MenuWrapper = function MenuWrapper(_ref2) {
    var children = _ref2.children, isLoading = _ref2.isLoading, maxHeight = _ref2.maxHeight, maxWidth = _ref2.maxWidth, onClose = _ref2.onClose, onUpdate = _ref2.onUpdate, statusLabel = _ref2.statusLabel, setInitialFocusRef = _ref2.setInitialFocusRef, shouldRenderToParent = _ref2.shouldRenderToParent, spacing = _ref2.spacing, testId = _ref2.testId, isTriggeredUsingKeyboard = _ref2.isTriggeredUsingKeyboard, autoFocus = _ref2.autoFocus;
    var _useContext = (0, $1oC0p.useContext)((0, $aS3sB.FocusManagerContext)), menuItemRefs = _useContext.menuItemRefs;
    var closeOnMenuItemClick = function closeOnMenuItemClick(e) {
        var isTargetMenuItemOrDecendant = menuItemRefs.some(function(menuItem) {
            var isCheckboxOrRadio = (0, $OUUyq.default)(menuItem) || (0, $azgim.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDecendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $1oC0p.useLayoutEffect)(function() {
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $1oC0p.useEffect)(function() {
        var _menuItemRefs$find;
        var firstFocusableRef = (_menuItemRefs$find = menuItemRefs.find(function(ref) {
            return !ref.hasAttribute('disabled');
        })) !== null && _menuItemRefs$find !== void 0 ? _menuItemRefs$find : null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef === null || firstFocusableRef === void 0 || firstFocusableRef.focus();
        setInitialFocusRef === null || setInitialFocusRef === void 0 || setInitialFocusRef(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return (0, $3dJ4i.jsx)((0, $adr5D.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && "".concat(testId, "--menu-group")
    }, isLoading ? (0, $3dJ4i.jsx)($77359e3da7ef9360$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && "".concat(testId, "--loading-indicator")
    }) : children);
};
var $77359e3da7ef9360$export$2e2bcd8739ae039 = $77359e3da7ef9360$var$MenuWrapper;

});
parcelRegister("adr5D", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $770021c68c23976a$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $3dJ4i = parcelRequire("3dJ4i");

var $rX2Mz = parcelRequire("rX2Mz");
var $770021c68c23976a$var$_excluded = [
    "isLoading",
    "maxWidth",
    "minWidth",
    "minHeight",
    "maxHeight",
    "testId",
    "role",
    "spacing",
    "className"
];
var $770021c68c23976a$var$baseStyles = (0, $3dJ4i.css)({
    display: 'flex',
    position: 'static',
    flexDirection: 'column',
    overflow: 'auto'
});
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $770021c68c23976a$var$MenuGroup = function MenuGroup(_ref) {
    var isLoading = _ref.isLoading, maxWidth = _ref.maxWidth, minWidth = _ref.minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, testId = _ref.testId, role = _ref.role, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'cozy' : _ref$spacing, UNSAFE_className = _ref.className, rest = (0, $gnQ3X.default)(_ref, $770021c68c23976a$var$_excluded);
    return (0, $3dJ4i.jsx)((0, $rX2Mz.SpacingContext).Provider, {
        value: spacing
    }, (0, $3dJ4i.jsx)((0, $rX2Mz.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "border"
    }, (0, $3dJ4i.jsx)("div", (0, $c9bqK.default)({
        "aria-busy": isLoading,
        style: {
            minWidth: minWidth,
            maxWidth: maxWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        },
        css: $770021c68c23976a$var$baseStyles,
        "data-testid": testId,
        role: role,
        className: UNSAFE_className
    }, rest))));
};
var $770021c68c23976a$export$2e2bcd8739ae039 = $770021c68c23976a$var$MenuGroup;

});

parcelRegister("OUUyq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0990d0ff96159c59$export$2e2bcd8739ae039; });
function $0990d0ff96159c59$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("azgim", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7b19d01fe6173fe3$export$2e2bcd8739ae039; });
function $7b19d01fe6173fe3$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("eY2pT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ae588b333e0b05bd$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $gfKh0 = parcelRequire("gfKh0");
var $ae588b333e0b05bd$export$756f795847463ebd = /*#__PURE__*/ (0, $1oC0p.createContext)({
    setItemState: (0, $gfKh0.default),
    getItemState: function getItemState() {
        return undefined;
    },
    setGroupState: (0, $gfKh0.default),
    getGroupState: function getGroupState() {
        return {};
    }
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ var $ae588b333e0b05bd$var$SelectionStore = function SelectionStore(props) {
    var children = props.children;
    var store = (0, $1oC0p.useRef)({});
    var context = (0, $1oC0p.useMemo)(function() {
        return {
            setItemState: function setItemState(group, id, value) {
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: function getItemState(group, id) {
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: function setGroupState(group, value) {
                store.current[group] = value;
            },
            getGroupState: function getGroupState(group) {
                return store.current[group] || {};
            }
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($ae588b333e0b05bd$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $ae588b333e0b05bd$export$2e2bcd8739ae039 = $ae588b333e0b05bd$var$SelectionStore;

});

parcelRegister("ce0eK", function(module, exports) {
$parcel$export(module.exports, "PREFIX", function () { return $8e66f9e1dda9a62a$export$8a682ae47622dbb9; });
$parcel$export(module.exports, "default", function () { return $8e66f9e1dda9a62a$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
var $8e66f9e1dda9a62a$export$8a682ae47622dbb9 = 'ds--dropdown--';
var $8e66f9e1dda9a62a$var$generateRandomString = function generateRandomString() {
    return(// Therefore, so there is no risk of mismatch
    // between server and client generated markup.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    "".concat($8e66f9e1dda9a62a$export$8a682ae47622dbb9).concat(Math.random().toString(16).substr(2, 8)));
};
function $8e66f9e1dda9a62a$export$2e2bcd8739ae039() {
    var cachedId = (0, $1oC0p.useRef)($8e66f9e1dda9a62a$var$generateRandomString());
    return cachedId.current;
}

});


parcelRegister("j9BEl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $df1c100df26f3bb5$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $7Zt4h = parcelRequire("7Zt4h");

var $kFuqb = parcelRequire("kFuqb");

var $3oV3g = parcelRequire("3oV3g");

var $7t0tI = parcelRequire("7t0tI");
var $df1c100df26f3bb5$var$ExportedAnalyticsContext = function ExportedAnalyticsContext(props) {
    var _process$env;
    var isModernContextEnabledEnv = typeof $7t0tI !== 'undefined' && $7t0tI !== null && ((_process$env = {}, _process$env === void 0) ? void 0 : _process$env['ANALYTICS_NEXT_MODERN_CONTEXT']);
    return isModernContextEnabledEnv || (0, $7Zt4h.getBooleanFF)('platform.analytics-next-use-modern-context_fqgbx') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3oV3g.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kFuqb.default), props);
};
var $df1c100df26f3bb5$export$2e2bcd8739ae039 = $df1c100df26f3bb5$var$ExportedAnalyticsContext;

});
parcelRegister("kFuqb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f0bf3c0a01f39e80$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $h4ELM = parcelRequire("h4ELM");

var $i7dvh = parcelRequire("i7dvh");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $4OgEb = parcelRequire("4OgEb");

var $bEiDG = parcelRequire("bEiDG");
function $f0bf3c0a01f39e80$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f0bf3c0a01f39e80$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $jlBwm.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $jlBwm.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $i3Ugd.default)(this, result);
    };
}
function $f0bf3c0a01f39e80$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f0bf3c0a01f39e80$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $f0bf3c0a01f39e80$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).func
};
var $f0bf3c0a01f39e80$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $f0bf3c0a01f39e80$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    (0, $i7dvh.default)(AnalyticsContext, _Component);
    var _super = $f0bf3c0a01f39e80$var$_createSuper(AnalyticsContext);
    function AnalyticsContext(props) {
        var _this;
        (0, $cTewU.default)(this, AnalyticsContext);
        _this = _super.call(this, props);
        (0, $f53LC.default)((0, $h4ELM.default)(_this), "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, $f53LC.default)((0, $h4ELM.default)(_this), "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $f0bf3c0a01f39e80$var$noop : _this$context$getAtla;
            return [].concat((0, $lFOXD.default)(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, $f53LC.default)((0, $h4ELM.default)(_this), "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $f0bf3c0a01f39e80$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, $avOEA.default)(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $bEiDG.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
    return AnalyticsContext;
}((0, $1oC0p.Component));
(0, $f53LC.default)($f0bf3c0a01f39e80$var$AnalyticsContext, "contextTypes", $f0bf3c0a01f39e80$var$ContextTypes);
(0, $f53LC.default)($f0bf3c0a01f39e80$var$AnalyticsContext, "childContextTypes", $f0bf3c0a01f39e80$var$ContextTypes);
var $f0bf3c0a01f39e80$export$2e2bcd8739ae039 = $f0bf3c0a01f39e80$var$AnalyticsContext;

});

parcelRegister("3oV3g", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $279fde3eadf46ed4$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");

var $e1T86 = parcelRequire("e1T86");

var $j10Ql = parcelRequire("j10Ql");
var $279fde3eadf46ed4$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $j10Ql.useTrackedRef)(data);
    var analyticsContext = (0, $e1T86.useAnalyticsContext)();
    var getAtlaskitAnalyticsContext = (0, $1oC0p.useCallback)(function() {
        return [].concat((0, $lFOXD.default)(analyticsContext.getAtlaskitAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        analyticsContext,
        dataRef
    ]);
    var value = (0, $1oC0p.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: analyticsContext.getAtlaskitAnalyticsEventHandlers
        };
    }, [
        analyticsContext,
        getAtlaskitAnalyticsContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $bEiDG.default).Provider, {
        value: value
    }, children);
};
var $279fde3eadf46ed4$export$2e2bcd8739ae039 = $279fde3eadf46ed4$var$AnalyticsContext;

});


parcelRegister("56Xlo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3b8b8bc15be3f933$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $f53LC = parcelRequire("f53LC");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $j9BEl = parcelRequire("j9BEl");
var $3b8b8bc15be3f933$var$_excluded = [
    "analyticsContext"
];
function $3b8b8bc15be3f933$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3b8b8bc15be3f933$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3b8b8bc15be3f933$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3b8b8bc15be3f933$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3b8b8bc15be3f933$var$withAnalyticsContext = function withAnalyticsContext(defaultData) {
    return function(WrappedComponent) {
        var WithAnalyticsContext = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
            var analyticsContext = _ref.analyticsContext, rest = (0, $gnQ3X.default)(_ref, $3b8b8bc15be3f933$var$_excluded);
            var analyticsData = (0, $1oC0p.useMemo)(function() {
                return $3b8b8bc15be3f933$var$_objectSpread($3b8b8bc15be3f933$var$_objectSpread({}, defaultData), analyticsContext);
            }, [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $j9BEl.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(WrappedComponent, (0, $c9bqK.default)({}, rest, {
                ref: ref
            })));
        });
        WithAnalyticsContext.displayName = "WithAnalyticsContext(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsContext;
    };
};
var $3b8b8bc15be3f933$export$2e2bcd8739ae039 = $3b8b8bc15be3f933$var$withAnalyticsContext;

});

parcelRegister("dmRJm", function(module, exports) {

var $kIM6T = parcelRequire("kIM6T");

var $l80hK = parcelRequire("l80hK");
/** Used to compose bitmasks for value comparisons. */ var $9bb70234e0ba2b91$var$COMPARE_PARTIAL_FLAG = 1, $9bb70234e0ba2b91$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $9bb70234e0ba2b91$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $kIM6T;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $l80hK(srcValue, objValue, $9bb70234e0ba2b91$var$COMPARE_PARTIAL_FLAG | $9bb70234e0ba2b91$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $9bb70234e0ba2b91$var$baseIsMatch;

});
parcelRegister("kIM6T", function(module, exports) {

var $eDehO = parcelRequire("eDehO");

var $3zPSM = parcelRequire("3zPSM");

var $lUcgp = parcelRequire("lUcgp");

var $kguP2 = parcelRequire("kguP2");

var $fy2QK = parcelRequire("fy2QK");

var $all0A = parcelRequire("all0A");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f15d3c6271cf3ba4$var$Stack(entries) {
    var data = this.__data__ = new $eDehO(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$f15d3c6271cf3ba4$var$Stack.prototype.clear = $3zPSM;
$f15d3c6271cf3ba4$var$Stack.prototype['delete'] = $lUcgp;
$f15d3c6271cf3ba4$var$Stack.prototype.get = $kguP2;
$f15d3c6271cf3ba4$var$Stack.prototype.has = $fy2QK;
$f15d3c6271cf3ba4$var$Stack.prototype.set = $all0A;
module.exports = $f15d3c6271cf3ba4$var$Stack;

});
parcelRegister("3zPSM", function(module, exports) {

var $eDehO = parcelRequire("eDehO");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $29ace2c6d3207ea0$var$stackClear() {
    this.__data__ = new $eDehO;
    this.size = 0;
}
module.exports = $29ace2c6d3207ea0$var$stackClear;

});

parcelRegister("lUcgp", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ff28573e0b4321e0$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $ff28573e0b4321e0$var$stackDelete;

});

parcelRegister("kguP2", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ec0d35f1384f2d1d$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $ec0d35f1384f2d1d$var$stackGet;

});

parcelRegister("fy2QK", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $b51c3de59d2ccb15$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $b51c3de59d2ccb15$var$stackHas;

});

parcelRegister("all0A", function(module, exports) {

var $eDehO = parcelRequire("eDehO");

var $8IbLS = parcelRequire("8IbLS");

var $jCpAW = parcelRequire("jCpAW");
/** Used as the size to enable large array optimizations. */ var $787c2968852d0c5a$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $787c2968852d0c5a$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $eDehO) {
        var pairs = data.__data__;
        if (!$8IbLS || pairs.length < $787c2968852d0c5a$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $jCpAW(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $787c2968852d0c5a$var$stackSet;

});


parcelRegister("l80hK", function(module, exports) {

var $7hoil = parcelRequire("7hoil");

var $lhaWD = parcelRequire("lhaWD");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $f61a90f977b56423$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$lhaWD(value) && !$lhaWD(other)) return value !== value && other !== other;
    return $7hoil(value, other, bitmask, customizer, $f61a90f977b56423$var$baseIsEqual, stack);
}
module.exports = $f61a90f977b56423$var$baseIsEqual;

});
parcelRegister("7hoil", function(module, exports) {

var $kIM6T = parcelRequire("kIM6T");

var $3KkwK = parcelRequire("3KkwK");

var $cPBh3 = parcelRequire("cPBh3");

var $l3vrq = parcelRequire("l3vrq");

var $fMIy0 = parcelRequire("fMIy0");

var $lPKNl = parcelRequire("lPKNl");

var $jGQxx = parcelRequire("jGQxx");

var $zh0e0 = parcelRequire("zh0e0");
/** Used to compose bitmasks for value comparisons. */ var $54ccf76346e2988e$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $54ccf76346e2988e$var$argsTag = '[object Arguments]', $54ccf76346e2988e$var$arrayTag = '[object Array]', $54ccf76346e2988e$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $54ccf76346e2988e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $54ccf76346e2988e$var$hasOwnProperty = $54ccf76346e2988e$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $54ccf76346e2988e$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $lPKNl(object), othIsArr = $lPKNl(other), objTag = objIsArr ? $54ccf76346e2988e$var$arrayTag : $fMIy0(object), othTag = othIsArr ? $54ccf76346e2988e$var$arrayTag : $fMIy0(other);
    objTag = objTag == $54ccf76346e2988e$var$argsTag ? $54ccf76346e2988e$var$objectTag : objTag;
    othTag = othTag == $54ccf76346e2988e$var$argsTag ? $54ccf76346e2988e$var$objectTag : othTag;
    var objIsObj = objTag == $54ccf76346e2988e$var$objectTag, othIsObj = othTag == $54ccf76346e2988e$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $jGQxx(object)) {
        if (!$jGQxx(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $kIM6T);
        return objIsArr || $zh0e0(object) ? $3KkwK(object, other, bitmask, customizer, equalFunc, stack) : $cPBh3(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $54ccf76346e2988e$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $54ccf76346e2988e$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $54ccf76346e2988e$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $kIM6T);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $kIM6T);
    return $l3vrq(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $54ccf76346e2988e$var$baseIsEqualDeep;

});
parcelRegister("3KkwK", function(module, exports) {

var $fTwME = parcelRequire("fTwME");

var $4PN4h = parcelRequire("4PN4h");

var $ivYUA = parcelRequire("ivYUA");
/** Used to compose bitmasks for value comparisons. */ var $2ba597420d1278c2$var$COMPARE_PARTIAL_FLAG = 1, $2ba597420d1278c2$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $2ba597420d1278c2$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $2ba597420d1278c2$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $2ba597420d1278c2$var$COMPARE_UNORDERED_FLAG ? new $fTwME : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$4PN4h(other, function(othValue, othIndex) {
                if (!$ivYUA(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = $2ba597420d1278c2$var$equalArrays;

});
parcelRegister("fTwME", function(module, exports) {

var $jCpAW = parcelRequire("jCpAW");

var $2oKKn = parcelRequire("2oKKn");

var $5Mfmc = parcelRequire("5Mfmc");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $b9256c387fc9b567$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $jCpAW;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$b9256c387fc9b567$var$SetCache.prototype.add = $b9256c387fc9b567$var$SetCache.prototype.push = $2oKKn;
$b9256c387fc9b567$var$SetCache.prototype.has = $5Mfmc;
module.exports = $b9256c387fc9b567$var$SetCache;

});
parcelRegister("2oKKn", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $1bf215ab674fc9e3$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $1bf215ab674fc9e3$var$setCacheAdd(value) {
    this.__data__.set(value, $1bf215ab674fc9e3$var$HASH_UNDEFINED);
    return this;
}
module.exports = $1bf215ab674fc9e3$var$setCacheAdd;

});

parcelRegister("5Mfmc", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $434d5905c0e2d285$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $434d5905c0e2d285$var$setCacheHas;

});


parcelRegister("4PN4h", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $3851fcc04e846b4d$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $3851fcc04e846b4d$var$arraySome;

});

parcelRegister("ivYUA", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d7aa5f0be688545e$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $d7aa5f0be688545e$var$cacheHas;

});


parcelRegister("cPBh3", function(module, exports) {

var $3MHuE = parcelRequire("3MHuE");

var $gEINE = parcelRequire("gEINE");

var $8tfJP = parcelRequire("8tfJP");

var $3KkwK = parcelRequire("3KkwK");

var $jFnRj = parcelRequire("jFnRj");

var $6ANrX = parcelRequire("6ANrX");
/** Used to compose bitmasks for value comparisons. */ var $957729547d2447c0$var$COMPARE_PARTIAL_FLAG = 1, $957729547d2447c0$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $957729547d2447c0$var$boolTag = '[object Boolean]', $957729547d2447c0$var$dateTag = '[object Date]', $957729547d2447c0$var$errorTag = '[object Error]', $957729547d2447c0$var$mapTag = '[object Map]', $957729547d2447c0$var$numberTag = '[object Number]', $957729547d2447c0$var$regexpTag = '[object RegExp]', $957729547d2447c0$var$setTag = '[object Set]', $957729547d2447c0$var$stringTag = '[object String]', $957729547d2447c0$var$symbolTag = '[object Symbol]';
var $957729547d2447c0$var$arrayBufferTag = '[object ArrayBuffer]', $957729547d2447c0$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $957729547d2447c0$var$symbolProto = $3MHuE ? $3MHuE.prototype : undefined, $957729547d2447c0$var$symbolValueOf = $957729547d2447c0$var$symbolProto ? $957729547d2447c0$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $957729547d2447c0$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $957729547d2447c0$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $957729547d2447c0$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $gEINE(object), new $gEINE(other))) return false;
            return true;
        case $957729547d2447c0$var$boolTag:
        case $957729547d2447c0$var$dateTag:
        case $957729547d2447c0$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $8tfJP(+object, +other);
        case $957729547d2447c0$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $957729547d2447c0$var$regexpTag:
        case $957729547d2447c0$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $957729547d2447c0$var$mapTag:
            var convert = $jFnRj;
        case $957729547d2447c0$var$setTag:
            var isPartial = bitmask & $957729547d2447c0$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $6ANrX);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $957729547d2447c0$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $3KkwK(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $957729547d2447c0$var$symbolTag:
            if ($957729547d2447c0$var$symbolValueOf) return $957729547d2447c0$var$symbolValueOf.call(object) == $957729547d2447c0$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $957729547d2447c0$var$equalByTag;

});
parcelRegister("gEINE", function(module, exports) {

var $bBiRC = parcelRequire("bBiRC");
/** Built-in value references. */ var $c203221415f41931$var$Uint8Array = $bBiRC.Uint8Array;
module.exports = $c203221415f41931$var$Uint8Array;

});

parcelRegister("jFnRj", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $e5145a8e0f796a13$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $e5145a8e0f796a13$var$mapToArray;

});

parcelRegister("6ANrX", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $4ccc7696483f6c7a$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $4ccc7696483f6c7a$var$setToArray;

});


parcelRegister("l3vrq", function(module, exports) {

var $lk7RV = parcelRequire("lk7RV");
/** Used to compose bitmasks for value comparisons. */ var $f5424466c6ee4aa5$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $f5424466c6ee4aa5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f5424466c6ee4aa5$var$hasOwnProperty = $f5424466c6ee4aa5$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $f5424466c6ee4aa5$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $f5424466c6ee4aa5$var$COMPARE_PARTIAL_FLAG, objProps = $lk7RV(object), objLength = objProps.length, othProps = $lk7RV(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $f5424466c6ee4aa5$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = $f5424466c6ee4aa5$var$equalObjects;

});
parcelRegister("lk7RV", function(module, exports) {

var $3eEUA = parcelRequire("3eEUA");

var $dgk1F = parcelRequire("dgk1F");

var $lrU6c = parcelRequire("lrU6c");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $f86191c8c7318196$var$getAllKeys(object) {
    return $3eEUA(object, $lrU6c, $dgk1F);
}
module.exports = $f86191c8c7318196$var$getAllKeys;

});
parcelRegister("3eEUA", function(module, exports) {

var $4jLK2 = parcelRequire("4jLK2");

var $lPKNl = parcelRequire("lPKNl");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $25b26a18cffa7dd2$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $lPKNl(object) ? result : $4jLK2(result, symbolsFunc(object));
}
module.exports = $25b26a18cffa7dd2$var$baseGetAllKeys;

});
parcelRegister("4jLK2", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $324df84505b66cc8$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $324df84505b66cc8$var$arrayPush;

});


parcelRegister("dgk1F", function(module, exports) {

var $eRDHU = parcelRequire("eRDHU");

var $hJ191 = parcelRequire("hJ191");
/** Used for built-in method references. */ var $9a7c4daf90bb6692$var$objectProto = Object.prototype;
/** Built-in value references. */ var $9a7c4daf90bb6692$var$propertyIsEnumerable = $9a7c4daf90bb6692$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $9a7c4daf90bb6692$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $9a7c4daf90bb6692$var$getSymbols = !$9a7c4daf90bb6692$var$nativeGetSymbols ? $hJ191 : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $eRDHU($9a7c4daf90bb6692$var$nativeGetSymbols(object), function(symbol) {
        return $9a7c4daf90bb6692$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $9a7c4daf90bb6692$var$getSymbols;

});
parcelRegister("eRDHU", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $ad24d0fa01a20a72$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $ad24d0fa01a20a72$var$arrayFilter;

});

parcelRegister("hJ191", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $ce7786e945828a84$var$stubArray() {
    return [];
}
module.exports = $ce7786e945828a84$var$stubArray;

});


parcelRegister("lrU6c", function(module, exports) {

var $94SbA = parcelRequire("94SbA");

var $6lsRO = parcelRequire("6lsRO");

var $6PGLN = parcelRequire("6PGLN");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $f9d7a2af603f46e5$var$keys(object) {
    return $6PGLN(object) ? $94SbA(object) : $6lsRO(object);
}
module.exports = $f9d7a2af603f46e5$var$keys;

});
parcelRegister("94SbA", function(module, exports) {

var $iNuX8 = parcelRequire("iNuX8");

var $8E4Q5 = parcelRequire("8E4Q5");

var $lPKNl = parcelRequire("lPKNl");

var $jGQxx = parcelRequire("jGQxx");

var $f6osf = parcelRequire("f6osf");

var $zh0e0 = parcelRequire("zh0e0");
/** Used for built-in method references. */ var $69be84fc2b0cc704$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $69be84fc2b0cc704$var$hasOwnProperty = $69be84fc2b0cc704$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $69be84fc2b0cc704$var$arrayLikeKeys(value, inherited) {
    var isArr = $lPKNl(value), isArg = !isArr && $8E4Q5(value), isBuff = !isArr && !isArg && $jGQxx(value), isType = !isArr && !isArg && !isBuff && $zh0e0(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $iNuX8(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $69be84fc2b0cc704$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $f6osf(key, length)))) result.push(key);
    return result;
}
module.exports = $69be84fc2b0cc704$var$arrayLikeKeys;

});
parcelRegister("iNuX8", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $daf4d02eccbf14e2$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $daf4d02eccbf14e2$var$baseTimes;

});

parcelRegister("8E4Q5", function(module, exports) {

var $jjQDv = parcelRequire("jjQDv");

var $lhaWD = parcelRequire("lhaWD");
/** Used for built-in method references. */ var $64b5d013d9ba84e9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $64b5d013d9ba84e9$var$hasOwnProperty = $64b5d013d9ba84e9$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $64b5d013d9ba84e9$var$propertyIsEnumerable = $64b5d013d9ba84e9$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $64b5d013d9ba84e9$var$isArguments = $jjQDv(function() {
    return arguments;
}()) ? $jjQDv : function(value) {
    return $lhaWD(value) && $64b5d013d9ba84e9$var$hasOwnProperty.call(value, 'callee') && !$64b5d013d9ba84e9$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $64b5d013d9ba84e9$var$isArguments;

});
parcelRegister("jjQDv", function(module, exports) {

var $2EKmr = parcelRequire("2EKmr");

var $lhaWD = parcelRequire("lhaWD");
/** `Object#toString` result references. */ var $e1089f2233a3dc7f$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $e1089f2233a3dc7f$var$baseIsArguments(value) {
    return $lhaWD(value) && $2EKmr(value) == $e1089f2233a3dc7f$var$argsTag;
}
module.exports = $e1089f2233a3dc7f$var$baseIsArguments;

});


parcelRegister("jGQxx", function(module, exports) {

var $bBiRC = parcelRequire("bBiRC");

var $jGSnE = parcelRequire("jGSnE");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $bBiRC.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $jGSnE;
module.exports = isBuffer;

});
parcelRegister("jGSnE", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $e55c1f6184e33c9b$var$stubFalse() {
    return false;
}
module.exports = $e55c1f6184e33c9b$var$stubFalse;

});


parcelRegister("zh0e0", function(module, exports) {

var $7g4Cm = parcelRequire("7g4Cm");

var $g6cIm = parcelRequire("g6cIm");

var $hn5WQ = parcelRequire("hn5WQ");
/* Node.js helper references. */ var $06a0755de8701d54$var$nodeIsTypedArray = $hn5WQ && $hn5WQ.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $06a0755de8701d54$var$isTypedArray = $06a0755de8701d54$var$nodeIsTypedArray ? $g6cIm($06a0755de8701d54$var$nodeIsTypedArray) : $7g4Cm;
module.exports = $06a0755de8701d54$var$isTypedArray;

});
parcelRegister("7g4Cm", function(module, exports) {

var $2EKmr = parcelRequire("2EKmr");

var $cTpmH = parcelRequire("cTpmH");

var $lhaWD = parcelRequire("lhaWD");
/** `Object#toString` result references. */ var $548d9bfca4c5bfe4$var$argsTag = '[object Arguments]', $548d9bfca4c5bfe4$var$arrayTag = '[object Array]', $548d9bfca4c5bfe4$var$boolTag = '[object Boolean]', $548d9bfca4c5bfe4$var$dateTag = '[object Date]', $548d9bfca4c5bfe4$var$errorTag = '[object Error]', $548d9bfca4c5bfe4$var$funcTag = '[object Function]', $548d9bfca4c5bfe4$var$mapTag = '[object Map]', $548d9bfca4c5bfe4$var$numberTag = '[object Number]', $548d9bfca4c5bfe4$var$objectTag = '[object Object]', $548d9bfca4c5bfe4$var$regexpTag = '[object RegExp]', $548d9bfca4c5bfe4$var$setTag = '[object Set]', $548d9bfca4c5bfe4$var$stringTag = '[object String]', $548d9bfca4c5bfe4$var$weakMapTag = '[object WeakMap]';
var $548d9bfca4c5bfe4$var$arrayBufferTag = '[object ArrayBuffer]', $548d9bfca4c5bfe4$var$dataViewTag = '[object DataView]', $548d9bfca4c5bfe4$var$float32Tag = '[object Float32Array]', $548d9bfca4c5bfe4$var$float64Tag = '[object Float64Array]', $548d9bfca4c5bfe4$var$int8Tag = '[object Int8Array]', $548d9bfca4c5bfe4$var$int16Tag = '[object Int16Array]', $548d9bfca4c5bfe4$var$int32Tag = '[object Int32Array]', $548d9bfca4c5bfe4$var$uint8Tag = '[object Uint8Array]', $548d9bfca4c5bfe4$var$uint8ClampedTag = '[object Uint8ClampedArray]', $548d9bfca4c5bfe4$var$uint16Tag = '[object Uint16Array]', $548d9bfca4c5bfe4$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $548d9bfca4c5bfe4$var$typedArrayTags = {};
$548d9bfca4c5bfe4$var$typedArrayTags[$548d9bfca4c5bfe4$var$float32Tag] = $548d9bfca4c5bfe4$var$typedArrayTags[$548d9bfca4c5bfe4$var$float64Tag] = $548d9bfca4c5bfe4$var$typedArrayTags[$548d9bfca4c5bfe4$var$int8Tag] = $548d9bfca4c5bfe4$var$typedArrayTags[$548d9bfca4c5bfe4$var$int16Tag] = $548d9bfca4c5bfe4$var$typedArrayTags[$548d9bfca4c5bfe4$var$int32Tag] = $548d9bfca4c5bfe4$var$typedArrayTags[$548d9bfca4c5bfe4$var$uint8Tag] = $548d9bfca4c5bfe4$var$typedArrayTags[$548d9bfca4c5bfe4$var$uint8ClampedTag] = $548d9bfca4c5bfe4$var$typedArrayTags[$548d9bfca4c5bfe4$var$uint16Tag] = $548d9bfca4c5bfe4$var$typedArrayTags[$548d9bfca4c5bfe4$var$uint32Tag] = true;
$548d9bfca4c5bfe4$var$typedArrayTags[$548d9bfca4c5bfe4$var$argsTag] = $548d9bfca4c5bfe4$var$typedArrayTags[$548d9bfca4c5bfe4$var$arrayTag] = $548d9bfca4c5bfe4$var$typedArrayTags[$548d9bfca4c5bfe4$var$arrayBufferTag] = $548d9bfca4c5bfe4$var$typedArrayTags[$548d9bfca4c5bfe4$var$boolTag] = $548d9bfca4c5bfe4$var$typedArrayTags[$548d9bfca4c5bfe4$var$dataViewTag] = $548d9bfca4c5bfe4$var$typedArrayTags[$548d9bfca4c5bfe4$var$dateTag] = $548d9bfca4c5bfe4$var$typedArrayTags[$548d9bfca4c5bfe4$var$errorTag] = $548d9bfca4c5bfe4$var$typedArrayTags[$548d9bfca4c5bfe4$var$funcTag] = $548d9bfca4c5bfe4$var$typedArrayTags[$548d9bfca4c5bfe4$var$mapTag] = $548d9bfca4c5bfe4$var$typedArrayTags[$548d9bfca4c5bfe4$var$numberTag] = $548d9bfca4c5bfe4$var$typedArrayTags[$548d9bfca4c5bfe4$var$objectTag] = $548d9bfca4c5bfe4$var$typedArrayTags[$548d9bfca4c5bfe4$var$regexpTag] = $548d9bfca4c5bfe4$var$typedArrayTags[$548d9bfca4c5bfe4$var$setTag] = $548d9bfca4c5bfe4$var$typedArrayTags[$548d9bfca4c5bfe4$var$stringTag] = $548d9bfca4c5bfe4$var$typedArrayTags[$548d9bfca4c5bfe4$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $548d9bfca4c5bfe4$var$baseIsTypedArray(value) {
    return $lhaWD(value) && $cTpmH(value.length) && !!$548d9bfca4c5bfe4$var$typedArrayTags[$2EKmr(value)];
}
module.exports = $548d9bfca4c5bfe4$var$baseIsTypedArray;

});
parcelRegister("cTpmH", function(module, exports) {
/** Used as references for various `Number` constants. */ var $962e4c171a5f9227$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $962e4c171a5f9227$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $962e4c171a5f9227$var$MAX_SAFE_INTEGER;
}
module.exports = $962e4c171a5f9227$var$isLength;

});


parcelRegister("g6cIm", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $bb8711b5cd7f6dcd$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $bb8711b5cd7f6dcd$var$baseUnary;

});

parcelRegister("hn5WQ", function(module, exports) {

var $aFUsE = parcelRequire("aFUsE");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $aFUsE.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("6lsRO", function(module, exports) {

var $1b6pL = parcelRequire("1b6pL");

var $5krLJ = parcelRequire("5krLJ");
/** Used for built-in method references. */ var $49eb189dccfc2005$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $49eb189dccfc2005$var$hasOwnProperty = $49eb189dccfc2005$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $49eb189dccfc2005$var$baseKeys(object) {
    if (!$1b6pL(object)) return $5krLJ(object);
    var result = [];
    for(var key in Object(object))if ($49eb189dccfc2005$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = $49eb189dccfc2005$var$baseKeys;

});
parcelRegister("1b6pL", function(module, exports) {
/** Used for built-in method references. */ var $0dbbcb4f4a621b20$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $0dbbcb4f4a621b20$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $0dbbcb4f4a621b20$var$objectProto;
    return value === proto;
}
module.exports = $0dbbcb4f4a621b20$var$isPrototype;

});

parcelRegister("5krLJ", function(module, exports) {

var $a8tXu = parcelRequire("a8tXu");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $3e145c4fb842c38f$var$nativeKeys = $a8tXu(Object.keys, Object);
module.exports = $3e145c4fb842c38f$var$nativeKeys;

});
parcelRegister("a8tXu", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $7611e3de64a60c21$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $7611e3de64a60c21$var$overArg;

});



parcelRegister("6PGLN", function(module, exports) {

var $i4iXI = parcelRequire("i4iXI");

var $cTpmH = parcelRequire("cTpmH");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $4f98aebb3298e821$var$isArrayLike(value) {
    return value != null && $cTpmH(value.length) && !$i4iXI(value);
}
module.exports = $4f98aebb3298e821$var$isArrayLike;

});




parcelRegister("fMIy0", function(module, exports) {

var $4w1PP = parcelRequire("4w1PP");

var $8IbLS = parcelRequire("8IbLS");

var $9R3rT = parcelRequire("9R3rT");

var $2a3F6 = parcelRequire("2a3F6");

var $614Hw = parcelRequire("614Hw");

var $2EKmr = parcelRequire("2EKmr");

var $j0oFE = parcelRequire("j0oFE");
/** `Object#toString` result references. */ var $b7dde4eb65678917$var$mapTag = '[object Map]', $b7dde4eb65678917$var$objectTag = '[object Object]', $b7dde4eb65678917$var$promiseTag = '[object Promise]', $b7dde4eb65678917$var$setTag = '[object Set]', $b7dde4eb65678917$var$weakMapTag = '[object WeakMap]';
var $b7dde4eb65678917$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $b7dde4eb65678917$var$dataViewCtorString = $j0oFE($4w1PP), $b7dde4eb65678917$var$mapCtorString = $j0oFE($8IbLS), $b7dde4eb65678917$var$promiseCtorString = $j0oFE($9R3rT), $b7dde4eb65678917$var$setCtorString = $j0oFE($2a3F6), $b7dde4eb65678917$var$weakMapCtorString = $j0oFE($614Hw);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $b7dde4eb65678917$var$getTag = $2EKmr;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($4w1PP && $b7dde4eb65678917$var$getTag(new $4w1PP(new ArrayBuffer(1))) != $b7dde4eb65678917$var$dataViewTag || $8IbLS && $b7dde4eb65678917$var$getTag(new $8IbLS) != $b7dde4eb65678917$var$mapTag || $9R3rT && $b7dde4eb65678917$var$getTag($9R3rT.resolve()) != $b7dde4eb65678917$var$promiseTag || $2a3F6 && $b7dde4eb65678917$var$getTag(new $2a3F6) != $b7dde4eb65678917$var$setTag || $614Hw && $b7dde4eb65678917$var$getTag(new $614Hw) != $b7dde4eb65678917$var$weakMapTag) $b7dde4eb65678917$var$getTag = function(value) {
    var result = $2EKmr(value), Ctor = result == $b7dde4eb65678917$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $j0oFE(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $b7dde4eb65678917$var$dataViewCtorString:
            return $b7dde4eb65678917$var$dataViewTag;
        case $b7dde4eb65678917$var$mapCtorString:
            return $b7dde4eb65678917$var$mapTag;
        case $b7dde4eb65678917$var$promiseCtorString:
            return $b7dde4eb65678917$var$promiseTag;
        case $b7dde4eb65678917$var$setCtorString:
            return $b7dde4eb65678917$var$setTag;
        case $b7dde4eb65678917$var$weakMapCtorString:
            return $b7dde4eb65678917$var$weakMapTag;
    }
    return result;
};
module.exports = $b7dde4eb65678917$var$getTag;

});
parcelRegister("4w1PP", function(module, exports) {

var $4jmfA = parcelRequire("4jmfA");

var $bBiRC = parcelRequire("bBiRC");
/* Built-in method references that are verified to be native. */ var $349b92f9a7fb06f9$var$DataView = $4jmfA($bBiRC, 'DataView');
module.exports = $349b92f9a7fb06f9$var$DataView;

});

parcelRegister("9R3rT", function(module, exports) {

var $4jmfA = parcelRequire("4jmfA");

var $bBiRC = parcelRequire("bBiRC");
/* Built-in method references that are verified to be native. */ var $72cbbd2d95e590d9$var$Promise = $4jmfA($bBiRC, 'Promise');
module.exports = $72cbbd2d95e590d9$var$Promise;

});

parcelRegister("2a3F6", function(module, exports) {

var $4jmfA = parcelRequire("4jmfA");

var $bBiRC = parcelRequire("bBiRC");
/* Built-in method references that are verified to be native. */ var $192f5b1ee45264ad$var$Set = $4jmfA($bBiRC, 'Set');
module.exports = $192f5b1ee45264ad$var$Set;

});

parcelRegister("614Hw", function(module, exports) {

var $4jmfA = parcelRequire("4jmfA");

var $bBiRC = parcelRequire("bBiRC");
/* Built-in method references that are verified to be native. */ var $46167b9446278235$var$WeakMap = $4jmfA($bBiRC, 'WeakMap');
module.exports = $46167b9446278235$var$WeakMap;

});





parcelRegister("8flHN", function(module, exports) {

var $3rDfs = parcelRequire("3rDfs");

var $lrU6c = parcelRequire("lrU6c");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $018ca77a74e285a1$var$getMatchData(object) {
    var result = $lrU6c(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $3rDfs(value)
        ];
    }
    return result;
}
module.exports = $018ca77a74e285a1$var$getMatchData;

});
parcelRegister("3rDfs", function(module, exports) {

var $ih96c = parcelRequire("ih96c");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $282256a21dad6a21$var$isStrictComparable(value) {
    return value === value && !$ih96c(value);
}
module.exports = $282256a21dad6a21$var$isStrictComparable;

});


parcelRegister("cH8hr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $93dfec7c0b7e9669$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");
var $93dfec7c0b7e9669$var$BORDER_WIDTH = 2;
var $93dfec7c0b7e9669$var$baseFocusOutsideStyles = (0, $3dJ4i.css)({
    outline: "".concat($93dfec7c0b7e9669$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $93dfec7c0b7e9669$var$BORDER_WIDTH
});
var $93dfec7c0b7e9669$var$baseInsetStyles = (0, $3dJ4i.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$93dfec7c0b7e9669$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $93dfec7c0b7e9669$var$focusRingStyles = (0, $3dJ4i.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $93dfec7c0b7e9669$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $93dfec7c0b7e9669$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
var $93dfec7c0b7e9669$var$insetFocusRingStyles = (0, $3dJ4i.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $93dfec7c0b7e9669$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $93dfec7c0b7e9669$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $93dfec7c0b7e9669$var$FocusRing = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $93dfec7c0b7e9669$var$baseInsetStyles : $93dfec7c0b7e9669$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $93dfec7c0b7e9669$var$insetFocusRingStyles : $93dfec7c0b7e9669$var$focusRingStyles;
    var focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return (0, $3dJ4i.jsx)((0, $3dJ4i.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $1oC0p.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $1oC0p.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$93dfec7c0b7e9669$var$FocusRing.displayName = 'FocusRing';
var $93dfec7c0b7e9669$export$2e2bcd8739ae039 = $93dfec7c0b7e9669$var$FocusRing;

});

parcelRegister("hQkBB", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", function () { return $cfd746d1bf871dc9$export$64d6499adf9b2e51; });

var $lRA4b = parcelRequire("lRA4b");
function $cfd746d1bf871dc9$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $lRA4b.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("lRA4b", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", function () { return $feaa86424f980873$export$ce553301d55c2fd8; });
$parcel$export(module.exports, "COMMERCIAL", function () { return $feaa86424f980873$export$f005e2e9f707cb5f; });
$parcel$export(module.exports, "FEDRAMP_FEDEX", function () { return $feaa86424f980873$export$bd6b5a7802d76127; });
$parcel$export(module.exports, "STAGING", function () { return $feaa86424f980873$export$a739cd5aac835909; });
$parcel$export(module.exports, "PRODUCTION", function () { return $feaa86424f980873$export$42dd0cdd351a4a9; });
$parcel$export(module.exports, "DEV", function () { return $feaa86424f980873$export$404582bc18fe4d9e; });
var $feaa86424f980873$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $feaa86424f980873$export$f005e2e9f707cb5f = 'commercial';
var $feaa86424f980873$export$bd6b5a7802d76127 = 'fedramp-fedex';
var $feaa86424f980873$export$a739cd5aac835909 = 'stg';
var $feaa86424f980873$export$42dd0cdd351a4a9 = 'prod';
var $feaa86424f980873$export$404582bc18fe4d9e = 'dev';

});


parcelRegister("3PL5N", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2caaaa1fd55fd2ac$export$2e2bcd8739ae039; });
/* motion.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $2qaZZ = parcelRequire("2qaZZ");

var $bhnpb = parcelRequire("bhnpb");

var $1oC0p = parcelRequire("1oC0p");

var $eUuZl = parcelRequire("eUuZl");

var $hocso = parcelRequire("hocso");

var $d4i8K = parcelRequire("d4i8K");

var $eKwFW = parcelRequire("eKwFW");

var $01fYV = parcelRequire("01fYV");

var $cZB9Z = parcelRequire("cZB9Z");
var $2caaaa1fd55fd2ac$var$styles = {
    base: "_1y0co91m _1bumglyw _sedtglyw",
    hidden: "_3um015vq",
    entering: "_1o51eoah",
    exiting: "_1o51q7pw"
};
var $2caaaa1fd55fd2ac$export$569340a66b14e0dc = /*#__PURE__*/ function(Reanimate) {
    Reanimate["enter"] = "enter";
    Reanimate["exit_then_enter"] = "exit_then_enter";
    return Reanimate;
}({});
/**
 * __Motion__
 *
 * A motion primitive that can be used to animate the entry and exit of components.
 */ var $2caaaa1fd55fd2ac$var$Motion = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, enteringAnimation = _ref.enteringAnimation, enteringAnimationXcss = _ref.enteringAnimationXcss, exitingAnimation = _ref.exitingAnimation, exitingAnimationXcss = _ref.exitingAnimationXcss, onFinishMotion = _ref.onFinish, xcss = _ref.xcss, testId = _ref.testId;
    var staggered = (0, $cZB9Z.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $01fYV.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var staggeredDelay = isExiting ? 0 : staggered.delay;
    var staggedIsReady = staggered.isReady;
    var _useState = (0, $1oC0p.useState)(appear ? staggedIsReady && !staggeredDelay ? 'entering' : 'init' : 'idle'), _useState2 = (0, $2qaZZ.default)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var elementRef = (0, $1oC0p.useRef)(null);
    var reanimateRef = (0, $1oC0p.useRef)();
    var animationRef = (0, $1oC0p.useRef)();
    var staggeredEntryRef = (0, $1oC0p.useRef)();
    (0, $1oC0p.useEffect)(function() {
        if (isExiting) setState('exiting');
    }, [
        isExiting
    ]);
    // Handles staggered entry
    (0, $1oC0p.useEffect)(function() {
        if (state !== 'init') return;
        // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(function() {
            setState('entering');
        }, staggeredDelay);
        return function() {
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        state,
        staggedIsReady,
        staggeredDelay
    ]);
    /**
   * Updates relevant state.
   * Called when the animation is finished, or immediately with reduced motion.
   */ var onAnimationEnd = (0, $1oC0p.useCallback)(function(state, cancelled) {
        // We are done animating, so we set the state to idle
        var newState = 'idle';
        if (state === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('exiting');
        }
        if (state === 'entering') onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('entering');
        if (reanimateRef.current === $2caaaa1fd55fd2ac$export$569340a66b14e0dc.exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = $2caaaa1fd55fd2ac$export$569340a66b14e0dc.enter;
            newState = 'entering';
        } else if (reanimateRef.current) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        if (!cancelled) setState(newState);
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onExitFinished
    ]);
    (0, $1oC0p.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (!staggedIsReady) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        }
        // If the state is idle or init, we don't need to do anything
        if (state === 'idle' || state === 'init') return;
        // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if ((0, $d4i8K.isReducedMotion)() || !exitingAnimation && !exitingAnimationXcss) {
            onAnimationEnd(state, isCancelled);
            return;
        }
        var animationDuration = 0;
        var animationDelay = 0;
        if (state === 'entering' || state === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    var animationTimings = (0, $eKwFW.getDurationMs)((0, $eKwFW.resolveMotionToken)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDelay = animationTimings.delay;
                } else {
                    // Custom motion
                    var _styles = window.getComputedStyle(elementRef.current);
                    if (_styles.animationDuration) animationDuration = (0, $eKwFW.convertToMs)(_styles.animationDuration);
                    if (_styles.animationDelay) animationDelay = (0, $eKwFW.convertToMs)(_styles.animationDelay);
                }
            }
        }
        // Queue `onAnimationEnd` for after the animation has finished
        if (state === 'exiting' && (exitingAnimation || exitingAnimationXcss)) animationRef.current = setTimeout(function() {
            return onAnimationEnd(state, isCancelled);
        }, animationDuration + animationDelay);
        else if (state === 'entering' && (enteringAnimation || enteringAnimationXcss)) animationRef.current = setTimeout(function() {
            return onAnimationEnd(state, isCancelled);
        }, animationDuration + animationDelay);
        return function() {
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        state,
        exitingAnimation,
        enteringAnimation,
        exitingAnimationXcss,
        enteringAnimationXcss,
        staggeredDelay,
        staggedIsReady
    ]);
    (0, $1oC0p.useImperativeHandle)(ref, function() {
        return {
            reanimate: function reanimate(value) {
                animationRef.current && clearTimeout(animationRef.current);
                reanimateRef.current = value;
                if (value === $2caaaa1fd55fd2ac$export$569340a66b14e0dc.exit_then_enter) setState('exiting');
                else if (value === $2caaaa1fd55fd2ac$export$569340a66b14e0dc.enter) setState('entering');
            }
        };
    });
    var style = {};
    var customAnimation;
    if (state === 'entering') {
        if (enteringAnimation) style.animation = enteringAnimation;
        else if (enteringAnimationXcss) customAnimation = enteringAnimationXcss;
    } else if (state === 'exiting') {
        if (exitingAnimation) style.animation = exitingAnimation;
        else if (exitingAnimationXcss) customAnimation = exitingAnimationXcss;
    }
    var hasAnimationStyles = state !== 'idle' && state !== 'init';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bhnpb.default)([
            hasAnimationStyles && $2caaaa1fd55fd2ac$var$styles.base,
            state === 'init' && $2caaaa1fd55fd2ac$var$styles.hidden,
            state === 'entering' && $2caaaa1fd55fd2ac$var$styles.entering,
            state === 'exiting' && $2caaaa1fd55fd2ac$var$styles.exiting,
            (0, $eUuZl.cx)(xcss, customAnimation)
        ]),
        ref: (0, $hocso.default)([
            staggered.ref,
            elementRef
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: hasAnimationStyles ? style : undefined,
        "data-testid": testId
    }, children);
});
var $2caaaa1fd55fd2ac$export$2e2bcd8739ae039 = $2caaaa1fd55fd2ac$var$Motion;

});
parcelRegister("eUuZl", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $adae555243c76d8b$export$a274e22fb40f762e; });
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ parcelRequire("1oC0p");


var $kgmpe = parcelRequire("kgmpe");
var $adae555243c76d8b$var$strictApi = (0, $kgmpe.createStrictAPI)();
var $adae555243c76d8b$export$dbf350e5966cf602 = $adae555243c76d8b$var$strictApi.css;
var $adae555243c76d8b$export$eb1ecd84a24ee424 = $adae555243c76d8b$var$strictApi.cssMap;
$adae555243c76d8b$var$strictApi.cssMap;
var $adae555243c76d8b$export$a274e22fb40f762e = $adae555243c76d8b$var$strictApi.cx;
var $adae555243c76d8b$var$XCSSProp = $adae555243c76d8b$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 

});
parcelRegister("kgmpe", function(module, exports) {
$parcel$export(module.exports, "createStrictAPI", function () { return $ec06aea13c7dc3d6$export$39716b4af53f4ad; });

var $jdBSr = parcelRequire("jdBSr");

var $6Qrqa = parcelRequire("6Qrqa");
function $ec06aea13c7dc3d6$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $jdBSr.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $jdBSr.createStrictSetupError)();
        },
        cx: $6Qrqa.cx,
        XCSSProp () {
            throw (0, $jdBSr.createStrictSetupError)();
        }
    };
}

});
parcelRegister("jdBSr", function(module, exports) {
$parcel$export(module.exports, "createStrictSetupError", function () { return $dfdc9ccb3fed44ea$export$c4df1cb0c2b4d77c; });
const $dfdc9ccb3fed44ea$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $dfdc9ccb3fed44ea$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("6Qrqa", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $4fbcdea21c01cd8c$export$a274e22fb40f762e; });

var $duc3y = parcelRequire("duc3y");
const $4fbcdea21c01cd8c$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $duc3y.default)(actualStyles);
};

});
parcelRegister("duc3y", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9d176dd84d73b4a6$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $9d176dd84d73b4a6$var$ATOMIC_GROUP_LENGTH = 5;
function $9d176dd84d73b4a6$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $9d176dd84d73b4a6$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});




parcelRegister("hocso", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ca8e573e58a16f96$export$2e2bcd8739ae039; });

var $2zYm4 = parcelRequire("2zYm4");
function $ca8e573e58a16f96$export$2e2bcd8739ae039(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null && (0, $2zYm4.default)(ref) === 'object') ref.current = value;
        });
    };
}

});

parcelRegister("eKwFW", function(module, exports) {
$parcel$export(module.exports, "getDurationMs", function () { return $abceb53fed5da77c$export$d0038b6e47881463; });
$parcel$export(module.exports, "convertToMs", function () { return $abceb53fed5da77c$export$75eee42ff540d8ae; });
$parcel$export(module.exports, "resolveMotionToken", function () { return $abceb53fed5da77c$export$82b92541889a035d; });

var $lFOXD = parcelRequire("lFOXD");

var $6xVyM = parcelRequire("6xVyM");
var $abceb53fed5da77c$export$d0038b6e47881463 = function getDurationMs(animation) {
    var match = (0, $lFOXD.default)(animation.trim().matchAll(/(-?\d*\.?\d+)(ms|s)\b/g));
    if (match.length === 0) return {
        duration: 0,
        delay: 0
    };
    var durationValue = parseFloat(match[0][1]);
    var durationUnit = match[0][2];
    var duration = durationUnit === 's' ? durationValue * 1000 : durationValue;
    var delay = 0;
    if (match[1]) {
        var delayValue = parseFloat(match[1][1]);
        var delayUnit = match[1][2];
        delay = delayUnit === 's' ? delayValue * 1000 : delayValue;
    }
    return {
        duration: duration,
        delay: delay
    };
};
var $abceb53fed5da77c$export$75eee42ff540d8ae = function convertToMs(duration) {
    // Use regex to separate the number and the unit
    var matches = duration.match(/^(\d+\.?\d*)(s|ms)$/);
    if (!matches) return 0; // Or return for invalid format
    var value = parseFloat(matches[1]);
    var unit = matches[2];
    if (unit === 's') return value * 1000; // Convert seconds to milliseconds
    else return value; // Already in milliseconds
};
var $abceb53fed5da77c$export$82b92541889a035d = function resolveMotionToken(token) {
    var cssVarMatch = token.match(/var\(\s*(--[^,\s)]+)/);
    var cssVar = cssVarMatch ? cssVarMatch[1] : null;
    if (cssVar) {
        var _getDocument;
        var documentElement = (_getDocument = (0, $6xVyM.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.documentElement;
        if (documentElement) return getComputedStyle(documentElement).getPropertyValue(cssVar);
    }
    return '';
};

});


parcelRegister("bd2OO", function(module, exports) {
$parcel$export(module.exports, "LevelContext", function () { return $8293184d2e3c1660$export$650d12d3c2ddb8fc; });
$parcel$export(module.exports, "LevelNodeContext", function () { return $8293184d2e3c1660$export$18f4d8b5b3a77f59; });
$parcel$export(module.exports, "RootNodeContext", function () { return $8293184d2e3c1660$export$fa973f110e8f6ca8; });
$parcel$export(module.exports, "Layering", function () { return $8293184d2e3c1660$export$7c885f891c940977; });

var $1oC0p = parcelRequire("1oC0p");

var $8KSLn = parcelRequire("8KSLn");
var $8293184d2e3c1660$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $1oC0p.createContext)(0);
var $8293184d2e3c1660$export$18f4d8b5b3a77f59 = /*#__PURE__*/ (0, $1oC0p.createContext)({
    current: null
});
var $8293184d2e3c1660$export$fa973f110e8f6ca8 = /*#__PURE__*/ (0, $1oC0p.createContext)({
    current: null
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $8293184d2e3c1660$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel, levelNode = _ref.node;
    (0, $1oC0p.useEffect)(function() {
        var levelNodeSafe = levelNode.current;
        var parentNode = levelNodeSafe.parent;
        parentNode === null || parentNode === void 0 || parentNode.addChild(levelNodeSafe);
        return function() {
            parentNode === null || parentNode === void 0 || parentNode.removeChild(levelNodeSafe);
        };
    }, [
        levelNode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($8293184d2e3c1660$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($8293184d2e3c1660$export$18f4d8b5b3a77f59.Provider, {
        value: levelNode
    }, children));
};
var $8293184d2e3c1660$export$7c885f891c940977 = function Layering(_ref2) {
    var children = _ref2.children, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? true : _ref2$isDisabled;
    var currentLevel = (0, $1oC0p.useContext)($8293184d2e3c1660$export$650d12d3c2ddb8fc);
    var parentNode = (0, $1oC0p.useContext)($8293184d2e3c1660$export$18f4d8b5b3a77f59);
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    var newNode = (0, $1oC0p.useRef)(new (0, $8KSLn.LayerNode)(Math.random().toString(36), parentNode.current));
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($8293184d2e3c1660$var$LevelProvider, {
        currentLevel: currentLevel + 1,
        node: newNode
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($8293184d2e3c1660$export$fa973f110e8f6ca8.Provider, {
        value: newNode
    }, content);
};

});
parcelRegister("8KSLn", function(module, exports) {
$parcel$export(module.exports, "LayerNode", function () { return $65fd196e6ac39ea2$export$da4f61fd78d35243; });

var $lFOXD = parcelRequire("lFOXD");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");
var $65fd196e6ac39ea2$export$da4f61fd78d35243 = /*#__PURE__*/ function() {
    function LayerNode(id, parent) {
        (0, $cTewU.default)(this, LayerNode);
        this.id = id;
        this.childNodes = [];
        this.parent = parent;
    }
    return (0, $avOEA.default)(LayerNode, [
        {
            key: "addChild",
            value: function addChild(node) {
                this.childNodes.push(node);
            }
        },
        {
            key: "removeChild",
            value: function removeChild(node) {
                this.childNodes = this.childNodes.filter(function(child) {
                    return child.id !== node.id;
                });
            }
        },
        {
            key: "getLevel",
            value: function getLevel() {
                if (!this.parent) return 1;
                return this.parent.getLevel() + 1;
            }
        },
        {
            key: "getHeight",
            value: function getHeight() {
                if (this.childNodes.length === 0) return 1;
                return Math.max.apply(Math, (0, $lFOXD.default)(this.childNodes.map(function(child) {
                    return child.getHeight();
                }))) + 1;
            }
        }
    ]);
}();

});


parcelRegister("5E2F4", function(module, exports) {
$parcel$export(module.exports, "useCloseOnEscapePress", function () { return $41c2c0b22964791c$export$4a4bf067ea9e7886; });
$parcel$export(module.exports, "useLayering", function () { return $41c2c0b22964791c$export$c8b4d54e03dee6ed; });

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $bd2OO = parcelRequire("bd2OO");
var $41c2c0b22964791c$var$ESCAPE = 'Escape';
function $41c2c0b22964791c$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $1oC0p.useRef)(false);
    var _useLayering = $41c2c0b22964791c$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $1oC0p.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $41c2c0b22964791c$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $1oC0p.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $1oC0p.useEffect)(function() {
        return (0, $dH1HR.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $41c2c0b22964791c$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $1oC0p.useContext)((0, $bd2OO.LevelContext));
    var layerNode = (0, $1oC0p.useContext)((0, $bd2OO.LevelNodeContext));
    var rootNode = (0, $1oC0p.useContext)((0, $bd2OO.RootNodeContext));
    var isLayerDisabled = (0, $1oC0p.useCallback)(function() {
        // This is an impossible case, added for type safety
        if (!(layerNode !== null && layerNode !== void 0 && layerNode.current) || !(rootNode !== null && rootNode !== void 0 && rootNode.current)) return false;
        return layerNode.current.getLevel() < rootNode.current.getHeight();
    }, [
        layerNode,
        rootNode
    ]);
    var getTopLevel = (0, $1oC0p.useCallback)(function() {
        return rootNode !== null && rootNode !== void 0 && rootNode.current ? rootNode.current.getHeight() : null;
    }, [
        rootNode
    ]);
    return {
        currentLevel: currentLevel,
        isLayerDisabled: isLayerDisabled,
        getTopLevel: getTopLevel
    };
}

});

parcelRegister("90p8I", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $68e79d555ddad884$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $bJ5Wj = parcelRequire("bJ5Wj");
/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $68e79d555ddad884$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $1oC0p.useContext)((0, $bJ5Wj.RouterLinkProviderContext)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $68e79d555ddad884$export$2e2bcd8739ae039 = $68e79d555ddad884$var$useRouterLink;

});
parcelRegister("bJ5Wj", function(module, exports) {
$parcel$export(module.exports, "RouterLinkProviderContext", function () { return $88988128aefaf155$export$2931e0ee690eee88; });

var $1oC0p = parcelRequire("1oC0p");
var $88988128aefaf155$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $1oC0p.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $88988128aefaf155$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($88988128aefaf155$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $88988128aefaf155$export$2e2bcd8739ae039 = $88988128aefaf155$var$RouterLinkProvider;

});


parcelRegister("1wCKu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $11c6d65546a19ba3$export$2e2bcd8739ae039; });

var $6XQNN = parcelRequire("6XQNN");
function $11c6d65546a19ba3$var$isOptionsObject(options) {
    return options === Object(options) && Object.keys(options).length !== 0;
}
function $11c6d65546a19ba3$var$defaultBehavior(actions, behavior) {
    if (behavior === void 0) behavior = 'auto';
    var canSmoothScroll = 'scrollBehavior' in document.body.style;
    actions.forEach(function(_ref) {
        var el = _ref.el, top = _ref.top, left = _ref.left;
        if (el.scroll && canSmoothScroll) el.scroll({
            top: top,
            left: left,
            behavior: behavior
        });
        else {
            el.scrollTop = top;
            el.scrollLeft = left;
        }
    });
}
function $11c6d65546a19ba3$var$getOptions(options) {
    if (options === false) return {
        block: 'end',
        inline: 'nearest'
    };
    if ($11c6d65546a19ba3$var$isOptionsObject(options)) return options;
    return {
        block: 'start',
        inline: 'nearest'
    };
}
function $11c6d65546a19ba3$var$scrollIntoView(target, options) {
    var isTargetAttached = target.isConnected || target.ownerDocument.documentElement.contains(target);
    if ($11c6d65546a19ba3$var$isOptionsObject(options) && typeof options.behavior === 'function') return options.behavior(isTargetAttached ? (0, $6XQNN.default)(target, options) : []);
    if (!isTargetAttached) return;
    var computeOptions = $11c6d65546a19ba3$var$getOptions(options);
    return $11c6d65546a19ba3$var$defaultBehavior((0, $6XQNN.default)(target, computeOptions), computeOptions.behavior);
}
var $11c6d65546a19ba3$export$2e2bcd8739ae039 = $11c6d65546a19ba3$var$scrollIntoView;

});
parcelRegister("6XQNN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5121362796a3b437$export$2e2bcd8739ae039; });
function $5121362796a3b437$var$t(t) {
    return "object" == typeof t && null != t && 1 === t.nodeType;
}
function $5121362796a3b437$var$e(t, e) {
    return (!e || "hidden" !== t) && "visible" !== t && "clip" !== t;
}
function $5121362796a3b437$var$n(t, n) {
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        var r = getComputedStyle(t, null);
        return $5121362796a3b437$var$e(r.overflowY, n) || $5121362796a3b437$var$e(r.overflowX, n) || function(t) {
            var e = function(t) {
                if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
                try {
                    return t.ownerDocument.defaultView.frameElement;
                } catch (t) {
                    return null;
                }
            }(t);
            return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        }(t);
    }
    return !1;
}
function $5121362796a3b437$var$r(t, e, n, r, i, o, l, d) {
    return o < t && l > e || o > t && l < e ? 0 : o <= t && d <= n || l >= e && d >= n ? o - t - r : l > e && d < n || o < t && d > n ? l - e + i : 0;
}
var $5121362796a3b437$export$2e2bcd8739ae039 = function(e, i) {
    var o = window, l = i.scrollMode, d = i.block, f = i.inline, h = i.boundary, u = i.skipOverflowHiddenElements, s = "function" == typeof h ? h : function(t) {
        return t !== h;
    };
    if (!$5121362796a3b437$var$t(e)) throw new TypeError("Invalid target");
    for(var a, c, g = document.scrollingElement || document.documentElement, p = [], m = e; $5121362796a3b437$var$t(m) && s(m);){
        if ((m = null == (c = (a = m).parentElement) ? a.getRootNode().host || null : c) === g) {
            p.push(m);
            break;
        }
        null != m && m === document.body && $5121362796a3b437$var$n(m) && !$5121362796a3b437$var$n(document.documentElement) || null != m && $5121362796a3b437$var$n(m, u) && p.push(m);
    }
    for(var w = o.visualViewport ? o.visualViewport.width : innerWidth, v = o.visualViewport ? o.visualViewport.height : innerHeight, W = window.scrollX || pageXOffset, H = window.scrollY || pageYOffset, b = e.getBoundingClientRect(), y = b.height, E = b.width, M = b.top, V = b.right, x = b.bottom, I = b.left, C = "start" === d || "nearest" === d ? M : "end" === d ? x : M + y / 2, R = "center" === f ? I + E / 2 : "end" === f ? V : I, T = [], k = 0; k < p.length; k++){
        var B = p[k], D = B.getBoundingClientRect(), O = D.height, X = D.width, Y = D.top, L = D.right, S = D.bottom, j = D.left;
        if ("if-needed" === l && M >= 0 && I >= 0 && x <= v && V <= w && M >= Y && x <= S && I >= j && V <= L) return T;
        var N = getComputedStyle(B), q = parseInt(N.borderLeftWidth, 10), z = parseInt(N.borderTopWidth, 10), A = parseInt(N.borderRightWidth, 10), F = parseInt(N.borderBottomWidth, 10), G = 0, J = 0, K = "offsetWidth" in B ? B.offsetWidth - B.clientWidth - q - A : 0, P = "offsetHeight" in B ? B.offsetHeight - B.clientHeight - z - F : 0, Q = "offsetWidth" in B ? 0 === B.offsetWidth ? 0 : X / B.offsetWidth : 0, U = "offsetHeight" in B ? 0 === B.offsetHeight ? 0 : O / B.offsetHeight : 0;
        if (g === B) G = "start" === d ? C : "end" === d ? C - v : "nearest" === d ? $5121362796a3b437$var$r(H, H + v, v, z, F, H + C, H + C + y, y) : C - v / 2, J = "start" === f ? R : "center" === f ? R - w / 2 : "end" === f ? R - w : $5121362796a3b437$var$r(W, W + w, w, q, A, W + R, W + R + E, E), G = Math.max(0, G + H), J = Math.max(0, J + W);
        else {
            G = "start" === d ? C - Y - z : "end" === d ? C - S + F + P : "nearest" === d ? $5121362796a3b437$var$r(Y, S, O, z, F + P, C, C + y, y) : C - (Y + O / 2) + P / 2, J = "start" === f ? R - j - q : "center" === f ? R - (j + X / 2) + K / 2 : "end" === f ? R - L + A + K : $5121362796a3b437$var$r(j, L, X, q, A + K, R, R + E, E);
            var Z = B.scrollLeft, $ = B.scrollTop;
            C += $ - (G = Math.max(0, Math.min($ + G / U, B.scrollHeight - O / U + P))), R += Z - (J = Math.max(0, Math.min(Z + J / Q, B.scrollWidth - X / Q + K)));
        }
        T.push({
            el: B,
            top: G,
            left: J
        });
    }
    return T;
};

});


parcelRegister("8Buwy", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6LNID = parcelRequire("6LNID");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $643974dad75ce7e5$var$_interopRequireDefault($6LNID).default;
    }
});
function $643974dad75ce7e5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("6LNID", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $4eddb301d974f51f$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $1gsc7 = parcelRequire("1gsc7");

var $gUjjH = parcelRequire("gUjjH");
function $4eddb301d974f51f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4eddb301d974f51f$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $4eddb301d974f51f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $4eddb301d974f51f$var$NodeResolver = function(_Component) {
    $4eddb301d974f51f$var$_inherits(NodeResolver, _Component);
    function NodeResolver() {
        $4eddb301d974f51f$var$_classCallCheck(this, NodeResolver);
        return $4eddb301d974f51f$var$_possibleConstructorReturn(this, (NodeResolver.__proto__ || Object.getPrototypeOf(NodeResolver)).apply(this, arguments));
    }
    $4eddb301d974f51f$var$_createClass(NodeResolver, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.props.innerRef((0, $gUjjH.findDOMNode)(this));
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.props.innerRef(null);
            }
        },
        {
            key: 'render',
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return NodeResolver;
}($1gsc7.Component);
module.exports.default = $4eddb301d974f51f$var$NodeResolver;

});
parcelRegister("1gsc7", function(module, exports) {
'use strict';

module.exports = (parcelRequire("fU1p5"));

});
parcelRegister("fU1p5", function(module, exports) {
$parcel$export(module.exports, "Children", function () { return $b93d2cba269dd7f3$export$dca3b0875bd9a954; }, function (v) { return $b93d2cba269dd7f3$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $b93d2cba269dd7f3$export$16fa2f45be04daa8; }, function (v) { return $b93d2cba269dd7f3$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b93d2cba269dd7f3$export$ffb0004e005737fa; }, function (v) { return $b93d2cba269dd7f3$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $b93d2cba269dd7f3$export$e2c29f18771995cb; }, function (v) { return $b93d2cba269dd7f3$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $b93d2cba269dd7f3$export$221d75b3f55bb0bd; }, function (v) { return $b93d2cba269dd7f3$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b93d2cba269dd7f3$export$5f8d39834fd61797; }, function (v) { return $b93d2cba269dd7f3$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b93d2cba269dd7f3$export$74bf444e3cd11ea5; }, function (v) { return $b93d2cba269dd7f3$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $b93d2cba269dd7f3$export$1ced07cd6b1985ce; }, function (v) { return $b93d2cba269dd7f3$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $b93d2cba269dd7f3$export$abd8e32b826d7ea7; }, function (v) { return $b93d2cba269dd7f3$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $b93d2cba269dd7f3$export$69a3209f1a06c04d; }, function (v) { return $b93d2cba269dd7f3$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cloneElement", function () { return $b93d2cba269dd7f3$export$e530037191fcd5d7; }, function (v) { return $b93d2cba269dd7f3$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $b93d2cba269dd7f3$export$fd42f52fd3ae1109; }, function (v) { return $b93d2cba269dd7f3$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $b93d2cba269dd7f3$export$c8a8987d4410bf2d; }, function (v) { return $b93d2cba269dd7f3$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $b93d2cba269dd7f3$export$7d1e3a5e95ceca43; }, function (v) { return $b93d2cba269dd7f3$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $b93d2cba269dd7f3$export$257a8862b851cb5b; }, function (v) { return $b93d2cba269dd7f3$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $b93d2cba269dd7f3$export$a8257692ac88316c; }, function (v) { return $b93d2cba269dd7f3$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $b93d2cba269dd7f3$export$488013bae63b21da; }, function (v) { return $b93d2cba269dd7f3$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $b93d2cba269dd7f3$export$7c73462e0d25e514; }, function (v) { return $b93d2cba269dd7f3$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $b93d2cba269dd7f3$export$7568632d0d33d16d; }, function (v) { return $b93d2cba269dd7f3$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $b93d2cba269dd7f3$export$f93f40ac0ca7e3a8; }, function (v) { return $b93d2cba269dd7f3$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $b93d2cba269dd7f3$export$1f96ae73734a86cc; }, function (v) { return $b93d2cba269dd7f3$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $b93d2cba269dd7f3$export$9a47ced3238df325; }, function (v) { return $b93d2cba269dd7f3$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $b93d2cba269dd7f3$export$35808ee640e87ca7; }, function (v) { return $b93d2cba269dd7f3$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $b93d2cba269dd7f3$export$fae74005e78b1a27; }, function (v) { return $b93d2cba269dd7f3$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $b93d2cba269dd7f3$export$dc8fbce3eb94dc1e; }, function (v) { return $b93d2cba269dd7f3$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $b93d2cba269dd7f3$export$6a7bc4e911dc01cf; }, function (v) { return $b93d2cba269dd7f3$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $b93d2cba269dd7f3$export$6d9c69b0de29b591; }, function (v) { return $b93d2cba269dd7f3$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $b93d2cba269dd7f3$export$f680877a34711e37; }, function (v) { return $b93d2cba269dd7f3$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $b93d2cba269dd7f3$export$d5a552a76deda3c2; }, function (v) { return $b93d2cba269dd7f3$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $b93d2cba269dd7f3$export$aaabe4eda9ed9969; }, function (v) { return $b93d2cba269dd7f3$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $b93d2cba269dd7f3$export$e5c5a5f917a5871c; }, function (v) { return $b93d2cba269dd7f3$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $b93d2cba269dd7f3$export$1538c33de8887b59; }, function (v) { return $b93d2cba269dd7f3$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $b93d2cba269dd7f3$export$fca7f784ae7a249a; }, function (v) { return $b93d2cba269dd7f3$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $b93d2cba269dd7f3$export$13e3392192263954; }, function (v) { return $b93d2cba269dd7f3$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $b93d2cba269dd7f3$export$b8f5890fc79d6aca; }, function (v) { return $b93d2cba269dd7f3$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $b93d2cba269dd7f3$export$60241385465d0a34; }, function (v) { return $b93d2cba269dd7f3$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $b93d2cba269dd7f3$export$306c0aa65ff9ec16; }, function (v) { return $b93d2cba269dd7f3$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $b93d2cba269dd7f3$export$7b286972b8d8ccbf; }, function (v) { return $b93d2cba269dd7f3$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $b93d2cba269dd7f3$export$83d89fbfd8236492; }, function (v) { return $b93d2cba269dd7f3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b93d2cba269dd7f3$export$dca3b0875bd9a954;
var $b93d2cba269dd7f3$export$16fa2f45be04daa8;
var $b93d2cba269dd7f3$export$ffb0004e005737fa;
var $b93d2cba269dd7f3$export$e2c29f18771995cb;
var $b93d2cba269dd7f3$export$221d75b3f55bb0bd;
var $b93d2cba269dd7f3$export$5f8d39834fd61797;
var $b93d2cba269dd7f3$export$74bf444e3cd11ea5;
var $b93d2cba269dd7f3$export$1ced07cd6b1985ce;
var $b93d2cba269dd7f3$export$abd8e32b826d7ea7;
var $b93d2cba269dd7f3$export$69a3209f1a06c04d;
var $b93d2cba269dd7f3$export$e530037191fcd5d7;
var $b93d2cba269dd7f3$export$fd42f52fd3ae1109;
var $b93d2cba269dd7f3$export$c8a8987d4410bf2d;
var $b93d2cba269dd7f3$export$7d1e3a5e95ceca43;
var $b93d2cba269dd7f3$export$257a8862b851cb5b;
var $b93d2cba269dd7f3$export$a8257692ac88316c;
var $b93d2cba269dd7f3$export$488013bae63b21da;
var $b93d2cba269dd7f3$export$7c73462e0d25e514;
var $b93d2cba269dd7f3$export$7568632d0d33d16d;
var $b93d2cba269dd7f3$export$f93f40ac0ca7e3a8;
var $b93d2cba269dd7f3$export$1f96ae73734a86cc;
var $b93d2cba269dd7f3$export$9a47ced3238df325;
var $b93d2cba269dd7f3$export$35808ee640e87ca7;
var $b93d2cba269dd7f3$export$fae74005e78b1a27;
var $b93d2cba269dd7f3$export$dc8fbce3eb94dc1e;
var $b93d2cba269dd7f3$export$6a7bc4e911dc01cf;
var $b93d2cba269dd7f3$export$6d9c69b0de29b591;
var $b93d2cba269dd7f3$export$f680877a34711e37;
var $b93d2cba269dd7f3$export$d5a552a76deda3c2;
var $b93d2cba269dd7f3$export$aaabe4eda9ed9969;
var $b93d2cba269dd7f3$export$e5c5a5f917a5871c;
var $b93d2cba269dd7f3$export$1538c33de8887b59;
var $b93d2cba269dd7f3$export$fca7f784ae7a249a;
var $b93d2cba269dd7f3$export$13e3392192263954;
var $b93d2cba269dd7f3$export$b8f5890fc79d6aca;
var $b93d2cba269dd7f3$export$60241385465d0a34;
var $b93d2cba269dd7f3$export$306c0aa65ff9ec16;
var $b93d2cba269dd7f3$export$7b286972b8d8ccbf;
var $b93d2cba269dd7f3$export$83d89fbfd8236492;

var $7t0tI = parcelRequire("7t0tI");
"use strict";
var $b93d2cba269dd7f3$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $b93d2cba269dd7f3$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $b93d2cba269dd7f3$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $b93d2cba269dd7f3$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $b93d2cba269dd7f3$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $b93d2cba269dd7f3$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $b93d2cba269dd7f3$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $b93d2cba269dd7f3$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $b93d2cba269dd7f3$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $b93d2cba269dd7f3$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $b93d2cba269dd7f3$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $b93d2cba269dd7f3$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $b93d2cba269dd7f3$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $b93d2cba269dd7f3$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$b93d2cba269dd7f3$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $b93d2cba269dd7f3$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $b93d2cba269dd7f3$var$assign = Object.assign, $b93d2cba269dd7f3$var$emptyObject = {};
function $b93d2cba269dd7f3$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $b93d2cba269dd7f3$var$emptyObject;
    this.updater = updater || $b93d2cba269dd7f3$var$ReactNoopUpdateQueue;
}
$b93d2cba269dd7f3$var$Component.prototype.isReactComponent = {};
$b93d2cba269dd7f3$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$b93d2cba269dd7f3$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $b93d2cba269dd7f3$var$ComponentDummy() {}
$b93d2cba269dd7f3$var$ComponentDummy.prototype = $b93d2cba269dd7f3$var$Component.prototype;
function $b93d2cba269dd7f3$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $b93d2cba269dd7f3$var$emptyObject;
    this.updater = updater || $b93d2cba269dd7f3$var$ReactNoopUpdateQueue;
}
var $b93d2cba269dd7f3$var$pureComponentPrototype = $b93d2cba269dd7f3$var$PureComponent.prototype = new $b93d2cba269dd7f3$var$ComponentDummy();
$b93d2cba269dd7f3$var$pureComponentPrototype.constructor = $b93d2cba269dd7f3$var$PureComponent;
$b93d2cba269dd7f3$var$assign($b93d2cba269dd7f3$var$pureComponentPrototype, $b93d2cba269dd7f3$var$Component.prototype);
$b93d2cba269dd7f3$var$pureComponentPrototype.isPureReactComponent = !0;
var $b93d2cba269dd7f3$var$isArrayImpl = Array.isArray, $b93d2cba269dd7f3$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, $b93d2cba269dd7f3$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $b93d2cba269dd7f3$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $b93d2cba269dd7f3$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $b93d2cba269dd7f3$var$cloneAndReplaceKey(oldElement, newKey) {
    return $b93d2cba269dd7f3$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $b93d2cba269dd7f3$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $b93d2cba269dd7f3$var$REACT_ELEMENT_TYPE;
}
function $b93d2cba269dd7f3$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $b93d2cba269dd7f3$var$userProvidedKeyEscapeRegex = /\/+/g;
function $b93d2cba269dd7f3$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $b93d2cba269dd7f3$var$escape("" + element.key) : index.toString(36);
}
function $b93d2cba269dd7f3$var$noop$1() {}
function $b93d2cba269dd7f3$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($b93d2cba269dd7f3$var$noop$1, $b93d2cba269dd7f3$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $b93d2cba269dd7f3$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $b93d2cba269dd7f3$var$REACT_ELEMENT_TYPE:
                case $b93d2cba269dd7f3$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $b93d2cba269dd7f3$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $b93d2cba269dd7f3$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $b93d2cba269dd7f3$var$getElementKey(children, 0) : nameSoFar, $b93d2cba269dd7f3$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($b93d2cba269dd7f3$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $b93d2cba269dd7f3$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($b93d2cba269dd7f3$var$isValidElement(callback) && (callback = $b93d2cba269dd7f3$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($b93d2cba269dd7f3$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($b93d2cba269dd7f3$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $b93d2cba269dd7f3$var$getElementKey(nameSoFar, i), invokeCallback += $b93d2cba269dd7f3$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $b93d2cba269dd7f3$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $b93d2cba269dd7f3$var$getElementKey(nameSoFar, i++), invokeCallback += $b93d2cba269dd7f3$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $b93d2cba269dd7f3$var$mapIntoArray($b93d2cba269dd7f3$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $b93d2cba269dd7f3$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $b93d2cba269dd7f3$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $b93d2cba269dd7f3$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $b93d2cba269dd7f3$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $7t0tI && "function" === typeof $7t0tI.emit) {
        $7t0tI.emit("uncaughtException", error);
        return;
    }
    console.error(error);
};
function $b93d2cba269dd7f3$var$noop() {}
$b93d2cba269dd7f3$export$dca3b0875bd9a954 = {
    map: $b93d2cba269dd7f3$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $b93d2cba269dd7f3$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $b93d2cba269dd7f3$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $b93d2cba269dd7f3$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$b93d2cba269dd7f3$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$b93d2cba269dd7f3$export$16fa2f45be04daa8 = $b93d2cba269dd7f3$var$Component;
$b93d2cba269dd7f3$export$ffb0004e005737fa = $b93d2cba269dd7f3$var$REACT_FRAGMENT_TYPE;
$b93d2cba269dd7f3$export$e2c29f18771995cb = $b93d2cba269dd7f3$var$REACT_PROFILER_TYPE;
$b93d2cba269dd7f3$export$221d75b3f55bb0bd = $b93d2cba269dd7f3$var$PureComponent;
$b93d2cba269dd7f3$export$5f8d39834fd61797 = $b93d2cba269dd7f3$var$REACT_STRICT_MODE_TYPE;
$b93d2cba269dd7f3$export$74bf444e3cd11ea5 = $b93d2cba269dd7f3$var$REACT_SUSPENSE_TYPE;
$b93d2cba269dd7f3$export$1ced07cd6b1985ce = $b93d2cba269dd7f3$var$ReactSharedInternals;
$b93d2cba269dd7f3$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $b93d2cba269dd7f3$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$b93d2cba269dd7f3$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$b93d2cba269dd7f3$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $b93d2cba269dd7f3$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$b93d2cba269dd7f3$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $b93d2cba269dd7f3$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$b93d2cba269dd7f3$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $b93d2cba269dd7f3$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $b93d2cba269dd7f3$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$b93d2cba269dd7f3$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$b93d2cba269dd7f3$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $b93d2cba269dd7f3$var$ReactElement(type, key, void 0, void 0, null, props);
};
$b93d2cba269dd7f3$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$b93d2cba269dd7f3$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $b93d2cba269dd7f3$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$b93d2cba269dd7f3$export$a8257692ac88316c = $b93d2cba269dd7f3$var$isValidElement;
$b93d2cba269dd7f3$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $b93d2cba269dd7f3$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $b93d2cba269dd7f3$var$lazyInitializer
    };
};
$b93d2cba269dd7f3$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $b93d2cba269dd7f3$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$b93d2cba269dd7f3$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $b93d2cba269dd7f3$var$ReactSharedInternals.T, currentTransition = {};
    $b93d2cba269dd7f3$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $b93d2cba269dd7f3$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($b93d2cba269dd7f3$var$noop, $b93d2cba269dd7f3$var$reportGlobalError);
    } catch (error) {
        $b93d2cba269dd7f3$var$reportGlobalError(error);
    } finally{
        $b93d2cba269dd7f3$var$ReactSharedInternals.T = prevTransition;
    }
};
$b93d2cba269dd7f3$export$f93f40ac0ca7e3a8 = function() {
    return $b93d2cba269dd7f3$var$ReactSharedInternals.H.useCacheRefresh();
};
$b93d2cba269dd7f3$export$1f96ae73734a86cc = function(usable) {
    return $b93d2cba269dd7f3$var$ReactSharedInternals.H.use(usable);
};
$b93d2cba269dd7f3$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $b93d2cba269dd7f3$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$b93d2cba269dd7f3$export$35808ee640e87ca7 = function(callback, deps) {
    return $b93d2cba269dd7f3$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$b93d2cba269dd7f3$export$fae74005e78b1a27 = function(Context) {
    return $b93d2cba269dd7f3$var$ReactSharedInternals.H.useContext(Context);
};
$b93d2cba269dd7f3$export$dc8fbce3eb94dc1e = function() {};
$b93d2cba269dd7f3$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $b93d2cba269dd7f3$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$b93d2cba269dd7f3$export$6d9c69b0de29b591 = function(create, createDeps, update) {
    var dispatcher = $b93d2cba269dd7f3$var$ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
$b93d2cba269dd7f3$export$f680877a34711e37 = function() {
    return $b93d2cba269dd7f3$var$ReactSharedInternals.H.useId();
};
$b93d2cba269dd7f3$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $b93d2cba269dd7f3$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$b93d2cba269dd7f3$export$aaabe4eda9ed9969 = function(create, deps) {
    return $b93d2cba269dd7f3$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$b93d2cba269dd7f3$export$e5c5a5f917a5871c = function(create, deps) {
    return $b93d2cba269dd7f3$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$b93d2cba269dd7f3$export$1538c33de8887b59 = function(create, deps) {
    return $b93d2cba269dd7f3$var$ReactSharedInternals.H.useMemo(create, deps);
};
$b93d2cba269dd7f3$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $b93d2cba269dd7f3$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$b93d2cba269dd7f3$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $b93d2cba269dd7f3$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$b93d2cba269dd7f3$export$b8f5890fc79d6aca = function(initialValue) {
    return $b93d2cba269dd7f3$var$ReactSharedInternals.H.useRef(initialValue);
};
$b93d2cba269dd7f3$export$60241385465d0a34 = function(initialState) {
    return $b93d2cba269dd7f3$var$ReactSharedInternals.H.useState(initialState);
};
$b93d2cba269dd7f3$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $b93d2cba269dd7f3$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$b93d2cba269dd7f3$export$7b286972b8d8ccbf = function() {
    return $b93d2cba269dd7f3$var$ReactSharedInternals.H.useTransition();
};
$b93d2cba269dd7f3$export$83d89fbfd8236492 = "19.1.0";

});




parcelRegister("exfZj", function(module, exports) {
$parcel$export(module.exports, "easeInOut", function () { return $a9508ca5770d9e2a$export$c07234257a03d5e9; });
$parcel$export(module.exports, "easeOut", function () { return $a9508ca5770d9e2a$export$57636bb43b1ccbb0; });
var $a9508ca5770d9e2a$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
var $a9508ca5770d9e2a$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
var $a9508ca5770d9e2a$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
var $a9508ca5770d9e2a$export$fc825baa2ef870d0 = 'cubic-bezier(0.4,0,0,1)';
var $a9508ca5770d9e2a$export$816ee5d79b5bd9a5 = 'cubic-bezier(0.6,0,0,1)';
var $a9508ca5770d9e2a$export$53ce3390a1a8f2a2 = 'cubic-bezier(0.8,0,0,1)';
var $a9508ca5770d9e2a$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';

});

parcelRegister("5AtlP", function(module, exports) {
$parcel$export(module.exports, "getFirstName", function () { return $f5b50bde618a4cd3$export$cf3a9fa4cebe2986; });
function $f5b50bde618a4cd3$export$cf3a9fa4cebe2986(fullName = '') {
    return fullName.trim().split(' ')[0] || '';
}

});

parcelRegister("iiMec", function(module, exports) {

var $a8tXu = parcelRequire("a8tXu");
/** Built-in value references. */ var $d52f5187398d5cf2$var$getPrototype = $a8tXu(Object.getPrototypeOf, Object);
module.exports = $d52f5187398d5cf2$var$getPrototype;

});

parcelRegister("7ZMp9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5d23c7110508bb95$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $aL8rw = parcelRequire("aL8rw");

var $gxoz1 = parcelRequire("gxoz1");

var $gnEGa = parcelRequire("gnEGa");

var $48X4a = parcelRequire("48X4a");
var $1Vn55 = parcelRequire("1Vn55");
var $5d23c7110508bb95$var$_excluded = [
    "children",
    "testId",
    "appearance",
    "newWindowLabel",
    "target",
    "className",
    "style"
];
var $5d23c7110508bb95$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
var $5d23c7110508bb95$var$iconStyles = null;
var $5d23c7110508bb95$var$LinkWithoutRef = function LinkWithoutRef(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, newWindowLabel = _ref.newWindowLabel, target = _ref.target, _preventedClassName = _ref.className, _preventedStyle = _ref.style, htmlAttributes = (0, $gnQ3X.default)(_ref, $5d23c7110508bb95$var$_excluded);
    return /*#__PURE__*/ $1oC0p.createElement((0, $48X4a.default), (0, $c9bqK.default)({}, htmlAttributes, {
        target: target,
        ref: ref,
        xcss: (0, $gxoz1.cx)($5d23c7110508bb95$var$styles.base, (0, $gnEGa.fg)('platform-dst-shape-theme-default') && $5d23c7110508bb95$var$styles.baseT26Shape, appearance === 'default' && $5d23c7110508bb95$var$styles.defaultAppearance, appearance === 'subtle' && $5d23c7110508bb95$var$styles.subtleAppearance, appearance === 'inverse' && $5d23c7110508bb95$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $5d23c7110508bb95$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }), children, target === '_blank' && /*#__PURE__*/ $1oC0p.createElement((0, $1Vn55.default), {
        as: "span",
        xcss: $5d23c7110508bb95$var$styles.iconWrapper,
        testId: testId && "".concat(testId, "__icon")
    }, "\uFEFF", /*#__PURE__*/ $1oC0p.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $aL8rw.default)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $1oC0p.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    }))));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ var $5d23c7110508bb95$var$Link = /*#__PURE__*/ (0, $1oC0p.forwardRef)($5d23c7110508bb95$var$LinkWithoutRef);
var $5d23c7110508bb95$export$2e2bcd8739ae039 = $5d23c7110508bb95$var$Link;

});
parcelRegister("aL8rw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7d54d7c7182f5b1e$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $7d54d7c7182f5b1e$var$ATOMIC_GROUP_LENGTH = 5;
function $7d54d7c7182f5b1e$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $7d54d7c7182f5b1e$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("gxoz1", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $c0a2c84e0c72a7dc$export$a274e22fb40f762e; });
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ parcelRequire("1oC0p");


var $eg7Cg = parcelRequire("eg7Cg");
var $c0a2c84e0c72a7dc$var$strictApi = (0, $eg7Cg.createStrictAPI)();
var $c0a2c84e0c72a7dc$export$dbf350e5966cf602 = $c0a2c84e0c72a7dc$var$strictApi.css;
var $c0a2c84e0c72a7dc$export$eb1ecd84a24ee424 = $c0a2c84e0c72a7dc$var$strictApi.cssMap;
$c0a2c84e0c72a7dc$var$strictApi.cssMap;
var $c0a2c84e0c72a7dc$export$a274e22fb40f762e = $c0a2c84e0c72a7dc$var$strictApi.cx;
var $c0a2c84e0c72a7dc$var$XCSSProp = $c0a2c84e0c72a7dc$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 

});
parcelRegister("eg7Cg", function(module, exports) {
$parcel$export(module.exports, "createStrictAPI", function () { return $a61877b6ff611773$export$39716b4af53f4ad; });

var $frPkY = parcelRequire("frPkY");

var $91sjr = parcelRequire("91sjr");
function $a61877b6ff611773$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $frPkY.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $frPkY.createStrictSetupError)();
        },
        cx: $91sjr.cx,
        XCSSProp () {
            throw (0, $frPkY.createStrictSetupError)();
        }
    };
}

});
parcelRegister("frPkY", function(module, exports) {
$parcel$export(module.exports, "createStrictSetupError", function () { return $b3f133249e186177$export$c4df1cb0c2b4d77c; });
const $b3f133249e186177$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $b3f133249e186177$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("91sjr", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $691a2b5ac02932fa$export$a274e22fb40f762e; });

var $aL8rw = parcelRequire("aL8rw");
const $691a2b5ac02932fa$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $aL8rw.default)(actualStyles);
};

});



parcelRegister("gnEGa", function(module, exports) {
$parcel$export(module.exports, "fg", function () { return $bece595b1722f48a$export$b40ec24ac8275656; });

var $hHmFP = parcelRequire("hHmFP");
function $bece595b1722f48a$export$ba05d765b8392e5e(flagResolver) {
    (0, $hHmFP.setBooleanResolver)(flagResolver);
}
function $bece595b1722f48a$export$470e5c2be1411c89(name) {
    return (0, $hHmFP.resolveBooleanFlag)(name);
}
function $bece595b1722f48a$export$b40ec24ac8275656(name) {
    return (0, $hHmFP.resolveBooleanFlag)(name);
}

});
parcelRegister("hHmFP", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", function () { return $ce280a53f089c6ac$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $ce280a53f089c6ac$export$6333b6aff9fc6275; });

var $6mDRs = parcelRequire("6mDRs");

var $3oGHW = parcelRequire("3oGHW");

var $7t0tI = parcelRequire("7t0tI");
var $ce280a53f089c6ac$var$pkgName = '@atlaskit/platform-feature-flags';
var $ce280a53f089c6ac$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $ce280a53f089c6ac$var$hasProcessEnv = typeof $7t0tI !== 'undefined' && typeof $7t0tI.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $ce280a53f089c6ac$var$ENV_ENABLE_PLATFORM_FF = $ce280a53f089c6ac$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $ce280a53f089c6ac$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $ce280a53f089c6ac$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $ce280a53f089c6ac$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $ce280a53f089c6ac$var$ENV_ENABLE_PLATFORM_FF || $ce280a53f089c6ac$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $ce280a53f089c6ac$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $ce280a53f089c6ac$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$ce280a53f089c6ac$var$globalVar[$ce280a53f089c6ac$export$7e41b1b2bdee3f98] = $ce280a53f089c6ac$var$globalVar[$ce280a53f089c6ac$export$7e41b1b2bdee3f98] || $ce280a53f089c6ac$var$DEFAULT_PFF_GLOBAL;
function $ce280a53f089c6ac$export$f2b591175b3e424c(resolver) {
    $ce280a53f089c6ac$var$globalVar[$ce280a53f089c6ac$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $ce280a53f089c6ac$export$6333b6aff9fc6275(flagKey) {
    if ($ce280a53f089c6ac$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $3oGHW.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $ce280a53f089c6ac$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $ce280a53f089c6ac$var$globalVar[$ce280a53f089c6ac$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $ce280a53f089c6ac$var$globalVar[$ce280a53f089c6ac$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $6mDRs.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $ce280a53f089c6ac$var$globalVar[$ce280a53f089c6ac$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("6mDRs", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4a23b7c02e8e2dff$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $lFyMw = parcelRequire("lFyMw");

var $9WANm = parcelRequire("9WANm");



var $4a23b7c02e8e2dff$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $4a23b7c02e8e2dff$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, $cTewU.default)(this, FeatureGates);
    }
    return (0, $avOEA.default)(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$4a23b7c02e8e2dff$var$_FeatureGates = $4a23b7c02e8e2dff$var$FeatureGates;
(0, $f53LC.default)($4a23b7c02e8e2dff$var$FeatureGates, "client", new (0, $lFyMw.Client)());
(0, $f53LC.default)($4a23b7c02e8e2dff$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, $f53LC.default)($4a23b7c02e8e2dff$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, $f53LC.default)($4a23b7c02e8e2dff$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$4a23b7c02e8e2dff$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $4a23b7c02e8e2dff$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $4a23b7c02e8e2dff$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, $f53LC.default)($4a23b7c02e8e2dff$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$4a23b7c02e8e2dff$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $4a23b7c02e8e2dff$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $4a23b7c02e8e2dff$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, $f53LC.default)($4a23b7c02e8e2dff$var$FeatureGates, "initializeCalled", $4a23b7c02e8e2dff$var$_FeatureGates.client.initializeCalled.bind($4a23b7c02e8e2dff$var$_FeatureGates.client));
(0, $f53LC.default)($4a23b7c02e8e2dff$var$FeatureGates, "initializeCompleted", $4a23b7c02e8e2dff$var$_FeatureGates.client.initializeCompleted.bind($4a23b7c02e8e2dff$var$_FeatureGates.client));
(0, $f53LC.default)($4a23b7c02e8e2dff$var$FeatureGates, "waitUntilInitializeCompleted", $4a23b7c02e8e2dff$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($4a23b7c02e8e2dff$var$_FeatureGates.client));
(0, $f53LC.default)($4a23b7c02e8e2dff$var$FeatureGates, "initialize", $4a23b7c02e8e2dff$var$_FeatureGates.client.initialize.bind($4a23b7c02e8e2dff$var$_FeatureGates.client));
(0, $f53LC.default)($4a23b7c02e8e2dff$var$FeatureGates, "initializeWithProvider", $4a23b7c02e8e2dff$var$_FeatureGates.client.initializeWithProvider.bind($4a23b7c02e8e2dff$var$_FeatureGates.client));
(0, $f53LC.default)($4a23b7c02e8e2dff$var$FeatureGates, "initializeFromValues", $4a23b7c02e8e2dff$var$_FeatureGates.client.initializeFromValues.bind($4a23b7c02e8e2dff$var$_FeatureGates.client));
(0, $f53LC.default)($4a23b7c02e8e2dff$var$FeatureGates, "manuallyLogGateExposure", $4a23b7c02e8e2dff$var$_FeatureGates.client.manuallyLogGateExposure.bind($4a23b7c02e8e2dff$var$_FeatureGates.client));
(0, $f53LC.default)($4a23b7c02e8e2dff$var$FeatureGates, "getExperiment", $4a23b7c02e8e2dff$var$_FeatureGates.client.getExperiment.bind($4a23b7c02e8e2dff$var$_FeatureGates.client));
(0, $f53LC.default)($4a23b7c02e8e2dff$var$FeatureGates, "manuallyLogExperimentExposure", $4a23b7c02e8e2dff$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($4a23b7c02e8e2dff$var$_FeatureGates.client));
(0, $f53LC.default)($4a23b7c02e8e2dff$var$FeatureGates, "manuallyLogLayerExposure", $4a23b7c02e8e2dff$var$_FeatureGates.client.manuallyLogLayerExposure.bind($4a23b7c02e8e2dff$var$_FeatureGates.client));
(0, $f53LC.default)($4a23b7c02e8e2dff$var$FeatureGates, "shutdownStatsig", $4a23b7c02e8e2dff$var$_FeatureGates.client.shutdownStatsig.bind($4a23b7c02e8e2dff$var$_FeatureGates.client));
(0, $f53LC.default)($4a23b7c02e8e2dff$var$FeatureGates, "overrideGate", $4a23b7c02e8e2dff$var$_FeatureGates.client.overrideGate.bind($4a23b7c02e8e2dff$var$_FeatureGates.client));
(0, $f53LC.default)($4a23b7c02e8e2dff$var$FeatureGates, "clearGateOverride", $4a23b7c02e8e2dff$var$_FeatureGates.client.clearGateOverride.bind($4a23b7c02e8e2dff$var$_FeatureGates.client));
(0, $f53LC.default)($4a23b7c02e8e2dff$var$FeatureGates, "overrideConfig", $4a23b7c02e8e2dff$var$_FeatureGates.client.overrideConfig.bind($4a23b7c02e8e2dff$var$_FeatureGates.client));
(0, $f53LC.default)($4a23b7c02e8e2dff$var$FeatureGates, "clearConfigOverride", $4a23b7c02e8e2dff$var$_FeatureGates.client.clearConfigOverride.bind($4a23b7c02e8e2dff$var$_FeatureGates.client));
(0, $f53LC.default)($4a23b7c02e8e2dff$var$FeatureGates, "setOverrides", $4a23b7c02e8e2dff$var$_FeatureGates.client.setOverrides.bind($4a23b7c02e8e2dff$var$_FeatureGates.client));
(0, $f53LC.default)($4a23b7c02e8e2dff$var$FeatureGates, "getOverrides", $4a23b7c02e8e2dff$var$_FeatureGates.client.getOverrides.bind($4a23b7c02e8e2dff$var$_FeatureGates.client));
(0, $f53LC.default)($4a23b7c02e8e2dff$var$FeatureGates, "clearAllOverrides", $4a23b7c02e8e2dff$var$_FeatureGates.client.clearAllOverrides.bind($4a23b7c02e8e2dff$var$_FeatureGates.client));
(0, $f53LC.default)($4a23b7c02e8e2dff$var$FeatureGates, "isCurrentUser", $4a23b7c02e8e2dff$var$_FeatureGates.client.isCurrentUser.bind($4a23b7c02e8e2dff$var$_FeatureGates.client));
(0, $f53LC.default)($4a23b7c02e8e2dff$var$FeatureGates, "onGateUpdated", $4a23b7c02e8e2dff$var$_FeatureGates.client.onGateUpdated.bind($4a23b7c02e8e2dff$var$_FeatureGates.client));
(0, $f53LC.default)($4a23b7c02e8e2dff$var$FeatureGates, "onExperimentValueUpdated", $4a23b7c02e8e2dff$var$_FeatureGates.client.onExperimentValueUpdated.bind($4a23b7c02e8e2dff$var$_FeatureGates.client));
(0, $f53LC.default)($4a23b7c02e8e2dff$var$FeatureGates, "onAnyUpdated", $4a23b7c02e8e2dff$var$_FeatureGates.client.onAnyUpdated.bind($4a23b7c02e8e2dff$var$_FeatureGates.client));
(0, $f53LC.default)($4a23b7c02e8e2dff$var$FeatureGates, "updateUser", $4a23b7c02e8e2dff$var$_FeatureGates.client.updateUser.bind($4a23b7c02e8e2dff$var$_FeatureGates.client));
(0, $f53LC.default)($4a23b7c02e8e2dff$var$FeatureGates, "updateUserWithProvider", $4a23b7c02e8e2dff$var$_FeatureGates.client.updateUserWithProvider.bind($4a23b7c02e8e2dff$var$_FeatureGates.client));
(0, $f53LC.default)($4a23b7c02e8e2dff$var$FeatureGates, "updateUserWithValues", $4a23b7c02e8e2dff$var$_FeatureGates.client.updateUserWithValues.bind($4a23b7c02e8e2dff$var$_FeatureGates.client));
(0, $f53LC.default)($4a23b7c02e8e2dff$var$FeatureGates, "getPackageVersion", $4a23b7c02e8e2dff$var$_FeatureGates.client.getPackageVersion.bind($4a23b7c02e8e2dff$var$_FeatureGates.client));
(0, $f53LC.default)($4a23b7c02e8e2dff$var$FeatureGates, "getLayer", $4a23b7c02e8e2dff$var$_FeatureGates.client.getLayer.bind($4a23b7c02e8e2dff$var$_FeatureGates.client));
(0, $f53LC.default)($4a23b7c02e8e2dff$var$FeatureGates, "getLayerValue", $4a23b7c02e8e2dff$var$_FeatureGates.client.getLayerValue.bind($4a23b7c02e8e2dff$var$_FeatureGates.client));
var $4a23b7c02e8e2dff$var$boundFGJS = $4a23b7c02e8e2dff$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $4a23b7c02e8e2dff$var$FeatureGates;
    else {
        var $4a23b7c02e8e2dff$var$_boundFGJS, $4a23b7c02e8e2dff$var$_boundFGJS$getPackage;
        $4a23b7c02e8e2dff$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $4a23b7c02e8e2dff$var$boundVersion = (($4a23b7c02e8e2dff$var$_boundFGJS = $4a23b7c02e8e2dff$var$boundFGJS) === null || $4a23b7c02e8e2dff$var$_boundFGJS === void 0 || ($4a23b7c02e8e2dff$var$_boundFGJS$getPackage = $4a23b7c02e8e2dff$var$_boundFGJS.getPackageVersion) === null || $4a23b7c02e8e2dff$var$_boundFGJS$getPackage === void 0 ? void 0 : $4a23b7c02e8e2dff$var$_boundFGJS$getPackage.call($4a23b7c02e8e2dff$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($4a23b7c02e8e2dff$var$boundVersion !== (0, $9WANm.CLIENT_VERSION)) {
            var $4a23b7c02e8e2dff$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($4a23b7c02e8e2dff$var$boundVersion, " when module version ").concat((0, $9WANm.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($4a23b7c02e8e2dff$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $4a23b7c02e8e2dff$export$2e2bcd8739ae039 = $4a23b7c02e8e2dff$var$boundFGJS;

});
parcelRegister("lFyMw", function(module, exports) {
$parcel$export(module.exports, "Client", function () { return $fc68683516cba95b$export$1f2bb630327ac4b6; });

var $gnQ3X = parcelRequire("gnQ3X");

var $2qaZZ = parcelRequire("2qaZZ");

var $cn8ql = parcelRequire("cn8ql");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $5Cxn4 = parcelRequire("5Cxn4");

var $ec1qE = parcelRequire("ec1qE");

var $8LrFU = parcelRequire("8LrFU");

var $hHzWr = parcelRequire("hHzWr");

var $jXGRQ = parcelRequire("jXGRQ");

var $5m8eB = parcelRequire("5m8eB");

var $jFAYA = parcelRequire("jFAYA");

var $3kPiN = parcelRequire("3kPiN");

var $3lH9g = parcelRequire("3lH9g");

var $hbgOx = parcelRequire("hbgOx");

var $cnAmV = parcelRequire("cnAmV");

var $9WANm = parcelRequire("9WANm");
var $fc68683516cba95b$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $fc68683516cba95b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fc68683516cba95b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fc68683516cba95b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fc68683516cba95b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fc68683516cba95b$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $fc68683516cba95b$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $fc68683516cba95b$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $3lH9g.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, $cTewU.default)(this, Client);
        (0, $f53LC.default)(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, $f53LC.default)(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, $f53LC.default)(this, "initWithDefaults", false);
        (0, $f53LC.default)(this, "hasCheckGateErrorOccurred", false);
        (0, $f53LC.default)(this, "hasGetExperimentErrorOccurred", false);
        (0, $f53LC.default)(this, "hasGetExperimentValueErrorOccurred", false);
        (0, $f53LC.default)(this, "hasGetLayerErrorOccurred", false);
        (0, $f53LC.default)(this, "hasGetLayerValueErrorOccurred", false);
        (0, $f53LC.default)(this, "subscriptions", new (0, $8LrFU.default)());
        (0, $f53LC.default)(this, "dataAdapter", new (0, $3kPiN.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, $f53LC.default)(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $3lH9g.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, $avOEA.default)(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $cnAmV.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $cnAmV.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $cnAmV.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $cnAmV.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $9WANm.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $fc68683516cba95b$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $9WANm.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $hbgOx.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $cnAmV.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $cnAmV.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $cnAmV.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $jFAYA.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 2;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 2:
                                if (!this.initCompleted) {
                                    _context7.next = 4;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 4:
                                _context7.next = 6;
                                return this.initPromise;
                            case 6:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $hHzWr.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $hHzWr.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $5m8eB.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $cnAmV.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $cnAmV.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $fc68683516cba95b$var$_objectSpread({}, clientOptions);
                                _context8.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $jFAYA.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $jFAYA.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, $2qaZZ.default)(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 20;
                                break;
                            case 13:
                                _context8.prev = 13;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context8.t0;
                            case 20:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $fc68683516cba95b$var$_objectSpread($fc68683516cba95b$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, $2qaZZ.default)(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 22;
                                break;
                            case 15:
                                _context9.prev = 15;
                                _context9.t0 = _context9["catch"](1);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context9.t0;
                            case 22:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args0 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee0$(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $cnAmV.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $fc68683516cba95b$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $fc68683516cba95b$var$_objectSpread($fc68683516cba95b$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $fc68683516cba95b$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $hbgOx.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, $gnQ3X.default)(newClientOptions, $fc68683516cba95b$var$_excluded);
                                this.user = (0, $cnAmV.toStatsigUser)(identifiers, customAttributes);
                                statsigOptions = $fc68683516cba95b$var$_objectSpread($fc68683516cba95b$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $ec1qE.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $ec1qE.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 12;
                                this.statsigClient = new (0, $ec1qE.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context0.next = 29;
                                break;
                            case 19:
                                _context0.prev = 19;
                                _context0.t0 = _context0["catch"](12);
                                if (_context0.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context0.t0 === null || _context0.t0 === void 0 ? void 0 : _context0.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $ec1qE.StatsigClient)($fc68683516cba95b$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context0.t0;
                            case 29:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 3;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 5;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 6;
                                _context10.next = 9;
                                return this.initPromise;
                            case 9:
                                _context10.next = 13;
                                break;
                            case 11:
                                _context10.prev = 11;
                                _context10.t0 = _context10["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee1$(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 4;
                                                    break;
                                                }
                                                _context1.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context11.sent;
                                user = (0, $cnAmV.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                _context11.next = 13;
                                break;
                            case 8:
                                _context11.prev = 8;
                                _context11.t0 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context11.t0 instanceof Error ? _context11.t0.message : JSON.stringify(_context11.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context11.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 21;
                                    break;
                                }
                                _context11.next = 21;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 21:
                                _context11.next = 27;
                                break;
                            case 23:
                                _context11.prev = 23;
                                _context11.t1 = _context11["catch"](15);
                                success = false;
                                errorMessage = String(_context11.t1);
                            case 27:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 34;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 35;
                                break;
                            case 34:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 35:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            23
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $9WANm.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $jXGRQ.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $jXGRQ.Layer).fromLayer((0, $ec1qE._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("8LrFU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $66182e35177d4c25$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $f72YL = parcelRequire("f72YL");
function $66182e35177d4c25$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $66182e35177d4c25$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $66182e35177d4c25$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $66182e35177d4c25$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $66182e35177d4c25$export$a66cbd9b2289cd78 = '@all-features';
var $66182e35177d4c25$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, $cTewU.default)(this, Subscriptions);
        (0, $f53LC.default)(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($f72YL)))();
    }
    return (0, $avOEA.default)(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $66182e35177d4c25$var$_objectSpread($66182e35177d4c25$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $66182e35177d4c25$var$_objectSpread($66182e35177d4c25$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $66182e35177d4c25$var$_objectSpread($66182e35177d4c25$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $66182e35177d4c25$var$_objectSpread($66182e35177d4c25$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($66182e35177d4c25$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($66182e35177d4c25$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($66182e35177d4c25$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $66182e35177d4c25$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("hHzWr", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", function () { return $ce32550e5290cacc$export$6dc24881a3d96325; });

var $2zYm4 = parcelRequire("2zYm4");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $cnAmV = parcelRequire("cnAmV");
var $ce32550e5290cacc$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, $cTewU.default)(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, $avOEA.default)(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, $2zYm4.default)(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, $2zYm4.default)(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $cnAmV.migrateEvaluationDetails)(experiment.details), (0, $cnAmV.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("cnAmV", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", function () { return $9033d81bc9dbb16d$export$d119b37e5f788b43; });
$parcel$export(module.exports, "shallowEquals", function () { return $9033d81bc9dbb16d$export$fa1c2bbf4100b8bc; });
$parcel$export(module.exports, "toStatsigUser", function () { return $9033d81bc9dbb16d$export$3dad1db244472f32; });
$parcel$export(module.exports, "migrateInitializationOptions", function () { return $9033d81bc9dbb16d$export$202946b690d26d22; });
$parcel$export(module.exports, "migrateEvaluationDetails", function () { return $9033d81bc9dbb16d$export$18ad168d3dbac899; });
$parcel$export(module.exports, "migrateSecondaryExposures", function () { return $9033d81bc9dbb16d$export$55fd683752d01e67; });

var $gnQ3X = parcelRequire("gnQ3X");

var $2qaZZ = parcelRequire("2qaZZ");

var $f53LC = parcelRequire("f53LC");

var $hMUFv = parcelRequire("hMUFv");

var $5m8eB = parcelRequire("5m8eB");

var $hbgOx = parcelRequire("hbgOx");
var $9033d81bc9dbb16d$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $9033d81bc9dbb16d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9033d81bc9dbb16d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9033d81bc9dbb16d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9033d81bc9dbb16d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9033d81bc9dbb16d$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $9033d81bc9dbb16d$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $hMUFv.isFedRamp)() ? (0, $hbgOx.PerimeterType).FEDRAMP_MODERATE : (0, $hbgOx.PerimeterType).COMMERCIAL
    }, options);
};
var $9033d81bc9dbb16d$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, $2qaZZ.default)(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, $2qaZZ.default)(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, $2qaZZ.default)(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, $2qaZZ.default)(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $9033d81bc9dbb16d$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    var user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $9033d81bc9dbb16d$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, $gnQ3X.default)(options, $9033d81bc9dbb16d$var$_excluded);
    return $9033d81bc9dbb16d$var$_objectSpread($9033d81bc9dbb16d$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $9033d81bc9dbb16d$var$evaluationReasonMappings = Object.entries((0, $5m8eB.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, $2qaZZ.default)(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $9033d81bc9dbb16d$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $9033d81bc9dbb16d$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, $2qaZZ.default)(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $5m8eB.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $9033d81bc9dbb16d$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("5m8eB", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", function () { return $3e6565033f4a5cf4$export$c62558b199e46828; });
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $3e6565033f4a5cf4$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("hbgOx", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", function () { return $c82081ad70fd0412$export$479e7351a733299; });
$parcel$export(module.exports, "PerimeterType", function () { return $c82081ad70fd0412$export$c42b7bbc5e7ba555; });
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $c82081ad70fd0412$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $c82081ad70fd0412$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $c82081ad70fd0412$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("jXGRQ", function(module, exports) {
$parcel$export(module.exports, "Layer", function () { return $e884c79c4f962b23$export$936d0764594b6eb3; });

var $2zYm4 = parcelRequire("2zYm4");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $cnAmV = parcelRequire("cnAmV");
var $e884c79c4f962b23$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, $cTewU.default)(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, $avOEA.default)(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, $2zYm4.default)(val) === (0, $2zYm4.default)(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $cnAmV.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $cnAmV.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $cnAmV.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("jFAYA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e51e876218f09007$export$2e2bcd8739ae039; });

var $f53LC = parcelRequire("f53LC");

var $cn8ql = parcelRequire("cn8ql");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $5Cxn4 = parcelRequire("5Cxn4");

var $hbgOx = parcelRequire("hbgOx");

var $9WANm = parcelRequire("9WANm");

var $jvDUn = parcelRequire("jvDUn");
function $e51e876218f09007$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e51e876218f09007$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e51e876218f09007$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e51e876218f09007$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e51e876218f09007$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $e51e876218f09007$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $e51e876218f09007$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $e51e876218f09007$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $e51e876218f09007$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $e51e876218f09007$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $e51e876218f09007$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $e51e876218f09007$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $e51e876218f09007$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $e51e876218f09007$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $e51e876218f09007$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, $cTewU.default)(this, Fetcher);
    }
    return (0, $avOEA.default)(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error('Failed to retrieve client sdk key');
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error('Failed to retrieve experiment values');
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $jvDUn.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $jvDUn.ResponseError)('Unexpected 204 response');
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $e51e876218f09007$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $hbgOx.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $hbgOx.FeatureGateEnvironment).Production:
                        return $e51e876218f09007$export$18c93900db9358a4;
                    case (0, $hbgOx.FeatureGateEnvironment).Staging:
                        return $e51e876218f09007$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $hbgOx.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $hbgOx.FeatureGateEnvironment).Development:
                        return $e51e876218f09007$export$f058dbf75c3bc647;
                    case (0, $hbgOx.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $e51e876218f09007$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $e51e876218f09007$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $e51e876218f09007$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $e51e876218f09007$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $9WANm.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $e51e876218f09007$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($e51e876218f09007$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($e51e876218f09007$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("9WANm", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", function () { return $73d6129ad179658a$export$a59f8d67326bd1cb; });
/// <reference types="node" />
var $73d6129ad179658a$export$a59f8d67326bd1cb = "0.0.0-development";

});

parcelRegister("jvDUn", function(module, exports) {
$parcel$export(module.exports, "ResponseError", function () { return $e33fde8b2dec7c64$export$286baf652d0b1206; });

var $avOEA = parcelRequire("avOEA");

var $cTewU = parcelRequire("cTewU");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $i7dvh = parcelRequire("i7dvh");

var $4GELH = parcelRequire("4GELH");
function $e33fde8b2dec7c64$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $e33fde8b2dec7c64$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $e33fde8b2dec7c64$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e33fde8b2dec7c64$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $e33fde8b2dec7c64$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, $cTewU.default)(this, ResponseError);
        return $e33fde8b2dec7c64$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, $i7dvh.default)(ResponseError, _Error);
    return (0, $avOEA.default)(ResponseError);
}(/*#__PURE__*/ (0, $4GELH.default)(Error));

});


parcelRegister("3kPiN", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", function () { return $26db08e645abe002$export$55fffef3474104af; });

var $cn8ql = parcelRequire("cn8ql");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $7SQOE = parcelRequire("7SQOE");

var $i7dvh = parcelRequire("i7dvh");

var $f53LC = parcelRequire("f53LC");

var $5Cxn4 = parcelRequire("5Cxn4");

var $ec1qE = parcelRequire("ec1qE");
function $26db08e645abe002$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $26db08e645abe002$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $26db08e645abe002$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $26db08e645abe002$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $26db08e645abe002$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $26db08e645abe002$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $26db08e645abe002$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($26db08e645abe002$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $26db08e645abe002$var$_superPropGet(t, o, e, r) {
    var p = (0, $7SQOE.default)((0, $jlBwm.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $26db08e645abe002$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, $cTewU.default)(this, NoFetchDataAdapter);
        _this = $26db08e645abe002$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, $f53LC.default)(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, $i7dvh.default)(NoFetchDataAdapter, _DataAdapterCore);
    return (0, $avOEA.default)(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $ec1qE.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $26db08e645abe002$var$_objectSpread($26db08e645abe002$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $ec1qE._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $26db08e645abe002$var$_objectSpread($26db08e645abe002$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $ec1qE._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $ec1qE._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $ec1qE.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $26db08e645abe002$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $26db08e645abe002$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $ec1qE.DataAdapterCore));

});

parcelRegister("3lH9g", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", function () { return $2704cda6acabf0a8$export$d8474cff104280f3; });
$parcel$export(module.exports, "PersistentOverrideAdapter", function () { return $2704cda6acabf0a8$export$bcb28fbac1def494; });

var $f53LC = parcelRequire("f53LC");

var $2qaZZ = parcelRequire("2qaZZ");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $3wfvf = parcelRequire("3wfvf");
function $2704cda6acabf0a8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2704cda6acabf0a8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2704cda6acabf0a8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2704cda6acabf0a8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2704cda6acabf0a8$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $2704cda6acabf0a8$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $2704cda6acabf0a8$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $2704cda6acabf0a8$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $2704cda6acabf0a8$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $2704cda6acabf0a8$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $2704cda6acabf0a8$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $2704cda6acabf0a8$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $2704cda6acabf0a8$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $2704cda6acabf0a8$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $2704cda6acabf0a8$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $2704cda6acabf0a8$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, $cTewU.default)(this, PersistentOverrideAdapter);
        this._overrides = $2704cda6acabf0a8$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, $avOEA.default)(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $2704cda6acabf0a8$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $2704cda6acabf0a8$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $2704cda6acabf0a8$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, $2qaZZ.default)(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, $2qaZZ.default)(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, $2qaZZ.default)(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($2704cda6acabf0a8$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($2704cda6acabf0a8$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $2704cda6acabf0a8$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $3wfvf._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $2704cda6acabf0a8$var$_objectSpread($2704cda6acabf0a8$var$_objectSpread({}, $2704cda6acabf0a8$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, $2qaZZ.default)(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, $2qaZZ.default)(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($2704cda6acabf0a8$var$djb2MapKey((0, $3wfvf._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($2704cda6acabf0a8$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($2704cda6acabf0a8$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($2704cda6acabf0a8$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $2704cda6acabf0a8$var$_objectSpread($2704cda6acabf0a8$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $2704cda6acabf0a8$var$_objectSpread($2704cda6acabf0a8$var$_objectSpread({}, current.details), {}, {
                        reason: $2704cda6acabf0a8$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($2704cda6acabf0a8$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($2704cda6acabf0a8$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($2704cda6acabf0a8$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($2704cda6acabf0a8$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($2704cda6acabf0a8$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($2704cda6acabf0a8$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $2704cda6acabf0a8$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($2704cda6acabf0a8$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $2704cda6acabf0a8$var$_objectSpread($2704cda6acabf0a8$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $3wfvf._makeTypedGet)(current.name, overridden),
                    details: $2704cda6acabf0a8$var$_objectSpread($2704cda6acabf0a8$var$_objectSpread({}, current.details), {}, {
                        reason: $2704cda6acabf0a8$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($2704cda6acabf0a8$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $2704cda6acabf0a8$var$_objectSpread($2704cda6acabf0a8$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $3wfvf._makeTypedGet)(current.name, overridden),
                    details: $2704cda6acabf0a8$var$_objectSpread($2704cda6acabf0a8$var$_objectSpread({}, current.details), {}, {
                        reason: $2704cda6acabf0a8$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("3oGHW", function(module, exports) {
$parcel$export(module.exports, "debug", function () { return $2794bddee7e270cf$export$1c9f709888824e05; });
var $2794bddee7e270cf$var$_process, $2794bddee7e270cf$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $2794bddee7e270cf$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($2794bddee7e270cf$var$_process = globalThis.process) === null || $2794bddee7e270cf$var$_process === void 0 || ($2794bddee7e270cf$var$_process = $2794bddee7e270cf$var$_process.env) === null || $2794bddee7e270cf$var$_process === void 0 ? void 0 : $2794bddee7e270cf$var$_process.JEST_WORKER_ID) !== undefined;
var $2794bddee7e270cf$var$DEBUG_MODE = !$2794bddee7e270cf$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($2794bddee7e270cf$var$_process2 = globalThis.process) === null || $2794bddee7e270cf$var$_process2 === void 0 || ($2794bddee7e270cf$var$_process2 = $2794bddee7e270cf$var$_process2.env) === null || $2794bddee7e270cf$var$_process2 === void 0 ? void 0 : $2794bddee7e270cf$var$_process2.NODE_ENV) !== 'production';
var $2794bddee7e270cf$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$2794bddee7e270cf$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("48X4a", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3045ba187952c969$export$2e2bcd8739ae039; });
/* anchor.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $c9bqK = parcelRequire("c9bqK");

var $2zYm4 = parcelRequire("2zYm4");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");


var $c04yF = parcelRequire("c04yF");

var $lmxXn = parcelRequire("lmxXn");

var $9Htkf = parcelRequire("9Htkf");

var $3UbP6 = parcelRequire("3UbP6");

var $6Wtc0 = parcelRequire("6Wtc0");

var $2zNIn = parcelRequire("2zNIn");

var $etBkE = parcelRequire("etBkE");

var $df7j8 = parcelRequire("df7j8");

var $eSFEs = parcelRequire("eSFEs");
var $3045ba187952c969$var$_excluded = [
    "href",
    "children",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss",
    "newWindowLabel"
], $3045ba187952c969$var$_excluded2 = [
    "className"
];
var $3045ba187952c969$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi",
    position: "_kqswh2mm"
};
var $3045ba187952c969$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $3045ba187952c969$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $3045ba187952c969$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $6Wtc0.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, _ref$newWindowLabel = _ref.newWindowLabel, newWindowLabel = _ref$newWindowLabel === void 0 ? '(opens new window)' : _ref$newWindowLabel, htmlAttributes = (0, $gnQ3X.default)(_ref, $3045ba187952c969$var$_excluded);
    var interactionContext = (0, $1oC0p.useContext)((0, $etBkE.default));
    var handleClick = (0, $1oC0p.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $2zNIn.useId)();
    var onClick = (0, $9Htkf.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "@atlaskit/primitives",
        packageVersion: "0.0.0-development",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $gnQ3X.default)(htmlAttributes, $3045ba187952c969$var$_excluded2);
    var RouterLink = (0, $3UbP6.default)();
    var isExternal = typeof href === 'string' && $3045ba187952c969$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $3045ba187952c969$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, $2zYm4.default)(href) === 'object';
    (0, $lmxXn.default)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ $1oC0p.createElement((0, $eSFEs.default), (0, $c9bqK.default)({
        as: Component,
        className: xcss,
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        xcss: (0, $c04yF.cx)($3045ba187952c969$var$styles.root, $3045ba187952c969$var$styles.position, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }), children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ $1oC0p.createElement((0, $df7j8.default), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel)));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $3045ba187952c969$var$Anchor = /*#__PURE__*/ (0, $1oC0p.forwardRef)($3045ba187952c969$var$AnchorNoRef);
var $3045ba187952c969$export$2e2bcd8739ae039 = $3045ba187952c969$var$Anchor;

});
parcelRegister("c04yF", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $8bc9054b40952189$export$a274e22fb40f762e; });

var $2KOOf = parcelRequire("2KOOf");
const $8bc9054b40952189$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $2KOOf.default)(actualStyles);
};

});
parcelRegister("2KOOf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $20174a5b3cfbd91c$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $20174a5b3cfbd91c$var$ATOMIC_GROUP_LENGTH = 5;
function $20174a5b3cfbd91c$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $20174a5b3cfbd91c$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});


parcelRegister("9Htkf", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $70fee0a54d19cb87$export$a4687b0234b40e28; });

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $jPCf3 = parcelRequire("jPCf3");

var $a7Fox = parcelRequire("a7Fox");
function $70fee0a54d19cb87$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $70fee0a54d19cb87$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $70fee0a54d19cb87$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $70fee0a54d19cb87$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $70fee0a54d19cb87$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $jPCf3.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $a7Fox.useTrackedRef)(analyticsData);
    var fnRef = (0, $a7Fox.useTrackedRef)(fn);
    var handler = (0, $1oC0p.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $70fee0a54d19cb87$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("jPCf3", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", function () { return $e70071c56ce5fbda$export$5bf35293e545f20c; });

var $hcVab = parcelRequire("hcVab");

var $iBDbC = parcelRequire("iBDbC");

var $bfphz = parcelRequire("bfphz");
function $e70071c56ce5fbda$export$5bf35293e545f20c() {
    var analyticsContext = (0, $bfphz.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $hcVab.useCallbackOne)(function(payload) {
        return new (0, $iBDbC.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("iBDbC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d8ba144bdbc3b0e1$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $7SQOE = parcelRequire("7SQOE");

var $i7dvh = parcelRequire("i7dvh");

var $f53LC = parcelRequire("f53LC");

var $2XX17 = parcelRequire("2XX17");
function $d8ba144bdbc3b0e1$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $d8ba144bdbc3b0e1$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $d8ba144bdbc3b0e1$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d8ba144bdbc3b0e1$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $d8ba144bdbc3b0e1$var$_superPropGet(t, o, e, r) {
    var p = (0, $7SQOE.default)((0, $jlBwm.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $d8ba144bdbc3b0e1$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $d8ba144bdbc3b0e1$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $d8ba144bdbc3b0e1$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $cTewU.default)(this, UIAnalyticsEvent);
        _this = $d8ba144bdbc3b0e1$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $f53LC.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $f53LC.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $lFOXD.default)(_this.context);
            var handlers = (0, $lFOXD.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $f53LC.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $i7dvh.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $avOEA.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $d8ba144bdbc3b0e1$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $2XX17.default));

});
parcelRegister("2XX17", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $228edf078054661b$export$2e2bcd8739ae039; });

var $2zYm4 = parcelRequire("2zYm4");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");
function $228edf078054661b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $228edf078054661b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $228edf078054661b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $228edf078054661b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $228edf078054661b$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $228edf078054661b$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $228edf078054661b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $cTewU.default)(this, AnalyticsEvent);
        (0, $f53LC.default)(this, "_isAnalyticsEvent", true);
        (0, $f53LC.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $228edf078054661b$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $avOEA.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $2zYm4.default)(updater) === 'object') this.payload = $228edf078054661b$var$_objectSpread($228edf078054661b$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("bfphz", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", function () { return $8304b4fb98960f6b$export$d1f587f82ad51c4; });

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");
var $8304b4fb98960f6b$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $1oC0p.useContext)((0, $bEiDG.default));
};

});


parcelRegister("a7Fox", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", function () { return $75eaaafb96fdca61$export$1d27a74659855e44; });

var $1oC0p = parcelRequire("1oC0p");
var $75eaaafb96fdca61$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $1oC0p.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("3UbP6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2d7fc5ef34c59c65$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $2K0RI = parcelRequire("2K0RI");
/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $2d7fc5ef34c59c65$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $1oC0p.useContext)((0, $2K0RI.RouterLinkProviderContext)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $2d7fc5ef34c59c65$export$2e2bcd8739ae039 = $2d7fc5ef34c59c65$var$useRouterLink;

});
parcelRegister("2K0RI", function(module, exports) {
$parcel$export(module.exports, "RouterLinkProviderContext", function () { return $1ff08c7dcce19823$export$2931e0ee690eee88; });

var $1oC0p = parcelRequire("1oC0p");
var $1ff08c7dcce19823$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $1oC0p.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $1ff08c7dcce19823$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($1ff08c7dcce19823$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $1ff08c7dcce19823$export$2e2bcd8739ae039 = $1ff08c7dcce19823$var$RouterLinkProvider;

});


parcelRegister("6Wtc0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $50decdea947a560b$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $50decdea947a560b$export$2e2bcd8739ae039() {}

});

parcelRegister("2zNIn", function(module, exports) {
$parcel$export(module.exports, "useId", function () { return $1e0569f2f900e6e0$export$f680877a34711e37; });

var $2zYm4 = parcelRequire("2zYm4");

var $1oC0p = parcelRequire("1oC0p");
function $1e0569f2f900e6e0$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useId().replace(/[:«»]/g, '_');
}
var $1e0569f2f900e6e0$export$6be90bcb437e928f = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($1e0569f2f900e6e0$export$f680877a34711e37()).concat(postfix);
    (0, $1oC0p.useEffect)(function() {
        if (!ref) return;
        switch((0, $2zYm4.default)(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, $2zYm4.default)(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $1e0569f2f900e6e0$export$6ee17796e3d70de2() {
    var uid = $1e0569f2f900e6e0$export$f680877a34711e37();
    return function(id) {
        return "".concat(uid, "-").concat(id.toString());
    };
}

});

parcelRegister("df7j8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9a425837446587bc$export$2e2bcd8739ae039; });
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $bVOgM = parcelRequire("bVOgM");
var $9a425837446587bc$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $9a425837446587bc$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $bVOgM.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ])
    }, children);
};
$9a425837446587bc$var$VisuallyHidden.displayName = 'VisuallyHidden';
var $9a425837446587bc$export$2e2bcd8739ae039 = $9a425837446587bc$var$VisuallyHidden;

});
parcelRegister("bVOgM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8afc0317024415f4$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $8afc0317024415f4$var$ATOMIC_GROUP_LENGTH = 5;
function $8afc0317024415f4$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $8afc0317024415f4$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});


parcelRegister("eSFEs", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ad566af3e23dd79c$export$2e2bcd8739ae039; });
/* focusable.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $2KOOf = parcelRequire("2KOOf");
var $ad566af3e23dd79c$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $ad566af3e23dd79c$var$_excluded2 = [
    "className"
];
var $ad566af3e23dd79c$var$focusRingStyles = null;
var $ad566af3e23dd79c$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $ad566af3e23dd79c$var$Focusable = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, $gnQ3X.default)(_ref, $ad566af3e23dd79c$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $gnQ3X.default)(htmlAttributes, $ad566af3e23dd79c$var$_excluded2);
    return /*#__PURE__*/ $1oC0p.createElement(Component, (0, $c9bqK.default)({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $2KOOf.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $ad566af3e23dd79c$export$2e2bcd8739ae039 = $ad566af3e23dd79c$var$Focusable;

});


parcelRegister("1Vn55", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $166d04b848103c5d$export$2e2bcd8739ae039; });
/* box.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $2KOOf = parcelRequire("2KOOf");

var $7fdt6 = parcelRequire("7fdt6");
var $166d04b848103c5d$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $166d04b848103c5d$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $166d04b848103c5d$var$baseStyles = null;
var $166d04b848103c5d$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhkby5v",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $166d04b848103c5d$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $166d04b848103c5d$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var $166d04b848103c5d$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $166d04b848103c5d$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $166d04b848103c5d$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $166d04b848103c5d$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $166d04b848103c5d$var$Box = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $gnQ3X.default)(_ref, $166d04b848103c5d$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $gnQ3X.default)(htmlAttributes, $166d04b848103c5d$var$_excluded2);
    var node = /*#__PURE__*/ $1oC0p.createElement(Component, (0, $c9bqK.default)({
        style: style,
        ref: ref,
        className: (0, $2KOOf.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $166d04b848103c5d$var$backgroundColorMap[backgroundColor],
            backgroundColor && $166d04b848103c5d$var$isSurfaceToken(backgroundColor) && $166d04b848103c5d$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $166d04b848103c5d$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $166d04b848103c5d$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $166d04b848103c5d$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $166d04b848103c5d$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $1oC0p.createElement((0, $7fdt6.SurfaceContext).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $166d04b848103c5d$export$2e2bcd8739ae039 = $166d04b848103c5d$var$Box;
function $166d04b848103c5d$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $166d04b848103c5d$var$setSurfaceTokenMap;
}

});
parcelRegister("7fdt6", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", function () { return $546461a53126e2f9$export$1ca2a26fecb070ae; });

var $1oC0p = parcelRequire("1oC0p");
var $546461a53126e2f9$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1oC0p.createContext)('elevation.surface');
var $546461a53126e2f9$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $1oC0p.useContext)($546461a53126e2f9$export$1ca2a26fecb070ae);
};
$546461a53126e2f9$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});



parcelRegister("hra1O", function(module, exports) {
function $cb1cbcadfcc5a111$export$2e2bcd8739ae039(r) {
    throw new TypeError('"' + r + '" is read-only');
}

});

parcelRegister("ff3wF", function(module, exports) {
$parcel$export(module.exports, "HelperMessage", function () { return $b18afde638dfaf85$export$8fbe3c7d0ed2c683; });
$parcel$export(module.exports, "ErrorMessage", function () { return $b18afde638dfaf85$export$915e9e7bd4f0f96d; });
/** @jsx jsx */ 
var $3dJ4i = parcelRequire("3dJ4i");

var $eWkao = parcelRequire("eWkao");

var $6r1ZZ = parcelRequire("6r1ZZ");

var $3c7rQ = parcelRequire("3c7rQ");

var $7gyMa = parcelRequire("7gyMa");

var $hnR5n = parcelRequire("hnR5n");

var $agPDl = parcelRequire("agPDl");

var $fqpc8 = parcelRequire("fqpc8");
/**
 * API for the internal `<Message />` component. This is not public API.
 */ /**
 * Public API of the various message components.
 */ var $b18afde638dfaf85$var$fontFamily = (0, $hnR5n.fontFamily)();
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $b18afde638dfaf85$var$lightH200Styles = (0, $3dJ4i.css)((0, $agPDl.h200)({
    theme: {
        mode: 'light'
    }
}));
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $b18afde638dfaf85$var$darkH200Styles = (0, $3dJ4i.css)((0, $agPDl.h200)({
    theme: {
        mode: 'dark'
    }
}));
var $b18afde638dfaf85$var$messageStyles = (0, $3dJ4i.css)({
    display: 'flex',
    marginTop: "var(--ds-space-050, 4px)",
    justifyContent: 'baseline',
    fontFamily: "".concat($b18afde638dfaf85$var$fontFamily),
    fontWeight: 'normal'
});
var $b18afde638dfaf85$var$messageAppearanceStyles = {
    default: (0, $3dJ4i.css)({
        color: "var(--ds-text-subtlest, ".concat((0, $3c7rQ.N200), ")")
    }),
    error: (0, $3dJ4i.css)({
        color: "var(--ds-text-danger, #AE2A19)"
    }),
    valid: (0, $3dJ4i.css)({
        color: "var(--ds-text-success, #216E4E)"
    })
};
var $b18afde638dfaf85$var$iconWrapperStyles = (0, $3dJ4i.css)({
    display: 'flex'
});
var $b18afde638dfaf85$var$IconWrapper = function IconWrapper(_ref) {
    var children = _ref.children;
    return (0, $3dJ4i.jsx)("span", {
        css: $b18afde638dfaf85$var$iconWrapperStyles
    }, children);
};
var $b18afde638dfaf85$var$messageIcons = {
    error: (0, $3dJ4i.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6r1ZZ))), {
        size: "small",
        label: "error"
    }),
    valid: (0, $3dJ4i.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eWkao))), {
        size: "small",
        label: "success"
    })
};
var $b18afde638dfaf85$var$Message = function Message(_ref2) {
    var children = _ref2.children, _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? 'default' : _ref2$appearance, fieldId = _ref2.fieldId, testId = _ref2.testId;
    var _useGlobalTheme = (0, $7gyMa.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var icon = $b18afde638dfaf85$var$messageIcons[appearance];
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ var content = typeof children === 'string' ? children : (0, $3dJ4i.jsx)("span", null, children);
    return (0, $3dJ4i.jsx)("div", {
        css: [
            mode === 'light' ? $b18afde638dfaf85$var$lightH200Styles : $b18afde638dfaf85$var$darkH200Styles,
            $b18afde638dfaf85$var$messageStyles,
            $b18afde638dfaf85$var$messageAppearanceStyles[appearance]
        ],
        "data-testid": testId,
        id: fieldId,
        "aria-live": "polite"
    }, icon && (0, $3dJ4i.jsx)($b18afde638dfaf85$var$IconWrapper, null, icon), content);
};
var $b18afde638dfaf85$export$8fbe3c7d0ed2c683 = function HelperMessage(_ref3) {
    var children = _ref3.children, testId = _ref3.testId;
    return (0, $3dJ4i.jsx)((0, $fqpc8.FieldId).Consumer, null, function(fieldId) {
        return (0, $3dJ4i.jsx)($b18afde638dfaf85$var$Message, {
            fieldId: fieldId ? "".concat(fieldId, "-helper") : undefined,
            testId: testId
        }, children);
    });
};
var $b18afde638dfaf85$export$915e9e7bd4f0f96d = function ErrorMessage(_ref4) {
    var children = _ref4.children, testId = _ref4.testId;
    return (0, $3dJ4i.jsx)((0, $fqpc8.FieldId).Consumer, null, function(fieldId) {
        return (0, $3dJ4i.jsx)($b18afde638dfaf85$var$Message, {
            appearance: "error",
            fieldId: fieldId ? "".concat(fieldId, "-error") : undefined,
            testId: testId
        }, children);
    });
};
var $b18afde638dfaf85$export$5505afb209a532c8 = function ValidMessage(_ref5) {
    var children = _ref5.children, testId = _ref5.testId;
    return (0, $3dJ4i.jsx)((0, $fqpc8.FieldId).Consumer, null, function(fieldId) {
        return (0, $3dJ4i.jsx)($b18afde638dfaf85$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? "".concat(fieldId, "-valid") : undefined,
            testId: testId
        }, children);
    });
};

});
parcelRegister("eWkao", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ae0620213e90336c$var$_react = $ae0620213e90336c$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $gdjRW = parcelRequire("gdjRW");
function $ae0620213e90336c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ae0620213e90336c$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $ae0620213e90336c$var$_react.default.createElement($gdjRW.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 20a8 8 0 110-16 8 8 0 010 16zm1.364-10.964l-2.152 4.11-1.543-1.39a1 1 0 10-1.338 1.487l2.5 2.25a1 1 0 001.555-.279l2.75-5.25a1 1 0 00-1.772-.928z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$ae0620213e90336c$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $ae0620213e90336c$var$_default = $ae0620213e90336c$var$EditorSuccessIcon;
module.exports.default = $ae0620213e90336c$var$_default;

});
parcelRegister("gdjRW", function(module, exports) {
$parcel$export(module.exports, "Icon", function () { return $bcdd45cd39ea111a$export$f04a61298a47a40f; });

var $c9bqK = parcelRequire("c9bqK");

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $7gyMa = parcelRequire("7gyMa");

var $73Trl = parcelRequire("73Trl");

var $lFtUx = parcelRequire("lFtUx");
function $bcdd45cd39ea111a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bcdd45cd39ea111a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bcdd45cd39ea111a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bcdd45cd39ea111a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $bcdd45cd39ea111a$var$iconStyles = (0, $3dJ4i.css)({
    display: 'inline-block',
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '> svg': $bcdd45cd39ea111a$var$_objectSpread($bcdd45cd39ea111a$var$_objectSpread({}, (0, $lFtUx.commonSVGStyles)), {}, {
        maxWidth: '100%',
        maxHeight: '100%',
        color: 'var(--icon-primary-color)',
        fill: 'var(--icon-secondary-color)',
        verticalAlign: 'bottom'
    })
});
/**
 * For windows high contrast mode
 */ var $bcdd45cd39ea111a$var$baseHcmStyles = (0, $3dJ4i.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        '> svg': {
            filter: 'grayscale(1)',
            '--icon-primary-color': 'CanvasText',
            // foreground
            '--icon-secondary-color': 'Canvas' // background
        }
    }
});
var $bcdd45cd39ea111a$var$primaryEqualsSecondaryHcmStyles = (0, $3dJ4i.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        '> svg': {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            '--icon-primary-color': 'Canvas' // foreground
        }
    }
});
var $bcdd45cd39ea111a$var$secondaryTransparentHcmStyles = (0, $3dJ4i.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        '> svg': {
            '--icon-secondary-color': 'transparent' // background
        }
    }
});
var $bcdd45cd39ea111a$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $3dJ4i.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $lFtUx.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    var _useGlobalTheme = (0, $7gyMa.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $3dJ4i.jsx)("span", (0, $c9bqK.default)({
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            '--icon-primary-color': primaryColor,
            '--icon-secondary-color': secondaryColor || (0, $73Trl.getBackground)(mode)
        }
    }, glyphProps, {
        css: [
            $bcdd45cd39ea111a$var$iconStyles,
            $bcdd45cd39ea111a$var$baseHcmStyles,
            primaryColor === secondaryColor && $bcdd45cd39ea111a$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === 'transparent' && $bcdd45cd39ea111a$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsualting them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            (0, $3dJ4i.css)({
                width: dimensions.width,
                height: dimensions.height,
                '> svg': dimensions
            })
        ]
    }));
});
var $bcdd45cd39ea111a$export$2e2bcd8739ae039 = $bcdd45cd39ea111a$export$f04a61298a47a40f;

});
parcelRegister("73Trl", function(module, exports) {
$parcel$export(module.exports, "getBackground", function () { return $5243d177f8796ac4$export$18cb9425622d4e06; });
var $5243d177f8796ac4$var$themedBackground = {
    light: "var(--ds-surface, #FFFFFF)",
    dark: "var(--ds-surface, #1B2638)"
};
var $5243d177f8796ac4$export$18cb9425622d4e06 = function getBackground() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'light';
    return $5243d177f8796ac4$var$themedBackground[mode];
};

});

parcelRegister("lFtUx", function(module, exports) {
$parcel$export(module.exports, "commonSVGStyles", function () { return $fc64a0fce6a011ab$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "getIconSize", function () { return $fc64a0fce6a011ab$export$3eb7d6130acfda37; });

var $dH0ii = parcelRequire("dH0ii");

var $3dJ4i = parcelRequire("3dJ4i");
var $fc64a0fce6a011ab$export$16374db1c3e6dfba = {
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: 'currentColor'
    }
};
var $fc64a0fce6a011ab$var$smallStyles = (0, $3dJ4i.css)((0, $dH0ii.dimensions).small);
var $fc64a0fce6a011ab$var$mediumStyles = (0, $3dJ4i.css)((0, $dH0ii.dimensions).medium);
var $fc64a0fce6a011ab$var$largeStyles = (0, $3dJ4i.css)((0, $dH0ii.dimensions).large);
var $fc64a0fce6a011ab$var$xlargeStyles = (0, $3dJ4i.css)((0, $dH0ii.dimensions).xlarge);
var $fc64a0fce6a011ab$export$ef0ad74202575b64 = {
    small: $fc64a0fce6a011ab$var$smallStyles,
    medium: $fc64a0fce6a011ab$var$mediumStyles,
    large: $fc64a0fce6a011ab$var$largeStyles,
    xlarge: $fc64a0fce6a011ab$var$xlargeStyles
};
var $fc64a0fce6a011ab$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $dH0ii.dimensions)[size];
    return undefined;
};

});
parcelRegister("dH0ii", function(module, exports) {
$parcel$export(module.exports, "dimensions", function () { return $9f7f84e7b3b1da86$export$62ad7b0c781000e9; });
var $9f7f84e7b3b1da86$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
var $9f7f84e7b3b1da86$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
var $9f7f84e7b3b1da86$export$62ad7b0c781000e9 = {
    small: {
        width: $9f7f84e7b3b1da86$export$c647cb0ee6e282fe.small,
        height: $9f7f84e7b3b1da86$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $9f7f84e7b3b1da86$export$c647cb0ee6e282fe.medium,
        height: $9f7f84e7b3b1da86$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $9f7f84e7b3b1da86$export$c647cb0ee6e282fe.large,
        height: $9f7f84e7b3b1da86$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $9f7f84e7b3b1da86$export$c647cb0ee6e282fe.xlarge,
        height: $9f7f84e7b3b1da86$export$c647cb0ee6e282fe.xlarge
    }
};

});




parcelRegister("6r1ZZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4af6d09a4c475e32$var$_react = $4af6d09a4c475e32$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $gdjRW = parcelRequire("gdjRW");
function $4af6d09a4c475e32$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $4af6d09a4c475e32$var$ErrorIcon = (props)=>/*#__PURE__*/ $4af6d09a4c475e32$var$_react.default.createElement($gdjRW.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path d="M13.416 4.417a2.002 2.002 0 00-2.832 0l-6.168 6.167a2.002 2.002 0 000 2.833l6.168 6.167a2.002 2.002 0 002.832 0l6.168-6.167a2.002 2.002 0 000-2.833l-6.168-6.167z" fill="currentColor"/><path d="M12 14a1 1 0 01-1-1V8a1 1 0 012 0v5a1 1 0 01-1 1m0 3a1 1 0 010-2 1 1 0 010 2" fill="inherit"/></g></svg>`
    }, props));
$4af6d09a4c475e32$var$ErrorIcon.displayName = 'ErrorIcon';
var $4af6d09a4c475e32$var$_default = $4af6d09a4c475e32$var$ErrorIcon;
module.exports.default = $4af6d09a4c475e32$var$_default;

});


parcelRegister("4BITs", function(module, exports) {
"use strict";
// We don't want bundlers to error when they encounter usage of any of these exports.
// It's up to the package author to ensure that if they access React internals,
// they do so in a safe way that won't break if React changes how they use these internals.
// (e.g. only access them in development, and only in an optional way that won't
// break if internals are not there or do not have the expected structure)
// @ts-ignore
module.exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = undefined;
// @ts-ignore
module.exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = undefined;
// @ts-ignore
module.exports.__SERVER_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = undefined;

// Here we actually pull in the React library and add everything
// it exports to our own `module.exports`.
// If React suddenly were to add one of the above "polyfilled" exports,
// the React version would overwrite our version, so this should be
// future-proof.
Object.assign(module.exports, (parcelRequire("1oC0p")));

});

parcelRegister("4iB1K", function(module, exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $321590ac1f699224$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = $321590ac1f699224$var$copyArray;

});

parcelRegister("hPHXF", function(module, exports) {
$parcel$export(module.exports, "Base64", function () { return $cfb94ce5accfa053$export$f436b0c2107cbd35; });
/**
 *  base64.ts
 *
 *  Licensed under the BSD 3-Clause License.
 *    http://opensource.org/licenses/BSD-3-Clause
 *
 *  References:
 *    http://en.wikipedia.org/wiki/Base64
 *
 * @author Dan Kogai (https://github.com/dankogai)
 */ 
var $567QU = parcelRequire("567QU");
var $cfb94ce5accfa053$require$Buffer = $567QU.Buffer;
const $cfb94ce5accfa053$export$83d89fbfd8236492 = '3.7.5';
/**
 * @deprecated use lowercase `version`.
 */ const $cfb94ce5accfa053$export$a4ad2735b021c132 = $cfb94ce5accfa053$export$83d89fbfd8236492;
const $cfb94ce5accfa053$var$_hasatob = typeof atob === 'function';
const $cfb94ce5accfa053$var$_hasbtoa = typeof btoa === 'function';
const $cfb94ce5accfa053$var$_hasBuffer = typeof $cfb94ce5accfa053$require$Buffer === 'function';
const $cfb94ce5accfa053$var$_TD = typeof TextDecoder === 'function' ? new TextDecoder() : undefined;
const $cfb94ce5accfa053$var$_TE = typeof TextEncoder === 'function' ? new TextEncoder() : undefined;
const $cfb94ce5accfa053$var$b64ch = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
const $cfb94ce5accfa053$var$b64chs = Array.prototype.slice.call($cfb94ce5accfa053$var$b64ch);
const $cfb94ce5accfa053$var$b64tab = ((a)=>{
    let tab = {};
    a.forEach((c, i)=>tab[c] = i);
    return tab;
})($cfb94ce5accfa053$var$b64chs);
const $cfb94ce5accfa053$var$b64re = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/;
const $cfb94ce5accfa053$var$_fromCC = String.fromCharCode.bind(String);
const $cfb94ce5accfa053$var$_U8Afrom = typeof Uint8Array.from === 'function' ? Uint8Array.from.bind(Uint8Array) : (it)=>new Uint8Array(Array.prototype.slice.call(it, 0));
const $cfb94ce5accfa053$var$_mkUriSafe = (src)=>src.replace(/=/g, '').replace(/[+\/]/g, (m0)=>m0 == '+' ? '-' : '_');
const $cfb94ce5accfa053$var$_tidyB64 = (s)=>s.replace(/[^A-Za-z0-9\+\/]/g, '');
/**
 * polyfill version of `btoa`
 */ const $cfb94ce5accfa053$export$ec0fb543302ee251 = (bin)=>{
    // console.log('polyfilled');
    let u32, c0, c1, c2, asc = '';
    const pad = bin.length % 3;
    for(let i = 0; i < bin.length;){
        if ((c0 = bin.charCodeAt(i++)) > 255 || (c1 = bin.charCodeAt(i++)) > 255 || (c2 = bin.charCodeAt(i++)) > 255) throw new TypeError('invalid character found');
        u32 = c0 << 16 | c1 << 8 | c2;
        asc += $cfb94ce5accfa053$var$b64chs[u32 >> 18 & 63] + $cfb94ce5accfa053$var$b64chs[u32 >> 12 & 63] + $cfb94ce5accfa053$var$b64chs[u32 >> 6 & 63] + $cfb94ce5accfa053$var$b64chs[u32 & 63];
    }
    return pad ? asc.slice(0, pad - 3) + "===".substring(pad) : asc;
};
/**
 * does what `window.btoa` of web browsers do.
 * @param {String} bin binary string
 * @returns {string} Base64-encoded string
 */ const $cfb94ce5accfa053$export$a32219e24f8d1e2 = $cfb94ce5accfa053$var$_hasbtoa ? (bin)=>btoa(bin) : $cfb94ce5accfa053$var$_hasBuffer ? (bin)=>$cfb94ce5accfa053$require$Buffer.from(bin, 'binary').toString('base64') : $cfb94ce5accfa053$export$ec0fb543302ee251;
const $cfb94ce5accfa053$var$_fromUint8Array = $cfb94ce5accfa053$var$_hasBuffer ? (u8a)=>$cfb94ce5accfa053$require$Buffer.from(u8a).toString('base64') : (u8a)=>{
    // cf. https://stackoverflow.com/questions/12710001/how-to-convert-uint8-array-to-base64-encoded-string/12713326#12713326
    const maxargs = 0x1000;
    let strs = [];
    for(let i = 0, l = u8a.length; i < l; i += maxargs)strs.push($cfb94ce5accfa053$var$_fromCC.apply(null, u8a.subarray(i, i + maxargs)));
    return $cfb94ce5accfa053$export$a32219e24f8d1e2(strs.join(''));
};
/**
 * converts a Uint8Array to a Base64 string.
 * @param {boolean} [urlsafe] URL-and-filename-safe a la RFC4648 §5
 * @returns {string} Base64 string
 */ const $cfb94ce5accfa053$export$27bbb4e040978768 = (u8a, urlsafe = false)=>urlsafe ? $cfb94ce5accfa053$var$_mkUriSafe($cfb94ce5accfa053$var$_fromUint8Array(u8a)) : $cfb94ce5accfa053$var$_fromUint8Array(u8a);
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const utob = (src: string) => unescape(encodeURIComponent(src));
// reverting good old fationed regexp
const $cfb94ce5accfa053$var$cb_utob = (c)=>{
    if (c.length < 2) {
        var cc = c.charCodeAt(0);
        return cc < 0x80 ? c : cc < 0x800 ? $cfb94ce5accfa053$var$_fromCC(0xc0 | cc >>> 6) + $cfb94ce5accfa053$var$_fromCC(0x80 | cc & 0x3f) : $cfb94ce5accfa053$var$_fromCC(0xe0 | cc >>> 12 & 0x0f) + $cfb94ce5accfa053$var$_fromCC(0x80 | cc >>> 6 & 0x3f) + $cfb94ce5accfa053$var$_fromCC(0x80 | cc & 0x3f);
    } else {
        var cc = 0x10000 + (c.charCodeAt(0) - 0xD800) * 0x400 + (c.charCodeAt(1) - 0xDC00);
        return $cfb94ce5accfa053$var$_fromCC(0xf0 | cc >>> 18 & 0x07) + $cfb94ce5accfa053$var$_fromCC(0x80 | cc >>> 12 & 0x3f) + $cfb94ce5accfa053$var$_fromCC(0x80 | cc >>> 6 & 0x3f) + $cfb94ce5accfa053$var$_fromCC(0x80 | cc & 0x3f);
    }
};
const $cfb94ce5accfa053$var$re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-8 string
 * @returns {string} UTF-16 string
 */ const $cfb94ce5accfa053$export$10d4b9bd20a66b0 = (u)=>u.replace($cfb94ce5accfa053$var$re_utob, $cfb94ce5accfa053$var$cb_utob);
//
const $cfb94ce5accfa053$var$_encode = $cfb94ce5accfa053$var$_hasBuffer ? (s)=>$cfb94ce5accfa053$require$Buffer.from(s, 'utf8').toString('base64') : $cfb94ce5accfa053$var$_TE ? (s)=>$cfb94ce5accfa053$var$_fromUint8Array($cfb94ce5accfa053$var$_TE.encode(s)) : (s)=>$cfb94ce5accfa053$export$a32219e24f8d1e2($cfb94ce5accfa053$export$10d4b9bd20a66b0(s));
/**
 * converts a UTF-8-encoded string to a Base64 string.
 * @param {boolean} [urlsafe] if `true` make the result URL-safe
 * @returns {string} Base64 string
 */ const $cfb94ce5accfa053$export$37cc283d8fbd3462 = (src, urlsafe = false)=>urlsafe ? $cfb94ce5accfa053$var$_mkUriSafe($cfb94ce5accfa053$var$_encode(src)) : $cfb94ce5accfa053$var$_encode(src);
/**
 * converts a UTF-8-encoded string to URL-safe Base64 RFC4648 §5.
 * @returns {string} Base64 string
 */ const $cfb94ce5accfa053$export$90c31d5baa78df44 = (src)=>$cfb94ce5accfa053$export$37cc283d8fbd3462(src, true);
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const btou = (src: string) => decodeURIComponent(escape(src));
// reverting good old fationed regexp
const $cfb94ce5accfa053$var$re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;
const $cfb94ce5accfa053$var$cb_btou = (cccc)=>{
    switch(cccc.length){
        case 4:
            var cp = (0x07 & cccc.charCodeAt(0)) << 18 | (0x3f & cccc.charCodeAt(1)) << 12 | (0x3f & cccc.charCodeAt(2)) << 6 | 0x3f & cccc.charCodeAt(3), offset = cp - 0x10000;
            return $cfb94ce5accfa053$var$_fromCC((offset >>> 10) + 0xD800) + $cfb94ce5accfa053$var$_fromCC((offset & 0x3FF) + 0xDC00);
        case 3:
            return $cfb94ce5accfa053$var$_fromCC((0x0f & cccc.charCodeAt(0)) << 12 | (0x3f & cccc.charCodeAt(1)) << 6 | 0x3f & cccc.charCodeAt(2));
        default:
            return $cfb94ce5accfa053$var$_fromCC((0x1f & cccc.charCodeAt(0)) << 6 | 0x3f & cccc.charCodeAt(1));
    }
};
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-16 string
 * @returns {string} UTF-8 string
 */ const $cfb94ce5accfa053$export$67e9defdeac3dd95 = (b)=>b.replace($cfb94ce5accfa053$var$re_btou, $cfb94ce5accfa053$var$cb_btou);
/**
 * polyfill version of `atob`
 */ const $cfb94ce5accfa053$export$7f16d8e674ddec24 = (asc)=>{
    // console.log('polyfilled');
    asc = asc.replace(/\s+/g, '');
    if (!$cfb94ce5accfa053$var$b64re.test(asc)) throw new TypeError('malformed base64.');
    asc += '=='.slice(2 - (asc.length & 3));
    let u24, bin = '', r1, r2;
    for(let i = 0; i < asc.length;){
        u24 = $cfb94ce5accfa053$var$b64tab[asc.charAt(i++)] << 18 | $cfb94ce5accfa053$var$b64tab[asc.charAt(i++)] << 12 | (r1 = $cfb94ce5accfa053$var$b64tab[asc.charAt(i++)]) << 6 | (r2 = $cfb94ce5accfa053$var$b64tab[asc.charAt(i++)]);
        bin += r1 === 64 ? $cfb94ce5accfa053$var$_fromCC(u24 >> 16 & 255) : r2 === 64 ? $cfb94ce5accfa053$var$_fromCC(u24 >> 16 & 255, u24 >> 8 & 255) : $cfb94ce5accfa053$var$_fromCC(u24 >> 16 & 255, u24 >> 8 & 255, u24 & 255);
    }
    return bin;
};
/**
 * does what `window.atob` of web browsers do.
 * @param {String} asc Base64-encoded string
 * @returns {string} binary string
 */ const $cfb94ce5accfa053$export$1406ac7a6dfd7b7a = $cfb94ce5accfa053$var$_hasatob ? (asc)=>atob($cfb94ce5accfa053$var$_tidyB64(asc)) : $cfb94ce5accfa053$var$_hasBuffer ? (asc)=>$cfb94ce5accfa053$require$Buffer.from(asc, 'base64').toString('binary') : $cfb94ce5accfa053$export$7f16d8e674ddec24;
//
const $cfb94ce5accfa053$var$_toUint8Array = $cfb94ce5accfa053$var$_hasBuffer ? (a)=>$cfb94ce5accfa053$var$_U8Afrom($cfb94ce5accfa053$require$Buffer.from(a, 'base64')) : (a)=>$cfb94ce5accfa053$var$_U8Afrom($cfb94ce5accfa053$export$1406ac7a6dfd7b7a(a).split('').map((c)=>c.charCodeAt(0)));
/**
 * converts a Base64 string to a Uint8Array.
 */ const $cfb94ce5accfa053$export$73470fd2221e6aef = (a)=>$cfb94ce5accfa053$var$_toUint8Array($cfb94ce5accfa053$var$_unURI(a));
//
const $cfb94ce5accfa053$var$_decode = $cfb94ce5accfa053$var$_hasBuffer ? (a)=>$cfb94ce5accfa053$require$Buffer.from(a, 'base64').toString('utf8') : $cfb94ce5accfa053$var$_TD ? (a)=>$cfb94ce5accfa053$var$_TD.decode($cfb94ce5accfa053$var$_toUint8Array(a)) : (a)=>$cfb94ce5accfa053$export$67e9defdeac3dd95($cfb94ce5accfa053$export$1406ac7a6dfd7b7a(a));
const $cfb94ce5accfa053$var$_unURI = (a)=>$cfb94ce5accfa053$var$_tidyB64(a.replace(/[-_]/g, (m0)=>m0 == '-' ? '+' : '/'));
/**
 * converts a Base64 string to a UTF-8 string.
 * @param {String} src Base64 string.  Both normal and URL-safe are supported
 * @returns {string} UTF-8 string
 */ const $cfb94ce5accfa053$export$c537b38001c583b7 = (src)=>$cfb94ce5accfa053$var$_decode($cfb94ce5accfa053$var$_unURI(src));
/**
 * check if a value is a valid Base64 string
 * @param {String} src a value to check
  */ const $cfb94ce5accfa053$export$1ea939691cdc45b8 = (src)=>{
    if (typeof src !== 'string') return false;
    const s = src.replace(/\s+/g, '').replace(/={0,2}$/, '');
    return !/[^\s0-9a-zA-Z\+/]/.test(s) || !/[^\s0-9a-zA-Z\-_]/.test(s);
};
//
const $cfb94ce5accfa053$var$_noEnum = (v)=>{
    return {
        value: v,
        enumerable: false,
        writable: true,
        configurable: true
    };
};
/**
 * extend String.prototype with relevant methods
 */ const $cfb94ce5accfa053$export$4678ebf2295c49b = function() {
    const _add = (name, body)=>Object.defineProperty(String.prototype, name, $cfb94ce5accfa053$var$_noEnum(body));
    _add('fromBase64', function() {
        return $cfb94ce5accfa053$export$c537b38001c583b7(this);
    });
    _add('toBase64', function(urlsafe) {
        return $cfb94ce5accfa053$export$37cc283d8fbd3462(this, urlsafe);
    });
    _add('toBase64URI', function() {
        return $cfb94ce5accfa053$export$37cc283d8fbd3462(this, true);
    });
    _add('toBase64URL', function() {
        return $cfb94ce5accfa053$export$37cc283d8fbd3462(this, true);
    });
    _add('toUint8Array', function() {
        return $cfb94ce5accfa053$export$73470fd2221e6aef(this);
    });
};
/**
 * extend Uint8Array.prototype with relevant methods
 */ const $cfb94ce5accfa053$export$a105d6a15258bd2 = function() {
    const _add = (name, body)=>Object.defineProperty(Uint8Array.prototype, name, $cfb94ce5accfa053$var$_noEnum(body));
    _add('toBase64', function(urlsafe) {
        return $cfb94ce5accfa053$export$27bbb4e040978768(this, urlsafe);
    });
    _add('toBase64URI', function() {
        return $cfb94ce5accfa053$export$27bbb4e040978768(this, true);
    });
    _add('toBase64URL', function() {
        return $cfb94ce5accfa053$export$27bbb4e040978768(this, true);
    });
};
/**
 * extend Builtin prototypes with relevant methods
 */ const $cfb94ce5accfa053$export$1abf1fe5ebfd5245 = ()=>{
    $cfb94ce5accfa053$export$4678ebf2295c49b();
    $cfb94ce5accfa053$export$a105d6a15258bd2();
};
const $cfb94ce5accfa053$export$f436b0c2107cbd35 = {
    version: $cfb94ce5accfa053$export$83d89fbfd8236492,
    VERSION: $cfb94ce5accfa053$export$a4ad2735b021c132,
    atob: $cfb94ce5accfa053$export$1406ac7a6dfd7b7a,
    atobPolyfill: $cfb94ce5accfa053$export$7f16d8e674ddec24,
    btoa: $cfb94ce5accfa053$export$a32219e24f8d1e2,
    btoaPolyfill: $cfb94ce5accfa053$export$ec0fb543302ee251,
    fromBase64: $cfb94ce5accfa053$export$c537b38001c583b7,
    toBase64: $cfb94ce5accfa053$export$37cc283d8fbd3462,
    encode: $cfb94ce5accfa053$export$37cc283d8fbd3462,
    encodeURI: $cfb94ce5accfa053$export$90c31d5baa78df44,
    encodeURL: $cfb94ce5accfa053$export$90c31d5baa78df44,
    utob: $cfb94ce5accfa053$export$10d4b9bd20a66b0,
    btou: $cfb94ce5accfa053$export$67e9defdeac3dd95,
    decode: $cfb94ce5accfa053$export$c537b38001c583b7,
    isValid: $cfb94ce5accfa053$export$1ea939691cdc45b8,
    fromUint8Array: $cfb94ce5accfa053$export$27bbb4e040978768,
    toUint8Array: $cfb94ce5accfa053$export$73470fd2221e6aef,
    extendString: $cfb94ce5accfa053$export$4678ebf2295c49b,
    extendUint8Array: $cfb94ce5accfa053$export$a105d6a15258bd2,
    extendBuiltins: $cfb94ce5accfa053$export$1abf1fe5ebfd5245
};

});

parcelRegister("61pdb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5437a6fa40a6a5e2291c258b3bd34ef>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $46266490593ddb94$var$_react = $46266490593ddb94$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $46266490593ddb94$var$_baseNew = $46266490593ddb94$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $46266490593ddb94$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $46266490593ddb94$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $46266490593ddb94$var$_react.default.createElement($46266490593ddb94$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.959 3.97-7.25 9a.75.75 0 0 1-1.163.007l-3.5-4.25 1.158-.954 2.914 3.539 6.673-8.283z"/>`
    }, props));
$46266490593ddb94$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $46266490593ddb94$var$_default = module.exports.default = $46266490593ddb94$var$CheckMarkIcon;

});

parcelRegister("4WS03", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $39a67771810b537d$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $lUruo = parcelRequire("lUruo");

var $ilIaa = parcelRequire("ilIaa");

var $awhiQ = parcelRequire("awhiQ");

var $lCzCA = parcelRequire("lCzCA");

var $jBgJs = parcelRequire("jBgJs");

var $7kLyP = parcelRequire("7kLyP");
var $39a67771810b537d$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $39a67771810b537d$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $39a67771810b537d$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Button(_ref, ref) {
    var _tooltip$content;
    var preventedAriaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, _onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, $gnQ3X.default)(_ref, $39a67771810b537d$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $gnQ3X.default)(unsafeRest, $39a67771810b537d$var$_excluded2);
    if (isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $lCzCA.default), (0, $c9bqK.default)({}, saferRest, {
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: _onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $jBgJs.default), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $7kLyP.default), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $awhiQ.default), null, label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $ilIaa.default), {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents
    }, function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $lCzCA.default), (0, $c9bqK.default)({}, saferRest, {
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === 'circle',
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: function onClick(e, analyticsEvent) {
                var _triggerProps$onClick;
                _onClick === null || _onClick === void 0 || _onClick(e, analyticsEvent);
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _saferRest$onMouseOve;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _saferRest$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _saferRest$onMouseMov;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _saferRest$onMouseDow;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _saferRest$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _saferRest$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
            },
            ref: (0, $lUruo.default)([
                ref,
                triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $jBgJs.default), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $7kLyP.default), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $awhiQ.default), null, label)));
    });
}));
$39a67771810b537d$var$IconButton.displayName = 'IconButton';
var $39a67771810b537d$export$2e2bcd8739ae039 = $39a67771810b537d$var$IconButton;

});
parcelRegister("lUruo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ff3426b3dfcfd680$export$2e2bcd8739ae039; });
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $ff3426b3dfcfd680$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("ilIaa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d5bc720234330d49$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $2qaZZ = parcelRequire("2qaZZ");

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $jygsg = parcelRequire("jygsg");

var $hTZvl = parcelRequire("hTZvl");

var $g4fZg = parcelRequire("g4fZg");

var $kKWOf = parcelRequire("kKWOf");

var $6P6Jp = parcelRequire("6P6Jp");

var $01fYV = parcelRequire("01fYV");
var $b6Sy7 = parcelRequire("b6Sy7");

var $h7fyy = parcelRequire("h7fyy");

var $jer1f = parcelRequire("jer1f");

var $52Fo7 = parcelRequire("52Fo7");

var $cYAGC = parcelRequire("cYAGC");

var $ujAQt = parcelRequire("ujAQt");

var $1dSuR = parcelRequire("1dSuR");

var $cykVe = parcelRequire("cykVe");

var $k7SeZ = parcelRequire("k7SeZ");

var $evbin = parcelRequire("evbin");
function $d5bc720234330d49$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d5bc720234330d49$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d5bc720234330d49$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d5bc720234330d49$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d5bc720234330d49$var$tooltipZIndex = (0, $cYAGC.layers).tooltip();
var $d5bc720234330d49$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "20.14.1"
};
// Inverts motion direction
var $d5bc720234330d49$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $d5bc720234330d49$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $d5bc720234330d49$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? 'bottom' : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? 'bottom' : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $k7SeZ.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? 'div' : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $hTZvl.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $hTZvl.default) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn, shortcut = _ref.shortcut, _ref$UNSAFE_shouldAlw = _ref.UNSAFE_shouldAlwaysFadeIn, shouldAlwaysFadeIn = _ref$UNSAFE_shouldAlw === void 0 ? false : _ref$UNSAFE_shouldAlw, _ref$UNSAFE_shouldRen = _ref.UNSAFE_shouldRenderToParent, UNSAFE_shouldRenderToParent = _ref$UNSAFE_shouldRen === void 0 ? false : _ref$UNSAFE_shouldRen;
    // Not using a gate for this check. When the gate is disabled `mouse-y` and `mouse-x` are treated as `mouse`.
    var isMousePosition = position === 'mouse' || position === 'mouse-y' || position === 'mouse-x';
    var tooltipPosition = isMousePosition ? mousePosition : position;
    var onShowHandler = (0, $jygsg.usePlatformLeafSyntheticEventHandler)($d5bc720234330d49$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $d5bc720234330d49$var$analyticsAttributes));
    var onHideHandler = (0, $jygsg.usePlatformLeafSyntheticEventHandler)($d5bc720234330d49$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $d5bc720234330d49$var$analyticsAttributes));
    var apiRef = (0, $1oC0p.useRef)(null);
    var _useState = (0, $1oC0p.useState)('hide'), _useState2 = (0, $2qaZZ.default)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $1oC0p.useRef)(null);
    var containerRef = (0, $1oC0p.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $1oC0p.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $kKWOf.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $kKWOf.default)(onShowHandler);
    var onHideHandlerStable = (0, $kKWOf.default)(onHideHandler);
    var delayStable = (0, $kKWOf.default)(delay);
    var canAppearStable = (0, $kKWOf.default)(canAppear);
    var hasCalledShowHandler = (0, $1oC0p.useRef)(false);
    var shouldAlwaysFadeInStable = (0, $kKWOf.default)(shouldAlwaysFadeIn);
    var start = (0, $1oC0p.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $1oC0p.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $1oC0p.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $1oC0p.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $1oC0p.useRef)(false);
    (0, $1oC0p.useEffect)(function() {
        return (0, $ujAQt.register)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $1oC0p.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(!isImmediate ? 'fade-in' : 'show-immediate');
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done,
            shouldAlwaysFadeIn: (0, $h7fyy.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? shouldAlwaysFadeInStable.current : false
        };
        var api = (0, $1dSuR.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable,
        shouldAlwaysFadeInStable
    ]);
    var hideTooltipOnEsc = (0, $1oC0p.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $g4fZg.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $1oC0p.useEffect)(function() {
        if (state === 'hide') return 0, $hTZvl.default;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $dH1HR.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $1oC0p.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $1oC0p.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $1oC0p.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = isMousePosition ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            // Removing old `mouse` behind gate because it stored a function.
            // With the gate we just store the coords which are easier to work with.
            mouse: (0, $h7fyy.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? undefined : (0, $evbin.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            }),
            clientX: event.clientX,
            clientY: event.clientY
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        isMousePosition,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $1oC0p.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = isMousePosition ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) {
            if (!(0, $h7fyy.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback')) apiRef.current.mousePosition = (0, $evbin.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            });
            apiRef.current.mousePos = {
                clientX: event.clientX,
                clientY: event.clientY
            };
        }
    } : undefined;
    var onMouseOverTooltip = (0, $1oC0p.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $1oC0p.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch (_unused) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $1oC0p.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $1oC0p.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    var handleOpenLayerObserverCloseSignal = (0, $1oC0p.useCallback)(function() {
        var _apiRef$current4;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $6P6Jp.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current5, _apiRef$current6;
        if (isMousePosition && (_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.mousePos && targetRef.current && (0, $h7fyy.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback')) return (0, $evbin.getVirtualElementFromMousePos)(apiRef.current.mousePos, {
            targetElement: targetRef.current,
            tooltipPosition: position
        });
        if (isMousePosition && (_apiRef$current6 = apiRef.current) !== null && _apiRef$current6 !== void 0 && _apiRef$current6.mousePosition && !(0, $h7fyy.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback')) {
            var _apiRef$current7;
            return (_apiRef$current7 = apiRef.current) === null || _apiRef$current7 === void 0 ? void 0 : _apiRef$current7.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $cykVe.default)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // Adding `data-testid` to the TriggerProps interface breaks Buttons, so we use type assertion
    tooltipTriggerProps['data-testid'] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $1oC0p.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    var PopperWrapper = UNSAFE_shouldRenderToParent && (0, $h7fyy.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? (0, $1oC0p.Fragment) : $d5bc720234330d49$var$TooltipPortal;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children($d5bc720234330d49$var$_objectSpread($d5bc720234330d49$var$_objectSpread({}, tooltipTriggerProps), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(CastTargetContainer, (0, $c9bqK.default)({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(PopperWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $jer1f.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = isMousePosition ? undefined : $d5bc720234330d49$var$invertedDirection[$d5bc720234330d49$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $01fYV.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $b6Sy7.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $d5bc720234330d49$var$_objectSpread($d5bc720234330d49$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                shortcut: shortcut
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $d5bc720234330d49$export$2e2bcd8739ae039 = $d5bc720234330d49$var$Tooltip;
var $d5bc720234330d49$var$TooltipPortal = function TooltipPortal(_ref7) {
    var children = _ref7.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $52Fo7.default), {
        zIndex: $d5bc720234330d49$var$tooltipZIndex
    }, children);
};

});
parcelRegister("jygsg", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", function () { return $e3bdf4ea26355fa9$export$1a04351537078b55; });

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $1ujk4 = parcelRequire("1ujk4");

var $kI191 = parcelRequire("kI191");
function $e3bdf4ea26355fa9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e3bdf4ea26355fa9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e3bdf4ea26355fa9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e3bdf4ea26355fa9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e3bdf4ea26355fa9$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $1ujk4.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $kI191.useTrackedRef)(analyticsData);
    var fnRef = (0, $kI191.useTrackedRef)(fn);
    var handler = (0, $1oC0p.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $e3bdf4ea26355fa9$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("1ujk4", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", function () { return $115794e2dcc47dce$export$5bf35293e545f20c; });

var $hcVab = parcelRequire("hcVab");

var $kc46U = parcelRequire("kc46U");

var $fB9Kd = parcelRequire("fB9Kd");
function $115794e2dcc47dce$export$5bf35293e545f20c() {
    var analyticsContext = (0, $fB9Kd.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $hcVab.useCallbackOne)(function(payload) {
        return new (0, $kc46U.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("kc46U", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $eb381de54fd90d57$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $7SQOE = parcelRequire("7SQOE");

var $i7dvh = parcelRequire("i7dvh");

var $f53LC = parcelRequire("f53LC");

var $lh1b5 = parcelRequire("lh1b5");
function $eb381de54fd90d57$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $eb381de54fd90d57$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $eb381de54fd90d57$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($eb381de54fd90d57$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $eb381de54fd90d57$var$_superPropGet(t, o, e, r) {
    var p = (0, $7SQOE.default)((0, $jlBwm.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $eb381de54fd90d57$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $eb381de54fd90d57$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $eb381de54fd90d57$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $cTewU.default)(this, UIAnalyticsEvent);
        _this = $eb381de54fd90d57$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $f53LC.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $f53LC.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $lFOXD.default)(_this.context);
            var handlers = (0, $lFOXD.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $f53LC.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $i7dvh.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $avOEA.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $eb381de54fd90d57$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $lh1b5.default));

});
parcelRegister("lh1b5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f7cc196b28c4a7d6$export$2e2bcd8739ae039; });

var $2zYm4 = parcelRequire("2zYm4");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");
function $f7cc196b28c4a7d6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f7cc196b28c4a7d6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f7cc196b28c4a7d6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f7cc196b28c4a7d6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f7cc196b28c4a7d6$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $f7cc196b28c4a7d6$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $f7cc196b28c4a7d6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $cTewU.default)(this, AnalyticsEvent);
        (0, $f53LC.default)(this, "_isAnalyticsEvent", true);
        (0, $f53LC.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $f7cc196b28c4a7d6$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $avOEA.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $2zYm4.default)(updater) === 'object') this.payload = $f7cc196b28c4a7d6$var$_objectSpread($f7cc196b28c4a7d6$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("fB9Kd", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", function () { return $b5b1debca72da071$export$d1f587f82ad51c4; });

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");
var $b5b1debca72da071$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $1oC0p.useContext)((0, $bEiDG.default));
};

});


parcelRegister("kI191", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", function () { return $f138ce02cfca0dfe$export$1d27a74659855e44; });

var $1oC0p = parcelRequire("1oC0p");
var $f138ce02cfca0dfe$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $1oC0p.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("hTZvl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d087483af02eadf2$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $d087483af02eadf2$export$2e2bcd8739ae039() {}

});

parcelRegister("g4fZg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bb296bc1bfc854e0$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $h0QW4 = parcelRequire("h0QW4");
function $bb296bc1bfc854e0$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $1oC0p.useRef)(false);
    var onKeyDown = (0, $1oC0p.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $h0QW4.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $1oC0p.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $1oC0p.useEffect)(function() {
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled) return;
        return (0, $dH1HR.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

});
parcelRegister("h0QW4", function(module, exports) {
$parcel$export(module.exports, "ESCAPE", function () { return $c62b7fa8385201b6$export$2bb790b9008907b4; });
/**
 * Character key codes which can be used in keyboard events.
 */ var $c62b7fa8385201b6$export$390330c10ff2b9a1 = 'ArrowUp';
var $c62b7fa8385201b6$export$a80636c6f41931fe = 'ArrowDown';
var $c62b7fa8385201b6$export$4af703091671bc = 'Home';
var $c62b7fa8385201b6$export$e2bc30913faa5db7 = 'End';
var $c62b7fa8385201b6$export$10f6869ed0a7d75b = 'Tab';
var $c62b7fa8385201b6$export$8152f929a25a0ff4 = 'Enter';
var $c62b7fa8385201b6$export$e51a3576c045c8d5 = 'Space';
var $c62b7fa8385201b6$export$2bb790b9008907b4 = 'Escape';

});


parcelRegister("kKWOf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f1c5b8d617e95356$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
function $f1c5b8d617e95356$export$2e2bcd8739ae039(value) {
    var ref = (0, $1oC0p.useRef)(value);
    (0, $1oC0p.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("h7fyy", function(module, exports) {
$parcel$export(module.exports, "fg", function () { return $c75f284071519a20$export$b40ec24ac8275656; });

var $6Vi4W = parcelRequire("6Vi4W");
function $c75f284071519a20$export$ba05d765b8392e5e(flagResolver) {
    (0, $6Vi4W.setBooleanResolver)(flagResolver);
}
function $c75f284071519a20$export$470e5c2be1411c89(name) {
    return (0, $6Vi4W.resolveBooleanFlag)(name);
}
function $c75f284071519a20$export$b40ec24ac8275656(name) {
    return (0, $6Vi4W.resolveBooleanFlag)(name);
}

});
parcelRegister("6Vi4W", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", function () { return $50a617010ad7a07f$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $50a617010ad7a07f$export$6333b6aff9fc6275; });

var $k0D6j = parcelRequire("k0D6j");

var $dv86y = parcelRequire("dv86y");

var $7t0tI = parcelRequire("7t0tI");
var $50a617010ad7a07f$var$pkgName = '@atlaskit/platform-feature-flags';
var $50a617010ad7a07f$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $50a617010ad7a07f$var$hasProcessEnv = typeof $7t0tI !== 'undefined' && typeof $7t0tI.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $50a617010ad7a07f$var$ENV_ENABLE_PLATFORM_FF = $50a617010ad7a07f$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $50a617010ad7a07f$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $50a617010ad7a07f$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $50a617010ad7a07f$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $50a617010ad7a07f$var$ENV_ENABLE_PLATFORM_FF || $50a617010ad7a07f$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $50a617010ad7a07f$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $50a617010ad7a07f$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$50a617010ad7a07f$var$globalVar[$50a617010ad7a07f$export$7e41b1b2bdee3f98] = $50a617010ad7a07f$var$globalVar[$50a617010ad7a07f$export$7e41b1b2bdee3f98] || $50a617010ad7a07f$var$DEFAULT_PFF_GLOBAL;
function $50a617010ad7a07f$export$f2b591175b3e424c(resolver) {
    $50a617010ad7a07f$var$globalVar[$50a617010ad7a07f$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $50a617010ad7a07f$export$6333b6aff9fc6275(flagKey) {
    if ($50a617010ad7a07f$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $dv86y.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $50a617010ad7a07f$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $50a617010ad7a07f$var$globalVar[$50a617010ad7a07f$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $50a617010ad7a07f$var$globalVar[$50a617010ad7a07f$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $k0D6j.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $50a617010ad7a07f$var$globalVar[$50a617010ad7a07f$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("k0D6j", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e912235a8f92f8a9$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $1GrdC = parcelRequire("1GrdC");

var $6hzLi = parcelRequire("6hzLi");



var $e912235a8f92f8a9$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $e912235a8f92f8a9$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, $cTewU.default)(this, FeatureGates);
    }
    return (0, $avOEA.default)(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$e912235a8f92f8a9$var$_FeatureGates = $e912235a8f92f8a9$var$FeatureGates;
(0, $f53LC.default)($e912235a8f92f8a9$var$FeatureGates, "client", new (0, $1GrdC.Client)());
(0, $f53LC.default)($e912235a8f92f8a9$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, $f53LC.default)($e912235a8f92f8a9$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, $f53LC.default)($e912235a8f92f8a9$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$e912235a8f92f8a9$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $e912235a8f92f8a9$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $e912235a8f92f8a9$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, $f53LC.default)($e912235a8f92f8a9$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$e912235a8f92f8a9$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $e912235a8f92f8a9$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $e912235a8f92f8a9$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, $f53LC.default)($e912235a8f92f8a9$var$FeatureGates, "initializeCalled", $e912235a8f92f8a9$var$_FeatureGates.client.initializeCalled.bind($e912235a8f92f8a9$var$_FeatureGates.client));
(0, $f53LC.default)($e912235a8f92f8a9$var$FeatureGates, "initializeCompleted", $e912235a8f92f8a9$var$_FeatureGates.client.initializeCompleted.bind($e912235a8f92f8a9$var$_FeatureGates.client));
(0, $f53LC.default)($e912235a8f92f8a9$var$FeatureGates, "waitUntilInitializeCompleted", $e912235a8f92f8a9$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($e912235a8f92f8a9$var$_FeatureGates.client));
(0, $f53LC.default)($e912235a8f92f8a9$var$FeatureGates, "initialize", $e912235a8f92f8a9$var$_FeatureGates.client.initialize.bind($e912235a8f92f8a9$var$_FeatureGates.client));
(0, $f53LC.default)($e912235a8f92f8a9$var$FeatureGates, "initializeWithProvider", $e912235a8f92f8a9$var$_FeatureGates.client.initializeWithProvider.bind($e912235a8f92f8a9$var$_FeatureGates.client));
(0, $f53LC.default)($e912235a8f92f8a9$var$FeatureGates, "initializeFromValues", $e912235a8f92f8a9$var$_FeatureGates.client.initializeFromValues.bind($e912235a8f92f8a9$var$_FeatureGates.client));
(0, $f53LC.default)($e912235a8f92f8a9$var$FeatureGates, "manuallyLogGateExposure", $e912235a8f92f8a9$var$_FeatureGates.client.manuallyLogGateExposure.bind($e912235a8f92f8a9$var$_FeatureGates.client));
(0, $f53LC.default)($e912235a8f92f8a9$var$FeatureGates, "getExperiment", $e912235a8f92f8a9$var$_FeatureGates.client.getExperiment.bind($e912235a8f92f8a9$var$_FeatureGates.client));
(0, $f53LC.default)($e912235a8f92f8a9$var$FeatureGates, "manuallyLogExperimentExposure", $e912235a8f92f8a9$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($e912235a8f92f8a9$var$_FeatureGates.client));
(0, $f53LC.default)($e912235a8f92f8a9$var$FeatureGates, "manuallyLogLayerExposure", $e912235a8f92f8a9$var$_FeatureGates.client.manuallyLogLayerExposure.bind($e912235a8f92f8a9$var$_FeatureGates.client));
(0, $f53LC.default)($e912235a8f92f8a9$var$FeatureGates, "shutdownStatsig", $e912235a8f92f8a9$var$_FeatureGates.client.shutdownStatsig.bind($e912235a8f92f8a9$var$_FeatureGates.client));
(0, $f53LC.default)($e912235a8f92f8a9$var$FeatureGates, "overrideGate", $e912235a8f92f8a9$var$_FeatureGates.client.overrideGate.bind($e912235a8f92f8a9$var$_FeatureGates.client));
(0, $f53LC.default)($e912235a8f92f8a9$var$FeatureGates, "clearGateOverride", $e912235a8f92f8a9$var$_FeatureGates.client.clearGateOverride.bind($e912235a8f92f8a9$var$_FeatureGates.client));
(0, $f53LC.default)($e912235a8f92f8a9$var$FeatureGates, "overrideConfig", $e912235a8f92f8a9$var$_FeatureGates.client.overrideConfig.bind($e912235a8f92f8a9$var$_FeatureGates.client));
(0, $f53LC.default)($e912235a8f92f8a9$var$FeatureGates, "clearConfigOverride", $e912235a8f92f8a9$var$_FeatureGates.client.clearConfigOverride.bind($e912235a8f92f8a9$var$_FeatureGates.client));
(0, $f53LC.default)($e912235a8f92f8a9$var$FeatureGates, "setOverrides", $e912235a8f92f8a9$var$_FeatureGates.client.setOverrides.bind($e912235a8f92f8a9$var$_FeatureGates.client));
(0, $f53LC.default)($e912235a8f92f8a9$var$FeatureGates, "getOverrides", $e912235a8f92f8a9$var$_FeatureGates.client.getOverrides.bind($e912235a8f92f8a9$var$_FeatureGates.client));
(0, $f53LC.default)($e912235a8f92f8a9$var$FeatureGates, "clearAllOverrides", $e912235a8f92f8a9$var$_FeatureGates.client.clearAllOverrides.bind($e912235a8f92f8a9$var$_FeatureGates.client));
(0, $f53LC.default)($e912235a8f92f8a9$var$FeatureGates, "isCurrentUser", $e912235a8f92f8a9$var$_FeatureGates.client.isCurrentUser.bind($e912235a8f92f8a9$var$_FeatureGates.client));
(0, $f53LC.default)($e912235a8f92f8a9$var$FeatureGates, "onGateUpdated", $e912235a8f92f8a9$var$_FeatureGates.client.onGateUpdated.bind($e912235a8f92f8a9$var$_FeatureGates.client));
(0, $f53LC.default)($e912235a8f92f8a9$var$FeatureGates, "onExperimentValueUpdated", $e912235a8f92f8a9$var$_FeatureGates.client.onExperimentValueUpdated.bind($e912235a8f92f8a9$var$_FeatureGates.client));
(0, $f53LC.default)($e912235a8f92f8a9$var$FeatureGates, "onAnyUpdated", $e912235a8f92f8a9$var$_FeatureGates.client.onAnyUpdated.bind($e912235a8f92f8a9$var$_FeatureGates.client));
(0, $f53LC.default)($e912235a8f92f8a9$var$FeatureGates, "updateUser", $e912235a8f92f8a9$var$_FeatureGates.client.updateUser.bind($e912235a8f92f8a9$var$_FeatureGates.client));
(0, $f53LC.default)($e912235a8f92f8a9$var$FeatureGates, "updateUserWithProvider", $e912235a8f92f8a9$var$_FeatureGates.client.updateUserWithProvider.bind($e912235a8f92f8a9$var$_FeatureGates.client));
(0, $f53LC.default)($e912235a8f92f8a9$var$FeatureGates, "updateUserWithValues", $e912235a8f92f8a9$var$_FeatureGates.client.updateUserWithValues.bind($e912235a8f92f8a9$var$_FeatureGates.client));
(0, $f53LC.default)($e912235a8f92f8a9$var$FeatureGates, "getPackageVersion", $e912235a8f92f8a9$var$_FeatureGates.client.getPackageVersion.bind($e912235a8f92f8a9$var$_FeatureGates.client));
(0, $f53LC.default)($e912235a8f92f8a9$var$FeatureGates, "getLayer", $e912235a8f92f8a9$var$_FeatureGates.client.getLayer.bind($e912235a8f92f8a9$var$_FeatureGates.client));
(0, $f53LC.default)($e912235a8f92f8a9$var$FeatureGates, "getLayerValue", $e912235a8f92f8a9$var$_FeatureGates.client.getLayerValue.bind($e912235a8f92f8a9$var$_FeatureGates.client));
var $e912235a8f92f8a9$var$boundFGJS = $e912235a8f92f8a9$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $e912235a8f92f8a9$var$FeatureGates;
    else {
        var $e912235a8f92f8a9$var$_boundFGJS, $e912235a8f92f8a9$var$_boundFGJS$getPackage;
        $e912235a8f92f8a9$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $e912235a8f92f8a9$var$boundVersion = (($e912235a8f92f8a9$var$_boundFGJS = $e912235a8f92f8a9$var$boundFGJS) === null || $e912235a8f92f8a9$var$_boundFGJS === void 0 || ($e912235a8f92f8a9$var$_boundFGJS$getPackage = $e912235a8f92f8a9$var$_boundFGJS.getPackageVersion) === null || $e912235a8f92f8a9$var$_boundFGJS$getPackage === void 0 ? void 0 : $e912235a8f92f8a9$var$_boundFGJS$getPackage.call($e912235a8f92f8a9$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($e912235a8f92f8a9$var$boundVersion !== (0, $6hzLi.CLIENT_VERSION)) {
            var $e912235a8f92f8a9$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($e912235a8f92f8a9$var$boundVersion, " when module version ").concat((0, $6hzLi.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($e912235a8f92f8a9$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $e912235a8f92f8a9$export$2e2bcd8739ae039 = $e912235a8f92f8a9$var$boundFGJS;

});
parcelRegister("1GrdC", function(module, exports) {
$parcel$export(module.exports, "Client", function () { return $139ed3bcc800a4b3$export$1f2bb630327ac4b6; });

var $gnQ3X = parcelRequire("gnQ3X");

var $2qaZZ = parcelRequire("2qaZZ");

var $cn8ql = parcelRequire("cn8ql");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $5Cxn4 = parcelRequire("5Cxn4");

var $ec1qE = parcelRequire("ec1qE");

var $4J6nZ = parcelRequire("4J6nZ");

var $gK2qk = parcelRequire("gK2qk");

var $aGYXU = parcelRequire("aGYXU");

var $iP8X2 = parcelRequire("iP8X2");

var $6OrUO = parcelRequire("6OrUO");

var $bkUCD = parcelRequire("bkUCD");

var $QzI7i = parcelRequire("QzI7i");

var $8yl7f = parcelRequire("8yl7f");

var $fgQZ7 = parcelRequire("fgQZ7");

var $6hzLi = parcelRequire("6hzLi");
var $139ed3bcc800a4b3$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $139ed3bcc800a4b3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $139ed3bcc800a4b3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $139ed3bcc800a4b3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $139ed3bcc800a4b3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $139ed3bcc800a4b3$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $139ed3bcc800a4b3$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $139ed3bcc800a4b3$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $QzI7i.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, $cTewU.default)(this, Client);
        (0, $f53LC.default)(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, $f53LC.default)(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, $f53LC.default)(this, "initWithDefaults", false);
        (0, $f53LC.default)(this, "hasCheckGateErrorOccurred", false);
        (0, $f53LC.default)(this, "hasGetExperimentErrorOccurred", false);
        (0, $f53LC.default)(this, "hasGetExperimentValueErrorOccurred", false);
        (0, $f53LC.default)(this, "hasGetLayerErrorOccurred", false);
        (0, $f53LC.default)(this, "hasGetLayerValueErrorOccurred", false);
        (0, $f53LC.default)(this, "subscriptions", new (0, $4J6nZ.default)());
        (0, $f53LC.default)(this, "dataAdapter", new (0, $bkUCD.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, $f53LC.default)(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $QzI7i.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, $avOEA.default)(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $fgQZ7.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $fgQZ7.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $fgQZ7.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $fgQZ7.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $6hzLi.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $139ed3bcc800a4b3$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $6hzLi.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $8yl7f.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $fgQZ7.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $fgQZ7.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $fgQZ7.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $6OrUO.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 2;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 2:
                                if (!this.initCompleted) {
                                    _context7.next = 4;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 4:
                                _context7.next = 6;
                                return this.initPromise;
                            case 6:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $gK2qk.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $gK2qk.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $iP8X2.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $fgQZ7.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $fgQZ7.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $139ed3bcc800a4b3$var$_objectSpread({}, clientOptions);
                                _context8.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $6OrUO.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $6OrUO.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, $2qaZZ.default)(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 20;
                                break;
                            case 13:
                                _context8.prev = 13;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context8.t0;
                            case 20:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $139ed3bcc800a4b3$var$_objectSpread($139ed3bcc800a4b3$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, $2qaZZ.default)(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 22;
                                break;
                            case 15:
                                _context9.prev = 15;
                                _context9.t0 = _context9["catch"](1);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context9.t0;
                            case 22:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args0 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee0$(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $fgQZ7.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $139ed3bcc800a4b3$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $139ed3bcc800a4b3$var$_objectSpread($139ed3bcc800a4b3$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $139ed3bcc800a4b3$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $8yl7f.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, $gnQ3X.default)(newClientOptions, $139ed3bcc800a4b3$var$_excluded);
                                this.user = (0, $fgQZ7.toStatsigUser)(identifiers, customAttributes);
                                statsigOptions = $139ed3bcc800a4b3$var$_objectSpread($139ed3bcc800a4b3$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $ec1qE.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $ec1qE.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 12;
                                this.statsigClient = new (0, $ec1qE.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context0.next = 29;
                                break;
                            case 19:
                                _context0.prev = 19;
                                _context0.t0 = _context0["catch"](12);
                                if (_context0.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context0.t0 === null || _context0.t0 === void 0 ? void 0 : _context0.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $ec1qE.StatsigClient)($139ed3bcc800a4b3$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context0.t0;
                            case 29:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 3;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 5;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 6;
                                _context10.next = 9;
                                return this.initPromise;
                            case 9:
                                _context10.next = 13;
                                break;
                            case 11:
                                _context10.prev = 11;
                                _context10.t0 = _context10["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee1$(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 4;
                                                    break;
                                                }
                                                _context1.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context11.sent;
                                user = (0, $fgQZ7.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                _context11.next = 13;
                                break;
                            case 8:
                                _context11.prev = 8;
                                _context11.t0 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context11.t0 instanceof Error ? _context11.t0.message : JSON.stringify(_context11.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context11.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 21;
                                    break;
                                }
                                _context11.next = 21;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 21:
                                _context11.next = 27;
                                break;
                            case 23:
                                _context11.prev = 23;
                                _context11.t1 = _context11["catch"](15);
                                success = false;
                                errorMessage = String(_context11.t1);
                            case 27:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 34;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 35;
                                break;
                            case 34:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 35:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            23
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $6hzLi.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $aGYXU.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $aGYXU.Layer).fromLayer((0, $ec1qE._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("4J6nZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $37105186eb633779$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $f72YL = parcelRequire("f72YL");
function $37105186eb633779$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $37105186eb633779$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $37105186eb633779$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $37105186eb633779$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $37105186eb633779$export$a66cbd9b2289cd78 = '@all-features';
var $37105186eb633779$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, $cTewU.default)(this, Subscriptions);
        (0, $f53LC.default)(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($f72YL)))();
    }
    return (0, $avOEA.default)(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $37105186eb633779$var$_objectSpread($37105186eb633779$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $37105186eb633779$var$_objectSpread($37105186eb633779$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $37105186eb633779$var$_objectSpread($37105186eb633779$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $37105186eb633779$var$_objectSpread($37105186eb633779$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($37105186eb633779$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($37105186eb633779$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($37105186eb633779$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $37105186eb633779$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("gK2qk", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", function () { return $c302d27fbbb1deaf$export$6dc24881a3d96325; });

var $2zYm4 = parcelRequire("2zYm4");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $fgQZ7 = parcelRequire("fgQZ7");
var $c302d27fbbb1deaf$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, $cTewU.default)(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, $avOEA.default)(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, $2zYm4.default)(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, $2zYm4.default)(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $fgQZ7.migrateEvaluationDetails)(experiment.details), (0, $fgQZ7.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("fgQZ7", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", function () { return $b1e17352df5df3a0$export$d119b37e5f788b43; });
$parcel$export(module.exports, "shallowEquals", function () { return $b1e17352df5df3a0$export$fa1c2bbf4100b8bc; });
$parcel$export(module.exports, "toStatsigUser", function () { return $b1e17352df5df3a0$export$3dad1db244472f32; });
$parcel$export(module.exports, "migrateInitializationOptions", function () { return $b1e17352df5df3a0$export$202946b690d26d22; });
$parcel$export(module.exports, "migrateEvaluationDetails", function () { return $b1e17352df5df3a0$export$18ad168d3dbac899; });
$parcel$export(module.exports, "migrateSecondaryExposures", function () { return $b1e17352df5df3a0$export$55fd683752d01e67; });

var $gnQ3X = parcelRequire("gnQ3X");

var $2qaZZ = parcelRequire("2qaZZ");

var $f53LC = parcelRequire("f53LC");

var $hMUFv = parcelRequire("hMUFv");

var $iP8X2 = parcelRequire("iP8X2");

var $8yl7f = parcelRequire("8yl7f");
var $b1e17352df5df3a0$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $b1e17352df5df3a0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b1e17352df5df3a0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b1e17352df5df3a0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b1e17352df5df3a0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b1e17352df5df3a0$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $b1e17352df5df3a0$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $hMUFv.isFedRamp)() ? (0, $8yl7f.PerimeterType).FEDRAMP_MODERATE : (0, $8yl7f.PerimeterType).COMMERCIAL
    }, options);
};
var $b1e17352df5df3a0$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, $2qaZZ.default)(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, $2qaZZ.default)(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, $2qaZZ.default)(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, $2qaZZ.default)(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $b1e17352df5df3a0$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    var user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $b1e17352df5df3a0$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, $gnQ3X.default)(options, $b1e17352df5df3a0$var$_excluded);
    return $b1e17352df5df3a0$var$_objectSpread($b1e17352df5df3a0$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $b1e17352df5df3a0$var$evaluationReasonMappings = Object.entries((0, $iP8X2.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, $2qaZZ.default)(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $b1e17352df5df3a0$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $b1e17352df5df3a0$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, $2qaZZ.default)(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $iP8X2.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $b1e17352df5df3a0$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("iP8X2", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", function () { return $db43eef4ee77049f$export$c62558b199e46828; });
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $db43eef4ee77049f$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("8yl7f", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", function () { return $63a1e0e78450d325$export$479e7351a733299; });
$parcel$export(module.exports, "PerimeterType", function () { return $63a1e0e78450d325$export$c42b7bbc5e7ba555; });
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $63a1e0e78450d325$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $63a1e0e78450d325$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $63a1e0e78450d325$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("aGYXU", function(module, exports) {
$parcel$export(module.exports, "Layer", function () { return $7c8d1e101d41b693$export$936d0764594b6eb3; });

var $2zYm4 = parcelRequire("2zYm4");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $fgQZ7 = parcelRequire("fgQZ7");
var $7c8d1e101d41b693$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, $cTewU.default)(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, $avOEA.default)(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, $2zYm4.default)(val) === (0, $2zYm4.default)(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $fgQZ7.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $fgQZ7.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $fgQZ7.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("6OrUO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4f5d10fd20676898$export$2e2bcd8739ae039; });

var $f53LC = parcelRequire("f53LC");

var $cn8ql = parcelRequire("cn8ql");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $5Cxn4 = parcelRequire("5Cxn4");

var $8yl7f = parcelRequire("8yl7f");

var $6hzLi = parcelRequire("6hzLi");

var $c7uDB = parcelRequire("c7uDB");
function $4f5d10fd20676898$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4f5d10fd20676898$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4f5d10fd20676898$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4f5d10fd20676898$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4f5d10fd20676898$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $4f5d10fd20676898$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $4f5d10fd20676898$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $4f5d10fd20676898$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $4f5d10fd20676898$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $4f5d10fd20676898$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $4f5d10fd20676898$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $4f5d10fd20676898$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $4f5d10fd20676898$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $4f5d10fd20676898$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $4f5d10fd20676898$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, $cTewU.default)(this, Fetcher);
    }
    return (0, $avOEA.default)(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error('Failed to retrieve client sdk key');
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error('Failed to retrieve experiment values');
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $c7uDB.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $c7uDB.ResponseError)('Unexpected 204 response');
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $4f5d10fd20676898$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $8yl7f.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $8yl7f.FeatureGateEnvironment).Production:
                        return $4f5d10fd20676898$export$18c93900db9358a4;
                    case (0, $8yl7f.FeatureGateEnvironment).Staging:
                        return $4f5d10fd20676898$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $8yl7f.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $8yl7f.FeatureGateEnvironment).Development:
                        return $4f5d10fd20676898$export$f058dbf75c3bc647;
                    case (0, $8yl7f.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $4f5d10fd20676898$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $4f5d10fd20676898$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $4f5d10fd20676898$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $4f5d10fd20676898$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $6hzLi.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $4f5d10fd20676898$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($4f5d10fd20676898$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($4f5d10fd20676898$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("6hzLi", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", function () { return $493012280a7e7eae$export$a59f8d67326bd1cb; });
/// <reference types="node" />
var $493012280a7e7eae$export$a59f8d67326bd1cb = "0.0.0-development";

});

parcelRegister("c7uDB", function(module, exports) {
$parcel$export(module.exports, "ResponseError", function () { return $8d2de77bba482605$export$286baf652d0b1206; });

var $avOEA = parcelRequire("avOEA");

var $cTewU = parcelRequire("cTewU");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $i7dvh = parcelRequire("i7dvh");

var $4GELH = parcelRequire("4GELH");
function $8d2de77bba482605$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $8d2de77bba482605$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $8d2de77bba482605$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($8d2de77bba482605$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $8d2de77bba482605$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, $cTewU.default)(this, ResponseError);
        return $8d2de77bba482605$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, $i7dvh.default)(ResponseError, _Error);
    return (0, $avOEA.default)(ResponseError);
}(/*#__PURE__*/ (0, $4GELH.default)(Error));

});


parcelRegister("bkUCD", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", function () { return $840d7bf226c81ab2$export$55fffef3474104af; });

var $cn8ql = parcelRequire("cn8ql");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $7SQOE = parcelRequire("7SQOE");

var $i7dvh = parcelRequire("i7dvh");

var $f53LC = parcelRequire("f53LC");

var $5Cxn4 = parcelRequire("5Cxn4");

var $ec1qE = parcelRequire("ec1qE");
function $840d7bf226c81ab2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $840d7bf226c81ab2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $840d7bf226c81ab2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $840d7bf226c81ab2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $840d7bf226c81ab2$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $840d7bf226c81ab2$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $840d7bf226c81ab2$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($840d7bf226c81ab2$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $840d7bf226c81ab2$var$_superPropGet(t, o, e, r) {
    var p = (0, $7SQOE.default)((0, $jlBwm.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $840d7bf226c81ab2$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, $cTewU.default)(this, NoFetchDataAdapter);
        _this = $840d7bf226c81ab2$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, $f53LC.default)(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, $i7dvh.default)(NoFetchDataAdapter, _DataAdapterCore);
    return (0, $avOEA.default)(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $ec1qE.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $840d7bf226c81ab2$var$_objectSpread($840d7bf226c81ab2$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $ec1qE._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $840d7bf226c81ab2$var$_objectSpread($840d7bf226c81ab2$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $ec1qE._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $ec1qE._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $ec1qE.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $840d7bf226c81ab2$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $840d7bf226c81ab2$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $ec1qE.DataAdapterCore));

});

parcelRegister("QzI7i", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", function () { return $09e08ed11c658782$export$d8474cff104280f3; });
$parcel$export(module.exports, "PersistentOverrideAdapter", function () { return $09e08ed11c658782$export$bcb28fbac1def494; });

var $f53LC = parcelRequire("f53LC");

var $2qaZZ = parcelRequire("2qaZZ");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $3wfvf = parcelRequire("3wfvf");
function $09e08ed11c658782$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $09e08ed11c658782$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $09e08ed11c658782$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $09e08ed11c658782$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $09e08ed11c658782$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $09e08ed11c658782$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $09e08ed11c658782$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $09e08ed11c658782$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $09e08ed11c658782$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $09e08ed11c658782$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $09e08ed11c658782$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $09e08ed11c658782$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $09e08ed11c658782$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $09e08ed11c658782$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $09e08ed11c658782$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $09e08ed11c658782$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, $cTewU.default)(this, PersistentOverrideAdapter);
        this._overrides = $09e08ed11c658782$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, $avOEA.default)(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $09e08ed11c658782$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $09e08ed11c658782$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $09e08ed11c658782$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, $2qaZZ.default)(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, $2qaZZ.default)(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, $2qaZZ.default)(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($09e08ed11c658782$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($09e08ed11c658782$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $09e08ed11c658782$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $3wfvf._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $09e08ed11c658782$var$_objectSpread($09e08ed11c658782$var$_objectSpread({}, $09e08ed11c658782$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, $2qaZZ.default)(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, $2qaZZ.default)(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($09e08ed11c658782$var$djb2MapKey((0, $3wfvf._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($09e08ed11c658782$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($09e08ed11c658782$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($09e08ed11c658782$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $09e08ed11c658782$var$_objectSpread($09e08ed11c658782$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $09e08ed11c658782$var$_objectSpread($09e08ed11c658782$var$_objectSpread({}, current.details), {}, {
                        reason: $09e08ed11c658782$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($09e08ed11c658782$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($09e08ed11c658782$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($09e08ed11c658782$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($09e08ed11c658782$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($09e08ed11c658782$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($09e08ed11c658782$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $09e08ed11c658782$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($09e08ed11c658782$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $09e08ed11c658782$var$_objectSpread($09e08ed11c658782$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $3wfvf._makeTypedGet)(current.name, overridden),
                    details: $09e08ed11c658782$var$_objectSpread($09e08ed11c658782$var$_objectSpread({}, current.details), {}, {
                        reason: $09e08ed11c658782$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($09e08ed11c658782$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $09e08ed11c658782$var$_objectSpread($09e08ed11c658782$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $3wfvf._makeTypedGet)(current.name, overridden),
                    details: $09e08ed11c658782$var$_objectSpread($09e08ed11c658782$var$_objectSpread({}, current.details), {}, {
                        reason: $09e08ed11c658782$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("dv86y", function(module, exports) {
$parcel$export(module.exports, "debug", function () { return $9d44750f5eaaa411$export$1c9f709888824e05; });
var $9d44750f5eaaa411$var$_process, $9d44750f5eaaa411$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $9d44750f5eaaa411$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($9d44750f5eaaa411$var$_process = globalThis.process) === null || $9d44750f5eaaa411$var$_process === void 0 || ($9d44750f5eaaa411$var$_process = $9d44750f5eaaa411$var$_process.env) === null || $9d44750f5eaaa411$var$_process === void 0 ? void 0 : $9d44750f5eaaa411$var$_process.JEST_WORKER_ID) !== undefined;
var $9d44750f5eaaa411$var$DEBUG_MODE = !$9d44750f5eaaa411$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($9d44750f5eaaa411$var$_process2 = globalThis.process) === null || $9d44750f5eaaa411$var$_process2 === void 0 || ($9d44750f5eaaa411$var$_process2 = $9d44750f5eaaa411$var$_process2.env) === null || $9d44750f5eaaa411$var$_process2 === void 0 ? void 0 : $9d44750f5eaaa411$var$_process2.NODE_ENV) !== 'production';
var $9d44750f5eaaa411$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$9d44750f5eaaa411$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("cYAGC", function(module, exports) {
$parcel$export(module.exports, "layers", function () { return $97278bcbbc72944b$export$7be255094ccdc533; });

var $9EShk = parcelRequire("9EShk");

var $1DTYW = parcelRequire("1DTYW");
var $97278bcbbc72944b$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $97278bcbbc72944b$export$c93026a968943f95 = 'light';
var $97278bcbbc72944b$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $97278bcbbc72944b$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $1DTYW.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    (0, $9EShk.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $97278bcbbc72944b$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $97278bcbbc72944b$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $97278bcbbc72944b$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $9EShk.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $97278bcbbc72944b$export$ba1d834b86d72a09 = $97278bcbbc72944b$export$a1b3edb637fb4f35;
var $97278bcbbc72944b$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $1DTYW.N20A), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $1DTYW.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $1DTYW.N30A), ")")
            }
        }
    };
};

});
parcelRegister("9EShk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7081f40df698ecd2$export$2e2bcd8739ae039; });

var $7RLYv = parcelRequire("7RLYv");

var $7t0tI = parcelRequire("7t0tI");
function $7081f40df698ecd2$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $7RLYv.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $7081f40df698ecd2$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $7t0tI;
}

});
parcelRegister("7RLYv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5ba2b27b2d15c5f0$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $5ba2b27b2d15c5f0$var$printed = {};
function $5ba2b27b2d15c5f0$export$2e2bcd8739ae039(message) {
    if ($5ba2b27b2d15c5f0$var$printed[message]) return;
    $5ba2b27b2d15c5f0$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});


parcelRegister("1DTYW", function(module, exports) {
$parcel$export(module.exports, "B200", function () { return $1324dbcec4aea542$export$215b7063051591f1; });
$parcel$export(module.exports, "N20A", function () { return $1324dbcec4aea542$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $1324dbcec4aea542$export$920c0d5c49070351; });
// Reds
var $1324dbcec4aea542$export$4b84fd0e2c617bd = '#FFEBE6';
var $1324dbcec4aea542$export$b34b069eff244586 = '#FFBDAD';
var $1324dbcec4aea542$export$be802dd0d8b57f35 = '#FF8F73';
var $1324dbcec4aea542$export$60847d42f9da92a6 = '#FF7452';
var $1324dbcec4aea542$export$4a7404f376229999 = '#FF5630';
var $1324dbcec4aea542$export$2010d0fb4295b346 = '#DE350B';
var $1324dbcec4aea542$export$2837b5a1a71d5c02 = '#BF2600';
var $1324dbcec4aea542$export$8d9596b529bbb9cf = '#FFFAE6';
var $1324dbcec4aea542$export$41060a744ab0b7ae = '#FFF0B3';
var $1324dbcec4aea542$export$1cc05bbbf340e559 = '#FFE380';
var $1324dbcec4aea542$export$5aae31392d72caaa = '#FFC400';
var $1324dbcec4aea542$export$c6930421db9fa514 = '#FFAB00';
var $1324dbcec4aea542$export$59619663aa6500fb = '#FF991F';
var $1324dbcec4aea542$export$874739ea9e379ab6 = '#FF8B00';
var $1324dbcec4aea542$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $1324dbcec4aea542$export$69a3bf21b9686c2b = '#ABF5D1';
var $1324dbcec4aea542$export$afbce1382ec95f73 = '#79F2C0';
var $1324dbcec4aea542$export$747d86715d4175de = '#57D9A3';
var $1324dbcec4aea542$export$940e1f69e873f202 = '#36B37E';
var $1324dbcec4aea542$export$a49394138f7b8e85 = '#00875A';
var $1324dbcec4aea542$export$6fa04827ac68a4fb = '#006644';
var $1324dbcec4aea542$export$226de0355ed012f8 = '#DEEBFF';
var $1324dbcec4aea542$export$8c13c2ee36917869 = '#B3D4FF';
var $1324dbcec4aea542$export$ecfc1dff386a3e7a = '#4C9AFF';
var $1324dbcec4aea542$export$215b7063051591f1 = '#2684FF';
var $1324dbcec4aea542$export$e62e8919cca44969 = '#0065FF';
var $1324dbcec4aea542$export$b3de0ae08da2ce64 = '#0052CC';
var $1324dbcec4aea542$export$a6ee3d71bc067634 = '#0747A6';
var $1324dbcec4aea542$export$67f15409e87642a1 = '#669DF1';
var $1324dbcec4aea542$export$f0539dbc42dbb067 = '#8FB8F6';
var $1324dbcec4aea542$export$363e4475840015bb = '#EAE6FF';
var $1324dbcec4aea542$export$4b0a4417ed59760f = '#C0B6F2';
var $1324dbcec4aea542$export$6011520a64d9a187 = '#998DD9';
var $1324dbcec4aea542$export$a7175d4e9206bc80 = '#8777D9';
var $1324dbcec4aea542$export$b48405b95304b5a1 = '#6554C0';
var $1324dbcec4aea542$export$c71e4279dd54a18d = '#5243AA';
var $1324dbcec4aea542$export$147899de772240ec = '#403294';
var $1324dbcec4aea542$export$2cf711fe14c66f06 = '#E6FCFF';
var $1324dbcec4aea542$export$7a8f4d33f6f9772c = '#B3F5FF';
var $1324dbcec4aea542$export$776c9c497ef08533 = '#79E2F2';
var $1324dbcec4aea542$export$69cb3ca10c1e330e = '#00C7E6';
var $1324dbcec4aea542$export$9dc1ef0f3f48059b = '#00B8D9';
var $1324dbcec4aea542$export$7c835c78b6fcdef8 = '#00A3BF';
var $1324dbcec4aea542$export$6036577f95c3877e = '#008DA6';
var $1324dbcec4aea542$export$29a4f05edc054374 = '#FFFFFF';
var $1324dbcec4aea542$export$e655ef011c4aa1a2 = '#FAFBFC';
var $1324dbcec4aea542$export$9fdfb749e33cdf97 = '#F4F5F7';
var $1324dbcec4aea542$export$3e51e8f1440314ba = '#EBECF0';
var $1324dbcec4aea542$export$1ce2d1575d444ceb = '#DFE1E6';
var $1324dbcec4aea542$export$8754fc7e6d8b3000 = '#C1C7D0';
var $1324dbcec4aea542$export$c2e91cbeada39b8b = '#B3BAC5';
var $1324dbcec4aea542$export$5f71e19f3a7ad9de = '#A5ADBA';
var $1324dbcec4aea542$export$eaa8c8a70ac22806 = '#97A0AF';
var $1324dbcec4aea542$export$7c87d337fb91a97d = '#8993A4';
var $1324dbcec4aea542$export$d6447c357493214f = '#7A869A';
var $1324dbcec4aea542$export$f563ee71e9ee74cd = '#6B778C';
var $1324dbcec4aea542$export$e2ef2124cf4024b1 = '#5E6C84';
var $1324dbcec4aea542$export$eece5f492e429f08 = '#505F79';
var $1324dbcec4aea542$export$c39c0fe0f26207ae = '#42526E';
var $1324dbcec4aea542$export$7090862dc3038a9f = '#344563';
var $1324dbcec4aea542$export$ad0bacf983b7ddaa = '#253858';
var $1324dbcec4aea542$export$7d61b15e0da132af = '#172B4D';
var $1324dbcec4aea542$export$fbda843f0a27fe96 = '#091E42';
var $1324dbcec4aea542$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $1324dbcec4aea542$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $1324dbcec4aea542$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $1324dbcec4aea542$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $1324dbcec4aea542$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $1324dbcec4aea542$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $1324dbcec4aea542$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $1324dbcec4aea542$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $1324dbcec4aea542$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $1324dbcec4aea542$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $1324dbcec4aea542$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $1324dbcec4aea542$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $1324dbcec4aea542$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $1324dbcec4aea542$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $1324dbcec4aea542$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $1324dbcec4aea542$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $1324dbcec4aea542$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $1324dbcec4aea542$export$2f6319cf7d736c2a = '#E6EDFA';
var $1324dbcec4aea542$export$95126bc8884d6634 = '#DCE5F5';
var $1324dbcec4aea542$export$8338d8c35d44ff1 = '#CED9EB';
var $1324dbcec4aea542$export$5368d76ae4fbbda7 = '#B8C7E0';
var $1324dbcec4aea542$export$9f0a771d16ec8d36 = '#ABBBD6';
var $1324dbcec4aea542$export$abcf8c38338b4aa5 = '#9FB0CC';
var $1324dbcec4aea542$export$97e81faa16a182c7 = '#8C9CB8';
var $1324dbcec4aea542$export$bfe21c59123ecf33 = '#7988A3';
var $1324dbcec4aea542$export$ee82aa2ea6a1558 = '#67758F';
var $1324dbcec4aea542$export$682927c6ed76be02 = '#56637A';
var $1324dbcec4aea542$export$91fd9994c5be9757 = '#455166';
var $1324dbcec4aea542$export$d281fbfe3cff2df6 = '#3B475C';
var $1324dbcec4aea542$export$3902c91d8b98a753 = '#313D52';
var $1324dbcec4aea542$export$8e8133c1ba5845b5 = '#283447';
var $1324dbcec4aea542$export$33ff357f6620b39 = '#202B3D';
var $1324dbcec4aea542$export$633847cf062b69e0 = '#1B2638';
var $1324dbcec4aea542$export$9776a6e503bdbf76 = '#121A29';
var $1324dbcec4aea542$export$6c813d5160dff5db = '#0E1624';
var $1324dbcec4aea542$export$3d4f271a500072a = '#0D1424';
var $1324dbcec4aea542$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $1324dbcec4aea542$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $1324dbcec4aea542$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $1324dbcec4aea542$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $1324dbcec4aea542$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $1324dbcec4aea542$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $1324dbcec4aea542$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $1324dbcec4aea542$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $1324dbcec4aea542$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $1324dbcec4aea542$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $1324dbcec4aea542$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $1324dbcec4aea542$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $1324dbcec4aea542$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $1324dbcec4aea542$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $1324dbcec4aea542$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $1324dbcec4aea542$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $1324dbcec4aea542$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $1324dbcec4aea542$export$d2adc5dedf09fced = '#292A2E';
var $1324dbcec4aea542$export$f51762073d2bb381 = '#94C748';
var $1324dbcec4aea542$export$95e26d54def96891 = '#B3DF72';

});


parcelRegister("ujAQt", function(module, exports) {
$parcel$export(module.exports, "register", function () { return $05b200461b546303$export$6503ec6e8aabbaf; });
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $dH1HR = parcelRequire("dH1HR");
var $05b200461b546303$var$registrations = new Set();
var $05b200461b546303$var$cleanupEndEventListeners = null;
function $05b200461b546303$var$onDragStart() {
    if ($05b200461b546303$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $05b200461b546303$var$cleanupEndEventListeners = (0, $dH1HR.bindAll)(window, [
        {
            type: 'dragend',
            listener: $05b200461b546303$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $05b200461b546303$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $05b200461b546303$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($05b200461b546303$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $05b200461b546303$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $05b200461b546303$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $05b200461b546303$var$cleanupEndEventListeners = null;
    var clone = Array.from($05b200461b546303$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $05b200461b546303$var$bindStartEvents() {
    return (0, $dH1HR.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $05b200461b546303$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $05b200461b546303$var$onDragStart
        }
    ]);
}
var $05b200461b546303$var$cleanupStartEventListeners = null;
function $05b200461b546303$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$05b200461b546303$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $05b200461b546303$var$cleanupStartEventListeners = $05b200461b546303$var$bindStartEvents();
    $05b200461b546303$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $05b200461b546303$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $05b200461b546303$var$registrations.delete(registration);
        if ($05b200461b546303$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $05b200461b546303$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $05b200461b546303$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("1dSuR", function(module, exports) {
$parcel$export(module.exports, "show", function () { return $0e41473e89ef48bd$export$57bf213be019eeb0; });

var $h7fyy = parcelRequire("h7fyy");

var $3DgMo = parcelRequire("3DgMo");
// This file is a singleton for managing tooltips
var $0e41473e89ef48bd$var$active = null;
function $0e41473e89ef48bd$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($0e41473e89ef48bd$var$active && $0e41473e89ef48bd$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $3DgMo.clearScheduled)();
            $0e41473e89ef48bd$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $3DgMo.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $3DgMo.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $3DgMo.scheduleTimeout)(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        var shouldAlwaysFadeIn = (0, $h7fyy.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? entry.shouldAlwaysFadeIn : false;
        var showImmediately = Boolean($0e41473e89ef48bd$var$active && $0e41473e89ef48bd$var$active.isVisible()) && !shouldAlwaysFadeIn;
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($0e41473e89ef48bd$var$active) {
            (0, $3DgMo.clearScheduled)();
            $0e41473e89ef48bd$var$active.entry.hide({
                isImmediate: true
            });
            $0e41473e89ef48bd$var$active.entry.done();
            $0e41473e89ef48bd$var$active = null;
        }
        // this tooltip is now the active tooltip
        $0e41473e89ef48bd$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $3DgMo.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        // Removing old `mousePosition` behind gate because it stored a function.
        // With the gate we just store the coords which are easier to work with.
        mousePosition: (0, $h7fyy.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? undefined : getInitialMouse(),
        mousePos: entry.source.type === 'mouse' && (0, $h7fyy.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? {
            clientX: entry.source.clientX,
            clientY: entry.source.clientY
        } : null
    };
    return result;
}

});
parcelRegister("3DgMo", function(module, exports) {
$parcel$export(module.exports, "clearScheduled", function () { return $2a5207b2a4f338ca$export$eaf678f6f93f5250; });
$parcel$export(module.exports, "scheduleTimeout", function () { return $2a5207b2a4f338ca$export$5f4d6617421d489b; });
var $2a5207b2a4f338ca$var$delayId = null;
function $2a5207b2a4f338ca$export$eaf678f6f93f5250() {
    if ($2a5207b2a4f338ca$var$delayId != null) {
        window.clearTimeout($2a5207b2a4f338ca$var$delayId);
        $2a5207b2a4f338ca$var$delayId = null;
    }
}
function $2a5207b2a4f338ca$export$5f4d6617421d489b(fn, delay) {
    $2a5207b2a4f338ca$export$eaf678f6f93f5250();
    $2a5207b2a4f338ca$var$delayId = window.setTimeout(function() {
        $2a5207b2a4f338ca$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("cykVe", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9238e3af13b498c1$export$2e2bcd8739ae039; });

var $iHi0C = parcelRequire("iHi0C");
function $9238e3af13b498c1$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $iHi0C.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});
parcelRegister("iHi0C", function(module, exports) {
$parcel$export(module.exports, "useIdSeed", function () { return $d9ca3658b32c197e$export$6ee17796e3d70de2; });

var $2zYm4 = parcelRequire("2zYm4");

var $1oC0p = parcelRequire("1oC0p");

var $6JmtO = parcelRequire("6JmtO");

var $h7fyy = parcelRequire("h7fyy");
var $d9ca3658b32c197e$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $d9ca3658b32c197e$var$react18UseId = ($d9ca3658b32c197e$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useId) !== null && $d9ca3658b32c197e$var$_React$useId !== void 0 ? $d9ca3658b32c197e$var$_React$useId : undefined;
function $d9ca3658b32c197e$export$f680877a34711e37() {
    if ($d9ca3658b32c197e$var$react18UseId && (0, $h7fyy.fg)('platform-dst-react-18-use-id')) {
        if ((0, $h7fyy.fg)('platform-dst-react-18-use-id-selector-safe')) // tl;dr: React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`
        // in hundreds of tests. So we replace it with a safe string of `_` to match future
        // React 19 functionality: https://github.com/facebook/react/pull/33422
        return $d9ca3658b32c197e$var$react18UseId().replace(/[:«»]/g, '_');
        return $d9ca3658b32c197e$var$react18UseId();
    }
    return "uid".concat((0, $6JmtO.useUID)());
}
var $d9ca3658b32c197e$export$6be90bcb437e928f = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($d9ca3658b32c197e$export$f680877a34711e37()).concat(postfix);
    (0, $1oC0p.useEffect)(function() {
        if (!ref) return;
        switch((0, $2zYm4.default)(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, $2zYm4.default)(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $d9ca3658b32c197e$export$6ee17796e3d70de2() {
    if ($d9ca3658b32c197e$var$react18UseId && (0, $h7fyy.fg)('platform-dst-react-18-use-id')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- cleanup with feature gating
        var uid = $d9ca3658b32c197e$export$f680877a34711e37();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $6JmtO.useUIDSeed)();
}

});


parcelRegister("k7SeZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ea6e8931dd7fed44$export$2e2bcd8739ae039; });
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $axrVF = parcelRequire("axrVF");

var $3yTdJ = parcelRequire("3yTdJ");
var $ea6e8931dd7fed44$var$styles = {
    base: "_2rkofajl _11c8wadc _vchhusvi _p12fp3fh _bfhkgkf6 _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $ea6e8931dd7fed44$var$TooltipContainer = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $1oC0p.createElement((0, $3yTdJ.default), {
        ref: ref,
        style: style,
        className: (0, $axrVF.default)([
            $ea6e8931dd7fed44$var$styles.base,
            truncate && $ea6e8931dd7fed44$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut
    }, children);
});
$ea6e8931dd7fed44$var$TooltipContainer.displayName = 'TooltipContainer';
var $ea6e8931dd7fed44$export$2e2bcd8739ae039 = $ea6e8931dd7fed44$var$TooltipContainer;

});
parcelRegister("axrVF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7ac2a693351b620b$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $7ac2a693351b620b$var$ATOMIC_GROUP_LENGTH = 5;
function $7ac2a693351b620b$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $7ac2a693351b620b$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("3yTdJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $297f61b4ace78c33$export$2e2bcd8739ae039; });
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $axrVF = parcelRequire("axrVF");

var $5sNnT = parcelRequire("5sNnT");
var $297f61b4ace78c33$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $297f61b4ace78c33$var$TooltipPrimitive = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $1oC0p.createElement("div", {
        role: "tooltip",
        className: (0, $axrVF.default)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children, shortcut && /*#__PURE__*/ $1oC0p.createElement((0, $5sNnT.TooltipShortcut), {
        shortcut: shortcut
    })));
});
$297f61b4ace78c33$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $297f61b4ace78c33$export$2e2bcd8739ae039 = $297f61b4ace78c33$var$TooltipPrimitive;

});
parcelRegister("5sNnT", function(module, exports) {
$parcel$export(module.exports, "TooltipShortcut", function () { return $3fa5e00018b6e091$export$5bcbc43c84236222; });
/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $axrVF = parcelRequire("axrVF");
var $3fa5e00018b6e091$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c8wadc _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
var $3fa5e00018b6e091$export$5bcbc43c84236222 = function TooltipShortcut(_ref) {
    var shortcut = _ref.shortcut;
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        className: (0, $axrVF.default)([
            $3fa5e00018b6e091$var$styles.shortcutSegmentsContainer
        ])
    }, shortcut.map(function(segment, index) {
        return /*#__PURE__*/ $1oC0p.createElement("kbd", {
            key: "".concat(segment, "-").concat(index),
            className: (0, $axrVF.default)([
                $3fa5e00018b6e091$var$styles.shortcutSegment
            ])
        }, segment);
    }));
};

});



parcelRegister("evbin", function(module, exports) {
$parcel$export(module.exports, "getMousePosition", function () { return $a8ecb8f3c8d00d6b$export$642213d516a9b928; });
$parcel$export(module.exports, "getVirtualElementFromMousePos", function () { return $a8ecb8f3c8d00d6b$export$2e68479e0a5d8746; });
function $a8ecb8f3c8d00d6b$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}
function $a8ecb8f3c8d00d6b$export$2e68479e0a5d8746(mousePos, _ref) {
    var targetElement = _ref.targetElement, tooltipPosition = _ref.tooltipPosition;
    if (tooltipPosition === 'mouse') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: mousePos.clientY,
                width: 0,
                height: 0
            });
        }
    };
    var targetRect = targetElement.getBoundingClientRect();
    if (tooltipPosition === 'mouse-x') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: targetRect.top,
                width: 0,
                height: targetRect.height
            });
        }
    };
    if (tooltipPosition === 'mouse-y') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: targetRect.left,
                y: mousePos.clientY,
                width: targetRect.width,
                height: 0
            });
        }
    };
    throw new Error("Invalid tooltip position for virtual element: ".concat(tooltipPosition));
}

});


parcelRegister("awhiQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7a8a508fde881bb9$export$2e2bcd8739ae039; });
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $21nAd = parcelRequire("21nAd");
var $7a8a508fde881bb9$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $7a8a508fde881bb9$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $21nAd.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ])
    }, children);
};
$7a8a508fde881bb9$var$VisuallyHidden.displayName = 'VisuallyHidden';
var $7a8a508fde881bb9$export$2e2bcd8739ae039 = $7a8a508fde881bb9$var$VisuallyHidden;

});
parcelRegister("21nAd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $178df7e0b76433b3$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $178df7e0b76433b3$var$ATOMIC_GROUP_LENGTH = 5;
function $178df7e0b76433b3$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $178df7e0b76433b3$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});


parcelRegister("lCzCA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fbd8c73b8607da45$export$2e2bcd8739ae039; });
/* button-base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $axrVF = parcelRequire("axrVF");

var $1oC0p = parcelRequire("1oC0p");

var $72iRh = parcelRequire("72iRh");

var $lUruo = parcelRequire("lUruo");

var $iaGXW = parcelRequire("iaGXW");

var $gbIa2 = parcelRequire("gbIa2");

var $h7fyy = parcelRequire("h7fyy");

var $6Ipjw = parcelRequire("6Ipjw");

var $awhiQ = parcelRequire("awhiQ");

var $9z2pQ = parcelRequire("9z2pQ");

var $fhMPB = parcelRequire("fhMPB");

var $2ylX1 = parcelRequire("2ylX1");
var $fbd8c73b8607da45$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isIconButton",
    "isCircle",
    "hasIconBefore",
    "hasIconAfter",
    "shouldFitContainer",
    "spacing",
    "ariaLabel",
    "ariaLabelledBy",
    "children",
    "interactionName",
    "onClick",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onClickCapture",
    "testId",
    "analyticsContext",
    "componentName",
    "role",
    "onMouseOver",
    "onMouseOut",
    "onFocus",
    "onBlur",
    "onMouseMove",
    "type"
], $fbd8c73b8607da45$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $fbd8c73b8607da45$var$LOADING_LABEL = ', Loading';
var $fbd8c73b8607da45$var$styles = {
    base: "_2rkosqtm _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhk1fvb _syaz1lh4 _aetrglyw _irr31fvb _30l31lh4 _1di61fvb _9h8h1lh4",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    circle: "_2rko14q2",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var $fbd8c73b8607da45$var$defaultStyles = {
    root: "_bfhk1j54 _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhksm61 _syaz1gjq _8l3mmuej _aetrb3bt _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr3yw9d _30l310s3 _1di6ih13 _9h8h10s3",
    interactiveRefreshed: "_irr3166n _30l31gjq _1di61dty _9h8h1gjq"
};
var $fbd8c73b8607da45$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
var $fbd8c73b8607da45$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _9h8hal3n",
    interactive: "_30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
var $fbd8c73b8607da45$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
var $fbd8c73b8607da45$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
var $fbd8c73b8607da45$var$subtleStyles = {
    root: "_bfhkqtfy _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhkqtfy _syaz1gjq _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr34mfv _30l310s3 _1di619qy _9h8h10s3",
    interactiveRefreshed: "_irr34mfv _30l31gjq _1di619qy _9h8h1gjq"
};
var $fbd8c73b8607da45$var$selectedStyles = {
    root: "_bfhk7btw _syaz1pke _10531pke _f8pj1pke _30l31pke _9h8h1pke",
    rootRefreshed: "_bfhkfg4m _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3t71w _30l31pke _1di6yssv _9h8h1pke",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $fbd8c73b8607da45$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function(_ref, ref) {
    var propAppearance = _ref.appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, children = _ref.children, interactionName = _ref.interactionName, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUp = _ref.onMouseUp, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUp = _ref.onKeyUp, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStart = _ref.onTouchStart, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEnd = _ref.onTouchEnd, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDown = _ref.onPointerDown, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUp = _ref.onPointerUp, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, testId = _ref.testId, analyticsContext = _ref.analyticsContext, componentName = _ref.componentName, role = _ref.role, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onMouseMove = _ref.onMouseMove, type = _ref.type, unsafeRest = (0, $gnQ3X.default)(_ref, $fbd8c73b8607da45$var$_excluded);
    var localRef = (0, $1oC0p.useRef)(null);
    var splitButtonContext = (0, $9z2pQ.useSplitButtonContext)();
    var loadingLabelId = (0, $gbIa2.useId)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    var appearance = isDefaultAppearanceSplitButton && (0, $h7fyy.fg)('platform-component-visual-refresh') ? 'subtle' : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || 'default';
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $iaGXW.default)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $gnQ3X.default)(unsafeRest, $fbd8c73b8607da45$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $6Ipjw.default), (0, $c9bqK.default)({}, saferRest, {
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $lUruo.default)([
            localRef,
            ref
        ]),
        xcss: (0, $72iRh.cx)($fbd8c73b8607da45$var$styles.base, appearance === 'default' && ((0, $h7fyy.fg)('platform-component-visual-refresh') ? $fbd8c73b8607da45$var$defaultStyles.rootRefreshed : $fbd8c73b8607da45$var$defaultStyles.root), appearance === 'default' && isInteractive && ((0, $h7fyy.fg)('platform-component-visual-refresh') ? $fbd8c73b8607da45$var$defaultStyles.interactiveRefreshed : $fbd8c73b8607da45$var$defaultStyles.interactive), appearance === 'primary' && $fbd8c73b8607da45$var$primaryStyles.root, appearance === 'primary' && isInteractive && $fbd8c73b8607da45$var$primaryStyles.interactive, appearance === 'warning' && $fbd8c73b8607da45$var$warningStyles.root, appearance === 'warning' && isInteractive && $fbd8c73b8607da45$var$warningStyles.interactive, appearance === 'danger' && $fbd8c73b8607da45$var$dangerStyles.root, appearance === 'danger' && isInteractive && $fbd8c73b8607da45$var$dangerStyles.interactive, appearance === 'discovery' && $fbd8c73b8607da45$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $fbd8c73b8607da45$var$discoveryStyles.interactive, appearance === 'subtle' && ((0, $h7fyy.fg)('platform-component-visual-refresh') ? $fbd8c73b8607da45$var$subtleStyles.rootRefreshed : $fbd8c73b8607da45$var$subtleStyles.root), appearance === 'subtle' && isInteractive && ((0, $h7fyy.fg)('platform-component-visual-refresh') ? $fbd8c73b8607da45$var$subtleStyles.interactiveRefreshed : $fbd8c73b8607da45$var$subtleStyles.interactive), $fbd8c73b8607da45$var$styles.linkDecorationUnset, isSelected && ((0, $h7fyy.fg)('platform-component-visual-refresh') ? $fbd8c73b8607da45$var$selectedStyles.rootRefreshed : $fbd8c73b8607da45$var$selectedStyles.root), isSelected && isSplitButton && $fbd8c73b8607da45$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $fbd8c73b8607da45$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $fbd8c73b8607da45$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $fbd8c73b8607da45$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $fbd8c73b8607da45$var$selectedStyles.discovery, isDisabled && $fbd8c73b8607da45$var$styles.disabled, isCircle && !isSplitButton && $fbd8c73b8607da45$var$styles.circle, spacing === 'compact' && $fbd8c73b8607da45$var$styles.spacingCompact, hasIconBefore && $fbd8c73b8607da45$var$styles.buttonIconBefore, shouldFitContainer && $fbd8c73b8607da45$var$styles.fullWidth, hasIconAfter && $fbd8c73b8607da45$var$styles.buttonIconAfter, isIconButton && $fbd8c73b8607da45$var$styles.iconButton, isIconButton && spacing === 'compact' && $fbd8c73b8607da45$var$styles.iconButtonCompact, isLoading && $fbd8c73b8607da45$var$styles.loading, isSplitButton && $fbd8c73b8607da45$var$styles.splitButton, isNavigationSplitButton && $fbd8c73b8607da45$var$styles.navigationSplitButton),
        isDisabled: isEffectivelyDisabled,
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat($fbd8c73b8607da45$var$LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }, (0, $fhMPB.default)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9z2pQ.SplitButtonContext).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        className: (0, $axrVF.default)([
            $fbd8c73b8607da45$var$styles.loadingOverlay
        ])
    }, (0, $2ylX1.default)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $awhiQ.default), {
        id: loadingLabelId
    }, $fbd8c73b8607da45$var$LOADING_LABEL)));
});
var $fbd8c73b8607da45$export$2e2bcd8739ae039 = $fbd8c73b8607da45$var$ButtonBase;

});
parcelRegister("72iRh", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $51f75934f9f546b3$export$a274e22fb40f762e; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("1oC0p");


var $gHDq2 = parcelRequire("gHDq2");
var $51f75934f9f546b3$var$_createStrictAPI = (0, $gHDq2.createStrictAPI)(), $51f75934f9f546b3$var$XCSSProp = $51f75934f9f546b3$var$_createStrictAPI.XCSSProp, $51f75934f9f546b3$export$dbf350e5966cf602 = $51f75934f9f546b3$var$_createStrictAPI.css, $51f75934f9f546b3$export$eb1ecd84a24ee424 = $51f75934f9f546b3$var$_createStrictAPI.cssMap, $51f75934f9f546b3$export$a274e22fb40f762e = $51f75934f9f546b3$var$_createStrictAPI.cx;
 // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means products only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 
});
parcelRegister("gHDq2", function(module, exports) {
$parcel$export(module.exports, "createStrictAPI", function () { return $c28f3d4305317ef7$export$39716b4af53f4ad; });

var $5tO4r = parcelRequire("5tO4r");

var $7iPpc = parcelRequire("7iPpc");
function $c28f3d4305317ef7$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $5tO4r.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $5tO4r.createStrictSetupError)();
        },
        cx: $7iPpc.cx,
        XCSSProp () {
            throw (0, $5tO4r.createStrictSetupError)();
        }
    };
}

});
parcelRegister("5tO4r", function(module, exports) {
$parcel$export(module.exports, "createStrictSetupError", function () { return $3fd6803117213000$export$c4df1cb0c2b4d77c; });
const $3fd6803117213000$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $3fd6803117213000$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("7iPpc", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $551216e0b9cffa8a$export$a274e22fb40f762e; });

var $axrVF = parcelRequire("axrVF");
const $551216e0b9cffa8a$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $axrVF.default)(actualStyles);
};

});



parcelRegister("iaGXW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d3aa7d41232db998$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
function $d3aa7d41232db998$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $1oC0p.useRef)(true);
    (0, $1oC0p.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("gbIa2", function(module, exports) {
$parcel$export(module.exports, "useId", function () { return $bc8fedd5d079d711$export$f680877a34711e37; });

var $2zYm4 = parcelRequire("2zYm4");

var $1oC0p = parcelRequire("1oC0p");

var $6JmtO = parcelRequire("6JmtO");

var $h7fyy = parcelRequire("h7fyy");
var $bc8fedd5d079d711$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $bc8fedd5d079d711$var$react18UseId = ($bc8fedd5d079d711$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useId) !== null && $bc8fedd5d079d711$var$_React$useId !== void 0 ? $bc8fedd5d079d711$var$_React$useId : undefined;
function $bc8fedd5d079d711$export$f680877a34711e37() {
    if ($bc8fedd5d079d711$var$react18UseId && (0, $h7fyy.fg)('platform-dst-react-18-use-id')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $bc8fedd5d079d711$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $6JmtO.useUID)());
}
var $bc8fedd5d079d711$export$6be90bcb437e928f = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($bc8fedd5d079d711$export$f680877a34711e37()).concat(postfix);
    (0, $1oC0p.useEffect)(function() {
        if (!ref) return;
        switch((0, $2zYm4.default)(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, $2zYm4.default)(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $bc8fedd5d079d711$export$6ee17796e3d70de2() {
    if ($bc8fedd5d079d711$var$react18UseId && (0, $h7fyy.fg)('platform-dst-react-18-use-id')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $bc8fedd5d079d711$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $6JmtO.useUIDSeed)();
}

});

parcelRegister("6Ipjw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4e3a7cf7f3c74217$export$2e2bcd8739ae039; });
/* pressable.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");


var $7iPpc = parcelRequire("7iPpc");

var $bezzJ = parcelRequire("bezzJ");

var $dpVOT = parcelRequire("dpVOT");

var $gTjgV = parcelRequire("gTjgV");

var $etBkE = parcelRequire("etBkE");

var $auuFw = parcelRequire("auuFw");
var $4e3a7cf7f3c74217$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $4e3a7cf7f3c74217$var$_excluded2 = [
    "className"
];
var $4e3a7cf7f3c74217$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $4e3a7cf7f3c74217$var$Pressable = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $gTjgV.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, $gnQ3X.default)(_ref, $4e3a7cf7f3c74217$var$_excluded);
    var interactionContext = (0, $1oC0p.useContext)((0, $etBkE.default));
    var handleClick = (0, $1oC0p.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $bezzJ.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "14.15.4",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $gnQ3X.default)(htmlAttributes, $4e3a7cf7f3c74217$var$_excluded2);
    return /*#__PURE__*/ $1oC0p.createElement((0, $auuFw.default), (0, $c9bqK.default)({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $dpVOT.isSafari)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $7iPpc.cx)($4e3a7cf7f3c74217$var$styles.root, isDisabled && $4e3a7cf7f3c74217$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $4e3a7cf7f3c74217$export$2e2bcd8739ae039 = $4e3a7cf7f3c74217$var$Pressable;

});
parcelRegister("bezzJ", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $82dc990504d0dc26$export$a4687b0234b40e28; });

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $1ujk4 = parcelRequire("1ujk4");

var $kI191 = parcelRequire("kI191");
function $82dc990504d0dc26$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $82dc990504d0dc26$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $82dc990504d0dc26$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $82dc990504d0dc26$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $82dc990504d0dc26$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $1ujk4.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $kI191.useTrackedRef)(analyticsData);
    var fnRef = (0, $kI191.useTrackedRef)(fn);
    var handler = (0, $1oC0p.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $82dc990504d0dc26$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("dpVOT", function(module, exports) {
$parcel$export(module.exports, "isSafari", function () { return $9c4a75ff762852fe$export$95df08bae54cb4df; });
function $9c4a75ff762852fe$var$testPlatform(re) {
    var _userAgentData;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_userAgentData = window.navigator['userAgentData']) === null || _userAgentData === void 0 ? void 0 : _userAgentData.platform) || window.navigator.platform) : false;
}
function $9c4a75ff762852fe$var$isIPhone() {
    return $9c4a75ff762852fe$var$testPlatform(/^iPhone/i);
}
function $9c4a75ff762852fe$var$isMac() {
    return $9c4a75ff762852fe$var$testPlatform(/^Mac/i);
}
function $9c4a75ff762852fe$var$isIPad() {
    return $9c4a75ff762852fe$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $9c4a75ff762852fe$var$isMac() && navigator.maxTouchPoints > 1;
}
function $9c4a75ff762852fe$var$isIOS() {
    return $9c4a75ff762852fe$var$isIPhone() || $9c4a75ff762852fe$var$isIPad();
}
function $9c4a75ff762852fe$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        var _window$navigator$use;
        var ua = (_window$navigator$use = window.navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}
function $9c4a75ff762852fe$export$e1865c3bedcd822b() {
    return $9c4a75ff762852fe$var$isMac() || $9c4a75ff762852fe$var$isIOS();
}

});

parcelRegister("gTjgV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c4c0bb66d9a66353$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $c4c0bb66d9a66353$export$2e2bcd8739ae039() {}

});

parcelRegister("auuFw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7a347ee737d7cb06$export$2e2bcd8739ae039; });
/* focusable.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $axrVF = parcelRequire("axrVF");

var $h7fyy = parcelRequire("h7fyy");
var $7a347ee737d7cb06$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $7a347ee737d7cb06$var$_excluded2 = [
    "className"
];
var $7a347ee737d7cb06$var$focusRingStyles = null;
var $7a347ee737d7cb06$var$insetFocusRingStyles = null;
// This is added to override and reset global styles that apps might be applying - for example,
// at the time of writing, Jira has global styles that targets all button and anchor elements,
// adding an outline on :focus.
var $7a347ee737d7cb06$var$outlineResetStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $7a347ee737d7cb06$var$Focusable = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, $gnQ3X.default)(_ref, $7a347ee737d7cb06$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $gnQ3X.default)(htmlAttributes, $7a347ee737d7cb06$var$_excluded2);
    return /*#__PURE__*/ $1oC0p.createElement(Component, (0, $c9bqK.default)({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $axrVF.default)([
            "_mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            (0, $h7fyy.fg)('platform_dst_compiled_primitives_outline_reset') && "_ymio1r31 _ypr0glyw _zcxs1o36",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $7a347ee737d7cb06$export$2e2bcd8739ae039 = $7a347ee737d7cb06$var$Focusable;

});


parcelRegister("9z2pQ", function(module, exports) {
$parcel$export(module.exports, "SplitButtonContext", function () { return $6f6941b27a08e699$export$4b86304b2c0d7e71; });
$parcel$export(module.exports, "useSplitButtonContext", function () { return $6f6941b27a08e699$export$47e2c6fdb142d947; });

var $1oC0p = parcelRequire("1oC0p");
var $6f6941b27a08e699$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
var $6f6941b27a08e699$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $1oC0p.useContext)($6f6941b27a08e699$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        var newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("fhMPB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b20e5271e86cf2bc$export$2e2bcd8739ae039; });
function $b20e5271e86cf2bc$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $b20e5271e86cf2bc$var$tabKeyCode = 9;
function $b20e5271e86cf2bc$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $b20e5271e86cf2bc$var$tabKeyCode) return;
    $b20e5271e86cf2bc$var$abort(event);
}
function $b20e5271e86cf2bc$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $b20e5271e86cf2bc$var$abort,
        onMouseUpCapture: $b20e5271e86cf2bc$var$abort,
        onKeyDownCapture: $b20e5271e86cf2bc$var$onKey,
        onKeyUpCapture: $b20e5271e86cf2bc$var$onKey,
        onTouchStartCapture: $b20e5271e86cf2bc$var$abort,
        onTouchEndCapture: $b20e5271e86cf2bc$var$abort,
        onPointerDownCapture: $b20e5271e86cf2bc$var$abort,
        onPointerUpCapture: $b20e5271e86cf2bc$var$abort,
        onClickCapture: $b20e5271e86cf2bc$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $b20e5271e86cf2bc$var$abort
    } : events;
}

});

parcelRegister("2ylX1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1dbfc8c62de116d0$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $k7Rwn = parcelRequire("k7Rwn");
function $1dbfc8c62de116d0$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $1dbfc8c62de116d0$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $1dbfc8c62de116d0$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $k7Rwn.default), {
        size: $1dbfc8c62de116d0$var$getIconSpacing(spacing),
        appearance: $1dbfc8c62de116d0$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}

});
parcelRegister("k7Rwn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ea6dfa4dd66dc7b5$export$2e2bcd8739ae039; });
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $axrVF = parcelRequire("axrVF");

var $1oC0p = parcelRequire("1oC0p");

var $etBkE = parcelRequire("etBkE");

var $DdsbK = parcelRequire("DdsbK");

var $jllqM = parcelRequire("jllqM");
/**
 * Returns the appropriate circle stroke color.
 */ function $ea6dfa4dd66dc7b5$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $DdsbK.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $DdsbK.N0), ")");
}
var $ea6dfa4dd66dc7b5$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $ea6dfa4dd66dc7b5$var$loadIn = null;
var $ea6dfa4dd66dc7b5$var$styles = {
    rotateStyles: "_y44v1ozz _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_y44v1a7z _1o51q7pw _tzy4idpf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _opj11kw7 _134c892t _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $ea6dfa4dd66dc7b5$var$useLayoutEffect = typeof window === 'undefined' ? (0, $1oC0p.useEffect) : (0, $1oC0p.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $ea6dfa4dd66dc7b5$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $jllqM.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $ea6dfa4dd66dc7b5$var$getStrokeColor(appearance);
    var context = (0, $1oC0p.useContext)((0, $etBkE.default));
    $ea6dfa4dd66dc7b5$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $axrVF.default)([
            $ea6dfa4dd66dc7b5$var$styles.wrapperStyles,
            $ea6dfa4dd66dc7b5$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $axrVF.default)([
            $ea6dfa4dd66dc7b5$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $axrVF.default)([
            $ea6dfa4dd66dc7b5$var$styles.circleStyles
        ])
    })));
}));
var $ea6dfa4dd66dc7b5$export$2e2bcd8739ae039 = $ea6dfa4dd66dc7b5$var$Spinner;

});
parcelRegister("DdsbK", function(module, exports) {
$parcel$export(module.exports, "N0", function () { return $075e143f94feb311$export$29a4f05edc054374; });
$parcel$export(module.exports, "N500", function () { return $075e143f94feb311$export$c39c0fe0f26207ae; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $075e143f94feb311$export$4b84fd0e2c617bd = '#FFEBE6';
var $075e143f94feb311$export$b34b069eff244586 = '#FFBDAD';
var $075e143f94feb311$export$be802dd0d8b57f35 = '#FF8F73';
var $075e143f94feb311$export$60847d42f9da92a6 = '#FF7452';
var $075e143f94feb311$export$4a7404f376229999 = '#FF5630';
var $075e143f94feb311$export$2010d0fb4295b346 = '#DE350B';
var $075e143f94feb311$export$2837b5a1a71d5c02 = '#BF2600';
var $075e143f94feb311$export$8d9596b529bbb9cf = '#FFFAE6';
var $075e143f94feb311$export$41060a744ab0b7ae = '#FFF0B3';
var $075e143f94feb311$export$1cc05bbbf340e559 = '#FFE380';
var $075e143f94feb311$export$5aae31392d72caaa = '#FFC400';
var $075e143f94feb311$export$c6930421db9fa514 = '#FFAB00';
var $075e143f94feb311$export$59619663aa6500fb = '#FF991F';
var $075e143f94feb311$export$874739ea9e379ab6 = '#FF8B00';
var $075e143f94feb311$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $075e143f94feb311$export$69a3bf21b9686c2b = '#ABF5D1';
var $075e143f94feb311$export$afbce1382ec95f73 = '#79F2C0';
var $075e143f94feb311$export$747d86715d4175de = '#57D9A3';
var $075e143f94feb311$export$940e1f69e873f202 = '#36B37E';
var $075e143f94feb311$export$a49394138f7b8e85 = '#00875A';
var $075e143f94feb311$export$6fa04827ac68a4fb = '#006644';
var $075e143f94feb311$export$226de0355ed012f8 = '#DEEBFF';
var $075e143f94feb311$export$8c13c2ee36917869 = '#B3D4FF';
var $075e143f94feb311$export$ecfc1dff386a3e7a = '#4C9AFF';
var $075e143f94feb311$export$215b7063051591f1 = '#2684FF';
var $075e143f94feb311$export$e62e8919cca44969 = '#0065FF';
var $075e143f94feb311$export$b3de0ae08da2ce64 = '#0052CC';
var $075e143f94feb311$export$a6ee3d71bc067634 = '#0747A6';
var $075e143f94feb311$export$67f15409e87642a1 = '#669DF1';
var $075e143f94feb311$export$f0539dbc42dbb067 = '#8FB8F6';
var $075e143f94feb311$export$363e4475840015bb = '#EAE6FF';
var $075e143f94feb311$export$4b0a4417ed59760f = '#C0B6F2';
var $075e143f94feb311$export$6011520a64d9a187 = '#998DD9';
var $075e143f94feb311$export$a7175d4e9206bc80 = '#8777D9';
var $075e143f94feb311$export$b48405b95304b5a1 = '#6554C0';
var $075e143f94feb311$export$c71e4279dd54a18d = '#5243AA';
var $075e143f94feb311$export$147899de772240ec = '#403294';
var $075e143f94feb311$export$2cf711fe14c66f06 = '#E6FCFF';
var $075e143f94feb311$export$7a8f4d33f6f9772c = '#B3F5FF';
var $075e143f94feb311$export$776c9c497ef08533 = '#79E2F2';
var $075e143f94feb311$export$69cb3ca10c1e330e = '#00C7E6';
var $075e143f94feb311$export$9dc1ef0f3f48059b = '#00B8D9';
var $075e143f94feb311$export$7c835c78b6fcdef8 = '#00A3BF';
var $075e143f94feb311$export$6036577f95c3877e = '#008DA6';
var $075e143f94feb311$export$29a4f05edc054374 = '#FFFFFF';
var $075e143f94feb311$export$e655ef011c4aa1a2 = '#FAFBFC';
var $075e143f94feb311$export$9fdfb749e33cdf97 = '#F4F5F7';
var $075e143f94feb311$export$3e51e8f1440314ba = '#EBECF0';
var $075e143f94feb311$export$1ce2d1575d444ceb = '#DFE1E6';
var $075e143f94feb311$export$8754fc7e6d8b3000 = '#C1C7D0';
var $075e143f94feb311$export$c2e91cbeada39b8b = '#B3BAC5';
var $075e143f94feb311$export$5f71e19f3a7ad9de = '#A5ADBA';
var $075e143f94feb311$export$eaa8c8a70ac22806 = '#97A0AF';
var $075e143f94feb311$export$7c87d337fb91a97d = '#8993A4';
var $075e143f94feb311$export$d6447c357493214f = '#7A869A';
var $075e143f94feb311$export$f563ee71e9ee74cd = '#6B778C';
var $075e143f94feb311$export$e2ef2124cf4024b1 = '#5E6C84';
var $075e143f94feb311$export$eece5f492e429f08 = '#505F79';
var $075e143f94feb311$export$c39c0fe0f26207ae = '#42526E';
var $075e143f94feb311$export$7090862dc3038a9f = '#344563';
var $075e143f94feb311$export$ad0bacf983b7ddaa = '#253858';
var $075e143f94feb311$export$7d61b15e0da132af = '#172B4D';
var $075e143f94feb311$export$fbda843f0a27fe96 = '#091E42';
var $075e143f94feb311$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $075e143f94feb311$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $075e143f94feb311$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $075e143f94feb311$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $075e143f94feb311$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $075e143f94feb311$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $075e143f94feb311$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $075e143f94feb311$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $075e143f94feb311$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $075e143f94feb311$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $075e143f94feb311$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $075e143f94feb311$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $075e143f94feb311$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $075e143f94feb311$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $075e143f94feb311$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $075e143f94feb311$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $075e143f94feb311$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $075e143f94feb311$export$2f6319cf7d736c2a = '#E6EDFA';
var $075e143f94feb311$export$95126bc8884d6634 = '#DCE5F5';
var $075e143f94feb311$export$8338d8c35d44ff1 = '#CED9EB';
var $075e143f94feb311$export$5368d76ae4fbbda7 = '#B8C7E0';
var $075e143f94feb311$export$9f0a771d16ec8d36 = '#ABBBD6';
var $075e143f94feb311$export$abcf8c38338b4aa5 = '#9FB0CC';
var $075e143f94feb311$export$97e81faa16a182c7 = '#8C9CB8';
var $075e143f94feb311$export$bfe21c59123ecf33 = '#7988A3';
var $075e143f94feb311$export$ee82aa2ea6a1558 = '#67758F';
var $075e143f94feb311$export$682927c6ed76be02 = '#56637A';
var $075e143f94feb311$export$91fd9994c5be9757 = '#455166';
var $075e143f94feb311$export$d281fbfe3cff2df6 = '#3B475C';
var $075e143f94feb311$export$3902c91d8b98a753 = '#313D52';
var $075e143f94feb311$export$8e8133c1ba5845b5 = '#283447';
var $075e143f94feb311$export$33ff357f6620b39 = '#202B3D';
var $075e143f94feb311$export$633847cf062b69e0 = '#1B2638';
var $075e143f94feb311$export$9776a6e503bdbf76 = '#121A29';
var $075e143f94feb311$export$6c813d5160dff5db = '#0E1624';
var $075e143f94feb311$export$3d4f271a500072a = '#0D1424';
var $075e143f94feb311$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $075e143f94feb311$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $075e143f94feb311$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $075e143f94feb311$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $075e143f94feb311$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $075e143f94feb311$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $075e143f94feb311$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $075e143f94feb311$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $075e143f94feb311$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $075e143f94feb311$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $075e143f94feb311$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $075e143f94feb311$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $075e143f94feb311$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $075e143f94feb311$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $075e143f94feb311$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $075e143f94feb311$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $075e143f94feb311$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $075e143f94feb311$export$d2adc5dedf09fced = '#292A2E';
var $075e143f94feb311$export$f51762073d2bb381 = '#94C748';
var $075e143f94feb311$export$95e26d54def96891 = '#B3DF72';

});

parcelRegister("jllqM", function(module, exports) {
$parcel$export(module.exports, "presetSizes", function () { return $e1509a39136a530d$export$4e9f1640bbe7a1a8; });
var $e1509a39136a530d$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});




parcelRegister("jBgJs", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e44e73af2907f664$export$2e2bcd8739ae039; });
/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $axrVF = parcelRequire("axrVF");

var $1oC0p = parcelRequire("1oC0p");
var $e44e73af2907f664$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    beforeIcon: "_1he91b66 _w795v77o",
    afterIcon: "_1he9v77o _w7951b66",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $e44e73af2907f664$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, isLoading = _ref.isLoading, position = _ref.position;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        className: (0, $axrVF.default)([
            $e44e73af2907f664$var$styles.common,
            type === 'text' && $e44e73af2907f664$var$styles.text,
            type === 'icon' && $e44e73af2907f664$var$styles.icon,
            isLoading && $e44e73af2907f664$var$styles.fade,
            position === 'before' && $e44e73af2907f664$var$styles.beforeIcon,
            position === 'after' && $e44e73af2907f664$var$styles.afterIcon
        ])
    }, children);
};
var $e44e73af2907f664$export$2e2bcd8739ae039 = $e44e73af2907f664$var$Content;

});

parcelRegister("7kLyP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $556f4b404f04f294$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
function $556f4b404f04f294$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $556f4b404f04f294$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, $556f4b404f04f294$var$isIconRenderProp(Icon) ? Icon({
        label: '',
        color: 'currentColor'
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Icon, {
        label: "",
        color: 'currentColor'
    }));
};
var $556f4b404f04f294$export$2e2bcd8739ae039 = $556f4b404f04f294$var$IconRenderer;

});


parcelRegister("aKeh7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::73df1d388ecc854df8671cdf3cc68b05>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7d29460165ecb880$var$_react = $7d29460165ecb880$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $7d29460165ecb880$var$_baseNew = $7d29460165ecb880$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $7d29460165ecb880$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPauseOverlay".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pause video when icon is overlayed on Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7d29460165ecb880$var$VideoPauseOverlayIcon = (props)=>/*#__PURE__*/ $7d29460165ecb880$var$_react.default.createElement($7d29460165ecb880$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm7 0a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$7d29460165ecb880$var$VideoPauseOverlayIcon.displayName = 'VideoPauseOverlayIcon';
var $7d29460165ecb880$var$_default = module.exports.default = $7d29460165ecb880$var$VideoPauseOverlayIcon;

});

parcelRegister("1iN19", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d2e3c8fcba4e62054ef71c09ada81e61>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f2d7ec4a24de794$var$_react = $0f2d7ec4a24de794$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $0f2d7ec4a24de794$var$_baseNew = $0f2d7ec4a24de794$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $0f2d7ec4a24de794$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPlayOverlay".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for play video when icon is overlayed on Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0f2d7ec4a24de794$var$VideoPlayOverlayIcon = (props)=>/*#__PURE__*/ $0f2d7ec4a24de794$var$_react.default.createElement($0f2d7ec4a24de794$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.112C2 1.592 3.63.627 4.963 1.36l8.902 4.888c1.383.76 1.383 2.747 0 3.506l-8.902 4.888C3.63 15.373 2 14.408 2 12.888z" clip-rule="evenodd"/>`
    }, props));
$0f2d7ec4a24de794$var$VideoPlayOverlayIcon.displayName = 'VideoPlayOverlayIcon';
var $0f2d7ec4a24de794$var$_default = module.exports.default = $0f2d7ec4a24de794$var$VideoPlayOverlayIcon;

});

parcelRegister("7Xn5M", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::821d8a868bec01d1b9c95a45239911fb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5caff4b827f13cb1$var$_react = $5caff4b827f13cb1$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $5caff4b827f13cb1$var$_baseNew = $5caff4b827f13cb1$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $5caff4b827f13cb1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Premium".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for premium features.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5caff4b827f13cb1$var$PremiumIcon = (props)=>/*#__PURE__*/ $5caff4b827f13cb1$var$_react.default.createElement($5caff4b827f13cb1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 3v1.5H3V3h1.5V1.5H3V0H1.5v1.5H0V3zM8 1c.31 0 .587.19.699.478l1.63 4.193 4.193 1.63a.75.75 0 0 1 0 1.398l-4.193 1.63-1.63 4.193a.75.75 0 0 1-1.398 0l-1.63-4.193L1.478 8.7a.75.75 0 0 1 0-1.398l4.193-1.63L7.3 1.478A.75.75 0 0 1 8 1m0 2.82L6.949 6.521a.75.75 0 0 1-.427.427L3.819 8l2.703 1.051a.75.75 0 0 1 .427.427L8 12.181l1.051-2.703a.75.75 0 0 1 .427-.427L12.181 8 9.478 6.949a.75.75 0 0 1-.427-.427zm5 10.68V16h1.5v-1.5H16V13h-1.5v-1.5H13V13h-1.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$5caff4b827f13cb1$var$PremiumIcon.displayName = 'PremiumIcon';
var $5caff4b827f13cb1$var$_default = module.exports.default = $5caff4b827f13cb1$var$PremiumIcon;

});

parcelRegister("53VCz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11b8e18b02050eefbe32dafc654ee453>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3af9ede7fd56ccc9$var$_react = $3af9ede7fd56ccc9$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $3af9ede7fd56ccc9$var$_baseNew = $3af9ede7fd56ccc9$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $3af9ede7fd56ccc9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3af9ede7fd56ccc9$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $3af9ede7fd56ccc9$var$_react.default.createElement($3af9ede7fd56ccc9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$3af9ede7fd56ccc9$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $3af9ede7fd56ccc9$var$_default = module.exports.default = $3af9ede7fd56ccc9$var$ArrowRightIcon;

});

parcelRegister("bIY3n", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e570c2c471e9f2c44e5e57e4d5245eb9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8892631fc819236e$var$_react = $8892631fc819236e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $8892631fc819236e$var$_baseNew = $8892631fc819236e$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $8892631fc819236e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Add".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8892631fc819236e$var$AddIcon = (props)=>/*#__PURE__*/ $8892631fc819236e$var$_react.default.createElement($8892631fc819236e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 8.75V15h1.5V8.75H15v-1.5H8.75V1h-1.5v6.25H1v1.5z" clip-rule="evenodd"/>`
    }, props));
$8892631fc819236e$var$AddIcon.displayName = 'AddIcon';
var $8892631fc819236e$var$_default = module.exports.default = $8892631fc819236e$var$AddIcon;

});

parcelRegister("7dskR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $540fba263cbb9f47$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $jN4m6 = parcelRequire("jN4m6");

var $1xo8q = parcelRequire("1xo8q");
var $540fba263cbb9f47$var$justifyContentMap = {
    start: (0, $3dJ4i.css)({
        justifyContent: 'start'
    }),
    center: (0, $3dJ4i.css)({
        justifyContent: 'center'
    }),
    end: (0, $3dJ4i.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $3dJ4i.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $3dJ4i.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $3dJ4i.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $3dJ4i.css)({
        justifyContent: 'stretch'
    })
};
var $540fba263cbb9f47$var$justifyItemsMap = {
    start: (0, $3dJ4i.css)({
        justifyItems: 'start'
    }),
    center: (0, $3dJ4i.css)({
        justifyItems: 'center'
    }),
    end: (0, $3dJ4i.css)({
        justifyItems: 'end'
    }),
    stretch: (0, $3dJ4i.css)({
        justifyItems: 'stretch'
    })
};
var $540fba263cbb9f47$var$alignContentMap = {
    start: (0, $3dJ4i.css)({
        alignContent: 'start'
    }),
    center: (0, $3dJ4i.css)({
        alignContent: 'center'
    }),
    end: (0, $3dJ4i.css)({
        alignContent: 'end'
    }),
    'space-between': (0, $3dJ4i.css)({
        alignContent: 'space-between'
    }),
    'space-around': (0, $3dJ4i.css)({
        alignContent: 'space-around'
    }),
    'space-evenly': (0, $3dJ4i.css)({
        alignContent: 'space-evenly'
    }),
    stretch: (0, $3dJ4i.css)({
        alignContent: 'stretch'
    })
};
var $540fba263cbb9f47$var$alignItemsMap = {
    start: (0, $3dJ4i.css)({
        alignItems: 'start'
    }),
    center: (0, $3dJ4i.css)({
        alignItems: 'center'
    }),
    baseline: (0, $3dJ4i.css)({
        alignItems: 'baseline'
    }),
    end: (0, $3dJ4i.css)({
        alignItems: 'end'
    })
};
var $540fba263cbb9f47$var$baseStyles = (0, $3dJ4i.css)({
    display: 'grid',
    boxSizing: 'border-box'
});
var $540fba263cbb9f47$var$gridAutoFlowMap = {
    row: (0, $3dJ4i.css)({
        gridAutoFlow: 'row'
    }),
    column: (0, $3dJ4i.css)({
        gridAutoFlow: 'column'
    }),
    dense: (0, $3dJ4i.css)({
        gridAutoFlow: 'dense'
    }),
    'row dense': (0, $3dJ4i.css)({
        gridAutoFlow: 'row dense'
    }),
    'column dense': (0, $3dJ4i.css)({
        gridAutoFlow: 'column dense'
    })
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ var $540fba263cbb9f47$var$Grid = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignItems, alignContent = _ref.alignContent, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, id = _ref.id, role = _ref.role, testId = _ref.testId, autoFlow = _ref.autoFlow, gridTemplateAreas = _ref.templateAreas, gridTemplateRows = _ref.templateRows, gridTemplateColumns = _ref.templateColumns, xcss = _ref.xcss;
    var Component = as || 'div';
    var xcssClassName = xcss && (0, $1xo8q.parseXcss)(xcss);
    var style = gridTemplateAreas || gridTemplateColumns || gridTemplateRows ? Object.assign({}, {
        gridTemplateAreas: gridTemplateAreas ? gridTemplateAreas.map(function(str) {
            return "\"".concat(str, "\"");
        }).join('\n') : undefined,
        gridTemplateColumns: gridTemplateColumns,
        gridTemplateRows: gridTemplateRows
    }) : undefined;
    return (0, $3dJ4i.jsx)(Component, {
        id: id,
        role: role,
        style: style,
        css: [
            $540fba263cbb9f47$var$baseStyles,
            gap && (0, $jN4m6.spaceStylesMap).gap[gap],
            columnGap && (0, $jN4m6.spaceStylesMap).columnGap[columnGap],
            rowGap && (0, $jN4m6.spaceStylesMap).rowGap[rowGap],
            alignItems && $540fba263cbb9f47$var$alignItemsMap[alignItems],
            alignContent && $540fba263cbb9f47$var$alignContentMap[alignContent],
            justifyContent && $540fba263cbb9f47$var$justifyContentMap[justifyContent],
            autoFlow && $540fba263cbb9f47$var$gridAutoFlowMap[autoFlow],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            xcssClassName && xcssClassName
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$540fba263cbb9f47$var$Grid.displayName = 'Grid';
var $540fba263cbb9f47$export$2e2bcd8739ae039 = $540fba263cbb9f47$var$Grid;

});

parcelRegister("lWOKW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ffa662df7c16fff2$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $2qaZZ = parcelRequire("2qaZZ");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $gJJny = parcelRequire("gJJny");

var $lPa8d = parcelRequire("lPa8d");

var $mWKBO = parcelRequire("mWKBO");

var $hIewe = parcelRequire("hIewe");
var $h4AmC = parcelRequire("h4AmC");
var $1sBRT = parcelRequire("1sBRT");
var $jessv = parcelRequire("jessv");
var $ffa662df7c16fff2$var$_excluded = [
    "isChecked",
    "isDisabled",
    "isInvalid",
    "defaultChecked",
    "isIndeterminate",
    "size",
    "onChange",
    "analyticsContext",
    "label",
    "name",
    "value",
    "isRequired",
    "testId"
];
/* eslint-disable @atlaskit/design-system/no-nested-styles */ var $ffa662df7c16fff2$var$checkboxStyles = (0, $3dJ4i.css)({
    width: '100%',
    height: '100%',
    margin: "var(--ds-space-0, 0px)",
    appearance: 'none',
    border: 'none',
    gridArea: '1 / 1 / 2 / 2',
    opacity: 0,
    outline: 'none',
    '& + svg': {
        /**
     *  Change the variables --checkbox-background-color, --checkbox-border-color
     *  and --checkbox-tick-color according to user interactions.
     *  All other variables are constant.
     *  All styles from the input target the sibling svg.
     */ '--checkbox-background-color': 'var(--local-background)',
        '--checkbox-border-color': 'var(--local-border)',
        '--checkbox-tick-color': 'var(--local-tick-rest)',
        color: 'var(--checkbox-background-color)',
        fill: 'var(--checkbox-tick-color)',
        gridArea: '1 / 1 / 2 / 2',
        pointerEvents: 'none',
        transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
        'rect:first-of-type': {
            stroke: 'var(--checkbox-border-color)',
            strokeWidth: (0, $mWKBO.getBooleanFF)('platform.design-system-team.update-border-radio-checkbox_7askv') ? "var(--ds-border-width, 1px)" : 2,
            transition: 'stroke 0.2s ease-in-out'
        }
    },
    '&&:focus + svg, &&:checked:focus + svg': {
        '--checkbox-border-color': 'var(--local-border-focus)'
    },
    '&:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-hover)',
        '--checkbox-border-color': 'var(--local-border-hover)'
    },
    '&:checked:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-checked-hover)',
        '--checkbox-border-color': 'var(--local-border-checked-hover)'
    },
    '&:checked + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    '&[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-invalid)'
    },
    '&:checked[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-checked-invalid)'
    },
    '&:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)'
    },
    '&:checked:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)',
        '--checkbox-tick-color': 'var(--local-tick-active)'
    },
    '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        cursor: 'not-allowed',
        pointerEvents: 'none'
    },
    '&:disabled:checked + svg': {
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    '@media screen and (forced-colors: active)': {
        '& + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        '&:checked + svg, &:checked:hover + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        '&:focus + svg rect:first-of-type': {
            stroke: 'Highlight'
        },
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'GrayText',
            '--checkbox-tick-color': 'GrayText'
        }
    }
});
/* eslint-enable @atlaskit/design-system/no-nested-styles */ /**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ var $ffa662df7c16fff2$var$Checkbox = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function Checkbox(props, ref) {
    var isCheckedProp = props.isChecked, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isInvalid = props.isInvalid, isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid, _props$defaultChecked = props.defaultChecked, defaultChecked = _props$defaultChecked === void 0 ? false : _props$defaultChecked, _props$isIndeterminat = props.isIndeterminate, isIndeterminate = _props$isIndeterminat === void 0 ? false : _props$isIndeterminat, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, onChangeProps = props.onChange, analyticsContext = props.analyticsContext, label = props.label, name = props.name, value = props.value, isRequired = props.isRequired, testId = props.testId, rest = (0, $gnQ3X.default)(props, $ffa662df7c16fff2$var$_excluded);
    var _useState = (0, $1oC0p.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked), _useState2 = (0, $2qaZZ.default)(_useState, 2), isCheckedState = _useState2[0], setIsCheckedState = _useState2[1];
    var onChange = (0, $1oC0p.useCallback)(function(e, analyticsEvent) {
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    var onChangeAnalytics = (0, $gJJny.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "@atlaskit/checkbox",
        packageVersion: "12.6.11"
    });
    var internalRef = (0, $1oC0p.useRef)(null);
    var mergedRefs = (0, $lPa8d.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    var isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    return (0, $3dJ4i.jsx)((0, $h4AmC.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? "".concat(rest.id, "-label") : undefined,
        testId: testId && "".concat(testId, "--checkbox-label")
    }, (0, $3dJ4i.jsx)("input", (0, $c9bqK.default)({}, rest, {
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        css: $ffa662df7c16fff2$var$checkboxStyles,
        onChange: onChangeAnalytics,
        "aria-checked": isIndeterminate ? 'mixed' : isChecked,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && "".concat(testId, "--hidden-checkbox"),
        "data-invalid": isInvalid ? 'true' : undefined
    })), (0, $3dJ4i.jsx)((0, $hIewe.default), {
        size: size,
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && (0, $3dJ4i.jsx)((0, $1sBRT.default), null, label, isRequired && (0, $3dJ4i.jsx)((0, $jessv.default), null)));
}));
$ffa662df7c16fff2$var$Checkbox.displayName = 'Checkbox';
var $ffa662df7c16fff2$export$2e2bcd8739ae039 = $ffa662df7c16fff2$var$Checkbox;

});
parcelRegister("lPa8d", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fe363853292213b8$export$2e2bcd8739ae039; });
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $fe363853292213b8$export$2e2bcd8739ae039(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("mWKBO", function(module, exports) {
$parcel$export(module.exports, "getBooleanFF", function () { return $044fa0dd75e56d89$export$470e5c2be1411c89; });

var $eM5qO = parcelRequire("eM5qO");
function $044fa0dd75e56d89$export$ba05d765b8392e5e(flagResolver) {
    (0, $eM5qO.setBooleanResolver)(flagResolver);
}
function $044fa0dd75e56d89$export$470e5c2be1411c89(name) {
    return (0, $eM5qO.resolveBooleanFlag)(name);
}

});
parcelRegister("eM5qO", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", function () { return $ac19c2f114c4a454$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $ac19c2f114c4a454$export$6333b6aff9fc6275; });

var $1xWAc = parcelRequire("1xWAc");

var $7t0tI = parcelRequire("7t0tI");
var $ac19c2f114c4a454$var$pkgName = '@atlaskit/platform-feature-flags';
var $ac19c2f114c4a454$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $ac19c2f114c4a454$var$hasProcessEnv = typeof $7t0tI !== 'undefined' && typeof $7t0tI.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $ac19c2f114c4a454$var$ENV_ENABLE_PLATFORM_FF = $ac19c2f114c4a454$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $ac19c2f114c4a454$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $ac19c2f114c4a454$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $ac19c2f114c4a454$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $ac19c2f114c4a454$var$ENV_ENABLE_PLATFORM_FF || $ac19c2f114c4a454$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $ac19c2f114c4a454$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $ac19c2f114c4a454$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$ac19c2f114c4a454$var$globalVar[$ac19c2f114c4a454$export$7e41b1b2bdee3f98] = $ac19c2f114c4a454$var$globalVar[$ac19c2f114c4a454$export$7e41b1b2bdee3f98] || $ac19c2f114c4a454$var$DEFAULT_PFF_GLOBAL;
function $ac19c2f114c4a454$export$f2b591175b3e424c(resolver) {
    $ac19c2f114c4a454$var$globalVar[$ac19c2f114c4a454$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2;
}
function $ac19c2f114c4a454$export$6333b6aff9fc6275(flagKey) {
    if ($ac19c2f114c4a454$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $1xWAc.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $ac19c2f114c4a454$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL3;
        var result = (_globalVar$PFF_GLOBAL3 = $ac19c2f114c4a454$var$globalVar[$ac19c2f114c4a454$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("1xWAc", function(module, exports) {
$parcel$export(module.exports, "debug", function () { return $120650dbfc20a854$export$1c9f709888824e05; });
var $120650dbfc20a854$var$_ref, $120650dbfc20a854$var$_globalThis$process, $120650dbfc20a854$var$_globalThis$process$e, $120650dbfc20a854$var$_globalThis$process2, $120650dbfc20a854$var$_globalThis$process2$;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $120650dbfc20a854$var$TESTS_MODE = ($120650dbfc20a854$var$_ref = (globalThis === null || globalThis === void 0 ? void 0 : ($120650dbfc20a854$var$_globalThis$process = globalThis.process) === null || $120650dbfc20a854$var$_globalThis$process === void 0 ? void 0 : ($120650dbfc20a854$var$_globalThis$process$e = $120650dbfc20a854$var$_globalThis$process.env) === null || $120650dbfc20a854$var$_globalThis$process$e === void 0 ? void 0 : $120650dbfc20a854$var$_globalThis$process$e.JEST_WORKER_ID) !== undefined, $120650dbfc20a854$var$_ref !== void 0) ? $120650dbfc20a854$var$_ref : false;
var $120650dbfc20a854$var$DEBUG_MODE = !$120650dbfc20a854$var$TESTS_MODE && (globalThis === null || globalThis === void 0 ? void 0 : ($120650dbfc20a854$var$_globalThis$process2 = globalThis.process) === null || $120650dbfc20a854$var$_globalThis$process2 === void 0 ? void 0 : ($120650dbfc20a854$var$_globalThis$process2$ = $120650dbfc20a854$var$_globalThis$process2.env) === null || $120650dbfc20a854$var$_globalThis$process2$ === void 0 ? void 0 : $120650dbfc20a854$var$_globalThis$process2$.NODE_ENV) !== 'production';
var $120650dbfc20a854$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$120650dbfc20a854$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("hIewe", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ce51ced9a5cc497a$export$2e2bcd8739ae039; });
/**  @jsx jsx */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $e2V0T = parcelRequire("e2V0T");
function $ce51ced9a5cc497a$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return (0, $3dJ4i.jsx)("rect", {
        fill: "inherit",
        x: "8",
        y: "11",
        width: "8",
        height: "2",
        rx: "1"
    });
    if (isChecked) return (0, $3dJ4i.jsx)("path", {
        d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ var $ce51ced9a5cc497a$var$CheckboxIcon = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref) {
    var size = _ref.size, isIndeterminate = _ref.isIndeterminate, isChecked = _ref.isChecked;
    var icon = (0, $1oC0p.useMemo)(function() {
        return $ce51ced9a5cc497a$var$getIcon(isIndeterminate, isChecked);
    }, [
        isIndeterminate,
        isChecked
    ]);
    return (0, $3dJ4i.jsx)((0, $e2V0T.default), {
        label: "",
        size: size,
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, (0, $3dJ4i.jsx)("g", {
        fillRule: "evenodd"
    }, (0, $3dJ4i.jsx)("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $ce51ced9a5cc497a$export$2e2bcd8739ae039 = $ce51ced9a5cc497a$var$CheckboxIcon;

});
parcelRegister("e2V0T", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a39d7a46070a4568$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $7gyMa = parcelRequire("7gyMa");

var $2qiIe = parcelRequire("2qiIe");

var $7m1q2 = parcelRequire("7m1q2");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $a39d7a46070a4568$var$svgStyles = (0, $3dJ4i.css)((0, $7m1q2.commonSVGStyles));
/**
 * __SVG__
 *
 * An icon is used as a visual representation of common actions and commands to provide context.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-svgs)
 */ var $a39d7a46070a4568$var$SVG = /*#__PURE__*/ (0, $1oC0p.memo)(function SVG(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 'medium' : _ref$size, label = _ref.label, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, testId = _ref.testId, children = _ref.children;
    var _useGlobalTheme = (0, $7gyMa.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $3dJ4i.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            fill: secondaryColor || (0, $2qiIe.getBackground)(mode)
        },
        css: [
            $a39d7a46070a4568$var$svgStyles,
            (0, $7m1q2.sizeStyleMap)[size]
        ],
        "data-testid": testId,
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation'
    }, children);
});
var $a39d7a46070a4568$export$2e2bcd8739ae039 = $a39d7a46070a4568$var$SVG;

});
parcelRegister("2qiIe", function(module, exports) {
$parcel$export(module.exports, "getBackground", function () { return $1c3c86630911910b$export$18cb9425622d4e06; });
var $1c3c86630911910b$var$themedBackground = {
    light: "var(--ds-surface, #FFFFFF)",
    dark: "var(--ds-surface, #1B2638)"
};
var $1c3c86630911910b$export$18cb9425622d4e06 = function getBackground() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'light';
    return $1c3c86630911910b$var$themedBackground[mode];
};

});

parcelRegister("7m1q2", function(module, exports) {
$parcel$export(module.exports, "commonSVGStyles", function () { return $0161bca626919ed6$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "sizeStyleMap", function () { return $0161bca626919ed6$export$ef0ad74202575b64; });

var $7NHwz = parcelRequire("7NHwz");

var $3dJ4i = parcelRequire("3dJ4i");
var $0161bca626919ed6$export$16374db1c3e6dfba = {
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: 'currentColor'
    }
};
var $0161bca626919ed6$var$smallStyles = (0, $3dJ4i.css)((0, $7NHwz.dimensions).small);
var $0161bca626919ed6$var$mediumStyles = (0, $3dJ4i.css)((0, $7NHwz.dimensions).medium);
var $0161bca626919ed6$var$largeStyles = (0, $3dJ4i.css)((0, $7NHwz.dimensions).large);
var $0161bca626919ed6$var$xlargeStyles = (0, $3dJ4i.css)((0, $7NHwz.dimensions).xlarge);
var $0161bca626919ed6$export$ef0ad74202575b64 = {
    small: $0161bca626919ed6$var$smallStyles,
    medium: $0161bca626919ed6$var$mediumStyles,
    large: $0161bca626919ed6$var$largeStyles,
    xlarge: $0161bca626919ed6$var$xlargeStyles
};
var $0161bca626919ed6$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $7NHwz.dimensions)[size];
    return undefined;
};

});
parcelRegister("7NHwz", function(module, exports) {
$parcel$export(module.exports, "dimensions", function () { return $5adedf072958a79e$export$62ad7b0c781000e9; });
var $5adedf072958a79e$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
var $5adedf072958a79e$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
var $5adedf072958a79e$export$62ad7b0c781000e9 = {
    small: {
        width: $5adedf072958a79e$export$c647cb0ee6e282fe.small,
        height: $5adedf072958a79e$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $5adedf072958a79e$export$c647cb0ee6e282fe.medium,
        height: $5adedf072958a79e$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $5adedf072958a79e$export$c647cb0ee6e282fe.large,
        height: $5adedf072958a79e$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $5adedf072958a79e$export$c647cb0ee6e282fe.xlarge,
        height: $5adedf072958a79e$export$c647cb0ee6e282fe.xlarge
    }
};

});




parcelRegister("h4AmC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c6df047995b8adca$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $3dJ4i = parcelRequire("3dJ4i");

var $3c7rQ = parcelRequire("3c7rQ");

var $7gyMa = parcelRequire("7gyMa");

var $4Trtv = parcelRequire("4Trtv");

var $finpS = parcelRequire("finpS");
var $c6df047995b8adca$var$labelStyles = (0, $3dJ4i.css)({
    display: 'grid',
    gridAutoColumns: '1fr',
    gridAutoRows: 'min-content',
    color: "var(--ds-text, ".concat((0, $3c7rQ.N900), ")"),
    cursor: 'default',
    fontFamily: "var(--ds-font-family-sans, ".concat((0, $4Trtv.fontFamily), ")")
});
var $c6df047995b8adca$var$textLabelLayoutStyles = (0, $3dJ4i.css)({
    gap: "var(--ds-space-0, 0px)".concat(" ", "var(--ds-space-050, 4px)"),
    gridTemplateColumns: 'min-content auto'
});
var $c6df047995b8adca$var$disabledStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text-disabled, ".concat((0, $3c7rQ.N80), ")"),
    cursor: 'not-allowed'
});
var $c6df047995b8adca$var$themeStyles = {
    light: (0, $3dJ4i.css)({
        /**
     * Background
     */ '--local-background': (0, $finpS.default).light.boxColor.rest,
        '--local-background-active': (0, $finpS.default).light.boxColor.active,
        '--local-background-checked': (0, $finpS.default).light.boxColor.checked,
        '--local-background-checked-hover': (0, $finpS.default).light.boxColor.hoveredAndChecked,
        '--local-background-disabled': (0, $finpS.default).light.boxColor.disabled,
        '--local-background-hover': (0, $finpS.default).light.boxColor.hovered,
        /**
     * Border
     */ '--local-border': (0, $finpS.default).light.borderColor.rest,
        '--local-border-active': (0, $finpS.default).light.borderColor.active,
        '--local-border-checked': (0, $finpS.default).light.borderColor.checked,
        '--local-border-checked-hover': (0, $finpS.default).light.borderColor.hoveredAndChecked,
        '--local-border-checked-invalid': (0, $finpS.default).light.borderColor.invalidAndChecked,
        '--local-border-disabled': (0, $finpS.default).light.borderColor.disabled,
        '--local-border-focus': (0, $finpS.default).light.borderColor.focused,
        '--local-border-hover': (0, $finpS.default).light.borderColor.hovered,
        '--local-border-invalid': (0, $finpS.default).light.borderColor.invalid,
        /**
     * Tick
     */ '--local-tick-active': (0, $finpS.default).light.tickColor.activeAndChecked,
        '--local-tick-checked': (0, $finpS.default).light.tickColor.checked,
        '--local-tick-disabled': (0, $finpS.default).light.tickColor.disabledAndChecked,
        '--local-tick-rest': 'transparent'
    }),
    dark: (0, $3dJ4i.css)({
        /**
     * Background
     */ '--local-background': (0, $finpS.default).dark.boxColor.rest,
        '--local-background-active': (0, $finpS.default).dark.boxColor.active,
        '--local-background-checked': (0, $finpS.default).dark.boxColor.checked,
        '--local-background-checked-hover': (0, $finpS.default).dark.boxColor.hoveredAndChecked,
        '--local-background-disabled': (0, $finpS.default).dark.boxColor.disabled,
        '--local-background-hover': (0, $finpS.default).dark.boxColor.hovered,
        /**
     * Border
     */ '--local-border': (0, $finpS.default).dark.borderColor.rest,
        '--local-border-active': (0, $finpS.default).dark.borderColor.active,
        '--local-border-checked': (0, $finpS.default).dark.borderColor.checked,
        '--local-border-checked-hover': (0, $finpS.default).dark.borderColor.hoveredAndChecked,
        '--local-border-checked-invalid': (0, $finpS.default).dark.borderColor.invalidAndChecked,
        '--local-border-disabled': (0, $finpS.default).dark.borderColor.disabled,
        '--local-border-focus': (0, $finpS.default).dark.borderColor.focused,
        '--local-border-hover': (0, $finpS.default).dark.borderColor.hovered,
        '--local-border-invalid': (0, $finpS.default).dark.borderColor.invalid,
        /**
     * Tick
     */ '--local-tick-active': (0, $finpS.default).dark.tickColor.activeAndChecked,
        '--local-tick-checked': (0, $finpS.default).dark.tickColor.checked,
        '--local-tick-disabled': (0, $finpS.default).dark.tickColor.disabledAndChecked,
        '--local-tick-rest': 'transparent'
    })
};
function $c6df047995b8adca$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, testId = _ref.testId, label = _ref.label, id = _ref.id;
    var _useGlobalTheme = (0, $7gyMa.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $3dJ4i.jsx)("label", {
        css: [
            $c6df047995b8adca$var$labelStyles,
            label && $c6df047995b8adca$var$textLabelLayoutStyles,
            isDisabled && $c6df047995b8adca$var$disabledStyles,
            mode === 'light' && $c6df047995b8adca$var$themeStyles.light,
            mode === 'dark' && $c6df047995b8adca$var$themeStyles.dark
        ],
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});
parcelRegister("4Trtv", function(module, exports) {
$parcel$export(module.exports, "fontFamily", function () { return $39019c6be36422e1$export$a5975749f0374264; });

var $hnR5n = parcelRequire("hnR5n");
var $39019c6be36422e1$export$a5975749f0374264 = (0, $hnR5n.fontFamily)();

});

parcelRegister("finpS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b22ab37906e5b0ff$export$2e2bcd8739ae039; });

var $mWKBO = parcelRequire("mWKBO");

var $3c7rQ = parcelRequire("3c7rQ");
var $b22ab37906e5b0ff$var$theme = {
    light: {
        borderColor: {
            rest: (0, $mWKBO.getBooleanFF)('platform.design-system-team.update-border-radio-checkbox_7askv') ? "var(--ds-border-bold, ".concat((0, $3c7rQ.N100), ")") : "var(--ds-border-input, ".concat((0, $3c7rQ.N40), ")"),
            hovered: (0, $mWKBO.getBooleanFF)('platform.design-system-team.update-border-radio-checkbox_7askv') ? "var(--ds-border-bold, ".concat((0, $3c7rQ.N100), ")") : "var(--ds-border-input, ".concat((0, $3c7rQ.N40), ")"),
            disabled: "var(--ds-background-disabled, ".concat((0, $3c7rQ.N20), ")"),
            checked: "var(--ds-background-selected-bold, ".concat((0, $3c7rQ.B400), ")"),
            active: "var(--ds-border, ".concat((0, $3c7rQ.B50), ")"),
            invalid: "var(--ds-border-danger, ".concat((0, $3c7rQ.R300), ")"),
            invalidAndChecked: "var(--ds-border-danger, ".concat((0, $3c7rQ.R300), ")"),
            focused: "var(--ds-border-focused, ".concat((0, $3c7rQ.B200), ")"),
            hoveredAndChecked: "var(--ds-background-selected-bold-hovered, ".concat((0, $3c7rQ.B300), ")")
        },
        boxColor: {
            rest: "var(--ds-background-input, ".concat((0, $3c7rQ.N10), ")"),
            hovered: "var(--ds-background-input-hovered, ".concat((0, $3c7rQ.N30), ")"),
            disabled: "var(--ds-background-disabled, ".concat((0, $3c7rQ.N20), ")"),
            active: "var(--ds-background-input-pressed, ".concat((0, $3c7rQ.B50), ")"),
            hoveredAndChecked: "var(--ds-background-selected-bold-hovered, ".concat((0, $3c7rQ.B300), ")"),
            checked: "var(--ds-background-selected-bold, ".concat((0, $3c7rQ.B400), ")")
        },
        tickColor: {
            disabledAndChecked: "var(--ds-icon-disabled, ".concat((0, $3c7rQ.N70), ")"),
            activeAndChecked: "var(--ds-icon-inverse, ".concat((0, $3c7rQ.B400), ")"),
            checked: "var(--ds-icon-inverse, ".concat((0, $3c7rQ.N10), ")")
        }
    },
    dark: {
        borderColor: {
            rest: (0, $mWKBO.getBooleanFF)('platform.design-system-team.update-border-radio-checkbox_7askv') ? "var(--ds-border-bold, ".concat((0, $3c7rQ.DN200), ")") : "var(--ds-border-input, ".concat((0, $3c7rQ.DN80), ")"),
            hovered: "var(--ds-border-input, ".concat((0, $3c7rQ.DN200), ")"),
            disabled: "var(--ds-background-disabled, ".concat((0, $3c7rQ.DN10), ")"),
            checked: "var(--ds-background-selected-bold, ".concat((0, $3c7rQ.B400), ")"),
            active: "var(--ds-border, ".concat((0, $3c7rQ.B200), ")"),
            invalid: "var(--ds-border-danger, ".concat((0, $3c7rQ.R300), ")"),
            invalidAndChecked: "var(--ds-border-danger, ".concat((0, $3c7rQ.R300), ")"),
            focused: "var(--ds-border-focused, ".concat((0, $3c7rQ.B75), ")"),
            hoveredAndChecked: "var(--ds-background-selected-bold-hovered, ".concat((0, $3c7rQ.B75), ")")
        },
        boxColor: {
            rest: "var(--ds-background-input, ".concat((0, $3c7rQ.DN10), ")"),
            hovered: "var(--ds-background-input-hovered, ".concat((0, $3c7rQ.DN30), ")"),
            disabled: "var(--ds-background-disabled, ".concat((0, $3c7rQ.DN10), ")"),
            active: "var(--ds-background-input-pressed, ".concat((0, $3c7rQ.B200), ")"),
            hoveredAndChecked: "var(--ds-background-selected-bold-hovered, ".concat((0, $3c7rQ.B75), ")"),
            checked: "var(--ds-background-selected-bold, ".concat((0, $3c7rQ.B400), ")")
        },
        tickColor: {
            disabledAndChecked: "var(--ds-icon-disabled, ".concat((0, $3c7rQ.DN90), ")"),
            activeAndChecked: "var(--ds-icon-inverse, ".concat((0, $3c7rQ.DN10), ")"),
            checked: "var(--ds-icon-inverse, ".concat((0, $3c7rQ.DN10), ")")
        }
    }
};
var $b22ab37906e5b0ff$export$2e2bcd8739ae039 = $b22ab37906e5b0ff$var$theme;

});


parcelRegister("1sBRT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1105c7d30b6a22e8$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $3dJ4i = parcelRequire("3dJ4i");
var $1105c7d30b6a22e8$var$labelTextStyles = (0, $3dJ4i.css)({
    alignSelf: 'center',
    gridArea: '1 / 2 / 2 / 3'
});
function $1105c7d30b6a22e8$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children;
    return (0, $3dJ4i.jsx)("span", {
        css: $1105c7d30b6a22e8$var$labelTextStyles
    }, children);
}

});

parcelRegister("jessv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e005666ec4f6e1dd$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $3dJ4i = parcelRequire("3dJ4i");

var $3c7rQ = parcelRequire("3c7rQ");
var $e005666ec4f6e1dd$var$requiredIndicatorStyles = (0, $3dJ4i.css)({
    paddingLeft: "var(--ds-space-025, 2px)",
    color: "var(--ds-text-danger, ".concat((0, $3c7rQ.R500), ")")
});
function $e005666ec4f6e1dd$export$2e2bcd8739ae039() {
    return (0, $3dJ4i.jsx)("span", {
        css: $e005666ec4f6e1dd$var$requiredIndicatorStyles,
        "aria-hidden": true
    }, "*");
}

});


parcelRegister("kaFhh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1fa22b134d342ddb8339c9dc89d7524>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $03ca242c321a43b2$var$_react = $03ca242c321a43b2$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $03ca242c321a43b2$var$_baseNew = $03ca242c321a43b2$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $03ca242c321a43b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Task".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $03ca242c321a43b2$var$TaskIcon = (props)=>/*#__PURE__*/ $03ca242c321a43b2$var$_react.default.createElement($03ca242c321a43b2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm9.326 2.98-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308z" clip-rule="evenodd"/>`
    }, props));
$03ca242c321a43b2$var$TaskIcon.displayName = 'TaskIcon';
var $03ca242c321a43b2$var$_default = module.exports.default = $03ca242c321a43b2$var$TaskIcon;

});

parcelRegister("97j0t", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bfc058bc597636775f186a66702ef9b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6a3382d00f416b95$var$_react = $6a3382d00f416b95$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6a3382d00f416b95$var$_baseNew = $6a3382d00f416b95$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $6a3382d00f416b95$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Board".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6a3382d00f416b95$var$BoardIcon = (props)=>/*#__PURE__*/ $6a3382d00f416b95$var$_react.default.createElement($6a3382d00f416b95$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h2.833v-9zm4.333 0v9h3.334v-9zm4.834 0v9H14a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$6a3382d00f416b95$var$BoardIcon.displayName = 'BoardIcon';
var $6a3382d00f416b95$var$_default = module.exports.default = $6a3382d00f416b95$var$BoardIcon;

});

parcelRegister("4rx0e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::068663bc7237a4f6d91e480dd5b2499a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $33c348af03bf3698$var$_react = $33c348af03bf3698$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $33c348af03bf3698$var$_baseNew = $33c348af03bf3698$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $33c348af03bf3698$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Table".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for tables, tabular data, and spreadsheets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $33c348af03bf3698$var$TableIcon = (props)=>/*#__PURE__*/ $33c348af03bf3698$var$_react.default.createElement($33c348af03bf3698$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8.75h-8v3.75H14a.5.5 0 0 0 .5-.5zM1.5 12a.5.5 0 0 0 .5.5h3V8.75H1.5zm13-8a.5.5 0 0 0-.5-.5H6.5v3.75h8zm-13 3.25H5V3.5H2a.5.5 0 0 0-.5.5zM16 12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z"/>`
    }, props));
$33c348af03bf3698$var$TableIcon.displayName = 'TableIcon';
var $33c348af03bf3698$var$_default = module.exports.default = $33c348af03bf3698$var$TableIcon;

});

parcelRegister("fxaW1", function(module, exports) {
$parcel$export(module.exports, "shallowEqualObjects", function () { return $b4f26b8985dec6dd$export$3e67810a3f0e9f1c; });
function $b4f26b8985dec6dd$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $b4f26b8985dec6dd$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $b4f26b8985dec6dd$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $b4f26b8985dec6dd$export$967a6b9924a689f7(a, b);
    return $b4f26b8985dec6dd$export$3e67810a3f0e9f1c(a, b);
}

});

parcelRegister("pmFxV", function(module, exports) {
$parcel$export(module.exports, "ExperienceSuccess", function () { return $04c3eb868b06356f$export$4962f3898bd5c829; });

var $1oC0p = parcelRequire("1oC0p");
var $04c3eb868b06356f$export$4962f3898bd5c829 = function ExperienceSuccess(_ref) {
    var experience = _ref.experience;
    (0, $1oC0p.useLayoutEffect)(function() {
        experience.success();
    }, [
        experience
    ]);
    return null;
};

});

parcelRegister("8QkkG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6702f3b3c79e0f27$export$2e2bcd8739ae039; });

var $dUzPB = parcelRequire("dUzPB");

var $g2AUw = parcelRequire("g2AUw");

var $2ZGAV = parcelRequire("2ZGAV");

var $d4ZW7 = parcelRequire("d4ZW7");
function $6702f3b3c79e0f27$export$2e2bcd8739ae039(r) {
    return (0, $dUzPB.default)(r) || (0, $g2AUw.default)(r) || (0, $2ZGAV.default)(r) || (0, $d4ZW7.default)();
}

});

parcelRegister("3wBS0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2911bc758ca2906f$export$2e2bcd8739ae039; });

var $2zYm4 = parcelRequire("2zYm4");
var $2911bc758ca2906f$var$convertToError = function convertToError(e) {
    var error;
    if (e instanceof Error) error = e;
    else if (typeof e === 'string') error = new Error(e);
    else if ((0, $2zYm4.default)(e) === 'object') try {
        error = new Error('Object error instance thrown for operation: ' + JSON.stringify(e));
    } catch (jsonError) {
        error = new Error('Object serialisation error thrown during operation: ' + String(e));
    }
    else error = new Error('No error instance thrown for operation: ' + String(e));
    return error;
};
var $2911bc758ca2906f$export$2e2bcd8739ae039 = $2911bc758ca2906f$var$convertToError;

});

parcelRegister("auF8s", function(module, exports) {

var $4jLK2 = parcelRequire("4jLK2");

var $e06LX = parcelRequire("e06LX");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $7a3c9d6218c43abc$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $e06LX);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $7a3c9d6218c43abc$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $4jLK2(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $7a3c9d6218c43abc$var$baseFlatten;

});
parcelRegister("e06LX", function(module, exports) {

var $3MHuE = parcelRequire("3MHuE");

var $8E4Q5 = parcelRequire("8E4Q5");

var $lPKNl = parcelRequire("lPKNl");
/** Built-in value references. */ var $a31651a1aa52b9f5$var$spreadableSymbol = $3MHuE ? $3MHuE.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $a31651a1aa52b9f5$var$isFlattenable(value) {
    return $lPKNl(value) || $8E4Q5(value) || !!($a31651a1aa52b9f5$var$spreadableSymbol && value && value[$a31651a1aa52b9f5$var$spreadableSymbol]);
}
module.exports = $a31651a1aa52b9f5$var$isFlattenable;

});


parcelRegister("3KbVH", function(module, exports) {

var $dilJK = parcelRequire("dilJK");

var $jeI8Y = parcelRequire("jeI8Y");

var $1f5iV = parcelRequire("1f5iV");

var $lPKNl = parcelRequire("lPKNl");

var $4etkd = parcelRequire("4etkd");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $2b9eebf5a55b4b79$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $1f5iV;
    if (typeof value == 'object') return $lPKNl(value) ? $jeI8Y(value[0], value[1]) : $dilJK(value);
    return $4etkd(value);
}
module.exports = $2b9eebf5a55b4b79$var$baseIteratee;

});
parcelRegister("dilJK", function(module, exports) {

var $dmRJm = parcelRequire("dmRJm");

var $8flHN = parcelRequire("8flHN");

var $hJEpp = parcelRequire("hJEpp");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $9addd149db741bb3$var$baseMatches(source) {
    var matchData = $8flHN(source);
    if (matchData.length == 1 && matchData[0][2]) return $hJEpp(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $dmRJm(object, source, matchData);
    };
}
module.exports = $9addd149db741bb3$var$baseMatches;

});
parcelRegister("hJEpp", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $ce95fbfe7bad507a$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $ce95fbfe7bad507a$var$matchesStrictComparable;

});


parcelRegister("jeI8Y", function(module, exports) {

var $l80hK = parcelRequire("l80hK");

var $4EAwS = parcelRequire("4EAwS");

var $8avIg = parcelRequire("8avIg");

var $lIDFS = parcelRequire("lIDFS");

var $3rDfs = parcelRequire("3rDfs");

var $hJEpp = parcelRequire("hJEpp");

var $119FI = parcelRequire("119FI");
/** Used to compose bitmasks for value comparisons. */ var $e0119120d5390bec$var$COMPARE_PARTIAL_FLAG = 1, $e0119120d5390bec$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $e0119120d5390bec$var$baseMatchesProperty(path, srcValue) {
    if ($lIDFS(path) && $3rDfs(srcValue)) return $hJEpp($119FI(path), srcValue);
    return function(object) {
        var objValue = $4EAwS(object, path);
        return objValue === undefined && objValue === srcValue ? $8avIg(object, path) : $l80hK(srcValue, objValue, $e0119120d5390bec$var$COMPARE_PARTIAL_FLAG | $e0119120d5390bec$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $e0119120d5390bec$var$baseMatchesProperty;

});
parcelRegister("8avIg", function(module, exports) {

var $90xK9 = parcelRequire("90xK9");

var $eW6W4 = parcelRequire("eW6W4");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $5f27db6f2fb2ce7d$var$hasIn(object, path) {
    return object != null && $eW6W4(object, path, $90xK9);
}
module.exports = $5f27db6f2fb2ce7d$var$hasIn;

});
parcelRegister("90xK9", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $68ee49e62966a7ed$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $68ee49e62966a7ed$var$baseHasIn;

});

parcelRegister("eW6W4", function(module, exports) {

var $hLLeA = parcelRequire("hLLeA");

var $8E4Q5 = parcelRequire("8E4Q5");

var $lPKNl = parcelRequire("lPKNl");

var $f6osf = parcelRequire("f6osf");

var $cTpmH = parcelRequire("cTpmH");

var $119FI = parcelRequire("119FI");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $adfbdcbd1c5e47b6$var$hasPath(object, path, hasFunc) {
    path = $hLLeA(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $119FI(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $cTpmH(length) && $f6osf(key, length) && ($lPKNl(object) || $8E4Q5(object));
}
module.exports = $adfbdcbd1c5e47b6$var$hasPath;

});



parcelRegister("1f5iV", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $0e7b4e76421e80bb$var$identity(value) {
    return value;
}
module.exports = $0e7b4e76421e80bb$var$identity;

});

parcelRegister("4etkd", function(module, exports) {

var $9Qn7O = parcelRequire("9Qn7O");

var $b8vlH = parcelRequire("b8vlH");

var $lIDFS = parcelRequire("lIDFS");

var $119FI = parcelRequire("119FI");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $314f3793de1805c8$var$property(path) {
    return $lIDFS(path) ? $9Qn7O($119FI(path)) : $b8vlH(path);
}
module.exports = $314f3793de1805c8$var$property;

});
parcelRegister("9Qn7O", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $72aae887a83b3cce$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $72aae887a83b3cce$var$baseProperty;

});

parcelRegister("b8vlH", function(module, exports) {

var $5oMeU = parcelRequire("5oMeU");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $81b8c253b34c5572$var$basePropertyDeep(path) {
    return function(object) {
        return $5oMeU(object, path);
    };
}
module.exports = $81b8c253b34c5572$var$basePropertyDeep;

});



parcelRegister("kY6PH", function(module, exports) {

var $aGDk7 = parcelRequire("aGDk7");

var $aoZtB = parcelRequire("aoZtB");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $f43eb61b79c72930$var$baseEach = $aoZtB($aGDk7);
module.exports = $f43eb61b79c72930$var$baseEach;

});
parcelRegister("aGDk7", function(module, exports) {

var $hInl6 = parcelRequire("hInl6");

var $lrU6c = parcelRequire("lrU6c");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $7c7c547755c2d334$var$baseForOwn(object, iteratee) {
    return object && $hInl6(object, iteratee, $lrU6c);
}
module.exports = $7c7c547755c2d334$var$baseForOwn;

});
parcelRegister("hInl6", function(module, exports) {

var $5jobf = parcelRequire("5jobf");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $ce58a670f068373a$var$baseFor = $5jobf();
module.exports = $ce58a670f068373a$var$baseFor;

});
parcelRegister("5jobf", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $3de17bd8d8789b42$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $3de17bd8d8789b42$var$createBaseFor;

});



parcelRegister("aoZtB", function(module, exports) {

var $6PGLN = parcelRequire("6PGLN");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $792bd5382a824cff$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$6PGLN(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $792bd5382a824cff$var$createBaseEach;

});


parcelRegister("bqMAt", function(module, exports) {

var $1f5iV = parcelRequire("1f5iV");

var $axmYb = parcelRequire("axmYb");

var $jj29P = parcelRequire("jj29P");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $8527cfd5a337ca91$var$baseRest(func, start) {
    return $jj29P($axmYb(func, start, $1f5iV), func + '');
}
module.exports = $8527cfd5a337ca91$var$baseRest;

});
parcelRegister("axmYb", function(module, exports) {

var $3ls0q = parcelRequire("3ls0q");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7abecdc323c478eb$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $7abecdc323c478eb$var$overRest(func, start, transform) {
    start = $7abecdc323c478eb$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $7abecdc323c478eb$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $3ls0q(func, this, otherArgs);
    };
}
module.exports = $7abecdc323c478eb$var$overRest;

});
parcelRegister("3ls0q", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $26f90e9ed1e087a4$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $26f90e9ed1e087a4$var$apply;

});


parcelRegister("jj29P", function(module, exports) {

var $j199U = parcelRequire("j199U");

var $i9M4A = parcelRequire("i9M4A");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $e0e17718533c241f$var$setToString = $i9M4A($j199U);
module.exports = $e0e17718533c241f$var$setToString;

});
parcelRegister("j199U", function(module, exports) {

var $3Kt5H = parcelRequire("3Kt5H");

var $cmtMX = parcelRequire("cmtMX");

var $1f5iV = parcelRequire("1f5iV");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $dd85370c1f08aaa6$var$baseSetToString = !$cmtMX ? $1f5iV : function(func, string) {
    return $cmtMX(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $3Kt5H(string),
        'writable': true
    });
};
module.exports = $dd85370c1f08aaa6$var$baseSetToString;

});
parcelRegister("3Kt5H", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $2bac3bd7f8fc3bd7$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $2bac3bd7f8fc3bd7$var$constant;

});


parcelRegister("i9M4A", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $d37e5b869faf8491$var$HOT_COUNT = 800, $d37e5b869faf8491$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d37e5b869faf8491$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $d37e5b869faf8491$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $d37e5b869faf8491$var$nativeNow(), remaining = $d37e5b869faf8491$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $d37e5b869faf8491$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $d37e5b869faf8491$var$shortOut;

});



parcelRegister("cHt3R", function(module, exports) {

var $8tfJP = parcelRequire("8tfJP");

var $6PGLN = parcelRequire("6PGLN");

var $f6osf = parcelRequire("f6osf");

var $ih96c = parcelRequire("ih96c");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $93f00b2a7ebaaf8b$var$isIterateeCall(value, index, object) {
    if (!$ih96c(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $6PGLN(object) && $f6osf(index, object.length) : type == 'string' && index in object) return $8tfJP(object[index], value);
    return false;
}
module.exports = $93f00b2a7ebaaf8b$var$isIterateeCall;

});

parcelRegister("2OL6m", function(module, exports) {
$parcel$export(module.exports, "combine", function () { return (parcelRequire("jrlIh")).combine; });

var $jrlIh = parcelRequire("jrlIh");

});
parcelRegister("jrlIh", function(module, exports) {
$parcel$export(module.exports, "combine", function () { return $e27161b4180d34ed$export$1be1fc439b849fdf; });
/** Create a new combined function that will call all the provided functions */ function $e27161b4180d34ed$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function cleanup() {
        fns.forEach(function(fn) {
            return fn();
        });
    };
}

});


parcelRegister("kzuyT", function(module, exports) {
$parcel$export(module.exports, "draggable", function () { return (parcelRequire("fxPVd")).draggable; });
$parcel$export(module.exports, "dropTargetForElements", function () { return (parcelRequire("fxPVd")).dropTargetForElements; });
$parcel$export(module.exports, "monitorForElements", function () { return (parcelRequire("fxPVd")).monitorForElements; });

var $fxPVd = parcelRequire("fxPVd");
 // Payload for the draggable being dragged

});
parcelRegister("fxPVd", function(module, exports) {
$parcel$export(module.exports, "dropTargetForElements", function () { return $b51236a7af728235$export$e7140b68045b5036; });
$parcel$export(module.exports, "monitorForElements", function () { return $b51236a7af728235$export$59a074bac4c54f54; });
$parcel$export(module.exports, "draggable", function () { return $b51236a7af728235$export$c746a5152d4ba26c; });

var $2qaZZ = parcelRequire("2qaZZ");

var $dH1HR = parcelRequire("dH1HR");

var $kwSyV = parcelRequire("kwSyV");

var $hDj86 = parcelRequire("hDj86");

var $9LOtS = parcelRequire("9LOtS");

var $jrlIh = parcelRequire("jrlIh");

var $LSEQ4 = parcelRequire("LSEQ4");

var $jNxxH = parcelRequire("jNxxH");

var $lJqmY = parcelRequire("lJqmY");

var $gUlOk = parcelRequire("gUlOk");

var $32gfR = parcelRequire("32gfR");

var $6bk4h = parcelRequire("6bk4h");

var $Kswn1 = parcelRequire("Kswn1");
var $b51236a7af728235$var$draggableRegistry = new WeakMap();
function $b51236a7af728235$var$addToRegistry(args) {
    $b51236a7af728235$var$draggableRegistry.set(args.element, args);
    return function cleanup() {
        $b51236a7af728235$var$draggableRegistry.delete(args.element);
    };
}
var $b51236a7af728235$var$honeyPotFix = (0, $hDj86.makeHoneyPotFix)();
var $b51236a7af728235$var$adapter = (0, $9LOtS.makeAdapter)({
    typeKey: 'element',
    defaultDropEffect: 'move',
    mount: function mount(api) {
        /**  Binding event listeners the `document` rather than `window` so that
     * this adapter always gets preference over the text adapter.
     * `document` is the first `EventTarget` under `window`
     * https://twitter.com/alexandereardon/status/1604658588311465985
     */ return (0, $jrlIh.combine)($b51236a7af728235$var$honeyPotFix.bindEvents(), (0, $dH1HR.bind)(document, {
            type: 'dragstart',
            listener: function listener(event) {
                var _entry$dragHandle, _entry$getInitialData, _entry$getInitialData2, _entry$dragHandle2, _entry$getInitialData3, _entry$getInitialData4;
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                var target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return null;
                // see if the thing being dragged is owned by us
                var entry = $b51236a7af728235$var$draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return null;
                /**
         * A text selection drag _can_ have the `draggable` element be
         * the `event.target` if the user is dragging the text selection
         * from the `draggable`.
         *
         * To know if the `draggable` is being dragged, we look at whether any
         * `"text/plain"` data is being dragged. If it is, then a text selection
         * drag is occurring.
         *
         * This behaviour has been validated on:
         *
         * - Chrome@128 on Android@14
         * - Chrome@128 on iOS@17.6.1
         * - Chrome@128 on Windows@11
         * - Chrome@128 on MacOS@14.6.1
         * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
         * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
         *
         * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
         * but unfortunately ProseMirror is always setting `""` as the dragged text
         *
         * Note: Unfortunately editor is (heavily) leaning on the current functionality today
         * and unwinding it will be a decent amount of effort. So for now, a text selection
         * where the `event.target` is a `draggable` element will still trigger the
         * element adapter.
         *
         * // Future state:
         * if(event.dataTransfer.getData(textMediaType)) {
         * 	return;
         * }
         *
         */ var input = (0, $gUlOk.getInput)(event);
                var feedback = {
                    element: entry.element,
                    dragHandle: (_entry$dragHandle = entry.dragHandle) !== null && _entry$dragHandle !== void 0 ? _entry$dragHandle : null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return null;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    var over = (0, $kwSyV.getElementFromPointWithoutHoneypot)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return null;
                    }
                }
                /**
         *  **Goal**
         *  Pass information to other applications
         *
         * **Approach**
         *  Put data into the native data store
         *
         *  **What about the native adapter?**
         *  When the element adapter puts native data into the native data store
         *  the native adapter is not triggered in the current window,
         *  but a native adapter in an external window _can_ be triggered
         *
         *  **Why bake this into core?**
         *  This functionality could be pulled out and exposed inside of
         *  `onGenerateDragPreview`. But decided to make it a part of the
         *  base API as it felt like a common enough use case and ended
         *  up being a similar amount of code to include this function as
         *  it was to expose the hook for it
         */ var nativeData = (_entry$getInitialData = (_entry$getInitialData2 = entry.getInitialDataForExternal) === null || _entry$getInitialData2 === void 0 ? void 0 : _entry$getInitialData2.call(entry, feedback)) !== null && _entry$getInitialData !== void 0 ? _entry$getInitialData : null;
                if (nativeData) for(var _i = 0, _Object$entries = Object.entries(nativeData); _i < _Object$entries.length; _i++){
                    var _Object$entries$_i = (0, $2qaZZ.default)(_Object$entries[_i], 2), key = _Object$entries$_i[0], data = _Object$entries$_i[1];
                    event.dataTransfer.setData(key, data !== null && data !== void 0 ? data : '');
                }
                /**
         *  📱 For Android devices, a drag operation will not start unless
         * "text/plain" or "text/uri-list" data exists in the native data store
         * https://twitter.com/alexandereardon/status/1732189803754713424
         *
         * Tested on:
         * Device: Google Pixel 5
         * Android version: 14 (November 5, 2023)
         * Chrome version: 120.0
         */ if ((0, $lJqmY.isAndroid)() && !event.dataTransfer.types.includes((0, $32gfR.textMediaType)) && !event.dataTransfer.types.includes((0, $6bk4h.URLMediaType))) event.dataTransfer.setData((0, $32gfR.textMediaType), (0, $lJqmY.androidFallbackText));
                /**
         * 1. Must set any media type for `iOS15` to work
         * 2. We are also doing adding data so that the native adapter
         * can know that the element adapter has handled this drag
         *
         * We used to wrap this `setData()` in a `try/catch` for Firefox,
         * but it looks like that was not needed.
         *
         * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
         *
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
         * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
         *
         * // just checking a few more combinations to be super safe
         *
         * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
         * - ✅ Chrome@78 (Oct 2019) on Windows 10
         * - ✅ Safari@14.1 on macOS Big Sur
         */ event.dataTransfer.setData((0, $Kswn1.elementAdapterNativeDataKey), '');
                var payload = {
                    element: entry.element,
                    dragHandle: (_entry$dragHandle2 = entry.dragHandle) !== null && _entry$dragHandle2 !== void 0 ? _entry$dragHandle2 : null,
                    data: (_entry$getInitialData3 = (_entry$getInitialData4 = entry.getInitialData) === null || _entry$getInitialData4 === void 0 ? void 0 : _entry$getInitialData4.call(entry, feedback)) !== null && _entry$getInitialData3 !== void 0 ? _entry$getInitialData3 : {}
                };
                var dragType = {
                    type: 'element',
                    payload: payload,
                    startedFrom: 'internal'
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        }));
    },
    dispatchEventToSource: function dispatchEventToSource(_ref) {
        var _draggableRegistry$ge, _draggableRegistry$ge2;
        var eventName = _ref.eventName, payload = _ref.payload;
        // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        (_draggableRegistry$ge = $b51236a7af728235$var$draggableRegistry.get(payload.source.element)) === null || _draggableRegistry$ge === void 0 || (_draggableRegistry$ge2 = _draggableRegistry$ge[eventName]) === null || _draggableRegistry$ge2 === void 0 || _draggableRegistry$ge2.call(_draggableRegistry$ge, // I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: $b51236a7af728235$var$honeyPotFix.getOnPostDispatch()
});
var $b51236a7af728235$export$e7140b68045b5036 = $b51236a7af728235$var$adapter.dropTarget;
var $b51236a7af728235$export$59a074bac4c54f54 = $b51236a7af728235$var$adapter.monitor;
function $b51236a7af728235$export$c746a5152d4ba26c(args) {
    var existing;
    var cleanup = (0, $jrlIh.combine)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    $b51236a7af728235$var$adapter.registerUsage(), $b51236a7af728235$var$addToRegistry(args), (0, $jNxxH.addAttribute)(args.element, {
        attribute: 'draggable',
        value: 'true'
    }));
    // Wrapping in `once` to prevent unexpected side effects if consumers call
    // the clean up function multiple times.
    return (0, $LSEQ4.once)(cleanup);
} /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Arguments given to all feedback functions (eg `canDrag()`) on for a `draggable()` */  /** Arguments given to all feedback functions (eg `canDrop()`) on a `dropTargetForElements()` */  /** Arguments given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForElements` */ 

});
parcelRegister("kwSyV", function(module, exports) {
$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", function () { return $ef211ec2baf817be$export$81d0353f25f5dd; });

var $2qaZZ = parcelRequire("2qaZZ");

var $g3bBV = parcelRequire("g3bBV");
function $ef211ec2baf817be$export$81d0353f25f5dd(client) {
    // eslint-disable-next-line no-restricted-syntax
    var _document$elementsFro = document.elementsFromPoint(client.x, client.y), _document$elementsFro2 = (0, $2qaZZ.default)(_document$elementsFro, 2), top = _document$elementsFro2[0], second = _document$elementsFro2[1];
    if (!top) return null;
    if ((0, $g3bBV.isHoneyPotElement)(top)) return second !== null && second !== void 0 ? second : null;
    return top;
}

});
parcelRegister("g3bBV", function(module, exports) {
$parcel$export(module.exports, "isHoneyPotElement", function () { return $baf5eed03cf5a0ad$export$821bdcd739a2706b; });

var $2mVQF = parcelRequire("2mVQF");
function $baf5eed03cf5a0ad$export$821bdcd739a2706b(target) {
    return target instanceof Element && target.hasAttribute((0, $2mVQF.honeyPotDataAttribute));
}

});
parcelRegister("2mVQF", function(module, exports) {
$parcel$export(module.exports, "honeyPotDataAttribute", function () { return $1b9a8258b1e41ecb$export$6eafea55f7947469; });
// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
var $1b9a8258b1e41ecb$export$6eafea55f7947469 = 'data-pdnd-honey-pot';

});



parcelRegister("hDj86", function(module, exports) {
$parcel$export(module.exports, "makeHoneyPotFix", function () { return $cd64eaee9cf1bbf2$export$8ecad27c959e89e0; });

var $f53LC = parcelRequire("f53LC");

var $dH1HR = parcelRequire("dH1HR");

var $XNt2f = parcelRequire("XNt2f");

var $2mVQF = parcelRequire("2mVQF");
function $cd64eaee9cf1bbf2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cd64eaee9cf1bbf2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cd64eaee9cf1bbf2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cd64eaee9cf1bbf2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cd64eaee9cf1bbf2$var$honeyPotSize = 2;
var $cd64eaee9cf1bbf2$var$halfHoneyPotSize = $cd64eaee9cf1bbf2$var$honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function $cd64eaee9cf1bbf2$var$floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function $cd64eaee9cf1bbf2$var$pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - $cd64eaee9cf1bbf2$var$halfHoneyPotSize,
        y: point.y - $cd64eaee9cf1bbf2$var$halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $cd64eaee9cf1bbf2$var$preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $cd64eaee9cf1bbf2$var$preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - $cd64eaee9cf1bbf2$var$honeyPotSize),
        y: Math.min(point.y, window.innerHeight - $cd64eaee9cf1bbf2$var$honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function $cd64eaee9cf1bbf2$var$getHoneyPotRectFor(_ref) {
    var client = _ref.client;
    var point = $cd64eaee9cf1bbf2$var$preventGoingForwardsOffScreen($cd64eaee9cf1bbf2$var$preventGoingBackwardsOffScreen($cd64eaee9cf1bbf2$var$pullBackByHalfHoneyPotSize($cd64eaee9cf1bbf2$var$floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: $cd64eaee9cf1bbf2$var$honeyPotSize,
        height: $cd64eaee9cf1bbf2$var$honeyPotSize
    });
}
function $cd64eaee9cf1bbf2$var$getRectStyles(_ref2) {
    var clientRect = _ref2.clientRect;
    return {
        left: "".concat(clientRect.left, "px"),
        top: "".concat(clientRect.top, "px"),
        width: "".concat(clientRect.width, "px"),
        height: "".concat(clientRect.height, "px")
    };
}
function $cd64eaee9cf1bbf2$var$isWithin(_ref3) {
    var client = _ref3.client, clientRect = _ref3.clientRect;
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function $cd64eaee9cf1bbf2$var$mountHoneyPot(_ref4) {
    var initial = _ref4.initial;
    var element = document.createElement('div');
    element.setAttribute((0, $2mVQF.honeyPotDataAttribute), 'true');
    // can shift during the drag thanks to Firefox
    var clientRect = $cd64eaee9cf1bbf2$var$getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, $cd64eaee9cf1bbf2$var$_objectSpread($cd64eaee9cf1bbf2$var$_objectSpread({
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: 'transparent',
        position: 'fixed',
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: 'border-box'
    }, $cd64eaee9cf1bbf2$var$getRectStyles({
        clientRect: clientRect
    })), {}, {
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: 'auto',
        // Want to make sure the honey pot is top of everything else.
        // Don't need to worry about native drag previews, as they will
        // have been rendered (and removed) before the honey pot is rendered
        zIndex: (0, $XNt2f.maxZIndex)
    }));
    document.body.appendChild(element);
    /**
   *  🦊 In firefox we can get `"pointermove"` events after the drag
   * has started, which is a spec violation.
   * The final `"pointermove"` will reveal where the "depressed" position
   * is for our honey pot fix.
   */ var unbindPointerMove = (0, $dH1HR.bind)(window, {
        type: 'pointermove',
        listener: function listener(event) {
            var client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = $cd64eaee9cf1bbf2$var$getHoneyPotRectFor({
                client: client
            });
            Object.assign(element.style, $cd64eaee9cf1bbf2$var$getRectStyles({
                clientRect: clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish(_ref5) {
        var current = _ref5.current;
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if ($cd64eaee9cf1bbf2$var$isWithin({
            client: current,
            clientRect: clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        var unbindPostDragEvents = (0, $dH1HR.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: cleanup
            },
            {
                type: 'pointermove',
                listener: cleanup
            },
            {
                type: 'focusin',
                listener: cleanup
            },
            {
                type: 'focusout',
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: 'dragstart',
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: 'dragenter',
                listener: cleanup
            },
            {
                type: 'dragover',
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function $cd64eaee9cf1bbf2$export$8ecad27c959e89e0() {
    var latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, $dH1HR.bind)(window, {
            type: 'pointermove',
            listener: function listener(event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        var finish = null;
        return function onPostEvent(_ref6) {
            var eventName = _ref6.eventName, payload = _ref6.payload;
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === 'onDragStart') {
                var input = payload.location.initial.input;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                var initial = latestPointerMove !== null && latestPointerMove !== void 0 ? latestPointerMove : {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = $cd64eaee9cf1bbf2$var$mountHoneyPot({
                    initial: initial
                });
            }
            if (eventName === 'onDrop') {
                var _finish;
                var _input = payload.location.current.input;
                (_finish = finish) === null || _finish === void 0 || _finish({
                    current: {
                        x: _input.clientX,
                        y: _input.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents: bindEvents,
        getOnPostDispatch: getOnPostDispatch
    };
}

});
parcelRegister("XNt2f", function(module, exports) {
$parcel$export(module.exports, "maxZIndex", function () { return $0b3be1faf74e0525$export$7d0a15ee70427305; });
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
var $0b3be1faf74e0525$export$7d0a15ee70427305 = 2147483647;

});


parcelRegister("9LOtS", function(module, exports) {
$parcel$export(module.exports, "makeAdapter", function () { return $71cfa94ff585bac1$export$2aa3a33160990d96; });

var $4BNx6 = parcelRequire("4BNx6");

var $bHtty = parcelRequire("bHtty");

var $fvY3W = parcelRequire("fvY3W");

var $2DD9Q = parcelRequire("2DD9Q");
function $71cfa94ff585bac1$export$2aa3a33160990d96(_ref) {
    var typeKey = _ref.typeKey, mount = _ref.mount, dispatchEventToSource = _ref.dispatchEventToSource, onPostDispatch = _ref.onPostDispatch, defaultDropEffect = _ref.defaultDropEffect;
    var monitorAPI = (0, $2DD9Q.makeMonitor)();
    var dropTargetAPI = (0, $fvY3W.makeDropTarget)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource === null || dispatchEventToSource === void 0 || dispatchEventToSource(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch === null || onPostDispatch === void 0 || onPostDispatch(args);
    }
    function start(_ref2) {
        var event = _ref2.event, dragType = _ref2.dragType;
        (0, $4BNx6.lifecycle).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            var api = {
                canStart: (0, $4BNx6.lifecycle).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, $bHtty.register)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}

});
parcelRegister("4BNx6", function(module, exports) {
$parcel$export(module.exports, "lifecycle", function () { return $35b10a550411be33$export$3efdceeb8ca25c51; });

var $lFOXD = parcelRequire("lFOXD");

var $dH1HR = parcelRequire("dH1HR");

var $kwSyV = parcelRequire("kwSyV");

var $g3bBV = parcelRequire("g3bBV");

var $lmWo8 = parcelRequire("lmWo8");

var $hl86x = parcelRequire("hl86x");

var $gUlOk = parcelRequire("gUlOk");

var $hETpl = parcelRequire("hETpl");
var $35b10a550411be33$var$globalState = {
    isActive: false
};
function $35b10a550411be33$var$canStart() {
    return !$35b10a550411be33$var$globalState.isActive;
}
function $35b10a550411be33$var$getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function $35b10a550411be33$var$hasHierarchyChanged(_ref) {
    var current = _ref.current, next = _ref.next;
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(var i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function $35b10a550411be33$var$start(_ref2) {
    var event = _ref2.event, dragType = _ref2.dragType, getDropTargetsOver = _ref2.getDropTargetsOver, dispatchEvent = _ref2.dispatchEvent;
    if (!$35b10a550411be33$var$canStart()) return;
    var initial = $35b10a550411be33$var$getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    $35b10a550411be33$var$globalState.isActive = true;
    var state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    $35b10a550411be33$var$setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    var dispatch = (0, $hETpl.makeDispatch)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        var hasChanged = $35b10a550411be33$var$hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        var input = (0, $gUlOk.getInput)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        var target = (0, $g3bBV.isHoneyPotElement)(event.target) ? (0, $kwSyV.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        var nextDropTargets = getDropTargetsOver({
            target: target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            $35b10a550411be33$var$setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        $35b10a550411be33$var$globalState.isActive = false;
        unbindEvents();
    }
    var unbindEvents = (0, $dH1HR.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: 'dragover',
            listener: function listener(event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: 'dragenter',
            listener: onUpdateEvent
        },
        {
            type: 'dragleave',
            listener: function listener(event) {
                if (!(0, $lmWo8.isLeavingWindow)({
                    dragLeave: event
                })) return;
                /**
       * At this point we don't know if a drag is being cancelled,
       * or if a drag is leaving the `window`.
       *
       * Both have:
       *   1. "dragleave" (with `relatedTarget: null`)
       *   2. "dragend" (a "dragend" can occur when outside the `window`)
       *
       * **Clearing drop targets**
       *
       * For either case we are clearing the the drop targets
       *
       * - cancelling: we clear drop targets in `"dragend"` anyway
       * - leaving the `window`: we clear the drop targets (to clear stickiness)
       *
       * **Leaving the window and finishing the drag**
       *
       * _internal drags_
       *
       * - The drag continues when the user is outside the `window`
       *   and can resume if the user drags back over the `window`,
       *   or end when the user drops in an external `window`.
       * - We will get a `"dragend"`, or we can listen for other
       *   events to determine the drag is finished when the user re-enters the `window`).
       *
       * _external drags_
       *
       * - We conclude the drag operation.
       * - We have no idea if the user will drag back over the `window`,
       *   or if the drag ends elsewhere.
       * - We will create a new drag if the user re-enters the `window`.
       *
       * **Not updating `input`**
       *
       * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
       * Workaround: intentionally not updating `input` in "dragleave"
       * rather than the users current input values
       * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
       * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
       **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === 'external') cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: 'drop',
            listener: function listener(event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $gUlOk.getInput)(event)
                };
                /** If there are no drop targets, then we will get
       * a "drop" event if:
       * - `preventUnhandled()` is being used
       * - there is an unmanaged drop target (eg another library)
       * In these cases, it's up to the consumer
       * to handle the drop if it's not over one of our drop targets
       * - `preventUnhandled()` will cancel the "drop"
       * - unmanaged drop targets can handle the "drop" how they want to
       * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                $35b10a550411be33$var$setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: 'dragend',
            listener: function listener(event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $gUlOk.getInput)(event)
                };
                cancel();
            }
        }
    ].concat((0, $lFOXD.default)((0, $hl86x.getBindingsForBrokenDrags)({
        onDragEnd: cancel
    }))), // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: $35b10a550411be33$var$getNativeSetDragImage(event)
    });
}
function $35b10a550411be33$var$setDropEffectOnEvent(_ref3) {
    var _current$;
    var event = _ref3.event, current = _ref3.current;
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    var innerMost = (_current$ = current[0]) === null || _current$ === void 0 ? void 0 : _current$.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function $35b10a550411be33$var$getStartLocation(_ref4) {
    var event = _ref4.event, dragType = _ref4.dragType, getDropTargetsOver = _ref4.getDropTargetsOver;
    var input = (0, $gUlOk.getInput)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === 'external') return {
        input: input,
        dropTargets: []
    };
    var dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
var $35b10a550411be33$export$3efdceeb8ca25c51 = {
    canStart: $35b10a550411be33$var$canStart,
    start: $35b10a550411be33$var$start
};

});
parcelRegister("lmWo8", function(module, exports) {
$parcel$export(module.exports, "isLeavingWindow", function () { return $f8e8f1c08f8e8d3d$export$57d220c74e84a273; });

var $gjrVx = parcelRequire("gjrVx");

var $6EVQu = parcelRequire("6EVQu");

var $jFod5 = parcelRequire("jFod5");

var $3RPG8 = parcelRequire("3RPG8");
function $f8e8f1c08f8e8d3d$export$57d220c74e84a273(_ref) {
    var dragLeave = _ref.dragLeave;
    var type = dragLeave.type, relatedTarget = dragLeave.relatedTarget;
    if (type !== 'dragleave') return false;
    if ((0, $6EVQu.isSafari)()) return (0, $jFod5.isLeavingWindowInSafari)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   * (foreign element)
   */ if ((0, $gjrVx.isFirefox)()) return (0, $3RPG8.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is `null` *(standard check)*
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});
parcelRegister("gjrVx", function(module, exports) {
$parcel$export(module.exports, "isFirefox", function () { return $be041565cdba7374$export$b7d78993b74f766d; });

var $LSEQ4 = parcelRequire("LSEQ4");
var $be041565cdba7374$export$b7d78993b74f766d = (0, $LSEQ4.once)(function isFirefox() {
    return navigator.userAgent.includes('Firefox');
});

});
parcelRegister("LSEQ4", function(module, exports) {
$parcel$export(module.exports, "once", function () { return $08fec9c7b3ed8a7f$export$d2de3aaeafa91619; });
/** Provide a function that you only ever want to be called a single time */ function $08fec9c7b3ed8a7f$export$d2de3aaeafa91619(fn) {
    var cache = null;
    return function wrapped() {
        if (!cache) {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}

});


parcelRegister("6EVQu", function(module, exports) {
$parcel$export(module.exports, "isSafari", function () { return $4d93597535f1d36d$export$95df08bae54cb4df; });

var $LSEQ4 = parcelRequire("LSEQ4");
var $4d93597535f1d36d$export$95df08bae54cb4df = (0, $LSEQ4.once)(function isSafari() {
    var _navigator = navigator, userAgent = _navigator.userAgent;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});

});

parcelRegister("jFod5", function(module, exports) {
$parcel$export(module.exports, "isEnteringWindowInSafari", function () { return $e514a04b6e3bb510$export$de68634bd94ed596; });
$parcel$export(module.exports, "isLeavingWindowInSafari", function () { return $e514a04b6e3bb510$export$f21837c338005454; });

var $dH1HR = parcelRequire("dH1HR");

var $6EVQu = parcelRequire("6EVQu");
/* For "dragenter" events, the browser should set `relatedTarget` to the previous element.
 * For external drag operations, our first "dragenter" event should have a `event.relatedTarget` of `null`.
 *
 *  Unfortunately in Safari `event.relatedTarget` is *always* set to `null`
 *  Safari bug: https://bugs.webkit.org/show_bug.cgi?id=242627
 *  To work around this we count "dragenter" and "dragleave" events */ // Using symbols for event properties so we don't clash with
// anything on the `event` object
var $e514a04b6e3bb510$var$symbols = {
    isLeavingWindow: Symbol('leaving'),
    isEnteringWindow: Symbol('entering')
};
function $e514a04b6e3bb510$export$de68634bd94ed596(_ref) {
    var dragEnter = _ref.dragEnter;
    if (!(0, $6EVQu.isSafari)()) return false;
    return dragEnter.hasOwnProperty($e514a04b6e3bb510$var$symbols.isEnteringWindow);
}
function $e514a04b6e3bb510$export$f21837c338005454(_ref2) {
    var dragLeave = _ref2.dragLeave;
    if (!(0, $6EVQu.isSafari)()) return false;
    return dragLeave.hasOwnProperty($e514a04b6e3bb510$var$symbols.isLeavingWindow);
}
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === 'undefined') return;
    if (!(0, $6EVQu.isSafari)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    var state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, $dH1HR.bindAll)(window, [
        {
            type: 'dragstart',
            listener: function listener() {
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: 'drop',
            listener: resetState
        },
        {
            type: 'dragend',
            listener: resetState
        },
        {
            type: 'dragenter',
            listener: function listener(event) {
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                // @ts-expect-error: adding property to the event object
                event[$e514a04b6e3bb510$var$symbols.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: 'dragleave',
            listener: function listener(event) {
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    // @ts-expect-error: adding property to the event object
                    event[$e514a04b6e3bb510$var$symbols.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();

});

parcelRegister("3RPG8", function(module, exports) {
$parcel$export(module.exports, "isFromAnotherWindow", function () { return $2d0e68a1726d26be$export$e46810fef53b5b0e; });
/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ function $2d0e68a1726d26be$var$isNodeLike(target) {
    return 'nodeName' in target;
}
function $2d0e68a1726d26be$export$e46810fef53b5b0e(eventTarget) {
    return $2d0e68a1726d26be$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}

});


parcelRegister("hl86x", function(module, exports) {
$parcel$export(module.exports, "getBindingsForBrokenDrags", function () { return $c9faaf2f097e7b0c$export$ac5e5b0daf997b2; });
function $c9faaf2f097e7b0c$export$ac5e5b0daf997b2(_ref) {
    var onDragEnd = _ref.onDragEnd;
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            }()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: 'pointerdown',
            listener: onDragEnd
        }
    ];
}

});

parcelRegister("gUlOk", function(module, exports) {
$parcel$export(module.exports, "getInput", function () { return $c4f2cb7929aef229$export$7c112ceec8941e67; });
function $c4f2cb7929aef229$export$7c112ceec8941e67(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}

});

parcelRegister("hETpl", function(module, exports) {
$parcel$export(module.exports, "makeDispatch", function () { return $cdb126ee2a5c3c22$export$9f13ecc44e83d682; });

var $FcGYz = parcelRequire("FcGYz");
var $cdb126ee2a5c3c22$var$scheduleOnDrag = (0, $FcGYz.default)(function(fn) {
    return fn();
});
var $cdb126ee2a5c3c22$var$dragStart = function() {
    var scheduled = null;
    function schedule(fn) {
        var frameId = requestAnimationFrame(function() {
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
}();
function $cdb126ee2a5c3c22$export$9f13ecc44e83d682(_ref) {
    var source = _ref.source, initial = _ref.initial, dispatchEvent = _ref.dispatchEvent;
    var previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    var dispatch = {
        start: function start(_ref2) {
            var nativeSetDragImage = _ref2.nativeSetDragImage;
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            var location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: 'onGenerateDragPreview',
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            $cdb126ee2a5c3c22$var$dragStart.schedule(function() {
                safeDispatch({
                    eventName: 'onDragStart',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate: function dragUpdate(_ref3) {
            var current = _ref3.current;
            $cdb126ee2a5c3c22$var$dragStart.flush();
            $cdb126ee2a5c3c22$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDropTargetChange',
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag: function drag(_ref4) {
            var current = _ref4.current;
            $cdb126ee2a5c3c22$var$scheduleOnDrag(function() {
                $cdb126ee2a5c3c22$var$dragStart.flush();
                var location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: 'onDrag',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop: function drop(_ref5) {
            var current = _ref5.current, updatedSourcePayload = _ref5.updatedSourcePayload;
            $cdb126ee2a5c3c22$var$dragStart.flush();
            $cdb126ee2a5c3c22$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDrop',
                payload: {
                    source: updatedSourcePayload !== null && updatedSourcePayload !== void 0 ? updatedSourcePayload : source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}

});


parcelRegister("bHtty", function(module, exports) {
$parcel$export(module.exports, "register", function () { return $884a93185dad55c1$export$6503ec6e8aabbaf; });
// Extending `Map` to allow us to link Key and Values together
var $884a93185dad55c1$var$ledger = new Map();
function $884a93185dad55c1$var$registerUsage(_ref) {
    var typeKey = _ref.typeKey, mount = _ref.mount;
    var entry = $884a93185dad55c1$var$ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    var initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    $884a93185dad55c1$var$ledger.set(typeKey, initial);
    return initial;
}
function $884a93185dad55c1$export$6503ec6e8aabbaf(args) {
    var entry = $884a93185dad55c1$var$registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        $884a93185dad55c1$var$ledger.delete(args.typeKey);
    };
}

});

parcelRegister("fvY3W", function(module, exports) {
$parcel$export(module.exports, "makeDropTarget", function () { return $b4b85775c702178f$export$47d10e7bd9c81890; });

var $f53LC = parcelRequire("f53LC");

var $lFOXD = parcelRequire("lFOXD");

var $jrlIh = parcelRequire("jrlIh");

var $LSEQ4 = parcelRequire("LSEQ4");

var $jNxxH = parcelRequire("jNxxH");
function $b4b85775c702178f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b4b85775c702178f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b4b85775c702178f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b4b85775c702178f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b4b85775c702178f$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $b4b85775c702178f$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $b4b85775c702178f$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $b4b85775c702178f$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $b4b85775c702178f$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $b4b85775c702178f$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $b4b85775c702178f$var$copyReverse(array) {
    return array.slice(0).reverse();
}
function $b4b85775c702178f$export$47d10e7bd9c81890(_ref) {
    var typeKey = _ref.typeKey, defaultDropEffect = _ref.defaultDropEffect;
    var registry = new WeakMap();
    var dropTargetDataAtt = "data-drop-target-for-".concat(typeKey);
    var dropTargetSelector = "[".concat(dropTargetDataAtt, "]");
    function addToRegistry(args) {
        registry.set(args.element, args);
        return function() {
            return registry.delete(args.element);
        };
    }
    function dropTargetForConsumers(args) {
        var existing;
        var cleanup = (0, $jrlIh.combine)((0, $jNxxH.addAttribute)(args.element, {
            attribute: dropTargetDataAtt,
            value: 'true'
        }), addToRegistry(args));
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $LSEQ4.once)(cleanup);
    }
    function getActualDropTargets(_ref2) {
        var _args$getData, _args$getData2, _args$getDropEffect, _args$getDropEffect2;
        var source = _ref2.source, target = _ref2.target, input = _ref2.input, _ref2$result = _ref2.result, result = _ref2$result === void 0 ? [] : _ref2$result;
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        var closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        var args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        var feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        // calculate our new record
        var data = (_args$getData = (_args$getData2 = args.getData) === null || _args$getData2 === void 0 ? void 0 : _args$getData2.call(args, feedback)) !== null && _args$getData !== void 0 ? _args$getData : {};
        var dropEffect = (_args$getDropEffect = (_args$getDropEffect2 = args.getDropEffect) === null || _args$getDropEffect2 === void 0 ? void 0 : _args$getDropEffect2.call(args, feedback)) !== null && _args$getDropEffect !== void 0 ? _args$getDropEffect : defaultDropEffect;
        var record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [].concat((0, $lFOXD.default)(result), [
                record
            ])
        });
    }
    function notifyCurrent(_ref3) {
        var eventName = _ref3.eventName, payload = _ref3.payload;
        var _iterator = $b4b85775c702178f$var$_createForOfIteratorHelper(payload.location.current.dropTargets), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _entry$eventName;
                var record = _step.value;
                var entry = registry.get(record.element);
                var args = $b4b85775c702178f$var$_objectSpread($b4b85775c702178f$var$_objectSpread({}, payload), {}, {
                    self: record
                });
                entry === null || entry === void 0 || (_entry$eventName = entry[eventName]) === null || _entry$eventName === void 0 || _entry$eventName.call(entry, // I cannot seem to get the types right here.
                // TS doesn't seem to like that one event can need `nativeSetDragImage`
                // @ts-expect-error
                args);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }
    var actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: function onDropTargetChange(_ref4) {
            var payload = _ref4.payload;
            var isCurrent = new Set(payload.location.current.dropTargets.map(function(record) {
                return record.element;
            }));
            var visited = new Set();
            var _iterator2 = $b4b85775c702178f$var$_createForOfIteratorHelper(payload.location.previous.dropTargets), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _entry$onDropTargetCh;
                    var record = _step2.value;
                    visited.add(record.element);
                    var entry = registry.get(record.element);
                    var isOver = isCurrent.has(record.element);
                    var args = $b4b85775c702178f$var$_objectSpread($b4b85775c702178f$var$_objectSpread({}, payload), {}, {
                        self: record
                    });
                    entry === null || entry === void 0 || (_entry$onDropTargetCh = entry.onDropTargetChange) === null || _entry$onDropTargetCh === void 0 || _entry$onDropTargetCh.call(entry, args);
                    // if we cannot find the drop target in the current array, then it has been left
                    if (!isOver) {
                        var _entry$onDragLeave;
                        entry === null || entry === void 0 || (_entry$onDragLeave = entry.onDragLeave) === null || _entry$onDragLeave === void 0 || _entry$onDragLeave.call(entry, args);
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var _iterator3 = $b4b85775c702178f$var$_createForOfIteratorHelper(payload.location.current.dropTargets), _step3;
            try {
                for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                    var _entry$onDropTargetCh2, _entry$onDragEnter;
                    var _record = _step3.value;
                    // already published an update to this drop target
                    if (visited.has(_record.element)) continue;
                    // at this point we have a new drop target that is being entered into
                    var _args = $b4b85775c702178f$var$_objectSpread($b4b85775c702178f$var$_objectSpread({}, payload), {}, {
                        self: _record
                    });
                    var _entry = registry.get(_record.element);
                    _entry === null || _entry === void 0 || (_entry$onDropTargetCh2 = _entry.onDropTargetChange) === null || _entry$onDropTargetCh2 === void 0 || _entry$onDropTargetCh2.call(_entry, _args);
                    _entry === null || _entry === void 0 || (_entry$onDragEnter = _entry.onDragEnter) === null || _entry$onDragEnter === void 0 || _entry$onDragEnter.call(_entry, _args);
                }
            } catch (err) {
                _iterator3.e(err);
            } finally{
                _iterator3.f();
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver(_ref5) {
        var source = _ref5.source, target = _ref5.target, input = _ref5.input, current = _ref5.current;
        var actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        var lastCaptureOrdered = $b4b85775c702178f$var$copyReverse(current);
        var actualCaptureOrdered = $b4b85775c702178f$var$copyReverse(actual);
        var resultCaptureOrdered = [];
        for(var index = 0; index < lastCaptureOrdered.length; index++){
            var _argsForLast$getIsSti;
            var last = lastCaptureOrdered[index];
            var fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            var parent = resultCaptureOrdered[index - 1];
            var lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if ((parent === null || parent === void 0 ? void 0 : parent.element) !== (lastParent === null || lastParent === void 0 ? void 0 : lastParent.element)) break;
            // We need to check whether the old drop target can still be dropped on
            var argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            var feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!((_argsForLast$getIsSti = argsForLast.getIsSticky) !== null && _argsForLast$getIsSti !== void 0 && _argsForLast$getIsSti.call(argsForLast, feedback))) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push($b4b85775c702178f$var$_objectSpread($b4b85775c702178f$var$_objectSpread({}, last), {}, {
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            }));
        }
        // return bubble ordered result
        return $b4b85775c702178f$var$copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}

});
parcelRegister("jNxxH", function(module, exports) {
$parcel$export(module.exports, "addAttribute", function () { return $e69c9cc9a78ce998$export$5dcb5c23b6ba980a; });
function $e69c9cc9a78ce998$export$5dcb5c23b6ba980a(element, _ref) {
    var attribute = _ref.attribute, value = _ref.value;
    element.setAttribute(attribute, value);
    return function() {
        return element.removeAttribute(attribute);
    };
}

});


parcelRegister("2DD9Q", function(module, exports) {
$parcel$export(module.exports, "makeMonitor", function () { return $1ebd9937af4d03e5$export$5dd4ed888d5b12ca; });

var $f53LC = parcelRequire("f53LC");

var $LSEQ4 = parcelRequire("LSEQ4");
function $1ebd9937af4d03e5$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $1ebd9937af4d03e5$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $1ebd9937af4d03e5$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $1ebd9937af4d03e5$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $1ebd9937af4d03e5$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $1ebd9937af4d03e5$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $1ebd9937af4d03e5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1ebd9937af4d03e5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1ebd9937af4d03e5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1ebd9937af4d03e5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1ebd9937af4d03e5$export$5dd4ed888d5b12ca() {
    var registry = new Set();
    var dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        var entry = $1ebd9937af4d03e5$var$_objectSpread({}, args);
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        }
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $LSEQ4.once)(cleanup);
    }
    function dispatchEvent(_ref) {
        var eventName = _ref.eventName, payload = _ref.payload;
        if (eventName === 'onGenerateDragPreview') {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            var _iterator = $1ebd9937af4d03e5$var$_createForOfIteratorHelper(registry), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var monitor = _step.value;
                    tryAddToActive(monitor);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        var active = Array.from(dragging.active);
        for(var _i = 0, _active = active; _i < _active.length; _i++){
            var _monitor = _active[_i];
            // A monitor can be removed by another monitor during an event.
            // We need to check that the monitor is still registered before calling it
            if (dragging.active.has(_monitor)) {
                var _monitor$eventName;
                // @ts-expect-error: I cannot get this type working!
                (_monitor$eventName = _monitor[eventName]) === null || _monitor$eventName === void 0 || _monitor$eventName.call(_monitor, payload);
            }
        }
        if (eventName === 'onDrop') {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}

});


parcelRegister("lJqmY", function(module, exports) {
$parcel$export(module.exports, "isAndroid", function () { return $fd224162c5813617$export$a11b0059900ceec8; });
$parcel$export(module.exports, "androidFallbackText", function () { return $fd224162c5813617$export$aceb3ed8b7f7bd2c; });

var $LSEQ4 = parcelRequire("LSEQ4");
var $fd224162c5813617$export$a11b0059900ceec8 = (0, $LSEQ4.once)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes('android');
});
var $fd224162c5813617$export$aceb3ed8b7f7bd2c = 'pdnd:android-fallback';

});

parcelRegister("32gfR", function(module, exports) {
$parcel$export(module.exports, "textMediaType", function () { return $235e2adb5c73372c$export$fd3d00026297c0ad; });
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $235e2adb5c73372c$export$fd3d00026297c0ad = 'text/plain';

});

parcelRegister("6bk4h", function(module, exports) {
$parcel$export(module.exports, "URLMediaType", function () { return $4803563e49ee8c25$export$4c44a460f123106; });
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $4803563e49ee8c25$export$4c44a460f123106 = 'text/uri-list';

});

parcelRegister("Kswn1", function(module, exports) {
$parcel$export(module.exports, "elementAdapterNativeDataKey", function () { return $08ba6bb0561a593b$export$c9c4cc54e73b125d; });
/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ var $08ba6bb0561a593b$export$c9c4cc54e73b125d = 'application/vnd.pdnd';

});



parcelRegister("eDaGe", function(module, exports) {
$parcel$export(module.exports, "monitorForExternal", function () { return (parcelRequire("kB894")).monitorForExternal; });

var $kB894 = parcelRequire("kB894");
 // The data that is being dragged

});
parcelRegister("kB894", function(module, exports) {
$parcel$export(module.exports, "monitorForExternal", function () { return $efed94d33bb2fc91$export$bb1740f3194979c1; });

var $lFOXD = parcelRequire("lFOXD");

var $dH1HR = parcelRequire("dH1HR");

var $9LOtS = parcelRequire("9LOtS");

var $lJqmY = parcelRequire("lJqmY");

var $2WVea = parcelRequire("2WVea");

var $hl86x = parcelRequire("hl86x");

var $32gfR = parcelRequire("32gfR");

var $Kswn1 = parcelRequire("Kswn1");
function $efed94d33bb2fc91$export$a8e56a860d7957c7(_ref) {
    var type = _ref.type, value = _ref.value;
    // We don't want to expose our private elementAdapter key / value
    if (type === (0, $Kswn1.elementAdapterNativeDataKey)) return false;
    // Not exposing "text/plain" if it contains the android fallback text
    // We _could_ add an `isAndroid()` check, but it's probably safest
    // to trim this data out, regardless of what OS we see it on.
    if (type === (0, $32gfR.textMediaType) && value === (0, $lJqmY.androidFallbackText)) return false;
    return true;
}
function $efed94d33bb2fc91$export$8c257a3856120a77(transfer) {
    return Array.from(transfer.types).filter(function(type) {
        return $efed94d33bb2fc91$export$a8e56a860d7957c7({
            type: type,
            value: transfer.getData(type)
        });
    });
}
function $efed94d33bb2fc91$export$8d28cfecded8dcab(dataTransfer) {
    // item.kind is 'string' | 'file'
    // For 'string' item.type is the mimeType (eg 'text/plain')
    // For 'file' item.type is the file type (eg 'image/jpg')
    return Array.from(dataTransfer.items).filter(function(item) {
        return item.kind === 'file' || $efed94d33bb2fc91$export$a8e56a860d7957c7({
            type: item.type,
            value: dataTransfer.getData(item.type)
        });
    });
}
var $efed94d33bb2fc91$var$didDragStartLocally = false;
var $efed94d33bb2fc91$var$adapter = (0, $9LOtS.makeAdapter)({
    typeKey: 'external',
    // for external drags, we are generally making a copy of something that is being dragged
    defaultDropEffect: 'copy',
    mount: function mount(api) {
        // Binding to the `window` so that the element adapter
        // has a chance to get in first on the`document`.
        // We are giving preference to the element adapter.
        return (0, $dH1HR.bind)(window, {
            type: 'dragenter',
            listener: function listener(event) {
                // drag operation was started within the document, it won't be an "external" drag
                if ($efed94d33bb2fc91$var$didDragStartLocally) return;
                // Note: not checking if event was cancelled (`event.defaultPrevented`) as
                // cancelling a "dragenter" accepts the drag operation (not prevent it)
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                if (!api.canStart(event)) return;
                if (!(0, $2WVea.isEnteringWindow)({
                    dragEnter: event
                })) return;
                // Note: not checking types for `elementAdapterNativeDataKey` as we expect to see that
                // key when pdnd started the drag in another document
                var types = $efed94d33bb2fc91$export$8c257a3856120a77(event.dataTransfer);
                if (!types.length) return;
                var locked = {
                    types: types,
                    items: [],
                    getStringData: function getStringData() {
                        return null;
                    }
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'external',
                        startedFrom: 'external',
                        payload: locked,
                        getDropPayload: function getDropPayload(event) {
                            // this would be a platform error
                            // trying to handle it gracefully rather than throwing (for now)
                            if (!event.dataTransfer) return locked;
                            var items = $efed94d33bb2fc91$export$8d28cfecded8dcab(event.dataTransfer);
                            // need to use `.bind` as `getData` is required
                            // to be run with `event.dataTransfer` as the "this" context
                            var nativeGetData = event.dataTransfer.getData.bind(event.dataTransfer);
                            return {
                                types: types,
                                items: items,
                                // return `null` if there is no result, otherwise string
                                getStringData: function getStringData(mediaType) {
                                    // not dragging the requested type
                                    // return `null` (no result)
                                    if (!types.includes(mediaType)) return null;
                                    // nativeGetData will return `""` when there is no value,
                                    // but at this point we know we will only get explicitly set
                                    // values back as we have checked the `types`.
                                    // `""` can be an explicitly set value.
                                    var value = nativeGetData(mediaType);
                                    // not exposing data for unavailable types
                                    if (!$efed94d33bb2fc91$export$a8e56a860d7957c7({
                                        type: mediaType,
                                        value: value
                                    })) return null;
                                    return value;
                                }
                            };
                        }
                    }
                });
            }
        });
    }
});
function $efed94d33bb2fc91$export$9edc779df9a85289(args) {
    // not removing unused events, just leaning on the type system
    return $efed94d33bb2fc91$var$adapter.dropTarget(args);
}
function $efed94d33bb2fc91$export$bb1740f3194979c1(args) {
    // not removing unused events, just leaning on the type system
    return $efed94d33bb2fc91$var$adapter.monitor(args);
}
(function startup() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    // A shared single usage registration as we want to capture
    // all external drag operations, even if there are no drop targets
    // on the page yet
    $efed94d33bb2fc91$var$adapter.registerUsage();
    // independent of pdnd, we need to keep track of
    // all drag operations so that we can know if a drag operation
    // has started locally
    var idle = {
        type: 'idle'
    };
    var state = idle;
    function clear() {
        if (state.type !== 'dragging') return;
        $efed94d33bb2fc91$var$didDragStartLocally = false;
        state.cleanup();
        state = idle;
    }
    function bindEndEvents() {
        return (0, $dH1HR.bindAll)(window, [
            {
                type: 'dragend',
                listener: clear
            }
        ].concat((0, $lFOXD.default)((0, $hl86x.getBindingsForBrokenDrags)({
            onDragEnd: clear
        }))), // we want to make sure we get all the events,
        // and this helps avoid not seeing events when folks stop
        // them later on the event path
        {
            capture: true
        });
    }
    // we always keep this event listener active
    (0, $dH1HR.bind)(window, {
        type: 'dragstart',
        listener: function listener() {
            // something bad has happened if this is true!
            if (state.type !== 'idle') return;
            // set our global flag
            $efed94d33bb2fc91$var$didDragStartLocally = true;
            state = {
                type: 'dragging',
                cleanup: bindEndEvents()
            };
        },
        // binding in the capture phase so these listeners are called
        // before our listeners in the adapters `mount` function
        options: {
            capture: true
        }
    });
})(); /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Arguments given to all feedback functions (eg `canDrop()`) on a `dropTargetForExternal` */  /** Arguments given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForExternal` */ 

});
parcelRegister("2WVea", function(module, exports) {
$parcel$export(module.exports, "isEnteringWindow", function () { return $225d63bde78125d5$export$d1c6f249e893cdf4; });

var $gjrVx = parcelRequire("gjrVx");

var $6EVQu = parcelRequire("6EVQu");

var $jFod5 = parcelRequire("jFod5");

var $3RPG8 = parcelRequire("3RPG8");
function $225d63bde78125d5$export$d1c6f249e893cdf4(_ref) {
    var dragEnter = _ref.dragEnter;
    var type = dragEnter.type, relatedTarget = dragEnter.relatedTarget;
    if (type !== 'dragenter') return false;
    if ((0, $6EVQu.isSafari)()) return (0, $jFod5.isEnteringWindowInSafari)({
        dragEnter: dragEnter
    });
    // standard check
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is the `iframe` element in the parent `window`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is an element inside the child `iframe`
   * (foreign element)
   */ if ((0, $gjrVx.isFirefox)()) return (0, $3RPG8.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is `null` *(standard check)*
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is the `iframe` element in the parent `window`
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});



parcelRegister("d58at", function(module, exports) {
$parcel$export(module.exports, "monitorForTextSelection", function () { return (parcelRequire("fJq9X")).monitorForTextSelection; });

var $fJq9X = parcelRequire("fJq9X");
 // Payload for the text selection being dragged

});
parcelRegister("fJq9X", function(module, exports) {
$parcel$export(module.exports, "monitorForTextSelection", function () { return $b73f59c29195457a$export$2e178e3647f5e6e9; });

var $dH1HR = parcelRequire("dH1HR");

var $hDj86 = parcelRequire("hDj86");

var $9LOtS = parcelRequire("9LOtS");

var $jrlIh = parcelRequire("jrlIh");

var $6EVQu = parcelRequire("6EVQu");

var $ihvnn = parcelRequire("ihvnn");

var $32gfR = parcelRequire("32gfR");

var $Kswn1 = parcelRequire("Kswn1");
function $b73f59c29195457a$var$findTextNode(event) {
    var _event$dataTransfer;
    // Standard: the `event.target` should be the closest `Text` node.
    if (event.target instanceof Text) return event.target;
    // Structuring things this way so that if Safari fixes their bug
    // then the standard check will start working
    if (!(0, $6EVQu.isSafari)()) return null;
    /**
   * According to the spec, `event.target` should be the `Text` node that
   * the drag started from when dragging a text selection.
   *
   * → https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
   *
   * However, in Safari the closest `HTMLElement` is returned.
   * So we need to figure out if text is dragging ourselves.
   *
   * → https://bugs.webkit.org/show_bug.cgi?id=268959
   */ if (!(event.target instanceof HTMLElement)) return null;
    // Unlikely that this particular drag is a text selection drag
    if (event.target.draggable) return null;
    // if the drag contains no text data, then not dragging selected text
    // return `null` if there is no dataTransfer, or if `getData()` returns ""
    if (!((_event$dataTransfer = event.dataTransfer) !== null && _event$dataTransfer !== void 0 && _event$dataTransfer.getData((0, $32gfR.textMediaType)))) return null;
    /**
   * Grab the first Text node and use that.
   * Only doing a single level search as that is all we need for this bug.
   */ var text = Array.from(event.target.childNodes).find(function(node) {
        return node.nodeType === Node.TEXT_NODE;
    });
    return text !== null && text !== void 0 ? text : null;
}
var $b73f59c29195457a$var$honeyPotFix = (0, $hDj86.makeHoneyPotFix)();
var $b73f59c29195457a$var$adapter = (0, $9LOtS.makeAdapter)({
    typeKey: 'text-selection',
    // for text selection, we will usually be making a copy of the text
    defaultDropEffect: 'copy',
    mount: function mount(api) {
        // Binding to the `window` so that the element adapter has a
        // chance to get in first on the `document`.
        // We are giving preference to the element adapter.
        return (0, $jrlIh.combine)($b73f59c29195457a$var$honeyPotFix.bindEvents(), (0, $dH1HR.bind)(window, {
            type: 'dragstart',
            listener: function listener(event) {
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                // Drag is being handled by the element adapter
                if (event.dataTransfer.types.includes((0, $Kswn1.elementAdapterNativeDataKey))) return;
                // Something else is handling this drag
                if (!api.canStart(event)) return;
                // no text being dragged
                if (!event.dataTransfer.types.includes((0, $32gfR.textMediaType))) return;
                var target = $b73f59c29195457a$var$findTextNode(event);
                // could not find `Text` node that is being dragged from
                if (!target) return;
                var payload = {
                    // The `Text` node that is the `target` is the `Text` node
                    // that the user started the drag from.
                    // The full text being dragged can be looked up from the `dataTransfer`.
                    target: target,
                    plain: event.dataTransfer.getData((0, $32gfR.textMediaType)),
                    HTML: event.dataTransfer.getData((0, $ihvnn.HTMLMediaType))
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'text-selection',
                        startedFrom: 'internal',
                        payload: payload
                    }
                });
            }
        }));
    },
    onPostDispatch: $b73f59c29195457a$var$honeyPotFix.getOnPostDispatch()
});
function $b73f59c29195457a$export$9bfaa8eb182300d1(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $b73f59c29195457a$var$adapter.dropTarget(args);
}
// A shared single usage registration as any text can be dragged at any time
(function register() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    $b73f59c29195457a$var$adapter.registerUsage();
})();
function $b73f59c29195457a$export$2e178e3647f5e6e9(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $b73f59c29195457a$var$adapter.monitor(args);
} /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Argument given to all feedback functions (eg `canDrop()`) on a `dropTargetForExternal` */  /** Argument given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForExternal` */ 

});
parcelRegister("ihvnn", function(module, exports) {
$parcel$export(module.exports, "HTMLMediaType", function () { return $d4f227288019bb04$export$338a9f6c7a1f02b0; });
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $d4f227288019bb04$export$338a9f6c7a1f02b0 = 'text/html';

});



parcelRegister("15dQb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0ca0fe88a1c58975$export$2e2bcd8739ae039; });
/* badge.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kG2I3 = parcelRequire("kG2I3");

var $gwKpR = parcelRequire("gwKpR");

var $8gp1u = parcelRequire("8gp1u");

var $kBxVG = parcelRequire("kBxVG");

var $1QDdc = parcelRequire("1QDdc");
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they will be updated in the labelling system work and we want to avoid frequent UI changes.\
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ var $0ca0fe88a1c58975$var$neutral300 = '#DDDEE1';
var $0ca0fe88a1c58975$var$red300 = '#FD9891';
var $0ca0fe88a1c58975$var$blue300 = '#8FB8F6';
var $0ca0fe88a1c58975$var$neutral1000 = '#292A2E';
var $0ca0fe88a1c58975$var$styles = {
    root: "_2rkolb4i _18zr1b66 _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    added: "_bfhk1y9u _syazi7uo",
    default: "_bfhk1fkg _syazwwip",
    important: "_bfhk1366 _syazwwip",
    primary: "_bfhk1ymo _syazwwip",
    primaryInverted: "_bfhkvuon _syaz1oa5",
    removed: "_bfhk1gly _syazi7uo"
};
var $0ca0fe88a1c58975$var$badgeValueWithNegativeNumberSupported = function badgeValueWithNegativeNumberSupported(children, max) {
    return typeof children === 'number' && typeof max === 'number' ? (0, $1QDdc.formatValueWithNegativeSupport)(children, max) : children;
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ var $0ca0fe88a1c58975$var$Badge = /*#__PURE__*/ (0, $1oC0p.memo)(function Badge(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$children = _ref.children, children = _ref$children === void 0 ? 0 : _ref$children, _ref$max = _ref.max, max = _ref$max === void 0 ? 99 : _ref$max, style = _ref.style, testId = _ref.testId;
    if ((0, $gwKpR.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        // Map old appearance names to new ones
        var newAppearance = (0, $kBxVG.appearanceMapping)[appearance];
        return(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        $1oC0p.createElement((0, $kBxVG.default), {
            appearance: newAppearance,
            max: max,
            style: style,
            testId: testId
        }, children));
    }
    var oldAppearance = (0, $kBxVG.appearanceMappingToOld)[appearance];
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, $kG2I3.default)([
            $0ca0fe88a1c58975$var$styles.root,
            $0ca0fe88a1c58975$var$styles[oldAppearance]
        ])
    }, /*#__PURE__*/ $1oC0p.createElement((0, $8gp1u.default), {
        size: "small",
        align: "center",
        color: "inherit"
    }, $0ca0fe88a1c58975$var$badgeValueWithNegativeNumberSupported(children, max)));
});
var $0ca0fe88a1c58975$export$2e2bcd8739ae039 = $0ca0fe88a1c58975$var$Badge;

});
parcelRegister("kG2I3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f0d9d4f807236989$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $f0d9d4f807236989$var$ATOMIC_GROUP_LENGTH = 5;
function $f0d9d4f807236989$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $f0d9d4f807236989$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("gwKpR", function(module, exports) {
$parcel$export(module.exports, "fg", function () { return $c083a3c67ef697ed$export$b40ec24ac8275656; });

var $hPqhw = parcelRequire("hPqhw");
function $c083a3c67ef697ed$export$ba05d765b8392e5e(flagResolver) {
    (0, $hPqhw.setBooleanResolver)(flagResolver);
}
function $c083a3c67ef697ed$export$470e5c2be1411c89(name) {
    return (0, $hPqhw.resolveBooleanFlag)(name);
}
function $c083a3c67ef697ed$export$b40ec24ac8275656(name) {
    return (0, $hPqhw.resolveBooleanFlag)(name);
}

});
parcelRegister("hPqhw", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", function () { return $cfab9614585cf4b1$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $cfab9614585cf4b1$export$6333b6aff9fc6275; });

var $ddFWy = parcelRequire("ddFWy");

var $f2TWO = parcelRequire("f2TWO");

var $7t0tI = parcelRequire("7t0tI");
var $cfab9614585cf4b1$var$pkgName = '@atlaskit/platform-feature-flags';
var $cfab9614585cf4b1$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $cfab9614585cf4b1$var$hasProcessEnv = typeof $7t0tI !== 'undefined' && typeof $7t0tI.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $cfab9614585cf4b1$var$ENV_ENABLE_PLATFORM_FF = $cfab9614585cf4b1$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $cfab9614585cf4b1$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $cfab9614585cf4b1$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $cfab9614585cf4b1$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $cfab9614585cf4b1$var$ENV_ENABLE_PLATFORM_FF || $cfab9614585cf4b1$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $cfab9614585cf4b1$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $cfab9614585cf4b1$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$cfab9614585cf4b1$var$globalVar[$cfab9614585cf4b1$export$7e41b1b2bdee3f98] = $cfab9614585cf4b1$var$globalVar[$cfab9614585cf4b1$export$7e41b1b2bdee3f98] || $cfab9614585cf4b1$var$DEFAULT_PFF_GLOBAL;
function $cfab9614585cf4b1$export$f2b591175b3e424c(resolver) {
    $cfab9614585cf4b1$var$globalVar[$cfab9614585cf4b1$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $cfab9614585cf4b1$export$6333b6aff9fc6275(flagKey) {
    if ($cfab9614585cf4b1$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $f2TWO.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $cfab9614585cf4b1$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $cfab9614585cf4b1$var$globalVar[$cfab9614585cf4b1$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $cfab9614585cf4b1$var$globalVar[$cfab9614585cf4b1$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $ddFWy.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $cfab9614585cf4b1$var$globalVar[$cfab9614585cf4b1$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("ddFWy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $99fd0653c81347e7$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $8Lp8W = parcelRequire("8Lp8W");

var $8Datk = parcelRequire("8Datk");



var $99fd0653c81347e7$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $99fd0653c81347e7$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, $cTewU.default)(this, FeatureGates);
    }
    return (0, $avOEA.default)(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$99fd0653c81347e7$var$_FeatureGates = $99fd0653c81347e7$var$FeatureGates;
(0, $f53LC.default)($99fd0653c81347e7$var$FeatureGates, "client", new (0, $8Lp8W.Client)());
(0, $f53LC.default)($99fd0653c81347e7$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, $f53LC.default)($99fd0653c81347e7$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, $f53LC.default)($99fd0653c81347e7$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$99fd0653c81347e7$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $99fd0653c81347e7$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $99fd0653c81347e7$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, $f53LC.default)($99fd0653c81347e7$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$99fd0653c81347e7$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $99fd0653c81347e7$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $99fd0653c81347e7$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, $f53LC.default)($99fd0653c81347e7$var$FeatureGates, "initializeCalled", $99fd0653c81347e7$var$_FeatureGates.client.initializeCalled.bind($99fd0653c81347e7$var$_FeatureGates.client));
(0, $f53LC.default)($99fd0653c81347e7$var$FeatureGates, "initializeCompleted", $99fd0653c81347e7$var$_FeatureGates.client.initializeCompleted.bind($99fd0653c81347e7$var$_FeatureGates.client));
(0, $f53LC.default)($99fd0653c81347e7$var$FeatureGates, "waitUntilInitializeCompleted", $99fd0653c81347e7$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($99fd0653c81347e7$var$_FeatureGates.client));
(0, $f53LC.default)($99fd0653c81347e7$var$FeatureGates, "initialize", $99fd0653c81347e7$var$_FeatureGates.client.initialize.bind($99fd0653c81347e7$var$_FeatureGates.client));
(0, $f53LC.default)($99fd0653c81347e7$var$FeatureGates, "initializeWithProvider", $99fd0653c81347e7$var$_FeatureGates.client.initializeWithProvider.bind($99fd0653c81347e7$var$_FeatureGates.client));
(0, $f53LC.default)($99fd0653c81347e7$var$FeatureGates, "initializeFromValues", $99fd0653c81347e7$var$_FeatureGates.client.initializeFromValues.bind($99fd0653c81347e7$var$_FeatureGates.client));
(0, $f53LC.default)($99fd0653c81347e7$var$FeatureGates, "manuallyLogGateExposure", $99fd0653c81347e7$var$_FeatureGates.client.manuallyLogGateExposure.bind($99fd0653c81347e7$var$_FeatureGates.client));
(0, $f53LC.default)($99fd0653c81347e7$var$FeatureGates, "getExperiment", $99fd0653c81347e7$var$_FeatureGates.client.getExperiment.bind($99fd0653c81347e7$var$_FeatureGates.client));
(0, $f53LC.default)($99fd0653c81347e7$var$FeatureGates, "manuallyLogExperimentExposure", $99fd0653c81347e7$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($99fd0653c81347e7$var$_FeatureGates.client));
(0, $f53LC.default)($99fd0653c81347e7$var$FeatureGates, "manuallyLogLayerExposure", $99fd0653c81347e7$var$_FeatureGates.client.manuallyLogLayerExposure.bind($99fd0653c81347e7$var$_FeatureGates.client));
(0, $f53LC.default)($99fd0653c81347e7$var$FeatureGates, "shutdownStatsig", $99fd0653c81347e7$var$_FeatureGates.client.shutdownStatsig.bind($99fd0653c81347e7$var$_FeatureGates.client));
(0, $f53LC.default)($99fd0653c81347e7$var$FeatureGates, "overrideGate", $99fd0653c81347e7$var$_FeatureGates.client.overrideGate.bind($99fd0653c81347e7$var$_FeatureGates.client));
(0, $f53LC.default)($99fd0653c81347e7$var$FeatureGates, "clearGateOverride", $99fd0653c81347e7$var$_FeatureGates.client.clearGateOverride.bind($99fd0653c81347e7$var$_FeatureGates.client));
(0, $f53LC.default)($99fd0653c81347e7$var$FeatureGates, "overrideConfig", $99fd0653c81347e7$var$_FeatureGates.client.overrideConfig.bind($99fd0653c81347e7$var$_FeatureGates.client));
(0, $f53LC.default)($99fd0653c81347e7$var$FeatureGates, "clearConfigOverride", $99fd0653c81347e7$var$_FeatureGates.client.clearConfigOverride.bind($99fd0653c81347e7$var$_FeatureGates.client));
(0, $f53LC.default)($99fd0653c81347e7$var$FeatureGates, "setOverrides", $99fd0653c81347e7$var$_FeatureGates.client.setOverrides.bind($99fd0653c81347e7$var$_FeatureGates.client));
(0, $f53LC.default)($99fd0653c81347e7$var$FeatureGates, "getOverrides", $99fd0653c81347e7$var$_FeatureGates.client.getOverrides.bind($99fd0653c81347e7$var$_FeatureGates.client));
(0, $f53LC.default)($99fd0653c81347e7$var$FeatureGates, "clearAllOverrides", $99fd0653c81347e7$var$_FeatureGates.client.clearAllOverrides.bind($99fd0653c81347e7$var$_FeatureGates.client));
(0, $f53LC.default)($99fd0653c81347e7$var$FeatureGates, "isCurrentUser", $99fd0653c81347e7$var$_FeatureGates.client.isCurrentUser.bind($99fd0653c81347e7$var$_FeatureGates.client));
(0, $f53LC.default)($99fd0653c81347e7$var$FeatureGates, "onGateUpdated", $99fd0653c81347e7$var$_FeatureGates.client.onGateUpdated.bind($99fd0653c81347e7$var$_FeatureGates.client));
(0, $f53LC.default)($99fd0653c81347e7$var$FeatureGates, "onExperimentValueUpdated", $99fd0653c81347e7$var$_FeatureGates.client.onExperimentValueUpdated.bind($99fd0653c81347e7$var$_FeatureGates.client));
(0, $f53LC.default)($99fd0653c81347e7$var$FeatureGates, "onAnyUpdated", $99fd0653c81347e7$var$_FeatureGates.client.onAnyUpdated.bind($99fd0653c81347e7$var$_FeatureGates.client));
(0, $f53LC.default)($99fd0653c81347e7$var$FeatureGates, "updateUser", $99fd0653c81347e7$var$_FeatureGates.client.updateUser.bind($99fd0653c81347e7$var$_FeatureGates.client));
(0, $f53LC.default)($99fd0653c81347e7$var$FeatureGates, "updateUserWithProvider", $99fd0653c81347e7$var$_FeatureGates.client.updateUserWithProvider.bind($99fd0653c81347e7$var$_FeatureGates.client));
(0, $f53LC.default)($99fd0653c81347e7$var$FeatureGates, "updateUserWithValues", $99fd0653c81347e7$var$_FeatureGates.client.updateUserWithValues.bind($99fd0653c81347e7$var$_FeatureGates.client));
(0, $f53LC.default)($99fd0653c81347e7$var$FeatureGates, "getPackageVersion", $99fd0653c81347e7$var$_FeatureGates.client.getPackageVersion.bind($99fd0653c81347e7$var$_FeatureGates.client));
(0, $f53LC.default)($99fd0653c81347e7$var$FeatureGates, "getLayer", $99fd0653c81347e7$var$_FeatureGates.client.getLayer.bind($99fd0653c81347e7$var$_FeatureGates.client));
(0, $f53LC.default)($99fd0653c81347e7$var$FeatureGates, "getLayerValue", $99fd0653c81347e7$var$_FeatureGates.client.getLayerValue.bind($99fd0653c81347e7$var$_FeatureGates.client));
var $99fd0653c81347e7$var$boundFGJS = $99fd0653c81347e7$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $99fd0653c81347e7$var$FeatureGates;
    else {
        var $99fd0653c81347e7$var$_boundFGJS, $99fd0653c81347e7$var$_boundFGJS$getPackage;
        $99fd0653c81347e7$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $99fd0653c81347e7$var$boundVersion = (($99fd0653c81347e7$var$_boundFGJS = $99fd0653c81347e7$var$boundFGJS) === null || $99fd0653c81347e7$var$_boundFGJS === void 0 || ($99fd0653c81347e7$var$_boundFGJS$getPackage = $99fd0653c81347e7$var$_boundFGJS.getPackageVersion) === null || $99fd0653c81347e7$var$_boundFGJS$getPackage === void 0 ? void 0 : $99fd0653c81347e7$var$_boundFGJS$getPackage.call($99fd0653c81347e7$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($99fd0653c81347e7$var$boundVersion !== (0, $8Datk.CLIENT_VERSION)) {
            var $99fd0653c81347e7$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($99fd0653c81347e7$var$boundVersion, " when module version ").concat((0, $8Datk.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($99fd0653c81347e7$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $99fd0653c81347e7$export$2e2bcd8739ae039 = $99fd0653c81347e7$var$boundFGJS;

});
parcelRegister("8Lp8W", function(module, exports) {
$parcel$export(module.exports, "Client", function () { return $66163774857def6b$export$1f2bb630327ac4b6; });

var $gnQ3X = parcelRequire("gnQ3X");

var $2qaZZ = parcelRequire("2qaZZ");

var $cn8ql = parcelRequire("cn8ql");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $5Cxn4 = parcelRequire("5Cxn4");

var $ec1qE = parcelRequire("ec1qE");

var $25hr3 = parcelRequire("25hr3");

var $6IINe = parcelRequire("6IINe");

var $4JyI4 = parcelRequire("4JyI4");

var $6VkYP = parcelRequire("6VkYP");

var $etVaO = parcelRequire("etVaO");

var $dJCHO = parcelRequire("dJCHO");

var $luvhR = parcelRequire("luvhR");

var $6e0cU = parcelRequire("6e0cU");

var $4LLD2 = parcelRequire("4LLD2");

var $8Datk = parcelRequire("8Datk");
var $66163774857def6b$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $66163774857def6b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $66163774857def6b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $66163774857def6b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $66163774857def6b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $66163774857def6b$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $66163774857def6b$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $66163774857def6b$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $luvhR.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, $cTewU.default)(this, Client);
        (0, $f53LC.default)(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, $f53LC.default)(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, $f53LC.default)(this, "initWithDefaults", false);
        (0, $f53LC.default)(this, "hasCheckGateErrorOccurred", false);
        (0, $f53LC.default)(this, "hasGetExperimentErrorOccurred", false);
        (0, $f53LC.default)(this, "hasGetExperimentValueErrorOccurred", false);
        (0, $f53LC.default)(this, "hasGetLayerErrorOccurred", false);
        (0, $f53LC.default)(this, "hasGetLayerValueErrorOccurred", false);
        (0, $f53LC.default)(this, "subscriptions", new (0, $25hr3.default)());
        (0, $f53LC.default)(this, "dataAdapter", new (0, $dJCHO.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, $f53LC.default)(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $luvhR.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, $avOEA.default)(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $4LLD2.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $4LLD2.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $4LLD2.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $4LLD2.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $8Datk.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $66163774857def6b$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $8Datk.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $6e0cU.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $4LLD2.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $4LLD2.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $4LLD2.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $etVaO.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 2;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 2:
                                if (!this.initCompleted) {
                                    _context7.next = 4;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 4:
                                _context7.next = 6;
                                return this.initPromise;
                            case 6:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $6IINe.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $6IINe.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $6VkYP.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $4LLD2.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $4LLD2.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $66163774857def6b$var$_objectSpread({}, clientOptions);
                                _context8.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $etVaO.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $etVaO.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, $2qaZZ.default)(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 20;
                                break;
                            case 13:
                                _context8.prev = 13;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context8.t0;
                            case 20:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $66163774857def6b$var$_objectSpread($66163774857def6b$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, $2qaZZ.default)(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 22;
                                break;
                            case 15:
                                _context9.prev = 15;
                                _context9.t0 = _context9["catch"](1);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context9.t0;
                            case 22:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args0 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee0$(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $4LLD2.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $66163774857def6b$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $66163774857def6b$var$_objectSpread($66163774857def6b$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $66163774857def6b$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $6e0cU.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, $gnQ3X.default)(newClientOptions, $66163774857def6b$var$_excluded);
                                this.user = (0, $4LLD2.toStatsigUser)(identifiers, customAttributes);
                                statsigOptions = $66163774857def6b$var$_objectSpread($66163774857def6b$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $ec1qE.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $ec1qE.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 12;
                                this.statsigClient = new (0, $ec1qE.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context0.next = 29;
                                break;
                            case 19:
                                _context0.prev = 19;
                                _context0.t0 = _context0["catch"](12);
                                if (_context0.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context0.t0 === null || _context0.t0 === void 0 ? void 0 : _context0.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $ec1qE.StatsigClient)($66163774857def6b$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context0.t0;
                            case 29:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 3;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 5;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 6;
                                _context10.next = 9;
                                return this.initPromise;
                            case 9:
                                _context10.next = 13;
                                break;
                            case 11:
                                _context10.prev = 11;
                                _context10.t0 = _context10["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee1$(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 4;
                                                    break;
                                                }
                                                _context1.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context11.sent;
                                user = (0, $4LLD2.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                _context11.next = 13;
                                break;
                            case 8:
                                _context11.prev = 8;
                                _context11.t0 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context11.t0 instanceof Error ? _context11.t0.message : JSON.stringify(_context11.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context11.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 21;
                                    break;
                                }
                                _context11.next = 21;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 21:
                                _context11.next = 27;
                                break;
                            case 23:
                                _context11.prev = 23;
                                _context11.t1 = _context11["catch"](15);
                                success = false;
                                errorMessage = String(_context11.t1);
                            case 27:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 34;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 35;
                                break;
                            case 34:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 35:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            23
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $8Datk.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $4JyI4.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $4JyI4.Layer).fromLayer((0, $ec1qE._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("25hr3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $184992b0416428da$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $f72YL = parcelRequire("f72YL");
function $184992b0416428da$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $184992b0416428da$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $184992b0416428da$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $184992b0416428da$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $184992b0416428da$export$a66cbd9b2289cd78 = '@all-features';
var $184992b0416428da$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, $cTewU.default)(this, Subscriptions);
        (0, $f53LC.default)(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($f72YL)))();
    }
    return (0, $avOEA.default)(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $184992b0416428da$var$_objectSpread($184992b0416428da$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $184992b0416428da$var$_objectSpread($184992b0416428da$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $184992b0416428da$var$_objectSpread($184992b0416428da$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $184992b0416428da$var$_objectSpread($184992b0416428da$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($184992b0416428da$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($184992b0416428da$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($184992b0416428da$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $184992b0416428da$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("6IINe", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", function () { return $4e49991c35a8059c$export$6dc24881a3d96325; });

var $2zYm4 = parcelRequire("2zYm4");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $4LLD2 = parcelRequire("4LLD2");
var $4e49991c35a8059c$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, $cTewU.default)(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, $avOEA.default)(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, $2zYm4.default)(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, $2zYm4.default)(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $4LLD2.migrateEvaluationDetails)(experiment.details), (0, $4LLD2.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("4LLD2", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", function () { return $37907f41fd32c4e2$export$d119b37e5f788b43; });
$parcel$export(module.exports, "shallowEquals", function () { return $37907f41fd32c4e2$export$fa1c2bbf4100b8bc; });
$parcel$export(module.exports, "toStatsigUser", function () { return $37907f41fd32c4e2$export$3dad1db244472f32; });
$parcel$export(module.exports, "migrateInitializationOptions", function () { return $37907f41fd32c4e2$export$202946b690d26d22; });
$parcel$export(module.exports, "migrateEvaluationDetails", function () { return $37907f41fd32c4e2$export$18ad168d3dbac899; });
$parcel$export(module.exports, "migrateSecondaryExposures", function () { return $37907f41fd32c4e2$export$55fd683752d01e67; });

var $gnQ3X = parcelRequire("gnQ3X");

var $2qaZZ = parcelRequire("2qaZZ");

var $f53LC = parcelRequire("f53LC");

var $hMUFv = parcelRequire("hMUFv");

var $6VkYP = parcelRequire("6VkYP");

var $6e0cU = parcelRequire("6e0cU");
var $37907f41fd32c4e2$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $37907f41fd32c4e2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $37907f41fd32c4e2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $37907f41fd32c4e2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $37907f41fd32c4e2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $37907f41fd32c4e2$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $37907f41fd32c4e2$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $hMUFv.isFedRamp)() ? (0, $6e0cU.PerimeterType).FEDRAMP_MODERATE : (0, $6e0cU.PerimeterType).COMMERCIAL
    }, options);
};
var $37907f41fd32c4e2$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, $2qaZZ.default)(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, $2qaZZ.default)(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, $2qaZZ.default)(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, $2qaZZ.default)(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $37907f41fd32c4e2$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    var user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $37907f41fd32c4e2$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, $gnQ3X.default)(options, $37907f41fd32c4e2$var$_excluded);
    return $37907f41fd32c4e2$var$_objectSpread($37907f41fd32c4e2$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $37907f41fd32c4e2$var$evaluationReasonMappings = Object.entries((0, $6VkYP.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, $2qaZZ.default)(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $37907f41fd32c4e2$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $37907f41fd32c4e2$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, $2qaZZ.default)(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $6VkYP.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $37907f41fd32c4e2$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("6VkYP", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", function () { return $50a85727b11d860e$export$c62558b199e46828; });
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $50a85727b11d860e$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("6e0cU", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", function () { return $4884360541a97f84$export$479e7351a733299; });
$parcel$export(module.exports, "PerimeterType", function () { return $4884360541a97f84$export$c42b7bbc5e7ba555; });
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $4884360541a97f84$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $4884360541a97f84$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $4884360541a97f84$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("4JyI4", function(module, exports) {
$parcel$export(module.exports, "Layer", function () { return $37264a0bfd5e8d6c$export$936d0764594b6eb3; });

var $2zYm4 = parcelRequire("2zYm4");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $4LLD2 = parcelRequire("4LLD2");
var $37264a0bfd5e8d6c$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, $cTewU.default)(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, $avOEA.default)(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, $2zYm4.default)(val) === (0, $2zYm4.default)(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $4LLD2.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $4LLD2.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $4LLD2.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("etVaO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a8b01f8ec3e7cfde$export$2e2bcd8739ae039; });

var $f53LC = parcelRequire("f53LC");

var $cn8ql = parcelRequire("cn8ql");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $5Cxn4 = parcelRequire("5Cxn4");

var $6e0cU = parcelRequire("6e0cU");

var $8Datk = parcelRequire("8Datk");

var $d9T25 = parcelRequire("d9T25");
function $a8b01f8ec3e7cfde$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a8b01f8ec3e7cfde$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a8b01f8ec3e7cfde$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a8b01f8ec3e7cfde$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a8b01f8ec3e7cfde$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $a8b01f8ec3e7cfde$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $a8b01f8ec3e7cfde$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $a8b01f8ec3e7cfde$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $a8b01f8ec3e7cfde$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $a8b01f8ec3e7cfde$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $a8b01f8ec3e7cfde$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $a8b01f8ec3e7cfde$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $a8b01f8ec3e7cfde$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $a8b01f8ec3e7cfde$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $a8b01f8ec3e7cfde$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, $cTewU.default)(this, Fetcher);
    }
    return (0, $avOEA.default)(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error('Failed to retrieve client sdk key');
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error('Failed to retrieve experiment values');
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $d9T25.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $d9T25.ResponseError)('Unexpected 204 response');
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $a8b01f8ec3e7cfde$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $6e0cU.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $6e0cU.FeatureGateEnvironment).Production:
                        return $a8b01f8ec3e7cfde$export$18c93900db9358a4;
                    case (0, $6e0cU.FeatureGateEnvironment).Staging:
                        return $a8b01f8ec3e7cfde$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $6e0cU.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $6e0cU.FeatureGateEnvironment).Development:
                        return $a8b01f8ec3e7cfde$export$f058dbf75c3bc647;
                    case (0, $6e0cU.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $a8b01f8ec3e7cfde$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $a8b01f8ec3e7cfde$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $a8b01f8ec3e7cfde$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $a8b01f8ec3e7cfde$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $8Datk.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $a8b01f8ec3e7cfde$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($a8b01f8ec3e7cfde$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($a8b01f8ec3e7cfde$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("8Datk", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", function () { return $648a16c5164adb95$export$a59f8d67326bd1cb; });
/// <reference types="node" />
var $648a16c5164adb95$export$a59f8d67326bd1cb = "0.0.0-development";

});

parcelRegister("d9T25", function(module, exports) {
$parcel$export(module.exports, "ResponseError", function () { return $9946cdf44f871a21$export$286baf652d0b1206; });

var $avOEA = parcelRequire("avOEA");

var $cTewU = parcelRequire("cTewU");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $i7dvh = parcelRequire("i7dvh");

var $4GELH = parcelRequire("4GELH");
function $9946cdf44f871a21$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $9946cdf44f871a21$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $9946cdf44f871a21$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($9946cdf44f871a21$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $9946cdf44f871a21$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, $cTewU.default)(this, ResponseError);
        return $9946cdf44f871a21$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, $i7dvh.default)(ResponseError, _Error);
    return (0, $avOEA.default)(ResponseError);
}(/*#__PURE__*/ (0, $4GELH.default)(Error));

});


parcelRegister("dJCHO", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", function () { return $9ffd8075b0d8773f$export$55fffef3474104af; });

var $cn8ql = parcelRequire("cn8ql");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $7SQOE = parcelRequire("7SQOE");

var $i7dvh = parcelRequire("i7dvh");

var $f53LC = parcelRequire("f53LC");

var $5Cxn4 = parcelRequire("5Cxn4");

var $ec1qE = parcelRequire("ec1qE");
function $9ffd8075b0d8773f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9ffd8075b0d8773f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9ffd8075b0d8773f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9ffd8075b0d8773f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9ffd8075b0d8773f$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $9ffd8075b0d8773f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $9ffd8075b0d8773f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($9ffd8075b0d8773f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $9ffd8075b0d8773f$var$_superPropGet(t, o, e, r) {
    var p = (0, $7SQOE.default)((0, $jlBwm.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $9ffd8075b0d8773f$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, $cTewU.default)(this, NoFetchDataAdapter);
        _this = $9ffd8075b0d8773f$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, $f53LC.default)(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, $i7dvh.default)(NoFetchDataAdapter, _DataAdapterCore);
    return (0, $avOEA.default)(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $ec1qE.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $9ffd8075b0d8773f$var$_objectSpread($9ffd8075b0d8773f$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $ec1qE._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $9ffd8075b0d8773f$var$_objectSpread($9ffd8075b0d8773f$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $ec1qE._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $ec1qE._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $ec1qE.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $9ffd8075b0d8773f$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $9ffd8075b0d8773f$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $ec1qE.DataAdapterCore));

});

parcelRegister("luvhR", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", function () { return $fa54ab49563aee77$export$d8474cff104280f3; });
$parcel$export(module.exports, "PersistentOverrideAdapter", function () { return $fa54ab49563aee77$export$bcb28fbac1def494; });

var $f53LC = parcelRequire("f53LC");

var $2qaZZ = parcelRequire("2qaZZ");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $3wfvf = parcelRequire("3wfvf");
function $fa54ab49563aee77$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fa54ab49563aee77$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fa54ab49563aee77$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fa54ab49563aee77$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fa54ab49563aee77$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $fa54ab49563aee77$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $fa54ab49563aee77$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $fa54ab49563aee77$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $fa54ab49563aee77$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $fa54ab49563aee77$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $fa54ab49563aee77$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $fa54ab49563aee77$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $fa54ab49563aee77$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $fa54ab49563aee77$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $fa54ab49563aee77$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $fa54ab49563aee77$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, $cTewU.default)(this, PersistentOverrideAdapter);
        this._overrides = $fa54ab49563aee77$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, $avOEA.default)(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $fa54ab49563aee77$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $fa54ab49563aee77$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $fa54ab49563aee77$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, $2qaZZ.default)(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, $2qaZZ.default)(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, $2qaZZ.default)(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($fa54ab49563aee77$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($fa54ab49563aee77$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $fa54ab49563aee77$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $3wfvf._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $fa54ab49563aee77$var$_objectSpread($fa54ab49563aee77$var$_objectSpread({}, $fa54ab49563aee77$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, $2qaZZ.default)(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, $2qaZZ.default)(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($fa54ab49563aee77$var$djb2MapKey((0, $3wfvf._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($fa54ab49563aee77$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($fa54ab49563aee77$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($fa54ab49563aee77$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $fa54ab49563aee77$var$_objectSpread($fa54ab49563aee77$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $fa54ab49563aee77$var$_objectSpread($fa54ab49563aee77$var$_objectSpread({}, current.details), {}, {
                        reason: $fa54ab49563aee77$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($fa54ab49563aee77$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($fa54ab49563aee77$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($fa54ab49563aee77$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($fa54ab49563aee77$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($fa54ab49563aee77$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($fa54ab49563aee77$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $fa54ab49563aee77$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($fa54ab49563aee77$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $fa54ab49563aee77$var$_objectSpread($fa54ab49563aee77$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $3wfvf._makeTypedGet)(current.name, overridden),
                    details: $fa54ab49563aee77$var$_objectSpread($fa54ab49563aee77$var$_objectSpread({}, current.details), {}, {
                        reason: $fa54ab49563aee77$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($fa54ab49563aee77$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $fa54ab49563aee77$var$_objectSpread($fa54ab49563aee77$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $3wfvf._makeTypedGet)(current.name, overridden),
                    details: $fa54ab49563aee77$var$_objectSpread($fa54ab49563aee77$var$_objectSpread({}, current.details), {}, {
                        reason: $fa54ab49563aee77$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("f2TWO", function(module, exports) {
$parcel$export(module.exports, "debug", function () { return $af4270f5a2b500d6$export$1c9f709888824e05; });
var $af4270f5a2b500d6$var$_process, $af4270f5a2b500d6$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $af4270f5a2b500d6$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($af4270f5a2b500d6$var$_process = globalThis.process) === null || $af4270f5a2b500d6$var$_process === void 0 || ($af4270f5a2b500d6$var$_process = $af4270f5a2b500d6$var$_process.env) === null || $af4270f5a2b500d6$var$_process === void 0 ? void 0 : $af4270f5a2b500d6$var$_process.JEST_WORKER_ID) !== undefined;
var $af4270f5a2b500d6$var$DEBUG_MODE = !$af4270f5a2b500d6$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($af4270f5a2b500d6$var$_process2 = globalThis.process) === null || $af4270f5a2b500d6$var$_process2 === void 0 || ($af4270f5a2b500d6$var$_process2 = $af4270f5a2b500d6$var$_process2.env) === null || $af4270f5a2b500d6$var$_process2 === void 0 ? void 0 : $af4270f5a2b500d6$var$_process2.NODE_ENV) !== 'production';
var $af4270f5a2b500d6$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$af4270f5a2b500d6$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("8gp1u", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $60433a6392b8c83a$export$2e2bcd8739ae039; });
/* text.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $aXKKG = parcelRequire("aXKKG");

var $lmxXn = parcelRequire("lmxXn");

var $lm01c = parcelRequire("lm01c");

var $iXXw7 = parcelRequire("iXXw7");
var $60433a6392b8c83a$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $60433a6392b8c83a$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $iXXw7.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($60433a6392b8c83a$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $60433a6392b8c83a$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
var $60433a6392b8c83a$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pwu06",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $60433a6392b8c83a$var$fontSizeMap = {
    medium: "_11c8fhey",
    UNSAFE_small: "_11c8rymc",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
var $60433a6392b8c83a$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $60433a6392b8c83a$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
var $60433a6392b8c83a$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $60433a6392b8c83a$var$Text = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $lmxXn.default)($60433a6392b8c83a$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $lm01c.useHasTextAncestor)();
    var color = $60433a6392b8c83a$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = /*#__PURE__*/ $1oC0p.createElement(Component, {
        id: id,
        className: (0, $aXKKG.default)([
            $60433a6392b8c83a$var$styles.root,
            size && $60433a6392b8c83a$var$fontSizeMap[size],
            color && $60433a6392b8c83a$var$textColorMap[color],
            maxLines && $60433a6392b8c83a$var$styles.truncation,
            maxLines === 1 && $60433a6392b8c83a$var$styles.breakAll,
            align && $60433a6392b8c83a$var$styles["textAlign.".concat(align)],
            weight && $60433a6392b8c83a$var$fontWeightMap[weight],
            Component === 'em' && $60433a6392b8c83a$var$styles['as.em'],
            Component === 'strong' && $60433a6392b8c83a$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $1oC0p.createElement((0, $lm01c.HasTextAncestorProvider), {
        value: true
    }, component);
});
var $60433a6392b8c83a$export$2e2bcd8739ae039 = $60433a6392b8c83a$var$Text;

});
parcelRegister("aXKKG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7fb3ae0a6998571c$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $7fb3ae0a6998571c$var$ATOMIC_GROUP_LENGTH = 5;
function $7fb3ae0a6998571c$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $7fb3ae0a6998571c$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("lm01c", function(module, exports) {
$parcel$export(module.exports, "useHasTextAncestor", function () { return $f8bbaaaf20a92e1e$export$9322276ec105d055; });
$parcel$export(module.exports, "HasTextAncestorProvider", function () { return $f8bbaaaf20a92e1e$export$ae933c6cbe5643ad; });

var $1oC0p = parcelRequire("1oC0p");
var $f8bbaaaf20a92e1e$var$HasTextAncestorContext = /*#__PURE__*/ (0, $1oC0p.createContext)(false);
var $f8bbaaaf20a92e1e$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $1oC0p.useContext)($f8bbaaaf20a92e1e$var$HasTextAncestorContext);
};
var $f8bbaaaf20a92e1e$export$ae933c6cbe5643ad = $f8bbaaaf20a92e1e$var$HasTextAncestorContext.Provider;

});

parcelRegister("iXXw7", function(module, exports) {
$parcel$export(module.exports, "useSurface", function () { return $dcebe788383a5743$export$1aeb4f6b93c4540d; });

var $1oC0p = parcelRequire("1oC0p");
var $dcebe788383a5743$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1oC0p.createContext)('elevation.surface');
var $dcebe788383a5743$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $1oC0p.useContext)($dcebe788383a5743$export$1ca2a26fecb070ae);
};
$dcebe788383a5743$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});


parcelRegister("kBxVG", function(module, exports) {
$parcel$export(module.exports, "appearanceMapping", function () { return $f0019501a0238a8a$export$d21bba0569254935; });
$parcel$export(module.exports, "appearanceMappingToOld", function () { return $f0019501a0238a8a$export$16f8cc7ac3541e83; });
$parcel$export(module.exports, "default", function () { return $f0019501a0238a8a$export$2e2bcd8739ae039; });
/* badge-new.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $kG2I3 = parcelRequire("kG2I3");

var $8gp1u = parcelRequire("8gp1u");

var $1QDdc = parcelRequire("1QDdc");
var $f0019501a0238a8a$export$d21bba0569254935 = {
    added: 'success',
    removed: 'danger',
    default: 'neutral',
    primary: 'information',
    primaryInverted: 'inverse',
    important: 'danger',
    warning: 'warning',
    discovery: 'discovery',
    danger: 'danger',
    success: 'success',
    information: 'information',
    inverse: 'inverse',
    neutral: 'neutral'
};
var $f0019501a0238a8a$export$16f8cc7ac3541e83 = {
    added: 'added',
    removed: 'removed',
    default: 'default',
    primary: 'primary',
    primaryInverted: 'primaryInverted',
    important: 'important',
    danger: 'removed',
    success: 'added',
    information: 'primary',
    inverse: 'primaryInverted',
    neutral: 'default',
    warning: 'default',
    discovery: 'default'
};
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ // Nested selectors with data attributes are required for theme switching
var $f0019501a0238a8a$var$stylesNew = {
    root: "_2rkolb4i _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    success: "_syaz1p1e _bfhk14j0",
    danger: "_syaz1blx _bfhk18wg",
    warning: "_syazmgs1 _bfhk10f4",
    information: "_syaz1qd9 _bfhk8lbg",
    discovery: "_syaz1g72 _bfhke670",
    neutral: "_syazi7uo _bfhk7qp0",
    inverse: "_bfhkvuon _syazi7uo"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ var $f0019501a0238a8a$var$badgeValueWithNegativeNumberSupported = function badgeValueWithNegativeNumberSupported(children, max) {
    return typeof children === 'number' && max ? (0, $1QDdc.formatValue)(children, max) : children;
};
/**
 * __BadgeNew__
 *
 * New visual refresh implementation of Badge component for the labelling system.
 * This component is used when the 'platform-dst-lozenge-tag-badge-visual-uplifts' feature flag is enabled.
 *
 * Uses new appearance naming convention:
 * - success (green)
 * - danger (red)
 * - neutral (gray)
 * - information (blue)
 * - inverse (inverted colors)
 * - warning (orange/yellow)
 * - discovery (purple)
 */ var $f0019501a0238a8a$var$BadgeNew = /*#__PURE__*/ (0, $1oC0p.memo)(function BadgeNew(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'neutral' : _ref$appearance, _ref$children = _ref.children, children = _ref$children === void 0 ? 0 : _ref$children, _ref$max = _ref.max, max = _ref$max === void 0 ? 99 : _ref$max, style = _ref.style, testId = _ref.testId;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, $kG2I3.default)([
            $f0019501a0238a8a$var$stylesNew.root,
            $f0019501a0238a8a$var$stylesNew[appearance]
        ])
    }, /*#__PURE__*/ $1oC0p.createElement((0, $8gp1u.default), {
        size: "small",
        align: "center",
        color: "inherit"
    }, $f0019501a0238a8a$var$badgeValueWithNegativeNumberSupported(children, max)));
});
var $f0019501a0238a8a$export$2e2bcd8739ae039 = $f0019501a0238a8a$var$BadgeNew;

});
parcelRegister("1QDdc", function(module, exports) {
$parcel$export(module.exports, "formatValueWithNegativeSupport", function () { return $158910760079200c$export$4b844743568d5983; });
$parcel$export(module.exports, "formatValue", function () { return $158910760079200c$export$7c4d25c0c3217d8c; });
function $158910760079200c$var$getSafeValueWithNegativeSupport() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var numericValue = +value;
    // NOTE: Changing below code as this causes custom fields -ve number to show up as zero in activity timeline.
    // This will ensure it renders correctly if it is a number otherwise renders 0
    // If the value is NaN, return it as is (assuming it's a non-numeric string)
    if (isNaN(numericValue)) return value;
    // Return the numeric value, allowing negative numbers
    return numericValue;
}
function $158910760079200c$export$4b844743568d5983(value, max) {
    var safeValue = $158910760079200c$var$getSafeValueWithNegativeSupport(value);
    var safeMax = $158910760079200c$var$getSafeValueWithNegativeSupport(max);
    var hasSafeMaxValue = false;
    if (max !== undefined) hasSafeMaxValue = true;
    if (safeMax === Infinity && safeValue === Infinity) return "\u221E";
    if (hasSafeMaxValue && safeMax < safeValue) return "".concat(safeMax, "+");
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}
function $158910760079200c$var$getSafeValue() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $158910760079200c$export$7c4d25c0c3217d8c(value, max) {
    var safeValue = $158910760079200c$var$getSafeValue(value);
    var safeMax = $158910760079200c$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return "".concat(safeMax, "+");
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});



parcelRegister("5P1ZO", function(module, exports) {
$parcel$export(module.exports, "auth", function () { return $43d34383b0503a4c$export$73693bad9f5880b0; });
$parcel$export(module.exports, "AuthError", function () { return (parcelRequire("89ncj")).AuthError; });

var $2zYm4 = parcelRequire("2zYm4");

var $89ncj = parcelRequire("89ncj");

var $D3o0i = parcelRequire("D3o0i");
function $43d34383b0503a4c$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise(function(resolve, reject) {
        var authWindow = null;
        var authWindowInterval;
        var handleAuthWindowMessage = function handleAuthWindowMessage(event) {
            if (event.source !== authWindow) return;
            var data = event.data;
            if ((0, $2zYm4.default)(data) !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    var errorType = data.errorType.toLowerCase();
                    if ((0, $D3o0i.isOfTypeAuthError)(errorType)) reject(new (0, $89ncj.AuthError)(data.message, errorType));
                    else reject(new (0, $89ncj.AuthError)(data.message));
                    break;
            }
        };
        var handleAuthWindowInterval = function handleAuthWindowInterval() {
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $89ncj.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        var start = function start() {
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        var finish = function finish() {
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}

});
parcelRegister("89ncj", function(module, exports) {
$parcel$export(module.exports, "AuthError", function () { return $5ef12891a1a44a4c$export$145273558d58e0ac; });

var $avOEA = parcelRequire("avOEA");

var $cTewU = parcelRequire("cTewU");

var $i7dvh = parcelRequire("i7dvh");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $4GELH = parcelRequire("4GELH");
function $5ef12891a1a44a4c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5ef12891a1a44a4c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $jlBwm.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $jlBwm.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $i3Ugd.default)(this, result);
    };
}
function $5ef12891a1a44a4c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5ef12891a1a44a4c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $5ef12891a1a44a4c$export$145273558d58e0ac = /*#__PURE__*/ function(_Error) {
    (0, $i7dvh.default)(AuthError, _Error);
    var _super = $5ef12891a1a44a4c$var$_createSuper(AuthError);
    function AuthError(message, type) {
        var _this;
        (0, $cTewU.default)(this, AuthError);
        _this = _super.call(this, message);
        _this.message = message;
        _this.type = type;
        _this.name = 'AuthError';
        _this.type = type;
        _this.message = message;
        return _this;
    }
    return (0, $avOEA.default)(AuthError);
}(/*#__PURE__*/ (0, $4GELH.default)(Error));

});

parcelRegister("D3o0i", function(module, exports) {
$parcel$export(module.exports, "isOfTypeAuthError", function () { return $0756450db8909afa$export$400e64c8451aa84f; });
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
var $0756450db8909afa$export$400e64c8451aa84f = function isOfTypeAuthError(inputString) {
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};

});


parcelRegister("4Z5S3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3a1169bf907ee320$export$2e2bcd8739ae039; });

var $eL00g = parcelRequire("eL00g");
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3a1169bf907ee320$export$2e2bcd8739ae039 = (0, $eL00g.Popup);

});
parcelRegister("eL00g", function(module, exports) {
$parcel$export(module.exports, "Popup", function () { return $abe5751cd7394948$export$129a32eedafa97c5; });
/* popup.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");


var $hlSUb = parcelRequire("hlSUb");

var $bd2OO = parcelRequire("bd2OO");

var $6P6Jp = parcelRequire("6P6Jp");

var $01fYV = parcelRequire("01fYV");

var $j40tR = parcelRequire("j40tR");

var $8q4Jo = parcelRequire("8q4Jo");
var $kUCSO = parcelRequire("kUCSO");

var $52Fo7 = parcelRequire("52Fo7");

var $8fUTx = parcelRequire("8fUTx");

var $6yOgy = parcelRequire("6yOgy");

var $dm95C = parcelRequire("dm95C");

var $290SI = parcelRequire("290SI");

var $91qSw = parcelRequire("91qSw");
var $abe5751cd7394948$var$defaultLayer = 400;
var $abe5751cd7394948$var$wrapperStyles = {
    root: "_kqswh2mm"
};
var $abe5751cd7394948$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref) {
    var xcss = _ref.xcss, _ref$appearance = _ref.appearance, inAppearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, isOpen = _ref.isOpen, providedId = _ref.id, offset = _ref.offset, testId = _ref.testId, trigger = _ref.trigger, content = _ref.content, onClose = _ref.onClose, boundary = _ref.boundary, _ref$rootBoundary = _ref.rootBoundary, rootBoundary = _ref$rootBoundary === void 0 ? 'viewport' : _ref$rootBoundary, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, fallbackPlacements = _ref.fallbackPlacements, PopupContainer = _ref.popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? $abe5751cd7394948$var$defaultLayer : _ref$zIndex, _ref$shouldUseCapture = _ref.shouldUseCaptureOnOutsideClick, shouldUseCaptureOnOutsideClick = _ref$shouldUseCapture === void 0 ? false : _ref$shouldUseCapture, _ref$shouldRenderToPa = _ref.shouldRenderToParent, inShouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldDisableFoc = _ref.shouldDisableFocusLock, shouldDisableFocusLock = _ref$shouldDisableFoc === void 0 ? false : _ref$shouldDisableFoc, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport;
    var _useState = (0, $1oC0p.useState)(null), _useState2 = (0, $2qaZZ.default)(_useState, 2), triggerRef = _useState2[0], setTriggerRef = _useState2[1];
    var getMergedTriggerRef = (0, $290SI.useGetMemoizedMergedTriggerRef)();
    var getMergedTriggerRefNew = (0, $91qSw.useGetMemoizedMergedTriggerRefNew)();
    var generatedId = (0, $hlSUb.useId)();
    var _usePopupAppearance = (0, $dm95C.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    }), appearance = _usePopupAppearance.appearance, shouldRenderToParent = _usePopupAppearance.shouldRenderToParent;
    var id = providedId || generatedId;
    var handleOpenLayerObserverCloseSignal = (0, $1oC0p.useCallback)(function() {
        onClose === null || onClose === void 0 || onClose(null);
    }, [
        onClose
    ]);
    (0, $6P6Jp.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal,
        type: 'popup'
    });
    var renderPopperWrapper = /*#__PURE__*/ $1oC0p.createElement((0, $bd2OO.Layering), {
        isDisabled: false
    }, /*#__PURE__*/ $1oC0p.createElement((0, $6yOgy.default), {
        xcss: xcss,
        appearance: appearance,
        content: content,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: PopupContainer,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
        shouldFitContainer: shouldFitContainer,
        shouldDisableFocusLock: shouldDisableFocusLock,
        shouldReturnFocus: shouldReturnFocus,
        triggerRef: triggerRef,
        strategy: shouldFitContainer ? 'absolute' : strategy,
        role: role,
        label: label,
        titleId: titleId,
        modifiers: modifiers,
        shouldFitViewport: shouldFitViewport
    }));
    var popupContent = /*#__PURE__*/ $1oC0p.createElement((0, $8q4Jo.Manager), null, /*#__PURE__*/ $1oC0p.createElement((0, $kUCSO.Reference), null, function(_ref2) {
        var ref = _ref2.ref;
        return trigger({
            ref: !(0, $j40tR.fg)('platform-design-system-popup-ref') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
            'aria-controls': isOpen ? id : undefined,
            'aria-expanded': isOpen,
            'aria-haspopup': role === 'dialog' && (0, $j40tR.fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
        });
    }), !(0, $j40tR.fg)('platform-dst-motion-uplift') && isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ $1oC0p.createElement((0, $52Fo7.default), {
        zIndex: zIndex
    }, renderPopperWrapper)), (0, $j40tR.fg)('platform-dst-motion-uplift') && /*#__PURE__*/ $1oC0p.createElement((0, $01fYV.default), null, isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ $1oC0p.createElement((0, $52Fo7.default), {
        zIndex: zIndex
    }, renderPopperWrapper))));
    if (shouldFitContainer) return /*#__PURE__*/ $1oC0p.createElement((0, $8fUTx.default), {
        xcss: $abe5751cd7394948$var$wrapperStyles.root
    }, popupContent);
    return popupContent;
});

});
parcelRegister("hlSUb", function(module, exports) {
$parcel$export(module.exports, "useId", function () { return $ca1efcdcb1234dce$export$f680877a34711e37; });

var $2zYm4 = parcelRequire("2zYm4");

var $1oC0p = parcelRequire("1oC0p");
function $ca1efcdcb1234dce$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useId().replace(/[:«»]/g, '_');
}
var $ca1efcdcb1234dce$export$6be90bcb437e928f = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($ca1efcdcb1234dce$export$f680877a34711e37()).concat(postfix);
    (0, $1oC0p.useEffect)(function() {
        if (!ref) return;
        switch((0, $2zYm4.default)(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, $2zYm4.default)(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $ca1efcdcb1234dce$export$6ee17796e3d70de2() {
    var uid = $ca1efcdcb1234dce$export$f680877a34711e37();
    return function(id) {
        return "".concat(uid, "-").concat(id.toString());
    };
}

});

parcelRegister("j40tR", function(module, exports) {
$parcel$export(module.exports, "fg", function () { return $de0ec376c08ab8ca$export$b40ec24ac8275656; });

var $lp3pM = parcelRequire("lp3pM");
function $de0ec376c08ab8ca$export$ba05d765b8392e5e(flagResolver) {
    (0, $lp3pM.setBooleanResolver)(flagResolver);
}
function $de0ec376c08ab8ca$export$470e5c2be1411c89(name) {
    return (0, $lp3pM.resolveBooleanFlag)(name);
}
function $de0ec376c08ab8ca$export$b40ec24ac8275656(name) {
    return (0, $lp3pM.resolveBooleanFlag)(name);
}

});
parcelRegister("lp3pM", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", function () { return $f94e94dfa5b00ce9$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $f94e94dfa5b00ce9$export$6333b6aff9fc6275; });

var $8xXfz = parcelRequire("8xXfz");

var $cvLRT = parcelRequire("cvLRT");

var $7t0tI = parcelRequire("7t0tI");
var $f94e94dfa5b00ce9$var$pkgName = '@atlaskit/platform-feature-flags';
var $f94e94dfa5b00ce9$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $f94e94dfa5b00ce9$var$hasProcessEnv = typeof $7t0tI !== 'undefined' && typeof $7t0tI.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $f94e94dfa5b00ce9$var$ENV_ENABLE_PLATFORM_FF = $f94e94dfa5b00ce9$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $f94e94dfa5b00ce9$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $f94e94dfa5b00ce9$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $f94e94dfa5b00ce9$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $f94e94dfa5b00ce9$var$ENV_ENABLE_PLATFORM_FF || $f94e94dfa5b00ce9$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $f94e94dfa5b00ce9$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $f94e94dfa5b00ce9$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$f94e94dfa5b00ce9$var$globalVar[$f94e94dfa5b00ce9$export$7e41b1b2bdee3f98] = $f94e94dfa5b00ce9$var$globalVar[$f94e94dfa5b00ce9$export$7e41b1b2bdee3f98] || $f94e94dfa5b00ce9$var$DEFAULT_PFF_GLOBAL;
function $f94e94dfa5b00ce9$export$f2b591175b3e424c(resolver) {
    $f94e94dfa5b00ce9$var$globalVar[$f94e94dfa5b00ce9$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $f94e94dfa5b00ce9$export$6333b6aff9fc6275(flagKey) {
    if ($f94e94dfa5b00ce9$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $cvLRT.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $f94e94dfa5b00ce9$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $f94e94dfa5b00ce9$var$globalVar[$f94e94dfa5b00ce9$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $f94e94dfa5b00ce9$var$globalVar[$f94e94dfa5b00ce9$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $8xXfz.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $f94e94dfa5b00ce9$var$globalVar[$f94e94dfa5b00ce9$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("8xXfz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $638f5da5d9b7d42f$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $MD0A5 = parcelRequire("MD0A5");

var $2aU6B = parcelRequire("2aU6B");



var $638f5da5d9b7d42f$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $638f5da5d9b7d42f$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, $cTewU.default)(this, FeatureGates);
    }
    return (0, $avOEA.default)(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$638f5da5d9b7d42f$var$_FeatureGates = $638f5da5d9b7d42f$var$FeatureGates;
(0, $f53LC.default)($638f5da5d9b7d42f$var$FeatureGates, "client", new (0, $MD0A5.Client)());
(0, $f53LC.default)($638f5da5d9b7d42f$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, $f53LC.default)($638f5da5d9b7d42f$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, $f53LC.default)($638f5da5d9b7d42f$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$638f5da5d9b7d42f$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $638f5da5d9b7d42f$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $638f5da5d9b7d42f$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, $f53LC.default)($638f5da5d9b7d42f$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$638f5da5d9b7d42f$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $638f5da5d9b7d42f$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $638f5da5d9b7d42f$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, $f53LC.default)($638f5da5d9b7d42f$var$FeatureGates, "initializeCalled", $638f5da5d9b7d42f$var$_FeatureGates.client.initializeCalled.bind($638f5da5d9b7d42f$var$_FeatureGates.client));
(0, $f53LC.default)($638f5da5d9b7d42f$var$FeatureGates, "initializeCompleted", $638f5da5d9b7d42f$var$_FeatureGates.client.initializeCompleted.bind($638f5da5d9b7d42f$var$_FeatureGates.client));
(0, $f53LC.default)($638f5da5d9b7d42f$var$FeatureGates, "waitUntilInitializeCompleted", $638f5da5d9b7d42f$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($638f5da5d9b7d42f$var$_FeatureGates.client));
(0, $f53LC.default)($638f5da5d9b7d42f$var$FeatureGates, "initialize", $638f5da5d9b7d42f$var$_FeatureGates.client.initialize.bind($638f5da5d9b7d42f$var$_FeatureGates.client));
(0, $f53LC.default)($638f5da5d9b7d42f$var$FeatureGates, "initializeWithProvider", $638f5da5d9b7d42f$var$_FeatureGates.client.initializeWithProvider.bind($638f5da5d9b7d42f$var$_FeatureGates.client));
(0, $f53LC.default)($638f5da5d9b7d42f$var$FeatureGates, "initializeFromValues", $638f5da5d9b7d42f$var$_FeatureGates.client.initializeFromValues.bind($638f5da5d9b7d42f$var$_FeatureGates.client));
(0, $f53LC.default)($638f5da5d9b7d42f$var$FeatureGates, "manuallyLogGateExposure", $638f5da5d9b7d42f$var$_FeatureGates.client.manuallyLogGateExposure.bind($638f5da5d9b7d42f$var$_FeatureGates.client));
(0, $f53LC.default)($638f5da5d9b7d42f$var$FeatureGates, "getExperiment", $638f5da5d9b7d42f$var$_FeatureGates.client.getExperiment.bind($638f5da5d9b7d42f$var$_FeatureGates.client));
(0, $f53LC.default)($638f5da5d9b7d42f$var$FeatureGates, "manuallyLogExperimentExposure", $638f5da5d9b7d42f$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($638f5da5d9b7d42f$var$_FeatureGates.client));
(0, $f53LC.default)($638f5da5d9b7d42f$var$FeatureGates, "manuallyLogLayerExposure", $638f5da5d9b7d42f$var$_FeatureGates.client.manuallyLogLayerExposure.bind($638f5da5d9b7d42f$var$_FeatureGates.client));
(0, $f53LC.default)($638f5da5d9b7d42f$var$FeatureGates, "shutdownStatsig", $638f5da5d9b7d42f$var$_FeatureGates.client.shutdownStatsig.bind($638f5da5d9b7d42f$var$_FeatureGates.client));
(0, $f53LC.default)($638f5da5d9b7d42f$var$FeatureGates, "overrideGate", $638f5da5d9b7d42f$var$_FeatureGates.client.overrideGate.bind($638f5da5d9b7d42f$var$_FeatureGates.client));
(0, $f53LC.default)($638f5da5d9b7d42f$var$FeatureGates, "clearGateOverride", $638f5da5d9b7d42f$var$_FeatureGates.client.clearGateOverride.bind($638f5da5d9b7d42f$var$_FeatureGates.client));
(0, $f53LC.default)($638f5da5d9b7d42f$var$FeatureGates, "overrideConfig", $638f5da5d9b7d42f$var$_FeatureGates.client.overrideConfig.bind($638f5da5d9b7d42f$var$_FeatureGates.client));
(0, $f53LC.default)($638f5da5d9b7d42f$var$FeatureGates, "clearConfigOverride", $638f5da5d9b7d42f$var$_FeatureGates.client.clearConfigOverride.bind($638f5da5d9b7d42f$var$_FeatureGates.client));
(0, $f53LC.default)($638f5da5d9b7d42f$var$FeatureGates, "setOverrides", $638f5da5d9b7d42f$var$_FeatureGates.client.setOverrides.bind($638f5da5d9b7d42f$var$_FeatureGates.client));
(0, $f53LC.default)($638f5da5d9b7d42f$var$FeatureGates, "getOverrides", $638f5da5d9b7d42f$var$_FeatureGates.client.getOverrides.bind($638f5da5d9b7d42f$var$_FeatureGates.client));
(0, $f53LC.default)($638f5da5d9b7d42f$var$FeatureGates, "clearAllOverrides", $638f5da5d9b7d42f$var$_FeatureGates.client.clearAllOverrides.bind($638f5da5d9b7d42f$var$_FeatureGates.client));
(0, $f53LC.default)($638f5da5d9b7d42f$var$FeatureGates, "isCurrentUser", $638f5da5d9b7d42f$var$_FeatureGates.client.isCurrentUser.bind($638f5da5d9b7d42f$var$_FeatureGates.client));
(0, $f53LC.default)($638f5da5d9b7d42f$var$FeatureGates, "onGateUpdated", $638f5da5d9b7d42f$var$_FeatureGates.client.onGateUpdated.bind($638f5da5d9b7d42f$var$_FeatureGates.client));
(0, $f53LC.default)($638f5da5d9b7d42f$var$FeatureGates, "onExperimentValueUpdated", $638f5da5d9b7d42f$var$_FeatureGates.client.onExperimentValueUpdated.bind($638f5da5d9b7d42f$var$_FeatureGates.client));
(0, $f53LC.default)($638f5da5d9b7d42f$var$FeatureGates, "onAnyUpdated", $638f5da5d9b7d42f$var$_FeatureGates.client.onAnyUpdated.bind($638f5da5d9b7d42f$var$_FeatureGates.client));
(0, $f53LC.default)($638f5da5d9b7d42f$var$FeatureGates, "updateUser", $638f5da5d9b7d42f$var$_FeatureGates.client.updateUser.bind($638f5da5d9b7d42f$var$_FeatureGates.client));
(0, $f53LC.default)($638f5da5d9b7d42f$var$FeatureGates, "updateUserWithProvider", $638f5da5d9b7d42f$var$_FeatureGates.client.updateUserWithProvider.bind($638f5da5d9b7d42f$var$_FeatureGates.client));
(0, $f53LC.default)($638f5da5d9b7d42f$var$FeatureGates, "updateUserWithValues", $638f5da5d9b7d42f$var$_FeatureGates.client.updateUserWithValues.bind($638f5da5d9b7d42f$var$_FeatureGates.client));
(0, $f53LC.default)($638f5da5d9b7d42f$var$FeatureGates, "getPackageVersion", $638f5da5d9b7d42f$var$_FeatureGates.client.getPackageVersion.bind($638f5da5d9b7d42f$var$_FeatureGates.client));
(0, $f53LC.default)($638f5da5d9b7d42f$var$FeatureGates, "getLayer", $638f5da5d9b7d42f$var$_FeatureGates.client.getLayer.bind($638f5da5d9b7d42f$var$_FeatureGates.client));
(0, $f53LC.default)($638f5da5d9b7d42f$var$FeatureGates, "getLayerValue", $638f5da5d9b7d42f$var$_FeatureGates.client.getLayerValue.bind($638f5da5d9b7d42f$var$_FeatureGates.client));
var $638f5da5d9b7d42f$var$boundFGJS = $638f5da5d9b7d42f$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $638f5da5d9b7d42f$var$FeatureGates;
    else {
        var $638f5da5d9b7d42f$var$_boundFGJS, $638f5da5d9b7d42f$var$_boundFGJS$getPackage;
        $638f5da5d9b7d42f$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $638f5da5d9b7d42f$var$boundVersion = (($638f5da5d9b7d42f$var$_boundFGJS = $638f5da5d9b7d42f$var$boundFGJS) === null || $638f5da5d9b7d42f$var$_boundFGJS === void 0 || ($638f5da5d9b7d42f$var$_boundFGJS$getPackage = $638f5da5d9b7d42f$var$_boundFGJS.getPackageVersion) === null || $638f5da5d9b7d42f$var$_boundFGJS$getPackage === void 0 ? void 0 : $638f5da5d9b7d42f$var$_boundFGJS$getPackage.call($638f5da5d9b7d42f$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($638f5da5d9b7d42f$var$boundVersion !== (0, $2aU6B.CLIENT_VERSION)) {
            var $638f5da5d9b7d42f$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($638f5da5d9b7d42f$var$boundVersion, " when module version ").concat((0, $2aU6B.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($638f5da5d9b7d42f$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $638f5da5d9b7d42f$export$2e2bcd8739ae039 = $638f5da5d9b7d42f$var$boundFGJS;

});
parcelRegister("MD0A5", function(module, exports) {
$parcel$export(module.exports, "Client", function () { return $0922be0f3fbba3dc$export$1f2bb630327ac4b6; });

var $gnQ3X = parcelRequire("gnQ3X");

var $2qaZZ = parcelRequire("2qaZZ");

var $cn8ql = parcelRequire("cn8ql");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $5Cxn4 = parcelRequire("5Cxn4");

var $ec1qE = parcelRequire("ec1qE");

var $8yn2F = parcelRequire("8yn2F");

var $a6XEV = parcelRequire("a6XEV");

var $fY1rr = parcelRequire("fY1rr");

var $fv7RE = parcelRequire("fv7RE");

var $cmR4P = parcelRequire("cmR4P");

var $jaLQB = parcelRequire("jaLQB");

var $f9Tc0 = parcelRequire("f9Tc0");

var $aBBGI = parcelRequire("aBBGI");

var $bXoyV = parcelRequire("bXoyV");

var $2aU6B = parcelRequire("2aU6B");
var $0922be0f3fbba3dc$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $0922be0f3fbba3dc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0922be0f3fbba3dc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0922be0f3fbba3dc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0922be0f3fbba3dc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0922be0f3fbba3dc$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $0922be0f3fbba3dc$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $0922be0f3fbba3dc$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $f9Tc0.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, $cTewU.default)(this, Client);
        (0, $f53LC.default)(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, $f53LC.default)(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, $f53LC.default)(this, "initWithDefaults", false);
        (0, $f53LC.default)(this, "hasCheckGateErrorOccurred", false);
        (0, $f53LC.default)(this, "hasGetExperimentErrorOccurred", false);
        (0, $f53LC.default)(this, "hasGetExperimentValueErrorOccurred", false);
        (0, $f53LC.default)(this, "hasGetLayerErrorOccurred", false);
        (0, $f53LC.default)(this, "hasGetLayerValueErrorOccurred", false);
        (0, $f53LC.default)(this, "subscriptions", new (0, $8yn2F.default)());
        (0, $f53LC.default)(this, "dataAdapter", new (0, $jaLQB.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, $f53LC.default)(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $f9Tc0.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, $avOEA.default)(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $bXoyV.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $bXoyV.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $bXoyV.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $bXoyV.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $2aU6B.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $0922be0f3fbba3dc$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $2aU6B.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $aBBGI.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $bXoyV.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $bXoyV.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $bXoyV.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $cmR4P.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 2;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 2:
                                if (!this.initCompleted) {
                                    _context7.next = 4;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 4:
                                _context7.next = 6;
                                return this.initPromise;
                            case 6:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $a6XEV.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $a6XEV.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $fv7RE.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $bXoyV.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $bXoyV.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $0922be0f3fbba3dc$var$_objectSpread({}, clientOptions);
                                _context8.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $cmR4P.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $cmR4P.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, $2qaZZ.default)(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 20;
                                break;
                            case 13:
                                _context8.prev = 13;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context8.t0;
                            case 20:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $0922be0f3fbba3dc$var$_objectSpread($0922be0f3fbba3dc$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, $2qaZZ.default)(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 22;
                                break;
                            case 15:
                                _context9.prev = 15;
                                _context9.t0 = _context9["catch"](1);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context9.t0;
                            case 22:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args0 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee0$(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $bXoyV.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $0922be0f3fbba3dc$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $0922be0f3fbba3dc$var$_objectSpread($0922be0f3fbba3dc$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $0922be0f3fbba3dc$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $aBBGI.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, $gnQ3X.default)(newClientOptions, $0922be0f3fbba3dc$var$_excluded);
                                this.user = (0, $bXoyV.toStatsigUser)(identifiers, customAttributes);
                                statsigOptions = $0922be0f3fbba3dc$var$_objectSpread($0922be0f3fbba3dc$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $ec1qE.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $ec1qE.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 12;
                                this.statsigClient = new (0, $ec1qE.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context0.next = 29;
                                break;
                            case 19:
                                _context0.prev = 19;
                                _context0.t0 = _context0["catch"](12);
                                if (_context0.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context0.t0 === null || _context0.t0 === void 0 ? void 0 : _context0.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $ec1qE.StatsigClient)($0922be0f3fbba3dc$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context0.t0;
                            case 29:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 3;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 5;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 6;
                                _context10.next = 9;
                                return this.initPromise;
                            case 9:
                                _context10.next = 13;
                                break;
                            case 11:
                                _context10.prev = 11;
                                _context10.t0 = _context10["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee1$(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 4;
                                                    break;
                                                }
                                                _context1.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context11.sent;
                                user = (0, $bXoyV.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                _context11.next = 13;
                                break;
                            case 8:
                                _context11.prev = 8;
                                _context11.t0 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context11.t0 instanceof Error ? _context11.t0.message : JSON.stringify(_context11.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context11.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 21;
                                    break;
                                }
                                _context11.next = 21;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 21:
                                _context11.next = 27;
                                break;
                            case 23:
                                _context11.prev = 23;
                                _context11.t1 = _context11["catch"](15);
                                success = false;
                                errorMessage = String(_context11.t1);
                            case 27:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 34;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 35;
                                break;
                            case 34:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 35:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            23
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $2aU6B.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $fY1rr.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $fY1rr.Layer).fromLayer((0, $ec1qE._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("8yn2F", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $63a35f614971c6a4$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $f72YL = parcelRequire("f72YL");
function $63a35f614971c6a4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $63a35f614971c6a4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $63a35f614971c6a4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $63a35f614971c6a4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $63a35f614971c6a4$export$a66cbd9b2289cd78 = '@all-features';
var $63a35f614971c6a4$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, $cTewU.default)(this, Subscriptions);
        (0, $f53LC.default)(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($f72YL)))();
    }
    return (0, $avOEA.default)(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $63a35f614971c6a4$var$_objectSpread($63a35f614971c6a4$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $63a35f614971c6a4$var$_objectSpread($63a35f614971c6a4$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $63a35f614971c6a4$var$_objectSpread($63a35f614971c6a4$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $63a35f614971c6a4$var$_objectSpread($63a35f614971c6a4$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($63a35f614971c6a4$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($63a35f614971c6a4$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($63a35f614971c6a4$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $63a35f614971c6a4$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("a6XEV", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", function () { return $75c8bdf8983db1b0$export$6dc24881a3d96325; });

var $2zYm4 = parcelRequire("2zYm4");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $bXoyV = parcelRequire("bXoyV");
var $75c8bdf8983db1b0$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, $cTewU.default)(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, $avOEA.default)(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, $2zYm4.default)(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, $2zYm4.default)(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $bXoyV.migrateEvaluationDetails)(experiment.details), (0, $bXoyV.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("bXoyV", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", function () { return $8b4841f844db2a56$export$d119b37e5f788b43; });
$parcel$export(module.exports, "shallowEquals", function () { return $8b4841f844db2a56$export$fa1c2bbf4100b8bc; });
$parcel$export(module.exports, "toStatsigUser", function () { return $8b4841f844db2a56$export$3dad1db244472f32; });
$parcel$export(module.exports, "migrateInitializationOptions", function () { return $8b4841f844db2a56$export$202946b690d26d22; });
$parcel$export(module.exports, "migrateEvaluationDetails", function () { return $8b4841f844db2a56$export$18ad168d3dbac899; });
$parcel$export(module.exports, "migrateSecondaryExposures", function () { return $8b4841f844db2a56$export$55fd683752d01e67; });

var $gnQ3X = parcelRequire("gnQ3X");

var $2qaZZ = parcelRequire("2qaZZ");

var $f53LC = parcelRequire("f53LC");

var $hMUFv = parcelRequire("hMUFv");

var $fv7RE = parcelRequire("fv7RE");

var $aBBGI = parcelRequire("aBBGI");
var $8b4841f844db2a56$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $8b4841f844db2a56$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8b4841f844db2a56$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8b4841f844db2a56$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8b4841f844db2a56$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8b4841f844db2a56$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $8b4841f844db2a56$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $hMUFv.isFedRamp)() ? (0, $aBBGI.PerimeterType).FEDRAMP_MODERATE : (0, $aBBGI.PerimeterType).COMMERCIAL
    }, options);
};
var $8b4841f844db2a56$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, $2qaZZ.default)(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, $2qaZZ.default)(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, $2qaZZ.default)(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, $2qaZZ.default)(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $8b4841f844db2a56$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    var user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $8b4841f844db2a56$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, $gnQ3X.default)(options, $8b4841f844db2a56$var$_excluded);
    return $8b4841f844db2a56$var$_objectSpread($8b4841f844db2a56$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $8b4841f844db2a56$var$evaluationReasonMappings = Object.entries((0, $fv7RE.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, $2qaZZ.default)(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $8b4841f844db2a56$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $8b4841f844db2a56$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, $2qaZZ.default)(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $fv7RE.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $8b4841f844db2a56$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("fv7RE", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", function () { return $b48fd9f9de29ec33$export$c62558b199e46828; });
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $b48fd9f9de29ec33$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("aBBGI", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", function () { return $7b8a9825edcec454$export$479e7351a733299; });
$parcel$export(module.exports, "PerimeterType", function () { return $7b8a9825edcec454$export$c42b7bbc5e7ba555; });
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $7b8a9825edcec454$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $7b8a9825edcec454$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $7b8a9825edcec454$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("fY1rr", function(module, exports) {
$parcel$export(module.exports, "Layer", function () { return $b9fd93dcab233d7b$export$936d0764594b6eb3; });

var $2zYm4 = parcelRequire("2zYm4");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $bXoyV = parcelRequire("bXoyV");
var $b9fd93dcab233d7b$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, $cTewU.default)(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, $avOEA.default)(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, $2zYm4.default)(val) === (0, $2zYm4.default)(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $bXoyV.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $bXoyV.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $bXoyV.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("cmR4P", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9010b616aab7138f$export$2e2bcd8739ae039; });

var $f53LC = parcelRequire("f53LC");

var $cn8ql = parcelRequire("cn8ql");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $5Cxn4 = parcelRequire("5Cxn4");

var $aBBGI = parcelRequire("aBBGI");

var $2aU6B = parcelRequire("2aU6B");

var $4gR41 = parcelRequire("4gR41");
function $9010b616aab7138f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9010b616aab7138f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9010b616aab7138f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9010b616aab7138f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9010b616aab7138f$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $9010b616aab7138f$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $9010b616aab7138f$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $9010b616aab7138f$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $9010b616aab7138f$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $9010b616aab7138f$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $9010b616aab7138f$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $9010b616aab7138f$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $9010b616aab7138f$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $9010b616aab7138f$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $9010b616aab7138f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, $cTewU.default)(this, Fetcher);
    }
    return (0, $avOEA.default)(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error('Failed to retrieve client sdk key');
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error('Failed to retrieve experiment values');
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $4gR41.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $4gR41.ResponseError)('Unexpected 204 response');
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $9010b616aab7138f$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $aBBGI.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $aBBGI.FeatureGateEnvironment).Production:
                        return $9010b616aab7138f$export$18c93900db9358a4;
                    case (0, $aBBGI.FeatureGateEnvironment).Staging:
                        return $9010b616aab7138f$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $aBBGI.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $aBBGI.FeatureGateEnvironment).Development:
                        return $9010b616aab7138f$export$f058dbf75c3bc647;
                    case (0, $aBBGI.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $9010b616aab7138f$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $9010b616aab7138f$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $9010b616aab7138f$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $9010b616aab7138f$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $2aU6B.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $9010b616aab7138f$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($9010b616aab7138f$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($9010b616aab7138f$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("2aU6B", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", function () { return $195809515509d466$export$a59f8d67326bd1cb; });
/// <reference types="node" />
var $195809515509d466$export$a59f8d67326bd1cb = "0.0.0-development";

});

parcelRegister("4gR41", function(module, exports) {
$parcel$export(module.exports, "ResponseError", function () { return $31c1d16f508c1be4$export$286baf652d0b1206; });

var $avOEA = parcelRequire("avOEA");

var $cTewU = parcelRequire("cTewU");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $i7dvh = parcelRequire("i7dvh");

var $4GELH = parcelRequire("4GELH");
function $31c1d16f508c1be4$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $31c1d16f508c1be4$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $31c1d16f508c1be4$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($31c1d16f508c1be4$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $31c1d16f508c1be4$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, $cTewU.default)(this, ResponseError);
        return $31c1d16f508c1be4$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, $i7dvh.default)(ResponseError, _Error);
    return (0, $avOEA.default)(ResponseError);
}(/*#__PURE__*/ (0, $4GELH.default)(Error));

});


parcelRegister("jaLQB", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", function () { return $df5410fd00dd0577$export$55fffef3474104af; });

var $cn8ql = parcelRequire("cn8ql");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $7SQOE = parcelRequire("7SQOE");

var $i7dvh = parcelRequire("i7dvh");

var $f53LC = parcelRequire("f53LC");

var $5Cxn4 = parcelRequire("5Cxn4");

var $ec1qE = parcelRequire("ec1qE");
function $df5410fd00dd0577$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $df5410fd00dd0577$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $df5410fd00dd0577$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $df5410fd00dd0577$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $df5410fd00dd0577$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $df5410fd00dd0577$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $df5410fd00dd0577$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($df5410fd00dd0577$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $df5410fd00dd0577$var$_superPropGet(t, o, e, r) {
    var p = (0, $7SQOE.default)((0, $jlBwm.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $df5410fd00dd0577$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, $cTewU.default)(this, NoFetchDataAdapter);
        _this = $df5410fd00dd0577$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, $f53LC.default)(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, $i7dvh.default)(NoFetchDataAdapter, _DataAdapterCore);
    return (0, $avOEA.default)(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $ec1qE.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $df5410fd00dd0577$var$_objectSpread($df5410fd00dd0577$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $ec1qE._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $df5410fd00dd0577$var$_objectSpread($df5410fd00dd0577$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $ec1qE._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $ec1qE._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $ec1qE.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $df5410fd00dd0577$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $df5410fd00dd0577$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $ec1qE.DataAdapterCore));

});

parcelRegister("f9Tc0", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", function () { return $b0928261e4812c1e$export$d8474cff104280f3; });
$parcel$export(module.exports, "PersistentOverrideAdapter", function () { return $b0928261e4812c1e$export$bcb28fbac1def494; });

var $f53LC = parcelRequire("f53LC");

var $2qaZZ = parcelRequire("2qaZZ");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $3wfvf = parcelRequire("3wfvf");
function $b0928261e4812c1e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b0928261e4812c1e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b0928261e4812c1e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b0928261e4812c1e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b0928261e4812c1e$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $b0928261e4812c1e$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $b0928261e4812c1e$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $b0928261e4812c1e$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $b0928261e4812c1e$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $b0928261e4812c1e$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $b0928261e4812c1e$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $b0928261e4812c1e$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $b0928261e4812c1e$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $b0928261e4812c1e$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $b0928261e4812c1e$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $b0928261e4812c1e$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, $cTewU.default)(this, PersistentOverrideAdapter);
        this._overrides = $b0928261e4812c1e$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, $avOEA.default)(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $b0928261e4812c1e$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $b0928261e4812c1e$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $b0928261e4812c1e$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, $2qaZZ.default)(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, $2qaZZ.default)(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, $2qaZZ.default)(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($b0928261e4812c1e$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($b0928261e4812c1e$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $b0928261e4812c1e$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $3wfvf._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $b0928261e4812c1e$var$_objectSpread($b0928261e4812c1e$var$_objectSpread({}, $b0928261e4812c1e$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, $2qaZZ.default)(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, $2qaZZ.default)(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($b0928261e4812c1e$var$djb2MapKey((0, $3wfvf._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($b0928261e4812c1e$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($b0928261e4812c1e$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($b0928261e4812c1e$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $b0928261e4812c1e$var$_objectSpread($b0928261e4812c1e$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $b0928261e4812c1e$var$_objectSpread($b0928261e4812c1e$var$_objectSpread({}, current.details), {}, {
                        reason: $b0928261e4812c1e$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($b0928261e4812c1e$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($b0928261e4812c1e$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($b0928261e4812c1e$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($b0928261e4812c1e$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($b0928261e4812c1e$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($b0928261e4812c1e$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $b0928261e4812c1e$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($b0928261e4812c1e$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $b0928261e4812c1e$var$_objectSpread($b0928261e4812c1e$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $3wfvf._makeTypedGet)(current.name, overridden),
                    details: $b0928261e4812c1e$var$_objectSpread($b0928261e4812c1e$var$_objectSpread({}, current.details), {}, {
                        reason: $b0928261e4812c1e$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($b0928261e4812c1e$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $b0928261e4812c1e$var$_objectSpread($b0928261e4812c1e$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $3wfvf._makeTypedGet)(current.name, overridden),
                    details: $b0928261e4812c1e$var$_objectSpread($b0928261e4812c1e$var$_objectSpread({}, current.details), {}, {
                        reason: $b0928261e4812c1e$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("cvLRT", function(module, exports) {
$parcel$export(module.exports, "debug", function () { return $91bd82e87bb6abb2$export$1c9f709888824e05; });
var $91bd82e87bb6abb2$var$_process, $91bd82e87bb6abb2$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $91bd82e87bb6abb2$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($91bd82e87bb6abb2$var$_process = globalThis.process) === null || $91bd82e87bb6abb2$var$_process === void 0 || ($91bd82e87bb6abb2$var$_process = $91bd82e87bb6abb2$var$_process.env) === null || $91bd82e87bb6abb2$var$_process === void 0 ? void 0 : $91bd82e87bb6abb2$var$_process.JEST_WORKER_ID) !== undefined;
var $91bd82e87bb6abb2$var$DEBUG_MODE = !$91bd82e87bb6abb2$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($91bd82e87bb6abb2$var$_process2 = globalThis.process) === null || $91bd82e87bb6abb2$var$_process2 === void 0 || ($91bd82e87bb6abb2$var$_process2 = $91bd82e87bb6abb2$var$_process2.env) === null || $91bd82e87bb6abb2$var$_process2 === void 0 ? void 0 : $91bd82e87bb6abb2$var$_process2.NODE_ENV) !== 'production';
var $91bd82e87bb6abb2$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$91bd82e87bb6abb2$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("8fUTx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $602bdb89bbebacd7$export$2e2bcd8739ae039; });
/* box.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $5S1Z0 = parcelRequire("5S1Z0");

var $ap1EX = parcelRequire("ap1EX");
var $602bdb89bbebacd7$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $602bdb89bbebacd7$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $602bdb89bbebacd7$var$baseStyles = null;
var $602bdb89bbebacd7$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhkby5v",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $602bdb89bbebacd7$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $602bdb89bbebacd7$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var $602bdb89bbebacd7$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $602bdb89bbebacd7$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $602bdb89bbebacd7$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $602bdb89bbebacd7$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $602bdb89bbebacd7$var$Box = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $gnQ3X.default)(_ref, $602bdb89bbebacd7$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $gnQ3X.default)(htmlAttributes, $602bdb89bbebacd7$var$_excluded2);
    var node = /*#__PURE__*/ $1oC0p.createElement(Component, (0, $c9bqK.default)({
        style: style,
        ref: ref,
        className: (0, $5S1Z0.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $602bdb89bbebacd7$var$backgroundColorMap[backgroundColor],
            backgroundColor && $602bdb89bbebacd7$var$isSurfaceToken(backgroundColor) && $602bdb89bbebacd7$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $602bdb89bbebacd7$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $602bdb89bbebacd7$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $602bdb89bbebacd7$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $602bdb89bbebacd7$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $1oC0p.createElement((0, $ap1EX.SurfaceContext).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $602bdb89bbebacd7$export$2e2bcd8739ae039 = $602bdb89bbebacd7$var$Box;
function $602bdb89bbebacd7$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $602bdb89bbebacd7$var$setSurfaceTokenMap;
}

});
parcelRegister("5S1Z0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $446388abd3d172c2$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $446388abd3d172c2$var$ATOMIC_GROUP_LENGTH = 5;
function $446388abd3d172c2$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $446388abd3d172c2$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("ap1EX", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", function () { return $792d86b95e85a53d$export$1ca2a26fecb070ae; });

var $1oC0p = parcelRequire("1oC0p");
var $792d86b95e85a53d$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1oC0p.createContext)('elevation.surface');
var $792d86b95e85a53d$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $1oC0p.useContext)($792d86b95e85a53d$export$1ca2a26fecb070ae);
};
$792d86b95e85a53d$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});


parcelRegister("6yOgy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4c6ce8d7df0f2584$export$2e2bcd8739ae039; });
/* popper-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $lFOXD = parcelRequire("lFOXD");

var $2qaZZ = parcelRequire("2qaZZ");

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $5S1Z0 = parcelRequire("5S1Z0");

var $5E2F4 = parcelRequire("5E2F4");

var $3PL5N = parcelRequire("3PL5N");

var $j40tR = parcelRequire("j40tR");

var $jer1f = parcelRequire("jer1f");

var $2POui = parcelRequire("2POui");

var $f4Nfi = parcelRequire("f4Nfi");

var $aAHFu = parcelRequire("aAHFu");
var $4c6ce8d7df0f2584$var$_excluded = [
    "shouldRenderToParent",
    "shouldFitContainer",
    "children",
    "appearance",
    "className",
    "isReferenceHidden",
    "shouldFitViewport"
];
var $4c6ce8d7df0f2584$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
var $4c6ce8d7df0f2584$var$fullWidthStyles = null;
var $4c6ce8d7df0f2584$var$wrapperStyles = {
    root: "_2rko12b0 _1e0c1ule _vchhusvi _1pby1nn1 _bfhk1bhr _16qs130s _syazi7uo _1q1l1bhr _nt751r31 _49pcglyw _1hvw1o36",
    rootT26Shape: "_2rko1mok",
    rootLayer: "_1pby1nn1",
    fullWidth: "_1bsb1osq"
};
var $4c6ce8d7df0f2584$var$scrollableStyles = null;
var $4c6ce8d7df0f2584$var$blanketStyles = null;
var $4c6ce8d7df0f2584$var$modalStyles = null;
var $4c6ce8d7df0f2584$var$newModalStyles = null;
var $4c6ce8d7df0f2584$var$focusRingStyles = {
    root: "_mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y"
};
var $4c6ce8d7df0f2584$var$placementMap = {
    'top': {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut)"
    },
    'top-start': {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut)"
    },
    'top-end': {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut)"
    },
    'bottom': {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut)"
    },
    'bottom-start': {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut)"
    },
    'bottom-end': {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut)"
    },
    'left': {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut)"
    },
    'left-start': {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut)"
    },
    'left-end': {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut)"
    },
    'right': {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut)"
    },
    'right-start': {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut)"
    },
    'right-end': {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut)"
    }
};
var $4c6ce8d7df0f2584$var$DefaultPopupComponent = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
    var shouldRenderToParent = props.shouldRenderToParent, shouldFitContainer = props.shouldFitContainer, children = props.children, appearance = props.appearance, className = props.className, _isReferenceHidden = props.isReferenceHidden, shouldFitViewport = props.shouldFitViewport, htmlAttributes = (0, $gnQ3X.default)(props, $4c6ce8d7df0f2584$var$_excluded);
    return /*#__PURE__*/ $1oC0p.createElement("div", (0, $c9bqK.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $5S1Z0.default)([
            $4c6ce8d7df0f2584$var$wrapperStyles.root,
            (0, $j40tR.fg)('platform-dst-shape-theme-default') && $4c6ce8d7df0f2584$var$wrapperStyles.rootT26Shape,
            appearance === 'UNSAFE_modal-below-sm' && !(0, $j40tR.fg)('platform_dst_nav4_flyout_menu_slots_close_button') && "_dk5d1b66 _c71ldtre _kqsw1n9t _152t1b66",
            appearance === 'UNSAFE_modal-below-sm' && (0, $j40tR.fg)('platform_dst_nav4_flyout_menu_slots_close_button') && "_dk5d1b66 _c71l1ei0 _kqsw1n9t _152t1b66",
            (!shouldRenderToParent || shouldFitViewport) && "_1reo1wug _18m91wug",
            shouldFitContainer && "_1bsb1osq",
            className
        ])
    }, htmlAttributes, {
        ref: !(0, $j40tR.fg)('platform-dst-motion-uplift') ? ref : undefined
    }), children);
});
function $4c6ce8d7df0f2584$var$PopperWrapper(_ref) {
    var xcss = _ref.xcss, isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, content = _ref.content, fallbackPlacements = _ref.fallbackPlacements, onClose = _ref.onClose, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, shouldFlip = _ref.shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, _ref$popupComponent = _ref.popupComponent, PopupContainer = _ref$popupComponent === void 0 ? $4c6ce8d7df0f2584$var$DefaultPopupComponent : _ref$popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, triggerRef = _ref.triggerRef, shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, shouldRenderToParent = _ref.shouldRenderToParent, shouldFitContainer = _ref.shouldFitContainer, shouldDisableFocusLock = _ref.shouldDisableFocusLock, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance;
    var _useState = (0, $1oC0p.useState)(null), _useState2 = (0, $2qaZZ.default)(_useState, 2), popupRef = _useState2[0], setPopupRef = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)(null), _useState4 = (0, $2qaZZ.default)(_useState3, 2), initialFocusRef = _useState4[0], setInitialFocusRef = _useState4[1];
    // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    var shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    var shouldDisableFocusTrap = role !== 'dialog';
    (0, $aAHFu.useFocusManager)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $f4Nfi.useCloseManager)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    var _useLayering = (0, $5E2F4.useLayering)(), currentLevel = _useLayering.currentLevel;
    var mergedModifiers = (0, $1oC0p.useMemo)(function() {
        return [
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            }
        ].concat((0, $lFOXD.default)(modifiers || []));
    }, [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return /*#__PURE__*/ $1oC0p.createElement((0, $jer1f.Popper), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    }, function(_ref2) {
        var _ref3 = _ref2.ref, style = _ref2.style, placement = _ref2.placement, update = _ref2.update, isReferenceHidden = _ref2.isReferenceHidden;
        var popupContainer = /*#__PURE__*/ $1oC0p.createElement(PopupContainer, {
            className: (0, $5S1Z0.default)([
                xcss,
                // @ts-expect-error: `ax` is not typed correctly
                !initialFocusRef && (0, $j40tR.fg)('platform-design-system-apply-popup-wrapper-focus') && $4c6ce8d7df0f2584$var$focusRingStyles.root
            ]),
            appearance: appearance,
            id: id,
            "data-ds--level": currentLevel,
            "data-placement": placement,
            "data-testid": testId,
            role: role,
            "aria-label": label,
            "aria-labelledby": titleId,
            ref: !(0, $j40tR.fg)('platform-dst-motion-uplift') ? function(node) {
                if (node) {
                    if (typeof _ref3 === 'function') _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            } : undefined,
            style: (0, $j40tR.fg)('platform-dst-motion-uplift') || appearance === 'UNSAFE_modal-below-sm' ? {} : style,
            tabIndex: autoFocus ? 0 : undefined,
            shouldRenderToParent: shouldRenderToParent,
            shouldFitContainer: shouldFitContainer,
            shouldFitViewport: shouldFitViewport,
            isReferenceHidden: isReferenceHidden
        }, /*#__PURE__*/ $1oC0p.createElement((0, $2POui.RepositionOnUpdate), {
            update: update
        }, content({
            update: update,
            isOpen: isOpen,
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        })));
        var container = /*#__PURE__*/ $1oC0p.createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style,
            // using tabIndex={-1} would cause a bug where Safari focuses
            // first on the browser address bar when using keyboard
            ref: function ref(node) {
                if (node) {
                    if (typeof _ref3 === 'function') _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            },
            "data-testid": "".concat(testId, "--container"),
            className: (0, $5S1Z0.default)([
                $4c6ce8d7df0f2584$var$wrapperStyles.rootLayer,
                shouldFitContainer && $4c6ce8d7df0f2584$var$wrapperStyles.fullWidth
            ])
        }, placement === 'auto' || placement === 'auto-start' || placement === 'auto-end' ? popupContainer : /*#__PURE__*/ $1oC0p.createElement((0, $3PL5N.default), {
            enteringAnimation: $4c6ce8d7df0f2584$var$placementMap[placement].enter,
            exitingAnimation: $4c6ce8d7df0f2584$var$placementMap[placement].exit
        }, popupContainer));
        return /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), null, (0, $j40tR.fg)('platform-dst-motion-uplift') ? container : popupContainer, appearance === 'UNSAFE_modal-below-sm' && /*#__PURE__*/ $1oC0p.createElement("div", {
            className: (0, $5S1Z0.default)([
                "_1r04idpf _kqsw1n9t _bfhk1i5c"
            ])
        }));
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4c6ce8d7df0f2584$export$2e2bcd8739ae039 = $4c6ce8d7df0f2584$var$PopperWrapper;

});
parcelRegister("2POui", function(module, exports) {
$parcel$export(module.exports, "RepositionOnUpdate", function () { return $210781fdbc3fb7db$export$51eddd7655ca235a; });

var $1oC0p = parcelRequire("1oC0p");
var $210781fdbc3fb7db$export$51eddd7655ca235a = function RepositionOnUpdate(_ref) {
    var children = _ref.children, update = _ref.update;
    // Ref used here to skip update on first render (when refs haven't been set)
    var isFirstRenderRef = (0, $1oC0p.useRef)(true);
    (0, $1oC0p.useLayoutEffect)(function() {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, children);
};

});

parcelRegister("f4Nfi", function(module, exports) {
$parcel$export(module.exports, "useCloseManager", function () { return $af9d6de4bdd03a85$export$92dae2778ae88f9d; });
// eslint-disable-next-line no-duplicate-imports

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $6SyWG = parcelRequire("6SyWG");

var $5E2F4 = parcelRequire("5E2F4");

var $j40tR = parcelRequire("j40tR");

var $f3ocV = parcelRequire("f3ocV");

var $37thQ = parcelRequire("37thQ");
var $af9d6de4bdd03a85$export$92dae2778ae88f9d = function useCloseManager(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, capture = _ref.shouldUseCaptureOnOutsideClick, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useLayering = (0, $5E2F4.useLayering)(), isLayerDisabled = _useLayering.isLayerDisabled, currentLevel = _useLayering.currentLevel;
    var _useAnimationFrame = (0, $37thQ.useAnimationFrame)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    var mouseDownTarget = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useEffect)(function() {
        if (!isOpen || !popupRef) return 0, $6SyWG.default;
        var closePopup = function closePopup(event) {
            if (onClose) {
                var _currentLevel = null;
                if (event.target instanceof HTMLElement) {
                    var _event$target$closest, _event$target$closest2;
                    _currentLevel = (_event$target$closest = (_event$target$closest2 = event.target.closest("[data-ds--level]")) === null || _event$target$closest2 === void 0 ? void 0 : _event$target$closest2.getAttribute('data-ds--level')) !== null && _event$target$closest !== void 0 ? _event$target$closest : null;
                }
                _currentLevel ? onClose(event, Number(_currentLevel)) : onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $j40tR.fg)('platform_dst_popup-disable-focuslock')) // Restoring the normal focus order for trigger.
            requestFrame(function() {
                triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '0');
                if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        var onClick = function onClick(event) {
            var target = event.target;
            var doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist) return;
            if (isLayerDisabled()) {
                if (target instanceof HTMLElement) {
                    var _target$closest;
                    var layeredElement = (_target$closest = target.closest) === null || _target$closest === void 0 ? void 0 : _target$closest.call(target, "[data-ds--level]");
                    if (layeredElement) {
                        var closeType = layeredElement.getAttribute('[data-ds--close--type]');
                        if (closeType === 'single') // if the close type is single, we won't close other disabled layers when clicking outside
                        return;
                        var levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                        if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // won't trigger onClick event when we click in a higher layer.
                        return;
                    }
                }
            }
            var isClickOnPopup = popupRef && popupRef.contains(target);
            var isClickOnTrigger = triggerRef && triggerRef.contains(target);
            var didClickStartInsidePopup = popupRef && mouseDownTarget.current instanceof Node && popupRef.contains(mouseDownTarget.current);
            if (!isClickOnPopup && !isClickOnTrigger && !didClickStartInsidePopup) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $f3ocV.isInteractiveElement)(document.activeElement) && (0, $j40tR.fg)('platform_dst_popup-disable-focuslock')) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
            }
        };
        var onMouseDown = function onMouseDown(event) {
            /**
       * Tracking the target of the mouse down event.
       * This is used to prevent the popup from closing when the user mouses down inside the popup, but then
       * moves the mouse outside the popup before releasing the mouse button.
       *
       * This is a common user interaction - users may have mistakenly clicked on something, or changed their mind,
       * so they try to cancel their click by moving their mouse away from what they had moused down on.
       *
       * Blanket uses the same technique.
       */ mouseDownTarget.current = event.target;
        };
        var onKeyDown = function onKeyDown(event) {
            var key = event.key;
            if ((key === 'Escape' || key === 'Esc') && (0, $j40tR.fg)('platform_dst_nested_escape')) {
                var _eventTarget$closest;
                var eventTarget = event.target instanceof HTMLElement ? event.target : null;
                var layeredAncestor = eventTarget === null || eventTarget === void 0 || (_eventTarget$closest = eventTarget.closest) === null || _eventTarget$closest === void 0 ? void 0 : _eventTarget$closest.call(eventTarget, '[data-ds--level]');
                var levelStr = layeredAncestor === null || layeredAncestor === void 0 ? void 0 : layeredAncestor.getAttribute('data-ds--level');
                if (levelStr && Number(levelStr) > currentLevel) return;
            }
            if ((0, $j40tR.fg)('platform_dst_popup-disable-focuslock')) {
                var shiftKey = event.shiftKey;
                if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(function() {
                        var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
                        }
                    });
                    return;
                }
                if (key === 'Tab') {
                    var _document$activeEleme;
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && (_document$activeEleme = document.activeElement) !== null && _document$activeEleme !== void 0 && _document$activeEleme.closest('[aria-modal]')) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(function() {
                            var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(function() {
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc') {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc' || shouldCloseOnTab && key === 'Tab') closePopup(event);
            }
        };
        var unbind = (0, $6SyWG.default);
        if ((0, $j40tR.fg)('popup-onclose-fix')) setTimeout(function() {
            unbind = (0, $dH1HR.bindAll)(window, [
                {
                    type: 'click',
                    listener: onClick,
                    options: {
                        capture: capture
                    }
                },
                {
                    type: 'keydown',
                    listener: onKeyDown
                },
                {
                    type: 'mousedown',
                    listener: onMouseDown
                }
            ]);
        }, 0);
        else unbind = (0, $dH1HR.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'mousedown',
                listener: onMouseDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        var unbindBlur = (0, $6SyWG.default);
        unbindBlur = (0, $dH1HR.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return function() {
            if ((0, $j40tR.fg)('popup-onclose-fix')) setTimeout(function() {
                unbind();
            }, 0);
            else unbind();
            cancelAllFrames();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};

});
parcelRegister("6SyWG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5022e4a93f0578e0$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $5022e4a93f0578e0$export$2e2bcd8739ae039() {}

});

parcelRegister("f3ocV", function(module, exports) {
$parcel$export(module.exports, "isInteractiveElement", function () { return $af59e9ec2b49dc8b$export$3dee5e4542c672d9; });
var $af59e9ec2b49dc8b$var$interactiveTags = [
    'button',
    'a',
    'input',
    'select',
    'textarea'
];
var $af59e9ec2b49dc8b$export$3dee5e4542c672d9 = function isInteractiveElement(element) {
    if ($af59e9ec2b49dc8b$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
    return false;
};

});

parcelRegister("37thQ", function(module, exports) {
$parcel$export(module.exports, "useAnimationFrame", function () { return $2458be4779b0e22c$export$641fa9c94086b46e; });

var $1oC0p = parcelRequire("1oC0p");
var $2458be4779b0e22c$export$641fa9c94086b46e = function useAnimationFrame() {
    var animationsRef = (0, $1oC0p.useRef)([]);
    var requestFrame = (0, $1oC0p.useCallback)(function(callback) {
        var id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    var cancelFrame = (0, $1oC0p.useCallback)(function(id) {
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter(function(frameId) {
            return frameId !== id;
        });
    }, []);
    var cancelAllFrames = (0, $1oC0p.useCallback)(function() {
        animationsRef.current.forEach(function(id) {
            return cancelAnimationFrame(id);
        });
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};

});


parcelRegister("aAHFu", function(module, exports) {
$parcel$export(module.exports, "useFocusManager", function () { return $7b5f23bfbaf663c6$export$10c5169755ce7bd7; });

var $1oC0p = parcelRequire("1oC0p");

var $4b05t = parcelRequire("4b05t");

var $6SyWG = parcelRequire("6SyWG");

var $5E2F4 = parcelRequire("5E2F4");

var $j40tR = parcelRequire("j40tR");

var $37thQ = parcelRequire("37thQ");
var $7b5f23bfbaf663c6$export$10c5169755ce7bd7 = function useFocusManager(_ref) {
    var initialFocusRef = _ref.initialFocusRef, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, shouldReturnFocus = _ref.shouldReturnFocus, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useAnimationFrame = (0, $37thQ.useAnimationFrame)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    var _useLayering = (0, $5E2F4.useLayering)(), currentLevel = _useLayering.currentLevel;
    (0, $1oC0p.useEffect)(function() {
        if (!popupRef || shouldCloseOnTab) return 0, $6SyWG.default;
        if (shouldDisableFocusTrap && (0, $j40tR.fg)('platform_dst_popup-disable-focuslock')) {
            var isDropdown = popupRef.matches('[id^=ds--dropdown--]');
            var popups = document.querySelectorAll("[data-ds--level=\"".concat(currentLevel - 1, "\"]"));
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(function() {
                    triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '-1');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $6SyWG.default;
            }
        }
        var trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: (0, $j40tR.fg)('platform_dst_nested_escape') ? false : true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        var focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($4b05t)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(function() {
            focusTrap.activate();
        });
        return function() {
            cancelAllFrames();
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};

});


parcelRegister("dm95C", function(module, exports) {
$parcel$export(module.exports, "usePopupAppearance", function () { return $9b94616f29eb402a$export$4065aef1d79a5730; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $752g9 = parcelRequire("752g9");
function $9b94616f29eb402a$export$4065aef1d79a5730(_ref) {
    var _appearance = _ref.appearance, _shouldRenderToParent = _ref.shouldRenderToParent;
    var mq = (0, $752g9.UNSAFE_useMediaQuery)('below.sm', function(e) {
        setIsSmallViewport(!!e.matches);
    });
    var _useState = (0, $1oC0p.useState)(!!(mq !== null && mq !== void 0 && mq.matches)), _useState2 = (0, $2qaZZ.default)(_useState, 2), isSmallViewport = _useState2[0], setIsSmallViewport = _useState2[1];
    var appearance = _appearance === 'UNSAFE_modal-below-sm' && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
    var shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}

});
parcelRegister("752g9", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useMediaQuery", function () { return $527ac0b38eb949d2$export$49e55ae2c03d6045; });

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $enyAY = parcelRequire("enyAY");
var $527ac0b38eb949d2$var$_window, $527ac0b38eb949d2$var$_window$matchMedia, $527ac0b38eb949d2$var$_window2, $527ac0b38eb949d2$var$_window2$matchMedia, $527ac0b38eb949d2$var$_window3, $527ac0b38eb949d2$var$_window3$matchMedia, $527ac0b38eb949d2$var$_window4, $527ac0b38eb949d2$var$_window4$matchMedia, $527ac0b38eb949d2$var$_window5, $527ac0b38eb949d2$var$_window5$matchMedia, $527ac0b38eb949d2$var$_window6, $527ac0b38eb949d2$var$_window6$matchMedia, $527ac0b38eb949d2$var$_window7, $527ac0b38eb949d2$var$_window7$matchMedia, $527ac0b38eb949d2$var$_window8, $527ac0b38eb949d2$var$_window8$matchMedia, $527ac0b38eb949d2$var$_window9, $527ac0b38eb949d2$var$_window9$matchMedia, $527ac0b38eb949d2$var$_window0, $527ac0b38eb949d2$var$_window0$matchMedia, $527ac0b38eb949d2$var$_window1, $527ac0b38eb949d2$var$_window1$matchMedia;
var $527ac0b38eb949d2$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : ($527ac0b38eb949d2$var$_window = window) === null || $527ac0b38eb949d2$var$_window === void 0 || ($527ac0b38eb949d2$var$_window$matchMedia = $527ac0b38eb949d2$var$_window.matchMedia) === null || $527ac0b38eb949d2$var$_window$matchMedia === void 0 ? void 0 : $527ac0b38eb949d2$var$_window$matchMedia.call($527ac0b38eb949d2$var$_window, (0, $enyAY.media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : ($527ac0b38eb949d2$var$_window2 = window) === null || $527ac0b38eb949d2$var$_window2 === void 0 || ($527ac0b38eb949d2$var$_window2$matchMedia = $527ac0b38eb949d2$var$_window2.matchMedia) === null || $527ac0b38eb949d2$var$_window2$matchMedia === void 0 ? void 0 : $527ac0b38eb949d2$var$_window2$matchMedia.call($527ac0b38eb949d2$var$_window2, (0, $enyAY.media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : ($527ac0b38eb949d2$var$_window3 = window) === null || $527ac0b38eb949d2$var$_window3 === void 0 || ($527ac0b38eb949d2$var$_window3$matchMedia = $527ac0b38eb949d2$var$_window3.matchMedia) === null || $527ac0b38eb949d2$var$_window3$matchMedia === void 0 ? void 0 : $527ac0b38eb949d2$var$_window3$matchMedia.call($527ac0b38eb949d2$var$_window3, (0, $enyAY.media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : ($527ac0b38eb949d2$var$_window4 = window) === null || $527ac0b38eb949d2$var$_window4 === void 0 || ($527ac0b38eb949d2$var$_window4$matchMedia = $527ac0b38eb949d2$var$_window4.matchMedia) === null || $527ac0b38eb949d2$var$_window4$matchMedia === void 0 ? void 0 : $527ac0b38eb949d2$var$_window4$matchMedia.call($527ac0b38eb949d2$var$_window4, (0, $enyAY.media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : ($527ac0b38eb949d2$var$_window5 = window) === null || $527ac0b38eb949d2$var$_window5 === void 0 || ($527ac0b38eb949d2$var$_window5$matchMedia = $527ac0b38eb949d2$var$_window5.matchMedia) === null || $527ac0b38eb949d2$var$_window5$matchMedia === void 0 ? void 0 : $527ac0b38eb949d2$var$_window5$matchMedia.call($527ac0b38eb949d2$var$_window5, (0, $enyAY.media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : ($527ac0b38eb949d2$var$_window6 = window) === null || $527ac0b38eb949d2$var$_window6 === void 0 || ($527ac0b38eb949d2$var$_window6$matchMedia = $527ac0b38eb949d2$var$_window6.matchMedia) === null || $527ac0b38eb949d2$var$_window6$matchMedia === void 0 ? void 0 : $527ac0b38eb949d2$var$_window6$matchMedia.call($527ac0b38eb949d2$var$_window6, (0, $enyAY.media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : ($527ac0b38eb949d2$var$_window7 = window) === null || $527ac0b38eb949d2$var$_window7 === void 0 || ($527ac0b38eb949d2$var$_window7$matchMedia = $527ac0b38eb949d2$var$_window7.matchMedia) === null || $527ac0b38eb949d2$var$_window7$matchMedia === void 0 ? void 0 : $527ac0b38eb949d2$var$_window7$matchMedia.call($527ac0b38eb949d2$var$_window7, (0, $enyAY.media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : ($527ac0b38eb949d2$var$_window8 = window) === null || $527ac0b38eb949d2$var$_window8 === void 0 || ($527ac0b38eb949d2$var$_window8$matchMedia = $527ac0b38eb949d2$var$_window8.matchMedia) === null || $527ac0b38eb949d2$var$_window8$matchMedia === void 0 ? void 0 : $527ac0b38eb949d2$var$_window8$matchMedia.call($527ac0b38eb949d2$var$_window8, (0, $enyAY.media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : ($527ac0b38eb949d2$var$_window9 = window) === null || $527ac0b38eb949d2$var$_window9 === void 0 || ($527ac0b38eb949d2$var$_window9$matchMedia = $527ac0b38eb949d2$var$_window9.matchMedia) === null || $527ac0b38eb949d2$var$_window9$matchMedia === void 0 ? void 0 : $527ac0b38eb949d2$var$_window9$matchMedia.call($527ac0b38eb949d2$var$_window9, (0, $enyAY.media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : ($527ac0b38eb949d2$var$_window0 = window) === null || $527ac0b38eb949d2$var$_window0 === void 0 || ($527ac0b38eb949d2$var$_window0$matchMedia = $527ac0b38eb949d2$var$_window0.matchMedia) === null || $527ac0b38eb949d2$var$_window0$matchMedia === void 0 ? void 0 : $527ac0b38eb949d2$var$_window0$matchMedia.call($527ac0b38eb949d2$var$_window0, (0, $enyAY.media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : ($527ac0b38eb949d2$var$_window1 = window) === null || $527ac0b38eb949d2$var$_window1 === void 0 || ($527ac0b38eb949d2$var$_window1$matchMedia = $527ac0b38eb949d2$var$_window1.matchMedia) === null || $527ac0b38eb949d2$var$_window1$matchMedia === void 0 ? void 0 : $527ac0b38eb949d2$var$_window1$matchMedia.call($527ac0b38eb949d2$var$_window1, (0, $enyAY.media).below.xl.replace('@media ', '').trim())
};
var $527ac0b38eb949d2$export$49e55ae2c03d6045 = function UNSAFE_useMediaQuery(queryString, listener) {
    var listenerRef = (0, $1oC0p.useRef)(listener);
    (0, $1oC0p.useEffect)(function() {
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ var hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ var mq = $527ac0b38eb949d2$var$queries[queryString];
    (0, $1oC0p.useLayoutEffect)(function() {
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $dH1HR.bind)(mq, {
            type: 'change',
            listener: function listener(event) {
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});
parcelRegister("enyAY", function(module, exports) {
$parcel$export(module.exports, "media", function () { return $a77e0c9c253be08b$export$987d49ffe1b0900f; });
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $a77e0c9c253be08b$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

});



parcelRegister("290SI", function(module, exports) {
$parcel$export(module.exports, "useGetMemoizedMergedTriggerRef", function () { return $18fd1b1bab0dd98d$export$7cc5c058dd769dff; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $dWJ7u = parcelRequire("dWJ7u");
var $18fd1b1bab0dd98d$export$7cc5c058dd769dff = function useGetMemoizedMergedTriggerRef() {
    var _useState = (0, $1oC0p.useState)(function() {
        return (0, $dWJ7u.default)(function(ref, setTriggerRef, isOpen) {
            return function(node) {
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, $2qaZZ.default)(_useState, 1), getMemoizedMergedTriggerRef = _useState2[0];
    return getMemoizedMergedTriggerRef;
};

});

parcelRegister("91qSw", function(module, exports) {
$parcel$export(module.exports, "useGetMemoizedMergedTriggerRefNew", function () { return $69190e89a57beb7b$export$5d3a2de79e07b376; });

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $dWJ7u = parcelRequire("dWJ7u");
var $69190e89a57beb7b$export$5d3a2de79e07b376 = function useGetMemoizedMergedTriggerRefNew() {
    var _useState = (0, $1oC0p.useState)(function() {
        return (0, $dWJ7u.default)(function(ref, setTriggerRef) {
            return function(node) {
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, $2qaZZ.default)(_useState, 1), getMemoizedMergedTriggerRefNew = _useState2[0];
    return getMemoizedMergedTriggerRefNew;
};

});



parcelRegister("ldYqt", function(module, exports) {
$parcel$export(module.exports, "UFOExperienceState", function () { return $f739af3b6cae21c8$export$81b70111112841a0; });
var $f739af3b6cae21c8$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    // isn't recovered IN_PROGRESS?
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("h8nQ0", function(module, exports) {
$parcel$export(module.exports, "ConcurrentExperience", function () { return $c795acb9486f97f6$export$ac1cddfee07ba6ac; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $jggcA = parcelRequire("jggcA");

var $ek6PN = parcelRequire("ek6PN");
var $c795acb9486f97f6$export$ac1cddfee07ba6ac = /*#__PURE__*/ function() {
    function ConcurrentExperience(experienceId, config) {
        (0, $cTewU.default)(this, ConcurrentExperience);
        (0, $f53LC.default)(this, "instances", {});
        this.experienceId = experienceId;
        this.config = config;
    }
    return (0, $avOEA.default)(ConcurrentExperience, [
        {
            key: "getInstance",
            value: function getInstance(instanceId) {
                if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $ek6PN.UFOExperience)(this.experienceId, this.config, instanceId);
                return this.instances[instanceId];
            }
        },
        {
            key: "release",
            value: function release(instanceId) {
                (0, $jggcA.ufolog)('instanceId', instanceId);
                if (this.instances[instanceId]) this.instances[instanceId].abort();
                delete this.instances[instanceId];
            }
        }
    ]);
}();

});
parcelRegister("jggcA", function(module, exports) {
$parcel$export(module.exports, "ufolog", function () { return $e05c14597ab17ea4$export$b4958caff08a0960; });
$parcel$export(module.exports, "ufowarn", function () { return $e05c14597ab17ea4$export$d53d07b6034c4560; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");
var $e05c14597ab17ea4$var$UFOLogger = /*#__PURE__*/ function() {
    function UFOLogger() {
        (0, $cTewU.default)(this, UFOLogger);
        (0, $f53LC.default)(this, "enabled", false);
    }
    return (0, $avOEA.default)(UFOLogger, [
        {
            key: "log",
            value: function log() {
                var _console;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                // eslint-disable-next-line no-console
                this.enabled && (_console = console).log.apply(_console, [
                    UFOLogger.UFOprefix
                ].concat(args));
            }
        },
        {
            key: "warn",
            value: function warn() {
                var _console2;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                // eslint-disable-next-line no-console
                this.enabled && (_console2 = console).warn.apply(_console2, [
                    UFOLogger.UFOprefix
                ].concat(args));
            }
        },
        {
            key: "enable",
            value: function enable() {
                this.enabled = true;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this.enabled = false;
            }
        }
    ]);
}();
(0, $f53LC.default)($e05c14597ab17ea4$var$UFOLogger, "UFOprefix", "[ufo\uD83D\uDEF8]");
var $e05c14597ab17ea4$export$4ab84f6f04f6566d = new $e05c14597ab17ea4$var$UFOLogger();
var $e05c14597ab17ea4$export$b4958caff08a0960 = function ufolog() {
    $e05c14597ab17ea4$export$4ab84f6f04f6566d.log.apply($e05c14597ab17ea4$export$4ab84f6f04f6566d, arguments);
};
var $e05c14597ab17ea4$export$d53d07b6034c4560 = function ufowarn() {
    $e05c14597ab17ea4$export$4ab84f6f04f6566d.warn.apply($e05c14597ab17ea4$export$4ab84f6f04f6566d, arguments);
};

});

parcelRegister("ek6PN", function(module, exports) {
$parcel$export(module.exports, "UFOExperience", function () { return $a6d83c1c9803e538$export$c00d22927c60484a; });

var $avOEA = parcelRequire("avOEA");

var $cTewU = parcelRequire("cTewU");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $i7dvh = parcelRequire("i7dvh");

var $8EmPZ = parcelRequire("8EmPZ");
function $a6d83c1c9803e538$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $a6d83c1c9803e538$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $a6d83c1c9803e538$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a6d83c1c9803e538$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $a6d83c1c9803e538$export$c00d22927c60484a = /*#__PURE__*/ function(_UFOAbstractExperienc) {
    function UFOExperience() {
        (0, $cTewU.default)(this, UFOExperience);
        return $a6d83c1c9803e538$var$_callSuper(this, UFOExperience, arguments);
    }
    (0, $i7dvh.default)(UFOExperience, _UFOAbstractExperienc);
    return (0, $avOEA.default)(UFOExperience);
}((0, $8EmPZ.UFOAbstractExperience));

});
parcelRegister("8EmPZ", function(module, exports) {
$parcel$export(module.exports, "UFOAbstractExperience", function () { return $64c3c63d1bb981f6$export$d31c89db257648c; });

var $lFOXD = parcelRequire("lFOXD");

var $cn8ql = parcelRequire("cn8ql");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $5Cxn4 = parcelRequire("5Cxn4");

var $5df37 = parcelRequire("5df37");

var $iEVkD = parcelRequire("iEVkD");

var $6BOUe = parcelRequire("6BOUe");

var $jggcA = parcelRequire("jggcA");

var $gr8DY = parcelRequire("gr8DY");

var $inUWW = parcelRequire("inUWW");

var $l7rXA = parcelRequire("l7rXA");

var $4kW0y = parcelRequire("4kW0y");

var $ldYqt = parcelRequire("ldYqt");

var $eOBv1 = parcelRequire("eOBv1");

var $bPjpC = parcelRequire("bPjpC");
function $64c3c63d1bb981f6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $64c3c63d1bb981f6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $64c3c63d1bb981f6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $64c3c63d1bb981f6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $64c3c63d1bb981f6$var$getPageVisibleState = function getPageVisibleState() {
    return !(0, $4kW0y.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $inUWW.PageVisibleState).VISIBLE : (0, $inUWW.PageVisibleState).HIDDEN;
};
var $64c3c63d1bb981f6$export$c753e8669d30c8ad = function perfNowOrTimestamp(timestamp) {
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $l7rXA.roundPerfNow)();
};
var $64c3c63d1bb981f6$export$d31c89db257648c = /*#__PURE__*/ function() {
    function UFOAbstractExperience(id, config) {
        var _this = this;
        var instanceId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        (0, $cTewU.default)(this, UFOAbstractExperience);
        (0, $f53LC.default)(this, "state", (0, $ldYqt.UFOExperienceState).NOT_STARTED);
        (0, $f53LC.default)(this, "instanceId", null);
        // for concurrent
        (0, $f53LC.default)(this, "parent", null);
        (0, $f53LC.default)(this, "category", null);
        (0, $f53LC.default)(this, "metadata", {});
        (0, $f53LC.default)(this, "onDoneCallbacks", []);
        (0, $f53LC.default)(this, "childExperiences", []);
        (0, $f53LC.default)(this, "explicitTimings", {});
        // @todo move to page load experience when proper classes/inheritance prepared
        (0, $f53LC.default)(this, "isSSROutputAsFMP", false);
        (0, $f53LC.default)(this, "uuid", null);
        (0, $f53LC.default)(this, "_until", null);
        (0, $f53LC.default)(this, "metrics", {
            startTime: null,
            endTime: null,
            marks: []
        });
        (0, $f53LC.default)(this, "performanceConfig", {});
        (0, $f53LC.default)(this, "setPageVisibleStateToMixed", function() {
            _this.pageVisibleState = (0, $inUWW.PageVisibleState).MIXED;
            (0, $gr8DY.visibilityChangeObserver).unsubscribe(_this.setPageVisibleStateToMixed);
        });
        this.id = id;
        this.category = (config === null || config === void 0 ? void 0 : config.category) || null;
        this.until = (config === null || config === void 0 ? void 0 : config.until) || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $64c3c63d1bb981f6$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $bPjpC.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $bPjpC.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    return (0, $avOEA.default)(UFOAbstractExperience, [
        {
            key: "transition",
            value: function() {
                var _transition = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(newState, timestamp) {
                    var data;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                (0, $jggcA.ufolog)('async transition', this.id, this.state.id, newState.id);
                                if (!(0, $eOBv1.canTransition)(this.state, newState)) {
                                    _context.next = 15;
                                    break;
                                }
                                (0, $jggcA.ufolog)("TRANSITION: ".concat(this.id, " from ").concat(this.state.id, " to ").concat(newState.id, " successful"), this.state.final, !newState.final);
                                if (newState === (0, $ldYqt.UFOExperienceState).STARTED) this._reset();
                                if (this.state.final && !newState.final) {
                                    this.metrics.startTime = $64c3c63d1bb981f6$export$c753e8669d30c8ad(timestamp);
                                    this.uuid = (0, $5df37.v4)();
                                }
                                this.state = newState;
                                if (!newState.final) {
                                    _context.next = 14;
                                    break;
                                }
                                this.metrics.endTime = $64c3c63d1bb981f6$export$c753e8669d30c8ad(timestamp);
                                if (!this._isManualStateEnabled()) (0, $6BOUe.getGlobalEventStream)().push((0, $6BOUe.unsubscribeEvent)((0, $inUWW.SUBSCRIBE_ALL), this.handleDoneBind));
                                _context.next = 11;
                                return this.exportData();
                            case 11:
                                data = _context.sent;
                                (0, $jggcA.ufolog)('this.parent', this.parent);
                                (0, $6BOUe.getGlobalEventStream)().push((0, $6BOUe.experiencePayloadEvent)(data));
                            case 14:
                                return _context.abrupt("return", true);
                            case 15:
                                (0, $jggcA.ufolog)("TRANSITION: ".concat(this.id, " from ").concat(this.state.id, " to ").concat(newState.id, " unsuccessful"));
                                (0, $jggcA.ufowarn)("transition of ".concat(this.id, " from ").concat(this.state, " to ").concat(newState, " is not possible"));
                                return _context.abrupt("return", false);
                            case 18:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function transition(_x, _x2) {
                    return _transition.apply(this, arguments);
                }
                return transition;
            }()
        },
        {
            key: "start",
            value: function() {
                var _start = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(startTime) {
                    var transitionSuccessful;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return this.transition((0, $ldYqt.UFOExperienceState).STARTED, startTime);
                            case 2:
                                transitionSuccessful = _context2.sent;
                                if (transitionSuccessful) {
                                    this.pageVisibleState = $64c3c63d1bb981f6$var$getPageVisibleState();
                                    (0, $gr8DY.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
                                    if (!this._isManualStateEnabled()) {
                                        (0, $jggcA.ufolog)('subscribed', this.id);
                                        (0, $6BOUe.getGlobalEventStream)().push((0, $6BOUe.subscribeEvent)((0, $inUWW.SUBSCRIBE_ALL), this.handleDoneBind));
                                    }
                                }
                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function start(_x3) {
                    return _start.apply(this, arguments);
                }
                return start;
            }()
        },
        {
            key: "mark",
            value: function mark(name, timestamp) {
                if (name !== (0, $inUWW.FMP_MARK) && name !== (0, $inUWW.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
                else (0, $jggcA.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
            }
        },
        {
            key: "_mark",
            value: function _mark(name, timestamp) {
                this.metrics.marks.push({
                    name: name,
                    time: $64c3c63d1bb981f6$export$c753e8669d30c8ad(timestamp)
                });
                this.transition((0, $ldYqt.UFOExperienceState).IN_PROGRESS);
            }
        },
        {
            key: "markFMP",
            value: function markFMP(timestamp) {
                this._mark((0, $inUWW.FMP_MARK), timestamp);
            }
        },
        {
            key: "markInlineResponse",
            value: function markInlineResponse(timestamp) {
                this._mark((0, $inUWW.INLINE_RESPONSE_MARK), timestamp);
            }
        },
        {
            key: "_isManualStateEnabled",
            value: function _isManualStateEnabled() {
                return this.until === null;
            }
        },
        {
            key: "_validateManualState",
            value: function _validateManualState() {
                if (!this._isManualStateEnabled()) {
                    (0, $jggcA.ufowarn)('manual change of state not allowed as "until" is defined');
                    return false;
                }
                return true;
            }
        },
        {
            key: "switchToEndState",
            value: function switchToEndState(state, config) {
                if (!(config !== null && config !== void 0 && config.force) && !this._validateManualState()) return null;
                if (config !== null && config !== void 0 && config.metadata) this.addMetadata(config.metadata);
                (0, $gr8DY.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
                return this.transition(state);
            }
        },
        {
            key: "success",
            value: function() {
                var _success = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", this.switchToEndState((0, $ldYqt.UFOExperienceState).SUCCEEDED, config));
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function success(_x4) {
                    return _success.apply(this, arguments);
                }
                return success;
            }()
        },
        {
            key: "failure",
            value: function() {
                var _failure = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee4(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                return _context4.abrupt("return", this.switchToEndState((0, $ldYqt.UFOExperienceState).FAILED, config));
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function failure(_x5) {
                    return _failure.apply(this, arguments);
                }
                return failure;
            }()
        },
        {
            key: "abort",
            value: function() {
                var _abort = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee5(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                return _context5.abrupt("return", this.switchToEndState((0, $ldYqt.UFOExperienceState).ABORTED, config));
                            case 1:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function abort(_x6) {
                    return _abort.apply(this, arguments);
                }
                return abort;
            }()
        },
        {
            key: "addMetadata",
            value: function addMetadata(data) {
                Object.assign(this.metadata, data);
            }
        },
        {
            key: "_handleDoneExperience",
            value: function _handleDoneExperience(data) {
                (0, $jggcA.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
                if (data.state.final) {
                    if (this._until !== null) {
                        var _this$_until = this._until(data), done = _this$_until.done, state = _this$_until.state;
                        if (done && !this.state.final) this.transition(state);
                    }
                }
            }
        },
        {
            key: "getId",
            value: function() {
                var _getId = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee6() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                return _context6.abrupt("return", this.id);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function getId() {
                    return _getId.apply(this, arguments);
                }
                return getId;
            }()
        },
        {
            key: "exportData",
            value: function() {
                var _exportData = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                _context7.next = 2;
                                return this.getId();
                            case 2:
                                _context7.t0 = _context7.sent;
                                _context7.t1 = this.uuid;
                                _context7.t2 = this.type;
                                _context7.t3 = (0, $iEVkD.UFO_EXPERIMENTAL_BUILD_VERSION) || 'unknown';
                                _context7.t4 = this.performanceType;
                                _context7.t5 = this.category;
                                _context7.t6 = this.state;
                                _context7.t7 = $64c3c63d1bb981f6$var$_objectSpread({}, this.metadata);
                                _context7.t8 = $64c3c63d1bb981f6$var$_objectSpread({}, this.metrics);
                                _context7.t9 = (0, $lFOXD.default)(this.childExperiences);
                                _context7.t10 = {
                                    success: !!this.state.success,
                                    startTime: this.metrics.startTime,
                                    duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
                                };
                                _context7.t11 = this.config.platform || null;
                                _context7.t12 = this.pageVisibleState;
                                _context7.t13 = this.featureFlags;
                                _context7.t14 = this.isSSROutputAsFMP;
                                _context7.t15 = this.timings;
                                _context7.t16 = this.explicitTimings;
                                _context7.t17 = this.performanceConfig;
                                return _context7.abrupt("return", {
                                    id: _context7.t0,
                                    uuid: _context7.t1,
                                    type: _context7.t2,
                                    schemaVersion: _context7.t3,
                                    performanceType: _context7.t4,
                                    category: _context7.t5,
                                    state: _context7.t6,
                                    metadata: _context7.t7,
                                    metrics: _context7.t8,
                                    children: _context7.t9,
                                    result: _context7.t10,
                                    platform: _context7.t11,
                                    pageVisibleState: _context7.t12,
                                    featureFlags: _context7.t13,
                                    isSSROutputAsFMP: _context7.t14,
                                    timings: _context7.t15,
                                    explicitTimings: _context7.t16,
                                    performanceConfig: _context7.t17
                                });
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function exportData() {
                    return _exportData.apply(this, arguments);
                }
                return exportData;
            }()
        },
        {
            key: "_reset",
            value: function _reset() {
                this.parent = null;
                this.metadata = {};
                this.onDoneCallbacks = [];
                this.childExperiences = [];
                this.metrics = {
                    startTime: null,
                    endTime: null,
                    marks: []
                };
                this._until = this.until ? this.until() : null;
            }
        }
    ]);
}();

});
parcelRegister("5df37", function(module, exports) {

var $fl0qq = parcelRequire("fl0qq");

var $5TdI6 = parcelRequire("5TdI6");
var $3cb9d723354318c5$var$uuid = $5TdI6;
$3cb9d723354318c5$var$uuid.v1 = $fl0qq;
$3cb9d723354318c5$var$uuid.v4 = $5TdI6;
module.exports = $3cb9d723354318c5$var$uuid;

});
parcelRegister("fl0qq", function(module, exports) {

var $1iFDD = parcelRequire("1iFDD");

var $hUX6u = parcelRequire("hUX6u");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $b2a925a4a14fdead$var$_nodeId;
var $b2a925a4a14fdead$var$_clockseq;
// Previous uuid creation time
var $b2a925a4a14fdead$var$_lastMSecs = 0;
var $b2a925a4a14fdead$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $b2a925a4a14fdead$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $b2a925a4a14fdead$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $b2a925a4a14fdead$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $1iFDD();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $b2a925a4a14fdead$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $b2a925a4a14fdead$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $b2a925a4a14fdead$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $b2a925a4a14fdead$var$_lastMSecs + (nsecs - $b2a925a4a14fdead$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $b2a925a4a14fdead$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $b2a925a4a14fdead$var$_lastMSecs = msecs;
    $b2a925a4a14fdead$var$_lastNSecs = nsecs;
    $b2a925a4a14fdead$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $hUX6u(b);
}
module.exports = $b2a925a4a14fdead$var$v1;

});
parcelRegister("1iFDD", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $0f27c5622fc8e20b$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($0f27c5622fc8e20b$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $0f27c5622fc8e20b$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $0f27c5622fc8e20b$var$getRandomValues($0f27c5622fc8e20b$var$rnds8);
        return $0f27c5622fc8e20b$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $0f27c5622fc8e20b$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $0f27c5622fc8e20b$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $0f27c5622fc8e20b$var$rnds;
    };
}

});

parcelRegister("hUX6u", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $d0b58365f3fc0a25$var$byteToHex = [];
for(var $d0b58365f3fc0a25$var$i = 0; $d0b58365f3fc0a25$var$i < 256; ++$d0b58365f3fc0a25$var$i)$d0b58365f3fc0a25$var$byteToHex[$d0b58365f3fc0a25$var$i] = ($d0b58365f3fc0a25$var$i + 0x100).toString(16).substr(1);
function $d0b58365f3fc0a25$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $d0b58365f3fc0a25$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = $d0b58365f3fc0a25$var$bytesToUuid;

});


parcelRegister("5TdI6", function(module, exports) {

var $1iFDD = parcelRequire("1iFDD");

var $hUX6u = parcelRequire("hUX6u");
function $449cb9673c4c8bbb$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $1iFDD)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $hUX6u(rnds);
}
module.exports = $449cb9673c4c8bbb$var$v4;

});


parcelRegister("iEVkD", function(module, exports) {
$parcel$export(module.exports, "UFO_EXPERIMENTAL_BUILD_VERSION", function () { return $d9586f57762d7b94$export$2295b861f318254a; });
// temp solution until we can get it automated
var $d9586f57762d7b94$export$2295b861f318254a = '0.1.5';

});

parcelRegister("6BOUe", function(module, exports) {
$parcel$export(module.exports, "getGlobalEventStream", function () { return $4cfdafa11067bef8$export$6123a44dc2384540; });
$parcel$export(module.exports, "subscribeEvent", function () { return $4cfdafa11067bef8$export$37863216db4b714d; });
$parcel$export(module.exports, "unsubscribeEvent", function () { return $4cfdafa11067bef8$export$ee1a7bd1fc9ea85e; });
$parcel$export(module.exports, "experiencePayloadEvent", function () { return $4cfdafa11067bef8$export$7c957416596ca127; });

var $jggcA = parcelRequire("jggcA");

var $inUWW = parcelRequire("inUWW");
var $4cfdafa11067bef8$var$MAX_EARLY_QUEUE_LENGTH = 250;
var $4cfdafa11067bef8$export$6123a44dc2384540 = function getGlobalEventStream() {
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        var earlyStream = function() {
            var stream = [];
            return {
                __buffer_only__: true,
                push: function push(event) {
                    if (stream.length < $4cfdafa11067bef8$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: function getStream() {
                    return stream;
                }
            };
        }();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
var $4cfdafa11067bef8$export$c1522520b417b066 = function setGlobalEventStream(eventStream) {
    var _globalThis$__UFO_GLO, _globalThis$__UFO_GLO2;
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !((_globalThis$__UFO_GLO = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO !== void 0 && _globalThis$__UFO_GLO.__buffer_only__)) {
        (0, $jggcA.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if ((_globalThis$__UFO_GLO2 = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO2 !== void 0 && _globalThis$__UFO_GLO2.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
var $4cfdafa11067bef8$export$37863216db4b714d = function subscribeEvent(experienceId, callback) {
    return {
        type: (0, $inUWW.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
var $4cfdafa11067bef8$export$ee1a7bd1fc9ea85e = function unsubscribeEvent(experienceId, callback) {
    return {
        type: (0, $inUWW.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
var $4cfdafa11067bef8$export$7c957416596ca127 = function experiencePayloadEvent(data) {
    return {
        type: (0, $inUWW.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("inUWW", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStreamEventType", function () { return $d6268cfd730b888d$export$96253c35c37cf96b; });
$parcel$export(module.exports, "PageVisibleState", function () { return $d6268cfd730b888d$export$a12c67b37a306b13; });
$parcel$export(module.exports, "SUBSCRIBE_ALL", function () { return $d6268cfd730b888d$export$79bf131685ad41d7; });
$parcel$export(module.exports, "FMP_MARK", function () { return $d6268cfd730b888d$export$9f2bf58999404c75; });
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", function () { return $d6268cfd730b888d$export$837e0f79a8056912; });
var $d6268cfd730b888d$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $d6268cfd730b888d$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $d6268cfd730b888d$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $d6268cfd730b888d$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $d6268cfd730b888d$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $d6268cfd730b888d$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
var $d6268cfd730b888d$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
var $d6268cfd730b888d$export$9f2bf58999404c75 = 'fmp';
var $d6268cfd730b888d$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("gr8DY", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", function () { return $bf75df6b54fa30f6$export$13e680397ec8f3eb; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $4kW0y = parcelRequire("4kW0y");
var $bf75df6b54fa30f6$var$VisibilityChangeObserver = /*#__PURE__*/ function() {
    function VisibilityChangeObserver() {
        var _this = this;
        (0, $cTewU.default)(this, VisibilityChangeObserver);
        (0, $f53LC.default)(this, "started", false);
        (0, $f53LC.default)(this, "observers", []);
        (0, $f53LC.default)(this, "broadcast", function() {
            _this.observers.forEach(function(fn) {
                return fn();
            });
            _this.observers = [];
        });
    }
    return (0, $avOEA.default)(VisibilityChangeObserver, [
        {
            key: "start",
            value: function start() {
                if (this.started) return;
                this.started = true;
                document.addEventListener('visibilitychange', this.broadcast);
                /**
       * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
       * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
       * so for that case, you need to also include code to listen for the pagehide event.
       */ if ((0, $4kW0y.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                this.observers.push(callback);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(callback) {
                this.observers = this.observers.filter(function(fn) {
                    return fn !== callback;
                });
            }
        }
    ]);
}();
var $bf75df6b54fa30f6$export$13e680397ec8f3eb = new $bf75df6b54fa30f6$var$VisibilityChangeObserver();

});
parcelRegister("4kW0y", function(module, exports) {
$parcel$export(module.exports, "isWindowObjectAvailable", function () { return $328606e00ae501f0$export$15e172712955e18f; });
var $328606e00ae501f0$export$15e172712955e18f = function isWindowObjectAvailable() {
    return typeof window !== 'undefined';
};

});


parcelRegister("l7rXA", function(module, exports) {
$parcel$export(module.exports, "roundPerfNow", function () { return $f5fff0b37cd90aa9$export$5f490af6b2b115cf; });
var $f5fff0b37cd90aa9$export$5f490af6b2b115cf = function roundPerfNow() {
    return ~~performance.now();
};

});

parcelRegister("eOBv1", function(module, exports) {
$parcel$export(module.exports, "canTransition", function () { return $ac92d2cb8014fbef$export$178881f329fdb81f; });

var $f53LC = parcelRequire("f53LC");

var $ldYqt = parcelRequire("ldYqt");
var $ac92d2cb8014fbef$var$UFOStateAvailableTransitions = (0, $f53LC.default)((0, $f53LC.default)((0, $f53LC.default)((0, $f53LC.default)((0, $f53LC.default)((0, $f53LC.default)((0, $f53LC.default)((0, $f53LC.default)((0, $f53LC.default)({}, (0, $ldYqt.UFOExperienceState).NOT_STARTED.id, [
    (0, $ldYqt.UFOExperienceState).STARTED.id
]), (0, $ldYqt.UFOExperienceState).STARTED.id, [
    (0, $ldYqt.UFOExperienceState).IN_PROGRESS.id,
    (0, $ldYqt.UFOExperienceState).BLOCKED.id,
    (0, $ldYqt.UFOExperienceState).SUCCEEDED.id,
    (0, $ldYqt.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $ldYqt.UFOExperienceState).FAILED.id,
    (0, $ldYqt.UFOExperienceState).ABORTED.id
]), (0, $ldYqt.UFOExperienceState).IN_PROGRESS.id, [
    (0, $ldYqt.UFOExperienceState).BLOCKED.id,
    (0, $ldYqt.UFOExperienceState).SUCCEEDED.id,
    (0, $ldYqt.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $ldYqt.UFOExperienceState).FAILED.id,
    (0, $ldYqt.UFOExperienceState).ABORTED.id
]), (0, $ldYqt.UFOExperienceState).BLOCKED.id, [
    (0, $ldYqt.UFOExperienceState).RECOVERED.id,
    (0, $ldYqt.UFOExperienceState).ABORTED.id
]), (0, $ldYqt.UFOExperienceState).RECOVERED.id, [
    (0, $ldYqt.UFOExperienceState).STARTED.id,
    (0, $ldYqt.UFOExperienceState).SUCCEEDED.id,
    (0, $ldYqt.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $ldYqt.UFOExperienceState).FAILED.id,
    (0, $ldYqt.UFOExperienceState).ABORTED.id
]), (0, $ldYqt.UFOExperienceState).SUCCEEDED.id, [
    (0, $ldYqt.UFOExperienceState).STARTED.id
]), (0, $ldYqt.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id, [
    (0, $ldYqt.UFOExperienceState).SUCCEEDED.id,
    (0, $ldYqt.UFOExperienceState).FAILED.id,
    (0, $ldYqt.UFOExperienceState).ABORTED.id
]), (0, $ldYqt.UFOExperienceState).FAILED.id, [
    (0, $ldYqt.UFOExperienceState).STARTED.id
]), (0, $ldYqt.UFOExperienceState).ABORTED.id, [
    (0, $ldYqt.UFOExperienceState).STARTED.id
]);
var $ac92d2cb8014fbef$export$178881f329fdb81f = function canTransition(state1, state2) {
    return $ac92d2cb8014fbef$var$UFOStateAvailableTransitions[state1.id] && $ac92d2cb8014fbef$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});

parcelRegister("bPjpC", function(module, exports) {
$parcel$export(module.exports, "ExperienceTypes", function () { return $89c383feb39d12a0$export$994164cf3ae1cc9a; });
$parcel$export(module.exports, "ExperiencePerformanceTypes", function () { return $89c383feb39d12a0$export$cc26007c03242fff; });
var $89c383feb39d12a0$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $89c383feb39d12a0$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});




parcelRegister("74Hur", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $526aa4517bee758f$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $d4gmc = parcelRequire("d4gmc");

var $90JID = parcelRequire("90JID");

var $ebJx7 = parcelRequire("ebJx7");
var $526aa4517bee758f$var$_excluded = [
    "testId",
    "src",
    "size",
    "teamId",
    "compact"
];
var $526aa4517bee758f$export$ebe0b8fe8b6acbfd = "var(--ds-icon-inverse, ".concat((0, $90JID.N0), ")");
var $526aa4517bee758f$export$72502e51aebdd94e = "var(--ds-icon-subtle, ".concat((0, $90JID.N90), ")");
function $526aa4517bee758f$export$2e2bcd8739ae039(_ref) {
    var testId = _ref.testId, src = _ref.src, _ref$size = _ref.size, size = _ref$size === void 0 ? 'medium' : _ref$size, _ref$teamId = _ref.teamId, teamId = _ref$teamId === void 0 ? '' : _ref$teamId, _ref$compact = _ref.compact, compact = _ref$compact === void 0 ? false : _ref$compact, props = (0, $gnQ3X.default)(_ref, $526aa4517bee758f$var$_excluded);
    // Strip ARI in case the teamId was given in that format
    teamId = teamId.replace('ari:cloud:identity::team/', '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $d4gmc.default), (0, $c9bqK.default)({
        appearance: "square"
    }, props, {
        size: size,
        src: src,
        testId: "".concat(testId, "-team-avatar")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $ebJx7.TeamAvatarImage), {
        src: src,
        size: size,
        testId: testId,
        teamId: teamId,
        compact: compact
    }));
}

});
parcelRegister("d4gmc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $98385641a849b426$export$2e2bcd8739ae039; });
/* avatar.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $6THDr = parcelRequire("6THDr");

var $lXke7 = parcelRequire("lXke7");

var $hjAcH = parcelRequire("hjAcH");

var $7lwCL = parcelRequire("7lwCL");

var $d4PqV = parcelRequire("d4PqV");

var $kjtT0 = parcelRequire("kjtT0");

var $ffO9K = parcelRequire("ffO9K");

var $lqPgK = parcelRequire("lqPgK");

var $4Kmsl = parcelRequire("4Kmsl");

var $3lgxL = parcelRequire("3lgxL");

var $iq3a7 = parcelRequire("iq3a7");
function $98385641a849b426$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $98385641a849b426$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $98385641a849b426$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $98385641a849b426$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $98385641a849b426$var$packageName = "@atlaskit/avatar";
var $98385641a849b426$var$packageVersion = "25.11.2";
var $98385641a849b426$var$containerStyles = null;
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ var $98385641a849b426$var$Avatar = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'circle' : _ref$appearance, label = _ref.label, borderColor = _ref.borderColor, children = _ref.children, href = _ref.href, isDisabled = _ref.isDisabled, name = _ref.name, onClick = _ref.onClick, presence = _ref.presence, sizeProp = _ref.size, src = _ref.src, stackIndex = _ref.stackIndex, status = _ref.status, target = _ref.target, testId = _ref.testId, _ref$as = _ref.as, AvatarContainer = _ref$as === void 0 ? 'div' : _ref$as, _ref$isDecorative = _ref.isDecorative, isDecorative = _ref$isDecorative === void 0 ? false : _ref$isDecorative, imgLoading = _ref.imgLoading, ariaControls = _ref['aria-controls'], ariaExpanded = _ref['aria-expanded'], ariaHasPopup = _ref['aria-haspopup'];
    var _useAnalyticsEvents = (0, $lXke7.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var context = (0, $d4PqV.useAvatarContext)();
    var size = sizeProp || (context === null || context === void 0 ? void 0 : context.size) || 'medium';
    var customPresenceNode = /*#__PURE__*/ (0, $1oC0p.isValidElement)(presence) ? presence : null;
    var customStatusNode = /*#__PURE__*/ (0, $1oC0p.isValidElement)(status) ? status : null;
    var isValidIconSize = size !== 'xxlarge' && size !== 'xsmall';
    var lastAnalytics = (0, $1oC0p.useRef)(analyticsContext);
    var labelId = (0, $hjAcH.useId)();
    (0, $1oC0p.useEffect)(function() {
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    var onClickHandler = (0, $1oC0p.useCallback)(function(event) {
        if (isDisabled || typeof onClick !== 'function') return;
        var analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'avatar',
            attributes: {
                componentName: 'avatar',
                packageName: $98385641a849b426$var$packageName,
                packageVersion: $98385641a849b426$var$packageVersion
            }
        });
        /**
     * To avoid wrapping this component in AnalyticsContext we manually
     * push the parent context's meta data into the context.
     */ var context = $98385641a849b426$var$_objectSpread({
            componentName: 'avatar',
            packageName: $98385641a849b426$var$packageName,
            packageVersion: $98385641a849b426$var$packageVersion
        }, lastAnalytics.current);
        analyticsEvent.context.push(context);
        /**
     * Replicating the logic in the `withAnalyticsEvents` HOC.
     */ var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    var isPresence = isValidIconSize && presence && !status;
    var isStatus = isValidIconSize && status;
    // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    var defaultLabel = [
        name,
        isStatus && !customStatusNode && "(".concat(status, ")"),
        isPresence && !customPresenceNode && "(".concat(presence, ")")
    ].filter(Boolean).join(' ');
    var isInteractive = onClick || href || isDisabled || ariaHasPopup;
    var containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return /*#__PURE__*/ $1oC0p.createElement((0, $lqPgK.EnsureIsInsideAvatarContext).Provider, {
        value: true
    }, /*#__PURE__*/ $1oC0p.createElement(AvatarContainer, {
        "data-testid": testId,
        role: containerShouldBeImage ? 'img' : undefined,
        "aria-labelledby": containerShouldBeImage && !isDecorative ? labelId : undefined,
        style: {
            zIndex: stackIndex
        },
        className: (0, $6THDr.default)([
            "_12ji1r31 _1qu2glyw _12y3idpf _1e0c1o8l _kqswh2mm"
        ])
    }, /*#__PURE__*/ $1oC0p.createElement((0, $ffO9K.AvatarContentContext).Provider, {
        value: {
            as: (0, $4Kmsl.default)(isDisabled, href, onClick, ariaHasPopup),
            appearance: appearance,
            borderColor: borderColor,
            href: href,
            isDisabled: isDisabled,
            label: label || defaultLabel,
            onClick: isInteractive ? onClickHandler : undefined,
            ref: ref,
            size: size,
            stackIndex: stackIndex,
            target: target,
            testId: testId ? "".concat(testId, "--inner") : undefined,
            'aria-controls': ariaControls,
            'aria-expanded': ariaExpanded,
            'aria-haspopup': ariaHasPopup,
            avatarImage: /*#__PURE__*/ $1oC0p.createElement((0, $kjtT0.default), {
                alt: !containerShouldBeImage && src ? name : undefined,
                src: src,
                appearance: appearance,
                size: size,
                testId: testId,
                imgLoading: imgLoading
            })
        }
    }, children || /*#__PURE__*/ $1oC0p.createElement((0, $7lwCL.AvatarContent), null)), isPresence && /*#__PURE__*/ $1oC0p.createElement((0, $3lgxL.default), {
        appearance: appearance,
        size: size,
        presence: typeof presence === 'string' ? presence : undefined,
        testId: testId
    }, customPresenceNode), isStatus && /*#__PURE__*/ $1oC0p.createElement((0, $iq3a7.default), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        status: typeof status === 'string' ? status : undefined,
        testId: testId
    }, customStatusNode), containerShouldBeImage ? /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId && "".concat(testId, "--label"),
        id: labelId,
        hidden: true
    }, defaultLabel) : undefined));
});
$98385641a849b426$var$Avatar.displayName = 'Avatar';
var $98385641a849b426$export$2e2bcd8739ae039 = $98385641a849b426$var$Avatar;

});
parcelRegister("6THDr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5059ba29568051b7$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $5059ba29568051b7$var$ATOMIC_GROUP_LENGTH = 5;
function $5059ba29568051b7$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $5059ba29568051b7$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("lXke7", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", function () { return $ffbecc49f99c766c$export$5bf35293e545f20c; });

var $hcVab = parcelRequire("hcVab");

var $bpo6M = parcelRequire("bpo6M");

var $81IZB = parcelRequire("81IZB");
function $ffbecc49f99c766c$export$5bf35293e545f20c() {
    var analyticsContext = (0, $81IZB.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $hcVab.useCallbackOne)(function(payload) {
        return new (0, $bpo6M.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("bpo6M", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $84e4baea067c055b$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $7SQOE = parcelRequire("7SQOE");

var $i7dvh = parcelRequire("i7dvh");

var $f53LC = parcelRequire("f53LC");

var $hV3YI = parcelRequire("hV3YI");
function $84e4baea067c055b$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $84e4baea067c055b$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $84e4baea067c055b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($84e4baea067c055b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $84e4baea067c055b$var$_superPropGet(t, o, e, r) {
    var p = (0, $7SQOE.default)((0, $jlBwm.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $84e4baea067c055b$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $84e4baea067c055b$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $84e4baea067c055b$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $cTewU.default)(this, UIAnalyticsEvent);
        _this = $84e4baea067c055b$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $f53LC.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $f53LC.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $lFOXD.default)(_this.context);
            var handlers = (0, $lFOXD.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $f53LC.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $i7dvh.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $avOEA.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $84e4baea067c055b$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $hV3YI.default));

});
parcelRegister("hV3YI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d0bad88662636642$export$2e2bcd8739ae039; });

var $2zYm4 = parcelRequire("2zYm4");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");
function $d0bad88662636642$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d0bad88662636642$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d0bad88662636642$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d0bad88662636642$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d0bad88662636642$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $d0bad88662636642$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $d0bad88662636642$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $cTewU.default)(this, AnalyticsEvent);
        (0, $f53LC.default)(this, "_isAnalyticsEvent", true);
        (0, $f53LC.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $d0bad88662636642$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $avOEA.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $2zYm4.default)(updater) === 'object') this.payload = $d0bad88662636642$var$_objectSpread($d0bad88662636642$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("81IZB", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", function () { return $5d815152d5e89569$export$d1f587f82ad51c4; });

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");
var $5d815152d5e89569$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $1oC0p.useContext)((0, $bEiDG.default));
};

});


parcelRegister("hjAcH", function(module, exports) {
$parcel$export(module.exports, "useId", function () { return $c9b04b57f74a4a8f$export$f680877a34711e37; });

var $2zYm4 = parcelRequire("2zYm4");

var $1oC0p = parcelRequire("1oC0p");
function $c9b04b57f74a4a8f$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useId().replace(/[:«»]/g, '_');
}
var $c9b04b57f74a4a8f$export$6be90bcb437e928f = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($c9b04b57f74a4a8f$export$f680877a34711e37()).concat(postfix);
    (0, $1oC0p.useEffect)(function() {
        if (!ref) return;
        switch((0, $2zYm4.default)(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, $2zYm4.default)(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $c9b04b57f74a4a8f$export$6ee17796e3d70de2() {
    var uid = $c9b04b57f74a4a8f$export$f680877a34711e37();
    return function(id) {
        return "".concat(uid, "-").concat(id.toString());
    };
}

});

parcelRegister("7lwCL", function(module, exports) {
$parcel$export(module.exports, "AvatarContent", function () { return $5593cd0d038a9edb$export$47fbc0b44cae5559; });
/* avatar-content.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $c9bqK = parcelRequire("c9bqK");

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $6THDr = parcelRequire("6THDr");

var $ekHT4 = parcelRequire("ekHT4");

var $ffO9K = parcelRequire("ffO9K");

var $lqPgK = parcelRequire("lqPgK");
var $5593cd0d038a9edb$var$boxShadowCssVar = '--avatar-box-shadow';
var $5593cd0d038a9edb$var$bgColorCssVar = '--avatar-bg-color';
var $5593cd0d038a9edb$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk1j28 _aetrf705 _1peqidpf _11fnglyw _1ejjglyw _mizu1v1w _1ah3v77o _ra3xnqa1 _128mdkaa _4dave4h9",
    circle: "_2rko1qll _14mj1qll",
    square: "_2rkol0p1",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peq2wxo"
};
var $5593cd0d038a9edb$var$unboundStyles = {
    rootCustomBorder: "_11q7cxp3",
    root: "_vchh1ntv _bfhkcxp3 _16qs1nhn",
    hexagonFocusContainer: "_1rjc1wgn _18zr1dm9 _1mou5h37 _bfhk1j28 _mkrz1k6g _1o9o1v1w",
    hexagonFocusContainerMarginFg: "_195g1ksc",
    hexagonBorderContainerCustomBorder: "_11q7cxp3",
    hexagonBorderContainer: "_1rjcf6hp _18zruxly _bfhkcxp3 _mkrz1kw7 _1o9ovuon",
    hexagonBorderContainerMarginFg: "_1mou18m8 _195gzwb8",
    hexagon: "_2rkoidpf _mkrz1kw7 _16qsn7od _14mjidpf _1ejjn7od _128midpf _4davidpf",
    interactive: "_80omtlke _4tpu1f0r _ez1ykb7n _gcm1jer9 _eeh8kb7n _jlxit94y",
    interactiveMotion: "_v564155l _1llweo6y"
};
var $5593cd0d038a9edb$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
var $5593cd0d038a9edb$var$marginAdjustmentMap = {
    xsmall: "_195gcwjc",
    small: "_195gcwjc",
    medium: "_195gs7t4",
    large: "_195gs7t4",
    xlarge: "_195g8ocb",
    xxlarge: "_195g1ukp"
};
var $5593cd0d038a9edb$export$47fbc0b44cae5559 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children;
    (0, $lqPgK.useEnsureIsInsideAvatar)();
    var _useContext = (0, $1oC0p.useContext)((0, $ffO9K.AvatarContentContext)), Container = _useContext.as, appearance = _useContext.appearance, avatarImage = _useContext.avatarImage, _useContext$borderCol = _useContext.borderColor, borderColor = _useContext$borderCol === void 0 ? "var(--ds-surface, #FFFFFF)" : _useContext$borderCol, href = _useContext.href, isDisabled = _useContext.isDisabled, label = _useContext.label, onClick = _useContext.onClick, contextRef = _useContext.ref, tabIndex = _useContext.tabIndex, target = _useContext.target, testId = _useContext.testId, size = _useContext.size, stackIndex = _useContext.stackIndex, ariaControls = _useContext['aria-controls'], ariaExpanded = _useContext['aria-expanded'], ariaHasPopup = _useContext['aria-haspopup'];
    var isInteractive = Boolean(onClick || href || isDisabled || ariaHasPopup);
    var renderedContent = /*#__PURE__*/ $1oC0p.createElement(Container, (0, $c9bqK.default)({
        style: (0, $f53LC.default)((0, $f53LC.default)({}, $5593cd0d038a9edb$var$bgColorCssVar, borderColor), $5593cd0d038a9edb$var$boxShadowCssVar, "0 0 0 2px ".concat(borderColor)),
        ref: ref || contextRef,
        "aria-label": isInteractive ? label : undefined,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        onClick: onClick,
        tabIndex: tabIndex,
        "data-testid": testId,
        disabled: isDisabled,
        type: Container === 'button' ? 'button' : undefined
    }, href && {
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined
    }, {
        className: (0, $6THDr.default)([
            $5593cd0d038a9edb$var$unboundStyles.root,
            (0, $ekHT4.fg)('avatar-custom-border') && $5593cd0d038a9edb$var$unboundStyles.rootCustomBorder,
            $5593cd0d038a9edb$var$styles.root,
            appearance === 'square' && $5593cd0d038a9edb$var$styles.square,
            appearance === 'circle' && $5593cd0d038a9edb$var$styles.circle,
            appearance === 'hexagon' && $5593cd0d038a9edb$var$unboundStyles.hexagon,
            $5593cd0d038a9edb$var$widthHeightMap[size],
            stackIndex !== undefined && $5593cd0d038a9edb$var$styles.positionRelative,
            isInteractive && !isDisabled && $5593cd0d038a9edb$var$unboundStyles.interactive,
            isInteractive && !isDisabled && (0, $ekHT4.fg)('platform-dst-motion-uplift') && $5593cd0d038a9edb$var$unboundStyles.interactiveMotion,
            isDisabled && $5593cd0d038a9edb$var$styles.disabled
        ])
    }), children || avatarImage);
    if (appearance !== 'hexagon') return renderedContent;
    // For a Hexagon Avatar in order to have hexagonal "border" and "outline", we have to
    // layer multiple elements and use their background colors to create the different layers.
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        style: (0, $f53LC.default)((0, $f53LC.default)({}, $5593cd0d038a9edb$var$bgColorCssVar, borderColor), $5593cd0d038a9edb$var$boxShadowCssVar, "0 0 0 2px ".concat(borderColor)),
        "data-testid": testId ? "".concat(testId, "-hexagon-focus-container") : 'hexagon-focus-container',
        className: (0, $6THDr.default)([
            $5593cd0d038a9edb$var$unboundStyles.hexagonFocusContainer,
            !(0, $ekHT4.fg)('platform_dst_hexagon_avatar_unified_size') && $5593cd0d038a9edb$var$marginAdjustmentMap[size],
            (0, $ekHT4.fg)('platform_dst_hexagon_avatar_unified_size') && $5593cd0d038a9edb$var$unboundStyles.hexagonFocusContainerMarginFg
        ])
    }, /*#__PURE__*/ $1oC0p.createElement("div", {
        "data-testid": testId ? "".concat(testId, "-hexagon-border-container") : 'hexagon-border-container',
        className: (0, $6THDr.default)([
            $5593cd0d038a9edb$var$unboundStyles.hexagonBorderContainer,
            (0, $ekHT4.fg)('avatar-custom-border') && $5593cd0d038a9edb$var$unboundStyles.hexagonBorderContainerCustomBorder,
            (0, $ekHT4.fg)('platform_dst_hexagon_avatar_unified_size') && $5593cd0d038a9edb$var$unboundStyles.hexagonBorderContainerMarginFg
        ])
    }, renderedContent));
});

});
parcelRegister("ekHT4", function(module, exports) {
$parcel$export(module.exports, "fg", function () { return $a6f4fa097df6abf0$export$b40ec24ac8275656; });

var $dnLO2 = parcelRequire("dnLO2");
function $a6f4fa097df6abf0$export$ba05d765b8392e5e(flagResolver) {
    (0, $dnLO2.setBooleanResolver)(flagResolver);
}
function $a6f4fa097df6abf0$export$470e5c2be1411c89(name) {
    return (0, $dnLO2.resolveBooleanFlag)(name);
}
function $a6f4fa097df6abf0$export$b40ec24ac8275656(name) {
    return (0, $dnLO2.resolveBooleanFlag)(name);
}

});
parcelRegister("dnLO2", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", function () { return $9be281a17fd777cc$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $9be281a17fd777cc$export$6333b6aff9fc6275; });

var $iTr7d = parcelRequire("iTr7d");

var $30tUo = parcelRequire("30tUo");

var $7t0tI = parcelRequire("7t0tI");
var $9be281a17fd777cc$var$pkgName = '@atlaskit/platform-feature-flags';
var $9be281a17fd777cc$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $9be281a17fd777cc$var$hasProcessEnv = typeof $7t0tI !== 'undefined' && typeof $7t0tI.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $9be281a17fd777cc$var$ENV_ENABLE_PLATFORM_FF = $9be281a17fd777cc$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $9be281a17fd777cc$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $9be281a17fd777cc$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $9be281a17fd777cc$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $9be281a17fd777cc$var$ENV_ENABLE_PLATFORM_FF || $9be281a17fd777cc$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $9be281a17fd777cc$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $9be281a17fd777cc$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$9be281a17fd777cc$var$globalVar[$9be281a17fd777cc$export$7e41b1b2bdee3f98] = $9be281a17fd777cc$var$globalVar[$9be281a17fd777cc$export$7e41b1b2bdee3f98] || $9be281a17fd777cc$var$DEFAULT_PFF_GLOBAL;
function $9be281a17fd777cc$export$f2b591175b3e424c(resolver) {
    $9be281a17fd777cc$var$globalVar[$9be281a17fd777cc$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $9be281a17fd777cc$export$6333b6aff9fc6275(flagKey) {
    if ($9be281a17fd777cc$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $30tUo.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $9be281a17fd777cc$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $9be281a17fd777cc$var$globalVar[$9be281a17fd777cc$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $9be281a17fd777cc$var$globalVar[$9be281a17fd777cc$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $iTr7d.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $9be281a17fd777cc$var$globalVar[$9be281a17fd777cc$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("iTr7d", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dc1265948a4691ef$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $5vnR4 = parcelRequire("5vnR4");

var $13mYk = parcelRequire("13mYk");



var $dc1265948a4691ef$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $dc1265948a4691ef$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, $cTewU.default)(this, FeatureGates);
    }
    return (0, $avOEA.default)(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$dc1265948a4691ef$var$_FeatureGates = $dc1265948a4691ef$var$FeatureGates;
(0, $f53LC.default)($dc1265948a4691ef$var$FeatureGates, "client", new (0, $5vnR4.Client)());
(0, $f53LC.default)($dc1265948a4691ef$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, $f53LC.default)($dc1265948a4691ef$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, $f53LC.default)($dc1265948a4691ef$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$dc1265948a4691ef$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $dc1265948a4691ef$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $dc1265948a4691ef$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, $f53LC.default)($dc1265948a4691ef$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$dc1265948a4691ef$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $dc1265948a4691ef$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $dc1265948a4691ef$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, $f53LC.default)($dc1265948a4691ef$var$FeatureGates, "initializeCalled", $dc1265948a4691ef$var$_FeatureGates.client.initializeCalled.bind($dc1265948a4691ef$var$_FeatureGates.client));
(0, $f53LC.default)($dc1265948a4691ef$var$FeatureGates, "initializeCompleted", $dc1265948a4691ef$var$_FeatureGates.client.initializeCompleted.bind($dc1265948a4691ef$var$_FeatureGates.client));
(0, $f53LC.default)($dc1265948a4691ef$var$FeatureGates, "waitUntilInitializeCompleted", $dc1265948a4691ef$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($dc1265948a4691ef$var$_FeatureGates.client));
(0, $f53LC.default)($dc1265948a4691ef$var$FeatureGates, "initialize", $dc1265948a4691ef$var$_FeatureGates.client.initialize.bind($dc1265948a4691ef$var$_FeatureGates.client));
(0, $f53LC.default)($dc1265948a4691ef$var$FeatureGates, "initializeWithProvider", $dc1265948a4691ef$var$_FeatureGates.client.initializeWithProvider.bind($dc1265948a4691ef$var$_FeatureGates.client));
(0, $f53LC.default)($dc1265948a4691ef$var$FeatureGates, "initializeFromValues", $dc1265948a4691ef$var$_FeatureGates.client.initializeFromValues.bind($dc1265948a4691ef$var$_FeatureGates.client));
(0, $f53LC.default)($dc1265948a4691ef$var$FeatureGates, "manuallyLogGateExposure", $dc1265948a4691ef$var$_FeatureGates.client.manuallyLogGateExposure.bind($dc1265948a4691ef$var$_FeatureGates.client));
(0, $f53LC.default)($dc1265948a4691ef$var$FeatureGates, "getExperiment", $dc1265948a4691ef$var$_FeatureGates.client.getExperiment.bind($dc1265948a4691ef$var$_FeatureGates.client));
(0, $f53LC.default)($dc1265948a4691ef$var$FeatureGates, "manuallyLogExperimentExposure", $dc1265948a4691ef$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($dc1265948a4691ef$var$_FeatureGates.client));
(0, $f53LC.default)($dc1265948a4691ef$var$FeatureGates, "manuallyLogLayerExposure", $dc1265948a4691ef$var$_FeatureGates.client.manuallyLogLayerExposure.bind($dc1265948a4691ef$var$_FeatureGates.client));
(0, $f53LC.default)($dc1265948a4691ef$var$FeatureGates, "shutdownStatsig", $dc1265948a4691ef$var$_FeatureGates.client.shutdownStatsig.bind($dc1265948a4691ef$var$_FeatureGates.client));
(0, $f53LC.default)($dc1265948a4691ef$var$FeatureGates, "overrideGate", $dc1265948a4691ef$var$_FeatureGates.client.overrideGate.bind($dc1265948a4691ef$var$_FeatureGates.client));
(0, $f53LC.default)($dc1265948a4691ef$var$FeatureGates, "clearGateOverride", $dc1265948a4691ef$var$_FeatureGates.client.clearGateOverride.bind($dc1265948a4691ef$var$_FeatureGates.client));
(0, $f53LC.default)($dc1265948a4691ef$var$FeatureGates, "overrideConfig", $dc1265948a4691ef$var$_FeatureGates.client.overrideConfig.bind($dc1265948a4691ef$var$_FeatureGates.client));
(0, $f53LC.default)($dc1265948a4691ef$var$FeatureGates, "clearConfigOverride", $dc1265948a4691ef$var$_FeatureGates.client.clearConfigOverride.bind($dc1265948a4691ef$var$_FeatureGates.client));
(0, $f53LC.default)($dc1265948a4691ef$var$FeatureGates, "setOverrides", $dc1265948a4691ef$var$_FeatureGates.client.setOverrides.bind($dc1265948a4691ef$var$_FeatureGates.client));
(0, $f53LC.default)($dc1265948a4691ef$var$FeatureGates, "getOverrides", $dc1265948a4691ef$var$_FeatureGates.client.getOverrides.bind($dc1265948a4691ef$var$_FeatureGates.client));
(0, $f53LC.default)($dc1265948a4691ef$var$FeatureGates, "clearAllOverrides", $dc1265948a4691ef$var$_FeatureGates.client.clearAllOverrides.bind($dc1265948a4691ef$var$_FeatureGates.client));
(0, $f53LC.default)($dc1265948a4691ef$var$FeatureGates, "isCurrentUser", $dc1265948a4691ef$var$_FeatureGates.client.isCurrentUser.bind($dc1265948a4691ef$var$_FeatureGates.client));
(0, $f53LC.default)($dc1265948a4691ef$var$FeatureGates, "onGateUpdated", $dc1265948a4691ef$var$_FeatureGates.client.onGateUpdated.bind($dc1265948a4691ef$var$_FeatureGates.client));
(0, $f53LC.default)($dc1265948a4691ef$var$FeatureGates, "onExperimentValueUpdated", $dc1265948a4691ef$var$_FeatureGates.client.onExperimentValueUpdated.bind($dc1265948a4691ef$var$_FeatureGates.client));
(0, $f53LC.default)($dc1265948a4691ef$var$FeatureGates, "onAnyUpdated", $dc1265948a4691ef$var$_FeatureGates.client.onAnyUpdated.bind($dc1265948a4691ef$var$_FeatureGates.client));
(0, $f53LC.default)($dc1265948a4691ef$var$FeatureGates, "updateUser", $dc1265948a4691ef$var$_FeatureGates.client.updateUser.bind($dc1265948a4691ef$var$_FeatureGates.client));
(0, $f53LC.default)($dc1265948a4691ef$var$FeatureGates, "updateUserWithProvider", $dc1265948a4691ef$var$_FeatureGates.client.updateUserWithProvider.bind($dc1265948a4691ef$var$_FeatureGates.client));
(0, $f53LC.default)($dc1265948a4691ef$var$FeatureGates, "updateUserWithValues", $dc1265948a4691ef$var$_FeatureGates.client.updateUserWithValues.bind($dc1265948a4691ef$var$_FeatureGates.client));
(0, $f53LC.default)($dc1265948a4691ef$var$FeatureGates, "getPackageVersion", $dc1265948a4691ef$var$_FeatureGates.client.getPackageVersion.bind($dc1265948a4691ef$var$_FeatureGates.client));
(0, $f53LC.default)($dc1265948a4691ef$var$FeatureGates, "getLayer", $dc1265948a4691ef$var$_FeatureGates.client.getLayer.bind($dc1265948a4691ef$var$_FeatureGates.client));
(0, $f53LC.default)($dc1265948a4691ef$var$FeatureGates, "getLayerValue", $dc1265948a4691ef$var$_FeatureGates.client.getLayerValue.bind($dc1265948a4691ef$var$_FeatureGates.client));
var $dc1265948a4691ef$var$boundFGJS = $dc1265948a4691ef$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $dc1265948a4691ef$var$FeatureGates;
    else {
        var $dc1265948a4691ef$var$_boundFGJS, $dc1265948a4691ef$var$_boundFGJS$getPackage;
        $dc1265948a4691ef$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $dc1265948a4691ef$var$boundVersion = (($dc1265948a4691ef$var$_boundFGJS = $dc1265948a4691ef$var$boundFGJS) === null || $dc1265948a4691ef$var$_boundFGJS === void 0 || ($dc1265948a4691ef$var$_boundFGJS$getPackage = $dc1265948a4691ef$var$_boundFGJS.getPackageVersion) === null || $dc1265948a4691ef$var$_boundFGJS$getPackage === void 0 ? void 0 : $dc1265948a4691ef$var$_boundFGJS$getPackage.call($dc1265948a4691ef$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($dc1265948a4691ef$var$boundVersion !== (0, $13mYk.CLIENT_VERSION)) {
            var $dc1265948a4691ef$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($dc1265948a4691ef$var$boundVersion, " when module version ").concat((0, $13mYk.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($dc1265948a4691ef$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $dc1265948a4691ef$export$2e2bcd8739ae039 = $dc1265948a4691ef$var$boundFGJS;

});
parcelRegister("5vnR4", function(module, exports) {
$parcel$export(module.exports, "Client", function () { return $40225a18ce2c05ee$export$1f2bb630327ac4b6; });

var $gnQ3X = parcelRequire("gnQ3X");

var $2qaZZ = parcelRequire("2qaZZ");

var $cn8ql = parcelRequire("cn8ql");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $5Cxn4 = parcelRequire("5Cxn4");

var $ec1qE = parcelRequire("ec1qE");

var $fyKxE = parcelRequire("fyKxE");

var $6hVVy = parcelRequire("6hVVy");

var $4P0lQ = parcelRequire("4P0lQ");

var $htlOv = parcelRequire("htlOv");

var $3U8Eq = parcelRequire("3U8Eq");

var $iqTfN = parcelRequire("iqTfN");

var $g9Joj = parcelRequire("g9Joj");

var $87EAr = parcelRequire("87EAr");

var $040dp = parcelRequire("040dp");

var $13mYk = parcelRequire("13mYk");
var $40225a18ce2c05ee$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $40225a18ce2c05ee$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $40225a18ce2c05ee$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $40225a18ce2c05ee$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $40225a18ce2c05ee$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $40225a18ce2c05ee$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $40225a18ce2c05ee$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $40225a18ce2c05ee$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $g9Joj.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, $cTewU.default)(this, Client);
        (0, $f53LC.default)(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, $f53LC.default)(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, $f53LC.default)(this, "initWithDefaults", false);
        (0, $f53LC.default)(this, "hasCheckGateErrorOccurred", false);
        (0, $f53LC.default)(this, "hasGetExperimentErrorOccurred", false);
        (0, $f53LC.default)(this, "hasGetExperimentValueErrorOccurred", false);
        (0, $f53LC.default)(this, "hasGetLayerErrorOccurred", false);
        (0, $f53LC.default)(this, "hasGetLayerValueErrorOccurred", false);
        (0, $f53LC.default)(this, "subscriptions", new (0, $fyKxE.default)());
        (0, $f53LC.default)(this, "dataAdapter", new (0, $iqTfN.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, $f53LC.default)(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $g9Joj.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, $avOEA.default)(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $040dp.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $040dp.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $040dp.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $040dp.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $13mYk.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $40225a18ce2c05ee$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $13mYk.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $87EAr.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $040dp.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $040dp.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $040dp.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $3U8Eq.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 2;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 2:
                                if (!this.initCompleted) {
                                    _context7.next = 4;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 4:
                                _context7.next = 6;
                                return this.initPromise;
                            case 6:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $6hVVy.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $6hVVy.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $htlOv.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $040dp.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $040dp.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $40225a18ce2c05ee$var$_objectSpread({}, clientOptions);
                                _context8.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $3U8Eq.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $3U8Eq.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, $2qaZZ.default)(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 20;
                                break;
                            case 13:
                                _context8.prev = 13;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context8.t0;
                            case 20:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $40225a18ce2c05ee$var$_objectSpread($40225a18ce2c05ee$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, $2qaZZ.default)(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 22;
                                break;
                            case 15:
                                _context9.prev = 15;
                                _context9.t0 = _context9["catch"](1);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context9.t0;
                            case 22:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args0 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee0$(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $040dp.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $40225a18ce2c05ee$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $40225a18ce2c05ee$var$_objectSpread($40225a18ce2c05ee$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $40225a18ce2c05ee$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $87EAr.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, $gnQ3X.default)(newClientOptions, $40225a18ce2c05ee$var$_excluded);
                                this.user = (0, $040dp.toStatsigUser)(identifiers, customAttributes);
                                statsigOptions = $40225a18ce2c05ee$var$_objectSpread($40225a18ce2c05ee$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $ec1qE.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $ec1qE.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 12;
                                this.statsigClient = new (0, $ec1qE.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context0.next = 29;
                                break;
                            case 19:
                                _context0.prev = 19;
                                _context0.t0 = _context0["catch"](12);
                                if (_context0.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context0.t0 === null || _context0.t0 === void 0 ? void 0 : _context0.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $ec1qE.StatsigClient)($40225a18ce2c05ee$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context0.t0;
                            case 29:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 3;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 5;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 6;
                                _context10.next = 9;
                                return this.initPromise;
                            case 9:
                                _context10.next = 13;
                                break;
                            case 11:
                                _context10.prev = 11;
                                _context10.t0 = _context10["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee1$(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 4;
                                                    break;
                                                }
                                                _context1.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context11.sent;
                                user = (0, $040dp.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                _context11.next = 13;
                                break;
                            case 8:
                                _context11.prev = 8;
                                _context11.t0 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context11.t0 instanceof Error ? _context11.t0.message : JSON.stringify(_context11.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context11.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 21;
                                    break;
                                }
                                _context11.next = 21;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 21:
                                _context11.next = 27;
                                break;
                            case 23:
                                _context11.prev = 23;
                                _context11.t1 = _context11["catch"](15);
                                success = false;
                                errorMessage = String(_context11.t1);
                            case 27:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 34;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 35;
                                break;
                            case 34:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 35:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            23
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $13mYk.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $4P0lQ.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $4P0lQ.Layer).fromLayer((0, $ec1qE._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("fyKxE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b53e22323352d235$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $f72YL = parcelRequire("f72YL");
function $b53e22323352d235$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b53e22323352d235$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b53e22323352d235$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b53e22323352d235$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b53e22323352d235$export$a66cbd9b2289cd78 = '@all-features';
var $b53e22323352d235$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, $cTewU.default)(this, Subscriptions);
        (0, $f53LC.default)(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($f72YL)))();
    }
    return (0, $avOEA.default)(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $b53e22323352d235$var$_objectSpread($b53e22323352d235$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $b53e22323352d235$var$_objectSpread($b53e22323352d235$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $b53e22323352d235$var$_objectSpread($b53e22323352d235$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $b53e22323352d235$var$_objectSpread($b53e22323352d235$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($b53e22323352d235$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($b53e22323352d235$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($b53e22323352d235$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $b53e22323352d235$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("6hVVy", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", function () { return $494143bdb4011ffb$export$6dc24881a3d96325; });

var $2zYm4 = parcelRequire("2zYm4");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $040dp = parcelRequire("040dp");
var $494143bdb4011ffb$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, $cTewU.default)(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, $avOEA.default)(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, $2zYm4.default)(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, $2zYm4.default)(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $040dp.migrateEvaluationDetails)(experiment.details), (0, $040dp.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("040dp", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", function () { return $00c08a974a7f32b3$export$d119b37e5f788b43; });
$parcel$export(module.exports, "shallowEquals", function () { return $00c08a974a7f32b3$export$fa1c2bbf4100b8bc; });
$parcel$export(module.exports, "toStatsigUser", function () { return $00c08a974a7f32b3$export$3dad1db244472f32; });
$parcel$export(module.exports, "migrateInitializationOptions", function () { return $00c08a974a7f32b3$export$202946b690d26d22; });
$parcel$export(module.exports, "migrateEvaluationDetails", function () { return $00c08a974a7f32b3$export$18ad168d3dbac899; });
$parcel$export(module.exports, "migrateSecondaryExposures", function () { return $00c08a974a7f32b3$export$55fd683752d01e67; });

var $gnQ3X = parcelRequire("gnQ3X");

var $2qaZZ = parcelRequire("2qaZZ");

var $f53LC = parcelRequire("f53LC");

var $hMUFv = parcelRequire("hMUFv");

var $htlOv = parcelRequire("htlOv");

var $87EAr = parcelRequire("87EAr");
var $00c08a974a7f32b3$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $00c08a974a7f32b3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $00c08a974a7f32b3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $00c08a974a7f32b3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $00c08a974a7f32b3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $00c08a974a7f32b3$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $00c08a974a7f32b3$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $hMUFv.isFedRamp)() ? (0, $87EAr.PerimeterType).FEDRAMP_MODERATE : (0, $87EAr.PerimeterType).COMMERCIAL
    }, options);
};
var $00c08a974a7f32b3$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, $2qaZZ.default)(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, $2qaZZ.default)(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, $2qaZZ.default)(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, $2qaZZ.default)(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $00c08a974a7f32b3$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    var user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $00c08a974a7f32b3$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, $gnQ3X.default)(options, $00c08a974a7f32b3$var$_excluded);
    return $00c08a974a7f32b3$var$_objectSpread($00c08a974a7f32b3$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $00c08a974a7f32b3$var$evaluationReasonMappings = Object.entries((0, $htlOv.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, $2qaZZ.default)(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $00c08a974a7f32b3$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $00c08a974a7f32b3$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, $2qaZZ.default)(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $htlOv.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $00c08a974a7f32b3$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("htlOv", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", function () { return $cb8610d4f578b959$export$c62558b199e46828; });
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $cb8610d4f578b959$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("87EAr", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", function () { return $5e9e75d92f8435fb$export$479e7351a733299; });
$parcel$export(module.exports, "PerimeterType", function () { return $5e9e75d92f8435fb$export$c42b7bbc5e7ba555; });
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $5e9e75d92f8435fb$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $5e9e75d92f8435fb$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $5e9e75d92f8435fb$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("4P0lQ", function(module, exports) {
$parcel$export(module.exports, "Layer", function () { return $382c329e9d2ccbed$export$936d0764594b6eb3; });

var $2zYm4 = parcelRequire("2zYm4");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $040dp = parcelRequire("040dp");
var $382c329e9d2ccbed$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, $cTewU.default)(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, $avOEA.default)(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, $2zYm4.default)(val) === (0, $2zYm4.default)(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $040dp.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $040dp.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $040dp.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("3U8Eq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2d7d4ff61a669942$export$2e2bcd8739ae039; });

var $f53LC = parcelRequire("f53LC");

var $cn8ql = parcelRequire("cn8ql");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $5Cxn4 = parcelRequire("5Cxn4");

var $87EAr = parcelRequire("87EAr");

var $13mYk = parcelRequire("13mYk");

var $7bk0n = parcelRequire("7bk0n");
function $2d7d4ff61a669942$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2d7d4ff61a669942$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2d7d4ff61a669942$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2d7d4ff61a669942$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2d7d4ff61a669942$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $2d7d4ff61a669942$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $2d7d4ff61a669942$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $2d7d4ff61a669942$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $2d7d4ff61a669942$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $2d7d4ff61a669942$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $2d7d4ff61a669942$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $2d7d4ff61a669942$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $2d7d4ff61a669942$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $2d7d4ff61a669942$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $2d7d4ff61a669942$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, $cTewU.default)(this, Fetcher);
    }
    return (0, $avOEA.default)(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error('Failed to retrieve client sdk key');
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error('Failed to retrieve experiment values');
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $7bk0n.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $7bk0n.ResponseError)('Unexpected 204 response');
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $2d7d4ff61a669942$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $87EAr.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $87EAr.FeatureGateEnvironment).Production:
                        return $2d7d4ff61a669942$export$18c93900db9358a4;
                    case (0, $87EAr.FeatureGateEnvironment).Staging:
                        return $2d7d4ff61a669942$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $87EAr.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $87EAr.FeatureGateEnvironment).Development:
                        return $2d7d4ff61a669942$export$f058dbf75c3bc647;
                    case (0, $87EAr.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $2d7d4ff61a669942$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $2d7d4ff61a669942$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $2d7d4ff61a669942$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $2d7d4ff61a669942$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $13mYk.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $2d7d4ff61a669942$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($2d7d4ff61a669942$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($2d7d4ff61a669942$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("13mYk", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", function () { return $0c47e40c73e5c8ac$export$a59f8d67326bd1cb; });
/// <reference types="node" />
var $0c47e40c73e5c8ac$export$a59f8d67326bd1cb = "0.0.0-development";

});

parcelRegister("7bk0n", function(module, exports) {
$parcel$export(module.exports, "ResponseError", function () { return $53a9140ee8a57a3c$export$286baf652d0b1206; });

var $avOEA = parcelRequire("avOEA");

var $cTewU = parcelRequire("cTewU");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $i7dvh = parcelRequire("i7dvh");

var $4GELH = parcelRequire("4GELH");
function $53a9140ee8a57a3c$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $53a9140ee8a57a3c$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $53a9140ee8a57a3c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($53a9140ee8a57a3c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $53a9140ee8a57a3c$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, $cTewU.default)(this, ResponseError);
        return $53a9140ee8a57a3c$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, $i7dvh.default)(ResponseError, _Error);
    return (0, $avOEA.default)(ResponseError);
}(/*#__PURE__*/ (0, $4GELH.default)(Error));

});


parcelRegister("iqTfN", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", function () { return $d6b583f3cac466a4$export$55fffef3474104af; });

var $cn8ql = parcelRequire("cn8ql");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $7SQOE = parcelRequire("7SQOE");

var $i7dvh = parcelRequire("i7dvh");

var $f53LC = parcelRequire("f53LC");

var $5Cxn4 = parcelRequire("5Cxn4");

var $ec1qE = parcelRequire("ec1qE");
function $d6b583f3cac466a4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d6b583f3cac466a4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d6b583f3cac466a4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d6b583f3cac466a4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d6b583f3cac466a4$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $d6b583f3cac466a4$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $d6b583f3cac466a4$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d6b583f3cac466a4$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $d6b583f3cac466a4$var$_superPropGet(t, o, e, r) {
    var p = (0, $7SQOE.default)((0, $jlBwm.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $d6b583f3cac466a4$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, $cTewU.default)(this, NoFetchDataAdapter);
        _this = $d6b583f3cac466a4$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, $f53LC.default)(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, $i7dvh.default)(NoFetchDataAdapter, _DataAdapterCore);
    return (0, $avOEA.default)(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $ec1qE.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $d6b583f3cac466a4$var$_objectSpread($d6b583f3cac466a4$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $ec1qE._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $d6b583f3cac466a4$var$_objectSpread($d6b583f3cac466a4$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $ec1qE._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $ec1qE._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $ec1qE.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $d6b583f3cac466a4$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $d6b583f3cac466a4$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $ec1qE.DataAdapterCore));

});

parcelRegister("g9Joj", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", function () { return $bc30b25c82c6d5dc$export$d8474cff104280f3; });
$parcel$export(module.exports, "PersistentOverrideAdapter", function () { return $bc30b25c82c6d5dc$export$bcb28fbac1def494; });

var $f53LC = parcelRequire("f53LC");

var $2qaZZ = parcelRequire("2qaZZ");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $3wfvf = parcelRequire("3wfvf");
function $bc30b25c82c6d5dc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bc30b25c82c6d5dc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bc30b25c82c6d5dc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bc30b25c82c6d5dc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $bc30b25c82c6d5dc$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $bc30b25c82c6d5dc$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $bc30b25c82c6d5dc$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $bc30b25c82c6d5dc$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $bc30b25c82c6d5dc$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $bc30b25c82c6d5dc$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $bc30b25c82c6d5dc$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $bc30b25c82c6d5dc$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $bc30b25c82c6d5dc$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $bc30b25c82c6d5dc$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $bc30b25c82c6d5dc$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $bc30b25c82c6d5dc$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, $cTewU.default)(this, PersistentOverrideAdapter);
        this._overrides = $bc30b25c82c6d5dc$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, $avOEA.default)(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $bc30b25c82c6d5dc$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $bc30b25c82c6d5dc$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $bc30b25c82c6d5dc$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, $2qaZZ.default)(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, $2qaZZ.default)(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, $2qaZZ.default)(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($bc30b25c82c6d5dc$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($bc30b25c82c6d5dc$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $bc30b25c82c6d5dc$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $3wfvf._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $bc30b25c82c6d5dc$var$_objectSpread($bc30b25c82c6d5dc$var$_objectSpread({}, $bc30b25c82c6d5dc$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, $2qaZZ.default)(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, $2qaZZ.default)(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($bc30b25c82c6d5dc$var$djb2MapKey((0, $3wfvf._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($bc30b25c82c6d5dc$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($bc30b25c82c6d5dc$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($bc30b25c82c6d5dc$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $bc30b25c82c6d5dc$var$_objectSpread($bc30b25c82c6d5dc$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $bc30b25c82c6d5dc$var$_objectSpread($bc30b25c82c6d5dc$var$_objectSpread({}, current.details), {}, {
                        reason: $bc30b25c82c6d5dc$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($bc30b25c82c6d5dc$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($bc30b25c82c6d5dc$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($bc30b25c82c6d5dc$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($bc30b25c82c6d5dc$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($bc30b25c82c6d5dc$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($bc30b25c82c6d5dc$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $bc30b25c82c6d5dc$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($bc30b25c82c6d5dc$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $bc30b25c82c6d5dc$var$_objectSpread($bc30b25c82c6d5dc$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $3wfvf._makeTypedGet)(current.name, overridden),
                    details: $bc30b25c82c6d5dc$var$_objectSpread($bc30b25c82c6d5dc$var$_objectSpread({}, current.details), {}, {
                        reason: $bc30b25c82c6d5dc$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($bc30b25c82c6d5dc$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $bc30b25c82c6d5dc$var$_objectSpread($bc30b25c82c6d5dc$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $3wfvf._makeTypedGet)(current.name, overridden),
                    details: $bc30b25c82c6d5dc$var$_objectSpread($bc30b25c82c6d5dc$var$_objectSpread({}, current.details), {}, {
                        reason: $bc30b25c82c6d5dc$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("30tUo", function(module, exports) {
$parcel$export(module.exports, "debug", function () { return $230892637200581f$export$1c9f709888824e05; });
var $230892637200581f$var$_process, $230892637200581f$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $230892637200581f$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($230892637200581f$var$_process = globalThis.process) === null || $230892637200581f$var$_process === void 0 || ($230892637200581f$var$_process = $230892637200581f$var$_process.env) === null || $230892637200581f$var$_process === void 0 ? void 0 : $230892637200581f$var$_process.JEST_WORKER_ID) !== undefined;
var $230892637200581f$var$DEBUG_MODE = !$230892637200581f$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($230892637200581f$var$_process2 = globalThis.process) === null || $230892637200581f$var$_process2 === void 0 || ($230892637200581f$var$_process2 = $230892637200581f$var$_process2.env) === null || $230892637200581f$var$_process2 === void 0 ? void 0 : $230892637200581f$var$_process2.NODE_ENV) !== 'production';
var $230892637200581f$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$230892637200581f$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("ffO9K", function(module, exports) {
$parcel$export(module.exports, "AvatarContentContext", function () { return $b1af29b28a588545$export$b983474ddd0b6d28; });

var $1oC0p = parcelRequire("1oC0p");
var $b1af29b28a588545$var$defaultAvatarContentProps = {
    as: 'span',
    appearance: 'circle',
    avatarImage: null,
    ref: null,
    size: 'medium'
};
var $b1af29b28a588545$export$b983474ddd0b6d28 = /*#__PURE__*/ (0, $1oC0p.createContext)($b1af29b28a588545$var$defaultAvatarContentProps);

});

parcelRegister("lqPgK", function(module, exports) {
$parcel$export(module.exports, "EnsureIsInsideAvatarContext", function () { return $f9a3cbaf94c29c87$export$6b4cbd90d24955ad; });
$parcel$export(module.exports, "useEnsureIsInsideAvatar", function () { return $f9a3cbaf94c29c87$export$7db5c57474082dd9; });

var $1oC0p = parcelRequire("1oC0p");
var $f9a3cbaf94c29c87$export$6b4cbd90d24955ad = /*#__PURE__*/ (0, $1oC0p.createContext)(false);
var $f9a3cbaf94c29c87$export$7db5c57474082dd9 = function useEnsureIsInsideAvatar() {
    var context = (0, $1oC0p.useContext)($f9a3cbaf94c29c87$export$6b4cbd90d24955ad);
    if (!context) throw new Error('Avatar sub-components must be used within a Avatar component.');
};

});


parcelRegister("d4PqV", function(module, exports) {
$parcel$export(module.exports, "useAvatarContext", function () { return $98538baf50b5305e$export$b50b87a1c4086b23; });

var $1oC0p = parcelRequire("1oC0p");
var $98538baf50b5305e$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
var $98538baf50b5305e$export$b50b87a1c4086b23 = function useAvatarContext() {
    return (0, $1oC0p.useContext)($98538baf50b5305e$export$a20dad690e1279e2);
};

});

parcelRegister("kjtT0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ec9cc3c2455ab39d$export$2e2bcd8739ae039; });
/* avatar-image.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $6THDr = parcelRequire("6THDr");

var $3emdC = parcelRequire("3emdC");

var $17DlR = parcelRequire("17DlR");

var $dUgrm = parcelRequire("dUgrm");
var $ec9cc3c2455ab39d$var$styles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq",
    icon: "_1e0c1txw _1bsb1osq _4t3i1osq _bfhk7qp0",
    circle: "_2rko1rr0",
    hexagon: "_mkrz1k6g"
};
var $ec9cc3c2455ab39d$var$borderRadiusMap = {
    xsmall: "_2rkolb4i",
    small: "_2rkolb4i",
    medium: "_2rko12b0",
    large: "_2rko12b0",
    xlarge: "_2rko1qi0",
    xxlarge: "_2rkopb1k"
};
var $ec9cc3c2455ab39d$var$nestedSvgStylesMap = {
    xsmall: "_w8l57vkz _17527vkz",
    small: "_w8l51tcg _17521tcg",
    medium: "_w8l5zwfg _1752zwfg",
    large: "_w8l51ylp _17521ylp",
    xlarge: "_w8l516xz _175216xz",
    xxlarge: "_w8l51qr7 _17521qr7"
};
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ var $ec9cc3c2455ab39d$var$AvatarImage = function AvatarImage(_ref) {
    var _ref$alt = _ref.alt, alt = _ref$alt === void 0 ? '' : _ref$alt, src = _ref.src, appearance = _ref.appearance, size = _ref.size, testId = _ref.testId, imgLoading = _ref.imgLoading;
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $2qaZZ.default)(_useState, 2), hasImageErrored = _useState2[0], setHasImageErrored = _useState2[1];
    // If src changes, reset state
    (0, $1oC0p.useEffect)(function() {
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) {
        var renderedIcon;
        switch(appearance){
            case 'circle':
                renderedIcon = /*#__PURE__*/ $1oC0p.createElement((0, (/*@__PURE__*/$parcel$interopDefault($17DlR))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && "".concat(testId, "--person"),
                    spacing: "spacious"
                });
                break;
            case 'hexagon':
                renderedIcon = /*#__PURE__*/ $1oC0p.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3emdC))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && "".concat(testId, "--agent"),
                    spacing: "spacious"
                });
                break;
            default:
            case 'square':
                renderedIcon = /*#__PURE__*/ $1oC0p.createElement((0, (/*@__PURE__*/$parcel$interopDefault($dUgrm))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && "".concat(testId, "--ship"),
                    spacing: "spacious"
                });
                break;
        }
        return /*#__PURE__*/ $1oC0p.createElement("span", {
            className: (0, $6THDr.default)([
                $ec9cc3c2455ab39d$var$styles.icon,
                $ec9cc3c2455ab39d$var$nestedSvgStylesMap[size]
            ])
        }, renderedIcon);
    }
    return /*#__PURE__*/ $1oC0p.createElement("img", {
        loading: imgLoading,
        src: src,
        alt: alt,
        "data-testid": testId && "".concat(testId, "--image"),
        onError: function onError() {
            return setHasImageErrored(true);
        },
        "aria-hidden": !alt ? true : undefined,
        "data-vc": testId ? "".concat(testId, "--image") : 'avatar-image',
        "data-ssr-placeholder-ignored": true,
        className: (0, $6THDr.default)([
            $ec9cc3c2455ab39d$var$styles.image,
            $ec9cc3c2455ab39d$var$borderRadiusMap[size],
            appearance === 'circle' && $ec9cc3c2455ab39d$var$styles.circle,
            appearance === 'hexagon' && $ec9cc3c2455ab39d$var$styles.hexagon
        ])
    });
};
var $ec9cc3c2455ab39d$export$2e2bcd8739ae039 = $ec9cc3c2455ab39d$var$AvatarImage;

});
parcelRegister("3emdC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e079be55658218810235742dfafa5bd4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25a3ea0ad4fd019b$var$_react = $25a3ea0ad4fd019b$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $25a3ea0ad4fd019b$var$_baseNew = $25a3ea0ad4fd019b$var$_interopRequireDefault((parcelRequire("cQlFF")));
function $25a3ea0ad4fd019b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiAgent".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Rovo Agent.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25a3ea0ad4fd019b$var$AiAgentIcon = (props)=>/*#__PURE__*/ $25a3ea0ad4fd019b$var$_react.default.createElement($25a3ea0ad4fd019b$var$_baseNew.default, Object.assign({
        name: "AiAgentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.971.493a2 2 0 0 1 2.058 0l5 3A2 2 0 0 1 15 5.208v5.584a2 2 0 0 1-.971 1.715l-5 3a2 2 0 0 1-2.058 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .971-1.715zm1.286 1.286a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.429v5.584a.5.5 0 0 0 .243.429l1.098.66a4.25 4.25 0 1 1 8.318 0l1.098-.66a.5.5 0 0 0 .243-.429V5.208a.5.5 0 0 0-.243-.429zM8 8.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5" clip-rule="evenodd"/>`
    }, props));
$25a3ea0ad4fd019b$var$AiAgentIcon.displayName = 'AiAgentIcon';
var $25a3ea0ad4fd019b$var$_default = module.exports.default = $25a3ea0ad4fd019b$var$AiAgentIcon;

});
parcelRegister("cQlFF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return (parcelRequire("7zppx")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("7zppx")).Icon; });

var $7zppx = parcelRequire("7zppx");

});
parcelRegister("7zppx", function(module, exports) {
$parcel$export(module.exports, "Icon", function () { return $582f835f7cba409f$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $582f835f7cba409f$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $jbHVw = parcelRequire("jbHVw");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $582f835f7cba409f$var$svgStyles = null;
var $582f835f7cba409f$var$iconStyles = null;
var $582f835f7cba409f$var$smallIconStyles = null;
var $582f835f7cba409f$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $582f835f7cba409f$var$baseHcmStyles = null;
var $582f835f7cba409f$var$scaleSize = null;
var $582f835f7cba409f$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $582f835f7cba409f$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $582f835f7cba409f$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $582f835f7cba409f$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $582f835f7cba409f$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $jbHVw.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $1oC0p.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $jbHVw.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $582f835f7cba409f$var$coreSizeSmall[spacing] : $582f835f7cba409f$var$coreSizeMedium[spacing]
        ])
    }));
});
var $582f835f7cba409f$export$2e2bcd8739ae039 = $582f835f7cba409f$export$f04a61298a47a40f;

});
parcelRegister("jbHVw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $df811e589c0b106b$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $df811e589c0b106b$var$ATOMIC_GROUP_LENGTH = 5;
function $df811e589c0b106b$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $df811e589c0b106b$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});




parcelRegister("17DlR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc4353a18034f564a0b3573d4163ea60>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0d14f84abe40548d$var$_react = $0d14f84abe40548d$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $0d14f84abe40548d$var$_baseNew = $0d14f84abe40548d$var$_interopRequireDefault((parcelRequire("cQlFF")));
function $0d14f84abe40548d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0d14f84abe40548d$var$PersonIcon = (props)=>/*#__PURE__*/ $0d14f84abe40548d$var$_react.default.createElement($0d14f84abe40548d$var$_baseNew.default, Object.assign({
        name: "PersonIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$0d14f84abe40548d$var$PersonIcon.displayName = 'PersonIcon';
var $0d14f84abe40548d$var$_default = module.exports.default = $0d14f84abe40548d$var$PersonIcon;

});

parcelRegister("dUgrm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b5b008ccfed50bccf7a8bb78b89f8a48>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1fd420469498f39$var$_react = $a1fd420469498f39$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $a1fd420469498f39$var$_baseNew = $a1fd420469498f39$var$_interopRequireDefault((parcelRequire("cQlFF")));
function $a1fd420469498f39$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a1fd420469498f39$var$ReleaseIcon = (props)=>/*#__PURE__*/ $a1fd420469498f39$var$_react.default.createElement($a1fd420469498f39$var$_baseNew.default, Object.assign({
        name: "ReleaseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2h3v2h2a.75.75 0 0 1 .648.372L11.18 7h4.069a.75.75 0 0 1 .646 1.132l-2.887 4.886a2 2 0 0 1-1.722.982H2a2 2 0 0 1-2-2V7.75A.75.75 0 0 1 .75 7H2V4.75A.75.75 0 0 1 2.75 4H4zm-.5 5h5.944L8.57 5.5H3.5zm-2 1.5V12a.5.5 0 0 0 .5.5h9.287a.5.5 0 0 0 .43-.246L13.936 8.5z" clip-rule="evenodd"/>`
    }, props));
$a1fd420469498f39$var$ReleaseIcon.displayName = 'ReleaseIcon';
var $a1fd420469498f39$var$_default = module.exports.default = $a1fd420469498f39$var$ReleaseIcon;

});


parcelRegister("4Kmsl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $374ce0a657416b28$export$2e2bcd8739ae039; });
var $374ce0a657416b28$var$getCustomElement = function getCustomElement(isDisabled, href, onClick, ariaHasPopup) {
    if (href && !isDisabled) return 'a';
    if (onClick || isDisabled || ariaHasPopup) return 'button';
    return 'span';
};
var $374ce0a657416b28$export$2e2bcd8739ae039 = $374ce0a657416b28$var$getCustomElement;

});

parcelRegister("3lgxL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $26f02a7bbf944947$export$2e2bcd8739ae039; });
/* presence-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $6THDr = parcelRequire("6THDr");

var $2lR1L = parcelRequire("2lR1L");
var $26f02a7bbf944947$var$styles = {
    root: "_kqswstnw _lcxvglyw"
};
var $26f02a7bbf944947$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
var $26f02a7bbf944947$var$circleIconOffsetMap = {
    small: "_94n5idpf _1xi2idpf",
    medium: "_94n5idpf _1xi2idpf",
    large: "_94n5t94y _1xi2t94y",
    xlarge: "_94n51v6z _1xi21v6z"
};
var $26f02a7bbf944947$var$squareIconOffsetMap = {
    root: "_94n5myb0 _1xi2myb0"
};
var $26f02a7bbf944947$var$hexagonIconOffsetMap = {
    small: "_94n51n1a _1xi21n1a",
    medium: "_94n51n1a _1xi21n1a",
    large: "_94n51y44 _1xi2myb0",
    xlarge: "_94n5l52n _1xi21lpd"
};
/**
 * __Presence wrapper__
 *
 * A presence wrapper is used internally to position presence ontop of the avatar.
 */ var $26f02a7bbf944947$var$PresenceWrapper = function PresenceWrapper(_ref) {
    var size = _ref.size, appearance = _ref.appearance, children = _ref.children, borderColor = _ref.borderColor, presence = _ref.presence, testId = _ref.testId;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--presence"),
        className: (0, $6THDr.default)([
            $26f02a7bbf944947$var$styles.root,
            $26f02a7bbf944947$var$iconSizeMap[size],
            $26f02a7bbf944947$var$circleIconOffsetMap[size],
            appearance === 'square' && $26f02a7bbf944947$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $26f02a7bbf944947$var$hexagonIconOffsetMap[size]
        ])
    }, /*#__PURE__*/ $1oC0p.createElement((0, $2lR1L.default), {
        borderColor: borderColor,
        presence: !children ? presence : undefined
    }, children));
};
var $26f02a7bbf944947$export$2e2bcd8739ae039 = $26f02a7bbf944947$var$PresenceWrapper;

});
parcelRegister("2lR1L", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1b66ad17466568ac$export$2e2bcd8739ae039; });
/* presence.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $1oC0p = parcelRequire("1oC0p");


var $3biWO = parcelRequire("3biWO");
var $1b66ad17466568ac$var$BusyIndicator = /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), null, /*#__PURE__*/ $1oC0p.createElement("circle", {
    fill: "var(--ds-icon-danger, #C9372C)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $1oC0p.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
}));
var $1b66ad17466568ac$var$FocusIndicator = /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), null, /*#__PURE__*/ $1oC0p.createElement("path", {
    fill: "var(--ds-icon-discovery, #AF59E1)",
    d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
}));
var $1b66ad17466568ac$var$OfflineIndicator = /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), null, /*#__PURE__*/ $1oC0p.createElement("path", {
    fill: "var(--ds-text-subtlest, #6B6E76)",
    d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}), /*#__PURE__*/ $1oC0p.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}));
var $1b66ad17466568ac$var$OnlineIndicator = /*#__PURE__*/ $1oC0p.createElement("circle", {
    fill: "var(--ds-icon-success, #6A9A23)",
    cx: "4",
    cy: "4",
    r: "4"
});
function $1b66ad17466568ac$var$getPresence(presence) {
    switch(presence){
        case 'busy':
            return $1b66ad17466568ac$var$BusyIndicator;
        case 'focus':
            return $1b66ad17466568ac$var$FocusIndicator;
        case 'offline':
            return $1b66ad17466568ac$var$OfflineIndicator;
        case 'online':
            return $1b66ad17466568ac$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ var $1b66ad17466568ac$var$AvatarPresence = function AvatarPresence(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, presence = _ref.presence;
    return /*#__PURE__*/ $1oC0p.createElement((0, $3biWO.default), {
        bgColor: borderColor
    }, presence ? /*#__PURE__*/ $1oC0p.createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $1b66ad17466568ac$var$getPresence(presence)) : children);
};
var $1b66ad17466568ac$export$2e2bcd8739ae039 = $1b66ad17466568ac$var$AvatarPresence;

});
parcelRegister("3biWO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $251118c8b3ca0edd$export$2e2bcd8739ae039; });
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $6THDr = parcelRequire("6THDr");
var $251118c8b3ca0edd$var$styles = {
    root: "_2rko1qll _1reo15vq _18m915vq _189e1dm9 _1dqonqa1 _1e0c1txw _vchhusvi _1bsb1osq _4t3i1osq _4cvr1h6o _ae4v1h6o _bfhk1bhr"
};
var $251118c8b3ca0edd$var$unboundStyles = {
    root: "_1h6d1bhr"
};
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ var $251118c8b3ca0edd$var$IconWrapper = function IconWrapper(_ref) {
    var bgColor = _ref.bgColor, children = _ref.children;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        role: "presentation",
        style: {
            borderColor: bgColor,
            backgroundColor: bgColor
        },
        className: (0, $6THDr.default)([
            $251118c8b3ca0edd$var$styles.root,
            $251118c8b3ca0edd$var$unboundStyles.root
        ])
    }, children);
};
var $251118c8b3ca0edd$export$2e2bcd8739ae039 = $251118c8b3ca0edd$var$IconWrapper;

});



parcelRegister("iq3a7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d68d1baa2aa1487c$export$2e2bcd8739ae039; });
/* status-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $6THDr = parcelRequire("6THDr");

var $jUk4V = parcelRequire("jUk4V");
var $d68d1baa2aa1487c$var$styles = {
    root: "_kqswstnw"
};
var $d68d1baa2aa1487c$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
var $d68d1baa2aa1487c$var$circleIconOffsetMap = {
    small: "_rjxpidpf _152tidpf",
    medium: "_rjxpidpf _152tidpf",
    large: "_rjxpt94y _152tt94y",
    xlarge: "_rjxp1v6z _152t1v6z"
};
var $d68d1baa2aa1487c$var$squareIconOffsetMap = {
    root: "_rjxpidpf _152tidpf"
};
var $d68d1baa2aa1487c$var$hexagonIconOffsetMap = {
    small: "_rjxp1n1a _152t1n1a",
    medium: "_rjxp1n1a _152t1n1a",
    large: "_rjxpmyb0 _152t1y44",
    xlarge: "_rjxp1lpd _152tl52n"
};
/**
 * __Status wrapper__
 *
 * A status wrapper is used internally to position status on top of the avatar.
 */ var $d68d1baa2aa1487c$var$StatusWrapper = function StatusWrapper(_ref) {
    var size = _ref.size, status = _ref.status, appearance = _ref.appearance, borderColor = _ref.borderColor, children = _ref.children, testId = _ref.testId;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--status"),
        className: (0, $6THDr.default)([
            $d68d1baa2aa1487c$var$styles.root,
            $d68d1baa2aa1487c$var$iconSizeMap[size],
            $d68d1baa2aa1487c$var$circleIconOffsetMap[size],
            appearance === 'square' && $d68d1baa2aa1487c$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $d68d1baa2aa1487c$var$hexagonIconOffsetMap[size]
        ])
    }, /*#__PURE__*/ $1oC0p.createElement((0, $jUk4V.default), {
        borderColor: borderColor,
        status: !children ? status : undefined
    }, children));
};
var $d68d1baa2aa1487c$export$2e2bcd8739ae039 = $d68d1baa2aa1487c$var$StatusWrapper;

});
parcelRegister("jUk4V", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e7e2d26d8905f031$export$2e2bcd8739ae039; });
/* status.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $1oC0p = parcelRequire("1oC0p");


var $3biWO = parcelRequire("3biWO");
var $e7e2d26d8905f031$var$ApprovedIndicator = /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), null, /*#__PURE__*/ $1oC0p.createElement("circle", {
    fill: "var(--ds-icon-success, #6A9A23)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $1oC0p.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
}));
var $e7e2d26d8905f031$var$DeclinedIndicator = /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), null, /*#__PURE__*/ $1oC0p.createElement("circle", {
    fill: "var(--ds-icon-danger, #C9372C)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $1oC0p.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
}));
var $e7e2d26d8905f031$var$LockedIndicator = /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), null, /*#__PURE__*/ $1oC0p.createElement("circle", {
    fill: "var(--ds-text-subtlest, #6B6E76)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $1oC0p.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
}));
function $e7e2d26d8905f031$var$getStatus(status) {
    switch(status){
        case 'approved':
            return $e7e2d26d8905f031$var$ApprovedIndicator;
        case 'declined':
            return $e7e2d26d8905f031$var$DeclinedIndicator;
        case 'locked':
            return $e7e2d26d8905f031$var$LockedIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ var $e7e2d26d8905f031$var$AvatarStatus = function AvatarStatus(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, status = _ref.status;
    return /*#__PURE__*/ $1oC0p.createElement((0, $3biWO.default), {
        bgColor: borderColor
    }, status ? /*#__PURE__*/ $1oC0p.createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $e7e2d26d8905f031$var$getStatus(status)) : children);
};
var $e7e2d26d8905f031$export$2e2bcd8739ae039 = $e7e2d26d8905f031$var$AvatarStatus;

});



parcelRegister("90JID", function(module, exports) {
$parcel$export(module.exports, "N0", function () { return $68f793f494bd0acc$export$29a4f05edc054374; });
$parcel$export(module.exports, "N90", function () { return $68f793f494bd0acc$export$7c87d337fb91a97d; });
// Reds
var $68f793f494bd0acc$export$4b84fd0e2c617bd = '#FFEBE6';
var $68f793f494bd0acc$export$b34b069eff244586 = '#FFBDAD';
var $68f793f494bd0acc$export$be802dd0d8b57f35 = '#FF8F73';
var $68f793f494bd0acc$export$60847d42f9da92a6 = '#FF7452';
var $68f793f494bd0acc$export$4a7404f376229999 = '#FF5630';
var $68f793f494bd0acc$export$2010d0fb4295b346 = '#DE350B';
var $68f793f494bd0acc$export$2837b5a1a71d5c02 = '#BF2600';
var $68f793f494bd0acc$export$8d9596b529bbb9cf = '#FFFAE6';
var $68f793f494bd0acc$export$41060a744ab0b7ae = '#FFF0B3';
var $68f793f494bd0acc$export$1cc05bbbf340e559 = '#FFE380';
var $68f793f494bd0acc$export$5aae31392d72caaa = '#FFC400';
var $68f793f494bd0acc$export$c6930421db9fa514 = '#FFAB00';
var $68f793f494bd0acc$export$59619663aa6500fb = '#FF991F';
var $68f793f494bd0acc$export$874739ea9e379ab6 = '#FF8B00';
var $68f793f494bd0acc$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $68f793f494bd0acc$export$69a3bf21b9686c2b = '#ABF5D1';
var $68f793f494bd0acc$export$afbce1382ec95f73 = '#79F2C0';
var $68f793f494bd0acc$export$747d86715d4175de = '#57D9A3';
var $68f793f494bd0acc$export$940e1f69e873f202 = '#36B37E';
var $68f793f494bd0acc$export$a49394138f7b8e85 = '#00875A';
var $68f793f494bd0acc$export$6fa04827ac68a4fb = '#006644';
var $68f793f494bd0acc$export$226de0355ed012f8 = '#DEEBFF';
var $68f793f494bd0acc$export$8c13c2ee36917869 = '#B3D4FF';
var $68f793f494bd0acc$export$ecfc1dff386a3e7a = '#4C9AFF';
var $68f793f494bd0acc$export$215b7063051591f1 = '#2684FF';
var $68f793f494bd0acc$export$e62e8919cca44969 = '#0065FF';
var $68f793f494bd0acc$export$b3de0ae08da2ce64 = '#0052CC';
var $68f793f494bd0acc$export$a6ee3d71bc067634 = '#0747A6';
var $68f793f494bd0acc$export$67f15409e87642a1 = '#669DF1';
var $68f793f494bd0acc$export$f0539dbc42dbb067 = '#8FB8F6';
var $68f793f494bd0acc$export$363e4475840015bb = '#EAE6FF';
var $68f793f494bd0acc$export$4b0a4417ed59760f = '#C0B6F2';
var $68f793f494bd0acc$export$6011520a64d9a187 = '#998DD9';
var $68f793f494bd0acc$export$a7175d4e9206bc80 = '#8777D9';
var $68f793f494bd0acc$export$b48405b95304b5a1 = '#6554C0';
var $68f793f494bd0acc$export$c71e4279dd54a18d = '#5243AA';
var $68f793f494bd0acc$export$147899de772240ec = '#403294';
var $68f793f494bd0acc$export$2cf711fe14c66f06 = '#E6FCFF';
var $68f793f494bd0acc$export$7a8f4d33f6f9772c = '#B3F5FF';
var $68f793f494bd0acc$export$776c9c497ef08533 = '#79E2F2';
var $68f793f494bd0acc$export$69cb3ca10c1e330e = '#00C7E6';
var $68f793f494bd0acc$export$9dc1ef0f3f48059b = '#00B8D9';
var $68f793f494bd0acc$export$7c835c78b6fcdef8 = '#00A3BF';
var $68f793f494bd0acc$export$6036577f95c3877e = '#008DA6';
var $68f793f494bd0acc$export$29a4f05edc054374 = '#FFFFFF';
var $68f793f494bd0acc$export$e655ef011c4aa1a2 = '#FAFBFC';
var $68f793f494bd0acc$export$9fdfb749e33cdf97 = '#F4F5F7';
var $68f793f494bd0acc$export$3e51e8f1440314ba = '#EBECF0';
var $68f793f494bd0acc$export$1ce2d1575d444ceb = '#DFE1E6';
var $68f793f494bd0acc$export$8754fc7e6d8b3000 = '#C1C7D0';
var $68f793f494bd0acc$export$c2e91cbeada39b8b = '#B3BAC5';
var $68f793f494bd0acc$export$5f71e19f3a7ad9de = '#A5ADBA';
var $68f793f494bd0acc$export$eaa8c8a70ac22806 = '#97A0AF';
var $68f793f494bd0acc$export$7c87d337fb91a97d = '#8993A4';
var $68f793f494bd0acc$export$d6447c357493214f = '#7A869A';
var $68f793f494bd0acc$export$f563ee71e9ee74cd = '#6B778C';
var $68f793f494bd0acc$export$e2ef2124cf4024b1 = '#5E6C84';
var $68f793f494bd0acc$export$eece5f492e429f08 = '#505F79';
var $68f793f494bd0acc$export$c39c0fe0f26207ae = '#42526E';
var $68f793f494bd0acc$export$7090862dc3038a9f = '#344563';
var $68f793f494bd0acc$export$ad0bacf983b7ddaa = '#253858';
var $68f793f494bd0acc$export$7d61b15e0da132af = '#172B4D';
var $68f793f494bd0acc$export$fbda843f0a27fe96 = '#091E42';
var $68f793f494bd0acc$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $68f793f494bd0acc$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $68f793f494bd0acc$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $68f793f494bd0acc$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $68f793f494bd0acc$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $68f793f494bd0acc$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $68f793f494bd0acc$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $68f793f494bd0acc$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $68f793f494bd0acc$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $68f793f494bd0acc$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $68f793f494bd0acc$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $68f793f494bd0acc$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $68f793f494bd0acc$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $68f793f494bd0acc$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $68f793f494bd0acc$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $68f793f494bd0acc$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $68f793f494bd0acc$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $68f793f494bd0acc$export$2f6319cf7d736c2a = '#E6EDFA';
var $68f793f494bd0acc$export$95126bc8884d6634 = '#DCE5F5';
var $68f793f494bd0acc$export$8338d8c35d44ff1 = '#CED9EB';
var $68f793f494bd0acc$export$5368d76ae4fbbda7 = '#B8C7E0';
var $68f793f494bd0acc$export$9f0a771d16ec8d36 = '#ABBBD6';
var $68f793f494bd0acc$export$abcf8c38338b4aa5 = '#9FB0CC';
var $68f793f494bd0acc$export$97e81faa16a182c7 = '#8C9CB8';
var $68f793f494bd0acc$export$bfe21c59123ecf33 = '#7988A3';
var $68f793f494bd0acc$export$ee82aa2ea6a1558 = '#67758F';
var $68f793f494bd0acc$export$682927c6ed76be02 = '#56637A';
var $68f793f494bd0acc$export$91fd9994c5be9757 = '#455166';
var $68f793f494bd0acc$export$d281fbfe3cff2df6 = '#3B475C';
var $68f793f494bd0acc$export$3902c91d8b98a753 = '#313D52';
var $68f793f494bd0acc$export$8e8133c1ba5845b5 = '#283447';
var $68f793f494bd0acc$export$33ff357f6620b39 = '#202B3D';
var $68f793f494bd0acc$export$633847cf062b69e0 = '#1B2638';
var $68f793f494bd0acc$export$9776a6e503bdbf76 = '#121A29';
var $68f793f494bd0acc$export$6c813d5160dff5db = '#0E1624';
var $68f793f494bd0acc$export$3d4f271a500072a = '#0D1424';
var $68f793f494bd0acc$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $68f793f494bd0acc$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $68f793f494bd0acc$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $68f793f494bd0acc$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $68f793f494bd0acc$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $68f793f494bd0acc$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $68f793f494bd0acc$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $68f793f494bd0acc$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $68f793f494bd0acc$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $68f793f494bd0acc$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $68f793f494bd0acc$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $68f793f494bd0acc$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $68f793f494bd0acc$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $68f793f494bd0acc$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $68f793f494bd0acc$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $68f793f494bd0acc$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $68f793f494bd0acc$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $68f793f494bd0acc$export$d2adc5dedf09fced = '#292A2E';
var $68f793f494bd0acc$export$f51762073d2bb381 = '#94C748';
var $68f793f494bd0acc$export$95e26d54def96891 = '#B3DF72';

});

parcelRegister("ebJx7", function(module, exports) {
$parcel$export(module.exports, "TeamAvatarImage", function () { return $a54569b9139b9771$export$ac3673635a5387be; });
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $4M53l = parcelRequire("4M53l");

var $1EcnU = parcelRequire("1EcnU");

var $fmiVo = parcelRequire("fmiVo");
var $a54569b9139b9771$var$boxShadowCssVar = '--avatar-box-shadow';
var $a54569b9139b9771$var$bgColorCssVar = '--avatar-bg-color';
/**
 * We need to maintan the container styles manually until Avatar provides the correct border radius.
 * After that we can return to wrapping in <AvatarContent> rather than span
 */ var $a54569b9139b9771$var$containerStyles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk1j28 _aetrf705 _1peqidpf _11fnglyw",
    nonCompactSpacing: "_6rthv77o _1pfhv77o _12l2v77o _ahbqv77o",
    compactSpacing: "_6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t",
    circle: "_2rko1qll _14mj1qll",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peqs237"
};
var $a54569b9139b9771$var$unboundStyles = {
    root: "_vchh1ntv _bfhkcxp3 _16qs1nhn",
    interactive: "_80omtlke _4tpu1g4v _ez1ykb7n _gcm1182g _eeh8kb7n _jlxit94y"
};
var $a54569b9139b9771$var$avatarImageStyles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq"
};
var $a54569b9139b9771$var$SIZES = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
var $a54569b9139b9771$var$borderRadiusMap = {
    xsmall: "_2rkol0p1",
    small: "_2rkol0p1",
    medium: "_2rkol0p1",
    large: "_2rkol0p1",
    xlarge: "_2rkol0p1",
    xxlarge: "_2rkol0p1"
};
var $a54569b9139b9771$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
var $a54569b9139b9771$export$ac3673635a5387be = function TeamAvatarImage(_ref) {
    var _ref$alt = _ref.alt, alt = _ref$alt === void 0 ? '' : _ref$alt, src = _ref.src, size = _ref.size, testId = _ref.testId, teamId = _ref.teamId, _ref$compact = _ref.compact, compact = _ref$compact === void 0 ? false : _ref$compact;
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $2qaZZ.default)(_useState, 2), hasImageErrored = _useState2[0], setHasImageErrored = _useState2[1];
    var avatarSrc = (0, $fmiVo.getTeamAvatarSrc)(src, teamId);
    // If src changes, reset state
    (0, $1oC0p.useEffect)(function() {
        setHasImageErrored(false);
    }, [
        avatarSrc
    ]);
    if (!avatarSrc || hasImageErrored) return /*#__PURE__*/ $1oC0p.createElement((0, $1EcnU.FallbackAvatar), {
        "aria-label": alt,
        width: $a54569b9139b9771$var$SIZES[size],
        height: $a54569b9139b9771$var$SIZES[size],
        "data-testid": testId,
        compact: compact
    });
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId,
        "aria-label": alt,
        className: (0, $4M53l.default)([
            $a54569b9139b9771$var$unboundStyles.root,
            $a54569b9139b9771$var$containerStyles.root,
            $a54569b9139b9771$var$borderRadiusMap[size],
            $a54569b9139b9771$var$widthHeightMap[size],
            compact ? $a54569b9139b9771$var$containerStyles.compactSpacing : $a54569b9139b9771$var$containerStyles.nonCompactSpacing
        ])
    }, /*#__PURE__*/ $1oC0p.createElement("img", {
        src: avatarSrc,
        alt: alt,
        "data-testid": testId && "".concat(testId, "--image"),
        onError: function onError() {
            return setHasImageErrored(true);
        },
        className: (0, $4M53l.default)([
            $a54569b9139b9771$var$avatarImageStyles.image
        ])
    }));
};

});
parcelRegister("4M53l", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $379f9089142c0a2c$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $379f9089142c0a2c$var$ATOMIC_GROUP_LENGTH = 5;
function $379f9089142c0a2c$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $379f9089142c0a2c$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("1EcnU", function(module, exports) {
$parcel$export(module.exports, "FallbackAvatar", function () { return $13332238ad1a9172$export$eb63dcc490f6bbcd; });
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");


var $1oC0p = parcelRequire("1oC0p");

var $gw0Bx = parcelRequire("gw0Bx");

var $con3C = parcelRequire("con3C");
var $13332238ad1a9172$var$_excluded = [
    "compact"
];
var $13332238ad1a9172$var$styles = {
    wrapper: "_1e0c1txw",
    wrapperSpacing: "_19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
    compactWrapperSpacing: "_19pkze3t _2hwxze3t _otyrze3t _18u0ze3t"
};
function $13332238ad1a9172$export$eb63dcc490f6bbcd(_ref) {
    var compact = _ref.compact, props = (0, $gnQ3X.default)(_ref, $13332238ad1a9172$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $con3C.default), {
        xcss: (0, $gw0Bx.cx)($13332238ad1a9172$var$styles.wrapper, compact ? $13332238ad1a9172$var$styles.compactWrapperSpacing : $13332238ad1a9172$var$styles.wrapperSpacing)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", (0, $c9bqK.default)({
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("g", {
        clipPath: "url(#clip0_2032_552)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "4",
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
        fill: "#44546F"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
        fill: "#44546F"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
        fill: "#44546F"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
        fill: "#44546F"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("clipPath", {
        id: "clip0_2032_552"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "4",
        fill: "white"
    })))));
}

});
parcelRegister("gw0Bx", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $c0601a897e90882f$export$a274e22fb40f762e; });
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ parcelRequire("1oC0p");


var $8nzE9 = parcelRequire("8nzE9");
var $c0601a897e90882f$var$strictApi = (0, $8nzE9.createStrictAPI)();
var $c0601a897e90882f$export$dbf350e5966cf602 = $c0601a897e90882f$var$strictApi.css;
var $c0601a897e90882f$export$eb1ecd84a24ee424 = $c0601a897e90882f$var$strictApi.cssMap;
$c0601a897e90882f$var$strictApi.cssMap;
var $c0601a897e90882f$export$a274e22fb40f762e = $c0601a897e90882f$var$strictApi.cx;
var $c0601a897e90882f$var$XCSSProp = $c0601a897e90882f$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 

});
parcelRegister("8nzE9", function(module, exports) {
$parcel$export(module.exports, "createStrictAPI", function () { return $619c1f645cc44049$export$39716b4af53f4ad; });

var $aU252 = parcelRequire("aU252");

var $6595k = parcelRequire("6595k");
function $619c1f645cc44049$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $aU252.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $aU252.createStrictSetupError)();
        },
        cx: $6595k.cx,
        XCSSProp () {
            throw (0, $aU252.createStrictSetupError)();
        }
    };
}

});
parcelRegister("aU252", function(module, exports) {
$parcel$export(module.exports, "createStrictSetupError", function () { return $7f00bf6e4c6f9768$export$c4df1cb0c2b4d77c; });
const $7f00bf6e4c6f9768$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $7f00bf6e4c6f9768$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("6595k", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $46da41c415261b81$export$a274e22fb40f762e; });

var $4M53l = parcelRequire("4M53l");
const $46da41c415261b81$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $4M53l.default)(actualStyles);
};

});



parcelRegister("con3C", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $90599ca7fc91dee9$export$2e2bcd8739ae039; });
/* box.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $4M53l = parcelRequire("4M53l");

var $058Ra = parcelRequire("058Ra");
var $90599ca7fc91dee9$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $90599ca7fc91dee9$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $90599ca7fc91dee9$var$baseStyles = null;
var $90599ca7fc91dee9$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhkby5v",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $90599ca7fc91dee9$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $90599ca7fc91dee9$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var $90599ca7fc91dee9$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $90599ca7fc91dee9$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $90599ca7fc91dee9$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $90599ca7fc91dee9$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $90599ca7fc91dee9$var$Box = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $gnQ3X.default)(_ref, $90599ca7fc91dee9$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $gnQ3X.default)(htmlAttributes, $90599ca7fc91dee9$var$_excluded2);
    var node = /*#__PURE__*/ $1oC0p.createElement(Component, (0, $c9bqK.default)({
        style: style,
        ref: ref,
        className: (0, $4M53l.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $90599ca7fc91dee9$var$backgroundColorMap[backgroundColor],
            backgroundColor && $90599ca7fc91dee9$var$isSurfaceToken(backgroundColor) && $90599ca7fc91dee9$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $90599ca7fc91dee9$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $90599ca7fc91dee9$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $90599ca7fc91dee9$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $90599ca7fc91dee9$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $1oC0p.createElement((0, $058Ra.SurfaceContext).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $90599ca7fc91dee9$export$2e2bcd8739ae039 = $90599ca7fc91dee9$var$Box;
function $90599ca7fc91dee9$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $90599ca7fc91dee9$var$setSurfaceTokenMap;
}

});
parcelRegister("058Ra", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", function () { return $00f7567c004bc4d4$export$1ca2a26fecb070ae; });

var $1oC0p = parcelRequire("1oC0p");
var $00f7567c004bc4d4$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1oC0p.createContext)('elevation.surface');
var $00f7567c004bc4d4$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $1oC0p.useContext)($00f7567c004bc4d4$export$1ca2a26fecb070ae);
};
$00f7567c004bc4d4$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});



parcelRegister("fmiVo", function(module, exports) {
$parcel$export(module.exports, "getTeamAvatarSrc", function () { return $b2e7972504a102bd$export$59ff7d19feb890b6; });
/**
 * If a src value is given, we'll use that directly.
 * Otherwise we'll generate a static URL from the teamId.
 * If neither are provided, return undefined so that the fallback will be used.
 */ function $b2e7972504a102bd$export$59ff7d19feb890b6(src, teamId) {
    if (src) return src;
    else if (teamId) return "/gateway/api/v4/teams/".concat(teamId, "/avatar");
    return undefined;
}

});



parcelRegister("l23yj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::69f4e6f87c1306b0b7d1107d65930cc1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f4fc8a53b23a3baa$var$_react = $f4fc8a53b23a3baa$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f4fc8a53b23a3baa$var$_baseNew = $f4fc8a53b23a3baa$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $f4fc8a53b23a3baa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f4fc8a53b23a3baa$var$PersonIcon = (props)=>/*#__PURE__*/ $f4fc8a53b23a3baa$var$_react.default.createElement($f4fc8a53b23a3baa$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$f4fc8a53b23a3baa$var$PersonIcon.displayName = 'PersonIcon';
var $f4fc8a53b23a3baa$var$_default = module.exports.default = $f4fc8a53b23a3baa$var$PersonIcon;

});

parcelRegister("kR3EL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f2eb97fa9922fb9c$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $3dJ4i = parcelRequire("3dJ4i");

var $7gyMa = parcelRequire("7gyMa");

var $agPDl = parcelRequire("agPDl");
var $f2eb97fa9922fb9c$var$formSectionDescriptionStyles = (0, $3dJ4i.css)({
    marginTop: "var(--ds-space-100, 8px)"
});
var $f2eb97fa9922fb9c$var$formSectionTitleStyles = (0, $3dJ4i.css)({
    marginTop: 0,
    marginRight: "var(--ds-space-400, 32px)",
    lineHeight: "var(--ds-space-400, 32px)",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
var $f2eb97fa9922fb9c$var$formSectionWrapperStyles = (0, $3dJ4i.css)({
    marginTop: "var(--ds-space-300, 24px)"
});
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $f2eb97fa9922fb9c$var$lightH600Styles = (0, $3dJ4i.css)((0, $agPDl.h600)({
    theme: {
        mode: 'light'
    }
}));
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $f2eb97fa9922fb9c$var$darkH600Styles = (0, $3dJ4i.css)((0, $agPDl.h600)({
    theme: {
        mode: 'dark'
    }
}));
var $f2eb97fa9922fb9c$var$FormSectionWrapper = function FormSectionWrapper(_ref) {
    var children = _ref.children;
    return (0, $3dJ4i.jsx)("div", {
        css: $f2eb97fa9922fb9c$var$formSectionWrapperStyles
    }, children);
};
var $f2eb97fa9922fb9c$var$FormSectionTitle = function FormSectionTitle(_ref2) {
    var children = _ref2.children;
    var _useGlobalTheme = (0, $7gyMa.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $3dJ4i.jsx)("h3", {
        css: [
            $f2eb97fa9922fb9c$var$formSectionTitleStyles,
            mode === 'light' ? $f2eb97fa9922fb9c$var$lightH600Styles : $f2eb97fa9922fb9c$var$darkH600Styles
        ]
    }, children);
};
var $f2eb97fa9922fb9c$var$FormSectionDescription = function FormSectionDescription(_ref3) {
    var children = _ref3.children;
    return (0, $3dJ4i.jsx)("div", {
        css: $f2eb97fa9922fb9c$var$formSectionDescriptionStyles
    }, children);
};
/**
 * __Form section__
 *
 * A form section is used to define a section of a form layout. This contains a section title, content
 * and a description of the section.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 */ var $f2eb97fa9922fb9c$var$FormSection = function FormSection(_ref4) {
    var children = _ref4.children, description = _ref4.description, title = _ref4.title;
    return (0, $3dJ4i.jsx)($f2eb97fa9922fb9c$var$FormSectionWrapper, null, title && (0, $3dJ4i.jsx)($f2eb97fa9922fb9c$var$FormSectionTitle, null, title), description && (0, $3dJ4i.jsx)($f2eb97fa9922fb9c$var$FormSectionDescription, null, description), children);
};
var $f2eb97fa9922fb9c$export$2e2bcd8739ae039 = $f2eb97fa9922fb9c$var$FormSection;

});

parcelRegister("4ISy2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fb6bef909769872b46b1e0328cacf596>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3705959377eabcdc$var$_react = $3705959377eabcdc$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $3705959377eabcdc$var$_baseNew = $3705959377eabcdc$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $3705959377eabcdc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3705959377eabcdc$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $3705959377eabcdc$var$_react.default.createElement($3705959377eabcdc$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M13 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$3705959377eabcdc$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIcon';
var $3705959377eabcdc$var$_default = module.exports.default = $3705959377eabcdc$var$ShowMoreHorizontalIcon;

});

parcelRegister("Il3dn", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

parcelRegister("muyyw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::efa63c6a59a6ee993a0458e40fc93a18>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0439c20b3d5f0b35$var$_react = $0439c20b3d5f0b35$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $0439c20b3d5f0b35$var$_baseNew = $0439c20b3d5f0b35$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $0439c20b3d5f0b35$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0439c20b3d5f0b35$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $0439c20b3d5f0b35$var$_react.default.createElement($0439c20b3d5f0b35$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 7.47 5-5 1.06 1.06-3.72 3.72H15v1.5H3.56l3.72 3.72-1.06 1.06-5-5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$0439c20b3d5f0b35$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $0439c20b3d5f0b35$var$_default = module.exports.default = $0439c20b3d5f0b35$var$ArrowLeftIcon;

});

parcelRegister("gta0F", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::481d1ea8ad85e9d7b0bddff8ba9b16d1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfd71e82ab0194f9$var$_react = $bfd71e82ab0194f9$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $bfd71e82ab0194f9$var$_baseNew = $bfd71e82ab0194f9$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $bfd71e82ab0194f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListChecklist".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known usages: Checklist, 'Requirement' work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bfd71e82ab0194f9$var$ListChecklistIcon = (props)=>/*#__PURE__*/ $bfd71e82ab0194f9$var$_react.default.createElement($bfd71e82ab0194f9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m5.59 9.97-3 3.75a.75.75 0 0 1-1.16.01l-.05-.07-1.37-2.12 1.26-.81.81 1.25 2.33-2.95zm0-7.5-3 3.75a.75.75 0 0 1-1.16.01l-.05-.07L.01 4.04l1.26-.81.81 1.25 2.33-2.95zM16 11v1.5H7V11zm0-7.5V5H7V3.5z"/>`
    }, props));
$bfd71e82ab0194f9$var$ListChecklistIcon.displayName = 'ListChecklistIcon';
var $bfd71e82ab0194f9$var$_default = module.exports.default = $bfd71e82ab0194f9$var$ListChecklistIcon;

});

parcelRegister("iSvhd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dbe588062472d672$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3405feb70bdc0482b21b411108f82ba5>>
 * @codegenCommand yarn build-glyphs
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cjYIJ = parcelRequire("cjYIJ");

var $7Mywp = parcelRequire("7Mywp");
function $dbe588062472d672$export$2e2bcd8739ae039(_ref) {
    var _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bug' : _ref$label, size = _ref.size, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $7Mywp.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cjYIJ))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}

});
parcelRegister("cjYIJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b1c065f0aa91b3c3f089345b7ec72ae8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8f865c36b7401746$var$_react = $8f865c36b7401746$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $8f865c36b7401746$var$_baseNew = $8f865c36b7401746$var$_interopRequireDefault((parcelRequire("4Gm7Q")));
function $8f865c36b7401746$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Bug".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Request types in JSM, bugs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8f865c36b7401746$var$BugIcon = (props)=>/*#__PURE__*/ $8f865c36b7401746$var$_react.default.createElement($8f865c36b7401746$var$_baseNew.default, Object.assign({
        name: "BugIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 2.5A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 8 2.5m3 1.52V4a3 3 0 0 0-6 0v.02c-.29.05-.553.182-.761.372l-.887-.633-.917-2.064-1.37.61.944 2.125c.09.204.234.38.416.51l1.325.946V7H.5v1.5h3.25v1.149l-1.15.958a1.25 1.25 0 0 0-.318.401L1.08 13.415l1.342.67 1.18-2.36.46-.383A4.25 4.25 0 0 0 8.001 14h.249A4 4 0 0 0 12 11.393l.4.333 1.18 2.36 1.34-.671-1.202-2.407a1.25 1.25 0 0 0-.318-.401l-1.15-.958V8.5h3.25V7h-3.25V5.886l1.325-.946a1.25 1.25 0 0 0 .416-.51l.944-2.125-1.37-.61-.917 2.064-.887.633A1.5 1.5 0 0 0 11 4.02M10.75 10V5.5h-5.5v4.443l.035.226A2.75 2.75 0 0 0 8 12.5h.249a2.5 2.5 0 0 0 2.5-2.5" clip-rule="evenodd"/>`
    }, props));
$8f865c36b7401746$var$BugIcon.displayName = 'BugIcon';
var $8f865c36b7401746$var$_default = module.exports.default = $8f865c36b7401746$var$BugIcon;

});
parcelRegister("4Gm7Q", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return (parcelRequire("eDLrr")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("eDLrr")).Icon; });

var $eDLrr = parcelRequire("eDLrr");

});
parcelRegister("eDLrr", function(module, exports) {
$parcel$export(module.exports, "Icon", function () { return $aa89821955d62a1a$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $aa89821955d62a1a$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $1UZM1 = parcelRequire("1UZM1");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $aa89821955d62a1a$var$svgStyles = null;
var $aa89821955d62a1a$var$iconStyles = null;
var $aa89821955d62a1a$var$smallIconStyles = null;
var $aa89821955d62a1a$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $aa89821955d62a1a$var$baseHcmStyles = null;
var $aa89821955d62a1a$var$scaleSize = null;
var $aa89821955d62a1a$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $aa89821955d62a1a$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $aa89821955d62a1a$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $aa89821955d62a1a$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $aa89821955d62a1a$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $1UZM1.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $1oC0p.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $1UZM1.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $aa89821955d62a1a$var$coreSizeSmall[spacing] : $aa89821955d62a1a$var$coreSizeMedium[spacing]
        ])
    }));
});
var $aa89821955d62a1a$export$2e2bcd8739ae039 = $aa89821955d62a1a$export$f04a61298a47a40f;

});
parcelRegister("1UZM1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $165af05c81a592ed$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $165af05c81a592ed$var$ATOMIC_GROUP_LENGTH = 5;
function $165af05c81a592ed$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $165af05c81a592ed$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});




parcelRegister("7Mywp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $017651bb71402a74$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
function $017651bb71402a74$export$2e2bcd8739ae039(_ref) {
    var _ref$label = _ref.label, label = _ref$label === void 0 ? '' : _ref$label, _ref$size = _ref.size, size = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId, color = _ref.color, Icon = _ref.icon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Icon, {
        label: label,
        size: size === 'medium' ? 'medium' : 'small',
        color: color,
        testId: testId
    });
}

});


parcelRegister("1jakU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0f3f95565cbe1133$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc6be74be899a91647cea1371235d747>>
 * @codegenCommand yarn build-glyphs
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $6SmMc = parcelRequire("6SmMc");

var $7Mywp = parcelRequire("7Mywp");
function $0f3f95565cbe1133$export$2e2bcd8739ae039(_ref) {
    var _ref$label = _ref.label, label = _ref$label === void 0 ? 'Story' : _ref$label, size = _ref.size, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $7Mywp.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6SmMc))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
}

});
parcelRegister("6SmMc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c7bb68234d60992450ed6f02b59a5e8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5019742af55a1f0c$var$_react = $5019742af55a1f0c$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $5019742af55a1f0c$var$_baseNew = $5019742af55a1f0c$var$_interopRequireDefault((parcelRequire("4Gm7Q")));
function $5019742af55a1f0c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Story".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for story work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5019742af55a1f0c$var$StoryIcon = (props)=>/*#__PURE__*/ $5019742af55a1f0c$var$_react.default.createElement($5019742af55a1f0c$var$_baseNew.default, Object.assign({
        name: "StoryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.518 3a.5.5 0 0 0-.5-.5H4.983a.5.5 0 0 0-.5.5v9.806L8 10.333l.431.304 3.087 2.169zm1.5 11.202a.776.776 0 0 1-1.122.694l-.099-.06L8 12.166l-3.796 2.67a.775.775 0 0 1-1.22-.634V3a2 2 0 0 1 2-2h6.035a2 2 0 0 1 2 2z"/>`
    }, props));
$5019742af55a1f0c$var$StoryIcon.displayName = 'StoryIcon';
var $5019742af55a1f0c$var$_default = module.exports.default = $5019742af55a1f0c$var$StoryIcon;

});


parcelRegister("lOYk4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fe2d0f5532e045e7$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::00a580c76a83b898772f38add89d77e3>>
 * @codegenCommand yarn build-glyphs
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $cGs45 = parcelRequire("cGs45");

var $7Mywp = parcelRequire("7Mywp");
function $fe2d0f5532e045e7$export$2e2bcd8739ae039(_ref) {
    var _ref$label = _ref.label, label = _ref$label === void 0 ? 'Task' : _ref$label, size = _ref.size, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $7Mywp.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cGs45))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});
parcelRegister("cGs45", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::511501585faa18257c05d7a2687e12c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $93bf2d5d63e3f934$var$_react = $93bf2d5d63e3f934$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $93bf2d5d63e3f934$var$_baseNew = $93bf2d5d63e3f934$var$_interopRequireDefault((parcelRequire("4Gm7Q")));
function $93bf2d5d63e3f934$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Task".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $93bf2d5d63e3f934$var$TaskIcon = (props)=>/*#__PURE__*/ $93bf2d5d63e3f934$var$_react.default.createElement($93bf2d5d63e3f934$var$_baseNew.default, Object.assign({
        name: "TaskIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm9.326 2.98-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308z" clip-rule="evenodd"/>`
    }, props));
$93bf2d5d63e3f934$var$TaskIcon.displayName = 'TaskIcon';
var $93bf2d5d63e3f934$var$_default = module.exports.default = $93bf2d5d63e3f934$var$TaskIcon;

});


parcelRegister("iyuye", function(module, exports) {

var $erWD3 = parcelRequire("erWD3");

var $ih96c = parcelRequire("ih96c");
/** Error message constants. */ var $d82319cd6e5631ad$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $d82319cd6e5631ad$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($d82319cd6e5631ad$var$FUNC_ERROR_TEXT);
    if ($ih96c(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $erWD3(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
module.exports = $d82319cd6e5631ad$var$throttle;

});

parcelRegister("81kxF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::654979ffcf55141d2c08f198a843721e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5d6e59f717c4a085$var$_react = $5d6e59f717c4a085$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $5d6e59f717c4a085$var$_baseNew = $5d6e59f717c4a085$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $5d6e59f717c4a085$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Settings".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5d6e59f717c4a085$var$SettingsIcon = (props)=>/*#__PURE__*/ $5d6e59f717c4a085$var$_react.default.createElement($5d6e59f717c4a085$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.058.462A.75.75 0 0 1 6.75 0h2.5a.75.75 0 0 1 .692.462l1.026 2.462 2.578-.374a.75.75 0 0 1 .757.367l1.25 2.166a.75.75 0 0 1-.049.824L13.937 8l1.567 2.093c.18.24.2.565.05.825l-1.25 2.165a.75.75 0 0 1-.758.367l-2.578-.374-1.026 2.463A.75.75 0 0 1 9.25 16h-2.5a.75.75 0 0 1-.692-.461l-1.026-2.463-2.578.374a.75.75 0 0 1-.757-.367l-1.25-2.165a.75.75 0 0 1 .049-.825L2.063 8 .496 5.907a.75.75 0 0 1-.05-.824l1.25-2.166a.75.75 0 0 1 .758-.367l2.578.374zM7.25 1.5l-.871 2.09c-.242.58-.845.923-1.467.833l-2.17-.315-.749 1.296L3.32 7.176c.366.488.366 1.16 0 1.648l-1.327 1.772.749 1.296 2.17-.315a1.375 1.375 0 0 1 1.467.832L7.25 14.5h1.5l.871-2.09c.242-.58.845-.923 1.467-.833l2.17.315.749-1.296-1.327-1.772a1.375 1.375 0 0 1 0-1.648l1.327-1.772-.749-1.296-2.17.315A1.375 1.375 0 0 1 9.62 3.59L8.75 1.5zm.75 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$5d6e59f717c4a085$var$SettingsIcon.displayName = 'SettingsIcon';
var $5d6e59f717c4a085$var$_default = module.exports.default = $5d6e59f717c4a085$var$SettingsIcon;

});

parcelRegister("kz1DD", function(module, exports) {
$parcel$export(module.exports, "TransformWrapper", function () { return $ef8858de857ee727$export$51cb649375dcd655; });
$parcel$export(module.exports, "TransformComponent", function () { return $ef8858de857ee727$export$1def2aa75b7c7fe0; });

var $1oC0p = parcelRequire("1oC0p");
/**
 * Rounds number to given decimal
 * eg. roundNumber(2.34343, 1) => 2.3
 */ var $ef8858de857ee727$var$roundNumber = function(num, decimal) {
    return Number(num.toFixed(decimal));
};
/**
 * Checks if value is number, if not it returns default value
 * 1# eg. checkIsNumber(2, 30) => 2
 * 2# eg. checkIsNumber(null, 30) => 30
 */ var $ef8858de857ee727$var$checkIsNumber = function(num, defaultValue) {
    return typeof num === "number" ? num : defaultValue;
};
var $ef8858de857ee727$var$handleCallback = function(context, event, callback) {
    if (callback && typeof callback === "function") callback(context, event);
};
/* eslint-disable no-plusplus */ /* eslint-disable no-param-reassign */ /**
 * Functions should return denominator of the target value, which is the next animation step.
 * t is a value from 0 to 1, reflecting the percentage of animation status.
 */ var $ef8858de857ee727$var$easeOut = function(t) {
    return -Math.cos(t * Math.PI) / 2 + 0.5;
};
// linear
var $ef8858de857ee727$var$linear = function(t) {
    return t;
};
// accelerating from zero velocity
var $ef8858de857ee727$var$easeInQuad = function(t) {
    return t * t;
};
// decelerating to zero velocity
var $ef8858de857ee727$var$easeOutQuad = function(t) {
    return t * (2 - t);
};
// acceleration until halfway, then deceleration
var $ef8858de857ee727$var$easeInOutQuad = function(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
};
// accelerating from zero velocity
var $ef8858de857ee727$var$easeInCubic = function(t) {
    return t * t * t;
};
// decelerating to zero velocity
var $ef8858de857ee727$var$easeOutCubic = function(t) {
    return --t * t * t + 1;
};
// acceleration until halfway, then deceleration
var $ef8858de857ee727$var$easeInOutCubic = function(t) {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
};
// accelerating from zero velocity
var $ef8858de857ee727$var$easeInQuart = function(t) {
    return t * t * t * t;
};
// decelerating to zero velocity
var $ef8858de857ee727$var$easeOutQuart = function(t) {
    return 1 - --t * t * t * t;
};
// acceleration until halfway, then deceleration
var $ef8858de857ee727$var$easeInOutQuart = function(t) {
    return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
};
// accelerating from zero velocity
var $ef8858de857ee727$var$easeInQuint = function(t) {
    return t * t * t * t * t;
};
// decelerating to zero velocity
var $ef8858de857ee727$var$easeOutQuint = function(t) {
    return 1 + --t * t * t * t * t;
};
// acceleration until halfway, then deceleration
var $ef8858de857ee727$var$easeInOutQuint = function(t) {
    return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
};
var $ef8858de857ee727$var$animations = {
    easeOut: $ef8858de857ee727$var$easeOut,
    linear: $ef8858de857ee727$var$linear,
    easeInQuad: $ef8858de857ee727$var$easeInQuad,
    easeOutQuad: $ef8858de857ee727$var$easeOutQuad,
    easeInOutQuad: $ef8858de857ee727$var$easeInOutQuad,
    easeInCubic: $ef8858de857ee727$var$easeInCubic,
    easeOutCubic: $ef8858de857ee727$var$easeOutCubic,
    easeInOutCubic: $ef8858de857ee727$var$easeInOutCubic,
    easeInQuart: $ef8858de857ee727$var$easeInQuart,
    easeOutQuart: $ef8858de857ee727$var$easeOutQuart,
    easeInOutQuart: $ef8858de857ee727$var$easeInOutQuart,
    easeInQuint: $ef8858de857ee727$var$easeInQuint,
    easeOutQuint: $ef8858de857ee727$var$easeOutQuint,
    easeInOutQuint: $ef8858de857ee727$var$easeInOutQuint
};
/* eslint-disable no-param-reassign */ var $ef8858de857ee727$var$handleCancelAnimationFrame = function(animation) {
    if (typeof animation === "number") cancelAnimationFrame(animation);
};
var $ef8858de857ee727$var$handleCancelAnimation = function(contextInstance) {
    if (!contextInstance.mounted) return;
    $ef8858de857ee727$var$handleCancelAnimationFrame(contextInstance.animation);
    // Clear animation state
    contextInstance.animate = false;
    contextInstance.animation = null;
    contextInstance.velocity = null;
};
function $ef8858de857ee727$var$handleSetupAnimation(contextInstance, animationName, animationTime, callback) {
    if (!contextInstance.mounted) return;
    var startTime = new Date().getTime();
    var lastStep = 1;
    // if another animation is active
    $ef8858de857ee727$var$handleCancelAnimation(contextInstance);
    // new animation
    contextInstance.animation = function() {
        if (!contextInstance.mounted) return $ef8858de857ee727$var$handleCancelAnimationFrame(contextInstance.animation);
        var frameTime = new Date().getTime() - startTime;
        var animationProgress = frameTime / animationTime;
        var animationType = $ef8858de857ee727$var$animations[animationName];
        var step = animationType(animationProgress);
        if (frameTime >= animationTime) {
            callback(lastStep);
            contextInstance.animation = null;
        } else if (contextInstance.animation) {
            callback(step);
            requestAnimationFrame(contextInstance.animation);
        }
    };
    requestAnimationFrame(contextInstance.animation);
}
function $ef8858de857ee727$var$isValidTargetState(targetState) {
    var scale = targetState.scale, positionX = targetState.positionX, positionY = targetState.positionY;
    if (Number.isNaN(scale) || Number.isNaN(positionX) || Number.isNaN(positionY)) return false;
    return true;
}
function $ef8858de857ee727$var$animate(contextInstance, targetState, animationTime, animationName) {
    var isValid = $ef8858de857ee727$var$isValidTargetState(targetState);
    if (!contextInstance.mounted || !isValid) return;
    var setTransformState = contextInstance.setTransformState;
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    var scaleDiff = targetState.scale - scale;
    var positionXDiff = targetState.positionX - positionX;
    var positionYDiff = targetState.positionY - positionY;
    if (animationTime === 0) setTransformState(targetState.scale, targetState.positionX, targetState.positionY);
    else // animation start timestamp
    $ef8858de857ee727$var$handleSetupAnimation(contextInstance, animationName, animationTime, function(step) {
        var newScale = scale + scaleDiff * step;
        var newPositionX = positionX + positionXDiff * step;
        var newPositionY = positionY + positionYDiff * step;
        setTransformState(newScale, newPositionX, newPositionY);
    });
}
/* eslint-disable no-param-reassign */ function $ef8858de857ee727$var$getComponentsSizes(wrapperComponent, contentComponent, newScale) {
    var wrapperWidth = wrapperComponent.offsetWidth;
    var wrapperHeight = wrapperComponent.offsetHeight;
    var contentWidth = contentComponent.offsetWidth;
    var contentHeight = contentComponent.offsetHeight;
    var newContentWidth = contentWidth * newScale;
    var newContentHeight = contentHeight * newScale;
    var newDiffWidth = wrapperWidth - newContentWidth;
    var newDiffHeight = wrapperHeight - newContentHeight;
    return {
        wrapperWidth: wrapperWidth,
        wrapperHeight: wrapperHeight,
        newContentWidth: newContentWidth,
        newDiffWidth: newDiffWidth,
        newContentHeight: newContentHeight,
        newDiffHeight: newDiffHeight
    };
}
var $ef8858de857ee727$var$getBounds = function(wrapperWidth, newContentWidth, diffWidth, wrapperHeight, newContentHeight, diffHeight, centerZoomedOut) {
    var scaleWidthFactor = wrapperWidth > newContentWidth ? diffWidth * (centerZoomedOut ? 1 : 0.5) : 0;
    var scaleHeightFactor = wrapperHeight > newContentHeight ? diffHeight * (centerZoomedOut ? 1 : 0.5) : 0;
    var minPositionX = wrapperWidth - newContentWidth - scaleWidthFactor;
    var maxPositionX = scaleWidthFactor;
    var minPositionY = wrapperHeight - newContentHeight - scaleHeightFactor;
    var maxPositionY = scaleHeightFactor;
    return {
        minPositionX: minPositionX,
        maxPositionX: maxPositionX,
        minPositionY: minPositionY,
        maxPositionY: maxPositionY
    };
};
var $ef8858de857ee727$var$calculateBounds = function(contextInstance, newScale) {
    var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
    var centerZoomedOut = contextInstance.setup.centerZoomedOut;
    if (!wrapperComponent || !contentComponent) throw new Error("Components are not mounted");
    var _a = $ef8858de857ee727$var$getComponentsSizes(wrapperComponent, contentComponent, newScale), wrapperWidth = _a.wrapperWidth, wrapperHeight = _a.wrapperHeight, newContentWidth = _a.newContentWidth, newDiffWidth = _a.newDiffWidth, newContentHeight = _a.newContentHeight, newDiffHeight = _a.newDiffHeight;
    var bounds = $ef8858de857ee727$var$getBounds(wrapperWidth, newContentWidth, newDiffWidth, wrapperHeight, newContentHeight, newDiffHeight, Boolean(centerZoomedOut));
    return bounds;
};
/**
 * Keeps value between given bounds, used for limiting view to given boundaries
 * 1# eg. boundLimiter(2, 0, 3, true) => 2
 * 2# eg. boundLimiter(4, 0, 3, true) => 3
 * 3# eg. boundLimiter(-2, 0, 3, true) => 0
 * 4# eg. boundLimiter(10, 0, 3, false) => 10
 */ var $ef8858de857ee727$var$boundLimiter = function(value, minBound, maxBound, isActive) {
    if (!isActive) return $ef8858de857ee727$var$roundNumber(value, 2);
    if (value < minBound) return $ef8858de857ee727$var$roundNumber(minBound, 2);
    if (value > maxBound) return $ef8858de857ee727$var$roundNumber(maxBound, 2);
    return $ef8858de857ee727$var$roundNumber(value, 2);
};
var $ef8858de857ee727$var$handleCalculateBounds = function(contextInstance, newScale) {
    var bounds = $ef8858de857ee727$var$calculateBounds(contextInstance, newScale);
    // Save bounds
    contextInstance.bounds = bounds;
    return bounds;
};
function $ef8858de857ee727$var$getMouseBoundedPosition(positionX, positionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent) {
    var minPositionX = bounds.minPositionX, minPositionY = bounds.minPositionY, maxPositionX = bounds.maxPositionX, maxPositionY = bounds.maxPositionY;
    var paddingX = 0;
    var paddingY = 0;
    if (wrapperComponent) {
        paddingX = paddingValueX;
        paddingY = paddingValueY;
    }
    var x = $ef8858de857ee727$var$boundLimiter(positionX, minPositionX - paddingX, maxPositionX + paddingX, limitToBounds);
    var y = $ef8858de857ee727$var$boundLimiter(positionY, minPositionY - paddingY, maxPositionY + paddingY, limitToBounds);
    return {
        x: x,
        y: y
    };
}
function $ef8858de857ee727$var$handleCalculateZoomPositions(contextInstance, mouseX, mouseY, newScale, bounds, limitToBounds) {
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    var scaleDifference = newScale - scale;
    if (typeof mouseX !== "number" || typeof mouseY !== "number") {
        console.error("Mouse X and Y position were not provided!");
        return {
            x: positionX,
            y: positionY
        };
    }
    var calculatedPositionX = positionX - mouseX * scaleDifference;
    var calculatedPositionY = positionY - mouseY * scaleDifference;
    // do not limit to bounds when there is padding animation,
    // it causes animation strange behaviour
    var newPositions = $ef8858de857ee727$var$getMouseBoundedPosition(calculatedPositionX, calculatedPositionY, bounds, limitToBounds, 0, 0, null);
    return newPositions;
}
function $ef8858de857ee727$var$checkZoomBounds(zoom, minScale, maxScale, zoomPadding, enablePadding) {
    var scalePadding = enablePadding ? zoomPadding : 0;
    var minScaleWithPadding = minScale - scalePadding;
    if (!Number.isNaN(maxScale) && zoom >= maxScale) return maxScale;
    if (!Number.isNaN(minScale) && zoom <= minScaleWithPadding) return minScaleWithPadding;
    return zoom;
}
var $ef8858de857ee727$var$isPanningStartAllowed = function(contextInstance, event) {
    var excluded = contextInstance.setup.panning.excluded;
    var isInitialized = contextInstance.isInitialized, wrapperComponent = contextInstance.wrapperComponent;
    var target = event.target;
    var targetIsShadowDom = "shadowRoot" in target && "composedPath" in event;
    var isWrapperChild = targetIsShadowDom ? event.composedPath().some(function(el) {
        if (!(el instanceof Element)) return false;
        return wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(el);
    }) : wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(target);
    var isAllowed = isInitialized && target && isWrapperChild;
    if (!isAllowed) return false;
    var isExcluded = $ef8858de857ee727$var$isExcludedNode(target, excluded);
    if (isExcluded) return false;
    return true;
};
var $ef8858de857ee727$var$isPanningAllowed = function(contextInstance) {
    var isInitialized = contextInstance.isInitialized, isPanning = contextInstance.isPanning, setup = contextInstance.setup;
    var disabled = setup.panning.disabled;
    var isAllowed = isInitialized && isPanning && !disabled;
    if (!isAllowed) return false;
    return true;
};
var $ef8858de857ee727$var$handlePanningSetup = function(contextInstance, event) {
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY;
    contextInstance.isPanning = true;
    // Panning with mouse
    var x = event.clientX;
    var y = event.clientY;
    contextInstance.startCoords = {
        x: x - positionX,
        y: y - positionY
    };
};
var $ef8858de857ee727$var$handleTouchPanningSetup = function(contextInstance, event) {
    var touches = event.touches;
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY;
    contextInstance.isPanning = true;
    // Panning with touch
    var oneFingerTouch = touches.length === 1;
    if (oneFingerTouch) {
        var x = touches[0].clientX;
        var y = touches[0].clientY;
        contextInstance.startCoords = {
            x: x - positionX,
            y: y - positionY
        };
    }
};
function $ef8858de857ee727$var$handlePanToBounds(contextInstance) {
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY, scale = _a.scale;
    var _b = contextInstance.setup, disabled = _b.disabled, limitToBounds = _b.limitToBounds, centerZoomedOut = _b.centerZoomedOut;
    var wrapperComponent = contextInstance.wrapperComponent;
    if (disabled || !wrapperComponent || !contextInstance.bounds) return;
    var _c = contextInstance.bounds, maxPositionX = _c.maxPositionX, minPositionX = _c.minPositionX, maxPositionY = _c.maxPositionY, minPositionY = _c.minPositionY;
    var xChanged = positionX > maxPositionX || positionX < minPositionX;
    var yChanged = positionY > maxPositionY || positionY < minPositionY;
    var mousePosX = positionX > maxPositionX ? wrapperComponent.offsetWidth : contextInstance.setup.minPositionX || 0;
    var mousePosY = positionY > maxPositionY ? wrapperComponent.offsetHeight : contextInstance.setup.minPositionY || 0;
    var _d = $ef8858de857ee727$var$handleCalculateZoomPositions(contextInstance, mousePosX, mousePosY, scale, contextInstance.bounds, limitToBounds || centerZoomedOut), x = _d.x, y = _d.y;
    return {
        scale: scale,
        positionX: xChanged ? x : positionX,
        positionY: yChanged ? y : positionY
    };
}
function $ef8858de857ee727$var$handleNewPosition(contextInstance, newPositionX, newPositionY, paddingValueX, paddingValueY) {
    var limitToBounds = contextInstance.setup.limitToBounds;
    var wrapperComponent = contextInstance.wrapperComponent, bounds = contextInstance.bounds;
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    if (wrapperComponent === null || bounds === null || newPositionX === positionX && newPositionY === positionY) return;
    var _b = $ef8858de857ee727$var$getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent), x = _b.x, y = _b.y;
    contextInstance.setTransformState(scale, x, y);
}
var $ef8858de857ee727$var$getPanningClientPosition = function(contextInstance, clientX, clientY) {
    var startCoords = contextInstance.startCoords, transformState = contextInstance.transformState;
    var panning = contextInstance.setup.panning;
    var lockAxisX = panning.lockAxisX, lockAxisY = panning.lockAxisY;
    var positionX = transformState.positionX, positionY = transformState.positionY;
    if (!startCoords) return {
        x: positionX,
        y: positionY
    };
    var mouseX = clientX - startCoords.x;
    var mouseY = clientY - startCoords.y;
    var newPositionX = lockAxisX ? positionX : mouseX;
    var newPositionY = lockAxisY ? positionY : mouseY;
    return {
        x: newPositionX,
        y: newPositionY
    };
};
var $ef8858de857ee727$var$getPaddingValue = function(contextInstance, size) {
    var setup = contextInstance.setup, transformState = contextInstance.transformState;
    var scale = transformState.scale;
    var minScale = setup.minScale, disablePadding = setup.disablePadding;
    if (size > 0 && scale >= minScale && !disablePadding) return size;
    return 0;
};
var $ef8858de857ee727$var$isVelocityCalculationAllowed = function(contextInstance) {
    var mounted = contextInstance.mounted;
    var _a = contextInstance.setup, disabled = _a.disabled, velocityAnimation = _a.velocityAnimation;
    var scale = contextInstance.transformState.scale;
    var disabledVelocity = velocityAnimation.disabled;
    var isAllowed = !disabledVelocity || scale > 1 || !disabled || mounted;
    if (!isAllowed) return false;
    return true;
};
var $ef8858de857ee727$var$isVelocityAllowed = function(contextInstance) {
    var mounted = contextInstance.mounted, velocity = contextInstance.velocity, bounds = contextInstance.bounds;
    var _a = contextInstance.setup, disabled = _a.disabled, velocityAnimation = _a.velocityAnimation;
    var scale = contextInstance.transformState.scale;
    var disabledVelocity = velocityAnimation.disabled;
    var isAllowed = !disabledVelocity || scale > 1 || !disabled || mounted;
    if (!isAllowed) return false;
    if (!velocity || !bounds) return false;
    return true;
};
function $ef8858de857ee727$var$getVelocityMoveTime(contextInstance, velocity) {
    var velocityAnimation = contextInstance.setup.velocityAnimation;
    var equalToMove = velocityAnimation.equalToMove, animationTime = velocityAnimation.animationTime, sensitivity = velocityAnimation.sensitivity;
    if (equalToMove) return animationTime * velocity * sensitivity;
    return animationTime;
}
function $ef8858de857ee727$var$getVelocityPosition(newPosition, startPosition, currentPosition, isLocked, limitToBounds, minPosition, maxPosition, minTarget, maxTarget, step) {
    if (limitToBounds) {
        if (startPosition > maxPosition && currentPosition > maxPosition) {
            var calculatedPosition = maxPosition + (newPosition - maxPosition) * step;
            if (calculatedPosition > maxTarget) return maxTarget;
            if (calculatedPosition < maxPosition) return maxPosition;
            return calculatedPosition;
        }
        if (startPosition < minPosition && currentPosition < minPosition) {
            var calculatedPosition = minPosition + (newPosition - minPosition) * step;
            if (calculatedPosition < minTarget) return minTarget;
            if (calculatedPosition > minPosition) return minPosition;
            return calculatedPosition;
        }
    }
    if (isLocked) return startPosition;
    return $ef8858de857ee727$var$boundLimiter(newPosition, minPosition, maxPosition, limitToBounds);
}
function $ef8858de857ee727$var$getSizeMultiplier(wrapperComponent, equalToMove) {
    var defaultMultiplier = 1;
    if (equalToMove) return Math.min(defaultMultiplier, wrapperComponent.offsetWidth / window.innerWidth);
    return defaultMultiplier;
}
function $ef8858de857ee727$var$handleCalculateVelocity(contextInstance, position) {
    var isAllowed = $ef8858de857ee727$var$isVelocityCalculationAllowed(contextInstance);
    if (!isAllowed) return;
    var lastMousePosition = contextInstance.lastMousePosition, velocityTime = contextInstance.velocityTime, setup = contextInstance.setup;
    var wrapperComponent = contextInstance.wrapperComponent;
    var equalToMove = setup.velocityAnimation.equalToMove;
    var now = Date.now();
    if (lastMousePosition && velocityTime && wrapperComponent) {
        var sizeMultiplier = $ef8858de857ee727$var$getSizeMultiplier(wrapperComponent, equalToMove);
        var distanceX = position.x - lastMousePosition.x;
        var distanceY = position.y - lastMousePosition.y;
        var velocityX = distanceX / sizeMultiplier;
        var velocityY = distanceY / sizeMultiplier;
        var interval = now - velocityTime;
        var speed = distanceX * distanceX + distanceY * distanceY;
        var velocity = Math.sqrt(speed) / interval;
        contextInstance.velocity = {
            velocityX: velocityX,
            velocityY: velocityY,
            total: velocity
        };
    }
    contextInstance.lastMousePosition = position;
    contextInstance.velocityTime = now;
}
function $ef8858de857ee727$var$handleVelocityPanning(contextInstance) {
    var velocity = contextInstance.velocity, bounds = contextInstance.bounds, setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var isAllowed = $ef8858de857ee727$var$isVelocityAllowed(contextInstance);
    if (!isAllowed || !velocity || !bounds || !wrapperComponent) return;
    var velocityX = velocity.velocityX, velocityY = velocity.velocityY, total = velocity.total;
    var maxPositionX = bounds.maxPositionX, minPositionX = bounds.minPositionX, maxPositionY = bounds.maxPositionY, minPositionY = bounds.minPositionY;
    var limitToBounds = setup.limitToBounds, alignmentAnimation = setup.alignmentAnimation;
    var zoomAnimation = setup.zoomAnimation, panning = setup.panning;
    var lockAxisY = panning.lockAxisY, lockAxisX = panning.lockAxisX;
    var animationType = zoomAnimation.animationType;
    var sizeX = alignmentAnimation.sizeX, sizeY = alignmentAnimation.sizeY, velocityAlignmentTime = alignmentAnimation.velocityAlignmentTime;
    var alignAnimationTime = velocityAlignmentTime;
    var moveAnimationTime = $ef8858de857ee727$var$getVelocityMoveTime(contextInstance, total);
    var finalAnimationTime = Math.max(moveAnimationTime, alignAnimationTime);
    var paddingValueX = $ef8858de857ee727$var$getPaddingValue(contextInstance, sizeX);
    var paddingValueY = $ef8858de857ee727$var$getPaddingValue(contextInstance, sizeY);
    var paddingX = paddingValueX * wrapperComponent.offsetWidth / 100;
    var paddingY = paddingValueY * wrapperComponent.offsetHeight / 100;
    var maxTargetX = maxPositionX + paddingX;
    var minTargetX = minPositionX - paddingX;
    var maxTargetY = maxPositionY + paddingY;
    var minTargetY = minPositionY - paddingY;
    var startState = contextInstance.transformState;
    var startTime = new Date().getTime();
    $ef8858de857ee727$var$handleSetupAnimation(contextInstance, animationType, finalAnimationTime, function(step) {
        var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
        var frameTime = new Date().getTime() - startTime;
        var animationProgress = frameTime / alignAnimationTime;
        var alignAnimation = $ef8858de857ee727$var$animations[alignmentAnimation.animationType];
        var alignStep = 1 - alignAnimation(Math.min(1, animationProgress));
        var customStep = 1 - step;
        var newPositionX = positionX + velocityX * customStep;
        var newPositionY = positionY + velocityY * customStep;
        var currentPositionX = $ef8858de857ee727$var$getVelocityPosition(newPositionX, startState.positionX, positionX, lockAxisX, limitToBounds, minPositionX, maxPositionX, minTargetX, maxTargetX, alignStep);
        var currentPositionY = $ef8858de857ee727$var$getVelocityPosition(newPositionY, startState.positionY, positionY, lockAxisY, limitToBounds, minPositionY, maxPositionY, minTargetY, maxTargetY, alignStep);
        if (positionX !== newPositionX || positionY !== newPositionY) contextInstance.setTransformState(scale, currentPositionX, currentPositionY);
    });
}
function $ef8858de857ee727$var$handlePanningStart(contextInstance, event) {
    var scale = contextInstance.transformState.scale;
    $ef8858de857ee727$var$handleCancelAnimation(contextInstance);
    $ef8858de857ee727$var$handleCalculateBounds(contextInstance, scale);
    if (window.TouchEvent !== undefined && event instanceof TouchEvent) $ef8858de857ee727$var$handleTouchPanningSetup(contextInstance, event);
    else $ef8858de857ee727$var$handlePanningSetup(contextInstance, event);
}
function $ef8858de857ee727$var$handleAlignToBounds(contextInstance) {
    var scale = contextInstance.transformState.scale;
    var _a = contextInstance.setup, minScale = _a.minScale, alignmentAnimation = _a.alignmentAnimation;
    var disabled = alignmentAnimation.disabled, sizeX = alignmentAnimation.sizeX, sizeY = alignmentAnimation.sizeY, animationTime = alignmentAnimation.animationTime, animationType = alignmentAnimation.animationType;
    var isDisabled = disabled || scale < minScale || !sizeX && !sizeY;
    if (isDisabled) return;
    var targetState = $ef8858de857ee727$var$handlePanToBounds(contextInstance);
    if (targetState) $ef8858de857ee727$var$animate(contextInstance, targetState, animationTime, animationType);
}
function $ef8858de857ee727$var$handlePanning(contextInstance, clientX, clientY) {
    var startCoords = contextInstance.startCoords, setup = contextInstance.setup;
    var _a = setup.alignmentAnimation, sizeX = _a.sizeX, sizeY = _a.sizeY;
    if (!startCoords) return;
    var _b = $ef8858de857ee727$var$getPanningClientPosition(contextInstance, clientX, clientY), x = _b.x, y = _b.y;
    var paddingValueX = $ef8858de857ee727$var$getPaddingValue(contextInstance, sizeX);
    var paddingValueY = $ef8858de857ee727$var$getPaddingValue(contextInstance, sizeY);
    $ef8858de857ee727$var$handleCalculateVelocity(contextInstance, {
        x: x,
        y: y
    });
    $ef8858de857ee727$var$handleNewPosition(contextInstance, x, y, paddingValueX, paddingValueY);
}
function $ef8858de857ee727$var$handlePanningEnd(contextInstance) {
    if (contextInstance.isPanning) {
        var velocityDisabled = contextInstance.setup.panning.velocityDisabled;
        var velocity = contextInstance.velocity, wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
        contextInstance.isPanning = false;
        contextInstance.animate = false;
        contextInstance.animation = null;
        var wrapperRect = wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.getBoundingClientRect();
        var contentRect = contentComponent === null || contentComponent === void 0 ? void 0 : contentComponent.getBoundingClientRect();
        var wrapperWidth = (wrapperRect === null || wrapperRect === void 0 ? void 0 : wrapperRect.width) || 0;
        var wrapperHeight = (wrapperRect === null || wrapperRect === void 0 ? void 0 : wrapperRect.height) || 0;
        var contentWidth = (contentRect === null || contentRect === void 0 ? void 0 : contentRect.width) || 0;
        var contentHeight = (contentRect === null || contentRect === void 0 ? void 0 : contentRect.height) || 0;
        var isZoomed = wrapperWidth < contentWidth || wrapperHeight < contentHeight;
        var shouldAnimate = !velocityDisabled && velocity && (velocity === null || velocity === void 0 ? void 0 : velocity.total) > 0.1 && isZoomed;
        if (shouldAnimate) $ef8858de857ee727$var$handleVelocityPanning(contextInstance);
        else $ef8858de857ee727$var$handleAlignToBounds(contextInstance);
    }
}
function $ef8858de857ee727$var$handleZoomToPoint(contextInstance, scale, mouseX, mouseY) {
    var _a = contextInstance.setup, minScale = _a.minScale, maxScale = _a.maxScale, limitToBounds = _a.limitToBounds;
    var newScale = $ef8858de857ee727$var$checkZoomBounds($ef8858de857ee727$var$roundNumber(scale, 2), minScale, maxScale, 0, false);
    var bounds = $ef8858de857ee727$var$handleCalculateBounds(contextInstance, newScale);
    var _b = $ef8858de857ee727$var$handleCalculateZoomPositions(contextInstance, mouseX, mouseY, newScale, bounds, limitToBounds), x = _b.x, y = _b.y;
    return {
        scale: newScale,
        positionX: x,
        positionY: y
    };
}
function $ef8858de857ee727$var$handleAlignToScaleBounds(contextInstance, mousePositionX, mousePositionY) {
    var scale = contextInstance.transformState.scale;
    var wrapperComponent = contextInstance.wrapperComponent;
    var _a = contextInstance.setup, minScale = _a.minScale, limitToBounds = _a.limitToBounds, zoomAnimation = _a.zoomAnimation;
    var disabled = zoomAnimation.disabled, animationTime = zoomAnimation.animationTime, animationType = zoomAnimation.animationType;
    var isDisabled = disabled || scale >= minScale;
    if (scale >= 1 || limitToBounds) // fire fit to bounds animation
    $ef8858de857ee727$var$handleAlignToBounds(contextInstance);
    if (isDisabled || !wrapperComponent || !contextInstance.mounted) return;
    var mouseX = mousePositionX || wrapperComponent.offsetWidth / 2;
    var mouseY = mousePositionY || wrapperComponent.offsetHeight / 2;
    var targetState = $ef8858de857ee727$var$handleZoomToPoint(contextInstance, minScale, mouseX, mouseY);
    if (targetState) $ef8858de857ee727$var$animate(contextInstance, targetState, animationTime, animationType);
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $ef8858de857ee727$var$__assign = function() {
    $ef8858de857ee727$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ef8858de857ee727$var$__assign.apply(this, arguments);
};
function $ef8858de857ee727$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $ef8858de857ee727$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
var $ef8858de857ee727$var$initialState = {
    previousScale: 1,
    scale: 1,
    positionX: 0,
    positionY: 0
};
var $ef8858de857ee727$var$initialSetup = {
    disabled: false,
    minPositionX: null,
    maxPositionX: null,
    minPositionY: null,
    maxPositionY: null,
    minScale: 1,
    maxScale: 8,
    limitToBounds: true,
    centerZoomedOut: false,
    centerOnInit: false,
    disablePadding: false,
    smooth: true,
    wheel: {
        step: 0.2,
        disabled: false,
        smoothStep: 0.001,
        wheelDisabled: false,
        touchPadDisabled: false,
        activationKeys: [],
        excluded: []
    },
    panning: {
        disabled: false,
        velocityDisabled: false,
        lockAxisX: false,
        lockAxisY: false,
        allowLeftClickPan: true,
        allowMiddleClickPan: true,
        allowRightClickPan: true,
        wheelPanning: false,
        activationKeys: [],
        excluded: []
    },
    pinch: {
        step: 5,
        disabled: false,
        excluded: []
    },
    doubleClick: {
        disabled: false,
        step: 0.7,
        mode: "zoomIn",
        animationType: "easeOut",
        animationTime: 200,
        excluded: []
    },
    zoomAnimation: {
        disabled: false,
        size: 0.4,
        animationTime: 200,
        animationType: "easeOut"
    },
    alignmentAnimation: {
        disabled: false,
        sizeX: 100,
        sizeY: 100,
        animationTime: 200,
        velocityAlignmentTime: 400,
        animationType: "easeOut"
    },
    velocityAnimation: {
        disabled: false,
        sensitivity: 1,
        animationTime: 400,
        animationType: "easeOut",
        equalToMove: true
    }
};
var $ef8858de857ee727$var$baseClasses = {
    wrapperClass: "react-transform-wrapper",
    contentClass: "react-transform-component"
};
var $ef8858de857ee727$var$createState = function(props) {
    var _a, _b, _c, _d;
    return {
        previousScale: (_a = props.initialScale) !== null && _a !== void 0 ? _a : $ef8858de857ee727$var$initialState.scale,
        scale: (_b = props.initialScale) !== null && _b !== void 0 ? _b : $ef8858de857ee727$var$initialState.scale,
        positionX: (_c = props.initialPositionX) !== null && _c !== void 0 ? _c : $ef8858de857ee727$var$initialState.positionX,
        positionY: (_d = props.initialPositionY) !== null && _d !== void 0 ? _d : $ef8858de857ee727$var$initialState.positionY
    };
};
var $ef8858de857ee727$var$createSetup = function(props) {
    var newSetup = $ef8858de857ee727$var$__assign({}, $ef8858de857ee727$var$initialSetup);
    Object.keys(props).forEach(function(key) {
        var validValue = typeof props[key] !== "undefined";
        var validParameter = typeof $ef8858de857ee727$var$initialSetup[key] !== "undefined";
        if (validParameter && validValue) {
            var dataType = Object.prototype.toString.call($ef8858de857ee727$var$initialSetup[key]);
            var isObject = dataType === "[object Object]";
            var isArray = dataType === "[object Array]";
            if (isObject) newSetup[key] = $ef8858de857ee727$var$__assign($ef8858de857ee727$var$__assign({}, $ef8858de857ee727$var$initialSetup[key]), props[key]);
            else if (isArray) newSetup[key] = $ef8858de857ee727$var$__spreadArray($ef8858de857ee727$var$__spreadArray([], $ef8858de857ee727$var$initialSetup[key], true), props[key], true);
            else newSetup[key] = props[key];
        }
    });
    return newSetup;
};
var $ef8858de857ee727$var$handleCalculateButtonZoom = function(contextInstance, delta, step) {
    var scale = contextInstance.transformState.scale;
    var wrapperComponent = contextInstance.wrapperComponent, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation, smooth = setup.smooth;
    var size = zoomAnimation.size;
    if (!wrapperComponent) throw new Error("Wrapper is not mounted");
    var targetScale = smooth ? scale * Math.exp(delta * step) : scale + delta * step;
    var newScale = $ef8858de857ee727$var$checkZoomBounds($ef8858de857ee727$var$roundNumber(targetScale, 3), minScale, maxScale, size, false);
    return newScale;
};
function $ef8858de857ee727$var$handleZoomToViewCenter(contextInstance, delta, step, animationTime, animationType) {
    var wrapperComponent = contextInstance.wrapperComponent;
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    if (!wrapperComponent) return console.error("No WrapperComponent found");
    var wrapperWidth = wrapperComponent.offsetWidth;
    var wrapperHeight = wrapperComponent.offsetHeight;
    var mouseX = (wrapperWidth / 2 - positionX) / scale;
    var mouseY = (wrapperHeight / 2 - positionY) / scale;
    var newScale = $ef8858de857ee727$var$handleCalculateButtonZoom(contextInstance, delta, step);
    var targetState = $ef8858de857ee727$var$handleZoomToPoint(contextInstance, newScale, mouseX, mouseY);
    if (!targetState) return console.error("Error during zoom event. New transformation state was not calculated.");
    $ef8858de857ee727$var$animate(contextInstance, targetState, animationTime, animationType);
}
function $ef8858de857ee727$var$resetTransformations(contextInstance, animationTime, animationType, onResetTransformation) {
    var setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var limitToBounds = setup.limitToBounds;
    var initialTransformation = $ef8858de857ee727$var$createState(contextInstance.props);
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    if (!wrapperComponent) return;
    var newBounds = $ef8858de857ee727$var$calculateBounds(contextInstance, initialTransformation.scale);
    var boundedPositions = $ef8858de857ee727$var$getMouseBoundedPosition(initialTransformation.positionX, initialTransformation.positionY, newBounds, limitToBounds, 0, 0, wrapperComponent);
    var newState = {
        scale: initialTransformation.scale,
        positionX: boundedPositions.x,
        positionY: boundedPositions.y
    };
    if (scale === initialTransformation.scale && positionX === initialTransformation.positionX && positionY === initialTransformation.positionY) return;
    onResetTransformation === null || onResetTransformation === void 0 || onResetTransformation();
    $ef8858de857ee727$var$animate(contextInstance, newState, animationTime, animationType);
}
function $ef8858de857ee727$var$getOffset(element, wrapper, content, state) {
    var offset = element.getBoundingClientRect();
    var wrapperOffset = wrapper.getBoundingClientRect();
    var contentOffset = content.getBoundingClientRect();
    var xOff = wrapperOffset.x * state.scale;
    var yOff = wrapperOffset.y * state.scale;
    return {
        x: (offset.x - contentOffset.x + xOff) / state.scale,
        y: (offset.y - contentOffset.y + yOff) / state.scale
    };
}
function $ef8858de857ee727$var$calculateZoomToNode(contextInstance, node, customZoom) {
    var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent, transformState = contextInstance.transformState;
    var _a = contextInstance.setup, limitToBounds = _a.limitToBounds, minScale = _a.minScale, maxScale = _a.maxScale;
    if (!wrapperComponent || !contentComponent) return transformState;
    var wrapperRect = wrapperComponent.getBoundingClientRect();
    var nodeRect = node.getBoundingClientRect();
    var nodeOffset = $ef8858de857ee727$var$getOffset(node, wrapperComponent, contentComponent, transformState);
    var nodeLeft = nodeOffset.x;
    var nodeTop = nodeOffset.y;
    var nodeWidth = nodeRect.width / transformState.scale;
    var nodeHeight = nodeRect.height / transformState.scale;
    var scaleX = wrapperComponent.offsetWidth / nodeWidth;
    var scaleY = wrapperComponent.offsetHeight / nodeHeight;
    var newScale = $ef8858de857ee727$var$checkZoomBounds(customZoom || Math.min(scaleX, scaleY), minScale, maxScale, 0, false);
    var offsetX = (wrapperRect.width - nodeWidth * newScale) / 2;
    var offsetY = (wrapperRect.height - nodeHeight * newScale) / 2;
    var newPositionX = (wrapperRect.left - nodeLeft) * newScale + offsetX;
    var newPositionY = (wrapperRect.top - nodeTop) * newScale + offsetY;
    var bounds = $ef8858de857ee727$var$calculateBounds(contextInstance, newScale);
    var _b = $ef8858de857ee727$var$getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, 0, 0, wrapperComponent), x = _b.x, y = _b.y;
    return {
        positionX: x,
        positionY: y,
        scale: newScale
    };
}
var $ef8858de857ee727$var$zoomIn = function(contextInstance) {
    return function(step, animationTime, animationType) {
        if (step === void 0) step = 0.5;
        if (animationTime === void 0) animationTime = 300;
        if (animationType === void 0) animationType = "easeOut";
        $ef8858de857ee727$var$handleZoomToViewCenter(contextInstance, 1, step, animationTime, animationType);
    };
};
var $ef8858de857ee727$var$zoomOut = function(contextInstance) {
    return function(step, animationTime, animationType) {
        if (step === void 0) step = 0.5;
        if (animationTime === void 0) animationTime = 300;
        if (animationType === void 0) animationType = "easeOut";
        $ef8858de857ee727$var$handleZoomToViewCenter(contextInstance, -1, step, animationTime, animationType);
    };
};
var $ef8858de857ee727$var$setTransform = function(contextInstance) {
    return function(newPositionX, newPositionY, newScale, animationTime, animationType) {
        if (animationTime === void 0) animationTime = 300;
        if (animationType === void 0) animationType = "easeOut";
        var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY, scale = _a.scale;
        var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
        var disabled = contextInstance.setup.disabled;
        if (disabled || !wrapperComponent || !contentComponent) return;
        var targetState = {
            positionX: Number.isNaN(newPositionX) ? positionX : newPositionX,
            positionY: Number.isNaN(newPositionY) ? positionY : newPositionY,
            scale: Number.isNaN(newScale) ? scale : newScale
        };
        $ef8858de857ee727$var$animate(contextInstance, targetState, animationTime, animationType);
    };
};
var $ef8858de857ee727$var$resetTransform = function(contextInstance) {
    return function(animationTime, animationType) {
        if (animationTime === void 0) animationTime = 200;
        if (animationType === void 0) animationType = "easeOut";
        $ef8858de857ee727$var$resetTransformations(contextInstance, animationTime, animationType);
    };
};
var $ef8858de857ee727$var$centerView = function(contextInstance) {
    return function(scale, animationTime, animationType) {
        if (animationTime === void 0) animationTime = 200;
        if (animationType === void 0) animationType = "easeOut";
        var transformState = contextInstance.transformState, wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
        if (wrapperComponent && contentComponent) {
            var targetState = $ef8858de857ee727$export$a51b33620579dad4(scale || transformState.scale, wrapperComponent, contentComponent);
            $ef8858de857ee727$var$animate(contextInstance, targetState, animationTime, animationType);
        }
    };
};
var $ef8858de857ee727$var$zoomToElement = function(contextInstance) {
    return function(node, scale, animationTime, animationType) {
        if (animationTime === void 0) animationTime = 600;
        if (animationType === void 0) animationType = "easeOut";
        $ef8858de857ee727$var$handleCancelAnimation(contextInstance);
        var wrapperComponent = contextInstance.wrapperComponent;
        var target = typeof node === "string" ? document.getElementById(node) : node;
        if (wrapperComponent && target && wrapperComponent.contains(target)) {
            var targetState = $ef8858de857ee727$var$calculateZoomToNode(contextInstance, target, scale);
            $ef8858de857ee727$var$animate(contextInstance, targetState, animationTime, animationType);
        }
    };
};
var $ef8858de857ee727$var$getControls = function(contextInstance) {
    return {
        instance: contextInstance,
        zoomIn: $ef8858de857ee727$var$zoomIn(contextInstance),
        zoomOut: $ef8858de857ee727$var$zoomOut(contextInstance),
        setTransform: $ef8858de857ee727$var$setTransform(contextInstance),
        resetTransform: $ef8858de857ee727$var$resetTransform(contextInstance),
        centerView: $ef8858de857ee727$var$centerView(contextInstance),
        zoomToElement: $ef8858de857ee727$var$zoomToElement(contextInstance)
    };
};
var $ef8858de857ee727$var$getState = function(contextInstance) {
    return {
        instance: contextInstance,
        state: contextInstance.transformState
    };
};
var $ef8858de857ee727$var$getContext = function(contextInstance) {
    var ref = {};
    Object.assign(ref, $ef8858de857ee727$var$getState(contextInstance));
    Object.assign(ref, $ef8858de857ee727$var$getControls(contextInstance));
    return ref;
};
// We want to make event listeners non-passive, and to do so have to check
// that browsers support EventListenerOptions in the first place.
// https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
var $ef8858de857ee727$var$passiveSupported = false;
function $ef8858de857ee727$var$makePassiveEventOption() {
    try {
        var options = {
            get passive () {
                // This function will be called when the browser
                //   attempts to access the passive property.
                $ef8858de857ee727$var$passiveSupported = true;
                return false;
            }
        };
        return options;
    } catch (err) {
        $ef8858de857ee727$var$passiveSupported = false;
        return $ef8858de857ee727$var$passiveSupported;
    }
}
var $ef8858de857ee727$var$matchPrefix = ".".concat($ef8858de857ee727$var$baseClasses.wrapperClass);
var $ef8858de857ee727$var$isExcludedNode = function(node, excluded) {
    return excluded.some(function(exclude) {
        return node.matches("".concat($ef8858de857ee727$var$matchPrefix, " ").concat(exclude, ", ").concat($ef8858de857ee727$var$matchPrefix, " .").concat(exclude, ", ").concat($ef8858de857ee727$var$matchPrefix, " ").concat(exclude, " *, ").concat($ef8858de857ee727$var$matchPrefix, " .").concat(exclude, " *"));
    });
};
var $ef8858de857ee727$var$cancelTimeout = function(timeout) {
    if (timeout) clearTimeout(timeout);
};
var $ef8858de857ee727$export$c15ec262effbd456 = function(x, y, scale) {
    // Standard translate prevents blurry svg on the safari
    return "translate(".concat(x, "px, ").concat(y, "px) scale(").concat(scale, ")");
};
var $ef8858de857ee727$export$3b94f66093db6f05 = function(x, y, scale) {
    // The shorthand for matrix does not work for Safari hence the need to explicitly use matrix3d
    // Refer to https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/matrix
    var a = scale;
    var b = 0;
    var c = 0;
    var d = scale;
    var tx = x;
    var ty = y;
    return "matrix3d(".concat(a, ", ").concat(b, ", 0, 0, ").concat(c, ", ").concat(d, ", 0, 0, 0, 0, 1, 0, ").concat(tx, ", ").concat(ty, ", 0, 1)");
};
var $ef8858de857ee727$export$a51b33620579dad4 = function(scale, wrapperComponent, contentComponent) {
    var contentWidth = contentComponent.offsetWidth * scale;
    var contentHeight = contentComponent.offsetHeight * scale;
    var centerPositionX = (wrapperComponent.offsetWidth - contentWidth) / 2;
    var centerPositionY = (wrapperComponent.offsetHeight - contentHeight) / 2;
    return {
        scale: scale,
        positionX: centerPositionX,
        positionY: centerPositionY
    };
};
function $ef8858de857ee727$var$mergeRefs(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
var $ef8858de857ee727$var$isWheelAllowed = function(contextInstance, event) {
    var _a = contextInstance.setup.wheel, disabled = _a.disabled, wheelDisabled = _a.wheelDisabled, touchPadDisabled = _a.touchPadDisabled, excluded = _a.excluded;
    var isInitialized = contextInstance.isInitialized, isPanning = contextInstance.isPanning;
    var target = event.target;
    var isAllowed = isInitialized && !isPanning && !disabled && target;
    if (!isAllowed) return false;
    // Event ctrlKey detects if touchpad action is executing wheel or pinch gesture
    if (wheelDisabled && !event.ctrlKey) return false;
    if (touchPadDisabled && event.ctrlKey) return false;
    var isExcluded = $ef8858de857ee727$var$isExcludedNode(target, excluded);
    if (isExcluded) return false;
    return true;
};
var $ef8858de857ee727$var$getDeltaY = function(event) {
    if (event) return event.deltaY < 0 ? 1 : -1;
    return 0;
};
function $ef8858de857ee727$var$getDelta(event, customDelta) {
    var deltaY = $ef8858de857ee727$var$getDeltaY(event);
    var delta = $ef8858de857ee727$var$checkIsNumber(customDelta, deltaY);
    return delta;
}
function $ef8858de857ee727$var$getMousePosition(event, contentComponent, scale) {
    var contentRect = contentComponent.getBoundingClientRect();
    var mouseX = 0;
    var mouseY = 0;
    if ("clientX" in event) {
        // mouse position x, y over wrapper component
        mouseX = (event.clientX - contentRect.left) / scale;
        mouseY = (event.clientY - contentRect.top) / scale;
    } else {
        var touch = event.touches[0];
        mouseX = (touch.clientX - contentRect.left) / scale;
        mouseY = (touch.clientY - contentRect.top) / scale;
    }
    if (Number.isNaN(mouseX) || Number.isNaN(mouseY)) console.error("No mouse or touch offset found");
    return {
        x: mouseX,
        y: mouseY
    };
}
var $ef8858de857ee727$var$handleCalculateWheelZoom = function(contextInstance, delta, step, disable, getTarget) {
    var scale = contextInstance.transformState.scale;
    var wrapperComponent = contextInstance.wrapperComponent, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation, disablePadding = setup.disablePadding;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    if (!wrapperComponent) throw new Error("Wrapper is not mounted");
    var targetScale = scale + delta * step;
    if (getTarget) return targetScale;
    var paddingEnabled = disable ? false : !disabled;
    var newScale = $ef8858de857ee727$var$checkZoomBounds($ef8858de857ee727$var$roundNumber(targetScale, 3), minScale, maxScale, size, paddingEnabled && !disablePadding);
    return newScale;
};
var $ef8858de857ee727$var$handleWheelZoomStop = function(contextInstance, event) {
    var previousWheelEvent = contextInstance.previousWheelEvent;
    var scale = contextInstance.transformState.scale;
    var _a = contextInstance.setup, maxScale = _a.maxScale, minScale = _a.minScale;
    if (!previousWheelEvent) return false;
    if (scale < maxScale || scale > minScale) return true;
    if (Math.sign(previousWheelEvent.deltaY) !== Math.sign(event.deltaY)) return true;
    if (previousWheelEvent.deltaY > 0 && previousWheelEvent.deltaY < event.deltaY) return true;
    if (previousWheelEvent.deltaY < 0 && previousWheelEvent.deltaY > event.deltaY) return true;
    if (Math.sign(previousWheelEvent.deltaY) !== Math.sign(event.deltaY)) return true;
    return false;
};
var $ef8858de857ee727$var$isPinchStartAllowed = function(contextInstance, event) {
    var _a = contextInstance.setup.pinch, disabled = _a.disabled, excluded = _a.excluded;
    var isInitialized = contextInstance.isInitialized;
    var target = event.target;
    var isAllowed = isInitialized && !disabled && target;
    if (!isAllowed) return false;
    var isExcluded = $ef8858de857ee727$var$isExcludedNode(target, excluded);
    if (isExcluded) return false;
    return true;
};
var $ef8858de857ee727$var$isPinchAllowed = function(contextInstance) {
    var disabled = contextInstance.setup.pinch.disabled;
    var isInitialized = contextInstance.isInitialized, pinchStartDistance = contextInstance.pinchStartDistance;
    var isAllowed = isInitialized && !disabled && pinchStartDistance;
    if (!isAllowed) return false;
    return true;
};
var $ef8858de857ee727$var$calculateTouchMidPoint = function(event, scale, contentComponent) {
    var contentRect = contentComponent.getBoundingClientRect();
    var touches = event.touches;
    var firstPointX = $ef8858de857ee727$var$roundNumber(touches[0].clientX - contentRect.left, 5);
    var firstPointY = $ef8858de857ee727$var$roundNumber(touches[0].clientY - contentRect.top, 5);
    var secondPointX = $ef8858de857ee727$var$roundNumber(touches[1].clientX - contentRect.left, 5);
    var secondPointY = $ef8858de857ee727$var$roundNumber(touches[1].clientY - contentRect.top, 5);
    return {
        x: (firstPointX + secondPointX) / 2 / scale,
        y: (firstPointY + secondPointY) / 2 / scale
    };
};
var $ef8858de857ee727$var$getTouchDistance = function(event) {
    return Math.sqrt(Math.pow(event.touches[0].pageX - event.touches[1].pageX, 2) + Math.pow(event.touches[0].pageY - event.touches[1].pageY, 2));
};
var $ef8858de857ee727$var$calculatePinchZoom = function(contextInstance, currentDistance) {
    var pinchStartScale = contextInstance.pinchStartScale, pinchStartDistance = contextInstance.pinchStartDistance, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation, disablePadding = setup.disablePadding;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    if (!pinchStartScale || pinchStartDistance === null || !currentDistance) throw new Error("Pinch touches distance was not provided");
    if (currentDistance < 0) return contextInstance.transformState.scale;
    var touchProportion = currentDistance / pinchStartDistance;
    var scaleDifference = touchProportion * pinchStartScale;
    return $ef8858de857ee727$var$checkZoomBounds($ef8858de857ee727$var$roundNumber(scaleDifference, 2), minScale, maxScale, size, !disabled && !disablePadding);
};
var $ef8858de857ee727$var$wheelStopEventTime = 160;
var $ef8858de857ee727$var$wheelAnimationTime = 100;
var $ef8858de857ee727$var$handleWheelStart = function(contextInstance, event) {
    var _a = contextInstance.props, onWheelStart = _a.onWheelStart, onZoomStart = _a.onZoomStart;
    if (!contextInstance.wheelStopEventTimer) {
        $ef8858de857ee727$var$handleCancelAnimation(contextInstance);
        $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(contextInstance), event, onWheelStart);
        $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(contextInstance), event, onZoomStart);
    }
};
var $ef8858de857ee727$var$handleWheelZoom = function(contextInstance, event) {
    var _a = contextInstance.props, onWheel = _a.onWheel, onZoom = _a.onZoom;
    var contentComponent = contextInstance.contentComponent, setup = contextInstance.setup, transformState = contextInstance.transformState;
    var scale = transformState.scale;
    var limitToBounds = setup.limitToBounds, centerZoomedOut = setup.centerZoomedOut, zoomAnimation = setup.zoomAnimation, wheel = setup.wheel, disablePadding = setup.disablePadding, smooth = setup.smooth;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    var step = wheel.step, smoothStep = wheel.smoothStep;
    if (!contentComponent) throw new Error("Component not mounted");
    event.preventDefault();
    event.stopPropagation();
    var delta = $ef8858de857ee727$var$getDelta(event, null);
    var zoomStep = smooth ? smoothStep * Math.abs(event.deltaY) : step;
    var newScale = $ef8858de857ee727$var$handleCalculateWheelZoom(contextInstance, delta, zoomStep, !event.ctrlKey);
    // if scale not change
    if (scale === newScale) return;
    var bounds = $ef8858de857ee727$var$handleCalculateBounds(contextInstance, newScale);
    var mousePosition = $ef8858de857ee727$var$getMousePosition(event, contentComponent, scale);
    var isPaddingDisabled = disabled || size === 0 || centerZoomedOut || disablePadding;
    var isLimitedToBounds = limitToBounds && isPaddingDisabled;
    var _b = $ef8858de857ee727$var$handleCalculateZoomPositions(contextInstance, mousePosition.x, mousePosition.y, newScale, bounds, isLimitedToBounds), x = _b.x, y = _b.y;
    contextInstance.previousWheelEvent = event;
    contextInstance.setTransformState(newScale, x, y);
    $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(contextInstance), event, onWheel);
    $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(contextInstance), event, onZoom);
};
var $ef8858de857ee727$var$handleWheelStop = function(contextInstance, event) {
    var _a = contextInstance.props, onWheelStop = _a.onWheelStop, onZoomStop = _a.onZoomStop;
    // fire animation
    $ef8858de857ee727$var$cancelTimeout(contextInstance.wheelAnimationTimer);
    contextInstance.wheelAnimationTimer = setTimeout(function() {
        if (!contextInstance.mounted) return;
        $ef8858de857ee727$var$handleAlignToScaleBounds(contextInstance, event.x, event.y);
        contextInstance.wheelAnimationTimer = null;
    }, $ef8858de857ee727$var$wheelAnimationTime);
    // Wheel stop event
    var hasStoppedZooming = $ef8858de857ee727$var$handleWheelZoomStop(contextInstance, event);
    if (hasStoppedZooming) {
        $ef8858de857ee727$var$cancelTimeout(contextInstance.wheelStopEventTimer);
        contextInstance.wheelStopEventTimer = setTimeout(function() {
            if (!contextInstance.mounted) return;
            contextInstance.wheelStopEventTimer = null;
            $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(contextInstance), event, onWheelStop);
            $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(contextInstance), event, onZoomStop);
        }, $ef8858de857ee727$var$wheelStopEventTime);
    }
};
var $ef8858de857ee727$var$getTouchCenter = function(event) {
    var totalX = 0;
    var totalY = 0;
    // Sum up the positions of all touches
    for(var i = 0; i < 2; i += 1){
        totalX += event.touches[i].clientX;
        totalY += event.touches[i].clientY;
    }
    // Calculate the average position
    var x = totalX / 2;
    var y = totalY / 2;
    return {
        x: x,
        y: y
    };
};
var $ef8858de857ee727$var$handlePinchStart = function(contextInstance, event) {
    var distance = $ef8858de857ee727$var$getTouchDistance(event);
    contextInstance.pinchStartDistance = distance;
    contextInstance.lastDistance = distance;
    contextInstance.pinchStartScale = contextInstance.transformState.scale;
    contextInstance.isPanning = false;
    var center = $ef8858de857ee727$var$getTouchCenter(event);
    contextInstance.pinchLastCenterX = center.x;
    contextInstance.pinchLastCenterY = center.y;
    $ef8858de857ee727$var$handleCancelAnimation(contextInstance);
};
var $ef8858de857ee727$var$handlePinchZoom = function(contextInstance, event) {
    var contentComponent = contextInstance.contentComponent, pinchStartDistance = contextInstance.pinchStartDistance, wrapperComponent = contextInstance.wrapperComponent;
    var scale = contextInstance.transformState.scale;
    var _a = contextInstance.setup, limitToBounds = _a.limitToBounds, centerZoomedOut = _a.centerZoomedOut, zoomAnimation = _a.zoomAnimation, alignmentAnimation = _a.alignmentAnimation;
    var disabled = zoomAnimation.disabled, size = zoomAnimation.size;
    // if one finger starts from outside of wrapper
    if (pinchStartDistance === null || !contentComponent) return;
    var midPoint = $ef8858de857ee727$var$calculateTouchMidPoint(event, scale, contentComponent);
    // if touches goes off of the wrapper element
    if (!Number.isFinite(midPoint.x) || !Number.isFinite(midPoint.y)) return;
    var currentDistance = $ef8858de857ee727$var$getTouchDistance(event);
    var newScale = $ef8858de857ee727$var$calculatePinchZoom(contextInstance, currentDistance);
    var center = $ef8858de857ee727$var$getTouchCenter(event);
    // pan should be scale invariant.
    var panX = center.x - (contextInstance.pinchLastCenterX || 0);
    var panY = center.y - (contextInstance.pinchLastCenterY || 0);
    if (newScale === scale && panX === 0 && panY === 0) return;
    contextInstance.pinchLastCenterX = center.x;
    contextInstance.pinchLastCenterY = center.y;
    var bounds = $ef8858de857ee727$var$handleCalculateBounds(contextInstance, newScale);
    var isPaddingDisabled = disabled || size === 0 || centerZoomedOut;
    var isLimitedToBounds = limitToBounds && isPaddingDisabled;
    var _b = $ef8858de857ee727$var$handleCalculateZoomPositions(contextInstance, midPoint.x, midPoint.y, newScale, bounds, isLimitedToBounds), x = _b.x, y = _b.y;
    contextInstance.pinchMidpoint = midPoint;
    contextInstance.lastDistance = currentDistance;
    var sizeX = alignmentAnimation.sizeX, sizeY = alignmentAnimation.sizeY;
    var paddingValueX = $ef8858de857ee727$var$getPaddingValue(contextInstance, sizeX);
    var paddingValueY = $ef8858de857ee727$var$getPaddingValue(contextInstance, sizeY);
    var newPositionX = x + panX;
    var newPositionY = y + panY;
    var _c = $ef8858de857ee727$var$getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent), finalX = _c.x, finalY = _c.y;
    contextInstance.setTransformState(newScale, finalX, finalY);
};
var $ef8858de857ee727$var$handlePinchStop = function(contextInstance) {
    var pinchMidpoint = contextInstance.pinchMidpoint;
    contextInstance.velocity = null;
    contextInstance.lastDistance = null;
    contextInstance.pinchMidpoint = null;
    contextInstance.pinchStartScale = null;
    contextInstance.pinchStartDistance = null;
    $ef8858de857ee727$var$handleAlignToScaleBounds(contextInstance, pinchMidpoint === null || pinchMidpoint === void 0 ? void 0 : pinchMidpoint.x, pinchMidpoint === null || pinchMidpoint === void 0 ? void 0 : pinchMidpoint.y);
};
var $ef8858de857ee727$var$handleDoubleClickStop = function(contextInstance, event) {
    var onZoomStop = contextInstance.props.onZoomStop;
    var animationTime = contextInstance.setup.doubleClick.animationTime;
    $ef8858de857ee727$var$cancelTimeout(contextInstance.doubleClickStopEventTimer);
    contextInstance.doubleClickStopEventTimer = setTimeout(function() {
        contextInstance.doubleClickStopEventTimer = null;
        $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(contextInstance), event, onZoomStop);
    }, animationTime);
};
var $ef8858de857ee727$var$handleDoubleClickResetMode = function(contextInstance, event) {
    var _a = contextInstance.props, onZoomStart = _a.onZoomStart, onZoom = _a.onZoom;
    var _b = contextInstance.setup.doubleClick, animationTime = _b.animationTime, animationType = _b.animationType;
    $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(contextInstance), event, onZoomStart);
    $ef8858de857ee727$var$resetTransformations(contextInstance, animationTime, animationType, function() {
        return $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(contextInstance), event, onZoom);
    });
    $ef8858de857ee727$var$handleDoubleClickStop(contextInstance, event);
};
function $ef8858de857ee727$var$getDoubleClickScale(mode, scale) {
    if (mode === "toggle") return scale === 1 ? 1 : -1;
    return mode === "zoomOut" ? -1 : 1;
}
function $ef8858de857ee727$var$handleDoubleClick(contextInstance, event) {
    var setup = contextInstance.setup, doubleClickStopEventTimer = contextInstance.doubleClickStopEventTimer, transformState = contextInstance.transformState, contentComponent = contextInstance.contentComponent;
    var scale = transformState.scale;
    var _a = contextInstance.props, onZoomStart = _a.onZoomStart, onZoom = _a.onZoom;
    var _b = setup.doubleClick, disabled = _b.disabled, mode = _b.mode, step = _b.step, animationTime = _b.animationTime, animationType = _b.animationType;
    if (disabled) return;
    if (doubleClickStopEventTimer) return;
    if (mode === "reset") return $ef8858de857ee727$var$handleDoubleClickResetMode(contextInstance, event);
    if (!contentComponent) return console.error("No ContentComponent found");
    var delta = $ef8858de857ee727$var$getDoubleClickScale(mode, contextInstance.transformState.scale);
    var newScale = $ef8858de857ee727$var$handleCalculateButtonZoom(contextInstance, delta, step);
    // stop execution when scale didn't change
    if (scale === newScale) return;
    $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(contextInstance), event, onZoomStart);
    var mousePosition = $ef8858de857ee727$var$getMousePosition(event, contentComponent, scale);
    var targetState = $ef8858de857ee727$var$handleZoomToPoint(contextInstance, newScale, mousePosition.x, mousePosition.y);
    if (!targetState) return console.error("Error during zoom event. New transformation state was not calculated.");
    $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(contextInstance), event, onZoom);
    $ef8858de857ee727$var$animate(contextInstance, targetState, animationTime, animationType);
    $ef8858de857ee727$var$handleDoubleClickStop(contextInstance, event);
}
var $ef8858de857ee727$var$isDoubleClickAllowed = function(contextInstance, event) {
    var isInitialized = contextInstance.isInitialized, setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var _a = setup.doubleClick, disabled = _a.disabled, excluded = _a.excluded;
    var target = event.target;
    var isWrapperChild = wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(target);
    var isAllowed = isInitialized && target && isWrapperChild && !disabled;
    if (!isAllowed) return false;
    var isExcluded = $ef8858de857ee727$var$isExcludedNode(target, excluded);
    if (isExcluded) return false;
    return true;
};
var $ef8858de857ee727$var$ZoomPanPinch = /** @class */ function() {
    function ZoomPanPinch(props) {
        var _this = this;
        this.mounted = true;
        this.pinchLastCenterX = null;
        this.pinchLastCenterY = null;
        this.onChangeCallbacks = new Set();
        this.onInitCallbacks = new Set();
        // Components
        this.wrapperComponent = null;
        this.contentComponent = null;
        // Initialization
        this.isInitialized = false;
        this.bounds = null;
        // wheel helpers
        this.previousWheelEvent = null;
        this.wheelStopEventTimer = null;
        this.wheelAnimationTimer = null;
        // panning helpers
        this.isPanning = false;
        this.isWheelPanning = false;
        this.startCoords = null;
        this.lastTouch = null;
        // pinch helpers
        this.distance = null;
        this.lastDistance = null;
        this.pinchStartDistance = null;
        this.pinchStartScale = null;
        this.pinchMidpoint = null;
        // double click helpers
        this.doubleClickStopEventTimer = null;
        // velocity helpers
        this.velocity = null;
        this.velocityTime = null;
        this.lastMousePosition = null;
        // animations helpers
        this.animate = false;
        this.animation = null;
        this.maxBounds = null;
        // key press
        this.pressedKeys = {};
        this.mount = function() {
            _this.initializeWindowEvents();
        };
        this.unmount = function() {
            _this.cleanupWindowEvents();
        };
        this.update = function(newProps) {
            _this.props = newProps;
            $ef8858de857ee727$var$handleCalculateBounds(_this, _this.transformState.scale);
            _this.setup = $ef8858de857ee727$var$createSetup(newProps);
        };
        this.initializeWindowEvents = function() {
            var _a, _b;
            var passive = $ef8858de857ee727$var$makePassiveEventOption();
            var currentDocument = (_a = _this.wrapperComponent) === null || _a === void 0 ? void 0 : _a.ownerDocument;
            var currentWindow = currentDocument === null || currentDocument === void 0 ? void 0 : currentDocument.defaultView;
            (_b = _this.wrapperComponent) === null || _b === void 0 || _b.addEventListener("wheel", _this.onWheelPanning, passive);
            // Panning on window to allow panning when mouse is out of component wrapper
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("mousedown", _this.onPanningStart, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("mousemove", _this.onPanning, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("mouseup", _this.onPanningStop, passive);
            currentDocument === null || currentDocument === void 0 || currentDocument.addEventListener("mouseleave", _this.clearPanning, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("keyup", _this.setKeyUnPressed, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("keydown", _this.setKeyPressed, passive);
        };
        this.cleanupWindowEvents = function() {
            var _a, _b;
            var passive = $ef8858de857ee727$var$makePassiveEventOption();
            var currentDocument = (_a = _this.wrapperComponent) === null || _a === void 0 ? void 0 : _a.ownerDocument;
            var currentWindow = currentDocument === null || currentDocument === void 0 ? void 0 : currentDocument.defaultView;
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("mousedown", _this.onPanningStart, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("mousemove", _this.onPanning, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("mouseup", _this.onPanningStop, passive);
            currentDocument === null || currentDocument === void 0 || currentDocument.removeEventListener("mouseleave", _this.clearPanning, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("keyup", _this.setKeyUnPressed, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("keydown", _this.setKeyPressed, passive);
            document.removeEventListener("mouseleave", _this.clearPanning, passive);
            $ef8858de857ee727$var$handleCancelAnimation(_this);
            (_b = _this.observer) === null || _b === void 0 || _b.disconnect();
        };
        this.handleInitializeWrapperEvents = function(wrapper) {
            // Zooming events on wrapper
            var passive = $ef8858de857ee727$var$makePassiveEventOption();
            wrapper.addEventListener("wheel", _this.onWheelZoom, passive);
            wrapper.addEventListener("dblclick", _this.onDoubleClick, passive);
            wrapper.addEventListener("touchstart", _this.onTouchPanningStart, passive);
            wrapper.addEventListener("touchmove", _this.onTouchPanning, passive);
            wrapper.addEventListener("touchend", _this.onTouchPanningStop, passive);
        };
        this.handleInitialize = function(contentComponent) {
            var centerOnInit = _this.setup.centerOnInit;
            _this.applyTransformation();
            _this.onInitCallbacks.forEach(function(callback) {
                return callback($ef8858de857ee727$var$getContext(_this));
            });
            if (centerOnInit) {
                _this.setCenter();
                _this.observer = new ResizeObserver(function() {
                    var _a;
                    var currentWidth = contentComponent.offsetWidth;
                    var currentHeight = contentComponent.offsetHeight;
                    if (currentWidth > 0 || currentHeight > 0) {
                        _this.onInitCallbacks.forEach(function(callback) {
                            return callback($ef8858de857ee727$var$getContext(_this));
                        });
                        _this.setCenter();
                        (_a = _this.observer) === null || _a === void 0 || _a.disconnect();
                    }
                });
                // if nothing about the contentComponent has changed after 5 seconds, disconnect the observer
                setTimeout(function() {
                    var _a;
                    (_a = _this.observer) === null || _a === void 0 || _a.disconnect();
                }, 5000);
                // Start observing the target node for configured mutations
                _this.observer.observe(contentComponent);
            }
        };
        /// ///////
        // Zoom
        /// ///////
        this.onWheelZoom = function(event) {
            var disabled = _this.setup.disabled;
            if (disabled) return;
            var isAllowed = $ef8858de857ee727$var$isWheelAllowed(_this, event);
            if (!isAllowed) return;
            var keysPressed = _this.isPressingKeys(_this.setup.wheel.activationKeys);
            if (!keysPressed) return;
            $ef8858de857ee727$var$handleWheelStart(_this, event);
            $ef8858de857ee727$var$handleWheelZoom(_this, event);
            $ef8858de857ee727$var$handleWheelStop(_this, event);
        };
        /// ///////
        // Pan
        /// ///////
        this.onWheelPanning = function(event) {
            var _a = _this.setup, disabled = _a.disabled, wheel = _a.wheel, panning = _a.panning;
            if (!_this.wrapperComponent || !_this.contentComponent || disabled || !wheel.wheelDisabled || panning.disabled || !panning.wheelPanning || event.ctrlKey) return;
            event.preventDefault();
            event.stopPropagation();
            var _b = _this.transformState, positionX = _b.positionX, positionY = _b.positionY;
            var mouseX = positionX - event.deltaX;
            var mouseY = positionY - event.deltaY;
            var newPositionX = panning.lockAxisX ? positionX : mouseX;
            var newPositionY = panning.lockAxisY ? positionY : mouseY;
            var _c = _this.setup.alignmentAnimation, sizeX = _c.sizeX, sizeY = _c.sizeY;
            var paddingValueX = $ef8858de857ee727$var$getPaddingValue(_this, sizeX);
            var paddingValueY = $ef8858de857ee727$var$getPaddingValue(_this, sizeY);
            if (newPositionX === positionX && newPositionY === positionY) return;
            $ef8858de857ee727$var$handleNewPosition(_this, newPositionX, newPositionY, paddingValueX, paddingValueY);
        };
        this.onPanningStart = function(event) {
            var disabled = _this.setup.disabled;
            var onPanningStart = _this.props.onPanningStart;
            if (disabled) return;
            var isAllowed = $ef8858de857ee727$var$isPanningStartAllowed(_this, event);
            if (!isAllowed) return;
            var keysPressed = _this.isPressingKeys(_this.setup.panning.activationKeys);
            if (!keysPressed) return;
            if (event.button === 0 && !_this.setup.panning.allowLeftClickPan) return;
            if (event.button === 1 && !_this.setup.panning.allowMiddleClickPan) return;
            if (event.button === 2 && !_this.setup.panning.allowRightClickPan) return;
            event.preventDefault();
            event.stopPropagation();
            $ef8858de857ee727$var$handleCancelAnimation(_this);
            $ef8858de857ee727$var$handlePanningStart(_this, event);
            $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(_this), event, onPanningStart);
        };
        this.onPanning = function(event) {
            var disabled = _this.setup.disabled;
            var onPanning = _this.props.onPanning;
            if (disabled) return;
            var isAllowed = $ef8858de857ee727$var$isPanningAllowed(_this);
            if (!isAllowed) return;
            var keysPressed = _this.isPressingKeys(_this.setup.panning.activationKeys);
            if (!keysPressed) return;
            event.preventDefault();
            event.stopPropagation();
            $ef8858de857ee727$var$handlePanning(_this, event.clientX, event.clientY);
            $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(_this), event, onPanning);
        };
        this.onPanningStop = function(event) {
            var onPanningStop = _this.props.onPanningStop;
            if (_this.isPanning) {
                $ef8858de857ee727$var$handlePanningEnd(_this);
                $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(_this), event, onPanningStop);
            }
        };
        /// ///////
        // Pinch
        /// ///////
        this.onPinchStart = function(event) {
            var disabled = _this.setup.disabled;
            var _a = _this.props, onPinchingStart = _a.onPinchingStart, onZoomStart = _a.onZoomStart;
            if (disabled) return;
            var isAllowed = $ef8858de857ee727$var$isPinchStartAllowed(_this, event);
            if (!isAllowed) return;
            $ef8858de857ee727$var$handlePinchStart(_this, event);
            $ef8858de857ee727$var$handleCancelAnimation(_this);
            $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(_this), event, onPinchingStart);
            $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(_this), event, onZoomStart);
        };
        this.onPinch = function(event) {
            var disabled = _this.setup.disabled;
            var _a = _this.props, onPinching = _a.onPinching, onZoom = _a.onZoom;
            if (disabled) return;
            var isAllowed = $ef8858de857ee727$var$isPinchAllowed(_this);
            if (!isAllowed) return;
            event.preventDefault();
            event.stopPropagation();
            $ef8858de857ee727$var$handlePinchZoom(_this, event);
            $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(_this), event, onPinching);
            $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(_this), event, onZoom);
        };
        this.onPinchStop = function(event) {
            var _a = _this.props, onPinchingStop = _a.onPinchingStop, onZoomStop = _a.onZoomStop;
            if (_this.pinchStartScale) {
                $ef8858de857ee727$var$handlePinchStop(_this);
                $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(_this), event, onPinchingStop);
                $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(_this), event, onZoomStop);
            }
        };
        /// ///////
        // Touch
        /// ///////
        this.onTouchPanningStart = function(event) {
            var disabled = _this.setup.disabled;
            var onPanningStart = _this.props.onPanningStart;
            if (disabled) return;
            var isAllowed = $ef8858de857ee727$var$isPanningStartAllowed(_this, event);
            if (!isAllowed) return;
            var isDoubleTap = _this.lastTouch && +new Date() - _this.lastTouch < 200;
            if (!isDoubleTap) {
                _this.lastTouch = +new Date();
                $ef8858de857ee727$var$handleCancelAnimation(_this);
                var touches = event.touches;
                var isPanningAction = touches.length === 1;
                var isPinchAction = touches.length === 2;
                if (isPanningAction) {
                    $ef8858de857ee727$var$handleCancelAnimation(_this);
                    $ef8858de857ee727$var$handlePanningStart(_this, event);
                    $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(_this), event, onPanningStart);
                }
                if (isPinchAction) _this.onPinchStart(event);
            }
        };
        this.onTouchPanning = function(event) {
            var disabled = _this.setup.disabled;
            var onPanning = _this.props.onPanning;
            if (_this.isPanning && event.touches.length === 1) {
                if (disabled) return;
                var isAllowed = $ef8858de857ee727$var$isPanningAllowed(_this);
                if (!isAllowed) return;
                event.preventDefault();
                event.stopPropagation();
                var touch = event.touches[0];
                $ef8858de857ee727$var$handlePanning(_this, touch.clientX, touch.clientY);
                $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(_this), event, onPanning);
            } else if (event.touches.length > 1) _this.onPinch(event);
        };
        this.onTouchPanningStop = function(event) {
            _this.onPanningStop(event);
            _this.onPinchStop(event);
        };
        /// ///////
        // Double Click
        /// ///////
        this.onDoubleClick = function(event) {
            var disabled = _this.setup.disabled;
            if (disabled) return;
            var isAllowed = $ef8858de857ee727$var$isDoubleClickAllowed(_this, event);
            if (!isAllowed) return;
            $ef8858de857ee727$var$handleDoubleClick(_this, event);
        };
        /// ///////
        // Helpers
        /// ///////
        this.clearPanning = function(event) {
            if (_this.isPanning) _this.onPanningStop(event);
        };
        this.setKeyPressed = function(e) {
            _this.pressedKeys[e.key] = true;
        };
        this.setKeyUnPressed = function(e) {
            _this.pressedKeys[e.key] = false;
        };
        this.isPressingKeys = function(keys) {
            if (!keys.length) return true;
            return Boolean(keys.find(function(key) {
                return _this.pressedKeys[key];
            }));
        };
        this.setTransformState = function(scale, positionX, positionY) {
            var onTransformed = _this.props.onTransformed;
            if (!Number.isNaN(scale) && !Number.isNaN(positionX) && !Number.isNaN(positionY)) {
                if (scale !== _this.transformState.scale) {
                    _this.transformState.previousScale = _this.transformState.scale;
                    _this.transformState.scale = scale;
                }
                _this.transformState.positionX = positionX;
                _this.transformState.positionY = positionY;
                _this.applyTransformation();
                var ctx_1 = $ef8858de857ee727$var$getContext(_this);
                _this.onChangeCallbacks.forEach(function(callback) {
                    return callback(ctx_1);
                });
                $ef8858de857ee727$var$handleCallback(ctx_1, {
                    scale: scale,
                    positionX: positionX,
                    positionY: positionY
                }, onTransformed);
            } else console.error("Detected NaN set state values");
        };
        this.setCenter = function() {
            if (_this.wrapperComponent && _this.contentComponent) {
                var targetState = $ef8858de857ee727$export$a51b33620579dad4(_this.transformState.scale, _this.wrapperComponent, _this.contentComponent);
                _this.setTransformState(targetState.scale, targetState.positionX, targetState.positionY);
            }
        };
        this.handleTransformStyles = function(x, y, scale) {
            if (_this.props.customTransform) return _this.props.customTransform(x, y, scale);
            return $ef8858de857ee727$export$c15ec262effbd456(x, y, scale);
        };
        this.applyTransformation = function() {
            if (!_this.mounted || !_this.contentComponent) return;
            var _a = _this.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
            var transform = _this.handleTransformStyles(positionX, positionY, scale);
            _this.contentComponent.style.transform = transform;
        };
        this.getContext = function() {
            return $ef8858de857ee727$var$getContext(_this);
        };
        /**
         * Hooks
         */ this.onChange = function(callback) {
            if (!_this.onChangeCallbacks.has(callback)) _this.onChangeCallbacks.add(callback);
            return function() {
                _this.onChangeCallbacks.delete(callback);
            };
        };
        this.onInit = function(callback) {
            if (!_this.onInitCallbacks.has(callback)) _this.onInitCallbacks.add(callback);
            return function() {
                _this.onInitCallbacks.delete(callback);
            };
        };
        /**
         * Initialization
         */ this.init = function(wrapperComponent, contentComponent) {
            _this.cleanupWindowEvents();
            _this.wrapperComponent = wrapperComponent;
            _this.contentComponent = contentComponent;
            $ef8858de857ee727$var$handleCalculateBounds(_this, _this.transformState.scale);
            _this.handleInitializeWrapperEvents(wrapperComponent);
            _this.handleInitialize(contentComponent);
            _this.initializeWindowEvents();
            _this.isInitialized = true;
            var ctx = $ef8858de857ee727$var$getContext(_this);
            $ef8858de857ee727$var$handleCallback(ctx, undefined, _this.props.onInit);
        };
        this.props = props;
        this.setup = $ef8858de857ee727$var$createSetup(this.props);
        this.transformState = $ef8858de857ee727$var$createState(this.props);
    }
    return ZoomPanPinch;
}();
var $ef8858de857ee727$export$841858b892ce1f4c = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createContext(null);
var $ef8858de857ee727$var$getContent = function(children, ctx) {
    if (typeof children === "function") return children(ctx);
    return children;
};
var $ef8858de857ee727$export$51cb649375dcd655 = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function(props, ref) {
    var instance = (0, $1oC0p.useRef)(new $ef8858de857ee727$var$ZoomPanPinch(props)).current;
    var content = $ef8858de857ee727$var$getContent(props.children, $ef8858de857ee727$var$getControls(instance));
    (0, $1oC0p.useImperativeHandle)(ref, function() {
        return $ef8858de857ee727$var$getControls(instance);
    }, [
        instance
    ]);
    (0, $1oC0p.useEffect)(function() {
        instance.update(props);
    }, [
        instance,
        props
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($ef8858de857ee727$export$841858b892ce1f4c.Provider, {
        value: instance
    }, content);
});
var $ef8858de857ee727$export$cbc53e226f857b23 = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function(props, ref) {
    var localRef = (0, $1oC0p.useRef)(null);
    var instance = (0, $1oC0p.useContext)($ef8858de857ee727$export$841858b892ce1f4c);
    (0, $1oC0p.useEffect)(function() {
        return instance.onChange(function(ctx) {
            if (localRef.current) {
                var positionX = 0;
                var positionY = 0;
                localRef.current.style.transform = instance.handleTransformStyles(positionX, positionY, 1 / ctx.instance.transformState.scale);
            }
        });
    }, [
        instance
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", $ef8858de857ee727$var$__assign({}, props, {
        ref: $ef8858de857ee727$var$mergeRefs([
            localRef,
            ref
        ])
    }));
});
var $ef8858de857ee727$var$initialElementRect = {
    width: 0,
    height: 0,
    y: 0,
    x: 0,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
};
var $ef8858de857ee727$var$useResize = function(ref, onResize, dependencies) {
    var resizeObserverRef = (0, $1oC0p.useRef)();
    var rectRef = (0, $1oC0p.useRef)($ef8858de857ee727$var$initialElementRect);
    var didUnmount = (0, $1oC0p.useRef)(false);
    (0, $1oC0p.useLayoutEffect)(function() {
        var _a;
        didUnmount.current = false;
        if (!("ResizeObserver" in window)) return;
        if (ref) {
            resizeObserverRef.current = new ResizeObserver(function(entries) {
                var newSize = ref.getBoundingClientRect();
                if (!Array.isArray(entries) || !entries.length || didUnmount.current || newSize.width === rectRef.current.width && newSize.height === rectRef.current.height) return;
                onResize(newSize, ref);
                rectRef.current = newSize;
            });
            (_a = resizeObserverRef.current) === null || _a === void 0 || _a.observe(ref);
        }
        return function() {
            var _a;
            didUnmount.current = true;
            if (ref) (_a = resizeObserverRef.current) === null || _a === void 0 || _a.unobserve(ref);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $ef8858de857ee727$var$__spreadArray([
        onResize,
        ref
    ], dependencies, true));
};
var $ef8858de857ee727$var$previewStyles = {
    position: "absolute",
    zIndex: 2,
    top: "0px",
    left: "0px",
    boxSizing: "border-box",
    border: "3px solid red",
    transformOrigin: "0% 0%",
    boxShadow: "rgba(0,0,0,0.2) 0 0 0 10000000px"
};
var $ef8858de857ee727$export$a97dd8f3835953ef = function(_a) {
    var _b = _a.width, width = _b === void 0 ? 200 : _b, _c = _a.height, height = _c === void 0 ? 200 : _c, _d = _a.borderColor, borderColor = _d === void 0 ? "red" : _d, children = _a.children, rest = $ef8858de857ee727$var$__rest(_a, [
        "width",
        "height",
        "borderColor",
        "children"
    ]);
    var _e = (0, $1oC0p.useState)(false), initialized = _e[0], setInitialized = _e[1];
    var instance = $ef8858de857ee727$export$1708b11af87412f8();
    var miniMapInstance = (0, $1oC0p.useRef)(null);
    var mainRef = (0, $1oC0p.useRef)(null);
    var wrapperRef = (0, $1oC0p.useRef)(null);
    var previewRef = (0, $1oC0p.useRef)(null);
    var getViewportSize = (0, $1oC0p.useCallback)(function() {
        if (instance.wrapperComponent) {
            var rect = instance.wrapperComponent.getBoundingClientRect();
            return {
                width: rect.width,
                height: rect.height
            };
        }
        return {
            width: 0,
            height: 0
        };
    }, [
        instance.wrapperComponent
    ]);
    var getContentSize = (0, $1oC0p.useCallback)(function() {
        if (instance.contentComponent) {
            var rect = instance.contentComponent.getBoundingClientRect();
            return {
                width: rect.width / instance.transformState.scale,
                height: rect.height / instance.transformState.scale
            };
        }
        return {
            width: 0,
            height: 0
        };
    }, [
        instance.contentComponent,
        instance.transformState.scale
    ]);
    var computeMiniMapScale = (0, $1oC0p.useCallback)(function() {
        var contentSize = getContentSize();
        var scaleX = width / contentSize.width;
        var scaleY = height / contentSize.height;
        var scale = scaleY > scaleX ? scaleX : scaleY;
        return scale;
    }, [
        getContentSize,
        height,
        width
    ]);
    var computeMiniMapSize = function() {
        var contentSize = getContentSize();
        var scaleX = width / contentSize.width;
        var scaleY = height / contentSize.height;
        if (scaleY > scaleX) return {
            width: width,
            height: contentSize.height * scaleX
        };
        return {
            width: contentSize.width * scaleY,
            height: height
        };
    };
    var computeMiniMapStyle = function() {
        var scale = computeMiniMapScale();
        var style = {
            transform: "scale(".concat(scale || 1, ")"),
            transformOrigin: "0% 0%",
            position: "absolute",
            boxSizing: "border-box",
            zIndex: 1,
            overflow: "hidden"
        };
        Object.keys(style).forEach(function(key) {
            if (wrapperRef.current) wrapperRef.current.style[key] = style[key];
        });
    };
    var transformMiniMap = function() {
        computeMiniMapStyle();
        var miniSize = computeMiniMapSize();
        var wrapSize = getContentSize();
        if (wrapperRef.current) {
            wrapperRef.current.style.width = "".concat(wrapSize.width, "px");
            wrapperRef.current.style.height = "".concat(wrapSize.height, "px");
        }
        if (mainRef.current) {
            mainRef.current.style.width = "".concat(miniSize.width, "px");
            mainRef.current.style.height = "".concat(miniSize.height, "px");
        }
        if (previewRef.current) {
            var size = getViewportSize();
            var scale = computeMiniMapScale();
            var previewScale = scale * (1 / instance.transformState.scale);
            var transform = instance.handleTransformStyles(-instance.transformState.positionX * previewScale, -instance.transformState.positionY * previewScale, 1);
            previewRef.current.style.transform = transform;
            previewRef.current.style.width = "".concat(size.width * previewScale, "px");
            previewRef.current.style.height = "".concat(size.height * previewScale, "px");
        }
    };
    var initialize = function() {
        transformMiniMap();
    };
    $ef8858de857ee727$export$769cca75086a299c(function() {
        transformMiniMap();
    });
    $ef8858de857ee727$export$e14839139473133b(function() {
        initialize();
        setInitialized(true);
    });
    $ef8858de857ee727$var$useResize(instance.contentComponent, initialize, [
        initialized
    ]);
    (0, $1oC0p.useEffect)(function() {
        return instance.onChange(function(zpp) {
            var scale = computeMiniMapScale();
            if (miniMapInstance.current) {
                miniMapInstance.current.instance.transformState.scale = zpp.instance.transformState.scale;
                miniMapInstance.current.instance.transformState.positionX = zpp.instance.transformState.positionX * scale;
                miniMapInstance.current.instance.transformState.positionY = zpp.instance.transformState.positionY * scale;
            }
        });
    }, [
        computeMiniMapScale,
        instance,
        miniMapInstance
    ]);
    var wrapperStyle = (0, $1oC0p.useMemo)(function() {
        return {
            position: "relative",
            zIndex: 2,
            overflow: "hidden"
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", $ef8858de857ee727$var$__assign({}, rest, {
        ref: mainRef,
        style: wrapperStyle,
        className: "rzpp-mini-map ".concat(rest.className || "")
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", $ef8858de857ee727$var$__assign({}, rest, {
        ref: wrapperRef,
        className: "rzpp-wrapper"
    }), children), (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        className: "rzpp-preview",
        ref: previewRef,
        style: $ef8858de857ee727$var$__assign($ef8858de857ee727$var$__assign({}, $ef8858de857ee727$var$previewStyles), {
            borderColor: borderColor
        })
    }));
};
function $ef8858de857ee727$var$styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === 'undefined') return;
    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';
    if (insertAt === 'top') {
        if (head.firstChild) head.insertBefore(style, head.firstChild);
        else head.appendChild(style);
    } else head.appendChild(style);
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild(document.createTextNode(css));
}
var $ef8858de857ee727$var$css_248z = ".transform-component-module_wrapper__SPB86 {\n  position: relative;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  overflow: hidden;\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Safari */\n  -khtml-user-select: none; /* Konqueror HTML */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n  margin: 0;\n  padding: 0;\n}\n.transform-component-module_content__FBWxo {\n  display: flex;\n  flex-wrap: wrap;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  margin: 0;\n  padding: 0;\n  transform-origin: 0% 0%;\n}\n.transform-component-module_content__FBWxo img {\n  pointer-events: none;\n}\n";
var $ef8858de857ee727$var$styles = {
    "wrapper": "transform-component-module_wrapper__SPB86",
    "content": "transform-component-module_content__FBWxo"
};
$ef8858de857ee727$var$styleInject($ef8858de857ee727$var$css_248z);
var $ef8858de857ee727$export$1def2aa75b7c7fe0 = function(_a) {
    var children = _a.children, _b = _a.wrapperClass, wrapperClass = _b === void 0 ? "" : _b, _c = _a.contentClass, contentClass = _c === void 0 ? "" : _c, wrapperStyle = _a.wrapperStyle, contentStyle = _a.contentStyle, _d = _a.wrapperProps, wrapperProps = _d === void 0 ? {} : _d, _e = _a.contentProps, contentProps = _e === void 0 ? {} : _e;
    var _f = (0, $1oC0p.useContext)($ef8858de857ee727$export$841858b892ce1f4c), init = _f.init, cleanupWindowEvents = _f.cleanupWindowEvents;
    var wrapperRef = (0, $1oC0p.useRef)(null);
    var contentRef = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useEffect)(function() {
        var wrapper = wrapperRef.current;
        var content = contentRef.current;
        if (wrapper !== null && content !== null && init) init === null || init === void 0 || init(wrapper, content);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        return function() {
            cleanupWindowEvents === null || cleanupWindowEvents === void 0 || cleanupWindowEvents();
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", $ef8858de857ee727$var$__assign({}, wrapperProps, {
        ref: wrapperRef,
        className: "".concat($ef8858de857ee727$var$baseClasses.wrapperClass, " ").concat($ef8858de857ee727$var$styles.wrapper, " ").concat(wrapperClass),
        style: wrapperStyle
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", $ef8858de857ee727$var$__assign({}, contentProps, {
        ref: contentRef,
        className: "".concat($ef8858de857ee727$var$baseClasses.contentClass, " ").concat($ef8858de857ee727$var$styles.content, " ").concat(contentClass),
        style: contentStyle
    }), children));
};
var $ef8858de857ee727$export$1708b11af87412f8 = function() {
    var libraryContext = (0, $1oC0p.useContext)($ef8858de857ee727$export$841858b892ce1f4c);
    if (!libraryContext) throw new Error("Transform context must be placed inside TransformWrapper");
    return libraryContext;
};
var $ef8858de857ee727$export$8a75c83865bcf9dd = function() {
    var libraryContext = $ef8858de857ee727$export$1708b11af87412f8();
    return $ef8858de857ee727$var$getControls(libraryContext);
};
var $ef8858de857ee727$export$e14839139473133b = function(callback) {
    var libraryContext = $ef8858de857ee727$export$1708b11af87412f8();
    (0, $1oC0p.useEffect)(function() {
        var unmountCallback;
        var unmount;
        if (libraryContext.contentComponent && libraryContext.wrapperComponent) unmountCallback = callback($ef8858de857ee727$var$getState(libraryContext));
        else unmount = libraryContext.onInit(function(ref) {
            unmountCallback = callback($ef8858de857ee727$var$getState(ref.instance));
        });
        return function() {
            unmount === null || unmount === void 0 || unmount();
            unmountCallback === null || unmountCallback === void 0 || unmountCallback();
        };
    }, []);
};
var $ef8858de857ee727$export$769cca75086a299c = function(callback) {
    var libraryContext = $ef8858de857ee727$export$1708b11af87412f8();
    (0, $1oC0p.useEffect)(function() {
        var unmountCallback;
        var unmount = libraryContext.onChange(function(ref) {
            unmountCallback = callback($ef8858de857ee727$var$getState(ref.instance));
        });
        return function() {
            unmount();
            unmountCallback === null || unmountCallback === void 0 || unmountCallback();
        };
    }, [
        callback,
        libraryContext
    ]);
};
function $ef8858de857ee727$export$4915c4f91c47b682(callback) {
    var libraryContext = $ef8858de857ee727$export$1708b11af87412f8();
    var _a = (0, $1oC0p.useState)(callback($ef8858de857ee727$var$getState(libraryContext))), transformRender = _a[0], setTransformRender = _a[1];
    (0, $1oC0p.useEffect)(function() {
        var mounted = true;
        var unmount = libraryContext.onChange(function(ref) {
            if (mounted) setTransformRender(callback($ef8858de857ee727$var$getState(ref.instance)));
        });
        return function() {
            unmount();
            mounted = false;
        };
    }, [
        callback,
        libraryContext
    ]);
    return transformRender;
}

});

parcelRegister("gRDcE", function(module, exports) {
$parcel$export(module.exports, "ZoomIn", function () { return $e28c461dfd89186d$export$d13069184bfa0730; });

var $7VQPk = parcelRequire("7VQPk");
const $e28c461dfd89186d$export$d13069184bfa0730 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        id: "icon-content-zoom in",
        width: size,
        height: size,
        viewBox: "0 0 62 63",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M59.66,53.76 C61.58,55.68 61.58,58.79 59.66,60.71 C57.74,62.63 54.63,62.63 52.71,60.71 L37.65,45.65 L44.6,38.7 L59.66,53.76 Z",
                        opacity: "0.5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M26.23,0.18 C40.72,0.18 52.46,11.93 52.46,26.42 C52.46,40.9 40.72,52.65 26.23,52.65 C11.74,52.65 0,40.9 0,26.42 C0,11.93 11.74,0.18 26.23,0.18 Z M46.97,26.42 C46.97,37.87 37.69,47.16 26.23,47.16 C14.78,47.16 5.49,37.87 5.49,26.42 C5.49,14.96 14.78,5.67 26.23,5.67 C37.69,5.67 46.97,14.96 46.97,26.42 Z"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M26.23,47.16 C37.69,47.16 46.97,37.87 46.97,26.42 C46.97,14.96 37.69,5.67 26.23,5.67 C14.78,5.67 5.49,14.96 5.49,26.42 C5.49,37.87 14.78,47.16 26.23,47.16 Z M26.54,14.52 C28.05,14.52 29.28,15.75 29.28,17.26 L29.28,23.97 L35.99,23.97 C37.51,23.97 38.74,25.2 38.74,26.72 C38.74,28.24 37.51,29.46 35.99,29.46 L29.28,29.46 L29.28,36.18 C29.28,37.69 28.05,38.92 26.54,38.92 C25.02,38.92 23.79,37.69 23.79,36.18 L23.79,29.46 L17.08,29.46 C15.56,29.46 14.34,28.24 14.34,26.72 C14.34,25.2 15.56,23.97 17.08,23.97 L23.79,23.97 L23.79,17.26 C23.79,15.75 25.02,14.52 26.54,14.52 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });

});

parcelRegister("yKFYG", function(module, exports) {
$parcel$export(module.exports, "ZoomOut", function () { return $0b44293d87c575f9$export$adc4acb67269225; });

var $7VQPk = parcelRequire("7VQPk");
const $0b44293d87c575f9$export$adc4acb67269225 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        id: "icon-content-zoom out",
        width: size,
        height: size,
        viewBox: "0 0 62 63",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M59.66,53.76 C61.58,55.68 61.58,58.79 59.66,60.71 C57.74,62.63 54.63,62.63 52.71,60.71 L37.33,45.33 L44.28,38.38 L59.66,53.76 Z",
                        opacity: "0.5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M52.46,26.42 C52.46,11.93 40.72,0.18 26.23,0.18 C11.74,0.18 0,11.93 0,26.42 C0,40.9 11.74,52.65 26.23,52.65 C40.72,52.65 52.46,40.9 52.46,26.42 Z M26.23,47.16 C37.69,47.16 46.97,37.87 46.97,26.42 C46.97,14.96 37.69,5.67 26.23,5.67 C14.78,5.67 5.49,14.96 5.49,26.42 C5.49,37.87 14.78,47.16 26.23,47.16 Z"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M26.23,47.16 C37.69,47.16 46.97,37.87 46.97,26.42 C46.97,14.96 37.69,5.67 26.23,5.67 C14.78,5.67 5.49,14.96 5.49,26.42 C5.49,37.87 14.78,47.16 26.23,47.16 Z M38.74,26.72 C38.74,25.2 37.51,23.97 35.99,23.97 L17.08,23.97 L16.95,23.98 C15.5,24.05 14.34,25.25 14.34,26.72 C14.34,28.24 15.56,29.47 17.08,29.47 L35.99,29.47 L36.12,29.46 C37.58,29.39 38.74,28.19 38.74,26.72 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });

});

parcelRegister("a7Xqx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::471b5e5cdc883753bc3e3b52ee5ae2e2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75f8a7cd1e999c53$var$_react = $75f8a7cd1e999c53$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $75f8a7cd1e999c53$var$_baseNew = $75f8a7cd1e999c53$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $75f8a7cd1e999c53$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Backlog".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for backlogs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75f8a7cd1e999c53$var$BacklogIcon = (props)=>/*#__PURE__*/ $75f8a7cd1e999c53$var$_react.default.createElement($75f8a7cd1e999c53$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2.167h11V3a.5.5 0 0 0-.5-.5zm10.5 4.167h-11v2.666h11zm0 4.166h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$75f8a7cd1e999c53$var$BacklogIcon.displayName = 'BacklogIcon';
var $75f8a7cd1e999c53$var$_default = module.exports.default = $75f8a7cd1e999c53$var$BacklogIcon;

});

parcelRegister("aVTcD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83cc862a6ce0fb1f7d8883d625af8c63>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f5a0c5cabda2415$var$_react = $7f5a0c5cabda2415$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $7f5a0c5cabda2415$var$_baseNew = $7f5a0c5cabda2415$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $7f5a0c5cabda2415$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookWithBookmark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: knowledge bases, articles, and other representations of books or info.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7f5a0c5cabda2415$var$BookWithBookmarkIcon = (props)=>/*#__PURE__*/ $7f5a0c5cabda2415$var$_react.default.createElement($7f5a0c5cabda2415$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.875A2.875 2.875 0 0 1 4.875 0h8.375a.75.75 0 0 1 .75.75V9.5a.75.75 0 0 1-.75.75V13H14v1.5h-3.5V13h1.25v-2.75H4.875a1.375 1.375 0 1 0 0 2.75H5.5v1.5h-.625A2.875 2.875 0 0 1 2 11.625zM3.5 9.1a2.86 2.86 0 0 1 1.375-.35H12.5V1.5H4.875c-.76 0-1.375.616-1.375 1.375z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.5 15.564V11.5h3v4.064a.25.25 0 0 1-.441.16L8 14.465l-1.059 1.26a.25.25 0 0 1-.441-.16"/>`
    }, props));
$7f5a0c5cabda2415$var$BookWithBookmarkIcon.displayName = 'BookWithBookmarkIcon';
var $7f5a0c5cabda2415$var$_default = module.exports.default = $7f5a0c5cabda2415$var$BookWithBookmarkIcon;

});

parcelRegister("5II9n", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::35a8ca9f503841cffe12f1ff6d6bb3be>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42a34f1e2299b39e$var$_react = $42a34f1e2299b39e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $42a34f1e2299b39e$var$_baseNew = $42a34f1e2299b39e$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $42a34f1e2299b39e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Camera".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: upload photo in Trello, photos.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $42a34f1e2299b39e$var$CameraIcon = (props)=>/*#__PURE__*/ $42a34f1e2299b39e$var$_react.default.createElement($42a34f1e2299b39e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.4.8A.75.75 0 0 1 6 .5h4a.75.75 0 0 1 .6.3l1.275 1.7h1.375A2.75 2.75 0 0 1 16 5.25V12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5.25A2.75 2.75 0 0 1 2.75 2.5h1.375zM6.375 2 5.1 3.7a.75.75 0 0 1-.6.3H2.75c-.69 0-1.25.56-1.25 1.25V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V5.25c0-.69-.56-1.25-1.25-1.25H11.5a.75.75 0 0 1-.6-.3L9.625 2zM8 6.5A1.75 1.75 0 1 0 8 10a1.75 1.75 0 0 0 0-3.5M4.75 8.25a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0" clip-rule="evenodd"/>`
    }, props));
$42a34f1e2299b39e$var$CameraIcon.displayName = 'CameraIcon';
var $42a34f1e2299b39e$var$_default = module.exports.default = $42a34f1e2299b39e$var$CameraIcon;

});

parcelRegister("dO8Do", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be0b9c9537e0b69b1d3c8d2587861fe5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a0d6a48064846045$var$_react = $a0d6a48064846045$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $a0d6a48064846045$var$_baseNew = $a0d6a48064846045$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $a0d6a48064846045$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Decision".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a0d6a48064846045$var$DecisionIcon = (props)=>/*#__PURE__*/ $a0d6a48064846045$var$_react.default.createElement($a0d6a48064846045$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m13.97.97-4.5 4.5 1.06 1.06 4.5-4.5zM3.56 2.5H8V1H1.75a.75.75 0 0 0-.75.75V8h1.5V3.56l4.604 4.604a.5.5 0 0 1 .146.354V15h1.5V8.518a2 2 0 0 0-.586-1.414z" clip-rule="evenodd"/>`
    }, props));
$a0d6a48064846045$var$DecisionIcon.displayName = 'DecisionIcon';
var $a0d6a48064846045$var$_default = module.exports.default = $a0d6a48064846045$var$DecisionIcon;

});

parcelRegister("3FUL0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84a07eff465bcaaea8db49f0fc7877da>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ad13a3cc41068cb$var$_react = $2ad13a3cc41068cb$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $2ad13a3cc41068cb$var$_baseNew = $2ad13a3cc41068cb$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $2ad13a3cc41068cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Department".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for departments, reporting lines, or other tree chart representations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2ad13a3cc41068cb$var$DepartmentIcon = (props)=>/*#__PURE__*/ $2ad13a3cc41068cb$var$_react.default.createElement($2ad13a3cc41068cb$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.5.75A.75.75 0 0 1 6.25 0h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-1v2.25h3.125c.76 0 1.375.616 1.375 1.375V11h1a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 .75-.75h1V8.75h-7.5V11h1a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 .75-.75h1V8.625c0-.76.616-1.375 1.375-1.375H7.25V5h-1a.75.75 0 0 1-.75-.75zM7 1.5v2h2v-2zm-4.5 11v2h2v-2zm9 0v2h2v-2z" clip-rule="evenodd"/>`
    }, props));
$2ad13a3cc41068cb$var$DepartmentIcon.displayName = 'DepartmentIcon';
var $2ad13a3cc41068cb$var$_default = module.exports.default = $2ad13a3cc41068cb$var$DepartmentIcon;

});

parcelRegister("3OOxO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e8b466fb905db85ecf24180397d24c4f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2c7d3fa40e32f890$var$_react = $2c7d3fa40e32f890$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $2c7d3fa40e32f890$var$_baseNew = $2c7d3fa40e32f890$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $2c7d3fa40e32f890$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2c7d3fa40e32f890$var$EditIcon = (props)=>/*#__PURE__*/ $2c7d3fa40e32f890$var$_react.default.createElement($2c7d3fa40e32f890$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.708zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.216l-.54 1.891 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V10H15v3.001a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$2c7d3fa40e32f890$var$EditIcon.displayName = 'EditIcon';
var $2c7d3fa40e32f890$var$_default = module.exports.default = $2c7d3fa40e32f890$var$EditIcon;

});

parcelRegister("2JPM3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed0744cae5af6a1635a1b9234b867386>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1fe7f200582e6f72$var$_react = $1fe7f200582e6f72$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $1fe7f200582e6f72$var$_baseNew = $1fe7f200582e6f72$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $1fe7f200582e6f72$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Emoji".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Editor as a category for Emoji's.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1fe7f200582e6f72$var$EmojiIcon = (props)=>/*#__PURE__*/ $1fe7f200582e6f72$var$_react.default.createElement($1fe7f200582e6f72$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m4.5-1.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m4.5 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m-2.915 3.783c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .721-.714l.005-.007-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513" clip-rule="evenodd"/>`
    }, props));
$1fe7f200582e6f72$var$EmojiIcon.displayName = 'EmojiIcon';
var $1fe7f200582e6f72$var$_default = module.exports.default = $1fe7f200582e6f72$var$EmojiIcon;

});

parcelRegister("6pmKv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7831691c1245bdf104acebfc690a968c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4aa6b95fb2f2f167$var$_react = $4aa6b95fb2f2f167$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $4aa6b95fb2f2f167$var$_baseNew = $4aa6b95fb2f2f167$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $4aa6b95fb2f2f167$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4aa6b95fb2f2f167$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $4aa6b95fb2f2f167$var$_react.default.createElement($4aa6b95fb2f2f167$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3.5c-2.943 0-5.49 1.845-6.424 4.396a.3.3 0 0 0 0 .208C2.509 10.655 5.057 12.5 8 12.5s5.49-1.845 6.424-4.396a.3.3 0 0 0 0-.208C13.491 5.345 10.943 3.5 8 3.5M.167 7.38C1.32 4.232 4.433 2 8 2c3.566 0 6.681 2.232 7.833 5.38.146.4.146.84 0 1.24C14.68 11.768 11.566 14 8 14 4.433 14 1.319 11.768.167 8.62a1.8 1.8 0 0 1 0-1.24M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$4aa6b95fb2f2f167$var$EyeOpenIcon.displayName = 'EyeOpenIcon';
var $4aa6b95fb2f2f167$var$_default = module.exports.default = $4aa6b95fb2f2f167$var$EyeOpenIcon;

});

parcelRegister("9A47Z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b192fbc7db5453924997563ea93d01df>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6f9aad8d62c1233e$var$_react = $6f9aad8d62c1233e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6f9aad8d62c1233e$var$_baseNew = $6f9aad8d62c1233e$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $6f9aad8d62c1233e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Files".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: documents, files. Do not use to represent pages — use the dedicated 'Pages' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6f9aad8d62c1233e$var$FilesIcon = (props)=>/*#__PURE__*/ $6f9aad8d62c1233e$var$_react.default.createElement($6f9aad8d62c1233e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 11a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4.25c0-.52-.208-1.02-.578-1.385L9.072.543A1.88 1.88 0 0 0 7.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h3v2.75c0 .414.336.75.75.75h2.75v6a.5.5 0 0 1-.5.5zm5.93-8H8.5V2.087z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7 16h4.75A3.25 3.25 0 0 0 15 12.75V5h-1.5v7.75a1.75 1.75 0 0 1-1.75 1.75H7z" clip-rule="evenodd"/>`
    }, props));
$6f9aad8d62c1233e$var$FilesIcon.displayName = 'FilesIcon';
var $6f9aad8d62c1233e$var$_default = module.exports.default = $6f9aad8d62c1233e$var$FilesIcon;

});

parcelRegister("OXM0c", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::04422a31fe921661fd3c15a462bdcae0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $099309582f5df496$var$_react = $099309582f5df496$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $099309582f5df496$var$_baseNew = $099309582f5df496$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $099309582f5df496$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Globe".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: public link in Confluence share dialog, global rules in Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $099309582f5df496$var$GlobeIcon = (props)=>/*#__PURE__*/ $099309582f5df496$var$_react.default.createElement($099309582f5df496$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.543 7.25h2.722c.073-1.784.403-3.413.92-4.663q.123-.294.26-.566A6.5 6.5 0 0 0 1.544 7.25M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 1.5c-.151 0-.364.07-.632.344-.27.276-.547.714-.796 1.316-.432 1.043-.733 2.47-.805 4.09h4.466c-.072-1.62-.373-3.047-.805-4.09-.249-.602-.526-1.04-.796-1.316C8.364 1.571 8.15 1.5 8 1.5m3.735 5.75c-.073-1.784-.403-3.413-.92-4.663a8 8 0 0 0-.26-.566 6.5 6.5 0 0 1 3.902 5.229zm-1.502 1.5H5.767c.072 1.62.373 3.047.805 4.09.249.602.526 1.04.796 1.316.268.273.481.344.632.344s.364-.07.632-.344c.27-.276.547-.714.796-1.316.432-1.043.733-2.47.805-4.09m.321 5.229q.14-.272.26-.566c.518-1.25.848-2.879.92-4.663h2.723a6.5 6.5 0 0 1-3.903 5.229m-5.108 0q-.14-.272-.26-.566c-.518-1.25-.848-2.879-.92-4.663H1.542a6.5 6.5 0 0 0 3.903 5.229" clip-rule="evenodd"/>`
    }, props));
$099309582f5df496$var$GlobeIcon.displayName = 'GlobeIcon';
var $099309582f5df496$var$_default = module.exports.default = $099309582f5df496$var$GlobeIcon;

});

parcelRegister("cNamI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5f93e34be6622a1cb8208e9984b09a45>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $950219ff5e98641d$var$_react = $950219ff5e98641d$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $950219ff5e98641d$var$_baseNew = $950219ff5e98641d$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $950219ff5e98641d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Lightbulb".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: learnings in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $950219ff5e98641d$var$LightbulbIcon = (props)=>/*#__PURE__*/ $950219ff5e98641d$var$_react.default.createElement($950219ff5e98641d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10 12.5H6V14a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5zm-2-11c-3.022 0-4.935 3.243-3.473 5.888L5.535 9.21c.303.548.463 1.164.465 1.79h4a3.7 3.7 0 0 1 .465-1.79l1.008-1.822C12.935 4.743 11.022 1.5 8 1.5M11.5 14a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-2.988a2.2 2.2 0 0 0-.277-1.075L3.215 8.114C1.2 4.47 3.835 0 8 0c4.164 0 6.8 4.47 4.785 8.114l-1.008 1.823a2.2 2.2 0 0 0-.277 1.075z"/>`
    }, props));
$950219ff5e98641d$var$LightbulbIcon.displayName = 'LightbulbIcon';
var $950219ff5e98641d$var$_default = module.exports.default = $950219ff5e98641d$var$LightbulbIcon;

});

parcelRegister("6hGO6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8bbccaea74398c387e69395dfeae5f34>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4935892ffc4dede5$var$_react = $4935892ffc4dede5$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $4935892ffc4dede5$var$_baseNew = $4935892ffc4dede5$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $4935892ffc4dede5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PeopleGroup".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4935892ffc4dede5$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $4935892ffc4dede5$var$_react.default.createElement($4935892ffc4dede5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9 4.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0M11 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M3 5.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0M4 3a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M2.625 9A2.625 2.625 0 0 0 0 11.625V13h1.5v-1.375c0-.621.504-1.125 1.125-1.125H5V9zM6 12.5A3.5 3.5 0 0 1 9.5 9h3a3.5 3.5 0 0 1 3.5 3.5V14h-1.5v-1.5a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2V14H6z" clip-rule="evenodd"/>`
    }, props));
$4935892ffc4dede5$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $4935892ffc4dede5$var$_default = module.exports.default = $4935892ffc4dede5$var$PeopleGroupIcon;

});

parcelRegister("5R44a", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::045b0e6f318b6cb40cf896c360eca820>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $44350e76e967080f$var$_react = $44350e76e967080f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $44350e76e967080f$var$_baseNew = $44350e76e967080f$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $44350e76e967080f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Teams".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for teams in Atlassian.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $44350e76e967080f$var$TeamsIcon = (props)=>/*#__PURE__*/ $44350e76e967080f$var$_react.default.createElement($44350e76e967080f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M1 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m11-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0M3.75 9.5a2.25 2.25 0 0 0-2.25 2.25V13a.5.5 0 0 0 .5.5h4V15H2a2 2 0 0 1-2-2v-1.25A3.75 3.75 0 0 1 3.75 8h1.149a3.75 3.75 0 0 1 3.524 2.469l.564 1.55A2.25 2.25 0 0 0 11.1 13.5H14a.5.5 0 0 0 .5-.5v-1.25a2.25 2.25 0 0 0-2.25-2.25H12c-.775 0-1.258.06-1.531.112-.137.026-.22.05-.26.062l-.027.01.007-.003.01-.004.005-.003.003-.002h.002c.001-.001.001-.001-.334-.672l-.335-.671h.001l.002-.002.004-.001.008-.004.018-.008a1 1 0 0 1 .174-.066q.156-.053.44-.11C10.572 8.065 11.15 8 12 8h.25A3.75 3.75 0 0 1 16 11.75V13a2 2 0 0 1-2 2h-2.899a3.75 3.75 0 0 1-3.524-2.469l-.564-1.55A2.25 2.25 0 0 0 4.9 9.5z" clip-rule="evenodd"/>`
    }, props));
$44350e76e967080f$var$TeamsIcon.displayName = 'TeamsIcon';
var $44350e76e967080f$var$_default = module.exports.default = $44350e76e967080f$var$TeamsIcon;

});

parcelRegister("6VSBC", function(module, exports) {
$parcel$export(module.exports, "EnterprisePageProductNav", function () { return $3872cd7d84b2ef7a$export$e36ad2737327f9c; });
$parcel$export(module.exports, "default", function () { return $3872cd7d84b2ef7a$export$2e2bcd8739ae039; });
/* enterprise-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kbpa7 = parcelRequire("kbpa7");

var $eOIix = parcelRequire("eOIix");

var $jQ0cd = parcelRequire("jQ0cd");

var $gn6Qa = parcelRequire("gn6Qa");
const $3872cd7d84b2ef7a$var$enterpriseNavTitleStyle = null;
const $3872cd7d84b2ef7a$export$e36ad2737327f9c = ({ isActive: isActive })=>{
    const intl = (0, $8e22h.default)();
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    const ctaButtonText = intl.formatMessage({
        id: 'EnterpriseLandingPage.navbar.cta',
        defaultMessage: 'Contact sales'
    });
    const mobileCtaButtonText = intl.formatMessage({
        id: 'EnterpriseLandingPage.navbar.mobile.cta',
        defaultMessage: 'Contact sales'
    });
    const links = [
        {
            globalLinksKey: 'overview',
            linkText: intl.formatMessage({
                id: 'EnterpriseLandingPage.navbar.overview',
                defaultMessage: 'Overview'
            }),
            hasDropdown: false,
            isActive: isActive === 'overview',
            productKey: 'enterprise',
            href: (0, $jQ0cd.useLocalizedHref)('/enterprise')
        },
        {
            globalLinksKey: 'success',
            linkText: intl.formatMessage({
                id: 'EnterpriseLandingPage.navbar.success',
                defaultMessage: 'Success'
            }),
            hasDropdown: false,
            isActive: isActive === 'success',
            productKey: 'enterprise',
            href: (0, $jQ0cd.useLocalizedHref)('/enterprise/success')
        },
        {
            globalLinksKey: 'resources',
            linkText: intl.formatMessage({
                id: 'EnterpriseLandingPage.navbar.resources',
                defaultMessage: 'Resources'
            }),
            hasDropdown: false,
            isActive: isActive === 'resources',
            productKey: 'enterprise',
            href: (0, $jQ0cd.useLocalizedHref)('/enterprise/resources')
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-product-navigation",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gn6Qa.ProductPageNav), {
            productLogoUrl: (0, $jQ0cd.useLocalizedHref)('/enterprise'),
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _4t3i1osq _k48p1fw0 _1wybgktf _vwz4gktf _o5721q9c",
                    isDarkTheme && "_syaz1afi"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                },
                children: "Enterprise"
            }),
            productLogoAriaLabel: "Enterprise",
            productPageNavLinks: links,
            mobileLinksSections: [
                {
                    mobileLinkKey: 'mobile-enterprise',
                    mobileLinksProps: links
                }
            ],
            navigationTrynowCtaText: ctaButtonText,
            navigationTrynowCtaUrl: (0, $jQ0cd.useLocalizedHref)('/enterprise/contact?formType=product-features'),
            mobileCtaText: mobileCtaButtonText,
            mobileCtaUrl: (0, $jQ0cd.useLocalizedHref)('/enterprise/contact?formType=product-features')
        })
    });
};
var $3872cd7d84b2ef7a$export$2e2bcd8739ae039 = $3872cd7d84b2ef7a$export$e36ad2737327f9c;

});

parcelRegister("hhv63", function(module, exports) {
$parcel$export(module.exports, "updatePreferences", function () { return $a62f11770126afae$export$7bb3e177c1a1e841; });
$parcel$export(module.exports, "ConsentHubClientConfigProvider", function () { return $a62f11770126afae$export$4f1d572ab3f4c2e6; });
$parcel$export(module.exports, "useConsentHubClientConfig", function () { return $a62f11770126afae$export$ef2475d0eafefa1b; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $5Ntyw = parcelRequire("5Ntyw");
const $a62f11770126afae$var$requiredProps = [
    'email',
    'site',
    'locale',
    'formUrl'
];
const $a62f11770126afae$var$defaultLocaleConfig = {
    locale: 'UNKNOWN',
    localeRequiresMarketingCommunicationOptIn: true
};
const $a62f11770126afae$export$ff156a5e09be2a6a = async (stargateClient)=>{
    return await stargateClient.getConsentConfig().then((response)=>response, ()=>$a62f11770126afae$var$defaultLocaleConfig);
};
const $a62f11770126afae$export$7bb3e177c1a1e841 = async (stargateClient, params, localeConfig)=>{
    const paramsLocale = params.paramsLocale ? params.paramsLocale : 'UNKNOWN';
    const postData = {
        locale: localeConfig?.locale || paramsLocale,
        ...params
    };
    if (!$a62f11770126afae$var$requiredProps.every((prop)=>postData.hasOwnProperty(prop))) throw `Invalid parameters. Required: {${$a62f11770126afae$var$requiredProps.toString()}}`;
    const updateConsentPreferencesResponseStatus = await stargateClient.updateConsentPreferences(postData);
    return updateConsentPreferencesResponseStatus;
};
const $a62f11770126afae$var$useGetConsentConfig = ()=>{
    const stargateClient = (0, $5Ntyw.useBxpWebStargateClient)();
    const [localeConfig, setLocaleConfig] = (0, $1oC0p.useState)($a62f11770126afae$var$defaultLocaleConfig);
    (0, $1oC0p.useEffect)(()=>{
        const fetchConfigData = async ()=>{
            const consentHubConfig = await $a62f11770126afae$export$ff156a5e09be2a6a(stargateClient);
            if (consentHubConfig) setLocaleConfig(consentHubConfig);
        };
        fetchConfigData().catch((err)=>console.log(err));
    }, [
        stargateClient
    ]);
    return localeConfig;
};
const $a62f11770126afae$export$6ccd5662e539f2b6 = /*#__PURE__*/ (0, $1oC0p.createContext)($a62f11770126afae$var$defaultLocaleConfig);
const $a62f11770126afae$export$4f1d572ab3f4c2e6 = ({ children: children })=>{
    const localeConfig = $a62f11770126afae$var$useGetConsentConfig();
    return /*#__PURE__*/ (0, $7VQPk.jsx)($a62f11770126afae$export$6ccd5662e539f2b6.Provider, {
        value: localeConfig,
        children: children
    });
};
const $a62f11770126afae$export$ef2475d0eafefa1b = ()=>{
    const context = (0, $1oC0p.useContext)($a62f11770126afae$export$6ccd5662e539f2b6);
    if (!context) throw new Error('useConsentHubClientConfig must be used within a ConsentHubClientConfigProvider');
    return context;
};

});

parcelRegister("lawKK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f693f033a1373d3c$export$2e2bcd8739ae039; });

var $f53LC = parcelRequire("f53LC");

var $8QkkG = parcelRequire("8QkkG");

var $2qaZZ = parcelRequire("2qaZZ");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $gJJny = parcelRequire("gJJny");

var $7gyMa = parcelRequire("7gyMa");

var $btjy5 = parcelRequire("btjy5");

var $bJ4Xk = parcelRequire("bJ4Xk");

var $34TA1 = parcelRequire("34TA1");
function $f693f033a1373d3c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f693f033a1373d3c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f693f033a1373d3c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f693f033a1373d3c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f693f033a1373d3c$var$baseStyles = (0, $3dJ4i.css)({
    display: 'flex',
    maxWidth: '100%',
    minHeight: '0%',
    flexBasis: '100%',
    flexDirection: 'column',
    flexGrow: 1
});
var $f693f033a1373d3c$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: "@atlaskit/tabs",
    packageVersion: "13.4.9"
};
var $f693f033a1373d3c$var$getTabPanelWithContext = function getTabPanelWithContext(_ref) {
    var tabPanel = _ref.tabPanel, index = _ref.index, isSelected = _ref.isSelected, tabsId = _ref.tabsId;
    return(// Ensure tabPanel exists in case it has been removed
    tabPanel && (0, $3dJ4i.jsx)((0, $btjy5.TabPanelContext).Provider, {
        value: {
            role: 'tabpanel',
            id: "".concat(tabsId, "-").concat(index, "-tab"),
            hidden: isSelected ? undefined : true,
            'aria-labelledby': "".concat(tabsId, "-").concat(index),
            onMouseDown: (0, $34TA1.onMouseDownBlur),
            tabIndex: isSelected ? 0 : -1
        },
        key: index
    }, tabPanel));
};
/**
 * __Tabs__
 *
 * Tabs acts as a container for all Tab components.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ var $f693f033a1373d3c$var$Tabs = function Tabs(props) {
    var _props$shouldUnmountT = props.shouldUnmountTabPanelOnChange, shouldUnmountTabPanelOnChange = _props$shouldUnmountT === void 0 ? false : _props$shouldUnmountT, SelectedType = props.selected, defaultSelected = props.defaultSelected, onChangeProp = props.onChange, id = props.id, analyticsContext = props.analyticsContext, children = props.children, testId = props.testId;
    var _useGlobalTheme = (0, $7gyMa.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var _useState = (0, $1oC0p.useState)(SelectedType || defaultSelected || 0), _useState2 = (0, $2qaZZ.default)(_useState, 2), selectedState = _useState2[0], setSelected = _useState2[1];
    var selected = SelectedType === undefined ? selectedState : SelectedType;
    var childrenArray = (0, $1oC0p.Children).toArray(children)// Don't include any conditional children
    .filter(function(child) {
        return Boolean(child);
    });
    // First child should be a tabList followed by tab panels
    var _childrenArray = (0, $8QkkG.default)(childrenArray), tabList = _childrenArray[0], tabPanels = _childrenArray.slice(1);
    // Keep track of visited and add to a set
    var visited = (0, $1oC0p.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    var onChange = (0, $1oC0p.useCallback)(function(index, analyticsEvent) {
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    var onChangeAnalytics = (0, $gJJny.usePlatformLeafEventHandler)($f693f033a1373d3c$var$_objectSpread({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext
    }, $f693f033a1373d3c$var$analyticsAttributes));
    var tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $f693f033a1373d3c$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map(function(tabIndex) {
        return $f693f033a1373d3c$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        });
    });
    var tabsStyles = (0, $1oC0p.useMemo)(function() {
        return (0, $bJ4Xk.getTabsStyles)(mode);
    }, [
        mode
    ]);
    return(// Only styles that affect the Tabs container itself have been applied via primitives.
    // The other styles applied through the CSS prop are there for styling children
    // through inheritance. This is important for custom cases that use the useTabPanel(),
    // which applies accessibility attributes that we use as a styling hook.
    (0, $3dJ4i.jsx)("div", {
        "data-testid": testId,
        css: [
            $f693f033a1373d3c$var$baseStyles,
            tabsStyles
        ]
    }, (0, $3dJ4i.jsx)((0, $btjy5.TabListContext).Provider, {
        value: {
            selected: selected,
            onChange: onChangeAnalytics,
            tabsId: id
        }
    }, tabList), (0, $3dJ4i.jsx)((0, $1oC0p.Fragment), null, tabPanelsWithContext)));
};
var $f693f033a1373d3c$export$2e2bcd8739ae039 = $f693f033a1373d3c$var$Tabs;

});
parcelRegister("btjy5", function(module, exports) {
$parcel$export(module.exports, "TabContext", function () { return $85a1911bdf59ecbd$export$5a5d356ca5f10a0a; });
$parcel$export(module.exports, "TabListContext", function () { return $85a1911bdf59ecbd$export$aa6907f9fd69e93b; });
$parcel$export(module.exports, "TabPanelContext", function () { return $85a1911bdf59ecbd$export$2054129d247c3102; });
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $1oC0p = parcelRequire("1oC0p");
var $85a1911bdf59ecbd$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
var $85a1911bdf59ecbd$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
var $85a1911bdf59ecbd$export$2054129d247c3102 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});

parcelRegister("bJ4Xk", function(module, exports) {
$parcel$export(module.exports, "getTabsStyles", function () { return $8897bdcf3df5d3c2$export$dd5afd2190fb792c; });
$parcel$export(module.exports, "getTabListStyles", function () { return $8897bdcf3df5d3c2$export$42a3c683c377bcb2; });

var $f53LC = parcelRequire("f53LC");

var $3dJ4i = parcelRequire("3dJ4i");

var $6w3Ij = parcelRequire("6w3Ij");
function $8897bdcf3df5d3c2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8897bdcf3df5d3c2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8897bdcf3df5d3c2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8897bdcf3df5d3c2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8897bdcf3df5d3c2$var$tabLeftRightPadding = "var(--ds-space-100, 8px)";
var $8897bdcf3df5d3c2$var$tabTopBottomPadding = "var(--ds-space-050, 4px)";
// TODO this should probably be `border.width.indicator`
var $8897bdcf3df5d3c2$var$underlineHeight = "var(--ds-border-width-outline, 2px)";
var $8897bdcf3df5d3c2$var$highContrastFocusStyles = {
    outline: "var(--ds-border-width, 1px)".concat(" solid")
};
// Required so the focus ring is visible in high contrast mode
var $8897bdcf3df5d3c2$var$highContrastFocusRing = {
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': $8897bdcf3df5d3c2$var$highContrastFocusStyles,
        '@supports not selector(*:focus-visible)': {
            '&:focus': $8897bdcf3df5d3c2$var$highContrastFocusStyles
        }
    }
};
var $8897bdcf3df5d3c2$var$tabFocusStyles = function tabFocusStyles(mode) {
    return {
        boxShadow: "0 0 0 2px ".concat((0, $6w3Ij.getTabPanelFocusColor)(mode), " inset"),
        borderRadius: "var(--ds-border-radius, 3px)",
        outline: 'none'
    };
};
var $8897bdcf3df5d3c2$var$getTabPanelStyles = function getTabPanelStyles(mode) {
    return $8897bdcf3df5d3c2$var$_objectSpread({
        flexGrow: 1,
        /*
      NOTE min-height set to 0% because of Firefox bug
      FF http://stackoverflow.com/questions/28636832/firefox-overflow-y-not-working-with-nested-flexbox
    */ minHeight: '0%',
        display: 'flex',
        padding: "0 ".concat($8897bdcf3df5d3c2$var$tabLeftRightPadding),
        '&:focus-visible': $8897bdcf3df5d3c2$var$tabFocusStyles(mode),
        '@supports not selector(*:focus-visible)': {
            '&:focus': $8897bdcf3df5d3c2$var$tabFocusStyles(mode)
        }
    }, $8897bdcf3df5d3c2$var$highContrastFocusRing);
};
var $8897bdcf3df5d3c2$export$dd5afd2190fb792c = function getTabsStyles(mode) {
    return(// eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $3dJ4i.css)({
        '& [role="tabpanel"]': $8897bdcf3df5d3c2$var$getTabPanelStyles(mode),
        // The hidden attribute doesn't work on flex elements
        // Change display to be none
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        '& > [hidden]': {
            display: 'none'
        }
    }));
};
var $8897bdcf3df5d3c2$var$tabLineStyles = {
    content: '""',
    borderRadius: "var(--ds-border-radius-050, 2px)",
    bottom: 0,
    margin: 0,
    position: 'absolute',
    width: 'inherit',
    left: $8897bdcf3df5d3c2$var$tabLeftRightPadding,
    right: $8897bdcf3df5d3c2$var$tabLeftRightPadding
};
var $8897bdcf3df5d3c2$export$42a3c683c377bcb2 = function getTabListStyles(mode) {
    return(// eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $3dJ4i.css)({
        '& [role="tab"]': $8897bdcf3df5d3c2$export$916c8b0fccbb37d2(mode),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        '&::before': $8897bdcf3df5d3c2$var$_objectSpread($8897bdcf3df5d3c2$var$_objectSpread({}, $8897bdcf3df5d3c2$var$tabLineStyles), {}, {
            height: $8897bdcf3df5d3c2$var$underlineHeight,
            // This line is not a border so the selected line is visible in high contrast mode
            backgroundColor: (0, $6w3Ij.getTabLineColor)(mode).lineColor
        })
    }));
};
var $8897bdcf3df5d3c2$var$tabPanelFocusStyles = function tabPanelFocusStyles(mode) {
    var colors = (0, $6w3Ij.getTabColors)(mode);
    return {
        boxShadow: "0 0 0 2px ".concat(colors.focusBorderColor, " inset"),
        borderRadius: "var(--ds-border-radius, 3px)",
        outline: 'none',
        // Hide TabLine on focus
        '&::after': {
            opacity: 0
        }
    };
};
var $8897bdcf3df5d3c2$export$916c8b0fccbb37d2 = function getTabStyles(mode) {
    var colors = (0, $6w3Ij.getTabColors)(mode);
    return $8897bdcf3df5d3c2$var$_objectSpread($8897bdcf3df5d3c2$var$_objectSpread({
        color: colors.labelColor,
        cursor: 'pointer',
        lineHeight: 1.8,
        margin: 0,
        padding: "".concat($8897bdcf3df5d3c2$var$tabTopBottomPadding, " ").concat($8897bdcf3df5d3c2$var$tabLeftRightPadding),
        position: 'relative',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&:hover': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.hoverLabelColor,
            '&::after': $8897bdcf3df5d3c2$var$_objectSpread($8897bdcf3df5d3c2$var$_objectSpread({}, $8897bdcf3df5d3c2$var$tabLineStyles), {}, {
                borderBottom: "".concat($8897bdcf3df5d3c2$var$underlineHeight, " solid ").concat((0, $6w3Ij.getTabLineColor)(mode).hoveredColor),
                height: 0
            })
        },
        '&:active': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.activeLabelColor,
            '&::after': $8897bdcf3df5d3c2$var$_objectSpread($8897bdcf3df5d3c2$var$_objectSpread({}, $8897bdcf3df5d3c2$var$tabLineStyles), {}, {
                borderBottom: "".concat($8897bdcf3df5d3c2$var$underlineHeight, " solid ").concat((0, $6w3Ij.getTabLineColor)(mode).activeColor),
                height: 0
            })
        },
        '&:focus-visible': $8897bdcf3df5d3c2$var$tabPanelFocusStyles(mode),
        '@supports not selector(*:focus-visible)': {
            '&:focus': $8897bdcf3df5d3c2$var$tabPanelFocusStyles(mode)
        }
    }, $8897bdcf3df5d3c2$var$highContrastFocusRing), {}, {
        '&[aria-selected="true"]': {
            color: colors.selectedColor,
            '&::after': $8897bdcf3df5d3c2$var$_objectSpread($8897bdcf3df5d3c2$var$_objectSpread({}, $8897bdcf3df5d3c2$var$tabLineStyles), {}, {
                // This line is a border so it is visible in high contrast mode
                borderBottom: "".concat($8897bdcf3df5d3c2$var$underlineHeight, " solid ").concat((0, $6w3Ij.getTabLineColor)(mode).selectedColor),
                height: 0
            })
        }
    });
};

});
parcelRegister("6w3Ij", function(module, exports) {
$parcel$export(module.exports, "getTabColors", function () { return $4be89cb811b70b40$export$8a53023232713127; });
$parcel$export(module.exports, "getTabLineColor", function () { return $4be89cb811b70b40$export$eff40d6a7c078cf; });
$parcel$export(module.exports, "getTabPanelFocusColor", function () { return $4be89cb811b70b40$export$5b33c784b26b1d3f; });

var $3c7rQ = parcelRequire("3c7rQ");
var $4be89cb811b70b40$var$tabColorMap = {
    light: {
        labelColor: "var(--ds-text-subtle, ".concat((0, $3c7rQ.N500), ")"),
        activeLabelColor: "var(--ds-text, ".concat((0, $3c7rQ.B500), ")"),
        hoverLabelColor: "var(--ds-text-subtle, ".concat((0, $3c7rQ.B400), ")"),
        selectedColor: "var(--ds-text-selected, ".concat((0, $3c7rQ.B400), ")"),
        focusBorderColor: "var(--ds-border-focused, ".concat((0, $3c7rQ.B100), ")")
    },
    dark: {
        labelColor: "var(--ds-text-subtle, ".concat((0, $3c7rQ.DN400), ")"),
        activeLabelColor: "var(--ds-text, ".concat((0, $3c7rQ.B200), ")"),
        hoverLabelColor: "var(--ds-text-subtle, ".concat((0, $3c7rQ.B75), ")"),
        selectedColor: "var(--ds-text-selected, ".concat((0, $3c7rQ.B75), ")"),
        focusBorderColor: "var(--ds-border-focused, ".concat((0, $3c7rQ.B75), ")")
    }
};
var $4be89cb811b70b40$export$8a53023232713127 = function getTabColors(mode) {
    return $4be89cb811b70b40$var$tabColorMap[mode];
};
var $4be89cb811b70b40$var$tabLineColorMap = {
    light: {
        lineColor: "var(--ds-border, ".concat((0, $3c7rQ.N30), ")"),
        hoveredColor: "var(--ds-border, transparent)",
        activeColor: "var(--ds-border, transparent)",
        selectedColor: "var(--ds-border-selected, ".concat((0, $3c7rQ.B400), ")")
    },
    dark: {
        lineColor: "var(--ds-border, ".concat((0, $3c7rQ.DN0), ")"),
        hoveredColor: "var(--ds-border, transparent)",
        activeColor: "var(--ds-border, transparent)",
        selectedColor: "var(--ds-border-selected, ".concat((0, $3c7rQ.B75), ")")
    }
};
var $4be89cb811b70b40$export$eff40d6a7c078cf = function getTabLineColor(mode) {
    return $4be89cb811b70b40$var$tabLineColorMap[mode];
};
var $4be89cb811b70b40$var$tabPanelFocusColorMap = {
    light: "var(--ds-border-focused, ".concat((0, $3c7rQ.B100), ")"),
    dark: "var(--ds-border-focused, ".concat((0, $3c7rQ.B75), ")")
};
var $4be89cb811b70b40$export$5b33c784b26b1d3f = function getTabPanelFocusColor(mode) {
    return $4be89cb811b70b40$var$tabPanelFocusColorMap[mode];
};

});


parcelRegister("34TA1", function(module, exports) {
$parcel$export(module.exports, "onMouseDownBlur", function () { return $23dcdbd655f15e6a$export$1aedf39a68fc0142; });
// Prevent a focus ring if clicked
var $23dcdbd655f15e6a$export$1aedf39a68fc0142 = function onMouseDownBlur(e) {
    var currentTarget = e.currentTarget;
    var focusedDuringMouseDown = currentTarget === document.activeElement;
    requestAnimationFrame(function() {
        if (focusedDuringMouseDown && currentTarget !== document.activeElement && document.body.contains(currentTarget)) {
            currentTarget.focus();
            return;
        }
        if (!focusedDuringMouseDown && document.body.contains(currentTarget)) currentTarget.blur();
    });
};

});


parcelRegister("9T4IS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $732ce9f1d0fdbdd6$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $7gyMa = parcelRequire("7gyMa");

var $6dioi = parcelRequire("6dioi");

var $btjy5 = parcelRequire("btjy5");

var $bJ4Xk = parcelRequire("bJ4Xk");

var $34TA1 = parcelRequire("34TA1");
var $732ce9f1d0fdbdd6$var$baseStyles = (0, $3dJ4i.css)({
    display: 'flex',
    padding: "var(--ds-space-0, 0px)",
    position: 'relative'
});
/**
 * __TabList__
 *
 * A TabList groups `Tab` components together.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ var $732ce9f1d0fdbdd6$var$TabList = function TabList(_ref) {
    var children = _ref.children;
    var _useGlobalTheme = (0, $7gyMa.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var _useTabList = (0, $6dioi.useTabList)(), tabsId = _useTabList.tabsId, selected = _useTabList.selected, onChange = _useTabList.onChange;
    var ref = /*#__PURE__*/ (0, $1oC0p.createRef)();
    // Don't include any conditional children
    var childrenArray = (0, $1oC0p.Children).toArray(children).filter(Boolean);
    var length = childrenArray.length;
    var tabListStyles = (0, $1oC0p.useMemo)(function() {
        return (0, $bJ4Xk.getTabListStyles)(mode);
    }, [
        mode
    ]);
    var selectTabByIndex = (0, $1oC0p.useCallback)(function(index) {
        var _ref$current;
        var newSelectedNode = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.querySelector("[id='".concat(tabsId, "-").concat(index, "']"));
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    var onKeyDown = (0, $1oC0p.useCallback)(function(e) {
        if (![
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(e.key)) return;
        // preventing horizontal or vertical scroll
        e.preventDefault();
        var lastTabIndex = length - 1;
        if ([
            'Home',
            'End'
        ].includes(e.key)) {
            var _newSelected = e.key === 'Home' ? 0 : lastTabIndex;
            selectTabByIndex(_newSelected);
            return;
        }
        // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        var selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
        var modifier = e.key === 'ArrowRight' ? 1 : -1;
        var newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    var getTabWithContext = (0, $1oC0p.useCallback)(function(_ref2) {
        var tab = _ref2.tab, isSelected = _ref2.isSelected, index = _ref2.index;
        return (0, $3dJ4i.jsx)((0, $btjy5.TabContext).Provider, {
            value: {
                onClick: function onClick() {
                    return onChange(index);
                },
                onMouseDown: (0, $34TA1.onMouseDownBlur),
                onKeyDown: onKeyDown,
                'aria-setsize': length,
                role: 'tab',
                id: "".concat(tabsId, "-").concat(index),
                'aria-posinset': index + 1,
                'aria-selected': isSelected,
                'aria-controls': "".concat(tabsId, "-").concat(index, "-tab"),
                tabIndex: isSelected ? 0 : -1
            },
            key: index
        }, tab);
    }, [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return(// Only styles that affect the TabList itself have been applied via primitives.
    // The other styles applied through the CSS prop are there for styling children
    // through inheritance. This is important for custom cases that use the useTab(),
    // which applies accessibility atributes that we use as a styling hook.
    (0, $3dJ4i.jsx)("div", {
        role: "tablist",
        ref: ref,
        css: [
            $732ce9f1d0fdbdd6$var$baseStyles,
            tabListStyles
        ]
    }, childrenArray.map(function(child, index) {
        return getTabWithContext({
            tab: child,
            index: index,
            isSelected: index === selected
        });
    })));
};
var $732ce9f1d0fdbdd6$export$2e2bcd8739ae039 = $732ce9f1d0fdbdd6$var$TabList;

});
parcelRegister("6dioi", function(module, exports) {
$parcel$export(module.exports, "useTab", function () { return $48623902a0996682$export$fdf4756d5b8ef90a; });
$parcel$export(module.exports, "useTabList", function () { return $48623902a0996682$export$773e389e644c5874; });
$parcel$export(module.exports, "useTabPanel", function () { return $48623902a0996682$export$fae0121b5afe572d; });

var $1oC0p = parcelRequire("1oC0p");

var $btjy5 = parcelRequire("btjy5");
var $48623902a0996682$export$fdf4756d5b8ef90a = function useTab() {
    var tabData = (0, $1oC0p.useContext)((0, $btjy5.TabContext));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
};
var $48623902a0996682$export$773e389e644c5874 = function useTabList() {
    var tabListData = (0, $1oC0p.useContext)((0, $btjy5.TabListContext));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
};
var $48623902a0996682$export$fae0121b5afe572d = function useTabPanel() {
    var tabPanelData = (0, $1oC0p.useContext)((0, $btjy5.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
};

});


parcelRegister("8KOLZ", function(module, exports) {
$parcel$export(module.exports, "useFireAnalyticsEvents", function () { return $658739b320652fc5$export$637f611434c7b092; });

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");

var $iSeHD = parcelRequire("iSeHD");
const $658739b320652fc5$var$EMPTY_ATTRIBUTES = {};
const $658739b320652fc5$export$637f611434c7b092 = (initialAttributes)=>{
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const pendingEvents = (0, $1oC0p.useRef)([]);
    // Memoize initialAttributes to prevent unnecessary re-renders
    const memoizedInitialAttributes = (0, $1oC0p.useMemo)(()=>initialAttributes ?? $658739b320652fc5$var$EMPTY_ATTRIBUTES, [
        initialAttributes
    ]);
    const fireEvent = (0, $1oC0p.useCallback)((eventPayload)=>{
        if (analyticsClient) createAnalyticsEvent({
            ...eventPayload,
            attributes: {
                ...memoizedInitialAttributes,
                ...eventPayload['attributes'] || {}
            }
        }).fire();
        else // store events to send later
        pendingEvents.current.push(eventPayload);
    }, [
        analyticsClient,
        createAnalyticsEvent,
        memoizedInitialAttributes
    ]);
    // fires pending events once client is available
    (0, $1oC0p.useEffect)(()=>{
        if (analyticsClient && pendingEvents.current.length > 0) {
            pendingEvents.current.forEach((eventPayload)=>{
                createAnalyticsEvent({
                    ...eventPayload,
                    attributes: {
                        ...memoizedInitialAttributes,
                        ...eventPayload['attributes'] || {}
                    }
                }).fire();
            });
            pendingEvents.current = [];
        }
    // we only need to run this effect when the analytics client changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        analyticsClient
    ]);
    const fireUIEvent = (0, $1oC0p.useCallback)((eventPayload)=>{
        fireEvent({
            ...eventPayload,
            eventType: 'ui'
        });
    }, [
        fireEvent
    ]);
    const fireTrackEvent = (0, $1oC0p.useCallback)((eventPayload)=>{
        fireEvent({
            ...eventPayload,
            eventType: 'track'
        });
    }, [
        fireEvent
    ]);
    const fireScreenEvent = (0, $1oC0p.useCallback)((eventPayload)=>{
        fireEvent({
            ...eventPayload,
            eventType: 'screen'
        });
    }, [
        fireEvent
    ]);
    const fireOperationalEvent = (0, $1oC0p.useCallback)((eventPayload)=>{
        fireEvent({
            ...eventPayload,
            eventType: 'operational'
        });
    }, [
        fireEvent
    ]);
    return {
        fireUIEvent: fireUIEvent,
        fireTrackEvent: fireTrackEvent,
        fireScreenEvent: fireScreenEvent,
        fireOperationalEvent: fireOperationalEvent,
        pendingEvents: pendingEvents
    };
};

});

parcelRegister("8kWtd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4df587d0c3f1832e97f8caba30d1552>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $611d8beea2f13157$var$_react = $611d8beea2f13157$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $611d8beea2f13157$var$_baseNew = $611d8beea2f13157$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $611d8beea2f13157$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeTextSummary".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for summarizing content with Atlassian Intelligence & Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $611d8beea2f13157$var$AiGenerativeTextSummaryIcon = (props)=>/*#__PURE__*/ $611d8beea2f13157$var$_react.default.createElement($611d8beea2f13157$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h14v1.5H1zm0 4.166h14v1.5H1zm10.796 4.328a.75.75 0 0 1 1.41 0l.615 1.687 1.686.615a.75.75 0 0 1 0 1.41l-1.686.615-.615 1.686a.75.75 0 0 1-1.41 0l-.615-1.686-1.687-.615a.75.75 0 0 1 0-1.41l1.687-.615zM1 9.333h7v1.5H1zm0 4.166h5v1.5H1z" clip-rule="evenodd"/>`
    }, props));
$611d8beea2f13157$var$AiGenerativeTextSummaryIcon.displayName = 'AiGenerativeTextSummaryIcon';
var $611d8beea2f13157$var$_default = module.exports.default = $611d8beea2f13157$var$AiGenerativeTextSummaryIcon;

});

parcelRegister("d6iWh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a02f6f2bebc5924b5c7f92f48f61953>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02761af2cf514ed8$var$_react = $02761af2cf514ed8$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $02761af2cf514ed8$var$_baseNew = $02761af2cf514ed8$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $02761af2cf514ed8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "InformationCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: For highlighting information when less visual emphasis is needed within the UI compared to the filled information status icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $02761af2cf514ed8$var$InformationCircleIcon = (props)=>/*#__PURE__*/ $02761af2cf514ed8$var$_react.default.createElement($02761af2cf514ed8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25.25H6.5v-1.5H8a.75.75 0 0 1 .75.75v5h-1.5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$02761af2cf514ed8$var$InformationCircleIcon.displayName = 'InformationCircleIcon';
var $02761af2cf514ed8$var$_default = module.exports.default = $02761af2cf514ed8$var$InformationCircleIcon;

});

parcelRegister("bmQfx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6a6c601e24c01efd86daa4bd04d7c20b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $846a4775e901e20d$var$_react = $846a4775e901e20d$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $846a4775e901e20d$var$_baseNew = $846a4775e901e20d$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $846a4775e901e20d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ThumbsDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: voting, feedback in AI.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $846a4775e901e20d$var$ThumbsDownIcon = (props)=>/*#__PURE__*/ $846a4775e901e20d$var$_react.default.createElement($846a4775e901e20d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.292 13.406a.5.5 0 0 0 .77-.15l2.438-4.69V2.5H4.128c-.492 0-.927.32-1.073.79L1.726 7.54A1.125 1.125 0 0 0 2.8 9h3.45a.75.75 0 0 1 .75.75v3.175a.5.5 0 0 0 .174.38zM12 2.5V8h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm-.295 7-2.313 4.45a2 2 0 0 1-3.076.596l-.118-.101a2 2 0 0 1-.698-1.519V10.5H2.8A2.625 2.625 0 0 1 .295 7.092l1.328-4.25A2.625 2.625 0 0 1 4.128 1H14a2 2 0 0 1 2 2v4.5a2 2 0 0 1-2 2z" clip-rule="evenodd"/>`
    }, props));
$846a4775e901e20d$var$ThumbsDownIcon.displayName = 'ThumbsDownIcon';
var $846a4775e901e20d$var$_default = module.exports.default = $846a4775e901e20d$var$ThumbsDownIcon;

});

parcelRegister("51it3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a1671a6ac4d424a875e471692b3026e8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a7b5f0937e89bff$var$_react = $3a7b5f0937e89bff$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $3a7b5f0937e89bff$var$_baseNew = $3a7b5f0937e89bff$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $3a7b5f0937e89bff$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ThumbsUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: voting options in Jira, like.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a7b5f0937e89bff$var$ThumbsUpIcon = (props)=>/*#__PURE__*/ $3a7b5f0937e89bff$var$_react.default.createElement($3a7b5f0937e89bff$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.708 2.594a.5.5 0 0 0-.77.15L5.5 7.433V13.5h6.371c.493 0 .928-.32 1.074-.79l1.328-4.25A1.125 1.125 0 0 0 13.2 7H9.75A.75.75 0 0 1 9 6.25V3.075a.5.5 0 0 0-.175-.38zM4 13.5V8H2a.5.5 0 0 0-.5.5V13a.5.5 0 0 0 .5.5zm.295-7 2.313-4.45a2 2 0 0 1 3.076-.596l.118.101a2 2 0 0 1 .698 1.519V5.5h2.7a2.625 2.625 0 0 1 2.505 3.408l-1.328 4.25A2.625 2.625 0 0 1 11.871 15H2a2 2 0 0 1-2-2V8.5a2 2 0 0 1 2-2z" clip-rule="evenodd"/>`
    }, props));
$3a7b5f0937e89bff$var$ThumbsUpIcon.displayName = 'ThumbsUpIcon';
var $3a7b5f0937e89bff$var$_default = module.exports.default = $3a7b5f0937e89bff$var$ThumbsUpIcon;

});

parcelRegister("fyijY", function(module, exports) {
$parcel$export(module.exports, "encodeXML", function () { return (parcelRequire("h82ow")).encodeXML; });
$parcel$export(module.exports, "escapeAttribute", function () { return (parcelRequire("h82ow")).escapeAttribute; });
$parcel$export(module.exports, "escapeText", function () { return (parcelRequire("h82ow")).escapeText; });
$parcel$export(module.exports, "decodeHTML", function () { return (parcelRequire("9i7QI")).decodeHTML; });

var $9i7QI = parcelRequire("9i7QI");

var $8lOYC = parcelRequire("8lOYC");

var $h82ow = parcelRequire("h82ow");
var $b5283e321449c041$export$b8c86583d9718b50;
(function(EntityLevel) {
    /** Support only XML entities. */ EntityLevel[EntityLevel["XML"] = 0] = "XML";
    /** Support HTML entities, which are a superset of XML entities. */ EntityLevel[EntityLevel["HTML"] = 1] = "HTML";
})($b5283e321449c041$export$b8c86583d9718b50 || ($b5283e321449c041$export$b8c86583d9718b50 = {}));
var $b5283e321449c041$export$1851b20d614eb756;
(function(EncodingMode) {
    /**
     * The output is UTF-8 encoded. Only characters that need escaping within
     * XML will be escaped.
     */ EncodingMode[EncodingMode["UTF8"] = 0] = "UTF8";
    /**
     * The output consists only of ASCII characters. Characters that need
     * escaping within HTML, and characters that aren't ASCII characters will
     * be escaped.
     */ EncodingMode[EncodingMode["ASCII"] = 1] = "ASCII";
    /**
     * Encode all characters that have an equivalent entity, as well as all
     * characters that are not ASCII characters.
     */ EncodingMode[EncodingMode["Extensive"] = 2] = "Extensive";
    /**
     * Encode all characters that have to be escaped in HTML attributes,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Attribute"] = 3] = "Attribute";
    /**
     * Encode all characters that have to be escaped in HTML text,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Text"] = 4] = "Text";
})($b5283e321449c041$export$1851b20d614eb756 || ($b5283e321449c041$export$1851b20d614eb756 = {}));
function $b5283e321449c041$export$2f872c0f2117be69(data, options = $b5283e321449c041$export$b8c86583d9718b50.XML) {
    const level = typeof options === "number" ? options : options.level;
    if (level === $b5283e321449c041$export$b8c86583d9718b50.HTML) {
        const mode = typeof options === "object" ? options.mode : undefined;
        return (0, $9i7QI.decodeHTML)(data, mode);
    }
    return (0, $9i7QI.decodeXML)(data);
}
function $b5283e321449c041$export$c94669f4c7d36be4(data, options = $b5283e321449c041$export$b8c86583d9718b50.XML) {
    var _a;
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    (_a = opts.mode) !== null && _a !== void 0 ? _a : opts.mode = (0, $9i7QI.DecodingMode).Strict;
    return $b5283e321449c041$export$2f872c0f2117be69(data, opts);
}
function $b5283e321449c041$export$c564cdbbe6da493(data, options = $b5283e321449c041$export$b8c86583d9718b50.XML) {
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    // Mode `UTF8` just escapes XML entities
    if (opts.mode === $b5283e321449c041$export$1851b20d614eb756.UTF8) return (0, $h82ow.escapeUTF8)(data);
    if (opts.mode === $b5283e321449c041$export$1851b20d614eb756.Attribute) return (0, $h82ow.escapeAttribute)(data);
    if (opts.mode === $b5283e321449c041$export$1851b20d614eb756.Text) return (0, $h82ow.escapeText)(data);
    if (opts.level === $b5283e321449c041$export$b8c86583d9718b50.HTML) {
        if (opts.mode === $b5283e321449c041$export$1851b20d614eb756.ASCII) return (0, $8lOYC.encodeNonAsciiHTML)(data);
        return (0, $8lOYC.encodeHTML)(data);
    }
    // ASCII and Extensive are equivalent
    return (0, $h82ow.encodeXML)(data);
}

});
parcelRegister("9i7QI", function(module, exports) {
$parcel$export(module.exports, "DecodingMode", function () { return $6c3be22c80aecac7$export$8c8f129ce60f53c; });
$parcel$export(module.exports, "EntityDecoder", function () { return $6c3be22c80aecac7$export$15263a93ff7ec8ba; });
$parcel$export(module.exports, "decodeHTML", function () { return $6c3be22c80aecac7$export$f045cb747ce77a19; });
$parcel$export(module.exports, "decodeXML", function () { return $6c3be22c80aecac7$export$88e3b9643a8bd06e; });
$parcel$export(module.exports, "htmlDecodeTree", function () { return (parcelRequire("j3h6Q")).default; });
$parcel$export(module.exports, "xmlDecodeTree", function () { return (parcelRequire("7Ui2N")).default; });
$parcel$export(module.exports, "fromCodePoint", function () { return (parcelRequire("fJ3ZX")).fromCodePoint; });

var $j3h6Q = parcelRequire("j3h6Q");

var $7Ui2N = parcelRequire("7Ui2N");

var $fJ3ZX = parcelRequire("fJ3ZX");
var $6c3be22c80aecac7$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($6c3be22c80aecac7$var$CharCodes || ($6c3be22c80aecac7$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ const $6c3be22c80aecac7$var$TO_LOWER_BIT = 32;
var $6c3be22c80aecac7$export$6a4325c613e0faec;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($6c3be22c80aecac7$export$6a4325c613e0faec || ($6c3be22c80aecac7$export$6a4325c613e0faec = {}));
function $6c3be22c80aecac7$var$isNumber(code) {
    return code >= $6c3be22c80aecac7$var$CharCodes.ZERO && code <= $6c3be22c80aecac7$var$CharCodes.NINE;
}
function $6c3be22c80aecac7$var$isHexadecimalCharacter(code) {
    return code >= $6c3be22c80aecac7$var$CharCodes.UPPER_A && code <= $6c3be22c80aecac7$var$CharCodes.UPPER_F || code >= $6c3be22c80aecac7$var$CharCodes.LOWER_A && code <= $6c3be22c80aecac7$var$CharCodes.LOWER_F;
}
function $6c3be22c80aecac7$var$isAsciiAlphaNumeric(code) {
    return code >= $6c3be22c80aecac7$var$CharCodes.UPPER_A && code <= $6c3be22c80aecac7$var$CharCodes.UPPER_Z || code >= $6c3be22c80aecac7$var$CharCodes.LOWER_A && code <= $6c3be22c80aecac7$var$CharCodes.LOWER_Z || $6c3be22c80aecac7$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $6c3be22c80aecac7$var$isEntityInAttributeInvalidEnd(code) {
    return code === $6c3be22c80aecac7$var$CharCodes.EQUALS || $6c3be22c80aecac7$var$isAsciiAlphaNumeric(code);
}
var $6c3be22c80aecac7$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($6c3be22c80aecac7$var$EntityDecoderState || ($6c3be22c80aecac7$var$EntityDecoderState = {}));
var $6c3be22c80aecac7$export$8c8f129ce60f53c;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($6c3be22c80aecac7$export$8c8f129ce60f53c || ($6c3be22c80aecac7$export$8c8f129ce60f53c = {}));
class $6c3be22c80aecac7$export$15263a93ff7ec8ba {
    constructor(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors){
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $6c3be22c80aecac7$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $6c3be22c80aecac7$export$8c8f129ce60f53c.Strict;
    }
    /** Resets the instance to make it reusable. */ startEntity(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = $6c3be22c80aecac7$var$EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    }
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param string The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ write(str, offset) {
        switch(this.state){
            case $6c3be22c80aecac7$var$EntityDecoderState.EntityStart:
                if (str.charCodeAt(offset) === $6c3be22c80aecac7$var$CharCodes.NUM) {
                    this.state = $6c3be22c80aecac7$var$EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(str, offset + 1);
                }
                this.state = $6c3be22c80aecac7$var$EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(str, offset);
            case $6c3be22c80aecac7$var$EntityDecoderState.NumericStart:
                return this.stateNumericStart(str, offset);
            case $6c3be22c80aecac7$var$EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(str, offset);
            case $6c3be22c80aecac7$var$EntityDecoderState.NumericHex:
                return this.stateNumericHex(str, offset);
            case $6c3be22c80aecac7$var$EntityDecoderState.NamedEntity:
                return this.stateNamedEntity(str, offset);
        }
    }
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericStart(str, offset) {
        if (offset >= str.length) return -1;
        if ((str.charCodeAt(offset) | $6c3be22c80aecac7$var$TO_LOWER_BIT) === $6c3be22c80aecac7$var$CharCodes.LOWER_X) {
            this.state = $6c3be22c80aecac7$var$EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(str, offset + 1);
        }
        this.state = $6c3be22c80aecac7$var$EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(str, offset);
    }
    addToNumericResult(str, start, end, base) {
        if (start !== end) {
            const digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    }
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericHex(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if ($6c3be22c80aecac7$var$isNumber(char) || $6c3be22c80aecac7$var$isHexadecimalCharacter(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 16);
        return -1;
    }
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericDecimal(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if ($6c3be22c80aecac7$var$isNumber(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 10);
        return -1;
    }
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ emitNumericEntity(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === $6c3be22c80aecac7$var$CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === $6c3be22c80aecac7$export$8c8f129ce60f53c.Strict) return 0;
        this.emitCodePoint((0, $fJ3ZX.replaceCodePoint)(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== $6c3be22c80aecac7$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    }
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNamedEntity(str, offset) {
        const { decodeTree: decodeTree } = this;
        let current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        let valueLength = (current & $6c3be22c80aecac7$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        for(; offset < str.length; offset++, this.excess++){
            const char = str.charCodeAt(offset);
            this.treeIndex = $6c3be22c80aecac7$export$44c08d99945e6276(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === $6c3be22c80aecac7$export$8c8f129ce60f53c.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            $6c3be22c80aecac7$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
            current = decodeTree[this.treeIndex];
            valueLength = (current & $6c3be22c80aecac7$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === $6c3be22c80aecac7$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== $6c3be22c80aecac7$export$8c8f129ce60f53c.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    }
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ emitNotTerminatedNamedEntity() {
        var _a;
        const { result: result, decodeTree: decodeTree } = this;
        const valueLength = (decodeTree[result] & $6c3be22c80aecac7$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    }
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ emitNamedEntityData(result, valueLength, consumed) {
        const { decodeTree: decodeTree } = this;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$6c3be22c80aecac7$export$6a4325c613e0faec.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    }
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ end() {
        var _a;
        switch(this.state){
            case $6c3be22c80aecac7$var$EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== $6c3be22c80aecac7$export$8c8f129ce60f53c.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $6c3be22c80aecac7$var$EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $6c3be22c80aecac7$var$EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $6c3be22c80aecac7$var$EntityDecoderState.NumericStart:
                (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            case $6c3be22c80aecac7$var$EntityDecoderState.EntityStart:
                // Return 0 if we have no entity.
                return 0;
        }
    }
}
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $6c3be22c80aecac7$var$getDecoder(decodeTree) {
    let ret = "";
    const decoder = new $6c3be22c80aecac7$export$15263a93ff7ec8ba(decodeTree, (str)=>ret += (0, $fJ3ZX.fromCodePoint)(str));
    return function decodeWithTrie(str, decodeMode) {
        let lastIndex = 0;
        let offset = 0;
        while((offset = str.indexOf("&", offset)) >= 0){
            ret += str.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            const len = decoder.write(str, // Skip the "&"
            offset + 1);
            if (len < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + len;
            // If `len` is 0, skip the current `&` and continue.
            offset = len === 0 ? lastIndex + 1 : lastIndex;
        }
        const result = ret + str.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        ret = "";
        return result;
    };
}
function $6c3be22c80aecac7$export$44c08d99945e6276(decodeTree, current, nodeIdx, char) {
    const branchCount = (current & $6c3be22c80aecac7$export$6a4325c613e0faec.BRANCH_LENGTH) >> 7;
    const jumpOffset = current & $6c3be22c80aecac7$export$6a4325c613e0faec.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        const value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    let lo = nodeIdx;
    let hi = lo + branchCount - 1;
    while(lo <= hi){
        const mid = lo + hi >>> 1;
        const midVal = decodeTree[mid];
        if (midVal < char) lo = mid + 1;
        else if (midVal > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
const $6c3be22c80aecac7$var$htmlDecoder = $6c3be22c80aecac7$var$getDecoder((0, $j3h6Q.default));
const $6c3be22c80aecac7$var$xmlDecoder = $6c3be22c80aecac7$var$getDecoder((0, $7Ui2N.default));
function $6c3be22c80aecac7$export$f045cb747ce77a19(str, mode = $6c3be22c80aecac7$export$8c8f129ce60f53c.Legacy) {
    return $6c3be22c80aecac7$var$htmlDecoder(str, mode);
}
function $6c3be22c80aecac7$export$49f5e8089adb006a(str) {
    return $6c3be22c80aecac7$var$htmlDecoder(str, $6c3be22c80aecac7$export$8c8f129ce60f53c.Attribute);
}
function $6c3be22c80aecac7$export$da52f4371b3f37de(str) {
    return $6c3be22c80aecac7$var$htmlDecoder(str, $6c3be22c80aecac7$export$8c8f129ce60f53c.Strict);
}
function $6c3be22c80aecac7$export$88e3b9643a8bd06e(str) {
    return $6c3be22c80aecac7$var$xmlDecoder(str, $6c3be22c80aecac7$export$8c8f129ce60f53c.Strict);
}

});
parcelRegister("j3h6Q", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ddeb91b5ddfb9405$export$2e2bcd8739ae039; });
// Generated using scripts/write-decode-map.ts
var $ddeb91b5ddfb9405$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
"\u1d41<\xd5\u0131\u028a\u049d\u057b\u05d0\u0675\u06de\u07a2\u07d6\u080f\u0a4a\u0a91\u0da1\u0e6d\u0f09\u0f26\u10ca\u1228\u12e1\u1415\u149d\u14c3\u14df\u1525\0\0\0\0\0\0\u156b\u16cd\u198d\u1c12\u1ddd\u1f7e\u2060\u21b0\u228d\u23c0\u23fb\u2442\u2824\u2912\u2d08\u2e48\u2fce\u3016\u32ba\u3639\u37ac\u38fe\u3a28\u3a71\u3ae0\u3b2e\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803b\xc6\u40c6P\u803b&\u4026cute\u803b\xc1\u40c1reve;\u4102\u0100iyx}rc\u803b\xc2\u40c2;\u4410r;\uc000\ud835\udd04rave\u803b\xc0\u40c0pha;\u4391acr;\u4100d;\u6a53\u0100gp\x9d\xa1on;\u4104f;\uc000\ud835\udd38plyFunction;\u6061ing\u803b\xc5\u40c5\u0100cs\xbe\xc3r;\uc000\ud835\udc9cign;\u6254ilde\u803b\xc3\u40c3ml\u803b\xc4\u40c4\u0400aceforsu\xe5\xfb\xfe\u0117\u011c\u0122\u0127\u012a\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6ae7ed;\u6306y;\u4411\u0180crt\u0105\u010b\u0114ause;\u6235noullis;\u612ca;\u4392r;\uc000\ud835\udd05pf;\uc000\ud835\udd39eve;\u42d8c\xf2\u0113mpeq;\u624e\u0700HOacdefhilorsu\u014d\u0151\u0156\u0180\u019e\u01a2\u01b5\u01b7\u01ba\u01dc\u0215\u0273\u0278\u027ecy;\u4427PY\u803b\xa9\u40a9\u0180cpy\u015d\u0162\u017aute;\u4106\u0100;i\u0167\u0168\u62d2talDifferentialD;\u6145leys;\u612d\u0200aeio\u0189\u018e\u0194\u0198ron;\u410cdil\u803b\xc7\u40c7rc;\u4108nint;\u6230ot;\u410a\u0100dn\u01a7\u01adilla;\u40b8terDot;\u40b7\xf2\u017fi;\u43a7rcle\u0200DMPT\u01c7\u01cb\u01d1\u01d6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01e2\u01f8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020foubleQuote;\u601duote;\u6019\u0200lnpu\u021e\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6a74\u0180git\u022f\u0236\u023aruent;\u6261nt;\u622fourIntegral;\u622e\u0100fr\u024c\u024e;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6a2fcr;\uc000\ud835\udc9ep\u0100;C\u0284\u0285\u62d3ap;\u624d\u0580DJSZacefios\u02a0\u02ac\u02b0\u02b4\u02b8\u02cb\u02d7\u02e1\u02e6\u0333\u048d\u0100;o\u0179\u02a5trahd;\u6911cy;\u4402cy;\u4405cy;\u440f\u0180grs\u02bf\u02c4\u02c7ger;\u6021r;\u61a1hv;\u6ae4\u0100ay\u02d0\u02d5ron;\u410e;\u4414l\u0100;t\u02dd\u02de\u6207a;\u4394r;\uc000\ud835\udd07\u0100af\u02eb\u0327\u0100cm\u02f0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031ccute;\u40b4o\u0174\u030b\u030d;\u42d9bleAcute;\u42ddrave;\u4060ilde;\u42dcond;\u62c4ferentialD;\u6146\u0470\u033d\0\0\0\u0342\u0354\0\u0405f;\uc000\ud835\udd3b\u0180;DE\u0348\u0349\u034d\u40a8ot;\u60dcqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03cf\u03e2\u03f8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037b\xbb\u0349nArrow;\u61d3\u0100eo\u0387\u03a4ft\u0180ART\u0390\u0396\u03a1rrow;\u61d0ightArrow;\u61d4e\xe5\u02cang\u0100LR\u03ab\u03c4eft\u0100AR\u03b3\u03b9rrow;\u67f8ightArrow;\u67faightArrow;\u67f9ight\u0100AT\u03d8\u03derrow;\u61d2ee;\u62a8p\u0241\u03e9\0\0\u03efrrow;\u61d1ownArrow;\u61d5erticalBar;\u6225n\u0300ABLRTa\u0412\u042a\u0430\u045e\u047f\u037crrow\u0180;BU\u041d\u041e\u0422\u6193ar;\u6913pArrow;\u61f5reve;\u4311eft\u02d2\u043a\0\u0446\0\u0450ightVector;\u6950eeVector;\u695eector\u0100;B\u0459\u045a\u61bdar;\u6956ight\u01d4\u0467\0\u0471eeVector;\u695fector\u0100;B\u047a\u047b\u61c1ar;\u6957ee\u0100;A\u0486\u0487\u62a4rrow;\u61a7\u0100ct\u0492\u0497r;\uc000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04bd\u04c0\u04c4\u04cb\u04de\u04e2\u04e7\u04ee\u04f5\u0521\u052f\u0536\u0552\u055d\u0560\u0565G;\u414aH\u803b\xd0\u40d0cute\u803b\xc9\u40c9\u0180aiy\u04d2\u04d7\u04dcron;\u411arc\u803b\xca\u40ca;\u442dot;\u4116r;\uc000\ud835\udd08rave\u803b\xc8\u40c8ement;\u6208\u0100ap\u04fa\u04fecr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65fberySmallSquare;\u65ab\u0100gp\u0526\u052aon;\u4118f;\uc000\ud835\udd3csilon;\u4395u\u0100ai\u053c\u0549l\u0100;T\u0542\u0543\u6a75ilde;\u6242librium;\u61cc\u0100ci\u0557\u055ar;\u6130m;\u6a73a;\u4397ml\u803b\xcb\u40cb\u0100ip\u056a\u056fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058d\u05b2\u05ccy;\u4424r;\uc000\ud835\udd09lled\u0253\u0597\0\0\u05a3mallSquare;\u65fcerySmallSquare;\u65aa\u0370\u05ba\0\u05bf\0\0\u05c4f;\uc000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05cb\u0600JTabcdfgorst\u05e8\u05ec\u05ef\u05fa\u0600\u0612\u0616\u061b\u061d\u0623\u066c\u0672cy;\u4403\u803b>\u403emma\u0100;d\u05f7\u05f8\u4393;\u43dcreve;\u411e\u0180eiy\u0607\u060c\u0610dil;\u4122rc;\u411c;\u4413ot;\u4120r;\uc000\ud835\udd0a;\u62d9pf;\uc000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064e\u0656\u065b\u0666qual\u0100;L\u063e\u063f\u6265ess;\u62dbullEqual;\u6267reater;\u6aa2ess;\u6277lantEqual;\u6a7eilde;\u6273cr;\uc000\ud835\udca2;\u626b\u0400Aacfiosu\u0685\u068b\u0696\u069b\u069e\u06aa\u06be\u06caRDcy;\u442a\u0100ct\u0690\u0694ek;\u42c7;\u405eirc;\u4124r;\u610clbertSpace;\u610b\u01f0\u06af\0\u06b2f;\u610dizontalLine;\u6500\u0100ct\u06c3\u06c5\xf2\u06a9rok;\u4126mp\u0144\u06d0\u06d8ownHum\xf0\u012fqual;\u624f\u0700EJOacdfgmnostu\u06fa\u06fe\u0703\u0707\u070e\u071a\u071e\u0721\u0728\u0744\u0778\u078b\u078f\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803b\xcd\u40cd\u0100iy\u0713\u0718rc\u803b\xce\u40ce;\u4418ot;\u4130r;\u6111rave\u803b\xcc\u40cc\u0180;ap\u0720\u072f\u073f\u0100cg\u0734\u0737r;\u412ainaryI;\u6148lie\xf3\u03dd\u01f4\u0749\0\u0762\u0100;e\u074d\u074e\u622c\u0100gr\u0753\u0758ral;\u622bsection;\u62c2isible\u0100CT\u076c\u0772omma;\u6063imes;\u6062\u0180gpt\u077f\u0783\u0788on;\u412ef;\uc000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01eb\u079a\0\u079ecy;\u4406l\u803b\xcf\u40cf\u0280cfosu\u07ac\u07b7\u07bc\u07c2\u07d0\u0100iy\u07b1\u07b5rc;\u4134;\u4419r;\uc000\ud835\udd0dpf;\uc000\ud835\udd41\u01e3\u07c7\0\u07ccr;\uc000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07e4\u07e8\u07ec\u07f1\u07fd\u0802\u0808cy;\u4425cy;\u440cppa;\u439a\u0100ey\u07f6\u07fbdil;\u4136;\u441ar;\uc000\ud835\udd0epf;\uc000\ud835\udd42cr;\uc000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082c\u0850\u0863\u09b3\u09b8\u09c7\u09cd\u0a37\u0a47cy;\u4409\u803b<\u403c\u0280cmnpr\u0837\u083c\u0841\u0844\u084dute;\u4139bda;\u439bg;\u67ealacetrf;\u6112r;\u619e\u0180aey\u0857\u085c\u0861ron;\u413ddil;\u413b;\u441b\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087e\u08a9\u08b1\u08e0\u08e6\u08fc\u092f\u095b\u0390\u096a\u0100nr\u0883\u088fgleBracket;\u67e8row\u0180;BR\u0899\u089a\u089e\u6190ar;\u61e4ightArrow;\u61c6eiling;\u6308o\u01f5\u08b7\0\u08c3bleBracket;\u67e6n\u01d4\u08c8\0\u08d2eeVector;\u6961ector\u0100;B\u08db\u08dc\u61c3ar;\u6959loor;\u630aight\u0100AV\u08ef\u08f5rrow;\u6194ector;\u694e\u0100er\u0901\u0917e\u0180;AV\u0909\u090a\u0910\u62a3rrow;\u61a4ector;\u695aiangle\u0180;BE\u0924\u0925\u0929\u62b2ar;\u69cfqual;\u62b4p\u0180DTV\u0937\u0942\u094cownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61bfar;\u6958ector\u0100;B\u0965\u0966\u61bcar;\u6952ight\xe1\u039cs\u0300EFGLST\u097e\u098b\u0995\u099d\u09a2\u09adqualGreater;\u62daullEqual;\u6266reater;\u6276ess;\u6aa1lantEqual;\u6a7dilde;\u6272r;\uc000\ud835\udd0f\u0100;e\u09bd\u09be\u62d8ftarrow;\u61daidot;\u413f\u0180npw\u09d4\u0a16\u0a1bg\u0200LRlr\u09de\u09f7\u0a02\u0a10eft\u0100AR\u09e6\u09ecrrow;\u67f5ightArrow;\u67f7ightArrow;\u67f6eft\u0100ar\u03b3\u0a0aight\xe1\u03bfight\xe1\u03caf;\uc000\ud835\udd43er\u0100LR\u0a22\u0a2ceftArrow;\u6199ightArrow;\u6198\u0180cht\u0a3e\u0a40\u0a42\xf2\u084c;\u61b0rok;\u4141;\u626a\u0400acefiosu\u0a5a\u0a5d\u0a60\u0a77\u0a7c\u0a85\u0a8b\u0a8ep;\u6905y;\u441c\u0100dl\u0a65\u0a6fiumSpace;\u605flintrf;\u6133r;\uc000\ud835\udd10nusPlus;\u6213pf;\uc000\ud835\udd44c\xf2\u0a76;\u439c\u0480Jacefostu\u0aa3\u0aa7\u0aad\u0ac0\u0b14\u0b19\u0d91\u0d97\u0d9ecy;\u440acute;\u4143\u0180aey\u0ab4\u0ab9\u0aberon;\u4147dil;\u4145;\u441d\u0180gsw\u0ac7\u0af0\u0b0eative\u0180MTV\u0ad3\u0adf\u0ae8ediumSpace;\u600bhi\u0100cn\u0ae6\u0ad8\xeb\u0ad9eryThi\xee\u0ad9ted\u0100GL\u0af8\u0b06reaterGreate\xf2\u0673essLes\xf3\u0a48Line;\u400ar;\uc000\ud835\udd11\u0200Bnpt\u0b22\u0b28\u0b37\u0b3areak;\u6060BreakingSpace;\u40a0f;\u6115\u0680;CDEGHLNPRSTV\u0b55\u0b56\u0b6a\u0b7c\u0ba1\u0beb\u0c04\u0c5e\u0c84\u0ca6\u0cd8\u0d61\u0d85\u6aec\u0100ou\u0b5b\u0b64ngruent;\u6262pCap;\u626doubleVerticalBar;\u6226\u0180lqx\u0b83\u0b8a\u0b9bement;\u6209ual\u0100;T\u0b92\u0b93\u6260ilde;\uc000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0bb6\u0bb7\u0bbd\u0bc9\u0bd3\u0bd8\u0be5\u626fqual;\u6271ullEqual;\uc000\u2267\u0338reater;\uc000\u226b\u0338ess;\u6279lantEqual;\uc000\u2a7e\u0338ilde;\u6275ump\u0144\u0bf2\u0bfdownHump;\uc000\u224e\u0338qual;\uc000\u224f\u0338e\u0100fs\u0c0a\u0c27tTriangle\u0180;BE\u0c1a\u0c1b\u0c21\u62eaar;\uc000\u29cf\u0338qual;\u62ecs\u0300;EGLST\u0c35\u0c36\u0c3c\u0c44\u0c4b\u0c58\u626equal;\u6270reater;\u6278ess;\uc000\u226a\u0338lantEqual;\uc000\u2a7d\u0338ilde;\u6274ested\u0100GL\u0c68\u0c79reaterGreater;\uc000\u2aa2\u0338essLess;\uc000\u2aa1\u0338recedes\u0180;ES\u0c92\u0c93\u0c9b\u6280qual;\uc000\u2aaf\u0338lantEqual;\u62e0\u0100ei\u0cab\u0cb9verseElement;\u620cghtTriangle\u0180;BE\u0ccb\u0ccc\u0cd2\u62ebar;\uc000\u29d0\u0338qual;\u62ed\u0100qu\u0cdd\u0d0cuareSu\u0100bp\u0ce8\u0cf9set\u0100;E\u0cf0\u0cf3\uc000\u228f\u0338qual;\u62e2erset\u0100;E\u0d03\u0d06\uc000\u2290\u0338qual;\u62e3\u0180bcp\u0d13\u0d24\u0d4eset\u0100;E\u0d1b\u0d1e\uc000\u2282\u20d2qual;\u6288ceeds\u0200;EST\u0d32\u0d33\u0d3b\u0d46\u6281qual;\uc000\u2ab0\u0338lantEqual;\u62e1ilde;\uc000\u227f\u0338erset\u0100;E\u0d58\u0d5b\uc000\u2283\u20d2qual;\u6289ilde\u0200;EFT\u0d6e\u0d6f\u0d75\u0d7f\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uc000\ud835\udca9ilde\u803b\xd1\u40d1;\u439d\u0700Eacdfgmoprstuv\u0dbd\u0dc2\u0dc9\u0dd5\u0ddb\u0de0\u0de7\u0dfc\u0e02\u0e20\u0e22\u0e32\u0e3f\u0e44lig;\u4152cute\u803b\xd3\u40d3\u0100iy\u0dce\u0dd3rc\u803b\xd4\u40d4;\u441eblac;\u4150r;\uc000\ud835\udd12rave\u803b\xd2\u40d2\u0180aei\u0dee\u0df2\u0df6cr;\u414cga;\u43a9cron;\u439fpf;\uc000\ud835\udd46enCurly\u0100DQ\u0e0e\u0e1aoubleQuote;\u601cuote;\u6018;\u6a54\u0100cl\u0e27\u0e2cr;\uc000\ud835\udcaaash\u803b\xd8\u40d8i\u016c\u0e37\u0e3cde\u803b\xd5\u40d5es;\u6a37ml\u803b\xd6\u40d6er\u0100BP\u0e4b\u0e60\u0100ar\u0e50\u0e53r;\u603eac\u0100ek\u0e5a\u0e5c;\u63deet;\u63b4arenthesis;\u63dc\u0480acfhilors\u0e7f\u0e87\u0e8a\u0e8f\u0e92\u0e94\u0e9d\u0eb0\u0efcrtialD;\u6202y;\u441fr;\uc000\ud835\udd13i;\u43a6;\u43a0usMinus;\u40b1\u0100ip\u0ea2\u0eadncareplan\xe5\u069df;\u6119\u0200;eio\u0eb9\u0eba\u0ee0\u0ee4\u6abbcedes\u0200;EST\u0ec8\u0ec9\u0ecf\u0eda\u627aqual;\u6aaflantEqual;\u627cilde;\u627eme;\u6033\u0100dp\u0ee9\u0eeeuct;\u620fortion\u0100;a\u0225\u0ef9l;\u621d\u0100ci\u0f01\u0f06r;\uc000\ud835\udcab;\u43a8\u0200Ufos\u0f11\u0f16\u0f1b\u0f1fOT\u803b\"\u4022r;\uc000\ud835\udd14pf;\u611acr;\uc000\ud835\udcac\u0600BEacefhiorsu\u0f3e\u0f43\u0f47\u0f60\u0f73\u0fa7\u0faa\u0fad\u1096\u10a9\u10b4\u10bearr;\u6910G\u803b\xae\u40ae\u0180cnr\u0f4e\u0f53\u0f56ute;\u4154g;\u67ebr\u0100;t\u0f5c\u0f5d\u61a0l;\u6916\u0180aey\u0f67\u0f6c\u0f71ron;\u4158dil;\u4156;\u4420\u0100;v\u0f78\u0f79\u611cerse\u0100EU\u0f82\u0f99\u0100lq\u0f87\u0f8eement;\u620builibrium;\u61cbpEquilibrium;\u696fr\xbb\u0f79o;\u43a1ght\u0400ACDFTUVa\u0fc1\u0feb\u0ff3\u1022\u1028\u105b\u1087\u03d8\u0100nr\u0fc6\u0fd2gleBracket;\u67e9row\u0180;BL\u0fdc\u0fdd\u0fe1\u6192ar;\u61e5eftArrow;\u61c4eiling;\u6309o\u01f5\u0ff9\0\u1005bleBracket;\u67e7n\u01d4\u100a\0\u1014eeVector;\u695dector\u0100;B\u101d\u101e\u61c2ar;\u6955loor;\u630b\u0100er\u102d\u1043e\u0180;AV\u1035\u1036\u103c\u62a2rrow;\u61a6ector;\u695biangle\u0180;BE\u1050\u1051\u1055\u62b3ar;\u69d0qual;\u62b5p\u0180DTV\u1063\u106e\u1078ownVector;\u694feeVector;\u695cector\u0100;B\u1082\u1083\u61bear;\u6954ector\u0100;B\u1091\u1092\u61c0ar;\u6953\u0100pu\u109b\u109ef;\u611dndImplies;\u6970ightarrow;\u61db\u0100ch\u10b9\u10bcr;\u611b;\u61b1leDelayed;\u69f4\u0680HOacfhimoqstu\u10e4\u10f1\u10f7\u10fd\u1119\u111e\u1151\u1156\u1161\u1167\u11b5\u11bb\u11bf\u0100Cc\u10e9\u10eeHcy;\u4429y;\u4428FTcy;\u442ccute;\u415a\u0280;aeiy\u1108\u1109\u110e\u1113\u1117\u6abcron;\u4160dil;\u415erc;\u415c;\u4421r;\uc000\ud835\udd16ort\u0200DLRU\u112a\u1134\u113e\u1149ownArrow\xbb\u041eeftArrow\xbb\u089aightArrow\xbb\u0fddpArrow;\u6191gma;\u43a3allCircle;\u6218pf;\uc000\ud835\udd4a\u0272\u116d\0\0\u1170t;\u621aare\u0200;ISU\u117b\u117c\u1189\u11af\u65a1ntersection;\u6293u\u0100bp\u118f\u119eset\u0100;E\u1197\u1198\u628fqual;\u6291erset\u0100;E\u11a8\u11a9\u6290qual;\u6292nion;\u6294cr;\uc000\ud835\udcaear;\u62c6\u0200bcmp\u11c8\u11db\u1209\u120b\u0100;s\u11cd\u11ce\u62d0et\u0100;E\u11cd\u11d5qual;\u6286\u0100ch\u11e0\u1205eeds\u0200;EST\u11ed\u11ee\u11f4\u11ff\u627bqual;\u6ab0lantEqual;\u627dilde;\u627fTh\xe1\u0f8c;\u6211\u0180;es\u1212\u1213\u1223\u62d1rset\u0100;E\u121c\u121d\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123e\u1244\u1249\u1255\u125e\u1271\u1276\u129f\u12c2\u12c8\u12d1ORN\u803b\xde\u40deADE;\u6122\u0100Hc\u124e\u1252cy;\u440by;\u4426\u0100bu\u125a\u125c;\u4009;\u43a4\u0180aey\u1265\u126a\u126fron;\u4164dil;\u4162;\u4422r;\uc000\ud835\udd17\u0100ei\u127b\u1289\u01f2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128e\u1298kSpace;\uc000\u205f\u200aSpace;\u6009lde\u0200;EFT\u12ab\u12ac\u12b2\u12bc\u623cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uc000\ud835\udd4bipleDot;\u60db\u0100ct\u12d6\u12dbr;\uc000\ud835\udcafrok;\u4166\u0ae1\u12f7\u130e\u131a\u1326\0\u132c\u1331\0\0\0\0\0\u1338\u133d\u1377\u1385\0\u13ff\u1404\u140a\u1410\u0100cr\u12fb\u1301ute\u803b\xda\u40dar\u0100;o\u1307\u1308\u619fcir;\u6949r\u01e3\u1313\0\u1316y;\u440eve;\u416c\u0100iy\u131e\u1323rc\u803b\xdb\u40db;\u4423blac;\u4170r;\uc000\ud835\udd18rave\u803b\xd9\u40d9acr;\u416a\u0100di\u1341\u1369er\u0100BP\u1348\u135d\u0100ar\u134d\u1350r;\u405fac\u0100ek\u1357\u1359;\u63dfet;\u63b5arenthesis;\u63ddon\u0100;P\u1370\u1371\u62c3lus;\u628e\u0100gp\u137b\u137fon;\u4172f;\uc000\ud835\udd4c\u0400ADETadps\u1395\u13ae\u13b8\u13c4\u03e8\u13d2\u13d7\u13f3rrow\u0180;BD\u1150\u13a0\u13a4ar;\u6912ownArrow;\u61c5ownArrow;\u6195quilibrium;\u696eee\u0100;A\u13cb\u13cc\u62a5rrow;\u61a5own\xe1\u03f3er\u0100LR\u13de\u13e8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13f9\u13fa\u43d2on;\u43a5ing;\u416ecr;\uc000\ud835\udcb0ilde;\u4168ml\u803b\xdc\u40dc\u0480Dbcdefosv\u1427\u142c\u1430\u1433\u143e\u1485\u148a\u1490\u1496ash;\u62abar;\u6aeby;\u4412ash\u0100;l\u143b\u143c\u62a9;\u6ae6\u0100er\u1443\u1445;\u62c1\u0180bty\u144c\u1450\u147aar;\u6016\u0100;i\u144f\u1455cal\u0200BLST\u1461\u1465\u146a\u1474ar;\u6223ine;\u407ceparator;\u6758ilde;\u6240ThinSpace;\u600ar;\uc000\ud835\udd19pf;\uc000\ud835\udd4dcr;\uc000\ud835\udcb1dash;\u62aa\u0280cefos\u14a7\u14ac\u14b1\u14b6\u14bcirc;\u4174dge;\u62c0r;\uc000\ud835\udd1apf;\uc000\ud835\udd4ecr;\uc000\ud835\udcb2\u0200fios\u14cb\u14d0\u14d2\u14d8r;\uc000\ud835\udd1b;\u439epf;\uc000\ud835\udd4fcr;\uc000\ud835\udcb3\u0480AIUacfosu\u14f1\u14f5\u14f9\u14fd\u1504\u150f\u1514\u151a\u1520cy;\u442fcy;\u4407cy;\u442ecute\u803b\xdd\u40dd\u0100iy\u1509\u150drc;\u4176;\u442br;\uc000\ud835\udd1cpf;\uc000\ud835\udd50cr;\uc000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153f\u154b\u154f\u155d\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417d;\u4417ot;\u417b\u01f2\u1554\0\u155boWidt\xe8\u0ad9a;\u4396r;\u6128pf;\u6124cr;\uc000\ud835\udcb5\u0be1\u1583\u158a\u1590\0\u15b0\u15b6\u15bf\0\0\0\0\u15c6\u15db\u15eb\u165f\u166d\0\u1695\u169b\u16b2\u16b9\0\u16becute\u803b\xe1\u40e1reve;\u4103\u0300;Ediuy\u159c\u159d\u15a1\u15a3\u15a8\u15ad\u623e;\uc000\u223e\u0333;\u623frc\u803b\xe2\u40e2te\u80bb\xb4\u0306;\u4430lig\u803b\xe6\u40e6\u0100;r\xb2\u15ba;\uc000\ud835\udd1erave\u803b\xe0\u40e0\u0100ep\u15ca\u15d6\u0100fp\u15cf\u15d4sym;\u6135\xe8\u15d3ha;\u43b1\u0100ap\u15dfc\u0100cl\u15e4\u15e7r;\u4101g;\u6a3f\u0264\u15f0\0\0\u160a\u0280;adsv\u15fa\u15fb\u15ff\u1601\u1607\u6227nd;\u6a55;\u6a5clope;\u6a58;\u6a5a\u0380;elmrsz\u1618\u1619\u161b\u161e\u163f\u164f\u1659\u6220;\u69a4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163a\u163c\u163e;\u69a8;\u69a9;\u69aa;\u69ab;\u69ac;\u69ad;\u69ae;\u69aft\u0100;v\u1645\u1646\u621fb\u0100;d\u164c\u164d\u62be;\u699d\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637c\u0100gp\u1663\u1667on;\u4105f;\uc000\ud835\udd52\u0380;Eaeiop\u12c1\u167b\u167d\u1682\u1684\u1687\u168a;\u6a70cir;\u6a6f;\u624ad;\u624bs;\u4027rox\u0100;e\u12c1\u1692\xf1\u1683ing\u803b\xe5\u40e5\u0180cty\u16a1\u16a6\u16a8r;\uc000\ud835\udcb6;\u402amp\u0100;e\u12c1\u16af\xf1\u0288ilde\u803b\xe3\u40e3ml\u803b\xe4\u40e4\u0100ci\u16c2\u16c8onin\xf4\u0272nt;\u6a11\u0800Nabcdefiklnoprsu\u16ed\u16f1\u1730\u173c\u1743\u1748\u1778\u177d\u17e0\u17e6\u1839\u1850\u170d\u193d\u1948\u1970ot;\u6aed\u0100cr\u16f6\u171ek\u0200ceps\u1700\u1705\u170d\u1713ong;\u624cpsilon;\u43f6rime;\u6035im\u0100;e\u171a\u171b\u623dq;\u62cd\u0176\u1722\u1726ee;\u62bded\u0100;g\u172c\u172d\u6305e\xbb\u172drk\u0100;t\u135c\u1737brk;\u63b6\u0100oy\u1701\u1741;\u4431quo;\u601e\u0280cmprt\u1753\u175b\u1761\u1764\u1768aus\u0100;e\u010a\u0109ptyv;\u69b0s\xe9\u170cno\xf5\u0113\u0180ahw\u176f\u1771\u1773;\u43b2;\u6136een;\u626cr;\uc000\ud835\udd1fg\u0380costuvw\u178d\u179d\u17b3\u17c1\u17d5\u17db\u17de\u0180aiu\u1794\u1796\u179a\xf0\u0760rc;\u65efp\xbb\u1371\u0180dpt\u17a4\u17a8\u17adot;\u6a00lus;\u6a01imes;\u6a02\u0271\u17b9\0\0\u17becup;\u6a06ar;\u6605riangle\u0100du\u17cd\u17d2own;\u65bdp;\u65b3plus;\u6a04e\xe5\u1444\xe5\u14adarow;\u690d\u0180ako\u17ed\u1826\u1835\u0100cn\u17f2\u1823k\u0180lst\u17fa\u05ab\u1802ozenge;\u69ebriangle\u0200;dlr\u1812\u1813\u1818\u181d\u65b4own;\u65beeft;\u65c2ight;\u65b8k;\u6423\u01b1\u182b\0\u1833\u01b2\u182f\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183e\u184d\u0100;q\u1843\u1846\uc000=\u20e5uiv;\uc000\u2261\u20e5t;\u6310\u0200ptwx\u1859\u185e\u1867\u186cf;\uc000\ud835\udd53\u0100;t\u13cb\u1863om\xbb\u13cctie;\u62c8\u0600DHUVbdhmptuv\u1885\u1896\u18aa\u18bb\u18d7\u18db\u18ec\u18ff\u1905\u190a\u1910\u1921\u0200LRlr\u188e\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18a1\u18a2\u18a4\u18a6\u18a8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18b3\u18b5\u18b7\u18b9;\u655d;\u655a;\u655c;\u6559\u0380;HLRhlr\u18ca\u18cb\u18cd\u18cf\u18d1\u18d3\u18d5\u6551;\u656c;\u6563;\u6560;\u656b;\u6562;\u655fox;\u69c9\u0200LRlr\u18e4\u18e6\u18e8\u18ea;\u6555;\u6552;\u6510;\u650c\u0280;DUdu\u06bd\u18f7\u18f9\u18fb\u18fd;\u6565;\u6568;\u652c;\u6534inus;\u629flus;\u629eimes;\u62a0\u0200LRlr\u1919\u191b\u191d\u191f;\u655b;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193b\u6502;\u656a;\u6561;\u655e;\u653c;\u6524;\u651c\u0100ev\u0123\u1942bar\u803b\xa6\u40a6\u0200ceio\u1951\u1956\u195a\u1960r;\uc000\ud835\udcb7mi;\u604fm\u0100;e\u171a\u171cl\u0180;bh\u1968\u1969\u196b\u405c;\u69c5sub;\u67c8\u016c\u1974\u197el\u0100;e\u1979\u197a\u6022t\xbb\u197ap\u0180;Ee\u012f\u1985\u1987;\u6aae\u0100;q\u06dc\u06db\u0ce1\u19a7\0\u19e8\u1a11\u1a15\u1a32\0\u1a37\u1a50\0\0\u1ab4\0\0\u1ac1\0\0\u1b21\u1b2e\u1b4d\u1b52\0\u1bfd\0\u1c0c\u0180cpr\u19ad\u19b2\u19ddute;\u4107\u0300;abcds\u19bf\u19c0\u19c4\u19ca\u19d5\u19d9\u6229nd;\u6a44rcup;\u6a49\u0100au\u19cf\u19d2p;\u6a4bp;\u6a47ot;\u6a40;\uc000\u2229\ufe00\u0100eo\u19e2\u19e5t;\u6041\xee\u0693\u0200aeiu\u19f0\u19fb\u1a01\u1a05\u01f0\u19f5\0\u19f8s;\u6a4don;\u410ddil\u803b\xe7\u40e7rc;\u4109ps\u0100;s\u1a0c\u1a0d\u6a4cm;\u6a50ot;\u410b\u0180dmn\u1a1b\u1a20\u1a26il\u80bb\xb8\u01adptyv;\u69b2t\u8100\xa2;e\u1a2d\u1a2e\u40a2r\xe4\u01b2r;\uc000\ud835\udd20\u0180cei\u1a3d\u1a40\u1a4dy;\u4447ck\u0100;m\u1a47\u1a48\u6713ark\xbb\u1a48;\u43c7r\u0380;Ecefms\u1a5f\u1a60\u1a62\u1a6b\u1aa4\u1aaa\u1aae\u65cb;\u69c3\u0180;el\u1a69\u1a6a\u1a6d\u42c6q;\u6257e\u0261\u1a74\0\0\u1a88rrow\u0100lr\u1a7c\u1a81eft;\u61baight;\u61bb\u0280RSacd\u1a92\u1a94\u1a96\u1a9a\u1a9f\xbb\u0f47;\u64c8st;\u629birc;\u629aash;\u629dnint;\u6a10id;\u6aefcir;\u69c2ubs\u0100;u\u1abb\u1abc\u6663it\xbb\u1abc\u02ec\u1ac7\u1ad4\u1afa\0\u1b0aon\u0100;e\u1acd\u1ace\u403a\u0100;q\xc7\xc6\u026d\u1ad9\0\0\u1ae2a\u0100;t\u1ade\u1adf\u402c;\u4040\u0180;fl\u1ae8\u1ae9\u1aeb\u6201\xee\u1160e\u0100mx\u1af1\u1af6ent\xbb\u1ae9e\xf3\u024d\u01e7\u1afe\0\u1b07\u0100;d\u12bb\u1b02ot;\u6a6dn\xf4\u0246\u0180fry\u1b10\u1b14\u1b17;\uc000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1b1dr;\u6117\u0100ao\u1b25\u1b29rr;\u61b5ss;\u6717\u0100cu\u1b32\u1b37r;\uc000\ud835\udcb8\u0100bp\u1b3c\u1b44\u0100;e\u1b41\u1b42\u6acf;\u6ad1\u0100;e\u1b49\u1b4a\u6ad0;\u6ad2dot;\u62ef\u0380delprvw\u1b60\u1b6c\u1b77\u1b82\u1bac\u1bd4\u1bf9arr\u0100lr\u1b68\u1b6a;\u6938;\u6935\u0270\u1b72\0\0\u1b75r;\u62dec;\u62dfarr\u0100;p\u1b7f\u1b80\u61b6;\u693d\u0300;bcdos\u1b8f\u1b90\u1b96\u1ba1\u1ba5\u1ba8\u622arcap;\u6a48\u0100au\u1b9b\u1b9ep;\u6a46p;\u6a4aot;\u628dr;\u6a45;\uc000\u222a\ufe00\u0200alrv\u1bb5\u1bbf\u1bde\u1be3rr\u0100;m\u1bbc\u1bbd\u61b7;\u693cy\u0180evw\u1bc7\u1bd4\u1bd8q\u0270\u1bce\0\0\u1bd2re\xe3\u1b73u\xe3\u1b75ee;\u62ceedge;\u62cfen\u803b\xa4\u40a4earrow\u0100lr\u1bee\u1bf3eft\xbb\u1b80ight\xbb\u1bbde\xe4\u1bdd\u0100ci\u1c01\u1c07onin\xf4\u01f7nt;\u6231lcty;\u632d\u0980AHabcdefhijlorstuwz\u1c38\u1c3b\u1c3f\u1c5d\u1c69\u1c75\u1c8a\u1c9e\u1cac\u1cb7\u1cfb\u1cff\u1d0d\u1d7b\u1d91\u1dab\u1dbb\u1dc6\u1dcdr\xf2\u0381ar;\u6965\u0200glrs\u1c48\u1c4d\u1c52\u1c54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1c5a\u1c5b\u6010\xbb\u090a\u016b\u1c61\u1c67arow;\u690fa\xe3\u0315\u0100ay\u1c6e\u1c73ron;\u410f;\u4434\u0180;ao\u0332\u1c7c\u1c84\u0100gr\u02bf\u1c81r;\u61catseq;\u6a77\u0180glm\u1c91\u1c94\u1c98\u803b\xb0\u40b0ta;\u43b4ptyv;\u69b1\u0100ir\u1ca3\u1ca8sht;\u697f;\uc000\ud835\udd21ar\u0100lr\u1cb3\u1cb5\xbb\u08dc\xbb\u101e\u0280aegsv\u1cc2\u0378\u1cd6\u1cdc\u1ce0m\u0180;os\u0326\u1cca\u1cd4nd\u0100;s\u0326\u1cd1uit;\u6666amma;\u43ddin;\u62f2\u0180;io\u1ce7\u1ce8\u1cf8\u40f7de\u8100\xf7;o\u1ce7\u1cf0ntimes;\u62c7n\xf8\u1cf7cy;\u4452c\u026f\u1d06\0\0\u1d0arn;\u631eop;\u630d\u0280lptuw\u1d18\u1d1d\u1d22\u1d49\u1d55lar;\u4024f;\uc000\ud835\udd55\u0280;emps\u030b\u1d2d\u1d37\u1d3d\u1d42q\u0100;d\u0352\u1d33ot;\u6251inus;\u6238lus;\u6214quare;\u62a1blebarwedg\xe5\xfan\u0180adh\u112e\u1d5d\u1d67ownarrow\xf3\u1c83arpoon\u0100lr\u1d72\u1d76ef\xf4\u1cb4igh\xf4\u1cb6\u0162\u1d7f\u1d85karo\xf7\u0f42\u026f\u1d8a\0\0\u1d8ern;\u631fop;\u630c\u0180cot\u1d98\u1da3\u1da6\u0100ry\u1d9d\u1da1;\uc000\ud835\udcb9;\u4455l;\u69f6rok;\u4111\u0100dr\u1db0\u1db4ot;\u62f1i\u0100;f\u1dba\u1816\u65bf\u0100ah\u1dc0\u1dc3r\xf2\u0429a\xf2\u0fa6angle;\u69a6\u0100ci\u1dd2\u1dd5y;\u445fgrarr;\u67ff\u0900Dacdefglmnopqrstux\u1e01\u1e09\u1e19\u1e38\u0578\u1e3c\u1e49\u1e61\u1e7e\u1ea5\u1eaf\u1ebd\u1ee1\u1f2a\u1f37\u1f44\u1f4e\u1f5a\u0100Do\u1e06\u1d34o\xf4\u1c89\u0100cs\u1e0e\u1e14ute\u803b\xe9\u40e9ter;\u6a6e\u0200aioy\u1e22\u1e27\u1e31\u1e36ron;\u411br\u0100;c\u1e2d\u1e2e\u6256\u803b\xea\u40ealon;\u6255;\u444dot;\u4117\u0100Dr\u1e41\u1e45ot;\u6252;\uc000\ud835\udd22\u0180;rs\u1e50\u1e51\u1e57\u6a9aave\u803b\xe8\u40e8\u0100;d\u1e5c\u1e5d\u6a96ot;\u6a98\u0200;ils\u1e6a\u1e6b\u1e72\u1e74\u6a99nters;\u63e7;\u6113\u0100;d\u1e79\u1e7a\u6a95ot;\u6a97\u0180aps\u1e85\u1e89\u1e97cr;\u4113ty\u0180;sv\u1e92\u1e93\u1e95\u6205et\xbb\u1e93p\u01001;\u1e9d\u1ea4\u0133\u1ea1\u1ea3;\u6004;\u6005\u6003\u0100gs\u1eaa\u1eac;\u414bp;\u6002\u0100gp\u1eb4\u1eb8on;\u4119f;\uc000\ud835\udd56\u0180als\u1ec4\u1ece\u1ed2r\u0100;s\u1eca\u1ecb\u62d5l;\u69e3us;\u6a71i\u0180;lv\u1eda\u1edb\u1edf\u43b5on\xbb\u1edb;\u43f5\u0200csuv\u1eea\u1ef3\u1f0b\u1f23\u0100io\u1eef\u1e31rc\xbb\u1e2e\u0269\u1ef9\0\0\u1efb\xed\u0548ant\u0100gl\u1f02\u1f06tr\xbb\u1e5dess\xbb\u1e7a\u0180aei\u1f12\u1f16\u1f1als;\u403dst;\u625fv\u0100;D\u0235\u1f20D;\u6a78parsl;\u69e5\u0100Da\u1f2f\u1f33ot;\u6253rr;\u6971\u0180cdi\u1f3e\u1f41\u1ef8r;\u612fo\xf4\u0352\u0100ah\u1f49\u1f4b;\u43b7\u803b\xf0\u40f0\u0100mr\u1f53\u1f57l\u803b\xeb\u40ebo;\u60ac\u0180cip\u1f61\u1f64\u1f67l;\u4021s\xf4\u056e\u0100eo\u1f6c\u1f74ctatio\xee\u0559nential\xe5\u0579\u09e1\u1f92\0\u1f9e\0\u1fa1\u1fa7\0\0\u1fc6\u1fcc\0\u1fd3\0\u1fe6\u1fea\u2000\0\u2008\u205allingdotse\xf1\u1e44y;\u4444male;\u6640\u0180ilr\u1fad\u1fb3\u1fc1lig;\u8000\ufb03\u0269\u1fb9\0\0\u1fbdg;\u8000\ufb00ig;\u8000\ufb04;\uc000\ud835\udd23lig;\u8000\ufb01lig;\uc000fj\u0180alt\u1fd9\u1fdc\u1fe1t;\u666dig;\u8000\ufb02ns;\u65b1of;\u4192\u01f0\u1fee\0\u1ff3f;\uc000\ud835\udd57\u0100ak\u05bf\u1ff7\u0100;v\u1ffc\u1ffd\u62d4;\u6ad9artint;\u6a0d\u0100ao\u200c\u2055\u0100cs\u2011\u2052\u03b1\u201a\u2030\u2038\u2045\u2048\0\u2050\u03b2\u2022\u2025\u2027\u202a\u202c\0\u202e\u803b\xbd\u40bd;\u6153\u803b\xbc\u40bc;\u6155;\u6159;\u615b\u01b3\u2034\0\u2036;\u6154;\u6156\u02b4\u203e\u2041\0\0\u2043\u803b\xbe\u40be;\u6157;\u615c5;\u6158\u01b6\u204c\0\u204e;\u615a;\u615d8;\u615el;\u6044wn;\u6322cr;\uc000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209f\u20a5\u20b0\u20b4\u20f0\u20f5\u20fa\u20ff\u2103\u2112\u2138\u0317\u213e\u2152\u219e\u0100;l\u064d\u2087;\u6a8c\u0180cmp\u2090\u2095\u209dute;\u41f5ma\u0100;d\u209c\u1cda\u43b3;\u6a86reve;\u411f\u0100iy\u20aa\u20aerc;\u411d;\u4433ot;\u4121\u0200;lqs\u063e\u0642\u20bd\u20c9\u0180;qs\u063e\u064c\u20c4lan\xf4\u0665\u0200;cdl\u0665\u20d2\u20d5\u20e5c;\u6aa9ot\u0100;o\u20dc\u20dd\u6a80\u0100;l\u20e2\u20e3\u6a82;\u6a84\u0100;e\u20ea\u20ed\uc000\u22db\ufe00s;\u6a94r;\uc000\ud835\udd24\u0100;g\u0673\u061bmel;\u6137cy;\u4453\u0200;Eaj\u065a\u210c\u210e\u2110;\u6a92;\u6aa5;\u6aa4\u0200Eaes\u211b\u211d\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6a8arox\xbb\u2124\u0100;q\u212e\u212f\u6a88\u0100;q\u212e\u211bim;\u62e7pf;\uc000\ud835\udd58\u0100ci\u2143\u2146r;\u610am\u0180;el\u066b\u214e\u2150;\u6a8e;\u6a90\u8300>;cdlqr\u05ee\u2160\u216a\u216e\u2173\u2179\u0100ci\u2165\u2167;\u6aa7r;\u6a7aot;\u62d7Par;\u6995uest;\u6a7c\u0280adels\u2184\u216a\u2190\u0656\u219b\u01f0\u2189\0\u218epro\xf8\u209er;\u6978q\u0100lq\u063f\u2196les\xf3\u2088i\xed\u066b\u0100en\u21a3\u21adrtneqq;\uc000\u2269\ufe00\xc5\u21aa\u0500Aabcefkosy\u21c4\u21c7\u21f1\u21f5\u21fa\u2218\u221d\u222f\u2268\u227dr\xf2\u03a0\u0200ilmr\u21d0\u21d4\u21d7\u21dbrs\xf0\u1484f\xbb\u2024il\xf4\u06a9\u0100dr\u21e0\u21e4cy;\u444a\u0180;cw\u08f4\u21eb\u21efir;\u6948;\u61adar;\u610firc;\u4125\u0180alr\u2201\u220e\u2213rts\u0100;u\u2209\u220a\u6665it\xbb\u220alip;\u6026con;\u62b9r;\uc000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223a\u223e\u2243\u225e\u2263rr;\u61fftht;\u623bk\u0100lr\u2249\u2253eftarrow;\u61a9ightarrow;\u61aaf;\uc000\ud835\udd59bar;\u6015\u0180clt\u226f\u2274\u2278r;\uc000\ud835\udcbdas\xe8\u21f4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1c5b\u0ae1\u22a3\0\u22aa\0\u22b8\u22c5\u22ce\0\u22d5\u22f3\0\0\u22f8\u2322\u2367\u2362\u237f\0\u2386\u23aa\u23b4cute\u803b\xed\u40ed\u0180;iy\u0771\u22b0\u22b5rc\u803b\xee\u40ee;\u4438\u0100cx\u22bc\u22bfy;\u4435cl\u803b\xa1\u40a1\u0100fr\u039f\u22c9;\uc000\ud835\udd26rave\u803b\xec\u40ec\u0200;ino\u073e\u22dd\u22e9\u22ee\u0100in\u22e2\u22e6nt;\u6a0ct;\u622dfin;\u69dcta;\u6129lig;\u4133\u0180aop\u22fe\u231a\u231d\u0180cgt\u2305\u2308\u2317r;\u412b\u0180elp\u071f\u230f\u2313in\xe5\u078ear\xf4\u0720h;\u4131f;\u62b7ed;\u41b5\u0280;cfot\u04f4\u232c\u2331\u233d\u2341are;\u6105in\u0100;t\u2338\u2339\u621eie;\u69dddo\xf4\u2319\u0280;celp\u0757\u234c\u2350\u235b\u2361al;\u62ba\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234darhk;\u6a17rod;\u6a3c\u0200cgpt\u236f\u2372\u2376\u237by;\u4451on;\u412ff;\uc000\ud835\udd5aa;\u43b9uest\u803b\xbf\u40bf\u0100ci\u238a\u238fr;\uc000\ud835\udcben\u0280;Edsv\u04f4\u239b\u239d\u23a1\u04f3;\u62f9ot;\u62f5\u0100;v\u23a6\u23a7\u62f4;\u62f3\u0100;i\u0777\u23aelde;\u4129\u01eb\u23b8\0\u23bccy;\u4456l\u803b\xef\u40ef\u0300cfmosu\u23cc\u23d7\u23dc\u23e1\u23e7\u23f5\u0100iy\u23d1\u23d5rc;\u4135;\u4439r;\uc000\ud835\udd27ath;\u4237pf;\uc000\ud835\udd5b\u01e3\u23ec\0\u23f1r;\uc000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240b\u2416\u2422\u2427\u242d\u2431\u2435\u243bppa\u0100;v\u2413\u2414\u43ba;\u43f0\u0100ey\u241b\u2420dil;\u4137;\u443ar;\uc000\ud835\udd28reen;\u4138cy;\u4445cy;\u445cpf;\uc000\ud835\udd5ccr;\uc000\ud835\udcc0\u0b80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248d\u2491\u250e\u253d\u255a\u2580\u264e\u265e\u2665\u2679\u267d\u269a\u26b2\u26d8\u275d\u2768\u278b\u27c0\u2801\u2812\u0180art\u2477\u247a\u247cr\xf2\u09c6\xf2\u0395ail;\u691barr;\u690e\u0100;g\u0994\u248b;\u6a8bar;\u6962\u0963\u24a5\0\u24aa\0\u24b1\0\0\0\0\0\u24b5\u24ba\0\u24c6\u24c8\u24cd\0\u24f9ute;\u413amptyv;\u69b4ra\xee\u084cbda;\u43bbg\u0180;dl\u088e\u24c1\u24c3;\u6991\xe5\u088e;\u6a85uo\u803b\xab\u40abr\u0400;bfhlpst\u0899\u24de\u24e6\u24e9\u24eb\u24ee\u24f1\u24f5\u0100;f\u089d\u24e3s;\u691fs;\u691d\xeb\u2252p;\u61abl;\u6939im;\u6973l;\u61a2\u0180;ae\u24ff\u2500\u2504\u6aabil;\u6919\u0100;s\u2509\u250a\u6aad;\uc000\u2aad\ufe00\u0180abr\u2515\u2519\u251drr;\u690crk;\u6772\u0100ak\u2522\u252cc\u0100ek\u2528\u252a;\u407b;\u405b\u0100es\u2531\u2533;\u698bl\u0100du\u2539\u253b;\u698f;\u698d\u0200aeuy\u2546\u254b\u2556\u2558ron;\u413e\u0100di\u2550\u2554il;\u413c\xec\u08b0\xe2\u2529;\u443b\u0200cqrs\u2563\u2566\u256d\u257da;\u6936uo\u0100;r\u0e19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694bh;\u61b2\u0280;fgqs\u258b\u258c\u0989\u25f3\u25ff\u6264t\u0280ahlrt\u2598\u25a4\u25b7\u25c2\u25e8rrow\u0100;t\u0899\u25a1a\xe9\u24f6arpoon\u0100du\u25af\u25b4own\xbb\u045ap\xbb\u0966eftarrows;\u61c7ight\u0180ahs\u25cd\u25d6\u25derrow\u0100;s\u08f4\u08a7arpoon\xf3\u0f98quigarro\xf7\u21f0hreetimes;\u62cb\u0180;qs\u258b\u0993\u25falan\xf4\u09ac\u0280;cdgs\u09ac\u260a\u260d\u261d\u2628c;\u6aa8ot\u0100;o\u2614\u2615\u6a7f\u0100;r\u261a\u261b\u6a81;\u6a83\u0100;e\u2622\u2625\uc000\u22da\ufe00s;\u6a93\u0280adegs\u2633\u2639\u263d\u2649\u264bppro\xf8\u24c6ot;\u62d6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248c\xf4\u099bi\xed\u09b2\u0180ilr\u2655\u08e1\u265asht;\u697c;\uc000\ud835\udd29\u0100;E\u099c\u2663;\u6a91\u0161\u2669\u2676r\u0100du\u25b2\u266e\u0100;l\u0965\u2673;\u696alk;\u6584cy;\u4459\u0280;acht\u0a48\u2688\u268b\u2691\u2696r\xf2\u25c1orne\xf2\u1d08ard;\u696bri;\u65fa\u0100io\u269f\u26a4dot;\u4140ust\u0100;a\u26ac\u26ad\u63b0che\xbb\u26ad\u0200Eaes\u26bb\u26bd\u26c9\u26d4;\u6268p\u0100;p\u26c3\u26c4\u6a89rox\xbb\u26c4\u0100;q\u26ce\u26cf\u6a87\u0100;q\u26ce\u26bbim;\u62e6\u0400abnoptwz\u26e9\u26f4\u26f7\u271a\u272f\u2741\u2747\u2750\u0100nr\u26ee\u26f1g;\u67ecr;\u61fdr\xeb\u08c1g\u0180lmr\u26ff\u270d\u2714eft\u0100ar\u09e6\u2707ight\xe1\u09f2apsto;\u67fcight\xe1\u09fdparrow\u0100lr\u2725\u2729ef\xf4\u24edight;\u61ac\u0180afl\u2736\u2739\u273dr;\u6985;\uc000\ud835\udd5dus;\u6a2dimes;\u6a34\u0161\u274b\u274fst;\u6217\xe1\u134e\u0180;ef\u2757\u2758\u1800\u65cange\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277c\u2785\u2787r\xf2\u08a8orne\xf2\u1d8car\u0100;d\u0f98\u2783;\u696d;\u600eri;\u62bf\u0300achiqt\u2798\u279d\u0a40\u27a2\u27ae\u27bbquo;\u6039r;\uc000\ud835\udcc1m\u0180;eg\u09b2\u27aa\u27ac;\u6a8d;\u6a8f\u0100bu\u252a\u27b3o\u0100;r\u0e1f\u27b9;\u601arok;\u4142\u8400<;cdhilqr\u082b\u27d2\u2639\u27dc\u27e0\u27e5\u27ea\u27f0\u0100ci\u27d7\u27d9;\u6aa6r;\u6a79re\xe5\u25f2mes;\u62c9arr;\u6976uest;\u6a7b\u0100Pi\u27f5\u27f9ar;\u6996\u0180;ef\u2800\u092d\u181b\u65c3r\u0100du\u2807\u280dshar;\u694ahar;\u6966\u0100en\u2817\u2821rtneqq;\uc000\u2268\ufe00\xc5\u281e\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288e\u2893\u28a0\u28a5\u28a8\u28da\u28e2\u28e4\u0a83\u28f3\u2902Dot;\u623a\u0200clpr\u284e\u2852\u2863\u287dr\u803b\xaf\u40af\u0100et\u2857\u2859;\u6642\u0100;e\u285e\u285f\u6720se\xbb\u285f\u0100;s\u103b\u2868to\u0200;dlu\u103b\u2873\u2877\u287bow\xee\u048cef\xf4\u090f\xf0\u13d1ker;\u65ae\u0100oy\u2887\u288cmma;\u6a29;\u443cash;\u6014asuredangle\xbb\u1626r;\uc000\ud835\udd2ao;\u6127\u0180cdn\u28af\u28b4\u28c9ro\u803b\xb5\u40b5\u0200;acd\u1464\u28bd\u28c0\u28c4s\xf4\u16a7ir;\u6af0ot\u80bb\xb7\u01b5us\u0180;bd\u28d2\u1903\u28d3\u6212\u0100;u\u1d3c\u28d8;\u6a2a\u0163\u28de\u28e1p;\u6adb\xf2\u2212\xf0\u0a81\u0100dp\u28e9\u28eeels;\u62a7f;\uc000\ud835\udd5e\u0100ct\u28f8\u28fdr;\uc000\ud835\udcc2pos\xbb\u159d\u0180;lm\u2909\u290a\u290d\u43bctimap;\u62b8\u0c00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297e\u2989\u2998\u29da\u29e9\u2a15\u2a1a\u2a58\u2a5d\u2a83\u2a95\u2aa4\u2aa8\u2b04\u2b07\u2b44\u2b7f\u2bae\u2c34\u2c67\u2c7c\u2ce9\u0100gt\u2947\u294b;\uc000\u22d9\u0338\u0100;v\u2950\u0bcf\uc000\u226b\u20d2\u0180elt\u295a\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61cdightarrow;\u61ce;\uc000\u22d8\u0338\u0100;v\u297b\u0c47\uc000\u226a\u20d2ightarrow;\u61cf\u0100Dd\u298e\u2993ash;\u62afash;\u62ae\u0280bcnpt\u29a3\u29a7\u29ac\u29b1\u29ccla\xbb\u02deute;\u4144g;\uc000\u2220\u20d2\u0280;Eiop\u0d84\u29bc\u29c0\u29c5\u29c8;\uc000\u2a70\u0338d;\uc000\u224b\u0338s;\u4149ro\xf8\u0d84ur\u0100;a\u29d3\u29d4\u666el\u0100;s\u29d3\u0b38\u01f3\u29df\0\u29e3p\u80bb\xa0\u0b37mp\u0100;e\u0bf9\u0c00\u0280aeouy\u29f4\u29fe\u2a03\u2a10\u2a13\u01f0\u29f9\0\u29fb;\u6a43on;\u4148dil;\u4146ng\u0100;d\u0d7e\u2a0aot;\uc000\u2a6d\u0338p;\u6a42;\u443dash;\u6013\u0380;Aadqsx\u0b92\u2a29\u2a2d\u2a3b\u2a41\u2a45\u2a50rr;\u61d7r\u0100hr\u2a33\u2a36k;\u6924\u0100;o\u13f2\u13f0ot;\uc000\u2250\u0338ui\xf6\u0b63\u0100ei\u2a4a\u2a4ear;\u6928\xed\u0b98ist\u0100;s\u0ba0\u0b9fr;\uc000\ud835\udd2b\u0200Eest\u0bc5\u2a66\u2a79\u2a7c\u0180;qs\u0bbc\u2a6d\u0be1\u0180;qs\u0bbc\u0bc5\u2a74lan\xf4\u0be2i\xed\u0bea\u0100;r\u0bb6\u2a81\xbb\u0bb7\u0180Aap\u2a8a\u2a8d\u2a91r\xf2\u2971rr;\u61aear;\u6af2\u0180;sv\u0f8d\u2a9c\u0f8c\u0100;d\u2aa1\u2aa2\u62fc;\u62facy;\u445a\u0380AEadest\u2ab7\u2aba\u2abe\u2ac2\u2ac5\u2af6\u2af9r\xf2\u2966;\uc000\u2266\u0338rr;\u619ar;\u6025\u0200;fqs\u0c3b\u2ace\u2ae3\u2aeft\u0100ar\u2ad4\u2ad9rro\xf7\u2ac1ightarro\xf7\u2a90\u0180;qs\u0c3b\u2aba\u2aealan\xf4\u0c55\u0100;s\u0c55\u2af4\xbb\u0c36i\xed\u0c5d\u0100;r\u0c35\u2afei\u0100;e\u0c1a\u0c25i\xe4\u0d90\u0100pt\u2b0c\u2b11f;\uc000\ud835\udd5f\u8180\xac;in\u2b19\u2b1a\u2b36\u40acn\u0200;Edv\u0b89\u2b24\u2b28\u2b2e;\uc000\u22f9\u0338ot;\uc000\u22f5\u0338\u01e1\u0b89\u2b33\u2b35;\u62f7;\u62f6i\u0100;v\u0cb8\u2b3c\u01e1\u0cb8\u2b41\u2b43;\u62fe;\u62fd\u0180aor\u2b4b\u2b63\u2b69r\u0200;ast\u0b7b\u2b55\u2b5a\u2b5flle\xec\u0b7bl;\uc000\u2afd\u20e5;\uc000\u2202\u0338lint;\u6a14\u0180;ce\u0c92\u2b70\u2b73u\xe5\u0ca5\u0100;c\u0c98\u2b78\u0100;e\u0c92\u2b7d\xf1\u0c98\u0200Aait\u2b88\u2b8b\u2b9d\u2ba7r\xf2\u2988rr\u0180;cw\u2b94\u2b95\u2b99\u619b;\uc000\u2933\u0338;\uc000\u219d\u0338ghtarrow\xbb\u2b95ri\u0100;e\u0ccb\u0cd6\u0380chimpqu\u2bbd\u2bcd\u2bd9\u2b04\u0b78\u2be4\u2bef\u0200;cer\u0d32\u2bc6\u0d37\u2bc9u\xe5\u0d45;\uc000\ud835\udcc3ort\u026d\u2b05\0\0\u2bd6ar\xe1\u2b56m\u0100;e\u0d6e\u2bdf\u0100;q\u0d74\u0d73su\u0100bp\u2beb\u2bed\xe5\u0cf8\xe5\u0d0b\u0180bcp\u2bf6\u2c11\u2c19\u0200;Ees\u2bff\u2c00\u0d22\u2c04\u6284;\uc000\u2ac5\u0338et\u0100;e\u0d1b\u2c0bq\u0100;q\u0d23\u2c00c\u0100;e\u0d32\u2c17\xf1\u0d38\u0200;Ees\u2c22\u2c23\u0d5f\u2c27\u6285;\uc000\u2ac6\u0338et\u0100;e\u0d58\u2c2eq\u0100;q\u0d60\u2c23\u0200gilr\u2c3d\u2c3f\u2c45\u2c47\xec\u0bd7lde\u803b\xf1\u40f1\xe7\u0c43iangle\u0100lr\u2c52\u2c5ceft\u0100;e\u0c1a\u2c5a\xf1\u0c26ight\u0100;e\u0ccb\u2c65\xf1\u0cd7\u0100;m\u2c6c\u2c6d\u43bd\u0180;es\u2c74\u2c75\u2c79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2c8f\u2c94\u2c99\u2c9e\u2ca3\u2cb0\u2cb6\u2cd3\u2ce3ash;\u62adarr;\u6904p;\uc000\u224d\u20d2ash;\u62ac\u0100et\u2ca8\u2cac;\uc000\u2265\u20d2;\uc000>\u20d2nfin;\u69de\u0180Aet\u2cbd\u2cc1\u2cc5rr;\u6902;\uc000\u2264\u20d2\u0100;r\u2cca\u2ccd\uc000<\u20d2ie;\uc000\u22b4\u20d2\u0100At\u2cd8\u2cdcrr;\u6903rie;\uc000\u22b5\u20d2im;\uc000\u223c\u20d2\u0180Aan\u2cf0\u2cf4\u2d02rr;\u61d6r\u0100hr\u2cfa\u2cfdk;\u6923\u0100;o\u13e7\u13e5ear;\u6927\u1253\u1a95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2d2d\0\u2d38\u2d48\u2d60\u2d65\u2d72\u2d84\u1b07\0\0\u2d8d\u2dab\0\u2dc8\u2dce\0\u2ddc\u2e19\u2e2b\u2e3e\u2e43\u0100cs\u2d31\u1a97ute\u803b\xf3\u40f3\u0100iy\u2d3c\u2d45r\u0100;c\u1a9e\u2d42\u803b\xf4\u40f4;\u443e\u0280abios\u1aa0\u2d52\u2d57\u01c8\u2d5alac;\u4151v;\u6a38old;\u69bclig;\u4153\u0100cr\u2d69\u2d6dir;\u69bf;\uc000\ud835\udd2c\u036f\u2d79\0\0\u2d7c\0\u2d82n;\u42dbave\u803b\xf2\u40f2;\u69c1\u0100bm\u2d88\u0df4ar;\u69b5\u0200acit\u2d95\u2d98\u2da5\u2da8r\xf2\u1a80\u0100ir\u2d9d\u2da0r;\u69beoss;\u69bbn\xe5\u0e52;\u69c0\u0180aei\u2db1\u2db5\u2db9cr;\u414dga;\u43c9\u0180cdn\u2dc0\u2dc5\u01cdron;\u43bf;\u69b6pf;\uc000\ud835\udd60\u0180ael\u2dd4\u2dd7\u01d2r;\u69b7rp;\u69b9\u0380;adiosv\u2dea\u2deb\u2dee\u2e08\u2e0d\u2e10\u2e16\u6228r\xf2\u1a86\u0200;efm\u2df7\u2df8\u2e02\u2e05\u6a5dr\u0100;o\u2dfe\u2dff\u6134f\xbb\u2dff\u803b\xaa\u40aa\u803b\xba\u40bagof;\u62b6r;\u6a56lope;\u6a57;\u6a5b\u0180clo\u2e1f\u2e21\u2e27\xf2\u2e01ash\u803b\xf8\u40f8l;\u6298i\u016c\u2e2f\u2e34de\u803b\xf5\u40f5es\u0100;a\u01db\u2e3as;\u6a36ml\u803b\xf6\u40f6bar;\u633d\u0ae1\u2e5e\0\u2e7d\0\u2e80\u2e9d\0\u2ea2\u2eb9\0\0\u2ecb\u0e9c\0\u2f13\0\0\u2f2b\u2fbc\0\u2fc8r\u0200;ast\u0403\u2e67\u2e72\u0e85\u8100\xb6;l\u2e6d\u2e6e\u40b6le\xec\u0403\u0269\u2e78\0\0\u2e7bm;\u6af3;\u6afdy;\u443fr\u0280cimpt\u2e8b\u2e8f\u2e93\u1865\u2e97nt;\u4025od;\u402eil;\u6030enk;\u6031r;\uc000\ud835\udd2d\u0180imo\u2ea8\u2eb0\u2eb4\u0100;v\u2ead\u2eae\u43c6;\u43d5ma\xf4\u0a76ne;\u660e\u0180;tv\u2ebf\u2ec0\u2ec8\u43c0chfork\xbb\u1ffd;\u43d6\u0100au\u2ecf\u2edfn\u0100ck\u2ed5\u2eddk\u0100;h\u21f4\u2edb;\u610e\xf6\u21f4s\u0480;abcdemst\u2ef3\u2ef4\u1908\u2ef9\u2efd\u2f04\u2f06\u2f0a\u2f0e\u402bcir;\u6a23ir;\u6a22\u0100ou\u1d40\u2f02;\u6a25;\u6a72n\u80bb\xb1\u0e9dim;\u6a26wo;\u6a27\u0180ipu\u2f19\u2f20\u2f25ntint;\u6a15f;\uc000\ud835\udd61nd\u803b\xa3\u40a3\u0500;Eaceinosu\u0ec8\u2f3f\u2f41\u2f44\u2f47\u2f81\u2f89\u2f92\u2f7e\u2fb6;\u6ab3p;\u6ab7u\xe5\u0ed9\u0100;c\u0ece\u2f4c\u0300;acens\u0ec8\u2f59\u2f5f\u2f66\u2f68\u2f7eppro\xf8\u2f43urlye\xf1\u0ed9\xf1\u0ece\u0180aes\u2f6f\u2f76\u2f7approx;\u6ab9qq;\u6ab5im;\u62e8i\xed\u0edfme\u0100;s\u2f88\u0eae\u6032\u0180Eas\u2f78\u2f90\u2f7a\xf0\u2f75\u0180dfp\u0eec\u2f99\u2faf\u0180als\u2fa0\u2fa5\u2faalar;\u632eine;\u6312urf;\u6313\u0100;t\u0efb\u2fb4\xef\u0efbrel;\u62b0\u0100ci\u2fc0\u2fc5r;\uc000\ud835\udcc5;\u43c8ncsp;\u6008\u0300fiopsu\u2fda\u22e2\u2fdf\u2fe5\u2feb\u2ff1r;\uc000\ud835\udd2epf;\uc000\ud835\udd62rime;\u6057cr;\uc000\ud835\udcc6\u0180aeo\u2ff8\u3009\u3013t\u0100ei\u2ffe\u3005rnion\xf3\u06b0nt;\u6a16st\u0100;e\u3010\u3011\u403f\xf1\u1f19\xf4\u0f14\u0a80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30e0\u310e\u312b\u3147\u3162\u3172\u318e\u3206\u3215\u3224\u3229\u3258\u326e\u3272\u3290\u32b0\u32b7\u0180art\u3047\u304a\u304cr\xf2\u10b3\xf2\u03ddail;\u691car\xf2\u1c65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307f\u308f\u3094\u30cc\u0100eu\u306d\u3071;\uc000\u223d\u0331te;\u4155i\xe3\u116emptyv;\u69b3g\u0200;del\u0fd1\u3089\u308b\u308d;\u6992;\u69a5\xe5\u0fd1uo\u803b\xbb\u40bbr\u0580;abcfhlpstw\u0fdc\u30ac\u30af\u30b7\u30b9\u30bc\u30be\u30c0\u30c3\u30c7\u30cap;\u6975\u0100;f\u0fe0\u30b4s;\u6920;\u6933s;\u691e\xeb\u225d\xf0\u272el;\u6945im;\u6974l;\u61a3;\u619d\u0100ai\u30d1\u30d5il;\u691ao\u0100;n\u30db\u30dc\u6236al\xf3\u0f1e\u0180abr\u30e7\u30ea\u30eer\xf2\u17e5rk;\u6773\u0100ak\u30f3\u30fdc\u0100ek\u30f9\u30fb;\u407d;\u405d\u0100es\u3102\u3104;\u698cl\u0100du\u310a\u310c;\u698e;\u6990\u0200aeuy\u3117\u311c\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0ff2\xe2\u30fa;\u4440\u0200clqs\u3134\u3137\u313d\u3144a;\u6937dhar;\u6969uo\u0100;r\u020e\u020dh;\u61b3\u0180acg\u314e\u315f\u0f44l\u0200;ips\u0f78\u3158\u315b\u109cn\xe5\u10bbar\xf4\u0fa9t;\u65ad\u0180ilr\u3169\u1023\u316esht;\u697d;\uc000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317d\u317f\xbb\u047b\u0100;l\u1091\u3184;\u696c\u0100;v\u318b\u318c\u43c1;\u43f1\u0180gns\u3195\u31f9\u31fcht\u0300ahlrst\u31a4\u31b0\u31c2\u31d8\u31e4\u31eerrow\u0100;t\u0fdc\u31ada\xe9\u30c8arpoon\u0100du\u31bb\u31bfow\xee\u317ep\xbb\u1092eft\u0100ah\u31ca\u31d0rrow\xf3\u0feaarpoon\xf3\u0551ightarrows;\u61c9quigarro\xf7\u30cbhreetimes;\u62ccg;\u42daingdotse\xf1\u1f32\u0180ahm\u320d\u3210\u3213r\xf2\u0feaa\xf2\u0551;\u600foust\u0100;a\u321e\u321f\u63b1che\xbb\u321fmid;\u6aee\u0200abpt\u3232\u323d\u3240\u3252\u0100nr\u3237\u323ag;\u67edr;\u61fer\xeb\u1003\u0180afl\u3247\u324a\u324er;\u6986;\uc000\ud835\udd63us;\u6a2eimes;\u6a35\u0100ap\u325d\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6a12ar\xf2\u31e3\u0200achq\u327b\u3280\u10bc\u3285quo;\u603ar;\uc000\ud835\udcc7\u0100bu\u30fb\u328ao\u0100;r\u0214\u0213\u0180hir\u3297\u329b\u32a0re\xe5\u31f8mes;\u62cai\u0200;efl\u32aa\u1059\u1821\u32ab\u65b9tri;\u69celuhar;\u6968;\u611e\u0d61\u32d5\u32db\u32df\u332c\u3338\u3371\0\u337a\u33a4\0\0\u33ec\u33f0\0\u3428\u3448\u345a\u34ad\u34b1\u34ca\u34f1\0\u3616\0\0\u3633cute;\u415bqu\xef\u27ba\u0500;Eaceinpsy\u11ed\u32f3\u32f5\u32ff\u3302\u330b\u330f\u331f\u3326\u3329;\u6ab4\u01f0\u32fa\0\u32fc;\u6ab8on;\u4161u\xe5\u11fe\u0100;d\u11f3\u3307il;\u415frc;\u415d\u0180Eas\u3316\u3318\u331b;\u6ab6p;\u6abaim;\u62e9olint;\u6a13i\xed\u1204;\u4441ot\u0180;be\u3334\u1d47\u3335\u62c5;\u6a66\u0380Aacmstx\u3346\u334a\u3357\u335b\u335e\u3363\u336drr;\u61d8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0a36\u0a34t\u803b\xa7\u40a7i;\u403bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uc000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33a0rp;\u666f\u0100hy\u338b\u338fcy;\u4449;\u4448rt\u026d\u3399\0\0\u339ci\xe4\u1464ara\xec\u2e6f\u803b\xad\u40ad\u0100gm\u33a8\u33b4ma\u0180;fv\u33b1\u33b2\u33b2\u43c3;\u43c2\u0400;deglnpr\u12ab\u33c5\u33c9\u33ce\u33d6\u33de\u33e1\u33e6ot;\u6a6a\u0100;q\u12b1\u12b0\u0100;E\u33d3\u33d4\u6a9e;\u6aa0\u0100;E\u33db\u33dc\u6a9d;\u6a9fe;\u6246lus;\u6a24arr;\u6972ar\xf2\u113d\u0200aeit\u33f8\u3408\u340f\u3417\u0100ls\u33fd\u3404lsetm\xe9\u336ahp;\u6a33parsl;\u69e4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341c\u341d\u6aaa\u0100;s\u3422\u3423\u6aac;\uc000\u2aac\ufe00\u0180flp\u342e\u3433\u3442tcy;\u444c\u0100;b\u3438\u3439\u402f\u0100;a\u343e\u343f\u69c4r;\u633ff;\uc000\ud835\udd64a\u0100dr\u344d\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349f\u0100au\u3465\u346fp\u0100;s\u1188\u346b;\uc000\u2293\ufe00p\u0100;s\u11b4\u3475;\uc000\u2294\ufe00u\u0100bp\u347f\u348f\u0180;es\u1197\u119c\u3486et\u0100;e\u1197\u348d\xf1\u119d\u0180;es\u11a8\u11ad\u3496et\u0100;e\u11a8\u349d\xf1\u11ae\u0180;af\u117b\u34a6\u05b0r\u0165\u34ab\u05b1\xbb\u117car\xf2\u1148\u0200cemt\u34b9\u34be\u34c2\u34c5r;\uc000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11be\u0100ar\u34ce\u34d5r\u0100;f\u34d4\u17bf\u6606\u0100an\u34da\u34edight\u0100ep\u34e3\u34eapsilo\xee\u1ee0h\xe9\u2eafs\xbb\u2852\u0280bcmnp\u34fb\u355e\u1209\u358b\u358e\u0480;Edemnprs\u350e\u350f\u3511\u3515\u351e\u3523\u352c\u3531\u3536\u6282;\u6ac5ot;\u6abd\u0100;d\u11da\u351aot;\u6ac3ult;\u6ac1\u0100Ee\u3528\u352a;\u6acb;\u628alus;\u6abfarr;\u6979\u0180eiu\u353d\u3552\u3555t\u0180;en\u350e\u3545\u354bq\u0100;q\u11da\u350feq\u0100;q\u352b\u3528m;\u6ac7\u0100bp\u355a\u355c;\u6ad5;\u6ad3c\u0300;acens\u11ed\u356c\u3572\u3579\u357b\u3326ppro\xf8\u32faurlye\xf1\u11fe\xf1\u11f3\u0180aes\u3582\u3588\u331bppro\xf8\u331aq\xf1\u3317g;\u666a\u0680123;Edehlmnps\u35a9\u35ac\u35af\u121c\u35b2\u35b4\u35c0\u35c9\u35d5\u35da\u35df\u35e8\u35ed\u803b\xb9\u40b9\u803b\xb2\u40b2\u803b\xb3\u40b3;\u6ac6\u0100os\u35b9\u35bct;\u6abeub;\u6ad8\u0100;d\u1222\u35c5ot;\u6ac4s\u0100ou\u35cf\u35d2l;\u67c9b;\u6ad7arr;\u697bult;\u6ac2\u0100Ee\u35e4\u35e6;\u6acc;\u628blus;\u6ac0\u0180eiu\u35f4\u3609\u360ct\u0180;en\u121c\u35fc\u3602q\u0100;q\u1222\u35b2eq\u0100;q\u35e7\u35e4m;\u6ac8\u0100bp\u3611\u3613;\u6ad4;\u6ad6\u0180Aan\u361c\u3620\u362drr;\u61d9r\u0100hr\u3626\u3628\xeb\u222e\u0100;o\u0a2b\u0a29war;\u692alig\u803b\xdf\u40df\u0be1\u3651\u365d\u3660\u12ce\u3673\u3679\0\u367e\u36c2\0\0\0\0\0\u36db\u3703\0\u3709\u376c\0\0\0\u3787\u0272\u3656\0\0\u365bget;\u6316;\u43c4r\xeb\u0e5f\u0180aey\u3666\u366b\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uc000\ud835\udd31\u0200eiko\u3686\u369d\u36b5\u36bc\u01f2\u368b\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369b\u43b8ym;\u43d1\u0100cn\u36a2\u36b2k\u0100as\u36a8\u36aeppro\xf8\u12c1im\xbb\u12acs\xf0\u129e\u0100as\u36ba\u36ae\xf0\u12c1rn\u803b\xfe\u40fe\u01ec\u031f\u36c6\u22e7es\u8180\xd7;bd\u36cf\u36d0\u36d8\u40d7\u0100;a\u190f\u36d5r;\u6a31;\u6a30\u0180eps\u36e1\u36e3\u3700\xe1\u2a4d\u0200;bcf\u0486\u36ec\u36f0\u36f4ot;\u6336ir;\u6af1\u0100;o\u36f9\u36fc\uc000\ud835\udd65rk;\u6ada\xe1\u3362rime;\u6034\u0180aip\u370f\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374d\u3740\u3751\u3757\u375c\u375fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65b5own\xbb\u1dbbeft\u0100;e\u2800\u373e\xf1\u092e;\u625cight\u0100;e\u32aa\u374b\xf1\u105aot;\u65ecinus;\u6a3alus;\u6a39b;\u69cdime;\u6a3bezium;\u63e2\u0180cht\u3772\u377d\u3781\u0100ry\u3777\u377b;\uc000\ud835\udcc9;\u4446cy;\u445brok;\u4167\u0100io\u378b\u378ex\xf4\u1777head\u0100lr\u3797\u37a0eftarro\xf7\u084fightarrow\xbb\u0f5d\u0900AHabcdfghlmoprstuw\u37d0\u37d3\u37d7\u37e4\u37f0\u37fc\u380e\u381c\u3823\u3834\u3851\u385d\u386b\u38a9\u38cc\u38d2\u38ea\u38f6r\xf2\u03edar;\u6963\u0100cr\u37dc\u37e2ute\u803b\xfa\u40fa\xf2\u1150r\u01e3\u37ea\0\u37edy;\u445eve;\u416d\u0100iy\u37f5\u37farc\u803b\xfb\u40fb;\u4443\u0180abh\u3803\u3806\u380br\xf2\u13adlac;\u4171a\xf2\u13c3\u0100ir\u3813\u3818sht;\u697e;\uc000\ud835\udd32rave\u803b\xf9\u40f9\u0161\u3827\u3831r\u0100lr\u382c\u382e\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384d\u026f\u383f\0\0\u384arn\u0100;e\u3845\u3846\u631cr\xbb\u3846op;\u630fri;\u65f8\u0100al\u3856\u385acr;\u416b\u80bb\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uc000\ud835\udd66\u0300adhlsu\u114b\u3878\u387d\u1372\u3891\u38a0own\xe1\u13b3arpoon\u0100lr\u3888\u388cef\xf4\u382digh\xf4\u382fi\u0180;hl\u3899\u389a\u389c\u43c5\xbb\u13faon\xbb\u389aparrows;\u61c8\u0180cit\u38b0\u38c4\u38c8\u026f\u38b6\0\0\u38c1rn\u0100;e\u38bc\u38bd\u631dr\xbb\u38bdop;\u630eng;\u416fri;\u65f9cr;\uc000\ud835\udcca\u0180dir\u38d9\u38dd\u38e2ot;\u62f0lde;\u4169i\u0100;f\u3730\u38e8\xbb\u1813\u0100am\u38ef\u38f2r\xf2\u38a8l\u803b\xfc\u40fcangle;\u69a7\u0780ABDacdeflnoprsz\u391c\u391f\u3929\u392d\u39b5\u39b8\u39bd\u39df\u39e4\u39e8\u39f3\u39f9\u39fd\u3a01\u3a20r\xf2\u03f7ar\u0100;v\u3926\u3927\u6ae8;\u6ae9as\xe8\u03e1\u0100nr\u3932\u3937grt;\u699c\u0380eknprst\u34e3\u3946\u394b\u3952\u395d\u3964\u3996app\xe1\u2415othin\xe7\u1e96\u0180hir\u34eb\u2ec8\u3959op\xf4\u2fb5\u0100;h\u13b7\u3962\xef\u318d\u0100iu\u3969\u396dgm\xe1\u33b3\u0100bp\u3972\u3984setneq\u0100;q\u397d\u3980\uc000\u228a\ufe00;\uc000\u2acb\ufe00setneq\u0100;q\u398f\u3992\uc000\u228b\ufe00;\uc000\u2acc\ufe00\u0100hr\u399b\u399fet\xe1\u369ciangle\u0100lr\u39aa\u39afeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39c4\u39d2\u39d7\u0180;be\u2dea\u39cb\u39cfar;\u62bbq;\u625alip;\u62ee\u0100bt\u39dc\u1468a\xf2\u1469r;\uc000\ud835\udd33tr\xe9\u39aesu\u0100bp\u39ef\u39f1\xbb\u0d1c\xbb\u0d59pf;\uc000\ud835\udd67ro\xf0\u0efbtr\xe9\u39b4\u0100cu\u3a06\u3a0br;\uc000\ud835\udccb\u0100bp\u3a10\u3a18n\u0100Ee\u3980\u3a16\xbb\u397en\u0100Ee\u3992\u3a1e\xbb\u3990igzag;\u699a\u0380cefoprs\u3a36\u3a3b\u3a56\u3a5b\u3a54\u3a61\u3a6airc;\u4175\u0100di\u3a40\u3a51\u0100bg\u3a45\u3a49ar;\u6a5fe\u0100;q\u15fa\u3a4f;\u6259erp;\u6118r;\uc000\ud835\udd34pf;\uc000\ud835\udd68\u0100;e\u1479\u3a66at\xe8\u1479cr;\uc000\ud835\udccc\u0ae3\u178e\u3a87\0\u3a8b\0\u3a90\u3a9b\0\0\u3a9d\u3aa8\u3aab\u3aaf\0\0\u3ac3\u3ace\0\u3ad8\u17dc\u17dftr\xe9\u17d1r;\uc000\ud835\udd35\u0100Aa\u3a94\u3a97r\xf2\u03c3r\xf2\u09f6;\u43be\u0100Aa\u3aa1\u3aa4r\xf2\u03b8r\xf2\u09eba\xf0\u2713is;\u62fb\u0180dpt\u17a4\u3ab5\u3abe\u0100fl\u3aba\u17a9;\uc000\ud835\udd69im\xe5\u17b2\u0100Aa\u3ac7\u3acar\xf2\u03cer\xf2\u0a01\u0100cq\u3ad2\u17b8r;\uc000\ud835\udccd\u0100pt\u17d6\u3adcr\xe9\u17d4\u0400acefiosu\u3af0\u3afd\u3b08\u3b0c\u3b11\u3b15\u3b1b\u3b21c\u0100uy\u3af6\u3afbte\u803b\xfd\u40fd;\u444f\u0100iy\u3b02\u3b06rc;\u4177;\u444bn\u803b\xa5\u40a5r;\uc000\ud835\udd36cy;\u4457pf;\uc000\ud835\udd6acr;\uc000\ud835\udcce\u0100cm\u3b26\u3b29y;\u444el\u803b\xff\u40ff\u0500acdefhiosw\u3b42\u3b48\u3b54\u3b58\u3b64\u3b69\u3b6d\u3b74\u3b7a\u3b80cute;\u417a\u0100ay\u3b4d\u3b52ron;\u417e;\u4437ot;\u417c\u0100et\u3b5d\u3b61tr\xe6\u155fa;\u43b6r;\uc000\ud835\udd37cy;\u4436grarr;\u61ddpf;\uc000\ud835\udd6bcr;\uc000\ud835\udccf\u0100jn\u3b85\u3b87;\u600dj;\u600c".split("").map((c)=>c.charCodeAt(0)));

});

parcelRegister("7Ui2N", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5c1bc29187a584dd$export$2e2bcd8739ae039; });
// Generated using scripts/write-decode-map.ts
var $5c1bc29187a584dd$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
"\u0200aglq\t\x15\x18\x1b\u026d\x0f\0\0\x12p;\u4026os;\u4027t;\u403et;\u403cuot;\u4022".split("").map((c)=>c.charCodeAt(0)));

});

parcelRegister("fJ3ZX", function(module, exports) {
$parcel$export(module.exports, "fromCodePoint", function () { return $b72e28f1e48a721c$export$73bfc63873071f74; });
$parcel$export(module.exports, "replaceCodePoint", function () { return $b72e28f1e48a721c$export$b978ab756102108a; });
// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $b72e28f1e48a721c$var$_a;
const $b72e28f1e48a721c$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
const $b72e28f1e48a721c$export$73bfc63873071f74 = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
($b72e28f1e48a721c$var$_a = String.fromCodePoint) !== null && $b72e28f1e48a721c$var$_a !== void 0 ? $b72e28f1e48a721c$var$_a : function(codePoint) {
    let output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
        codePoint = 0xdc00 | codePoint & 0x3ff;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
function $b72e28f1e48a721c$export$b978ab756102108a(codePoint) {
    var _a;
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return 0xfffd;
    return (_a = $b72e28f1e48a721c$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
function $b72e28f1e48a721c$export$2e2bcd8739ae039(codePoint) {
    return $b72e28f1e48a721c$export$73bfc63873071f74($b72e28f1e48a721c$export$b978ab756102108a(codePoint));
}

});


parcelRegister("8lOYC", function(module, exports) {
$parcel$export(module.exports, "encodeHTML", function () { return $6147d3d29ddd075c$export$f9d6449b9af28dc1; });
$parcel$export(module.exports, "encodeNonAsciiHTML", function () { return $6147d3d29ddd075c$export$e6e86c76506f1190; });

var $7Zx4d = parcelRequire("7Zx4d");

var $h82ow = parcelRequire("h82ow");
const $6147d3d29ddd075c$var$htmlReplacer = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function $6147d3d29ddd075c$export$f9d6449b9af28dc1(data) {
    return $6147d3d29ddd075c$var$encodeHTMLTrieRe($6147d3d29ddd075c$var$htmlReplacer, data);
}
function $6147d3d29ddd075c$export$e6e86c76506f1190(data) {
    return $6147d3d29ddd075c$var$encodeHTMLTrieRe((0, $h82ow.xmlReplacer), data);
}
function $6147d3d29ddd075c$var$encodeHTMLTrieRe(regExp, str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = regExp.exec(str)) !== null){
        const i = match.index;
        ret += str.substring(lastIdx, i);
        const char = str.charCodeAt(i);
        let next = (0, $7Zx4d.default).get(char);
        if (typeof next === "object") {
            // We are in a branch. Try to match the next char.
            if (i + 1 < str.length) {
                const nextChar = str.charCodeAt(i + 1);
                const value = typeof next.n === "number" ? next.n === nextChar ? next.o : undefined : next.n.get(nextChar);
                if (value !== undefined) {
                    ret += value;
                    lastIdx = regExp.lastIndex += 1;
                    continue;
                }
            }
            next = next.v;
        }
        // We might have a tree node without a value; skip and use a numeric entity.
        if (next !== undefined) {
            ret += next;
            lastIdx = i + 1;
        } else {
            const cp = (0, $h82ow.getCodePoint)(str, i);
            ret += `&#x${cp.toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = regExp.lastIndex += Number(cp !== char);
        }
    }
    return ret + str.substr(lastIdx);
}

});
parcelRegister("7Zx4d", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5d17e1547aea90db$export$2e2bcd8739ae039; });
// Generated using scripts/write-encode-map.ts
function $5d17e1547aea90db$var$restoreDiff(arr) {
    for(let i = 1; i < arr.length; i++)arr[i][0] += arr[i - 1][0] + 1;
    return arr;
}
var // prettier-ignore
$5d17e1547aea90db$export$2e2bcd8739ae039 = new Map(/* #__PURE__ */ $5d17e1547aea90db$var$restoreDiff([
    [
        9,
        "&Tab;"
    ],
    [
        0,
        "&NewLine;"
    ],
    [
        22,
        "&excl;"
    ],
    [
        0,
        "&quot;"
    ],
    [
        0,
        "&num;"
    ],
    [
        0,
        "&dollar;"
    ],
    [
        0,
        "&percnt;"
    ],
    [
        0,
        "&amp;"
    ],
    [
        0,
        "&apos;"
    ],
    [
        0,
        "&lpar;"
    ],
    [
        0,
        "&rpar;"
    ],
    [
        0,
        "&ast;"
    ],
    [
        0,
        "&plus;"
    ],
    [
        0,
        "&comma;"
    ],
    [
        1,
        "&period;"
    ],
    [
        0,
        "&sol;"
    ],
    [
        10,
        "&colon;"
    ],
    [
        0,
        "&semi;"
    ],
    [
        0,
        {
            v: "&lt;",
            n: 8402,
            o: "&nvlt;"
        }
    ],
    [
        0,
        {
            v: "&equals;",
            n: 8421,
            o: "&bne;"
        }
    ],
    [
        0,
        {
            v: "&gt;",
            n: 8402,
            o: "&nvgt;"
        }
    ],
    [
        0,
        "&quest;"
    ],
    [
        0,
        "&commat;"
    ],
    [
        26,
        "&lbrack;"
    ],
    [
        0,
        "&bsol;"
    ],
    [
        0,
        "&rbrack;"
    ],
    [
        0,
        "&Hat;"
    ],
    [
        0,
        "&lowbar;"
    ],
    [
        0,
        "&DiacriticalGrave;"
    ],
    [
        5,
        {
            n: 106,
            o: "&fjlig;"
        }
    ],
    [
        20,
        "&lbrace;"
    ],
    [
        0,
        "&verbar;"
    ],
    [
        0,
        "&rbrace;"
    ],
    [
        34,
        "&nbsp;"
    ],
    [
        0,
        "&iexcl;"
    ],
    [
        0,
        "&cent;"
    ],
    [
        0,
        "&pound;"
    ],
    [
        0,
        "&curren;"
    ],
    [
        0,
        "&yen;"
    ],
    [
        0,
        "&brvbar;"
    ],
    [
        0,
        "&sect;"
    ],
    [
        0,
        "&die;"
    ],
    [
        0,
        "&copy;"
    ],
    [
        0,
        "&ordf;"
    ],
    [
        0,
        "&laquo;"
    ],
    [
        0,
        "&not;"
    ],
    [
        0,
        "&shy;"
    ],
    [
        0,
        "&circledR;"
    ],
    [
        0,
        "&macr;"
    ],
    [
        0,
        "&deg;"
    ],
    [
        0,
        "&PlusMinus;"
    ],
    [
        0,
        "&sup2;"
    ],
    [
        0,
        "&sup3;"
    ],
    [
        0,
        "&acute;"
    ],
    [
        0,
        "&micro;"
    ],
    [
        0,
        "&para;"
    ],
    [
        0,
        "&centerdot;"
    ],
    [
        0,
        "&cedil;"
    ],
    [
        0,
        "&sup1;"
    ],
    [
        0,
        "&ordm;"
    ],
    [
        0,
        "&raquo;"
    ],
    [
        0,
        "&frac14;"
    ],
    [
        0,
        "&frac12;"
    ],
    [
        0,
        "&frac34;"
    ],
    [
        0,
        "&iquest;"
    ],
    [
        0,
        "&Agrave;"
    ],
    [
        0,
        "&Aacute;"
    ],
    [
        0,
        "&Acirc;"
    ],
    [
        0,
        "&Atilde;"
    ],
    [
        0,
        "&Auml;"
    ],
    [
        0,
        "&angst;"
    ],
    [
        0,
        "&AElig;"
    ],
    [
        0,
        "&Ccedil;"
    ],
    [
        0,
        "&Egrave;"
    ],
    [
        0,
        "&Eacute;"
    ],
    [
        0,
        "&Ecirc;"
    ],
    [
        0,
        "&Euml;"
    ],
    [
        0,
        "&Igrave;"
    ],
    [
        0,
        "&Iacute;"
    ],
    [
        0,
        "&Icirc;"
    ],
    [
        0,
        "&Iuml;"
    ],
    [
        0,
        "&ETH;"
    ],
    [
        0,
        "&Ntilde;"
    ],
    [
        0,
        "&Ograve;"
    ],
    [
        0,
        "&Oacute;"
    ],
    [
        0,
        "&Ocirc;"
    ],
    [
        0,
        "&Otilde;"
    ],
    [
        0,
        "&Ouml;"
    ],
    [
        0,
        "&times;"
    ],
    [
        0,
        "&Oslash;"
    ],
    [
        0,
        "&Ugrave;"
    ],
    [
        0,
        "&Uacute;"
    ],
    [
        0,
        "&Ucirc;"
    ],
    [
        0,
        "&Uuml;"
    ],
    [
        0,
        "&Yacute;"
    ],
    [
        0,
        "&THORN;"
    ],
    [
        0,
        "&szlig;"
    ],
    [
        0,
        "&agrave;"
    ],
    [
        0,
        "&aacute;"
    ],
    [
        0,
        "&acirc;"
    ],
    [
        0,
        "&atilde;"
    ],
    [
        0,
        "&auml;"
    ],
    [
        0,
        "&aring;"
    ],
    [
        0,
        "&aelig;"
    ],
    [
        0,
        "&ccedil;"
    ],
    [
        0,
        "&egrave;"
    ],
    [
        0,
        "&eacute;"
    ],
    [
        0,
        "&ecirc;"
    ],
    [
        0,
        "&euml;"
    ],
    [
        0,
        "&igrave;"
    ],
    [
        0,
        "&iacute;"
    ],
    [
        0,
        "&icirc;"
    ],
    [
        0,
        "&iuml;"
    ],
    [
        0,
        "&eth;"
    ],
    [
        0,
        "&ntilde;"
    ],
    [
        0,
        "&ograve;"
    ],
    [
        0,
        "&oacute;"
    ],
    [
        0,
        "&ocirc;"
    ],
    [
        0,
        "&otilde;"
    ],
    [
        0,
        "&ouml;"
    ],
    [
        0,
        "&div;"
    ],
    [
        0,
        "&oslash;"
    ],
    [
        0,
        "&ugrave;"
    ],
    [
        0,
        "&uacute;"
    ],
    [
        0,
        "&ucirc;"
    ],
    [
        0,
        "&uuml;"
    ],
    [
        0,
        "&yacute;"
    ],
    [
        0,
        "&thorn;"
    ],
    [
        0,
        "&yuml;"
    ],
    [
        0,
        "&Amacr;"
    ],
    [
        0,
        "&amacr;"
    ],
    [
        0,
        "&Abreve;"
    ],
    [
        0,
        "&abreve;"
    ],
    [
        0,
        "&Aogon;"
    ],
    [
        0,
        "&aogon;"
    ],
    [
        0,
        "&Cacute;"
    ],
    [
        0,
        "&cacute;"
    ],
    [
        0,
        "&Ccirc;"
    ],
    [
        0,
        "&ccirc;"
    ],
    [
        0,
        "&Cdot;"
    ],
    [
        0,
        "&cdot;"
    ],
    [
        0,
        "&Ccaron;"
    ],
    [
        0,
        "&ccaron;"
    ],
    [
        0,
        "&Dcaron;"
    ],
    [
        0,
        "&dcaron;"
    ],
    [
        0,
        "&Dstrok;"
    ],
    [
        0,
        "&dstrok;"
    ],
    [
        0,
        "&Emacr;"
    ],
    [
        0,
        "&emacr;"
    ],
    [
        2,
        "&Edot;"
    ],
    [
        0,
        "&edot;"
    ],
    [
        0,
        "&Eogon;"
    ],
    [
        0,
        "&eogon;"
    ],
    [
        0,
        "&Ecaron;"
    ],
    [
        0,
        "&ecaron;"
    ],
    [
        0,
        "&Gcirc;"
    ],
    [
        0,
        "&gcirc;"
    ],
    [
        0,
        "&Gbreve;"
    ],
    [
        0,
        "&gbreve;"
    ],
    [
        0,
        "&Gdot;"
    ],
    [
        0,
        "&gdot;"
    ],
    [
        0,
        "&Gcedil;"
    ],
    [
        1,
        "&Hcirc;"
    ],
    [
        0,
        "&hcirc;"
    ],
    [
        0,
        "&Hstrok;"
    ],
    [
        0,
        "&hstrok;"
    ],
    [
        0,
        "&Itilde;"
    ],
    [
        0,
        "&itilde;"
    ],
    [
        0,
        "&Imacr;"
    ],
    [
        0,
        "&imacr;"
    ],
    [
        2,
        "&Iogon;"
    ],
    [
        0,
        "&iogon;"
    ],
    [
        0,
        "&Idot;"
    ],
    [
        0,
        "&imath;"
    ],
    [
        0,
        "&IJlig;"
    ],
    [
        0,
        "&ijlig;"
    ],
    [
        0,
        "&Jcirc;"
    ],
    [
        0,
        "&jcirc;"
    ],
    [
        0,
        "&Kcedil;"
    ],
    [
        0,
        "&kcedil;"
    ],
    [
        0,
        "&kgreen;"
    ],
    [
        0,
        "&Lacute;"
    ],
    [
        0,
        "&lacute;"
    ],
    [
        0,
        "&Lcedil;"
    ],
    [
        0,
        "&lcedil;"
    ],
    [
        0,
        "&Lcaron;"
    ],
    [
        0,
        "&lcaron;"
    ],
    [
        0,
        "&Lmidot;"
    ],
    [
        0,
        "&lmidot;"
    ],
    [
        0,
        "&Lstrok;"
    ],
    [
        0,
        "&lstrok;"
    ],
    [
        0,
        "&Nacute;"
    ],
    [
        0,
        "&nacute;"
    ],
    [
        0,
        "&Ncedil;"
    ],
    [
        0,
        "&ncedil;"
    ],
    [
        0,
        "&Ncaron;"
    ],
    [
        0,
        "&ncaron;"
    ],
    [
        0,
        "&napos;"
    ],
    [
        0,
        "&ENG;"
    ],
    [
        0,
        "&eng;"
    ],
    [
        0,
        "&Omacr;"
    ],
    [
        0,
        "&omacr;"
    ],
    [
        2,
        "&Odblac;"
    ],
    [
        0,
        "&odblac;"
    ],
    [
        0,
        "&OElig;"
    ],
    [
        0,
        "&oelig;"
    ],
    [
        0,
        "&Racute;"
    ],
    [
        0,
        "&racute;"
    ],
    [
        0,
        "&Rcedil;"
    ],
    [
        0,
        "&rcedil;"
    ],
    [
        0,
        "&Rcaron;"
    ],
    [
        0,
        "&rcaron;"
    ],
    [
        0,
        "&Sacute;"
    ],
    [
        0,
        "&sacute;"
    ],
    [
        0,
        "&Scirc;"
    ],
    [
        0,
        "&scirc;"
    ],
    [
        0,
        "&Scedil;"
    ],
    [
        0,
        "&scedil;"
    ],
    [
        0,
        "&Scaron;"
    ],
    [
        0,
        "&scaron;"
    ],
    [
        0,
        "&Tcedil;"
    ],
    [
        0,
        "&tcedil;"
    ],
    [
        0,
        "&Tcaron;"
    ],
    [
        0,
        "&tcaron;"
    ],
    [
        0,
        "&Tstrok;"
    ],
    [
        0,
        "&tstrok;"
    ],
    [
        0,
        "&Utilde;"
    ],
    [
        0,
        "&utilde;"
    ],
    [
        0,
        "&Umacr;"
    ],
    [
        0,
        "&umacr;"
    ],
    [
        0,
        "&Ubreve;"
    ],
    [
        0,
        "&ubreve;"
    ],
    [
        0,
        "&Uring;"
    ],
    [
        0,
        "&uring;"
    ],
    [
        0,
        "&Udblac;"
    ],
    [
        0,
        "&udblac;"
    ],
    [
        0,
        "&Uogon;"
    ],
    [
        0,
        "&uogon;"
    ],
    [
        0,
        "&Wcirc;"
    ],
    [
        0,
        "&wcirc;"
    ],
    [
        0,
        "&Ycirc;"
    ],
    [
        0,
        "&ycirc;"
    ],
    [
        0,
        "&Yuml;"
    ],
    [
        0,
        "&Zacute;"
    ],
    [
        0,
        "&zacute;"
    ],
    [
        0,
        "&Zdot;"
    ],
    [
        0,
        "&zdot;"
    ],
    [
        0,
        "&Zcaron;"
    ],
    [
        0,
        "&zcaron;"
    ],
    [
        19,
        "&fnof;"
    ],
    [
        34,
        "&imped;"
    ],
    [
        63,
        "&gacute;"
    ],
    [
        65,
        "&jmath;"
    ],
    [
        142,
        "&circ;"
    ],
    [
        0,
        "&caron;"
    ],
    [
        16,
        "&breve;"
    ],
    [
        0,
        "&DiacriticalDot;"
    ],
    [
        0,
        "&ring;"
    ],
    [
        0,
        "&ogon;"
    ],
    [
        0,
        "&DiacriticalTilde;"
    ],
    [
        0,
        "&dblac;"
    ],
    [
        51,
        "&DownBreve;"
    ],
    [
        127,
        "&Alpha;"
    ],
    [
        0,
        "&Beta;"
    ],
    [
        0,
        "&Gamma;"
    ],
    [
        0,
        "&Delta;"
    ],
    [
        0,
        "&Epsilon;"
    ],
    [
        0,
        "&Zeta;"
    ],
    [
        0,
        "&Eta;"
    ],
    [
        0,
        "&Theta;"
    ],
    [
        0,
        "&Iota;"
    ],
    [
        0,
        "&Kappa;"
    ],
    [
        0,
        "&Lambda;"
    ],
    [
        0,
        "&Mu;"
    ],
    [
        0,
        "&Nu;"
    ],
    [
        0,
        "&Xi;"
    ],
    [
        0,
        "&Omicron;"
    ],
    [
        0,
        "&Pi;"
    ],
    [
        0,
        "&Rho;"
    ],
    [
        1,
        "&Sigma;"
    ],
    [
        0,
        "&Tau;"
    ],
    [
        0,
        "&Upsilon;"
    ],
    [
        0,
        "&Phi;"
    ],
    [
        0,
        "&Chi;"
    ],
    [
        0,
        "&Psi;"
    ],
    [
        0,
        "&ohm;"
    ],
    [
        7,
        "&alpha;"
    ],
    [
        0,
        "&beta;"
    ],
    [
        0,
        "&gamma;"
    ],
    [
        0,
        "&delta;"
    ],
    [
        0,
        "&epsi;"
    ],
    [
        0,
        "&zeta;"
    ],
    [
        0,
        "&eta;"
    ],
    [
        0,
        "&theta;"
    ],
    [
        0,
        "&iota;"
    ],
    [
        0,
        "&kappa;"
    ],
    [
        0,
        "&lambda;"
    ],
    [
        0,
        "&mu;"
    ],
    [
        0,
        "&nu;"
    ],
    [
        0,
        "&xi;"
    ],
    [
        0,
        "&omicron;"
    ],
    [
        0,
        "&pi;"
    ],
    [
        0,
        "&rho;"
    ],
    [
        0,
        "&sigmaf;"
    ],
    [
        0,
        "&sigma;"
    ],
    [
        0,
        "&tau;"
    ],
    [
        0,
        "&upsi;"
    ],
    [
        0,
        "&phi;"
    ],
    [
        0,
        "&chi;"
    ],
    [
        0,
        "&psi;"
    ],
    [
        0,
        "&omega;"
    ],
    [
        7,
        "&thetasym;"
    ],
    [
        0,
        "&Upsi;"
    ],
    [
        2,
        "&phiv;"
    ],
    [
        0,
        "&piv;"
    ],
    [
        5,
        "&Gammad;"
    ],
    [
        0,
        "&digamma;"
    ],
    [
        18,
        "&kappav;"
    ],
    [
        0,
        "&rhov;"
    ],
    [
        3,
        "&epsiv;"
    ],
    [
        0,
        "&backepsilon;"
    ],
    [
        10,
        "&IOcy;"
    ],
    [
        0,
        "&DJcy;"
    ],
    [
        0,
        "&GJcy;"
    ],
    [
        0,
        "&Jukcy;"
    ],
    [
        0,
        "&DScy;"
    ],
    [
        0,
        "&Iukcy;"
    ],
    [
        0,
        "&YIcy;"
    ],
    [
        0,
        "&Jsercy;"
    ],
    [
        0,
        "&LJcy;"
    ],
    [
        0,
        "&NJcy;"
    ],
    [
        0,
        "&TSHcy;"
    ],
    [
        0,
        "&KJcy;"
    ],
    [
        1,
        "&Ubrcy;"
    ],
    [
        0,
        "&DZcy;"
    ],
    [
        0,
        "&Acy;"
    ],
    [
        0,
        "&Bcy;"
    ],
    [
        0,
        "&Vcy;"
    ],
    [
        0,
        "&Gcy;"
    ],
    [
        0,
        "&Dcy;"
    ],
    [
        0,
        "&IEcy;"
    ],
    [
        0,
        "&ZHcy;"
    ],
    [
        0,
        "&Zcy;"
    ],
    [
        0,
        "&Icy;"
    ],
    [
        0,
        "&Jcy;"
    ],
    [
        0,
        "&Kcy;"
    ],
    [
        0,
        "&Lcy;"
    ],
    [
        0,
        "&Mcy;"
    ],
    [
        0,
        "&Ncy;"
    ],
    [
        0,
        "&Ocy;"
    ],
    [
        0,
        "&Pcy;"
    ],
    [
        0,
        "&Rcy;"
    ],
    [
        0,
        "&Scy;"
    ],
    [
        0,
        "&Tcy;"
    ],
    [
        0,
        "&Ucy;"
    ],
    [
        0,
        "&Fcy;"
    ],
    [
        0,
        "&KHcy;"
    ],
    [
        0,
        "&TScy;"
    ],
    [
        0,
        "&CHcy;"
    ],
    [
        0,
        "&SHcy;"
    ],
    [
        0,
        "&SHCHcy;"
    ],
    [
        0,
        "&HARDcy;"
    ],
    [
        0,
        "&Ycy;"
    ],
    [
        0,
        "&SOFTcy;"
    ],
    [
        0,
        "&Ecy;"
    ],
    [
        0,
        "&YUcy;"
    ],
    [
        0,
        "&YAcy;"
    ],
    [
        0,
        "&acy;"
    ],
    [
        0,
        "&bcy;"
    ],
    [
        0,
        "&vcy;"
    ],
    [
        0,
        "&gcy;"
    ],
    [
        0,
        "&dcy;"
    ],
    [
        0,
        "&iecy;"
    ],
    [
        0,
        "&zhcy;"
    ],
    [
        0,
        "&zcy;"
    ],
    [
        0,
        "&icy;"
    ],
    [
        0,
        "&jcy;"
    ],
    [
        0,
        "&kcy;"
    ],
    [
        0,
        "&lcy;"
    ],
    [
        0,
        "&mcy;"
    ],
    [
        0,
        "&ncy;"
    ],
    [
        0,
        "&ocy;"
    ],
    [
        0,
        "&pcy;"
    ],
    [
        0,
        "&rcy;"
    ],
    [
        0,
        "&scy;"
    ],
    [
        0,
        "&tcy;"
    ],
    [
        0,
        "&ucy;"
    ],
    [
        0,
        "&fcy;"
    ],
    [
        0,
        "&khcy;"
    ],
    [
        0,
        "&tscy;"
    ],
    [
        0,
        "&chcy;"
    ],
    [
        0,
        "&shcy;"
    ],
    [
        0,
        "&shchcy;"
    ],
    [
        0,
        "&hardcy;"
    ],
    [
        0,
        "&ycy;"
    ],
    [
        0,
        "&softcy;"
    ],
    [
        0,
        "&ecy;"
    ],
    [
        0,
        "&yucy;"
    ],
    [
        0,
        "&yacy;"
    ],
    [
        1,
        "&iocy;"
    ],
    [
        0,
        "&djcy;"
    ],
    [
        0,
        "&gjcy;"
    ],
    [
        0,
        "&jukcy;"
    ],
    [
        0,
        "&dscy;"
    ],
    [
        0,
        "&iukcy;"
    ],
    [
        0,
        "&yicy;"
    ],
    [
        0,
        "&jsercy;"
    ],
    [
        0,
        "&ljcy;"
    ],
    [
        0,
        "&njcy;"
    ],
    [
        0,
        "&tshcy;"
    ],
    [
        0,
        "&kjcy;"
    ],
    [
        1,
        "&ubrcy;"
    ],
    [
        0,
        "&dzcy;"
    ],
    [
        7074,
        "&ensp;"
    ],
    [
        0,
        "&emsp;"
    ],
    [
        0,
        "&emsp13;"
    ],
    [
        0,
        "&emsp14;"
    ],
    [
        1,
        "&numsp;"
    ],
    [
        0,
        "&puncsp;"
    ],
    [
        0,
        "&ThinSpace;"
    ],
    [
        0,
        "&hairsp;"
    ],
    [
        0,
        "&NegativeMediumSpace;"
    ],
    [
        0,
        "&zwnj;"
    ],
    [
        0,
        "&zwj;"
    ],
    [
        0,
        "&lrm;"
    ],
    [
        0,
        "&rlm;"
    ],
    [
        0,
        "&dash;"
    ],
    [
        2,
        "&ndash;"
    ],
    [
        0,
        "&mdash;"
    ],
    [
        0,
        "&horbar;"
    ],
    [
        0,
        "&Verbar;"
    ],
    [
        1,
        "&lsquo;"
    ],
    [
        0,
        "&CloseCurlyQuote;"
    ],
    [
        0,
        "&lsquor;"
    ],
    [
        1,
        "&ldquo;"
    ],
    [
        0,
        "&CloseCurlyDoubleQuote;"
    ],
    [
        0,
        "&bdquo;"
    ],
    [
        1,
        "&dagger;"
    ],
    [
        0,
        "&Dagger;"
    ],
    [
        0,
        "&bull;"
    ],
    [
        2,
        "&nldr;"
    ],
    [
        0,
        "&hellip;"
    ],
    [
        9,
        "&permil;"
    ],
    [
        0,
        "&pertenk;"
    ],
    [
        0,
        "&prime;"
    ],
    [
        0,
        "&Prime;"
    ],
    [
        0,
        "&tprime;"
    ],
    [
        0,
        "&backprime;"
    ],
    [
        3,
        "&lsaquo;"
    ],
    [
        0,
        "&rsaquo;"
    ],
    [
        3,
        "&oline;"
    ],
    [
        2,
        "&caret;"
    ],
    [
        1,
        "&hybull;"
    ],
    [
        0,
        "&frasl;"
    ],
    [
        10,
        "&bsemi;"
    ],
    [
        7,
        "&qprime;"
    ],
    [
        7,
        {
            v: "&MediumSpace;",
            n: 8202,
            o: "&ThickSpace;"
        }
    ],
    [
        0,
        "&NoBreak;"
    ],
    [
        0,
        "&af;"
    ],
    [
        0,
        "&InvisibleTimes;"
    ],
    [
        0,
        "&ic;"
    ],
    [
        72,
        "&euro;"
    ],
    [
        46,
        "&tdot;"
    ],
    [
        0,
        "&DotDot;"
    ],
    [
        37,
        "&complexes;"
    ],
    [
        2,
        "&incare;"
    ],
    [
        4,
        "&gscr;"
    ],
    [
        0,
        "&hamilt;"
    ],
    [
        0,
        "&Hfr;"
    ],
    [
        0,
        "&Hopf;"
    ],
    [
        0,
        "&planckh;"
    ],
    [
        0,
        "&hbar;"
    ],
    [
        0,
        "&imagline;"
    ],
    [
        0,
        "&Ifr;"
    ],
    [
        0,
        "&lagran;"
    ],
    [
        0,
        "&ell;"
    ],
    [
        1,
        "&naturals;"
    ],
    [
        0,
        "&numero;"
    ],
    [
        0,
        "&copysr;"
    ],
    [
        0,
        "&weierp;"
    ],
    [
        0,
        "&Popf;"
    ],
    [
        0,
        "&Qopf;"
    ],
    [
        0,
        "&realine;"
    ],
    [
        0,
        "&real;"
    ],
    [
        0,
        "&reals;"
    ],
    [
        0,
        "&rx;"
    ],
    [
        3,
        "&trade;"
    ],
    [
        1,
        "&integers;"
    ],
    [
        2,
        "&mho;"
    ],
    [
        0,
        "&zeetrf;"
    ],
    [
        0,
        "&iiota;"
    ],
    [
        2,
        "&bernou;"
    ],
    [
        0,
        "&Cayleys;"
    ],
    [
        1,
        "&escr;"
    ],
    [
        0,
        "&Escr;"
    ],
    [
        0,
        "&Fouriertrf;"
    ],
    [
        1,
        "&Mellintrf;"
    ],
    [
        0,
        "&order;"
    ],
    [
        0,
        "&alefsym;"
    ],
    [
        0,
        "&beth;"
    ],
    [
        0,
        "&gimel;"
    ],
    [
        0,
        "&daleth;"
    ],
    [
        12,
        "&CapitalDifferentialD;"
    ],
    [
        0,
        "&dd;"
    ],
    [
        0,
        "&ee;"
    ],
    [
        0,
        "&ii;"
    ],
    [
        10,
        "&frac13;"
    ],
    [
        0,
        "&frac23;"
    ],
    [
        0,
        "&frac15;"
    ],
    [
        0,
        "&frac25;"
    ],
    [
        0,
        "&frac35;"
    ],
    [
        0,
        "&frac45;"
    ],
    [
        0,
        "&frac16;"
    ],
    [
        0,
        "&frac56;"
    ],
    [
        0,
        "&frac18;"
    ],
    [
        0,
        "&frac38;"
    ],
    [
        0,
        "&frac58;"
    ],
    [
        0,
        "&frac78;"
    ],
    [
        49,
        "&larr;"
    ],
    [
        0,
        "&ShortUpArrow;"
    ],
    [
        0,
        "&rarr;"
    ],
    [
        0,
        "&darr;"
    ],
    [
        0,
        "&harr;"
    ],
    [
        0,
        "&updownarrow;"
    ],
    [
        0,
        "&nwarr;"
    ],
    [
        0,
        "&nearr;"
    ],
    [
        0,
        "&LowerRightArrow;"
    ],
    [
        0,
        "&LowerLeftArrow;"
    ],
    [
        0,
        "&nlarr;"
    ],
    [
        0,
        "&nrarr;"
    ],
    [
        1,
        {
            v: "&rarrw;",
            n: 824,
            o: "&nrarrw;"
        }
    ],
    [
        0,
        "&Larr;"
    ],
    [
        0,
        "&Uarr;"
    ],
    [
        0,
        "&Rarr;"
    ],
    [
        0,
        "&Darr;"
    ],
    [
        0,
        "&larrtl;"
    ],
    [
        0,
        "&rarrtl;"
    ],
    [
        0,
        "&LeftTeeArrow;"
    ],
    [
        0,
        "&mapstoup;"
    ],
    [
        0,
        "&map;"
    ],
    [
        0,
        "&DownTeeArrow;"
    ],
    [
        1,
        "&hookleftarrow;"
    ],
    [
        0,
        "&hookrightarrow;"
    ],
    [
        0,
        "&larrlp;"
    ],
    [
        0,
        "&looparrowright;"
    ],
    [
        0,
        "&harrw;"
    ],
    [
        0,
        "&nharr;"
    ],
    [
        1,
        "&lsh;"
    ],
    [
        0,
        "&rsh;"
    ],
    [
        0,
        "&ldsh;"
    ],
    [
        0,
        "&rdsh;"
    ],
    [
        1,
        "&crarr;"
    ],
    [
        0,
        "&cularr;"
    ],
    [
        0,
        "&curarr;"
    ],
    [
        2,
        "&circlearrowleft;"
    ],
    [
        0,
        "&circlearrowright;"
    ],
    [
        0,
        "&leftharpoonup;"
    ],
    [
        0,
        "&DownLeftVector;"
    ],
    [
        0,
        "&RightUpVector;"
    ],
    [
        0,
        "&LeftUpVector;"
    ],
    [
        0,
        "&rharu;"
    ],
    [
        0,
        "&DownRightVector;"
    ],
    [
        0,
        "&dharr;"
    ],
    [
        0,
        "&dharl;"
    ],
    [
        0,
        "&RightArrowLeftArrow;"
    ],
    [
        0,
        "&udarr;"
    ],
    [
        0,
        "&LeftArrowRightArrow;"
    ],
    [
        0,
        "&leftleftarrows;"
    ],
    [
        0,
        "&upuparrows;"
    ],
    [
        0,
        "&rightrightarrows;"
    ],
    [
        0,
        "&ddarr;"
    ],
    [
        0,
        "&leftrightharpoons;"
    ],
    [
        0,
        "&Equilibrium;"
    ],
    [
        0,
        "&nlArr;"
    ],
    [
        0,
        "&nhArr;"
    ],
    [
        0,
        "&nrArr;"
    ],
    [
        0,
        "&DoubleLeftArrow;"
    ],
    [
        0,
        "&DoubleUpArrow;"
    ],
    [
        0,
        "&DoubleRightArrow;"
    ],
    [
        0,
        "&dArr;"
    ],
    [
        0,
        "&DoubleLeftRightArrow;"
    ],
    [
        0,
        "&DoubleUpDownArrow;"
    ],
    [
        0,
        "&nwArr;"
    ],
    [
        0,
        "&neArr;"
    ],
    [
        0,
        "&seArr;"
    ],
    [
        0,
        "&swArr;"
    ],
    [
        0,
        "&lAarr;"
    ],
    [
        0,
        "&rAarr;"
    ],
    [
        1,
        "&zigrarr;"
    ],
    [
        6,
        "&larrb;"
    ],
    [
        0,
        "&rarrb;"
    ],
    [
        15,
        "&DownArrowUpArrow;"
    ],
    [
        7,
        "&loarr;"
    ],
    [
        0,
        "&roarr;"
    ],
    [
        0,
        "&hoarr;"
    ],
    [
        0,
        "&forall;"
    ],
    [
        0,
        "&comp;"
    ],
    [
        0,
        {
            v: "&part;",
            n: 824,
            o: "&npart;"
        }
    ],
    [
        0,
        "&exist;"
    ],
    [
        0,
        "&nexist;"
    ],
    [
        0,
        "&empty;"
    ],
    [
        1,
        "&Del;"
    ],
    [
        0,
        "&Element;"
    ],
    [
        0,
        "&NotElement;"
    ],
    [
        1,
        "&ni;"
    ],
    [
        0,
        "&notni;"
    ],
    [
        2,
        "&prod;"
    ],
    [
        0,
        "&coprod;"
    ],
    [
        0,
        "&sum;"
    ],
    [
        0,
        "&minus;"
    ],
    [
        0,
        "&MinusPlus;"
    ],
    [
        0,
        "&dotplus;"
    ],
    [
        1,
        "&Backslash;"
    ],
    [
        0,
        "&lowast;"
    ],
    [
        0,
        "&compfn;"
    ],
    [
        1,
        "&radic;"
    ],
    [
        2,
        "&prop;"
    ],
    [
        0,
        "&infin;"
    ],
    [
        0,
        "&angrt;"
    ],
    [
        0,
        {
            v: "&ang;",
            n: 8402,
            o: "&nang;"
        }
    ],
    [
        0,
        "&angmsd;"
    ],
    [
        0,
        "&angsph;"
    ],
    [
        0,
        "&mid;"
    ],
    [
        0,
        "&nmid;"
    ],
    [
        0,
        "&DoubleVerticalBar;"
    ],
    [
        0,
        "&NotDoubleVerticalBar;"
    ],
    [
        0,
        "&and;"
    ],
    [
        0,
        "&or;"
    ],
    [
        0,
        {
            v: "&cap;",
            n: 65024,
            o: "&caps;"
        }
    ],
    [
        0,
        {
            v: "&cup;",
            n: 65024,
            o: "&cups;"
        }
    ],
    [
        0,
        "&int;"
    ],
    [
        0,
        "&Int;"
    ],
    [
        0,
        "&iiint;"
    ],
    [
        0,
        "&conint;"
    ],
    [
        0,
        "&Conint;"
    ],
    [
        0,
        "&Cconint;"
    ],
    [
        0,
        "&cwint;"
    ],
    [
        0,
        "&ClockwiseContourIntegral;"
    ],
    [
        0,
        "&awconint;"
    ],
    [
        0,
        "&there4;"
    ],
    [
        0,
        "&becaus;"
    ],
    [
        0,
        "&ratio;"
    ],
    [
        0,
        "&Colon;"
    ],
    [
        0,
        "&dotminus;"
    ],
    [
        1,
        "&mDDot;"
    ],
    [
        0,
        "&homtht;"
    ],
    [
        0,
        {
            v: "&sim;",
            n: 8402,
            o: "&nvsim;"
        }
    ],
    [
        0,
        {
            v: "&backsim;",
            n: 817,
            o: "&race;"
        }
    ],
    [
        0,
        {
            v: "&ac;",
            n: 819,
            o: "&acE;"
        }
    ],
    [
        0,
        "&acd;"
    ],
    [
        0,
        "&VerticalTilde;"
    ],
    [
        0,
        "&NotTilde;"
    ],
    [
        0,
        {
            v: "&eqsim;",
            n: 824,
            o: "&nesim;"
        }
    ],
    [
        0,
        "&sime;"
    ],
    [
        0,
        "&NotTildeEqual;"
    ],
    [
        0,
        "&cong;"
    ],
    [
        0,
        "&simne;"
    ],
    [
        0,
        "&ncong;"
    ],
    [
        0,
        "&ap;"
    ],
    [
        0,
        "&nap;"
    ],
    [
        0,
        "&ape;"
    ],
    [
        0,
        {
            v: "&apid;",
            n: 824,
            o: "&napid;"
        }
    ],
    [
        0,
        "&backcong;"
    ],
    [
        0,
        {
            v: "&asympeq;",
            n: 8402,
            o: "&nvap;"
        }
    ],
    [
        0,
        {
            v: "&bump;",
            n: 824,
            o: "&nbump;"
        }
    ],
    [
        0,
        {
            v: "&bumpe;",
            n: 824,
            o: "&nbumpe;"
        }
    ],
    [
        0,
        {
            v: "&doteq;",
            n: 824,
            o: "&nedot;"
        }
    ],
    [
        0,
        "&doteqdot;"
    ],
    [
        0,
        "&efDot;"
    ],
    [
        0,
        "&erDot;"
    ],
    [
        0,
        "&Assign;"
    ],
    [
        0,
        "&ecolon;"
    ],
    [
        0,
        "&ecir;"
    ],
    [
        0,
        "&circeq;"
    ],
    [
        1,
        "&wedgeq;"
    ],
    [
        0,
        "&veeeq;"
    ],
    [
        1,
        "&triangleq;"
    ],
    [
        2,
        "&equest;"
    ],
    [
        0,
        "&ne;"
    ],
    [
        0,
        {
            v: "&Congruent;",
            n: 8421,
            o: "&bnequiv;"
        }
    ],
    [
        0,
        "&nequiv;"
    ],
    [
        1,
        {
            v: "&le;",
            n: 8402,
            o: "&nvle;"
        }
    ],
    [
        0,
        {
            v: "&ge;",
            n: 8402,
            o: "&nvge;"
        }
    ],
    [
        0,
        {
            v: "&lE;",
            n: 824,
            o: "&nlE;"
        }
    ],
    [
        0,
        {
            v: "&gE;",
            n: 824,
            o: "&ngE;"
        }
    ],
    [
        0,
        {
            v: "&lnE;",
            n: 65024,
            o: "&lvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&gnE;",
            n: 65024,
            o: "&gvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&ll;",
            n: new Map(/* #__PURE__ */ $5d17e1547aea90db$var$restoreDiff([
                [
                    824,
                    "&nLtv;"
                ],
                [
                    7577,
                    "&nLt;"
                ]
            ]))
        }
    ],
    [
        0,
        {
            v: "&gg;",
            n: new Map(/* #__PURE__ */ $5d17e1547aea90db$var$restoreDiff([
                [
                    824,
                    "&nGtv;"
                ],
                [
                    7577,
                    "&nGt;"
                ]
            ]))
        }
    ],
    [
        0,
        "&between;"
    ],
    [
        0,
        "&NotCupCap;"
    ],
    [
        0,
        "&nless;"
    ],
    [
        0,
        "&ngt;"
    ],
    [
        0,
        "&nle;"
    ],
    [
        0,
        "&nge;"
    ],
    [
        0,
        "&lesssim;"
    ],
    [
        0,
        "&GreaterTilde;"
    ],
    [
        0,
        "&nlsim;"
    ],
    [
        0,
        "&ngsim;"
    ],
    [
        0,
        "&LessGreater;"
    ],
    [
        0,
        "&gl;"
    ],
    [
        0,
        "&NotLessGreater;"
    ],
    [
        0,
        "&NotGreaterLess;"
    ],
    [
        0,
        "&pr;"
    ],
    [
        0,
        "&sc;"
    ],
    [
        0,
        "&prcue;"
    ],
    [
        0,
        "&sccue;"
    ],
    [
        0,
        "&PrecedesTilde;"
    ],
    [
        0,
        {
            v: "&scsim;",
            n: 824,
            o: "&NotSucceedsTilde;"
        }
    ],
    [
        0,
        "&NotPrecedes;"
    ],
    [
        0,
        "&NotSucceeds;"
    ],
    [
        0,
        {
            v: "&sub;",
            n: 8402,
            o: "&NotSubset;"
        }
    ],
    [
        0,
        {
            v: "&sup;",
            n: 8402,
            o: "&NotSuperset;"
        }
    ],
    [
        0,
        "&nsub;"
    ],
    [
        0,
        "&nsup;"
    ],
    [
        0,
        "&sube;"
    ],
    [
        0,
        "&supe;"
    ],
    [
        0,
        "&NotSubsetEqual;"
    ],
    [
        0,
        "&NotSupersetEqual;"
    ],
    [
        0,
        {
            v: "&subne;",
            n: 65024,
            o: "&varsubsetneq;"
        }
    ],
    [
        0,
        {
            v: "&supne;",
            n: 65024,
            o: "&varsupsetneq;"
        }
    ],
    [
        1,
        "&cupdot;"
    ],
    [
        0,
        "&UnionPlus;"
    ],
    [
        0,
        {
            v: "&sqsub;",
            n: 824,
            o: "&NotSquareSubset;"
        }
    ],
    [
        0,
        {
            v: "&sqsup;",
            n: 824,
            o: "&NotSquareSuperset;"
        }
    ],
    [
        0,
        "&sqsube;"
    ],
    [
        0,
        "&sqsupe;"
    ],
    [
        0,
        {
            v: "&sqcap;",
            n: 65024,
            o: "&sqcaps;"
        }
    ],
    [
        0,
        {
            v: "&sqcup;",
            n: 65024,
            o: "&sqcups;"
        }
    ],
    [
        0,
        "&CirclePlus;"
    ],
    [
        0,
        "&CircleMinus;"
    ],
    [
        0,
        "&CircleTimes;"
    ],
    [
        0,
        "&osol;"
    ],
    [
        0,
        "&CircleDot;"
    ],
    [
        0,
        "&circledcirc;"
    ],
    [
        0,
        "&circledast;"
    ],
    [
        1,
        "&circleddash;"
    ],
    [
        0,
        "&boxplus;"
    ],
    [
        0,
        "&boxminus;"
    ],
    [
        0,
        "&boxtimes;"
    ],
    [
        0,
        "&dotsquare;"
    ],
    [
        0,
        "&RightTee;"
    ],
    [
        0,
        "&dashv;"
    ],
    [
        0,
        "&DownTee;"
    ],
    [
        0,
        "&bot;"
    ],
    [
        1,
        "&models;"
    ],
    [
        0,
        "&DoubleRightTee;"
    ],
    [
        0,
        "&Vdash;"
    ],
    [
        0,
        "&Vvdash;"
    ],
    [
        0,
        "&VDash;"
    ],
    [
        0,
        "&nvdash;"
    ],
    [
        0,
        "&nvDash;"
    ],
    [
        0,
        "&nVdash;"
    ],
    [
        0,
        "&nVDash;"
    ],
    [
        0,
        "&prurel;"
    ],
    [
        1,
        "&LeftTriangle;"
    ],
    [
        0,
        "&RightTriangle;"
    ],
    [
        0,
        {
            v: "&LeftTriangleEqual;",
            n: 8402,
            o: "&nvltrie;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleEqual;",
            n: 8402,
            o: "&nvrtrie;"
        }
    ],
    [
        0,
        "&origof;"
    ],
    [
        0,
        "&imof;"
    ],
    [
        0,
        "&multimap;"
    ],
    [
        0,
        "&hercon;"
    ],
    [
        0,
        "&intcal;"
    ],
    [
        0,
        "&veebar;"
    ],
    [
        1,
        "&barvee;"
    ],
    [
        0,
        "&angrtvb;"
    ],
    [
        0,
        "&lrtri;"
    ],
    [
        0,
        "&bigwedge;"
    ],
    [
        0,
        "&bigvee;"
    ],
    [
        0,
        "&bigcap;"
    ],
    [
        0,
        "&bigcup;"
    ],
    [
        0,
        "&diam;"
    ],
    [
        0,
        "&sdot;"
    ],
    [
        0,
        "&sstarf;"
    ],
    [
        0,
        "&divideontimes;"
    ],
    [
        0,
        "&bowtie;"
    ],
    [
        0,
        "&ltimes;"
    ],
    [
        0,
        "&rtimes;"
    ],
    [
        0,
        "&leftthreetimes;"
    ],
    [
        0,
        "&rightthreetimes;"
    ],
    [
        0,
        "&backsimeq;"
    ],
    [
        0,
        "&curlyvee;"
    ],
    [
        0,
        "&curlywedge;"
    ],
    [
        0,
        "&Sub;"
    ],
    [
        0,
        "&Sup;"
    ],
    [
        0,
        "&Cap;"
    ],
    [
        0,
        "&Cup;"
    ],
    [
        0,
        "&fork;"
    ],
    [
        0,
        "&epar;"
    ],
    [
        0,
        "&lessdot;"
    ],
    [
        0,
        "&gtdot;"
    ],
    [
        0,
        {
            v: "&Ll;",
            n: 824,
            o: "&nLl;"
        }
    ],
    [
        0,
        {
            v: "&Gg;",
            n: 824,
            o: "&nGg;"
        }
    ],
    [
        0,
        {
            v: "&leg;",
            n: 65024,
            o: "&lesg;"
        }
    ],
    [
        0,
        {
            v: "&gel;",
            n: 65024,
            o: "&gesl;"
        }
    ],
    [
        2,
        "&cuepr;"
    ],
    [
        0,
        "&cuesc;"
    ],
    [
        0,
        "&NotPrecedesSlantEqual;"
    ],
    [
        0,
        "&NotSucceedsSlantEqual;"
    ],
    [
        0,
        "&NotSquareSubsetEqual;"
    ],
    [
        0,
        "&NotSquareSupersetEqual;"
    ],
    [
        2,
        "&lnsim;"
    ],
    [
        0,
        "&gnsim;"
    ],
    [
        0,
        "&precnsim;"
    ],
    [
        0,
        "&scnsim;"
    ],
    [
        0,
        "&nltri;"
    ],
    [
        0,
        "&NotRightTriangle;"
    ],
    [
        0,
        "&nltrie;"
    ],
    [
        0,
        "&NotRightTriangleEqual;"
    ],
    [
        0,
        "&vellip;"
    ],
    [
        0,
        "&ctdot;"
    ],
    [
        0,
        "&utdot;"
    ],
    [
        0,
        "&dtdot;"
    ],
    [
        0,
        "&disin;"
    ],
    [
        0,
        "&isinsv;"
    ],
    [
        0,
        "&isins;"
    ],
    [
        0,
        {
            v: "&isindot;",
            n: 824,
            o: "&notindot;"
        }
    ],
    [
        0,
        "&notinvc;"
    ],
    [
        0,
        "&notinvb;"
    ],
    [
        1,
        {
            v: "&isinE;",
            n: 824,
            o: "&notinE;"
        }
    ],
    [
        0,
        "&nisd;"
    ],
    [
        0,
        "&xnis;"
    ],
    [
        0,
        "&nis;"
    ],
    [
        0,
        "&notnivc;"
    ],
    [
        0,
        "&notnivb;"
    ],
    [
        6,
        "&barwed;"
    ],
    [
        0,
        "&Barwed;"
    ],
    [
        1,
        "&lceil;"
    ],
    [
        0,
        "&rceil;"
    ],
    [
        0,
        "&LeftFloor;"
    ],
    [
        0,
        "&rfloor;"
    ],
    [
        0,
        "&drcrop;"
    ],
    [
        0,
        "&dlcrop;"
    ],
    [
        0,
        "&urcrop;"
    ],
    [
        0,
        "&ulcrop;"
    ],
    [
        0,
        "&bnot;"
    ],
    [
        1,
        "&profline;"
    ],
    [
        0,
        "&profsurf;"
    ],
    [
        1,
        "&telrec;"
    ],
    [
        0,
        "&target;"
    ],
    [
        5,
        "&ulcorn;"
    ],
    [
        0,
        "&urcorn;"
    ],
    [
        0,
        "&dlcorn;"
    ],
    [
        0,
        "&drcorn;"
    ],
    [
        2,
        "&frown;"
    ],
    [
        0,
        "&smile;"
    ],
    [
        9,
        "&cylcty;"
    ],
    [
        0,
        "&profalar;"
    ],
    [
        7,
        "&topbot;"
    ],
    [
        6,
        "&ovbar;"
    ],
    [
        1,
        "&solbar;"
    ],
    [
        60,
        "&angzarr;"
    ],
    [
        51,
        "&lmoustache;"
    ],
    [
        0,
        "&rmoustache;"
    ],
    [
        2,
        "&OverBracket;"
    ],
    [
        0,
        "&bbrk;"
    ],
    [
        0,
        "&bbrktbrk;"
    ],
    [
        37,
        "&OverParenthesis;"
    ],
    [
        0,
        "&UnderParenthesis;"
    ],
    [
        0,
        "&OverBrace;"
    ],
    [
        0,
        "&UnderBrace;"
    ],
    [
        2,
        "&trpezium;"
    ],
    [
        4,
        "&elinters;"
    ],
    [
        59,
        "&blank;"
    ],
    [
        164,
        "&circledS;"
    ],
    [
        55,
        "&boxh;"
    ],
    [
        1,
        "&boxv;"
    ],
    [
        9,
        "&boxdr;"
    ],
    [
        3,
        "&boxdl;"
    ],
    [
        3,
        "&boxur;"
    ],
    [
        3,
        "&boxul;"
    ],
    [
        3,
        "&boxvr;"
    ],
    [
        7,
        "&boxvl;"
    ],
    [
        7,
        "&boxhd;"
    ],
    [
        7,
        "&boxhu;"
    ],
    [
        7,
        "&boxvh;"
    ],
    [
        19,
        "&boxH;"
    ],
    [
        0,
        "&boxV;"
    ],
    [
        0,
        "&boxdR;"
    ],
    [
        0,
        "&boxDr;"
    ],
    [
        0,
        "&boxDR;"
    ],
    [
        0,
        "&boxdL;"
    ],
    [
        0,
        "&boxDl;"
    ],
    [
        0,
        "&boxDL;"
    ],
    [
        0,
        "&boxuR;"
    ],
    [
        0,
        "&boxUr;"
    ],
    [
        0,
        "&boxUR;"
    ],
    [
        0,
        "&boxuL;"
    ],
    [
        0,
        "&boxUl;"
    ],
    [
        0,
        "&boxUL;"
    ],
    [
        0,
        "&boxvR;"
    ],
    [
        0,
        "&boxVr;"
    ],
    [
        0,
        "&boxVR;"
    ],
    [
        0,
        "&boxvL;"
    ],
    [
        0,
        "&boxVl;"
    ],
    [
        0,
        "&boxVL;"
    ],
    [
        0,
        "&boxHd;"
    ],
    [
        0,
        "&boxhD;"
    ],
    [
        0,
        "&boxHD;"
    ],
    [
        0,
        "&boxHu;"
    ],
    [
        0,
        "&boxhU;"
    ],
    [
        0,
        "&boxHU;"
    ],
    [
        0,
        "&boxvH;"
    ],
    [
        0,
        "&boxVh;"
    ],
    [
        0,
        "&boxVH;"
    ],
    [
        19,
        "&uhblk;"
    ],
    [
        3,
        "&lhblk;"
    ],
    [
        3,
        "&block;"
    ],
    [
        8,
        "&blk14;"
    ],
    [
        0,
        "&blk12;"
    ],
    [
        0,
        "&blk34;"
    ],
    [
        13,
        "&square;"
    ],
    [
        8,
        "&blacksquare;"
    ],
    [
        0,
        "&EmptyVerySmallSquare;"
    ],
    [
        1,
        "&rect;"
    ],
    [
        0,
        "&marker;"
    ],
    [
        2,
        "&fltns;"
    ],
    [
        1,
        "&bigtriangleup;"
    ],
    [
        0,
        "&blacktriangle;"
    ],
    [
        0,
        "&triangle;"
    ],
    [
        2,
        "&blacktriangleright;"
    ],
    [
        0,
        "&rtri;"
    ],
    [
        3,
        "&bigtriangledown;"
    ],
    [
        0,
        "&blacktriangledown;"
    ],
    [
        0,
        "&dtri;"
    ],
    [
        2,
        "&blacktriangleleft;"
    ],
    [
        0,
        "&ltri;"
    ],
    [
        6,
        "&loz;"
    ],
    [
        0,
        "&cir;"
    ],
    [
        32,
        "&tridot;"
    ],
    [
        2,
        "&bigcirc;"
    ],
    [
        8,
        "&ultri;"
    ],
    [
        0,
        "&urtri;"
    ],
    [
        0,
        "&lltri;"
    ],
    [
        0,
        "&EmptySmallSquare;"
    ],
    [
        0,
        "&FilledSmallSquare;"
    ],
    [
        8,
        "&bigstar;"
    ],
    [
        0,
        "&star;"
    ],
    [
        7,
        "&phone;"
    ],
    [
        49,
        "&female;"
    ],
    [
        1,
        "&male;"
    ],
    [
        29,
        "&spades;"
    ],
    [
        2,
        "&clubs;"
    ],
    [
        1,
        "&hearts;"
    ],
    [
        0,
        "&diamondsuit;"
    ],
    [
        3,
        "&sung;"
    ],
    [
        2,
        "&flat;"
    ],
    [
        0,
        "&natural;"
    ],
    [
        0,
        "&sharp;"
    ],
    [
        163,
        "&check;"
    ],
    [
        3,
        "&cross;"
    ],
    [
        8,
        "&malt;"
    ],
    [
        21,
        "&sext;"
    ],
    [
        33,
        "&VerticalSeparator;"
    ],
    [
        25,
        "&lbbrk;"
    ],
    [
        0,
        "&rbbrk;"
    ],
    [
        84,
        "&bsolhsub;"
    ],
    [
        0,
        "&suphsol;"
    ],
    [
        28,
        "&LeftDoubleBracket;"
    ],
    [
        0,
        "&RightDoubleBracket;"
    ],
    [
        0,
        "&lang;"
    ],
    [
        0,
        "&rang;"
    ],
    [
        0,
        "&Lang;"
    ],
    [
        0,
        "&Rang;"
    ],
    [
        0,
        "&loang;"
    ],
    [
        0,
        "&roang;"
    ],
    [
        7,
        "&longleftarrow;"
    ],
    [
        0,
        "&longrightarrow;"
    ],
    [
        0,
        "&longleftrightarrow;"
    ],
    [
        0,
        "&DoubleLongLeftArrow;"
    ],
    [
        0,
        "&DoubleLongRightArrow;"
    ],
    [
        0,
        "&DoubleLongLeftRightArrow;"
    ],
    [
        1,
        "&longmapsto;"
    ],
    [
        2,
        "&dzigrarr;"
    ],
    [
        258,
        "&nvlArr;"
    ],
    [
        0,
        "&nvrArr;"
    ],
    [
        0,
        "&nvHarr;"
    ],
    [
        0,
        "&Map;"
    ],
    [
        6,
        "&lbarr;"
    ],
    [
        0,
        "&bkarow;"
    ],
    [
        0,
        "&lBarr;"
    ],
    [
        0,
        "&dbkarow;"
    ],
    [
        0,
        "&drbkarow;"
    ],
    [
        0,
        "&DDotrahd;"
    ],
    [
        0,
        "&UpArrowBar;"
    ],
    [
        0,
        "&DownArrowBar;"
    ],
    [
        2,
        "&Rarrtl;"
    ],
    [
        2,
        "&latail;"
    ],
    [
        0,
        "&ratail;"
    ],
    [
        0,
        "&lAtail;"
    ],
    [
        0,
        "&rAtail;"
    ],
    [
        0,
        "&larrfs;"
    ],
    [
        0,
        "&rarrfs;"
    ],
    [
        0,
        "&larrbfs;"
    ],
    [
        0,
        "&rarrbfs;"
    ],
    [
        2,
        "&nwarhk;"
    ],
    [
        0,
        "&nearhk;"
    ],
    [
        0,
        "&hksearow;"
    ],
    [
        0,
        "&hkswarow;"
    ],
    [
        0,
        "&nwnear;"
    ],
    [
        0,
        "&nesear;"
    ],
    [
        0,
        "&seswar;"
    ],
    [
        0,
        "&swnwar;"
    ],
    [
        8,
        {
            v: "&rarrc;",
            n: 824,
            o: "&nrarrc;"
        }
    ],
    [
        1,
        "&cudarrr;"
    ],
    [
        0,
        "&ldca;"
    ],
    [
        0,
        "&rdca;"
    ],
    [
        0,
        "&cudarrl;"
    ],
    [
        0,
        "&larrpl;"
    ],
    [
        2,
        "&curarrm;"
    ],
    [
        0,
        "&cularrp;"
    ],
    [
        7,
        "&rarrpl;"
    ],
    [
        2,
        "&harrcir;"
    ],
    [
        0,
        "&Uarrocir;"
    ],
    [
        0,
        "&lurdshar;"
    ],
    [
        0,
        "&ldrushar;"
    ],
    [
        2,
        "&LeftRightVector;"
    ],
    [
        0,
        "&RightUpDownVector;"
    ],
    [
        0,
        "&DownLeftRightVector;"
    ],
    [
        0,
        "&LeftUpDownVector;"
    ],
    [
        0,
        "&LeftVectorBar;"
    ],
    [
        0,
        "&RightVectorBar;"
    ],
    [
        0,
        "&RightUpVectorBar;"
    ],
    [
        0,
        "&RightDownVectorBar;"
    ],
    [
        0,
        "&DownLeftVectorBar;"
    ],
    [
        0,
        "&DownRightVectorBar;"
    ],
    [
        0,
        "&LeftUpVectorBar;"
    ],
    [
        0,
        "&LeftDownVectorBar;"
    ],
    [
        0,
        "&LeftTeeVector;"
    ],
    [
        0,
        "&RightTeeVector;"
    ],
    [
        0,
        "&RightUpTeeVector;"
    ],
    [
        0,
        "&RightDownTeeVector;"
    ],
    [
        0,
        "&DownLeftTeeVector;"
    ],
    [
        0,
        "&DownRightTeeVector;"
    ],
    [
        0,
        "&LeftUpTeeVector;"
    ],
    [
        0,
        "&LeftDownTeeVector;"
    ],
    [
        0,
        "&lHar;"
    ],
    [
        0,
        "&uHar;"
    ],
    [
        0,
        "&rHar;"
    ],
    [
        0,
        "&dHar;"
    ],
    [
        0,
        "&luruhar;"
    ],
    [
        0,
        "&ldrdhar;"
    ],
    [
        0,
        "&ruluhar;"
    ],
    [
        0,
        "&rdldhar;"
    ],
    [
        0,
        "&lharul;"
    ],
    [
        0,
        "&llhard;"
    ],
    [
        0,
        "&rharul;"
    ],
    [
        0,
        "&lrhard;"
    ],
    [
        0,
        "&udhar;"
    ],
    [
        0,
        "&duhar;"
    ],
    [
        0,
        "&RoundImplies;"
    ],
    [
        0,
        "&erarr;"
    ],
    [
        0,
        "&simrarr;"
    ],
    [
        0,
        "&larrsim;"
    ],
    [
        0,
        "&rarrsim;"
    ],
    [
        0,
        "&rarrap;"
    ],
    [
        0,
        "&ltlarr;"
    ],
    [
        1,
        "&gtrarr;"
    ],
    [
        0,
        "&subrarr;"
    ],
    [
        1,
        "&suplarr;"
    ],
    [
        0,
        "&lfisht;"
    ],
    [
        0,
        "&rfisht;"
    ],
    [
        0,
        "&ufisht;"
    ],
    [
        0,
        "&dfisht;"
    ],
    [
        5,
        "&lopar;"
    ],
    [
        0,
        "&ropar;"
    ],
    [
        4,
        "&lbrke;"
    ],
    [
        0,
        "&rbrke;"
    ],
    [
        0,
        "&lbrkslu;"
    ],
    [
        0,
        "&rbrksld;"
    ],
    [
        0,
        "&lbrksld;"
    ],
    [
        0,
        "&rbrkslu;"
    ],
    [
        0,
        "&langd;"
    ],
    [
        0,
        "&rangd;"
    ],
    [
        0,
        "&lparlt;"
    ],
    [
        0,
        "&rpargt;"
    ],
    [
        0,
        "&gtlPar;"
    ],
    [
        0,
        "&ltrPar;"
    ],
    [
        3,
        "&vzigzag;"
    ],
    [
        1,
        "&vangrt;"
    ],
    [
        0,
        "&angrtvbd;"
    ],
    [
        6,
        "&ange;"
    ],
    [
        0,
        "&range;"
    ],
    [
        0,
        "&dwangle;"
    ],
    [
        0,
        "&uwangle;"
    ],
    [
        0,
        "&angmsdaa;"
    ],
    [
        0,
        "&angmsdab;"
    ],
    [
        0,
        "&angmsdac;"
    ],
    [
        0,
        "&angmsdad;"
    ],
    [
        0,
        "&angmsdae;"
    ],
    [
        0,
        "&angmsdaf;"
    ],
    [
        0,
        "&angmsdag;"
    ],
    [
        0,
        "&angmsdah;"
    ],
    [
        0,
        "&bemptyv;"
    ],
    [
        0,
        "&demptyv;"
    ],
    [
        0,
        "&cemptyv;"
    ],
    [
        0,
        "&raemptyv;"
    ],
    [
        0,
        "&laemptyv;"
    ],
    [
        0,
        "&ohbar;"
    ],
    [
        0,
        "&omid;"
    ],
    [
        0,
        "&opar;"
    ],
    [
        1,
        "&operp;"
    ],
    [
        1,
        "&olcross;"
    ],
    [
        0,
        "&odsold;"
    ],
    [
        1,
        "&olcir;"
    ],
    [
        0,
        "&ofcir;"
    ],
    [
        0,
        "&olt;"
    ],
    [
        0,
        "&ogt;"
    ],
    [
        0,
        "&cirscir;"
    ],
    [
        0,
        "&cirE;"
    ],
    [
        0,
        "&solb;"
    ],
    [
        0,
        "&bsolb;"
    ],
    [
        3,
        "&boxbox;"
    ],
    [
        3,
        "&trisb;"
    ],
    [
        0,
        "&rtriltri;"
    ],
    [
        0,
        {
            v: "&LeftTriangleBar;",
            n: 824,
            o: "&NotLeftTriangleBar;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleBar;",
            n: 824,
            o: "&NotRightTriangleBar;"
        }
    ],
    [
        11,
        "&iinfin;"
    ],
    [
        0,
        "&infintie;"
    ],
    [
        0,
        "&nvinfin;"
    ],
    [
        4,
        "&eparsl;"
    ],
    [
        0,
        "&smeparsl;"
    ],
    [
        0,
        "&eqvparsl;"
    ],
    [
        5,
        "&blacklozenge;"
    ],
    [
        8,
        "&RuleDelayed;"
    ],
    [
        1,
        "&dsol;"
    ],
    [
        9,
        "&bigodot;"
    ],
    [
        0,
        "&bigoplus;"
    ],
    [
        0,
        "&bigotimes;"
    ],
    [
        1,
        "&biguplus;"
    ],
    [
        1,
        "&bigsqcup;"
    ],
    [
        5,
        "&iiiint;"
    ],
    [
        0,
        "&fpartint;"
    ],
    [
        2,
        "&cirfnint;"
    ],
    [
        0,
        "&awint;"
    ],
    [
        0,
        "&rppolint;"
    ],
    [
        0,
        "&scpolint;"
    ],
    [
        0,
        "&npolint;"
    ],
    [
        0,
        "&pointint;"
    ],
    [
        0,
        "&quatint;"
    ],
    [
        0,
        "&intlarhk;"
    ],
    [
        10,
        "&pluscir;"
    ],
    [
        0,
        "&plusacir;"
    ],
    [
        0,
        "&simplus;"
    ],
    [
        0,
        "&plusdu;"
    ],
    [
        0,
        "&plussim;"
    ],
    [
        0,
        "&plustwo;"
    ],
    [
        1,
        "&mcomma;"
    ],
    [
        0,
        "&minusdu;"
    ],
    [
        2,
        "&loplus;"
    ],
    [
        0,
        "&roplus;"
    ],
    [
        0,
        "&Cross;"
    ],
    [
        0,
        "&timesd;"
    ],
    [
        0,
        "&timesbar;"
    ],
    [
        1,
        "&smashp;"
    ],
    [
        0,
        "&lotimes;"
    ],
    [
        0,
        "&rotimes;"
    ],
    [
        0,
        "&otimesas;"
    ],
    [
        0,
        "&Otimes;"
    ],
    [
        0,
        "&odiv;"
    ],
    [
        0,
        "&triplus;"
    ],
    [
        0,
        "&triminus;"
    ],
    [
        0,
        "&tritime;"
    ],
    [
        0,
        "&intprod;"
    ],
    [
        2,
        "&amalg;"
    ],
    [
        0,
        "&capdot;"
    ],
    [
        1,
        "&ncup;"
    ],
    [
        0,
        "&ncap;"
    ],
    [
        0,
        "&capand;"
    ],
    [
        0,
        "&cupor;"
    ],
    [
        0,
        "&cupcap;"
    ],
    [
        0,
        "&capcup;"
    ],
    [
        0,
        "&cupbrcap;"
    ],
    [
        0,
        "&capbrcup;"
    ],
    [
        0,
        "&cupcup;"
    ],
    [
        0,
        "&capcap;"
    ],
    [
        0,
        "&ccups;"
    ],
    [
        0,
        "&ccaps;"
    ],
    [
        2,
        "&ccupssm;"
    ],
    [
        2,
        "&And;"
    ],
    [
        0,
        "&Or;"
    ],
    [
        0,
        "&andand;"
    ],
    [
        0,
        "&oror;"
    ],
    [
        0,
        "&orslope;"
    ],
    [
        0,
        "&andslope;"
    ],
    [
        1,
        "&andv;"
    ],
    [
        0,
        "&orv;"
    ],
    [
        0,
        "&andd;"
    ],
    [
        0,
        "&ord;"
    ],
    [
        1,
        "&wedbar;"
    ],
    [
        6,
        "&sdote;"
    ],
    [
        3,
        "&simdot;"
    ],
    [
        2,
        {
            v: "&congdot;",
            n: 824,
            o: "&ncongdot;"
        }
    ],
    [
        0,
        "&easter;"
    ],
    [
        0,
        "&apacir;"
    ],
    [
        0,
        {
            v: "&apE;",
            n: 824,
            o: "&napE;"
        }
    ],
    [
        0,
        "&eplus;"
    ],
    [
        0,
        "&pluse;"
    ],
    [
        0,
        "&Esim;"
    ],
    [
        0,
        "&Colone;"
    ],
    [
        0,
        "&Equal;"
    ],
    [
        1,
        "&ddotseq;"
    ],
    [
        0,
        "&equivDD;"
    ],
    [
        0,
        "&ltcir;"
    ],
    [
        0,
        "&gtcir;"
    ],
    [
        0,
        "&ltquest;"
    ],
    [
        0,
        "&gtquest;"
    ],
    [
        0,
        {
            v: "&leqslant;",
            n: 824,
            o: "&nleqslant;"
        }
    ],
    [
        0,
        {
            v: "&geqslant;",
            n: 824,
            o: "&ngeqslant;"
        }
    ],
    [
        0,
        "&lesdot;"
    ],
    [
        0,
        "&gesdot;"
    ],
    [
        0,
        "&lesdoto;"
    ],
    [
        0,
        "&gesdoto;"
    ],
    [
        0,
        "&lesdotor;"
    ],
    [
        0,
        "&gesdotol;"
    ],
    [
        0,
        "&lap;"
    ],
    [
        0,
        "&gap;"
    ],
    [
        0,
        "&lne;"
    ],
    [
        0,
        "&gne;"
    ],
    [
        0,
        "&lnap;"
    ],
    [
        0,
        "&gnap;"
    ],
    [
        0,
        "&lEg;"
    ],
    [
        0,
        "&gEl;"
    ],
    [
        0,
        "&lsime;"
    ],
    [
        0,
        "&gsime;"
    ],
    [
        0,
        "&lsimg;"
    ],
    [
        0,
        "&gsiml;"
    ],
    [
        0,
        "&lgE;"
    ],
    [
        0,
        "&glE;"
    ],
    [
        0,
        "&lesges;"
    ],
    [
        0,
        "&gesles;"
    ],
    [
        0,
        "&els;"
    ],
    [
        0,
        "&egs;"
    ],
    [
        0,
        "&elsdot;"
    ],
    [
        0,
        "&egsdot;"
    ],
    [
        0,
        "&el;"
    ],
    [
        0,
        "&eg;"
    ],
    [
        2,
        "&siml;"
    ],
    [
        0,
        "&simg;"
    ],
    [
        0,
        "&simlE;"
    ],
    [
        0,
        "&simgE;"
    ],
    [
        0,
        {
            v: "&LessLess;",
            n: 824,
            o: "&NotNestedLessLess;"
        }
    ],
    [
        0,
        {
            v: "&GreaterGreater;",
            n: 824,
            o: "&NotNestedGreaterGreater;"
        }
    ],
    [
        1,
        "&glj;"
    ],
    [
        0,
        "&gla;"
    ],
    [
        0,
        "&ltcc;"
    ],
    [
        0,
        "&gtcc;"
    ],
    [
        0,
        "&lescc;"
    ],
    [
        0,
        "&gescc;"
    ],
    [
        0,
        "&smt;"
    ],
    [
        0,
        "&lat;"
    ],
    [
        0,
        {
            v: "&smte;",
            n: 65024,
            o: "&smtes;"
        }
    ],
    [
        0,
        {
            v: "&late;",
            n: 65024,
            o: "&lates;"
        }
    ],
    [
        0,
        "&bumpE;"
    ],
    [
        0,
        {
            v: "&PrecedesEqual;",
            n: 824,
            o: "&NotPrecedesEqual;"
        }
    ],
    [
        0,
        {
            v: "&sce;",
            n: 824,
            o: "&NotSucceedsEqual;"
        }
    ],
    [
        2,
        "&prE;"
    ],
    [
        0,
        "&scE;"
    ],
    [
        0,
        "&precneqq;"
    ],
    [
        0,
        "&scnE;"
    ],
    [
        0,
        "&prap;"
    ],
    [
        0,
        "&scap;"
    ],
    [
        0,
        "&precnapprox;"
    ],
    [
        0,
        "&scnap;"
    ],
    [
        0,
        "&Pr;"
    ],
    [
        0,
        "&Sc;"
    ],
    [
        0,
        "&subdot;"
    ],
    [
        0,
        "&supdot;"
    ],
    [
        0,
        "&subplus;"
    ],
    [
        0,
        "&supplus;"
    ],
    [
        0,
        "&submult;"
    ],
    [
        0,
        "&supmult;"
    ],
    [
        0,
        "&subedot;"
    ],
    [
        0,
        "&supedot;"
    ],
    [
        0,
        {
            v: "&subE;",
            n: 824,
            o: "&nsubE;"
        }
    ],
    [
        0,
        {
            v: "&supE;",
            n: 824,
            o: "&nsupE;"
        }
    ],
    [
        0,
        "&subsim;"
    ],
    [
        0,
        "&supsim;"
    ],
    [
        2,
        {
            v: "&subnE;",
            n: 65024,
            o: "&varsubsetneqq;"
        }
    ],
    [
        0,
        {
            v: "&supnE;",
            n: 65024,
            o: "&varsupsetneqq;"
        }
    ],
    [
        2,
        "&csub;"
    ],
    [
        0,
        "&csup;"
    ],
    [
        0,
        "&csube;"
    ],
    [
        0,
        "&csupe;"
    ],
    [
        0,
        "&subsup;"
    ],
    [
        0,
        "&supsub;"
    ],
    [
        0,
        "&subsub;"
    ],
    [
        0,
        "&supsup;"
    ],
    [
        0,
        "&suphsub;"
    ],
    [
        0,
        "&supdsub;"
    ],
    [
        0,
        "&forkv;"
    ],
    [
        0,
        "&topfork;"
    ],
    [
        0,
        "&mlcp;"
    ],
    [
        8,
        "&Dashv;"
    ],
    [
        1,
        "&Vdashl;"
    ],
    [
        0,
        "&Barv;"
    ],
    [
        0,
        "&vBar;"
    ],
    [
        0,
        "&vBarv;"
    ],
    [
        1,
        "&Vbar;"
    ],
    [
        0,
        "&Not;"
    ],
    [
        0,
        "&bNot;"
    ],
    [
        0,
        "&rnmid;"
    ],
    [
        0,
        "&cirmid;"
    ],
    [
        0,
        "&midcir;"
    ],
    [
        0,
        "&topcir;"
    ],
    [
        0,
        "&nhpar;"
    ],
    [
        0,
        "&parsim;"
    ],
    [
        9,
        {
            v: "&parsl;",
            n: 8421,
            o: "&nparsl;"
        }
    ],
    [
        44343,
        {
            n: new Map(/* #__PURE__ */ $5d17e1547aea90db$var$restoreDiff([
                [
                    56476,
                    "&Ascr;"
                ],
                [
                    1,
                    "&Cscr;"
                ],
                [
                    0,
                    "&Dscr;"
                ],
                [
                    2,
                    "&Gscr;"
                ],
                [
                    2,
                    "&Jscr;"
                ],
                [
                    0,
                    "&Kscr;"
                ],
                [
                    2,
                    "&Nscr;"
                ],
                [
                    0,
                    "&Oscr;"
                ],
                [
                    0,
                    "&Pscr;"
                ],
                [
                    0,
                    "&Qscr;"
                ],
                [
                    1,
                    "&Sscr;"
                ],
                [
                    0,
                    "&Tscr;"
                ],
                [
                    0,
                    "&Uscr;"
                ],
                [
                    0,
                    "&Vscr;"
                ],
                [
                    0,
                    "&Wscr;"
                ],
                [
                    0,
                    "&Xscr;"
                ],
                [
                    0,
                    "&Yscr;"
                ],
                [
                    0,
                    "&Zscr;"
                ],
                [
                    0,
                    "&ascr;"
                ],
                [
                    0,
                    "&bscr;"
                ],
                [
                    0,
                    "&cscr;"
                ],
                [
                    0,
                    "&dscr;"
                ],
                [
                    1,
                    "&fscr;"
                ],
                [
                    1,
                    "&hscr;"
                ],
                [
                    0,
                    "&iscr;"
                ],
                [
                    0,
                    "&jscr;"
                ],
                [
                    0,
                    "&kscr;"
                ],
                [
                    0,
                    "&lscr;"
                ],
                [
                    0,
                    "&mscr;"
                ],
                [
                    0,
                    "&nscr;"
                ],
                [
                    1,
                    "&pscr;"
                ],
                [
                    0,
                    "&qscr;"
                ],
                [
                    0,
                    "&rscr;"
                ],
                [
                    0,
                    "&sscr;"
                ],
                [
                    0,
                    "&tscr;"
                ],
                [
                    0,
                    "&uscr;"
                ],
                [
                    0,
                    "&vscr;"
                ],
                [
                    0,
                    "&wscr;"
                ],
                [
                    0,
                    "&xscr;"
                ],
                [
                    0,
                    "&yscr;"
                ],
                [
                    0,
                    "&zscr;"
                ],
                [
                    52,
                    "&Afr;"
                ],
                [
                    0,
                    "&Bfr;"
                ],
                [
                    1,
                    "&Dfr;"
                ],
                [
                    0,
                    "&Efr;"
                ],
                [
                    0,
                    "&Ffr;"
                ],
                [
                    0,
                    "&Gfr;"
                ],
                [
                    2,
                    "&Jfr;"
                ],
                [
                    0,
                    "&Kfr;"
                ],
                [
                    0,
                    "&Lfr;"
                ],
                [
                    0,
                    "&Mfr;"
                ],
                [
                    0,
                    "&Nfr;"
                ],
                [
                    0,
                    "&Ofr;"
                ],
                [
                    0,
                    "&Pfr;"
                ],
                [
                    0,
                    "&Qfr;"
                ],
                [
                    1,
                    "&Sfr;"
                ],
                [
                    0,
                    "&Tfr;"
                ],
                [
                    0,
                    "&Ufr;"
                ],
                [
                    0,
                    "&Vfr;"
                ],
                [
                    0,
                    "&Wfr;"
                ],
                [
                    0,
                    "&Xfr;"
                ],
                [
                    0,
                    "&Yfr;"
                ],
                [
                    1,
                    "&afr;"
                ],
                [
                    0,
                    "&bfr;"
                ],
                [
                    0,
                    "&cfr;"
                ],
                [
                    0,
                    "&dfr;"
                ],
                [
                    0,
                    "&efr;"
                ],
                [
                    0,
                    "&ffr;"
                ],
                [
                    0,
                    "&gfr;"
                ],
                [
                    0,
                    "&hfr;"
                ],
                [
                    0,
                    "&ifr;"
                ],
                [
                    0,
                    "&jfr;"
                ],
                [
                    0,
                    "&kfr;"
                ],
                [
                    0,
                    "&lfr;"
                ],
                [
                    0,
                    "&mfr;"
                ],
                [
                    0,
                    "&nfr;"
                ],
                [
                    0,
                    "&ofr;"
                ],
                [
                    0,
                    "&pfr;"
                ],
                [
                    0,
                    "&qfr;"
                ],
                [
                    0,
                    "&rfr;"
                ],
                [
                    0,
                    "&sfr;"
                ],
                [
                    0,
                    "&tfr;"
                ],
                [
                    0,
                    "&ufr;"
                ],
                [
                    0,
                    "&vfr;"
                ],
                [
                    0,
                    "&wfr;"
                ],
                [
                    0,
                    "&xfr;"
                ],
                [
                    0,
                    "&yfr;"
                ],
                [
                    0,
                    "&zfr;"
                ],
                [
                    0,
                    "&Aopf;"
                ],
                [
                    0,
                    "&Bopf;"
                ],
                [
                    1,
                    "&Dopf;"
                ],
                [
                    0,
                    "&Eopf;"
                ],
                [
                    0,
                    "&Fopf;"
                ],
                [
                    0,
                    "&Gopf;"
                ],
                [
                    1,
                    "&Iopf;"
                ],
                [
                    0,
                    "&Jopf;"
                ],
                [
                    0,
                    "&Kopf;"
                ],
                [
                    0,
                    "&Lopf;"
                ],
                [
                    0,
                    "&Mopf;"
                ],
                [
                    1,
                    "&Oopf;"
                ],
                [
                    3,
                    "&Sopf;"
                ],
                [
                    0,
                    "&Topf;"
                ],
                [
                    0,
                    "&Uopf;"
                ],
                [
                    0,
                    "&Vopf;"
                ],
                [
                    0,
                    "&Wopf;"
                ],
                [
                    0,
                    "&Xopf;"
                ],
                [
                    0,
                    "&Yopf;"
                ],
                [
                    1,
                    "&aopf;"
                ],
                [
                    0,
                    "&bopf;"
                ],
                [
                    0,
                    "&copf;"
                ],
                [
                    0,
                    "&dopf;"
                ],
                [
                    0,
                    "&eopf;"
                ],
                [
                    0,
                    "&fopf;"
                ],
                [
                    0,
                    "&gopf;"
                ],
                [
                    0,
                    "&hopf;"
                ],
                [
                    0,
                    "&iopf;"
                ],
                [
                    0,
                    "&jopf;"
                ],
                [
                    0,
                    "&kopf;"
                ],
                [
                    0,
                    "&lopf;"
                ],
                [
                    0,
                    "&mopf;"
                ],
                [
                    0,
                    "&nopf;"
                ],
                [
                    0,
                    "&oopf;"
                ],
                [
                    0,
                    "&popf;"
                ],
                [
                    0,
                    "&qopf;"
                ],
                [
                    0,
                    "&ropf;"
                ],
                [
                    0,
                    "&sopf;"
                ],
                [
                    0,
                    "&topf;"
                ],
                [
                    0,
                    "&uopf;"
                ],
                [
                    0,
                    "&vopf;"
                ],
                [
                    0,
                    "&wopf;"
                ],
                [
                    0,
                    "&xopf;"
                ],
                [
                    0,
                    "&yopf;"
                ],
                [
                    0,
                    "&zopf;"
                ]
            ]))
        }
    ],
    [
        8906,
        "&fflig;"
    ],
    [
        0,
        "&filig;"
    ],
    [
        0,
        "&fllig;"
    ],
    [
        0,
        "&ffilig;"
    ],
    [
        0,
        "&ffllig;"
    ]
]));

});

parcelRegister("h82ow", function(module, exports) {
$parcel$export(module.exports, "xmlReplacer", function () { return $c7850a825e7152b5$export$5699810ce3244ab8; });
$parcel$export(module.exports, "getCodePoint", function () { return $c7850a825e7152b5$export$e02688b8085d016b; });
$parcel$export(module.exports, "encodeXML", function () { return $c7850a825e7152b5$export$18855ec5be97da16; });
$parcel$export(module.exports, "escapeUTF8", function () { return $c7850a825e7152b5$export$9e081872deefdcb0; });
$parcel$export(module.exports, "escapeAttribute", function () { return $c7850a825e7152b5$export$30330f3d5eb70e11; });
$parcel$export(module.exports, "escapeText", function () { return $c7850a825e7152b5$export$96e6fc3a139b2555; });
const $c7850a825e7152b5$export$5699810ce3244ab8 = /["&'<>$\x80-\uFFFF]/g;
const $c7850a825e7152b5$var$xmlCodeMap = new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        39,
        "&apos;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ]
]);
const $c7850a825e7152b5$export$e02688b8085d016b = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt != null ? (str, index)=>str.codePointAt(index) : (c, index)=>(c.charCodeAt(index) & 0xfc00) === 0xd800 ? (c.charCodeAt(index) - 0xd800) * 0x400 + c.charCodeAt(index + 1) - 0xdc00 + 0x10000 : c.charCodeAt(index);
function $c7850a825e7152b5$export$18855ec5be97da16(str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = $c7850a825e7152b5$export$5699810ce3244ab8.exec(str)) !== null){
        const i = match.index;
        const char = str.charCodeAt(i);
        const next = $c7850a825e7152b5$var$xmlCodeMap.get(char);
        if (next !== undefined) {
            ret += str.substring(lastIdx, i) + next;
            lastIdx = i + 1;
        } else {
            ret += `${str.substring(lastIdx, i)}&#x${$c7850a825e7152b5$export$e02688b8085d016b(str, i).toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = $c7850a825e7152b5$export$5699810ce3244ab8.lastIndex += Number((char & 0xfc00) === 0xd800);
        }
    }
    return ret + str.substr(lastIdx);
}
const $c7850a825e7152b5$export$4e7f196112fea3c5 = $c7850a825e7152b5$export$18855ec5be97da16;
/**
 * Creates a function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 *
 * @param regex Regular expression to match characters to escape.
 * @param map Map of characters to escape to their entities.
 *
 * @returns Function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 */ function $c7850a825e7152b5$var$getEscaper(regex, map) {
    return function escape(data) {
        let match;
        let lastIdx = 0;
        let result = "";
        while(match = regex.exec(data)){
            if (lastIdx !== match.index) result += data.substring(lastIdx, match.index);
            // We know that this character will be in the map.
            result += map.get(match[0].charCodeAt(0));
            // Every match will be of length 1
            lastIdx = match.index + 1;
        }
        return result + data.substring(lastIdx);
    };
}
const $c7850a825e7152b5$export$9e081872deefdcb0 = $c7850a825e7152b5$var$getEscaper(/[&<>'"]/g, $c7850a825e7152b5$var$xmlCodeMap);
const $c7850a825e7152b5$export$30330f3d5eb70e11 = $c7850a825e7152b5$var$getEscaper(/["&\u00A0]/g, new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));
const $c7850a825e7152b5$export$96e6fc3a139b2555 = $c7850a825e7152b5$var$getEscaper(/[&<>\u00A0]/g, new Map([
    [
        38,
        "&amp;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));

});



parcelRegister("8cFW9", function(module, exports) {

var $bBiRC = parcelRequire("bBiRC");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $bBiRC.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("044AT", function(module, exports) {

var $jM7lD = parcelRequire("jM7lD");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $00c3f019a8ea1fc2$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $jM7lD(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = $00c3f019a8ea1fc2$var$cloneTypedArray;

});
parcelRegister("jM7lD", function(module, exports) {

var $gEINE = parcelRequire("gEINE");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $e658332d980af196$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $gEINE(result).set(new $gEINE(arrayBuffer));
    return result;
}
module.exports = $e658332d980af196$var$cloneArrayBuffer;

});


parcelRegister("64IpJ", function(module, exports) {

var $6DkQS = parcelRequire("6DkQS");

var $iiMec = parcelRequire("iiMec");

var $1b6pL = parcelRequire("1b6pL");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $46c5917dd804d4c7$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$1b6pL(object) ? $6DkQS($iiMec(object)) : {};
}
module.exports = $46c5917dd804d4c7$var$initCloneObject;

});
parcelRegister("6DkQS", function(module, exports) {

var $ih96c = parcelRequire("ih96c");
/** Built-in value references. */ var $4d468f5c997304ff$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $4d468f5c997304ff$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$ih96c(proto)) return {};
        if ($4d468f5c997304ff$var$objectCreate) return $4d468f5c997304ff$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = $4d468f5c997304ff$var$baseCreate;

});


parcelRegister("6mx2n", function(module, exports) {

var $c5uls = parcelRequire("c5uls");

var $h6ZSp = parcelRequire("h6ZSp");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $4a1e6cacd7634ff8$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $h6ZSp(object, key, newValue);
        else $c5uls(object, key, newValue);
    }
    return object;
}
module.exports = $4a1e6cacd7634ff8$var$copyObject;

});

parcelRegister("58mMQ", function(module, exports) {

var $94SbA = parcelRequire("94SbA");

var $gRjiS = parcelRequire("gRjiS");

var $6PGLN = parcelRequire("6PGLN");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $3bcf6012be1fceb8$var$keysIn(object) {
    return $6PGLN(object) ? $94SbA(object, true) : $gRjiS(object);
}
module.exports = $3bcf6012be1fceb8$var$keysIn;

});
parcelRegister("gRjiS", function(module, exports) {

var $ih96c = parcelRequire("ih96c");

var $1b6pL = parcelRequire("1b6pL");

var $d8aqD = parcelRequire("d8aqD");
/** Used for built-in method references. */ var $c46091dcf5529043$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c46091dcf5529043$var$hasOwnProperty = $c46091dcf5529043$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $c46091dcf5529043$var$baseKeysIn(object) {
    if (!$ih96c(object)) return $d8aqD(object);
    var isProto = $1b6pL(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$c46091dcf5529043$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $c46091dcf5529043$var$baseKeysIn;

});
parcelRegister("d8aqD", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $98f41c9e4a4b76be$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $98f41c9e4a4b76be$var$nativeKeysIn;

});



parcelRegister("7VkDL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5c4dde019823d534$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6d32d0479ba45c629729cf798e1abfca>>
 * @codegenCommand yarn build-glyphs
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $dUJI5 = parcelRequire("dUJI5");

var $7Mywp = parcelRequire("7Mywp");
function $5c4dde019823d534$export$2e2bcd8739ae039(_ref) {
    var _ref$label = _ref.label, label = _ref$label === void 0 ? 'Epic' : _ref$label, size = _ref.size, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $7Mywp.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dUJI5))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
}

});
parcelRegister("dUJI5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::27415f759dcf84731b49eedf76030531>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a213f65f5566696d$var$_react = $a213f65f5566696d$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $a213f65f5566696d$var$_baseNew = $a213f65f5566696d$var$_interopRequireDefault((parcelRequire("4Gm7Q")));
function $a213f65f5566696d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Epic".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for epics in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a213f65f5566696d$var$EpicIcon = (props)=>/*#__PURE__*/ $a213f65f5566696d$var$_react.default.createElement($a213f65f5566696d$var$_baseNew.default, Object.assign({
        name: "EpicIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.271.05a.75.75 0 0 1 .479.7v4.635l3.147.63a.75.75 0 0 1 .407 1.24l-7.75 8.5a.75.75 0 0 1-1.304-.505v-4.635l-3.147-.63a.75.75 0 0 1-.407-1.24l7.75-8.5A.75.75 0 0 1 10.27.05M3.698 8.776l3.052.61v3.93l5.552-6.09-3.052-.61v-3.93z" clip-rule="evenodd"/>`
    }, props));
$a213f65f5566696d$var$EpicIcon.displayName = 'EpicIcon';
var $a213f65f5566696d$var$_default = module.exports.default = $a213f65f5566696d$var$EpicIcon;

});


parcelRegister("dTPlE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5f2152e50a3b99db24df80b6d3e591d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1e83e1969f37e79$var$_react = $a1e83e1969f37e79$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $a1e83e1969f37e79$var$_baseNew = $a1e83e1969f37e79$var$_interopRequireDefault((parcelRequire("jcI35")));
function $a1e83e1969f37e79$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a1e83e1969f37e79$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $a1e83e1969f37e79$var$_react.default.createElement($a1e83e1969f37e79$var$_baseNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$a1e83e1969f37e79$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $a1e83e1969f37e79$var$_default = module.exports.default = $a1e83e1969f37e79$var$PageLiveDocIcon;

});

parcelRegister("KrnvM", function(module, exports) {
'use strict';

module.exports = (parcelRequire("ehjsU"));

});
parcelRegister("ehjsU", function(module, exports) {
$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $a651c09db2bc4e75$export$bf730a2d8bf68b42; }, function (v) { return $a651c09db2bc4e75$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a651c09db2bc4e75$export$bf730a2d8bf68b42;
"use strict";

var $1oC0p = parcelRequire("1oC0p");

var $ixLXc = parcelRequire("ixLXc");
function $a651c09db2bc4e75$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $a651c09db2bc4e75$var$objectIs = "function" === typeof Object.is ? Object.is : $a651c09db2bc4e75$var$is, $a651c09db2bc4e75$var$useSyncExternalStore = $ixLXc.useSyncExternalStore, $a651c09db2bc4e75$var$useRef = $1oC0p.useRef, $a651c09db2bc4e75$var$useEffect = $1oC0p.useEffect, $a651c09db2bc4e75$var$useMemo = $1oC0p.useMemo, $a651c09db2bc4e75$var$useDebugValue = $1oC0p.useDebugValue;
$a651c09db2bc4e75$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $a651c09db2bc4e75$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $a651c09db2bc4e75$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($a651c09db2bc4e75$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $a651c09db2bc4e75$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $a651c09db2bc4e75$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $a651c09db2bc4e75$var$useDebugValue(value);
    return value;
};

});


parcelRegister("5QRrh", function(module, exports) {
/*! @license DOMPurify 2.5.8 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.5.8/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _construct(Parent, args, Class) {
        if (_isNativeReflectConstruct()) _construct = Reflect.construct;
        else _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return _construct.apply(null, arguments);
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var hasOwnProperty = Object.hasOwnProperty, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    var _ref = typeof Reflect !== 'undefined' && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!construct) construct = function construct(Func, args) {
        return _construct(Func, _toConsumableArray(args));
    };
    var arrayForEach = unapply(Array.prototype.forEach);
    var arrayPop = unapply(Array.prototype.pop);
    var arrayPush = unapply(Array.prototype.push);
    var stringToLowerCase = unapply(String.prototype.toLowerCase);
    var stringToString = unapply(String.prototype.toString);
    var stringMatch = unapply(String.prototype.match);
    var stringReplace = unapply(String.prototype.replace);
    var stringIndexOf = unapply(String.prototype.indexOf);
    var stringTrim = unapply(String.prototype.trim);
    var regExpTest = unapply(RegExp.prototype.test);
    var typeErrorCreate = unconstruct(TypeError);
    function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /* Add properties to a lookup table */ function addToSet(set, array, transformCaseFunc) {
        var _transformCaseFunc;
        transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        var l = array.length;
        while(l--){
            var element = array[l];
            if (typeof element === 'string') {
                var lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /* Shallow clone an object */ function clone(object) {
        var newObject = create(null);
        var property;
        for(property in object)if (apply(hasOwnProperty, object, [
            property
        ]) === true) newObject[property] = object[property];
        return newObject;
    }
    /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */ function lookupGetter(object, prop) {
        while(object !== null){
            var desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue(element) {
            console.warn('fallback value for', element);
            return null;
        }
        return fallbackValue;
    }
    var html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'select',
        'shadow',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    // SVG
    var svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    var svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    var svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'fedropshadow',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    var mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    var mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    var text = freeze([
        '#text'
    ]);
    var html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'xmlns',
        'slot'
    ]);
    var svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    var mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    var xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
    var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    var DOCTYPE_NAME = seal(/^html$/i);
    var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */ var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
        if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        var suffix = null;
        var ATTR_NAME = 'data-tt-policy-suffix';
        if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) suffix = document.currentScript.getAttribute(ATTR_NAME);
        var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML: function createHTML(html) {
                    return html;
                },
                createScriptURL: function createScriptURL(scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    function createDOMPurify() {
        var window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        var DOMPurify = function DOMPurify(root) {
            return createDOMPurify(root);
        };
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = '2.5.8';
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== 9) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        var originalDocument = window1.document;
        var document = window1.document;
        var DocumentFragment = window1.DocumentFragment, HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap, HTMLFormElement = window1.HTMLFormElement, DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        var ElementPrototype = Element.prototype;
        var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        var getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            var template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
        var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
        var _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        var importNode = originalDocument.importNode;
        var documentMode = {};
        try {
            documentMode = clone(document).documentMode ? document.documentMode : {};
        } catch (_) {}
        var hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
        var MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
        var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ var ALLOWED_TAGS = null;
        var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
        /* Allowed attribute names */ var ALLOWED_ATTR = null;
        var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ var FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ var FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ var ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ var ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ var ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ var ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ var SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ var SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ var WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ var SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ var FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ var RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ var RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ var RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ var SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ var SANITIZE_NAMED_PROPS = false;
        var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ var KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ var IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ var USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ var FORBID_CONTENTS = null;
        var DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ var DATA_URI_TAGS = null;
        var DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ var URI_SAFE_ATTRIBUTES = null;
        var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ var NAMESPACE = HTML_NAMESPACE;
        var IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ var ALLOWED_NAMESPACES = null;
        var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        /* Parsing of strict XHTML documents */ var PARSER_MEDIA_TYPE;
        var SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        var transformCaseFunc;
        /* Keep a reference to config to pass to hooks */ var CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ var formElement = document.createElement('form');
        var isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        var _parseConfig = function _parseConfig(cfg) {
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || _typeof(cfg) !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
            cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
            cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        var HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ var ALL_SVG_TAGS = addToSet({}, svg$1);
        addToSet(ALL_SVG_TAGS, svgFilters);
        addToSet(ALL_SVG_TAGS, svgDisallowed);
        var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
        addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
        /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ var _checkValidNamespace = function _checkValidNamespace(element) {
            var parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            var tagName = stringToLowerCase(element.tagName);
            var parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ var _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                node.parentNode.removeChild(node);
            } catch (_) {
                try {
                    node.outerHTML = emptyHTML;
                } catch (_) {
                    node.remove();
                }
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ var _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name);
            // We void attribute values for unremovable "is"" attributes
            if (name === 'is' && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ var _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ var doc;
            var leadingWhitespace;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ var matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            var body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */ var _createIterator = function _createIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ var _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
        };
        /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ var _isNode = function _isNode(object) {
            return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ var _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], function(hook) {
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ var _sanitizeElements = function _sanitizeElements(currentNode) {
            var content;
            /* Execute a hook if present */ _executeHook('beforeSanitizeElements', currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Check if tagname contains Unicode */ if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ var tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook('uponSanitizeElement', currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Mitigate a problem with templates inside select */ if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any ocurrence of processing instructions */ if (currentNode.nodeType === 7) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    var parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        var childCount = childNodes.length;
                        for(var i = childCount - 1; i >= 0; --i){
                            var childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
                /* Get the element's text content */ content = currentNode.textContent;
                content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
                content = stringReplace(content, ERB_EXPR$1, ' ');
                content = stringReplace(content, TMPLIT_EXPR$1, ' ');
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeElements', currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */ var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT$1);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            var attr;
            var value;
            var lcName;
            var l;
            /* Execute a hook if present */ _executeHook('beforeSanitizeAttributes', currentNode, null);
            var attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
            var hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                attr = attributes[l];
                var _attr = attr, name = _attr.name, namespaceURI = _attr.namespaceURI;
                value = name === 'value' ? attr.value : stringTrim(attr.value);
                lcName = transformCaseFunc(name);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) {
                    value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
                    value = stringReplace(value, ERB_EXPR$1, ' ');
                    value = stringReplace(value, TMPLIT_EXPR$1, ' ');
                }
                /* Is `value` valid for this attribute? */ var lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeAttributes', currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            var shadowNode;
            var shadowIterator = _createIterator(fragment);
            /* Execute a hook if present */ _executeHook('beforeSanitizeShadowDOM', fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook('uponSanitizeShadowNode', shadowNode, null);
                /* Sanitize tags and elements */ _sanitizeElements(shadowNode);
                /* Check attributes next */ _sanitizeAttributes(shadowNode);
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeShadowDOM', fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var body;
            var importedNode;
            var currentNode;
            var oldNode;
            var returnNode;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Check we can run. Otherwise fall back or ignore */ if (!DOMPurify.isSupported) {
                if (_typeof(window1.toStaticHTML) === 'object' || typeof window1.toStaticHTML === 'function') {
                    if (typeof dirty === 'string') return window1.toStaticHTML(dirty);
                    if (_isNode(dirty)) return window1.toStaticHTML(dirty.outerHTML);
                }
                return dirty;
            }
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    var tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Fix IE's strange behavior with manipulated textNodes #89 */ if (currentNode.nodeType === 3 && currentNode === oldNode) continue;
                /* Sanitize tags and elements */ _sanitizeElements(currentNode);
                /* Check attributes next */ _sanitizeAttributes(currentNode);
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
                oldNode = currentNode;
            }
            oldNode = null;
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) {
                serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
            }
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function(cfg) {
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            var lcTag = transformCaseFunc(tag);
            var lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

});

parcelRegister("hpDnm", function(module, exports) {

var $kp5nV = parcelRequire("kp5nV");

var $1frIC = parcelRequire("1frIC");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $cad350b3a4d1e4e2$var$pick = $1frIC(function(object, paths) {
    return object == null ? {} : $kp5nV(object, paths);
});
module.exports = $cad350b3a4d1e4e2$var$pick;

});
parcelRegister("kp5nV", function(module, exports) {

var $fqptw = parcelRequire("fqptw");

var $8avIg = parcelRequire("8avIg");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $edaa51c779a6741c$var$basePick(object, paths) {
    return $fqptw(object, paths, function(value, path) {
        return $8avIg(object, path);
    });
}
module.exports = $edaa51c779a6741c$var$basePick;

});
parcelRegister("fqptw", function(module, exports) {

var $5oMeU = parcelRequire("5oMeU");

var $brerY = parcelRequire("brerY");

var $hLLeA = parcelRequire("hLLeA");
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $b3ad0b8a3c96db41$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $5oMeU(object, path);
        if (predicate(value, path)) $brerY(result, $hLLeA(path, object), value);
    }
    return result;
}
module.exports = $b3ad0b8a3c96db41$var$basePickBy;

});


parcelRegister("1frIC", function(module, exports) {

var $Euo5O = parcelRequire("Euo5O");

var $axmYb = parcelRequire("axmYb");

var $jj29P = parcelRequire("jj29P");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $0e8cb184d6489cc8$var$flatRest(func) {
    return $jj29P($axmYb(func, undefined, $Euo5O), func + '');
}
module.exports = $0e8cb184d6489cc8$var$flatRest;

});
parcelRegister("Euo5O", function(module, exports) {

var $auF8s = parcelRequire("auF8s");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $079b4ee268152e61$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $auF8s(array, 1) : [];
}
module.exports = $079b4ee268152e61$var$flatten;

});



parcelRegister("gcAZd", function(module, exports) {
$parcel$export(module.exports, "JSM_DEFAULT_BILLING_CYCLE", function () { return $ff47f9ee8d194adc$export$be354061b07829a8; });
$parcel$export(module.exports, "JSM_DEFAULT_UNIT_COUNT", function () { return $ff47f9ee8d194adc$export$2295858875312a6f; });
$parcel$export(module.exports, "JSM_MIN_ENTERPRISE_USER_COUNT", function () { return $ff47f9ee8d194adc$export$66d53803b4a2565a; });
$parcel$export(module.exports, "jsmOfferingSkus", function () { return $ff47f9ee8d194adc$export$38631f866342776a; });
$parcel$export(module.exports, "jsmOfferingSkusArray", function () { return $ff47f9ee8d194adc$export$efd16829e921ffb8; });
$parcel$export(module.exports, "jsmPlanLimitConfigs", function () { return $ff47f9ee8d194adc$export$9e62e4d7dc794618; });
$parcel$export(module.exports, "jsmBillingCycleConfig", function () { return $ff47f9ee8d194adc$export$34fbcdd33d5f7ba7; });
const $ff47f9ee8d194adc$export$be354061b07829a8 = 'MONTHLY';
const $ff47f9ee8d194adc$export$2295858875312a6f = 75;
const $ff47f9ee8d194adc$export$66d53803b4a2565a = 201;
const $ff47f9ee8d194adc$export$38631f866342776a = {
    free: 'jira-servicedesk-free',
    standard: 'jira-servicedesk-standard-repack-sku',
    premium: 'jira-servicedesk-premium',
    enterprise: 'jira-servicedesk-enterprise-sku'
};
const $ff47f9ee8d194adc$export$efd16829e921ffb8 = Object.values($ff47f9ee8d194adc$export$38631f866342776a);
const $ff47f9ee8d194adc$export$9e62e4d7dc794618 = [
    {
        planName: 'Free',
        offeringSku: $ff47f9ee8d194adc$export$38631f866342776a.free,
        recommendationLimit: 0,
        signupLimit: 20000
    },
    {
        planName: 'Standard',
        offeringSku: $ff47f9ee8d194adc$export$38631f866342776a.standard,
        recommendationLimit: 3,
        signupLimit: 20000
    },
    {
        planName: 'Premium',
        offeringSku: $ff47f9ee8d194adc$export$38631f866342776a.premium,
        recommendationLimit: 50,
        signupLimit: 20000
    },
    {
        planName: 'Enterprise',
        offeringSku: $ff47f9ee8d194adc$export$38631f866342776a.enterprise,
        recommendationLimit: 250,
        signupLimit: 20000
    }
];
const $ff47f9ee8d194adc$export$34fbcdd33d5f7ba7 = {
    monthly: true,
    annual: true
};

});

parcelRegister("3fxcB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a077d34b75af68b5a629fa3ed5b43193>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25dc871355f8422b$var$_react = $25dc871355f8422b$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $25dc871355f8422b$var$_baseNew = $25dc871355f8422b$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $25dc871355f8422b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Location".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: location in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25dc871355f8422b$var$LocationIcon = (props)=>/*#__PURE__*/ $25dc871355f8422b$var$_react.default.createElement($25dc871355f8422b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5c-3.627 0-5.764 4.07-3.705 7.056L8 13.93l3.705-5.373C13.765 5.57 11.627 1.5 8 1.5M3.06 9.408C.314 5.427 3.164 0 8 0s7.686 5.427 4.94 9.408l-4.323 6.268a.75.75 0 0 1-1.234 0zM8 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M5.5 6a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0" clip-rule="evenodd"/>`
    }, props));
$25dc871355f8422b$var$LocationIcon.displayName = 'LocationIcon';
var $25dc871355f8422b$var$_default = module.exports.default = $25dc871355f8422b$var$LocationIcon;

});

parcelRegister("f5ck7", function(module, exports) {
$parcel$export(module.exports, "TabActiveContext", function () { return $4758c11da8236a1e$export$b48a823132043a33; });
$parcel$export(module.exports, "useTabActiveContext", function () { return $4758c11da8236a1e$export$f78195dad520baf6; });

var $1oC0p = parcelRequire("1oC0p");
const $4758c11da8236a1e$export$b48a823132043a33 = (0, $1oC0p.createContext)(true);
const $4758c11da8236a1e$export$f78195dad520baf6 = ()=>(0, $1oC0p.useContext)($4758c11da8236a1e$export$b48a823132043a33);

});

parcelRegister("lDmb2", function(module, exports) {
$parcel$export(module.exports, "TabList", function () { return $121910c2e808e15b$export$e51a686c67fdaa2d; });
/* tab-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $kbpa7 = parcelRequire("kbpa7");

var $eOIix = parcelRequire("eOIix");

var $28sf5 = parcelRequire("28sf5");
const $121910c2e808e15b$var$tabListStyles = null;
const $121910c2e808e15b$var$highlightStyles = null;
const $121910c2e808e15b$var$darkThemeHighlightStyles = null;
const $121910c2e808e15b$var$tabListContainerStyles = null;
const $121910c2e808e15b$var$darkThemeTabListContainerStyles = null;
const $121910c2e808e15b$var$awf1TabListContainerStyles = null;
const $121910c2e808e15b$var$scrollAreaStyles = null;
const $121910c2e808e15b$var$navButtonStyles = null;
const $121910c2e808e15b$var$darkThemeNavButtonStyles = null;
const $121910c2e808e15b$var$hiddenNavButtonStyles = null;
const $121910c2e808e15b$var$fadeBaseStyles = null;
const $121910c2e808e15b$var$fadeStartStyles = null;
const $121910c2e808e15b$var$fadeEndStyles = null;
const $121910c2e808e15b$var$darkThemeFadeStartStyles = null;
const $121910c2e808e15b$var$darkThemeFadeEndStyles = null;
const $121910c2e808e15b$var$hiddenFadeStyles = null;
const $121910c2e808e15b$export$e51a686c67fdaa2d = ({ children: children, activeTabId: activeTabId })=>{
    const intl = (0, $8e22h.default)();
    const { isDarkTheme: isDarkTheme, isAwf1Theme: isAwf1Theme } = (0, $eOIix.useTheme)();
    const { scrollableRef: scrollableRef, highlightRef: highlightRef, isPreviousInactive: isPreviousInactive, isNextInactive: isNextInactive, handleScroll: handleScroll } = (0, $28sf5.useScrollableTabList)(activeTabId);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleScrollLeft = (0, $1oC0p.useCallback)(()=>{
        handleScroll(-1);
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'scrollTabsLeft',
            source: 'tabScrollControl',
            attributes: {
                label: 'scroll tabs left'
            }
        }).fire();
    }, [
        handleScroll,
        createAnalyticsEvent
    ]);
    const handleScrollRight = (0, $1oC0p.useCallback)(()=>{
        handleScroll(1);
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'scrollTabsRight',
            source: 'tabScrollControl',
            attributes: {
                label: 'scroll tabs right'
            }
        }).fire();
    }, [
        handleScroll,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _4cvr1h6o _11q7dkka _1j301j28 _2rko1jfw _1yt4u2gc _1bsb1ns9 _p12f1osq",
            isDarkTheme && "_11q7vkha _z21jtf30",
            isAwf1Theme && "_1p1dangw _ect4zzfg"
        ]),
        style: {
            "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200')),
            "--_1mehvmr": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark200')),
            "--_vimidu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark600'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                type: "button",
                onClick: handleScrollLeft,
                "aria-label": intl.formatMessage({
                    id: 'tab-list.scroll-left',
                    defaultMessage: 'Scroll tabs left'
                }),
                tabIndex: isPreviousInactive ? -1 : 0,
                "aria-hidden": isPreviousInactive,
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1h6o _11q7glyw _19itglyw _80omtlke _1yt4119w _1ul91ejb _1tke1ejb _syaz1pfd _1o9zidpf _tzy4kb7n _v5641hrg _sugaglyw",
                    isDarkTheme && "_syaz1afi",
                    isPreviousInactive && "_tzy4idpf _lcxvglyw _1bsbidpf _1ul9idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1reo15vq _18m915vq"
                ]),
                style: {
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "7",
                    height: "12",
                    viewBox: "0 0 7 12",
                    fill: "none",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M5.8335 10.8333L0.833496 5.83334L5.8335 0.833344",
                        stroke: isDarkTheme ? (0, $kbpa7.wacToken)('color.neutral.light0') : (0, $kbpa7.wacToken)('color.primary.black'),
                        strokeWidth: "1.66667",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "aria-hidden": "true",
                        className: (0, $2jatx.default)([
                            "_kqswstnw _152tidpf _u7coidpf _1bsb1ejb _lcxvglyw _1pbycs5v _v5641hrg",
                            "_1e02idpf _11q7dx5r",
                            isDarkTheme && "_11q71ta9",
                            isPreviousInactive && "_tzy4idpf"
                        ]),
                        style: {
                            "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200')),
                            "--_1mehvmr": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark200'))
                        }
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("ul", {
                        ref: scrollableRef,
                        role: "tablist",
                        "aria-orientation": "horizontal",
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _1e0c1txw _4cvr1h6o _1bsb1osq _1reo15zi _rjfvx6dd _qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kpfhglyw _8164u2gc _1uvfzwfg _1wwwzwfg"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                ref: highlightRef,
                                "aria-hidden": "true",
                                className: (0, $2jatx.default)([
                                    "_kqswstnw _152tidpf _4t3i1osq _2rkoxy5q _11q71pfd _sugaglyw _v5641r0g _lcxvglyw _sedtglyw",
                                    isDarkTheme && "_11q71afi"
                                ]),
                                style: {
                                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                                }
                            }),
                            children
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "aria-hidden": "true",
                        className: (0, $2jatx.default)([
                            "_kqswstnw _152tidpf _u7coidpf _1bsb1ejb _lcxvglyw _1pbycs5v _v5641hrg",
                            "_rjxpidpf _11q7ugqf",
                            isDarkTheme && "_11q717kn",
                            isNextInactive && "_tzy4idpf"
                        ]),
                        style: {
                            "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200')),
                            "--_1mehvmr": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark200'))
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                type: "button",
                onClick: handleScrollRight,
                "aria-label": intl.formatMessage({
                    id: 'tab-list.scroll-right',
                    defaultMessage: 'Scroll tabs right'
                }),
                tabIndex: isNextInactive ? -1 : 0,
                "aria-hidden": isNextInactive,
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1h6o _11q7glyw _19itglyw _80omtlke _1yt4119w _1ul91ejb _1tke1ejb _syaz1pfd _1o9zidpf _tzy4kb7n _v5641hrg _sugaglyw",
                    isDarkTheme && "_syaz1afi",
                    isNextInactive && "_tzy4idpf _lcxvglyw _1bsbidpf _1ul9idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1reo15vq _18m915vq"
                ]),
                style: {
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "7",
                    height: "12",
                    viewBox: "0 0 7 12",
                    fill: "none",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M0.833496 10.8333L5.8335 5.83334L0.833496 0.833344",
                        stroke: isDarkTheme ? (0, $kbpa7.wacToken)('color.neutral.light0') : (0, $kbpa7.wacToken)('color.primary.black'),
                        strokeWidth: "1.66667",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                })
            })
        ]
    });
};

});
parcelRegister("28sf5", function(module, exports) {
$parcel$export(module.exports, "useScrollableTabList", function () { return $ef69e28b94f66947$export$370d3ad9e0600bac; });

var $1oC0p = parcelRequire("1oC0p");
const $ef69e28b94f66947$var$SCROLL_AMOUNT = 200;
const $ef69e28b94f66947$var$SCROLL_PADDING = 48;
const $ef69e28b94f66947$var$prefersReducedMotion = ()=>typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const $ef69e28b94f66947$export$370d3ad9e0600bac = (activeTabId)=>{
    const scrollableRef = (0, $1oC0p.useRef)(null);
    const highlightRef = (0, $1oC0p.useRef)(null);
    const [isPreviousInactive, setIsPreviousInactive] = (0, $1oC0p.useState)(true);
    const [isNextInactive, setIsNextInactive] = (0, $1oC0p.useState)(true);
    const isFirstRender = (0, $1oC0p.useRef)(true);
    const isManualScrolling = (0, $1oC0p.useRef)(false);
    const isProgrammaticScroll = (0, $1oC0p.useRef)(false);
    const manualScrollTimeoutRef = (0, $1oC0p.useRef)();
    // Suppress auto-centering for a duration after manual scrolling
    const markManualScroll = (0, $1oC0p.useCallback)(()=>{
        isManualScrolling.current = true;
        if (manualScrollTimeoutRef.current) clearTimeout(manualScrollTimeoutRef.current);
        manualScrollTimeoutRef.current = setTimeout(()=>{
            isManualScrolling.current = false;
        }, 500);
    }, []);
    // Measure and position the highlight behind the active tab
    const updateHighlightPosition = (0, $1oC0p.useCallback)(()=>{
        const scrollable = scrollableRef.current;
        const highlight = highlightRef.current;
        if (!scrollable || !highlight || !activeTabId) return;
        const activeTab = scrollable.querySelector(`[data-tab-id="${activeTabId}"]`);
        if (!activeTab) return;
        const listRect = scrollable.getBoundingClientRect();
        const tabRect = activeTab.getBoundingClientRect();
        const left = tabRect.left - listRect.left + scrollable.scrollLeft;
        const width = tabRect.width;
        highlight.style.left = `${left}px`;
        highlight.style.width = `${width}px`;
    }, [
        activeTabId
    ]);
    // Scroll the active tab into the center of the visible area
    const scrollActiveTabIntoView = (0, $1oC0p.useCallback)(()=>{
        const scrollable = scrollableRef.current;
        if (!scrollable || !activeTabId) return;
        const activeTab = scrollable.querySelector(`[data-tab-id="${activeTabId}"]`);
        if (!activeTab) return;
        const scrollableWidth = scrollable.offsetWidth;
        const tabLeft = activeTab.offsetLeft;
        const tabWidth = activeTab.offsetWidth;
        const targetScroll = tabLeft - (scrollableWidth - tabWidth) / 2;
        isProgrammaticScroll.current = true;
        scrollable.scrollTo({
            left: targetScroll,
            behavior: $ef69e28b94f66947$var$prefersReducedMotion() ? 'auto' : 'smooth'
        });
    }, [
        activeTabId
    ]);
    // Update nav button visibility based on scroll position
    const updateNavButtonVisibility = (0, $1oC0p.useCallback)(()=>{
        const scrollable = scrollableRef.current;
        if (!scrollable) return;
        const atEnd = scrollable.scrollLeft > scrollable.scrollWidth - scrollable.offsetWidth - $ef69e28b94f66947$var$SCROLL_PADDING * 0.75;
        const atStart = scrollable.scrollLeft <= $ef69e28b94f66947$var$SCROLL_PADDING;
        setIsNextInactive(atEnd);
        setIsPreviousInactive(atStart);
    }, []);
    // Scroll the tab list by a fixed amount
    const handleScroll = (0, $1oC0p.useCallback)((direction)=>{
        const scrollable = scrollableRef.current;
        if (!scrollable) return;
        markManualScroll();
        isProgrammaticScroll.current = true;
        scrollable.scrollTo({
            top: 0,
            left: scrollable.scrollLeft + $ef69e28b94f66947$var$SCROLL_AMOUNT * direction,
            behavior: $ef69e28b94f66947$var$prefersReducedMotion() ? 'auto' : 'smooth'
        });
    }, [
        markManualScroll
    ]);
    // Position highlight on first render without transition
    (0, $1oC0p.useLayoutEffect)(()=>{
        if (isFirstRender.current) {
            const highlight = highlightRef.current;
            if (highlight) highlight.style.transition = 'none';
            requestAnimationFrame(()=>{
                updateHighlightPosition();
                requestAnimationFrame(()=>{
                    if (highlight) highlight.style.transition = '';
                    isFirstRender.current = false;
                });
            });
        }
    }, [
        updateHighlightPosition
    ]);
    // Update highlight and scroll into view on subsequent tab changes
    (0, $1oC0p.useEffect)(()=>{
        if (!isFirstRender.current) {
            updateHighlightPosition();
            scrollActiveTabIntoView();
        }
    }, [
        updateHighlightPosition,
        scrollActiveTabIntoView
    ]);
    // Recalculate highlight position and scroll on container resize (debounced)
    (0, $1oC0p.useEffect)(()=>{
        const scrollable = scrollableRef.current;
        if (!scrollable || typeof ResizeObserver !== 'function') return;
        let rafId = null;
        const observer = new ResizeObserver(()=>{
            if (rafId !== null) cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(()=>{
                updateHighlightPosition();
                if (!isManualScrolling.current) scrollActiveTabIntoView();
                rafId = null;
            });
        });
        observer.observe(scrollable);
        return ()=>{
            if (rafId !== null) cancelAnimationFrame(rafId);
            if (manualScrollTimeoutRef.current) clearTimeout(manualScrollTimeoutRef.current);
            observer.disconnect();
        };
    }, [
        updateHighlightPosition,
        scrollActiveTabIntoView
    ]);
    // Detect manual (user-initiated) horizontal scrolling on the tab list
    (0, $1oC0p.useEffect)(()=>{
        const scrollable = scrollableRef.current;
        if (!scrollable) return;
        const onScroll = ()=>{
            if (isProgrammaticScroll.current) {
                isProgrammaticScroll.current = false;
                return;
            }
            markManualScroll();
        };
        scrollable.addEventListener('scroll', onScroll, {
            passive: true
        });
        return ()=>{
            scrollable.removeEventListener('scroll', onScroll);
        };
    }, [
        markManualScroll
    ]);
    // Set up IntersectionObserver to track scroll position for nav buttons
    (0, $1oC0p.useEffect)(()=>{
        const scrollable = scrollableRef.current;
        if (!scrollable || typeof window.IntersectionObserver !== 'function') return;
        const options = {
            root: scrollable,
            rootMargin: `0px ${$ef69e28b94f66947$var$SCROLL_PADDING * 0.75}px 0px 0px`,
            threshold: [
                0.1,
                0.9,
                1.0
            ]
        };
        const observer = new IntersectionObserver(()=>{
            updateNavButtonVisibility();
        }, options);
        const firstItem = scrollable.querySelector('li:first-of-type');
        const lastItem = scrollable.querySelector('li:last-of-type');
        if (firstItem) observer.observe(firstItem);
        if (lastItem) observer.observe(lastItem);
        updateNavButtonVisibility();
        return ()=>{
            observer.disconnect();
        };
    }, [
        updateNavButtonVisibility
    ]);
    return {
        scrollableRef: scrollableRef,
        highlightRef: highlightRef,
        isPreviousInactive: isPreviousInactive,
        isNextInactive: isNextInactive,
        handleScroll: handleScroll
    };
};

});


parcelRegister("1dc5i", function(module, exports) {
$parcel$export(module.exports, "TabPanel", function () { return $fb7ea0e2b2e15ff6$export$3d96ec278d3efce4; });
/* tab-panel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $f5ck7 = parcelRequire("f5ck7");
// All panels are kept in the DOM and stacked in the same CSS grid cell so we can
// cross-fade between them without any layout shift. This matches the canonical
// WAC stacked-cross-fade idiom used in `customer-testimonials` and
// `hero-carousel` (gridArea "1 / 1" + opacity transition). Spec: GWP-11578.
const $fb7ea0e2b2e15ff6$var$panelStyles = null;
const $fb7ea0e2b2e15ff6$var$activePanelStyles = null;
const $fb7ea0e2b2e15ff6$export$3d96ec278d3efce4 = ({ children: children, id: id, isActive: isActive = true, ...rest })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f5ck7.TabActiveContext).Provider, {
        value: isActive,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            id: id,
            role: "tabpanel",
            "aria-labelledby": `tab-${id}`,
            // Inactive panels are visually invisible (opacity 0) and not
            // interactive (pointer-events: none + tabIndex: -1). They still
            // exist in the accessibility tree so screen readers can navigate,
            // but `aria-hidden` keeps them out of the announcement queue.
            tabIndex: isActive ? 0 : -1,
            "aria-hidden": !isActive,
            ...rest,
            className: (0, $2jatx.default)([
                "_nd5l1ekt _tzy4idpf _lcxvglyw _v56412jn _sedtglyw",
                isActive && "_tzy4kb7n _lcxv1wug"
            ]),
            style: {
                "--_1mnvk9u": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('motion.duration.400ms')),
                "--_kqkuu4": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('motion.easing.ease40-in-out'))
            },
            children: children
        })
    });
};

});

parcelRegister("leEwa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::54f75e2054943fb775b789c9f2b57e27>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f75a55c8f3683e3c$var$_react = $f75a55c8f3683e3c$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f75a55c8f3683e3c$var$_baseNew = $f75a55c8f3683e3c$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $f75a55c8f3683e3c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Bar charts; Reports in JSM, Space Analytics in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f75a55c8f3683e3c$var$ChartBarIcon = (props)=>/*#__PURE__*/ $f75a55c8f3683e3c$var$_react.default.createElement($f75a55c8f3683e3c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="m5.25 8.5.077.004A.75.75 0 0 1 6 9.25v2.5a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 1 .75-.75zm4-3.5a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-6A.75.75 0 0 1 8.25 5zm4-3a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-9a.75.75 0 0 1 .75-.75z"/>`
    }, props));
$f75a55c8f3683e3c$var$ChartBarIcon.displayName = 'ChartBarIcon';
var $f75a55c8f3683e3c$var$_default = module.exports.default = $f75a55c8f3683e3c$var$ChartBarIcon;

});

parcelRegister("agxCc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::21c7c38467d82a38f61fac3c4f24f045>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $77957947befae1d2$var$_react = $77957947befae1d2$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $77957947befae1d2$var$_baseNew = $77957947befae1d2$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $77957947befae1d2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiChat".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for white label Rovo experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $77957947befae1d2$var$AiChatIcon = (props)=>/*#__PURE__*/ $77957947befae1d2$var$_react.default.createElement($77957947befae1d2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 3.125C14.5 2.504 13.996 2 13.375 2H2.625C2.004 2 1.5 2.504 1.5 3.125v10.832L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125zm1.5 8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25V3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125z"/><path fill="currentcolor" d="M5 6.25a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>`
    }, props));
$77957947befae1d2$var$AiChatIcon.displayName = 'AiChatIcon';
var $77957947befae1d2$var$_default = module.exports.default = $77957947befae1d2$var$AiChatIcon;

});

parcelRegister("gyofT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ec2830ef4a5653740a2b8f60e21924b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c0d2a2eb698c43d8$var$_react = $c0d2a2eb698c43d8$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $c0d2a2eb698c43d8$var$_baseNew = $c0d2a2eb698c43d8$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $c0d2a2eb698c43d8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiAgent".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Rovo Agent.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c0d2a2eb698c43d8$var$AiAgentIcon = (props)=>/*#__PURE__*/ $c0d2a2eb698c43d8$var$_react.default.createElement($c0d2a2eb698c43d8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.971.493a2 2 0 0 1 2.058 0l5 3A2 2 0 0 1 15 5.208v5.584a2 2 0 0 1-.971 1.715l-5 3a2 2 0 0 1-2.058 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .971-1.715zm1.286 1.286a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.429v5.584a.5.5 0 0 0 .243.429l1.098.66a4.25 4.25 0 1 1 8.318 0l1.098-.66a.5.5 0 0 0 .243-.429V5.208a.5.5 0 0 0-.243-.429zM8 8.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5" clip-rule="evenodd"/>`
    }, props));
$c0d2a2eb698c43d8$var$AiAgentIcon.displayName = 'AiAgentIcon';
var $c0d2a2eb698c43d8$var$_default = module.exports.default = $c0d2a2eb698c43d8$var$AiAgentIcon;

});

parcelRegister("ktqe1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ab25c6896d727bd4806885f3b789ade9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ee7adbdfec1a4e3f$var$_react = $ee7adbdfec1a4e3f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $ee7adbdfec1a4e3f$var$_baseNew = $ee7adbdfec1a4e3f$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $ee7adbdfec1a4e3f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Bug".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Request types in JSM, bugs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ee7adbdfec1a4e3f$var$BugIcon = (props)=>/*#__PURE__*/ $ee7adbdfec1a4e3f$var$_react.default.createElement($ee7adbdfec1a4e3f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 2.5A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 8 2.5m3 1.52V4a3 3 0 0 0-6 0v.02c-.29.05-.553.182-.761.372l-.887-.633-.917-2.064-1.37.61.944 2.125c.09.204.234.38.416.51l1.325.946V7H.5v1.5h3.25v1.149l-1.15.958a1.25 1.25 0 0 0-.318.401L1.08 13.415l1.342.67 1.18-2.36.46-.383A4.25 4.25 0 0 0 8.001 14h.249A4 4 0 0 0 12 11.393l.4.333 1.18 2.36 1.34-.671-1.202-2.407a1.25 1.25 0 0 0-.318-.401l-1.15-.958V8.5h3.25V7h-3.25V5.886l1.325-.946a1.25 1.25 0 0 0 .416-.51l.944-2.125-1.37-.61-.917 2.064-.887.633A1.5 1.5 0 0 0 11 4.02M10.75 10V5.5h-5.5v4.443l.035.226A2.75 2.75 0 0 0 8 12.5h.249a2.5 2.5 0 0 0 2.5-2.5" clip-rule="evenodd"/>`
    }, props));
$ee7adbdfec1a4e3f$var$BugIcon.displayName = 'BugIcon';
var $ee7adbdfec1a4e3f$var$_default = module.exports.default = $ee7adbdfec1a4e3f$var$BugIcon;

});

parcelRegister("cybEc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::adfa31acacdadf9066a8b0b559629bfc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9231b1ecc601cac2$var$_react = $9231b1ecc601cac2$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $9231b1ecc601cac2$var$_baseNew = $9231b1ecc601cac2$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $9231b1ecc601cac2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Clock".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: recent, time input, sprint time remaining, overdue task work type status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9231b1ecc601cac2$var$ClockIcon = (props)=>/*#__PURE__*/ $9231b1ecc601cac2$var$_react.default.createElement($9231b1ecc601cac2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0M8.75 3.25v4.389l2.219 1.775-.938 1.172-2.5-2-.281-.226V3.25zM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/>`
    }, props));
$9231b1ecc601cac2$var$ClockIcon.displayName = 'ClockIcon';
var $9231b1ecc601cac2$var$_default = module.exports.default = $9231b1ecc601cac2$var$ClockIcon;

});

parcelRegister("iCsNc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2251b011785916069b749fddb2c5cd02>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d8e21c38448f35d8$var$_react = $d8e21c38448f35d8$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $d8e21c38448f35d8$var$_baseNew = $d8e21c38448f35d8$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $d8e21c38448f35d8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d8e21c38448f35d8$var$AutomationIcon = (props)=>/*#__PURE__*/ $d8e21c38448f35d8$var$_react.default.createElement($d8e21c38448f35d8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$d8e21c38448f35d8$var$AutomationIcon.displayName = 'AutomationIcon';
var $d8e21c38448f35d8$var$_default = module.exports.default = $d8e21c38448f35d8$var$AutomationIcon;

});

parcelRegister("dNI7u", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bb7d4b05cefe88d0219507dc0673c3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a0c2133a3d226096$var$_react = $a0c2133a3d226096$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $a0c2133a3d226096$var$_baseNew = $a0c2133a3d226096$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $a0c2133a3d226096$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a0c2133a3d226096$var$BranchIcon = (props)=>/*#__PURE__*/ $a0c2133a3d226096$var$_react.default.createElement($a0c2133a3d226096$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$a0c2133a3d226096$var$BranchIcon.displayName = 'BranchIcon';
var $a0c2133a3d226096$var$_default = module.exports.default = $a0c2133a3d226096$var$BranchIcon;

});

parcelRegister("aTuVh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cca747bf584e772ee6e9df3631122996>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7ee7070fa3cc9dab$var$_react = $7ee7070fa3cc9dab$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $7ee7070fa3cc9dab$var$_baseNew = $7ee7070fa3cc9dab$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $7ee7070fa3cc9dab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Incident".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for incidents in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7ee7070fa3cc9dab$var$IncidentIcon = (props)=>/*#__PURE__*/ $7ee7070fa3cc9dab$var$_react.default.createElement($7ee7070fa3cc9dab$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1a.75.75 0 0 1 .696.471l2.2 5.5 2.612 6.529H15V15H1v-1.5h1.492L7.304 1.471A.75.75 0 0 1 8 1M4.108 13.5h7.784l-.8-2H4.908zm1.4-3.5h4.984l-.8-2H6.308zm1.4-3.5h2.184L8 3.77z" clip-rule="evenodd"/>`
    }, props));
$7ee7070fa3cc9dab$var$IncidentIcon.displayName = 'IncidentIcon';
var $7ee7070fa3cc9dab$var$_default = module.exports.default = $7ee7070fa3cc9dab$var$IncidentIcon;

});

parcelRegister("g02sa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ccb1509d7e2270e6a953aebace8cfd49>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ba5e8c96d5d39b0c$var$_react = $ba5e8c96d5d39b0c$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $ba5e8c96d5d39b0c$var$_baseNew = $ba5e8c96d5d39b0c$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $ba5e8c96d5d39b0c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ba5e8c96d5d39b0c$var$ShareIcon = (props)=>/*#__PURE__*/ $ba5e8c96d5d39b0c$var$_react.default.createElement($ba5e8c96d5d39b0c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2.5 1a2.5 2.5 0 1 1 .73 1.765L6.212 7.567a2.5 2.5 0 0 1 0 .866l4.016 2.302a2.5 2.5 0 1 1-.692 1.332L5.521 9.766a2.5 2.5 0 1 1 0-3.53l4.016-2.302A2.5 2.5 0 0 1 9.5 3.5M3.75 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M12 11.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$ba5e8c96d5d39b0c$var$ShareIcon.displayName = 'ShareIcon';
var $ba5e8c96d5d39b0c$var$_default = module.exports.default = $ba5e8c96d5d39b0c$var$ShareIcon;

});

parcelRegister("7Sdq5", function(module, exports) {
$parcel$export(module.exports, "CollectionsCompoundNav", function () { return $61c36fa46e5ad31f$export$c217303c3f69f1be; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $jQ0cd = parcelRequire("jQ0cd");

var $cR2Ov = parcelRequire("cR2Ov");

var $hcVGp = parcelRequire("hcVGp");
const $61c36fa46e5ad31f$export$c217303c3f69f1be = ()=>{
    const intl = (0, $8e22h.default)();
    const teamworkOverviewHref = (0, $jQ0cd.useLocalizedHref)('/collections/teamwork');
    const teamworkFeaturesHref = (0, $jQ0cd.useLocalizedHref)('/collections/teamwork/features');
    const teamworkGuidesHref = (0, $jQ0cd.useLocalizedHref)('/collections/teamwork/guides');
    const teamworkEnterpriseHref = (0, $jQ0cd.useLocalizedHref)('/collections/teamwork/enterprise');
    const teamworkPricingHref = (0, $jQ0cd.useLocalizedHref)('/collections/teamwork/pricing');
    const teamworkResourcesHref = (0, $jQ0cd.useLocalizedHref)('/collections/teamwork/resources');
    const strategyOverviewHref = (0, $jQ0cd.useLocalizedHref)('/collections/strategy');
    const strategyDemosHref = (0, $jQ0cd.useLocalizedHref)('/collections/strategy/demo-center');
    const strategyPricingHref = (0, $jQ0cd.useLocalizedHref)('/collections/strategy/pricing');
    const strategyResourcesHref = (0, $jQ0cd.useLocalizedHref)('/collections/strategy/resources');
    const strategyUseCasesHref = (0, $jQ0cd.useLocalizedHref)('/collections/strategy/use-cases');
    const strategyCustomersHref = (0, $jQ0cd.useLocalizedHref)('/collections/strategy/customers');
    const serviceOverviewHref = (0, $jQ0cd.useLocalizedHref)('/collections/service');
    const serviceGuidesHref = (0, $jQ0cd.useLocalizedHref)('/collections/service/guides');
    const servicePricingHref = (0, $jQ0cd.useLocalizedHref)('/collections/service/pricing');
    const softwareHref = (0, $jQ0cd.useLocalizedHref)('/collections/software');
    const productHref = (0, $jQ0cd.useLocalizedHref)('/collections/product');
    const collectionsHref = (0, $jQ0cd.useLocalizedHref)('/collections');
    const props = {
        optionalClassName: 'collections-nav',
        compoundSubNavTitle: 'Collections',
        compoundSubNavTitleHref: collectionsHref,
        compoundSubNavLinksProps: [
            {
                globalLinksKey: 'teamwork',
                linkText: 'Teamwork',
                hasDropdown: true,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    orientation: "column",
                    contentSections: [
                        {
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.overview',
                                        defaultMessage: 'Overview'
                                    }),
                                    href: teamworkOverviewHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.features',
                                        defaultMessage: 'Features'
                                    }),
                                    href: teamworkFeaturesHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.guides',
                                        defaultMessage: 'Guides'
                                    }),
                                    href: teamworkGuidesHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.enterprise',
                                        defaultMessage: 'Enterprise'
                                    }),
                                    href: teamworkEnterpriseHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.pricing',
                                        defaultMessage: 'Pricing'
                                    }),
                                    href: teamworkPricingHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.resources',
                                        defaultMessage: 'Resources'
                                    }),
                                    href: teamworkResourcesHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: 'strategy',
                linkText: 'Strategy',
                hasDropdown: true,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    orientation: "column",
                    contentSections: [
                        {
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.overview',
                                        defaultMessage: 'Overview'
                                    }),
                                    href: strategyOverviewHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.demos',
                                        defaultMessage: 'Demos'
                                    }),
                                    href: strategyDemosHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.pricing',
                                        defaultMessage: 'Pricing'
                                    }),
                                    href: strategyPricingHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.resources',
                                        defaultMessage: 'Resources'
                                    }),
                                    href: strategyResourcesHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.useCases',
                                        defaultMessage: 'Use Cases'
                                    }),
                                    href: strategyUseCasesHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.customers',
                                        defaultMessage: 'Customers'
                                    }),
                                    href: strategyCustomersHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: 'service',
                linkText: 'Service',
                hasDropdown: true,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    orientation: "column",
                    contentSections: [
                        {
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.overview',
                                        defaultMessage: 'Overview'
                                    }),
                                    href: serviceOverviewHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.guides',
                                        defaultMessage: 'Guides'
                                    }),
                                    href: serviceGuidesHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.pricing',
                                        defaultMessage: 'Pricing'
                                    }),
                                    href: servicePricingHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: 'software',
                linkText: 'Software',
                hasDropdown: false,
                href: softwareHref
            },
            {
                globalLinksKey: 'product',
                linkText: 'Product',
                hasDropdown: false,
                href: productHref
            }
        ]
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hcVGp.GlobalNav), {
        productKey: 'collection',
        compoundNav: props
    });
};

});

parcelRegister("lgKym", function(module, exports) {
$parcel$export(module.exports, "CompassNav", function () { return $73340f47439b5afe$export$78e93448314ae49; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $eOIix = parcelRequire("eOIix");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $gn6Qa = parcelRequire("gn6Qa");
const $73340f47439b5afe$var$CompassLogoComponent = ()=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "compass",
        type: "logo",
        appearance: "brand",
        darkTheme: isDarkTheme
    });
};
const $73340f47439b5afe$export$78e93448314ae49 = ()=>{
    const intl = (0, $8e22h.default)();
    const pricingHref = (0, $jQ0cd.useLocalizedHref)('/software/compass/pricing');
    const resourcesHref = (0, $jQ0cd.useLocalizedHref)('/software/compass/resources');
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-CompassNav",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gn6Qa.ProductPageNav), {
            productLogoUrl: "/software/compass",
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($73340f47439b5afe$var$CompassLogoComponent, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: 'CompassPageTemplate.navbar.compass-logo',
                defaultMessage: 'Compass logo'
            }),
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($73340f47439b5afe$var$CompassLogoComponent, {}),
            productPageNavLinks: [
                {
                    globalLinksKey: 'features',
                    linkText: intl.formatMessage({
                        id: 'CompassPageTemplate.navbar.features',
                        defaultMessage: 'Features'
                    }),
                    hasDropdown: false,
                    productKey: 'compass',
                    href: (0, $jQ0cd.useLocalizedHref)('/software/compass/features')
                },
                {
                    globalLinksKey: 'pricing',
                    linkText: intl.formatMessage({
                        id: 'CompassPageTemplate.navbar.pricing',
                        defaultMessage: 'Pricing'
                    }),
                    hasDropdown: false,
                    productKey: 'compass',
                    href: pricingHref
                },
                {
                    globalLinksKey: 'resources',
                    linkText: intl.formatMessage({
                        id: 'CompassPageTemplate.navbar.resources',
                        defaultMessage: 'Resources'
                    }),
                    hasDropdown: false,
                    productKey: 'compass',
                    href: resourcesHref
                }
            ],
            isShowTryNowLink: false,
            mobileLinksSections: [
                {
                    mobileLinkKey: 'mobile-compass',
                    mobileLinksProps: [
                        {
                            globalLinksKey: 'features',
                            linkText: intl.formatMessage({
                                id: 'CompassPageTemplate.navbar.features',
                                defaultMessage: 'Features'
                            }),
                            hasDropdown: false,
                            productKey: 'compass',
                            href: (0, $jQ0cd.useLocalizedHref)('/software/compass/features')
                        },
                        {
                            globalLinksKey: 'pricing',
                            linkText: intl.formatMessage({
                                id: 'CompassPageTemplate.navbar.pricing',
                                defaultMessage: 'Pricing'
                            }),
                            hasDropdown: false,
                            productKey: 'compass',
                            href: pricingHref
                        },
                        {
                            globalLinksKey: 'resources',
                            linkText: intl.formatMessage({
                                id: 'CompassPageTemplate.navbar.resources',
                                defaultMessage: 'Resources'
                            }),
                            hasDropdown: false,
                            productKey: 'compass',
                            href: resourcesHref
                        }
                    ]
                }
            ]
        })
    });
};

});

parcelRegister("g2lQR", function(module, exports) {
$parcel$export(module.exports, "GuardNav", function () { return $97dc5fc3d3238142$export$941339143e9f5522; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $20OkY = parcelRequire("20OkY");

var $asbmK = parcelRequire("asbmK");

var $eOIix = parcelRequire("eOIix");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $gn6Qa = parcelRequire("gn6Qa");
const $97dc5fc3d3238142$var$GuardLogoComponent = ()=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "guard",
        type: "logo",
        appearance: "brand",
        darkTheme: isDarkTheme
    });
};
const $97dc5fc3d3238142$export$941339143e9f5522 = ()=>{
    const intl = (0, $8e22h.default)();
    const signupLink = 'https://admin.atlassian.com/atlassian-guard';
    const { openCrossFlow: openCrossFlow } = (0, $asbmK.useCrossFlowFrontendTouchpoint)({
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const capabilitiesHref = (0, $jQ0cd.useLocalizedHref)('/software/guard/capabilities');
    const pricingHref = (0, $jQ0cd.useLocalizedHref)('/software/guard/pricing');
    const guidesHref = (0, $jQ0cd.useLocalizedHref)('/software/guard/guide#getting-started');
    const demoHref = (0, $jQ0cd.useLocalizedHref)('/software/guard/demo');
    const links = [
        {
            globalLinksKey: 'capabilities',
            linkText: intl.formatMessage({
                id: 'GuardPageTemplate.navbar.capabilities',
                defaultMessage: 'Capabilities'
            }),
            hasDropdown: false,
            productKey: 'guard',
            href: capabilitiesHref
        },
        {
            globalLinksKey: 'guides',
            linkText: intl.formatMessage({
                id: 'GuardPageTemplate.navbar.guides',
                defaultMessage: 'Guides'
            }),
            hasDropdown: false,
            productKey: 'guard',
            href: guidesHref
        },
        {
            globalLinksKey: 'demo',
            linkText: intl.formatMessage({
                id: 'GuardPageTemplate.navbar.demo',
                defaultMessage: 'Demo'
            }),
            hasDropdown: false,
            productKey: 'guard',
            href: demoHref
        },
        {
            globalLinksKey: 'pricing',
            linkText: intl.formatMessage({
                id: 'GuardPageTemplate.navbar.pricing',
                defaultMessage: 'Pricing'
            }),
            hasDropdown: false,
            productKey: 'guard',
            href: pricingHref
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-GuardNav",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gn6Qa.ProductPageNav), {
            productLogoUrl: "/software/guard",
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($97dc5fc3d3238142$var$GuardLogoComponent, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: 'GuardPageTemplate.navbar.guard-logo',
                defaultMessage: 'Guard logo'
            }),
            mobileCtaText: intl.formatMessage({
                id: 'GuardPageTemplate.navbar.tryitfree',
                defaultMessage: 'Try it free'
            }),
            navigationTrynowCtaText: intl.formatMessage({
                id: 'GuardPageTemplate.navbar.tryitfree',
                defaultMessage: 'Try it free'
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: openCrossFlow,
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($97dc5fc3d3238142$var$GuardLogoComponent, {}),
            productPageNavLinks: links,
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: openCrossFlow,
            mobileLinksSections: [
                {
                    mobileLinkKey: 'mobile-guard',
                    mobileLinksProps: links
                }
            ]
        })
    });
};

});

parcelRegister("grkXZ", function(module, exports) {
$parcel$export(module.exports, "DropdownSelector", function () { return $7df351058cf48215$export$67ffdcf8cfce0fd; });
/* dropdown-selector.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $kKAAc = parcelRequire("kKAAc");
const $7df351058cf48215$var$dropdownSelectorContainerStyle = null;
const $7df351058cf48215$var$labelStyle = null;
const $7df351058cf48215$var$labelStyleSignup = null;
const $7df351058cf48215$export$67ffdcf8cfce0fd = ({ options: options, name: name, id: id, testId: testId, label: label, onChangeHandler: onChangeHandler, defaultValue: defaultValue, cssOverrides: cssOverrides, className: className })=>{
    const [isMenuOpen, setIsMenuOpen] = (0, $1oC0p.useState)(false);
    const elementID = id ? id : `${name}-dropdown`;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c116y _2lx21bp4 _1bsb1osq",
            className
        ]),
        children: [
            cssOverrides?.labelStyle === 'signup' && /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                htmlFor: elementID,
                className: (0, $2jatx.default)([
                    "_syazvwuj _vwz41gnr _6rth1b66 _y3gn1e5h _k48pbfng _1wybdlk8"
                ]),
                children: label
            }),
            !cssOverrides?.labelStyle && /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                htmlFor: elementID,
                className: (0, $2jatx.default)([
                    "_syazvwuj _1wyboqnp _vwz41gnr _6rth1b66 _y3gn1e5h"
                ]),
                children: label
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: "select-dropdown-container",
                "data-testid": testId ? testId : elementID,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kKAAc.default), {
                    defaultValue: defaultValue || {
                        label: 'Select...',
                        value: ''
                    },
                    options: options,
                    unstyled: true,
                    inputId: elementID,
                    onChange: (selectedOption)=>{
                        onChangeHandler?.(selectedOption?.value || '');
                    },
                    onMenuOpen: ()=>setIsMenuOpen(true),
                    onMenuClose: ()=>setIsMenuOpen(false),
                    styles: {
                        // @ts-ignore
                        container: (provided)=>({
                                ...provided,
                                appearance: 'none',
                                flexDirection: 'row',
                                fontSize: '1rem',
                                lineHeight: '1.2',
                                textAlign: 'left',
                                ...(cssOverrides || {}).container
                            }),
                        // @ts-ignore
                        singleValue: (provided)=>({
                                ...provided,
                                marginLeft: "var(--ds-space-025, 2px)",
                                marginRight: "var(--ds-space-025, 2px)",
                                ...(cssOverrides || {}).singleValue
                            }),
                        // @ts-ignore
                        placeholder: (provided)=>({
                                ...provided,
                                marginLeft: "var(--ds-space-025, 2px)",
                                marginRight: "var(--ds-space-025, 2px)",
                                ...(cssOverrides || {}).placeholder
                            }),
                        // @ts-ignore
                        valueContainer: (provided)=>({
                                ...provided,
                                paddingLeft: "var(--ds-space-075, 6px)",
                                paddingRight: "var(--ds-space-075, 6px)",
                                ...(cssOverrides || {}).valueContainer
                            }),
                        // @ts-ignore
                        menu: (provided)=>({
                                ...provided,
                                marginTop: "var(--ds-space-050, 4px)",
                                // eslint-disable-next-line local/ensure-wac-token-usage
                                boxShadow: '0px 3px 5px 0px #091E4233',
                                // eslint-disable-next-line local/ensure-wac-token-usage
                                background: '#ffffff',
                                padding: 0,
                                borderRadius: "var(--ds-space-050, 4px)",
                                ...(cssOverrides || {}).menu
                            }),
                        // @ts-ignore
                        control: (provided, state)=>({
                                ...provided,
                                cursor: 'pointer',
                                backgroundColor: isMenuOpen ? '#253858' : '#FAFBFC',
                                color: isMenuOpen ? '#ffffff' : '#172B4D',
                                height: '2.65rem',
                                border: state.isFocused ? `2px solid #4C9AFF` : `2px solid #dfe1e6`,
                                borderRadius: "var(--ds-space-050, 4px)",
                                '&:hover': {
                                    background: isMenuOpen ? undefined : '#F4F5F7'
                                },
                                ...(cssOverrides || {}).control
                            }),
                        // @ts-ignore
                        dropdownIndicator: (provided, state)=>({
                                ...provided,
                                transition: 'all .2s ease',
                                transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : undefined,
                                ...(cssOverrides || {}).dropdownIndicator
                            }),
                        // @ts-ignore
                        indicatorsContainer: (provided)=>({
                                ...provided,
                                paddingTop: "var(--ds-space-075, 6px)",
                                paddingBottom: "var(--ds-space-075, 6px)",
                                paddingLeft: "var(--ds-space-025, 2px)",
                                paddingRight: "var(--ds-space-075, 6px)",
                                ...(cssOverrides || {}).indicatorsContainer
                            }),
                        // @ts-ignore
                        option: (provided, state)=>({
                                ...provided,
                                cursor: 'pointer',
                                padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`,
                                whiteSpace: 'pre-wrap',
                                overflowWrap: 'break-word',
                                backgroundColor: state.isSelected ? '#B2D4FF' : state.isFocused ? '#EBECF0' : '#FAFBFC',
                                color: state.isSelected ? '#0065FF' : '#172B4D',
                                '&:hover': {
                                    background: state.isSelected ? '#B2D4FF' : '#EBECF0'
                                },
                                '&:active': {
                                    // eslint-disable-next-line local/ensure-wac-token-usage
                                    background: '#DFE1E5'
                                },
                                ...(cssOverrides || {}).option
                            }),
                        // @ts-ignore
                        input: (provided)=>({
                                ...provided,
                                color: 'transparent',
                                ...(cssOverrides || {}).input
                            })
                    }
                })
            })
        ]
    });
};

});

parcelRegister("8IRDn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::19440c8dd0e3db5766add744ad314d45>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $659c096e7ab9950d$var$_react = $659c096e7ab9950d$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $659c096e7ab9950d$var$_baseNew = $659c096e7ab9950d$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $659c096e7ab9950d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Email".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $659c096e7ab9950d$var$EmailIcon = (props)=>/*#__PURE__*/ $659c096e7ab9950d$var$_react.default.createElement($659c096e7ab9950d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v.529L8 8.128l6.5-3.6V4a.5.5 0 0 0-.5-.5zm12.5 2.743L8.363 9.641a.75.75 0 0 1-.726 0L1.5 6.243V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$659c096e7ab9950d$var$EmailIcon.displayName = 'EmailIcon';
var $659c096e7ab9950d$var$_default = module.exports.default = $659c096e7ab9950d$var$EmailIcon;

});

parcelRegister("5EeVR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $66345548d441cf68$export$2e2bcd8739ae039; });
/* skeleton.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $eUwCn = parcelRequire("eUwCn");
const $66345548d441cf68$var$DEFAULT_LINE_HEIGHT = '1.25rem';
const $66345548d441cf68$var$DEFAULT_WIDTH = '100%';
const $66345548d441cf68$var$DEFAULT_MAX_WIDTH = '100%';
const $66345548d441cf68$var$DEFAULT_GAP = '150';
const $66345548d441cf68$var$DEFAULT_COUNT = 1;
const $66345548d441cf68$var$ALIGN_TO_FLEX = {
    start: 'flex-start',
    center: 'center',
    end: 'flex-end',
    stretch: 'stretch'
};
// Breakpoint rules read CSS custom properties so the static `css` stays
// build-time-extractable while per-bone values are supplied inline.
const $66345548d441cf68$var$containerStyles = null;
const $66345548d441cf68$var$boneStyles = null;
// Uniform sends "" (not undefined) for an unset field; treat both as "no value".
const $66345548d441cf68$var$orFallback = (value, fallback)=>value === undefined || value === '' ? fallback : value;
const $66345548d441cf68$var$toCount = (value)=>{
    if (value === undefined || value === '') return undefined;
    const numeric = typeof value === 'string' ? Number(value) : value;
    return Number.isFinite(numeric) && numeric > 0 ? Math.floor(numeric) : undefined;
};
const $66345548d441cf68$var$resolveFlatCount = (mobile, tablet, desktop)=>{
    const mobileValue = $66345548d441cf68$var$toCount(mobile) ?? $66345548d441cf68$var$DEFAULT_COUNT;
    const tabletValue = $66345548d441cf68$var$toCount(tablet) ?? mobileValue;
    const desktopValue = $66345548d441cf68$var$toCount(desktop) ?? tabletValue;
    return {
        mobile: mobileValue,
        tablet: tabletValue,
        desktop: desktopValue
    };
};
// Cascades unset breakpoints up from mobile.
const $66345548d441cf68$var$resolveFlat = (mobile, tablet, desktop, fallback)=>{
    const mobileValue = $66345548d441cf68$var$orFallback(mobile, fallback);
    const tabletValue = $66345548d441cf68$var$orFallback(tablet, mobileValue);
    const desktopValue = $66345548d441cf68$var$orFallback(desktop, tabletValue);
    return {
        mobile: mobileValue,
        tablet: tabletValue,
        desktop: desktopValue
    };
};
// Tolerates a partial object (Uniform may only author the mobile value).
const $66345548d441cf68$var$resolveGap = (gap)=>{
    const value = gap ?? {};
    const mobile = $66345548d441cf68$var$orFallback(value.mobile, $66345548d441cf68$var$DEFAULT_GAP);
    const tablet = $66345548d441cf68$var$orFallback(value.tablet, mobile);
    const desktop = $66345548d441cf68$var$orFallback(value.desktop, tablet);
    return {
        mobile: `var(--ds-space-${mobile})`,
        tablet: `var(--ds-space-${tablet})`,
        desktop: `var(--ds-space-${desktop})`
    };
};
const $66345548d441cf68$var$UniformSkeleton = ({ width: width, tabletWidth: tabletWidth, desktopWidth: desktopWidth, maxWidth: maxWidth, tabletMaxWidth: tabletMaxWidth, desktopMaxWidth: desktopMaxWidth, height: height, tabletHeight: tabletHeight, desktopHeight: desktopHeight, aspectRatio: aspectRatio, tabletAspectRatio: tabletAspectRatio, desktopAspectRatio: desktopAspectRatio, borderRadius: borderRadius, count: count, tabletCount: tabletCount, desktopCount: desktopCount, gap: gap, lastLineWidth: lastLineWidth, tabletLastLineWidth: tabletLastLineWidth, desktopLastLineWidth: desktopLastLineWidth, align: align = 'stretch' })=>{
    const counts = $66345548d441cf68$var$resolveFlatCount(count, tabletCount, desktopCount);
    const maxCount = Math.max(counts.mobile, counts.tablet, counts.desktop);
    const widths = $66345548d441cf68$var$resolveFlat(width, tabletWidth, desktopWidth, $66345548d441cf68$var$DEFAULT_WIDTH);
    const maxWidths = $66345548d441cf68$var$resolveFlat(maxWidth, tabletMaxWidth, desktopMaxWidth, $66345548d441cf68$var$DEFAULT_MAX_WIDTH);
    // "" means "no override": fall back to the normal width / no aspect ratio.
    const lastWidths = $66345548d441cf68$var$resolveFlat(lastLineWidth, tabletLastLineWidth, desktopLastLineWidth, '');
    const aspectRatios = $66345548d441cf68$var$resolveFlat(aspectRatio, tabletAspectRatio, desktopAspectRatio, '');
    const heights = $66345548d441cf68$var$resolveFlat(height, tabletHeight, desktopHeight, $66345548d441cf68$var$DEFAULT_LINE_HEIGHT);
    const gaps = $66345548d441cf68$var$resolveGap(gap);
    // Where an aspectRatio is set the height is `auto`; otherwise the fixed one.
    const heightAt = (viewport)=>aspectRatios[viewport] ? 'auto' : heights[viewport];
    const aspectAt = (viewport)=>aspectRatios[viewport] || 'auto';
    const containerStyle = {
        '--wac-skeleton-gap-mobile': gaps.mobile,
        '--wac-skeleton-gap-tablet': gaps.tablet,
        '--wac-skeleton-gap-desktop': gaps.desktop,
        alignItems: $66345548d441cf68$var$ALIGN_TO_FLEX[align]
    };
    // The last visible bone gets the short last-line width, when one is set.
    const widthAt = (index, viewport)=>{
        const isLastVisible = counts[viewport] > 1 && index === counts[viewport] - 1;
        return isLastVisible && lastWidths[viewport] ? lastWidths[viewport] : widths[viewport];
    };
    const displayAt = (index, viewport)=>index < counts[viewport] ? 'block' : 'none';
    const buildBoneStyle = (index)=>({
            '--wac-skeleton-display-mobile': displayAt(index, 'mobile'),
            '--wac-skeleton-display-tablet': displayAt(index, 'tablet'),
            '--wac-skeleton-display-desktop': displayAt(index, 'desktop'),
            '--wac-skeleton-width-mobile': widthAt(index, 'mobile'),
            '--wac-skeleton-width-tablet': widthAt(index, 'tablet'),
            '--wac-skeleton-width-desktop': widthAt(index, 'desktop'),
            '--wac-skeleton-max-width-mobile': maxWidths.mobile,
            '--wac-skeleton-max-width-tablet': maxWidths.tablet,
            '--wac-skeleton-max-width-desktop': maxWidths.desktop,
            '--wac-skeleton-height-mobile': heightAt('mobile'),
            '--wac-skeleton-height-tablet': heightAt('tablet'),
            '--wac-skeleton-height-desktop': heightAt('desktop'),
            '--wac-skeleton-aspect-mobile': aspectAt('mobile'),
            '--wac-skeleton-aspect-tablet': aspectAt('tablet'),
            '--wac-skeleton-aspect-desktop': aspectAt('desktop'),
            borderRadius: borderRadius
        });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        style: containerStyle,
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1bsb1osq _1p57xte4 _1to91dlp _1plr1sr7"
        ]),
        children: Array.from({
            length: maxCount
        }, (_, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                style: buildBoneStyle(index),
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1reo15vq _18m915vq _1e0cnw9a _1bsb1pk8 _p12f1o5e _4t3izf1f _1h1t1fty _181n19o1 _14b514g9 _b8yq1l85 _1xlo1qh7 _7dyz1vvd _dm25suzz _glte1j0o _10jx7cob _165tmmre _bb4111mi"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                    width: "100%",
                    height: "100%"
                })
            }, index))
    });
};
var $66345548d441cf68$export$2e2bcd8739ae039 = $66345548d441cf68$var$UniformSkeleton;

});

parcelRegister("60ByZ", function(module, exports) {
$parcel$export(module.exports, "Tab", function () { return $cac7b5f11fd9c462$export$3e41faf802a29e71; });
/* tab.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $eY3N6 = parcelRequire("eY3N6");

var $kbpa7 = parcelRequire("kbpa7");

var $eOIix = parcelRequire("eOIix");
const $cac7b5f11fd9c462$var$listItemStyles = null;
const $cac7b5f11fd9c462$var$tabLinkStyles = null;
const $cac7b5f11fd9c462$var$inactiveTabStyles = null;
const $cac7b5f11fd9c462$var$darkThemeInactiveTabStyles = null;
const $cac7b5f11fd9c462$var$activeTabStyles = null;
const $cac7b5f11fd9c462$var$darkThemeActiveTabStyles = null;
const $cac7b5f11fd9c462$var$largeTabSizingStyles = null;
const $cac7b5f11fd9c462$var$smallTabSizingStyles = null;
const $cac7b5f11fd9c462$export$3e41faf802a29e71 = ({ tabId: tabIdProp, index: index = 0, title: title, isActive: isActive = false, onTabSelect: onTabSelect, tabSize: tabSize, focusOnActivate: focusOnActivate = true })=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    const tabId = tabIdProp ?? `tab-${index}`;
    const tabRef = (0, $1oC0p.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleClick = (0, $1oC0p.useCallback)((e)=>{
        e.preventDefault();
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'tab',
            actionSubjectId: 'wacRefreshTab',
            source: 'tabsMenu',
            attributes: {
                label: title,
                tabId: tabId,
                tabIndex: index
            }
        }).fire();
        onTabSelect?.(tabId);
    }, [
        onTabSelect,
        tabId,
        title,
        index,
        createAnalyticsEvent
    ]);
    const handleKeyDown = (0, $1oC0p.useCallback)((e)=>{
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onTabSelect?.(tabId);
            return;
        }
        const currentTab = tabRef.current;
        const tabList = currentTab?.closest('[role="tablist"]');
        if (!tabList || !currentTab) return;
        const tabs = Array.from(tabList.querySelectorAll('[role="tab"]'));
        const currentIndex = tabs.indexOf(currentTab);
        if (currentIndex === -1) return;
        let nextIndex = null;
        switch(e.key){
            case 'ArrowRight':
                nextIndex = (currentIndex + 1) % tabs.length;
                break;
            case 'ArrowLeft':
                nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
                break;
            case 'Home':
                nextIndex = 0;
                break;
            case 'End':
                nextIndex = tabs.length - 1;
                break;
            default:
                return;
        }
        e.preventDefault();
        tabs[nextIndex]?.click();
    }, [
        onTabSelect,
        tabId
    ]);
    // Track previous active state to only focus on changes, not initial mount
    const wasActive = (0, $1oC0p.useRef)(isActive);
    (0, $1oC0p.useEffect)(()=>{
        if (isActive && !wasActive.current && focusOnActivate && tabRef.current) tabRef.current.focus();
        wasActive.current = isActive;
    }, [
        isActive,
        focusOnActivate
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
        "data-tab-id": tabId,
        role: "presentation",
        className: (0, $2jatx.default)([
            "_kqswh2mm _1pbykb7n _1hu1v2br _1e0c1txw _qtt8glyw _80omtlke"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
            ref: tabRef,
            href: `#${tabId}`,
            role: "tab",
            id: `tab-${tabId}`,
            "aria-controls": tabId,
            "aria-selected": isActive,
            tabIndex: isActive ? 0 : -1,
            onClick: handleClick,
            onKeyDown: handleKeyDown,
            // Disable the browser's built-in link-drag behavior. Without
            // this, mousedown + small movement on the anchor fires
            // `dragstart` instead of `click`, silently swallowing the
            // tab selection.
            draggable: false,
            onDragStart: (e)=>e.preventDefault(),
            "data-event-container": "tab",
            "data-event-id": tabId,
            "data-event-label": title,
            className: (0, $2jatx.default)([
                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1h6o _1bah1h6o _1rjcu2gc _o5721q9c _2rko1mv1 _4bfu1r31 _1hmsglyw _ajmmnqa1 _80omtlke _v564cpn1 _12ji1r31 _1qu2glyw _12y31o36 _uiztglyw _1mymglyw _sedtglyw _k48pbfng",
                tabSize === 'large' && "_1wybf6fq _vwz41ou6 _18zr1ejb _3p1cgktf _py5o1f4h _owpuxy5q _fz891tcg _1ol9zwfg _ecdx1jfw",
                tabSize === 'small' && "_1wyb7vkz _vwz41tcg _18zrv47k _owpu1f4h _fz89f6fq _1ol91ou6 _ecdxxy5q",
                isActive ? isDarkTheme ? "_syaz1pfd _1j301afi _1ygb6lb8 _1ah3myb0" : "_syaz1afi _1j301pfd _1ygb14ak _1ah3myb0" : isDarkTheme ? "_syaz1afi _1j307ga5 _1ygb14ak _1ah312gs _o7ksglyw _30l31wym" : "_syaz1pfd _1j30dkka _1ygb6lb8 _1ah312gs _o7ksglyw _30l35hrz"
            ]),
            style: {
                "--_hjrx1n": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.pill')),
                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                "--_y6vyc2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark400')),
                "--_138yw56": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue300')),
                "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200')),
                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
            },
            children: title
        })
    });
};

});

parcelRegister("f3oWf", function(module, exports) {
$parcel$export(module.exports, "iconMapping", function () { return $e4f57aa48d72479d$export$82f701de2810d5a7; });

var $gyofT = parcelRequire("gyofT");

var $agxCc = parcelRequire("agxCc");

var $8kWtd = parcelRequire("8kWtd");

var $6OwZZ = parcelRequire("6OwZZ");

var $4Vh86 = parcelRequire("4Vh86");

var $5qjmd = parcelRequire("5qjmd");

var $iCsNc = parcelRequire("iCsNc");

var $a7Xqx = parcelRequire("a7Xqx");

var $97j0t = parcelRequire("97j0t");

var $aVTcD = parcelRequire("aVTcD");

var $dNI7u = parcelRequire("dNI7u");

var $l4wQM = parcelRequire("l4wQM");

var $ktqe1 = parcelRequire("ktqe1");

var $56bcs = parcelRequire("56bcs");

var $5II9n = parcelRequire("5II9n");

var $1LeRj = parcelRequire("1LeRj");

var $leEwa = parcelRequire("leEwa");

var $era0o = parcelRequire("era0o");

var $iZu54 = parcelRequire("iZu54");

var $loQfN = parcelRequire("loQfN");

var $hrBjL = parcelRequire("hrBjL");

var $61pdb = parcelRequire("61pdb");

var $7ilxc = parcelRequire("7ilxc");

var $cybEc = parcelRequire("cybEc");

var $fhgNY = parcelRequire("fhgNY");

var $6e3tU = parcelRequire("6e3tU");

var $9ghqh = parcelRequire("9ghqh");

var $dO8Do = parcelRequire("dO8Do");

var $3FUL0 = parcelRequire("3FUL0");

var $3OOxO = parcelRequire("3OOxO");

var $2JPM3 = parcelRequire("2JPM3");

var $6pmKv = parcelRequire("6pmKv");

var $6j91P = parcelRequire("6j91P");

var $iSCOr = parcelRequire("iSCOr");

var $2RA08 = parcelRequire("2RA08");

var $9A47Z = parcelRequire("9A47Z");

var $biJi9 = parcelRequire("biJi9");

var $3AJLg = parcelRequire("3AJLg");

var $6UXAj = parcelRequire("6UXAj");

var $dNlyT = parcelRequire("dNlyT");

var $49zFb = parcelRequire("49zFb");

var $cNamI = parcelRequire("cNamI");

var $eAAXu = parcelRequire("eAAXu");

var $gta0F = parcelRequire("gta0F");

var $fonh7 = parcelRequire("fonh7");

var $3fxcB = parcelRequire("3fxcB");

var $ck1qR = parcelRequire("ck1qR");

var $iBtIB = parcelRequire("iBtIB");

var $cOWmd = parcelRequire("cOWmd");

var $ax2O9 = parcelRequire("ax2O9");

var $kX9u3 = parcelRequire("kX9u3");

var $hz0ya = parcelRequire("hz0ya");

var $bECX9 = parcelRequire("bECX9");

var $5SjQD = parcelRequire("5SjQD");

var $6hGO6 = parcelRequire("6hGO6");

var $l23yj = parcelRequire("l23yj");

var $czSoI = parcelRequire("czSoI");

var $kvde0 = parcelRequire("kvde0");

var $7V9HC = parcelRequire("7V9HC");

var $7Xn5M = parcelRequire("7Xn5M");

var $hA8Qq = parcelRequire("hA8Qq");

var $hBIcK = parcelRequire("hBIcK");

var $7doBf = parcelRequire("7doBf");

var $gHoFv = parcelRequire("gHoFv");

var $qz5Fw = parcelRequire("qz5Fw");

var $5ZCzy = parcelRequire("5ZCzy");

var $g02sa = parcelRequire("g02sa");

var $3w1ji = parcelRequire("3w1ji");

var $fq25Q = parcelRequire("fq25Q");

var $2Qv7t = parcelRequire("2Qv7t");

var $48PMv = parcelRequire("48PMv");

var $8GlZZ = parcelRequire("8GlZZ");

var $5R44a = parcelRequire("5R44a");

var $aUEBX = parcelRequire("aUEBX");

var $9ih0P = parcelRequire("9ih0P");

var $1DU5m = parcelRequire("1DU5m");

var $djIg7 = parcelRequire("djIg7");

var $l7rtf = parcelRequire("l7rtf");

var $1eGzb = parcelRequire("1eGzb");

var $k2zyM = parcelRequire("k2zyM");

var $2GO8b = parcelRequire("2GO8b");

var $dTPlE = parcelRequire("dTPlE");

var $8BlKa = parcelRequire("8BlKa");

var $lUMmm = parcelRequire("lUMmm");

var $6xXDI = parcelRequire("6xXDI");

var $f1MsQ = parcelRequire("f1MsQ");

var $5nJnO = parcelRequire("5nJnO");
const $e4f57aa48d72479d$export$82f701de2810d5a7 = {
    AiGenerativeTextSummaryIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($8kWtd))),
        version: 'core'
    },
    AssetsGraphIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($1eGzb))),
        version: 'core'
    },
    ClockIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($cybEc))),
        version: 'core'
    },
    RovoIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($lUMmm))),
        version: 'core'
    },
    TextAudioTranscriptIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($f1MsQ))),
        version: 'core'
    },
    TimelineIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($aUEBX))),
        version: 'core'
    },
    CalendarIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($56bcs))),
        version: 'core'
    },
    CameraIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($5II9n))),
        version: 'core'
    },
    WarningIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($djIg7))),
        version: 'core'
    },
    TeamsIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($5R44a))),
        version: 'core'
    },
    ChangesIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($1LeRj))),
        version: 'core'
    },
    ChartBarIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($leEwa))),
        version: 'core'
    },
    BriefcaseIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($l4wQM))),
        version: 'core'
    },
    AutomationIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($iCsNc))),
        version: 'core'
    },
    BugIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($ktqe1))),
        version: 'core'
    },
    DepartmentIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($3FUL0))),
        version: 'core'
    },
    EyeOpenIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($6pmKv))),
        version: 'core'
    },
    BranchIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($dNI7u))),
        version: 'core'
    },
    PhoneIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7V9HC))),
        version: 'core'
    },
    PremiumIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7Xn5M))),
        version: 'core'
    },
    CommentIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($6e3tU))),
        version: 'core'
    },
    Page: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($bECX9))),
        version: 'core'
    },
    PageIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($bECX9))),
        version: 'core'
    },
    PersonAddIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($czSoI))),
        version: 'core'
    },
    PersonAddedIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($kvde0))),
        version: 'core'
    },
    LobbyBellIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($fonh7))),
        version: 'core'
    },
    LocationIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($3fxcB))),
        version: 'core'
    },
    InformationIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($49zFb))),
        version: 'core'
    },
    PriorityMajorIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($hBIcK))),
        version: 'core'
    },
    OfficeBuildingIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($kX9u3))),
        version: 'core'
    },
    ChartTrendIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($loQfN))),
        version: 'core'
    },
    CheckboxCheckedIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7ilxc))),
        version: 'core'
    },
    GoalIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($6UXAj))),
        version: 'core'
    },
    ScreenIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($qz5Fw))),
        version: 'core'
    },
    BookWithBookmarkIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($aVTcD))),
        version: 'core'
    },
    PagesIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($5SjQD))),
        version: 'core'
    },
    ChartMatrixIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($iZu54))),
        version: 'core'
    },
    RoadmapIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($gHoFv))),
        version: 'core'
    },
    ShowMoreVerticalIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($3w1ji))),
        version: 'core'
    },
    TagIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($48PMv))),
        version: 'core'
    },
    MarketplaceIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($iBtIB))),
        version: 'core'
    },
    AngleBracketsIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($4Vh86))),
        version: 'core'
    },
    ProjectIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7doBf))),
        version: 'core'
    },
    BoardIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($97j0t))),
        version: 'core'
    },
    MegaphoneIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($cOWmd))),
        version: 'core'
    },
    TransitionIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($9ih0P))),
        version: 'core'
    },
    VideoIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($1DU5m))),
        version: 'core'
    },
    StarStarredIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($2Qv7t))),
        version: 'core'
    },
    EmojiIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($2JPM3))),
        version: 'core'
    },
    TaskInProgressIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($8GlZZ))),
        version: 'core'
    },
    FormsIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($3AJLg))),
        version: 'core'
    },
    FilesIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($9A47Z))),
        version: 'core'
    },
    FlagIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($biJi9))),
        version: 'core'
    },
    FileIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($2RA08))),
        version: 'core'
    },
    ListBulletedIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($eAAXu))),
        version: 'core'
    },
    SmartLinkListIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($fq25Q))),
        version: 'core'
    },
    MagicWandIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($ck1qR))),
        version: 'core'
    },
    OperationsIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($hz0ya))),
        version: 'core'
    },
    DecisionIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($dO8Do))),
        version: 'core'
    },
    FeedbackIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($6j91P))),
        version: 'core'
    },
    ObjectiveIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($ax2O9))),
        version: 'core'
    },
    PresenterModeIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($hA8Qq))),
        version: 'core'
    },
    BacklogIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($a7Xqx))),
        version: 'core'
    },
    SearchIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($5ZCzy))),
        version: 'core'
    },
    EditIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($3OOxO))),
        version: 'core'
    },
    CheckMarkIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($61pdb))),
        version: 'core'
    },
    CheckCircleIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($hrBjL))),
        version: 'core'
    },
    ListChecklistIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($gta0F))),
        version: 'core'
    },
    ArchiveBoxIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($5qjmd))),
        version: 'core'
    },
    AlertIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($6OwZZ))),
        version: 'core'
    },
    RoadmapsPlanIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($8BlKa))),
        version: 'core'
    },
    PeopleGroupIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($6hGO6))),
        version: 'core'
    },
    BrowserExtensionIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($k2zyM))),
        version: 'core'
    },
    SyncIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($6xXDI))),
        version: 'core'
    },
    NotepadIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($2GO8b))),
        version: 'core'
    },
    PageLiveDocIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($dTPlE))),
        version: 'core'
    },
    AiAgentIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($gyofT))),
        version: 'core'
    },
    AiChatIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($agxCc))),
        version: 'core'
    },
    ChartBubbleIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($era0o))),
        version: 'core'
    },
    CloudArrowUpIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($fhgNY))),
        version: 'core'
    },
    DataFlowIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($9ghqh))),
        version: 'core'
    },
    FieldCheckboxGroupIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($iSCOr))),
        version: 'core'
    },
    GridIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($dNlyT))),
        version: 'core'
    },
    LightbulbIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($cNamI))),
        version: 'core'
    },
    PersonIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($l23yj))),
        version: 'core'
    },
    ShareIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($g02sa))),
        version: 'core'
    },
    WorkItemsIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($l7rtf))),
        version: 'core'
    },
    ViewsIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($5nJnO))),
        version: 'core'
    }
};

});
parcelRegister("6OwZZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::76f067d08aa7c324d1505318ade2e26f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f6102723708b1ca$var$_react = $4f6102723708b1ca$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $4f6102723708b1ca$var$_baseNew = $4f6102723708b1ca$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $4f6102723708b1ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Alert".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for alerts in JSM and Compass.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4f6102723708b1ca$var$AlertIcon = (props)=>/*#__PURE__*/ $4f6102723708b1ca$var$_react.default.createElement($4f6102723708b1ca$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 0v3h-1.5V0zM2.123 1.063 4.172 3.11 3.11 4.17 1.063 2.124zm12.814 1.06L12.89 4.172 11.83 3.11l2.047-2.048zM4.195 5.875A1.5 1.5 0 0 1 5.69 4.5h4.62a1.5 1.5 0 0 1 1.495 1.375l.635 7.625H14V15H2v-1.5h1.56zm.87 7.625h5.87L10.31 6H5.69z" clip-rule="evenodd"/>`
    }, props));
$4f6102723708b1ca$var$AlertIcon.displayName = 'AlertIcon';
var $4f6102723708b1ca$var$_default = module.exports.default = $4f6102723708b1ca$var$AlertIcon;

});

parcelRegister("4Vh86", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::196b600e7960a1af1a5f6fffc09ddaa0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3959c5e36ea5e16d$var$_react = $3959c5e36ea5e16d$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $3959c5e36ea5e16d$var$_baseNew = $3959c5e36ea5e16d$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $3959c5e36ea5e16d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3959c5e36ea5e16d$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $3959c5e36ea5e16d$var$_react.default.createElement($3959c5e36ea5e16d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.315 14.445 6-13.5 1.37.61-6 13.5zM13.982 10l-2.925 2.145.886 1.21 3.75-2.75a.75.75 0 0 0 0-1.21l-3.75-2.75-.886 1.21zM2.018 6l2.926 2.145-.888 1.21-3.75-2.75a.75.75 0 0 1 0-1.21l3.75-2.75.888 1.21z" clip-rule="evenodd"/>`
    }, props));
$3959c5e36ea5e16d$var$AngleBracketsIcon.displayName = 'AngleBracketsIcon';
var $3959c5e36ea5e16d$var$_default = module.exports.default = $3959c5e36ea5e16d$var$AngleBracketsIcon;

});

parcelRegister("5qjmd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53af402aec64299fbaefa11fd3d04c88>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3f2e65705ed861f0$var$_react = $3f2e65705ed861f0$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $3f2e65705ed861f0$var$_baseNew = $3f2e65705ed861f0$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $3f2e65705ed861f0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArchiveBox".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: archiving pages, storage.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3f2e65705ed861f0$var$ArchiveBoxIcon = (props)=>/*#__PURE__*/ $3f2e65705ed861f0$var$_react.default.createElement($3f2e65705ed861f0$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h14v5h-1v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6H1zm2.5 5v7a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V6zm10-1.5h-11v-2h11zm-3 4.5h-5V7.5h5z" clip-rule="evenodd"/>`
    }, props));
$3f2e65705ed861f0$var$ArchiveBoxIcon.displayName = 'ArchiveBoxIcon';
var $3f2e65705ed861f0$var$_default = module.exports.default = $3f2e65705ed861f0$var$ArchiveBoxIcon;

});

parcelRegister("l4wQM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e2b10cb2fb36d0ad7bfa02e0b0408651>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f573741a4f66ef2e$var$_react = $f573741a4f66ef2e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f573741a4f66ef2e$var$_baseNew = $f573741a4f66ef2e$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $f573741a4f66ef2e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Briefcase".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Job title in Atlas, Operations in JSM.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f573741a4f66ef2e$var$BriefcaseIcon = (props)=>/*#__PURE__*/ $f573741a4f66ef2e$var$_react.default.createElement($f573741a4f66ef2e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 2.5a.5.5 0 0 0-.5.5v1h5V3a.5.5 0 0 0-.5-.5zM12 4V3a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v1H3a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM3 5.5a.5.5 0 0 0-.5.5v2h11V6a.5.5 0 0 0-.5-.5zm10.5 4H8.75V11h-1.5V9.5H2.5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$f573741a4f66ef2e$var$BriefcaseIcon.displayName = 'BriefcaseIcon';
var $f573741a4f66ef2e$var$_default = module.exports.default = $f573741a4f66ef2e$var$BriefcaseIcon;

});

parcelRegister("1LeRj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c939fd7642839817f37f5fef435fb296>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1485b4e646777d05$var$_react = $1485b4e646777d05$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $1485b4e646777d05$var$_baseNew = $1485b4e646777d05$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $1485b4e646777d05$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Changes".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for changes in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1485b4e646777d05$var$ChangesIcon = (props)=>/*#__PURE__*/ $1485b4e646777d05$var$_react.default.createElement($1485b4e646777d05$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 4.22 11.53.97l-1.06 1.06L12.44 4H2v1.5h10.44l-1.97 1.97 1.06 1.06 3.25-3.25a.75.75 0 0 0 0-1.06M3.56 10.5l1.97-1.97-1.06-1.06-3.25 3.25a.75.75 0 0 0 0 1.06l3.25 3.25 1.06-1.06L3.56 12H14v-1.5z" clip-rule="evenodd"/>`
    }, props));
$1485b4e646777d05$var$ChangesIcon.displayName = 'ChangesIcon';
var $1485b4e646777d05$var$_default = module.exports.default = $1485b4e646777d05$var$ChangesIcon;

});

parcelRegister("era0o", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3a8c88470e968ec08c5aa075e8f42b3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a82b592e72d28b05$var$_react = $a82b592e72d28b05$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $a82b592e72d28b05$var$_baseNew = $a82b592e72d28b05$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $a82b592e72d28b05$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBubble".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Bubble and matrix charts; Matrix view in in JPD
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a82b592e72d28b05$var$ChartBubbleIcon = (props)=>/*#__PURE__*/ $a82b592e72d28b05$var$_react.default.createElement($a82b592e72d28b05$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M11.27 9.01a1.38 1.38 0 1 1-1.51 1.51l-.01-.14.01-.14A1.38 1.38 0 0 1 11.13 9zM5.75 6.5a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5m4.75-5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"/>`
    }, props));
$a82b592e72d28b05$var$ChartBubbleIcon.displayName = 'ChartBubbleIcon';
var $a82b592e72d28b05$var$_default = module.exports.default = $a82b592e72d28b05$var$ChartBubbleIcon;

});

parcelRegister("iZu54", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d0119e14b14178352097aaf532e33e0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dd3541ec470c3c13$var$_react = $dd3541ec470c3c13$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $dd3541ec470c3c13$var$_baseNew = $dd3541ec470c3c13$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $dd3541ec470c3c13$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartMatrix".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Matrix view in in JPD, and other matrix charts.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dd3541ec470c3c13$var$ChartMatrixIcon = (props)=>/*#__PURE__*/ $dd3541ec470c3c13$var$_react.default.createElement($dd3541ec470c3c13$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8 4.25a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M13.25 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-5.5 2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/><path fill="currentcolor" fill-rule="evenodd" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2m5.5-9.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0m8 3.5a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5M10.5 8A1.75 1.75 0 1 1 14 8a1.75 1.75 0 0 1-3.5 0m-5 2.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$dd3541ec470c3c13$var$ChartMatrixIcon.displayName = 'ChartMatrixIcon';
var $dd3541ec470c3c13$var$_default = module.exports.default = $dd3541ec470c3c13$var$ChartMatrixIcon;

});

parcelRegister("7ilxc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f3359cfcb124b9edec9402a579fa9711>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $54faeb292ecf7d1f$var$_react = $54faeb292ecf7d1f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $54faeb292ecf7d1f$var$_baseNew = $54faeb292ecf7d1f$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $54faeb292ecf7d1f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $54faeb292ecf7d1f$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $54faeb292ecf7d1f$var$_react.default.createElement($54faeb292ecf7d1f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$54faeb292ecf7d1f$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
var $54faeb292ecf7d1f$var$_default = module.exports.default = $54faeb292ecf7d1f$var$CheckboxCheckedIcon;

});

parcelRegister("fhgNY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e83f76db2e7ada7e0358014b5e026a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b1f57aa6b89a634a$var$_react = $b1f57aa6b89a634a$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $b1f57aa6b89a634a$var$_baseNew = $b1f57aa6b89a634a$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $b1f57aa6b89a634a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b1f57aa6b89a634a$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $b1f57aa6b89a634a$var$_react.default.createElement($b1f57aa6b89a634a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3a4.25 4.25 0 0 0-4.236 3.9.75.75 0 0 1-.565.668A2.251 2.251 0 0 0 3.75 12v1.5a3.75 3.75 0 0 1-1.418-7.222 5.751 5.751 0 0 1 11.239-.458A4 4 0 0 1 12 13.5V12a2.5 2.5 0 0 0 .712-4.897.75.75 0 0 1-.526-.59A4.25 4.25 0 0 0 8 3m0 4a.75.75 0 0 1 .53.22l3 3-1.06 1.06-1.72-1.72V16h-1.5V9.56l-1.72 1.72-1.06-1.06 3-3A.75.75 0 0 1 8 7" clip-rule="evenodd"/>`
    }, props));
$b1f57aa6b89a634a$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $b1f57aa6b89a634a$var$_default = module.exports.default = $b1f57aa6b89a634a$var$CloudArrowUpIcon;

});

parcelRegister("9ghqh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6e9795e597b52fb83fbace5cb1978ff6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6be31f7c0a64a3c5$var$_react = $6be31f7c0a64a3c5$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6be31f7c0a64a3c5$var$_baseNew = $6be31f7c0a64a3c5$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $6be31f7c0a64a3c5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DataFlow".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Database schema in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6be31f7c0a64a3c5$var$DataFlowIcon = (props)=>/*#__PURE__*/ $6be31f7c0a64a3c5$var$_react.default.createElement($6be31f7c0a64a3c5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.75 1.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.122 0a2.251 2.251 0 1 1 0 1.5H9.563C8.976 3 8.5 3.476 8.5 4.063V7.25h3.128a2.251 2.251 0 1 1 0 1.5H8.5v3.188c0 .586.476 1.062 1.063 1.062h2.065a2.251 2.251 0 1 1 0 1.5H9.563A2.563 2.563 0 0 1 7 11.938V8.75H4.372a2.25 2.25 0 1 1 0-1.5H7V4.063A2.56 2.56 0 0 1 9.563 1.5zM2.25 7.25a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m11.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m0 5.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$6be31f7c0a64a3c5$var$DataFlowIcon.displayName = 'DataFlowIcon';
var $6be31f7c0a64a3c5$var$_default = module.exports.default = $6be31f7c0a64a3c5$var$DataFlowIcon;

});

parcelRegister("iSCOr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::012d66b4638df27988cb46b8baf9afaf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dbeb60837b8587ed$var$_react = $dbeb60837b8587ed$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $dbeb60837b8587ed$var$_baseNew = $dbeb60837b8587ed$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $dbeb60837b8587ed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FieldCheckboxGroup".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Checkbox group field type in Proforma.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dbeb60837b8587ed$var$FieldCheckboxGroupIcon = (props)=>/*#__PURE__*/ $dbeb60837b8587ed$var$_react.default.createElement($dbeb60837b8587ed$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 2.75A.75.75 0 0 1 1.75 2h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5A.75.75 0 0 1 1 6.25zm1.5.75v2h2v-2zM16 5.25H8v-1.5h8zM1 9.75A.75.75 0 0 1 1.75 9h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75zm1.5.75v2h2v-2zM16 12.25H8v-1.5h8z" clip-rule="evenodd"/>`
    }, props));
$dbeb60837b8587ed$var$FieldCheckboxGroupIcon.displayName = 'FieldCheckboxGroupIcon';
var $dbeb60837b8587ed$var$_default = module.exports.default = $dbeb60837b8587ed$var$FieldCheckboxGroupIcon;

});

parcelRegister("biJi9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::16a72127bfc0e3d91a970ca1d9129c37>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83a4822407e99dc6$var$_react = $83a4822407e99dc6$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $83a4822407e99dc6$var$_baseNew = $83a4822407e99dc6$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $83a4822407e99dc6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Flag".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: flags in Editor, feature flags.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83a4822407e99dc6$var$FlagIcon = (props)=>/*#__PURE__*/ $83a4822407e99dc6$var$_react.default.createElement($83a4822407e99dc6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.22 1.22A.75.75 0 0 1 2.75 1H14a.75.75 0 0 1 .6 1.2l-2.662 3.55L14.6 9.3a.75.75 0 0 1-.6 1.2H3.5V15H2V1.75a.75.75 0 0 1 .22-.53M3.5 9h9l-2.1-2.8a.75.75 0 0 1 0-.9l2.1-2.8h-9z" clip-rule="evenodd"/>`
    }, props));
$83a4822407e99dc6$var$FlagIcon.displayName = 'FlagIcon';
var $83a4822407e99dc6$var$_default = module.exports.default = $83a4822407e99dc6$var$FlagIcon;

});

parcelRegister("3AJLg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f6cd595d4ec67af9dd83acc02e35c9f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $29d83b27cecfd60b$var$_react = $29d83b27cecfd60b$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $29d83b27cecfd60b$var$_baseNew = $29d83b27cecfd60b$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $29d83b27cecfd60b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Form".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Represents forms across Atlassian products, including Proforma.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $29d83b27cecfd60b$var$FormIcon = (props)=>/*#__PURE__*/ $29d83b27cecfd60b$var$_react.default.createElement($29d83b27cecfd60b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 1.5H1V0h6zM1 3.875c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v1.75C15 6.385 14.384 7 13.625 7H2.375C1.615 7 1 6.384 1 5.625zM2.5 4v1.5h11V4zM7 10.5H1V9h6zm-6 2.375c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v1.75c0 .76-.616 1.375-1.375 1.375H2.375C1.615 16 1 15.384 1 14.625zM2.5 13v1.5h11V13z" clip-rule="evenodd"/>`
    }, props));
$29d83b27cecfd60b$var$FormIcon.displayName = 'FormIcon';
var $29d83b27cecfd60b$var$_default = module.exports.default = $29d83b27cecfd60b$var$FormIcon;

});

parcelRegister("6UXAj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::62b2367dcefa534d3cc5e1a7e205b220>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $50963153fc855bc9$var$_react = $50963153fc855bc9$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $50963153fc855bc9$var$_baseNew = $50963153fc855bc9$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $50963153fc855bc9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Goal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for goals in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $50963153fc855bc9$var$GoalIcon = (props)=>/*#__PURE__*/ $50963153fc855bc9$var$_react.default.createElement($50963153fc855bc9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0" clip-rule="evenodd"/>`
    }, props));
$50963153fc855bc9$var$GoalIcon.displayName = 'GoalIcon';
var $50963153fc855bc9$var$_default = module.exports.default = $50963153fc855bc9$var$GoalIcon;

});

parcelRegister("dNlyT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7de7b5804889990b150be57e7707dfe0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a0b093aad4bb76da$var$_react = $a0b093aad4bb76da$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $a0b093aad4bb76da$var$_baseNew = $a0b093aad4bb76da$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $a0b093aad4bb76da$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Grid".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: spaces in Confluence, and grid view, all content in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a0b093aad4bb76da$var$GridIcon = (props)=>/*#__PURE__*/ $a0b093aad4bb76da$var$_react.default.createElement($a0b093aad4bb76da$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v4.25h4.75V2.5zm5.75 0v4.75h4.75V3a.5.5 0 0 0-.5-.5zm4.75 6.25H8.75v4.75H13a.5.5 0 0 0 .5-.5zM7.25 13.5V8.75H2.5V13a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$a0b093aad4bb76da$var$GridIcon.displayName = 'GridIcon';
var $a0b093aad4bb76da$var$_default = module.exports.default = $a0b093aad4bb76da$var$GridIcon;

});

parcelRegister("49zFb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d43a7428702b82788297fb999fe29f0a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3063aaa999ab433f$var$_react = $3063aaa999ab433f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $3063aaa999ab433f$var$_baseNew = $3063aaa999ab433f$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $3063aaa999ab433f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3063aaa999ab433f$var$InformationIcon = (props)=>/*#__PURE__*/ $3063aaa999ab433f$var$_react.default.createElement($3063aaa999ab433f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$3063aaa999ab433f$var$InformationIcon.displayName = 'InformationIcon';
var $3063aaa999ab433f$var$_default = module.exports.default = $3063aaa999ab433f$var$InformationIcon;

});

parcelRegister("fonh7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::de887aadbfedd5e674ee79e9bf8242ce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b34b26d834178e56$var$_react = $b34b26d834178e56$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $b34b26d834178e56$var$_baseNew = $b34b26d834178e56$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $b34b26d834178e56$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LobbyBell".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: risks in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b34b26d834178e56$var$LobbyBellIcon = (props)=>/*#__PURE__*/ $b34b26d834178e56$var$_react.default.createElement($b34b26d834178e56$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 1h4v1.5H8.75v1.75h.92a4.75 4.75 0 0 1 4.72 4.225l.355 3.192A.75.75 0 0 1 14 12.5H2a.75.75 0 0 1-.745-.833l.354-3.192A4.75 4.75 0 0 1 6.33 4.25h.92V2.5H6zm.33 4.75A3.25 3.25 0 0 0 3.1 8.641L2.838 11h10.324L12.9 8.641A3.25 3.25 0 0 0 9.67 5.75zM15 13.5V15H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$b34b26d834178e56$var$LobbyBellIcon.displayName = 'LobbyBellIcon';
var $b34b26d834178e56$var$_default = module.exports.default = $b34b26d834178e56$var$LobbyBellIcon;

});

parcelRegister("ck1qR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b57d69a7e6f53846886bde82f36883e5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8f8876b0e978f062$var$_react = $8f8876b0e978f062$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $8f8876b0e978f062$var$_baseNew = $8f8876b0e978f062$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $8f8876b0e978f062$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "MagicWand".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8f8876b0e978f062$var$MagicWandIcon = (props)=>/*#__PURE__*/ $8f8876b0e978f062$var$_react.default.createElement($8f8876b0e978f062$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M9.027 3.911a1.376 1.376 0 0 1 1.841-.094l.105.094 1.116 1.116a1.376 1.376 0 0 1 0 1.946l-8.616 8.616a1.376 1.376 0 0 1-1.946 0L.411 14.473a1.376 1.376 0 0 1 0-1.946zM1.561 13.5l.939.94L7.938 9 7 8.061zm13.431-4.067-1.06 1.06-1.415-1.414 1.061-1.06zM8.061 7l.938.938L10.939 6l-.94-.94zM16 5v1.5h-2V5zM7.982 2.422l-1.06 1.06-1.414-1.414 1.06-1.06zm7.01-.354-1.414 1.414-1.06-1.06 1.414-1.414zM11 0v2H9.5V0z"/>`
    }, props));
$8f8876b0e978f062$var$MagicWandIcon.displayName = 'MagicWandIcon';
var $8f8876b0e978f062$var$_default = module.exports.default = $8f8876b0e978f062$var$MagicWandIcon;

});

parcelRegister("iBtIB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ed07350d21c7e2ad94ff4198361d506>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $037ec0f846817020$var$_react = $037ec0f846817020$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $037ec0f846817020$var$_baseNew = $037ec0f846817020$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $037ec0f846817020$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Marketplace".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Marketplace.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $037ec0f846817020$var$MarketplaceIcon = (props)=>/*#__PURE__*/ $037ec0f846817020$var$_react.default.createElement($037ec0f846817020$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.789 1.513A.75.75 0 0 1 2.5 1h11a.75.75 0 0 1 .711.513l1.502 4.5a.8.8 0 0 1 .038.237A3.08 3.08 0 0 1 14 9.032V13a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.031A3.08 3.08 0 0 1 .25 6.25q0-.12.038-.237zM3.5 9.329V13a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9.33a3.08 3.08 0 0 1-2.166-1.064A3.08 3.08 0 0 1 8 9.334a3.08 3.08 0 0 1-2.334-1.068A3.08 3.08 0 0 1 3.5 9.329M4.916 6.25v.03a1.584 1.584 0 0 1-3.163.08l.037-.11zm1.5.038.005-.038h3.158l.004.038a1.584 1.584 0 0 1-3.166 0M9.413 4.75H6.588l.25-2.25h2.324zm1.672 1.5a1.584 1.584 0 0 0 3.164.11l-.037-.11zm2.626-1.5h-2.788l-.25-2.25h2.288zM5.33 2.5l-.25 2.25H2.29l.75-2.25z" clip-rule="evenodd"/>`
    }, props));
$037ec0f846817020$var$MarketplaceIcon.displayName = 'MarketplaceIcon';
var $037ec0f846817020$var$_default = module.exports.default = $037ec0f846817020$var$MarketplaceIcon;

});

parcelRegister("cOWmd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c12e14f5c33454d538618fce8415497d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $95576c15b59f6f99$var$_react = $95576c15b59f6f99$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $95576c15b59f6f99$var$_baseNew = $95576c15b59f6f99$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $95576c15b59f6f99$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Megaphone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: feedback in products.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $95576c15b59f6f99$var$MegaphoneIcon = (props)=>/*#__PURE__*/ $95576c15b59f6f99$var$_react.default.createElement($95576c15b59f6f99$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.5 3.096a.5.5 0 0 0-.686-.464L7.5 4.758v4.734l5.314 2.126a.5.5 0 0 0 .686-.464zm-6 8.012 4.757 1.903A2 2 0 0 0 15 11.154V3.096a2 2 0 0 0-2.743-1.857L6.606 3.5H3a2 2 0 0 0-2 2v3.25a2 2 0 0 0 2 2h.5V13a2 2 0 0 0 2 2h1.25a.75.75 0 0 0 .75-.75zM6 9.25H3a.5.5 0 0 1-.5-.5V5.5A.5.5 0 0 1 3 5h3zm0 1.5v2.75h-.5A.5.5 0 0 1 5 13v-2.25z" clip-rule="evenodd"/>`
    }, props));
$95576c15b59f6f99$var$MegaphoneIcon.displayName = 'MegaphoneIcon';
var $95576c15b59f6f99$var$_default = module.exports.default = $95576c15b59f6f99$var$MegaphoneIcon;

});

parcelRegister("ax2O9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6209776ef69c56f26af2970fd840a919>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7aaf2a0eb695d083$var$_react = $7aaf2a0eb695d083$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $7aaf2a0eb695d083$var$_baseNew = $7aaf2a0eb695d083$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $7aaf2a0eb695d083$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Objective".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for objectives.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7aaf2a0eb695d083$var$ObjectiveIcon = (props)=>/*#__PURE__*/ $7aaf2a0eb695d083$var$_react.default.createElement($7aaf2a0eb695d083$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.422.02a.75.75 0 0 1 .54.493l.38 1.144 1.145.381a.75.75 0 0 1 .293 1.242l-2 2a.75.75 0 0 1-.53.22h-1.69L8.03 9.03 6.97 7.97l3.53-3.53V2.75a.75.75 0 0 1 .22-.53l2-2a.75.75 0 0 1 .702-.2M12 4h.94l.922-.922-.35-.116a.75.75 0 0 1-.473-.475l-.117-.349-.922.923zM8 1.5A6.5 6.5 0 1 0 14.5 8H16a8 8 0 1 1-8-8zM8 5a3 3 0 1 0 3 3h1.5A4.5 4.5 0 1 1 8 3.5z" clip-rule="evenodd"/>`
    }, props));
$7aaf2a0eb695d083$var$ObjectiveIcon.displayName = 'ObjectiveIcon';
var $7aaf2a0eb695d083$var$_default = module.exports.default = $7aaf2a0eb695d083$var$ObjectiveIcon;

});

parcelRegister("hz0ya", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::30e149500cf1a05a183dbc43511b361c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc9621c5d990e12c$var$_react = $cc9621c5d990e12c$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $cc9621c5d990e12c$var$_baseNew = $cc9621c5d990e12c$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $cc9621c5d990e12c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Operations".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for IT Operations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cc9621c5d990e12c$var$OperationsIcon = (props)=>/*#__PURE__*/ $cc9621c5d990e12c$var$_react.default.createElement($cc9621c5d990e12c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.036 2.904A6.501 6.501 0 1 0 8 14.5V16a8 8 0 1 1 5.657-13.657l.53.53L8.28 8.78 7.22 7.72l2.304-2.305A3.001 3.001 0 1 0 8 11v1.5a4.5 4.5 0 1 1 2.608-8.168z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M14.58 4.862a.75.75 0 0 1 .959.454l.008.025a.75.75 0 1 1-1.414.499l-.007-.02a.75.75 0 0 1 .454-.958m-2.798 2.573a.75.75 0 0 1 .713.786l-.001.015-.001.014a.75.75 0 1 1-1.498-.083v-.01l.001-.01a.75.75 0 0 1 .786-.712m3.497.184a.75.75 0 0 1 .71.787v.026a.75.75 0 1 1-1.498-.081V8.33a.75.75 0 0 1 .788-.711m-4.205 2.656a.75.75 0 0 1-.052 1.06l-.022.019a.75.75 0 1 1-1-1.118l.015-.013a.75.75 0 0 1 1.059.052m3.799.16a.75.75 0 0 1 .355.999l-.011.023a.75.75 0 0 1-1.353-.649l.01-.019a.75.75 0 0 1 .999-.355m-1.457 2.442a.75.75 0 0 1-.053 1.06l-.02.017a.75.75 0 0 1-1.001-1.117l.015-.014a.75.75 0 0 1 1.06.054m-2.278 1.703a.75.75 0 0 1-.454.959l-.025.008a.75.75 0 0 1-.499-1.414l.02-.007a.75.75 0 0 1 .958.454" clip-rule="evenodd"/>`
    }, props));
$cc9621c5d990e12c$var$OperationsIcon.displayName = 'OperationsIcon';
var $cc9621c5d990e12c$var$_default = module.exports.default = $cc9621c5d990e12c$var$OperationsIcon;

});

parcelRegister("5SjQD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aff4cd926156d74fe58acdf2d87dd6f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $44716444b1e41481$var$_react = $44716444b1e41481$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $44716444b1e41481$var$_baseNew = $44716444b1e41481$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $44716444b1e41481$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pages".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for multipe pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $44716444b1e41481$var$PagesIcon = (props)=>/*#__PURE__*/ $44716444b1e41481$var$_react.default.createElement($44716444b1e41481$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM4 4h6v1.5H4zm10.5 8.75V6H16v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75M4 7h4.5v1.5H4z" clip-rule="evenodd"/>`
    }, props));
$44716444b1e41481$var$PagesIcon.displayName = 'PagesIcon';
var $44716444b1e41481$var$_default = module.exports.default = $44716444b1e41481$var$PagesIcon;

});

parcelRegister("czSoI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a7c8caaba4b6537db98d2e63ce6d8f75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9282f322805ee7c4$var$_react = $9282f322805ee7c4$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $9282f322805ee7c4$var$_baseNew = $9282f322805ee7c4$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $9282f322805ee7c4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding a user to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9282f322805ee7c4$var$PersonAddIcon = (props)=>/*#__PURE__*/ $9282f322805ee7c4$var$_react.default.createElement($9282f322805ee7c4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M1 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m11.25 4.75V11h1.5V8.75H16v-1.5h-2.25V5h-1.5v2.25H10v1.5zm-8.5 1.75a2.25 2.25 0 0 0-2.25 2.25V15H0v-2.25A3.75 3.75 0 0 1 3.75 9h2.5A3.75 3.75 0 0 1 10 12.75V15H8.5v-2.25a2.25 2.25 0 0 0-2.25-2.25z" clip-rule="evenodd"/>`
    }, props));
$9282f322805ee7c4$var$PersonAddIcon.displayName = 'PersonAddIcon';
var $9282f322805ee7c4$var$_default = module.exports.default = $9282f322805ee7c4$var$PersonAddIcon;

});

parcelRegister("kvde0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c2b2be59784c9b52b8b3b5b23f53d5b2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eed0f61411f9d686$var$_react = $eed0f61411f9d686$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $eed0f61411f9d686$var$_baseNew = $eed0f61411f9d686$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $eed0f61411f9d686$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAdded".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for a user added to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eed0f61411f9d686$var$PersonAddedIcon = (props)=>/*#__PURE__*/ $eed0f61411f9d686$var$_react.default.createElement($eed0f61411f9d686$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M1 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m14.877 2.03-4 4a.75.75 0 0 1-1.051.01L8.98 8.262l1.04-1.08 1.316 1.267 3.48-3.48zM3.75 10.5a2.25 2.25 0 0 0-2.25 2.25V15H0v-2.25A3.75 3.75 0 0 1 3.75 9h2.52a3.75 3.75 0 0 1 3.75 3.75V15h-1.5v-2.25a2.25 2.25 0 0 0-2.25-2.25z" clip-rule="evenodd"/>`
    }, props));
$eed0f61411f9d686$var$PersonAddedIcon.displayName = 'PersonAddedIcon';
var $eed0f61411f9d686$var$_default = module.exports.default = $eed0f61411f9d686$var$PersonAddedIcon;

});

parcelRegister("7V9HC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b34e6857b52d4ec156a688609aa0810c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5c4561fcacc10609$var$_react = $5c4561fcacc10609$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $5c4561fcacc10609$var$_baseNew = $5c4561fcacc10609$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $5c4561fcacc10609$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Phone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: call us, phone number input.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5c4561fcacc10609$var$PhoneIcon = (props)=>/*#__PURE__*/ $5c4561fcacc10609$var$_react.default.createElement($5c4561fcacc10609$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1.75A.75.75 0 0 1 1.75 1h3.5a.75.75 0 0 1 .721.544l.821 2.874a1.75 1.75 0 0 1-.562 1.825L4.29 7.86c.975 1.55 2.3 2.875 3.85 3.85l1.617-1.94a1.75 1.75 0 0 1 1.825-.562l2.874.82a.75.75 0 0 1 .544.722v3.5a.75.75 0 0 1-.75.75c-2.266 0-4.422-.61-6.309-1.664a13.77 13.77 0 0 1-5.277-5.277A12.9 12.9 0 0 1 1 1.75m8.484 10.69c1.25.578 2.606.94 4.016 1.035v-2.16l-2.33-.665a.25.25 0 0 0-.26.08zM3.56 6.516 5.27 5.09a.25.25 0 0 0 .08-.261L4.684 2.5H2.525A11.4 11.4 0 0 0 3.56 6.516" clip-rule="evenodd"/>`
    }, props));
$5c4561fcacc10609$var$PhoneIcon.displayName = 'PhoneIcon';
var $5c4561fcacc10609$var$_default = module.exports.default = $5c4561fcacc10609$var$PhoneIcon;

});

parcelRegister("hA8Qq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::975f3556f302c98e53e9a5c512ff1020>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cccca8cfb09450cd$var$_react = $cccca8cfb09450cd$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $cccca8cfb09450cd$var$_baseNew = $cccca8cfb09450cd$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $cccca8cfb09450cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PresenterMode".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for presenter mode in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cccca8cfb09450cd$var$PresenterModeIcon = (props)=>/*#__PURE__*/ $cccca8cfb09450cd$var$_react.default.createElement($cccca8cfb09450cd$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.909 2.5a2.409 2.409 0 0 0-1.054 4.576l-.657 1.348a3.909 3.909 0 1 1 5.226-5.226l-1.348.657A2.41 2.41 0 0 0 4.909 2.5m-.19 2.22a.75.75 0 0 1 .786-.175l9 3.25a.75.75 0 0 1 .02 1.403l-3.822 1.505-1.505 3.822a.75.75 0 0 1-1.403-.02l-3.25-9a.75.75 0 0 1 .175-.785M6.5 6.498l2.032 5.628.896-2.276a.75.75 0 0 1 .423-.423l2.276-.896z" clip-rule="evenodd"/>`
    }, props));
$cccca8cfb09450cd$var$PresenterModeIcon.displayName = 'PresenterModeIcon';
var $cccca8cfb09450cd$var$_default = module.exports.default = $cccca8cfb09450cd$var$PresenterModeIcon;

});

parcelRegister("hBIcK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ff5f3689a11c3468e5139786a8e64251>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cd182e7734303b34$var$_react = $cd182e7734303b34$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $cd182e7734303b34$var$_baseNew = $cd182e7734303b34$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $cd182e7734303b34$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PriorityMajor".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for major work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cd182e7734303b34$var$PriorityMajorIcon = (props)=>/*#__PURE__*/ $cd182e7734303b34$var$_react.default.createElement($cd182e7734303b34$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.913 4.75-5.5-3.625a.75.75 0 0 0-.826 0l-5.5 3.625L2.913 6 8 2.65 13.087 6zm0 4.5-5.5-3.625a.75.75 0 0 0-.826 0l-5.5 3.625.826 1.252L8 7.149l5.087 3.353zm0 4.5-5.5-3.626a.75.75 0 0 0-.826 0l-5.5 3.625.826 1.252L8 11.65l5.087 3.353z"/>`
    }, props));
$cd182e7734303b34$var$PriorityMajorIcon.displayName = 'PriorityMajorIcon';
var $cd182e7734303b34$var$_default = module.exports.default = $cd182e7734303b34$var$PriorityMajorIcon;

});

parcelRegister("7doBf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dc58ff4eb916aa4715fd29d4da19740a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $540cd44dc8e6039e$var$_react = $540cd44dc8e6039e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $540cd44dc8e6039e$var$_baseNew = $540cd44dc8e6039e$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $540cd44dc8e6039e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Project".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for projects in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $540cd44dc8e6039e$var$ProjectIcon = (props)=>/*#__PURE__*/ $540cd44dc8e6039e$var$_react.default.createElement($540cd44dc8e6039e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.5 3a.5.5 0 0 0-.5-.5h-2.482a.5.5 0 0 0-.354.146L7.78 5.03a.75.75 0 0 1-.53.22H3.018a.5.5 0 0 0-.354.146l-.353.354 1.72 1.72a.75.75 0 0 1 0 1.06l-2.25 2.25L.72 9.72 2.44 8 .72 6.28a.75.75 0 0 1 0-1.06l.884-.884a2 2 0 0 1 1.414-.586h3.921l2.165-2.164A2 2 0 0 1 10.518 1H13a2 2 0 0 1 2 2v2.482a2 2 0 0 1-.586 1.414L12.25 9.061v3.921a2 2 0 0 1-.586 1.415l-.884.883a.75.75 0 0 1-1.06 0L8 13.56l-1.72 1.72-1.06-1.06 2.25-2.25a.75.75 0 0 1 1.06 0l1.72 1.72.354-.354a.5.5 0 0 0 .146-.354V8.75a.75.75 0 0 1 .22-.53l2.384-2.384a.5.5 0 0 0 .146-.354zm-6.72 7.28-5 5-1.06-1.06 5-5z" clip-rule="evenodd"/><path fill="currentcolor" d="M12.5 4.625a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"/>`
    }, props));
$540cd44dc8e6039e$var$ProjectIcon.displayName = 'ProjectIcon';
var $540cd44dc8e6039e$var$_default = module.exports.default = $540cd44dc8e6039e$var$ProjectIcon;

});

parcelRegister("qz5Fw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1698552166bfef93121ec02f2fff1081>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $04fda60d28122c84$var$_react = $04fda60d28122c84$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $04fda60d28122c84$var$_baseNew = $04fda60d28122c84$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $04fda60d28122c84$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Screen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: assets in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $04fda60d28122c84$var$ScreenIcon = (props)=>/*#__PURE__*/ $04fda60d28122c84$var$_react.default.createElement($04fda60d28122c84$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H8.75v1.5H12V15H4v-1.5h3.25V12H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$04fda60d28122c84$var$ScreenIcon.displayName = 'ScreenIcon';
var $04fda60d28122c84$var$_default = module.exports.default = $04fda60d28122c84$var$ScreenIcon;

});

parcelRegister("3w1ji", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::02df73cd5dddff20d82e48f58fe7ce92>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $28f5606a9a13cc58$var$_react = $28f5606a9a13cc58$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $28f5606a9a13cc58$var$_baseNew = $28f5606a9a13cc58$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $28f5606a9a13cc58$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus, traditionally on mobile.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $28f5606a9a13cc58$var$ShowMoreVerticalIcon = (props)=>/*#__PURE__*/ $28f5606a9a13cc58$var$_react.default.createElement($28f5606a9a13cc58$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.5 1.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$28f5606a9a13cc58$var$ShowMoreVerticalIcon.displayName = 'ShowMoreVerticalIcon';
var $28f5606a9a13cc58$var$_default = module.exports.default = $28f5606a9a13cc58$var$ShowMoreVerticalIcon;

});

parcelRegister("fq25Q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d0cf5658da3b79d5f876ad9c272a691a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b39ae860c380c09c$var$_react = $b39ae860c380c09c$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $b39ae860c380c09c$var$_baseNew = $b39ae860c380c09c$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $b39ae860c380c09c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLinkList".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing Smart link embedded link lists.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b39ae860c380c09c$var$SmartLinkListIcon = (props)=>/*#__PURE__*/ $b39ae860c380c09c$var$_react.default.createElement($b39ae860c380c09c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm2.5 3H4V4h1.5zm6.5 0H7V4h5zM5.5 8.75H4v-1.5h1.5zm6.5 0H7v-1.5h5zM5.5 12H4v-1.5h1.5zm6.5 0H7v-1.5h5z" clip-rule="evenodd"/>`
    }, props));
$b39ae860c380c09c$var$SmartLinkListIcon.displayName = 'SmartLinkListIcon';
var $b39ae860c380c09c$var$_default = module.exports.default = $b39ae860c380c09c$var$SmartLinkListIcon;

});

parcelRegister("8GlZZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::350d68f25c9b4e9b7a6f8128f373fbcc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65234f7ca62870d2$var$_react = $65234f7ca62870d2$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $65234f7ca62870d2$var$_baseNew = $65234f7ca62870d2$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $65234f7ca62870d2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TaskInProgress".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for in progress task status. Used in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $65234f7ca62870d2$var$TaskInProgressIcon = (props)=>/*#__PURE__*/ $65234f7ca62870d2$var$_react.default.createElement($65234f7ca62870d2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.543 7.25h7.646L6.97 5.03l1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H1.542a6.501 6.501 0 1 0 0-1.5M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8" clip-rule="evenodd"/>`
    }, props));
$65234f7ca62870d2$var$TaskInProgressIcon.displayName = 'TaskInProgressIcon';
var $65234f7ca62870d2$var$_default = module.exports.default = $65234f7ca62870d2$var$TaskInProgressIcon;

});

parcelRegister("aUEBX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7de7c2be3f7c9d9cc79e629bb0768f3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f1ea2e2c453dc33$var$_react = $7f1ea2e2c453dc33$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $7f1ea2e2c453dc33$var$_baseNew = $7f1ea2e2c453dc33$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $7f1ea2e2c453dc33$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Timeline".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for timelines in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7f1ea2e2c453dc33$var$TimelineIcon = (props)=>/*#__PURE__*/ $7f1ea2e2c453dc33$var$_react.default.createElement($7f1ea2e2c453dc33$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11 2.5H1V1h10zm4 4.167H5v-1.5h10zm-4 4.167H1v-1.5h10zM15 15H5v-1.5h10z" clip-rule="evenodd"/>`
    }, props));
$7f1ea2e2c453dc33$var$TimelineIcon.displayName = 'TimelineIcon';
var $7f1ea2e2c453dc33$var$_default = module.exports.default = $7f1ea2e2c453dc33$var$TimelineIcon;

});

parcelRegister("9ih0P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b20915105f9f06f3ef89ee9497af0ea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6c42fdd1b032760e$var$_react = $6c42fdd1b032760e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6c42fdd1b032760e$var$_baseNew = $6c42fdd1b032760e$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $6c42fdd1b032760e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Transition".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for transitions in Analytics.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6c42fdd1b032760e$var$TransitionIcon = (props)=>/*#__PURE__*/ $6c42fdd1b032760e$var$_react.default.createElement($6c42fdd1b032760e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.75 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.122 0a2.251 2.251 0 1 1 0 1.5h-.816c-.586 0-1.062.476-1.062 1.063v5.875A2.563 2.563 0 0 1 6.188 13.5h-.816a2.25 2.25 0 1 1 0-1.5h.816c.586 0 1.062-.476 1.062-1.062V5.062A2.56 2.56 0 0 1 9.813 2.5zM3.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$6c42fdd1b032760e$var$TransitionIcon.displayName = 'TransitionIcon';
var $6c42fdd1b032760e$var$_default = module.exports.default = $6c42fdd1b032760e$var$TransitionIcon;

});

parcelRegister("djIg7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c615014b011664b243a37531e093f861>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9b1f619c052c2afa$var$_react = $9b1f619c052c2afa$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $9b1f619c052c2afa$var$_baseNew = $9b1f619c052c2afa$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $9b1f619c052c2afa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Warning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9b1f619c052c2afa$var$WarningIcon = (props)=>/*#__PURE__*/ $9b1f619c052c2afa$var$_react.default.createElement($9b1f619c052c2afa$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.169c.757-1.396 2.76-1.396 3.516 0l5.9 10.878C16.381 13.379 15.416 15 13.9 15H2.1C.584 15-.38 13.38.342 12.047zM7.25 9.5v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$9b1f619c052c2afa$var$WarningIcon.displayName = 'WarningIcon';
var $9b1f619c052c2afa$var$_default = module.exports.default = $9b1f619c052c2afa$var$WarningIcon;

});

parcelRegister("l7rtf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fa0a7a20e9878c1f12b50feba4970dc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f5ff8f8dc5479751$var$_react = $f5ff8f8dc5479751$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f5ff8f8dc5479751$var$_baseNew = $f5ff8f8dc5479751$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $f5ff8f8dc5479751$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItems".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing multiple work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f5ff8f8dc5479751$var$WorkItemsIcon = (props)=>/*#__PURE__*/ $f5ff8f8dc5479751$var$_react.default.createElement($f5ff8f8dc5479751$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.5 4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5zM9.448 5.608l-3.167 3.75a.75.75 0 0 1-1.09.061l-.055-.06-1.584-1.876 1.146-.966 1.01 1.196 2.594-3.071zM13 10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2z"/><path fill="currentcolor" d="M14.5 11.75V7H16v4.75A3.25 3.25 0 0 1 12.75 15H5v-1.5h7.75a1.75 1.75 0 0 0 1.75-1.75"/>`
    }, props));
$f5ff8f8dc5479751$var$WorkItemsIcon.displayName = 'WorkItemsIcon';
var $f5ff8f8dc5479751$var$_default = module.exports.default = $f5ff8f8dc5479751$var$WorkItemsIcon;

});

parcelRegister("1eGzb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a128432aba3d4deb725c4d0760aebb99>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e681e0e9ec5f2ef$var$_react = $0e681e0e9ec5f2ef$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $0e681e0e9ec5f2ef$var$_baseNew = $0e681e0e9ec5f2ef$var$_interopRequireDefault((parcelRequire("jcI35")));
function $0e681e0e9ec5f2ef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsGraph".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing Assets graph
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0e681e0e9ec5f2ef$var$AssetsGraphIcon = (props)=>/*#__PURE__*/ $0e681e0e9ec5f2ef$var$_react.default.createElement($0e681e0e9ec5f2ef$var$_baseNew.default, Object.assign({
        name: "AssetsGraphIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m12.78 4.28-1.833 1.832a3.5 3.5 0 0 1 0 3.775l1.833 1.833-1.06 1.06-1.833-1.833a3.5 3.5 0 0 1-3.775 0L4.28 12.78l-1.06-1.06 1.832-1.833a3.5 3.5 0 0 1 0-3.775L3.22 4.28l1.06-1.06 1.832 1.832a3.5 3.5 0 0 1 3.775 0L11.72 3.22zM9.414 6.586a2 2 0 1 0-2.828 2.828 2 2 0 0 0 2.828-2.828"/><path fill="currentcolor" d="M11.73.73a2.5 2.5 0 1 1 3.54 3.54A2.5 2.5 0 0 1 11.73.73m2.48 1.06A1 1 0 1 0 12.8 3.2a1 1 0 0 0 1.41-1.41m-2.48 9.94a2.5 2.5 0 1 1 3.54 3.53 2.5 2.5 0 0 1-3.54-3.53m2.48 1.06a1 1 0 1 0-1.41 1.41 1 1 0 0 0 1.41-1.41M.73.73a2.5 2.5 0 1 1 3.54 3.54A2.5 2.5 0 0 1 .73.73m2.48 1.06A1 1 0 1 0 1.8 3.2a1 1 0 0 0 1.41-1.41M.73 11.73a2.5 2.5 0 1 1 3.54 3.53 2.5 2.5 0 0 1-3.54-3.53m2.48 1.06A1 1 0 1 0 1.8 14.2a1 1 0 0 0 1.41-1.41"/>`
    }, props));
$0e681e0e9ec5f2ef$var$AssetsGraphIcon.displayName = 'AssetsGraphIcon';
var $0e681e0e9ec5f2ef$var$_default = module.exports.default = $0e681e0e9ec5f2ef$var$AssetsGraphIcon;

});

parcelRegister("k2zyM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9d288013ed94ec7ddbe1bb143e39a4fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e96f93ff829ead8b$var$_react = $e96f93ff829ead8b$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $e96f93ff829ead8b$var$_baseNew = $e96f93ff829ead8b$var$_interopRequireDefault((parcelRequire("jcI35")));
function $e96f93ff829ead8b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BrowserExtension".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for chrome extensions
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e96f93ff829ead8b$var$BrowserExtensionIcon = (props)=>/*#__PURE__*/ $e96f93ff829ead8b$var$_react.default.createElement($e96f93ff829ead8b$var$_baseNew.default, Object.assign({
        name: "BrowserExtensionIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.25 2v.5h2.25a2 2 0 0 1 2 2v2.25h.5a2 2 0 1 1 0 4h-.5V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2.25a.75.75 0 0 1 .75-.75h.5a1.25 1.25 0 1 0 0-2.5h-.5A.75.75 0 0 1 1 6.75V4.5a2 2 0 0 1 2-2h2.25V2a2 2 0 1 1 4 0M2.5 4.5A.5.5 0 0 1 3 4h8.5a.5.5 0 0 1 .5.5V13a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-1.511a2.75 2.75 0 0 0 0-5.478z" clip-rule="evenodd"/>`
    }, props));
$e96f93ff829ead8b$var$BrowserExtensionIcon.displayName = 'BrowserExtensionIcon';
var $e96f93ff829ead8b$var$_default = module.exports.default = $e96f93ff829ead8b$var$BrowserExtensionIcon;

});

parcelRegister("2GO8b", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b5a64a2ca9b8ddc91e264b2e4d54e26>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1f5663fd08175dde$var$_react = $1f5663fd08175dde$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $1f5663fd08175dde$var$_baseNew = $1f5663fd08175dde$var$_interopRequireDefault((parcelRequire("jcI35")));
function $1f5663fd08175dde$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notepad".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Whiteboard component 'card'
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1f5663fd08175dde$var$NotepadIcon = (props)=>/*#__PURE__*/ $1f5663fd08175dde$var$_react.default.createElement($1f5663fd08175dde$var$_baseNew.default, Object.assign({
        name: "NotepadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 1V0h1.5v1h1.75V0h1.5v1h1.75V0H12v1h1a2 2 0 0 1 2 2v7.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 16H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h6v-3.75a.75.75 0 0 1 .75-.75h3.75V3a.5.5 0 0 0-.5-.5h-1v2h-1.5v-2H8.75v2h-1.5v-2H5.5v2H4zm8.94 9H10.5v2.44zM12 8H4V6.5h8zm-5 2v1.5H4V10z" clip-rule="evenodd"/>`
    }, props));
$1f5663fd08175dde$var$NotepadIcon.displayName = 'NotepadIcon';
var $1f5663fd08175dde$var$_default = module.exports.default = $1f5663fd08175dde$var$NotepadIcon;

});

parcelRegister("8BlKa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b7be9690353c7bf82b96c9a0cc89ae3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6432a540254daa54$var$_react = $6432a540254daa54$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6432a540254daa54$var$_baseNew = $6432a540254daa54$var$_interopRequireDefault((parcelRequire("jcI35")));
function $6432a540254daa54$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "RoadmapsPlan".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing plans.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6432a540254daa54$var$RoadmapsPlanIcon = (props)=>/*#__PURE__*/ $6432a540254daa54$var$_react.default.createElement($6432a540254daa54$var$_baseNew.default, Object.assign({
        name: "RoadmapsPlanIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.5 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M1 3.5a2.5 2.5 0 0 1 4.886-.75h4.864a3 3 0 1 1 0 6h-5.5a1.5 1.5 0 1 0 0 3h4.865a2.501 2.501 0 1 1 0 1.5H5.25a3 3 0 1 1 0-6h5.5a1.5 1.5 0 0 0 0-3H5.886A2.501 2.501 0 0 1 1 3.5m11.5 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$6432a540254daa54$var$RoadmapsPlanIcon.displayName = 'RoadmapsPlanIcon';
var $6432a540254daa54$var$_default = module.exports.default = $6432a540254daa54$var$RoadmapsPlanIcon;

});

parcelRegister("lUMmm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a463dbdb96f5dd0cff6dca797202b246>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ff445725fe4e8cde$var$_react = $ff445725fe4e8cde$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $ff445725fe4e8cde$var$_baseNew = $ff445725fe4e8cde$var$_interopRequireDefault((parcelRequire("jcI35")));
function $ff445725fe4e8cde$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Rovo".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing Rovo
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ff445725fe4e8cde$var$RovoIcon = (props)=>/*#__PURE__*/ $ff445725fe4e8cde$var$_react.default.createElement($ff445725fe4e8cde$var$_baseNew.default, Object.assign({
        name: "RovoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.687.64a2.63 2.63 0 0 1 2.625 0l4.404 2.544a2.63 2.63 0 0 1 1.313 2.273v5.084c0 .938-.5 1.804-1.313 2.274l-4.404 2.542a2.63 2.63 0 0 1-2.625 0l-4.403-2.542A2.63 2.63 0 0 1 .97 10.54V5.457c0-.938.5-1.804 1.313-2.273zM3.034 4.483a1.13 1.13 0 0 0-.563.975v5.084c0 .402.215.774.563.975l4.403 2.543c.348.2.777.2 1.125 0l.688-.398v-1.997L5.896 9.568a1.38 1.38 0 0 1-.646-1.166V3.203zM8.562 1.94a1.13 1.13 0 0 0-1.125 0l-.687.398v1.996l3.354 2.097c.402.251.646.692.646 1.166v5.199l2.216-1.28c.348-.2.563-.572.563-.974V5.457c0-.402-.215-.774-.563-.975zM6.75 8.333l2.5 1.563V7.663l-2.5-1.561z" clip-rule="evenodd"/>`
    }, props));
$ff445725fe4e8cde$var$RovoIcon.displayName = 'RovoIcon';
var $ff445725fe4e8cde$var$_default = module.exports.default = $ff445725fe4e8cde$var$RovoIcon;

});

parcelRegister("6xXDI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::840e9064aa0761adacec2a7ce2dee628>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4c441650e47ff0d3$var$_react = $4c441650e47ff0d3$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $4c441650e47ff0d3$var$_baseNew = $4c441650e47ff0d3$var$_interopRequireDefault((parcelRequire("jcI35")));
function $4c441650e47ff0d3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sync".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for syncing changes and save operations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4c441650e47ff0d3$var$SyncIcon = (props)=>/*#__PURE__*/ $4c441650e47ff0d3$var$_react.default.createElement($4c441650e47ff0d3$var$_baseNew.default, Object.assign({
        name: "SyncIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 .5h4.25a.75.75 0 0 1 .75.75V5.5H5.5V2.941a9 9 0 0 0-1.094.916C3.42 4.83 2.5 6.214 2.5 8c0 1.813.817 3.18 1.871 4.11 1.079.95 2.346 1.39 3.129 1.39V15c-1.217 0-2.825-.623-4.121-1.765C2.058 12.07 1 10.312 1 8c0-2.339 1.21-4.084 2.354-5.211.308-.304.615-.567.9-.789H2zm10.621 2.266C13.942 3.93 15 5.688 15 8c0 2.338-1.204 4.079-2.344 5.201-.304.3-.607.56-.889.78H14v1.5H9.75a.75.75 0 0 1-.75-.75v-4.25h1.5v2.573a9 9 0 0 0 1.104-.921C12.584 11.166 13.5 9.787 13.5 8c0-1.813-.817-3.18-1.871-4.11C10.551 2.94 9.283 2.5 8.5 2.5V1c1.217 0 2.825.623 4.121 1.766" clip-rule="evenodd"/>`
    }, props));
$4c441650e47ff0d3$var$SyncIcon.displayName = 'SyncIcon';
var $4c441650e47ff0d3$var$_default = module.exports.default = $4c441650e47ff0d3$var$SyncIcon;

});

parcelRegister("f1MsQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6dad959d4748daed02c67a782b9b76e4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af0c8afa9834d472$var$_react = $af0c8afa9834d472$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $af0c8afa9834d472$var$_baseNew = $af0c8afa9834d472$var$_interopRequireDefault((parcelRequire("jcI35")));
function $af0c8afa9834d472$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextAudioTranscript".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for viewing transcript in Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af0c8afa9834d472$var$TextAudioTranscriptIcon = (props)=>/*#__PURE__*/ $af0c8afa9834d472$var$_react.default.createElement($af0c8afa9834d472$var$_baseNew.default, Object.assign({
        name: "TextAudioTranscriptIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 0H2v1.5h14zM6 5.105C6 4.315 5.418 3.5 4.5 3.5S3 4.314 3 5.105v3.29C3 9.185 3.582 10 4.5 10S6 9.186 6 8.395zm10-.939H8.959v1.5H16zm0 4.167h-5v1.5h5zm-8.5.062v.073c0 1.699-1.328 3.052-3 3.052s-3-1.353-3-3.052v-.073H0v.073c0 2.247 1.593 4.131 3.75 4.49V14.5H1.5V16h6v-1.5H5.25v-1.542C7.407 12.6 9 10.715 9 8.468v-.073zm8.5 4.104h-5v1.5h5z" clip-rule="evenodd"/>`
    }, props));
$af0c8afa9834d472$var$TextAudioTranscriptIcon.displayName = 'TextAudioTranscriptIcon';
var $af0c8afa9834d472$var$_default = module.exports.default = $af0c8afa9834d472$var$TextAudioTranscriptIcon;

});

parcelRegister("5nJnO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5412db8dd6dbd639e997b10aa14b104a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3eb24de21519b485$var$_react = $3eb24de21519b485$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $3eb24de21519b485$var$_baseNew = $3eb24de21519b485$var$_interopRequireDefault((parcelRequire("jcI35")));
function $3eb24de21519b485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Views".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing saved views.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3eb24de21519b485$var$ViewsIcon = (props)=>/*#__PURE__*/ $3eb24de21519b485$var$_react.default.createElement($3eb24de21519b485$var$_baseNew.default, Object.assign({
        name: "ViewsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.5 5.5H6v6h5a.5.5 0 0 0 .5-.5zm-9 5.5a.5.5 0 0 0 .5.5h1.5v-6h-2zm9-8a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v1h9zm1.5 8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2z"/><path fill="currentcolor" d="M14.5 12.75V6H16v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75"/>`
    }, props));
$3eb24de21519b485$var$ViewsIcon.displayName = 'ViewsIcon';
var $3eb24de21519b485$var$_default = module.exports.default = $3eb24de21519b485$var$ViewsIcon;

});


parcelRegister("evmye", function(module, exports) {
$parcel$export(module.exports, "Provider", function () { return (parcelRequire("5huaA")).default; });
$parcel$export(module.exports, "useDispatch", function () { return (parcelRequire("ljd5i")).useDispatch; });
$parcel$export(module.exports, "useSelector", function () { return (parcelRequire("jjx9d")).useSelector; });
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $ixLXc = parcelRequire("ixLXc");

var $KrnvM = parcelRequire("KrnvM");
parcelRequire("dfFgi");
var $gUjjH = parcelRequire("gUjjH");

var $3YZxS = parcelRequire("3YZxS");

var $jjx9d = parcelRequire("jjx9d");

var $k4dLS = parcelRequire("k4dLS");
parcelRequire("aZyKU");
(0, $jjx9d.initializeUseSelector)((0, $KrnvM.useSyncExternalStoreWithSelector));
(0, $k4dLS.initializeConnect)((0, $ixLXc.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $3YZxS.setBatch)((0, $gUjjH.unstable_batchedUpdates));

});
parcelRegister("dfFgi", function(module, exports) {
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return (parcelRequire("gUjjH")).unstable_batchedUpdates; });

var $gUjjH = parcelRequire("gUjjH");

});

parcelRegister("3YZxS", function(module, exports) {
$parcel$export(module.exports, "setBatch", function () { return $2e66b756d4258c8a$export$4b9874722d0da7bc; });
$parcel$export(module.exports, "getBatch", function () { return $2e66b756d4258c8a$export$fc47d4c0ba3bd2c6; });
// Default to a dummy "batch" implementation that just runs the callback
function $2e66b756d4258c8a$var$defaultNoopBatch(callback) {
    callback();
}
let $2e66b756d4258c8a$var$batch = $2e66b756d4258c8a$var$defaultNoopBatch; // Allow injecting another batching function later
const $2e66b756d4258c8a$export$4b9874722d0da7bc = (newBatch)=>$2e66b756d4258c8a$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $2e66b756d4258c8a$export$fc47d4c0ba3bd2c6 = ()=>$2e66b756d4258c8a$var$batch;

});

parcelRegister("jjx9d", function(module, exports) {
$parcel$export(module.exports, "initializeUseSelector", function () { return $e0f981148329114b$export$e2e6e3f3f3b782e3; });
$parcel$export(module.exports, "useSelector", function () { return $e0f981148329114b$export$2105062e25df4afe; });

var $1oC0p = parcelRequire("1oC0p");

var $dqXUQ = parcelRequire("dqXUQ");

var $6llk2 = parcelRequire("6llk2");

var $hJtym = parcelRequire("hJtym");
let $e0f981148329114b$var$useSyncExternalStoreWithSelector = (0, $hJtym.notInitialized);
const $e0f981148329114b$export$e2e6e3f3f3b782e3 = (fn)=>{
    $e0f981148329114b$var$useSyncExternalStoreWithSelector = fn;
};
const $e0f981148329114b$var$refEquality = (a, b)=>a === b;
function $e0f981148329114b$export$2b53f90d2bd1cbfb(context = (0, $6llk2.ReactReduxContext)) {
    const useReduxContext = context === (0, $6llk2.ReactReduxContext) ? (0, $dqXUQ.useReduxContext) : (0, $dqXUQ.createReduxContextHook)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $e0f981148329114b$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === 'function' ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $1oC0p.useRef)(true);
        const wrappedSelector = (0, $1oC0p.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $e0f981148329114b$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $1oC0p.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $e0f981148329114b$export$2105062e25df4afe = /*#__PURE__*/ $e0f981148329114b$export$2b53f90d2bd1cbfb();

});
parcelRegister("dqXUQ", function(module, exports) {
$parcel$export(module.exports, "createReduxContextHook", function () { return $9c7c2e159092eda4$export$d4d6226d5fc61558; });
$parcel$export(module.exports, "useReduxContext", function () { return $9c7c2e159092eda4$export$c1275ca9a6fd3ec5; });

var $1oC0p = parcelRequire("1oC0p");

var $6llk2 = parcelRequire("6llk2");
function $9c7c2e159092eda4$export$d4d6226d5fc61558(context = (0, $6llk2.ReactReduxContext)) {
    return function useReduxContext() {
        const contextValue = (0, $1oC0p.useContext)(context);
        return contextValue;
    };
}
const $9c7c2e159092eda4$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $9c7c2e159092eda4$export$d4d6226d5fc61558();

});
parcelRegister("6llk2", function(module, exports) {
$parcel$export(module.exports, "ReactReduxContext", function () { return $49e53e5d370fc464$export$cc80c08dc91f1c00; });

var $1oC0p = parcelRequire("1oC0p");
const $49e53e5d370fc464$var$ContextKey = Symbol.for(`react-redux-context`);
const $49e53e5d370fc464$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $49e53e5d370fc464$var$getContext() {
    var _gT$ContextKey;
    if (!$1oC0p.createContext) return {};
    const contextMap = (_gT$ContextKey = $49e53e5d370fc464$var$gT[$49e53e5d370fc464$var$ContextKey]) != null ? _gT$ContextKey : $49e53e5d370fc464$var$gT[$49e53e5d370fc464$var$ContextKey] = new Map();
    let realContext = contextMap.get($1oC0p.createContext);
    if (!realContext) {
        realContext = $1oC0p.createContext(null);
        contextMap.set($1oC0p.createContext, realContext);
    }
    return realContext;
}
const $49e53e5d370fc464$export$cc80c08dc91f1c00 = /*#__PURE__*/ $49e53e5d370fc464$var$getContext();
var $49e53e5d370fc464$export$2e2bcd8739ae039 = $49e53e5d370fc464$export$cc80c08dc91f1c00;

});


parcelRegister("hJtym", function(module, exports) {
$parcel$export(module.exports, "notInitialized", function () { return $ce8d904e7b5f1467$export$20656a4825650bd0; });
const $ce8d904e7b5f1467$export$20656a4825650bd0 = ()=>{
    throw new Error('uSES not initialized!');
};

});


parcelRegister("k4dLS", function(module, exports) {
$parcel$export(module.exports, "initializeConnect", function () { return $e9bedd0684062466$export$36d45daa6a4925b8; });

var $c9bqK = parcelRequire("c9bqK");

var $5BpLM = parcelRequire("5BpLM");

var $6PuZm = parcelRequire("6PuZm");

var $1oC0p = parcelRequire("1oC0p");

var $i98sK = parcelRequire("i98sK");

var $jUj8J = parcelRequire("jUj8J");

var $2SNac = parcelRequire("2SNac");

var $9Vog3 = parcelRequire("9Vog3");

var $asxdX = parcelRequire("asxdX");

var $1iuz7 = parcelRequire("1iuz7");

var $iQ6YZ = parcelRequire("iQ6YZ");

var $7yj9S = parcelRequire("7yj9S");
parcelRequire("7PpWx");

var $6llk2 = parcelRequire("6llk2");

var $hJtym = parcelRequire("hJtym");
const $e9bedd0684062466$var$_excluded = [
    "reactReduxForwardedRef"
];
let $e9bedd0684062466$var$useSyncExternalStore = (0, $hJtym.notInitialized);
const $e9bedd0684062466$export$36d45daa6a4925b8 = (fn)=>{
    $e9bedd0684062466$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $e9bedd0684062466$var$EMPTY_ARRAY = [
    null,
    0
];
const $e9bedd0684062466$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $e9bedd0684062466$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $e9bedd0684062466$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $iQ6YZ.useIsomorphicLayoutEffect)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $e9bedd0684062466$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $e9bedd0684062466$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $e9bedd0684062466$var$initStateUpdates = ()=>$e9bedd0684062466$var$EMPTY_ARRAY;
function $e9bedd0684062466$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $e9bedd0684062466$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $e9bedd0684062466$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $e9bedd0684062466$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $7yj9S.default), areStatePropsEqual: areStatePropsEqual = (0, $7yj9S.default), areMergedPropsEqual: areMergedPropsEqual = (0, $7yj9S.default), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $6llk2.ReactReduxContext) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $9Vog3.mapStateToPropsFactory)(mapStateToProps);
    const initMapDispatchToProps = (0, $2SNac.mapDispatchToPropsFactory)(mapDispatchToProps);
    const initMergeProps = (0, $asxdX.mergePropsFactory)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $1oC0p.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $5BpLM.default)(props, $e9bedd0684062466$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $1oC0p.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $i98sK.isContextConsumer)(/*#__PURE__*/ $1oC0p.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $1oC0p.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $1oC0p.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $jUj8J.default)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $1oC0p.useMemo(()=>{
                if (!shouldHandleStateChanges) return $e9bedd0684062466$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $1iuz7.createSubscription)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $1oC0p.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $c9bqK.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $1oC0p.useRef();
            const lastWrapperProps = $1oC0p.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $1oC0p.useRef();
            const renderIsScheduled = $1oC0p.useRef(false);
            const isProcessingDispatch = $1oC0p.useRef(false);
            const isMounted = $1oC0p.useRef(false);
            const latestSubscriptionCallbackError = $1oC0p.useRef();
            (0, $iQ6YZ.useIsomorphicLayoutEffect)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $1oC0p.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $1oC0p.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $e9bedd0684062466$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $e9bedd0684062466$var$useIsomorphicLayoutEffectWithArgs($e9bedd0684062466$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $e9bedd0684062466$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $iQ6YZ.useIsomorphicLayoutEffect)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $1oC0p.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $1oC0p.createElement(WrappedComponent, (0, $c9bqK.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $1oC0p.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $1oC0p.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $1oC0p.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $1oC0p.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $1oC0p.createElement(Connect, (0, $c9bqK.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($6PuZm)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($6PuZm)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $e9bedd0684062466$export$2e2bcd8739ae039 = $e9bedd0684062466$var$connect;

});
parcelRegister("i98sK", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jT1Rh"));

});
parcelRegister("jT1Rh", function(module, exports) {
$parcel$export(module.exports, "ContextConsumer", function () { return $e7a49864e45a9be5$export$a7c73072b1a182ae; }, function (v) { return $e7a49864e45a9be5$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $e7a49864e45a9be5$export$9f27bc3417b4524d; }, function (v) { return $e7a49864e45a9be5$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $e7a49864e45a9be5$export$db77ccec0bb4ccac; }, function (v) { return $e7a49864e45a9be5$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $e7a49864e45a9be5$export$8392c0c9d3dcbd35; }, function (v) { return $e7a49864e45a9be5$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $e7a49864e45a9be5$export$ffb0004e005737fa; }, function (v) { return $e7a49864e45a9be5$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $e7a49864e45a9be5$export$b624eff549462981; }, function (v) { return $e7a49864e45a9be5$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $e7a49864e45a9be5$export$7897aa7841a5380c; }, function (v) { return $e7a49864e45a9be5$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $e7a49864e45a9be5$export$602eac185826482c; }, function (v) { return $e7a49864e45a9be5$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $e7a49864e45a9be5$export$e2c29f18771995cb; }, function (v) { return $e7a49864e45a9be5$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $e7a49864e45a9be5$export$5f8d39834fd61797; }, function (v) { return $e7a49864e45a9be5$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $e7a49864e45a9be5$export$74bf444e3cd11ea5; }, function (v) { return $e7a49864e45a9be5$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $e7a49864e45a9be5$export$998bcd577473dd93; }, function (v) { return $e7a49864e45a9be5$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $e7a49864e45a9be5$export$92387174baf9b227; }, function (v) { return $e7a49864e45a9be5$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $e7a49864e45a9be5$export$ec112efeb987d9c6; }, function (v) { return $e7a49864e45a9be5$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $e7a49864e45a9be5$export$b706b080d889d2c9; }, function (v) { return $e7a49864e45a9be5$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $e7a49864e45a9be5$export$5be5a87408f70ddc; }, function (v) { return $e7a49864e45a9be5$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $e7a49864e45a9be5$export$45a5e7f76e0caa8d; }, function (v) { return $e7a49864e45a9be5$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $e7a49864e45a9be5$export$455c2e768291efa6; }, function (v) { return $e7a49864e45a9be5$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $e7a49864e45a9be5$export$9522e17588c12572; }, function (v) { return $e7a49864e45a9be5$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $e7a49864e45a9be5$export$2110ac352bb060b9; }, function (v) { return $e7a49864e45a9be5$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $e7a49864e45a9be5$export$56885ab8b9c456ab; }, function (v) { return $e7a49864e45a9be5$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $e7a49864e45a9be5$export$d927fcb6adf8f9de; }, function (v) { return $e7a49864e45a9be5$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $e7a49864e45a9be5$export$b82d16f27459e05a; }, function (v) { return $e7a49864e45a9be5$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $e7a49864e45a9be5$export$522c17b4f5e123e8; }, function (v) { return $e7a49864e45a9be5$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $e7a49864e45a9be5$export$1aabd8a0274ecfd6; }, function (v) { return $e7a49864e45a9be5$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $e7a49864e45a9be5$export$3d6c20d97e46b957; }, function (v) { return $e7a49864e45a9be5$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $e7a49864e45a9be5$export$9b621391a187a31a; }, function (v) { return $e7a49864e45a9be5$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $e7a49864e45a9be5$export$f5bbd400c2f4426f; }, function (v) { return $e7a49864e45a9be5$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e7a49864e45a9be5$export$a7c73072b1a182ae;
var $e7a49864e45a9be5$export$9f27bc3417b4524d;
var $e7a49864e45a9be5$export$db77ccec0bb4ccac;
var $e7a49864e45a9be5$export$8392c0c9d3dcbd35;
var $e7a49864e45a9be5$export$ffb0004e005737fa;
var $e7a49864e45a9be5$export$b624eff549462981;
var $e7a49864e45a9be5$export$7897aa7841a5380c;
var $e7a49864e45a9be5$export$602eac185826482c;
var $e7a49864e45a9be5$export$e2c29f18771995cb;
var $e7a49864e45a9be5$export$5f8d39834fd61797;
var $e7a49864e45a9be5$export$74bf444e3cd11ea5;
var $e7a49864e45a9be5$export$998bcd577473dd93;
var $e7a49864e45a9be5$export$92387174baf9b227;
var $e7a49864e45a9be5$export$ec112efeb987d9c6;
var $e7a49864e45a9be5$export$b706b080d889d2c9;
var $e7a49864e45a9be5$export$5be5a87408f70ddc;
var $e7a49864e45a9be5$export$45a5e7f76e0caa8d;
var $e7a49864e45a9be5$export$455c2e768291efa6;
var $e7a49864e45a9be5$export$9522e17588c12572;
var $e7a49864e45a9be5$export$2110ac352bb060b9;
var $e7a49864e45a9be5$export$56885ab8b9c456ab;
var $e7a49864e45a9be5$export$d927fcb6adf8f9de;
var $e7a49864e45a9be5$export$b82d16f27459e05a;
var $e7a49864e45a9be5$export$522c17b4f5e123e8;
var $e7a49864e45a9be5$export$1aabd8a0274ecfd6;
var $e7a49864e45a9be5$export$3d6c20d97e46b957;
var $e7a49864e45a9be5$export$9b621391a187a31a;
var $e7a49864e45a9be5$export$f5bbd400c2f4426f;
'use strict';
var $e7a49864e45a9be5$var$b = Symbol.for("react.element"), $e7a49864e45a9be5$var$c = Symbol.for("react.portal"), $e7a49864e45a9be5$var$d = Symbol.for("react.fragment"), $e7a49864e45a9be5$var$e = Symbol.for("react.strict_mode"), $e7a49864e45a9be5$var$f = Symbol.for("react.profiler"), $e7a49864e45a9be5$var$g = Symbol.for("react.provider"), $e7a49864e45a9be5$var$h = Symbol.for("react.context"), $e7a49864e45a9be5$var$k = Symbol.for("react.server_context"), $e7a49864e45a9be5$var$l = Symbol.for("react.forward_ref"), $e7a49864e45a9be5$var$m = Symbol.for("react.suspense"), $e7a49864e45a9be5$var$n = Symbol.for("react.suspense_list"), $e7a49864e45a9be5$var$p = Symbol.for("react.memo"), $e7a49864e45a9be5$var$q = Symbol.for("react.lazy"), $e7a49864e45a9be5$var$t = Symbol.for("react.offscreen"), $e7a49864e45a9be5$var$u;
$e7a49864e45a9be5$var$u = Symbol.for("react.module.reference");
function $e7a49864e45a9be5$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $e7a49864e45a9be5$var$b:
                switch(a = a.type, a){
                    case $e7a49864e45a9be5$var$d:
                    case $e7a49864e45a9be5$var$f:
                    case $e7a49864e45a9be5$var$e:
                    case $e7a49864e45a9be5$var$m:
                    case $e7a49864e45a9be5$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $e7a49864e45a9be5$var$k:
                            case $e7a49864e45a9be5$var$h:
                            case $e7a49864e45a9be5$var$l:
                            case $e7a49864e45a9be5$var$q:
                            case $e7a49864e45a9be5$var$p:
                            case $e7a49864e45a9be5$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $e7a49864e45a9be5$var$c:
                return r;
        }
    }
}
$e7a49864e45a9be5$export$a7c73072b1a182ae = $e7a49864e45a9be5$var$h;
$e7a49864e45a9be5$export$9f27bc3417b4524d = $e7a49864e45a9be5$var$g;
$e7a49864e45a9be5$export$db77ccec0bb4ccac = $e7a49864e45a9be5$var$b;
$e7a49864e45a9be5$export$8392c0c9d3dcbd35 = $e7a49864e45a9be5$var$l;
$e7a49864e45a9be5$export$ffb0004e005737fa = $e7a49864e45a9be5$var$d;
$e7a49864e45a9be5$export$b624eff549462981 = $e7a49864e45a9be5$var$q;
$e7a49864e45a9be5$export$7897aa7841a5380c = $e7a49864e45a9be5$var$p;
$e7a49864e45a9be5$export$602eac185826482c = $e7a49864e45a9be5$var$c;
$e7a49864e45a9be5$export$e2c29f18771995cb = $e7a49864e45a9be5$var$f;
$e7a49864e45a9be5$export$5f8d39834fd61797 = $e7a49864e45a9be5$var$e;
$e7a49864e45a9be5$export$74bf444e3cd11ea5 = $e7a49864e45a9be5$var$m;
$e7a49864e45a9be5$export$998bcd577473dd93 = $e7a49864e45a9be5$var$n;
$e7a49864e45a9be5$export$92387174baf9b227 = function() {
    return !1;
};
$e7a49864e45a9be5$export$ec112efeb987d9c6 = function() {
    return !1;
};
$e7a49864e45a9be5$export$b706b080d889d2c9 = function(a) {
    return $e7a49864e45a9be5$var$v(a) === $e7a49864e45a9be5$var$h;
};
$e7a49864e45a9be5$export$5be5a87408f70ddc = function(a) {
    return $e7a49864e45a9be5$var$v(a) === $e7a49864e45a9be5$var$g;
};
$e7a49864e45a9be5$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $e7a49864e45a9be5$var$b;
};
$e7a49864e45a9be5$export$455c2e768291efa6 = function(a) {
    return $e7a49864e45a9be5$var$v(a) === $e7a49864e45a9be5$var$l;
};
$e7a49864e45a9be5$export$9522e17588c12572 = function(a) {
    return $e7a49864e45a9be5$var$v(a) === $e7a49864e45a9be5$var$d;
};
$e7a49864e45a9be5$export$2110ac352bb060b9 = function(a) {
    return $e7a49864e45a9be5$var$v(a) === $e7a49864e45a9be5$var$q;
};
$e7a49864e45a9be5$export$56885ab8b9c456ab = function(a) {
    return $e7a49864e45a9be5$var$v(a) === $e7a49864e45a9be5$var$p;
};
$e7a49864e45a9be5$export$d927fcb6adf8f9de = function(a) {
    return $e7a49864e45a9be5$var$v(a) === $e7a49864e45a9be5$var$c;
};
$e7a49864e45a9be5$export$b82d16f27459e05a = function(a) {
    return $e7a49864e45a9be5$var$v(a) === $e7a49864e45a9be5$var$f;
};
$e7a49864e45a9be5$export$522c17b4f5e123e8 = function(a) {
    return $e7a49864e45a9be5$var$v(a) === $e7a49864e45a9be5$var$e;
};
$e7a49864e45a9be5$export$1aabd8a0274ecfd6 = function(a) {
    return $e7a49864e45a9be5$var$v(a) === $e7a49864e45a9be5$var$m;
};
$e7a49864e45a9be5$export$3d6c20d97e46b957 = function(a) {
    return $e7a49864e45a9be5$var$v(a) === $e7a49864e45a9be5$var$n;
};
$e7a49864e45a9be5$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $e7a49864e45a9be5$var$d || a === $e7a49864e45a9be5$var$f || a === $e7a49864e45a9be5$var$e || a === $e7a49864e45a9be5$var$m || a === $e7a49864e45a9be5$var$n || a === $e7a49864e45a9be5$var$t || "object" === typeof a && null !== a && (a.$$typeof === $e7a49864e45a9be5$var$q || a.$$typeof === $e7a49864e45a9be5$var$p || a.$$typeof === $e7a49864e45a9be5$var$g || a.$$typeof === $e7a49864e45a9be5$var$h || a.$$typeof === $e7a49864e45a9be5$var$l || a.$$typeof === $e7a49864e45a9be5$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$e7a49864e45a9be5$export$f5bbd400c2f4426f = $e7a49864e45a9be5$var$v;

});


parcelRegister("jUj8J", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e7e2181096bfccff$export$2e2bcd8739ae039; });

var $5BpLM = parcelRequire("5BpLM");
parcelRequire("1jZg7");
const $e7e2181096bfccff$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $e7e2181096bfccff$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $e7e2181096bfccff$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $5BpLM.default)(_ref, $e7e2181096bfccff$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $e7e2181096bfccff$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("1jZg7", function(module, exports) {

var $7PpWx = parcelRequire("7PpWx");
function $0f671588e05a2c63$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $7PpWx.default)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $0f671588e05a2c63$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $0f671588e05a2c63$var$verify(mapStateToProps, 'mapStateToProps');
    $0f671588e05a2c63$var$verify(mapDispatchToProps, 'mapDispatchToProps');
    $0f671588e05a2c63$var$verify(mergeProps, 'mergeProps');
}

});
parcelRegister("7PpWx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5b316b95b6b4d68b$export$2e2bcd8739ae039; });
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $5b316b95b6b4d68b$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});



parcelRegister("2SNac", function(module, exports) {
$parcel$export(module.exports, "mapDispatchToPropsFactory", function () { return $2196c2c090c8a7f7$export$b69a785ceac019a6; });

var $3fgLb = parcelRequire("3fgLb");

var $aHbfu = parcelRequire("aHbfu");

var $bj3j6 = parcelRequire("bj3j6");
function $2196c2c090c8a7f7$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $aHbfu.wrapMapToPropsConstant)((dispatch)=>(0, $3fgLb.default)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $aHbfu.wrapMapToPropsConstant)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === 'function' ? (0, $aHbfu.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : (0, $bj3j6.createInvalidArgFactory)(mapDispatchToProps, 'mapDispatchToProps');
}

});
parcelRegister("3fgLb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $25cfc60251c47938$export$2e2bcd8739ae039; });
function $25cfc60251c47938$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}

});

parcelRegister("aHbfu", function(module, exports) {
$parcel$export(module.exports, "wrapMapToPropsConstant", function () { return $7c96a552cd77e605$export$710f7c60f68acd3e; });
$parcel$export(module.exports, "wrapMapToPropsFunc", function () { return $7c96a552cd77e605$export$8d46c7f53c8c602f; });
parcelRequire("gtkVO");
function $7c96a552cd77e605$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $7c96a552cd77e605$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $7c96a552cd77e605$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $7c96a552cd77e605$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $7c96a552cd77e605$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("gtkVO", function(module, exports) {

var $kNp48 = parcelRequire("kNp48");

var $7PpWx = parcelRequire("7PpWx");
function $bfdf975662db4485$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $kNp48.default)(value)) (0, $7PpWx.default)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}

});
parcelRegister("kNp48", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f23bd3cbbe953a09$export$2e2bcd8739ae039; });
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $f23bd3cbbe953a09$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});



parcelRegister("bj3j6", function(module, exports) {
$parcel$export(module.exports, "createInvalidArgFactory", function () { return $83b408c9c6f51c21$export$19ef7b929f7e2559; });
function $83b408c9c6f51c21$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}

});


parcelRegister("9Vog3", function(module, exports) {
$parcel$export(module.exports, "mapStateToPropsFactory", function () { return $739c411240e02ce1$export$e00e93951827eda7; });

var $aHbfu = parcelRequire("aHbfu");

var $bj3j6 = parcelRequire("bj3j6");
function $739c411240e02ce1$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $aHbfu.wrapMapToPropsConstant)(()=>({})) : typeof mapStateToProps === 'function' ? (0, $aHbfu.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : (0, $bj3j6.createInvalidArgFactory)(mapStateToProps, 'mapStateToProps');
}

});

parcelRegister("asxdX", function(module, exports) {
$parcel$export(module.exports, "mergePropsFactory", function () { return $79d64a86c26bad0b$export$17457cf6fa742f84; });

var $c9bqK = parcelRequire("c9bqK");
parcelRequire("gtkVO");

var $bj3j6 = parcelRequire("bj3j6");
function $79d64a86c26bad0b$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $c9bqK.default)({}, ownProps, stateProps, dispatchProps);
}
function $79d64a86c26bad0b$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $79d64a86c26bad0b$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$79d64a86c26bad0b$export$691c327fc30bc857 : typeof mergeProps === 'function' ? $79d64a86c26bad0b$export$5b105939c84b5234(mergeProps) : (0, $bj3j6.createInvalidArgFactory)(mergeProps, 'mergeProps');
}

});

parcelRegister("1iuz7", function(module, exports) {
$parcel$export(module.exports, "createSubscription", function () { return $0f1f2e8c857f8c1d$export$d567d2b9af322f8f; });

var $3YZxS = parcelRequire("3YZxS");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $0f1f2e8c857f8c1d$var$createListenerCollection() {
    const batch = (0, $3YZxS.getBatch)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $0f1f2e8c857f8c1d$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $0f1f2e8c857f8c1d$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $0f1f2e8c857f8c1d$var$nullListeners; // Reasons to keep the subscription active
    let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener); // cleanup nested sub
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $0f1f2e8c857f8c1d$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $0f1f2e8c857f8c1d$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}

});

parcelRegister("iQ6YZ", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $db727feb5f78601c$export$700979bc83e7db82; });

var $1oC0p = parcelRequire("1oC0p");
const $db727feb5f78601c$export$71594e8a50f746f4 = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
const $db727feb5f78601c$export$700979bc83e7db82 = $db727feb5f78601c$export$71594e8a50f746f4 ? $1oC0p.useLayoutEffect : $1oC0p.useEffect;

});

parcelRegister("7yj9S", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $57fa91cbde18c714$export$2e2bcd8739ae039; });
function $57fa91cbde18c714$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $57fa91cbde18c714$export$2e2bcd8739ae039(objA, objB) {
    if ($57fa91cbde18c714$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$57fa91cbde18c714$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});


parcelRegister("aZyKU", function(module, exports) {
$parcel$export(module.exports, "Provider", function () { return (parcelRequire("5huaA")).default; });
$parcel$export(module.exports, "useDispatch", function () { return (parcelRequire("ljd5i")).useDispatch; });
$parcel$export(module.exports, "useSelector", function () { return (parcelRequire("jjx9d")).useSelector; });

var $5huaA = parcelRequire("5huaA");

var $k4dLS = parcelRequire("k4dLS");

var $6llk2 = parcelRequire("6llk2");

var $ljd5i = parcelRequire("ljd5i");

var $jjx9d = parcelRequire("jjx9d");

var $cbn1I = parcelRequire("cbn1I");

var $7yj9S = parcelRequire("7yj9S");
parcelRequire("b1saB");

});
parcelRegister("5huaA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3d85f160b0ec9c95$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $6llk2 = parcelRequire("6llk2");

var $1iuz7 = parcelRequire("1iuz7");

var $iQ6YZ = parcelRequire("iQ6YZ");
function $3d85f160b0ec9c95$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = 'once', noopCheck: noopCheck = 'once' }) {
    const contextValue = $1oC0p.useMemo(()=>{
        const subscription = (0, $1iuz7.createSubscription)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $1oC0p.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $iQ6YZ.useIsomorphicLayoutEffect)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $6llk2.ReactReduxContext); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $1oC0p.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $3d85f160b0ec9c95$export$2e2bcd8739ae039 = $3d85f160b0ec9c95$var$Provider;

});

parcelRegister("ljd5i", function(module, exports) {
$parcel$export(module.exports, "useDispatch", function () { return $f83585a36441adc0$export$8ad76b76a4c905f8; });

var $6llk2 = parcelRequire("6llk2");

var $cbn1I = parcelRequire("cbn1I");
function $f83585a36441adc0$export$bc9b55530897c558(context = (0, $6llk2.ReactReduxContext)) {
    const useStore = context === (0, $6llk2.ReactReduxContext) ? (0, $cbn1I.useStore) : (0, $cbn1I.createStoreHook)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $f83585a36441adc0$export$8ad76b76a4c905f8 = /*#__PURE__*/ $f83585a36441adc0$export$bc9b55530897c558();

});
parcelRegister("cbn1I", function(module, exports) {
$parcel$export(module.exports, "createStoreHook", function () { return $8de85fb95013398c$export$671dba69185d0304; });
$parcel$export(module.exports, "useStore", function () { return $8de85fb95013398c$export$6ccbb43953eebf8; });

var $6llk2 = parcelRequire("6llk2");

var $dqXUQ = parcelRequire("dqXUQ");
function $8de85fb95013398c$export$671dba69185d0304(context = (0, $6llk2.ReactReduxContext)) {
    const useReduxContext = context === (0, $6llk2.ReactReduxContext) ? (0, $dqXUQ.useReduxContext) : (0, $dqXUQ.createReduxContextHook)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $8de85fb95013398c$export$6ccbb43953eebf8 = /*#__PURE__*/ $8de85fb95013398c$export$671dba69185d0304();

});


parcelRegister("b1saB", function(module, exports) {

});



parcelRegister("3GhuR", function(module, exports) {
$parcel$export(module.exports, "createAction", function () { return $2ae2ddd62f1f182e$export$309c7a02b0b0bc62; });
$parcel$export(module.exports, "configureStore", function () { return $2ae2ddd62f1f182e$export$7d8a5b498da695ac; });
$parcel$export(module.exports, "createReducer", function () { return $2ae2ddd62f1f182e$export$473eb76d322d0290; });
$parcel$export(module.exports, "createSlice", function () { return $2ae2ddd62f1f182e$export$4d8d9bd83c24ae8b; });

var $eSosQ = parcelRequire("eSosQ");

var $bcxFK = parcelRequire("bcxFK");

var $gYrFl = parcelRequire("gYrFl");

var $8aRHJ = parcelRequire("8aRHJ");

var $7t0tI = parcelRequire("7t0tI");
var $2ae2ddd62f1f182e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $2ae2ddd62f1f182e$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $2ae2ddd62f1f182e$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $2ae2ddd62f1f182e$var$__defProp = Object.defineProperty;
var $2ae2ddd62f1f182e$var$__defProps = Object.defineProperties;
var $2ae2ddd62f1f182e$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $2ae2ddd62f1f182e$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $2ae2ddd62f1f182e$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $2ae2ddd62f1f182e$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $2ae2ddd62f1f182e$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $2ae2ddd62f1f182e$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $2ae2ddd62f1f182e$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($2ae2ddd62f1f182e$var$__hasOwnProp.call(b, prop)) $2ae2ddd62f1f182e$var$__defNormalProp(a, prop, b[prop]);
    if ($2ae2ddd62f1f182e$var$__getOwnPropSymbols) for(var _i = 0, _c = $2ae2ddd62f1f182e$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($2ae2ddd62f1f182e$var$__propIsEnum.call(b, prop)) $2ae2ddd62f1f182e$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $2ae2ddd62f1f182e$var$__spreadProps = function(a, b) {
    return $2ae2ddd62f1f182e$var$__defProps(a, $2ae2ddd62f1f182e$var$__getOwnPropDescs(b));
};
var $2ae2ddd62f1f182e$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $2ae2ddd62f1f182e$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $gYrFl.createSelector).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $2ae2ddd62f1f182e$var$__spreadArray([
            (0, $eSosQ.isDraft)(value) ? (0, $eSosQ.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $2ae2ddd62f1f182e$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $bcxFK.compose;
    return (0, $bcxFK.compose).apply(null, arguments);
};
var $2ae2ddd62f1f182e$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $2ae2ddd62f1f182e$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/tsHelpers.ts
var $2ae2ddd62f1f182e$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $2ae2ddd62f1f182e$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $2ae2ddd62f1f182e$var$__spreadValues($2ae2ddd62f1f182e$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $2ae2ddd62f1f182e$export$b956e38827fca970(action) {
    return $2ae2ddd62f1f182e$export$53b83ca8eaab0383(action) && "type" in action;
}
function $2ae2ddd62f1f182e$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && $2ae2ddd62f1f182e$var$hasMatchFunction(action);
}
function $2ae2ddd62f1f182e$export$ebd532f9034651f3(action) {
    return $2ae2ddd62f1f182e$export$b956e38827fca970(action) && typeof action.type === "string" && Object.keys(action).every($2ae2ddd62f1f182e$var$isValidKey);
}
function $2ae2ddd62f1f182e$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $2ae2ddd62f1f182e$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/actionCreatorInvariantMiddleware.ts
function $2ae2ddd62f1f182e$var$getMessage(type) {
    var splitType = type ? ("" + type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return "Detected an action creator with type \"" + (type || "unknown") + "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(" + actionName + "())` instead of `dispatch(" + actionName + ")`. This is necessary even if the action has no payload.";
}
function $2ae2ddd62f1f182e$export$6a1fcb4ceef578f(options) {
    if (options === void 0) options = {};
    var _c, isActionCreator2;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $2ae2ddd62f1f182e$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $2ae2ddd62f1f182e$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $2ae2ddd62f1f182e$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $2ae2ddd62f1f182e$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $2ae2ddd62f1f182e$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var $2ae2ddd62f1f182e$export$490d10040a0cbe8a = /** @class */ function(_super) {
    $2ae2ddd62f1f182e$var$__extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, $2ae2ddd62f1f182e$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, $2ae2ddd62f1f182e$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function $2ae2ddd62f1f182e$var$freezeDraftable(val) {
    return (0, $eSosQ.isDraftable)(val) ? (0, $eSosQ.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $2ae2ddd62f1f182e$var$isProduction = true;
var $2ae2ddd62f1f182e$var$prefix = "Invariant failed";
function $2ae2ddd62f1f182e$var$invariant(condition, message) {
    if (condition) return;
    if ($2ae2ddd62f1f182e$var$isProduction) throw new Error($2ae2ddd62f1f182e$var$prefix);
    throw new Error($2ae2ddd62f1f182e$var$prefix + ": " + (message || ""));
}
function $2ae2ddd62f1f182e$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $2ae2ddd62f1f182e$var$getSerialize(serializer, decycler), indent);
}
function $2ae2ddd62f1f182e$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $2ae2ddd62f1f182e$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $2ae2ddd62f1f182e$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $2ae2ddd62f1f182e$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $2ae2ddd62f1f182e$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $2ae2ddd62f1f182e$var$trackProperties(isImmutable, ignorePaths, obj, path, checkedObjects) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    if (checkedObjects === void 0) checkedObjects = new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $2ae2ddd62f1f182e$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $2ae2ddd62f1f182e$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $2ae2ddd62f1f182e$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $2ae2ddd62f1f182e$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $2ae2ddd62f1f182e$export$77670485918dab4e(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $2ae2ddd62f1f182e$export$53b83ca8eaab0383(val);
}
function $2ae2ddd62f1f182e$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $2ae2ddd62f1f182e$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $2ae2ddd62f1f182e$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $2ae2ddd62f1f182e$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $2ae2ddd62f1f182e$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$2ae2ddd62f1f182e$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $2ae2ddd62f1f182e$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $2ae2ddd62f1f182e$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $2ae2ddd62f1f182e$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $2ae2ddd62f1f182e$export$36c1185aeee5b0a6(options);
    };
}
function $2ae2ddd62f1f182e$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e, _f = options.actionCreatorCheck, actionCreatorCheck = _f === void 0 ? true : _f;
    var middlewareArray = new $2ae2ddd62f1f182e$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($2ae2ddd62f1f182e$var$isBoolean(thunk)) middlewareArray.push((0, $8aRHJ.default));
        else middlewareArray.push((0, $8aRHJ.default).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions, actionCreatorOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $2ae2ddd62f1f182e$var$IS_PRODUCTION = true;
function $2ae2ddd62f1f182e$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $2ae2ddd62f1f182e$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($2ae2ddd62f1f182e$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $bcxFK.combineReducers)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$2ae2ddd62f1f182e$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$2ae2ddd62f1f182e$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $bcxFK.applyMiddleware).apply(void 0, finalMiddleware);
    var finalCompose = (0, $bcxFK.compose);
    if (devTools) finalCompose = $2ae2ddd62f1f182e$var$composeWithDevTools($2ae2ddd62f1f182e$var$__spreadValues({
        trace: !$2ae2ddd62f1f182e$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new $2ae2ddd62f1f182e$export$490d10040a0cbe8a(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = $2ae2ddd62f1f182e$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $bcxFK.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $2ae2ddd62f1f182e$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error("`builder.addCase` cannot be called with an empty action type");
            if (type in actionsMap) throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $2ae2ddd62f1f182e$var$isStateFunction(x) {
    return typeof x === "function";
}
var $2ae2ddd62f1f182e$var$hasWarnedAboutObjectNotation = false;
function $2ae2ddd62f1f182e$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $2ae2ddd62f1f182e$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($2ae2ddd62f1f182e$var$isStateFunction(initialState)) getInitialState = function() {
        return $2ae2ddd62f1f182e$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $2ae2ddd62f1f182e$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $2ae2ddd62f1f182e$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $eSosQ.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $eSosQ.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $eSosQ.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $2ae2ddd62f1f182e$var$hasWarnedAboutObjectNotation2 = false;
function $2ae2ddd62f1f182e$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $2ae2ddd62f1f182e$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    typeof $7t0tI;
    var initialState = typeof options.initialState == "function" ? options.initialState : $2ae2ddd62f1f182e$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $2ae2ddd62f1f182e$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $2ae2ddd62f1f182e$export$309c7a02b0b0bc62(type, prepareCallback) : $2ae2ddd62f1f182e$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $2ae2ddd62f1f182e$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $2ae2ddd62f1f182e$var$__spreadValues($2ae2ddd62f1f182e$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $2ae2ddd62f1f182e$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $2ae2ddd62f1f182e$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $2ae2ddd62f1f182e$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($2ae2ddd62f1f182e$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $2ae2ddd62f1f182e$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $2ae2ddd62f1f182e$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $2ae2ddd62f1f182e$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $2ae2ddd62f1f182e$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $2ae2ddd62f1f182e$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $2ae2ddd62f1f182e$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $2ae2ddd62f1f182e$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $2ae2ddd62f1f182e$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $2ae2ddd62f1f182e$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $2ae2ddd62f1f182e$var$createSingleArgumentStateOperator(mutator) {
    var operator = $2ae2ddd62f1f182e$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $2ae2ddd62f1f182e$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $2ae2ddd62f1f182e$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $eSosQ.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, $eSosQ.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function $2ae2ddd62f1f182e$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $2ae2ddd62f1f182e$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $2ae2ddd62f1f182e$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $2ae2ddd62f1f182e$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $2ae2ddd62f1f182e$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $2ae2ddd62f1f182e$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $2ae2ddd62f1f182e$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $2ae2ddd62f1f182e$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $2ae2ddd62f1f182e$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $2ae2ddd62f1f182e$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $2ae2ddd62f1f182e$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $2ae2ddd62f1f182e$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $2ae2ddd62f1f182e$var$__spreadValues($2ae2ddd62f1f182e$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $2ae2ddd62f1f182e$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $2ae2ddd62f1f182e$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $2ae2ddd62f1f182e$var$createStateOperator(addOneMutably),
        addMany: $2ae2ddd62f1f182e$var$createStateOperator(addManyMutably),
        setOne: $2ae2ddd62f1f182e$var$createStateOperator(setOneMutably),
        setMany: $2ae2ddd62f1f182e$var$createStateOperator(setManyMutably),
        setAll: $2ae2ddd62f1f182e$var$createStateOperator(setAllMutably),
        updateOne: $2ae2ddd62f1f182e$var$createStateOperator(updateOneMutably),
        updateMany: $2ae2ddd62f1f182e$var$createStateOperator(updateManyMutably),
        upsertOne: $2ae2ddd62f1f182e$var$createStateOperator(upsertOneMutably),
        upsertMany: $2ae2ddd62f1f182e$var$createStateOperator(upsertManyMutably),
        removeOne: $2ae2ddd62f1f182e$var$createStateOperator(removeOneMutably),
        removeMany: $2ae2ddd62f1f182e$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $2ae2ddd62f1f182e$var$createSortedStateAdapter(selectId, sort) {
    var _c = $2ae2ddd62f1f182e$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $2ae2ddd62f1f182e$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($2ae2ddd62f1f182e$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $2ae2ddd62f1f182e$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $2ae2ddd62f1f182e$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $2ae2ddd62f1f182e$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $2ae2ddd62f1f182e$var$createStateOperator(addOneMutably),
        updateOne: $2ae2ddd62f1f182e$var$createStateOperator(updateOneMutably),
        upsertOne: $2ae2ddd62f1f182e$var$createStateOperator(upsertOneMutably),
        setOne: $2ae2ddd62f1f182e$var$createStateOperator(setOneMutably),
        setMany: $2ae2ddd62f1f182e$var$createStateOperator(setManyMutably),
        setAll: $2ae2ddd62f1f182e$var$createStateOperator(setAllMutably),
        addMany: $2ae2ddd62f1f182e$var$createStateOperator(addManyMutably),
        updateMany: $2ae2ddd62f1f182e$var$createStateOperator(updateManyMutably),
        upsertMany: $2ae2ddd62f1f182e$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $2ae2ddd62f1f182e$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $2ae2ddd62f1f182e$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $2ae2ddd62f1f182e$var$createInitialStateFactory();
    var selectorsFactory = $2ae2ddd62f1f182e$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $2ae2ddd62f1f182e$var$createSortedStateAdapter(selectId, sortComparer) : $2ae2ddd62f1f182e$var$createUnsortedStateAdapter(selectId);
    return $2ae2ddd62f1f182e$var$__spreadValues($2ae2ddd62f1f182e$var$__spreadValues($2ae2ddd62f1f182e$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $2ae2ddd62f1f182e$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $2ae2ddd62f1f182e$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $2ae2ddd62f1f182e$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $2ae2ddd62f1f182e$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $2ae2ddd62f1f182e$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $2ae2ddd62f1f182e$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $2ae2ddd62f1f182e$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $2ae2ddd62f1f182e$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $2ae2ddd62f1f182e$export$6abd22dc03e5063f = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $2ae2ddd62f1f182e$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $2ae2ddd62f1f182e$var$__spreadProps($2ae2ddd62f1f182e$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $2ae2ddd62f1f182e$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $2ae2ddd62f1f182e$var$__spreadProps($2ae2ddd62f1f182e$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $2ae2ddd62f1f182e$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $2ae2ddd62f1f182e$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $2ae2ddd62f1f182e$var$__spreadProps($2ae2ddd62f1f182e$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $2ae2ddd62f1f182e$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $2ae2ddd62f1f182e$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $2ae2ddd62f1f182e$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$2ae2ddd62f1f182e$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $2ae2ddd62f1f182e$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $2ae2ddd62f1f182e$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $2ae2ddd62f1f182e$var$RejectWithValue) throw result;
                                                if (result instanceof $2ae2ddd62f1f182e$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $2ae2ddd62f1f182e$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then($2ae2ddd62f1f182e$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $2ae2ddd62f1f182e$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $2ae2ddd62f1f182e$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/matchers.ts
var $2ae2ddd62f1f182e$var$matches = function(matcher, action) {
    if ($2ae2ddd62f1f182e$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $2ae2ddd62f1f182e$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $2ae2ddd62f1f182e$var$matches(matcher, action);
        });
    };
}
function $2ae2ddd62f1f182e$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $2ae2ddd62f1f182e$var$matches(matcher, action);
        });
    };
}
function $2ae2ddd62f1f182e$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $2ae2ddd62f1f182e$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $2ae2ddd62f1f182e$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $2ae2ddd62f1f182e$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$2ae2ddd62f1f182e$var$isAsyncThunkArray(asyncThunks)) return $2ae2ddd62f1f182e$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $2ae2ddd62f1f182e$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $2ae2ddd62f1f182e$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $2ae2ddd62f1f182e$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$2ae2ddd62f1f182e$var$isAsyncThunkArray(asyncThunks)) return $2ae2ddd62f1f182e$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $2ae2ddd62f1f182e$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $2ae2ddd62f1f182e$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $2ae2ddd62f1f182e$export$9dd1fb32974da385($2ae2ddd62f1f182e$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$2ae2ddd62f1f182e$var$isAsyncThunkArray(asyncThunks)) return $2ae2ddd62f1f182e$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $2ae2ddd62f1f182e$export$9dd1fb32974da385($2ae2ddd62f1f182e$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $2ae2ddd62f1f182e$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $2ae2ddd62f1f182e$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$2ae2ddd62f1f182e$var$isAsyncThunkArray(asyncThunks)) return $2ae2ddd62f1f182e$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $2ae2ddd62f1f182e$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $2ae2ddd62f1f182e$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $2ae2ddd62f1f182e$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$2ae2ddd62f1f182e$var$isAsyncThunkArray(asyncThunks)) return $2ae2ddd62f1f182e$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $2ae2ddd62f1f182e$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $2ae2ddd62f1f182e$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $2ae2ddd62f1f182e$var$noop = function() {};
var $2ae2ddd62f1f182e$var$catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = $2ae2ddd62f1f182e$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $2ae2ddd62f1f182e$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $2ae2ddd62f1f182e$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $2ae2ddd62f1f182e$var$task = "task";
var $2ae2ddd62f1f182e$var$listener = "listener";
var $2ae2ddd62f1f182e$var$completed = "completed";
var $2ae2ddd62f1f182e$var$cancelled = "cancelled";
var $2ae2ddd62f1f182e$var$taskCancelled = "task-" + $2ae2ddd62f1f182e$var$cancelled;
var $2ae2ddd62f1f182e$var$taskCompleted = "task-" + $2ae2ddd62f1f182e$var$completed;
var $2ae2ddd62f1f182e$var$listenerCancelled = $2ae2ddd62f1f182e$var$listener + "-" + $2ae2ddd62f1f182e$var$cancelled;
var $2ae2ddd62f1f182e$var$listenerCompleted = $2ae2ddd62f1f182e$var$listener + "-" + $2ae2ddd62f1f182e$var$completed;
var $2ae2ddd62f1f182e$export$cb1bdac908fed7f = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $2ae2ddd62f1f182e$var$task + " " + $2ae2ddd62f1f182e$var$cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $2ae2ddd62f1f182e$var$validateActive = function(signal) {
    if (signal.aborted) throw new $2ae2ddd62f1f182e$export$cb1bdac908fed7f(signal.reason);
};
function $2ae2ddd62f1f182e$var$raceWithSignal(signal, promise2) {
    var cleanup = $2ae2ddd62f1f182e$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $2ae2ddd62f1f182e$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $2ae2ddd62f1f182e$var$addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $2ae2ddd62f1f182e$var$noop;
    });
}
var $2ae2ddd62f1f182e$var$runTask = function(task2, cleanUp) {
    return $2ae2ddd62f1f182e$var$__async(void 0, null, function() {
        var value, error_1;
        return $2ae2ddd62f1f182e$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $2ae2ddd62f1f182e$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $2ae2ddd62f1f182e$var$createPause = function(signal) {
    return function(promise2) {
        return $2ae2ddd62f1f182e$var$catchRejection($2ae2ddd62f1f182e$var$raceWithSignal(signal, promise2).then(function(output) {
            $2ae2ddd62f1f182e$var$validateActive(signal);
            return output;
        }));
    };
};
var $2ae2ddd62f1f182e$var$createDelay = function(signal) {
    var pause = $2ae2ddd62f1f182e$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $2ae2ddd62f1f182e$var$assign = Object.assign;
var $2ae2ddd62f1f182e$var$INTERNAL_NIL_TOKEN = {};
var $2ae2ddd62f1f182e$var$alm = "listenerMiddleware";
var $2ae2ddd62f1f182e$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $2ae2ddd62f1f182e$var$addAbortSignalListener(parentAbortSignal, function() {
            return $2ae2ddd62f1f182e$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $2ae2ddd62f1f182e$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $2ae2ddd62f1f182e$var$runTask(function() {
            return $2ae2ddd62f1f182e$var$__async(void 0, null, function() {
                var result2;
                return $2ae2ddd62f1f182e$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $2ae2ddd62f1f182e$var$validateActive(parentAbortSignal);
                            $2ae2ddd62f1f182e$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $2ae2ddd62f1f182e$var$createPause(childAbortController.signal),
                                    delay: $2ae2ddd62f1f182e$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $2ae2ddd62f1f182e$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $2ae2ddd62f1f182e$var$abortControllerWithReason(childAbortController, $2ae2ddd62f1f182e$var$taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result);
        return {
            result: $2ae2ddd62f1f182e$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $2ae2ddd62f1f182e$var$abortControllerWithReason(childAbortController, $2ae2ddd62f1f182e$var$taskCancelled);
            }
        };
    };
};
var $2ae2ddd62f1f182e$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return $2ae2ddd62f1f182e$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $2ae2ddd62f1f182e$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $2ae2ddd62f1f182e$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $2ae2ddd62f1f182e$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $2ae2ddd62f1f182e$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $2ae2ddd62f1f182e$var$catchRejection(take(predicate, timeout));
    };
};
var $2ae2ddd62f1f182e$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $2ae2ddd62f1f182e$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $2ae2ddd62f1f182e$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $2ae2ddd62f1f182e$var$createListenerEntry = function(options) {
    var _c = $2ae2ddd62f1f182e$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $2ae2ddd62f1f182e$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $2ae2ddd62f1f182e$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $2ae2ddd62f1f182e$var$abortControllerWithReason(controller, $2ae2ddd62f1f182e$var$listenerCancelled);
    });
};
var $2ae2ddd62f1f182e$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($2ae2ddd62f1f182e$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $2ae2ddd62f1f182e$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $2ae2ddd62f1f182e$export$f03a6b845d3fb58b = $2ae2ddd62f1f182e$export$309c7a02b0b0bc62($2ae2ddd62f1f182e$var$alm + "/add");
var $2ae2ddd62f1f182e$export$b1b8022855fb2b71 = $2ae2ddd62f1f182e$export$309c7a02b0b0bc62($2ae2ddd62f1f182e$var$alm + "/removeAll");
var $2ae2ddd62f1f182e$export$b03e9483f936dccb = $2ae2ddd62f1f182e$export$309c7a02b0b0bc62($2ae2ddd62f1f182e$var$alm + "/remove");
var $2ae2ddd62f1f182e$var$defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $2ae2ddd62f1f182e$var$__spreadArray([
        $2ae2ddd62f1f182e$var$alm + "/error"
    ], args));
};
function $2ae2ddd62f1f182e$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $2ae2ddd62f1f182e$var$defaultErrorHandler : _c;
    $2ae2ddd62f1f182e$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $2ae2ddd62f1f182e$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $2ae2ddd62f1f182e$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = $2ae2ddd62f1f182e$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $2ae2ddd62f1f182e$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return $2ae2ddd62f1f182e$var$__async(_this, null, function() {
            var internalTaskController, take, autoJoinPromises, listenerError_1;
            return $2ae2ddd62f1f182e$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $2ae2ddd62f1f182e$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $2ae2ddd62f1f182e$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $2ae2ddd62f1f182e$var$createDelay(internalTaskController.signal),
                                pause: $2ae2ddd62f1f182e$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $2ae2ddd62f1f182e$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $2ae2ddd62f1f182e$var$abortControllerWithReason(controller, $2ae2ddd62f1f182e$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $2ae2ddd62f1f182e$export$cb1bdac908fed7f)) $2ae2ddd62f1f182e$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            Promise.allSettled(autoJoinPromises)
                        ];
                    case 5:
                        _c.sent();
                        $2ae2ddd62f1f182e$var$abortControllerWithReason(internalTaskController, $2ae2ddd62f1f182e$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $2ae2ddd62f1f182e$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!$2ae2ddd62f1f182e$export$b956e38827fca970(action)) return next(action);
                if ($2ae2ddd62f1f182e$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($2ae2ddd62f1f182e$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($2ae2ddd62f1f182e$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $2ae2ddd62f1f182e$var$INTERNAL_NIL_TOKEN) throw new Error($2ae2ddd62f1f182e$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $2ae2ddd62f1f182e$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $2ae2ddd62f1f182e$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $2ae2ddd62f1f182e$export$8fb31c0f05df007b = "RTK_autoBatch";
var $2ae2ddd62f1f182e$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$2ae2ddd62f1f182e$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $2ae2ddd62f1f182e$var$promise;
var $2ae2ddd62f1f182e$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($2ae2ddd62f1f182e$var$promise || ($2ae2ddd62f1f182e$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $2ae2ddd62f1f182e$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $2ae2ddd62f1f182e$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $2ae2ddd62f1f182e$var$createQueueWithTimer(10);
var $2ae2ddd62f1f182e$export$676277d7dca0f396 = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $2ae2ddd62f1f182e$var$queueMicrotaskShim : options.type === "raf" ? $2ae2ddd62f1f182e$var$rAF : options.type === "callback" ? options.queueNotification : $2ae2ddd62f1f182e$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$2ae2ddd62f1f182e$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $eSosQ.enableES5)();

});
parcelRegister("bcxFK", function(module, exports) {
$parcel$export(module.exports, "createStore", function () { return $827aef558ac6896f$export$f51a9068ac82ea43; });
$parcel$export(module.exports, "combineReducers", function () { return $827aef558ac6896f$export$66e4520cdb265d18; });
$parcel$export(module.exports, "compose", function () { return $827aef558ac6896f$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "applyMiddleware", function () { return $827aef558ac6896f$export$9ff26e0402cc7b7; });

var $8jRs5 = parcelRequire("8jRs5");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $827aef558ac6896f$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $827aef558ac6896f$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $827aef558ac6896f$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $827aef558ac6896f$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $827aef558ac6896f$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $827aef558ac6896f$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $827aef558ac6896f$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $827aef558ac6896f$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $827aef558ac6896f$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($827aef558ac6896f$var$isDate(val)) return 'date';
    if ($827aef558ac6896f$var$isError(val)) return 'error';
    var constructorName = $827aef558ac6896f$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $827aef558ac6896f$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $827aef558ac6896f$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $827aef558ac6896f$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $827aef558ac6896f$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $827aef558ac6896f$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($827aef558ac6896f$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($827aef558ac6896f$var$formatProdErrorMessage(1));
        return enhancer($827aef558ac6896f$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($827aef558ac6896f$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($827aef558ac6896f$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($827aef558ac6896f$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($827aef558ac6896f$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($827aef558ac6896f$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$827aef558ac6896f$var$isPlainObject(action)) throw new Error($827aef558ac6896f$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($827aef558ac6896f$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($827aef558ac6896f$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($827aef558ac6896f$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $827aef558ac6896f$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($827aef558ac6896f$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$827aef558ac6896f$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $827aef558ac6896f$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$827aef558ac6896f$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $827aef558ac6896f$export$8928921ea2d3b126 = $827aef558ac6896f$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $827aef558ac6896f$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $827aef558ac6896f$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $827aef558ac6896f$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$827aef558ac6896f$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $827aef558ac6896f$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $827aef558ac6896f$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $827aef558ac6896f$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $827aef558ac6896f$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($827aef558ac6896f$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $827aef558ac6896f$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($827aef558ac6896f$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $827aef558ac6896f$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $827aef558ac6896f$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($827aef558ac6896f$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $827aef558ac6896f$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $827aef558ac6896f$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $827aef558ac6896f$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($827aef558ac6896f$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $827aef558ac6896f$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $827aef558ac6896f$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $827aef558ac6896f$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($827aef558ac6896f$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $827aef558ac6896f$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $8jRs5.default)((0, $8jRs5.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});

parcelRegister("gYrFl", function(module, exports) {
$parcel$export(module.exports, "createSelector", function () { return $c5b7b5cfcb030a5f$export$595d22ed68ca2841; });

var $7EqCI = parcelRequire("7EqCI");
function $c5b7b5cfcb030a5f$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
        }).join(', ');
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $c5b7b5cfcb030a5f$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === 'object') {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== 'function') throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $c5b7b5cfcb030a5f$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $c5b7b5cfcb030a5f$export$595d22ed68ca2841 = /* #__PURE__ */ $c5b7b5cfcb030a5f$export$5943f4447f6ef248((0, $7EqCI.defaultMemoize));
var $c5b7b5cfcb030a5f$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $c5b7b5cfcb030a5f$export$595d22ed68ca2841;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};

});
parcelRegister("7EqCI", function(module, exports) {
$parcel$export(module.exports, "defaultMemoize", function () { return $5920ebb5cf61fafa$export$281bff7f05488aa2; });
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $5920ebb5cf61fafa$var$NOT_FOUND = 'NOT_FOUND';
function $5920ebb5cf61fafa$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $5920ebb5cf61fafa$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $5920ebb5cf61fafa$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $5920ebb5cf61fafa$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $5920ebb5cf61fafa$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $5920ebb5cf61fafa$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $5920ebb5cf61fafa$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $5920ebb5cf61fafa$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $5920ebb5cf61fafa$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $5920ebb5cf61fafa$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $5920ebb5cf61fafa$var$createSingletonCache(comparator) : $5920ebb5cf61fafa$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $5920ebb5cf61fafa$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}

});


parcelRegister("8aRHJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5f38ea78e345cae2$export$2e2bcd8739ae039; });
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $5f38ea78e345cae2$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === 'function') // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $5f38ea78e345cae2$var$thunk = $5f38ea78e345cae2$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$5f38ea78e345cae2$var$thunk.withExtraArgument = $5f38ea78e345cae2$var$createThunkMiddleware;
var $5f38ea78e345cae2$export$2e2bcd8739ae039 = $5f38ea78e345cae2$var$thunk;

});


parcelRegister("7VPuM", function(module, exports) {

var $4jLK2 = parcelRequire("4jLK2");

var $iiMec = parcelRequire("iiMec");

var $dgk1F = parcelRequire("dgk1F");

var $hJ191 = parcelRequire("hJ191");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5c65cd33ec1e85a9$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $5c65cd33ec1e85a9$var$getSymbolsIn = !$5c65cd33ec1e85a9$var$nativeGetSymbols ? $hJ191 : function(object) {
    var result = [];
    while(object){
        $4jLK2(result, $dgk1F(object));
        object = $iiMec(object);
    }
    return result;
};
module.exports = $5c65cd33ec1e85a9$var$getSymbolsIn;

});

parcelRegister("fbqqW", function(module, exports) {

var $3eEUA = parcelRequire("3eEUA");

var $7VPuM = parcelRequire("7VPuM");

var $58mMQ = parcelRequire("58mMQ");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $b0dc633f746652d2$var$getAllKeysIn(object) {
    return $3eEUA(object, $58mMQ, $7VPuM);
}
module.exports = $b0dc633f746652d2$var$getAllKeysIn;

});

parcelRegister("9uL34", function(module, exports) {
$parcel$export(module.exports, "PatternLogos", function () { return $9ce6b13b299d308e$export$355432025e812df1; });
/* logos.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $2ivuE = parcelRequire("2ivuE");

var $iPPTB = parcelRequire("iPPTB");

var $1rGpC = parcelRequire("1rGpC");
const $9ce6b13b299d308e$var$ConditionalLogo = (props)=>{
    if (props.link) return /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        href: props.link,
        className: "logoblock logo-linked",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
            src: props.src,
            alt: props.alt,
            width: props.width,
            loading: "lazy"
        })
    });
    return(// eslint-disable-next-line no-restricted-syntax
    /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
        className: "logoblock logo-plain",
        src: props.src,
        alt: props.alt,
        width: props.width,
        loading: "lazy"
    }));
};
const $9ce6b13b299d308e$export$355432025e812df1 = ({ inlineLogos: inlineLogos, headerText: headerText, bodyText: bodyText, className: className, eyebrowText: eyebrowText, footNoteText: footNoteText, ctaProps: ctaProps, linkPosition: linkPosition = 'top' })=>{
    if (inlineLogos.length < 4 || inlineLogos.length > 12) throw new Error('Minimum 4 logos required, maximum 12');
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ca0qvbgk _u5f3idpf _n3tdvbgk _19bvidpf _y3gn1h6o _i6jxckbl _1lh7idpf _z3ncckbl _wpaiidpf _1kmxzwfg _1ggmidpf _1ykzzwfg _1maeidpf _1916ud5o _1nk71e5h _jti51ul9 _xjyridpf _2thuidpf _hbr3idpf",
            className
        ]),
        children: [
            headerText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                layout: "10",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ivuE.ContentBlock), {
                    isCentered: true,
                    headerText: headerText,
                    headerType: "h2",
                    eyebrowText: eyebrowText,
                    bodyText: bodyText,
                    ctaProps: linkPosition === 'top' && ctaProps?.primaryLinkProps ? ctaProps : undefined
                })
            }) : null,
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: `logos-content lgth length-${inlineLogos.length}`,
                    children: inlineLogos.map((inlineLogo, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)($9ce6b13b299d308e$var$ConditionalLogo, {
                            alt: inlineLogo.alt,
                            src: inlineLogo.src,
                            link: inlineLogo.link,
                            width: inlineLogo.width
                        }, index))
                })
            }),
            footNoteText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: "footnote-text",
                    children: footNoteText
                })
            }) : null,
            linkPosition === 'bottom' && ctaProps?.primaryLinkProps ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    style: {
                        textAlign: 'center'
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                        ...ctaProps.primaryLinkProps
                    })
                })
            }) : null
        ]
    });
};

});

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck
// This file is the entry for Webpack and Parcel fallback.

var $yhhhl = parcelRequire("yhhhl");

var $fuLgT = parcelRequire("fuLgT");

var $hgaI1 = parcelRequire("hgaI1");
// This file includes the mapping between the route and the component that should be rendered for that route.
// You are not meant to import this file on client-side code, as it will make the bundle size bigger.

var $4ccia = parcelRequire("4ccia");

var $6mvtm = parcelRequire("6mvtm");

var $4X0dO = parcelRequire("4X0dO");

var $gIKKj = parcelRequire("gIKKj");

var $eRzlV = parcelRequire("eRzlV");

var $k6PTJ = parcelRequire("k6PTJ");

var $5UKqd = parcelRequire("5UKqd");

var $iwpqF = parcelRequire("iwpqF");

var $lsYgE = parcelRequire("lsYgE");

var $2ABij = parcelRequire("2ABij");

var $2kCSN = parcelRequire("2kCSN");

var $83Z9w = parcelRequire("83Z9w");

var $1mtK6 = parcelRequire("1mtK6");

var $5zs0K = parcelRequire("5zs0K");

var $806Eh = parcelRequire("806Eh");

var $bWWTF = parcelRequire("bWWTF");

var $fxtKw = parcelRequire("fxtKw");

var $dG76n = parcelRequire("dG76n");

var $2fKIG = parcelRequire("2fKIG");

var $8IsVQ = parcelRequire("8IsVQ");

var $9Ws6n = parcelRequire("9Ws6n");

var $kufmD = parcelRequire("kufmD");

var $gKC0O = parcelRequire("gKC0O");

var $fTqPM = parcelRequire("fTqPM");

var $e18uw = parcelRequire("e18uw");

var $ccCRD = parcelRequire("ccCRD");

var $kqZTJ = parcelRequire("kqZTJ");

var $kShM7 = parcelRequire("kShM7");

var $4f5AO = parcelRequire("4f5AO");

var $SJn7F = parcelRequire("SJn7F");

var $8vTdi = parcelRequire("8vTdi");

var $drgFv = parcelRequire("drgFv");

var $2veNk = parcelRequire("2veNk");

var $cqCPq = parcelRequire("cqCPq");

var $WuRB2 = parcelRequire("WuRB2");

var $8KaV5 = parcelRequire("8KaV5");

var $jToCF = parcelRequire("jToCF");

var $4FLZc = parcelRequire("4FLZc");

var $imhoT = parcelRequire("imhoT");

var $ik40B = parcelRequire("ik40B");

var $jYywI = parcelRequire("jYywI");

var $30s1N = parcelRequire("30s1N");

var $fenhY = parcelRequire("fenhY");

var $kPZ6t = parcelRequire("kPZ6t");

var $c33x4 = parcelRequire("c33x4");

var $8ItDm = parcelRequire("8ItDm");

var $6mr2B = parcelRequire("6mr2B");

var $5v5zT = parcelRequire("5v5zT");

var $9h3ui = parcelRequire("9h3ui");

var $8v2ki = parcelRequire("8v2ki");

var $2LTjU = parcelRequire("2LTjU");

var $idul7 = parcelRequire("idul7");

var $iEYMn = parcelRequire("iEYMn");

var $1MAo5 = parcelRequire("1MAo5");

var $dQR2M = parcelRequire("dQR2M");
const $9c0bba3d3f832473$export$90ba7e5165ba2be5 = [
    'paid-lp-jsw-features',
    'paid-lp-jsw-pm',
    'paid-lp-jsw-template',
    'paid-lp-jsw-roadmaps',
    'paid-lp-jsw-tracker',
    'paid-lp-jsw-competitors',
    'paid-lp-jsw-automation',
    'paid-lp-jsw-agile',
    'paid-lp-jsw-project_collaboration',
    'paid-lp-jsw-teamwork',
    'anchor-lp-jsw-team-marketing',
    'anchor-lp-jsw-team-engineering',
    'anchor-lp-jsw-team-operations',
    'anchor-lp-jsw-team-hr',
    'anchor-lp-jsw-team-design',
    'anchor-lp-jsw-team-programmgmt',
    'anchor-lp-jsw-team-sales',
    'anchor-lp-jsw-team-legal'
];



var $dXL3R = parcelRequire("dXL3R");

var $3jSW5 = parcelRequire("3jSW5");

var $2LlD0 = parcelRequire("2LlD0");

var $faUzl = parcelRequire("faUzl");

var $7btsq = parcelRequire("7btsq");

var $eNeuM = parcelRequire("eNeuM");

var $lTIGz = parcelRequire("lTIGz");

var $eIZwM = parcelRequire("eIZwM");

var $bcBwv = parcelRequire("bcBwv");

var $gfnSo = parcelRequire("gfnSo");

var $lFb3d = parcelRequire("lFb3d");

var $g4d4R = parcelRequire("g4d4R");

var $02cSL = parcelRequire("02cSL");

var $koI83 = parcelRequire("koI83");

var $Q2S5p = parcelRequire("Q2S5p");

var $2S6eY = parcelRequire("2S6eY");

var $04Umd = parcelRequire("04Umd");

var $31J3d = parcelRequire("31J3d");

var $6QgX2 = parcelRequire("6QgX2");

var $keOu4 = parcelRequire("keOu4");

var $cbLEA = parcelRequire("cbLEA");

var $ioPgw = parcelRequire("ioPgw");

var $4PDzO = parcelRequire("4PDzO");

var $hI6CC = parcelRequire("hI6CC");

var $7Lagj = parcelRequire("7Lagj");

var $keaFO = parcelRequire("keaFO");

var $7R96I = parcelRequire("7R96I");

var $lfqXN = parcelRequire("lfqXN");

var $czsFN = parcelRequire("czsFN");

var $67UrT = parcelRequire("67UrT");

var $iWEGU = parcelRequire("iWEGU");

var $2aZDx = parcelRequire("2aZDx");

var $gbUpX = parcelRequire("gbUpX");

var $1YXN8 = parcelRequire("1YXN8");
/**
 * Access rules for the /uniform-preview route.
 *
 * The route renders unpublished draft compositions, so it historically existed
 * only in non-production environments and "which environment am I?" was the
 * whole access decision. It is now also served in production so the WAC
 * migration tooling can render and visually QA the compositions it builds,
 * which means that single check is no longer sufficient. The real rules live
 * here so the router and the SSR page-props resolver apply the same ones.
 *
 * There is deliberately no shared-secret check. wac-web has no runtime secret
 * channel — every env var reaching this code is baked in at build time from
 * .env.* and, if listed in `inlineEnvironment`, inlined into the browser
 * bundle — so a "secret" here would either be undefined at runtime or public.
 * What guards the route instead: it is absent from customer-facing hostnames,
 * marked noindex/nofollow in the SSR HTML, restricted to an explicit project
 * allow-list, and useless without a valid compositionId + projectId pair. The
 * composition itself is still fetched via wac-management-service, which holds
 * the Uniform API key server-side.
 *
 * Deliberately free of imports and side effects: the router runs during client
 * hydration as well as during SSR, so anything reachable from it ends up in the
 * browser bundle.
 */ /**
 * wac-web's own Bifrost hostnames, as opposed to a customer-facing domain such
 * as www.atlassian.com. Mirrors the Host regex used by the ingress routes in
 * wac-web.sd.yml.
 */ const $d83278564f9275cb$var$INTERNAL_WAC_WEB_HOSTNAME = /^wac-web\.(ddev|stg-east|prod-east)\.frontend\.public\.atl-paas\.net$/;
const $d83278564f9275cb$export$9ad63ebd4cca3b05 = (hostname)=>$d83278564f9275cb$var$INTERNAL_WAC_WEB_HOSTNAME.test(hostname);
const $d83278564f9275cb$export$f6b1ca2a3a8460a1 = (raw)=>(raw ?? '').split(',').map((projectId)=>projectId.trim()).filter(Boolean);
const $d83278564f9275cb$export$1bad5a4e77d72ad4 = (requestedProjectId, allowedProjectIds)=>Boolean(requestedProjectId) && allowedProjectIds.includes(requestedProjectId);


// wac-management-service publishes exactly these three routing-table objects
// (see RoutingTableEnvironment in wac-management-service/src/routing-table/constants.ts).
// It has no dev-specific object, so a dev or local build reads the staging object,
// the same content-environment its sibling WAC_MANAGEMENT_CDN/PREVIEW_CDN vars use.
const $8d8fc7d3d32dbcb4$var$MANAGEMENT_ROUTING_TABLE_FILE_NAMES = {
    production: 'routing-table-production.json',
    staging: 'routing-table-staging.json',
    dev: 'routing-table-staging.json',
    local: 'routing-table-staging.json'
};
const $8d8fc7d3d32dbcb4$export$9dab8dd71c3a980f = async ()=>{
    try {
        const isPreview = window.location.search.includes('wacae-preview=true') && false;
        if (isPreview) console.log('wacae-preview is true, fetching Preview Routing Table');
        const baseUrl = "https://wac-management-service--rte-tbl.us-east-1.prod.public.atl-paas.net";
        const fileName = isPreview ? 'routing-table-preview.json' : $8d8fc7d3d32dbcb4$var$MANAGEMENT_ROUTING_TABLE_FILE_NAMES["production"] ?? 'routing-table-staging.json';
        const routingTableUrl = `${baseUrl}/${fileName}`;
        const response = await fetch(routingTableUrl);
        if (!response.ok) throw new Error(`Failed to fetch Routing Table from CloudFront: ${response.status} ${response.statusText}`);
        return await response.json();
    } catch (error) {
        console.error('Error fetching Routing Table', error);
    }
};
const $8d8fc7d3d32dbcb4$var$ROUTING_TABLE_METADATA_KEYS = new Set([
    'x'
]);
const $8d8fc7d3d32dbcb4$export$443f269ba643b5d6 = (segments, index, segLength, routeObject)=>{
    const currSeg = String(segments[index]);
    const hasSeg = $8d8fc7d3d32dbcb4$var$ROUTING_TABLE_METADATA_KEYS.has(currSeg) ? undefined : routeObject[currSeg];
    const hasWildcard = routeObject['*'];
    const lastSeg = index === segLength;
    let hasSegResult = false;
    let hasWildcardResult = false;
    if (hasSeg) {
        if (lastSeg) hasSegResult = !Boolean(hasSeg['p']);
        else hasSegResult = $8d8fc7d3d32dbcb4$export$443f269ba643b5d6(segments, index + 1, segLength, hasSeg);
    }
    if (hasWildcard) {
        if (lastSeg) hasWildcardResult = !Boolean(hasWildcard['p']);
        else hasWildcardResult = $8d8fc7d3d32dbcb4$export$443f269ba643b5d6(segments, index + 1, segLength, hasWildcard);
    }
    return hasSegResult || hasWildcardResult;
};



var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $hu3Tl = parcelRequire("hu3Tl");

var $3mZSr = parcelRequire("3mZSr");

var $hu7gH = parcelRequire("hu7gH");
const $fc114bc7d66a4f84$export$da6d2f7032b7150b = (location, userLocale, userLoggedIn, subAnchor, routingTable, isEdgeRoutedToWae = false)=>{
    const route = (0, $hu7gH.parseRoute)(location);
    // Helper function to prepare segments for routing table lookup
    const prepareRoutingSegments = (routePath, hostname)=>{
        const vanitySegment = (0, $3mZSr.getVanitySegment)(hostname);
        if (vanitySegment) {
            const actualPath = window.location.pathname;
            if (actualPath === '/' || actualPath === '') return [
                vanitySegment
            ]; // Homepage
            else {
                const pathSegments = actualPath.split('/').filter((segment)=>segment !== '');
                // /product is stripped from bitbucket.org paths before
                // they reach any backend. The Uniform project map mirrors
                // Magnolia's content tree which nests pages under
                // bitbucketapp/product/*, so we re-insert the segment here
                // (same approach Magnolia uses via prependProductToAllBitbucketUrls).
                // https://bitbucket.org/atlassian/magnolia/src/8f7194d2cd01a1c89444c0b626b6e19ecd92a61e/atlassian-configuration/src/main/java/com/atlassian/magnolia/custom/templating/functions/CustomAtlassianTemplatingFunctions.java?at=master#CustomAtlassianTemplatingFunctions.java-80,84,86,96,141
                if (vanitySegment === 'bitbucketapp' && pathSegments[0] !== 'product') return [
                    vanitySegment,
                    'product',
                    ...pathSegments
                ];
                return [
                    vanitySegment,
                    ...pathSegments
                ];
            }
        } else {
            // bxp-nginx maps vanity domains (e.g. bitbucket.org)
            // to path-prefixed routes (e.g. bitbucketapp/write) on an internal
            // hostname, so getVanitySegment() returns null. We still need to
            // re-insert /product for bitbucketapp paths since nginx strips it.
            const segments = routePath.split('/');
            if (segments[0] === 'bitbucketapp' && segments[1] !== 'product') return [
                segments[0],
                'product',
                ...segments.slice(1)
            ];
            return segments;
        }
    };
    // check if query params contains compositionSource
    const compositionSource = new URLSearchParams(location.search).get('compositionSource');
    compositionSource === 'live' && undefined;
    if (isEdgeRoutedToWae) {
        const segments = prepareRoutingSegments(route.path, location.hostname);
        return {
            Component: (0, $67UrT.UniformEntryPage),
            entryName: 'uniform-entry-page',
            isEdgeRoutedToWae: true,
            isUniformCanary: route.isUniformCanary,
            isS3UniformRoute: true,
            resolvedContentPath: segments.join('/')
        };
    }
    // Check if page is a Uniform-supported route
    const checkRoutingTable = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).routingTable);
    if (checkRoutingTable && routingTable) {
        const segments = prepareRoutingSegments(route.path, location.hostname);
        const segLength = segments.length;
        if (routingTable && (route.path !== '' || (0, $3mZSr.isVanityHostname)(location.hostname)) && (0, $8d8fc7d3d32dbcb4$export$443f269ba643b5d6)(segments, 0, segLength - 1, routingTable['wac'])) {
            console.log(route.path, 'is Uniform route served by Routing Table (resolved:', segments.join('/'), ')');
            return {
                Component: (0, $67UrT.UniformEntryPage),
                entryName: 'uniform-entry-page',
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true,
                resolvedContentPath: segments.join('/')
            };
        } else console.log(route.path, 'is NOT Uniform route');
    }
    switch(route.path){
        // todo: gwp-11369 delete after feature is tested, merged, and deployed
        case `test-gql-pricing/${$fc114bc7d66a4f84$var$getRouteExtension(route.path, 'test-gql-pricing/')}`:
            if (!(0, $eRzlV.isProduction)()) return {
                Component: (0, $67UrT.UniformEntryPage),
                entryName: 'uniform-entry-page',
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
            return {
                Component: (0, $iwpqF.FourOhFourPage),
                entryName: '404'
            };
        case 'wae-inventory':
        case `wae-inventory/${$fc114bc7d66a4f84$var$getRouteExtension(route.path, 'wae-inventory')}`:
        case 'banners':
            if (!(0, $eRzlV.isProduction)()) return {
                Component: (0, $67UrT.UniformEntryPage),
                entryName: 'uniform-entry-page',
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
            return {
                Component: (0, $iwpqF.FourOhFourPage),
                entryName: '404'
            };
        case 'uniform-preview':
            {
                // Two independent gates decide whether this route resolves at all.
                //
                // UNIFORM_PREVIEW_SECRET is set only in non-production environments
                // (staging, dev, local), so its presence means "this is a preview
                // environment". NODE_ENV cannot serve that purpose: Parcel/Atlaspack
                // bakes it in at build time and it is "production" for staging builds
                // too, which would incorrectly block the route on staging.
                //
                // UNIFORM_PREVIEW_ENABLED opts an environment into serving the route
                // even when it is not a preview environment — production, in practice.
                // It is deliberately a non-secret boolean: this module runs during
                // client hydration as well as SSR, and every env var read here is
                // inlined into the browser bundle by the bundler.
                //
                // This gate only decides whether the route resolves. What the page is
                // allowed to *render* — the projectId allow-list — lives in
                // resolve-page-props.ts, which is server-only and so is the right place
                // for it. Both must agree, or prod serves a route that renders nothing.
                const isPreviewEnvironment = Boolean(undefined);
                const isPreviewRouteEnabled = true;
                if (!isPreviewEnvironment && !isPreviewRouteEnabled) return {
                    Component: (0, $iwpqF.FourOhFourPage),
                    entryName: '404'
                };
                // Outside a preview environment the route is served only on wac-web's
                // own Bifrost hostname, never on a customer-facing domain such as
                // www.atlassian.com. The migration tooling calls that host directly, so
                // this costs it nothing.
                //
                // Note this keeps the route off the marketing domain; it does not make
                // it internal-only. prod-east does not set privateAccessOnly, so the
                // Bifrost hostname is publicly reachable. The projectId allow-list and
                // the compositionId requirement are what actually limit what renders.
                if (!isPreviewEnvironment && !(0, $d83278564f9275cb$export$9ad63ebd4cca3b05)(location.hostname)) return {
                    Component: (0, $iwpqF.FourOhFourPage),
                    entryName: '404'
                };
                route.variant;
                return {
                    Component: (0, $2aZDx.UniformPreviewPage),
                    entryName: 'uniform-preview-page'
                };
            }
        // this route name is temporary and not confirmed yet, but using for development purposes
        case 'resources/usage/calculator':
            if (!(0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp11118UsageBasedPricingCalculator)) return {
                Component: (0, $iwpqF.FourOhFourPage),
                entryName: '404'
            };
            return {
                Component: (0, $4PDzO.UsageBasedPricingPage),
                entryName: 'usage-based-pricing-page'
            };
        case 'software/rovo/pricing':
            route.variant;
            return {
                Component: (0, $ioPgw.SoftwareRovoPricingPage),
                entryName: 'software-rovo-pricing-page',
                query: (0, $5UKqd.PricingPageRelayQuery),
                queryVars: (0, $5UKqd.getPricingPageRelayQueryVars)('rovo', location),
                isRelayEnabled: true,
                relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
            };
        case 'software/jira/product-discovery/pricing':
            switch(route.variant){
                default:
                    const isWae = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7856PricingPagesWaeMigrationM3);
                    if (isWae) return {
                        Component: (0, $67UrT.UniformEntryPage),
                        entryName: 'uniform-entry-page',
                        isUniformCanary: route.isUniformCanary,
                        isS3UniformRoute: true
                    };
                    return {
                        Component: (0, $04Umd.JiraProductDiscoveryPricingPage),
                        entryName: 'jira-product-discovery-pricing-page',
                        query: (0, $5UKqd.PricingPageRelayQuery),
                        queryVars: (0, $5UKqd.getPricingPageRelayQueryVars)('jira-product-discovery', location, 'Jira Product Discovery Pricing Page'),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
            }
        case 'software/loom/pricing':
            switch(route.variant){
                default:
                    const isWae1 = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7856PricingPagesWaeMigrationM3);
                    if (isWae1) return {
                        Component: (0, $67UrT.UniformEntryPage),
                        entryName: 'uniform-entry-page',
                        isUniformCanary: route.isUniformCanary,
                        isS3UniformRoute: true
                    };
                    return {
                        Component: (0, $cbLEA.LoomPricingPage),
                        entryName: 'loom-pricing-page',
                        query: (0, $5UKqd.PricingPageRelayQuery),
                        queryVars: (0, $5UKqd.getPricingPageRelayQueryVars)('loom', location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
            }
        case `software/loom${$fc114bc7d66a4f84$var$getRouteExtension(route.path, 'software/loom')}`:
            return {
                Component: (0, $67UrT.UniformEntryPage),
                entryName: 'uniform-entry-page',
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
        case 'buy/cloud/org-setup':
            route.variant;
            return {
                Component: (0, $lsYgE.BuyCloudOrgSetupPage),
                entryName: 'buy-cloud-org-setup-page'
            };
        case 'buy/cloud/site-setup':
            route.variant;
            return {
                Component: (0, $2kCSN.BuyCloudSiteSetupPage),
                entryName: 'buy-cloud-site-setup-page'
            };
        case 'software/bitbucket/pricing':
            switch(route.variant){
                default:
                    const isWae2 = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7856PricingPagesWaeMigrationM3);
                    if (isWae2) return {
                        Component: (0, $67UrT.UniformEntryPage),
                        entryName: 'uniform-entry-page',
                        isUniformCanary: route.isUniformCanary,
                        isS3UniformRoute: true
                    };
                    return {
                        Component: (0, $2fKIG.SoftwareBitbucketPricingPage),
                        entryName: 'software-bitbucket-pricing-page',
                        query: (0, $5UKqd.PricingPageRelayQuery),
                        queryVars: (0, $5UKqd.getPricingPageRelayQueryVars)('bitbucket', location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
            }
        case 'buy/cloud/post-order-provisioning':
            route.variant;
            return {
                Component: (0, $2ABij.BuyCloudPostOrderProvisioningPage),
                entryName: 'buy-cloud-post-order-provisioning-page'
            };
        case 'software/rovo/start':
            route.variant;
            return {
                Component: (0, $hI6CC.SoftwareRovoStartPage),
                entryName: 'software-rovo-start-page'
            };
        case 'customers':
            return {
                Component: (0, $1mtK6.CustomersLandingPage),
                entryName: 'customers-landing-page',
                query: (0, $4ccia.CustomerLandingPageRelayQuery),
                queryVars: (0, $4ccia.getCustomerLandingPageRelayQueryVars)(location),
                isRelayEnabled: true,
                relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
            };
        case 'software/jira':
            const countryCode = userLocale?.trim().toUpperCase();
            if (userLoggedIn === false && (0, $9c0bba3d3f832473$export$90ba7e5165ba2be5).includes(route.variant) && (0, $hu3Tl.getRegionFromCountryCode)(countryCode) !== 'unknown' && ![
                'AU',
                'NZ',
                'GB',
                'DE'
            ].includes(countryCode ?? '')) {
                const jiraWaeExperiment = (0, $gIKKj.getExperimentWithExposures)((0, $4X0dO.experiments).gwpJiraAnchorJourneyWaeMigration);
                if (jiraWaeExperiment.type === 'enrolled' && jiraWaeExperiment.value === true) return {
                    Component: (0, $67UrT.UniformEntryPage),
                    entryName: 'uniform-entry-page',
                    isUniformCanary: route.isUniformCanary,
                    isS3UniformRoute: true
                };
            }
            switch(route.variant){
                case 'paid-lp-jsw-features':
                    return {
                        Component: (0, $7btsq.JiraSoftwarePagePaidLpJswFeatures),
                        entryName: 'jira-software-page-paid-lp-jsw-features'
                    };
                case 'paid-lp-jsw-roadmaps':
                    return {
                        Component: (0, $eIZwM.JiraSoftwarePagePaidLpJswRoadmaps),
                        entryName: 'jira-software-page-paid-lp-jsw-roadmaps',
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case 'paid-lp-jsw-template':
                    return {
                        Component: (0, $gfnSo.JiraSoftwarePagePaidLpJswTemplate),
                        entryName: 'jira-software-page-paid-lp-jsw-template',
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case 'paid-lp-jsw-tracker':
                    return {
                        Component: (0, $lFb3d.JiraSoftwarePagePaidLpJswTracker),
                        entryName: 'jira-software-page-paid-lp-jsw-tracker',
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case 'paid-lp-jsw-pm':
                    return {
                        Component: (0, $eNeuM.JiraSoftwarePagePaidLpJswPm),
                        entryName: 'jira-software-page-paid-lp-jsw-pm',
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case 'paid-lp-jsw-project_collaboration':
                    return {
                        Component: (0, $lTIGz.JiraSoftwarePagePaidLpJswProjCollab),
                        entryName: 'jira-software-page-paid-lp-jsw-project_collaboration',
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case 'paid-lp-jsw-automation':
                    return {
                        Component: (0, $2LlD0.JiraSoftwarePagePaidLpJswAutomation),
                        entryName: 'jira-software-page-paid-lp-jsw-automation',
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case 'paid-lp-jsw-teamwork':
                    return {
                        Component: (0, $bcBwv.JiraSoftwarePagePaidLpJswTeamwork),
                        entryName: 'jira-software-page-paid-lp-jsw-teamwork',
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case 'paid-lp-jsw-agile':
                    return {
                        Component: (0, $3jSW5.JiraSoftwarePagePaidLpJswAgile),
                        entryName: 'jira-software-page-paid-lp-jsw-agile',
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case 'paid-lp-jsw-competitors':
                    return {
                        Component: (0, $faUzl.JiraSoftwarePagePaidLpJswCompetitors),
                        entryName: 'jira-software-page-paid-lp-jsw-competitors',
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case 'anchor-lp-jsw-team-engineering':
                    return {
                        Component: (0, $9h3ui.JiraSoftwarePageAnchorLpJswEngineering),
                        entryName: 'jira-software-page-anchor-lp-jsw-team-engineering',
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case 'anchor-lp-jsw-team-marketing':
                    return {
                        Component: (0, $idul7.JiraSoftwarePageAnchorLpJswMarketing),
                        entryName: 'jira-software-page-anchor-lp-jsw-team-marketing',
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case 'anchor-lp-jsw-team-hr':
                    return {
                        Component: (0, $8v2ki.JiraSoftwarePageAnchorLpJswHr),
                        entryName: 'jira-software-page-anchor-lp-jsw-team-hr',
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case 'anchor-lp-jsw-team-legal':
                    return {
                        Component: (0, $2LTjU.JiraSoftwarePageAnchorLpJswLegal),
                        entryName: 'jira-software-page-anchor-lp-jsw-team-legal',
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case 'anchor-lp-jsw-team-operations':
                    return {
                        Component: (0, $iEYMn.JiraSoftwarePageAnchorLpJswOperations),
                        entryName: 'jira-software-page-anchor-lp-jsw-team-operations',
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case 'anchor-lp-jsw-team-design':
                    return {
                        Component: (0, $5v5zT.JiraSoftwarePageAnchorLpJswDesign),
                        entryName: 'jira-software-page-anchor-lp-jsw-team-design',
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case 'anchor-lp-jsw-team-programmgmt':
                    return {
                        Component: (0, $1MAo5.JiraSoftwarePageAnchorLpJswProgramMgmt),
                        entryName: 'jira-software-page-anchor-lp-jsw-team-programmgmt',
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case 'anchor-lp-jsw-team-sales':
                    return {
                        Component: (0, $dQR2M.JiraSoftwarePageAnchorLpJswSales),
                        entryName: 'jira-software-page-anchor-lp-jsw-team-sales',
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                default:
                    //For logged in, we will either show a "Has Jira" experience, otherwise the Uniform "logged out" page
                    return {
                        Component: (0, $dXL3R.JiraSoftwarePage),
                        entryName: 'jira-software-page',
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        isUniformCanary: route.isUniformCanary,
                        isS3UniformRoute: true
                    };
            }
        case 'software/jira/product-discovery':
            return {
                Component: (0, $2S6eY.JiraProductDiscoveryPage),
                entryName: 'jira-product-discovery-page'
            };
        case 'software/jira/features':
            return {
                Component: (0, $g4d4R.JiraSoftwareFeaturesPage),
                entryName: 'jira-software-features-page'
            };
        case `software/jira/guides${$fc114bc7d66a4f84$var$getRouteExtension(route.path, 'software/jira/guides')}`:
            return {
                Component: (0, $67UrT.UniformEntryPage),
                entryName: 'uniform-entry-page',
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
        case 'software/jira/free':
            return {
                Component: (0, $02cSL.JiraSoftwareFreePage),
                entryName: 'jira-software-free-page'
            };
        case 'software/jira/pricing':
            const isWae3 = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).jiraPricingWaeMigrationExperimentRerunGate);
            const isJiraPricingExperiment = (0, $gIKKj.getExperiment)((0, $4X0dO.experiments).jiraPricingWaeMigrationExperimentRerunExp);
            if (isWae3 && isJiraPricingExperiment.type === 'enrolled' && isJiraPricingExperiment.value === true) return {
                Component: (0, $iWEGU.UniformJiraPricingEntryPage),
                entryName: 'uniform-jira-pricing-entry-page',
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
            const jiraPricingTitleInternal = (0, $koI83.getPricingTitleInternal)();
            return {
                Component: (0, $Q2S5p.JiraSoftwarePricingPage),
                entryName: 'jira-software-pricing-page',
                query: (0, $5UKqd.PricingPageRelayQuery),
                queryVars: (0, $5UKqd.getPricingPageRelayQueryVars)('jira-software', location, jiraPricingTitleInternal),
                isRelayEnabled: true,
                relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
            };
        case 'software/jira/service-management':
            // main product tour page and all anchors are on WAE
            return {
                Component: (0, $67UrT.UniformEntryPage),
                entryName: 'uniform-entry-page',
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
        case 'software/confluence':
            const isCBSubAnchorPriority = (0, $ik40B.isInContextualBanditsSubAnchor)(subAnchor) && route.locale === 'en';
            const excludedCountyCodesFromExperiment = [
                'IN',
                'ID',
                'GB'
            ];
            const excludedCountry = userLocale !== null && userLocale !== undefined && excludedCountyCodesFromExperiment.includes(userLocale);
            if (route.variant && (0, $ik40B.isTargetedSubAnchor)(subAnchor) && !excludedCountry) {
                const subAnchorExperiment = (0, $gIKKj.getExperiment)((0, $4X0dO.experiments).cfind4782LandingPageSubAnchorV3);
                // if treatment return the sub anchor experiment, else control gets whatever normal route behavior is
                if (subAnchorExperiment.type === 'enrolled' && subAnchorExperiment.value) return {
                    Component: (0, $jToCF.ConfluenceSoftwarePageVariantPaidLpConfSubAnchors),
                    entryName: 'confluence-software-page-variant-paid-lp-conf-subAnchors',
                    query: (0, $k6PTJ.AnchorPageRelayQuery),
                    queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)((0, $ik40B.getPageId)(subAnchor), location),
                    isRelayEnabled: true,
                    relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                };
            }
            if (!userLoggedIn && route.variant && (0, $cqCPq.isTargetedKeyword)(route.keyword) && !isCBSubAnchorPriority) return {
                Component: (0, $8KaV5.ConfluenceSoftwarePageVariantPaidLpConfKeywords),
                entryName: 'confluence-software-page-variant-paid-lp-conf-keywords',
                query: (0, $k6PTJ.AnchorPageRelayQuery),
                queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)((0, $cqCPq.getPageId)(route.keyword), location),
                isRelayEnabled: true,
                relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
            };
            // features anchor is branded default + CB subanchor traffic
            // Also includes migrated anchors because they are wrapped in the same experiment, handled separately through uniform
            if (route.variant && (route.variant === 'paid-lp-conf-features' || (0, $ik40B.isInConfluenceMigratedAnchors)(route.variant) || (0, $ik40B.isInConfluenceCBSubAnchorCMSVariant)(route.variant)) && !userLoggedIn) {
                const confluenceContextualBanditsExperiment = (0, $gIKKj.getExperimentWithExposures)((0, $4X0dO.experiments).confluenceContextualBanditsInWae);
                if (confluenceContextualBanditsExperiment.type === 'enrolled' && confluenceContextualBanditsExperiment.value === true) return {
                    Component: (0, $67UrT.UniformEntryPage),
                    entryName: 'uniform-entry-page',
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    isUniformCanary: route.isUniformCanary,
                    isS3UniformRoute: true
                };
            }
            switch(route.variant){
                case 'paid-lp-conf-features':
                    return {
                        Component: (0, $WuRB2.ConfluenceSoftwarePageVariantPaidLpConfFeatures),
                        entryName: 'confluence-software-page-variant-paid-lp-conf-features'
                    };
                case 'paid-lp-confl-template':
                    return {
                        Component: (0, $imhoT.ConfluenceSoftwarePageVariantPaidLpConflTemplate),
                        entryName: 'confluence-software-page-variant-paid-lp-confl-template',
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case 'paid-lp-confl-documentation':
                    return {
                        Component: (0, $4FLZc.ConfluenceSoftwarePageVariantPaidLpConflDocumentation),
                        entryName: 'confluence-software-page-variant-paid-lp-confl-documentation',
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case 'anchor-lp-conf-collaboration':
                    return {
                        Component: (0, $9Ws6n.ConfluenceSoftwarePageVariantAnchorLpConfCollaboration),
                        entryName: 'confluence-software-page-variant-anchor-lp-conf-collaboration',
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case 'anchor-lp-conf-automation':
                    return {
                        Component: (0, $8IsVQ.ConfluenceSoftwarePageAnchorAutomation),
                        entryName: 'confluence-software-anchor-lp-automation',
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case 'anchor-lp-conf-teamwork':
                    return {
                        Component: (0, $8vTdi.ConfluenceSoftwarePageAnchorTeamwork),
                        entryName: 'confluence-software-anchor-lp-teamwork',
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case 'anchor-lp-conf-competitors':
                    return {
                        Component: (0, $kufmD.ConfluenceSoftwarePageAnchorCompetitors),
                        entryName: 'confluence-software-anchor-lp-competitors',
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case 'anchor-lp-conf-work-management':
                    return {
                        Component: (0, $drgFv.ConfluenceSoftwarePageAnchorWorkManagement),
                        entryName: 'confluence-software-anchor-lp-work-management',
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case 'anchor-lp-conf-team-engineering':
                    return {
                        Component: (0, $e18uw.ConfluenceSoftwarePageAnchorEngineering),
                        entryName: 'confluence-software-anchor-lp-team-engineering',
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case 'anchor-lp-conf-team-marketing':
                    return {
                        Component: (0, $kShM7.ConfluenceSoftwarePageAnchorMarketing),
                        entryName: 'confluence-software-anchor-lp-team-marketing',
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case 'anchor-lp-conf-team-legal':
                    return {
                        Component: (0, $kqZTJ.ConfluenceSoftwarePageAnchorLegal),
                        entryName: 'confluence-software-anchor-lp-team-legal',
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case 'anchor-lp-conf-team-hr':
                    return {
                        Component: (0, $ccCRD.ConfluenceSoftwarePageAnchorHr),
                        entryName: 'confluence-software-anchor-lp-team-hr',
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case 'anchor-lp-conf-team-operations':
                    return {
                        Component: (0, $4f5AO.ConfluenceSoftwarePageAnchorOperations),
                        entryName: 'confluence-software-anchor-lp-team-operations',
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case 'anchor-lp-conf-team-design':
                    return {
                        Component: (0, $fTqPM.ConfluenceSoftwarePageAnchorDesign),
                        entryName: 'confluence-software-anchor-lp-team-design',
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case 'anchor-lp-conf-team-programmgmt':
                    return {
                        Component: (0, $SJn7F.ConfluenceSoftwarePageAnchorProgramMgmt),
                        entryName: 'confluence-software-anchor-lp-team-programmgmt',
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case 'anchor-lp-conf-team-customerservice':
                    return {
                        Component: (0, $gKC0O.ConfluenceSoftwarePageAnchorCustomerService),
                        entryName: 'confluence-software-anchor-lp-team-customerservice',
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                default:
                    if ((0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).dxpMigrationConfluenceProductTourGate)) return {
                        Component: (0, $67UrT.UniformEntryPage),
                        entryName: 'uniform-entry-page',
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        isUniformCanary: route.isUniformCanary,
                        isS3UniformRoute: true
                    };
                    else return {
                        Component: (0, $2veNk.ConfluenceSoftwarePage),
                        entryName: 'confluence-software-page'
                    };
            }
        case 'software/jira/service-management/product-pricing':
            const jiraServiceManagementProductPricingTitle = (0, $31J3d.getPricingTitleInternal)();
            return {
                Component: (0, $6QgX2.JiraServiceManagementPricingPage),
                entryName: 'jira-service-management-pricing-page',
                query: (0, $5UKqd.PricingPageRelayQuery),
                queryVars: (0, $5UKqd.getPricingPageRelayQueryVars)('jira-service-management', location, jiraServiceManagementProductPricingTitle),
                isRelayEnabled: true,
                relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
            };
        case 'software/jira/service-management/pricing':
            const jiraServiceManagementPricingTitle = (0, $31J3d.getPricingTitleInternal)();
            return {
                Component: (0, $6QgX2.JiraServiceManagementPricingPage),
                entryName: 'jira-service-management-pricing-page',
                query: (0, $5UKqd.PricingPageRelayQuery),
                queryVars: (0, $5UKqd.getPricingPageRelayQueryVars)('jira-service-management', location, jiraServiceManagementPricingTitle),
                isRelayEnabled: true,
                relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
            };
        case 'software/confluence/pricing':
            const isWaeMigration = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).confluencePricingPageWaeMigration);
            const isConfluenceExperiment = (0, $gIKKj.getExperiment)((0, $4X0dO.experiments).confluencePricingPageWaeMigration);
            if (isWaeMigration && isConfluenceExperiment.type === 'enrolled' && isConfluenceExperiment.value === true) return {
                Component: (0, $czsFN.UniformConfluencePricingEntryPage),
                entryName: 'uniform-confluence-pricing-entry-page',
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
            const confluencePricingTitleInternal = (0, $fenhY.getPricingTitleInternal)();
            return {
                Component: (0, $30s1N.ConfluencePricingPage),
                entryName: 'confluence-pricing-page',
                query: (0, $5UKqd.PricingPageRelayQuery),
                queryVars: (0, $5UKqd.getPricingPageRelayQueryVars)('confluence', location, confluencePricingTitleInternal),
                isRelayEnabled: true,
                relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
            };
        case 'software/confluence/free':
            return {
                Component: (0, $jYywI.ConfluenceFreePage),
                entryName: 'confluence-free-page'
            };
        case 'software/confluence/templates':
            return {
                Component: (0, $8ItDm.ConfluenceTemplatesRelayPage),
                entryName: 'confluence-templates-contentful-relay-page',
                query: (0, $1YXN8.ConfluenceTemplatesUnifiedRelayPageQuery),
                queryVars: (0, $1YXN8.getConfluenceTemplatesUnifiedRelayPageQueryVars)(location),
                isRelayEnabled: true,
                relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
            };
        case 'software':
            return {
                Component: (0, $67UrT.UniformEntryPage),
                entryName: 'uniform-entry-page',
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
        case 'try':
            return {
                Component: (0, $lfqXN.TryPage),
                entryName: 'try-page'
            };
        case 'try/cloud/signup':
            return {
                Component: (0, $7R96I.SignupPage),
                entryName: 'signup-page'
            };
        case 'try/cloud/loom/choose':
            return {
                Component: (0, $keaFO.LoomChoicePage),
                entryName: 'loom-choice-page'
            };
        case 'ondemand/signup/checkemail':
            return {
                Component: (0, $bWWTF.CheckemailPage),
                entryName: 'checkemail-page'
            };
        case 'ondemand/signup/confirmation':
        case 'buy/cloud/confirmation':
            return {
                Component: (0, $fxtKw.ConfirmationPage),
                entryName: 'confirmation-page',
                featureFlags: route.featureFlags
            };
        case 'software/confluence/templates/search':
            return {
                Component: (0, $6mr2B.ConfluenceTemplateSearchRelayPage),
                entryName: 'confluence-template-search-contentful-relay-page',
                query: (0, $1YXN8.ConfluenceTemplatesUnifiedRelayPageQuery),
                queryVars: (0, $1YXN8.getConfluenceTemplatesUnifiedRelayPageQueryVars)(location),
                isRelayEnabled: true,
                relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
            };
        case `software/confluence/templates/categories${$fc114bc7d66a4f84$var$getRouteExtension(route.path, 'software/confluence/templates/categories')}`:
            return {
                Component: (0, $kPZ6t.ConfluenceTemplateCategoryRelayPage),
                entryName: 'confluence-template-category-contentful-relay-page',
                query: (0, $1YXN8.ConfluenceTemplatesUnifiedRelayPageQuery),
                queryVars: (0, $1YXN8.getConfluenceTemplatesUnifiedRelayPageQueryVars)(location),
                isRelayEnabled: true,
                relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
            };
        case `software/confluence/templates/collections${$fc114bc7d66a4f84$var$getRouteExtension(route.path, 'software/confluence/templates/collections')}`:
            return {
                Component: (0, $c33x4.ConfluenceTemplateCollectionDetailsRelayPage),
                entryName: 'confluence-template-collection-details-contentful-relay-page',
                query: (0, $gbUpX.ConfluenceTemplateCollectionDetailsRelayPageQuery),
                queryVars: (0, $gbUpX.getConfluenceTemplateCollectionDetailsRelayPageQueryVars)(location),
                isRelayEnabled: true,
                relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
            };
        case `software/jira/templates/service-management`:
            return {
                Component: (0, $keOu4.JiraTemplateCategoryPage),
                entryName: 'jira-template-category-page'
            };
        case 'enterprise/contact':
            return {
                Component: (0, $5zs0K.EnterpriseContactSalesPage),
                entryName: 'enterprise-contact-sales-page'
            };
        case 'enterprise/contact-thanks':
            switch(route.variant){
                case 'product-features':
                    return {
                        Component: (0, $806Eh.EnterpriseContactThanksPage),
                        entryName: 'enterprise-contact-thanks-page'
                    };
                case 'pricing-quotes':
                    return {
                        Component: (0, $806Eh.EnterpriseContactThanksPage),
                        entryName: 'enterprise-contact-thanks-page'
                    };
                case 'migration-options':
                    return {
                        Component: (0, $806Eh.EnterpriseContactThanksPage),
                        entryName: 'enterprise-contact-thanks-page'
                    };
                case 'billing-licensing':
                    return {
                        Component: (0, $806Eh.EnterpriseContactThanksPage),
                        entryName: 'enterprise-contact-thanks-page'
                    };
                case 'technical-support':
                    return {
                        Component: (0, $806Eh.EnterpriseContactThanksPage),
                        entryName: 'enterprise-contact-thanks-page'
                    };
                default:
                    return {
                        Component: (0, $806Eh.EnterpriseContactThanksPage),
                        entryName: 'enterprise-contact-thanks-page'
                    };
            }
        case 'teams/nonprofits/discount-pricing':
            return {
                Component: (0, $7Lagj.NonProfitPricingPage),
                entryName: 'non-profit-pricing-page',
                query: (0, $5UKqd.PricingPageRelayQuery),
                queryVars: (0, $5UKqd.getPricingPageRelayQueryVars)('nonprofit', location),
                isRelayEnabled: true,
                relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
            };
        case `software/confluence/templates${$fc114bc7d66a4f84$var$getRouteExtension(route.path, 'software/confluence/templates')}`:
            return {
                Component: (0, $67UrT.UniformEntryPage),
                entryName: 'uniform-entry-page',
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
        case 'cdn-library':
            return {
                Component: (0, $83Z9w.default),
                entryName: 'cdn-library'
            };
        case 'search':
            return {
                Component: (0, $dG76n.SearchResultsPage),
                entryName: 'search'
            };
        case '':
            return {
                Component: (0, $67UrT.UniformEntryPage),
                entryName: 'uniform-entry-page',
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
        default:
            return {
                Component: (0, $iwpqF.FourOhFourPage),
                entryName: '404'
            };
    }
};
const $fc114bc7d66a4f84$var$getRouteExtension = (path, baseTemplate)=>{
    const pathExtn = path.split(baseTemplate).splice(1).join(baseTemplate);
    return pathExtn ? pathExtn : '';
};



var $3t7DW = parcelRequire("3t7DW");

var $3NQOU = parcelRequire("3NQOU");


var $hp3ar = parcelRequire("hp3ar");

var $gLm0b = parcelRequire("gLm0b");

var $idVA4 = parcelRequire("idVA4");
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $fuLgT.default)()
    }
};
const $8fffc1c97a6ec5cd$var$parsedClientCookies = document.cookie ? (0, $yhhhl.parse)(document.cookie) : {};
const $8fffc1c97a6ec5cd$var$userAgent = typeof window !== 'undefined' ? window.navigator.userAgent : '';
const $8fffc1c97a6ec5cd$var$locationData = {
    countryIsoCode: window.countryCode || '',
    regionIsoCode: window.regionIsoCode || ''
};
const $8fffc1c97a6ec5cd$var$isPerfOnetrustEnabled = (0, $gLm0b.isPerformanceOnetrustEnabled)(typeof window !== 'undefined' ? window.optanonConsentCookie : (0, $gLm0b.extractOptanonConsentCookie)(document.cookie), $8fffc1c97a6ec5cd$var$locationData);
const { finalExperimentOverrides: $8fffc1c97a6ec5cd$var$finalExperimentOverrides, finalFeatureGateOverrides: $8fffc1c97a6ec5cd$var$finalFeatureGateOverrides } = (0, $idVA4.processExperimentAndFeatureGateOverrides)($8fffc1c97a6ec5cd$var$parsedClientCookies, $8fffc1c97a6ec5cd$var$userAgent, $8fffc1c97a6ec5cd$var$isPerfOnetrustEnabled);
if ((0, $hp3ar.isEdgeCachingPath)(window.location.pathname)) {
    (0, $hp3ar.overrideAjsAnonIdFromCookie)();
    (0, $hp3ar.overrideCustomAttributes)();
}
(0, $hgaI1.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
    overrideValues: {
        experimentOverrides: $8fffc1c97a6ec5cd$var$finalExperimentOverrides,
        featureGateOverrides: $8fffc1c97a6ec5cd$var$finalFeatureGateOverrides
    },
    localMode: !$8fffc1c97a6ec5cd$var$isPerfOnetrustEnabled
}).then(async ()=>{
    const routingTable = await (0, $8d8fc7d3d32dbcb4$export$9dab8dd71c3a980f)();
    const { Component: Component, isRelayEnabled: isRelayEnabled, query: query, queryVars: queryVars, relayApi: relayApi } = (0, $fc114bc7d66a4f84$export$da6d2f7032b7150b)(window.location, undefined, undefined, undefined, routingTable, Boolean(window.isEdgeRoutedToWae));
    if (!isRelayEnabled) (0, $3NQOU.init)(Component);
    else (0, $3t7DW.init)(Component, query, queryVars, relayApi);
});




//# sourceMappingURL=index.84566004.js.map
